webpackJsonp([1],{

/***/ "+3sH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var camel_case_1 = __webpack_require__("L9Tr");
var id_1 = __webpack_require__("z2AX");
var column_prop_getters_1 = __webpack_require__("sXN4");
/**
 * Sets the column defaults
 */
function setColumnDefaults(columns) {
    if (!columns)
        return;
    for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
        var column = columns_1[_i];
        if (!column.$$id) {
            column.$$id = id_1.id();
        }
        // prop can be numeric; zero is valid not a missing prop
        // translate name => prop
        if (isNullOrUndefined(column.prop) && column.name) {
            column.prop = camel_case_1.camelCase(column.name);
        }
        if (!column.$$valueGetter) {
            column.$$valueGetter = column_prop_getters_1.getterForProp(column.prop);
        }
        // format props if no name passed
        if (!isNullOrUndefined(column.prop) && isNullOrUndefined(column.name)) {
            column.name = camel_case_1.deCamelCase(String(column.prop));
        }
        if (isNullOrUndefined(column.prop) && isNullOrUndefined(column.name)) {
            column.name = ''; // Fixes IE and Edge displaying `null`
        }
        if (!column.hasOwnProperty('resizeable')) {
            column.resizeable = true;
        }
        if (!column.hasOwnProperty('sortable')) {
            column.sortable = true;
        }
        if (!column.hasOwnProperty('draggable')) {
            column.draggable = true;
        }
        if (!column.hasOwnProperty('canAutoResize')) {
            column.canAutoResize = true;
        }
        if (!column.hasOwnProperty('width')) {
            column.width = 150;
        }
    }
}
exports.setColumnDefaults = setColumnDefaults;
function isNullOrUndefined(value) {
    return value === null || value === undefined;
}
exports.isNullOrUndefined = isNullOrUndefined;
/**
 * Translates templates definitions to objects
 */
function translateTemplates(templates) {
    var result = [];
    for (var _i = 0, templates_1 = templates; _i < templates_1.length; _i++) {
        var temp = templates_1[_i];
        var col = {};
        var props = Object.getOwnPropertyNames(temp);
        for (var _a = 0, props_1 = props; _a < props_1.length; _a++) {
            var prop = props_1[_a];
            col[prop] = temp[prop];
        }
        if (temp.headerTemplate) {
            col.headerTemplate = temp.headerTemplate;
        }
        if (temp.cellTemplate) {
            col.cellTemplate = temp.cellTemplate;
        }
        if (temp.summaryFunc) {
            col.summaryFunc = temp.summaryFunc;
        }
        if (temp.summaryTemplate) {
            col.summaryTemplate = temp.summaryTemplate;
        }
        result.push(col);
    }
    return result;
}
exports.translateTemplates = translateTemplates;
//# sourceMappingURL=column-helper.js.map

/***/ }),

/***/ "+TKD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Component; });
/**
 * Created by stas on 5/25/2017.
 */
var Component;
(function (Component) {
    Component[Component["AgentManagement"] = 1] = "AgentManagement";
    Component[Component["LocationManagement"] = 2] = "LocationManagement";
    Component[Component["ExchangeRates"] = 3] = "ExchangeRates";
    Component[Component["CustomerManagement"] = 4] = "CustomerManagement";
    Component[Component["Calculator"] = 5] = "Calculator";
    Component[Component["ProductManagement"] = 6] = "ProductManagement";
    Component[Component["OrderManagement"] = 7] = "OrderManagement";
    Component[Component["Reports"] = 8] = "Reports";
    Component[Component["OrderDetails"] = 9] = "OrderDetails";
    Component[Component["Dashboard"] = 10] = "Dashboard";
    Component[Component["Amazon"] = 11] = "Amazon";
    Component[Component["AmazonManagement"] = 12] = "AmazonManagement";
    Component[Component["TariffUpdater"] = 13] = "TariffUpdater";
    Component[Component["StatusAPI"] = 14] = "StatusAPI";
    Component[Component["CustomersImport"] = 15] = "CustomersImport";
})(Component || (Component = {}));
//# sourceMappingURL=component.js.map

/***/ }),

/***/ "+W9T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AmazonComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_amazon_service__ = __webpack_require__("WdmS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar__ = __webpack_require__("Fiov");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel__ = __webpack_require__("gqkz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies__ = __webpack_require__("46qw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_configService__ = __webpack_require__("cfSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_userService__ = __webpack_require__("ZSxL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_router__ = __webpack_require__("5oXY");









var AmazonComponent = /** @class */ (function () {
    function AmazonComponent(renderer, amazonService, configService, userService, router) {
        this.renderer = renderer;
        this.amazonService = amazonService;
        this.configService = configService;
        this.userService = userService;
        this.router = router;
        this.showInfo = true;
        this.errors = [];
    }
    AmazonComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hash = location.hash;
        if (String.isNullOrEmpty(hash)) {
            this.login();
            return;
        }
        if (!location.hash.split('access_token='))
            return;
        this.accessToken = location.hash.match(/access_token=([^&]*)&/)[1];
        if (!this.accessToken)
            return;
        this.userService.getExternalUserInfo(this.accessToken).then(function (resp) {
            __WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies__["Cookie"].set(_this.configService.config.ApiTokenCookieName, _this.accessToken, 1, '/');
            __WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies__["Cookie"].set(_this.configService.config.UserAmazonCookieName, resp.Data.Id.toString(), 1, '/');
            var userId = resp.Data.Id;
            _this.showInfo = false;
            _this.getAmazonUser(userId).then(function (resp) {
                _this.router.navigate(["amazon/info/dashboard"]);
                if (!resp) {
                    _this.router.navigate(["amazon/info/seller"]);
                }
            });
        });
    };
    AmazonComponent.prototype.login = function () {
        var _this = this;
        this.showInfo = false;
        __WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies__["Cookie"].delete(this.configService.config.ApiTokenCookieName);
        __WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies__["Cookie"].delete(this.configService.config.UserAmazonCookieName);
        __WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies__["Cookie"].delete(this.configService.config.UserCookieName);
        this.userService.prepareExternalLogin().then(function (x) {
            window.location.href =
                _this.configService.config.AmazonApiUrl + "/api/Account/ExternalLogin?provider=Amazon&response_type=token&client_id=self&redirect_uri=" + _this.configService.config.AmazonApiUrl + "/api/Account/ExternalLogin&state=0eYM9Qg6Gu3Z8H3CqEQUfmI3i_XM59C-q5UUdAONOpw1";
        });
    };
    AmazonComponent.prototype.getAmazonUser = function (id) {
        var _this = this;
        return this.amazonService.getSellerByUserId(id).then(function (resp) {
            return _this.currentSeller = resp.Data;
        });
    };
    AmazonComponent.prototype.ngAfterViewInit = function () {
        var spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");
        if (window.navigator.userAgent.indexOf("Edge") > -1)
            return;
        __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar__["initialize"](this.amazonPanel.nativeElement);
    };
    AmazonComponent.prototype.isValid = function () {
        return !String.isNullOrEmpty(this.sellerId) &&
            !String.isNullOrEmpty(this.marketplaceId) &&
            !String.isNullOrEmpty(this.mwsAuthToken);
    };
    AmazonComponent.prototype.exportProducts = function () {
        if (!this.isValid())
            return;
        this.amazonService.exportProducts(this.sellerId, this.marketplaceId, this.mwsAuthToken, this.company);
    };
    AmazonComponent.prototype.goToOtherSite = function () {
        window.location.href = "https://borderbuddy.com/contact/"; //TODO ask Yuriy for URL
    };
    AmazonComponent.prototype.scrollTop = function () {
        if (this.amazonPanel)
            this.amazonPanel.nativeElement.scrollTop = 0;
    };
    AmazonComponent.prototype.carouselTabSelect = function () {
        this.scrollTop();
        $(".slick-my").slick({
            arrows: false,
            dots: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
        });
    };
    AmazonComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] }, { type: __WEBPACK_IMPORTED_MODULE_1__services_amazon_service__["a" /* AmazonService */] }, { type: __WEBPACK_IMPORTED_MODULE_6__services_configService__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_7__services_userService__["a" /* UserService */] }, { type: __WEBPACK_IMPORTED_MODULE_8__angular_router__["n" /* Router */] }]; };
    return AmazonComponent;
}());

//# sourceMappingURL=amazon.component.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "+erw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var body_group_header_template_directive_1 = __webpack_require__("aIIe");
var DatatableGroupHeaderDirective = /** @class */ (function () {
    function DatatableGroupHeaderDirective() {
        /**
         * Row height is required when virtual scroll is enabled.
         */
        this.rowHeight = 0;
        /**
         * Track toggling of group visibility
         */
        this.toggle = new core_1.EventEmitter();
    }
    /**
     * Toggle the expansion of a group
     */
    DatatableGroupHeaderDirective.prototype.toggleExpandGroup = function (group) {
        this.toggle.emit({
            type: 'group',
            value: group
        });
    };
    /**
     * Expand all groups
     */
    DatatableGroupHeaderDirective.prototype.expandAllGroups = function () {
        this.toggle.emit({
            type: 'all',
            value: true
        });
    };
    /**
     * Collapse all groups
     */
    DatatableGroupHeaderDirective.prototype.collapseAllGroups = function () {
        this.toggle.emit({
            type: 'all',
            value: false
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DatatableGroupHeaderDirective.prototype, "rowHeight", void 0);
    __decorate([
        core_1.Input(),
        core_1.ContentChild(body_group_header_template_directive_1.DatatableGroupHeaderTemplateDirective, { read: core_1.TemplateRef }),
        __metadata("design:type", core_1.TemplateRef)
    ], DatatableGroupHeaderDirective.prototype, "template", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DatatableGroupHeaderDirective.prototype, "toggle", void 0);
    DatatableGroupHeaderDirective = __decorate([
        core_1.Directive({ selector: 'ngx-datatable-group-header' })
    ], DatatableGroupHeaderDirective);
    return DatatableGroupHeaderDirective;
}());
exports.DatatableGroupHeaderDirective = DatatableGroupHeaderDirective;
//# sourceMappingURL=body-group-header.directive.js.map

/***/ }),

/***/ "/+tr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
 * @description Recursive object extending
 * @author Viacheslav Lotsmanov <lotsmanov89@gmail.com>
 * @license MIT
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2013-2018 Viacheslav Lotsmanov
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */



function isSpecificValue(val) {
	return (
		val instanceof Buffer
		|| val instanceof Date
		|| val instanceof RegExp
	) ? true : false;
}

function cloneSpecificValue(val) {
	if (val instanceof Buffer) {
		var x = Buffer.alloc
			? Buffer.alloc(val.length)
			: new Buffer(val.length);
		val.copy(x);
		return x;
	} else if (val instanceof Date) {
		return new Date(val.getTime());
	} else if (val instanceof RegExp) {
		return new RegExp(val);
	} else {
		throw new Error('Unexpected situation');
	}
}

/**
 * Recursive cloning array.
 */
function deepCloneArray(arr) {
	var clone = [];
	arr.forEach(function (item, index) {
		if (typeof item === 'object' && item !== null) {
			if (Array.isArray(item)) {
				clone[index] = deepCloneArray(item);
			} else if (isSpecificValue(item)) {
				clone[index] = cloneSpecificValue(item);
			} else {
				clone[index] = deepExtend({}, item);
			}
		} else {
			clone[index] = item;
		}
	});
	return clone;
}

function safeGetProperty(object, property) {
	return property === '__proto__' ? undefined : object[property];
}

/**
 * Extening object that entered in first argument.
 *
 * Returns extended object or false if have no target object or incorrect type.
 *
 * If you wish to clone source object (without modify it), just use empty new
 * object as first argument, like this:
 *   deepExtend({}, yourObj_1, [yourObj_N]);
 */
var deepExtend = module.exports = function (/*obj_1, [obj_2], [obj_N]*/) {
	if (arguments.length < 1 || typeof arguments[0] !== 'object') {
		return false;
	}

	if (arguments.length < 2) {
		return arguments[0];
	}

	var target = arguments[0];

	// convert arguments to array and cut off target object
	var args = Array.prototype.slice.call(arguments, 1);

	var val, src, clone;

	args.forEach(function (obj) {
		// skip argument if isn't an object, is null, or is an array
		if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
			return;
		}

		Object.keys(obj).forEach(function (key) {
			src = safeGetProperty(target, key); // source value
			val = safeGetProperty(obj, key); // new value

			// recursion prevention
			if (val === target) {
				return;

			/**
			 * if new value isn't object then just overwrite by new value
			 * instead of extending.
			 */
			} else if (typeof val !== 'object' || val === null) {
				target[key] = val;
				return;

			// just clone arrays (and recursive clone objects inside)
			} else if (Array.isArray(val)) {
				target[key] = deepCloneArray(val);
				return;

			// custom cloning and overwrite for specific objects
			} else if (isSpecificValue(val)) {
				target[key] = cloneSpecificValue(val);
				return;

			// overwrite by new value if source isn't object or array
			} else if (typeof src !== 'object' || src === null || Array.isArray(src)) {
				target[key] = deepExtend({}, val);
				return;

			// source value and new value is objects both, extending...
			} else {
				target[key] = deepExtend(src, val);
				return;
			}
		});
	});

	return target;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("EuP9").Buffer))

/***/ }),

/***/ "/9l6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TaxService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("Fzro");

var TaxService = /** @class */ (function () {
    function TaxService(http) {
        this.http = http;
        this.canadianHsCodesAlAndSteel10 = {};
        this.canadianHsCodesAlAndSteel25 = {};
        this.canadianHsCodesChina0 = {};
        this.usaHsCodesChina25 = {};
        TaxService.Instance = this;
        this.getCanadianCountermeasures10();
        this.getUSAChinaCodes();
    }
    TaxService.prototype.getCanadianCountermeasures10 = function () {
        var _this = this;
        var url = 'configuration/Canadian_Countermeasures_10.json';
        return this.http.get(url).toPromise().then(function (x) {
            var res = x.json();
            if (res["10"])
                _this.canadianHsCodesAlAndSteel10 = res["10"];
            if (res["25"])
                _this.canadianHsCodesAlAndSteel25 = res["25"];
            if (res["0"])
                _this.canadianHsCodesChina0 = res["0"];
            return res;
        });
    };
    TaxService.prototype.getUSAChinaCodes = function () {
        var _this = this;
        var url = 'configuration/USA_China_Codes.json';
        return this.http.get(url).toPromise().then(function (x) {
            var res = x.json();
            _this.usaHsCodesChina25 = res;
            return res;
        });
    };
    TaxService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["e" /* Http */] }]; };
    return TaxService;
}());

//# sourceMappingURL=tax.service.js.map

/***/ }),

/***/ "/Th8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocationUpdateRequest; });
/**
 * Created by vlad.p on 10/12/2017.
 */
var LocationUpdateRequest = /** @class */ (function () {
    function LocationUpdateRequest(obj) {
        Object.assign(this, obj);
    }
    return LocationUpdateRequest;
}());

//# sourceMappingURL=locationUpdateRequest.js.map

/***/ }),

/***/ "/UE+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var ProgressBarComponent = /** @class */ (function () {
    function ProgressBarComponent() {
    }
    ProgressBarComponent = __decorate([
        core_1.Component({
            selector: 'datatable-progress',
            template: "\n    <div class=\"progress-linear\" role=\"progressbar\">\n      <div class=\"container\">\n        <div class=\"bar\"></div>\n      </div>\n    </div>\n  ",
            changeDetection: core_1.ChangeDetectionStrategy.OnPush
        })
    ], ProgressBarComponent);
    return ProgressBarComponent;
}());
exports.ProgressBarComponent = ProgressBarComponent;
//# sourceMappingURL=progress-bar.component.js.map

/***/ }),

/***/ "/Zin":
/***/ (function(module, exports, __webpack_require__) {

!function(e,r){ true?module.exports=r():"function"==typeof define&&define.amd?define([],r):"object"==typeof exports?exports.textMaskCore=r():e.textMaskCore=r()}(this,function(){return function(e){function r(n){if(t[n])return t[n].exports;var o=t[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,r),o.loaded=!0,o.exports}var t={};return r.m=e,r.c=t,r.p="",r(0)}([function(e,r,t){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(r,"__esModule",{value:!0});var o=t(3);Object.defineProperty(r,"conformToMask",{enumerable:!0,get:function(){return n(o).default}});var i=t(2);Object.defineProperty(r,"adjustCaretPosition",{enumerable:!0,get:function(){return n(i).default}});var a=t(5);Object.defineProperty(r,"createTextMaskInputElement",{enumerable:!0,get:function(){return n(a).default}})},function(e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.placeholderChar="_",r.strFunction="function"},function(e,r){"use strict";function t(e){var r=e.previousConformedValue,t=void 0===r?o:r,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,l=void 0===u?0:u,s=e.conformedValue,f=e.rawValue,d=e.placeholderChar,c=e.placeholder,p=e.indexesOfPipedChars,v=void 0===p?n:p,h=e.caretTrapIndexes,m=void 0===h?n:h;if(0===l||!f.length)return 0;var y=f.length,g=t.length,b=c.length,C=s.length,P=y-g,k=P>0,x=0===g,O=P>1&&!k&&!x;if(O)return l;var T=k&&(t===s||s===c),w=0,M=void 0,S=void 0;if(T)w=l-P;else{var j=s.toLowerCase(),_=f.toLowerCase(),V=_.substr(0,l).split(o),A=V.filter(function(e){return j.indexOf(e)!==-1});S=A[A.length-1];var N=a.substr(0,A.length).split(o).filter(function(e){return e!==d}).length,E=c.substr(0,A.length).split(o).filter(function(e){return e!==d}).length,F=E!==N,R=void 0!==a[A.length-1]&&void 0!==c[A.length-2]&&a[A.length-1]!==d&&a[A.length-1]!==c[A.length-1]&&a[A.length-1]===c[A.length-2];!k&&(F||R)&&N>0&&c.indexOf(S)>-1&&void 0!==f[l]&&(M=!0,S=f[l]);for(var I=v.map(function(e){return j[e]}),J=I.filter(function(e){return e===S}).length,W=A.filter(function(e){return e===S}).length,q=c.substr(0,c.indexOf(d)).split(o).filter(function(e,r){return e===S&&f[r]!==e}).length,L=q+W+J+(M?1:0),z=0,B=0;B<C;B++){var D=j[B];if(w=B+1,D===S&&z++,z>=L)break}}if(k){for(var G=w,H=w;H<=b;H++)if(c[H]===d&&(G=H),c[H]===d||m.indexOf(H)!==-1||H===b)return G}else if(M){for(var K=w-1;K>=0;K--)if(s[K]===S||m.indexOf(K)!==-1||0===K)return K}else for(var Q=w;Q>=0;Q--)if(c[Q-1]===d||m.indexOf(Q)!==-1||0===Q)return Q}Object.defineProperty(r,"__esModule",{value:!0}),r.default=t;var n=[],o=""},function(e,r,t){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:l,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,t=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0,i.isArray)(r)){if(("undefined"==typeof r?"undefined":o(r))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");r=r(e,t),r=(0,i.processCaretTraps)(r).maskWithoutCaretTraps}var n=t.guide,s=void 0===n||n,f=t.previousConformedValue,d=void 0===f?l:f,c=t.placeholderChar,p=void 0===c?a.placeholderChar:c,v=t.placeholder,h=void 0===v?(0,i.convertMaskToPlaceholder)(r,p):v,m=t.currentCaretPosition,y=t.keepCharPositions,g=s===!1&&void 0!==d,b=e.length,C=d.length,P=h.length,k=r.length,x=b-C,O=x>0,T=m+(O?-x:0),w=T+Math.abs(x);if(y===!0&&!O){for(var M=l,S=T;S<w;S++)h[S]===p&&(M+=p);e=e.slice(0,T)+M+e.slice(T,b)}for(var j=e.split(l).map(function(e,r){return{char:e,isNew:r>=T&&r<w}}),_=b-1;_>=0;_--){var V=j[_].char;if(V!==p){var A=_>=T&&C===k;V===h[A?_-x:_]&&j.splice(_,1)}}var N=l,E=!1;e:for(var F=0;F<P;F++){var R=h[F];if(R===p){if(j.length>0)for(;j.length>0;){var I=j.shift(),J=I.char,W=I.isNew;if(J===p&&g!==!0){N+=p;continue e}if(r[F].test(J)){if(y===!0&&W!==!1&&d!==l&&s!==!1&&O){for(var q=j.length,L=null,z=0;z<q;z++){var B=j[z];if(B.char!==p&&B.isNew===!1)break;if(B.char===p){L=z;break}}null!==L?(N+=J,j.splice(L,1)):F--}else N+=J;continue e}E=!0}g===!1&&(N+=h.substr(F,P));break}N+=R}if(g&&O===!1){for(var D=null,G=0;G<N.length;G++)h[G]===p&&(D=G);N=null!==D?N.substr(0,D+1):l}return{conformedValue:N,meta:{someCharsRejected:E}}}Object.defineProperty(r,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r.default=n;var i=t(4),a=t(1),u=[],l=""},function(e,r,t){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:s.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(r)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(r)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?r:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return"string"==typeof e||e instanceof String}function a(e){return"number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return"undefined"==typeof e||null===e}function l(e){for(var r=[],t=void 0;t=e.indexOf(d),t!==-1;)r.push(t),e.splice(t,1);return{maskWithoutCaretTraps:e,indexes:r}}Object.defineProperty(r,"__esModule",{value:!0}),r.convertMaskToPlaceholder=n,r.isArray=o,r.isString=i,r.isNumber=a,r.isNil=u,r.processCaretTraps=l;var s=t(1),f=[],d="[]"},function(e,r,t){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var r={previousConformedValue:void 0,previousPlaceholder:void 0};return{state:r,update:function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,s=n.mask,d=n.guide,m=n.pipe,g=n.placeholderChar,b=void 0===g?v.placeholderChar:g,C=n.keepCharPositions,P=void 0!==C&&C,k=n.showMask,x=void 0!==k&&k;if("undefined"==typeof t&&(t=o.value),t!==r.previousConformedValue){("undefined"==typeof s?"undefined":l(s))===y&&void 0!==s.pipe&&void 0!==s.mask&&(m=s.pipe,s=s.mask);var O=void 0,T=void 0;if(s instanceof Array&&(O=(0,p.convertMaskToPlaceholder)(s,b)),s!==!1){var w=a(t),M=o.selectionEnd,S=r.previousConformedValue,j=r.previousPlaceholder,_=void 0;if(("undefined"==typeof s?"undefined":l(s))===v.strFunction){if(T=s(w,{currentCaretPosition:M,previousConformedValue:S,placeholderChar:b}),T===!1)return;var V=(0,p.processCaretTraps)(T),A=V.maskWithoutCaretTraps,N=V.indexes;T=A,_=N,O=(0,p.convertMaskToPlaceholder)(T,b)}else T=s;var E={previousConformedValue:S,guide:d,placeholderChar:b,pipe:m,placeholder:O,currentCaretPosition:M,keepCharPositions:P},F=(0,c.default)(w,T,E),R=F.conformedValue,I=("undefined"==typeof m?"undefined":l(m))===v.strFunction,J={};I&&(J=m(R,u({rawValue:w},E)),J===!1?J={value:S,rejected:!0}:(0,p.isString)(J)&&(J={value:J}));var W=I?J.value:R,q=(0,f.default)({previousConformedValue:S,previousPlaceholder:j,conformedValue:W,placeholder:O,rawValue:w,currentCaretPosition:M,placeholderChar:b,indexesOfPipedChars:J.indexesOfPipedChars,caretTrapIndexes:_}),L=W===O&&0===q,z=x?O:h,B=L?z:W;r.previousConformedValue=B,r.previousPlaceholder=O,o.value!==B&&(o.value=B,i(o,q))}}}}}function i(e,r){document.activeElement===e&&(g?b(function(){return e.setSelectionRange(r,r,m)},0):e.setSelectionRange(r,r,m))}function a(e){if((0,p.isString)(e))return e;if((0,p.isNumber)(e))return String(e);if(void 0===e||null===e)return h;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(r,"__esModule",{value:!0});var u=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])}return e},l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r.default=o;var s=t(2),f=n(s),d=t(3),c=n(d),p=t(4),v=t(1),h="",m="none",y="object",g="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),b="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout}])});

/***/ }),

/***/ "/j9b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var common_1 = __webpack_require__("2Je8");
var components_1 = __webpack_require__("5hg6");
var directives_1 = __webpack_require__("NQUu");
var services_1 = __webpack_require__("J/iR");
var NgxDatatableModule = /** @class */ (function () {
    function NgxDatatableModule() {
    }
    NgxDatatableModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule
            ],
            providers: [
                services_1.ScrollbarHelper,
                services_1.DimensionsHelper
            ],
            declarations: [
                components_1.DataTableFooterTemplateDirective,
                directives_1.VisibilityDirective,
                directives_1.DraggableDirective,
                directives_1.ResizeableDirective,
                directives_1.OrderableDirective,
                directives_1.LongPressDirective,
                components_1.ScrollerComponent,
                components_1.DatatableComponent,
                components_1.DataTableColumnDirective,
                components_1.DataTableHeaderComponent,
                components_1.DataTableHeaderCellComponent,
                components_1.DataTableBodyComponent,
                components_1.DataTableFooterComponent,
                components_1.DataTablePagerComponent,
                components_1.ProgressBarComponent,
                components_1.DataTableBodyRowComponent,
                components_1.DataTableRowWrapperComponent,
                components_1.DatatableRowDetailDirective,
                components_1.DatatableGroupHeaderDirective,
                components_1.DatatableRowDetailTemplateDirective,
                components_1.DataTableBodyCellComponent,
                components_1.DataTableSelectionComponent,
                components_1.DataTableColumnHeaderDirective,
                components_1.DataTableColumnCellDirective,
                components_1.DatatableFooterDirective,
                components_1.DatatableGroupHeaderTemplateDirective,
                components_1.DataTableSummaryRowComponent,
            ],
            exports: [
                components_1.DatatableComponent,
                components_1.DatatableRowDetailDirective,
                components_1.DatatableGroupHeaderDirective,
                components_1.DatatableRowDetailTemplateDirective,
                components_1.DataTableColumnDirective,
                components_1.DataTableColumnHeaderDirective,
                components_1.DataTableColumnCellDirective,
                components_1.DataTableFooterTemplateDirective,
                components_1.DatatableFooterDirective,
                components_1.DataTablePagerComponent,
                components_1.DatatableGroupHeaderTemplateDirective
            ]
        })
    ], NgxDatatableModule);
    return NgxDatatableModule;
}());
exports.NgxDatatableModule = NgxDatatableModule;
//# sourceMappingURL=datatable.module.js.map

/***/ }),

/***/ "/jm2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
/**
 * Gets the width of the scrollbar.  Nesc for windows
 * http://stackoverflow.com/a/13382873/888165
 */
var DimensionsHelper = /** @class */ (function () {
    function DimensionsHelper() {
    }
    DimensionsHelper.prototype.getDimensions = function (element) {
        return element.getBoundingClientRect();
    };
    DimensionsHelper = __decorate([
        core_1.Injectable()
    ], DimensionsHelper);
    return DimensionsHelper;
}());
exports.DimensionsHelper = DimensionsHelper;
//# sourceMappingURL=dimensions-helper.service.js.map

/***/ }),

/***/ "0RJd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var ScrollerComponent = /** @class */ (function () {
    function ScrollerComponent(ngZone, element, renderer) {
        this.ngZone = ngZone;
        this.renderer = renderer;
        this.scrollbarV = false;
        this.scrollbarH = false;
        this.scroll = new core_1.EventEmitter();
        this.scrollYPos = 0;
        this.scrollXPos = 0;
        this.prevScrollYPos = 0;
        this.prevScrollXPos = 0;
        this.element = element.nativeElement;
    }
    ScrollerComponent.prototype.ngOnInit = function () {
        var _this = this;
        // manual bind so we don't always listen
        if (this.scrollbarV || this.scrollbarH) {
            var renderer = this.renderer;
            this.parentElement = renderer.parentNode(renderer.parentNode(this.element));
            this.ngZone.runOutsideAngular(function () {
                _this.parentElement.addEventListener('scroll', _this.onScrolled.bind(_this));
            });
        }
    };
    ScrollerComponent.prototype.ngOnDestroy = function () {
        if (this.scrollbarV || this.scrollbarH) {
            this.parentElement.removeEventListener('scroll', this.onScrolled.bind(this));
        }
    };
    ScrollerComponent.prototype.setOffset = function (offsetY) {
        if (this.parentElement) {
            this.parentElement.scrollTop = offsetY;
        }
    };
    ScrollerComponent.prototype.onScrolled = function (event) {
        var _this = this;
        var dom = event.currentTarget;
        requestAnimationFrame(function () {
            _this.scrollYPos = dom.scrollTop;
            _this.scrollXPos = dom.scrollLeft;
            _this.updateOffset();
        });
    };
    ScrollerComponent.prototype.updateOffset = function () {
        var direction;
        if (this.scrollYPos < this.prevScrollYPos) {
            direction = 'down';
        }
        else if (this.scrollYPos > this.prevScrollYPos) {
            direction = 'up';
        }
        this.scroll.emit({
            direction: direction,
            scrollYPos: this.scrollYPos,
            scrollXPos: this.scrollXPos
        });
        this.prevScrollYPos = this.scrollYPos;
        this.prevScrollXPos = this.scrollXPos;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], ScrollerComponent.prototype, "scrollbarV", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], ScrollerComponent.prototype, "scrollbarH", void 0);
    __decorate([
        core_1.HostBinding('style.height.px'),
        core_1.Input(),
        __metadata("design:type", Number)
    ], ScrollerComponent.prototype, "scrollHeight", void 0);
    __decorate([
        core_1.HostBinding('style.width.px'),
        core_1.Input(),
        __metadata("design:type", Number)
    ], ScrollerComponent.prototype, "scrollWidth", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], ScrollerComponent.prototype, "scroll", void 0);
    ScrollerComponent = __decorate([
        core_1.Component({
            selector: 'datatable-scroller',
            template: "\n    <ng-content></ng-content>\n  ",
            host: {
                class: 'datatable-scroll'
            },
            changeDetection: core_1.ChangeDetectionStrategy.OnPush
        }),
        __metadata("design:paramtypes", [core_1.NgZone, core_1.ElementRef, core_1.Renderer2])
    ], ScrollerComponent);
    return ScrollerComponent;
}());
exports.ScrollerComponent = ScrollerComponent;
//# sourceMappingURL=scroller.component.js.map

/***/ }),

/***/ "0dt4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var types_1 = __webpack_require__("j2I9");
var utils_1 = __webpack_require__("x6Zf");
var DataTableHeaderComponent = /** @class */ (function () {
    function DataTableHeaderComponent(cd) {
        this.cd = cd;
        this.sort = new core_1.EventEmitter();
        this.reorder = new core_1.EventEmitter();
        this.resize = new core_1.EventEmitter();
        this.select = new core_1.EventEmitter();
        this.columnContextmenu = new core_1.EventEmitter(false);
        this._styleByGroup = {
            left: {},
            center: {},
            right: {}
        };
    }
    Object.defineProperty(DataTableHeaderComponent.prototype, "innerWidth", {
        get: function () {
            return this._innerWidth;
        },
        set: function (val) {
            this._innerWidth = val;
            if (this._columns) {
                var colByPin = utils_1.columnsByPin(this._columns);
                this._columnGroupWidths = utils_1.columnGroupWidths(colByPin, this._columns);
                this.setStylesByGroup();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderComponent.prototype, "headerHeight", {
        get: function () {
            return this._headerHeight;
        },
        set: function (val) {
            if (val !== 'auto') {
                this._headerHeight = val + "px";
            }
            else {
                this._headerHeight = val;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderComponent.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (val) {
            this._columns = val;
            var colsByPin = utils_1.columnsByPin(val);
            this._columnsByPin = utils_1.columnsByPinArr(val);
            this._columnGroupWidths = utils_1.columnGroupWidths(colsByPin, val);
            this.setStylesByGroup();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderComponent.prototype, "offsetX", {
        get: function () { return this._offsetX; },
        set: function (val) {
            this._offsetX = val;
            this.setStylesByGroup();
        },
        enumerable: true,
        configurable: true
    });
    DataTableHeaderComponent.prototype.onLongPressStart = function (_a) {
        var event = _a.event, model = _a.model;
        model.dragging = true;
        this.dragEventTarget = event;
    };
    DataTableHeaderComponent.prototype.onLongPressEnd = function (_a) {
        var event = _a.event, model = _a.model;
        this.dragEventTarget = event;
        // delay resetting so sort can be
        // prevented if we were dragging
        setTimeout(function () {
            model.dragging = false;
        }, 5);
    };
    Object.defineProperty(DataTableHeaderComponent.prototype, "headerWidth", {
        get: function () {
            if (this.scrollbarH) {
                return this.innerWidth + 'px';
            }
            return '100%';
        },
        enumerable: true,
        configurable: true
    });
    DataTableHeaderComponent.prototype.trackByGroups = function (index, colGroup) {
        return colGroup.type;
    };
    DataTableHeaderComponent.prototype.columnTrackingFn = function (index, column) {
        return column.$$id;
    };
    DataTableHeaderComponent.prototype.onColumnResized = function (width, column) {
        if (width <= column.minWidth) {
            width = column.minWidth;
        }
        else if (width >= column.maxWidth) {
            width = column.maxWidth;
        }
        this.resize.emit({
            column: column,
            prevValue: column.width,
            newValue: width
        });
    };
    DataTableHeaderComponent.prototype.onColumnReordered = function (_a) {
        var prevIndex = _a.prevIndex, newIndex = _a.newIndex, model = _a.model;
        this.reorder.emit({
            column: model,
            prevValue: prevIndex,
            newValue: newIndex
        });
    };
    DataTableHeaderComponent.prototype.onSort = function (_a) {
        var column = _a.column, prevValue = _a.prevValue, newValue = _a.newValue;
        // if we are dragging don't sort!
        if (column.dragging)
            return;
        var sorts = this.calcNewSorts(column, prevValue, newValue);
        this.sort.emit({
            sorts: sorts,
            column: column,
            prevValue: prevValue,
            newValue: newValue
        });
    };
    DataTableHeaderComponent.prototype.calcNewSorts = function (column, prevValue, newValue) {
        var idx = 0;
        if (!this.sorts) {
            this.sorts = [];
        }
        var sorts = this.sorts.map(function (s, i) {
            s = __assign({}, s);
            if (s.prop === column.prop)
                idx = i;
            return s;
        });
        if (newValue === undefined) {
            sorts.splice(idx, 1);
        }
        else if (prevValue) {
            sorts[idx].dir = newValue;
        }
        else {
            if (this.sortType === types_1.SortType.single) {
                sorts.splice(0, this.sorts.length);
            }
            sorts.push({ dir: newValue, prop: column.prop });
        }
        return sorts;
    };
    DataTableHeaderComponent.prototype.setStylesByGroup = function () {
        this._styleByGroup['left'] = this.calcStylesByGroup('left');
        this._styleByGroup['center'] = this.calcStylesByGroup('center');
        this._styleByGroup['right'] = this.calcStylesByGroup('right');
        this.cd.detectChanges();
    };
    DataTableHeaderComponent.prototype.calcStylesByGroup = function (group) {
        var widths = this._columnGroupWidths;
        var offsetX = this.offsetX;
        var styles = {
            width: widths[group] + "px"
        };
        if (group === 'center') {
            utils_1.translateXY(styles, offsetX * -1, 0);
        }
        else if (group === 'right') {
            var totalDiff = widths.total - this.innerWidth;
            var offset = totalDiff * -1;
            utils_1.translateXY(styles, offset, 0);
        }
        return styles;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableHeaderComponent.prototype, "sortAscendingIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableHeaderComponent.prototype, "sortDescendingIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableHeaderComponent.prototype, "scrollbarH", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableHeaderComponent.prototype, "dealsWithGroup", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], DataTableHeaderComponent.prototype, "innerWidth", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DataTableHeaderComponent.prototype, "sorts", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableHeaderComponent.prototype, "sortType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableHeaderComponent.prototype, "allRowsSelected", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableHeaderComponent.prototype, "selectionType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableHeaderComponent.prototype, "reorderable", void 0);
    __decorate([
        core_1.HostBinding('style.height'),
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], DataTableHeaderComponent.prototype, "headerHeight", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], DataTableHeaderComponent.prototype, "columns", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], DataTableHeaderComponent.prototype, "offsetX", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTableHeaderComponent.prototype, "sort", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTableHeaderComponent.prototype, "reorder", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTableHeaderComponent.prototype, "resize", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTableHeaderComponent.prototype, "select", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], DataTableHeaderComponent.prototype, "columnContextmenu", void 0);
    __decorate([
        core_1.HostBinding('style.width'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], DataTableHeaderComponent.prototype, "headerWidth", null);
    DataTableHeaderComponent = __decorate([
        core_1.Component({
            selector: 'datatable-header',
            template: "\n    <div\n      orderable\n      (reorder)=\"onColumnReordered($event)\"\n      [style.width.px]=\"_columnGroupWidths.total\"\n      class=\"datatable-header-inner\">\n      <div\n        *ngFor=\"let colGroup of _columnsByPin; trackBy: trackByGroups\"\n        [class]=\"'datatable-row-' + colGroup.type\"\n        [ngStyle]=\"_styleByGroup[colGroup.type]\">\n        <datatable-header-cell\n          *ngFor=\"let column of colGroup.columns; trackBy: columnTrackingFn\"\n          resizeable\n          [resizeEnabled]=\"column.resizeable\"\n          (resize)=\"onColumnResized($event, column)\"\n          long-press\n          [pressModel]=\"column\"\n          [pressEnabled]=\"reorderable && column.draggable\"\n          (longPressStart)=\"onLongPressStart($event)\"\n          (longPressEnd)=\"onLongPressEnd($event)\"\n          draggable\n          [dragX]=\"reorderable && column.draggable && column.dragging\"\n          [dragY]=\"false\"\n          [dragModel]=\"column\"\n          [dragEventTarget]=\"dragEventTarget\"\n          [headerHeight]=\"headerHeight\"\n          [column]=\"column\"\n          [sortType]=\"sortType\"\n          [sorts]=\"sorts\"\n          [selectionType]=\"selectionType\"\n          [sortAscendingIcon]=\"sortAscendingIcon\"\n          [sortDescendingIcon]=\"sortDescendingIcon\"\n          [allRowsSelected]=\"allRowsSelected\"\n          (sort)=\"onSort($event)\"\n          (select)=\"select.emit($event)\"\n          (columnContextmenu)=\"columnContextmenu.emit($event)\">\n        </datatable-header-cell>\n      </div>\n    </div>\n  ",
            host: {
                class: 'datatable-header'
            },
            changeDetection: core_1.ChangeDetectionStrategy.OnPush
        }),
        __metadata("design:paramtypes", [core_1.ChangeDetectorRef])
    ], DataTableHeaderComponent);
    return DataTableHeaderComponent;
}());
exports.DataTableHeaderComponent = DataTableHeaderComponent;
//# sourceMappingURL=header.component.js.map

/***/ }),

/***/ "0emy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, $) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TabsComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgTranscludeDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TabDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return WizardComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return WizardModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("2Je8");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var TabsComponent = /** @class */ (function () {
    function TabsComponent() {
        this.tabs = [];
        this.stringHelper = String;
        this.isDestroyed = false;
    }
    /**
     * @return {?}
     */
    TabsComponent.prototype.ngOnDestroy = function () {
        this.isDestroyed = true;
    };
    /**
     * @return {?}
     */
    TabsComponent.prototype.ngOnInit = function () {
        if (this.tabsType == "pills")
            this.classMap += " nav-pills";
    };
    /**
     * @return {?}
     */
    TabsComponent.prototype.ngAfterViewInit = function () {
    };
    /**
     * @param {?} tab
     * @return {?}
     */
    TabsComponent.prototype.addTab = function (tab) {
        if (tab.index == -1)
            return;
        this.tabs.push(tab);
        this.sortTabs();
        //tab.active = this.tabs.length === 1 && tab.active !== false;
    };
    /**
     * @return {?}
     */
    TabsComponent.prototype.sortTabs = function () {
        this.tabs = this.tabs.sort(function (a, b) { return a.index < b.index ? -1 : 1; });
    };
    /**
     * @param {?} tab
     * @param {?=} options
     * @return {?}
     */
    TabsComponent.prototype.removeTab = function (tab, options) {
        if (options === void 0) { options = { reselect: true, emit: true, removeNative: true }; }
        if (tab.index === -1 || this.isDestroyed) {
            return;
        }
        // Select a new tab if the tab to be removed is selected and not destroyed
        if (options.reselect && tab.active && this.hasAvailableTabs(tab.index)) {
            var /** @type {?} */ newActiveIndex = this.getClosestTabIndex(tab.index);
            this.tabs[newActiveIndex].active = true;
        }
        if (options.emit) {
            tab.removed.emit(tab);
        }
        var /** @type {?} */ itemIndex = this.tabs.indexOf(this.tabs.find(function (x) { return x.index == tab.index; }));
        this.tabs.splice(itemIndex, 1);
        if (tab.elementRef.nativeElement && tab.elementRef.nativeElement.remove && options.removeNative) {
            tab.elementRef.nativeElement.remove();
        }
    };
    /**
     * @param {?} index
     * @return {?}
     */
    TabsComponent.prototype.getClosestTabIndex = function (index) {
        var /** @type {?} */ tabsLength = this.tabs.length;
        if (!tabsLength) {
            return -1;
        }
        for (var /** @type {?} */ step = 1; step <= tabsLength; step += 1) {
            var /** @type {?} */ prevIndex = index - step;
            var /** @type {?} */ nextIndex = index + step;
            if (this.tabs[prevIndex] && !this.tabs[prevIndex].disabled) {
                return prevIndex;
            }
            if (this.tabs[nextIndex] && !this.tabs[nextIndex].disabled) {
                return nextIndex;
            }
        }
        return -1;
    };
    /**
     * @param {?} index
     * @return {?}
     */
    TabsComponent.prototype.hasAvailableTabs = function (index) {
        var /** @type {?} */ tabsLength = this.tabs.length;
        if (!tabsLength) {
            return false;
        }
        for (var /** @type {?} */ i = 0; i < tabsLength; i += 1) {
            if (!this.tabs[i].disabled && i !== index) {
                return true;
            }
        }
        return false;
    };
    /**
     * @param {?} tab
     * @return {?}
     */
    TabsComponent.prototype.onSelect = function (tab) {
        this.activeTab = tab;
    };
    return TabsComponent;
}());
TabsComponent.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                selector: 'tabs',
                template: "\n      <div [ngClass]=\"tabsClass\">\n          <ul class=\"nav\" [ngClass]=\"classMap\" (click)=\"$event.preventDefault()\">\n              <li *ngFor=\"let tabz of tabs\" [ngClass]=\"['nav-item', tabz.customClass || '']\" [class.active]=\"tabz.active\" [class.disabled]=\"tabz.disabled\">\n                  <a href=\"javascript:void(0);\" class=\"nav-link\" [class.active]=\"tabz.active\" [class.disabled]=\"tabz.disabled\" (click)=\"tabz.active = true\">\n                      <span [ngTransclude]=\"tabz.headingRef\"><i *ngIf=\"!stringHelper.isNullOrEmpty(tabz.icon)\" class=\"material-icons\">{{tabz.icon}}</i>{{tabz.heading}}</span>\n                  </a>\n              </li>\n          </ul>\n      </div>\n      <div class=\"tab-content\">\n          <ng-content></ng-content>\n      </div>\n    ",
            },] },
];
/**
 * @nocollapse
 */
TabsComponent.ctorParameters = function () { return []; };
TabsComponent.propDecorators = {
    'tabsClass': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ["class",] },],
    'tabsType': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ["type",] },],
    'classMap': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ["navClass",] },],
};
var NgTranscludeDirective = /** @class */ (function () {
    /**
     * @param {?} viewRef
     */
    function NgTranscludeDirective(viewRef) {
        this.viewRef = viewRef;
    }
    Object.defineProperty(NgTranscludeDirective.prototype, "ngTransclude", {
        /**
         * @return {?}
         */
        get: function () {
            return this._ngTransclude;
        },
        /**
         * @param {?} templateRef
         * @return {?}
         */
        set: function (templateRef) {
            this._ngTransclude = templateRef;
            if (templateRef) {
                this.viewRef.createEmbeddedView(templateRef);
            }
        },
        enumerable: true,
        configurable: true
    });
    return NgTranscludeDirective;
}());
NgTranscludeDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[ngTransclude]'
            },] },
];
/**
 * @nocollapse
 */
NgTranscludeDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
]; };
NgTranscludeDirective.propDecorators = {
    'ngTransclude': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
var SelectEvent = /** @class */ (function () {
    /**
     * @param {?} target
     */
    function SelectEvent(target) {
        this._preventDefault = false;
        this.target = target;
    }
    /**
     * @return {?}
     */
    SelectEvent.prototype.preventDefault = function () {
        this._preventDefault = true;
    };
    return SelectEvent;
}());
var TabDirective = /** @class */ (function () {
    /**
     * @param {?} tabsComponent
     * @param {?} elementRef
     */
    function TabDirective(tabsComponent, elementRef) {
        this.elementRef = elementRef;
        this.isTabCombined = false;
        this._index = -1;
        this.check = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](false);
        this.isSelect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](false);
        this.deselect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.removed = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onContinueClicked = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onPreviousClicked = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.addClass = true;
        this.tabsComponent = tabsComponent;
    }
    Object.defineProperty(TabDirective.prototype, "nextButton", {
        /**
         * @return {?}
         */
        get: function () {
            return this._nextButton;
        },
        /**
         * @param {?} val
         * @return {?}
         */
        set: function (val) {
            this._nextButton = val;
            var /** @type {?} */ t = (this.tabsComponent);
            t.nextButtonText = val;
            t.nextButtonVisible = t.nextButtonText != "hidden";
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(TabDirective.prototype, "index", {
        /**
         * @return {?}
         */
        get: function () {
            return this._index;
        },
        /**
         * @param {?} val
         * @return {?}
         */
        set: function (val) {
            var _this = this;
            if (val === -1) {
                this.tabsComponent.removeTab(this, { reselect: true, emit: true, removeNative: false });
                this._index = val;
                return;
            }
            this._index = val;
            //if no tab
            if (!this.tabsComponent.tabs.find(function (x) { return x == _this; }))
                this.tabsComponent.addTab(this);
            this.tabsComponent.sortTabs();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabDirective.prototype, "active", {
        /**
         * @return {?}
         */
        get: function () {
            return this._active;
        },
        /**
         * @param {?} active
         * @return {?}
         */
        set: function (active) {
            var _this = this;
            if (this.disabled && active || !active) {
                if (!active) {
                    this._active = active;
                }
                this.deselect.emit(this);
                return;
            }
            if (this.tabsComponent.activeTab != null) {
                var /** @type {?} */ checkEvent = new SelectEvent(this);
                this.tabsComponent.activeTab.check.emit(checkEvent);
                if (checkEvent._preventDefault) {
                    return;
                }
            }
            this._active = active;
            var /** @type {?} */ event = new SelectEvent(this);
            this.isSelect.emit(event);
            if (event._preventDefault) {
                this._active = false;
                return;
            }
            this.tabsComponent.onSelect(this);
            this.tabsComponent.tabs.forEach(function (tab) {
                if (tab !== _this) {
                    tab.active = false;
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    TabDirective.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.tabsComponent.tabs.find(function (x) { return x == _this; }))
            this.tabsComponent.addTab(this);
    };
    /**
     * @return {?}
     */
    TabDirective.prototype.ngOnDestroy = function () {
        this.tabsComponent.removeTab(this, { reselect: false, emit: false, removeNative: true });
    };
    return TabDirective;
}());
TabDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'tab, [tab]' },] },
];
/**
 * @nocollapse
 */
TabDirective.ctorParameters = function () { return [
    { type: TabsComponent, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
TabDirective.propDecorators = {
    'heading': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'id': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'removable': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'customClass': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'icon': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'previousButton': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'isNextButtonDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'isPrevButtonDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'buttonTemplate': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'nextButton': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'isTabCombined': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'index': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'active': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['class.active',] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'check': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'isSelect': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'deselect': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'removed': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'onContinueClicked': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'onPreviousClicked': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'addClass': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['class.tab-pane',] },],
};
var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function createCommonjsModule(fn, module) {
    return module = { exports: {} }, fn(module, module.exports), module.exports;
}
var jquery = createCommonjsModule(function (module) {
    /*!
     * jQuery JavaScript Library v3.3.1
     * https://jquery.com/
     *
     * Includes Sizzle.js
     * https://sizzlejs.com/
     *
     * Copyright JS Foundation and other contributors
     * Released under the MIT license
     * https://jquery.org/license
     *
     * Date: 2018-01-20T17:24Z
     */
    (function (global, factory) {
        {
            // For CommonJS and CommonJS-like environments where a proper `window`
            // is present, execute the factory and get jQuery.
            // For environments that do not have a `window` with a `document`
            // (such as Node.js), expose a factory as module.exports.
            // This accentuates the need for the creation of a real `window`.
            // e.g. var jQuery = require("jquery")(window);
            // See ticket #14549 for more info.
            module.exports = global.document ?
                factory(global, true) :
                function (w) {
                    if (!w.document) {
                        throw new Error("jQuery requires a window with a document");
                    }
                    return factory(w);
                };
        }
        // Pass this if window is not defined yet
    })(typeof window !== "undefined" ? window : commonjsGlobal, function (window, noGlobal) {
        // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
        // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
        // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
        // enough that all such attempts are guarded in a try block.
        var arr = [];
        var document = window.document;
        var getProto = Object.getPrototypeOf;
        var slice = arr.slice;
        var concat = arr.concat;
        var push = arr.push;
        var indexOf = arr.indexOf;
        var class2type = {};
        var toString = class2type.toString;
        var hasOwn = class2type.hasOwnProperty;
        var fnToString = hasOwn.toString;
        var ObjectFunctionString = fnToString.call(Object);
        var support = {};
        var isFunction = function isFunction(obj) {
            // Support: Chrome <=57, Firefox <=52
            // In some browsers, typeof returns "function" for HTML <object> elements
            // (i.e., `typeof document.createElement( "object" ) === "function"`).
            // We don't want to classify *any* DOM node as a function.
            return typeof obj === "function" && typeof obj.nodeType !== "number";
        };
        var isWindow = function isWindow(obj) {
            return obj != null && obj === obj.window;
        };
        var preservedScriptAttributes = {
            type: true,
            src: true,
            noModule: true
        };
        function DOMEval(code, doc, node) {
            doc = doc || document;
            var i, script = doc.createElement("script");
            script.text = code;
            if (node) {
                for (i in preservedScriptAttributes) {
                    if (node[i]) {
                        script[i] = node[i];
                    }
                }
            }
            doc.head.appendChild(script).parentNode.removeChild(script);
        }
        function toType(obj) {
            if (obj == null) {
                return obj + "";
            }
            // Support: Android <=2.3 only (functionish RegExp)
            return typeof obj === "object" || typeof obj === "function" ?
                class2type[toString.call(obj)] || "object" :
                typeof obj;
        }
        /* global Symbol */
        // Defining this global in .eslintrc.json would create a danger of using the global
        // unguarded in another place, it seems safer to define global only for this module
        var version = "3.3.1", 
        // Define a local copy of jQuery
        jQuery = function (selector, context) {
            // The jQuery object is actually just the init constructor 'enhanced'
            // Need init if jQuery is called (just allow error to be thrown if not included)
            return new jQuery.fn.init(selector, context);
        }, 
        // Support: Android <=4.0 only
        // Make sure we trim BOM and NBSP
        rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        jQuery.fn = jQuery.prototype = {
            // The current version of jQuery being used
            jquery: version,
            constructor: jQuery,
            // The default length of a jQuery object is 0
            length: 0,
            toArray: function () {
                return slice.call(this);
            },
            // Get the Nth element in the matched element set OR
            // Get the whole matched element set as a clean array
            get: function (num) {
                // Return all the elements in a clean array
                if (num == null) {
                    return slice.call(this);
                }
                // Return just the one element from the set
                return num < 0 ? this[num + this.length] : this[num];
            },
            // Take an array of elements and push it onto the stack
            // (returning the new matched element set)
            pushStack: function (elems) {
                // Build a new jQuery matched element set
                var ret = jQuery.merge(this.constructor(), elems);
                // Add the old object onto the stack (as a reference)
                ret.prevObject = this;
                // Return the newly-formed element set
                return ret;
            },
            // Execute a callback for every element in the matched set.
            each: function (callback) {
                return jQuery.each(this, callback);
            },
            map: function (callback) {
                return this.pushStack(jQuery.map(this, function (elem, i) {
                    return callback.call(elem, i, elem);
                }));
            },
            slice: function () {
                return this.pushStack(slice.apply(this, arguments));
            },
            first: function () {
                return this.eq(0);
            },
            last: function () {
                return this.eq(-1);
            },
            eq: function (i) {
                var len = this.length, j = +i + (i < 0 ? len : 0);
                return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
            },
            end: function () {
                return this.prevObject || this.constructor();
            },
            // For internal use only.
            // Behaves like an Array's method, not like a jQuery method.
            push: push,
            sort: arr.sort,
            splice: arr.splice
        };
        jQuery.extend = jQuery.fn.extend = function () {
            var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
            // Handle a deep copy situation
            if (typeof target === "boolean") {
                deep = target;
                // Skip the boolean and the target
                target = arguments[i] || {};
                i++;
            }
            // Handle case when target is a string or something (possible in deep copy)
            if (typeof target !== "object" && !isFunction(target)) {
                target = {};
            }
            // Extend jQuery itself if only one argument is passed
            if (i === length) {
                target = this;
                i--;
            }
            for (; i < length; i++) {
                // Only deal with non-null/undefined values
                if ((options = arguments[i]) != null) {
                    // Extend the base object
                    for (name in options) {
                        src = target[name];
                        copy = options[name];
                        // Prevent never-ending loop
                        if (target === copy) {
                            continue;
                        }
                        // Recurse if we're merging plain objects or arrays
                        if (deep && copy && (jQuery.isPlainObject(copy) ||
                            (copyIsArray = Array.isArray(copy)))) {
                            if (copyIsArray) {
                                copyIsArray = false;
                                clone = src && Array.isArray(src) ? src : [];
                            }
                            else {
                                clone = src && jQuery.isPlainObject(src) ? src : {};
                            }
                            // Never move original objects, clone them
                            target[name] = jQuery.extend(deep, clone, copy);
                            // Don't bring in undefined values
                        }
                        else if (copy !== undefined) {
                            target[name] = copy;
                        }
                    }
                }
            }
            // Return the modified object
            return target;
        };
        jQuery.extend({
            // Unique for each copy of jQuery on the page
            expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
            // Assume jQuery is ready without the ready module
            isReady: true,
            error: function (msg) {
                throw new Error(msg);
            },
            noop: function () { },
            isPlainObject: function (obj) {
                var proto, Ctor;
                // Detect obvious negatives
                // Use toString instead of jQuery.type to catch host objects
                if (!obj || toString.call(obj) !== "[object Object]") {
                    return false;
                }
                proto = getProto(obj);
                // Objects with no prototype (e.g., `Object.create( null )`) are plain
                if (!proto) {
                    return true;
                }
                // Objects with prototype are plain iff they were constructed by a global Object function
                Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
                return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
            },
            isEmptyObject: function (obj) {
                /* eslint-disable no-unused-vars */
                // See https://github.com/eslint/eslint/issues/6125
                var name;
                for (name in obj) {
                    return false;
                }
                return true;
            },
            // Evaluates a script in a global context
            globalEval: function (code) {
                DOMEval(code);
            },
            each: function (obj, callback) {
                var length, i = 0;
                if (isArrayLike(obj)) {
                    length = obj.length;
                    for (; i < length; i++) {
                        if (callback.call(obj[i], i, obj[i]) === false) {
                            break;
                        }
                    }
                }
                else {
                    for (i in obj) {
                        if (callback.call(obj[i], i, obj[i]) === false) {
                            break;
                        }
                    }
                }
                return obj;
            },
            // Support: Android <=4.0 only
            trim: function (text) {
                return text == null ?
                    "" :
                    (text + "").replace(rtrim, "");
            },
            // results is for internal usage only
            makeArray: function (arr, results) {
                var ret = results || [];
                if (arr != null) {
                    if (isArrayLike(Object(arr))) {
                        jQuery.merge(ret, typeof arr === "string" ?
                            [arr] : arr);
                    }
                    else {
                        push.call(ret, arr);
                    }
                }
                return ret;
            },
            inArray: function (elem, arr, i) {
                return arr == null ? -1 : indexOf.call(arr, elem, i);
            },
            // Support: Android <=4.0 only, PhantomJS 1 only
            // push.apply(_, arraylike) throws on ancient WebKit
            merge: function (first, second) {
                var len = +second.length, j = 0, i = first.length;
                for (; j < len; j++) {
                    first[i++] = second[j];
                }
                first.length = i;
                return first;
            },
            grep: function (elems, callback, invert) {
                var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
                // Go through the array, only saving the items
                // that pass the validator function
                for (; i < length; i++) {
                    callbackInverse = !callback(elems[i], i);
                    if (callbackInverse !== callbackExpect) {
                        matches.push(elems[i]);
                    }
                }
                return matches;
            },
            // arg is for internal usage only
            map: function (elems, callback, arg) {
                var length, value, i = 0, ret = [];
                // Go through the array, translating each of the items to their new values
                if (isArrayLike(elems)) {
                    length = elems.length;
                    for (; i < length; i++) {
                        value = callback(elems[i], i, arg);
                        if (value != null) {
                            ret.push(value);
                        }
                    }
                    // Go through every key on the object,
                }
                else {
                    for (i in elems) {
                        value = callback(elems[i], i, arg);
                        if (value != null) {
                            ret.push(value);
                        }
                    }
                }
                // Flatten any nested arrays
                return concat.apply([], ret);
            },
            // A global GUID counter for objects
            guid: 1,
            // jQuery.support is not used in Core but other projects attach their
            // properties to it so it needs to exist.
            support: support
        });
        if (typeof Symbol === "function") {
            jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
        }
        // Populate the class2type map
        jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (i, name) {
            class2type["[object " + name + "]"] = name.toLowerCase();
        });
        function isArrayLike(obj) {
            // Support: real iOS 8.2 only (not reproducible in simulator)
            // `in` check used to prevent JIT error (gh-2145)
            // hasOwn isn't used here due to false negatives
            // regarding Nodelist length in IE
            var length = !!obj && "length" in obj && obj.length, type = toType(obj);
            if (isFunction(obj) || isWindow(obj)) {
                return false;
            }
            return type === "array" || length === 0 ||
                typeof length === "number" && length > 0 && (length - 1) in obj;
        }
        var Sizzle = 
        /*!
         * Sizzle CSS Selector Engine v2.3.3
         * https://sizzlejs.com/
         *
         * Copyright jQuery Foundation and other contributors
         * Released under the MIT license
         * http://jquery.org/license
         *
         * Date: 2016-08-08
         */
        (function (window) {
            var i, support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, 
            // Local document vars
            setDocument, document, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, 
            // Instance-specific data
            expando = "sizzle" + 1 * new Date(), preferredDoc = window.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), sortOrder = function (a, b) {
                if (a === b) {
                    hasDuplicate = true;
                }
                return 0;
            }, 
            // Instance methods
            hasOwn = ({}).hasOwnProperty, arr = [], pop = arr.pop, push_native = arr.push, push = arr.push, slice = arr.slice, 
            // Use a stripped-down indexOf as it's faster than native
            // https://jsperf.com/thor-indexof-vs-for/5
            indexOf = function (list, elem) {
                var i = 0, len = list.length;
                for (; i < len; i++) {
                    if (list[i] === elem) {
                        return i;
                    }
                }
                return -1;
            }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", 
            // Regular expressions
            // http://www.w3.org/TR/css3-selectors/#whitespace
            whitespace = "[\\x20\\t\\r\\n\\f]", 
            // http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
            identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+", 
            // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
            attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
                // Operator (capture 2)
                "*([*^$|!~]?=)" + whitespace +
                // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
                "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
                "*\\]", pseudos = ":(" + identifier + ")(?:\\((" +
                // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
                // 1. quoted (capture 3; capture 4 or capture 5)
                "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
                // 2. simple (capture 6)
                "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
                // 3. anything else (capture 2)
                ".*" +
                ")\\)|)", 
            // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
            rwhitespace = new RegExp(whitespace + "+", "g"), rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rattributeQuotes = new RegExp("=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
                "ID": new RegExp("^#(" + identifier + ")"),
                "CLASS": new RegExp("^\\.(" + identifier + ")"),
                "TAG": new RegExp("^(" + identifier + "|[*])"),
                "ATTR": new RegExp("^" + attributes),
                "PSEUDO": new RegExp("^" + pseudos),
                "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
                    "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
                    "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
                "bool": new RegExp("^(?:" + booleans + ")$", "i"),
                // For use in libraries implementing .is()
                // We use this for POS matching in `select`
                "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                    whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
            }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, 
            // Easily-parseable/retrievable ID or TAG or CLASS selectors
            rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, 
            // CSS escapes
            // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
            runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"), funescape = function (_, escaped, escapedWhitespace) {
                var high = "0x" + escaped - 0x10000;
                // NaN means non-codepoint
                // Support: Firefox<24
                // Workaround erroneous numeric interpretation of +"0x"
                return high !== high || escapedWhitespace ?
                    escaped :
                    high < 0 ?
                        // BMP codepoint
                        String.fromCharCode(high + 0x10000) :
                        // Supplemental Plane codepoint (surrogate pair)
                        String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
            }, 
            // CSS string/identifier serialization
            // https://drafts.csswg.org/cssom/#common-serializing-idioms
            rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, fcssescape = function (ch, asCodePoint) {
                if (asCodePoint) {
                    // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                    if (ch === "\0") {
                        return "\uFFFD";
                    }
                    // Control characters and (dependent upon position) numbers get escaped as code points
                    return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
                }
                // Other potentially-special ASCII characters get backslash-escaped
                return "\\" + ch;
            }, 
            // Used for iframes
            // See setDocument()
            // Removing the function wrapper causes a "Permission Denied"
            // error in IE
            unloadHandler = function () {
                setDocument();
            }, disabledAncestor = addCombinator(function (elem) {
                return elem.disabled === true && ("form" in elem || "label" in elem);
            }, { dir: "parentNode", next: "legend" });
            // Optimize for push.apply( _, NodeList )
            try {
                push.apply((arr = slice.call(preferredDoc.childNodes)), preferredDoc.childNodes);
                // Support: Android<4.0
                // Detect silently failing push.apply
                arr[preferredDoc.childNodes.length].nodeType;
            }
            catch (e) {
                push = { apply: arr.length ?
                        // Leverage slice if possible
                        function (target, els) {
                            push_native.apply(target, slice.call(els));
                        } :
                        // Support: IE<9
                        // Otherwise append directly
                        function (target, els) {
                            var j = target.length, i = 0;
                            // Can't trust NodeList.length
                            while ((target[j++] = els[i++])) { }
                            target.length = j - 1;
                        }
                };
            }
            function Sizzle(selector, context, results, seed) {
                var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, 
                // nodeType defaults to 9, since context defaults to document
                nodeType = context ? context.nodeType : 9;
                results = results || [];
                // Return early from calls with invalid selector or context
                if (typeof selector !== "string" || !selector ||
                    nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
                    return results;
                }
                // Try to shortcut find operations (as opposed to filters) in HTML documents
                if (!seed) {
                    if ((context ? context.ownerDocument || context : preferredDoc) !== document) {
                        setDocument(context);
                    }
                    context = context || document;
                    if (documentIsHTML) {
                        // If the selector is sufficiently simple, try using a "get*By*" DOM method
                        // (excepting DocumentFragment context, where the methods don't exist)
                        if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                            // ID selector
                            if ((m = match[1])) {
                                // Document context
                                if (nodeType === 9) {
                                    if ((elem = context.getElementById(m))) {
                                        // Support: IE, Opera, Webkit
                                        // TODO: identify versions
                                        // getElementById can match elements by name instead of ID
                                        if (elem.id === m) {
                                            results.push(elem);
                                            return results;
                                        }
                                    }
                                    else {
                                        return results;
                                    }
                                    // Element context
                                }
                                else {
                                    // Support: IE, Opera, Webkit
                                    // TODO: identify versions
                                    // getElementById can match elements by name instead of ID
                                    if (newContext && (elem = newContext.getElementById(m)) &&
                                        contains(context, elem) &&
                                        elem.id === m) {
                                        results.push(elem);
                                        return results;
                                    }
                                }
                                // Type selector
                            }
                            else if (match[2]) {
                                push.apply(results, context.getElementsByTagName(selector));
                                return results;
                                // Class selector
                            }
                            else if ((m = match[3]) && support.getElementsByClassName &&
                                context.getElementsByClassName) {
                                push.apply(results, context.getElementsByClassName(m));
                                return results;
                            }
                        }
                        // Take advantage of querySelectorAll
                        if (support.qsa &&
                            !compilerCache[selector + " "] &&
                            (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                            if (nodeType !== 1) {
                                newContext = context;
                                newSelector = selector;
                                // qSA looks outside Element context, which is not what we want
                                // Thanks to Andrew Dupont for this workaround technique
                                // Support: IE <=8
                                // Exclude object elements
                            }
                            else if (context.nodeName.toLowerCase() !== "object") {
                                // Capture the context ID, setting it first if necessary
                                if ((nid = context.getAttribute("id"))) {
                                    nid = nid.replace(rcssescape, fcssescape);
                                }
                                else {
                                    context.setAttribute("id", (nid = expando));
                                }
                                // Prefix every selector in the list
                                groups = tokenize(selector);
                                i = groups.length;
                                while (i--) {
                                    groups[i] = "#" + nid + " " + toSelector(groups[i]);
                                }
                                newSelector = groups.join(",");
                                // Expand context for sibling selectors
                                newContext = rsibling.test(selector) && testContext(context.parentNode) ||
                                    context;
                            }
                            if (newSelector) {
                                try {
                                    push.apply(results, newContext.querySelectorAll(newSelector));
                                    return results;
                                }
                                catch (qsaError) {
                                }
                                finally {
                                    if (nid === expando) {
                                        context.removeAttribute("id");
                                    }
                                }
                            }
                        }
                    }
                }
                // All others
                return select(selector.replace(rtrim, "$1"), context, results, seed);
            }
            /**
             * Create key-value caches of limited size
             * @returns {function(string, object)} Returns the Object data after storing it on itself with
             *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
             *	deleting the oldest entry
             */
            function createCache() {
                var keys = [];
                function cache(key, value) {
                    // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                    if (keys.push(key + " ") > Expr.cacheLength) {
                        // Only keep the most recent entries
                        delete cache[keys.shift()];
                    }
                    return (cache[key + " "] = value);
                }
                return cache;
            }
            /**
             * Mark a function for special use by Sizzle
             * @param {Function} fn The function to mark
             */
            function markFunction(fn) {
                fn[expando] = true;
                return fn;
            }
            /**
             * Support testing using an element
             * @param {Function} fn Passed the created element and returns a boolean result
             */
            function assert(fn) {
                var el = document.createElement("fieldset");
                try {
                    return !!fn(el);
                }
                catch (e) {
                    return false;
                }
                finally {
                    // Remove from its parent by default
                    if (el.parentNode) {
                        el.parentNode.removeChild(el);
                    }
                    // release memory in IE
                    el = null;
                }
            }
            /**
             * Adds the same handler for all of the specified attrs
             * @param {String} attrs Pipe-separated list of attributes
             * @param {Function} handler The method that will be applied
             */
            function addHandle(attrs, handler) {
                var arr = attrs.split("|"), i = arr.length;
                while (i--) {
                    Expr.attrHandle[arr[i]] = handler;
                }
            }
            /**
             * Checks document order of two siblings
             * @param {Element} a
             * @param {Element} b
             * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
             */
            function siblingCheck(a, b) {
                var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
                    a.sourceIndex - b.sourceIndex;
                // Use IE sourceIndex if available on both nodes
                if (diff) {
                    return diff;
                }
                // Check if b follows a
                if (cur) {
                    while ((cur = cur.nextSibling)) {
                        if (cur === b) {
                            return -1;
                        }
                    }
                }
                return a ? 1 : -1;
            }
            /**
             * Returns a function to use in pseudos for input types
             * @param {String} type
             */
            function createInputPseudo(type) {
                return function (elem) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && elem.type === type;
                };
            }
            /**
             * Returns a function to use in pseudos for buttons
             * @param {String} type
             */
            function createButtonPseudo(type) {
                return function (elem) {
                    var name = elem.nodeName.toLowerCase();
                    return (name === "input" || name === "button") && elem.type === type;
                };
            }
            /**
             * Returns a function to use in pseudos for :enabled/:disabled
             * @param {Boolean} disabled true for :disabled; false for :enabled
             */
            function createDisabledPseudo(disabled) {
                // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
                return function (elem) {
                    // Only certain elements can match :enabled or :disabled
                    // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                    // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                    if ("form" in elem) {
                        // Check for inherited disabledness on relevant non-disabled elements:
                        // * listed form-associated elements in a disabled fieldset
                        //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                        //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                        // * option elements in a disabled optgroup
                        //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                        // All such elements have a "form" property.
                        if (elem.parentNode && elem.disabled === false) {
                            // Option elements defer to a parent optgroup if present
                            if ("label" in elem) {
                                if ("label" in elem.parentNode) {
                                    return elem.parentNode.disabled === disabled;
                                }
                                else {
                                    return elem.disabled === disabled;
                                }
                            }
                            // Support: IE 6 - 11
                            // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                            return elem.isDisabled === disabled ||
                                // Where there is no isDisabled, check manually
                                /* jshint -W018 */
                                elem.isDisabled !== !disabled &&
                                    disabledAncestor(elem) === disabled;
                        }
                        return elem.disabled === disabled;
                        // Try to winnow out elements that can't be disabled before trusting the disabled property.
                        // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                        // even exist on them, let alone have a boolean value.
                    }
                    else if ("label" in elem) {
                        return elem.disabled === disabled;
                    }
                    // Remaining elements are neither :enabled nor :disabled
                    return false;
                };
            }
            /**
             * Returns a function to use in pseudos for positionals
             * @param {Function} fn
             */
            function createPositionalPseudo(fn) {
                return markFunction(function (argument) {
                    argument = +argument;
                    return markFunction(function (seed, matches) {
                        var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                        // Match elements found at the specified indexes
                        while (i--) {
                            if (seed[(j = matchIndexes[i])]) {
                                seed[j] = !(matches[j] = seed[j]);
                            }
                        }
                    });
                });
            }
            /**
             * Checks a node for validity as a Sizzle context
             * @param {Element|Object=} context
             * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
             */
            function testContext(context) {
                return context && typeof context.getElementsByTagName !== "undefined" && context;
            }
            // Expose support vars for convenience
            support = Sizzle.support = {};
            /**
             * Detects XML nodes
             * @param {Element|Object} elem An element or a document
             * @returns {Boolean} True iff elem is a non-HTML XML node
             */
            isXML = Sizzle.isXML = function (elem) {
                // documentElement is verified for cases where it doesn't yet exist
                // (such as loading iframes in IE - #4833)
                var documentElement = elem && (elem.ownerDocument || elem).documentElement;
                return documentElement ? documentElement.nodeName !== "HTML" : false;
            };
            /**
             * Sets document-related variables once based on the current document
             * @param {Element|Object} [doc] An element or document object to use to set the document
             * @returns {Object} Returns the current document
             */
            setDocument = Sizzle.setDocument = function (node) {
                var hasCompare, subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
                // Return early if doc is invalid or already selected
                if (doc === document || doc.nodeType !== 9 || !doc.documentElement) {
                    return document;
                }
                // Update global variables
                document = doc;
                docElem = document.documentElement;
                documentIsHTML = !isXML(document);
                // Support: IE 9-11, Edge
                // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
                if (preferredDoc !== document &&
                    (subWindow = document.defaultView) && subWindow.top !== subWindow) {
                    // Support: IE 11, Edge
                    if (subWindow.addEventListener) {
                        subWindow.addEventListener("unload", unloadHandler, false);
                        // Support: IE 9 - 10 only
                    }
                    else if (subWindow.attachEvent) {
                        subWindow.attachEvent("onunload", unloadHandler);
                    }
                }
                /* Attributes
                ---------------------------------------------------------------------- */
                // Support: IE<8
                // Verify that getAttribute really returns attributes and not properties
                // (excepting IE8 booleans)
                support.attributes = assert(function (el) {
                    el.className = "i";
                    return !el.getAttribute("className");
                });
                /* getElement(s)By*
                ---------------------------------------------------------------------- */
                // Check if getElementsByTagName("*") returns only elements
                support.getElementsByTagName = assert(function (el) {
                    el.appendChild(document.createComment(""));
                    return !el.getElementsByTagName("*").length;
                });
                // Support: IE<9
                support.getElementsByClassName = rnative.test(document.getElementsByClassName);
                // Support: IE<10
                // Check if getElementById returns elements by name
                // The broken getElementById methods don't pick up programmatically-set names,
                // so use a roundabout getElementsByName test
                support.getById = assert(function (el) {
                    docElem.appendChild(el).id = expando;
                    return !document.getElementsByName || !document.getElementsByName(expando).length;
                });
                // ID filter and find
                if (support.getById) {
                    Expr.filter["ID"] = function (id) {
                        var attrId = id.replace(runescape, funescape);
                        return function (elem) {
                            return elem.getAttribute("id") === attrId;
                        };
                    };
                    Expr.find["ID"] = function (id, context) {
                        if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                            var elem = context.getElementById(id);
                            return elem ? [elem] : [];
                        }
                    };
                }
                else {
                    Expr.filter["ID"] = function (id) {
                        var attrId = id.replace(runescape, funescape);
                        return function (elem) {
                            var node = typeof elem.getAttributeNode !== "undefined" &&
                                elem.getAttributeNode("id");
                            return node && node.value === attrId;
                        };
                    };
                    // Support: IE 6 - 7 only
                    // getElementById is not reliable as a find shortcut
                    Expr.find["ID"] = function (id, context) {
                        if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                            var node, i, elems, elem = context.getElementById(id);
                            if (elem) {
                                // Verify the id attribute
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) {
                                    return [elem];
                                }
                                // Fall back on getElementsByName
                                elems = context.getElementsByName(id);
                                i = 0;
                                while ((elem = elems[i++])) {
                                    node = elem.getAttributeNode("id");
                                    if (node && node.value === id) {
                                        return [elem];
                                    }
                                }
                            }
                            return [];
                        }
                    };
                }
                // Tag
                Expr.find["TAG"] = support.getElementsByTagName ?
                    function (tag, context) {
                        if (typeof context.getElementsByTagName !== "undefined") {
                            return context.getElementsByTagName(tag);
                            // DocumentFragment nodes don't have gEBTN
                        }
                        else if (support.qsa) {
                            return context.querySelectorAll(tag);
                        }
                    } :
                    function (tag, context) {
                        var elem, tmp = [], i = 0, 
                        // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                        results = context.getElementsByTagName(tag);
                        // Filter out possible comments
                        if (tag === "*") {
                            while ((elem = results[i++])) {
                                if (elem.nodeType === 1) {
                                    tmp.push(elem);
                                }
                            }
                            return tmp;
                        }
                        return results;
                    };
                // Class
                Expr.find["CLASS"] = support.getElementsByClassName && function (className, context) {
                    if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
                        return context.getElementsByClassName(className);
                    }
                };
                /* QSA/matchesSelector
                ---------------------------------------------------------------------- */
                // QSA and matchesSelector support
                // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
                rbuggyMatches = [];
                // qSa(:focus) reports false when true (Chrome 21)
                // We allow this because of a bug in IE8/9 that throws an error
                // whenever `document.activeElement` is accessed on an iframe
                // So, we allow :focus to pass through QSA all the time to avoid the IE error
                // See https://bugs.jquery.com/ticket/13378
                rbuggyQSA = [];
                if ((support.qsa = rnative.test(document.querySelectorAll))) {
                    // Build QSA regex
                    // Regex strategy adopted from Diego Perini
                    assert(function (el) {
                        // Select is set to empty string on purpose
                        // This is to test IE's treatment of not explicitly
                        // setting a boolean content attribute,
                        // since its presence should be enough
                        // https://bugs.jquery.com/ticket/12359
                        docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" +
                            "<select id='" + expando + "-\r\\' msallowcapture=''>" +
                            "<option selected=''></option></select>";
                        // Support: IE8, Opera 11-12.16
                        // Nothing should be selected when empty strings follow ^= or $= or *=
                        // The test attribute must be unknown in Opera but "safe" for WinRT
                        // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                        if (el.querySelectorAll("[msallowcapture^='']").length) {
                            rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                        }
                        // Support: IE8
                        // Boolean attributes and "value" are not treated correctly
                        if (!el.querySelectorAll("[selected]").length) {
                            rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                        }
                        // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                        if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
                            rbuggyQSA.push("~=");
                        }
                        // Webkit/Opera - :checked should return selected option elements
                        // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                        // IE8 throws error here and will not see later tests
                        if (!el.querySelectorAll(":checked").length) {
                            rbuggyQSA.push(":checked");
                        }
                        // Support: Safari 8+, iOS 8+
                        // https://bugs.webkit.org/show_bug.cgi?id=136851
                        // In-page `selector#id sibling-combinator selector` fails
                        if (!el.querySelectorAll("a#" + expando + "+*").length) {
                            rbuggyQSA.push(".#.+[+~]");
                        }
                    });
                    assert(function (el) {
                        el.innerHTML = "<a href='' disabled='disabled'></a>" +
                            "<select disabled='disabled'><option/></select>";
                        // Support: Windows 8 Native Apps
                        // The type and name attributes are restricted during .innerHTML assignment
                        var input = document.createElement("input");
                        input.setAttribute("type", "hidden");
                        el.appendChild(input).setAttribute("name", "D");
                        // Support: IE8
                        // Enforce case-sensitivity of name attribute
                        if (el.querySelectorAll("[name=d]").length) {
                            rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                        }
                        // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                        // IE8 throws error here and will not see later tests
                        if (el.querySelectorAll(":enabled").length !== 2) {
                            rbuggyQSA.push(":enabled", ":disabled");
                        }
                        // Support: IE9-11+
                        // IE's :disabled selector does not pick up the children of disabled fieldsets
                        docElem.appendChild(el).disabled = true;
                        if (el.querySelectorAll(":disabled").length !== 2) {
                            rbuggyQSA.push(":enabled", ":disabled");
                        }
                        // Opera 10-11 does not throw on post-comma invalid pseudos
                        el.querySelectorAll("*,:x");
                        rbuggyQSA.push(",.*:");
                    });
                }
                if ((support.matchesSelector = rnative.test((matches = docElem.matches ||
                    docElem.webkitMatchesSelector ||
                    docElem.mozMatchesSelector ||
                    docElem.oMatchesSelector ||
                    docElem.msMatchesSelector)))) {
                    assert(function (el) {
                        // Check to see if it's possible to do matchesSelector
                        // on a disconnected node (IE 9)
                        support.disconnectedMatch = matches.call(el, "*");
                        // This should fail with an exception
                        // Gecko does not error, returns false instead
                        matches.call(el, "[s!='']:x");
                        rbuggyMatches.push("!=", pseudos);
                    });
                }
                rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
                rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
                /* Contains
                ---------------------------------------------------------------------- */
                hasCompare = rnative.test(docElem.compareDocumentPosition);
                // Element contains another
                // Purposefully self-exclusive
                // As in, an element does not contain itself
                contains = hasCompare || rnative.test(docElem.contains) ?
                    function (a, b) {
                        var adown = a.nodeType === 9 ? a.documentElement : a, bup = b && b.parentNode;
                        return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ?
                            adown.contains(bup) :
                            a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
                    } :
                    function (a, b) {
                        if (b) {
                            while ((b = b.parentNode)) {
                                if (b === a) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    };
                /* Sorting
                ---------------------------------------------------------------------- */
                // Document order sorting
                sortOrder = hasCompare ?
                    function (a, b) {
                        // Flag for duplicate removal
                        if (a === b) {
                            hasDuplicate = true;
                            return 0;
                        }
                        // Sort on method existence if only one input has compareDocumentPosition
                        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                        if (compare) {
                            return compare;
                        }
                        // Calculate position if both inputs belong to the same document
                        compare = (a.ownerDocument || a) === (b.ownerDocument || b) ?
                            a.compareDocumentPosition(b) :
                            // Otherwise we know they are disconnected
                            1;
                        // Disconnected nodes
                        if (compare & 1 ||
                            (!support.sortDetached && b.compareDocumentPosition(a) === compare)) {
                            // Choose the first element that is related to our preferred document
                            if (a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
                                return -1;
                            }
                            if (b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
                                return 1;
                            }
                            // Maintain original order
                            return sortInput ?
                                (indexOf(sortInput, a) - indexOf(sortInput, b)) :
                                0;
                        }
                        return compare & 4 ? -1 : 1;
                    } :
                    function (a, b) {
                        // Exit early if the nodes are identical
                        if (a === b) {
                            hasDuplicate = true;
                            return 0;
                        }
                        var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [a], bp = [b];
                        // Parentless nodes are either documents or disconnected
                        if (!aup || !bup) {
                            return a === document ? -1 :
                                b === document ? 1 :
                                    aup ? -1 :
                                        bup ? 1 :
                                            sortInput ?
                                                (indexOf(sortInput, a) - indexOf(sortInput, b)) :
                                                0;
                            // If the nodes are siblings, we can do a quick check
                        }
                        else if (aup === bup) {
                            return siblingCheck(a, b);
                        }
                        // Otherwise we need full lists of their ancestors for comparison
                        cur = a;
                        while ((cur = cur.parentNode)) {
                            ap.unshift(cur);
                        }
                        cur = b;
                        while ((cur = cur.parentNode)) {
                            bp.unshift(cur);
                        }
                        // Walk down the tree looking for a discrepancy
                        while (ap[i] === bp[i]) {
                            i++;
                        }
                        return i ?
                            // Do a sibling check if the nodes have a common ancestor
                            siblingCheck(ap[i], bp[i]) :
                            // Otherwise nodes in our document sort first
                            ap[i] === preferredDoc ? -1 :
                                bp[i] === preferredDoc ? 1 :
                                    0;
                    };
                return document;
            };
            Sizzle.matches = function (expr, elements) {
                return Sizzle(expr, null, null, elements);
            };
            Sizzle.matchesSelector = function (elem, expr) {
                // Set document vars if needed
                if ((elem.ownerDocument || elem) !== document) {
                    setDocument(elem);
                }
                // Make sure that attribute selectors are quoted
                expr = expr.replace(rattributeQuotes, "='$1']");
                if (support.matchesSelector && documentIsHTML &&
                    !compilerCache[expr + " "] &&
                    (!rbuggyMatches || !rbuggyMatches.test(expr)) &&
                    (!rbuggyQSA || !rbuggyQSA.test(expr))) {
                    try {
                        var ret = matches.call(elem, expr);
                        // IE 9's matchesSelector returns false on disconnected nodes
                        if (ret || support.disconnectedMatch ||
                            // As well, disconnected nodes are said to be in a document
                            // fragment in IE 9
                            elem.document && elem.document.nodeType !== 11) {
                            return ret;
                        }
                    }
                    catch (e) { }
                }
                return Sizzle(expr, document, null, [elem]).length > 0;
            };
            Sizzle.contains = function (context, elem) {
                // Set document vars if needed
                if ((context.ownerDocument || context) !== document) {
                    setDocument(context);
                }
                return contains(context, elem);
            };
            Sizzle.attr = function (elem, name) {
                // Set document vars if needed
                if ((elem.ownerDocument || elem) !== document) {
                    setDocument(elem);
                }
                var fn = Expr.attrHandle[name.toLowerCase()], 
                // Don't get fooled by Object.prototype properties (jQuery #13807)
                val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ?
                    fn(elem, name, !documentIsHTML) :
                    undefined;
                return val !== undefined ?
                    val :
                    support.attributes || !documentIsHTML ?
                        elem.getAttribute(name) :
                        (val = elem.getAttributeNode(name)) && val.specified ?
                            val.value :
                            null;
            };
            Sizzle.escape = function (sel) {
                return (sel + "").replace(rcssescape, fcssescape);
            };
            Sizzle.error = function (msg) {
                throw new Error("Syntax error, unrecognized expression: " + msg);
            };
            /**
             * Document sorting and removing duplicates
             * @param {ArrayLike} results
             */
            Sizzle.uniqueSort = function (results) {
                var elem, duplicates = [], j = 0, i = 0;
                // Unless we *know* we can detect duplicates, assume their presence
                hasDuplicate = !support.detectDuplicates;
                sortInput = !support.sortStable && results.slice(0);
                results.sort(sortOrder);
                if (hasDuplicate) {
                    while ((elem = results[i++])) {
                        if (elem === results[i]) {
                            j = duplicates.push(i);
                        }
                    }
                    while (j--) {
                        results.splice(duplicates[j], 1);
                    }
                }
                // Clear input after sorting to release objects
                // See https://github.com/jquery/sizzle/pull/225
                sortInput = null;
                return results;
            };
            /**
             * Utility function for retrieving the text value of an array of DOM nodes
             * @param {Array|Element} elem
             */
            getText = Sizzle.getText = function (elem) {
                var node, ret = "", i = 0, nodeType = elem.nodeType;
                if (!nodeType) {
                    // If no nodeType, this is expected to be an array
                    while ((node = elem[i++])) {
                        // Do not traverse comment nodes
                        ret += getText(node);
                    }
                }
                else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                    // Use textContent for elements
                    // innerText usage removed for consistency of new lines (jQuery #11153)
                    if (typeof elem.textContent === "string") {
                        return elem.textContent;
                    }
                    else {
                        // Traverse its children
                        for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                            ret += getText(elem);
                        }
                    }
                }
                else if (nodeType === 3 || nodeType === 4) {
                    return elem.nodeValue;
                }
                // Do not include comment or processing instruction nodes
                return ret;
            };
            Expr = Sizzle.selectors = {
                // Can be adjusted by the user
                cacheLength: 50,
                createPseudo: markFunction,
                match: matchExpr,
                attrHandle: {},
                find: {},
                relative: {
                    ">": { dir: "parentNode", first: true },
                    " ": { dir: "parentNode" },
                    "+": { dir: "previousSibling", first: true },
                    "~": { dir: "previousSibling" }
                },
                preFilter: {
                    "ATTR": function (match) {
                        match[1] = match[1].replace(runescape, funescape);
                        // Move the given value to match[3] whether quoted or unquoted
                        match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                        if (match[2] === "~=") {
                            match[3] = " " + match[3] + " ";
                        }
                        return match.slice(0, 4);
                    },
                    "CHILD": function (match) {
                        /* matches from matchExpr["CHILD"]
                            1 type (only|nth|...)
                            2 what (child|of-type)
                            3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
                            4 xn-component of xn+y argument ([+-]?\d*n|)
                            5 sign of xn-component
                            6 x of xn-component
                            7 sign of y-component
                            8 y of y-component
                        */
                        match[1] = match[1].toLowerCase();
                        if (match[1].slice(0, 3) === "nth") {
                            // nth-* requires argument
                            if (!match[3]) {
                                Sizzle.error(match[0]);
                            }
                            // numeric x and y parameters for Expr.filter.CHILD
                            // remember that false/true cast respectively to 0/1
                            match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                            match[5] = +((match[7] + match[8]) || match[3] === "odd");
                            // other types prohibit arguments
                        }
                        else if (match[3]) {
                            Sizzle.error(match[0]);
                        }
                        return match;
                    },
                    "PSEUDO": function (match) {
                        var excess, unquoted = !match[6] && match[2];
                        if (matchExpr["CHILD"].test(match[0])) {
                            return null;
                        }
                        // Accept quoted arguments as-is
                        if (match[3]) {
                            match[2] = match[4] || match[5] || "";
                            // Strip excess characters from unquoted arguments
                        }
                        else if (unquoted && rpseudo.test(unquoted) &&
                            // Get excess from tokenize (recursively)
                            (excess = tokenize(unquoted, true)) &&
                            // advance to the next closing parenthesis
                            (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                            // excess is a negative index
                            match[0] = match[0].slice(0, excess);
                            match[2] = unquoted.slice(0, excess);
                        }
                        // Return only captures needed by the pseudo filter method (type and argument)
                        return match.slice(0, 3);
                    }
                },
                filter: {
                    "TAG": function (nodeNameSelector) {
                        var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                        return nodeNameSelector === "*" ?
                            function () { return true; } :
                            function (elem) {
                                return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                            };
                    },
                    "CLASS": function (className) {
                        var pattern = classCache[className + " "];
                        return pattern ||
                            (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) &&
                                classCache(className, function (elem) {
                                    return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                                });
                    },
                    "ATTR": function (name, operator, check) {
                        return function (elem) {
                            var result = Sizzle.attr(elem, name);
                            if (result == null) {
                                return operator === "!=";
                            }
                            if (!operator) {
                                return true;
                            }
                            result += "";
                            return operator === "=" ? result === check :
                                operator === "!=" ? result !== check :
                                    operator === "^=" ? check && result.indexOf(check) === 0 :
                                        operator === "*=" ? check && result.indexOf(check) > -1 :
                                            operator === "$=" ? check && result.slice(-check.length) === check :
                                                operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 :
                                                    operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" :
                                                        false;
                        };
                    },
                    "CHILD": function (type, what, argument, first, last) {
                        var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                        return first === 1 && last === 0 ?
                            // Shortcut for :nth-*(n)
                            function (elem) {
                                return !!elem.parentNode;
                            } :
                            function (elem, context, xml) {
                                var cache, uniqueCache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                                if (parent) {
                                    // :(first|last|only)-(child|of-type)
                                    if (simple) {
                                        while (dir) {
                                            node = elem;
                                            while ((node = node[dir])) {
                                                if (ofType ?
                                                    node.nodeName.toLowerCase() === name :
                                                    node.nodeType === 1) {
                                                    return false;
                                                }
                                            }
                                            // Reverse direction for :only-* (if we haven't yet done so)
                                            start = dir = type === "only" && !start && "nextSibling";
                                        }
                                        return true;
                                    }
                                    start = [forward ? parent.firstChild : parent.lastChild];
                                    // non-xml :nth-child(...) stores cache data on `parent`
                                    if (forward && useCache) {
                                        // Seek `elem` from a previously-cached index
                                        // ...in a gzip-friendly way
                                        node = parent;
                                        outerCache = node[expando] || (node[expando] = {});
                                        // Support: IE <9 only
                                        // Defend against cloned attroperties (jQuery gh-1709)
                                        uniqueCache = outerCache[node.uniqueID] ||
                                            (outerCache[node.uniqueID] = {});
                                        cache = uniqueCache[type] || [];
                                        nodeIndex = cache[0] === dirruns && cache[1];
                                        diff = nodeIndex && cache[2];
                                        node = nodeIndex && parent.childNodes[nodeIndex];
                                        while ((node = ++nodeIndex && node && node[dir] ||
                                            // Fallback to seeking `elem` from the start
                                            (diff = nodeIndex = 0) || start.pop())) {
                                            // When found, cache indexes on `parent` and break
                                            if (node.nodeType === 1 && ++diff && node === elem) {
                                                uniqueCache[type] = [dirruns, nodeIndex, diff];
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        // Use previously-cached element index if available
                                        if (useCache) {
                                            // ...in a gzip-friendly way
                                            node = elem;
                                            outerCache = node[expando] || (node[expando] = {});
                                            // Support: IE <9 only
                                            // Defend against cloned attroperties (jQuery gh-1709)
                                            uniqueCache = outerCache[node.uniqueID] ||
                                                (outerCache[node.uniqueID] = {});
                                            cache = uniqueCache[type] || [];
                                            nodeIndex = cache[0] === dirruns && cache[1];
                                            diff = nodeIndex;
                                        }
                                        // xml :nth-child(...)
                                        // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                        if (diff === false) {
                                            // Use the same loop as above to seek `elem` from the start
                                            while ((node = ++nodeIndex && node && node[dir] ||
                                                (diff = nodeIndex = 0) || start.pop())) {
                                                if ((ofType ?
                                                    node.nodeName.toLowerCase() === name :
                                                    node.nodeType === 1) &&
                                                    ++diff) {
                                                    // Cache the index of each encountered element
                                                    if (useCache) {
                                                        outerCache = node[expando] || (node[expando] = {});
                                                        // Support: IE <9 only
                                                        // Defend against cloned attroperties (jQuery gh-1709)
                                                        uniqueCache = outerCache[node.uniqueID] ||
                                                            (outerCache[node.uniqueID] = {});
                                                        uniqueCache[type] = [dirruns, diff];
                                                    }
                                                    if (node === elem) {
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    // Incorporate the offset, then check against cycle size
                                    diff -= last;
                                    return diff === first || (diff % first === 0 && diff / first >= 0);
                                }
                            };
                    },
                    "PSEUDO": function (pseudo, argument) {
                        // pseudo-class names are case-insensitive
                        // http://www.w3.org/TR/selectors/#pseudo-classes
                        // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                        // Remember that setFilters inherits from pseudos
                        var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] ||
                            Sizzle.error("unsupported pseudo: " + pseudo);
                        // The user may use createPseudo to indicate that
                        // arguments are needed to create the filter function
                        // just as Sizzle does
                        if (fn[expando]) {
                            return fn(argument);
                        }
                        // But maintain support for old signatures
                        if (fn.length > 1) {
                            args = [pseudo, pseudo, "", argument];
                            return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ?
                                markFunction(function (seed, matches) {
                                    var idx, matched = fn(seed, argument), i = matched.length;
                                    while (i--) {
                                        idx = indexOf(seed, matched[i]);
                                        seed[idx] = !(matches[idx] = matched[i]);
                                    }
                                }) :
                                function (elem) {
                                    return fn(elem, 0, args);
                                };
                        }
                        return fn;
                    }
                },
                pseudos: {
                    // Potentially complex pseudos
                    "not": markFunction(function (selector) {
                        // Trim the selector passed to compile
                        // to avoid treating leading and trailing
                        // spaces as combinators
                        var input = [], results = [], matcher = compile(selector.replace(rtrim, "$1"));
                        return matcher[expando] ?
                            markFunction(function (seed, matches, context, xml) {
                                var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                                // Match elements unmatched by `matcher`
                                while (i--) {
                                    if ((elem = unmatched[i])) {
                                        seed[i] = !(matches[i] = elem);
                                    }
                                }
                            }) :
                            function (elem, context, xml) {
                                input[0] = elem;
                                matcher(input, null, xml, results);
                                // Don't keep the element (issue #299)
                                input[0] = null;
                                return !results.pop();
                            };
                    }),
                    "has": markFunction(function (selector) {
                        return function (elem) {
                            return Sizzle(selector, elem).length > 0;
                        };
                    }),
                    "contains": markFunction(function (text) {
                        text = text.replace(runescape, funescape);
                        return function (elem) {
                            return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
                        };
                    }),
                    // "Whether an element is represented by a :lang() selector
                    // is based solely on the element's language value
                    // being equal to the identifier C,
                    // or beginning with the identifier C immediately followed by "-".
                    // The matching of C against the element's language value is performed case-insensitively.
                    // The identifier C does not have to be a valid language name."
                    // http://www.w3.org/TR/selectors/#lang-pseudo
                    "lang": markFunction(function (lang) {
                        // lang value must be a valid identifier
                        if (!ridentifier.test(lang || "")) {
                            Sizzle.error("unsupported lang: " + lang);
                        }
                        lang = lang.replace(runescape, funescape).toLowerCase();
                        return function (elem) {
                            var elemLang;
                            do {
                                if ((elemLang = documentIsHTML ?
                                    elem.lang :
                                    elem.getAttribute("xml:lang") || elem.getAttribute("lang"))) {
                                    elemLang = elemLang.toLowerCase();
                                    return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                                }
                            } while ((elem = elem.parentNode) && elem.nodeType === 1);
                            return false;
                        };
                    }),
                    // Miscellaneous
                    "target": function (elem) {
                        var hash = window.location && window.location.hash;
                        return hash && hash.slice(1) === elem.id;
                    },
                    "root": function (elem) {
                        return elem === docElem;
                    },
                    "focus": function (elem) {
                        return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                    },
                    // Boolean properties
                    "enabled": createDisabledPseudo(false),
                    "disabled": createDisabledPseudo(true),
                    "checked": function (elem) {
                        // In CSS3, :checked should return both checked and selected elements
                        // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                        var nodeName = elem.nodeName.toLowerCase();
                        return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
                    },
                    "selected": function (elem) {
                        // Accessing this property makes selected-by-default
                        // options in Safari work properly
                        if (elem.parentNode) {
                            elem.parentNode.selectedIndex;
                        }
                        return elem.selected === true;
                    },
                    // Contents
                    "empty": function (elem) {
                        // http://www.w3.org/TR/selectors/#empty-pseudo
                        // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                        //   but not by others (comment: 8; processing instruction: 7; etc.)
                        // nodeType < 6 works because attributes (2) do not appear as children
                        for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                            if (elem.nodeType < 6) {
                                return false;
                            }
                        }
                        return true;
                    },
                    "parent": function (elem) {
                        return !Expr.pseudos["empty"](elem);
                    },
                    // Element/input types
                    "header": function (elem) {
                        return rheader.test(elem.nodeName);
                    },
                    "input": function (elem) {
                        return rinputs.test(elem.nodeName);
                    },
                    "button": function (elem) {
                        var name = elem.nodeName.toLowerCase();
                        return name === "input" && elem.type === "button" || name === "button";
                    },
                    "text": function (elem) {
                        var attr;
                        return elem.nodeName.toLowerCase() === "input" &&
                            elem.type === "text" &&
                            // Support: IE<8
                            // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                            ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                    },
                    // Position-in-collection
                    "first": createPositionalPseudo(function () {
                        return [0];
                    }),
                    "last": createPositionalPseudo(function (matchIndexes, length) {
                        return [length - 1];
                    }),
                    "eq": createPositionalPseudo(function (matchIndexes, length, argument) {
                        return [argument < 0 ? argument + length : argument];
                    }),
                    "even": createPositionalPseudo(function (matchIndexes, length) {
                        var i = 0;
                        for (; i < length; i += 2) {
                            matchIndexes.push(i);
                        }
                        return matchIndexes;
                    }),
                    "odd": createPositionalPseudo(function (matchIndexes, length) {
                        var i = 1;
                        for (; i < length; i += 2) {
                            matchIndexes.push(i);
                        }
                        return matchIndexes;
                    }),
                    "lt": createPositionalPseudo(function (matchIndexes, length, argument) {
                        var i = argument < 0 ? argument + length : argument;
                        for (; --i >= 0;) {
                            matchIndexes.push(i);
                        }
                        return matchIndexes;
                    }),
                    "gt": createPositionalPseudo(function (matchIndexes, length, argument) {
                        var i = argument < 0 ? argument + length : argument;
                        for (; ++i < length;) {
                            matchIndexes.push(i);
                        }
                        return matchIndexes;
                    })
                }
            };
            Expr.pseudos["nth"] = Expr.pseudos["eq"];
            // Add button/input type pseudos
            for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
                Expr.pseudos[i] = createInputPseudo(i);
            }
            for (i in { submit: true, reset: true }) {
                Expr.pseudos[i] = createButtonPseudo(i);
            }
            // Easy API for creating new setFilters
            function setFilters() { }
            setFilters.prototype = Expr.filters = Expr.pseudos;
            Expr.setFilters = new setFilters();
            tokenize = Sizzle.tokenize = function (selector, parseOnly) {
                var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
                if (cached) {
                    return parseOnly ? 0 : cached.slice(0);
                }
                soFar = selector;
                groups = [];
                preFilters = Expr.preFilter;
                while (soFar) {
                    // Comma and first run
                    if (!matched || (match = rcomma.exec(soFar))) {
                        if (match) {
                            // Don't consume trailing commas as valid
                            soFar = soFar.slice(match[0].length) || soFar;
                        }
                        groups.push((tokens = []));
                    }
                    matched = false;
                    // Combinators
                    if ((match = rcombinators.exec(soFar))) {
                        matched = match.shift();
                        tokens.push({
                            value: matched,
                            // Cast descendant combinators to space
                            type: match[0].replace(rtrim, " ")
                        });
                        soFar = soFar.slice(matched.length);
                    }
                    // Filters
                    for (type in Expr.filter) {
                        if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] ||
                            (match = preFilters[type](match)))) {
                            matched = match.shift();
                            tokens.push({
                                value: matched,
                                type: type,
                                matches: match
                            });
                            soFar = soFar.slice(matched.length);
                        }
                    }
                    if (!matched) {
                        break;
                    }
                }
                // Return the length of the invalid excess
                // if we're just parsing
                // Otherwise, throw an error or return tokens
                return parseOnly ?
                    soFar.length :
                    soFar ?
                        Sizzle.error(selector) :
                        // Cache the tokens
                        tokenCache(selector, groups).slice(0);
            };
            function toSelector(tokens) {
                var i = 0, len = tokens.length, selector = "";
                for (; i < len; i++) {
                    selector += tokens[i].value;
                }
                return selector;
            }
            function addCombinator(matcher, combinator, base) {
                var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
                return combinator.first ?
                    // Check against closest ancestor/preceding element
                    function (elem, context, xml) {
                        while ((elem = elem[dir])) {
                            if (elem.nodeType === 1 || checkNonElements) {
                                return matcher(elem, context, xml);
                            }
                        }
                        return false;
                    } :
                    // Check against all ancestor/preceding elements
                    function (elem, context, xml) {
                        var oldCache, uniqueCache, outerCache, newCache = [dirruns, doneName];
                        // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                        if (xml) {
                            while ((elem = elem[dir])) {
                                if (elem.nodeType === 1 || checkNonElements) {
                                    if (matcher(elem, context, xml)) {
                                        return true;
                                    }
                                }
                            }
                        }
                        else {
                            while ((elem = elem[dir])) {
                                if (elem.nodeType === 1 || checkNonElements) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    // Support: IE <9 only
                                    // Defend against cloned attroperties (jQuery gh-1709)
                                    uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
                                    if (skip && skip === elem.nodeName.toLowerCase()) {
                                        elem = elem[dir] || elem;
                                    }
                                    else if ((oldCache = uniqueCache[key]) &&
                                        oldCache[0] === dirruns && oldCache[1] === doneName) {
                                        // Assign to newCache so results back-propagate to previous elements
                                        return (newCache[2] = oldCache[2]);
                                    }
                                    else {
                                        // Reuse newcache so results back-propagate to previous elements
                                        uniqueCache[key] = newCache;
                                        // A match means we're done; a fail means we have to keep checking
                                        if ((newCache[2] = matcher(elem, context, xml))) {
                                            return true;
                                        }
                                    }
                                }
                            }
                        }
                        return false;
                    };
            }
            function elementMatcher(matchers) {
                return matchers.length > 1 ?
                    function (elem, context, xml) {
                        var i = matchers.length;
                        while (i--) {
                            if (!matchers[i](elem, context, xml)) {
                                return false;
                            }
                        }
                        return true;
                    } :
                    matchers[0];
            }
            function multipleContexts(selector, contexts, results) {
                var i = 0, len = contexts.length;
                for (; i < len; i++) {
                    Sizzle(selector, contexts[i], results);
                }
                return results;
            }
            function condense(unmatched, map, filter, context, xml) {
                var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
                for (; i < len; i++) {
                    if ((elem = unmatched[i])) {
                        if (!filter || filter(elem, context, xml)) {
                            newUnmatched.push(elem);
                            if (mapped) {
                                map.push(i);
                            }
                        }
                    }
                }
                return newUnmatched;
            }
            function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
                if (postFilter && !postFilter[expando]) {
                    postFilter = setMatcher(postFilter);
                }
                if (postFinder && !postFinder[expando]) {
                    postFinder = setMatcher(postFinder, postSelector);
                }
                return markFunction(function (seed, results, context, xml) {
                    var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, 
                    // Get initial elements from seed or context
                    elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []), 
                    // Prefilter to get matcher input, preserving a map for seed-results synchronization
                    matcherIn = preFilter && (seed || !selector) ?
                        condense(elems, preMap, preFilter, context, xml) :
                        elems, matcherOut = matcher ?
                        // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                        postFinder || (seed ? preFilter : preexisting || postFilter) ?
                            // ...intermediate processing is necessary
                            [] :
                            // ...otherwise use results directly
                            results :
                        matcherIn;
                    // Find primary matches
                    if (matcher) {
                        matcher(matcherIn, matcherOut, context, xml);
                    }
                    // Apply postFilter
                    if (postFilter) {
                        temp = condense(matcherOut, postMap);
                        postFilter(temp, [], context, xml);
                        // Un-match failing elements by moving them back to matcherIn
                        i = temp.length;
                        while (i--) {
                            if ((elem = temp[i])) {
                                matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                            }
                        }
                    }
                    if (seed) {
                        if (postFinder || preFilter) {
                            if (postFinder) {
                                // Get the final matcherOut by condensing this intermediate into postFinder contexts
                                temp = [];
                                i = matcherOut.length;
                                while (i--) {
                                    if ((elem = matcherOut[i])) {
                                        // Restore matcherIn since elem is not yet a final match
                                        temp.push((matcherIn[i] = elem));
                                    }
                                }
                                postFinder(null, (matcherOut = []), temp, xml);
                            }
                            // Move matched elements from seed to results to keep them synchronized
                            i = matcherOut.length;
                            while (i--) {
                                if ((elem = matcherOut[i]) &&
                                    (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {
                                    seed[temp] = !(results[temp] = elem);
                                }
                            }
                        }
                        // Add elements to results, through postFinder if defined
                    }
                    else {
                        matcherOut = condense(matcherOut === results ?
                            matcherOut.splice(preexisting, matcherOut.length) :
                            matcherOut);
                        if (postFinder) {
                            postFinder(null, results, matcherOut, xml);
                        }
                        else {
                            push.apply(results, matcherOut);
                        }
                    }
                });
            }
            function matcherFromTokens(tokens) {
                var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, 
                // The foundational matcher ensures that elements are reachable from top-level context(s)
                matchContext = addCombinator(function (elem) {
                    return elem === checkContext;
                }, implicitRelative, true), matchAnyContext = addCombinator(function (elem) {
                    return indexOf(checkContext, elem) > -1;
                }, implicitRelative, true), matchers = [function (elem, context, xml) {
                        var ret = (!leadingRelative && (xml || context !== outermostContext)) || ((checkContext = context).nodeType ?
                            matchContext(elem, context, xml) :
                            matchAnyContext(elem, context, xml));
                        // Avoid hanging onto element (issue #299)
                        checkContext = null;
                        return ret;
                    }];
                for (; i < len; i++) {
                    if ((matcher = Expr.relative[tokens[i].type])) {
                        matchers = [addCombinator(elementMatcher(matchers), matcher)];
                    }
                    else {
                        matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                        // Return special upon seeing a positional matcher
                        if (matcher[expando]) {
                            // Find the next relative operator (if any) for proper handling
                            j = ++i;
                            for (; j < len; j++) {
                                if (Expr.relative[tokens[j].type]) {
                                    break;
                                }
                            }
                            return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(
                            // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                            tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === " " ? "*" : "" })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens((tokens = tokens.slice(j))), j < len && toSelector(tokens));
                        }
                        matchers.push(matcher);
                    }
                }
                return elementMatcher(matchers);
            }
            function matcherFromGroupMatchers(elementMatchers, setMatchers) {
                var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function (seed, context, xml, results, outermost) {
                    var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, 
                    // We must always have either seed elements or outermost context
                    elems = seed || byElement && Expr.find["TAG"]("*", outermost), 
                    // Use integer dirruns iff this is the outermost matcher
                    dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1), len = elems.length;
                    if (outermost) {
                        outermostContext = context === document || context || outermost;
                    }
                    // Add elements passing elementMatchers directly to results
                    // Support: IE<9, Safari
                    // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                    for (; i !== len && (elem = elems[i]) != null; i++) {
                        if (byElement && elem) {
                            j = 0;
                            if (!context && elem.ownerDocument !== document) {
                                setDocument(elem);
                                xml = !documentIsHTML;
                            }
                            while ((matcher = elementMatchers[j++])) {
                                if (matcher(elem, context || document, xml)) {
                                    results.push(elem);
                                    break;
                                }
                            }
                            if (outermost) {
                                dirruns = dirrunsUnique;
                            }
                        }
                        // Track unmatched elements for set filters
                        if (bySet) {
                            // They will have gone through all possible matchers
                            if ((elem = !matcher && elem)) {
                                matchedCount--;
                            }
                            // Lengthen the array for every element, matched or not
                            if (seed) {
                                unmatched.push(elem);
                            }
                        }
                    }
                    // `i` is now the count of elements visited above, and adding it to `matchedCount`
                    // makes the latter nonnegative.
                    matchedCount += i;
                    // Apply set filters to unmatched elements
                    // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                    // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                    // no element matchers and no seed.
                    // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                    // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                    // numerically zero.
                    if (bySet && i !== matchedCount) {
                        j = 0;
                        while ((matcher = setMatchers[j++])) {
                            matcher(unmatched, setMatched, context, xml);
                        }
                        if (seed) {
                            // Reintegrate element matches to eliminate the need for sorting
                            if (matchedCount > 0) {
                                while (i--) {
                                    if (!(unmatched[i] || setMatched[i])) {
                                        setMatched[i] = pop.call(results);
                                    }
                                }
                            }
                            // Discard index placeholder values to get only actual matches
                            setMatched = condense(setMatched);
                        }
                        // Add matches to results
                        push.apply(results, setMatched);
                        // Seedless set matches succeeding multiple successful matchers stipulate sorting
                        if (outermost && !seed && setMatched.length > 0 &&
                            (matchedCount + setMatchers.length) > 1) {
                            Sizzle.uniqueSort(results);
                        }
                    }
                    // Override manipulation of globals by nested matchers
                    if (outermost) {
                        dirruns = dirrunsUnique;
                        outermostContext = contextBackup;
                    }
                    return unmatched;
                };
                return bySet ?
                    markFunction(superMatcher) :
                    superMatcher;
            }
            compile = Sizzle.compile = function (selector, match /* Internal Use Only */) {
                var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
                if (!cached) {
                    // Generate a function of recursive functions that can be used to check each element
                    if (!match) {
                        match = tokenize(selector);
                    }
                    i = match.length;
                    while (i--) {
                        cached = matcherFromTokens(match[i]);
                        if (cached[expando]) {
                            setMatchers.push(cached);
                        }
                        else {
                            elementMatchers.push(cached);
                        }
                    }
                    // Cache the compiled function
                    cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                    // Save selector and tokenization
                    cached.selector = selector;
                }
                return cached;
            };
            /**
             * A low-level selection function that works with Sizzle's compiled
             *  selector functions
             * @param {String|Function} selector A selector or a pre-compiled
             *  selector function built with Sizzle.compile
             * @param {Element} context
             * @param {Array} [results]
             * @param {Array} [seed] A set of elements to match against
             */
            select = Sizzle.select = function (selector, context, results, seed) {
                var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize((selector = compiled.selector || selector));
                results = results || [];
                // Try to minimize operations if there is only one selector in the list and no seed
                // (the latter of which guarantees us context)
                if (match.length === 1) {
                    // Reduce context if the leading compound selector is an ID
                    tokens = match[0] = match[0].slice(0);
                    if (tokens.length > 2 && (token = tokens[0]).type === "ID" &&
                        context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                        context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
                        if (!context) {
                            return results;
                            // Precompiled matchers will still verify ancestry, so step up a level
                        }
                        else if (compiled) {
                            context = context.parentNode;
                        }
                        selector = selector.slice(tokens.shift().value.length);
                    }
                    // Fetch a seed set for right-to-left matching
                    i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
                    while (i--) {
                        token = tokens[i];
                        // Abort if we hit a combinator
                        if (Expr.relative[(type = token.type)]) {
                            break;
                        }
                        if ((find = Expr.find[type])) {
                            // Search, expanding context for leading sibling combinators
                            if ((seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context))) {
                                // If seed is empty or no tokens remain, we can return early
                                tokens.splice(i, 1);
                                selector = seed.length && toSelector(tokens);
                                if (!selector) {
                                    push.apply(results, seed);
                                    return results;
                                }
                                break;
                            }
                        }
                    }
                }
                // Compile and execute a filtering function if one is not provided
                // Provide `match` to avoid retokenization if we modified the selector above
                (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
                return results;
            };
            // One-time assignments
            // Sort stability
            support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
            // Support: Chrome 14-35+
            // Always assume duplicates if they aren't passed to the comparison function
            support.detectDuplicates = !!hasDuplicate;
            // Initialize against the default document
            setDocument();
            // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
            // Detached nodes confoundingly follow *each other*
            support.sortDetached = assert(function (el) {
                // Should return 1, but returns 4 (following)
                return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
            });
            // Support: IE<8
            // Prevent attribute/property "interpolation"
            // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
            if (!assert(function (el) {
                el.innerHTML = "<a href='#'></a>";
                return el.firstChild.getAttribute("href") === "#";
            })) {
                addHandle("type|href|height|width", function (elem, name, isXML) {
                    if (!isXML) {
                        return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
                    }
                });
            }
            // Support: IE<9
            // Use defaultValue in place of getAttribute("value")
            if (!support.attributes || !assert(function (el) {
                el.innerHTML = "<input/>";
                el.firstChild.setAttribute("value", "");
                return el.firstChild.getAttribute("value") === "";
            })) {
                addHandle("value", function (elem, name, isXML) {
                    if (!isXML && elem.nodeName.toLowerCase() === "input") {
                        return elem.defaultValue;
                    }
                });
            }
            // Support: IE<9
            // Use getAttributeNode to fetch booleans when getAttribute lies
            if (!assert(function (el) {
                return el.getAttribute("disabled") == null;
            })) {
                addHandle(booleans, function (elem, name, isXML) {
                    var val;
                    if (!isXML) {
                        return elem[name] === true ? name.toLowerCase() :
                            (val = elem.getAttributeNode(name)) && val.specified ?
                                val.value :
                                null;
                    }
                });
            }
            return Sizzle;
        })(window);
        jQuery.find = Sizzle;
        jQuery.expr = Sizzle.selectors;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
        jQuery.text = Sizzle.getText;
        jQuery.isXMLDoc = Sizzle.isXML;
        jQuery.contains = Sizzle.contains;
        jQuery.escapeSelector = Sizzle.escape;
        var dir = function (elem, dir, until) {
            var matched = [], truncate = until !== undefined;
            while ((elem = elem[dir]) && elem.nodeType !== 9) {
                if (elem.nodeType === 1) {
                    if (truncate && jQuery(elem).is(until)) {
                        break;
                    }
                    matched.push(elem);
                }
            }
            return matched;
        };
        var siblings = function (n, elem) {
            var matched = [];
            for (; n; n = n.nextSibling) {
                if (n.nodeType === 1 && n !== elem) {
                    matched.push(n);
                }
            }
            return matched;
        };
        var rneedsContext = jQuery.expr.match.needsContext;
        function nodeName(elem, name) {
            return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
        }
        var rsingleTag = (/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i);
        // Implement the identical functionality for filter and not
        function winnow(elements, qualifier, not) {
            if (isFunction(qualifier)) {
                return jQuery.grep(elements, function (elem, i) {
                    return !!qualifier.call(elem, i, elem) !== not;
                });
            }
            // Single element
            if (qualifier.nodeType) {
                return jQuery.grep(elements, function (elem) {
                    return (elem === qualifier) !== not;
                });
            }
            // Arraylike of elements (jQuery, arguments, Array)
            if (typeof qualifier !== "string") {
                return jQuery.grep(elements, function (elem) {
                    return (indexOf.call(qualifier, elem) > -1) !== not;
                });
            }
            // Filtered directly for both simple and complex selectors
            return jQuery.filter(qualifier, elements, not);
        }
        jQuery.filter = function (expr, elems, not) {
            var elem = elems[0];
            if (not) {
                expr = ":not(" + expr + ")";
            }
            if (elems.length === 1 && elem.nodeType === 1) {
                return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
            }
            return jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
                return elem.nodeType === 1;
            }));
        };
        jQuery.fn.extend({
            find: function (selector) {
                var i, ret, len = this.length, self = this;
                if (typeof selector !== "string") {
                    return this.pushStack(jQuery(selector).filter(function () {
                        for (i = 0; i < len; i++) {
                            if (jQuery.contains(self[i], this)) {
                                return true;
                            }
                        }
                    }));
                }
                ret = this.pushStack([]);
                for (i = 0; i < len; i++) {
                    jQuery.find(selector, self[i], ret);
                }
                return len > 1 ? jQuery.uniqueSort(ret) : ret;
            },
            filter: function (selector) {
                return this.pushStack(winnow(this, selector || [], false));
            },
            not: function (selector) {
                return this.pushStack(winnow(this, selector || [], true));
            },
            is: function (selector) {
                return !!winnow(this, 
                // If this is a positional/relative selector, check membership in the returned set
                // so $("p:first").is("p:last") won't return true for a doc with two "p".
                typeof selector === "string" && rneedsContext.test(selector) ?
                    jQuery(selector) :
                    selector || [], false).length;
            }
        });
        // Initialize a jQuery object
        // A central reference to the root jQuery(document)
        var rootjQuery, 
        // A simple way to check for HTML strings
        // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
        // Strict HTML recognition (#11290: must start with <)
        // Shortcut simple #id case for speed
        rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function (selector, context, root) {
            var match, elem;
            // HANDLE: $(""), $(null), $(undefined), $(false)
            if (!selector) {
                return this;
            }
            // Method init() accepts an alternate rootjQuery
            // so migrate can support jQuery.sub (gh-2101)
            root = root || rootjQuery;
            // Handle HTML strings
            if (typeof selector === "string") {
                if (selector[0] === "<" &&
                    selector[selector.length - 1] === ">" &&
                    selector.length >= 3) {
                    // Assume that strings that start and end with <> are HTML and skip the regex check
                    match = [null, selector, null];
                }
                else {
                    match = rquickExpr.exec(selector);
                }
                // Match html or make sure no context is specified for #id
                if (match && (match[1] || !context)) {
                    // HANDLE: $(html) -> $(array)
                    if (match[1]) {
                        context = context instanceof jQuery ? context[0] : context;
                        // Option to run scripts is true for back-compat
                        // Intentionally let the error be thrown if parseHTML is not present
                        jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                        // HANDLE: $(html, props)
                        if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                            for (match in context) {
                                // Properties of context are called as methods if possible
                                if (isFunction(this[match])) {
                                    this[match](context[match]);
                                    // ...and otherwise set as attributes
                                }
                                else {
                                    this.attr(match, context[match]);
                                }
                            }
                        }
                        return this;
                        // HANDLE: $(#id)
                    }
                    else {
                        elem = document.getElementById(match[2]);
                        if (elem) {
                            // Inject the element directly into the jQuery object
                            this[0] = elem;
                            this.length = 1;
                        }
                        return this;
                    }
                    // HANDLE: $(expr, $(...))
                }
                else if (!context || context.jquery) {
                    return (context || root).find(selector);
                    // HANDLE: $(expr, context)
                    // (which is just equivalent to: $(context).find(expr)
                }
                else {
                    return this.constructor(context).find(selector);
                }
                // HANDLE: $(DOMElement)
            }
            else if (selector.nodeType) {
                this[0] = selector;
                this.length = 1;
                return this;
                // HANDLE: $(function)
                // Shortcut for document ready
            }
            else if (isFunction(selector)) {
                return root.ready !== undefined ?
                    root.ready(selector) :
                    // Execute immediately if ready is not present
                    selector(jQuery);
            }
            return jQuery.makeArray(selector, this);
        };
        // Give the init function the jQuery prototype for later instantiation
        init.prototype = jQuery.fn;
        // Initialize central reference
        rootjQuery = jQuery(document);
        var rparentsprev = /^(?:parents|prev(?:Until|All))/, 
        // Methods guaranteed to produce a unique set when starting from a unique set
        guaranteedUnique = {
            children: true,
            contents: true,
            next: true,
            prev: true
        };
        jQuery.fn.extend({
            has: function (target) {
                var targets = jQuery(target, this), l = targets.length;
                return this.filter(function () {
                    var i = 0;
                    for (; i < l; i++) {
                        if (jQuery.contains(this, targets[i])) {
                            return true;
                        }
                    }
                });
            },
            closest: function (selectors, context) {
                var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
                // Positional selectors never match, since there's no _selection_ context
                if (!rneedsContext.test(selectors)) {
                    for (; i < l; i++) {
                        for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
                            // Always skip document fragments
                            if (cur.nodeType < 11 && (targets ?
                                targets.index(cur) > -1 :
                                // Don't pass non-elements to Sizzle
                                cur.nodeType === 1 &&
                                    jQuery.find.matchesSelector(cur, selectors))) {
                                matched.push(cur);
                                break;
                            }
                        }
                    }
                }
                return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
            },
            // Determine the position of an element within the set
            index: function (elem) {
                // No argument, return index in parent
                if (!elem) {
                    return (this[0] && this[0].parentNode) ? this.first().prevAll().length : -1;
                }
                // Index in selector
                if (typeof elem === "string") {
                    return indexOf.call(jQuery(elem), this[0]);
                }
                // Locate the position of the desired element
                return indexOf.call(this, 
                // If it receives a jQuery object, the first element is used
                elem.jquery ? elem[0] : elem);
            },
            add: function (selector, context) {
                return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
            },
            addBack: function (selector) {
                return this.add(selector == null ?
                    this.prevObject : this.prevObject.filter(selector));
            }
        });
        function sibling(cur, dir) {
            while ((cur = cur[dir]) && cur.nodeType !== 1) { }
            return cur;
        }
        jQuery.each({
            parent: function (elem) {
                var parent = elem.parentNode;
                return parent && parent.nodeType !== 11 ? parent : null;
            },
            parents: function (elem) {
                return dir(elem, "parentNode");
            },
            parentsUntil: function (elem, i, until) {
                return dir(elem, "parentNode", until);
            },
            next: function (elem) {
                return sibling(elem, "nextSibling");
            },
            prev: function (elem) {
                return sibling(elem, "previousSibling");
            },
            nextAll: function (elem) {
                return dir(elem, "nextSibling");
            },
            prevAll: function (elem) {
                return dir(elem, "previousSibling");
            },
            nextUntil: function (elem, i, until) {
                return dir(elem, "nextSibling", until);
            },
            prevUntil: function (elem, i, until) {
                return dir(elem, "previousSibling", until);
            },
            siblings: function (elem) {
                return siblings((elem.parentNode || {}).firstChild, elem);
            },
            children: function (elem) {
                return siblings(elem.firstChild);
            },
            contents: function (elem) {
                if (nodeName(elem, "iframe")) {
                    return elem.contentDocument;
                }
                // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
                // Treat the template element as a regular one in browsers that
                // don't support it.
                if (nodeName(elem, "template")) {
                    elem = elem.content || elem;
                }
                return jQuery.merge([], elem.childNodes);
            }
        }, function (name, fn) {
            jQuery.fn[name] = function (until, selector) {
                var matched = jQuery.map(this, fn, until);
                if (name.slice(-5) !== "Until") {
                    selector = until;
                }
                if (selector && typeof selector === "string") {
                    matched = jQuery.filter(selector, matched);
                }
                if (this.length > 1) {
                    // Remove duplicates
                    if (!guaranteedUnique[name]) {
                        jQuery.uniqueSort(matched);
                    }
                    // Reverse order for parents* and prev-derivatives
                    if (rparentsprev.test(name)) {
                        matched.reverse();
                    }
                }
                return this.pushStack(matched);
            };
        });
        var rnothtmlwhite = (/[^\x20\t\r\n\f]+/g);
        // Convert String-formatted options into Object-formatted ones
        function createOptions(options) {
            var object = {};
            jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
                object[flag] = true;
            });
            return object;
        }
        /*
         * Create a callback list using the following parameters:
         *
         *	options: an optional list of space-separated options that will change how
         *			the callback list behaves or a more traditional option object
         *
         * By default a callback list will act like an event callback list and can be
         * "fired" multiple times.
         *
         * Possible options:
         *
         *	once:			will ensure the callback list can only be fired once (like a Deferred)
         *
         *	memory:			will keep track of previous values and will call any callback added
         *					after the list has been fired right away with the latest "memorized"
         *					values (like a Deferred)
         *
         *	unique:			will ensure a callback can only be added once (no duplicate in the list)
         *
         *	stopOnFalse:	interrupt callings when a callback returns false
         *
         */
        jQuery.Callbacks = function (options) {
            // Convert options from String-formatted to Object-formatted if needed
            // (we check in cache first)
            options = typeof options === "string" ?
                createOptions(options) :
                jQuery.extend({}, options);
            var // Flag to know if list is currently firing
            firing, 
            // Last fire value for non-forgettable lists
            memory, 
            // Flag to know if list was already fired
            fired, 
            // Flag to prevent firing
            locked, 
            // Actual callback list
            list = [], 
            // Queue of execution data for repeatable lists
            queue = [], 
            // Index of currently firing callback (modified by add/remove as needed)
            firingIndex = -1, 
            // Fire callbacks
            fire = function () {
                // Enforce single-firing
                locked = locked || options.once;
                // Execute callbacks for all pending executions,
                // respecting firingIndex overrides and runtime changes
                fired = firing = true;
                for (; queue.length; firingIndex = -1) {
                    memory = queue.shift();
                    while (++firingIndex < list.length) {
                        // Run callback and check for early termination
                        if (list[firingIndex].apply(memory[0], memory[1]) === false &&
                            options.stopOnFalse) {
                            // Jump to end and forget the data so .add doesn't re-fire
                            firingIndex = list.length;
                            memory = false;
                        }
                    }
                }
                // Forget the data if we're done with it
                if (!options.memory) {
                    memory = false;
                }
                firing = false;
                // Clean up if we're done firing for good
                if (locked) {
                    // Keep an empty list if we have data for future add calls
                    if (memory) {
                        list = [];
                        // Otherwise, this object is spent
                    }
                    else {
                        list = "";
                    }
                }
            }, 
            // Actual Callbacks object
            self = {
                // Add a callback or a collection of callbacks to the list
                add: function () {
                    if (list) {
                        // If we have memory from a past run, we should fire after adding
                        if (memory && !firing) {
                            firingIndex = list.length - 1;
                            queue.push(memory);
                        }
                        (function add(args) {
                            jQuery.each(args, function (_, arg) {
                                if (isFunction(arg)) {
                                    if (!options.unique || !self.has(arg)) {
                                        list.push(arg);
                                    }
                                }
                                else if (arg && arg.length && toType(arg) !== "string") {
                                    // Inspect recursively
                                    add(arg);
                                }
                            });
                        })(arguments);
                        if (memory && !firing) {
                            fire();
                        }
                    }
                    return this;
                },
                // Remove a callback from the list
                remove: function () {
                    jQuery.each(arguments, function (_, arg) {
                        var index;
                        while ((index = jQuery.inArray(arg, list, index)) > -1) {
                            list.splice(index, 1);
                            // Handle firing indexes
                            if (index <= firingIndex) {
                                firingIndex--;
                            }
                        }
                    });
                    return this;
                },
                // Check if a given callback is in the list.
                // If no argument is given, return whether or not list has callbacks attached.
                has: function (fn) {
                    return fn ?
                        jQuery.inArray(fn, list) > -1 :
                        list.length > 0;
                },
                // Remove all callbacks from the list
                empty: function () {
                    if (list) {
                        list = [];
                    }
                    return this;
                },
                // Disable .fire and .add
                // Abort any current/pending executions
                // Clear all callbacks and values
                disable: function () {
                    locked = queue = [];
                    list = memory = "";
                    return this;
                },
                disabled: function () {
                    return !list;
                },
                // Disable .fire
                // Also disable .add unless we have memory (since it would have no effect)
                // Abort any pending executions
                lock: function () {
                    locked = queue = [];
                    if (!memory && !firing) {
                        list = memory = "";
                    }
                    return this;
                },
                locked: function () {
                    return !!locked;
                },
                // Call all callbacks with the given context and arguments
                fireWith: function (context, args) {
                    if (!locked) {
                        args = args || [];
                        args = [context, args.slice ? args.slice() : args];
                        queue.push(args);
                        if (!firing) {
                            fire();
                        }
                    }
                    return this;
                },
                // Call all the callbacks with the given arguments
                fire: function () {
                    self.fireWith(this, arguments);
                    return this;
                },
                // To know if the callbacks have already been called at least once
                fired: function () {
                    return !!fired;
                }
            };
            return self;
        };
        function Identity(v) {
            return v;
        }
        function Thrower(ex) {
            throw ex;
        }
        function adoptValue(value, resolve, reject, noValue) {
            var method;
            try {
                // Check for promise aspect first to privilege synchronous behavior
                if (value && isFunction((method = value.promise))) {
                    method.call(value).done(resolve).fail(reject);
                    // Other thenables
                }
                else if (value && isFunction((method = value.then))) {
                    method.call(value, resolve, reject);
                    // Other non-thenables
                }
                else {
                    // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
                    // * false: [ value ].slice( 0 ) => resolve( value )
                    // * true: [ value ].slice( 1 ) => resolve()
                    resolve.apply(undefined, [value].slice(noValue));
                }
                // For Promises/A+, convert exceptions into rejections
                // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
                // Deferred#then to conditionally suppress rejection.
            }
            catch (value) {
                // Support: Android 4.0 only
                // Strict mode functions invoked without .call/.apply get global-object context
                reject.apply(undefined, [value]);
            }
        }
        jQuery.extend({
            Deferred: function (func) {
                var tuples = [
                    // action, add listener, callbacks,
                    // ... .then handlers, argument index, [final state]
                    ["notify", "progress", jQuery.Callbacks("memory"),
                        jQuery.Callbacks("memory"), 2],
                    ["resolve", "done", jQuery.Callbacks("once memory"),
                        jQuery.Callbacks("once memory"), 0, "resolved"],
                    ["reject", "fail", jQuery.Callbacks("once memory"),
                        jQuery.Callbacks("once memory"), 1, "rejected"]
                ], state = "pending", promise = {
                    state: function () {
                        return state;
                    },
                    always: function () {
                        deferred.done(arguments).fail(arguments);
                        return this;
                    },
                    "catch": function (fn) {
                        return promise.then(null, fn);
                    },
                    // Keep pipe for back-compat
                    pipe: function () {
                        var fns = arguments;
                        return jQuery.Deferred(function (newDefer) {
                            jQuery.each(tuples, function (i, tuple) {
                                // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                                var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                                // deferred.progress(function() { bind to newDefer or newDefer.notify })
                                // deferred.done(function() { bind to newDefer or newDefer.resolve })
                                // deferred.fail(function() { bind to newDefer or newDefer.reject })
                                deferred[tuple[1]](function () {
                                    var returned = fn && fn.apply(this, arguments);
                                    if (returned && isFunction(returned.promise)) {
                                        returned.promise()
                                            .progress(newDefer.notify)
                                            .done(newDefer.resolve)
                                            .fail(newDefer.reject);
                                    }
                                    else {
                                        newDefer[tuple[0] + "With"](this, fn ? [returned] : arguments);
                                    }
                                });
                            });
                            fns = null;
                        }).promise();
                    },
                    then: function (onFulfilled, onRejected, onProgress) {
                        var maxDepth = 0;
                        function resolve(depth, deferred, handler, special) {
                            return function () {
                                var that = this, args = arguments, mightThrow = function () {
                                    var returned, then;
                                    // Support: Promises/A+ section 2.3.3.3.3
                                    // https://promisesaplus.com/#point-59
                                    // Ignore double-resolution attempts
                                    if (depth < maxDepth) {
                                        return;
                                    }
                                    returned = handler.apply(that, args);
                                    // Support: Promises/A+ section 2.3.1
                                    // https://promisesaplus.com/#point-48
                                    if (returned === deferred.promise()) {
                                        throw new TypeError("Thenable self-resolution");
                                    }
                                    // Support: Promises/A+ sections 2.3.3.1, 3.5
                                    // https://promisesaplus.com/#point-54
                                    // https://promisesaplus.com/#point-75
                                    // Retrieve `then` only once
                                    then = returned &&
                                        // Support: Promises/A+ section 2.3.4
                                        // https://promisesaplus.com/#point-64
                                        // Only check objects and functions for thenability
                                        (typeof returned === "object" ||
                                            typeof returned === "function") &&
                                        returned.then;
                                    // Handle a returned thenable
                                    if (isFunction(then)) {
                                        // Special processors (notify) just wait for resolution
                                        if (special) {
                                            then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                            // Normal processors (resolve) also hook into progress
                                        }
                                        else {
                                            // ...and disregard older resolution values
                                            maxDepth++;
                                            then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                        }
                                        // Handle all other returned values
                                    }
                                    else {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Identity) {
                                            that = undefined;
                                            args = [returned];
                                        }
                                        // Process the value(s)
                                        // Default process is resolve
                                        (special || deferred.resolveWith)(that, args);
                                    }
                                }, 
                                // Only normal processors (resolve) catch and reject exceptions
                                process = special ?
                                    mightThrow :
                                    function () {
                                        try {
                                            mightThrow();
                                        }
                                        catch (e) {
                                            if (jQuery.Deferred.exceptionHook) {
                                                jQuery.Deferred.exceptionHook(e, process.stackTrace);
                                            }
                                            // Support: Promises/A+ section 2.3.3.3.4.1
                                            // https://promisesaplus.com/#point-61
                                            // Ignore post-resolution exceptions
                                            if (depth + 1 >= maxDepth) {
                                                // Only substitute handlers pass on context
                                                // and multiple values (non-spec behavior)
                                                if (handler !== Thrower) {
                                                    that = undefined;
                                                    args = [e];
                                                }
                                                deferred.rejectWith(that, args);
                                            }
                                        }
                                    };
                                // Support: Promises/A+ section 2.3.3.3.1
                                // https://promisesaplus.com/#point-57
                                // Re-resolve promises immediately to dodge false rejection from
                                // subsequent errors
                                if (depth) {
                                    process();
                                }
                                else {
                                    // Call an optional hook to record the stack, in case of exception
                                    // since it's otherwise lost when execution goes async
                                    if (jQuery.Deferred.getStackHook) {
                                        process.stackTrace = jQuery.Deferred.getStackHook();
                                    }
                                    window.setTimeout(process);
                                }
                            };
                        }
                        return jQuery.Deferred(function (newDefer) {
                            // progress_handlers.add( ... )
                            tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ?
                                onProgress :
                                Identity, newDefer.notifyWith));
                            // fulfilled_handlers.add( ... )
                            tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ?
                                onFulfilled :
                                Identity));
                            // rejected_handlers.add( ... )
                            tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ?
                                onRejected :
                                Thrower));
                        }).promise();
                    },
                    // Get a promise for this deferred
                    // If obj is provided, the promise aspect is added to the object
                    promise: function (obj) {
                        return obj != null ? jQuery.extend(obj, promise) : promise;
                    }
                }, deferred = {};
                // Add list-specific methods
                jQuery.each(tuples, function (i, tuple) {
                    var list = tuple[2], stateString = tuple[5];
                    // promise.progress = list.add
                    // promise.done = list.add
                    // promise.fail = list.add
                    promise[tuple[1]] = list.add;
                    // Handle state
                    if (stateString) {
                        list.add(function () {
                            // state = "resolved" (i.e., fulfilled)
                            // state = "rejected"
                            state = stateString;
                        }, 
                        // rejected_callbacks.disable
                        // fulfilled_callbacks.disable
                        tuples[3 - i][2].disable, 
                        // rejected_handlers.disable
                        // fulfilled_handlers.disable
                        tuples[3 - i][3].disable, 
                        // progress_callbacks.lock
                        tuples[0][2].lock, 
                        // progress_handlers.lock
                        tuples[0][3].lock);
                    }
                    // progress_handlers.fire
                    // fulfilled_handlers.fire
                    // rejected_handlers.fire
                    list.add(tuple[3].fire);
                    // deferred.notify = function() { deferred.notifyWith(...) }
                    // deferred.resolve = function() { deferred.resolveWith(...) }
                    // deferred.reject = function() { deferred.rejectWith(...) }
                    deferred[tuple[0]] = function () {
                        deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                        return this;
                    };
                    // deferred.notifyWith = list.fireWith
                    // deferred.resolveWith = list.fireWith
                    // deferred.rejectWith = list.fireWith
                    deferred[tuple[0] + "With"] = list.fireWith;
                });
                // Make the deferred a promise
                promise.promise(deferred);
                // Call given func if any
                if (func) {
                    func.call(deferred, deferred);
                }
                // All done!
                return deferred;
            },
            // Deferred helper
            when: function (singleValue) {
                var 
                // count of uncompleted subordinates
                remaining = arguments.length, 
                // count of unprocessed arguments
                i = remaining, 
                // subordinate fulfillment data
                resolveContexts = Array(i), resolveValues = slice.call(arguments), 
                // the master Deferred
                master = jQuery.Deferred(), 
                // subordinate callback factory
                updateFunc = function (i) {
                    return function (value) {
                        resolveContexts[i] = this;
                        resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                        if (!(--remaining)) {
                            master.resolveWith(resolveContexts, resolveValues);
                        }
                    };
                };
                // Single- and empty arguments are adopted like Promise.resolve
                if (remaining <= 1) {
                    adoptValue(singleValue, master.done(updateFunc(i)).resolve, master.reject, !remaining);
                    // Use .then() to unwrap secondary thenables (cf. gh-3000)
                    if (master.state() === "pending" ||
                        isFunction(resolveValues[i] && resolveValues[i].then)) {
                        return master.then();
                    }
                }
                // Multiple arguments are aggregated like Promise.all array elements
                while (i--) {
                    adoptValue(resolveValues[i], updateFunc(i), master.reject);
                }
                return master.promise();
            }
        });
        // These usually indicate a programmer mistake during development,
        // warn about them ASAP rather than swallowing them by default.
        var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
        jQuery.Deferred.exceptionHook = function (error, stack) {
            // Support: IE 8 - 9 only
            // Console exists when dev tools are open, which can happen at any time
            if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
                window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
            }
        };
        jQuery.readyException = function (error) {
            window.setTimeout(function () {
                throw error;
            });
        };
        // The deferred used on DOM ready
        var readyList = jQuery.Deferred();
        jQuery.fn.ready = function (fn) {
            readyList
                .then(fn)
                .catch(function (error) {
                jQuery.readyException(error);
            });
            return this;
        };
        jQuery.extend({
            // Is the DOM ready to be used? Set to true once it occurs.
            isReady: false,
            // A counter to track how many items to wait for before
            // the ready event fires. See #6781
            readyWait: 1,
            // Handle when the DOM is ready
            ready: function (wait) {
                // Abort if there are pending holds or we're already ready
                if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
                    return;
                }
                // Remember that the DOM is ready
                jQuery.isReady = true;
                // If a normal DOM Ready event fired, decrement, and wait if need be
                if (wait !== true && --jQuery.readyWait > 0) {
                    return;
                }
                // If there are functions bound, to execute
                readyList.resolveWith(document, [jQuery]);
            }
        });
        jQuery.ready.then = readyList.then;
        // The ready event handler and self cleanup method
        function completed() {
            document.removeEventListener("DOMContentLoaded", completed);
            window.removeEventListener("load", completed);
            jQuery.ready();
        }
        // Catch cases where $(document).ready() is called
        // after the browser event has already occurred.
        // Support: IE <=9 - 10 only
        // Older IE sometimes signals "interactive" too soon
        if (document.readyState === "complete" ||
            (document.readyState !== "loading" && !document.documentElement.doScroll)) {
            // Handle it asynchronously to allow scripts the opportunity to delay ready
            window.setTimeout(jQuery.ready);
        }
        else {
            // Use the handy event callback
            document.addEventListener("DOMContentLoaded", completed);
            // A fallback to window.onload, that will always work
            window.addEventListener("load", completed);
        }
        // Multifunctional method to get and set values of a collection
        // The value/s can optionally be executed if it's a function
        var access = function (elems, fn, key, value, chainable, emptyGet, raw) {
            var i = 0, len = elems.length, bulk = key == null;
            // Sets many values
            if (toType(key) === "object") {
                chainable = true;
                for (i in key) {
                    access(elems, fn, i, key[i], true, emptyGet, raw);
                }
                // Sets one value
            }
            else if (value !== undefined) {
                chainable = true;
                if (!isFunction(value)) {
                    raw = true;
                }
                if (bulk) {
                    // Bulk operations run against the entire set
                    if (raw) {
                        fn.call(elems, value);
                        fn = null;
                        // ...except when executing function values
                    }
                    else {
                        bulk = fn;
                        fn = function (elem, key, value) {
                            return bulk.call(jQuery(elem), value);
                        };
                    }
                }
                if (fn) {
                    for (; i < len; i++) {
                        fn(elems[i], key, raw ?
                            value :
                            value.call(elems[i], i, fn(elems[i], key)));
                    }
                }
            }
            if (chainable) {
                return elems;
            }
            // Gets
            if (bulk) {
                return fn.call(elems);
            }
            return len ? fn(elems[0], key) : emptyGet;
        };
        // Matches dashed string for camelizing
        var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
        // Used by camelCase as callback to replace()
        function fcamelCase(all, letter) {
            return letter.toUpperCase();
        }
        // Convert dashed to camelCase; used by the css and data modules
        // Support: IE <=9 - 11, Edge 12 - 15
        // Microsoft forgot to hump their vendor prefix (#9572)
        function camelCase(string) {
            return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
        }
        var acceptData = function (owner) {
            // Accepts only:
            //  - Node
            //    - Node.ELEMENT_NODE
            //    - Node.DOCUMENT_NODE
            //  - Object
            //    - Any
            return owner.nodeType === 1 || owner.nodeType === 9 || !(+owner.nodeType);
        };
        function Data() {
            this.expando = jQuery.expando + Data.uid++;
        }
        Data.uid = 1;
        Data.prototype = {
            cache: function (owner) {
                // Check if the owner object already has a cache
                var value = owner[this.expando];
                // If not, create one
                if (!value) {
                    value = {};
                    // We can accept data for non-element nodes in modern browsers,
                    // but we should not, see #8335.
                    // Always return an empty object.
                    if (acceptData(owner)) {
                        // If it is a node unlikely to be stringify-ed or looped over
                        // use plain assignment
                        if (owner.nodeType) {
                            owner[this.expando] = value;
                            // Otherwise secure it in a non-enumerable property
                            // configurable must be true to allow the property to be
                            // deleted when data is removed
                        }
                        else {
                            Object.defineProperty(owner, this.expando, {
                                value: value,
                                configurable: true
                            });
                        }
                    }
                }
                return value;
            },
            set: function (owner, data, value) {
                var prop, cache = this.cache(owner);
                // Handle: [ owner, key, value ] args
                // Always use camelCase key (gh-2257)
                if (typeof data === "string") {
                    cache[camelCase(data)] = value;
                    // Handle: [ owner, { properties } ] args
                }
                else {
                    // Copy the properties one-by-one to the cache object
                    for (prop in data) {
                        cache[camelCase(prop)] = data[prop];
                    }
                }
                return cache;
            },
            get: function (owner, key) {
                return key === undefined ?
                    this.cache(owner) :
                    // Always use camelCase key (gh-2257)
                    owner[this.expando] && owner[this.expando][camelCase(key)];
            },
            access: function (owner, key, value) {
                // In cases where either:
                //
                //   1. No key was specified
                //   2. A string key was specified, but no value provided
                //
                // Take the "read" path and allow the get method to determine
                // which value to return, respectively either:
                //
                //   1. The entire cache object
                //   2. The data stored at the key
                //
                if (key === undefined ||
                    ((key && typeof key === "string") && value === undefined)) {
                    return this.get(owner, key);
                }
                // When the key is not a string, or both a key and value
                // are specified, set or extend (existing objects) with either:
                //
                //   1. An object of properties
                //   2. A key and value
                //
                this.set(owner, key, value);
                // Since the "set" path can have two possible entry points
                // return the expected data based on which path was taken[*]
                return value !== undefined ? value : key;
            },
            remove: function (owner, key) {
                var i, cache = owner[this.expando];
                if (cache === undefined) {
                    return;
                }
                if (key !== undefined) {
                    // Support array or space separated string of keys
                    if (Array.isArray(key)) {
                        // If key is an array of keys...
                        // We always set camelCase keys, so remove that.
                        key = key.map(camelCase);
                    }
                    else {
                        key = camelCase(key);
                        // If a key with the spaces exists, use it.
                        // Otherwise, create an array by matching non-whitespace
                        key = key in cache ?
                            [key] :
                            (key.match(rnothtmlwhite) || []);
                    }
                    i = key.length;
                    while (i--) {
                        delete cache[key[i]];
                    }
                }
                // Remove the expando if there's no more data
                if (key === undefined || jQuery.isEmptyObject(cache)) {
                    // Support: Chrome <=35 - 45
                    // Webkit & Blink performance suffers when deleting properties
                    // from DOM nodes, so set to undefined instead
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                    if (owner.nodeType) {
                        owner[this.expando] = undefined;
                    }
                    else {
                        delete owner[this.expando];
                    }
                }
            },
            hasData: function (owner) {
                var cache = owner[this.expando];
                return cache !== undefined && !jQuery.isEmptyObject(cache);
            }
        };
        var dataPriv = new Data();
        var dataUser = new Data();
        //	Implementation Summary
        //
        //	1. Enforce API surface and semantic compatibility with 1.9.x branch
        //	2. Improve the module's maintainability by reducing the storage
        //		paths to a single mechanism.
        //	3. Use the same single mechanism to support "private" and "user" data.
        //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
        //	5. Avoid exposing implementation details on user objects (eg. expando properties)
        //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
        var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
        function getData(data) {
            if (data === "true") {
                return true;
            }
            if (data === "false") {
                return false;
            }
            if (data === "null") {
                return null;
            }
            // Only convert to a number if it doesn't change the string
            if (data === +data + "") {
                return +data;
            }
            if (rbrace.test(data)) {
                return JSON.parse(data);
            }
            return data;
        }
        function dataAttr(elem, key, data) {
            var name;
            // If nothing was found internally, try to fetch any
            // data from the HTML5 data-* attribute
            if (data === undefined && elem.nodeType === 1) {
                name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
                data = elem.getAttribute(name);
                if (typeof data === "string") {
                    try {
                        data = getData(data);
                    }
                    catch (e) { }
                    // Make sure we set the data so it isn't changed later
                    dataUser.set(elem, key, data);
                }
                else {
                    data = undefined;
                }
            }
            return data;
        }
        jQuery.extend({
            hasData: function (elem) {
                return dataUser.hasData(elem) || dataPriv.hasData(elem);
            },
            data: function (elem, name, data) {
                return dataUser.access(elem, name, data);
            },
            removeData: function (elem, name) {
                dataUser.remove(elem, name);
            },
            // TODO: Now that all calls to _data and _removeData have been replaced
            // with direct calls to dataPriv methods, these can be deprecated.
            _data: function (elem, name, data) {
                return dataPriv.access(elem, name, data);
            },
            _removeData: function (elem, name) {
                dataPriv.remove(elem, name);
            }
        });
        jQuery.fn.extend({
            data: function (key, value) {
                var i, name, data, elem = this[0], attrs = elem && elem.attributes;
                // Gets all values
                if (key === undefined) {
                    if (this.length) {
                        data = dataUser.get(elem);
                        if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                            i = attrs.length;
                            while (i--) {
                                // Support: IE 11 only
                                // The attrs elements can be null (#14894)
                                if (attrs[i]) {
                                    name = attrs[i].name;
                                    if (name.indexOf("data-") === 0) {
                                        name = camelCase(name.slice(5));
                                        dataAttr(elem, name, data[name]);
                                    }
                                }
                            }
                            dataPriv.set(elem, "hasDataAttrs", true);
                        }
                    }
                    return data;
                }
                // Sets multiple values
                if (typeof key === "object") {
                    return this.each(function () {
                        dataUser.set(this, key);
                    });
                }
                return access(this, function (value) {
                    var data;
                    // The calling jQuery object (element matches) is not empty
                    // (and therefore has an element appears at this[ 0 ]) and the
                    // `value` parameter was not undefined. An empty jQuery object
                    // will result in `undefined` for elem = this[ 0 ] which will
                    // throw an exception if an attempt to read a data cache is made.
                    if (elem && value === undefined) {
                        // Attempt to get data from the cache
                        // The key will always be camelCased in Data
                        data = dataUser.get(elem, key);
                        if (data !== undefined) {
                            return data;
                        }
                        // Attempt to "discover" the data in
                        // HTML5 custom data-* attrs
                        data = dataAttr(elem, key);
                        if (data !== undefined) {
                            return data;
                        }
                        // We tried really hard, but the data doesn't exist.
                        return;
                    }
                    // Set the data...
                    this.each(function () {
                        // We always store the camelCased key
                        dataUser.set(this, key, value);
                    });
                }, null, value, arguments.length > 1, null, true);
            },
            removeData: function (key) {
                return this.each(function () {
                    dataUser.remove(this, key);
                });
            }
        });
        jQuery.extend({
            queue: function (elem, type, data) {
                var queue;
                if (elem) {
                    type = (type || "fx") + "queue";
                    queue = dataPriv.get(elem, type);
                    // Speed up dequeue by getting out quickly if this is just a lookup
                    if (data) {
                        if (!queue || Array.isArray(data)) {
                            queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                        }
                        else {
                            queue.push(data);
                        }
                    }
                    return queue || [];
                }
            },
            dequeue: function (elem, type) {
                type = type || "fx";
                var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function () {
                    jQuery.dequeue(elem, type);
                };
                // If the fx queue is dequeued, always remove the progress sentinel
                if (fn === "inprogress") {
                    fn = queue.shift();
                    startLength--;
                }
                if (fn) {
                    // Add a progress sentinel to prevent the fx queue from being
                    // automatically dequeued
                    if (type === "fx") {
                        queue.unshift("inprogress");
                    }
                    // Clear up the last queue stop function
                    delete hooks.stop;
                    fn.call(elem, next, hooks);
                }
                if (!startLength && hooks) {
                    hooks.empty.fire();
                }
            },
            // Not public - generate a queueHooks object, or return the current one
            _queueHooks: function (elem, type) {
                var key = type + "queueHooks";
                return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                    empty: jQuery.Callbacks("once memory").add(function () {
                        dataPriv.remove(elem, [type + "queue", key]);
                    })
                });
            }
        });
        jQuery.fn.extend({
            queue: function (type, data) {
                var setter = 2;
                if (typeof type !== "string") {
                    data = type;
                    type = "fx";
                    setter--;
                }
                if (arguments.length < setter) {
                    return jQuery.queue(this[0], type);
                }
                return data === undefined ?
                    this :
                    this.each(function () {
                        var queue = jQuery.queue(this, type, data);
                        // Ensure a hooks for this queue
                        jQuery._queueHooks(this, type);
                        if (type === "fx" && queue[0] !== "inprogress") {
                            jQuery.dequeue(this, type);
                        }
                    });
            },
            dequeue: function (type) {
                return this.each(function () {
                    jQuery.dequeue(this, type);
                });
            },
            clearQueue: function (type) {
                return this.queue(type || "fx", []);
            },
            // Get a promise resolved when queues of a certain type
            // are emptied (fx is the type by default)
            promise: function (type, obj) {
                var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function () {
                    if (!(--count)) {
                        defer.resolveWith(elements, [elements]);
                    }
                };
                if (typeof type !== "string") {
                    obj = type;
                    type = undefined;
                }
                type = type || "fx";
                while (i--) {
                    tmp = dataPriv.get(elements[i], type + "queueHooks");
                    if (tmp && tmp.empty) {
                        count++;
                        tmp.empty.add(resolve);
                    }
                }
                resolve();
                return defer.promise(obj);
            }
        });
        var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;
        var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
        var cssExpand = ["Top", "Right", "Bottom", "Left"];
        var isHiddenWithinTree = function (elem, el) {
            // isHiddenWithinTree might be called from jQuery#filter function;
            // in that case, element will be second argument
            elem = el || elem;
            // Inline style trumps all
            return elem.style.display === "none" ||
                elem.style.display === "" &&
                    // Otherwise, check computed style
                    // Support: Firefox <=43 - 45
                    // Disconnected elements can have computed display: none, so first confirm that elem is
                    // in the document.
                    jQuery.contains(elem.ownerDocument, elem) &&
                    jQuery.css(elem, "display") === "none";
        };
        var swap = function (elem, options, callback, args) {
            var ret, name, old = {};
            // Remember the old values, and insert the new ones
            for (name in options) {
                old[name] = elem.style[name];
                elem.style[name] = options[name];
            }
            ret = callback.apply(elem, args || []);
            // Revert the old values
            for (name in options) {
                elem.style[name] = old[name];
            }
            return ret;
        };
        function adjustCSS(elem, prop, valueParts, tween) {
            var adjusted, scale, maxIterations = 20, currentValue = tween ?
                function () {
                    return tween.cur();
                } :
                function () {
                    return jQuery.css(elem, prop, "");
                }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), 
            // Starting value computation is required for potential unit mismatches
            initialInUnit = (jQuery.cssNumber[prop] || unit !== "px" && +initial) &&
                rcssNum.exec(jQuery.css(elem, prop));
            if (initialInUnit && initialInUnit[3] !== unit) {
                // Support: Firefox <=54
                // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
                initial = initial / 2;
                // Trust units reported by jQuery.css
                unit = unit || initialInUnit[3];
                // Iteratively approximate from a nonzero starting point
                initialInUnit = +initial || 1;
                while (maxIterations--) {
                    // Evaluate and update our best guess (doubling guesses that zero out).
                    // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                    jQuery.style(elem, prop, initialInUnit + unit);
                    if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
                        maxIterations = 0;
                    }
                    initialInUnit = initialInUnit / scale;
                }
                initialInUnit = initialInUnit * 2;
                jQuery.style(elem, prop, initialInUnit + unit);
                // Make sure we update the tween properties later on
                valueParts = valueParts || [];
            }
            if (valueParts) {
                initialInUnit = +initialInUnit || +initial || 0;
                // Apply relative offset (+=/-=) if specified
                adjusted = valueParts[1] ?
                    initialInUnit + (valueParts[1] + 1) * valueParts[2] :
                    +valueParts[2];
                if (tween) {
                    tween.unit = unit;
                    tween.start = initialInUnit;
                    tween.end = adjusted;
                }
            }
            return adjusted;
        }
        var defaultDisplayMap = {};
        function getDefaultDisplay(elem) {
            var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
            if (display) {
                return display;
            }
            temp = doc.body.appendChild(doc.createElement(nodeName));
            display = jQuery.css(temp, "display");
            temp.parentNode.removeChild(temp);
            if (display === "none") {
                display = "block";
            }
            defaultDisplayMap[nodeName] = display;
            return display;
        }
        function showHide(elements, show) {
            var display, elem, values = [], index = 0, length = elements.length;
            // Determine new display value for elements that need to change
            for (; index < length; index++) {
                elem = elements[index];
                if (!elem.style) {
                    continue;
                }
                display = elem.style.display;
                if (show) {
                    // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                    // check is required in this first loop unless we have a nonempty display value (either
                    // inline or about-to-be-restored)
                    if (display === "none") {
                        values[index] = dataPriv.get(elem, "display") || null;
                        if (!values[index]) {
                            elem.style.display = "";
                        }
                    }
                    if (elem.style.display === "" && isHiddenWithinTree(elem)) {
                        values[index] = getDefaultDisplay(elem);
                    }
                }
                else {
                    if (display !== "none") {
                        values[index] = "none";
                        // Remember what we're overwriting
                        dataPriv.set(elem, "display", display);
                    }
                }
            }
            // Set the display of the elements in a second loop to avoid constant reflow
            for (index = 0; index < length; index++) {
                if (values[index] != null) {
                    elements[index].style.display = values[index];
                }
            }
            return elements;
        }
        jQuery.fn.extend({
            show: function () {
                return showHide(this, true);
            },
            hide: function () {
                return showHide(this);
            },
            toggle: function (state) {
                if (typeof state === "boolean") {
                    return state ? this.show() : this.hide();
                }
                return this.each(function () {
                    if (isHiddenWithinTree(this)) {
                        jQuery(this).show();
                    }
                    else {
                        jQuery(this).hide();
                    }
                });
            }
        });
        var rcheckableType = (/^(?:checkbox|radio)$/i);
        var rtagName = (/<([a-z][^\/\0>\x20\t\r\n\f]+)/i);
        var rscriptType = (/^$|^module$|\/(?:java|ecma)script/i);
        // We have to close these tags to support XHTML (#13200)
        var wrapMap = {
            // Support: IE <=9 only
            option: [1, "<select multiple='multiple'>", "</select>"],
            // XHTML parsers do not magically insert elements in the
            // same way that tag soup parsers do. So we cannot shorten
            // this by omitting <tbody> or other required elements.
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""]
        };
        // Support: IE <=9 only
        wrapMap.optgroup = wrapMap.option;
        wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
        wrapMap.th = wrapMap.td;
        function getAll(context, tag) {
            // Support: IE <=9 - 11 only
            // Use typeof to avoid zero-argument method invocation on host objects (#15151)
            var ret;
            if (typeof context.getElementsByTagName !== "undefined") {
                ret = context.getElementsByTagName(tag || "*");
            }
            else if (typeof context.querySelectorAll !== "undefined") {
                ret = context.querySelectorAll(tag || "*");
            }
            else {
                ret = [];
            }
            if (tag === undefined || tag && nodeName(context, tag)) {
                return jQuery.merge([context], ret);
            }
            return ret;
        }
        // Mark scripts as having already been evaluated
        function setGlobalEval(elems, refElements) {
            var i = 0, l = elems.length;
            for (; i < l; i++) {
                dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
            }
        }
        var rhtml = /<|&#?\w+;/;
        function buildFragment(elems, context, scripts, selection, ignored) {
            var elem, tmp, tag, wrap, contains, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
            for (; i < l; i++) {
                elem = elems[i];
                if (elem || elem === 0) {
                    // Add nodes directly
                    if (toType(elem) === "object") {
                        // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(nodes, elem.nodeType ? [elem] : elem);
                        // Convert non-html into a text node
                    }
                    else if (!rhtml.test(elem)) {
                        nodes.push(context.createTextNode(elem));
                        // Convert html into DOM nodes
                    }
                    else {
                        tmp = tmp || fragment.appendChild(context.createElement("div"));
                        // Deserialize a standard representation
                        tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
                        wrap = wrapMap[tag] || wrapMap._default;
                        tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                        // Descend through wrappers to the right content
                        j = wrap[0];
                        while (j--) {
                            tmp = tmp.lastChild;
                        }
                        // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(nodes, tmp.childNodes);
                        // Remember the top-level container
                        tmp = fragment.firstChild;
                        // Ensure the created nodes are orphaned (#12392)
                        tmp.textContent = "";
                    }
                }
            }
            // Remove wrapper from fragment
            fragment.textContent = "";
            i = 0;
            while ((elem = nodes[i++])) {
                // Skip elements already in the context collection (trac-4087)
                if (selection && jQuery.inArray(elem, selection) > -1) {
                    if (ignored) {
                        ignored.push(elem);
                    }
                    continue;
                }
                contains = jQuery.contains(elem.ownerDocument, elem);
                // Append to fragment
                tmp = getAll(fragment.appendChild(elem), "script");
                // Preserve script evaluation history
                if (contains) {
                    setGlobalEval(tmp);
                }
                // Capture executables
                if (scripts) {
                    j = 0;
                    while ((elem = tmp[j++])) {
                        if (rscriptType.test(elem.type || "")) {
                            scripts.push(elem);
                        }
                    }
                }
            }
            return fragment;
        }
        (function () {
            var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
            // Support: Android 4.0 - 4.3 only
            // Check state lost if the name is set (#11217)
            // Support: Windows Web Apps (WWA)
            // `name` and `type` must use .setAttribute for WWA (#14901)
            input.setAttribute("type", "radio");
            input.setAttribute("checked", "checked");
            input.setAttribute("name", "t");
            div.appendChild(input);
            // Support: Android <=4.1 only
            // Older WebKit doesn't clone checked state correctly in fragments
            support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
            // Support: IE <=11 only
            // Make sure textarea (and checkbox) defaultValue is properly cloned
            div.innerHTML = "<textarea>x</textarea>";
            support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        })();
        var documentElement = document.documentElement;
        var rkeyEvent = /^key/, rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/, rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
        function returnTrue() {
            return true;
        }
        function returnFalse() {
            return false;
        }
        // Support: IE <=9 only
        // See #13393 for more info
        function safeActiveElement() {
            try {
                return document.activeElement;
            }
            catch (err) { }
        }
        function on(elem, types, selector, data, fn, one) {
            var origFn, type;
            // Types can be a map of types/handlers
            if (typeof types === "object") {
                // ( types-Object, selector, data )
                if (typeof selector !== "string") {
                    // ( types-Object, data )
                    data = data || selector;
                    selector = undefined;
                }
                for (type in types) {
                    on(elem, type, selector, data, types[type], one);
                }
                return elem;
            }
            if (data == null && fn == null) {
                // ( types, fn )
                fn = selector;
                data = selector = undefined;
            }
            else if (fn == null) {
                if (typeof selector === "string") {
                    // ( types, selector, fn )
                    fn = data;
                    data = undefined;
                }
                else {
                    // ( types, data, fn )
                    fn = data;
                    data = selector;
                    selector = undefined;
                }
            }
            if (fn === false) {
                fn = returnFalse;
            }
            else if (!fn) {
                return elem;
            }
            if (one === 1) {
                origFn = fn;
                fn = function (event) {
                    // Can use an empty set, since event contains the info
                    jQuery().off(event);
                    return origFn.apply(this, arguments);
                };
                // Use same guid so caller can remove using origFn
                fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
            }
            return elem.each(function () {
                jQuery.event.add(this, types, fn, data, selector);
            });
        }
        /*
         * Helper functions for managing events -- not part of the public interface.
         * Props to Dean Edwards' addEvent library for many of the ideas.
         */
        jQuery.event = {
            global: {},
            add: function (elem, types, handler, data, selector) {
                var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
                // Don't attach events to noData or text/comment nodes (but allow plain objects)
                if (!elemData) {
                    return;
                }
                // Caller can pass in an object of custom data in lieu of the handler
                if (handler.handler) {
                    handleObjIn = handler;
                    handler = handleObjIn.handler;
                    selector = handleObjIn.selector;
                }
                // Ensure that invalid selectors throw exceptions at attach time
                // Evaluate against documentElement in case elem is a non-element node (e.g., document)
                if (selector) {
                    jQuery.find.matchesSelector(documentElement, selector);
                }
                // Make sure that the handler has a unique ID, used to find/remove it later
                if (!handler.guid) {
                    handler.guid = jQuery.guid++;
                }
                // Init the element's event structure and main handler, if this is the first
                if (!(events = elemData.events)) {
                    events = elemData.events = {};
                }
                if (!(eventHandle = elemData.handle)) {
                    eventHandle = elemData.handle = function (e) {
                        // Discard the second event of a jQuery.event.trigger() and
                        // when an event is called after a page has unloaded
                        return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
                            jQuery.event.dispatch.apply(elem, arguments) : undefined;
                    };
                }
                // Handle multiple events separated by a space
                types = (types || "").match(rnothtmlwhite) || [""];
                t = types.length;
                while (t--) {
                    tmp = rtypenamespace.exec(types[t]) || [];
                    type = origType = tmp[1];
                    namespaces = (tmp[2] || "").split(".").sort();
                    // There *must* be a type, no attaching namespace-only handlers
                    if (!type) {
                        continue;
                    }
                    // If event changes its type, use the special event handlers for the changed type
                    special = jQuery.event.special[type] || {};
                    // If selector defined, determine special event api type, otherwise given type
                    type = (selector ? special.delegateType : special.bindType) || type;
                    // Update special based on newly reset type
                    special = jQuery.event.special[type] || {};
                    // handleObj is passed to all event handlers
                    handleObj = jQuery.extend({
                        type: type,
                        origType: origType,
                        data: data,
                        handler: handler,
                        guid: handler.guid,
                        selector: selector,
                        needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                        namespace: namespaces.join(".")
                    }, handleObjIn);
                    // Init the event handler queue if we're the first
                    if (!(handlers = events[type])) {
                        handlers = events[type] = [];
                        handlers.delegateCount = 0;
                        // Only use addEventListener if the special events handler returns false
                        if (!special.setup ||
                            special.setup.call(elem, data, namespaces, eventHandle) === false) {
                            if (elem.addEventListener) {
                                elem.addEventListener(type, eventHandle);
                            }
                        }
                    }
                    if (special.add) {
                        special.add.call(elem, handleObj);
                        if (!handleObj.handler.guid) {
                            handleObj.handler.guid = handler.guid;
                        }
                    }
                    // Add to the element's handler list, delegates in front
                    if (selector) {
                        handlers.splice(handlers.delegateCount++, 0, handleObj);
                    }
                    else {
                        handlers.push(handleObj);
                    }
                    // Keep track of which events have ever been used, for event optimization
                    jQuery.event.global[type] = true;
                }
            },
            // Detach an event or set of events from an element
            remove: function (elem, types, handler, selector, mappedTypes) {
                var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
                if (!elemData || !(events = elemData.events)) {
                    return;
                }
                // Once for each type.namespace in types; type may be omitted
                types = (types || "").match(rnothtmlwhite) || [""];
                t = types.length;
                while (t--) {
                    tmp = rtypenamespace.exec(types[t]) || [];
                    type = origType = tmp[1];
                    namespaces = (tmp[2] || "").split(".").sort();
                    // Unbind all events (on this namespace, if provided) for the element
                    if (!type) {
                        for (type in events) {
                            jQuery.event.remove(elem, type + types[t], handler, selector, true);
                        }
                        continue;
                    }
                    special = jQuery.event.special[type] || {};
                    type = (selector ? special.delegateType : special.bindType) || type;
                    handlers = events[type] || [];
                    tmp = tmp[2] &&
                        new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                    // Remove matching events
                    origCount = j = handlers.length;
                    while (j--) {
                        handleObj = handlers[j];
                        if ((mappedTypes || origType === handleObj.origType) &&
                            (!handler || handler.guid === handleObj.guid) &&
                            (!tmp || tmp.test(handleObj.namespace)) &&
                            (!selector || selector === handleObj.selector ||
                                selector === "**" && handleObj.selector)) {
                            handlers.splice(j, 1);
                            if (handleObj.selector) {
                                handlers.delegateCount--;
                            }
                            if (special.remove) {
                                special.remove.call(elem, handleObj);
                            }
                        }
                    }
                    // Remove generic event handler if we removed something and no more handlers exist
                    // (avoids potential for endless recursion during removal of special event handlers)
                    if (origCount && !handlers.length) {
                        if (!special.teardown ||
                            special.teardown.call(elem, namespaces, elemData.handle) === false) {
                            jQuery.removeEvent(elem, type, elemData.handle);
                        }
                        delete events[type];
                    }
                }
                // Remove data and the expando if it's no longer used
                if (jQuery.isEmptyObject(events)) {
                    dataPriv.remove(elem, "handle events");
                }
            },
            dispatch: function (nativeEvent) {
                // Make a writable jQuery.Event from the native event object
                var event = jQuery.event.fix(nativeEvent);
                var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), handlers = (dataPriv.get(this, "events") || {})[event.type] || [], special = jQuery.event.special[event.type] || {};
                // Use the fix-ed jQuery.Event rather than the (read-only) native event
                args[0] = event;
                for (i = 1; i < arguments.length; i++) {
                    args[i] = arguments[i];
                }
                event.delegateTarget = this;
                // Call the preDispatch hook for the mapped type, and let it bail if desired
                if (special.preDispatch && special.preDispatch.call(this, event) === false) {
                    return;
                }
                // Determine handlers
                handlerQueue = jQuery.event.handlers.call(this, event, handlers);
                // Run delegates first; they may want to stop propagation beneath us
                i = 0;
                while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
                    event.currentTarget = matched.elem;
                    j = 0;
                    while ((handleObj = matched.handlers[j++]) &&
                        !event.isImmediatePropagationStopped()) {
                        // Triggered event must either 1) have no namespace, or 2) have namespace(s)
                        // a subset or equal to those in the bound event (both can have no namespace).
                        if (!event.rnamespace || event.rnamespace.test(handleObj.namespace)) {
                            event.handleObj = handleObj;
                            event.data = handleObj.data;
                            ret = ((jQuery.event.special[handleObj.origType] || {}).handle ||
                                handleObj.handler).apply(matched.elem, args);
                            if (ret !== undefined) {
                                if ((event.result = ret) === false) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                }
                            }
                        }
                    }
                }
                // Call the postDispatch hook for the mapped type
                if (special.postDispatch) {
                    special.postDispatch.call(this, event);
                }
                return event.result;
            },
            handlers: function (event, handlers) {
                var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
                // Find delegate handlers
                if (delegateCount &&
                    // Support: IE <=9
                    // Black-hole SVG <use> instance trees (trac-13180)
                    cur.nodeType &&
                    // Support: Firefox <=42
                    // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
                    // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
                    // Support: IE 11 only
                    // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
                    !(event.type === "click" && event.button >= 1)) {
                    for (; cur !== this; cur = cur.parentNode || this) {
                        // Don't check non-elements (#13208)
                        // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                        if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                            matchedHandlers = [];
                            matchedSelectors = {};
                            for (i = 0; i < delegateCount; i++) {
                                handleObj = handlers[i];
                                // Don't conflict with Object.prototype properties (#13203)
                                sel = handleObj.selector + " ";
                                if (matchedSelectors[sel] === undefined) {
                                    matchedSelectors[sel] = handleObj.needsContext ?
                                        jQuery(sel, this).index(cur) > -1 :
                                        jQuery.find(sel, this, null, [cur]).length;
                                }
                                if (matchedSelectors[sel]) {
                                    matchedHandlers.push(handleObj);
                                }
                            }
                            if (matchedHandlers.length) {
                                handlerQueue.push({ elem: cur, handlers: matchedHandlers });
                            }
                        }
                    }
                }
                // Add the remaining (directly-bound) handlers
                cur = this;
                if (delegateCount < handlers.length) {
                    handlerQueue.push({ elem: cur, handlers: handlers.slice(delegateCount) });
                }
                return handlerQueue;
            },
            addProp: function (name, hook) {
                Object.defineProperty(jQuery.Event.prototype, name, {
                    enumerable: true,
                    configurable: true,
                    get: isFunction(hook) ?
                        function () {
                            if (this.originalEvent) {
                                return hook(this.originalEvent);
                            }
                        } :
                        function () {
                            if (this.originalEvent) {
                                return this.originalEvent[name];
                            }
                        },
                    set: function (value) {
                        Object.defineProperty(this, name, {
                            enumerable: true,
                            configurable: true,
                            writable: true,
                            value: value
                        });
                    }
                });
            },
            fix: function (originalEvent) {
                return originalEvent[jQuery.expando] ?
                    originalEvent :
                    new jQuery.Event(originalEvent);
            },
            special: {
                load: {
                    // Prevent triggered image.load events from bubbling to window.load
                    noBubble: true
                },
                focus: {
                    // Fire native event if possible so blur/focus sequence is correct
                    trigger: function () {
                        if (this !== safeActiveElement() && this.focus) {
                            this.focus();
                            return false;
                        }
                    },
                    delegateType: "focusin"
                },
                blur: {
                    trigger: function () {
                        if (this === safeActiveElement() && this.blur) {
                            this.blur();
                            return false;
                        }
                    },
                    delegateType: "focusout"
                },
                click: {
                    // For checkbox, fire native event so checked state will be right
                    trigger: function () {
                        if (this.type === "checkbox" && this.click && nodeName(this, "input")) {
                            this.click();
                            return false;
                        }
                    },
                    // For cross-browser consistency, don't fire native .click() on links
                    _default: function (event) {
                        return nodeName(event.target, "a");
                    }
                },
                beforeunload: {
                    postDispatch: function (event) {
                        // Support: Firefox 20+
                        // Firefox doesn't alert if the returnValue field is not set.
                        if (event.result !== undefined && event.originalEvent) {
                            event.originalEvent.returnValue = event.result;
                        }
                    }
                }
            }
        };
        jQuery.removeEvent = function (elem, type, handle) {
            // This "if" is needed for plain objects
            if (elem.removeEventListener) {
                elem.removeEventListener(type, handle);
            }
        };
        jQuery.Event = function (src, props) {
            // Allow instantiation without the 'new' keyword
            if (!(this instanceof jQuery.Event)) {
                return new jQuery.Event(src, props);
            }
            // Event object
            if (src && src.type) {
                this.originalEvent = src;
                this.type = src.type;
                // Events bubbling up the document may have been marked as prevented
                // by a handler lower down the tree; reflect the correct value.
                this.isDefaultPrevented = src.defaultPrevented ||
                    src.defaultPrevented === undefined &&
                        // Support: Android <=2.3 only
                        src.returnValue === false ?
                    returnTrue :
                    returnFalse;
                // Create target properties
                // Support: Safari <=6 - 7 only
                // Target should not be a text node (#504, #13143)
                this.target = (src.target && src.target.nodeType === 3) ?
                    src.target.parentNode :
                    src.target;
                this.currentTarget = src.currentTarget;
                this.relatedTarget = src.relatedTarget;
                // Event type
            }
            else {
                this.type = src;
            }
            // Put explicitly provided properties onto the event object
            if (props) {
                jQuery.extend(this, props);
            }
            // Create a timestamp if incoming event doesn't have one
            this.timeStamp = src && src.timeStamp || Date.now();
            // Mark it as fixed
            this[jQuery.expando] = true;
        };
        // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
        // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
        jQuery.Event.prototype = {
            constructor: jQuery.Event,
            isDefaultPrevented: returnFalse,
            isPropagationStopped: returnFalse,
            isImmediatePropagationStopped: returnFalse,
            isSimulated: false,
            preventDefault: function () {
                var e = this.originalEvent;
                this.isDefaultPrevented = returnTrue;
                if (e && !this.isSimulated) {
                    e.preventDefault();
                }
            },
            stopPropagation: function () {
                var e = this.originalEvent;
                this.isPropagationStopped = returnTrue;
                if (e && !this.isSimulated) {
                    e.stopPropagation();
                }
            },
            stopImmediatePropagation: function () {
                var e = this.originalEvent;
                this.isImmediatePropagationStopped = returnTrue;
                if (e && !this.isSimulated) {
                    e.stopImmediatePropagation();
                }
                this.stopPropagation();
            }
        };
        // Includes all common event props including KeyEvent and MouseEvent specific props
        jQuery.each({
            altKey: true,
            bubbles: true,
            cancelable: true,
            changedTouches: true,
            ctrlKey: true,
            detail: true,
            eventPhase: true,
            metaKey: true,
            pageX: true,
            pageY: true,
            shiftKey: true,
            view: true,
            "char": true,
            charCode: true,
            key: true,
            keyCode: true,
            button: true,
            buttons: true,
            clientX: true,
            clientY: true,
            offsetX: true,
            offsetY: true,
            pointerId: true,
            pointerType: true,
            screenX: true,
            screenY: true,
            targetTouches: true,
            toElement: true,
            touches: true,
            which: function (event) {
                var button = event.button;
                // Add which for key events
                if (event.which == null && rkeyEvent.test(event.type)) {
                    return event.charCode != null ? event.charCode : event.keyCode;
                }
                // Add which for click: 1 === left; 2 === middle; 3 === right
                if (!event.which && button !== undefined && rmouseEvent.test(event.type)) {
                    if (button & 1) {
                        return 1;
                    }
                    if (button & 2) {
                        return 3;
                    }
                    if (button & 4) {
                        return 2;
                    }
                    return 0;
                }
                return event.which;
            }
        }, jQuery.event.addProp);
        // Create mouseenter/leave events using mouseover/out and event-time checks
        // so that event delegation works in jQuery.
        // Do the same for pointerenter/pointerleave and pointerover/pointerout
        //
        // Support: Safari 7 only
        // Safari sends mouseenter too often; see:
        // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
        // for the description of the bug (it existed in older Chrome versions as well).
        jQuery.each({
            mouseenter: "mouseover",
            mouseleave: "mouseout",
            pointerenter: "pointerover",
            pointerleave: "pointerout"
        }, function (orig, fix) {
            jQuery.event.special[orig] = {
                delegateType: fix,
                bindType: fix,
                handle: function (event) {
                    var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                    // For mouseenter/leave call the handler if related is outside the target.
                    // NB: No relatedTarget if the mouse left/entered the browser window
                    if (!related || (related !== target && !jQuery.contains(target, related))) {
                        event.type = handleObj.origType;
                        ret = handleObj.handler.apply(this, arguments);
                        event.type = fix;
                    }
                    return ret;
                }
            };
        });
        jQuery.fn.extend({
            on: function (types, selector, data, fn) {
                return on(this, types, selector, data, fn);
            },
            one: function (types, selector, data, fn) {
                return on(this, types, selector, data, fn, 1);
            },
            off: function (types, selector, fn) {
                var handleObj, type;
                if (types && types.preventDefault && types.handleObj) {
                    // ( event )  dispatched jQuery.Event
                    handleObj = types.handleObj;
                    jQuery(types.delegateTarget).off(handleObj.namespace ?
                        handleObj.origType + "." + handleObj.namespace :
                        handleObj.origType, handleObj.selector, handleObj.handler);
                    return this;
                }
                if (typeof types === "object") {
                    // ( types-object [, selector] )
                    for (type in types) {
                        this.off(type, selector, types[type]);
                    }
                    return this;
                }
                if (selector === false || typeof selector === "function") {
                    // ( types [, fn] )
                    fn = selector;
                    selector = undefined;
                }
                if (fn === false) {
                    fn = returnFalse;
                }
                return this.each(function () {
                    jQuery.event.remove(this, types, fn, selector);
                });
            }
        });
        var 
        /* eslint-disable max-len */
        // See https://github.com/eslint/eslint/issues/3229
        rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi, 
        /* eslint-enable */
        // Support: IE <=10 - 11, Edge 12 - 13 only
        // In IE/Edge using regex groups here causes severe slowdowns.
        // See https://connect.microsoft.com/IE/feedback/details/1736512/
        rnoInnerhtml = /<script|<style|<link/i, 
        // checked="checked" or checked
        rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
        // Prefer a tbody over its parent table for containing new rows
        function manipulationTarget(elem, content) {
            if (nodeName(elem, "table") &&
                nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {
                return jQuery(elem).children("tbody")[0] || elem;
            }
            return elem;
        }
        // Replace/restore the type attribute of script elements for safe DOM manipulation
        function disableScript(elem) {
            elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
            return elem;
        }
        function restoreScript(elem) {
            if ((elem.type || "").slice(0, 5) === "true/") {
                elem.type = elem.type.slice(5);
            }
            else {
                elem.removeAttribute("type");
            }
            return elem;
        }
        function cloneCopyEvent(src, dest) {
            var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
            if (dest.nodeType !== 1) {
                return;
            }
            // 1. Copy private data: events, handlers, etc.
            if (dataPriv.hasData(src)) {
                pdataOld = dataPriv.access(src);
                pdataCur = dataPriv.set(dest, pdataOld);
                events = pdataOld.events;
                if (events) {
                    delete pdataCur.handle;
                    pdataCur.events = {};
                    for (type in events) {
                        for (i = 0, l = events[type].length; i < l; i++) {
                            jQuery.event.add(dest, type, events[type][i]);
                        }
                    }
                }
            }
            // 2. Copy user data
            if (dataUser.hasData(src)) {
                udataOld = dataUser.access(src);
                udataCur = jQuery.extend({}, udataOld);
                dataUser.set(dest, udataCur);
            }
        }
        // Fix IE bugs, see support tests
        function fixInput(src, dest) {
            var nodeName = dest.nodeName.toLowerCase();
            // Fails to persist the checked state of a cloned checkbox or radio button.
            if (nodeName === "input" && rcheckableType.test(src.type)) {
                dest.checked = src.checked;
                // Fails to return the selected option to the default selected state when cloning options
            }
            else if (nodeName === "input" || nodeName === "textarea") {
                dest.defaultValue = src.defaultValue;
            }
        }
        function domManip(collection, args, callback, ignored) {
            // Flatten any nested arrays
            args = concat.apply([], args);
            var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
            // We can't cloneNode fragments that contain checked, in WebKit
            if (valueIsFunction ||
                (l > 1 && typeof value === "string" &&
                    !support.checkClone && rchecked.test(value))) {
                return collection.each(function (index) {
                    var self = collection.eq(index);
                    if (valueIsFunction) {
                        args[0] = value.call(this, index, self.html());
                    }
                    domManip(self, args, callback, ignored);
                });
            }
            if (l) {
                fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
                first = fragment.firstChild;
                if (fragment.childNodes.length === 1) {
                    fragment = first;
                }
                // Require either new content or an interest in ignored elements to invoke the callback
                if (first || ignored) {
                    scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                    hasScripts = scripts.length;
                    // Use the original fragment for the last item
                    // instead of the first because it can end up
                    // being emptied incorrectly in certain situations (#8070).
                    for (; i < l; i++) {
                        node = fragment;
                        if (i !== iNoClone) {
                            node = jQuery.clone(node, true, true);
                            // Keep references to cloned scripts for later restoration
                            if (hasScripts) {
                                // Support: Android <=4.0 only, PhantomJS 1 only
                                // push.apply(_, arraylike) throws on ancient WebKit
                                jQuery.merge(scripts, getAll(node, "script"));
                            }
                        }
                        callback.call(collection[i], node, i);
                    }
                    if (hasScripts) {
                        doc = scripts[scripts.length - 1].ownerDocument;
                        // Reenable scripts
                        jQuery.map(scripts, restoreScript);
                        // Evaluate executable scripts on first document insertion
                        for (i = 0; i < hasScripts; i++) {
                            node = scripts[i];
                            if (rscriptType.test(node.type || "") &&
                                !dataPriv.access(node, "globalEval") &&
                                jQuery.contains(doc, node)) {
                                if (node.src && (node.type || "").toLowerCase() !== "module") {
                                    // Optional AJAX dependency, but won't run scripts if not present
                                    if (jQuery._evalUrl) {
                                        jQuery._evalUrl(node.src);
                                    }
                                }
                                else {
                                    DOMEval(node.textContent.replace(rcleanScript, ""), doc, node);
                                }
                            }
                        }
                    }
                }
            }
            return collection;
        }
        function remove(elem, selector, keepData) {
            var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
            for (; (node = nodes[i]) != null; i++) {
                if (!keepData && node.nodeType === 1) {
                    jQuery.cleanData(getAll(node));
                }
                if (node.parentNode) {
                    if (keepData && jQuery.contains(node.ownerDocument, node)) {
                        setGlobalEval(getAll(node, "script"));
                    }
                    node.parentNode.removeChild(node);
                }
            }
            return elem;
        }
        jQuery.extend({
            htmlPrefilter: function (html) {
                return html.replace(rxhtmlTag, "<$1></$2>");
            },
            clone: function (elem, dataAndEvents, deepDataAndEvents) {
                var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = jQuery.contains(elem.ownerDocument, elem);
                // Fix IE cloning issues
                if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) &&
                    !jQuery.isXMLDoc(elem)) {
                    // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                    destElements = getAll(clone);
                    srcElements = getAll(elem);
                    for (i = 0, l = srcElements.length; i < l; i++) {
                        fixInput(srcElements[i], destElements[i]);
                    }
                }
                // Copy the events from the original to the clone
                if (dataAndEvents) {
                    if (deepDataAndEvents) {
                        srcElements = srcElements || getAll(elem);
                        destElements = destElements || getAll(clone);
                        for (i = 0, l = srcElements.length; i < l; i++) {
                            cloneCopyEvent(srcElements[i], destElements[i]);
                        }
                    }
                    else {
                        cloneCopyEvent(elem, clone);
                    }
                }
                // Preserve script evaluation history
                destElements = getAll(clone, "script");
                if (destElements.length > 0) {
                    setGlobalEval(destElements, !inPage && getAll(elem, "script"));
                }
                // Return the cloned set
                return clone;
            },
            cleanData: function (elems) {
                var data, elem, type, special = jQuery.event.special, i = 0;
                for (; (elem = elems[i]) !== undefined; i++) {
                    if (acceptData(elem)) {
                        if ((data = elem[dataPriv.expando])) {
                            if (data.events) {
                                for (type in data.events) {
                                    if (special[type]) {
                                        jQuery.event.remove(elem, type);
                                        // This is a shortcut to avoid jQuery.event.remove's overhead
                                    }
                                    else {
                                        jQuery.removeEvent(elem, type, data.handle);
                                    }
                                }
                            }
                            // Support: Chrome <=35 - 45+
                            // Assign undefined instead of using delete, see Data#remove
                            elem[dataPriv.expando] = undefined;
                        }
                        if (elem[dataUser.expando]) {
                            // Support: Chrome <=35 - 45+
                            // Assign undefined instead of using delete, see Data#remove
                            elem[dataUser.expando] = undefined;
                        }
                    }
                }
            }
        });
        jQuery.fn.extend({
            detach: function (selector) {
                return remove(this, selector, true);
            },
            remove: function (selector) {
                return remove(this, selector);
            },
            text: function (value) {
                return access(this, function (value) {
                    return value === undefined ?
                        jQuery.text(this) :
                        this.empty().each(function () {
                            if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                                this.textContent = value;
                            }
                        });
                }, null, value, arguments.length);
            },
            append: function () {
                return domManip(this, arguments, function (elem) {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                        var target = manipulationTarget(this, elem);
                        target.appendChild(elem);
                    }
                });
            },
            prepend: function () {
                return domManip(this, arguments, function (elem) {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                        var target = manipulationTarget(this, elem);
                        target.insertBefore(elem, target.firstChild);
                    }
                });
            },
            before: function () {
                return domManip(this, arguments, function (elem) {
                    if (this.parentNode) {
                        this.parentNode.insertBefore(elem, this);
                    }
                });
            },
            after: function () {
                return domManip(this, arguments, function (elem) {
                    if (this.parentNode) {
                        this.parentNode.insertBefore(elem, this.nextSibling);
                    }
                });
            },
            empty: function () {
                var elem, i = 0;
                for (; (elem = this[i]) != null; i++) {
                    if (elem.nodeType === 1) {
                        // Prevent memory leaks
                        jQuery.cleanData(getAll(elem, false));
                        // Remove any remaining nodes
                        elem.textContent = "";
                    }
                }
                return this;
            },
            clone: function (dataAndEvents, deepDataAndEvents) {
                dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
                deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
                return this.map(function () {
                    return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
                });
            },
            html: function (value) {
                return access(this, function (value) {
                    var elem = this[0] || {}, i = 0, l = this.length;
                    if (value === undefined && elem.nodeType === 1) {
                        return elem.innerHTML;
                    }
                    // See if we can take a shortcut and just use innerHTML
                    if (typeof value === "string" && !rnoInnerhtml.test(value) &&
                        !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {
                        value = jQuery.htmlPrefilter(value);
                        try {
                            for (; i < l; i++) {
                                elem = this[i] || {};
                                // Remove element nodes and prevent memory leaks
                                if (elem.nodeType === 1) {
                                    jQuery.cleanData(getAll(elem, false));
                                    elem.innerHTML = value;
                                }
                            }
                            elem = 0;
                            // If using innerHTML throws an exception, use the fallback method
                        }
                        catch (e) { }
                    }
                    if (elem) {
                        this.empty().append(value);
                    }
                }, null, value, arguments.length);
            },
            replaceWith: function () {
                var ignored = [];
                // Make the changes, replacing each non-ignored context element with the new content
                return domManip(this, arguments, function (elem) {
                    var parent = this.parentNode;
                    if (jQuery.inArray(this, ignored) < 0) {
                        jQuery.cleanData(getAll(this));
                        if (parent) {
                            parent.replaceChild(elem, this);
                        }
                    }
                    // Force callback invocation
                }, ignored);
            }
        });
        jQuery.each({
            appendTo: "append",
            prependTo: "prepend",
            insertBefore: "before",
            insertAfter: "after",
            replaceAll: "replaceWith"
        }, function (name, original) {
            jQuery.fn[name] = function (selector) {
                var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
                for (; i <= last; i++) {
                    elems = i === last ? this : this.clone(true);
                    jQuery(insert[i])[original](elems);
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // .get() because push.apply(_, arraylike) throws on ancient WebKit
                    push.apply(ret, elems.get());
                }
                return this.pushStack(ret);
            };
        });
        var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
        var getStyles = function (elem) {
            // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
            // IE throws on elements created in popups
            // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
            var view = elem.ownerDocument.defaultView;
            if (!view || !view.opener) {
                view = window;
            }
            return view.getComputedStyle(elem);
        };
        var rboxStyle = new RegExp(cssExpand.join("|"), "i");
        (function () {
            // Executing both pixelPosition & boxSizingReliable tests require only one layout
            // so they're executed at the same time to save the second computation.
            function computeStyleTests() {
                // This is a singleton, we need to execute it only once
                if (!div) {
                    return;
                }
                container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
                    "margin-top:1px;padding:0;border:0";
                div.style.cssText =
                    "position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
                        "margin:auto;border:1px;padding:1px;" +
                        "width:60%;top:1%";
                documentElement.appendChild(container).appendChild(div);
                var divStyle = window.getComputedStyle(div);
                pixelPositionVal = divStyle.top !== "1%";
                // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
                reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
                // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
                // Some styles come back with percentage values, even though they shouldn't
                div.style.right = "60%";
                pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
                // Support: IE 9 - 11 only
                // Detect misreporting of content dimensions for box-sizing:border-box elements
                boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
                // Support: IE 9 only
                // Detect overflow:scroll screwiness (gh-3699)
                div.style.position = "absolute";
                scrollboxSizeVal = div.offsetWidth === 36 || "absolute";
                documentElement.removeChild(container);
                // Nullify the div so it wouldn't be stored in the memory and
                // it will also be a sign that checks already performed
                div = null;
            }
            function roundPixelMeasures(measure) {
                return Math.round(parseFloat(measure));
            }
            var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
            // Finish early in limited (non-browser) environments
            if (!div.style) {
                return;
            }
            // Support: IE <=9 - 11 only
            // Style of cloned element affects source element cloned (#8908)
            div.style.backgroundClip = "content-box";
            div.cloneNode(true).style.backgroundClip = "";
            support.clearCloneStyle = div.style.backgroundClip === "content-box";
            jQuery.extend(support, {
                boxSizingReliable: function () {
                    computeStyleTests();
                    return boxSizingReliableVal;
                },
                pixelBoxStyles: function () {
                    computeStyleTests();
                    return pixelBoxStylesVal;
                },
                pixelPosition: function () {
                    computeStyleTests();
                    return pixelPositionVal;
                },
                reliableMarginLeft: function () {
                    computeStyleTests();
                    return reliableMarginLeftVal;
                },
                scrollboxSize: function () {
                    computeStyleTests();
                    return scrollboxSizeVal;
                }
            });
        })();
        function curCSS(elem, name, computed) {
            var width, minWidth, maxWidth, ret, 
            // Support: Firefox 51+
            // Retrieving style before computed somehow
            // fixes an issue with getting wrong values
            // on detached elements
            style = elem.style;
            computed = computed || getStyles(elem);
            // getPropertyValue is needed for:
            //   .css('filter') (IE 9 only, #12537)
            //   .css('--customProperty) (#3144)
            if (computed) {
                ret = computed.getPropertyValue(name) || computed[name];
                if (ret === "" && !jQuery.contains(elem.ownerDocument, elem)) {
                    ret = jQuery.style(elem, name);
                }
                // A tribute to the "awesome hack by Dean Edwards"
                // Android Browser returns percentage for some values,
                // but width seems to be reliably pixels.
                // This is against the CSSOM draft spec:
                // https://drafts.csswg.org/cssom/#resolved-values
                if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                    // Remember the original values
                    width = style.width;
                    minWidth = style.minWidth;
                    maxWidth = style.maxWidth;
                    // Put in the new values to get a computed value out
                    style.minWidth = style.maxWidth = style.width = ret;
                    ret = computed.width;
                    // Revert the changed values
                    style.width = width;
                    style.minWidth = minWidth;
                    style.maxWidth = maxWidth;
                }
            }
            return ret !== undefined ?
                // Support: IE <=9 - 11 only
                // IE returns zIndex value as an integer.
                ret + "" :
                ret;
        }
        function addGetHookIf(conditionFn, hookFn) {
            // Define the hook, we'll check on the first run if it's really needed.
            return {
                get: function () {
                    if (conditionFn()) {
                        // Hook not needed (or it's not possible to use it due
                        // to missing dependency), remove it.
                        delete this.get;
                        return;
                    }
                    // Hook needed; redefine it so that the support test is not executed again.
                    return (this.get = hookFn).apply(this, arguments);
                }
            };
        }
        var 
        // Swappable if display is none or starts with table
        // except "table", "table-cell", or "table-caption"
        // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
        rdisplayswap = /^(none|table(?!-c[ea]).+)/, rcustomProp = /^--/, cssShow = { position: "absolute", visibility: "hidden", display: "block" }, cssNormalTransform = {
            letterSpacing: "0",
            fontWeight: "400"
        }, cssPrefixes = ["Webkit", "Moz", "ms"], emptyStyle = document.createElement("div").style;
        // Return a css property mapped to a potentially vendor prefixed property
        function vendorPropName(name) {
            // Shortcut for names that are not vendor prefixed
            if (name in emptyStyle) {
                return name;
            }
            // Check for vendor prefixed names
            var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
            while (i--) {
                name = cssPrefixes[i] + capName;
                if (name in emptyStyle) {
                    return name;
                }
            }
        }
        // Return a property mapped along what jQuery.cssProps suggests or to
        // a vendor prefixed property.
        function finalPropName(name) {
            var ret = jQuery.cssProps[name];
            if (!ret) {
                ret = jQuery.cssProps[name] = vendorPropName(name) || name;
            }
            return ret;
        }
        function setPositiveNumber(elem, value, subtract) {
            // Any relative (+/-) values have already been
            // normalized at this point
            var matches = rcssNum.exec(value);
            return matches ?
                // Guard against undefined "subtract", e.g., when used as in cssHooks
                Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") :
                value;
        }
        function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
            var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0;
            // Adjustment may not be necessary
            if (box === (isBorderBox ? "border" : "content")) {
                return 0;
            }
            for (; i < 4; i += 2) {
                // Both box models exclude margin
                if (box === "margin") {
                    delta += jQuery.css(elem, box + cssExpand[i], true, styles);
                }
                // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
                if (!isBorderBox) {
                    // Add padding
                    delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                    // For "border" or "margin", add border
                    if (box !== "padding") {
                        delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                        // But still keep track of it otherwise
                    }
                    else {
                        extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                    }
                    // If we get here with a border-box (content + padding + border), we're seeking "content" or
                    // "padding" or "margin"
                }
                else {
                    // For "content", subtract padding
                    if (box === "content") {
                        delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                    }
                    // For "content" or "padding", subtract border
                    if (box !== "margin") {
                        delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                    }
                }
            }
            // Account for positive content-box scroll gutter when requested by providing computedVal
            if (!isBorderBox && computedVal >= 0) {
                // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
                // Assuming integer scroll gutter, subtract the rest and round down
                delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] -
                    computedVal -
                    delta -
                    extra -
                    0.5));
            }
            return delta;
        }
        function getWidthOrHeight(elem, dimension, extra) {
            // Start with computed style
            var styles = getStyles(elem), val = curCSS(elem, dimension, styles), isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox;
            // Support: Firefox <=54
            // Return a confounding non-pixel value or feign ignorance, as appropriate.
            if (rnumnonpx.test(val)) {
                if (!extra) {
                    return val;
                }
                val = "auto";
            }
            // Check for style in case a browser which returns unreliable values
            // for getComputedStyle silently falls back to the reliable elem.style
            valueIsBorderBox = valueIsBorderBox &&
                (support.boxSizingReliable() || val === elem.style[dimension]);
            // Fall back to offsetWidth/offsetHeight when value is "auto"
            // This happens for inline elements with no explicit setting (gh-3571)
            // Support: Android <=4.1 - 4.3 only
            // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
            if (val === "auto" ||
                !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") {
                val = elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)];
                // offsetWidth/offsetHeight provide border-box values
                valueIsBorderBox = true;
            }
            // Normalize "" and auto
            val = parseFloat(val) || 0;
            // Adjust for the element's box model
            return (val +
                boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, 
                // Provide the current computed size to request scroll gutter calculation (gh-3589)
                val)) + "px";
        }
        jQuery.extend({
            // Add in style property hooks for overriding the default
            // behavior of getting and setting a style property
            cssHooks: {
                opacity: {
                    get: function (elem, computed) {
                        if (computed) {
                            // We should always get a number back from opacity
                            var ret = curCSS(elem, "opacity");
                            return ret === "" ? "1" : ret;
                        }
                    }
                }
            },
            // Don't automatically add "px" to these possibly-unitless properties
            cssNumber: {
                "animationIterationCount": true,
                "columnCount": true,
                "fillOpacity": true,
                "flexGrow": true,
                "flexShrink": true,
                "fontWeight": true,
                "lineHeight": true,
                "opacity": true,
                "order": true,
                "orphans": true,
                "widows": true,
                "zIndex": true,
                "zoom": true
            },
            // Add in properties whose names you wish to fix before
            // setting or getting the value
            cssProps: {},
            // Get and set the style property on a DOM Node
            style: function (elem, name, value, extra) {
                // Don't set styles on text and comment nodes
                if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
                    return;
                }
                // Make sure that we're working with the right name
                var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
                // Make sure that we're working with the right name. We don't
                // want to query the value if it is a CSS custom property
                // since they are user-defined.
                if (!isCustomProp) {
                    name = finalPropName(origName);
                }
                // Gets hook for the prefixed version, then unprefixed version
                hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
                // Check if we're setting a value
                if (value !== undefined) {
                    type = typeof value;
                    // Convert "+=" or "-=" to relative numbers (#7345)
                    if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                        value = adjustCSS(elem, name, ret);
                        // Fixes bug #9237
                        type = "number";
                    }
                    // Make sure that null and NaN values aren't set (#7116)
                    if (value == null || value !== value) {
                        return;
                    }
                    // If a number was passed in, add the unit (except for certain CSS properties)
                    if (type === "number") {
                        value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                    }
                    // background-* props affect original clone's values
                    if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
                        style[name] = "inherit";
                    }
                    // If a hook was provided, use that value, otherwise just set the specified value
                    if (!hooks || !("set" in hooks) ||
                        (value = hooks.set(elem, value, extra)) !== undefined) {
                        if (isCustomProp) {
                            style.setProperty(name, value);
                        }
                        else {
                            style[name] = value;
                        }
                    }
                }
                else {
                    // If a hook was provided get the non-computed value from there
                    if (hooks && "get" in hooks &&
                        (ret = hooks.get(elem, false, extra)) !== undefined) {
                        return ret;
                    }
                    // Otherwise just get the value from the style object
                    return style[name];
                }
            },
            css: function (elem, name, extra, styles) {
                var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
                // Make sure that we're working with the right name. We don't
                // want to modify the value if it is a CSS custom property
                // since they are user-defined.
                if (!isCustomProp) {
                    name = finalPropName(origName);
                }
                // Try prefixed name followed by the unprefixed name
                hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
                // If a hook was provided get the computed value from there
                if (hooks && "get" in hooks) {
                    val = hooks.get(elem, true, extra);
                }
                // Otherwise, if a way to get the computed value exists, use that
                if (val === undefined) {
                    val = curCSS(elem, name, styles);
                }
                // Convert "normal" to computed value
                if (val === "normal" && name in cssNormalTransform) {
                    val = cssNormalTransform[name];
                }
                // Make numeric if forced or a qualifier was provided and val looks numeric
                if (extra === "" || extra) {
                    num = parseFloat(val);
                    return extra === true || isFinite(num) ? num || 0 : val;
                }
                return val;
            }
        });
        jQuery.each(["height", "width"], function (i, dimension) {
            jQuery.cssHooks[dimension] = {
                get: function (elem, computed, extra) {
                    if (computed) {
                        // Certain elements can have dimension info if we invisibly show them
                        // but it must have a current display style that would benefit
                        return rdisplayswap.test(jQuery.css(elem, "display")) &&
                            // Support: Safari 8+
                            // Table columns in Safari have non-zero offsetWidth & zero
                            // getBoundingClientRect().width unless display is changed.
                            // Support: IE <=11 only
                            // Running getBoundingClientRect on a disconnected node
                            // in IE throws an error.
                            (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ?
                            swap(elem, cssShow, function () {
                                return getWidthOrHeight(elem, dimension, extra);
                            }) :
                            getWidthOrHeight(elem, dimension, extra);
                    }
                },
                set: function (elem, value, extra) {
                    var matches, styles = getStyles(elem), isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra && boxModelAdjustment(elem, dimension, extra, isBorderBox, styles);
                    // Account for unreliable border-box dimensions by comparing offset* to computed and
                    // faking a content-box to get border and padding (gh-3699)
                    if (isBorderBox && support.scrollboxSize() === styles.position) {
                        subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] -
                            parseFloat(styles[dimension]) -
                            boxModelAdjustment(elem, dimension, "border", false, styles) -
                            0.5);
                    }
                    // Convert to pixels if value adjustment is needed
                    if (subtract && (matches = rcssNum.exec(value)) &&
                        (matches[3] || "px") !== "px") {
                        elem.style[dimension] = value;
                        value = jQuery.css(elem, dimension);
                    }
                    return setPositiveNumber(elem, value, subtract);
                }
            };
        });
        jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function (elem, computed) {
            if (computed) {
                return (parseFloat(curCSS(elem, "marginLeft")) ||
                    elem.getBoundingClientRect().left -
                        swap(elem, { marginLeft: 0 }, function () {
                            return elem.getBoundingClientRect().left;
                        })) + "px";
            }
        });
        // These hooks are used by animate to expand properties
        jQuery.each({
            margin: "",
            padding: "",
            border: "Width"
        }, function (prefix, suffix) {
            jQuery.cssHooks[prefix + suffix] = {
                expand: function (value) {
                    var i = 0, expanded = {}, 
                    // Assumes a single number if not a string
                    parts = typeof value === "string" ? value.split(" ") : [value];
                    for (; i < 4; i++) {
                        expanded[prefix + cssExpand[i] + suffix] =
                            parts[i] || parts[i - 2] || parts[0];
                    }
                    return expanded;
                }
            };
            if (prefix !== "margin") {
                jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
            }
        });
        jQuery.fn.extend({
            css: function (name, value) {
                return access(this, function (elem, name, value) {
                    var styles, len, map = {}, i = 0;
                    if (Array.isArray(name)) {
                        styles = getStyles(elem);
                        len = name.length;
                        for (; i < len; i++) {
                            map[name[i]] = jQuery.css(elem, name[i], false, styles);
                        }
                        return map;
                    }
                    return value !== undefined ?
                        jQuery.style(elem, name, value) :
                        jQuery.css(elem, name);
                }, name, value, arguments.length > 1);
            }
        });
        function Tween(elem, options, prop, end, easing) {
            return new Tween.prototype.init(elem, options, prop, end, easing);
        }
        jQuery.Tween = Tween;
        Tween.prototype = {
            constructor: Tween,
            init: function (elem, options, prop, end, easing, unit) {
                this.elem = elem;
                this.prop = prop;
                this.easing = easing || jQuery.easing._default;
                this.options = options;
                this.start = this.now = this.cur();
                this.end = end;
                this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
            },
            cur: function () {
                var hooks = Tween.propHooks[this.prop];
                return hooks && hooks.get ?
                    hooks.get(this) :
                    Tween.propHooks._default.get(this);
            },
            run: function (percent) {
                var eased, hooks = Tween.propHooks[this.prop];
                if (this.options.duration) {
                    this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
                }
                else {
                    this.pos = eased = percent;
                }
                this.now = (this.end - this.start) * eased + this.start;
                if (this.options.step) {
                    this.options.step.call(this.elem, this.now, this);
                }
                if (hooks && hooks.set) {
                    hooks.set(this);
                }
                else {
                    Tween.propHooks._default.set(this);
                }
                return this;
            }
        };
        Tween.prototype.init.prototype = Tween.prototype;
        Tween.propHooks = {
            _default: {
                get: function (tween) {
                    var result;
                    // Use a property on the element directly when it is not a DOM element,
                    // or when there is no matching style property that exists.
                    if (tween.elem.nodeType !== 1 ||
                        tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
                        return tween.elem[tween.prop];
                    }
                    // Passing an empty string as a 3rd parameter to .css will automatically
                    // attempt a parseFloat and fallback to a string if the parse fails.
                    // Simple values such as "10px" are parsed to Float;
                    // complex values such as "rotate(1rad)" are returned as-is.
                    result = jQuery.css(tween.elem, tween.prop, "");
                    // Empty strings, null, undefined and "auto" are converted to 0.
                    return !result || result === "auto" ? 0 : result;
                },
                set: function (tween) {
                    // Use step hook for back compat.
                    // Use cssHook if its there.
                    // Use .style if available and use plain properties where available.
                    if (jQuery.fx.step[tween.prop]) {
                        jQuery.fx.step[tween.prop](tween);
                    }
                    else if (tween.elem.nodeType === 1 &&
                        (tween.elem.style[jQuery.cssProps[tween.prop]] != null ||
                            jQuery.cssHooks[tween.prop])) {
                        jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                    }
                    else {
                        tween.elem[tween.prop] = tween.now;
                    }
                }
            }
        };
        // Support: IE <=9 only
        // Panic based approach to setting things on disconnected nodes
        Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
            set: function (tween) {
                if (tween.elem.nodeType && tween.elem.parentNode) {
                    tween.elem[tween.prop] = tween.now;
                }
            }
        };
        jQuery.easing = {
            linear: function (p) {
                return p;
            },
            swing: function (p) {
                return 0.5 - Math.cos(p * Math.PI) / 2;
            },
            _default: "swing"
        };
        jQuery.fx = Tween.prototype.init;
        // Back compat <1.8 extension point
        jQuery.fx.step = {};
        var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
        function schedule() {
            if (inProgress) {
                if (document.hidden === false && window.requestAnimationFrame) {
                    window.requestAnimationFrame(schedule);
                }
                else {
                    window.setTimeout(schedule, jQuery.fx.interval);
                }
                jQuery.fx.tick();
            }
        }
        // Animations created synchronously will run synchronously
        function createFxNow() {
            window.setTimeout(function () {
                fxNow = undefined;
            });
            return (fxNow = Date.now());
        }
        // Generate parameters to create a standard animation
        function genFx(type, includeWidth) {
            var which, i = 0, attrs = { height: type };
            // If we include width, step value is 1 to do all cssExpand values,
            // otherwise step value is 2 to skip over Left and Right
            includeWidth = includeWidth ? 1 : 0;
            for (; i < 4; i += 2 - includeWidth) {
                which = cssExpand[i];
                attrs["margin" + which] = attrs["padding" + which] = type;
            }
            if (includeWidth) {
                attrs.opacity = attrs.width = type;
            }
            return attrs;
        }
        function createTween(value, prop, animation) {
            var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
            for (; index < length; index++) {
                if ((tween = collection[index].call(animation, prop, value))) {
                    // We're done with this property
                    return tween;
                }
            }
        }
        function defaultPrefilter(elem, props, opts) {
            var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
            // Queue-skipping animations hijack the fx hooks
            if (!opts.queue) {
                hooks = jQuery._queueHooks(elem, "fx");
                if (hooks.unqueued == null) {
                    hooks.unqueued = 0;
                    oldfire = hooks.empty.fire;
                    hooks.empty.fire = function () {
                        if (!hooks.unqueued) {
                            oldfire();
                        }
                    };
                }
                hooks.unqueued++;
                anim.always(function () {
                    // Ensure the complete handler is called before this completes
                    anim.always(function () {
                        hooks.unqueued--;
                        if (!jQuery.queue(elem, "fx").length) {
                            hooks.empty.fire();
                        }
                    });
                });
            }
            // Detect show/hide animations
            for (prop in props) {
                value = props[prop];
                if (rfxtypes.test(value)) {
                    delete props[prop];
                    toggle = toggle || value === "toggle";
                    if (value === (hidden ? "hide" : "show")) {
                        // Pretend to be hidden if this is a "show" and
                        // there is still data from a stopped show/hide
                        if (value === "show" && dataShow && dataShow[prop] !== undefined) {
                            hidden = true;
                            // Ignore all other no-op show/hide data
                        }
                        else {
                            continue;
                        }
                    }
                    orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
                }
            }
            // Bail out if this is a no-op like .hide().hide()
            propTween = !jQuery.isEmptyObject(props);
            if (!propTween && jQuery.isEmptyObject(orig)) {
                return;
            }
            // Restrict "overflow" and "display" styles during box animations
            if (isBox && elem.nodeType === 1) {
                // Support: IE <=9 - 11, Edge 12 - 15
                // Record all 3 overflow attributes because IE does not infer the shorthand
                // from identically-valued overflowX and overflowY and Edge just mirrors
                // the overflowX value there.
                opts.overflow = [style.overflow, style.overflowX, style.overflowY];
                // Identify a display type, preferring old show/hide data over the CSS cascade
                restoreDisplay = dataShow && dataShow.display;
                if (restoreDisplay == null) {
                    restoreDisplay = dataPriv.get(elem, "display");
                }
                display = jQuery.css(elem, "display");
                if (display === "none") {
                    if (restoreDisplay) {
                        display = restoreDisplay;
                    }
                    else {
                        // Get nonempty value(s) by temporarily forcing visibility
                        showHide([elem], true);
                        restoreDisplay = elem.style.display || restoreDisplay;
                        display = jQuery.css(elem, "display");
                        showHide([elem]);
                    }
                }
                // Animate inline elements as inline-block
                if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                    if (jQuery.css(elem, "float") === "none") {
                        // Restore the original display value at the end of pure show/hide animations
                        if (!propTween) {
                            anim.done(function () {
                                style.display = restoreDisplay;
                            });
                            if (restoreDisplay == null) {
                                display = style.display;
                                restoreDisplay = display === "none" ? "" : display;
                            }
                        }
                        style.display = "inline-block";
                    }
                }
            }
            if (opts.overflow) {
                style.overflow = "hidden";
                anim.always(function () {
                    style.overflow = opts.overflow[0];
                    style.overflowX = opts.overflow[1];
                    style.overflowY = opts.overflow[2];
                });
            }
            // Implement show/hide animations
            propTween = false;
            for (prop in orig) {
                // General show/hide setup for this element animation
                if (!propTween) {
                    if (dataShow) {
                        if ("hidden" in dataShow) {
                            hidden = dataShow.hidden;
                        }
                    }
                    else {
                        dataShow = dataPriv.access(elem, "fxshow", { display: restoreDisplay });
                    }
                    // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                    if (toggle) {
                        dataShow.hidden = !hidden;
                    }
                    // Show elements before animating them
                    if (hidden) {
                        showHide([elem], true);
                    }
                    /* eslint-disable no-loop-func */
                    anim.done(function () {
                        /* eslint-enable no-loop-func */
                        // The final step of a "hide" animation is actually hiding the element
                        if (!hidden) {
                            showHide([elem]);
                        }
                        dataPriv.remove(elem, "fxshow");
                        for (prop in orig) {
                            jQuery.style(elem, prop, orig[prop]);
                        }
                    });
                }
                // Per-property setup
                propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
                if (!(prop in dataShow)) {
                    dataShow[prop] = propTween.start;
                    if (hidden) {
                        propTween.end = propTween.start;
                        propTween.start = 0;
                    }
                }
            }
        }
        function propFilter(props, specialEasing) {
            var index, name, easing, value, hooks;
            // camelCase, specialEasing and expand cssHook pass
            for (index in props) {
                name = camelCase(index);
                easing = specialEasing[name];
                value = props[index];
                if (Array.isArray(value)) {
                    easing = value[1];
                    value = props[index] = value[0];
                }
                if (index !== name) {
                    props[name] = value;
                    delete props[index];
                }
                hooks = jQuery.cssHooks[name];
                if (hooks && "expand" in hooks) {
                    value = hooks.expand(value);
                    delete props[name];
                    // Not quite $.extend, this won't overwrite existing keys.
                    // Reusing 'index' because we have the correct "name"
                    for (index in value) {
                        if (!(index in props)) {
                            props[index] = value[index];
                            specialEasing[index] = easing;
                        }
                    }
                }
                else {
                    specialEasing[name] = easing;
                }
            }
        }
        function Animation(elem, properties, options) {
            var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function () {
                // Don't match elem in the :animated selector
                delete tick.elem;
            }), tick = function () {
                if (stopped) {
                    return false;
                }
                var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), 
                // Support: Android 2.3 only
                // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
                temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
                for (; index < length; index++) {
                    animation.tweens[index].run(percent);
                }
                deferred.notifyWith(elem, [animation, percent, remaining]);
                // If there's more to do, yield
                if (percent < 1 && length) {
                    return remaining;
                }
                // If this was an empty animation, synthesize a final progress notification
                if (!length) {
                    deferred.notifyWith(elem, [animation, 1, 0]);
                }
                // Resolve the animation and report its conclusion
                deferred.resolveWith(elem, [animation]);
                return false;
            }, animation = deferred.promise({
                elem: elem,
                props: jQuery.extend({}, properties),
                opts: jQuery.extend(true, {
                    specialEasing: {},
                    easing: jQuery.easing._default
                }, options),
                originalProperties: properties,
                originalOptions: options,
                startTime: fxNow || createFxNow(),
                duration: options.duration,
                tweens: [],
                createTween: function (prop, end) {
                    var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                    animation.tweens.push(tween);
                    return tween;
                },
                stop: function (gotoEnd) {
                    var index = 0, 
                    // If we are going to the end, we want to run all the tweens
                    // otherwise we skip this part
                    length = gotoEnd ? animation.tweens.length : 0;
                    if (stopped) {
                        return this;
                    }
                    stopped = true;
                    for (; index < length; index++) {
                        animation.tweens[index].run(1);
                    }
                    // Resolve when we played the last frame; otherwise, reject
                    if (gotoEnd) {
                        deferred.notifyWith(elem, [animation, 1, 0]);
                        deferred.resolveWith(elem, [animation, gotoEnd]);
                    }
                    else {
                        deferred.rejectWith(elem, [animation, gotoEnd]);
                    }
                    return this;
                }
            }), props = animation.props;
            propFilter(props, animation.opts.specialEasing);
            for (; index < length; index++) {
                result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
                if (result) {
                    if (isFunction(result.stop)) {
                        jQuery._queueHooks(animation.elem, animation.opts.queue).stop =
                            result.stop.bind(result);
                    }
                    return result;
                }
            }
            jQuery.map(props, createTween, animation);
            if (isFunction(animation.opts.start)) {
                animation.opts.start.call(elem, animation);
            }
            // Attach callbacks from options
            animation
                .progress(animation.opts.progress)
                .done(animation.opts.done, animation.opts.complete)
                .fail(animation.opts.fail)
                .always(animation.opts.always);
            jQuery.fx.timer(jQuery.extend(tick, {
                elem: elem,
                anim: animation,
                queue: animation.opts.queue
            }));
            return animation;
        }
        jQuery.Animation = jQuery.extend(Animation, {
            tweeners: {
                "*": [function (prop, value) {
                        var tween = this.createTween(prop, value);
                        adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                        return tween;
                    }]
            },
            tweener: function (props, callback) {
                if (isFunction(props)) {
                    callback = props;
                    props = ["*"];
                }
                else {
                    props = props.match(rnothtmlwhite);
                }
                var prop, index = 0, length = props.length;
                for (; index < length; index++) {
                    prop = props[index];
                    Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                    Animation.tweeners[prop].unshift(callback);
                }
            },
            prefilters: [defaultPrefilter],
            prefilter: function (callback, prepend) {
                if (prepend) {
                    Animation.prefilters.unshift(callback);
                }
                else {
                    Animation.prefilters.push(callback);
                }
            }
        });
        jQuery.speed = function (speed, easing, fn) {
            var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
                complete: fn || !fn && easing ||
                    isFunction(speed) && speed,
                duration: speed,
                easing: fn && easing || easing && !isFunction(easing) && easing
            };
            // Go to the end state if fx are off
            if (jQuery.fx.off) {
                opt.duration = 0;
            }
            else {
                if (typeof opt.duration !== "number") {
                    if (opt.duration in jQuery.fx.speeds) {
                        opt.duration = jQuery.fx.speeds[opt.duration];
                    }
                    else {
                        opt.duration = jQuery.fx.speeds._default;
                    }
                }
            }
            // Normalize opt.queue - true/undefined/null -> "fx"
            if (opt.queue == null || opt.queue === true) {
                opt.queue = "fx";
            }
            // Queueing
            opt.old = opt.complete;
            opt.complete = function () {
                if (isFunction(opt.old)) {
                    opt.old.call(this);
                }
                if (opt.queue) {
                    jQuery.dequeue(this, opt.queue);
                }
            };
            return opt;
        };
        jQuery.fn.extend({
            fadeTo: function (speed, to, easing, callback) {
                // Show any hidden elements after setting opacity to 0
                return this.filter(isHiddenWithinTree).css("opacity", 0).show()
                    .end().animate({ opacity: to }, speed, easing, callback);
            },
            animate: function (prop, speed, easing, callback) {
                var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function () {
                    // Operate on a copy of prop so per-property easing won't be lost
                    var anim = Animation(this, jQuery.extend({}, prop), optall);
                    // Empty animations, or finishing resolves immediately
                    if (empty || dataPriv.get(this, "finish")) {
                        anim.stop(true);
                    }
                };
                doAnimation.finish = doAnimation;
                return empty || optall.queue === false ?
                    this.each(doAnimation) :
                    this.queue(optall.queue, doAnimation);
            },
            stop: function (type, clearQueue, gotoEnd) {
                var stopQueue = function (hooks) {
                    var stop = hooks.stop;
                    delete hooks.stop;
                    stop(gotoEnd);
                };
                if (typeof type !== "string") {
                    gotoEnd = clearQueue;
                    clearQueue = type;
                    type = undefined;
                }
                if (clearQueue && type !== false) {
                    this.queue(type || "fx", []);
                }
                return this.each(function () {
                    var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                    if (index) {
                        if (data[index] && data[index].stop) {
                            stopQueue(data[index]);
                        }
                    }
                    else {
                        for (index in data) {
                            if (data[index] && data[index].stop && rrun.test(index)) {
                                stopQueue(data[index]);
                            }
                        }
                    }
                    for (index = timers.length; index--;) {
                        if (timers[index].elem === this &&
                            (type == null || timers[index].queue === type)) {
                            timers[index].anim.stop(gotoEnd);
                            dequeue = false;
                            timers.splice(index, 1);
                        }
                    }
                    // Start the next in the queue if the last step wasn't forced.
                    // Timers currently will call their complete callbacks, which
                    // will dequeue but only if they were gotoEnd.
                    if (dequeue || !gotoEnd) {
                        jQuery.dequeue(this, type);
                    }
                });
            },
            finish: function (type) {
                if (type !== false) {
                    type = type || "fx";
                }
                return this.each(function () {
                    var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                    // Enable finishing flag on private data
                    data.finish = true;
                    // Empty the queue first
                    jQuery.queue(this, type, []);
                    if (hooks && hooks.stop) {
                        hooks.stop.call(this, true);
                    }
                    // Look for any active animations, and finish them
                    for (index = timers.length; index--;) {
                        if (timers[index].elem === this && timers[index].queue === type) {
                            timers[index].anim.stop(true);
                            timers.splice(index, 1);
                        }
                    }
                    // Look for any animations in the old queue and finish them
                    for (index = 0; index < length; index++) {
                        if (queue[index] && queue[index].finish) {
                            queue[index].finish.call(this);
                        }
                    }
                    // Turn off finishing flag
                    delete data.finish;
                });
            }
        });
        jQuery.each(["toggle", "show", "hide"], function (i, name) {
            var cssFn = jQuery.fn[name];
            jQuery.fn[name] = function (speed, easing, callback) {
                return speed == null || typeof speed === "boolean" ?
                    cssFn.apply(this, arguments) :
                    this.animate(genFx(name, true), speed, easing, callback);
            };
        });
        // Generate shortcuts for custom animations
        jQuery.each({
            slideDown: genFx("show"),
            slideUp: genFx("hide"),
            slideToggle: genFx("toggle"),
            fadeIn: { opacity: "show" },
            fadeOut: { opacity: "hide" },
            fadeToggle: { opacity: "toggle" }
        }, function (name, props) {
            jQuery.fn[name] = function (speed, easing, callback) {
                return this.animate(props, speed, easing, callback);
            };
        });
        jQuery.timers = [];
        jQuery.fx.tick = function () {
            var timer, i = 0, timers = jQuery.timers;
            fxNow = Date.now();
            for (; i < timers.length; i++) {
                timer = timers[i];
                // Run the timer and safely remove it when done (allowing for external removal)
                if (!timer() && timers[i] === timer) {
                    timers.splice(i--, 1);
                }
            }
            if (!timers.length) {
                jQuery.fx.stop();
            }
            fxNow = undefined;
        };
        jQuery.fx.timer = function (timer) {
            jQuery.timers.push(timer);
            jQuery.fx.start();
        };
        jQuery.fx.interval = 13;
        jQuery.fx.start = function () {
            if (inProgress) {
                return;
            }
            inProgress = true;
            schedule();
        };
        jQuery.fx.stop = function () {
            inProgress = null;
        };
        jQuery.fx.speeds = {
            slow: 600,
            fast: 200,
            // Default speed
            _default: 400
        };
        // Based off of the plugin by Clint Helfers, with permission.
        // https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
        jQuery.fn.delay = function (time, type) {
            time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
            type = type || "fx";
            return this.queue(type, function (next, hooks) {
                var timeout = window.setTimeout(next, time);
                hooks.stop = function () {
                    window.clearTimeout(timeout);
                };
            });
        };
        (function () {
            var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
            input.type = "checkbox";
            // Support: Android <=4.3 only
            // Default value for a checkbox should be "on"
            support.checkOn = input.value !== "";
            // Support: IE <=11 only
            // Must access selectedIndex to make default options select
            support.optSelected = opt.selected;
            // Support: IE <=11 only
            // An input loses its value after becoming a radio
            input = document.createElement("input");
            input.value = "t";
            input.type = "radio";
            support.radioValue = input.value === "t";
        })();
        var boolHook, attrHandle = jQuery.expr.attrHandle;
        jQuery.fn.extend({
            attr: function (name, value) {
                return access(this, jQuery.attr, name, value, arguments.length > 1);
            },
            removeAttr: function (name) {
                return this.each(function () {
                    jQuery.removeAttr(this, name);
                });
            }
        });
        jQuery.extend({
            attr: function (elem, name, value) {
                var ret, hooks, nType = elem.nodeType;
                // Don't get/set attributes on text, comment and attribute nodes
                if (nType === 3 || nType === 8 || nType === 2) {
                    return;
                }
                // Fallback to prop when attributes are not supported
                if (typeof elem.getAttribute === "undefined") {
                    return jQuery.prop(elem, name, value);
                }
                // Attribute hooks are determined by the lowercase version
                // Grab necessary hook if one is defined
                if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                    hooks = jQuery.attrHooks[name.toLowerCase()] ||
                        (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
                }
                if (value !== undefined) {
                    if (value === null) {
                        jQuery.removeAttr(elem, name);
                        return;
                    }
                    if (hooks && "set" in hooks &&
                        (ret = hooks.set(elem, value, name)) !== undefined) {
                        return ret;
                    }
                    elem.setAttribute(name, value + "");
                    return value;
                }
                if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
                    return ret;
                }
                ret = jQuery.find.attr(elem, name);
                // Non-existent attributes return null, we normalize to undefined
                return ret == null ? undefined : ret;
            },
            attrHooks: {
                type: {
                    set: function (elem, value) {
                        if (!support.radioValue && value === "radio" &&
                            nodeName(elem, "input")) {
                            var val = elem.value;
                            elem.setAttribute("type", value);
                            if (val) {
                                elem.value = val;
                            }
                            return value;
                        }
                    }
                }
            },
            removeAttr: function (elem, value) {
                var name, i = 0, 
                // Attribute names can contain non-HTML whitespace characters
                // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
                attrNames = value && value.match(rnothtmlwhite);
                if (attrNames && elem.nodeType === 1) {
                    while ((name = attrNames[i++])) {
                        elem.removeAttribute(name);
                    }
                }
            }
        });
        // Hooks for boolean attributes
        boolHook = {
            set: function (elem, value, name) {
                if (value === false) {
                    // Remove boolean attributes when set to false
                    jQuery.removeAttr(elem, name);
                }
                else {
                    elem.setAttribute(name, name);
                }
                return name;
            }
        };
        jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (i, name) {
            var getter = attrHandle[name] || jQuery.find.attr;
            attrHandle[name] = function (elem, name, isXML) {
                var ret, handle, lowercaseName = name.toLowerCase();
                if (!isXML) {
                    // Avoid an infinite loop by temporarily removing this function from the getter
                    handle = attrHandle[lowercaseName];
                    attrHandle[lowercaseName] = ret;
                    ret = getter(elem, name, isXML) != null ?
                        lowercaseName :
                        null;
                    attrHandle[lowercaseName] = handle;
                }
                return ret;
            };
        });
        var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
        jQuery.fn.extend({
            prop: function (name, value) {
                return access(this, jQuery.prop, name, value, arguments.length > 1);
            },
            removeProp: function (name) {
                return this.each(function () {
                    delete this[jQuery.propFix[name] || name];
                });
            }
        });
        jQuery.extend({
            prop: function (elem, name, value) {
                var ret, hooks, nType = elem.nodeType;
                // Don't get/set properties on text, comment and attribute nodes
                if (nType === 3 || nType === 8 || nType === 2) {
                    return;
                }
                if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                    // Fix name and attach hooks
                    name = jQuery.propFix[name] || name;
                    hooks = jQuery.propHooks[name];
                }
                if (value !== undefined) {
                    if (hooks && "set" in hooks &&
                        (ret = hooks.set(elem, value, name)) !== undefined) {
                        return ret;
                    }
                    return (elem[name] = value);
                }
                if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
                    return ret;
                }
                return elem[name];
            },
            propHooks: {
                tabIndex: {
                    get: function (elem) {
                        // Support: IE <=9 - 11 only
                        // elem.tabIndex doesn't always return the
                        // correct value when it hasn't been explicitly set
                        // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                        // Use proper attribute retrieval(#12072)
                        var tabindex = jQuery.find.attr(elem, "tabindex");
                        if (tabindex) {
                            return parseInt(tabindex, 10);
                        }
                        if (rfocusable.test(elem.nodeName) ||
                            rclickable.test(elem.nodeName) &&
                                elem.href) {
                            return 0;
                        }
                        return -1;
                    }
                }
            },
            propFix: {
                "for": "htmlFor",
                "class": "className"
            }
        });
        // Support: IE <=11 only
        // Accessing the selectedIndex property
        // forces the browser to respect setting selected
        // on the option
        // The getter ensures a default option is selected
        // when in an optgroup
        // eslint rule "no-unused-expressions" is disabled for this code
        // since it considers such accessions noop
        if (!support.optSelected) {
            jQuery.propHooks.selected = {
                get: function (elem) {
                    /* eslint no-unused-expressions: "off" */
                    var parent = elem.parentNode;
                    if (parent && parent.parentNode) {
                        parent.parentNode.selectedIndex;
                    }
                    return null;
                },
                set: function (elem) {
                    /* eslint no-unused-expressions: "off" */
                    var parent = elem.parentNode;
                    if (parent) {
                        parent.selectedIndex;
                        if (parent.parentNode) {
                            parent.parentNode.selectedIndex;
                        }
                    }
                }
            };
        }
        jQuery.each([
            "tabIndex",
            "readOnly",
            "maxLength",
            "cellSpacing",
            "cellPadding",
            "rowSpan",
            "colSpan",
            "useMap",
            "frameBorder",
            "contentEditable"
        ], function () {
            jQuery.propFix[this.toLowerCase()] = this;
        });
        // Strip and collapse whitespace according to HTML spec
        // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
        function stripAndCollapse(value) {
            var tokens = value.match(rnothtmlwhite) || [];
            return tokens.join(" ");
        }
        function getClass(elem) {
            return elem.getAttribute && elem.getAttribute("class") || "";
        }
        function classesToArray(value) {
            if (Array.isArray(value)) {
                return value;
            }
            if (typeof value === "string") {
                return value.match(rnothtmlwhite) || [];
            }
            return [];
        }
        jQuery.fn.extend({
            addClass: function (value) {
                var classes, elem, cur, curValue, clazz, j, finalValue, i = 0;
                if (isFunction(value)) {
                    return this.each(function (j) {
                        jQuery(this).addClass(value.call(this, j, getClass(this)));
                    });
                }
                classes = classesToArray(value);
                if (classes.length) {
                    while ((elem = this[i++])) {
                        curValue = getClass(elem);
                        cur = elem.nodeType === 1 && (" " + stripAndCollapse(curValue) + " ");
                        if (cur) {
                            j = 0;
                            while ((clazz = classes[j++])) {
                                if (cur.indexOf(" " + clazz + " ") < 0) {
                                    cur += clazz + " ";
                                }
                            }
                            // Only assign if different to avoid unneeded rendering.
                            finalValue = stripAndCollapse(cur);
                            if (curValue !== finalValue) {
                                elem.setAttribute("class", finalValue);
                            }
                        }
                    }
                }
                return this;
            },
            removeClass: function (value) {
                var classes, elem, cur, curValue, clazz, j, finalValue, i = 0;
                if (isFunction(value)) {
                    return this.each(function (j) {
                        jQuery(this).removeClass(value.call(this, j, getClass(this)));
                    });
                }
                if (!arguments.length) {
                    return this.attr("class", "");
                }
                classes = classesToArray(value);
                if (classes.length) {
                    while ((elem = this[i++])) {
                        curValue = getClass(elem);
                        // This expression is here for better compressibility (see addClass)
                        cur = elem.nodeType === 1 && (" " + stripAndCollapse(curValue) + " ");
                        if (cur) {
                            j = 0;
                            while ((clazz = classes[j++])) {
                                // Remove *all* instances
                                while (cur.indexOf(" " + clazz + " ") > -1) {
                                    cur = cur.replace(" " + clazz + " ", " ");
                                }
                            }
                            // Only assign if different to avoid unneeded rendering.
                            finalValue = stripAndCollapse(cur);
                            if (curValue !== finalValue) {
                                elem.setAttribute("class", finalValue);
                            }
                        }
                    }
                }
                return this;
            },
            toggleClass: function (value, stateVal) {
                var type = typeof value, isValidValue = type === "string" || Array.isArray(value);
                if (typeof stateVal === "boolean" && isValidValue) {
                    return stateVal ? this.addClass(value) : this.removeClass(value);
                }
                if (isFunction(value)) {
                    return this.each(function (i) {
                        jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
                    });
                }
                return this.each(function () {
                    var className, i, self, classNames;
                    if (isValidValue) {
                        // Toggle individual class names
                        i = 0;
                        self = jQuery(this);
                        classNames = classesToArray(value);
                        while ((className = classNames[i++])) {
                            // Check each className given, space separated list
                            if (self.hasClass(className)) {
                                self.removeClass(className);
                            }
                            else {
                                self.addClass(className);
                            }
                        }
                        // Toggle whole class name
                    }
                    else if (value === undefined || type === "boolean") {
                        className = getClass(this);
                        if (className) {
                            // Store className if set
                            dataPriv.set(this, "__className__", className);
                        }
                        // If the element has a class name or if we're passed `false`,
                        // then remove the whole classname (if there was one, the above saved it).
                        // Otherwise bring back whatever was previously saved (if anything),
                        // falling back to the empty string if nothing was stored.
                        if (this.setAttribute) {
                            this.setAttribute("class", className || value === false ?
                                "" :
                                dataPriv.get(this, "__className__") || "");
                        }
                    }
                });
            },
            hasClass: function (selector) {
                var className, elem, i = 0;
                className = " " + selector + " ";
                while ((elem = this[i++])) {
                    if (elem.nodeType === 1 &&
                        (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
                        return true;
                    }
                }
                return false;
            }
        });
        var rreturn = /\r/g;
        jQuery.fn.extend({
            val: function (value) {
                var hooks, ret, valueIsFunction, elem = this[0];
                if (!arguments.length) {
                    if (elem) {
                        hooks = jQuery.valHooks[elem.type] ||
                            jQuery.valHooks[elem.nodeName.toLowerCase()];
                        if (hooks &&
                            "get" in hooks &&
                            (ret = hooks.get(elem, "value")) !== undefined) {
                            return ret;
                        }
                        ret = elem.value;
                        // Handle most common string cases
                        if (typeof ret === "string") {
                            return ret.replace(rreturn, "");
                        }
                        // Handle cases where value is null/undef or number
                        return ret == null ? "" : ret;
                    }
                    return;
                }
                valueIsFunction = isFunction(value);
                return this.each(function (i) {
                    var val;
                    if (this.nodeType !== 1) {
                        return;
                    }
                    if (valueIsFunction) {
                        val = value.call(this, i, jQuery(this).val());
                    }
                    else {
                        val = value;
                    }
                    // Treat null/undefined as ""; convert numbers to string
                    if (val == null) {
                        val = "";
                    }
                    else if (typeof val === "number") {
                        val += "";
                    }
                    else if (Array.isArray(val)) {
                        val = jQuery.map(val, function (value) {
                            return value == null ? "" : value + "";
                        });
                    }
                    hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                    // If set returns undefined, fall back to normal setting
                    if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
                        this.value = val;
                    }
                });
            }
        });
        jQuery.extend({
            valHooks: {
                option: {
                    get: function (elem) {
                        var val = jQuery.find.attr(elem, "value");
                        return val != null ?
                            val :
                            // Support: IE <=10 - 11 only
                            // option.text throws exceptions (#14686, #14858)
                            // Strip and collapse whitespace
                            // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                            stripAndCollapse(jQuery.text(elem));
                    }
                },
                select: {
                    get: function (elem) {
                        var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                        if (index < 0) {
                            i = max;
                        }
                        else {
                            i = one ? index : 0;
                        }
                        // Loop through all the selected options
                        for (; i < max; i++) {
                            option = options[i];
                            // Support: IE <=9 only
                            // IE8-9 doesn't update selected after form reset (#2551)
                            if ((option.selected || i === index) &&
                                // Don't return options that are disabled or in a disabled optgroup
                                !option.disabled &&
                                (!option.parentNode.disabled ||
                                    !nodeName(option.parentNode, "optgroup"))) {
                                // Get the specific value for the option
                                value = jQuery(option).val();
                                // We don't need an array for one selects
                                if (one) {
                                    return value;
                                }
                                // Multi-Selects return an array
                                values.push(value);
                            }
                        }
                        return values;
                    },
                    set: function (elem, value) {
                        var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                        while (i--) {
                            option = options[i];
                            /* eslint-disable no-cond-assign */
                            if (option.selected =
                                jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
                                optionSet = true;
                            }
                            /* eslint-enable no-cond-assign */
                        }
                        // Force browsers to behave consistently when non-matching value is set
                        if (!optionSet) {
                            elem.selectedIndex = -1;
                        }
                        return values;
                    }
                }
            }
        });
        // Radios and checkboxes getter/setter
        jQuery.each(["radio", "checkbox"], function () {
            jQuery.valHooks[this] = {
                set: function (elem, value) {
                    if (Array.isArray(value)) {
                        return (elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1);
                    }
                }
            };
            if (!support.checkOn) {
                jQuery.valHooks[this].get = function (elem) {
                    return elem.getAttribute("value") === null ? "on" : elem.value;
                };
            }
        });
        // Return jQuery for attributes-only inclusion
        support.focusin = "onfocusin" in window;
        var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function (e) {
            e.stopPropagation();
        };
        jQuery.extend(jQuery.event, {
            trigger: function (event, data, elem, onlyHandlers) {
                var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [elem || document], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
                cur = lastElement = tmp = elem = elem || document;
                // Don't do events on text and comment nodes
                if (elem.nodeType === 3 || elem.nodeType === 8) {
                    return;
                }
                // focus/blur morphs to focusin/out; ensure we're not firing them right now
                if (rfocusMorph.test(type + jQuery.event.triggered)) {
                    return;
                }
                if (type.indexOf(".") > -1) {
                    // Namespaced trigger; create a regexp to match event type in handle()
                    namespaces = type.split(".");
                    type = namespaces.shift();
                    namespaces.sort();
                }
                ontype = type.indexOf(":") < 0 && "on" + type;
                // Caller can pass in a jQuery.Event object, Object, or just an event type string
                event = event[jQuery.expando] ?
                    event :
                    new jQuery.Event(type, typeof event === "object" && event);
                // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
                event.isTrigger = onlyHandlers ? 2 : 3;
                event.namespace = namespaces.join(".");
                event.rnamespace = event.namespace ?
                    new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") :
                    null;
                // Clean up the event in case it is being reused
                event.result = undefined;
                if (!event.target) {
                    event.target = elem;
                }
                // Clone any incoming data and prepend the event, creating the handler arg list
                data = data == null ?
                    [event] :
                    jQuery.makeArray(data, [event]);
                // Allow special events to draw outside the lines
                special = jQuery.event.special[type] || {};
                if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
                    return;
                }
                // Determine event propagation path in advance, per W3C events spec (#9951)
                // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
                if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                    bubbleType = special.delegateType || type;
                    if (!rfocusMorph.test(bubbleType + type)) {
                        cur = cur.parentNode;
                    }
                    for (; cur; cur = cur.parentNode) {
                        eventPath.push(cur);
                        tmp = cur;
                    }
                    // Only add window if we got to document (e.g., not plain obj or detached DOM)
                    if (tmp === (elem.ownerDocument || document)) {
                        eventPath.push(tmp.defaultView || tmp.parentWindow || window);
                    }
                }
                // Fire handlers on the event path
                i = 0;
                while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
                    lastElement = cur;
                    event.type = i > 1 ?
                        bubbleType :
                        special.bindType || type;
                    // jQuery handler
                    handle = (dataPriv.get(cur, "events") || {})[event.type] &&
                        dataPriv.get(cur, "handle");
                    if (handle) {
                        handle.apply(cur, data);
                    }
                    // Native handler
                    handle = ontype && cur[ontype];
                    if (handle && handle.apply && acceptData(cur)) {
                        event.result = handle.apply(cur, data);
                        if (event.result === false) {
                            event.preventDefault();
                        }
                    }
                }
                event.type = type;
                // If nobody prevented the default action, do it now
                if (!onlyHandlers && !event.isDefaultPrevented()) {
                    if ((!special._default ||
                        special._default.apply(eventPath.pop(), data) === false) &&
                        acceptData(elem)) {
                        // Call a native DOM method on the target with the same name as the event.
                        // Don't do default actions on window, that's where global variables be (#6170)
                        if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                            // Don't re-trigger an onFOO event when we call its FOO() method
                            tmp = elem[ontype];
                            if (tmp) {
                                elem[ontype] = null;
                            }
                            // Prevent re-triggering of the same event, since we already bubbled it above
                            jQuery.event.triggered = type;
                            if (event.isPropagationStopped()) {
                                lastElement.addEventListener(type, stopPropagationCallback);
                            }
                            elem[type]();
                            if (event.isPropagationStopped()) {
                                lastElement.removeEventListener(type, stopPropagationCallback);
                            }
                            jQuery.event.triggered = undefined;
                            if (tmp) {
                                elem[ontype] = tmp;
                            }
                        }
                    }
                }
                return event.result;
            },
            // Piggyback on a donor event to simulate a different one
            // Used only for `focus(in | out)` events
            simulate: function (type, elem, event) {
                var e = jQuery.extend(new jQuery.Event(), event, {
                    type: type,
                    isSimulated: true
                });
                jQuery.event.trigger(e, null, elem);
            }
        });
        jQuery.fn.extend({
            trigger: function (type, data) {
                return this.each(function () {
                    jQuery.event.trigger(type, data, this);
                });
            },
            triggerHandler: function (type, data) {
                var elem = this[0];
                if (elem) {
                    return jQuery.event.trigger(type, data, elem, true);
                }
            }
        });
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        if (!support.focusin) {
            jQuery.each({ focus: "focusin", blur: "focusout" }, function (orig, fix) {
                // Attach a single capturing handler on the document while someone wants focusin/focusout
                var handler = function (event) {
                    jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
                };
                jQuery.event.special[fix] = {
                    setup: function () {
                        var doc = this.ownerDocument || this, attaches = dataPriv.access(doc, fix);
                        if (!attaches) {
                            doc.addEventListener(orig, handler, true);
                        }
                        dataPriv.access(doc, fix, (attaches || 0) + 1);
                    },
                    teardown: function () {
                        var doc = this.ownerDocument || this, attaches = dataPriv.access(doc, fix) - 1;
                        if (!attaches) {
                            doc.removeEventListener(orig, handler, true);
                            dataPriv.remove(doc, fix);
                        }
                        else {
                            dataPriv.access(doc, fix, attaches);
                        }
                    }
                };
            });
        }
        var location = window.location;
        var nonce = Date.now();
        var rquery = (/\?/);
        // Cross-browser xml parsing
        jQuery.parseXML = function (data) {
            var xml;
            if (!data || typeof data !== "string") {
                return null;
            }
            // Support: IE 9 - 11 only
            // IE throws on parseFromString with invalid input.
            try {
                xml = (new window.DOMParser()).parseFromString(data, "text/xml");
            }
            catch (e) {
                xml = undefined;
            }
            if (!xml || xml.getElementsByTagName("parsererror").length) {
                jQuery.error("Invalid XML: " + data);
            }
            return xml;
        };
        var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
        function buildParams(prefix, obj, traditional, add) {
            var name;
            if (Array.isArray(obj)) {
                // Serialize array item.
                jQuery.each(obj, function (i, v) {
                    if (traditional || rbracket.test(prefix)) {
                        // Treat each array item as a scalar.
                        add(prefix, v);
                    }
                    else {
                        // Item is non-scalar (array or object), encode its numeric index.
                        buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
                    }
                });
            }
            else if (!traditional && toType(obj) === "object") {
                // Serialize object item.
                for (name in obj) {
                    buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
                }
            }
            else {
                // Serialize scalar item.
                add(prefix, obj);
            }
        }
        // Serialize an array of form elements or a set of
        // key/values into a query string
        jQuery.param = function (a, traditional) {
            var prefix, s = [], add = function (key, valueOrFunction) {
                // If value is a function, invoke it and use its return value
                var value = isFunction(valueOrFunction) ?
                    valueOrFunction() :
                    valueOrFunction;
                s[s.length] = encodeURIComponent(key) + "=" +
                    encodeURIComponent(value == null ? "" : value);
            };
            // If an array was passed in, assume that it is an array of form elements.
            if (Array.isArray(a) || (a.jquery && !jQuery.isPlainObject(a))) {
                // Serialize the form elements
                jQuery.each(a, function () {
                    add(this.name, this.value);
                });
            }
            else {
                // If traditional, encode the "old" way (the way 1.3.2 or older
                // did it), otherwise encode params recursively.
                for (prefix in a) {
                    buildParams(prefix, a[prefix], traditional, add);
                }
            }
            // Return the resulting serialization
            return s.join("&");
        };
        jQuery.fn.extend({
            serialize: function () {
                return jQuery.param(this.serializeArray());
            },
            serializeArray: function () {
                return this.map(function () {
                    // Can add propHook for "elements" to filter or add form elements
                    var elements = jQuery.prop(this, "elements");
                    return elements ? jQuery.makeArray(elements) : this;
                })
                    .filter(function () {
                    var type = this.type;
                    // Use .is( ":disabled" ) so that fieldset[disabled] works
                    return this.name && !jQuery(this).is(":disabled") &&
                        rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) &&
                        (this.checked || !rcheckableType.test(type));
                })
                    .map(function (i, elem) {
                    var val = jQuery(this).val();
                    if (val == null) {
                        return null;
                    }
                    if (Array.isArray(val)) {
                        return jQuery.map(val, function (val) {
                            return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
                        });
                    }
                    return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
                }).get();
            }
        });
        var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, 
        // #7653, #8125, #8152: local protocol detection
        rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, 
        /* Prefilters
         * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
         * 2) These are called:
         *    - BEFORE asking for a transport
         *    - AFTER param serialization (s.data is a string if s.processData is true)
         * 3) key is the dataType
         * 4) the catchall symbol "*" can be used
         * 5) execution will start with transport dataType and THEN continue down to "*" if needed
         */
        prefilters = {}, 
        /* Transports bindings
         * 1) key is the dataType
         * 2) the catchall symbol "*" can be used
         * 3) selection will start with transport dataType and THEN go to "*" if needed
         */
        transports = {}, 
        // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
        allTypes = "*/".concat("*"), 
        // Anchor tag for parsing the document origin
        originAnchor = document.createElement("a");
        originAnchor.href = location.href;
        // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
        function addToPrefiltersOrTransports(structure) {
            // dataTypeExpression is optional and defaults to "*"
            return function (dataTypeExpression, func) {
                if (typeof dataTypeExpression !== "string") {
                    func = dataTypeExpression;
                    dataTypeExpression = "*";
                }
                var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
                if (isFunction(func)) {
                    // For each dataType in the dataTypeExpression
                    while ((dataType = dataTypes[i++])) {
                        // Prepend if requested
                        if (dataType[0] === "+") {
                            dataType = dataType.slice(1) || "*";
                            (structure[dataType] = structure[dataType] || []).unshift(func);
                            // Otherwise append
                        }
                        else {
                            (structure[dataType] = structure[dataType] || []).push(func);
                        }
                    }
                }
            };
        }
        // Base inspection function for prefilters and transports
        function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
            var inspected = {}, seekingTransport = (structure === transports);
            function inspect(dataType) {
                var selected;
                inspected[dataType] = true;
                jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
                    var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                    if (typeof dataTypeOrTransport === "string" &&
                        !seekingTransport && !inspected[dataTypeOrTransport]) {
                        options.dataTypes.unshift(dataTypeOrTransport);
                        inspect(dataTypeOrTransport);
                        return false;
                    }
                    else if (seekingTransport) {
                        return !(selected = dataTypeOrTransport);
                    }
                });
                return selected;
            }
            return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
        }
        // A special extend for ajax options
        // that takes "flat" options (not to be deep extended)
        // Fixes #9887
        function ajaxExtend(target, src) {
            var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
            for (key in src) {
                if (src[key] !== undefined) {
                    (flatOptions[key] ? target : (deep || (deep = {})))[key] = src[key];
                }
            }
            if (deep) {
                jQuery.extend(true, target, deep);
            }
            return target;
        }
        /* Handles responses to an ajax request:
         * - finds the right dataType (mediates between content-type and expected dataType)
         * - returns the corresponding response
         */
        function ajaxHandleResponses(s, jqXHR, responses) {
            var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
            // Remove auto dataType and get content-type in the process
            while (dataTypes[0] === "*") {
                dataTypes.shift();
                if (ct === undefined) {
                    ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
                }
            }
            // Check if we're dealing with a known content-type
            if (ct) {
                for (type in contents) {
                    if (contents[type] && contents[type].test(ct)) {
                        dataTypes.unshift(type);
                        break;
                    }
                }
            }
            // Check to see if we have a response for the expected dataType
            if (dataTypes[0] in responses) {
                finalDataType = dataTypes[0];
            }
            else {
                // Try convertible dataTypes
                for (type in responses) {
                    if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                        finalDataType = type;
                        break;
                    }
                    if (!firstDataType) {
                        firstDataType = type;
                    }
                }
                // Or just use first one
                finalDataType = finalDataType || firstDataType;
            }
            // If we found a dataType
            // We add the dataType to the list if needed
            // and return the corresponding response
            if (finalDataType) {
                if (finalDataType !== dataTypes[0]) {
                    dataTypes.unshift(finalDataType);
                }
                return responses[finalDataType];
            }
        }
        /* Chain conversions given the request and the original response
         * Also sets the responseXXX fields on the jqXHR instance
         */
        function ajaxConvert(s, response, jqXHR, isSuccess) {
            var conv2, current, conv, tmp, prev, converters = {}, 
            // Work with a copy of dataTypes in case we need to modify it for conversion
            dataTypes = s.dataTypes.slice();
            // Create converters map with lowercased keys
            if (dataTypes[1]) {
                for (conv in s.converters) {
                    converters[conv.toLowerCase()] = s.converters[conv];
                }
            }
            current = dataTypes.shift();
            // Convert to each sequential dataType
            while (current) {
                if (s.responseFields[current]) {
                    jqXHR[s.responseFields[current]] = response;
                }
                // Apply the dataFilter if provided
                if (!prev && isSuccess && s.dataFilter) {
                    response = s.dataFilter(response, s.dataType);
                }
                prev = current;
                current = dataTypes.shift();
                if (current) {
                    // There's only work to do if current dataType is non-auto
                    if (current === "*") {
                        current = prev;
                        // Convert response if prev dataType is non-auto and differs from current
                    }
                    else if (prev !== "*" && prev !== current) {
                        // Seek a direct converter
                        conv = converters[prev + " " + current] || converters["* " + current];
                        // If none found, seek a pair
                        if (!conv) {
                            for (conv2 in converters) {
                                // If conv2 outputs current
                                tmp = conv2.split(" ");
                                if (tmp[1] === current) {
                                    // If prev can be converted to accepted input
                                    conv = converters[prev + " " + tmp[0]] ||
                                        converters["* " + tmp[0]];
                                    if (conv) {
                                        // Condense equivalence converters
                                        if (conv === true) {
                                            conv = converters[conv2];
                                            // Otherwise, insert the intermediate dataType
                                        }
                                        else if (converters[conv2] !== true) {
                                            current = tmp[0];
                                            dataTypes.unshift(tmp[1]);
                                        }
                                        break;
                                    }
                                }
                            }
                        }
                        // Apply converter (if not an equivalence)
                        if (conv !== true) {
                            // Unless errors are allowed to bubble, catch and return them
                            if (conv && s.throws) {
                                response = conv(response);
                            }
                            else {
                                try {
                                    response = conv(response);
                                }
                                catch (e) {
                                    return {
                                        state: "parsererror",
                                        error: conv ? e : "No conversion from " + prev + " to " + current
                                    };
                                }
                            }
                        }
                    }
                }
            }
            return { state: "success", data: response };
        }
        jQuery.extend({
            // Counter for holding the number of active queries
            active: 0,
            // Last-Modified header cache for next request
            lastModified: {},
            etag: {},
            ajaxSettings: {
                url: location.href,
                type: "GET",
                isLocal: rlocalProtocol.test(location.protocol),
                global: true,
                processData: true,
                async: true,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                /*
                timeout: 0,
                data: null,
                dataType: null,
                username: null,
                password: null,
                cache: null,
                throws: false,
                traditional: false,
                headers: {},
                */
                accepts: {
                    "*": allTypes,
                    text: "text/plain",
                    html: "text/html",
                    xml: "application/xml, text/xml",
                    json: "application/json, text/javascript"
                },
                contents: {
                    xml: /\bxml\b/,
                    html: /\bhtml/,
                    json: /\bjson\b/
                },
                responseFields: {
                    xml: "responseXML",
                    text: "responseText",
                    json: "responseJSON"
                },
                // Data converters
                // Keys separate source (or catchall "*") and destination types with a single space
                converters: {
                    // Convert anything to text
                    "* text": String,
                    // Text to html (true = no transformation)
                    "text html": true,
                    // Evaluate text as a json expression
                    "text json": JSON.parse,
                    // Parse text as xml
                    "text xml": jQuery.parseXML
                },
                // For options that shouldn't be deep extended:
                // you can add your own custom options here if
                // and when you create one that shouldn't be
                // deep extended (see ajaxExtend)
                flatOptions: {
                    url: true,
                    context: true
                }
            },
            // Creates a full fledged settings object into target
            // with both ajaxSettings and settings fields.
            // If target is omitted, writes into ajaxSettings.
            ajaxSetup: function (target, settings) {
                return settings ?
                    // Building a settings object
                    ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) :
                    // Extending ajaxSettings
                    ajaxExtend(jQuery.ajaxSettings, target);
            },
            ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
            ajaxTransport: addToPrefiltersOrTransports(transports),
            // Main method
            ajax: function (url, options) {
                // If url is an object, simulate pre-1.5 signature
                if (typeof url === "object") {
                    options = url;
                    url = undefined;
                }
                // Force options to be an object
                options = options || {};
                var transport, 
                // URL without anti-cache param
                cacheURL, 
                // Response headers
                responseHeadersString, responseHeaders, 
                // timeout handle
                timeoutTimer, 
                // Url cleanup var
                urlAnchor, 
                // Request state (becomes false upon send and true upon completion)
                completed, 
                // To know if global events are to be dispatched
                fireGlobals, 
                // Loop variable
                i, 
                // uncached part of the url
                uncached, 
                // Create the final options object
                s = jQuery.ajaxSetup({}, options), 
                // Callbacks context
                callbackContext = s.context || s, 
                // Context for global events is callbackContext if it is a DOM node or jQuery collection
                globalEventContext = s.context &&
                    (callbackContext.nodeType || callbackContext.jquery) ?
                    jQuery(callbackContext) :
                    jQuery.event, 
                // Deferreds
                deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), 
                // Status-dependent callbacks
                statusCode = s.statusCode || {}, 
                // Headers (they are sent all at once)
                requestHeaders = {}, requestHeadersNames = {}, 
                // Default abort message
                strAbort = "canceled", 
                // Fake xhr
                jqXHR = {
                    readyState: 0,
                    // Builds headers hashtable if needed
                    getResponseHeader: function (key) {
                        var match;
                        if (completed) {
                            if (!responseHeaders) {
                                responseHeaders = {};
                                while ((match = rheaders.exec(responseHeadersString))) {
                                    responseHeaders[match[1].toLowerCase()] = match[2];
                                }
                            }
                            match = responseHeaders[key.toLowerCase()];
                        }
                        return match == null ? null : match;
                    },
                    // Raw string
                    getAllResponseHeaders: function () {
                        return completed ? responseHeadersString : null;
                    },
                    // Caches the header
                    setRequestHeader: function (name, value) {
                        if (completed == null) {
                            name = requestHeadersNames[name.toLowerCase()] =
                                requestHeadersNames[name.toLowerCase()] || name;
                            requestHeaders[name] = value;
                        }
                        return this;
                    },
                    // Overrides response content-type header
                    overrideMimeType: function (type) {
                        if (completed == null) {
                            s.mimeType = type;
                        }
                        return this;
                    },
                    // Status-dependent callbacks
                    statusCode: function (map) {
                        var code;
                        if (map) {
                            if (completed) {
                                // Execute the appropriate callbacks
                                jqXHR.always(map[jqXHR.status]);
                            }
                            else {
                                // Lazy-add the new callbacks in a way that preserves old ones
                                for (code in map) {
                                    statusCode[code] = [statusCode[code], map[code]];
                                }
                            }
                        }
                        return this;
                    },
                    // Cancel the request
                    abort: function (statusText) {
                        var finalText = statusText || strAbort;
                        if (transport) {
                            transport.abort(finalText);
                        }
                        done(0, finalText);
                        return this;
                    }
                };
                // Attach deferreds
                deferred.promise(jqXHR);
                // Add protocol if not provided (prefilters might expect it)
                // Handle falsy url in the settings object (#10093: consistency with old signature)
                // We also use the url parameter if available
                s.url = ((url || s.url || location.href) + "")
                    .replace(rprotocol, location.protocol + "//");
                // Alias method option to type as per ticket #12004
                s.type = options.method || options.type || s.method || s.type;
                // Extract dataTypes list
                s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];
                // A cross-domain request is in order when the origin doesn't match the current origin.
                if (s.crossDomain == null) {
                    urlAnchor = document.createElement("a");
                    // Support: IE <=8 - 11, Edge 12 - 15
                    // IE throws exception on accessing the href property if url is malformed,
                    // e.g. http://example.com:80x/
                    try {
                        urlAnchor.href = s.url;
                        // Support: IE <=8 - 11 only
                        // Anchor's host property isn't correctly set when s.url is relative
                        urlAnchor.href = urlAnchor.href;
                        s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
                            urlAnchor.protocol + "//" + urlAnchor.host;
                    }
                    catch (e) {
                        // If there is an error parsing the URL, assume it is crossDomain,
                        // it can be rejected by the transport if it is invalid
                        s.crossDomain = true;
                    }
                }
                // Convert data if not already a string
                if (s.data && s.processData && typeof s.data !== "string") {
                    s.data = jQuery.param(s.data, s.traditional);
                }
                // Apply prefilters
                inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
                // If request was aborted inside a prefilter, stop there
                if (completed) {
                    return jqXHR;
                }
                // We can fire global events as of now if asked to
                // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
                fireGlobals = jQuery.event && s.global;
                // Watch for a new set of requests
                if (fireGlobals && jQuery.active++ === 0) {
                    jQuery.event.trigger("ajaxStart");
                }
                // Uppercase the type
                s.type = s.type.toUpperCase();
                // Determine if request has content
                s.hasContent = !rnoContent.test(s.type);
                // Save the URL in case we're toying with the If-Modified-Since
                // and/or If-None-Match header later on
                // Remove hash to simplify url manipulation
                cacheURL = s.url.replace(rhash, "");
                // More options handling for requests with no content
                if (!s.hasContent) {
                    // Remember the hash so we can put it back
                    uncached = s.url.slice(cacheURL.length);
                    // If data is available and should be processed, append data to url
                    if (s.data && (s.processData || typeof s.data === "string")) {
                        cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                        // #9682: remove data so that it's not used in an eventual retry
                        delete s.data;
                    }
                    // Add or update anti-cache param if needed
                    if (s.cache === false) {
                        cacheURL = cacheURL.replace(rantiCache, "$1");
                        uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + (nonce++) + uncached;
                    }
                    // Put hash and anti-cache on the URL that will be requested (gh-1732)
                    s.url = cacheURL + uncached;
                    // Change '%20' to '+' if this is encoded form body content (gh-2658)
                }
                else if (s.data && s.processData &&
                    (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
                    s.data = s.data.replace(r20, "+");
                }
                // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                if (s.ifModified) {
                    if (jQuery.lastModified[cacheURL]) {
                        jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                    }
                    if (jQuery.etag[cacheURL]) {
                        jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
                    }
                }
                // Set the correct header, if data is being sent
                if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
                    jqXHR.setRequestHeader("Content-Type", s.contentType);
                }
                // Set the Accepts header for the server, depending on the dataType
                jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ?
                    s.accepts[s.dataTypes[0]] +
                        (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") :
                    s.accepts["*"]);
                // Check for headers option
                for (i in s.headers) {
                    jqXHR.setRequestHeader(i, s.headers[i]);
                }
                // Allow custom headers/mimetypes and early abort
                if (s.beforeSend &&
                    (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {
                    // Abort if not done already and return
                    return jqXHR.abort();
                }
                // Aborting is no longer a cancellation
                strAbort = "abort";
                // Install callbacks on deferreds
                completeDeferred.add(s.complete);
                jqXHR.done(s.success);
                jqXHR.fail(s.error);
                // Get transport
                transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
                // If no transport, we auto-abort
                if (!transport) {
                    done(-1, "No Transport");
                }
                else {
                    jqXHR.readyState = 1;
                    // Send global event
                    if (fireGlobals) {
                        globalEventContext.trigger("ajaxSend", [jqXHR, s]);
                    }
                    // If request was aborted inside ajaxSend, stop there
                    if (completed) {
                        return jqXHR;
                    }
                    // Timeout
                    if (s.async && s.timeout > 0) {
                        timeoutTimer = window.setTimeout(function () {
                            jqXHR.abort("timeout");
                        }, s.timeout);
                    }
                    try {
                        completed = false;
                        transport.send(requestHeaders, done);
                    }
                    catch (e) {
                        // Rethrow post-completion exceptions
                        if (completed) {
                            throw e;
                        }
                        // Propagate others as results
                        done(-1, e);
                    }
                }
                // Callback for when everything is done
                function done(status, nativeStatusText, responses, headers) {
                    var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                    // Ignore repeat invocations
                    if (completed) {
                        return;
                    }
                    completed = true;
                    // Clear timeout if it exists
                    if (timeoutTimer) {
                        window.clearTimeout(timeoutTimer);
                    }
                    // Dereference transport for early garbage collection
                    // (no matter how long the jqXHR object will be used)
                    transport = undefined;
                    // Cache response headers
                    responseHeadersString = headers || "";
                    // Set readyState
                    jqXHR.readyState = status > 0 ? 4 : 0;
                    // Determine if successful
                    isSuccess = status >= 200 && status < 300 || status === 304;
                    // Get response data
                    if (responses) {
                        response = ajaxHandleResponses(s, jqXHR, responses);
                    }
                    // Convert no matter what (that way responseXXX fields are always set)
                    response = ajaxConvert(s, response, jqXHR, isSuccess);
                    // If successful, handle type chaining
                    if (isSuccess) {
                        // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                        if (s.ifModified) {
                            modified = jqXHR.getResponseHeader("Last-Modified");
                            if (modified) {
                                jQuery.lastModified[cacheURL] = modified;
                            }
                            modified = jqXHR.getResponseHeader("etag");
                            if (modified) {
                                jQuery.etag[cacheURL] = modified;
                            }
                        }
                        // if no content
                        if (status === 204 || s.type === "HEAD") {
                            statusText = "nocontent";
                            // if not modified
                        }
                        else if (status === 304) {
                            statusText = "notmodified";
                            // If we have data, let's convert it
                        }
                        else {
                            statusText = response.state;
                            success = response.data;
                            error = response.error;
                            isSuccess = !error;
                        }
                    }
                    else {
                        // Extract error from statusText and normalize for non-aborts
                        error = statusText;
                        if (status || !statusText) {
                            statusText = "error";
                            if (status < 0) {
                                status = 0;
                            }
                        }
                    }
                    // Set data for the fake xhr object
                    jqXHR.status = status;
                    jqXHR.statusText = (nativeStatusText || statusText) + "";
                    // Success/Error
                    if (isSuccess) {
                        deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
                    }
                    else {
                        deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
                    }
                    // Status-dependent callbacks
                    jqXHR.statusCode(statusCode);
                    statusCode = undefined;
                    if (fireGlobals) {
                        globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]);
                    }
                    // Complete
                    completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);
                    if (fireGlobals) {
                        globalEventContext.trigger("ajaxComplete", [jqXHR, s]);
                        // Handle the global AJAX counter
                        if (!(--jQuery.active)) {
                            jQuery.event.trigger("ajaxStop");
                        }
                    }
                }
                return jqXHR;
            },
            getJSON: function (url, data, callback) {
                return jQuery.get(url, data, callback, "json");
            },
            getScript: function (url, callback) {
                return jQuery.get(url, undefined, callback, "script");
            }
        });
        jQuery.each(["get", "post"], function (i, method) {
            jQuery[method] = function (url, data, callback, type) {
                // Shift arguments if data argument was omitted
                if (isFunction(data)) {
                    type = type || callback;
                    callback = data;
                    data = undefined;
                }
                // The url can be an options object (which then must have .url)
                return jQuery.ajax(jQuery.extend({
                    url: url,
                    type: method,
                    dataType: type,
                    data: data,
                    success: callback
                }, jQuery.isPlainObject(url) && url));
            };
        });
        jQuery._evalUrl = function (url) {
            return jQuery.ajax({
                url: url,
                // Make this explicit, since user can override this through ajaxSetup (#11264)
                type: "GET",
                dataType: "script",
                cache: true,
                async: false,
                global: false,
                "throws": true
            });
        };
        jQuery.fn.extend({
            wrapAll: function (html) {
                var wrap;
                if (this[0]) {
                    if (isFunction(html)) {
                        html = html.call(this[0]);
                    }
                    // The elements to wrap the target around
                    wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                    if (this[0].parentNode) {
                        wrap.insertBefore(this[0]);
                    }
                    wrap.map(function () {
                        var elem = this;
                        while (elem.firstElementChild) {
                            elem = elem.firstElementChild;
                        }
                        return elem;
                    }).append(this);
                }
                return this;
            },
            wrapInner: function (html) {
                if (isFunction(html)) {
                    return this.each(function (i) {
                        jQuery(this).wrapInner(html.call(this, i));
                    });
                }
                return this.each(function () {
                    var self = jQuery(this), contents = self.contents();
                    if (contents.length) {
                        contents.wrapAll(html);
                    }
                    else {
                        self.append(html);
                    }
                });
            },
            wrap: function (html) {
                var htmlIsFunction = isFunction(html);
                return this.each(function (i) {
                    jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
                });
            },
            unwrap: function (selector) {
                this.parent(selector).not("body").each(function () {
                    jQuery(this).replaceWith(this.childNodes);
                });
                return this;
            }
        });
        jQuery.expr.pseudos.hidden = function (elem) {
            return !jQuery.expr.pseudos.visible(elem);
        };
        jQuery.expr.pseudos.visible = function (elem) {
            return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
        };
        jQuery.ajaxSettings.xhr = function () {
            try {
                return new window.XMLHttpRequest();
            }
            catch (e) { }
        };
        var xhrSuccessStatus = {
            // File protocol always yields status code 0, assume 200
            0: 200,
            // Support: IE <=9 only
            // #1450: sometimes IE returns 1223 when it should be 204
            1223: 204
        }, xhrSupported = jQuery.ajaxSettings.xhr();
        support.cors = !!xhrSupported && ("withCredentials" in xhrSupported);
        support.ajax = xhrSupported = !!xhrSupported;
        jQuery.ajaxTransport(function (options) {
            var callback, errorCallback;
            // Cross domain only allowed if supported through XMLHttpRequest
            if (support.cors || xhrSupported && !options.crossDomain) {
                return {
                    send: function (headers, complete) {
                        var i, xhr = options.xhr();
                        xhr.open(options.type, options.url, options.async, options.username, options.password);
                        // Apply custom fields if provided
                        if (options.xhrFields) {
                            for (i in options.xhrFields) {
                                xhr[i] = options.xhrFields[i];
                            }
                        }
                        // Override mime type if needed
                        if (options.mimeType && xhr.overrideMimeType) {
                            xhr.overrideMimeType(options.mimeType);
                        }
                        // X-Requested-With header
                        // For cross-domain requests, seeing as conditions for a preflight are
                        // akin to a jigsaw puzzle, we simply never set it to be sure.
                        // (it can always be set on a per-request basis or even using ajaxSetup)
                        // For same-domain requests, won't change header if already provided.
                        if (!options.crossDomain && !headers["X-Requested-With"]) {
                            headers["X-Requested-With"] = "XMLHttpRequest";
                        }
                        // Set headers
                        for (i in headers) {
                            xhr.setRequestHeader(i, headers[i]);
                        }
                        // Callback
                        callback = function (type) {
                            return function () {
                                if (callback) {
                                    callback = errorCallback = xhr.onload =
                                        xhr.onerror = xhr.onabort = xhr.ontimeout =
                                            xhr.onreadystatechange = null;
                                    if (type === "abort") {
                                        xhr.abort();
                                    }
                                    else if (type === "error") {
                                        // Support: IE <=9 only
                                        // On a manual native abort, IE9 throws
                                        // errors on any property access that is not readyState
                                        if (typeof xhr.status !== "number") {
                                            complete(0, "error");
                                        }
                                        else {
                                            complete(
                                            // File: protocol always yields status 0; see #8605, #14207
                                            xhr.status, xhr.statusText);
                                        }
                                    }
                                    else {
                                        complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, 
                                        // Support: IE <=9 only
                                        // IE9 has no XHR2 but throws on binary (trac-11426)
                                        // For XHR2 non-text, let the caller handle it (gh-2498)
                                        (xhr.responseType || "text") !== "text" ||
                                            typeof xhr.responseText !== "string" ?
                                            { binary: xhr.response } :
                                            { text: xhr.responseText }, xhr.getAllResponseHeaders());
                                    }
                                }
                            };
                        };
                        // Listen to events
                        xhr.onload = callback();
                        errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                        // Support: IE 9 only
                        // Use onreadystatechange to replace onabort
                        // to handle uncaught aborts
                        if (xhr.onabort !== undefined) {
                            xhr.onabort = errorCallback;
                        }
                        else {
                            xhr.onreadystatechange = function () {
                                // Check readyState before timeout as it changes
                                if (xhr.readyState === 4) {
                                    // Allow onerror to be called first,
                                    // but that will not handle a native abort
                                    // Also, save errorCallback to a variable
                                    // as xhr.onerror cannot be accessed
                                    window.setTimeout(function () {
                                        if (callback) {
                                            errorCallback();
                                        }
                                    });
                                }
                            };
                        }
                        // Create the abort callback
                        callback = callback("abort");
                        try {
                            // Do send the request (this may raise an exception)
                            xhr.send(options.hasContent && options.data || null);
                        }
                        catch (e) {
                            // #14683: Only rethrow if this hasn't been notified as an error yet
                            if (callback) {
                                throw e;
                            }
                        }
                    },
                    abort: function () {
                        if (callback) {
                            callback();
                        }
                    }
                };
            }
        });
        // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
        jQuery.ajaxPrefilter(function (s) {
            if (s.crossDomain) {
                s.contents.script = false;
            }
        });
        // Install script dataType
        jQuery.ajaxSetup({
            accepts: {
                script: "text/javascript, application/javascript, " +
                    "application/ecmascript, application/x-ecmascript"
            },
            contents: {
                script: /\b(?:java|ecma)script\b/
            },
            converters: {
                "text script": function (text) {
                    jQuery.globalEval(text);
                    return text;
                }
            }
        });
        // Handle cache's special case and crossDomain
        jQuery.ajaxPrefilter("script", function (s) {
            if (s.cache === undefined) {
                s.cache = false;
            }
            if (s.crossDomain) {
                s.type = "GET";
            }
        });
        // Bind script tag hack transport
        jQuery.ajaxTransport("script", function (s) {
            // This transport only deals with cross domain requests
            if (s.crossDomain) {
                var script, callback;
                return {
                    send: function (_, complete) {
                        script = jQuery("<script>").prop({
                            charset: s.scriptCharset,
                            src: s.url
                        }).on("load error", callback = function (evt) {
                            script.remove();
                            callback = null;
                            if (evt) {
                                complete(evt.type === "error" ? 404 : 200, evt.type);
                            }
                        });
                        // Use native DOM manipulation to avoid our domManip AJAX trickery
                        document.head.appendChild(script[0]);
                    },
                    abort: function () {
                        if (callback) {
                            callback();
                        }
                    }
                };
            }
        });
        var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
        // Default jsonp settings
        jQuery.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
                var callback = oldCallbacks.pop() || (jQuery.expando + "_" + (nonce++));
                this[callback] = true;
                return callback;
            }
        });
        // Detect, normalize options and install callbacks for jsonp requests
        jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {
            var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ?
                "url" :
                typeof s.data === "string" &&
                    (s.contentType || "")
                        .indexOf("application/x-www-form-urlencoded") === 0 &&
                    rjsonp.test(s.data) && "data");
            // Handle iff the expected data type is "jsonp" or we have a parameter to set
            if (jsonProp || s.dataTypes[0] === "jsonp") {
                // Get callback name, remembering preexisting value associated with it
                callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ?
                    s.jsonpCallback() :
                    s.jsonpCallback;
                // Insert callback into url or form data
                if (jsonProp) {
                    s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
                }
                else if (s.jsonp !== false) {
                    s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
                }
                // Use data converter to retrieve json after script execution
                s.converters["script json"] = function () {
                    if (!responseContainer) {
                        jQuery.error(callbackName + " was not called");
                    }
                    return responseContainer[0];
                };
                // Force json dataType
                s.dataTypes[0] = "json";
                // Install callback
                overwritten = window[callbackName];
                window[callbackName] = function () {
                    responseContainer = arguments;
                };
                // Clean-up function (fires after converters)
                jqXHR.always(function () {
                    // If previous value didn't exist - remove it
                    if (overwritten === undefined) {
                        jQuery(window).removeProp(callbackName);
                        // Otherwise restore preexisting value
                    }
                    else {
                        window[callbackName] = overwritten;
                    }
                    // Save back as free
                    if (s[callbackName]) {
                        // Make sure that re-using the options doesn't screw things around
                        s.jsonpCallback = originalSettings.jsonpCallback;
                        // Save the callback name for future use
                        oldCallbacks.push(callbackName);
                    }
                    // Call if it was a function and we have a response
                    if (responseContainer && isFunction(overwritten)) {
                        overwritten(responseContainer[0]);
                    }
                    responseContainer = overwritten = undefined;
                });
                // Delegate to script
                return "script";
            }
        });
        // Support: Safari 8 only
        // In Safari 8 documents created via document.implementation.createHTMLDocument
        // collapse sibling forms: the second one becomes a child of the first one.
        // Because of that, this security measure has to be disabled in Safari 8.
        // https://bugs.webkit.org/show_bug.cgi?id=137337
        support.createHTMLDocument = (function () {
            var body = document.implementation.createHTMLDocument("").body;
            body.innerHTML = "<form></form><form></form>";
            return body.childNodes.length === 2;
        })();
        // Argument "data" should be string of html
        // context (optional): If specified, the fragment will be created in this context,
        // defaults to document
        // keepScripts (optional): If true, will include scripts passed in the html string
        jQuery.parseHTML = function (data, context, keepScripts) {
            if (typeof data !== "string") {
                return [];
            }
            if (typeof context === "boolean") {
                keepScripts = context;
                context = false;
            }
            var base, parsed, scripts;
            if (!context) {
                // Stop scripts or inline event handlers from being executed immediately
                // by using document.implementation
                if (support.createHTMLDocument) {
                    context = document.implementation.createHTMLDocument("");
                    // Set the base href for the created document
                    // so any parsed elements with URLs
                    // are based on the document's URL (gh-2965)
                    base = context.createElement("base");
                    base.href = document.location.href;
                    context.head.appendChild(base);
                }
                else {
                    context = document;
                }
            }
            parsed = rsingleTag.exec(data);
            scripts = !keepScripts && [];
            // Single tag
            if (parsed) {
                return [context.createElement(parsed[1])];
            }
            parsed = buildFragment([data], context, scripts);
            if (scripts && scripts.length) {
                jQuery(scripts).remove();
            }
            return jQuery.merge([], parsed.childNodes);
        };
        /**
         * Load a url into a page
         */
        jQuery.fn.load = function (url, params, callback) {
            var selector, type, response, self = this, off = url.indexOf(" ");
            if (off > -1) {
                selector = stripAndCollapse(url.slice(off));
                url = url.slice(0, off);
            }
            // If it's a function
            if (isFunction(params)) {
                // We assume that it's the callback
                callback = params;
                params = undefined;
                // Otherwise, build a param string
            }
            else if (params && typeof params === "object") {
                type = "POST";
            }
            // If we have elements to modify, make the request
            if (self.length > 0) {
                jQuery.ajax({
                    url: url,
                    // If "type" variable is undefined, then "GET" method will be used.
                    // Make value of this field explicit since
                    // user can override it through ajaxSetup method
                    type: type || "GET",
                    dataType: "html",
                    data: params
                }).done(function (responseText) {
                    // Save response for use in complete callback
                    response = arguments;
                    self.html(selector ?
                        // If a selector was specified, locate the right elements in a dummy div
                        // Exclude scripts to avoid IE 'Permission Denied' errors
                        jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) :
                        // Otherwise use the full result
                        responseText);
                    // If the request succeeds, this function gets "data", "status", "jqXHR"
                    // but they are ignored because response was set above.
                    // If it fails, this function gets "jqXHR", "status", "error"
                }).always(callback && function (jqXHR, status) {
                    self.each(function () {
                        callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
                    });
                });
            }
            return this;
        };
        // Attach a bunch of functions for handling common AJAX events
        jQuery.each([
            "ajaxStart",
            "ajaxStop",
            "ajaxComplete",
            "ajaxError",
            "ajaxSuccess",
            "ajaxSend"
        ], function (i, type) {
            jQuery.fn[type] = function (fn) {
                return this.on(type, fn);
            };
        });
        jQuery.expr.pseudos.animated = function (elem) {
            return jQuery.grep(jQuery.timers, function (fn) {
                return elem === fn.elem;
            }).length;
        };
        jQuery.offset = {
            setOffset: function (elem, options, i) {
                var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
                // Set position first, in-case top/left are set even on static elem
                if (position === "static") {
                    elem.style.position = "relative";
                }
                curOffset = curElem.offset();
                curCSSTop = jQuery.css(elem, "top");
                curCSSLeft = jQuery.css(elem, "left");
                calculatePosition = (position === "absolute" || position === "fixed") &&
                    (curCSSTop + curCSSLeft).indexOf("auto") > -1;
                // Need to be able to calculate position if either
                // top or left is auto and position is either absolute or fixed
                if (calculatePosition) {
                    curPosition = curElem.position();
                    curTop = curPosition.top;
                    curLeft = curPosition.left;
                }
                else {
                    curTop = parseFloat(curCSSTop) || 0;
                    curLeft = parseFloat(curCSSLeft) || 0;
                }
                if (isFunction(options)) {
                    // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
                    options = options.call(elem, i, jQuery.extend({}, curOffset));
                }
                if (options.top != null) {
                    props.top = (options.top - curOffset.top) + curTop;
                }
                if (options.left != null) {
                    props.left = (options.left - curOffset.left) + curLeft;
                }
                if ("using" in options) {
                    options.using.call(elem, props);
                }
                else {
                    curElem.css(props);
                }
            }
        };
        jQuery.fn.extend({
            // offset() relates an element's border box to the document origin
            offset: function (options) {
                // Preserve chaining for setter
                if (arguments.length) {
                    return options === undefined ?
                        this :
                        this.each(function (i) {
                            jQuery.offset.setOffset(this, options, i);
                        });
                }
                var rect, win, elem = this[0];
                if (!elem) {
                    return;
                }
                // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
                // Support: IE <=11 only
                // Running getBoundingClientRect on a
                // disconnected node in IE throws an error
                if (!elem.getClientRects().length) {
                    return { top: 0, left: 0 };
                }
                // Get document-relative position by adding viewport scroll to viewport-relative gBCR
                rect = elem.getBoundingClientRect();
                win = elem.ownerDocument.defaultView;
                return {
                    top: rect.top + win.pageYOffset,
                    left: rect.left + win.pageXOffset
                };
            },
            // position() relates an element's margin box to its offset parent's padding box
            // This corresponds to the behavior of CSS absolute positioning
            position: function () {
                if (!this[0]) {
                    return;
                }
                var offsetParent, offset, doc, elem = this[0], parentOffset = { top: 0, left: 0 };
                // position:fixed elements are offset from the viewport, which itself always has zero offset
                if (jQuery.css(elem, "position") === "fixed") {
                    // Assume position:fixed implies availability of getBoundingClientRect
                    offset = elem.getBoundingClientRect();
                }
                else {
                    offset = this.offset();
                    // Account for the *real* offset parent, which can be the document or its root element
                    // when a statically positioned element is identified
                    doc = elem.ownerDocument;
                    offsetParent = elem.offsetParent || doc.documentElement;
                    while (offsetParent &&
                        (offsetParent === doc.body || offsetParent === doc.documentElement) &&
                        jQuery.css(offsetParent, "position") === "static") {
                        offsetParent = offsetParent.parentNode;
                    }
                    if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                        // Incorporate borders into its offset, since they are outside its content origin
                        parentOffset = jQuery(offsetParent).offset();
                        parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                        parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                    }
                }
                // Subtract parent offsets and element margins
                return {
                    top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                    left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
                };
            },
            // This method will return documentElement in the following cases:
            // 1) For the element inside the iframe without offsetParent, this method will return
            //    documentElement of the parent window
            // 2) For the hidden or detached element
            // 3) For body or html element, i.e. in case of the html node - it will return itself
            //
            // but those exceptions were never presented as a real life use-cases
            // and might be considered as more preferable results.
            //
            // This logic, however, is not guaranteed and can change at any point in the future
            offsetParent: function () {
                return this.map(function () {
                    var offsetParent = this.offsetParent;
                    while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
                        offsetParent = offsetParent.offsetParent;
                    }
                    return offsetParent || documentElement;
                });
            }
        });
        // Create scrollLeft and scrollTop methods
        jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (method, prop) {
            var top = "pageYOffset" === prop;
            jQuery.fn[method] = function (val) {
                return access(this, function (elem, method, val) {
                    // Coalesce documents and windows
                    var win;
                    if (isWindow(elem)) {
                        win = elem;
                    }
                    else if (elem.nodeType === 9) {
                        win = elem.defaultView;
                    }
                    if (val === undefined) {
                        return win ? win[prop] : elem[method];
                    }
                    if (win) {
                        win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                    }
                    else {
                        elem[method] = val;
                    }
                }, method, val, arguments.length);
            };
        });
        // Support: Safari <=7 - 9.1, Chrome <=37 - 49
        // Add the top/left cssHooks using jQuery.fn.position
        // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
        // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
        // getComputedStyle returns percent when specified for top/left/bottom/right;
        // rather than make the css module depend on the offset module, just check for it here
        jQuery.each(["top", "left"], function (i, prop) {
            jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function (elem, computed) {
                if (computed) {
                    computed = curCSS(elem, prop);
                    // If curCSS returns percentage, fallback to offset
                    return rnumnonpx.test(computed) ?
                        jQuery(elem).position()[prop] + "px" :
                        computed;
                }
            });
        });
        // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
        jQuery.each({ Height: "height", Width: "width" }, function (name, type) {
            jQuery.each({ padding: "inner" + name, content: type, "": "outer" + name }, function (defaultExtra, funcName) {
                // Margin is only for outerHeight, outerWidth
                jQuery.fn[funcName] = function (margin, value) {
                    var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                    return access(this, function (elem, type, value) {
                        var doc;
                        if (isWindow(elem)) {
                            // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                            return funcName.indexOf("outer") === 0 ?
                                elem["inner" + name] :
                                elem.document.documentElement["client" + name];
                        }
                        // Get document width or height
                        if (elem.nodeType === 9) {
                            doc = elem.documentElement;
                            // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                            // whichever is greatest
                            return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                        }
                        return value === undefined ?
                            // Get width or height on the element, requesting but not forcing parseFloat
                            jQuery.css(elem, type, extra) :
                            // Set width or height on the element
                            jQuery.style(elem, type, value, extra);
                    }, type, chainable ? margin : undefined, chainable);
                };
            });
        });
        jQuery.each(("blur focus focusin focusout resize scroll click dblclick " +
            "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
            "change select submit keydown keypress keyup contextmenu").split(" "), function (i, name) {
            // Handle event binding
            jQuery.fn[name] = function (data, fn) {
                return arguments.length > 0 ?
                    this.on(name, null, data, fn) :
                    this.trigger(name);
            };
        });
        jQuery.fn.extend({
            hover: function (fnOver, fnOut) {
                return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
            }
        });
        jQuery.fn.extend({
            bind: function (types, data, fn) {
                return this.on(types, null, data, fn);
            },
            unbind: function (types, fn) {
                return this.off(types, null, fn);
            },
            delegate: function (selector, types, data, fn) {
                return this.on(types, selector, data, fn);
            },
            undelegate: function (selector, types, fn) {
                // ( namespace ) or ( selector, types [, fn] )
                return arguments.length === 1 ?
                    this.off(selector, "**") :
                    this.off(types, selector || "**", fn);
            }
        });
        // Bind a function to a context, optionally partially applying any
        // arguments.
        // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
        // However, it is not slated for removal any time soon
        jQuery.proxy = function (fn, context) {
            var tmp, args, proxy;
            if (typeof context === "string") {
                tmp = fn[context];
                context = fn;
                fn = tmp;
            }
            // Quick check to determine if target is callable, in the spec
            // this throws a TypeError, but we will just return undefined.
            if (!isFunction(fn)) {
                return undefined;
            }
            // Simulated bind
            args = slice.call(arguments, 2);
            proxy = function () {
                return fn.apply(context || this, args.concat(slice.call(arguments)));
            };
            // Set the guid of unique handler to the same of original handler, so it can be removed
            proxy.guid = fn.guid = fn.guid || jQuery.guid++;
            return proxy;
        };
        jQuery.holdReady = function (hold) {
            if (hold) {
                jQuery.readyWait++;
            }
            else {
                jQuery.ready(true);
            }
        };
        jQuery.isArray = Array.isArray;
        jQuery.parseJSON = JSON.parse;
        jQuery.nodeName = nodeName;
        jQuery.isFunction = isFunction;
        jQuery.isWindow = isWindow;
        jQuery.camelCase = camelCase;
        jQuery.type = toType;
        jQuery.now = Date.now;
        jQuery.isNumeric = function (obj) {
            // As of jQuery 3.0, isNumeric is limited to
            // strings and numbers (primitives or objects)
            // that can be coerced to finite numbers (gh-2662)
            var type = jQuery.type(obj);
            return (type === "number" || type === "string") &&
                // parseFloat NaNs numeric-cast false positives ("")
                // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
                // subtraction forces infinities to NaN
                !isNaN(obj - parseFloat(obj));
        };
        // Register as a named AMD module, since jQuery can be concatenated with other
        // files that may use define, but not via a proper concatenation script that
        // understands anonymous AMD modules. A named AMD is safest and most robust
        // way to register. Lowercase jquery is used because AMD module names are
        // derived from file names, and jQuery is normally delivered in a lowercase
        // file name. Do this after creating the global so that if an AMD module wants
        // to call noConflict to hide this version of jQuery, it will work.
        // Note that for maximum portability, libraries that are not jQuery should
        // declare themselves as anonymous modules, and avoid setting a global if an
        // AMD loader is present. jQuery is a special case. For more information, see
        // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
        if (false) {
            undefined("jquery", [], function () {
                return jQuery;
            });
        }
        var 
        // Map over jQuery in case of overwrite
        _jQuery = window.jQuery, 
        // Map over the $ in case of overwrite
        _$ = window.$;
        jQuery.noConflict = function (deep) {
            if (window.$ === jQuery) {
                window.$ = _$;
            }
            if (deep && window.jQuery === jQuery) {
                window.jQuery = _jQuery;
            }
            return jQuery;
        };
        // Expose jQuery and $ identifiers, even in AMD
        // (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
        // and CommonJS for browser emulators (#13566)
        if (!noGlobal) {
            window.jQuery = window.$ = jQuery;
        }
        return jQuery;
    });
});
var BaseEvent = /** @class */ (function () {
    /**
     * @param {?} target
     */
    function BaseEvent(target) {
        this._preventDefault = false;
        this.target = target;
    }
    /**
     * @return {?}
     */
    BaseEvent.prototype.preventDefault = function () {
        this._preventDefault = true;
    };
    return BaseEvent;
}());
var WizardComponent = /** @class */ (function (_super) {
    __extends(WizardComponent, _super);
    /**
     * @param {?} elementRef
     */
    function WizardComponent(elementRef) {
        var _this = _super.call(this) || this;
        _this.nextButtonClass = "btn btn-next btn-fill btn-wd";
        _this.prevButtonClass = "btn btn-previous btn-fill btn-default btn-wd";
        _this.nextIconClass = "material-icons";
        _this.nextIconText = "arrow_forward";
        _this.prevIconClass = "material-icons";
        _this.prevIconText = "arrow_back";
        _this.previousButtonContainerClass = '';
        _this.nextButtonContainerClass = '';
        _this.showProgressBar = false;
        _this.showHeader = true;
        _this.scrollClassRef = null;
        _this.currentProgress = 0;
        _this.finish = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        return _this;
    }
    /**
     * @return {?}
     */
    WizardComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.tabs.find(function (x) { return x.active; })) {
                var /** @type {?} */ t = _this.tabs[0];
                if (t != null)
                    t.active = true;
            }
            _this.initAnimation();
        });
    };
    Object.defineProperty(WizardComponent.prototype, "progress", {
        /**
         * @return {?}
         */
        get: function () {
            var _this = this;
            if (!this.activeTab)
                return;
            var /** @type {?} */ currentTab = this.tabs.find(function (x) { return x.index == _this.activeTab.index; });
            var /** @type {?} */ activeTabs = this.tabs.filter(function (tab) { return tab.index >= 0; });
            var /** @type {?} */ index = activeTabs.indexOf(currentTab);
            var /** @type {?} */ multiple = 100 / (activeTabs.length - 1);
            return index >= 0 ? index * multiple : 0;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?=} emitContinue
     * @return {?}
     */
    WizardComponent.prototype.nextTab = function (emitContinue) {
        var _this = this;
        if (emitContinue === void 0) { emitContinue = true; }
        if (this.activeTab.isNextButtonDisabled)
            return;
        if (emitContinue) {
            var /** @type {?} */ continueEvent = new BaseEvent(this.activeTab);
            this.activeTab.onContinueClicked.emit(continueEvent);
            if (continueEvent._preventDefault) {
                return;
            }
        }
        if (this.activeTab.index >= Math.max.apply(Math, this.tabs.map(function (x) { return x.index; }))) {
            this.finish.emit();
            return;
        }
        //this.tabs[this.activeTab.index + 1].active = true;
        var /** @type {?} */ nextTab = this.tabs.find(function (x) { return x.index >= _this.activeTab.index + 1; });
        if (nextTab) {
            nextTab.active = true;
            this.scrollTop();
        }
    };
    /**
     * @return {?}
     */
    WizardComponent.prototype.scrollTop = function () {
        var /** @type {?} */ el = document.querySelector(this.scrollClassRef);
        if (el) {
            el.scrollTop = 0;
        }
    };
    /**
     * @param {?=} emitPrevious
     * @return {?}
     */
    WizardComponent.prototype.previousTab = function (emitPrevious) {
        var _this = this;
        if (emitPrevious === void 0) { emitPrevious = true; }
        if (this.activeTab.isPrevButtonDisabled) {
            return;
        }
        if (this.activeTab.index <= 0) {
            return;
        }
        if (emitPrevious) {
            var /** @type {?} */ previousEvent = new BaseEvent(this.activeTab);
            this.activeTab.onPreviousClicked.emit(previousEvent);
            if (previousEvent._preventDefault) {
                return;
            }
        }
        var /** @type {?} */ prevTabs = this.tabs.filter(function (x) { return (x.index <= _this.activeTab.index - 1) && (_this.activeTab.index != -1); });
        var /** @type {?} */ prevTab = prevTabs[prevTabs.length - 1];
        if (prevTab) {
            prevTab.active = true;
            this.scrollTop();
        }
    };
    /**
     * @return {?}
     */
    WizardComponent.prototype.initAnimation = function () {
        var /** @type {?} */ navigation = $(".wizard-navigation");
        var /** @type {?} */ $total = navigation.find('li').length;
        var /** @type {?} */ $width = 100 / $total;
        var /** @type {?} */ $wizard = navigation.closest('.wizard-card');
        var /** @type {?} */ $current = this.activeTab.index + 1;
        var /** @type {?} */ nextText = "Next";
        if ($current >= $total) {
            nextText = "Finish";
        }
        this.previousButtonText = this.activeTab.previousButton || this.previousButton || "Previous";
        this.nextButtonText = this.activeTab.nextButton || this.nextButton || nextText;
        this.previousButtonVisible = this.previousButtonText != "hidden" && $current != 1;
        this.nextButtonVisible = this.nextButtonText != "hidden";
        var /** @type {?} */ $display_width = $(document).width();
        if ($display_width < 600 && $total > 3) {
            $width = 50;
        }
        navigation.find('li').css('width', $width + '%');
        var /** @type {?} */ button_text = navigation.find('li:first-child a span').html();
        if (button_text)
            button_text = button_text.replace(/<!--([\s\S]*?)-->/gm, "");
        $('.moving-tab').text(button_text);
        var /** @type {?} */ total_steps = $wizard.find('li').length;
        var /** @type {?} */ move_distance = $wizard.width() / total_steps;
        var /** @type {?} */ step_width = move_distance;
        move_distance *= this.activeTab.index;
        if ($current == 1) {
            move_distance -= 8;
        }
        else if ($current == total_steps) {
            move_distance += 8;
        }
        $wizard.find('.moving-tab').css('width', step_width);
        $('.moving-tab').css({
            'transform': 'translate3d(' + move_distance + 'px, 0, 0)',
            'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
        });
        $('.moving-tab').css('transition', 'transform 0s');
    };
    /**
     * @param {?} tab
     * @return {?}
     */
    WizardComponent.prototype.onSelect = function (tab) {
        _super.prototype.onSelect.call(this, tab);
        var /** @type {?} */ navigation = $(".wizard-navigation");
        var /** @type {?} */ $total = navigation.find('li').length;
        var /** @type {?} */ $current = this.activeTab.index + 1;
        var /** @type {?} */ $wizard = navigation.closest('.wizard-card');
        var /** @type {?} */ nextText = "Next";
        if ($current >= $total) {
            nextText = "Finish";
        }
        this.previousButtonText = this.activeTab.previousButton || "Previous";
        this.nextButtonText = this.activeTab.nextButton || nextText;
        this.previousButtonVisible = this.previousButtonText != "hidden" && $current != 1;
        this.nextButtonVisible = this.nextButtonText != "hidden";
        var /** @type {?} */ button_text = navigation.find('li:nth-child(' + $current + ') a span').html();
        if (button_text)
            button_text = button_text.replace(/<!--([\s\S]*?)-->/gm, "");
        setTimeout(function () {
            $('.moving-tab').text(button_text);
        }, 150);
        var /** @type {?} */ checkbox = $('.footer-checkbox');
        if (this.activeTab.index !== 0) {
            $(checkbox).css({
                'opacity': '0',
                'visibility': 'hidden',
                'position': 'absolute'
            });
        }
        else {
            $(checkbox).css({
                'opacity': '1',
                'visibility': 'visible'
            });
        }
        var /** @type {?} */ total_steps = $wizard.find('li').length;
        var /** @type {?} */ move_distance = $wizard.width() / total_steps;
        var /** @type {?} */ step_width = move_distance;
        move_distance *= this.activeTab.index;
        if ($current == 1) {
            move_distance -= 8;
        }
        else if ($current == total_steps) {
            move_distance += 8;
        }
        $wizard.find('.moving-tab').css('width', step_width);
        $('.moving-tab').css({
            'transform': 'translate3d(' + move_distance + 'px, 0, 0)',
            'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
        });
    };
    return WizardComponent;
}(TabsComponent));
WizardComponent.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                selector: 'wizard',
                template: "\n      <div class=\"wizard-container\">\n\n          <div class=\"progress\" *ngIf=\"showProgressBar\">\n              <div class=\"progress-bar\" role=\"progressbar\" [ngStyle]=\"{'width':  progress +'%'}\">\n              </div>\n          </div>\n\n          <div class=\"nav-center\" *ngIf=\"showHeader\">\n              <ul class=\"nav nav-pills nav-pills-warning nav-pills-icons\" role=\"tablist\">\n                  <ng-container *ngFor=\"let tab of tabs\">\n                      <li (click)=\"tab.active = true\" [class.active]=\"tab.active\">\n                          <a data-toggle=\"tab\" role=\"tab\" [ngClass]=\"tab.customClass\">\n                              <i class=\"material-icons\">{{ tab.icon }}</i>\n                              <div class=\"tab-info\">\n                                  {{ tab.heading }}\n                              </div>\n                          </a>\n                      </li>\n                  </ng-container>\n              </ul>\n          </div>\n\n          <div id=\"wizardProfile\">\n              <ng-content select=\".wizard-header\"></ng-content>\n\n              <div class=\"tab-content\">\n                  <ng-content></ng-content>\n              </div>\n\n              <div class=\"wizard-footer\" *ngIf=\"activeTab\">\n                  <ng-container *ngIf=\"!activeTab.buttonTemplate\">\n                      <ng-container  [ngTemplateOutlet]=\"continueButton\"></ng-container>\n                      <ng-container  [ngTemplateOutlet]=\"prevButton\"></ng-container>\n                      <div class=\"clearfix\"></div>\n                  </ng-container>\n\n                  <ng-container *ngIf=\"activeTab.buttonTemplate\" [ngTemplateOutlet]=\"activeTab.buttonTemplate\">\n\n                  </ng-container>\n              </div>\n          </div>\n      </div>\n\n      <ng-template #continueButton>\n          <div class=\"btn-container nextButton\" *ngIf=\"nextButtonVisible\" (click)=\"nextTab()\"\n               [ngClass]=\"[activeTab.isNextButtonDisabled ? 'disabled' : '', nextButtonContainerClass]\">\n              <input #nextButton type='button' [ngClass]=\"[nextButtonClass]\"\n                     name='next' [value]='nextButtonText' />\n              <i *ngIf=\"nextIconText && nextIconClass\" [ngClass]=\"[nextIconClass]\">{{nextIconText}}</i>\n          </div>\n      </ng-template>\n\n      <ng-template #prevButton >\n          <div class=\"btn-container previousButton\" *ngIf=\"previousButtonVisible\" (click)=\"previousTab()\"\n               [ngClass]=\"[activeTab.isPrevButtonDisabled ? 'disabled' : '', previousButtonContainerClass]\">\n              <input #previosButton type='button' [ngClass]=\"[prevButtonClass]\"\n                     name='previous' [value]='previousButtonText' />\n              <i *ngIf=\"prevIconText && prevIconClass\" [ngClass]=\"[prevIconClass]\">{{prevIconText}}</i>\n          </div>\n      </ng-template>\n    ",
                providers: [{ provide: TabsComponent, useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return WizardComponent; }) }]
            },] },
];
/**
 * @nocollapse
 */
WizardComponent.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
WizardComponent.propDecorators = {
    'nextButtonClass': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'prevButtonClass': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'nextIconClass': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'nextIconText': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'prevIconClass': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'prevIconText': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'previousButtonContainerClass': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'nextButtonContainerClass': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'previousButton': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'nextButton': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'showProgressBar': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'showHeader': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'scrollClassRef': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'finish': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'previousButtonRef': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ["prevButton",] },],
    'continueButtonRef': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ["continueButton",] },],
};
var WizardModule = /** @class */ (function () {
    function WizardModule() {
    }
    return WizardModule;
}());
WizardModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [
                    __WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]
                ],
                declarations: [
                    WizardComponent, TabsComponent, NgTranscludeDirective, TabDirective
                ],
                providers: [],
                exports: [
                    WizardComponent, TabsComponent, TabDirective
                ]
            },] },
];
/**
 * @nocollapse
 */
WizardModule.ctorParameters = function () { return []; };
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=ngx-wizard.es5.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("24Wi")))

/***/ }),

/***/ "15BH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_helpers_enumHelper__ = __webpack_require__("ZP5A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_helpers_enumHelper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_helpers_enumHelper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_select2_dist_js_select2_js__ = __webpack_require__("hv7s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_select2_dist_js_select2_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_select2_dist_js_select2_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_perfect_scrollbar__ = __webpack_require__("Fiov");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_components_menuItem__ = __webpack_require__("4NyL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_managers_storageManager__ = __webpack_require__("ivjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_router__ = __webpack_require__("5oXY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_helpers_screenHelper__ = __webpack_require__("eeIR");








var LayoutComponent = /** @class */ (function () {
    function LayoutComponent(router, renderer, storageManager) {
        this.router = router;
        this.renderer = renderer;
        this.storageManager = storageManager;
        this.menuItems = [];
        this.loading = false;
        this.onResize(null);
    }
    LayoutComponent.prototype.onResize = function (event) {
        this.isMobileMenu = __WEBPACK_IMPORTED_MODULE_7__common_helpers_screenHelper__["a" /* ScreenHelper */].isTabletOrPhone();
        ;
    };
    LayoutComponent.prototype.ngOnDestroy = function () {
        if (!this.body)
            return;
        this.body.classList.remove("nav-open");
    };
    LayoutComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.body = document.getElementsByTagName('body')[0];
        var isWindows = navigator.platform.indexOf('Win') > -1;
        if (isWindows) {
            // if we are on windows OS we activate the perfectScrollbar function
            this.body.classList.add("perfect-scrollbar-on");
        }
        else {
            this.body.classList.add("perfect-scrollbar-off");
        }
        if (isWindows) {
            __WEBPACK_IMPORTED_MODULE_3_perfect_scrollbar__["initialize"](this.mainPanel.nativeElement);
        }
        this.router.events.subscribe(function (val) {
            if (val instanceof __WEBPACK_IMPORTED_MODULE_6__angular_router__["f" /* NavigationStart */]) {
                _this.loading = true;
                if (_this.navBar && _this.isMobileMenu && _this.navBar.sidebarVisible)
                    _this.navBar.sidebarToggle();
            }
            else if (val instanceof __WEBPACK_IMPORTED_MODULE_6__angular_router__["e" /* NavigationEnd */])
                _this.loading = false;
            else if (val instanceof __WEBPACK_IMPORTED_MODULE_6__angular_router__["d" /* GuardsCheckEnd */] && !val.shouldActivate) {
                _this.loading = false;
            }
            if (!(val instanceof __WEBPACK_IMPORTED_MODULE_6__angular_router__["e" /* NavigationEnd */])) {
                return;
            }
            _this.mainPanel.nativeElement.scrollTop = 0;
            //TODO Resolver
        });
        this.storageManager.getCurrentUser().then(function (user) {
            var disabled = false;
            _this.menuItems = [
                new __WEBPACK_IMPORTED_MODULE_4__objects_components_menuItem__["a" /* MenuItem */]({
                    Name: "Main Dashboard",
                    Path: "/dashboard",
                    Collapsed: true,
                    Icon: 'dashboard',
                    Disabled: disabled,
                    IconClass: 'material-icons',
                    Children: [],
                    ShowCaret: false,
                })
            ];
            _this.menuItems.push(new __WEBPACK_IMPORTED_MODULE_4__objects_components_menuItem__["a" /* MenuItem */]({
                Name: "Calculator",
                Path: "/calculator/agent",
                Icon: 'iso',
                Collapsed: true,
                IconClass: 'material-icons',
                Disabled: disabled,
                Children: [],
                ShowCaret: false
            }));
            _this.menuItems.push(new __WEBPACK_IMPORTED_MODULE_4__objects_components_menuItem__["a" /* MenuItem */]({
                Name: 'Customers',
                Path: '/management/customer',
                Icon: 'recent_actors',
                IconClass: 'material-icons',
                Children: [],
                ShowButton: true,
                ButtonText: "+",
                ButtonHandler: function () { return _this.customerModal.show(); }
            }));
            _this.menuItems.push(new __WEBPACK_IMPORTED_MODULE_4__objects_components_menuItem__["a" /* MenuItem */]({
                Name: 'Management',
                Path: '',
                Icon: 'folder_shared',
                Collapsed: true,
                IconClass: 'material-icons',
                Disabled: disabled,
                Children: [
                    // by task https://jira.ak-tech.com/browse/BB-3054
                    // new MenuItem({
                    //     Name: 'Agents',
                    //     Path: '/management/agent',
                    //     Icon: 'perm_contact_calendar',
                    //     IconClass: 'material-icons',
                    //     Children: []
                    // }),
                    new __WEBPACK_IMPORTED_MODULE_4__objects_components_menuItem__["a" /* MenuItem */]({
                        Name: 'Orders',
                        Path: '/management/order',
                        Icon: 'receipt',
                        IconClass: 'material-icons',
                        Children: []
                    }),
                    new __WEBPACK_IMPORTED_MODULE_4__objects_components_menuItem__["a" /* MenuItem */]({
                        Name: 'Products',
                        Path: '/management/product',
                        Icon: 'card_travel',
                        IconClass: 'material-icons',
                        Children: []
                    }),
                    new __WEBPACK_IMPORTED_MODULE_4__objects_components_menuItem__["a" /* MenuItem */]({
                        Name: 'Locations',
                        Path: '/management/location',
                        Icon: 'pin_drop',
                        IconClass: 'material-icons',
                        Children: []
                    }),
                    new __WEBPACK_IMPORTED_MODULE_4__objects_components_menuItem__["a" /* MenuItem */]({
                        Name: 'Amazon Sellers',
                        Path: '/management/amazon/sellers',
                        Icon: 'perm_contact_calendar',
                        IconClass: 'material-icons',
                        Children: []
                    }),
                    new __WEBPACK_IMPORTED_MODULE_4__objects_components_menuItem__["a" /* MenuItem */]({
                        Name: 'Customers Import',
                        Path: '/management/customersImport',
                        Icon: 'note_add',
                        IconClass: 'material-icons',
                        Children: []
                    }),
                ]
            }));
            _this.menuItems.push(new __WEBPACK_IMPORTED_MODULE_4__objects_components_menuItem__["a" /* MenuItem */]({
                Name: 'Reports',
                Path: '',
                Icon: 'assignment_late',
                Collapsed: true,
                IconClass: 'material-icons',
                Disabled: disabled,
                Children: [
                    new __WEBPACK_IMPORTED_MODULE_4__objects_components_menuItem__["a" /* MenuItem */]({
                        Name: 'Brokerage fees',
                        Path: '/report/fee',
                        Icon: 'monetization_on',
                        IconClass: 'material-icons',
                        Children: []
                    }),
                    new __WEBPACK_IMPORTED_MODULE_4__objects_components_menuItem__["a" /* MenuItem */]({
                        Name: 'Quotes',
                        Path: '/report/quantity',
                        Icon: 'filter_9_plus',
                        IconClass: 'material-icons',
                        Children: []
                    }),
                    new __WEBPACK_IMPORTED_MODULE_4__objects_components_menuItem__["a" /* MenuItem */]({
                        Name: 'RNS Status',
                        Path: '/report/rns/status',
                        Icon: 'filter_9_plus',
                        IconClass: 'material-icons',
                        Children: []
                    })
                ]
            }));
            _this.menuItems.push(new __WEBPACK_IMPORTED_MODULE_4__objects_components_menuItem__["a" /* MenuItem */]({
                Name: 'Settings',
                Path: '',
                Collapsed: true,
                Icon: 'settings',
                IconClass: 'material-icons',
                ShowCaret: false,
                Disabled: true,
                Children: []
            }));
            _this.menuItems.push(new __WEBPACK_IMPORTED_MODULE_4__objects_components_menuItem__["a" /* MenuItem */]({
                Name: 'Zonos',
                Path: '/zonos',
                Collapsed: true,
                Icon: 'request_quote',
                IconClass: 'material-icons',
                ShowCaret: false,
                Children: []
            }));
            _this.menuItems = _this.filterMenuItems(_this.menuItems, user);
        });
    };
    LayoutComponent.prototype.hideSelect2 = function () {
        var select = $('select.select2');
        select.each(function () {
            $(this).select2('close');
        });
    };
    LayoutComponent.prototype.ngAfterViewInit = function () {
        var spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");
    };
    LayoutComponent.prototype.filterMenuItems = function (items, user) {
        var superAdminGroup = user.Groups.find(function (x) { return x.Name == 'Super Admin'; });
        if (superAdminGroup != null)
            return items;
        var clientAdmin = user.Groups.find(function (x) { return x.Name == 'Client Admin'; });
        var userAdmin = user.Groups.find(function (x) { return x.Name == 'User Admin'; });
        var managementMenuItem = items.find(function (x) { return x.Name == 'Management'; });
        if (clientAdmin && managementMenuItem) {
            var agentsMenuItem = managementMenuItem.Children.find(function (x) { return x.Name == 'Agents'; });
            if (agentsMenuItem && !userAdmin) {
                managementMenuItem.Children.splice(managementMenuItem.Children.indexOf(agentsMenuItem), 1);
            }
            return items;
        }
        if (managementMenuItem)
            managementMenuItem.Children = managementMenuItem.Children.filter(function (x) { return x.Name == 'Agents'; });
        return [managementMenuItem];
    };
    LayoutComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_6__angular_router__["n" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] }, { type: __WEBPACK_IMPORTED_MODULE_5__common_managers_storageManager__["a" /* StorageManager */] }]; };
    return LayoutComponent;
}());

//# sourceMappingURL=layout.component.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "17ct":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SortDirection;
(function (SortDirection) {
    SortDirection["asc"] = "asc";
    SortDirection["desc"] = "desc";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
//# sourceMappingURL=sort-direction.type.js.map

/***/ }),

/***/ "214W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var platform_browser_1 = __webpack_require__("Qbdm");
/**
 * Gets the width of the scrollbar.  Nesc for windows
 * http://stackoverflow.com/a/13382873/888165
 */
var ScrollbarHelper = /** @class */ (function () {
    function ScrollbarHelper(document) {
        this.document = document;
        this.width = this.getWidth();
    }
    ScrollbarHelper.prototype.getWidth = function () {
        var outer = this.document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.width = '100px';
        outer.style.msOverflowStyle = 'scrollbar';
        this.document.body.appendChild(outer);
        var widthNoScroll = outer.offsetWidth;
        outer.style.overflow = 'scroll';
        var inner = this.document.createElement('div');
        inner.style.width = '100%';
        outer.appendChild(inner);
        var widthWithScroll = inner.offsetWidth;
        outer.parentNode.removeChild(outer);
        return widthNoScroll - widthWithScroll;
    };
    ScrollbarHelper = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Inject(platform_browser_1.DOCUMENT)),
        __metadata("design:paramtypes", [Object])
    ], ScrollbarHelper);
    return ScrollbarHelper;
}());
exports.ScrollbarHelper = ScrollbarHelper;
//# sourceMappingURL=scrollbar-helper.service.js.map

/***/ }),

/***/ "24Wi":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["$"] = __webpack_require__("ndXn");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "24Wip":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),

/***/ "2LVV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var column_header_directive_1 = __webpack_require__("sUlX");
var column_cell_directive_1 = __webpack_require__("2tXe");
var DataTableColumnDirective = /** @class */ (function () {
    function DataTableColumnDirective() {
    }
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableColumnDirective.prototype, "name", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableColumnDirective.prototype, "prop", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableColumnDirective.prototype, "frozenLeft", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableColumnDirective.prototype, "frozenRight", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableColumnDirective.prototype, "flexGrow", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableColumnDirective.prototype, "resizeable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableColumnDirective.prototype, "comparator", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableColumnDirective.prototype, "pipe", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableColumnDirective.prototype, "sortable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableColumnDirective.prototype, "draggable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableColumnDirective.prototype, "canAutoResize", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableColumnDirective.prototype, "minWidth", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableColumnDirective.prototype, "width", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableColumnDirective.prototype, "maxWidth", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableColumnDirective.prototype, "checkboxable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableColumnDirective.prototype, "headerCheckboxable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableColumnDirective.prototype, "headerClass", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableColumnDirective.prototype, "cellClass", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Function)
    ], DataTableColumnDirective.prototype, "summaryFunc", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", core_1.TemplateRef)
    ], DataTableColumnDirective.prototype, "summaryTemplate", void 0);
    __decorate([
        core_1.Input(),
        core_1.ContentChild(column_cell_directive_1.DataTableColumnCellDirective, { read: core_1.TemplateRef }),
        __metadata("design:type", core_1.TemplateRef)
    ], DataTableColumnDirective.prototype, "cellTemplate", void 0);
    __decorate([
        core_1.Input(),
        core_1.ContentChild(column_header_directive_1.DataTableColumnHeaderDirective, { read: core_1.TemplateRef }),
        __metadata("design:type", core_1.TemplateRef)
    ], DataTableColumnDirective.prototype, "headerTemplate", void 0);
    DataTableColumnDirective = __decorate([
        core_1.Directive({ selector: 'ngx-datatable-column' })
    ], DataTableColumnDirective);
    return DataTableColumnDirective;
}());
exports.DataTableColumnDirective = DataTableColumnDirective;
//# sourceMappingURL=column.directive.js.map

/***/ }),

/***/ "2dA3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SortType;
(function (SortType) {
    SortType["single"] = "single";
    SortType["multi"] = "multi";
})(SortType = exports.SortType || (exports.SortType = {}));
//# sourceMappingURL=sort.type.js.map

/***/ }),

/***/ "2tXe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var DataTableColumnCellDirective = /** @class */ (function () {
    function DataTableColumnCellDirective(template) {
        this.template = template;
    }
    DataTableColumnCellDirective = __decorate([
        core_1.Directive({ selector: '[ngx-datatable-cell-template]' }),
        __metadata("design:paramtypes", [core_1.TemplateRef])
    ], DataTableColumnCellDirective);
    return DataTableColumnCellDirective;
}());
exports.DataTableColumnCellDirective = DataTableColumnCellDirective;
//# sourceMappingURL=column-cell.directive.js.map

/***/ }),

/***/ "2xC4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var types_1 = __webpack_require__("j2I9");
var utils_1 = __webpack_require__("x6Zf");
var events_1 = __webpack_require__("NBsw");
var DataTableHeaderCellComponent = /** @class */ (function () {
    function DataTableHeaderCellComponent(cd) {
        this.cd = cd;
        this.sort = new core_1.EventEmitter();
        this.select = new core_1.EventEmitter();
        this.columnContextmenu = new core_1.EventEmitter(false);
        this.sortFn = this.onSort.bind(this);
        this.selectFn = this.select.emit.bind(this.select);
        this.cellContext = {
            column: this.column,
            sortDir: this.sortDir,
            sortFn: this.sortFn,
            allRowsSelected: this.allRowsSelected,
            selectFn: this.selectFn
        };
    }
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "allRowsSelected", {
        get: function () {
            return this._allRowsSelected;
        },
        set: function (value) {
            this._allRowsSelected = value;
            this.cellContext.allRowsSelected = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "column", {
        get: function () {
            return this._column;
        },
        set: function (column) {
            this._column = column;
            this.cellContext.column = column;
            this.cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "sorts", {
        get: function () {
            return this._sorts;
        },
        set: function (val) {
            this._sorts = val;
            this.sortDir = this.calcSortDir(val);
            this.cellContext.sortDir = this.sortDir;
            this.sortClass = this.calcSortClass(this.sortDir);
            this.cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "columnCssClasses", {
        get: function () {
            var cls = 'datatable-header-cell';
            if (this.column.sortable)
                cls += ' sortable';
            if (this.column.resizeable)
                cls += ' resizeable';
            if (this.column.headerClass) {
                if (typeof this.column.headerClass === 'string') {
                    cls += ' ' + this.column.headerClass;
                }
                else if (typeof this.column.headerClass === 'function') {
                    var res = this.column.headerClass({
                        column: this.column
                    });
                    if (typeof res === 'string') {
                        cls += res;
                    }
                    else if (typeof res === 'object') {
                        var keys = Object.keys(res);
                        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                            var k = keys_1[_i];
                            if (res[k] === true)
                                cls += " " + k;
                        }
                    }
                }
            }
            var sortDir = this.sortDir;
            if (sortDir) {
                cls += " sort-active sort-" + sortDir;
            }
            return cls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "name", {
        get: function () {
            // guaranteed to have a value by setColumnDefaults() in column-helper.ts
            return this.column.headerTemplate === undefined ? this.column.name : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "minWidth", {
        get: function () {
            return this.column.minWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "maxWidth", {
        get: function () {
            return this.column.maxWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "width", {
        get: function () {
            return this.column.width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "isCheckboxable", {
        get: function () {
            return this.column.checkboxable &&
                this.column.headerCheckboxable &&
                this.selectionType === types_1.SelectionType.checkbox;
        },
        enumerable: true,
        configurable: true
    });
    DataTableHeaderCellComponent.prototype.onContextmenu = function ($event) {
        this.columnContextmenu.emit({ event: $event, column: this.column });
    };
    DataTableHeaderCellComponent.prototype.calcSortDir = function (sorts) {
        var _this = this;
        if (sorts && this.column) {
            var sort = sorts.find(function (s) {
                return s.prop === _this.column.prop;
            });
            if (sort)
                return sort.dir;
        }
    };
    DataTableHeaderCellComponent.prototype.onSort = function () {
        if (!this.column.sortable)
            return;
        var newValue = utils_1.nextSortDir(this.sortType, this.sortDir);
        this.sort.emit({
            column: this.column,
            prevValue: this.sortDir,
            newValue: newValue
        });
    };
    DataTableHeaderCellComponent.prototype.calcSortClass = function (sortDir) {
        if (sortDir === types_1.SortDirection.asc) {
            return "sort-btn sort-asc " + this.sortAscendingIcon;
        }
        else if (sortDir === types_1.SortDirection.desc) {
            return "sort-btn sort-desc " + this.sortDescendingIcon;
        }
        else {
            return "sort-btn";
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableHeaderCellComponent.prototype, "sortType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableHeaderCellComponent.prototype, "sortAscendingIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableHeaderCellComponent.prototype, "sortDescendingIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], DataTableHeaderCellComponent.prototype, "allRowsSelected", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableHeaderCellComponent.prototype, "selectionType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], DataTableHeaderCellComponent.prototype, "column", null);
    __decorate([
        core_1.HostBinding('style.height.px'),
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableHeaderCellComponent.prototype, "headerHeight", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], DataTableHeaderCellComponent.prototype, "sorts", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTableHeaderCellComponent.prototype, "sort", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTableHeaderCellComponent.prototype, "select", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], DataTableHeaderCellComponent.prototype, "columnContextmenu", void 0);
    __decorate([
        core_1.HostBinding('class'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], DataTableHeaderCellComponent.prototype, "columnCssClasses", null);
    __decorate([
        core_1.HostBinding('attr.title'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], DataTableHeaderCellComponent.prototype, "name", null);
    __decorate([
        core_1.HostBinding('style.minWidth.px'),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], DataTableHeaderCellComponent.prototype, "minWidth", null);
    __decorate([
        core_1.HostBinding('style.maxWidth.px'),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], DataTableHeaderCellComponent.prototype, "maxWidth", null);
    __decorate([
        core_1.HostBinding('style.width.px'),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], DataTableHeaderCellComponent.prototype, "width", null);
    __decorate([
        core_1.HostListener('contextmenu', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DataTableHeaderCellComponent.prototype, "onContextmenu", null);
    DataTableHeaderCellComponent = __decorate([
        core_1.Component({
            selector: 'datatable-header-cell',
            template: "\n    <div class=\"datatable-header-cell-template-wrap\">\n      <label\n        *ngIf=\"isCheckboxable\"\n        class=\"datatable-checkbox\">\n        <input\n          type=\"checkbox\"\n          [checked]=\"allRowsSelected\"\n          (change)=\"select.emit(!allRowsSelected)\"\n        />\n      </label>\n      <span\n        *ngIf=\"!column.headerTemplate\"\n        class=\"datatable-header-cell-wrapper\">\n        <span\n          class=\"datatable-header-cell-label draggable\"\n          (click)=\"onSort()\"\n          [innerHTML]=\"name\">\n        </span>\n      </span>\n      <ng-template\n        *ngIf=\"column.headerTemplate\"\n        [ngTemplateOutlet]=\"column.headerTemplate\"\n        [ngTemplateOutletContext]=\"cellContext\">\n      </ng-template>\n      <span\n        (click)=\"onSort()\"\n        [class]=\"sortClass\">\n      </span>\n    </div>\n  ",
            host: {
                class: 'datatable-header-cell'
            },
            changeDetection: core_1.ChangeDetectionStrategy.OnPush
        }),
        __metadata("design:paramtypes", [core_1.ChangeDetectorRef])
    ], DataTableHeaderCellComponent);
    return DataTableHeaderCellComponent;
}());
exports.DataTableHeaderCellComponent = DataTableHeaderCellComponent;
//# sourceMappingURL=header-cell.component.js.map

/***/ }),

/***/ "3Ddi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CanadianCurrencyCode; });
/**
 * Created by vlad.p on 8/22/2017.
 */
var CanadianCurrencyCode = /** @class */ (function () {
    function CanadianCurrencyCode() {
    }
    return CanadianCurrencyCode;
}());

//# sourceMappingURL=canadianCurrencyCode.js.map

/***/ }),

/***/ "4/R3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("TToO");

// CONCATENATED MODULE: ./app/objects/requests/baseModifyRequest.ts
/**
 * Created by alex.y on 10/12/2017.
 */
var BaseModifyRequest = /** @class */ (function () {
    function BaseModifyRequest() {
    }
    return BaseModifyRequest;
}());

//# sourceMappingURL=baseModifyRequest.js.map
// CONCATENATED MODULE: ./app/objects/requests/customerModifyRequest.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customerModifyRequest_CustomerModifyRequest; });


/**
 * Created by alex.y on 10/12/2017.
 */
var customerModifyRequest_CustomerModifyRequest = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](CustomerModifyRequest, _super);
    function CustomerModifyRequest(obj) {
        var _this = _super.call(this) || this;
        Object.assign(_this, obj);
        return _this;
    }
    return CustomerModifyRequest;
}(BaseModifyRequest));

//# sourceMappingURL=customerModifyRequest.js.map

/***/ }),

/***/ "41dP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentCompany; });
var PaymentCompany;
(function (PaymentCompany) {
    PaymentCompany[PaymentCompany["None"] = 0] = "None";
    PaymentCompany[PaymentCompany["CargoWise"] = 1] = "CargoWise";
    PaymentCompany[PaymentCompany["NexGen"] = 2] = "NexGen";
})(PaymentCompany || (PaymentCompany = {}));
//# sourceMappingURL=paymentCompany.js.map

/***/ }),

/***/ "46qw":
/***/ (function(module, exports, __webpack_require__) {

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__("S1aP"));
var services = __webpack_require__("S1aP");
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    services: services
};
//# sourceMappingURL=ng2-cookies.js.map

/***/ }),

/***/ "4NyL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuItem; });
var MenuItem = /** @class */ (function () {
    function MenuItem(obj) {
        this.ShowCaret = true;
        this.Exact = true;
        Object.assign(this, obj);
        this.Collapsed = this.Collapsed == null ? true : this.Collapsed;
        this.Disabled = this.Disabled || false;
        this.Exact = this.Exact || true;
    }
    return MenuItem;
}());

//# sourceMappingURL=menuItem.js.map

/***/ }),

/***/ "4gpe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var DataTablePagerComponent = /** @class */ (function () {
    function DataTablePagerComponent() {
        this.change = new core_1.EventEmitter();
        this._count = 0;
        this._page = 1;
        this._size = 0;
    }
    Object.defineProperty(DataTablePagerComponent.prototype, "size", {
        get: function () {
            return this._size;
        },
        set: function (val) {
            this._size = val;
            this.pages = this.calcPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTablePagerComponent.prototype, "count", {
        get: function () {
            return this._count;
        },
        set: function (val) {
            this._count = val;
            this.pages = this.calcPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTablePagerComponent.prototype, "page", {
        get: function () {
            return this._page;
        },
        set: function (val) {
            this._page = val;
            this.pages = this.calcPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTablePagerComponent.prototype, "totalPages", {
        get: function () {
            var count = this.size < 1 ? 1 : Math.ceil(this.count / this.size);
            return Math.max(count || 0, 1);
        },
        enumerable: true,
        configurable: true
    });
    DataTablePagerComponent.prototype.canPrevious = function () {
        return this.page > 1;
    };
    DataTablePagerComponent.prototype.canNext = function () {
        return this.page < this.totalPages;
    };
    DataTablePagerComponent.prototype.prevPage = function () {
        this.selectPage(this.page - 1);
    };
    DataTablePagerComponent.prototype.nextPage = function () {
        this.selectPage(this.page + 1);
    };
    DataTablePagerComponent.prototype.selectPage = function (page) {
        if (page > 0 && page <= this.totalPages && page !== this.page) {
            this.page = page;
            this.change.emit({
                page: page
            });
        }
    };
    DataTablePagerComponent.prototype.calcPages = function (page) {
        var pages = [];
        var startPage = 1;
        var endPage = this.totalPages;
        var maxSize = 5;
        var isMaxSized = maxSize < this.totalPages;
        page = page || this.page;
        if (isMaxSized) {
            startPage = page - Math.floor(maxSize / 2);
            endPage = page + Math.floor(maxSize / 2);
            if (startPage < 1) {
                startPage = 1;
                endPage = Math.min(startPage + maxSize - 1, this.totalPages);
            }
            else if (endPage > this.totalPages) {
                startPage = Math.max(this.totalPages - maxSize + 1, 1);
                endPage = this.totalPages;
            }
        }
        for (var num = startPage; num <= endPage; num++) {
            pages.push({
                number: num,
                text: num
            });
        }
        return pages;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTablePagerComponent.prototype, "pagerLeftArrowIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTablePagerComponent.prototype, "pagerRightArrowIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTablePagerComponent.prototype, "pagerPreviousIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTablePagerComponent.prototype, "pagerNextIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], DataTablePagerComponent.prototype, "size", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], DataTablePagerComponent.prototype, "count", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], DataTablePagerComponent.prototype, "page", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTablePagerComponent.prototype, "change", void 0);
    DataTablePagerComponent = __decorate([
        core_1.Component({
            selector: 'datatable-pager',
            template: "\n    <ul class=\"pager\">\n      <li [class.disabled]=\"!canPrevious()\">\n        <a\n          role=\"button\"\n          aria-label=\"go to first page\"\n          href=\"javascript:void(0)\"\n          (click)=\"selectPage(1)\">\n          <i class=\"{{pagerPreviousIcon}}\"></i>\n        </a>\n      </li>\n      <li [class.disabled]=\"!canPrevious()\">\n        <a\n          role=\"button\"\n          aria-label=\"go to previous page\"\n          href=\"javascript:void(0)\"\n          (click)=\"prevPage()\">\n          <i class=\"{{pagerLeftArrowIcon}}\"></i>\n        </a>\n      </li>\n      <li\n        role=\"button\"\n        [attr.aria-label]=\"'page ' + pg.number\"\n        class=\"pages\"\n        *ngFor=\"let pg of pages\"\n        [class.active]=\"pg.number === page\">\n        <a\n          href=\"javascript:void(0)\"\n          (click)=\"selectPage(pg.number)\">\n          {{pg.text}}\n        </a>\n      </li>\n      <li [class.disabled]=\"!canNext()\">\n        <a\n          role=\"button\"\n          aria-label=\"go to next page\"\n          href=\"javascript:void(0)\"\n          (click)=\"nextPage()\">\n          <i class=\"{{pagerRightArrowIcon}}\"></i>\n        </a>\n      </li>\n      <li [class.disabled]=\"!canNext()\">\n        <a\n          role=\"button\"\n          aria-label=\"go to last page\"\n          href=\"javascript:void(0)\"\n          (click)=\"selectPage(totalPages)\">\n          <i class=\"{{pagerNextIcon}}\"></i>\n        </a>\n      </li>\n    </ul>\n  ",
            host: {
                class: 'datatable-pager'
            },
            changeDetection: core_1.ChangeDetectionStrategy.OnPush
        })
    ], DataTablePagerComponent);
    return DataTablePagerComponent;
}());
exports.DataTablePagerComponent = DataTablePagerComponent;
//# sourceMappingURL=pager.component.js.map

/***/ }),

/***/ "5Lgg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalculatorService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__ = __webpack_require__("EEr4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__);

var CalculatorService = /** @class */ (function () {
    function CalculatorService() {
        this.handler = new __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["Subject"]();
        this.isVehicleHandler = new __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["Subject"]();
    }
    CalculatorService.prototype.broadcast = function (location) {
        this.handler.next(location);
    };
    CalculatorService.prototype.subscribe = function (callback) {
        return this.handler.subscribe(callback);
    };
    CalculatorService.prototype.broadcastIsVeh = function (isVehicle) {
        this.isVehicleHandler.next(isVehicle);
    };
    CalculatorService.prototype.subscribeIsVeh = function (callback) {
        return this.isVehicleHandler.subscribe(callback);
    };
    CalculatorService.prototype.isMobile = function () {
        if (screen.width > 767)
            return false;
        return true;
    };
    return CalculatorService;
}());

//# sourceMappingURL=calculatorService.js.map

/***/ }),

/***/ "5hg6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("sQpZ"));
__export(__webpack_require__("hIqV"));
__export(__webpack_require__("KPjg"));
__export(__webpack_require__("yl66"));
__export(__webpack_require__("Fglw"));
__export(__webpack_require__("p4tm"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "6hVY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__("j2I9");
var column_prop_getters_1 = __webpack_require__("sXN4");
/**
 * Gets the next sort direction
 */
function nextSortDir(sortType, current) {
    if (sortType === types_1.SortType.single) {
        if (current === types_1.SortDirection.asc) {
            return types_1.SortDirection.desc;
        }
        else {
            return types_1.SortDirection.asc;
        }
    }
    else {
        if (!current) {
            return types_1.SortDirection.asc;
        }
        else if (current === types_1.SortDirection.asc) {
            return types_1.SortDirection.desc;
        }
        else if (current === types_1.SortDirection.desc) {
            return undefined;
        }
        // avoid TS7030: Not all code paths return a value.
        return undefined;
    }
}
exports.nextSortDir = nextSortDir;
/**
 * Adapted from fueld-ui on 6/216
 * https://github.com/FuelInteractive/fuel-ui/tree/master/src/pipes/OrderBy
 */
function orderByComparator(a, b) {
    if (a === null || typeof a === 'undefined')
        a = 0;
    if (b === null || typeof b === 'undefined')
        b = 0;
    if (a instanceof Date && b instanceof Date) {
        if (a < b)
            return -1;
        if (a > b)
            return 1;
    }
    else if ((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))) {
        // Convert to string in case of a=0 or b=0
        a = String(a);
        b = String(b);
        // Isn't a number so lowercase the string to properly compare
        if (a.toLowerCase() < b.toLowerCase())
            return -1;
        if (a.toLowerCase() > b.toLowerCase())
            return 1;
    }
    else {
        // Parse strings as numbers to compare properly
        if (parseFloat(a) < parseFloat(b))
            return -1;
        if (parseFloat(a) > parseFloat(b))
            return 1;
    }
    // equal each other
    return 0;
}
exports.orderByComparator = orderByComparator;
/**
 * creates a shallow copy of the `rows` input and returns the sorted copy. this function
 * does not sort the `rows` argument in place
 */
function sortRows(rows, columns, dirs) {
    if (!rows)
        return [];
    if (!dirs || !dirs.length || !columns)
        return rows.slice();
    /**
     * record the row ordering of results from prior sort operations (if applicable)
     * this is necessary to guarantee stable sorting behavior
     */
    var rowToIndexMap = new Map();
    rows.forEach(function (row, index) { return rowToIndexMap.set(row, index); });
    var temp = rows.slice();
    var cols = columns.reduce(function (obj, col) {
        if (col.comparator && typeof col.comparator === 'function') {
            obj[col.prop] = col.comparator;
        }
        return obj;
    }, {});
    // cache valueGetter and compareFn so that they
    // do not need to be looked-up in the sort function body
    var cachedDirs = dirs.map(function (dir) {
        var prop = dir.prop;
        return {
            prop: prop,
            dir: dir.dir,
            valueGetter: column_prop_getters_1.getterForProp(prop),
            compareFn: cols[prop] || orderByComparator
        };
    });
    return temp.sort(function (rowA, rowB) {
        for (var _i = 0, cachedDirs_1 = cachedDirs; _i < cachedDirs_1.length; _i++) {
            var cachedDir = cachedDirs_1[_i];
            // Get property and valuegetters for column to be sorted
            var prop = cachedDir.prop, valueGetter = cachedDir.valueGetter;
            // Get A and B cell values from rows based on properties of the columns
            var propA = valueGetter(rowA, prop);
            var propB = valueGetter(rowB, prop);
            // Compare function gets five parameters:
            // Two cell values to be compared as propA and propB
            // Two rows corresponding to the cells as rowA and rowB
            // Direction of the sort for this column as SortDirection
            // Compare can be a standard JS comparison function (a,b) => -1|0|1
            // as additional parameters are silently ignored. The whole row and sort
            // direction enable more complex sort logic.
            var comparison = cachedDir.dir !== types_1.SortDirection.desc ?
                cachedDir.compareFn(propA, propB, rowA, rowB, cachedDir.dir) :
                -cachedDir.compareFn(propA, propB, rowA, rowB, cachedDir.dir);
            // Don't return 0 yet in case of needing to sort by next property
            if (comparison !== 0)
                return comparison;
        }
        if (!(rowToIndexMap.has(rowA) && rowToIndexMap.has(rowB)))
            return 0;
        /**
         * all else being equal, preserve original order of the rows (stable sort)
         */
        return rowToIndexMap.get(rowA) < rowToIndexMap.get(rowB) ? -1 : 1;
    });
}
exports.sortRows = sortRows;
//# sourceMappingURL=sort.js.map

/***/ }),

/***/ "72WZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrderService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseService__ = __webpack_require__("IhmT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__("Fzro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ng2_cookies_ng2_cookies__ = __webpack_require__("46qw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ng2_cookies_ng2_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ng2_cookies_ng2_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__("5oXY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configService__ = __webpack_require__("cfSW");






/**
 * Created by alex.y on 8/9/2017.
 */
var OrderService = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](OrderService, _super);
    function OrderService(http, configService, activatedRoute) {
        var _this = _super.call(this, http, configService) || this;
        _this.http = http;
        _this.configService = configService;
        _this.activatedRoute = activatedRoute;
        return _this;
    }
    OrderService.prototype.search = function (request) {
        var params = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["l" /* URLSearchParams */]();
        params.append('top', request.Top.toString());
        params.append('skip', request.Skip.toString());
        params.append('orderBy', request.OrderBy.PropertyName);
        params.append('orderByDir', request.OrderBy.OrderBy.toString());
        params.append('query', encodeURIComponent(request.Query.toString()));
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "order/search",
            search: params
        })).then(function (r) { return r.Data; });
    };
    OrderService.prototype.modify = function (order) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "order",
            body: order
        }));
    };
    OrderService.prototype.create = function (order, viewType) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "order?viewType=" + viewType,
            body: order
        }));
    };
    OrderService.prototype.publicCreate = function (order, marketingUrl, viewType) {
        var googleTrackingId = this.activatedRoute.snapshot.queryParams["gclid"];
        var utm_source = this.activatedRoute.snapshot.queryParams["utm_source"];
        var utm_medium = this.activatedRoute.snapshot.queryParams["utm_medium"];
        var utm_campaign = this.activatedRoute.snapshot.queryParams["utm_campaign"];
        var utm_term = this.activatedRoute.snapshot.queryParams["utm_term"];
        var utm_content = this.activatedRoute.snapshot.queryParams["utm_content"];
        if (String.isNullOrEmpty(googleTrackingId)) {
            var cookieNames = __WEBPACK_IMPORTED_MODULE_3_ng2_cookies_ng2_cookies__["Cookie"].getAll();
            for (var cookieName in cookieNames) {
                if (cookieName.includes("gac_")) {
                    var cookie = __WEBPACK_IMPORTED_MODULE_3_ng2_cookies_ng2_cookies__["Cookie"].get(cookieName);
                    if (cookie) {
                        var sp = cookie.split('.');
                        if (sp.length > 2) {
                            googleTrackingId = sp[2];
                        }
                        else {
                            googleTrackingId = cookie;
                        }
                    }
                }
            }
        }
        if (String.isNullOrEmpty(googleTrackingId)) {
            var cookieValue = __WEBPACK_IMPORTED_MODULE_3_ng2_cookies_ng2_cookies__["Cookie"].get('__utmz');
            if (cookieValue) {
                var parts = cookieValue.split("|");
                var nameAndValue = parts.find(function (part) { return part.includes('utmgclid'); });
                if (nameAndValue) {
                    googleTrackingId = nameAndValue.split("=")[1];
                }
            }
        }
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "order?marketingUrl=" + marketingUrl + "&googleTrackingId=" + googleTrackingId + "&viewType=" + viewType + "&utm_source=" + utm_source + "&utm_medium=" + utm_medium + "&utm_campaign=" + utm_campaign + "&utm_term=" + utm_term + "&utm_content=" + utm_content,
            body: order
        }));
    };
    OrderService.prototype.update = function (order) {
        return this.put(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "order",
            body: order
        }));
    };
    OrderService.prototype.getById = function (id) {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "order/" + id,
        }));
    };
    OrderService.prototype.getEmailOrder = function (id, email) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "order/ccrequestemail",
            body: { orderId: id, email: email }
        }));
    };
    OrderService.prototype.createInvoice = function (orderId) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "order/" + orderId + "/invoice"
        }));
    };
    OrderService.prototype.sendInvoice = function (orderId, invoiceId) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "order/" + orderId + "/invoice/" + invoiceId + "/send"
        }));
    };
    OrderService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_http__["e" /* Http */] }, { type: __WEBPACK_IMPORTED_MODULE_5__configService__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* ActivatedRoute */] }]; };
    return OrderService;
}(__WEBPACK_IMPORTED_MODULE_1__baseService__["a" /* BaseApi */]));

//# sourceMappingURL=orderService.js.map

/***/ }),

/***/ "7A4S":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {if (process.env.NODE_ENV === 'production') {
  module.exports = __webpack_require__("8ULe");
} else {
  module.exports = __webpack_require__("MT2O");
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "7P1x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CurrencyEnum; });
/**
 * Created by alex.y on 7/20/2017.
 */
var CurrencyEnum;
(function (CurrencyEnum) {
    CurrencyEnum["FXAUDCAD"] = "Australian dollar";
    CurrencyEnum["FXBRLCAD"] = "Brazilian real";
    CurrencyEnum["FXCNYCAD"] = "Chinese renminbi";
    CurrencyEnum["FXEURCAD"] = "European euro";
    CurrencyEnum["FXHKDCAD"] = "Hong Kong dollar";
    CurrencyEnum["FXINRCAD"] = "Indian rupee";
    CurrencyEnum["FXIDRCAD"] = "Indonesian rupiah";
    CurrencyEnum["FXJPYCAD"] = "Japanese yen";
    CurrencyEnum["FXMYRCAD"] = "Malaysian ringgit";
    CurrencyEnum["FXMXNCAD"] = "Mexican peso";
    CurrencyEnum["FXNZDCAD"] = "New Zealand dollar";
    CurrencyEnum["FXNOKCAD"] = "Norwegian krone";
    CurrencyEnum["FXPENCAD"] = "Peruvian new sol";
    CurrencyEnum["FXRUBCAD"] = "Russian ruble";
    CurrencyEnum["FXSARCAD"] = "Saudi riyal";
    CurrencyEnum["FXSGDCAD"] = "Singapore dollar";
    CurrencyEnum["FXZARCAD"] = "South African";
    CurrencyEnum["FXKRWCAD"] = "South Korean";
    CurrencyEnum["FXSEKCAD"] = "Swedish krona";
    CurrencyEnum["FXCHFCAD"] = "Swiss franc";
    CurrencyEnum["FXTWDCAD"] = "Taiwanese dollar";
    CurrencyEnum["FXTHBCAD"] = "Thai baht";
    CurrencyEnum["FXTRYCAD"] = "Turkish lira";
    CurrencyEnum["FXGBPCAD"] = "UK pound";
    CurrencyEnum["FXUSDCAD"] = "US dollar";
    CurrencyEnum["FXVNDCAD"] = "Vietnamese dong";
})(CurrencyEnum || (CurrencyEnum = {}));
//# sourceMappingURL=currencyEnum.js.map

/***/ }),

/***/ "8ULe":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.HelloSign=t():e.HelloSign=t()}(window,function(){return function(e){var t={};function i(n){if(t[n])return t[n].exports;var o=t[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,i),o.l=!0,o.exports}return i.m=e,i.c=t,i.d=function(e,t,n){i.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:n})},i.r=function(e){Object.defineProperty(e,"__esModule",{value:!0})},i.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return i.d(t,"a",t),t},i.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},i.p="",i(i.s=1)}([function(e){e.exports={name:"hellosign-embedded",version:"1.4.3",description:"Embed HelloSign signature requests and templates from within your web application.",homepage:"https://github.com/HelloFax/hellosign-embedded",main:"index.js",license:"ISC",scripts:{build:"webpack",demo:"npm run build && npm start --prefix=demo",prerelease:"node scripts/pre-release.js",prepublishOnly:"npm install && npm run build && npm run prerelease",setup:"npm install && npm run build && npm run setup --prefix=demo",test:"mocha test"},repository:{type:"git",url:"https://github.com/HelloFax/hellosign-embedded.git"},author:{name:"HelloSign",email:"api@hellosign.com",url:"https://hellosign.com"},devDependencies:{"@babel/core":"^7.0.0-beta.42","@babel/plugin-proposal-object-rest-spread":"^7.0.0-beta.42","@babel/plugin-transform-object-assign":"^7.0.0-beta.42","@babel/preset-env":"^7.0.0-beta.42","babel-loader":"^8.0.0-beta.2",chai:"^4.1.2",jsdom:"^11.6.2","jsdom-global":"^3.0.2",mocha:"^5.0.4",webpack:"^4.2.0","webpack-cli":"^2.0.13"},files:["umd","index.js"]}},function(e,t,i){"use strict";function n(){return(n=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var i=arguments[t];for(var n in i)Object.prototype.hasOwnProperty.call(i,n)&&(e[n]=i[n])}return e}).apply(this,arguments)}function o(e){return(o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}!function(){var t,r=(t={},window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(e,i,n){t[i]=n}),t);window.isDebugEnabled=!!r.debug&&"true"===r.debug;var s=navigator.userAgent.toLowerCase(),a={cacheBust:0,lastHash:0,intervalId:0,rmCallback:null,defaultDelay:500,hasPostMessage:void 0!==window.postMessage,_serializeMessageValue:function(e){return"object"===o(e)&&(e=JSON.stringify(e)),encodeURIComponent(e)},send:function(e,t,i){h("XWM Send: Sending Message."),h("  targetUrl: "+t);var n=a;if(t){if("string"!=typeof e){var o=[];for(var r in e)o.push(r+"="+this._serializeMessageValue(e[r]));e=o.join("&")}if(h("  message: "+e),n.hasPostMessage)(i=i||parent).postMessage(e,t.replace(/([^:]+:\/\/[^\/]+).*/,"$1"));else if(t){var s=(new Date).getTime(),l=++n.cacheBust,c=document.getElementById(i);c?c.setAttribute("src",t.replace(/#.*$/,"")+"#"+s+l+"&"+e):parent.location=t.replace(/#.*$/,"")+"#"+s+l+"&"+e}h("XWM Send: Message sent.")}},receive:function(e,t,i){"function"!=typeof e&&d("callback must be a function"),"string"!=typeof t&&d("sourceOrigin must be a string"),h("XWM Receive: Initialize receiver."),h("  callback: "+(e.name?e.name:"Anonymous function")),h("  sourceOrigin: "+t);var n=a;n.hasPostMessage?(e&&(n.rmCallback&&(window.addEventListener?window.removeEventListener("message",n.rmCallback,!1):window.detachEvent("onmessage",n.rmCallback)),n.rmCallback=function(i){if(i.origin!==t&&!new RegExp("[/|.]"+t+"$","i").test(i.origin))return!1;h("XWM Receive: Message received!"),h("  data: "+i.data),h("  sourceOrigin: "+t),e(i)}),window.addEventListener?window.addEventListener("message",n.rmCallback,!1):window.attachEvent("onmessage",n.rmCallback)):(h("XWM Receive: Starting poll..."),n.intervalId&&(clearInterval(n.intervalId),n.intervalId=null),void 0===i&&(i=n.defaultDelay),e&&(i=void 0!==i?i:200,n.intervalId=setInterval(function(){var i=document.location.hash,o=/^#?\d+&/;if(i!==n.lastHash&&o.test(i)){n.lastHash=i;var r=i.replace(o,"");h("XWM Receive: Message received!"),h("  data: "+r),h("  sourceOrigin: "+t),e({data:r})}},i)))}},l={savedViewportContent:"",set:function(){h("Optimizing viewport meta tag for mobile"),this.savedViewportContent=this._getElement().getAttribute("content");var e=this._explodePairs(this.savedViewportContent);e.width="device-width",e["maximum-scale"]="1.0",e["user-scalable"]="no",this._getElement().setAttribute("content",this._joinPairs(e))},restore:function(){h("Restoring viewport meta tag"),this._getElement().setAttribute("content",this.savedViewportContent)},_getElement:function(){var e=document.querySelector("meta[name=viewport]");return e||((e=document.createElement("meta")).setAttribute("name","viewport"),e.setAttribute("content","initial-scale=1.0"),document.head.appendChild(e)),e},_joinPairs:function(e){var t=[];for(var i in e)t.push(i+"="+e[i]);return t.join(", ")},_explodePairs:function(e){var t={};return e.split(",").forEach(function(e){var i=(e=e.trim()).split("=");t[i[0]]=i[1]}),t}},c={VERSION:i(0).version,DEFAULT_UX_VERSION:1,IFRAME_WIDTH_RATIO:.8,DEFAULT_WIDTH:900,DEFAULT_HEIGHT:900,MIN_HEIGHT:480,wrapper:null,iframe:null,overlay:null,cancelButton:null,clientId:null,isOldIE:/msie (8|7|6|5)/gi.test(s),isFF:/firefox/gi.test(s),isOpera:/opera/gi.test(s),isMobile:/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(s),baseUrl:"https://www.hellosign.com",cdnBaseUrl:"https://s3.amazonaws.com/cdn.hellofax.com",XWM:a,CULTURES:{EN_US:"en_US",FR_FR:"fr_FR",DE_DE:"de_DE",SV_SE:"sv_SE",ZH_CN:"zh_CN",DA_DK:"da_DK",NL_NL:"nl_NL",ES_ES:"es_ES",ES_MX:"es_MX",PT_BR:"pt_BR",PL_PL:"pl_PL",init:function(){return this.supportedCultures=[this.EN_US,this.FR_FR,this.DE_DE,this.SV_SE,this.ZH_CN,this.DA_DK,this.NL_NL,this.ES_ES,this.ES_MX,this.PT_BR,this.PL_PL],this}}.init(),isDebugEnabled:window.isDebugEnabled,EVENT_SIGNED:"signature_request_signed",EVENT_DECLINED:"signature_request_declined",EVENT_CANCELED:"signature_request_canceled",EVENT_SENT:"signature_request_sent",EVENT_TEMPLATE_CREATED:"template_created",EVENT_ERROR:"error",init:function(e){this.clientId=e},open:function(e){var t=this,i=this.safeUrl(e.redirectUrl),r=e.messageListener,s=this.safeUrl(e.url);if(this.uxVersion=e.uxVersion||this.DEFAULT_UX_VERSION,this.isDefaultUX=this.uxVersion===this.DEFAULT_UX_VERSION,this.healthCheckTimeoutMs=e.healthCheckTimeoutMs,this.uxVersion&&(s+=(s.indexOf("?")>0?"&":"?")+"ux_version="+this.uxVersion),void 0!==e.debug&&(this.isDebugEnabled=!0===e.debug||"true"==e.debug),void 0!==e.skipDomainVerification&&(this.skipDomainVerification=!0===e.skipDomainVerification||"true"==e.skipDomainVerification),void 0!==e.hideHeader&&(this.hideHeader=!0===e.hideHeader||"true"==e.hideHeader),"object"===o(e.whiteLabelingOptions)?(this.whiteLabelingOptions=JSON.stringify(e.whiteLabelingOptions),this.whiteLabelingOptions=this.whiteLabelingOptions.replace(/#/g,"")):void 0!==e.whiteLabelingOptions&&h("Invalid white labeling options supplied, option will be ignored: "+e.whiteLabelingOptions),this.isInPage=void 0!==e.container,this.container=e.container||document.body,this.isInPage&&void 0!==e.height&&(isNaN(parseInt(e.height,10))||e.height<=0))throw new Error("Invalid iFrame height ("+e.height+") it must be a valid positive number");if(h("Opening HelloSign embedded iFrame with the following params:"),h(e),!s)throw new Error("No url specified");var d=void 0===e.userCulture?this.CULTURES.EN_US:e.userCulture;if(-1===this.inArray(d,this.CULTURES.supportedCultures))throw new Error("Invalid userCulture specified: "+d);s+=s.indexOf("?")>0?"&":"?",i&&(s+="redirect_url="+encodeURIComponent(i)+"&"),s+="parent_url="+encodeURIComponent(document.location.href.replace(/\?.*/,""))+"&",s+=!0===this.skipDomainVerification?"skip_domain_verification=1&":"",s+="client_id="+this.clientId+"&",s+=void 0!==e.requester?"requester="+encodeURIComponent(e.requester)+"&":"",s+="user_culture="+d,this.isDebugEnabled&&(s+="&debug=true"),this.hideHeader&&(s+="&hideHeader=true"),this.whiteLabelingOptions&&(s+="&white_labeling_options="+encodeURI(this.whiteLabelingOptions));var u,p,f,m,g=(s+="&js_version="+this.VERSION).replace(/([^:]+:\/\/[^\/]+).*/,"$1"),b=this.getWindowDimensions(e.height),w={overlay:{position:"fixed",top:"0px",left:"0px",bottom:"0px",right:"0px","z-index":9997,display:"block","background-color":"#222",opacity:.4,"-khtml-opacity":.4,"-moz-opacity":.4,filter:"alpha(opacity=40)","-ms-filter":"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)"},wrapper:this.isInPage?{}:{position:"absolute",top:b.top,left:b.left,"z-index":9998},iframe:this.isInPage?{}:{margin:"1px","background-color":"#FFF","z-index":9998},cancelButton:{position:"absolute",top:"-13px",right:"-13px",width:"30px",height:"30px","background-image":"url("+this.cdnBaseUrl+"/css/fancybox/fancybox.png)","background-position":"-40px 0px",cursor:"pointer","z-index":9999}},v=function(){if(t.iframe){var e={};e=t.isMobile?t.getMobileDimensions():t.getWindowDimensions(),t.wrapper.style.top=e.top,t.wrapper.style.left=e.left,t.wrapper.style.width=e.widthString,t.iframe.style.height=e.heightString,t.iframe.style.width=e.widthString}};if(this.uxVersion>1)if(this.isInPage)w.wrapper.width="100%",w.wrapper.height=b.heightString,w.iframe.width="100%",w.iframe.height=b.heightString,w.iframe.border="none",w.iframe["box-shadow"]="none",w.cancelButton.display="none",this.isMobile&&(w.iframe.width="1px",w.iframe["min-width"]="100%");else if(this.isMobile){var E=this.getMobileDimensions();w.wrapper.position="absolute",w.wrapper.top="0",w.wrapper.left="0",w.wrapper.width=E.widthString,w.wrapper.height=E.heightString,w.iframe.position="absolute",w.iframe.top=0,w.iframe.left=0,w.iframe.width=E.widthString,w.iframe.height=E.heightString,w.iframe.border="none",w.iframe["box-shadow"]="none",w.cancelButton.display="none"}if(this.isInPage||(this.overlay||(this.overlay=document.createElement("div"),this.overlay.setAttribute("id","hsEmbeddedOverlay"),document.body.appendChild(this.overlay)),this.overlay.setAttribute("style","display: block;")),this.wrapper||(this.wrapper=document.createElement("div"),this.wrapper.setAttribute("id","hsEmbeddedWrapper"),this.isMobile&&window.scrollTo(0,0),this.container.appendChild(this.wrapper)),!this.isInPage)if(this.isMobile&&this.isDefaultUX){var y=document.body.clientWidth/window.innerWidth;window.onscroll=function(){var e=document.body.clientWidth/window.innerWidth;y!==e&&(y=e,v())}}else window.onresize=v;for(var _ in this.iframe||(this.iframe=document.createElement("iframe"),this.iframe.setAttribute("id","hsEmbeddedFrame"),this.wrapper.appendChild(this.iframe)),this.iframe.setAttribute("src",s),this.iframe.setAttribute("scrolling","no"),this.iframe.setAttribute("frameborder","0"),this.isDefaultUX&&this.iframe.setAttribute("width",this.DEFAULT_WIDTH),this.iframe.setAttribute("height",b.heightRaw),(-1===s.indexOf("embeddedSign")||null!=e.uxVersion&&e.uxVersion<2)&&(this.isInPage||!0!==e.allowCancel&&void 0!==e.allowCancel||this.cancelButton?!e.allowCancel&&this.cancelButton&&this.wrapper.removeChild(this.cancelButton):(this.cancelButton=document.createElement("a"),this.cancelButton.setAttribute("id","hsEmbeddedCancel"),this.cancelButton.setAttribute("href","javascript:;"),this.cancelButton.onclick=function(){c.close(),r&&(h("Reporting cancelation"),r({event:c.EVENT_CANCELED}))},this.wrapper.appendChild(this.cancelButton))),w){var x=this[_];if(x)for(var I in w[_])try{x.style[I]=w[_][I]}catch(e){h(e)}}if(this.cancelButton&&(this.isFF||this.isOpera)){var D=this.cancelButton.getAttribute("style");D+=D?"; ":"",D+="background-image: "+w.cancelButton["background-image"]+"; ",D+="background-position: "+w.cancelButton["background-position"]+";",this.cancelButton.setAttribute("style",D)}this.isInPage||this.isMobile&&!this.isDefaultUX||v(),this.isMobile&&!this.isDefaultUX&&window===window.top&&l.set(),this.isMobile&&!this.isInPage&&(this.fixIframe=(u=function(){window.scrollTo(0,0)},p=1e3,function(){var e=this,t=arguments,i=f&&!m;clearTimeout(m),m=setTimeout(function(){m=null,f||u.apply(e,t)},p),i&&u.apply(e,t)}),this.fixIframe(),window.addEventListener("scroll",this.fixIframe)),this.healthCheckTimeoutMs&&(this._healthCheckTimeoutHandle=setTimeout(function(){var e="Signer page failed to initialize within "+t.healthCheckTimeoutMs+" milliseconds.";t.reportError(e,document.location.href),t.close()},this.healthCheckTimeoutMs)),a.receive(function(i){var l=i.source||"hsEmbeddedFrame";if("initialize"===i.data&&e.uxVersion>1){t.healthCheckTimeoutMs&&clearTimeout(t._healthCheckTimeoutHandle);var d=n({},e);delete d.container,a.send(JSON.stringify({type:"embeddedConfig",payload:d}),i.origin,l)}else if("close"==i.data)c.close(),r&&e.uxVersion>1&&r({event:c.EVENT_CANCELED});else if("decline"==i.data)c.close(),r({event:c.EVENT_DECLINED});else if("user-done"==i.data)c.close();else if(0===i.data.indexOf("hello:")){var h=i.data.split(":")[1];a.send("helloback:"+h,s,l)}else if(r&&i.data){for(var u,p={},f=i.data.split("&"),m=function(e){var t=e;try{if("object"===o(t=JSON.parse(e)))for(var i in t)t[i]=parseJson(t[i])}catch(e){}return t},g=0;g<f.length;g++)2===(u=f[g].split("=")).length&&(p[u[0]]=m(decodeURIComponent(u[1])));r(p)}},g)},close:function(){if(this.isMobile&&!this.isDefaultUX&&window===window.top&&l.restore(),h("Closing HelloSign embedded iFrame"),this.iframe){this.cancelButton&&(this.wrapper.removeChild(this.cancelButton),this.cancelButton=null),this._fadeOutIFrame()}this.isMobile&&window.removeEventListener("scroll",this.fixIframe)},_fadeOutIFrame:function(e){var t=this;if(t.iframe){if(e?e-=.1:e=1,t.iframe.style.opacity=e,t.iframe.style.filter="alpha(opacity="+parseInt(100*e,10)+")",e<=0)return t.iframe.style.opacity=0,t.iframe.style.filter="alpha(opacity=0)",t.iframe.style.display="none",clearTimeout(i),t.overlay&&t.container.removeChild(t.overlay),t.container.removeChild(t.wrapper),t.wrapper.removeChild(t.iframe),t.overlay=null,t.iframe=null,t.wrapper=null,!1;var i=setTimeout(function(e){return function(){t._fadeOutIFrame(e)}}(e),10)}},reportError:function(e,t){a.send({event:c.EVENT_ERROR,description:e},t)},ensureParentDomain:function(e,t,i,n,o){if(window.top!=window)if("string"==typeof i)if("function"==typeof o){if(!0===n){var r="Domain verification has been skipped. Before requesting approval for your app, please be sure to test domain verification by setting skipDomainVerification to false.";h(r),alert(r),o(!0)}else a.receive(function(e){if(0===e.data.indexOf("helloback:")){var t=e.data.split(":")[1]==i;o(t)}},e);a.send("hello:"+i,t)}else d("Callback not supplied by HelloSign. Please contact support.");else d("Token not supplied by HelloSign. Please contact support.");else o(!0)},getWindowDimensions:function(e){var t,i,n=p()?window.pageXOffset:u()?document.documentElement.scrollLeft:document.body.scrollLeft,o=p()?window.pageYOffset:u()?document.documentElement.scrollTop:document.body.scrollTop;this.isOldIE?(t=document.body.clientWidth,i=document.body.clientHeight):(t=window.innerWidth,i=window.innerHeight);var r=this.isInPage&&e?e:Math.max(this.MIN_HEIGHT,i-60);return{widthString:(this.uxVersion>1?Math.min(this.DEFAULT_WIDTH,t*this.IFRAME_WIDTH_RATIO):this.DEFAULT_WIDTH)+"px",heightString:r+"px",heightRaw:r,scrollX:n,scrollY:o,top:Math.max(0,o+parseInt((i-r)/2,10))+"px",left:Math.max(0,parseInt((t-this.DEFAULT_WIDTH)/2,10))+"px"}},getMobileDimensions:function(){var e,t=screen.width,i=(screen.height,window.innerWidth);return(e=window.innerHeight>i?{widthString:this.isDefaultUX?"100vw":t+"px",heightString:this.isDefaultUX?"100vh":"100%"}:{widthString:i+"px",heightString:this.isDefaultUX?"100vh":"100%"}).top="0",e.left="0",e},inArray:function(e,t){if(this.hasJQuery)return $.inArray(e,t);if(t)for(var i=0;i<t.length;i++)if(t[i]==e)return i;return-1},safeUrl:function(e){if(e)try{e=(e=e.replace(/</g,"&lt;")).replace(/>/g,"&gt;");var t=document.createElement("div");t.innerHTML=e;var i=t.innerText;e=i||e.replace(/\&amp\;/g,"&")}catch(e){h("Could not decode url: "+e)}return e}};function d(e){void 0!==e&&(window.console&&console.log?console.log(e):alert(e))}function h(e){c.isDebugEnabled&&void 0!==e&&window.console&&console.log&&console.log(e)}function u(){return"CSS1Compat"===(document.compatMode||"")}function p(){return void 0!==window.pageXOffset}window.HelloSign=c,e.exports=c}()}])});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "9/L2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var DataTableFooterTemplateDirective = /** @class */ (function () {
    function DataTableFooterTemplateDirective(template) {
        this.template = template;
    }
    DataTableFooterTemplateDirective = __decorate([
        core_1.Directive({ selector: '[ngx-datatable-footer-template]' }),
        __metadata("design:paramtypes", [core_1.TemplateRef])
    ], DataTableFooterTemplateDirective);
    return DataTableFooterTemplateDirective;
}());
exports.DataTableFooterTemplateDirective = DataTableFooterTemplateDirective;
//# sourceMappingURL=footer-template.directive.js.map

/***/ }),

/***/ "9ev/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrderViewType; });
var OrderViewType;
(function (OrderViewType) {
    OrderViewType[OrderViewType["Tile"] = 0] = "Tile";
    OrderViewType[OrderViewType["Table"] = 1] = "Table";
})(OrderViewType || (OrderViewType = {}));
//# sourceMappingURL=orderViewType.js.map

/***/ }),

/***/ "AIey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserViewHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_users_user__ = __webpack_require__("E4s1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ngx_odata_v4__ = __webpack_require__("MDYC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_components_component__ = __webpack_require__("+TKD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_management_order_orderViewType__ = __webpack_require__("9ev/");




var UserViewHelper = /** @class */ (function () {
    function UserViewHelper() {
    }
    UserViewHelper.getColumnOrderBy = function (currentConfigDict, component) {
        var currentConfigs = currentConfigDict[component];
        var currentConfig = currentConfigs.ColumnsConfigs.find(function (x) { return x.Type == currentConfigs.ViewType; });
        var orderByColumn;
        if (currentConfig)
            orderByColumn = currentConfig.Columns.find(function (c) { return c.SortType != __WEBPACK_IMPORTED_MODULE_0__objects_users_user__["b" /* SortType */].None; });
        var orderBy;
        if (orderByColumn)
            orderBy = { PropertyName: orderByColumn.Property, OrderBy: orderByColumn.SortType == __WEBPACK_IMPORTED_MODULE_0__objects_users_user__["b" /* SortType */].Asc ? __WEBPACK_IMPORTED_MODULE_1_ngx_odata_v4__["a" /* OrderBy */].Asc : __WEBPACK_IMPORTED_MODULE_1_ngx_odata_v4__["a" /* OrderBy */].Desc };
        return orderBy;
    };
    UserViewHelper.getColumns = function (userViewService, componentEnum, viewType) {
        if (viewType === void 0) { viewType = null; }
        var currentViewType = viewType;
        if (currentViewType == null)
            currentViewType = this.getCurrentView(userViewService);
        if (userViewService.userView)
            return userViewService.userView[componentEnum].ColumnsConfigs
                .find(function (x) { return x.Type == currentViewType; }).Columns
                .filter(function (x) { return x.IsSelected == true; })
                .sort(function (a, b) {
                return a.Index - b.Index;
            });
        return [];
    };
    UserViewHelper.getCurrentView = function (userViewService) {
        if (userViewService.userView)
            return userViewService.userView[__WEBPACK_IMPORTED_MODULE_2__objects_components_component__["a" /* Component */].OrderManagement].ViewType;
        return __WEBPACK_IMPORTED_MODULE_3__objects_management_order_orderViewType__["a" /* OrderViewType */].Tile;
    };
    return UserViewHelper;
}());

//# sourceMappingURL=userViewHelper.js.map

/***/ }),

/***/ "AYdn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserFlag; });
/**
 * Created by vlad.p on 8/2/2017.
 */
var UserFlag;
(function (UserFlag) {
    UserFlag[UserFlag["Default"] = 0] = "Default";
    UserFlag[UserFlag["Disabled"] = 1] = "Disabled";
})(UserFlag || (UserFlag = {}));
//# sourceMappingURL=userFlag.js.map

/***/ }),

/***/ "AvNY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserHelper; });
/**
 * Created by vlad.p on 8/4/2017.
 */
var UserHelper = /** @class */ (function () {
    function UserHelper() {
    }
    UserHelper.isInGroup = function (user, group) {
        return this.isInGroupById(user, group.Id);
    };
    UserHelper.isInGroupById = function (user, groupId) {
        if (user.Groups == null || user.Groups.length == 0)
            return false;
        return user.Groups.find(function (x) { return x.Id == groupId; }) != null;
    };
    UserHelper.getCommaSeparatedGroups = function (user) {
        if (user == null || user.Groups == null || user.Groups.length == 0)
            return 'No Groups.';
        var result = user.Groups[0].Name;
        for (var i = 1; i < user.Groups.length; i++) {
            result += ', ' + user.Groups[i].Name;
        }
        return result;
    };
    return UserHelper;
}());

//# sourceMappingURL=userHelper.js.map

/***/ }),

/***/ "BRKd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExtraDataSearchRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ExtraDataSearchType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ReferenceType; });
var ExtraDataSearchRequest = /** @class */ (function () {
    function ExtraDataSearchRequest(obj) {
        if (obj != null)
            Object.assign(this, obj);
    }
    return ExtraDataSearchRequest;
}());

var ExtraDataSearchType;
(function (ExtraDataSearchType) {
    ExtraDataSearchType[ExtraDataSearchType["ByRefIdAndRefType"] = 0] = "ByRefIdAndRefType";
})(ExtraDataSearchType || (ExtraDataSearchType = {}));
var ReferenceType;
(function (ReferenceType) {
    ReferenceType[ReferenceType["Order"] = 0] = "Order";
    ReferenceType[ReferenceType["Customer"] = 1] = "Customer";
    ReferenceType[ReferenceType["Agent"] = 2] = "Agent";
})(ReferenceType || (ReferenceType = {}));
//# sourceMappingURL=extraDataSearchRequest.js.map

/***/ }),

/***/ "BhF2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalculatorType; });
/**
 * Created by alex.y on 9/5/2017.
 */
var CalculatorType;
(function (CalculatorType) {
    CalculatorType[CalculatorType["CanadianImport"] = 0] = "CanadianImport";
    CalculatorType[CalculatorType["UsaImport"] = 1] = "UsaImport";
})(CalculatorType || (CalculatorType = {}));
//# sourceMappingURL=calculatorType.js.map

/***/ }),

/***/ "C8Kb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var utils_1 = __webpack_require__("x6Zf");
var types_1 = __webpack_require__("j2I9");
var events_1 = __webpack_require__("NBsw");
var DataTableBodyCellComponent = /** @class */ (function () {
    function DataTableBodyCellComponent(element, cd) {
        this.cd = cd;
        this.activate = new core_1.EventEmitter();
        this.isFocused = false;
        this.onCheckboxChangeFn = this.onCheckboxChange.bind(this);
        this.activateFn = this.activate.emit.bind(this.activate);
        this.cellContext = {
            onCheckboxChangeFn: this.onCheckboxChangeFn,
            activateFn: this.activateFn,
            row: this.row,
            group: this.group,
            value: this.value,
            column: this.column,
            rowHeight: this.rowHeight,
            isSelected: this.isSelected,
            rowIndex: this.rowIndex
        };
        this._element = element.nativeElement;
    }
    Object.defineProperty(DataTableBodyCellComponent.prototype, "group", {
        get: function () {
            return this._group;
        },
        set: function (group) {
            this._group = group;
            this.cellContext.group = group;
            this.checkValueUpdates();
            this.cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "rowHeight", {
        get: function () {
            return this._rowHeight;
        },
        set: function (val) {
            this._rowHeight = val;
            this.cellContext.rowHeight = val;
            this.checkValueUpdates();
            this.cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "isSelected", {
        get: function () {
            return this._isSelected;
        },
        set: function (val) {
            this._isSelected = val;
            this.cellContext.isSelected = val;
            this.cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "expanded", {
        get: function () {
            return this._expanded;
        },
        set: function (val) {
            this._expanded = val;
            this.cellContext.expanded = val;
            this.cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "rowIndex", {
        get: function () {
            return this._rowIndex;
        },
        set: function (val) {
            this._rowIndex = val;
            this.cellContext.rowIndex = val;
            this.checkValueUpdates();
            this.cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "column", {
        get: function () {
            return this._column;
        },
        set: function (column) {
            this._column = column;
            this.cellContext.column = column;
            this.checkValueUpdates();
            this.cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "row", {
        get: function () {
            return this._row;
        },
        set: function (row) {
            this._row = row;
            this.cellContext.row = row;
            this.checkValueUpdates();
            this.cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "sorts", {
        get: function () {
            return this._sorts;
        },
        set: function (val) {
            this._sorts = val;
            this.calcSortDir = this.calcSortDir(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "columnCssClasses", {
        get: function () {
            var cls = 'datatable-body-cell';
            if (this.column.cellClass) {
                if (typeof this.column.cellClass === 'string') {
                    cls += ' ' + this.column.cellClass;
                }
                else if (typeof this.column.cellClass === 'function') {
                    var res = this.column.cellClass({
                        row: this.row,
                        group: this.group,
                        column: this.column,
                        value: this.value,
                        rowHeight: this.rowHeight
                    });
                    if (typeof res === 'string') {
                        cls += res;
                    }
                    else if (typeof res === 'object') {
                        var keys = Object.keys(res);
                        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                            var k = keys_1[_i];
                            if (res[k] === true)
                                cls += " " + k;
                        }
                    }
                }
            }
            if (!this.sortDir)
                cls += ' sort-active';
            if (this.isFocused)
                cls += ' active';
            if (this.sortDir === types_1.SortDirection.asc)
                cls += ' sort-asc';
            if (this.sortDir === types_1.SortDirection.desc)
                cls += ' sort-desc';
            return cls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "width", {
        get: function () {
            return this.column.width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "height", {
        get: function () {
            var height = this.rowHeight;
            if (isNaN(height))
                return height;
            return height + 'px';
        },
        enumerable: true,
        configurable: true
    });
    DataTableBodyCellComponent.prototype.ngDoCheck = function () {
        this.checkValueUpdates();
    };
    DataTableBodyCellComponent.prototype.ngOnDestroy = function () {
        if (this.cellTemplate) {
            this.cellTemplate.clear();
        }
    };
    DataTableBodyCellComponent.prototype.checkValueUpdates = function () {
        var value = '';
        if (!this.row || !this.column) {
            value = '';
        }
        else {
            var val = this.column.$$valueGetter(this.row, this.column.prop);
            var userPipe = this.column.pipe;
            if (userPipe) {
                value = userPipe.transform(val);
            }
            else if (value !== undefined) {
                value = val;
            }
        }
        if (this.value !== value) {
            this.value = value;
            this.cellContext.value = value;
            this.sanitizedValue = value !== null && value !== undefined ? this.stripHtml(value) : value;
            this.cd.markForCheck();
        }
    };
    DataTableBodyCellComponent.prototype.onFocus = function () {
        this.isFocused = true;
    };
    DataTableBodyCellComponent.prototype.onBlur = function () {
        this.isFocused = false;
    };
    DataTableBodyCellComponent.prototype.onClick = function (event) {
        this.activate.emit({
            type: 'click',
            event: event,
            row: this.row,
            group: this.group,
            rowHeight: this.rowHeight,
            column: this.column,
            value: this.value,
            cellElement: this._element
        });
    };
    DataTableBodyCellComponent.prototype.onDblClick = function (event) {
        this.activate.emit({
            type: 'dblclick',
            event: event,
            row: this.row,
            group: this.group,
            rowHeight: this.rowHeight,
            column: this.column,
            value: this.value,
            cellElement: this._element
        });
    };
    DataTableBodyCellComponent.prototype.onKeyDown = function (event) {
        var keyCode = event.keyCode;
        var isTargetCell = event.target === this._element;
        var isAction = keyCode === utils_1.Keys.return ||
            keyCode === utils_1.Keys.down ||
            keyCode === utils_1.Keys.up ||
            keyCode === utils_1.Keys.left ||
            keyCode === utils_1.Keys.right;
        if (isAction && isTargetCell) {
            event.preventDefault();
            event.stopPropagation();
            this.activate.emit({
                type: 'keydown',
                event: event,
                row: this.row,
                group: this.group,
                rowHeight: this.rowHeight,
                column: this.column,
                value: this.value,
                cellElement: this._element
            });
        }
    };
    DataTableBodyCellComponent.prototype.onCheckboxChange = function (event) {
        this.activate.emit({
            type: 'checkbox',
            event: event,
            row: this.row,
            group: this.group,
            rowHeight: this.rowHeight,
            column: this.column,
            value: this.value,
            cellElement: this._element
        });
    };
    DataTableBodyCellComponent.prototype.calcSortDir = function (sorts) {
        var _this = this;
        if (!sorts)
            return;
        var sort = sorts.find(function (s) {
            return s.prop === _this.column.prop;
        });
        if (sort)
            return sort.dir;
    };
    DataTableBodyCellComponent.prototype.stripHtml = function (html) {
        if (!html.replace)
            return html;
        return html.replace(/<\/?[^>]+(>|$)/g, '');
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableBodyCellComponent.prototype, "displayCheck", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], DataTableBodyCellComponent.prototype, "group", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], DataTableBodyCellComponent.prototype, "rowHeight", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], DataTableBodyCellComponent.prototype, "isSelected", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], DataTableBodyCellComponent.prototype, "expanded", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], DataTableBodyCellComponent.prototype, "rowIndex", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], DataTableBodyCellComponent.prototype, "column", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], DataTableBodyCellComponent.prototype, "row", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], DataTableBodyCellComponent.prototype, "sorts", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTableBodyCellComponent.prototype, "activate", void 0);
    __decorate([
        core_1.ViewChild('cellTemplate', { read: core_1.ViewContainerRef }),
        __metadata("design:type", core_1.ViewContainerRef)
    ], DataTableBodyCellComponent.prototype, "cellTemplate", void 0);
    __decorate([
        core_1.HostBinding('class'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], DataTableBodyCellComponent.prototype, "columnCssClasses", null);
    __decorate([
        core_1.HostBinding('style.width.px'),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], DataTableBodyCellComponent.prototype, "width", null);
    __decorate([
        core_1.HostBinding('style.height'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], DataTableBodyCellComponent.prototype, "height", null);
    __decorate([
        core_1.HostListener('focus'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DataTableBodyCellComponent.prototype, "onFocus", null);
    __decorate([
        core_1.HostListener('blur'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DataTableBodyCellComponent.prototype, "onBlur", null);
    __decorate([
        core_1.HostListener('click', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DataTableBodyCellComponent.prototype, "onClick", null);
    __decorate([
        core_1.HostListener('dblclick', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DataTableBodyCellComponent.prototype, "onDblClick", null);
    __decorate([
        core_1.HostListener('keydown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DataTableBodyCellComponent.prototype, "onKeyDown", null);
    DataTableBodyCellComponent = __decorate([
        core_1.Component({
            selector: 'datatable-body-cell',
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
            template: "\n    <div class=\"datatable-body-cell-label\">\n      <label\n        *ngIf=\"column.checkboxable && (!displayCheck || displayCheck(row, column, value))\"\n        class=\"datatable-checkbox\">\n        <input\n          type=\"checkbox\"\n          [checked]=\"isSelected\"\n          (click)=\"onCheckboxChange($event)\"\n        />\n      </label>\n      <span\n        *ngIf=\"!column.cellTemplate\"\n        [title]=\"sanitizedValue\"\n        [innerHTML]=\"value\">\n      </span>\n      <ng-template #cellTemplate\n        *ngIf=\"column.cellTemplate\"\n        [ngTemplateOutlet]=\"column.cellTemplate\"\n        [ngTemplateOutletContext]=\"cellContext\">\n      </ng-template>\n    </div>\n  "
        }),
        __metadata("design:paramtypes", [core_1.ElementRef, core_1.ChangeDetectorRef])
    ], DataTableBodyCellComponent);
    return DataTableBodyCellComponent;
}());
exports.DataTableBodyCellComponent = DataTableBodyCellComponent;
//# sourceMappingURL=body-cell.component.js.map

/***/ }),

/***/ "CCID":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the columns by pin.
 */
function columnsByPin(cols) {
    var ret = {
        left: [],
        center: [],
        right: []
    };
    if (cols) {
        for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
            var col = cols_1[_i];
            if (col.frozenLeft) {
                ret.left.push(col);
            }
            else if (col.frozenRight) {
                ret.right.push(col);
            }
            else {
                ret.center.push(col);
            }
        }
    }
    return ret;
}
exports.columnsByPin = columnsByPin;
/**
 * Returns the widths of all group sets of a column
 */
function columnGroupWidths(groups, all) {
    return {
        left: columnTotalWidth(groups.left),
        center: columnTotalWidth(groups.center),
        right: columnTotalWidth(groups.right),
        total: Math.floor(columnTotalWidth(all))
    };
}
exports.columnGroupWidths = columnGroupWidths;
/**
 * Calculates the total width of all columns and their groups
 */
function columnTotalWidth(columns, prop) {
    var totalWidth = 0;
    if (columns) {
        for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
            var c = columns_1[_i];
            var has = prop && c[prop];
            var width = has ? c[prop] : c.width;
            totalWidth = totalWidth + parseFloat(width);
        }
    }
    return totalWidth;
}
exports.columnTotalWidth = columnTotalWidth;
/**
 * Calculates the total width of all columns and their groups
 */
function columnsTotalWidth(columns, prop) {
    var totalWidth = 0;
    for (var _i = 0, columns_2 = columns; _i < columns_2.length; _i++) {
        var column = columns_2[_i];
        var has = prop && column[prop];
        totalWidth = totalWidth + (has ? column[prop] : column.width);
    }
    return totalWidth;
}
exports.columnsTotalWidth = columnsTotalWidth;
function columnsByPinArr(val) {
    var colsByPinArr = [];
    var colsByPin = columnsByPin(val);
    colsByPinArr.push({ type: 'left', columns: colsByPin['left'] });
    colsByPinArr.push({ type: 'center', columns: colsByPin['center'] });
    colsByPinArr.push({ type: 'right', columns: colsByPin['right'] });
    return colsByPinArr;
}
exports.columnsByPinArr = columnsByPinArr;
//# sourceMappingURL=column.js.map

/***/ }),

/***/ "E4s1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return User; });
/* unused harmony export OrderManagementConfig */
/* unused harmony export ColumnsConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Column; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UserViewConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SortType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_baseEntity__ = __webpack_require__("mCwL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__userFlag__ = __webpack_require__("AYdn");



var User = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](User, _super);
    function User(obj) {
        var _this = _super.call(this) || this;
        _this.Groups = [];
        _this.Flag = __WEBPACK_IMPORTED_MODULE_2__userFlag__["a" /* UserFlag */].Default;
        _this.OrderIDs = [];
        _this.Orders = new Array();
        if (obj != null)
            Object.assign(_this, obj);
        return _this;
    }
    return User;
}(__WEBPACK_IMPORTED_MODULE_1__common_baseEntity__["a" /* BaseEntity */]));

var OrderManagementConfig = /** @class */ (function () {
    function OrderManagementConfig(obj) {
        if (obj)
            Object.assign(this, obj);
    }
    return OrderManagementConfig;
}());

var ColumnsConfig = /** @class */ (function () {
    function ColumnsConfig(obj) {
        this.Columns = [];
        Object.assign(this, obj);
    }
    return ColumnsConfig;
}());

var Column = /** @class */ (function () {
    function Column(obj) {
        Object.assign(this, obj);
    }
    return Column;
}());

var UserViewConfig = /** @class */ (function () {
    function UserViewConfig(obj) {
        this.Id = null;
        Object.assign(this, obj);
    }
    return UserViewConfig;
}());

var SortType;
(function (SortType) {
    SortType[SortType["None"] = 0] = "None";
    SortType[SortType["Asc"] = 1] = "Asc";
    SortType[SortType["Desc"] = 2] = "Desc";
})(SortType || (SortType = {}));
//# sourceMappingURL=user.js.map

/***/ }),

/***/ "EKta":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),

/***/ "EuP9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("EKta")
var ieee754 = __webpack_require__("ujcs")
var isArray = __webpack_require__("Ht8P")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "Fglw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("2LVV"));
__export(__webpack_require__("sUlX"));
__export(__webpack_require__("2tXe"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "GWXQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var row_detail_template_directive_1 = __webpack_require__("Ii9O");
var DatatableRowDetailDirective = /** @class */ (function () {
    function DatatableRowDetailDirective() {
        /**
         * The detail row height is required especially
         * when virtual scroll is enabled.
         */
        this.rowHeight = 0;
        /**
         * Row detail row visbility was toggled.
         */
        this.toggle = new core_1.EventEmitter();
    }
    /**
     * Toggle the expansion of the row
     */
    DatatableRowDetailDirective.prototype.toggleExpandRow = function (row) {
        this.toggle.emit({
            type: 'row',
            value: row
        });
    };
    /**
     * API method to expand all the rows.
     */
    DatatableRowDetailDirective.prototype.expandAllRows = function () {
        this.toggle.emit({
            type: 'all',
            value: true
        });
    };
    /**
     * API method to collapse all the rows.
     */
    DatatableRowDetailDirective.prototype.collapseAllRows = function () {
        this.toggle.emit({
            type: 'all',
            value: false
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DatatableRowDetailDirective.prototype, "rowHeight", void 0);
    __decorate([
        core_1.Input(),
        core_1.ContentChild(row_detail_template_directive_1.DatatableRowDetailTemplateDirective, { read: core_1.TemplateRef }),
        __metadata("design:type", core_1.TemplateRef)
    ], DatatableRowDetailDirective.prototype, "template", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DatatableRowDetailDirective.prototype, "toggle", void 0);
    DatatableRowDetailDirective = __decorate([
        core_1.Directive({ selector: 'ngx-datatable-row-detail' })
    ], DatatableRowDetailDirective);
    return DatatableRowDetailDirective;
}());
exports.DatatableRowDetailDirective = DatatableRowDetailDirective;
//# sourceMappingURL=row-detail.directive.js.map

/***/ }),

/***/ "GfIz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var column_1 = __webpack_require__("CCID");
/**
 * Calculates the Total Flex Grow
 */
function getTotalFlexGrow(columns) {
    var totalFlexGrow = 0;
    for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
        var c = columns_1[_i];
        totalFlexGrow += c.flexGrow || 0;
    }
    return totalFlexGrow;
}
exports.getTotalFlexGrow = getTotalFlexGrow;
/**
 * Adjusts the column widths.
 * Inspired by: https://github.com/facebook/fixed-data-table/blob/master/src/FixedDataTableWidthHelper.js
 */
function adjustColumnWidths(allColumns, expectedWidth) {
    var columnsWidth = column_1.columnsTotalWidth(allColumns);
    var totalFlexGrow = getTotalFlexGrow(allColumns);
    var colsByGroup = column_1.columnsByPin(allColumns);
    if (columnsWidth !== expectedWidth) {
        scaleColumns(colsByGroup, expectedWidth, totalFlexGrow);
    }
}
exports.adjustColumnWidths = adjustColumnWidths;
/**
 * Resizes columns based on the flexGrow property, while respecting manually set widths
 */
function scaleColumns(colsByGroup, maxWidth, totalFlexGrow) {
    // calculate total width and flexgrow points for coulumns that can be resized
    for (var attr in colsByGroup) {
        for (var _i = 0, _a = colsByGroup[attr]; _i < _a.length; _i++) {
            var column = _a[_i];
            if (!column.canAutoResize) {
                maxWidth -= column.width;
                totalFlexGrow -= column.flexGrow ? column.flexGrow : 0;
            }
            else {
                column.width = 0;
            }
        }
    }
    var hasMinWidth = {};
    var remainingWidth = maxWidth;
    // resize columns until no width is left to be distributed
    do {
        var widthPerFlexPoint = remainingWidth / totalFlexGrow;
        remainingWidth = 0;
        for (var attr in colsByGroup) {
            for (var _b = 0, _c = colsByGroup[attr]; _b < _c.length; _b++) {
                var column = _c[_b];
                // if the column can be resize and it hasn't reached its minimum width yet
                if (column.canAutoResize && !hasMinWidth[column.prop]) {
                    var newWidth = column.width + column.flexGrow * widthPerFlexPoint;
                    if (column.minWidth !== undefined && newWidth < column.minWidth) {
                        remainingWidth += newWidth - column.minWidth;
                        column.width = column.minWidth;
                        hasMinWidth[column.prop] = true;
                    }
                    else {
                        column.width = newWidth;
                    }
                }
            }
        }
    } while (remainingWidth !== 0);
}
/**
 * Forces the width of the columns to
 * distribute equally but overflowing when necessary
 *
 * Rules:
 *
 *  - If combined withs are less than the total width of the grid,
 *    proportion the widths given the min / max / normal widths to fill the width.
 *
 *  - If the combined widths, exceed the total width of the grid,
 *    use the standard widths.
 *
 *  - If a column is resized, it should always use that width
 *
 *  - The proportional widths should never fall below min size if specified.
 *
 *  - If the grid starts off small but then becomes greater than the size ( + / - )
 *    the width should use the original width; not the newly proportioned widths.
 */
function forceFillColumnWidths(allColumns, expectedWidth, startIdx, allowBleed, defaultColWidth) {
    if (defaultColWidth === void 0) { defaultColWidth = 300; }
    var columnsToResize = allColumns
        .slice(startIdx + 1, allColumns.length)
        .filter(function (c) {
        return c.canAutoResize !== false;
    });
    for (var _i = 0, columnsToResize_1 = columnsToResize; _i < columnsToResize_1.length; _i++) {
        var column = columnsToResize_1[_i];
        if (!column.$$oldWidth) {
            column.$$oldWidth = column.width;
        }
    }
    var additionWidthPerColumn = 0;
    var exceedsWindow = false;
    var contentWidth = getContentWidth(allColumns, defaultColWidth);
    var remainingWidth = expectedWidth - contentWidth;
    var columnsProcessed = [];
    // This loop takes care of the
    do {
        additionWidthPerColumn = remainingWidth / columnsToResize.length;
        exceedsWindow = contentWidth >= expectedWidth;
        for (var _a = 0, columnsToResize_2 = columnsToResize; _a < columnsToResize_2.length; _a++) {
            var column = columnsToResize_2[_a];
            if (exceedsWindow && allowBleed) {
                column.width = column.$$oldWidth || column.width || defaultColWidth;
            }
            else {
                var newSize = (column.width || defaultColWidth) + additionWidthPerColumn;
                if (column.minWidth && newSize < column.minWidth) {
                    column.width = column.minWidth;
                    columnsProcessed.push(column);
                }
                else if (column.maxWidth && newSize > column.maxWidth) {
                    column.width = column.maxWidth;
                    columnsProcessed.push(column);
                }
                else {
                    column.width = newSize;
                }
            }
            column.width = Math.max(0, column.width);
        }
        contentWidth = getContentWidth(allColumns);
        remainingWidth = expectedWidth - contentWidth;
        removeProcessedColumns(columnsToResize, columnsProcessed);
    } while (remainingWidth > 0 && columnsToResize.length !== 0);
}
exports.forceFillColumnWidths = forceFillColumnWidths;
/**
 * Remove the processed columns from the current active columns.
 */
function removeProcessedColumns(columnsToResize, columnsProcessed) {
    for (var _i = 0, columnsProcessed_1 = columnsProcessed; _i < columnsProcessed_1.length; _i++) {
        var column = columnsProcessed_1[_i];
        var index = columnsToResize.indexOf(column);
        columnsToResize.splice(index, 1);
    }
}
/**
 * Gets the width of the columns
 */
function getContentWidth(allColumns, defaultColWidth) {
    if (defaultColWidth === void 0) { defaultColWidth = 300; }
    var contentWidth = 0;
    for (var _i = 0, allColumns_1 = allColumns; _i < allColumns_1.length; _i++) {
        var column = allColumns_1[_i];
        contentWidth += (column.width || defaultColWidth);
    }
    return contentWidth;
}
//# sourceMappingURL=math.js.map

/***/ }),

/***/ "HY16":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RequestType; });
/**
 * Created by alex.y on 9/26/2017.
 */
var RequestType;
(function (RequestType) {
    RequestType[RequestType["Search"] = 0] = "Search";
    RequestType[RequestType["ProductsAndTariffs"] = 1] = "ProductsAndTariffs";
})(RequestType || (RequestType = {}));
//# sourceMappingURL=requestType.js.map

/***/ }),

/***/ "Ht8P":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "I2hE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("xTdc"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "IfaC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var core_1 = __webpack_require__("3j3K");
var common_1 = __webpack_require__("2Je8");
var Tooltip_1 = __webpack_require__("Z/0s");
var TooltipContent_1 = __webpack_require__("WavH");
__export(__webpack_require__("Z/0s"));
__export(__webpack_require__("WavH"));
var TooltipModule = (function () {
    function TooltipModule() {
    }
    return TooltipModule;
}());
TooltipModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule
        ],
        declarations: [
            Tooltip_1.Tooltip,
            TooltipContent_1.TooltipContent,
        ],
        exports: [
            Tooltip_1.Tooltip,
            TooltipContent_1.TooltipContent,
        ],
        entryComponents: [
            TooltipContent_1.TooltipContent
        ]
    })
], TooltipModule);
exports.TooltipModule = TooltipModule;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "IhmT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/rxjs/add/operator/toPromise.js
var toPromise = __webpack_require__("eErF");
var toPromise_default = /*#__PURE__*/__webpack_require__.n(toPromise);

// EXTERNAL MODULE: ./node_modules/@angular/http/@angular/http.es5.js
var http_es5 = __webpack_require__("Fzro");

// CONCATENATED MODULE: ./app/objects/common/baseResponse.ts
/**
 * Created by stas on 5/22/2017.
 */
// Same as ApiJsonResult
var BaseResponse = /** @class */ (function () {
    function BaseResponse(success, responseCode, errors, data) {
        this.Success = success;
        this.ResponseCode = responseCode;
        this.Data = data;
        this.Errors = errors;
    }
    return BaseResponse;
}());

//# sourceMappingURL=baseResponse.js.map
// EXTERNAL MODULE: ./app/common/helpers/stringHelper.ts
var stringHelper = __webpack_require__("xFNE");
var stringHelper_default = /*#__PURE__*/__webpack_require__.n(stringHelper);

// EXTERNAL MODULE: ./app/services/configService.ts
var configService = __webpack_require__("cfSW");

// EXTERNAL MODULE: ./node_modules/ng2-cookies/ng2-cookies.js
var ng2_cookies = __webpack_require__("46qw");
var ng2_cookies_default = /*#__PURE__*/__webpack_require__.n(ng2_cookies);

// CONCATENATED MODULE: ./app/services/baseService.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseService_BaseApi; });






var baseService_BaseApi = /** @class */ (function () {
    function BaseApi(http, configService) {
        this.http = http;
        this.configService = configService;
        this.config = this.configService.config;
    }
    BaseApi.prototype.get = function (params) {
        params.method = http_es5["h" /* RequestMethod */].Get;
        return this.sendRequest(params);
    };
    BaseApi.prototype.post = function (params) {
        params.method = http_es5["h" /* RequestMethod */].Post;
        return this.sendRequest(params);
    };
    BaseApi.prototype.put = function (params) {
        params.method = http_es5["h" /* RequestMethod */].Put;
        return this.sendRequest(params);
    };
    BaseApi.prototype.delete = function (params) {
        params.method = http_es5["h" /* RequestMethod */].Delete;
        return this.sendRequest(params);
    };
    BaseApi.prototype.sendRequest = function (params) {
        var request = this.validate(params);
        return this.http.request(request, params).map(function (res) {
            var jsonData = res.json();
            return new BaseResponse(jsonData.Success, jsonData.Status, jsonData.Errors, jsonData.Data);
        }).toPromise().catch(function (x) {
            var jsonData = x.json();
            return Promise.reject(new BaseResponse(jsonData.Success, jsonData.ResponseCode, jsonData.Errors, jsonData.Data));
        });
    };
    BaseApi.prototype.validate = function (params) {
        if (params == null) {
            params = new http_es5["i" /* RequestOptions */]();
        }
        if (params.method == null) {
            params.method = http_es5["h" /* RequestMethod */].Get;
            console.log("request method is empty. Using default GET");
        }
        if (String.isNullOrEmpty(params.url)) {
            console.log("Url is empty");
        }
        if (params.headers == null)
            params.headers = new http_es5["d" /* Headers */]();
        params.headers.append("Content-Type", 'application/json');
        var cookie = ng2_cookies["Cookie"].get(this.config.ApiTokenCookieName);
        if (!String.isNullOrEmpty(cookie) && !params.headers.has("Authorization")) {
            params.headers.append("Authorization", "Bearer " + cookie);
        }
        params.url = this.config.ApiUrl + "/" + params.url;
        return new http_es5["g" /* Request */](params);
    };
    BaseApi.ctorParameters = function () { return [{ type: http_es5["e" /* Http */] }, { type: configService["a" /* ConfigService */] }]; };
    return BaseApi;
}());

//# sourceMappingURL=baseService.js.map

/***/ }),

/***/ "Ii9O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var DatatableRowDetailTemplateDirective = /** @class */ (function () {
    function DatatableRowDetailTemplateDirective(template) {
        this.template = template;
    }
    DatatableRowDetailTemplateDirective = __decorate([
        core_1.Directive({
            selector: '[ngx-datatable-row-detail-template]'
        }),
        __metadata("design:paramtypes", [core_1.TemplateRef])
    ], DatatableRowDetailTemplateDirective);
    return DatatableRowDetailTemplateDirective;
}());
exports.DatatableRowDetailTemplateDirective = DatatableRowDetailTemplateDirective;
//# sourceMappingURL=row-detail-template.directive.js.map

/***/ }),

/***/ "J/iR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("214W"));
__export(__webpack_require__("/jm2"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "JJFZ":
/***/ (function(module, exports) {

/**
 * Class Cookie - Holds static functions to deal with Cookies
 */
var Cookie = (function () {
    function Cookie() {
    }
    /**
     * Retrieves a single cookie by it's name
     *
     * @param  {string} name Identification of the Cookie
     * @returns The Cookie's value
     */
    Cookie.get = function (name) {
        var myWindow = window;
        name = myWindow.escape(name);
        var regexp = new RegExp('(?:^' + name + '|;\\s*' + name + ')=(.*?)(?:;|$)', 'g');
        var result = regexp.exec(document.cookie);
        return (result === null) ? null : myWindow.unescape(result[1]);
    };
    /**
     * Retrieves a a list of all cookie avaiable
     *
     * @returns Object with all Cookies
     */
    Cookie.getAll = function () {
        var cookies = {};
        if (document.cookie && document.cookie != '') {
            var split = document.cookie.split(';');
            for (var i = 0; i < split.length; i++) {
                var currCookie = split[i].split('=');
                currCookie[0] = currCookie[0].replace(/^ /, '');
                cookies[decodeURIComponent(currCookie[0])] = decodeURIComponent(currCookie[1]);
            }
        }
        return cookies;
    };
    /**
     * Save the Cookie
     *
     * @param  {string} name Cookie's identification
     * @param  {string} value Cookie's value
     * @param  {number} expires Cookie's expiration date in days from now. If it's undefined the cookie is a session Cookie
     * @param  {string} path Path relative to the domain where the cookie should be avaiable. Default /
     * @param  {string} domain Domain where the cookie should be avaiable. Default current domain
     */
    Cookie.set = function (name, value, expires, path, domain) {
        var myWindow = window;
        var cookieStr = myWindow.escape(name) + '=' + myWindow.escape(value) + ';';
        if (expires) {
            var dtExpires = new Date(new Date().getTime() + expires * 1000 * 60 * 60 * 24);
            cookieStr += 'expires=' + dtExpires.toUTCString() + ';';
        }
        if (path) {
            cookieStr += 'path=' + path + ';';
        }
        if (domain) {
            cookieStr += 'domain=' + domain + ';';
        }
        // console.log(cookieStr);
        document.cookie = cookieStr;
    };
    /**
     * Removes specified Cookie
     *
     * @param  {string} name Cookie's identification
     * @param  {string} path Path relative to the domain where the cookie should be avaiable. Default /
     * @param  {string} domain Domain where the cookie should be avaiable. Default current domain
     */
    Cookie.delete = function (name, path, domain) {
        // If the cookie exists
        if (Cookie.get(name)) {
            Cookie.set(name, '', -1, path, domain);
        }
    };
    /**
     * Delete all cookie avaiable
     */
    Cookie.deleteAll = function (path, domain) {
        var cookies = Cookie.getAll();
        for (var cookieName in cookies) {
            Cookie.delete(cookieName, path, domain);
        }
    };
    return Cookie;
})();
exports.Cookie = Cookie;
//# sourceMappingURL=cookie.js.map

/***/ }),

/***/ "JMlz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var events_1 = __webpack_require__("NBsw");
var operators_1 = __webpack_require__("W+Sr");
var fromEvent_1 = __webpack_require__("TIy+");
var ResizeableDirective = /** @class */ (function () {
    function ResizeableDirective(element, renderer) {
        this.renderer = renderer;
        this.resizeEnabled = true;
        this.resize = new core_1.EventEmitter();
        this.resizing = false;
        this.element = element.nativeElement;
    }
    ResizeableDirective.prototype.ngAfterViewInit = function () {
        var renderer2 = this.renderer;
        var node = renderer2.createElement('span');
        if (this.resizeEnabled) {
            renderer2.addClass(node, 'resize-handle');
        }
        else {
            renderer2.addClass(node, 'resize-handle--not-resizable');
        }
        renderer2.appendChild(this.element, node);
    };
    ResizeableDirective.prototype.ngOnDestroy = function () {
        this._destroySubscription();
    };
    ResizeableDirective.prototype.onMouseup = function () {
        this.resizing = false;
        if (this.subscription && !this.subscription.closed) {
            this._destroySubscription();
            this.resize.emit(this.element.clientWidth);
        }
    };
    ResizeableDirective.prototype.onMousedown = function (event) {
        var _this = this;
        var isHandle = (event.target).classList.contains('resize-handle');
        var initialWidth = this.element.clientWidth;
        var mouseDownScreenX = event.screenX;
        if (isHandle) {
            event.stopPropagation();
            this.resizing = true;
            var mouseup = fromEvent_1.fromEvent(document, 'mouseup');
            this.subscription = mouseup
                .subscribe(function (ev) { return _this.onMouseup(); });
            var mouseMoveSub = fromEvent_1.fromEvent(document, 'mousemove')
                .pipe(operators_1.takeUntil(mouseup))
                .subscribe(function (e) { return _this.move(e, initialWidth, mouseDownScreenX); });
            this.subscription.add(mouseMoveSub);
        }
    };
    ResizeableDirective.prototype.move = function (event, initialWidth, mouseDownScreenX) {
        var movementX = event.screenX - mouseDownScreenX;
        var newWidth = initialWidth + movementX;
        var overMinWidth = !this.minWidth || newWidth >= this.minWidth;
        var underMaxWidth = !this.maxWidth || newWidth <= this.maxWidth;
        if (overMinWidth && underMaxWidth) {
            this.element.style.width = newWidth + "px";
        }
    };
    ResizeableDirective.prototype._destroySubscription = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], ResizeableDirective.prototype, "resizeEnabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], ResizeableDirective.prototype, "minWidth", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], ResizeableDirective.prototype, "maxWidth", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], ResizeableDirective.prototype, "resize", void 0);
    __decorate([
        core_1.HostListener('mousedown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ResizeableDirective.prototype, "onMousedown", null);
    ResizeableDirective = __decorate([
        core_1.Directive({
            selector: '[resizeable]',
            host: {
                '[class.resizeable]': 'resizeEnabled'
            }
        }),
        __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer2])
    ], ResizeableDirective);
    return ResizeableDirective;
}());
exports.ResizeableDirective = ResizeableDirective;
//# sourceMappingURL=resizeable.directive.js.map

/***/ }),

/***/ "Jc2l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var prefixes_1 = __webpack_require__("WzQ7");
var camel_case_1 = __webpack_require__("L9Tr");
// browser detection and prefixing tools
var transform = typeof window !== 'undefined' ? prefixes_1.getVendorPrefixedName('transform') : undefined;
var backfaceVisibility = typeof window !== 'undefined' ? prefixes_1.getVendorPrefixedName('backfaceVisibility') : undefined;
var hasCSSTransforms = typeof window !== 'undefined' ? !!prefixes_1.getVendorPrefixedName('transform') : undefined;
var hasCSS3DTransforms = typeof window !== 'undefined' ? !!prefixes_1.getVendorPrefixedName('perspective') : undefined;
var ua = typeof window !== 'undefined' ? window.navigator.userAgent : 'Chrome';
var isSafari = (/Safari\//).test(ua) && !(/Chrome\//).test(ua);
function translateXY(styles, x, y) {
    if (typeof transform !== 'undefined' && hasCSSTransforms) {
        if (!isSafari && hasCSS3DTransforms) {
            styles[transform] = "translate3d(" + x + "px, " + y + "px, 0)";
            styles[backfaceVisibility] = 'hidden';
        }
        else {
            styles[camel_case_1.camelCase(transform)] = "translate(" + x + "px, " + y + "px)";
        }
    }
    else {
        styles.top = y + "px";
        styles.left = x + "px";
    }
}
exports.translateXY = translateXY;
//# sourceMappingURL=translate.js.map

/***/ }),

/***/ "KGeA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExtraData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_baseEntity__ = __webpack_require__("mCwL");


/**
 * Created by alex.y on 9/18/2017.
 */
var ExtraData = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ExtraData, _super);
    function ExtraData(init) {
        var _this = _super.call(this) || this;
        Object.assign(_this, init);
        return _this;
    }
    return ExtraData;
}(__WEBPACK_IMPORTED_MODULE_1__common_baseEntity__["a" /* BaseEntity */]));

//# sourceMappingURL=extraData.js.map

/***/ }),

/***/ "KJe9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Class Cookie - Holds static functions to deal with Cookies
 */
var CookieService = (function () {
    function CookieService() {
    }
    /**
     * Checks the existence of a single cookie by it's name
     *
     * @param  {string} name Identification of the cookie
     * @returns existence of the cookie
     */
    CookieService.prototype.check = function (name) {
        if (typeof document === "undefined")
            return false; // Check if document exist avoiding issues on server side prerendering
        name = encodeURIComponent(name);
        var regexp = new RegExp('(?:^' + name + '|;\\s*' + name + ')=(.*?)(?:;|$)', 'g');
        var exists = regexp.test(document.cookie);
        return exists;
    };
    /**
     * Retrieves a single cookie by it's name
     *
     * @param  {string} name Identification of the Cookie
     * @returns The Cookie's value
     */
    CookieService.prototype.get = function (name) {
        if (this.check(name)) {
            name = encodeURIComponent(name);
            var regexp = new RegExp('(?:^' + name + '|;\\s*' + name + ')=(.*?)(?:;|$)', 'g');
            var result = regexp.exec(document.cookie);
            return decodeURIComponent(result[1]);
        }
        else {
            return '';
        }
    };
    /**
     * Retrieves a a list of all cookie avaiable
     *
     * @returns Object with all Cookies
     */
    CookieService.prototype.getAll = function () {
        var cookies = {};
        // tslint:disable-next-line:triple-equals
        if (document.cookie && document.cookie != '') {
            var split = document.cookie.split(';');
            for (var _i = 0, split_1 = split; _i < split_1.length; _i++) {
                var s = split_1[_i];
                var currCookie = s.split('=');
                currCookie[0] = currCookie[0].replace(/^ /, '');
                cookies[decodeURIComponent(currCookie[0])] = decodeURIComponent(currCookie[1]);
            }
        }
        return cookies;
    };
    /**
     * Save the Cookie
     *
     * @param  {string} name Cookie's identification
     * @param  {string} value Cookie's value
     * @param  {number} expires Cookie's expiration date in days from now or at a specific date from a Date object. If it's undefined the cookie is a session Cookie
     * @param  {string} path Path relative to the domain where the cookie should be avaiable. Default /
     * @param  {string} domain Domain where the cookie should be avaiable. Default current domain
     * @param  {boolean} secure If true, the cookie will only be available through a secured connection
     */
    CookieService.prototype.set = function (name, value, expires, path, domain, secure) {
        var cookieStr = encodeURIComponent(name) + '=' + encodeURIComponent(value) + ';';
        if (expires) {
            if (typeof expires === 'number') {
                var dtExpires = new Date(new Date().getTime() + expires * 1000 * 60 * 60 * 24);
                cookieStr += 'expires=' + dtExpires.toUTCString() + ';';
            }
            else {
                cookieStr += 'expires=' + expires.toUTCString() + ';';
            }
        }
        if (path) {
            cookieStr += 'path=' + path + ';';
        }
        if (domain) {
            cookieStr += 'domain=' + domain + ';';
        }
        if (secure) {
            cookieStr += 'secure;';
        }
        // console.log(cookieStr);
        document.cookie = cookieStr;
    };
    /**
     * Removes specified Cookie
     *
     * @param  {string} name Cookie's identification
     * @param  {string} path Path relative to the domain where the cookie should be avaiable. Default /
     * @param  {string} domain Domain where the cookie should be avaiable. Default current domain
     */
    CookieService.prototype.delete = function (name, path, domain) {
        this.set(name, '', -1, path, domain);
    };
    /**
     * Delete all cookie avaiable
     */
    CookieService.prototype.deleteAll = function (path, domain) {
        var cookies = this.getAll();
        for (var _i = 0, _a = Object.keys(cookies); _i < _a.length; _i++) {
            var cookieName = _a[_i];
            this.delete(cookieName, path, domain);
        }
    };
    return CookieService;
}());
exports.CookieService = CookieService;
exports.Cookie = new CookieService();
//# sourceMappingURL=cookie.js.map

/***/ }),

/***/ "KPjg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("X6wl"));
__export(__webpack_require__("C8Kb"));
__export(__webpack_require__("UHPl"));
__export(__webpack_require__("/UE+"));
__export(__webpack_require__("0RJd"));
__export(__webpack_require__("fj/O"));
__export(__webpack_require__("yN1j"));
__export(__webpack_require__("+erw"));
__export(__webpack_require__("aIIe"));
__export(__webpack_require__("I2hE"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "L9Tr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Converts strings from something to camel case
 * http://stackoverflow.com/questions/10425287/convert-dash-separated-string-to-camelcase
 */
function camelCase(str) {
    // Replace special characters with a space
    str = str.replace(/[^a-zA-Z0-9 ]/g, ' ');
    // put a space before an uppercase letter
    str = str.replace(/([a-z](?=[A-Z]))/g, '$1 ');
    // Lower case first character and some other stuff
    str = str.replace(/([^a-zA-Z0-9 ])|^[0-9]+/g, '').trim().toLowerCase();
    // uppercase characters preceded by a space or number
    str = str.replace(/([ 0-9]+)([a-zA-Z])/g, function (a, b, c) {
        return b.trim() + c.toUpperCase();
    });
    return str;
}
exports.camelCase = camelCase;
/**
 * Converts strings from camel case to words
 * http://stackoverflow.com/questions/7225407/convert-camelcasetext-to-camel-case-text
 */
function deCamelCase(str) {
    return str
        .replace(/([A-Z])/g, function (match) { return " " + match; })
        .replace(/^./, function (match) { return match.toUpperCase(); });
}
exports.deCamelCase = deCamelCase;
//# sourceMappingURL=camel-case.js.map

/***/ }),

/***/ "LOzE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ImporterType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImportToType; });
var ImporterType;
(function (ImporterType) {
    ImporterType[ImporterType["Vehicle"] = 0] = "Vehicle";
    ImporterType[ImporterType["Product"] = 1] = "Product";
    ImporterType[ImporterType["Regular"] = 2] = "Regular";
    ImporterType[ImporterType["Enterprise"] = 3] = "Enterprise";
})(ImporterType || (ImporterType = {}));
var ImportToType;
(function (ImportToType) {
    ImportToType[ImportToType["Canada"] = 0] = "Canada";
    ImportToType[ImportToType["Usa"] = 1] = "Usa";
})(ImportToType || (ImportToType = {}));
//# sourceMappingURL=type.js.map

/***/ }),

/***/ "Lttq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function selectRows(selected, row, comparefn) {
    var selectedIndex = comparefn(row, selected);
    if (selectedIndex > -1) {
        selected.splice(selectedIndex, 1);
    }
    else {
        selected.push(row);
    }
    return selected;
}
exports.selectRows = selectRows;
function selectRowsBetween(selected, rows, index, prevIndex, comparefn) {
    var reverse = index < prevIndex;
    for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var greater = i >= prevIndex && i <= index;
        var lesser = i <= prevIndex && i >= index;
        var range = { start: 0, end: 0 };
        if (reverse) {
            range = {
                start: index,
                end: prevIndex
            };
        }
        else {
            range = {
                start: prevIndex,
                end: index + 1
            };
        }
        if ((reverse && lesser) || (!reverse && greater)) {
            // if in the positive range to be added to `selected`, and
            // not already in the selected array, add it
            if (i >= range.start && i <= range.end) {
                selected.push(row);
            }
        }
    }
    return selected;
}
exports.selectRowsBetween = selectRowsBetween;
//# sourceMappingURL=selection.js.map

/***/ }),

/***/ "LuMv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Class UnmanagedCookieService - Holds static functions to deal with Cookies
 */
var UnmanagedCookieService = (function () {
    function UnmanagedCookieService() {
    }
    /**
     * Checks the existence of a single cookie by it's name
     *
     * @param  {string} name Identification of the cookie
     * @returns existence of the cookie
     */
    UnmanagedCookieService.prototype.check = function (name) {
        if (typeof document === "undefined")
            return false; // Check if document exist avoiding issues on server side prerendering
        var regexp = new RegExp('(?:^' + name + '|;\\s*' + name + ')=(.*?)(?:;|$)', 'g');
        var exists = regexp.test(document.cookie);
        return exists;
    };
    /**
     * Retrieves a single cookie by it's name
     *
     * @param  {string} name Identification of the Cookie
     * @returns The Cookie's value
     */
    UnmanagedCookieService.prototype.get = function (name) {
        if (this.check(name)) {
            var regexp = new RegExp('(?:^' + name + '|;\\s*' + name + ')=(.*?)(?:;|$)', 'g');
            var result = regexp.exec(document.cookie);
            return result[1];
        }
        else {
            return '';
        }
    };
    /**
     * Retrieves a a list of all cookie avaiable
     *
     * @returns Object with all Cookies
     */
    UnmanagedCookieService.prototype.getAll = function () {
        var cookies = {};
        // tslint:disable-next-line:triple-equals
        if (document.cookie && document.cookie != '') {
            var split = document.cookie.split(';');
            for (var _i = 0, split_1 = split; _i < split_1.length; _i++) {
                var s = split_1[_i];
                var currCookie = s.split('=');
                currCookie[0] = currCookie[0].replace(/^ /, '');
                cookies[currCookie[0]] = currCookie[1];
            }
        }
        return cookies;
    };
    /**
     * Save the Cookie
     *
     * @param  {string} name Cookie's identification
     * @param  {string} value Cookie's value
     * @param  {number} expires Cookie's expiration date in days from now or at a specific date from a Date object. If it's undefined the cookie is a session Cookie
     * @param  {string} path Path relative to the domain where the cookie should be avaiable. Default /
     * @param  {string} domain Domain where the cookie should be avaiable. Default current domain
     * @param  {boolean} secure If true, the cookie will only be available through a secured connection
     */
    UnmanagedCookieService.prototype.set = function (name, value, expires, path, domain, secure) {
        var cookieStr = name + '=' + value + ';';
        if (expires) {
            if (typeof expires === 'number') {
                var dtExpires = new Date(new Date().getTime() + expires * 1000 * 60 * 60 * 24);
                cookieStr += 'expires=' + dtExpires.toUTCString() + ';';
            }
            else {
                cookieStr += 'expires=' + expires.toUTCString() + ';';
            }
        }
        if (path) {
            cookieStr += 'path=' + path + ';';
        }
        if (domain) {
            cookieStr += 'domain=' + domain + ';';
        }
        if (secure) {
            cookieStr += 'secure;';
        }
        // console.log(cookieStr);
        document.cookie = cookieStr;
    };
    /**
     * Removes specified Cookie
     *
     * @param  {string} name Cookie's identification
     * @param  {string} path Path relative to the domain where the cookie should be avaiable. Default /
     * @param  {string} domain Domain where the cookie should be avaiable. Default current domain
     */
    UnmanagedCookieService.prototype.delete = function (name, path, domain) {
        this.set(name, '', -1, path, domain);
    };
    /**
     * Delete all cookie avaiable
     */
    UnmanagedCookieService.prototype.deleteAll = function (path, domain) {
        var cookies = this.getAll();
        for (var _i = 0, _a = Object.keys(cookies); _i < _a.length; _i++) {
            var cookieName = _a[_i];
            this.delete(cookieName, path, domain);
        }
    };
    return UnmanagedCookieService;
}());
exports.UnmanagedCookieService = UnmanagedCookieService;
exports.UnmanagedCookie = new UnmanagedCookieService();
//# sourceMappingURL=unmanagedCookie.js.map

/***/ }),

/***/ "M4fF":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.4';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
          srcValue = source[key],
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length &&
        (typeof value == 'number' || reIsUint.test(value)) &&
        (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(args) {
      args.push(undefined, customDefaultsAssignIn);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "M9C8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LMCreateModalComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_management_locationManagement_location__ = __webpack_require__("ZxOp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_management_locationManagement_locationType__ = __webpack_require__("vlGe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_locationService__ = __webpack_require__("tI4G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_blurUtil__ = __webpack_require__("vWtP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_EnumUtil__ = __webpack_require__("niNk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_LocationUtil__ = __webpack_require__("uI+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__objects_requests_locationUpdateRequest__ = __webpack_require__("/Th8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ng2_toastr__ = __webpack_require__("xssS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ng2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_ng2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__objects_management_order_orderLocation__ = __webpack_require__("oiko");










/**
 * Created by alex.y on 8/2/2017.
 */
var LMCreateModalComponent = /** @class */ (function () {
    function LMCreateModalComponent(toastr, locationService, ChangeDetectorRef) {
        this.toastr = toastr;
        this.locationService = locationService;
        this.ChangeDetectorRef = ChangeDetectorRef;
        this.locationCreated = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        // @Input()
        this.locationProp = new __WEBPACK_IMPORTED_MODULE_9__objects_management_order_orderLocation__["a" /* OrderLocation */]();
        this.locationPropInput = new __WEBPACK_IMPORTED_MODULE_9__objects_management_order_orderLocation__["a" /* OrderLocation */]();
        this.errors = [];
        this.locationTypeLink = __WEBPACK_IMPORTED_MODULE_2__objects_management_locationManagement_locationType__["a" /* LocationType */];
        this.isEditModal = false;
        this.enumUtil = __WEBPACK_IMPORTED_MODULE_5__common_utils_EnumUtil__["a" /* EnumUtil */];
        this.locationType = null;
        this.showForm = false;
        this.changeOrder = false;
        this.typeChanged = false;
    }
    LMCreateModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.locationModal.onHidden.subscribe(function (x) { return _this.onHiddenHandler(); });
    };
    LMCreateModalComponent.prototype.onHiddenHandler = function () {
        __WEBPACK_IMPORTED_MODULE_4__common_utils_blurUtil__["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
        $('#locationType').select2('destroy');
        $('#locationType').off('select2:select');
        $('#locationType').off('select2:unselect');
        this.locationForm.reset();
        this.showForm = false;
    };
    LMCreateModalComponent.prototype.hide = function () {
        this.locationModal.hide();
    };
    LMCreateModalComponent.prototype.show = function (isEditModal, location) {
        var _this = this;
        if (isEditModal === void 0) { isEditModal = false; }
        if (location === void 0) { location = new __WEBPACK_IMPORTED_MODULE_1__objects_management_locationManagement_location__["a" /* Location */](); }
        this.locationModal.show();
        this.showForm = true;
        this.changeOrder = false;
        this.isEditModal = isEditModal;
        //this.originalAgent = agent;
        this.locationProp = JSON.parse(JSON.stringify(location));
        this.locationPropInput = JSON.parse(JSON.stringify(location));
        this.originalLocation = JSON.parse(JSON.stringify(location));
        this.locationFromString = __WEBPACK_IMPORTED_MODULE_6__common_utils_LocationUtil__["a" /* LocationUtil */].formatAddress(this.locationProp, true);
        this.locationType = this.locationProp.Type;
        this.typeChanged = false;
        __WEBPACK_IMPORTED_MODULE_4__common_utils_blurUtil__["a" /* BlurUtil */].blurMenu(this.idToBlur);
        setTimeout(function (x) {
            _this.initSelect2LocationType();
        }, 200);
    };
    LMCreateModalComponent.prototype.convertEnumToTuple = function (enumType) {
        return __WEBPACK_IMPORTED_MODULE_5__common_utils_EnumUtil__["a" /* EnumUtil */].convertEnumToTuple(enumType);
    };
    LMCreateModalComponent.prototype.initSelect2LocationType = function () {
        var self = this;
        var tupl = (self.enumUtil.convertEnumToTuple(self.locationTypeLink));
        tupl.splice(tupl.indexOf(tupl.find(function (x) { return x.Key == 5; })));
        $('#locationType').select2({
            width: '100%',
            data: self.generateSelectData(tupl),
            allowClear: true,
            placeholder: 'Select Type',
            closeOnSelect: true
        }).on('select2:select', function (e) {
            // self.orderItem.Currency = ;
            // let code: CanadianCurrencyCode = self.canadianCurrencyCodes.find(x => x.Code == $(this).val());
            // Object.assign(self.orderItem.CanadianCurrencyCode, code);
            self.locationType = $(this).val();
            self.typeChanged = self.originalLocation.Type != self.locationType;
            self.ChangeDetectorRef.detectChanges();
            self.locationModel.model.control.updateValueAndValidity();
        }).on('select2:unselect', function (e) {
            self.locationType = null;
            self.ChangeDetectorRef.detectChanges();
            self.locationModel.model.control.updateValueAndValidity();
        });
        $("#locationType").val(self.locationProp.Type).trigger("change");
    };
    LMCreateModalComponent.prototype.generateSelectData = function (data) {
        var result = [];
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var item = data_1[_i];
            result.push({
                id: item.Key,
                text: item.Value
            });
        }
        return result;
    };
    LMCreateModalComponent.prototype.onLocationChange = function (location) {
        this.locationProp = location;
        if (location != null)
            this.locationFromString = __WEBPACK_IMPORTED_MODULE_6__common_utils_LocationUtil__["a" /* LocationUtil */].formatAddress(location, true);
        this.ChangeDetectorRef.detectChanges();
        this.locationModel.model.control.updateValueAndValidity();
    };
    LMCreateModalComponent.prototype.createLocation = function (isValid) {
        var _this = this;
        if (!isValid)
            return;
        if (!this.locationProp)
            return;
        this.locationProp.Type = this.locationType;
        this.processing = true;
        this.locationService.modify(new __WEBPACK_IMPORTED_MODULE_7__objects_requests_locationUpdateRequest__["a" /* LocationUpdateRequest */]({ Location: this.locationProp, ChangeOrders: this.changeOrder })).then(function (result) {
            _this.processing = false;
            if (!result || !result.Data)
                return;
            if (_this.changeOrder)
                _this.toastr.success("Orders were updated");
            _this.locationCreated.emit(result.Data);
            _this.hide();
        }).catch(function () {
            _this.processing = false;
            _this.toastr.error("Does not change any order");
        });
    };
    LMCreateModalComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_8_ng2_toastr__["ToastsManager"] }, { type: __WEBPACK_IMPORTED_MODULE_3__services_locationService__["a" /* LocationService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] }]; };
    return LMCreateModalComponent;
}());

//# sourceMappingURL=locationManagementCreateModal.component.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "MAv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrderItemOptions; });
/**
 * Created by alex.y on 10/13/2017.
 */
var OrderItemOptions;
(function (OrderItemOptions) {
    OrderItemOptions[OrderItemOptions["IsPassVehicle"] = 1] = "IsPassVehicle";
    OrderItemOptions[OrderItemOptions["IsTrucks"] = 2] = "IsTrucks";
    OrderItemOptions[OrderItemOptions["IsAC"] = 4] = "IsAC";
    OrderItemOptions[OrderItemOptions["IsVehicleParts"] = 8] = "IsVehicleParts";
    OrderItemOptions[OrderItemOptions["IsLessOrEqualFifteenYrs"] = 16] = "IsLessOrEqualFifteenYrs";
    OrderItemOptions[OrderItemOptions["UsedEquipment"] = 32] = "UsedEquipment";
    OrderItemOptions[OrderItemOptions["isTrailerOnly"] = 64] = "isTrailerOnly";
})(OrderItemOptions || (OrderItemOptions = {}));
//# sourceMappingURL=orderItemOptions.js.map

/***/ }),

/***/ "MDYC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OperatorType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Query; });
var START_OF_ISO_WEEK = 1;
var resetYear = function (d) {
    if (d === null)
        return null;
    return new Date(d.getFullYear(), 0);
};
var resetISOWeek = function (d) {
    if (d === null)
        return null;
    var day = d.getDay();
    var diff = (day < START_OF_ISO_WEEK ? 7 : 0) + day - START_OF_ISO_WEEK;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() - diff);
};
function asValidDateOrNull(date) {
    if (isValidDate(date))
        return date;
    return null;
}
function asValidDateOrThrow(date, origin) {
    if (isValidDate(date))
        return date;
    throw new TypeError("Cant parse date from \"" + origin + "\"");
}
var newValidDateOrThrow = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = new ((_a = Date).bind.apply(_a, [void 0].concat(args)))();
    return asValidDateOrThrow(result, args);
    var _a;
};
function isValidDate(d) {
    return d !== null && d instanceof Date && isFinite(d.getTime());
}
function leadZero(n, targetLength) {
    if (targetLength === void 0) {
        targetLength = 2;
    }
    var output = n + '';
    while (output.length < targetLength) {
        output = '0' + output;
    }
    return output;
}
function absFloor(num) {
    if (num < 0) {
        // -0 -> 0
        return Math.ceil(num) || 0;
    }
    else {
        return Math.floor(num);
    }
}
function tokensRx(obj) {
    var keys = [];
    for (var key in obj) {
        keys.push(key);
    }
    keys.sort(function (a, b) { return b.length - a.length; });
    return new RegExp(keys.join('|') + '|\\[[^[]*\\]|.', 'g');
}
var diffCalendarDate = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var u1 = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate());
    var u2 = Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate());
    return absFloor((u1 - u2) / 86400000 /* Date */);
};
/**
 * Makes function that return part of ISO 8610 formatted string
 */
function createFormatIso(len) {
    return function (d) {
        if (!isValidDate(d))
            return null;
        var date = new Date(d.getTime());
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
        return date.toISOString().substring(0, len);
    };
}
// YYYY-MM-DD
// YYYY-MM-DDTHH:mm
// YYYY-MM-DDTHH:mm:ss.SSS
var formatLocalIso = createFormatIso(23);
var formatters = {
    // Month: 1, 2, ..., 12
    'M': function (date) { return date.getMonth() + 1; },
    // Month: 01, 02, ..., 12
    'MM': function (date) { return leadZero(date.getMonth() + 1); },
    // Quarter: 1, 2, 3, 4
    'Q': function (date) { return Math.ceil((date.getMonth() + 1) / 3); },
    // Day of month: 1, 2, ..., 31
    'D': function (date) { return date.getDate(); },
    // Day of month: 01, 02, ..., 31
    'DD': function (date) { return leadZero(date.getDate()); },
    // Day of year: 1, 2, ..., 366
    'DDD': function (date) { return diffCalendarDate(date, resetYear(date)) + 1; },
    // Day of year: 001, 002, ..., 366
    'DDDD': function (date) { return leadZero(formatters['DDD'](date), 3); },
    // Day of week: 0, 1, ..., 6
    'd': function (date) { return date.getDay(); },
    // Day of ISO week: 1, 2, ..., 7
    'E': function (date) { return date.getDay() || 7; },
    // ISO week: 1, 2, ..., 53
    'W': function (date) {
        var isoYear = +formatters['GGGG'](date);
        var start = resetISOWeek(newValidDateOrThrow(isoYear, 0, 4));
        return Math.floor(diffCalendarDate(date, start) / 7) + 1;
    },
    // ISO week: 01, 02, ..., 53
    'WW': function (date) { return leadZero(formatters['W'](date)); },
    // Year: 00, 01, ..., 99
    'YY': function (date) { return date.getFullYear().toString().slice(-2); },
    // Year: 1900, 1901, ..., 2099
    'YYYY': function (date) { return leadZero(date.getFullYear(), 4); },
    // ISO week-numbering year: 00, 01, ..., 99
    'GG': function (date) { return formatters['GGGG'](date).toString().slice(-2); },
    // ISO week-numbering year: 1900, 1901, ..., 2099
    'GGGG': function (date) {
        var startYear = date.getFullYear();
        var correction = date < resetISOWeek(newValidDateOrThrow(startYear, 0, 4))
            ? -1
            : date < resetISOWeek(newValidDateOrThrow(startYear + 1, 0, 4))
                ? 0
                : 1;
        return leadZero(startYear + correction, 4);
    },
    // Hour: 0, 1, ... 23
    'H': function (date) { return date.getHours(); },
    // Hour: 00, 01, ..., 23
    'HH': function (date) { return leadZero(date.getHours()); },
    // Hour: 1, 2, ..., 12
    'h': function (date) { return (date.getHours() % 12) || 12; },
    // Hour: 01, 02, ..., 12
    'hh': function (date) { return leadZero(formatters['h'](date)); },
    // Minute: 0, 1, ..., 59
    'm': function (date) { return date.getMinutes(); },
    // Minute: 00, 01, ..., 59
    'mm': function (date) { return leadZero(date.getMinutes()); },
    // Second: 0, 1, ..., 59
    's': function (date) { return date.getSeconds(); },
    // Second: 00, 01, ..., 59
    'ss': function (date) { return leadZero(date.getSeconds()); },
    // 1/10 of second: 0, 1, ..., 9
    'S': function (date) { return Math.floor(date.getMilliseconds() / 100); },
    // 1/100 of second: 00, 01, ..., 99
    'SS': function (date) { return leadZero(Math.floor(date.getMilliseconds() / 10)); },
    // Millisecond: 000, 001, ..., 999
    'SSS': function (date) { return leadZero(date.getMilliseconds(), 3); },
    // Timezone: -01:00, +00:00, ... +12:00
    'Z': function (date) { return formatTimezone(date.getTimezoneOffset(), ':'); },
    // Timezone: -0100, +0000, ... +1200
    'ZZ': function (date) { return formatTimezone(date.getTimezoneOffset()); },
    // Seconds timestamp: 512969520
    'X': function (date) { return Math.floor(date.getTime() / 1000); },
    // Milliseconds timestamp: 512969520900
    'x': function (date) { return date.getTime(); },
};
function formatTimezone(offset, delimeter) {
    if (delimeter === void 0) {
        delimeter = '';
    }
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    return sign + leadZero(hours) + delimeter + leadZero(minutes);
}
function splitToTokens(template, formatters) {
    var RX_TOKENS = tokensRx(formatters);
    var tokens = template.match(RX_TOKENS);
    // this regexp cant fail because of "|."
    var result = [];
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        var tokenFn = formatters[token];
        if (tokenFn) {
            result.push(tokenFn);
        }
        else if (token.charAt(0) === '[' && token.charAt(token.length - 1) === ']') {
            result.push(token.substring(1, token.length - 1));
        }
        else {
            result.push(token);
        }
    }
    return result;
}
function formatByTokens(d, tokens) {
    var result = [];
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        result.push(typeof token === 'function' ? token(d, i, tokens) : token);
    }
    return result.join('');
}
function createFormat(formatters) {
    var cache = {};
    return function (d, template) {
        if (!isValidDate(d))
            return null;
        var tokens = cache[template];
        if (tokens === undefined) {
            tokens = splitToTokens(template, formatters);
            cache[template] = tokens;
        }
        return formatByTokens(d, tokens);
    };
}
/**
 * format without any locale, just numbers
 */
var format = createFormat(formatters);
var rx1 = '\\d';
var rx2 = '\\d\\d';
var rx12 = '\\d\\d?';
var rx3 = '\\d{3}';
var rx4 = '\\d{4}';
var rxN = '\\d{5,}';
var defaultParsers = {
    // Month: 1, 2, ..., 12
    'M': [rx12, function (date, value) { date.setMonth(+value - 1); }],
    // Month: 01, 02, ..., 12
    'MM': [rx2, function (date, value) { date.setMonth(+value - 1); }],
    // Quarter: 1, 2, 3, 4
    // 'Q': (date, value) => Math.ceil((date.getMonth() + 1) / 3),
    // Day of month: 1, 2, ..., 31
    'D': [rx12, function (date, value) { date.setDate(+value); }],
    // Day of month: 01, 02, ..., 31
    'DD': [rx2, function (date, value) { date.setDate(+value); }],
    // Day of year: 1, 2, ..., 366
    // TODO 'DDD': (date, value) => getDayOfYear(date),
    // Day of year: 001, 002, ..., 366
    // TODO 'DDDD': (date, value) => leadZero(getDayOfYear(date), 3),
    // Day of week: 0, 1, ..., 6
    // 'd': (date, value) => date.getDay(),
    // Day of ISO week: 1, 2, ..., 7
    // 'E': (date, value) => date.getDay() || 7,
    // ISO week: 1, 2, ..., 53
    // TODO 'W': (date, value) => getISOWeek(date),
    // ISO week: 01, 02, ..., 53
    // TODO 'WW': (date, value) => leadZero(getISOWeek(date)),
    // Year: 00, 01, ..., 99
    'YY': [rx2, function (date, value) { date.setFullYear(2000 + +value); }],
    // Year: 1900, 1901, ..., 2099
    'YYYY': [rx4, function (date, value) { date.setFullYear(+value); }],
    // ISO week-numbering year: 00, 01, ..., 99
    // TODO 'GG': (date, value) => getISOYear(date).toString().slice(-2),
    // ISO week-numbering year: 1900, 1901, ..., 2099
    // TODO 'GGGG': (date, value) => getISOYear(date),
    // Hour: 0, 1, ... 23
    'H': [rx12, function (date, value) { date.setHours(+value); }],
    // Hour: 00, 01, ..., 23
    'HH': [rx2, function (date, value) { date.setHours(+value); }],
    // Hour: 1, 2, ..., 12
    //'h': (date, value) => (date.getHours() % 12) || 12,
    // Hour: 01, 02, ..., 12
    // 'hh': (date, value) => leadZero(formatters['h'](date)),
    // Minute: 0, 1, ..., 59
    'm': [rx12, function (date, value) { date.setMinutes(+value); }],
    // Minute: 00, 01, ..., 59
    'mm': [rx2, function (date, value) { date.setMinutes(+value); }],
    // Second: 0, 1, ..., 59
    's': [rx12, function (date, value) { date.setSeconds(+value); }],
    // Second: 00, 01, ..., 59
    'ss': [rx2, function (date, value) { date.setSeconds(+value); }],
    // 1/10 of second: 0, 1, ..., 9
    'S': [rx1, function (date, value) { date.setMilliseconds(+value * 100); }],
    // 1/100 of second: 00, 01, ..., 99
    'SS': [rx2, function (date, value) { date.setMilliseconds(+value * 10); }],
    // Millisecond: 000, 001, ..., 999
    'SSS': [rx3, function (date, value) { date.setMilliseconds(+value); }],
    // Timezone: -01:00, +00:00, ... +12:00
    // TODO 'Z': (date, value) => formatTimezone(date.getTimezoneOffset(), ':'),
    // Timezone: -0100, +0000, ... +1200
    // TODO 'ZZ': (date, value) => formatTimezone(date.getTimezoneOffset()),
    // Seconds timestamp: 512969520
    'X': [rxN, function (date, value) { date.setTime(+value * 1000); }],
    // Milliseconds timestamp: 512969520900
    'x': [rxN, function (date, value) { date.setTime(+value); }],
};
function escapeRegExp(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
function createParse(parsers) {
    var RX_TOKENS = tokensRx(parsers);
    return function parse(dateStr, template) {
        var tokens = template.match(RX_TOKENS);
        // this regexp cant fail because of "|."
        var parsersFn = [];
        var rxStr = tokens.map(function (token) {
            var parser = parsers[token];
            if (parser) {
                parsersFn.push(parser[1]);
                var regexpPart = parser[0];
                return "(" + regexpPart + ")";
            }
            if (token.charAt(0) === '[' && token.charAt(token.length - 1) === ']')
                token = token.substring(1, token.length - 1);
            return escapeRegExp(token);
        }).join('');
        var rx = new RegExp('^' + rxStr + '$', 'i');
        var values = dateStr.match(rx);
        if (!values)
            return null;
        /* NOTE second zero needed to set current timezone */
        var date = new Date(0, 0);
        values.slice(1).forEach(function (value, index) {
            var parserFn = parsersFn[index];
            parserFn(date, value);
        });
        return asValidDateOrNull(date);
    };
}
/**
 * parse without any locale, just numbers
 */
var parse = createParse(defaultParsers);
var OperatorType = {};
OperatorType.Eq = /** @type {?} */ ("eq");
OperatorType.Less = /** @type {?} */ ("lt");
OperatorType.Greater = /** @type {?} */ ("gt");
OperatorType.GreaterOrEqual = /** @type {?} */ ("ge");
OperatorType.LessOrEqual = /** @type {?} */ ("le");
OperatorType.NotEqual = /** @type {?} */ ("ne");
OperatorType[OperatorType.Eq] = "Eq";
OperatorType[OperatorType.Less] = "Less";
OperatorType[OperatorType.Greater] = "Greater";
OperatorType[OperatorType.GreaterOrEqual] = "GreaterOrEqual";
OperatorType[OperatorType.LessOrEqual] = "LessOrEqual";
OperatorType[OperatorType.NotEqual] = "NotEqual";
var OrderBy = {};
OrderBy.Asc = /** @type {?} */ ("asc");
OrderBy.Desc = /** @type {?} */ ("desc");
OrderBy[OrderBy.Asc] = "Asc";
OrderBy[OrderBy.Desc] = "Desc";
var Query = /** @class */ (function () {
    /**
     * @param {?=} extendedPropName
     */
    function Query(extendedPropName) {
        this._select = [];
        this._filter = [];
        this._orderBy = [];
        this._expand = [];
        this._extendedPropName = extendedPropName;
    }
    /**
     * @return {?}
     */
    Query.create = function () {
        return new Query();
    };
    /**
     * @param {?} value
     * @return {?}
     */
    Query.isGuid = function (value) {
        value = value.toLowerCase();
        var /** @type {?} */ regex = /[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}/i;
        var /** @type {?} */ match = regex.exec(value);
        return match != null;
    };
    /**
     * @param {?} field
     * @param {?} order
     * @return {?}
     */
    Query.prototype.orderBy = function (field, order) {
        if (!field || field.length == 0)
            return this;
        return this.orderByComplex(field + " " + order);
    };
    /**
     * @param {?} orderBy
     * @return {?}
     */
    Query.prototype.orderByComplex = function (orderBy) {
        this._orderBy.push(orderBy);
        return this;
    };
    /**
     * @param {?} propertyName
     * @param {?=} func
     * @return {?}
     */
    Query.prototype.expand = function (propertyName, func) {
        var /** @type {?} */ exQuery = new Query(propertyName);
        if (func != null) {
            func(exQuery);
        }
        this._expand.push(exQuery);
        return this;
    };
    /**
     * @param {?} field
     * @param {?} operator
     * @param {?} val2
     * @param {?=} format
     * @return {?}
     */
    Query.prototype.filter = function (field, operator, val2, format$$1) {
        if ((field == null || field.length == 0) || (val2 == null || val2.length == 0))
            return this;
        if (val2 instanceof Date) {
            if (format$$1)
                val2 = format(val2, format$$1);
            else
                val2 = formatLocalIso(val2) + "Z";
        }
        else if (typeof val2 == "string" && !Query.isGuid(val2) && val2.indexOf("'") === -1) {
            val2 = "'" + val2 + "'";
        }
        return this.filterComplex(field + " " + operator.toString() + " " + val2);
    };
    /**
     * @param {?} filter
     * @return {?}
     */
    Query.prototype.filterComplex = function (filter) {
        this._filter.push(filter);
        return this;
    };
    /**
     * @param {?} skip
     * @return {?}
     */
    Query.prototype.skip = function (skip) {
        this._skip = skip;
        return this;
    };
    /**
     * @param {?} top
     * @return {?}
     */
    Query.prototype.top = function (top) {
        this._top = top;
        return this;
    };
    /**
     * @param {?} count
     * @return {?}
     */
    Query.prototype.count = function (count) {
        this._count = count;
        return this;
    };
    /**
     * @param {...?} fields
     * @return {?}
     */
    Query.prototype.select = function () {
        var fields = [];
        for (var _b = 0; _b < arguments.length; _b++) {
            fields[_b] = arguments[_b];
        }
        this._select = fields;
        return this;
    };
    /**
     * @param {?} result
     * @param {?} prefix
     * @param {?} delimiter
     * @param {?} variable
     * @return {?}
     */
    Query.checkAndAppend = function (result, prefix, delimiter, variable) {
        if (variable == null)
            return result;
        if (typeof variable == "number" && variable == 0) {
            return result;
        }
        if (typeof variable == "boolean" && !variable) {
            return result;
        }
        if (variable)
            return Query.append(result, prefix, delimiter, variable);
        return result;
    };
    /**
     * @param {?} result
     * @param {?} prefix
     * @param {?} delimiter
     * @param {?} variable
     * @return {?}
     */
    Query.append = function (result, prefix, delimiter, variable) {
        var /** @type {?} */ length = result.length;
        if (length > 0)
            result = "" + result + delimiter + prefix + "=" + variable;
        else
            result = prefix + "=" + variable;
        return result;
    };
    /**
     * @return {?}
     */
    Query.prototype.compile = function () {
        var /** @type {?} */ isExpand = this._extendedPropName != null && this._extendedPropName.length > 0;
        var /** @type {?} */ resultStr = "";
        var /** @type {?} */ delimiter = isExpand ? ';' : '&';
        if (this._top != 0) {
            resultStr = Query.checkAndAppend(resultStr, '$top', delimiter, this._top);
        }
        if (this._skip != 0) {
            resultStr = Query.checkAndAppend(resultStr, '$skip', delimiter, this._skip);
        }
        resultStr = Query.checkAndAppend(resultStr, '$count', delimiter, this._count);
        if (this._filter.length > 0) {
            resultStr = Query.checkAndAppend(resultStr, '$filter', delimiter, this._filter.join(" and "));
        }
        if (this._orderBy.length > 0) {
            resultStr = Query.checkAndAppend(resultStr, '$orderby', delimiter, this._orderBy.join(','));
        }
        if (this._select.length > 0) {
            resultStr = Query.checkAndAppend(resultStr, '$select', delimiter, this._select.join(','));
        }
        if (this._expand.length > 0) {
            var /** @type {?} */ result = [];
            for (var _b = 0, _c = this._expand; _b < _c.length; _b++) {
                var item = _c[_b];
                var /** @type {?} */ compiled = item.compile();
                result.push(compiled);
            }
            if (result.length > 0) {
                resultStr = Query.checkAndAppend(resultStr, '$expand', delimiter, result.join(','));
            }
        }
        if (resultStr.length > 0 && isExpand)
            resultStr = "(" + resultStr + ")";
        if (isExpand)
            resultStr = "" + this._extendedPropName + resultStr;
        return resultStr;
    };
    return Query;
}());
window.Query = Query || {};
window.OperatorType = OperatorType || {};
window.OrderBy = OrderBy || {};
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=ngx-odata-v4.es5.js.map


/***/ }),

/***/ "MT2O":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["HelloSign"] = factory();
	else
		root["HelloSign"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/embedded.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./package.json":
/*!**********************!*\
  !*** ./package.json ***!
  \**********************/
/*! exports provided: name, version, description, homepage, main, license, scripts, repository, author, devDependencies, files, default */
/***/ (function(module) {

module.exports = {"name":"hellosign-embedded","version":"1.4.3","description":"Embed HelloSign signature requests and templates from within your web application.","homepage":"https://github.com/HelloFax/hellosign-embedded","main":"index.js","license":"ISC","scripts":{"build":"webpack","demo":"npm run build && npm start --prefix=demo","prerelease":"node scripts/pre-release.js","prepublishOnly":"npm install && npm run build && npm run prerelease","setup":"npm install && npm run build && npm run setup --prefix=demo","test":"mocha test"},"repository":{"type":"git","url":"https://github.com/HelloFax/hellosign-embedded.git"},"author":{"name":"HelloSign","email":"api@hellosign.com","url":"https://hellosign.com"},"devDependencies":{"@babel/core":"^7.0.0-beta.42","@babel/plugin-proposal-object-rest-spread":"^7.0.0-beta.42","@babel/plugin-transform-object-assign":"^7.0.0-beta.42","@babel/preset-env":"^7.0.0-beta.42","babel-loader":"^8.0.0-beta.2","chai":"^4.1.2","jsdom":"^11.6.2","jsdom-global":"^3.0.2","mocha":"^5.0.4","webpack":"^4.2.0","webpack-cli":"^2.0.13"},"files":["umd","index.js"]};

/***/ }),

/***/ "./src/embedded.js":
/*!*************************!*\
  !*** ./src/embedded.js ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * HelloSign JS library for embeddables
 * Copyright (c) 2016 HelloSign
 *
 * XWM - Cross-window messaging inspired by Ben Alman's
 * jQuery postMessage plugin:
 * http://benalman.com/projects/jquery-postmessage-plugin/
 *
 *    Copyright (c) 2009 "Cowboy" Ben Alman
 *    Dual licensed under the MIT and GPL licenses.
 *    http://benalman.com/about/license/
 */
(function () {
  function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      vars[key] = value;
    });
    return vars;
  } // Underscore.js debounce implementation.
  //
  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.


  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
          args = arguments;

      var later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  var urlVars = getUrlVars();
  window.isDebugEnabled = urlVars.debug ? urlVars.debug === 'true' : false;
  var userAgent = navigator.userAgent.toLowerCase();
  var XWM = {
    cacheBust: 0,
    lastHash: 0,
    intervalId: 0,
    rmCallback: null,
    defaultDelay: 500,
    hasPostMessage: window['postMessage'] !== undefined,
    _serializeMessageValue: function _serializeMessageValue(value) {
      if (_typeof(value) === 'object') {
        value = JSON.stringify(value);
      }

      return encodeURIComponent(value);
    },
    send: function send(message, targetUrl, target) {
      l('XWM Send: Sending Message.');
      l('  targetUrl: ' + targetUrl);
      var self = XWM;

      if (!targetUrl) {
        return;
      } // Serialize the message into a string


      if (typeof message != 'string') {
        var parts = [];

        for (var k in message) {
          parts.push(k + '=' + this._serializeMessageValue(message[k]));
        }

        message = parts.join('&');
      }

      l('  message: ' + message);

      if (self.hasPostMessage) {
        // The browser supports window.postMessage, so call it with a targetOrigin
        // set appropriately, based on the targetUrl parameter.
        target = target || parent;
        target['postMessage'](message, targetUrl.replace(/([^:]+:\/\/[^\/]+).*/, '$1'));
      } else if (targetUrl) {
        // The browser does not support window.postMessage, so set the location
        // of the target to targetUrl#message. A bit ugly, but it works! A cache
        // bust parameter is added to ensure that repeat messages trigger the
        // callback.
        var t = new Date().getTime();
        var c = ++self.cacheBust;
        var targetFrame = document.getElementById(target); // target is the window id in this case
        // targetWindow.location = targetUrl.replace( /#.*$/, '' ) + '#' + t + c + '&' + message;

        if (targetFrame) {
          targetFrame.setAttribute('src', targetUrl.replace(/#.*$/, '') + '#' + t + c + '&' + message);
        } else {
          parent.location = targetUrl.replace(/#.*$/, '') + '#' + t + c + '&' + message;
        }
      }

      l('XWM Send: Message sent.');
    },
    receive: function receive(callback, sourceOrigin, delay) {
      if (typeof callback !== 'function') {
        error('callback must be a function');
      }

      if (typeof sourceOrigin !== 'string') {
        error('sourceOrigin must be a string');
      }

      l('XWM Receive: Initialize receiver.');
      l('  callback: ' + (callback.name ? callback.name : 'Anonymous function'));
      l('  sourceOrigin: ' + sourceOrigin);
      var self = XWM;

      if (self.hasPostMessage) {
        // Since the browser supports window.postMessage, the callback will be
        // bound to the actual event associated with window.postMessage.
        if (callback) {
          if (self.rmCallback) {
            // Unbind previous callback
            if (window['addEventListener']) {
              window['removeEventListener']('message', self.rmCallback, false);
            } else {
              //IE8 doesn't support removeEventListener
              window['detachEvent']('onmessage', self.rmCallback);
            }
          } // Bind the callback. A reference to the callback is stored for ease of unbinding


          self.rmCallback = function (evt) {
            // Ensure the event is originating from the source domain, accounting
            // for subdomains (evt.origin must end with a dot and the sourceOrigin string).
            if (evt.origin !== sourceOrigin) {
              var subdomainTest = new RegExp('[\/|\.]' + sourceOrigin + '$', 'i');

              if (!subdomainTest.test(evt.origin)) {
                return false;
              }
            }

            l('XWM Receive: Message received!');
            l('  data: ' + evt.data);
            l('  sourceOrigin: ' + sourceOrigin);
            callback(evt);
          };
        }

        if (window['addEventListener']) {
          window['addEventListener']('message', self.rmCallback, false);
        } else {
          //IE8 doesn't support addEventListener
          window['attachEvent']('onmessage', self.rmCallback);
        }
      } else {
        // Since the browser sucks, a polling loop will be started, and the
        // callback will be called whenever the location.hash changes.
        l('XWM Receive: Starting poll...');

        if (self.intervalId) {
          clearInterval(self.intervalId);
          self.intervalId = null;
        }

        if (typeof delay === 'undefined') {
          delay = self.defaultDelay;
        }

        if (callback) {
          delay = delay !== undefined ? delay : 200;
          self.intervalId = setInterval(function () {
            var hash = document.location.hash;
            var re = /^#?\d+&/;

            if (hash !== self.lastHash && re.test(hash)) {
              self.lastHash = hash;
              var data = hash.replace(re, '');
              l('XWM Receive: Message received!');
              l('  data: ' + data);
              l('  sourceOrigin: ' + sourceOrigin);
              callback({
                data: data
              });
            }
          }, delay);
        }
      }
    }
  };
  /**
   * Helper functions to manage the "viewport" meta tag.
   * This allows us to dynamically control the display
   * and placement of the iFrame in a mobile context.
   */

  var MetaTagHelper = {
    savedViewportContent: '',
    set: function set() {
      l('Optimizing viewport meta tag for mobile'); // Save off the current viewport meta tag content

      this.savedViewportContent = this._getElement().getAttribute('content'); // Add mobile-optimized settings

      var contentPairs = this._explodePairs(this.savedViewportContent);

      contentPairs['width'] = 'device-width';
      contentPairs['maximum-scale'] = '1.0';
      contentPairs['user-scalable'] = 'no';

      this._getElement().setAttribute('content', this._joinPairs(contentPairs));
    },
    restore: function restore() {
      l('Restoring viewport meta tag');

      this._getElement().setAttribute('content', this.savedViewportContent);
    },
    _getElement: function _getElement() {
      var el = document.querySelector('meta[name=viewport]');

      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', 'viewport');
        el.setAttribute('content', 'initial-scale=1.0');
        document.head.appendChild(el);
      }

      return el;
    },
    _joinPairs: function _joinPairs(keyed) {
      var pairs = [];

      for (var key in keyed) {
        pairs.push(key + '=' + keyed[key]);
      }

      return pairs.join(', ');
    },
    _explodePairs: function _explodePairs(metaString) {
      var pairs = metaString.split(',');
      var obj = {};
      pairs.forEach(function (pair) {
        pair = pair.trim();
        var kv = pair.split('=');
        obj[kv[0]] = kv[1];
      });
      return obj;
    }
  };
  var HelloSign = {
    VERSION: __webpack_require__(/*! ../package.json */ "./package.json").version,
    DEFAULT_UX_VERSION: 1,
    IFRAME_WIDTH_RATIO: 0.8,
    DEFAULT_WIDTH: 900,
    DEFAULT_HEIGHT: 900,
    MIN_HEIGHT: 480,
    wrapper: null,
    iframe: null,
    overlay: null,
    cancelButton: null,
    clientId: null,
    isOldIE: /msie (8|7|6|5)/gi.test(userAgent),
    isFF: /firefox/gi.test(userAgent),
    isOpera: /opera/gi.test(userAgent),
    isMobile: /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent),
    baseUrl: 'https://www.hellosign.com',
    cdnBaseUrl: 'https://s3.amazonaws.com/cdn.hellofax.com',
    XWM: XWM,
    CULTURES: {
      EN_US: 'en_US',
      FR_FR: 'fr_FR',
      DE_DE: 'de_DE',
      SV_SE: 'sv_SE',
      ZH_CN: 'zh_CN',
      DA_DK: 'da_DK',
      NL_NL: 'nl_NL',
      ES_ES: 'es_ES',
      ES_MX: 'es_MX',
      PT_BR: 'pt_BR',
      PL_PL: 'pl_PL',
      init: function init() {
        this.supportedCultures = [this.EN_US, this.FR_FR, this.DE_DE, this.SV_SE, this.ZH_CN, this.DA_DK, this.NL_NL, this.ES_ES, this.ES_MX, this.PT_BR, this.PL_PL];
        return this;
      }
    }.init(),
    isDebugEnabled: window.isDebugEnabled,
    // PUBLIC EVENTS
    // ---------------------------
    // - error                          An error occurred in the iFrame
    // - signature_request_signed       The signature request was signed
    // - signature_request_canceled     The user closed the iFrame before completing
    // THESE EVENT CODES ARE ACTUALLY USED IN TWO PLACES
    // IF YOU CHANGE THEM MAKE SURE TO CHANGE THE OTHERS
    // IN HFACTIONS.PHP TO STAY CONSISTENT.
    EVENT_SIGNED: 'signature_request_signed',
    EVENT_DECLINED: 'signature_request_declined',
    EVENT_CANCELED: 'signature_request_canceled',
    EVENT_SENT: 'signature_request_sent',
    EVENT_TEMPLATE_CREATED: 'template_created',
    EVENT_ERROR: 'error',
    //  ----  PUBLIC METHODS  -----------------------------
    init: function init(appClientId) {
      this.clientId = appClientId;
    },
    open: function open(params) {
      var self = this; // PARAMETERS:
      // ----------------------
      // - url                      String. The url to open in the child frame
      // - redirectUrl              String. Where to go after the signature is completed
      // - allowCancel              Boolean. Whether a cancel button should be displayed (default = true)
      // - messageListener          Function. A listener for X-window messages coming from the child frame
      // - userCulture              HelloSign.CULTURE. One of the HelloSign.CULTURES.supportedCultures (default = HelloSign.CULTURES.EN_US)
      // - debug                    Boolean. When true, debugging statements will be written to the console (default = false)
      // - skipDomainVerification   Boolean. When true, domain verification step will be skipped if and only if the Signature Request was created with test_mode=1 (default = false)
      // - container                DOM element that will contain the iframe on the page (default = document.body)
      // - height                   Height of the iFrame (only applicable when a container is specified)
      // - hideHeader               Boolean. When true, the header will be hidden (default = false). This is only functional for customers with embedded branding enabled.
      // - uxVersion                Integer. The version of the embedded user experience to display to signers (1 = legacy, 2 = responsive). This option is only honored if your account has accessed the API prior to Nov 14, 2015.
      // - requester                String. The email of the person issuing a signature request. Required for allowing 'Me + Others' requests
      // - whiteLabelingOptions     Object. An associative array to be used to customize the app's signer page
      // - healthCheckTimeoutMs     Integer. The number of milliseconds to wait for a response from the iframe. If no response after that time the iframe will be closed. 15000 milliseconds is recommended.

      var redirectUrl = this.safeUrl(params['redirectUrl']);
      var messageListener = params['messageListener'];
      var frameUrl = this.safeUrl(params['url']);
      this.uxVersion = params['uxVersion'] || this.DEFAULT_UX_VERSION;
      this.isDefaultUX = this.uxVersion === this.DEFAULT_UX_VERSION;
      this.healthCheckTimeoutMs = params['healthCheckTimeoutMs'];

      if (this.uxVersion) {
        frameUrl += (frameUrl.indexOf('?') > 0 ? '&' : '?') + 'ux_version=' + this.uxVersion;
      }

      if (typeof params['debug'] !== 'undefined') {
        this.isDebugEnabled = params['debug'] === true || params['debug'] == 'true';
      }

      if (typeof params['skipDomainVerification'] !== 'undefined') {
        this.skipDomainVerification = params['skipDomainVerification'] === true || params['skipDomainVerification'] == 'true';
      }

      if (typeof params['hideHeader'] !== 'undefined') {
        this.hideHeader = params['hideHeader'] === true || params['hideHeader'] == 'true';
      }

      if (_typeof(params['whiteLabelingOptions']) === 'object') {
        this.whiteLabelingOptions = JSON.stringify(params['whiteLabelingOptions']);
        this.whiteLabelingOptions = this.whiteLabelingOptions.replace(/#/g, '');
      } else if (typeof params['whiteLabelingOptions'] !== 'undefined') {
        l("Invalid white labeling options supplied, option will be ignored: " + params['whiteLabelingOptions']);
      }

      this.isInPage = params['container'] !== undefined;
      this.container = params['container'] || document.body; // Validate parameters

      if (this.isInPage && params['height'] !== undefined && (isNaN(parseInt(params['height'], 10)) || params['height'] <= 0)) {
        throw new Error('Invalid iFrame height (' + params['height'] + ') it must be a valid positive number');
      }

      l('Opening HelloSign embedded iFrame with the following params:');
      l(params);

      if (!frameUrl) {
        throw new Error('No url specified');
      }

      var userCulture = typeof params['userCulture'] === 'undefined' ? this.CULTURES.EN_US : params['userCulture'];

      if (this.inArray(userCulture, this.CULTURES.supportedCultures) === -1) {
        throw new Error('Invalid userCulture specified: ' + userCulture);
      }

      frameUrl += frameUrl.indexOf('?') > 0 ? '&' : '?';

      if (redirectUrl) {
        frameUrl += 'redirect_url=' + encodeURIComponent(redirectUrl) + '&';
      }

      frameUrl += 'parent_url=' + encodeURIComponent(document.location.href.replace(/\?.*/, '')) + '&';
      frameUrl += this.skipDomainVerification === true ? 'skip_domain_verification=1&' : '';
      frameUrl += 'client_id=' + this.clientId + '&';
      frameUrl += typeof params['requester'] !== 'undefined' ? 'requester=' + encodeURIComponent(params['requester']) + '&' : '';
      frameUrl += 'user_culture=' + userCulture;

      if (this.isDebugEnabled) {
        frameUrl += '&debug=true';
      }

      if (this.hideHeader) {
        frameUrl += '&hideHeader=true';
      }

      if (this.whiteLabelingOptions) {
        frameUrl += '&white_labeling_options=' + encodeURI(this.whiteLabelingOptions);
      }

      frameUrl += '&js_version=' + this.VERSION;
      var origin = frameUrl.replace(/([^:]+:\/\/[^\/]+).*/, '$1');
      var windowDims = this.getWindowDimensions(params['height']);
      var styles = {
        'overlay': {
          'position': 'fixed',
          'top': '0px',
          'left': '0px',
          'bottom': '0px',
          'right': '0px',
          'z-index': 9997,
          'display': 'block',
          'background-color': '#222',
          'opacity': 0.4,
          '-khtml-opacity': 0.4,
          '-moz-opacity': 0.4,
          'filter': 'alpha(opacity=40)',
          '-ms-filter': 'progid:DXImageTransform.Microsoft.Alpha(Opacity=40)'
        },
        'wrapper': this.isInPage ? {} : {
          'position': 'absolute',
          'top': windowDims.top,
          'left': windowDims.left,
          'z-index': 9998
        },
        'iframe': this.isInPage ? {} : {
          'margin': '1px',
          'background-color': '#FFF',
          'z-index': 9998
        },
        'cancelButton': {
          'position': 'absolute',
          'top': '-13px',
          'right': '-13px',
          'width': '30px',
          'height': '30px',
          'background-image': 'url(' + this.cdnBaseUrl + '/css/fancybox/fancybox.png)',
          'background-position': '-40px 0px',
          'cursor': 'pointer',
          'z-index': 9999
        }
      };

      var resizeIFrame = function _resizeIFrame() {
        if (self.iframe) {
          var dims = {};

          if (self.isMobile) {
            dims = self.getMobileDimensions();
          } else {
            dims = self.getWindowDimensions();
          }

          self.wrapper.style['top'] = dims.top;
          self.wrapper.style['left'] = dims.left;
          self.wrapper.style['width'] = dims.widthString;
          self.iframe.style['height'] = dims.heightString;
          self.iframe.style['width'] = dims.widthString;
        }
      };

      if (this.uxVersion > 1) {
        if (this.isInPage) {
          // Adjust the iFrame style to fit the in-page container
          styles['wrapper']['width'] = '100%';
          styles['wrapper']['height'] = windowDims.heightString;
          styles['iframe']['width'] = '100%';
          styles['iframe']['height'] = windowDims.heightString;
          styles['iframe']['border'] = 'none';
          styles['iframe']['box-shadow'] = 'none';
          styles['cancelButton']['display'] = 'none'; // This is an iOS hack.  Apparently iOS ignores widths set
          // with a non-pixel value, which means iFrames get expanded
          // to the full width of their content.  Setting a pixel
          // value and then using `min-width` is the workaround for
          // this.
          // See:  http://stackoverflow.com/questions/23083462/how-to-get-an-iframe-to-be-responsive-in-ios-safari

          if (this.isMobile) {
            styles['iframe']['width'] = '1px';
            styles['iframe']['min-width'] = '100%';
          }
        } else if (this.isMobile) {
          var mobileDims = this.getMobileDimensions(); // Adjust the iFrame style to fit the whole screen

          styles['wrapper']['position'] = 'absolute';
          styles['wrapper']['top'] = '0';
          styles['wrapper']['left'] = '0';
          styles['wrapper']['width'] = mobileDims.widthString;
          styles['wrapper']['height'] = mobileDims.heightString;
          styles['iframe']['position'] = 'absolute';
          styles['iframe']['top'] = 0;
          styles['iframe']['left'] = 0;
          styles['iframe']['width'] = mobileDims.widthString;
          styles['iframe']['height'] = mobileDims.heightString;
          styles['iframe']['border'] = 'none';
          styles['iframe']['box-shadow'] = 'none';
          styles['cancelButton']['display'] = 'none';
        }
      } // Build overlay


      if (!this.isInPage) {
        if (!this.overlay) {
          this.overlay = document.createElement('div');
          this.overlay.setAttribute('id', 'hsEmbeddedOverlay');
          document.body.appendChild(this.overlay);
        }

        this.overlay.setAttribute('style', 'display: block;');
      } // Build the wrapper


      if (!this.wrapper) {
        this.wrapper = document.createElement('div');
        this.wrapper.setAttribute('id', 'hsEmbeddedWrapper'); // Hack.  We need this on mobile before we insert the DOM
        // element, otherwise the modal appears above the fold

        if (this.isMobile) {
          window.scrollTo(0, 0);
        }

        this.container.appendChild(this.wrapper);
      }

      if (!this.isInPage) {
        if (this.isMobile && this.isDefaultUX) {
          // If this is a mobile device, poll the window dimensions to see
          // if the zoom scale changes and resize the iFrame. This prevents
          // the user from zooming and getting into a state where they can't
          // submit the embedded request
          var zoomScale = document.body.clientWidth / window.innerWidth;

          var detectZoom = function _detectZoom() {
            var newZoomScale = document.body.clientWidth / window.innerWidth;

            if (zoomScale !== newZoomScale) {
              zoomScale = newZoomScale;
              resizeIFrame();
            }
          };

          window.onscroll = detectZoom;
        } else {
          // When the window is resized, also resize the iframe if necessary
          // NOTE: Only do this when the iFrame is displayed as a popup, it does not really make sense when it's in-page
          // Also used for new mobile ux
          window.onresize = resizeIFrame;
        }
      } // Build the iFrame


      if (!this.iframe) {
        this.iframe = document.createElement('iframe');
        this.iframe.setAttribute('id', 'hsEmbeddedFrame');
        this.wrapper.appendChild(this.iframe);
      }

      this.iframe.setAttribute('src', frameUrl);
      this.iframe.setAttribute('scrolling', 'no'); // This needs to stay as 'no' or else iPads, etc. get broken

      this.iframe.setAttribute('frameborder', '0');

      if (this.isDefaultUX) {
        this.iframe.setAttribute('width', this.DEFAULT_WIDTH);
      }

      this.iframe.setAttribute('height', windowDims.heightRaw); // TODO: Detecting 'embeddedSign' in the frameUrl is a hack. Clean
      // this up once the embedded close button has been implemented for
      // embedded requesting and templates.

      if (frameUrl.indexOf('embeddedSign') === -1 || params['uxVersion'] != null && params['uxVersion'] < 2) {
        if (!this.isInPage && (params['allowCancel'] === true || params['allowCancel'] === undefined) && !this.cancelButton) {
          this.cancelButton = document.createElement('a');
          this.cancelButton.setAttribute('id', 'hsEmbeddedCancel');
          this.cancelButton.setAttribute('href', 'javascript:;');

          this.cancelButton.onclick = function () {
            // Close iFrame
            HelloSign.close(); // Send 'cancel' message

            if (messageListener) {
              l('Reporting cancelation');
              messageListener({
                'event': HelloSign.EVENT_CANCELED
              });
            }
          };

          this.wrapper.appendChild(this.cancelButton);
        } else if (!params['allowCancel'] && this.cancelButton) {
          this.wrapper.removeChild(this.cancelButton);
        }
      } // Add inline styling


      for (var k in styles) {
        var el = this[k];

        if (el) {
          for (var i in styles[k]) {
            try {
              el.style[i] = styles[k][i];
            } catch (e) {
              // Ignore - exceptions get thrown when the given style is not supported
              l(e);
            }
          }
        }
      }

      if (this.cancelButton && (this.isFF || this.isOpera)) {
        // Firefox is weird with bg images
        var s = this.cancelButton.getAttribute('style');
        s += s ? '; ' : '';
        s += 'background-image: ' + styles.cancelButton['background-image'] + '; ';
        s += 'background-position: ' + styles.cancelButton['background-position'] + ';';
        this.cancelButton.setAttribute('style', s);
      }

      if (!this.isInPage && (!this.isMobile || this.isDefaultUX)) {
        // Run resizeIFrame to make sure it fits best from the beginning
        resizeIFrame();
      }

      if (this.isMobile && !this.isDefaultUX && window === window.top) {
        // Only set the meta tags for the top window
        MetaTagHelper.set();
      }

      if (this.isMobile && !this.isInPage) {
        this.fixIframe = debounce(function () {
          window.scrollTo(0, 0);
        }, 1000);
        this.fixIframe();
        window.addEventListener('scroll', this.fixIframe);
      } // Close the iframe if page fails to initialize within 15 seconds


      if (this.healthCheckTimeoutMs) {
        this._healthCheckTimeoutHandle = setTimeout(function () {
          var message = 'Signer page failed to initialize within ' + self.healthCheckTimeoutMs + ' milliseconds.';
          self.reportError(message, document.location.href);
          self.close();
        }, this.healthCheckTimeoutMs);
      } // Start listening for messages from the iFrame


      XWM.receive(function _parentWindowCallback(evt) {
        var source = evt.source || 'hsEmbeddedFrame';

        if (evt.data === 'initialize' && params['uxVersion'] > 1) {
          if (self.healthCheckTimeoutMs) clearTimeout(self._healthCheckTimeoutHandle); // remove container from payload to prevent circular reference error

          var payload = _extends({}, params);

          delete payload.container;
          XWM.send(JSON.stringify({
            type: 'embeddedConfig',
            payload: payload
          }), evt.origin, source);
        } else if (evt.data == 'close') {
          // Close iFrame
          HelloSign.close();

          if (messageListener && params['uxVersion'] > 1) {
            messageListener({
              'event': HelloSign.EVENT_CANCELED
            });
          }
        } else if (evt.data == 'decline') {
          // Close iFrame
          HelloSign.close();
          messageListener({
            'event': HelloSign.EVENT_DECLINED
          });
        } else if (evt.data == 'user-done') {
          // Close iFrame
          HelloSign.close();
        } else if (evt.data.indexOf('hello:') === 0) {
          // Hello message - Extract token and send it back
          var parts = evt.data.split(':');
          var token = parts[1];
          XWM.send('helloback:' + token, frameUrl, source);
        } else if (messageListener && evt.data) {
          // Forward to message callback
          var eventData = {};
          var p,
              pairs = evt.data.split('&'); // Recursive helper function to deserialize the event data.

          var deserializeEventData = function deserializeEventData(str) {
            var obj = str;

            try {
              // Safely parse the string
              obj = JSON.parse(str);

              if (_typeof(obj) === 'object') {
                for (var key in obj) {
                  obj[key] = parseJson(obj[key]);
                }
              }
            } catch (e) {
              /* ignore */
            }

            return obj;
          };

          for (var i = 0; i < pairs.length; i++) {
            p = pairs[i].split('=');

            if (p.length === 2) {
              eventData[p[0]] = deserializeEventData(decodeURIComponent(p[1]));
            }
          }

          messageListener(eventData);
        }
      }, origin);
    },
    close: function close() {
      // Reset viewport settings
      if (this.isMobile && !this.isDefaultUX && window === window.top) {
        MetaTagHelper.restore();
      }

      l('Closing HelloSign embedded iFrame'); // Close the child iframe from the parent window

      if (this.iframe) {
        var self = this;

        if (this.cancelButton) {
          this.wrapper.removeChild(this.cancelButton);
          this.cancelButton = null;
        }

        this._fadeOutIFrame();
      }

      if (this.isMobile) {
        window.removeEventListener('scroll', this.fixIframe);
      }
    },
    //  ----  PRIVATE METHODS  ----------------------------
    _fadeOutIFrame: function _fadeOutIFrame(currentOpacity) {
      var self = this;

      if (self.iframe) {
        if (!currentOpacity) {
          currentOpacity = 1.0;
        } else {
          currentOpacity -= 0.1;
        }

        self.iframe.style.opacity = currentOpacity;
        self.iframe.style.filter = 'alpha(opacity=' + parseInt(currentOpacity * 100, 10) + ')';

        if (currentOpacity <= 0.0) {
          self.iframe.style.opacity = 0;
          self.iframe.style.filter = 'alpha(opacity=0)';
          self.iframe.style.display = 'none';
          clearTimeout(animationTimer);

          if (self.overlay) {
            self.container.removeChild(self.overlay);
          }

          self.container.removeChild(self.wrapper);
          self.wrapper.removeChild(self.iframe);
          self.overlay = null;
          self.iframe = null;
          self.wrapper = null;
          return false;
        }

        var animationTimer = setTimeout(function (currentOpacity) {
          return function () {
            self._fadeOutIFrame(currentOpacity);
          };
        }(currentOpacity), 10);
      }
    },
    reportError: function reportError(errorMessage, parentUrl) {
      XWM.send({
        'event': HelloSign.EVENT_ERROR,
        'description': errorMessage
      }, parentUrl);
    },
    ensureParentDomain: function ensureParentDomain(domainName, parentUrl, token, skipDomainVerification, callback) {
      // domainName:  Domain to match against the parent window location
      // parentUrl:   Url of the parent window to check (provided to us but not reliable)
      // callback:    Method to call with the result, it should take only one boolean parameter.
      if (window.top == window) {
        // Not in an iFrame, no need to go further
        callback(true);
        return;
      }

      if (typeof token !== 'string') {
        error('Token not supplied by HelloSign. Please contact support.');
        return;
      }

      if (typeof callback !== 'function') {
        error('Callback not supplied by HelloSign. Please contact support.');
        return;
      }

      if (skipDomainVerification === true) {
        var warningMsg = 'Domain verification has been skipped. Before requesting approval for your app, please be sure to test domain verification by setting skipDomainVerification to false.';
        l(warningMsg);
        alert(warningMsg);
        callback(true);
      } else {
        // Starts waiting for the hello back message
        XWM.receive(function _ensureParentDomainCallback(evt) {
          if (evt.data.indexOf('helloback:') === 0) {
            var parts = evt.data.split(':');
            var valid = parts[1] == token;
            callback(valid);
          }
        }, domainName);
      } // Send hello message


      XWM.send('hello:' + token, parentUrl);
    },
    getWindowDimensions: function getWindowDimensions(customHeight) {
      var scrollX = getScrollX();
      var scrollY = getScrollY();
      var windowWidth, windowHeight;

      if (this.isOldIE) {
        windowWidth = document.body.clientWidth;
        windowHeight = document.body.clientHeight;
      } else {
        windowWidth = window.innerWidth;
        windowHeight = window.innerHeight;
      }

      var height = this.isInPage && customHeight ? customHeight : Math.max(this.MIN_HEIGHT, windowHeight - 60);
      var width = this.uxVersion > 1 ? Math.min(this.DEFAULT_WIDTH, windowWidth * this.IFRAME_WIDTH_RATIO) : this.DEFAULT_WIDTH;
      return {
        'widthString': width + 'px',
        'heightString': height + 'px',
        'heightRaw': height,
        'scrollX': scrollX,
        'scrollY': scrollY,
        'top': Math.max(0, scrollY + parseInt((windowHeight - height) / 2, 10)) + 'px',
        'left': Math.max(0, parseInt((windowWidth - this.DEFAULT_WIDTH) / 2, 10)) + 'px'
      };
    },
    getMobileDimensions: function getMobileDimensions() {
      var dims;
      var screenWidth = screen.width;
      var screenHeight = screen.height;
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      var isPortrait = windowHeight > windowWidth;

      if (isPortrait) {
        dims = {
          'widthString': this.isDefaultUX ? '100vw' : screenWidth + 'px',
          'heightString': this.isDefaultUX ? '100vh' : '100%' // 100vh needed for old signer page, but cuts off some newer UX elements

        };
      } else {
        // Landscape
        dims = {
          'widthString': windowWidth + 'px',
          'heightString': this.isDefaultUX ? '100vh' : '100%'
        };
      } // Always fill screen on mobile


      dims.top = '0';
      dims.left = '0';
      return dims;
    },
    inArray: function inArray(v, array) {
      if (this.hasJQuery) {
        return $.inArray(v, array);
      } else if (array) {
        for (var i = 0; i < array.length; i++) {
          if (array[i] == v) {
            return i;
          }
        }
      }

      return -1;
    },
    safeUrl: function safeUrl(url) {
      if (url) {
        try {
          // Security: remove script tags from URLs before processing
          url = url.replace(/</g, "&lt;");
          url = url.replace(/>/g, "&gt;"); // HTML-Decode the given url if necessary, by rendering to the page

          var el = document.createElement('div');
          el.innerHTML = url;
          var decodedUrl = el.innerText; // Fall back to just replacing '&amp;' in case of failure

          if (!decodedUrl) {
            url = url.replace(/\&amp\;/g, '&');
          } else {
            url = decodedUrl;
          }
        } catch (e) {
          l('Could not decode url: ' + e);
        }
      }

      return url;
    }
  };
  /**
   * Wrapper that will ensure an error message is displayed, either in console.log
   * or as a browser alert.
   * @param message String error message
   */

  function error(message) {
    if (typeof message !== 'undefined') {
      if (window.console && console.log) {
        console.log(message);
      } else {
        alert(message);
      }
    }
  }
  /**
   * Custom wrapper that conditionally logs messages to console.log.
   * @param messageObj String or Object to log
   */


  function l(messageObj) {
    if (HelloSign.isDebugEnabled && typeof messageObj !== 'undefined' && window.console && console.log) {
      console.log(messageObj);
    }
  }
  /**
   *  Getter functions for determining scroll position that work on all
   *  browsers.
   */


  function getScrollX() {
    return _supportPageOffset() ? window.pageXOffset : _isCSS1Compat() ? document.documentElement.scrollLeft : document.body.scrollLeft;
  }

  function getScrollY() {
    return _supportPageOffset() ? window.pageYOffset : _isCSS1Compat() ? document.documentElement.scrollTop : document.body.scrollTop;
  }

  function _isCSS1Compat() {
    return (document.compatMode || '') === 'CSS1Compat';
  }

  function _supportPageOffset() {
    return window.pageXOffset !== undefined;
  } // Also add HelloSign as global variable for AMD implementations.
  // This will prevent older integrations from breaking.


  if (true) {
    window.HelloSign = HelloSign;
  } // Export the HS object


  module.exports = HelloSign;
})();

/***/ })

/******/ });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "NBsw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:variable-name */
exports.MouseEvent = (window || global).MouseEvent;
exports.KeyboardEvent = (window || global).KeyboardEvent;
exports.Event = (window || global).Event;
//# sourceMappingURL=events.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "NQUu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("Z9jN"));
__export(__webpack_require__("QIkZ"));
__export(__webpack_require__("icKY"));
__export(__webpack_require__("JMlz"));
__export(__webpack_require__("y7Yj"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "Nkju":
/***/ (function(module, exports) {

module.exports = function atoa (a, n) { return Array.prototype.slice.call(a, n); }


/***/ }),

/***/ "ORct":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SelectionType;
(function (SelectionType) {
    SelectionType["single"] = "single";
    SelectionType["multi"] = "multi";
    SelectionType["multiClick"] = "multiClick";
    SelectionType["cell"] = "cell";
    SelectionType["checkbox"] = "checkbox";
})(SelectionType = exports.SelectionType || (exports.SelectionType = {}));
//# sourceMappingURL=selection.type.js.map

/***/ }),

/***/ "OjYj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
if (typeof document !== 'undefined' && !document.elementsFromPoint) {
    document.elementsFromPoint = elementsFromPoint;
}
/*tslint:disable*/
/**
 * Polyfill for `elementsFromPoint`
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/elementsFromPoint
 * https://gist.github.com/iddan/54d5d9e58311b0495a91bf06de661380
 * https://gist.github.com/oslego/7265412
 */
function elementsFromPoint(x, y) {
    var elements = [];
    var previousPointerEvents = [];
    var current; // TODO: window.getComputedStyle should be used with inferred type (Element)
    var i;
    var d;
    //if (document === undefined) return elements;
    // get all elements via elementFromPoint, and remove them from hit-testing in order
    while ((current = document.elementFromPoint(x, y)) && elements.indexOf(current) === -1 && current != null) {
        // push the element and its current style
        elements.push(current);
        previousPointerEvents.push({
            value: current.style.getPropertyValue('pointer-events'),
            priority: current.style.getPropertyPriority('pointer-events')
        });
        // add "pointer-events: none", to get to the underlying element
        current.style.setProperty('pointer-events', 'none', 'important');
    }
    // restore the previous pointer-events values
    for (i = previousPointerEvents.length; d = previousPointerEvents[--i];) {
        elements[i].style.setProperty('pointer-events', d.value ? d.value : '', d.priority);
    }
    // return our results
    return elements;
}
exports.elementsFromPoint = elementsFromPoint;
/*tslint:enable*/
//# sourceMappingURL=elm-from-point.js.map

/***/ }),

/***/ "PGpm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExtraDataService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseService__ = __webpack_require__("IhmT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__("Fzro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_extraData_extraDataSearchRequest__ = __webpack_require__("BRKd");




/**
 * Created by alex.y on 9/18/2017.
 */
var ExtraDataService = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ExtraDataService, _super);
    function ExtraDataService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExtraDataService.prototype.getByRefIdandRefType = function (refId, refType) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
                return [2 /*return*/, this.search(new __WEBPACK_IMPORTED_MODULE_3__objects_extraData_extraDataSearchRequest__["a" /* ExtraDataSearchRequest */]({
                        SearchType: __WEBPACK_IMPORTED_MODULE_3__objects_extraData_extraDataSearchRequest__["b" /* ExtraDataSearchType */].ByRefIdAndRefType,
                        ReferenceId: refId,
                        ReferenceType: refType
                    }))];
            });
        });
    };
    ExtraDataService.prototype.search = function (request) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "extradata/search",
            body: request
        }));
    };
    ExtraDataService.prototype.modify = function (extraData) {
        return this.put(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "extradata",
            body: extraData
        }));
    };
    return ExtraDataService;
}(__WEBPACK_IMPORTED_MODULE_1__baseService__["a" /* BaseApi */]));

//# sourceMappingURL=extraDataService.js.map

/***/ }),

/***/ "PL+a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./app/objects/products/product.ts + 1 modules
var product = __webpack_require__("aZ3i");

// EXTERNAL MODULE: ./app/objects/management/locationManagement/Country.ts
var Country = __webpack_require__("eZFs");

// EXTERNAL MODULE: ./app/objects/currencyExchange/canadianCurrencyCode.ts
var canadianCurrencyCode = __webpack_require__("3Ddi");

// CONCATENATED MODULE: ./app/objects/orders/orderTotal.ts
/**
 * Created by alex.y on 8/8/2017.
 */
var OrderTotal = /** @class */ (function () {
    function OrderTotal() {
        this.Taxes = [];
    }
    return OrderTotal;
}());

//# sourceMappingURL=orderTotal.js.map
// EXTERNAL MODULE: ./app/objects/currencyExchange/currencyEnum.ts
var currencyEnum = __webpack_require__("7P1x");

// CONCATENATED MODULE: ./app/objects/orders/orderItem.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return orderItem_OrderItem; });
/* unused harmony export GreenLevyType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemTax; });





/**
 * Created by alex.y on 8/8/2017.
 */
var orderItem_OrderItem = /** @class */ (function () {
    // public GreenLevy: GreenLevyType;
    function OrderItem(obj) {
        this.Currency = currencyEnum["a" /* CurrencyEnum */].FXUSDCAD;
        this.Product = new product["a" /* Product */]();
        this.DutyList = [];
        this.Manufacturer = new Country["a" /* Country */]();
        this.CanadianCurrencyCode = new canadianCurrencyCode["a" /* CanadianCurrencyCode */]();
        this.Total = new OrderTotal();
        this.IsPurchased = false;
        this.IsAgentEditCustomDuty = false;
        this.Taxes = [];
        Object.assign(this, obj);
    }
    return OrderItem;
}());

var GreenLevyType;
(function (GreenLevyType) {
    GreenLevyType[GreenLevyType["from0to13"] = 0] = "from0to13";
    GreenLevyType[GreenLevyType["from13to14"] = 1] = "from13to14";
    GreenLevyType[GreenLevyType["from14to15"] = 2] = "from14to15";
    GreenLevyType[GreenLevyType["from15to16"] = 3] = "from15to16";
    GreenLevyType[GreenLevyType["more16"] = 4] = "more16";
})(GreenLevyType || (GreenLevyType = {}));
var ItemTax = /** @class */ (function () {
    function ItemTax(obj) {
        Object.assign(this, obj);
    }
    return ItemTax;
}());

//# sourceMappingURL=orderItem.js.map

/***/ }),

/***/ "Pb0k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormHelper; });
/**
 * Created by alex.y on 9/15/2017.
 */
var FormHelper = /** @class */ (function () {
    function FormHelper() {
    }
    /**
     * mark all form controlls as dirty
     * and validate form
     * @param form
     */
    FormHelper.markControllsAsDirty = function (form) {
        Object.keys(form.controls).forEach(function (key) {
            form.controls[key].markAsDirty();
            form.controls[key].markAsTouched();
            form.controls[key].updateValueAndValidity();
        });
    };
    FormHelper.isFromValid = function (form) {
        this.markControllsAsDirty(form);
        //  form.updateValueAndValidity();
        return form.valid;
    };
    FormHelper.scrollToTopCalcV2 = function () {
        var el = document.querySelector(".public-calc");
        if (el) {
            el.scrollTop = 0;
        }
    };
    FormHelper.scrollToCalcV2TabOnMobile = function () {
        if (window.orientation != undefined) {
            setTimeout(function () {
                if (window.navigator.platform == "iPhone") {
                    document.body.scrollTop = 0;
                    document.body.scrollIntoView(true);
                }
                else {
                    var el = document.querySelector('.public-calc');
                    el.scrollTop = 0;
                    el.scrollIntoView(true);
                }
            }, 100);
        }
    };
    return FormHelper;
}());

//# sourceMappingURL=formHelper.js.map

/***/ }),

/***/ "PdJh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomerModalComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_customers_customer__ = __webpack_require__("svBX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_customerService__ = __webpack_require__("Tq/D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_blurUtil__ = __webpack_require__("vWtP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_router__ = __webpack_require__("5oXY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_perfect_scrollbar__ = __webpack_require__("Fiov");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__objects_requests_customerModifyRequest__ = __webpack_require__("4/R3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ng2_toastr__ = __webpack_require__("xssS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ng2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_ng2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_extraDataService__ = __webpack_require__("PGpm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__objects_extraData_extraDataSearchRequest__ = __webpack_require__("BRKd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__objects_extraData_extraData__ = __webpack_require__("KGeA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__extraData_baseExtraData__ = __webpack_require__("ntOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_management_order_orderViewType__ = __webpack_require__("9ev/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_helpers_userViewHelper__ = __webpack_require__("AIey");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_userViewService__ = __webpack_require__("e4LZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__objects_components_component__ = __webpack_require__("+TKD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__objects_email_emailTemplateType__ = __webpack_require__("gE7E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_emailService__ = __webpack_require__("z/46");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services_paymentService__ = __webpack_require__("vw9J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__objects_email_PaymentEmailRequest__ = __webpack_require__("n/KB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_managers_storageManager__ = __webpack_require__("ivjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__services_configService__ = __webpack_require__("cfSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_rxjs_BehaviorSubject__ = __webpack_require__("TfWX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_rxjs_observable_fromPromise__ = __webpack_require__("ioK+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_rxjs_operators__ = __webpack_require__("W+Sr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_rxjs_operators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_rxjs_operators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__objects_payment_paymentCompany__ = __webpack_require__("41dP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__objects_customers_stripe_payment_data__ = __webpack_require__("clEe");




























/**
 * Created by alex.y on 9/7/2017.
 */
var CustomerModalComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CustomerModalComponent, _super);
    function CustomerModalComponent(customerService, router, toastr, cdr, extraDataService, userViewService, emailService, storageManager, paymentService, configService) {
        var _this = _super.call(this, extraDataService) || this;
        _this.customerService = customerService;
        _this.router = router;
        _this.toastr = toastr;
        _this.cdr = cdr;
        _this.extraDataService = extraDataService;
        _this.userViewService = userViewService;
        _this.emailService = emailService;
        _this.storageManager = storageManager;
        _this.paymentService = paymentService;
        _this.configService = configService;
        _this.originalCustomer = new __WEBPACK_IMPORTED_MODULE_2__objects_customers_customer__["a" /* Customer */]();
        _this.currentCustomer = new __WEBPACK_IMPORTED_MODULE_2__objects_customers_customer__["a" /* Customer */]();
        _this.string = String;
        _this.number = Number;
        _this.processing = false;
        _this.changeCustomersForAll = false;
        _this.customerSaved = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        _this.top = 10;
        _this.skip = 3;
        _this.hasNextOrder = true;
        _this.isOrderLoading = false;
        _this.extraData = new __WEBPACK_IMPORTED_MODULE_11__objects_extraData_extraData__["a" /* ExtraData */]();
        _this.tableColumns = [];
        _this.cardRequestLoader = false;
        _this.sentText = false;
        _this.updateRequestSent = false;
        _this.showProcessPaymentBtn = false;
        _this.showUpdatePaymentDataBtn = false;
        _this.showSendCcRequestExistingCustomerBtn = false;
        _this.paymentSeccess = false;
        _this.showbigModal = false;
        _this.paymentData = { FileNumber: "", Amount: "", CurrencyCode: "" };
        _this.showLoader = false;
        _this.CcError = false;
        _this.cwOrganization = '';
        _this.select2CwOrganizationData = null;
        _this.paymentCompany = __WEBPACK_IMPORTED_MODULE_26__objects_payment_paymentCompany__["a" /* PaymentCompany */].None;
        // TEMP FOR TEST BY TASK https://jira.ak-tech.org/browse/BB-2852
        _this.isDisabledSendGetStartedEmailButton$ = new __WEBPACK_IMPORTED_MODULE_23_rxjs_BehaviorSubject__["BehaviorSubject"](false);
        _this.customerPaymentLink$ = new __WEBPACK_IMPORTED_MODULE_23_rxjs_BehaviorSubject__["BehaviorSubject"]('');
        _this.isCopied$ = new __WEBPACK_IMPORTED_MODULE_23_rxjs_BehaviorSubject__["BehaviorSubject"](false);
        return _this;
    }
    CustomerModalComponent.prototype.changeCCode = function () {
        if (this.CurrencyCode == undefined) {
            this.CcError = true;
        }
        else {
            this.CcError = false;
        }
        this.cdr.detectChanges();
    };
    CustomerModalComponent.prototype.processPayment = function (isValid) {
        var _this = this;
        this.changeCCode();
        this.showLoader = true;
        if (this.CcError) {
            console.log("CcError");
            this.showLoader = false;
            return;
        }
        if (!isValid) {
            console.log("valid");
            this.showLoader = false;
            return;
        }
        var am = this.replase(this.amount.nativeElement.value);
        this.paymentData.Amount = am;
        var fn = this.paymentData.FileNumber.trim();
        this.paymentService.pay(fn, am, this.CurrencyCode, this.currentCustomer.Id, this.currentUser.Id, null, this.currentCustomer.StripePaymentData != null ? this.currentCustomer.StripePaymentData.PaymentCompany : __WEBPACK_IMPORTED_MODULE_26__objects_payment_paymentCompany__["a" /* PaymentCompany */].CargoWise).then(function (result) {
            _this.showbigModal = true;
            _this.paymentSeccess = true;
        }, function (reject) {
            _this.showbigModal = true;
            _this.paymentErrorMsg = reject.Data.Message;
        });
    };
    CustomerModalComponent.prototype.replase = function (str) {
        return str.replace(/\,/g, "").replace("$", "").trim();
    };
    CustomerModalComponent.prototype.show = function (customerId) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var customer, tempExtraData;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!customerId) return [3 /*break*/, 3];
                        this.isEditMode = true;
                        this.title = 'Edit Customer';
                        return [4 /*yield*/, this.customerService.getCustomerById(customerId)];
                    case 1:
                        customer = (_a.sent()).Data;
                        this.originalCustomer = customer;
                        this.currentCustomer = JSON.parse(JSON.stringify(customer));
                        this.showProcessPaymentBtn = this.currentCustomer.StripePaymentData != null;
                        this.showUpdatePaymentDataBtn = this.currentCustomer.StripePaymentData != null;
                        this.showSendCcRequestExistingCustomerBtn = this.currentCustomer.StripePaymentData == null;
                        this.cargoWise = this.currentCustomer.StripePaymentData == null || this.currentCustomer.StripePaymentData.PaymentCompany == __WEBPACK_IMPORTED_MODULE_26__objects_payment_paymentCompany__["a" /* PaymentCompany */].CargoWise || this.currentCustomer.StripePaymentData.PaymentCompany == __WEBPACK_IMPORTED_MODULE_26__objects_payment_paymentCompany__["a" /* PaymentCompany */].None;
                        this.nexGen = this.currentCustomer.StripePaymentData && this.currentCustomer.StripePaymentData.PaymentCompany == __WEBPACK_IMPORTED_MODULE_26__objects_payment_paymentCompany__["a" /* PaymentCompany */].NexGen;
                        this.paymentCompany = this.cargoWise ? __WEBPACK_IMPORTED_MODULE_26__objects_payment_paymentCompany__["a" /* PaymentCompany */].CargoWise : __WEBPACK_IMPORTED_MODULE_26__objects_payment_paymentCompany__["a" /* PaymentCompany */].NexGen;
                        this.newCustomer = true;
                        this.customerModal.show();
                        this.hasNextOrder = true;
                        this.skip = customer.Orders.length;
                        return [4 /*yield*/, this.getExtraData(customerId.toString(), __WEBPACK_IMPORTED_MODULE_10__objects_extraData_extraDataSearchRequest__["c" /* ReferenceType */].Order)];
                    case 2:
                        tempExtraData = _a.sent();
                        if (tempExtraData)
                            this.extraData = tempExtraData;
                        else {
                            this.extraData = new __WEBPACK_IMPORTED_MODULE_11__objects_extraData_extraData__["a" /* ExtraData */]();
                            this.extraData.ReferenceId = customerId.toString();
                            this.extraData.ReferenceType = 0;
                            this.extraData.Name = "marketing text";
                        }
                        __WEBPACK_IMPORTED_MODULE_4__common_utils_blurUtil__["a" /* BlurUtil */].blurMenu(this.idToBlur);
                        this.tableColumns = __WEBPACK_IMPORTED_MODULE_14__common_helpers_userViewHelper__["a" /* UserViewHelper */].getColumns(this.userViewService, __WEBPACK_IMPORTED_MODULE_16__objects_components_component__["a" /* Component */].OrderManagement, __WEBPACK_IMPORTED_MODULE_13__objects_management_order_orderViewType__["a" /* OrderViewType */].Tile);
                        this.updatePaymentLink();
                        return [3 /*break*/, 4];
                    case 3:
                        this.isEditMode = false;
                        this.title = 'Add Customer';
                        this.customerModal.show();
                        __WEBPACK_IMPORTED_MODULE_4__common_utils_blurUtil__["a" /* BlurUtil */].blurMenu(this.idToBlur);
                        this.tableColumns = __WEBPACK_IMPORTED_MODULE_14__common_helpers_userViewHelper__["a" /* UserViewHelper */].getColumns(this.userViewService, __WEBPACK_IMPORTED_MODULE_16__objects_components_component__["a" /* Component */].OrderManagement, __WEBPACK_IMPORTED_MODULE_13__objects_management_order_orderViewType__["a" /* OrderViewType */].Tile);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CustomerModalComponent.prototype.showProcessPaymentModal = function () {
        this.paymentProcessModal.show();
    };
    CustomerModalComponent.prototype.updatePaymentData = function () {
        var _this = this;
        var request = new __WEBPACK_IMPORTED_MODULE_20__objects_email_PaymentEmailRequest__["a" /* PaymentEmailRequest */]({
            EmailType: __WEBPACK_IMPORTED_MODULE_17__objects_email_emailTemplateType__["a" /* EmailTemplateType */].UpdatePaymentData,
            OrderId: "",
            CustomerId: this.currentCustomer.Id,
            AgentUserId: this.currentUser.Id,
            PaymentCompany: this.currentCustomer.StripePaymentData != null ? this.currentCustomer.StripePaymentData.PaymentCompany : __WEBPACK_IMPORTED_MODULE_26__objects_payment_paymentCompany__["a" /* PaymentCompany */].CargoWise
        });
        this.emailService.sendPaymentEmail(request).then(function (resp) {
            if (resp.Success) {
                _this.updateRequestSent = true;
            }
        });
    };
    CustomerModalComponent.prototype.changePaymentType = function (type) {
        if (this.currentCustomer.StripePaymentData == null)
            this.currentCustomer.StripePaymentData = new __WEBPACK_IMPORTED_MODULE_27__objects_customers_stripe_payment_data__["a" /* StripePaymentData */]();
        if (type == 1) {
            this.nexGen = false;
            this.currentCustomer.StripePaymentData.PaymentCompany = __WEBPACK_IMPORTED_MODULE_26__objects_payment_paymentCompany__["a" /* PaymentCompany */].CargoWise;
            this.paymentCompany = __WEBPACK_IMPORTED_MODULE_26__objects_payment_paymentCompany__["a" /* PaymentCompany */].CargoWise;
        }
        else if (type == 2) {
            this.cargoWise = false;
            this.currentCustomer.StripePaymentData.PaymentCompany = __WEBPACK_IMPORTED_MODULE_26__objects_payment_paymentCompany__["a" /* PaymentCompany */].NexGen;
            this.paymentCompany = __WEBPACK_IMPORTED_MODULE_26__objects_payment_paymentCompany__["a" /* PaymentCompany */].NexGen;
        }
        this.updatePaymentLink();
    };
    CustomerModalComponent.prototype.changeCustomerType = function (type) {
        var _this = this;
        if (type == 1)
            this.existingCustomer = false;
        if (type == 2)
            this.newCustomer = false;
        if (this.existingCustomer) {
            setTimeout(function () {
                _this.initCwOrganizationCodeSelect2();
            }, 200);
        }
        this.updatePaymentLink();
    };
    CustomerModalComponent.prototype.sendToNewCustomer = function () {
        //this.cardRequestLoader = true;
        var _this = this;
        var request = new __WEBPACK_IMPORTED_MODULE_20__objects_email_PaymentEmailRequest__["a" /* PaymentEmailRequest */]({
            EmailType: __WEBPACK_IMPORTED_MODULE_17__objects_email_emailTemplateType__["a" /* EmailTemplateType */].CreditCardRequest,
            OrderId: "",
            CustomerId: this.currentCustomer.Id,
            AgentUserId: this.currentUser.Id,
            PaymentCompany: this.paymentCompany
        });
        this.emailService.sendPaymentEmail(request).then(function (resp) {
            if (resp.Success) {
                _this.cardRequestLoader = false;
                _this.sentText = true;
            }
        });
    };
    CustomerModalComponent.prototype.sendToExistingCustomer = function () {
        var _this = this;
        var request = new __WEBPACK_IMPORTED_MODULE_20__objects_email_PaymentEmailRequest__["a" /* PaymentEmailRequest */]({
            EmailType: __WEBPACK_IMPORTED_MODULE_17__objects_email_emailTemplateType__["a" /* EmailTemplateType */].CreditCardExistingCustomerRequest,
            OrderId: "",
            CustomerId: this.currentCustomer.Id,
            AgentUserId: this.currentUser.Id,
            CargoWiseOrganizationCode: this.cwOrganization,
            PaymentCompany: this.paymentCompany
        });
        this.emailService.sendPaymentEmail(request).then(function (resp) {
            if (resp.Success) {
                _this.cardRequestLoader = false;
                _this.sentText = true;
                $('#cwOrganizationSelect').html("");
            }
        });
    };
    CustomerModalComponent.prototype.initCwOrganizationCodeSelect2 = function () {
        var self = this;
        var selectElement = $('#cwOrganizationSelect');
        var cw1ConnectorUrl = this.configService.config.CW1ConnectorUrl;
        var cw1ConnectorKey = this.configService.config.CW1ConnectorKey;
        selectElement.select2({
            width: '100%',
            data: [],
            allowClear: true,
            selectOnClose: true,
            placeholder: 'Select CW1 organization',
            ajax: {
                url: cw1ConnectorUrl + "?key=" + cw1ConnectorKey,
                dataType: "json",
                delay: 500,
                data: function (params) {
                    return {
                        org_name: params.term
                    };
                },
                processResults: function (data, params) {
                    var results = data.Organizations.map(function (x) { return ({
                        id: x.OrganizationCode,
                        text: x.OrganizationName + " (" + x.OrganizationCode + ")",
                        Item: x
                    }); });
                    return {
                        results: results
                    };
                },
            },
            minimumInputLength: 3
        }).on('select2:select', function (e) {
            var selectedData = $(this).select2('data');
            self.cwOrganization = selectedData[0].id;
            self.updatePaymentLink();
            self.select2CwOrganizationData.trigger("select", { data: { item: selectedData[0].Item, text: selectedData[0].text, id: selectedData[0].id } });
        }).on('select2:unselect', function (e) {
            self.cwOrganization = '';
            self.updatePaymentLink();
        }).on('select2:open', function (params) {
            var select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });
        this.select2CwOrganizationData = selectElement.data("select2");
    };
    CustomerModalComponent.prototype.ngOnInit = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var _a;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        __WEBPACK_IMPORTED_MODULE_6_perfect_scrollbar__["initialize"](this.customerModalRef.nativeElement);
                        _a = this;
                        return [4 /*yield*/, this.storageManager.getCurrentUser()];
                    case 1:
                        _a.currentUser = _b.sent();
                        this.updatePaymentLink();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerModalComponent.prototype.updatePaymentLink = function () {
        var templateType = this.existingCustomer ? __WEBPACK_IMPORTED_MODULE_17__objects_email_emailTemplateType__["a" /* EmailTemplateType */].CreditCardExistingCustomerRequest : __WEBPACK_IMPORTED_MODULE_17__objects_email_emailTemplateType__["a" /* EmailTemplateType */].CreditCardRequest;
        var link = location.origin + "/orderpayment/?email=" + this.currentCustomer.Email + "&c=" + this.currentCustomer.Id + "&emailtype=" + templateType + "&an=" + this.currentUser.Id + "&pp=0&paycom=" + this.paymentCompany;
        if (!String.isNullOrEmpty(this.cwOrganization)) {
            link += "&cwoc=" + this.cwOrganization;
        }
        this.customerPaymentLink$.next(link);
    };
    CustomerModalComponent.prototype.onPaymentProcessModalHidden = function () {
        this.paymentData.FileNumber = '';
        this.paymentData.Amount = '';
        this.paymentErrorMsg = '';
        this.showbigModal = false;
        this.paymentSeccess = false;
        this.showLoader = false;
    };
    CustomerModalComponent.prototype.onModalHidden = function () {
        this.customerForm.reset();
        __WEBPACK_IMPORTED_MODULE_4__common_utils_blurUtil__["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
    };
    CustomerModalComponent.prototype.sendCreditCardRequest = function () {
        if (this.newCustomer)
            this.sendToNewCustomer();
        else if (this.existingCustomer) {
            this.sendToExistingCustomer();
        }
    };
    CustomerModalComponent.prototype.onMousewheel = function () {
        var delta = document.getElementById("myModal").clientHeight - document.getElementById("myModal").scrollHeight == 0;
        if (delta && !this.isOrderLoading)
            this.loadNextOrders();
    };
    CustomerModalComponent.prototype.onArrowDown = function (event) {
        if (this.isOrderLoading)
            return;
        if (event.keyCode == 38 || event.keyCode == 40)
            this.loadNextOrders();
    };
    CustomerModalComponent.prototype.handleScroll = function () {
        this.loadNextOrders();
    };
    CustomerModalComponent.prototype.viewAllOrders = function () {
        __WEBPACK_IMPORTED_MODULE_4__common_utils_blurUtil__["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
        this.router.navigate(["management/order", {
                customeremail: this.currentCustomer.Email,
                customerid: this.currentCustomer.Id
            }]);
    };
    CustomerModalComponent.prototype.loadNextOrders = function () {
        var _this = this;
        if (!this.hasNextOrder)
            return;
        this.isOrderLoading = true;
        this.customerService.getByCustomerId(this.currentCustomer.Id, this.skip, this.top).then(function (result) {
            _this.isOrderLoading = false;
            if (!result || !result.Data)
                return;
            if (result.Data.Items.length == 0)
                _this.hasNextOrder = false;
            _this.skip += _this.top;
            result.Data.Items.sort(function (x, y) {
                return new Date(x.Created) > new Date(y.Created) ? -1 : 1;
            });
            for (var _i = 0, _a = result.Data.Items; _i < _a.length; _i++) {
                var o = _a[_i];
                _this.currentCustomer.Orders.push(o);
                _this.originalCustomer.Orders.push(o);
            }
        });
    };
    CustomerModalComponent.prototype.save = function (isValid) {
        var _this = this;
        if (!isValid)
            return;
        this.processing = true;
        if (!this.isEditMode) {
            this.customerService.create(this.currentCustomer).then(function (response) {
                _this.processing = false;
                _this.customerSaved.emit(response.Data);
                _this.customerModal.hide();
            }).catch(function () {
                _this.toastr.error("Failed to create");
                _this.processing = false;
            });
            if (this.extraData.ReferenceId != null)
                this.extraDataService.modify(this.extraData);
        }
        else {
            this.customerService.update(new __WEBPACK_IMPORTED_MODULE_7__objects_requests_customerModifyRequest__["a" /* CustomerModifyRequest */]({
                Customer: this.currentCustomer,
                ChangeForAllOrders: this.changeCustomersForAll
            })).then(function (response) {
                _this.processing = false;
                if (_this.changeCustomersForAll)
                    _this.toastr.success("Orders were updated");
                _this.customerSaved.emit(response.Data);
                _this.customerModal.hide();
            }).catch(function () {
                _this.toastr.error("Does not change any order");
                _this.processing = false;
            });
            this.extraDataService.modify(this.extraData);
        }
    };
    CustomerModalComponent.prototype.cancel = function () {
        this.customerModal.hide();
    };
    // TEMP FOR TEST BY TASK https://jira.ak-tech.org/browse/BB-2852
    CustomerModalComponent.prototype.sendGetStartedEmail = function () {
        var _this = this;
        this.isDisabledSendGetStartedEmailButton$.next(true);
        Object(__WEBPACK_IMPORTED_MODULE_24_rxjs_observable_fromPromise__["fromPromise"])(this.emailService.sendGetStartedEmail(this.currentCustomer.Email))
            .pipe(Object(__WEBPACK_IMPORTED_MODULE_25_rxjs_operators__["finalize"])(function () { return _this.isDisabledSendGetStartedEmailButton$.next(false); }))
            .subscribe();
    };
    CustomerModalComponent.prototype.copyToClipboard = function (copyToClipboardInput) {
        var _this = this;
        copyToClipboardInput.select();
        document.execCommand('copy');
        copyToClipboardInput.setSelectionRange(0, copyToClipboardInput.value.length);
        this.toastr.success('Link copied to clipboard.');
        this.isCopied$.next(true);
        var timeoutId = setTimeout(function () {
            _this.isCopied$.next(false);
            clearTimeout(timeoutId);
        }, 3000);
    };
    CustomerModalComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_3__services_customerService__["a" /* CustomerService */] }, { type: __WEBPACK_IMPORTED_MODULE_5__angular_router__["n" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_8_ng2_toastr__["ToastsManager"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectorRef"] }, { type: __WEBPACK_IMPORTED_MODULE_9__services_extraDataService__["a" /* ExtraDataService */] }, { type: __WEBPACK_IMPORTED_MODULE_15__services_userViewService__["a" /* UserViewService */] }, { type: __WEBPACK_IMPORTED_MODULE_18__services_emailService__["a" /* EmailService */] }, { type: __WEBPACK_IMPORTED_MODULE_21__common_managers_storageManager__["a" /* StorageManager */] }, { type: __WEBPACK_IMPORTED_MODULE_19__services_paymentService__["a" /* PaymentService */] }, { type: __WEBPACK_IMPORTED_MODULE_22__services_configService__["a" /* ConfigService */] }]; };
    return CustomerModalComponent;
}(__WEBPACK_IMPORTED_MODULE_12__extraData_baseExtraData__["a" /* BaseExtraData */]));

//# sourceMappingURL=customerModal.component.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "QIkZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var operators_1 = __webpack_require__("W+Sr");
var fromEvent_1 = __webpack_require__("TIy+");
var events_1 = __webpack_require__("NBsw");
var LongPressDirective = /** @class */ (function () {
    function LongPressDirective() {
        this.pressEnabled = true;
        this.duration = 500;
        this.longPressStart = new core_1.EventEmitter();
        this.longPressing = new core_1.EventEmitter();
        this.longPressEnd = new core_1.EventEmitter();
        this.mouseX = 0;
        this.mouseY = 0;
    }
    Object.defineProperty(LongPressDirective.prototype, "press", {
        get: function () { return this.pressing; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LongPressDirective.prototype, "isLongPress", {
        get: function () {
            return this.isLongPressing;
        },
        enumerable: true,
        configurable: true
    });
    LongPressDirective.prototype.onMouseDown = function (event) {
        var _this = this;
        // don't do right/middle clicks
        if (event.which !== 1 || !this.pressEnabled)
            return;
        // don't start drag if its on resize handle
        var target = event.target;
        if (target.classList.contains('resize-handle'))
            return;
        this.mouseX = event.clientX;
        this.mouseY = event.clientY;
        this.pressing = true;
        this.isLongPressing = false;
        var mouseup = fromEvent_1.fromEvent(document, 'mouseup');
        this.subscription = mouseup.subscribe(function (ev) { return _this.onMouseup(); });
        this.timeout = setTimeout(function () {
            _this.isLongPressing = true;
            _this.longPressStart.emit({
                event: event,
                model: _this.pressModel
            });
            _this.subscription.add(fromEvent_1.fromEvent(document, 'mousemove')
                .pipe(operators_1.takeUntil(mouseup))
                .subscribe(function (mouseEvent) { return _this.onMouseMove(mouseEvent); }));
            _this.loop(event);
        }, this.duration);
        this.loop(event);
    };
    LongPressDirective.prototype.onMouseMove = function (event) {
        if (this.pressing && !this.isLongPressing) {
            var xThres = Math.abs(event.clientX - this.mouseX) > 10;
            var yThres = Math.abs(event.clientY - this.mouseY) > 10;
            if (xThres || yThres) {
                this.endPress();
            }
        }
    };
    LongPressDirective.prototype.loop = function (event) {
        var _this = this;
        if (this.isLongPressing) {
            this.timeout = setTimeout(function () {
                _this.longPressing.emit({
                    event: event,
                    model: _this.pressModel
                });
                _this.loop(event);
            }, 50);
        }
    };
    LongPressDirective.prototype.endPress = function () {
        clearTimeout(this.timeout);
        this.isLongPressing = false;
        this.pressing = false;
        this._destroySubscription();
        this.longPressEnd.emit({
            model: this.pressModel
        });
    };
    LongPressDirective.prototype.onMouseup = function () {
        this.endPress();
    };
    LongPressDirective.prototype.ngOnDestroy = function () {
        this._destroySubscription();
    };
    LongPressDirective.prototype._destroySubscription = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], LongPressDirective.prototype, "pressEnabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], LongPressDirective.prototype, "pressModel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], LongPressDirective.prototype, "duration", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], LongPressDirective.prototype, "longPressStart", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], LongPressDirective.prototype, "longPressing", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], LongPressDirective.prototype, "longPressEnd", void 0);
    __decorate([
        core_1.HostBinding('class.press'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], LongPressDirective.prototype, "press", null);
    __decorate([
        core_1.HostBinding('class.longpress'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], LongPressDirective.prototype, "isLongPress", null);
    __decorate([
        core_1.HostListener('mousedown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], LongPressDirective.prototype, "onMouseDown", null);
    LongPressDirective = __decorate([
        core_1.Directive({ selector: '[long-press]' })
    ], LongPressDirective);
    return LongPressDirective;
}());
exports.LongPressDirective = LongPressDirective;
//# sourceMappingURL=long-press.directive.js.map

/***/ }),

/***/ "Qp6t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Keys;
(function (Keys) {
    Keys[Keys["up"] = 38] = "up";
    Keys[Keys["down"] = 40] = "down";
    Keys[Keys["return"] = 13] = "return";
    Keys[Keys["escape"] = 27] = "escape";
    Keys[Keys["left"] = 37] = "left";
    Keys[Keys["right"] = 39] = "right";
})(Keys = exports.Keys || (exports.Keys = {}));
//# sourceMappingURL=keys.js.map

/***/ }),

/***/ "Rzwq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgentSelectorComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ng2_cookies_ng2_cookies__ = __webpack_require__("46qw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ng2_cookies_ng2_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ng2_cookies_ng2_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_configService__ = __webpack_require__("cfSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_users_user__ = __webpack_require__("E4s1");




/**
 * Created by alex.y on 9/22/2017.
 */
var AgentSelectorComponent = /** @class */ (function () {
    function AgentSelectorComponent(configService) {
        this.configService = configService;
        this.agentsChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.currentAgent = new __WEBPACK_IMPORTED_MODULE_3__objects_users_user__["c" /* User */]();
        this.agentColors = [];
        this.allAgents = [];
    }
    AgentSelectorComponent.prototype.ngAfterViewInit = function () {
        this.initAgentSelect();
    };
    AgentSelectorComponent.prototype.setValue = function () {
        var selector = $("#" + this.select2Id);
        if (selector)
            this.agentsChange.emit(selector.val());
    };
    AgentSelectorComponent.prototype.initAgentSelect = function () {
        var self = this;
        var init = true;
        var data = [];
        for (var _i = 0, _a = this.allAgents; _i < _a.length; _i++) {
            var item = _a[_i];
            data.push({
                id: item.Id,
                text: item.Email,
                Item: item
            });
        }
        var timerId;
        var isUnselect = false;
        this.select = $("#" + this.select2Id);
        this.select.select2({
            width: '100%',
            data: data,
            allowClear: true,
            placeholder: 'Select agents',
            multiple: 'multiple',
            closeOnSelect: true,
            templateSelection: function (state) {
                var colorObj = self.agentColors.find(function (x) { return x.Email == state.text; });
                var color = "#EB5757";
                if (colorObj)
                    color = colorObj.color;
                return "<i class=\"material-icons circle-icon\" style=\"color:" + color + "\">fiber_manual_record</i><span style=\"color:" + color + "\">" + state.text + "</span>";
            },
            escapeMarkup: function (m) {
                return m;
            }
        }).on('select2:select', function (e) {
            var dataArray = $(this).val();
            if (!init)
                self.agentsChange.emit(dataArray);
            var t = $('[aria-selected = "false"]').length;
            if (t == 0)
                $(this).select2("close");
        }).on('select2:opening', function (e) {
            if (isUnselect) {
                e.preventDefault();
                isUnselect = false;
            }
        }).on('select2:unselect', function (e) {
            isUnselect = true;
            var dataArray = $(this).val();
            if (timerId)
                clearTimeout(timerId);
            timerId = setTimeout(function () {
                self.agentsChange.emit(dataArray);
            }, 1000);
        }).on('select2:open', function (params) {
            var select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });
        if (data.length == 1)
            this.select.val(__WEBPACK_IMPORTED_MODULE_1_ng2_cookies_ng2_cookies__["Cookie"].get(this.configService.config.UserCookieName)).trigger("change");
        else {
            var select2Data = $("#" + this.select2Id).data("select2");
            for (var _b = 0, data_1 = data; _b < data_1.length; _b++) {
                var dat = data_1[_b];
                select2Data.trigger("select", { data: dat });
            }
        }
        init = false;
    };
    AgentSelectorComponent.prototype.resizeSelect = function (height) {
        if (height > 0)
            $(".select2-selection--multiple").css("max-height", height);
    };
    AgentSelectorComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__services_configService__["a" /* ConfigService */] }]; };
    return AgentSelectorComponent;
}());

//# sourceMappingURL=agentSelector.component.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "S1aP":
/***/ (function(module, exports, __webpack_require__) {

// Export all services
var cookie_1 = __webpack_require__("JJFZ");
exports.Cookie = cookie_1.Cookie;
//# sourceMappingURL=services.js.map

/***/ }),

/***/ "SCcC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Guid; });
/**
 * Created by iqpir on 5/28/2017.
 */
var Guid = /** @class */ (function () {
    function Guid() {
    }
    Guid.newGuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    return Guid;
}());

//# sourceMappingURL=guidHelper.js.map

/***/ }),

/***/ "TDHu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TaxType; });
/**
 * Created by alex.y on 8/8/2017.
 */
var TaxType;
(function (TaxType) {
    TaxType[TaxType["CustomDuty"] = 1] = "CustomDuty";
    TaxType[TaxType["CustomGST"] = 2] = "CustomGST";
    TaxType[TaxType["CustomPST"] = 3] = "CustomPST";
    TaxType[TaxType["AAFee"] = 4] = "AAFee";
    TaxType[TaxType["AAFeeGST"] = 5] = "AAFeeGST";
    TaxType[TaxType["AAFeePST"] = 6] = "AAFeePST";
    TaxType[TaxType["CustomMPF"] = 7] = "CustomMPF";
    TaxType[TaxType["CustomHMF"] = 8] = "CustomHMF";
    TaxType[TaxType["ClassificationFee"] = 9] = "ClassificationFee";
    TaxType[TaxType["Bond"] = 10] = "Bond";
    TaxType[TaxType["BondUnderFee"] = 11] = "BondUnderFee";
    TaxType[TaxType["CustomISF"] = 12] = "CustomISF";
    TaxType[TaxType["DutyDistRate"] = 13] = "DutyDistRate";
    TaxType[TaxType["NAFTA"] = 14] = "NAFTA";
    TaxType[TaxType["ABIFee"] = 15] = "ABIFee";
    TaxType[TaxType["FDA"] = 16] = "FDA";
    TaxType[TaxType["ImportRegisterFee"] = 17] = "ImportRegisterFee";
    TaxType[TaxType["PAPSFee"] = 18] = "PAPSFee";
    TaxType[TaxType["AdminFee"] = 19] = "AdminFee";
    TaxType[TaxType["Manual"] = 20] = "Manual";
    TaxType[TaxType["ITN"] = 21] = "ITN";
    TaxType[TaxType["RIV"] = 22] = "RIV";
    TaxType[TaxType["FormOne"] = 23] = "FormOne";
    TaxType[TaxType["AC"] = 24] = "AC";
    TaxType[TaxType["UsedEquipment"] = 25] = "UsedEquipment";
    TaxType[TaxType["GreenLevy"] = 26] = "GreenLevy";
    TaxType[TaxType["EManifest"] = 27] = "EManifest";
    TaxType[TaxType["SoilExamFee"] = 28] = "SoilExamFee";
    TaxType[TaxType["AgentPortFee"] = 29] = "AgentPortFee";
})(TaxType || (TaxType = {}));
//# sourceMappingURL=taxType.js.map

/***/ }),

/***/ "TeqA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Throttle a function
 */
function throttle(func, wait, options) {
    options = options || {};
    var context;
    var args;
    var result;
    var timeout = null;
    var previous = 0;
    function later() {
        previous = options.leading === false ? 0 : +new Date();
        timeout = null;
        result = func.apply(context, args);
    }
    return function () {
        var now = +new Date();
        if (!previous && options.leading === false) {
            previous = now;
        }
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0) {
            clearTimeout(timeout);
            timeout = null;
            previous = now;
            result = func.apply(context, args);
        }
        else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
}
exports.throttle = throttle;
/**
 * Throttle decorator
 *
 *  class MyClass {
 *    throttleable(10)
 *    myFn() { ... }
 *  }
 */
function throttleable(duration, options) {
    return function innerDecorator(target, key, descriptor) {
        return {
            configurable: true,
            enumerable: descriptor.enumerable,
            get: function getter() {
                Object.defineProperty(this, key, {
                    configurable: true,
                    enumerable: descriptor.enumerable,
                    value: throttle(descriptor.value, duration, options)
                });
                return this[key];
            }
        };
    };
}
exports.throttleable = throttleable;
//# sourceMappingURL=throttle.js.map

/***/ }),

/***/ "Tp9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductSearchType; });
/**
 * Created by alex.y on 12/11/2017.
 */
var ProductSearchType;
(function (ProductSearchType) {
    ProductSearchType[ProductSearchType["ProductHsCode"] = 0] = "ProductHsCode";
    ProductSearchType[ProductSearchType["ProductQuery"] = 1] = "ProductQuery";
    ProductSearchType[ProductSearchType["VehicleQuery"] = 2] = "VehicleQuery";
    ProductSearchType[ProductSearchType["VehicleHsCode"] = 3] = "VehicleHsCode";
})(ProductSearchType || (ProductSearchType = {}));
//# sourceMappingURL=productSearchType.js.map

/***/ }),

/***/ "Tq/D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomerService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseService__ = __webpack_require__("IhmT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__("Fzro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configService__ = __webpack_require__("cfSW");




/**
 * Created by alex.y on 9/7/2017.
 */
var CustomerService = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CustomerService, _super);
    function CustomerService(http, configService) {
        return _super.call(this, http, configService) || this;
    }
    CustomerService.prototype.search = function (request) {
        var params = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["l" /* URLSearchParams */]();
        params.append('query', encodeURIComponent(request.Query));
        params.append('top', request.Top.toString());
        params.append('skip', request.Skip.toString());
        params.append('orderBy', request.OrderBy.PropertyName);
        params.append('orderByDir', request.OrderBy.OrderBy.toString());
        params.append('fillOrders', request.FillOrders.toString());
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "customer/search",
            search: params
        }));
    };
    CustomerService.prototype.update = function (request) {
        return this.put(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "customer/modify",
            body: request
        }));
    };
    CustomerService.prototype.create = function (customer) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "customer/createinternal",
            body: customer
        }));
    };
    CustomerService.prototype.updateInPipeDrive = function (customer) {
        return this.put(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "customer/modify/pipedrive",
            body: customer
        }));
    };
    CustomerService.prototype.getByCustomerId = function (customerId, skip, top) {
        if (skip === void 0) { skip = 0; }
        if (top === void 0) { top = 10; }
        var params = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["l" /* URLSearchParams */]();
        params.append('top', top.toString());
        params.append('skip', skip.toString());
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "customer/" + customerId + "/orders",
            search: params
        }));
    };
    CustomerService.prototype.getCustomerById = function (customerId) {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "customer/" + customerId,
        }));
    };
    CustomerService.prototype.getCustomerPayDataById = function (customerId) {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "customer/paydata/" + customerId,
        }));
    };
    CustomerService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_http__["e" /* Http */] }, { type: __WEBPACK_IMPORTED_MODULE_3__configService__["a" /* ConfigService */] }]; };
    return CustomerService;
}(__WEBPACK_IMPORTED_MODULE_1__baseService__["a" /* BaseApi */]));

//# sourceMappingURL=customerService.js.map

/***/ }),

/***/ "U6Mf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContextmenuType;
(function (ContextmenuType) {
    ContextmenuType["header"] = "header";
    ContextmenuType["body"] = "body";
})(ContextmenuType = exports.ContextmenuType || (exports.ContextmenuType = {}));
//# sourceMappingURL=contextmenu.type.js.map

/***/ }),

/***/ "UB/I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Seller; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SellerStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_baseEntity__ = __webpack_require__("mCwL");


var Seller = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Seller, _super);
    function Seller(obj) {
        var _this = _super.call(this) || this;
        if (obj != null)
            Object.assign(_this, obj);
        return _this;
    }
    return Seller;
}(__WEBPACK_IMPORTED_MODULE_1__common_baseEntity__["a" /* BaseEntity */]));

var SellerStatus;
(function (SellerStatus) {
    SellerStatus[SellerStatus["NotStarted"] = 0] = "NotStarted";
    SellerStatus[SellerStatus["InProgress"] = 1] = "InProgress";
    SellerStatus[SellerStatus["Done"] = 2] = "Done";
})(SellerStatus || (SellerStatus = {}));
//# sourceMappingURL=seller.js.map

/***/ }),

/***/ "UHPl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var utils_1 = __webpack_require__("x6Zf");
var services_1 = __webpack_require__("J/iR");
var events_1 = __webpack_require__("NBsw");
var DataTableBodyRowComponent = /** @class */ (function () {
    function DataTableBodyRowComponent(differs, scrollbarHelper, cd, element) {
        this.differs = differs;
        this.scrollbarHelper = scrollbarHelper;
        this.cd = cd;
        this.activate = new core_1.EventEmitter();
        this._groupStyles = {
            left: {},
            center: {},
            right: {}
        };
        this._element = element.nativeElement;
        this._rowDiffer = differs.find({}).create();
    }
    Object.defineProperty(DataTableBodyRowComponent.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (val) {
            this._columns = val;
            this.recalculateColumns(val);
            this.buildStylesByGroup();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyRowComponent.prototype, "innerWidth", {
        get: function () {
            return this._innerWidth;
        },
        set: function (val) {
            if (this._columns) {
                var colByPin = utils_1.columnsByPin(this._columns);
                this._columnGroupWidths = utils_1.columnGroupWidths(colByPin, colByPin);
            }
            this._innerWidth = val;
            this.recalculateColumns();
            this.buildStylesByGroup();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyRowComponent.prototype, "offsetX", {
        get: function () { return this._offsetX; },
        set: function (val) {
            this._offsetX = val;
            this.buildStylesByGroup();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyRowComponent.prototype, "cssClass", {
        get: function () {
            var cls = 'datatable-body-row';
            if (this.isSelected)
                cls += ' active';
            if (this.rowIndex % 2 !== 0)
                cls += ' datatable-row-odd';
            if (this.rowIndex % 2 === 0)
                cls += ' datatable-row-even';
            if (this.rowClass) {
                var res = this.rowClass(this.row);
                if (typeof res === 'string') {
                    cls += " " + res;
                }
                else if (typeof res === 'object') {
                    var keys = Object.keys(res);
                    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                        var k = keys_1[_i];
                        if (res[k] === true)
                            cls += " " + k;
                    }
                }
            }
            return cls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyRowComponent.prototype, "columnsTotalWidths", {
        get: function () {
            return this._columnGroupWidths.total;
        },
        enumerable: true,
        configurable: true
    });
    DataTableBodyRowComponent.prototype.ngDoCheck = function () {
        if (this._rowDiffer.diff(this.row)) {
            this.cd.markForCheck();
        }
    };
    DataTableBodyRowComponent.prototype.trackByGroups = function (index, colGroup) {
        return colGroup.type;
    };
    DataTableBodyRowComponent.prototype.columnTrackingFn = function (index, column) {
        return column.$$id;
    };
    DataTableBodyRowComponent.prototype.buildStylesByGroup = function () {
        this._groupStyles['left'] = this.calcStylesByGroup('left');
        this._groupStyles['center'] = this.calcStylesByGroup('center');
        this._groupStyles['right'] = this.calcStylesByGroup('right');
        this.cd.markForCheck();
    };
    DataTableBodyRowComponent.prototype.calcStylesByGroup = function (group) {
        var widths = this._columnGroupWidths;
        var offsetX = this.offsetX;
        var styles = {
            width: widths[group] + "px"
        };
        if (group === 'left') {
            utils_1.translateXY(styles, offsetX, 0);
        }
        else if (group === 'right') {
            var bodyWidth = parseInt(this.innerWidth + '', 0);
            var totalDiff = widths.total - bodyWidth;
            var offsetDiff = totalDiff - offsetX;
            var offset = (offsetDiff + this.scrollbarHelper.width) * -1;
            utils_1.translateXY(styles, offset, 0);
        }
        return styles;
    };
    DataTableBodyRowComponent.prototype.onActivate = function (event, index) {
        event.cellIndex = index;
        event.rowElement = this._element;
        this.activate.emit(event);
    };
    DataTableBodyRowComponent.prototype.onKeyDown = function (event) {
        var keyCode = event.keyCode;
        var isTargetRow = event.target === this._element;
        var isAction = keyCode === utils_1.Keys.return ||
            keyCode === utils_1.Keys.down ||
            keyCode === utils_1.Keys.up ||
            keyCode === utils_1.Keys.left ||
            keyCode === utils_1.Keys.right;
        if (isAction && isTargetRow) {
            event.preventDefault();
            event.stopPropagation();
            this.activate.emit({
                type: 'keydown',
                event: event,
                row: this.row,
                rowElement: this._element
            });
        }
    };
    DataTableBodyRowComponent.prototype.onMouseenter = function (event) {
        this.activate.emit({
            type: 'mouseenter',
            event: event,
            row: this.row,
            rowElement: this._element
        });
    };
    DataTableBodyRowComponent.prototype.recalculateColumns = function (val) {
        if (val === void 0) { val = this.columns; }
        this._columns = val;
        var colsByPin = utils_1.columnsByPin(this._columns);
        this._columnsByPin = utils_1.columnsByPinArr(this._columns);
        this._columnGroupWidths = utils_1.columnGroupWidths(colsByPin, this._columns);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], DataTableBodyRowComponent.prototype, "columns", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], DataTableBodyRowComponent.prototype, "innerWidth", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableBodyRowComponent.prototype, "expanded", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableBodyRowComponent.prototype, "rowClass", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableBodyRowComponent.prototype, "row", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableBodyRowComponent.prototype, "group", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableBodyRowComponent.prototype, "isSelected", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableBodyRowComponent.prototype, "rowIndex", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableBodyRowComponent.prototype, "displayCheck", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], DataTableBodyRowComponent.prototype, "offsetX", null);
    __decorate([
        core_1.HostBinding('class'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], DataTableBodyRowComponent.prototype, "cssClass", null);
    __decorate([
        core_1.HostBinding('style.height.px'),
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableBodyRowComponent.prototype, "rowHeight", void 0);
    __decorate([
        core_1.HostBinding('style.width.px'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], DataTableBodyRowComponent.prototype, "columnsTotalWidths", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTableBodyRowComponent.prototype, "activate", void 0);
    __decorate([
        core_1.HostListener('keydown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DataTableBodyRowComponent.prototype, "onKeyDown", null);
    __decorate([
        core_1.HostListener('mouseenter', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DataTableBodyRowComponent.prototype, "onMouseenter", null);
    DataTableBodyRowComponent = __decorate([
        core_1.Component({
            selector: 'datatable-body-row',
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
            template: "\n    <div\n      *ngFor=\"let colGroup of _columnsByPin; let i = index; trackBy: trackByGroups\"\n      class=\"datatable-row-{{colGroup.type}} datatable-row-group\"\n      [ngStyle]=\"_groupStyles[colGroup.type]\">\n      <datatable-body-cell\n        *ngFor=\"let column of colGroup.columns; let ii = index; trackBy: columnTrackingFn\"\n        tabindex=\"-1\"\n        [row]=\"row\"\n        [group]=\"group\"\n        [expanded]=\"expanded\"\n        [isSelected]=\"isSelected\"\n        [rowIndex]=\"rowIndex\"\n        [column]=\"column\"\n        [rowHeight]=\"rowHeight\"\n        [displayCheck]=\"displayCheck\"\n        (activate)=\"onActivate($event, ii)\">\n      </datatable-body-cell>\n    </div>\n  "
        }),
        __param(1, core_1.SkipSelf()),
        __metadata("design:paramtypes", [core_1.KeyValueDiffers,
            services_1.ScrollbarHelper,
            core_1.ChangeDetectorRef,
            core_1.ElementRef])
    ], DataTableBodyRowComponent);
    return DataTableBodyRowComponent;
}());
exports.DataTableBodyRowComponent = DataTableBodyRowComponent;
//# sourceMappingURL=body-row.component.js.map

/***/ }),

/***/ "UITZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@angular/platform-browser/@angular/platform-browser.es5.js
var platform_browser_es5 = __webpack_require__("Qbdm");

// EXTERNAL MODULE: ./node_modules/@angular/core/@angular/core.es5.js
var core_es5 = __webpack_require__("3j3K");

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("TToO");

// EXTERNAL MODULE: ./node_modules/ng2-toastr/ng2-toastr.js
var ng2_toastr = __webpack_require__("xssS");
var ng2_toastr_default = /*#__PURE__*/__webpack_require__.n(ng2_toastr);

// EXTERNAL MODULE: ./app/common/managers/storageManager.ts
var managers_storageManager = __webpack_require__("ivjz");

// EXTERNAL MODULE: ./app/services/baseService.ts + 1 modules
var baseService = __webpack_require__("IhmT");

// EXTERNAL MODULE: ./node_modules/@angular/http/@angular/http.es5.js
var http_es5 = __webpack_require__("Fzro");

// CONCATENATED MODULE: ./app/services/logService.ts



var logService_LogService = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](LogService, _super);
    function LogService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LogService.prototype.save = function (logRequest) {
        return this.post(new http_es5["i" /* RequestOptions */]({
            url: "log",
            body: logRequest
        }));
    };
    return LogService;
}(baseService["a" /* BaseApi */]));

//# sourceMappingURL=logService.js.map
// CONCATENATED MODULE: ./app/app.module.ts





function createConfigService(config, handler) {
    return function () { return config.load(); };
}
function createCountryDataService(countryService, handler) {
    return function () { return countryService.load(); };
}
var app_module_CustomToastOption = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](CustomToastOption, _super);
    function CustomToastOption() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.newestOnTop = false;
        _this.showCloseButton = true;
        _this.positionClass = "toast-top-full-width";
        _this.enableHTML = true;
        _this.maxShown = 5;
        return _this;
    }
    return CustomToastOption;
}(ng2_toastr["ToastOptions"]));

var app_module_customErrorHandler = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](customErrorHandler, _super);
    function customErrorHandler(injector) {
        var _this = _super.call(this) || this;
        _this.injector = injector;
        return _this;
    }
    Object.defineProperty(customErrorHandler.prototype, "storageManager", {
        get: function () {
            if (this._storageManager)
                return this._storageManager;
            var store = this.injector.get(managers_storageManager["a" /* StorageManager */]);
            if (store)
                this._storageManager = store;
            return this._storageManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(customErrorHandler.prototype, "logService", {
        get: function () {
            if (this._logService)
                return this._logService;
            var log = this.injector.get(logService_LogService);
            if (log)
                this._logService = log;
            return this._logService;
        },
        enumerable: true,
        configurable: true
    });
    customErrorHandler.prototype.handleError = function (error) {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            var store, currentUser, extraData, request;
            return tslib_es6["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        store = this.storageManager;
                        return [4 /*yield*/, store.getCurrentUser()];
                    case 1:
                        currentUser = _a.sent();
                        extraData = [new Tuple("Stack", error.stack),
                            new Tuple("Url", window.location.href),
                            new Tuple("UserAgent", navigator.userAgent),
                            new Tuple("ScreenWidth", screen.width),
                            new Tuple("ScreenHeight", screen.height)];
                        if (currentUser) {
                            extraData.push(new Tuple("UserId", currentUser.Id), new Tuple("UserEmail", currentUser.Email));
                        }
                        request = new LogRequest({
                            LogLevel: LogLevel.Error,
                            Message: error.message,
                            ExtraData: extraData
                        });
                        this.logService.save(request).catch();
                        _super.prototype.handleError.call(this, error);
                        return [2 /*return*/];
                }
            });
        });
    };
    return customErrorHandler;
}(core_es5["ErrorHandler"]));

var LogRequest = /** @class */ (function () {
    function LogRequest(init) {
        Object.assign(this, init);
    }
    return LogRequest;
}());
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Trace"] = 0] = "Trace";
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Warn"] = 3] = "Warn";
    LogLevel[LogLevel["Error"] = 4] = "Error";
    LogLevel[LogLevel["Fatal"] = 5] = "Fatal";
    LogLevel[LogLevel["Off"] = 6] = "Off";
})(LogLevel || (LogLevel = {}));
var Tuple = /** @class */ (function () {
    function Tuple(Item1, Item2) {
        this.Item1 = Item1;
        this.Item2 = Item2;
    }
    return Tuple;
}());
var customCurrencyMaskConfig = {
    align: "left",
    allowNegative: true,
    allowZero: true,
    decimal: ".",
    precision: 2,
    prefix: "$ ",
    suffix: "",
    thousands: ",",
    nullable: true
};
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());

//# sourceMappingURL=app.module.js.map
// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./app/services/configService.ts
var services_configService = __webpack_require__("cfSW");

// CONCATENATED MODULE: ./app/app.component.ts




var app_component_AppComponent = /** @class */ (function () {
    function AppComponent(toastr, vcr, configService) {
        this.toastr = toastr;
        this.configService = configService;
        this.toastr.setRootViewContainerRef(vcr);
    }
    AppComponent.prototype.ngAfterViewInit = function () {
        if (!String.isNullOrEmpty(this.configService.config.GTagId)) {
            // by task https://jira.ak-tech.org/browse/BB-2517
            // const s = document.createElement("script");
            // s.src = `https://www.googletagmanager.com/gtag/js?id=${this.configService.config.GUATagId ? this.configService.config.GUATagId : this.configService.config.GTagId}`;
            // s.async = true;
            //
            // document.head.insertBefore(s, document.head.firstChild);
            var s2 = document.createElement("script");
            s2.type = "text/javascript";
            s2.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(\n                {'gtm.start': new Date().getTime(),event:'gtm.js'});\n                var f=d.getElementsByTagName(s)[0],\n                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n                })(window,document,'script','dataLayer','" + this.configService.config.GTagId + "');";
            document.head.insertBefore(s2, document.head.firstChild);
            var s3 = document.createElement("script");
            s3.type = "text/javascript";
            s3.innerHTML = "  window.dataLayer = window.dataLayer || [];\n  function gtag(){dataLayer.push(arguments);}\n  gtag('js', new Date());\n\n\n  gtag('config', '" + (this.configService.config.GUATagId ? this.configService.config.GUATagId : this.configService.config.GTagId) + "');\n            ";
            document.head.insertBefore(s3, document.head.firstChild);
        }
        //removes this by request in BB-1791
        //this.initZendesk();
    };
    AppComponent.prototype.initZendesk = function () {
        var zendeskScript = document.createElement("script");
        zendeskScript.type = "text/javascript";
        zendeskScript.innerHTML = "/*<![CDATA[*/window.zEmbed||function(e,t){var n,o,d,i,s,a=[],r=document.createElement(\"iframe\");\n        window.zEmbed=function(){a.push(arguments)},window.zE=window.zE||window.zEmbed,r.src=\"javascript:false\",r.title=\"\",r.role=\"presentation\",\n        (r.frameElement||r).style.cssText=\"display: none\",d=document.getElementsByTagName(\"script\"),\n        d=d[d.length-1],d.parentNode.insertBefore(r,d),i=r.contentWindow,s=i.document;try{o=s}catch(e){\n        n=document.domain,r.src='javascript:var d=document.open();d.domain=\"'+n+'\";void(0);',o=s}o.open()._l=function(){var e=this.createElement(\"script\");n&&(this.domain=n),\n        e.id=\"js-iframe-async\",\n        e.src=\"https://assets.zendesk.com/embeddable_framework/main.js\",\n        this.t=+new Date,this.zendeskHost=\"borderbuddy.zendesk.com\",this.zEQueue=a,this.body.appendChild(e)},o.write('<body onload=\"document._l();\">'),o.close()}();\n            /*]]>*/";
        document.head.insertBefore(zendeskScript, document.head.firstChild);
    };
    AppComponent.ctorParameters = function () { return [{ type: ng2_toastr["ToastsManager"] }, { type: core_es5["ViewContainerRef"] }, { type: services_configService["a" /* ConfigService */] }]; };
    return AppComponent;
}());

//# sourceMappingURL=app.component.js.map
// EXTERNAL MODULE: ./node_modules/@angular/common/@angular/common.es5.js
var common_es5 = __webpack_require__("2Je8");

// EXTERNAL MODULE: ./node_modules/ng2-toastr/src/toast-container.component.js
var toast_container_component = __webpack_require__("kC0j");
var toast_container_component_default = /*#__PURE__*/__webpack_require__.n(toast_container_component);

// EXTERNAL MODULE: ./node_modules/ng2-toastr/src/toast-options.js
var toast_options = __webpack_require__("7YxL");
var toast_options_default = /*#__PURE__*/__webpack_require__.n(toast_options);

// CONCATENATED MODULE: ./compiled/node_modules/ng2-toastr/src/toast-container.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_ToastContainer = [];
var RenderType_ToastContainer = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ToastContainer, data: { 'animation': [{ type: 7, name: 'inOut', definitions: [{ type: 0,
                        name: 'flyRight, flyLeft', styles: { type: 6, styles: { opacity: 1, transform: 'translateX(0)' },
                            offset: null }, options: undefined }, { type: 0, name: 'fade',
                        styles: { type: 6, styles: { opacity: 1 }, offset: null }, options: undefined },
                    { type: 0, name: 'slideDown, slideUp', styles: { type: 6, styles: { opacity: 1, transform: 'translateY(0)' },
                            offset: null }, options: undefined }, { type: 1, expr: 'void => flyRight',
                        animation: [{ type: 6, styles: { opacity: 0, transform: 'translateX(100%)' }, offset: null },
                            { type: 4, styles: null, timings: '0.2s ease-in' }], options: null },
                    { type: 1, expr: 'flyRight => void', animation: [{ type: 4, styles: { type: 6, styles: { opacity: 0,
                                        transform: 'translateX(100%)' }, offset: null }, timings: '0.2s 10ms ease-out' }],
                        options: null }, { type: 1, expr: 'void => flyLeft', animation: [{ type: 6,
                                styles: { opacity: 0, transform: 'translateX(-100%)' }, offset: null },
                            { type: 4, styles: null, timings: '0.2s ease-in' }], options: null },
                    { type: 1, expr: 'flyLeft => void', animation: [{ type: 4, styles: { type: 6, styles: { opacity: 0,
                                        transform: 'translateX(-100%)' }, offset: null }, timings: '0.2s 10ms ease-out' }],
                        options: null }, { type: 1, expr: 'void => fade', animation: [{ type: 6,
                                styles: { opacity: 0 }, offset: null }, { type: 4, styles: null,
                                timings: '0.3s ease-in' }], options: null }, { type: 1, expr: 'fade => void',
                        animation: [{ type: 4, styles: { type: 6, styles: { opacity: 0 }, offset: null },
                                timings: '0.3s 10ms ease-out' }], options: null }, { type: 1, expr: 'void => slideDown',
                        animation: [{ type: 6, styles: { opacity: 0, transform: 'translateY(-200%)' }, offset: null },
                            { type: 4, styles: null, timings: '0.3s ease-in' }], options: null },
                    { type: 1, expr: 'slideDown => void', animation: [{ type: 4, styles: { type: 6, styles: { opacity: 0,
                                        transform: 'translateY(-200%)' }, offset: null }, timings: '0.3s 10ms ease-out' }],
                        options: null }, { type: 1, expr: 'void => slideUp', animation: [{ type: 6,
                                styles: { opacity: 0, transform: 'translateY(200%)' }, offset: null },
                            { type: 4, styles: null, timings: '0.3s ease-in' }], options: null },
                    { type: 1, expr: 'slideUp => void', animation: [{ type: 4, styles: { type: 6, styles: { opacity: 0,
                                        transform: 'translateY(200%)' }, offset: null }, timings: '0.3s 10ms ease-out' }],
                        options: null }], options: {} }] } });
function View_ToastContainer_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'toast-close-button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.removeToast(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['×\n        ']))], null, null);
}
function View_ToastContainer_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [], [[8, 'className', 0]], null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, '', (_v.parent.context.$implicit.config.titleClass || _co.titleClass), '');
        _ck(_v, 0, 0, currVal_0);
        var currVal_1 = _v.parent.context.$implicit.title;
        _ck(_v, 1, 0, currVal_1);
    });
}
function View_ToastContainer_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [], [[8, 'className', 0], [8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, '', (_v.parent.context.$implicit.config.messageClass || _co.messageClass), '');
        var currVal_1 = _co.sanitizer.bypassSecurityTrustHtml(_v.parent.context.$implicit.message);
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
function View_ToastContainer_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], [[8, 'className', 0]], null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, '', (_v.parent.context.$implicit.config.messageClass || _co.messageClass), '');
        _ck(_v, 0, 0, currVal_0);
        var currVal_1 = _v.parent.context.$implicit.message;
        _ck(_v, 1, 0, currVal_1);
    });
}
function View_ToastContainer_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [], [[24, '@inOut', 0], [8, 'className', 0]], [[null, '@inOut.done'], [null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('@inOut.done' === en)) {
                var pd_0 = (_co.onAnimationEnd($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('click' === en)) {
                var pd_1 = (_co.clicked(_v.context.$implicit) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['\n        '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ToastContainer_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' \n        '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ToastContainer_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 8, 'div', [], null, null, null, null, null)), core_es5["ɵdid"](16384, null, 0, common_es5["NgSwitch"], [], { ngSwitch: [0, 'ngSwitch'] }, null),
        (_l()(), core_es5["ɵted"](null, ['\n          '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ToastContainer_4)), core_es5["ɵdid"](278528, null, 0, common_es5["NgSwitchCase"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], common_es5["NgSwitch"]], { ngSwitchCase: [0,
                'ngSwitchCase'] }, null), (_l()(), core_es5["ɵted"](null, ['\n          '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ToastContainer_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgSwitchDefault"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            common_es5["NgSwitch"]], null, null), (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵted"](null, ['             \n      ']))], function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.config.showCloseButton;
        _ck(_v, 3, 0, currVal_2);
        var currVal_3 = _v.context.$implicit.title;
        _ck(_v, 6, 0, currVal_3);
        var currVal_4 = _v.context.$implicit.config.enableHTML;
        _ck(_v, 9, 0, currVal_4);
        var currVal_5 = true;
        _ck(_v, 12, 0, currVal_5);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.animate;
        var currVal_1 = core_es5["ɵinlineInterpolate"](1, 'toast toast-', _v.context.$implicit.type, '');
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
function View_ToastContainer_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵeld"](0, [['toastContainer',
                1]], null, 4, 'div', [['id', 'toast-container']], [[4, 'position', null],
            [8, 'className', 0]], null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ToastContainer_1)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n    '])),
        (_l()(), core_es5["ɵted"](null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.toasts;
        _ck(_v, 4, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.position;
        var currVal_1 = core_es5["ɵinlineInterpolate"](1, '', _co.positionClass, '');
        _ck(_v, 1, 0, currVal_0, currVal_1);
    });
}
function View_ToastContainer_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'toast-container', [], null, null, null, View_ToastContainer_0, RenderType_ToastContainer)), core_es5["ɵdid"](180224, null, 0, toast_container_component["ToastContainer"], [platform_browser_es5["DomSanitizer"], core_es5["ChangeDetectorRef"], core_es5["NgZone"], toast_options["ToastOptions"]], null, null)], null, null);
}
var ToastContainerNgFactory = core_es5["ɵccf"]('toast-container', toast_container_component["ToastContainer"], View_ToastContainer_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=toast-container.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/modal/modal-backdrop.component.js
var modal_backdrop_component = __webpack_require__("tok5");

// CONCATENATED MODULE: ./compiled/node_modules/ngx-bootstrap/modal/modal-backdrop.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


var styles_ModalBackdropComponent = [];
var RenderType_ModalBackdropComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ModalBackdropComponent, data: {} });
function View_ModalBackdropComponent_0(_l) {
    return core_es5["ɵvid"](0, [], null, null);
}
function View_ModalBackdropComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'bs-modal-backdrop', [['class', 'modal-backdrop']], null, null, null, View_ModalBackdropComponent_0, RenderType_ModalBackdropComponent)), core_es5["ɵdid"](114688, null, 0, modal_backdrop_component["a" /* ModalBackdropComponent */], [core_es5["ElementRef"], core_es5["Renderer"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ModalBackdropComponentNgFactory = core_es5["ɵccf"]('bs-modal-backdrop', modal_backdrop_component["a" /* ModalBackdropComponent */], View_ModalBackdropComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvbW9kYWwvbW9kYWwtYmFja2Ryb3AuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL21vZGFsL21vZGFsLWJhY2tkcm9wLmNvbXBvbmVudC5kLnRzIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvbW9kYWwvbW9kYWwtYmFja2Ryb3AuY29tcG9uZW50LmQudHMuTW9kYWxCYWNrZHJvcENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxicy1tb2RhbC1iYWNrZHJvcD48L2JzLW1vZGFsLWJhY2tkcm9wPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7dUNBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=
//# sourceMappingURL=modal-backdrop.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/modal/modal-container.component.js
var modal_container_component = __webpack_require__("bYio");

// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/modal/modal-options.class.js
var modal_options_class = __webpack_require__("7/a6");

// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/modal/bs-modal.service.js
var bs_modal_service = __webpack_require__("/9u5");

// CONCATENATED MODULE: ./compiled/node_modules/ngx-bootstrap/modal/modal-container.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_ModalContainerComponent = [];
var RenderType_ModalContainerComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ModalContainerComponent, data: {} });
function View_ModalContainerComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['role', 'document']], [[8, 'className', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n      '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'modal-content']], null, null, null, null, null)),
        core_es5["ɵncd"](null, 0), (_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(),
            core_es5["ɵted"](null, ['\n  ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ('modal-dialog' + (_co.config.class ? (' ' + _co.config.class) : ''));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_ModalContainerComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'modal-container', [['class', 'modal'], ['role', 'dialog'], ['tabindex', '-1']], null, [[null,
                'click'], ['window', 'keydown.esc']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('window:keydown.esc' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 1).onEsc() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_ModalContainerComponent_0, RenderType_ModalContainerComponent)), core_es5["ɵdid"](245760, null, 0, modal_container_component["a" /* ModalContainerComponent */], [modal_options_class["d" /* ModalOptions */], core_es5["ElementRef"], bs_modal_service["a" /* BsModalService */],
            core_es5["Renderer"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ModalContainerComponentNgFactory = core_es5["ɵccf"]('modal-container', modal_container_component["a" /* ModalContainerComponent */], View_ModalContainerComponent_Host_0, {}, {}, ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvbW9kYWwvbW9kYWwtY29udGFpbmVyLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9tb2RhbC9tb2RhbC1jb250YWluZXIuY29tcG9uZW50LmQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9tb2RhbC9tb2RhbC1jb250YWluZXIuY29tcG9uZW50LmQudHMuTW9kYWxDb250YWluZXJDb21wb25lbnQuaHRtbCIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL21vZGFsL21vZGFsLWNvbnRhaW5lci5jb21wb25lbnQuZC50cy5Nb2RhbENvbnRhaW5lckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxkaXYgW2NsYXNzXT1cIidtb2RhbC1kaWFsb2cnICsgKGNvbmZpZy5jbGFzcyA/ICcgJyArIGNvbmZpZy5jbGFzcyA6ICcnKVwiIHJvbGU9XCJkb2N1bWVudFwiPlxuICAgICAgPGRpdiBjbGFzcz1cIm1vZGFsLWNvbnRlbnRcIj48bmctY29udGVudD48L25nLWNvbnRlbnQ+PC9kaXY+XG4gICAgPC9kaXY+XG4gICIsIjxtb2RhbC1jb250YWluZXI+PC9tb2RhbC1jb250YWluZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQSwyQ0FDSTtNQUFBO01BQUEsNENBQXlGO01BQ3ZGO1VBQUE7YUFBMkIsa0JBQStCLDJDQUN0RDtpQkFBQTs7SUFGRDtJQUFMLFdBQUssU0FBTDs7OztvQkNESjtNQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLDZFQUFBO01BQUE7cUJBQUE7SUFBQTs7OzsifQ==
//# sourceMappingURL=modal-container.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/dropdown/bs-dropdown-container.component.js
var bs_dropdown_container_component = __webpack_require__("NvNJ");

// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/dropdown/bs-dropdown.state.js
var bs_dropdown_state = __webpack_require__("oZUJ");

// CONCATENATED MODULE: ./compiled/node_modules/ngx-bootstrap/dropdown/bs-dropdown-container.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_BsDropdownContainerComponent = [];
var RenderType_BsDropdownContainerComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_BsDropdownContainerComponent, data: {} });
function View_BsDropdownContainerComponent_0(_l) {
    return core_es5["ɵvid"](2, [(_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [], [[2, 'dropup', null], [2, 'dropdown',
                null], [2, 'show', null], [2, 'open', null]], null, null, null, null)), core_es5["ɵncd"](null, 0), (_l()(),
            core_es5["ɵted"](null, ['\n  ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.direction === 'up');
        var currVal_1 = (_co.direction === 'down');
        var currVal_2 = _co.isOpen;
        var currVal_3 = _co.isOpen;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    });
}
function View_BsDropdownContainerComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'bs-dropdown-container', [['style', 'display:block;position: absolute;']], null, null, null, View_BsDropdownContainerComponent_0, RenderType_BsDropdownContainerComponent)),
        core_es5["ɵdid"](180224, null, 0, bs_dropdown_container_component["a" /* BsDropdownContainerComponent */], [bs_dropdown_state["a" /* BsDropdownState */],
            core_es5["ChangeDetectorRef"], core_es5["Renderer"], core_es5["ElementRef"]], null, null)], null, null);
}
var BsDropdownContainerComponentNgFactory = core_es5["ɵccf"]('bs-dropdown-container', bs_dropdown_container_component["a" /* BsDropdownContainerComponent */], View_BsDropdownContainerComponent_Host_0, {}, {}, ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvZHJvcGRvd24vYnMtZHJvcGRvd24tY29udGFpbmVyLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9kcm9wZG93bi9icy1kcm9wZG93bi1jb250YWluZXIuY29tcG9uZW50LmQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9kcm9wZG93bi9icy1kcm9wZG93bi1jb250YWluZXIuY29tcG9uZW50LmQudHMuQnNEcm9wZG93bkNvbnRhaW5lckNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvZHJvcGRvd24vYnMtZHJvcGRvd24tY29udGFpbmVyLmNvbXBvbmVudC5kLnRzLkJzRHJvcGRvd25Db250YWluZXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbiAgICA8ZGl2IFtjbGFzcy5kcm9wdXBdPVwiZGlyZWN0aW9uID09PSAndXAnXCJcbiAgICAgICAgIFtjbGFzcy5kcm9wZG93bl09XCJkaXJlY3Rpb24gPT09ICdkb3duJ1wiXG4gICAgICAgICBbY2xhc3Muc2hvd109XCJpc09wZW5cIlxuICAgICAgICAgW2NsYXNzLm9wZW5dPVwiaXNPcGVuXCI+PG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PjwvZGl2PlxuICAiLCI8YnMtZHJvcGRvd24tY29udGFpbmVyPjwvYnMtZHJvcGRvd24tY29udGFpbmVyPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OztvQkNBQSwyQ0FDSTtNQUFBO1VBQUE7TUFBQSxtREFHMkIsa0JBQStCO2FBQUE7O0lBSHJEO0lBQ0E7SUFDQTtJQUNBO0lBSEwsV0FBSyxVQUNBLFVBQ0EsVUFDQSxTQUhMOzs7O29CQ0RKO01BQUE7TUFBQTthQUFBO3dEQUFBOzs7OzsifQ==
//# sourceMappingURL=bs-dropdown-container.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/ngx-mydatepicker/dist/ngx-my-date-picker.component.js + 1 modules
var ngx_my_date_picker_component = __webpack_require__("RQEG");

// EXTERNAL MODULE: ./node_modules/ngx-mydatepicker/dist/directives/ngx-my-date-picker.focus.directive.js
var ngx_my_date_picker_focus_directive = __webpack_require__("DPx2");

// EXTERNAL MODULE: ./node_modules/ngx-mydatepicker/dist/services/ngx-my-date-picker.util.service.js
var ngx_my_date_picker_util_service = __webpack_require__("ONP7");

// CONCATENATED MODULE: ./compiled/node_modules/ngx-mydatepicker/dist/ngx-my-date-picker.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_NgxMyDatePicker = ['.ngxmdp .headertodaybtn,.ngxmdp .monthcell,.ngxmdp .weekdaytitle{overflow:hidden;white-space:nowrap}.ngxmdp *{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:Arial,Helvetica,sans-serif;padding:0;margin:0}.ngxmdp .selector{position:absolute;padding:0;border:1px solid #CCC;border-radius:4px;z-index:100000;animation:selectorfadein 60ms}.ngxmdp .selector:focus{border:1px solid #ADD8E6;outline:0}@keyframes selectorfadein{from{opacity:0}to{opacity:1}}.ngxmdp .selectorarrow{background:#FAFAFA;padding:0}.ngxmdp .selectorarrow:after,.ngxmdp .selectorarrow:before{bottom:100%;border:solid transparent;content:" ";height:0;width:0;position:absolute}.ngxmdp .selectorarrow:after{border-color:rgba(250,250,250,0);border-bottom-color:#FAFAFA;border-width:10px;margin-left:-10px}.ngxmdp .selectorarrow:before{border-color:rgba(204,204,204,0);border-bottom-color:#CCC;border-width:11px;margin-left:-11px}.ngxmdp .selectorarrow:focus:before{border-bottom-color:#ADD8E6}.ngxmdp .selectorarrowleft:after,.ngxmdp .selectorarrowleft:before{left:24px}.ngxmdp .selectorarrowright:after,.ngxmdp .selectorarrowright:before{left:86%}.ngxmdp ::-ms-clear{display:none}.ngxmdp .headerbtnenabled,.ngxmdp .headertodaybtnenabled,.ngxmdp .yearchangebtnenabled{cursor:pointer}.ngxmdp .headerbtndisabled,.ngxmdp .headertodaybtndisabled,.ngxmdp .yearchangebtndisabled{cursor:not-allowed;opacity:.65}.ngxmdp .headertodaybtn{background:#FFF}.ngxmdp .header{width:100%;height:30px;border-radius:4px 4px 0 0;background-color:#FAFAFA}.ngxmdp .header td{vertical-align:middle;border:none;line-height:0}.ngxmdp .header td:nth-child(1){padding-left:4px}.ngxmdp .header td:nth-child(2){text-align:center}.ngxmdp .header td:nth-child(3){padding-right:4px}.ngxmdp .caltable,.ngxmdp .monthtable,.ngxmdp .yeartable{border-radius:0 0 4px 4px;table-layout:fixed;width:100%;height:calc(100% - 30px);background-color:#FFF;font-size:14px}.ngxmdp .caltable tbody tr:nth-child(6) td:first-child,.ngxmdp .monthtable tbody tr:nth-child(4) td:first-child,.ngxmdp .yeartable tbody tr:nth-child(7) td:first-child{border-bottom-left-radius:4px}.ngxmdp .caltable tbody tr:nth-child(6) td:last-child,.ngxmdp .monthtable tbody tr:nth-child(4) td:last-child,.ngxmdp .yeartable tbody tr:nth-child(7) td:last-child{border-bottom-right-radius:4px}.ngxmdp .caltable,.ngxmdp .daycell,.ngxmdp .monthcell,.ngxmdp .monthtable,.ngxmdp .weekdaytitle,.ngxmdp .yearcell,.ngxmdp .yeartable{border-collapse:collapse;color:#036;line-height:1.1}.ngxmdp .daycell,.ngxmdp .monthcell,.ngxmdp .weekdaytitle,.ngxmdp .yearcell{padding:4px;text-align:center}.ngxmdp .weekdaytitle{background-color:#DDD;font-size:11px;font-weight:400;vertical-align:middle;max-width:36px}.ngxmdp .weekdaytitleweeknbr{width:20px;border-right:1px solid #BBB}.ngxmdp .monthcell{background-color:#FAFAFA}.ngxmdp .yearcell{background-color:#FAFAFA;width:20%}.ngxmdp .daycell .datevalue{background-color:inherit;vertical-align:middle}.ngxmdp .daycell .datevalue span{vertical-align:middle}.ngxmdp .daycellweeknbr{font-size:10px;border-right:1px solid #CCC;cursor:default;color:#000}.ngxmdp .nextmonth,.ngxmdp .prevmonth{color:#CCC}.ngxmdp .disabled{cursor:default!important;color:#CCC!important;background:#FBEFEF!important}.ngxmdp .highlight{color:#C30000}.ngxmdp .dimday{opacity:.5}.ngxmdp .currmonth{background-color:#F6F6F6;font-weight:400}.ngxmdp .markdate{position:absolute;width:4px;height:4px;border-radius:4px}.ngxmdp .markcurrday,.ngxmdp .markcurrmonth,.ngxmdp .markcurryear{text-decoration:underline}.ngxmdp .selectedday .datevalue,.ngxmdp .selectedmonth .monthvalue,.ngxmdp .selectedyear .yearvalue{border:none;background-color:#8EBFFF;border-radius:2px}.ngxmdp .headerbtncell{background-color:#FAFAFA;display:table-cell;vertical-align:middle}.ngxmdp .yearchangebtncell{text-align:center;background-color:#FAFAFA}.ngxmdp .headerbtn,.ngxmdp .headerlabelbtn,.ngxmdp .yearchangebtn{background:#FAFAFA;border:none;height:22px}.ngxmdp .headerbtn{width:16px}.ngxmdp .headerlabelbtn{font-size:14px;outline:0;cursor:default}.ngxmdp .headerlabelbtnnotedit{cursor:default}.ngxmdp .headertodaybtn{border:1px solid #CCC;padding:0 4px;border-radius:4px;font-size:11px;height:22px;min-width:60px;max-width:84px}.ngxmdp .headerbtn,.ngxmdp .headermonthtxt,.ngxmdp .headertodaybtn,.ngxmdp .headeryeartxt,.ngxmdp .yearchangebtn{color:#000}.ngxmdp button::-moz-focus-inner{border:0}.ngxmdp .headermonthtxt,.ngxmdp .headeryeartxt{text-align:center;display:table-cell;vertical-align:middle;font-size:14px;height:26px;width:40px;max-width:40px;overflow:hidden;white-space:nowrap}.ngxmdp .headertodaybtn:focus{background:#ADD8E6}.ngxmdp .headerbtn:focus,.ngxmdp .monthlabel:focus,.ngxmdp .yearchangebtn:focus,.ngxmdp .yearlabel:focus{color:#ADD8E6;outline:0}.ngxmdp .daycell:focus,.ngxmdp .monthcell:focus,.ngxmdp .yearcell:focus{outline:#CCC solid 1px}.ngxmdp .icon-ngxmydpdown,.ngxmdp .icon-ngxmydpleft,.ngxmdp .icon-ngxmydpright,.ngxmdp .icon-ngxmydpup{color:#222;font-size:20px}.ngxmdp .icon-ngxmydptoday{color:#222;font-size:11px}.ngxmdp table{display:table;border-spacing:0}.ngxmdp table td{padding:0}.ngxmdp table,.ngxmdp td,.ngxmdp th{border:none}.ngxmdp .headertodaybtnenabled:hover{background-color:#E6E6E6}.ngxmdp .tablesingleday:hover,.ngxmdp .tablesinglemonth:hover,.ngxmdp .tablesingleyear:hover{background-color:#DDD}.ngxmdp .daycell,.ngxmdp .monthcell,.ngxmdp .monthlabel,.ngxmdp .yearcell,.ngxmdp .yearlabel{cursor:pointer}.ngxmdp .headerbtnenabled:hover,.ngxmdp .monthlabel:hover,.ngxmdp .yearchangebtnenabled:hover,.ngxmdp .yearlabel:hover{color:#777}@font-face{font-family:ngx-mydatepicker;src:url(data:application/octet-stream;base64,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) format(\'truetype\');font-weight:400;font-style:normal}.ngxmdp .ngxmdpicon{font-family:ngx-mydatepicker;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.ngxmdp .icon-ngxmydpright:before{content:"\\e800"}.ngxmdp .icon-ngxmydpleft:before{content:"\\e801"}.ngxmdp .icon-ngxmydptoday:before{content:"\\e802"}.ngxmdp .icon-ngxmydpup:before{content:"\\e803"}.ngxmdp .icon-ngxmydpdown:before{content:"\\e804"}'];
var RenderType_NgxMyDatePicker = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_NgxMyDatePicker, data: {} });
function View_NgxMyDatePicker_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 6, 'button', [['class',
                'headertodaybtn'], ['type', 'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onTodayClicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'headertodaybtnenabled': 0, 'headertodaybtndisabled': 1 }),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'ngxmdpicon icon-ngxmydptoday']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'headertodaybtn';
        var currVal_2 = _ck(_v, 2, 0, !_co.disableTodayBtn, _co.disableTodayBtn);
        _ck(_v, 1, 0, currVal_1, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.disableTodayBtn;
        _ck(_v, 0, 0, currVal_0);
        var currVal_3 = _co.opts.todayBtnTxt;
        _ck(_v, 6, 0, currVal_3);
    });
}
function View_NgxMyDatePicker_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'th', [['class',
                'weekdaytitle weekdaytitleweeknbr']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['#']))], null, null);
}
function View_NgxMyDatePicker_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'th', [['class',
                'weekdaytitle'], ['scope', 'col']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_NgxMyDatePicker_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'td', [['class',
                'daycell daycellweeknbr']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.weekNbr;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_NgxMyDatePicker_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'div', [['class',
                'markdate']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), core_es5["ɵpod"]({ 'background-color': 0 })], function (_ck, _v) {
        var currVal_0 = _ck(_v, 2, 0, _v.parent.context.$implicit.markedDate.color);
        _ck(_v, 1, 0, currVal_0);
    }, null);
}
function View_NgxMyDatePicker_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 11, 'td', [['class',
                'daycell'], ['tabindex', '0']], null, [[null, 'click'], [null,
                'keydown']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                (!_v.context.$implicit.disabled && _co.onCellClicked(_v.context.$implicit));
                var pd_0 = ($event.stopPropagation() !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown' === en)) {
                var pd_1 = (_co.onCellKeyDown($event, _v.context.$implicit) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'currmonth': 0, 'selectedday': 1, 'disabled': 2,
            'tablesingleday': 3 }), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_NgxMyDatePicker_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'datevalue']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'prevmonth': 0,
            'currmonth': 1, 'nextmonth': 2, 'highlight': 3 }), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'span', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'markcurrday': 0, 'dimday': 1 }), (_l()(), core_es5["ɵted"](null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'daycell';
        var currVal_1 = _ck(_v, 2, 0, ((_v.context.$implicit.cmo === _co.currMonthId) && !_v.context.$implicit.disabled), ((((_co.selectedDate.day === _v.context.$implicit.dateObj.day) && (_co.selectedDate.month === _v.context.$implicit.dateObj.month)) && (_co.selectedDate.year === _v.context.$implicit.dateObj.year)) && (_v.context.$implicit.cmo === _co.currMonthId)), _v.context.$implicit.disabled, ((_v.context.$implicit.cmo === _co.currMonthId) && !_v.context.$implicit.disabled));
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_2 = _v.context.$implicit.markedDate.marked;
        _ck(_v, 4, 0, currVal_2);
        var currVal_3 = 'datevalue';
        var currVal_4 = _ck(_v, 7, 0, (_v.context.$implicit.cmo === _co.prevMonthId), (_v.context.$implicit.cmo === _co.currMonthId), (_v.context.$implicit.cmo === _co.nextMonthId), _v.context.$implicit.highlight);
        _ck(_v, 6, 0, currVal_3, currVal_4);
        var currVal_5 = _ck(_v, 10, 0, (_v.context.$implicit.currDay && _co.opts.markCurrentDay), (_v.context.$implicit.highlight && (((_v.context.$implicit.cmo === _co.prevMonthId) || (_v.context.$implicit.cmo === _co.nextMonthId)) || _v.context.$implicit.disabled)));
        _ck(_v, 9, 0, currVal_5);
    }, function (_ck, _v) {
        var currVal_6 = _v.context.$implicit.dateObj.day;
        _ck(_v, 11, 0, currVal_6);
    });
}
function View_NgxMyDatePicker_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'tr', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_NgxMyDatePicker_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_NgxMyDatePicker_7)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.opts.showWeekNumbers && (_co.opts.firstDayOfWeek === 'mo'));
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.week;
        _ck(_v, 4, 0, currVal_1);
    }, null);
}
function View_NgxMyDatePicker_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 9, 'table', [['class',
                'caltable']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 5, 'thead', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_NgxMyDatePicker_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_NgxMyDatePicker_4)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'tbody', [], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_NgxMyDatePicker_5)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.opts.showWeekNumbers && (_co.opts.firstDayOfWeek === 'mo'));
        _ck(_v, 4, 0, currVal_0);
        var currVal_1 = _co.weekDays;
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = _co.dates;
        _ck(_v, 9, 0, currVal_2);
    }, null);
}
function View_NgxMyDatePicker_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 6, 'td', [['class',
                'monthcell tablesinglemonth'], ['tabindex', '0']], null, [[null,
                'click'], [null, 'keydown']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                (!_v.context.$implicit.disabled && _co.onMonthCellClicked(_v.context.$implicit));
                var pd_0 = ($event.stopPropagation() !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown' === en)) {
                var pd_1 = (_co.onMonthCellKeyDown($event, _v.context.$implicit) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'selectedmonth': 0, 'disabled': 1 }), (_l()(),
            core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'monthvalue']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'markcurrmonth': 0 }),
        (_l()(), core_es5["ɵted"](null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'monthcell tablesinglemonth';
        var currVal_1 = _ck(_v, 2, 0, _v.context.$implicit.selected, _v.context.$implicit.disabled);
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_2 = 'monthvalue';
        var currVal_3 = _ck(_v, 5, 0, (_v.context.$implicit.currMonth && _co.opts.markCurrentMonth));
        _ck(_v, 4, 0, currVal_2, currVal_3);
    }, function (_ck, _v) {
        var currVal_4 = _v.context.$implicit.name;
        _ck(_v, 6, 0, currVal_4);
    });
}
function View_NgxMyDatePicker_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'tr', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_NgxMyDatePicker_11)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_NgxMyDatePicker_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'table', [['class',
                'monthtable']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 2, 'tbody', [], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_NgxMyDatePicker_10)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.months;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_NgxMyDatePicker_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 6, 'td', [['class',
                'yearcell tablesingleyear'], ['tabindex', '0']], null, [[null,
                'click'], [null, 'keydown']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                (!_v.context.$implicit.disabled && _co.onYearCellClicked(_v.context.$implicit));
                var pd_0 = ($event.stopPropagation() !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown' === en)) {
                var pd_1 = (_co.onYearCellKeyDown($event, _v.context.$implicit) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'selectedyear': 0, 'disabled': 1 }), (_l()(),
            core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'yearvalue']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'markcurryear': 0 }),
        (_l()(), core_es5["ɵted"](null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'yearcell tablesingleyear';
        var currVal_1 = _ck(_v, 2, 0, _v.context.$implicit.selected, _v.context.$implicit.disabled);
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_2 = 'yearvalue';
        var currVal_3 = _ck(_v, 5, 0, (_v.context.$implicit.currYear && _co.opts.markCurrentYear));
        _ck(_v, 4, 0, currVal_2, currVal_3);
    }, function (_ck, _v) {
        var currVal_4 = _v.context.$implicit.year;
        _ck(_v, 6, 0, currVal_4);
    });
}
function View_NgxMyDatePicker_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'tr', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_NgxMyDatePicker_14)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_NgxMyDatePicker_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 13, 'table', [['class',
                'yeartable']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 12, 'tbody', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'td', [['class', 'yearchangebtncell'], ['colspan', '5']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = ($event.stopPropagation() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'yearchangebtn ngxmdpicon icon-ngxmydpup'], ['type',
                'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onPrevYears($event, _co.years[0][0].year) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'yearchangebtnenabled': 0,
            'yearchangebtndisabled': 1 }), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_NgxMyDatePicker_13)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'td', [['class',
                'yearchangebtncell'], ['colspan', '5']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = ($event.stopPropagation() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'yearchangebtn ngxmdpicon icon-ngxmydpdown'], ['type',
                'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onNextYears($event, _co.years[0][0].year) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'yearchangebtnenabled': 0,
            'yearchangebtndisabled': 1 })], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'yearchangebtn ngxmdpicon icon-ngxmydpup';
        var currVal_2 = _ck(_v, 6, 0, !_co.prevYearsDisabled, _co.prevYearsDisabled);
        _ck(_v, 5, 0, currVal_1, currVal_2);
        var currVal_3 = _co.years;
        _ck(_v, 8, 0, currVal_3);
        var currVal_5 = 'yearchangebtn ngxmdpicon icon-ngxmydpdown';
        var currVal_6 = _ck(_v, 13, 0, !_co.nextYearsDisabled, _co.nextYearsDisabled);
        _ck(_v, 12, 0, currVal_5, currVal_6);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.prevYearsDisabled;
        _ck(_v, 4, 0, currVal_0);
        var currVal_4 = _co.nextYearsDisabled;
        _ck(_v, 11, 0, currVal_4);
    });
}
function View_NgxMyDatePicker_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { selectorEl: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 48, 'div', [['class', 'ngxmdp']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, [[1, 0], ['selectorEl', 1]], null, 47, 'div', [['class', 'selector'], ['tabindex', '0']], null, [[null,
                'keyup']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('keyup' === en)) {
                var pd_0 = (_co.onCloseSelector($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'selectorarrow': 0, 'selectorarrowleft': 1,
            'selectorarrowright': 2 }), core_es5["ɵdid"](278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), core_es5["ɵpod"]({ 'width': 0,
            'height': 1, 'top': 2, 'left': 3 }), core_es5["ɵdid"](4210688, null, 0, ngx_my_date_picker_focus_directive["a" /* FocusDirective */], [core_es5["ElementRef"], core_es5["Renderer"]], { value: [0, 'value'] }, null), (_l()(), core_es5["ɵeld"](0, null, null, 35, 'table', [['class', 'header']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 34, 'tbody', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 33, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'td', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵeld"](0, null, null, 13, 'div', [['style', 'float:left']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'headerbtncell']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'headerbtn ngxmdpicon icon-ngxmydpleft'],
            ['type', 'button']], [[1, 'aria-label', 0], [8, 'disabled', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onPrevMonth() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'headerbtnenabled': 0, 'headerbtndisabled': 1 }),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'headermonthtxt']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['class', 'headerlabelbtn'],
            ['type', 'button']], [[8, 'tabIndex', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = ((_co.opts.monthSelector && _co.onSelectMonthClicked($event)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'monthlabel': 0, 'headerlabelbtnnotedit': 1 }),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'headerbtncell']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'headerbtn ngxmdpicon icon-ngxmydpright'], ['type', 'button']], [[1, 'aria-label', 0], [8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onNextMonth() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'headerbtnenabled': 0,
            'headerbtndisabled': 1 }), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_NgxMyDatePicker_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['style', 'float:right']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'headerbtncell']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'headerbtn ngxmdpicon icon-ngxmydpleft'], ['type', 'button']], [[1, 'aria-label', 0], [8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onPrevYear() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'headerbtnenabled': 0,
            'headerbtndisabled': 1 }), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'headeryeartxt']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['class', 'headerlabelbtn'], ['type', 'button']], [[8, 'tabIndex',
                0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = ((_co.opts.yearSelector && _co.onSelectYearClicked($event)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'yearlabel': 0,
            'headerlabelbtnnotedit': 1 }), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(),
            core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'headerbtncell']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'headerbtn ngxmdpicon icon-ngxmydpright'],
            ['type', 'button']], [[1, 'aria-label', 0], [8, 'disabled', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onNextYear() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'headerbtnenabled': 0, 'headerbtndisabled': 1 }),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_NgxMyDatePicker_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_NgxMyDatePicker_9)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_NgxMyDatePicker_12)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'selector';
        var currVal_1 = _ck(_v, 4, 0, _co.opts.showSelectorArrow, (_co.opts.showSelectorArrow && !_co.opts.alignSelectorRight), (_co.opts.showSelectorArrow && _co.opts.alignSelectorRight));
        _ck(_v, 3, 0, currVal_0, currVal_1);
        var currVal_2 = _ck(_v, 6, 0, _co.opts.selectorWidth, _co.opts.selectorHeight, _co.selectorPos.top, _co.selectorPos.left);
        _ck(_v, 5, 0, currVal_2);
        var currVal_3 = 1;
        _ck(_v, 7, 0, currVal_3);
        var currVal_6 = 'headerbtn ngxmdpicon icon-ngxmydpleft';
        var currVal_7 = _ck(_v, 16, 0, !_co.prevMonthDisabled, _co.prevMonthDisabled);
        _ck(_v, 15, 0, currVal_6, currVal_7);
        var currVal_9 = 'headerlabelbtn';
        var currVal_10 = _ck(_v, 20, 0, _co.opts.monthSelector, !_co.opts.monthSelector);
        _ck(_v, 19, 0, currVal_9, currVal_10);
        var currVal_14 = 'headerbtn ngxmdpicon icon-ngxmydpright';
        var currVal_15 = _ck(_v, 25, 0, !_co.nextMonthDisabled, _co.nextMonthDisabled);
        _ck(_v, 24, 0, currVal_14, currVal_15);
        var currVal_16 = _co.opts.showTodayBtn;
        _ck(_v, 28, 0, currVal_16);
        var currVal_19 = 'headerbtn ngxmdpicon icon-ngxmydpleft';
        var currVal_20 = _ck(_v, 34, 0, !_co.prevYearDisabled, _co.prevYearDisabled);
        _ck(_v, 33, 0, currVal_19, currVal_20);
        var currVal_22 = 'headerlabelbtn';
        var currVal_23 = _ck(_v, 38, 0, _co.opts.yearSelector, !_co.opts.yearSelector);
        _ck(_v, 37, 0, currVal_22, currVal_23);
        var currVal_27 = 'headerbtn ngxmdpicon icon-ngxmydpright';
        var currVal_28 = _ck(_v, 43, 0, !_co.nextYearDisabled, _co.nextYearDisabled);
        _ck(_v, 42, 0, currVal_27, currVal_28);
        var currVal_29 = (!_co.selectMonth && !_co.selectYear);
        _ck(_v, 45, 0, currVal_29);
        var currVal_30 = _co.selectMonth;
        _ck(_v, 47, 0, currVal_30);
        var currVal_31 = _co.selectYear;
        _ck(_v, 49, 0, currVal_31);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_4 = _co.opts.ariaLabelPrevMonth;
        var currVal_5 = _co.prevMonthDisabled;
        _ck(_v, 14, 0, currVal_4, currVal_5);
        var currVal_8 = core_es5["ɵinlineInterpolate"](1, '', (_co.opts.monthSelector ? '0' : '-1'), '');
        _ck(_v, 18, 0, currVal_8);
        var currVal_11 = _co.visibleMonth.monthTxt;
        _ck(_v, 21, 0, currVal_11);
        var currVal_12 = _co.opts.ariaLabelNextMonth;
        var currVal_13 = _co.nextMonthDisabled;
        _ck(_v, 23, 0, currVal_12, currVal_13);
        var currVal_17 = _co.opts.ariaLabelPrevYear;
        var currVal_18 = _co.prevYearDisabled;
        _ck(_v, 32, 0, currVal_17, currVal_18);
        var currVal_21 = core_es5["ɵinlineInterpolate"](1, '', (_co.opts.yearSelector ? '0' : '-1'), '');
        _ck(_v, 36, 0, currVal_21);
        var currVal_24 = _co.visibleMonth.year;
        _ck(_v, 39, 0, currVal_24);
        var currVal_25 = _co.opts.ariaLabelNextYear;
        var currVal_26 = _co.nextYearDisabled;
        _ck(_v, 41, 0, currVal_25, currVal_26);
    });
}
function View_NgxMyDatePicker_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'ngx-my-date-picker', [], null, null, null, View_NgxMyDatePicker_0, RenderType_NgxMyDatePicker)), core_es5["ɵprd"](512, null, ngx_my_date_picker_util_service["a" /* UtilService */], ngx_my_date_picker_util_service["a" /* UtilService */], []), core_es5["ɵdid"](49152, null, 0, ngx_my_date_picker_component["a" /* NgxMyDatePicker */], [core_es5["ElementRef"],
            core_es5["Renderer"], core_es5["ChangeDetectorRef"], ngx_my_date_picker_util_service["a" /* UtilService */]], null, null)], null, null);
}
var NgxMyDatePickerNgFactory = core_es5["ɵccf"]('ngx-my-date-picker', ngx_my_date_picker_component["a" /* NgxMyDatePicker */], View_NgxMyDatePicker_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=ngx-my-date-picker.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/ngx-tooltip/TooltipContent.js
var TooltipContent = __webpack_require__("WavH");
var TooltipContent_default = /*#__PURE__*/__webpack_require__.n(TooltipContent);

// CONCATENATED MODULE: ./compiled/node_modules/ngx-tooltip/TooltipContent.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


var styles_TooltipContent = [];
var RenderType_TooltipContent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_TooltipContent, data: {} });
function View_TooltipContent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, ['\n'])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['role', 'tooltip']], [[8, 'className', 0], [4, 'top', null],
            [4, 'left', null], [2, 'in', null], [2, 'fade', null]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'tooltip-arrow']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' \n    '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'tooltip-inner']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n        '])), core_es5["ɵncd"](null, 0), (_l()(), core_es5["ɵted"](null, ['\n        ', '\n    '])), (_l()(), core_es5["ɵted"](null, [' \n'])), (_l()(),
            core_es5["ɵted"](null, ['\n']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, 'tooltip ', _co.placement, '');
        var currVal_1 = (_co.top + 'px');
        var currVal_2 = (_co.left + 'px');
        var currVal_3 = _co.isIn;
        var currVal_4 = _co.isFade;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4);
        var currVal_5 = _co.content;
        _ck(_v, 8, 0, currVal_5);
    });
}
function View_TooltipContent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'tooltip-content', [], null, null, null, View_TooltipContent_0, RenderType_TooltipContent)), core_es5["ɵdid"](4243456, null, 0, TooltipContent["TooltipContent"], [core_es5["ElementRef"], core_es5["ChangeDetectorRef"]], null, null)], null, null);
}
var TooltipContentNgFactory = core_es5["ɵccf"]('tooltip-content', TooltipContent["TooltipContent"], View_TooltipContent_Host_0, { hostElement: 'hostElement', content: 'content',
    placement: 'placement', animation: 'animation' }, {}, ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL25neC10b29sdGlwL1Rvb2x0aXBDb250ZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL25vZGVfbW9kdWxlcy9uZ3gtdG9vbHRpcC9Ub29sdGlwQ29udGVudC5kLnRzIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL25neC10b29sdGlwL1Rvb2x0aXBDb250ZW50LmQudHMuVG9vbHRpcENvbnRlbnQuaHRtbCIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL25vZGVfbW9kdWxlcy9uZ3gtdG9vbHRpcC9Ub29sdGlwQ29udGVudC5kLnRzLlRvb2x0aXBDb250ZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG48ZGl2IGNsYXNzPVwidG9vbHRpcCB7eyBwbGFjZW1lbnQgfX1cIlxuICAgICBbc3R5bGUudG9wXT1cInRvcCArICdweCdcIlxuICAgICBbc3R5bGUubGVmdF09XCJsZWZ0ICsgJ3B4J1wiXG4gICAgIFtjbGFzcy5pbl09XCJpc0luXCJcbiAgICAgW2NsYXNzLmZhZGVdPVwiaXNGYWRlXCJcbiAgICAgcm9sZT1cInRvb2x0aXBcIj5cbiAgICA8ZGl2IGNsYXNzPVwidG9vbHRpcC1hcnJvd1wiPjwvZGl2PiBcbiAgICA8ZGl2IGNsYXNzPVwidG9vbHRpcC1pbm5lclwiPlxuICAgICAgICA8bmctY29udGVudD48L25nLWNvbnRlbnQ+XG4gICAgICAgIHt7IGNvbnRlbnQgfX1cbiAgICA8L2Rpdj4gXG48L2Rpdj5cbiIsIjx0b29sdGlwLWNvbnRlbnQ+PC90b29sdGlwLWNvbnRlbnQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7b0JDQUEsdUNBQ0E7TUFBQTtVQUFBO01BQUEsMERBS29CO01BQUEsYUFDaEI7TUFBQTtNQUFpQyw0Q0FDakM7VUFBQTtVQUFBLDRDQUEyQjtVQUFBLHdCQUN2QixrQkFBeUI7VUFBQSwwQkFFdkIsd0NBQ0o7aUJBQUE7O0lBWEQ7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUpMLFdBQUssVUFDQSxVQUNBLFVBQ0EsVUFDQSxTQUpMO0lBUWlDO0lBQUE7Ozs7b0JDVGpDO01BQUE7K0JBQUEsVUFBQTtNQUFBOzs7OzsifQ==
//# sourceMappingURL=TooltipContent.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/theme/css/select.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.bootstrap-select .btn{text-transform:none;font-size:14px}.select2-container--open .select2-dropdown--above{border-bottom:1px solid #aaa!important}.form-group.select2 .help-block{display:block}.font-size-12{font-size:12px}.blue-grey-400{color:#a3afb7!important}.bg-blue-grey-100{background-color:#f3f7f9!important}.bg-blue-grey-400{background-color:#a3afb7!important}.wrapper-transparent{background-color:rgba(0,0,0,.4)!important;position:absolute;top:0;left:0;width:100%;height:100%}.wrapper-transparent h3{color:#fff;margin-top:15px!important}.select2-results .list-group-item{text-align:left;border:none!important;padding:10px;cursor:pointer}.select2-results label{font-weight:400;font-size:16px}.select2-results .select2-results__option--highlighted[aria-selected] .list-group-item,.select2-results label{color:#76838f}.select2-container--default .select2-results>.select2-results__options{max-height:340px!important}.select2-container--default .select2-selection--single{border-radius:3px;height:36px!important}.select2-container--default .select2-selection--single label{color:#76838f;font-weight:400;font-size:16px}.select2-container--default .select2-selection--single .select2-selection__rendered{color:#76838f;line-height:36px!important}.select2-container--default .select2-results__option--highlighted[aria-selected]{background-color:#e07e3c}.select2-results__options .checkbox-primary input[type=checkbox]:checked+label:after,.select2-results__options .checkbox-primary input[type=radio]:checked+label:after{content:""}#brands-list .select2-container{z-index:9999}#brands-list .select2-container--default .select2-results__option--highlighted[aria-selected]{background-color:#fff!important}#brands-list .select2-container--default .select2-results__option[aria-selected=true]{background-color:#fff}#brands-list .select2-container--default .select2-selection--single .select2-selection__arrow b{border:none;margin-left:-10px;margin-top:-6px}#brands-list .select2-container--default .select2-selection--single .select2-selection__arrow b:after{font:normal normal normal 18px/1 FontAwesome;color:#777;content:"\\F002"}#brands-list input.select2-search__field{border-radius:3px}#brands-list input.select2-search__field::-webkit-input-placeholder{color:#999}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvdGhlbWUvY3NzL3NlbGVjdC5jc3MubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL3RoZW1lL2Nzcy9zZWxlY3QuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=select.css.ngstyle.js.map
// CONCATENATED MODULE: ./compiled/node_modules/select2/dist/css/select2.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var select2_css_ngstyle_styles = ['.select2-container{box-sizing:border-box;display:inline-block;margin:0;position:relative;vertical-align:middle}.select2-container .select2-selection--single{box-sizing:border-box;cursor:pointer;display:block;height:28px;user-select:none;-webkit-user-select:none}.select2-container .select2-selection--single .select2-selection__rendered{display:block;padding-left:8px;padding-right:20px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.select2-container .select2-selection--single .select2-selection__clear{position:relative}.select2-container[dir=rtl] .select2-selection--single .select2-selection__rendered{padding-right:8px;padding-left:20px}.select2-container .select2-selection--multiple{box-sizing:border-box;cursor:pointer;display:block;min-height:32px;user-select:none;-webkit-user-select:none}.select2-container .select2-selection--multiple .select2-selection__rendered{display:inline-block;overflow:hidden;padding-left:8px;text-overflow:ellipsis;white-space:nowrap}.select2-container .select2-search--inline{float:left}.select2-container .select2-search--inline .select2-search__field{box-sizing:border-box;border:none;font-size:100%;margin-top:5px;padding:0}.select2-container .select2-search--inline .select2-search__field::-webkit-search-cancel-button{-webkit-appearance:none}.select2-dropdown{background-color:#fff;border:1px solid #aaa;border-radius:4px;box-sizing:border-box;display:block;position:absolute;left:-100000px;width:100%;z-index:1051}.select2-results{display:block}.select2-results__options{list-style:none;margin:0;padding:0}.select2-results__option{padding:6px;user-select:none;-webkit-user-select:none}.select2-results__option[aria-selected]{cursor:pointer}.select2-container--open .select2-dropdown{left:0}.select2-container--open .select2-dropdown--above{border-bottom:none;border-bottom-left-radius:0;border-bottom-right-radius:0}.select2-container--open .select2-dropdown--below{border-top:none;border-top-left-radius:0;border-top-right-radius:0}.select2-search--dropdown{display:block;padding:4px}.select2-search--dropdown .select2-search__field{padding:4px;width:100%;box-sizing:border-box}.select2-search--dropdown .select2-search__field::-webkit-search-cancel-button{-webkit-appearance:none}.select2-search--dropdown.select2-search--hide{display:none}.select2-close-mask{border:0;margin:0;padding:0;display:block;position:fixed;left:0;top:0;min-height:100%;min-width:100%;height:auto;width:auto;opacity:0;z-index:99;background-color:#fff;filter:alpha(opacity=0)}.select2-hidden-accessible{border:0!important;clip:rect(0 0 0 0)!important;height:1px!important;margin:-1px!important;overflow:hidden!important;padding:0!important;position:absolute!important;width:1px!important}.select2-container--default .select2-selection--single{background-color:#fff;border:1px solid #aaa;border-radius:4px}.select2-container--default .select2-selection--single .select2-selection__rendered{color:#444;line-height:28px}.select2-container--default .select2-selection--single .select2-selection__clear{cursor:pointer;float:right;font-weight:700}.select2-container--default .select2-selection--single .select2-selection__placeholder{color:#999}.select2-container--default .select2-selection--single .select2-selection__arrow{height:26px;position:absolute;top:1px;right:1px;width:20px}.select2-container--default .select2-selection--single .select2-selection__arrow b{border-color:#888 transparent transparent;border-style:solid;border-width:5px 4px 0;height:0;left:50%;margin-left:-4px;margin-top:-2px;position:absolute;top:50%;width:0}.select2-container--default[dir=rtl] .select2-selection--single .select2-selection__clear{float:left}.select2-container--default[dir=rtl] .select2-selection--single .select2-selection__arrow{left:1px;right:auto}.select2-container--default.select2-container--disabled .select2-selection--single{background-color:#eee;cursor:default}.select2-container--default.select2-container--disabled .select2-selection--single .select2-selection__clear{display:none}.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b{border-color:transparent transparent #888;border-width:0 4px 5px}.select2-container--default .select2-selection--multiple{background-color:#fff;border:1px solid #aaa;border-radius:4px;cursor:text}.select2-container--default .select2-selection--multiple .select2-selection__rendered{box-sizing:border-box;list-style:none;margin:0;padding:0 5px;width:100%}.select2-container--default .select2-selection--multiple .select2-selection__rendered li{list-style:none}.select2-container--default .select2-selection--multiple .select2-selection__placeholder{color:#999;margin-top:5px;float:left}.select2-container--default .select2-selection--multiple .select2-selection__clear{cursor:pointer;float:right;font-weight:700;margin-top:5px;margin-right:10px}.select2-container--default .select2-selection--multiple .select2-selection__choice{background-color:#e4e4e4;border:1px solid #aaa;border-radius:4px;cursor:default;float:left;margin-right:5px;margin-top:5px;padding:0 5px}.select2-container--default .select2-selection--multiple .select2-selection__choice__remove{color:#999;cursor:pointer;display:inline-block;font-weight:700;margin-right:2px}.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:hover{color:#333}.select2-container--default[dir=rtl] .select2-selection--multiple .select2-search--inline,.select2-container--default[dir=rtl] .select2-selection--multiple .select2-selection__choice,.select2-container--default[dir=rtl] .select2-selection--multiple .select2-selection__placeholder{float:right}.select2-container--default[dir=rtl] .select2-selection--multiple .select2-selection__choice{margin-left:5px;margin-right:auto}.select2-container--default[dir=rtl] .select2-selection--multiple .select2-selection__choice__remove{margin-left:2px;margin-right:auto}.select2-container--default.select2-container--focus .select2-selection--multiple{border:1px solid #000;outline:0}.select2-container--default.select2-container--disabled .select2-selection--multiple{background-color:#eee;cursor:default}.select2-container--default.select2-container--disabled .select2-selection__choice__remove{display:none}.select2-container--default.select2-container--open.select2-container--above .select2-selection--multiple,.select2-container--default.select2-container--open.select2-container--above .select2-selection--single{border-top-left-radius:0;border-top-right-radius:0}.select2-container--default.select2-container--open.select2-container--below .select2-selection--multiple,.select2-container--default.select2-container--open.select2-container--below .select2-selection--single{border-bottom-left-radius:0;border-bottom-right-radius:0}.select2-container--default .select2-search--dropdown .select2-search__field{border:1px solid #aaa}.select2-container--default .select2-search--inline .select2-search__field{background:transparent;border:none;outline:0;box-shadow:none;-webkit-appearance:textfield}.select2-container--default .select2-results>.select2-results__options{max-height:200px;overflow-y:auto}.select2-container--default .select2-results__option[role=group]{padding:0}.select2-container--default .select2-results__option[aria-disabled=true]{color:#999}.select2-container--default .select2-results__option[aria-selected=true]{background-color:#ddd}.select2-container--default .select2-results__option .select2-results__option{padding-left:1em}.select2-container--default .select2-results__option .select2-results__option .select2-results__group{padding-left:0}.select2-container--default .select2-results__option .select2-results__option .select2-results__option{margin-left:-1em;padding-left:2em}.select2-container--default .select2-results__option .select2-results__option .select2-results__option .select2-results__option{margin-left:-2em;padding-left:3em}.select2-container--default .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option{margin-left:-3em;padding-left:4em}.select2-container--default .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option{margin-left:-4em;padding-left:5em}.select2-container--default .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option{margin-left:-5em;padding-left:6em}.select2-container--default .select2-results__option--highlighted[aria-selected]{background-color:#5897fb;color:#fff}.select2-container--default .select2-results__group{cursor:default;display:block;padding:6px}.select2-container--classic .select2-selection--single{background-color:#f7f7f7;border:1px solid #aaa;border-radius:4px;outline:0;background-image:-webkit-linear-gradient(top,#fff 50%,#eee);background-image:-o-linear-gradient(top,#fff 50%,#eee 100%);background-image:linear-gradient(180deg,#fff 50%,#eee);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr="#FFFFFFFF",endColorstr="#FFEEEEEE",GradientType=0)}.select2-container--classic .select2-selection--single:focus{border:1px solid #5897fb}.select2-container--classic .select2-selection--single .select2-selection__rendered{color:#444;line-height:28px}.select2-container--classic .select2-selection--single .select2-selection__clear{cursor:pointer;float:right;font-weight:700;margin-right:10px}.select2-container--classic .select2-selection--single .select2-selection__placeholder{color:#999}.select2-container--classic .select2-selection--single .select2-selection__arrow{background-color:#ddd;border:none;border-left:1px solid #aaa;border-top-right-radius:4px;border-bottom-right-radius:4px;height:26px;position:absolute;top:1px;right:1px;width:20px;background-image:-webkit-linear-gradient(top,#eee 50%,#ccc);background-image:-o-linear-gradient(top,#eee 50%,#ccc 100%);background-image:linear-gradient(180deg,#eee 50%,#ccc);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr="#FFEEEEEE",endColorstr="#FFCCCCCC",GradientType=0)}.select2-container--classic .select2-selection--single .select2-selection__arrow b{border-color:#888 transparent transparent;border-style:solid;border-width:5px 4px 0;height:0;left:50%;margin-left:-4px;margin-top:-2px;position:absolute;top:50%;width:0}.select2-container--classic[dir=rtl] .select2-selection--single .select2-selection__clear{float:left}.select2-container--classic[dir=rtl] .select2-selection--single .select2-selection__arrow{border:none;border-right:1px solid #aaa;border-radius:0;border-top-left-radius:4px;border-bottom-left-radius:4px;left:1px;right:auto}.select2-container--classic.select2-container--open .select2-selection--single{border:1px solid #5897fb}.select2-container--classic.select2-container--open .select2-selection--single .select2-selection__arrow{background:transparent;border:none}.select2-container--classic.select2-container--open .select2-selection--single .select2-selection__arrow b{border-color:transparent transparent #888;border-width:0 4px 5px}.select2-container--classic.select2-container--open.select2-container--above .select2-selection--single{border-top:none;border-top-left-radius:0;border-top-right-radius:0;background-image:-webkit-linear-gradient(top,#fff,#eee 50%);background-image:-o-linear-gradient(top,#fff 0,#eee 50%);background-image:linear-gradient(180deg,#fff 0,#eee 50%);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr="#FFFFFFFF",endColorstr="#FFEEEEEE",GradientType=0)}.select2-container--classic.select2-container--open.select2-container--below .select2-selection--single{border-bottom:none;border-bottom-left-radius:0;border-bottom-right-radius:0;background-image:-webkit-linear-gradient(top,#eee 50%,#fff);background-image:-o-linear-gradient(top,#eee 50%,#fff 100%);background-image:linear-gradient(180deg,#eee 50%,#fff);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr="#FFEEEEEE",endColorstr="#FFFFFFFF",GradientType=0)}.select2-container--classic .select2-selection--multiple{background-color:#fff;border:1px solid #aaa;border-radius:4px;cursor:text;outline:0}.select2-container--classic .select2-selection--multiple:focus{border:1px solid #5897fb}.select2-container--classic .select2-selection--multiple .select2-selection__rendered{list-style:none;margin:0;padding:0 5px}.select2-container--classic .select2-selection--multiple .select2-selection__clear{display:none}.select2-container--classic .select2-selection--multiple .select2-selection__choice{background-color:#e4e4e4;border:1px solid #aaa;border-radius:4px;cursor:default;float:left;margin-right:5px;margin-top:5px;padding:0 5px}.select2-container--classic .select2-selection--multiple .select2-selection__choice__remove{color:#888;cursor:pointer;display:inline-block;font-weight:700;margin-right:2px}.select2-container--classic .select2-selection--multiple .select2-selection__choice__remove:hover{color:#555}.select2-container--classic[dir=rtl] .select2-selection--multiple .select2-selection__choice{float:right;margin-left:5px;margin-right:auto}.select2-container--classic[dir=rtl] .select2-selection--multiple .select2-selection__choice__remove{margin-left:2px;margin-right:auto}.select2-container--classic.select2-container--open .select2-selection--multiple{border:1px solid #5897fb}.select2-container--classic.select2-container--open.select2-container--above .select2-selection--multiple{border-top:none;border-top-left-radius:0;border-top-right-radius:0}.select2-container--classic.select2-container--open.select2-container--below .select2-selection--multiple{border-bottom:none;border-bottom-left-radius:0;border-bottom-right-radius:0}.select2-container--classic .select2-search--dropdown .select2-search__field{border:1px solid #aaa;outline:0}.select2-container--classic .select2-search--inline .select2-search__field{outline:0;box-shadow:none}.select2-container--classic .select2-dropdown{background-color:#fff;border:1px solid transparent}.select2-container--classic .select2-dropdown--above{border-bottom:none}.select2-container--classic .select2-dropdown--below{border-top:none}.select2-container--classic .select2-results>.select2-results__options{max-height:200px;overflow-y:auto}.select2-container--classic .select2-results__option[role=group]{padding:0}.select2-container--classic .select2-results__option[aria-disabled=true]{color:grey}.select2-container--classic .select2-results__option--highlighted[aria-selected]{background-color:#3875d7;color:#fff}.select2-container--classic .select2-results__group{cursor:default;display:block;padding:6px}.select2-container--classic.select2-container--open .select2-dropdown{border-color:#5897fb}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL3NlbGVjdDIvZGlzdC9jc3Mvc2VsZWN0Mi5jc3MubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL25vZGVfbW9kdWxlcy9zZWxlY3QyL2Rpc3QvY3NzL3NlbGVjdDIuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=select2.css.ngstyle.js.map
// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/index.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var index_css_ngstyle_styles = ['.ngx-datatable{display:block;overflow:hidden;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;-webkit-transform:translateZ(0)}.ngx-datatable [hidden]{display:none!important}.ngx-datatable *,.ngx-datatable :after,.ngx-datatable :before{-webkit-box-sizing:border-box;box-sizing:border-box}.ngx-datatable.scroll-vertical .datatable-body{overflow-y:auto}.ngx-datatable.scroll-vertical .datatable-body .datatable-row-wrapper{position:absolute}.ngx-datatable.scroll-horz .datatable-body{overflow-x:auto;-webkit-overflow-scrolling:touch}.ngx-datatable.fixed-header .datatable-header .datatable-header-inner{white-space:nowrap}.ngx-datatable.fixed-header .datatable-header .datatable-header-inner .datatable-header-cell{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ngx-datatable.fixed-row .datatable-scroll,.ngx-datatable.fixed-row .datatable-scroll .datatable-body-row{white-space:nowrap}.ngx-datatable.fixed-row .datatable-scroll .datatable-body-row .datatable-body-cell,.ngx-datatable.fixed-row .datatable-scroll .datatable-body-row .datatable-body-group-cell{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ngx-datatable .datatable-body-row,.ngx-datatable .datatable-header-inner,.ngx-datatable .datatable-row-center{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-flow:row;-o-flex-flow:row;flex-flow:row}.ngx-datatable .datatable-body-cell,.ngx-datatable .datatable-header-cell{overflow-x:hidden;vertical-align:top;display:inline-block;line-height:1.625}.ngx-datatable .datatable-body-cell:focus,.ngx-datatable .datatable-header-cell:focus{outline:none}.ngx-datatable .datatable-row-left,.ngx-datatable .datatable-row-right{z-index:9}.ngx-datatable .datatable-row-center,.ngx-datatable .datatable-row-group,.ngx-datatable .datatable-row-left,.ngx-datatable .datatable-row-right{position:relative}.ngx-datatable .datatable-header{display:block;overflow:hidden}.ngx-datatable .datatable-header .datatable-header-inner{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-align-items:stretch}.ngx-datatable .datatable-header .datatable-header-cell{position:relative;display:inline-block}.ngx-datatable .datatable-header .datatable-header-cell.sortable .datatable-header-cell-wrapper{cursor:pointer}.ngx-datatable .datatable-header .datatable-header-cell.longpress .datatable-header-cell-wrapper{cursor:move}.ngx-datatable .datatable-header .datatable-header-cell .sort-btn{line-height:100%;vertical-align:middle;display:inline-block;cursor:pointer}.ngx-datatable .datatable-header .datatable-header-cell .resize-handle,.ngx-datatable .datatable-header .datatable-header-cell .resize-handle--not-resizable{display:inline-block;position:absolute;right:0;top:0;bottom:0;width:5px;padding:0 4px;visibility:hidden}.ngx-datatable .datatable-header .datatable-header-cell .resize-handle{cursor:ew-resize}.ngx-datatable .datatable-header .datatable-header-cell.resizeable:hover .resize-handle,.ngx-datatable .datatable-header .datatable-header-cell:hover .resize-handle--not-resizable{visibility:visible}.ngx-datatable .datatable-header .datatable-header-cell .datatable-header-cell-template-wrap{height:inherit}.ngx-datatable .datatable-body{position:relative;z-index:10;display:block}.ngx-datatable .datatable-body .datatable-scroll{display:inline-block}.ngx-datatable .datatable-body .datatable-row-detail{overflow-y:hidden}.ngx-datatable .datatable-body .datatable-row-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ngx-datatable .datatable-body .datatable-body-row{outline:none}.ngx-datatable .datatable-body .datatable-body-row>div{display:-webkit-box;display:-ms-flexbox;display:flex}.ngx-datatable .datatable-footer{display:block;width:100%}.ngx-datatable .datatable-footer .datatable-footer-inner{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}.ngx-datatable .datatable-footer .selected-count .page-count{-webkit-box-flex:1;-ms-flex:1 1 40%;flex:1 1 40%}.ngx-datatable .datatable-footer .selected-count .datatable-pager{-webkit-box-flex:1;-ms-flex:1 1 60%;flex:1 1 60%}.ngx-datatable .datatable-footer .page-count{-webkit-box-flex:1;-ms-flex:1 1 20%;flex:1 1 20%}.ngx-datatable .datatable-footer .datatable-pager{-webkit-box-flex:1;-ms-flex:1 1 80%;flex:1 1 80%;text-align:right}.ngx-datatable .datatable-footer .datatable-pager .pager,.ngx-datatable .datatable-footer .datatable-pager .pager li{padding:0;margin:0;display:inline-block;list-style:none}.ngx-datatable .datatable-footer .datatable-pager .pager li,.ngx-datatable .datatable-footer .datatable-pager .pager li a{outline:none}.ngx-datatable .datatable-footer .datatable-pager .pager li a{cursor:pointer;display:inline-block}.ngx-datatable .datatable-footer .datatable-pager .pager li.disabled a{cursor:not-allowed}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvaW5kZXguY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9pbmRleC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=index.css.ngstyle.js.map
// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/assets/icons.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var icons_css_ngstyle_styles = ['@font-face{font-family:data-table;src:url(assets/data-table.bce071e976865da511003c50333620c5.eot);src:url(assets/data-table.bce071e976865da511003c50333620c5.eot?#iefix) format("embedded-opentype"),url(assets/data-table.246ea8fa6c452b0f3c4fdd23e955e165.woff) format("woff"),url(assets/data-table.c8c6d300cb7abb9f36e8cff3c58f584d.ttf) format("truetype"),url(assets/data-table.b0aebd744ce7adb780a9342fd395535e.svg#data-table) format("svg");font-weight:400;font-style:normal}[data-icon]:before{content:attr(data-icon)}[class*=" datatable-icon-"]:before,[class^=datatable-icon-]:before,[data-icon]:before{font-family:data-table!important;font-style:normal!important;font-weight:400!important;font-variant:normal!important;text-transform:none!important;speak:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.datatable-icon-filter:before{content:"b"}.datatable-icon-collapse:before{content:"a"}.datatable-icon-expand:before{content:"c"}.datatable-icon-close:before{content:"d"}.datatable-icon-up:before{content:"e"}.datatable-icon-down:before{content:"f"}.datatable-icon-sort:before{content:"g"}.datatable-icon-done:before{content:"h"}.datatable-icon-done-all:before{content:"i"}.datatable-icon-search:before{content:"j"}.datatable-icon-pin:before{content:"k"}.datatable-icon-add:before{content:"m"}.datatable-icon-left:before{content:"o"}.datatable-icon-right:before{content:"p"}.datatable-icon-skip:before{content:"q"}.datatable-icon-prev:before{content:"r"}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvYXNzZXRzL2ljb25zLmNzcy5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvYXNzZXRzL2ljb25zLmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=icons.css.ngstyle.js.map
// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/themes/material.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var material_css_ngstyle_styles = ['.ngx-datatable.material{background:#fff;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.ngx-datatable.material.striped .datatable-row-odd{background:#eee}.ngx-datatable.material.multi-click-selection .datatable-body-row.active,.ngx-datatable.material.multi-click-selection .datatable-body-row.active .datatable-row-group,.ngx-datatable.material.multi-selection .datatable-body-row.active,.ngx-datatable.material.multi-selection .datatable-body-row.active .datatable-row-group,.ngx-datatable.material.single-selection .datatable-body-row.active,.ngx-datatable.material.single-selection .datatable-body-row.active .datatable-row-group{background-color:#304ffe;color:#fff}.ngx-datatable.material.multi-click-selection .datatable-body-row.active:hover,.ngx-datatable.material.multi-click-selection .datatable-body-row.active:hover .datatable-row-group,.ngx-datatable.material.multi-selection .datatable-body-row.active:hover,.ngx-datatable.material.multi-selection .datatable-body-row.active:hover .datatable-row-group,.ngx-datatable.material.single-selection .datatable-body-row.active:hover,.ngx-datatable.material.single-selection .datatable-body-row.active:hover .datatable-row-group{background-color:#193ae4;color:#fff}.ngx-datatable.material.multi-click-selection .datatable-body-row.active:focus,.ngx-datatable.material.multi-click-selection .datatable-body-row.active:focus .datatable-row-group,.ngx-datatable.material.multi-selection .datatable-body-row.active:focus,.ngx-datatable.material.multi-selection .datatable-body-row.active:focus .datatable-row-group,.ngx-datatable.material.single-selection .datatable-body-row.active:focus,.ngx-datatable.material.single-selection .datatable-body-row.active:focus .datatable-row-group{background-color:#2041ef;color:#fff}.ngx-datatable.material:not(.cell-selection) .datatable-body-row:hover,.ngx-datatable.material:not(.cell-selection) .datatable-body-row:hover .datatable-row-group{background-color:#eee;transition-property:background;transition-duration:.3s;transition-timing-function:linear}.ngx-datatable.material:not(.cell-selection) .datatable-body-row:focus,.ngx-datatable.material:not(.cell-selection) .datatable-body-row:focus .datatable-row-group{background-color:#ddd}.ngx-datatable.material.cell-selection .datatable-body-cell:hover,.ngx-datatable.material.cell-selection .datatable-body-cell:hover .datatable-row-group{background-color:#eee;transition-property:background;transition-duration:.3s;transition-timing-function:linear}.ngx-datatable.material.cell-selection .datatable-body-cell:focus,.ngx-datatable.material.cell-selection .datatable-body-cell:focus .datatable-row-group{background-color:#ddd}.ngx-datatable.material.cell-selection .datatable-body-cell.active,.ngx-datatable.material.cell-selection .datatable-body-cell.active .datatable-row-group{background-color:#304ffe;color:#fff}.ngx-datatable.material.cell-selection .datatable-body-cell.active:hover,.ngx-datatable.material.cell-selection .datatable-body-cell.active:hover .datatable-row-group{background-color:#193ae4;color:#fff}.ngx-datatable.material.cell-selection .datatable-body-cell.active:focus,.ngx-datatable.material.cell-selection .datatable-body-cell.active:focus .datatable-row-group{background-color:#2041ef;color:#fff}.ngx-datatable.material .empty-row{height:50px}.ngx-datatable.material .empty-row,.ngx-datatable.material .loading-row{text-align:left;padding:.5rem 1.2rem;vertical-align:top;border-top:0}.ngx-datatable.material .datatable-body .datatable-row-left,.ngx-datatable.material .datatable-header .datatable-row-left{background-color:#fff;background-position:100% 0;background-repeat:repeat-y;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAABCAYAAAD5PA/NAAAAFklEQVQIHWPSkNeSBmJhTQVtbiDNCgASagIIuJX8OgAAAABJRU5ErkJggg==)}.ngx-datatable.material .datatable-body .datatable-row-right,.ngx-datatable.material .datatable-header .datatable-row-right{background-position:0 0;background-color:#fff;background-repeat:repeat-y;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAABCAYAAAD5PA/NAAAAFklEQVQI12PQkNdi1VTQ5gbSwkAsDQARLAIGtOSFUAAAAABJRU5ErkJggg==)}.ngx-datatable.material .datatable-header{border-bottom:1px solid rgba(0,0,0,.12)}.ngx-datatable.material .datatable-header .datatable-header-cell{text-align:left;padding:.9rem 1.2rem;font-weight:400;color:rgba(0,0,0,.54);vertical-align:bottom;font-size:12px;font-weight:500}.ngx-datatable.material .datatable-header .datatable-header-cell .datatable-header-cell-wrapper{position:relative}.ngx-datatable.material .datatable-header .datatable-header-cell.longpress .draggable:after{transition:transform .4s ease,opacity .4s ease;opacity:.5;transform:scale(1)}.ngx-datatable.material .datatable-header .datatable-header-cell .draggable:after{content:" ";position:absolute;top:50%;left:50%;margin:-30px 0 0 -30px;height:60px;width:60px;background:#eee;border-radius:100%;opacity:1;filter:none;transform:scale(0);z-index:9999;pointer-events:none}.ngx-datatable.material .datatable-header .datatable-header-cell.dragging .resize-handle{border-right:none}.ngx-datatable.material .datatable-header .resize-handle{border-right:1px solid #eee}.ngx-datatable.material .datatable-body .datatable-row-detail{background:#f5f5f5;padding:10px}.ngx-datatable.material .datatable-body .datatable-group-header{background:#f5f5f5;border-bottom:1px solid #d9d8d9;border-top:1px solid #d9d8d9}.ngx-datatable.material .datatable-body .datatable-body-row .datatable-body-cell,.ngx-datatable.material .datatable-body .datatable-body-row .datatable-body-group-cell{text-align:left;padding:.9rem 1.2rem;vertical-align:top;border-top:0;color:rgba(0,0,0,.87);transition:width .3s ease;font-size:14px;font-weight:400}.ngx-datatable.material .datatable-body .progress-linear{display:block;position:relative;width:100%;height:5px;padding:0;margin:0;position:absolute}.ngx-datatable.material .datatable-body .progress-linear .container{display:block;position:relative;overflow:hidden;width:100%;height:5px;-webkit-transform:translate(0) scale(1);transform:translate(0) scale(1);background-color:#aad1f9}.ngx-datatable.material .datatable-body .progress-linear .container .bar{transition:all .2s linear;-webkit-animation:query .8s infinite cubic-bezier(.39,.575,.565,1);animation:query .8s infinite cubic-bezier(.39,.575,.565,1);transition:-webkit-transform .2s linear;transition:transform .2s linear;background-color:#106cc8;position:absolute;left:0;top:0;bottom:0;width:100%;height:5px}.ngx-datatable.material .datatable-footer{border-top:1px solid rgba(0,0,0,.12);font-size:12px;font-weight:400;color:rgba(0,0,0,.54)}.ngx-datatable.material .datatable-footer .page-count{line-height:50px;height:50px;padding:0 1.2rem}.ngx-datatable.material .datatable-footer .datatable-pager{margin:0 10px}.ngx-datatable.material .datatable-footer .datatable-pager li{vertical-align:middle}.ngx-datatable.material .datatable-footer .datatable-pager li.disabled a{color:rgba(0,0,0,.26)!important;background-color:transparent!important}.ngx-datatable.material .datatable-footer .datatable-pager li.active a{background-color:hsla(0,0%,62%,.2);font-weight:700}.ngx-datatable.material .datatable-footer .datatable-pager a{height:22px;min-width:24px;line-height:22px;padding:0 6px;border-radius:3px;margin:6px 3px;text-align:center;vertical-align:top;color:rgba(0,0,0,.54);text-decoration:none;vertical-align:bottom}.ngx-datatable.material .datatable-footer .datatable-pager a:hover{color:rgba(0,0,0,.75);background-color:hsla(0,0%,62%,.2)}.ngx-datatable.material .datatable-footer .datatable-pager .datatable-icon-left,.ngx-datatable.material .datatable-footer .datatable-pager .datatable-icon-prev,.ngx-datatable.material .datatable-footer .datatable-pager .datatable-icon-right,.ngx-datatable.material .datatable-footer .datatable-pager .datatable-icon-skip{font-size:20px;line-height:20px;padding:0 3px}.ngx-datatable.material .datatable-summary-row .datatable-body-row,.ngx-datatable.material .datatable-summary-row .datatable-body-row:hover{background-color:#ddd}.ngx-datatable.material .datatable-summary-row .datatable-body-row .datatable-body-cell{font-weight:700}.datatable-checkbox{position:relative;margin:0;cursor:pointer;vertical-align:middle;display:inline-block;box-sizing:border-box;padding:0}.datatable-checkbox input[type=checkbox]{position:relative;margin:0 1rem 0 0;cursor:pointer;outline:none}.datatable-checkbox input[type=checkbox]:before{-webkit-transition:all .3s ease-in-out;-moz-transition:all .3s ease-in-out;transition:all .3s ease-in-out;content:"";position:absolute;left:0;z-index:1;width:1rem;height:1rem;border:2px solid #f2f2f2}.datatable-checkbox input[type=checkbox]:checked:before{-webkit-transform:rotate(-45deg);-moz-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg);height:.5rem;border-color:#009688;border-top-style:none;border-right-style:none}.datatable-checkbox input[type=checkbox]:after{content:"";position:absolute;top:0;left:0;width:1rem;height:1rem;background:#fff;cursor:pointer}@keyframes query{0%{opacity:1;transform:translateX(35%) scaleX(.3)}to{opacity:0;transform:translateX(-50%) scaleX(0)}}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvdGhlbWVzL21hdGVyaWFsLmNzcy5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvdGhlbWVzL21hdGVyaWFsLmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=material.css.ngstyle.js.map
// CONCATENATED MODULE: ./compiled/node_modules/@qontu/ngx-inline-editor/themes/bootstrap.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var bootstrap_css_ngstyle_styles = ['a.c-inline-editor{text-decoration:none;color:#428bca;border-bottom:1px dashed #428bca;cursor:pointer;line-height:2;margin-right:5px;margin-left:5px}.c-inline-editor.a.editable-empty,.c-inline-editor.a.editable-empty:focus,.c-inline-editor.a.editable-empty:hover,.c-inline-editor.editable-empty,.c-inline-editor.editable-empty:focus,.c-inline-editor.editable-empty:hover{font-style:italic;color:#d14;text-decoration:none}.c-inline-editor.inlineEditForm{display:inline-block;white-space:nowrap;margin:0}#inlineEditWrapper{display:inline-block}.c-inline-editor.inlineEditForm input,.c-inline-editor.select{width:auto;display:inline}.c-inline-editor.inline-editor-button-group{display:inline-block}.c-inline-editor.editInvalid{color:#a94442;margin-bottom:0}.c-inline-editor.error{border-color:#a94442}[hidden].c-inline-editor{display:none}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bxb250dS9uZ3gtaW5saW5lLWVkaXRvci90aGVtZXMvYm9vdHN0cmFwLmNzcy5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bxb250dS9uZ3gtaW5saW5lLWVkaXRvci90aGVtZXMvYm9vdHN0cmFwLmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=bootstrap.css.ngstyle.js.map
// CONCATENATED MODULE: ./compiled/theme/css/datatable.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var datatable_css_ngstyle_styles = ['.ngx-datatable.scroll-vertical .datatable-body{-ms-overflow-style:auto;overflow-y:auto}.ngx-datatable.material{box-shadow:none;-webkit-box-shadow:none}.ngx-datatable.material .datatable-body-cell,.ngx-datatable.material .datatable-header-cell{border:1px solid #dcdcdc}.ngx-datatable.material .datatable-body{border:3px solid #dcdcdc}.ngx-datatable.material .datatable-header{border-left:3px solid #dcdcdc}.ngx-datatable.material .btn{margin-top:0}.ngx-datatable.material .datatable-checkbox{padding:0!important}.ngx-datatable.material .label{margin-right:10px}.ngx-datatable.material .small{font-style:italic;color:#999}@font-face{font-family:data-table;src:url(assets/data-table.bce071e976865da511003c50333620c5.eot);src:url(assets/data-table.bce071e976865da511003c50333620c5.eot?#iefix) format("embedded-opentype"),url(assets/data-table.246ea8fa6c452b0f3c4fdd23e955e165.woff) format("woff"),url(assets/data-table.c8c6d300cb7abb9f36e8cff3c58f584d.ttf) format("truetype"),url(assets/data-table.b0aebd744ce7adb780a9342fd395535e.svg#data-table) format("svg");font-weight:400;font-style:normal}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvdGhlbWUvY3NzL2RhdGF0YWJsZS5jc3MubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL3RoZW1lL2Nzcy9kYXRhdGFibGUuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=datatable.css.ngstyle.js.map
// CONCATENATED MODULE: ./app/common/directives/ripples.directive.ts

var ripples_directive_RipplesDirective = /** @class */ (function () {
    function RipplesDirective(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.el = this.elementRef;
        this.rippleContainer = this.renderer.createElement("div");
        this.renderer.addClass(this.rippleContainer, "ripple-container");
        this.renderer.appendChild(this.el.nativeElement, this.rippleContainer);
        this.eventListeners = new Map();
        this.init();
    }
    RipplesDirective.prototype.init = function () {
        this.addEventListener(this.el.nativeElement, ["mousedown", "touchstart"], this.onMouseDown.bind(this));
    };
    RipplesDirective.prototype.onMouseDown = function (event) {
        var _this = this;
        if (!event)
            return;
        if (this.rippleContainer.childNodes.length > 0)
            return;
        /**
         * Verify if the user is just touching on a device and return if so
         */
        if (RipplesDirective.isTouch() && event.type === "mousedown") {
            return;
        }
        /**
         * Get relY and relX positions
         */
        var relY = RipplesDirective.getRelY(this.rippleContainer, event);
        var relX = RipplesDirective.getRelX(this.rippleContainer, event);
        /**
         * If relY and/or relX are false, return the event
         */
        if (!relY && !relX) {
            return;
        }
        /**
         * Get the ripple color
         */
        var rippleColor = RipplesDirective.getRipplesColor(this.el.nativeElement);
        /**
         * Create the ripple element
         */
        this.ripple = this.renderer.createElement("div");
        /**
         * Append the ripple to the wrapper
         */
        this.renderer.appendChild(this.rippleContainer, this.ripple);
        this.renderer.addClass(this.ripple, "ripple");
        this.ripple.style["left"] = relX + "px";
        this.ripple.style["top"] = relY + "px";
        this.ripple.style["background-color"] = rippleColor;
        RipplesDirective.enforceStyleRecalculation(this.ripple);
        /**
         * Turn on the ripple animation
         */
        this.rippleOn(this.el.nativeElement, this.ripple);
        /**
         * Call the rippleEnd function when the transition "on" ends
         */
        setTimeout(function () {
            _this.rippleEnd(_this.ripple);
        }, 500);
        /**
         * Detect when the user leaves the element
         */
        this.addEventListener(this.el.nativeElement, ["mouseup", "mouseleave", "touchend"], function () {
            _this.ripple.dataset["mousedown"] = "off";
            if (_this.ripple.dataset["animating"] == "off") {
                _this.rippleOut(_this.ripple);
            }
        });
    };
    RipplesDirective.isTouch = function () {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };
    ;
    RipplesDirective.hasTransitionSupport = function () {
        var thisBody = document.body != null ? document.body : document.documentElement;
        return thisBody.style['transition'] != null ||
            thisBody.style['WebkitTransition'] != null ||
            thisBody.style['MozTransition'] != null ||
            thisBody.style['MsTransition'] != null ||
            thisBody.style['OTransition'] != null;
    };
    ;
    RipplesDirective.getNewSize = function (element, ripple) {
        return (Math.max(element.offsetWidth, element.offsetHeight) / ripple.offsetWidth) * 2.5;
    };
    ;
    RipplesDirective.getRipplesColor = function (element) {
        return element.dataset["ripple-color"] ? element.dataset["ripple-color"] : window.getComputedStyle(element).color;
    };
    ;
    RipplesDirective.getRelX = function (element, event) {
        var offset = element.getBoundingClientRect();
        if (!RipplesDirective.isTouch()) {
            /**
             * Get the mouse position relative to the ripple wrapper
             */
            return event.pageX - offset.left;
        }
        else {
            /**
             * Make sure the user is using only one finger and then get the touch
             * position relative to the ripple wrapper
             */
            event = event.originalEvent;
            if (event != null && event.touches != null && event.touches.length === 1) {
                return event.touches[0].pageX - offset.left;
            }
            return 0;
        }
    };
    ;
    /**
     * Get the relY
     */
    RipplesDirective.getRelY = function (element, event) {
        var offset = element.getBoundingClientRect();
        if (!RipplesDirective.isTouch()) {
            /**
             * Get the mouse position relative to the ripple wrapper
             */
            return event.pageY - offset.top;
        }
        else {
            /**
             * Make sure the user is using only one finger and then get the touch
             * position relative to the ripple wrapper
             */
            event = event.originalEvent;
            if (event != null && event.touches != null && event.touches.length === 1) {
                return event.touches[0].pageY - offset.top;
            }
            return 0;
        }
    };
    ;
    RipplesDirective.prototype.rippleEnd = function (ripple) {
        ripple.dataset["animating"] = "off";
        if (ripple.dataset["mousedown"] == "off") {
            this.rippleOut(ripple);
        }
    };
    ;
    /**
     * Turn off the ripple effect
     */
    RipplesDirective.prototype.rippleOut = function (ripple) {
        this.eventListeners.forEach(function (value, key) {
            ripple.removeEventListener(key, value);
        });
        this.eventListeners.clear();
        if (RipplesDirective.hasTransitionSupport()) {
            this.renderer.addClass(ripple, "ripple-out");
        }
        this.addEventListener(ripple, ["transitionend", "webkitTransitionEnd", "oTransitionEnd", "MSTransitionEnd"], function () {
            ripple.parentNode.removeChild(ripple);
        });
    };
    ;
    RipplesDirective.prototype.rippleOn = function (element, ripple) {
        var size = RipplesDirective.getNewSize(element, ripple);
        if (RipplesDirective.hasTransitionSupport()) {
            this.renderer.addClass(ripple, "ripple-on");
            ripple.style["-ms-transform"] = "scale(" + size + ")";
            ripple.style["-moz-transform"] = "scale(" + size + ")";
            ripple.style["-webkit-transform"] = "scale(" + size + ")";
            ripple.style["transform"] = "scale(" + size + ")";
            ripple.dataset["animating"] = "on";
            ripple.dataset["mousedown"] = "on";
        }
    };
    ;
    RipplesDirective.enforceStyleRecalculation = function (element) {
        window.getComputedStyle(element).getPropertyValue('opacity');
    };
    RipplesDirective.prototype.addEventListener = function (element, events, fn) {
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var event = events_1[_i];
            element.addEventListener(event, fn);
            this.eventListeners.set(event, fn);
        }
    };
    RipplesDirective.ctorParameters = function () { return [{ type: core_es5["ElementRef"] }, { type: core_es5["Renderer2"] }]; };
    return RipplesDirective;
}());

//# sourceMappingURL=ripples.directive.js.map
// EXTERNAL MODULE: ./node_modules/@angular/forms/@angular/forms.es5.js
var forms_es5 = __webpack_require__("NVOs");

// CONCATENATED MODULE: ./app/objects/common/valueAccessorBase.ts
var ValueAccessorBase = /** @class */ (function () {
    function ValueAccessorBase() {
        this.changed = [];
        this.touched = [];
    }
    Object.defineProperty(ValueAccessorBase.prototype, "value", {
        get: function () {
            return this.innerValue;
        },
        set: function (value) {
            if (this.innerValue !== value) {
                this.innerValue = value;
                this.changed.forEach(function (f) { return f(value); });
            }
        },
        enumerable: true,
        configurable: true
    });
    ValueAccessorBase.prototype.touch = function () {
        this.touched.forEach(function (f) { return f(); });
    };
    ValueAccessorBase.prototype.writeValue = function (value) {
        this.innerValue = value;
    };
    ValueAccessorBase.prototype.registerOnChange = function (fn) {
        this.changed.push(fn);
    };
    ValueAccessorBase.prototype.registerOnTouched = function (fn) {
        this.touched.push(fn);
    };
    return ValueAccessorBase;
}());

//# sourceMappingURL=valueAccessorBase.js.map
// CONCATENATED MODULE: ./app/components/common/checkbox/checkbox.component.ts




var checkbox_component_CheckboxComponent = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](CheckboxComponent, _super);
    function CheckboxComponent(validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this.validators = validators;
        _this.asyncValidators = asyncValidators;
        return _this;
    }
    CheckboxComponent.prototype.ngAfterViewInit = function () {
        this.model.control.setValidators(this.validators);
        this.model.control.setAsyncValidators(this.asyncValidators);
    };
    CheckboxComponent.ctorParameters = function () { return [{ type: Array, decorators: [{ type: core_es5["Optional"] }, { type: core_es5["Inject"], args: [forms_es5["NG_VALIDATORS"]] }] }, { type: Array, decorators: [{ type: core_es5["Optional"] }, { type: core_es5["Inject"], args: [forms_es5["NG_ASYNC_VALIDATORS"]] }] }]; };
    return CheckboxComponent;
}(ValueAccessorBase));

//# sourceMappingURL=checkbox.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/common/checkbox/checkbox.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_CheckboxComponent = [];
var RenderType_CheckboxComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CheckboxComponent, data: {} });
function View_CheckboxComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { model: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 23, 'div', [['class', 'checkbox']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0, 'form-group': 1 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'label', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'disabled': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'input', [['type', 'checkbox']], [[1, 'name', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 10).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 10).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.value = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["CheckboxControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["CheckboxControlValueAccessor"]]), core_es5["ɵdid"](671744, [[1, 4]], 0, forms_es5["NgModel"], [[8, null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { isDisabled: [0, 'isDisabled'], model: [1, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-material']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'check']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'label-text']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), core_es5["ɵncd"](null, 0),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'checkbox';
        var currVal_1 = _ck(_v, 3, 0, (((_co.form != null) && (!_co.model.pristine || _co.form.submitted)) && !_co.model.valid), (_co.form != null));
        _ck(_v, 2, 0, currVal_0, currVal_1);
        var currVal_2 = _ck(_v, 7, 0, _co.disabled);
        _ck(_v, 6, 0, currVal_2);
        var currVal_11 = _co.disabled;
        var currVal_12 = _co.value;
        _ck(_v, 12, 0, currVal_11, currVal_12);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = _co.name;
        var currVal_4 = core_es5["ɵnov"](_v, 14).ngClassUntouched;
        var currVal_5 = core_es5["ɵnov"](_v, 14).ngClassTouched;
        var currVal_6 = core_es5["ɵnov"](_v, 14).ngClassPristine;
        var currVal_7 = core_es5["ɵnov"](_v, 14).ngClassDirty;
        var currVal_8 = core_es5["ɵnov"](_v, 14).ngClassValid;
        var currVal_9 = core_es5["ɵnov"](_v, 14).ngClassInvalid;
        var currVal_10 = core_es5["ɵnov"](_v, 14).ngClassPending;
        _ck(_v, 9, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_13 = (_co.label || '');
        _ck(_v, 20, 0, currVal_13);
    });
}
function View_CheckboxComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'checkbox', [], null, null, null, View_CheckboxComponent_0, RenderType_CheckboxComponent)),
        core_es5["ɵprd"](5120, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], null, null)], null, null);
}
var CheckboxComponentNgFactory = core_es5["ɵccf"]('checkbox', checkbox_component_CheckboxComponent, View_CheckboxComponent_Host_0, { name: 'name', label: 'label',
    form: 'form', disabled: 'disabled' }, {}, ['*']);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=checkbox.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/objects/orders/orderStatus.ts
var orders_orderStatus = __webpack_require__("natU");

// EXTERNAL MODULE: ./node_modules/@angular/router/@angular/router.es5.js
var router_es5 = __webpack_require__("5oXY");

// CONCATENATED MODULE: ./app/objects/responses/orderSearch.ts
/**
 * Created by alex.y on 9/14/2017.
 */
var OrderSearch = /** @class */ (function () {
    function OrderSearch() {
        this.AgentId = null;
        this.CustomerID = null;
    }
    return OrderSearch;
}());

//# sourceMappingURL=orderSearch.js.map
// EXTERNAL MODULE: ./app/common/utils/blurUtil.ts
var blurUtil = __webpack_require__("vWtP");

// CONCATENATED MODULE: ./app/components/Managment/orderManagement/orderItem/base-order-item.component.ts

var base_order_item_component_BaseOrderItemComponent = /** @class */ (function () {
    function BaseOrderItemComponent() {
    }
    BaseOrderItemComponent.prototype.goToDetailsBase = function (id, router, orderSearch, unblurId, order) {
        router.navigate(["management/order", {
                query: orderSearch.Query ? orderSearch.Query : "",
                agentid: orderSearch.AgentId ? orderSearch.AgentId.toString() : "",
                customerid: orderSearch.CustomerID ? orderSearch.CustomerID.toString() : ""
            }]);
        blurUtil["a" /* BlurUtil */].unBlurMenu(unblurId);
        router.navigate(["order/" + id.toString(), {
                query: orderSearch.Query ? orderSearch.Query : "",
                agentid: orderSearch.AgentId ? orderSearch.AgentId.toString() : "",
                customerid: order.Customer && order.Customer.Id ? order.Customer.Id.toString() : ""
            }]);
    };
    BaseOrderItemComponent.prototype.isMobile = function () {
        if (screen.width > 767)
            return false;
        return true;
    };
    return BaseOrderItemComponent;
}());

//# sourceMappingURL=base-order-item.component.js.map
// EXTERNAL MODULE: ./app/common/helpers/calculatorHelper.ts + 4 modules
var calculatorHelper = __webpack_require__("osrx");

// CONCATENATED MODULE: ./app/common/helpers/propertyHelper.ts
var PropertyHelper = /** @class */ (function () {
    function PropertyHelper() {
    }
    PropertyHelper.getValueFromClassProperty = function (propertyName, classInstance) {
        if (propertyName.indexOf(".") === -1)
            return classInstance[propertyName];
        var splittedObject = propertyName.split(".");
        return this.getValueFromComplexObject(splittedObject, 0, classInstance);
    };
    PropertyHelper.getValueFromComplexObject = function (splittedObject, index, object) {
        if (index === void 0) { index = 0; }
        if (index >= splittedObject.length)
            return object;
        index += 1;
        if (!object)
            return "";
        return this.getValueFromComplexObject(splittedObject, index, object[splittedObject[index - 1]]);
    };
    PropertyHelper.isPropsValid = function (object) {
        return Object.keys(object).find(function (key) { return object[key] && object[key].hasOwnProperty("IsValid") && object[key].IsValid == false; }) == null;
    };
    return PropertyHelper;
}());

//# sourceMappingURL=propertyHelper.js.map
// CONCATENATED MODULE: ./node_modules/ts-date/esm/src/add/add-unit.js
function addTimeFn(ms) {
    return function (d, n) {
        if (d === null)
            return null;
        if (!isFinite(n))
            return d;
        return new Date(d.getTime() + ms * n);
    };
}
function addFn(keyGet, keySet) {
    return function (d, n) {
        if (d === null)
            return null;
        if (!isFinite(n))
            return d;
        var result = new Date(d.getTime());
        result[keySet](result[keyGet]() + n);
        return result;
    };
}
var addMilliseconds = addTimeFn(1 /* Milliseconds */);
var addSeconds = addTimeFn(1000 /* Seconds */);
var addMinutes = addTimeFn(60000 /* Minutes */);
var addHours = addTimeFn(3600000 /* Hours */);
var addDate = addFn('getDate', 'setDate');
var addMonth = addFn('getMonth', 'setMonth');
var addYear = addFn('getFullYear', 'setFullYear');
var addUTCMilliseconds = addFn('getUTCMilliseconds', 'setUTCMilliseconds');
var addUTCSeconds = addFn('getUTCSeconds', 'setUTCSeconds');
var addUTCMinutes = addFn('getUTCMinutes', 'setUTCMinutes');
var addUTCHours = addFn('getUTCHours', 'setUTCHours');
var addUTCDate = addFn('getUTCDate', 'setUTCDate');
var addUTCMonth = addFn('getUTCMonth', 'setUTCMonth');
var addUTCYear = addFn('getUTCFullYear', 'setUTCFullYear');

// CONCATENATED MODULE: ./node_modules/ts-date/esm/src/reset/reset-unit.js
var START_OF_ISO_WEEK = 1;
var resetYear = function (d) {
    if (d === null)
        return null;
    return new Date(d.getFullYear(), 0);
};
var resetMonth = function (d) {
    if (d === null)
        return null;
    return new Date(d.getFullYear(), d.getMonth(), 1);
};
var resetISOWeek = function (d) {
    if (d === null)
        return null;
    var day = d.getDay();
    var diff = (day < START_OF_ISO_WEEK ? 7 : 0) + day - START_OF_ISO_WEEK;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() - diff);
};
var resetDate = function (d) {
    if (d === null)
        return null;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
};
var resetHours = function (d) {
    if (d === null)
        return null;
    var result = new Date(d.getTime());
    result.setMinutes(0, 0, 0);
    return result;
};
var resetMinutes = function (d) {
    if (d === null)
        return null;
    var result = new Date(d.getTime());
    result.setSeconds(0, 0);
    return result;
};
var resetSeconds = function (d) {
    if (d === null)
        return null;
    var result = new Date(d.getTime());
    result.setMilliseconds(0);
    return result;
};

// CONCATENATED MODULE: ./node_modules/ts-date/esm/src/create/create-ts-date.js
function fromDate(date) {
    var d = new Date(+date);
    return asValidDateOrNull(d);
}
function fromDateOrThrow(date) {
    var d = new Date(date instanceof Date ? date.getTime() : date);
    return asValidDateOrThrow(d, date);
}
function asValidDateOrNull(date) {
    if (isValidDate(date))
        return date;
    return null;
}
function asValidDateOrThrow(date, origin) {
    if (isValidDate(date))
        return date;
    throw new TypeError("Cant parse date from \"" + origin + "\"");
}
var newValidDate = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = new ((_a = Date).bind.apply(_a, [void 0].concat(args)))();
    return asValidDateOrNull(result);
    var _a;
};
var newValidDateOrThrow = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = new ((_a = Date).bind.apply(_a, [void 0].concat(args)))();
    return asValidDateOrThrow(result, args);
    var _a;
};
function isValidDate(d) {
    return d !== null && d instanceof Date && isFinite(d.getTime());
}

// CONCATENATED MODULE: ./node_modules/ts-date/esm/src/utils/utils.js
function leadZero(n, targetLength) {
    if (targetLength === void 0) { targetLength = 2; }
    var output = n + '';
    while (output.length < targetLength) {
        output = '0' + output;
    }
    return output;
}
function absFloor(num) {
    if (num < 0) {
        // -0 -> 0
        return Math.ceil(num) || 0;
    }
    else {
        return Math.floor(num);
    }
}
function extend(obj1, obj2) {
    var result = {};
    for (var key in obj1) {
        result[key] = obj1[key];
    }
    for (var key in obj2) {
        result[key] = obj2[key];
    }
    return result;
}
function tokensRx(obj) {
    var keys = [];
    for (var key in obj) {
        keys.push(key);
    }
    keys.sort(function (a, b) { return b.length - a.length; });
    return new RegExp(keys.join('|') + '|\\[[^[]*\\]|.', 'g');
}

// CONCATENATED MODULE: ./node_modules/ts-date/esm/src/diff/diff-unit.js


function diffByUnits(unitsInMs) {
    return function (d1, d2) {
        if (!isValidDate(d1) || !isValidDate(d2))
            return null;
        return absFloor((d1.getTime() - d2.getTime()) / unitsInMs);
    };
}
var diffMilliseconds = diffByUnits(1 /* Milliseconds */);
var diffSeconds = diffByUnits(1000 /* Seconds */);
var diffMinutes = diffByUnits(60000 /* Minutes */);
var diffHours = diffByUnits(3600000 /* Hours */);
function dateToArray(d) {
    return [d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()];
}
function compareArrays(list1, list2, fromPosition) {
    for (var i = fromPosition; i < list1.length; i++) {
        if (list1[i] === list2[i])
            continue;
        return list1[i] > list2[i] ? 1 : -1;
    }
    return 0;
}
var diffDate = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var utc1 = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate());
    var utc2 = Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate());
    var diff = absFloor((utc1 - utc2) / 86400000 /* Date */);
    if (diff === 0)
        return 0;
    var diffTail = compareArrays(dateToArray(d1), dateToArray(d2), 3);
    if (diffTail === 0 || diff > 0 === diffTail > 0)
        return diff;
    return diff + diffTail;
};
var diffMonth = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var diff = (d1.getFullYear() - d2.getFullYear()) * 12 + d1.getMonth() - d2.getMonth();
    if (diff === 0)
        return 0;
    var diffTail = compareArrays(dateToArray(d1), dateToArray(d2), 2);
    if (diffTail === 0 || diff > 0 === diffTail > 0)
        return diff;
    return diff + diffTail;
};
var diffYear = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var diff = d1.getFullYear() - d2.getFullYear();
    if (diff === 0)
        return 0;
    var diffTail = compareArrays(dateToArray(d1), dateToArray(d2), 1);
    if (!diffTail || diff > 0 === diffTail > 0)
        return diff;
    return diff + diffTail;
};

// CONCATENATED MODULE: ./node_modules/ts-date/esm/src/diff/diff-calendar-unit.js


var diffCalendarYear = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    return d1.getFullYear() - d2.getFullYear();
};
var diffCalendarMonth = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    return (d1.getFullYear() - d2.getFullYear()) * 12 + d1.getMonth() - d2.getMonth();
};
var diffCalendarDate = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var u1 = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate());
    var u2 = Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate());
    return absFloor((u1 - u2) / 86400000 /* Date */);
};

// CONCATENATED MODULE: ./node_modules/ts-date/esm/src/diff/diff-precise-unit.js


function diffPreciseByUnits(unitsInMs) {
    return (function (d1, d2) {
        if (!isValidDate(d1) || !isValidDate(d2))
            return null;
        return (d1.getTime() - d2.getTime()) / unitsInMs;
    });
}
var diffPreciseSeconds = diffPreciseByUnits(1000 /* Seconds */);
var diffPreciseMinutes = diffPreciseByUnits(60000 /* Minutes */);
var diffPreciseHours = diffPreciseByUnits(3600000 /* Hours */);
var diffPreciseDate = diffPreciseByUnits(86400000 /* Date */);
var diffPreciseMonth = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var startOfMonth1 = +new Date(d1.getFullYear(), d1.getMonth());
    var startOfNextMonth1 = +new Date(d1.getFullYear(), d1.getMonth() + 1);
    var startOfMonth2 = +new Date(d2.getFullYear(), d2.getMonth());
    var startOfNextMonth2 = +new Date(d2.getFullYear(), d2.getMonth() + 1);
    var m1 = startOfNextMonth1 - startOfMonth1;
    var m2 = startOfNextMonth2 - startOfMonth2;
    var t1 = d1.getTime() - startOfMonth1;
    var t2 = d2.getTime() - startOfMonth2;
    /**
     * that formula was made to avoid "1 - 0.9" calculations
     * do same thing as
     * diffCalendarMonth(d1, d2) + t1 / m1 - t2 / m2
     */
    return (diffCalendarMonth(d1, d2) * m1 * m2 + t1 * m2 - t2 * m1) / (m1 * m2);
};
var diffPreciseYear = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var startOfYear1 = +new Date(d1.getFullYear(), 0);
    var startOfNextYear1 = +new Date(d1.getFullYear() + 1, 0);
    var startOfYear2 = +new Date(d2.getFullYear(), 0);
    var startOfNextYear2 = +new Date(d2.getFullYear() + 1, 0);
    var y1 = startOfNextYear1 - startOfYear1;
    var y2 = startOfNextYear2 - startOfYear2;
    var t1 = d1.getTime() - startOfYear1;
    var t2 = d2.getTime() - startOfYear2;
    return (diffCalendarYear(d1, d2) * y1 * y2 + t1 * y2 - t2 * y1) / (y1 * y2);
};

// CONCATENATED MODULE: ./node_modules/ts-date/esm/src/format/format-iso.js

/**
 * Makes function that return part of ISO 8610 formatted string
 */
function createFormatIso(len) {
    return function (d) {
        if (!isValidDate(d))
            return null;
        var date = new Date(d.getTime());
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
        return date.toISOString().substring(0, len);
    };
}
// YYYY-MM-DD
var formatDateIso = createFormatIso(10);
// YYYY-MM-DDTHH:mm
var formatDateTimeIso = createFormatIso(16);
// YYYY-MM-DDTHH:mm:ss.SSS
var formatLocalIso = createFormatIso(23);

// CONCATENATED MODULE: ./node_modules/ts-date/esm/src/parse/parse-iso.js
function toNumber(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : +value;
}
//               ( HH )  ( MM )     ( SS )(    MS   )   (      TZD            )
var ISO_RX = /^\s*(\d{4,6}?)(?:-?(\d\d))?(?:-?(\d\d))?(?:T(\d\d):?(\d\d):?(?:(\d\d)(\.\d{1,3})?)?([+-]\d\d?(?::\d\d)?|Z)?)?\s*$/;
function parseIso(dateStr) {
    if (!dateStr)
        return null;
    var timeList = dateStr.match(ISO_RX);
    if (!timeList)
        return null;
    var Y = +timeList[1];
    var M = toNumber(timeList[2], 1) - 1;
    var D = toNumber(timeList[3], 1);
    var maybeResult = new Date(Y, M, D);
    var isDateOk = (maybeResult.getDate() === D &&
        maybeResult.getMonth() === M &&
        maybeResult.getFullYear() === Y);
    if (!isDateOk)
        return null;
    if (!timeList[4])
        return maybeResult;
    var H = toNumber(timeList[4], 0);
    var m = toNumber(timeList[5], 0);
    var s = toNumber(timeList[6], 0);
    var ms = toNumber(timeList[7], 0) * 1000;
    var isTimeOk = (H < 24 &&
        m < 60 &&
        s < 60);
    if (!isTimeOk)
        return null;
    var tzd = timeList[8];
    var tzOffset = 0;
    if (tzd) {
        if (tzd !== 'Z') {
            var tzdList = tzd.split(':');
            var tzH = toNumber(tzdList[0], 0);
            var tzM = toNumber(tzdList[1], 0);
            var isTzOk = (tzH >= -12 &&
                tzH <= 12 &&
                tzM < 60);
            if (!isTzOk)
                return null;
            tzOffset = tzH * 60 + tzM;
        }
        tzOffset += maybeResult.getTimezoneOffset();
    }
    maybeResult.setHours(H, m - tzOffset, s, ms);
    return maybeResult;
}
function parseIsoOrThrow(dateStr) {
    var result = parseIso(dateStr);
    if (result === null)
        throw new Error("Failed to parse as ISO 8601 string: \"" + dateStr + "\"");
    return result;
}

// CONCATENATED MODULE: ./node_modules/ts-date/esm/src/default-exports.js









// CONCATENATED MODULE: ./node_modules/ts-date/esm/src/format/default-formatters.js




var default_formatters_formatters = {
    // Month: 1, 2, ..., 12
    'M': function (date) { return date.getMonth() + 1; },
    // Month: 01, 02, ..., 12
    'MM': function (date) { return leadZero(date.getMonth() + 1); },
    // Quarter: 1, 2, 3, 4
    'Q': function (date) { return Math.ceil((date.getMonth() + 1) / 3); },
    // Day of month: 1, 2, ..., 31
    'D': function (date) { return date.getDate(); },
    // Day of month: 01, 02, ..., 31
    'DD': function (date) { return leadZero(date.getDate()); },
    // Day of year: 1, 2, ..., 366
    'DDD': function (date) { return diffCalendarDate(date, resetYear(date)) + 1; },
    // Day of year: 001, 002, ..., 366
    'DDDD': function (date) { return leadZero(default_formatters_formatters['DDD'](date), 3); },
    // Day of week: 0, 1, ..., 6
    'd': function (date) { return date.getDay(); },
    // Day of ISO week: 1, 2, ..., 7
    'E': function (date) { return date.getDay() || 7; },
    // ISO week: 1, 2, ..., 53
    'W': function (date) {
        var isoYear = +default_formatters_formatters['GGGG'](date);
        var start = resetISOWeek(newValidDateOrThrow(isoYear, 0, 4));
        return Math.floor(diffCalendarDate(date, start) / 7) + 1;
    },
    // ISO week: 01, 02, ..., 53
    'WW': function (date) { return leadZero(default_formatters_formatters['W'](date)); },
    // Year: 00, 01, ..., 99
    'YY': function (date) { return date.getFullYear().toString().slice(-2); },
    // Year: 1900, 1901, ..., 2099
    'YYYY': function (date) { return leadZero(date.getFullYear(), 4); },
    // ISO week-numbering year: 00, 01, ..., 99
    'GG': function (date) { return default_formatters_formatters['GGGG'](date).toString().slice(-2); },
    // ISO week-numbering year: 1900, 1901, ..., 2099
    'GGGG': function (date) {
        var startYear = date.getFullYear();
        var correction = date < resetISOWeek(newValidDateOrThrow(startYear, 0, 4))
            ? -1
            : date < resetISOWeek(newValidDateOrThrow(startYear + 1, 0, 4))
                ? 0
                : 1;
        return leadZero(startYear + correction, 4);
    },
    // Hour: 0, 1, ... 23
    'H': function (date) { return date.getHours(); },
    // Hour: 00, 01, ..., 23
    'HH': function (date) { return leadZero(date.getHours()); },
    // Hour: 1, 2, ..., 12
    'h': function (date) { return (date.getHours() % 12) || 12; },
    // Hour: 01, 02, ..., 12
    'hh': function (date) { return leadZero(default_formatters_formatters['h'](date)); },
    // Minute: 0, 1, ..., 59
    'm': function (date) { return date.getMinutes(); },
    // Minute: 00, 01, ..., 59
    'mm': function (date) { return leadZero(date.getMinutes()); },
    // Second: 0, 1, ..., 59
    's': function (date) { return date.getSeconds(); },
    // Second: 00, 01, ..., 59
    'ss': function (date) { return leadZero(date.getSeconds()); },
    // 1/10 of second: 0, 1, ..., 9
    'S': function (date) { return Math.floor(date.getMilliseconds() / 100); },
    // 1/100 of second: 00, 01, ..., 99
    'SS': function (date) { return leadZero(Math.floor(date.getMilliseconds() / 10)); },
    // Millisecond: 000, 001, ..., 999
    'SSS': function (date) { return leadZero(date.getMilliseconds(), 3); },
    // Timezone: -01:00, +00:00, ... +12:00
    'Z': function (date) { return formatTimezone(date.getTimezoneOffset(), ':'); },
    // Timezone: -0100, +0000, ... +1200
    'ZZ': function (date) { return formatTimezone(date.getTimezoneOffset()); },
    // Seconds timestamp: 512969520
    'X': function (date) { return Math.floor(date.getTime() / 1000); },
    // Milliseconds timestamp: 512969520900
    'x': function (date) { return date.getTime(); },
};
function formatTimezone(offset, delimeter) {
    if (delimeter === void 0) { delimeter = ''; }
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    return sign + leadZero(hours) + delimeter + leadZero(minutes);
}
/* harmony default export */ var default_formatters = (default_formatters_formatters);

// CONCATENATED MODULE: ./node_modules/ts-date/esm/src/format/create-format.js


function splitToTokens(template, formatters) {
    var RX_TOKENS = tokensRx(formatters);
    var tokens = template.match(RX_TOKENS);
    // this regexp cant fail because of "|."
    var result = [];
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        var tokenFn = formatters[token];
        if (tokenFn) {
            result.push(tokenFn);
        }
        else if (token.charAt(0) === '[' && token.charAt(token.length - 1) === ']') {
            result.push(token.substring(1, token.length - 1));
        }
        else {
            result.push(token);
        }
    }
    return result;
}
function formatByTokens(d, tokens) {
    var result = [];
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        result.push(typeof token === 'function' ? token(d, i, tokens) : token);
    }
    return result.join('');
}
function createFormat(formatters) {
    var cache = {};
    return function (d, template) {
        if (!isValidDate(d))
            return null;
        var tokens = cache[template];
        if (tokens === undefined) {
            tokens = splitToTokens(template, formatters);
            cache[template] = tokens;
        }
        return formatByTokens(d, tokens);
    };
}

// CONCATENATED MODULE: ./node_modules/ts-date/esm/src/format/format.js


/**
 * format without any locale, just numbers
 */
var format_format = createFormat(default_formatters);

// CONCATENATED MODULE: ./node_modules/ts-date/esm/src/parse/default-parsers.js
var rx1 = '\\d';
var rx2 = '\\d\\d';
var rx12 = '\\d\\d?';
var rx3 = '\\d{3}';
var rx4 = '\\d{4}';
var rxN = '\\d{5,}';
var defaultParsers = {
    // Month: 1, 2, ..., 12
    'M': [rx12, function (date, value) { date.setMonth(+value - 1); }],
    // Month: 01, 02, ..., 12
    'MM': [rx2, function (date, value) { date.setMonth(+value - 1); }],
    // Quarter: 1, 2, 3, 4
    // 'Q': (date, value) => Math.ceil((date.getMonth() + 1) / 3),
    // Day of month: 1, 2, ..., 31
    'D': [rx12, function (date, value) { date.setDate(+value); }],
    // Day of month: 01, 02, ..., 31
    'DD': [rx2, function (date, value) { date.setDate(+value); }],
    // Day of year: 1, 2, ..., 366
    // TODO 'DDD': (date, value) => getDayOfYear(date),
    // Day of year: 001, 002, ..., 366
    // TODO 'DDDD': (date, value) => leadZero(getDayOfYear(date), 3),
    // Day of week: 0, 1, ..., 6
    // 'd': (date, value) => date.getDay(),
    // Day of ISO week: 1, 2, ..., 7
    // 'E': (date, value) => date.getDay() || 7,
    // ISO week: 1, 2, ..., 53
    // TODO 'W': (date, value) => getISOWeek(date),
    // ISO week: 01, 02, ..., 53
    // TODO 'WW': (date, value) => leadZero(getISOWeek(date)),
    // Year: 00, 01, ..., 99
    'YY': [rx2, function (date, value) { date.setFullYear(2000 + +value); }],
    // Year: 1900, 1901, ..., 2099
    'YYYY': [rx4, function (date, value) { date.setFullYear(+value); }],
    // ISO week-numbering year: 00, 01, ..., 99
    // TODO 'GG': (date, value) => getISOYear(date).toString().slice(-2),
    // ISO week-numbering year: 1900, 1901, ..., 2099
    // TODO 'GGGG': (date, value) => getISOYear(date),
    // Hour: 0, 1, ... 23
    'H': [rx12, function (date, value) { date.setHours(+value); }],
    // Hour: 00, 01, ..., 23
    'HH': [rx2, function (date, value) { date.setHours(+value); }],
    // Hour: 1, 2, ..., 12
    //'h': (date, value) => (date.getHours() % 12) || 12,
    // Hour: 01, 02, ..., 12
    // 'hh': (date, value) => leadZero(formatters['h'](date)),
    // Minute: 0, 1, ..., 59
    'm': [rx12, function (date, value) { date.setMinutes(+value); }],
    // Minute: 00, 01, ..., 59
    'mm': [rx2, function (date, value) { date.setMinutes(+value); }],
    // Second: 0, 1, ..., 59
    's': [rx12, function (date, value) { date.setSeconds(+value); }],
    // Second: 00, 01, ..., 59
    'ss': [rx2, function (date, value) { date.setSeconds(+value); }],
    // 1/10 of second: 0, 1, ..., 9
    'S': [rx1, function (date, value) { date.setMilliseconds(+value * 100); }],
    // 1/100 of second: 00, 01, ..., 99
    'SS': [rx2, function (date, value) { date.setMilliseconds(+value * 10); }],
    // Millisecond: 000, 001, ..., 999
    'SSS': [rx3, function (date, value) { date.setMilliseconds(+value); }],
    // Timezone: -01:00, +00:00, ... +12:00
    // TODO 'Z': (date, value) => formatTimezone(date.getTimezoneOffset(), ':'),
    // Timezone: -0100, +0000, ... +1200
    // TODO 'ZZ': (date, value) => formatTimezone(date.getTimezoneOffset()),
    // Seconds timestamp: 512969520
    'X': [rxN, function (date, value) { date.setTime(+value * 1000); }],
    // Milliseconds timestamp: 512969520900
    'x': [rxN, function (date, value) { date.setTime(+value); }],
};
/* harmony default export */ var default_parsers = (defaultParsers);

// CONCATENATED MODULE: ./node_modules/ts-date/esm/src/parse/create-parse.js


function escapeRegExp(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
function createParse(parsers) {
    var RX_TOKENS = tokensRx(parsers);
    return function parse(dateStr, template) {
        var tokens = template.match(RX_TOKENS);
        // this regexp cant fail because of "|."
        var parsersFn = [];
        var rxStr = tokens.map(function (token) {
            var parser = parsers[token];
            if (parser) {
                parsersFn.push(parser[1]);
                var regexpPart = parser[0];
                return "(" + regexpPart + ")";
            }
            if (token.charAt(0) === '[' && token.charAt(token.length - 1) === ']')
                token = token.substring(1, token.length - 1);
            return escapeRegExp(token);
        }).join('');
        var rx = new RegExp('^' + rxStr + '$', 'i');
        var values = dateStr.match(rx);
        if (!values)
            return null;
        /* NOTE second zero needed to set current timezone */
        var date = new Date(0, 0);
        values.slice(1).forEach(function (value, index) {
            var parserFn = parsersFn[index];
            parserFn(date, value);
        });
        return asValidDateOrNull(date);
    };
}
function parseOrThrowWrapper(fn) {
    return function parseOrThrow(dateStr, template) {
        var result = fn(dateStr, template);
        if (result === null)
            throw new Error("Failed to parse date \"" + dateStr + "\" by template \"" + template + "\"");
        return result;
    };
}

// CONCATENATED MODULE: ./node_modules/ts-date/esm/src/parse/parse.js


/**
 * parse without any locale, just numbers
 */
var parse_parse = createParse(default_parsers);
var parseOrThrow = parseOrThrowWrapper(parse_parse);

// CONCATENATED MODULE: ./node_modules/ts-date/esm/index.js




// CONCATENATED MODULE: ./app/common/helpers/orderHelper.ts




var orderHelper_OrderHelper = /** @class */ (function () {
    function OrderHelper() {
    }
    OrderHelper.getTooltipText = function (orderStatus) {
        switch (orderStatus) {
            case orders_orderStatus["a" /* OrderStatus */].Calculated:
                return "Calculated";
            case orders_orderStatus["a" /* OrderStatus */].Quoted:
                return "Wait for payment";
            case orders_orderStatus["a" /* OrderStatus */].Paid:
            case orders_orderStatus["a" /* OrderStatus */].Refunded:
                return "Preparing Documents";
            case orders_orderStatus["a" /* OrderStatus */].PrepareDoc:
                return "Sending to Customs";
            case orders_orderStatus["a" /* OrderStatus */].SentToCustom:
                return "Wait for Customs release";
            case orders_orderStatus["a" /* OrderStatus */].CustomReleased:
            case orders_orderStatus["a" /* OrderStatus */].BorderCrossed:
            case orders_orderStatus["a" /* OrderStatus */].Closed:
                return "Closing case";
        }
        return "Wait";
    };
    OrderHelper.getOrderIcon = function (status) {
        switch (status) {
            case orders_orderStatus["a" /* OrderStatus */].Calculated:
                return "iso";
            case orders_orderStatus["a" /* OrderStatus */].Quoted:
                return "credit_card";
            case orders_orderStatus["a" /* OrderStatus */].Paid:
            case orders_orderStatus["a" /* OrderStatus */].Refunded:
                return "description";
            case orders_orderStatus["a" /* OrderStatus */].PrepareDoc:
                return "contact_mail";
            case orders_orderStatus["a" /* OrderStatus */].SentToCustom:
                return "local_shipping";
            case orders_orderStatus["a" /* OrderStatus */].CustomReleased:
                return "beenhere";
            case orders_orderStatus["a" /* OrderStatus */].BorderCrossed:
            case orders_orderStatus["a" /* OrderStatus */].Closed:
                return "beenhere";
        }
        return "";
    };
    OrderHelper.formatValue = function (value, name, order, canadianCurrencyCodes) {
        switch (name) {
            case 'Order ID':
                return "BB-" + order.Id;
            case 'Goods':
            case 'Vehicle/Product':
                return calculatorHelper["a" /* CalculatorHelper */].isVehicleES(order) ? 'Vehicle' : 'Product';
            case 'Quote':
            case 'Quick Quote/Full Quote':
                return calculatorHelper["a" /* CalculatorHelper */].isQuickQuoteES(order) ? 'Quick Quote' : 'Full Quote';
            case 'GTP':
                return PropertyHelper.getValueFromClassProperty(value, order).toLocaleString('en-us', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + (String.isNullOrEmpty(order.TotalCurrencyName) ? '' : order.TotalCurrencyName);
            case 'Total Value':
                return PropertyHelper.getValueFromClassProperty(value, order)
                    .toLocaleString('en-us', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + (String.isNullOrEmpty(order.CurrencyName) ? '' : order.CurrencyName);
            case 'Shipping':
                return order.IsCommercial ? 'Business shipping' : 'Individual shipping';
            case 'Last Updated':
            case 'Created date':
                return format_format(new Date(PropertyHelper.getValueFromClassProperty(value, order)), 'MM.DD.YYYY');
            case 'BorderBuddy Customs Clearance ':
                return PropertyHelper.getValueFromClassProperty(value, order).toLocaleString('en-us', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " \n                " + (String.isNullOrEmpty(order.TotalCurrencyName) ? '' : order.TotalCurrencyName);
        }
        return PropertyHelper.getValueFromClassProperty(value, order);
    };
    OrderHelper.hasOption = function (order, flag) {
        if (order.Flag == null || typeof order.Flag == 'undefined')
            return false;
        return order.Flag.hasFlag(flag);
    };
    return OrderHelper;
}());

//# sourceMappingURL=orderHelper.js.map
// EXTERNAL MODULE: ./app/objects/orders/orderOptions.ts
var orderOptions = __webpack_require__("Wcmd");

// CONCATENATED MODULE: ./app/components/Managment/orderManagement/orderItem/orderItem.component.ts








/**
 * Created by alex.y on 9/13/2017.
 */
var orderItem_component_OrderItemComponent = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](OrderItemComponent, _super);
    function OrderItemComponent(router, route) {
        var _this = _super.call(this) || this;
        _this.router = router;
        _this.route = route;
        _this.topClass = "col-sp-5";
        _this.topClassNext = "";
        _this.paramsInUrl = new OrderSearch();
        _this.isDisabled = false;
        _this.unblurId = "";
        _this.columns = [];
        _this.orderStatus = orders_orderStatus["a" /* OrderStatus */];
        _this.orderHelper = orderHelper_OrderHelper;
        _this.calculatorHelper = calculatorHelper["a" /* CalculatorHelper */];
        _this.orderOptions = orderOptions["a" /* OrderOptions */];
        if (_this.route.snapshot.data && _this.route.snapshot.data.canadianCurrencyCodes)
            _this.canadianCurrencyCodes = _this.route.snapshot.data.canadianCurrencyCodes.Data;
        return _this;
    }
    Object.defineProperty(OrderItemComponent.prototype, "topClassStyle", {
        get: function () {
            var o = {};
            o[this.topClass] = true;
            o["disabled"] = this.isDisabled;
            return o;
        },
        enumerable: true,
        configurable: true
    });
    OrderItemComponent.prototype.goToDetails = function (id) {
        this.goToDetailsBase(id, this.router, this.paramsInUrl, this.unblurId, this.order);
    };
    OrderItemComponent.prototype.getTotalPrice = function () {
        var result = 0;
        for (var _i = 0, _a = this.order.OrderItems; _i < _a.length; _i++) {
            var item = _a[_i];
            result += item.Total.TotalPrice;
        }
        return result;
    };
    OrderItemComponent.prototype.getColumnByName = function (name) {
        return this.columns.find(function (x) { return x.Name == name; });
    };
    OrderItemComponent.ctorParameters = function () { return [{ type: router_es5["n" /* Router */] }, { type: router_es5["a" /* ActivatedRoute */] }]; };
    return OrderItemComponent;
}(base_order_item_component_BaseOrderItemComponent));

//# sourceMappingURL=orderItem.component.js.map
// EXTERNAL MODULE: ./node_modules/ngx-tooltip/Tooltip.js
var Tooltip = __webpack_require__("Z/0s");
var Tooltip_default = /*#__PURE__*/__webpack_require__.n(Tooltip);

// CONCATENATED MODULE: ./compiled/app/components/Managment/orderManagement/orderItem/orderItem.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */







var styles_OrderItemComponent = [];
var RenderType_OrderItemComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_OrderItemComponent, data: {} });
function View_OrderItemComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'edited']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class',
                'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['mode_edit'])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_OrderItemComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'card-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Order ID:'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'category']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ('BB-' + _co.order.Id);
        _ck(_v, 6, 0, currVal_0);
    });
}
function View_OrderItemComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'card-title text-ellipsis-inline']], [[8, 'title', 0]], null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ': '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-xs-7 card-info short-description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, '', _v.context.$implicit.Name, '');
        _ck(_v, 4, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.Name.trim();
        _ck(_v, 5, 0, currVal_1);
        var currVal_2 = _co.orderHelper.formatValue(_v.context.$implicit.Property, _v.context.$implicit.Name, _co.order, _co.canadianCurrencyCodes);
        _ck(_v, 9, 0, currVal_2);
    });
}
function View_OrderItemComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 33, 'div', [['class',
                'customer-card']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'tooltip-content', [['class', 'custom-tooltip'], ['placement', 'top']], [[8,
                'hidden', 0]], null, null, View_TooltipContent_0, RenderType_TooltipContent)),
        core_es5["ɵdid"](4243456, [['myTooltip', 4]], 0, TooltipContent["TooltipContent"], [core_es5["ElementRef"], core_es5["ChangeDetectorRef"]], { placement: [0, 'placement'], animation: [1, 'animation'] }, null), (_l()(),
            core_es5["ɵted"](0, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'card card-stats quick-order-details']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.goToDetails(_co.order.Id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](16777216, null, null, 6, 'div', [['class',
                'card-header'], ['tooltipPlacement', 'top']], [[1, 'data-background-color', 0]], [[null, 'focusin'], [null, 'mouseenter'], [null, 'focusout'],
            [null, 'mouseleave']], function (_v, en, $event) {
            var ad = true;
            if (('focusin' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 11).show() !== false);
                ad = (pd_0 && ad);
            }
            if (('mouseenter' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 11).show() !== false);
                ad = (pd_1 && ad);
            }
            if (('focusout' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 11).hide() !== false);
                ad = (pd_2 && ad);
            }
            if (('mouseleave' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 11).hide() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, Tooltip["Tooltip"], [core_es5["ViewContainerRef"], core_es5["ComponentFactoryResolver"]], { content: [0, 'content'],
            tooltipPlacement: [1, 'tooltipPlacement'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        (_l()(), core_es5["ɵted"](null, ['', ' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_OrderItemComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderItemComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'card-footer']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderItemComponent_3)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'customer-card';
        var currVal_1 = _co.topClassStyle;
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_3 = 'top';
        var currVal_4 = true;
        _ck(_v, 4, 0, currVal_3, currVal_4);
        var currVal_6 = 'card card-stats quick-order-details';
        var currVal_7 = _co.topClassNext;
        _ck(_v, 8, 0, currVal_6, currVal_7);
        var currVal_9 = core_es5["ɵnov"](_v, 4);
        var currVal_10 = 'top';
        _ck(_v, 11, 0, currVal_9, currVal_10);
        var currVal_11 = 'material-icons';
        var currVal_12 = (((_co.order.Status == _co.orderStatus.Closed) || (_co.order.Status == _co.orderStatus.BorderCrossed)) ? 'green' : 'brand');
        _ck(_v, 14, 0, currVal_11, currVal_12);
        var currVal_14 = _co.calculatorHelper.IsBBFeeEdited(_co.order);
        _ck(_v, 21, 0, currVal_14);
        var tmp_15_0 = null;
        var currVal_15 = (((tmp_15_0 = _co.getColumnByName('Order ID')) == null) ? null : tmp_15_0.IsSelected);
        _ck(_v, 24, 0, currVal_15);
        var currVal_16 = _co.columns;
        _ck(_v, 30, 0, currVal_16);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.isMobile();
        _ck(_v, 3, 0, currVal_2);
        var currVal_5 = _co.orderHelper.getTooltipText(_co.order.Status);
        _ck(_v, 5, 0, currVal_5);
        var currVal_8 = (((_co.order.Status == _co.orderStatus.Closed) || (_co.order.Status == _co.orderStatus.BorderCrossed)) ? 'green-light' : 'orange-light');
        _ck(_v, 10, 0, currVal_8);
        var currVal_13 = _co.orderHelper.getOrderIcon(_co.order.Status);
        _ck(_v, 15, 0, currVal_13);
    });
}
function View_OrderItemComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-item', [], null, null, null, View_OrderItemComponent_0, RenderType_OrderItemComponent)),
        core_es5["ɵdid"](49152, null, 0, orderItem_component_OrderItemComponent, [router_es5["n" /* Router */], router_es5["a" /* ActivatedRoute */]], null, null)], null, null);
}
var OrderItemComponentNgFactory = core_es5["ɵccf"]('order-item', orderItem_component_OrderItemComponent, View_OrderItemComponent_Host_0, { order: 'order', topClass: 'topClass',
    topClassNext: 'topClassNext', paramsInUrl: 'paramsInUrl', isDisabled: 'isDisabled',
    unblurId: 'unblurId', columns: 'columns' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=orderItem.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/common/formInput/formInput.component.ts




var formInput_component_FormInputComponent = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](FormInputComponent, _super);
    function FormInputComponent(validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this.validators = validators;
        _this.asyncValidators = asyncValidators;
        _this.hasErrors = false;
        _this.isPlaceholderNeed = false;
        _this.autofocus = false;
        _this.stringHelper = String;
        return _this;
    }
    FormInputComponent.prototype.ngOnInit = function () {
        this.type = this.type || "text";
        this.disabled = this.disabled || false;
    };
    FormInputComponent.prototype.ngAfterViewInit = function () {
        this.model.control.setValidators(this.validators);
        this.model.control.setAsyncValidators(this.asyncValidators);
    };
    FormInputComponent.ctorParameters = function () { return [{ type: Array, decorators: [{ type: core_es5["Optional"] }, { type: core_es5["Inject"], args: [forms_es5["NG_VALIDATORS"]] }] }, { type: Array, decorators: [{ type: core_es5["Optional"] }, { type: core_es5["Inject"], args: [forms_es5["NG_ASYNC_VALIDATORS"]] }] }]; };
    return FormInputComponent;
}(ValueAccessorBase));

//# sourceMappingURL=formInput.component.js.map
// CONCATENATED MODULE: ./app/common/directives/trimValueAccessor.ts



var TRIM_VALUE_ACCESSOR = {
    provide: forms_es5["NG_VALUE_ACCESSOR"],
    useExisting: Object(core_es5["forwardRef"])(function () { return trimValueAccessor_TrimValueAccessor; }),
    multi: true
};
var trimValueAccessor_TrimValueAccessor = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](TrimValueAccessor, _super);
    function TrimValueAccessor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ngOnChange = function (val) {
            _this.onChange(val.trim());
        };
        return _this;
    }
    TrimValueAccessor.prototype.writeValue = function (value) {
        if (typeof value === 'string')
            value = value.trim();
        _super.prototype.writeValue.call(this, value);
    };
    return TrimValueAccessor;
}(forms_es5["DefaultValueAccessor"]));

//# sourceMappingURL=trimValueAccessor.js.map
// CONCATENATED MODULE: ./app/common/directives/onFocus.ts

var onFocus_OnFocusDirective = /** @class */ (function () {
    function OnFocusDirective(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.el = this.elementRef;
    }
    OnFocusDirective.prototype.onFocus = function (e) {
        var elRef = this.elementRef.nativeElement.parentElement;
        while (elRef != null) {
            if (elRef.classList.contains(this.onFocusClass))
                break;
            elRef = elRef.parentElement;
        }
        if (elRef != null)
            this.renderer.addClass(elRef, this.focusClass);
        return;
    };
    OnFocusDirective.prototype.onBlur = function (e) {
        var elRef = this.elementRef.nativeElement.parentElement;
        while (elRef != null) {
            if (elRef.classList.contains(this.onFocusClass))
                break;
            elRef = elRef.parentElement;
        }
        if (elRef != null)
            this.renderer.removeClass(elRef, this.focusClass);
        return;
    };
    OnFocusDirective.ctorParameters = function () { return [{ type: core_es5["ElementRef"] }, { type: core_es5["Renderer2"] }]; };
    return OnFocusDirective;
}());

//# sourceMappingURL=onFocus.js.map
// CONCATENATED MODULE: ./compiled/app/components/common/formInput/formInput.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_FormInputComponent = [];
var RenderType_FormInputComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_FormInputComponent, data: {} });
function View_FormInputComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'label', [['class',
                'control-label text-ellipsis-inline']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.label;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_FormInputComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { model: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class', 'form-group label-floating']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0,
            'is-empty': 1 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_FormInputComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'input', [['class', 'form-control'], ['onFocusClass', 'form-group']], [[8, 'type', 0], [1, 'data-autofocus', 0], [1, 'name', 0], [1, 'placeholder', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend'], [null, 'focus']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 9)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 9).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 9)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 9)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 10).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 15).onFocus($event) !== false);
                ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
                var pd_6 = (core_es5["ɵnov"](_v, 15).onBlur($event) !== false);
                ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_7 = ((_co.value = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"], core_es5["ElementRef"],
            [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, [[1, 4]], 0, forms_es5["NgModel"], [[8, null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { isDisabled: [0, 'isDisabled'], model: [1, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        core_es5["ɵdid"](16384, null, 0, onFocus_OnFocusDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], { focusClass: [0, 'focusClass'], onFocusClass: [1, 'onFocusClass'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'material-input']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), core_es5["ɵncd"](null, 0), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'form-group label-floating';
        var currVal_1 = _ck(_v, 3, 0, ((((!_co.disabled && (_co.form != null)) && (!_co.model.pristine || _co.form.submitted)) && !_co.model.valid) || _co.hasErrors), (_co.stringHelper.isNullOrEmpty(_co.innerValue) && !_co.isPlaceholderNeed));
        _ck(_v, 2, 0, currVal_0, currVal_1);
        var currVal_2 = _co.label;
        _ck(_v, 6, 0, currVal_2);
        var currVal_14 = _co.disabled;
        var currVal_15 = _co.value;
        _ck(_v, 12, 0, currVal_14, currVal_15);
        var currVal_16 = 'is-focused';
        var currVal_17 = 'form-group';
        _ck(_v, 15, 0, currVal_16, currVal_17);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = _co.type;
        var currVal_4 = _co.autofocus;
        var currVal_5 = _co.name;
        var currVal_6 = (_co.isPlaceholderNeed ? _co.placeholder : '');
        var currVal_7 = core_es5["ɵnov"](_v, 14).ngClassUntouched;
        var currVal_8 = core_es5["ɵnov"](_v, 14).ngClassTouched;
        var currVal_9 = core_es5["ɵnov"](_v, 14).ngClassPristine;
        var currVal_10 = core_es5["ɵnov"](_v, 14).ngClassDirty;
        var currVal_11 = core_es5["ɵnov"](_v, 14).ngClassValid;
        var currVal_12 = core_es5["ɵnov"](_v, 14).ngClassInvalid;
        var currVal_13 = core_es5["ɵnov"](_v, 14).ngClassPending;
        _ck(_v, 8, 1, [currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9,
            currVal_10, currVal_11, currVal_12, currVal_13]);
    });
}
function View_FormInputComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'form-input', [], null, null, null, View_FormInputComponent_0, RenderType_FormInputComponent)),
        core_es5["ɵprd"](5120, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], null, null)], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
var FormInputComponentNgFactory = core_es5["ɵccf"]('form-input', formInput_component_FormInputComponent, View_FormInputComponent_Host_0, { hasErrors: 'hasErrors', type: 'type',
    name: 'name', label: 'label', disabled: 'disabled', form: 'form', placeholder: 'placeholder',
    isPlaceholderNeed: 'isPlaceholderNeed', autofocus: 'autofocus' }, {}, ['*']);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=formInput.component.ngfactory.js.map
// CONCATENATED MODULE: ./node_modules/ngx-currency/src/currency-mask.config.js

var CURRENCY_MASK_CONFIG = new core_es5["InjectionToken"]("currency.mask.config");
//# sourceMappingURL=currency-mask.config.js.map
// CONCATENATED MODULE: ./node_modules/ngx-currency/src/input.manager.js
var InputManager = (function () {
    function InputManager(htmlInputElement) {
        this.htmlInputElement = htmlInputElement;
    }
    InputManager.prototype.setCursorAt = function (position) {
        if (this.htmlInputElement.setSelectionRange) {
            this.htmlInputElement.focus();
            this.htmlInputElement.setSelectionRange(position, position);
        }
        else if (this.htmlInputElement.createTextRange) {
            var textRange = this.htmlInputElement.createTextRange();
            textRange.collapse(true);
            textRange.moveEnd("character", position);
            textRange.moveStart("character", position);
            textRange.select();
        }
    };
    InputManager.prototype.updateValueAndCursor = function (newRawValue, oldLength, selectionStart) {
        this.rawValue = newRawValue;
        var newLength = newRawValue.length;
        selectionStart = selectionStart - (oldLength - newLength);
        this.setCursorAt(selectionStart);
    };
    Object.defineProperty(InputManager.prototype, "canInputMoreNumbers", {
        get: function () {
            var haventReachedMaxLength = !(this.rawValue.length >= this.htmlInputElement.maxLength && this.htmlInputElement.maxLength >= 0);
            var selectionStart = this.inputSelection.selectionStart;
            var selectionEnd = this.inputSelection.selectionEnd;
            var haveNumberSelected = !!(selectionStart != selectionEnd &&
                this.htmlInputElement.value.substring(selectionStart, selectionEnd).match(/[^0-9\u0660-\u0669\u06F0-\u06F9]/));
            var startWithZero = (this.htmlInputElement.value.substring(0, 1) == "0");
            return haventReachedMaxLength || haveNumberSelected || startWithZero;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputManager.prototype, "inputSelection", {
        get: function () {
            var selectionStart = 0;
            var selectionEnd = 0;
            if (typeof this.htmlInputElement.selectionStart == "number" && typeof this.htmlInputElement.selectionEnd == "number") {
                selectionStart = this.htmlInputElement.selectionStart;
                selectionEnd = this.htmlInputElement.selectionEnd;
            }
            else {
                var range = document.selection.createRange();
                if (range && range.parentElement() == this.htmlInputElement) {
                    var lenght = this.htmlInputElement.value.length;
                    var normalizedValue = this.htmlInputElement.value.replace(/\r\n/g, "\n");
                    var startRange = this.htmlInputElement.createTextRange();
                    startRange.moveToBookmark(range.getBookmark());
                    var endRange = this.htmlInputElement.createTextRange();
                    endRange.collapse(false);
                    if (startRange.compareEndPoints("StartToEnd", endRange) > -1) {
                        selectionStart = selectionEnd = lenght;
                    }
                    else {
                        selectionStart = -startRange.moveStart("character", -lenght);
                        selectionStart += normalizedValue.slice(0, selectionStart).split("\n").length - 1;
                        if (startRange.compareEndPoints("EndToEnd", endRange) > -1) {
                            selectionEnd = lenght;
                        }
                        else {
                            selectionEnd = -startRange.moveEnd("character", -lenght);
                            selectionEnd += normalizedValue.slice(0, selectionEnd).split("\n").length - 1;
                        }
                    }
                }
            }
            return {
                selectionStart: selectionStart,
                selectionEnd: selectionEnd
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputManager.prototype, "rawValue", {
        get: function () {
            return this.htmlInputElement && this.htmlInputElement.value;
        },
        set: function (value) {
            this._storedRawValue = value;
            if (this.htmlInputElement) {
                this.htmlInputElement.value = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputManager.prototype, "storedRawValue", {
        get: function () {
            return this._storedRawValue;
        },
        enumerable: true,
        configurable: true
    });
    return InputManager;
}());

//# sourceMappingURL=input.manager.js.map
// CONCATENATED MODULE: ./node_modules/ngx-currency/src/input.service.js

var input_service_InputService = (function () {
    function InputService(htmlInputElement, options) {
        this.htmlInputElement = htmlInputElement;
        this.options = options;
        this.PER_AR_NUMBER = new Map();
        this.inputManager = new InputManager(htmlInputElement);
        this.initialize();
    }
    InputService.prototype.initialize = function () {
        this.PER_AR_NUMBER.set("\u06F0", "0");
        this.PER_AR_NUMBER.set("\u06F1", "1");
        this.PER_AR_NUMBER.set("\u06F2", "2");
        this.PER_AR_NUMBER.set("\u06F3", "3");
        this.PER_AR_NUMBER.set("\u06F4", "4");
        this.PER_AR_NUMBER.set("\u06F5", "5");
        this.PER_AR_NUMBER.set("\u06F6", "6");
        this.PER_AR_NUMBER.set("\u06F7", "7");
        this.PER_AR_NUMBER.set("\u06F8", "8");
        this.PER_AR_NUMBER.set("\u06F9", "9");
        this.PER_AR_NUMBER.set("\u0660", "0");
        this.PER_AR_NUMBER.set("\u0661", "1");
        this.PER_AR_NUMBER.set("\u0662", "2");
        this.PER_AR_NUMBER.set("\u0663", "3");
        this.PER_AR_NUMBER.set("\u0664", "4");
        this.PER_AR_NUMBER.set("\u0665", "5");
        this.PER_AR_NUMBER.set("\u0666", "6");
        this.PER_AR_NUMBER.set("\u0667", "7");
        this.PER_AR_NUMBER.set("\u0668", "8");
        this.PER_AR_NUMBER.set("\u0669", "9");
    };
    InputService.prototype.addNumber = function (keyCode) {
        if (!this.rawValue) {
            this.rawValue = this.applyMask(false, "0");
        }
        var keyChar = String.fromCharCode(keyCode);
        var selectionStart = this.inputSelection.selectionStart;
        var selectionEnd = this.inputSelection.selectionEnd;
        this.rawValue = this.rawValue.substring(0, selectionStart) + keyChar + this.rawValue.substring(selectionEnd, this.rawValue.length);
        this.updateFieldValue(selectionStart + 1);
    };
    InputService.prototype.applyMask = function (isNumber, rawValue) {
        var _a = this.options, allowNegative = _a.allowNegative, decimal = _a.decimal, precision = _a.precision, prefix = _a.prefix, suffix = _a.suffix, thousands = _a.thousands, nullable = _a.nullable;
        rawValue = isNumber ? new Number(rawValue).toFixed(precision) : rawValue;
        var onlyNumbers = rawValue.replace(/[^0-9\u0660-\u0669\u06F0-\u06F9]/g, "");
        if (!onlyNumbers) {
            return "";
        }
        var integerPart = onlyNumbers.slice(0, onlyNumbers.length - precision)
            .replace(/^\u0660*/g, "")
            .replace(/^\u06F0*/g, "")
            .replace(/^0*/g, "")
            .replace(/\B(?=([0-9\u0660-\u0669\u06F0-\u06F9]{3})+(?![0-9\u0660-\u0669\u06F0-\u06F9]))/g, thousands);
        if (thousands && integerPart.startsWith(thousands)) {
            integerPart = integerPart.substring(1);
        }
        if (integerPart == "") {
            integerPart = "0";
        }
        var newRawValue = integerPart;
        var decimalPart = onlyNumbers.slice(onlyNumbers.length - precision);
        if (precision > 0) {
            newRawValue += decimal + decimalPart;
        }
        var isZero = parseInt(integerPart) == 0 && (parseInt(decimalPart) == 0 || decimalPart == "");
        var operator = (rawValue.indexOf("-") > -1 && allowNegative && !isZero) ? "-" : "";
        return operator + prefix + newRawValue + suffix;
    };
    InputService.prototype.clearMask = function (rawValue) {
        if (this.isNullable() && rawValue === "")
            return null;
        var value = (rawValue || "0").replace(this.options.prefix, "").replace(this.options.suffix, "");
        if (this.options.thousands) {
            value = value.replace(new RegExp("\\" + this.options.thousands, "g"), "");
        }
        if (this.options.decimal) {
            value = value.replace(this.options.decimal, ".");
        }
        this.PER_AR_NUMBER.forEach(function (val, key) {
            var re = new RegExp(key, "g");
            value = value.replace(re, val);
        });
        return parseFloat(value);
    };
    InputService.prototype.changeToNegative = function () {
        if (this.options.allowNegative && this.rawValue != "" && this.rawValue.charAt(0) != "-" && this.value != 0) {
            this.rawValue = "-" + this.rawValue;
        }
    };
    InputService.prototype.changeToPositive = function () {
        this.rawValue = this.rawValue.replace("-", "");
    };
    InputService.prototype.removeNumber = function (keyCode) {
        if (this.isNullable() && this.value == 0) {
            this.rawValue = null;
            return;
        }
        var selectionEnd = this.inputSelection.selectionEnd;
        var selectionStart = this.inputSelection.selectionStart;
        if (selectionStart > this.rawValue.length - this.options.suffix.length) {
            selectionEnd = this.rawValue.length - this.options.suffix.length;
            selectionStart = this.rawValue.length - this.options.suffix.length;
        }
        var move = this.rawValue.substr(selectionStart - 1, 1).match(/\d/) ? 0 : -1;
        if ((keyCode == 8 &&
            selectionStart - 1 === 0 &&
            !(this.rawValue.substr(selectionStart, 1).match(/\d/))) ||
            ((keyCode == 46 || keyCode == 63272) &&
                selectionStart === 0 &&
                !(this.rawValue.substr(selectionStart + 1, 1).match(/\d/)))) {
            move = 1;
        }
        ;
        selectionEnd = keyCode == 46 || keyCode == 63272 ? selectionEnd + 1 : selectionEnd;
        selectionStart = keyCode == 8 ? selectionStart - 1 : selectionStart;
        this.rawValue = this.rawValue.substring(0, selectionStart) + this.rawValue.substring(selectionEnd, this.rawValue.length);
        this.updateFieldValue(selectionStart + move);
    };
    InputService.prototype.updateFieldValue = function (selectionStart) {
        var newRawValue = this.applyMask(false, this.rawValue || "");
        selectionStart = selectionStart == undefined ? this.rawValue.length : selectionStart;
        this.inputManager.updateValueAndCursor(newRawValue, this.rawValue.length, selectionStart);
    };
    InputService.prototype.updateOptions = function (options) {
        var value = this.value;
        this.options = options;
        this.value = value;
    };
    InputService.prototype.prefixLength = function () {
        return this.options.prefix.length;
    };
    InputService.prototype.isNullable = function () {
        return this.options.nullable;
    };
    Object.defineProperty(InputService.prototype, "canInputMoreNumbers", {
        get: function () {
            return this.inputManager.canInputMoreNumbers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputService.prototype, "inputSelection", {
        get: function () {
            return this.inputManager.inputSelection;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputService.prototype, "rawValue", {
        get: function () {
            return this.inputManager.rawValue;
        },
        set: function (value) {
            this.inputManager.rawValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputService.prototype, "storedRawValue", {
        get: function () {
            return this.inputManager.storedRawValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputService.prototype, "value", {
        get: function () {
            return this.clearMask(this.rawValue);
        },
        set: function (value) {
            this.rawValue = this.applyMask(true, "" + value);
        },
        enumerable: true,
        configurable: true
    });
    return InputService;
}());

//# sourceMappingURL=input.service.js.map
// CONCATENATED MODULE: ./node_modules/ngx-currency/src/input.handler.js

var input_handler_InputHandler = (function () {
    function InputHandler(htmlInputElement, options) {
        this.inputService = new input_service_InputService(htmlInputElement, options);
    }
    InputHandler.prototype.handleCut = function (event) {
        var _this = this;
        setTimeout(function () {
            _this.inputService.updateFieldValue();
            _this.setValue(_this.inputService.value);
            _this.onModelChange(_this.inputService.value);
        }, 0);
    };
    InputHandler.prototype.handleInput = function (event) {
        var keyCode = this.inputService.rawValue.charCodeAt(this.inputService.rawValue.length - 1);
        var rawValueLength = this.inputService.rawValue.length;
        var rawValueSelectionEnd = this.inputService.inputSelection.selectionEnd;
        var storedRawValueLength = this.inputService.storedRawValue.length;
        this.inputService.rawValue = this.inputService.storedRawValue;
        if (rawValueLength != rawValueSelectionEnd || Math.abs(rawValueLength - storedRawValueLength) != 1) {
            this.setCursorPosition(event);
            return;
        }
        if (rawValueLength < storedRawValueLength) {
            this.inputService.removeNumber(8);
        }
        if (rawValueLength > storedRawValueLength) {
            switch (keyCode) {
                case 43:
                    this.inputService.changeToPositive();
                    break;
                case 45:
                    this.inputService.changeToNegative();
                    break;
                default:
                    if (!this.inputService.canInputMoreNumbers) {
                        return;
                    }
                    this.inputService.addNumber(keyCode);
            }
        }
        this.setCursorPosition(event);
        this.onModelChange(this.inputService.value);
    };
    InputHandler.prototype.handleKeydown = function (event) {
        var keyCode = event.which || event.charCode || event.keyCode;
        if (keyCode == 8 || keyCode == 46 || keyCode == 63272) {
            event.preventDefault();
            var selectionRangeLength = Math.abs(this.inputService.inputSelection.selectionEnd - this.inputService.inputSelection.selectionStart);
            if (selectionRangeLength == 0) {
                this.inputService.removeNumber(keyCode);
                this.onModelChange(this.inputService.value);
            }
            if (selectionRangeLength >= (this.inputService.rawValue.length - this.inputService.prefixLength())) {
                this.clearValue();
            }
        }
    };
    InputHandler.prototype.clearValue = function () {
        this.setValue(this.inputService.isNullable() ? null : 0);
        this.onModelChange(this.inputService.value);
    };
    InputHandler.prototype.handleKeypress = function (event) {
        var keyCode = event.which || event.charCode || event.keyCode;
        if (keyCode === 97 && event.ctrlKey) {
            return;
        }
        switch (keyCode) {
            case undefined:
            case 9:
            case 13:
            case 37:
            case 39:
                return;
            case 43:
                this.inputService.changeToPositive();
                break;
            case 45:
                this.inputService.changeToNegative();
                break;
            default:
                if (this.inputService.canInputMoreNumbers) {
                    var selectionRangeLength = Math.abs(this.inputService.inputSelection.selectionEnd - this.inputService.inputSelection.selectionStart);
                    if (selectionRangeLength == this.inputService.rawValue.length) {
                        this.setValue(0);
                    }
                    this.inputService.addNumber(keyCode);
                }
        }
        event.preventDefault();
        this.onModelChange(this.inputService.value);
    };
    InputHandler.prototype.handlePaste = function (event) {
        var _this = this;
        setTimeout(function () {
            _this.inputService.updateFieldValue();
            _this.setValue(_this.inputService.value);
            _this.onModelChange(_this.inputService.value);
        }, 1);
    };
    InputHandler.prototype.updateOptions = function (options) {
        this.inputService.updateOptions(options);
    };
    InputHandler.prototype.getOnModelChange = function () {
        return this.onModelChange;
    };
    InputHandler.prototype.setOnModelChange = function (callbackFunction) {
        this.onModelChange = callbackFunction;
    };
    InputHandler.prototype.getOnModelTouched = function () {
        return this.onModelTouched;
    };
    InputHandler.prototype.setOnModelTouched = function (callbackFunction) {
        this.onModelTouched = callbackFunction;
    };
    InputHandler.prototype.setValue = function (value) {
        this.inputService.value = value;
    };
    InputHandler.prototype.setCursorPosition = function (event) {
        setTimeout(function () {
            event.target.setSelectionRange(event.target.value.length, event.target.value.length);
        }, 0);
    };
    return InputHandler;
}());

//# sourceMappingURL=input.handler.js.map
// CONCATENATED MODULE: ./node_modules/ngx-currency/src/currency-mask.directive.js




var CURRENCYMASKDIRECTIVE_VALUE_ACCESSOR = {
    provide: forms_es5["NG_VALUE_ACCESSOR"],
    useExisting: Object(core_es5["forwardRef"])(function () { return currency_mask_directive_CurrencyMaskDirective; }),
    multi: true,
};
var currency_mask_directive_CurrencyMaskDirective = (function () {
    function CurrencyMaskDirective(currencyMaskConfig, elementRef, keyValueDiffers) {
        this.currencyMaskConfig = currencyMaskConfig;
        this.elementRef = elementRef;
        this.keyValueDiffers = keyValueDiffers;
        this.options = {};
        this.optionsTemplate = {
            align: "right",
            allowNegative: true,
            allowZero: true,
            decimal: ".",
            precision: 2,
            prefix: "$ ",
            suffix: "",
            thousands: ",",
            nullable: false
        };
        if (currencyMaskConfig) {
            this.optionsTemplate = currencyMaskConfig;
        }
        this.keyValueDiffer = keyValueDiffers.find({}).create();
    }
    CurrencyMaskDirective.prototype.ngAfterViewInit = function () {
        this.elementRef.nativeElement.style.textAlign = this.options ? this.options.align : this.optionsTemplate.align;
    };
    CurrencyMaskDirective.prototype.ngDoCheck = function () {
        if (this.keyValueDiffer.diff(this.options)) {
            this.elementRef.nativeElement.style.textAlign = this.options.align ? this.options.align : this.optionsTemplate.align;
            this.inputHandler.updateOptions(Object.assign({}, this.optionsTemplate, this.options));
        }
    };
    CurrencyMaskDirective.prototype.ngOnInit = function () {
        this.inputHandler = new input_handler_InputHandler(this.elementRef.nativeElement, Object.assign({}, this.optionsTemplate, this.options));
    };
    CurrencyMaskDirective.prototype.handleBlur = function (event) {
        this.inputHandler.getOnModelTouched().apply(event);
    };
    CurrencyMaskDirective.prototype.handleCut = function (event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handleCut(event);
        }
    };
    CurrencyMaskDirective.prototype.handleInput = function (event) {
        if (this.isChromeAndroid()) {
            this.inputHandler.handleInput(event);
        }
    };
    CurrencyMaskDirective.prototype.handleKeydown = function (event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handleKeydown(event);
        }
    };
    CurrencyMaskDirective.prototype.handleKeypress = function (event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handleKeypress(event);
        }
    };
    CurrencyMaskDirective.prototype.handlePaste = function (event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handlePaste(event);
        }
    };
    CurrencyMaskDirective.prototype.isChromeAndroid = function () {
        return /chrome/i.test(navigator.userAgent) && /android/i.test(navigator.userAgent);
    };
    CurrencyMaskDirective.prototype.registerOnChange = function (callbackFunction) {
        this.inputHandler.setOnModelChange(callbackFunction);
    };
    CurrencyMaskDirective.prototype.registerOnTouched = function (callbackFunction) {
        this.inputHandler.setOnModelTouched(callbackFunction);
    };
    CurrencyMaskDirective.prototype.setDisabledState = function (value) {
        this.elementRef.nativeElement.disabled = value;
    };
    CurrencyMaskDirective.prototype.writeValue = function (value) {
        this.inputHandler.setValue(value);
    };
    return CurrencyMaskDirective;
}());

currency_mask_directive_CurrencyMaskDirective.decorators = [
    { type: core_es5["Directive"], args: [{
                selector: "[currencyMask]",
                providers: [CURRENCYMASKDIRECTIVE_VALUE_ACCESSOR]
            },] },
];
/** @nocollapse */
currency_mask_directive_CurrencyMaskDirective.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: core_es5["Optional"] }, { type: core_es5["Inject"], args: [CURRENCY_MASK_CONFIG,] },] },
    { type: core_es5["ElementRef"], },
    { type: core_es5["KeyValueDiffers"], },
]; };
currency_mask_directive_CurrencyMaskDirective.propDecorators = {
    'options': [{ type: core_es5["Input"] },],
    'handleBlur': [{ type: core_es5["HostListener"], args: ["blur", ["$event"],] },],
    'handleCut': [{ type: core_es5["HostListener"], args: ["cut", ["$event"],] },],
    'handleInput': [{ type: core_es5["HostListener"], args: ["input", ["$event"],] },],
    'handleKeydown': [{ type: core_es5["HostListener"], args: ["keydown", ["$event"],] },],
    'handleKeypress': [{ type: core_es5["HostListener"], args: ["keypress", ["$event"],] },],
    'handlePaste': [{ type: core_es5["HostListener"], args: ["paste", ["$event"],] },],
};
//# sourceMappingURL=currency-mask.directive.js.map
// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/modal/modal.component.js
var modal_component = __webpack_require__("xpy0");

// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/component-loader/component-loader.factory.js
var component_loader_factory = __webpack_require__("F6a+");

// CONCATENATED MODULE: ./app/common/pipes/firstKeyPipe.ts
var FirstKeyPipe = /** @class */ (function () {
    function FirstKeyPipe() {
    }
    FirstKeyPipe.prototype.transform = function (obj) {
        if (obj == null)
            return null;
        var keys = Object.keys(obj);
        if (keys && keys.length > 0)
            return keys[0];
        return null;
    };
    return FirstKeyPipe;
}());

//# sourceMappingURL=firstKeyPipe.js.map
// EXTERNAL MODULE: ./app/components/Managment/customerManagement/modal/customerModal.component.ts
var customerModal_component = __webpack_require__("PdJh");

// CONCATENATED MODULE: ./node_modules/ngx-validators/src/util.js
var Util = (function () {
    function Util() {
    }
    Util.isNotPresent = function (control) {
        var value = control.value;
        if (value === undefined || value === null) {
            return true;
        }
        return value !== '' ? false : true;
    };
    ;
    Util.addError = function (control, errorId, value) {
        if (!control.errors) {
            control.setErrors((_a = {}, _a[errorId] = value, _a));
        }
        else if (!control.hasError(errorId)) {
            control.errors[errorId] = value;
        }
        var _a;
    };
    Util.removeError = function (control, errorId) {
        if (control.errors && control.hasError(errorId)) {
            delete control.errors[errorId];
        }
    };
    return Util;
}());

//# sourceMappingURL=util.js.map
// EXTERNAL MODULE: ./node_modules/ngx-validators/node_modules/google-libphonenumber/dist/libphonenumber.js
var libphonenumber = __webpack_require__("ZweM");
var libphonenumber_default = /*#__PURE__*/__webpack_require__.n(libphonenumber);

// CONCATENATED MODULE: ./node_modules/ngx-validators/src/phone/phone-validators.js


var regionsCode = {
    // Region code for global networks (e.g. +800 numbers).
    UN001: '001',
    AD: 'AD',
    AE: 'AE',
    AF: 'AF',
    AG: 'AG',
    AI: 'AI',
    AL: 'AL',
    AM: 'AM',
    AN: 'AN',
    AO: 'AO',
    AQ: 'AQ',
    AR: 'AR',
    AS: 'AS',
    AT: 'AT',
    AU: 'AU',
    AW: 'AW',
    AX: 'AX',
    AZ: 'AZ',
    BA: 'BA',
    BB: 'BB',
    BD: 'BD',
    BE: 'BE',
    BF: 'BF',
    BG: 'BG',
    BH: 'BH',
    BI: 'BI',
    BJ: 'BJ',
    BL: 'BL',
    BM: 'BM',
    BN: 'BN',
    BO: 'BO',
    BR: 'BR',
    BS: 'BS',
    BT: 'BT',
    BV: 'BV',
    BW: 'BW',
    BY: 'BY',
    BZ: 'BZ',
    CA: 'CA',
    CC: 'CC',
    CD: 'CD',
    CF: 'CF',
    CG: 'CG',
    CH: 'CH',
    CI: 'CI',
    CK: 'CK',
    CL: 'CL',
    CM: 'CM',
    CN: 'CN',
    CO: 'CO',
    CR: 'CR',
    CU: 'CU',
    CV: 'CV',
    CX: 'CX',
    CY: 'CY',
    CZ: 'CZ',
    DE: 'DE',
    DJ: 'DJ',
    DK: 'DK',
    DM: 'DM',
    DO: 'DO',
    DZ: 'DZ',
    EC: 'EC',
    EE: 'EE',
    EG: 'EG',
    EH: 'EH',
    ER: 'ER',
    ES: 'ES',
    ET: 'ET',
    FI: 'FI',
    FJ: 'FJ',
    FK: 'FK',
    FM: 'FM',
    FO: 'FO',
    FR: 'FR',
    GA: 'GA',
    GB: 'GB',
    GD: 'GD',
    GE: 'GE',
    GF: 'GF',
    GG: 'GG',
    GH: 'GH',
    GI: 'GI',
    GL: 'GL',
    GM: 'GM',
    GN: 'GN',
    GP: 'GP',
    GQ: 'GQ',
    GR: 'GR',
    GS: 'GS',
    GT: 'GT',
    GU: 'GU',
    GW: 'GW',
    GY: 'GY',
    HK: 'HK',
    HM: 'HM',
    HN: 'HN',
    HR: 'HR',
    HT: 'HT',
    HU: 'HU',
    ID: 'ID',
    IE: 'IE',
    IL: 'IL',
    IM: 'IM',
    IN: 'IN',
    IO: 'IO',
    IQ: 'IQ',
    IR: 'IR',
    IS: 'IS',
    IT: 'IT',
    JE: 'JE',
    JM: 'JM',
    JO: 'JO',
    JP: 'JP',
    KE: 'KE',
    KG: 'KG',
    KH: 'KH',
    KI: 'KI',
    KM: 'KM',
    KN: 'KN',
    KP: 'KP',
    KR: 'KR',
    KW: 'KW',
    KY: 'KY',
    KZ: 'KZ',
    LA: 'LA',
    LB: 'LB',
    LC: 'LC',
    LI: 'LI',
    LK: 'LK',
    LR: 'LR',
    LS: 'LS',
    LT: 'LT',
    LU: 'LU',
    LV: 'LV',
    LY: 'LY',
    MA: 'MA',
    MC: 'MC',
    MD: 'MD',
    ME: 'ME',
    MF: 'MF',
    MG: 'MG',
    MH: 'MH',
    MK: 'MK',
    ML: 'ML',
    MM: 'MM',
    MN: 'MN',
    MO: 'MO',
    MP: 'MP',
    MQ: 'MQ',
    MR: 'MR',
    MS: 'MS',
    MT: 'MT',
    MU: 'MU',
    MV: 'MV',
    MW: 'MW',
    MX: 'MX',
    MY: 'MY',
    MZ: 'MZ',
    NA: 'NA',
    NC: 'NC',
    NE: 'NE',
    NF: 'NF',
    NG: 'NG',
    NI: 'NI',
    NL: 'NL',
    NO: 'NO',
    NP: 'NP',
    NR: 'NR',
    NU: 'NU',
    NZ: 'NZ',
    OM: 'OM',
    PA: 'PA',
    PE: 'PE',
    PF: 'PF',
    PG: 'PG',
    PH: 'PH',
    PK: 'PK',
    PL: 'PL',
    PM: 'PM',
    PN: 'PN',
    PR: 'PR',
    PS: 'PS',
    PT: 'PT',
    PW: 'PW',
    PY: 'PY',
    QA: 'QA',
    RE: 'RE',
    RO: 'RO',
    RS: 'RS',
    RU: 'RU',
    RW: 'RW',
    SA: 'SA',
    SB: 'SB',
    SC: 'SC',
    SD: 'SD',
    SE: 'SE',
    SG: 'SG',
    SH: 'SH',
    SI: 'SI',
    SJ: 'SJ',
    SK: 'SK',
    SL: 'SL',
    SM: 'SM',
    SN: 'SN',
    SO: 'SO',
    SR: 'SR',
    ST: 'ST',
    SV: 'SV',
    SY: 'SY',
    SZ: 'SZ',
    TC: 'TC',
    TD: 'TD',
    TF: 'TF',
    TG: 'TG',
    TH: 'TH',
    TJ: 'TJ',
    TK: 'TK',
    TL: 'TL',
    TM: 'TM',
    TN: 'TN',
    TO: 'TO',
    TR: 'TR',
    TT: 'TT',
    TV: 'TV',
    TW: 'TW',
    TZ: 'TZ',
    UA: 'UA',
    UG: 'UG',
    UM: 'UM',
    US: 'US',
    UY: 'UY',
    UZ: 'UZ',
    VA: 'VA',
    VC: 'VC',
    VE: 'VE',
    VG: 'VG',
    VI: 'VI',
    VN: 'VN',
    VU: 'VU',
    WF: 'WF',
    WS: 'WS',
    YE: 'YE',
    YT: 'YT',
    ZA: 'ZA',
    ZM: 'ZM',
    ZW: 'ZW',
    // Official code for the unknown region.
    ZZ: 'ZZ'
};
var phone_validators_PhoneValidators = (function () {
    function PhoneValidators() {
    }
    PhoneValidators.checkRegionCode = function (local) {
        return !(regionsCode[local] === undefined);
    };
    ;
    PhoneValidators.isValidRegionCode = function (control) {
        if (Util.isNotPresent(control)) {
            return undefined;
        }
        if (!PhoneValidators.checkRegionCode(control.value)) {
            return { 'noValidRegionCode': true };
        }
        return undefined;
    };
    ;
    PhoneValidators.isPhoneNumber = function (local) {
        var validator = function (control) {
            if (Util.isNotPresent(control)) {
                return undefined;
            }
            if (!PhoneValidators.checkRegionCode(local)) {
                return { 'noValidRegionCode': true };
            }
            var phoneParser = libphonenumber["PhoneNumberUtil"].getInstance();
            var error = { 'noPhoneNumber': true };
            try {
                var phoneNumber = phoneParser.parse(control.value, local);
                if (phoneParser.isValidNumber(phoneNumber)) {
                    error = undefined;
                }
            }
            catch (err) {
                error = { 'noPhoneNumber': true };
            }
            return error;
        };
        return validator;
    };
    ;
    PhoneValidators.isPossibleNumberWithReason = function (local) {
        var validator = function (control) {
            if (Util.isNotPresent(control)) {
                return undefined;
            }
            if (!PhoneValidators.checkRegionCode(local)) {
                return { 'noValidRegionCode': true };
            }
            var phoneParser = libphonenumber["PhoneNumberUtil"].getInstance();
            var error = { 'noPhoneNumber': true };
            try {
                var phoneNumber = phoneParser.parse(control.value, local);
                var reason = phoneParser.isPossibleNumberWithReason(phoneNumber);
                switch (reason) {
                    case libphonenumber["PhoneNumberUtil"].ValidationResult.IS_POSSIBLE:
                        error = undefined;
                        break;
                    case libphonenumber["PhoneNumberUtil"].ValidationResult.TOO_LONG:
                        error = { 'phoneNumberTooLong': true };
                        break;
                    case libphonenumber["PhoneNumberUtil"].ValidationResult.TOO_SHORT:
                        error = { 'phoneNumberTooShort': true };
                        break;
                    case libphonenumber["PhoneNumberUtil"].ValidationResult.INVALID_COUNTRY_CODE:
                        error = { 'phoneNumberInvalidCountryCode': true };
                        break;
                    default:
                        error = { 'noPhoneNumber': true };
                        break;
                }
            }
            catch (err) {
                error = { 'noPhoneNumber': true };
            }
            return error;
        };
        return validator;
    };
    ;
    return PhoneValidators;
}());

//# sourceMappingURL=phone-validators.js.map
// CONCATENATED MODULE: ./node_modules/ngx-validators/src/phone/phone.directive.js



var phone_directive_PossiblePhoneValidatorDirective = (function () {
    function PossiblePhoneValidatorDirective() {
        this.possiblePhone = 'US';
    }
    PossiblePhoneValidatorDirective.prototype.ngOnInit = function () {
        this.validator = phone_validators_PhoneValidators.isPossibleNumberWithReason(this.possiblePhone);
    };
    PossiblePhoneValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    return PossiblePhoneValidatorDirective;
}());

phone_directive_PossiblePhoneValidatorDirective.decorators = [
    { type: core_es5["Directive"], args: [{
                selector: '[possiblePhone][formControlName],[possiblePhone][formControl],[possiblePhone][ngModel]',
                providers: [{
                        provide: forms_es5["NG_VALIDATORS"],
                        // tslint:disable-next-line:no-forward-ref
                        useExisting: Object(core_es5["forwardRef"])(function () { return phone_directive_PossiblePhoneValidatorDirective; }),
                        multi: true
                    }]
            },] },
];
/** @nocollapse */
phone_directive_PossiblePhoneValidatorDirective.ctorParameters = function () { return []; };
phone_directive_PossiblePhoneValidatorDirective.propDecorators = {
    'possiblePhone': [{ type: core_es5["Input"] },],
};
var phone_directive_PhoneValidatorDirective = (function () {
    function PhoneValidatorDirective() {
        this.phone = 'US';
    }
    PhoneValidatorDirective.prototype.ngOnInit = function () {
        this.validator = phone_validators_PhoneValidators.isPhoneNumber(this.phone);
    };
    PhoneValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    return PhoneValidatorDirective;
}());

phone_directive_PhoneValidatorDirective.decorators = [
    { type: core_es5["Directive"], args: [{
                selector: '[phone][formControlName],[phone][formControl],[phone][ngModel]',
                providers: [{
                        provide: forms_es5["NG_VALIDATORS"],
                        // tslint:disable-next-line:no-forward-ref
                        useExisting: Object(core_es5["forwardRef"])(function () { return phone_directive_PhoneValidatorDirective; }),
                        multi: true
                    }]
            },] },
];
/** @nocollapse */
phone_directive_PhoneValidatorDirective.ctorParameters = function () { return []; };
phone_directive_PhoneValidatorDirective.propDecorators = {
    'phone': [{ type: core_es5["Input"] },],
};
var phone_directive_CountryCodeValidatorDirective = (function () {
    function CountryCodeValidatorDirective() {
    }
    CountryCodeValidatorDirective.prototype.ngOnInit = function () {
        this.validator = phone_validators_PhoneValidators.isValidRegionCode;
    };
    CountryCodeValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    return CountryCodeValidatorDirective;
}());

phone_directive_CountryCodeValidatorDirective.decorators = [
    { type: core_es5["Directive"], args: [{
                selector: '[countryCode][formControlName],[countryCode][formControl],[countryCode][ngModel]',
                providers: [{
                        provide: forms_es5["NG_VALIDATORS"],
                        // tslint:disable-next-line:no-forward-ref
                        useExisting: Object(core_es5["forwardRef"])(function () { return phone_directive_CountryCodeValidatorDirective; }),
                        multi: true
                    }]
            },] },
];
/** @nocollapse */
phone_directive_CountryCodeValidatorDirective.ctorParameters = function () { return []; };
//# sourceMappingURL=phone.directive.js.map
// EXTERNAL MODULE: ./app/services/customerService.ts
var services_customerService = __webpack_require__("Tq/D");

// EXTERNAL MODULE: ./node_modules/ng2-toastr/src/toast-manager.js
var toast_manager = __webpack_require__("/XCR");
var toast_manager_default = /*#__PURE__*/__webpack_require__.n(toast_manager);

// EXTERNAL MODULE: ./app/services/extraDataService.ts
var services_extraDataService = __webpack_require__("PGpm");

// EXTERNAL MODULE: ./app/services/userViewService.ts
var services_userViewService = __webpack_require__("e4LZ");

// EXTERNAL MODULE: ./app/services/emailService.ts
var services_emailService = __webpack_require__("z/46");

// EXTERNAL MODULE: ./app/services/paymentService.ts
var services_paymentService = __webpack_require__("vw9J");

// CONCATENATED MODULE: ./compiled/app/components/Managment/customerManagement/modal/customerModal.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



























var styles_CustomerModalComponent = [];
var RenderType_CustomerModalComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CustomerModalComponent, data: {} });
function View_CustomerModalComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' First Name is required. ']))], null, null);
}
function View_CustomerModalComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Email is required. ']))], null, null);
}
function View_CustomerModalComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Email is invalid. ']))], null, null);
}
function View_CustomerModalComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Last Name is required. ']))], null, null);
}
function View_CustomerModalComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Is not a countryCode']))], null, null);
}
function View_CustomerModalComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Is not a phone number']))], null, null);
}
function View_CustomerModalComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Company name should be less than 50 digits']))], null, null);
}
function View_CustomerModalComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['Update CC data']))], null, null);
}
function View_CustomerModalComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['Request was sent']))], null, null);
}
function View_CustomerModalComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 10, 'button', [['class',
                'btn btn-dark-orange btn-round'], ['type', 'button']], [[8, 'disabled', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.updatePaymentData() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_10)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_11)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'ripple-container']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = !_co.updateRequestSent;
        _ck(_v, 4, 0, currVal_1);
        var currVal_2 = _co.updateRequestSent;
        _ck(_v, 7, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.updateRequestSent;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_CustomerModalComponent_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn btn-dark-orange btn-round'], ['type', 'button']], [[8, 'disabled', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.showProcessPaymentModal() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Process Payment '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'ripple-container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.sentText;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_CustomerModalComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 32, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-sm-4 col-xs-4 col-sm-push-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_9)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [['label',
                'Change in all open orders'], ['name', 'changeCustomers']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.changeCustomersForAll = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], form: [2, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'col-sm-5 col-xs-4 col-sm-pull-4 cc_request_wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_12)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class',
                'btn btn-round btn-light-orange'], ['type', 'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.viewAllOrders() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, ['View all orders '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'col-sm-3 col-xs-4']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-primary btn-round pull-right'],
            ['type', 'submit']], [[8, 'disabled', 0]], null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"],
            core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Save '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.showUpdatePaymentDataBtn;
        _ck(_v, 5, 0, currVal_0);
        var currVal_8 = 'changeCustomers';
        var currVal_9 = 'Change in all open orders';
        var currVal_10 = core_es5["ɵnov"](_v.parent, 35);
        _ck(_v, 8, 0, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'changeCustomers';
        var currVal_12 = _co.changeCustomersForAll;
        _ck(_v, 10, 0, currVal_11, currVal_12);
        var currVal_13 = _co.showProcessPaymentBtn;
        _ck(_v, 19, 0, currVal_13);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = core_es5["ɵnov"](_v, 12).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 12).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 12).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 12).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 12).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 12).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 12).ngClassPending;
        _ck(_v, 7, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_14 = (!_co.currentCustomer.Orders || (_co.currentCustomer.Orders.length == 0));
        _ck(_v, 21, 0, currVal_14);
        var currVal_15 = (_co.processing || (core_es5["ɵnov"](_v.parent, 35).submitted && !core_es5["ɵnov"](_v.parent, 35).valid));
        _ck(_v, 28, 0, currVal_15);
    });
}
function View_CustomerModalComponent_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['style', 'float:right']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-primary btn-round pull-right'],
                ['type', 'submit']], [[8, 'disabled', 0]], null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"],
            core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Save '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.processing || (core_es5["ɵnov"](_v.parent, 35).submitted && !core_es5["ɵnov"](_v.parent, 35).valid));
        _ck(_v, 4, 0, currVal_0);
    });
}
function View_CustomerModalComponent_15(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-item', [['topClass', 'col-md-4 col-sm-6'], ['topClassNext', 'quick-order-details-margin']], null, null, null, View_OrderItemComponent_0, RenderType_OrderItemComponent)),
        core_es5["ɵdid"](49152, null, 0, orderItem_component_OrderItemComponent, [router_es5["n" /* Router */], router_es5["a" /* ActivatedRoute */]], { order: [0, 'order'], topClass: [1, 'topClass'], topClassNext: [2, 'topClassNext'],
            columns: [3, 'columns'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _v.context.$implicit;
        var currVal_1 = 'col-md-4 col-sm-6';
        var currVal_2 = 'quick-order-details-margin';
        var currVal_3 = _co.tableColumns;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_CustomerModalComponent_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'modal-footer']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'row row_quick_order']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_15)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.currentCustomer.Orders;
        _ck(_v, 5, 0, currVal_0);
    }, null);
}
function View_CustomerModalComponent_18(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' File Number is required. ']))], null, null);
}
function View_CustomerModalComponent_19(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'loader customer_model_loader']], null, null, null, null, null))], null, null);
}
function View_CustomerModalComponent_20(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class',
                'btn btn-primary btn-round pull-right'], ['type', 'submit']], null, null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Submit ']))], null, null);
}
function View_CustomerModalComponent_17(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 89, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 86, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 83, 'form', [['class', 'form-horizontal payment_process'],
            ['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngSubmit'], [null, 'submit'],
            [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 6).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 6).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.processPayment(core_es5["ɵnov"](_v, 6).valid) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[4, 4], ['paymentProcessForm',
                4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 76, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'col-sm-12 line-form']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.paymentData.FileNumber = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['fileNumber', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CustomerModalComponent_18)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'div', [['class',
                'col-sm-12 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class', 'form-group label-floating']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'is-empty': 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label text-ellipsis-inline']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Charge Amount'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, [[7, 0], ['amount', 1]], null, 3, 'input', [['class',
                'form-control'], ['currencyMask', ''], ['name', 'amount'], ['onFocusClass', 'form-group'],
            ['type', 'text']], null, [[null, 'blur'], [null, 'cut'],
            [null, 'input'], [null, 'keydown'], [null, 'keypress'],
            [null, 'paste'], [null, 'focus']], function (_v, en, $event) {
            var ad = true;
            if (('blur' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 40).handleBlur($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('cut' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 40).handleCut($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('input' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 40).handleInput($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('keydown' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 40).handleKeydown($event) !== false);
                ad = (pd_3 && ad);
            }
            if (('keypress' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 40).handleKeypress($event) !== false);
                ad = (pd_4 && ad);
            }
            if (('paste' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 40).handlePaste($event) !== false);
                ad = (pd_5 && ad);
            }
            if (('focus' === en)) {
                var pd_6 = (core_es5["ɵnov"](_v, 41).onFocus($event) !== false);
                ad = (pd_6 && ad);
            }
            if (('blur' === en)) {
                var pd_7 = (core_es5["ɵnov"](_v, 41).onBlur($event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵprd"](5120, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [currency_mask_directive_CurrencyMaskDirective]), core_es5["ɵdid"](4538368, null, 0, currency_mask_directive_CurrencyMaskDirective, [[2, CURRENCY_MASK_CONFIG], core_es5["ElementRef"], core_es5["KeyValueDiffers"]], null, null), core_es5["ɵdid"](16384, null, 0, onFocus_OnFocusDirective, [core_es5["ElementRef"],
            core_es5["Renderer2"]], { focusClass: [0, 'focusClass'], onFocusClass: [1, 'onFocusClass'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'material-input']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 29, 'div', [['class',
                'col-sm-12 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 26, 'div', [['class', 'form-group label-floating']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'has-error': 0, 'is-empty': 1 }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label text-ellipsis-inline']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Currency'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 18, 'select', [['class', 'form-control'],
            ['name', 'currency'], ['required', '']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 57).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 57).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.CurrencyCode = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_3 = (_co.changeCCode() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'option', [['value', 'USD']], null, null, null, null, null)), core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"],
            core_es5["Renderer2"], [2, forms_es5["SelectControlValueAccessor"]]], { value: [0, 'value'] }, null),
        core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], { value: [0, 'value'] }, null), (_l()(), core_es5["ɵted"](null, ['USD'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'option', [['value', 'CAD']], null, null, null, null, null)), core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"],
            core_es5["Renderer2"], [2, forms_es5["SelectControlValueAccessor"]]], { value: [0, 'value'] }, null),
        core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], { value: [0, 'value'] }, null), (_l()(), core_es5["ɵted"](null, ['CAD'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-sm-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_19)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_20)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_15 = '';
        _ck(_v, 15, 0, currVal_15);
        var currVal_16 = 'text';
        var currVal_17 = 'FileNumber';
        var currVal_18 = 'File #';
        var currVal_19 = false;
        var currVal_20 = core_es5["ɵnov"](_v, 6);
        _ck(_v, 17, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20);
        var currVal_21 = 'FileNumber';
        var currVal_22 = false;
        var currVal_23 = _co.paymentData.FileNumber;
        _ck(_v, 19, 0, currVal_21, currVal_22, currVal_23);
        var currVal_24 = ((core_es5["ɵunv"](_v, 24, 0, _ck(_v, 25, 0, core_es5["ɵnov"](_v.parent.parent, 0), core_es5["ɵnov"](_v, 17).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 17).model.pristine || core_es5["ɵnov"](_v, 6).submitted));
        _ck(_v, 24, 0, currVal_24);
        var currVal_25 = 'form-group label-floating';
        var currVal_26 = _ck(_v, 33, 0, (core_es5["ɵnov"](_v, 38).value.length <= 0));
        _ck(_v, 32, 0, currVal_25, currVal_26);
        _ck(_v, 40, 0);
        var currVal_27 = 'is-focused';
        var currVal_28 = 'form-group';
        _ck(_v, 41, 0, currVal_27, currVal_28);
        var currVal_29 = 'form-group label-floating';
        var currVal_30 = _ck(_v, 51, 0, _co.CcError, !_co.CurrencyCode);
        _ck(_v, 50, 0, currVal_29, currVal_30);
        var currVal_39 = '';
        _ck(_v, 58, 0, currVal_39);
        var currVal_40 = 'currency';
        var currVal_41 = _co.CurrencyCode;
        _ck(_v, 61, 0, currVal_40, currVal_41);
        var currVal_42 = 'USD';
        _ck(_v, 66, 0, currVal_42);
        var currVal_43 = 'USD';
        _ck(_v, 67, 0, currVal_43);
        var currVal_44 = 'CAD';
        _ck(_v, 71, 0, currVal_44);
        var currVal_45 = 'CAD';
        _ck(_v, 72, 0, currVal_45);
        var currVal_46 = _co.showLoader;
        _ck(_v, 81, 0, currVal_46);
        var currVal_47 = !_co.showLoader;
        _ck(_v, 84, 0, currVal_47);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (core_es5["ɵnov"](_v, 15).required ? '' : null);
        var currVal_8 = core_es5["ɵnov"](_v, 21).ngClassUntouched;
        var currVal_9 = core_es5["ɵnov"](_v, 21).ngClassTouched;
        var currVal_10 = core_es5["ɵnov"](_v, 21).ngClassPristine;
        var currVal_11 = core_es5["ɵnov"](_v, 21).ngClassDirty;
        var currVal_12 = core_es5["ɵnov"](_v, 21).ngClassValid;
        var currVal_13 = core_es5["ɵnov"](_v, 21).ngClassInvalid;
        var currVal_14 = core_es5["ɵnov"](_v, 21).ngClassPending;
        _ck(_v, 14, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_31 = (core_es5["ɵnov"](_v, 58).required ? '' : null);
        var currVal_32 = core_es5["ɵnov"](_v, 63).ngClassUntouched;
        var currVal_33 = core_es5["ɵnov"](_v, 63).ngClassTouched;
        var currVal_34 = core_es5["ɵnov"](_v, 63).ngClassPristine;
        var currVal_35 = core_es5["ɵnov"](_v, 63).ngClassDirty;
        var currVal_36 = core_es5["ɵnov"](_v, 63).ngClassValid;
        var currVal_37 = core_es5["ɵnov"](_v, 63).ngClassInvalid;
        var currVal_38 = core_es5["ɵnov"](_v, 63).ngClassPending;
        _ck(_v, 56, 0, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38);
    });
}
function View_CustomerModalComponent_22(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-12 col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Congratulations'])),
        (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_CustomerModalComponent_23(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'div', [['class',
                'col-xs-12 col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' ', ' was successfully charged ',
            ' for shipment number ', ' '])), core_es5["ɵppd"](3)], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.currentCustomer.FirstName;
        var currVal_1 = _co.currentCustomer.LastName;
        var currVal_2 = core_es5["ɵunv"](_v, 1, 2, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent.parent.parent, 1), _co.paymentData.Amount, 'USD', true));
        var currVal_3 = _co.paymentData.FileNumber;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    });
}
function View_CustomerModalComponent_24(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-12 col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['UH OH!'])), (_l()(),
            core_es5["ɵted"](null, [' ']))], null, null);
}
function View_CustomerModalComponent_25(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class',
                'col-xs-12 col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' The credit card for ', ' ', ' didn\'t work. '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' The message from the system says: ', ' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.currentCustomer.FirstName;
        var currVal_1 = _co.currentCustomer.LastName;
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_2 = _co.paymentErrorMsg;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_CustomerModalComponent_21(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class',
                'row payment_responce_block']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_22)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_23)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_24)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_25)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.paymentSeccess;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _co.paymentSeccess;
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = !_co.paymentSeccess;
        _ck(_v, 9, 0, currVal_2);
        var currVal_3 = !_co.paymentSeccess;
        _ck(_v, 12, 0, currVal_3);
    }, null);
}
function View_CustomerModalComponent_16(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](16777216, [[6, 0], ['paymentProcessModalRef', 1]], null, 24, 'div', [['bsModal', ''], ['class', 'modal fade'], ['id', 'paymentProcessModal'],
            ['role', 'dialog']], null, [[null, 'onHidden'], [null,
                'click'], [null, 'keydown.esc']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown.esc' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 1).onEsc() !== false);
                ad = (pd_1 && ad);
            }
            if (('onHidden' === en)) {
                var pd_2 = (_co.onPaymentProcessModalHidden() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4341760, [[2, 4], ['paymentProcessModal',
                4]], 0, modal_component["a" /* ModalDirective */], [core_es5["ElementRef"], core_es5["ViewContainerRef"], core_es5["Renderer"], component_loader_factory["a" /* ComponentLoaderFactory */]], null, { onHidden: 'onHidden' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'modal-dialog modal-sm'],
                ['role', 'document']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'modal-lg': 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'modal-content']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['aria-label', 'Close'], ['class', 'close pull-right btn btn-round btn-white modal-close-btn'],
            ['data-dismiss', 'modal'], ['type', 'button']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).hide() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons modal-close-icon']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['close'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'modal-body']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_17)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_21)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'modal-dialog modal-sm';
        var currVal_1 = _ck(_v, 5, 0, _co.showbigModal);
        _ck(_v, 4, 0, currVal_0, currVal_1);
        var currVal_2 = !_co.showbigModal;
        _ck(_v, 17, 0, currVal_2);
        var currVal_3 = _co.showbigModal;
        _ck(_v, 20, 0, currVal_3);
    }, null);
}
function View_CustomerModalComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, FirstKeyPipe, []), core_es5["ɵpid"](0, common_es5["CurrencyPipe"], [core_es5["LOCALE_ID"]]), core_es5["ɵqud"](402653184, 1, { customerModal: 0 }), core_es5["ɵqud"](671088640, 2, { paymentProcessModal: 0 }),
        core_es5["ɵqud"](402653184, 3, { customerForm: 0 }), core_es5["ɵqud"](671088640, 4, { paymentProcessForm: 0 }),
        core_es5["ɵqud"](402653184, 5, { customerModalRef: 0 }), core_es5["ɵqud"](671088640, 6, { paymentProcessModalRef: 0 }),
        core_es5["ɵqud"](671088640, 7, { amount: 0 }), (_l()(), core_es5["ɵeld"](16777216, [[5, 0], ['customerModalRef',
                1]], null, 165, 'div', [['bsModal', ''], ['class', 'modal fade customer-modal'],
            ['id', 'myModal'], ['role', 'dialog']], null, [[null, 'onHidden'],
            [null, 'scroll'], [null, 'click'], [null, 'keydown.esc']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 10).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown.esc' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 10).onEsc() !== false);
                ad = (pd_1 && ad);
            }
            if (('onHidden' === en)) {
                var pd_2 = (_co.onModalHidden() !== false);
                ad = (pd_2 && ad);
            }
            if (('scroll' === en)) {
                var pd_3 = (_co.handleScroll() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4341760, [[1, 4], ['customerModal',
                4]], 0, modal_component["a" /* ModalDirective */], [core_es5["ElementRef"], core_es5["ViewContainerRef"], core_es5["Renderer"],
            component_loader_factory["a" /* ComponentLoaderFactory */]], null, { onHidden: 'onHidden' }), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 161, 'div', [['class', 'modal-dialog modal-lg'], ['role', 'document']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 158, 'div', [['class',
                'modal-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'modal-header header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'modal-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['aria-label', 'Close'], ['class', 'close pull-right btn btn-round btn-white modal-close-btn'],
            ['data-dismiss', 'modal'], ['type', 'button']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 10).hide() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons modal-close-icon']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['close'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 141, 'div', [['class', 'modal-body']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 138, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 135, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 132, 'form', [['class',
                'form-horizontal'], ['novalidate', '']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngSubmit'], [null,
                'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 35).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 35).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.save(core_es5["ɵnov"](_v, 35).valid) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[3, 4], ['customerForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 125, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 94, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-sm-3']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-header thumbnail default-image margin-bottom-0'],
                ['data-background-color', 'orange']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['person'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 82, 'div', [['class', 'col-sm-9']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 40, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'col-sm-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'form-input', [['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentCustomer.FirstName = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['firstNameModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CustomerModalComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class',
                'col-sm-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'form-input', [['pattern', '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'],
            ['required', '']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentCustomer.Email = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['emailModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], disabled: [3, 'disabled'],
            form: [4, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CustomerModalComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CustomerModalComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 37, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'col-sm-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 12, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2,
                    'ng-valid', null], [2, 'ng-invalid', null], [2,
                    'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.currentCustomer.LastName = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['lastNameModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CustomerModalComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'col-sm-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['possiblePhone', 'US']], [[2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentCustomer.Phone = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](81920, null, 0, phone_directive_PossiblePhoneValidatorDirective, [], { possiblePhone: [0,
                'possiblePhone'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [phone_directive_PossiblePhoneValidatorDirective]), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], disabled: [3, 'disabled'],
            form: [4, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, [['phoneModel', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_CustomerModalComponent_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_CustomerModalComponent_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class',
                'row card-bottom-row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-sm-8 left-input line-form']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 14, 'div', [['class', 'col-sm-5 right-input line-form']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['maxlength', '49']], [[1, 'maxlength', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentCustomer.Company.Name = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](540672, null, 0, forms_es5["MaxLengthValidator"], [], { maxlength: [0, 'maxlength'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["MaxLengthValidator"]]), core_es5["ɵdid"](4308992, [['companyModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_CustomerModalComponent_7)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_13)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_14)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerModalComponent_16)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_16 = '';
        _ck(_v, 59, 0, currVal_16);
        var currVal_17 = 'text';
        var currVal_18 = 'First Name';
        var currVal_19 = 'First Name';
        var currVal_20 = false;
        var currVal_21 = core_es5["ɵnov"](_v, 35);
        _ck(_v, 61, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21);
        var currVal_22 = 'First Name';
        var currVal_23 = false;
        var currVal_24 = _co.currentCustomer.FirstName;
        _ck(_v, 63, 0, currVal_22, currVal_23, currVal_24);
        var currVal_25 = ((core_es5["ɵunv"](_v, 68, 0, _ck(_v, 69, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 61).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 61).model.pristine || core_es5["ɵnov"](_v, 35).submitted));
        _ck(_v, 68, 0, currVal_25);
        var currVal_35 = '';
        _ck(_v, 76, 0, currVal_35);
        var currVal_36 = '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
        _ck(_v, 77, 0, currVal_36);
        var currVal_37 = 'text';
        var currVal_38 = 'Email';
        var currVal_39 = 'Email';
        var currVal_40 = false;
        var currVal_41 = core_es5["ɵnov"](_v, 35);
        _ck(_v, 79, 0, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41);
        var currVal_42 = 'Email';
        var currVal_43 = false;
        var currVal_44 = _co.currentCustomer.Email;
        _ck(_v, 81, 0, currVal_42, currVal_43, currVal_44);
        var currVal_45 = ((core_es5["ɵunv"](_v, 86, 0, _ck(_v, 87, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 79).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 61).model.pristine || core_es5["ɵnov"](_v, 35).submitted));
        _ck(_v, 86, 0, currVal_45);
        var currVal_46 = ((core_es5["ɵunv"](_v, 90, 0, _ck(_v, 91, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 79).model.errors)) == 'pattern') && (!core_es5["ɵnov"](_v, 61).model.pristine || core_es5["ɵnov"](_v, 35).submitted));
        _ck(_v, 90, 0, currVal_46);
        var currVal_55 = '';
        _ck(_v, 101, 0, currVal_55);
        var currVal_56 = 'text';
        var currVal_57 = 'Last Name';
        var currVal_58 = 'Last Name';
        var currVal_59 = false;
        var currVal_60 = core_es5["ɵnov"](_v, 35);
        _ck(_v, 103, 0, currVal_56, currVal_57, currVal_58, currVal_59, currVal_60);
        var currVal_61 = 'Last Name';
        var currVal_62 = false;
        var currVal_63 = _co.currentCustomer.LastName;
        _ck(_v, 105, 0, currVal_61, currVal_62, currVal_63);
        var currVal_64 = ((core_es5["ɵunv"](_v, 110, 0, _ck(_v, 111, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 103).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 103).model.pristine || core_es5["ɵnov"](_v, 35).submitted));
        _ck(_v, 110, 0, currVal_64);
        var currVal_72 = 'US';
        _ck(_v, 118, 0, currVal_72);
        var currVal_73 = 'text';
        var currVal_74 = 'Phone ';
        var currVal_75 = 'Phone (opt)';
        var currVal_76 = false;
        var currVal_77 = core_es5["ɵnov"](_v, 35);
        _ck(_v, 120, 0, currVal_73, currVal_74, currVal_75, currVal_76, currVal_77);
        var currVal_78 = 'Phone ';
        var currVal_79 = false;
        var currVal_80 = _co.currentCustomer.Phone;
        _ck(_v, 122, 0, currVal_78, currVal_79, currVal_80);
        var currVal_81 = core_es5["ɵnov"](_v, 122).hasError('noValidRegionCode');
        _ck(_v, 127, 0, currVal_81);
        var currVal_82 = core_es5["ɵnov"](_v, 122).hasError('noPhoneNumber');
        _ck(_v, 130, 0, currVal_82);
        var currVal_91 = '49';
        _ck(_v, 145, 0, currVal_91);
        var currVal_92 = 'text';
        var currVal_93 = 'Company';
        var currVal_94 = 'Company';
        var currVal_95 = false;
        var currVal_96 = core_es5["ɵnov"](_v, 35);
        _ck(_v, 147, 0, currVal_92, currVal_93, currVal_94, currVal_95, currVal_96);
        var currVal_97 = 'Company';
        var currVal_98 = false;
        var currVal_99 = _co.currentCustomer.Company.Name;
        _ck(_v, 149, 0, currVal_97, currVal_98, currVal_99);
        var currVal_100 = (core_es5["ɵnov"](_v, 147).model.hasError('maxlength') && !core_es5["ɵnov"](_v, 147).model.pristine);
        _ck(_v, 154, 0, currVal_100);
        var currVal_101 = _co.isEditMode;
        _ck(_v, 160, 0, currVal_101);
        var currVal_102 = !_co.isEditMode;
        _ck(_v, 163, 0, currVal_102);
        var currVal_103 = _co.isEditMode;
        _ck(_v, 171, 0, currVal_103);
        var currVal_104 = _co.isEditMode;
        _ck(_v, 177, 0, currVal_104);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.title;
        _ck(_v, 19, 0, currVal_0);
        var currVal_1 = core_es5["ɵnov"](_v, 37).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 37).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 37).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 37).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 37).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 37).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 37).ngClassPending;
        _ck(_v, 33, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_8 = (core_es5["ɵnov"](_v, 59).required ? '' : null);
        var currVal_9 = core_es5["ɵnov"](_v, 65).ngClassUntouched;
        var currVal_10 = core_es5["ɵnov"](_v, 65).ngClassTouched;
        var currVal_11 = core_es5["ɵnov"](_v, 65).ngClassPristine;
        var currVal_12 = core_es5["ɵnov"](_v, 65).ngClassDirty;
        var currVal_13 = core_es5["ɵnov"](_v, 65).ngClassValid;
        var currVal_14 = core_es5["ɵnov"](_v, 65).ngClassInvalid;
        var currVal_15 = core_es5["ɵnov"](_v, 65).ngClassPending;
        _ck(_v, 58, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15);
        var currVal_26 = (core_es5["ɵnov"](_v, 76).required ? '' : null);
        var currVal_27 = (core_es5["ɵnov"](_v, 77).pattern ? core_es5["ɵnov"](_v, 77).pattern : null);
        var currVal_28 = core_es5["ɵnov"](_v, 83).ngClassUntouched;
        var currVal_29 = core_es5["ɵnov"](_v, 83).ngClassTouched;
        var currVal_30 = core_es5["ɵnov"](_v, 83).ngClassPristine;
        var currVal_31 = core_es5["ɵnov"](_v, 83).ngClassDirty;
        var currVal_32 = core_es5["ɵnov"](_v, 83).ngClassValid;
        var currVal_33 = core_es5["ɵnov"](_v, 83).ngClassInvalid;
        var currVal_34 = core_es5["ɵnov"](_v, 83).ngClassPending;
        _ck(_v, 75, 0, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34);
        var currVal_47 = (core_es5["ɵnov"](_v, 101).required ? '' : null);
        var currVal_48 = core_es5["ɵnov"](_v, 107).ngClassUntouched;
        var currVal_49 = core_es5["ɵnov"](_v, 107).ngClassTouched;
        var currVal_50 = core_es5["ɵnov"](_v, 107).ngClassPristine;
        var currVal_51 = core_es5["ɵnov"](_v, 107).ngClassDirty;
        var currVal_52 = core_es5["ɵnov"](_v, 107).ngClassValid;
        var currVal_53 = core_es5["ɵnov"](_v, 107).ngClassInvalid;
        var currVal_54 = core_es5["ɵnov"](_v, 107).ngClassPending;
        _ck(_v, 100, 0, currVal_47, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54);
        var currVal_65 = core_es5["ɵnov"](_v, 124).ngClassUntouched;
        var currVal_66 = core_es5["ɵnov"](_v, 124).ngClassTouched;
        var currVal_67 = core_es5["ɵnov"](_v, 124).ngClassPristine;
        var currVal_68 = core_es5["ɵnov"](_v, 124).ngClassDirty;
        var currVal_69 = core_es5["ɵnov"](_v, 124).ngClassValid;
        var currVal_70 = core_es5["ɵnov"](_v, 124).ngClassInvalid;
        var currVal_71 = core_es5["ɵnov"](_v, 124).ngClassPending;
        _ck(_v, 117, 0, currVal_65, currVal_66, currVal_67, currVal_68, currVal_69, currVal_70, currVal_71);
        var currVal_83 = (core_es5["ɵnov"](_v, 145).maxlength ? core_es5["ɵnov"](_v, 145).maxlength : null);
        var currVal_84 = core_es5["ɵnov"](_v, 151).ngClassUntouched;
        var currVal_85 = core_es5["ɵnov"](_v, 151).ngClassTouched;
        var currVal_86 = core_es5["ɵnov"](_v, 151).ngClassPristine;
        var currVal_87 = core_es5["ɵnov"](_v, 151).ngClassDirty;
        var currVal_88 = core_es5["ɵnov"](_v, 151).ngClassValid;
        var currVal_89 = core_es5["ɵnov"](_v, 151).ngClassInvalid;
        var currVal_90 = core_es5["ɵnov"](_v, 151).ngClassPending;
        _ck(_v, 144, 0, currVal_83, currVal_84, currVal_85, currVal_86, currVal_87, currVal_88, currVal_89, currVal_90);
    });
}
function View_CustomerModalComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'customer-modal', [], null, [[null, 'scroll'], [null, 'mousewheel'],
            ['document', 'keydown']], function (_v, en, $event) {
            var ad = true;
            if (('scroll' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onMousewheel($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('mousewheel' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 1).onMousewheel($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('document:keydown' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 1).onArrowDown($event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, View_CustomerModalComponent_0, RenderType_CustomerModalComponent)), core_es5["ɵdid"](114688, null, 0, customerModal_component["a" /* CustomerModalComponent */], [services_customerService["a" /* CustomerService */], router_es5["n" /* Router */], toast_manager["ToastsManager"],
            core_es5["ChangeDetectorRef"], services_extraDataService["a" /* ExtraDataService */], services_userViewService["a" /* UserViewService */], services_emailService["a" /* EmailService */],
            managers_storageManager["a" /* StorageManager */], services_paymentService["a" /* PaymentService */], services_configService["a" /* ConfigService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CustomerModalComponentNgFactory = core_es5["ɵccf"]('customer-modal', customerModal_component["a" /* CustomerModalComponent */], View_CustomerModalComponent_Host_0, { idToBlur: 'idToBlur' }, { customerSaved: 'customerSaved' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=customerModal.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/theme/css/sideBar.css.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var sideBar_css_shim_ngstyle_styles = ['.logo[_ngcontent-%COMP%]{background-color:#e07e3c}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvdGhlbWUvY3NzL3NpZGVCYXIuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL3RoZW1lL2Nzcy9zaWRlQmFyLmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=sideBar.css.shim.ngstyle.js.map
// CONCATENATED MODULE: ./compiled/theme/css/sideMenu.css.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var sideMenu_css_shim_ngstyle_styles = ['.block[_ngcontent-%COMP%]{display:block!important;overflow:hidden!important;-webkit-transition:height .5s;transition:height .5s}.block[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:18px;padding-left:25px}.block[_ngcontent-%COMP%]   .sidebar-normal[_ngcontent-%COMP%]{margin-left:-40px!important}.block[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%]:hover:not(.active) > a[_ngcontent-%COMP%]{background-color:transparent;outline:none}.block[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#9e9e9e;pointer-events:none;cursor:not-allowed}.sidebar-moving-tab[_ngcontent-%COMP%]   span.material-icons[_ngcontent-%COMP%]{font-size:18px;padding-left:25px;float:left;margin-top:2px}.sidebar-moving-tab[_ngcontent-%COMP%]   span.sidebar-normal[_ngcontent-%COMP%]{margin-left:9px;vertical-align:top}p.menu-item-title[_ngcontent-%COMP%]{display:inline-block}button.menu-item-button[_ngcontent-%COMP%]{float:right;border:none;background:none;font-size:x-large;vertical-align:middle;margin-top:4px;position:absolute;right:8px}b.caret[_ngcontent-%COMP%]{float:right}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvdGhlbWUvY3NzL3NpZGVNZW51LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi90aGVtZS9jc3Mvc2lkZU1lbnUuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=sideMenu.css.shim.ngstyle.js.map
// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/collapse/collapse.directive.js
var collapse_directive = __webpack_require__("yASy");

// EXTERNAL MODULE: ./app/common/helpers/guidHelper.ts
var guidHelper = __webpack_require__("SCcC");

// CONCATENATED MODULE: ./app/components/sidebar/sideMenu/sideMenu.component.ts



var sideMenu_component_SideMenuComponent = /** @class */ (function () {
    function SideMenuComponent(renderer, router) {
        this.renderer = renderer;
        this.router = router;
        this.initialized = false;
        this.stringHelper = String;
    }
    SideMenuComponent.prototype.ngOnInit = function () {
        if (String.isNullOrEmpty(this.collapsedMenuPrefix)) {
            this.collapsedMenuPrefix = guidHelper["a" /* Guid */].newGuid();
        }
    };
    SideMenuComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            var stop = false;
            var menuRef = _this.menuRef.toArray();
            var menuDivRef = _this.menuDivRef.toArray();
            var menuChildRef = _this.menuChildRef.toArray();
            var menuIndex = 0;
            _this.menuItems.forEach(function (menu, index) {
                if (menuRef.length > index)
                    menu.Element = menuRef[index];
                else
                    menu.Element = menuDivRef[index];
                var div = menuDivRef[index];
                if (!menu.Collapsed) {
                    _this.setHeight(div.nativeElement, div.nativeElement.scrollHeight);
                }
                if (menu.Children == null || menu.Children.length == 0)
                    return true;
                menu.Children.forEach(function (item, childIndex) {
                    item.Element = menuChildRef[menuIndex + childIndex];
                    if (!stop) {
                        if (_this.router.isActive(item.Path, item.Exact)) {
                            menu.Collapsed = false;
                            _this.setMovingTabPosition(null);
                            stop = true;
                            return false;
                        }
                    }
                });
                menuIndex += menu.Children.length;
            });
            _this.initAnimation();
        }, 20);
    };
    SideMenuComponent.prototype.onCollapsed = function (event) {
        var _this = this;
        this.setHeight(event._el.nativeElement, 0);
        setTimeout(function () {
            _this.setMovingTabPosition(null);
        }, 500);
    };
    SideMenuComponent.prototype.onExpanded = function (event) {
        var _this = this;
        this.setHeight(event._el.nativeElement, 0);
        this.setHeight(event._el.nativeElement, event._el.nativeElement.scrollHeight);
        setTimeout(function () {
            _this.setMovingTabPosition(null);
        }, 500);
    };
    SideMenuComponent.prototype.setHeight = function (el, height) {
        this.renderer.setStyle(el, 'height', height + 'px');
    };
    SideMenuComponent.prototype.initAnimation = function () {
        var _this = this;
        setTimeout(function () {
            var activeMenu = _this.findActiveMenu(_this.router.url);
            if (activeMenu == null || activeMenu.Element == null)
                return;
            _this.activeMenu = activeMenu.Element.nativeElement;
            _this.initialized = true;
            _this.renderer.addClass(activeMenu.Element.nativeElement.parentElement, "visible");
            _this.router.events.subscribe(function (val) {
                if (!(val instanceof router_es5["d" /* GuardsCheckEnd */]))
                    return;
                if (!val.shouldActivate)
                    return;
                var activeMenu = _this.findActiveMenu(val.url);
                if (activeMenu == null || activeMenu.Element == null)
                    return;
                var parent = _this.findParentMenu(val.url);
                _this.activeMenu = activeMenu.Element.nativeElement;
                if (parent != null) {
                    parent.Collapsed = false;
                    setTimeout(function () {
                        _this.animateMovingTab();
                    }, 100);
                }
                else {
                    _this.animateMovingTab();
                }
            });
        });
    };
    SideMenuComponent.prototype.animateMovingTab = function () {
        var _this = this;
        clearTimeout(this.sidebarTimer);
        for (var _i = 0, _a = this.menuLiRef.toArray(); _i < _a.length; _i++) {
            var li = _a[_i];
            this.renderer.removeClass(li.nativeElement, 'visible');
            this.renderer.removeClass(li.nativeElement, 'active');
        }
        for (var _b = 0, _c = this.menuChildRef.toArray(); _b < _c.length; _b++) {
            var child = _c[_b];
            this.renderer.removeClass(child.nativeElement.parentElement, 'active');
        }
        this.movingTab.nativeElement.style.paddingLeft = window.getComputedStyle(this.activeMenu).paddingLeft;
        this.renderer.addClass(this.movingTab.nativeElement, 'moving');
        var button_text = this.activeMenu.innerHTML;
        this.setMovingTabPosition(this.activeMenu);
        this.sidebarTimer = setTimeout(function () {
            _this.renderer.removeClass(_this.movingTab.nativeElement, 'moving');
            _this.renderer.addClass(_this.activeMenu.parentElement, 'visible');
            _this.renderer.addClass(_this.activeMenu.parentElement, 'active');
            var parent = _this.findParentMenu(_this.router.url);
            if (parent != null) {
                _this.renderer.addClass(parent.Element.nativeElement.parentElement, 'active');
            }
        }, 650);
        setTimeout(function () {
            _this.movingTab.nativeElement.innerHTML = button_text;
        }, 10);
    };
    SideMenuComponent.prototype.setMovingTabPosition = function (currentActive) {
        if (!this.initialized)
            return;
        currentActive = currentActive || this.activeMenu;
        var li_distance = currentActive.parentElement.offsetTop - 10;
        var collapse = currentActive.closest('.collapse');
        if (collapse != null) {
            var parent_distance = collapse.parentElement.offsetTop;
            if (collapse.className.indexOf('in') != -1)
                li_distance = li_distance + parent_distance;
            else
                li_distance = parent_distance;
        }
        this.movingTab.nativeElement.style.transform = 'translate3d(0px,' + li_distance + 'px, 0)';
    };
    SideMenuComponent.prototype.findActiveMenu = function (url) {
        var activeMenu;
        for (var _i = 0, _a = this.menuItems; _i < _a.length; _i++) {
            var menu = _a[_i];
            if (menu.Path == url) {
                activeMenu = menu;
                break;
            }
            if (menu.Children == null || menu.Children.length == 0)
                continue;
            for (var _b = 0, _c = menu.Children; _b < _c.length; _b++) {
                var child = _c[_b];
                if (child.Path == url || (!child.Exact && url.startsWith(child.Path))) {
                    activeMenu = child;
                    break;
                }
            }
        }
        return activeMenu;
    };
    SideMenuComponent.prototype.findParentMenu = function (url) {
        var activeMenu;
        for (var _i = 0, _a = this.menuItems; _i < _a.length; _i++) {
            var menu = _a[_i];
            if (menu.Children == null || menu.Children.length == 0)
                continue;
            for (var _b = 0, _c = menu.Children; _b < _c.length; _b++) {
                var child = _c[_b];
                if (child.Path == url || (!child.Exact && url.startsWith(child.Path))) {
                    activeMenu = menu;
                    break;
                }
            }
        }
        return activeMenu;
    };
    SideMenuComponent.ctorParameters = function () { return [{ type: core_es5["Renderer2"] }, { type: router_es5["n" /* Router */] }]; };
    return SideMenuComponent;
}());

//# sourceMappingURL=sideMenu.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/sidebar/sideMenu/sideMenu.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_SideMenuComponent = [sideMenu_css_shim_ngstyle_styles];
var RenderType_SideMenuComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_SideMenuComponent, data: {} });
function View_SideMenuComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'button', [['class',
                'menu-item-button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (_v.parent.parent.context.$implicit.ButtonHandler() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.parent.context.$implicit.ButtonText;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_SideMenuComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, [[2, 0], ['menuItem', 1]], null, 11, 'a', [], [[1, 'target', 0], [8, 'href', 4]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](671744, [[7, 4]], 0, router_es5["p" /* RouterLinkWithHref */], [router_es5["n" /* Router */], router_es5["a" /* ActivatedRoute */], common_es5["LocationStrategy"]], { routerLink: [0, 'routerLink'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [], [[8, 'className', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'menu-item-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SideMenuComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_2 = _v.parent.context.$implicit.Path;
        _ck(_v, 1, 0, currVal_2);
        var currVal_6 = _v.parent.context.$implicit.ShowButton;
        _ck(_v, 10, 0, currVal_6);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).target;
        var currVal_1 = core_es5["ɵnov"](_v, 1).href;
        _ck(_v, 0, 0, currVal_0, currVal_1);
        var currVal_3 = _v.parent.context.$implicit.IconClass;
        _ck(_v, 3, 0, currVal_3);
        var currVal_4 = _v.parent.context.$implicit.Icon;
        _ck(_v, 4, 0, currVal_4);
        var currVal_5 = _v.parent.context.$implicit.Name;
        _ck(_v, 7, 0, currVal_5);
    });
}
function View_SideMenuComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'button', [['class',
                'menu-item-button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (_v.parent.parent.context.$implicit.ButtonHandler() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.parent.context.$implicit.ButtonText;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_SideMenuComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, [[2, 0], ['menuItem', 1]], null, 10, 'a', [['target', '_blank']], [[1, 'href', 4]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [], [[8, 'className', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'menu-item-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SideMenuComponent_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_4 = _v.parent.context.$implicit.ShowButton;
        _ck(_v, 9, 0, currVal_4);
    }, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.Path;
        _ck(_v, 0, 0, currVal_0);
        var currVal_1 = _v.parent.context.$implicit.IconClass;
        _ck(_v, 2, 0, currVal_1);
        var currVal_2 = _v.parent.context.$implicit.Icon;
        _ck(_v, 3, 0, currVal_2);
        var currVal_3 = _v.parent.context.$implicit.Name;
        _ck(_v, 6, 0, currVal_3);
    });
}
function View_SideMenuComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'b', [['class',
                'caret']], null, null, null, null, null))], null, null);
}
function View_SideMenuComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 10, 'a', [['class',
                'collapsed'], ['data-toggle', 'collapse']], [[1, 'aria-expanded', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = ((_v.parent.context.$implicit.Collapsed = !_v.parent.context.$implicit.Collapsed) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [], [[8, 'className', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['',
            ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'menu-item-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['',
            ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SideMenuComponent_7)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_4 = _v.parent.context.$implicit.ShowCaret;
        _ck(_v, 9, 0, currVal_4);
    }, function (_ck, _v) {
        var currVal_0 = !_v.parent.context.$implicit.Collapsed;
        _ck(_v, 0, 0, currVal_0);
        var currVal_1 = _v.parent.context.$implicit.IconClass;
        _ck(_v, 2, 0, currVal_1);
        var currVal_2 = _v.parent.context.$implicit.Icon;
        _ck(_v, 3, 0, currVal_2);
        var currVal_3 = _v.parent.context.$implicit.Name;
        _ck(_v, 6, 0, currVal_3);
    });
}
function View_SideMenuComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, [[4, 0], ['menuChild', 1]], null, 9, 'a', [], [[1, 'target', 0], [8, 'href', 4]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](671744, [[9, 4], [7, 4]], 0, router_es5["p" /* RouterLinkWithHref */], [router_es5["n" /* Router */], router_es5["a" /* ActivatedRoute */], common_es5["LocationStrategy"]], { routerLink: [0, 'routerLink'] }, null), core_es5["ɵpad"](1), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], [[8, 'className', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['',
            ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'sidebar-normal']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['',
            ''])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_2 = _ck(_v, 2, 0, _v.parent.context.$implicit.Path);
        _ck(_v, 1, 0, currVal_2);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).target;
        var currVal_1 = core_es5["ɵnov"](_v, 1).href;
        _ck(_v, 0, 0, currVal_0, currVal_1);
        var currVal_3 = _v.parent.context.$implicit.IconClass;
        _ck(_v, 4, 0, currVal_3);
        var currVal_4 = _v.parent.context.$implicit.Icon;
        _ck(_v, 5, 0, currVal_4);
        var currVal_5 = _v.parent.context.$implicit.Name;
        _ck(_v, 8, 0, currVal_5);
    });
}
function View_SideMenuComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, [[4, 0], ['menuChild', 1]], null, 7, 'a', [['target', '_blank']], [[1, 'href', 4]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], [[8, 'className', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'sidebar-normal']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(),
            core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.Path;
        _ck(_v, 0, 0, currVal_0);
        var currVal_1 = _v.parent.context.$implicit.IconClass;
        _ck(_v, 2, 0, currVal_1);
        var currVal_2 = _v.parent.context.$implicit.Icon;
        _ck(_v, 3, 0, currVal_2);
        var currVal_3 = _v.parent.context.$implicit.Name;
        _ck(_v, 6, 0, currVal_3);
    });
}
function View_SideMenuComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 16, 'ul', [['class',
                'nav child']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'li', [['routerLinkActive', 'active']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'disabled': 0 }), core_es5["ɵdid"](1720320, null, 2, router_es5["o" /* RouterLinkActive */], [router_es5["n" /* Router */], core_es5["ElementRef"], core_es5["Renderer2"], core_es5["ChangeDetectorRef"]], { routerLinkActiveOptions: [0, 'routerLinkActiveOptions'], routerLinkActive: [1,
                'routerLinkActive'] }, null), core_es5["ɵqud"](603979776, 8, { links: 1 }), core_es5["ɵqud"](603979776, 9, { linksWithHrefs: 1 }), core_es5["ɵpod"]({ exact: 0 }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SideMenuComponent_10)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SideMenuComponent_11)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_0 = _ck(_v, 4, 0, (_v.parent.parent.context.$implicit.Disabled || _v.context.$implicit.Disabled));
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _ck(_v, 8, 0, _v.context.$implicit.Exact);
        var currVal_2 = 'active';
        _ck(_v, 5, 0, currVal_1, currVal_2);
        var currVal_3 = !_v.context.$implicit.Path.startsWith('http');
        _ck(_v, 11, 0, currVal_3);
        var currVal_4 = _v.context.$implicit.Path.startsWith('http');
        _ck(_v, 14, 0, currVal_4);
    }, null);
}
function View_SideMenuComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, [[3, 0], ['menuItemDiv', 1]], null, 7, 'div', [['class', 'collapse block']], [[8, 'id', 0], [2, 'collapse', null], [4, 'display',
                null], [2, 'in', null], [2, 'show', null], [1, 'aria-expanded',
                0], [1, 'aria-hidden', 0], [2, 'collapsing', null]], [[null, 'collapsed'],
            [null, 'expanded']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('collapsed' === en)) {
                var pd_0 = (_co.onCollapsed($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('expanded' === en)) {
                var pd_1 = (_co.onExpanded($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'in show': 0 }), core_es5["ɵdid"](16384, null, 0, collapse_directive["a" /* CollapseDirective */], [core_es5["ElementRef"], core_es5["Renderer"]], { collapse: [0, 'collapse'] }, { collapsed: 'collapsed', expanded: 'expanded' }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SideMenuComponent_9)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_8 = 'collapse block';
        var currVal_9 = _ck(_v, 2, 0, !_v.parent.context.$implicit.Collapsed);
        _ck(_v, 1, 0, currVal_8, currVal_9);
        var currVal_10 = _v.parent.context.$implicit.Collapsed;
        _ck(_v, 3, 0, currVal_10);
        var currVal_11 = _v.parent.context.$implicit.Children;
        _ck(_v, 6, 0, currVal_11);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵinlineInterpolate"](2, '', _co.collapsedMenuPrefix, '_', _v.parent.context.index, '');
        var currVal_1 = core_es5["ɵnov"](_v, 3).isCollapse;
        var currVal_2 = core_es5["ɵnov"](_v, 3).display;
        var currVal_3 = core_es5["ɵnov"](_v, 3).isExpanded;
        var currVal_4 = core_es5["ɵnov"](_v, 3).isExpanded;
        var currVal_5 = core_es5["ɵnov"](_v, 3).isExpanded;
        var currVal_6 = core_es5["ɵnov"](_v, 3).isCollapsed;
        var currVal_7 = core_es5["ɵnov"](_v, 3).isCollapsing;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
    });
}
function View_SideMenuComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, [[1, 0], ['menuLi', 1]], null, 19, 'li', [['routerLinkActive',
                'active']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'disabled': 0 }),
        core_es5["ɵdid"](1720320, null, 2, router_es5["o" /* RouterLinkActive */], [router_es5["n" /* Router */], core_es5["ElementRef"],
            core_es5["Renderer2"], core_es5["ChangeDetectorRef"]], { routerLinkActiveOptions: [0, 'routerLinkActiveOptions'],
            routerLinkActive: [1, 'routerLinkActive'] }, null), core_es5["ɵqud"](603979776, 6, { links: 1 }), core_es5["ɵqud"](603979776, 7, { linksWithHrefs: 1 }), core_es5["ɵpod"]({ exact: 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SideMenuComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SideMenuComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SideMenuComponent_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SideMenuComponent_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, _v.context.$implicit.Disabled);
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _ck(_v, 6, 0, true);
        var currVal_2 = 'active';
        _ck(_v, 3, 0, currVal_1, currVal_2);
        var currVal_3 = (!_co.stringHelper.isNullOrEmpty(_v.context.$implicit.Path) && !_v.context.$implicit.Path.startsWith('http'));
        _ck(_v, 9, 0, currVal_3);
        var currVal_4 = (!_co.stringHelper.isNullOrEmpty(_v.context.$implicit.Path) && _v.context.$implicit.Path.startsWith('http'));
        _ck(_v, 12, 0, currVal_4);
        var currVal_5 = _co.stringHelper.isNullOrEmpty(_v.context.$implicit.Path);
        _ck(_v, 15, 0, currVal_5);
        var currVal_6 = _v.context.$implicit.Children;
        _ck(_v, 18, 0, currVal_6);
    }, null);
}
function View_SideMenuComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](671088640, 1, { menuLiRef: 1 }), core_es5["ɵqud"](671088640, 2, { menuRef: 1 }),
        core_es5["ɵqud"](671088640, 3, { menuDivRef: 1 }), core_es5["ɵqud"](671088640, 4, { menuChildRef: 1 }), core_es5["ɵqud"](402653184, 5, { movingTab: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class',
                'nav-container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [['class', 'nav']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SideMenuComponent_1)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, [[5, 0], ['movingTab', 1]], null, 0, 'div', [['class', 'sidebar-moving-tab']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.menuItems;
        _ck(_v, 10, 0, currVal_0);
    }, null);
}
function View_SideMenuComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'side-menu', [], null, null, null, View_SideMenuComponent_0, RenderType_SideMenuComponent)),
        core_es5["ɵdid"](4308992, null, 0, sideMenu_component_SideMenuComponent, [core_es5["Renderer2"], router_es5["n" /* Router */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var SideMenuComponentNgFactory = core_es5["ɵccf"]('side-menu', sideMenu_component_SideMenuComponent, View_SideMenuComponent_Host_0, { sideBar: 'sideBar', menuItems: 'menuItems',
    collapsedMenuPrefix: 'collapsedMenuPrefix' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=sideMenu.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/perfect-scrollbar/index.js
var perfect_scrollbar = __webpack_require__("Fiov");
var perfect_scrollbar_default = /*#__PURE__*/__webpack_require__.n(perfect_scrollbar);

// CONCATENATED MODULE: ./app/common/menu/baseMenuComponent.ts

var baseMenuComponent_BaseMenuComponent = /** @class */ (function () {
    function BaseMenuComponent(storageManager, router) {
        this.storageManager = storageManager;
        this.router = router;
    }
    BaseMenuComponent.prototype.logout = function () {
        this.storageManager.logout();
        this.router.navigate(['/auth/login']);
    };
    BaseMenuComponent.prototype.goToProfile = function () {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return tslib_es6["d" /* __generator */](this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.sidebarToggle();
                        _b = (_a = this.router).navigate;
                        _c = ['management/agent'];
                        _d = {};
                        return [4 /*yield*/, this.storageManager.getCurrentUser()];
                    case 1:
                        _b.apply(_a, [_c.concat([(_d.id = (_e.sent()).Id, _d)])]);
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseMenuComponent.prototype.sidebarToggle = function () {
        var toggleButton = this.toggleButton;
        var body = document.getElementsByTagName('body')[0];
        if (this.sidebarVisible == false) {
            setTimeout(function () {
                toggleButton.classList.add('toggled');
            }, 500);
            body.classList.add('nav-open');
            this.sidebarVisible = true;
        }
        else {
            this.toggleButton.classList.remove('toggled');
            this.sidebarVisible = false;
            body.classList.remove('nav-open');
        }
    };
    return BaseMenuComponent;
}());

//# sourceMappingURL=baseMenuComponent.js.map
// CONCATENATED MODULE: ./app/components/sidebar/sideBar/sideBar.component.ts





var sideBar_component_SideBarComponent = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](SideBarComponent, _super);
    function SideBarComponent(router, storageManager) {
        return _super.call(this, storageManager, router) || this;
    }
    SideBarComponent.prototype.ngOnInit = function () {
        perfect_scrollbar["initialize"](this.sidebar.nativeElement);
        this.appName = new Promise(function (resolve, reject) { return resolve("Border Buddy"); });
        this.toggleButton = document.getElementsByClassName('navbar-toggle')[0];
    };
    SideBarComponent.prototype.ngAfterViewInit = function () {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            return tslib_es6["d" /* __generator */](this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    SideBarComponent.prototype.logout = function () {
        this.storageManager.logout();
        this.router.navigate(['/auth/login']);
    };
    SideBarComponent.ctorParameters = function () { return [{ type: router_es5["n" /* Router */] }, { type: managers_storageManager["a" /* StorageManager */] }]; };
    return SideBarComponent;
}(baseMenuComponent_BaseMenuComponent));

//# sourceMappingURL=sideBar.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/sidebar/sideBar/sideBar.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_SideBarComponent = [sideBar_css_shim_ngstyle_styles];
var RenderType_SideBarComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_SideBarComponent, data: {} });
function View_SideBarComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 50, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 47, 'ul', [['class', 'nav nav-mobile-menu']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 10, 'li', [['class', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'a', [['aria-expanded',
                'false'], ['class', 'dropdown-toggle']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                _co.goToProfile();
                var pd_0 = ($event.preventDefault() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['person'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'hidden-lg hidden-md']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Profile'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'a', [['href', '#']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                _co.logout();
                var pd_0 = ($event.preventDefault() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['exit_to_app'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'hidden-lg hidden-md']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Logout'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 18, 'li', [['class', 'dropdown hidden']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'a', [['aria-expanded', 'false'], ['class', 'dropdown-toggle'], ['data-toggle',
                'dropdown']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = ($event.preventDefault() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['notifications'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'notification']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['0'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'p', [['class', 'hidden-lg hidden-md']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Notifications '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'b', [['class', 'caret']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'ul', [['class', 'dropdown-menu']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'li', [['class', 'separator hidden-lg hidden-md']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_SideBarComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { sidebar: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 23, 'div', [['class', 'sidebar'], ['data-active-color', 'orange'], ['data-background-color',
                'white'], ['id', 'left-sidebar']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'logo']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'logo-normal']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'logo-img']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['height', '24'], ['src', 'assets/logo.437b02847d771cc3f66f87a5dbeb3d66.png'],
            ['width', '140']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, [[1, 0], ['sidebar', 1]], null, 7, 'div', [['class',
                'sidebar-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SideBarComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'side-menu', [], null, null, null, View_SideMenuComponent_0, RenderType_SideMenuComponent)), core_es5["ɵdid"](4308992, null, 0, sideMenu_component_SideMenuComponent, [core_es5["Renderer2"], router_es5["n" /* Router */]], { sideBar: [0, 'sideBar'],
            menuItems: [1, 'menuItems'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'sidebar-background']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isMobileMenu;
        _ck(_v, 17, 0, currVal_0);
        var currVal_1 = _co;
        var currVal_2 = _co.menuItems;
        _ck(_v, 20, 0, currVal_1, currVal_2);
    }, null);
}
function View_SideBarComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'side-bar', [], null, null, null, View_SideBarComponent_0, RenderType_SideBarComponent)),
        core_es5["ɵdid"](4308992, null, 0, sideBar_component_SideBarComponent, [router_es5["n" /* Router */], managers_storageManager["a" /* StorageManager */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var SideBarComponentNgFactory = core_es5["ɵccf"]('side-bar', sideBar_component_SideBarComponent, View_SideBarComponent_Host_0, { isMobileMenu: 'isMobileMenu',
    menuItems: 'menuItems' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=sideBar.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/dropdown/bs-dropdown.directive.js
var bs_dropdown_directive = __webpack_require__("+dHm");

// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/dropdown/bs-dropdown.config.js
var bs_dropdown_config = __webpack_require__("RaSy");

// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/dropdown/bs-dropdown-toggle.directive.js
var bs_dropdown_toggle_directive = __webpack_require__("Zek7");

// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/dropdown/bs-dropdown-menu.directive.js
var bs_dropdown_menu_directive = __webpack_require__("4ejn");

// CONCATENATED MODULE: ./app/components/navbar/navbar.component.ts






var navbar_component_NavbarComponent = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](NavbarComponent, _super);
    function NavbarComponent(element, router, storageManager, location) {
        var _this = _super.call(this, storageManager, router) || this;
        _this.element = element;
        _this.location = location;
        _this.admin = false;
        _this.sidebarVisible = false;
        return _this;
    }
    NavbarComponent.prototype.ngOnInit = function () {
        var navbar = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
        this.userName = this.storageManager.getCurrentUser().then(function (user) {
            // this.admin = user.Roles.indexOf(1) > -1 || user.Roles.indexOf(13) > -1;
            return user.Email;
        });
    };
    NavbarComponent.prototype.stepBack = function () {
        this.location.back();
    };
    NavbarComponent.ctorParameters = function () { return [{ type: core_es5["ElementRef"] }, { type: router_es5["n" /* Router */] }, { type: managers_storageManager["a" /* StorageManager */] }, { type: common_es5["Location"] }]; };
    return NavbarComponent;
}(baseMenuComponent_BaseMenuComponent));

//# sourceMappingURL=navbar.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/navbar/navbar.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */












var styles_NavbarComponent = [];
var RenderType_NavbarComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_NavbarComponent, data: {} });
function View_NavbarComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 13, 'ul', [['class',
                'dropdown-menu'], ['role', 'menu']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.goToProfile() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['Profile'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '#']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                _co.logout();
                var pd_0 = ($event.preventDefault() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['Logout'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_NavbarComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'ul', [['class',
                'dropdown-menu'], ['role', 'menu']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_NavbarComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 48, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 45, 'ul', [['class', 'nav navbar-nav navbar-right']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](16777216, null, null, 17, 'li', [['dropdown', '']], [[2, 'dropup', null], [2, 'open', null], [2, 'show', null]], null, null, null, null)), core_es5["ɵprd"](512, null, bs_dropdown_state["a" /* BsDropdownState */], bs_dropdown_state["a" /* BsDropdownState */], []), core_es5["ɵdid"](212992, null, 0, bs_dropdown_directive["a" /* BsDropdownDirective */], [core_es5["ElementRef"], core_es5["Renderer"], core_es5["ViewContainerRef"],
            component_loader_factory["a" /* ComponentLoaderFactory */], bs_dropdown_config["a" /* BsDropdownConfig */], bs_dropdown_state["a" /* BsDropdownState */]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'a', [['class', 'dropdown-toggle btn btn-white btn-round btn-just-icon'],
            ['dropdownToggle', ''], ['href', '#']], [[1, 'aria-haspopup', 0], [1, 'disabled',
                0], [1, 'aria-expanded', 0]], [[null, 'click'], ['document', 'click'],
            [null, 'keyup.esc']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 9).onClick() !== false);
                ad = (pd_0 && ad);
            }
            if (('document:click' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 9).onDocumentClick($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('keyup.esc' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 9).onEsc() !== false);
                ad = (pd_2 && ad);
            }
            if (('click' === en)) {
                var pd_3 = (false !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](147456, null, 0, bs_dropdown_toggle_directive["a" /* BsDropdownToggleDirective */], [bs_dropdown_state["a" /* BsDropdownState */], core_es5["ElementRef"]], null, null), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['account_circle'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'hidden-lg hidden-md']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Profile'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_NavbarComponent_2)), core_es5["ɵdid"](16384, null, 0, bs_dropdown_menu_directive["a" /* BsDropdownMenuDirective */], [bs_dropdown_state["a" /* BsDropdownState */], core_es5["ViewContainerRef"], core_es5["TemplateRef"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](16777216, null, null, 21, 'li', [['class', 'hidden'],
            ['dropdown', '']], [[2, 'dropup', null], [2, 'open', null], [2,
                'show', null]], null, null, null, null)),
        core_es5["ɵprd"](512, null, bs_dropdown_state["a" /* BsDropdownState */], bs_dropdown_state["a" /* BsDropdownState */], []),
        core_es5["ɵdid"](212992, null, 0, bs_dropdown_directive["a" /* BsDropdownDirective */], [core_es5["ElementRef"], core_es5["Renderer"],
            core_es5["ViewContainerRef"], component_loader_factory["a" /* ComponentLoaderFactory */], bs_dropdown_config["a" /* BsDropdownConfig */], bs_dropdown_state["a" /* BsDropdownState */]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 13, 'a', [['class', 'dropdown-toggle btn btn-white btn-round btn-just-icon'],
                ['href', '#']], null, [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                if (('click' === en)) {
                    var pd_0 = (false !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['add_alert'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'notification']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['0'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'p', [['class', 'hidden-lg hidden-md']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Notifications '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'b', [['class', 'caret']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_NavbarComponent_3)),
        core_es5["ɵdid"](16384, null, 0, bs_dropdown_menu_directive["a" /* BsDropdownMenuDirective */], [bs_dropdown_state["a" /* BsDropdownState */],
            core_es5["ViewContainerRef"], core_es5["TemplateRef"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'li', [['class', 'separator hidden-lg hidden-md']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        _ck(_v, 6, 0);
        _ck(_v, 25, 0);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 6).dropup;
        var currVal_1 = core_es5["ɵnov"](_v, 6).isOpen;
        var currVal_2 = (core_es5["ɵnov"](_v, 6).isOpen && core_es5["ɵnov"](_v, 6).isBs4);
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2);
        var currVal_3 = true;
        var currVal_4 = core_es5["ɵnov"](_v, 9).isDisabled;
        var currVal_5 = core_es5["ɵnov"](_v, 9).isOpen;
        _ck(_v, 8, 0, currVal_3, currVal_4, currVal_5);
        var currVal_6 = core_es5["ɵnov"](_v, 25).dropup;
        var currVal_7 = core_es5["ɵnov"](_v, 25).isOpen;
        var currVal_8 = (core_es5["ɵnov"](_v, 25).isOpen && core_es5["ɵnov"](_v, 25).isBs4);
        _ck(_v, 23, 0, currVal_6, currVal_7, currVal_8);
    });
}
function View_NavbarComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 41, 'nav', [['class',
                'navbar navbar-transparent navbar-absolute'], ['id', 'navbar-top']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 38, 'div', [['class', 'container-fluid']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class', 'navbar-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 10, 'button', [['class', 'navbar-toggle'],
                ['type', 'button']], null, [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.sidebarToggle() !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'sr-only']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Toggle navigation'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'icon-bar']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'icon-bar']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'icon-bar']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'div', [['class', 'navbar-left']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'ul', [['class', 'nav navbar-nav']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 8, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'a', [['class', 'btn btn-white btn-round btn-just-icon']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.stepBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['navigate_before'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'collapse navbar-collapse']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_NavbarComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.isMobileMenu;
        _ck(_v, 38, 0, currVal_0);
    }, null);
}
function View_NavbarComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'navbar', [], null, null, null, View_NavbarComponent_0, RenderType_NavbarComponent)),
        core_es5["ɵdid"](114688, null, 0, navbar_component_NavbarComponent, [core_es5["ElementRef"], router_es5["n" /* Router */],
            managers_storageManager["a" /* StorageManager */], common_es5["Location"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var NavbarComponentNgFactory = core_es5["ɵccf"]('navbar', navbar_component_NavbarComponent, View_NavbarComponent_Host_0, { isMobileMenu: 'isMobileMenu' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=navbar.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/components/layout/layout.component.ts
var layout_component = __webpack_require__("15BH");

// CONCATENATED MODULE: ./compiled/app/components/layout/layout.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */

























var styles_LayoutComponent = [styles, select2_css_ngstyle_styles, index_css_ngstyle_styles, icons_css_ngstyle_styles, material_css_ngstyle_styles,
    bootstrap_css_ngstyle_styles, datatable_css_ngstyle_styles];
var RenderType_LayoutComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_LayoutComponent, data: {} });
function View_LayoutComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class',
                'spinner-circle']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, ':svg:svg', [['class', 'spinner-circular'], ['viewBox', '25 25 50 50']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, ':svg:circle', [['class',
                'path'], ['cx', '50'], ['cy', '50'], ['fill', 'none'], ['r', '20'], ['stroke-miterlimit',
                '10'], ['stroke-width', '2']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_LayoutComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { navBar: 0 }), core_es5["ɵqud"](402653184, 2, { mainPanel: 0 }),
        core_es5["ɵqud"](402653184, 3, { customerModal: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'customer-modal', [], null, [[null, 'scroll'],
            [null, 'mousewheel'], ['document', 'keydown']], function (_v, en, $event) {
            var ad = true;
            if (('scroll' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).onMousewheel($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('mousewheel' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 4).onMousewheel($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('document:keydown' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 4).onArrowDown($event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, View_CustomerModalComponent_0, RenderType_CustomerModalComponent)),
        core_es5["ɵdid"](114688, [[3, 4], ['customerModal', 4]], 0, customerModal_component["a" /* CustomerModalComponent */], [services_customerService["a" /* CustomerService */],
            router_es5["n" /* Router */], toast_manager["ToastsManager"], core_es5["ChangeDetectorRef"], services_extraDataService["a" /* ExtraDataService */], services_userViewService["a" /* UserViewService */],
            services_emailService["a" /* EmailService */], managers_storageManager["a" /* StorageManager */], services_paymentService["a" /* PaymentService */], services_configService["a" /* ConfigService */]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 16, 'div', [['class', 'wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'side-bar', [], null, null, null, View_SideBarComponent_0, RenderType_SideBarComponent)),
        core_es5["ɵdid"](4308992, null, 0, sideBar_component_SideBarComponent, [router_es5["n" /* Router */], managers_storageManager["a" /* StorageManager */]], { isMobileMenu: [0, 'isMobileMenu'], menuItems: [1, 'menuItems'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, [[2, 0], ['mainPanel',
                1]], null, 10, 'div', [['class', 'main-panel'], ['id', 'mainPanel']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'navbar', [], null, null, null, View_NavbarComponent_0, RenderType_NavbarComponent)),
        core_es5["ɵdid"](114688, [[1, 4], ['navBar', 4]], 0, navbar_component_NavbarComponent, [core_es5["ElementRef"], router_es5["n" /* Router */],
            managers_storageManager["a" /* StorageManager */], common_es5["Location"]], { isMobileMenu: [0, 'isMobileMenu'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](16777216, null, null, 1, 'router-outlet', [], null, null, null, null, null)), core_es5["ɵdid"](212992, null, 0, router_es5["r" /* RouterOutlet */], [router_es5["b" /* ChildrenOutletContexts */], core_es5["ViewContainerRef"], core_es5["ComponentFactoryResolver"],
            [8, null], core_es5["ChangeDetectorRef"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LayoutComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        _ck(_v, 4, 0);
        var currVal_0 = _co.isMobileMenu;
        var currVal_1 = _co.menuItems;
        _ck(_v, 9, 0, currVal_0, currVal_1);
        var currVal_2 = _co.isMobileMenu;
        _ck(_v, 14, 0, currVal_2);
        _ck(_v, 17, 0);
        var currVal_3 = _co.loading;
        _ck(_v, 20, 0, currVal_3);
    }, null);
}
function View_LayoutComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'layout', [], null, [['window', 'resize'], ['window', 'popstate']], function (_v, en, $event) {
            var ad = true;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onResize() !== false);
                ad = (pd_0 && ad);
            }
            if (('window:popstate' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 1).hideSelect2($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_LayoutComponent_0, RenderType_LayoutComponent)), core_es5["ɵdid"](4440064, null, 0, layout_component["a" /* LayoutComponent */], [router_es5["n" /* Router */], core_es5["Renderer2"], managers_storageManager["a" /* StorageManager */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var LayoutComponentNgFactory = core_es5["ɵccf"]('layout', layout_component["a" /* LayoutComponent */], View_LayoutComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvbGF5b3V0L2xheW91dC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvbGF5b3V0L2xheW91dC5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9sYXlvdXQvbGF5b3V0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvbGF5b3V0L2xheW91dC5jb21wb25lbnQudHMuTGF5b3V0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGN1c3RvbWVyLW1vZGFsICNjdXN0b21lck1vZGFsPjwvY3VzdG9tZXItbW9kYWw+IDxkaXYgY2xhc3M9XCJ3cmFwcGVyXCI+IDxzaWRlLWJhciBbbWVudUl0ZW1zXT1cIm1lbnVJdGVtc1wiIFtpc01vYmlsZU1lbnVdPVwiaXNNb2JpbGVNZW51XCI+PC9zaWRlLWJhcj4gPGRpdiAjbWFpblBhbmVsIGNsYXNzPVwibWFpbi1wYW5lbFwiIGlkPVwibWFpblBhbmVsXCI+IDxuYXZiYXIgW2lzTW9iaWxlTWVudV09XCJpc01vYmlsZU1lbnVcIiAjbmF2QmFyPjwvbmF2YmFyPiA8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+IDxkaXYgY2xhc3M9XCJzcGlubmVyLWNpcmNsZVwiICpuZ0lmPVwibG9hZGluZ1wiPiA8c3ZnIGNsYXNzPVwic3Bpbm5lci1jaXJjdWxhclwiIHZpZXdCb3g9XCIyNSAyNSA1MCA1MFwiPiA8Y2lyY2xlIGNsYXNzPVwicGF0aFwiIGN4PVwiNTBcIiBjeT1cIjUwXCIgcj1cIjIwXCIgZmlsbD1cIm5vbmVcIiBzdHJva2Utd2lkdGg9XCIyXCIgc3Ryb2tlLW1pdGVybGltaXQ9XCIxMFwiPjwvY2lyY2xlPiA8L3N2Zz4gPC9kaXY+IDwvZGl2PiA8L2Rpdj4iLCI8bGF5b3V0PjwvbGF5b3V0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0E4UjtNQUFBO01BQTRDLHNDQUFDO1VBQUE7VUFBQSwwREFBb0Q7VUFBQSxRQUFDO1VBQUE7VUFBQTtVQUFBLGdCQUF5RyxzQ0FBTztVQUFBOzs7OzZDQUFoZjtVQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1VBQUE7YUFBQTs7a0ZBQUE7VUFBQSw2QkFBZ0Qsc0NBQUM7aUJBQUE7Y0FBQSwwREFBcUI7VUFBQSxRQUFDO1VBQUE7YUFBQTtVQUFBO01BQTJFLHNDQUFDO1VBQUE7VUFBQSwwREFBa0Q7VUFBQSxRQUFDO1VBQUE7YUFBQTt5Q0FBQTtNQUF1RCxzQ0FBQztVQUFBO1VBQUEsbURBQUE7VUFBQTtjQUFBO01BQStCLHNDQUFDO1VBQUEsOERBQUE7VUFBQTtNQUF5TixzQ0FBTzs7O1FBQTlmO1FBQXlHO1FBQXhCO1FBQVYsV0FBa0MsVUFBeEIsU0FBVjtRQUF1STtRQUFSLFlBQVEsU0FBUjtRQUF3RDtRQUE0RDtRQUE1QixZQUE0QixTQUE1Qjs7OztvQkNBOVI7TUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO01BQUEsNkRBQUE7TUFBQTtNQUFBO0lBQUE7Ozs7In0=
//# sourceMappingURL=layout.component.ngfactory.js.map
// CONCATENATED MODULE: ./node_modules/ngx-pagination/dist/ngx-pagination.js



var ngx_pagination_PaginationService = (function () {
    function PaginationService() {
        this.change = new core_es5["EventEmitter"]();
        this.instances = {};
        this.DEFAULT_ID = 'DEFAULT_PAGINATION_ID';
    }
    PaginationService.prototype.defaultId = function () { return this.DEFAULT_ID; };
    PaginationService.prototype.register = function (instance) {
        if (!instance.id) {
            instance.id = this.DEFAULT_ID;
        }
        if (!this.instances[instance.id]) {
            this.instances[instance.id] = instance;
            this.change.emit(instance.id);
        }
        else {
            var changed = this.updateInstance(instance);
            if (changed) {
                this.change.emit(instance.id);
            }
        }
    };
    /**
     * Check each property of the instance and update any that have changed. Return
     * true if any changes were made, else return false.
     */
    PaginationService.prototype.updateInstance = function (instance) {
        var changed = false;
        for (var prop in this.instances[instance.id]) {
            if (instance[prop] !== this.instances[instance.id][prop]) {
                this.instances[instance.id][prop] = instance[prop];
                changed = true;
            }
        }
        return changed;
    };
    /**
     * Returns the current page number.
     */
    PaginationService.prototype.getCurrentPage = function (id) {
        if (this.instances[id]) {
            return this.instances[id].currentPage;
        }
    };
    /**
     * Sets the current page number.
     */
    PaginationService.prototype.setCurrentPage = function (id, page) {
        if (this.instances[id]) {
            var instance = this.instances[id];
            var maxPage = Math.ceil(instance.totalItems / instance.itemsPerPage);
            if (page <= maxPage && 1 <= page) {
                this.instances[id].currentPage = page;
                this.change.emit(id);
            }
        }
    };
    /**
     * Sets the value of instance.totalItems
     */
    PaginationService.prototype.setTotalItems = function (id, totalItems) {
        if (this.instances[id] && 0 <= totalItems) {
            this.instances[id].totalItems = totalItems;
            this.change.emit(id);
        }
    };
    /**
     * Sets the value of instance.itemsPerPage.
     */
    PaginationService.prototype.setItemsPerPage = function (id, itemsPerPage) {
        if (this.instances[id]) {
            this.instances[id].itemsPerPage = itemsPerPage;
            this.change.emit(id);
        }
    };
    /**
     * Returns a clone of the pagination instance object matching the id. If no
     * id specified, returns the instance corresponding to the default id.
     */
    PaginationService.prototype.getInstance = function (id) {
        if (id === void 0) { id = this.DEFAULT_ID; }
        if (this.instances[id]) {
            return this.clone(this.instances[id]);
        }
        return {};
    };
    /**
     * Perform a shallow clone of an object.
     */
    PaginationService.prototype.clone = function (obj) {
        var target = {};
        for (var i in obj) {
            if (obj.hasOwnProperty(i)) {
                target[i] = obj[i];
            }
        }
        return target;
    };
    return PaginationService;
}());

var LARGE_NUMBER = Number.MAX_SAFE_INTEGER;
var PaginatePipe = (function () {
    function PaginatePipe(service) {
        this.service = service;
        // store the values from the last time the pipe was invoked
        this.state = {};
    }
    PaginatePipe.prototype.transform = function (collection, args) {
        // When an observable is passed through the AsyncPipe, it will output
        // `null` until the subscription resolves. In this case, we want to
        // use the cached data from the `state` object to prevent the NgFor
        // from flashing empty until the real values arrive.
        if (args instanceof Array) {
            // compatible with angular2 before beta16
            args = args[0];
        }
        if (!(collection instanceof Array)) {
            var _id = args.id || this.service.defaultId;
            if (this.state[_id]) {
                return this.state[_id].slice;
            }
            else {
                return collection;
            }
        }
        var serverSideMode = args.totalItems && args.totalItems !== collection.length;
        var instance = this.createInstance(collection, args);
        var id = instance.id;
        var start, end;
        var perPage = instance.itemsPerPage;
        this.service.register(instance);
        if (!serverSideMode && collection instanceof Array) {
            perPage = +perPage || LARGE_NUMBER;
            start = (instance.currentPage - 1) * perPage;
            end = start + perPage;
            var isIdentical = this.stateIsIdentical(id, collection, start, end);
            if (isIdentical) {
                return this.state[id].slice;
            }
            else {
                var slice = collection.slice(start, end);
                this.saveState(id, collection, slice, start, end);
                this.service.change.emit(id);
                return slice;
            }
        }
        // save the state for server-side collection to avoid null
        // flash as new data loads.
        this.saveState(id, collection, collection, start, end);
        return collection;
    };
    /**
     * Create an PaginationInstance object, using defaults for any optional properties not supplied.
     */
    PaginatePipe.prototype.createInstance = function (collection, args) {
        var config = args;
        this.checkConfig(config);
        return {
            id: config.id || this.service.defaultId(),
            itemsPerPage: config.itemsPerPage || 0,
            currentPage: config.currentPage || 1,
            totalItems: config.totalItems || collection.length
        };
    };
    /**
     * Ensure the argument passed to the filter contains the required properties.
     */
    PaginatePipe.prototype.checkConfig = function (config) {
        var required = ['itemsPerPage', 'currentPage'];
        var missing = required.filter(function (prop) { return !(prop in config); });
        if (0 < missing.length) {
            throw new Error("PaginatePipe: Argument is missing the following required properties: " + missing.join(', '));
        }
    };
    /**
     * To avoid returning a brand new array each time the pipe is run, we store the state of the sliced
     * array for a given id. This means that the next time the pipe is run on this collection & id, we just
     * need to check that the collection, start and end points are all identical, and if so, return the
     * last sliced array.
     */
    PaginatePipe.prototype.saveState = function (id, collection, slice, start, end) {
        this.state[id] = {
            collection: collection,
            size: collection.length,
            slice: slice,
            start: start,
            end: end
        };
    };
    /**
     * For a given id, returns true if the collection, size, start and end values are identical.
     */
    PaginatePipe.prototype.stateIsIdentical = function (id, collection, start, end) {
        var state = this.state[id];
        if (!state) {
            return false;
        }
        var isMetaDataIdentical = state.size === collection.length &&
            state.start === start &&
            state.end === end;
        if (!isMetaDataIdentical) {
            return false;
        }
        return state.slice.every(function (element, index) { return element === collection[start + index]; });
    };
    return PaginatePipe;
}());
PaginatePipe.decorators = [
    { type: core_es5["Pipe"], args: [{
                name: 'paginate',
                pure: false
            },] },
];
/** @nocollapse */
PaginatePipe.ctorParameters = function () { return [
    { type: ngx_pagination_PaginationService, },
]; };

/**
 * The default template and styles for the pagination links are borrowed directly
 * from Zurb Foundation 6: http://foundation.zurb.com/sites/docs/pagination.html
 */
/**
 * The default template and styles for the pagination links are borrowed directly
 * from Zurb Foundation 6: http://foundation.zurb.com/sites/docs/pagination.html
 */ var DEFAULT_TEMPLATE = "\n    <pagination-template  #p=\"paginationApi\"\n                         [id]=\"id\"\n                         [maxSize]=\"maxSize\"\n                         (pageChange)=\"pageChange.emit($event)\">\n    <ul class=\"ngx-pagination\" \n        role=\"navigation\" \n        [attr.aria-label]=\"screenReaderPaginationLabel\" \n        *ngIf=\"!(autoHide && p.pages.length <= 1)\">\n\n        <li class=\"pagination-previous\" [class.disabled]=\"p.isFirstPage()\" *ngIf=\"directionLinks\"> \n            <a *ngIf=\"1 < p.getCurrent()\" (click)=\"p.previous()\" [attr.aria-label]=\"previousLabel + ' ' + screenReaderPageLabel\">\n                {{ previousLabel }} <span class=\"show-for-sr\">{{ screenReaderPageLabel }}</span>\n            </a>\n            <span *ngIf=\"p.isFirstPage()\">\n                {{ previousLabel }} <span class=\"show-for-sr\">{{ screenReaderPageLabel }}</span>\n            </span>\n        </li>\n\n        <li [class.current]=\"p.getCurrent() === page.value\" *ngFor=\"let page of p.pages\">\n            <a (click)=\"p.setCurrent(page.value)\" *ngIf=\"p.getCurrent() !== page.value\">\n                <span class=\"show-for-sr\">{{ screenReaderPageLabel }} </span>\n                <span>{{ page.label }}</span>\n            </a>\n            <div *ngIf=\"p.getCurrent() === page.value\">\n                <span class=\"show-for-sr\">{{ screenReaderCurrentLabel }} </span>\n                <span>{{ page.label }}</span> \n            </div>\n        </li>\n\n        <li class=\"pagination-next\" [class.disabled]=\"p.isLastPage()\" *ngIf=\"directionLinks\">\n            <a *ngIf=\"!p.isLastPage()\" (click)=\"p.next()\" [attr.aria-label]=\"nextLabel + ' ' + screenReaderPageLabel\">\n                 {{ nextLabel }} <span class=\"show-for-sr\">{{ screenReaderPageLabel }}</span>\n            </a>\n            <span *ngIf=\"p.isLastPage()\">\n                 {{ nextLabel }} <span class=\"show-for-sr\">{{ screenReaderPageLabel }}</span>\n            </span>\n        </li>\n\n    </ul>\n    </pagination-template>\n    ";
var DEFAULT_STYLES = "\n.ngx-pagination {\n  margin-left: 0;\n  margin-bottom: 1rem; }\n  .ngx-pagination::before, .ngx-pagination::after {\n    content: ' ';\n    display: table; }\n  .ngx-pagination::after {\n    clear: both; }\n  .ngx-pagination li {\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    margin-right: 0.0625rem;\n    border-radius: 0; }\n  .ngx-pagination li {\n    display: inline-block; }\n  .ngx-pagination a,\n  .ngx-pagination button {\n    color: #0a0a0a; \n    display: block;\n    padding: 0.1875rem 0.625rem;\n    border-radius: 0; }\n    .ngx-pagination a:hover,\n    .ngx-pagination button:hover {\n      background: #e6e6e6; }\n  .ngx-pagination .current {\n    padding: 0.1875rem 0.625rem;\n    background: #2199e8;\n    color: #fefefe;\n    cursor: default; }\n  .ngx-pagination .disabled {\n    padding: 0.1875rem 0.625rem;\n    color: #cacaca;\n    cursor: default; } \n    .ngx-pagination .disabled:hover {\n      background: transparent; }\n  .ngx-pagination .ellipsis::after {\n    content: '\u2026';\n    padding: 0.1875rem 0.625rem;\n    color: #0a0a0a; }\n  .ngx-pagination a, .ngx-pagination button {\n    cursor: pointer; }\n\n.ngx-pagination .pagination-previous a::before,\n.ngx-pagination .pagination-previous.disabled::before { \n  content: '\u00AB';\n  display: inline-block;\n  margin-right: 0.5rem; }\n\n.ngx-pagination .pagination-next a::after,\n.ngx-pagination .pagination-next.disabled::after {\n  content: '\u00BB';\n  display: inline-block;\n  margin-left: 0.5rem; }\n\n.ngx-pagination .show-for-sr {\n  position: absolute !important;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0); }";

/**
 * The default pagination controls component. Actually just a default implementation of a custom template.
 */
var ngx_pagination_PaginationControlsComponent = (function () {
    function PaginationControlsComponent() {
        this.maxSize = 7;
        this.previousLabel = 'Previous';
        this.nextLabel = 'Next';
        this.screenReaderPaginationLabel = 'Pagination';
        this.screenReaderPageLabel = 'page';
        this.screenReaderCurrentLabel = "You're on page";
        this.pageChange = new core_es5["EventEmitter"]();
        this._directionLinks = true;
        this._autoHide = false;
    }
    Object.defineProperty(PaginationControlsComponent.prototype, "directionLinks", {
        get: function () {
            return this._directionLinks;
        },
        set: function (value) {
            this._directionLinks = !!value && value !== 'false';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationControlsComponent.prototype, "autoHide", {
        get: function () {
            return this._autoHide;
        },
        set: function (value) {
            this._autoHide = !!value && value !== 'false';
        },
        enumerable: true,
        configurable: true
    });
    return PaginationControlsComponent;
}());
ngx_pagination_PaginationControlsComponent.decorators = [
    { type: core_es5["Component"], args: [{
                selector: 'pagination-controls',
                template: DEFAULT_TEMPLATE,
                styles: [DEFAULT_STYLES],
                changeDetection: core_es5["ChangeDetectionStrategy"].OnPush,
                encapsulation: core_es5["ViewEncapsulation"].None
            },] },
];
/** @nocollapse */
ngx_pagination_PaginationControlsComponent.ctorParameters = function () { return []; };
ngx_pagination_PaginationControlsComponent.propDecorators = {
    'id': [{ type: core_es5["Input"] },],
    'maxSize': [{ type: core_es5["Input"] },],
    'directionLinks': [{ type: core_es5["Input"] },],
    'autoHide': [{ type: core_es5["Input"] },],
    'previousLabel': [{ type: core_es5["Input"] },],
    'nextLabel': [{ type: core_es5["Input"] },],
    'screenReaderPaginationLabel': [{ type: core_es5["Input"] },],
    'screenReaderPageLabel': [{ type: core_es5["Input"] },],
    'screenReaderCurrentLabel': [{ type: core_es5["Input"] },],
    'pageChange': [{ type: core_es5["Output"] },],
};

/**
 * This directive is what powers all pagination controls components, including the default one.
 * It exposes an API which is hooked up to the PaginationService to keep the PaginatePipe in sync
 * with the pagination controls.
 */
var ngx_pagination_PaginationControlsDirective = (function () {
    function PaginationControlsDirective(service, changeDetectorRef) {
        var _this = this;
        this.service = service;
        this.changeDetectorRef = changeDetectorRef;
        this.maxSize = 7;
        this.pageChange = new core_es5["EventEmitter"]();
        this.pages = [];
        this.changeSub = this.service.change
            .subscribe(function (id) {
            if (_this.id === id) {
                _this.updatePageLinks();
                _this.changeDetectorRef.markForCheck();
                _this.changeDetectorRef.detectChanges();
            }
        });
    }
    PaginationControlsDirective.prototype.ngOnInit = function () {
        if (this.id === undefined) {
            this.id = this.service.defaultId();
        }
        this.updatePageLinks();
    };
    PaginationControlsDirective.prototype.ngOnChanges = function (changes) {
        this.updatePageLinks();
    };
    PaginationControlsDirective.prototype.ngOnDestroy = function () {
        this.changeSub.unsubscribe();
    };
    /**
     * Go to the previous page
     */
    PaginationControlsDirective.prototype.previous = function () {
        this.checkValidId();
        this.setCurrent(this.getCurrent() - 1);
    };
    /**
     * Go to the next page
     */
    PaginationControlsDirective.prototype.next = function () {
        this.checkValidId();
        this.setCurrent(this.getCurrent() + 1);
    };
    /**
     * Returns true if current page is first page
     */
    PaginationControlsDirective.prototype.isFirstPage = function () {
        return this.getCurrent() === 1;
    };
    /**
     * Returns true if current page is last page
     */
    PaginationControlsDirective.prototype.isLastPage = function () {
        return this.getLastPage() === this.getCurrent();
    };
    /**
     * Set the current page number.
     */
    PaginationControlsDirective.prototype.setCurrent = function (page) {
        this.pageChange.emit(page);
    };
    /**
     * Get the current page number.
     */
    PaginationControlsDirective.prototype.getCurrent = function () {
        return this.service.getCurrentPage(this.id);
    };
    /**
     * Returns the last page number
     */
    PaginationControlsDirective.prototype.getLastPage = function () {
        var inst = this.service.getInstance(this.id);
        if (inst.totalItems < 1) {
            // when there are 0 or fewer (an error case) items, there are no "pages" as such,
            // but it makes sense to consider a single, empty page as the last page.
            return 1;
        }
        return Math.ceil(inst.totalItems / inst.itemsPerPage);
    };
    PaginationControlsDirective.prototype.checkValidId = function () {
        if (!this.service.getInstance(this.id).id) {
            console.warn("PaginationControlsDirective: the specified id \"" + this.id + "\" does not match any registered PaginationInstance");
        }
    };
    /**
     * Updates the page links and checks that the current page is valid. Should run whenever the
     * PaginationService.change stream emits a value matching the current ID, or when any of the
     * input values changes.
     */
    PaginationControlsDirective.prototype.updatePageLinks = function () {
        var _this = this;
        var inst = this.service.getInstance(this.id);
        var correctedCurrentPage = this.outOfBoundCorrection(inst);
        if (correctedCurrentPage !== inst.currentPage) {
            setTimeout(function () {
                _this.setCurrent(correctedCurrentPage);
                _this.pages = _this.createPageArray(inst.currentPage, inst.itemsPerPage, inst.totalItems, _this.maxSize);
            });
        }
        else {
            this.pages = this.createPageArray(inst.currentPage, inst.itemsPerPage, inst.totalItems, this.maxSize);
        }
    };
    /**
     * Checks that the instance.currentPage property is within bounds for the current page range.
     * If not, return a correct value for currentPage, or the current value if OK.
     */
    PaginationControlsDirective.prototype.outOfBoundCorrection = function (instance) {
        var totalPages = Math.ceil(instance.totalItems / instance.itemsPerPage);
        if (totalPages < instance.currentPage && 0 < totalPages) {
            return totalPages;
        }
        else if (instance.currentPage < 1) {
            return 1;
        }
        return instance.currentPage;
    };
    /**
     * Returns an array of Page objects to use in the pagination controls.
     */
    PaginationControlsDirective.prototype.createPageArray = function (currentPage, itemsPerPage, totalItems, paginationRange) {
        // paginationRange could be a string if passed from attribute, so cast to number.
        paginationRange = +paginationRange;
        var pages = [];
        var totalPages = Math.ceil(totalItems / itemsPerPage);
        var halfWay = Math.ceil(paginationRange / 2);
        var isStart = currentPage <= halfWay;
        var isEnd = totalPages - halfWay < currentPage;
        var isMiddle = !isStart && !isEnd;
        var ellipsesNeeded = paginationRange < totalPages;
        var i = 1;
        while (i <= totalPages && i <= paginationRange) {
            var label = void 0;
            var pageNumber = this.calculatePageNumber(i, currentPage, paginationRange, totalPages);
            var openingEllipsesNeeded = (i === 2 && (isMiddle || isEnd));
            var closingEllipsesNeeded = (i === paginationRange - 1 && (isMiddle || isStart));
            if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
                label = '...';
            }
            else {
                label = pageNumber;
            }
            pages.push({
                label: label,
                value: pageNumber
            });
            i++;
        }
        return pages;
    };
    /**
     * Given the position in the sequence of pagination links [i],
     * figure out what page number corresponds to that position.
     */
    PaginationControlsDirective.prototype.calculatePageNumber = function (i, currentPage, paginationRange, totalPages) {
        var halfWay = Math.ceil(paginationRange / 2);
        if (i === paginationRange) {
            return totalPages;
        }
        else if (i === 1) {
            return i;
        }
        else if (paginationRange < totalPages) {
            if (totalPages - halfWay < currentPage) {
                return totalPages - paginationRange + i;
            }
            else if (halfWay < currentPage) {
                return currentPage - halfWay + i;
            }
            else {
                return i;
            }
        }
        else {
            return i;
        }
    };
    return PaginationControlsDirective;
}());
ngx_pagination_PaginationControlsDirective.decorators = [
    { type: core_es5["Directive"], args: [{
                selector: 'pagination-template,[pagination-template]',
                exportAs: 'paginationApi'
            },] },
];
/** @nocollapse */
ngx_pagination_PaginationControlsDirective.ctorParameters = function () { return [
    { type: ngx_pagination_PaginationService, },
    { type: core_es5["ChangeDetectorRef"], },
]; };
ngx_pagination_PaginationControlsDirective.propDecorators = {
    'id': [{ type: core_es5["Input"] },],
    'maxSize': [{ type: core_es5["Input"] },],
    'pageChange': [{ type: core_es5["Output"] },],
};

var NgxPaginationModule = (function () {
    function NgxPaginationModule() {
    }
    return NgxPaginationModule;
}());
NgxPaginationModule.decorators = [
    { type: core_es5["NgModule"], args: [{
                imports: [common_es5["CommonModule"]],
                declarations: [
                    PaginatePipe,
                    ngx_pagination_PaginationControlsComponent,
                    ngx_pagination_PaginationControlsDirective
                ],
                providers: [ngx_pagination_PaginationService],
                exports: [PaginatePipe, ngx_pagination_PaginationControlsComponent, ngx_pagination_PaginationControlsDirective]
            },] },
];
/** @nocollapse */
NgxPaginationModule.ctorParameters = function () { return []; };

/**
 * Generated bundle index. Do not edit.
 */



// CONCATENATED MODULE: ./app/components/Managment/pagination/managementPagination.component.ts

/**
 * Created by alex.y on 9/11/2017.
 */
var managementPagination_component_ManagementPaginationComponent = /** @class */ (function () {
    function ManagementPaginationComponent() {
        this.searchEventEmitter = new core_es5["EventEmitter"]();
    }
    ManagementPaginationComponent.prototype.search = function () {
        this.searchEventEmitter.emit();
    };
    return ManagementPaginationComponent;
}());

//# sourceMappingURL=managementPagination.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/pagination/managementPagination.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_ManagementPaginationComponent = [];
var RenderType_ManagementPaginationComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ManagementPaginationComponent, data: {} });
function View_ManagementPaginationComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v.parent, 3).previous() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['PREVIOUS']))], null, null);
}
function View_ManagementPaginationComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v.parent.parent, 3).setCurrent(_v.parent.context.$implicit.value) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.label;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_ManagementPaginationComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' ', ' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.label;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_ManagementPaginationComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 10, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'li', [['class', 'paginate_button']], [[2, 'active', null]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ManagementPaginationComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ManagementPaginationComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_1 = (core_es5["ɵnov"](_v.parent, 3).getCurrent() !== _v.context.$implicit.value);
        _ck(_v, 5, 0, currVal_1);
        var currVal_2 = (core_es5["ɵnov"](_v.parent, 3).getCurrent() === _v.context.$implicit.value);
        _ck(_v, 8, 0, currVal_2);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v.parent, 3).getCurrent() === _v.context.$implicit.value);
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_ManagementPaginationComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v.parent, 3).next() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['NEXT']))], null, null);
}
function View_ManagementPaginationComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 26, 'div', [['class',
                'col-lg-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 23, 'pagination-template', [], null, [[null, 'pageChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('pageChange' === en)) {
                _co.config.currentPage = $event;
                var pd_0 = (_co.search() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](737280, [['p', 4]], 0, ngx_pagination_PaginationControlsDirective, [ngx_pagination_PaginationService, core_es5["ChangeDetectorRef"]], { id: [0, 'id'] }, { pageChange: 'pageChange' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class', 'dataTables_paginate paging_full_numbers'], ['style', 'text-align:center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'ul', [['class', 'pagination']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'li', [['class', 'paginate_button previous']], [[2, 'disabled', null]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ManagementPaginationComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ManagementPaginationComponent_2)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'li', [['class', 'paginate_button next']], [[2, 'disabled', null]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ManagementPaginationComponent_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.config.id;
        _ck(_v, 3, 0, currVal_0);
        var currVal_2 = !core_es5["ɵnov"](_v, 3).isFirstPage();
        _ck(_v, 12, 0, currVal_2);
        var currVal_3 = core_es5["ɵnov"](_v, 3).pages;
        _ck(_v, 16, 0, currVal_3);
        var currVal_5 = !core_es5["ɵnov"](_v, 3).isLastPage();
        _ck(_v, 21, 0, currVal_5);
    }, function (_ck, _v) {
        var currVal_1 = core_es5["ɵnov"](_v, 3).isFirstPage();
        _ck(_v, 9, 0, currVal_1);
        var currVal_4 = core_es5["ɵnov"](_v, 3).isLastPage();
        _ck(_v, 18, 0, currVal_4);
    });
}
function View_ManagementPaginationComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'management-pagination', [], null, null, null, View_ManagementPaginationComponent_0, RenderType_ManagementPaginationComponent)), core_es5["ɵdid"](49152, null, 0, managementPagination_component_ManagementPaginationComponent, [], null, null)], null, null);
}
var ManagementPaginationComponentNgFactory = core_es5["ɵccf"]('management-pagination', managementPagination_component_ManagementPaginationComponent, View_ManagementPaginationComponent_Host_0, { config: 'config' }, { searchEventEmitter: 'searchEventEmitter' }, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L3BhZ2luYXRpb24vbWFuYWdlbWVudFBhZ2luYXRpb24uY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL01hbmFnbWVudC9wYWdpbmF0aW9uL21hbmFnZW1lbnRQYWdpbmF0aW9uLmNvbXBvbmVudC50cyIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL01hbmFnbWVudC9wYWdpbmF0aW9uL21hbmFnZW1lbnRQYWdpbmF0aW9uLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L3BhZ2luYXRpb24vbWFuYWdlbWVudFBhZ2luYXRpb24uY29tcG9uZW50LnRzLk1hbmFnZW1lbnRQYWdpbmF0aW9uQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImNvbC1sZy0xMlwiPiA8cGFnaW5hdGlvbi10ZW1wbGF0ZSAjcD1cInBhZ2luYXRpb25BcGlcIiBbaWRdPVwiY29uZmlnLmlkXCIgKHBhZ2VDaGFuZ2UpPVwiY29uZmlnLmN1cnJlbnRQYWdlID0gJGV2ZW50O3NlYXJjaCgpXCI+IDxkaXYgc3R5bGU9XCJ0ZXh0LWFsaWduOmNlbnRlclwiIGNsYXNzPVwiZGF0YVRhYmxlc19wYWdpbmF0ZSBwYWdpbmdfZnVsbF9udW1iZXJzXCI+IDx1bCBjbGFzcz1cInBhZ2luYXRpb25cIj4gPGxpIGNsYXNzPVwicGFnaW5hdGVfYnV0dG9uIHByZXZpb3VzXCIgW2NsYXNzLmRpc2FibGVkXT1cInAuaXNGaXJzdFBhZ2UoKVwiPiA8YSAqbmdJZj1cIiFwLmlzRmlyc3RQYWdlKClcIiAoY2xpY2spPVwicC5wcmV2aW91cygpXCI+UFJFVklPVVM8L2E+IDwvbGk+IDxuZy1jb250YWluZXIgKm5nRm9yPVwibGV0IHBhZ2Ugb2YgcC5wYWdlc1wiPiA8bGkgY2xhc3M9XCJwYWdpbmF0ZV9idXR0b25cIiBbY2xhc3MuYWN0aXZlXT1cInAuZ2V0Q3VycmVudCgpID09PSBwYWdlLnZhbHVlXCI+IDxhIChjbGljayk9XCJwLnNldEN1cnJlbnQocGFnZS52YWx1ZSlcIiAqbmdJZj1cInAuZ2V0Q3VycmVudCgpICE9PSBwYWdlLnZhbHVlXCI+IHt7IHBhZ2UubGFiZWwgfX0gPC9hPiA8YSAqbmdJZj1cInAuZ2V0Q3VycmVudCgpID09PSBwYWdlLnZhbHVlXCI+IHt7IHBhZ2UubGFiZWwgfX0gPC9hPiA8L2xpPiA8L25nLWNvbnRhaW5lcj4gPGxpIGNsYXNzPVwicGFnaW5hdGVfYnV0dG9uIG5leHRcIiBbY2xhc3MuZGlzYWJsZWRdPVwicC5pc0xhc3RQYWdlKClcIj4gPGEgKm5nSWY9XCIhcC5pc0xhc3RQYWdlKClcIiAoY2xpY2spPVwicC5uZXh0KClcIj5ORVhUPC9hPiA8L2xpPiA8L3VsPiA8L2Rpdj4gPC9wYWdpbmF0aW9uLXRlbXBsYXRlPiA8L2Rpdj4iLCI8bWFuYWdlbWVudC1wYWdpbmF0aW9uPjwvbWFuYWdlbWVudC1wYWdpbmF0aW9uPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQXVUO01BQUE7UUFBQTtRQUE0QjtVQUFBO1VBQUE7UUFBQTtRQUE1QjtNQUFBLGdDQUFtRDs7OztvQkFBMkk7TUFBQTtRQUFBO1FBQUc7VUFBQTtVQUFBO1FBQUE7UUFBSDtNQUFBLGdDQUE0RTs7UUFBQTtRQUFBOzs7O29CQUF1QjtNQUFBLHdFQUF5QzthQUFBO0lBQUE7SUFBQTs7OztvQkFBcFE7TUFBQTtNQUEyQyxzQ0FBQztVQUFBO1VBQUEsNENBQTJFO1VBQUEsUUFBQztVQUFBLDhDQUFBO1VBQUEsc0VBQWtHO2lCQUFBLHVCQUFDO1VBQUEsOERBQUE7VUFBQTtNQUErRCxzQ0FBTTs7UUFBbEk7UUFBdEMsV0FBc0MsU0FBdEM7UUFBc0c7UUFBSCxXQUFHLFNBQUg7O1FBQW5KO1FBQTVCLFdBQTRCLFNBQTVCOzs7O29CQUF5VTtNQUFBO1FBQUE7UUFBMkI7VUFBQTtVQUFBO1FBQUE7UUFBM0I7TUFBQSxnQ0FBOEM7Ozs7b0JBQWh5QjtNQUFBO01BQXVCLHNDQUFDO1VBQUE7VUFBQTtZQUFBO1lBQUE7WUFBeUQ7Y0FBQTtjQUFBO2NBQUE7WUFBQTtZQUF6RDtVQUFBLHVDQUFBO1VBQUE7TUFBNkcsc0NBQUM7VUFBQTtVQUFBO01BQStFLHNDQUFDO1VBQUE7VUFBQSw4QkFBdUIsc0NBQUM7aUJBQUE7Y0FBQTtjQUFBLGdCQUF3RSxzQ0FBQztVQUFBO2FBQUE7VUFBQSx3QkFBK0Qsc0NBQU07VUFBQSxRQUFDO1VBQUEsOENBQUE7VUFBQTtVQUFBLGVBQWdULHNDQUFDO1VBQUE7VUFBQSwwREFBbUU7VUFBQSxRQUFDO1VBQUEsOENBQUE7VUFBQSxzRUFBc0Q7aUJBQUEsdUJBQU0sc0NBQU07aUJBQUEsdUJBQU8sc0NBQXVCO2lCQUFBOztJQUFseEI7SUFBeEMsV0FBd0MsU0FBeEM7SUFBa1M7SUFBSCxZQUFHLFNBQUg7SUFBb0Y7SUFBZCxZQUFjLFNBQWQ7SUFBd1g7SUFBSCxZQUFHLFNBQUg7O0lBQS9kO0lBQXJDLFdBQXFDLFNBQXJDO0lBQWllO0lBQWpDLFlBQWlDLFNBQWpDOzs7O29CQ0E5cUI7TUFBQTs4Q0FBQSxVQUFBO01BQUE7Ozs7In0=
//# sourceMappingURL=managementPagination.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/services/orderService.ts
var services_orderService = __webpack_require__("72WZ");

// EXTERNAL MODULE: ./app/services/userService.ts
var services_userService = __webpack_require__("ZSxL");

// EXTERNAL MODULE: ./app/objects/requests/baseSearchRequest.ts
var baseSearchRequest = __webpack_require__("hDLL");

// CONCATENATED MODULE: ./app/objects/requests/orderSearchRequest.ts


/**
 * Created by alex.y on 9/13/2017.
 */
var orderSearchRequest_OrderSearchRequest = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](OrderSearchRequest, _super);
    function OrderSearchRequest(obj) {
        var _this = _super.call(this) || this;
        Object.assign(_this, obj);
        return _this;
    }
    return OrderSearchRequest;
}(baseSearchRequest["a" /* BaseSearchRequest */]));

//# sourceMappingURL=orderSearchRequest.js.map
// EXTERNAL MODULE: ./app/objects/management/order/orderViewType.ts
var orderViewType = __webpack_require__("9ev/");

// EXTERNAL MODULE: ./app/objects/components/component.ts
var component = __webpack_require__("+TKD");

// EXTERNAL MODULE: ./app/common/helpers/userViewHelper.ts
var userViewHelper = __webpack_require__("AIey");

// CONCATENATED MODULE: ./app/components/Managment/orderManagement/baseOrderManagement.ts






/**
 * Created by svitlana.i on 10/10/2017.
 */
var baseOrderManagement_BaseOrderManagement = /** @class */ (function () {
    function BaseOrderManagement(orderService, location, customerService, userService, storageManager, userViewService, orderODataService) {
        var _this = this;
        this.orderService = orderService;
        this.location = location;
        this.customerService = customerService;
        this.userService = userService;
        this.storageManager = storageManager;
        this.userViewService = userViewService;
        this.orderODataService = orderODataService;
        this.config = {
            id: 'custom',
            itemsPerPage: 12,
            currentPage: 1,
            totalItems: 1
        };
        this.agentId = null;
        this.customerId = null;
        this.query = "";
        this.orders = [];
        this.isLoading = false;
        this.isViewLoading = false;
        this.currentUser = null;
        this.isTableShown = true;
        this.tableColumns = [];
        storageManager.getCurrentUser().then(function (user) {
            _this.currentUser = user;
        });
    }
    BaseOrderManagement.prototype.getSearchParams = function () {
        var result = new OrderSearch();
        result.AgentId = this.agentId;
        result.Query = this.query;
        result.CustomerID = this.customerId;
        return result;
    };
    BaseOrderManagement.prototype.getColumns = function (viewType) {
        if (viewType === void 0) { viewType = null; }
        return userViewHelper["a" /* UserViewHelper */].getColumns(this.userViewService, component["a" /* Component */].OrderManagement, viewType);
    };
    Object.defineProperty(BaseOrderManagement.prototype, "currentView", {
        get: function () {
            if (this.userViewService.userView)
                return this.userViewService.userView[component["a" /* Component */].OrderManagement].ViewType;
            return orderViewType["a" /* OrderViewType */].Tile;
        },
        enumerable: true,
        configurable: true
    });
    BaseOrderManagement.prototype.search = function (removeAgentId, redirectURL, isLazyLoad, showSpinner) {
        var _this = this;
        if (removeAgentId === void 0) { removeAgentId = true; }
        if (redirectURL === void 0) { redirectURL = "/management/order"; }
        if (isLazyLoad === void 0) { isLazyLoad = false; }
        if (showSpinner === void 0) { showSpinner = true; }
        var isOrderManagement = redirectURL == "/management/order";
        var top = (this.currentView == orderViewType["a" /* OrderViewType */].Table) && isOrderManagement ? 20 : this.config.itemsPerPage;
        var orderBy = userViewHelper["a" /* UserViewHelper */].getColumnOrderBy(this.userViewService.userView, component["a" /* Component */].OrderManagement);
        this.isLoading = true;
        this.isViewLoading = !isLazyLoad && showSpinner;
        if (removeAgentId) {
            this.location.replaceState(redirectURL);
            this.agentId = null;
            var searchQuery = calculatorHelper["a" /* CalculatorHelper */].replaceOrderPrefix(this.query);
            return this.orderService.search(new orderSearchRequest_OrderSearchRequest({
                Skip: (this.config.currentPage - 1) * this.config.itemsPerPage,
                Top: top,
                Query: searchQuery,
                OrderBy: orderBy
            })).then(function (orders) { return _this.searchResolve(orders, isLazyLoad); })
                .catch(function (reject) { return _this.searchReject(reject); });
        }
        else if (this.agentId) {
            return this.orderODataService.getOrdersByAgentId(this.agentId, (this.config.currentPage - 1) * this.config.itemsPerPage, top, orderBy)
                .then(function (orders) { return _this.searchResolve(orders, isLazyLoad); })
                .catch(function (reject) { return _this.searchReject(reject); });
        }
        else {
            return this.orderODataService.getByCustomerId(this.customerId, (this.config.currentPage - 1) * this.config.itemsPerPage, top, orderBy)
                .then(function (orders) { return _this.searchResolve(orders, isLazyLoad); })
                .catch(function (reject) { return _this.searchReject(reject); });
        }
    };
    BaseOrderManagement.prototype.searchResolve = function (orders, isLazyLoad) {
        if (isLazyLoad === void 0) { isLazyLoad = false; }
        if (this.currentView == orderViewType["a" /* OrderViewType */].Table && isLazyLoad) {
            (_a = this.orders).push.apply(_a, orders.Items);
            this.orders = this.orders.slice(); // need for ngx-data-table detect changes!!!!
        }
        else {
            this.orders = orders.Items;
        }
        this.config.totalItems = orders.TotalCount;
        document.getElementById('mainPanel').scrollTop = 0;
        this.isLoading = false;
        this.isViewLoading = false;
        this.isTableShown = true;
        return this.orders;
        var _a;
    };
    BaseOrderManagement.prototype.searchReject = function (reject) {
        this.orders.splice(0, this.orders.length);
        this.isViewLoading = false;
        this.isLoading = false;
        return this.orders;
    };
    return BaseOrderManagement;
}());

//# sourceMappingURL=baseOrderManagement.js.map
// CONCATENATED MODULE: ./app/objects/report/feeTotal.ts
/**
 * Created by alex.y on 9/22/2017.
 */
var FeeTotal = /** @class */ (function () {
    function FeeTotal() {
    }
    return FeeTotal;
}());

//# sourceMappingURL=feeTotal.js.map
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./app/common/helpers/chartsHelper.ts



/**
 * Created by alex.y on 12/15/2017.
 */
var chartsHelper_ChartsHelper = /** @class */ (function () {
    function ChartsHelper() {
    }
    ChartsHelper.convertAndCutDate = function (totalFeeResponses, startDate, endDate) {
        for (var _i = 0, totalFeeResponses_1 = totalFeeResponses; _i < totalFeeResponses_1.length; _i++) {
            var tf = totalFeeResponses_1[_i];
            for (var _a = 0, _b = tf.FeeTotals; _a < _b.length; _a++) {
                var ft = _b[_a];
                ft.Date = new Date(moment("" + ft.Date).local().format('MM/DD/YYYY'));
            }
        }
        this.groupByDate(totalFeeResponses, startDate, endDate);
    };
    ChartsHelper.groupByDate = function (totalFeeResponses, startDate, endDate) {
        for (var _i = 0, totalFeeResponses_2 = totalFeeResponses; _i < totalFeeResponses_2.length; _i++) {
            var tf = totalFeeResponses_2[_i];
            var summaryFeeTotal = new Array();
            for (var i = 0; i < tf.FeeTotals.length - 1; i++) {
                if (tf.FeeTotals[i].Date < startDate || tf.FeeTotals[i].Date > endDate) {
                    tf.FeeTotals.splice(i, 1);
                    i--;
                }
            }
            var grouped = lodash["groupBy"](tf.FeeTotals, "Date");
            for (var _a = 0, _b = lodash["values"](grouped); _a < _b.length; _a++) {
                var g = _b[_a];
                if (g.length == 0)
                    continue;
                var newFeeTotal = new FeeTotal();
                newFeeTotal.Date = g[0].Date;
                newFeeTotal.Total = lodash["sumBy"](g, "Total");
                summaryFeeTotal.push(newFeeTotal);
            }
            tf.FeeTotals = summaryFeeTotal;
        }
    };
    return ChartsHelper;
}());

//# sourceMappingURL=chartsHelper.js.map
// EXTERNAL MODULE: ./node_modules/ngx-odata-v4/ngx-odata-v4.es5.js
var ngx_odata_v4_es5 = __webpack_require__("MDYC");

// CONCATENATED MODULE: ./app/objects/responses/searchResponse.ts
/**
 * Created by alex.y on 7/31/2017.
 */
var SearchResponse = /** @class */ (function () {
    function SearchResponse(obj) {
        Object.assign(this, obj);
    }
    return SearchResponse;
}());

//# sourceMappingURL=searchResponse.js.map
// CONCATENATED MODULE: ./app/services/orderOData.service.ts




var orderOData_service_OrderODataService = /** @class */ (function () {
    function OrderODataService(http, config) {
        this.http = http;
        this.config = config;
    }
    OrderODataService.prototype.search = function (request) {
        var query = this.createQuery(request.Skip, request.Top, request.OrderBy);
        if (request.Query) {
            query.filterComplex("contains(Customer/Email, '" + request.Query + "') \n            or contains(Customer/FirstName, '" + request.Query + "') \n            or contains(Customer/LastName, '" + request.Query + "') \n            or contains(Customer/Company/Name, '" + request.Query + "') \n            or startswith(cast(Id, 'Edm.String'),'" + request.Query + "')\n            or contains(concat(concat(Customer/FirstName, ' '), Customer/LastName), '" + request.Query + "' )\n            ");
        }
        return this.http.get(this.config.config.ApiUrl + "/OrderOData?" + query.compile()).toPromise().then(function (x) {
            var result = x.json();
            return new SearchResponse({
                Items: result.value,
                TotalCount: result['@odata.count']
            });
        });
    };
    OrderODataService.prototype.expandAll = function (query) {
        query.expand("OrderItems", function (oi) {
            return oi.expand("CanadianCurrencyCode");
        })
            .expand("Agent", function (agent) {
            agent.select("FullName", "Email");
        })
            .expand("Locations")
            .expand("Currency")
            .expand("Customer", function (cust) {
            return cust.expand("Company");
        }).expand("Totals");
    };
    OrderODataService.prototype.createQuery = function (skip, top, orderBy) {
        if (orderBy === void 0) { orderBy = null; }
        var query = ngx_odata_v4_es5["b" /* Query */].create().count(true);
        if (orderBy && orderBy.PropertyName != "''")
            query.orderByComplex(orderBy.PropertyName.split('.').join('/') + " " + orderBy.OrderBy);
        query.skip(skip).top(top);
        this.expandAll(query);
        return query;
    };
    OrderODataService.prototype.getOrdersByAgentId = function (agentId, skip, top, orderBy) {
        if (orderBy === void 0) { orderBy = null; }
        var query = this.createQuery(skip, top, orderBy);
        query.filterComplex("AgentId eq " + agentId);
        return this.http.get(this.config.config.ApiUrl + "/OrderOData?" + query.compile()).toPromise().then(function (x) {
            var result = x.json();
            return new SearchResponse({
                Items: result.value,
                TotalCount: result['@odata.count']
            });
        });
    };
    OrderODataService.prototype.getByCustomerId = function (customerId, skip, top, orderBy) {
        if (orderBy === void 0) { orderBy = null; }
        var query = this.createQuery(skip, top, orderBy);
        query.filterComplex("Customer/OriginalId eq " + customerId);
        return this.http.get(this.config.config.ApiUrl + "/OrderOData?" + query.compile()).toPromise().then(function (x) {
            var result = x.json();
            return new SearchResponse({
                Items: result.value,
                TotalCount: result['@odata.count']
            });
        });
    };
    OrderODataService.ctorParameters = function () { return [{ type: http_es5["e" /* Http */] }, { type: services_configService["a" /* ConfigService */] }]; };
    return OrderODataService;
}());

//# sourceMappingURL=orderOData.service.js.map
// CONCATENATED MODULE: ./app/components/dashboard/dashboard.component.ts












var dashboard_component_DashboardComponent = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](DashboardComponent, _super);
    function DashboardComponent(route, orderService, location, customerService, userService, router, storageManager, userViewService, orderODataService) {
        var _this = _super.call(this, orderService, location, customerService, userService, storageManager, userViewService, orderODataService) || this;
        _this.route = route;
        _this.orderService = orderService;
        _this.location = location;
        _this.customerService = customerService;
        _this.userService = userService;
        _this.router = router;
        _this.storageManager = storageManager;
        _this.userViewService = userViewService;
        _this.orderODataService = orderODataService;
        _this.stringLink = String;
        _this.query = "";
        _this.totalFees = [];
        _this.totalQuantity = [];
        return _this;
    }
    DashboardComponent.prototype.ngOnInit = function () {
        this.config.totalItems = this.route.snapshot.data.userViewOrder.orders.TotalCount;
        this.orders = this.route.snapshot.data.userViewOrder.orders.Items;
        this.totalFees = this.route.snapshot.data.totalFee;
        this.totalQuantity = this.route.snapshot.data.totalQuantity;
        var beginDate = new Date((new Date()).setDate(new Date().getDate() - 7), 0, 0, 0);
        var endDate = new Date();
        chartsHelper_ChartsHelper.convertAndCutDate(this.totalFees, beginDate, endDate);
        chartsHelper_ChartsHelper.convertAndCutDate(this.totalQuantity, beginDate, endDate);
        this.tableColumns = this.getColumns(orderViewType["a" /* OrderViewType */].Tile);
    };
    DashboardComponent.prototype.goToSearch = function () {
        this.router.navigate(['/management/order', { query: this.query }]);
    };
    DashboardComponent.ctorParameters = function () { return [{ type: router_es5["a" /* ActivatedRoute */] }, { type: services_orderService["a" /* OrderService */] }, { type: common_es5["Location"] }, { type: services_customerService["a" /* CustomerService */] }, { type: services_userService["a" /* UserService */] }, { type: router_es5["n" /* Router */] }, { type: managers_storageManager["a" /* StorageManager */] }, { type: services_userViewService["a" /* UserViewService */] }, { type: orderOData_service_OrderODataService }]; };
    return DashboardComponent;
}(baseOrderManagement_BaseOrderManagement));

//# sourceMappingURL=dashboard.component.js.map
// CONCATENATED MODULE: ./app/components/Managment/search/managementSearch.component.ts

/**
 * Created by alex.y on 9/11/2017.
 */
var managementSearch_component_ManagementSearchComponent = /** @class */ (function () {
    function ManagementSearchComponent() {
        this.searchEventEmitter = new core_es5["EventEmitter"]();
        this.createEventEmitter = new core_es5["EventEmitter"]();
        this.showCreate = false;
        this.createIcon = "";
        this.helpText = "";
        this.query = "";
        this.showCleanFilter = false;
        this.progress = false;
        this.loading = false;
        this.queryChange = new core_es5["EventEmitter"]();
    }
    ManagementSearchComponent.prototype.search = function () {
        this.queryChange.emit(this.query);
        this.searchEventEmitter.emit(true);
    };
    return ManagementSearchComponent;
}());

//# sourceMappingURL=managementSearch.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/search/managementSearch.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_ManagementSearchComponent = [];
var RenderType_ManagementSearchComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ManagementSearchComponent, data: {} });
function View_ManagementSearchComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'button', [['class',
                'btn btn-white btn-round btn-just-icon create-icon']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.createEventEmitter.emit(true) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.createIcon;
        _ck(_v, 4, 0, currVal_0);
    });
}
function View_ManagementSearchComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'button', [['class',
                'btn btn-white btn-round btn-just-icon delete']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                _co.query = '';
                var pd_0 = (_co.search() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['delete_sweep'])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_ManagementSearchComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'progress', [['aria-label',
                'Content loading…'], ['style', 'accent-color:coral;visibility:visible;width:calc(100% - 19px);margin-left:10px;margin-top:10px']], [[4, 'visibility', null]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.loading ? 'visible' : 'hidden');
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ManagementSearchComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 51, 'div', [['class',
                'row top_buttons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 43, 'div', [['class', 'col-sm-7 col-xs-9 top_buttons_body customer_top_buttons']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 37, 'div', [['style', 'position:relative']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_ManagementSearchComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 23, 'div', [['class', 'search']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'button', [['class',
                'btn btn-white btn-round btn-just-icon'], ['type', 'submit']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.search() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['search'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'ripple-container']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'form-group form-search is-empty']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'input', [['class', 'form-control'], ['placeholder', 'Search'], ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'keyup.enter'], [null, 'ngModelChange'], [null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 23)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 23).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 23)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 23)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 24).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('keyup.enter' === en)) {
                var pd_5 = (_co.search() !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.query = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"],
            core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[8, null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class',
                'material-input']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ManagementSearchComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_ManagementSearchComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'text-help mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'top_buttons_body top_buttons_right customer_top_buttons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), core_es5["ɵncd"](null, 0), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.showCreate;
        _ck(_v, 7, 0, currVal_0);
        var currVal_8 = _co.query;
        _ck(_v, 26, 0, currVal_8);
        var currVal_9 = (_co.query || _co.showCleanFilter);
        _ck(_v, 35, 0, currVal_9);
        var currVal_10 = _co.progress;
        _ck(_v, 40, 0, currVal_10);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = core_es5["ɵnov"](_v, 28).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 28).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 28).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 28).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 28).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 28).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 28).ngClassPending;
        _ck(_v, 22, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_11 = _co.helpText;
        _ck(_v, 44, 0, currVal_11);
    });
}
function View_ManagementSearchComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'management-search', [], null, null, null, View_ManagementSearchComponent_0, RenderType_ManagementSearchComponent)), core_es5["ɵdid"](49152, null, 0, managementSearch_component_ManagementSearchComponent, [], null, null)], null, null);
}
var ManagementSearchComponentNgFactory = core_es5["ɵccf"]('management-search', managementSearch_component_ManagementSearchComponent, View_ManagementSearchComponent_Host_0, { showCreate: 'showCreate',
    createIcon: 'createIcon', helpText: 'helpText', query: 'query', showCleanFilter: 'showCleanFilter',
    progress: 'progress', loading: 'loading' }, { searchEventEmitter: 'searchEventEmitter',
    createEventEmitter: 'createEventEmitter', queryChange: 'queryChange' }, ['*']);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=managementSearch.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/ng2-charts/charts/charts.js
var charts = __webpack_require__("GRaa");
var charts_default = /*#__PURE__*/__webpack_require__.n(charts);

// CONCATENATED MODULE: ./app/components/reports/charts/totalFeeChart/totalFeeChart.component.ts
var TotalFeeChartComponent = /** @class */ (function () {
    function TotalFeeChartComponent() {
        this.totalFeeResponses = [];
        this.showCurrency = true;
        this.showTotal = false;
        this.showLegend = false;
        this.agentColors = [];
        /* Chart Settings Start */
        // lineChart
        this.lineChartData = [];
        this.lineChartLabels = [];
        this.lineChartColors = [];
        this.lineChartLegend = true;
        this.lineChartType = 'line';
    }
    /* Chart Settings End*/
    TotalFeeChartComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setChartData();
        this.generateColors();
        var max = this.getMax();
        var ticks = {
            beginAtZero: true,
            callback: function (label) {
                return _this.formatNumber(label);
            }
        };
        if (max < 10) {
            ticks["min"] = 0;
            ticks["max"] = 10;
        }
        //this.convertAndCutDate();
        this.lineChartOptions = {
            responsive: true,
            legend: {
                display: this.showLegend,
                position: 'right',
                labels: {
                    usePointStyle: true
                },
            },
            scales: {
                yAxes: [{
                        ticks: ticks
                    }]
            },
            tooltips: {
                callbacks: {
                    label: function (tooltipItem) {
                        return _this.formatNumber(tooltipItem.yLabel);
                    },
                    title: function (tooltipItem) {
                        var email = _this.lineChartData[tooltipItem[0].datasetIndex].label;
                        return tooltipItem[0].xLabel + " : " + email;
                    }
                }
            }
        };
    };
    TotalFeeChartComponent.prototype.changeHeight = function (event) {
        if (this.agentSelectorComponent)
            this.agentSelectorComponent.resizeSelect(this.elementView.nativeElement.offsetHeight);
    };
    TotalFeeChartComponent.prototype.formatNumber = function (value) {
        value = +value.toFixed(2);
        var parts = value.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return "" + (this.showCurrency ? 'CAD $' : '') + parts.join(".");
    };
    TotalFeeChartComponent.prototype.getMax = function () {
        var max = 0;
        for (var _i = 0, _a = this.lineChartData; _i < _a.length; _i++) {
            var it = _a[_i];
            for (var _b = 0, _c = it.data; _b < _c.length; _b++) {
                var data = _c[_b];
                if (data > max)
                    max = data;
            }
        }
        return max;
    };
    TotalFeeChartComponent.prototype.setChartData = function () {
        var _this = this;
        var dates = [];
        for (var _i = 0, _a = this.totalFeeResponses; _i < _a.length; _i++) {
            var resp = _a[_i];
            var _loop_1 = function (it) {
                if (!dates.find(function (x) { return x.toString() == it.Date.toString(); }))
                    dates.push(it.Date);
            };
            for (var _b = 0, _c = resp.FeeTotals; _b < _c.length; _b++) {
                var it = _c[_b];
                _loop_1(it);
            }
        }
        setTimeout(function (x) {
            if (_this.agentSelectorComponent)
                _this.agentSelectorComponent.resizeSelect(_this.elementView.nativeElement.offsetHeight);
        }, 50);
        dates.sort(function (x, y) {
            return new Date(x) >= new Date(y) ? 1 : -1;
        });
        for (var _d = 0, dates_1 = dates; _d < dates_1.length; _d++) {
            var d = dates_1[_d];
            this.lineChartLabels.push(String.formatDateMMDDYYYY(d.toString()));
        }
        if (this.showTotal) {
            this.lineChartData.push({
                data: this.getTotal(this.totalFeeResponses, dates),
                label: "Total"
            });
            this.lineChartLabels = [];
            for (var _e = 0, dates_2 = dates; _e < dates_2.length; _e++) {
                var d = dates_2[_e];
                this.lineChartLabels.push(String.formatDateDDMMMYYYY(d.toString()));
            }
            return;
        }
        for (var _f = 0, _g = this.totalFeeResponses; _f < _g.length; _f++) {
            var agent = _g[_f];
            var data = this.getData(agent.FeeTotals);
            this.lineChartData.push({
                data: data,
                label: agent.Agent.Email
            });
        }
        this.lineChartLabels = [];
        for (var _h = 0, dates_3 = dates; _h < dates_3.length; _h++) {
            var d = dates_3[_h];
            this.lineChartLabels.push(String.formatDateDDMMMYYYY(d.toString()));
        }
    };
    TotalFeeChartComponent.prototype.getTotal = function (arr, dates) {
        var itemValues = new Array();
        for (var i = 0; i < this.lineChartLabels.length; i++) {
            itemValues.push(0);
        }
        for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
            var item = arr_1[_i];
            for (var _a = 0, _b = item.FeeTotals; _a < _b.length; _a++) {
                var fee = _b[_a];
                var index = this.lineChartLabels.indexOf(String.formatDateMMDDYYYY(fee.Date.toString()));
                itemValues[index] += fee.Total;
            }
        }
        return itemValues;
    };
    TotalFeeChartComponent.prototype.getData = function (totalFee) {
        var items = totalFee;
        var itemValues = new Array();
        items.sort(function (x, y) {
            return new Date(x.Date) >= new Date(y.Date) ? 1 : -1;
        });
        for (var i = 0; i < this.lineChartLabels.length; i++) {
            itemValues.push(0);
        }
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var it = items_1[_i];
            var index = this.lineChartLabels.indexOf(String.formatDateMMDDYYYY(it.Date.toString()));
            itemValues.splice(index, 1, it.Total);
        }
        return itemValues;
    };
    TotalFeeChartComponent.prototype.generateColors = function () {
        var _this = this;
        var _loop_2 = function (i) {
            var colorObj = this_1.agentColors.find(function (x) { return x.Email == _this.lineChartData[i - 1].label; });
            var color = "#EB5757";
            if (colorObj)
                color = colorObj.color;
            this_1.lineChartColors.push({
                fill: false,
                backgroundColor: color,
                borderColor: color,
                pointBackgroundColor: color,
                pointBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: color,
            });
        };
        var this_1 = this;
        for (var i = 1; i < this.lineChartData.length + 1; i++) {
            _loop_2(i);
        }
    };
    return TotalFeeChartComponent;
}());

//# sourceMappingURL=totalFeeChart.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/reports/charts/totalFeeChart/totalFeeChart.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_TotalFeeChartComponent = [];
var RenderType_TotalFeeChartComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_TotalFeeChartComponent, data: {} });
function View_TotalFeeChartComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { elementView: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'chart-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, [[1, 0], ['chart', 1]], null, 2, 'canvas', [['baseChart',
                ''], ['height', '150'], ['width', '400']], null, null, null, null, null)), core_es5["ɵdid"](737280, null, 0, charts["BaseChartDirective"], [core_es5["ElementRef"]], { datasets: [0, 'datasets'], labels: [1, 'labels'], options: [2,
                'options'], chartType: [3, 'chartType'], colors: [4, 'colors'], legend: [5, 'legend'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.lineChartData;
        var currVal_1 = _co.lineChartLabels;
        var currVal_2 = _co.lineChartOptions;
        var currVal_3 = _co.lineChartType;
        var currVal_4 = _co.lineChartColors;
        var currVal_5 = _co.lineChartLegend;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    }, null);
}
function View_TotalFeeChartComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'chart-total-fee', [], null, [['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).changeHeight() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_TotalFeeChartComponent_0, RenderType_TotalFeeChartComponent)), core_es5["ɵdid"](114688, null, 0, TotalFeeChartComponent, [], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var TotalFeeChartComponentNgFactory = core_es5["ɵccf"]('chart-total-fee', TotalFeeChartComponent, View_TotalFeeChartComponent_Host_0, { totalFeeResponses: 'totalFeeResponses',
    showCurrency: 'showCurrency', showTotal: 'showTotal', showLegend: 'showLegend',
    agentColors: 'agentColors', agentSelectorComponent: 'agentSelectorComponent' }, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy9jaGFydHMvdG90YWxGZWVDaGFydC90b3RhbEZlZUNoYXJ0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9yZXBvcnRzL2NoYXJ0cy90b3RhbEZlZUNoYXJ0L3RvdGFsRmVlQ2hhcnQuY29tcG9uZW50LnRzIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy9jaGFydHMvdG90YWxGZWVDaGFydC90b3RhbEZlZUNoYXJ0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy9jaGFydHMvdG90YWxGZWVDaGFydC90b3RhbEZlZUNoYXJ0LmNvbXBvbmVudC50cy5Ub3RhbEZlZUNoYXJ0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImNoYXJ0LXdyYXBwZXJcIj4gPGNhbnZhcyBiYXNlQ2hhcnQgd2lkdGg9XCI0MDBcIiBoZWlnaHQ9XCIxNTBcIiAjY2hhcnQgW2RhdGFzZXRzXT1cImxpbmVDaGFydERhdGFcIiBbbGFiZWxzXT1cImxpbmVDaGFydExhYmVsc1wiIFtvcHRpb25zXT1cImxpbmVDaGFydE9wdGlvbnNcIiBbY29sb3JzXT1cImxpbmVDaGFydENvbG9yc1wiIFtsZWdlbmRdPVwibGluZUNoYXJ0TGVnZW5kXCIgW2NoYXJ0VHlwZV09XCJsaW5lQ2hhcnRUeXBlXCI+IDwvY2FudmFzPiA8L2Rpdj4iLCI8Y2hhcnQtdG90YWwtZmVlPjwvY2hhcnQtdG90YWwtZmVlPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozt5RENBQTtNQUFBO01BQUEsNENBQTJCO01BQUM7VUFBQTtVQUFBLHFDQUFBO1VBQUE7Y0FBQTtVQUFBLGVBQXVOLHNDQUFVO1VBQUE7O0lBQS9LO0lBQTJCO0lBQTJCO0lBQW1GO0lBQXREO0lBQTJCO0lBQWhLLFdBQWtELFVBQTJCLFVBQTJCLFVBQW1GLFVBQXRELFVBQTJCLFNBQWhLOzs7O29CQ0E1QjtNQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO01BQUEsMkVBQUE7TUFBQTs7UUFBQTs7Ozs7OzsifQ==
//# sourceMappingURL=totalFeeChart.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/app/components/dashboard/dashboard.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



















var styles_DashboardComponent = [];
var RenderType_DashboardComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DashboardComponent, data: {} });
function View_DashboardComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-item', [], null, null, null, View_OrderItemComponent_0, RenderType_OrderItemComponent)), core_es5["ɵdid"](49152, null, 0, orderItem_component_OrderItemComponent, [router_es5["n" /* Router */], router_es5["a" /* ActivatedRoute */]], { order: [0, 'order'], paramsInUrl: [1, 'paramsInUrl'],
            columns: [2, 'columns'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _v.context.$implicit;
        var currVal_1 = _co.getSearchParams();
        var currVal_2 = _co.tableColumns;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2);
    }, null);
}
function View_DashboardComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_DashboardComponent_2)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), core_es5["ɵpid"](0, PaginatePipe, [ngx_pagination_PaginationService]),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 3, 0, core_es5["ɵnov"](_v, 4).transform(_co.orders, _co.config));
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_DashboardComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'row'], ['style', 'text-align:center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h2', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' No matching results! '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_DashboardComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'management-pagination', [], null, [[null, 'searchEventEmitter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('searchEventEmitter' === en)) {
                var pd_0 = (_co.search(true, 'dashboard') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ManagementPaginationComponent_0, RenderType_ManagementPaginationComponent)),
        core_es5["ɵdid"](49152, null, 0, managementPagination_component_ManagementPaginationComponent, [], { config: [0, 'config'] }, { searchEventEmitter: 'searchEventEmitter' }), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.config;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_DashboardComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 56, 'div', [['class',
                'main-content dashboard'], ['id', 'dashboard']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 53, 'div', [['class', 'container-fluid']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'management-search', [], null, [[null, 'searchEventEmitter'],
            [null, 'queryChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('searchEventEmitter' === en)) {
                var pd_0 = (_co.goToSearch() !== false);
                ad = (pd_0 && ad);
            }
            if (('queryChange' === en)) {
                var pd_1 = ((_co.query = $event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_ManagementSearchComponent_0, RenderType_ManagementSearchComponent)),
        core_es5["ɵdid"](49152, null, 0, managementSearch_component_ManagementSearchComponent, [], { showCreate: [0,
                'showCreate'], query: [1, 'query'], showCleanFilter: [2, 'showCleanFilter'] }, { searchEventEmitter: 'searchEventEmitter',
            queryChange: 'queryChange' }), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 37, 'div', [['class',
                'row charts']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'div', [['class', 'col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 13, 'div', [['class', 'card']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'card-header'], ['data-background-color', '#E07E3C']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'card-title short-description']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Total Brokerage Fees per last week'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-content']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'chart-total-fee', [], null, [['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 23).changeHeight() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_TotalFeeChartComponent_0, RenderType_TotalFeeChartComponent)),
        core_es5["ɵdid"](114688, null, 0, TotalFeeChartComponent, [], { totalFeeResponses: [0,
                'totalFeeResponses'], showTotal: [1, 'showTotal'], showLegend: [2, 'showLegend'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'div', [['class',
                'col-md-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class', 'card']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-header'], ['data-background-color',
                '#E07E3C']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'card-title short-description']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Total Quotes per last week'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'chart-total-fee', [], null, [['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 41).changeHeight() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_TotalFeeChartComponent_0, RenderType_TotalFeeChartComponent)),
        core_es5["ɵdid"](114688, null, 0, TotalFeeChartComponent, [], { totalFeeResponses: [0,
                'totalFeeResponses'], showCurrency: [1, 'showCurrency'], showTotal: [2, 'showTotal'],
            showLegend: [3, 'showLegend'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DashboardComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DashboardComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DashboardComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = false;
        var currVal_1 = _co.query;
        var currVal_2 = !_co.stringLink.isNullOrEmpty(_co.query);
        _ck(_v, 5, 0, currVal_0, currVal_1, currVal_2);
        var currVal_3 = _co.totalFees;
        var currVal_4 = true;
        var currVal_5 = false;
        _ck(_v, 23, 0, currVal_3, currVal_4, currVal_5);
        var currVal_6 = _co.totalQuantity;
        var currVal_7 = false;
        var currVal_8 = true;
        var currVal_9 = false;
        _ck(_v, 41, 0, currVal_6, currVal_7, currVal_8, currVal_9);
        var currVal_10 = (_co.orders.length > 0);
        _ck(_v, 48, 0, currVal_10);
        var currVal_11 = (_co.orders.length == 0);
        _ck(_v, 51, 0, currVal_11);
        var currVal_12 = (_co.orders.length > 0);
        _ck(_v, 54, 0, currVal_12);
    }, null);
}
function View_DashboardComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'dashboard', [], null, null, null, View_DashboardComponent_0, RenderType_DashboardComponent)),
        core_es5["ɵdid"](114688, null, 0, dashboard_component_DashboardComponent, [router_es5["a" /* ActivatedRoute */], services_orderService["a" /* OrderService */],
            common_es5["Location"], services_customerService["a" /* CustomerService */], services_userService["a" /* UserService */], router_es5["n" /* Router */], managers_storageManager["a" /* StorageManager */],
            services_userViewService["a" /* UserViewService */], orderOData_service_OrderODataService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var DashboardComponentNgFactory = core_es5["ɵccf"]('dashboard', dashboard_component_DashboardComponent, View_DashboardComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=dashboard.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/Managment/customerManagement/customerItem/customerItem.component.ts
/**
 * Created by alex.y on 9/7/2017.
 */
var CustomerItemComponent = /** @class */ (function () {
    function CustomerItemComponent() {
        this.string = String;
    }
    return CustomerItemComponent;
}());

//# sourceMappingURL=customerItem.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/customerManagement/customerItem/customerItem.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_CustomerItemComponent = [];
var RenderType_CustomerItemComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CustomerItemComponent, data: {} });
function View_CustomerItemComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ((_co.customer.LocationStreet ? (_co.customer.LocationStreet + ', ') : '') + (_co.customer.LocationCity ? _co.customer.LocationCity : ''));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CustomerItemComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.customer.LocationCountry;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CustomerItemComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.customer.LocationCountry;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CustomerItemComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.customer.LocationZip;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CustomerItemComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 70, 'div', [['class',
                'col-sp-5 customer-card']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 67, 'div', [['class', 'card card-stats']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.customerModal.show(_co.customer.Id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-header'], ['data-background-color',
                    'orange']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['person'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'card-content']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'category']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'category']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 49, 'div', [['class', 'card-footer']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-5']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'card-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Phone: '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-xs-7 card-info short-description']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'card-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Email: '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-xs-7 card-info big-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'card-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Address: '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class', 'col-xs-7 card-info big-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerItemComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerItemComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerItemComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerItemComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_4 = (_co.customer.LocationStreet || _co.customer.LocationCity);
        _ck(_v, 56, 0, currVal_4);
        var currVal_5 = (!_co.customer.LocationStreet && !_co.customer.LocationCity);
        _ck(_v, 59, 0, currVal_5);
        var currVal_6 = (_co.customer.LocationCountry && (_co.customer.LocationStreet || _co.customer.LocationCity));
        _ck(_v, 62, 0, currVal_6);
        var currVal_7 = _co.customer.LocationZip;
        _ck(_v, 65, 0, currVal_7);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.customer.FirstName;
        _ck(_v, 13, 0, currVal_0);
        var currVal_1 = _co.customer.LastName;
        _ck(_v, 16, 0, currVal_1);
        var currVal_2 = _co.customer.Phone;
        _ck(_v, 30, 0, currVal_2);
        var currVal_3 = _co.customer.Email;
        _ck(_v, 42, 0, currVal_3);
    });
}
function View_CustomerItemComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'customer-item', [], null, null, null, View_CustomerItemComponent_0, RenderType_CustomerItemComponent)), core_es5["ɵdid"](49152, null, 0, CustomerItemComponent, [], null, null)], null, null);
}
var CustomerItemComponentNgFactory = core_es5["ɵccf"]('customer-item', CustomerItemComponent, View_CustomerItemComponent_Host_0, { customer: 'customer',
    customerModal: 'customerModal' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=customerItem.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/objects/requests/customerSearchRequest.ts


/**
 * Created by alex.y on 9/7/2017.
 */
var customerSearchRequest_CustomerSearchRequest = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](CustomerSearchRequest, _super);
    function CustomerSearchRequest(obj) {
        var _this = _super.call(this) || this;
        Object.assign(_this, obj);
        return _this;
    }
    return CustomerSearchRequest;
}(baseSearchRequest["a" /* BaseSearchRequest */]));

//# sourceMappingURL=customerSearchRequest.js.map
// CONCATENATED MODULE: ./app/components/Managment/customerManagement/customerManagement.component.ts





/**
 * Created by alex.y on 9/7/2017.
 */
var customerManagement_component_CustomerManagementComponent = /** @class */ (function () {
    function CustomerManagementComponent(route, customerService) {
        this.route = route;
        this.customerService = customerService;
        this.query = "";
        this.loading = false;
        this.customers = [];
        this.idToBlur = "customer-management";
        this.config = {
            id: 'custom',
            itemsPerPage: 12,
            currentPage: 1,
            totalItems: 1
        };
    }
    CustomerManagementComponent.prototype.unBlurMenu = function () {
        blurUtil["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
    };
    CustomerManagementComponent.prototype.ngOnInit = function () {
        this.config.totalItems = this.route.snapshot.data.customers.TotalCount;
        this.customers = this.route.snapshot.data.customers.Items;
    };
    CustomerManagementComponent.prototype.search = function () {
        var _this = this;
        this.loading = true;
        var field = 'Id';
        if (!String.isNullOrEmpty(this.query))
            field = '_score';
        this.customerService.search(new customerSearchRequest_CustomerSearchRequest({
            Skip: (this.config.currentPage - 1) * this.config.itemsPerPage,
            Top: this.config.itemsPerPage,
            Query: this.query,
            OrderBy: { PropertyName: field, OrderBy: ngx_odata_v4_es5["a" /* OrderBy */].Desc },
            FillOrders: false
        })).then(function (users) {
            _this.customers = users.Data.Items;
            _this.config.totalItems = users.Data.TotalCount;
            document.getElementById('mainPanel').scrollTop = 0;
            _this.loading = false;
        }).catch(function (response) {
            _this.customers.splice(0, _this.customers.length);
            _this.loading = false;
        });
    };
    CustomerManagementComponent.prototype.createCustomer = function () {
        // this.customerModalComponent.show(new User());
    };
    CustomerManagementComponent.prototype.onCustomerSaved = function (customer) {
        var existingCustomer = this.customers.find(function (x) { return x.Id == customer.Id; });
        if (existingCustomer != null) {
            if (customer.Orders.length == 0 && existingCustomer.Orders.length > 0)
                customer.Orders = existingCustomer.Orders;
            Object.assign(existingCustomer, customer);
        }
        else {
            this.customers.unshift(customer);
            this.customers.pop();
            this.config.totalItems += 1;
        }
    };
    CustomerManagementComponent.ctorParameters = function () { return [{ type: router_es5["a" /* ActivatedRoute */] }, { type: services_customerService["a" /* CustomerService */] }]; };
    return CustomerManagementComponent;
}());

//# sourceMappingURL=customerManagement.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/customerManagement/customerManagement.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





















var styles_CustomerManagementComponent = [];
var RenderType_CustomerManagementComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CustomerManagementComponent, data: {} });
function View_CustomerManagementComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'customer-item', [], null, null, null, View_CustomerItemComponent_0, RenderType_CustomerItemComponent)), core_es5["ɵdid"](49152, null, 0, CustomerItemComponent, [], { customer: [0, 'customer'],
            customerModal: [1, 'customerModal'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        var currVal_1 = core_es5["ɵnov"](_v.parent.parent, 1);
        _ck(_v, 3, 0, currVal_0, currVal_1);
    }, null);
}
function View_CustomerManagementComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_CustomerManagementComponent_2)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), core_es5["ɵpid"](0, PaginatePipe, [ngx_pagination_PaginationService]),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 3, 0, core_es5["ɵnov"](_v, 4).transform(_co.customers, _co.config));
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_CustomerManagementComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'row'], ['style', 'text-align:center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h2', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' No matching results! '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_CustomerManagementComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'management-pagination', [], null, [[null, 'searchEventEmitter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('searchEventEmitter' === en)) {
                var pd_0 = (_co.search() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ManagementPaginationComponent_0, RenderType_ManagementPaginationComponent)),
        core_es5["ɵdid"](49152, null, 0, managementPagination_component_ManagementPaginationComponent, [], { config: [0, 'config'] }, { searchEventEmitter: 'searchEventEmitter' }), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.config;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_CustomerManagementComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'customer-modal', [], null, [[null, 'customerSaved'], [null,
                'scroll'], [null, 'mousewheel'], ['document', 'keydown']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('scroll' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onMousewheel($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('mousewheel' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 1).onMousewheel($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('document:keydown' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 1).onArrowDown($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('customerSaved' === en)) {
                var pd_3 = (_co.onCustomerSaved($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, View_CustomerModalComponent_0, RenderType_CustomerModalComponent)), core_es5["ɵdid"](114688, [['customerModal', 4]], 0, customerModal_component["a" /* CustomerModalComponent */], [services_customerService["a" /* CustomerService */], router_es5["n" /* Router */],
            toast_manager["ToastsManager"], core_es5["ChangeDetectorRef"], services_extraDataService["a" /* ExtraDataService */], services_userViewService["a" /* UserViewService */],
            services_emailService["a" /* EmailService */], managers_storageManager["a" /* StorageManager */], services_paymentService["a" /* PaymentService */], services_configService["a" /* ConfigService */]], { idToBlur: [0, 'idToBlur'] }, { customerSaved: 'customerSaved' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'main-content']], [[1, 'id', 0]], null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'div', [['class', 'container-fluid']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 2, 'management-search', [['helpText', 'Search by Name, Email, Phone, Company Name']], null, [[null, 'searchEventEmitter'], [null, 'queryChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('searchEventEmitter' === en)) {
                    _co.config.currentPage = 1;
                    var pd_0 = (_co.search() !== false);
                    ad = (pd_0 && ad);
                }
                if (('queryChange' === en)) {
                    var pd_1 = ((_co.query = $event) !== false);
                    ad = (pd_1 && ad);
                }
                return ad;
            }, View_ManagementSearchComponent_0, RenderType_ManagementSearchComponent)),
        core_es5["ɵdid"](49152, null, 0, managementSearch_component_ManagementSearchComponent, [], { helpText: [0,
                'helpText'], query: [1, 'query'], progress: [2, 'progress'], loading: [3, 'loading'] }, { searchEventEmitter: 'searchEventEmitter', queryChange: 'queryChange' }), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerManagementComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerManagementComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerManagementComponent_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.idToBlur;
        _ck(_v, 1, 0, currVal_0);
        var currVal_2 = 'Search by Name, Email, Phone, Company Name';
        var currVal_3 = _co.query;
        var currVal_4 = true;
        var currVal_5 = _co.loading;
        _ck(_v, 8, 0, currVal_2, currVal_3, currVal_4, currVal_5);
        var currVal_6 = (_co.customers.length > 0);
        _ck(_v, 12, 0, currVal_6);
        var currVal_7 = (_co.customers.length == 0);
        _ck(_v, 15, 0, currVal_7);
        var currVal_8 = (_co.customers.length > 0);
        _ck(_v, 18, 0, currVal_8);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.idToBlur;
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_CustomerManagementComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'customer', [], null, [['window', 'popstate']], function (_v, en, $event) {
            var ad = true;
            if (('window:popstate' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).unBlurMenu($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CustomerManagementComponent_0, RenderType_CustomerManagementComponent)),
        core_es5["ɵdid"](114688, null, 0, customerManagement_component_CustomerManagementComponent, [router_es5["a" /* ActivatedRoute */],
            services_customerService["a" /* CustomerService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CustomerManagementComponentNgFactory = core_es5["ɵccf"]('customer', customerManagement_component_CustomerManagementComponent, View_CustomerManagementComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=customerManagement.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/ng2-cookies/index.js
var ng2_cookies = __webpack_require__("tbtb");
var ng2_cookies_default = /*#__PURE__*/__webpack_require__.n(ng2_cookies);

// CONCATENATED MODULE: ./app/services/uploadService.ts





/**
 * Created by alex.y on 10/3/2017.
 */
var uploadService_UploadService = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](UploadService, _super);
    function UploadService(http, configService) {
        return _super.call(this, http, configService) || this;
    }
    UploadService.prototype.downloadFile = function (fileName, url, additionalParams, downloadFileName) {
        if (fileName === void 0) { fileName = null; }
        if (url === void 0) { url = 'upload'; }
        if (additionalParams === void 0) { additionalParams = []; }
        if (downloadFileName === void 0) { downloadFileName = null; }
        var params = new http_es5["i" /* RequestOptions */]();
        params.headers = new http_es5["d" /* Headers */]();
        params.headers.append("Content-Type", 'application/json');
        params.headers.append("Authorization", "Bearer " + ng2_cookies["Cookie"].get(this.config.ApiTokenCookieName));
        params.method = http_es5["h" /* RequestMethod */].Get;
        params.url = this.config.ApiUrl + "/" + url;
        params.params = new http_es5["l" /* URLSearchParams */]();
        if (fileName)
            params.params.append('filename', fileName);
        if (additionalParams.length > 0)
            additionalParams.forEach(function (p) { return params.params.append(p.param, p.val); });
        params.responseType = http_es5["j" /* ResponseContentType */].Blob;
        return this.http.get(params.url, params).toPromise().then(function (res) {
            var url = window.URL.createObjectURL(res.blob());
            var link = document.createElement('a');
            link.href = url;
            if (fileName)
                link.download = fileName.substring(37);
            else
                link.download = downloadFileName;
            link.click();
            return new Promise(function (resolve, reject) { return resolve(true); });
        });
    };
    UploadService.prototype.exportOrders = function (fileName, dateFrom, dateTo) {
        var paramArray = [];
        if (dateFrom)
            paramArray.push({
                param: 'from',
                val: (new Date(dateFrom)).toLocaleDateString()
            });
        if (dateTo)
            paramArray.push({
                param: 'to',
                val: (new Date(dateTo)).toLocaleDateString()
            });
        return this.downloadFile(fileName, "upload/export/order", paramArray);
    };
    UploadService.prototype.downloadDocument = function (id, type) {
        return this.downloadFile(null, "upload/export/" + type + "/" + id, [], type);
    };
    UploadService.prototype.uploadCustomers = function (uploadData) {
        var params = new http_es5["i" /* RequestOptions */]();
        params.headers = new http_es5["d" /* Headers */]();
        params.headers.append("Authorization", "Bearer " + ng2_cookies["Cookie"].get(this.config.ApiTokenCookieName));
        params.method = http_es5["h" /* RequestMethod */].Post;
        var url = this.config.ApiUrl + "/upload/customers";
        return this.http.post(url, uploadData, params).toPromise();
    };
    UploadService.prototype.uploadFile = function (orderId, type, file) {
        var uploadData = new FormData();
        uploadData.append('files', file, file.name);
        var req = new http_es5["g" /* Request */]({
            url: this.config.ApiUrl + "/upload/vehicle?orderId=" + orderId + "&type=" + type + "&name=" + file.name,
            method: http_es5["h" /* RequestMethod */].Post,
            headers: new http_es5["d" /* Headers */]({
                Authorization: "Bearer " + ng2_cookies["Cookie"].get(this.config.ApiTokenCookieName)
            }),
            body: uploadData
        });
        return this.http.request(req);
    };
    UploadService.prototype.getAllFiles = function (orderId) {
        var params = new http_es5["i" /* RequestOptions */]();
        params.headers = new http_es5["d" /* Headers */]();
        params.headers.append("Authorization", "Bearer " + ng2_cookies["Cookie"].get(this.config.ApiTokenCookieName));
        params.url = "upload/vehicle/getFiles/" + orderId;
        params.method = http_es5["h" /* RequestMethod */].Get;
        return this.get(params);
    };
    UploadService.ctorParameters = function () { return [{ type: http_es5["e" /* Http */] }, { type: services_configService["a" /* ConfigService */] }]; };
    return UploadService;
}(baseService["a" /* BaseApi */]));

//# sourceMappingURL=uploadService.js.map
// CONCATENATED MODULE: ./app/components/Managment/customers-import/customersImport.component.ts



var customersImport_component_CustomersImportComponent = /** @class */ (function () {
    function CustomersImportComponent(uploadService) {
        this.uploadService = uploadService;
        this.idToBlur = "customers-import";
        this.fileToUpload = null;
        this.logs = [];
    }
    CustomersImportComponent.prototype.unBlurMenu = function () {
        blurUtil["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
    };
    CustomersImportComponent.prototype.handleFileInput = function (files) {
        this.fileToUpload = files.item(0);
    };
    CustomersImportComponent.prototype.getSampleFile = function () {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            var csvData, blob, url, link;
            return tslib_es6["d" /* __generator */](this, function (_a) {
                this.isLoading = true;
                try {
                    csvData = "First name;Last name;Email\nJohn;Doe;john.doe@mail.com\nJames;Smith;james.smith@mail.com\nWilliam;Jones;william.jones@mail.com";
                    blob = new Blob([csvData], { type: 'text/csv' });
                    url = window.URL.createObjectURL(blob);
                    link = document.createElement('a');
                    link.href = url;
                    link.download = 'import_customers_sample.csv';
                    link.click();
                }
                finally {
                    this.isLoading = false;
                }
                return [2 /*return*/];
            });
        });
    };
    CustomersImportComponent.prototype.postFile = function () {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            var _this = this;
            var uploadData;
            return tslib_es6["d" /* __generator */](this, function (_a) {
                this.isLoading = true;
                this.logs = ["Importing customers..."];
                uploadData = new FormData();
                uploadData.append('file', this.fileToUpload, this.fileToUpload.name);
                this.uploadService.uploadCustomers(uploadData)
                    .then(function (res) {
                    _this.isLoading = false;
                    _this.logs.push("Customers were successfully imported and email sending is started");
                }, function (res) {
                    _this.isLoading = false;
                    _this.logs = ["Failed to upload the file selected."];
                    var response = res.json();
                    (_a = _this.logs).push.apply(_a, response.Errors.map(function (x) { return x.Value; }).reduce(function (a, b) { return a.concat(b); }, []));
                    var _a;
                });
                return [2 /*return*/];
            });
        });
    };
    CustomersImportComponent.ctorParameters = function () { return [{ type: uploadService_UploadService }]; };
    return CustomersImportComponent;
}());

//# sourceMappingURL=customersImport.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/customers-import/customersImport.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_CustomersImportComponent = [];
var RenderType_CustomersImportComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CustomersImportComponent, data: {} });
function View_CustomersImportComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.fileToUpload.name;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CustomersImportComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['No file selected']))], null, null);
}
function View_CustomersImportComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' ', ' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CustomersImportComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'spinner']], null, null, null, null, null))], null, null);
}
function View_CustomersImportComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 47, 'div', [['class',
                'main-content']], [[1, 'id', 0]], null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 44, 'div', [['class', 'container-fluid']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 5, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class',
                'btn btn-round btn-light-orange'], ['type', 'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.getSampleFile() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, ['Get a sample file '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'div', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'button', [['class', 'btn btn-round btn-light-orange'], ['type', 'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 19).click() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Choose file'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, [['fileInput', 1]], null, 0, 'input', [['accept',
                '.csv'], ['style', 'display:none'], ['type', 'file']], null, [[null,
                'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (_co.handleFileInput($event.target.files) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomersImportComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomersImportComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-dark-orange btn-round'], ['type', 'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.postFile() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, ['Upload File '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomersImportComponent_3)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomersImportComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = _co.fileToUpload;
        _ck(_v, 23, 0, currVal_3);
        var currVal_4 = !_co.fileToUpload;
        _ck(_v, 26, 0, currVal_4);
        var currVal_6 = _co.logs;
        _ck(_v, 41, 0, currVal_6);
        var currVal_7 = _co.isLoading;
        _ck(_v, 45, 0, currVal_7);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.idToBlur;
        _ck(_v, 0, 0, currVal_0);
        var currVal_1 = _co.isLoading;
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = _co.isLoading;
        _ck(_v, 13, 0, currVal_2);
        var currVal_5 = _co.isLoading;
        _ck(_v, 31, 0, currVal_5);
    });
}
function View_CustomersImportComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'customer', [], null, [['window', 'popstate']], function (_v, en, $event) {
            var ad = true;
            if (('window:popstate' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).unBlurMenu($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CustomersImportComponent_0, RenderType_CustomersImportComponent)), core_es5["ɵdid"](49152, null, 0, customersImport_component_CustomersImportComponent, [uploadService_UploadService], null, null)], null, null);
}
var CustomersImportComponentNgFactory = core_es5["ɵccf"]('customer', customersImport_component_CustomersImportComponent, View_CustomersImportComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=customersImport.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/objects/management/locationManagement/locationType.ts
var locationType = __webpack_require__("vlGe");

// CONCATENATED MODULE: ./app/components/Managment/locationManagement/locationIitem/locationItem.component.ts

var locationItem_component_LocationItemComponent = /** @class */ (function () {
    function LocationItemComponent() {
        this.string = String;
    }
    LocationItemComponent.prototype.convertName = function (name) {
        return String.getEnumValue(name, locationType["a" /* LocationType */]);
    };
    return LocationItemComponent;
}());

//# sourceMappingURL=locationItem.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/locationManagement/locationIitem/locationItem.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_LocationItemComponent = [];
var RenderType_LocationItemComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_LocationItemComponent, data: {} });
function View_LocationItemComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [['class',
                'card-text']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.location.Street;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_LocationItemComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'li', [['class',
                'card-text']], null, null, null, null, null))], null, null);
}
function View_LocationItemComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 44, 'div', [['class',
                'col-sp-5 location-card']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 41, 'div', [['class', 'card card-stats']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 5, 'button', [['class', 'btn btn-round btn-white btn-fill btn-just-icon pull-right edit-button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.locationModal.show(true, _co.location) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons visible-on-sidebar-regular icon-orange']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['more_vert'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 31, 'div', [['class', 'card-footer']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 28, 'ul', [['style',
                'list-style-type:none;padding-left:0']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 2, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'card-title orange-text']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Address:'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationItemComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationItemComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'card-title orange-text']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Type: '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'card-title orange-text']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Zip code: '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.location.Street;
        _ck(_v, 20, 0, currVal_0);
        var currVal_2 = !_co.location.Street;
        _ck(_v, 26, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = (((_co.location.City ? (_co.location.City + ', ') : '') + (_co.location.State ? (_co.location.State + ',') : '')) + _co.location.Country);
        _ck(_v, 23, 0, currVal_1);
        var currVal_3 = _co.convertName(_co.location.Type.toString());
        _ck(_v, 33, 0, currVal_3);
        var currVal_4 = _co.location.Zip;
        _ck(_v, 40, 0, currVal_4);
    });
}
function View_LocationItemComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'location-item', [], null, null, null, View_LocationItemComponent_0, RenderType_LocationItemComponent)), core_es5["ɵdid"](49152, null, 0, locationItem_component_LocationItemComponent, [], null, null)], null, null);
}
var LocationItemComponentNgFactory = core_es5["ɵccf"]('location-item', locationItem_component_LocationItemComponent, View_LocationItemComponent_Host_0, { location: 'location',
    locationModal: 'locationModal' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=locationItem.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/services/locationService.ts
var services_locationService = __webpack_require__("tI4G");

// EXTERNAL MODULE: ./app/objects/management/locationManagement/location.ts
var locationManagement_location = __webpack_require__("ZxOp");

// CONCATENATED MODULE: ./app/objects/requests/locationSearchRequest.ts
/**
 * Created by alex.y on 8/3/2017.
 */
var LocationSearchRequest = /** @class */ (function () {
    function LocationSearchRequest(obj) {
        this.Top = 10;
        this.Skip = 0;
        this.Country = "";
        this.City = "";
        this.Street = "";
        Object.assign(this, obj);
    }
    return LocationSearchRequest;
}());

//# sourceMappingURL=locationSearchRequest.js.map
// CONCATENATED MODULE: ./app/components/Managment/locationManagement/locationManagement.component.ts






/**
 * Created by alex.y on 7/31/2017.
 */
var locationManagement_component_LocationManagementComponent = /** @class */ (function () {
    function LocationManagementComponent(route, locationService) {
        this.route = route;
        this.locationService = locationService;
        this.searchResponse = new SearchResponse();
        this.searchQuery = new locationManagement_location["a" /* Location */]();
        this.currentOffset = 0;
        this.idToBlur = "location-management";
        this.config = {
            id: 'custom',
            itemsPerPage: 12,
            currentPage: 1,
            totalItems: 1
        };
    }
    LocationManagementComponent.prototype.unBlurMenu = function () {
        blurUtil["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
    };
    LocationManagementComponent.prototype.ngOnInit = function () {
        this.searchResponse = this.route.snapshot.data.locations;
        this.config.totalItems = this.route.snapshot.data.locations.TotalCount;
    };
    LocationManagementComponent.prototype.searchLocations = function (searchQuery) {
        if (searchQuery == null)
            return;
        this.searchQuery = searchQuery;
        this.currentOffset = 0;
        this.search();
    };
    LocationManagementComponent.prototype.setPage = function (offset) {
        this.currentOffset = offset;
        this.search();
    };
    LocationManagementComponent.prototype.search = function () {
        var _this = this;
        this.locationService.search(new LocationSearchRequest({
            Skip: (this.config.currentPage - 1) * this.config.itemsPerPage,
            Top: this.config.itemsPerPage,
            Country: this.searchQuery.Country,
            City: this.searchQuery.City,
            Street: this.searchQuery.Street
        })).then(function (response) {
            if (!response || !response.Data)
                return;
            document.getElementById('mainPanel').scrollTop = 0;
            _this.config.totalItems = response.Data.TotalCount;
            _this.searchResponse = response.Data;
        });
    };
    LocationManagementComponent.prototype.showCreateModal = function () {
        this.createModal.show();
    };
    LocationManagementComponent.prototype.locationCreatedHandler = function (location) {
        var existingLocation = this.searchResponse.Items.find(function (x) { return x.Id == location.Id; });
        if (existingLocation != null) {
            Object.assign(existingLocation, location);
        }
        else {
            this.searchResponse.Items.unshift(location);
            if (this.searchResponse.Items.length > this.config.itemsPerPage)
                this.searchResponse.Items.pop();
            this.config.totalItems += 1;
        }
    };
    LocationManagementComponent.ctorParameters = function () { return [{ type: router_es5["a" /* ActivatedRoute */] }, { type: services_locationService["a" /* LocationService */] }]; };
    return LocationManagementComponent;
}());

//# sourceMappingURL=locationManagement.component.js.map
// CONCATENATED MODULE: ./app/components/Managment/locationManagement/locationManagementSearch/locationManagementSearch.component.ts
/**
 * Created by alex.y on 7/31/2017.
 */


var locationManagementSearch_component_LocationManagementSearchComponent = /** @class */ (function () {
    function LocationManagementSearchComponent(ChangeDetectorRef) {
        this.ChangeDetectorRef = ChangeDetectorRef;
        this.searchEvent = new core_es5["EventEmitter"]();
        this.searchQuery = new locationManagement_location["a" /* Location */]();
    }
    LocationManagementSearchComponent.prototype.submit = function () {
        if (!this.searchQueryString)
            this.searchQuery = new locationManagement_location["a" /* Location */]();
        this.searchEvent.emit(this.searchQuery);
    };
    LocationManagementSearchComponent.prototype.onLocationChange = function (location) {
        this.searchQuery = location;
        this.ChangeDetectorRef.detectChanges();
    };
    LocationManagementSearchComponent.ctorParameters = function () { return [{ type: core_es5["ChangeDetectorRef"] }]; };
    return LocationManagementSearchComponent;
}());

//# sourceMappingURL=locationManagementSearch.component.js.map
// CONCATENATED MODULE: ./app/components/common/locationFromInput/locationFormInput.component.ts

/**
 * Created by alex.y on 8/2/2017.
 */




var locationFormInput_component_LocationFormInputComponent = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](LocationFormInputComponent, _super);
    function LocationFormInputComponent(validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this.validators = validators;
        _this.asyncValidators = asyncValidators;
        _this.options = {};
        _this.placeholder = '';
        _this.inputEmitter = new core_es5["EventEmitter"]();
        _this.clonedLocation = new locationManagement_location["a" /* Location */]();
        _this.hasAddressSelected = false;
        _this.stringHelper = String;
        return _this;
    }
    LocationFormInputComponent.prototype.ngOnInit = function () {
        this.disabled = this.disabled || false;
    };
    LocationFormInputComponent.prototype.ngAfterViewInit = function () {
        Object.assign(this.clonedLocation, this.inputLocation);
        this.model.control.setValidators(this.validators);
        this.model.control.setAsyncValidators(this.asyncValidators);
    };
    LocationFormInputComponent.prototype.parseAddress = function (type, address) {
        return address.find(function (x) { return x["types"].find(function (y) { return y == type; }) != null; });
    };
    LocationFormInputComponent.prototype.getAddress = function (place) {
        if (!place)
            return null;
        this.hasAddressSelected = true;
        var address = place["address_components"];
        if (!address)
            return null;
        var country = this.parseAddress("country", address);
        var state = this.parseAddress("administrative_area_level_1", address);
        var city = this.parseAddress("locality", address);
        if (!city)
            city = this.parseAddress("postal_town", address);
        var street = this.parseAddress("route", address);
        var building = this.parseAddress("street_number", address);
        var zip = this.parseAddress("postal_code", address);
        var admin = this.parseAddress("administrative_area_level_1", address);
        var name = '';
        var placeName = place["name"];
        var formattedAddr = place["formatted_address"];
        if (formattedAddr.indexOf(placeName) == -1)
            name = placeName;
        var resultStreet = "";
        if (!String.isNullOrEmpty(building))
            resultStreet += building["long_name"] + " ";
        resultStreet += street ? street["long_name"] : "";
        if (admin && zip)
            zip = admin["short_name"] + " " + zip["long_name"];
        else if (zip)
            zip = zip["long_name"];
        this.inputLocation = (new locationManagement_location["a" /* Location */]({
            City: city ? city["long_name"] : "",
            Country: country ? country["long_name"] : "",
            Street: "" + (name ? name : '') + (name && resultStreet ? ',' : '') + resultStreet,
            Zip: zip ? zip : "",
            State: state ? state["long_name"] : "",
            Id: this.clonedLocation.Id,
            Created: this.clonedLocation.Created,
            Updated: this.clonedLocation.Updated,
            Type: this.clonedLocation.Type
        }));
        this.value = "" + (name ? name + ', ' : '') + place["formatted_address"];
        this.inputEmitter.emit(this.inputLocation);
    };
    LocationFormInputComponent.prototype.handleInput = function () {
        this.inputLocation = null;
        this.inputEmitter.emit(null);
    };
    LocationFormInputComponent.ctorParameters = function () { return [{ type: Array, decorators: [{ type: core_es5["Optional"] }, { type: core_es5["Inject"], args: [forms_es5["NG_VALIDATORS"]] }] }, { type: Array, decorators: [{ type: core_es5["Optional"] }, { type: core_es5["Inject"], args: [forms_es5["NG_ASYNC_VALIDATORS"]] }] }]; };
    return LocationFormInputComponent;
}(ValueAccessorBase));

//# sourceMappingURL=locationFormInput.component.js.map
// CONCATENATED MODULE: ./node_modules/ng2-google-place-autocomplete/src/app/ng2-google-place.service.ts
var GooglePlaceService = /** @class */ (function () {
    function GooglePlaceService() {
    }
    GooglePlaceService.prototype.find = function (address_components, query, val) {
        if (val === void 0) { val = null; }
        for (var _i = 0, address_components_1 = address_components; _i < address_components_1.length; _i++) {
            var attr = address_components_1[_i];
            for (var _a = 0, _b = attr.types; _a < _b.length; _a++) {
                var type = _b[_a];
                if (type == query) {
                    return val ? attr[val] : attr;
                }
            }
        }
        return null;
    };
    GooglePlaceService.prototype.street_number = function (address_components) {
        return this.find(address_components, 'street_number', 'long_name');
    };
    GooglePlaceService.prototype.street = function (address_components) {
        return this.find(address_components, 'route', 'long_name');
    };
    GooglePlaceService.prototype.city = function (address_components) {
        return this.find(address_components, 'locality', 'long_name');
    };
    GooglePlaceService.prototype.state = function (address_components) {
        return this.find(address_components, 'administrative_area_level_1', 'long_name');
    };
    GooglePlaceService.prototype.postal_code = function (address_components) {
        return this.find(address_components, 'postal_code', 'long_name');
    };
    GooglePlaceService.prototype.country = function (address_components) {
        return this.find(address_components, 'country', 'long_name');
    };
    GooglePlaceService.prototype.administrative_area_level_2 = function (address_components) {
        return this.find(address_components, 'administrative_area_level_2', "long_name");
    };
    // MORE NOT USED YET /////
    GooglePlaceService.prototype.intersection = function (address_components) {
        return this.find(address_components, 'intersection');
    };
    GooglePlaceService.prototype.political = function (address_components) {
        return this.find(address_components, 'political');
    };
    GooglePlaceService.prototype.administrative_area_level_3 = function (address_components) {
        return this.find(address_components, 'administrative_area_level_3');
    };
    GooglePlaceService.prototype.administrative_area_level_4 = function (address_components) {
        return this.find(address_components, 'administrative_area_level_4');
    };
    GooglePlaceService.prototype.administrative_area_level_5 = function (address_components) {
        return this.find(address_components, 'administrative_area_level_5');
    };
    GooglePlaceService.prototype.colloquial_area = function (address_components) {
        return this.find(address_components, 'colloquial_area');
    };
    GooglePlaceService.prototype.ward = function (address_components) {
        return this.find(address_components, 'ward');
    };
    GooglePlaceService.prototype.sublocality = function (address_components) {
        return this.find(address_components, 'sublocality');
    };
    GooglePlaceService.prototype.sublocality_level_1 = function (address_components) {
        return this.find(address_components, 'sublocality_level_1');
    };
    GooglePlaceService.prototype.sublocality_level_2 = function (address_components) {
        return this.find(address_components, 'sublocality_level_2');
    };
    GooglePlaceService.prototype.sublocality_level_3 = function (address_components) {
        return this.find(address_components, 'sublocality_level_3');
    };
    GooglePlaceService.prototype.sublocality_level_4 = function (address_components) {
        return this.find(address_components, 'sublocality_level_4');
    };
    GooglePlaceService.prototype.sublocality_level_5 = function (address_components) {
        return this.find(address_components, 'sublocality_level_5');
    };
    GooglePlaceService.prototype.neighborhood = function (address_components) {
        return this.find(address_components, 'neighborhood');
    };
    GooglePlaceService.prototype.premise = function (address_components) {
        return this.find(address_components, 'premise');
    };
    GooglePlaceService.prototype.subpremise = function (address_components) {
        return this.find(address_components, 'subpremise');
    };
    GooglePlaceService.prototype.natural_feature = function (address_components) {
        return this.find(address_components, 'natural_feature');
    };
    GooglePlaceService.prototype.airport = function (address_components) {
        return this.find(address_components, 'airport');
    };
    GooglePlaceService.prototype.park = function (address_components) {
        return this.find(address_components, 'park');
    };
    GooglePlaceService.prototype.point_of_interest = function (address_components) {
        return this.find(address_components, 'point_of_interest');
    };
    GooglePlaceService.prototype.floor = function (address_components) {
        return this.find(address_components, 'floor');
    };
    GooglePlaceService.prototype.establishment = function (address_components) {
        return this.find(address_components, 'establishment');
    };
    GooglePlaceService.prototype.parking = function (address_components) {
        return this.find(address_components, 'parking');
    };
    GooglePlaceService.prototype.post_box = function (address_components) {
        return this.find(address_components, 'post_box');
    };
    GooglePlaceService.prototype.postal_town = function (address_components) {
        return this.find(address_components, 'postal_town');
    };
    GooglePlaceService.prototype.room = function (address_components) {
        return this.find(address_components, 'room');
    };
    GooglePlaceService.prototype.bus_station = function (address_components) {
        return this.find(address_components, 'bus_station');
    };
    GooglePlaceService.prototype.train_station = function (address_components) {
        return this.find(address_components, 'train_station');
    };
    GooglePlaceService.prototype.transit_station = function (address_components) {
        return this.find(address_components, 'transit_station');
    };
    /// return list ISO 3166-1 Alpha-2 country code
    GooglePlaceService.prototype.countryIsoCode = function () {
        return [
            {
                Name: "Afghanistan",
                Code: "AF"
            },
            {
                Name: "Åland Islands",
                Code: "AX"
            },
            {
                Name: "Albania",
                Code: "AL"
            },
            {
                Name: "Algeria",
                Code: "DZ"
            },
            {
                Name: "American Samoa",
                Code: "AS"
            },
            {
                Name: "Andorra",
                Code: "AD"
            },
            {
                Name: "Angola",
                Code: "AO"
            },
            {
                Name: "Anguilla",
                Code: "AI"
            },
            {
                Name: "Antarctica",
                Code: "AQ"
            },
            {
                Name: "Antigua and Barbuda",
                Code: "AG"
            },
            {
                Name: "Argentina",
                Code: "AR"
            },
            {
                Name: "Armenia",
                Code: "AM"
            },
            {
                Name: "Aruba",
                Code: "AW"
            },
            {
                Name: "Australia",
                Code: "AU"
            },
            {
                Name: "Austria",
                Code: "AT"
            },
            {
                Name: "Azerbaijan",
                Code: "AZ"
            },
            {
                Name: "Bahamas",
                Code: "BS"
            },
            {
                Name: "Bahrain",
                Code: "BH"
            },
            {
                Name: "Bangladesh",
                Code: "BD"
            },
            {
                Name: "Barbados",
                Code: "BB"
            },
            {
                Name: "Belarus",
                Code: "BY"
            },
            {
                Name: "Belgium",
                Code: "BE"
            },
            {
                Name: "Belize",
                Code: "BZ"
            },
            {
                Name: "Benin",
                Code: "BJ"
            },
            {
                Name: "Bermuda",
                Code: "BM"
            },
            {
                Name: "Bhutan",
                Code: "BT"
            },
            {
                Name: "Bolivia, Plurinational State of",
                Code: "BO"
            },
            {
                Name: "Bonaire, Sint Eustatius and Saba",
                Code: "BQ"
            },
            {
                Name: "Bosnia and Herzegovina",
                Code: "BA"
            },
            {
                Name: "Botswana",
                Code: "BW"
            },
            {
                Name: "Bouvet Island",
                Code: "BV"
            },
            {
                Name: "Brazil",
                Code: "BR"
            },
            {
                Name: "British Indian Ocean Territory",
                Code: "IO"
            },
            {
                Name: "Brunei Darussalam",
                Code: "BN"
            },
            {
                Name: "Bulgaria",
                Code: "BG"
            },
            {
                Name: "Burkina Faso",
                Code: "BF"
            },
            {
                Name: "Burundi",
                Code: "BI"
            },
            {
                Name: "Cambodia",
                Code: "KH"
            },
            {
                Name: "Cameroon",
                Code: "CM"
            },
            {
                Name: "Canada",
                Code: "CA"
            },
            {
                Name: "Cape Verde",
                Code: "CV"
            },
            {
                Name: "Cayman Islands",
                Code: "KY"
            },
            {
                Name: "Central African Republic",
                Code: "CF"
            },
            {
                Name: "Chad",
                Code: "TD"
            },
            {
                Name: "Chile",
                Code: "CL"
            },
            {
                Name: "China",
                Code: "CN"
            },
            {
                Name: "Christmas Island",
                Code: "CX"
            },
            {
                Name: "Cocos (Keeling) Islands",
                Code: "CC"
            },
            {
                Name: "Colombia",
                Code: "CO"
            },
            {
                Name: "Comoros",
                Code: "KM"
            },
            {
                Name: "Congo",
                Code: "CG"
            },
            {
                Name: "Congo, the Democratic Republic of the",
                Code: "CD"
            },
            {
                Name: "Cook Islands",
                Code: "CK"
            },
            {
                Name: "Costa Rica",
                Code: "CR"
            },
            {
                Name: "Côte d'Ivoire",
                Code: "CI"
            },
            {
                Name: "Croatia",
                Code: "HR"
            },
            {
                Name: "Cuba",
                Code: "CU"
            },
            {
                Name: "Curaçao",
                Code: "CW"
            },
            {
                Name: "Cyprus",
                Code: "CY"
            },
            {
                Name: "Czech Republic",
                Code: "CZ"
            },
            {
                Name: "Denmark",
                Code: "DK"
            },
            {
                Name: "Djibouti",
                Code: "DJ"
            },
            {
                Name: "Dominica",
                Code: "DM"
            },
            {
                Name: "Dominican Republic",
                Code: "DO"
            },
            {
                Name: "Ecuador",
                Code: "EC"
            },
            {
                Name: "Egypt",
                Code: "EG"
            },
            {
                Name: "El Salvador",
                Code: "SV"
            },
            {
                Name: "Equatorial Guinea",
                Code: "GQ"
            },
            {
                Name: "Eritrea",
                Code: "ER"
            },
            {
                Name: "Estonia",
                Code: "EE"
            },
            {
                Name: "Ethiopia",
                Code: "ET"
            },
            {
                Name: "Falkland Islands (Malvinas)",
                Code: "FK"
            },
            {
                Name: "Faroe Islands",
                Code: "FO"
            },
            {
                Name: "Fiji",
                Code: "FJ"
            },
            {
                Name: "Finland",
                Code: "FI"
            },
            {
                Name: "France",
                Code: "FR"
            },
            {
                Name: "French Guiana",
                Code: "GF"
            },
            {
                Name: "French Polynesia",
                Code: "PF"
            },
            {
                Name: "French Southern Territories",
                Code: "TF"
            },
            {
                Name: "Gabon",
                Code: "GA"
            },
            {
                Name: "Gambia",
                Code: "GM"
            },
            {
                Name: "Georgia",
                Code: "GE"
            },
            {
                Name: "Germany",
                Code: "DE"
            },
            {
                Name: "Ghana",
                Code: "GH"
            },
            {
                Name: "Gibraltar",
                Code: "GI"
            },
            {
                Name: "Greece",
                Code: "GR"
            },
            {
                Name: "Greenland",
                Code: "GL"
            },
            {
                Name: "Grenada",
                Code: "GD"
            },
            {
                Name: "Guadeloupe",
                Code: "GP"
            },
            {
                Name: "Guam",
                Code: "GU"
            },
            {
                Name: "Guatemala",
                Code: "GT"
            },
            {
                Name: "Guernsey",
                Code: "GG"
            },
            {
                Name: "Guinea",
                Code: "GN"
            },
            {
                Name: "Guinea-Bissau",
                Code: "GW"
            },
            {
                Name: "Guyana",
                Code: "GY"
            },
            {
                Name: "Haiti",
                Code: "HT"
            },
            {
                Name: "Heard Island and McDonald Islands",
                Code: "HM"
            },
            {
                Name: "Holy See (Vatican City State)",
                Code: "VA"
            },
            {
                Name: "Honduras",
                Code: "HN"
            },
            {
                Name: "Hong Kong",
                Code: "HK"
            },
            {
                Name: "Hungary",
                Code: "HU"
            },
            {
                Name: "Iceland",
                Code: "IS"
            },
            {
                Name: "India",
                Code: "IN"
            },
            {
                Name: "Indonesia",
                Code: "ID"
            },
            {
                Name: "Iran, Islamic Republic of",
                Code: "IR"
            },
            {
                Name: "Iraq",
                Code: "IQ"
            },
            {
                Name: "Ireland",
                Code: "IE"
            },
            {
                Name: "Isle of Man",
                Code: "IM"
            },
            {
                Name: "Israel",
                Code: "IL"
            },
            {
                Name: "Italy",
                Code: "IT"
            },
            {
                Name: "Jamaica",
                Code: "JM"
            },
            {
                Name: "Japan",
                Code: "JP"
            },
            {
                Name: "Jersey",
                Code: "JE"
            },
            {
                Name: "Jordan",
                Code: "JO"
            },
            {
                Name: "Kazakhstan",
                Code: "KZ"
            },
            {
                Name: "Kenya",
                Code: "KE"
            },
            {
                Name: "Kiribati",
                Code: "KI"
            },
            {
                Name: "Korea, Democratic People's Republic of",
                Code: "KP"
            },
            {
                Name: "Korea, Republic of",
                Code: "KR"
            },
            {
                Name: "Kuwait",
                Code: "KW"
            },
            {
                Name: "Kyrgyzstan",
                Code: "KG"
            },
            {
                Name: "Lao People's Democratic Republic",
                Code: "LA"
            },
            {
                Name: "Latvia",
                Code: "LV"
            },
            {
                Name: "Lebanon",
                Code: "LB"
            },
            {
                Name: "Lesotho",
                Code: "LS"
            },
            {
                Name: "Liberia",
                Code: "LR"
            },
            {
                Name: "Libya",
                Code: "LY"
            },
            {
                Name: "Liechtenstein",
                Code: "LI"
            },
            {
                Name: "Lithuania",
                Code: "LT"
            },
            {
                Name: "Luxembourg",
                Code: "LU"
            },
            {
                Name: "Macao",
                Code: "MO"
            },
            {
                Name: "Macedonia, the Former Yugoslav Republic of",
                Code: "MK"
            },
            {
                Name: "Madagascar",
                Code: "MG"
            },
            {
                Name: "Malawi",
                Code: "MW"
            },
            {
                Name: "Malaysia",
                Code: "MY"
            },
            {
                Name: "Maldives",
                Code: "MV"
            },
            {
                Name: "Mali",
                Code: "ML"
            },
            {
                Name: "Malta",
                Code: "MT"
            },
            {
                Name: "Marshall Islands",
                Code: "MH"
            },
            {
                Name: "Martinique",
                Code: "MQ"
            },
            {
                Name: "Mauritania",
                Code: "MR"
            },
            {
                Name: "Mauritius",
                Code: "MU"
            },
            {
                Name: "Mayotte",
                Code: "YT"
            },
            {
                Name: "Mexico",
                Code: "MX"
            },
            {
                Name: "Micronesia, Federated States of",
                Code: "FM"
            },
            {
                Name: "Moldova, Republic of",
                Code: "MD"
            },
            {
                Name: "Monaco",
                Code: "MC"
            },
            {
                Name: "Mongolia",
                Code: "MN"
            },
            {
                Name: "Montenegro",
                Code: "ME"
            },
            {
                Name: "Montserrat",
                Code: "MS"
            },
            {
                Name: "Morocco",
                Code: "MA"
            },
            {
                Name: "Mozambique",
                Code: "MZ"
            },
            {
                Name: "Myanmar",
                Code: "MM"
            },
            {
                Name: "Namibia",
                Code: "NA"
            },
            {
                Name: "Nauru",
                Code: "NR"
            },
            {
                Name: "Nepal",
                Code: "NP"
            },
            {
                Name: "Netherlands",
                Code: "NL"
            },
            {
                Name: "New Caledonia",
                Code: "NC"
            },
            {
                Name: "New Zealand",
                Code: "NZ"
            },
            {
                Name: "Nicaragua",
                Code: "NI"
            },
            {
                Name: "Niger",
                Code: "NE"
            },
            {
                Name: "Nigeria",
                Code: "NG"
            },
            {
                Name: "Niue",
                Code: "NU"
            },
            {
                Name: "Norfolk Island",
                Code: "NF"
            },
            {
                Name: "Northern Mariana Islands",
                Code: "MP"
            },
            {
                Name: "Norway",
                Code: "NO"
            },
            {
                Name: "Oman",
                Code: "OM"
            },
            {
                Name: "Pakistan",
                Code: "PK"
            },
            {
                Name: "Palau",
                Code: "PW"
            },
            {
                Name: "Palestine, State of",
                Code: "PS"
            },
            {
                Name: "Panama",
                Code: "PA"
            },
            {
                Name: "Papua New Guinea",
                Code: "PG"
            },
            {
                Name: "Paraguay",
                Code: "PY"
            },
            {
                Name: "Peru",
                Code: "PE"
            },
            {
                Name: "Philippines",
                Code: "PH"
            },
            {
                Name: "Pitcairn",
                Code: "PN"
            },
            {
                Name: "Poland",
                Code: "PL"
            },
            {
                Name: "Portugal",
                Code: "PT"
            },
            {
                Name: "Puerto Rico",
                Code: "PR"
            },
            {
                Name: "Qatar",
                Code: "QA"
            },
            {
                Name: "Réunion",
                Code: "RE"
            },
            {
                Name: "Romania",
                Code: "RO"
            },
            {
                Name: "Russian Federation",
                Code: "RU"
            },
            {
                Name: "Rwanda",
                Code: "RW"
            },
            {
                Name: "Saint Barthélemy",
                Code: "BL"
            },
            {
                Name: "Saint Helena, Ascension and Tristan da Cunha",
                Code: "SH"
            },
            {
                Name: "Saint Kitts and Nevis",
                Code: "KN"
            },
            {
                Name: "Saint Lucia",
                Code: "LC"
            },
            {
                Name: "Saint Martin (French part)",
                Code: "MF"
            },
            {
                Name: "Saint Pierre and Miquelon",
                Code: "PM"
            },
            {
                Name: "Saint Vincent and the Grenadines",
                Code: "VC"
            },
            {
                Name: "Samoa",
                Code: "WS"
            },
            {
                Name: "San Marino",
                Code: "SM"
            },
            {
                Name: "Sao Tome and Principe",
                Code: "ST"
            },
            {
                Name: "Saudi Arabia",
                Code: "SA"
            },
            {
                Name: "Senegal",
                Code: "SN"
            },
            {
                Name: "Serbia",
                Code: "RS"
            },
            {
                Name: "Seychelles",
                Code: "SC"
            },
            {
                Name: "Sierra Leone",
                Code: "SL"
            },
            {
                Name: "Singapore",
                Code: "SG"
            },
            {
                Name: "Sint Maarten (Dutch part)",
                Code: "SX"
            },
            {
                Name: "Slovakia",
                Code: "SK"
            },
            {
                Name: "Slovenia",
                Code: "SI"
            },
            {
                Name: "Solomon Islands",
                Code: "SB"
            },
            {
                Name: "Somalia",
                Code: "SO"
            },
            {
                Name: "South Africa",
                Code: "ZA"
            },
            {
                Name: "South Georgia and the South Sandwich Islands",
                Code: "GS"
            },
            {
                Name: "South Sudan",
                Code: "SS"
            },
            {
                Name: "Spain",
                Code: "ES"
            },
            {
                Name: "Sri Lanka",
                Code: "LK"
            },
            {
                Name: "Sudan",
                Code: "SD"
            },
            {
                Name: "Suriname",
                Code: "SR"
            },
            {
                Name: "Svalbard and Jan Mayen",
                Code: "SJ"
            },
            {
                Name: "Swaziland",
                Code: "SZ"
            },
            {
                Name: "Sweden",
                Code: "SE"
            },
            {
                Name: "Switzerland",
                Code: "CH"
            },
            {
                Name: "Syrian Arab Republic",
                Code: "SY"
            },
            {
                Name: "Taiwan, Province of China",
                Code: "TW"
            },
            {
                Name: "Tajikistan",
                Code: "TJ"
            },
            {
                Name: "Tanzania, United Republic of",
                Code: "TZ"
            },
            {
                Name: "Thailand",
                Code: "TH"
            },
            {
                Name: "Timor-Leste",
                Code: "TL"
            },
            {
                Name: "Togo",
                Code: "TG"
            },
            {
                Name: "Tokelau",
                Code: "TK"
            },
            {
                Name: "Tonga",
                Code: "TO"
            },
            {
                Name: "Trinidad and Tobago",
                Code: "TT"
            },
            {
                Name: "Tunisia",
                Code: "TN"
            },
            {
                Name: "Turkey",
                Code: "TR"
            },
            {
                Name: "Turkmenistan",
                Code: "TM"
            },
            {
                Name: "Turks and Caicos Islands",
                Code: "TC"
            },
            {
                Name: "Tuvalu",
                Code: "TV"
            },
            {
                Name: "Uganda",
                Code: "UG"
            },
            {
                Name: "Ukraine",
                Code: "UA"
            },
            {
                Name: "United Arab Emirates",
                Code: "AE"
            },
            {
                Name: "United Kingdom",
                Code: "GB"
            },
            {
                Name: "United States",
                Code: "US"
            },
            {
                Name: "United States Minor Outlying Islands",
                Code: "UM"
            },
            {
                Name: "Uruguay",
                Code: "UY"
            },
            {
                Name: "Uzbekistan",
                Code: "UZ"
            },
            {
                Name: "Vanuatu",
                Code: "VU"
            },
            {
                Name: "Venezuela, Bolivarian Republic of",
                Code: "VE"
            },
            {
                Name: "Viet Nam",
                Code: "VN"
            },
            {
                Name: "Virgin Islands, British",
                Code: "VG"
            },
            {
                Name: "Virgin Islands, U.S.",
                Code: "VI"
            },
            {
                Name: "Wallis and Futuna",
                Code: "WF"
            },
            {
                Name: "Western Sahara",
                Code: "EH"
            },
            {
                Name: "Yemen",
                Code: "YE"
            },
            {
                Name: "Zambia",
                Code: "ZM"
            },
            {
                Name: "Zimbabwe",
                Code: "ZW"
            }
        ];
    };
    // Types options 
    GooglePlaceService.prototype.TypesOptions = function () {
        return [
            '(cities)',
            '(regions)',
            'country',
            'postal_code',
            'sublocality',
            'establishment',
            'address',
            'geocode'
        ];
    };
    GooglePlaceService.ctorParameters = function () { return []; };
    return GooglePlaceService;
}());

//# sourceMappingURL=ng2-google-place.service.js.map
// CONCATENATED MODULE: ./node_modules/ng2-google-place-autocomplete/src/app/ng2-google-place.directive.ts


var ng2_google_place_directive_GooglePlaceDirective = /** @class */ (function () {
    function GooglePlaceDirective(el, service) {
        this.el = el;
        this.service = service;
        this.CountryCodes = new core_es5["EventEmitter"]();
        this.setAddress = new core_es5["EventEmitter"]();
        this.street_number = new core_es5["EventEmitter"]();
        this.postal_code = new core_es5["EventEmitter"]();
        this.country = new core_es5["EventEmitter"]();
        this.lat = new core_es5["EventEmitter"]();
        this.lng = new core_es5["EventEmitter"]();
        this.adr_address = new core_es5["EventEmitter"]();
        this.formatted_address = new core_es5["EventEmitter"]();
        this.name = new core_es5["EventEmitter"]();
        this.place_id = new core_es5["EventEmitter"]();
        this.types = new core_es5["EventEmitter"]();
        this.url = new core_es5["EventEmitter"]();
        this.utc_offset = new core_es5["EventEmitter"]();
        this.vicinity = new core_es5["EventEmitter"]();
        this.photos = new core_es5["EventEmitter"]();
        this.street = new core_es5["EventEmitter"]();
        this.city = new core_es5["EventEmitter"]();
        this.state = new core_es5["EventEmitter"]();
        this.district = new core_es5["EventEmitter"]();
    }
    GooglePlaceDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.CountryCodes.emit(this.service.countryIsoCode());
        this.autocomplete = new google.maps.places.Autocomplete(this.el.nativeElement, this.options);
        this.trigger = this.autocomplete.addListener('place_changed', function () {
            _this.place = _this.autocomplete.getPlace();
            if (_this.place && _this.place.place_id) {
                _this.invokeEvent();
            }
        });
    };
    GooglePlaceDirective.prototype.invokeEvent = function () {
        this.setAddress.emit(this.place);
        this.street_number.emit(this.service.street_number(this.place.address_components) ? this.service.street_number(this.place.address_components) : null);
        this.street.emit(this.service.street(this.place.address_components) ? this.service.street(this.place.address_components) : null);
        this.city.emit(this.service.city(this.place.address_components) ? this.service.city(this.place.address_components) : null);
        this.state.emit(this.service.state(this.place.address_components) ? this.service.state(this.place.address_components) : null);
        this.country.emit(this.service.country(this.place.address_components) ? this.service.country(this.place.address_components) : null);
        this.postal_code.emit(this.service.postal_code(this.place.address_components) ? this.service.postal_code(this.place.address_components) : null);
        this.district.emit(this.service.administrative_area_level_2(this.place.address_components) ? this.service.administrative_area_level_2(this.place.address_components) : null);
        this.lat.emit(this.place.geometry.location.lat() ? this.place.geometry.location.lat() : null);
        this.lng.emit(this.place.geometry.location.lng() ? this.place.geometry.location.lng() : null);
        this.adr_address.emit(this.place.adr_address ? this.place.adr_address : null);
        this.formatted_address.emit(this.place.formatted_address ? this.place.formatted_address : null);
        this.name.emit(this.place.name ? this.place.name : null);
        this.place_id.emit(this.place.place_id ? this.place.place_id : null);
        this.types.emit(this.place.types ? this.place.types : null);
        this.url.emit(this.place.url ? this.place.url : null);
        this.utc_offset.emit(this.place.utc_offset ? this.place.utc_offset : null);
        this.vicinity.emit(this.place.vicinity ? this.place.vicinity : null);
        this.photos.emit(this.place.photos ? this.place.photos : null);
        /*
       DEPRECATED SINCE 2014
       this.place.id
       reference
       */
        /*
        NOT USED YET
    
        this.intersection.emit(this.service.intersection(this.place.address_components) ? this.service.intersection(this.place.address_components) : null)
        this.political.emit(this.service.political(this.place.address_components) ? this.service.political(this.place.address_components) : null)
        this.colloquial_area.emit(this.service.colloquial_area(this.place.address_components) ? this.service.colloquial_area(this.place.address_components) : null)
        
        this.ward.emit(this.service.ward(this.place.address_components) ? this.service.ward(this.place.address_components) : null)
        
        this.administrative_area_level_3.emit(this.service.administrative_area_level_3(this.place.address_components) ? this.service.administrative_area_level_3(this.place.address_components) : null)
        this.administrative_area_level_4.emit(this.service.administrative_area_level_4(this.place.address_components) ? this.service.administrative_area_level_4(this.place.address_components) : null)
        this.administrative_area_level_5.emit(this.service.administrative_area_level_5(this.place.address_components) ? this.service.administrative_area_level_5(this.place.address_components) : null)
        
        this.sublocality.emit(this.service.sublocality(this.place.address_components) ? this.service.sublocality(this.place.address_components) : null)
        this.sublocality_level_1.emit(this.service.sublocality_level_1(this.place.address_components) ? this.service.sublocality_level_1(this.place.address_components) : null)
        this.sublocality_level_2.emit(this.service.sublocality_level_2(this.place.address_components) ? this.service.sublocality_level_2(this.place.address_components) : null)
        this.sublocality_level_3.emit(this.service.sublocality_level_3(this.place.address_components) ? this.service.sublocality_level_3(this.place.address_components) : null)
        this.sublocality_level_4.emit(this.service.sublocality_level_4(this.place.address_components) ? this.service.sublocality_level_4(this.place.address_components) : null)
        this.sublocality_level_5.emit(this.service.sublocality_level_5(this.place.address_components) ? this.service.sublocality_level_5(this.place.address_components) : null)
        
        this.neighborhood.emit(this.service.neighborhood(this.place.address_components) ? this.service.neighborhood(this.place.address_components) : null)
        this.premise.emit(this.service.premise(this.place.address_components) ? this.service.premise(this.place.address_components) : null)
        this.subpremise.emit(this.service.subpremise(this.place.address_components) ? this.service.subpremise(this.place.address_components) : null)
        this.natural_feature.emit(this.service.natural_feature(this.place.address_components) ? this.service.natural_feature(this.place.address_components) : null)
        this.airport.emit(this.service.airport(this.place.address_components) ? this.service.airport(this.place.address_components) : null)
        this.park.emit(this.service.park(this.place.address_components) ? this.service.park(this.place.address_components) : null)
        this.point_of_interest.emit(this.service.point_of_interest(this.place.address_components) ? this.service.point_of_interest(this.place.address_components) : null)
        this.floor.emit(this.service.floor(this.place.address_components) ? this.service.floor(this.place.address_components) : null)
        this.establishment.emit(this.service.establishment(this.place.address_components) ? this.service.establishment(this.place.address_components) : null)
        this.parking.emit(this.service.parking(this.place.address_components) ? this.service.parking(this.place.address_components) : null)
        this.post_box.emit(this.service.post_box(this.place.address_components) ? this.service.post_box(this.place.address_components) : null)
        this.postal_town.emit(this.service.postal_town(this.place.address_components) ? this.service.postal_town(this.place.address_components) : null)
        this.room.emit(this.service.room(this.place.address_components) ? this.service.room(this.place.address_components) : null)
        this.bus_station.emit(this.service.bus_station(this.place.address_components) ? this.service.bus_station(this.place.address_components) : null)
        this.train_station.emit(this.service.train_station(this.place.address_components) ? this.service.train_station(this.place.address_components) : null)
        this.transit_station.emit(this.service.transit_station(this.place.address_components) ? this.service.transit_station(this.place.address_components) : null)
        */
    };
    GooglePlaceDirective.ctorParameters = function () { return [{ type: core_es5["ElementRef"] }, { type: GooglePlaceService }]; };
    return GooglePlaceDirective;
}());

//# sourceMappingURL=ng2-google-place.directive.js.map
// CONCATENATED MODULE: ./compiled/app/components/common/locationFromInput/locationFormInput.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_LocationFormInputComponent = [];
var RenderType_LocationFormInputComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_LocationFormInputComponent, data: {} });
function View_LocationFormInputComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { model: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'form-group label-floating']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0,
            'is-empty': 1 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['',
            ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, [['location', 1]], null, 8, 'input', [['class', 'form-control'], ['id', 'location'], ['name',
                'location'], ['ng2-google-place-autocomplete', ''], ['onFocusClass', 'form-group'],
            ['type', 'text']], [[8, 'placeholder', 0], [2, 'ng-untouched', null], [2,
                'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'setAddress'], [null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend'], [null, 'focus']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 9)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 9).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 9)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 9)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 10).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 16).onFocus($event) !== false);
                ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
                var pd_6 = (core_es5["ɵnov"](_v, 16).onBlur($event) !== false);
                ad = (pd_6 && ad);
            }
            if (('setAddress' === en)) {
                var pd_7 = (_co.getAddress($event) !== false);
                ad = (pd_7 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_8 = ((_co.value = $event) !== false);
                ad = (pd_8 && ad);
            }
            if (('input' === en)) {
                var pd_9 = (_co.handleInput() !== false);
                ad = (pd_9 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"], core_es5["ElementRef"],
            [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, [[1, 4]], 0, forms_es5["NgModel"], [[8, null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        core_es5["ɵdid"](81920, null, 0, ng2_google_place_directive_GooglePlaceDirective, [core_es5["ElementRef"], GooglePlaceService], { options: [0, 'options'] }, { setAddress: 'setAddress' }), core_es5["ɵdid"](16384, null, 0, onFocus_OnFocusDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], { focusClass: [0, 'focusClass'],
            onFocusClass: [1, 'onFocusClass'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class',
                'material-input']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), core_es5["ɵncd"](null, 0), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'form-group label-floating';
        var currVal_1 = _ck(_v, 3, 0, (((!_co.disabled && (_co.form != null)) && (!_co.model.pristine || _co.form.submitted)) && !_co.model.valid), _co.stringHelper.isNullOrEmpty(_co.innerValue));
        _ck(_v, 2, 0, currVal_0, currVal_1);
        var currVal_11 = 'location';
        var currVal_12 = _co.disabled;
        var currVal_13 = _co.value;
        _ck(_v, 12, 0, currVal_11, currVal_12, currVal_13);
        var currVal_14 = _co.options;
        _ck(_v, 15, 0, currVal_14);
        var currVal_15 = 'is-focused';
        var currVal_16 = 'form-group';
        _ck(_v, 16, 0, currVal_15, currVal_16);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.label;
        _ck(_v, 6, 0, currVal_2);
        var currVal_3 = core_es5["ɵinlineInterpolate"](1, '', _co.placeholder, '');
        var currVal_4 = core_es5["ɵnov"](_v, 14).ngClassUntouched;
        var currVal_5 = core_es5["ɵnov"](_v, 14).ngClassTouched;
        var currVal_6 = core_es5["ɵnov"](_v, 14).ngClassPristine;
        var currVal_7 = core_es5["ɵnov"](_v, 14).ngClassDirty;
        var currVal_8 = core_es5["ɵnov"](_v, 14).ngClassValid;
        var currVal_9 = core_es5["ɵnov"](_v, 14).ngClassInvalid;
        var currVal_10 = core_es5["ɵnov"](_v, 14).ngClassPending;
        _ck(_v, 8, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10);
    });
}
function View_LocationFormInputComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'location-form-input', [], null, null, null, View_LocationFormInputComponent_0, RenderType_LocationFormInputComponent)), core_es5["ɵprd"](5120, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [locationFormInput_component_LocationFormInputComponent]), core_es5["ɵdid"](4308992, null, 0, locationFormInput_component_LocationFormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], null, null)], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
var LocationFormInputComponentNgFactory = core_es5["ɵccf"]('location-form-input', locationFormInput_component_LocationFormInputComponent, View_LocationFormInputComponent_Host_0, { name: 'name',
    label: 'label', disabled: 'disabled', form: 'form', options: 'options', inputLocation: 'inputLocation',
    placeholder: 'placeholder' }, { inputEmitter: 'inputEmitter' }, ['*']);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=locationFormInput.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/locationManagement/locationManagementSearch/locationManagementSearch.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_LocationManagementSearchComponent = [];
var RenderType_LocationManagementSearchComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_LocationManagementSearchComponent, data: {} });
function View_LocationManagementSearchComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, 'button', [['class',
                'btn btn-white btn-round btn-just-icon'], ['type', 'submit']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.submit() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['search'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'ripple-container']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'form-group form-search is-empty']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'location-form-input', [['label', ''], ['name', 'location'], ['placeholder',
                'Search']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'inputEmitter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.searchQueryString = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('inputEmitter' === en)) {
                var pd_1 = (_co.onLocationChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_LocationFormInputComponent_0, RenderType_LocationFormInputComponent)),
        core_es5["ɵdid"](4308992, null, 0, locationFormInput_component_LocationFormInputComponent, [[2, forms_es5["NG_VALIDATORS"]],
            [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], disabled: [2,
                'disabled'], inputLocation: [3, 'inputLocation'], placeholder: [4, 'placeholder'] }, { inputEmitter: 'inputEmitter' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [locationFormInput_component_LocationFormInputComponent]), core_es5["ɵdid"](671744, [['location', 4]], 0, forms_es5["NgModel"], [[8, null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'material-input']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'location';
        var currVal_8 = '';
        var currVal_9 = false;
        var currVal_10 = _co.searchQuery;
        var currVal_11 = 'Search';
        _ck(_v, 12, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11);
        var currVal_12 = 'location';
        var currVal_13 = false;
        var currVal_14 = _co.searchQueryString;
        _ck(_v, 14, 0, currVal_12, currVal_13, currVal_14);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 16).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 16).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 16).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 16).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 16).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 16).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 16).ngClassPending;
        _ck(_v, 11, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_LocationManagementSearchComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'location-management-search', [], null, null, null, View_LocationManagementSearchComponent_0, RenderType_LocationManagementSearchComponent)), core_es5["ɵdid"](49152, null, 0, locationManagementSearch_component_LocationManagementSearchComponent, [core_es5["ChangeDetectorRef"]], null, null)], null, null);
}
var LocationManagementSearchComponentNgFactory = core_es5["ɵccf"]('location-management-search', locationManagementSearch_component_LocationManagementSearchComponent, View_LocationManagementSearchComponent_Host_0, {}, { searchEvent: 'searchEvent' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=locationManagementSearch.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/common/directives/validators/managementLocationValidator.ts
var ManagementLocationValidatorDirective = /** @class */ (function () {
    function ManagementLocationValidatorDirective() {
    }
    ManagementLocationValidatorDirective.prototype.validate = function (control) {
        if (!this.location)
            return { validateLocationManagement: false };
        if (!this.location || (!this.location.Country))
            return { validateLocationManagement: false };
        if (this.originalLocation != null && !String.isNullOrEmpty(this.originalLocation.Country) && this.originalLocation.Country.toLowerCase() != this.location.Country.toLowerCase()) {
            return { validateChangeCountry: false };
        }
        if (this.locationType == 2) {
            if (this.location.Country.toLowerCase() == 'canada' && !this.location.State)
                return { validateLocationManagement: false };
            if ((!this.location.Country.match(/.*(Canada|USA|United States).*/i)))
                return { validateLocationManagement: false };
            return null;
        }
        if (this.locationType == 3 || this.locationType == 4) {
            if ((!this.location.Country || !this.location.City || !this.location.Street))
                return { validateLocationManagement: false };
        }
        return null;
    };
    ManagementLocationValidatorDirective.ctorParameters = function () { return []; };
    return ManagementLocationValidatorDirective;
}());

//# sourceMappingURL=managementLocationValidator.js.map
// EXTERNAL MODULE: ./app/components/Managment/locationManagement/locationModals/locationManagementCreateModal.component.ts
var locationManagementCreateModal_component = __webpack_require__("M9C8");

// CONCATENATED MODULE: ./compiled/app/components/Managment/locationManagement/locationModals/locationManagementCreateModal.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */















var styles_LMCreateModalComponent = [];
var RenderType_LMCreateModalComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_LMCreateModalComponent, data: {} });
function View_LMCreateModalComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Location is required. ']))], null, null);
}
function View_LMCreateModalComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Required Street, City and County ']))], null, null);
}
function View_LMCreateModalComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Country is required (and Province for Canada) ']))], null, null);
}
function View_LMCreateModalComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Country is required (and Province for Canada) ']))], null, null);
}
function View_LMCreateModalComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 10, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LMCreateModalComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LMCreateModalComponent_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LMCreateModalComponent_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ((_co.locationType == 3) || (_co.locationType == 4));
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = (_co.locationType == 2);
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = (((_co.locationType == 1) || !_co.locationType) || (_co.locationType == 5));
        _ck(_v, 9, 0, currVal_2);
    }, null);
}
function View_LMCreateModalComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Change of country is not allowed. ']))], null, null);
}
function View_LMCreateModalComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Type is required ']))], null, null);
}
function View_LMCreateModalComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Type is required ']))], null, null);
}
function View_LMCreateModalComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [['label',
                'Change in all open orders'], ['name', 'changeLocations']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.changeOrder = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], form: [2, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'changeLocations';
        var currVal_8 = 'Change in all open orders';
        var currVal_9 = core_es5["ɵnov"](_v.parent, 4);
        _ck(_v, 1, 0, currVal_7, currVal_8, currVal_9);
        var currVal_10 = 'changeLocations';
        var currVal_11 = _co.changeOrder;
        _ck(_v, 3, 0, currVal_10, currVal_11);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 5).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 5).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 5).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 5).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 5).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 5).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 5).ngClassPending;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_LMCreateModalComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'zip']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Zip: ', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.locationPropInput.Zip;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_LMCreateModalComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 88, 'div', [['class',
                'col-md-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 85, 'form', [['class', 'form-horizontal'], ['novalidate', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngSubmit'],
            [null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 4).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.createLocation((core_es5["ɵnov"](_v, 52).valid && core_es5["ɵnov"](_v, 18).model.valid)) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[2, 4], ['locationForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 78, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 56, 'div', [['class',
                'row margin-top-20 margin-bottom-20']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 24, 'div', [['class', 'col-md-8 line-form']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'location-form-input', [['label', 'Location'], ['name', 'location'], ['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null,
                'inputEmitter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.locationFromString = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('inputEmitter' === en)) {
                var pd_1 = (_co.onLocationChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_LocationFormInputComponent_0, RenderType_LocationFormInputComponent)),
        core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0,
                'required'] }, null), core_es5["ɵdid"](16384, null, 0, ManagementLocationValidatorDirective, [], { location: [0, 'location'], originalLocation: [1, 'originalLocation'],
            locationType: [2, 'locationType'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], ManagementLocationValidatorDirective]), core_es5["ɵdid"](4308992, [[3, 4], ['location', 4]], 0, locationFormInput_component_LocationFormInputComponent, [[2, forms_es5["NG_VALIDATORS"]],
            [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], disabled: [2,
                'disabled'], form: [3, 'form'], inputLocation: [4, 'inputLocation'] }, { inputEmitter: 'inputEmitter' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [locationFormInput_component_LocationFormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_LMCreateModalComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_LMCreateModalComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_LMCreateModalComponent_7)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 27, 'div', [['class', 'col-md-4 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 24, 'div', [['class',
                'form-group label-floating select2']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Type'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'select', [['class', 'form-control select2'], ['id', 'locationType'], ['name',
                'locationType'], ['required', '']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 48).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 48).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.locationType = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, [['selectType', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 2, null, View_LMCreateModalComponent_8)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_LMCreateModalComponent_9)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'row row-btn']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-sm-6 col-xs-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LMCreateModalComponent_10)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'col-sm-6 col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LMCreateModalComponent_11)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-primary btn-round pull-right'],
            ['type', 'submit']], [[8, 'disabled', 0]], null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"],
            core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Save '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_15 = '';
        _ck(_v, 15, 0, currVal_15);
        var currVal_16 = _co.locationProp;
        var currVal_17 = _co.originalLocation;
        var currVal_18 = _co.locationType;
        _ck(_v, 16, 0, currVal_16, currVal_17, currVal_18);
        var currVal_19 = 'location';
        var currVal_20 = 'Location';
        var currVal_21 = false;
        var currVal_22 = core_es5["ɵnov"](_v, 4);
        var currVal_23 = _co.locationProp;
        _ck(_v, 18, 0, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23);
        var currVal_24 = 'location';
        var currVal_25 = false;
        var currVal_26 = _co.locationFromString;
        _ck(_v, 20, 0, currVal_24, currVal_25, currVal_26);
        var currVal_27 = ((core_es5["ɵunv"](_v, 25, 0, _ck(_v, 26, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 18).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 18).model.pristine || core_es5["ɵnov"](_v, 4).submitted));
        _ck(_v, 25, 0, currVal_27);
        var currVal_28 = ((core_es5["ɵunv"](_v, 29, 0, _ck(_v, 30, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 18).model.errors)) == 'validateLocationManagement') && (!core_es5["ɵnov"](_v, 18).model.pristine || core_es5["ɵnov"](_v, 4).submitted));
        _ck(_v, 29, 0, currVal_28);
        var currVal_29 = ((core_es5["ɵunv"](_v, 33, 0, _ck(_v, 34, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 18).model.errors)) == 'validateChangeCountry') && (!core_es5["ɵnov"](_v, 18).model.pristine || core_es5["ɵnov"](_v, 4).submitted));
        _ck(_v, 33, 0, currVal_29);
        var currVal_30 = 'form-group label-floating select2';
        var currVal_31 = _ck(_v, 42, 0, ((!core_es5["ɵnov"](_v, 52).pristine || core_es5["ɵnov"](_v, 4).submitted) && !core_es5["ɵnov"](_v, 52).valid));
        _ck(_v, 41, 0, currVal_30, currVal_31);
        var currVal_40 = '';
        _ck(_v, 49, 0, currVal_40);
        var currVal_41 = 'locationType';
        var currVal_42 = _co.locationType;
        _ck(_v, 52, 0, currVal_41, currVal_42);
        var currVal_43 = ((core_es5["ɵunv"](_v, 58, 0, _ck(_v, 59, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 52).errors)) == 'greaterThan') && (!core_es5["ɵnov"](_v, 52).pristine || core_es5["ɵnov"](_v, 4).submitted));
        _ck(_v, 58, 0, currVal_43);
        var currVal_44 = ((core_es5["ɵunv"](_v, 62, 0, _ck(_v, 63, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 52).errors)) == 'required') && (!core_es5["ɵnov"](_v, 52).pristine || core_es5["ɵnov"](_v, 4).submitted));
        _ck(_v, 62, 0, currVal_44);
        var currVal_45 = (!_co.typeChanged && _co.locationPropInput.Id);
        _ck(_v, 73, 0, currVal_45);
        var currVal_46 = _co.locationPropInput.Zip;
        _ck(_v, 79, 0, currVal_46);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵnov"](_v, 6).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 6).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 6).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 6).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 6).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 6).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 6).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (core_es5["ɵnov"](_v, 15).required ? '' : null);
        var currVal_8 = core_es5["ɵnov"](_v, 22).ngClassUntouched;
        var currVal_9 = core_es5["ɵnov"](_v, 22).ngClassTouched;
        var currVal_10 = core_es5["ɵnov"](_v, 22).ngClassPristine;
        var currVal_11 = core_es5["ɵnov"](_v, 22).ngClassDirty;
        var currVal_12 = core_es5["ɵnov"](_v, 22).ngClassValid;
        var currVal_13 = core_es5["ɵnov"](_v, 22).ngClassInvalid;
        var currVal_14 = core_es5["ɵnov"](_v, 22).ngClassPending;
        _ck(_v, 14, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_32 = (core_es5["ɵnov"](_v, 49).required ? '' : null);
        var currVal_33 = core_es5["ɵnov"](_v, 54).ngClassUntouched;
        var currVal_34 = core_es5["ɵnov"](_v, 54).ngClassTouched;
        var currVal_35 = core_es5["ɵnov"](_v, 54).ngClassPristine;
        var currVal_36 = core_es5["ɵnov"](_v, 54).ngClassDirty;
        var currVal_37 = core_es5["ɵnov"](_v, 54).ngClassValid;
        var currVal_38 = core_es5["ɵnov"](_v, 54).ngClassInvalid;
        var currVal_39 = core_es5["ɵnov"](_v, 54).ngClassPending;
        _ck(_v, 47, 0, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39);
        var currVal_47 = (_co.processing || (core_es5["ɵnov"](_v, 4).submitted && (!core_es5["ɵnov"](_v, 52).valid || !core_es5["ɵnov"](_v, 18).model.valid)));
        _ck(_v, 81, 0, currVal_47);
    });
}
function View_LMCreateModalComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, FirstKeyPipe, []), core_es5["ɵqud"](402653184, 1, { locationModal: 0 }),
        core_es5["ɵqud"](671088640, 2, { locationForm: 0 }), core_es5["ɵqud"](671088640, 3, { locationModel: 0 }),
        (_l()(), core_es5["ɵeld"](16777216, null, null, 28, 'div', [['bsModal', ''],
            ['class', 'modal fade location-modal'], ['id', 'myModal'], ['role', 'dialog']], null, [[null, 'click'], [null, 'keydown.esc']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 5).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown.esc' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 5).onEsc() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4341760, [[1, 4], ['locationModal',
                4]], 0, modal_component["a" /* ModalDirective */], [core_es5["ElementRef"], core_es5["ViewContainerRef"], core_es5["Renderer"],
            component_loader_factory["a" /* ComponentLoaderFactory */]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 24, 'div', [['class',
                'modal-dialog'], ['role', 'document']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'modal-content']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'modal-header header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'modal-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['aria-label',
                'Close'], ['class', 'close pull-right btn btn-round btn-white modal-close-btn'],
            ['data-dismiss', 'modal'], ['type', 'button']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.hide() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons modal-close-icon']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['close'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'modal-body']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LMCreateModalComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.showForm;
        _ck(_v, 27, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.isEditModal ? 'Edit Location' : 'Create Location');
        _ck(_v, 14, 0, currVal_0);
    });
}
function View_LMCreateModalComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'lm-create-modal', [], null, null, null, View_LMCreateModalComponent_0, RenderType_LMCreateModalComponent)), core_es5["ɵdid"](114688, null, 0, locationManagementCreateModal_component["a" /* LMCreateModalComponent */], [toast_manager["ToastsManager"], services_locationService["a" /* LocationService */], core_es5["ChangeDetectorRef"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var LMCreateModalComponentNgFactory = core_es5["ɵccf"]('lm-create-modal', locationManagementCreateModal_component["a" /* LMCreateModalComponent */], View_LMCreateModalComponent_Host_0, { idToBlur: 'idToBlur' }, { locationCreated: 'locationCreated' }, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L2xvY2F0aW9uTWFuYWdlbWVudC9sb2NhdGlvbk1vZGFscy9sb2NhdGlvbk1hbmFnZW1lbnRDcmVhdGVNb2RhbC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L2xvY2F0aW9uTWFuYWdlbWVudC9sb2NhdGlvbk1vZGFscy9sb2NhdGlvbk1hbmFnZW1lbnRDcmVhdGVNb2RhbC5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9NYW5hZ21lbnQvbG9jYXRpb25NYW5hZ2VtZW50L2xvY2F0aW9uTW9kYWxzL2xvY2F0aW9uTWFuYWdlbWVudENyZWF0ZU1vZGFsLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L2xvY2F0aW9uTWFuYWdlbWVudC9sb2NhdGlvbk1vZGFscy9sb2NhdGlvbk1hbmFnZW1lbnRDcmVhdGVNb2RhbC5jb21wb25lbnQudHMuTE1DcmVhdGVNb2RhbENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgYnNNb2RhbCBjbGFzcz1cIm1vZGFsIGZhZGUgbG9jYXRpb24tbW9kYWxcIiBpZD1cIm15TW9kYWxcIiAjbG9jYXRpb25Nb2RhbD1cImJzLW1vZGFsXCIgcm9sZT1cImRpYWxvZ1wiPiA8ZGl2IGNsYXNzPVwibW9kYWwtZGlhbG9nXCIgcm9sZT1cImRvY3VtZW50XCI+IDxkaXYgY2xhc3M9XCJtb2RhbC1jb250ZW50XCI+IDxkaXYgY2xhc3M9XCJtb2RhbC1oZWFkZXIgaGVhZGVyXCI+IDxoNCBjbGFzcz1cIm1vZGFsLXRpdGxlXCI+IHt7IGlzRWRpdE1vZGFsID8gJ0VkaXQgTG9jYXRpb24nIDogJ0NyZWF0ZSBMb2NhdGlvbicgfX08L2g0PiA8L2Rpdj4gPGJ1dHRvbiAoY2xpY2spPVwiaGlkZSgpXCIgdHlwZT1cImJ1dHRvblwiIGNsYXNzPVwiY2xvc2UgcHVsbC1yaWdodCBidG4gYnRuLXJvdW5kIGJ0bi13aGl0ZSBtb2RhbC1jbG9zZS1idG5cIiBkYXRhLWRpc21pc3M9XCJtb2RhbFwiIGFyaWEtbGFiZWw9XCJDbG9zZVwiPjxpIGNsYXNzPVwibWF0ZXJpYWwtaWNvbnMgbW9kYWwtY2xvc2UtaWNvblwiPmNsb3NlPC9pPjwvYnV0dG9uPiA8ZGl2IGNsYXNzPVwibW9kYWwtYm9keVwiPiA8ZGl2IGNsYXNzPVwicm93XCI+IDxkaXYgY2xhc3M9XCJjb2wtbWQtMTJcIiAqbmdJZj1cInNob3dGb3JtXCI+IDxmb3JtICNsb2NhdGlvbkZvcm09XCJuZ0Zvcm1cIiBjbGFzcz1cImZvcm0taG9yaXpvbnRhbFwiIG5vdmFsaWRhdGUgKG5nU3VibWl0KT1cImNyZWF0ZUxvY2F0aW9uKHNlbGVjdFR5cGUudmFsaWQgJiYgbG9jYXRpb24ubW9kZWwudmFsaWQpXCI+IDxkaXYgY2xhc3M9XCJjYXJkLWNvbnRlbnRcIj4gPGRpdiBjbGFzcz1cInJvdyBtYXJnaW4tdG9wLTIwIG1hcmdpbi1ib3R0b20tMjBcIj4gPGRpdiBjbGFzcz1cImNvbC1tZC04IGxpbmUtZm9ybVwiPiA8bG9jYXRpb24tZm9ybS1pbnB1dCAjbG9jYXRpb24gbmFtZT1cImxvY2F0aW9uXCIgbGFiZWw9XCJMb2NhdGlvblwiIFtmb3JtXT1cImxvY2F0aW9uRm9ybVwiIFsobmdNb2RlbCldPVwibG9jYXRpb25Gcm9tU3RyaW5nXCIgW2lucHV0TG9jYXRpb25dPVwibG9jYXRpb25Qcm9wXCIgKGlucHV0RW1pdHRlcik9XCJvbkxvY2F0aW9uQ2hhbmdlKCRldmVudClcIiBbZGlzYWJsZWRdPVwiZmFsc2VcIiByZXF1aXJlZCBbdmFsaWRhdGVMb2NhdGlvbk1hbmFnZW1lbnRdPVwibG9jYXRpb25Qcm9wXCIgW29yaWdpbmFsTG9jYXRpb25dPVwib3JpZ2luYWxMb2NhdGlvblwiIFtsb2NhdGlvblR5cGVdPVwibG9jYXRpb25UeXBlXCI+IDxzcGFuIGNsYXNzPVwiaGVscC1ibG9ja1wiICpuZ0lmPVwiKGxvY2F0aW9uLm1vZGVsLmVycm9ycyB8IGZpcnN0S2V5KSA9PSAncmVxdWlyZWQnICYmICghbG9jYXRpb24ubW9kZWwucHJpc3RpbmUgfHwgbG9jYXRpb25Gb3JtLnN1Ym1pdHRlZClcIj4gTG9jYXRpb24gaXMgcmVxdWlyZWQuIDwvc3Bhbj4gPHNwYW4gY2xhc3M9XCJoZWxwLWJsb2NrXCIgKm5nSWY9XCIobG9jYXRpb24ubW9kZWwuZXJyb3JzIHwgZmlyc3RLZXkpID09ICd2YWxpZGF0ZUxvY2F0aW9uTWFuYWdlbWVudCcgJiYgKCFsb2NhdGlvbi5tb2RlbC5wcmlzdGluZSB8fCBsb2NhdGlvbkZvcm0uc3VibWl0dGVkKVwiPiA8bmctY29udGFpbmVyICpuZ0lmPVwibG9jYXRpb25UeXBlID09IDMgfHwgbG9jYXRpb25UeXBlID09IDRcIj4gUmVxdWlyZWQgU3RyZWV0LCBDaXR5IGFuZCBDb3VudHkgPC9uZy1jb250YWluZXI+IDxuZy1jb250YWluZXIgKm5nSWY9XCJsb2NhdGlvblR5cGUgPT0gMiBcIj4gQ291bnRyeSBpcyByZXF1aXJlZCAoYW5kIFByb3ZpbmNlIGZvciBDYW5hZGEpIDwvbmctY29udGFpbmVyPiA8bmctY29udGFpbmVyICpuZ0lmPVwibG9jYXRpb25UeXBlID09IDEgfHwgIWxvY2F0aW9uVHlwZSB8fCBsb2NhdGlvblR5cGUgPT0gNVwiPiBDb3VudHJ5IGlzIHJlcXVpcmVkIChhbmQgUHJvdmluY2UgZm9yIENhbmFkYSkgPC9uZy1jb250YWluZXI+IDwvc3Bhbj4gPHNwYW4gY2xhc3M9XCJoZWxwLWJsb2NrXCIgKm5nSWY9XCIobG9jYXRpb24ubW9kZWwuZXJyb3JzIHwgZmlyc3RLZXkpID09ICd2YWxpZGF0ZUNoYW5nZUNvdW50cnknICYmICghbG9jYXRpb24ubW9kZWwucHJpc3RpbmUgfHwgbG9jYXRpb25Gb3JtLnN1Ym1pdHRlZClcIj4gQ2hhbmdlIG9mIGNvdW50cnkgaXMgbm90IGFsbG93ZWQuIDwvc3Bhbj4gPC9sb2NhdGlvbi1mb3JtLWlucHV0PiA8L2Rpdj4gPGRpdiBjbGFzcz1cImNvbC1tZC00IGxpbmUtZm9ybVwiPiA8ZGl2IGNsYXNzPVwiZm9ybS1ncm91cCBsYWJlbC1mbG9hdGluZyBzZWxlY3QyXCIgW25nQ2xhc3NdPVwieydoYXMtZXJyb3InOiAoIXNlbGVjdFR5cGUucHJpc3RpbmUgfHwgbG9jYXRpb25Gb3JtLnN1Ym1pdHRlZCkgJiYgIXNlbGVjdFR5cGUudmFsaWR9XCI+IDxsYWJlbCBjbGFzcz1cImNvbnRyb2wtbGFiZWxcIj5UeXBlPC9sYWJlbD4gPHNlbGVjdCAjc2VsZWN0VHlwZT1cIm5nTW9kZWxcIiBpZD1cImxvY2F0aW9uVHlwZVwiIGNsYXNzPVwiZm9ybS1jb250cm9sIHNlbGVjdDJcIiByZXF1aXJlZCBuYW1lPVwibG9jYXRpb25UeXBlXCIgWyhuZ01vZGVsKV09XCJsb2NhdGlvblR5cGVcIj4gPC9zZWxlY3Q+IDxzcGFuIGNsYXNzPVwiaGVscC1ibG9ja1wiICpuZ0lmPVwiKHNlbGVjdFR5cGUuZXJyb3JzIHwgZmlyc3RLZXkpID09ICdncmVhdGVyVGhhbicgJiYgKCFzZWxlY3RUeXBlLnByaXN0aW5lIHx8IGxvY2F0aW9uRm9ybS5zdWJtaXR0ZWQpXCI+IFR5cGUgaXMgcmVxdWlyZWQgPC9zcGFuPiA8c3BhbiBjbGFzcz1cImhlbHAtYmxvY2tcIiAqbmdJZj1cIihzZWxlY3RUeXBlLmVycm9ycyB8IGZpcnN0S2V5KSA9PSAncmVxdWlyZWQnICYmICghc2VsZWN0VHlwZS5wcmlzdGluZSB8fCBsb2NhdGlvbkZvcm0uc3VibWl0dGVkKVwiPiBUeXBlIGlzIHJlcXVpcmVkIDwvc3Bhbj4gPC9kaXY+IDwvZGl2PiA8L2Rpdj4gPGRpdiBjbGFzcz1cInJvdyByb3ctYnRuXCI+IDxkaXYgY2xhc3M9XCJjb2wtc20tNiBjb2wteHMtMTJcIj4gPGNoZWNrYm94ICpuZ0lmPVwiIXR5cGVDaGFuZ2VkICYmIGxvY2F0aW9uUHJvcElucHV0LklkXCIgWyhuZ01vZGVsKV09XCJjaGFuZ2VPcmRlclwiIGxhYmVsPVwiQ2hhbmdlIGluIGFsbCBvcGVuIG9yZGVyc1wiIG5hbWU9XCJjaGFuZ2VMb2NhdGlvbnNcIiBbZm9ybV09XCJsb2NhdGlvbkZvcm1cIj4gPC9jaGVja2JveD4gPC9kaXY+IDxkaXYgY2xhc3M9XCJjb2wtc20tNiBjb2wteHMtMTJcIj4gPHNwYW4gY2xhc3M9XCJ6aXBcIiAqbmdJZj1cImxvY2F0aW9uUHJvcElucHV0LlppcFwiPlppcDoge3tsb2NhdGlvblByb3BJbnB1dC5aaXB9fTwvc3Bhbj4gPGJ1dHRvbiB0eXBlPVwic3VibWl0XCIgY2xhc3M9XCJidG4gYnRuLXByaW1hcnkgYnRuLXJvdW5kIHB1bGwtcmlnaHRcIiBbZGlzYWJsZWRdPVwicHJvY2Vzc2luZyB8fCAobG9jYXRpb25Gb3JtLnN1Ym1pdHRlZCAmJiAoIXNlbGVjdFR5cGUudmFsaWQgfHwgIWxvY2F0aW9uLm1vZGVsLnZhbGlkKSlcIj4gU2F2ZSA8L2J1dHRvbj4gPC9kaXY+IDwvZGl2PiA8L2Rpdj4gPC9mb3JtPiA8L2Rpdj4gPC9kaXY+IDwvZGl2PiA8L2Rpdj4gPC9kaXY+IDwvZGl2PiIsIjxsbS1jcmVhdGUtbW9kYWw+PC9sbS1jcmVhdGUtbW9kYWw+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0E4b0M7TUFBQTtNQUEwSTs7O29CQUE0TDtNQUFBO01BQTZEOzs7O29CQUFrRDtNQUFBO01BQXlDOzs7O29CQUErRDtNQUFBO01BQThFOzs7O29CQUFsYztNQUFBO01BQTRKLHNDQUFDO1VBQUEscUVBQUE7VUFBQTtVQUFBLGVBQThHLHNDQUFDO1VBQUE7YUFBQTtVQUFBLHdCQUF1RyxzQ0FBQztVQUFBO2FBQUE7VUFBQSx3QkFBNEk7O0lBQXJWO0lBQWQsV0FBYyxTQUFkO0lBQTZIO0lBQWQsV0FBYyxTQUFkO0lBQXNIO0lBQWQsV0FBYyxTQUFkOzs7O29CQUFxSjtNQUFBO01BQXVKOzs7O29CQUFxYjtNQUFBO01BQXFJOzs7b0JBQTBCO01BQUE7TUFBa0k7OztvQkFBMEc7TUFBQTtNQUFBO01BQUE7TUFBQTtJQUFBO0lBQUE7SUFBdUQ7TUFBQTtNQUFBO0lBQUE7SUFBdkQ7RUFBQSx1RUFBQTtNQUFBO01BQUEsMEVBQUE7TUFBQTtRQUFBO01BQUEsaUNBQUE7TUFBQTtNQUFBLG9EQUFBO01BQUEsbUNBQUE7TUFBQSw0Q0FBZ0s7OztJQUE3QztJQUFsQztJQUF5RDtJQUExSSxXQUFtSCxVQUFsQyxVQUF5RCxTQUExSTtJQUFtSDtJQUE1RDtJQUF2RCxXQUFtSCxXQUE1RCxVQUF2RDs7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUEscUVBQUE7Ozs7b0JBQXFOO01BQUE7TUFBZ0Q7O0lBQUE7SUFBQTs7OztvQkFBeC9FO01BQUE7TUFBd0Msc0NBQUM7VUFBQTtjQUFBO2NBQUE7a0JBQUE7Y0FBQTtZQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQWdFO2NBQUE7a0JBQUE7Y0FBQTtZQUFBO1lBQWhFO1VBQUEsdUNBQUE7VUFBQSxvQ0FBQTtvQkFBQTthQUFBLDBFQUFBO1VBQUE7VUFBQSxlQUFzSSxzQ0FBQztVQUFBO1VBQUEsNENBQTBCO1VBQUEsUUFBQztVQUFBO1VBQUEsOEJBQWdELHNDQUFDO2lCQUFBO2NBQUE7TUFBZ0Msc0NBQUM7VUFBQTtjQUFBO2NBQUE7Y0FBQTtrQkFBQTtjQUFBO1lBQUE7WUFBQTtZQUFzRjtjQUFBO2NBQUE7WUFBQTtZQUFnRTtjQUFBO2NBQUE7WUFBQTtZQUF0SjtVQUFBO2FBQUE7VUFBQSxtQ0FBQTtVQUFBO2NBQUEsdURBQUE7MkJBQUE7WUFBQTtVQUFBLHlFQUFBO1VBQUE7Y0FBQTtjQUFBO2FBQUE7UUFBQTtNQUFBLDBDQUFBO1VBQUE7VUFBQTthQUFBLG9FQUFBO1VBQUE7TUFBNFUsMEJBQUM7VUFBQSx1Q0FBQTt3QkFBQSwwQ0FBeUIsSUFBK0k7VUFBQSxRQUFDO2FBQUE7VUFBQSwrQkFBeUIsSUFBK2UsMEJBQUM7VUFBQSx1RUFBQTtVQUFBO1VBQUEsc0JBQXlCLElBQXdLLDBCQUF1QjtVQUFBLFFBQU8sc0NBQUM7VUFBQTtVQUFBLDRDQUFnQztVQUFBLFFBQUM7VUFBQTtVQUFBLHFDQUFBO1VBQUE7Y0FBQSxzREFBK0M7TUFBaUcsc0NBQUM7VUFBQTtVQUFBLDhCQUE2Qix5Q0FBWTtpQkFBQSx1QkFBQztVQUFBO2NBQUE7Y0FBQTtjQUFBO2tCQUFBO2NBQUE7WUFBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUEwRztjQUFBO2NBQUE7WUFBQTtZQUExRztVQUFBLHVDQUFBO1VBQUEsaUVBQUE7VUFBQTtVQUFBLHNCQUFBO1FBQUE7TUFBQTtRQUFBO01BQUEsMENBQUE7VUFBQTtVQUFBLHFFQUFBO1VBQUEsOERBQUE7VUFBQSxpRUFBcUk7aUJBQUEsdUJBQVUsc0NBQUM7aUJBQUE7YUFBQTtVQUFBLCtCQUF5QixJQUFxSTtNQUFDO2FBQUE7VUFBQSwrQkFBeUIsSUFBa0k7TUFBTyxzQ0FBTztNQUFPLHNDQUFDO1VBQUE7VUFBQSw4QkFBeUIsc0NBQUM7aUJBQUE7Y0FBQTtNQUFnQyxzQ0FBQztVQUFBLHNFQUFBO1VBQUE7VUFBQSxlQUE0SyxzQ0FBTztVQUFBLFFBQUM7VUFBQTtVQUFBLGdCQUFnQyxzQ0FBQztVQUFBO2FBQUE7VUFBQSx3QkFBcUYsc0NBQUM7VUFBQTtjQUFBO1VBQUEsdUJBQUE7c0JBQUEsK0JBQXVLO1VBQUEsYUFBZSxzQ0FBTztVQUFBLFFBQU8sc0NBQU87VUFBQSxRQUFROztJQUFqd0U7SUFBbk4sWUFBbU4sVUFBbk47SUFBNE47SUFBNEM7SUFBc0M7SUFBOVMsWUFBNE4sV0FBNEMsV0FBc0MsVUFBOVM7SUFBK0I7SUFBZ0I7SUFBaUo7SUFBaEk7SUFBdUQ7SUFBdkgsWUFBK0IsV0FBZ0IsV0FBaUosV0FBaEksV0FBdUQsVUFBdkg7SUFBK0I7SUFBaUs7SUFBMUc7SUFBdEYsWUFBK0IsV0FBaUssV0FBMUcsVUFBdEY7SUFBc1c7UUFBQTtRQUFBO0lBQXpCLFlBQXlCLFVBQXpCO0lBQWtNO1FBQUE7UUFBQTtJQUF6QixZQUF5QixVQUF6QjtJQUFraUI7UUFBQTtRQUFBO0lBQXpCLFlBQXlCLFVBQXpCO0lBQXNRO0lBQTBDO1FBQUE7SUFBL0MsWUFBSyxXQUEwQyxVQUEvQztJQUF3UTtJQUE3RSxZQUE2RSxVQUE3RTtJQUFzRjtJQUFvQjtJQUExRyxZQUFzRixXQUFvQixVQUExRztJQUF5SztRQUFBO1FBQUE7SUFBekIsWUFBeUIsVUFBekI7SUFBd0w7UUFBQTtRQUFBO0lBQXpCLFlBQXlCLFVBQXpCO0lBQXNQO0lBQVYsWUFBVSxVQUFWO0lBQXVPO0lBQWxCLFlBQWtCLFVBQWxCOzs7SUFBLzVFO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsV0FBQSxxRUFBQTtJQUFvUDtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsWUFBQSxVQUFBO1FBQUEsVUFBQTtJQUEyN0M7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFlBQUEsV0FBQTtRQUFBLHFCQUFBO0lBQXk0QjtRQUFBO0lBQW5FLFlBQW1FLFVBQW5FOzs7Ozs7TUFBbGtHO1VBQUE7VUFBQTt1QkFBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1VBQUEsdUNBQUE7VUFBQTtvQ0FBQSwrQkFBb0c7VUFBQSxRQUFDO1VBQUE7VUFBQSw4QkFBMEMsc0NBQUM7aUJBQUE7Y0FBQTtNQUEyQixzQ0FBQztVQUFBO1VBQUEsOEJBQWlDLHNDQUFDO2lCQUFBO2NBQUEsMERBQXdCO1VBQUEsV0FBNkQsc0NBQU87VUFBQSxRQUFDO1VBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtRQUFRO1VBQUE7VUFBQTtRQUFBO1FBQVI7TUFBQSx1Q0FBQTtVQUFBLDBEQUFnSjtVQUFBO1VBQUE7TUFBMkMsMENBQWtCO01BQUM7VUFBQTtNQUF3QixzQ0FBQztVQUFBO1VBQUEsZ0JBQWlCLHNDQUFDO1VBQUE7YUFBQTtVQUFBLHdCQUF3dkYsc0NBQU87VUFBQSxRQUFPLHNDQUFPO1VBQUEsUUFBTzs7SUFBN3ZGO0lBQXZCLFlBQXVCLFNBQXZCOzs7SUFBOVQ7SUFBQTs7OztvQkNBdE87TUFBQTt1Q0FBQSxVQUFBO01BQUE7O1FBQUE7Ozs7OyJ9
//# sourceMappingURL=locationManagementCreateModal.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/locationManagement/locationManagement.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
















var styles_LocationManagementComponent = [];
var RenderType_LocationManagementComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_LocationManagementComponent, data: {} });
function View_LocationManagementComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'location-item', [], null, null, null, View_LocationItemComponent_0, RenderType_LocationItemComponent)), core_es5["ɵdid"](49152, null, 0, locationItem_component_LocationItemComponent, [], { location: [0, 'location'],
            locationModal: [1, 'locationModal'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        var currVal_1 = core_es5["ɵnov"](_v.parent.parent, 39);
        _ck(_v, 3, 0, currVal_0, currVal_1);
    }, null);
}
function View_LocationManagementComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_LocationManagementComponent_2)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), core_es5["ɵpid"](0, PaginatePipe, [ngx_pagination_PaginationService]),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 3, 0, core_es5["ɵnov"](_v, 4).transform(_co.searchResponse.Items, _co.config));
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_LocationManagementComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'row'], ['style', 'text-align:center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h2', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' No matching results! '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_LocationManagementComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'management-pagination', [], null, [[null, 'searchEventEmitter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('searchEventEmitter' === en)) {
                var pd_0 = (_co.search() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ManagementPaginationComponent_0, RenderType_ManagementPaginationComponent)),
        core_es5["ɵdid"](49152, null, 0, managementPagination_component_ManagementPaginationComponent, [], { config: [0, 'config'] }, { searchEventEmitter: 'searchEventEmitter' }), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.config;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_LocationManagementComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { createModal: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 35, 'div', [['class', 'main-content']], [[1, 'id', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 32, 'div', [['class', 'container-fluid']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'row top_buttons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-sm-7 col-xs-12 top_buttons_body']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'button', [['class', 'btn btn-white btn-round btn-just-icon location']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.showCreateModal() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['add_location'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'search']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'location-management-search', [], null, [[null, 'searchEvent']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('searchEvent' === en)) {
                    _co.config.currentPage = 1;
                    var pd_0 = (_co.searchLocations($event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_LocationManagementSearchComponent_0, RenderType_LocationManagementSearchComponent)),
        core_es5["ɵdid"](49152, null, 0, locationManagementSearch_component_LocationManagementSearchComponent, [core_es5["ChangeDetectorRef"]], null, { searchEvent: 'searchEvent' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'text-help mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Search by Location'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationManagementComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationManagementComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationManagementComponent_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'lm-create-modal', [], null, [[null,
                'locationCreated']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('locationCreated' === en)) {
                var pd_0 = (_co.locationCreatedHandler($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_LMCreateModalComponent_0, RenderType_LMCreateModalComponent)),
        core_es5["ɵdid"](114688, [[1, 4], ['createModal', 4]], 0, locationManagementCreateModal_component["a" /* LMCreateModalComponent */], [toast_manager["ToastsManager"],
            services_locationService["a" /* LocationService */], core_es5["ChangeDetectorRef"]], { idToBlur: [0, 'idToBlur'] }, { locationCreated: 'locationCreated' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = (_co.searchResponse.Items.length > 0);
        _ck(_v, 28, 0, currVal_1);
        var currVal_2 = (_co.searchResponse.Items.length == 0);
        _ck(_v, 31, 0, currVal_2);
        var currVal_3 = (_co.searchResponse.Items.length > 0);
        _ck(_v, 34, 0, currVal_3);
        var currVal_4 = _co.idToBlur;
        _ck(_v, 39, 0, currVal_4);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.idToBlur;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_LocationManagementComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'location-management', [], null, [['window', 'popstate']], function (_v, en, $event) {
            var ad = true;
            if (('window:popstate' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).unBlurMenu($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_LocationManagementComponent_0, RenderType_LocationManagementComponent)),
        core_es5["ɵdid"](114688, null, 0, locationManagement_component_LocationManagementComponent, [router_es5["a" /* ActivatedRoute */],
            services_locationService["a" /* LocationService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var LocationManagementComponentNgFactory = core_es5["ɵccf"]('location-management', locationManagement_component_LocationManagementComponent, View_LocationManagementComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=locationManagement.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/Managment/productManagement/productItem/productItem.component.ts
/**
 * Created by alex.y on 9/11/2017.
 */
var ProductItemComponent = /** @class */ (function () {
    function ProductItemComponent() {
        this.string = String;
    }
    return ProductItemComponent;
}());

//# sourceMappingURL=productItem.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/productManagement/productItem/productItem.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_ProductItemComponent = [];
var RenderType_ProductItemComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ProductItemComponent, data: {} });
function View_ProductItemComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [['class',
                'card-text']], [[8, 'title', 0]], null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, '', _co.product.Name, '');
        _ck(_v, 0, 0, currVal_0);
        var currVal_1 = _co.product.Name;
        _ck(_v, 1, 0, currVal_1);
    });
}
function View_ProductItemComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [['class',
                'card-text card-text-description']], [[8, 'title', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, '', _co.product.Description, '');
        _ck(_v, 0, 0, currVal_0);
        var currVal_1 = _co.product.Description;
        _ck(_v, 1, 0, currVal_1);
    });
}
function View_ProductItemComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [['class',
                'card-text']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.product.HsCode;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_ProductItemComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 38, 'div', [['class',
                'col-sp-5 location-card']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 35, 'div', [['class', 'card card-stats']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 5, 'button', [['class', 'btn btn-round btn-white btn-fill btn-just-icon pull-right edit-button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.productModal.show(_co.product) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons visible-on-sidebar-regular icon-orange']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['more_vert'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'card-footer']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'ul', [['style',
                'list-style-type:none;padding-left:0']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 2, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'card-title orange-text']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Name:'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ProductItemComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'card-title orange-text']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Description:'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ProductItemComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'card-title orange-text']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['HsCode:'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ProductItemComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.product.Name;
        _ck(_v, 20, 0, currVal_0);
        var currVal_1 = _co.product.Description;
        _ck(_v, 27, 0, currVal_1);
        var currVal_2 = _co.product.HsCode;
        _ck(_v, 34, 0, currVal_2);
    }, null);
}
function View_ProductItemComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'product-item', [], null, null, null, View_ProductItemComponent_0, RenderType_ProductItemComponent)), core_es5["ɵdid"](49152, null, 0, ProductItemComponent, [], null, null)], null, null);
}
var ProductItemComponentNgFactory = core_es5["ɵccf"]('product-item', ProductItemComponent, View_ProductItemComponent_Host_0, { product: 'product', productModal: 'productModal' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=productItem.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/services/productService.ts
var services_productService = __webpack_require__("XowU");

// EXTERNAL MODULE: ./app/objects/requests/productSearchRequest.ts
var productSearchRequest = __webpack_require__("hgwR");

// EXTERNAL MODULE: ./app/objects/products/requestType.ts
var requestType = __webpack_require__("HY16");

// CONCATENATED MODULE: ./app/components/Managment/productManagement/productManagement.component.ts





/**
 * Created by alex.y on 9/11/2017.
 */
var productManagement_component_ProductManagementComponent = /** @class */ (function () {
    function ProductManagementComponent(route, productService) {
        this.route = route;
        this.productService = productService;
        this.products = [];
        this.idToBlur = "product-management";
        this.config = {
            id: 'custom',
            itemsPerPage: 12,
            currentPage: 1,
            totalItems: 1
        };
    }
    ProductManagementComponent.prototype.unBlurMenu = function () {
        blurUtil["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
    };
    ProductManagementComponent.prototype.ngOnInit = function () {
        this.config.totalItems = this.route.snapshot.data.products.TotalCount;
        this.products = this.route.snapshot.data.products.Items;
    };
    ProductManagementComponent.prototype.search = function () {
        var _this = this;
        this.productService.search(new productSearchRequest["a" /* ProductSearchRequest */]({
            Skip: (this.config.currentPage - 1) * this.config.itemsPerPage,
            Top: this.config.itemsPerPage,
            Query: this.query,
            Source: null,
            RequestType: requestType["a" /* RequestType */].Search
        })).then(function (users) {
            _this.products = users.Data.Items;
            _this.config.totalItems = users.Data.TotalCount;
            document.getElementById('mainPanel').scrollTop = 0;
        }).catch(function (response) {
            _this.products.splice(0, _this.products.length);
        });
    };
    ProductManagementComponent.prototype.onProductSaved = function (product) {
        var existingProduct = this.products.find(function (x) { return x.Id == product.Id; });
        if (existingProduct != null) {
            Object.assign(existingProduct, product);
        }
        else {
            this.products.unshift(product);
            this.products.pop();
            this.config.totalItems += 1;
        }
    };
    ProductManagementComponent.ctorParameters = function () { return [{ type: router_es5["a" /* ActivatedRoute */] }, { type: services_productService["a" /* ProductService */] }]; };
    return ProductManagementComponent;
}());

//# sourceMappingURL=productManagement.component.js.map
// EXTERNAL MODULE: ./app/objects/products/product.ts + 1 modules
var products_product = __webpack_require__("aZ3i");

// CONCATENATED MODULE: ./app/components/Managment/productManagement/modal/productModal.component.ts





/**
 * Created by alex.y on 9/11/2017.
 */
var productModal_component_ProductModalComponent = /** @class */ (function () {
    function ProductModalComponent(productService, toastr) {
        this.productService = productService;
        this.toastr = toastr;
        this.originalProduct = new products_product["a" /* Product */]();
        this.currentProduct = new products_product["a" /* Product */]();
        this.string = String;
        this.number = Number;
        this.processing = false;
        this.productSaved = new core_es5["EventEmitter"]();
    }
    ProductModalComponent.prototype.show = function (product) {
        this.originalProduct = product;
        this.currentProduct = JSON.parse(JSON.stringify(product));
        this.productModal.show();
        blurUtil["a" /* BlurUtil */].blurMenu(this.idToBlur);
    };
    ProductModalComponent.prototype.onModalHidden = function () {
        this.productForm.reset();
        blurUtil["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
    };
    ProductModalComponent.prototype.save = function (isValid) {
        var _this = this;
        if (!isValid)
            return;
        this.processing = true;
        this.productService.update(this.currentProduct).then(function (response) {
            _this.processing = false;
            if (_this.currentProduct.ChangeOrders)
                _this.toastr.success("Orders were updated");
            _this.productSaved.emit(response.Data);
            _this.productModal.hide();
        }).catch(function () {
            _this.toastr.error("Does not change any order");
        });
    };
    ProductModalComponent.prototype.cancel = function () {
        this.productModal.hide();
    };
    ProductModalComponent.ctorParameters = function () { return [{ type: services_productService["a" /* ProductService */] }, { type: ng2_toastr["ToastsManager"] }]; };
    return ProductModalComponent;
}());

//# sourceMappingURL=productModal.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/productManagement/modal/productModal.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */














var styles_ProductModalComponent = [];
var RenderType_ProductModalComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ProductModalComponent, data: {} });
function View_ProductModalComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Name is required. ']))], null, null);
}
function View_ProductModalComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, FirstKeyPipe, []), core_es5["ɵqud"](402653184, 1, { productModal: 0 }),
        core_es5["ɵqud"](402653184, 2, { productForm: 0 }), (_l()(), core_es5["ɵeld"](16777216, null, null, 111, 'div', [['bsModal', ''], ['class', 'modal fade customer-modal product-modal'],
            ['role', 'dialog']], null, [[null, 'onHidden'], [null,
                'click'], [null, 'keydown.esc']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown.esc' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 4).onEsc() !== false);
                ad = (pd_1 && ad);
            }
            if (('onHidden' === en)) {
                var pd_2 = (_co.onModalHidden() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4341760, [[1, 4], ['productModal', 4]], 0, modal_component["a" /* ModalDirective */], [core_es5["ElementRef"], core_es5["ViewContainerRef"], core_es5["Renderer"], component_loader_factory["a" /* ComponentLoaderFactory */]], null, { onHidden: 'onHidden' }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 107, 'div', [['class', 'modal-dialog modal-lg'],
            ['role', 'document']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 104, 'div', [['class', 'modal-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'modal-header header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'modal-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['aria-label',
                'Close'], ['class', 'close pull-right btn btn-round btn-white modal-close-btn'],
            ['data-dismiss', 'modal'], ['type', 'button']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).hide() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons modal-close-icon']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['close'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 90, 'div', [['class', 'modal-body']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 87, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 84, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 81, 'form', [['class',
                'form-horizontal'], ['novalidate', '']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngSubmit'], [null,
                'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 29).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 29).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.save(core_es5["ɵnov"](_v, 29).valid) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[2, 4], ['productForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 74, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 50, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 47, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 30, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class',
                'col-sm-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentProduct.Name = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['nameModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_ProductModalComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class',
                'col-sm-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'form-group label-floating']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class',
                'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['HS Code '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'hs-code'], ['readonly', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'col-md-12 line-form']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'form-group label-floating']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class',
                'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Description '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['readonly', '']], [[8, 'innerHTML', 1]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class', 'row row-btn']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'col-md-offset-5 col-md-4 col-xs-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [['label', 'Change in all open orders'], ['name', 'changeProducts']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentProduct.ChangeOrders = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], form: [2, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'col-md-3 col-xs-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-primary btn-round pull-right'],
            ['type', 'submit']], [[8, 'disabled', 0]], null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"],
            core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Save '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_16 = '';
        _ck(_v, 44, 0, currVal_16);
        var currVal_17 = 'text';
        var currVal_18 = 'Name';
        var currVal_19 = 'Name';
        var currVal_20 = false;
        var currVal_21 = core_es5["ɵnov"](_v, 29);
        _ck(_v, 46, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21);
        var currVal_22 = 'Name';
        var currVal_23 = false;
        var currVal_24 = _co.currentProduct.Name;
        _ck(_v, 48, 0, currVal_22, currVal_23, currVal_24);
        var currVal_25 = ((core_es5["ɵunv"](_v, 53, 0, _ck(_v, 54, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 46).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 46).model.pristine || core_es5["ɵnov"](_v, 29).submitted));
        _ck(_v, 53, 0, currVal_25);
        var currVal_35 = 'changeProducts';
        var currVal_36 = 'Change in all open orders';
        var currVal_37 = core_es5["ɵnov"](_v, 29);
        _ck(_v, 92, 0, currVal_35, currVal_36, currVal_37);
        var currVal_38 = 'changeProducts';
        var currVal_39 = _co.currentProduct.ChangeOrders;
        _ck(_v, 94, 0, currVal_38, currVal_39);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Edit Product';
        _ck(_v, 13, 0, currVal_0);
        var currVal_1 = core_es5["ɵnov"](_v, 31).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 31).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 31).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 31).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 31).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 31).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 31).ngClassPending;
        _ck(_v, 27, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_8 = (core_es5["ɵnov"](_v, 44).required ? '' : null);
        var currVal_9 = core_es5["ɵnov"](_v, 50).ngClassUntouched;
        var currVal_10 = core_es5["ɵnov"](_v, 50).ngClassTouched;
        var currVal_11 = core_es5["ɵnov"](_v, 50).ngClassPristine;
        var currVal_12 = core_es5["ɵnov"](_v, 50).ngClassDirty;
        var currVal_13 = core_es5["ɵnov"](_v, 50).ngClassValid;
        var currVal_14 = core_es5["ɵnov"](_v, 50).ngClassInvalid;
        var currVal_15 = core_es5["ɵnov"](_v, 50).ngClassPending;
        _ck(_v, 43, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15);
        var currVal_26 = _co.currentProduct.HsCode;
        _ck(_v, 66, 0, currVal_26);
        var currVal_27 = _co.currentProduct.Description;
        _ck(_v, 80, 0, currVal_27);
        var currVal_28 = core_es5["ɵnov"](_v, 96).ngClassUntouched;
        var currVal_29 = core_es5["ɵnov"](_v, 96).ngClassTouched;
        var currVal_30 = core_es5["ɵnov"](_v, 96).ngClassPristine;
        var currVal_31 = core_es5["ɵnov"](_v, 96).ngClassDirty;
        var currVal_32 = core_es5["ɵnov"](_v, 96).ngClassValid;
        var currVal_33 = core_es5["ɵnov"](_v, 96).ngClassInvalid;
        var currVal_34 = core_es5["ɵnov"](_v, 96).ngClassPending;
        _ck(_v, 91, 0, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34);
        var currVal_40 = (_co.processing || (core_es5["ɵnov"](_v, 29).submitted && !core_es5["ɵnov"](_v, 29).valid));
        _ck(_v, 102, 0, currVal_40);
    });
}
function View_ProductModalComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'product-modal', [], null, null, null, View_ProductModalComponent_0, RenderType_ProductModalComponent)), core_es5["ɵdid"](49152, null, 0, productModal_component_ProductModalComponent, [services_productService["a" /* ProductService */], toast_manager["ToastsManager"]], null, null)], null, null);
}
var ProductModalComponentNgFactory = core_es5["ɵccf"]('product-modal', productModal_component_ProductModalComponent, View_ProductModalComponent_Host_0, { idToBlur: 'idToBlur' }, { productSaved: 'productSaved' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=productModal.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/productManagement/productManagement.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */















var styles_ProductManagementComponent = [];
var RenderType_ProductManagementComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ProductManagementComponent, data: {} });
function View_ProductManagementComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'product-item', [], null, null, null, View_ProductItemComponent_0, RenderType_ProductItemComponent)), core_es5["ɵdid"](49152, null, 0, ProductItemComponent, [], { product: [0, 'product'],
            productModal: [1, 'productModal'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        var currVal_1 = core_es5["ɵnov"](_v.parent.parent, 1);
        _ck(_v, 3, 0, currVal_0, currVal_1);
    }, null);
}
function View_ProductManagementComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_ProductManagementComponent_2)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), core_es5["ɵpid"](0, PaginatePipe, [ngx_pagination_PaginationService]),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 3, 0, core_es5["ɵnov"](_v, 4).transform(_co.products, _co.config));
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_ProductManagementComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'row'], ['style', 'text-align:center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h2', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' No matching results! '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_ProductManagementComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'management-pagination', [], null, [[null, 'searchEventEmitter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('searchEventEmitter' === en)) {
                var pd_0 = (_co.search() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ManagementPaginationComponent_0, RenderType_ManagementPaginationComponent)),
        core_es5["ɵdid"](49152, null, 0, managementPagination_component_ManagementPaginationComponent, [], { config: [0, 'config'] }, { searchEventEmitter: 'searchEventEmitter' }), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.config;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_ProductManagementComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'product-modal', [], null, [[null, 'productSaved']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('productSaved' === en)) {
                var pd_0 = (_co.onProductSaved($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ProductModalComponent_0, RenderType_ProductModalComponent)), core_es5["ɵdid"](49152, [['productModal', 4]], 0, productModal_component_ProductModalComponent, [services_productService["a" /* ProductService */], toast_manager["ToastsManager"]], { idToBlur: [0, 'idToBlur'] }, { productSaved: 'productSaved' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'main-content']], [[1, 'id', 0]], null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'div', [['class', 'container-fluid']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 2, 'management-search', [], null, [[null, 'searchEventEmitter'], [null, 'queryChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('searchEventEmitter' === en)) {
                    _co.config.currentPage = 1;
                    var pd_0 = (_co.search() !== false);
                    ad = (pd_0 && ad);
                }
                if (('queryChange' === en)) {
                    var pd_1 = ((_co.query = $event) !== false);
                    ad = (pd_1 && ad);
                }
                return ad;
            }, View_ManagementSearchComponent_0, RenderType_ManagementSearchComponent)),
        core_es5["ɵdid"](49152, null, 0, managementSearch_component_ManagementSearchComponent, [], { helpText: [0,
                'helpText'], query: [1, 'query'] }, { searchEventEmitter: 'searchEventEmitter',
            queryChange: 'queryChange' }), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ProductManagementComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ProductManagementComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ProductManagementComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.idToBlur;
        _ck(_v, 1, 0, currVal_0);
        var currVal_2 = 'Search by Product Name, HS Code or Company Name';
        var currVal_3 = _co.query;
        _ck(_v, 8, 0, currVal_2, currVal_3);
        var currVal_4 = (_co.products.length > 0);
        _ck(_v, 12, 0, currVal_4);
        var currVal_5 = (_co.products.length == 0);
        _ck(_v, 15, 0, currVal_5);
        var currVal_6 = (_co.products.length > 0);
        _ck(_v, 18, 0, currVal_6);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.idToBlur;
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_ProductManagementComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'product-management', [], null, [['window', 'popstate']], function (_v, en, $event) {
            var ad = true;
            if (('window:popstate' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).unBlurMenu($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ProductManagementComponent_0, RenderType_ProductManagementComponent)),
        core_es5["ɵdid"](114688, null, 0, productManagement_component_ProductManagementComponent, [router_es5["a" /* ActivatedRoute */],
            services_productService["a" /* ProductService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ProductManagementComponentNgFactory = core_es5["ɵccf"]('product-management', productManagement_component_ProductManagementComponent, View_ProductManagementComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L3Byb2R1Y3RNYW5hZ2VtZW50L3Byb2R1Y3RNYW5hZ2VtZW50LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9NYW5hZ21lbnQvcHJvZHVjdE1hbmFnZW1lbnQvcHJvZHVjdE1hbmFnZW1lbnQuY29tcG9uZW50LnRzIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L3Byb2R1Y3RNYW5hZ2VtZW50L3Byb2R1Y3RNYW5hZ2VtZW50LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L3Byb2R1Y3RNYW5hZ2VtZW50L3Byb2R1Y3RNYW5hZ2VtZW50LmNvbXBvbmVudC50cy5Qcm9kdWN0TWFuYWdlbWVudENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxwcm9kdWN0LW1vZGFsIChwcm9kdWN0U2F2ZWQpPVwib25Qcm9kdWN0U2F2ZWQoJGV2ZW50KVwiIFtpZFRvQmx1cl09XCJpZFRvQmx1clwiICNwcm9kdWN0TW9kYWw+PC9wcm9kdWN0LW1vZGFsPiA8ZGl2IGNsYXNzPVwibWFpbi1jb250ZW50XCIgW2F0dHIuaWRdPVwiaWRUb0JsdXJcIj4gPGRpdiBjbGFzcz1cImNvbnRhaW5lci1mbHVpZFwiPiA8bWFuYWdlbWVudC1zZWFyY2ggKHNlYXJjaEV2ZW50RW1pdHRlcik9XCJjb25maWcuY3VycmVudFBhZ2U9MTtzZWFyY2goKVwiIFsocXVlcnkpXT1cInF1ZXJ5XCIgW2hlbHBUZXh0XT1cIidTZWFyY2ggYnkgUHJvZHVjdCBOYW1lLCBIUyBDb2RlIG9yIENvbXBhbnkgTmFtZSdcIj4gPC9tYW5hZ2VtZW50LXNlYXJjaD4gPGRpdiAqbmdJZj1cInByb2R1Y3RzLmxlbmd0aCA+IDBcIiBjbGFzcz1cInJvd1wiPiA8bmctY29udGFpbmVyICpuZ0Zvcj1cImxldCBwcm9kdWN0IG9mIHByb2R1Y3RzIHwgcGFnaW5hdGU6IGNvbmZpZzsgbGV0IGk9aW5kZXhcIj4gPHByb2R1Y3QtaXRlbSBbcHJvZHVjdF09XCJwcm9kdWN0XCIgW3Byb2R1Y3RNb2RhbF09XCJwcm9kdWN0TW9kYWxcIj48L3Byb2R1Y3QtaXRlbT4gPC9uZy1jb250YWluZXI+IDwvZGl2PiA8ZGl2IHN0eWxlPVwidGV4dC1hbGlnbjpjZW50ZXJcIiAqbmdJZj1cInByb2R1Y3RzLmxlbmd0aCA9PSAwXCIgY2xhc3M9XCJyb3dcIj4gPGgyPiBObyBtYXRjaGluZyByZXN1bHRzISA8L2gyPiA8L2Rpdj4gPGRpdiAqbmdJZj1cInByb2R1Y3RzLmxlbmd0aCA+IDBcIiBjbGFzcz1cInJvd1wiPiA8bWFuYWdlbWVudC1wYWdpbmF0aW9uIChzZWFyY2hFdmVudEVtaXR0ZXIpPVwic2VhcmNoKClcIiBbY29uZmlnXT1cImNvbmZpZ1wiPiA8L21hbmFnZW1lbnQtcGFnaW5hdGlvbj4gPC9kaXY+IDwvZGl2PiA8L2Rpdj4gIiwiPHByb2R1Y3QtbWFuYWdlbWVudD48L3Byb2R1Y3QtbWFuYWdlbWVudD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQXVaO01BQUE7TUFBK0Usc0NBQUM7VUFBQTsyRUFBQSxVQUFBO1VBQUE7Y0FBQSxnREFBK0U7VUFBQTtJQUFqRTtJQUFvQjtJQUFsQyxXQUFjLFVBQW9CLFNBQWxDOzs7O29CQUE5SDtNQUFBO01BQTZDLHNDQUFDO1VBQUEseUVBQUE7VUFBQTtVQUFBLDhDQUFjO01BQWlLOztJQUFqSztJQUFkLFdBQWMsU0FBZDs7OztvQkFBdUw7TUFBQTtNQUFBLDhCQUF3RSxzQ0FBQzthQUFBO1VBQUEsNENBQUk7TUFBQSw2QkFBMkI7Ozs7b0JBQVE7TUFBQTtNQUE2QyxzQ0FBQztVQUFBO1VBQUE7WUFBQTtZQUFBO1lBQXVCO2NBQUE7Y0FBQTtZQUFBO1lBQXZCO1VBQUE7YUFBQTtVQUFBLGlFQUF5RTtpQkFBQSx1QkFBeUI7OztJQUEzQztJQUF2RCxXQUF1RCxTQUF2RDs7OztvQkFBNXVCO01BQUE7UUFBQTtRQUFBO1FBQWU7VUFBQTtVQUFBO1FBQUE7UUFBZjtNQUFBLCtFQUFBO01BQUE7TUFBQSx5REFBMkc7TUFBQSxRQUFDO01BQUEsdUVBQStDO2FBQUEsdUJBQUM7TUFBQTtNQUFBLDhCQUE2QixzQ0FBQzthQUFBO1VBQUE7dUJBQUE7WUFBQTtZQUFBO1lBQW1CO2NBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBcUQ7Y0FBQTtjQUFBO1lBQUE7WUFBeEU7VUFBQTthQUFBO1VBQUE7VUFBQSw0QkFBeUosMEJBQXFCO1VBQUEsUUFBQztVQUFBLDJDQUFBO1VBQUEsc0VBQW9PO2lCQUFBLHVCQUFDO1VBQUEsMkRBQUE7VUFBQTtNQUErRyxzQ0FBQztVQUFBLHlFQUFBO1VBQUE7VUFBQSxlQUF1SixzQ0FBTztVQUFBLFFBQU87O0lBQTV5QjtJQUF2RCxXQUF1RCxTQUF2RDtJQUFvUjtJQUFsQjtJQUF4RSxXQUEwRixVQUFsQixTQUF4RTtJQUFvTDtJQUFMLFlBQUssU0FBTDtJQUFvUTtJQUEvQixZQUErQixTQUEvQjtJQUFxSDtJQUFMLFlBQUssU0FBTDs7O0lBQXhqQjtJQUExQixXQUEwQixTQUExQjs7OztvQkNBNUc7TUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBO2FBQUE7NEJBQUE7SUFBQTs7OzsifQ==
//# sourceMappingURL=productManagement.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/components/columns/column.directive.js
var column_directive = __webpack_require__("2LVV");
var column_directive_default = /*#__PURE__*/__webpack_require__.n(column_directive);

// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/components/columns/column-cell.directive.js
var column_cell_directive = __webpack_require__("2tXe");
var column_cell_directive_default = /*#__PURE__*/__webpack_require__.n(column_cell_directive);

// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/components/datatable.component.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var datatable_component_css_ngstyle_styles = ['.ngx-datatable{display:block;overflow:hidden;justify-content:center;position:relative;-webkit-transform:translateZ(0)}.ngx-datatable [hidden]{display:none!important}.ngx-datatable *,.ngx-datatable :after,.ngx-datatable :before{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box}.ngx-datatable.scroll-vertical .datatable-body{overflow-y:auto}.ngx-datatable.scroll-vertical .datatable-body .datatable-row-wrapper{position:absolute}.ngx-datatable.scroll-horz .datatable-body{overflow-x:auto;-webkit-overflow-scrolling:touch}.ngx-datatable.fixed-header .datatable-header .datatable-header-inner{white-space:nowrap}.ngx-datatable.fixed-header .datatable-header .datatable-header-inner .datatable-header-cell{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ngx-datatable.fixed-row .datatable-scroll,.ngx-datatable.fixed-row .datatable-scroll .datatable-body-row{white-space:nowrap}.ngx-datatable.fixed-row .datatable-scroll .datatable-body-row .datatable-body-cell,.ngx-datatable.fixed-row .datatable-scroll .datatable-body-row .datatable-body-group-cell{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ngx-datatable .datatable-body-row,.ngx-datatable .datatable-header-inner,.ngx-datatable .datatable-row-center{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;flex-direction:row;-webkit-flex-flow:row;-moz-flex-flow:row;-ms-flex-flow:row;-o-flex-flow:row;flex-flow:row}.ngx-datatable .datatable-body-cell,.ngx-datatable .datatable-header-cell{overflow-x:hidden;vertical-align:top;display:inline-block;line-height:1.625}.ngx-datatable .datatable-body-cell:focus,.ngx-datatable .datatable-header-cell:focus{outline:none}.ngx-datatable .datatable-row-left,.ngx-datatable .datatable-row-right{z-index:9}.ngx-datatable .datatable-row-center,.ngx-datatable .datatable-row-group,.ngx-datatable .datatable-row-left,.ngx-datatable .datatable-row-right{position:relative}.ngx-datatable .datatable-header{display:block;overflow:hidden}.ngx-datatable .datatable-header .datatable-header-inner{align-items:stretch;-webkit-align-items:stretch}.ngx-datatable .datatable-header .datatable-header-cell{position:relative;display:inline-block}.ngx-datatable .datatable-header .datatable-header-cell.sortable .datatable-header-cell-wrapper{cursor:pointer}.ngx-datatable .datatable-header .datatable-header-cell.longpress .datatable-header-cell-wrapper{cursor:move}.ngx-datatable .datatable-header .datatable-header-cell .sort-btn{line-height:100%;vertical-align:middle;display:inline-block;cursor:pointer}.ngx-datatable .datatable-header .datatable-header-cell .resize-handle,.ngx-datatable .datatable-header .datatable-header-cell .resize-handle--not-resizable{display:inline-block;position:absolute;right:0;top:0;bottom:0;width:5px;padding:0 4px;visibility:hidden}.ngx-datatable .datatable-header .datatable-header-cell .resize-handle{cursor:ew-resize}.ngx-datatable .datatable-header .datatable-header-cell.resizeable:hover .resize-handle,.ngx-datatable .datatable-header .datatable-header-cell:hover .resize-handle--not-resizable{visibility:visible}.ngx-datatable .datatable-header .datatable-header-cell .datatable-header-cell-template-wrap{height:inherit}.ngx-datatable .datatable-body{position:relative;z-index:10;display:block}.ngx-datatable .datatable-body .datatable-scroll{display:inline-block}.ngx-datatable .datatable-body .datatable-row-detail{overflow-y:hidden}.ngx-datatable .datatable-body .datatable-row-wrapper{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ngx-datatable .datatable-body .datatable-body-row{outline:none}.ngx-datatable .datatable-body .datatable-body-row>div{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex}.ngx-datatable .datatable-footer{display:block;width:100%}.ngx-datatable .datatable-footer .datatable-footer-inner{display:flex;align-items:center;width:100%}.ngx-datatable .datatable-footer .selected-count .page-count{flex:1 1 40%}.ngx-datatable .datatable-footer .selected-count .datatable-pager{flex:1 1 60%}.ngx-datatable .datatable-footer .page-count{flex:1 1 20%}.ngx-datatable .datatable-footer .datatable-pager{flex:1 1 80%;text-align:right}.ngx-datatable .datatable-footer .datatable-pager .pager,.ngx-datatable .datatable-footer .datatable-pager .pager li{padding:0;margin:0;display:inline-block;list-style:none}.ngx-datatable .datatable-footer .datatable-pager .pager li,.ngx-datatable .datatable-footer .datatable-pager .pager li a{outline:none}.ngx-datatable .datatable-footer .datatable-pager .pager li a{cursor:pointer;display:inline-block}.ngx-datatable .datatable-footer .datatable-pager .pager li.disabled a{cursor:not-allowed}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9kYXRhdGFibGUuY29tcG9uZW50LmNzcy5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9kYXRhdGFibGUuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=datatable.component.css.ngstyle.js.map
// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/components/header/header-cell.component.js
var header_cell_component = __webpack_require__("2xC4");
var header_cell_component_default = /*#__PURE__*/__webpack_require__.n(header_cell_component);

// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/components/header/header-cell.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_DataTableHeaderCellComponent = [];
var RenderType_DataTableHeaderCellComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableHeaderCellComponent, data: {} });
function View_DataTableHeaderCellComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'label', [['class',
                'datatable-checkbox']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'input', [['type', 'checkbox']], [[8, 'checked', 0]], [[null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (_co.select.emit(!_co.allRowsSelected) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['\n      ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.allRowsSelected;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_DataTableHeaderCellComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [['class',
                'datatable-header-cell-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n        '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'datatable-header-cell-label draggable']], [[8, 'innerHTML', 1]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onSort() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['\n        '])),
        (_l()(), core_es5["ɵted"](null, ['\n      ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.name;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_DataTableHeaderCellComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, ['\n      ']))], null, null);
}
function View_DataTableHeaderCellComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableHeaderCellComponent_4)), core_es5["ɵdid"](540672, null, 0, common_es5["NgTemplateOutlet"], [core_es5["ViewContainerRef"]], { ngTemplateOutletContext: [0, 'ngTemplateOutletContext'],
            ngTemplateOutlet: [1, 'ngTemplateOutlet'] }, null), (_l()(), core_es5["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.cellContext;
        var currVal_1 = _co.column.headerTemplate;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_DataTableHeaderCellComponent_0(_l) {
    return core_es5["ɵvid"](2, [(_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class', 'datatable-header-cell-template-wrap']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableHeaderCellComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableHeaderCellComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableHeaderCellComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [], [[8, 'className',
                    0]], [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.onSort() !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), (_l()(), core_es5["ɵted"](null, ['\n      '])),
        (_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isCheckboxable;
        _ck(_v, 4, 0, currVal_0);
        var currVal_1 = !_co.column.headerTemplate;
        _ck(_v, 7, 0, currVal_1);
        var currVal_2 = _co.column.headerTemplate;
        _ck(_v, 10, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = _co.sortClass;
        _ck(_v, 12, 0, currVal_3);
    });
}
function View_DataTableHeaderCellComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'datatable-header-cell', [['class', 'datatable-header-cell']], [[4, 'height', 'px'], [8, 'className', 0], [1,
                'title', 0], [4, 'minWidth', 'px'], [4, 'maxWidth', 'px'], [4, 'width', 'px']], [[null,
                'contextmenu']], function (_v, en, $event) {
            var ad = true;
            if (('contextmenu' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onContextmenu($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_DataTableHeaderCellComponent_0, RenderType_DataTableHeaderCellComponent)),
        core_es5["ɵdid"](49152, null, 0, header_cell_component["DataTableHeaderCellComponent"], [core_es5["ChangeDetectorRef"]], null, null)], null, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).headerHeight;
        var currVal_1 = core_es5["ɵnov"](_v, 1).columnCssClasses;
        var currVal_2 = core_es5["ɵnov"](_v, 1).name;
        var currVal_3 = core_es5["ɵnov"](_v, 1).minWidth;
        var currVal_4 = core_es5["ɵnov"](_v, 1).maxWidth;
        var currVal_5 = core_es5["ɵnov"](_v, 1).width;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    });
}
var DataTableHeaderCellComponentNgFactory = core_es5["ɵccf"]('datatable-header-cell', header_cell_component["DataTableHeaderCellComponent"], View_DataTableHeaderCellComponent_Host_0, { sortType: 'sortType',
    sortAscendingIcon: 'sortAscendingIcon', sortDescendingIcon: 'sortDescendingIcon',
    allRowsSelected: 'allRowsSelected', selectionType: 'selectionType', column: 'column',
    headerHeight: 'headerHeight', sorts: 'sorts' }, { sort: 'sort', select: 'select', columnContextmenu: 'columnContextmenu' }, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9oZWFkZXIvaGVhZGVyLWNlbGwuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvaGVhZGVyL2hlYWRlci1jZWxsLmNvbXBvbmVudC5kLnRzIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9oZWFkZXIvaGVhZGVyLWNlbGwuY29tcG9uZW50LmQudHMuRGF0YVRhYmxlSGVhZGVyQ2VsbENvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9oZWFkZXIvaGVhZGVyLWNlbGwuY29tcG9uZW50LmQudHMuRGF0YVRhYmxlSGVhZGVyQ2VsbENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxkaXYgY2xhc3M9XCJkYXRhdGFibGUtaGVhZGVyLWNlbGwtdGVtcGxhdGUtd3JhcFwiPlxuICAgICAgPGxhYmVsXG4gICAgICAgICpuZ0lmPVwiaXNDaGVja2JveGFibGVcIlxuICAgICAgICBjbGFzcz1cImRhdGF0YWJsZS1jaGVja2JveFwiPlxuICAgICAgICA8aW5wdXRcbiAgICAgICAgICB0eXBlPVwiY2hlY2tib3hcIlxuICAgICAgICAgIFtjaGVja2VkXT1cImFsbFJvd3NTZWxlY3RlZFwiXG4gICAgICAgICAgKGNoYW5nZSk9XCJzZWxlY3QuZW1pdCghYWxsUm93c1NlbGVjdGVkKVwiXG4gICAgICAgIC8+XG4gICAgICA8L2xhYmVsPlxuICAgICAgPHNwYW5cbiAgICAgICAgKm5nSWY9XCIhY29sdW1uLmhlYWRlclRlbXBsYXRlXCJcbiAgICAgICAgY2xhc3M9XCJkYXRhdGFibGUtaGVhZGVyLWNlbGwtd3JhcHBlclwiPlxuICAgICAgICA8c3BhblxuICAgICAgICAgIGNsYXNzPVwiZGF0YXRhYmxlLWhlYWRlci1jZWxsLWxhYmVsIGRyYWdnYWJsZVwiXG4gICAgICAgICAgKGNsaWNrKT1cIm9uU29ydCgpXCJcbiAgICAgICAgICBbaW5uZXJIVE1MXT1cIm5hbWVcIj5cbiAgICAgICAgPC9zcGFuPlxuICAgICAgPC9zcGFuPlxuICAgICAgPG5nLXRlbXBsYXRlXG4gICAgICAgICpuZ0lmPVwiY29sdW1uLmhlYWRlclRlbXBsYXRlXCJcbiAgICAgICAgW25nVGVtcGxhdGVPdXRsZXRdPVwiY29sdW1uLmhlYWRlclRlbXBsYXRlXCJcbiAgICAgICAgW25nVGVtcGxhdGVPdXRsZXRDb250ZXh0XT1cImNlbGxDb250ZXh0XCI+XG4gICAgICA8L25nLXRlbXBsYXRlPlxuICAgICAgPHNwYW5cbiAgICAgICAgKGNsaWNrKT1cIm9uU29ydCgpXCJcbiAgICAgICAgW2NsYXNzXT1cInNvcnRDbGFzc1wiPlxuICAgICAgPC9zcGFuPlxuICAgIDwvZGl2PlxuICAiLCI8ZGF0YXRhYmxlLWhlYWRlci1jZWxsPjwvZGF0YXRhYmxlLWhlYWRlci1jZWxsPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OztvQkNFTTtNQUFBO01BQUEsZ0JBRTZCLCtDQUMzQjtNQUFBO01BQUE7UUFBQTtRQUFBO1FBR0U7VUFBQTtVQUFBO1FBQUE7UUFIRjtNQUFBLGdDQUlFOzs7UUFGQTtRQUZGLFdBRUUsU0FGRjs7OztvQkFNRjtNQUFBO01BQUEsOEJBRXdDO01BQ3RDO1VBQUE7WUFBQTtZQUFBO1lBRUU7Y0FBQTtjQUFBO1lBQUE7WUFGRjtVQUFBLGdDQUdxQjtNQUNkOztJQURMO0lBSEYsV0FHRSxTQUhGOzs7O29CQVN3Qzs7O29CQUgxQztNQUFBLDZDQUFBO01BQUE7VUFBQTs7O0lBR0U7SUFEQTtJQUZGLFdBR0UsVUFEQSxTQUZGOzs7O29CQXBCTiwyQ0FDSTtNQUFBO01BQUEsMERBQWlEO01BQUEsZUFDL0M7TUFBQSw2Q0FBQTtNQUFBLHNFQVFRO2FBQUEsOEJBQ1I7TUFBQSwyRUFBQTtNQUFBO01BQUEsZUFRTyw2Q0FDUDtNQUFBO2FBQUE7VUFBQSx3QkFJYyw2Q0FDZDtpQkFBQTtjQUFBO1lBQUE7WUFBQTtZQUNFO2NBQUE7Y0FBQTtZQUFBO1lBREY7VUFBQSxnQ0FFc0I7TUFDZiwyQ0FDSDs7O1FBMUJGO1FBREYsV0FDRSxTQURGO1FBVUU7UUFERixXQUNFLFNBREY7UUFVRTtRQURGLFlBQ0UsU0FERjs7O1FBT0U7UUFGRixZQUVFLFNBRkY7Ozs7b0JDekJOO01BQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO01BQUE7YUFBQTtVQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsV0FBQSwyREFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=header-cell.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/directives/draggable.directive.js
var draggable_directive = __webpack_require__("Z9jN");
var draggable_directive_default = /*#__PURE__*/__webpack_require__.n(draggable_directive);

// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/directives/resizeable.directive.js
var resizeable_directive = __webpack_require__("JMlz");
var resizeable_directive_default = /*#__PURE__*/__webpack_require__.n(resizeable_directive);

// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/directives/long-press.directive.js
var long_press_directive = __webpack_require__("QIkZ");
var long_press_directive_default = /*#__PURE__*/__webpack_require__.n(long_press_directive);

// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/components/header/header.component.js
var header_component = __webpack_require__("0dt4");
var header_component_default = /*#__PURE__*/__webpack_require__.n(header_component);

// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/directives/orderable.directive.js
var orderable_directive = __webpack_require__("icKY");
var orderable_directive_default = /*#__PURE__*/__webpack_require__.n(orderable_directive);

// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/components/header/header.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_DataTableHeaderComponent = [];
var RenderType_DataTableHeaderComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableHeaderComponent, data: {} });
function View_DataTableHeaderComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'datatable-header-cell', [['class', 'datatable-header-cell'], ['draggable', ''], ['long-press', ''], ['resizeable',
                '']], [[2, 'resizeable', null], [2, 'press', null], [2, 'longpress',
                null], [4, 'height', 'px'], [8, 'className', 0], [1, 'title', 0], [4, 'minWidth',
                'px'], [4, 'maxWidth', 'px'], [4, 'width', 'px']], [[null, 'resize'], [null,
                'longPressStart'], [null, 'longPressEnd'], [null, 'sort'],
            [null, 'select'], [null, 'columnContextmenu'], [null,
                'mousedown'], [null, 'contextmenu']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 2).onMousedown($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('mousedown' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 3).onMouseDown($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('contextmenu' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 4).onContextmenu($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('resize' === en)) {
                var pd_3 = (_co.onColumnResized($event, _v.context.$implicit) !== false);
                ad = (pd_3 && ad);
            }
            if (('longPressStart' === en)) {
                var pd_4 = (_co.onLongPressStart($event) !== false);
                ad = (pd_4 && ad);
            }
            if (('longPressEnd' === en)) {
                var pd_5 = (_co.onLongPressEnd($event) !== false);
                ad = (pd_5 && ad);
            }
            if (('sort' === en)) {
                var pd_6 = (_co.onSort($event) !== false);
                ad = (pd_6 && ad);
            }
            if (('select' === en)) {
                var pd_7 = (_co.select.emit($event) !== false);
                ad = (pd_7 && ad);
            }
            if (('columnContextmenu' === en)) {
                var pd_8 = (_co.columnContextmenu.emit($event) !== false);
                ad = (pd_8 && ad);
            }
            return ad;
        }, View_DataTableHeaderCellComponent_0, RenderType_DataTableHeaderCellComponent)),
        core_es5["ɵdid"](671744, [[1, 4]], 0, draggable_directive["DraggableDirective"], [core_es5["ElementRef"]], { dragEventTarget: [0,
                'dragEventTarget'], dragModel: [1, 'dragModel'], dragX: [2, 'dragX'], dragY: [3,
                'dragY'] }, null), core_es5["ɵdid"](4341760, null, 0, resizeable_directive["ResizeableDirective"], [core_es5["ElementRef"], core_es5["Renderer2"]], { resizeEnabled: [0, 'resizeEnabled'] }, { resize: 'resize' }),
        core_es5["ɵdid"](147456, null, 0, long_press_directive["LongPressDirective"], [], { pressEnabled: [0,
                'pressEnabled'], pressModel: [1, 'pressModel'] }, { longPressStart: 'longPressStart',
            longPressEnd: 'longPressEnd' }), core_es5["ɵdid"](49152, null, 0, header_cell_component["DataTableHeaderCellComponent"], [core_es5["ChangeDetectorRef"]], { sortType: [0, 'sortType'], sortAscendingIcon: [1, 'sortAscendingIcon'],
            sortDescendingIcon: [2, 'sortDescendingIcon'], allRowsSelected: [3, 'allRowsSelected'],
            selectionType: [4, 'selectionType'], column: [5, 'column'], headerHeight: [6,
                'headerHeight'], sorts: [7, 'sorts'] }, { sort: 'sort', select: 'select',
            columnContextmenu: 'columnContextmenu' }), (_l()(), core_es5["ɵted"](null, ['\n        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_9 = _co.dragEventTarget;
        var currVal_10 = _v.context.$implicit;
        var currVal_11 = ((_co.reorderable && _v.context.$implicit.draggable) && _v.context.$implicit.dragging);
        var currVal_12 = false;
        _ck(_v, 1, 0, currVal_9, currVal_10, currVal_11, currVal_12);
        var currVal_13 = _v.context.$implicit.resizeable;
        _ck(_v, 2, 0, currVal_13);
        var currVal_14 = (_co.reorderable && _v.context.$implicit.draggable);
        var currVal_15 = _v.context.$implicit;
        _ck(_v, 3, 0, currVal_14, currVal_15);
        var currVal_16 = _co.sortType;
        var currVal_17 = _co.sortAscendingIcon;
        var currVal_18 = _co.sortDescendingIcon;
        var currVal_19 = _co.allRowsSelected;
        var currVal_20 = _co.selectionType;
        var currVal_21 = _v.context.$implicit;
        var currVal_22 = _co.headerHeight;
        var currVal_23 = _co.sorts;
        _ck(_v, 4, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 2).resizeEnabled;
        var currVal_1 = core_es5["ɵnov"](_v, 3).press;
        var currVal_2 = core_es5["ɵnov"](_v, 3).isLongPress;
        var currVal_3 = core_es5["ɵnov"](_v, 4).headerHeight;
        var currVal_4 = core_es5["ɵnov"](_v, 4).columnCssClasses;
        var currVal_5 = core_es5["ɵnov"](_v, 4).name;
        var currVal_6 = core_es5["ɵnov"](_v, 4).minWidth;
        var currVal_7 = core_es5["ɵnov"](_v, 4).maxWidth;
        var currVal_8 = core_es5["ɵnov"](_v, 4).width;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    });
}
function View_DataTableHeaderComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [], [[8, 'className', 0]], null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableHeaderComponent_2)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'], ngForTrackBy: [1, 'ngForTrackBy'] }, null), (_l()(), core_es5["ɵted"](null, ['\n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co._styleByGroup[_v.context.$implicit.type];
        _ck(_v, 1, 0, currVal_1);
        var currVal_2 = _v.context.$implicit.columns;
        var currVal_3 = _co.columnTrackingFn;
        _ck(_v, 4, 0, currVal_2, currVal_3);
    }, function (_ck, _v) {
        var currVal_0 = ('datatable-row-' + _v.context.$implicit.type);
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_DataTableHeaderComponent_0(_l) {
    return core_es5["ɵvid"](2, [(_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'datatable-header-inner'], ['orderable', '']], [[4, 'width', 'px']], [[null, 'reorder']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('reorder' === en)) {
                var pd_0 = (_co.onColumnReordered($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1196032, null, 1, orderable_directive["OrderableDirective"], [core_es5["KeyValueDiffers"], platform_browser_es5["DOCUMENT"]], null, { reorder: 'reorder' }), core_es5["ɵqud"](603979776, 1, { draggables: 1 }), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableHeaderComponent_1)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'], ngForTrackBy: [1, 'ngForTrackBy'] }, null), (_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co._columnsByPin;
        var currVal_2 = _co.trackByGroups;
        _ck(_v, 6, 0, currVal_1, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co._columnGroupWidths.total;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_DataTableHeaderComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'datatable-header', [['class', 'datatable-header']], [[4, 'height', null], [4, 'width', null]], null, null, View_DataTableHeaderComponent_0, RenderType_DataTableHeaderComponent)),
        core_es5["ɵdid"](49152, null, 0, header_component["DataTableHeaderComponent"], [core_es5["ChangeDetectorRef"]], null, null)], null, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).headerHeight;
        var currVal_1 = core_es5["ɵnov"](_v, 1).headerWidth;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
var DataTableHeaderComponentNgFactory = core_es5["ɵccf"]('datatable-header', header_component["DataTableHeaderComponent"], View_DataTableHeaderComponent_Host_0, { sortAscendingIcon: 'sortAscendingIcon',
    sortDescendingIcon: 'sortDescendingIcon', scrollbarH: 'scrollbarH', dealsWithGroup: 'dealsWithGroup',
    innerWidth: 'innerWidth', sorts: 'sorts', sortType: 'sortType', allRowsSelected: 'allRowsSelected',
    selectionType: 'selectionType', reorderable: 'reorderable', headerHeight: 'headerHeight',
    columns: 'columns', offsetX: 'offsetX' }, { sort: 'sort', reorder: 'reorder', resize: 'resize',
    select: 'select', columnContextmenu: 'columnContextmenu' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=header.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/components/footer/pager.component.js
var pager_component = __webpack_require__("4gpe");
var pager_component_default = /*#__PURE__*/__webpack_require__.n(pager_component);

// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/components/footer/pager.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_DataTablePagerComponent = [];
var RenderType_DataTablePagerComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTablePagerComponent, data: {} });
function View_DataTablePagerComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'li', [['class',
                'pages'], ['role', 'button']], [[1, 'aria-label', 0], [2, 'active', null]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href',
                'javascript:void(0)']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectPage(_v.context.$implicit.number) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['\n          ', '\n        '])),
        (_l()(), core_es5["ɵted"](null, ['\n      ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ('page ' + _v.context.$implicit.number);
        var currVal_1 = (_v.context.$implicit.number === _co.page);
        _ck(_v, 0, 0, currVal_0, currVal_1);
        var currVal_2 = _v.context.$implicit.text;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_DataTablePagerComponent_0(_l) {
    return core_es5["ɵvid"](2, [(_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵeld"](0, null, null, 36, 'ul', [['class', 'pager']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 6, 'li', [], [[2, 'disabled', null]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'a', [['aria-label',
                'go to first page'], ['href', 'javascript:void(0)'], ['role', 'button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectPage(1) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['\n          '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'i', [], [[8, 'className',
                0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], [[2, 'disabled', null]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'a', [['aria-label', 'go to previous page'],
            ['href', 'javascript:void(0)'], ['role', 'button']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.prevPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['\n          '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'i', [], [[8, 'className',
                0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTablePagerComponent_1)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], [[2, 'disabled', null]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'a', [['aria-label',
                'go to next page'], ['href', 'javascript:void(0)'], ['role', 'button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.nextPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['\n          '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'i', [], [[8, 'className',
                0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], [[2, 'disabled', null]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'a', [['aria-label', 'go to last page'], ['href',
                'javascript:void(0)'], ['role', 'button']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectPage(_co.totalPages) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['\n          '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'i', [], [[8, 'className',
                0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_4 = _co.pages;
        _ck(_v, 20, 0, currVal_4);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.canPrevious();
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = core_es5["ɵinlineInterpolate"](1, '', _co.pagerPreviousIcon, '');
        _ck(_v, 7, 0, currVal_1);
        var currVal_2 = !_co.canPrevious();
        _ck(_v, 11, 0, currVal_2);
        var currVal_3 = core_es5["ɵinlineInterpolate"](1, '', _co.pagerLeftArrowIcon, '');
        _ck(_v, 15, 0, currVal_3);
        var currVal_5 = !_co.canNext();
        _ck(_v, 22, 0, currVal_5);
        var currVal_6 = core_es5["ɵinlineInterpolate"](1, '', _co.pagerRightArrowIcon, '');
        _ck(_v, 26, 0, currVal_6);
        var currVal_7 = !_co.canNext();
        _ck(_v, 30, 0, currVal_7);
        var currVal_8 = core_es5["ɵinlineInterpolate"](1, '', _co.pagerNextIcon, '');
        _ck(_v, 34, 0, currVal_8);
    });
}
function View_DataTablePagerComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'datatable-pager', [['class', 'datatable-pager']], null, null, null, View_DataTablePagerComponent_0, RenderType_DataTablePagerComponent)), core_es5["ɵdid"](49152, null, 0, pager_component["DataTablePagerComponent"], [], null, null)], null, null);
}
var DataTablePagerComponentNgFactory = core_es5["ɵccf"]('datatable-pager', pager_component["DataTablePagerComponent"], View_DataTablePagerComponent_Host_0, { pagerLeftArrowIcon: 'pagerLeftArrowIcon',
    pagerRightArrowIcon: 'pagerRightArrowIcon', pagerPreviousIcon: 'pagerPreviousIcon',
    pagerNextIcon: 'pagerNextIcon', size: 'size', count: 'count', page: 'page' }, { change: 'change' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=pager.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/components/footer/footer.component.js
var footer_component = __webpack_require__("bYJ/");
var footer_component_default = /*#__PURE__*/__webpack_require__.n(footer_component);

// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/components/footer/footer.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_DataTableFooterComponent = [];
var RenderType_DataTableFooterComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableFooterComponent, data: {} });
function View_DataTableFooterComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, ['\n      ']))], null, null);
}
function View_DataTableFooterComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_DataTableFooterComponent_2)), core_es5["ɵdid"](540672, null, 0, common_es5["NgTemplateOutlet"], [core_es5["ViewContainerRef"]], { ngTemplateOutletContext: [0, 'ngTemplateOutletContext'],
            ngTemplateOutlet: [1, 'ngTemplateOutlet'] }, null), core_es5["ɵpod"]({ rowCount: 0,
            pageSize: 1, selectedCount: 2, curPage: 3, offset: 4 }), (_l()(), core_es5["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, _co.rowCount, _co.pageSize, _co.selectedCount, _co.curPage, _co.offset);
        var currVal_1 = _co.footerTemplate.template;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_DataTableFooterComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['\n          ', ' ', ' / \n        ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.selectedCount.toLocaleString();
        var currVal_1 = _co.selectedMessage;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    });
}
function View_DataTableFooterComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'page-count']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableFooterComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n        ', ' ', '\n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.selectedMessage;
        _ck(_v, 3, 0, currVal_0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.rowCount.toLocaleString();
        var currVal_2 = _co.totalMessage;
        _ck(_v, 4, 0, currVal_1, currVal_2);
    });
}
function View_DataTableFooterComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'datatable-pager', [['class', 'datatable-pager']], [[8, 'hidden', 0]], [[null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (_co.page.emit($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_DataTablePagerComponent_0, RenderType_DataTablePagerComponent)),
        core_es5["ɵdid"](49152, null, 0, pager_component["DataTablePagerComponent"], [], { pagerLeftArrowIcon: [0,
                'pagerLeftArrowIcon'], pagerRightArrowIcon: [1, 'pagerRightArrowIcon'], pagerPreviousIcon: [2,
                'pagerPreviousIcon'], pagerNextIcon: [3, 'pagerNextIcon'], size: [4, 'size'], count: [5,
                'count'], page: [6, 'page'] }, { change: 'change' }), (_l()(), core_es5["ɵted"](null, ['\n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.pagerLeftArrowIcon;
        var currVal_2 = _co.pagerRightArrowIcon;
        var currVal_3 = _co.pagerPreviousIcon;
        var currVal_4 = _co.pagerNextIcon;
        var currVal_5 = _co.pageSize;
        var currVal_6 = _co.rowCount;
        var currVal_7 = _co.curPage;
        _ck(_v, 1, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.isVisible;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_DataTableFooterComponent_0(_l) {
    return core_es5["ɵvid"](2, [(_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'datatable-footer-inner']], [[4, 'height', 'px']], null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'selected-count': 0 }),
        (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableFooterComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableFooterComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableFooterComponent_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(),
            core_es5["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'datatable-footer-inner';
        var currVal_2 = _ck(_v, 3, 0, _co.selectedMessage);
        _ck(_v, 2, 0, currVal_1, currVal_2);
        var currVal_3 = _co.footerTemplate;
        _ck(_v, 6, 0, currVal_3);
        var currVal_4 = !_co.footerTemplate;
        _ck(_v, 9, 0, currVal_4);
        var currVal_5 = !_co.footerTemplate;
        _ck(_v, 12, 0, currVal_5);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.footerHeight;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_DataTableFooterComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'datatable-footer', [['class', 'datatable-footer']], null, null, null, View_DataTableFooterComponent_0, RenderType_DataTableFooterComponent)), core_es5["ɵdid"](49152, null, 0, footer_component["DataTableFooterComponent"], [], null, null)], null, null);
}
var DataTableFooterComponentNgFactory = core_es5["ɵccf"]('datatable-footer', footer_component["DataTableFooterComponent"], View_DataTableFooterComponent_Host_0, { footerHeight: 'footerHeight',
    rowCount: 'rowCount', pageSize: 'pageSize', offset: 'offset', pagerLeftArrowIcon: 'pagerLeftArrowIcon',
    pagerRightArrowIcon: 'pagerRightArrowIcon', pagerPreviousIcon: 'pagerPreviousIcon',
    pagerNextIcon: 'pagerNextIcon', totalMessage: 'totalMessage', footerTemplate: 'footerTemplate',
    selectedCount: 'selectedCount', selectedMessage: 'selectedMessage' }, { page: 'page' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=footer.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/components/datatable.component.js
var datatable_component = __webpack_require__("sQpZ");
var datatable_component_default = /*#__PURE__*/__webpack_require__.n(datatable_component);

// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/directives/visibility.directive.js
var visibility_directive = __webpack_require__("y7Yj");
var visibility_directive_default = /*#__PURE__*/__webpack_require__.n(visibility_directive);

// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/components/body/progress-bar.component.js
var progress_bar_component = __webpack_require__("/UE+");
var progress_bar_component_default = /*#__PURE__*/__webpack_require__.n(progress_bar_component);

// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/components/body/progress-bar.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


var styles_ProgressBarComponent = [];
var RenderType_ProgressBarComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ProgressBarComponent, data: {} });
function View_ProgressBarComponent_0(_l) {
    return core_es5["ɵvid"](2, [(_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'progress-linear'], ['role', 'progressbar']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class',
                'container']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'bar']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n      '])),
        (_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵted"](null, ['\n  ']))], null, null);
}
function View_ProgressBarComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'datatable-progress', [], null, null, null, View_ProgressBarComponent_0, RenderType_ProgressBarComponent)), core_es5["ɵdid"](49152, null, 0, progress_bar_component["ProgressBarComponent"], [], null, null)], null, null);
}
var ProgressBarComponentNgFactory = core_es5["ɵccf"]('datatable-progress', progress_bar_component["ProgressBarComponent"], View_ProgressBarComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3Byb2dyZXNzLWJhci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3Byb2dyZXNzLWJhci5jb21wb25lbnQuZC50cyIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvYm9keS9wcm9ncmVzcy1iYXIuY29tcG9uZW50LmQudHMuUHJvZ3Jlc3NCYXJDb21wb25lbnQuaHRtbCIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvYm9keS9wcm9ncmVzcy1iYXIuY29tcG9uZW50LmQudHMuUHJvZ3Jlc3NCYXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbiAgICA8ZGl2IGNsYXNzPVwicHJvZ3Jlc3MtbGluZWFyXCIgcm9sZT1cInByb2dyZXNzYmFyXCI+XG4gICAgICA8ZGl2IGNsYXNzPVwiY29udGFpbmVyXCI+XG4gICAgICAgIDxkaXYgY2xhc3M9XCJiYXJcIj48L2Rpdj5cbiAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuICAiLCI8ZGF0YXRhYmxlLXByb2dyZXNzPjwvZGF0YXRhYmxlLXByb2dyZXNzPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7O29CQ0FBLDJDQUNJO01BQUE7TUFBQSwwREFBZ0Q7TUFBQSxlQUM5QztNQUFBO01BQXVCLCtDQUNyQjtVQUFBO1VBQUEsOEJBQXVCO01BQ25CLDJDQUNGOzs7O29CQ0xWO01BQUE7cUNBQUEsVUFBQTtNQUFBOzs7In0=
//# sourceMappingURL=progress-bar.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/components/body/body-cell.component.js
var body_cell_component = __webpack_require__("C8Kb");
var body_cell_component_default = /*#__PURE__*/__webpack_require__.n(body_cell_component);

// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/components/body/body-cell.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_DataTableBodyCellComponent = [];
var RenderType_DataTableBodyCellComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableBodyCellComponent, data: {} });
function View_DataTableBodyCellComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'label', [['class',
                'datatable-checkbox']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'input', [['type', 'checkbox']], [[8, 'checked', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onCheckboxChange($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['\n      ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isSelected;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_DataTableBodyCellComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], [[8, 'title', 0], [8, 'innerHTML', 1]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n      ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.sanitizedValue;
        var currVal_1 = _co.value;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
function View_DataTableBodyCellComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, ['\n      ']))], null, null);
}
function View_DataTableBodyCellComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵand"](16777216, [[1, 3], ['cellTemplate', 2]], null, 1, null, View_DataTableBodyCellComponent_4)), core_es5["ɵdid"](540672, null, 0, common_es5["NgTemplateOutlet"], [core_es5["ViewContainerRef"]], { ngTemplateOutletContext: [0, 'ngTemplateOutletContext'],
            ngTemplateOutlet: [1, 'ngTemplateOutlet'] }, null), (_l()(), core_es5["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.cellContext;
        var currVal_1 = _co.column.cellTemplate;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_DataTableBodyCellComponent_0(_l) {
    return core_es5["ɵvid"](2, [core_es5["ɵqud"](671088640, 1, { cellTemplate: 0 }), (_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class',
                'datatable-body-cell-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableBodyCellComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableBodyCellComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableBodyCellComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(),
            core_es5["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.column.checkboxable && (!_co.displayCheck || _co.displayCheck(_co.row, _co.column, _co.value)));
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = !_co.column.cellTemplate;
        _ck(_v, 8, 0, currVal_1);
        var currVal_2 = _co.column.cellTemplate;
        _ck(_v, 11, 0, currVal_2);
    }, null);
}
function View_DataTableBodyCellComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'datatable-body-cell', [], [[8, 'className', 0], [4, 'width', 'px'], [4, 'height', null]], [[null, 'focus'], [null, 'blur'], [null, 'click'], [null,
                'dblclick'], [null, 'keydown']], function (_v, en, $event) {
            var ad = true;
            if (('focus' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onFocus() !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 1).onBlur() !== false);
                ad = (pd_1 && ad);
            }
            if (('click' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('dblclick' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 1).onDblClick($event) !== false);
                ad = (pd_3 && ad);
            }
            if (('keydown' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 1).onKeyDown($event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, View_DataTableBodyCellComponent_0, RenderType_DataTableBodyCellComponent)),
        core_es5["ɵdid"](442368, null, 0, body_cell_component["DataTableBodyCellComponent"], [core_es5["ElementRef"],
            core_es5["ChangeDetectorRef"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).columnCssClasses;
        var currVal_1 = core_es5["ɵnov"](_v, 1).width;
        var currVal_2 = core_es5["ɵnov"](_v, 1).height;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2);
    });
}
var DataTableBodyCellComponentNgFactory = core_es5["ɵccf"]('datatable-body-cell', body_cell_component["DataTableBodyCellComponent"], View_DataTableBodyCellComponent_Host_0, { displayCheck: 'displayCheck',
    group: 'group', rowHeight: 'rowHeight', isSelected: 'isSelected', expanded: 'expanded',
    rowIndex: 'rowIndex', column: 'column', row: 'row', sorts: 'sorts' }, { activate: 'activate' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=body-cell.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/components/body/body-row.component.js
var body_row_component = __webpack_require__("UHPl");
var body_row_component_default = /*#__PURE__*/__webpack_require__.n(body_row_component);

// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/services/scrollbar-helper.service.js
var scrollbar_helper_service = __webpack_require__("214W");
var scrollbar_helper_service_default = /*#__PURE__*/__webpack_require__.n(scrollbar_helper_service);

// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/components/body/body-row.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_DataTableBodyRowComponent = [];
var RenderType_DataTableBodyRowComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableBodyRowComponent, data: {} });
function View_DataTableBodyRowComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'datatable-body-cell', [['tabindex', '-1']], [[8, 'className', 0], [4, 'width', 'px'], [4, 'height', null]], [[null, 'activate'], [null, 'focus'], [null, 'blur'], [null,
                'click'], [null, 'dblclick'], [null, 'keydown']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('focus' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onFocus() !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 1).onBlur() !== false);
                ad = (pd_1 && ad);
            }
            if (('click' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('dblclick' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 1).onDblClick($event) !== false);
                ad = (pd_3 && ad);
            }
            if (('keydown' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 1).onKeyDown($event) !== false);
                ad = (pd_4 && ad);
            }
            if (('activate' === en)) {
                var pd_5 = (_co.onActivate($event, _v.context.index) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, View_DataTableBodyCellComponent_0, RenderType_DataTableBodyCellComponent)),
        core_es5["ɵdid"](442368, null, 0, body_cell_component["DataTableBodyCellComponent"], [core_es5["ElementRef"],
            core_es5["ChangeDetectorRef"]], { displayCheck: [0, 'displayCheck'], group: [1, 'group'],
            rowHeight: [2, 'rowHeight'], isSelected: [3, 'isSelected'], expanded: [4, 'expanded'],
            rowIndex: [5, 'rowIndex'], column: [6, 'column'], row: [7, 'row'] }, { activate: 'activate' }),
        (_l()(), core_es5["ɵted"](null, ['\n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = _co.displayCheck;
        var currVal_4 = _co.group;
        var currVal_5 = _co.rowHeight;
        var currVal_6 = _co.isSelected;
        var currVal_7 = _co.expanded;
        var currVal_8 = _co.rowIndex;
        var currVal_9 = _v.context.$implicit;
        var currVal_10 = _co.row;
        _ck(_v, 1, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).columnCssClasses;
        var currVal_1 = core_es5["ɵnov"](_v, 1).width;
        var currVal_2 = core_es5["ɵnov"](_v, 1).height;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2);
    });
}
function View_DataTableBodyRowComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [], [[8, 'className', 0]], null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableBodyRowComponent_2)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'],
            ngForTrackBy: [1, 'ngForTrackBy'] }, null), (_l()(), core_es5["ɵted"](null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co._groupStyles[_v.context.$implicit.type];
        _ck(_v, 1, 0, currVal_1);
        var currVal_2 = _v.context.$implicit.columns;
        var currVal_3 = _co.columnTrackingFn;
        _ck(_v, 4, 0, currVal_2, currVal_3);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, 'datatable-row-', _v.context.$implicit.type, ' datatable-row-group');
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_DataTableBodyRowComponent_0(_l) {
    return core_es5["ɵvid"](2, [(_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableBodyRowComponent_1)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'], ngForTrackBy: [1, 'ngForTrackBy'] }, null), (_l()(), core_es5["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co._columnsByPin;
        var currVal_1 = _co.trackByGroups;
        _ck(_v, 2, 0, currVal_0, currVal_1);
    }, null);
}
function View_DataTableBodyRowComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'datatable-body-row', [], [[8, 'className', 0], [4, 'height', 'px'], [4, 'width', 'px']], [[null,
                'keydown'], [null, 'mouseenter']], function (_v, en, $event) {
            var ad = true;
            if (('keydown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onKeyDown($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('mouseenter' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 1).onMouseenter($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_DataTableBodyRowComponent_0, RenderType_DataTableBodyRowComponent)), core_es5["ɵdid"](311296, null, 0, body_row_component["DataTableBodyRowComponent"], [core_es5["KeyValueDiffers"], [1, scrollbar_helper_service["ScrollbarHelper"]],
            core_es5["ChangeDetectorRef"], core_es5["ElementRef"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).cssClass;
        var currVal_1 = core_es5["ɵnov"](_v, 1).rowHeight;
        var currVal_2 = core_es5["ɵnov"](_v, 1).columnsTotalWidths;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2);
    });
}
var DataTableBodyRowComponentNgFactory = core_es5["ɵccf"]('datatable-body-row', body_row_component["DataTableBodyRowComponent"], View_DataTableBodyRowComponent_Host_0, { columns: 'columns',
    innerWidth: 'innerWidth', expanded: 'expanded', rowClass: 'rowClass', row: 'row',
    group: 'group', isSelected: 'isSelected', rowIndex: 'rowIndex', displayCheck: 'displayCheck',
    offsetX: 'offsetX', rowHeight: 'rowHeight' }, { activate: 'activate' }, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L2JvZHktcm93LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvYm9keS1yb3cuY29tcG9uZW50LmQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvYm9keS1yb3cuY29tcG9uZW50LmQudHMuRGF0YVRhYmxlQm9keVJvd0NvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L2JvZHktcm93LmNvbXBvbmVudC5kLnRzLkRhdGFUYWJsZUJvZHlSb3dDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbiAgICA8ZGl2XG4gICAgICAqbmdGb3I9XCJsZXQgY29sR3JvdXAgb2YgX2NvbHVtbnNCeVBpbjsgbGV0IGkgPSBpbmRleDsgdHJhY2tCeTogdHJhY2tCeUdyb3Vwc1wiXG4gICAgICBjbGFzcz1cImRhdGF0YWJsZS1yb3cte3tjb2xHcm91cC50eXBlfX0gZGF0YXRhYmxlLXJvdy1ncm91cFwiXG4gICAgICBbbmdTdHlsZV09XCJfZ3JvdXBTdHlsZXNbY29sR3JvdXAudHlwZV1cIj5cbiAgICAgIDxkYXRhdGFibGUtYm9keS1jZWxsXG4gICAgICAgICpuZ0Zvcj1cImxldCBjb2x1bW4gb2YgY29sR3JvdXAuY29sdW1uczsgbGV0IGlpID0gaW5kZXg7IHRyYWNrQnk6IGNvbHVtblRyYWNraW5nRm5cIlxuICAgICAgICB0YWJpbmRleD1cIi0xXCJcbiAgICAgICAgW3Jvd109XCJyb3dcIlxuICAgICAgICBbZ3JvdXBdPVwiZ3JvdXBcIlxuICAgICAgICBbZXhwYW5kZWRdPVwiZXhwYW5kZWRcIlxuICAgICAgICBbaXNTZWxlY3RlZF09XCJpc1NlbGVjdGVkXCJcbiAgICAgICAgW3Jvd0luZGV4XT1cInJvd0luZGV4XCJcbiAgICAgICAgW2NvbHVtbl09XCJjb2x1bW5cIlxuICAgICAgICBbcm93SGVpZ2h0XT1cInJvd0hlaWdodFwiXG4gICAgICAgIFtkaXNwbGF5Q2hlY2tdPVwiZGlzcGxheUNoZWNrXCJcbiAgICAgICAgKGFjdGl2YXRlKT1cIm9uQWN0aXZhdGUoJGV2ZW50LCBpaSlcIj5cbiAgICAgIDwvZGF0YXRhYmxlLWJvZHktY2VsbD5cbiAgICA8L2Rpdj5cbiAgIiwiPGRhdGF0YWJsZS1ib2R5LXJvdz48L2RhdGF0YWJsZS1ib2R5LXJvdz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDS007TUFBQTtNQUFBO1VBQUE7UUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQVdFO1VBQUE7VUFBQTtRQUFBO1FBWEY7TUFBQTthQUFBOzhCQUFBO1VBQUE7VUFBQTtNQVdzQzs7SUFEcEM7SUFOQTtJQUtBO0lBSEE7SUFEQTtJQUVBO0lBQ0E7SUFMQTtJQUhGLFdBVUUsVUFOQSxVQUtBLFVBSEEsVUFEQSxVQUVBLFVBQ0E7UUFMQSxVQUhGOztJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUEsNkJBQUE7Ozs7b0JBSkY7TUFBQTthQUFBO3FCQUFBLHlDQUcwQztVQUFBLGVBQ3hDO1VBQUEsMENBQUE7VUFBQTtjQUFBLGdEQVlzQjtVQUFBOztJQWJ0QjtJQUhGLFdBR0UsU0FIRjtJQUtJO0lBQUE7SUFERixXQUNFLG1CQURGOztJQUZBO1FBQUE7SUFGRixXQUVFLFNBRkY7Ozs7b0JBREosMkNBQ0k7TUFBQTthQUFBOzRCQUFBO1VBQUEsZUFpQk07O0lBaEJKO0lBQUE7SUFERixXQUNFLG1CQURGOzs7O29CQ0RKO01BQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO01BQUEsaUZBQUE7TUFBQTs0Q0FBQTtJQUFBOztJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUEsNkJBQUE7Ozs7Ozs7In0=
//# sourceMappingURL=body-row.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/components/body/summary/summary-row.component.js
var summary_row_component = __webpack_require__("xTdc");
var summary_row_component_default = /*#__PURE__*/__webpack_require__.n(summary_row_component);

// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/components/body/summary/summary-row.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_DataTableSummaryRowComponent = [];
var RenderType_DataTableSummaryRowComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableSummaryRowComponent, data: {} });
function View_DataTableSummaryRowComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'datatable-body-row', [['tabindex', '-1']], [[8, 'className', 0], [4, 'height', 'px'], [4, 'width', 'px']], [[null,
                'keydown'], [null, 'mouseenter']], function (_v, en, $event) {
            var ad = true;
            if (('keydown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onKeyDown($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('mouseenter' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 1).onMouseenter($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_DataTableBodyRowComponent_0, RenderType_DataTableBodyRowComponent)),
        core_es5["ɵdid"](311296, null, 0, body_row_component["DataTableBodyRowComponent"], [core_es5["KeyValueDiffers"],
            [1, scrollbar_helper_service["ScrollbarHelper"]], core_es5["ChangeDetectorRef"], core_es5["ElementRef"]], { columns: [0, 'columns'],
            innerWidth: [1, 'innerWidth'], row: [2, 'row'], rowIndex: [3, 'rowIndex'], offsetX: [4,
                'offsetX'], rowHeight: [5, 'rowHeight'] }, null), (_l()(), core_es5["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = _co._internalColumns;
        var currVal_4 = _co.innerWidth;
        var currVal_5 = _co.summaryRow;
        var currVal_6 = (0 - 1);
        var currVal_7 = _co.offsetX;
        var currVal_8 = _co.rowHeight;
        _ck(_v, 1, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).cssClass;
        var currVal_1 = core_es5["ɵnov"](_v, 1).rowHeight;
        var currVal_2 = core_es5["ɵnov"](_v, 1).columnsTotalWidths;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2);
    });
}
function View_DataTableSummaryRowComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, ['\n  '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableSummaryRowComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.summaryRow && _co._internalColumns);
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_DataTableSummaryRowComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'datatable-summary-row', [['class', 'datatable-summary-row']], null, null, null, View_DataTableSummaryRowComponent_0, RenderType_DataTableSummaryRowComponent)),
        core_es5["ɵdid"](573440, null, 0, summary_row_component["DataTableSummaryRowComponent"], [], null, null)], null, null);
}
var DataTableSummaryRowComponentNgFactory = core_es5["ɵccf"]('datatable-summary-row', summary_row_component["DataTableSummaryRowComponent"], View_DataTableSummaryRowComponent_Host_0, { rows: 'rows',
    columns: 'columns', rowHeight: 'rowHeight', offsetX: 'offsetX', innerWidth: 'innerWidth' }, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3N1bW1hcnkvc3VtbWFyeS1yb3cuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvYm9keS9zdW1tYXJ5L3N1bW1hcnktcm93LmNvbXBvbmVudC5kLnRzIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3N1bW1hcnkvc3VtbWFyeS1yb3cuY29tcG9uZW50LmQudHMuRGF0YVRhYmxlU3VtbWFyeVJvd0NvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3N1bW1hcnkvc3VtbWFyeS1yb3cuY29tcG9uZW50LmQudHMuRGF0YVRhYmxlU3VtbWFyeVJvd0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICA8ZGF0YXRhYmxlLWJvZHktcm93XG4gICAgKm5nSWY9XCJzdW1tYXJ5Um93ICYmIF9pbnRlcm5hbENvbHVtbnNcIlxuICAgIHRhYmluZGV4PVwiLTFcIlxuICAgIFtpbm5lcldpZHRoXT1cImlubmVyV2lkdGhcIlxuICAgIFtvZmZzZXRYXT1cIm9mZnNldFhcIlxuICAgIFtjb2x1bW5zXT1cIl9pbnRlcm5hbENvbHVtbnNcIlxuICAgIFtyb3dIZWlnaHRdPVwicm93SGVpZ2h0XCJcbiAgICBbcm93XT1cInN1bW1hcnlSb3dcIlxuICAgIFtyb3dJbmRleF09XCItMVwiPlxuICA8L2RhdGF0YWJsZS1ib2R5LXJvdz5cbiAgIiwiPGRhdGF0YWJsZS1zdW1tYXJ5LXJvdz48L2RhdGF0YWJsZS1zdW1tYXJ5LXJvdz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQ0U7TUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7TUFBQTthQUFBO1VBQUE7VUFBQTtjQUFBLHFEQVFrQjtVQUFBOztJQUhoQjtJQUZBO0lBSUE7SUFDQTtJQUpBO0lBRUE7SUFORixXQUtFLFVBRkEsVUFJQSxVQUNBLFVBSkEsVUFFQSxTQU5GOztJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUEsNkJBQUE7Ozs7b0JBREYseUNBQ0U7TUFBQTthQUFBO1VBQUEsd0JBU3FCOztJQVJuQjtJQURGLFdBQ0UsU0FERjs7OztvQkNERjtNQUFBO2lGQUFBO2FBQUE7VUFBQTs7Ozs7In0=
//# sourceMappingURL=summary-row.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/components/body/body-row-wrapper.component.js
var body_row_wrapper_component = __webpack_require__("fj/O");
var body_row_wrapper_component_default = /*#__PURE__*/__webpack_require__.n(body_row_wrapper_component);

// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/components/body/body-row-wrapper.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_DataTableRowWrapperComponent = [];
var RenderType_DataTableRowWrapperComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableRowWrapperComponent, data: {} });
function View_DataTableRowWrapperComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, ['\n      ']))], null, null);
}
function View_DataTableRowWrapperComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableRowWrapperComponent_3)), core_es5["ɵdid"](540672, null, 0, common_es5["NgTemplateOutlet"], [core_es5["ViewContainerRef"]], { ngTemplateOutletContext: [0, 'ngTemplateOutletContext'],
            ngTemplateOutlet: [1, 'ngTemplateOutlet'] }, null), (_l()(), core_es5["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.groupContext;
        var currVal_1 = _co.groupHeader.template;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_DataTableRowWrapperComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'datatable-group-header']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableRowWrapperComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getGroupHeaderStyle();
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = (_co.groupHeader && _co.groupHeader.template);
        _ck(_v, 4, 0, currVal_1);
    }, null);
}
function View_DataTableRowWrapperComponent_4(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵncd"](null, 0), (_l()(), core_es5["ɵand"](0, null, null, 0))], null, null);
}
function View_DataTableRowWrapperComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, ['\n      ']))], null, null);
}
function View_DataTableRowWrapperComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableRowWrapperComponent_7)), core_es5["ɵdid"](540672, null, 0, common_es5["NgTemplateOutlet"], [core_es5["ViewContainerRef"]], { ngTemplateOutletContext: [0, 'ngTemplateOutletContext'],
            ngTemplateOutlet: [1, 'ngTemplateOutlet'] }, null), (_l()(), core_es5["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.rowContext;
        var currVal_1 = _co.rowDetail.template;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_DataTableRowWrapperComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'datatable-row-detail']], [[4, 'height', 'px']], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableRowWrapperComponent_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = (_co.rowDetail && _co.rowDetail.template);
        _ck(_v, 3, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.detailRowHeight;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_DataTableRowWrapperComponent_0(_l) {
    return core_es5["ɵvid"](2, [(_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableRowWrapperComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableRowWrapperComponent_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableRowWrapperComponent_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.groupHeader && _co.groupHeader.template);
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = (((_co.groupHeader && _co.groupHeader.template) && _co.expanded) || (!_co.groupHeader || !_co.groupHeader.template));
        _ck(_v, 5, 0, currVal_1);
        var currVal_2 = ((_co.rowDetail && _co.rowDetail.template) && _co.expanded);
        _ck(_v, 8, 0, currVal_2);
    }, null);
}
function View_DataTableRowWrapperComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'datatable-row-wrapper', [['class', 'datatable-row-wrapper']], null, [[null, 'contextmenu']], function (_v, en, $event) {
            var ad = true;
            if (('contextmenu' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onContextmenu($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_DataTableRowWrapperComponent_0, RenderType_DataTableRowWrapperComponent)),
        core_es5["ɵdid"](311296, null, 0, body_row_wrapper_component["DataTableRowWrapperComponent"], [core_es5["ChangeDetectorRef"],
            core_es5["KeyValueDiffers"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var DataTableRowWrapperComponentNgFactory = core_es5["ɵccf"]('datatable-row-wrapper', body_row_wrapper_component["DataTableRowWrapperComponent"], View_DataTableRowWrapperComponent_Host_0, { innerWidth: 'innerWidth',
    rowDetail: 'rowDetail', groupHeader: 'groupHeader', offsetX: 'offsetX', detailRowHeight: 'detailRowHeight',
    row: 'row', groupedRows: 'groupedRows', rowIndex: 'rowIndex', expanded: 'expanded' }, { rowContextmenu: 'rowContextmenu' }, ['*']);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=body-row-wrapper.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/components/body/scroller.component.js
var scroller_component = __webpack_require__("0RJd");
var scroller_component_default = /*#__PURE__*/__webpack_require__.n(scroller_component);

// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/components/body/scroller.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


var styles_ScrollerComponent = [];
var RenderType_ScrollerComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ScrollerComponent, data: {} });
function View_ScrollerComponent_0(_l) {
    return core_es5["ɵvid"](2, [(_l()(), core_es5["ɵted"](null, ['\n    '])), core_es5["ɵncd"](null, 0), (_l()(), core_es5["ɵted"](null, ['\n  ']))], null, null);
}
function View_ScrollerComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'datatable-scroller', [['class', 'datatable-scroll']], [[4, 'height', 'px'], [4, 'width', 'px']], null, null, View_ScrollerComponent_0, RenderType_ScrollerComponent)), core_es5["ɵdid"](245760, null, 0, scroller_component["ScrollerComponent"], [core_es5["NgZone"], core_es5["ElementRef"], core_es5["Renderer2"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).scrollHeight;
        var currVal_1 = core_es5["ɵnov"](_v, 1).scrollWidth;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
var ScrollerComponentNgFactory = core_es5["ɵccf"]('datatable-scroller', scroller_component["ScrollerComponent"], View_ScrollerComponent_Host_0, { scrollbarV: 'scrollbarV', scrollbarH: 'scrollbarH',
    scrollHeight: 'scrollHeight', scrollWidth: 'scrollWidth' }, { scroll: 'scroll' }, ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3Njcm9sbGVyLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvc2Nyb2xsZXIuY29tcG9uZW50LmQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvc2Nyb2xsZXIuY29tcG9uZW50LmQudHMuU2Nyb2xsZXJDb21wb25lbnQuaHRtbCIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvYm9keS9zY3JvbGxlci5jb21wb25lbnQuZC50cy5TY3JvbGxlckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxuZy1jb250ZW50PjwvbmctY29udGVudD5cbiAgIiwiPGRhdGF0YWJsZS1zY3JvbGxlcj48L2RhdGF0YWJsZS1zY3JvbGxlcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7OztvQkNBQSxrREFDSTtNQUFBLEdBQXlCOzs7b0JDRDdCO01BQUE7TUFBQSw2RUFBQTtNQUFBO01BQUE7SUFBQTs7SUFBQTtJQUFBO0lBQUEsV0FBQSxtQkFBQTs7Ozs7In0=
//# sourceMappingURL=scroller.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/components/body/body.component.js
var body_component = __webpack_require__("X6wl");
var body_component_default = /*#__PURE__*/__webpack_require__.n(body_component);

// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/components/body/selection.component.js
var selection_component = __webpack_require__("yN1j");
var selection_component_default = /*#__PURE__*/__webpack_require__.n(selection_component);

// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/components/body/selection.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


var styles_DataTableSelectionComponent = [];
var RenderType_DataTableSelectionComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableSelectionComponent, data: {} });
function View_DataTableSelectionComponent_0(_l) {
    return core_es5["ɵvid"](2, [(_l()(), core_es5["ɵted"](null, ['\n    '])), core_es5["ɵncd"](null, 0), (_l()(), core_es5["ɵted"](null, ['\n  ']))], null, null);
}
function View_DataTableSelectionComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'datatable-selection', [], null, null, null, View_DataTableSelectionComponent_0, RenderType_DataTableSelectionComponent)), core_es5["ɵdid"](49152, null, 0, selection_component["DataTableSelectionComponent"], [], null, null)], null, null);
}
var DataTableSelectionComponentNgFactory = core_es5["ɵccf"]('datatable-selection', selection_component["DataTableSelectionComponent"], View_DataTableSelectionComponent_Host_0, { rows: 'rows',
    selected: 'selected', selectEnabled: 'selectEnabled', selectionType: 'selectionType',
    rowIdentity: 'rowIdentity', selectCheck: 'selectCheck' }, { activate: 'activate',
    select: 'select' }, ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3NlbGVjdGlvbi5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3NlbGVjdGlvbi5jb21wb25lbnQuZC50cyIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvYm9keS9zZWxlY3Rpb24uY29tcG9uZW50LmQudHMuRGF0YVRhYmxlU2VsZWN0aW9uQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvc2VsZWN0aW9uLmNvbXBvbmVudC5kLnRzLkRhdGFUYWJsZVNlbGVjdGlvbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxuZy1jb250ZW50PjwvbmctY29udGVudD5cbiAgIiwiPGRhdGF0YWJsZS1zZWxlY3Rpb24+PC9kYXRhdGFibGUtc2VsZWN0aW9uPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7O29CQ0FBLGtEQUNJO01BQUEsR0FBeUI7OztvQkNEN0I7TUFBQTs0Q0FBQSxVQUFBO01BQUE7Ozs7OzsifQ==
//# sourceMappingURL=selection.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/components/body/body.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
















var styles_DataTableBodyComponent = [];
var RenderType_DataTableBodyComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DataTableBodyComponent, data: {} });
function View_DataTableBodyComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'datatable-progress', [], null, null, null, View_ProgressBarComponent_0, RenderType_ProgressBarComponent)), core_es5["ɵdid"](49152, null, 0, progress_bar_component["ProgressBarComponent"], [], null, null), (_l()(), core_es5["ɵted"](null, ['\n      ']))], null, null);
}
function View_DataTableBodyComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'datatable-summary-row', [['class', 'datatable-summary-row']], null, null, null, View_DataTableSummaryRowComponent_0, RenderType_DataTableSummaryRowComponent)),
        core_es5["ɵdid"](573440, null, 0, summary_row_component["DataTableSummaryRowComponent"], [], { rows: [0, 'rows'], columns: [1, 'columns'], rowHeight: [2, 'rowHeight'], offsetX: [3,
                'offsetX'], innerWidth: [4, 'innerWidth'] }, null), (_l()(), core_es5["ɵted"](null, ['\n        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.rows;
        var currVal_1 = _co.columns;
        var currVal_2 = _co.summaryHeight;
        var currVal_3 = _co.offsetX;
        var currVal_4 = _co.innerWidth;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4);
    }, null);
}
function View_DataTableBodyComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'datatable-body-row', [['tabindex', '-1']], [[8, 'className', 0], [4, 'height', 'px'], [4, 'width', 'px']], [[null,
                'activate'], [null, 'keydown'], [null, 'mouseenter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('keydown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onKeyDown($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('mouseenter' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 1).onMouseenter($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('activate' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v.parent.parent.parent, 3).onActivate($event, (_co.indexes.first + _v.parent.context.index)) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, View_DataTableBodyRowComponent_0, RenderType_DataTableBodyRowComponent)),
        core_es5["ɵdid"](311296, null, 0, body_row_component["DataTableBodyRowComponent"], [core_es5["KeyValueDiffers"],
            [1, scrollbar_helper_service["ScrollbarHelper"]], core_es5["ChangeDetectorRef"], core_es5["ElementRef"]], { columns: [0, 'columns'],
            innerWidth: [1, 'innerWidth'], expanded: [2, 'expanded'], rowClass: [3, 'rowClass'],
            row: [4, 'row'], isSelected: [5, 'isSelected'], rowIndex: [6, 'rowIndex'], displayCheck: [7,
                'displayCheck'], offsetX: [8, 'offsetX'], rowHeight: [9, 'rowHeight'] }, { activate: 'activate' }),
        (_l()(), core_es5["ɵted"](null, ['\n          ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = _co.columns;
        var currVal_4 = _co.innerWidth;
        var currVal_5 = _co.getRowExpanded(_v.parent.context.$implicit);
        var currVal_6 = _co.rowClass;
        var currVal_7 = _v.parent.context.$implicit;
        var currVal_8 = core_es5["ɵnov"](_v.parent.parent.parent, 3).getRowSelected(_v.parent.context.$implicit);
        var currVal_9 = _co.getRowIndex(_v.parent.context.$implicit);
        var currVal_10 = _co.displayCheck;
        var currVal_11 = _co.offsetX;
        var currVal_12 = _co.getRowHeight(_v.parent.context.$implicit);
        _ck(_v, 1, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).cssClass;
        var currVal_1 = core_es5["ɵnov"](_v, 1).rowHeight;
        var currVal_2 = core_es5["ɵnov"](_v, 1).columnsTotalWidths;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2);
    });
}
function View_DataTableBodyComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'datatable-body-row', [['tabindex', '-1']], [[8, 'className', 0], [4, 'height', 'px'], [4, 'width', 'px']], [[null,
                'activate'], [null, 'keydown'], [null, 'mouseenter']], function (_v, en, $event) {
            var ad = true;
            if (('keydown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onKeyDown($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('mouseenter' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 1).onMouseenter($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('activate' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v.parent.parent.parent.parent, 3).onActivate($event, _v.context.index) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, View_DataTableBodyRowComponent_0, RenderType_DataTableBodyRowComponent)),
        core_es5["ɵdid"](311296, null, 0, body_row_component["DataTableBodyRowComponent"], [core_es5["KeyValueDiffers"],
            [1, scrollbar_helper_service["ScrollbarHelper"]], core_es5["ChangeDetectorRef"], core_es5["ElementRef"]], { columns: [0, 'columns'],
            innerWidth: [1, 'innerWidth'], expanded: [2, 'expanded'], rowClass: [3, 'rowClass'],
            row: [4, 'row'], group: [5, 'group'], isSelected: [6, 'isSelected'], rowIndex: [7,
                'rowIndex'], offsetX: [8, 'offsetX'], rowHeight: [9, 'rowHeight'] }, { activate: 'activate' }),
        (_l()(), core_es5["ɵted"](null, ['\n            ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = _co.columns;
        var currVal_4 = _co.innerWidth;
        var currVal_5 = _co.getRowExpanded(_v.context.$implicit);
        var currVal_6 = _co.rowClass;
        var currVal_7 = _v.context.$implicit;
        var currVal_8 = _v.parent.parent.context.$implicit.value;
        var currVal_9 = core_es5["ɵnov"](_v.parent.parent.parent.parent, 3).getRowSelected(_v.context.$implicit);
        var currVal_10 = _co.getRowIndex(_v.context.$implicit);
        var currVal_11 = _co.offsetX;
        var currVal_12 = _co.getRowHeight(_v.context.$implicit);
        _ck(_v, 1, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).cssClass;
        var currVal_1 = core_es5["ɵnov"](_v, 1).rowHeight;
        var currVal_2 = core_es5["ɵnov"](_v, 1).columnsTotalWidths;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2);
    });
}
function View_DataTableBodyComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, ['\n            '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DataTableBodyComponent_7)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'], ngForTrackBy: [1, 'ngForTrackBy'] }, null), (_l()(), core_es5["ɵted"](null, ['\n          ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _v.parent.context.$implicit.value;
        var currVal_1 = _co.rowTrackingFn;
        _ck(_v, 2, 0, currVal_0, currVal_1);
    }, null);
}
function View_DataTableBodyComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 8, 'datatable-row-wrapper', [['class', 'datatable-row-wrapper']], null, [[null, 'rowContextmenu'],
            [null, 'contextmenu']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('contextmenu' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 2).onContextmenu($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('rowContextmenu' === en)) {
                var pd_1 = (_co.rowContextmenu.emit($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_DataTableRowWrapperComponent_0, RenderType_DataTableRowWrapperComponent)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), core_es5["ɵdid"](311296, null, 0, body_row_wrapper_component["DataTableRowWrapperComponent"], [core_es5["ChangeDetectorRef"], core_es5["KeyValueDiffers"]], { innerWidth: [0, 'innerWidth'], rowDetail: [1, 'rowDetail'], groupHeader: [2, 'groupHeader'],
            offsetX: [3, 'offsetX'], detailRowHeight: [4, 'detailRowHeight'], row: [5, 'row'],
            groupedRows: [6, 'groupedRows'], rowIndex: [7, 'rowIndex'], expanded: [8, 'expanded'] }, { rowContextmenu: 'rowContextmenu' }), (_l()(), core_es5["ɵted"](0, ['\n          '])),
        (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_DataTableBodyComponent_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'], ngIfElse: [1, 'ngIfElse'] }, null), (_l()(), core_es5["ɵted"](0, ['\n          '])),
        (_l()(), core_es5["ɵand"](0, [['groupedRowsTemplate', 2]], 0, 0, null, View_DataTableBodyComponent_6)),
        (_l()(), core_es5["ɵted"](0, ['\n        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getRowsStyles(_v.context.$implicit);
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _co.innerWidth;
        var currVal_2 = _co.rowDetail;
        var currVal_3 = _co.groupHeader;
        var currVal_4 = _co.offsetX;
        var currVal_5 = _co.getDetailRowHeight(_v.context.$implicit[_v.context.index], _v.context.index);
        var currVal_6 = _v.context.$implicit;
        var currVal_7 = _co.groupedRows;
        var currVal_8 = _co.getRowIndex(_v.context.$implicit[_v.context.index]);
        var currVal_9 = _co.getRowExpanded(_v.context.$implicit);
        _ck(_v, 2, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9);
        var currVal_10 = !_co.groupedRows;
        var currVal_11 = core_es5["ɵnov"](_v, 7);
        _ck(_v, 5, 0, currVal_10, currVal_11);
    }, null);
}
function View_DataTableBodyComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'datatable-summary-row', [['class', 'datatable-summary-row']], null, null, null, View_DataTableSummaryRowComponent_0, RenderType_DataTableSummaryRowComponent)),
        core_es5["ɵdid"](573440, null, 0, summary_row_component["DataTableSummaryRowComponent"], [], { rows: [0, 'rows'], columns: [1, 'columns'], rowHeight: [2, 'rowHeight'], offsetX: [3,
                'offsetX'], innerWidth: [4, 'innerWidth'] }, null), (_l()(), core_es5["ɵted"](null, ['\n        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.rows;
        var currVal_1 = _co.columns;
        var currVal_2 = _co.summaryHeight;
        var currVal_3 = _co.offsetX;
        var currVal_4 = _co.innerWidth;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4);
    }, null);
}
function View_DataTableBodyComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 11, 'datatable-scroller', [['class', 'datatable-scroll']], [[4, 'height', 'px'], [4, 'width', 'px']], [[null,
                'scroll']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('scroll' === en)) {
                var pd_0 = (_co.onBodyScroll($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ScrollerComponent_0, RenderType_ScrollerComponent)), core_es5["ɵdid"](245760, [[1, 4]], 0, scroller_component["ScrollerComponent"], [core_es5["NgZone"], core_es5["ElementRef"], core_es5["Renderer2"]], { scrollbarV: [0,
                'scrollbarV'], scrollbarH: [1, 'scrollbarH'], scrollHeight: [2, 'scrollHeight'],
            scrollWidth: [3, 'scrollWidth'] }, { scroll: 'scroll' }), (_l()(), core_es5["ɵted"](0, ['\n        '])),
        (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_DataTableBodyComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, ['\n        '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_DataTableBodyComponent_4)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'], ngForTrackBy: [1, 'ngForTrackBy'] }, null), (_l()(),
            core_es5["ɵted"](0, ['\n        '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_DataTableBodyComponent_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, ['\n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.scrollbarV;
        var currVal_3 = _co.scrollbarH;
        var currVal_4 = _co.scrollHeight;
        var currVal_5 = ((_co.columnGroupWidths == null) ? null : _co.columnGroupWidths.total);
        _ck(_v, 1, 0, currVal_2, currVal_3, currVal_4, currVal_5);
        var currVal_6 = (_co.summaryRow && (_co.summaryPosition === 'top'));
        _ck(_v, 4, 0, currVal_6);
        var currVal_7 = _co.temp;
        var currVal_8 = _co.rowTrackingFn;
        _ck(_v, 7, 0, currVal_7, currVal_8);
        var currVal_9 = (_co.summaryRow && (_co.summaryPosition === 'bottom'));
        _ck(_v, 10, 0, currVal_9);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).scrollHeight;
        var currVal_1 = core_es5["ɵnov"](_v, 1).scrollWidth;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
function View_DataTableBodyComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'empty-row']], [[8, 'innerHTML', 1]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n      ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.emptyMessage;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_DataTableBodyComponent_0(_l) {
    return core_es5["ɵvid"](2, [core_es5["ɵqud"](671088640, 1, { scroller: 0 }), (_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'datatable-selection', [], null, [[null, 'select'], [null, 'activate']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('select' === en)) {
                var pd_0 = (_co.select.emit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('activate' === en)) {
                var pd_1 = (_co.activate.emit($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_DataTableSelectionComponent_0, RenderType_DataTableSelectionComponent)),
        core_es5["ɵdid"](49152, [['selector', 4]], 0, selection_component["DataTableSelectionComponent"], [], { rows: [0, 'rows'], selected: [1, 'selected'], selectEnabled: [2, 'selectEnabled'],
            selectionType: [3, 'selectionType'], rowIdentity: [4, 'rowIdentity'], selectCheck: [5,
                'selectCheck'] }, { activate: 'activate', select: 'select' }), (_l()(), core_es5["ɵted"](0, ['\n      '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_DataTableBodyComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, ['\n      '])),
        (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_DataTableBodyComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, ['\n      '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_DataTableBodyComponent_9)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, ['\n    '])), (_l()(), core_es5["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.rows;
        var currVal_1 = _co.selected;
        var currVal_2 = _co.selectEnabled;
        var currVal_3 = _co.selectionType;
        var currVal_4 = _co.rowIdentity;
        var currVal_5 = _co.selectCheck;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
        var currVal_6 = _co.loadingIndicator;
        _ck(_v, 6, 0, currVal_6);
        var currVal_7 = ((_co.rows == null) ? null : _co.rows.length);
        _ck(_v, 9, 0, currVal_7);
        var currVal_8 = (!((_co.rows == null) ? null : _co.rows.length) && !_co.loadingIndicator);
        _ck(_v, 12, 0, currVal_8);
    }, null);
}
function View_DataTableBodyComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'datatable-body', [['class', 'datatable-body']], [[4, 'width', null], [4, 'height', null]], null, null, View_DataTableBodyComponent_0, RenderType_DataTableBodyComponent)),
        core_es5["ɵdid"](245760, null, 0, body_component["DataTableBodyComponent"], [core_es5["ChangeDetectorRef"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).bodyWidth;
        var currVal_1 = core_es5["ɵnov"](_v, 1).bodyHeight;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
var DataTableBodyComponentNgFactory = core_es5["ɵccf"]('datatable-body', body_component["DataTableBodyComponent"], View_DataTableBodyComponent_Host_0, { scrollbarV: 'scrollbarV',
    scrollbarH: 'scrollbarH', loadingIndicator: 'loadingIndicator', externalPaging: 'externalPaging',
    rowHeight: 'rowHeight', offsetX: 'offsetX', emptyMessage: 'emptyMessage', selectionType: 'selectionType',
    selected: 'selected', rowIdentity: 'rowIdentity', rowDetail: 'rowDetail', groupHeader: 'groupHeader',
    selectCheck: 'selectCheck', displayCheck: 'displayCheck', trackByProp: 'trackByProp',
    rowClass: 'rowClass', groupedRows: 'groupedRows', groupExpansionDefault: 'groupExpansionDefault',
    innerWidth: 'innerWidth', groupRowsBy: 'groupRowsBy', virtualization: 'virtualization',
    summaryRow: 'summaryRow', summaryPosition: 'summaryPosition', summaryHeight: 'summaryHeight',
    pageSize: 'pageSize', rows: 'rows', columns: 'columns', offset: 'offset', rowCount: 'rowCount',
    bodyHeight: 'bodyHeight' }, { scroll: 'scroll', page: 'page', activate: 'activate',
    select: 'select', detailToggle: 'detailToggle', rowContextmenu: 'rowContextmenu' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=body.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/services/dimensions-helper.service.js
var dimensions_helper_service = __webpack_require__("/jm2");
var dimensions_helper_service_default = /*#__PURE__*/__webpack_require__.n(dimensions_helper_service);

// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-datatable/release/components/datatable.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */













var styles_DatatableComponent = [datatable_component_css_ngstyle_styles];
var RenderType_DatatableComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DatatableComponent, data: {} });
function View_DatatableComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'datatable-header', [['class', 'datatable-header']], [[4, 'height', null], [4, 'width', null]], [[null, 'sort'], [null, 'resize'], [null, 'reorder'], [null,
                'select'], [null, 'columnContextmenu']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('sort' === en)) {
                var pd_0 = (_co.onColumnSort($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('resize' === en)) {
                var pd_1 = (_co.onColumnResize($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('reorder' === en)) {
                var pd_2 = (_co.onColumnReorder($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('select' === en)) {
                var pd_3 = (_co.onHeaderSelect($event) !== false);
                ad = (pd_3 && ad);
            }
            if (('columnContextmenu' === en)) {
                var pd_4 = (_co.onColumnContextmenu($event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, View_DataTableHeaderComponent_0, RenderType_DataTableHeaderComponent)),
        core_es5["ɵdid"](49152, [[2, 4]], 0, header_component["DataTableHeaderComponent"], [core_es5["ChangeDetectorRef"]], { sortAscendingIcon: [0,
                'sortAscendingIcon'], sortDescendingIcon: [1, 'sortDescendingIcon'], scrollbarH: [2,
                'scrollbarH'], dealsWithGroup: [3, 'dealsWithGroup'], innerWidth: [4, 'innerWidth'],
            sorts: [5, 'sorts'], sortType: [6, 'sortType'], allRowsSelected: [7, 'allRowsSelected'],
            selectionType: [8, 'selectionType'], reorderable: [9, 'reorderable'], headerHeight: [10,
                'headerHeight'], columns: [11, 'columns'], offsetX: [12, 'offsetX'] }, { sort: 'sort',
            reorder: 'reorder', resize: 'resize', select: 'select', columnContextmenu: 'columnContextmenu' }),
        core_es5["ɵpid"](131072, common_es5["AsyncPipe"], [core_es5["ChangeDetectorRef"]]), (_l()(), core_es5["ɵted"](null, ['\n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.cssClasses.sortAscending;
        var currVal_3 = _co.cssClasses.sortDescending;
        var currVal_4 = _co.scrollbarH;
        var currVal_5 = _co.groupedRows;
        var currVal_6 = _co._innerWidth;
        var currVal_7 = _co.sorts;
        var currVal_8 = _co.sortType;
        var currVal_9 = _co.allRowsSelected;
        var currVal_10 = _co.selectionType;
        var currVal_11 = _co.reorderable;
        var currVal_12 = _co.headerHeight;
        var currVal_13 = _co._internalColumns;
        var currVal_14 = core_es5["ɵunv"](_v, 1, 12, core_es5["ɵnov"](_v, 2).transform(_co._offsetX));
        _ck(_v, 1, 1, [currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8,
            currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14]);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).headerHeight;
        var currVal_1 = core_es5["ɵnov"](_v, 1).headerWidth;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
function View_DatatableComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'datatable-footer', [['class', 'datatable-footer']], null, [[null, 'page']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('page' === en)) {
                var pd_0 = (_co.onFooterPage($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_DataTableFooterComponent_0, RenderType_DataTableFooterComponent)),
        core_es5["ɵdid"](49152, null, 0, footer_component["DataTableFooterComponent"], [], { footerHeight: [0,
                'footerHeight'], rowCount: [1, 'rowCount'], pageSize: [2, 'pageSize'], offset: [3,
                'offset'], pagerLeftArrowIcon: [4, 'pagerLeftArrowIcon'], pagerRightArrowIcon: [5,
                'pagerRightArrowIcon'], pagerPreviousIcon: [6, 'pagerPreviousIcon'], pagerNextIcon: [7,
                'pagerNextIcon'], totalMessage: [8, 'totalMessage'], footerTemplate: [9, 'footerTemplate'],
            selectedCount: [10, 'selectedCount'], selectedMessage: [11, 'selectedMessage'] }, { page: 'page' }), (_l()(), core_es5["ɵted"](null, ['\n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.footerHeight;
        var currVal_1 = _co.rowCount;
        var currVal_2 = _co.pageSize;
        var currVal_3 = _co.offset;
        var currVal_4 = _co.cssClasses.pagerLeftArrow;
        var currVal_5 = _co.cssClasses.pagerRightArrow;
        var currVal_6 = _co.cssClasses.pagerPrevious;
        var currVal_7 = _co.cssClasses.pagerNext;
        var currVal_8 = _co.messages.totalMessage;
        var currVal_9 = _co.footer;
        var currVal_10 = _co.selected.length;
        var currVal_11 = (!!_co.selectionType && _co.messages.selectedMessage);
        _ck(_v, 1, 1, [currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6,
            currVal_7, currVal_8, currVal_9, currVal_10, currVal_11]);
    }, null);
}
function View_DatatableComponent_0(_l) {
    return core_es5["ɵvid"](2, [core_es5["ɵqud"](402653184, 1, { bodyComponent: 0 }), core_es5["ɵqud"](671088640, 2, { headerComponent: 0 }),
        (_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['visibilityObserver', '']], [[2, 'visible', null]], [[null,
                'visible']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('visible' === en)) {
                var pd_0 = (_co.recalculate() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, visibility_directive["VisibilityDirective"], [core_es5["ElementRef"], core_es5["NgZone"]], null, { visible: 'visible' }), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DatatableComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'datatable-body', [['class', 'datatable-body']], [[4, 'width', null], [4, 'height', null]], [[null, 'page'], [null, 'activate'], [null, 'rowContextmenu'],
            [null, 'select'], [null, 'scroll']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('page' === en)) {
                var pd_0 = (_co.onBodyPage($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('activate' === en)) {
                var pd_1 = (_co.activate.emit($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('rowContextmenu' === en)) {
                var pd_2 = (_co.onRowContextmenu($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('select' === en)) {
                var pd_3 = (_co.onBodySelect($event) !== false);
                ad = (pd_3 && ad);
            }
            if (('scroll' === en)) {
                var pd_4 = (_co.onBodyScroll($event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, View_DataTableBodyComponent_0, RenderType_DataTableBodyComponent)),
        core_es5["ɵdid"](245760, [[1, 4]], 0, body_component["DataTableBodyComponent"], [core_es5["ChangeDetectorRef"]], { scrollbarV: [0,
                'scrollbarV'], scrollbarH: [1, 'scrollbarH'], loadingIndicator: [2, 'loadingIndicator'],
            externalPaging: [3, 'externalPaging'], rowHeight: [4, 'rowHeight'], offsetX: [5,
                'offsetX'], emptyMessage: [6, 'emptyMessage'], selectionType: [7, 'selectionType'],
            selected: [8, 'selected'], rowIdentity: [9, 'rowIdentity'], rowDetail: [10, 'rowDetail'],
            groupHeader: [11, 'groupHeader'], selectCheck: [12, 'selectCheck'], displayCheck: [13,
                'displayCheck'], trackByProp: [14, 'trackByProp'], rowClass: [15, 'rowClass'],
            groupedRows: [16, 'groupedRows'], groupExpansionDefault: [17, 'groupExpansionDefault'],
            innerWidth: [18, 'innerWidth'], groupRowsBy: [19, 'groupRowsBy'], virtualization: [20,
                'virtualization'], summaryRow: [21, 'summaryRow'], summaryPosition: [22, 'summaryPosition'],
            summaryHeight: [23, 'summaryHeight'], pageSize: [24, 'pageSize'], rows: [25, 'rows'],
            columns: [26, 'columns'], offset: [27, 'offset'], rowCount: [28, 'rowCount'], bodyHeight: [29,
                'bodyHeight'] }, { scroll: 'scroll', page: 'page', activate: 'activate', select: 'select',
            rowContextmenu: 'rowContextmenu' }), core_es5["ɵpid"](131072, common_es5["AsyncPipe"], [core_es5["ChangeDetectorRef"]]),
        (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵted"](null, ['\n      '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DatatableComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(),
            core_es5["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        _ck(_v, 4, 0);
        var currVal_1 = _co.headerHeight;
        _ck(_v, 7, 0, currVal_1);
        var currVal_4 = _co.scrollbarV;
        var currVal_5 = _co.scrollbarH;
        var currVal_6 = _co.loadingIndicator;
        var currVal_7 = _co.externalPaging;
        var currVal_8 = _co.rowHeight;
        var currVal_9 = core_es5["ɵunv"](_v, 10, 5, core_es5["ɵnov"](_v, 11).transform(_co._offsetX));
        var currVal_10 = _co.messages.emptyMessage;
        var currVal_11 = _co.selectionType;
        var currVal_12 = _co.selected;
        var currVal_13 = _co.rowIdentity;
        var currVal_14 = _co.rowDetail;
        var currVal_15 = _co.groupHeader;
        var currVal_16 = _co.selectCheck;
        var currVal_17 = _co.displayCheck;
        var currVal_18 = _co.trackByProp;
        var currVal_19 = _co.rowClass;
        var currVal_20 = _co.groupedRows;
        var currVal_21 = _co.groupExpansionDefault;
        var currVal_22 = _co._innerWidth;
        var currVal_23 = _co.groupRowsBy;
        var currVal_24 = _co.virtualization;
        var currVal_25 = _co.summaryRow;
        var currVal_26 = _co.summaryPosition;
        var currVal_27 = _co.summaryHeight;
        var currVal_28 = _co.pageSize;
        var currVal_29 = _co._internalRows;
        var currVal_30 = _co._internalColumns;
        var currVal_31 = _co.offset;
        var currVal_32 = _co.rowCount;
        var currVal_33 = _co.bodyHeight;
        _ck(_v, 10, 1, [currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10,
            currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17,
            currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24,
            currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31,
            currVal_32, currVal_33]);
        var currVal_34 = _co.footerHeight;
        _ck(_v, 15, 0, currVal_34);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 4).isVisible;
        _ck(_v, 3, 0, currVal_0);
        var currVal_2 = core_es5["ɵnov"](_v, 10).bodyWidth;
        var currVal_3 = core_es5["ɵnov"](_v, 10).bodyHeight;
        _ck(_v, 9, 0, currVal_2, currVal_3);
    });
}
function View_DatatableComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'ngx-datatable', [['class', 'ngx-datatable']], [[2, 'fixed-header', null], [2, 'fixed-row',
                null], [2, 'scroll-vertical', null], [2, 'scroll-horz', null],
            [2, 'selectable', null], [2, 'checkbox-selection', null], [2,
                'cell-selection', null], [2, 'single-selection', null],
            [2, 'multi-selection', null], [2, 'multi-click-selection', null]], [['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onWindowResize() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_DatatableComponent_0, RenderType_DatatableComponent)), core_es5["ɵdid"](5619712, null, 4, datatable_component["DatatableComponent"], [[1, scrollbar_helper_service["ScrollbarHelper"]], [1, dimensions_helper_service["DimensionsHelper"]],
            core_es5["ChangeDetectorRef"], core_es5["ElementRef"], core_es5["KeyValueDiffers"]], null, null),
        core_es5["ɵqud"](603979776, 1, { columnTemplates: 1 }), core_es5["ɵqud"](335544320, 2, { rowDetail: 0 }),
        core_es5["ɵqud"](335544320, 3, { groupHeader: 0 }), core_es5["ɵqud"](335544320, 4, { footer: 0 })], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).isFixedHeader;
        var currVal_1 = core_es5["ɵnov"](_v, 1).isFixedRow;
        var currVal_2 = core_es5["ɵnov"](_v, 1).isVertScroll;
        var currVal_3 = core_es5["ɵnov"](_v, 1).isHorScroll;
        var currVal_4 = core_es5["ɵnov"](_v, 1).isSelectable;
        var currVal_5 = core_es5["ɵnov"](_v, 1).isCheckboxSelection;
        var currVal_6 = core_es5["ɵnov"](_v, 1).isCellSelection;
        var currVal_7 = core_es5["ɵnov"](_v, 1).isSingleSelection;
        var currVal_8 = core_es5["ɵnov"](_v, 1).isMultiSelection;
        var currVal_9 = core_es5["ɵnov"](_v, 1).isMultiClickSelection;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9);
    });
}
var DatatableComponentNgFactory = core_es5["ɵccf"]('ngx-datatable', datatable_component["DatatableComponent"], View_DatatableComponent_Host_0, { rows: 'rows', groupRowsBy: 'groupRowsBy',
    groupedRows: 'groupedRows', columns: 'columns', selected: 'selected', scrollbarV: 'scrollbarV',
    scrollbarH: 'scrollbarH', rowHeight: 'rowHeight', columnMode: 'columnMode', headerHeight: 'headerHeight',
    footerHeight: 'footerHeight', externalPaging: 'externalPaging', externalSorting: 'externalSorting',
    limit: 'limit', count: 'count', offset: 'offset', loadingIndicator: 'loadingIndicator',
    selectionType: 'selectionType', reorderable: 'reorderable', sortType: 'sortType',
    sorts: 'sorts', cssClasses: 'cssClasses', messages: 'messages', rowIdentity: 'rowIdentity',
    rowClass: 'rowClass', selectCheck: 'selectCheck', displayCheck: 'displayCheck',
    groupExpansionDefault: 'groupExpansionDefault', trackByProp: 'trackByProp', selectAllRowsOnPage: 'selectAllRowsOnPage',
    virtualization: 'virtualization', summaryRow: 'summaryRow', summaryHeight: 'summaryHeight',
    summaryPosition: 'summaryPosition' }, { scroll: 'scroll', activate: 'activate', select: 'select',
    sort: 'sort', page: 'page', reorder: 'reorder', resize: 'resize', tableContextmenu: 'tableContextmenu' }, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9kYXRhdGFibGUuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvZGF0YXRhYmxlLmNvbXBvbmVudC5kLnRzIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9kYXRhdGFibGUuY29tcG9uZW50LmQudHMuRGF0YXRhYmxlQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2RhdGF0YWJsZS5jb21wb25lbnQuZC50cy5EYXRhdGFibGVDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbiAgICA8ZGl2XG4gICAgICB2aXNpYmlsaXR5T2JzZXJ2ZXJcbiAgICAgICh2aXNpYmxlKT1cInJlY2FsY3VsYXRlKClcIj5cbiAgICAgIDxkYXRhdGFibGUtaGVhZGVyXG4gICAgICAgICpuZ0lmPVwiaGVhZGVySGVpZ2h0XCJcbiAgICAgICAgW3NvcnRzXT1cInNvcnRzXCJcbiAgICAgICAgW3NvcnRUeXBlXT1cInNvcnRUeXBlXCJcbiAgICAgICAgW3Njcm9sbGJhckhdPVwic2Nyb2xsYmFySFwiXG4gICAgICAgIFtpbm5lcldpZHRoXT1cIl9pbm5lcldpZHRoXCJcbiAgICAgICAgW29mZnNldFhdPVwiX29mZnNldFggfCBhc3luY1wiXG4gICAgICAgIFtkZWFsc1dpdGhHcm91cF09XCJncm91cGVkUm93c1wiXG4gICAgICAgIFtjb2x1bW5zXT1cIl9pbnRlcm5hbENvbHVtbnNcIlxuICAgICAgICBbaGVhZGVySGVpZ2h0XT1cImhlYWRlckhlaWdodFwiXG4gICAgICAgIFtyZW9yZGVyYWJsZV09XCJyZW9yZGVyYWJsZVwiXG4gICAgICAgIFtzb3J0QXNjZW5kaW5nSWNvbl09XCJjc3NDbGFzc2VzLnNvcnRBc2NlbmRpbmdcIlxuICAgICAgICBbc29ydERlc2NlbmRpbmdJY29uXT1cImNzc0NsYXNzZXMuc29ydERlc2NlbmRpbmdcIlxuICAgICAgICBbYWxsUm93c1NlbGVjdGVkXT1cImFsbFJvd3NTZWxlY3RlZFwiXG4gICAgICAgIFtzZWxlY3Rpb25UeXBlXT1cInNlbGVjdGlvblR5cGVcIlxuICAgICAgICAoc29ydCk9XCJvbkNvbHVtblNvcnQoJGV2ZW50KVwiXG4gICAgICAgIChyZXNpemUpPVwib25Db2x1bW5SZXNpemUoJGV2ZW50KVwiXG4gICAgICAgIChyZW9yZGVyKT1cIm9uQ29sdW1uUmVvcmRlcigkZXZlbnQpXCJcbiAgICAgICAgKHNlbGVjdCk9XCJvbkhlYWRlclNlbGVjdCgkZXZlbnQpXCJcbiAgICAgICAgKGNvbHVtbkNvbnRleHRtZW51KT1cIm9uQ29sdW1uQ29udGV4dG1lbnUoJGV2ZW50KVwiPlxuICAgICAgPC9kYXRhdGFibGUtaGVhZGVyPlxuICAgICAgPGRhdGF0YWJsZS1ib2R5XG4gICAgICAgIFtncm91cFJvd3NCeV09XCJncm91cFJvd3NCeVwiXG4gICAgICAgIFtncm91cGVkUm93c109XCJncm91cGVkUm93c1wiXG4gICAgICAgIFtyb3dzXT1cIl9pbnRlcm5hbFJvd3NcIlxuICAgICAgICBbZ3JvdXBFeHBhbnNpb25EZWZhdWx0XT1cImdyb3VwRXhwYW5zaW9uRGVmYXVsdFwiXG4gICAgICAgIFtzY3JvbGxiYXJWXT1cInNjcm9sbGJhclZcIlxuICAgICAgICBbc2Nyb2xsYmFySF09XCJzY3JvbGxiYXJIXCJcbiAgICAgICAgW3ZpcnR1YWxpemF0aW9uXT1cInZpcnR1YWxpemF0aW9uXCJcbiAgICAgICAgW2xvYWRpbmdJbmRpY2F0b3JdPVwibG9hZGluZ0luZGljYXRvclwiXG4gICAgICAgIFtleHRlcm5hbFBhZ2luZ109XCJleHRlcm5hbFBhZ2luZ1wiXG4gICAgICAgIFtyb3dIZWlnaHRdPVwicm93SGVpZ2h0XCJcbiAgICAgICAgW3Jvd0NvdW50XT1cInJvd0NvdW50XCJcbiAgICAgICAgW29mZnNldF09XCJvZmZzZXRcIlxuICAgICAgICBbdHJhY2tCeVByb3BdPVwidHJhY2tCeVByb3BcIlxuICAgICAgICBbY29sdW1uc109XCJfaW50ZXJuYWxDb2x1bW5zXCJcbiAgICAgICAgW3BhZ2VTaXplXT1cInBhZ2VTaXplXCJcbiAgICAgICAgW29mZnNldFhdPVwiX29mZnNldFggfCBhc3luY1wiXG4gICAgICAgIFtyb3dEZXRhaWxdPVwicm93RGV0YWlsXCJcbiAgICAgICAgW2dyb3VwSGVhZGVyXT1cImdyb3VwSGVhZGVyXCJcbiAgICAgICAgW3NlbGVjdGVkXT1cInNlbGVjdGVkXCJcbiAgICAgICAgW2lubmVyV2lkdGhdPVwiX2lubmVyV2lkdGhcIlxuICAgICAgICBbYm9keUhlaWdodF09XCJib2R5SGVpZ2h0XCJcbiAgICAgICAgW3NlbGVjdGlvblR5cGVdPVwic2VsZWN0aW9uVHlwZVwiXG4gICAgICAgIFtlbXB0eU1lc3NhZ2VdPVwibWVzc2FnZXMuZW1wdHlNZXNzYWdlXCJcbiAgICAgICAgW3Jvd0lkZW50aXR5XT1cInJvd0lkZW50aXR5XCJcbiAgICAgICAgW3Jvd0NsYXNzXT1cInJvd0NsYXNzXCJcbiAgICAgICAgW3NlbGVjdENoZWNrXT1cInNlbGVjdENoZWNrXCJcbiAgICAgICAgW2Rpc3BsYXlDaGVja109XCJkaXNwbGF5Q2hlY2tcIlxuICAgICAgICBbc3VtbWFyeVJvd109XCJzdW1tYXJ5Um93XCJcbiAgICAgICAgW3N1bW1hcnlIZWlnaHRdPVwic3VtbWFyeUhlaWdodFwiXG4gICAgICAgIFtzdW1tYXJ5UG9zaXRpb25dPVwic3VtbWFyeVBvc2l0aW9uXCJcbiAgICAgICAgKHBhZ2UpPVwib25Cb2R5UGFnZSgkZXZlbnQpXCJcbiAgICAgICAgKGFjdGl2YXRlKT1cImFjdGl2YXRlLmVtaXQoJGV2ZW50KVwiXG4gICAgICAgIChyb3dDb250ZXh0bWVudSk9XCJvblJvd0NvbnRleHRtZW51KCRldmVudClcIlxuICAgICAgICAoc2VsZWN0KT1cIm9uQm9keVNlbGVjdCgkZXZlbnQpXCJcbiAgICAgICAgKHNjcm9sbCk9XCJvbkJvZHlTY3JvbGwoJGV2ZW50KVwiPlxuICAgICAgPC9kYXRhdGFibGUtYm9keT5cbiAgICAgIDxkYXRhdGFibGUtZm9vdGVyXG4gICAgICAgICpuZ0lmPVwiZm9vdGVySGVpZ2h0XCJcbiAgICAgICAgW3Jvd0NvdW50XT1cInJvd0NvdW50XCJcbiAgICAgICAgW3BhZ2VTaXplXT1cInBhZ2VTaXplXCJcbiAgICAgICAgW29mZnNldF09XCJvZmZzZXRcIlxuICAgICAgICBbZm9vdGVySGVpZ2h0XT1cImZvb3RlckhlaWdodFwiXG4gICAgICAgIFtmb290ZXJUZW1wbGF0ZV09XCJmb290ZXJcIlxuICAgICAgICBbdG90YWxNZXNzYWdlXT1cIm1lc3NhZ2VzLnRvdGFsTWVzc2FnZVwiXG4gICAgICAgIFtwYWdlckxlZnRBcnJvd0ljb25dPVwiY3NzQ2xhc3Nlcy5wYWdlckxlZnRBcnJvd1wiXG4gICAgICAgIFtwYWdlclJpZ2h0QXJyb3dJY29uXT1cImNzc0NsYXNzZXMucGFnZXJSaWdodEFycm93XCJcbiAgICAgICAgW3BhZ2VyUHJldmlvdXNJY29uXT1cImNzc0NsYXNzZXMucGFnZXJQcmV2aW91c1wiXG4gICAgICAgIFtzZWxlY3RlZENvdW50XT1cInNlbGVjdGVkLmxlbmd0aFwiXG4gICAgICAgIFtzZWxlY3RlZE1lc3NhZ2VdPVwiISFzZWxlY3Rpb25UeXBlICYmIG1lc3NhZ2VzLnNlbGVjdGVkTWVzc2FnZVwiXG4gICAgICAgIFtwYWdlck5leHRJY29uXT1cImNzc0NsYXNzZXMucGFnZXJOZXh0XCJcbiAgICAgICAgKHBhZ2UpPVwib25Gb290ZXJQYWdlKCRldmVudClcIj5cbiAgICAgIDwvZGF0YXRhYmxlLWZvb3Rlcj5cbiAgICA8L2Rpdj5cbiAgIiwiPG5neC1kYXRhdGFibGU+PC9uZ3gtZGF0YXRhYmxlPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDSU07TUFBQTtNQUFBO1VBQUE7UUFBQTtRQUFBO1FBZUU7VUFBQTtVQUFBO1FBQUE7UUFDQTtVQUFBO1VBQUE7UUFBQTtRQUNBO1VBQUE7VUFBQTtRQUFBO1FBQ0E7VUFBQTtVQUFBO1FBQUE7UUFDQTtVQUFBO1VBQUE7UUFBQTtRQW5CRjtNQUFBO2FBQUE7VUFBQTtVQUFBO1VBQUE7VUFBQTtjQUFBO1VBQUE7YUFNRSw2Q0Fha0Q7VUFBQTs7SUFSbEQ7SUFDQTtJQVJBO0lBR0E7SUFGQTtJQUhBO0lBQ0E7SUFVQTtJQUNBO0lBSkE7SUFEQTtJQURBO0lBRkE7SUFORixZQVdFLFVBQ0EsVUFSQSxVQUdBLFVBRkEsVUFIQSxVQUNBO1FBVUEsVUFDQSxXQUpBLFdBREEsV0FEQSxXQUZBLFVBTkY7O0lBQUE7SUFBQTtJQUFBLFdBQUEsbUJBQUE7Ozs7b0JBMERBO01BQUE7Z0JBQUE7UUFBQTtRQUFBO1FBY0U7VUFBQTtVQUFBO1FBQUE7UUFkRjtNQUFBO2FBQUE7VUFBQTtVQUFBO1VBQUE7VUFBQTtVQUFBO1VBQUEsZUFjZ0M7O0lBVDlCO0lBSEE7SUFDQTtJQUNBO0lBSUE7SUFDQTtJQUNBO0lBR0E7SUFOQTtJQURBO0lBS0E7SUFDQTtJQVpGLFlBS0UsVUFIQSxVQUNBLFVBQ0EsVUFJQSxVQUNBLFVBQ0E7UUFHQSxVQU5BLFVBREEsVUFLQSxXQUNBLFVBWkY7Ozs7O01BOUROLDJDQUNJO1VBQUE7Y0FBQTtZQUFBO1lBQUE7WUFFRTtjQUFBO2NBQUE7WUFBQTtZQUZGO1VBQUEsdUNBQUE7VUFBQSw2REFFNEI7VUFBQSxlQUMxQjtVQUFBLG1DQUFBO3dCQUFBLG1DQW9CbUI7VUFBQSxlQUNuQjtVQUFBO1VBQUE7Y0FBQTtZQUFBO1lBQUE7WUErQkU7Y0FBQTtjQUFBO1lBQUE7WUFDQTtjQUFBO2NBQUE7WUFBQTtZQUNBO2NBQUE7Y0FBQTtZQUFBO1lBQ0E7Y0FBQTtjQUFBO1lBQUE7WUFDQTtjQUFBO2NBQUE7WUFBQTtZQW5DRjtVQUFBO2FBQUE7VUFBQTtVQUFBO2NBQUE7VUFBQTtVQUFBO2NBQUE7VUFBQTtVQUFBO2NBQUE7VUFBQTtVQUFBO2NBQUE7VUFBQSx5Q0FnQkU7TUFtQmdDLDZDQUNqQjtNQUNqQjthQUFBO1VBQUEsd0JBZW1CLDJDQUNmO2lCQUFBOztJQTdFTjtJQUlJO0lBREYsV0FDRSxTQURGO0lBMEJFO0lBQ0E7SUFFQTtJQUNBO0lBQ0E7SUFNQTtJQU9BO0lBREE7SUFIQTtJQUtBO0lBUEE7SUFDQTtJQVFBO0lBQ0E7SUFkQTtJQVlBO0lBdkJBO0lBRUE7SUFnQkE7SUFuQkE7SUFNQTtJQXFCQTtJQUVBO0lBREE7SUFkQTtJQVpBO0lBV0E7SUFGQTtJQURBO0lBVUE7SUFyQkYsYUFLRSxVQUNBLFVBRUEsVUFDQSxVQUNBLFVBTUEsVUFPQTtRQURBLFdBSEEsV0FLQSxXQVBBLFdBQ0EsV0FRQSxXQUNBO1FBZEEsV0FZQSxXQXZCQSxXQUVBLFdBZ0JBLFdBbkJBLFdBTUE7UUFxQkEsV0FFQSxXQURBLFdBZEEsV0FaQSxXQVdBLFdBRkE7UUFEQSxXQVVBLFVBckJGO0lBc0NFO0lBREYsWUFDRSxVQURGOztJQTdERjtJQUFBLFdBQUEsU0FBQTtJQXdCRTtJQUFBO0lBQUEsV0FBQSxtQkFBQTs7OztvQkN6Qk47TUFBQTtVQUFBO1VBQUE7Y0FBQTtVQUFBO01BQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7TUFBQSxtRUFBQTtNQUFBOytEQUFBO2FBQUE7YUFBQTtJQUFBOztJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsV0FBQTtRQUFBLDZCQUFBOzs7Ozs7Ozs7Ozs7Ozs7OyJ9
//# sourceMappingURL=datatable.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/objects/users/user.ts
var users_user = __webpack_require__("E4s1");

// CONCATENATED MODULE: ./app/components/Managment/orderManagement/tableView/order-table-view.component.ts










var order_table_view_component_OrderTableViewComponent = /** @class */ (function () {
    function OrderTableViewComponent(route, configService, el, router, userViewService) {
        this.route = route;
        this.configService = configService;
        this.el = el;
        this.router = router;
        this.userViewService = userViewService;
        this.paramsInUrl = new OrderSearch();
        this.orders = [];
        this.searchEvent = new core_es5["EventEmitter"]();
        this.headerHeight = 60;
        this.rowHeight = 50;
        this.orderStatus = orders_orderStatus["a" /* OrderStatus */];
        this.orderHelper = orderHelper_OrderHelper;
        this.canadianCurrencyCodes = this.route.snapshot.data.canadianCurrencyCodes.Data;
    }
    Object.defineProperty(OrderTableViewComponent.prototype, "getColumns", {
        get: function () {
            var currentView = this.userViewService.userView[component["a" /* Component */].OrderManagement];
            var columnsConfig = currentView.ColumnsConfigs.find(function (x) { return x.Type == orderViewType["a" /* OrderViewType */].Table; });
            return columnsConfig.Columns;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderTableViewComponent.prototype, "getSortedColumn", {
        get: function () {
            var currentView = this.userViewService.userView[component["a" /* Component */].OrderManagement];
            var columnsConfig = currentView.ColumnsConfigs.find(function (x) { return x.Type == orderViewType["a" /* OrderViewType */].Table; });
            var sortedColumn = columnsConfig.Columns.find(function (c) { return c.SortType != users_user["b" /* SortType */].None; });
            return [{
                    prop: sortedColumn.Property,
                    dir: sortedColumn.SortType == users_user["b" /* SortType */].Desc ? 'desc' : 'asc'
                }];
        },
        enumerable: true,
        configurable: true
    });
    OrderTableViewComponent.prototype.onScroll = function (scrollY) {
        if (!scrollY || !scrollY.offsetY)
            return;
        // total height of all rows in the viewport
        var viewHeight = this.el.nativeElement.getBoundingClientRect().height - this.headerHeight;
        if (this.config.currentPage * this.config.itemsPerPage >= this.config.totalItems)
            return;
        if (viewHeight + scrollY.offsetY >= this.orders.length * this.rowHeight) {
            this.isLoading = true;
            this.config.currentPage++;
            this.searchEvent.emit(false);
        }
    };
    OrderTableViewComponent.prototype.onRowClicked = function (event) {
        if (event.type == "click") {
            var order = event.row;
            this.goToDetailsBase(order.Id, this.paramsInUrl, order);
        }
    };
    OrderTableViewComponent.prototype.goToDetailsBase = function (id, orderSearch, order) {
        this.router.navigate(["order/" + id.toString(), {
                query: orderSearch.Query ? orderSearch.Query : "",
                agentid: orderSearch.AgentId ? orderSearch.AgentId.toString() : "",
                customerid: order.Customer && order.Customer.Id ? order.Customer.Id.toString() : ""
            }]);
    };
    OrderTableViewComponent.prototype.handleSort = function (event) {
        var _this = this;
        var columns = this.getColumns;
        columns.forEach(function (c) { return c.SortType = users_user["b" /* SortType */].None; });
        var currentColumn = columns.find(function (c) { return c.Name == event.column.name; });
        currentColumn.SortType = event.newValue == 'desc' ? users_user["b" /* SortType */].Desc : users_user["b" /* SortType */].Asc;
        this.userViewService.modify(this.userViewService.userView[component["a" /* Component */].OrderManagement]).then(function (resp) {
            _this.userViewService.userView[component["a" /* Component */].OrderManagement] = resp.Data;
            _this.searchEvent.emit(true);
        });
    };
    OrderTableViewComponent.prototype.isSortable = function (prop) {
        return prop != "''";
    };
    OrderTableViewComponent.ctorParameters = function () { return [{ type: router_es5["a" /* ActivatedRoute */] }, { type: services_configService["a" /* ConfigService */] }, { type: core_es5["ElementRef"] }, { type: router_es5["n" /* Router */] }, { type: services_userViewService["a" /* UserViewService */] }]; };
    return OrderTableViewComponent;
}());

//# sourceMappingURL=order-table-view.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/orderManagement/tableView/order-table-view.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */















var styles_OrderTableViewComponent = [];
var RenderType_OrderTableViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_OrderTableViewComponent, data: {} });
function View_OrderTableViewComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'tooltip-content', [['class', ''], ['placement', 'right']], null, null, null, View_TooltipContent_0, RenderType_TooltipContent)),
        core_es5["ɵdid"](4243456, [['myTooltip', 4]], 0, TooltipContent["TooltipContent"], [core_es5["ElementRef"], core_es5["ChangeDetectorRef"]], { placement: [0, 'placement'], animation: [1, 'animation'] }, null), (_l()(),
            core_es5["ɵted"](0, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'card-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](16777216, null, null, 3, 'i', [['class',
                'material-icons'], ['tooltipPlacement', 'right']], null, [[null,
                'focusin'], [null, 'mouseenter'], [null, 'focusout'], [null,
                'mouseleave']], function (_v, en, $event) {
            var ad = true;
            if (('focusin' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 9).show() !== false);
                ad = (pd_0 && ad);
            }
            if (('mouseenter' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 9).show() !== false);
                ad = (pd_1 && ad);
            }
            if (('focusout' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 9).hide() !== false);
                ad = (pd_2 && ad);
            }
            if (('mouseleave' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 9).hide() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵdid"](16384, null, 0, Tooltip["Tooltip"], [core_es5["ViewContainerRef"],
            core_es5["ComponentFactoryResolver"]], { content: [0, 'content'], tooltipPlacement: [1,
                'tooltipPlacement'] }, null), (_l()(), core_es5["ɵted"](null, [' ', ' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'right';
        var currVal_1 = true;
        _ck(_v, 2, 0, currVal_0, currVal_1);
        var currVal_3 = 'material-icons';
        var currVal_4 = (((_v.context.value == _co.orderStatus.Closed) || (_v.context.value == _co.orderStatus.BorderCrossed)) ? 'icon-green' : 'icon-orange');
        _ck(_v, 8, 0, currVal_3, currVal_4);
        var currVal_5 = core_es5["ɵnov"](_v, 2);
        var currVal_6 = 'right';
        _ck(_v, 9, 0, currVal_5, currVal_6);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.orderHelper.getTooltipText(_v.context.value);
        _ck(_v, 3, 0, currVal_2);
        var currVal_7 = _co.orderHelper.getOrderIcon(_v.context.value);
        _ck(_v, 10, 0, currVal_7);
    });
}
function View_OrderTableViewComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' ', ' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.orderHelper.formatValue(_v.parent.context.$implicit.Property, _v.parent.context.$implicit.Name, _v.context.row, _co.canadianCurrencyCodes);
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_OrderTableViewComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 10, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ngx-datatable-column', [], null, null, null, null, null)), core_es5["ɵdid"](16384, [[1, 4]], 2, column_directive["DataTableColumnDirective"], [], { name: [0, 'name'], prop: [1, 'prop'], resizeable: [2, 'resizeable'],
            sortable: [3, 'sortable'] }, null), core_es5["ɵqud"](335544320, 7, { cellTemplate: 0 }),
        core_es5["ɵqud"](335544320, 8, { headerTemplate: 0 }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](0, [[7, 2]], null, 1, null, View_OrderTableViewComponent_4)),
        core_es5["ɵdid"](16384, null, 0, column_cell_directive["DataTableColumnCellDirective"], [core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _v.context.$implicit.Name;
        var currVal_1 = _v.context.$implicit.Property;
        var currVal_2 = false;
        var currVal_3 = _co.isSortable(_v.context.$implicit.Property);
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_OrderTableViewComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 18, 'ngx-datatable', [['class', 'material ngx-datatable']], [[2, 'fixed-header', null], [2, 'fixed-row',
                null], [2, 'scroll-vertical', null], [2, 'scroll-horz', null],
            [2, 'selectable', null], [2, 'checkbox-selection', null], [2,
                'cell-selection', null], [2, 'single-selection', null],
            [2, 'multi-selection', null], [2, 'multi-click-selection', null]], [[null, 'scroll'], [null, 'activate'], [null, 'sort'],
            [null, 'reorder'], ['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onWindowResize() !== false);
                ad = (pd_0 && ad);
            }
            if (('scroll' === en)) {
                var pd_1 = (_co.onScroll($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('activate' === en)) {
                var pd_2 = (_co.onRowClicked($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('sort' === en)) {
                var pd_3 = (_co.handleSort($event) !== false);
                ad = (pd_3 && ad);
            }
            if (('reorder' === en)) {
                var pd_4 = (_co.handleDragAndDrop($event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, View_DatatableComponent_0, RenderType_DatatableComponent)), core_es5["ɵdid"](5619712, null, 4, datatable_component["DatatableComponent"], [[1, scrollbar_helper_service["ScrollbarHelper"]], [1, dimensions_helper_service["DimensionsHelper"]],
            core_es5["ChangeDetectorRef"], core_es5["ElementRef"], core_es5["KeyValueDiffers"]], { rows: [0, 'rows'],
            scrollbarV: [1, 'scrollbarV'], rowHeight: [2, 'rowHeight'], columnMode: [3, 'columnMode'],
            headerHeight: [4, 'headerHeight'], externalSorting: [5, 'externalSorting'], reorderable: [6,
                'reorderable'], sortType: [7, 'sortType'], sorts: [8, 'sorts'] }, { scroll: 'scroll',
            activate: 'activate', sort: 'sort', reorder: 'reorder' }), core_es5["ɵqud"](603979776, 1, { columnTemplates: 1 }), core_es5["ɵqud"](335544320, 2, { rowDetail: 0 }), core_es5["ɵqud"](335544320, 3, { groupHeader: 0 }), core_es5["ɵqud"](335544320, 4, { footer: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ngx-datatable-column', [['name', ''], ['prop', 'Status']], null, null, null, null, null)), core_es5["ɵdid"](16384, [[1, 4]], 2, column_directive["DataTableColumnDirective"], [], { name: [0, 'name'], prop: [1, 'prop'] }, null), core_es5["ɵqud"](335544320, 5, { cellTemplate: 0 }),
        core_es5["ɵqud"](335544320, 6, { headerTemplate: 0 }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](0, [[5, 2]], null, 1, null, View_OrderTableViewComponent_2)),
        core_es5["ɵdid"](16384, null, 0, column_cell_directive["DataTableColumnCellDirective"], [core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderTableViewComponent_3)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_10 = _co.orders;
        var currVal_11 = true;
        var currVal_12 = _co.rowHeight;
        var currVal_13 = 'force';
        var currVal_14 = _co.headerHeight;
        var currVal_15 = true;
        var currVal_16 = false;
        var currVal_17 = 'single';
        var currVal_18 = _co.getSortedColumn;
        _ck(_v, 1, 0, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18);
        var currVal_19 = '';
        var currVal_20 = 'Status';
        _ck(_v, 8, 0, currVal_19, currVal_20);
        var currVal_21 = _co.tableColumns;
        _ck(_v, 17, 0, currVal_21);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).isFixedHeader;
        var currVal_1 = core_es5["ɵnov"](_v, 1).isFixedRow;
        var currVal_2 = core_es5["ɵnov"](_v, 1).isVertScroll;
        var currVal_3 = core_es5["ɵnov"](_v, 1).isHorScroll;
        var currVal_4 = core_es5["ɵnov"](_v, 1).isSelectable;
        var currVal_5 = core_es5["ɵnov"](_v, 1).isCheckboxSelection;
        var currVal_6 = core_es5["ɵnov"](_v, 1).isCellSelection;
        var currVal_7 = core_es5["ɵnov"](_v, 1).isSingleSelection;
        var currVal_8 = core_es5["ɵnov"](_v, 1).isMultiSelection;
        var currVal_9 = core_es5["ɵnov"](_v, 1).isMultiClickSelection;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9);
    });
}
function View_OrderTableViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderTableViewComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.orders && (_co.orders.length > 0));
        _ck(_v, 1, 0, currVal_0);
    }, null);
}
function View_OrderTableViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-table-view', [], null, null, null, View_OrderTableViewComponent_0, RenderType_OrderTableViewComponent)), core_es5["ɵdid"](49152, null, 0, order_table_view_component_OrderTableViewComponent, [router_es5["a" /* ActivatedRoute */], services_configService["a" /* ConfigService */], core_es5["ElementRef"], router_es5["n" /* Router */], services_userViewService["a" /* UserViewService */]], null, null)], null, null);
}
var OrderTableViewComponentNgFactory = core_es5["ɵccf"]('order-table-view', order_table_view_component_OrderTableViewComponent, View_OrderTableViewComponent_Host_0, { config: 'config',
    paramsInUrl: 'paramsInUrl', orders: 'orders', isLoading: 'isLoading', tableColumns: 'tableColumns' }, { searchEvent: 'searchEvent' }, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L29yZGVyTWFuYWdlbWVudC90YWJsZVZpZXcvb3JkZXItdGFibGUtdmlldy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L29yZGVyTWFuYWdlbWVudC90YWJsZVZpZXcvb3JkZXItdGFibGUtdmlldy5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9NYW5hZ21lbnQvb3JkZXJNYW5hZ2VtZW50L3RhYmxlVmlldy9vcmRlci10YWJsZS12aWV3LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L29yZGVyTWFuYWdlbWVudC90YWJsZVZpZXcvb3JkZXItdGFibGUtdmlldy5jb21wb25lbnQudHMuT3JkZXJUYWJsZVZpZXdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmd4LWRhdGF0YWJsZSAqbmdJZj1cIm9yZGVycyAmJiBvcmRlcnMubGVuZ3RoID4gMFwiIGNsYXNzPVwibWF0ZXJpYWxcIiBbcm93c109XCJvcmRlcnNcIiBbY29sdW1uTW9kZV09XCInZm9yY2UnXCIgW2hlYWRlckhlaWdodF09XCJoZWFkZXJIZWlnaHRcIiBbcm93SGVpZ2h0XT1cInJvd0hlaWdodFwiIFtzb3J0VHlwZV09XCInc2luZ2xlJ1wiIFtzb3J0c109XCJnZXRTb3J0ZWRDb2x1bW5cIiAoc2Nyb2xsKT1cIm9uU2Nyb2xsKCRldmVudClcIiBbc2Nyb2xsYmFyVl09XCJ0cnVlXCIgKGFjdGl2YXRlKT1cIm9uUm93Q2xpY2tlZCgkZXZlbnQpXCIgKHNvcnQpPVwiaGFuZGxlU29ydCgkZXZlbnQpXCIgKHJlb3JkZXIpPVwiaGFuZGxlRHJhZ0FuZERyb3AoJGV2ZW50KVwiIFtleHRlcm5hbFNvcnRpbmddPVwidHJ1ZVwiIFtyZW9yZGVyYWJsZV09XCJmYWxzZVwiPiA8bmd4LWRhdGF0YWJsZS1jb2x1bW4gcHJvcD1cIlN0YXR1c1wiIG5hbWU9XCJcIj4gPG5nLXRlbXBsYXRlIGxldC12YWx1ZT1cInZhbHVlXCIgbmd4LWRhdGF0YWJsZS1jZWxsLXRlbXBsYXRlPiA8dG9vbHRpcC1jb250ZW50IGNsYXNzPVwiXCIgI215VG9vbHRpcCBbYW5pbWF0aW9uXT1cInRydWVcIiBwbGFjZW1lbnQ9XCJyaWdodFwiPiB7e29yZGVySGVscGVyLmdldFRvb2x0aXBUZXh0KHZhbHVlKX19IDwvdG9vbHRpcC1jb250ZW50PiA8ZGl2IGNsYXNzPVwiY2FyZC1oZWFkZXJcIj4gPGkgW3Rvb2x0aXBdPVwibXlUb29sdGlwXCIgdG9vbHRpcFBsYWNlbWVudD1cInJpZ2h0XCIgY2xhc3M9XCJtYXRlcmlhbC1pY29uc1wiIFtuZ0NsYXNzXT1cInZhbHVlID09IG9yZGVyU3RhdHVzLkNsb3NlZCB8fCB2YWx1ZSA9PSBvcmRlclN0YXR1cy5Cb3JkZXJDcm9zc2VkID8gJ2ljb24tZ3JlZW4nIDogJ2ljb24tb3JhbmdlJ1wiPiB7e29yZGVySGVscGVyLmdldE9yZGVySWNvbih2YWx1ZSl9fSA8L2k+IDwvZGl2PiA8L25nLXRlbXBsYXRlPiA8L25neC1kYXRhdGFibGUtY29sdW1uPiA8bmctY29udGFpbmVyICpuZ0Zvcj1cImxldCBjb2x1bW4gb2YgdGFibGVDb2x1bW5zXCI+IDxuZ3gtZGF0YXRhYmxlLWNvbHVtbiBbcHJvcF09XCJjb2x1bW4uUHJvcGVydHlcIiBbbmFtZV09XCJjb2x1bW4uTmFtZVwiIFtyZXNpemVhYmxlXT1cImZhbHNlXCIgW3NvcnRhYmxlXT1cImlzU29ydGFibGUoY29sdW1uLlByb3BlcnR5KVwiPiA8bmctdGVtcGxhdGUgbGV0LXZhbHVlPVwidmFsdWVcIiBuZ3gtZGF0YXRhYmxlLWNlbGwtdGVtcGxhdGUgbGV0LXJvdz1cInJvd1wiPiB7e29yZGVySGVscGVyLmZvcm1hdFZhbHVlKGNvbHVtbi5Qcm9wZXJ0eSwgY29sdW1uLk5hbWUsIHJvdywgY2FuYWRpYW5DdXJyZW5jeUNvZGVzKSB9fSA8L25nLXRlbXBsYXRlPiA8L25neC1kYXRhdGFibGUtY29sdW1uPiA8L25nLWNvbnRhaW5lcj4gPC9uZ3gtZGF0YXRhYmxlPiAiLCI8b3JkZXItdGFibGUtdmlldz48L29yZGVyLXRhYmxlLXZpZXc+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0E2ZixzQ0FBQztNQUFBO01BQUE7YUFBQTtVQUFBLHFFQUEwRTtpQkFBQSxlQUF5RCxzQ0FBQztVQUFBO1VBQUEsMERBQXlCO1VBQUEsUUFBQztVQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLHVDQUFBO3NEQUFBO1VBQUEsa0NBQUE7cUNBQUE7VUFBQSxvQ0FBc0w7TUFBeUMsc0NBQU87OztRQUE1VTtRQUFuQjtRQUFyQyxXQUF3RCxVQUFuQixTQUFyQztRQUFnTjtRQUF1QjtRQUF6RSxXQUFrRCxVQUF1QixTQUF6RTtRQUFHO1FBQXNCO1FBQXpCLFdBQUcsVUFBc0IsU0FBekI7OztRQUFwRjtRQUFBO1FBQTBRO1FBQUE7Ozs7b0JBQXVWOzs7SUFBQTtRQUFBO0lBQUE7Ozs7b0JBQS9QO01BQUE7TUFBa0Qsc0NBQUM7VUFBQTtVQUFBLHFDQUFBO1VBQUE7Y0FBQTthQUFBLGlDQUFrSTtNQUFDO2FBQUE7VUFBQSw2QkFBK0ssc0NBQXdCO2lCQUFBOztJQUEzUjtJQUF6QjtJQUE4QztJQUFxQjtJQUF6RixXQUErQyxVQUF6QixVQUE4QyxVQUFxQixTQUF6Rjs7OztvQkFBNzlCO01BQUE7VUFBQTtVQUFBO2NBQUE7VUFBQTtNQUFBO1VBQUE7UUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBaU47VUFBQTtVQUFBO1FBQUE7UUFBZ0Q7VUFBQTtVQUFBO1FBQUE7UUFBa0M7VUFBQTtVQUFBO1FBQUE7UUFBNEI7VUFBQTtVQUFBO1FBQUE7UUFBL1Q7TUFBQSx5RUFBQTtNQUFBOytEQUFBO1VBQUE7VUFBQTtjQUFBO1VBQUE7TUFBQTtNQUFBLGlEQUFvWjtNQUFBLFFBQUM7TUFBQTtNQUFBLHVCQUFBO01BQUE7YUFBQSxpQ0FBNEM7TUFBQzthQUFBO1VBQUEsNkJBQStjLHNDQUF3QjtpQkFBQSx1QkFBQztVQUFBLHdEQUFBO1VBQUE7Y0FBQSwyQkFBNlk7OztJQUFudkM7SUFBeUs7SUFBcEc7SUFBckQ7SUFBdUI7SUFBMFA7SUFBeUI7SUFBN047SUFBc0I7SUFBdkwsV0FBb0UsV0FBeUssV0FBcEcsV0FBckQsV0FBdUIsV0FBMFAsV0FBeUI7UUFBN04sV0FBc0IsVUFBdkw7SUFBeWI7SUFBZDtJQUF0QixXQUFvQyxXQUFkLFVBQXRCO0lBQW1pQjtJQUFkLFlBQWMsVUFBZDs7SUFBMTZCO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsV0FBQTtRQUFBLDZCQUFBOzs7O29CQUFBO01BQUEsd0NBQUE7b0JBQUEsbUNBQXcwQztNQUFBOztJQUF6ekM7SUFBZixXQUFlLFNBQWY7Ozs7b0JDQUE7TUFBQTt3Q0FBQSxVQUFBO01BQUE7TUFBQTs7Ozs7In0=
//# sourceMappingURL=order-table-view.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/common/helpers/screenHelper.ts
var screenHelper = __webpack_require__("eeIR");

// CONCATENATED MODULE: ./app/components/Managment/orderManagement/orderManagement.component.ts

















/**
 * Created by alex.y on 9/13/2017.
 */
var orderManagement_component_OrderManagementComponent = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](OrderManagementComponent, _super);
    function OrderManagementComponent(route, orderService, location, customerService, userService, router, configService, storageManager, userViewService, http, orderODataService) {
        var _this = _super.call(this, orderService, location, customerService, userService, storageManager, userViewService, orderODataService) || this;
        _this.route = route;
        _this.orderService = orderService;
        _this.location = location;
        _this.customerService = customerService;
        _this.userService = userService;
        _this.router = router;
        _this.configService = configService;
        _this.storageManager = storageManager;
        _this.userViewService = userViewService;
        _this.http = http;
        _this.orderODataService = orderODataService;
        _this.orders = [];
        _this.config = {
            id: 'custom',
            itemsPerPage: 12,
            currentPage: 1,
            totalItems: 1
        };
        _this.orderViewType = orderViewType["a" /* OrderViewType */];
        _this.orderStatus = orders_orderStatus["a" /* OrderStatus */];
        _this.componentEnum = component["a" /* Component */];
        _this.idToBlur = "customer-management";
        return _this;
    }
    OrderManagementComponent.prototype.onResize = function (event) {
        var userView = this.userViewService.userView[component["a" /* Component */].OrderManagement];
        if (this.isMobileScreen == this.isMobileView || userView.ViewType == orderViewType["a" /* OrderViewType */].Tile)
            return;
        if (this.isMobileView) {
            userView.ViewType = orderViewType["a" /* OrderViewType */].Tile;
            this.updateColumns(true);
        }
        this.isMobileScreen = this.isMobileView;
    };
    OrderManagementComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.config.totalItems = this.route.snapshot.data.userViewOrder.orders.TotalCount;
        this.orders = this.route.snapshot.data.userViewOrder.orders.Items;
        this.route.params.subscribe(function (params) {
            var email = params['customeremail'];
            var query = params['query'];
            var agentId = params['agentid'];
            var customerId = params['customerid'];
            if (email)
                _this.query = email;
            if (query)
                _this.query = query;
            if (agentId)
                _this.agentId = agentId;
            if (customerId)
                _this.customerId = customerId;
        });
        this.updateColumns();
    };
    Object.defineProperty(OrderManagementComponent.prototype, "isMobileView", {
        get: function () {
            return screenHelper["a" /* ScreenHelper */].isPhone();
        },
        enumerable: true,
        configurable: true
    });
    OrderManagementComponent.prototype.createEvent = function () {
        this.router.navigate(["calculator/agent"]);
    };
    OrderManagementComponent.prototype.toggleView = function () {
        var _this = this;
        var userView = this.userViewService.userView[component["a" /* Component */].OrderManagement];
        if (userView.ViewType == orderViewType["a" /* OrderViewType */].Table)
            userView.ViewType = orderViewType["a" /* OrderViewType */].Tile;
        else
            userView.ViewType = orderViewType["a" /* OrderViewType */].Table;
        this.isViewLoading = true;
        this.orders = [];
        this.userViewService.updateUserView(new users_user["d" /* UserViewConfig */]({
            Id: userView.Id,
            UserId: this.currentUser.Id,
            ComponentId: component["a" /* Component */].OrderManagement,
            ViewType: userView.ViewType
        })).then(function (x) {
            if (!x.Data)
                return;
            userView.Id = x.Data.Id;
            _this.updateColumns();
            _this.config.currentPage = 1;
            _this.search(_this.agentId == null);
        });
    };
    OrderManagementComponent.prototype.updateColumns = function (refreshOrders) {
        if (refreshOrders === void 0) { refreshOrders = false; }
        this.tableColumns = this.getColumns();
        if (refreshOrders)
            this.search();
    };
    OrderManagementComponent.prototype.handleTableSearch = function (resetPage) {
        if (resetPage === void 0) { resetPage = false; }
        if (resetPage == true) {
            this.config.currentPage = 1;
        }
        this.search(this.agentId == null, '/management/order', !resetPage, !resetPage);
    };
    OrderManagementComponent.ctorParameters = function () { return [{ type: router_es5["a" /* ActivatedRoute */] }, { type: services_orderService["a" /* OrderService */] }, { type: common_es5["Location"] }, { type: services_customerService["a" /* CustomerService */] }, { type: services_userService["a" /* UserService */] }, { type: router_es5["n" /* Router */] }, { type: services_configService["a" /* ConfigService */] }, { type: managers_storageManager["a" /* StorageManager */] }, { type: services_userViewService["a" /* UserViewService */] }, { type: http_es5["e" /* Http */] }, { type: orderOData_service_OrderODataService }]; };
    return OrderManagementComponent;
}(baseOrderManagement_BaseOrderManagement));

//# sourceMappingURL=orderManagement.component.js.map
// EXTERNAL MODULE: ./node_modules/dragula/dragula.js
var dragula = __webpack_require__("vx8o");
var dragula_default = /*#__PURE__*/__webpack_require__.n(dragula);

// CONCATENATED MODULE: ./node_modules/@swimlane/ngx-dnd/release/services/drake-store.service.js


/**
 * Central service that handles all events
 *
 * @export
 * @class DrakeStoreService
 */
var drake_store_service_DrakeStoreService = (function () {
    function DrakeStoreService() {
        this.droppableMap = new WeakMap();
        this.draggableMap = new WeakMap();
        this.dragulaOptions = {};
        this.dragulaOptions = this.createDrakeOptions();
        this.drake = dragula([], this.dragulaOptions);
        this.registerEvents();
    }
    DrakeStoreService.prototype.register = function (droppable) {
        this.droppableMap.set(droppable.container, droppable);
        this.drake.containers.push(droppable.container);
    };
    DrakeStoreService.prototype.remove = function (droppable) {
        this.droppableMap.delete(droppable.container);
        var idx = this.drake.containers.indexOf(droppable.container);
        if (idx > -1) {
            this.drake.containers.splice(idx, 1);
        }
    };
    DrakeStoreService.prototype.registerDraggable = function (draggable) {
        this.draggableMap.set(draggable.element, draggable);
    };
    DrakeStoreService.prototype.removeDraggable = function (draggable) {
        this.draggableMap.delete(draggable.element);
    };
    DrakeStoreService.prototype.createDrakeOptions = function () {
        var _this = this;
        var accepts = function (el, target, source, sibling) {
            if (el.contains(target)) {
                return false;
            }
            var elementComponent = _this.draggableMap.get(el);
            var targetComponent = _this.droppableMap.get(target);
            if (elementComponent && targetComponent) {
                return elementComponent.dropZones.includes(targetComponent.dropZone);
            }
            return true;
        };
        var copy = function (el, source) {
            var sourceComponent = _this.droppableMap.get(source);
            if (sourceComponent) {
                return sourceComponent.copy;
            }
            return false;
        };
        var moves = function (el, source, handle, sibling) {
            var elementComponent = _this.draggableMap.get(el);
            if (elementComponent) {
                return elementComponent.moves(source, handle, sibling);
            }
            return true;
        };
        return { accepts: accepts, copy: copy, moves: moves, revertOnSpill: true };
    };
    DrakeStoreService.prototype.registerEvents = function () {
        var _this = this;
        var dragElm;
        var draggedItem;
        this.drake.on('drag', function (el, source) {
            draggedItem = undefined;
            dragElm = el;
            if (!el || !source) {
                return;
            }
            if (_this.draggableMap.has(el)) {
                var elementComponent = _this.draggableMap.get(el);
                draggedItem = elementComponent.model;
                elementComponent.drag.emit({
                    type: 'drag',
                    el: el,
                    source: source,
                    value: draggedItem
                });
            }
            if (_this.droppableMap.has(source)) {
                var sourceComponent = _this.droppableMap.get(source);
                _this.dragulaOptions.removeOnSpill = sourceComponent.removeOnSpill;
                sourceComponent.drag.emit({
                    type: 'drag',
                    el: el,
                    source: source,
                    sourceComponent: sourceComponent,
                    value: draggedItem
                });
            }
        });
        this.drake.on('drop', function (el, target, source) {
            if (_this.droppableMap.has(target)) {
                var targetComponent = _this.droppableMap.get(target);
                var dropElmModel = draggedItem;
                if (_this.droppableMap.has(source)) {
                    var sourceComponent = _this.droppableMap.get(source);
                    var sourceModel = sourceComponent.model;
                    var targetModel = targetComponent.model;
                    var dropIndex = Array.prototype.indexOf.call(target.children, el);
                    var dragIndex = (sourceModel && draggedItem) ? sourceModel.indexOf(draggedItem) : -1;
                    if (dropIndex > -1 && targetModel) {
                        if (dragIndex > -1 && sourceModel && target === source) {
                            sourceModel.splice(dropIndex, 0, sourceModel.splice(dragIndex, 1)[0]);
                        }
                        else {
                            if (el.parentNode === target) {
                                target.removeChild(el);
                            }
                            var copy = !sourceModel || (dragElm !== el);
                            if (copy) {
                                dropElmModel = JSON.parse(JSON.stringify(dropElmModel));
                            }
                            else {
                                if (el.parentNode !== source) {
                                    // add element back, let angular remove it
                                    source.append(el);
                                }
                                sourceModel.splice(dragIndex, 1);
                            }
                            targetModel.splice(dropIndex, 0, dropElmModel);
                        }
                    }
                }
                targetComponent.drop.emit({
                    type: 'drop',
                    el: el,
                    source: source,
                    value: dropElmModel
                });
            }
        });
        this.drake.on('remove', function (el, container, source) {
            if (_this.droppableMap.has(source)) {
                var sourceComponent = _this.droppableMap.get(source);
                var sourceModel = sourceComponent.model;
                var dragIndex = (draggedItem && sourceModel) ? sourceModel.indexOf(draggedItem) : -1;
                if (dragIndex > -1) {
                    if (el.parentNode !== source) {
                        // add element back, let angular remove it
                        source.append(el);
                    }
                    sourceModel.splice(dragIndex, 1);
                }
                sourceComponent.remove.emit({
                    type: 'remove',
                    el: el,
                    container: container,
                    source: source,
                    value: draggedItem
                });
            }
        });
        this.drake.on('cancel', function (el, container, source) {
            if (_this.droppableMap.has(container)) {
                var containerComponent = _this.droppableMap.get(container);
                containerComponent.cancel.emit({
                    type: 'cancel',
                    el: el,
                    container: container,
                    source: source,
                    value: draggedItem
                });
            }
        });
        this.drake.on('over', function (el, container, source) {
            if (_this.droppableMap.has(container)) {
                var containerComponent = _this.droppableMap.get(container);
                containerComponent.over.emit({
                    type: 'over',
                    el: el,
                    container: container,
                    source: source,
                    value: draggedItem
                });
            }
        });
        this.drake.on('out', function (el, container, source) {
            if (_this.droppableMap.has(container)) {
                var containerComponent = _this.droppableMap.get(container);
                containerComponent.out.emit({
                    type: 'out',
                    el: el,
                    container: container,
                    source: source,
                    value: draggedItem
                });
            }
        });
    };
    DrakeStoreService.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    DrakeStoreService.ctorParameters = function () { return []; };
    return DrakeStoreService;
}());

//# sourceMappingURL=drake-store.service.js.map
// CONCATENATED MODULE: ./node_modules/@swimlane/ngx-dnd/release/directives/ngx-droppable.directive.js


var ngx_droppable_directive_i = 10000;
function getNextId() {
    return ngx_droppable_directive_i++;
}
/**
 * Makes the container droppable and children draggable.
 *
 * @export
 * @class DroppableDirective
 * @implements {OnInit}
 * @implements {OnDestroy}
 * @implements {AfterViewInit}
 */
var ngx_droppable_directive_DroppableDirective = (function () {
    function DroppableDirective(el, renderer, drakesService) {
        this.el = el;
        this.renderer = renderer;
        this.drakesService = drakesService;
        this.copy = false;
        this.removeOnSpill = false;
        this.drop = new core_es5["EventEmitter"]();
        this.drag = new core_es5["EventEmitter"]();
        this.over = new core_es5["EventEmitter"]();
        this.out = new core_es5["EventEmitter"]();
        this.remove = new core_es5["EventEmitter"]();
        this.cancel = new core_es5["EventEmitter"]();
    }
    Object.defineProperty(DroppableDirective.prototype, "container", {
        get: function () {
            return this.el.nativeElement;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DroppableDirective.prototype, "dropZone", {
        get: function () {
            return this._dropZone || this.ngxDroppable || this.defaultZone;
        },
        set: function (val) {
            this._dropZone = val;
        },
        enumerable: true,
        configurable: true
    });
    DroppableDirective.prototype.ngOnInit = function () {
        this.defaultZone = "@@DefaultDropZone-" + getNextId() + "@@";
        this.drakesService.register(this);
    };
    DroppableDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.over.subscribe(function (ev) {
            _this.renderer.setElementClass(_this.container, 'gu-over', true);
        });
        this.out.subscribe(function (ev) {
            _this.renderer.setElementClass(_this.container, 'gu-over', false);
        });
    };
    DroppableDirective.prototype.ngOnDestroy = function () {
        this.drakesService.remove(this);
    };
    DroppableDirective.decorators = [
        { type: core_es5["Directive"], args: [{ selector: '[ngxDroppable]' },] },
    ];
    /** @nocollapse */
    DroppableDirective.ctorParameters = function () { return [
        { type: core_es5["ElementRef"], },
        { type: core_es5["Renderer"], },
        { type: drake_store_service_DrakeStoreService, },
    ]; };
    DroppableDirective.propDecorators = {
        'model': [{ type: core_es5["Input"] },],
        'copy': [{ type: core_es5["Input"] },],
        'removeOnSpill': [{ type: core_es5["Input"] },],
        'ngxDroppable': [{ type: core_es5["Input"] },],
        'drop': [{ type: core_es5["Output"] },],
        'drag': [{ type: core_es5["Output"] },],
        'over': [{ type: core_es5["Output"] },],
        'out': [{ type: core_es5["Output"] },],
        'remove': [{ type: core_es5["Output"] },],
        'cancel': [{ type: core_es5["Output"] },],
        'dropZone': [{ type: core_es5["Input"] },],
    };
    return DroppableDirective;
}());

//# sourceMappingURL=ngx-droppable.directive.js.map
// CONCATENATED MODULE: ./node_modules/@swimlane/ngx-dnd/release/directives/ngx-draggable.directive.js



/**
 * Adds properties and events to draggable elements
 *
 * @export
 * @class DraggableDirective
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
var ngx_draggable_directive_DraggableDirective = (function () {
    function DraggableDirective(el, drakesService, droppableDirective) {
        this.el = el;
        this.drakesService = drakesService;
        this.droppableDirective = droppableDirective;
        this._moves = true;
        /*
        ContentChildren doesn't get children created with NgTemplateOutlet
        See https://github.com/angular/angular/issues/14842
        Implemented via updateElements method
        
        @ContentChildren(DragHandleDirective, {descendants: true})
        handlesList: QueryList<DragHandleDirective>; */
        this.handles = [];
        this.drag = new core_es5["EventEmitter"]();
        this.dragDelay = 200; // milliseconds
        this.dragDelayed = true;
    }
    Object.defineProperty(DraggableDirective.prototype, "dropZones", {
        get: function () {
            return this._dropZones || this.ngxDraggable || this._parentDropzones;
        },
        set: function (val) {
            this._dropZones = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggableDirective.prototype, "hasHandle", {
        get: function () {
            return !!this.handles.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggableDirective.prototype, "element", {
        get: function () {
            return this.el.nativeElement;
        },
        enumerable: true,
        configurable: true
    });
    // From: https://github.com/bevacqua/dragula/issues/289#issuecomment-277143172
    DraggableDirective.prototype.onMove = function (e) {
        if (!this._moves || this.dragDelayed) {
            e.stopPropagation();
            clearTimeout(this.touchTimeout);
        }
    };
    DraggableDirective.prototype.onDown = function (e) {
        var _this = this;
        if (this._moves) {
            this.touchTimeout = setTimeout(function () {
                _this.dragDelayed = false;
            }, this.dragDelay);
        }
    };
    DraggableDirective.prototype.onUp = function (e) {
        if (this._moves) {
            clearTimeout(this.touchTimeout);
            this.dragDelayed = true;
        }
    };
    DraggableDirective.prototype.ngOnInit = function () {
        this.update();
    };
    DraggableDirective.prototype.update = function () {
        this._parentDropzones = [this.droppableDirective.dropZone];
        this.drakesService.registerDraggable(this);
        this.updateElements();
    };
    DraggableDirective.prototype.ngOnDestroy = function () {
        this.drakesService.removeDraggable(this);
    };
    DraggableDirective.prototype.updateElements = function () {
        var nativeElement = this.el.nativeElement;
        var handles = nativeElement.querySelectorAll('[ngxdraghandle]');
        this.handles = Array.from(handles).filter(function (h) { return findFirstDraggableParent(h) === nativeElement; });
        function findFirstDraggableParent(c) {
            while (c.parentNode) {
                c = c.parentNode;
                if (c.hasAttribute && c.hasAttribute('ngxdraggable')) {
                    return c;
                }
            }
        }
    };
    DraggableDirective.prototype.canMove = function (source, handle, sibling) {
        if (typeof this._moves === 'boolean')
            return this._moves;
        if (typeof this._moves === 'function')
            return this._moves(this.model, source, handle, sibling);
        return true;
    };
    DraggableDirective.prototype.moves = function (source, handle, sibling) {
        if (!this.canMove(source, handle, sibling))
            return false;
        return this.hasHandle ?
            this.handles.some(function (h) { return handelFor(handle, h); }) :
            true;
        function handelFor(c, p) {
            if (c === p)
                return true;
            while ((c = c.parentNode) && c !== p)
                ; // tslint:disable-line
            return !!c;
        }
    };
    DraggableDirective.prototype.ngDoCheck = function () {
        this.updateElements();
    };
    DraggableDirective.decorators = [
        { type: core_es5["Directive"], args: [{ selector: '[ngxDraggable]' },] },
    ];
    /** @nocollapse */
    DraggableDirective.ctorParameters = function () { return [
        { type: core_es5["ElementRef"], },
        { type: drake_store_service_DrakeStoreService, },
        { type: ngx_droppable_directive_DroppableDirective, },
    ]; };
    DraggableDirective.propDecorators = {
        'ngxDraggable': [{ type: core_es5["Input"] },],
        'model': [{ type: core_es5["Input"] },],
        'dropZones': [{ type: core_es5["Input"] },],
        '_moves': [{ type: core_es5["Input"], args: ['moves',] },],
        'drag': [{ type: core_es5["Output"] },],
        'onMove': [{ type: core_es5["HostListener"], args: ['touchmove', ['$event'],] },],
        'onDown': [{ type: core_es5["HostListener"], args: ['touchstart', ['$event'],] },],
        'onUp': [{ type: core_es5["HostListener"], args: ['touchend', ['$event'],] },],
    };
    return DraggableDirective;
}());

//# sourceMappingURL=ngx-draggable.directive.js.map
// CONCATENATED MODULE: ./app/components/Managment/orderManagement/order-column-modal/order-column-modal.component.ts








var order_column_modal_component_OrderColumnModalComponent = /** @class */ (function () {
    function OrderColumnModalComponent(userViewService) {
        this.userViewService = userViewService;
        this.columnsSaved = new core_es5["EventEmitter"]();
        this.sortChanged = new core_es5["EventEmitter"]();
        this.columns = [];
        this.sortType = users_user["b" /* SortType */];
        this.isSortChanged = null;
        this.isSaving = false;
    }
    Object.defineProperty(OrderColumnModalComponent.prototype, "isMoreThanOneSelected", {
        get: function () {
            return this.columns.find(function (c) { return c.IsSelected == true; }) != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderColumnModalComponent.prototype, "title", {
        get: function () {
            if (!this.config)
                return 'Edit Tile';
            return this.config.ViewType == orderViewType["a" /* OrderViewType */].Table ? 'Edit Table' : 'Edit Tile';
        },
        enumerable: true,
        configurable: true
    });
    OrderColumnModalComponent.prototype.show = function (config) {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            var _this = this;
            return tslib_es6["d" /* __generator */](this, function (_a) {
                this.config = config;
                this.currentConfig = JSON.parse(JSON.stringify(config));
                this.columns = this.currentConfig.ColumnsConfigs.find(function (x) { return x.Type == _this.config.ViewType; }).Columns;
                this.columns.sort(function (a, b) {
                    return a.Index - b.Index;
                });
                this.orderColumnModal.show();
                blurUtil["a" /* BlurUtil */].blurMenu(this.idToBlur);
                this.isSortChanged = false;
                return [2 /*return*/];
            });
        });
    };
    OrderColumnModalComponent.prototype.ngOnInit = function () {
        perfect_scrollbar["initialize"](this.orderColumnModalRef.nativeElement);
    };
    OrderColumnModalComponent.prototype.onModalHidden = function () {
        blurUtil["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
    };
    OrderColumnModalComponent.prototype.save = function () {
        var _this = this;
        if (!this.isMoreThanOneSelected || this.isSaving)
            return;
        this.isSaving = true;
        this.userViewService.userView[component["a" /* Component */].OrderManagement] = JSON.parse(JSON.stringify(this.currentConfig));
        this.userViewService.modify(this.currentConfig).then(function (x) {
            _this.userViewService.userView[component["a" /* Component */].OrderManagement] = x.Data;
            _this.orderColumnModal.hide();
            _this.isSaving = false;
        });
        this.columnsSaved.emit();
        if (this.isSortChanged == true)
            this.sortChanged.emit(true);
    };
    OrderColumnModalComponent.prototype.setSort = function (sortType, column) {
        this.columns.forEach(function (c) { return c.SortType = users_user["b" /* SortType */].None; });
        column.SortType = sortType;
        this.isSortChanged = true;
    };
    OrderColumnModalComponent.prototype.handleDrop = function (event) {
        var index = Array.prototype.indexOf.call(event.source.children, event.el); // t.dropIndex;
        index += 1;
        if (event.value.Index > index) {
            this.columns.filter(function (x) { return x.Index >= index && x.Index < event.value.Index; }).forEach(function (x) { return x.Index += 1; });
        }
        if (event.value.Index < index) {
            this.columns.filter(function (x) { return x.Index > event.value.Index && x.Index <= index; }).forEach(function (x) { return x.Index -= 1; });
        }
        event.value.Index = index;
    };
    OrderColumnModalComponent.prototype.isLocationField = function (column) {
        if (column.Name == 'Shipment From' || column.Name == 'Shipment To')
            return true;
        return false;
    };
    OrderColumnModalComponent.ctorParameters = function () { return [{ type: services_userViewService["a" /* UserViewService */] }]; };
    return OrderColumnModalComponent;
}());

//# sourceMappingURL=order-column-modal.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/orderManagement/order-column-modal/order-column-modal.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */













var styles_OrderColumnModalComponent = [];
var RenderType_OrderColumnModalComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_OrderColumnModalComponent, data: {} });
function View_OrderColumnModalComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 24, 'div', [['class',
                'col-xs-5 btn-container-flex']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'span', [['class', 'margin-right-10 text-gray']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'color-primary': 0 }),
        (_l()(), core_es5["ɵted"](null, ['Sort'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 7, 'button', [['class', 'close btn btn-round'],
            ['type', 'button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setSort(_co.sortType.Asc, _v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'btn-primary': 0, 'btn-white': 1 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['arrow_upward'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'button', [['class',
                'close btn btn-round margin-right-5'], ['type', 'button']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setSort(_co.sortType.Desc, _v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'btn-primary': 0, 'btn-white': 1 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['arrow_downward'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'margin-right-10 text-gray';
        var currVal_1 = _ck(_v, 4, 0, ((_v.parent.context.$implicit.SortType == _co.sortType.Desc) || (_v.parent.context.$implicit.SortType == _co.sortType.Asc)));
        _ck(_v, 3, 0, currVal_0, currVal_1);
        var currVal_2 = 'close btn btn-round';
        var currVal_3 = _ck(_v, 9, 0, (_v.parent.context.$implicit.SortType == _co.sortType.Asc), (_v.parent.context.$implicit.SortType != _co.sortType.Asc));
        _ck(_v, 8, 0, currVal_2, currVal_3);
        var currVal_4 = 'close btn btn-round margin-right-5';
        var currVal_5 = _ck(_v, 18, 0, (_v.parent.context.$implicit.SortType == _co.sortType.Desc), (_v.parent.context.$implicit.SortType != _co.sortType.Desc));
        _ck(_v, 17, 0, currVal_4, currVal_5);
    }, null);
}
function View_OrderColumnModalComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class',
                'col-sm-12 margin-top-5 margin-bottom-5'], ['ngxDraggable', '']], null, [[null, 'touchmove'], [null, 'touchstart'], [null, 'touchend']], function (_v, en, $event) {
            var ad = true;
            if (('touchmove' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onMove($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('touchstart' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 1).onDown($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('touchend' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 1).onUp($event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](475136, null, 0, ngx_draggable_directive_DraggableDirective, [core_es5["ElementRef"], drake_store_service_DrakeStoreService, ngx_droppable_directive_DroppableDirective], { ngxDraggable: [0,
                'ngxDraggable'], model: [1, 'model'], _moves: [2, '_moves'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'row margin-0 bordered display-flex']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'col-xs-7']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [], [[8, 'id', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.context.$implicit.IsSelected = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { label: [0, 'label'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_OrderColumnModalComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = '';
        var currVal_1 = _v.context.$implicit;
        var currVal_2 = _v.context.$implicit.IsSelected;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2);
        var currVal_11 = _v.context.$implicit.Name;
        _ck(_v, 8, 0, currVal_11);
        var currVal_12 = _v.context.$implicit.IsSelected;
        _ck(_v, 10, 0, currVal_12);
        var currVal_13 = (_v.context.$implicit.IsSelected && !_co.isLocationField(_v.context.$implicit));
        _ck(_v, 17, 0, currVal_13);
    }, function (_ck, _v) {
        var currVal_3 = core_es5["ɵinlineInterpolate"](1, 'checkbox_', _v.context.$implicit.Name, '');
        var currVal_4 = core_es5["ɵnov"](_v, 12).ngClassUntouched;
        var currVal_5 = core_es5["ɵnov"](_v, 12).ngClassTouched;
        var currVal_6 = core_es5["ɵnov"](_v, 12).ngClassPristine;
        var currVal_7 = core_es5["ɵnov"](_v, 12).ngClassDirty;
        var currVal_8 = core_es5["ɵnov"](_v, 12).ngClassValid;
        var currVal_9 = core_es5["ɵnov"](_v, 12).ngClassInvalid;
        var currVal_10 = core_es5["ɵnov"](_v, 12).ngClassPending;
        _ck(_v, 7, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10);
    });
}
function View_OrderColumnModalComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'col-sm-12 text-danger text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Please select preferred fields']))], null, null);
}
function View_OrderColumnModalComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { orderColumnModal: 0 }), core_es5["ɵqud"](402653184, 2, { orderColumnForm: 0 }), core_es5["ɵqud"](402653184, 3, { orderColumnModalRef: 0 }), (_l()(), core_es5["ɵeld"](16777216, [[3, 0], ['orderColumnModalRef', 1]], null, 46, 'div', [['bsModal', ''], ['class',
                'modal fade customer-modal'], ['id', 'myModal'], ['role', 'dialog']], null, [[null, 'onHidden'], [null, 'click'], [null, 'keydown.esc']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown.esc' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 4).onEsc() !== false);
                ad = (pd_1 && ad);
            }
            if (('onHidden' === en)) {
                var pd_2 = (_co.onModalHidden() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4341760, [[1, 4], ['orderColumnModal', 4]], 0, modal_component["a" /* ModalDirective */], [core_es5["ElementRef"], core_es5["ViewContainerRef"], core_es5["Renderer"], component_loader_factory["a" /* ComponentLoaderFactory */]], null, { onHidden: 'onHidden' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 42, 'div', [['class', 'modal-dialog modal-sm'],
                ['role', 'document']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 39, 'div', [['class', 'modal-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'modal-header header']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'modal-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['aria-label', 'Close'], ['class', 'close pull-right btn btn-round btn-white modal-close-btn'],
            ['data-dismiss', 'modal'], ['type', 'button']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).hide() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons modal-close-icon']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['close'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 24, 'div', [['class', 'modal-body']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'text-gray bold margin-top-10 margin-bottom-5']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['Columns'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'row'], ['ngxDroppable',
                    '']], null, [[null, 'drop']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('drop' === en)) {
                    var pd_0 = (_co.handleDrop($event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](4407296, null, 0, ngx_droppable_directive_DroppableDirective, [core_es5["ElementRef"], core_es5["Renderer"], drake_store_service_DrakeStoreService], { model: [0, 'model'], ngxDroppable: [1,
                'ngxDroppable'] }, { drop: 'drop' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_OrderColumnModalComponent_1)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderColumnModalComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-white-orange btn-round'],
                ['type', 'submit']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.save() !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Save '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.columns;
        var currVal_2 = '';
        _ck(_v, 30, 0, currVal_1, currVal_2);
        var currVal_3 = _co.columns;
        _ck(_v, 33, 0, currVal_3);
        var currVal_4 = !_co.isMoreThanOneSelected;
        _ck(_v, 38, 0, currVal_4);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.title;
        _ck(_v, 13, 0, currVal_0);
        var currVal_5 = (!_co.isMoreThanOneSelected || _co.isSaving);
        _ck(_v, 42, 0, currVal_5);
    });
}
function View_OrderColumnModalComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-column-modal', [], null, null, null, View_OrderColumnModalComponent_0, RenderType_OrderColumnModalComponent)), core_es5["ɵdid"](114688, null, 0, order_column_modal_component_OrderColumnModalComponent, [services_userViewService["a" /* UserViewService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var OrderColumnModalComponentNgFactory = core_es5["ɵccf"]('order-column-modal', order_column_modal_component_OrderColumnModalComponent, View_OrderColumnModalComponent_Host_0, { idToBlur: 'idToBlur' }, { columnsSaved: 'columnsSaved', sortChanged: 'sortChanged' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=order-column-modal.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/Managment/orderManagement/order-export-modal/order-export-modal.component.ts




var order_export_modal_component_OrderExportModalComponent = /** @class */ (function () {
    function OrderExportModalComponent(configService) {
        this.configService = configService;
        this.optionFrom = {
            dateFormat: 'mm.dd.yyyy',
        };
        this.optionTo = {
            dateFormat: 'mm.dd.yyyy',
        };
    }
    OrderExportModalComponent.prototype.show = function () {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            return tslib_es6["d" /* __generator */](this, function (_a) {
                this.dpList.forEach(function (dp) { return dp.clearDate(); });
                this.orderExportModal.show();
                blurUtil["a" /* BlurUtil */].blurMenu(this.idToBlur);
                this.dateFrom = null;
                this.dateTo = null;
                return [2 /*return*/];
            });
        });
    };
    OrderExportModalComponent.prototype.ngOnInit = function () {
        perfect_scrollbar["initialize"](this.orderExportModalRef.nativeElement);
    };
    OrderExportModalComponent.prototype.onModalHidden = function () {
        blurUtil["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
    };
    OrderExportModalComponent.prototype.exportOrders = function (isValid) {
        if (!isValid)
            return;
        window.open(this.configService.config.AdminUrl + "/order/export/all?datefrom=" + this.dateFrom + "&dateto=" + this.dateTo, '_blank'); // TODO add params
        this.orderExportModal.hide();
    };
    OrderExportModalComponent.prototype.handleDateFrom = function (event) {
        this.dateFrom = this.getDate(event.date);
        this.disableUntil(event.date);
    };
    OrderExportModalComponent.prototype.handleDateTo = function (event) {
        this.dateTo = this.getDate(event.date);
        this.disableSince(event.date);
    };
    OrderExportModalComponent.prototype.getDate = function (date) {
        return new Date(date['year'], date['month'] - 1, date['day'], 0, 0, 0);
    };
    OrderExportModalComponent.prototype.disableUntil = function (date) {
        var copy = this.getCopyOfOptions(this.optionTo);
        copy.disableUntil = { year: date.year,
            month: date.month,
            day: date.day };
        this.optionTo = copy;
    };
    OrderExportModalComponent.prototype.disableSince = function (date) {
        var copy = this.getCopyOfOptions(this.optionFrom);
        copy.disableSince = { year: date.year,
            month: date.month,
            day: date.day };
        this.optionFrom = copy;
    };
    // Returns copy of myOptions
    OrderExportModalComponent.prototype.getCopyOfOptions = function (val) {
        return JSON.parse(JSON.stringify(val));
    };
    OrderExportModalComponent.ctorParameters = function () { return [{ type: services_configService["a" /* ConfigService */] }]; };
    return OrderExportModalComponent;
}());

//# sourceMappingURL=order-export-modal.component.js.map
// CONCATENATED MODULE: ./app/components/common/datepicker/datepicker.component.ts

var datepicker_component_DatePickerComponent = /** @class */ (function () {
    function DatePickerComponent() {
        this.onDateChange = new core_es5["EventEmitter"]();
        this.model = { date: { year: 2018, month: 10, day: 9 } };
    }
    DatePickerComponent.prototype.onDateChanged = function (event) {
        this.onDateChange.emit(event);
    };
    DatePickerComponent.prototype.changeOption = function (opt) {
        this.ngxdp.options = opt;
    };
    DatePickerComponent.prototype.clearDate = function () {
        this.ngxdp.clearDate();
    };
    DatePickerComponent.ctorParameters = function () { return []; };
    return DatePickerComponent;
}());

//# sourceMappingURL=datepicker.component.js.map
// EXTERNAL MODULE: ./node_modules/ngx-mydatepicker/dist/ngx-my-date-picker.input.js + 1 modules
var ngx_my_date_picker_input = __webpack_require__("10nP");

// EXTERNAL MODULE: ./node_modules/ngx-mydatepicker/dist/services/ngx-my-date-picker.config.js
var ngx_my_date_picker_config = __webpack_require__("GVXd");

// CONCATENATED MODULE: ./compiled/app/components/common/datepicker/datepicker.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_DatePickerComponent = [];
var RenderType_DatePickerComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DatePickerComponent, data: {} });
function View_DatePickerComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { ngxdp: 0 }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](16777216, null, null, 3, 'input', [['class', 'cursor-pointer form-control'], ['name',
                'mydate'], ['ngx-mydatepicker', ''], ['placeholder', 'Select a date'], ['readonly',
                'readonly'], ['required', ''], ['style', 'float:none']], [[8, 'name', 0]], [[null,
                'click'], [null, 'dateChanged'], [null, 'keyup'], [null,
                'blur'], ['document', 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('keyup' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 7).onKeyUp($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 7).onBlur() !== false);
                ad = (pd_1 && ad);
            }
            if (('document:click' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 7).onClick($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('click' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 7).openCalendar() !== false);
                ad = (pd_3 && ad);
            }
            if (('dateChanged' === en)) {
                var pd_4 = (_co.onDateChanged($event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵprd"](5120, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [ngx_my_date_picker_input["a" /* NgxMyDatePickerDirective */]]), core_es5["ɵprd"](512, null, ngx_my_date_picker_util_service["a" /* UtilService */], ngx_my_date_picker_util_service["a" /* UtilService */], []), core_es5["ɵdid"](540672, [[1, 4], ['dp', 4]], 0, ngx_my_date_picker_input["a" /* NgxMyDatePickerDirective */], [ngx_my_date_picker_util_service["a" /* UtilService */], core_es5["ViewContainerRef"], core_es5["ComponentFactoryResolver"], core_es5["Renderer"],
            core_es5["ChangeDetectorRef"], core_es5["ElementRef"], ngx_my_date_picker_config["a" /* NgxMyDatePickerConfig */]], { options: [0,
                'options'] }, { dateChanged: 'dateChanged' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.myOptions;
        _ck(_v, 7, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.name;
        _ck(_v, 4, 0, currVal_0);
    });
}
function View_DatePickerComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'date-picker', [], null, null, null, View_DatePickerComponent_0, RenderType_DatePickerComponent)), core_es5["ɵdid"](49152, null, 0, datepicker_component_DatePickerComponent, [], null, null)], null, null);
}
var DatePickerComponentNgFactory = core_es5["ɵccf"]('date-picker', datepicker_component_DatePickerComponent, View_DatePickerComponent_Host_0, { name: 'name', myOptions: 'myOptions' }, { onDateChange: 'onDateChange' }, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL2RhdGVwaWNrZXIvZGF0ZXBpY2tlci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL2RhdGVwaWNrZXIvZGF0ZXBpY2tlci5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9jb21tb24vZGF0ZXBpY2tlci9kYXRlcGlja2VyLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL2RhdGVwaWNrZXIvZGF0ZXBpY2tlci5jb21wb25lbnQudHMuRGF0ZVBpY2tlckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIiA8ZGl2IGNsYXNzPVwiaW5wdXQtZ3JvdXBcIj4gPGlucHV0IGNsYXNzPVwiY3Vyc29yLXBvaW50ZXIgZm9ybS1jb250cm9sXCIgc3R5bGU9XCJmbG9hdDpub25lXCIgcGxhY2Vob2xkZXI9XCJTZWxlY3QgYSBkYXRlXCIgbmd4LW15ZGF0ZXBpY2tlciBuYW1lPVwibXlkYXRlXCIgKGNsaWNrKT1cImRwLm9wZW5DYWxlbmRhcigpXCIgcmVhZG9ubHk9XCJyZWFkb25seVwiIFtvcHRpb25zXT1cIm15T3B0aW9uc1wiICNkcD1cIm5neC1teWRhdGVwaWNrZXJcIiAoZGF0ZUNoYW5nZWQpPVwib25EYXRlQ2hhbmdlZCgkZXZlbnQpXCIgW25hbWVdPVwibmFtZVwiIHJlcXVpcmVkPVwiXCIvPiA8L2Rpdj4gIiwiPGRhdGUtcGlja2VyPjwvZGF0ZS1waWNrZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7O21EQ0FBO01BQUM7VUFBQTtNQUF5QixzQ0FBQztVQUFBO2NBQUE7Y0FBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQXlIO2NBQUE7Y0FBQTtZQUFBO1lBQTZGO2NBQUE7Y0FBQTtZQUFBO1lBQXROO1VBQUE7VUFBQTtZQUFBO1VBQUE7eUJBQUEsc0JBQUE7VUFBQTt5RUFBQTtjQUFBLHlDQUF1UjtVQUFBLFFBQU87O0lBQXJIO0lBQXpLLFdBQXlLLFNBQXpLOzs7SUFBNFA7SUFBNVAsV0FBNFAsU0FBNVA7Ozs7b0JDQTNCO01BQUE7b0NBQUEsVUFBQTtNQUFBOzs7OyJ9
//# sourceMappingURL=datepicker.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/orderManagement/order-export-modal/order-export-modal.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */











var styles_OrderExportModalComponent = [];
var RenderType_OrderExportModalComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_OrderExportModalComponent, data: {} });
function View_OrderExportModalComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { orderExportModal: 0 }), core_es5["ɵqud"](402653184, 2, { exportForm: 0 }), core_es5["ɵqud"](402653184, 3, { orderExportModalRef: 0 }), core_es5["ɵqud"](671088640, 4, { dpList: 1 }), (_l()(), core_es5["ɵeld"](16777216, [[3, 0], ['orderExportModalRef', 1]], null, 95, 'div', [['bsModal', ''], ['class', 'modal fade customer-modal edit-filters-modal'],
            ['id', 'myModal'], ['role', 'dialog']], null, [[null, 'onHidden'],
            [null, 'click'], [null, 'keydown.esc']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 5).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown.esc' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 5).onEsc() !== false);
                ad = (pd_1 && ad);
            }
            if (('onHidden' === en)) {
                var pd_2 = (_co.onModalHidden() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4341760, [[1, 4], ['orderExportModal', 4]], 0, modal_component["a" /* ModalDirective */], [core_es5["ElementRef"], core_es5["ViewContainerRef"], core_es5["Renderer"], component_loader_factory["a" /* ComponentLoaderFactory */]], null, { onHidden: 'onHidden' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 91, 'div', [['class', 'modal-dialog modal-sm'],
                ['role', 'document']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 88, 'div', [['class', 'modal-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'modal-header header']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'modal-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['EDIT FILTERS'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['aria-label', 'Close'], ['class', 'close pull-right btn btn-round btn-white modal-close-btn'],
            ['data-dismiss', 'modal'], ['type', 'button']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 5).hide() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons modal-close-icon']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['close'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 73, 'div', [['class', 'modal-body']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 70, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 67, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 64, 'div', [['class', 'col-xs-12 padding-top-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'row margin-0 bordered no-border-bottom']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'col-xs-12 text-gray bold margin-bottom-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'checkbox', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], null, null, View_CheckboxComponent_0, RenderType_CheckboxComponent)),
        core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2,
                forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], disabled: [2,
                'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, null),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 48, 'form', [['class', 'form-horizontal padding-0'], ['novalidate', '']], [[2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngSubmit'], [null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 46).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 46).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.exportOrders(core_es5["ɵnov"](_v, 46).valid) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[2, 4], ['exportForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 41, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 28, 'div', [['class',
                'bordered no-border-top padding-left-10 padding-right-10 padding-bottom-15 margin-bottom-10']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'row margin-0']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 22, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-sm-6 line-form text-center date-picker-inner']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class',
                'text-black']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['From'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'date-picker', [], null, [[null, 'onDateChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onDateChange' === en)) {
                var pd_0 = (_co.handleDateFrom($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_DatePickerComponent_0, RenderType_DatePickerComponent)), core_es5["ɵdid"](49152, [[4, 4]], 0, datepicker_component_DatePickerComponent, [], { name: [0, 'name'], myOptions: [1,
                'myOptions'] }, { onDateChange: 'onDateChange' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-sm-6 line-form text-center date-picker-inner']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'text-black']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['To'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'date-picker', [], null, [[null, 'onDateChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onDateChange' === en)) {
                var pd_0 = (_co.handleDateTo($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_DatePickerComponent_0, RenderType_DatePickerComponent)), core_es5["ɵdid"](49152, [[4, 4]], 0, datepicker_component_DatePickerComponent, [], { name: [0, 'name'], myOptions: [1,
                'myOptions'] }, { onDateChange: 'onDateChange' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'row row-btn']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'col-sm-12 text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-white-orange btn-round'],
            ['type', 'submit']], [[8, 'disabled', 0]], null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"],
            core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Apply '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'Created Date';
        var currVal_8 = 'Created Date';
        var currVal_9 = true;
        _ck(_v, 36, 0, currVal_7, currVal_8, currVal_9);
        var currVal_10 = 'Created Date';
        var currVal_11 = true;
        var currVal_12 = true;
        _ck(_v, 38, 0, currVal_10, currVal_11, currVal_12);
        var currVal_20 = _co.dateFrom;
        var currVal_21 = _co.optionFrom;
        _ck(_v, 66, 0, currVal_20, currVal_21);
        var currVal_22 = _co.dateTo;
        var currVal_23 = _co.optionTo;
        _ck(_v, 75, 0, currVal_22, currVal_23);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵnov"](_v, 40).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 40).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 40).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 40).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 40).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 40).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 40).ngClassPending;
        _ck(_v, 35, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_13 = core_es5["ɵnov"](_v, 48).ngClassUntouched;
        var currVal_14 = core_es5["ɵnov"](_v, 48).ngClassTouched;
        var currVal_15 = core_es5["ɵnov"](_v, 48).ngClassPristine;
        var currVal_16 = core_es5["ɵnov"](_v, 48).ngClassDirty;
        var currVal_17 = core_es5["ɵnov"](_v, 48).ngClassValid;
        var currVal_18 = core_es5["ɵnov"](_v, 48).ngClassInvalid;
        var currVal_19 = core_es5["ɵnov"](_v, 48).ngClassPending;
        _ck(_v, 44, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19);
        var currVal_24 = ((core_es5["ɵnov"](_v, 46).submitted && !core_es5["ɵnov"](_v, 46).valid) || ((_co.dateTo == null) || (_co.dateFrom == null)));
        _ck(_v, 86, 0, currVal_24);
    });
}
function View_OrderExportModalComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-export-modal', [], null, null, null, View_OrderExportModalComponent_0, RenderType_OrderExportModalComponent)), core_es5["ɵdid"](114688, null, 0, order_export_modal_component_OrderExportModalComponent, [services_configService["a" /* ConfigService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var OrderExportModalComponentNgFactory = core_es5["ɵccf"]('order-export-modal', order_export_modal_component_OrderExportModalComponent, View_OrderExportModalComponent_Host_0, { idToBlur: 'idToBlur' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=order-export-modal.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/orderManagement/orderManagement.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


























var styles_OrderManagementComponent = [];
var RenderType_OrderManagementComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_OrderManagementComponent, data: {} });
function View_OrderManagementComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'button', [['class',
                'btn btn-white btn-round btn-just-icon create-icon']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v.parent, 1).show(_co.userViewService.userView[_co.componentEnum.OrderManagement]) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['mode_edit'])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_OrderManagementComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'button', [['class',
                'btn btn-white btn-round btn-just-icon create-icon']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.toggleView() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['view_module'])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_OrderManagementComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-item', [], null, null, null, View_OrderItemComponent_0, RenderType_OrderItemComponent)), core_es5["ɵdid"](49152, null, 0, orderItem_component_OrderItemComponent, [router_es5["n" /* Router */], router_es5["a" /* ActivatedRoute */]], { order: [0, 'order'], paramsInUrl: [1, 'paramsInUrl'],
            columns: [2, 'columns'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _v.context.$implicit;
        var currVal_1 = _co.getSearchParams();
        var currVal_2 = _co.tableColumns;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2);
    }, null);
}
function View_OrderManagementComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_OrderManagementComponent_5)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), core_es5["ɵpid"](0, PaginatePipe, [ngx_pagination_PaginationService]),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 3, 0, core_es5["ɵnov"](_v, 4).transform(_co.orders, _co.config));
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_OrderManagementComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'row'], ['style', 'text-align:center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h2', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' No matching results! '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_OrderManagementComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'management-pagination', [], null, [[null, 'searchEventEmitter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('searchEventEmitter' === en)) {
                var pd_0 = (_co.search((_co.agentId == null)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ManagementPaginationComponent_0, RenderType_ManagementPaginationComponent)),
        core_es5["ɵdid"](49152, null, 0, managementPagination_component_ManagementPaginationComponent, [], { config: [0, 'config'] }, { searchEventEmitter: 'searchEventEmitter' }), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.config;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_OrderManagementComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 10, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderManagementComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderManagementComponent_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderManagementComponent_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.orders.length > 0);
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = (_co.orders.length == 0);
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = (_co.orders.length > 0);
        _ck(_v, 9, 0, currVal_2);
    }, null);
}
function View_OrderManagementComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'spinner']], null, null, null, null, null))], null, null);
}
function View_OrderManagementComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'order-table-view', [['class', 'order-table-view']], null, [[null,
                'searchEvent']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('searchEvent' === en)) {
                var pd_0 = (_co.handleTableSearch($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_OrderTableViewComponent_0, RenderType_OrderTableViewComponent)),
        core_es5["ɵdid"](49152, null, 0, order_table_view_component_OrderTableViewComponent, [router_es5["a" /* ActivatedRoute */],
            services_configService["a" /* ConfigService */], core_es5["ElementRef"], router_es5["n" /* Router */], services_userViewService["a" /* UserViewService */]], { config: [0,
                'config'], paramsInUrl: [1, 'paramsInUrl'], orders: [2, 'orders'], isLoading: [3,
                'isLoading'], tableColumns: [4, 'tableColumns'] }, { searchEvent: 'searchEvent' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.config;
        var currVal_1 = _co.getSearchParams();
        var currVal_2 = _co.orders;
        var currVal_3 = _co.isLoading;
        var currVal_4 = _co.tableColumns;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4);
    }, null);
}
function View_OrderManagementComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-column-modal', [['class', 'order-column-modal']], null, [[null, 'columnsSaved'],
            [null, 'sortChanged']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('columnsSaved' === en)) {
                var pd_0 = (_co.updateColumns($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('sortChanged' === en)) {
                _co.config.currentPage = 1;
                var pd_1 = (_co.search() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_OrderColumnModalComponent_0, RenderType_OrderColumnModalComponent)),
        core_es5["ɵdid"](114688, [['columnModal', 4]], 0, order_column_modal_component_OrderColumnModalComponent, [services_userViewService["a" /* UserViewService */]], { idToBlur: [0, 'idToBlur'] }, { columnsSaved: 'columnsSaved', sortChanged: 'sortChanged' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-export-modal', [], null, null, null, View_OrderExportModalComponent_0, RenderType_OrderExportModalComponent)),
        core_es5["ɵdid"](114688, [['exportModal', 4]], 0, order_export_modal_component_OrderExportModalComponent, [services_configService["a" /* ConfigService */]], { idToBlur: [0, 'idToBlur'] }, null), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 30, 'div', [['class', 'main-content']], [[1, 'id', 0]], null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 27, 'div', [['class', 'container-fluid']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 15, 'management-search', [['createIcon',
                    'iso'], ['helpText', 'Search by Order|Quote ID, Customer Name, Customer email, Company Name']], null, [[null, 'searchEventEmitter'], [null, 'queryChange'],
                [null, 'createEventEmitter']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('searchEventEmitter' === en)) {
                    _co.config.currentPage = 1;
                    _co.search();
                    var pd_0 = ((_co.isTableShown = false) !== false);
                    ad = (pd_0 && ad);
                }
                if (('queryChange' === en)) {
                    var pd_1 = ((_co.query = $event) !== false);
                    ad = (pd_1 && ad);
                }
                if (('createEventEmitter' === en)) {
                    var pd_2 = (_co.createEvent() !== false);
                    ad = (pd_2 && ad);
                }
                return ad;
            }, View_ManagementSearchComponent_0, RenderType_ManagementSearchComponent)),
        core_es5["ɵdid"](49152, null, 0, managementSearch_component_ManagementSearchComponent, [], { showCreate: [0,
                'showCreate'], createIcon: [1, 'createIcon'], helpText: [2, 'helpText'], query: [3,
                'query'], showCleanFilter: [4, 'showCleanFilter'] }, { searchEventEmitter: 'searchEventEmitter',
            createEventEmitter: 'createEventEmitter', queryChange: 'queryChange' }), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 5, 'button', [['class',
                'btn btn-white btn-round btn-just-icon create-icon']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).show() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['file_download'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_OrderManagementComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_OrderManagementComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderManagementComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderManagementComponent_8)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderManagementComponent_9)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.idToBlur;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _co.idToBlur;
        _ck(_v, 4, 0, currVal_1);
        var currVal_3 = true;
        var currVal_4 = 'iso';
        var currVal_5 = 'Search by Order|Quote ID, Customer Name, Customer email, Company Name';
        var currVal_6 = _co.query;
        var currVal_7 = (_co.agentId != null);
        _ck(_v, 11, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_8 = !_co.isMobileView;
        _ck(_v, 21, 0, currVal_8);
        var currVal_9 = !_co.isMobileView;
        _ck(_v, 24, 0, currVal_9);
        var currVal_10 = (((_co.currentView == _co.orderViewType.Tile) || _co.isMobileView) && !_co.isViewLoading);
        _ck(_v, 28, 0, currVal_10);
        var currVal_11 = _co.isViewLoading;
        _ck(_v, 31, 0, currVal_11);
        var currVal_12 = ((((_co.currentView == _co.orderViewType.Table) && _co.isTableShown) && !_co.isMobileView) && !_co.isViewLoading);
        _ck(_v, 34, 0, currVal_12);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.idToBlur;
        _ck(_v, 6, 0, currVal_2);
    });
}
function View_OrderManagementComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'order', [], null, [['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onResize() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_OrderManagementComponent_0, RenderType_OrderManagementComponent)), core_es5["ɵdid"](114688, null, 0, orderManagement_component_OrderManagementComponent, [router_es5["a" /* ActivatedRoute */], services_orderService["a" /* OrderService */],
            common_es5["Location"], services_customerService["a" /* CustomerService */], services_userService["a" /* UserService */], router_es5["n" /* Router */], services_configService["a" /* ConfigService */],
            managers_storageManager["a" /* StorageManager */], services_userViewService["a" /* UserViewService */], http_es5["e" /* Http */], orderOData_service_OrderODataService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var OrderManagementComponentNgFactory = core_es5["ɵccf"]('order', orderManagement_component_OrderManagementComponent, View_OrderManagementComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=orderManagement.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/objects/amazon/seller.ts
var amazon_seller = __webpack_require__("UB/I");

// CONCATENATED MODULE: ./app/components/Managment/amazon-management/seller/seller-item.component.ts

var seller_item_component_SellerItemComponent = /** @class */ (function () {
    function SellerItemComponent() {
        this.seller = new amazon_seller["a" /* Seller */]();
    }
    return SellerItemComponent;
}());

//# sourceMappingURL=seller-item.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/amazon-management/seller/seller-item.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


var styles_SellerItemComponent = [];
var RenderType_SellerItemComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_SellerItemComponent, data: {} });
function View_SellerItemComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 79, 'div', [['class',
                'col-sp-5 customer-card seller']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 76, 'div', [['class', 'card card-stats quick-order-details']], null, [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.sellerModal.show(_co.seller) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-header'], ['data-background-color',
                    'orange']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['person'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-content']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'category']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 61, 'div', [['class', 'card-footer']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'card-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Company Name: '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-xs-7 card-info short-description']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'card-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Billing Address: '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-xs-7 card-info big-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'card-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Billing Country: '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-xs-7 card-info short-description']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'card-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Phone Number: '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-xs-7 card-info short-description']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'card-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Job Title: '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-xs-7 card-info short-description']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.seller.ContactName;
        _ck(_v, 13, 0, currVal_0);
        var currVal_1 = _co.seller.CompanyName;
        _ck(_v, 27, 0, currVal_1);
        var currVal_2 = _co.seller.BillingAddress;
        _ck(_v, 39, 0, currVal_2);
        var currVal_3 = _co.seller.BillingCountry;
        _ck(_v, 51, 0, currVal_3);
        var currVal_4 = _co.seller.Phone;
        _ck(_v, 63, 0, currVal_4);
        var currVal_5 = _co.seller.JobTitle;
        _ck(_v, 75, 0, currVal_5);
    });
}
function View_SellerItemComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'seller-item', [], null, null, null, View_SellerItemComponent_0, RenderType_SellerItemComponent)), core_es5["ɵdid"](49152, null, 0, seller_item_component_SellerItemComponent, [], null, null)], null, null);
}
var SellerItemComponentNgFactory = core_es5["ɵccf"]('seller-item', seller_item_component_SellerItemComponent, View_SellerItemComponent_Host_0, { seller: 'seller', sellerModal: 'sellerModal' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=seller-item.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/Managment/amazon-management/seller/seller-modal.component.ts





var seller_modal_component_SellerModalComponent = /** @class */ (function () {
    function SellerModalComponent(router) {
        this.router = router;
        this.originalSeller = new amazon_seller["a" /* Seller */]();
        this.currentSeller = new amazon_seller["a" /* Seller */]();
        this.string = String;
        this.number = Number;
    }
    SellerModalComponent.prototype.show = function (seller) {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            return tslib_es6["d" /* __generator */](this, function (_a) {
                this.originalSeller = seller;
                this.currentSeller = JSON.parse(JSON.stringify(seller));
                this.sellerModal.show();
                blurUtil["a" /* BlurUtil */].blurMenu(this.idToBlur);
                return [2 /*return*/];
            });
        });
    };
    SellerModalComponent.prototype.ngOnInit = function () {
        perfect_scrollbar["initialize"](this.sellerModalRef.nativeElement);
    };
    SellerModalComponent.prototype.onModalHidden = function () {
        this.sellerForm.reset();
        blurUtil["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
    };
    SellerModalComponent.prototype.showStore = function (store) {
        blurUtil["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
        this.router.navigate(["management/amazon/seller/" + this.currentSeller.Id + "/store/" + store.Id]);
    };
    SellerModalComponent.ctorParameters = function () { return [{ type: router_es5["n" /* Router */] }]; };
    return SellerModalComponent;
}());

//# sourceMappingURL=seller-modal.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/amazon-management/seller/seller-modal.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_SellerModalComponent = [];
var RenderType_SellerModalComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_SellerModalComponent, data: {} });
function View_SellerModalComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 13, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'customer-card col-md-4 col-sm-6']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.showStore(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'card card-stats quick-order-details quick-order-details-margin']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-content padding-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'text-uppercase brand']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.StoreName;
        _ck(_v, 9, 0, currVal_0);
    });
}
function View_SellerModalComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { sellerModal: 0 }), core_es5["ɵqud"](402653184, 2, { sellerForm: 0 }),
        core_es5["ɵqud"](402653184, 3, { sellerModalRef: 0 }), (_l()(), core_es5["ɵeld"](16777216, [[3, 0], ['sellerModalRef',
                1]], null, 182, 'div', [['bsModal', ''], ['class', 'modal fade customer-modal'],
            ['id', 'myModal'], ['role', 'dialog']], null, [[null, 'onHidden'],
            [null, 'click'], [null, 'keydown.esc']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown.esc' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 4).onEsc() !== false);
                ad = (pd_1 && ad);
            }
            if (('onHidden' === en)) {
                var pd_2 = (_co.onModalHidden() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4341760, [[1, 4], ['sellerModal', 4]], 0, modal_component["a" /* ModalDirective */], [core_es5["ElementRef"], core_es5["ViewContainerRef"], core_es5["Renderer"], component_loader_factory["a" /* ComponentLoaderFactory */]], null, { onHidden: 'onHidden' }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 178, 'div', [['class', 'modal-dialog modal-lg'],
            ['role', 'document']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 175, 'div', [['class', 'modal-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'modal-header header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'modal-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['aria-label',
                'Close'], ['class', 'close pull-right btn btn-round btn-white modal-close-btn'],
            ['data-dismiss', 'modal'], ['type', 'button']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).hide() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons modal-close-icon']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['close'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 152, 'div', [['class', 'modal-body']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 149, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 146, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 143, 'form', [['class',
                'form-horizontal'], ['novalidate', '']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'submit'], [null,
                'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 29).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 29).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[2, 4], ['sellerForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 136, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 133, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-sm-3']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-header thumbnail default-image margin-bottom-0'],
                ['data-background-color', 'orange']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['person'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 121, 'div', [['class', 'col-sm-9']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 118, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'col-sm-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'form-input', [['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentSeller.ContactName = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['contactNameModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class',
                'col-sm-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'form-input', [['required', '']], [[1, 'required',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentSeller.CompanyName = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['companyNameModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class',
                'col-sm-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'form-input', [['required', '']], [[1, 'required',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentSeller.BillingAddress = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['billingAddressModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class',
                'col-sm-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'form-input', [['required', '']], [[1, 'required',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentSeller.BillingCountry = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['billingCountryModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class',
                'col-sm-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'form-input', [['required', '']], [[1, 'required',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentSeller.City = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['cityModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class',
                'col-sm-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'form-input', [['required', '']], [[1, 'required',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentSeller.State = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['stateModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class',
                'col-sm-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'form-input', [['required', '']], [[1, 'required',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentSeller.PostalCode = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['postalCodeModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class',
                'col-sm-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'form-input', [['required', '']], [[1, 'required',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentSeller.Phone = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['phoneModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class',
                'col-sm-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'form-input', [['required', '']], [[1, 'required',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentSeller.JobTitle = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['jobTitleModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'modal-footer']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'row row_quick_order']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SellerModalComponent_1)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_16 = '';
        _ck(_v, 53, 0, currVal_16);
        var currVal_17 = 'text';
        var currVal_18 = 'Contact Name';
        var currVal_19 = 'Contact Name';
        var currVal_20 = true;
        var currVal_21 = core_es5["ɵnov"](_v, 29);
        _ck(_v, 55, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21);
        var currVal_22 = 'Contact Name';
        var currVal_23 = true;
        var currVal_24 = _co.currentSeller.ContactName;
        _ck(_v, 57, 0, currVal_22, currVal_23, currVal_24);
        var currVal_33 = '';
        _ck(_v, 66, 0, currVal_33);
        var currVal_34 = 'text';
        var currVal_35 = 'Company Name';
        var currVal_36 = 'Company Name';
        var currVal_37 = true;
        var currVal_38 = core_es5["ɵnov"](_v, 29);
        _ck(_v, 68, 0, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38);
        var currVal_39 = 'Company Name';
        var currVal_40 = true;
        var currVal_41 = _co.currentSeller.CompanyName;
        _ck(_v, 70, 0, currVal_39, currVal_40, currVal_41);
        var currVal_50 = '';
        _ck(_v, 79, 0, currVal_50);
        var currVal_51 = 'text';
        var currVal_52 = 'Billing Address';
        var currVal_53 = 'Billing Address';
        var currVal_54 = true;
        var currVal_55 = core_es5["ɵnov"](_v, 29);
        _ck(_v, 81, 0, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55);
        var currVal_56 = 'Billing Address';
        var currVal_57 = true;
        var currVal_58 = _co.currentSeller.BillingAddress;
        _ck(_v, 83, 0, currVal_56, currVal_57, currVal_58);
        var currVal_67 = '';
        _ck(_v, 92, 0, currVal_67);
        var currVal_68 = 'text';
        var currVal_69 = 'Billing Country';
        var currVal_70 = 'Billing Country';
        var currVal_71 = true;
        var currVal_72 = core_es5["ɵnov"](_v, 29);
        _ck(_v, 94, 0, currVal_68, currVal_69, currVal_70, currVal_71, currVal_72);
        var currVal_73 = 'Billing Country';
        var currVal_74 = true;
        var currVal_75 = _co.currentSeller.BillingCountry;
        _ck(_v, 96, 0, currVal_73, currVal_74, currVal_75);
        var currVal_84 = '';
        _ck(_v, 105, 0, currVal_84);
        var currVal_85 = 'text';
        var currVal_86 = 'City';
        var currVal_87 = 'City';
        var currVal_88 = true;
        var currVal_89 = core_es5["ɵnov"](_v, 29);
        _ck(_v, 107, 0, currVal_85, currVal_86, currVal_87, currVal_88, currVal_89);
        var currVal_90 = 'City';
        var currVal_91 = true;
        var currVal_92 = _co.currentSeller.City;
        _ck(_v, 109, 0, currVal_90, currVal_91, currVal_92);
        var currVal_101 = '';
        _ck(_v, 118, 0, currVal_101);
        var currVal_102 = 'text';
        var currVal_103 = 'State';
        var currVal_104 = 'State';
        var currVal_105 = true;
        var currVal_106 = core_es5["ɵnov"](_v, 29);
        _ck(_v, 120, 0, currVal_102, currVal_103, currVal_104, currVal_105, currVal_106);
        var currVal_107 = 'State';
        var currVal_108 = true;
        var currVal_109 = _co.currentSeller.State;
        _ck(_v, 122, 0, currVal_107, currVal_108, currVal_109);
        var currVal_118 = '';
        _ck(_v, 131, 0, currVal_118);
        var currVal_119 = 'text';
        var currVal_120 = 'Postal Code';
        var currVal_121 = 'Postal Code';
        var currVal_122 = true;
        var currVal_123 = core_es5["ɵnov"](_v, 29);
        _ck(_v, 133, 0, currVal_119, currVal_120, currVal_121, currVal_122, currVal_123);
        var currVal_124 = 'Postal Code';
        var currVal_125 = true;
        var currVal_126 = _co.currentSeller.PostalCode;
        _ck(_v, 135, 0, currVal_124, currVal_125, currVal_126);
        var currVal_135 = '';
        _ck(_v, 144, 0, currVal_135);
        var currVal_136 = 'text';
        var currVal_137 = 'Phone Number';
        var currVal_138 = 'Phone Number';
        var currVal_139 = true;
        var currVal_140 = core_es5["ɵnov"](_v, 29);
        _ck(_v, 146, 0, currVal_136, currVal_137, currVal_138, currVal_139, currVal_140);
        var currVal_141 = 'Phone Number';
        var currVal_142 = true;
        var currVal_143 = _co.currentSeller.Phone;
        _ck(_v, 148, 0, currVal_141, currVal_142, currVal_143);
        var currVal_152 = '';
        _ck(_v, 157, 0, currVal_152);
        var currVal_153 = 'text';
        var currVal_154 = 'Job Title';
        var currVal_155 = 'Job Title';
        var currVal_156 = true;
        var currVal_157 = core_es5["ɵnov"](_v, 29);
        _ck(_v, 159, 0, currVal_153, currVal_154, currVal_155, currVal_156, currVal_157);
        var currVal_158 = 'Job Title';
        var currVal_159 = true;
        var currVal_160 = _co.currentSeller.JobTitle;
        _ck(_v, 161, 0, currVal_158, currVal_159, currVal_160);
        var currVal_161 = _co.currentSeller.Stores;
        _ck(_v, 180, 0, currVal_161);
    }, function (_ck, _v) {
        var currVal_0 = 'Seller';
        _ck(_v, 13, 0, currVal_0);
        var currVal_1 = core_es5["ɵnov"](_v, 31).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 31).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 31).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 31).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 31).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 31).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 31).ngClassPending;
        _ck(_v, 27, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_8 = (core_es5["ɵnov"](_v, 53).required ? '' : null);
        var currVal_9 = core_es5["ɵnov"](_v, 59).ngClassUntouched;
        var currVal_10 = core_es5["ɵnov"](_v, 59).ngClassTouched;
        var currVal_11 = core_es5["ɵnov"](_v, 59).ngClassPristine;
        var currVal_12 = core_es5["ɵnov"](_v, 59).ngClassDirty;
        var currVal_13 = core_es5["ɵnov"](_v, 59).ngClassValid;
        var currVal_14 = core_es5["ɵnov"](_v, 59).ngClassInvalid;
        var currVal_15 = core_es5["ɵnov"](_v, 59).ngClassPending;
        _ck(_v, 52, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15);
        var currVal_25 = (core_es5["ɵnov"](_v, 66).required ? '' : null);
        var currVal_26 = core_es5["ɵnov"](_v, 72).ngClassUntouched;
        var currVal_27 = core_es5["ɵnov"](_v, 72).ngClassTouched;
        var currVal_28 = core_es5["ɵnov"](_v, 72).ngClassPristine;
        var currVal_29 = core_es5["ɵnov"](_v, 72).ngClassDirty;
        var currVal_30 = core_es5["ɵnov"](_v, 72).ngClassValid;
        var currVal_31 = core_es5["ɵnov"](_v, 72).ngClassInvalid;
        var currVal_32 = core_es5["ɵnov"](_v, 72).ngClassPending;
        _ck(_v, 65, 0, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32);
        var currVal_42 = (core_es5["ɵnov"](_v, 79).required ? '' : null);
        var currVal_43 = core_es5["ɵnov"](_v, 85).ngClassUntouched;
        var currVal_44 = core_es5["ɵnov"](_v, 85).ngClassTouched;
        var currVal_45 = core_es5["ɵnov"](_v, 85).ngClassPristine;
        var currVal_46 = core_es5["ɵnov"](_v, 85).ngClassDirty;
        var currVal_47 = core_es5["ɵnov"](_v, 85).ngClassValid;
        var currVal_48 = core_es5["ɵnov"](_v, 85).ngClassInvalid;
        var currVal_49 = core_es5["ɵnov"](_v, 85).ngClassPending;
        _ck(_v, 78, 0, currVal_42, currVal_43, currVal_44, currVal_45, currVal_46, currVal_47, currVal_48, currVal_49);
        var currVal_59 = (core_es5["ɵnov"](_v, 92).required ? '' : null);
        var currVal_60 = core_es5["ɵnov"](_v, 98).ngClassUntouched;
        var currVal_61 = core_es5["ɵnov"](_v, 98).ngClassTouched;
        var currVal_62 = core_es5["ɵnov"](_v, 98).ngClassPristine;
        var currVal_63 = core_es5["ɵnov"](_v, 98).ngClassDirty;
        var currVal_64 = core_es5["ɵnov"](_v, 98).ngClassValid;
        var currVal_65 = core_es5["ɵnov"](_v, 98).ngClassInvalid;
        var currVal_66 = core_es5["ɵnov"](_v, 98).ngClassPending;
        _ck(_v, 91, 0, currVal_59, currVal_60, currVal_61, currVal_62, currVal_63, currVal_64, currVal_65, currVal_66);
        var currVal_76 = (core_es5["ɵnov"](_v, 105).required ? '' : null);
        var currVal_77 = core_es5["ɵnov"](_v, 111).ngClassUntouched;
        var currVal_78 = core_es5["ɵnov"](_v, 111).ngClassTouched;
        var currVal_79 = core_es5["ɵnov"](_v, 111).ngClassPristine;
        var currVal_80 = core_es5["ɵnov"](_v, 111).ngClassDirty;
        var currVal_81 = core_es5["ɵnov"](_v, 111).ngClassValid;
        var currVal_82 = core_es5["ɵnov"](_v, 111).ngClassInvalid;
        var currVal_83 = core_es5["ɵnov"](_v, 111).ngClassPending;
        _ck(_v, 104, 0, currVal_76, currVal_77, currVal_78, currVal_79, currVal_80, currVal_81, currVal_82, currVal_83);
        var currVal_93 = (core_es5["ɵnov"](_v, 118).required ? '' : null);
        var currVal_94 = core_es5["ɵnov"](_v, 124).ngClassUntouched;
        var currVal_95 = core_es5["ɵnov"](_v, 124).ngClassTouched;
        var currVal_96 = core_es5["ɵnov"](_v, 124).ngClassPristine;
        var currVal_97 = core_es5["ɵnov"](_v, 124).ngClassDirty;
        var currVal_98 = core_es5["ɵnov"](_v, 124).ngClassValid;
        var currVal_99 = core_es5["ɵnov"](_v, 124).ngClassInvalid;
        var currVal_100 = core_es5["ɵnov"](_v, 124).ngClassPending;
        _ck(_v, 117, 0, currVal_93, currVal_94, currVal_95, currVal_96, currVal_97, currVal_98, currVal_99, currVal_100);
        var currVal_110 = (core_es5["ɵnov"](_v, 131).required ? '' : null);
        var currVal_111 = core_es5["ɵnov"](_v, 137).ngClassUntouched;
        var currVal_112 = core_es5["ɵnov"](_v, 137).ngClassTouched;
        var currVal_113 = core_es5["ɵnov"](_v, 137).ngClassPristine;
        var currVal_114 = core_es5["ɵnov"](_v, 137).ngClassDirty;
        var currVal_115 = core_es5["ɵnov"](_v, 137).ngClassValid;
        var currVal_116 = core_es5["ɵnov"](_v, 137).ngClassInvalid;
        var currVal_117 = core_es5["ɵnov"](_v, 137).ngClassPending;
        _ck(_v, 130, 0, currVal_110, currVal_111, currVal_112, currVal_113, currVal_114, currVal_115, currVal_116, currVal_117);
        var currVal_127 = (core_es5["ɵnov"](_v, 144).required ? '' : null);
        var currVal_128 = core_es5["ɵnov"](_v, 150).ngClassUntouched;
        var currVal_129 = core_es5["ɵnov"](_v, 150).ngClassTouched;
        var currVal_130 = core_es5["ɵnov"](_v, 150).ngClassPristine;
        var currVal_131 = core_es5["ɵnov"](_v, 150).ngClassDirty;
        var currVal_132 = core_es5["ɵnov"](_v, 150).ngClassValid;
        var currVal_133 = core_es5["ɵnov"](_v, 150).ngClassInvalid;
        var currVal_134 = core_es5["ɵnov"](_v, 150).ngClassPending;
        _ck(_v, 143, 0, currVal_127, currVal_128, currVal_129, currVal_130, currVal_131, currVal_132, currVal_133, currVal_134);
        var currVal_144 = (core_es5["ɵnov"](_v, 157).required ? '' : null);
        var currVal_145 = core_es5["ɵnov"](_v, 163).ngClassUntouched;
        var currVal_146 = core_es5["ɵnov"](_v, 163).ngClassTouched;
        var currVal_147 = core_es5["ɵnov"](_v, 163).ngClassPristine;
        var currVal_148 = core_es5["ɵnov"](_v, 163).ngClassDirty;
        var currVal_149 = core_es5["ɵnov"](_v, 163).ngClassValid;
        var currVal_150 = core_es5["ɵnov"](_v, 163).ngClassInvalid;
        var currVal_151 = core_es5["ɵnov"](_v, 163).ngClassPending;
        _ck(_v, 156, 0, currVal_144, currVal_145, currVal_146, currVal_147, currVal_148, currVal_149, currVal_150, currVal_151);
    });
}
function View_SellerModalComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'seller-modal', [], null, null, null, View_SellerModalComponent_0, RenderType_SellerModalComponent)), core_es5["ɵdid"](114688, null, 0, seller_modal_component_SellerModalComponent, [router_es5["n" /* Router */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var SellerModalComponentNgFactory = core_es5["ɵccf"]('seller-modal', seller_modal_component_SellerModalComponent, View_SellerModalComponent_Host_0, { idToBlur: 'idToBlur' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=seller-modal.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/services/amazon.service.ts
var amazon_service = __webpack_require__("WdmS");

// CONCATENATED MODULE: ./app/components/Managment/amazon-management/amazon-seller-management.component.ts


var amazon_seller_management_component_AmazonSellerManagementComponent = /** @class */ (function () {
    function AmazonSellerManagementComponent(route, amazonService) {
        this.route = route;
        this.amazonService = amazonService;
        this.idToBlur = "customer-management";
        this.sellers = [];
        this.config = {
            id: 'custom',
            itemsPerPage: 12,
            currentPage: 1,
            totalItems: 1
        };
    }
    AmazonSellerManagementComponent.prototype.ngOnInit = function () {
        this.sellers = this.route.snapshot.data.sellers.Items;
        this.config.totalItems = this.route.snapshot.data.sellers.TotalCount;
    };
    AmazonSellerManagementComponent.prototype.search = function () {
        var _this = this;
        this.amazonService.getSellers((this.config.currentPage - 1) * this.config.itemsPerPage, this.config.itemsPerPage).then(function (response) {
            _this.sellers = response.Data.Items;
        });
    };
    AmazonSellerManagementComponent.ctorParameters = function () { return [{ type: router_es5["a" /* ActivatedRoute */] }, { type: amazon_service["a" /* AmazonService */] }]; };
    return AmazonSellerManagementComponent;
}());

//# sourceMappingURL=amazon-seller-management.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/amazon-management/amazon-seller-management.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */












var styles_AmazonSellerManagementComponent = [];
var RenderType_AmazonSellerManagementComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AmazonSellerManagementComponent, data: {} });
function View_AmazonSellerManagementComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'seller-item', [['class', 'seller-item']], null, null, null, View_SellerItemComponent_0, RenderType_SellerItemComponent)), core_es5["ɵdid"](49152, null, 0, seller_item_component_SellerItemComponent, [], { seller: [0, 'seller'],
            sellerModal: [1, 'sellerModal'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        var currVal_1 = core_es5["ɵnov"](_v.parent.parent, 1);
        _ck(_v, 3, 0, currVal_0, currVal_1);
    }, null);
}
function View_AmazonSellerManagementComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_AmazonSellerManagementComponent_2)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), core_es5["ɵpid"](0, PaginatePipe, [ngx_pagination_PaginationService]),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 3, 0, core_es5["ɵnov"](_v, 4).transform(_co.sellers, _co.config));
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_AmazonSellerManagementComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'row'], ['style', 'text-align:center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h2', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' No matching results! '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_AmazonSellerManagementComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'management-pagination', [], null, [[null, 'searchEventEmitter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('searchEventEmitter' === en)) {
                var pd_0 = (_co.search() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ManagementPaginationComponent_0, RenderType_ManagementPaginationComponent)),
        core_es5["ɵdid"](49152, null, 0, managementPagination_component_ManagementPaginationComponent, [], { config: [0, 'config'] }, { searchEventEmitter: 'searchEventEmitter' }), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.config;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_AmazonSellerManagementComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'seller-modal', [], null, null, null, View_SellerModalComponent_0, RenderType_SellerModalComponent)), core_es5["ɵdid"](114688, [['sellerModal', 4]], 0, seller_modal_component_SellerModalComponent, [router_es5["n" /* Router */]], { idToBlur: [0, 'idToBlur'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class', 'main-content']], [[1, 'id', 0]], null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'container-fluid']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonSellerManagementComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonSellerManagementComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonSellerManagementComponent_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.idToBlur;
        _ck(_v, 1, 0, currVal_0);
        var currVal_2 = (_co.sellers.length > 0);
        _ck(_v, 8, 0, currVal_2);
        var currVal_3 = (_co.sellers.length == 0);
        _ck(_v, 11, 0, currVal_3);
        var currVal_4 = (_co.sellers.length > 0);
        _ck(_v, 14, 0, currVal_4);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.idToBlur;
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_AmazonSellerManagementComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'amazon-seller-management', [], null, null, null, View_AmazonSellerManagementComponent_0, RenderType_AmazonSellerManagementComponent)), core_es5["ɵdid"](114688, null, 0, amazon_seller_management_component_AmazonSellerManagementComponent, [router_es5["a" /* ActivatedRoute */], amazon_service["a" /* AmazonService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AmazonSellerManagementComponentNgFactory = core_es5["ɵccf"]('amazon-seller-management', amazon_seller_management_component_AmazonSellerManagementComponent, View_AmazonSellerManagementComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=amazon-seller-management.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/common/inline-input/inline-input.component.ts

var inline_input_component_InlineInputComponent = /** @class */ (function () {
    function InlineInputComponent() {
        this.changeEvent = new core_es5["EventEmitter"]();
        this.isEditing = false;
        this.isValid = true;
    }
    InlineInputComponent.prototype.emmitModify = function () {
        if (!this.modelRef.valid)
            return;
        this.isEditing = !this.isEditing;
        if (this.model != this.prevValue)
            this.changeEvent.emit(this.model);
    };
    InlineInputComponent.prototype.open = function () {
        var _this = this;
        this.prevValue = this.model;
        this.isEditing = !this.isEditing;
        setTimeout(function () { return _this.inputReference.nativeElement.focus(); }, 0);
    };
    return InlineInputComponent;
}());

//# sourceMappingURL=inline-input.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/common/inline-input/inline-input.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_InlineInputComponent = [];
var RenderType_InlineInputComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_InlineInputComponent, data: {} });
function View_InlineInputComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.open() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['mode_edit'])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.model;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_InlineInputComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['HS code should be: XXXX.XX.XX.XX or XXXX.XX.XXXX']))], null, null);
}
function View_InlineInputComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, FirstKeyPipe, []), core_es5["ɵqud"](402653184, 1, { inputReference: 0 }),
        core_es5["ɵqud"](402653184, 2, { modelRef: 0 }), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_InlineInputComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 29, 'div', [], [[8, 'hidden', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 26, 'form', [['novalidate', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'submit'],
            [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 10).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 10).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['inputForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class', 'form-group label-floating']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'has-error': 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, [[1, 0], ['inputRefId', 1]], null, 8, 'input', [['autofocus', ''], ['class',
                'form-control'], ['name', 'inputRef'], ['pattern', '(\\d{4}\\.(\\d{2}\\.){2}\\d{2}$)|(\\d{4}\\.\\d{2}\\.\\d{4})$']], [[1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'blur'], [null, 'input'],
            [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 22).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_5 = ((_co.model = $event) !== false);
                ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
                var pd_6 = (_co.emmitModify() !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["PatternValidator"]]), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, [[2, 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'material-input']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 2, null, View_InlineInputComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.isEditing;
        _ck(_v, 4, 0, currVal_0);
        var currVal_9 = 'form-group label-floating';
        var currVal_10 = _ck(_v, 16, 0, !_co.modelRef.valid);
        _ck(_v, 15, 0, currVal_9, currVal_10);
        var currVal_19 = '(\\d{4}\\.(\\d{2}\\.){2}\\d{2}$)|(\\d{4}\\.\\d{2}\\.\\d{4})$';
        _ck(_v, 20, 0, currVal_19);
        var currVal_20 = 'inputRef';
        var currVal_21 = _co.model;
        _ck(_v, 24, 0, currVal_20, currVal_21);
        var currVal_22 = (core_es5["ɵunv"](_v, 31, 0, _ck(_v, 32, 0, core_es5["ɵnov"](_v, 0), _co.modelRef.errors)) == 'pattern');
        _ck(_v, 31, 0, currVal_22);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = !_co.isEditing;
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = core_es5["ɵnov"](_v, 12).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 12).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 12).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 12).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 12).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 12).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 12).ngClassPending;
        _ck(_v, 8, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
        var currVal_11 = (core_es5["ɵnov"](_v, 20).pattern ? core_es5["ɵnov"](_v, 20).pattern : null);
        var currVal_12 = core_es5["ɵnov"](_v, 26).ngClassUntouched;
        var currVal_13 = core_es5["ɵnov"](_v, 26).ngClassTouched;
        var currVal_14 = core_es5["ɵnov"](_v, 26).ngClassPristine;
        var currVal_15 = core_es5["ɵnov"](_v, 26).ngClassDirty;
        var currVal_16 = core_es5["ɵnov"](_v, 26).ngClassValid;
        var currVal_17 = core_es5["ɵnov"](_v, 26).ngClassInvalid;
        var currVal_18 = core_es5["ɵnov"](_v, 26).ngClassPending;
        _ck(_v, 18, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18);
    });
}
function View_InlineInputComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'inline-input', [], null, null, null, View_InlineInputComponent_0, RenderType_InlineInputComponent)), core_es5["ɵdid"](49152, null, 0, inline_input_component_InlineInputComponent, [], null, null)], null, null);
}
var InlineInputComponentNgFactory = core_es5["ɵccf"]('inline-input', inline_input_component_InlineInputComponent, View_InlineInputComponent_Host_0, { model: 'model', name: 'name' }, { changeEvent: 'changeEvent' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=inline-input.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/objects/common/baseEntity.ts
var baseEntity = __webpack_require__("mCwL");

// CONCATENATED MODULE: ./app/objects/amazon/AmazonStoreCredentials.ts


var AmazonStoreCredentials_AmazonStoreCredentials = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](AmazonStoreCredentials, _super);
    function AmazonStoreCredentials() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AmazonStoreCredentials;
}(baseEntity["a" /* BaseEntity */]));

//# sourceMappingURL=AmazonStoreCredentials.js.map
// CONCATENATED MODULE: ./app/common/helpers/HTCCodeHelper.ts
var HTCCodeHelper = /** @class */ (function () {
    function HTCCodeHelper() {
    }
    HTCCodeHelper.formatHTCCode = function (value) {
        if (!value)
            return '';
        if (new RegExp(/\d{4}\.\d{2}\.\d{4}$/).test(value) == true)
            return value;
        var splittedArray = value.split('.');
        return [splittedArray[0], splittedArray[1], [splittedArray[2], splittedArray[3]].join('')].join('.');
    };
    return HTCCodeHelper;
}());

//# sourceMappingURL=HTCCodeHelper.js.map
// CONCATENATED MODULE: ./app/components/Managment/amazon-management/store/amazon-store-management.ts








var amazon_store_management_AmazonStoreManagement = /** @class */ (function () {
    function AmazonStoreManagement(activatedRoute, route, amazonService, el, uploadService, configService) {
        this.activatedRoute = activatedRoute;
        this.route = route;
        this.amazonService = amazonService;
        this.el = el;
        this.uploadService = uploadService;
        this.configService = configService;
        this.store = new AmazonStoreCredentials_AmazonStoreCredentials();
        this.seller = new amazon_seller["a" /* Seller */]();
        this.HTCCodeHelper = HTCCodeHelper;
        this.config = {
            currentPage: 0,
            itemsPerPage: 50,
            totalItems: 0
        };
        this.headerHeight = 60;
        this.rowHeight = 50;
        this.currentSortProp = null;
        this.isAscending = null;
        this.isLoading = false;
    }
    AmazonStoreManagement.prototype.ngOnInit = function () {
        var _this = this;
        this.seller = this.route.snapshot.data.seller;
        this.activatedRoute.params.subscribe(function (params) {
            _this.sellerId = params['sellerId'];
            _this.storeId = params['storeId'];
            _this.showStore(_this.storeId);
        });
    };
    AmazonStoreManagement.prototype.showStore = function (storeId) {
        this.store = this.seller.Stores.find(function (store) { return store.Id == storeId; });
        var products = this.route.snapshot.data.products;
        this.store.Products = products.Items.slice();
        this.config.totalItems = this.store.TotalCount;
        this.config.currentPage++;
    };
    AmazonStoreManagement.prototype.loadProducts = function (reset) {
        var _this = this;
        if (reset === void 0) { reset = false; }
        if (this.isLoading == true)
            return;
        this.isLoading = true;
        this.amazonService.getProducts(this.sellerId, this.storeId, this.config.currentPage * this.config.itemsPerPage, this.config.itemsPerPage, true, this.currentSortProp, this.isAscending)
            .then(function (response) {
            _this.isLoading = false;
            if (reset)
                _this.store.Products = response.Data.Items;
            else
                (_a = _this.store.Products).push.apply(_a, response.Data.Items);
            _this.store.Products = _this.store.Products.slice();
            var _a;
        });
    };
    AmazonStoreManagement.prototype.onScroll = function (scrollY) {
        if (!scrollY || !scrollY.offsetY)
            return;
        // total height of all rows in the viewport
        var viewHeight = this.el.nativeElement.getBoundingClientRect().height - this.headerHeight;
        if (this.config.currentPage * this.config.itemsPerPage >= this.config.totalItems)
            return;
        if (viewHeight + scrollY.offsetY >= this.store.Products.length * this.rowHeight) {
            this.config.currentPage++;
            this.loadProducts();
        }
    };
    AmazonStoreManagement.prototype.handleSort = function (event) {
        this.isAscending = event.newValue == 'asc';
        this.currentSortProp = event.column.prop;
        this.config.currentPage = 0;
        this.loadProducts(true);
    };
    AmazonStoreManagement.prototype.updateProduct = function (product, hsCode) {
        product.HsCode = hsCode;
        this.amazonService.updateProduct(this.sellerId, this.storeId, product);
    };
    AmazonStoreManagement.prototype.exportProducts = function () {
        window.open(this.configService.config.AdminUrl + "/management/amazon/seller/" + this.sellerId + "/store/" + this.storeId + "/export", '_blank');
    };
    AmazonStoreManagement.ctorParameters = function () { return [{ type: router_es5["a" /* ActivatedRoute */] }, { type: router_es5["a" /* ActivatedRoute */] }, { type: amazon_service["a" /* AmazonService */] }, { type: core_es5["ElementRef"] }, { type: uploadService_UploadService }, { type: services_configService["a" /* ConfigService */] }]; };
    return AmazonStoreManagement;
}());

//# sourceMappingURL=amazon-store-management.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/amazon-management/store/amazon-store-management.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





















var styles_AmazonStoreManagement = [];
var RenderType_AmazonStoreManagement = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AmazonStoreManagement, data: {} });
function View_AmazonStoreManagement_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'basic-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'basic-info-item product-image']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt', '']], [[8, 'src', 4]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, '', _v.context.value, '');
        _ck(_v, 5, 0, currVal_0);
    });
}
function View_AmazonStoreManagement_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'basic-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.value;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_AmazonStoreManagement_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'basic-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.value;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_AmazonStoreManagement_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'basic-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.HTCCodeHelper.formatHTCCode(_v.context.value);
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_AmazonStoreManagement_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'basic-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'inline-input', [['name', 'HsCode']], null, [[null, 'changeEvent']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('changeEvent' === en)) {
                    var pd_0 = (_co.updateProduct(_v.context.row, $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_InlineInputComponent_0, RenderType_InlineInputComponent)), core_es5["ɵdid"](49152, null, 0, inline_input_component_InlineInputComponent, [], { model: [0, 'model'], name: [1,
                'name'] }, { changeEvent: 'changeEvent' }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_0 = _v.context.value;
        var currVal_1 = 'HsCode';
        _ck(_v, 4, 0, currVal_0, currVal_1);
    }, null);
}
function View_AmazonStoreManagement_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'basic-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'a', [], [[1, 'href', 4]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.value;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _v.context.value;
        _ck(_v, 4, 0, currVal_1);
    });
}
function View_AmazonStoreManagement_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 60, 'ngx-datatable', [['class', 'material ngx-datatable']], [[2, 'fixed-header', null], [2, 'fixed-row',
                null], [2, 'scroll-vertical', null], [2, 'scroll-horz', null],
            [2, 'selectable', null], [2, 'checkbox-selection', null], [2,
                'cell-selection', null], [2, 'single-selection', null],
            [2, 'multi-selection', null], [2, 'multi-click-selection', null]], [[null, 'scroll'], [null, 'sort'], ['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onWindowResize() !== false);
                ad = (pd_0 && ad);
            }
            if (('scroll' === en)) {
                var pd_1 = (_co.onScroll($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('sort' === en)) {
                var pd_2 = (_co.handleSort($event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, View_DatatableComponent_0, RenderType_DatatableComponent)), core_es5["ɵdid"](5619712, null, 4, datatable_component["DatatableComponent"], [[1, scrollbar_helper_service["ScrollbarHelper"]], [1, dimensions_helper_service["DimensionsHelper"]],
            core_es5["ChangeDetectorRef"], core_es5["ElementRef"], core_es5["KeyValueDiffers"]], { rows: [0, 'rows'],
            scrollbarV: [1, 'scrollbarV'], rowHeight: [2, 'rowHeight'], columnMode: [3, 'columnMode'],
            headerHeight: [4, 'headerHeight'], externalSorting: [5, 'externalSorting'], reorderable: [6,
                'reorderable'], sortType: [7, 'sortType'] }, { scroll: 'scroll', sort: 'sort' }),
        core_es5["ɵqud"](603979776, 1, { columnTemplates: 1 }), core_es5["ɵqud"](335544320, 2, { rowDetail: 0 }),
        core_es5["ɵqud"](335544320, 3, { groupHeader: 0 }), core_es5["ɵqud"](335544320, 4, { footer: 0 }), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ngx-datatable-column', [['prop', 'SmallImage']], null, null, null, null, null)), core_es5["ɵdid"](16384, [[1, 4]], 2, column_directive["DataTableColumnDirective"], [], { name: [0, 'name'], prop: [1, 'prop'], sortable: [2, 'sortable'] }, null), core_es5["ɵqud"](335544320, 5, { cellTemplate: 0 }), core_es5["ɵqud"](335544320, 6, { headerTemplate: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, [[5, 2]], null, 1, null, View_AmazonStoreManagement_2)), core_es5["ɵdid"](16384, null, 0, column_cell_directive["DataTableColumnCellDirective"], [core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ngx-datatable-column', [['name', 'Product name'], ['prop', 'Title']], null, null, null, null, null)), core_es5["ɵdid"](16384, [[1, 4]], 2, column_directive["DataTableColumnDirective"], [], { name: [0, 'name'], prop: [1, 'prop'] }, null), core_es5["ɵqud"](335544320, 7, { cellTemplate: 0 }), core_es5["ɵqud"](335544320, 8, { headerTemplate: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, [[7, 2]], null, 1, null, View_AmazonStoreManagement_3)),
        core_es5["ɵdid"](16384, null, 0, column_cell_directive["DataTableColumnCellDirective"], [core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ngx-datatable-column', [['name', 'Category'], ['prop', 'Model']], null, null, null, null, null)), core_es5["ɵdid"](16384, [[1, 4]], 2, column_directive["DataTableColumnDirective"], [], { name: [0, 'name'], prop: [1,
                'prop'] }, null), core_es5["ɵqud"](335544320, 9, { cellTemplate: 0 }), core_es5["ɵqud"](335544320, 10, { headerTemplate: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, [[9, 2]], null, 1, null, View_AmazonStoreManagement_4)), core_es5["ɵdid"](16384, null, 0, column_cell_directive["DataTableColumnCellDirective"], [core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ngx-datatable-column', [['name', 'Amazon HTS Code'], ['prop', 'HsCode']], null, null, null, null, null)), core_es5["ɵdid"](16384, [[1, 4]], 2, column_directive["DataTableColumnDirective"], [], { name: [0, 'name'], prop: [1, 'prop'] }, null), core_es5["ɵqud"](335544320, 11, { cellTemplate: 0 }), core_es5["ɵqud"](335544320, 12, { headerTemplate: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, [[11, 2]], null, 1, null, View_AmazonStoreManagement_5)),
        core_es5["ɵdid"](16384, null, 0, column_cell_directive["DataTableColumnCellDirective"], [core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ngx-datatable-column', [['name', 'HS code'], ['prop', 'HsCode']], null, null, null, null, null)), core_es5["ɵdid"](16384, [[1, 4]], 2, column_directive["DataTableColumnDirective"], [], { name: [0, 'name'], prop: [1,
                'prop'] }, null), core_es5["ɵqud"](335544320, 13, { cellTemplate: 0 }), core_es5["ɵqud"](335544320, 14, { headerTemplate: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, [[13, 2]], null, 1, null, View_AmazonStoreManagement_6)), core_es5["ɵdid"](16384, null, 0, column_cell_directive["DataTableColumnCellDirective"], [core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ngx-datatable-column', [['name', 'Description'], ['prop', 'LinkToProduct']], null, null, null, null, null)), core_es5["ɵdid"](16384, [[1, 4]], 2, column_directive["DataTableColumnDirective"], [], { name: [0, 'name'], prop: [1, 'prop'], sortable: [2, 'sortable'] }, null), core_es5["ɵqud"](335544320, 15, { cellTemplate: 0 }), core_es5["ɵqud"](335544320, 16, { headerTemplate: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, [[15, 2]], null, 1, null, View_AmazonStoreManagement_7)), core_es5["ɵdid"](16384, null, 0, column_cell_directive["DataTableColumnCellDirective"], [core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_10 = _co.store.Products;
        var currVal_11 = true;
        var currVal_12 = 150;
        var currVal_13 = 'force';
        var currVal_14 = _co.headerHeight;
        var currVal_15 = true;
        var currVal_16 = false;
        var currVal_17 = 'single';
        _ck(_v, 1, 0, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17);
        var currVal_18 = core_es5["ɵinlineInterpolate"](1, '', _co.store.Products.length, '');
        var currVal_19 = 'SmallImage';
        var currVal_20 = false;
        _ck(_v, 8, 0, currVal_18, currVal_19, currVal_20);
        var currVal_21 = 'Product name';
        var currVal_22 = 'Title';
        _ck(_v, 17, 0, currVal_21, currVal_22);
        var currVal_23 = 'Category';
        var currVal_24 = 'Model';
        _ck(_v, 26, 0, currVal_23, currVal_24);
        var currVal_25 = 'Amazon HTS Code';
        var currVal_26 = 'HsCode';
        _ck(_v, 35, 0, currVal_25, currVal_26);
        var currVal_27 = 'HS code';
        var currVal_28 = 'HsCode';
        _ck(_v, 44, 0, currVal_27, currVal_28);
        var currVal_29 = 'Description';
        var currVal_30 = 'LinkToProduct';
        var currVal_31 = false;
        _ck(_v, 53, 0, currVal_29, currVal_30, currVal_31);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).isFixedHeader;
        var currVal_1 = core_es5["ɵnov"](_v, 1).isFixedRow;
        var currVal_2 = core_es5["ɵnov"](_v, 1).isVertScroll;
        var currVal_3 = core_es5["ɵnov"](_v, 1).isHorScroll;
        var currVal_4 = core_es5["ɵnov"](_v, 1).isSelectable;
        var currVal_5 = core_es5["ɵnov"](_v, 1).isCheckboxSelection;
        var currVal_6 = core_es5["ɵnov"](_v, 1).isCellSelection;
        var currVal_7 = core_es5["ɵnov"](_v, 1).isSingleSelection;
        var currVal_8 = core_es5["ɵnov"](_v, 1).isMultiSelection;
        var currVal_9 = core_es5["ɵnov"](_v, 1).isMultiClickSelection;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9);
    });
}
function View_AmazonStoreManagement_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 34, 'div', [['class', 'main-content amazon-management']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 31, 'div', [['class', 'container-fluid']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class', 'top_buttons_body']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 12, 'ul', [['class', 'nav']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](16777216, null, null, 7, 'li', [['dropdown',
                '']], [[2, 'dropup', null], [2, 'open', null], [2, 'show', null]], null, null, null, null)), core_es5["ɵprd"](512, null, bs_dropdown_state["a" /* BsDropdownState */], bs_dropdown_state["a" /* BsDropdownState */], []), core_es5["ɵdid"](212992, null, 0, bs_dropdown_directive["a" /* BsDropdownDirective */], [core_es5["ElementRef"], core_es5["Renderer"], core_es5["ViewContainerRef"], component_loader_factory["a" /* ComponentLoaderFactory */],
            bs_dropdown_config["a" /* BsDropdownConfig */], bs_dropdown_state["a" /* BsDropdownState */]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'a', [['class', 'dropdown-toggle bold text-uppercase'], ['dropdownToggle', '']], [[1, 'aria-haspopup', 0], [1, 'disabled', 0], [1, 'aria-expanded', 0]], [[null,
                'click'], ['document', 'click'], [null, 'keyup.esc']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 14).onClick() !== false);
                ad = (pd_0 && ad);
            }
            if (('document:click' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 14).onDocumentClick($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('keyup.esc' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 14).onEsc() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](147456, null, 0, bs_dropdown_toggle_directive["a" /* BsDropdownToggleDirective */], [bs_dropdown_state["a" /* BsDropdownState */], core_es5["ElementRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'li', [['class', 'separator hidden-lg hidden-md']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 5, 'button', [['class', 'btn btn-white margin-0 btn-round btn-just-icon create-icon']], null, [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.exportProducts() !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['file_download'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'amazon-product-card-container order-table-view']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonStoreManagement_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        _ck(_v, 11, 0);
        var currVal_7 = ((_co.store && _co.store.Products) && (_co.store.Products.length > 0));
        _ck(_v, 32, 0, currVal_7);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵnov"](_v, 11).dropup;
        var currVal_1 = core_es5["ɵnov"](_v, 11).isOpen;
        var currVal_2 = (core_es5["ɵnov"](_v, 11).isOpen && core_es5["ɵnov"](_v, 11).isBs4);
        _ck(_v, 9, 0, currVal_0, currVal_1, currVal_2);
        var currVal_3 = true;
        var currVal_4 = core_es5["ɵnov"](_v, 14).isDisabled;
        var currVal_5 = core_es5["ɵnov"](_v, 14).isOpen;
        _ck(_v, 13, 0, currVal_3, currVal_4, currVal_5);
        var currVal_6 = _co.store.StoreName;
        _ck(_v, 15, 0, currVal_6);
    });
}
function View_AmazonStoreManagement_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'amazon-store-management', [], null, null, null, View_AmazonStoreManagement_0, RenderType_AmazonStoreManagement)), core_es5["ɵdid"](114688, null, 0, amazon_store_management_AmazonStoreManagement, [router_es5["a" /* ActivatedRoute */], router_es5["a" /* ActivatedRoute */], amazon_service["a" /* AmazonService */], core_es5["ElementRef"], uploadService_UploadService,
            services_configService["a" /* ConfigService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AmazonStoreManagementNgFactory = core_es5["ɵccf"]('amazon-store-management', amazon_store_management_AmazonStoreManagement, View_AmazonStoreManagement_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=amazon-store-management.ngfactory.js.map
// EXTERNAL MODULE: ./app/common/helpers/userHelper.ts
var userHelper = __webpack_require__("AvNY");

// CONCATENATED MODULE: ./app/components/agent/agent-item/agent-item.component.ts

/**
 * Created by vlad.p on 7/31/2017.
 */
var agent_item_component_AgentItemComponent = /** @class */ (function () {
    function AgentItemComponent() {
        this.userHelper = userHelper["a" /* UserHelper */];
        this.string = String;
    }
    return AgentItemComponent;
}());

//# sourceMappingURL=agent-item.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/agent/agent-item/agent-item.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_AgentItemComponent = [];
var RenderType_AgentItemComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AgentItemComponent, data: {} });
function View_AgentItemComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class',
                'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['person']))], null, null);
}
function View_AgentItemComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [], [[8, 'src', 4]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.string.isUrl(_co.agent.ImageSrc) ? _co.agent.ImageSrc : ('data:image/jpg;base64,' + _co.agent.ImageSrc));
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_AgentItemComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 73, 'div', [['class',
                'col-sp-5 agent-card']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 70, 'div', [['class', 'card card-stats pointer']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.agentModal.show(_co.agent) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'card-header'], ['data-background-color',
                    'orange']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AgentItemComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AgentItemComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'category']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'category']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 49, 'div', [['class', 'card-footer']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'card-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Role: '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-xs-7 card-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-5']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'card-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Job title:'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-xs-7 card-info']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'card-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Phone: '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-xs-7 card-info short-description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'card-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Email: '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-xs-7 card-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.string.isNullOrEmpty(_co.agent.ImageSrc);
        _ck(_v, 7, 0, currVal_0);
        var currVal_1 = !_co.string.isNullOrEmpty(_co.agent.ImageSrc);
        _ck(_v, 10, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.agent.FirstName;
        _ck(_v, 16, 0, currVal_2);
        var currVal_3 = _co.agent.LastName;
        _ck(_v, 19, 0, currVal_3);
        var currVal_4 = _co.userHelper.getCommaSeparatedGroups(_co.agent);
        _ck(_v, 33, 0, currVal_4);
        var currVal_5 = _co.agent.Position;
        _ck(_v, 45, 0, currVal_5);
        var currVal_6 = _co.agent.Phone;
        _ck(_v, 57, 0, currVal_6);
        var currVal_7 = _co.agent.Email;
        _ck(_v, 69, 0, currVal_7);
    });
}
function View_AgentItemComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'agent-item', [], null, null, null, View_AgentItemComponent_0, RenderType_AgentItemComponent)),
        core_es5["ɵdid"](49152, null, 0, agent_item_component_AgentItemComponent, [], null, null)], null, null);
}
var AgentItemComponentNgFactory = core_es5["ɵccf"]('agent-item', agent_item_component_AgentItemComponent, View_AgentItemComponent_Host_0, { agent: 'agent', agentModal: 'agentModal' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=agent-item.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/objects/requests/userSearchRequest.ts


/**
 * Created by vlad.p on 7/31/2017.
 */
var userSearchRequest_UserSearchRequest = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](UserSearchRequest, _super);
    function UserSearchRequest(obj) {
        var _this = _super.call(this) || this;
        Object.assign(_this, obj);
        return _this;
    }
    return UserSearchRequest;
}(baseSearchRequest["a" /* BaseSearchRequest */]));

//# sourceMappingURL=userSearchRequest.js.map
// CONCATENATED MODULE: ./app/components/agent/agent-management.component.ts







/**
 * Created by vlad.p on 7/31/2017.
 */
var agent_management_component_AgentManagementComponent = /** @class */ (function () {
    function AgentManagementComponent(route, userService, storageManager, configService, router) {
        this.route = route;
        this.userService = userService;
        this.storageManager = storageManager;
        this.configService = configService;
        this.router = router;
        this.agents = [];
        this.groups = [];
        this.idToBlur = "agent-management";
        this.config = {
            id: 'custom',
            itemsPerPage: 12,
            currentPage: 1,
            totalItems: 1
        };
    }
    AgentManagementComponent.prototype.unBlurMenu = function () {
        blurUtil["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
    };
    AgentManagementComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.config.totalItems = this.route.snapshot.data.agents.TotalCount;
        this.agents = this.route.snapshot.data.agents.Items;
        this.groups = this.route.snapshot.data.groups.Data;
        this.route.params.subscribe(function (params) {
            var id = params['id'];
            if (id)
                _this.storageManager.getCurrentUser().then(function (x) {
                    _this.agentModalComponent.show(x);
                    _this.router.navigate(['management/agent']);
                });
        });
    };
    AgentManagementComponent.prototype.search = function () {
        var _this = this;
        this.userService.search(new userSearchRequest_UserSearchRequest({
            Skip: (this.config.currentPage - 1) * this.config.itemsPerPage,
            Top: this.config.itemsPerPage,
            Query: this.query,
            FillOrders: true
        })).then(function (users) {
            _this.agents = users.Data.Items;
            _this.config.totalItems = users.Data.TotalCount;
            document.getElementById('mainPanel').scrollTop = 0;
        }).catch(function (response) {
            _this.agents.splice(0, _this.agents.length);
        });
    };
    AgentManagementComponent.prototype.createAgent = function () {
        this.agentModalComponent.show(new users_user["c" /* User */]());
    };
    AgentManagementComponent.prototype.onAgentSaved = function (agent) {
        var _this = this;
        var existingAgent = this.agents.find(function (x) { return x.Id == agent.Id; });
        if (existingAgent != null) {
            agent.Orders = existingAgent.Orders;
            Object.assign(existingAgent, agent);
            this.storageManager.getCurrentUser().then(function (y) {
                if (y.Id == existingAgent.Id) {
                    _this.storageManager.setCurrentUser(existingAgent);
                    window.location.reload();
                }
            });
        }
        else {
            this.agents.unshift(agent);
            if (this.agents.length > this.config.itemsPerPage)
                this.agents.pop();
            this.config.totalItems += 1;
        }
    };
    AgentManagementComponent.ctorParameters = function () { return [{ type: router_es5["a" /* ActivatedRoute */] }, { type: services_userService["a" /* UserService */] }, { type: managers_storageManager["a" /* StorageManager */] }, { type: services_configService["a" /* ConfigService */] }, { type: router_es5["n" /* Router */] }]; };
    return AgentManagementComponent;
}());

//# sourceMappingURL=agent-management.component.js.map
// EXTERNAL MODULE: ./app/components/agent/modal/agent-modal.component.ts
var agent_modal_component = __webpack_require__("gHgi");

// CONCATENATED MODULE: ./compiled/app/components/agent/modal/agent-modal.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


















var styles_AgentModalComponent = [];
var RenderType_AgentModalComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AgentModalComponent, data: {} });
function View_AgentModalComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class',
                'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['person']))], null, null);
}
function View_AgentModalComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['class',
                'avatar']], [[8, 'src', 4]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.string.isUrl(_co.currentAgent.ImageSrc) ? _co.currentAgent.ImageSrc : ('data:image/jpg;base64,' + _co.currentAgent.ImageSrc));
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_AgentModalComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' First Name is required. ']))], null, null);
}
function View_AgentModalComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Email is required. ']))], null, null);
}
function View_AgentModalComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Email is invalid. ']))], null, null);
}
function View_AgentModalComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 30, 'div', [['class',
                'col-sm-6 line-form select2-type']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 27, 'div', [['class', 'form-group label-floating'],
                ['id', 'emailSelect']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0, 'select-is-open': 1 }), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Email'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'select', [['class', 'form-control select2'], ['id', 'emailModel'], ['name', 'emailModel'],
            ['pattern', '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'], ['required', '']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'change'],
            [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 10).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 10).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.currentAgent.Email = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null),
        core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0,
                'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, [['emailModel', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'material-input']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_AgentModalComponent_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 2, null, View_AgentModalComponent_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'form-group label-floating';
        var currVal_1 = _ck(_v, 4, 0, ((core_es5["ɵnov"](_v, 15) && core_es5["ɵnov"](_v, 15).invalid) && (!core_es5["ɵnov"](_v, 15).pristine || core_es5["ɵnov"](_v.parent, 8).submitted)), (_co.select2Util.checkIfSelectOpen('emailSelect') || _co.currentAgent.Email));
        _ck(_v, 3, 0, currVal_0, currVal_1);
        var currVal_11 = '';
        _ck(_v, 11, 0, currVal_11);
        var currVal_12 = '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
        _ck(_v, 12, 0, currVal_12);
        var currVal_13 = 'emailModel';
        var currVal_14 = _co.currentAgent.Email;
        _ck(_v, 15, 0, currVal_13, currVal_14);
        var currVal_15 = ((core_es5["ɵunv"](_v, 23, 0, _ck(_v, 24, 0, core_es5["ɵnov"](_v.parent.parent, 0), (core_es5["ɵnov"](_v, 15) && core_es5["ɵnov"](_v, 15).errors))) == 'required') && (!core_es5["ɵnov"](_v, 15).pristine || core_es5["ɵnov"](_v.parent, 8).submitted));
        _ck(_v, 23, 0, currVal_15);
        var currVal_16 = ((core_es5["ɵunv"](_v, 27, 0, _ck(_v, 28, 0, core_es5["ɵnov"](_v.parent.parent, 0), (core_es5["ɵnov"](_v, 15) && core_es5["ɵnov"](_v, 15).errors))) == 'pattern') && (!core_es5["ɵnov"](_v, 15).pristine || core_es5["ɵnov"](_v.parent, 8).submitted));
        _ck(_v, 27, 0, currVal_16);
    }, function (_ck, _v) {
        var currVal_2 = (core_es5["ɵnov"](_v, 11).required ? '' : null);
        var currVal_3 = (core_es5["ɵnov"](_v, 12).pattern ? core_es5["ɵnov"](_v, 12).pattern : null);
        var currVal_4 = core_es5["ɵnov"](_v, 17).ngClassUntouched;
        var currVal_5 = core_es5["ɵnov"](_v, 17).ngClassTouched;
        var currVal_6 = core_es5["ɵnov"](_v, 17).ngClassPristine;
        var currVal_7 = core_es5["ɵnov"](_v, 17).ngClassDirty;
        var currVal_8 = core_es5["ɵnov"](_v, 17).ngClassValid;
        var currVal_9 = core_es5["ɵnov"](_v, 17).ngClassInvalid;
        var currVal_10 = core_es5["ɵnov"](_v, 17).ngClassPending;
        _ck(_v, 9, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10);
    });
}
function View_AgentModalComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Last Name is required. ']))], null, null);
}
function View_AgentModalComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Phone is required. ']))], null, null);
}
function View_AgentModalComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Is not a countryCode']))], null, null);
}
function View_AgentModalComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Is not a phone number']))], null, null);
}
function View_AgentModalComponent_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'checkbox checkbox-inline checkbox-top']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'input', [['name', 'role'], ['type', 'checkbox']], [[8, 'checked', 0], [8, 'value', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [['class', 'checkbox-material']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.groupChanged(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'check']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.userHelper.isInGroup(_co.currentAgent, _v.context.$implicit);
        var currVal_1 = _v.context.$implicit.Name;
        _ck(_v, 2, 0, currVal_0, currVal_1);
        var currVal_2 = _v.context.$implicit.Name;
        _ck(_v, 7, 0, currVal_2);
    });
}
function View_AgentModalComponent_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Position is required. ']))], null, null);
}
function View_AgentModalComponent_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class',
                'btn btn-round btn-light-orange'], ['type', 'button']], [[8, 'disabled', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.viewAllOrders() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, ['View all orders ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ((!_co.currentAgent.Orders || (_co.currentAgent.Orders.length == 0)) || (_co.userHelper.isInGroupById(_co.currentUser, 2) && (_co.currentUser.Groups.length == 1)));
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_AgentModalComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 150, 'div', [['class',
                'modal-body']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 147, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 144, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 141, 'form', [['class',
                'form-horizontal'], ['novalidate', '']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngSubmit'], [null,
                'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 8).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 8).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.save(core_es5["ɵnov"](_v, 8).valid) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[2, 4], ['agentForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 134, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 83, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-sm-3']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'card-header thumbnail default-image'],
                ['data-background-color', 'orange']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AgentModalComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AgentModalComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 68, 'div', [['class', 'col-sm-9']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'col-sm-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 12, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2,
                    'ng-valid', null], [2, 'ng-invalid', null], [2,
                    'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.currentAgent.FirstName = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['firstNameModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_AgentModalComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AgentModalComponent_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 42, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'col-sm-6 line-form']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentAgent.LastName = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['lastNameModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_AgentModalComponent_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class',
                'col-sm-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'form-input', [['possiblePhone', 'US'], ['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentAgent.Phone = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](81920, null, 0, phone_directive_PossiblePhoneValidatorDirective, [], { possiblePhone: [0, 'possiblePhone'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], phone_directive_PossiblePhoneValidatorDirective]), core_es5["ɵdid"](4308992, [['phoneModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], disabled: [3, 'disabled'],
            form: [4, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_AgentModalComponent_9)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AgentModalComponent_10)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AgentModalComponent_11)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 33, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class',
                'col-sm-7 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'form-group label-floating']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Define Roles'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AgentModalComponent_12)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 18, 'div', [['class', 'col-sm-5']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'position']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 12, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2,
                    'ng-valid', null], [2, 'ng-invalid', null], [2,
                    'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.currentAgent.Position = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['positionModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_AgentModalComponent_13)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_AgentModalComponent_14)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-primary btn-round pull-right submit'],
            ['type', 'submit']], [[8, 'disabled', 0]], null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"],
            core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Save '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.string.isNullOrEmpty(_co.currentAgent.ImageSrc);
        _ck(_v, 21, 0, currVal_7);
        var currVal_8 = !_co.string.isNullOrEmpty(_co.currentAgent.ImageSrc);
        _ck(_v, 24, 0, currVal_8);
        var currVal_17 = '';
        _ck(_v, 35, 0, currVal_17);
        var currVal_18 = 'text';
        var currVal_19 = 'First Name';
        var currVal_20 = 'First Name';
        var currVal_21 = false;
        var currVal_22 = core_es5["ɵnov"](_v, 8);
        _ck(_v, 37, 0, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22);
        var currVal_23 = 'First Name';
        var currVal_24 = false;
        var currVal_25 = _co.currentAgent.FirstName;
        _ck(_v, 39, 0, currVal_23, currVal_24, currVal_25);
        var currVal_26 = ((core_es5["ɵunv"](_v, 44, 0, _ck(_v, 45, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 37).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 37).model.pristine || core_es5["ɵnov"](_v, 8).submitted));
        _ck(_v, 44, 0, currVal_26);
        var currVal_27 = _co.showSelect;
        _ck(_v, 50, 0, currVal_27);
        var currVal_36 = '';
        _ck(_v, 58, 0, currVal_36);
        var currVal_37 = 'text';
        var currVal_38 = 'Last Name';
        var currVal_39 = 'Last Name';
        var currVal_40 = false;
        var currVal_41 = core_es5["ɵnov"](_v, 8);
        _ck(_v, 60, 0, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41);
        var currVal_42 = 'Last Name';
        var currVal_43 = false;
        var currVal_44 = _co.currentAgent.LastName;
        _ck(_v, 62, 0, currVal_42, currVal_43, currVal_44);
        var currVal_45 = ((core_es5["ɵunv"](_v, 67, 0, _ck(_v, 68, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 60).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 60).model.pristine || core_es5["ɵnov"](_v, 8).submitted));
        _ck(_v, 67, 0, currVal_45);
        var currVal_54 = '';
        _ck(_v, 75, 0, currVal_54);
        var currVal_55 = 'US';
        _ck(_v, 76, 0, currVal_55);
        var currVal_56 = 'text';
        var currVal_57 = 'Phone';
        var currVal_58 = 'Phone';
        var currVal_59 = false;
        var currVal_60 = core_es5["ɵnov"](_v, 8);
        _ck(_v, 78, 0, currVal_56, currVal_57, currVal_58, currVal_59, currVal_60);
        var currVal_61 = 'Phone';
        var currVal_62 = false;
        var currVal_63 = _co.currentAgent.Phone;
        _ck(_v, 80, 0, currVal_61, currVal_62, currVal_63);
        var currVal_64 = ((core_es5["ɵunv"](_v, 85, 0, _ck(_v, 86, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 78).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 78).model.pristine || core_es5["ɵnov"](_v, 8).submitted));
        _ck(_v, 85, 0, currVal_64);
        var currVal_65 = core_es5["ɵnov"](_v, 78).model.hasError('noValidRegionCode');
        _ck(_v, 89, 0, currVal_65);
        var currVal_66 = core_es5["ɵnov"](_v, 78).model.hasError('noPhoneNumber');
        _ck(_v, 92, 0, currVal_66);
        var currVal_67 = _co.groups;
        _ck(_v, 109, 0, currVal_67);
        var currVal_76 = '';
        _ck(_v, 118, 0, currVal_76);
        var currVal_77 = 'text';
        var currVal_78 = 'Position';
        var currVal_79 = 'Position';
        var currVal_80 = false;
        var currVal_81 = core_es5["ɵnov"](_v, 8);
        _ck(_v, 120, 0, currVal_77, currVal_78, currVal_79, currVal_80, currVal_81);
        var currVal_82 = 'Position';
        var currVal_83 = false;
        var currVal_84 = _co.currentAgent.Position;
        _ck(_v, 122, 0, currVal_82, currVal_83, currVal_84);
        var currVal_85 = ((core_es5["ɵunv"](_v, 127, 0, _ck(_v, 128, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 120).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 120).model.pristine || core_es5["ɵnov"](_v, 8).submitted));
        _ck(_v, 127, 0, currVal_85);
        var currVal_86 = _co.currentAgent.Id;
        _ck(_v, 139, 0, currVal_86);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵnov"](_v, 10).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 10).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 10).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 10).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 10).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 10).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 10).ngClassPending;
        _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_9 = (core_es5["ɵnov"](_v, 35).required ? '' : null);
        var currVal_10 = core_es5["ɵnov"](_v, 41).ngClassUntouched;
        var currVal_11 = core_es5["ɵnov"](_v, 41).ngClassTouched;
        var currVal_12 = core_es5["ɵnov"](_v, 41).ngClassPristine;
        var currVal_13 = core_es5["ɵnov"](_v, 41).ngClassDirty;
        var currVal_14 = core_es5["ɵnov"](_v, 41).ngClassValid;
        var currVal_15 = core_es5["ɵnov"](_v, 41).ngClassInvalid;
        var currVal_16 = core_es5["ɵnov"](_v, 41).ngClassPending;
        _ck(_v, 34, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16);
        var currVal_28 = (core_es5["ɵnov"](_v, 58).required ? '' : null);
        var currVal_29 = core_es5["ɵnov"](_v, 64).ngClassUntouched;
        var currVal_30 = core_es5["ɵnov"](_v, 64).ngClassTouched;
        var currVal_31 = core_es5["ɵnov"](_v, 64).ngClassPristine;
        var currVal_32 = core_es5["ɵnov"](_v, 64).ngClassDirty;
        var currVal_33 = core_es5["ɵnov"](_v, 64).ngClassValid;
        var currVal_34 = core_es5["ɵnov"](_v, 64).ngClassInvalid;
        var currVal_35 = core_es5["ɵnov"](_v, 64).ngClassPending;
        _ck(_v, 57, 0, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35);
        var currVal_46 = (core_es5["ɵnov"](_v, 75).required ? '' : null);
        var currVal_47 = core_es5["ɵnov"](_v, 82).ngClassUntouched;
        var currVal_48 = core_es5["ɵnov"](_v, 82).ngClassTouched;
        var currVal_49 = core_es5["ɵnov"](_v, 82).ngClassPristine;
        var currVal_50 = core_es5["ɵnov"](_v, 82).ngClassDirty;
        var currVal_51 = core_es5["ɵnov"](_v, 82).ngClassValid;
        var currVal_52 = core_es5["ɵnov"](_v, 82).ngClassInvalid;
        var currVal_53 = core_es5["ɵnov"](_v, 82).ngClassPending;
        _ck(_v, 74, 0, currVal_46, currVal_47, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53);
        var currVal_68 = (core_es5["ɵnov"](_v, 118).required ? '' : null);
        var currVal_69 = core_es5["ɵnov"](_v, 124).ngClassUntouched;
        var currVal_70 = core_es5["ɵnov"](_v, 124).ngClassTouched;
        var currVal_71 = core_es5["ɵnov"](_v, 124).ngClassPristine;
        var currVal_72 = core_es5["ɵnov"](_v, 124).ngClassDirty;
        var currVal_73 = core_es5["ɵnov"](_v, 124).ngClassValid;
        var currVal_74 = core_es5["ɵnov"](_v, 124).ngClassInvalid;
        var currVal_75 = core_es5["ɵnov"](_v, 124).ngClassPending;
        _ck(_v, 117, 0, currVal_68, currVal_69, currVal_70, currVal_71, currVal_72, currVal_73, currVal_74, currVal_75);
        var currVal_87 = (_co.processing || (core_es5["ɵnov"](_v, 8).submitted && !core_es5["ɵnov"](_v, 8).valid));
        _ck(_v, 141, 0, currVal_87);
    });
}
function View_AgentModalComponent_15(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-item', [['topClass', 'col-md-4 col-sm-6'], ['topClassNext', 'quick-order-details-margin']], null, null, null, View_OrderItemComponent_0, RenderType_OrderItemComponent)),
        core_es5["ɵdid"](49152, null, 0, orderItem_component_OrderItemComponent, [router_es5["n" /* Router */], router_es5["a" /* ActivatedRoute */]], { order: [0, 'order'], topClass: [1, 'topClass'], topClassNext: [2, 'topClassNext'],
            isDisabled: [3, 'isDisabled'], columns: [4, 'columns'] }, null), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _v.context.$implicit;
        var currVal_1 = 'col-md-4 col-sm-6';
        var currVal_2 = 'quick-order-details-margin';
        var currVal_3 = (_co.userHelper.isInGroupById(_co.currentUser, 2) && (_co.currentUser.Groups.length == 1));
        var currVal_4 = _co.tableColumns;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4);
    }, null);
}
function View_AgentModalComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, FirstKeyPipe, []), core_es5["ɵqud"](402653184, 1, { agentModal: 0 }), core_es5["ɵqud"](671088640, 2, { agentForm: 0 }), core_es5["ɵqud"](402653184, 3, { agentModalRef: 0 }),
        (_l()(), core_es5["ɵeld"](16777216, [[3, 0], ['ag', 1]], null, 31, 'div', [['bsModal',
                ''], ['class', 'modal fade agent-modal'], ['id', 'myModal'], ['role', 'dialog']], null, [[null, 'onHidden'], [null, 'scroll'], [null,
                'click'], [null, 'keydown.esc']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 5).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown.esc' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 5).onEsc() !== false);
                ad = (pd_1 && ad);
            }
            if (('onHidden' === en)) {
                var pd_2 = (_co.onModalHidden() !== false);
                ad = (pd_2 && ad);
            }
            if (('scroll' === en)) {
                var pd_3 = (_co.handleScroll() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4341760, [[1, 4], ['agentModal', 4]], 0, modal_component["a" /* ModalDirective */], [core_es5["ElementRef"], core_es5["ViewContainerRef"], core_es5["Renderer"], component_loader_factory["a" /* ComponentLoaderFactory */]], null, { onHidden: 'onHidden' }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 27, 'div', [['class', 'modal-dialog modal-lg'],
            ['role', 'document']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 24, 'div', [['class', 'modal-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'modal-header header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'modal-title'], ['id', 'myModalLabel']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['aria-label', 'Close'], ['class', 'close pull-right btn btn-round btn-white modal-close-btn'],
            ['data-dismiss', 'modal'], ['type', 'button']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 5).hide() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons modal-close-icon']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['close'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AgentModalComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'modal-footer']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'row row_quick_order']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AgentModalComponent_15)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = (_co.currentAgent != null);
        _ck(_v, 23, 0, currVal_1);
        var currVal_2 = _co.currentAgent.Orders;
        _ck(_v, 30, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (!_co.currentAgent.Id ? 'CREATE AGENT' : 'EDIT AGENT');
        _ck(_v, 14, 0, currVal_0);
    });
}
function View_AgentModalComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'agent-modal', [], null, [[null, 'scroll'], [null, 'mousewheel'],
            ['document', 'keydown']], function (_v, en, $event) {
            var ad = true;
            if (('scroll' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onMousewheel($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('mousewheel' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 1).onMousewheel($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('document:keydown' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 1).onArrowDown($event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, View_AgentModalComponent_0, RenderType_AgentModalComponent)), core_es5["ɵdid"](114688, null, 0, agent_modal_component["a" /* AgentModalComponent */], [services_userService["a" /* UserService */], services_configService["a" /* ConfigService */], router_es5["n" /* Router */],
            managers_storageManager["a" /* StorageManager */], services_userViewService["a" /* UserViewService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AgentModalComponentNgFactory = core_es5["ɵccf"]('agent-modal', agent_modal_component["a" /* AgentModalComponent */], View_AgentModalComponent_Host_0, { groups: 'groups', idToBlur: 'idToBlur' }, { agentSaved: 'agentSaved' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=agent-modal.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/app/components/agent/agent-management.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */

















var styles_AgentManagementComponent = [];
var RenderType_AgentManagementComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AgentManagementComponent, data: {} });
function View_AgentManagementComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'agent-item', [], null, null, null, View_AgentItemComponent_0, RenderType_AgentItemComponent)), core_es5["ɵdid"](49152, null, 0, agent_item_component_AgentItemComponent, [], { agent: [0, 'agent'], agentModal: [1, 'agentModal'] }, null),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        var currVal_1 = core_es5["ɵnov"](_v.parent.parent, 2);
        _ck(_v, 3, 0, currVal_0, currVal_1);
    }, null);
}
function View_AgentManagementComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_AgentManagementComponent_2)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), core_es5["ɵpid"](0, PaginatePipe, [ngx_pagination_PaginationService]),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 3, 0, core_es5["ɵnov"](_v, 4).transform(_co.agents, _co.config));
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_AgentManagementComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'row'], ['style', 'text-align:center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h2', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' No matching results! '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_AgentManagementComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'management-pagination', [], null, [[null, 'searchEventEmitter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('searchEventEmitter' === en)) {
                var pd_0 = (_co.search() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ManagementPaginationComponent_0, RenderType_ManagementPaginationComponent)),
        core_es5["ɵdid"](49152, null, 0, managementPagination_component_ManagementPaginationComponent, [], { config: [0, 'config'] }, { searchEventEmitter: 'searchEventEmitter' }), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.config;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_AgentManagementComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { agentModalComponent: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'agent-modal', [], null, [[null,
                'agentSaved'], [null, 'scroll'], [null, 'mousewheel'], ['document',
                'keydown']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('scroll' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 2).onMousewheel($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('mousewheel' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 2).onMousewheel($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('document:keydown' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 2).onArrowDown($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('agentSaved' === en)) {
                var pd_3 = (_co.onAgentSaved($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, View_AgentModalComponent_0, RenderType_AgentModalComponent)), core_es5["ɵdid"](114688, [[1, 4], ['agentModal', 4]], 0, agent_modal_component["a" /* AgentModalComponent */], [services_userService["a" /* UserService */], services_configService["a" /* ConfigService */],
            router_es5["n" /* Router */], managers_storageManager["a" /* StorageManager */], services_userViewService["a" /* UserViewService */]], { groups: [0, 'groups'],
            idToBlur: [1, 'idToBlur'] }, { agentSaved: 'agentSaved' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'div', [['class', 'main-content']], [[1, 'id', 0]], null, null, null, null)), core_es5["ɵpad"](1),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'div', [['class', 'container-fluid']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 2, 'management-search', [], null, [[null, 'searchEventEmitter'], [null, 'queryChange'],
                [null, 'createEventEmitter']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('searchEventEmitter' === en)) {
                    _co.config.currentPage = 1;
                    var pd_0 = (_co.search() !== false);
                    ad = (pd_0 && ad);
                }
                if (('queryChange' === en)) {
                    var pd_1 = ((_co.query = $event) !== false);
                    ad = (pd_1 && ad);
                }
                if (('createEventEmitter' === en)) {
                    var pd_2 = (_co.createAgent() !== false);
                    ad = (pd_2 && ad);
                }
                return ad;
            }, View_ManagementSearchComponent_0, RenderType_ManagementSearchComponent)),
        core_es5["ɵdid"](49152, null, 0, managementSearch_component_ManagementSearchComponent, [], { showCreate: [0,
                'showCreate'], createIcon: [1, 'createIcon'], helpText: [2, 'helpText'], query: [3,
                'query'] }, { searchEventEmitter: 'searchEventEmitter', createEventEmitter: 'createEventEmitter',
            queryChange: 'queryChange' }), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AgentManagementComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AgentManagementComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AgentManagementComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.groups;
        var currVal_1 = _co.idToBlur;
        _ck(_v, 2, 0, currVal_0, currVal_1);
        var currVal_3 = true;
        var currVal_4 = 'group_add';
        var currVal_5 = 'Search by Name, Email, Phone';
        var currVal_6 = _co.query;
        _ck(_v, 10, 0, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (_co.agents.length > 0);
        _ck(_v, 14, 0, currVal_7);
        var currVal_8 = (_co.agents.length == 0);
        _ck(_v, 17, 0, currVal_8);
        var currVal_9 = (_co.agents.length > 0);
        _ck(_v, 20, 0, currVal_9);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _ck(_v, 5, 0, _co.idToBlur);
        _ck(_v, 4, 0, currVal_2);
    });
}
function View_AgentManagementComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'agent', [], null, [['window', 'popstate']], function (_v, en, $event) {
            var ad = true;
            if (('window:popstate' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).unBlurMenu($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_AgentManagementComponent_0, RenderType_AgentManagementComponent)), core_es5["ɵdid"](114688, null, 0, agent_management_component_AgentManagementComponent, [router_es5["a" /* ActivatedRoute */], services_userService["a" /* UserService */],
            managers_storageManager["a" /* StorageManager */], services_configService["a" /* ConfigService */], router_es5["n" /* Router */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AgentManagementComponentNgFactory = core_es5["ɵccf"]('agent', agent_management_component_AgentManagementComponent, View_AgentManagementComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=agent-management.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/objects/orders/calculatorType.ts
var orders_calculatorType = __webpack_require__("BhF2");

// CONCATENATED MODULE: ./app/components/calculator/tabs/fill-order-tab/fill-order-tab.component.ts
/**
 * Created by vlad.p on 9/12/2017.
 */




var fill_order_tab_component_FillOrderTabComponent = /** @class */ (function () {
    function FillOrderTabComponent(renderer) {
        this.renderer = renderer;
        this.isPublic = false;
        this.extraDataChange = new core_es5["EventEmitter"]();
        this.isOrderDetails = false;
        this.submitted = false;
        this.isVehicle = false;
    }
    Object.defineProperty(FillOrderTabComponent.prototype, "isUsService", {
        get: function () {
            return calculatorHelper["a" /* CalculatorHelper */].isUsService(this.order);
        },
        enumerable: true,
        configurable: true
    });
    FillOrderTabComponent.prototype.countTotal = function () {
        var total = 0;
        if (this.order == null || this.order.OrderItems.length == 0)
            return total;
        if (calculatorHelper["a" /* CalculatorHelper */].isSameCurrency(this.order.OrderItems)) {
            for (var _i = 0, _a = this.order.OrderItems; _i < _a.length; _i++) {
                var orderItem = _a[_i];
                if (!isNaN(orderItem.Price))
                    total += orderItem.Price ? +orderItem.Price : 0;
            }
            return total;
        }
        var _loop_1 = function (orderItem) {
            if (orderItem.CanadianCurrencyCode == null || orderItem.CanadianCurrencyCode == null || String.isNullOrEmpty(orderItem.CanadianCurrencyCode.Code))
                return "continue";
            var exchangeRate = this_1.canadianCurrencyCodes.find(function (x) { return x.Code == orderItem.CanadianCurrencyCode.Code; });
            var price = +orderItem.Price;
            if (isNaN(price))
                return "continue";
            if (exchangeRate != null && this_1.order.CalculatorType != null) {
                price *= exchangeRate.Value; //converted to canadian
                if (this_1.order.CalculatorType == orders_calculatorType["a" /* CalculatorType */].UsaImport) {
                    var usdExchangeRate = this_1.canadianCurrencyCodes.find(function (x) { return x.Code == "FXUSDCAD"; });
                    price = price / usdExchangeRate.Value;
                }
            }
            total += price;
        };
        var this_1 = this;
        for (var _b = 0, _c = this.order.OrderItems; _b < _c.length; _b++) {
            var orderItem = _c[_b];
            _loop_1(orderItem);
        }
        return total;
    };
    FillOrderTabComponent.prototype.checkForm = function () {
        if (this.disableChanges)
            return true;
        var res = true;
        if (!this.customerCardComponent.checkForm())
            res = false;
        if (!this.locationCardComponent.checkForm())
            res = false;
        if (!this.productCardComponent.checkForm())
            res = false;
        return res;
    };
    FillOrderTabComponent.prototype.getTotalCurrencyCode = function () {
        if (this.order == null || this.order.OrderItems.length == 0)
            return '';
        if (calculatorHelper["a" /* CalculatorHelper */].isSameCurrency(this.order.OrderItems)) {
            return String.isNullOrEmpty(this.order.OrderItems[0].CanadianCurrencyCode.Name) ? '' : this.order.OrderItems[0].CanadianCurrencyCode.Name;
        }
        if (this.order.CalculatorType == null)
            return '';
        if (this.order.CalculatorType == orders_calculatorType["a" /* CalculatorType */].UsaImport)
            return this.canadianCurrencyCodes.find(function (x) { return x.Code == 'FXUSDCAD'; }).Name;
        return this.canadianCurrencyCodes.find(function (x) { return x.Code == 'FXCADCAD'; }).Name;
    };
    FillOrderTabComponent.prototype.goNextTab = function () {
        if (!this.checkForm()) {
            this.submitted = true;
            return;
        }
        var cont = document.querySelector(".main-panel");
        if (cont != null) {
            cont.scrollTop = 0;
            perfect_scrollbar["update"](cont);
        }
        if (!calculatorHelper["a" /* CalculatorHelper */].isVehicle(this.order))
            for (var _i = 0, _a = this.order.OrderItems; _i < _a.length; _i++) {
                var item = _a[_i];
                item.Year = null;
            }
        this.wizard.nextTab();
    };
    Object.defineProperty(FillOrderTabComponent.prototype, "isDisabled", {
        get: function () {
            var res = false;
            if (!this.customerCardComponent.isValid())
                res = true;
            if (!this.locationCardComponent.isValid())
                res = true;
            if (!this.productCardComponent.isValid())
                res = true;
            return res;
        },
        enumerable: true,
        configurable: true
    });
    FillOrderTabComponent.prototype.resetForm = function () {
        this.submitted = false;
        this.customerCardComponent.resetForm();
        this.locationCardComponent.resetForm();
    };
    FillOrderTabComponent.ctorParameters = function () { return [{ type: core_es5["Renderer2"] }]; };
    return FillOrderTabComponent;
}());

//# sourceMappingURL=fill-order-tab.component.js.map
// CONCATENATED MODULE: ./app/components/common/radio/radio.component.ts




var radio_component_RadioComponent = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](RadioComponent, _super);
    function RadioComponent(validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this.validators = validators;
        _this.asyncValidators = asyncValidators;
        return _this;
    }
    RadioComponent.prototype.ngAfterViewInit = function () {
        this.model.control.setValidators(this.validators);
        this.model.control.setAsyncValidators(this.asyncValidators);
    };
    RadioComponent.ctorParameters = function () { return [{ type: Array, decorators: [{ type: core_es5["Optional"] }, { type: core_es5["Inject"], args: [forms_es5["NG_VALIDATORS"]] }] }, { type: Array, decorators: [{ type: core_es5["Optional"] }, { type: core_es5["Inject"], args: [forms_es5["NG_ASYNC_VALIDATORS"]] }] }]; };
    return RadioComponent;
}(ValueAccessorBase));

//# sourceMappingURL=radio.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/common/radio/radio.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_RadioComponent = [];
var RenderType_RadioComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_RadioComponent, data: {} });
function View_RadioComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { model: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 23, 'div', [['class', 'radio']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 20, 'label', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'disabled': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'input', [['type', 'radio']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend'], [null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 8)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 8).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 8)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 8)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 9).onChange() !== false);
                ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 9).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.value = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](212992, null, 0, forms_es5["RadioControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], forms_es5["ɵi"], core_es5["Injector"]], { name: [0, 'name'], value: [1,
                'value'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], forms_es5["RadioControlValueAccessor"]]), core_es5["ɵdid"](671744, [[1, 4]], 0, forms_es5["NgModel"], [[8, null], [8, null], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'],
            model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class',
                'circle']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'check']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'radio-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), core_es5["ɵncd"](null, 0),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 5, 0, _co.disabled);
        _ck(_v, 4, 0, currVal_0);
        var currVal_8 = core_es5["ɵinlineInterpolate"](1, '', _co.name, '');
        var currVal_9 = _co.radioValue;
        _ck(_v, 9, 0, currVal_8, currVal_9);
        var currVal_10 = core_es5["ɵinlineInterpolate"](1, '', _co.name, '');
        var currVal_11 = _co.disabled;
        var currVal_12 = _co.value;
        _ck(_v, 11, 0, currVal_10, currVal_11, currVal_12);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = core_es5["ɵnov"](_v, 13).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 13).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 13).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 13).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 13).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 13).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 13).ngClassPending;
        _ck(_v, 7, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_13 = (_co.label || '');
        _ck(_v, 20, 0, currVal_13);
    });
}
function View_RadioComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'radio', [], null, null, null, View_RadioComponent_0, RenderType_RadioComponent)),
        core_es5["ɵprd"](5120, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2,
                forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], null, null)], null, null);
}
var RadioComponentNgFactory = core_es5["ɵccf"]('radio', radio_component_RadioComponent, View_RadioComponent_Host_0, { name: 'name', label: 'label', radioValue: 'radioValue',
    disabled: 'disabled' }, {}, ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL3JhZGlvL3JhZGlvLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9jb21tb24vcmFkaW8vcmFkaW8uY29tcG9uZW50LnRzIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL3JhZGlvL3JhZGlvLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL3JhZGlvL3JhZGlvLmNvbXBvbmVudC50cy5SYWRpb0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJyYWRpb1wiPiA8bGFiZWwgW25nQ2xhc3NdPVwieyAnZGlzYWJsZWQnOiBkaXNhYmxlZCB9XCI+IDxpbnB1dCB0eXBlPVwicmFkaW9cIiBuYW1lPVwie3tuYW1lfX1cIiBbdmFsdWVdPVwicmFkaW9WYWx1ZVwiIFsobmdNb2RlbCldPVwidmFsdWVcIiBbZGlzYWJsZWRdPVwiZGlzYWJsZWRcIj4gPHNwYW4gY2xhc3M9XCJjaXJjbGVcIj48L3NwYW4+IDxzcGFuIGNsYXNzPVwiY2hlY2tcIj48L3NwYW4+IDxwIGNsYXNzPVwicmFkaW8tbGFiZWxcIj57e2xhYmVsIHx8IFwiXCJ9fTwvcD4gPG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PiA8L2xhYmVsPiA8L2Rpdj4iLCI8cmFkaW8+PC9yYWRpbz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O21EQ0FBO01BQUE7TUFBQSw4QkFBbUIsc0NBQUM7YUFBQTtVQUFBLGlFQUFBO01BQUE7cUJBQUEsZ0RBQU87TUFBcUMsc0NBQUM7VUFBQTtjQUFBO2NBQUE7a0JBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUF5RDtjQUFBO2NBQUE7WUFBQTtZQUF6RDtVQUFBLHVDQUFBO1VBQUE7VUFBQSxzQkFBQTtVQUFBO2NBQUEsZ0NBQUE7VUFBQTtZQUFBO1VBQUEsaUVBQUE7VUFBQTtjQUFBO2NBQUEsb0RBQUE7dUJBQUEsbUNBQUE7VUFBQSw0Q0FBbUc7VUFBQSxRQUFDO1VBQUE7TUFBNEIsc0NBQUM7VUFBQTtVQUFBLGdCQUEyQixzQ0FBQztVQUFBO1VBQUEsMERBQXVCO1VBQUEsVUFBbUIsNkNBQUM7TUFBeUIsc0NBQVM7OztRQUFoUjtRQUFQLFdBQU8sU0FBUDtRQUFpRTtRQUFnQjtRQUFwQyxXQUFvQixVQUFnQixTQUFwQztRQUFvQjtRQUF5RDtRQUFwQjtRQUF6RCxZQUFvQixXQUF5RCxXQUFwQixVQUF6RDs7O1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQSxXQUFBLHFFQUFBO1FBQW9MO1FBQUE7Ozs7b0JDQXJQO01BQUE7YUFBQTtRQUFBO01BQUEsOEJBQUE7MEJBQUE7Ozs7OyJ9
//# sourceMappingURL=radio.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/components/calculator/cards/customer-card/customer-card.component.ts
var customer_card_component = __webpack_require__("wfUm");

// EXTERNAL MODULE: ./app/services/calculator/calculatorService.ts
var calculator_calculatorService = __webpack_require__("5Lgg");

// CONCATENATED MODULE: ./compiled/app/components/calculator/cards/customer-card/customer-card.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */

















var styles_CustomerCardComponent = [];
var RenderType_CustomerCardComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CustomerCardComponent, data: {} });
function View_CustomerCardComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Email is invalid']))], null, null);
}
function View_CustomerCardComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Email is required']))], null, null);
}
function View_CustomerCardComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 15, 'form-input', [['label', 'Email'], ['name', 'publicCustomerEmail'], ['pattern', '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'],
            ['required', ''], ['type', 'text']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.order.Customer.Email = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['publicEmail',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4,
                'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_CustomerCardComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_CustomerCardComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_9 = '';
        _ck(_v, 1, 0, currVal_9);
        var currVal_10 = '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
        _ck(_v, 2, 0, currVal_10);
        var currVal_11 = 'text';
        var currVal_12 = 'publicCustomerEmail';
        var currVal_13 = 'Email';
        var currVal_14 = _co.disableChanges;
        var currVal_15 = core_es5["ɵnov"](_v.parent, 2);
        _ck(_v, 4, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15);
        var currVal_16 = 'publicCustomerEmail';
        var currVal_17 = _co.disableChanges;
        var currVal_18 = _co.order.Customer.Email;
        _ck(_v, 6, 0, currVal_16, currVal_17, currVal_18);
        var currVal_19 = core_es5["ɵnov"](_v, 4).model.hasError('pattern');
        _ck(_v, 11, 0, currVal_19);
        var currVal_20 = core_es5["ɵnov"](_v, 4).model.hasError('required');
        _ck(_v, 14, 0, currVal_20);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 1).required ? '' : null);
        var currVal_1 = (core_es5["ɵnov"](_v, 2).pattern ? core_es5["ɵnov"](_v, 2).pattern : null);
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    });
}
function View_CustomerCardComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Email is required. ']))], null, null);
}
function View_CustomerCardComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Your email address is invalid. ']))], null, null);
}
function View_CustomerCardComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 27, 'div', [['class',
                'form-group label-floating'], ['id', 'emailBlock']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0, 'select-is-open': 1 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Email'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'select', [['class', 'form-control select2'], ['id', 'emailSelect'], ['name',
                'emailModel'], ['pattern', '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'],
            ['required', '']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 8).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 8).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.order.Customer.Email = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, [['emailModel', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'material-input']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_CustomerCardComponent_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 2, null, View_CustomerCardComponent_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'form-group label-floating';
        var currVal_1 = _ck(_v, 2, 0, (core_es5["ɵnov"](_v.parent, 2) && (core_es5["ɵnov"](_v, 13).invalid && (!core_es5["ɵnov"](_v, 13).pristine || core_es5["ɵnov"](_v.parent, 2).submitted))), (_co.select2Util.checkIfSelectOpen('emailBlock') || _co.order.Customer.Email));
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_11 = '';
        _ck(_v, 9, 0, currVal_11);
        var currVal_12 = '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
        _ck(_v, 10, 0, currVal_12);
        var currVal_13 = 'emailModel';
        var currVal_14 = _co.disableChanges;
        var currVal_15 = _co.order.Customer.Email;
        _ck(_v, 13, 0, currVal_13, currVal_14, currVal_15);
        var currVal_16 = ((core_es5["ɵunv"](_v, 21, 0, _ck(_v, 22, 0, core_es5["ɵnov"](_v.parent.parent, 0), core_es5["ɵnov"](_v, 13).errors)) == 'required') && (!core_es5["ɵnov"](_v, 13).pristine || core_es5["ɵnov"](_v.parent, 2).submitted));
        _ck(_v, 21, 0, currVal_16);
        var currVal_17 = ((core_es5["ɵunv"](_v, 25, 0, _ck(_v, 26, 0, core_es5["ɵnov"](_v.parent.parent, 0), core_es5["ɵnov"](_v, 13).errors)) == 'pattern') && (!core_es5["ɵnov"](_v, 13).pristine || core_es5["ɵnov"](_v.parent, 2).submitted));
        _ck(_v, 25, 0, currVal_17);
    }, function (_ck, _v) {
        var currVal_2 = (core_es5["ɵnov"](_v, 9).required ? '' : null);
        var currVal_3 = (core_es5["ɵnov"](_v, 10).pattern ? core_es5["ɵnov"](_v, 10).pattern : null);
        var currVal_4 = core_es5["ɵnov"](_v, 15).ngClassUntouched;
        var currVal_5 = core_es5["ɵnov"](_v, 15).ngClassTouched;
        var currVal_6 = core_es5["ɵnov"](_v, 15).ngClassPristine;
        var currVal_7 = core_es5["ɵnov"](_v, 15).ngClassDirty;
        var currVal_8 = core_es5["ɵnov"](_v, 15).ngClassValid;
        var currVal_9 = core_es5["ɵnov"](_v, 15).ngClassInvalid;
        var currVal_10 = core_es5["ɵnov"](_v, 15).ngClassPending;
        _ck(_v, 7, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10);
    });
}
function View_CustomerCardComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' First Name is required. ']))], null, null);
}
function View_CustomerCardComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Last Name is required. ']))], null, null);
}
function View_CustomerCardComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Is not a countryCode']))], null, null);
}
function View_CustomerCardComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Is not a phone number']))], null, null);
}
function View_CustomerCardComponent_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Company is required. ']))], null, null);
}
function View_CustomerCardComponent_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class',
                'col-md-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'form-input', [['class', 'lighter'], ['required', '']], [[1, 'required', 0],
            [2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.order.Customer.Company.Name = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['companyModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CustomerCardComponent_13)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_8 = '';
        _ck(_v, 3, 0, currVal_8);
        var currVal_9 = 'text';
        var currVal_10 = 'companyName';
        var currVal_11 = 'Company name';
        var currVal_12 = _co.disableChanges;
        var currVal_13 = core_es5["ɵnov"](_v.parent, 2);
        _ck(_v, 5, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13);
        var currVal_14 = 'companyName';
        var currVal_15 = _co.disableChanges;
        var currVal_16 = _co.order.Customer.Company.Name;
        _ck(_v, 7, 0, currVal_14, currVal_15, currVal_16);
        var currVal_17 = ((core_es5["ɵunv"](_v, 12, 0, _ck(_v, 13, 0, core_es5["ɵnov"](_v.parent.parent, 0), core_es5["ɵnov"](_v, 5).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 5).model.pristine || core_es5["ɵnov"](_v.parent, 2).submitted));
        _ck(_v, 12, 0, currVal_17);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 3).required ? '' : null);
        var currVal_1 = core_es5["ɵnov"](_v, 9).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 9).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 9).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 9).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 9).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 9).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 9).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
    });
}
function View_CustomerCardComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 142, 'form', [['class',
                'form-horizontal'], ['id', 'test'], ['novalidate', '']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 2).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 2).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[1, 4], ['customerForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 46, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'col-md-4']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'select2-type': 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerCardComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerCardComponent_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class',
                'col-md-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.order.Customer.FirstName = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [[3, 4], ['firstNameModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CustomerCardComponent_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class',
                'col-md-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.order.Customer.LastName = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [[2, 4], ['lastNameModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CustomerCardComponent_9)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 58, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 33, 'div', [['class', 'col-md-4']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Shipping'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'col-md-6 col-xs-4']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.order.IsCommercial = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'], disabled: [3,
                'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'col-md-6 col-xs-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.order.IsCommercial = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'], disabled: [3,
                'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['possiblePhone', 'US']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.order.Customer.Phone = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](81920, null, 0, phone_directive_PossiblePhoneValidatorDirective, [], { possiblePhone: [0,
                'possiblePhone'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [phone_directive_PossiblePhoneValidatorDirective]), core_es5["ɵdid"](4308992, [['phoneModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], disabled: [3, 'disabled'],
            form: [4, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_CustomerCardComponent_10)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_CustomerCardComponent_11)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerCardComponent_12)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 8, 'form-input', [['label', 'How did you hear about us today? (opt)'],
                ['name', 'extraDataName'], ['type', '\'text\'']], [[2, 'ng-untouched', null],
                [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                    null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
                [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.extraData.Data = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'readonly': 0 }),
        core_es5["ɵdid"](4308992, [['marketingTextModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]],
            [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'],
            disabled: [3, 'disabled'], form: [4, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'col-md-12 col-xs-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'checkbox', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.continuousBondFile = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], disabled: [2, 'disabled'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'col-md-4';
        var currVal_8 = _ck(_v, 10, 0, !_co.isPublic);
        _ck(_v, 9, 0, currVal_7, currVal_8);
        var currVal_9 = _co.isPublic;
        _ck(_v, 13, 0, currVal_9);
        var currVal_10 = !_co.isPublic;
        _ck(_v, 16, 0, currVal_10);
        var currVal_19 = '';
        _ck(_v, 22, 0, currVal_19);
        var currVal_20 = 'text';
        var currVal_21 = 'firstName';
        var currVal_22 = 'First Name';
        var currVal_23 = _co.disableChanges;
        var currVal_24 = core_es5["ɵnov"](_v, 2);
        _ck(_v, 24, 0, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24);
        var currVal_25 = 'firstName';
        var currVal_26 = _co.disableChanges;
        var currVal_27 = _co.order.Customer.FirstName;
        _ck(_v, 26, 0, currVal_25, currVal_26, currVal_27);
        var currVal_28 = ((core_es5["ɵunv"](_v, 31, 0, _ck(_v, 32, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 24).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 24).model.pristine || core_es5["ɵnov"](_v, 2).submitted));
        _ck(_v, 31, 0, currVal_28);
        var currVal_37 = '';
        _ck(_v, 39, 0, currVal_37);
        var currVal_38 = 'text';
        var currVal_39 = 'lastName';
        var currVal_40 = 'Last Name';
        var currVal_41 = _co.disableChanges;
        var currVal_42 = core_es5["ɵnov"](_v, 2);
        _ck(_v, 41, 0, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42);
        var currVal_43 = 'lastName';
        var currVal_44 = _co.disableChanges;
        var currVal_45 = _co.order.Customer.LastName;
        _ck(_v, 43, 0, currVal_43, currVal_44, currVal_45);
        var currVal_46 = ((core_es5["ɵunv"](_v, 48, 0, _ck(_v, 49, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 41).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 41).model.pristine || core_es5["ɵnov"](_v, 2).submitted));
        _ck(_v, 48, 0, currVal_46);
        var currVal_54 = 'commercial';
        var currVal_55 = 'Individual';
        var currVal_56 = false;
        var currVal_57 = _co.disableChanges;
        _ck(_v, 72, 0, currVal_54, currVal_55, currVal_56, currVal_57);
        var currVal_58 = 'commercial';
        var currVal_59 = _co.disableChanges;
        var currVal_60 = _co.order.IsCommercial;
        _ck(_v, 74, 0, currVal_58, currVal_59, currVal_60);
        var currVal_68 = 'commercial';
        var currVal_69 = 'Business';
        var currVal_70 = true;
        var currVal_71 = _co.disableChanges;
        _ck(_v, 82, 0, currVal_68, currVal_69, currVal_70, currVal_71);
        var currVal_72 = 'commercial';
        var currVal_73 = _co.disableChanges;
        var currVal_74 = _co.order.IsCommercial;
        _ck(_v, 84, 0, currVal_72, currVal_73, currVal_74);
        var currVal_82 = 'US';
        _ck(_v, 94, 0, currVal_82);
        var currVal_83 = 'text';
        var currVal_84 = 'phone';
        var currVal_85 = 'Phone (opt)';
        var currVal_86 = _co.disableChanges;
        var currVal_87 = core_es5["ɵnov"](_v, 2);
        _ck(_v, 96, 0, currVal_83, currVal_84, currVal_85, currVal_86, currVal_87);
        var currVal_88 = 'phone';
        var currVal_89 = _co.disableChanges;
        var currVal_90 = _co.order.Customer.Phone;
        _ck(_v, 98, 0, currVal_88, currVal_89, currVal_90);
        var currVal_91 = core_es5["ɵnov"](_v, 96).model.hasError('noValidRegionCode');
        _ck(_v, 103, 0, currVal_91);
        var currVal_92 = core_es5["ɵnov"](_v, 96).model.hasError('noPhoneNumber');
        _ck(_v, 106, 0, currVal_92);
        var currVal_93 = _co.order.IsCommercial;
        _ck(_v, 111, 0, currVal_93);
        var currVal_101 = _ck(_v, 120, 0, _co.hasExtraData);
        _ck(_v, 119, 0, currVal_101);
        var currVal_102 = '\'text\'';
        var currVal_103 = 'extraDataName';
        var currVal_104 = 'How did you hear about us today? (opt)';
        var currVal_105 = _co.disableChanges;
        var currVal_106 = core_es5["ɵnov"](_v, 2);
        _ck(_v, 121, 0, currVal_102, currVal_103, currVal_104, currVal_105, currVal_106);
        var currVal_107 = 'extraDataName';
        var currVal_108 = _co.disableChanges;
        var currVal_109 = _co.extraData.Data;
        _ck(_v, 123, 0, currVal_107, currVal_108, currVal_109);
        var currVal_117 = 'bond';
        var currVal_118 = 'Continuous Bond on File (Check for yes, to apply $0.00 charge)';
        var currVal_119 = _co.disableChanges;
        _ck(_v, 135, 0, currVal_117, currVal_118, currVal_119);
        var currVal_120 = 'bond';
        var currVal_121 = _co.disableChanges;
        var currVal_122 = _co.continuousBondFile;
        _ck(_v, 137, 0, currVal_120, currVal_121, currVal_122);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 4).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 4).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 4).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 4).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 4).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 4).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 4).ngClassPending;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_11 = (core_es5["ɵnov"](_v, 22).required ? '' : null);
        var currVal_12 = core_es5["ɵnov"](_v, 28).ngClassUntouched;
        var currVal_13 = core_es5["ɵnov"](_v, 28).ngClassTouched;
        var currVal_14 = core_es5["ɵnov"](_v, 28).ngClassPristine;
        var currVal_15 = core_es5["ɵnov"](_v, 28).ngClassDirty;
        var currVal_16 = core_es5["ɵnov"](_v, 28).ngClassValid;
        var currVal_17 = core_es5["ɵnov"](_v, 28).ngClassInvalid;
        var currVal_18 = core_es5["ɵnov"](_v, 28).ngClassPending;
        _ck(_v, 21, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18);
        var currVal_29 = (core_es5["ɵnov"](_v, 39).required ? '' : null);
        var currVal_30 = core_es5["ɵnov"](_v, 45).ngClassUntouched;
        var currVal_31 = core_es5["ɵnov"](_v, 45).ngClassTouched;
        var currVal_32 = core_es5["ɵnov"](_v, 45).ngClassPristine;
        var currVal_33 = core_es5["ɵnov"](_v, 45).ngClassDirty;
        var currVal_34 = core_es5["ɵnov"](_v, 45).ngClassValid;
        var currVal_35 = core_es5["ɵnov"](_v, 45).ngClassInvalid;
        var currVal_36 = core_es5["ɵnov"](_v, 45).ngClassPending;
        _ck(_v, 38, 0, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36);
        var currVal_47 = core_es5["ɵnov"](_v, 76).ngClassUntouched;
        var currVal_48 = core_es5["ɵnov"](_v, 76).ngClassTouched;
        var currVal_49 = core_es5["ɵnov"](_v, 76).ngClassPristine;
        var currVal_50 = core_es5["ɵnov"](_v, 76).ngClassDirty;
        var currVal_51 = core_es5["ɵnov"](_v, 76).ngClassValid;
        var currVal_52 = core_es5["ɵnov"](_v, 76).ngClassInvalid;
        var currVal_53 = core_es5["ɵnov"](_v, 76).ngClassPending;
        _ck(_v, 71, 0, currVal_47, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53);
        var currVal_61 = core_es5["ɵnov"](_v, 86).ngClassUntouched;
        var currVal_62 = core_es5["ɵnov"](_v, 86).ngClassTouched;
        var currVal_63 = core_es5["ɵnov"](_v, 86).ngClassPristine;
        var currVal_64 = core_es5["ɵnov"](_v, 86).ngClassDirty;
        var currVal_65 = core_es5["ɵnov"](_v, 86).ngClassValid;
        var currVal_66 = core_es5["ɵnov"](_v, 86).ngClassInvalid;
        var currVal_67 = core_es5["ɵnov"](_v, 86).ngClassPending;
        _ck(_v, 81, 0, currVal_61, currVal_62, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67);
        var currVal_75 = core_es5["ɵnov"](_v, 100).ngClassUntouched;
        var currVal_76 = core_es5["ɵnov"](_v, 100).ngClassTouched;
        var currVal_77 = core_es5["ɵnov"](_v, 100).ngClassPristine;
        var currVal_78 = core_es5["ɵnov"](_v, 100).ngClassDirty;
        var currVal_79 = core_es5["ɵnov"](_v, 100).ngClassValid;
        var currVal_80 = core_es5["ɵnov"](_v, 100).ngClassInvalid;
        var currVal_81 = core_es5["ɵnov"](_v, 100).ngClassPending;
        _ck(_v, 93, 0, currVal_75, currVal_76, currVal_77, currVal_78, currVal_79, currVal_80, currVal_81);
        var currVal_94 = core_es5["ɵnov"](_v, 125).ngClassUntouched;
        var currVal_95 = core_es5["ɵnov"](_v, 125).ngClassTouched;
        var currVal_96 = core_es5["ɵnov"](_v, 125).ngClassPristine;
        var currVal_97 = core_es5["ɵnov"](_v, 125).ngClassDirty;
        var currVal_98 = core_es5["ɵnov"](_v, 125).ngClassValid;
        var currVal_99 = core_es5["ɵnov"](_v, 125).ngClassInvalid;
        var currVal_100 = core_es5["ɵnov"](_v, 125).ngClassPending;
        _ck(_v, 118, 0, currVal_94, currVal_95, currVal_96, currVal_97, currVal_98, currVal_99, currVal_100);
        var currVal_110 = core_es5["ɵnov"](_v, 139).ngClassUntouched;
        var currVal_111 = core_es5["ɵnov"](_v, 139).ngClassTouched;
        var currVal_112 = core_es5["ɵnov"](_v, 139).ngClassPristine;
        var currVal_113 = core_es5["ɵnov"](_v, 139).ngClassDirty;
        var currVal_114 = core_es5["ɵnov"](_v, 139).ngClassValid;
        var currVal_115 = core_es5["ɵnov"](_v, 139).ngClassInvalid;
        var currVal_116 = core_es5["ɵnov"](_v, 139).ngClassPending;
        _ck(_v, 134, 0, currVal_110, currVal_111, currVal_112, currVal_113, currVal_114, currVal_115, currVal_116);
    });
}
function View_CustomerCardComponent_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'row'], ['style', 'height:266px']], null, null, null, null, null))], null, null);
}
function View_CustomerCardComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, FirstKeyPipe, []), core_es5["ɵqud"](671088640, 1, { customerForm: 0 }), core_es5["ɵqud"](671088640, 2, { lastNameModel: 0 }), core_es5["ɵqud"](671088640, 3, { firstNameModel: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'div', [['class',
                'card']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-header header card-header-text'], ['data-background-color',
                '#E07E3C']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'card-title calculator-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['CUSTOMER INFORMATION'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerCardComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CustomerCardComponent_14)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.showForm;
        _ck(_v, 15, 0, currVal_0);
        var currVal_1 = !_co.showForm;
        _ck(_v, 18, 0, currVal_1);
    }, null);
}
function View_CustomerCardComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'customer-card', [], null, null, null, View_CustomerCardComponent_0, RenderType_CustomerCardComponent)), core_es5["ɵdid"](4374528, null, 0, customer_card_component["a" /* CustomerCardComponent */], [services_configService["a" /* ConfigService */], services_extraDataService["a" /* ExtraDataService */], router_es5["n" /* Router */], calculator_calculatorService["a" /* CalculatorService */], services_customerService["a" /* CustomerService */]], null, null)], null, null);
}
var CustomerCardComponentNgFactory = core_es5["ɵccf"]('customer-card', customer_card_component["a" /* CustomerCardComponent */], View_CustomerCardComponent_Host_0, { order: 'order', locationCard: 'locationCard',
    extraData: 'extraData', disableChanges: 'disableChanges', productsCard: 'productsCard',
    isPublic: 'isPublic', isOrderDetails: 'isOrderDetails', sendCustomer: 'sendCustomer' }, { extraDataChange: 'extraDataChange' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=customer-card.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/common/utils/LocationUtil.ts
var LocationUtil = __webpack_require__("uI+f");

// EXTERNAL MODULE: ./app/objects/orders/orderItemOptions.ts
var orderItemOptions = __webpack_require__("MAv8");

// CONCATENATED MODULE: ./app/services/CountryService.ts
/**
 * Created by vlad.p on 11/6/2017.
 */

var CountryService_CountryService = /** @class */ (function () {
    function CountryService(http) {
        this.http = http;
        this.countryData = [];
    }
    CountryService.prototype.getCode = function (country) {
        if (String.isNullOrEmpty(country))
            return [];
        var countryData = this.countryData.find(function (x) { return x.name.toLowerCase() == country.toLowerCase(); });
        if (countryData != null)
            return countryData.currencies;
        return [];
    };
    CountryService.prototype.load = function () {
        var _this = this;
        var url = 'configuration/country-data.json';
        return this.http.get(url).toPromise().then(function (x) {
            _this.countryData = x.json();
            return _this.countryData;
        });
    };
    CountryService.ctorParameters = function () { return [{ type: http_es5["e" /* Http */] }]; };
    return CountryService;
}());

//# sourceMappingURL=CountryService.js.map
// EXTERNAL MODULE: ./app/objects/management/order/orderLocation.ts
var order_orderLocation = __webpack_require__("oiko");

// CONCATENATED MODULE: ./app/objects/orders/how-quickly-import-type.ts
var HowQuicklyImportType;
(function (HowQuicklyImportType) {
    HowQuicklyImportType[HowQuicklyImportType["Now"] = 0] = "Now";
    HowQuicklyImportType[HowQuicklyImportType["Within2Weeks"] = 1] = "Within2Weeks";
    HowQuicklyImportType[HowQuicklyImportType["Plus3Weeks"] = 2] = "Plus3Weeks";
    HowQuicklyImportType[HowQuicklyImportType["NotSure"] = 3] = "NotSure";
})(HowQuicklyImportType || (HowQuicklyImportType = {}));
//# sourceMappingURL=how-quickly-import-type.js.map
// CONCATENATED MODULE: ./app/components/calculator/cards/location-card/location-card.component.ts
/**
 * Created by vlad.p on 9/8/2017.
 */











var location_card_component_LocationCardComponent = /** @class */ (function () {
    function LocationCardComponent(calculatorService, ChangeDetectorRef, countryService) {
        this.calculatorService = calculatorService;
        this.ChangeDetectorRef = ChangeDetectorRef;
        this.countryService = countryService;
        this.locationTo = new order_orderLocation["a" /* OrderLocation */]();
        this.vehicleChange = new core_es5["EventEmitter"]();
        this.isVehicle = false;
        this.calculatorHelper = calculatorHelper["a" /* CalculatorHelper */];
        this.orderStatus = orders_orderStatus["a" /* OrderStatus */];
        this.orderOptions = orderOptions["a" /* OrderOptions */];
        this.howQuicklyImportTypeRef = HowQuicklyImportType;
        this.locationFromId = null;
        this.locationToId = null;
        this.showShippingTrackOption = true;
        this.showShippingAirOption = true;
        this.showShippingOceanOption = true;
    }
    Object.defineProperty(LocationCardComponent.prototype, "whoIsShipping", {
        get: function () {
            if (this.order.Flag != null && this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsCommercialCarrier)) {
                return 0;
            }
            else {
                if (this.order.Flag != null && this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsDrivingAcross)) {
                    return 1;
                }
                return 0;
            }
        },
        set: function (val) {
            if (val == 0) {
                this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsDrivingAcross;
                this.order.Flag |= orderOptions["a" /* OrderOptions */].IsCommercialCarrier;
            }
            else {
                this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsCommercialCarrier;
                this.order.Flag |= orderOptions["a" /* OrderOptions */].IsDrivingAcross;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LocationCardComponent.prototype, "carryingType", {
        get: function () {
            return this.order.CarryingType;
        },
        set: function (val) {
            if (this.order.Flag != null && this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsOcean))
                this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsOcean;
            if (val != 1) {
                this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsCommercialCarrier;
                this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsDrivingAcross;
            }
            if (val == 3)
                this.order.Flag |= orderOptions["a" /* OrderOptions */].IsOcean;
            this.order.CarryingType = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LocationCardComponent.prototype, "howQuicklyImportType", {
        get: function () {
            return this.order.HowQuicklyImportType;
        },
        set: function (val) {
            this.order.HowQuicklyImportType = val;
        },
        enumerable: true,
        configurable: true
    });
    LocationCardComponent.prototype.ngOnInit = function () {
        this.locationTo.Type = 2;
        var locTo = this.order.Locations.find(function (x) { return x.Type == 2; });
        if (locTo)
            this.locationTo = locTo;
        if (!this.locationToString)
            this.locationToString = LocationUtil["a" /* LocationUtil */].formatAddress(this.locationTo, true);
        if (!this.locationFromString)
            this.locationFromString = LocationUtil["a" /* LocationUtil */].formatAddress(this.order.Customer.Location, true);
        if (this.order && this.order.Flag)
            this.isVehicle = this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsVehicle);
        if (!this.order.CarryingType) {
            this.order.CarryingType = 1;
        }
    };
    LocationCardComponent.prototype.onLocationFromChange = function (location) {
        if (location != null) {
            this.locationFromString = LocationUtil["a" /* LocationUtil */].formatAddress(location, true);
        }
        var tempLocation = this.order.Customer.Location; //this.order.Locations.find(x => x.Type == 1);
        if (tempLocation && tempLocation.Id != null && typeof tempLocation.Id != 'undefined'
            && this.order.Id != null && typeof this.order.Id != 'undefined') {
            this.locationFromId = tempLocation.Id; // store id of previous location
        }
        this.order.Customer.Location = location;
        if (this.locationFromId != null && this.order.Customer.Location)
            this.order.Customer.Location.Id = this.locationFromId;
        if (this.order.Customer.Location) {
            this.order.Customer.Location.Type = 1;
            //CalculatorHelper.setDefaultCurrency(this.canadianCurrencyCodes, this.order, this.productsCard.calculatorAccordion.toArray(), this.countryService, false);
        }
        if (calculatorHelper["a" /* CalculatorHelper */].isCanadianVehicleCalculator(this.order) && !calculatorHelper["a" /* CalculatorHelper */].isUsaShipmentFrom(this.order)) {
            this.clearVehicleParts();
        }
        this.ChangeDetectorRef.detectChanges();
        this.locationFromModel.model.control.updateValueAndValidity();
        this.ChangeDetectorRef.detectChanges(); // Some serious shit happens with this validation
        this.calculatorService.broadcast(this.order.Customer.Location);
        this.showCarryingTypes(this.order);
    };
    LocationCardComponent.prototype.onCarryingTypeChange = function (val) {
        if (val != 1) {
            this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsCommercialCarrier;
            this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsDrivingAcross;
            console.log(this.order.Flag);
        }
    };
    LocationCardComponent.prototype.onLocationToChange = function (location) {
        this.locationTo = location;
        if (location != null)
            this.locationToString = LocationUtil["a" /* LocationUtil */].formatAddress(location, true);
        this.ChangeDetectorRef.detectChanges();
        this.locationToModel.model.control.updateValueAndValidity();
        this.ChangeDetectorRef.detectChanges(); // Some serious shit happens with this validation
        if (!location) {
            this.order.CalculatorType = null;
            if (!this.order.Id) {
                this.order.Locations = new Array();
                return;
            }
            var tempLocation = this.order.Locations.find(function (x) { return x.Type == 2; }); //todo mb store id in local variable)
            tempLocation.Country = '';
            tempLocation.City = '';
            tempLocation.Zip = '';
            tempLocation.State = '';
            tempLocation.Street = '';
            return;
        }
        if (location instanceof locationManagement_location["a" /* Location */]) {
            this.clearVehicleFlags();
            var tempLocation = this.order.Locations.find(function (x) { return x.Type == 2; });
            this.order.Locations = new Array();
            if (tempLocation && tempLocation.Id != null && typeof tempLocation.Id != 'undefined')
                this.locationTo.Id = tempLocation.Id;
            this.order.Locations.push(this.locationTo);
            this.order.CalculatorType = calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(this.order.Locations);
            this.calculatorService.broadcast(location);
        }
        if (String.isNullOrEmpty(location.toString())) {
            this.order.Locations = [];
            this.calculatorService.broadcast(null);
        }
        this.showCarryingTypes(this.order);
    };
    LocationCardComponent.prototype.showCarryingTypes = function (order) {
        if (order.Customer.Location != null && order.Locations.length) {
            var shipToLoc = order.Locations.find(function (x) { return x.Type == 2; });
            var shipFromLoc = order.Customer.Location.Country;
            if (shipFromLoc == "United States" && shipToLoc.Country == "Canada") {
                this.carryingType = 1;
                this.showShippingTrackOption = true;
                this.showShippingAirOption = false;
                this.showShippingOceanOption = false;
            }
            else if (shipFromLoc == "Canada" && shipToLoc.Country == "United States") {
                this.carryingType = 1;
                this.showShippingTrackOption = true;
                this.showShippingAirOption = true;
                this.showShippingOceanOption = true;
            }
            else if (shipToLoc.Country == "United States") {
                this.carryingType = 1;
                this.showShippingTrackOption = true;
                this.showShippingAirOption = true;
                this.showShippingOceanOption = true;
            }
            else if (shipFromLoc != "Canada") {
                this.carryingType = 2;
                this.showShippingTrackOption = false;
                this.showShippingAirOption = true;
                this.showShippingOceanOption = true;
            }
        }
        else {
            this.carryingType = 1;
            this.showShippingTrackOption = true;
            this.showShippingAirOption = true;
            this.showShippingOceanOption = true;
        }
    };
    LocationCardComponent.prototype.setLocationTo = function (location) {
        this.locationToString = LocationUtil["a" /* LocationUtil */].formatAddress(location, true);
        if (location)
            this.locationTo = location;
        this.locationTo.Type = 2;
        if (location != null && location.Country != null) {
            this.order.Locations = new Array();
            this.order.Locations.push(this.locationTo);
            this.order.CalculatorType = calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(this.order.Locations);
            this.calculatorService.broadcast(location);
        }
        if (String.isNullOrEmpty(location.toString())) {
            this.order.Locations = [];
            this.calculatorService.broadcast(null);
        }
    };
    LocationCardComponent.prototype.setLocationFrom = function (location) {
        this.locationFromString = LocationUtil["a" /* LocationUtil */].formatAddress(location, true);
        this.calculatorService.broadcast(location);
    };
    LocationCardComponent.prototype.setVehicle = function (value) {
        if (this.disableChanges)
            return;
        this.isVehicle = value;
        this.vehicleChange.emit(value);
        if (value)
            this.order.Flag |= orderOptions["a" /* OrderOptions */].IsVehicle;
        else
            this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsVehicle;
        this.calculatorService.broadcastIsVeh(value);
        if (!calculatorHelper["a" /* CalculatorHelper */].isCanadianVehicleCalculator(this.order)) {
            this.clearVehicleFlags();
        }
    };
    LocationCardComponent.prototype.checkForm = function () {
        this.locationForm.onSubmit(null);
        return this.isValid();
    };
    LocationCardComponent.prototype.isValid = function () {
        return this.locationFromModel.model.control.valid && this.locationToModel.model.control.valid;
    };
    LocationCardComponent.prototype.resetForm = function () {
        this.locationForm.resetForm();
        this.locationTo = new order_orderLocation["a" /* OrderLocation */]();
        this.locationToString = "";
        this.locationFromString = "";
        this.locationFromModel.model.control.markAsPristine();
    };
    LocationCardComponent.prototype.clearVehicleFlags = function () {
        for (var _i = 0, _a = this.productsCard.calculatorAccordion.toArray(); _i < _a.length; _i++) {
            var productCard = _a[_i];
            if (productCard.orderItem.Flags == null)
                return;
            if (productCard.orderItem.Flags.hasFlag(orderItemOptions["a" /* OrderItemOptions */].IsAC)) {
                productCard.orderItem.Flags &= ~orderItemOptions["a" /* OrderItemOptions */].IsAC;
                productCard.isAC = false;
            }
            if (productCard.orderItem.Flags.hasFlag(orderItemOptions["a" /* OrderItemOptions */].IsVehicleParts)) {
                productCard.orderItem.Flags &= ~orderItemOptions["a" /* OrderItemOptions */].IsVehicleParts;
                productCard.isVehicleParts = false;
            }
        }
    };
    LocationCardComponent.prototype.clearVehicleParts = function () {
        for (var _i = 0, _a = this.productsCard.calculatorAccordion.toArray(); _i < _a.length; _i++) {
            var productCard = _a[_i];
            if (productCard.orderItem.Flags == null)
                return;
            if (productCard.orderItem.Flags.hasFlag(orderItemOptions["a" /* OrderItemOptions */].IsVehicleParts)) {
                productCard.orderItem.Flags &= ~orderItemOptions["a" /* OrderItemOptions */].IsVehicleParts;
                productCard.isVehicleParts = false;
            }
        }
    };
    LocationCardComponent.ctorParameters = function () { return [{ type: calculator_calculatorService["a" /* CalculatorService */] }, { type: core_es5["ChangeDetectorRef"] }, { type: CountryService_CountryService }]; };
    return LocationCardComponent;
}());

//# sourceMappingURL=location-card.component.js.map
// CONCATENATED MODULE: ./app/common/directives/validators/shortLocationValidator.ts
var ShortLocationValidatorDirective = /** @class */ (function () {
    function ShortLocationValidatorDirective() {
        this.validateState = false;
    }
    ShortLocationValidatorDirective.prototype.validate = function (control) {
        if (!control.value)
            return null;
        if (!this.location || (!this.location.Country))
            return { validateLocationShort: false };
        if (this.location.Country.toLowerCase() == 'canada' && (this.validateState && !this.location.State))
            return { validateLocationShort: false };
        return null;
    };
    ShortLocationValidatorDirective.ctorParameters = function () { return []; };
    return ShortLocationValidatorDirective;
}());

//# sourceMappingURL=shortLocationValidator.js.map
// CONCATENATED MODULE: ./app/common/directives/validators/calcLocationValidator.ts
var LocationCalcValidatorDirective = /** @class */ (function () {
    function LocationCalcValidatorDirective() {
    }
    LocationCalcValidatorDirective.prototype.validate = function (control) {
        if (!this.locationTo)
            return null;
        var pattern = /.*(Canada|USA|United States).*/i;
        if ((!this.locationTo.Country.match(pattern)))
            return { validateCalcLocation: false };
        return null;
    };
    LocationCalcValidatorDirective.ctorParameters = function () { return []; };
    return LocationCalcValidatorDirective;
}());

//# sourceMappingURL=calcLocationValidator.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/cards/location-card/location-card.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */













var styles_LocationCardComponent = [];
var RenderType_LocationCardComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_LocationCardComponent, data: {} });
function View_LocationCardComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Shipment from is required. ']))], null, null);
}
function View_LocationCardComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Country is required ']))], null, null);
}
function View_LocationCardComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Shipment To is required. ']))], null, null);
}
function View_LocationCardComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Country can be only Canada or USA ']))], null, null);
}
function View_LocationCardComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Country is required (and Province for Canada) ']))], null, null);
}
function View_LocationCardComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'col-sm-3 col-xs-4']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.carryingType = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0,
                'name'], label: [1, 'label'], radioValue: [2, 'radioValue'], disabled: [3, 'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'CarryingType';
        var currVal_8 = 'Truck';
        var currVal_9 = 1;
        var currVal_10 = _co.disableChanges;
        _ck(_v, 3, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'CarryingType';
        var currVal_12 = _co.disableChanges;
        var currVal_13 = _co.carryingType;
        _ck(_v, 5, 0, currVal_11, currVal_12, currVal_13);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_LocationCardComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'col-sm-3 col-xs-4']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.carryingType = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0,
                'name'], label: [1, 'label'], radioValue: [2, 'radioValue'], disabled: [3, 'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'CarryingType';
        var currVal_8 = 'Air';
        var currVal_9 = 2;
        var currVal_10 = _co.disableChanges;
        _ck(_v, 3, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'CarryingType';
        var currVal_12 = _co.disableChanges;
        var currVal_13 = _co.carryingType;
        _ck(_v, 5, 0, currVal_11, currVal_12, currVal_13);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_LocationCardComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'col-sm-3 col-xs-4']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.carryingType = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0,
                'name'], label: [1, 'label'], radioValue: [2, 'radioValue'], disabled: [3, 'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'CarryingType';
        var currVal_8 = 'Ocean';
        var currVal_9 = 3;
        var currVal_10 = _co.disableChanges;
        _ck(_v, 3, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'CarryingType';
        var currVal_12 = _co.disableChanges;
        var currVal_13 = _co.carryingType;
        _ck(_v, 5, 0, currVal_11, currVal_12, currVal_13);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_LocationCardComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 33, 'div', [['class',
                'col-md-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class',
                'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Who is shipping'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'col-md-6 col-sm-4 col-xs-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.whoIsShipping = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'], disabled: [3,
                'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'col-md-6 col-sm-4 col-xs-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.whoIsShipping = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'], disabled: [3,
                'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'WhoIsShipping';
        var currVal_8 = 'Commercial Carrier';
        var currVal_9 = 0;
        var currVal_10 = _co.disableChanges;
        _ck(_v, 16, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'WhoIsShipping';
        var currVal_12 = _co.disableChanges;
        var currVal_13 = _co.whoIsShipping;
        _ck(_v, 18, 0, currVal_11, currVal_12, currVal_13);
        var currVal_21 = 'WhoIsShipping';
        var currVal_22 = 'I am driving it across';
        var currVal_23 = 1;
        var currVal_24 = _co.disableChanges;
        _ck(_v, 26, 0, currVal_21, currVal_22, currVal_23, currVal_24);
        var currVal_25 = 'WhoIsShipping';
        var currVal_26 = _co.disableChanges;
        var currVal_27 = _co.whoIsShipping;
        _ck(_v, 28, 0, currVal_25, currVal_26, currVal_27);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 20).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 20).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 20).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 20).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 20).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 20).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 20).ngClassPending;
        _ck(_v, 15, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_14 = core_es5["ɵnov"](_v, 30).ngClassUntouched;
        var currVal_15 = core_es5["ɵnov"](_v, 30).ngClassTouched;
        var currVal_16 = core_es5["ɵnov"](_v, 30).ngClassPristine;
        var currVal_17 = core_es5["ɵnov"](_v, 30).ngClassDirty;
        var currVal_18 = core_es5["ɵnov"](_v, 30).ngClassValid;
        var currVal_19 = core_es5["ɵnov"](_v, 30).ngClassInvalid;
        var currVal_20 = core_es5["ɵnov"](_v, 30).ngClassPending;
        _ck(_v, 25, 0, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20);
    });
}
function View_LocationCardComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'col-sm-3 col-xs-4']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.howQuicklyImportType = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0,
                'name'], label: [1, 'label'], radioValue: [2, 'radioValue'], disabled: [3, 'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'howQuicklyImportType';
        var currVal_8 = 'Now';
        var currVal_9 = _co.howQuicklyImportTypeRef.Now;
        var currVal_10 = _co.disableChanges;
        _ck(_v, 3, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'howQuicklyImportType';
        var currVal_12 = _co.disableChanges;
        var currVal_13 = _co.howQuicklyImportType;
        _ck(_v, 5, 0, currVal_11, currVal_12, currVal_13);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_LocationCardComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'col-sm-3 col-xs-4']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.howQuicklyImportType = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0,
                'name'], label: [1, 'label'], radioValue: [2, 'radioValue'], disabled: [3, 'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'howQuicklyImportType';
        var currVal_8 = 'Within 2 weeks';
        var currVal_9 = _co.howQuicklyImportTypeRef.Within2Weeks;
        var currVal_10 = _co.disableChanges;
        _ck(_v, 3, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'howQuicklyImportType';
        var currVal_12 = _co.disableChanges;
        var currVal_13 = _co.howQuicklyImportType;
        _ck(_v, 5, 0, currVal_11, currVal_12, currVal_13);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_LocationCardComponent_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'col-sm-3 col-xs-4']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.howQuicklyImportType = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0,
                'name'], label: [1, 'label'], radioValue: [2, 'radioValue'], disabled: [3, 'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'howQuicklyImportType';
        var currVal_8 = '3 weeks +';
        var currVal_9 = _co.howQuicklyImportTypeRef.Plus3Weeks;
        var currVal_10 = _co.disableChanges;
        _ck(_v, 3, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'howQuicklyImportType';
        var currVal_12 = _co.disableChanges;
        var currVal_13 = _co.howQuicklyImportType;
        _ck(_v, 5, 0, currVal_11, currVal_12, currVal_13);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_LocationCardComponent_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'col-sm-3 col-xs-4']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.howQuicklyImportType = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0,
                'name'], label: [1, 'label'], radioValue: [2, 'radioValue'], disabled: [3, 'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'howQuicklyImportType';
        var currVal_8 = 'Not sure';
        var currVal_9 = _co.howQuicklyImportTypeRef.NotSure;
        var currVal_10 = _co.disableChanges;
        _ck(_v, 3, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'howQuicklyImportType';
        var currVal_12 = _co.disableChanges;
        var currVal_13 = _co.howQuicklyImportType;
        _ck(_v, 5, 0, currVal_11, currVal_12, currVal_13);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_LocationCardComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, FirstKeyPipe, []), core_es5["ɵqud"](402653184, 1, { locationForm: 0 }),
        core_es5["ɵqud"](402653184, 2, { locationToModel: 0 }), core_es5["ɵqud"](402653184, 3, { locationFromModel: 0 }),
        core_es5["ɵqud"](402653184, 4, { locationFrom: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 148, 'form', [['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 7).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 7).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[1, 4], ['shipmentForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 141, 'div', [['class', 'card']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-header header card-header-text'],
                ['data-background-color', '#E07E3C']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'card-title calculator-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['SHIPMENT INFORMATION'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'tabs pull-right']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class',
                'simple-tab tab-pane']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setVehicle(true) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active-tab': 0, 'disabled': 1 }), (_l()(),
            core_es5["ɵted"](null, ['VEHICLES'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'simple-tab tab-pane second-tab']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setVehicle(false) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active-tab': 0,
            'disabled': 1 }), (_l()(), core_es5["ɵted"](null, ['PRODUCTS '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 119, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 53, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 17, 'location-form-input', [['required',
                    '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                    null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
                [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                    null]], [[null, 'ngModelChange'], [null,
                    'inputEmitter']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.locationFromString = $event) !== false);
                    ad = (pd_0 && ad);
                }
                if (('inputEmitter' === en)) {
                    var pd_1 = (_co.onLocationFromChange($event) !== false);
                    ad = (pd_1 && ad);
                }
                return ad;
            }, View_LocationFormInputComponent_0, RenderType_LocationFormInputComponent)),
        core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0,
                'required'] }, null), core_es5["ɵdid"](16384, null, 0, ShortLocationValidatorDirective, [], { location: [0, 'location'], validateState: [1, 'validateState'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], ShortLocationValidatorDirective]), core_es5["ɵdid"](4308992, [[3, 4], [4, 4], ['location', 4]], 0, locationFormInput_component_LocationFormInputComponent, [[2, forms_es5["NG_VALIDATORS"]],
            [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], disabled: [2,
                'disabled'], form: [3, 'form'], inputLocation: [4, 'inputLocation'] }, { inputEmitter: 'inputEmitter' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [locationFormInput_component_LocationFormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_LocationCardComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_LocationCardComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 28, 'div', [['class', 'col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'location-form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2,
                'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'inputEmitter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.locationToString = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('inputEmitter' === en)) {
                var pd_1 = (_co.onLocationToChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_LocationFormInputComponent_0, RenderType_LocationFormInputComponent)),
        core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0,
                'required'] }, null), core_es5["ɵdid"](16384, null, 0, ShortLocationValidatorDirective, [], { location: [0, 'location'], validateState: [1, 'validateState'] }, null), core_es5["ɵdid"](16384, null, 0, LocationCalcValidatorDirective, [], { locationTo: [0, 'locationTo'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0, p2_0) {
            return [p0_0, p1_0, p2_0];
        }, [forms_es5["RequiredValidator"], ShortLocationValidatorDirective, LocationCalcValidatorDirective]),
        core_es5["ɵdid"](4308992, [[2, 4], ['locationToModel', 4]], 0, locationFormInput_component_LocationFormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1,
                'label'], disabled: [2, 'disabled'], form: [3, 'form'], options: [4, 'options'],
            inputLocation: [5, 'inputLocation'] }, { inputEmitter: 'inputEmitter' }), core_es5["ɵpad"](2),
        core_es5["ɵpod"]({ country: 0 }), core_es5["ɵpod"]({ componentRestrictions: 0 }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [locationFormInput_component_LocationFormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_LocationCardComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_LocationCardComponent_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_LocationCardComponent_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 61, 'div', [['class',
                'form-horizontal']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 28, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class',
                'col-md-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class',
                'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Shipping Type'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationCardComponent_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationCardComponent_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationCardComponent_8)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationCardComponent_9)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 28, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-md-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['How quickly do you need to import your item?'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationCardComponent_10)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationCardComponent_11)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationCardComponent_12)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationCardComponent_13)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'simple-tab tab-pane';
        var currVal_8 = _ck(_v, 23, 0, _co.calculatorHelper.isVehicle(_co.order), ((_co.order.Status >= _co.orderStatus.Paid) || _co.disableChanges));
        _ck(_v, 22, 0, currVal_7, currVal_8);
        var currVal_9 = 'simple-tab tab-pane second-tab';
        var currVal_10 = _ck(_v, 28, 0, !_co.calculatorHelper.isVehicle(_co.order), ((_co.order.Status >= _co.orderStatus.Paid) || _co.disableChanges));
        _ck(_v, 27, 0, currVal_9, currVal_10);
        var currVal_19 = '';
        _ck(_v, 39, 0, currVal_19);
        var currVal_20 = _co.order.Customer.Location;
        var currVal_21 = false;
        _ck(_v, 40, 0, currVal_20, currVal_21);
        var currVal_22 = 'locationFrom';
        var currVal_23 = 'Shipment from';
        var currVal_24 = _co.disableChanges;
        var currVal_25 = core_es5["ɵnov"](_v, 7);
        var currVal_26 = _co.order.Customer.Location;
        _ck(_v, 42, 0, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26);
        var currVal_27 = 'locationFrom';
        var currVal_28 = _co.disableChanges;
        var currVal_29 = _co.locationFromString;
        _ck(_v, 44, 0, currVal_27, currVal_28, currVal_29);
        var currVal_30 = ((core_es5["ɵunv"](_v, 49, 0, _ck(_v, 50, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 42).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 42).model.pristine || core_es5["ɵnov"](_v, 7).submitted));
        _ck(_v, 49, 0, currVal_30);
        var currVal_31 = ((core_es5["ɵunv"](_v, 53, 0, _ck(_v, 54, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 42).model.errors)) == 'validateLocationShort') && (!core_es5["ɵnov"](_v, 42).model.pristine || core_es5["ɵnov"](_v, 7).submitted));
        _ck(_v, 53, 0, currVal_31);
        var currVal_40 = '';
        _ck(_v, 61, 0, currVal_40);
        var currVal_41 = _co.locationTo;
        var currVal_42 = true;
        _ck(_v, 62, 0, currVal_41, currVal_42);
        var currVal_43 = _co.locationTo;
        _ck(_v, 63, 0, currVal_43);
        var currVal_44 = 'locationTo';
        var currVal_45 = 'Shipment To';
        var currVal_46 = _co.disableChanges;
        var currVal_47 = core_es5["ɵnov"](_v, 7);
        var currVal_48 = _ck(_v, 68, 0, _ck(_v, 67, 0, _ck(_v, 66, 0, 'CA', 'US')));
        var currVal_49 = _co.locationTo;
        _ck(_v, 65, 0, currVal_44, currVal_45, currVal_46, currVal_47, currVal_48, currVal_49);
        var currVal_50 = 'locationTo';
        var currVal_51 = _co.disableChanges;
        var currVal_52 = _co.locationToString;
        _ck(_v, 70, 0, currVal_50, currVal_51, currVal_52);
        var currVal_53 = ((core_es5["ɵunv"](_v, 75, 0, _ck(_v, 76, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 65).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 65).model.pristine || core_es5["ɵnov"](_v, 7).submitted));
        _ck(_v, 75, 0, currVal_53);
        var currVal_54 = ((core_es5["ɵunv"](_v, 79, 0, _ck(_v, 80, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 65).model.errors)) == 'validateCalcLocation') && (!core_es5["ɵnov"](_v, 65).model.pristine || core_es5["ɵnov"](_v, 7).submitted));
        _ck(_v, 79, 0, currVal_54);
        var currVal_55 = ((core_es5["ɵunv"](_v, 83, 0, _ck(_v, 84, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 65).model.errors)) == 'validateLocationShort') && (!core_es5["ɵnov"](_v, 65).model.pristine || core_es5["ɵnov"](_v, 7).submitted));
        _ck(_v, 83, 0, currVal_55);
        var currVal_56 = _co.showShippingTrackOption;
        _ck(_v, 107, 0, currVal_56);
        var currVal_57 = _co.showShippingAirOption;
        _ck(_v, 110, 0, currVal_57);
        var currVal_58 = _co.showShippingOceanOption;
        _ck(_v, 113, 0, currVal_58);
        var currVal_59 = (_co.order.CarryingType == 1);
        _ck(_v, 118, 0, currVal_59);
        var currVal_60 = _co.showShippingTrackOption;
        _ck(_v, 137, 0, currVal_60);
        var currVal_61 = _co.showShippingTrackOption;
        _ck(_v, 140, 0, currVal_61);
        var currVal_62 = _co.showShippingTrackOption;
        _ck(_v, 143, 0, currVal_62);
        var currVal_63 = _co.showShippingTrackOption;
        _ck(_v, 146, 0, currVal_63);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 9).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 9).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 9).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 9).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 9).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 9).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 9).ngClassPending;
        _ck(_v, 5, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_11 = (core_es5["ɵnov"](_v, 39).required ? '' : null);
        var currVal_12 = core_es5["ɵnov"](_v, 46).ngClassUntouched;
        var currVal_13 = core_es5["ɵnov"](_v, 46).ngClassTouched;
        var currVal_14 = core_es5["ɵnov"](_v, 46).ngClassPristine;
        var currVal_15 = core_es5["ɵnov"](_v, 46).ngClassDirty;
        var currVal_16 = core_es5["ɵnov"](_v, 46).ngClassValid;
        var currVal_17 = core_es5["ɵnov"](_v, 46).ngClassInvalid;
        var currVal_18 = core_es5["ɵnov"](_v, 46).ngClassPending;
        _ck(_v, 38, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18);
        var currVal_32 = (core_es5["ɵnov"](_v, 61).required ? '' : null);
        var currVal_33 = core_es5["ɵnov"](_v, 72).ngClassUntouched;
        var currVal_34 = core_es5["ɵnov"](_v, 72).ngClassTouched;
        var currVal_35 = core_es5["ɵnov"](_v, 72).ngClassPristine;
        var currVal_36 = core_es5["ɵnov"](_v, 72).ngClassDirty;
        var currVal_37 = core_es5["ɵnov"](_v, 72).ngClassValid;
        var currVal_38 = core_es5["ɵnov"](_v, 72).ngClassInvalid;
        var currVal_39 = core_es5["ɵnov"](_v, 72).ngClassPending;
        _ck(_v, 60, 0, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39);
    });
}
function View_LocationCardComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'location-card', [], null, null, null, View_LocationCardComponent_0, RenderType_LocationCardComponent)), core_es5["ɵdid"](114688, null, 0, location_card_component_LocationCardComponent, [calculator_calculatorService["a" /* CalculatorService */], core_es5["ChangeDetectorRef"], CountryService_CountryService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var LocationCardComponentNgFactory = core_es5["ɵccf"]('location-card', location_card_component_LocationCardComponent, View_LocationCardComponent_Host_0, { order: 'order', productsCard: 'productsCard',
    canadianCurrencyCodes: 'canadianCurrencyCodes', disableChanges: 'disableChanges' }, { vehicleChange: 'vehicleChange' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=location-card.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/common/directives/validators/productNameValidator.ts
/**
 * Created by alex.y on 11/27/2017.
 */
var ProductValidatorValidatorDirective = /** @class */ (function () {
    function ProductValidatorValidatorDirective() {
    }
    ProductValidatorValidatorDirective.prototype.validate = function (control) {
        if (!control.value)
            return null;
        var name = control.value.trim();
        var hsCodeSplitted = name.split(/\d+\.[\d+.*]+/i);
        var matches = name.match(/\d+\.[\d+.*]+/ig);
        var wordCounter = matches ? matches.length : 0;
        var splitted = hsCodeSplitted.join(" ").split(/[.|\\|/|,|;|:|||!|?|&|\s]/);
        for (var _i = 0, splitted_1 = splitted; _i < splitted_1.length; _i++) {
            var it = splitted_1[_i];
            if (!String.isNullOrEmpty(it) && it.match(/^[@#$%^&*()_+\-=\[\]{}'"|<>]+$/) == null)
                wordCounter++;
        }
        if (wordCounter <= 1)
            return { validateProductName: false };
        return null;
    };
    ProductValidatorValidatorDirective.ctorParameters = function () { return []; };
    return ProductValidatorValidatorDirective;
}());

//# sourceMappingURL=productNameValidator.js.map
// EXTERNAL MODULE: ./node_modules/rxjs/add/operator/distinctUntilChanged.js
var distinctUntilChanged = __webpack_require__("q3ik");
var distinctUntilChanged_default = /*#__PURE__*/__webpack_require__.n(distinctUntilChanged);

// CONCATENATED MODULE: ./app/components/common/debounce/debounceDirective.ts



var debounceDirective_DebounceDirective = /** @class */ (function () {
    function DebounceDirective(model) {
        this.model = model;
        this.onDebounce = new core_es5["EventEmitter"]();
        this.debounceTime = 500;
        this.isFirstChange = true;
    }
    DebounceDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.model.valueChanges
            .debounceTime(this.debounceTime)
            .distinctUntilChanged()
            .subscribe(function (modelValue) {
            if (_this.isFirstChange) {
                _this.isFirstChange = false;
            }
            else {
                _this.onDebounce.emit(modelValue);
            }
        });
    };
    DebounceDirective.ctorParameters = function () { return [{ type: forms_es5["NgControl"] }]; };
    return DebounceDirective;
}());

//# sourceMappingURL=debounceDirective.js.map
// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/utils/ng2-bootstrap-config.js
var ng2_bootstrap_config = __webpack_require__("kWlY");

// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/accordion/accordion.config.js

/**
 * Configuration service, provides default values for the AccordionComponent.
 */
var accordion_config_AccordionConfig = (function () {
    function AccordionConfig() {
        /** Whether the other panels should be closed when a panel is opened */
        this.closeOthers = false;
    }
    AccordionConfig.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    AccordionConfig.ctorParameters = function () { return []; };
    return AccordionConfig;
}());

//# sourceMappingURL=accordion.config.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/accordion/accordion.component.js


/** Displays collapsible content panels for presenting information in a limited amount of space. */
var accordion_component_AccordionComponent = (function () {
    function AccordionComponent(config) {
        this.groups = [];
        Object.assign(this, config);
    }
    AccordionComponent.prototype.closeOtherPanels = function (openGroup) {
        if (!this.closeOthers) {
            return;
        }
        this.groups.forEach(function (group) {
            if (group !== openGroup) {
                group.isOpen = false;
            }
        });
    };
    AccordionComponent.prototype.addGroup = function (group) {
        this.groups.push(group);
    };
    AccordionComponent.prototype.removeGroup = function (group) {
        var index = this.groups.indexOf(group);
        if (index !== -1) {
            this.groups.splice(index, 1);
        }
    };
    AccordionComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'accordion',
                    template: "<ng-content></ng-content>",
                    // tslint:disable-next-line
                    host: {
                        //'[.class.panel-group]': 'true',
                        '[attr.aria-multiselectable]': 'closeOthers',
                        role: 'tablist',
                        class: 'panel-group',
                        style: 'display: block'
                    }
                },] },
    ];
    /** @nocollapse */
    AccordionComponent.ctorParameters = function () { return [
        { type: accordion_config_AccordionConfig, },
    ]; };
    AccordionComponent.propDecorators = {
        'closeOthers': [{ type: core_es5["Input"] },],
    };
    return AccordionComponent;
}());

//# sourceMappingURL=accordion.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/accordion/accordion-group.component.js



/*
 * ### Accordion heading

 Instead of using `heading` attribute on the `accordion-group`, you can use an `accordion-heading` attribute on `any` element inside of a group that will be used as group's header template.

 * */
var accordion_group_component_AccordionPanelComponent = (function () {
    function AccordionPanelComponent(accordion) {
        this.accordion = accordion;
    }
    Object.defineProperty(AccordionPanelComponent.prototype, "isOpen", {
        // Questionable, maybe .panel-open should be on child div.panel element?
        /** Is accordion group open or closed */
        get: function () {
            return this._isOpen;
        },
        set: function (value) {
            this._isOpen = value;
            if (value) {
                this.accordion.closeOtherPanels(this);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AccordionPanelComponent.prototype, "isBs3", {
        get: function () {
            return Object(ng2_bootstrap_config["a" /* isBs3 */])();
        },
        enumerable: true,
        configurable: true
    });
    AccordionPanelComponent.prototype.ngOnInit = function () {
        this.panelClass = this.panelClass || 'panel-default';
        this.accordion.addGroup(this);
    };
    AccordionPanelComponent.prototype.ngOnDestroy = function () {
        this.accordion.removeGroup(this);
    };
    AccordionPanelComponent.prototype.toggleOpen = function (event) {
        if (!this.isDisabled) {
            this.isOpen = !this.isOpen;
        }
    };
    AccordionPanelComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'accordion-group, accordion-panel',
                    template: "\n    <div class=\"panel card\" [ngClass]=\"panelClass\">\n      <div class=\"panel-heading card-header\" role=\"tab\" (click)=\"toggleOpen($event)\">\n        <div class=\"panel-title\">\n          <div role=\"button\" class=\"accordion-toggle\" [attr.aria-expanded]=\"isOpen\">\n            <div *ngIf=\"heading\"[ngClass]=\"{'text-muted': isDisabled}\">{{heading}}</div>\n            <ng-content select=\"[accordion-heading]\"></ng-content>\n          </div>\n        </div>\n      </div>\n      <div class=\"panel-collapse collapse\" role=\"tabpanel\" [collapse]=\"!isOpen\">\n        <div class=\"panel-body card-block card-body\">\n          <ng-content></ng-content>\n        </div>\n      </div>\n    </div>\n  ",
                    host: {
                        class: 'panel',
                        style: 'display: block'
                    }
                },] },
    ];
    /** @nocollapse */
    AccordionPanelComponent.ctorParameters = function () { return [
        { type: accordion_component_AccordionComponent, decorators: [{ type: core_es5["Inject"], args: [accordion_component_AccordionComponent,] },] },
    ]; };
    AccordionPanelComponent.propDecorators = {
        'heading': [{ type: core_es5["Input"] },],
        'panelClass': [{ type: core_es5["Input"] },],
        'isDisabled': [{ type: core_es5["Input"] },],
        'isOpen': [{ type: core_es5["HostBinding"], args: ['class.panel-open',] }, { type: core_es5["Input"] },],
    };
    return AccordionPanelComponent;
}());

//# sourceMappingURL=accordion-group.component.js.map
// CONCATENATED MODULE: ./compiled/node_modules/ngx-bootstrap/accordion/accordion-group.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_AccordionPanelComponent = [];
var RenderType_AccordionPanelComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AccordionPanelComponent, data: {} });
function View_AccordionPanelComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'text-muted': 0 }),
        (_l()(), core_es5["ɵted"](null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, _co.isDisabled);
        _ck(_v, 1, 0, currVal_0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.heading;
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_AccordionPanelComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, ['\n    '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'panel card']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'panel-heading card-header'], ['role', 'tab']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.toggleOpen($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['\n        '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'panel-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['\n          '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'accordion-toggle'], ['role', 'button']], [[1,
                'aria-expanded', 0]], null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['\n            '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AccordionPanelComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n            '])),
        core_es5["ɵncd"](null, 0), (_l()(), core_es5["ɵted"](null, ['\n          '])), (_l()(),
            core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵted"](null, ['\n      '])),
        (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'panel-collapse collapse'], ['role', 'tabpanel']], [[2, 'collapse', null], [4, 'display', null], [2, 'in', null],
            [2, 'show', null], [1, 'aria-expanded', 0], [1, 'aria-hidden', 0], [2,
                'collapsing', null]], null, null, null, null)), core_es5["ɵdid"](16384, null, 0, collapse_directive["a" /* CollapseDirective */], [core_es5["ElementRef"],
            core_es5["Renderer"]], { collapse: [0, 'collapse'] }, null), (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class',
                'panel-body card-block card-body']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n          '])),
        core_es5["ɵncd"](null, 1), (_l()(), core_es5["ɵted"](null, ['\n        '])), (_l()(),
            core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵted"](null, ['\n    '])),
        (_l()(), core_es5["ɵted"](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'panel card';
        var currVal_1 = _co.panelClass;
        _ck(_v, 2, 0, currVal_0, currVal_1);
        var currVal_3 = _co.heading;
        _ck(_v, 11, 0, currVal_3);
        var currVal_11 = !_co.isOpen;
        _ck(_v, 19, 0, currVal_11);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.isOpen;
        _ck(_v, 8, 0, currVal_2);
        var currVal_4 = core_es5["ɵnov"](_v, 19).isCollapse;
        var currVal_5 = core_es5["ɵnov"](_v, 19).display;
        var currVal_6 = core_es5["ɵnov"](_v, 19).isExpanded;
        var currVal_7 = core_es5["ɵnov"](_v, 19).isExpanded;
        var currVal_8 = core_es5["ɵnov"](_v, 19).isExpanded;
        var currVal_9 = core_es5["ɵnov"](_v, 19).isCollapsed;
        var currVal_10 = core_es5["ɵnov"](_v, 19).isCollapsing;
        _ck(_v, 18, 0, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10);
    });
}
function View_AccordionPanelComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'accordion-group', [['class', 'panel'], ['style', 'display: block']], [[2, 'panel-open', null]], null, null, View_AccordionPanelComponent_0, RenderType_AccordionPanelComponent)),
        core_es5["ɵdid"](245760, null, 0, accordion_group_component_AccordionPanelComponent, [accordion_component_AccordionComponent], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).isOpen;
        _ck(_v, 0, 0, currVal_0);
    });
}
var AccordionPanelComponentNgFactory = core_es5["ɵccf"]('accordion-group, accordion-panel', accordion_group_component_AccordionPanelComponent, View_AccordionPanelComponent_Host_0, { heading: 'heading',
    panelClass: 'panelClass', isDisabled: 'isDisabled', isOpen: 'isOpen' }, {}, ['[accordion-heading]',
    '*']);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=accordion-group.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/components/calculator/accordions/product-accordion/calculator-accordion.component.ts
var calculator_accordion_component = __webpack_require__("mZEr");

// EXTERNAL MODULE: ./app/services/calculator/tax.service.ts
var tax_service = __webpack_require__("/9l6");

// CONCATENATED MODULE: ./compiled/app/components/calculator/accordions/product-accordion/calculator-accordion.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





















var styles_CalculatorAccordion = [];
var RenderType_CalculatorAccordion = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CalculatorAccordion, data: {} });
function View_CalculatorAccordion_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'index']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (((_co.isVehicle ? 'Vehicle' : 'Product') + ' #') + _co.index);
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalculatorAccordion_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class',
                'material-icons brand']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = (((core_es5["ɵnov"](_v.parent.parent, 14) == null) ? null : core_es5["ɵnov"](_v.parent.parent, 14).isOpen) ? 'expand_less' : 'expand_more');
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalculatorAccordion_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, 'span', [['class',
                'btn btn-white btn-round btn-just-icon btn-round-mini pull-right']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.deleteItem() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'disabled': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['close'])),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'btn btn-white btn-round btn-just-icon btn-round-mini pull-right';
        var currVal_1 = _ck(_v, 2, 0, _co.disableChanges);
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_CalculatorAccordion_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-2 col-sm-1']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'short-description']], [[8, 'title', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ',
            ' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, '', _co.orderItem.Year, '');
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = _co.orderItem.Year;
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_CalculatorAccordion_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'div', [['class',
                'col-xs-4 col-sm-2 text-center short-description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ',
            ' '])), core_es5["ɵppd"](2)], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent.parent.parent.parent, 0), _co.orderItem.Price, '.2-2'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalculatorAccordion_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'col-xs-4 col-sm-2 text-center short-description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ',
            ' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.orderItem.Price;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalculatorAccordion_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 30, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'padding-left-15']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'col-xs-3 col-sm-2': 0,
            'col-xs-5 col-sm-3': 1 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'short-description']], [[8,
                'title', 0]], null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_7)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-3 mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'short-description text-italic-gray']], [[8, 'title', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-xs-2 text-center short-description mobile-hide']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-xs-2 col-sm-2 text-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_8)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_9)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'padding-left-15';
        var currVal_1 = _ck(_v, 4, 0, (_co.orderItem.Year && _co.calculatorHelper.isVehicle(_co.order)), (!_co.orderItem.Year || !_co.calculatorHelper.isVehicle(_co.order)));
        _ck(_v, 3, 0, currVal_0, currVal_1);
        var currVal_4 = (_co.orderItem.Year && _co.calculatorHelper.isVehicle(_co.order));
        _ck(_v, 11, 0, currVal_4);
        var currVal_9 = (_co.orderItem.Price && _co.isNumber(_co.orderItem.Price));
        _ck(_v, 26, 0, currVal_9);
        var currVal_10 = (_co.orderItem.Price && !_co.isNumber(_co.orderItem.Price));
        _ck(_v, 29, 0, currVal_10);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = core_es5["ɵinlineInterpolate"](1, '', ((_co.orderItem.Product == null) ? null : _co.orderItem.Product.Name), '');
        _ck(_v, 6, 0, currVal_2);
        var currVal_3 = ((_co.orderItem.Product == null) ? null : _co.orderItem.Product.Name);
        _ck(_v, 7, 0, currVal_3);
        var currVal_5 = core_es5["ɵinlineInterpolate"](1, '', ((_co.orderItem.Product == null) ? null : _co.orderItem.Product.Description), '');
        _ck(_v, 15, 0, currVal_5);
        var currVal_6 = ((_co.orderItem.Product == null) ? null : _co.orderItem.Product.Description);
        _ck(_v, 16, 0, currVal_6);
        var currVal_7 = ((_co.orderItem.Product == null) ? null : _co.orderItem.Product.HsCode);
        _ck(_v, 20, 0, currVal_7);
        var currVal_8 = ((_co.orderItem.CanadianCurrencyCode == null) ? null : _co.orderItem.CanadianCurrencyCode.Name);
        _ck(_v, 23, 0, currVal_8);
    });
}
function View_CalculatorAccordion_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class',
                'row order-info']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-1 pull-right brand']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_0 = !((core_es5["ɵnov"](_v.parent.parent, 14) == null) ? null : core_es5["ɵnov"](_v.parent.parent, 14).isOpen);
        _ck(_v, 3, 0, currVal_0);
    }, function (_ck, _v) {
        var currVal_1 = (((core_es5["ɵnov"](_v.parent.parent, 14) == null) ? null : core_es5["ɵnov"](_v.parent.parent, 14).isOpen) ? 'expand_less' : 'expand_more');
        _ck(_v, 8, 0, currVal_1);
    });
}
function View_CalculatorAccordion_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class',
                'row product']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 16, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-10']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'col-xs-2 btn-close']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.calculatorHelper.isQuickQuote(_co.order);
        _ck(_v, 9, 0, currVal_0);
        var currVal_1 = ((core_es5["ɵnov"](_v.parent, 14) == null) ? null : core_es5["ɵnov"](_v.parent, 14).isOpen);
        _ck(_v, 15, 0, currVal_1);
        var currVal_2 = (!((core_es5["ɵnov"](_v.parent, 14) == null) ? null : core_es5["ɵnov"](_v.parent, 14).isOpen) && !_co.isQuickQuote);
        _ck(_v, 18, 0, currVal_2);
        var currVal_3 = !((core_es5["ɵnov"](_v.parent, 14) == null) ? null : core_es5["ɵnov"](_v.parent, 14).isOpen);
        _ck(_v, 23, 0, currVal_3);
    }, null);
}
function View_CalculatorAccordion_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Year is required. ']))], null, null);
}
function View_CalculatorAccordion_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 28, 'div', [['class',
                'col-sm-2']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'form-group label-floating']], [[1, 'id', 0]], null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Year'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'select', [['class', 'form-control select2'], ['name', 'yearSelect'], ['required',
                '']], [[1, 'id', 0], [1, 'required', 0], [2, 'ng-untouched', null], [2,
                'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 10).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 10).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.orderItem.Year = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, [['yearSelect', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'option', [], null, null, null, null, null)), core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"],
            core_es5["Renderer2"], [2, forms_es5["SelectControlValueAccessor"]]], null, null),
        core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'material-input']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_11)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'form-group label-floating';
        var currVal_2 = _ck(_v, 4, 0, (core_es5["ɵnov"](_v, 14).invalid && (!core_es5["ɵnov"](_v, 14).pristine || core_es5["ɵnov"](_v.parent, 9).submitted)));
        _ck(_v, 3, 0, currVal_1, currVal_2);
        var currVal_12 = '';
        _ck(_v, 11, 0, currVal_12);
        var currVal_13 = 'yearSelect';
        var currVal_14 = _co.disableChanges;
        var currVal_15 = _co.orderItem.Year;
        _ck(_v, 14, 0, currVal_13, currVal_14, currVal_15);
        var currVal_16 = (core_es5["ɵnov"](_v, 14).invalid && (!core_es5["ɵnov"](_v, 14).pristine || core_es5["ɵnov"](_v.parent, 9).submitted));
        _ck(_v, 26, 0, currVal_16);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.select2ProductId + '_yearSelectDiv');
        _ck(_v, 2, 0, currVal_0);
        var currVal_3 = (_co.select2ProductId + '_year');
        var currVal_4 = (core_es5["ɵnov"](_v, 11).required ? '' : null);
        var currVal_5 = core_es5["ɵnov"](_v, 16).ngClassUntouched;
        var currVal_6 = core_es5["ɵnov"](_v, 16).ngClassTouched;
        var currVal_7 = core_es5["ɵnov"](_v, 16).ngClassPristine;
        var currVal_8 = core_es5["ɵnov"](_v, 16).ngClassDirty;
        var currVal_9 = core_es5["ɵnov"](_v, 16).ngClassValid;
        var currVal_10 = core_es5["ɵnov"](_v, 16).ngClassInvalid;
        var currVal_11 = core_es5["ɵnov"](_v, 16).ngClassPending;
        _ck(_v, 9, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11);
    });
}
function View_CalculatorAccordion_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Price is required. ']))], null, null);
}
function View_CalculatorAccordion_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Price should contain only digits. ']))], null, null);
}
function View_CalculatorAccordion_15(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'option', [], null, null, null, null, null)), core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"], core_es5["Renderer2"], [2, forms_es5["SelectControlValueAccessor"]]], { value: [0, 'value'] }, null), core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"],
            core_es5["Renderer2"], [8, null]], { value: [0, 'value'] }, null), (_l()(), core_es5["ɵted"](null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.Code;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.Code;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.Name;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_CalculatorAccordion_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 23, 'div', [['class',
                'form-group label-floating']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' Currency '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 15, 'select', [['class', 'form-control select2'],
            ['name', 'productCurrency'], ['required', '']], [[1, 'id', 0], [1, 'required', 0],
            [2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 8).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 8).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.orderItem.CanadianCurrencyCode.Code = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, [['currencySelect', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'option', [], null, null, null, null, null)), core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"],
            core_es5["Renderer2"], [2, forms_es5["SelectControlValueAccessor"]]], null, null),
        core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_15)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'form-group label-floating';
        var currVal_1 = _ck(_v, 2, 0, (core_es5["ɵnov"](_v.parent, 9) && (core_es5["ɵnov"](_v, 12).invalid && (!core_es5["ɵnov"](_v, 12).pristine || core_es5["ɵnov"](_v.parent, 9).submitted))));
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_11 = '';
        _ck(_v, 9, 0, currVal_11);
        var currVal_12 = 'productCurrency';
        var currVal_13 = _co.disableChanges;
        var currVal_14 = _co.orderItem.CanadianCurrencyCode.Code;
        _ck(_v, 12, 0, currVal_12, currVal_13, currVal_14);
        var currVal_15 = _co.canadianCurrencyCodes;
        _ck(_v, 21, 0, currVal_15);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.select2CurrencyId;
        var currVal_3 = (core_es5["ɵnov"](_v, 9).required ? '' : null);
        var currVal_4 = core_es5["ɵnov"](_v, 14).ngClassUntouched;
        var currVal_5 = core_es5["ɵnov"](_v, 14).ngClassTouched;
        var currVal_6 = core_es5["ɵnov"](_v, 14).ngClassPristine;
        var currVal_7 = core_es5["ɵnov"](_v, 14).ngClassDirty;
        var currVal_8 = core_es5["ɵnov"](_v, 14).ngClassValid;
        var currVal_9 = core_es5["ɵnov"](_v, 14).ngClassInvalid;
        var currVal_10 = core_es5["ɵnov"](_v, 14).ngClassPending;
        _ck(_v, 7, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10);
    });
}
function View_CalculatorAccordion_17(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Product is required. ']))], null, null);
}
function View_CalculatorAccordion_18(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Product Name should contain at least 2 words. ']))], null, null);
}
function View_CalculatorAccordion_19(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Tariff should be selected. ']))], null, null);
}
function View_CalculatorAccordion_20(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Product is required. ']))], null, null);
}
function View_CalculatorAccordion_22(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Year is required. ']))], null, null);
}
function View_CalculatorAccordion_21(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 28, 'div', [['class',
                'col-sm-2 col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'form-group label-floating']], [[1, 'id', 0]], null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Year'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'select', [['class', 'form-control select2'], ['name', 'yearSelect'], ['required',
                '']], [[1, 'id', 0], [1, 'required', 0], [2, 'ng-untouched', null], [2,
                'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 10).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 10).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.orderItem.Year = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, [['yearSelect', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'option', [], null, null, null, null, null)), core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"],
            core_es5["Renderer2"], [2, forms_es5["SelectControlValueAccessor"]]], null, null),
        core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'material-input']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_22)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'form-group label-floating';
        var currVal_2 = _ck(_v, 4, 0, (core_es5["ɵnov"](_v, 14).invalid && (!core_es5["ɵnov"](_v, 14).pristine || core_es5["ɵnov"](_v.parent.parent, 9).submitted)));
        _ck(_v, 3, 0, currVal_1, currVal_2);
        var currVal_12 = '';
        _ck(_v, 11, 0, currVal_12);
        var currVal_13 = 'yearSelect';
        var currVal_14 = _co.disableChanges;
        var currVal_15 = _co.orderItem.Year;
        _ck(_v, 14, 0, currVal_13, currVal_14, currVal_15);
        var currVal_16 = (core_es5["ɵnov"](_v, 14).invalid && (!core_es5["ɵnov"](_v, 14).pristine || core_es5["ɵnov"](_v.parent.parent, 9).submitted));
        _ck(_v, 26, 0, currVal_16);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.select2ProductId + '_yearSelectDiv');
        _ck(_v, 2, 0, currVal_0);
        var currVal_3 = (_co.select2ProductId + '_year');
        var currVal_4 = (core_es5["ɵnov"](_v, 11).required ? '' : null);
        var currVal_5 = core_es5["ɵnov"](_v, 16).ngClassUntouched;
        var currVal_6 = core_es5["ɵnov"](_v, 16).ngClassTouched;
        var currVal_7 = core_es5["ɵnov"](_v, 16).ngClassPristine;
        var currVal_8 = core_es5["ɵnov"](_v, 16).ngClassDirty;
        var currVal_9 = core_es5["ɵnov"](_v, 16).ngClassValid;
        var currVal_10 = core_es5["ɵnov"](_v, 16).ngClassInvalid;
        var currVal_11 = core_es5["ɵnov"](_v, 16).ngClassPending;
        _ck(_v, 9, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11);
    });
}
function View_CalculatorAccordion_23(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' HsCode is invalid. ']))], null, null);
}
function View_CalculatorAccordion_24(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' HsCode is required. ']))], null, null);
}
function View_CalculatorAccordion_27(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'col-md-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Product is not found in the ', ' Database. Please select correct product. ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ((_co.getSearchType() == 0) ? '"Canadian"' : ((_co.getSearchType() == 1) ? '"American"' : 'Both'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalculatorAccordion_28(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'col-md-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Product description from tariff DB: ', ' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.orderItem.Product.Description;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalculatorAccordion_30(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Tariff value: ',
            ' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_CalculatorAccordion_29(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_30)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.calculatorHelper.getTariff(_co.orderItem, _co.order, (_co.order.Flag && _co.order.Flag.hasFlag(_co.OrderOptions.IsVehicle)), _co.taxService.canadianHsCodesAlAndSteel10, _co.taxService.canadianHsCodesAlAndSteel25, _co.taxService.canadianHsCodesChina0, _co.taxService.usaHsCodesChina25);
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_CalculatorAccordion_26(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 16, 'div', [['class',
                'card tariff']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class', 'card-content text-left']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_27)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_28)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_29)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (!_co.orderItem.Product.Description && _co.manualHsCode);
        _ck(_v, 7, 0, currVal_0);
        var currVal_1 = ((_co.orderItem.Product.Name || !_co.isProductNameHidden) && _co.orderItem.Product.Description);
        _ck(_v, 10, 0, currVal_1);
        var currVal_2 = ((_co.orderItem.Product.Name || !_co.isProductNameHidden) && _co.orderItem.Product.Description);
        _ck(_v, 14, 0, currVal_2);
    }, null);
}
function View_CalculatorAccordion_25(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class',
                'col-xs-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_26)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'spinner-container']], [[8, 'hidden', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'spinner']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.isTarifLoading;
        _ck(_v, 3, 0, currVal_0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = !_co.isTarifLoading;
        _ck(_v, 5, 0, currVal_1);
    });
}
function View_CalculatorAccordion_34(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block short-description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' is required. ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getDutyLabel(_v.parent.parent.context.$implicit);
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalculatorAccordion_35(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block short-description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' should contain only digits. ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getDutyLabel(_v.parent.parent.context.$implicit);
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalculatorAccordion_33(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 17, 'form-input', [['pattern', '^[0-9]+([,.][0-9]{1,2})?$'], ['required', ''], ['type', 'number']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.parent.context.$implicit.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['customDuty',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4,
                'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CalculatorAccordion_34)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CalculatorAccordion_35)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_9 = '';
        _ck(_v, 1, 0, currVal_9);
        var currVal_10 = '^[0-9]+([,.][0-9]{1,2})?$';
        _ck(_v, 2, 0, currVal_10);
        var currVal_11 = 'number';
        var currVal_12 = core_es5["ɵinlineInterpolate"](1, '', ('duty' + _v.parent.context.index.toString()), '');
        var currVal_13 = core_es5["ɵinlineInterpolate"](1, '', _co.getDutyLabel(_v.parent.context.$implicit), '');
        var currVal_14 = _co.disableChanges;
        var currVal_15 = core_es5["ɵnov"](_v.parent.parent.parent.parent, 9);
        var currVal_16 = ('Type ' + _co.getDutyLabel(_v.parent.context.$implicit));
        var currVal_17 = true;
        _ck(_v, 4, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17);
        var currVal_18 = core_es5["ɵinlineInterpolate"](1, '', ('duty' + _v.parent.context.index.toString()), '');
        var currVal_19 = _co.disableChanges;
        var currVal_20 = _v.parent.context.$implicit.Value;
        _ck(_v, 6, 0, currVal_18, currVal_19, currVal_20);
        var currVal_21 = ((core_es5["ɵunv"](_v, 11, 0, _ck(_v, 12, 0, core_es5["ɵnov"](_v.parent.parent.parent.parent, 1), core_es5["ɵnov"](_v, 4).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 4).model.pristine || core_es5["ɵnov"](_v.parent.parent.parent.parent, 9).submitted));
        _ck(_v, 11, 0, currVal_21);
        var currVal_22 = ((core_es5["ɵunv"](_v, 15, 0, _ck(_v, 16, 0, core_es5["ɵnov"](_v.parent.parent.parent.parent, 1), core_es5["ɵnov"](_v, 4).model.errors)) == 'pattern') && (!core_es5["ɵnov"](_v, 4).model.pristine || core_es5["ɵnov"](_v.parent.parent.parent.parent, 9).submitted));
        _ck(_v, 15, 0, currVal_22);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 1).required ? '' : null);
        var currVal_1 = (core_es5["ɵnov"](_v, 2).pattern ? core_es5["ɵnov"](_v, 2).pattern : null);
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    });
}
function View_CalculatorAccordion_37(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block short-description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' is required. ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getDutyLabel(_v.parent.parent.context.$implicit);
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalculatorAccordion_38(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block short-description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' should contain only digits. ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getDutyLabel(_v.parent.parent.context.$implicit);
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalculatorAccordion_36(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 17, 'form-input', [['pattern', '^[0-9]+([,.][0-9]{1,2})?$'], ['required', ''], ['type', 'number']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.parent.context.$implicit.Quantity = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['dutyModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4,
                'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CalculatorAccordion_37)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CalculatorAccordion_38)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_9 = '';
        _ck(_v, 1, 0, currVal_9);
        var currVal_10 = '^[0-9]+([,.][0-9]{1,2})?$';
        _ck(_v, 2, 0, currVal_10);
        var currVal_11 = 'number';
        var currVal_12 = core_es5["ɵinlineInterpolate"](1, '', ('duty' + _v.parent.context.index.toString()), '');
        var currVal_13 = core_es5["ɵinlineInterpolate"](1, '', _co.getDutyLabel(_v.parent.context.$implicit), '');
        var currVal_14 = _co.disableChanges;
        var currVal_15 = core_es5["ɵnov"](_v.parent.parent.parent.parent, 9);
        var currVal_16 = ('Type ' + _co.getDutyLabel(_v.parent.context.$implicit));
        var currVal_17 = true;
        _ck(_v, 4, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17);
        var currVal_18 = core_es5["ɵinlineInterpolate"](1, '', ('duty' + _v.parent.context.index.toString()), '');
        var currVal_19 = _co.disableChanges;
        var currVal_20 = _v.parent.context.$implicit.Quantity;
        _ck(_v, 6, 0, currVal_18, currVal_19, currVal_20);
        var currVal_21 = ((core_es5["ɵunv"](_v, 11, 0, _ck(_v, 12, 0, core_es5["ɵnov"](_v.parent.parent.parent.parent, 1), core_es5["ɵnov"](_v, 4).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 4).model.pristine || core_es5["ɵnov"](_v.parent.parent.parent.parent, 9).submitted));
        _ck(_v, 11, 0, currVal_21);
        var currVal_22 = ((core_es5["ɵunv"](_v, 15, 0, _ck(_v, 16, 0, core_es5["ɵnov"](_v.parent.parent.parent.parent, 1), core_es5["ɵnov"](_v, 4).model.errors)) == 'pattern') && (!core_es5["ɵnov"](_v, 4).model.pristine || core_es5["ɵnov"](_v.parent.parent.parent.parent, 9).submitted));
        _ck(_v, 15, 0, currVal_22);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 1).required ? '' : null);
        var currVal_1 = (core_es5["ɵnov"](_v, 2).pattern ? core_es5["ɵnov"](_v, 2).pattern : null);
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    });
}
function View_CalculatorAccordion_32(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'col-sm-6 col-xs-12 margin-top-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_33)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_36)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_v.context.$implicit.DutyType == _co.dutyType.Manual);
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = (_v.context.$implicit.DutyType != _co.dutyType.Manual);
        _ck(_v, 6, 0, currVal_1);
    }, null);
}
function View_CalculatorAccordion_31(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_32)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.filterDuties(_co.orderItem.DutyList);
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_CalculatorAccordion_42(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' is required. ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getDutyLabel(_v.parent.parent.context.$implicit);
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalculatorAccordion_43(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' should contain only digits. ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getDutyLabel(_v.parent.parent.context.$implicit);
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalculatorAccordion_41(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class',
                'col-md-5 margin-top-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'form-input', [['pattern', '^[0-9]+([,.][0-9]{1,2})?$'], ['required',
                ''], ['type', 'number']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.parent.context.$implicit.Quantity = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_1 = (_co.onDutyChange($event, _v.parent.context.$implicit) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['dutyModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4,
                'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CalculatorAccordion_42)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CalculatorAccordion_43)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_9 = '';
        _ck(_v, 3, 0, currVal_9);
        var currVal_10 = '^[0-9]+([,.][0-9]{1,2})?$';
        _ck(_v, 4, 0, currVal_10);
        var currVal_11 = 'number';
        var currVal_12 = core_es5["ɵinlineInterpolate"](1, '', ('duty' + _v.parent.context.index.toString()), '');
        var currVal_13 = core_es5["ɵinlineInterpolate"](1, '', _co.getDutyLabel(_v.parent.context.$implicit), '');
        var currVal_14 = _co.disableChanges;
        var currVal_15 = core_es5["ɵnov"](_v.parent.parent.parent.parent, 9);
        var currVal_16 = ('Type ' + _co.getDutyLabel(_v.parent.context.$implicit));
        var currVal_17 = true;
        _ck(_v, 6, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17);
        var currVal_18 = core_es5["ɵinlineInterpolate"](1, '', ('duty' + _v.parent.context.index.toString()), '');
        var currVal_19 = _co.disableChanges;
        var currVal_20 = _v.parent.context.$implicit.Quantity;
        _ck(_v, 8, 0, currVal_18, currVal_19, currVal_20);
        var currVal_21 = ((core_es5["ɵunv"](_v, 13, 0, _ck(_v, 14, 0, core_es5["ɵnov"](_v.parent.parent.parent.parent, 1), core_es5["ɵnov"](_v, 6).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 6).model.pristine || core_es5["ɵnov"](_v.parent.parent.parent.parent, 9).submitted));
        _ck(_v, 13, 0, currVal_21);
        var currVal_22 = ((core_es5["ɵunv"](_v, 17, 0, _ck(_v, 18, 0, core_es5["ɵnov"](_v.parent.parent.parent.parent, 1), core_es5["ɵnov"](_v, 6).model.errors)) == 'pattern') && (!core_es5["ɵnov"](_v, 6).model.pristine || core_es5["ɵnov"](_v.parent.parent.parent.parent, 9).submitted));
        _ck(_v, 17, 0, currVal_22);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 3).required ? '' : null);
        var currVal_1 = (core_es5["ɵnov"](_v, 4).pattern ? core_es5["ɵnov"](_v, 4).pattern : null);
        var currVal_2 = core_es5["ɵnov"](_v, 10).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 10).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 10).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 10).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 10).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 10).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 10).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    });
}
function View_CalculatorAccordion_46(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' is required. ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getDutyLabel(_v.parent.parent.context.$implicit);
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalculatorAccordion_47(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' should contain only digits. ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getDutyLabel(_v.parent.parent.context.$implicit);
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalculatorAccordion_45(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class',
                'col-md-5 margin-top-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'form-input', [['pattern', '^[0-9]+([,.][0-9]{1,2})?$'], ['required',
                ''], ['type', 'number']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.parent.context.$implicit.Quantity = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_1 = (_co.onDutyChange($event, _v.parent.parent.context.$implicit) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['dutyModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4,
                'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CalculatorAccordion_46)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CalculatorAccordion_47)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_9 = '';
        _ck(_v, 3, 0, currVal_9);
        var currVal_10 = '^[0-9]+([,.][0-9]{1,2})?$';
        _ck(_v, 4, 0, currVal_10);
        var currVal_11 = 'number';
        var currVal_12 = core_es5["ɵinlineInterpolate"](1, '', ('duty' + _v.parent.context.index.toString()), '');
        var currVal_13 = core_es5["ɵinlineInterpolate"](1, '', _co.getDutyLabel(_v.parent.context.$implicit), '');
        var currVal_14 = _co.disableChanges;
        var currVal_15 = core_es5["ɵnov"](_v.parent.parent.parent.parent.parent, 9);
        var currVal_16 = ('Type ' + _co.getDutyLabel(_v.parent.context.$implicit));
        var currVal_17 = true;
        _ck(_v, 6, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17);
        var currVal_18 = core_es5["ɵinlineInterpolate"](1, '', ('duty' + _v.parent.context.index.toString()), '');
        var currVal_19 = _co.disableChanges;
        var currVal_20 = _v.parent.context.$implicit.Quantity;
        _ck(_v, 8, 0, currVal_18, currVal_19, currVal_20);
        var currVal_21 = ((core_es5["ɵunv"](_v, 13, 0, _ck(_v, 14, 0, core_es5["ɵnov"](_v.parent.parent.parent.parent.parent, 1), core_es5["ɵnov"](_v, 6).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 6).model.pristine || core_es5["ɵnov"](_v.parent.parent.parent.parent.parent, 9).submitted));
        _ck(_v, 13, 0, currVal_21);
        var currVal_22 = ((core_es5["ɵunv"](_v, 17, 0, _ck(_v, 18, 0, core_es5["ɵnov"](_v.parent.parent.parent.parent.parent, 1), core_es5["ɵnov"](_v, 6).model.errors)) == 'pattern') && (!core_es5["ɵnov"](_v, 6).model.pristine || core_es5["ɵnov"](_v.parent.parent.parent.parent.parent, 9).submitted));
        _ck(_v, 17, 0, currVal_22);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 3).required ? '' : null);
        var currVal_1 = (core_es5["ɵnov"](_v, 4).pattern ? core_es5["ɵnov"](_v, 4).pattern : null);
        var currVal_2 = core_es5["ɵnov"](_v, 10).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 10).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 10).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 10).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 10).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 10).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 10).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    });
}
function View_CalculatorAccordion_44(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_45)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_0 = (((_v.parent.context.$implicit.Measure == '%') && (_v.context.$implicit.Measure != '%')) && (_v.context.index == 0));
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_CalculatorAccordion_40(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_41)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_44)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_0 = (_v.context.$implicit.Measure != '%');
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.ExtraDuties;
        _ck(_v, 6, 0, currVal_1);
    }, null);
}
function View_CalculatorAccordion_39(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_40)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.orderItem.DutyList;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_CalculatorAccordion_49(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Polarization is required. ']))], null, null);
}
function View_CalculatorAccordion_50(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Polarization should contain only digits. ']))], null, null);
}
function View_CalculatorAccordion_48(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class',
                'col-sm-5 col-xs-12 margin-top-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 17, 'form-input', [['label', 'Polarization'],
                ['name', 'polarization'], ['pattern', '^[0-9]+([,.][0-9]{1,2})?$'], ['placeholder',
                    'Type polarization'], ['required', ''], ['type', 'number']], [[1, 'required',
                    0], [1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                    null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.polarizationDuty.Quantity = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['polarizationModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], disabled: [3, 'disabled'], form: [4,
                'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CalculatorAccordion_49)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CalculatorAccordion_50)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_9 = '';
        _ck(_v, 3, 0, currVal_9);
        var currVal_10 = '^[0-9]+([,.][0-9]{1,2})?$';
        _ck(_v, 4, 0, currVal_10);
        var currVal_11 = 'number';
        var currVal_12 = 'polarization';
        var currVal_13 = 'Polarization';
        var currVal_14 = _co.disableChanges;
        var currVal_15 = core_es5["ɵnov"](_v.parent.parent, 9);
        var currVal_16 = 'Type polarization';
        var currVal_17 = true;
        _ck(_v, 6, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17);
        var currVal_18 = 'polarization';
        var currVal_19 = _co.disableChanges;
        var currVal_20 = _co.polarizationDuty.Quantity;
        _ck(_v, 8, 0, currVal_18, currVal_19, currVal_20);
        var currVal_21 = ((core_es5["ɵunv"](_v, 13, 0, _ck(_v, 14, 0, core_es5["ɵnov"](_v.parent.parent, 1), core_es5["ɵnov"](_v, 6).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 6).model.pristine || core_es5["ɵnov"](_v.parent.parent, 9).submitted));
        _ck(_v, 13, 0, currVal_21);
        var currVal_22 = ((core_es5["ɵunv"](_v, 17, 0, _ck(_v, 18, 0, core_es5["ɵnov"](_v.parent.parent, 1), core_es5["ɵnov"](_v, 6).model.errors)) == 'pattern') && (!core_es5["ɵnov"](_v, 6).model.pristine || core_es5["ɵnov"](_v.parent.parent, 9).submitted));
        _ck(_v, 17, 0, currVal_22);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 3).required ? '' : null);
        var currVal_1 = (core_es5["ɵnov"](_v, 4).pattern ? core_es5["ɵnov"](_v, 4).pattern : null);
        var currVal_2 = core_es5["ɵnov"](_v, 10).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 10).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 10).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 10).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 10).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 10).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 10).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    });
}
function View_CalculatorAccordion_16(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 117, 'div', [['class',
                'row details']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 67, 'div', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'col-sm-6 col-xs-12': 0, 'col-sm-8 col-xs-12': 1 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 62, 'div', [['class',
                'form-group label-floating']], [[1, 'id', 0]], null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class',
                'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Product Name'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'input', [['name', 'hiddenCode'], ['required', ''], ['type', 'hidden']], [[1,
                'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 14)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 14).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 14)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 14)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 17).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_5 = ((_co.orderItem.Product.Id = $event) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, [['hiddenCode',
                4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, [[2, 0], ['prodInput',
                1]], null, 12, 'input', [['class', 'form-control padding-right-35 text-ellipsis-inline'],
            ['name', 'productSelect'], ['onFocusClass', 'form-group'], ['required', ''], ['validateProductName',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend'], [null, 'focus']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 26)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 26).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 26)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 26)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 30).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 35).onFocus($event) !== false);
                ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
                var pd_6 = (core_es5["ɵnov"](_v, 35).onBlur($event) !== false);
                ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_7 = ((_co.orderItem.Product.Name = $event) !== false);
                ad = (pd_7 && ad);
            }
            if (('input' === en)) {
                var pd_8 = (_co.handleProductInput($event.target.value) !== false);
                ad = (pd_8 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), core_es5["ɵpod"]({ 'display': 0 }),
        core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"],
            [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](16384, null, 0, ProductValidatorValidatorDirective, [], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], ProductValidatorValidatorDirective]), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, [['productSelect',
                4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2,
                'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), core_es5["ɵdid"](16384, null, 0, onFocus_OnFocusDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], { focusClass: [0, 'focusClass'],
            onFocusClass: [1, 'onFocusClass'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'span', [['class',
                'clear-product-select']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clearProduct() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), core_es5["ɵpod"]({ 'display': 0 }),
        (_l()(), core_es5["ɵted"](null, ['× '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_CalculatorAccordion_17)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_CalculatorAccordion_18)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_CalculatorAccordion_19)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 8, 'select', [['class', 'form-control select2'],
            ['name', 'productSelect'], ['required', '']], [[1, 'id', 0], [1, 'required', 0], [2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 55).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 55).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.orderItem.Product.Name = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, [['productSelect', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'material-input']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_20)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_21)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-sm-1 col-xs-2']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'form-group bold text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['OR'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'col-sm-3 col-xs-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['label',
                'HS/HTS code'], ['name', 'tarrif'], ['pattern', '\\d+\\.\\d+\\.(\\d+\\.\\d+|\\d{4})'],
            ['placeholder', 'Enter HS/HTS Code'], ['required', '']], [[1, 'required', 0], [1,
                'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'onDebounce']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.manualHsCode = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('onDebounce' === en)) {
                var pd_1 = (_co.handleHsChange() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = (_co.clearData() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['tariifModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], disabled: [2, 'disabled'], form: [3, 'form'],
            placeholder: [4, 'placeholder'], isPlaceholderNeed: [5, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        core_es5["ɵdid"](81920, null, 0, debounceDirective_DebounceDirective, [forms_es5["NgControl"]], { debounceTime: [0,
                'debounceTime'] }, { onDebounce: 'onDebounce' }), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, 0, 2, null, View_CalculatorAccordion_23)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CalculatorAccordion_24)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_25)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_31)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_39)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_48)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 4, 0, _co.isVehicle, !_co.isVehicle);
        _ck(_v, 3, 0, currVal_0);
        var currVal_2 = 'form-group label-floating';
        var currVal_3 = _ck(_v, 8, 0, ((core_es5["ɵnov"](_v, 59).invalid || core_es5["ɵnov"](_v, 19).invalid) && (!core_es5["ɵnov"](_v, 59).pristine || core_es5["ɵnov"](_v.parent, 9).submitted)));
        _ck(_v, 7, 0, currVal_2, currVal_3);
        var currVal_12 = '';
        _ck(_v, 15, 0, currVal_12);
        var currVal_13 = 'hiddenCode';
        var currVal_14 = _co.orderItem.Product.Id;
        _ck(_v, 19, 0, currVal_13, currVal_14);
        var currVal_23 = _ck(_v, 25, 0, ((_co.isProductNameHidden == false) ? 'block' : 'none'));
        _ck(_v, 24, 0, currVal_23);
        var currVal_24 = '';
        _ck(_v, 27, 0, currVal_24);
        var currVal_25 = 'productSelect';
        var currVal_26 = _co.disableChanges;
        var currVal_27 = _co.orderItem.Product.Name;
        _ck(_v, 32, 0, currVal_25, currVal_26, currVal_27);
        var currVal_28 = 'is-focused';
        var currVal_29 = 'form-group';
        _ck(_v, 35, 0, currVal_28, currVal_29);
        var currVal_30 = _ck(_v, 39, 0, ((_co.isProductNameHidden == false) ? 'block' : 'none'));
        _ck(_v, 38, 0, currVal_30);
        var currVal_31 = (((_co.isProductNameHidden == false) && (core_es5["ɵunv"](_v, 43, 0, _ck(_v, 44, 0, core_es5["ɵnov"](_v.parent, 1), core_es5["ɵnov"](_v, 59).errors)) == 'required')) && (!core_es5["ɵnov"](_v, 59).pristine || core_es5["ɵnov"](_v.parent, 9).submitted));
        _ck(_v, 43, 0, currVal_31);
        var currVal_32 = (((_co.isProductNameHidden == false) && (core_es5["ɵunv"](_v, 47, 0, _ck(_v, 48, 0, core_es5["ɵnov"](_v.parent, 1), core_es5["ɵnov"](_v, 59).errors)) == 'validateProductName')) && (!core_es5["ɵnov"](_v, 59).pristine || core_es5["ɵnov"](_v.parent, 9).submitted));
        _ck(_v, 47, 0, currVal_32);
        var currVal_33 = ((((core_es5["ɵunv"](_v, 51, 0, _ck(_v, 52, 0, core_es5["ɵnov"](_v.parent, 1), core_es5["ɵnov"](_v, 19).errors)) == 'required') && core_es5["ɵnov"](_v.parent, 9).submitted) && (_co.isProductNameHidden == false)) && !core_es5["ɵnov"](_v, 59).errors);
        _ck(_v, 51, 0, currVal_33);
        var currVal_43 = '';
        _ck(_v, 56, 0, currVal_43);
        var currVal_44 = 'productSelect';
        var currVal_45 = _co.disableChanges;
        var currVal_46 = _co.orderItem.Product.Name;
        _ck(_v, 59, 0, currVal_44, currVal_45, currVal_46);
        var currVal_47 = (((_co.isProductNameHidden == true) && core_es5["ɵnov"](_v, 59).invalid) && (!core_es5["ɵnov"](_v, 59).pristine || core_es5["ɵnov"](_v.parent, 9).submitted));
        _ck(_v, 67, 0, currVal_47);
        var currVal_48 = _co.isVehicle;
        _ck(_v, 72, 0, currVal_48);
        var currVal_58 = '';
        _ck(_v, 86, 0, currVal_58);
        var currVal_59 = '\\d+\\.\\d+\\.(\\d+\\.\\d+|\\d{4})';
        _ck(_v, 87, 0, currVal_59);
        var currVal_60 = 'tarrif';
        var currVal_61 = 'HS/HTS code';
        var currVal_62 = _co.disableChanges;
        var currVal_63 = core_es5["ɵnov"](_v.parent, 9);
        var currVal_64 = 'Enter HS/HTS Code';
        var currVal_65 = true;
        _ck(_v, 89, 0, currVal_60, currVal_61, currVal_62, currVal_63, currVal_64, currVal_65);
        var currVal_66 = 'tarrif';
        var currVal_67 = _co.disableChanges;
        var currVal_68 = _co.manualHsCode;
        _ck(_v, 91, 0, currVal_66, currVal_67, currVal_68);
        var currVal_69 = 1500;
        _ck(_v, 94, 0, currVal_69);
        var currVal_70 = (((core_es5["ɵunv"](_v, 97, 0, _ck(_v, 98, 0, core_es5["ɵnov"](_v.parent, 1), core_es5["ɵnov"](_v, 89).model.errors)) == 'pattern') && (!core_es5["ɵnov"](_v, 89).model.pristine || core_es5["ɵnov"](_v.parent, 9).submitted)) && _co.orderItem.Product.HsCode);
        _ck(_v, 97, 0, currVal_70);
        var currVal_71 = ((core_es5["ɵunv"](_v, 101, 0, _ck(_v, 102, 0, core_es5["ɵnov"](_v.parent, 1), core_es5["ɵnov"](_v, 89).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 89).model.pristine || core_es5["ɵnov"](_v.parent, 9).submitted));
        _ck(_v, 101, 0, currVal_71);
        var currVal_72 = (_co.orderItem.Product && _co.manualHsCode);
        _ck(_v, 107, 0, currVal_72);
        var currVal_73 = ((_co.orderItem.Product.Source == _co.tariffSource.Usa) && !_co.isTarifLoading);
        _ck(_v, 110, 0, currVal_73);
        var currVal_74 = ((_co.orderItem.Product.Source == _co.tariffSource.Canada) && !_co.isTarifLoading);
        _ck(_v, 113, 0, currVal_74);
        var currVal_75 = (_co.getSugarDuty() && !_co.isTarifLoading);
        _ck(_v, 116, 0, currVal_75);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = (_co.select2ProductId + '_productSelectDiv');
        _ck(_v, 6, 0, currVal_1);
        var currVal_4 = (core_es5["ɵnov"](_v, 15).required ? '' : null);
        var currVal_5 = core_es5["ɵnov"](_v, 21).ngClassUntouched;
        var currVal_6 = core_es5["ɵnov"](_v, 21).ngClassTouched;
        var currVal_7 = core_es5["ɵnov"](_v, 21).ngClassPristine;
        var currVal_8 = core_es5["ɵnov"](_v, 21).ngClassDirty;
        var currVal_9 = core_es5["ɵnov"](_v, 21).ngClassValid;
        var currVal_10 = core_es5["ɵnov"](_v, 21).ngClassInvalid;
        var currVal_11 = core_es5["ɵnov"](_v, 21).ngClassPending;
        _ck(_v, 13, 0, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11);
        var currVal_15 = (core_es5["ɵnov"](_v, 27).required ? '' : null);
        var currVal_16 = core_es5["ɵnov"](_v, 34).ngClassUntouched;
        var currVal_17 = core_es5["ɵnov"](_v, 34).ngClassTouched;
        var currVal_18 = core_es5["ɵnov"](_v, 34).ngClassPristine;
        var currVal_19 = core_es5["ɵnov"](_v, 34).ngClassDirty;
        var currVal_20 = core_es5["ɵnov"](_v, 34).ngClassValid;
        var currVal_21 = core_es5["ɵnov"](_v, 34).ngClassInvalid;
        var currVal_22 = core_es5["ɵnov"](_v, 34).ngClassPending;
        _ck(_v, 23, 0, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22);
        var currVal_34 = _co.select2ProductId;
        var currVal_35 = (core_es5["ɵnov"](_v, 56).required ? '' : null);
        var currVal_36 = core_es5["ɵnov"](_v, 61).ngClassUntouched;
        var currVal_37 = core_es5["ɵnov"](_v, 61).ngClassTouched;
        var currVal_38 = core_es5["ɵnov"](_v, 61).ngClassPristine;
        var currVal_39 = core_es5["ɵnov"](_v, 61).ngClassDirty;
        var currVal_40 = core_es5["ɵnov"](_v, 61).ngClassValid;
        var currVal_41 = core_es5["ɵnov"](_v, 61).ngClassInvalid;
        var currVal_42 = core_es5["ɵnov"](_v, 61).ngClassPending;
        _ck(_v, 54, 0, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42);
        var currVal_49 = (core_es5["ɵnov"](_v, 86).required ? '' : null);
        var currVal_50 = (core_es5["ɵnov"](_v, 87).pattern ? core_es5["ɵnov"](_v, 87).pattern : null);
        var currVal_51 = core_es5["ɵnov"](_v, 93).ngClassUntouched;
        var currVal_52 = core_es5["ɵnov"](_v, 93).ngClassTouched;
        var currVal_53 = core_es5["ɵnov"](_v, 93).ngClassPristine;
        var currVal_54 = core_es5["ɵnov"](_v, 93).ngClassDirty;
        var currVal_55 = core_es5["ɵnov"](_v, 93).ngClassValid;
        var currVal_56 = core_es5["ɵnov"](_v, 93).ngClassInvalid;
        var currVal_57 = core_es5["ɵnov"](_v, 93).ngClassPending;
        _ck(_v, 85, 0, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56, currVal_57);
    });
}
function View_CalculatorAccordion_52(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' 1st # of vin is required. ']))], null, null);
}
function View_CalculatorAccordion_53(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' 1st # should contain only digits. ']))], null, null);
}
function View_CalculatorAccordion_51(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 143, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'col-md-4 margin-top-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'form-input', [['label',
                '1st # of Vin'], ['name', 'FirstNumber'], ['pattern', '^[0-9]+([,.][0-9]{1,2})?$'],
            ['placeholder', 'Type 1st # of Vin'], ['required', ''], ['type', 'number']], [[1,
                'required', 0], [1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.orderItem.FirstNumber = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['firstNumberModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], disabled: [3, 'disabled'],
            form: [4, 'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CalculatorAccordion_52)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CalculatorAccordion_53)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 58, 'div', [['class', 'col-md-4']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Passenger Vehicle / Van / SUV'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class',
                'width-60 margin-right-15 display-inline-block']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class',
                'radio']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'input', [['name', 'isPassVehicle2'], ['type',
                'radio']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend'],
            [null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 42)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 42).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 42)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 42)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 43).onChange() !== false);
                ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 43).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.isPassVehicle = $event) !== false);
                ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_7 = (_co.setPassVehicle(true) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](212992, null, 0, forms_es5["RadioControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], forms_es5["ɵi"], core_es5["Injector"]], { name: [0, 'name'], value: [1,
                'value'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], forms_es5["RadioControlValueAccessor"]]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8,
                null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1,
                'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'circle']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'check']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'radio-label']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class', 'width-60 display-inline-block']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class',
                'radio']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'input', [['name', 'isPassVehicle'], ['type',
                'radio']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend'],
            [null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 66)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 66).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 66)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 66)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 67).onChange() !== false);
                ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 67).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.isPassVehicle = $event) !== false);
                ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_7 = (_co.setPassVehicle(false) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](212992, null, 0, forms_es5["RadioControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], forms_es5["ɵi"], core_es5["Injector"]], { name: [0, 'name'], value: [1,
                'value'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], forms_es5["RadioControlValueAccessor"]]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8,
                null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1,
                'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'circle']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'check']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'radio-label']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 58, 'div', [['class', 'col-md-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class',
                'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Trucks'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class',
                'width-60 margin-right-15 display-inline-block']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class',
                'radio']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'input', [['name', 'isTrucks2'], ['type', 'radio']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend'], [null,
                'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 102)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 102).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 102)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 102)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 103).onChange() !== false);
                ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 103).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.IsTrucksVal = $event) !== false);
                ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_7 = (_co.setIsTrucks(true) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](212992, null, 0, forms_es5["RadioControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], forms_es5["ɵi"], core_es5["Injector"]], { name: [0, 'name'], value: [1,
                'value'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], forms_es5["RadioControlValueAccessor"]]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8,
                null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1,
                'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'circle']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'check']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'radio-label']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class', 'width-60 display-inline-block']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class',
                'radio']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'input', [['name', 'isTrucks'], ['type', 'radio']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend'], [null,
                'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 126)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 126).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 126)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 126)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 127).onChange() !== false);
                ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 127).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.IsTrucksVal = $event) !== false);
                ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_7 = (_co.setIsTrucks(false) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](212992, null, 0, forms_es5["RadioControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], forms_es5["ɵi"], core_es5["Injector"]], { name: [0, 'name'], value: [1,
                'value'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], forms_es5["RadioControlValueAccessor"]]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8,
                null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1,
                'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'circle']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'check']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'radio-label']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_9 = '';
        _ck(_v, 5, 0, currVal_9);
        var currVal_10 = '^[0-9]+([,.][0-9]{1,2})?$';
        _ck(_v, 6, 0, currVal_10);
        var currVal_11 = 'number';
        var currVal_12 = 'FirstNumber';
        var currVal_13 = '1st # of Vin';
        var currVal_14 = _co.disableChanges;
        var currVal_15 = core_es5["ɵnov"](_v.parent, 9);
        var currVal_16 = 'Type 1st # of Vin';
        var currVal_17 = true;
        _ck(_v, 8, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17);
        var currVal_18 = 'FirstNumber';
        var currVal_19 = _co.disableChanges;
        var currVal_20 = _co.orderItem.FirstNumber;
        _ck(_v, 10, 0, currVal_18, currVal_19, currVal_20);
        var currVal_21 = ((core_es5["ɵunv"](_v, 15, 0, _ck(_v, 16, 0, core_es5["ɵnov"](_v.parent, 1), core_es5["ɵnov"](_v, 8).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 8).model.pristine || core_es5["ɵnov"](_v.parent, 9).submitted));
        _ck(_v, 15, 0, currVal_21);
        var currVal_22 = (((core_es5["ɵunv"](_v, 19, 0, _ck(_v, 20, 0, core_es5["ɵnov"](_v.parent, 1), core_es5["ɵnov"](_v, 8).model.errors)) == 'pattern') && (!core_es5["ɵnov"](_v, 8).model.pristine || core_es5["ɵnov"](_v.parent, 9).submitted)) && _co.orderItem.Price);
        _ck(_v, 19, 0, currVal_22);
        var currVal_30 = 'isPassVehicle2';
        var currVal_31 = true;
        _ck(_v, 43, 0, currVal_30, currVal_31);
        var currVal_32 = 'isPassVehicle2';
        var currVal_33 = _co.disableChanges;
        var currVal_34 = _co.isPassVehicle;
        _ck(_v, 45, 0, currVal_32, currVal_33, currVal_34);
        var currVal_43 = 'isPassVehicle';
        var currVal_44 = false;
        _ck(_v, 67, 0, currVal_43, currVal_44);
        var currVal_45 = 'isPassVehicle';
        var currVal_46 = _co.disableChanges;
        var currVal_47 = _co.isPassVehicle;
        _ck(_v, 69, 0, currVal_45, currVal_46, currVal_47);
        var currVal_56 = 'isTrucks2';
        var currVal_57 = true;
        _ck(_v, 103, 0, currVal_56, currVal_57);
        var currVal_58 = 'isTrucks2';
        var currVal_59 = _co.disableChanges;
        var currVal_60 = _co.IsTrucksVal;
        _ck(_v, 105, 0, currVal_58, currVal_59, currVal_60);
        var currVal_69 = 'isTrucks';
        var currVal_70 = false;
        _ck(_v, 127, 0, currVal_69, currVal_70);
        var currVal_71 = 'isTrucks';
        var currVal_72 = _co.disableChanges;
        var currVal_73 = _co.IsTrucksVal;
        _ck(_v, 129, 0, currVal_71, currVal_72, currVal_73);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 5).required ? '' : null);
        var currVal_1 = (core_es5["ɵnov"](_v, 6).pattern ? core_es5["ɵnov"](_v, 6).pattern : null);
        var currVal_2 = core_es5["ɵnov"](_v, 12).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 12).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 12).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 12).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 12).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 12).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 12).ngClassPending;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
        var currVal_23 = core_es5["ɵnov"](_v, 47).ngClassUntouched;
        var currVal_24 = core_es5["ɵnov"](_v, 47).ngClassTouched;
        var currVal_25 = core_es5["ɵnov"](_v, 47).ngClassPristine;
        var currVal_26 = core_es5["ɵnov"](_v, 47).ngClassDirty;
        var currVal_27 = core_es5["ɵnov"](_v, 47).ngClassValid;
        var currVal_28 = core_es5["ɵnov"](_v, 47).ngClassInvalid;
        var currVal_29 = core_es5["ɵnov"](_v, 47).ngClassPending;
        _ck(_v, 41, 0, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29);
        var currVal_35 = 'Yes';
        _ck(_v, 54, 0, currVal_35);
        var currVal_36 = core_es5["ɵnov"](_v, 71).ngClassUntouched;
        var currVal_37 = core_es5["ɵnov"](_v, 71).ngClassTouched;
        var currVal_38 = core_es5["ɵnov"](_v, 71).ngClassPristine;
        var currVal_39 = core_es5["ɵnov"](_v, 71).ngClassDirty;
        var currVal_40 = core_es5["ɵnov"](_v, 71).ngClassValid;
        var currVal_41 = core_es5["ɵnov"](_v, 71).ngClassInvalid;
        var currVal_42 = core_es5["ɵnov"](_v, 71).ngClassPending;
        _ck(_v, 65, 0, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42);
        var currVal_48 = 'No';
        _ck(_v, 78, 0, currVal_48);
        var currVal_49 = core_es5["ɵnov"](_v, 107).ngClassUntouched;
        var currVal_50 = core_es5["ɵnov"](_v, 107).ngClassTouched;
        var currVal_51 = core_es5["ɵnov"](_v, 107).ngClassPristine;
        var currVal_52 = core_es5["ɵnov"](_v, 107).ngClassDirty;
        var currVal_53 = core_es5["ɵnov"](_v, 107).ngClassValid;
        var currVal_54 = core_es5["ɵnov"](_v, 107).ngClassInvalid;
        var currVal_55 = core_es5["ɵnov"](_v, 107).ngClassPending;
        _ck(_v, 101, 0, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55);
        var currVal_61 = 'Yes';
        _ck(_v, 114, 0, currVal_61);
        var currVal_62 = core_es5["ɵnov"](_v, 131).ngClassUntouched;
        var currVal_63 = core_es5["ɵnov"](_v, 131).ngClassTouched;
        var currVal_64 = core_es5["ɵnov"](_v, 131).ngClassPristine;
        var currVal_65 = core_es5["ɵnov"](_v, 131).ngClassDirty;
        var currVal_66 = core_es5["ɵnov"](_v, 131).ngClassValid;
        var currVal_67 = core_es5["ɵnov"](_v, 131).ngClassInvalid;
        var currVal_68 = core_es5["ɵnov"](_v, 131).ngClassPending;
        _ck(_v, 125, 0, currVal_62, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67, currVal_68);
        var currVal_74 = 'No';
        _ck(_v, 138, 0, currVal_74);
    });
}
function View_CalculatorAccordion_57(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Fuel consumption is required. ']))], null, null);
}
function View_CalculatorAccordion_56(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 28, 'div', [['class',
                'col-sm-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'form-group label-floating']], [[1, 'id', 0]], null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Green Levy tax'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'select', [['class', 'form-control select2'], ['name', 'greenLevy'], ['required',
                '']], [[1, 'id', 0], [1, 'required', 0], [2, 'ng-untouched', null], [2,
                'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 10).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 10).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.greenLevyValue = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, [['greenLevySelect', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'],
            model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'option', [], null, null, null, null, null)),
        core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"], core_es5["Renderer2"],
            [2, forms_es5["SelectControlValueAccessor"]]], null, null), core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class',
                'material-input']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_57)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'form-group label-floating';
        var currVal_2 = _ck(_v, 4, 0, (core_es5["ɵnov"](_v, 14).invalid && (!core_es5["ɵnov"](_v, 14).pristine || core_es5["ɵnov"](_v.parent.parent.parent, 9).submitted)));
        _ck(_v, 3, 0, currVal_1, currVal_2);
        var currVal_12 = '';
        _ck(_v, 11, 0, currVal_12);
        var currVal_13 = 'greenLevy';
        var currVal_14 = (_co.disableChanges || _co.isTrailerOnly);
        var currVal_15 = _co.greenLevyValue;
        _ck(_v, 14, 0, currVal_13, currVal_14, currVal_15);
        var currVal_16 = (core_es5["ɵnov"](_v, 14).invalid && (!core_es5["ɵnov"](_v, 14).pristine || core_es5["ɵnov"](_v.parent.parent.parent, 9).submitted));
        _ck(_v, 26, 0, currVal_16);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.select2ProductId + '_greenLevySelectDiv');
        _ck(_v, 2, 0, currVal_0);
        var currVal_3 = (_co.select2ProductId + '_greenLevy');
        var currVal_4 = (core_es5["ɵnov"](_v, 11).required ? '' : null);
        var currVal_5 = core_es5["ɵnov"](_v, 16).ngClassUntouched;
        var currVal_6 = core_es5["ɵnov"](_v, 16).ngClassTouched;
        var currVal_7 = core_es5["ɵnov"](_v, 16).ngClassPristine;
        var currVal_8 = core_es5["ɵnov"](_v, 16).ngClassDirty;
        var currVal_9 = core_es5["ɵnov"](_v, 16).ngClassValid;
        var currVal_10 = core_es5["ɵnov"](_v, 16).ngClassInvalid;
        var currVal_11 = core_es5["ɵnov"](_v, 16).ngClassPending;
        _ck(_v, 9, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11);
    });
}
function View_CalculatorAccordion_55(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_56)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.calculatorHelper.isUsaShipmentFrom(_co.order);
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_CalculatorAccordion_58(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class',
                'col-sm-6 vehicles']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [['label', 'Trailer only'], ['name', 'trailerOnly']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.isTrailerOnly = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_1 = (_co.toggleIsTrailerOnly() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], form: [2, 'form'], disabled: [3, 'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, [['trailerOnly', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'trailerOnly';
        var currVal_8 = 'Trailer only';
        var currVal_9 = core_es5["ɵnov"](_v.parent.parent, 9);
        var currVal_10 = _co.disableChanges;
        _ck(_v, 3, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'trailerOnly';
        var currVal_12 = _co.disableChanges;
        var currVal_13 = _co.isTrailerOnly;
        _ck(_v, 5, 0, currVal_11, currVal_12, currVal_13);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_CalculatorAccordion_59(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'col-sm-12 vehicles']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 6, 'checkbox', [['label', 'Is this auto parts? (RIV fee)'],
                ['name', 'vehicleParts']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                    null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
                [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                    null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.isVehicleParts = $event) !== false);
                    ad = (pd_0 && ad);
                }
                if (('ngModelChange' === en)) {
                    var pd_1 = (_co.toggleVehicleParts() !== false);
                    ad = (pd_1 && ad);
                }
                return ad;
            }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], form: [2, 'form'], disabled: [3, 'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, [['vehicleParts', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'vehicleParts';
        var currVal_8 = 'Is this auto parts? (RIV fee)';
        var currVal_9 = core_es5["ɵnov"](_v.parent.parent, 9);
        var currVal_10 = _co.disableChanges;
        _ck(_v, 5, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'vehicleParts';
        var currVal_12 = _co.disableChanges;
        var currVal_13 = _co.isVehicleParts;
        _ck(_v, 7, 0, currVal_11, currVal_12, currVal_13);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 9).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 9).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 9).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 9).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 9).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 9).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 9).ngClassPending;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_CalculatorAccordion_60(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'col-sm-6 vehicles']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 6, 'checkbox', [['label', 'Used Equipment Exam?'],
                ['name', 'usedEquipmentExam']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                    null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
                [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                    null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.usedEquipmentExamp = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], form: [2, 'form'], disabled: [3, 'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, [['usedEquipmentExam', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'usedEquipmentExam';
        var currVal_8 = 'Used Equipment Exam?';
        var currVal_9 = core_es5["ɵnov"](_v.parent.parent, 9);
        var currVal_10 = _co.disableChanges;
        _ck(_v, 5, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'usedEquipmentExam';
        var currVal_12 = _co.disableChanges;
        var currVal_13 = _co.usedEquipmentExamp;
        _ck(_v, 7, 0, currVal_11, currVal_12, currVal_13);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 9).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 9).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 9).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 9).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 9).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 9).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 9).ngClassPending;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_CalculatorAccordion_54(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 27, 'div', [['class',
                'col-md-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_55)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'col-sm-6 vehicles']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [['label', 'Does this car have A/C? (AC tax)'], ['name', 'ac']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.isAC = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_1 = (_co.toggleAES() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], form: [2, 'form'], disabled: [3, 'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, [['ac', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_58)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_59)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_60)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.calculatorHelper.isCanadianVehicleCalculator(_co.order);
        _ck(_v, 3, 0, currVal_0);
        var currVal_8 = 'ac';
        var currVal_9 = 'Does this car have A/C? (AC tax)';
        var currVal_10 = core_es5["ɵnov"](_v.parent, 9);
        var currVal_11 = (_co.disableChanges || _co.isTrailerOnly);
        _ck(_v, 10, 0, currVal_8, currVal_9, currVal_10, currVal_11);
        var currVal_12 = 'ac';
        var currVal_13 = (_co.disableChanges || _co.isTrailerOnly);
        var currVal_14 = _co.isAC;
        _ck(_v, 12, 0, currVal_12, currVal_13, currVal_14);
        var currVal_15 = _co.isCanadaShipmentTo();
        _ck(_v, 19, 0, currVal_15);
        var currVal_16 = (_co.calculatorHelper.isCanadianVehicleCalculator(_co.order) && _co.calculatorHelper.isUsaShipmentFrom(_co.order));
        _ck(_v, 23, 0, currVal_16);
        var currVal_17 = _co.calculatorHelper.isUsedEquipment(_co.orderItem.Product);
        _ck(_v, 26, 0, currVal_17);
    }, function (_ck, _v) {
        var currVal_1 = core_es5["ɵnov"](_v, 14).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 14).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 14).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 14).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 14).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 14).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 14).ngClassPending;
        _ck(_v, 9, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
    });
}
function View_CalculatorAccordion_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DecimalPipe"], [core_es5["LOCALE_ID"]]), core_es5["ɵpid"](0, FirstKeyPipe, []), core_es5["ɵqud"](402653184, 1, { accordionForm: 0 }), core_es5["ɵqud"](671088640, 2, { productSelect: 0 }),
        core_es5["ɵqud"](402653184, 3, { accordion: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 176, 'form', [['class', 'form-horizontal calculator-product-form'], ['novalidate',
                '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 9).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 9).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'blur-content': 0 }),
        core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null),
        core_es5["ɵdid"](16384, [[1, 4], ['accordionForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8,
                null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 167, 'accordion-group', [['class', 'product-items panel'], ['style', 'display: block']], [[2, 'panel-open', null]], null, null, View_AccordionPanelComponent_0, RenderType_AccordionPanelComponent)), core_es5["ɵdid"](245760, [[3, 4], ['group',
                4]], 0, accordion_group_component_AccordionPanelComponent, [accordion_component_AccordionComponent], { panelClass: [0,
                'panelClass'], isDisabled: [1, 'isDisabled'], isOpen: [2, 'isOpen'] }, null),
        (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 4, 'div', [['accordion-heading',
                '']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, 1, 67, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 27, 'div', [['class',
                'col-md-6']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'col-md-4': 0, 'col-md-6': 1 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 22, 'div', [['class', 'form-group label-floating']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'has-error': 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Country of Manufacture'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 12, 'select', [['class', 'form-control select2'],
                ['name', 'manufacturerSelect'], ['required', '']], [[1, 'id', 0], [1, 'required',
                    0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                    'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                    null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'change'], [null,
                    'blur']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('change' === en)) {
                    var pd_0 = (core_es5["ɵnov"](_v, 36).onChange($event.target.value) !== false);
                    ad = (pd_0 && ad);
                }
                if (('blur' === en)) {
                    var pd_1 = (core_es5["ɵnov"](_v, 36).onTouched() !== false);
                    ad = (pd_1 && ad);
                }
                if (('ngModelChange' === en)) {
                    var pd_2 = ((_co.manufacturer = $event) !== false);
                    ad = (pd_2 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, [['manufacturerSelect', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'],
            model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'option', [], null, null, null, null, null)),
        core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"], core_es5["Renderer2"],
            [2, forms_es5["SelectControlValueAccessor"]]], null, null), core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class',
                'material-input']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_10)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 32, 'div', [['class', 'col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 29, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'col-xs-7']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 17, 'form-input', [['label', 'Product value'],
                ['name', 'price'], ['pattern', '^[0-9]+([,.][0-9]{1,2})?$'], ['placeholder',
                    'Type product value'], ['required', ''], ['type', 'number']], [[1, 'required',
                    0], [1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                    null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
                [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                    null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.orderItem.Price = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['priceModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], disabled: [3, 'disabled'],
            form: [4, 'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CalculatorAccordion_12)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_CalculatorAccordion_13)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_14)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, 1, 1, null, View_CalculatorAccordion_16)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 1, 1, null, View_CalculatorAccordion_51)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 82, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorAccordion_54)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'row margin-left-0 margin-right-0']], [[8, 'hidden', 0]], null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-md-3']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'form-group label-floating']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['FDA/EPA/DOT'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'select', [['class', 'form-control select2'], ['name', 'productSelect']], [[1,
                'id', 0]], null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'material-input']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 59, 'div', [['class', 'col-md-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label margin-right-15 margin-bottom-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Have you purchased this item yet?'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 53, 'div', [['class', 'display-inline-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 24, 'div', [['class', 'width-60 margin-right-15 display-inline-block']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class',
                'radio']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'disabled': 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'input', [['name',
                'purchased2'], ['type', 'radio']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend'], [null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 135)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 135).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 135)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 135)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 136).onChange() !== false);
                ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 136).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.orderItem.IsPurchased = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](212992, null, 0, forms_es5["RadioControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], forms_es5["ɵi"], core_es5["Injector"]], { name: [0, 'name'], value: [1,
                'value'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], forms_es5["RadioControlValueAccessor"]]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8,
                null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1,
                'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'circle']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'check']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'radio-label']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 24, 'div', [['class', 'width-60 display-inline-block']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class',
                'radio']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'label', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'disabled': 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'input', [['name', 'purchased'], ['type', 'radio']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend'], [null,
                'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 161)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 161).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 161)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 161)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 162).onChange() !== false);
                ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 162).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.orderItem.IsPurchased = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](212992, null, 0, forms_es5["RadioControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], forms_es5["ɵi"], core_es5["Injector"]], { name: [0, 'name'], value: [1,
                'value'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], forms_es5["RadioControlValueAccessor"]]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8,
                null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1,
                'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'circle']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'check']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'radio-label']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'form-horizontal calculator-product-form';
        var currVal_8 = _ck(_v, 7, 0, _co.isUsService);
        _ck(_v, 6, 0, currVal_7, currVal_8);
        var currVal_10 = _co.getClass();
        var currVal_11 = (_co.isQuickQuote || _co.isUsService);
        var currVal_12 = (_co.defaultState && !_co.isUsService);
        _ck(_v, 14, 0, currVal_10, currVal_11, currVal_12);
        var currVal_13 = !_co.isQuickQuote;
        _ck(_v, 19, 0, currVal_13);
        var currVal_14 = 'col-md-6';
        var currVal_15 = _ck(_v, 26, 0, (_co.isQuickQuote && _co.isVehicle), '(!isQuickQuote || !isVehicle)');
        _ck(_v, 25, 0, currVal_14, currVal_15);
        var currVal_16 = 'form-group label-floating';
        var currVal_17 = _ck(_v, 30, 0, (core_es5["ɵnov"](_v, 9) && (core_es5["ɵnov"](_v, 40).invalid && (!core_es5["ɵnov"](_v, 40).pristine || core_es5["ɵnov"](_v, 9).submitted))));
        _ck(_v, 29, 0, currVal_16, currVal_17);
        var currVal_27 = '';
        _ck(_v, 37, 0, currVal_27);
        var currVal_28 = 'manufacturerSelect';
        var currVal_29 = _co.disableChanges;
        var currVal_30 = _co.manufacturer;
        _ck(_v, 40, 0, currVal_28, currVal_29, currVal_30);
        var currVal_31 = (_co.isQuickQuote && _co.isVehicle);
        _ck(_v, 54, 0, currVal_31);
        var currVal_41 = '';
        _ck(_v, 63, 0, currVal_41);
        var currVal_42 = '^[0-9]+([,.][0-9]{1,2})?$';
        _ck(_v, 64, 0, currVal_42);
        var currVal_43 = 'number';
        var currVal_44 = 'price';
        var currVal_45 = 'Product value';
        var currVal_46 = _co.disableChanges;
        var currVal_47 = core_es5["ɵnov"](_v, 9);
        var currVal_48 = 'Type product value';
        var currVal_49 = true;
        _ck(_v, 66, 0, currVal_43, currVal_44, currVal_45, currVal_46, currVal_47, currVal_48, currVal_49);
        var currVal_50 = 'price';
        var currVal_51 = _co.disableChanges;
        var currVal_52 = _co.orderItem.Price;
        _ck(_v, 68, 0, currVal_50, currVal_51, currVal_52);
        var currVal_53 = ((core_es5["ɵunv"](_v, 73, 0, _ck(_v, 74, 0, core_es5["ɵnov"](_v, 1), core_es5["ɵnov"](_v, 66).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 66).model.pristine || core_es5["ɵnov"](_v, 9).submitted));
        _ck(_v, 73, 0, currVal_53);
        var currVal_54 = (((core_es5["ɵunv"](_v, 77, 0, _ck(_v, 78, 0, core_es5["ɵnov"](_v, 1), core_es5["ɵnov"](_v, 66).model.errors)) == 'pattern') && (!core_es5["ɵnov"](_v, 66).model.pristine || core_es5["ɵnov"](_v, 9).submitted)) && _co.orderItem.Price);
        _ck(_v, 77, 0, currVal_54);
        var currVal_55 = _co.orderItem;
        _ck(_v, 85, 0, currVal_55);
        var currVal_56 = !_co.isQuickQuote;
        _ck(_v, 92, 0, currVal_56);
        var currVal_57 = (_co.isVehicleCalc() && (_co.order.CalculatorType == _co.calculatorType.UsaImport));
        _ck(_v, 95, 0, currVal_57);
        var currVal_58 = (_co.calculatorHelper.isCanadianVehicleCalculator(_co.order) || _co.calculatorHelper.isUsedEquipment(_co.orderItem.Product));
        _ck(_v, 100, 0, currVal_58);
        var currVal_61 = 'radio';
        var currVal_62 = _ck(_v, 130, 0, _co.disableChanges);
        _ck(_v, 129, 0, currVal_61, currVal_62);
        var currVal_70 = 'purchased2';
        var currVal_71 = true;
        _ck(_v, 136, 0, currVal_70, currVal_71);
        var currVal_72 = 'purchased2';
        var currVal_73 = _co.disableChanges;
        var currVal_74 = _co.orderItem.IsPurchased;
        _ck(_v, 138, 0, currVal_72, currVal_73, currVal_74);
        var currVal_76 = _ck(_v, 158, 0, _co.disableChanges);
        _ck(_v, 157, 0, currVal_76);
        var currVal_84 = 'purchased';
        var currVal_85 = false;
        _ck(_v, 162, 0, currVal_84, currVal_85);
        var currVal_86 = 'purchased';
        var currVal_87 = _co.disableChanges;
        var currVal_88 = _co.orderItem.IsPurchased;
        _ck(_v, 164, 0, currVal_86, currVal_87, currVal_88);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵnov"](_v, 11).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 11).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 11).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 11).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 11).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 11).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 11).ngClassPending;
        _ck(_v, 5, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_9 = core_es5["ɵnov"](_v, 14).isOpen;
        _ck(_v, 13, 0, currVal_9);
        var currVal_18 = _co.select2ManufacturerId;
        var currVal_19 = (core_es5["ɵnov"](_v, 37).required ? '' : null);
        var currVal_20 = core_es5["ɵnov"](_v, 42).ngClassUntouched;
        var currVal_21 = core_es5["ɵnov"](_v, 42).ngClassTouched;
        var currVal_22 = core_es5["ɵnov"](_v, 42).ngClassPristine;
        var currVal_23 = core_es5["ɵnov"](_v, 42).ngClassDirty;
        var currVal_24 = core_es5["ɵnov"](_v, 42).ngClassValid;
        var currVal_25 = core_es5["ɵnov"](_v, 42).ngClassInvalid;
        var currVal_26 = core_es5["ɵnov"](_v, 42).ngClassPending;
        _ck(_v, 35, 0, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26);
        var currVal_32 = (core_es5["ɵnov"](_v, 63).required ? '' : null);
        var currVal_33 = (core_es5["ɵnov"](_v, 64).pattern ? core_es5["ɵnov"](_v, 64).pattern : null);
        var currVal_34 = core_es5["ɵnov"](_v, 70).ngClassUntouched;
        var currVal_35 = core_es5["ɵnov"](_v, 70).ngClassTouched;
        var currVal_36 = core_es5["ɵnov"](_v, 70).ngClassPristine;
        var currVal_37 = core_es5["ɵnov"](_v, 70).ngClassDirty;
        var currVal_38 = core_es5["ɵnov"](_v, 70).ngClassValid;
        var currVal_39 = core_es5["ɵnov"](_v, 70).ngClassInvalid;
        var currVal_40 = core_es5["ɵnov"](_v, 70).ngClassPending;
        _ck(_v, 62, 0, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40);
        var currVal_59 = (!_co.order.Customer.Location || !_co.isUsaShipmentTo());
        _ck(_v, 102, 0, currVal_59);
        var currVal_60 = _co.select2PdaId;
        _ck(_v, 111, 0, currVal_60);
        var currVal_63 = core_es5["ɵnov"](_v, 140).ngClassUntouched;
        var currVal_64 = core_es5["ɵnov"](_v, 140).ngClassTouched;
        var currVal_65 = core_es5["ɵnov"](_v, 140).ngClassPristine;
        var currVal_66 = core_es5["ɵnov"](_v, 140).ngClassDirty;
        var currVal_67 = core_es5["ɵnov"](_v, 140).ngClassValid;
        var currVal_68 = core_es5["ɵnov"](_v, 140).ngClassInvalid;
        var currVal_69 = core_es5["ɵnov"](_v, 140).ngClassPending;
        _ck(_v, 134, 0, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67, currVal_68, currVal_69);
        var currVal_75 = 'Yes';
        _ck(_v, 147, 0, currVal_75);
        var currVal_77 = core_es5["ɵnov"](_v, 166).ngClassUntouched;
        var currVal_78 = core_es5["ɵnov"](_v, 166).ngClassTouched;
        var currVal_79 = core_es5["ɵnov"](_v, 166).ngClassPristine;
        var currVal_80 = core_es5["ɵnov"](_v, 166).ngClassDirty;
        var currVal_81 = core_es5["ɵnov"](_v, 166).ngClassValid;
        var currVal_82 = core_es5["ɵnov"](_v, 166).ngClassInvalid;
        var currVal_83 = core_es5["ɵnov"](_v, 166).ngClassPending;
        _ck(_v, 160, 0, currVal_77, currVal_78, currVal_79, currVal_80, currVal_81, currVal_82, currVal_83);
        var currVal_89 = 'No';
        _ck(_v, 173, 0, currVal_89);
    });
}
function View_CalculatorAccordion_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'calculator-accordion', [], null, null, null, View_CalculatorAccordion_0, RenderType_CalculatorAccordion)), core_es5["ɵdid"](4374528, null, 0, calculator_accordion_component["a" /* CalculatorAccordion */], [services_configService["a" /* ConfigService */], services_productService["a" /* ProductService */], calculator_calculatorService["a" /* CalculatorService */], core_es5["ChangeDetectorRef"],
            tax_service["a" /* TaxService */]], null, null)], null, null);
}
var CalculatorAccordionNgFactory = core_es5["ɵccf"]('calculator-accordion', calculator_accordion_component["a" /* CalculatorAccordion */], View_CalculatorAccordion_Host_0, { index: 'index', orderItem: 'orderItem',
    productForm: 'productForm', currentProduct: 'currentProduct', order: 'order', canadianCurrencyCodes: 'canadianCurrencyCodes',
    defaultState: 'defaultState', disableChanges: 'disableChanges', isQuickQuote: 'isQuickQuote',
    isPublic: 'isPublic' }, { onItemRemoved: 'onItemRemoved' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=calculator-accordion.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/objects/orders/orderItem.ts + 1 modules
var orders_orderItem = __webpack_require__("PL+a");

// CONCATENATED MODULE: ./app/components/calculator/cards/products-card/products-card.component.ts







/**
 * Created by vlad.p on 9/8/2017.
 */
var products_card_component_ProductsCardComponent = /** @class */ (function () {
    function ProductsCardComponent(countryService, calculatorService) {
        this.countryService = countryService;
        this.calculatorService = calculatorService;
        this.isPublic = false;
        this.calculatorType = orders_calculatorType["a" /* CalculatorType */];
        this.calculatorHelper = calculatorHelper["a" /* CalculatorHelper */];
        this.isOneTime = false;
        this.orderStatus = orders_orderStatus["a" /* OrderStatus */];
        this.clonedOrderItemsFull = [];
        this.clonedOrderItemsQuick = [];
        this.showChangeQuoteSpinner = false;
        this.subscriptionArray = new Array();
    }
    Object.defineProperty(ProductsCardComponent.prototype, "isQuickQuote", {
        get: function () {
            if (!this.order || !this.order.Flag)
                return false;
            return this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsQuickQuote);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsCardComponent.prototype, "isVehicle", {
        get: function () {
            if (!this.order || !this.order.Flag)
                return false;
            return this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsVehicle);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsCardComponent.prototype, "isFullQuote", {
        get: function () {
            if (!this.order || !this.order.Flag)
                return true;
            return !this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsUsService) &&
                !this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsQuickQuote);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsCardComponent.prototype, "isUsService", {
        get: function () {
            if (!this.order || !this.order.Flag)
                return false;
            return this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsUsService);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsCardComponent.prototype, "isCanadianCaluclator", {
        get: function () {
            return calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(this.order.Locations) == orders_calculatorType["a" /* CalculatorType */].CanadianImport;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsCardComponent.prototype, "isOcean", {
        get: function () {
            return this.order.Flag != null && this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsOcean);
        },
        set: function (val) {
            if (this.order.Flag != null && this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsOcean)) {
                this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsOcean;
                this.order.CarryingType = 1;
            }
            else {
                this.order.Flag |= orderOptions["a" /* OrderOptions */].IsOcean;
                this.order.CarryingType = 3;
            }
        },
        enumerable: true,
        configurable: true
    });
    ProductsCardComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        var name = changes.isVehicle;
        if (!name || (name.previousValue == name.currentValue))
            return;
        this.showChangeQuoteSpinner = true;
        setTimeout(function () {
            _this.showChangeQuoteSpinner = false;
        }, 370); //i need really 370ms, because if faster select 2 hasn't been re-inited yet
    };
    ProductsCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.order.OrderItems.length == 0)
            this.order.OrderItems.push(new orders_orderItem["b" /* OrderItem */]({
                CanadianCurrencyCode: calculatorHelper["a" /* CalculatorHelper */].getDefaultCurrency(this.canadianCurrencyCodes, this.order, this.countryService)
            }));
        if (this.order.Flag != null && this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsOneTime))
            this.isOneTime = true;
        this.subscriptionArray.push(this.calculatorService.subscribe(function (location) {
            if (!location)
                return;
            if (location.Type == 2) {
                _this.handleChange();
            }
            for (var _i = 0, _a = _this.order.OrderItems; _i < _a.length; _i++) {
                var oi = _a[_i];
                if (!oi.CanadianCurrencyCode || !oi.CanadianCurrencyCode.Name)
                    oi.CanadianCurrencyCode = calculatorHelper["a" /* CalculatorHelper */].getDefaultCurrency(_this.canadianCurrencyCodes, _this.order, _this.countryService);
            }
        }));
        this.subscriptionArray.push(this.calculatorService.subscribeIsVeh(function (isVehicle) {
            _this.handleChange();
        }));
    };
    ProductsCardComponent.prototype.ngOnDestroy = function () {
        for (var _i = 0, _a = this.subscriptionArray; _i < _a.length; _i++) {
            var s = _a[_i];
            s.unsubscribe();
        }
    };
    ProductsCardComponent.prototype.handleChange = function () {
        if (!this.isUsService)
            return;
        if (this.isCanadianCaluclator && this.isVehicle)
            return;
        this.setQuote(0);
    };
    ProductsCardComponent.prototype.addProduct = function () {
        this.order.OrderItems.push(new orders_orderItem["b" /* OrderItem */]({
            CanadianCurrencyCode: calculatorHelper["a" /* CalculatorHelper */].getDefaultCurrency(this.canadianCurrencyCodes, this.order, this.countryService)
        }));
    };
    ProductsCardComponent.prototype.removeItem = function (oItem) {
        this.order.OrderItems = this.order.OrderItems.filter(function (item) { return item !== oItem; });
        if (this.order.OrderItems.length == 0) {
            this.order.OrderItems.push(new orders_orderItem["b" /* OrderItem */]({
                CanadianCurrencyCode: calculatorHelper["a" /* CalculatorHelper */].getDefaultCurrency(this.canadianCurrencyCodes, this.order, this.countryService)
            }));
        }
    };
    ProductsCardComponent.prototype.toggleIsOneTime = function () {
        if (this.order.Flag != null && this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsOneTime)) {
            this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsOneTime;
        }
        else {
            this.order.Flag |= orderOptions["a" /* OrderOptions */].IsOneTime;
        }
    };
    ProductsCardComponent.prototype.checkForm = function () {
        this.productsForm.onSubmit(null);
        if (this.isUsService)
            return true;
        var res = true;
        this.calculatorAccordion.forEach(function (item) {
            if (!item.checkForm())
                res = false;
        });
        if (!res)
            return res;
        return this.productsForm.valid;
    };
    ProductsCardComponent.prototype.isValid = function () {
        if (this.isUsService)
            return true;
        var res = true;
        this.calculatorAccordion.forEach(function (item) {
            if (!item.isValid())
                res = false;
        });
        return res;
    };
    ProductsCardComponent.prototype.setQuote = function (value) {
        var _this = this;
        if (this.order.Status >= orders_orderStatus["a" /* OrderStatus */].Paid || this.disableChanges)
            return;
        if (value == 2 && !this.isCanadianCaluclator)
            return;
        this.showChangeQuoteSpinner = true;
        if (!this.order.Flag)
            this.order.Flag = 0;
        if (this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsQuickQuote)) {
            this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsQuickQuote;
            this.clonedOrderItemsQuick = JSON.parse(JSON.stringify(this.order.OrderItems));
        }
        else if (!this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsUsService)) {
            this.clonedOrderItemsFull = JSON.parse(JSON.stringify(this.order.OrderItems));
        }
        this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsUsService;
        if (value == 0) {
            this.setQuoteOrderItems(this.order, JSON.parse(JSON.stringify(this.clonedOrderItemsFull)));
        }
        else if (value == 1) {
            this.order.Flag |= orderOptions["a" /* OrderOptions */].IsQuickQuote;
            this.setQuoteOrderItems(this.order, JSON.parse(JSON.stringify(this.clonedOrderItemsQuick)));
        }
        else {
            this.order.Flag |= orderOptions["a" /* OrderOptions */].IsUsService;
            this.order.OrderItems = [new orders_orderItem["b" /* OrderItem */]({
                    CanadianCurrencyCode: calculatorHelper["a" /* CalculatorHelper */].getDefaultCurrency(this.canadianCurrencyCodes, this.order, this.countryService)
                })];
        }
        setTimeout(function () {
            _this.showChangeQuoteSpinner = false;
        }, 370); //i need really 370ms, because if faster select 2 hasn't been re-inited yet
    };
    ProductsCardComponent.prototype.setQuoteOrderItems = function (order, clonedOrderItemsFull) {
        order.OrderItems = [];
        if (clonedOrderItemsFull.length == 0)
            order.OrderItems = [new orders_orderItem["b" /* OrderItem */]({
                    CanadianCurrencyCode: calculatorHelper["a" /* CalculatorHelper */].getDefaultCurrency(this.canadianCurrencyCodes, this.order, this.countryService)
                })];
        for (var _i = 0, clonedOrderItemsFull_1 = clonedOrderItemsFull; _i < clonedOrderItemsFull_1.length; _i++) {
            var it = clonedOrderItemsFull_1[_i];
            if (it.Id || (it.Manufacturer && it.Manufacturer.Name) || it.Price || it.Type > 0 || (it.Product && (it.Product.HsCode || it.Product.Name)) ||
                ((it.FirstNumber || it.Flags > 0 || it.Year) && order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsVehicle))) {
                if (!it.CanadianCurrencyCode || !it.CanadianCurrencyCode.Name)
                    it.CanadianCurrencyCode = calculatorHelper["a" /* CalculatorHelper */].getDefaultCurrency(this.canadianCurrencyCodes, order, this.countryService);
                order.OrderItems.push(it);
            }
            else
                this.order.OrderItems.push(new orders_orderItem["b" /* OrderItem */]({
                    CanadianCurrencyCode: calculatorHelper["a" /* CalculatorHelper */].getDefaultCurrency(this.canadianCurrencyCodes, order, this.countryService)
                }));
        }
    };
    ProductsCardComponent.prototype.isUsServiceTabDisabled = function () {
        if (!this.isCanadianCaluclator)
            return true;
        if ((this.order.Status >= orders_orderStatus["a" /* OrderStatus */].Paid || this.disableChanges) && !this.isUsService)
            return true;
        return false;
    };
    ProductsCardComponent.ctorParameters = function () { return [{ type: CountryService_CountryService }, { type: calculator_calculatorService["a" /* CalculatorService */] }]; };
    return ProductsCardComponent;
}());

//# sourceMappingURL=products-card.component.js.map
// CONCATENATED MODULE: ./compiled/node_modules/ngx-bootstrap/accordion/accordion.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_AccordionComponent = [];
var RenderType_AccordionComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AccordionComponent, data: {} });
function View_AccordionComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵncd"](null, 0)], null, null);
}
function View_AccordionComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'accordion', [['class',
                'panel-group'], ['role', 'tablist'], ['style', 'display: block']], [[1, 'aria-multiselectable',
                0]], null, null, View_AccordionComponent_0, RenderType_AccordionComponent)),
        core_es5["ɵdid"](49152, null, 0, accordion_component_AccordionComponent, [accordion_config_AccordionConfig], null, null)], null, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).closeOthers;
        _ck(_v, 0, 0, currVal_0);
    });
}
var AccordionComponentNgFactory = core_es5["ɵccf"]('accordion', accordion_component_AccordionComponent, View_AccordionComponent_Host_0, { closeOthers: 'closeOthers' }, {}, ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvYWNjb3JkaW9uL2FjY29yZGlvbi5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvYWNjb3JkaW9uL2FjY29yZGlvbi5jb21wb25lbnQuZC50cyIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL2FjY29yZGlvbi9hY2NvcmRpb24uY29tcG9uZW50LmQudHMuQWNjb3JkaW9uQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9hY2NvcmRpb24vYWNjb3JkaW9uLmNvbXBvbmVudC5kLnRzLkFjY29yZGlvbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxuZy1jb250ZW50PjwvbmctY29udGVudD4iLCI8YWNjb3JkaW9uPjwvYWNjb3JkaW9uPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OzsyQkNBQTs7O29CQ0FBO01BQUE7TUFBQTthQUFBO1VBQUE7SUFBQTtJQUFBLFdBQUEsU0FBQTs7Ozs7In0=
//# sourceMappingURL=accordion.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/cards/products-card/products-card.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */

















var styles_ProductsCardComponent = [];
var RenderType_ProductsCardComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ProductsCardComponent, data: {} });
function View_ProductsCardComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class',
                'simple-tab tab-pane']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setQuote(2) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active-tab': 0, 'disabled': 1 }), (_l()(), core_es5["ɵted"](null, ['US EXPORT Service']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'simple-tab tab-pane';
        var currVal_1 = _ck(_v, 2, 0, _co.isUsService, _co.isUsServiceTabDisabled());
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_ProductsCardComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'spinner']], null, null, null, null, null))], null, null);
}
function View_ProductsCardComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calculator-accordion', [], null, [[null, 'onItemRemoved']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onItemRemoved' === en)) {
                var pd_0 = (_co.removeItem($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalculatorAccordion_0, RenderType_CalculatorAccordion)), core_es5["ɵdid"](4374528, [[2, 4]], 0, calculator_accordion_component["a" /* CalculatorAccordion */], [services_configService["a" /* ConfigService */], services_productService["a" /* ProductService */], calculator_calculatorService["a" /* CalculatorService */],
            core_es5["ChangeDetectorRef"], tax_service["a" /* TaxService */]], { index: [0, 'index'], orderItem: [1,
                'orderItem'], productForm: [2, 'productForm'], order: [3, 'order'], canadianCurrencyCodes: [4,
                'canadianCurrencyCodes'], defaultState: [5, 'defaultState'], disableChanges: [6,
                'disableChanges'], isQuickQuote: [7, 'isQuickQuote'], isPublic: [8, 'isPublic'] }, { onItemRemoved: 'onItemRemoved' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_v.context.index + 1);
        var currVal_1 = _v.context.$implicit;
        var currVal_2 = _co.form;
        var currVal_3 = _co.order;
        var currVal_4 = _co.canadianCurrencyCodes;
        var currVal_5 = (((_co.order.OrderItems.length == 1) && (_v.context.index == 0)) || ((_co.order.OrderItems.length > 1) && ((_co.order.OrderItems.length - 1) == _v.context.index)));
        var currVal_6 = (_co.disableChanges || _co.isUsService);
        var currVal_7 = _co.isQuickQuote;
        var currVal_8 = _co.isPublic;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    }, null);
}
function View_ProductsCardComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class',
                'col-md-2']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [['label', 'Is Ocean'], ['name', 'ocean']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.isOcean = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], form: [2, 'form'], disabled: [3, 'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, [['ocean', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'ocean';
        var currVal_8 = 'Is Ocean';
        var currVal_9 = core_es5["ɵnov"](_v.parent, 6);
        var currVal_10 = _co.disableChanges;
        _ck(_v, 3, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'ocean';
        var currVal_12 = _co.disableChanges;
        var currVal_13 = _co.isOcean;
        _ck(_v, 5, 0, currVal_11, currVal_12, currVal_13);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_ProductsCardComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class',
                'col-md-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [['label', 'One time exemption'], ['name', 'oneTime']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.isOneTime = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_1 = (_co.toggleIsOneTime() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], form: [2, 'form'], disabled: [3, 'disabled'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, [['oneTime', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'oneTime';
        var currVal_8 = 'One time exemption';
        var currVal_9 = core_es5["ɵnov"](_v.parent, 6);
        var currVal_10 = _co.disableChanges;
        _ck(_v, 3, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'oneTime';
        var currVal_12 = _co.disableChanges;
        var currVal_13 = _co.isOneTime;
        _ck(_v, 5, 0, currVal_11, currVal_12, currVal_13);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_ProductsCardComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn btn-round pull-right btn-md-orange btn-wide add-more'], ['type', 'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.addProduct() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Add Product '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'ripple-container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.disableChanges;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ProductsCardComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { productsForm: 0 }), core_es5["ɵqud"](671088640, 2, { calculatorAccordion: 1 }),
        (_l()(), core_es5["ɵeld"](0, null, null, 64, 'div', [['class', 'card']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 61, 'form', [['novalidate',
                '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 6).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 6).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[1, 4], ['productsForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]),
        core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-header header card-header-text'],
                ['data-background-color', '#E07E3C']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'card-title calculator-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'div', [['class', 'tabs pull-right long-tabs']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ProductsCardComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class',
                'simple-tab tab-pane']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setQuote(1) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active-tab': 0, 'disabled': 1 }), (_l()(),
            core_es5["ɵted"](null, ['QUICK QUOTE'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'simple-tab tab-pane second-tab']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setQuote(0) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active-tab': 0,
            'disabled': 1 }), (_l()(), core_es5["ɵted"](null, ['FULL QUOTE '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ProductsCardComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 29, 'div', [['class', 'card-content products']], [[8, 'hidden',
                0]], null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'accordion', [['class',
                'panel-group'], ['role', 'tablist'], ['style', 'display: block']], [[1, 'aria-multiselectable',
                0]], null, null, View_AccordionComponent_0, RenderType_AccordionComponent)),
        core_es5["ɵdid"](49152, null, 0, accordion_component_AccordionComponent, [accordion_config_AccordionConfig], { closeOthers: [0,
                'closeOthers'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ProductsCardComponent_3)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class', 'row card-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_ProductsCardComponent_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ProductsCardComponent_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-6 col-xs-12 pull-right']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ProductsCardComponent_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_8 = _co.isVehicle;
        _ck(_v, 19, 0, currVal_8);
        var currVal_9 = 'simple-tab tab-pane';
        var currVal_10 = _ck(_v, 23, 0, _co.isQuickQuote, (((_co.order.Status >= _co.orderStatus.Paid) || _co.disableChanges) && !_co.isQuickQuote));
        _ck(_v, 22, 0, currVal_9, currVal_10);
        var currVal_11 = 'simple-tab tab-pane second-tab';
        var currVal_12 = _ck(_v, 28, 0, _co.isFullQuote, (((_co.order.Status >= _co.orderStatus.Paid) || _co.disableChanges) && !_co.isFullQuote));
        _ck(_v, 27, 0, currVal_11, currVal_12);
        var currVal_13 = _co.showChangeQuoteSpinner;
        _ck(_v, 33, 0, currVal_13);
        var currVal_16 = true;
        _ck(_v, 42, 0, currVal_16);
        var currVal_17 = _co.order.OrderItems;
        _ck(_v, 45, 0, currVal_17);
        var currVal_18 = (_co.order.CalculatorType == _co.calculatorType.UsaImport);
        _ck(_v, 53, 0, currVal_18);
        var currVal_19 = (_co.order.CalculatorType == _co.calculatorType.UsaImport);
        _ck(_v, 56, 0, currVal_19);
        var currVal_20 = (!_co.isQuickQuote && !_co.isUsService);
        _ck(_v, 61, 0, currVal_20);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (_co.calculatorHelper.isVehicle(_co.order) ? 'VEHICLE LIST' : 'PRODUCT LIST');
        _ck(_v, 13, 0, currVal_7);
        var currVal_14 = _co.showChangeQuoteSpinner;
        _ck(_v, 35, 0, currVal_14);
        var currVal_15 = core_es5["ɵnov"](_v, 42).closeOthers;
        _ck(_v, 41, 0, currVal_15);
    });
}
function View_ProductsCardComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'products-card', [], null, null, null, View_ProductsCardComponent_0, RenderType_ProductsCardComponent)), core_es5["ɵdid"](770048, null, 0, products_card_component_ProductsCardComponent, [CountryService_CountryService, calculator_calculatorService["a" /* CalculatorService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ProductsCardComponentNgFactory = core_es5["ɵccf"]('products-card', products_card_component_ProductsCardComponent, View_ProductsCardComponent_Host_0, { order: 'order', canadianCurrencyCodes: 'canadianCurrencyCodes',
    disableChanges: 'disableChanges', isPublic: 'isPublic' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=products-card.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/tabs/fill-order-tab/fill-order-tab.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
















var styles_FillOrderTabComponent = [];
var RenderType_FillOrderTabComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_FillOrderTabComponent, data: {} });
function View_FillOrderTabComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DecimalPipe"], [core_es5["LOCALE_ID"]]), core_es5["ɵqud"](402653184, 1, { customerCardComponent: 0 }),
        core_es5["ɵqud"](402653184, 2, { locationCardComponent: 0 }), core_es5["ɵqud"](402653184, 3, { productCardComponent: 0 }),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'customer-card', [], null, [[null, 'orderChange'], [null, 'extraDataChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('orderChange' === en)) {
                var pd_0 = ((_co.order = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('extraDataChange' === en)) {
                var pd_1 = ((_co.extraData = $event) !== false);
                ad = (pd_1 && ad);
            }
            if (('extraDataChange' === en)) {
                var pd_2 = (_co.extraDataChange.emit(_co.extraData) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, View_CustomerCardComponent_0, RenderType_CustomerCardComponent)),
        core_es5["ɵdid"](4374528, [[1, 4]], 0, customer_card_component["a" /* CustomerCardComponent */], [services_configService["a" /* ConfigService */], services_extraDataService["a" /* ExtraDataService */],
            router_es5["n" /* Router */], calculator_calculatorService["a" /* CalculatorService */], services_customerService["a" /* CustomerService */]], { order: [0, 'order'], locationCard: [1,
                'locationCard'], extraData: [2, 'extraData'], disableChanges: [3, 'disableChanges'],
            productsCard: [4, 'productsCard'], isPublic: [5, 'isPublic'], isOrderDetails: [6,
                'isOrderDetails'], sendCustomer: [7, 'sendCustomer'] }, { extraDataChange: 'extraDataChange' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'location-card', [], null, [[null, 'orderChange'],
            [null, 'vehicleChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('orderChange' === en)) {
                var pd_0 = ((_co.order = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('vehicleChange' === en)) {
                var pd_1 = ((_co.isVehicle = $event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_LocationCardComponent_0, RenderType_LocationCardComponent)),
        core_es5["ɵdid"](114688, [[2, 4], ['locationCard', 4]], 0, location_card_component_LocationCardComponent, [calculator_calculatorService["a" /* CalculatorService */],
            core_es5["ChangeDetectorRef"], CountryService_CountryService], { order: [0, 'order'], productsCard: [1,
                'productsCard'], canadianCurrencyCodes: [2, 'canadianCurrencyCodes'], disableChanges: [3,
                'disableChanges'] }, { vehicleChange: 'vehicleChange' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'products-card', [], null, [[null, 'orderChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('orderChange' === en)) {
                var pd_0 = ((_co.order = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ProductsCardComponent_0, RenderType_ProductsCardComponent)),
        core_es5["ɵdid"](770048, [[3, 4], ['productsCard', 4]], 0, products_card_component_ProductsCardComponent, [CountryService_CountryService,
            calculator_calculatorService["a" /* CalculatorService */]], { order: [0, 'order'], canadianCurrencyCodes: [1, 'canadianCurrencyCodes'],
            disableChanges: [2, 'disableChanges'], isPublic: [3, 'isPublic'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'col-sm-12 text-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'total']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'blur-content': 0 }), (_l()(), core_es5["ɵted"](null, ['Total Value: ', ''])), core_es5["ɵppd"](2), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-dark-orange btn-round btn-wide'],
            ['type', 'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.goNextTab() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' CONTINUE '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'col-md-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order;
        var currVal_1 = core_es5["ɵnov"](_v, 8);
        var currVal_2 = _co.extraData;
        var currVal_3 = _co.disableChanges;
        var currVal_4 = core_es5["ɵnov"](_v, 11);
        var currVal_5 = _co.isPublic;
        var currVal_6 = _co.isOrderDetails;
        var currVal_7 = _co.sendCustomer;
        _ck(_v, 5, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_8 = _co.order;
        var currVal_9 = core_es5["ɵnov"](_v, 11);
        var currVal_10 = _co.canadianCurrencyCodes;
        var currVal_11 = _co.disableChanges;
        _ck(_v, 8, 0, currVal_8, currVal_9, currVal_10, currVal_11);
        var currVal_12 = _co.order;
        var currVal_13 = _co.canadianCurrencyCodes;
        var currVal_14 = _co.disableChanges;
        var currVal_15 = _co.isPublic;
        _ck(_v, 11, 0, currVal_12, currVal_13, currVal_14, currVal_15);
        var currVal_16 = 'total';
        var currVal_17 = _ck(_v, 19, 0, _co.isUsService);
        _ck(_v, 18, 0, currVal_16, currVal_17);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_18 = ((_co.getTotalCurrencyCode() + ' ') + core_es5["ɵunv"](_v, 20, 0, _ck(_v, 21, 0, core_es5["ɵnov"](_v, 0), _co.countTotal(), '.2-2')));
        _ck(_v, 20, 0, currVal_18);
        var currVal_19 = (_co.submitted && _co.isDisabled);
        _ck(_v, 23, 0, currVal_19);
    });
}
function View_FillOrderTabComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'fill-order-tab', [], null, null, null, View_FillOrderTabComponent_0, RenderType_FillOrderTabComponent)), core_es5["ɵdid"](49152, null, 0, fill_order_tab_component_FillOrderTabComponent, [core_es5["Renderer2"]], null, null)], null, null);
}
var FillOrderTabComponentNgFactory = core_es5["ɵccf"]('fill-order-tab', fill_order_tab_component_FillOrderTabComponent, View_FillOrderTabComponent_Host_0, { order: 'order', canadianCurrencyCodes: 'canadianCurrencyCodes',
    wizard: 'wizard', extraData: 'extraData', disableChanges: 'disableChanges', isPublic: 'isPublic',
    isOrderDetails: 'isOrderDetails', sendCustomer: 'sendCustomer' }, { extraDataChange: 'extraDataChange' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=fill-order-tab.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/objects/common/responseError.ts
var ResponseError = /** @class */ (function () {
    function ResponseError() {
    }
    return ResponseError;
}());

//# sourceMappingURL=responseError.js.map
// CONCATENATED MODULE: ./app/components/common/errorsSummary/errorsSummary.component.ts

var errorsSummary_component_ErrorsSummaryComponent = /** @class */ (function () {
    function ErrorsSummaryComponent() {
    }
    ErrorsSummaryComponent.prototype.getErrors = function () {
        var result = [];
        for (var _i = 0, _a = this.errors; _i < _a.length; _i++) {
            var error = _a[_i];
            if (error instanceof ResponseError && error.Value)
                result = result.concat(error.Value);
            else if (typeof error == "string")
                result.push(error);
        }
        return result;
    };
    return ErrorsSummaryComponent;
}());

//# sourceMappingURL=errorsSummary.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/common/errorsSummary/errorsSummary.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_ErrorsSummaryComponent = [];
var RenderType_ErrorsSummaryComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ErrorsSummaryComponent, data: {} });
function View_ErrorsSummaryComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [['class',
                'text-danger']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_ErrorsSummaryComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ErrorsSummaryComponent_1)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getErrors();
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_ErrorsSummaryComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'errors-summary', [], null, null, null, View_ErrorsSummaryComponent_0, RenderType_ErrorsSummaryComponent)), core_es5["ɵdid"](49152, null, 0, errorsSummary_component_ErrorsSummaryComponent, [], null, null)], null, null);
}
var ErrorsSummaryComponentNgFactory = core_es5["ɵccf"]('errors-summary', errorsSummary_component_ErrorsSummaryComponent, View_ErrorsSummaryComponent_Host_0, { errors: 'errors' }, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL2Vycm9yc1N1bW1hcnkvZXJyb3JzU3VtbWFyeS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL2Vycm9yc1N1bW1hcnkvZXJyb3JzU3VtbWFyeS5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9jb21tb24vZXJyb3JzU3VtbWFyeS9lcnJvcnNTdW1tYXJ5LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL2Vycm9yc1N1bW1hcnkvZXJyb3JzU3VtbWFyeS5jb21wb25lbnQudHMuRXJyb3JzU3VtbWFyeUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjx1bD4gPGxpIGNsYXNzPVwidGV4dC1kYW5nZXJcIiAqbmdGb3I9XCJsZXQgZXJyb3Igb2YgZ2V0RXJyb3JzKClcIj4ge3tlcnJvcn19IDwvbGk+IDwvdWw+ICIsIjxlcnJvcnMtc3VtbWFyeT48L2Vycm9ycy1zdW1tYXJ5PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OztvQkNBSztNQUFBO01BQTBEO0lBQUE7SUFBQTs7OztvQkFBL0Q7TUFBQSx3RUFBSTthQUFBLHVCQUFDO01BQUEsdURBQUE7TUFBQTtVQUFBLDJCQUEwRSxzQ0FBTTthQUFBOztJQUF4RDtJQUF4QixXQUF3QixTQUF4Qjs7OztvQkNBTDtNQUFBO3VDQUFBLFVBQUE7TUFBQTs7OzsifQ==
//# sourceMappingURL=errorsSummary.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/objects/products/currencyEnum.ts
/**
 * Created by alex.y on 9/11/2017.
 */
var CurrencyEnum;
(function (CurrencyEnum) {
    CurrencyEnum[CurrencyEnum["None"] = 0] = "None";
    CurrencyEnum[CurrencyEnum["USD"] = 1] = "USD";
    CurrencyEnum[CurrencyEnum["CAD"] = 2] = "CAD";
})(CurrencyEnum || (CurrencyEnum = {}));
//# sourceMappingURL=currencyEnum.js.map
// EXTERNAL MODULE: ./app/objects/orders/taxType.ts
var orders_taxType = __webpack_require__("TDHu");

// CONCATENATED MODULE: ./app/objects/orders/tax.ts
/**
 * Created by alex.y on 8/8/2017.
 */
var Tax = /** @class */ (function () {
    function Tax() {
        this.Percentage = 0;
        this.Value = 0;
    }
    return Tax;
}());

//# sourceMappingURL=tax.js.map
// EXTERNAL MODULE: ./app/objects/calculator/duty.ts
var calculator_duty = __webpack_require__("l1uE");

// CONCATENATED MODULE: ./app/components/calculator/tabs/calculatorResults/baseCalculatorTab.ts






/**
 * Created by alex.y on 8/11/2017.
 */
var baseCalculatorTab_BaseCalculatorTab = /** @class */ (function () {
    function BaseCalculatorTab() {
        this.locationUtil = LocationUtil["a" /* LocationUtil */];
        this.currencyEnum = CurrencyEnum;
        this.isPublic = false;
        this.taxType = orders_taxType["a" /* TaxType */];
        this.calculatorHelper = calculatorHelper["a" /* CalculatorHelper */];
    }
    BaseCalculatorTab.prototype.findTax = function (taxType, orderItem) {
        var result = orderItem.Total.Taxes.find(function (x) { return x.Type == taxType; });
        if (!result)
            return new Tax();
        return result;
    };
    BaseCalculatorTab.prototype.hasManualDuty = function (orderItem) {
        if (orderItem == null || orderItem.DutyList == null)
            return false;
        for (var _i = 0, _a = orderItem.DutyList; _i < _a.length; _i++) {
            var duty = _a[_i];
            if (duty.DutyType == calculator_duty["b" /* DutyType */].Manual)
                return true;
        }
        return false;
    };
    BaseCalculatorTab.prototype.calculateGrantTotalForItem = function (orderItem, order) {
        return calculatorHelper["a" /* CalculatorHelper */].calculateGrantTotalForItem(orderItem, order);
    };
    BaseCalculatorTab.prototype.getCurrency = function (currency) {
        if (String.isNullOrEmpty(currency)) {
            return 'CAD';
        }
        return currency;
    };
    BaseCalculatorTab.prototype.getCurrencyRate = function (orderItemCurrency, orderCurrency) {
        if (orderCurrency == null)
            return orderItemCurrency.Value;
        if (orderItemCurrency.Code == orderCurrency.Code)
            return 1;
        return orderItemCurrency.Value / orderCurrency.Value;
    };
    BaseCalculatorTab.prototype.getCadValue = function (price, orderItemCurrency, orderCurrency) {
        if (orderCurrency == null)
            return price * orderItemCurrency.Value;
        var rate = orderItemCurrency.Value / orderCurrency.Value;
        if (orderItemCurrency.Code == orderCurrency.Code)
            rate = 1;
        return price * rate;
    };
    BaseCalculatorTab.prototype.findTaxesSum = function (orderItem, taxTypes) {
        if (taxTypes === void 0) { taxTypes = []; }
        var firstTotalTax = 0;
        for (var _i = 0, taxTypes_1 = taxTypes; _i < taxTypes_1.length; _i++) {
            var txtType = taxTypes_1[_i];
            firstTotalTax += this.findTax(txtType, orderItem).Value;
        }
        return firstTotalTax;
    };
    BaseCalculatorTab.prototype.findTaxesPersentSum = function (orderItem, taxTypes) {
        if (taxTypes === void 0) { taxTypes = []; }
        var firstTotalTax = 0;
        for (var _i = 0, taxTypes_2 = taxTypes; _i < taxTypes_2.length; _i++) {
            var txtType = taxTypes_2[_i];
            firstTotalTax += this.findTax(txtType, orderItem).Percentage;
        }
        return firstTotalTax;
    };
    return BaseCalculatorTab;
}());

//# sourceMappingURL=baseCalculatorTab.js.map
// EXTERNAL MODULE: ./app/objects/email/emailTemplateType.ts
var emailTemplateType = __webpack_require__("gE7E");

// CONCATENATED MODULE: ./app/objects/email/EmailRequest.ts
/**
 * Created by vadim.m on 10/23/2017.
 */
var EmailRequest = /** @class */ (function () {
    function EmailRequest(init) {
        Object.assign(this, init);
    }
    return EmailRequest;
}());

//# sourceMappingURL=EmailRequest.js.map
// CONCATENATED MODULE: ./app/common/helpers/tax.helper.ts


var tax_helper_TaxHelper = /** @class */ (function () {
    function TaxHelper() {
    }
    TaxHelper.getItemTax = function (orderItem, taxType) {
        var tax = this.getItemTaxOrNull(orderItem, taxType);
        return tax ? tax : new orders_orderItem["a" /* ItemTax */]();
    };
    TaxHelper.getItemTaxOrNull = function (orderItem, taxType) {
        return orderItem.Taxes.find(function (tax) { return tax.TaxType == taxType; });
    };
    TaxHelper.convertTotalToTaxes = function (value, order) {
        var part = 0;
        if (value > 0)
            part = +value / order.OrderItems.length;
        var total = 0;
        for (var _i = 0, _a = order.OrderItems; _i < _a.length; _i++) {
            var orderItem = _a[_i];
            var tax = orderItem.Taxes.find(function (x) { return x.TaxType == orders_taxType["a" /* TaxType */].AAFee; });
            if (tax != null) {
                tax.Value = part.roundToDigits(2);
                total += tax.Value;
            }
        }
        this.roundLastOrderItem(order, value, total);
        return order;
    };
    TaxHelper.roundLastOrderItem = function (order, aaTotal, newTotal) {
        if (newTotal != aaTotal) {
            var delta = ((+aaTotal).roundToDigits(5) - newTotal.roundToDigits(5)).roundToDigits(3);
            var lastOrderItem = order.OrderItems[order.OrderItems.length - 1];
            var aaFee = TaxHelper.getItemTax(lastOrderItem, orders_taxType["a" /* TaxType */].AAFee);
            if (aaFee) {
                aaFee.Value = (aaFee.Value + delta).roundToDigits(2);
            }
        }
    };
    return TaxHelper;
}());

//# sourceMappingURL=tax.helper.js.map
// CONCATENATED MODULE: ./app/objects/documents/SelfServeFileType.ts
var SelfServeFileType;
(function (SelfServeFileType) {
    SelfServeFileType[SelfServeFileType["BillOfSale"] = 0] = "BillOfSale";
    SelfServeFileType[SelfServeFileType["MSO"] = 1] = "MSO";
    SelfServeFileType[SelfServeFileType["EmissionComplianceLabel"] = 2] = "EmissionComplianceLabel";
    SelfServeFileType[SelfServeFileType["RecallClearanceLetter"] = 3] = "RecallClearanceLetter";
    SelfServeFileType[SelfServeFileType["KelleyBlueBookReport"] = 4] = "KelleyBlueBookReport";
    SelfServeFileType[SelfServeFileType["DeathCertificate"] = 5] = "DeathCertificate";
    SelfServeFileType[SelfServeFileType["B3Form"] = 6] = "B3Form";
})(SelfServeFileType || (SelfServeFileType = {}));
//# sourceMappingURL=SelfServeFileType.js.map
// EXTERNAL MODULE: ./node_modules/rxjs/observable/fromPromise.js
var fromPromise = __webpack_require__("ioK+");
var fromPromise_default = /*#__PURE__*/__webpack_require__.n(fromPromise);

// EXTERNAL MODULE: ./node_modules/rxjs/BehaviorSubject.js
var BehaviorSubject = __webpack_require__("TfWX");
var BehaviorSubject_default = /*#__PURE__*/__webpack_require__.n(BehaviorSubject);

// CONCATENATED MODULE: ./app/components/calculator/tabs/calculator-tab/calculatorTab.component.ts























/**
 * Created by alex.y on 8/10/2017.
 */
var calculatorTab_component_CalculatorTabComponent = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](CalculatorTabComponent, _super);
    function CalculatorTabComponent(toastr, orderService, router, emailService, configService, uploadService) {
        var _this = _super.call(this) || this;
        _this.toastr = toastr;
        _this.orderService = orderService;
        _this.router = router;
        _this.emailService = emailService;
        _this.configService = configService;
        _this.uploadService = uploadService;
        _this.orderChange = new core_es5["EventEmitter"]();
        _this.isPublic = false;
        _this.totalGrand = 0;
        _this.clonedTotalGrand = 0;
        _this.totalPriceBase = 0; //Total price of products before convert to currency
        _this.clonedTotalPriceBase = 0;
        _this.totalPriceInCurrency = 0; //Total price of products after convert but without taxes
        _this.clonedTotalPriceInCurrency = 0;
        _this.totalAACustomsClearanceFee = 0; // Total price of BB fee
        _this.clonedTotalAACustomsClearanceFee = 0;
        _this.percentFee = 0;
        _this.locationUtil = LocationUtil["a" /* LocationUtil */];
        _this.calculatorHelper = calculatorHelper["a" /* CalculatorHelper */];
        _this.currencyEnum = CurrencyEnum;
        _this.taxType = orders_taxType["a" /* TaxType */];
        _this.calculatorType = orders_calculatorType["a" /* CalculatorType */];
        _this.isSpinerVisible = true;
        _this.paypalDisabled = false;
        _this.orderOptions = orderOptions["a" /* OrderOptions */];
        _this.orderStatus = orders_orderStatus["a" /* OrderStatus */];
        _this.isEmailSending = false;
        _this.aaFeeCurrencyCode = null;
        _this.cardRequestLoader = false;
        _this.sentText = false;
        _this.fileName$ = new BehaviorSubject["BehaviorSubject"]('');
        _this.isDisableInviteCustomerButton$ = new BehaviorSubject["BehaviorSubject"](false);
        _this.errorMessages = [];
        return _this;
    }
    Object.defineProperty(CalculatorTabComponent.prototype, "isOrderValid", {
        get: function () {
            return this.errorMessages.length == 0;
        },
        enumerable: true,
        configurable: true
    });
    CalculatorTabComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.validateOrder();
            _this.isSpinerVisible = false;
        });
        Object(fromPromise["fromPromise"])(this.uploadService.getAllFiles(this.order.Id))
            .subscribe(function (resp) {
            var b3File = resp.Data.find(function (i) { return i.Type === SelfServeFileType.B3Form; });
            if (!b3File) {
                return;
            }
            _this.fileName$.next(b3File.Filename);
        });
        this.recalculateTotals();
        if (this.disableChanges)
            this.isSpinerVisible = false;
    };
    CalculatorTabComponent.prototype.recalculateTotals = function () {
        this.totalPriceDefaultCode = calculatorHelper["a" /* CalculatorHelper */].getTotalPriceCurrencyCode(this.order, this.canadianCurrencyCodes);
        this.totalPriceBase = this.onProductsValueChange(this.totalPriceDefaultCode);
        this.totalPriceInCurrency = this.onCustomsValueChange(this.order.Currency);
        this.totalAACustomsClearanceFee = this.recalculateBBClearanceFeeProxy();
        this.totalGrand = this.calculateGrantTotal(this.order.Currency);
        var tempOrder = JSON.parse(JSON.stringify(this.order));
        this.order = JSON.parse(JSON.stringify(this.clonedOrder));
        this.clonedTotalPriceBase = this.onProductsValueChange(this.totalPriceDefaultCode);
        this.clonedTotalPriceInCurrency = this.onCustomsValueChange(this.order.Currency);
        this.clonedTotalAACustomsClearanceFee = this.recalculateBBClearanceFeeProxy();
        this.clonedTotalGrand = this.calculateGrantTotal(this.order.Currency);
        this.order = JSON.parse(JSON.stringify(tempOrder));
    };
    CalculatorTabComponent.prototype.validateOrder = function () {
        this.errorMessages = [];
        if (!this.order) {
            this.errorMessages.push("Order is empty");
            return;
        }
        if (!this.order.Locations || this.order.Locations.length == 0) {
            this.errorMessages.push("No locations specified for order. Can not calculate totals.");
        }
        if (!this.order.Currency)
            this.errorMessages.push("Currency is not specified for order. Can not calculate.");
    };
    CalculatorTabComponent.prototype.onProductsValueChange = function (selectedCode) {
        if (selectedCode == null)
            return;
        return calculatorHelper["a" /* CalculatorHelper */].calculateProductsValue(selectedCode, this.order);
    };
    CalculatorTabComponent.prototype.handleProductsValueChange = function (selectedCode, clone) {
        if (clone === void 0) { clone = false; }
        if (selectedCode == null)
            return;
        this.totalPriceBase = this.onProductsValueChange(selectedCode);
        if (clone)
            this.clonedTotalPriceBase = this.totalPriceBase;
    };
    CalculatorTabComponent.prototype.onCustomsValueChange = function (selectedCode) {
        if (selectedCode == null)
            return;
        return this.calculateCustomsValue(selectedCode);
    };
    CalculatorTabComponent.prototype.handleCustomsValueChange = function (selectedCode, clone) {
        if (clone === void 0) { clone = false; }
        if (selectedCode == null)
            return;
        this.totalPriceInCurrency = this.onCustomsValueChange(selectedCode);
        if (clone)
            this.clonedTotalPriceInCurrency = this.totalPriceInCurrency;
    };
    CalculatorTabComponent.prototype.handleClearanceFeeChange = function (param) {
        if (param.selectedCode == null)
            return;
        this.aaFeeCurrencyCode = param.selectedCode;
        this.totalAACustomsClearanceFee = this.onClearanceFeeChange(param.selectedCode);
        if (param.clone)
            this.clonedTotalAACustomsClearanceFee = this.totalAACustomsClearanceFee;
    };
    CalculatorTabComponent.prototype.onClearanceFeeChange = function (selectedCode) {
        if (selectedCode == null)
            return;
        return this.calculateClearanceFee(selectedCode);
    };
    CalculatorTabComponent.prototype.onBBClearanceFeeChange = function (order) {
        this.order = order;
        this.clonedOrder = JSON.parse(JSON.stringify(this.order));
        this.totalAACustomsClearanceFee = this.recalculateBBClearanceFeeProxy();
        if (orderHelper_OrderHelper.hasOption(this.order, orderOptions["a" /* OrderOptions */].IsBBFeeEdited))
            this.clonedTotalAACustomsClearanceFee = this.totalAACustomsClearanceFee;
        this.orderChange.emit(order);
        this.totalGrand = this.calculateGrantTotal(this.order.Currency);
        this.clonedTotalGrand = this.totalGrand;
    };
    CalculatorTabComponent.prototype.calculateBBClearanceFeeForUsa = function (selectedCode) {
        if (selectedCode == null)
            selectedCode = this.order.Currency;
        var total = 0;
        for (var _i = 0, _a = this.order.OrderItems; _i < _a.length; _i++) {
            var orderItem = _a[_i];
            var aatax = tax_helper_TaxHelper.getItemTaxOrNull(orderItem, orders_taxType["a" /* TaxType */].AAFee);
            if (aatax != null)
                total += (+aatax.Value).roundToDigits(3);
        }
        return total.roundToDigits(3);
    };
    CalculatorTabComponent.prototype.recalculateBBClearanceFeeProxy = function () {
        return this.recalculateBBClearanceFee([
            { calc: this.calculateBBClearanceFeeForCad, type: orders_calculatorType["a" /* CalculatorType */].CanadianImport, args: [this.aaFeeCurrencyCode] },
            { calc: this.calculateBBClearanceFeeForUsa, type: orders_calculatorType["a" /* CalculatorType */].UsaImport, args: [this.aaFeeCurrencyCode] },
            { calc: this.onClearanceFeeChange, type: null, args: [this.order.Currency] },
        ]);
    };
    CalculatorTabComponent.prototype.recalculateBBClearanceFee = function (bbCalculators) {
        var calculatorType = calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(this.order.Locations);
        var isEdited = orderHelper_OrderHelper.hasOption(this.order, orderOptions["a" /* OrderOptions */].IsBBFeeEdited);
        var currentCalculator = bbCalculators.find(function (x) { return x.type == (isEdited == false ? null : calculatorType); });
        if (currentCalculator == null)
            return 0;
        return (_a = currentCalculator.calc).call.apply(_a, [this].concat(currentCalculator.args));
        var _a;
    };
    CalculatorTabComponent.prototype.calculateBBClearanceFeeForCad = function (selectedCode) {
        var total = 0;
        for (var _i = 0, _a = this.order.OrderItems; _i < _a.length; _i++) {
            var orderItem = _a[_i];
            var aatax = tax_helper_TaxHelper.getItemTaxOrNull(orderItem, orders_taxType["a" /* TaxType */].AAFee);
            if (aatax)
                total += aatax.Value.roundToDigits(2);
        }
        return total;
    };
    CalculatorTabComponent.prototype.onGrandTotalChange = function (selectedCode) {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            var isBBFeeEdited, resp, e_1, t;
            return tslib_es6["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (selectedCode == null || this.disableChanges)
                            return [2 /*return*/];
                        this.order.Currency = selectedCode;
                        this.order.CalculatorType = calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(this.order.Locations);
                        isBBFeeEdited = orderHelper_OrderHelper.hasOption(this.order, orderOptions["a" /* OrderOptions */].IsBBFeeEdited);
                        if (!this.isOrderValid)
                            return [2 /*return*/];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.isSpinerVisible = true;
                        if (isBBFeeEdited)
                            this.customsClearanceFee.convertOrderItemsTax([
                                { converter: this.customsClearanceFee.convertToOriginUsa, type: orders_calculatorType["a" /* CalculatorType */].UsaImport },
                                { converter: this.customsClearanceFee.convertToOriginCad, type: orders_calculatorType["a" /* CalculatorType */].CanadianImport }
                            ]);
                        return [4 /*yield*/, this.orderService.update(this.order)];
                    case 2:
                        resp = _a.sent();
                        this.order = resp.Data;
                        this.totalGrand = this.calculateGrantTotal(selectedCode);
                        if (isBBFeeEdited) {
                            this.recalculateTaxesToSelected(this.order);
                            this.totalAACustomsClearanceFee = this.recalculateBBClearanceFeeProxy();
                        }
                        this.clonedOrder = JSON.parse(JSON.stringify(this.order)); //Clone order for check if smth changed
                        this.clonedTotalGrand = this.totalGrand;
                        this.clonedTotalPriceBase = this.totalPriceBase;
                        this.clonedTotalPriceInCurrency = this.totalPriceInCurrency;
                        this.clonedTotalAACustomsClearanceFee = this.totalAACustomsClearanceFee;
                        this.order.CalculatorType = calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(this.order.Locations);
                        this.orderChange.emit(this.order);
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        t = e_1;
                        return [3 /*break*/, 5];
                    case 4:
                        this.isSpinerVisible = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CalculatorTabComponent.prototype.calculateCustomsValue = function (selectedCode) {
        var total = 0;
        if (selectedCode == null) {
            return total;
        }
        for (var _i = 0, _a = this.order.OrderItems; _i < _a.length; _i++) {
            var orderItem = _a[_i];
            total += orderItem.Price * orderItem.CanadianCurrencyCode.Value; //convert to canadian
        }
        return total / selectedCode.Value;
    };
    CalculatorTabComponent.prototype.calculateClearanceFee = function (selectedCode) {
        var total = 0;
        var rate = 1;
        if (selectedCode.Code != this.order.Currency.Code) {
            rate = this.order.Currency.Value;
        }
        for (var _i = 0, _a = this.order.OrderItems; _i < _a.length; _i++) {
            var orderItem = _a[_i];
            total += this.findTax(orders_taxType["a" /* TaxType */].AAFee, orderItem).Value * rate;
        }
        if (selectedCode.Code == this.order.Currency.Code) {
            return total;
        }
        return total / selectedCode.Value;
    };
    CalculatorTabComponent.prototype.calculateGrantTotal = function (selectedCode) {
        var total = 0;
        for (var _i = 0, _a = this.order.OrderItems; _i < _a.length; _i++) {
            var orderItem = _a[_i];
            total += this.calculateGrantTotalForItem(orderItem, this.order);
        }
        return total;
    };
    //public sendCreditCardRequest(order: Order){
    //    this.cardRequestLoader = true;
    //    let request = new EmailRequest({
    //        EmailType: EmailTemplateType.CreditCardRequest,
    //        OrderId: order.Id
    //    });
    //    this.emailService.sendPaymentEmail(request).then(resp => {
    //        if(resp.Success){
    //            this.cardRequestLoader = false;
    //            this.sentText = true;
    //        }
    //    })
    //}
    CalculatorTabComponent.prototype.goToOrderDetail = function () {
        var _this = this;
        this.order.Status = orders_orderStatus["a" /* OrderStatus */].Quoted;
        this.orderChange.emit(this.order);
        if (orderHelper_OrderHelper.hasOption(this.order, orderOptions["a" /* OrderOptions */].IsBBFeeEdited))
            this.recalculateTaxes(this.order);
        this.orderService.modify(this.order).then(function (x) {
            if (!x.Data)
                return;
            document.getElementById('mainPanel').scrollTop = 0;
            _this.clonedOrder = JSON.parse(JSON.stringify(_this.order)); //Clone order for check if smth changed
            _this.order = x.Data;
            _this.order.CalculatorType = calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(_this.order.Locations);
            if (orderHelper_OrderHelper.hasOption(_this.order, orderOptions["a" /* OrderOptions */].IsBBFeeEdited))
                _this.recalculateTaxesToSelected(_this.order);
            _this.orderChange.emit(_this.order);
            if (_this.isOrderDetails == true) {
                setTimeout(function () {
                    _this.orderDataComp.selectTab(1);
                    _this.wizard.nextTab();
                }, 200);
            }
            else
                _this.router.navigate(['order', _this.order.Id]);
        });
    };
    CalculatorTabComponent.prototype.sendOrderToCustomer = function (orderId) {
        var _this = this;
        this.isEmailSending = true;
        this.emailService.sendOrderToCustomer(new EmailRequest({ OrderId: orderId, EmailType: emailTemplateType["a" /* EmailTemplateType */].OrderToCustomer, Comment: this.comment })).then(function (x) {
            _this.toastr.success("Sending mail succeeded");
            _this.comment = "";
            _this.isEmailSending = false;
        }).catch(function () {
            _this.toastr.error("Sending mail failed");
            _this.isEmailSending = false;
        });
    };
    CalculatorTabComponent.prototype.createOrder = function (isOpenPayPal) {
        if (isOpenPayPal === void 0) { isOpenPayPal = false; }
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            var googleWindow, response, e_2;
            return tslib_es6["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        googleWindow = window.open(window.location.origin + "/paymentredirect");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.paypalDisabled = true;
                        return [4 /*yield*/, this.orderService.createInvoice(this.order.Id)];
                    case 2:
                        response = _a.sent();
                        if (isOpenPayPal && response.Data) {
                            googleWindow.location.replace(this.configService.config.PayPalUrl + "/invoice/payerView/details/" + response.Data.Invoice.Id);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        e_2 = _a.sent();
                        console.log(e_2);
                        return [3 /*break*/, 5];
                    case 4:
                        this.paypalDisabled = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CalculatorTabComponent.prototype.calculatePercentFee = function () {
        if (this.customsClearanceFee == null || this.customsClearanceFee.currentCurrencyCode == null || String.isNullOrEmpty(this.customsClearanceFee.currentCurrencyCode.Id))
            return 0;
        var firstCardConvertedValue = this.onProductsValueChange(this.customsClearanceFee.currentCurrencyCode);
        if (this.totalPriceBase !== 0)
            return this.totalAACustomsClearanceFee * 100 / firstCardConvertedValue;
        return null;
    };
    CalculatorTabComponent.prototype.recalculateTaxes = function (order) {
        this.order = order;
        // i think i should do it only for non cad/usd currency
        this.customsClearanceFee.convertOrderItemsTaxTest([
            { converter: this.customsClearanceFee.convertToOriginUsa, type: orders_calculatorType["a" /* CalculatorType */].UsaImport },
            { converter: this.customsClearanceFee.convertToOriginCad, type: orders_calculatorType["a" /* CalculatorType */].CanadianImport }
        ], this.order);
        this.orderChange.emit(this.order);
    };
    CalculatorTabComponent.prototype.recalculateTaxesToSelected = function (order) {
        this.order = order;
        // i think i should do it only for non cad/usd currency
        this.customsClearanceFee.convertOrderItemsTaxTest([
            { converter: this.customsClearanceFee.convertToSelectedUsd, type: orders_calculatorType["a" /* CalculatorType */].UsaImport },
            { converter: this.customsClearanceFee.convertToSelectedCad, type: orders_calculatorType["a" /* CalculatorType */].CanadianImport }
        ], this.order);
        this.orderChange.emit(this.order);
    };
    CalculatorTabComponent.prototype.uploadB3Form = function (file) {
        var _this = this;
        if (!file) {
            return;
        }
        this.uploadService
            .uploadFile(this.order.Id, SelfServeFileType.B3Form, file)
            .subscribe(function (resp) {
            _this.fileName$.next(file.name);
            _this.toastr.success("B3 form was successfully added to shipment #" + _this.order.Id);
        });
    };
    CalculatorTabComponent.prototype.sendInviteCustomerEmail = function () {
        var _this = this;
        this.isDisableInviteCustomerButton$.next(true);
        this.emailService
            .inviteCustomerToSelfServeApp(this.order.Customer.Email)
            .then(function () {
            _this.toastr.success('Invite email was sent');
            _this.isDisableInviteCustomerButton$.next(false);
        }, function (reject) {
            _this.toastr.error(reject.Data.Message || reject.Data);
            _this.isDisableInviteCustomerButton$.next(false);
        });
    };
    CalculatorTabComponent.ctorParameters = function () { return [{ type: ng2_toastr["ToastsManager"] }, { type: services_orderService["a" /* OrderService */] }, { type: router_es5["n" /* Router */] }, { type: services_emailService["a" /* EmailService */] }, { type: services_configService["a" /* ConfigService */] }, { type: uploadService_UploadService }]; };
    return CalculatorTabComponent;
}(baseCalculatorTab_BaseCalculatorTab));

//# sourceMappingURL=calculatorTab.component.js.map
// EXTERNAL MODULE: ./app/objects/currencyExchange/canadianCurrencyCode.ts
var canadianCurrencyCode = __webpack_require__("3Ddi");

// CONCATENATED MODULE: ./app/components/calculator/cards/currency-card/currency-card.component.ts


/**
 * Created by vlad.p on 9/14/2017.
 */
var currency_card_component_CurrencyCardComponent = /** @class */ (function () {
    function CurrencyCardComponent() {
        this.currencyChanged = new core_es5["EventEmitter"]();
        this.showHighlight = false;
        this.currentCurrencyCode = new canadianCurrencyCode["a" /* CanadianCurrencyCode */]();
    }
    CurrencyCardComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.currentCurrencyCode = _this.getDefaultCurrencyCode();
        });
    };
    CurrencyCardComponent.prototype.getDefaultCurrencyCode = function () {
        var _this = this;
        if (this.defaultCurrencyCode == null)
            return null;
        return this.canadianCurrencyCodes.find(function (x) { return x.Code == _this.defaultCurrencyCode.Code; });
    };
    CurrencyCardComponent.prototype.convert = function (selectedCode) {
        this.currencyChanged.emit(selectedCode);
    };
    return CurrencyCardComponent;
}());

//# sourceMappingURL=currency-card.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/cards/currency-card/currency-card.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_CurrencyCardComponent = [];
var RenderType_CurrencyCardComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CurrencyCardComponent, data: {} });
function View_CurrencyCardComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'option', [], [[8, 'selected', 0]], null, null, null, null)),
        core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"], core_es5["Renderer2"],
            [2, forms_es5["SelectControlValueAccessor"]]], { ngValue: [0, 'ngValue'] }, null),
        core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], { ngValue: [0, 'ngValue'] }, null), (_l()(), core_es5["ɵted"](null, [' ',
            ' ']))], function (_ck, _v) {
        var currVal_1 = _v.context.$implicit;
        _ck(_v, 1, 0, currVal_1);
        var currVal_2 = _v.context.$implicit;
        _ck(_v, 2, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_v.context.$implicit.Id == ((_co.currentCurrencyCode == null) ? null : _co.currentCurrencyCode.Id));
        _ck(_v, 0, 0, currVal_0);
        var currVal_3 = _v.context.$implicit.Name;
        _ck(_v, 3, 0, currVal_3);
    });
}
function View_CurrencyCardComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [['class',
                'percent']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', '% '])), core_es5["ɵppd"](2)], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent, 0), _co.percentFee, '.2-2'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CurrencyCardComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DecimalPipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](0, null, null, 45, 'div', [['class', 'text-center calc-tab small-tab']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'red-shadow': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 31, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 28, 'div', [['class',
                '']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'cost']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-md-6 currency']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'select', [['class',
                'form-control'], ['name', 'currency']], [[2, 'ng-untouched', null], [2,
                'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 23).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 23).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.currentCurrencyCode = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_3 = (_co.convert($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[8, null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CurrencyCardComponent_1)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'col-md-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' '])), core_es5["ɵppd"](2), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CurrencyCardComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'text-center calc-tab small-tab';
        var currVal_1 = _ck(_v, 3, 0, _co.showHighlight);
        _ck(_v, 2, 0, currVal_0, currVal_1);
        var currVal_10 = 'currency';
        var currVal_11 = _co.disableChanges;
        var currVal_12 = _co.currentCurrencyCode;
        _ck(_v, 25, 0, currVal_10, currVal_11, currVal_12);
        var currVal_13 = _co.canadianCurrencyCodes;
        _ck(_v, 30, 0, currVal_13);
        var currVal_15 = _co.percentFee;
        _ck(_v, 41, 0, currVal_15);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.title;
        _ck(_v, 10, 0, currVal_2);
        var currVal_3 = core_es5["ɵnov"](_v, 27).ngClassUntouched;
        var currVal_4 = core_es5["ɵnov"](_v, 27).ngClassTouched;
        var currVal_5 = core_es5["ɵnov"](_v, 27).ngClassPristine;
        var currVal_6 = core_es5["ɵnov"](_v, 27).ngClassDirty;
        var currVal_7 = core_es5["ɵnov"](_v, 27).ngClassValid;
        var currVal_8 = core_es5["ɵnov"](_v, 27).ngClassInvalid;
        var currVal_9 = core_es5["ɵnov"](_v, 27).ngClassPending;
        _ck(_v, 22, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9);
        var currVal_14 = core_es5["ɵunv"](_v, 37, 0, _ck(_v, 38, 0, core_es5["ɵnov"](_v, 0), _co.total, '.2-2'));
        _ck(_v, 37, 0, currVal_14);
    });
}
function View_CurrencyCardComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'currency-card', [], null, null, null, View_CurrencyCardComponent_0, RenderType_CurrencyCardComponent)), core_es5["ɵdid"](4243456, null, 0, currency_card_component_CurrencyCardComponent, [], null, null)], null, null);
}
var CurrencyCardComponentNgFactory = core_es5["ɵccf"]('currency-card', currency_card_component_CurrencyCardComponent, View_CurrencyCardComponent_Host_0, { order: 'order', title: 'title',
    total: 'total', percentFee: 'percentFee', canadianCurrencyCodes: 'canadianCurrencyCodes',
    defaultCurrencyCode: 'defaultCurrencyCode', disableChanges: 'disableChanges',
    showHighlight: 'showHighlight' }, { currencyChanged: 'currencyChanged' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=currency-card.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/calculator/cards/currency-card/clearance-option/clearance-option.component.ts



var clearance_option_component_ClearanceOptionComponent = /** @class */ (function () {
    function ClearanceOptionComponent() {
        this.valueChanged = new core_es5["EventEmitter"]();
    }
    Object.defineProperty(ClearanceOptionComponent.prototype, "bbFeeTax", {
        get: function () {
            return tax_helper_TaxHelper.getItemTaxOrNull(this.orderItem, orders_taxType["a" /* TaxType */].AAFee);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClearanceOptionComponent.prototype, "bbFeeValue", {
        get: function () {
            var tax = this.bbFeeTax;
            return !tax ? 0 : tax.Value.roundToDigits(2);
        },
        set: function (value) {
            var tax = this.bbFeeTax;
            tax.Value = +value;
        },
        enumerable: true,
        configurable: true
    });
    ClearanceOptionComponent.prototype.isValid = function () {
        return this.orderItemsFrom.valid;
    };
    return ClearanceOptionComponent;
}());

//# sourceMappingURL=clearance-option.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/cards/currency-card/clearance-option/clearance-option.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */







var styles_ClearanceOptionComponent = [];
var RenderType_ClearanceOptionComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ClearanceOptionComponent, data: {} });
function View_ClearanceOptionComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Total is required. ']))], null, null);
}
function View_ClearanceOptionComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Total should contain only digits. ']))], null, null);
}
function View_ClearanceOptionComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, FirstKeyPipe, []), core_es5["ɵqud"](402653184, 1, { orderItemsFrom: 0 }),
        (_l()(), core_es5["ɵeld"](0, null, null, 39, 'div', [['class', 'clearance-options']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-6 index']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'brand']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 30, 'div', [['class',
                'col-xs-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 27, 'form', [['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 14).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 14).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[1, 4], ['orderItemsFrom', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'li', [['role', 'menuitem']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'form-input', [['name',
                'total'], ['pattern', '^[0-9]+([,.][0-9]{1,2})?$'], ['required', ''], ['type',
                'number']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.bbFeeValue = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('input' === en)) {
                var pd_1 = (_co.valueChanged.emit($event.target.value) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['bbFeeInput',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], form: [2, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_ClearanceOptionComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_ClearanceOptionComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_17 = '';
        _ck(_v, 21, 0, currVal_17);
        var currVal_18 = '^[0-9]+([,.][0-9]{1,2})?$';
        _ck(_v, 22, 0, currVal_18);
        var currVal_19 = 'number';
        var currVal_20 = 'total';
        var currVal_21 = core_es5["ɵnov"](_v, 14);
        _ck(_v, 24, 0, currVal_19, currVal_20, currVal_21);
        var currVal_22 = 'total';
        var currVal_23 = _co.bbFeeValue;
        _ck(_v, 26, 0, currVal_22, currVal_23);
        var currVal_24 = (core_es5["ɵunv"](_v, 31, 0, _ck(_v, 32, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 24).model.errors)) == 'required');
        _ck(_v, 31, 0, currVal_24);
        var currVal_25 = ((core_es5["ɵunv"](_v, 35, 0, _ck(_v, 36, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 24).model.errors)) == 'pattern') && _co.bbFeeValue);
        _ck(_v, 35, 0, currVal_25);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ('Product #' + _co.index);
        _ck(_v, 7, 0, currVal_0);
        var currVal_1 = core_es5["ɵnov"](_v, 16).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 16).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 16).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 16).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 16).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 16).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 16).ngClassPending;
        _ck(_v, 12, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_8 = (core_es5["ɵnov"](_v, 21).required ? '' : null);
        var currVal_9 = (core_es5["ɵnov"](_v, 22).pattern ? core_es5["ɵnov"](_v, 22).pattern : null);
        var currVal_10 = core_es5["ɵnov"](_v, 28).ngClassUntouched;
        var currVal_11 = core_es5["ɵnov"](_v, 28).ngClassTouched;
        var currVal_12 = core_es5["ɵnov"](_v, 28).ngClassPristine;
        var currVal_13 = core_es5["ɵnov"](_v, 28).ngClassDirty;
        var currVal_14 = core_es5["ɵnov"](_v, 28).ngClassValid;
        var currVal_15 = core_es5["ɵnov"](_v, 28).ngClassInvalid;
        var currVal_16 = core_es5["ɵnov"](_v, 28).ngClassPending;
        _ck(_v, 20, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16);
    });
}
function View_ClearanceOptionComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'clearance-option', [], null, null, null, View_ClearanceOptionComponent_0, RenderType_ClearanceOptionComponent)), core_es5["ɵdid"](49152, null, 0, clearance_option_component_ClearanceOptionComponent, [], null, null)], null, null);
}
var ClearanceOptionComponentNgFactory = core_es5["ɵccf"]('clearance-option', clearance_option_component_ClearanceOptionComponent, View_ClearanceOptionComponent_Host_0, { orderItem: 'orderItem',
    form: 'form', index: 'index' }, { valueChanged: 'valueChanged' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=clearance-option.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/common/decorators/round.decorator.ts
function RoundDecimal(digits) {
    return function (target, key, descriptor) {
        var originalMethod = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var result = originalMethod.call.apply(originalMethod, [this].concat(args));
            if (!result)
                return result;
            if (isNaN(result))
                return result;
            return (+result).roundToDigits(digits);
        };
    };
}
//# sourceMappingURL=round.decorator.js.map
// CONCATENATED MODULE: ./app/components/calculator/cards/currency-card/clearance-fee-card.component.ts












var clearance_fee_card_component_ClearanceFeeCardComponent = /** @class */ (function () {
    function ClearanceFeeCardComponent(orderService) {
        this.orderService = orderService;
        this.currencyChanged = new core_es5["EventEmitter"]();
        this.showHighlight = false;
        this.orderChangeEmit = new core_es5["EventEmitter"]();
        this.aaFeeChangeEmit = new core_es5["EventEmitter"]();
        this.currentCurrencyCode = new canadianCurrencyCode["a" /* CanadianCurrencyCode */]();
        this.isDropDownShown = false;
        this.localTotal = 0;
        this.calculatorHelper = calculatorHelper["a" /* CalculatorHelper */];
        this.originCurrencyCode = null;
        this.isChanging = false;
    }
    ClearanceFeeCardComponent.prototype.ngOnChanges = function (changes) {
        if (changes['order'] && changes['order'].previousValue != changes['order'].currentValue) {
            var hasTaxes = true;
            for (var _i = 0, _a = this.order.OrderItems; _i < _a.length; _i++) {
                var oi = _a[_i];
                var aaTax = tax_helper_TaxHelper.getItemTaxOrNull(oi, orders_taxType["a" /* TaxType */].AAFee);
                if (!aaTax)
                    hasTaxes = false;
            }
            if (hasTaxes == true)
                return;
            this.recalculateTotal();
            this.convertOrderItemsTax([
                { converter: this.convertToSelectedUsd, type: orders_calculatorType["a" /* CalculatorType */].UsaImport },
                { converter: this.convertToSelectedCad, type: orders_calculatorType["a" /* CalculatorType */].CanadianImport, extraParams: [true] }
            ]);
        }
    };
    ClearanceFeeCardComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.currentCurrencyCode = _this.getDefaultCurrencyCode();
            _this.originCurrencyCode = _this.getDefaultCurrencyCode();
            _this.currencyChanged.emit({ selectedCode: _this.currentCurrencyCode, clone: false });
            _this.recalculateTotal();
            _this.convertOrderItemsTax([
                { converter: _this.convertToSelectedUsd, type: orders_calculatorType["a" /* CalculatorType */].UsaImport },
                { converter: _this.convertToSelectedCad, type: orders_calculatorType["a" /* CalculatorType */].CanadianImport, extraParams: [true] }
            ]);
            _this.orderChangeEmit.emit(_this.order);
        });
    };
    ClearanceFeeCardComponent.prototype.recalculateTotal = function (forceChange) {
        if (forceChange === void 0) { forceChange = false; }
        var totalFromTaxes = 0;
        for (var _i = 0, _a = this.order.OrderItems; _i < _a.length; _i++) {
            var oi = _a[_i];
            var bbFeeTax = tax_helper_TaxHelper.getItemTaxOrNull(oi, orders_taxType["a" /* TaxType */].AAFee);
            if (bbFeeTax != null && (orderHelper_OrderHelper.hasOption(this.order, orderOptions["a" /* OrderOptions */].IsBBFeeEdited) || forceChange)) {
                if (bbFeeTax.Value >= 0)
                    totalFromTaxes += bbFeeTax.Value;
            }
            else {
                var aaFee = oi.Total.Taxes.find(function (x) { return x.Type == orders_taxType["a" /* TaxType */].AAFee; });
                var newTax = this.getNewTax(aaFee);
                if (bbFeeTax == null)
                    oi.Taxes.push(newTax);
                else
                    bbFeeTax.Value = newTax.Value;
            }
        }
        totalFromTaxes = totalFromTaxes.roundToDigits(3);
        if (orderHelper_OrderHelper.hasOption(this.order, orderOptions["a" /* OrderOptions */].IsBBFeeEdited) || forceChange) {
            this.total = totalFromTaxes;
            this.aaFeeChangeEmit.emit(this.total);
        }
        return totalFromTaxes;
    };
    ClearanceFeeCardComponent.prototype.getNewTax = function (value) {
        return new orders_orderItem["a" /* ItemTax */]({
            TaxType: orders_taxType["a" /* TaxType */].AAFee,
            Value: value == null ? 0 : value.Value
        });
    };
    ClearanceFeeCardComponent.prototype.getDefaultCurrencyCode = function () {
        var _this = this;
        if (this.defaultCurrencyCode == null)
            return null;
        return this.canadianCurrencyCodes.find(function (x) { return x.Code == _this.defaultCurrencyCode.Code; });
    };
    ClearanceFeeCardComponent.prototype.onDropDownHidden = function () {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            var recalculatedTotal, result;
            return tslib_es6["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        recalculatedTotal = this.recalculateTotal(true);
                        if (this.localTotal.roundToDigits(2) == recalculatedTotal.roundToDigits(2)) {
                            this.isDropDownShown = !this.isDropDownShown;
                            return [2 /*return*/];
                        }
                        this.isChanging = true;
                        this.convertOrderItemsTax([
                            { converter: this.convertToOriginUsa, type: orders_calculatorType["a" /* CalculatorType */].UsaImport },
                            { converter: this.convertToOriginCad, type: orders_calculatorType["a" /* CalculatorType */].CanadianImport }
                        ]);
                        this.order.Flag |= orderOptions["a" /* OrderOptions */].IsBBFeeEdited;
                        return [4 /*yield*/, this.orderService.update(this.order)];
                    case 1:
                        result = _a.sent();
                        this.order = result.Data;
                        this.convertOrderItemsTax([
                            { converter: this.convertToSelectedUsd, type: orders_calculatorType["a" /* CalculatorType */].UsaImport },
                            { converter: this.convertToSelectedCad, type: orders_calculatorType["a" /* CalculatorType */].CanadianImport }
                        ]);
                        this.order.CalculatorType = calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(this.order.Locations);
                        this.orderChangeEmit.emit(this.order);
                        this.isDropDownShown = !this.isDropDownShown;
                        this.isChanging = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ClearanceFeeCardComponent.prototype.convertOrderItemsTax = function (converters) {
        var _this = this;
        this.order.OrderItems.forEach(function (orderItem) {
            var aaTax = tax_helper_TaxHelper.getItemTaxOrNull(orderItem, orders_taxType["a" /* TaxType */].AAFee);
            if (aaTax == null)
                return;
            var calculatorType = calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(_this.order.Locations);
            var converter = converters.find(function (x) { return x.type == calculatorType; });
            if (converter == null)
                return;
            aaTax.Value = (_a = converter.converter).call.apply(_a, [_this, aaTax.Value].concat(converter.extraParams));
            var _a;
        });
    };
    ClearanceFeeCardComponent.prototype.convertOrderItemsTaxTest = function (converters, order) {
        this.order = order;
        this.convertOrderItemsTax(converters);
    };
    ClearanceFeeCardComponent.prototype.convertToOriginUsa = function (value) {
        if (this.currentCurrencyCode.Name.toLowerCase() == 'usd')
            return value;
        var usdToCad = this.canadianCurrencyCodes.find(function (x) { return x.Code == 'FXUSDCAD'; }).Value;
        var total = value * this.currentCurrencyCode.Value; // to CAD
        total = total / usdToCad; // USD
        return total;
    };
    ClearanceFeeCardComponent.prototype.convertToOriginCad = function (value) {
        if (this.currentCurrencyCode.Name.toLowerCase() == 'cad')
            return value;
        return value * this.currentCurrencyCode.Value;
    };
    ClearanceFeeCardComponent.prototype.convertToSelectedCad = function (value, forceConvert) {
        if (forceConvert === void 0) { forceConvert = false; }
        if (!this.order || !this.order.Currency || !this.currentCurrencyCode || !this.currentCurrencyCode.Code)
            return value;
        if (this.order.Currency.Name.toLowerCase() != 'cad')
            forceConvert = true;
        if (this.currentCurrencyCode.Code == this.order.Currency.Code && !forceConvert)
            return value;
        return value / this.currentCurrencyCode.Value; // convert CAD to selected
    };
    ClearanceFeeCardComponent.prototype.convertToSelectedUsd = function (value) {
        if (!this.order || !this.order.Currency || !this.currentCurrencyCode || !this.currentCurrencyCode.Code)
            return value;
        var isCurrentCodeUsd = this.currentCurrencyCode.Name.toLowerCase() == 'usd';
        if (isCurrentCodeUsd)
            return value;
        var usdToCad = this.canadianCurrencyCodes.find(function (x) { return x.Code == 'FXUSDCAD'; }).Value;
        var total = value * usdToCad; // CAD VALUE
        total = total / this.currentCurrencyCode.Value; // TO SELECTED
        return total;
    };
    ClearanceFeeCardComponent.prototype.onDropDownShown = function () {
        this.isDropDownShown = !this.isDropDownShown;
        this.total = this.total.roundToDigits(2);
        this.localTotal = this.total;
    };
    ClearanceFeeCardComponent.prototype.hideDropDown = function () {
        if (this.isDropDownShown == false)
            return;
        if (!this.optionsFrom.valid || this.clearanceOptions.find(function (x) { return x.isValid() == false; }) != null)
            return;
        this.dropdownDirective.hide();
    };
    ClearanceFeeCardComponent.prototype.handleTotalChange = function (value) {
        var part = 0;
        if (value > 0)
            part = +value / this.order.OrderItems.length;
        var total = 0;
        for (var _i = 0, _a = this.order.OrderItems; _i < _a.length; _i++) {
            var orderItem = _a[_i];
            var tax = orderItem.Taxes.find(function (x) { return x.TaxType == orders_taxType["a" /* TaxType */].AAFee; });
            if (tax != null) {
                tax.Value = part.roundToDigits(2);
                total += tax.Value;
            }
        }
        this.roundLastOrderItem();
    };
    ClearanceFeeCardComponent.prototype.roundLastOrderItem = function () {
        var total = 0;
        this.order.OrderItems.forEach(function (oi) {
            var tax = tax_helper_TaxHelper.getItemTaxOrNull(oi, orders_taxType["a" /* TaxType */].AAFee);
            if (tax != null)
                total += tax.Value;
        });
        if (total != this.total) {
            var delta = ((+this.total).roundToDigits(5) - total.roundToDigits(5)).roundToDigits(3);
            var lastOrderItem = this.order.OrderItems[this.order.OrderItems.length - 1];
            var aaFee = tax_helper_TaxHelper.getItemTax(lastOrderItem, orders_taxType["a" /* TaxType */].AAFee);
            if (aaFee) {
                aaFee.Value = (aaFee.Value + delta).roundToDigits(2);
            }
        }
    };
    ClearanceFeeCardComponent.prototype.convert = function (selectedCode) {
        var _this = this;
        this.currencyChanged.emit({ selectedCode: selectedCode, clone: true });
        setTimeout(function () {
            _this.handleTotalChange(_this.total);
            _this.recalculateTotal();
        });
    };
    ClearanceFeeCardComponent.ctorParameters = function () { return [{ type: services_orderService["a" /* OrderService */] }]; };
    tslib_es6["b" /* __decorate */]([
        RoundDecimal(3),
        tslib_es6["e" /* __metadata */]("design:type", Function),
        tslib_es6["e" /* __metadata */]("design:paramtypes", [Number]),
        tslib_es6["e" /* __metadata */]("design:returntype", Number)
    ], ClearanceFeeCardComponent.prototype, "convertToOriginUsa", null);
    tslib_es6["b" /* __decorate */]([
        RoundDecimal(3),
        tslib_es6["e" /* __metadata */]("design:type", Function),
        tslib_es6["e" /* __metadata */]("design:paramtypes", [Number]),
        tslib_es6["e" /* __metadata */]("design:returntype", Number)
    ], ClearanceFeeCardComponent.prototype, "convertToOriginCad", null);
    tslib_es6["b" /* __decorate */]([
        RoundDecimal(3),
        tslib_es6["e" /* __metadata */]("design:type", Function),
        tslib_es6["e" /* __metadata */]("design:paramtypes", [Number, Boolean]),
        tslib_es6["e" /* __metadata */]("design:returntype", Number)
    ], ClearanceFeeCardComponent.prototype, "convertToSelectedCad", null);
    tslib_es6["b" /* __decorate */]([
        RoundDecimal(3),
        tslib_es6["e" /* __metadata */]("design:type", Function),
        tslib_es6["e" /* __metadata */]("design:paramtypes", [Number]),
        tslib_es6["e" /* __metadata */]("design:returntype", Number)
    ], ClearanceFeeCardComponent.prototype, "convertToSelectedUsd", null);
    return ClearanceFeeCardComponent;
}());

//# sourceMappingURL=clearance-fee-card.component.js.map
// CONCATENATED MODULE: ./app/common/directives/click-outside.directive.ts

var click_outside_directive_ClickOutsideDirective = /** @class */ (function () {
    function ClickOutsideDirective(elementRef) {
        this.elementRef = elementRef;
        this.clickOutside = new core_es5["EventEmitter"]();
    }
    ClickOutsideDirective.prototype.onDocumentClick = function (event) {
        var targetElement = event.target;
        // Check if the click was outside the element
        if (targetElement && !this.elementRef.nativeElement.contains(targetElement)) {
            this.clickOutside.emit(event);
        }
    };
    ClickOutsideDirective.ctorParameters = function () { return [{ type: core_es5["ElementRef"] }]; };
    return ClickOutsideDirective;
}());

//# sourceMappingURL=click-outside.directive.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/cards/currency-card/clearance-fee-card.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */

















var styles_ClearanceFeeCardComponent = [];
var RenderType_ClearanceFeeCardComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ClearanceFeeCardComponent, data: {} });
function View_ClearanceFeeCardComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'edited']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class',
                'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['mode_edit'])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_ClearanceFeeCardComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [['class',
                'percent']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' (', '%) '])), core_es5["ɵppd"](2)], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent, 0), _co.percentFee, '.2-2'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_ClearanceFeeCardComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'option', [], [[8, 'selected', 0]], null, null, null, null)),
        core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"], core_es5["Renderer2"],
            [2, forms_es5["SelectControlValueAccessor"]]], { ngValue: [0, 'ngValue'] }, null),
        core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], { ngValue: [0, 'ngValue'] }, null), (_l()(), core_es5["ɵted"](null, [' ',
            ' ']))], function (_ck, _v) {
        var currVal_1 = _v.context.$implicit;
        _ck(_v, 1, 0, currVal_1);
        var currVal_2 = _v.context.$implicit;
        _ck(_v, 2, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_v.context.$implicit.Id == ((_co.currentCurrencyCode == null) ? null : _co.currentCurrencyCode.Id));
        _ck(_v, 0, 0, currVal_0);
        var currVal_3 = _v.context.$implicit.Name;
        _ck(_v, 3, 0, currVal_3);
    });
}
function View_ClearanceFeeCardComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' ', ' '])), core_es5["ɵppd"](2)], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent, 0), _co.total, '.2-2'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_ClearanceFeeCardComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' ', ' ']))], null, function (_ck, _v) {
        var currVal_0 = 0;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_ClearanceFeeCardComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Total is required. ']))], null, null);
}
function View_ClearanceFeeCardComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Total should contain only digits. ']))], null, null);
}
function View_ClearanceFeeCardComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 17, 'form-input', [['name', 'total'], ['pattern', '^[0-9]+([,.][0-9]{1,2})?$'], ['required', ''], ['type',
                'number']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.total = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('input' === en)) {
                var pd_1 = (_co.handleTotalChange($event.target.value) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['totalModal',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], form: [2, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, 0, 2, null, View_ClearanceFeeCardComponent_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_ClearanceFeeCardComponent_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_9 = '';
        _ck(_v, 1, 0, currVal_9);
        var currVal_10 = '^[0-9]+([,.][0-9]{1,2})?$';
        _ck(_v, 2, 0, currVal_10);
        var currVal_11 = 'number';
        var currVal_12 = 'total';
        var currVal_13 = core_es5["ɵnov"](_v.parent, 49);
        _ck(_v, 4, 0, currVal_11, currVal_12, currVal_13);
        var currVal_14 = 'total';
        var currVal_15 = _co.total;
        _ck(_v, 6, 0, currVal_14, currVal_15);
        var currVal_16 = (core_es5["ɵunv"](_v, 11, 0, _ck(_v, 12, 0, core_es5["ɵnov"](_v.parent, 1), core_es5["ɵnov"](_v, 4).model.errors)) == 'required');
        _ck(_v, 11, 0, currVal_16);
        var currVal_17 = ((core_es5["ɵunv"](_v, 15, 0, _ck(_v, 16, 0, core_es5["ɵnov"](_v.parent, 1), core_es5["ɵnov"](_v, 4).model.errors)) == 'pattern') && _co.localTotal);
        _ck(_v, 15, 0, currVal_17);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 1).required ? '' : null);
        var currVal_1 = (core_es5["ɵnov"](_v, 2).pattern ? core_es5["ɵnov"](_v, 2).pattern : null);
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    });
}
function View_ClearanceFeeCardComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'clearance-option', [], null, [[null, 'valueChanged']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('valueChanged' === en)) {
                var pd_0 = (_co.recalculateTotal(true) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ClearanceOptionComponent_0, RenderType_ClearanceOptionComponent)),
        core_es5["ɵdid"](49152, [[3, 4], ['clearanceOption', 4]], 0, clearance_option_component_ClearanceOptionComponent, [], { orderItem: [0, 'orderItem'], form: [1, 'form'], index: [2, 'index'] }, { valueChanged: 'valueChanged' }),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        var currVal_1 = core_es5["ɵnov"](_v.parent.parent, 49);
        var currVal_2 = (_v.context.index + 1);
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2);
    }, null);
}
function View_ClearanceFeeCardComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [['aria-labelledby',
                'basic-link'], ['class', 'dropdown-menu'], ['id', 'dropdown-basic'], ['role', 'menu']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClearanceFeeCardComponent_10)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order.OrderItems;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_ClearanceFeeCardComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DecimalPipe"], [core_es5["LOCALE_ID"]]), core_es5["ɵpid"](0, FirstKeyPipe, []), core_es5["ɵqud"](402653184, 1, { dropdownDirective: 0 }), core_es5["ɵqud"](402653184, 2, { optionsFrom: 0 }), core_es5["ɵqud"](671088640, 3, { clearanceOptions: 1 }), (_l()(), core_es5["ɵeld"](0, null, null, 78, 'div', [['class', 'text-center calc-tab small-tab margin-bottom-0']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'red-shadow': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'position-relative']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_ClearanceFeeCardComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClearanceFeeCardComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 55, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 52, 'div', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 49, 'div', [['class', 'cost']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-md-6 currency']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'select', [['class',
                'form-control'], ['name', 'currency']], [[2, 'ng-untouched', null], [2,
                'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 36).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 36).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.currentCurrencyCode = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_3 = (_co.convert($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[8, null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClearanceFeeCardComponent_3)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 32, 'form', [['class', 'width-50-pct padding-left-10'],
            ['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 49).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 49).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[2, 4], ['optionsFrom', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'cost-dropdown text-center']], null, [[null, 'clickOutside'], ['document', 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('document:click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 54).onDocumentClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('clickOutside' === en)) {
                var pd_1 = (_co.hideDropDown() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, click_outside_directive_ClickOutsideDirective, [core_es5["ElementRef"]], null, { clickOutside: 'clickOutside' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](16777216, null, null, 21, 'div', [['class',
                'bs-dropdown'], ['dropdown', '']], [[2, 'dropup', null], [2, 'open', null],
            [2, 'show', null]], [[null, 'onHidden'], [null, 'onShown']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onHidden' === en)) {
                var pd_0 = (_co.onDropDownHidden() !== false);
                ad = (pd_0 && ad);
            }
            if (('onShown' === en)) {
                var pd_1 = (_co.onDropDownShown() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'disabled': 0 }),
        core_es5["ɵprd"](512, null, bs_dropdown_state["a" /* BsDropdownState */], bs_dropdown_state["a" /* BsDropdownState */], []),
        core_es5["ɵdid"](212992, [[1, 4], ['dropdownRef', 4]], 0, bs_dropdown_directive["a" /* BsDropdownDirective */], [core_es5["ElementRef"],
            core_es5["Renderer"], core_es5["ViewContainerRef"], component_loader_factory["a" /* ComponentLoaderFactory */], bs_dropdown_config["a" /* BsDropdownConfig */],
            bs_dropdown_state["a" /* BsDropdownState */]], { autoClose: [0, 'autoClose'], isDisabled: [1, 'isDisabled'] }, { onShown: 'onShown', onHidden: 'onHidden' }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 8, 'a', [['aria-controls', 'dropdown-basic'],
            ['class', ''], ['dropdownToggle', ''], ['role', 'button']], [[8, 'hidden', 0], [1,
                'aria-haspopup', 0], [1, 'disabled', 0], [1, 'aria-expanded', 0]], [[null,
                'click'], ['document', 'click'], [null, 'keyup.esc']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 63).onClick() !== false);
                ad = (pd_0 && ad);
            }
            if (('document:click' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 63).onDocumentClick($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('keyup.esc' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 63).onEsc() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](147456, null, 0, bs_dropdown_toggle_directive["a" /* BsDropdownToggleDirective */], [bs_dropdown_state["a" /* BsDropdownState */], core_es5["ElementRef"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClearanceFeeCardComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClearanceFeeCardComponent_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClearanceFeeCardComponent_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClearanceFeeCardComponent_9)), core_es5["ɵdid"](16384, null, 0, bs_dropdown_menu_directive["a" /* BsDropdownMenuDirective */], [bs_dropdown_state["a" /* BsDropdownState */], core_es5["ViewContainerRef"], core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'text-center calc-tab small-tab margin-bottom-0';
        var currVal_1 = _ck(_v, 7, 0, (_co.showHighlight && (_co.isChanging == false)));
        _ck(_v, 6, 0, currVal_0, currVal_1);
        var currVal_2 = _co.calculatorHelper.IsBBFeeEdited(_co.order);
        _ck(_v, 12, 0, currVal_2);
        var currVal_4 = _co.percentFee;
        _ck(_v, 22, 0, currVal_4);
        var currVal_12 = 'currency';
        var currVal_13 = _co.disableChanges;
        var currVal_14 = _co.currentCurrencyCode;
        _ck(_v, 38, 0, currVal_12, currVal_13, currVal_14);
        var currVal_15 = _co.canadianCurrencyCodes;
        _ck(_v, 43, 0, currVal_15);
        var currVal_26 = 'bs-dropdown';
        var currVal_27 = _ck(_v, 58, 0, _co.disableChanges);
        _ck(_v, 57, 0, currVal_26, currVal_27);
        var currVal_28 = false;
        var currVal_29 = _co.disableChanges;
        _ck(_v, 60, 0, currVal_28, currVal_29);
        var currVal_34 = ((_co.total != null) && (_co.total != 0));
        _ck(_v, 66, 0, currVal_34);
        var currVal_35 = (_co.total == 0);
        _ck(_v, 69, 0, currVal_35);
        var currVal_36 = _co.isDropDownShown;
        _ck(_v, 73, 0, currVal_36);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = _co.title;
        _ck(_v, 20, 0, currVal_3);
        var currVal_5 = core_es5["ɵnov"](_v, 40).ngClassUntouched;
        var currVal_6 = core_es5["ɵnov"](_v, 40).ngClassTouched;
        var currVal_7 = core_es5["ɵnov"](_v, 40).ngClassPristine;
        var currVal_8 = core_es5["ɵnov"](_v, 40).ngClassDirty;
        var currVal_9 = core_es5["ɵnov"](_v, 40).ngClassValid;
        var currVal_10 = core_es5["ɵnov"](_v, 40).ngClassInvalid;
        var currVal_11 = core_es5["ɵnov"](_v, 40).ngClassPending;
        _ck(_v, 35, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11);
        var currVal_16 = core_es5["ɵnov"](_v, 51).ngClassUntouched;
        var currVal_17 = core_es5["ɵnov"](_v, 51).ngClassTouched;
        var currVal_18 = core_es5["ɵnov"](_v, 51).ngClassPristine;
        var currVal_19 = core_es5["ɵnov"](_v, 51).ngClassDirty;
        var currVal_20 = core_es5["ɵnov"](_v, 51).ngClassValid;
        var currVal_21 = core_es5["ɵnov"](_v, 51).ngClassInvalid;
        var currVal_22 = core_es5["ɵnov"](_v, 51).ngClassPending;
        _ck(_v, 47, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22);
        var currVal_23 = core_es5["ɵnov"](_v, 60).dropup;
        var currVal_24 = core_es5["ɵnov"](_v, 60).isOpen;
        var currVal_25 = (core_es5["ɵnov"](_v, 60).isOpen && core_es5["ɵnov"](_v, 60).isBs4);
        _ck(_v, 56, 0, currVal_23, currVal_24, currVal_25);
        var currVal_30 = _co.isDropDownShown;
        var currVal_31 = true;
        var currVal_32 = core_es5["ɵnov"](_v, 63).isDisabled;
        var currVal_33 = core_es5["ɵnov"](_v, 63).isOpen;
        _ck(_v, 62, 0, currVal_30, currVal_31, currVal_32, currVal_33);
    });
}
function View_ClearanceFeeCardComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'clearance-fee-card', [], null, null, null, View_ClearanceFeeCardComponent_0, RenderType_ClearanceFeeCardComponent)), core_es5["ɵdid"](4767744, null, 0, clearance_fee_card_component_ClearanceFeeCardComponent, [services_orderService["a" /* OrderService */]], null, null)], null, null);
}
var ClearanceFeeCardComponentNgFactory = core_es5["ɵccf"]('clearance-fee-card', clearance_fee_card_component_ClearanceFeeCardComponent, View_ClearanceFeeCardComponent_Host_0, { order: 'order',
    title: 'title', total: 'total', percentFee: 'percentFee', canadianCurrencyCodes: 'canadianCurrencyCodes',
    defaultCurrencyCode: 'defaultCurrencyCode', disableChanges: 'disableChanges',
    showHighlight: 'showHighlight' }, { currencyChanged: 'currencyChanged', orderChangeEmit: 'orderChangeEmit',
    aaFeeChangeEmit: 'aaFeeChangeEmit' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=clearance-fee-card.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/common/directives/elementAutoSize.directive.ts

var elementAutoSize_directive_ElementAutoSize = /** @class */ (function () {
    function ElementAutoSize(element) {
        this.element = element;
    }
    ElementAutoSize.prototype.ngOnChanges = function (changes) {
        if (changes.value) {
            this.resize();
        }
    };
    ElementAutoSize.prototype.onKeyUp = function () {
        this.resize();
    };
    ElementAutoSize.prototype.resize = function () {
        var nativeElement = this.element.nativeElement;
        nativeElement.style.overflow = 'hidden';
        nativeElement.style.height = 'auto';
        nativeElement.setAttribute("overflow", "hidden");
        if (!String.isNullOrEmpty(this.value))
            nativeElement.style.height = nativeElement.scrollHeight + "px";
    };
    ElementAutoSize.ctorParameters = function () { return [{ type: core_es5["ElementRef"] }]; };
    return ElementAutoSize;
}());

//# sourceMappingURL=elementAutoSize.directive.js.map
// EXTERNAL MODULE: ./app/objects/orders/order.ts
var orders_order = __webpack_require__("hz4y");

// EXTERNAL MODULE: ./app/objects/users/viewType.ts
var users_viewType = __webpack_require__("n7Lc");

// CONCATENATED MODULE: ./app/components/calculator/tabs/calcInfoRow/calcInfoRow.component.ts











/**
 * Created by alex.y on 8/10/2017.
 */
var calcInfoRow_component_CalcInfoRowComponent = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](CalcInfoRowComponent, _super);
    function CalcInfoRowComponent(calculatorService, orderService, cdr) {
        var _this = _super.call(this) || this;
        _this.calculatorService = calculatorService;
        _this.orderService = orderService;
        _this.cdr = cdr;
        _this.value = null;
        _this.class = "";
        _this.isBigRow = false;
        _this.isMobileVersion = false;
        _this.isEditable = false;
        _this.previousValue = null;
        _this.previousPercent = null;
        _this.order = new orders_order["a" /* Order */]();
        _this.canInputPercent = false;
        return _this;
    }
    CalcInfoRowComponent.prototype.ngOnInit = function () {
        this.viewTypeEnum = screenHelper["a" /* ScreenHelper */].getViewType();
        this.viewType = users_viewType["a" /* ViewType */][this.viewTypeEnum];
    };
    CalcInfoRowComponent.prototype.isNumber = function (value) {
        return !isNaN(value);
    };
    CalcInfoRowComponent.prototype.showInputField = function () {
        if (this.isEditable) {
            this.canInputPercent = true;
        }
    };
    CalcInfoRowComponent.prototype.hideInputField = function () {
        this.canInputPercent = false;
    };
    CalcInfoRowComponent.prototype.checkTartget = function (classLict) {
        for (var _i = 0, classLict_1 = classLict; _i < classLict_1.length; _i++) {
            var i = classLict_1[_i];
            if (i == 'percent-input') {
                return true;
            }
        }
        return false;
    };
    CalcInfoRowComponent.prototype.checkEnter = function (e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            e.stopPropagation();
            this.recalculate();
        }
    };
    CalcInfoRowComponent.prototype.recalculate = function () {
        var _this = this;
        this.hideInputField();
        this.order.OrderItems.map(function (i) {
            if (i.Id == _this.orderItem.Id) {
                i.DutyList.map(function (d) {
                    if (d.DutyType == calculator_duty["b" /* DutyType */].Percent) {
                        d.Value = parseFloat(_this.percent);
                    }
                });
                if (!i.DutyList.length) {
                    i.DutyList.push(new calculator_duty["a" /* Duty */]({
                        DutyType: calculator_duty["b" /* DutyType */].Percent,
                        Measure: '%',
                        Value: parseFloat(_this.percent)
                    }));
                }
                i.IsAgentEditCustomDuty = true;
                i.AgentEditedCustomDutyPercent = parseFloat(_this.percent);
                i.Total.Taxes.map(function (t) {
                    if (t.Type == orders_taxType["a" /* TaxType */].CustomDuty) {
                        t.Percentage = parseFloat(_this.percent);
                        t.Value = _this.getCadValue(i.Price, i.CanadianCurrencyCode, _this.order.Currency) * t.Percentage / 100;
                    }
                    if (t.Type == orders_taxType["a" /* TaxType */].CustomGST) {
                        var cd = i.Total.Taxes.find(function (ft) { return ft.Type == orders_taxType["a" /* TaxType */].CustomDuty; });
                        t.Value = (_this.getCadValue(i.Price, i.CanadianCurrencyCode, _this.order.Currency) + cd.Value) / 100 * t.Percentage;
                    }
                    if (t.Type == orders_taxType["a" /* TaxType */].CustomPST) {
                        var cd = i.Total.Taxes.find(function (ft) { return ft.Type == orders_taxType["a" /* TaxType */].CustomDuty; });
                        var cadVal = _this.getCadValue(i.Price, i.CanadianCurrencyCode, _this.order.Currency);
                        t.Value = (cadVal / 100 * t.Percentage) + (cd.Value / 100 * t.Percentage);
                    }
                });
                i.Total.TotalPrice = calculatorHelper["a" /* CalculatorHelper */].calculateGrantTotalForItem(i, _this.order);
            }
        });
        this.percent = parseFloat(this.percent) + "%";
        this.orderService.create(this.order, this.viewType).then(function (response) {
            //var newOrder = JSON.parse(JSON.stringify(response.Data));
            // this.order = newOrder;
            // this.cdr.detectChanges();
        });
    };
    CalcInfoRowComponent.prototype.onClick = function (event) {
        if (this.isEditable) {
            if (this.canInputPercent && !this.checkTartget(event.target.classList) && !String.isNullOrEmpty(this.percent)) {
                this.recalculate();
            }
        }
    };
    CalcInfoRowComponent.ctorParameters = function () { return [{ type: calculator_calculatorService["a" /* CalculatorService */] }, { type: services_orderService["a" /* OrderService */] }, { type: core_es5["ChangeDetectorRef"] }]; };
    return CalcInfoRowComponent;
}(baseCalculatorTab_BaseCalculatorTab));

//# sourceMappingURL=calcInfoRow.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/tabs/calcInfoRow/calcInfoRow.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */







var styles_CalcInfoRowComponent = [];
var RenderType_CalcInfoRowComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CalcInfoRowComponent, data: {} });
function View_CalcInfoRowComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 25, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'span', [], [[8, 'title', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.showInputField() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 11, 'span', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'hidden': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'input', [['autofocus', ''], ['class', 'percent-input'], ['type', 'text']], [[2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'keydown'], [null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 9)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 9).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 9)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 9)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 10).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('keydown' === en)) {
                var pd_5 = (_co.checkEnter($event) !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.percent = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"],
            core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[8, null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'span', [['class', 'percent-area']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'hidden': 0 }),
        (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' create '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _ck(_v, 6, 0, !_co.canInputPercent);
        _ck(_v, 5, 0, currVal_1);
        var currVal_9 = _co.percent;
        _ck(_v, 12, 0, currVal_9);
        var currVal_10 = 'percent-area';
        var currVal_11 = _ck(_v, 19, 0, _co.canInputPercent);
        _ck(_v, 18, 0, currVal_10, currVal_11);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, '', (_co.percent ? _co.percent : 0), '');
        _ck(_v, 2, 0, currVal_0);
        var currVal_2 = core_es5["ɵnov"](_v, 14).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 14).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 14).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 14).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 14).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 14).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 14).ngClassPending;
        _ck(_v, 8, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
        var currVal_12 = (_co.percent ? _co.percent : 0);
        _ck(_v, 20, 0, currVal_12);
    });
}
function View_CalcInfoRowComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], [[8, 'title', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, '', (_co.percent ? _co.percent : 0), '');
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = (_co.percent ? _co.percent : 0);
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_CalcInfoRowComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 6, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'span', [], [[8, 'title', 0]], null, null, null, null)), core_es5["ɵppd"](2), (_l()(), core_es5["ɵted"](null, [' ', ' '])), core_es5["ɵppd"](2),
        (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, '', ((_co.percent ? _co.percent : core_es5["ɵunv"](_v, 2, 0, _ck(_v, 3, 0, core_es5["ɵnov"](_v.parent.parent.parent, 0), 0, '1.0-0'))) + '%'), '');
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = ((_co.percent ? _co.percent : core_es5["ɵunv"](_v, 4, 0, _ck(_v, 5, 0, core_es5["ɵnov"](_v.parent.parent.parent, 0), 0, '1.0-0'))) + '%');
        _ck(_v, 4, 0, currVal_1);
    });
}
function View_CalcInfoRowComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class',
                'short-description text-center col-xs-2 col-lg-1 currency-row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'bg-grey short-description text-center']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'red-background': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalcInfoRowComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalcInfoRowComponent_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalcInfoRowComponent_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'bg-grey short-description text-center';
        var currVal_1 = _ck(_v, 4, 0, ((_co.previousPercent != _co.percent) && _co.previousPercent));
        _ck(_v, 3, 0, currVal_0, currVal_1);
        var currVal_2 = _co.isEditable;
        _ck(_v, 7, 0, currVal_2);
        var currVal_3 = (!_co.isNumber(_co.percent) && !_co.isEditable);
        _ck(_v, 10, 0, currVal_3);
        var currVal_4 = (_co.isNumber(_co.percent) && !_co.isEditable);
        _ck(_v, 13, 0, currVal_4);
    }, null);
}
function View_CalcInfoRowComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'bg-grey short-description text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_CalcInfoRowComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'bg-grey short-description text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_CalcInfoRowComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'text-center col-sm-2 col-lg-1 currency-row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_CalcInfoRowComponent_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalcInfoRowComponent_8)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.currency;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _co.currencyExchange;
        _ck(_v, 6, 0, currVal_1);
    }, null);
}
function View_CalcInfoRowComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', '', ' ', ''])), core_es5["ɵppd"](2)], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (((_co.currency == 'USD') || (_co.currency == 'CAD')) ? '$' : '');
        var currVal_1 = core_es5["ɵunv"](_v, 1, 1, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent.parent, 0), (_co.value ? _co.value : 0), '1.2-2'));
        var currVal_2 = _co.currency;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2);
    });
}
function View_CalcInfoRowComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ', ''])), core_es5["ɵppd"](2)], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent.parent, 0), (_co.value ? _co.value : 0), '1.2-5'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalcInfoRowComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 29, 'div', [['class',
                'row product-card-info margin-right-0 margin-left-0']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'tax-name col-lg-9']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'col-xs-7': 0,
            'col-xs-5': 1 }), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalcInfoRowComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalcInfoRowComponent_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'div', [['class', 'text-center col-lg-2 col-sm-3 right-row']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'col-xs-3': 0,
            'col-xs-5': 1 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'bg-grey short-description margin-right--10']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'red-background': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalcInfoRowComponent_9)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalcInfoRowComponent_10)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'row product-card-info margin-right-0 margin-left-0';
        var currVal_1 = _co.class;
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_2 = 'tax-name col-lg-9';
        var currVal_3 = _ck(_v, 5, 0, !_co.isMobileVersion, _co.isMobileVersion);
        _ck(_v, 4, 0, currVal_2, currVal_3);
        var currVal_5 = !_co.isBigRow;
        _ck(_v, 9, 0, currVal_5);
        var currVal_6 = (_co.isBigRow && !_co.calculatorService.isMobile());
        _ck(_v, 12, 0, currVal_6);
        var currVal_7 = 'text-center col-lg-2 col-sm-3 right-row';
        var currVal_8 = _ck(_v, 16, 0, (!_co.isBigRow && !_co.isMobileVersion), (_co.isBigRow || (_co.isMobileVersion && !_co.isBigRow)));
        _ck(_v, 15, 0, currVal_7, currVal_8);
        var currVal_9 = 'bg-grey short-description margin-right--10';
        var currVal_10 = _ck(_v, 20, 0, (_co.value != _co.previousValue));
        _ck(_v, 19, 0, currVal_9, currVal_10);
        var currVal_11 = _co.currency;
        _ck(_v, 23, 0, currVal_11);
        var currVal_12 = !_co.currency;
        _ck(_v, 26, 0, currVal_12);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_4 = _co.title;
        _ck(_v, 6, 0, currVal_4);
    });
}
function View_CalcInfoRowComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DecimalPipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalcInfoRowComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ((_co.value > 0) || _co.isEditable);
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_CalcInfoRowComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CalcInfoRowComponentNgFactory = core_es5["ɵccf"]('calc-info-row', calcInfoRow_component_CalcInfoRowComponent, View_CalcInfoRowComponent_Host_0, { isPublic: 'isPublic',
    title: 'title', percent: 'percent', value: 'value', class: 'class', isBigRow: 'isBigRow',
    isMobileVersion: 'isMobileVersion', currencyExchange: 'currencyExchange', orderItem: 'orderItem',
    isEditable: 'isEditable', currency: 'currency', previousValue: 'previousValue',
    previousPercent: 'previousPercent', order: 'order' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=calcInfoRow.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/calculator/tabs/calculatorResults/canadianCalculator.component.ts






/**
 * Created by alex.y on 8/11/2017.
 */
var canadianCalculator_component_CanadianCalculatorComponent = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](CanadianCalculatorComponent, _super);
    function CanadianCalculatorComponent(router, taxService) {
        var _this = _super.call(this) || this;
        _this.router = router;
        _this.taxService = taxService;
        _this.string = String;
        _this.calculatorHelper = calculatorHelper["a" /* CalculatorHelper */];
        _this.showHst = false;
        _this.showQst = false;
        _this.isVehicle = false;
        _this.OrderOptions = orderOptions["a" /* OrderOptions */];
        return _this;
    }
    CanadianCalculatorComponent.prototype.ngOnInit = function () {
        if (this.order && this.order.Locations.length > 0)
            this.setHQst();
        if (this.order && this.order.Flag)
            this.isVehicle = this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsVehicle);
    };
    CanadianCalculatorComponent.prototype.setHQst = function () {
        var isHQst = calculatorHelper["a" /* CalculatorHelper */].isHQst(this.order);
        if (isHQst == null)
            return;
        if (isHQst == true)
            this.showHst = true;
        if (isHQst == false)
            this.showQst = true;
    };
    CanadianCalculatorComponent.prototype.isMoreOrEqThanTwentyFive = function () {
        return calculatorHelper["a" /* CalculatorHelper */].isMoreOrEqThanTwentyFive(this.order, this.orderItem);
    };
    CanadianCalculatorComponent.prototype.isFreeCustomDuty = function () {
        // if(this.orderItem.Product && (this.orderItem.Product.HsCode == "9999.99.99.99" || this.orderItem.Product.HsCode == "9999.99.99.98"))
        //     return false;
        return this.isMoreOrEqThanTwentyFive();
    };
    CanadianCalculatorComponent.ctorParameters = function () { return [{ type: router_es5["n" /* Router */] }, { type: tax_service["a" /* TaxService */] }]; };
    return CanadianCalculatorComponent;
}(baseCalculatorTab_BaseCalculatorTab));

//# sourceMappingURL=canadianCalculator.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/tabs/calculatorResults/canadianCalculator.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */









var styles_CanadianCalculatorComponent = [];
var RenderType_CanadianCalculatorComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CanadianCalculatorComponent, data: {} });
function View_CanadianCalculatorComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'card-row'], ['title', 'Used Equipment Exam']], null, [['document',
                'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], class: [2, 'class'],
            isBigRow: [3, 'isBigRow'], currency: [4, 'currency'], previousValue: [5, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Used Equipment Exam';
        var currVal_1 = _co.findTax(_co.taxType.UsedEquipment, _co.orderItem).Value;
        var currVal_2 = 'card-row';
        var currVal_3 = true;
        var currVal_4 = _co.getCurrency(_co.currency);
        var currVal_5 = _co.findTax(_co.taxType.UsedEquipment, _co.clonedOrderItem).Value;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    }, null);
}
function View_CanadianCalculatorComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'card-row']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], class: [2, 'class'],
            isBigRow: [3, 'isBigRow'], currency: [4, 'currency'], previousValue: [5, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Internal Transaction Number (ITN)';
        var currVal_1 = _co.findTax(_co.taxType.ITN, _co.orderItem).Value;
        var currVal_2 = 'card-row';
        var currVal_3 = true;
        var currVal_4 = _co.getCurrency(_co.currency);
        var currVal_5 = _co.findTax(_co.taxType.ITN, _co.clonedOrderItem).Value;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    }, null);
}
function View_CanadianCalculatorComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'card-row']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], class: [2, 'class'],
            isBigRow: [3, 'isBigRow'], currency: [4, 'currency'], previousValue: [5, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Vehicle Inspection Fee';
        var currVal_1 = _co.findTax(_co.taxType.RIV, _co.orderItem).Value;
        var currVal_2 = 'card-row';
        var currVal_3 = true;
        var currVal_4 = _co.getCurrency(_co.currency);
        var currVal_5 = _co.findTax(_co.taxType.RIV, _co.clonedOrderItem).Value;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    }, null);
}
function View_CanadianCalculatorComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'card-row']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], class: [2, 'class'],
            isBigRow: [3, 'isBigRow'], currency: [4, 'currency'], previousValue: [5, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'AC';
        var currVal_1 = _co.findTax(_co.taxType.AC, _co.orderItem).Value;
        var currVal_2 = 'card-row';
        var currVal_3 = true;
        var currVal_4 = _co.getCurrency(_co.currency);
        var currVal_5 = _co.findTax(_co.taxType.AC, _co.clonedOrderItem).Value;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    }, null);
}
function View_CanadianCalculatorComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'card-row']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], class: [2, 'class'],
            isBigRow: [3, 'isBigRow'], currency: [4, 'currency'], previousValue: [5, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Form 1';
        var currVal_1 = _co.findTax(_co.taxType.FormOne, _co.orderItem).Value;
        var currVal_2 = 'card-row';
        var currVal_3 = true;
        var currVal_4 = _co.getCurrency(_co.currency);
        var currVal_5 = _co.findTax(_co.taxType.FormOne, _co.clonedOrderItem).Value;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    }, null);
}
function View_CanadianCalculatorComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'card-row']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], class: [2, 'class'],
            isBigRow: [3, 'isBigRow'], currency: [4, 'currency'], previousValue: [5, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Agent Port Fee';
        var currVal_1 = _co.findTax(_co.taxType.AgentPortFee, _co.orderItem).Value;
        var currVal_2 = 'card-row';
        var currVal_3 = true;
        var currVal_4 = _co.getCurrency(_co.currency);
        var currVal_5 = _co.findTax(_co.taxType.AgentPortFee, _co.clonedOrderItem).Value;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    }, null);
}
function View_CanadianCalculatorComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'card-row']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], class: [2, 'class'],
            isBigRow: [3, 'isBigRow'], currency: [4, 'currency'], previousValue: [5, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Soil Exam Fee';
        var currVal_1 = _co.findTax(_co.taxType.SoilExamFee, _co.orderItem).Value;
        var currVal_2 = 'card-row';
        var currVal_3 = true;
        var currVal_4 = _co.getCurrency(_co.currency);
        var currVal_5 = _co.findTax(_co.taxType.SoilExamFee, _co.clonedOrderItem).Value;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    }, null);
}
function View_CanadianCalculatorComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'card-row']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], class: [2, 'class'],
            isBigRow: [3, 'isBigRow'], currency: [4, 'currency'], previousValue: [5, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Green Levy';
        var currVal_1 = _co.findTax(_co.taxType.GreenLevy, _co.orderItem).Value;
        var currVal_2 = 'card-row';
        var currVal_3 = true;
        var currVal_4 = _co.getCurrency(_co.currency);
        var currVal_5 = _co.findTax(_co.taxType.GreenLevy, _co.clonedOrderItem).Value;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    }, null);
}
function View_CanadianCalculatorComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'card-row']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], class: [3, 'class'], currency: [4, 'currency'], previousValue: [5, 'previousValue'],
            previousPercent: [6, 'previousPercent'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ('Customs ' + (_co.showQst ? 'Taxes' : 'Taxes'));
        var currVal_1 = _co.findTax(_co.taxType.CustomPST, _co.orderItem).Percentage;
        var currVal_2 = _co.findTax(_co.taxType.CustomPST, _co.orderItem).Value;
        var currVal_3 = 'card-row';
        var currVal_4 = _co.getCurrency(_co.currency);
        var currVal_5 = _co.findTax(_co.taxType.CustomPST, _co.clonedOrderItem).Value;
        var currVal_6 = _co.findTax(_co.taxType.CustomPST, _co.clonedOrderItem).Percentage;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    }, null);
}
function View_CanadianCalculatorComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['class', 'card-row'], ['title', 'Customs Taxes']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], class: [3, 'class'], currency: [4, 'currency'], previousValue: [5,
                'previousValue'], previousPercent: [6, 'previousPercent'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianCalculatorComponent_10)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Customs Taxes';
        var currVal_1 = _co.findTax(_co.taxType.CustomGST, _co.orderItem).Percentage;
        var currVal_2 = _co.findTax(_co.taxType.CustomGST, _co.orderItem).Value;
        var currVal_3 = 'card-row';
        var currVal_4 = _co.getCurrency(_co.currency);
        var currVal_5 = _co.findTax(_co.taxType.CustomGST, _co.clonedOrderItem).Value;
        var currVal_6 = _co.findTax(_co.taxType.CustomGST, _co.clonedOrderItem).Percentage;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (((_co.order.Flag != null) && !_co.order.Flag.hasFlag(_co.OrderOptions.IsVehicle)) || _co.order.IsCommercial);
        _ck(_v, 6, 0, currVal_7);
    }, null);
}
function View_CanadianCalculatorComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 8, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'calc-info-row', [['class', 'card-row'], ['title', 'Customs Taxes']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], class: [3, 'class'], currency: [4, 'currency'], previousValue: [5,
                'previousValue'], previousPercent: [6, 'previousPercent'] }, null),
        core_es5["ɵpad"](2), core_es5["ɵpad"](2), core_es5["ɵpad"](2), core_es5["ɵpad"](2), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Customs Taxes';
        var currVal_1 = _co.findTaxesPersentSum(_co.orderItem, _ck(_v, 4, 0, _co.taxType.CustomGST, _co.taxType.CustomPST));
        var currVal_2 = _co.findTaxesSum(_co.orderItem, _ck(_v, 5, 0, _co.taxType.CustomGST, _co.taxType.CustomPST));
        var currVal_3 = 'card-row';
        var currVal_4 = _co.getCurrency(_co.currency);
        var currVal_5 = _co.findTaxesSum(_co.clonedOrderItem, _ck(_v, 6, 0, _co.taxType.CustomGST, _co.taxType.CustomPST));
        var currVal_6 = _co.findTaxesPersentSum(_co.clonedOrderItem, _ck(_v, 7, 0, _co.taxType.CustomGST, _co.taxType.CustomPST));
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    }, null);
}
function View_CanadianCalculatorComponent_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 9, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'card-row'], ['title', 'Customs Clearance Fee Taxes']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], class: [3, 'class'], currency: [4, 'currency'], previousValue: [5,
                'previousValue'], previousPercent: [6, 'previousPercent'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'card-row']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 7).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], class: [3, 'class'], currency: [4, 'currency'], previousValue: [5,
                'previousValue'], previousPercent: [6, 'previousPercent'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Customs Clearance Fee Taxes';
        var currVal_1 = _co.findTax(_co.taxType.AAFeeGST, _co.orderItem).Percentage;
        var currVal_2 = _co.findTax(_co.taxType.AAFeeGST, _co.orderItem).Value;
        var currVal_3 = 'card-row';
        var currVal_4 = _co.getCurrency(_co.currency);
        var currVal_5 = _co.findTax(_co.taxType.AAFeeGST, _co.clonedOrderItem).Value;
        var currVal_6 = _co.findTax(_co.taxType.AAFeeGST, _co.clonedOrderItem).Percentage;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = ('Customs Clearance Fee ' + (_co.showQst ? 'Taxes' : 'Taxes'));
        var currVal_8 = _co.findTax(_co.taxType.AAFeePST, _co.orderItem).Percentage;
        var currVal_9 = _co.findTax(_co.taxType.AAFeePST, _co.orderItem).Value;
        var currVal_10 = 'card-row';
        var currVal_11 = _co.getCurrency(_co.currency);
        var currVal_12 = _co.findTax(_co.taxType.AAFeePST, _co.clonedOrderItem).Value;
        var currVal_13 = _co.findTax(_co.taxType.AAFeePST, _co.clonedOrderItem).Percentage;
        _ck(_v, 7, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13);
    }, null);
}
function View_CanadianCalculatorComponent_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 8, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'calc-info-row', [['class', 'card-row'], ['title', 'Customs Clearance Fee Taxes']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], class: [3, 'class'], currency: [4, 'currency'], previousValue: [5,
                'previousValue'], previousPercent: [6, 'previousPercent'] }, null),
        core_es5["ɵpad"](2), core_es5["ɵpad"](2), core_es5["ɵpad"](2), core_es5["ɵpad"](2), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Customs Clearance Fee Taxes';
        var currVal_1 = _co.findTaxesPersentSum(_co.orderItem, _ck(_v, 4, 0, _co.taxType.AAFeeGST, _co.taxType.AAFeePST));
        var currVal_2 = _co.findTaxesSum(_co.orderItem, _ck(_v, 5, 0, _co.taxType.AAFeeGST, _co.taxType.AAFeePST));
        var currVal_3 = 'card-row';
        var currVal_4 = _co.getCurrency(_co.currency);
        var currVal_5 = _co.findTaxesSum(_co.clonedOrderItem, _ck(_v, 6, 0, _co.taxType.AAFeeGST, _co.taxType.AAFeePST));
        var currVal_6 = _co.findTaxesPersentSum(_co.clonedOrderItem, _ck(_v, 7, 0, _co.taxType.AAFeeGST, _co.taxType.AAFeePST));
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    }, null);
}
function View_CanadianCalculatorComponent_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Administration Fee']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Administration Fee';
        var currVal_1 = _co.findTax(_co.taxType.AdminFee, _co.orderItem).Percentage;
        var currVal_2 = _co.findTax(_co.taxType.AdminFee, _co.orderItem).Value;
        var currVal_3 = _co.getCurrency(_co.currency);
        var currVal_4 = _co.findTax(_co.taxType.AdminFee, _co.clonedOrderItem).Value;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4);
    }, null);
}
function View_CanadianCalculatorComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DecimalPipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](0, null, null, 103, 'div', [['class', 'row no-btm-margin canad-calc']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 100, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 97, 'div', [['class', 'row margin-bottom-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-header bg-light-grey card-header-text card-padding'],
                ['data-background-color', '#fff7ee']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'card-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Recap Total'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 78, 'div', [['class', 'card-content no-btm-padding calc-info-row-container']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'card-row'], ['title', 'Value']], null, [['document',
                'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 16).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], class: [2, 'class'],
            isBigRow: [3, 'isBigRow'], currency: [4, 'currency'], previousValue: [5, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class',
                'card-row'], ['title', 'Exchange Rate']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 20).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], class: [2, 'class'],
            isBigRow: [3, 'isBigRow'], currencyExchange: [4, 'currencyExchange'], previousValue: [5,
                'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'card-row'], ['title', 'Value for Customs']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 24).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], class: [2,
                'class'], isBigRow: [3, 'isBigRow'], currency: [4, 'currency'], previousValue: [5,
                'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianCalculatorComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianCalculatorComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianCalculatorComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianCalculatorComponent_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianCalculatorComponent_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianCalculatorComponent_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianCalculatorComponent_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianCalculatorComponent_8)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row card-row product-card-info margin-right-0 margin-left-0']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'padding-left-15 product-card-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'card-title line-height-30 margin-0']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Customs Fees'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'card-row'], ['title', 'Customs Duty']], null, [['document',
                'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 61).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], class: [3, 'class'], orderItem: [4, 'orderItem'], isEditable: [5, 'isEditable'],
            currency: [6, 'currency'], previousValue: [7, 'previousValue'], previousPercent: [8,
                'previousPercent'], order: [9, 'order'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianCalculatorComponent_9)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianCalculatorComponent_11)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row card-row product-card-info margin-right-0 margin-left-0']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'padding-left-15 product-card-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'card-title line-height-30 margin-0']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Borderbuddy Fees'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'card-row'], ['title', 'Customs Clearance Fee']], null, [['document',
                'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 80).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], class: [2,
                'class'], isBigRow: [3, 'isBigRow'], currency: [4, 'currency'], previousValue: [5,
                'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianCalculatorComponent_12)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianCalculatorComponent_13)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianCalculatorComponent_14)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'card-header bg-light-grey card-header-text card-padding'], ['data-background-color',
                '$grey']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'card-title col-xs-6 col-sm-9 bold text-ellipsis-inline font-size-16 grand-total']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Grand Total Fees'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [['class',
                'card-title col-xs-6 col-sm-3 bold text-ellipsis-inline text-right font-size-16']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), core_es5["ɵppd"](2), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Value';
        var currVal_1 = _co.orderItem.Price;
        var currVal_2 = 'card-row';
        var currVal_3 = true;
        var currVal_4 = _co.getCurrency(_co.orderItem.CanadianCurrencyCode.Name);
        var currVal_5 = _co.clonedOrderItem.Price;
        _ck(_v, 16, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
        var currVal_6 = 'Exchange Rate';
        var currVal_7 = _co.getCurrencyRate(_co.orderItem.CanadianCurrencyCode, _co.order.Currency);
        var currVal_8 = 'card-row';
        var currVal_9 = true;
        var currVal_10 = ((_co.getCurrency(_co.orderItem.CanadianCurrencyCode.Name) + '/') + _co.getCurrency(_co.currency));
        var currVal_11 = _co.getCurrencyRate(_co.clonedOrderItem.CanadianCurrencyCode, _co.clonedOrder.Currency);
        _ck(_v, 20, 0, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11);
        var currVal_12 = 'Value for Customs';
        var currVal_13 = _co.getCadValue(_co.orderItem.Price, _co.orderItem.CanadianCurrencyCode, _co.order.Currency);
        var currVal_14 = 'card-row';
        var currVal_15 = true;
        var currVal_16 = _co.getCurrency(_co.currency);
        var currVal_17 = _co.getCadValue(_co.clonedOrderItem.Price, _co.clonedOrderItem.CanadianCurrencyCode, _co.clonedOrder.Currency);
        _ck(_v, 24, 0, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17);
        var currVal_18 = _co.calculatorHelper.isUsedEquipment(_co.orderItem.Product);
        _ck(_v, 28, 0, currVal_18);
        var currVal_19 = _co.calculatorHelper.isCanadianVehicleCalculator(_co.order);
        _ck(_v, 31, 0, currVal_19);
        var currVal_20 = _co.calculatorHelper.isCanadianVehicleCalculator(_co.order);
        _ck(_v, 34, 0, currVal_20);
        var currVal_21 = _co.calculatorHelper.isCanadianVehicleCalculator(_co.order);
        _ck(_v, 37, 0, currVal_21);
        var currVal_22 = _co.calculatorHelper.isCanadianVehicleCalculator(_co.order);
        _ck(_v, 40, 0, currVal_22);
        var currVal_23 = _co.calculatorHelper.isCanadianVehicleCalculator(_co.order);
        _ck(_v, 43, 0, currVal_23);
        var currVal_24 = _co.calculatorHelper.isCanadianVehicleCalculator(_co.order);
        _ck(_v, 46, 0, currVal_24);
        var currVal_25 = (_co.calculatorHelper.isCanadianVehicleCalculator(_co.order) && _co.calculatorHelper.isUsaShipmentFrom(_co.order));
        _ck(_v, 49, 0, currVal_25);
        var currVal_26 = 'Customs Duty';
        var currVal_27 = _co.calculatorHelper.getTariff(_co.orderItem, _co.order, _co.isVehicle, _co.taxService.canadianHsCodesAlAndSteel10, _co.taxService.canadianHsCodesAlAndSteel25, _co.taxService.canadianHsCodesChina0, _co.taxService.usaHsCodesChina25);
        var currVal_28 = _co.findTax(_co.taxType.CustomDuty, _co.orderItem).Value;
        var currVal_29 = 'card-row';
        var currVal_30 = _co.orderItem;
        var currVal_31 = true;
        var currVal_32 = _co.getCurrency(_co.currency);
        var currVal_33 = _co.findTax(_co.taxType.CustomDuty, _co.clonedOrderItem).Value;
        var currVal_34 = _co.calculatorHelper.getTariff(_co.clonedOrderItem, _co.order, _co.isVehicle, _co.taxService.canadianHsCodesAlAndSteel10, _co.taxService.canadianHsCodesAlAndSteel25, _co.taxService.canadianHsCodesChina0, _co.taxService.usaHsCodesChina25);
        var currVal_35 = _co.order;
        _ck(_v, 61, 0, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35);
        var currVal_36 = !_co.showHst;
        _ck(_v, 65, 0, currVal_36);
        var currVal_37 = _co.showHst;
        _ck(_v, 68, 0, currVal_37);
        var currVal_38 = 'Customs Clearance Fee';
        var currVal_39 = _co.findTax(_co.taxType.AAFee, _co.orderItem).Value;
        var currVal_40 = 'card-row';
        var currVal_41 = true;
        var currVal_42 = _co.getCurrency(_co.currency);
        var currVal_43 = _co.findTax(_co.taxType.AAFee, _co.clonedOrderItem).Value;
        _ck(_v, 80, 0, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43);
        var currVal_44 = !_co.showHst;
        _ck(_v, 84, 0, currVal_44);
        var currVal_45 = _co.showHst;
        _ck(_v, 87, 0, currVal_45);
        var currVal_46 = ((_co.order.Flag && !_co.order.Flag.hasFlag(_co.OrderOptions.IsVehicle)) || _co.order.IsCommercial);
        _ck(_v, 90, 0, currVal_46);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_47 = ((('$' + core_es5["ɵunv"](_v, 99, 0, _ck(_v, 100, 0, core_es5["ɵnov"](_v, 0), _co.calculateGrantTotalForItem(_co.orderItem, _co.order), '.2-2'))) + ' ') + _co.getCurrency(_co.currency));
        _ck(_v, 99, 0, currVal_47);
    });
}
function View_CanadianCalculatorComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'cad-calc-tab', [], null, null, null, View_CanadianCalculatorComponent_0, RenderType_CanadianCalculatorComponent)), core_es5["ɵdid"](114688, null, 0, canadianCalculator_component_CanadianCalculatorComponent, [router_es5["n" /* Router */], tax_service["a" /* TaxService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CanadianCalculatorComponentNgFactory = core_es5["ɵccf"]('cad-calc-tab', canadianCalculator_component_CanadianCalculatorComponent, View_CanadianCalculatorComponent_Host_0, { isPublic: 'isPublic',
    orderItem: 'orderItem', currency: 'currency', order: 'order', clonedOrder: 'clonedOrder',
    clonedOrderItem: 'clonedOrderItem' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=canadianCalculator.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/calculator/tabs/calculatorResults/usaCalculator.component.ts





/**
 * Created by alex.y on 8/11/2017.
 */
var usaCalculator_component_UsaCalculatorComponent = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](UsaCalculatorComponent, _super);
    function UsaCalculatorComponent(router) {
        var _this = _super.call(this) || this;
        _this.router = router;
        _this.calculatorHelper = calculatorHelper["a" /* CalculatorHelper */];
        _this.isVehicle = false;
        return _this;
    }
    UsaCalculatorComponent.prototype.ngOnInit = function () {
        if (this.order && this.order.Flag)
            this.isVehicle = this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsVehicle);
    };
    UsaCalculatorComponent.ctorParameters = function () { return [{ type: router_es5["n" /* Router */] }]; };
    return UsaCalculatorComponent;
}(baseCalculatorTab_BaseCalculatorTab));

//# sourceMappingURL=usaCalculator.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/tabs/calculatorResults/usaCalculator.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_UsaCalculatorComponent = [];
var RenderType_UsaCalculatorComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_UsaCalculatorComponent, data: {} });
function View_UsaCalculatorComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['title', 'Customs Duty']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], orderItem: [3, 'orderItem'], isEditable: [4, 'isEditable'], currency: [5,
                'currency'], previousValue: [6, 'previousValue'], previousPercent: [7, 'previousPercent'],
            order: [8, 'order'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Customs Duty';
        var currVal_1 = _co.calculatorHelper.getTariff(_co.orderItem, _co.order, _co.isVehicle);
        var currVal_2 = _co.findTax(_co.taxType.CustomDuty, _co.orderItem).Value;
        var currVal_3 = _co.orderItem;
        var currVal_4 = true;
        var currVal_5 = _co.getCurrency(_co.currency);
        var currVal_6 = _co.findTax(_co.taxType.CustomDuty, _co.clonedOrderItem).Value;
        var currVal_7 = _co.calculatorHelper.getTariff(_co.clonedOrderItem, _co.order, _co.isVehicle);
        var currVal_8 = _co.order;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    }, null);
}
function View_UsaCalculatorComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['title', 'Customs Duty']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], currency: [3, 'currency'], previousValue: [4, 'previousValue'], previousPercent: [5,
                'previousPercent'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Customs Duty';
        var currVal_1 = (_co.isVehicle ? _co.calculatorHelper.getTariff(_co.orderItem, _co.order, _co.isVehicle) : 'manual');
        var currVal_2 = (_co.isVehicle ? _co.findTax(_co.taxType.CustomDuty, _co.orderItem).Value : _co.findTax(_co.taxType.Manual, _co.orderItem).Value);
        var currVal_3 = _co.getCurrency(_co.currency);
        var currVal_4 = (_co.isVehicle ? _co.findTax(_co.taxType.CustomDuty, _co.clonedOrderItem).Value : _co.findTax(_co.taxType.Manual, _co.clonedOrderItem).Value);
        var currVal_5 = (_co.isVehicle ? _co.calculatorHelper.getTariff(_co.clonedOrderItem, _co.order, _co.isVehicle) : 'manual');
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    }, null);
}
function View_UsaCalculatorComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DecimalPipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](0, null, null, 121, 'div', [['class', 'row no-btm-margin']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 51, 'div', [['class', 'col-sm-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class', 'first-row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-header bg-light-grey card-header-text card-padding'],
                ['data-background-color', '$grey']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'card-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Recap Total'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'card-content no-btm-padding calc-info-row-container']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Value']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 16).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Value for Customs']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 19).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Exchange Rate']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 22).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currencyExchange: [3, 'currencyExchange'], previousValue: [4,
                'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 27, 'div', [['class', 'row no-btm-margin margin-right-0 margin-left-0']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'padding-left-20 padding-right-20']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'bg-light-grey padding-left-15']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'card-title line-height-30 margin-0']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Customs Fees'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class',
                'card-content no-btm-margin no-btm-padding calc-info-row-container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_UsaCalculatorComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_UsaCalculatorComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['title', 'Customs MPF']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 46).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['title', 'Customs HMF']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 50).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 65, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 62, 'div', [['class',
                'row no-btm-margin margin-right-0 margin-left-0']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'padding-left-20 padding-right-20']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'bg-light-grey padding-left-15']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'card-title line-height-30 margin-0']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Borderbuddy Fees'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 40, 'div', [['class', 'card-content fees calc-info-row-container']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Entry Fee']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 72).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Classification Fee']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 75).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Bond']], null, [['document',
                'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 78).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Bond Underwriting Fee']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 81).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Customs ISF']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 84).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Duty Disbursement Fee']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 87).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'NAFTA']], null, [['document',
                'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 90).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'ABI Fee']], null, [['document',
                'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 93).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'FDA/DOT/EPA']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 96).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Importer Registration Fee']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 99).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'One time PAPS Exemption']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 102).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'E-Manifest']], null, [['document',
                'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 105).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Administration Fee']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 108).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'], previousValue: [4, 'previousValue'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'card-header bg-light-grey card-header-text card-padding'], ['data-background-color',
                '$grey']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'card-title col-xs-6 col-sm-9 bold text-ellipsis-inline grand-total font-size-16']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Grand Total Fees'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [['class',
                'card-title col-xs-6 col-sm-3 bold text-ellipsis-inline text-right font-size-16']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), core_es5["ɵppd"](2), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Value';
        var currVal_1 = _co.orderItem.Price;
        var currVal_2 = true;
        var currVal_3 = _co.getCurrency(_co.orderItem.CanadianCurrencyCode.Name);
        var currVal_4 = _co.clonedOrderItem.Price;
        _ck(_v, 16, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4);
        var currVal_5 = 'Value for Customs';
        var currVal_6 = _co.getCadValue(_co.orderItem.Price, _co.orderItem.CanadianCurrencyCode, _co.order.Currency);
        var currVal_7 = true;
        var currVal_8 = _co.getCurrency(_co.currency);
        var currVal_9 = _co.getCadValue(_co.clonedOrderItem.Price, _co.clonedOrderItem.CanadianCurrencyCode, _co.clonedOrder.Currency);
        _ck(_v, 19, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9);
        var currVal_10 = 'Exchange Rate';
        var currVal_11 = _co.getCurrencyRate(_co.orderItem.CanadianCurrencyCode, _co.order.Currency);
        var currVal_12 = true;
        var currVal_13 = ((_co.getCurrency(_co.orderItem.CanadianCurrencyCode.Name) + '/') + _co.getCurrency(_co.currency));
        var currVal_14 = _co.getCurrencyRate(_co.clonedOrderItem.CanadianCurrencyCode, _co.clonedOrder.Currency);
        _ck(_v, 22, 0, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_15 = !_co.hasManualDuty(_co.orderItem);
        _ck(_v, 40, 0, currVal_15);
        var currVal_16 = _co.hasManualDuty(_co.orderItem);
        _ck(_v, 43, 0, currVal_16);
        var currVal_17 = 'Customs MPF';
        var currVal_18 = _co.findTax(_co.taxType.CustomMPF, _co.orderItem).Value;
        var currVal_19 = true;
        var currVal_20 = _co.getCurrency(_co.currency);
        var currVal_21 = _co.findTax(_co.taxType.CustomMPF, _co.clonedOrderItem).Value;
        _ck(_v, 46, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21);
        var currVal_22 = 'Customs HMF';
        var currVal_23 = _co.findTax(_co.taxType.CustomHMF, _co.orderItem).Value;
        var currVal_24 = true;
        var currVal_25 = _co.getCurrency(_co.currency);
        var currVal_26 = _co.findTax(_co.taxType.CustomHMF, _co.clonedOrderItem).Value;
        _ck(_v, 50, 0, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26);
        var currVal_27 = 'Entry Fee';
        var currVal_28 = _co.findTax(_co.taxType.AAFee, _co.orderItem).Value;
        var currVal_29 = true;
        var currVal_30 = _co.getCurrency(_co.currency);
        var currVal_31 = _co.findTax(_co.taxType.AAFee, _co.clonedOrderItem).Value;
        _ck(_v, 72, 0, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31);
        var currVal_32 = 'Classification Fee';
        var currVal_33 = _co.findTax(_co.taxType.ClassificationFee, _co.orderItem).Value;
        var currVal_34 = true;
        var currVal_35 = _co.getCurrency(_co.currency);
        var currVal_36 = _co.findTax(_co.taxType.ClassificationFee, _co.clonedOrderItem).Value;
        _ck(_v, 75, 0, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36);
        var currVal_37 = 'Bond';
        var currVal_38 = _co.findTax(_co.taxType.Bond, _co.orderItem).Value;
        var currVal_39 = true;
        var currVal_40 = _co.getCurrency(_co.currency);
        var currVal_41 = _co.findTax(_co.taxType.Bond, _co.clonedOrderItem).Value;
        _ck(_v, 78, 0, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41);
        var currVal_42 = 'Bond Underwriting Fee';
        var currVal_43 = _co.findTax(_co.taxType.BondUnderFee, _co.orderItem).Value;
        var currVal_44 = true;
        var currVal_45 = _co.getCurrency(_co.currency);
        var currVal_46 = _co.findTax(_co.taxType.BondUnderFee, _co.clonedOrderItem).Value;
        _ck(_v, 81, 0, currVal_42, currVal_43, currVal_44, currVal_45, currVal_46);
        var currVal_47 = 'Customs ISF';
        var currVal_48 = _co.findTax(_co.taxType.CustomISF, _co.orderItem).Value;
        var currVal_49 = true;
        var currVal_50 = _co.getCurrency(_co.currency);
        var currVal_51 = _co.findTax(_co.taxType.CustomISF, _co.clonedOrderItem).Value;
        _ck(_v, 84, 0, currVal_47, currVal_48, currVal_49, currVal_50, currVal_51);
        var currVal_52 = 'Duty Disbursement Fee';
        var currVal_53 = _co.findTax(_co.taxType.DutyDistRate, _co.orderItem).Value;
        var currVal_54 = true;
        var currVal_55 = _co.getCurrency(_co.currency);
        var currVal_56 = _co.findTax(_co.taxType.DutyDistRate, _co.clonedOrderItem).Value;
        _ck(_v, 87, 0, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56);
        var currVal_57 = 'NAFTA';
        var currVal_58 = _co.findTax(_co.taxType.NAFTA, _co.orderItem).Value;
        var currVal_59 = true;
        var currVal_60 = _co.getCurrency(_co.currency);
        var currVal_61 = _co.findTax(_co.taxType.NAFTA, _co.clonedOrderItem).Value;
        _ck(_v, 90, 0, currVal_57, currVal_58, currVal_59, currVal_60, currVal_61);
        var currVal_62 = 'ABI Fee';
        var currVal_63 = _co.findTax(_co.taxType.ABIFee, _co.orderItem).Value;
        var currVal_64 = true;
        var currVal_65 = _co.getCurrency(_co.currency);
        var currVal_66 = _co.findTax(_co.taxType.ABIFee, _co.clonedOrderItem).Value;
        _ck(_v, 93, 0, currVal_62, currVal_63, currVal_64, currVal_65, currVal_66);
        var currVal_67 = 'FDA/DOT/EPA';
        var currVal_68 = _co.findTax(_co.taxType.FDA, _co.orderItem).Value;
        var currVal_69 = true;
        var currVal_70 = _co.getCurrency(_co.currency);
        var currVal_71 = _co.findTax(_co.taxType.FDA, _co.clonedOrderItem).Value;
        _ck(_v, 96, 0, currVal_67, currVal_68, currVal_69, currVal_70, currVal_71);
        var currVal_72 = 'Importer Registration Fee';
        var currVal_73 = _co.findTax(_co.taxType.ImportRegisterFee, _co.orderItem).Value;
        var currVal_74 = true;
        var currVal_75 = _co.getCurrency(_co.currency);
        var currVal_76 = _co.findTax(_co.taxType.ImportRegisterFee, _co.clonedOrderItem).Value;
        _ck(_v, 99, 0, currVal_72, currVal_73, currVal_74, currVal_75, currVal_76);
        var currVal_77 = 'One time PAPS Exemption';
        var currVal_78 = _co.findTax(_co.taxType.PAPSFee, _co.orderItem).Value;
        var currVal_79 = true;
        var currVal_80 = _co.getCurrency(_co.currency);
        var currVal_81 = _co.findTax(_co.taxType.PAPSFee, _co.clonedOrderItem).Value;
        _ck(_v, 102, 0, currVal_77, currVal_78, currVal_79, currVal_80, currVal_81);
        var currVal_82 = 'E-Manifest';
        var currVal_83 = _co.findTax(_co.taxType.EManifest, _co.orderItem).Value;
        var currVal_84 = true;
        var currVal_85 = _co.getCurrency(_co.currency);
        var currVal_86 = _co.findTax(_co.taxType.EManifest, _co.clonedOrderItem).Value;
        _ck(_v, 105, 0, currVal_82, currVal_83, currVal_84, currVal_85, currVal_86);
        var currVal_87 = 'Administration Fee';
        var currVal_88 = _co.findTax(_co.taxType.AdminFee, _co.orderItem).Value;
        var currVal_89 = true;
        var currVal_90 = _co.getCurrency(_co.currency);
        var currVal_91 = _co.findTax(_co.taxType.AdminFee, _co.clonedOrderItem).Value;
        _ck(_v, 108, 0, currVal_87, currVal_88, currVal_89, currVal_90, currVal_91);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_92 = ((('$' + core_es5["ɵunv"](_v, 117, 0, _ck(_v, 118, 0, core_es5["ɵnov"](_v, 0), _co.calculateGrantTotalForItem(_co.orderItem, _co.order), '.2-2'))) + ' ') + _co.getCurrency(_co.currency));
        _ck(_v, 117, 0, currVal_92);
    });
}
function View_UsaCalculatorComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'usa-calc-tab', [], null, null, null, View_UsaCalculatorComponent_0, RenderType_UsaCalculatorComponent)), core_es5["ɵdid"](114688, null, 0, usaCalculator_component_UsaCalculatorComponent, [router_es5["n" /* Router */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var UsaCalculatorComponentNgFactory = core_es5["ɵccf"]('usa-calc-tab', usaCalculator_component_UsaCalculatorComponent, View_UsaCalculatorComponent_Host_0, { isPublic: 'isPublic',
    orderItem: 'orderItem', currency: 'currency', order: 'order', clonedOrder: 'clonedOrder',
    clonedOrderItem: 'clonedOrderItem' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=usaCalculator.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/calculator/accordions/order-details-accordion/order-details-accordion.component.ts
/**
 * Created by vlad.p on 9/11/2017.
 */








var order_details_accordion_component_OrderDetailsAccordionComponent = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](OrderDetailsAccordionComponent, _super);
    function OrderDetailsAccordionComponent(router) {
        var _this = _super.call(this) || this;
        _this.router = router;
        _this.clonedOrderItem = new orders_orderItem["b" /* OrderItem */]();
        _this.isPublic = false;
        _this.calculatorHelper = calculatorHelper["a" /* CalculatorHelper */];
        _this.taxType = orders_taxType["a" /* TaxType */];
        _this.calculatorType = orders_calculatorType["a" /* CalculatorType */];
        _this.orderOptions = orderOptions["a" /* OrderOptions */];
        return _this;
    }
    OrderDetailsAccordionComponent.ctorParameters = function () { return [{ type: router_es5["n" /* Router */] }]; };
    return OrderDetailsAccordionComponent;
}(baseCalculatorTab_BaseCalculatorTab));

//# sourceMappingURL=order-details-accordion.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/accordions/order-details-accordion/order-details-accordion.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */














var styles_OrderDetailsAccordionComponent = [];
var RenderType_OrderDetailsAccordionComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_OrderDetailsAccordionComponent, data: {} });
function View_OrderDetailsAccordionComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-2 col-sm-1']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'product-name']], [[8, 'title', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ',
            ' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, '', _co.orderItem.Year, '');
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = _co.orderItem.Year;
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_OrderDetailsAccordionComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'cad-calc-tab', [], null, null, null, View_CanadianCalculatorComponent_0, RenderType_CanadianCalculatorComponent)), core_es5["ɵdid"](114688, null, 0, canadianCalculator_component_CanadianCalculatorComponent, [router_es5["n" /* Router */], tax_service["a" /* TaxService */]], { isPublic: [0, 'isPublic'], orderItem: [1, 'orderItem'],
            currency: [2, 'currency'], order: [3, 'order'], clonedOrder: [4, 'clonedOrder'],
            clonedOrderItem: [5, 'clonedOrderItem'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isPublic;
        var currVal_1 = _co.orderItem;
        var currVal_2 = _co.currency;
        var currVal_3 = _co.order;
        var currVal_4 = _co.clonedOrder;
        var currVal_5 = _co.clonedOrderItem;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    }, null);
}
function View_OrderDetailsAccordionComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'usa-calc-tab', [], null, null, null, View_UsaCalculatorComponent_0, RenderType_UsaCalculatorComponent)), core_es5["ɵdid"](114688, null, 0, usaCalculator_component_UsaCalculatorComponent, [router_es5["n" /* Router */]], { isPublic: [0, 'isPublic'], orderItem: [1, 'orderItem'], currency: [2, 'currency'],
            order: [3, 'order'], clonedOrder: [4, 'clonedOrder'], clonedOrderItem: [5, 'clonedOrderItem'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isPublic;
        var currVal_1 = _co.orderItem;
        var currVal_2 = _co.currency;
        var currVal_3 = _co.order;
        var currVal_4 = _co.clonedOrder;
        var currVal_5 = _co.clonedOrderItem;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    }, null);
}
function View_OrderDetailsAccordionComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 76, 'accordion-group', [['class', 'panel'], ['style', 'display: block']], [[2, 'panel-open', null]], null, null, View_AccordionPanelComponent_0, RenderType_AccordionPanelComponent)),
        core_es5["ɵdid"](245760, [['group', 4]], 0, accordion_group_component_AccordionPanelComponent, [accordion_component_AccordionComponent], { isOpen: [0, 'isOpen'] }, null), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 66, 'div', [['accordion-heading', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12 index']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 54, 'div', [['class', 'row order-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'col-xs-4 col-sm-2': 0,
            'col-xs-6 col-sm-3': 1 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'product-name']], [[8, 'title',
                0]], null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderDetailsAccordionComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-sm-4 col-xs-4 mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'short-description text-italic-gray']], [[8, 'title', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'col-sm-2 text-center mobile-hide']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, null, null, null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['BB Fees (', ')'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), core_es5["ɵppd"](2), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'col-sm-2 col-xs-4 text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Total ', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'div', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), core_es5["ɵppd"](2), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'col-sm-1 col-xs-2']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'button', [['class',
                'btn btn-round btn-fab btn-fab-mini pull-right']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'ripple-container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 1, 1, null, View_OrderDetailsAccordionComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 1, 1, null, View_OrderDetailsAccordionComponent_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](1, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.defaultState;
        _ck(_v, 1, 0, currVal_1);
        var currVal_3 = _ck(_v, 18, 0, (_co.orderItem.Year && _co.calculatorHelper.isVehicle(_co.order)), (!_co.orderItem.Year || !_co.calculatorHelper.isVehicle(_co.order)));
        _ck(_v, 17, 0, currVal_3);
        var currVal_6 = (_co.orderItem.Year && _co.calculatorHelper.isVehicle(_co.order));
        _ck(_v, 25, 0, currVal_6);
        var currVal_13 = 'btn btn-round btn-fab btn-fab-mini pull-right';
        var currVal_14 = (((core_es5["ɵnov"](_v, 1) == null) ? null : core_es5["ɵnov"](_v, 1).isOpen) ? 'btn-light-orange' : 'btn-white');
        _ck(_v, 59, 0, currVal_13, currVal_14);
        var currVal_16 = (_co.order.CalculatorType == _co.calculatorType.CanadianImport);
        _ck(_v, 72, 0, currVal_16);
        var currVal_17 = (_co.order.CalculatorType == _co.calculatorType.UsaImport);
        _ck(_v, 75, 0, currVal_17);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵnov"](_v, 1).isOpen;
        _ck(_v, 0, 0, currVal_0);
        var currVal_2 = ('Product #' + _co.index);
        _ck(_v, 10, 0, currVal_2);
        var currVal_4 = core_es5["ɵinlineInterpolate"](1, '', ((_co.orderItem.Product == null) ? null : _co.orderItem.Product.Name), '');
        _ck(_v, 20, 0, currVal_4);
        var currVal_5 = ((_co.orderItem.Product == null) ? null : _co.orderItem.Product.Name);
        _ck(_v, 21, 0, currVal_5);
        var currVal_7 = core_es5["ɵinlineInterpolate"](1, '', ((_co.orderItem.Product == null) ? null : _co.orderItem.Product.Description), '');
        _ck(_v, 29, 0, currVal_7);
        var currVal_8 = ((_co.orderItem.Product == null) ? null : _co.orderItem.Product.Description);
        _ck(_v, 30, 0, currVal_8);
        var currVal_9 = _co.getCurrency(_co.currency);
        _ck(_v, 38, 0, currVal_9);
        var currVal_10 = (' ' + core_es5["ɵunv"](_v, 41, 0, _ck(_v, 42, 0, core_es5["ɵnov"](_v.parent, 0), _co.findTax(_co.taxType.AAFee, _co.orderItem).Value, '.2-2')));
        _ck(_v, 41, 0, currVal_10);
        var currVal_11 = (('(' + _co.getCurrency(_co.currency)) + ')');
        _ck(_v, 49, 0, currVal_11);
        var currVal_12 = core_es5["ɵunv"](_v, 52, 0, _ck(_v, 53, 0, core_es5["ɵnov"](_v.parent, 0), _co.calculateGrantTotalForItem(_co.orderItem, _co.order), '.2-2'));
        _ck(_v, 52, 0, currVal_12);
        var currVal_15 = (((core_es5["ɵnov"](_v, 1) == null) ? null : core_es5["ɵnov"](_v, 1).isOpen) ? 'expand_less' : 'expand_more');
        _ck(_v, 63, 0, currVal_15);
    });
}
function View_OrderDetailsAccordionComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'cad-calc-tab', [], null, null, null, View_CanadianCalculatorComponent_0, RenderType_CanadianCalculatorComponent)), core_es5["ɵdid"](114688, null, 0, canadianCalculator_component_CanadianCalculatorComponent, [router_es5["n" /* Router */], tax_service["a" /* TaxService */]], { isPublic: [0, 'isPublic'], orderItem: [1, 'orderItem'],
            currency: [2, 'currency'], order: [3, 'order'], clonedOrder: [4, 'clonedOrder'],
            clonedOrderItem: [5, 'clonedOrderItem'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isPublic;
        var currVal_1 = _co.orderItem;
        var currVal_2 = _co.currency;
        var currVal_3 = _co.order;
        var currVal_4 = _co.clonedOrder;
        var currVal_5 = _co.clonedOrderItem;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    }, null);
}
function View_OrderDetailsAccordionComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'usa-calc-tab', [], null, null, null, View_UsaCalculatorComponent_0, RenderType_UsaCalculatorComponent)), core_es5["ɵdid"](114688, null, 0, usaCalculator_component_UsaCalculatorComponent, [router_es5["n" /* Router */]], { isPublic: [0, 'isPublic'], orderItem: [1, 'orderItem'], currency: [2, 'currency'],
            order: [3, 'order'], clonedOrder: [4, 'clonedOrder'], clonedOrderItem: [5, 'clonedOrderItem'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isPublic;
        var currVal_1 = _co.orderItem;
        var currVal_2 = _co.currency;
        var currVal_3 = _co.order;
        var currVal_4 = _co.clonedOrder;
        var currVal_5 = _co.clonedOrderItem;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    }, null);
}
function View_OrderDetailsAccordionComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'calculator-product-form panel-collapse']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_OrderDetailsAccordionComponent_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_OrderDetailsAccordionComponent_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.order.CalculatorType == _co.calculatorType.CanadianImport);
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = (_co.order.CalculatorType == _co.calculatorType.UsaImport);
        _ck(_v, 6, 0, currVal_1);
    }, null);
}
function View_OrderDetailsAccordionComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DecimalPipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form', [['class', 'form-horizontal calculator-product-form'],
            ['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 3).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['productTaxForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderDetailsAccordionComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_OrderDetailsAccordionComponent_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = (!_co.calculatorHelper.isQuickQuote(_co.order) && !_co.calculatorHelper.isUsService(_co.order));
        _ck(_v, 8, 0, currVal_7);
        var currVal_8 = (_co.calculatorHelper.isQuickQuote(_co.order) || _co.calculatorHelper.isUsService(_co.order));
        _ck(_v, 11, 0, currVal_8);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 5).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 5).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 5).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 5).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 5).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 5).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 5).ngClassPending;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_OrderDetailsAccordionComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-details-accordion', [], null, null, null, View_OrderDetailsAccordionComponent_0, RenderType_OrderDetailsAccordionComponent)), core_es5["ɵdid"](49152, null, 0, order_details_accordion_component_OrderDetailsAccordionComponent, [router_es5["n" /* Router */]], null, null)], null, null);
}
var OrderDetailsAccordionComponentNgFactory = core_es5["ɵccf"]('order-details-accordion', order_details_accordion_component_OrderDetailsAccordionComponent, View_OrderDetailsAccordionComponent_Host_0, { isPublic: 'isPublic', order: 'order', orderItem: 'orderItem', index: 'index', currency: 'currency',
    defaultState: 'defaultState', clonedOrderItem: 'clonedOrderItem', clonedOrder: 'clonedOrder' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=order-details-accordion.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/calculator/cards/order-details-card/order-details-card.component.ts
/**
 * Created by vlad.p on 9/8/2017.
 */
var OrderDetailsCardComponent = /** @class */ (function () {
    function OrderDetailsCardComponent() {
        this.isPublic = false;
    }
    return OrderDetailsCardComponent;
}());

//# sourceMappingURL=order-details-card.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/cards/order-details-card/order-details-card.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_OrderDetailsCardComponent = [];
var RenderType_OrderDetailsCardComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_OrderDetailsCardComponent, data: {} });
function View_OrderDetailsCardComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'order-details-accordion', [], null, null, null, View_OrderDetailsAccordionComponent_0, RenderType_OrderDetailsAccordionComponent)), core_es5["ɵdid"](49152, null, 0, order_details_accordion_component_OrderDetailsAccordionComponent, [router_es5["n" /* Router */]], { isPublic: [0, 'isPublic'], order: [1,
                'order'], orderItem: [2, 'orderItem'], index: [3, 'index'], currency: [4, 'currency'],
            defaultState: [5, 'defaultState'], clonedOrderItem: [6, 'clonedOrderItem'], clonedOrder: [7,
                'clonedOrder'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isPublic;
        var currVal_1 = _co.order;
        var currVal_2 = _v.parent.context.$implicit;
        var currVal_3 = (_v.parent.context.index + 1);
        var currVal_4 = _co.currency;
        var currVal_5 = ((_co.order.OrderItems.length - 1) == _v.parent.context.index);
        var currVal_6 = _co.clonedOrder.OrderItems[_v.parent.context.index];
        var currVal_7 = _co.clonedOrder;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
    }, null);
}
function View_OrderDetailsCardComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderDetailsCardComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.clonedOrder.OrderItems[_v.context.index] && _v.context.$implicit);
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_OrderDetailsCardComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 30, 'div', [['class',
                'card']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 27, 'form', [['class', 'form-horizontal'], ['novalidate', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'submit'],
            [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 4).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['orderSummary', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-header header card-header-text'], ['data-background-color',
                '#E07E3C']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'card-title calculator-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['DETAILED INFORMATION'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'div', [['class', 'card-content order-summary']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 5, 'accordion', [['class', 'panel-group'],
                ['role', 'tablist'], ['style', 'display: block']], [[1, 'aria-multiselectable',
                    0]], null, null, View_AccordionComponent_0, RenderType_AccordionComponent)),
        core_es5["ɵdid"](49152, null, 0, accordion_component_AccordionComponent, [accordion_config_AccordionConfig], { closeOthers: [0,
                'closeOthers'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_OrderDetailsCardComponent_1)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_8 = true;
        _ck(_v, 21, 0, currVal_8);
        var currVal_9 = _co.order.OrderItems;
        _ck(_v, 24, 0, currVal_9);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 6).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 6).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 6).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 6).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 6).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 6).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 6).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = core_es5["ɵnov"](_v, 21).closeOthers;
        _ck(_v, 20, 0, currVal_7);
    });
}
function View_OrderDetailsCardComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-details-card', [], null, null, null, View_OrderDetailsCardComponent_0, RenderType_OrderDetailsCardComponent)), core_es5["ɵdid"](49152, null, 0, OrderDetailsCardComponent, [], null, null)], null, null);
}
var OrderDetailsCardComponentNgFactory = core_es5["ɵccf"]('order-details-card', OrderDetailsCardComponent, View_OrderDetailsCardComponent_Host_0, { order: 'order',
    currency: 'currency', clonedOrder: 'clonedOrder', isPublic: 'isPublic' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=order-details-card.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/tabs/calculator-tab/calculatorTab.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





















var styles_CalculatorTabComponent = [];
var RenderType_CalculatorTabComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CalculatorTabComponent, data: {} });
function View_CalculatorTabComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'spinner']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_CalculatorTabComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class',
                'btn btn-dark-orange btn-round btn-wide'], ['type', 'button']], [[8, 'disabled',
                0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.createOrder(true) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Pay Now ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ((_co.isPublic || _co.paypalDisabled) || ((_co.order.Flag != null) && _co.order.Flag.hasFlag(_co.orderOptions.IsQuickQuote)));
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_CalculatorTabComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class',
                'row public-btns']], [[8, 'hidden', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'col-md-3 text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-white-orange btn-round btn-wide'],
            ['type', 'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.sendOrderToCustomer(_co.order.Id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Send quote by email '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorTabComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = (_co.order.Status == _co.orderStatus.Quoted);
        _ck(_v, 9, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isSpinerVisible;
        _ck(_v, 0, 0, currVal_0);
        var currVal_1 = _co.isEmailSending;
        _ck(_v, 4, 0, currVal_1);
    });
}
function View_CalculatorTabComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), core_es5["ɵpid"](131072, common_es5["AsyncPipe"], [core_es5["ChangeDetectorRef"]])], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 1, 0, core_es5["ɵnov"](_v, 2).transform(_co.fileName$));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalculatorTabComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Upload B3 Form for Customer']))], null, null);
}
function View_CalculatorTabComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 31, 'div', [['class',
                'calc-tab-btn text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn btn-light-orange btn-round btn-email']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.sendOrderToCustomer(_co.order.Id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Email Quote to Customer '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'ripple-container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, [['b3FileUpload', 1]], null, 0, 'input', [['class', 'hidden'], ['name', 'file'], ['type', 'file']], null, [[null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (_co.uploadB3Form($event.target.files[0]) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 13, 'button', [['class', 'btn btn-light-orange btn-round btn-email width-md-initial'],
                ['type', 'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                if (('click' === en)) {
                    var pd_0 = (core_es5["ɵnov"](_v, 8).click() !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), core_es5["ɵpid"](131072, common_es5["AsyncPipe"], [core_es5["ChangeDetectorRef"]]), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_CalculatorTabComponent_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵpid"](131072, common_es5["AsyncPipe"], [core_es5["ChangeDetectorRef"]]),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_CalculatorTabComponent_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵpid"](131072, common_es5["AsyncPipe"], [core_es5["ChangeDetectorRef"]]), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'ripple-container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'button', [['class', 'btn btn-light-orange btn-round btn-email'], ['type',
                'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.sendInviteCustomerEmail() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), core_es5["ɵpid"](131072, common_es5["AsyncPipe"], [core_es5["ChangeDetectorRef"]]), (_l()(), core_es5["ɵted"](null, [' Vehicle app invite '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'ripple-container']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = core_es5["ɵunv"](_v, 15, 0, core_es5["ɵnov"](_v, 16).transform(_co.fileName$));
        _ck(_v, 15, 0, currVal_2);
        var currVal_3 = !core_es5["ɵunv"](_v, 19, 0, core_es5["ɵnov"](_v, 20).transform(_co.fileName$));
        _ck(_v, 19, 0, currVal_3);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ((!_co.isOrderValid || _co.disableChanges) || _co.isEmailSending);
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = core_es5["ɵunv"](_v, 10, 0, core_es5["ɵnov"](_v, 12).transform(_co.fileName$));
        _ck(_v, 10, 0, currVal_1);
        var currVal_4 = core_es5["ɵunv"](_v, 25, 0, core_es5["ɵnov"](_v, 27).transform(_co.isDisableInviteCustomerButton$));
        _ck(_v, 25, 0, currVal_4);
    });
}
function View_CalculatorTabComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-md-6 pull-left']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'errors-summary', [], null, null, null, View_ErrorsSummaryComponent_0, RenderType_ErrorsSummaryComponent)), core_es5["ɵdid"](49152, null, 0, errorsSummary_component_ErrorsSummaryComponent, [], { errors: [0, 'errors'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.errorMessages;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_CalculatorTabComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { customsClearanceFee: 0 }), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorTabComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 52, 'div', [['class', 'row']], [[8, 'hidden', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 37, 'div', [['class',
                'col-sm-9']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 34, 'div', [['class', 'text-center calc-tab']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 31, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-sm-4 col-xs-4']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'calc-tab-info text-ellipsis-multiline-brand']], [[8, 'title', 0]], null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['From:'])), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'col-sm-6 col-xs-4']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'calc-tab-info text-ellipsis-multiline-brand']], [[8, 'title', 0]], null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['To:'])), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class',
                'col-sm-2 col-xs-4']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'calc-tab-info text-ellipsis-multiline-brand']], [[8, 'title', 0]], null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-sm-3 mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'text-center calc-tab']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'calc-tab-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Your quote ID: '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class',
                'row small-tab-row']], [[8, 'hidden', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-lg-3 col-md-6 col-sm-3 col-xs-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'currency-card', [], null, [[null, 'currencyChanged']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('currencyChanged' === en)) {
                var pd_0 = (_co.handleProductsValueChange($event, true) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CurrencyCardComponent_0, RenderType_CurrencyCardComponent)),
        core_es5["ɵdid"](4243456, null, 0, currency_card_component_CurrencyCardComponent, [], { order: [0,
                'order'], title: [1, 'title'], total: [2, 'total'], canadianCurrencyCodes: [3, 'canadianCurrencyCodes'],
            defaultCurrencyCode: [4, 'defaultCurrencyCode'], disableChanges: [5, 'disableChanges'],
            showHighlight: [6, 'showHighlight'] }, { currencyChanged: 'currencyChanged' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-lg-3 col-md-6 col-sm-3 col-xs-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'currency-card', [], null, [[null, 'currencyChanged']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('currencyChanged' === en)) {
                var pd_0 = (_co.handleCustomsValueChange($event, true) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CurrencyCardComponent_0, RenderType_CurrencyCardComponent)),
        core_es5["ɵdid"](4243456, null, 0, currency_card_component_CurrencyCardComponent, [], { order: [0,
                'order'], title: [1, 'title'], total: [2, 'total'], canadianCurrencyCodes: [3, 'canadianCurrencyCodes'],
            defaultCurrencyCode: [4, 'defaultCurrencyCode'], disableChanges: [5, 'disableChanges'],
            showHighlight: [6, 'showHighlight'] }, { currencyChanged: 'currencyChanged' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-lg-3 col-md-6 col-sm-3 col-xs-6 big-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'clearance-fee-card', [], null, [[null, 'currencyChanged'],
            [null, 'orderChangeEmit'], [null, 'totalChange'], [null,
                'aaFeeChangeEmit']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('currencyChanged' === en)) {
                var pd_0 = (_co.handleClearanceFeeChange($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('orderChangeEmit' === en)) {
                var pd_1 = (_co.onBBClearanceFeeChange($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('totalChange' === en)) {
                var pd_2 = ((_co.totalAACustomsClearanceFee = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (('aaFeeChangeEmit' === en)) {
                var pd_3 = ((_co.totalAACustomsClearanceFee = $event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, View_ClearanceFeeCardComponent_0, RenderType_ClearanceFeeCardComponent)),
        core_es5["ɵdid"](4767744, [[1, 4], ['customsClearanceFee', 4]], 0, clearance_fee_card_component_ClearanceFeeCardComponent, [services_orderService["a" /* OrderService */]], { order: [0, 'order'], title: [1, 'title'], total: [2, 'total'],
            percentFee: [3, 'percentFee'], canadianCurrencyCodes: [4, 'canadianCurrencyCodes'],
            defaultCurrencyCode: [5, 'defaultCurrencyCode'], disableChanges: [6, 'disableChanges'],
            showHighlight: [7, 'showHighlight'] }, { currencyChanged: 'currencyChanged',
            orderChangeEmit: 'orderChangeEmit', aaFeeChangeEmit: 'aaFeeChangeEmit' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-lg-3 col-md-6 col-sm-3 col-xs-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'currency-card', [], null, [[null, 'currencyChanged']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('currencyChanged' === en)) {
                var pd_0 = (_co.onGrandTotalChange($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CurrencyCardComponent_0, RenderType_CurrencyCardComponent)),
        core_es5["ɵdid"](4243456, null, 0, currency_card_component_CurrencyCardComponent, [], { order: [0,
                'order'], title: [1, 'title'], total: [2, 'total'], canadianCurrencyCodes: [3, 'canadianCurrencyCodes'],
            defaultCurrencyCode: [4, 'defaultCurrencyCode'], disableChanges: [5, 'disableChanges'],
            showHighlight: [6, 'showHighlight'] }, { currencyChanged: 'currencyChanged' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 40, 'div', [['class', 'row']], [[8, 'hidden', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'col-md-9']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class',
                'card margin-top-10 margin-bottom-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 19, 'div', [['class', 'card-content']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'div', [['class', 'form-group label-floating text-area-long']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class',
                'control-label text-ellipsis-inline']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Comment'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'textarea', [['auto-size', ''], ['class', 'form-control'], ['cols', '100'], ['placeholder',
                'Here you can write some information about this quote'], ['rows', '1'],
            ['wrap', 'soft']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend'],
            ['window', 'keyup']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 99)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 99).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 99)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 99)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 100).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('window:keyup' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 105).onKeyUp() !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.comment = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"],
            core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[8, null], [8, null], [8, null], [2,
                forms_es5["NG_VALUE_ACCESSOR"]]], { isDisabled: [0, 'isDisabled'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), core_es5["ɵdid"](540672, null, 0, elementAutoSize_directive_ElementAutoSize, [core_es5["ElementRef"]], { value: [0, 'value'] }, null), (_l()(), core_es5["ɵted"](null, ['                    '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'material-input']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorTabComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-3']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorTabComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorTabComponent_7)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-details-card', [], [[8, 'hidden', 0]], null, null, View_OrderDetailsCardComponent_0, RenderType_OrderDetailsCardComponent)), core_es5["ɵdid"](49152, null, 0, OrderDetailsCardComponent, [], { order: [0, 'order'], currency: [1,
                'currency'], clonedOrder: [2, 'clonedOrder'], isPublic: [3, 'isPublic'] }, null),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isSpinerVisible;
        _ck(_v, 2, 0, currVal_0);
        var currVal_11 = _co.order;
        var currVal_12 = ('Total Value of Product' + ((_co.order.OrderItems.length > 1) ? 's' : ''));
        var currVal_13 = _co.totalPriceBase;
        var currVal_14 = _co.canadianCurrencyCodes;
        var currVal_15 = _co.totalPriceDefaultCode;
        var currVal_16 = _co.disableChanges;
        var currVal_17 = (_co.totalPriceBase != _co.clonedTotalPriceBase);
        _ck(_v, 63, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17);
        var currVal_18 = _co.order;
        var currVal_19 = 'Value for Customs';
        var currVal_20 = _co.totalPriceInCurrency;
        var currVal_21 = _co.canadianCurrencyCodes;
        var currVal_22 = _co.order.Currency;
        var currVal_23 = _co.disableChanges;
        var currVal_24 = (_co.totalPriceInCurrency != _co.clonedTotalPriceInCurrency);
        _ck(_v, 69, 0, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24);
        var currVal_25 = _co.order;
        var currVal_26 = 'BorderBuddy Customs Clearance Fee';
        var currVal_27 = _co.totalAACustomsClearanceFee;
        var currVal_28 = _co.calculatePercentFee();
        var currVal_29 = _co.canadianCurrencyCodes;
        var currVal_30 = _co.order.Currency;
        var currVal_31 = _co.disableChanges;
        var currVal_32 = (((_co.totalAACustomsClearanceFee == null) ? null : _co.totalAACustomsClearanceFee.toFixed(2)) != ((_co.clonedTotalAACustomsClearanceFee == null) ? null : _co.clonedTotalAACustomsClearanceFee.toFixed(2)));
        _ck(_v, 75, 0, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32);
        var currVal_33 = _co.order;
        var currVal_34 = 'Grand Total Payable';
        var currVal_35 = _co.totalGrand;
        var currVal_36 = _co.canadianCurrencyCodes;
        var currVal_37 = _co.order.Currency;
        var currVal_38 = _co.disableChanges;
        var currVal_39 = (_co.totalGrand != _co.clonedTotalGrand);
        _ck(_v, 81, 0, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39);
        var currVal_48 = _co.isEmailSending;
        var currVal_49 = _co.comment;
        _ck(_v, 102, 0, currVal_48, currVal_49);
        var currVal_50 = _co.comment;
        _ck(_v, 105, 0, currVal_50);
        var currVal_51 = _co.isPublic;
        _ck(_v, 115, 0, currVal_51);
        var currVal_52 = !_co.isPublic;
        _ck(_v, 120, 0, currVal_52);
        var currVal_53 = (_co.errorMessages && (_co.errorMessages.length > 0));
        _ck(_v, 124, 0, currVal_53);
        var currVal_55 = _co.order;
        var currVal_56 = ((_co.order.Currency == null) ? null : _co.order.Currency.Name);
        var currVal_57 = _co.clonedOrder;
        var currVal_58 = _co.isPublic;
        _ck(_v, 128, 0, currVal_55, currVal_56, currVal_57, currVal_58);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.isSpinerVisible;
        _ck(_v, 4, 0, currVal_1);
        var currVal_2 = core_es5["ɵinlineInterpolate"](1, '', _co.locationUtil.formatAddress(_co.order.Customer.Location, true), '');
        _ck(_v, 14, 0, currVal_2);
        var currVal_3 = _co.locationUtil.formatAddress(_co.order.Customer.Location, true);
        _ck(_v, 18, 0, currVal_3);
        var currVal_4 = core_es5["ɵinlineInterpolate"](1, '', _co.locationUtil.formatAddress(_co.locationUtil.getShipmentTo(_co.order.Locations), true), '');
        _ck(_v, 23, 0, currVal_4);
        var currVal_5 = _co.locationUtil.formatAddress(_co.locationUtil.getShipmentTo(_co.order.Locations), true);
        _ck(_v, 27, 0, currVal_5);
        var currVal_6 = core_es5["ɵinlineInterpolate"](1, '', (!_co.order.IsCommercial ? ((_co.order.Customer.FirstName + ' ') + _co.order.Customer.LastName) : _co.order.Customer.Company.Name), '');
        _ck(_v, 32, 0, currVal_6);
        var currVal_7 = (_co.order.IsCommercial ? ' Commercial' : 'Personal');
        _ck(_v, 35, 0, currVal_7);
        var currVal_8 = (!_co.order.IsCommercial ? ((_co.order.Customer.FirstName + ' ') + _co.order.Customer.LastName) : _co.order.Customer.Company.Name);
        _ck(_v, 38, 0, currVal_8);
        var currVal_9 = ('BB-' + _co.order.Id);
        _ck(_v, 52, 0, currVal_9);
        var currVal_10 = _co.isSpinerVisible;
        _ck(_v, 58, 0, currVal_10);
        var currVal_40 = _co.isSpinerVisible;
        _ck(_v, 85, 0, currVal_40);
        var currVal_41 = core_es5["ɵnov"](_v, 104).ngClassUntouched;
        var currVal_42 = core_es5["ɵnov"](_v, 104).ngClassTouched;
        var currVal_43 = core_es5["ɵnov"](_v, 104).ngClassPristine;
        var currVal_44 = core_es5["ɵnov"](_v, 104).ngClassDirty;
        var currVal_45 = core_es5["ɵnov"](_v, 104).ngClassValid;
        var currVal_46 = core_es5["ɵnov"](_v, 104).ngClassInvalid;
        var currVal_47 = core_es5["ɵnov"](_v, 104).ngClassPending;
        _ck(_v, 98, 0, currVal_41, currVal_42, currVal_43, currVal_44, currVal_45, currVal_46, currVal_47);
        var currVal_54 = _co.isSpinerVisible;
        _ck(_v, 127, 0, currVal_54);
    });
}
function View_CalculatorTabComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'calculator-tab', [], null, null, null, View_CalculatorTabComponent_0, RenderType_CalculatorTabComponent)), core_es5["ɵdid"](4243456, null, 0, calculatorTab_component_CalculatorTabComponent, [toast_manager["ToastsManager"], services_orderService["a" /* OrderService */], router_es5["n" /* Router */], services_emailService["a" /* EmailService */], services_configService["a" /* ConfigService */],
            uploadService_UploadService], null, null)], null, null);
}
var CalculatorTabComponentNgFactory = core_es5["ɵccf"]('calculator-tab', calculatorTab_component_CalculatorTabComponent, View_CalculatorTabComponent_Host_0, { isPublic: 'isPublic',
    order: 'order', wizard: 'wizard', canadianCurrencyCodes: 'canadianCurrencyCodes',
    disableChanges: 'disableChanges', isOrderDetails: 'isOrderDetails', orderDataComp: 'orderDataComp',
    clonedOrder: 'clonedOrder' }, { orderChange: 'orderChange' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=calculatorTab.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/services/orderContentService.ts



/**
 * Created by alex.y on 10/3/2017.
 */
var orderContentService_OrderContentService = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](OrderContentService, _super);
    function OrderContentService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.controllerUrl = 'ordercontent';
        return _this;
    }
    OrderContentService.prototype.getByOrderIdAndStatus = function (orderId, orderStatus) {
        if (orderStatus === void 0) { orderStatus = null; }
        var params = new http_es5["l" /* URLSearchParams */]();
        if (orderStatus)
            params.append('orderstatus', orderStatus.toString());
        return this.get(new http_es5["i" /* RequestOptions */]({
            url: this.controllerUrl + "/" + orderId,
            search: params
        }));
    };
    OrderContentService.prototype.modify = function (contents) {
        return this.post(new http_es5["i" /* RequestOptions */]({
            url: "" + this.controllerUrl,
            body: contents
        }));
    };
    OrderContentService.prototype.deleteByIds = function (ids) {
        var params = new http_es5["l" /* URLSearchParams */]();
        ids.forEach(function (i) { return params.append("ids", i.toString()); });
        return this.delete(new http_es5["i" /* RequestOptions */]({
            url: "" + this.controllerUrl,
            search: params
        }));
    };
    return OrderContentService;
}(baseService["a" /* BaseApi */]));

//# sourceMappingURL=orderContentService.js.map
// CONCATENATED MODULE: ./app/components/Managment/orderManagement/orderData/tabs/preparingDocTab.component.ts



/**
 * Created by alex.y on 10/2/2017.
 */
var preparingDocTab_component_PreparingDocTabComponent = /** @class */ (function () {
    function PreparingDocTabComponent(orderContentService) {
        this.orderContentService = orderContentService;
        this.isReadOnly = false;
        this.showTitle = true;
        this.showContinue = false;
        this.completeOrderEvent = new core_es5["EventEmitter"]();
    }
    PreparingDocTabComponent.prototype.saveComment = function () {
        var _this = this;
        if (this.isReadOnly)
            return;
        var arr = new Array();
        arr.push(this.orderContent);
        this.orderContentService.modify(arr).then(function (resp) {
            if (!resp.Data || resp.Data.length == 0)
                return;
            if (resp.Data[0].OrderStatus == _this.tabNumber)
                _this.orderContent = resp.Data[0];
        });
    };
    PreparingDocTabComponent.prototype.getTitle = function () {
        switch (this.tabNumber) {
            case (orders_orderStatus["a" /* OrderStatus */].Quoted):
                return "Payment";
            case (orders_orderStatus["a" /* OrderStatus */].Paid):
                return "Prepared Documents";
            case (orders_orderStatus["a" /* OrderStatus */].PrepareDoc):
                return "Sent to customs";
            case (orders_orderStatus["a" /* OrderStatus */].SentToCustom):
                return "Customs released";
            case (orders_orderStatus["a" /* OrderStatus */].CustomReleased):
            case (orders_orderStatus["a" /* OrderStatus */].BorderCrossed):
            case (orders_orderStatus["a" /* OrderStatus */].Closed):
                return "Case closed";
        }
    };
    PreparingDocTabComponent.ctorParameters = function () { return [{ type: orderContentService_OrderContentService }]; };
    return PreparingDocTabComponent;
}());

//# sourceMappingURL=preparingDocTab.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/orderManagement/orderData/tabs/preparingDocTab.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */







var styles_PreparingDocTabComponent = [];
var RenderType_PreparingDocTabComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_PreparingDocTabComponent, data: {} });
function View_PreparingDocTabComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'card-header header card-header-text'], ['data-background-color', '#E07E3C']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [['class', 'central-title text-uppercase']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['',
            ''])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getTitle();
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_PreparingDocTabComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class',
                'card']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PreparingDocTabComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'textarea', [], [[8, 'readOnly',
                    0], [8, 'placeholder', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                    null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
                [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                    null]], [[null, 'ngModelChange'], [null,
                    'focusout'], [null, 'input'], [null, 'blur'], [null,
                    'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('input' === en)) {
                    var pd_0 = (core_es5["ɵnov"](_v, 12)._handleInput($event.target.value) !== false);
                    ad = (pd_0 && ad);
                }
                if (('blur' === en)) {
                    var pd_1 = (core_es5["ɵnov"](_v, 12).onTouched() !== false);
                    ad = (pd_1 && ad);
                }
                if (('compositionstart' === en)) {
                    var pd_2 = (core_es5["ɵnov"](_v, 12)._compositionStart() !== false);
                    ad = (pd_2 && ad);
                }
                if (('compositionend' === en)) {
                    var pd_3 = (core_es5["ɵnov"](_v, 12)._compositionEnd($event.target.value) !== false);
                    ad = (pd_3 && ad);
                }
                if (('input' === en)) {
                    var pd_4 = (core_es5["ɵnov"](_v, 13).ngOnChange($event.target.value) !== false);
                    ad = (pd_4 && ad);
                }
                if (('ngModelChange' === en)) {
                    var pd_5 = ((_co.orderContent.Data.Data = $event) !== false);
                    ad = (pd_5 && ad);
                }
                if (('focusout' === en)) {
                    var pd_6 = (_co.saveComment() !== false);
                    ad = (pd_6 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"],
            core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[8, null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, ['\n                '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.showTitle;
        _ck(_v, 3, 0, currVal_0);
        var currVal_10 = _co.orderContent.Data.Data;
        _ck(_v, 15, 0, currVal_10);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.isReadOnly;
        var currVal_2 = (_co.isReadOnly ? '' : 'Here you can write some information about this step');
        var currVal_3 = core_es5["ɵnov"](_v, 17).ngClassUntouched;
        var currVal_4 = core_es5["ɵnov"](_v, 17).ngClassTouched;
        var currVal_5 = core_es5["ɵnov"](_v, 17).ngClassPristine;
        var currVal_6 = core_es5["ɵnov"](_v, 17).ngClassDirty;
        var currVal_7 = core_es5["ɵnov"](_v, 17).ngClassValid;
        var currVal_8 = core_es5["ɵnov"](_v, 17).ngClassInvalid;
        var currVal_9 = core_es5["ɵnov"](_v, 17).ngClassPending;
        _ck(_v, 11, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9);
    });
}
function View_PreparingDocTabComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'col-md-12 text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class',
                'btn btn-round btn-dark-orange btn-wide complete-button margin-top-10']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.completeOrderEvent.emit(true) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var currVal_0 = 'COMPLETE';
        _ck(_v, 6, 0, currVal_0);
    });
}
function View_PreparingDocTabComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PreparingDocTabComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PreparingDocTabComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.orderContent;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = (!_co.isReadOnly && _co.showContinue);
        _ck(_v, 4, 0, currVal_1);
    }, null);
}
function View_PreparingDocTabComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-prep-doc-tab', [], null, null, null, View_PreparingDocTabComponent_0, RenderType_PreparingDocTabComponent)), core_es5["ɵdid"](49152, null, 0, preparingDocTab_component_PreparingDocTabComponent, [orderContentService_OrderContentService], null, null)], null, null);
}
var PreparingDocTabComponentNgFactory = core_es5["ɵccf"]('order-prep-doc-tab', preparingDocTab_component_PreparingDocTabComponent, View_PreparingDocTabComponent_Host_0, { orderContent: 'orderContent',
    tabNumber: 'tabNumber', isReadOnly: 'isReadOnly', showTitle: 'showTitle', showContinue: 'showContinue',
    order: 'order' }, { completeOrderEvent: 'completeOrderEvent' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=preparingDocTab.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/rxjs/Observable.js
var Observable = __webpack_require__("rCTf");
var Observable_default = /*#__PURE__*/__webpack_require__.n(Observable);

// EXTERNAL MODULE: ./node_modules/rxjs/Subject.js
var Subject = __webpack_require__("EEr4");
var Subject_default = /*#__PURE__*/__webpack_require__.n(Subject);

// EXTERNAL MODULE: ./node_modules/rxjs/add/observable/of.js
var of = __webpack_require__("1APj");
var of_default = /*#__PURE__*/__webpack_require__.n(of);

// EXTERNAL MODULE: ./node_modules/rxjs/add/observable/from.js
var observable_from = __webpack_require__("S35O");
var from_default = /*#__PURE__*/__webpack_require__.n(observable_from);

// EXTERNAL MODULE: ./node_modules/rxjs/add/operator/mergeMap.js
var mergeMap = __webpack_require__("HcJ8");
var mergeMap_default = /*#__PURE__*/__webpack_require__.n(mergeMap);

// EXTERNAL MODULE: ./node_modules/rxjs/add/operator/map.js
var map = __webpack_require__("+pb+");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// CONCATENATED MODULE: ./node_modules/ngx-uploader/lib/src/ngx-uploader/classes/ngx-uploader.class.js







var UploadStatus;
(function (UploadStatus) {
    UploadStatus[UploadStatus["Queue"] = 0] = "Queue";
    UploadStatus[UploadStatus["Uploading"] = 1] = "Uploading";
    UploadStatus[UploadStatus["Done"] = 2] = "Done";
    UploadStatus[UploadStatus["Cancelled"] = 3] = "Cancelled";
})(UploadStatus || (UploadStatus = {}));
function humanizeBytes(bytes) {
    if (bytes === 0) {
        return '0 Byte';
    }
    var k = 1024;
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}
var ngx_uploader_class_NgUploaderService = (function () {
    function NgUploaderService(concurrency) {
        if (concurrency === void 0) { concurrency = Number.POSITIVE_INFINITY; }
        var _this = this;
        this.queue = [];
        this.serviceEvents = new core_es5["EventEmitter"]();
        this.uploadScheduler = new Subject["Subject"]();
        this.subs = [];
        this.uploadScheduler
            .mergeMap(function (upload) { return _this.startUpload(upload); }, concurrency)
            .subscribe(function (uploadOutput) { return _this.serviceEvents.emit(uploadOutput); });
    }
    NgUploaderService.prototype.handleFiles = function (incomingFiles) {
        var _this = this;
        (_a = this.queue).push.apply(_a, [].map.call(incomingFiles, function (file, i) {
            var uploadFile = {
                fileIndex: i,
                id: _this.generateId(),
                name: file.name,
                size: file.size,
                type: file.type,
                form: new FormData(),
                progress: {
                    status: UploadStatus.Queue,
                    data: {
                        percentage: 0,
                        speed: 0,
                        speedHuman: humanizeBytes(0) + "/s",
                        startTime: null,
                        endTime: null,
                        eta: null,
                        etaHuman: null
                    }
                },
                lastModifiedDate: file.lastModifiedDate,
                sub: undefined,
                nativeFile: file
            };
            _this.serviceEvents.emit({ type: 'addedToQueue', file: uploadFile });
            return uploadFile;
        }));
        this.serviceEvents.emit({ type: 'allAddedToQueue' });
        var _a;
    };
    NgUploaderService.prototype.initInputEvents = function (input) {
        var _this = this;
        input.subscribe(function (event) {
            switch (event.type) {
                case 'uploadFile':
                    var uploadFileIndex = _this.queue.findIndex(function (file) { return file === event.file; });
                    if (uploadFileIndex !== -1 && event.file) {
                        _this.uploadScheduler.next({ file: _this.queue[uploadFileIndex], event: event });
                    }
                    break;
                case 'uploadAll':
                    var files = _this.queue.filter(function (file) { return file.progress.status === UploadStatus.Queue; });
                    files.forEach(function (file) { return _this.uploadScheduler.next({ file: file, event: event }); });
                    break;
                case 'cancel':
                    var id_1 = event.id || null;
                    if (!id_1) {
                        return;
                    }
                    var index = _this.subs.findIndex(function (sub) { return sub.id === id_1; });
                    if (index !== -1 && _this.subs[index].sub) {
                        _this.subs[index].sub.unsubscribe();
                        var fileIndex = _this.queue.findIndex(function (file) { return file.id === id_1; });
                        if (fileIndex !== -1) {
                            _this.queue[fileIndex].progress.status = UploadStatus.Cancelled;
                            _this.serviceEvents.emit({ type: 'cancelled', file: _this.queue[fileIndex] });
                        }
                    }
                    break;
                case 'cancelAll':
                    _this.subs.forEach(function (sub) {
                        if (sub.sub) {
                            sub.sub.unsubscribe();
                        }
                        var file = _this.queue.find(function (uploadFile) { return uploadFile.id === sub.id; });
                        if (file) {
                            file.progress.status = UploadStatus.Cancelled;
                            _this.serviceEvents.emit({ type: 'cancelled', file: file });
                        }
                    });
                    break;
                case 'remove':
                    if (!event.id) {
                        return;
                    }
                    var i = _this.queue.findIndex(function (file) { return file.id === event.id; });
                    if (i !== -1) {
                        var file = _this.queue[i];
                        _this.queue.splice(i, 1);
                        _this.serviceEvents.emit({ type: 'removed', file: file });
                    }
                    break;
                case 'removeAll':
                    if (_this.queue.length) {
                        _this.queue = [];
                        _this.serviceEvents.emit({ type: 'removedAll' });
                    }
                    break;
            }
        });
    };
    NgUploaderService.prototype.startUpload = function (upload) {
        var _this = this;
        return new Observable["Observable"](function (observer) {
            var sub = _this.uploadFile(upload.file, upload.event)
                .subscribe(function (output) {
                observer.next(output);
            }, function (err) {
                observer.error(err);
                observer.complete();
            }, function () {
                observer.complete();
            });
            _this.subs.push({ id: upload.file.id, sub: sub });
        });
    };
    NgUploaderService.prototype.uploadFile = function (file, event) {
        var _this = this;
        return new Observable["Observable"](function (observer) {
            var url = event.url || '';
            var method = event.method || 'POST';
            var data = event.data || {};
            var headers = event.headers || {};
            var reader = new FileReader();
            var xhr = new XMLHttpRequest();
            var time = new Date().getTime();
            var progressStartTime = (file.progress.data && file.progress.data.startTime) || time;
            var speed = 0;
            var eta = null;
            xhr.upload.addEventListener('progress', function (e) {
                if (e.lengthComputable) {
                    var percentage = Math.round((e.loaded * 100) / e.total);
                    var diff = new Date().getTime() - time;
                    speed = Math.round(e.loaded / diff * 1000);
                    progressStartTime = (file.progress.data && file.progress.data.startTime) || new Date().getTime();
                    eta = Math.ceil((e.total - e.loaded) / speed);
                    file.progress = {
                        status: UploadStatus.Uploading,
                        data: {
                            percentage: percentage,
                            speed: speed,
                            speedHuman: humanizeBytes(speed) + "/s",
                            startTime: progressStartTime,
                            endTime: null,
                            eta: eta,
                            etaHuman: _this.secondsToHuman(eta)
                        }
                    };
                    observer.next({ type: 'uploading', file: file });
                }
            }, false);
            xhr.upload.addEventListener('error', function (e) {
                observer.error(e);
                observer.complete();
            });
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    var speedAverage = Math.round(file.size / (new Date().getTime() - progressStartTime) * 1000);
                    file.progress = {
                        status: UploadStatus.Done,
                        data: {
                            percentage: 100,
                            speed: speedAverage,
                            speedHuman: humanizeBytes(speedAverage) + "/s",
                            startTime: progressStartTime,
                            endTime: new Date().getTime(),
                            eta: eta,
                            etaHuman: _this.secondsToHuman(eta || 0)
                        }
                    };
                    file.responseStatus = xhr.status;
                    try {
                        file.response = JSON.parse(xhr.response);
                    }
                    catch (e) {
                        file.response = xhr.response;
                    }
                    observer.next({ type: 'done', file: file });
                    observer.complete();
                }
            };
            xhr.open(method, url, true);
            xhr.withCredentials = event.withCredentials ? true : false;
            try {
                var uploadFile_1 = file.nativeFile;
                var uploadIndex = _this.queue.findIndex(function (file) { return file.nativeFile === uploadFile_1; });
                if (_this.queue[uploadIndex].progress.status === UploadStatus.Cancelled) {
                    observer.complete();
                }
                file.form.append(event.fieldName || 'file', uploadFile_1, uploadFile_1.name);
                Object.keys(data).forEach(function (key) { return file.form.append(key, data[key]); });
                Object.keys(headers).forEach(function (key) { return xhr.setRequestHeader(key, headers[key]); });
                _this.serviceEvents.emit({ type: 'start', file: file });
                xhr.send(file.form);
            }
            catch (e) {
                observer.complete();
            }
            return function () {
                xhr.abort();
                reader.abort();
            };
        });
    };
    NgUploaderService.prototype.secondsToHuman = function (sec) {
        return new Date(sec * 1000).toISOString().substr(11, 8);
    };
    NgUploaderService.prototype.generateId = function () {
        return Math.random().toString(36).substring(7);
    };
    return NgUploaderService;
}());


// CONCATENATED MODULE: ./node_modules/ngx-uploader/lib/src/ngx-uploader/directives/ng-file-drop.directive.js
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var ng_file_drop_directive_NgFileDropDirective = (function () {
    function NgFileDropDirective(elementRef) {
        this.elementRef = elementRef;
        this.stopEvent = function (e) {
            e.stopPropagation();
            e.preventDefault();
        };
        this.uploadOutput = new core_es5["EventEmitter"]();
    }
    NgFileDropDirective.prototype.ngOnInit = function () {
        var _this = this;
        var concurrency = this.options && this.options.concurrency || Number.POSITIVE_INFINITY;
        this.upload = new ngx_uploader_class_NgUploaderService(concurrency);
        this.el = this.elementRef.nativeElement;
        this.upload.serviceEvents.subscribe(function (event) {
            _this.uploadOutput.emit(event);
        });
        if (this.uploadInput instanceof core_es5["EventEmitter"]) {
            this.upload.initInputEvents(this.uploadInput);
        }
        this.el.addEventListener('drop', this.stopEvent, false);
        this.el.addEventListener('dragenter', this.stopEvent, false);
        this.el.addEventListener('dragover', this.stopEvent, false);
    };
    NgFileDropDirective.prototype.ngOnDestroy = function () {
        if (this.uploadInput) {
            this.uploadInput.unsubscribe();
        }
    };
    NgFileDropDirective.prototype.onDrop = function (e) {
        e.stopPropagation();
        e.preventDefault();
        var event = { type: 'drop' };
        this.uploadOutput.emit(event);
        this.upload.handleFiles(e.dataTransfer.files);
    };
    NgFileDropDirective.prototype.onDragOver = function (e) {
        if (!e) {
            return;
        }
        var event = { type: 'dragOver' };
        this.uploadOutput.emit(event);
    };
    NgFileDropDirective.prototype.onDragLeave = function (e) {
        if (!e) {
            return;
        }
        var event = { type: 'dragOut' };
        this.uploadOutput.emit(event);
    };
    __decorate([
        Object(core_es5["Input"])(),
        __metadata("design:type", Object)
    ], NgFileDropDirective.prototype, "options", void 0);
    __decorate([
        Object(core_es5["Input"])(),
        __metadata("design:type", core_es5["EventEmitter"])
    ], NgFileDropDirective.prototype, "uploadInput", void 0);
    __decorate([
        Object(core_es5["Output"])(),
        __metadata("design:type", core_es5["EventEmitter"])
    ], NgFileDropDirective.prototype, "uploadOutput", void 0);
    __decorate([
        Object(core_es5["HostListener"])('drop', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], NgFileDropDirective.prototype, "onDrop", null);
    __decorate([
        Object(core_es5["HostListener"])('dragover', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], NgFileDropDirective.prototype, "onDragOver", null);
    __decorate([
        Object(core_es5["HostListener"])('dragleave', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], NgFileDropDirective.prototype, "onDragLeave", null);
    NgFileDropDirective = __decorate([
        Object(core_es5["Directive"])({
            selector: '[ngFileDrop]'
        }),
        __metadata("design:paramtypes", [core_es5["ElementRef"]])
    ], NgFileDropDirective);
    return NgFileDropDirective;
}());


// CONCATENATED MODULE: ./node_modules/ngx-uploader/lib/src/ngx-uploader/directives/ng-file-select.directive.js
var ng_file_select_directive___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ng_file_select_directive___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var ng_file_select_directive_NgFileSelectDirective = (function () {
    function NgFileSelectDirective(elementRef) {
        var _this = this;
        this.elementRef = elementRef;
        this.fileListener = function () {
            if (_this.el.files) {
                _this.upload.handleFiles(_this.el.files);
            }
        };
        this.uploadOutput = new core_es5["EventEmitter"]();
    }
    NgFileSelectDirective.prototype.ngOnInit = function () {
        var _this = this;
        var concurrency = this.options && this.options.concurrency || Number.POSITIVE_INFINITY;
        this.upload = new ngx_uploader_class_NgUploaderService(concurrency);
        this.el = this.elementRef.nativeElement;
        this.el.addEventListener('change', this.fileListener, false);
        this.upload.serviceEvents.subscribe(function (event) {
            _this.uploadOutput.emit(event);
        });
        if (this.uploadInput instanceof core_es5["EventEmitter"]) {
            this.upload.initInputEvents(this.uploadInput);
        }
    };
    NgFileSelectDirective.prototype.ngOnDestroy = function () {
        this.el.removeEventListener('change', this.fileListener, false);
        if (this.uploadInput) {
            this.uploadInput.unsubscribe();
        }
    };
    ng_file_select_directive___decorate([
        Object(core_es5["Input"])(),
        ng_file_select_directive___metadata("design:type", Object)
    ], NgFileSelectDirective.prototype, "options", void 0);
    ng_file_select_directive___decorate([
        Object(core_es5["Input"])(),
        ng_file_select_directive___metadata("design:type", core_es5["EventEmitter"])
    ], NgFileSelectDirective.prototype, "uploadInput", void 0);
    ng_file_select_directive___decorate([
        Object(core_es5["Output"])(),
        ng_file_select_directive___metadata("design:type", core_es5["EventEmitter"])
    ], NgFileSelectDirective.prototype, "uploadOutput", void 0);
    NgFileSelectDirective = ng_file_select_directive___decorate([
        Object(core_es5["Directive"])({
            selector: '[ngFileSelect]'
        }),
        ng_file_select_directive___metadata("design:paramtypes", [core_es5["ElementRef"]])
    ], NgFileSelectDirective);
    return NgFileSelectDirective;
}());


// CONCATENATED MODULE: ./node_modules/ngx-uploader/lib/src/ngx-uploader/module/ngx-uploader.module.js
var ngx_uploader_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var ngx_uploader_module_NgUploaderModule = (function () {
    function NgUploaderModule() {
    }
    NgUploaderModule = ngx_uploader_module___decorate([
        Object(core_es5["NgModule"])({
            declarations: [
                ng_file_select_directive_NgFileSelectDirective,
                ng_file_drop_directive_NgFileDropDirective
            ],
            exports: [
                ng_file_select_directive_NgFileSelectDirective,
                ng_file_drop_directive_NgFileDropDirective
            ]
        })
    ], NgUploaderModule);
    return NgUploaderModule;
}());


// CONCATENATED MODULE: ./node_modules/ngx-uploader/lib/index.js





// CONCATENATED MODULE: ./app/objects/orders/orderContentData.ts
/**
 * Created by alex.y on 10/3/2017.
 */
var OrderContentData = /** @class */ (function () {
    function OrderContentData(obj) {
        Object.assign(this, obj);
    }
    return OrderContentData;
}());

//# sourceMappingURL=orderContentData.js.map
// CONCATENATED MODULE: ./app/objects/orders/orderContent.ts

/**
 * Created by alex.y on 10/3/2017.
 */
var orderContent_OrderContent = /** @class */ (function () {
    function OrderContent(obj) {
        this.Data = new OrderContentData();
        Object.assign(this, obj);
    }
    return OrderContent;
}());

//# sourceMappingURL=orderContent.js.map
// CONCATENATED MODULE: ./app/objects/orders/orderDataType.ts
/**
 * Created by alex.y on 10/3/2017.
 */
var OrderDataType;
(function (OrderDataType) {
    OrderDataType[OrderDataType["Comment"] = 0] = "Comment";
    OrderDataType[OrderDataType["File"] = 1] = "File";
    OrderDataType[OrderDataType["CPB3461"] = 2] = "CPB3461";
    OrderDataType[OrderDataType["CPB7501"] = 3] = "CPB7501";
})(OrderDataType || (OrderDataType = {}));
//# sourceMappingURL=orderDataType.js.map
// CONCATENATED MODULE: ./app/objects/documnets/uploadDocumnet.ts
var UploadDocument = /** @class */ (function () {
    function UploadDocument(init) {
        Object.assign(this, init);
    }
    return UploadDocument;
}());

//# sourceMappingURL=uploadDocumnet.js.map
// CONCATENATED MODULE: ./app/services/documentService.ts



var documentService_DocumentService = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](DocumentService, _super);
    function DocumentService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentService.prototype.save = function (document, type) {
        return this.post(new http_es5["i" /* RequestOptions */]({
            url: "document/" + type,
            body: document
        }));
    };
    DocumentService.prototype.getDocuments = function (orderId, type, skip, top) {
        if (skip === void 0) { skip = 0; }
        if (top === void 0) { top = 10; }
        var params = new http_es5["l" /* URLSearchParams */]();
        params.append('top', top.toString());
        params.append('skip', skip.toString());
        return this.get(new http_es5["i" /* RequestOptions */]({
            url: "document/list/" + type + "/" + orderId,
            search: params
        }));
    };
    DocumentService.prototype.getDocumentById = function (id, type) {
        return this.get(new http_es5["i" /* RequestOptions */]({
            url: "document/" + type + "/" + id
        }));
    };
    DocumentService.prototype.deleteDocumentById = function (id, type) {
        return this.delete(new http_es5["i" /* RequestOptions */]({
            url: "document/" + type + "/" + id
        }));
    };
    return DocumentService;
}(baseService["a" /* BaseApi */]));

//# sourceMappingURL=documentService.js.map
// CONCATENATED MODULE: ./app/components/Managment/orderManagement/orderData/tabs/advancedDocSelector.component.ts















var advancedDocSelector_component_AdvancedDocSelectorComponent = /** @class */ (function () {
    function AdvancedDocSelectorComponent(configService, uploadService, toastrService, contentService, documentService) {
        this.configService = configService;
        this.uploadService = uploadService;
        this.toastrService = toastrService;
        this.contentService = contentService;
        this.documentService = documentService;
        this.documents3461 = [];
        this.documents7501 = [];
        this.completeOrderEvent = new core_es5["EventEmitter"]();
        this.orderStatus = orders_orderStatus["a" /* OrderStatus */];
        this.docs = [];
        this.uploadInput = new core_es5["EventEmitter"]();
        this.isFileUploading = false;
        /*file uploader options end*/
        this.orderDataType = OrderDataType;
        this.files = []; // local uploading files array
        this.uploadInput = new core_es5["EventEmitter"](); // input events, we use this to emit data to ngx-uploader
        this.humanizeBytes = humanizeBytes;
    }
    AdvancedDocSelectorComponent.prototype.ngOnInit = function () {
        this.getDocs();
        perfect_scrollbar["initialize"](this.docSelectorRef.nativeElement);
    };
    AdvancedDocSelectorComponent.prototype.ngOnChanges = function () {
        this.getDocs();
    };
    Object.defineProperty(AdvancedDocSelectorComponent.prototype, "isSelectAll", {
        get: function () {
            if (this.docs.length == 0)
                return false;
            var result = this.docs.find(function (x) { return x.IsSelected == false; });
            return result == null;
        },
        set: function (value) {
            var isSelectAll = this.isSelectAll;
            this.docs.forEach(function (x) { return x.IsSelected = !isSelectAll; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvancedDocSelectorComponent.prototype, "IsAnySelect", {
        get: function () {
            if (this.docs == null)
                return false;
            return this.docs.find(function (x) { return x.IsSelected == true; }) != null;
        },
        enumerable: true,
        configurable: true
    });
    AdvancedDocSelectorComponent.prototype.getCustomDocs = function () {
        var _this = this;
        if (this.documents3461 != null) {
            this.documents3461.forEach(function (document) {
                _this.docs.push(_this.getUploadDocumentObject(document.Name, document.Created, document.Id, OrderDataType.CPB3461));
            });
        }
        if (this.documents7501 != null) {
            this.documents7501.forEach(function (document) {
                _this.docs.push(_this.getUploadDocumentObject(document.Name, document.Created, document.Id, OrderDataType.CPB7501));
            });
        }
    };
    AdvancedDocSelectorComponent.prototype.getUploadDocumentObject = function (name, date, id, type) {
        var datePipe = new common_es5["DatePipe"]("en-US");
        var createdDate = datePipe.transform(date, 'dd/MM/yyyy');
        return new UploadDocument({
            Data: new orderContent_OrderContent({
                Data: new OrderContentData({
                    Data: name + "_" + createdDate,
                    Type: type,
                    Status: 1 // TODO
                }),
                Id: id
            }),
            IsSelected: false,
        });
    };
    AdvancedDocSelectorComponent.prototype.getDocs = function () {
        this.docs = [];
        for (var _i = 0, _a = this.order.DataList; _i < _a.length; _i++) {
            var orderData = _a[_i];
            if (orderData.Data.Type != OrderDataType.Comment && (orderData.OrderStatus == this.tabNumber))
                this.docs.push(new UploadDocument({
                    Data: orderData,
                    IsSelected: false,
                }));
        }
        this.getCustomDocs();
    };
    AdvancedDocSelectorComponent.prototype.startUpload = function () {
        if (this.files.length == 0 || !this.files[0].name || this.files[0].size > 4000000)
            return;
        this.files = this.files.filter(function (file) { return file.size <= 4000000; });
        this.isFileUploading = true;
        var cookie = ng2_cookies["Cookie"].get(this.configService.config.ApiTokenCookieName);
        var event = {
            type: 'uploadFile',
            url: this.configService.config.ApiUrl + "/upload?orderId=" + this.order.Id + "&orderstatus=" + this.order.Status,
            method: 'POST',
            fieldName: "file",
            file: this.files[0],
            data: { 'name': this.files[0].name },
            headers: { Authorization: "Bearer " + cookie }
        };
        this.files = [];
        this.uploadInput.emit(event);
    };
    AdvancedDocSelectorComponent.prototype.onUploadOutput = function (output) {
        if (output.type === 'allAddedToQueue') {
            this.startUpload();
        }
        else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') {
            if (output.file.size > 4000000) {
                this.toastrService.error('size must be less than 4 mb', null, { preventDuplicates: true });
                this.files = [];
            }
            else
                this.files.push(output.file);
        }
        else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
            // update current data in files array for uploading file
            var index = this.files.findIndex(function (file) { return typeof output.file !== 'undefined' && file.id === output.file.id; });
            this.files[index] = output.file;
        }
        else if (output.type === 'removed') {
            // remove file from array when removed
            this.files = this.files.filter(function (file) { return file !== output.file; });
        }
        else if (output.type === 'dragOver') {
            this.dragOver = true;
        }
        else if (output.type === 'dragOut') {
            this.dragOver = false;
        }
        else if (output.type === 'drop') {
            this.dragOver = false;
        }
        else if (output.type == "done")
            this.handleUploaded(output.file.response);
    };
    AdvancedDocSelectorComponent.prototype.handleUploaded = function (response) {
        this.isFileUploading = false;
        if (!response.Data)
            return;
        if (response.Data.OrderStatus == this.tabNumber)
            this.docs.push(new UploadDocument({
                Data: response.Data,
                IsSelected: false,
            }));
        this.order.DataList.push(response.Data);
    };
    AdvancedDocSelectorComponent.prototype.downloadSelectedFiles = function () {
        var docsToDownload = this.docs.filter(function (d) { return d.IsSelected == true; });
        for (var _i = 0, _a = docsToDownload.filter(function (d) { return d.Data.Data.Type == OrderDataType.File; }); _i < _a.length; _i++) {
            var doc = _a[_i];
            this.uploadService.downloadFile(doc.Data.Data.Data);
        }
        for (var _b = 0, _c = docsToDownload.filter(function (d) { return d.Data.Data.Type == OrderDataType.CPB3461; }); _b < _c.length; _b++) {
            var cbp3461 = _c[_b];
            this.uploadService.downloadDocument(cbp3461.Data.Id, 'CBP3461');
        }
        for (var _d = 0, _e = docsToDownload.filter(function (d) { return d.Data.Data.Type == OrderDataType.CPB7501; }); _d < _e.length; _d++) {
            var cbp3461 = _e[_d];
            this.uploadService.downloadDocument(cbp3461.Data.Id, 'CBP7501');
        }
    };
    AdvancedDocSelectorComponent.prototype.delete = function (uploadDocument) {
        var _this = this;
        var index = this.docs.indexOf(uploadDocument);
        this.docs.splice(index, 1);
        if (uploadDocument.Data.Data.Type == OrderDataType.File)
            this.contentService.deleteByIds([uploadDocument.Data.Id]).then(function (x) {
                _this.order.DataList.forEach(function (document) {
                    if (document.Id == uploadDocument.Data.Id) {
                        var index_1 = _this.order.DataList.indexOf(document);
                        if (index_1 >= 0)
                            _this.order.DataList.splice(index_1, 1);
                    }
                });
            });
        else {
            var type = 'CBP3461';
            if (uploadDocument.Data.Data.Type == OrderDataType.CPB7501)
                type = 'CBP7501';
            this.documentService.deleteDocumentById(uploadDocument.Data.Id, type).then(function (x) {
                if (uploadDocument.Data.Data.Type == OrderDataType.CPB7501)
                    _this.removeFromArray(_this.documents7501, uploadDocument.Data.Id);
                else
                    _this.removeFromArray(_this.documents3461, uploadDocument.Data.Id);
            });
        }
    };
    AdvancedDocSelectorComponent.prototype.removeFromArray = function (array, id) {
        var doc = array.find(function (x) { return x.Id == id; });
        var index = array.indexOf(doc);
        array.splice(index, 1);
    };
    AdvancedDocSelectorComponent.prototype.showDocument = function (doc) {
        var _this = this;
        if (doc.Data.Data.Type == OrderDataType.CPB3461) {
            this.documentService.getDocumentById(doc.Data.Id, 'CBP3461').then(function (x) {
                _this.doc3461ModalDir.show(x.Data);
            });
            return;
        }
        if (doc.Data.Data.Type == OrderDataType.CPB7501) {
            this.documentService.getDocumentById(doc.Data.Id, 'CBP7501').then(function (x) {
                _this.doc7501ModalDir.show(x.Data);
            });
            return;
        }
    };
    AdvancedDocSelectorComponent.prototype.handleDocModified = function (doc) {
        if (this.documents3461.find(function (x) { return x.Id == doc.Data.Id; }))
            return;
        var type = OrderDataType.CPB3461;
        this.docs.push(this.getUploadDocumentObject(doc.Data.Name, doc.Data.Created, doc.Data.Id, type));
        this.documents3461.push(doc.Data);
    };
    AdvancedDocSelectorComponent.prototype.handleDoc7501Modified = function (doc) {
        if (this.documents7501.find(function (x) { return x.Id == doc.Data.Id; }))
            return;
        var type = OrderDataType.CPB7501;
        this.docs.push(this.getUploadDocumentObject(doc.Data.Name, doc.Data.Created, doc.Data.Id, type));
        this.documents7501.push(doc.Data);
    };
    AdvancedDocSelectorComponent.ctorParameters = function () { return [{ type: services_configService["a" /* ConfigService */] }, { type: uploadService_UploadService }, { type: ng2_toastr["ToastsManager"] }, { type: orderContentService_OrderContentService }, { type: documentService_DocumentService }]; };
    return AdvancedDocSelectorComponent;
}());

//# sourceMappingURL=advancedDocSelector.component.js.map
// CONCATENATED MODULE: ./app/common/helpers/ValidationPatterns.ts
var ValidationPatterns = /** @class */ (function () {
    function ValidationPatterns() {
    }
    ValidationPatterns.integer = '^[0-9]+$';
    ValidationPatterns.doubleNumber = '^[0-9]+([,.][0-9]{1,2})?$';
    return ValidationPatterns;
}());

//# sourceMappingURL=ValidationPatterns.js.map
// CONCATENATED MODULE: ./app/components/export-documents/cbp-3461/document-blocks/header-info-3461.component.ts

var header_info_3461_component_HeaderInfo3461Component = /** @class */ (function () {
    function HeaderInfo3461Component() {
        this.numberPatternHelper = ValidationPatterns;
        this.stringHelper = String;
    }
    HeaderInfo3461Component.prototype.submitFormAndValidity = function () {
        this.headerInfoForm.onSubmit(null);
        return this.isFormValid();
    };
    HeaderInfo3461Component.prototype.isFormValid = function () {
        return this.headerInfoForm.valid;
    };
    return HeaderInfo3461Component;
}());

//# sourceMappingURL=header-info-3461.component.js.map
// CONCATENATED MODULE: ./app/components/export-documents/form-input-errors.component.ts
var FormInputErrorsComponent = /** @class */ (function () {
    function FormInputErrorsComponent() {
    }
    return FormInputErrorsComponent;
}());

//# sourceMappingURL=form-input-errors.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/export-documents/form-input-errors.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_FormInputErrorsComponent = [];
var RenderType_FormInputErrorsComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_FormInputErrorsComponent, data: {} });
function View_FormInputErrorsComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.inputField.Errors[0];
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_FormInputErrorsComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_FormInputErrorsComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.inputField.IsValid;
        _ck(_v, 1, 0, currVal_0);
    }, null);
}
function View_FormInputErrorsComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], null, null)], null, null);
}
var FormInputErrorsComponentNgFactory = core_es5["ɵccf"]('form-input-errors', FormInputErrorsComponent, View_FormInputErrorsComponent_Host_0, { inputField: 'inputField' }, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvZXhwb3J0LWRvY3VtZW50cy9mb3JtLWlucHV0LWVycm9ycy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvZXhwb3J0LWRvY3VtZW50cy9mb3JtLWlucHV0LWVycm9ycy5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9leHBvcnQtZG9jdW1lbnRzL2Zvcm0taW5wdXQtZXJyb3JzLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvZXhwb3J0LWRvY3VtZW50cy9mb3JtLWlucHV0LWVycm9ycy5jb21wb25lbnQudHMuRm9ybUlucHV0RXJyb3JzQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHNwYW4gY2xhc3M9XCJoZWxwLWJsb2NrXCIgKm5nSWY9XCIhaW5wdXRGaWVsZC5Jc1ZhbGlkXCI+e3tpbnB1dEZpZWxkLkVycm9yc1swXX19PC9zcGFuPiIsIjxmb3JtLWlucHV0LWVycm9ycz48L2Zvcm0taW5wdXQtZXJyb3JzPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO01BQXFEOztJQUFBO0lBQUE7Ozs7b0JBQXJEO01BQUEseUNBQUE7b0JBQUE7O0lBQXlCO0lBQXpCLFdBQXlCLFNBQXpCOzs7O29CQ0FBO01BQUE7eUNBQUEsVUFBQTtNQUFBOzs7OyJ9
//# sourceMappingURL=form-input-errors.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/app/components/export-documents/cbp-3461/document-blocks/header-info-3461.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_HeaderInfo3461Component = [];
var RenderType_HeaderInfo3461Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_HeaderInfo3461Component, data: {} });
function View_HeaderInfo3461Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Port of entry is required']))], null, null);
}
function View_HeaderInfo3461Component_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Importer Number is required']))], null, null);
}
function View_HeaderInfo3461Component_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Importer name and address is required']))], null, null);
}
function View_HeaderInfo3461Component_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Entry Number is required']))], null, null);
}
function View_HeaderInfo3461Component_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Bond Value should contain only digits']))], null, null);
}
function View_HeaderInfo3461Component_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Bond Value is required']))], null, null);
}
function View_HeaderInfo3461Component_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['This field should contain only digits']))], null, null);
}
function View_HeaderInfo3461Component_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Entry Value is required']))], null, null);
}
function View_HeaderInfo3461Component_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Entry Type is required']))], null, null);
}
function View_HeaderInfo3461Component_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Originating whse entry number is required']))], null, null);
}
function View_HeaderInfo3461Component_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Surety Code is required']))], null, null);
}
function View_HeaderInfo3461Component_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Location of goods(firms) is required']))], null, null);
}
function View_HeaderInfo3461Component_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Reference Id Code is required']))], null, null);
}
function View_HeaderInfo3461Component_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Reference Id Number Code is required']))], null, null);
}
function View_HeaderInfo3461Component_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { headerInfoForm: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row margin-bottom-0']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Header Information'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 490, 'form', [['class', 'padding-0'], ['novalidate', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'submit'],
            [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 12).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 12).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[1, 4], ['headerInfoForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-12 line-form margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.PortOfEntry.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['portOfEntryModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_HeaderInfo3461Component_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 134, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 33, 'div', [['class', 'col-md-3 line-form margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 30, 'div', [], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['2. BOND TYPE:'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.BondType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.BondType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.BondType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 49, 'div', [['class',
                'col-md-3 line-form margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 30, 'div', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['3. Importer Number:'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ImporterNumberType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, [['ImporterNumberType', 4]], 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2,
                forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2,
                'radioValue'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ImporterNumberType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, [['ImporterNumberType', 4]], 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2,
                forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2,
                'radioValue'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ImporterNumberType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, [['ImporterNumberType', 4]], 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2,
                forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2,
                'radioValue'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['class', 'input-with-checkbox'], ['required',
                '']], [[8, 'title', 0], [1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ImporterNumber.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['importerNumberModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_HeaderInfo3461Component_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 45, 'div', [['class', 'col-md-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-12 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ImporterNameAndAddress.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['importerNameAndAddressModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_HeaderInfo3461Component_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-12 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.EntryNumber.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['entryNumberModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_HeaderInfo3461Component_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 61, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'col-md-4 line-form margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['required',
                '']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.BondValue.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['bondValueModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_HeaderInfo3461Component_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_HeaderInfo3461Component_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'col-md-4 line-form margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['required',
                '']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.EntryValue.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['entryValueModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_HeaderInfo3461Component_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_HeaderInfo3461Component_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-md-4 line-form margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.Ces.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['cesModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 58, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 line-form margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.EntryType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['entryTypeModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_HeaderInfo3461Component_9)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 line-form margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['class', 'long-label'], ['required', ''], ['title', '10. Originating WHSE entry number:']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.OriginationWhseEntryNumber.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['OriginationWhseEntryNumberModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'], placeholder: [6, 'placeholder'],
            isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_HeaderInfo3461Component_10)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 line-form margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.SuretyCode.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['suretyCodeModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_HeaderInfo3461Component_11)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 121, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 40, 'div', [['class', 'col-md-6 line-form']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-md-12 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.PortOfUnLanding.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['portOfUnLandingModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]],
            [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'],
            name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-12 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.LocationOfGoods.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['locationOfGoodsModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_HeaderInfo3461Component_12)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 76, 'div', [['class',
                'col-md-6 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 73, 'div', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'checkbox-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['13. Mode of transportation:'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 59, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 29, 'div', [['class', 'col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ModeOfTransportation.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, [['ModeOfTransportation', 4]], 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2,
                forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2,
                'radioValue'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ModeOfTransportation.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ModeOfTransportation.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, [['ModeOfTransportation', 4]], 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2,
                forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2,
                'radioValue'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ModeOfTransportation.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class', 'col-md-6 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ModeOfTransportation.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ModeOfTransportation.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ModeOfTransportation.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)),
        core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0,
                'inputField'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 29, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'col-md-4 line-form margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched',
                    null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
                [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                    null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.GONumber.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['gONumberModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'col-md-8 line-form margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched',
                    null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
                [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                    null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.ConveyanceName.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['conveyanceNameModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]],
            [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'],
            name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Header Reference Information'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 39, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 line-form margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ReferenceIdCode.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['referenceIdCodeModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_HeaderInfo3461Component_13)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'col-md-8 line-form margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2,
                    'ng-valid', null], [2, 'ng-invalid', null], [2,
                    'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.ReferenceIdNumber.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['referenceIdNumberModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'], placeholder: [6, 'placeholder'], isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_HeaderInfo3461Component_14)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_15 = '';
        _ck(_v, 21, 0, currVal_15);
        var currVal_16 = !_co.document.PortOfEntry.IsValid;
        var currVal_17 = 'text';
        var currVal_18 = 'Port of entry';
        var currVal_19 = '1. PORT OF ENTRY:';
        var currVal_20 = false;
        var currVal_21 = core_es5["ɵnov"](_v, 12);
        _ck(_v, 23, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21);
        var currVal_22 = 'Port of entry';
        var currVal_23 = false;
        var currVal_24 = _co.document.PortOfEntry.Value;
        _ck(_v, 25, 0, currVal_22, currVal_23, currVal_24);
        var currVal_25 = _co.document.PortOfEntry;
        _ck(_v, 30, 0, currVal_25);
        var currVal_26 = ((core_es5["ɵnov"](_v, 23).model.hasError('required') && (!core_es5["ɵnov"](_v, 23).model.pristine || core_es5["ɵnov"](_v, 12).submitted)) && _co.document.PortOfEntry.IsValid);
        _ck(_v, 33, 0, currVal_26);
        var currVal_27 = _ck(_v, 44, 0, (core_es5["ɵnov"](_v, 12).submitted && (_co.document.BondType.Value == null)));
        _ck(_v, 43, 0, currVal_27);
        var currVal_35 = 'SingleTransactionBond';
        var currVal_36 = 'Single Transaction Bond';
        var currVal_37 = 0;
        _ck(_v, 50, 0, currVal_35, currVal_36, currVal_37);
        var currVal_38 = 'SingleTransactionBond';
        var currVal_39 = _co.document.BondType.Value;
        _ck(_v, 52, 0, currVal_38, currVal_39);
        var currVal_47 = 'Continuous Bond';
        var currVal_48 = 'Continuous Bond';
        var currVal_49 = 1;
        _ck(_v, 57, 0, currVal_47, currVal_48, currVal_49);
        var currVal_50 = 'Continuous Bond';
        var currVal_51 = _co.document.BondType.Value;
        _ck(_v, 59, 0, currVal_50, currVal_51);
        var currVal_59 = 'No Bond Required';
        var currVal_60 = 'No Bond Required';
        var currVal_61 = 2;
        _ck(_v, 64, 0, currVal_59, currVal_60, currVal_61);
        var currVal_62 = 'No Bond Required';
        var currVal_63 = _co.document.BondType.Value;
        _ck(_v, 66, 0, currVal_62, currVal_63);
        var currVal_64 = _co.document.BondType;
        _ck(_v, 71, 0, currVal_64);
        var currVal_65 = _ck(_v, 79, 0, (core_es5["ɵnov"](_v, 12).submitted && (_co.document.ImporterNumberType.Value == null)));
        _ck(_v, 78, 0, currVal_65);
        var currVal_73 = 'IRS';
        var currVal_74 = 'IRS';
        var currVal_75 = 0;
        _ck(_v, 85, 0, currVal_73, currVal_74, currVal_75);
        var currVal_76 = 'IRS';
        var currVal_77 = _co.document.ImporterNumberType.Value;
        _ck(_v, 87, 0, currVal_76, currVal_77);
        var currVal_85 = 'SSN';
        var currVal_86 = 'SSN';
        var currVal_87 = 1;
        _ck(_v, 92, 0, currVal_85, currVal_86, currVal_87);
        var currVal_88 = 'SSN';
        var currVal_89 = _co.document.ImporterNumberType.Value;
        _ck(_v, 94, 0, currVal_88, currVal_89);
        var currVal_97 = 'CBP Assigned';
        var currVal_98 = 'CBP Assigned';
        var currVal_99 = 2;
        _ck(_v, 99, 0, currVal_97, currVal_98, currVal_99);
        var currVal_100 = 'CBP Assigned';
        var currVal_101 = _co.document.ImporterNumberType.Value;
        _ck(_v, 101, 0, currVal_100, currVal_101);
        var currVal_102 = _co.document.ImporterNumberType;
        _ck(_v, 106, 0, currVal_102);
        var currVal_112 = '';
        _ck(_v, 110, 0, currVal_112);
        var currVal_113 = !_co.document.ImporterNumber.IsValid;
        var currVal_114 = 'text';
        var currVal_115 = 'importerNumberModel';
        var currVal_116 = false;
        var currVal_117 = core_es5["ɵnov"](_v, 12);
        _ck(_v, 112, 0, currVal_113, currVal_114, currVal_115, currVal_116, currVal_117);
        var currVal_118 = 'importerNumberModel';
        var currVal_119 = false;
        var currVal_120 = _co.document.ImporterNumber.Value;
        _ck(_v, 114, 0, currVal_118, currVal_119, currVal_120);
        var currVal_121 = _co.document.ImporterNumber;
        _ck(_v, 119, 0, currVal_121);
        var currVal_122 = ((core_es5["ɵnov"](_v, 23).model.hasError('required') && (!core_es5["ɵnov"](_v, 23).model.pristine || core_es5["ɵnov"](_v, 12).submitted)) && _co.document.PortOfEntry.IsValid);
        _ck(_v, 122, 0, currVal_122);
        var currVal_131 = '';
        _ck(_v, 133, 0, currVal_131);
        var currVal_132 = !_co.document.ImporterNameAndAddress.IsValid;
        var currVal_133 = 'text';
        var currVal_134 = 'importerNameAndAddressModel';
        var currVal_135 = '4. Importer name and address:';
        var currVal_136 = false;
        var currVal_137 = core_es5["ɵnov"](_v, 12);
        _ck(_v, 135, 0, currVal_132, currVal_133, currVal_134, currVal_135, currVal_136, currVal_137);
        var currVal_138 = 'importerNameAndAddressModel';
        var currVal_139 = false;
        var currVal_140 = _co.document.ImporterNameAndAddress.Value;
        _ck(_v, 137, 0, currVal_138, currVal_139, currVal_140);
        var currVal_141 = _co.document.ImporterNameAndAddress;
        _ck(_v, 142, 0, currVal_141);
        var currVal_142 = ((core_es5["ɵnov"](_v, 135).model.hasError('required') && (!core_es5["ɵnov"](_v, 135).model.pristine || core_es5["ɵnov"](_v, 12).submitted)) && _co.document.ImporterNameAndAddress.IsValid);
        _ck(_v, 145, 0, currVal_142);
        var currVal_151 = '';
        _ck(_v, 155, 0, currVal_151);
        var currVal_152 = !_co.document.EntryNumber.IsValid;
        var currVal_153 = 'text';
        var currVal_154 = 'entryNumberModel';
        var currVal_155 = '5. Entry Number:';
        var currVal_156 = false;
        var currVal_157 = core_es5["ɵnov"](_v, 12);
        _ck(_v, 157, 0, currVal_152, currVal_153, currVal_154, currVal_155, currVal_156, currVal_157);
        var currVal_158 = 'entryNumberModel';
        var currVal_159 = false;
        var currVal_160 = _co.document.EntryNumber.Value;
        _ck(_v, 159, 0, currVal_158, currVal_159, currVal_160);
        var currVal_161 = _co.document.EntryNumber;
        _ck(_v, 164, 0, currVal_161);
        var currVal_162 = ((core_es5["ɵnov"](_v, 157).model.hasError('required') && (!core_es5["ɵnov"](_v, 157).model.pristine || core_es5["ɵnov"](_v, 12).submitted)) && _co.document.EntryNumber.IsValid);
        _ck(_v, 167, 0, currVal_162);
        var currVal_172 = '';
        _ck(_v, 179, 0, currVal_172);
        var currVal_173 = _co.numberPatternHelper.integer;
        _ck(_v, 180, 0, currVal_173);
        var currVal_174 = !_co.document.BondValue.IsValid;
        var currVal_175 = 'number';
        var currVal_176 = 'bondValueModel';
        var currVal_177 = '6. Bond Value:';
        var currVal_178 = false;
        var currVal_179 = core_es5["ɵnov"](_v, 12);
        _ck(_v, 182, 0, currVal_174, currVal_175, currVal_176, currVal_177, currVal_178, currVal_179);
        var currVal_180 = 'bondValueModel';
        var currVal_181 = false;
        var currVal_182 = _co.document.BondValue.Value;
        _ck(_v, 184, 0, currVal_180, currVal_181, currVal_182);
        var currVal_183 = _co.document.BondValue;
        _ck(_v, 189, 0, currVal_183);
        var currVal_184 = core_es5["ɵnov"](_v, 182).model.hasError('pattern');
        _ck(_v, 192, 0, currVal_184);
        var currVal_185 = ((core_es5["ɵnov"](_v, 182).model.hasError('required') && (!core_es5["ɵnov"](_v, 182).model.pristine || core_es5["ɵnov"](_v, 12).submitted)) && _co.document.BondValue.IsValid);
        _ck(_v, 195, 0, currVal_185);
        var currVal_195 = '';
        _ck(_v, 202, 0, currVal_195);
        var currVal_196 = _co.numberPatternHelper.integer;
        _ck(_v, 203, 0, currVal_196);
        var currVal_197 = !_co.document.EntryValue.IsValid;
        var currVal_198 = 'number';
        var currVal_199 = 'EntryValue';
        var currVal_200 = '7. Entry Value:';
        var currVal_201 = false;
        var currVal_202 = core_es5["ɵnov"](_v, 12);
        _ck(_v, 205, 0, currVal_197, currVal_198, currVal_199, currVal_200, currVal_201, currVal_202);
        var currVal_203 = 'EntryValue';
        var currVal_204 = false;
        var currVal_205 = _co.document.EntryValue.Value;
        _ck(_v, 207, 0, currVal_203, currVal_204, currVal_205);
        var currVal_206 = _co.document.EntryValue;
        _ck(_v, 212, 0, currVal_206);
        var currVal_207 = core_es5["ɵnov"](_v, 205).model.hasError('pattern');
        _ck(_v, 215, 0, currVal_207);
        var currVal_208 = ((core_es5["ɵnov"](_v, 205).model.hasError('required') && (!core_es5["ɵnov"](_v, 205).model.pristine || core_es5["ɵnov"](_v, 12).submitted)) && _co.document.PortOfEntry.IsValid);
        _ck(_v, 218, 0, currVal_208);
        var currVal_216 = !_co.document.Ces.IsValid;
        var currVal_217 = 'text';
        var currVal_218 = 'CES';
        var currVal_219 = '8. CES:';
        var currVal_220 = false;
        var currVal_221 = core_es5["ɵnov"](_v, 12);
        _ck(_v, 225, 0, currVal_216, currVal_217, currVal_218, currVal_219, currVal_220, currVal_221);
        var currVal_222 = 'CES';
        var currVal_223 = false;
        var currVal_224 = _co.document.Ces.Value;
        _ck(_v, 227, 0, currVal_222, currVal_223, currVal_224);
        var currVal_225 = _co.document.Ces;
        _ck(_v, 232, 0, currVal_225);
        var currVal_234 = '';
        _ck(_v, 242, 0, currVal_234);
        var currVal_235 = !_co.document.EntryType.IsValid;
        var currVal_236 = 'number';
        var currVal_237 = 'Entry Type';
        var currVal_238 = '9. Entry Type:';
        var currVal_239 = false;
        var currVal_240 = core_es5["ɵnov"](_v, 12);
        _ck(_v, 244, 0, currVal_235, currVal_236, currVal_237, currVal_238, currVal_239, currVal_240);
        var currVal_241 = 'Entry Type';
        var currVal_242 = false;
        var currVal_243 = _co.document.EntryType.Value;
        _ck(_v, 246, 0, currVal_241, currVal_242, currVal_243);
        var currVal_244 = _co.document.EntryType;
        _ck(_v, 251, 0, currVal_244);
        var currVal_245 = ((core_es5["ɵnov"](_v, 244).model.hasError('required') && (!core_es5["ɵnov"](_v, 244).model.pristine || core_es5["ɵnov"](_v, 12).submitted)) && _co.document.EntryType.IsValid);
        _ck(_v, 254, 0, currVal_245);
        var currVal_254 = '';
        _ck(_v, 261, 0, currVal_254);
        var currVal_255 = !_co.document.OriginationWhseEntryNumber.IsValid;
        var currVal_256 = 'text';
        var currVal_257 = 'OriginationWhseEntryNumberModel';
        var currVal_258 = '10. Originating whse entry number:';
        var currVal_259 = false;
        var currVal_260 = core_es5["ɵnov"](_v, 12);
        var currVal_261 = 'FOR ENTRY TYPE 22 ONLY';
        var currVal_262 = true;
        _ck(_v, 263, 0, currVal_255, currVal_256, currVal_257, currVal_258, currVal_259, currVal_260, currVal_261, currVal_262);
        var currVal_263 = 'OriginationWhseEntryNumberModel';
        var currVal_264 = false;
        var currVal_265 = _co.document.OriginationWhseEntryNumber.Value;
        _ck(_v, 265, 0, currVal_263, currVal_264, currVal_265);
        var currVal_266 = _co.document.OriginationWhseEntryNumber;
        _ck(_v, 270, 0, currVal_266);
        var currVal_267 = ((core_es5["ɵnov"](_v, 263).model.hasError('required') && (!core_es5["ɵnov"](_v, 263).model.pristine || core_es5["ɵnov"](_v, 12).submitted)) && _co.document.OriginationWhseEntryNumber.IsValid);
        _ck(_v, 273, 0, currVal_267);
        var currVal_276 = '';
        _ck(_v, 280, 0, currVal_276);
        var currVal_277 = !_co.document.SuretyCode.IsValid;
        var currVal_278 = 'text';
        var currVal_279 = 'Surety Code';
        var currVal_280 = '11. Surety Code:';
        var currVal_281 = false;
        var currVal_282 = core_es5["ɵnov"](_v, 12);
        _ck(_v, 282, 0, currVal_277, currVal_278, currVal_279, currVal_280, currVal_281, currVal_282);
        var currVal_283 = 'Surety Code';
        var currVal_284 = false;
        var currVal_285 = _co.document.SuretyCode.Value;
        _ck(_v, 284, 0, currVal_283, currVal_284, currVal_285);
        var currVal_286 = ((core_es5["ɵnov"](_v, 282).model.hasError('required') && (!core_es5["ɵnov"](_v, 282).model.pristine || core_es5["ɵnov"](_v, 12).submitted)) && _co.document.PortOfEntry.IsValid);
        _ck(_v, 289, 0, currVal_286);
        var currVal_287 = _co.document.SuretyCode;
        _ck(_v, 292, 0, currVal_287);
        var currVal_295 = !_co.document.PortOfUnLanding.IsValid;
        var currVal_296 = 'text';
        var currVal_297 = 'portOfUnLandingModel';
        var currVal_298 = '12. Port of unlading:';
        var currVal_299 = false;
        var currVal_300 = core_es5["ɵnov"](_v, 12);
        _ck(_v, 306, 0, currVal_295, currVal_296, currVal_297, currVal_298, currVal_299, currVal_300);
        var currVal_301 = 'portOfUnLandingModel';
        var currVal_302 = false;
        var currVal_303 = _co.document.PortOfUnLanding.Value;
        _ck(_v, 308, 0, currVal_301, currVal_302, currVal_303);
        var currVal_304 = _co.document.PortOfUnLanding;
        _ck(_v, 313, 0, currVal_304);
        var currVal_313 = '';
        _ck(_v, 323, 0, currVal_313);
        var currVal_314 = !_co.document.LocationOfGoods.IsValid;
        var currVal_315 = 'text';
        var currVal_316 = 'locationOfGoodsModel';
        var currVal_317 = '14. Location of goods(firms):';
        var currVal_318 = false;
        var currVal_319 = core_es5["ɵnov"](_v, 12);
        _ck(_v, 325, 0, currVal_314, currVal_315, currVal_316, currVal_317, currVal_318, currVal_319);
        var currVal_320 = 'locationOfGoodsModel';
        var currVal_321 = false;
        var currVal_322 = _co.document.LocationOfGoods.Value;
        _ck(_v, 327, 0, currVal_320, currVal_321, currVal_322);
        var currVal_323 = ((core_es5["ɵnov"](_v, 325).model.hasError('required') && (!core_es5["ɵnov"](_v, 325).model.pristine || core_es5["ɵnov"](_v, 12).submitted)) && _co.document.PortOfEntry.IsValid);
        _ck(_v, 332, 0, currVal_323);
        var currVal_324 = _co.document.LocationOfGoods;
        _ck(_v, 335, 0, currVal_324);
        var currVal_325 = _ck(_v, 345, 0, (core_es5["ɵnov"](_v, 12).submitted && (_co.document.ModeOfTransportation.Value == null)));
        _ck(_v, 344, 0, currVal_325);
        var currVal_333 = 'Air';
        var currVal_334 = 'Air';
        var currVal_335 = 0;
        _ck(_v, 361, 0, currVal_333, currVal_334, currVal_335);
        var currVal_336 = 'Air';
        var currVal_337 = _co.document.ModeOfTransportation.Value;
        _ck(_v, 363, 0, currVal_336, currVal_337);
        var currVal_345 = 'Ocean';
        var currVal_346 = 'Ocean';
        var currVal_347 = 1;
        _ck(_v, 368, 0, currVal_345, currVal_346, currVal_347);
        var currVal_348 = 'Ocean';
        var currVal_349 = _co.document.ModeOfTransportation.Value;
        _ck(_v, 370, 0, currVal_348, currVal_349);
        var currVal_357 = 'Rail';
        var currVal_358 = 'Rail';
        var currVal_359 = 2;
        _ck(_v, 375, 0, currVal_357, currVal_358, currVal_359);
        var currVal_360 = 'Rail';
        var currVal_361 = _co.document.ModeOfTransportation.Value;
        _ck(_v, 377, 0, currVal_360, currVal_361);
        var currVal_369 = 'Truck';
        var currVal_370 = 'Truck';
        var currVal_371 = 3;
        _ck(_v, 382, 0, currVal_369, currVal_370, currVal_371);
        var currVal_372 = 'Truck';
        var currVal_373 = _co.document.ModeOfTransportation.Value;
        _ck(_v, 384, 0, currVal_372, currVal_373);
        var currVal_381 = 'HandCarry';
        var currVal_382 = 'Hand Carry';
        var currVal_383 = 4;
        _ck(_v, 392, 0, currVal_381, currVal_382, currVal_383);
        var currVal_384 = 'HandCarry';
        var currVal_385 = _co.document.ModeOfTransportation.Value;
        _ck(_v, 394, 0, currVal_384, currVal_385);
        var currVal_393 = 'Pipeline';
        var currVal_394 = 'Pipeline';
        var currVal_395 = 5;
        _ck(_v, 399, 0, currVal_393, currVal_394, currVal_395);
        var currVal_396 = 'Pipeline';
        var currVal_397 = _co.document.ModeOfTransportation.Value;
        _ck(_v, 401, 0, currVal_396, currVal_397);
        var currVal_405 = 'Other';
        var currVal_406 = 'Other';
        var currVal_407 = 6;
        _ck(_v, 406, 0, currVal_405, currVal_406, currVal_407);
        var currVal_408 = 'Other';
        var currVal_409 = _co.document.ModeOfTransportation.Value;
        _ck(_v, 408, 0, currVal_408, currVal_409);
        var currVal_410 = _co.document.ModeOfTransportation;
        _ck(_v, 414, 0, currVal_410);
        var currVal_418 = !_co.document.GONumber.IsValid;
        var currVal_419 = 'text';
        var currVal_420 = 'gONumberModel';
        var currVal_421 = '15. G.O. Number:';
        var currVal_422 = false;
        var currVal_423 = core_es5["ɵnov"](_v, 12);
        _ck(_v, 425, 0, currVal_418, currVal_419, currVal_420, currVal_421, currVal_422, currVal_423);
        var currVal_424 = 'gONumberModel';
        var currVal_425 = false;
        var currVal_426 = _co.document.GONumber.Value;
        _ck(_v, 427, 0, currVal_424, currVal_425, currVal_426);
        var currVal_427 = _co.document.GONumber;
        _ck(_v, 432, 0, currVal_427);
        var currVal_435 = !_co.document.ConveyanceName.IsValid;
        var currVal_436 = 'text';
        var currVal_437 = 'ConveyanceName';
        var currVal_438 = '16. Conveyance name/ftz zone id:';
        var currVal_439 = false;
        var currVal_440 = core_es5["ɵnov"](_v, 12);
        _ck(_v, 439, 0, currVal_435, currVal_436, currVal_437, currVal_438, currVal_439, currVal_440);
        var currVal_441 = 'ConveyanceName';
        var currVal_442 = false;
        var currVal_443 = _co.document.ConveyanceName.Value;
        _ck(_v, 441, 0, currVal_441, currVal_442, currVal_443);
        var currVal_444 = _co.document.ConveyanceName;
        _ck(_v, 446, 0, currVal_444);
        var currVal_453 = '';
        _ck(_v, 465, 0, currVal_453);
        var currVal_454 = !_co.document.ReferenceIdCode.IsValid;
        var currVal_455 = 'text';
        var currVal_456 = 'ReferenceIdCode';
        var currVal_457 = '17. Reference Id Code:';
        var currVal_458 = false;
        var currVal_459 = core_es5["ɵnov"](_v, 12);
        _ck(_v, 467, 0, currVal_454, currVal_455, currVal_456, currVal_457, currVal_458, currVal_459);
        var currVal_460 = 'ReferenceIdCode';
        var currVal_461 = false;
        var currVal_462 = _co.document.ReferenceIdCode.Value;
        _ck(_v, 469, 0, currVal_460, currVal_461, currVal_462);
        var currVal_463 = ((core_es5["ɵnov"](_v, 467).model.hasError('required') && (!core_es5["ɵnov"](_v, 467).model.pristine || core_es5["ɵnov"](_v, 12).submitted)) && _co.document.ReferenceIdCode.IsValid);
        _ck(_v, 474, 0, currVal_463);
        var currVal_464 = _co.document.ReferenceIdCode;
        _ck(_v, 477, 0, currVal_464);
        var currVal_473 = '';
        _ck(_v, 484, 0, currVal_473);
        var currVal_474 = !_co.document.ReferenceIdNumber.IsValid;
        var currVal_475 = 'text';
        var currVal_476 = 'ReferenceIdNumber';
        var currVal_477 = '18. Reference Id Number:';
        var currVal_478 = false;
        var currVal_479 = core_es5["ɵnov"](_v, 12);
        var currVal_480 = 'UP TO 50 CHARACTERS';
        var currVal_481 = true;
        _ck(_v, 486, 0, currVal_474, currVal_475, currVal_476, currVal_477, currVal_478, currVal_479, currVal_480, currVal_481);
        var currVal_482 = 'ReferenceIdNumber';
        var currVal_483 = false;
        var currVal_484 = _co.document.ReferenceIdNumber.Value;
        _ck(_v, 488, 0, currVal_482, currVal_483, currVal_484);
        var currVal_485 = ((core_es5["ɵnov"](_v, 486).model.hasError('required') && (!core_es5["ɵnov"](_v, 486).model.pristine || core_es5["ɵnov"](_v, 12).submitted)) && _co.document.ReferenceIdNumber.IsValid);
        _ck(_v, 493, 0, currVal_485);
        var currVal_486 = _co.document.ReferenceIdNumber;
        _ck(_v, 496, 0, currVal_486);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵnov"](_v, 14).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 14).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 14).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 14).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 14).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 14).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 14).ngClassPending;
        _ck(_v, 10, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (core_es5["ɵnov"](_v, 21).required ? '' : null);
        var currVal_8 = core_es5["ɵnov"](_v, 27).ngClassUntouched;
        var currVal_9 = core_es5["ɵnov"](_v, 27).ngClassTouched;
        var currVal_10 = core_es5["ɵnov"](_v, 27).ngClassPristine;
        var currVal_11 = core_es5["ɵnov"](_v, 27).ngClassDirty;
        var currVal_12 = core_es5["ɵnov"](_v, 27).ngClassValid;
        var currVal_13 = core_es5["ɵnov"](_v, 27).ngClassInvalid;
        var currVal_14 = core_es5["ɵnov"](_v, 27).ngClassPending;
        _ck(_v, 20, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_28 = core_es5["ɵnov"](_v, 54).ngClassUntouched;
        var currVal_29 = core_es5["ɵnov"](_v, 54).ngClassTouched;
        var currVal_30 = core_es5["ɵnov"](_v, 54).ngClassPristine;
        var currVal_31 = core_es5["ɵnov"](_v, 54).ngClassDirty;
        var currVal_32 = core_es5["ɵnov"](_v, 54).ngClassValid;
        var currVal_33 = core_es5["ɵnov"](_v, 54).ngClassInvalid;
        var currVal_34 = core_es5["ɵnov"](_v, 54).ngClassPending;
        _ck(_v, 49, 0, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34);
        var currVal_40 = core_es5["ɵnov"](_v, 61).ngClassUntouched;
        var currVal_41 = core_es5["ɵnov"](_v, 61).ngClassTouched;
        var currVal_42 = core_es5["ɵnov"](_v, 61).ngClassPristine;
        var currVal_43 = core_es5["ɵnov"](_v, 61).ngClassDirty;
        var currVal_44 = core_es5["ɵnov"](_v, 61).ngClassValid;
        var currVal_45 = core_es5["ɵnov"](_v, 61).ngClassInvalid;
        var currVal_46 = core_es5["ɵnov"](_v, 61).ngClassPending;
        _ck(_v, 56, 0, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44, currVal_45, currVal_46);
        var currVal_52 = core_es5["ɵnov"](_v, 68).ngClassUntouched;
        var currVal_53 = core_es5["ɵnov"](_v, 68).ngClassTouched;
        var currVal_54 = core_es5["ɵnov"](_v, 68).ngClassPristine;
        var currVal_55 = core_es5["ɵnov"](_v, 68).ngClassDirty;
        var currVal_56 = core_es5["ɵnov"](_v, 68).ngClassValid;
        var currVal_57 = core_es5["ɵnov"](_v, 68).ngClassInvalid;
        var currVal_58 = core_es5["ɵnov"](_v, 68).ngClassPending;
        _ck(_v, 63, 0, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56, currVal_57, currVal_58);
        var currVal_66 = core_es5["ɵnov"](_v, 89).ngClassUntouched;
        var currVal_67 = core_es5["ɵnov"](_v, 89).ngClassTouched;
        var currVal_68 = core_es5["ɵnov"](_v, 89).ngClassPristine;
        var currVal_69 = core_es5["ɵnov"](_v, 89).ngClassDirty;
        var currVal_70 = core_es5["ɵnov"](_v, 89).ngClassValid;
        var currVal_71 = core_es5["ɵnov"](_v, 89).ngClassInvalid;
        var currVal_72 = core_es5["ɵnov"](_v, 89).ngClassPending;
        _ck(_v, 84, 0, currVal_66, currVal_67, currVal_68, currVal_69, currVal_70, currVal_71, currVal_72);
        var currVal_78 = core_es5["ɵnov"](_v, 96).ngClassUntouched;
        var currVal_79 = core_es5["ɵnov"](_v, 96).ngClassTouched;
        var currVal_80 = core_es5["ɵnov"](_v, 96).ngClassPristine;
        var currVal_81 = core_es5["ɵnov"](_v, 96).ngClassDirty;
        var currVal_82 = core_es5["ɵnov"](_v, 96).ngClassValid;
        var currVal_83 = core_es5["ɵnov"](_v, 96).ngClassInvalid;
        var currVal_84 = core_es5["ɵnov"](_v, 96).ngClassPending;
        _ck(_v, 91, 0, currVal_78, currVal_79, currVal_80, currVal_81, currVal_82, currVal_83, currVal_84);
        var currVal_90 = core_es5["ɵnov"](_v, 103).ngClassUntouched;
        var currVal_91 = core_es5["ɵnov"](_v, 103).ngClassTouched;
        var currVal_92 = core_es5["ɵnov"](_v, 103).ngClassPristine;
        var currVal_93 = core_es5["ɵnov"](_v, 103).ngClassDirty;
        var currVal_94 = core_es5["ɵnov"](_v, 103).ngClassValid;
        var currVal_95 = core_es5["ɵnov"](_v, 103).ngClassInvalid;
        var currVal_96 = core_es5["ɵnov"](_v, 103).ngClassPending;
        _ck(_v, 98, 0, currVal_90, currVal_91, currVal_92, currVal_93, currVal_94, currVal_95, currVal_96);
        var currVal_103 = ((_co.document.ImporterNumberType.Value == null) ? 'Formats: IRS EIN NN-NNNNNNN, IRS EIN with suffix NN-NNNNNNNXX, SSN NNN-NN-NNNN,  CBP assigned number YYDDPP-NNNNN' : ((_co.document.ImporterNumberType.Value == 0) ? 'Formats: IRS EIN NN-NNNNNNN, IRS EIN with suffix NN-NNNNNNNXX' : ((_co.document.ImporterNumberType.Value == 1) ? 'Format: SSN NNN-NN-NNNN' : 'Format: CBP assigned number YYDDPP-NNNNN')));
        var currVal_104 = (core_es5["ɵnov"](_v, 110).required ? '' : null);
        var currVal_105 = core_es5["ɵnov"](_v, 116).ngClassUntouched;
        var currVal_106 = core_es5["ɵnov"](_v, 116).ngClassTouched;
        var currVal_107 = core_es5["ɵnov"](_v, 116).ngClassPristine;
        var currVal_108 = core_es5["ɵnov"](_v, 116).ngClassDirty;
        var currVal_109 = core_es5["ɵnov"](_v, 116).ngClassValid;
        var currVal_110 = core_es5["ɵnov"](_v, 116).ngClassInvalid;
        var currVal_111 = core_es5["ɵnov"](_v, 116).ngClassPending;
        _ck(_v, 109, 0, currVal_103, currVal_104, currVal_105, currVal_106, currVal_107, currVal_108, currVal_109, currVal_110, currVal_111);
        var currVal_123 = (core_es5["ɵnov"](_v, 133).required ? '' : null);
        var currVal_124 = core_es5["ɵnov"](_v, 139).ngClassUntouched;
        var currVal_125 = core_es5["ɵnov"](_v, 139).ngClassTouched;
        var currVal_126 = core_es5["ɵnov"](_v, 139).ngClassPristine;
        var currVal_127 = core_es5["ɵnov"](_v, 139).ngClassDirty;
        var currVal_128 = core_es5["ɵnov"](_v, 139).ngClassValid;
        var currVal_129 = core_es5["ɵnov"](_v, 139).ngClassInvalid;
        var currVal_130 = core_es5["ɵnov"](_v, 139).ngClassPending;
        _ck(_v, 132, 0, currVal_123, currVal_124, currVal_125, currVal_126, currVal_127, currVal_128, currVal_129, currVal_130);
        var currVal_143 = (core_es5["ɵnov"](_v, 155).required ? '' : null);
        var currVal_144 = core_es5["ɵnov"](_v, 161).ngClassUntouched;
        var currVal_145 = core_es5["ɵnov"](_v, 161).ngClassTouched;
        var currVal_146 = core_es5["ɵnov"](_v, 161).ngClassPristine;
        var currVal_147 = core_es5["ɵnov"](_v, 161).ngClassDirty;
        var currVal_148 = core_es5["ɵnov"](_v, 161).ngClassValid;
        var currVal_149 = core_es5["ɵnov"](_v, 161).ngClassInvalid;
        var currVal_150 = core_es5["ɵnov"](_v, 161).ngClassPending;
        _ck(_v, 154, 0, currVal_143, currVal_144, currVal_145, currVal_146, currVal_147, currVal_148, currVal_149, currVal_150);
        var currVal_163 = (core_es5["ɵnov"](_v, 179).required ? '' : null);
        var currVal_164 = (core_es5["ɵnov"](_v, 180).pattern ? core_es5["ɵnov"](_v, 180).pattern : null);
        var currVal_165 = core_es5["ɵnov"](_v, 186).ngClassUntouched;
        var currVal_166 = core_es5["ɵnov"](_v, 186).ngClassTouched;
        var currVal_167 = core_es5["ɵnov"](_v, 186).ngClassPristine;
        var currVal_168 = core_es5["ɵnov"](_v, 186).ngClassDirty;
        var currVal_169 = core_es5["ɵnov"](_v, 186).ngClassValid;
        var currVal_170 = core_es5["ɵnov"](_v, 186).ngClassInvalid;
        var currVal_171 = core_es5["ɵnov"](_v, 186).ngClassPending;
        _ck(_v, 178, 0, currVal_163, currVal_164, currVal_165, currVal_166, currVal_167, currVal_168, currVal_169, currVal_170, currVal_171);
        var currVal_186 = (core_es5["ɵnov"](_v, 202).required ? '' : null);
        var currVal_187 = (core_es5["ɵnov"](_v, 203).pattern ? core_es5["ɵnov"](_v, 203).pattern : null);
        var currVal_188 = core_es5["ɵnov"](_v, 209).ngClassUntouched;
        var currVal_189 = core_es5["ɵnov"](_v, 209).ngClassTouched;
        var currVal_190 = core_es5["ɵnov"](_v, 209).ngClassPristine;
        var currVal_191 = core_es5["ɵnov"](_v, 209).ngClassDirty;
        var currVal_192 = core_es5["ɵnov"](_v, 209).ngClassValid;
        var currVal_193 = core_es5["ɵnov"](_v, 209).ngClassInvalid;
        var currVal_194 = core_es5["ɵnov"](_v, 209).ngClassPending;
        _ck(_v, 201, 0, currVal_186, currVal_187, currVal_188, currVal_189, currVal_190, currVal_191, currVal_192, currVal_193, currVal_194);
        var currVal_209 = core_es5["ɵnov"](_v, 229).ngClassUntouched;
        var currVal_210 = core_es5["ɵnov"](_v, 229).ngClassTouched;
        var currVal_211 = core_es5["ɵnov"](_v, 229).ngClassPristine;
        var currVal_212 = core_es5["ɵnov"](_v, 229).ngClassDirty;
        var currVal_213 = core_es5["ɵnov"](_v, 229).ngClassValid;
        var currVal_214 = core_es5["ɵnov"](_v, 229).ngClassInvalid;
        var currVal_215 = core_es5["ɵnov"](_v, 229).ngClassPending;
        _ck(_v, 224, 0, currVal_209, currVal_210, currVal_211, currVal_212, currVal_213, currVal_214, currVal_215);
        var currVal_226 = (core_es5["ɵnov"](_v, 242).required ? '' : null);
        var currVal_227 = core_es5["ɵnov"](_v, 248).ngClassUntouched;
        var currVal_228 = core_es5["ɵnov"](_v, 248).ngClassTouched;
        var currVal_229 = core_es5["ɵnov"](_v, 248).ngClassPristine;
        var currVal_230 = core_es5["ɵnov"](_v, 248).ngClassDirty;
        var currVal_231 = core_es5["ɵnov"](_v, 248).ngClassValid;
        var currVal_232 = core_es5["ɵnov"](_v, 248).ngClassInvalid;
        var currVal_233 = core_es5["ɵnov"](_v, 248).ngClassPending;
        _ck(_v, 241, 0, currVal_226, currVal_227, currVal_228, currVal_229, currVal_230, currVal_231, currVal_232, currVal_233);
        var currVal_246 = (core_es5["ɵnov"](_v, 261).required ? '' : null);
        var currVal_247 = core_es5["ɵnov"](_v, 267).ngClassUntouched;
        var currVal_248 = core_es5["ɵnov"](_v, 267).ngClassTouched;
        var currVal_249 = core_es5["ɵnov"](_v, 267).ngClassPristine;
        var currVal_250 = core_es5["ɵnov"](_v, 267).ngClassDirty;
        var currVal_251 = core_es5["ɵnov"](_v, 267).ngClassValid;
        var currVal_252 = core_es5["ɵnov"](_v, 267).ngClassInvalid;
        var currVal_253 = core_es5["ɵnov"](_v, 267).ngClassPending;
        _ck(_v, 260, 0, currVal_246, currVal_247, currVal_248, currVal_249, currVal_250, currVal_251, currVal_252, currVal_253);
        var currVal_268 = (core_es5["ɵnov"](_v, 280).required ? '' : null);
        var currVal_269 = core_es5["ɵnov"](_v, 286).ngClassUntouched;
        var currVal_270 = core_es5["ɵnov"](_v, 286).ngClassTouched;
        var currVal_271 = core_es5["ɵnov"](_v, 286).ngClassPristine;
        var currVal_272 = core_es5["ɵnov"](_v, 286).ngClassDirty;
        var currVal_273 = core_es5["ɵnov"](_v, 286).ngClassValid;
        var currVal_274 = core_es5["ɵnov"](_v, 286).ngClassInvalid;
        var currVal_275 = core_es5["ɵnov"](_v, 286).ngClassPending;
        _ck(_v, 279, 0, currVal_268, currVal_269, currVal_270, currVal_271, currVal_272, currVal_273, currVal_274, currVal_275);
        var currVal_288 = core_es5["ɵnov"](_v, 310).ngClassUntouched;
        var currVal_289 = core_es5["ɵnov"](_v, 310).ngClassTouched;
        var currVal_290 = core_es5["ɵnov"](_v, 310).ngClassPristine;
        var currVal_291 = core_es5["ɵnov"](_v, 310).ngClassDirty;
        var currVal_292 = core_es5["ɵnov"](_v, 310).ngClassValid;
        var currVal_293 = core_es5["ɵnov"](_v, 310).ngClassInvalid;
        var currVal_294 = core_es5["ɵnov"](_v, 310).ngClassPending;
        _ck(_v, 305, 0, currVal_288, currVal_289, currVal_290, currVal_291, currVal_292, currVal_293, currVal_294);
        var currVal_305 = (core_es5["ɵnov"](_v, 323).required ? '' : null);
        var currVal_306 = core_es5["ɵnov"](_v, 329).ngClassUntouched;
        var currVal_307 = core_es5["ɵnov"](_v, 329).ngClassTouched;
        var currVal_308 = core_es5["ɵnov"](_v, 329).ngClassPristine;
        var currVal_309 = core_es5["ɵnov"](_v, 329).ngClassDirty;
        var currVal_310 = core_es5["ɵnov"](_v, 329).ngClassValid;
        var currVal_311 = core_es5["ɵnov"](_v, 329).ngClassInvalid;
        var currVal_312 = core_es5["ɵnov"](_v, 329).ngClassPending;
        _ck(_v, 322, 0, currVal_305, currVal_306, currVal_307, currVal_308, currVal_309, currVal_310, currVal_311, currVal_312);
        var currVal_326 = core_es5["ɵnov"](_v, 365).ngClassUntouched;
        var currVal_327 = core_es5["ɵnov"](_v, 365).ngClassTouched;
        var currVal_328 = core_es5["ɵnov"](_v, 365).ngClassPristine;
        var currVal_329 = core_es5["ɵnov"](_v, 365).ngClassDirty;
        var currVal_330 = core_es5["ɵnov"](_v, 365).ngClassValid;
        var currVal_331 = core_es5["ɵnov"](_v, 365).ngClassInvalid;
        var currVal_332 = core_es5["ɵnov"](_v, 365).ngClassPending;
        _ck(_v, 360, 0, currVal_326, currVal_327, currVal_328, currVal_329, currVal_330, currVal_331, currVal_332);
        var currVal_338 = core_es5["ɵnov"](_v, 372).ngClassUntouched;
        var currVal_339 = core_es5["ɵnov"](_v, 372).ngClassTouched;
        var currVal_340 = core_es5["ɵnov"](_v, 372).ngClassPristine;
        var currVal_341 = core_es5["ɵnov"](_v, 372).ngClassDirty;
        var currVal_342 = core_es5["ɵnov"](_v, 372).ngClassValid;
        var currVal_343 = core_es5["ɵnov"](_v, 372).ngClassInvalid;
        var currVal_344 = core_es5["ɵnov"](_v, 372).ngClassPending;
        _ck(_v, 367, 0, currVal_338, currVal_339, currVal_340, currVal_341, currVal_342, currVal_343, currVal_344);
        var currVal_350 = core_es5["ɵnov"](_v, 379).ngClassUntouched;
        var currVal_351 = core_es5["ɵnov"](_v, 379).ngClassTouched;
        var currVal_352 = core_es5["ɵnov"](_v, 379).ngClassPristine;
        var currVal_353 = core_es5["ɵnov"](_v, 379).ngClassDirty;
        var currVal_354 = core_es5["ɵnov"](_v, 379).ngClassValid;
        var currVal_355 = core_es5["ɵnov"](_v, 379).ngClassInvalid;
        var currVal_356 = core_es5["ɵnov"](_v, 379).ngClassPending;
        _ck(_v, 374, 0, currVal_350, currVal_351, currVal_352, currVal_353, currVal_354, currVal_355, currVal_356);
        var currVal_362 = core_es5["ɵnov"](_v, 386).ngClassUntouched;
        var currVal_363 = core_es5["ɵnov"](_v, 386).ngClassTouched;
        var currVal_364 = core_es5["ɵnov"](_v, 386).ngClassPristine;
        var currVal_365 = core_es5["ɵnov"](_v, 386).ngClassDirty;
        var currVal_366 = core_es5["ɵnov"](_v, 386).ngClassValid;
        var currVal_367 = core_es5["ɵnov"](_v, 386).ngClassInvalid;
        var currVal_368 = core_es5["ɵnov"](_v, 386).ngClassPending;
        _ck(_v, 381, 0, currVal_362, currVal_363, currVal_364, currVal_365, currVal_366, currVal_367, currVal_368);
        var currVal_374 = core_es5["ɵnov"](_v, 396).ngClassUntouched;
        var currVal_375 = core_es5["ɵnov"](_v, 396).ngClassTouched;
        var currVal_376 = core_es5["ɵnov"](_v, 396).ngClassPristine;
        var currVal_377 = core_es5["ɵnov"](_v, 396).ngClassDirty;
        var currVal_378 = core_es5["ɵnov"](_v, 396).ngClassValid;
        var currVal_379 = core_es5["ɵnov"](_v, 396).ngClassInvalid;
        var currVal_380 = core_es5["ɵnov"](_v, 396).ngClassPending;
        _ck(_v, 391, 0, currVal_374, currVal_375, currVal_376, currVal_377, currVal_378, currVal_379, currVal_380);
        var currVal_386 = core_es5["ɵnov"](_v, 403).ngClassUntouched;
        var currVal_387 = core_es5["ɵnov"](_v, 403).ngClassTouched;
        var currVal_388 = core_es5["ɵnov"](_v, 403).ngClassPristine;
        var currVal_389 = core_es5["ɵnov"](_v, 403).ngClassDirty;
        var currVal_390 = core_es5["ɵnov"](_v, 403).ngClassValid;
        var currVal_391 = core_es5["ɵnov"](_v, 403).ngClassInvalid;
        var currVal_392 = core_es5["ɵnov"](_v, 403).ngClassPending;
        _ck(_v, 398, 0, currVal_386, currVal_387, currVal_388, currVal_389, currVal_390, currVal_391, currVal_392);
        var currVal_398 = core_es5["ɵnov"](_v, 410).ngClassUntouched;
        var currVal_399 = core_es5["ɵnov"](_v, 410).ngClassTouched;
        var currVal_400 = core_es5["ɵnov"](_v, 410).ngClassPristine;
        var currVal_401 = core_es5["ɵnov"](_v, 410).ngClassDirty;
        var currVal_402 = core_es5["ɵnov"](_v, 410).ngClassValid;
        var currVal_403 = core_es5["ɵnov"](_v, 410).ngClassInvalid;
        var currVal_404 = core_es5["ɵnov"](_v, 410).ngClassPending;
        _ck(_v, 405, 0, currVal_398, currVal_399, currVal_400, currVal_401, currVal_402, currVal_403, currVal_404);
        var currVal_411 = core_es5["ɵnov"](_v, 429).ngClassUntouched;
        var currVal_412 = core_es5["ɵnov"](_v, 429).ngClassTouched;
        var currVal_413 = core_es5["ɵnov"](_v, 429).ngClassPristine;
        var currVal_414 = core_es5["ɵnov"](_v, 429).ngClassDirty;
        var currVal_415 = core_es5["ɵnov"](_v, 429).ngClassValid;
        var currVal_416 = core_es5["ɵnov"](_v, 429).ngClassInvalid;
        var currVal_417 = core_es5["ɵnov"](_v, 429).ngClassPending;
        _ck(_v, 424, 0, currVal_411, currVal_412, currVal_413, currVal_414, currVal_415, currVal_416, currVal_417);
        var currVal_428 = core_es5["ɵnov"](_v, 443).ngClassUntouched;
        var currVal_429 = core_es5["ɵnov"](_v, 443).ngClassTouched;
        var currVal_430 = core_es5["ɵnov"](_v, 443).ngClassPristine;
        var currVal_431 = core_es5["ɵnov"](_v, 443).ngClassDirty;
        var currVal_432 = core_es5["ɵnov"](_v, 443).ngClassValid;
        var currVal_433 = core_es5["ɵnov"](_v, 443).ngClassInvalid;
        var currVal_434 = core_es5["ɵnov"](_v, 443).ngClassPending;
        _ck(_v, 438, 0, currVal_428, currVal_429, currVal_430, currVal_431, currVal_432, currVal_433, currVal_434);
        var currVal_445 = (core_es5["ɵnov"](_v, 465).required ? '' : null);
        var currVal_446 = core_es5["ɵnov"](_v, 471).ngClassUntouched;
        var currVal_447 = core_es5["ɵnov"](_v, 471).ngClassTouched;
        var currVal_448 = core_es5["ɵnov"](_v, 471).ngClassPristine;
        var currVal_449 = core_es5["ɵnov"](_v, 471).ngClassDirty;
        var currVal_450 = core_es5["ɵnov"](_v, 471).ngClassValid;
        var currVal_451 = core_es5["ɵnov"](_v, 471).ngClassInvalid;
        var currVal_452 = core_es5["ɵnov"](_v, 471).ngClassPending;
        _ck(_v, 464, 0, currVal_445, currVal_446, currVal_447, currVal_448, currVal_449, currVal_450, currVal_451, currVal_452);
        var currVal_465 = (core_es5["ɵnov"](_v, 484).required ? '' : null);
        var currVal_466 = core_es5["ɵnov"](_v, 490).ngClassUntouched;
        var currVal_467 = core_es5["ɵnov"](_v, 490).ngClassTouched;
        var currVal_468 = core_es5["ɵnov"](_v, 490).ngClassPristine;
        var currVal_469 = core_es5["ɵnov"](_v, 490).ngClassDirty;
        var currVal_470 = core_es5["ɵnov"](_v, 490).ngClassValid;
        var currVal_471 = core_es5["ɵnov"](_v, 490).ngClassInvalid;
        var currVal_472 = core_es5["ɵnov"](_v, 490).ngClassPending;
        _ck(_v, 483, 0, currVal_465, currVal_466, currVal_467, currVal_468, currVal_469, currVal_470, currVal_471, currVal_472);
    });
}
function View_HeaderInfo3461Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'header-info-3461', [], null, null, null, View_HeaderInfo3461Component_0, RenderType_HeaderInfo3461Component)), core_es5["ɵdid"](49152, null, 0, header_info_3461_component_HeaderInfo3461Component, [], null, null)], null, null);
}
var HeaderInfo3461ComponentNgFactory = core_es5["ɵccf"]('header-info-3461', header_info_3461_component_HeaderInfo3461Component, View_HeaderInfo3461Component_Host_0, { document: 'document' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=header-info-3461.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/export-documents/cbp-3461/document-blocks/header-parties-3461.component.ts

var header_parties_3461_component_HeaderParties3461Component = /** @class */ (function () {
    function HeaderParties3461Component() {
        this.numberPatternHelper = ValidationPatterns;
    }
    HeaderParties3461Component.prototype.isFormValid = function () {
        return this.headerPartiesForm.valid;
    };
    HeaderParties3461Component.prototype.submitFormAndValidity = function () {
        this.headerPartiesForm.onSubmit(null);
        return this.isFormValid();
    };
    return HeaderParties3461Component;
}());

//# sourceMappingURL=header-parties-3461.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/export-documents/cbp-3461/document-blocks/header-parties-3461.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_HeaderParties3461Component = [];
var RenderType_HeaderParties3461Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_HeaderParties3461Component, data: {} });
function View_HeaderParties3461Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Header Party Name And Address is required']))], null, null);
}
function View_HeaderParties3461Component_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { headerPartiesForm: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'title']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['Header Parties (must apply to entire entry; if not, skip to line information)'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 139, 'form', [['class', 'padding-0'], ['novalidate', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'submit'],
            [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 12).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 12).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[1, 4], ['headerPartiesForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 132, 'div', [['class', 'container-table row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 129, 'div', [['class',
                'col-md-12 padding-0']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 126, 'div', [['class', 'table-inner']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 123, 'table', [['class',
                'table']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'thead', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'th', [['class', 'padding-left-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['19. Header party type:'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'th', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['20. Header party Type Name/Address'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'th', [['class', 'padding-right-30']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['21. Header ID #, If applicable'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 102, 'tbody', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 99, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 34, 'td', [['class',
                'padding-left-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 31, 'div', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.HeaderPartyType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.HeaderPartyType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.HeaderPartyType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.HeaderPartyType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'td', [['class',
                'vertical-align-top']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.HeaderPartyNameAndAddress.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['HeaderPartyNameAndAddressModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'],
            form: [4, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_HeaderParties3461Component_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 41, 'td', [['class',
                'padding-right-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 38, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 24, 'div', [], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.HeaderIDType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.HeaderIDType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.HeaderIDType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.HeaderID.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['headerIDModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'],
            form: [4, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _ck(_v, 50, 0, (core_es5["ɵnov"](_v, 12).submitted && (_co.document.HeaderPartyType.Value == null)));
        _ck(_v, 49, 0, currVal_7);
        var currVal_15 = 'Manufacturer_1';
        var currVal_16 = 'Manufacturer';
        var currVal_17 = 0;
        _ck(_v, 53, 0, currVal_15, currVal_16, currVal_17);
        var currVal_18 = 'Manufacturer_1';
        var currVal_19 = _co.document.HeaderPartyType.Value;
        _ck(_v, 55, 0, currVal_18, currVal_19);
        var currVal_27 = 'Consignee_1';
        var currVal_28 = 'Consignee';
        var currVal_29 = 1;
        _ck(_v, 60, 0, currVal_27, currVal_28, currVal_29);
        var currVal_30 = 'Consignee_1';
        var currVal_31 = _co.document.HeaderPartyType.Value;
        _ck(_v, 62, 0, currVal_30, currVal_31);
        var currVal_39 = 'Selling Party_1';
        var currVal_40 = 'Selling Party';
        var currVal_41 = 2;
        _ck(_v, 67, 0, currVal_39, currVal_40, currVal_41);
        var currVal_42 = 'Selling Party_1';
        var currVal_43 = _co.document.HeaderPartyType.Value;
        _ck(_v, 69, 0, currVal_42, currVal_43);
        var currVal_51 = 'Buying Party_1';
        var currVal_52 = 'Buying Party';
        var currVal_53 = 3;
        _ck(_v, 74, 0, currVal_51, currVal_52, currVal_53);
        var currVal_54 = 'Buying Party_1';
        var currVal_55 = _co.document.HeaderPartyType.Value;
        _ck(_v, 76, 0, currVal_54, currVal_55);
        var currVal_64 = '';
        _ck(_v, 85, 0, currVal_64);
        var currVal_65 = !_co.document.HeaderPartyNameAndAddress.IsValid;
        var currVal_66 = 'text';
        var currVal_67 = 'HeaderPartyNameAndAddress';
        var currVal_68 = false;
        var currVal_69 = core_es5["ɵnov"](_v, 12);
        _ck(_v, 87, 0, currVal_65, currVal_66, currVal_67, currVal_68, currVal_69);
        var currVal_70 = 'HeaderPartyNameAndAddress';
        var currVal_71 = false;
        var currVal_72 = _co.document.HeaderPartyNameAndAddress.Value;
        _ck(_v, 89, 0, currVal_70, currVal_71, currVal_72);
        var currVal_73 = ((core_es5["ɵnov"](_v, 87).model.hasError('required') && (!core_es5["ɵnov"](_v, 87).model.pristine || core_es5["ɵnov"](_v, 12).submitted)) && _co.document.HeaderPartyNameAndAddress.IsValid);
        _ck(_v, 94, 0, currVal_73);
        var currVal_74 = _co.document.HeaderPartyNameAndAddress;
        _ck(_v, 97, 0, currVal_74);
        var currVal_75 = _ck(_v, 107, 0, (core_es5["ɵnov"](_v, 12).submitted && (_co.document.HeaderIDType.Value == null)));
        _ck(_v, 106, 0, currVal_75);
        var currVal_83 = 'IRS_1';
        var currVal_84 = 'IRS';
        var currVal_85 = 0;
        _ck(_v, 110, 0, currVal_83, currVal_84, currVal_85);
        var currVal_86 = 'IRS_1';
        var currVal_87 = _co.document.HeaderIDType.Value;
        _ck(_v, 112, 0, currVal_86, currVal_87);
        var currVal_95 = 'SSN_1';
        var currVal_96 = 'SSN';
        var currVal_97 = 1;
        _ck(_v, 117, 0, currVal_95, currVal_96, currVal_97);
        var currVal_98 = 'SSN_1';
        var currVal_99 = _co.document.HeaderIDType.Value;
        _ck(_v, 119, 0, currVal_98, currVal_99);
        var currVal_107 = 'CBP Assigned_1';
        var currVal_108 = 'CBP Assigned';
        var currVal_109 = 2;
        _ck(_v, 124, 0, currVal_107, currVal_108, currVal_109);
        var currVal_110 = 'CBP Assigned_1';
        var currVal_111 = _co.document.HeaderIDType.Value;
        _ck(_v, 126, 0, currVal_110, currVal_111);
        var currVal_119 = !_co.document.HeaderID.IsValid;
        var currVal_120 = 'text';
        var currVal_121 = 'HeaderID';
        var currVal_122 = false;
        var currVal_123 = core_es5["ɵnov"](_v, 12);
        _ck(_v, 132, 0, currVal_119, currVal_120, currVal_121, currVal_122, currVal_123);
        var currVal_124 = 'HeaderID';
        var currVal_125 = false;
        var currVal_126 = _co.document.HeaderID.Value;
        _ck(_v, 134, 0, currVal_124, currVal_125, currVal_126);
        var currVal_127 = _co.document.HeaderID;
        _ck(_v, 139, 0, currVal_127);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 14).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 14).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 14).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 14).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 14).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 14).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 14).ngClassPending;
        _ck(_v, 10, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_8 = core_es5["ɵnov"](_v, 57).ngClassUntouched;
        var currVal_9 = core_es5["ɵnov"](_v, 57).ngClassTouched;
        var currVal_10 = core_es5["ɵnov"](_v, 57).ngClassPristine;
        var currVal_11 = core_es5["ɵnov"](_v, 57).ngClassDirty;
        var currVal_12 = core_es5["ɵnov"](_v, 57).ngClassValid;
        var currVal_13 = core_es5["ɵnov"](_v, 57).ngClassInvalid;
        var currVal_14 = core_es5["ɵnov"](_v, 57).ngClassPending;
        _ck(_v, 52, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_20 = core_es5["ɵnov"](_v, 64).ngClassUntouched;
        var currVal_21 = core_es5["ɵnov"](_v, 64).ngClassTouched;
        var currVal_22 = core_es5["ɵnov"](_v, 64).ngClassPristine;
        var currVal_23 = core_es5["ɵnov"](_v, 64).ngClassDirty;
        var currVal_24 = core_es5["ɵnov"](_v, 64).ngClassValid;
        var currVal_25 = core_es5["ɵnov"](_v, 64).ngClassInvalid;
        var currVal_26 = core_es5["ɵnov"](_v, 64).ngClassPending;
        _ck(_v, 59, 0, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26);
        var currVal_32 = core_es5["ɵnov"](_v, 71).ngClassUntouched;
        var currVal_33 = core_es5["ɵnov"](_v, 71).ngClassTouched;
        var currVal_34 = core_es5["ɵnov"](_v, 71).ngClassPristine;
        var currVal_35 = core_es5["ɵnov"](_v, 71).ngClassDirty;
        var currVal_36 = core_es5["ɵnov"](_v, 71).ngClassValid;
        var currVal_37 = core_es5["ɵnov"](_v, 71).ngClassInvalid;
        var currVal_38 = core_es5["ɵnov"](_v, 71).ngClassPending;
        _ck(_v, 66, 0, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38);
        var currVal_44 = core_es5["ɵnov"](_v, 78).ngClassUntouched;
        var currVal_45 = core_es5["ɵnov"](_v, 78).ngClassTouched;
        var currVal_46 = core_es5["ɵnov"](_v, 78).ngClassPristine;
        var currVal_47 = core_es5["ɵnov"](_v, 78).ngClassDirty;
        var currVal_48 = core_es5["ɵnov"](_v, 78).ngClassValid;
        var currVal_49 = core_es5["ɵnov"](_v, 78).ngClassInvalid;
        var currVal_50 = core_es5["ɵnov"](_v, 78).ngClassPending;
        _ck(_v, 73, 0, currVal_44, currVal_45, currVal_46, currVal_47, currVal_48, currVal_49, currVal_50);
        var currVal_56 = (core_es5["ɵnov"](_v, 85).required ? '' : null);
        var currVal_57 = core_es5["ɵnov"](_v, 91).ngClassUntouched;
        var currVal_58 = core_es5["ɵnov"](_v, 91).ngClassTouched;
        var currVal_59 = core_es5["ɵnov"](_v, 91).ngClassPristine;
        var currVal_60 = core_es5["ɵnov"](_v, 91).ngClassDirty;
        var currVal_61 = core_es5["ɵnov"](_v, 91).ngClassValid;
        var currVal_62 = core_es5["ɵnov"](_v, 91).ngClassInvalid;
        var currVal_63 = core_es5["ɵnov"](_v, 91).ngClassPending;
        _ck(_v, 84, 0, currVal_56, currVal_57, currVal_58, currVal_59, currVal_60, currVal_61, currVal_62, currVal_63);
        var currVal_76 = core_es5["ɵnov"](_v, 114).ngClassUntouched;
        var currVal_77 = core_es5["ɵnov"](_v, 114).ngClassTouched;
        var currVal_78 = core_es5["ɵnov"](_v, 114).ngClassPristine;
        var currVal_79 = core_es5["ɵnov"](_v, 114).ngClassDirty;
        var currVal_80 = core_es5["ɵnov"](_v, 114).ngClassValid;
        var currVal_81 = core_es5["ɵnov"](_v, 114).ngClassInvalid;
        var currVal_82 = core_es5["ɵnov"](_v, 114).ngClassPending;
        _ck(_v, 109, 0, currVal_76, currVal_77, currVal_78, currVal_79, currVal_80, currVal_81, currVal_82);
        var currVal_88 = core_es5["ɵnov"](_v, 121).ngClassUntouched;
        var currVal_89 = core_es5["ɵnov"](_v, 121).ngClassTouched;
        var currVal_90 = core_es5["ɵnov"](_v, 121).ngClassPristine;
        var currVal_91 = core_es5["ɵnov"](_v, 121).ngClassDirty;
        var currVal_92 = core_es5["ɵnov"](_v, 121).ngClassValid;
        var currVal_93 = core_es5["ɵnov"](_v, 121).ngClassInvalid;
        var currVal_94 = core_es5["ɵnov"](_v, 121).ngClassPending;
        _ck(_v, 116, 0, currVal_88, currVal_89, currVal_90, currVal_91, currVal_92, currVal_93, currVal_94);
        var currVal_100 = core_es5["ɵnov"](_v, 128).ngClassUntouched;
        var currVal_101 = core_es5["ɵnov"](_v, 128).ngClassTouched;
        var currVal_102 = core_es5["ɵnov"](_v, 128).ngClassPristine;
        var currVal_103 = core_es5["ɵnov"](_v, 128).ngClassDirty;
        var currVal_104 = core_es5["ɵnov"](_v, 128).ngClassValid;
        var currVal_105 = core_es5["ɵnov"](_v, 128).ngClassInvalid;
        var currVal_106 = core_es5["ɵnov"](_v, 128).ngClassPending;
        _ck(_v, 123, 0, currVal_100, currVal_101, currVal_102, currVal_103, currVal_104, currVal_105, currVal_106);
        var currVal_112 = core_es5["ɵnov"](_v, 136).ngClassUntouched;
        var currVal_113 = core_es5["ɵnov"](_v, 136).ngClassTouched;
        var currVal_114 = core_es5["ɵnov"](_v, 136).ngClassPristine;
        var currVal_115 = core_es5["ɵnov"](_v, 136).ngClassDirty;
        var currVal_116 = core_es5["ɵnov"](_v, 136).ngClassValid;
        var currVal_117 = core_es5["ɵnov"](_v, 136).ngClassInvalid;
        var currVal_118 = core_es5["ɵnov"](_v, 136).ngClassPending;
        _ck(_v, 131, 0, currVal_112, currVal_113, currVal_114, currVal_115, currVal_116, currVal_117, currVal_118);
    });
}
function View_HeaderParties3461Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'header-parties-3461', [], null, null, null, View_HeaderParties3461Component_0, RenderType_HeaderParties3461Component)), core_es5["ɵdid"](49152, null, 0, header_parties_3461_component_HeaderParties3461Component, [], null, null)], null, null);
}
var HeaderParties3461ComponentNgFactory = core_es5["ɵccf"]('header-parties-3461', header_parties_3461_component_HeaderParties3461Component, View_HeaderParties3461Component_Host_0, { document: 'document' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=header-parties-3461.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/export-documents/cbp-3461/document-blocks/certification-info-3461.component.ts
var CertificationInfo3461Component = /** @class */ (function () {
    function CertificationInfo3461Component() {
    }
    CertificationInfo3461Component.prototype.submitFormAndValidity = function () {
        this.certificationInfoForm.onSubmit(null);
        return this.isFormValid();
    };
    CertificationInfo3461Component.prototype.isFormValid = function () {
        return this.certificationInfoForm.valid;
    };
    return CertificationInfo3461Component;
}());

//# sourceMappingURL=certification-info-3461.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/export-documents/cbp-3461/document-blocks/certification-info-3461.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_CertificationInfo3461Component = [];
var RenderType_CertificationInfo3461Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CertificationInfo3461Component, data: {} });
function View_CertificationInfo3461Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Phone number is required ']))], null, null);
}
function View_CertificationInfo3461Component_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Date is required ']))], null, null);
}
function View_CertificationInfo3461Component_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Broker or other govt. agency use is required ']))], null, null);
}
function View_CertificationInfo3461Component_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Date use is required ']))], null, null);
}
function View_CertificationInfo3461Component_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { certificationInfoForm: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 221, 'form', [['class', 'padding-0'],
            ['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 4).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[1, 4], ['certificationInfoForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 103, 'div', [['class', 'row row-right-content-stick']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 36, 'div', [['class',
                'col-md-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['22. Certification'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['I hereby make application for entry/immediate delivery. I certify that the above information is accurate, the bond is sufficient, valid, and current, and that all requirements of 19 CFR Part 142 have been met.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-md-12 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.CertificationSignatureOfApplicant.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['certificationSignatureOfApplicantModel', 4]], 0, formInput_component_FormInputComponent, [[2,
                forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 62, 'div', [['class',
                'col-md-6 background-grey padding-right-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['23. CBP use only'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 50, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 47, 'div', [['class', 'col-md-12 margin-bottom-30 checkbox-with-input']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [['class', 'text-uppercase checkbox-padding-0']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.IsOtherAgencyActionRequired.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [['class', 'checkbox-form-margin-bottom']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.OtherAgencyActionNamely.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['OtherAgencyActionNamelyModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]],
            [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'],
            name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [['class', 'text-uppercase']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.IsCBPExaminationRequired.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [['class', 'text-uppercase']], [[2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.IsEntryRejected.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.EntryRejectedExplanation.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['entryRejectedExplanationModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]],
            [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'],
            name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 39, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-3 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.PhoneNumber.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['phoneNumberModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_CertificationInfo3461Component_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'col-md-3 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2,
                    'ng-valid', null], [2, 'ng-invalid', null], [2,
                    'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.CertificationDate.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['CertificationDateModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'], placeholder: [6, 'placeholder'], isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_CertificationInfo3461Component_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 68, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-6 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.BrokerOrOtherGOVT.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['BrokerOrOtherGOVTModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_CertificationInfo3461Component_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 27, 'div', [['class',
                'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row title-pull-top']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['DELIVERY AUTHORIZED:'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'col-md-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.DeliverySignature.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['DeliverySignatureModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]],
            [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'],
            name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'col-md-2 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2,
                    'ng-valid', null], [2, 'ng-invalid', null], [2,
                    'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.DeliveryDate.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['DeliveryDate', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'], placeholder: [6, 'placeholder'], isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_CertificationInfo3461Component_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_14 = !_co.document.CertificationSignatureOfApplicant.IsValid;
        var currVal_15 = 'text';
        var currVal_16 = 'certificationSignatureOfApplicantModel';
        var currVal_17 = 'Signature of applicant:';
        var currVal_18 = false;
        var currVal_19 = core_es5["ɵnov"](_v, 4);
        _ck(_v, 35, 0, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19);
        var currVal_20 = 'certificationSignatureOfApplicantModel';
        var currVal_21 = false;
        var currVal_22 = _co.document.CertificationSignatureOfApplicant.Value;
        _ck(_v, 37, 0, currVal_20, currVal_21, currVal_22);
        var currVal_23 = _co.document.CertificationSignatureOfApplicant;
        _ck(_v, 42, 0, currVal_23);
        var currVal_31 = 'Other agency';
        var currVal_32 = 'Other agency action required, namely:';
        _ck(_v, 64, 0, currVal_31, currVal_32);
        var currVal_33 = 'Other agency';
        var currVal_34 = _co.document.IsOtherAgencyActionRequired.Value;
        _ck(_v, 66, 0, currVal_33, currVal_34);
        var currVal_42 = !_co.document.OtherAgencyActionNamely.IsValid;
        var currVal_43 = 'text';
        var currVal_44 = 'OtherAgencyActionNamely';
        var currVal_45 = false;
        var currVal_46 = core_es5["ɵnov"](_v, 4);
        _ck(_v, 72, 0, currVal_42, currVal_43, currVal_44, currVal_45, currVal_46);
        var currVal_47 = 'OtherAgencyActionNamely';
        var currVal_48 = false;
        var currVal_49 = _co.document.OtherAgencyActionNamely.Value;
        _ck(_v, 74, 0, currVal_47, currVal_48, currVal_49);
        var currVal_50 = _co.document.OtherAgencyActionNamely;
        _ck(_v, 79, 0, currVal_50);
        var currVal_58 = 'IsCBPExaminationRequired';
        var currVal_59 = 'CBP examination required';
        _ck(_v, 83, 0, currVal_58, currVal_59);
        var currVal_60 = 'IsCBPExaminationRequired';
        var currVal_61 = _co.document.IsCBPExaminationRequired.Value;
        _ck(_v, 85, 0, currVal_60, currVal_61);
        var currVal_69 = 'IsEntryRejected';
        var currVal_70 = 'Entry rejected, because:';
        _ck(_v, 91, 0, currVal_69, currVal_70);
        var currVal_71 = 'IsEntryRejected';
        var currVal_72 = _co.document.IsEntryRejected.Value;
        _ck(_v, 93, 0, currVal_71, currVal_72);
        var currVal_80 = !_co.document.EntryRejectedExplanation.IsValid;
        var currVal_81 = 'text';
        var currVal_82 = 'EntryRejectedExplanation';
        var currVal_83 = false;
        var currVal_84 = core_es5["ɵnov"](_v, 4);
        _ck(_v, 99, 0, currVal_80, currVal_81, currVal_82, currVal_83, currVal_84);
        var currVal_85 = 'EntryRejectedExplanation';
        var currVal_86 = false;
        var currVal_87 = _co.document.EntryRejectedExplanation.Value;
        _ck(_v, 101, 0, currVal_85, currVal_86, currVal_87);
        var currVal_88 = _co.document.EntryRejectedExplanation;
        _ck(_v, 106, 0, currVal_88);
        var currVal_97 = '';
        _ck(_v, 118, 0, currVal_97);
        var currVal_98 = !_co.document.PhoneNumber.IsValid;
        var currVal_99 = 'text';
        var currVal_100 = 'phoneNumberModel';
        var currVal_101 = 'Phone number:';
        var currVal_102 = false;
        var currVal_103 = core_es5["ɵnov"](_v, 4);
        _ck(_v, 120, 0, currVal_98, currVal_99, currVal_100, currVal_101, currVal_102, currVal_103);
        var currVal_104 = 'phoneNumberModel';
        var currVal_105 = false;
        var currVal_106 = _co.document.PhoneNumber.Value;
        _ck(_v, 122, 0, currVal_104, currVal_105, currVal_106);
        var currVal_107 = ((core_es5["ɵnov"](_v, 120).model.hasError('required') && (!core_es5["ɵnov"](_v, 120).model.pristine || core_es5["ɵnov"](_v, 4).submitted)) && _co.document.PhoneNumber.IsValid);
        _ck(_v, 127, 0, currVal_107);
        var currVal_108 = _co.document.PhoneNumber;
        _ck(_v, 130, 0, currVal_108);
        var currVal_117 = '';
        _ck(_v, 137, 0, currVal_117);
        var currVal_118 = !_co.document.CertificationDate.IsValid;
        var currVal_119 = 'text';
        var currVal_120 = 'CertificationDate';
        var currVal_121 = 'Date:';
        var currVal_122 = false;
        var currVal_123 = core_es5["ɵnov"](_v, 4);
        var currVal_124 = 'MM/DD/YYYY';
        var currVal_125 = true;
        _ck(_v, 139, 0, currVal_118, currVal_119, currVal_120, currVal_121, currVal_122, currVal_123, currVal_124, currVal_125);
        var currVal_126 = 'CertificationDate';
        var currVal_127 = false;
        var currVal_128 = _co.document.CertificationDate.Value;
        _ck(_v, 141, 0, currVal_126, currVal_127, currVal_128);
        var currVal_129 = ((core_es5["ɵnov"](_v, 139).model.hasError('required') && (!core_es5["ɵnov"](_v, 139).model.pristine || core_es5["ɵnov"](_v, 4).submitted)) && _co.document.CertificationDate.IsValid);
        _ck(_v, 146, 0, currVal_129);
        var currVal_130 = _co.document.CertificationDate;
        _ck(_v, 149, 0, currVal_130);
        var currVal_139 = '';
        _ck(_v, 159, 0, currVal_139);
        var currVal_140 = !_co.document.BrokerOrOtherGOVT.IsValid;
        var currVal_141 = 'text';
        var currVal_142 = 'BrokerOrOtherGOVTModel';
        var currVal_143 = 'Broker or other govt. agency use:';
        var currVal_144 = false;
        var currVal_145 = core_es5["ɵnov"](_v, 4);
        _ck(_v, 161, 0, currVal_140, currVal_141, currVal_142, currVal_143, currVal_144, currVal_145);
        var currVal_146 = 'BrokerOrOtherGOVTModel';
        var currVal_147 = false;
        var currVal_148 = _co.document.BrokerOrOtherGOVT.Value;
        _ck(_v, 163, 0, currVal_146, currVal_147, currVal_148);
        var currVal_149 = ((core_es5["ɵnov"](_v, 161).model.hasError('required') && (!core_es5["ɵnov"](_v, 161).model.pristine || core_es5["ɵnov"](_v, 4).submitted)) && _co.document.BrokerOrOtherGOVT.IsValid);
        _ck(_v, 168, 0, currVal_149);
        var currVal_150 = _co.document.BrokerOrOtherGOVT;
        _ck(_v, 171, 0, currVal_150);
        var currVal_158 = !_co.document.DeliverySignature.IsValid;
        var currVal_159 = 'text';
        var currVal_160 = 'DeliverySignatureModel';
        var currVal_161 = 'Signature:';
        var currVal_162 = false;
        var currVal_163 = core_es5["ɵnov"](_v, 4);
        _ck(_v, 191, 0, currVal_158, currVal_159, currVal_160, currVal_161, currVal_162, currVal_163);
        var currVal_164 = 'DeliverySignatureModel';
        var currVal_165 = false;
        var currVal_166 = _co.document.DeliverySignature.Value;
        _ck(_v, 193, 0, currVal_164, currVal_165, currVal_166);
        var currVal_167 = _co.document.DeliverySignature;
        _ck(_v, 198, 0, currVal_167);
        var currVal_176 = '';
        _ck(_v, 207, 0, currVal_176);
        var currVal_177 = !_co.document.DeliveryDate.IsValid;
        var currVal_178 = 'text';
        var currVal_179 = 'DeliveryDate';
        var currVal_180 = 'Date:';
        var currVal_181 = false;
        var currVal_182 = core_es5["ɵnov"](_v, 4);
        var currVal_183 = 'MM/DD/YYYY';
        var currVal_184 = true;
        _ck(_v, 209, 0, currVal_177, currVal_178, currVal_179, currVal_180, currVal_181, currVal_182, currVal_183, currVal_184);
        var currVal_185 = 'DeliveryDate';
        var currVal_186 = false;
        var currVal_187 = _co.document.DeliveryDate.Value;
        _ck(_v, 211, 0, currVal_185, currVal_186, currVal_187);
        var currVal_188 = ((core_es5["ɵnov"](_v, 209).model.hasError('required') && (!core_es5["ɵnov"](_v, 209).model.pristine || core_es5["ɵnov"](_v, 4).submitted)) && _co.document.DeliveryDate.IsValid);
        _ck(_v, 216, 0, currVal_188);
        var currVal_189 = _co.document.DeliveryDate;
        _ck(_v, 219, 0, currVal_189);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 6).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 6).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 6).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 6).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 6).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 6).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 6).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = core_es5["ɵnov"](_v, 39).ngClassUntouched;
        var currVal_8 = core_es5["ɵnov"](_v, 39).ngClassTouched;
        var currVal_9 = core_es5["ɵnov"](_v, 39).ngClassPristine;
        var currVal_10 = core_es5["ɵnov"](_v, 39).ngClassDirty;
        var currVal_11 = core_es5["ɵnov"](_v, 39).ngClassValid;
        var currVal_12 = core_es5["ɵnov"](_v, 39).ngClassInvalid;
        var currVal_13 = core_es5["ɵnov"](_v, 39).ngClassPending;
        _ck(_v, 34, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13);
        var currVal_24 = core_es5["ɵnov"](_v, 68).ngClassUntouched;
        var currVal_25 = core_es5["ɵnov"](_v, 68).ngClassTouched;
        var currVal_26 = core_es5["ɵnov"](_v, 68).ngClassPristine;
        var currVal_27 = core_es5["ɵnov"](_v, 68).ngClassDirty;
        var currVal_28 = core_es5["ɵnov"](_v, 68).ngClassValid;
        var currVal_29 = core_es5["ɵnov"](_v, 68).ngClassInvalid;
        var currVal_30 = core_es5["ɵnov"](_v, 68).ngClassPending;
        _ck(_v, 63, 0, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30);
        var currVal_35 = core_es5["ɵnov"](_v, 76).ngClassUntouched;
        var currVal_36 = core_es5["ɵnov"](_v, 76).ngClassTouched;
        var currVal_37 = core_es5["ɵnov"](_v, 76).ngClassPristine;
        var currVal_38 = core_es5["ɵnov"](_v, 76).ngClassDirty;
        var currVal_39 = core_es5["ɵnov"](_v, 76).ngClassValid;
        var currVal_40 = core_es5["ɵnov"](_v, 76).ngClassInvalid;
        var currVal_41 = core_es5["ɵnov"](_v, 76).ngClassPending;
        _ck(_v, 71, 0, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41);
        var currVal_51 = core_es5["ɵnov"](_v, 87).ngClassUntouched;
        var currVal_52 = core_es5["ɵnov"](_v, 87).ngClassTouched;
        var currVal_53 = core_es5["ɵnov"](_v, 87).ngClassPristine;
        var currVal_54 = core_es5["ɵnov"](_v, 87).ngClassDirty;
        var currVal_55 = core_es5["ɵnov"](_v, 87).ngClassValid;
        var currVal_56 = core_es5["ɵnov"](_v, 87).ngClassInvalid;
        var currVal_57 = core_es5["ɵnov"](_v, 87).ngClassPending;
        _ck(_v, 82, 0, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56, currVal_57);
        var currVal_62 = core_es5["ɵnov"](_v, 95).ngClassUntouched;
        var currVal_63 = core_es5["ɵnov"](_v, 95).ngClassTouched;
        var currVal_64 = core_es5["ɵnov"](_v, 95).ngClassPristine;
        var currVal_65 = core_es5["ɵnov"](_v, 95).ngClassDirty;
        var currVal_66 = core_es5["ɵnov"](_v, 95).ngClassValid;
        var currVal_67 = core_es5["ɵnov"](_v, 95).ngClassInvalid;
        var currVal_68 = core_es5["ɵnov"](_v, 95).ngClassPending;
        _ck(_v, 90, 0, currVal_62, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67, currVal_68);
        var currVal_73 = core_es5["ɵnov"](_v, 103).ngClassUntouched;
        var currVal_74 = core_es5["ɵnov"](_v, 103).ngClassTouched;
        var currVal_75 = core_es5["ɵnov"](_v, 103).ngClassPristine;
        var currVal_76 = core_es5["ɵnov"](_v, 103).ngClassDirty;
        var currVal_77 = core_es5["ɵnov"](_v, 103).ngClassValid;
        var currVal_78 = core_es5["ɵnov"](_v, 103).ngClassInvalid;
        var currVal_79 = core_es5["ɵnov"](_v, 103).ngClassPending;
        _ck(_v, 98, 0, currVal_73, currVal_74, currVal_75, currVal_76, currVal_77, currVal_78, currVal_79);
        var currVal_89 = (core_es5["ɵnov"](_v, 118).required ? '' : null);
        var currVal_90 = core_es5["ɵnov"](_v, 124).ngClassUntouched;
        var currVal_91 = core_es5["ɵnov"](_v, 124).ngClassTouched;
        var currVal_92 = core_es5["ɵnov"](_v, 124).ngClassPristine;
        var currVal_93 = core_es5["ɵnov"](_v, 124).ngClassDirty;
        var currVal_94 = core_es5["ɵnov"](_v, 124).ngClassValid;
        var currVal_95 = core_es5["ɵnov"](_v, 124).ngClassInvalid;
        var currVal_96 = core_es5["ɵnov"](_v, 124).ngClassPending;
        _ck(_v, 117, 0, currVal_89, currVal_90, currVal_91, currVal_92, currVal_93, currVal_94, currVal_95, currVal_96);
        var currVal_109 = (core_es5["ɵnov"](_v, 137).required ? '' : null);
        var currVal_110 = core_es5["ɵnov"](_v, 143).ngClassUntouched;
        var currVal_111 = core_es5["ɵnov"](_v, 143).ngClassTouched;
        var currVal_112 = core_es5["ɵnov"](_v, 143).ngClassPristine;
        var currVal_113 = core_es5["ɵnov"](_v, 143).ngClassDirty;
        var currVal_114 = core_es5["ɵnov"](_v, 143).ngClassValid;
        var currVal_115 = core_es5["ɵnov"](_v, 143).ngClassInvalid;
        var currVal_116 = core_es5["ɵnov"](_v, 143).ngClassPending;
        _ck(_v, 136, 0, currVal_109, currVal_110, currVal_111, currVal_112, currVal_113, currVal_114, currVal_115, currVal_116);
        var currVal_131 = (core_es5["ɵnov"](_v, 159).required ? '' : null);
        var currVal_132 = core_es5["ɵnov"](_v, 165).ngClassUntouched;
        var currVal_133 = core_es5["ɵnov"](_v, 165).ngClassTouched;
        var currVal_134 = core_es5["ɵnov"](_v, 165).ngClassPristine;
        var currVal_135 = core_es5["ɵnov"](_v, 165).ngClassDirty;
        var currVal_136 = core_es5["ɵnov"](_v, 165).ngClassValid;
        var currVal_137 = core_es5["ɵnov"](_v, 165).ngClassInvalid;
        var currVal_138 = core_es5["ɵnov"](_v, 165).ngClassPending;
        _ck(_v, 158, 0, currVal_131, currVal_132, currVal_133, currVal_134, currVal_135, currVal_136, currVal_137, currVal_138);
        var currVal_151 = core_es5["ɵnov"](_v, 195).ngClassUntouched;
        var currVal_152 = core_es5["ɵnov"](_v, 195).ngClassTouched;
        var currVal_153 = core_es5["ɵnov"](_v, 195).ngClassPristine;
        var currVal_154 = core_es5["ɵnov"](_v, 195).ngClassDirty;
        var currVal_155 = core_es5["ɵnov"](_v, 195).ngClassValid;
        var currVal_156 = core_es5["ɵnov"](_v, 195).ngClassInvalid;
        var currVal_157 = core_es5["ɵnov"](_v, 195).ngClassPending;
        _ck(_v, 190, 0, currVal_151, currVal_152, currVal_153, currVal_154, currVal_155, currVal_156, currVal_157);
        var currVal_168 = (core_es5["ɵnov"](_v, 207).required ? '' : null);
        var currVal_169 = core_es5["ɵnov"](_v, 213).ngClassUntouched;
        var currVal_170 = core_es5["ɵnov"](_v, 213).ngClassTouched;
        var currVal_171 = core_es5["ɵnov"](_v, 213).ngClassPristine;
        var currVal_172 = core_es5["ɵnov"](_v, 213).ngClassDirty;
        var currVal_173 = core_es5["ɵnov"](_v, 213).ngClassValid;
        var currVal_174 = core_es5["ɵnov"](_v, 213).ngClassInvalid;
        var currVal_175 = core_es5["ɵnov"](_v, 213).ngClassPending;
        _ck(_v, 206, 0, currVal_168, currVal_169, currVal_170, currVal_171, currVal_172, currVal_173, currVal_174, currVal_175);
    });
}
function View_CertificationInfo3461Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'certification-info-3461', [], null, null, null, View_CertificationInfo3461Component_0, RenderType_CertificationInfo3461Component)), core_es5["ɵdid"](49152, null, 0, CertificationInfo3461Component, [], null, null)], null, null);
}
var CertificationInfo3461ComponentNgFactory = core_es5["ɵccf"]('certification-info-3461', CertificationInfo3461Component, View_CertificationInfo3461Component_Host_0, { document: 'document' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=certification-info-3461.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/export-documents/cbp-3461/document-blocks/line-information.component-3461.ts

var line_information_component_3461_LineInformationComponent3461 = /** @class */ (function () {
    function LineInformationComponent3461() {
        this.numberPatternHelper = ValidationPatterns;
    }
    LineInformationComponent3461.prototype.isFormValid = function () {
        return this.lineInformationForm.valid;
    };
    LineInformationComponent3461.prototype.submitFormAndValidity = function () {
        this.lineInformationForm.onSubmit(null);
        return this.isFormValid();
    };
    return LineInformationComponent3461;
}());

//# sourceMappingURL=line-information.component-3461.js.map
// CONCATENATED MODULE: ./compiled/app/components/export-documents/cbp-3461/document-blocks/line-information.component-3461.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_LineInformationComponent3461 = [];
var RenderType_LineInformationComponent3461 = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_LineInformationComponent3461, data: {} });
function View_LineInformationComponent3461_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['This field should contain only digits']))], null, null);
}
function View_LineInformationComponent3461_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Line Item Quantity should contain only digits']))], null, null);
}
function View_LineInformationComponent3461_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Country Of Origin is required']))], null, null);
}
function View_LineInformationComponent3461_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Line Name/Address is required']))], null, null);
}
function View_LineInformationComponent3461_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { lineInformationForm: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['24. LINE INFORMATION'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 334, 'form', [['class', 'padding-0'], ['novalidate', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'submit'],
            [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 13).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 13).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[1, 4], ['lineInformationForm',
                4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 117, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 86, 'div', [['class', 'col-md-8']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 47, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'col-sm-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 17, 'div', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['LINE 1 HTS CODE:'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [['placeholder', '1.']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.LineHtsCode1.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['LineHtsCode1', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'],
            form: [4, 'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class', 'col-sm-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['VALUE:'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['placeholder', '1.']], [[1, 'pattern', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.LineValue1.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['LineValue1', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'],
            placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 34, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-sm-6 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [['placeholder',
                '2.']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.LineHtsCode2.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['LineHtsCode2', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'],
            form: [4, 'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'col-sm-6 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'form-input', [['placeholder', '2.']], [[1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2,
                    'ng-valid', null], [2, 'ng-invalid', null], [2,
                    'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.LineValue2.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['LineValue2', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'],
            placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_LineInformationComponent3461_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 26, 'div', [['class', 'col-md-4 line-form margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 23, 'div', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'has-error': 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label display-block margin-bottom-15']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['ZONE STATUS:'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ZoneStatus.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ZoneStatus.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 121, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 76, 'div', [['class', 'col-md-8']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 73, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 34, 'div', [['class', 'col-md-6 line-form margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label display-block margin-bottom-15']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['HTS/COMMERCIAL/DESCRIPTION:'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.HtcCommercialDescType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.HtcCommercialDescType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.HtcCommercialDescValue.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['HtcCommercialDescValue', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]],
            [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'],
            name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'], form: [5, 'form'],
            placeholder: [6, 'placeholder'], isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 34, 'div', [['class',
                'col-md-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'form-input', [], [[1,
                    'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                    null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.LineItemQuantity.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['LineItemQuantity', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_LineInformationComponent3461_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.FtzFilingDate.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['FtzFilingDate', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'], placeholder: [6, 'placeholder'],
            isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 40, 'div', [['class', 'col-md-4 line-form']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 37, 'div', [], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label display-block margin-bottom-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Line Party Type:'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 29, 'div', [['class', 'margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.LinePartyType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.LinePartyType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.LinePartyType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.LinePartyType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 85, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 39, 'div', [['class', 'col-md-8']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.CountryOfOrigin.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['CountryOfOrigin', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_LineInformationComponent3461_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.LineNameAddress.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['LineNameAddress', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_LineInformationComponent3461_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 41, 'div', [['class',
                'col-md-4 line-form margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 27, 'div', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label display-block margin-bottom-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['LINE ID NUMBER, IF APPLICABLE:'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.LineIdNumberType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.LineIdNumberType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.LineIdNumberType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.LineIdNumberValue.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['LineIdNumberValue', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]],
            [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'],
            name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _ck(_v, 27, 0, (core_es5["ɵnov"](_v, 13).submitted && (_co.document.LineHtsCode1.Errors.length > 0)));
        _ck(_v, 26, 0, currVal_7);
        var currVal_15 = !_co.document.LineHtsCode1.IsValid;
        var currVal_16 = 'text';
        var currVal_17 = 'LineHtsCode1';
        var currVal_18 = false;
        var currVal_19 = core_es5["ɵnov"](_v, 13);
        var currVal_20 = '1.';
        var currVal_21 = true;
        _ck(_v, 33, 0, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21);
        var currVal_22 = 'LineHtsCode1';
        var currVal_23 = false;
        var currVal_24 = _co.document.LineHtsCode1.Value;
        _ck(_v, 35, 0, currVal_22, currVal_23, currVal_24);
        var currVal_25 = _co.document.LineHtsCode1;
        _ck(_v, 40, 0, currVal_25);
        var currVal_26 = _ck(_v, 49, 0, (core_es5["ɵnov"](_v, 13).submitted && (_co.document.LineValue1.Errors.length > 0)));
        _ck(_v, 48, 0, currVal_26);
        var currVal_35 = _co.numberPatternHelper.integer;
        _ck(_v, 55, 0, currVal_35);
        var currVal_36 = !_co.document.LineValue1.IsValid;
        var currVal_37 = 'text';
        var currVal_38 = 'LineValue1';
        var currVal_39 = false;
        var currVal_40 = core_es5["ɵnov"](_v, 13);
        var currVal_41 = '1.';
        var currVal_42 = true;
        _ck(_v, 57, 0, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42);
        var currVal_43 = 'LineValue1';
        var currVal_44 = false;
        var currVal_45 = _co.document.LineValue1.Value;
        _ck(_v, 59, 0, currVal_43, currVal_44, currVal_45);
        var currVal_46 = _co.document.LineValue1;
        _ck(_v, 64, 0, currVal_46);
        var currVal_54 = !_co.document.LineHtsCode2.IsValid;
        var currVal_55 = 'text';
        var currVal_56 = 'LineHtsCode2';
        var currVal_57 = false;
        var currVal_58 = core_es5["ɵnov"](_v, 13);
        var currVal_59 = '2.';
        var currVal_60 = true;
        _ck(_v, 75, 0, currVal_54, currVal_55, currVal_56, currVal_57, currVal_58, currVal_59, currVal_60);
        var currVal_61 = 'LineHtsCode2';
        var currVal_62 = false;
        var currVal_63 = _co.document.LineHtsCode2.Value;
        _ck(_v, 77, 0, currVal_61, currVal_62, currVal_63);
        var currVal_64 = _co.document.LineHtsCode2;
        _ck(_v, 82, 0, currVal_64);
        var currVal_73 = _co.numberPatternHelper.integer;
        _ck(_v, 89, 0, currVal_73);
        var currVal_74 = !_co.document.LineValue2.IsValid;
        var currVal_75 = 'text';
        var currVal_76 = 'LineValue2';
        var currVal_77 = false;
        var currVal_78 = core_es5["ɵnov"](_v, 13);
        var currVal_79 = '2.';
        var currVal_80 = true;
        _ck(_v, 91, 0, currVal_74, currVal_75, currVal_76, currVal_77, currVal_78, currVal_79, currVal_80);
        var currVal_81 = 'LineValue2';
        var currVal_82 = false;
        var currVal_83 = _co.document.LineValue2.Value;
        _ck(_v, 93, 0, currVal_81, currVal_82, currVal_83);
        var currVal_84 = _co.document.LineValue2;
        _ck(_v, 98, 0, currVal_84);
        var currVal_85 = (core_es5["ɵnov"](_v, 91).model.hasError('pattern') && _co.document.HeaderPartyNameAndAddress.IsValid);
        _ck(_v, 101, 0, currVal_85);
        var currVal_86 = _ck(_v, 111, 0, (core_es5["ɵnov"](_v, 13).submitted && (_co.document.ZoneStatus.Errors.length > 0)));
        _ck(_v, 110, 0, currVal_86);
        var currVal_94 = 'P';
        var currVal_95 = 'P';
        var currVal_96 = 0;
        _ck(_v, 117, 0, currVal_94, currVal_95, currVal_96);
        var currVal_97 = 'P';
        var currVal_98 = _co.document.ZoneStatus.Value;
        _ck(_v, 119, 0, currVal_97, currVal_98);
        var currVal_106 = 'N';
        var currVal_107 = 'N';
        var currVal_108 = 1;
        _ck(_v, 124, 0, currVal_106, currVal_107, currVal_108);
        var currVal_109 = 'N';
        var currVal_110 = _co.document.ZoneStatus.Value;
        _ck(_v, 126, 0, currVal_109, currVal_110);
        var currVal_111 = _co.document.ZoneStatus;
        _ck(_v, 131, 0, currVal_111);
        var currVal_112 = _ck(_v, 146, 0, (core_es5["ɵnov"](_v, 13).submitted && (_co.document.HtcCommercialDescType.Value == null)));
        _ck(_v, 145, 0, currVal_112);
        var currVal_120 = 'HTS';
        var currVal_121 = 'HTS';
        var currVal_122 = 1;
        _ck(_v, 152, 0, currVal_120, currVal_121, currVal_122);
        var currVal_123 = 'HTS';
        var currVal_124 = _co.document.HtcCommercialDescType.Value;
        _ck(_v, 154, 0, currVal_123, currVal_124);
        var currVal_132 = 'Commercial/Invoice';
        var currVal_133 = 'Commercial/Invoice';
        var currVal_134 = 0;
        _ck(_v, 159, 0, currVal_132, currVal_133, currVal_134);
        var currVal_135 = 'Commercial/Invoice';
        var currVal_136 = _co.document.HtcCommercialDescType.Value;
        _ck(_v, 161, 0, currVal_135, currVal_136);
        var currVal_144 = !_co.document.HtcCommercialDescValue.IsValid;
        var currVal_145 = 'text';
        var currVal_146 = 'HtcCommercialDescValue';
        var currVal_147 = ' ';
        var currVal_148 = false;
        var currVal_149 = core_es5["ɵnov"](_v, 13);
        var currVal_150 = 'Description: ';
        var currVal_151 = true;
        _ck(_v, 167, 0, currVal_144, currVal_145, currVal_146, currVal_147, currVal_148, currVal_149, currVal_150, currVal_151);
        var currVal_152 = 'HtcCommercialDescValue';
        var currVal_153 = false;
        var currVal_154 = _co.document.HtcCommercialDescValue.Value;
        _ck(_v, 169, 0, currVal_152, currVal_153, currVal_154);
        var currVal_155 = _co.document.HtcCommercialDescValue;
        _ck(_v, 174, 0, currVal_155);
        var currVal_164 = _co.numberPatternHelper.integer;
        _ck(_v, 183, 0, currVal_164);
        var currVal_165 = !_co.document.LineItemQuantity.IsValid;
        var currVal_166 = 'text';
        var currVal_167 = 'LineItemQuantity';
        var currVal_168 = 'Line Item Quantity:';
        var currVal_169 = false;
        var currVal_170 = core_es5["ɵnov"](_v, 13);
        _ck(_v, 185, 0, currVal_165, currVal_166, currVal_167, currVal_168, currVal_169, currVal_170);
        var currVal_171 = 'LineItemQuantity';
        var currVal_172 = false;
        var currVal_173 = _co.document.LineItemQuantity.Value;
        _ck(_v, 187, 0, currVal_171, currVal_172, currVal_173);
        var currVal_174 = _co.document.LineItemQuantity;
        _ck(_v, 192, 0, currVal_174);
        var currVal_175 = (core_es5["ɵnov"](_v, 185).model.hasError('pattern') && _co.document.LineItemQuantity.IsValid);
        _ck(_v, 195, 0, currVal_175);
        var currVal_183 = !_co.document.FtzFilingDate.IsValid;
        var currVal_184 = 'text';
        var currVal_185 = 'FtzFilingDate';
        var currVal_186 = 'FTZ Filing Date:';
        var currVal_187 = false;
        var currVal_188 = core_es5["ɵnov"](_v, 13);
        var currVal_189 = 'MM/DD/YYY ';
        var currVal_190 = true;
        _ck(_v, 202, 0, currVal_183, currVal_184, currVal_185, currVal_186, currVal_187, currVal_188, currVal_189, currVal_190);
        var currVal_191 = 'FtzFilingDate';
        var currVal_192 = false;
        var currVal_193 = _co.document.FtzFilingDate.Value;
        _ck(_v, 204, 0, currVal_191, currVal_192, currVal_193);
        var currVal_194 = _co.document.FtzFilingDate;
        _ck(_v, 209, 0, currVal_194);
        var currVal_195 = _ck(_v, 220, 0, (core_es5["ɵnov"](_v, 13).submitted && (_co.document.LinePartyType.Value == null)));
        _ck(_v, 219, 0, currVal_195);
        var currVal_203 = 'Line party Type Manufacturer';
        var currVal_204 = 'Manufacturer';
        var currVal_205 = 0;
        _ck(_v, 228, 0, currVal_203, currVal_204, currVal_205);
        var currVal_206 = 'Line party Type Manufacturer';
        var currVal_207 = _co.document.LinePartyType.Value;
        _ck(_v, 230, 0, currVal_206, currVal_207);
        var currVal_215 = 'Line party Type Consignee';
        var currVal_216 = 'Consignee';
        var currVal_217 = 1;
        _ck(_v, 235, 0, currVal_215, currVal_216, currVal_217);
        var currVal_218 = 'Line party Type Consignee';
        var currVal_219 = _co.document.LinePartyType.Value;
        _ck(_v, 237, 0, currVal_218, currVal_219);
        var currVal_227 = 'Line party Type Selling Party';
        var currVal_228 = 'Selling Party';
        var currVal_229 = 2;
        _ck(_v, 242, 0, currVal_227, currVal_228, currVal_229);
        var currVal_230 = 'Line party Type Selling Party';
        var currVal_231 = _co.document.LinePartyType.Value;
        _ck(_v, 244, 0, currVal_230, currVal_231);
        var currVal_239 = 'Line party Type Buying Party';
        var currVal_240 = 'Buying Party';
        var currVal_241 = 3;
        _ck(_v, 249, 0, currVal_239, currVal_240, currVal_241);
        var currVal_242 = 'Line party Type Buying Party';
        var currVal_243 = _co.document.LinePartyType.Value;
        _ck(_v, 251, 0, currVal_242, currVal_243);
        var currVal_252 = '';
        _ck(_v, 266, 0, currVal_252);
        var currVal_253 = !_co.document.CountryOfOrigin.IsValid;
        var currVal_254 = 'text';
        var currVal_255 = 'CountryOfOrigin';
        var currVal_256 = 'Country Of Origin:';
        var currVal_257 = false;
        var currVal_258 = core_es5["ɵnov"](_v, 13);
        _ck(_v, 268, 0, currVal_253, currVal_254, currVal_255, currVal_256, currVal_257, currVal_258);
        var currVal_259 = 'CountryOfOrigin';
        var currVal_260 = false;
        var currVal_261 = _co.document.CountryOfOrigin.Value;
        _ck(_v, 270, 0, currVal_259, currVal_260, currVal_261);
        var currVal_262 = _co.document.CountryOfOrigin;
        _ck(_v, 275, 0, currVal_262);
        var currVal_263 = ((core_es5["ɵnov"](_v, 268).model.hasError('required') && (!core_es5["ɵnov"](_v, 268).model.pristine || core_es5["ɵnov"](_v, 13).submitted)) && _co.document.CountryOfOrigin.IsValid);
        _ck(_v, 278, 0, currVal_263);
        var currVal_272 = '';
        _ck(_v, 285, 0, currVal_272);
        var currVal_273 = !_co.document.LineNameAddress.IsValid;
        var currVal_274 = 'text';
        var currVal_275 = 'LineNameAddress';
        var currVal_276 = 'Line Name/Address:';
        var currVal_277 = false;
        var currVal_278 = core_es5["ɵnov"](_v, 13);
        _ck(_v, 287, 0, currVal_273, currVal_274, currVal_275, currVal_276, currVal_277, currVal_278);
        var currVal_279 = 'LineNameAddress';
        var currVal_280 = false;
        var currVal_281 = _co.document.LineNameAddress.Value;
        _ck(_v, 289, 0, currVal_279, currVal_280, currVal_281);
        var currVal_282 = _co.document.LineNameAddress;
        _ck(_v, 294, 0, currVal_282);
        var currVal_283 = ((core_es5["ɵnov"](_v, 287).model.hasError('required') && (!core_es5["ɵnov"](_v, 287).model.pristine || core_es5["ɵnov"](_v, 13).submitted)) && _co.document.LineNameAddress.IsValid);
        _ck(_v, 297, 0, currVal_283);
        var currVal_284 = _ck(_v, 306, 0, (core_es5["ɵnov"](_v, 13).submitted && (_co.document.LineIdNumberType.Value == null)));
        _ck(_v, 305, 0, currVal_284);
        var currVal_292 = 'Line party Type IRS';
        var currVal_293 = 'IRS';
        var currVal_294 = 0;
        _ck(_v, 312, 0, currVal_292, currVal_293, currVal_294);
        var currVal_295 = 'Line party Type IRS';
        var currVal_296 = _co.document.LineIdNumberType.Value;
        _ck(_v, 314, 0, currVal_295, currVal_296);
        var currVal_304 = 'Line party Type SSN';
        var currVal_305 = 'SSN';
        var currVal_306 = 1;
        _ck(_v, 319, 0, currVal_304, currVal_305, currVal_306);
        var currVal_307 = 'Line party Type SSN';
        var currVal_308 = _co.document.LineIdNumberType.Value;
        _ck(_v, 321, 0, currVal_307, currVal_308);
        var currVal_316 = 'Line party Type CBP Assigned';
        var currVal_317 = 'CBP Assigned';
        var currVal_318 = 2;
        _ck(_v, 326, 0, currVal_316, currVal_317, currVal_318);
        var currVal_319 = 'Line party Type CBP Assigned';
        var currVal_320 = _co.document.LineIdNumberType.Value;
        _ck(_v, 328, 0, currVal_319, currVal_320);
        var currVal_328 = !_co.document.LineIdNumberValue.IsValid;
        var currVal_329 = 'text';
        var currVal_330 = 'LineIdNumberValue';
        var currVal_331 = false;
        var currVal_332 = core_es5["ɵnov"](_v, 13);
        _ck(_v, 334, 0, currVal_328, currVal_329, currVal_330, currVal_331, currVal_332);
        var currVal_333 = 'LineIdNumberValue';
        var currVal_334 = false;
        var currVal_335 = _co.document.LineIdNumberValue.Value;
        _ck(_v, 336, 0, currVal_333, currVal_334, currVal_335);
        var currVal_336 = _co.document.LineIdNumberValue;
        _ck(_v, 341, 0, currVal_336);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 15).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 15).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 15).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 15).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 15).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 15).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 15).ngClassPending;
        _ck(_v, 11, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_8 = core_es5["ɵnov"](_v, 37).ngClassUntouched;
        var currVal_9 = core_es5["ɵnov"](_v, 37).ngClassTouched;
        var currVal_10 = core_es5["ɵnov"](_v, 37).ngClassPristine;
        var currVal_11 = core_es5["ɵnov"](_v, 37).ngClassDirty;
        var currVal_12 = core_es5["ɵnov"](_v, 37).ngClassValid;
        var currVal_13 = core_es5["ɵnov"](_v, 37).ngClassInvalid;
        var currVal_14 = core_es5["ɵnov"](_v, 37).ngClassPending;
        _ck(_v, 32, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_27 = (core_es5["ɵnov"](_v, 55).pattern ? core_es5["ɵnov"](_v, 55).pattern : null);
        var currVal_28 = core_es5["ɵnov"](_v, 61).ngClassUntouched;
        var currVal_29 = core_es5["ɵnov"](_v, 61).ngClassTouched;
        var currVal_30 = core_es5["ɵnov"](_v, 61).ngClassPristine;
        var currVal_31 = core_es5["ɵnov"](_v, 61).ngClassDirty;
        var currVal_32 = core_es5["ɵnov"](_v, 61).ngClassValid;
        var currVal_33 = core_es5["ɵnov"](_v, 61).ngClassInvalid;
        var currVal_34 = core_es5["ɵnov"](_v, 61).ngClassPending;
        _ck(_v, 54, 0, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34);
        var currVal_47 = core_es5["ɵnov"](_v, 79).ngClassUntouched;
        var currVal_48 = core_es5["ɵnov"](_v, 79).ngClassTouched;
        var currVal_49 = core_es5["ɵnov"](_v, 79).ngClassPristine;
        var currVal_50 = core_es5["ɵnov"](_v, 79).ngClassDirty;
        var currVal_51 = core_es5["ɵnov"](_v, 79).ngClassValid;
        var currVal_52 = core_es5["ɵnov"](_v, 79).ngClassInvalid;
        var currVal_53 = core_es5["ɵnov"](_v, 79).ngClassPending;
        _ck(_v, 74, 0, currVal_47, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53);
        var currVal_65 = (core_es5["ɵnov"](_v, 89).pattern ? core_es5["ɵnov"](_v, 89).pattern : null);
        var currVal_66 = core_es5["ɵnov"](_v, 95).ngClassUntouched;
        var currVal_67 = core_es5["ɵnov"](_v, 95).ngClassTouched;
        var currVal_68 = core_es5["ɵnov"](_v, 95).ngClassPristine;
        var currVal_69 = core_es5["ɵnov"](_v, 95).ngClassDirty;
        var currVal_70 = core_es5["ɵnov"](_v, 95).ngClassValid;
        var currVal_71 = core_es5["ɵnov"](_v, 95).ngClassInvalid;
        var currVal_72 = core_es5["ɵnov"](_v, 95).ngClassPending;
        _ck(_v, 88, 0, currVal_65, currVal_66, currVal_67, currVal_68, currVal_69, currVal_70, currVal_71, currVal_72);
        var currVal_87 = core_es5["ɵnov"](_v, 121).ngClassUntouched;
        var currVal_88 = core_es5["ɵnov"](_v, 121).ngClassTouched;
        var currVal_89 = core_es5["ɵnov"](_v, 121).ngClassPristine;
        var currVal_90 = core_es5["ɵnov"](_v, 121).ngClassDirty;
        var currVal_91 = core_es5["ɵnov"](_v, 121).ngClassValid;
        var currVal_92 = core_es5["ɵnov"](_v, 121).ngClassInvalid;
        var currVal_93 = core_es5["ɵnov"](_v, 121).ngClassPending;
        _ck(_v, 116, 0, currVal_87, currVal_88, currVal_89, currVal_90, currVal_91, currVal_92, currVal_93);
        var currVal_99 = core_es5["ɵnov"](_v, 128).ngClassUntouched;
        var currVal_100 = core_es5["ɵnov"](_v, 128).ngClassTouched;
        var currVal_101 = core_es5["ɵnov"](_v, 128).ngClassPristine;
        var currVal_102 = core_es5["ɵnov"](_v, 128).ngClassDirty;
        var currVal_103 = core_es5["ɵnov"](_v, 128).ngClassValid;
        var currVal_104 = core_es5["ɵnov"](_v, 128).ngClassInvalid;
        var currVal_105 = core_es5["ɵnov"](_v, 128).ngClassPending;
        _ck(_v, 123, 0, currVal_99, currVal_100, currVal_101, currVal_102, currVal_103, currVal_104, currVal_105);
        var currVal_113 = core_es5["ɵnov"](_v, 156).ngClassUntouched;
        var currVal_114 = core_es5["ɵnov"](_v, 156).ngClassTouched;
        var currVal_115 = core_es5["ɵnov"](_v, 156).ngClassPristine;
        var currVal_116 = core_es5["ɵnov"](_v, 156).ngClassDirty;
        var currVal_117 = core_es5["ɵnov"](_v, 156).ngClassValid;
        var currVal_118 = core_es5["ɵnov"](_v, 156).ngClassInvalid;
        var currVal_119 = core_es5["ɵnov"](_v, 156).ngClassPending;
        _ck(_v, 151, 0, currVal_113, currVal_114, currVal_115, currVal_116, currVal_117, currVal_118, currVal_119);
        var currVal_125 = core_es5["ɵnov"](_v, 163).ngClassUntouched;
        var currVal_126 = core_es5["ɵnov"](_v, 163).ngClassTouched;
        var currVal_127 = core_es5["ɵnov"](_v, 163).ngClassPristine;
        var currVal_128 = core_es5["ɵnov"](_v, 163).ngClassDirty;
        var currVal_129 = core_es5["ɵnov"](_v, 163).ngClassValid;
        var currVal_130 = core_es5["ɵnov"](_v, 163).ngClassInvalid;
        var currVal_131 = core_es5["ɵnov"](_v, 163).ngClassPending;
        _ck(_v, 158, 0, currVal_125, currVal_126, currVal_127, currVal_128, currVal_129, currVal_130, currVal_131);
        var currVal_137 = core_es5["ɵnov"](_v, 171).ngClassUntouched;
        var currVal_138 = core_es5["ɵnov"](_v, 171).ngClassTouched;
        var currVal_139 = core_es5["ɵnov"](_v, 171).ngClassPristine;
        var currVal_140 = core_es5["ɵnov"](_v, 171).ngClassDirty;
        var currVal_141 = core_es5["ɵnov"](_v, 171).ngClassValid;
        var currVal_142 = core_es5["ɵnov"](_v, 171).ngClassInvalid;
        var currVal_143 = core_es5["ɵnov"](_v, 171).ngClassPending;
        _ck(_v, 166, 0, currVal_137, currVal_138, currVal_139, currVal_140, currVal_141, currVal_142, currVal_143);
        var currVal_156 = (core_es5["ɵnov"](_v, 183).pattern ? core_es5["ɵnov"](_v, 183).pattern : null);
        var currVal_157 = core_es5["ɵnov"](_v, 189).ngClassUntouched;
        var currVal_158 = core_es5["ɵnov"](_v, 189).ngClassTouched;
        var currVal_159 = core_es5["ɵnov"](_v, 189).ngClassPristine;
        var currVal_160 = core_es5["ɵnov"](_v, 189).ngClassDirty;
        var currVal_161 = core_es5["ɵnov"](_v, 189).ngClassValid;
        var currVal_162 = core_es5["ɵnov"](_v, 189).ngClassInvalid;
        var currVal_163 = core_es5["ɵnov"](_v, 189).ngClassPending;
        _ck(_v, 182, 0, currVal_156, currVal_157, currVal_158, currVal_159, currVal_160, currVal_161, currVal_162, currVal_163);
        var currVal_176 = core_es5["ɵnov"](_v, 206).ngClassUntouched;
        var currVal_177 = core_es5["ɵnov"](_v, 206).ngClassTouched;
        var currVal_178 = core_es5["ɵnov"](_v, 206).ngClassPristine;
        var currVal_179 = core_es5["ɵnov"](_v, 206).ngClassDirty;
        var currVal_180 = core_es5["ɵnov"](_v, 206).ngClassValid;
        var currVal_181 = core_es5["ɵnov"](_v, 206).ngClassInvalid;
        var currVal_182 = core_es5["ɵnov"](_v, 206).ngClassPending;
        _ck(_v, 201, 0, currVal_176, currVal_177, currVal_178, currVal_179, currVal_180, currVal_181, currVal_182);
        var currVal_196 = core_es5["ɵnov"](_v, 232).ngClassUntouched;
        var currVal_197 = core_es5["ɵnov"](_v, 232).ngClassTouched;
        var currVal_198 = core_es5["ɵnov"](_v, 232).ngClassPristine;
        var currVal_199 = core_es5["ɵnov"](_v, 232).ngClassDirty;
        var currVal_200 = core_es5["ɵnov"](_v, 232).ngClassValid;
        var currVal_201 = core_es5["ɵnov"](_v, 232).ngClassInvalid;
        var currVal_202 = core_es5["ɵnov"](_v, 232).ngClassPending;
        _ck(_v, 227, 0, currVal_196, currVal_197, currVal_198, currVal_199, currVal_200, currVal_201, currVal_202);
        var currVal_208 = core_es5["ɵnov"](_v, 239).ngClassUntouched;
        var currVal_209 = core_es5["ɵnov"](_v, 239).ngClassTouched;
        var currVal_210 = core_es5["ɵnov"](_v, 239).ngClassPristine;
        var currVal_211 = core_es5["ɵnov"](_v, 239).ngClassDirty;
        var currVal_212 = core_es5["ɵnov"](_v, 239).ngClassValid;
        var currVal_213 = core_es5["ɵnov"](_v, 239).ngClassInvalid;
        var currVal_214 = core_es5["ɵnov"](_v, 239).ngClassPending;
        _ck(_v, 234, 0, currVal_208, currVal_209, currVal_210, currVal_211, currVal_212, currVal_213, currVal_214);
        var currVal_220 = core_es5["ɵnov"](_v, 246).ngClassUntouched;
        var currVal_221 = core_es5["ɵnov"](_v, 246).ngClassTouched;
        var currVal_222 = core_es5["ɵnov"](_v, 246).ngClassPristine;
        var currVal_223 = core_es5["ɵnov"](_v, 246).ngClassDirty;
        var currVal_224 = core_es5["ɵnov"](_v, 246).ngClassValid;
        var currVal_225 = core_es5["ɵnov"](_v, 246).ngClassInvalid;
        var currVal_226 = core_es5["ɵnov"](_v, 246).ngClassPending;
        _ck(_v, 241, 0, currVal_220, currVal_221, currVal_222, currVal_223, currVal_224, currVal_225, currVal_226);
        var currVal_232 = core_es5["ɵnov"](_v, 253).ngClassUntouched;
        var currVal_233 = core_es5["ɵnov"](_v, 253).ngClassTouched;
        var currVal_234 = core_es5["ɵnov"](_v, 253).ngClassPristine;
        var currVal_235 = core_es5["ɵnov"](_v, 253).ngClassDirty;
        var currVal_236 = core_es5["ɵnov"](_v, 253).ngClassValid;
        var currVal_237 = core_es5["ɵnov"](_v, 253).ngClassInvalid;
        var currVal_238 = core_es5["ɵnov"](_v, 253).ngClassPending;
        _ck(_v, 248, 0, currVal_232, currVal_233, currVal_234, currVal_235, currVal_236, currVal_237, currVal_238);
        var currVal_244 = (core_es5["ɵnov"](_v, 266).required ? '' : null);
        var currVal_245 = core_es5["ɵnov"](_v, 272).ngClassUntouched;
        var currVal_246 = core_es5["ɵnov"](_v, 272).ngClassTouched;
        var currVal_247 = core_es5["ɵnov"](_v, 272).ngClassPristine;
        var currVal_248 = core_es5["ɵnov"](_v, 272).ngClassDirty;
        var currVal_249 = core_es5["ɵnov"](_v, 272).ngClassValid;
        var currVal_250 = core_es5["ɵnov"](_v, 272).ngClassInvalid;
        var currVal_251 = core_es5["ɵnov"](_v, 272).ngClassPending;
        _ck(_v, 265, 0, currVal_244, currVal_245, currVal_246, currVal_247, currVal_248, currVal_249, currVal_250, currVal_251);
        var currVal_264 = (core_es5["ɵnov"](_v, 285).required ? '' : null);
        var currVal_265 = core_es5["ɵnov"](_v, 291).ngClassUntouched;
        var currVal_266 = core_es5["ɵnov"](_v, 291).ngClassTouched;
        var currVal_267 = core_es5["ɵnov"](_v, 291).ngClassPristine;
        var currVal_268 = core_es5["ɵnov"](_v, 291).ngClassDirty;
        var currVal_269 = core_es5["ɵnov"](_v, 291).ngClassValid;
        var currVal_270 = core_es5["ɵnov"](_v, 291).ngClassInvalid;
        var currVal_271 = core_es5["ɵnov"](_v, 291).ngClassPending;
        _ck(_v, 284, 0, currVal_264, currVal_265, currVal_266, currVal_267, currVal_268, currVal_269, currVal_270, currVal_271);
        var currVal_285 = core_es5["ɵnov"](_v, 316).ngClassUntouched;
        var currVal_286 = core_es5["ɵnov"](_v, 316).ngClassTouched;
        var currVal_287 = core_es5["ɵnov"](_v, 316).ngClassPristine;
        var currVal_288 = core_es5["ɵnov"](_v, 316).ngClassDirty;
        var currVal_289 = core_es5["ɵnov"](_v, 316).ngClassValid;
        var currVal_290 = core_es5["ɵnov"](_v, 316).ngClassInvalid;
        var currVal_291 = core_es5["ɵnov"](_v, 316).ngClassPending;
        _ck(_v, 311, 0, currVal_285, currVal_286, currVal_287, currVal_288, currVal_289, currVal_290, currVal_291);
        var currVal_297 = core_es5["ɵnov"](_v, 323).ngClassUntouched;
        var currVal_298 = core_es5["ɵnov"](_v, 323).ngClassTouched;
        var currVal_299 = core_es5["ɵnov"](_v, 323).ngClassPristine;
        var currVal_300 = core_es5["ɵnov"](_v, 323).ngClassDirty;
        var currVal_301 = core_es5["ɵnov"](_v, 323).ngClassValid;
        var currVal_302 = core_es5["ɵnov"](_v, 323).ngClassInvalid;
        var currVal_303 = core_es5["ɵnov"](_v, 323).ngClassPending;
        _ck(_v, 318, 0, currVal_297, currVal_298, currVal_299, currVal_300, currVal_301, currVal_302, currVal_303);
        var currVal_309 = core_es5["ɵnov"](_v, 330).ngClassUntouched;
        var currVal_310 = core_es5["ɵnov"](_v, 330).ngClassTouched;
        var currVal_311 = core_es5["ɵnov"](_v, 330).ngClassPristine;
        var currVal_312 = core_es5["ɵnov"](_v, 330).ngClassDirty;
        var currVal_313 = core_es5["ɵnov"](_v, 330).ngClassValid;
        var currVal_314 = core_es5["ɵnov"](_v, 330).ngClassInvalid;
        var currVal_315 = core_es5["ɵnov"](_v, 330).ngClassPending;
        _ck(_v, 325, 0, currVal_309, currVal_310, currVal_311, currVal_312, currVal_313, currVal_314, currVal_315);
        var currVal_321 = core_es5["ɵnov"](_v, 338).ngClassUntouched;
        var currVal_322 = core_es5["ɵnov"](_v, 338).ngClassTouched;
        var currVal_323 = core_es5["ɵnov"](_v, 338).ngClassPristine;
        var currVal_324 = core_es5["ɵnov"](_v, 338).ngClassDirty;
        var currVal_325 = core_es5["ɵnov"](_v, 338).ngClassValid;
        var currVal_326 = core_es5["ɵnov"](_v, 338).ngClassInvalid;
        var currVal_327 = core_es5["ɵnov"](_v, 338).ngClassPending;
        _ck(_v, 333, 0, currVal_321, currVal_322, currVal_323, currVal_324, currVal_325, currVal_326, currVal_327);
    });
}
function View_LineInformationComponent3461_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'line-information-3461', [], null, null, null, View_LineInformationComponent3461_0, RenderType_LineInformationComponent3461)), core_es5["ɵdid"](49152, null, 0, line_information_component_3461_LineInformationComponent3461, [], null, null)], null, null);
}
var LineInformationComponent3461NgFactory = core_es5["ɵccf"]('line-information-3461', line_information_component_3461_LineInformationComponent3461, View_LineInformationComponent3461_Host_0, { document: 'document' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=line-information.component-3461.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/export-documents/cbp-3461/document-blocks/bill-of-landing-3461.component.ts

var bill_of_landing_3461_component_BillOfLanding3461Component = /** @class */ (function () {
    function BillOfLanding3461Component() {
        this.numberPatternHelper = ValidationPatterns;
    }
    BillOfLanding3461Component.prototype.isFormValid = function () {
        return this.billOfLandingForm.valid;
    };
    BillOfLanding3461Component.prototype.submitFormAndValidity = function () {
        this.billOfLandingForm.onSubmit(null);
        return this.isFormValid();
    };
    return BillOfLanding3461Component;
}());

//# sourceMappingURL=bill-of-landing-3461.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/export-documents/cbp-3461/document-blocks/bill-of-landing-3461.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */












var styles_BillOfLanding3461Component = [];
var RenderType_BillOfLanding3461Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_BillOfLanding3461Component, data: {} });
function View_BillOfLanding3461Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Bol Number is required']))], null, null);
}
function View_BillOfLanding3461Component_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['BOL NUMBER is required']))], null, null);
}
function View_BillOfLanding3461Component_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['This field should contain only digits']))], null, null);
}
function View_BillOfLanding3461Component_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Quantity is required']))], null, null);
}
function View_BillOfLanding3461Component_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Line Name/Address is required']))], null, null);
}
function View_BillOfLanding3461Component_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Quantity contain only digits']))], null, null);
}
function View_BillOfLanding3461Component_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Voyage/FLT/Trip is required']))], null, null);
}
function View_BillOfLanding3461Component_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Conveyance is required']))], null, null);
}
function View_BillOfLanding3461Component_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Arrival Date is required']))], null, null);
}
function View_BillOfLanding3461Component_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { billOfLandingForm: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['BILL OF LADING INFORMATION(USE ADDITIONAL BLOCK BELOW FOR A SECOND BILL OF LADING)'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 389, 'form', [['class', 'padding-0'], ['novalidate', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'submit'],
            [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 13).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 13).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[1, 4], ['billOfLandingForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 74, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 38, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 35, 'div', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'has-error': 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'checkbox-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['25.'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'radio-btn-right']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.NonAmsOrSplitBill.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'div', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['26.'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'radio-btn-right']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched',
                    null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
                [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                    null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.NonAmsOrSplitBill.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched',
                    null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
                [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                    null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.FirstBillOfLanding.ScacOrCarrierId.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['ScacOrCarrierId1', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2,
                forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'],
            name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2,
                    'ng-valid', null], [2, 'ng-invalid', null], [2,
                    'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.FirstBillOfLanding.InBondNumber.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['InBondNumber1', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_BillOfLanding3461Component_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 109, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 36, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['27. BOL TYPE:'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.FirstBillOfLanding.BolTypeInBond.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.FirstBillOfLanding.BolTypeMaster.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.FirstBillOfLanding.BolTypeHouse.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.FirstBillOfLanding.BolTypeRegularOrSimple.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 68, 'div', [['class',
                'col-md-8']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 43, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-6 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.FirstBillOfLanding.BolNumber.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['FirstBolNumber', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_BillOfLanding3461Component_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class',
                'col-md-6 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 18, 'form-input', [['required', '']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched', null], [2,
                    'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                    null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
                [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.FirstBillOfLanding.Quantity.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['FirstQuantity',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_BillOfLanding3461Component_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_BillOfLanding3461Component_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-6 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.FirstBillOfLanding.UnitOfMeasure.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['FirstUnitOfMeasure', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_BillOfLanding3461Component_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['SECOND BILL OF LADING'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 109, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 36, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'checkbox-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['BOL TYPE:'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.SecondBillOfLanding.BolTypeInBond.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.SecondBillOfLanding.BolTypeMaster.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.SecondBillOfLanding.BolTypeHouse.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'checkbox', [], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.SecondBillOfLanding.BolTypeRegularOrSimple.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 68, 'div', [['class',
                'col-md-8']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 29, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-sm-6 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.SecondBillOfLanding.ScacOrCarrierId.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['ScacOrCarrierId2', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2,
                forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'],
            name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'col-sm-6 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched',
                    null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
                [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                    null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.SecondBillOfLanding.InBondNumber.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['InBondNumber2', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 34, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-sm-6 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.SecondBillOfLanding.BolNumber.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['SecondBolNumber', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2,
                forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'],
            name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'col-sm-6 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'form-input', [], [[1,
                    'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                    null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.SecondBillOfLanding.Quantity.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['SecondQuantity', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_BillOfLanding3461Component_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 53, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.SecondBillOfLanding.UnitOfMeasure.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['SecondUnitOfMeasure', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]],
            [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'],
            name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2,
                    'ng-valid', null], [2, 'ng-invalid', null], [2,
                    'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.VoyageOrFltOrTrip.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['VoyageOrFltOrTrip', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_BillOfLanding3461Component_7)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2,
                    'ng-valid', null], [2, 'ng-invalid', null], [2,
                    'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.Conveyance.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['Conveyance', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_BillOfLanding3461Component_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ArrivalDate.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['ArrivalDate', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'], placeholder: [6, 'placeholder'], isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_BillOfLanding3461Component_9)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _ck(_v, 23, 0, (core_es5["ɵnov"](_v, 13).submitted && (_co.document.NonAmsOrSplitBill.Value == null)));
        _ck(_v, 22, 0, currVal_7);
        var currVal_15 = 'NonAms';
        var currVal_16 = 'NON-AMS';
        var currVal_17 = 0;
        _ck(_v, 33, 0, currVal_15, currVal_16, currVal_17);
        var currVal_18 = 'NonAms';
        var currVal_19 = _co.document.NonAmsOrSplitBill.Value;
        _ck(_v, 35, 0, currVal_18, currVal_19);
        var currVal_27 = 'Split Bill';
        var currVal_28 = 'SPLIT BILL';
        var currVal_29 = 1;
        _ck(_v, 49, 0, currVal_27, currVal_28, currVal_29);
        var currVal_30 = 'Split Bill';
        var currVal_31 = _co.document.NonAmsOrSplitBill.Value;
        _ck(_v, 51, 0, currVal_30, currVal_31);
        var currVal_39 = !_co.document.FirstBillOfLanding.ScacOrCarrierId.IsValid;
        var currVal_40 = 'text';
        var currVal_41 = 'ScacOrCarrierId1';
        var currVal_42 = '28. Scac/Carrier ID:';
        var currVal_43 = false;
        var currVal_44 = core_es5["ɵnov"](_v, 13);
        _ck(_v, 62, 0, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44);
        var currVal_45 = 'ScacOrCarrierId1';
        var currVal_46 = false;
        var currVal_47 = _co.document.FirstBillOfLanding.ScacOrCarrierId.Value;
        _ck(_v, 64, 0, currVal_45, currVal_46, currVal_47);
        var currVal_48 = _co.document.FirstBillOfLanding.ScacOrCarrierId;
        _ck(_v, 69, 0, currVal_48);
        var currVal_57 = '';
        _ck(_v, 76, 0, currVal_57);
        var currVal_58 = !_co.document.FirstBillOfLanding.InBondNumber.IsValid;
        var currVal_59 = 'text';
        var currVal_60 = 'InBondNumber1';
        var currVal_61 = '29. IN-BOND NUMBER:';
        var currVal_62 = false;
        var currVal_63 = core_es5["ɵnov"](_v, 13);
        _ck(_v, 78, 0, currVal_58, currVal_59, currVal_60, currVal_61, currVal_62, currVal_63);
        var currVal_64 = 'InBondNumber1';
        var currVal_65 = false;
        var currVal_66 = _co.document.FirstBillOfLanding.InBondNumber.Value;
        _ck(_v, 80, 0, currVal_64, currVal_65, currVal_66);
        var currVal_67 = ((core_es5["ɵnov"](_v, 78).model.hasError('required') && (!core_es5["ɵnov"](_v, 78).model.pristine || core_es5["ɵnov"](_v, 13).submitted)) && _co.document.FirstBillOfLanding.InBondNumber.IsValid);
        _ck(_v, 85, 0, currVal_67);
        var currVal_68 = _co.document.FirstBillOfLanding.InBondNumber;
        _ck(_v, 88, 0, currVal_68);
        var currVal_76 = 'FistInBond';
        var currVal_77 = 'In-Bond';
        _ck(_v, 101, 0, currVal_76, currVal_77);
        var currVal_78 = 'FistInBond';
        var currVal_79 = _co.document.FirstBillOfLanding.BolTypeInBond.Value;
        _ck(_v, 103, 0, currVal_78, currVal_79);
        var currVal_87 = 'FirstBolTypeMaster';
        var currVal_88 = 'Master';
        _ck(_v, 109, 0, currVal_87, currVal_88);
        var currVal_89 = 'FirstBolTypeMaster';
        var currVal_90 = _co.document.FirstBillOfLanding.BolTypeMaster.Value;
        _ck(_v, 111, 0, currVal_89, currVal_90);
        var currVal_98 = 'FirstBolTypeHouse';
        var currVal_99 = 'House';
        _ck(_v, 117, 0, currVal_98, currVal_99);
        var currVal_100 = 'FirstBolTypeHouse';
        var currVal_101 = _co.document.FirstBillOfLanding.BolTypeHouse.Value;
        _ck(_v, 119, 0, currVal_100, currVal_101);
        var currVal_109 = 'FirstBolTypeRegularOrSimple';
        var currVal_110 = 'Regular/Simple';
        _ck(_v, 125, 0, currVal_109, currVal_110);
        var currVal_111 = 'FirstBolTypeRegularOrSimple';
        var currVal_112 = _co.document.FirstBillOfLanding.BolTypeRegularOrSimple.Value;
        _ck(_v, 127, 0, currVal_111, currVal_112);
        var currVal_121 = '';
        _ck(_v, 140, 0, currVal_121);
        var currVal_122 = !_co.document.FirstBillOfLanding.BolNumber.IsValid;
        var currVal_123 = 'text';
        var currVal_124 = 'FirstBolNumber';
        var currVal_125 = '30. BOL NUMBER:';
        var currVal_126 = false;
        var currVal_127 = core_es5["ɵnov"](_v, 13);
        _ck(_v, 142, 0, currVal_122, currVal_123, currVal_124, currVal_125, currVal_126, currVal_127);
        var currVal_128 = 'FirstBolNumber';
        var currVal_129 = false;
        var currVal_130 = _co.document.FirstBillOfLanding.BolNumber.Value;
        _ck(_v, 144, 0, currVal_128, currVal_129, currVal_130);
        var currVal_131 = ((core_es5["ɵnov"](_v, 142).model.hasError('required') && (!core_es5["ɵnov"](_v, 142).model.pristine || core_es5["ɵnov"](_v, 13).submitted)) && _co.document.FirstBillOfLanding.BolNumber.IsValid);
        _ck(_v, 149, 0, currVal_131);
        var currVal_132 = _co.document.FirstBillOfLanding.BolNumber;
        _ck(_v, 152, 0, currVal_132);
        var currVal_142 = '';
        _ck(_v, 159, 0, currVal_142);
        var currVal_143 = _co.numberPatternHelper.integer;
        _ck(_v, 160, 0, currVal_143);
        var currVal_144 = !_co.document.FirstBillOfLanding.Quantity.IsValid;
        var currVal_145 = 'number';
        var currVal_146 = 'FirstQuantity';
        var currVal_147 = '31. Quantity:';
        var currVal_148 = false;
        var currVal_149 = core_es5["ɵnov"](_v, 13);
        _ck(_v, 162, 0, currVal_144, currVal_145, currVal_146, currVal_147, currVal_148, currVal_149);
        var currVal_150 = 'FirstQuantity';
        var currVal_151 = false;
        var currVal_152 = _co.document.FirstBillOfLanding.Quantity.Value;
        _ck(_v, 164, 0, currVal_150, currVal_151, currVal_152);
        var currVal_153 = core_es5["ɵnov"](_v, 162).model.hasError('pattern');
        _ck(_v, 169, 0, currVal_153);
        var currVal_154 = ((core_es5["ɵnov"](_v, 162).model.hasError('required') && (!core_es5["ɵnov"](_v, 162).model.pristine || core_es5["ɵnov"](_v, 13).submitted)) && _co.document.FirstBillOfLanding.Quantity.IsValid);
        _ck(_v, 172, 0, currVal_154);
        var currVal_155 = _co.document.FirstBillOfLanding.Quantity;
        _ck(_v, 175, 0, currVal_155);
        var currVal_164 = '';
        _ck(_v, 185, 0, currVal_164);
        var currVal_165 = !_co.document.FirstBillOfLanding.UnitOfMeasure.IsValid;
        var currVal_166 = 'text';
        var currVal_167 = 'FirstUnitOfMeasure';
        var currVal_168 = '32. Unit of measure:';
        var currVal_169 = false;
        var currVal_170 = core_es5["ɵnov"](_v, 13);
        _ck(_v, 187, 0, currVal_165, currVal_166, currVal_167, currVal_168, currVal_169, currVal_170);
        var currVal_171 = 'FirstUnitOfMeasure';
        var currVal_172 = false;
        var currVal_173 = _co.document.FirstBillOfLanding.UnitOfMeasure.Value;
        _ck(_v, 189, 0, currVal_171, currVal_172, currVal_173);
        var currVal_174 = ((core_es5["ɵnov"](_v, 187).model.hasError('required') && (!core_es5["ɵnov"](_v, 187).model.pristine || core_es5["ɵnov"](_v, 13).submitted)) && _co.document.FirstBillOfLanding.UnitOfMeasure.IsValid);
        _ck(_v, 194, 0, currVal_174);
        var currVal_175 = _co.document.FirstBillOfLanding.UnitOfMeasure;
        _ck(_v, 197, 0, currVal_175);
        var currVal_183 = 'SecondInBond';
        var currVal_184 = 'In-Bond';
        _ck(_v, 221, 0, currVal_183, currVal_184);
        var currVal_185 = 'SecondInBond';
        var currVal_186 = _co.document.SecondBillOfLanding.BolTypeInBond.Value;
        _ck(_v, 223, 0, currVal_185, currVal_186);
        var currVal_194 = 'SecondTypeMaster';
        var currVal_195 = 'Master';
        _ck(_v, 229, 0, currVal_194, currVal_195);
        var currVal_196 = 'SecondTypeMaster';
        var currVal_197 = _co.document.SecondBillOfLanding.BolTypeMaster.Value;
        _ck(_v, 231, 0, currVal_196, currVal_197);
        var currVal_205 = 'SecondBolTypeHouse';
        var currVal_206 = 'House';
        _ck(_v, 237, 0, currVal_205, currVal_206);
        var currVal_207 = 'SecondBolTypeHouse';
        var currVal_208 = _co.document.SecondBillOfLanding.BolTypeHouse.Value;
        _ck(_v, 239, 0, currVal_207, currVal_208);
        var currVal_216 = 'SecondBolTypeRegularOrSimple';
        var currVal_217 = 'Regular/Simple';
        _ck(_v, 245, 0, currVal_216, currVal_217);
        var currVal_218 = 'SecondBolTypeRegularOrSimple';
        var currVal_219 = _co.document.SecondBillOfLanding.BolTypeRegularOrSimple.Value;
        _ck(_v, 247, 0, currVal_218, currVal_219);
        var currVal_227 = !_co.document.SecondBillOfLanding.ScacOrCarrierId.IsValid;
        var currVal_228 = 'text';
        var currVal_229 = 'ScacOrCarrierId2';
        var currVal_230 = 'Scac/Carrier ID:';
        var currVal_231 = false;
        var currVal_232 = core_es5["ɵnov"](_v, 13);
        _ck(_v, 260, 0, currVal_227, currVal_228, currVal_229, currVal_230, currVal_231, currVal_232);
        var currVal_233 = 'ScacOrCarrierId2';
        var currVal_234 = false;
        var currVal_235 = _co.document.SecondBillOfLanding.ScacOrCarrierId.Value;
        _ck(_v, 262, 0, currVal_233, currVal_234, currVal_235);
        var currVal_236 = _co.document.SecondBillOfLanding.ScacOrCarrierId;
        _ck(_v, 267, 0, currVal_236);
        var currVal_244 = !_co.document.SecondBillOfLanding.InBondNumber.IsValid;
        var currVal_245 = 'text';
        var currVal_246 = 'InBondNumber2';
        var currVal_247 = 'IN-BOND NUMBER:';
        var currVal_248 = false;
        var currVal_249 = core_es5["ɵnov"](_v, 13);
        _ck(_v, 274, 0, currVal_244, currVal_245, currVal_246, currVal_247, currVal_248, currVal_249);
        var currVal_250 = 'InBondNumber2';
        var currVal_251 = false;
        var currVal_252 = _co.document.SecondBillOfLanding.InBondNumber.Value;
        _ck(_v, 276, 0, currVal_250, currVal_251, currVal_252);
        var currVal_253 = _co.document.SecondBillOfLanding.InBondNumber;
        _ck(_v, 281, 0, currVal_253);
        var currVal_261 = !_co.document.SecondBillOfLanding.BolNumber.IsValid;
        var currVal_262 = 'text';
        var currVal_263 = 'SecondBolNumber';
        var currVal_264 = 'BOL NUMBER:';
        var currVal_265 = false;
        var currVal_266 = core_es5["ɵnov"](_v, 13);
        _ck(_v, 291, 0, currVal_261, currVal_262, currVal_263, currVal_264, currVal_265, currVal_266);
        var currVal_267 = 'SecondBolNumber';
        var currVal_268 = false;
        var currVal_269 = _co.document.SecondBillOfLanding.BolNumber.Value;
        _ck(_v, 293, 0, currVal_267, currVal_268, currVal_269);
        var currVal_270 = _co.document.SecondBillOfLanding.BolNumber;
        _ck(_v, 298, 0, currVal_270);
        var currVal_279 = _co.numberPatternHelper.integer;
        _ck(_v, 305, 0, currVal_279);
        var currVal_280 = !_co.document.SecondBillOfLanding.Quantity.IsValid;
        var currVal_281 = 'number';
        var currVal_282 = 'SecondQuantity';
        var currVal_283 = 'Quantity:';
        var currVal_284 = false;
        var currVal_285 = core_es5["ɵnov"](_v, 13);
        _ck(_v, 307, 0, currVal_280, currVal_281, currVal_282, currVal_283, currVal_284, currVal_285);
        var currVal_286 = 'SecondQuantity';
        var currVal_287 = false;
        var currVal_288 = _co.document.SecondBillOfLanding.Quantity.Value;
        _ck(_v, 309, 0, currVal_286, currVal_287, currVal_288);
        var currVal_289 = _co.document.SecondBillOfLanding.Quantity;
        _ck(_v, 314, 0, currVal_289);
        var currVal_290 = (core_es5["ɵnov"](_v, 307).model.hasError('pattern') && _co.document.SecondBillOfLanding.Quantity.IsValid);
        _ck(_v, 317, 0, currVal_290);
        var currVal_298 = !_co.document.SecondBillOfLanding.UnitOfMeasure.IsValid;
        var currVal_299 = 'text';
        var currVal_300 = 'SecondUnitOfMeasure';
        var currVal_301 = 'Unit of Measure:';
        var currVal_302 = false;
        var currVal_303 = core_es5["ɵnov"](_v, 13);
        _ck(_v, 329, 0, currVal_298, currVal_299, currVal_300, currVal_301, currVal_302, currVal_303);
        var currVal_304 = 'SecondUnitOfMeasure';
        var currVal_305 = false;
        var currVal_306 = _co.document.SecondBillOfLanding.UnitOfMeasure.Value;
        _ck(_v, 331, 0, currVal_304, currVal_305, currVal_306);
        var currVal_307 = _co.document.SecondBillOfLanding.UnitOfMeasure;
        _ck(_v, 336, 0, currVal_307);
        var currVal_316 = '';
        _ck(_v, 343, 0, currVal_316);
        var currVal_317 = !_co.document.VoyageOrFltOrTrip.IsValid;
        var currVal_318 = 'text';
        var currVal_319 = 'VoyageOrFltOrTrip';
        var currVal_320 = 'Voyage/Flt/Trip:';
        var currVal_321 = false;
        var currVal_322 = core_es5["ɵnov"](_v, 13);
        _ck(_v, 345, 0, currVal_317, currVal_318, currVal_319, currVal_320, currVal_321, currVal_322);
        var currVal_323 = 'VoyageOrFltOrTrip';
        var currVal_324 = false;
        var currVal_325 = _co.document.VoyageOrFltOrTrip.Value;
        _ck(_v, 347, 0, currVal_323, currVal_324, currVal_325);
        var currVal_326 = ((core_es5["ɵnov"](_v, 345).model.hasError('required') && (!core_es5["ɵnov"](_v, 345).model.pristine || core_es5["ɵnov"](_v, 13).submitted)) && _co.document.VoyageOrFltOrTrip.IsValid);
        _ck(_v, 352, 0, currVal_326);
        var currVal_327 = _co.document.VoyageOrFltOrTrip;
        _ck(_v, 355, 0, currVal_327);
        var currVal_336 = '';
        _ck(_v, 362, 0, currVal_336);
        var currVal_337 = !_co.document.Conveyance.IsValid;
        var currVal_338 = 'text';
        var currVal_339 = 'Conveyance';
        var currVal_340 = 'Conveyance:';
        var currVal_341 = false;
        var currVal_342 = core_es5["ɵnov"](_v, 13);
        _ck(_v, 364, 0, currVal_337, currVal_338, currVal_339, currVal_340, currVal_341, currVal_342);
        var currVal_343 = 'Conveyance';
        var currVal_344 = false;
        var currVal_345 = _co.document.Conveyance.Value;
        _ck(_v, 366, 0, currVal_343, currVal_344, currVal_345);
        var currVal_346 = ((core_es5["ɵnov"](_v, 364).model.hasError('required') && (!core_es5["ɵnov"](_v, 364).model.pristine || core_es5["ɵnov"](_v, 13).submitted)) && _co.document.Conveyance.IsValid);
        _ck(_v, 371, 0, currVal_346);
        var currVal_347 = _co.document.Conveyance;
        _ck(_v, 374, 0, currVal_347);
        var currVal_356 = '';
        _ck(_v, 384, 0, currVal_356);
        var currVal_357 = !_co.document.ArrivalDate.IsValid;
        var currVal_358 = 'text';
        var currVal_359 = 'ArrivalDate';
        var currVal_360 = 'Arrival Date:';
        var currVal_361 = false;
        var currVal_362 = core_es5["ɵnov"](_v, 13);
        var currVal_363 = 'MM/DD/YYYY';
        var currVal_364 = true;
        _ck(_v, 386, 0, currVal_357, currVal_358, currVal_359, currVal_360, currVal_361, currVal_362, currVal_363, currVal_364);
        var currVal_365 = 'ArrivalDate';
        var currVal_366 = false;
        var currVal_367 = _co.document.ArrivalDate.Value;
        _ck(_v, 388, 0, currVal_365, currVal_366, currVal_367);
        var currVal_368 = ((core_es5["ɵnov"](_v, 386).model.hasError('required') && (!core_es5["ɵnov"](_v, 386).model.pristine || core_es5["ɵnov"](_v, 13).submitted)) && _co.document.ArrivalDate.IsValid);
        _ck(_v, 393, 0, currVal_368);
        var currVal_369 = _co.document.ArrivalDate;
        _ck(_v, 396, 0, currVal_369);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 15).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 15).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 15).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 15).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 15).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 15).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 15).ngClassPending;
        _ck(_v, 11, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_8 = core_es5["ɵnov"](_v, 37).ngClassUntouched;
        var currVal_9 = core_es5["ɵnov"](_v, 37).ngClassTouched;
        var currVal_10 = core_es5["ɵnov"](_v, 37).ngClassPristine;
        var currVal_11 = core_es5["ɵnov"](_v, 37).ngClassDirty;
        var currVal_12 = core_es5["ɵnov"](_v, 37).ngClassValid;
        var currVal_13 = core_es5["ɵnov"](_v, 37).ngClassInvalid;
        var currVal_14 = core_es5["ɵnov"](_v, 37).ngClassPending;
        _ck(_v, 32, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_20 = core_es5["ɵnov"](_v, 53).ngClassUntouched;
        var currVal_21 = core_es5["ɵnov"](_v, 53).ngClassTouched;
        var currVal_22 = core_es5["ɵnov"](_v, 53).ngClassPristine;
        var currVal_23 = core_es5["ɵnov"](_v, 53).ngClassDirty;
        var currVal_24 = core_es5["ɵnov"](_v, 53).ngClassValid;
        var currVal_25 = core_es5["ɵnov"](_v, 53).ngClassInvalid;
        var currVal_26 = core_es5["ɵnov"](_v, 53).ngClassPending;
        _ck(_v, 48, 0, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26);
        var currVal_32 = core_es5["ɵnov"](_v, 66).ngClassUntouched;
        var currVal_33 = core_es5["ɵnov"](_v, 66).ngClassTouched;
        var currVal_34 = core_es5["ɵnov"](_v, 66).ngClassPristine;
        var currVal_35 = core_es5["ɵnov"](_v, 66).ngClassDirty;
        var currVal_36 = core_es5["ɵnov"](_v, 66).ngClassValid;
        var currVal_37 = core_es5["ɵnov"](_v, 66).ngClassInvalid;
        var currVal_38 = core_es5["ɵnov"](_v, 66).ngClassPending;
        _ck(_v, 61, 0, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38);
        var currVal_49 = (core_es5["ɵnov"](_v, 76).required ? '' : null);
        var currVal_50 = core_es5["ɵnov"](_v, 82).ngClassUntouched;
        var currVal_51 = core_es5["ɵnov"](_v, 82).ngClassTouched;
        var currVal_52 = core_es5["ɵnov"](_v, 82).ngClassPristine;
        var currVal_53 = core_es5["ɵnov"](_v, 82).ngClassDirty;
        var currVal_54 = core_es5["ɵnov"](_v, 82).ngClassValid;
        var currVal_55 = core_es5["ɵnov"](_v, 82).ngClassInvalid;
        var currVal_56 = core_es5["ɵnov"](_v, 82).ngClassPending;
        _ck(_v, 75, 0, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56);
        var currVal_69 = core_es5["ɵnov"](_v, 105).ngClassUntouched;
        var currVal_70 = core_es5["ɵnov"](_v, 105).ngClassTouched;
        var currVal_71 = core_es5["ɵnov"](_v, 105).ngClassPristine;
        var currVal_72 = core_es5["ɵnov"](_v, 105).ngClassDirty;
        var currVal_73 = core_es5["ɵnov"](_v, 105).ngClassValid;
        var currVal_74 = core_es5["ɵnov"](_v, 105).ngClassInvalid;
        var currVal_75 = core_es5["ɵnov"](_v, 105).ngClassPending;
        _ck(_v, 100, 0, currVal_69, currVal_70, currVal_71, currVal_72, currVal_73, currVal_74, currVal_75);
        var currVal_80 = core_es5["ɵnov"](_v, 113).ngClassUntouched;
        var currVal_81 = core_es5["ɵnov"](_v, 113).ngClassTouched;
        var currVal_82 = core_es5["ɵnov"](_v, 113).ngClassPristine;
        var currVal_83 = core_es5["ɵnov"](_v, 113).ngClassDirty;
        var currVal_84 = core_es5["ɵnov"](_v, 113).ngClassValid;
        var currVal_85 = core_es5["ɵnov"](_v, 113).ngClassInvalid;
        var currVal_86 = core_es5["ɵnov"](_v, 113).ngClassPending;
        _ck(_v, 108, 0, currVal_80, currVal_81, currVal_82, currVal_83, currVal_84, currVal_85, currVal_86);
        var currVal_91 = core_es5["ɵnov"](_v, 121).ngClassUntouched;
        var currVal_92 = core_es5["ɵnov"](_v, 121).ngClassTouched;
        var currVal_93 = core_es5["ɵnov"](_v, 121).ngClassPristine;
        var currVal_94 = core_es5["ɵnov"](_v, 121).ngClassDirty;
        var currVal_95 = core_es5["ɵnov"](_v, 121).ngClassValid;
        var currVal_96 = core_es5["ɵnov"](_v, 121).ngClassInvalid;
        var currVal_97 = core_es5["ɵnov"](_v, 121).ngClassPending;
        _ck(_v, 116, 0, currVal_91, currVal_92, currVal_93, currVal_94, currVal_95, currVal_96, currVal_97);
        var currVal_102 = core_es5["ɵnov"](_v, 129).ngClassUntouched;
        var currVal_103 = core_es5["ɵnov"](_v, 129).ngClassTouched;
        var currVal_104 = core_es5["ɵnov"](_v, 129).ngClassPristine;
        var currVal_105 = core_es5["ɵnov"](_v, 129).ngClassDirty;
        var currVal_106 = core_es5["ɵnov"](_v, 129).ngClassValid;
        var currVal_107 = core_es5["ɵnov"](_v, 129).ngClassInvalid;
        var currVal_108 = core_es5["ɵnov"](_v, 129).ngClassPending;
        _ck(_v, 124, 0, currVal_102, currVal_103, currVal_104, currVal_105, currVal_106, currVal_107, currVal_108);
        var currVal_113 = (core_es5["ɵnov"](_v, 140).required ? '' : null);
        var currVal_114 = core_es5["ɵnov"](_v, 146).ngClassUntouched;
        var currVal_115 = core_es5["ɵnov"](_v, 146).ngClassTouched;
        var currVal_116 = core_es5["ɵnov"](_v, 146).ngClassPristine;
        var currVal_117 = core_es5["ɵnov"](_v, 146).ngClassDirty;
        var currVal_118 = core_es5["ɵnov"](_v, 146).ngClassValid;
        var currVal_119 = core_es5["ɵnov"](_v, 146).ngClassInvalid;
        var currVal_120 = core_es5["ɵnov"](_v, 146).ngClassPending;
        _ck(_v, 139, 0, currVal_113, currVal_114, currVal_115, currVal_116, currVal_117, currVal_118, currVal_119, currVal_120);
        var currVal_133 = (core_es5["ɵnov"](_v, 159).required ? '' : null);
        var currVal_134 = (core_es5["ɵnov"](_v, 160).pattern ? core_es5["ɵnov"](_v, 160).pattern : null);
        var currVal_135 = core_es5["ɵnov"](_v, 166).ngClassUntouched;
        var currVal_136 = core_es5["ɵnov"](_v, 166).ngClassTouched;
        var currVal_137 = core_es5["ɵnov"](_v, 166).ngClassPristine;
        var currVal_138 = core_es5["ɵnov"](_v, 166).ngClassDirty;
        var currVal_139 = core_es5["ɵnov"](_v, 166).ngClassValid;
        var currVal_140 = core_es5["ɵnov"](_v, 166).ngClassInvalid;
        var currVal_141 = core_es5["ɵnov"](_v, 166).ngClassPending;
        _ck(_v, 158, 0, currVal_133, currVal_134, currVal_135, currVal_136, currVal_137, currVal_138, currVal_139, currVal_140, currVal_141);
        var currVal_156 = (core_es5["ɵnov"](_v, 185).required ? '' : null);
        var currVal_157 = core_es5["ɵnov"](_v, 191).ngClassUntouched;
        var currVal_158 = core_es5["ɵnov"](_v, 191).ngClassTouched;
        var currVal_159 = core_es5["ɵnov"](_v, 191).ngClassPristine;
        var currVal_160 = core_es5["ɵnov"](_v, 191).ngClassDirty;
        var currVal_161 = core_es5["ɵnov"](_v, 191).ngClassValid;
        var currVal_162 = core_es5["ɵnov"](_v, 191).ngClassInvalid;
        var currVal_163 = core_es5["ɵnov"](_v, 191).ngClassPending;
        _ck(_v, 184, 0, currVal_156, currVal_157, currVal_158, currVal_159, currVal_160, currVal_161, currVal_162, currVal_163);
        var currVal_176 = core_es5["ɵnov"](_v, 225).ngClassUntouched;
        var currVal_177 = core_es5["ɵnov"](_v, 225).ngClassTouched;
        var currVal_178 = core_es5["ɵnov"](_v, 225).ngClassPristine;
        var currVal_179 = core_es5["ɵnov"](_v, 225).ngClassDirty;
        var currVal_180 = core_es5["ɵnov"](_v, 225).ngClassValid;
        var currVal_181 = core_es5["ɵnov"](_v, 225).ngClassInvalid;
        var currVal_182 = core_es5["ɵnov"](_v, 225).ngClassPending;
        _ck(_v, 220, 0, currVal_176, currVal_177, currVal_178, currVal_179, currVal_180, currVal_181, currVal_182);
        var currVal_187 = core_es5["ɵnov"](_v, 233).ngClassUntouched;
        var currVal_188 = core_es5["ɵnov"](_v, 233).ngClassTouched;
        var currVal_189 = core_es5["ɵnov"](_v, 233).ngClassPristine;
        var currVal_190 = core_es5["ɵnov"](_v, 233).ngClassDirty;
        var currVal_191 = core_es5["ɵnov"](_v, 233).ngClassValid;
        var currVal_192 = core_es5["ɵnov"](_v, 233).ngClassInvalid;
        var currVal_193 = core_es5["ɵnov"](_v, 233).ngClassPending;
        _ck(_v, 228, 0, currVal_187, currVal_188, currVal_189, currVal_190, currVal_191, currVal_192, currVal_193);
        var currVal_198 = core_es5["ɵnov"](_v, 241).ngClassUntouched;
        var currVal_199 = core_es5["ɵnov"](_v, 241).ngClassTouched;
        var currVal_200 = core_es5["ɵnov"](_v, 241).ngClassPristine;
        var currVal_201 = core_es5["ɵnov"](_v, 241).ngClassDirty;
        var currVal_202 = core_es5["ɵnov"](_v, 241).ngClassValid;
        var currVal_203 = core_es5["ɵnov"](_v, 241).ngClassInvalid;
        var currVal_204 = core_es5["ɵnov"](_v, 241).ngClassPending;
        _ck(_v, 236, 0, currVal_198, currVal_199, currVal_200, currVal_201, currVal_202, currVal_203, currVal_204);
        var currVal_209 = core_es5["ɵnov"](_v, 249).ngClassUntouched;
        var currVal_210 = core_es5["ɵnov"](_v, 249).ngClassTouched;
        var currVal_211 = core_es5["ɵnov"](_v, 249).ngClassPristine;
        var currVal_212 = core_es5["ɵnov"](_v, 249).ngClassDirty;
        var currVal_213 = core_es5["ɵnov"](_v, 249).ngClassValid;
        var currVal_214 = core_es5["ɵnov"](_v, 249).ngClassInvalid;
        var currVal_215 = core_es5["ɵnov"](_v, 249).ngClassPending;
        _ck(_v, 244, 0, currVal_209, currVal_210, currVal_211, currVal_212, currVal_213, currVal_214, currVal_215);
        var currVal_220 = core_es5["ɵnov"](_v, 264).ngClassUntouched;
        var currVal_221 = core_es5["ɵnov"](_v, 264).ngClassTouched;
        var currVal_222 = core_es5["ɵnov"](_v, 264).ngClassPristine;
        var currVal_223 = core_es5["ɵnov"](_v, 264).ngClassDirty;
        var currVal_224 = core_es5["ɵnov"](_v, 264).ngClassValid;
        var currVal_225 = core_es5["ɵnov"](_v, 264).ngClassInvalid;
        var currVal_226 = core_es5["ɵnov"](_v, 264).ngClassPending;
        _ck(_v, 259, 0, currVal_220, currVal_221, currVal_222, currVal_223, currVal_224, currVal_225, currVal_226);
        var currVal_237 = core_es5["ɵnov"](_v, 278).ngClassUntouched;
        var currVal_238 = core_es5["ɵnov"](_v, 278).ngClassTouched;
        var currVal_239 = core_es5["ɵnov"](_v, 278).ngClassPristine;
        var currVal_240 = core_es5["ɵnov"](_v, 278).ngClassDirty;
        var currVal_241 = core_es5["ɵnov"](_v, 278).ngClassValid;
        var currVal_242 = core_es5["ɵnov"](_v, 278).ngClassInvalid;
        var currVal_243 = core_es5["ɵnov"](_v, 278).ngClassPending;
        _ck(_v, 273, 0, currVal_237, currVal_238, currVal_239, currVal_240, currVal_241, currVal_242, currVal_243);
        var currVal_254 = core_es5["ɵnov"](_v, 295).ngClassUntouched;
        var currVal_255 = core_es5["ɵnov"](_v, 295).ngClassTouched;
        var currVal_256 = core_es5["ɵnov"](_v, 295).ngClassPristine;
        var currVal_257 = core_es5["ɵnov"](_v, 295).ngClassDirty;
        var currVal_258 = core_es5["ɵnov"](_v, 295).ngClassValid;
        var currVal_259 = core_es5["ɵnov"](_v, 295).ngClassInvalid;
        var currVal_260 = core_es5["ɵnov"](_v, 295).ngClassPending;
        _ck(_v, 290, 0, currVal_254, currVal_255, currVal_256, currVal_257, currVal_258, currVal_259, currVal_260);
        var currVal_271 = (core_es5["ɵnov"](_v, 305).pattern ? core_es5["ɵnov"](_v, 305).pattern : null);
        var currVal_272 = core_es5["ɵnov"](_v, 311).ngClassUntouched;
        var currVal_273 = core_es5["ɵnov"](_v, 311).ngClassTouched;
        var currVal_274 = core_es5["ɵnov"](_v, 311).ngClassPristine;
        var currVal_275 = core_es5["ɵnov"](_v, 311).ngClassDirty;
        var currVal_276 = core_es5["ɵnov"](_v, 311).ngClassValid;
        var currVal_277 = core_es5["ɵnov"](_v, 311).ngClassInvalid;
        var currVal_278 = core_es5["ɵnov"](_v, 311).ngClassPending;
        _ck(_v, 304, 0, currVal_271, currVal_272, currVal_273, currVal_274, currVal_275, currVal_276, currVal_277, currVal_278);
        var currVal_291 = core_es5["ɵnov"](_v, 333).ngClassUntouched;
        var currVal_292 = core_es5["ɵnov"](_v, 333).ngClassTouched;
        var currVal_293 = core_es5["ɵnov"](_v, 333).ngClassPristine;
        var currVal_294 = core_es5["ɵnov"](_v, 333).ngClassDirty;
        var currVal_295 = core_es5["ɵnov"](_v, 333).ngClassValid;
        var currVal_296 = core_es5["ɵnov"](_v, 333).ngClassInvalid;
        var currVal_297 = core_es5["ɵnov"](_v, 333).ngClassPending;
        _ck(_v, 328, 0, currVal_291, currVal_292, currVal_293, currVal_294, currVal_295, currVal_296, currVal_297);
        var currVal_308 = (core_es5["ɵnov"](_v, 343).required ? '' : null);
        var currVal_309 = core_es5["ɵnov"](_v, 349).ngClassUntouched;
        var currVal_310 = core_es5["ɵnov"](_v, 349).ngClassTouched;
        var currVal_311 = core_es5["ɵnov"](_v, 349).ngClassPristine;
        var currVal_312 = core_es5["ɵnov"](_v, 349).ngClassDirty;
        var currVal_313 = core_es5["ɵnov"](_v, 349).ngClassValid;
        var currVal_314 = core_es5["ɵnov"](_v, 349).ngClassInvalid;
        var currVal_315 = core_es5["ɵnov"](_v, 349).ngClassPending;
        _ck(_v, 342, 0, currVal_308, currVal_309, currVal_310, currVal_311, currVal_312, currVal_313, currVal_314, currVal_315);
        var currVal_328 = (core_es5["ɵnov"](_v, 362).required ? '' : null);
        var currVal_329 = core_es5["ɵnov"](_v, 368).ngClassUntouched;
        var currVal_330 = core_es5["ɵnov"](_v, 368).ngClassTouched;
        var currVal_331 = core_es5["ɵnov"](_v, 368).ngClassPristine;
        var currVal_332 = core_es5["ɵnov"](_v, 368).ngClassDirty;
        var currVal_333 = core_es5["ɵnov"](_v, 368).ngClassValid;
        var currVal_334 = core_es5["ɵnov"](_v, 368).ngClassInvalid;
        var currVal_335 = core_es5["ɵnov"](_v, 368).ngClassPending;
        _ck(_v, 361, 0, currVal_328, currVal_329, currVal_330, currVal_331, currVal_332, currVal_333, currVal_334, currVal_335);
        var currVal_348 = (core_es5["ɵnov"](_v, 384).required ? '' : null);
        var currVal_349 = core_es5["ɵnov"](_v, 390).ngClassUntouched;
        var currVal_350 = core_es5["ɵnov"](_v, 390).ngClassTouched;
        var currVal_351 = core_es5["ɵnov"](_v, 390).ngClassPristine;
        var currVal_352 = core_es5["ɵnov"](_v, 390).ngClassDirty;
        var currVal_353 = core_es5["ɵnov"](_v, 390).ngClassValid;
        var currVal_354 = core_es5["ɵnov"](_v, 390).ngClassInvalid;
        var currVal_355 = core_es5["ɵnov"](_v, 390).ngClassPending;
        _ck(_v, 383, 0, currVal_348, currVal_349, currVal_350, currVal_351, currVal_352, currVal_353, currVal_354, currVal_355);
    });
}
function View_BillOfLanding3461Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'bill-of-landing-3461', [], null, null, null, View_BillOfLanding3461Component_0, RenderType_BillOfLanding3461Component)), core_es5["ɵdid"](49152, null, 0, bill_of_landing_3461_component_BillOfLanding3461Component, [], null, null)], null, null);
}
var BillOfLanding3461ComponentNgFactory = core_es5["ɵccf"]('bill-of-landing-3461', bill_of_landing_3461_component_BillOfLanding3461Component, View_BillOfLanding3461Component_Host_0, { document: 'document' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=bill-of-landing-3461.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/objects/documents/CBP3461.ts


var CBP3461_CBP3461 = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](CBP3461, _super);
    function CBP3461() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /*Header Information*/
        _this.PortOfEntry = new DocumentProperty();
        _this.BondType = new DocumentProperty(); // TODO to enum
        _this.ImporterNumberType = new DocumentProperty(); // TODO to enum
        _this.ImporterNumber = new DocumentProperty();
        _this.ImporterNameAndAddress = new DocumentProperty();
        _this.EntryNumber = new DocumentProperty();
        _this.BondValue = new DocumentProperty();
        _this.EntryValue = new DocumentProperty();
        _this.Ces = new DocumentProperty();
        _this.EntryType = new DocumentProperty();
        _this.OriginationWhseEntryNumber = new DocumentProperty();
        _this.PortOfUnLanding = new DocumentProperty();
        _this.LocationOfGoods = new DocumentProperty();
        _this.ModeOfTransportation = new DocumentProperty(); // TODO to enum
        _this.SuretyCode = new DocumentProperty();
        _this.GONumber = new DocumentProperty();
        _this.ConveyanceName = new DocumentProperty();
        /*Header Reference Information*/
        _this.ReferenceIdCode = new DocumentProperty();
        _this.ReferenceIdNumber = new DocumentProperty();
        /*Header Parties Start*/
        _this.HeaderPartyType = new DocumentProperty(); // TODO to enum
        _this.HeaderPartyNameAndAddress = new DocumentProperty();
        _this.HeaderIDType = new DocumentProperty(); // TODO to enum
        //why number?
        _this.HeaderID = new DocumentProperty();
        /*Certification start*/
        _this.CertificationSignatureOfApplicant = new DocumentProperty();
        _this.PhoneNumber = new DocumentProperty();
        _this.CertificationDate = new DocumentProperty();
        _this.IsOtherAgencyActionRequired = new DocumentProperty();
        _this.OtherAgencyActionNamely = new DocumentProperty();
        _this.IsCBPExaminationRequired = new DocumentProperty();
        _this.IsEntryRejected = new DocumentProperty();
        _this.EntryRejectedExplanation = new DocumentProperty();
        _this.BrokerOrOtherGOVT = new DocumentProperty();
        _this.DeliverySignature = new DocumentProperty();
        _this.DeliveryDate = new DocumentProperty();
        /*Line info start*/
        _this.LineHtsCode1 = new DocumentProperty();
        _this.LineValue1 = new DocumentProperty();
        _this.LineHtsCode2 = new DocumentProperty();
        _this.LineValue2 = new DocumentProperty();
        _this.ZoneStatus = new DocumentProperty(); // TODO to enum
        _this.HtcCommercialDescType = new DocumentProperty(); // TODO to enum
        _this.HtcCommercialDescValue = new DocumentProperty();
        _this.LineItemQuantity = new DocumentProperty();
        _this.FtzFilingDate = new DocumentProperty();
        _this.LinePartyType = new DocumentProperty(); // TODO to enum
        _this.CountryOfOrigin = new DocumentProperty();
        _this.LineNameAddress = new DocumentProperty();
        _this.LineIdNumberType = new DocumentProperty(); // TODO to enum
        _this.LineIdNumberValue = new DocumentProperty();
        /*Line info end*/
        /*Bill of landing information*/
        _this.NonAmsOrSplitBill = new DocumentProperty();
        _this.FirstBillOfLanding = new BillOfLanding();
        _this.SecondBillOfLanding = new BillOfLanding();
        _this.VoyageOrFltOrTrip = new DocumentProperty();
        _this.Conveyance = new DocumentProperty();
        _this.ArrivalDate = new DocumentProperty();
        return _this;
    }
    return CBP3461;
}(baseEntity["a" /* BaseEntity */]));

var DocumentProperty = /** @class */ (function () {
    function DocumentProperty() {
        this.IsValid = true;
        this.Errors = [];
    }
    return DocumentProperty;
}());

var BillOfLanding = /** @class */ (function () {
    function BillOfLanding() {
        this.BolTypeInBond = new DocumentProperty();
        this.BolTypeMaster = new DocumentProperty();
        this.BolTypeHouse = new DocumentProperty();
        this.BolTypeRegularOrSimple = new DocumentProperty();
        this.ScacOrCarrierId = new DocumentProperty();
        this.InBondNumber = new DocumentProperty();
        this.BolNumber = new DocumentProperty();
        this.Quantity = new DocumentProperty();
        this.UnitOfMeasure = new DocumentProperty();
    }
    return BillOfLanding;
}());

//# sourceMappingURL=CBP3461.js.map
// CONCATENATED MODULE: ./app/common/helpers/scrollHelper.ts

var scrollHelper_ScrollHelper = /** @class */ (function () {
    function ScrollHelper() {
    }
    ScrollHelper.stickyElementOnScroll = function (scrollY, elements, top) {
        if (screenHelper["a" /* ScreenHelper */].isPhone())
            return;
        if (scrollY.target.scrollTop > top) {
            elements.forEach(function (el) {
                el.classList.add('sticky');
            });
            return;
        }
        elements.forEach(function (el) {
            el.classList.remove('sticky');
        });
    };
    ;
    /**
      * Force vertical scroll to be shown.
      * Used on pages were vertical scroll is needed and it cannot be achived via styles.
      * By some reason, 'overflow' style value is overwritten by body.
      */
    ScrollHelper.forceSetVerticalScroll = function (element) {
        element.style.overflowY = 'scroll';
    };
    return ScrollHelper;
}());

//# sourceMappingURL=scrollHelper.js.map
// CONCATENATED MODULE: ./app/components/export-documents/cbp-3461/document-3461.component.ts






var document_3461_component_Document3461Component = /** @class */ (function () {
    function Document3461Component(documentService) {
        this.documentService = documentService;
        this.processing = false;
        this.document = new CBP3461_CBP3461();
        this.isFormSubmitted = false;
        this.documentModified = new core_es5["EventEmitter"]();
    }
    Document3461Component.prototype.show = function (document) {
        if (document === void 0) { document = new CBP3461_CBP3461(); }
        //TODO send request for the new empty object or for edit object
        this.document = document;
        this.documentModal.show();
    };
    Document3461Component.prototype.ngOnInit = function () {
        perfect_scrollbar["initialize"](this.documentModalRef.nativeElement);
    };
    Document3461Component.prototype.isDocumentValid = function () {
        if (!this.certificationInfo3461Component || !this.lineInformation3461 ||
            !this.headerInfo3461Component || !this.headerParties3461Component || !this.billOfLanding3461Component) {
            return false;
        }
        return (this.certificationInfo3461Component.isFormValid() && this.lineInformation3461.isFormValid() &&
            this.headerInfo3461Component.isFormValid() && this.headerParties3461Component.isFormValid() && this.billOfLanding3461Component.isFormValid());
    };
    Document3461Component.prototype.onScroll = function (scrollY) {
        scrollHelper_ScrollHelper.stickyElementOnScroll(scrollY, [this.saveBtn.nativeElement, this.closeBtn.nativeElement], 150);
    };
    ;
    Document3461Component.prototype.closeDocumentModal = function (hideModal) {
        this.lineInformation3461.lineInformationForm.resetForm();
        this.headerInfo3461Component.headerInfoForm.resetForm();
        this.headerParties3461Component.headerPartiesForm.resetForm();
        this.certificationInfo3461Component.certificationInfoForm.resetForm();
        this.billOfLanding3461Component.billOfLandingForm.resetForm();
        this.isFormSubmitted = false;
        if (hideModal)
            this.documentModal.hide();
    };
    Document3461Component.prototype.save = function () {
        var _this = this;
        this.lineInformation3461.submitFormAndValidity();
        this.headerInfo3461Component.submitFormAndValidity();
        this.headerParties3461Component.submitFormAndValidity();
        this.certificationInfo3461Component.submitFormAndValidity();
        this.billOfLanding3461Component.submitFormAndValidity();
        if (!this.isDocumentValid()) {
            this.isFormSubmitted = true;
            return;
        }
        this.document.OrderId = this.order.Id;
        this.document.Created = new Date();
        this.document.Name = 'CBP3461'; // TODO this shit
        this.documentService.save(this.document, 'CBP3461').then(function (resp) {
            _this.document = resp.Data;
            var firstBillOfLanding = resp.Data.FirstBillOfLanding;
            var secondBillOfLanding = resp.Data.SecondBillOfLanding;
            var isValid = PropertyHelper.isPropsValid(resp.Data) && PropertyHelper.isPropsValid(firstBillOfLanding) && PropertyHelper.isPropsValid(secondBillOfLanding);
            if (isValid) {
                _this.processing = false;
                _this.closeDocumentModal(true);
                _this.documentModified.emit(resp);
            }
        });
    };
    Document3461Component.ctorParameters = function () { return [{ type: documentService_DocumentService }]; };
    return Document3461Component;
}());

//# sourceMappingURL=document-3461.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/export-documents/cbp-3461/document-3461.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


















var styles_Document3461Component = [];
var RenderType_Document3461Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_Document3461Component, data: {} });
function View_Document3461Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 26, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 23, 'form', [['class', 'form-horizontal'], ['novalidate', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'submit'],
            [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 4).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[2, 4], ['documentForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'header-info-3461', [], null, [[null, 'documentChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('documentChange' === en)) {
                    var pd_0 = ((_co.document = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_HeaderInfo3461Component_0, RenderType_HeaderInfo3461Component)),
        core_es5["ɵdid"](49152, [[5, 4]], 0, header_info_3461_component_HeaderInfo3461Component, [], { document: [0,
                'document'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'header-parties-3461', [], null, [[null, 'documentChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('documentChange' === en)) {
                    var pd_0 = ((_co.document = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_HeaderParties3461Component_0, RenderType_HeaderParties3461Component)),
        core_es5["ɵdid"](49152, [[6, 4]], 0, header_parties_3461_component_HeaderParties3461Component, [], { document: [0,
                'document'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'certification-info-3461', [], null, [[null, 'documentChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('documentChange' === en)) {
                    var pd_0 = ((_co.document = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_CertificationInfo3461Component_0, RenderType_CertificationInfo3461Component)),
        core_es5["ɵdid"](49152, [[7, 4]], 0, CertificationInfo3461Component, [], { document: [0,
                'document'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'line-information-3461', [], null, [[null, 'documentChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('documentChange' === en)) {
                    var pd_0 = ((_co.document = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_LineInformationComponent3461_0, RenderType_LineInformationComponent3461)),
        core_es5["ɵdid"](49152, [[4, 4]], 0, line_information_component_3461_LineInformationComponent3461, [], { document: [0,
                'document'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'bill-of-landing-3461', [], null, [[null, 'documentChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('documentChange' === en)) {
                    var pd_0 = ((_co.document = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_BillOfLanding3461Component_0, RenderType_BillOfLanding3461Component)),
        core_es5["ɵdid"](49152, [[8, 4]], 0, bill_of_landing_3461_component_BillOfLanding3461Component, [], { document: [0,
                'document'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.document;
        _ck(_v, 11, 0, currVal_7);
        var currVal_8 = _co.document;
        _ck(_v, 14, 0, currVal_8);
        var currVal_9 = _co.document;
        _ck(_v, 17, 0, currVal_9);
        var currVal_10 = _co.document;
        _ck(_v, 20, 0, currVal_10);
        var currVal_11 = _co.document;
        _ck(_v, 23, 0, currVal_11);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 6).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 6).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 6).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 6).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 6).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 6).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 6).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_Document3461Component_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { documentModal: 0 }), core_es5["ɵqud"](671088640, 2, { documentForm: 0 }),
        core_es5["ɵqud"](402653184, 3, { documentModalRef: 0 }), core_es5["ɵqud"](671088640, 4, { lineInformation3461: 0 }),
        core_es5["ɵqud"](671088640, 5, { headerInfo3461Component: 0 }), core_es5["ɵqud"](671088640, 6, { headerParties3461Component: 0 }),
        core_es5["ɵqud"](671088640, 7, { certificationInfo3461Component: 0 }), core_es5["ɵqud"](671088640, 8, { billOfLanding3461Component: 0 }), core_es5["ɵqud"](402653184, 9, { saveBtn: 0 }), core_es5["ɵqud"](402653184, 10, { closeBtn: 0 }), (_l()(), core_es5["ɵeld"](16777216, [[3, 0], ['documentModalRef', 1]], null, 39, 'div', [['bsModal', ''], ['class', 'modal document document-3461 fade customer-modal'],
            ['id', 'myModal'], ['role', 'dialog']], null, [[null, 'onHide'],
            [null, 'scroll'], [null, 'click'], [null, 'keydown.esc']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 11).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown.esc' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 11).onEsc() !== false);
                ad = (pd_1 && ad);
            }
            if (('onHide' === en)) {
                var pd_2 = (_co.closeDocumentModal(false) !== false);
                ad = (pd_2 && ad);
            }
            if (('scroll' === en)) {
                var pd_3 = (_co.onScroll($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4341760, [[1, 4], ['documentModal',
                4]], 0, modal_component["a" /* ModalDirective */], [core_es5["ElementRef"], core_es5["ViewContainerRef"], core_es5["Renderer"],
            component_loader_factory["a" /* ComponentLoaderFactory */]], { config: [0, 'config'] }, { onHide: 'onHide' }), core_es5["ɵpod"]({ keyboard: 0,
            backdrop: 1 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 34, 'div', [['class', 'modal-dialog modal-lg'], ['role', 'document']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 31, 'div', [['class', 'modal-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'modal-header header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'modal-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['CBP 3461 ENTRY/IMMEDIATE DELIVERY'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, [[10, 0], ['closeBtn', 1]], null, 4, 'button', [['aria-label',
                'Close'], ['class', 'close pull-right btn btn-round btn-white modal-close-btn'],
            ['data-dismiss', 'modal'], ['type', 'button']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.closeDocumentModal(true) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons modal-close-icon']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['close'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, [[9, 0], ['saveBtn', 1]], null, 7, 'button', [['class', 'save pull-right btn btn-round btn-white-orange padding-0'],
            ['type', 'submit']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.save() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'disabled': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons modal-close-icon']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['save'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'modal-body']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_Document3461Component_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 12, 0, false, 'static');
        _ck(_v, 11, 0, currVal_0);
        var currVal_2 = 'save pull-right btn btn-round btn-white-orange padding-0';
        var currVal_3 = _ck(_v, 32, 0, (_co.isFormSubmitted && !_co.isDocumentValid()));
        _ck(_v, 31, 0, currVal_2, currVal_3);
        var currVal_4 = core_es5["ɵnov"](_v, 11).isShown;
        _ck(_v, 44, 0, currVal_4);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = (_co.isFormSubmitted && !_co.isDocumentValid());
        _ck(_v, 30, 0, currVal_1);
    });
}
function View_Document3461Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'document-3461', [], null, null, null, View_Document3461Component_0, RenderType_Document3461Component)), core_es5["ɵdid"](114688, null, 0, document_3461_component_Document3461Component, [documentService_DocumentService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var Document3461ComponentNgFactory = core_es5["ɵccf"]('document-3461', document_3461_component_Document3461Component, View_Document3461Component_Host_0, { order: 'order' }, { documentModified: 'documentModified' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=document-3461.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/export-documents/cbp-7501/document-blocks/first-block-7501.component.ts

var first_block_7501_component_FirstBlock7501Component = /** @class */ (function () {
    function FirstBlock7501Component() {
        this.numberPatternHelper = ValidationPatterns;
    }
    FirstBlock7501Component.prototype.submitFormAndValidity = function () {
        this.firstBlockForm.onSubmit(null);
        return this.isFormValid();
    };
    FirstBlock7501Component.prototype.isFormValid = function () {
        return this.firstBlockForm.valid;
    };
    return FirstBlock7501Component;
}());

//# sourceMappingURL=first-block-7501.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/export-documents/cbp-7501/document-blocks/first-block-7501.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_FirstBlock7501Component = [];
var RenderType_FirstBlock7501Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_FirstBlock7501Component, data: {} });
function View_FirstBlock7501Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Filer Code is required ']))], null, null);
}
function View_FirstBlock7501Component_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Entry Type is required ']))], null, null);
}
function View_FirstBlock7501Component_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Surety No is required ']))], null, null);
}
function View_FirstBlock7501Component_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Surety No should contain only digits ']))], null, null);
}
function View_FirstBlock7501Component_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Bond type is required ']))], null, null);
}
function View_FirstBlock7501Component_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Bond type should contain only digits ']))], null, null);
}
function View_FirstBlock7501Component_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Port Code is required ']))], null, null);
}
function View_FirstBlock7501Component_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Port Code should contain only digits ']))], null, null);
}
function View_FirstBlock7501Component_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Mode of Transport should contain only digits ']))], null, null);
}
function View_FirstBlock7501Component_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Country of Origin is required ']))], null, null);
}
function View_FirstBlock7501Component_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['B/L or AWB No is required ']))], null, null);
}
function View_FirstBlock7501Component_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Manufacturer ID is required ']))], null, null);
}
function View_FirstBlock7501Component_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Exporting Country is required ']))], null, null);
}
function View_FirstBlock7501Component_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' I.T. Date is required ']))], null, null);
}
function View_FirstBlock7501Component_15(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Missing Docs is required ']))], null, null);
}
function View_FirstBlock7501Component_16(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Foreign Port of Lading should contain only digits']))], null, null);
}
function View_FirstBlock7501Component_17(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' U.S. Port of Unlading should contain only digits']))], null, null);
}
function View_FirstBlock7501Component_18(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Location of Goods/G.O. No. is required ']))], null, null);
}
function View_FirstBlock7501Component_19(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Consignee No is required ']))], null, null);
}
function View_FirstBlock7501Component_20(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Importer No is required ']))], null, null);
}
function View_FirstBlock7501Component_21(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Reference No is required ']))], null, null);
}
function View_FirstBlock7501Component_22(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Name is required ']))], null, null);
}
function View_FirstBlock7501Component_23(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['City is required ']))], null, null);
}
function View_FirstBlock7501Component_24(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['State is required ']))], null, null);
}
function View_FirstBlock7501Component_25(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Zip is required ']))], null, null);
}
function View_FirstBlock7501Component_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { firstBlockForm: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 605, 'form', [['class', 'padding-0'], ['novalidate', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'submit'],
            [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 3).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[1, 4], ['firstBlockForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 53, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.FilerCode.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['FilerCode', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)),
        core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0,
                'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.EntryType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['EntryType', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [['placeholder',
                'MM/DD/YYYY']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.SummaryDate.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['SummaryDate', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'], placeholder: [6, 'placeholder'],
            isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 70, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['required', '']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.SuretyNo.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['SuretyNo',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['required',
                '']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.BondType.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['BondType',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['required',
                '']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.PortCode.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['PortCode',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 48, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'form-input', [['placeholder', 'MM/DD/YYYY']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                    'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                    null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.EntryDate.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['EntryDate', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'], placeholder: [6, 'placeholder'],
            isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched',
                    null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
                [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                    null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.ImportingCarrier.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['ImportingCarrier', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2,
                forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'],
            name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'form-input', [], [[1,
                    'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                    null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.ModeOfTransport.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['ModeOfTransport', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_9)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 53, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.CountryOfOrigin.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['CountryOfOrigin', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_10)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [['placeholder',
                'MM/DD/YYYY']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ImportDate.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['ImportDate', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'], placeholder: [6, 'placeholder'],
            isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2,
                    'ng-valid', null], [2, 'ng-invalid', null], [2,
                    'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.BillOfLading.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['BillOfLading', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_11)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 53, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ManufacturerID.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['ManufacturerID', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_12)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ExportingCountry.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['ExportingCountry', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_13)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [['placeholder',
                'MULTI or MM/DD/YYYY']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ExportDate.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['ExportDate', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'], placeholder: [6, 'placeholder'],
            isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 53, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ITNo.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['ITNo', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'form-input', [['placeholder', 'MM/DD/YYYY'],
                ['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
                [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                    null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
                [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.ITDate.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['ITDate', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'], placeholder: [6, 'placeholder'], isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_14)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.MissingDocs.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['MissingDocs', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_15)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 58, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [], [[1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ForeignPortOfLading.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['ForeignPortOfLading', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_16)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [], [[1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.USPortOfUnlading.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['USPortOfUnlading', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_17)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.LocationOfGoodsGONo.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['LocationOfGoodsGONo', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_18)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 58, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required',
                ''], ['title', 'Formats: IRS EIN NN-NNNNNNN, IRS EIN with suffix NN-NNNNNNNXX, SSN NNN-NN-NNNN,  CBP assigned number YYDDPP-NNNNN']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ConsigneeNo.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['ConsigneeNo', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_19)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required',
                ''], ['title', 'Formats: IRS EIN NN-NNNNNNN, IRS EIN with suffix NN-NNNNNNNXX, SSN NNN-NN-NNNN,  CBP assigned number YYDDPP-NNNNN']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ImporterNo.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['ImporterNo', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_20)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required',
                ''], ['title', 'Formats: IRS EIN NN-NNNNNNN, IRS EIN with suffix NN-NNNNNNNXX, SSN NNN-NN-NNNN,  CBP assigned number YYDDPP-NNNNN']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ReferenceNo.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['ReferenceNo', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_21)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 57, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-md-6 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [['placeholder',
                'Name']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.UltimateConsigneeNameAndAddress.Name.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['UltimateConsigneeNameAndAddressName', 4]], 0, formInput_component_FormInputComponent, [[2,
                forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'], placeholder: [6, 'placeholder'], isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'col-md-2 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'form-input', [['class', 'no-label'],
                ['placeholder', 'City']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                    null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
                [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                    null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.UltimateConsigneeNameAndAddress.City.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['UltimateConsigneeNameAndAddressCity', 4]], 0, formInput_component_FormInputComponent, [[2,
                forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'],
            placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'col-md-2 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'form-input', [['class', 'no-label'],
                ['placeholder', 'State']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                    null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
                [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                    null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.UltimateConsigneeNameAndAddress.State.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['UltimateConsigneeNameAndAddressState', 4]], 0, formInput_component_FormInputComponent, [[2,
                forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'],
            placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'col-md-2 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'form-input', [['class', 'no-label'],
                ['placeholder', 'Zip']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                    null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
                [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                    null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.UltimateConsigneeNameAndAddress.Zip.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['UltimateConsigneeNameAndAddressZip', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]],
            [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'],
            name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'], placeholder: [5,
                'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 77, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-6 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['placeholder', 'Name'], ['required', '']], [[1, 'required',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ImporterOfRecordNameAndAddress.Name.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['ImporterOfRecordNameAndAddressName',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'], placeholder: [6, 'placeholder'],
            isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_22)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-2 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['class',
                'no-label'], ['placeholder', 'City'], ['required', '']], [[1, 'required', 0], [2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ImporterOfRecordNameAndAddress.City.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['ImporterOfRecordNameAndAddressCity',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'],
            form: [4, 'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_23)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-2 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['class',
                'no-label'], ['placeholder', 'State'], ['required', '']], [[1, 'required', 0], [2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ImporterOfRecordNameAndAddress.State.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['ImporterOfRecordNameAndAddressState',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'],
            form: [4, 'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_24)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-2 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['class',
                'no-label'], ['placeholder', 'Zip'], ['required', '']], [[1, 'required', 0], [2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.ImporterOfRecordNameAndAddress.Zip.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['ImporterOfRecordNameAndAddressZip',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'],
            form: [4, 'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FirstBlock7501Component_25)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_15 = '';
        _ck(_v, 12, 0, currVal_15);
        var currVal_16 = !_co.document.FilerCode.IsValid;
        var currVal_17 = 'text';
        var currVal_18 = 'FilerCode';
        var currVal_19 = '1. Filer Code/Entry No.';
        var currVal_20 = false;
        var currVal_21 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 14, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21);
        var currVal_22 = 'FilerCode';
        var currVal_23 = false;
        var currVal_24 = _co.document.FilerCode.Value;
        _ck(_v, 16, 0, currVal_22, currVal_23, currVal_24);
        var currVal_25 = ((core_es5["ɵnov"](_v, 14).model.hasError('required') && (!core_es5["ɵnov"](_v, 14).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.FilerCode.IsValid);
        _ck(_v, 21, 0, currVal_25);
        var currVal_26 = _co.document.FilerCode;
        _ck(_v, 24, 0, currVal_26);
        var currVal_35 = '';
        _ck(_v, 31, 0, currVal_35);
        var currVal_36 = !_co.document.EntryType.IsValid;
        var currVal_37 = 'text';
        var currVal_38 = 'EntryType';
        var currVal_39 = '2. Entry Type';
        var currVal_40 = false;
        var currVal_41 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 33, 0, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41);
        var currVal_42 = 'EntryType';
        var currVal_43 = false;
        var currVal_44 = _co.document.EntryType.Value;
        _ck(_v, 35, 0, currVal_42, currVal_43, currVal_44);
        var currVal_45 = _co.document.EntryType;
        _ck(_v, 40, 0, currVal_45);
        var currVal_46 = ((core_es5["ɵnov"](_v, 33).model.hasError('required') && (!core_es5["ɵnov"](_v, 33).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.EntryType.IsValid);
        _ck(_v, 43, 0, currVal_46);
        var currVal_54 = !_co.document.SummaryDate.IsValid;
        var currVal_55 = 'text';
        var currVal_56 = 'SummaryDate';
        var currVal_57 = '3. Summary Date';
        var currVal_58 = false;
        var currVal_59 = core_es5["ɵnov"](_v, 3);
        var currVal_60 = 'MM/DD/YYYY';
        var currVal_61 = true;
        _ck(_v, 50, 0, currVal_54, currVal_55, currVal_56, currVal_57, currVal_58, currVal_59, currVal_60, currVal_61);
        var currVal_62 = 'SummaryDate';
        var currVal_63 = false;
        var currVal_64 = _co.document.SummaryDate.Value;
        _ck(_v, 52, 0, currVal_62, currVal_63, currVal_64);
        var currVal_65 = _co.document.SummaryDate;
        _ck(_v, 57, 0, currVal_65);
        var currVal_75 = '';
        _ck(_v, 67, 0, currVal_75);
        var currVal_76 = _co.numberPatternHelper.integer;
        _ck(_v, 68, 0, currVal_76);
        var currVal_77 = !_co.document.SuretyNo.IsValid;
        var currVal_78 = 'number';
        var currVal_79 = 'SuretyNo';
        var currVal_80 = '4. Surety No.';
        var currVal_81 = false;
        var currVal_82 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 70, 0, currVal_77, currVal_78, currVal_79, currVal_80, currVal_81, currVal_82);
        var currVal_83 = 'SuretyNo';
        var currVal_84 = false;
        var currVal_85 = _co.document.SuretyNo.Value;
        _ck(_v, 72, 0, currVal_83, currVal_84, currVal_85);
        var currVal_86 = _co.document.SuretyNo;
        _ck(_v, 77, 0, currVal_86);
        var currVal_87 = ((core_es5["ɵnov"](_v, 70).model.hasError('required') && (!core_es5["ɵnov"](_v, 70).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.SuretyNo.IsValid);
        _ck(_v, 80, 0, currVal_87);
        var currVal_88 = ((core_es5["ɵnov"](_v, 70).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 70).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.SuretyNo.IsValid);
        _ck(_v, 83, 0, currVal_88);
        var currVal_98 = '';
        _ck(_v, 90, 0, currVal_98);
        var currVal_99 = _co.numberPatternHelper.integer;
        _ck(_v, 91, 0, currVal_99);
        var currVal_100 = !_co.document.BondType.IsValid;
        var currVal_101 = 'number';
        var currVal_102 = 'BondType';
        var currVal_103 = '5. Bond type';
        var currVal_104 = false;
        var currVal_105 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 93, 0, currVal_100, currVal_101, currVal_102, currVal_103, currVal_104, currVal_105);
        var currVal_106 = 'BondType';
        var currVal_107 = false;
        var currVal_108 = _co.document.BondType.Value;
        _ck(_v, 95, 0, currVal_106, currVal_107, currVal_108);
        var currVal_109 = _co.document.BondType;
        _ck(_v, 100, 0, currVal_109);
        var currVal_110 = ((core_es5["ɵnov"](_v, 93).model.hasError('required') && (!core_es5["ɵnov"](_v, 93).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.BondType.IsValid);
        _ck(_v, 103, 0, currVal_110);
        var currVal_111 = ((core_es5["ɵnov"](_v, 93).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 93).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.BondType.IsValid);
        _ck(_v, 106, 0, currVal_111);
        var currVal_121 = '';
        _ck(_v, 113, 0, currVal_121);
        var currVal_122 = _co.numberPatternHelper.integer;
        _ck(_v, 114, 0, currVal_122);
        var currVal_123 = !_co.document.PortCode.IsValid;
        var currVal_124 = 'number';
        var currVal_125 = 'PortCode';
        var currVal_126 = '6. Port Code';
        var currVal_127 = false;
        var currVal_128 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 116, 0, currVal_123, currVal_124, currVal_125, currVal_126, currVal_127, currVal_128);
        var currVal_129 = 'PortCode';
        var currVal_130 = false;
        var currVal_131 = _co.document.PortCode.Value;
        _ck(_v, 118, 0, currVal_129, currVal_130, currVal_131);
        var currVal_132 = _co.document.PortCode;
        _ck(_v, 123, 0, currVal_132);
        var currVal_133 = ((core_es5["ɵnov"](_v, 116).model.hasError('required') && (!core_es5["ɵnov"](_v, 116).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.PortCode.IsValid);
        _ck(_v, 126, 0, currVal_133);
        var currVal_134 = ((core_es5["ɵnov"](_v, 116).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 116).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.PortCode.IsValid);
        _ck(_v, 129, 0, currVal_134);
        var currVal_142 = !_co.document.EntryDate.IsValid;
        var currVal_143 = 'text';
        var currVal_144 = 'EntryDate';
        var currVal_145 = '7. Entry Date';
        var currVal_146 = false;
        var currVal_147 = core_es5["ɵnov"](_v, 3);
        var currVal_148 = 'MM/DD/YYYY';
        var currVal_149 = true;
        _ck(_v, 139, 0, currVal_142, currVal_143, currVal_144, currVal_145, currVal_146, currVal_147, currVal_148, currVal_149);
        var currVal_150 = 'EntryDate';
        var currVal_151 = false;
        var currVal_152 = _co.document.EntryDate.Value;
        _ck(_v, 141, 0, currVal_150, currVal_151, currVal_152);
        var currVal_153 = _co.document.EntryDate;
        _ck(_v, 146, 0, currVal_153);
        var currVal_161 = !_co.document.ImportingCarrier.IsValid;
        var currVal_162 = 'text';
        var currVal_163 = 'ImportingCarrier';
        var currVal_164 = '8. Importing Carrier';
        var currVal_165 = false;
        var currVal_166 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 153, 0, currVal_161, currVal_162, currVal_163, currVal_164, currVal_165, currVal_166);
        var currVal_167 = 'ImportingCarrier';
        var currVal_168 = false;
        var currVal_169 = _co.document.ImportingCarrier.Value;
        _ck(_v, 155, 0, currVal_167, currVal_168, currVal_169);
        var currVal_170 = _co.document.ImportingCarrier;
        _ck(_v, 160, 0, currVal_170);
        var currVal_179 = _co.numberPatternHelper.integer;
        _ck(_v, 167, 0, currVal_179);
        var currVal_180 = !_co.document.ModeOfTransport.IsValid;
        var currVal_181 = 'number';
        var currVal_182 = 'ModeOfTransport';
        var currVal_183 = '9. Mode of Transport';
        var currVal_184 = false;
        var currVal_185 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 169, 0, currVal_180, currVal_181, currVal_182, currVal_183, currVal_184, currVal_185);
        var currVal_186 = 'ModeOfTransport';
        var currVal_187 = false;
        var currVal_188 = _co.document.ModeOfTransport.Value;
        _ck(_v, 171, 0, currVal_186, currVal_187, currVal_188);
        var currVal_189 = _co.document.ModeOfTransport;
        _ck(_v, 176, 0, currVal_189);
        var currVal_190 = ((core_es5["ɵnov"](_v, 169).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 169).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.ModeOfTransport.IsValid);
        _ck(_v, 179, 0, currVal_190);
        var currVal_199 = '';
        _ck(_v, 189, 0, currVal_199);
        var currVal_200 = !_co.document.CountryOfOrigin.IsValid;
        var currVal_201 = 'text';
        var currVal_202 = 'CountryOfOrigin';
        var currVal_203 = '10. Country of Origin';
        var currVal_204 = false;
        var currVal_205 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 191, 0, currVal_200, currVal_201, currVal_202, currVal_203, currVal_204, currVal_205);
        var currVal_206 = 'CountryOfOrigin';
        var currVal_207 = false;
        var currVal_208 = _co.document.CountryOfOrigin.Value;
        _ck(_v, 193, 0, currVal_206, currVal_207, currVal_208);
        var currVal_209 = _co.document.CountryOfOrigin;
        _ck(_v, 198, 0, currVal_209);
        var currVal_210 = ((core_es5["ɵnov"](_v, 191).model.hasError('required') && (!core_es5["ɵnov"](_v, 191).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.CountryOfOrigin.IsValid);
        _ck(_v, 201, 0, currVal_210);
        var currVal_218 = !_co.document.ImportDate.IsValid;
        var currVal_219 = 'text';
        var currVal_220 = 'ImportDate';
        var currVal_221 = '11. Import Date';
        var currVal_222 = false;
        var currVal_223 = core_es5["ɵnov"](_v, 3);
        var currVal_224 = 'MM/DD/YYYY';
        var currVal_225 = true;
        _ck(_v, 208, 0, currVal_218, currVal_219, currVal_220, currVal_221, currVal_222, currVal_223, currVal_224, currVal_225);
        var currVal_226 = 'ImportDate';
        var currVal_227 = false;
        var currVal_228 = _co.document.ImportDate.Value;
        _ck(_v, 210, 0, currVal_226, currVal_227, currVal_228);
        var currVal_229 = _co.document.ImportDate;
        _ck(_v, 215, 0, currVal_229);
        var currVal_238 = '';
        _ck(_v, 222, 0, currVal_238);
        var currVal_239 = !_co.document.BillOfLading.IsValid;
        var currVal_240 = 'text';
        var currVal_241 = 'BillOfLading';
        var currVal_242 = '12. B/L or AWB No.';
        var currVal_243 = false;
        var currVal_244 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 224, 0, currVal_239, currVal_240, currVal_241, currVal_242, currVal_243, currVal_244);
        var currVal_245 = 'BillOfLading';
        var currVal_246 = false;
        var currVal_247 = _co.document.BillOfLading.Value;
        _ck(_v, 226, 0, currVal_245, currVal_246, currVal_247);
        var currVal_248 = _co.document.BillOfLading;
        _ck(_v, 231, 0, currVal_248);
        var currVal_249 = ((core_es5["ɵnov"](_v, 224).model.hasError('required') && (!core_es5["ɵnov"](_v, 224).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.BillOfLading.IsValid);
        _ck(_v, 234, 0, currVal_249);
        var currVal_258 = '';
        _ck(_v, 244, 0, currVal_258);
        var currVal_259 = !_co.document.ManufacturerID.IsValid;
        var currVal_260 = 'text';
        var currVal_261 = 'ManufacturerID';
        var currVal_262 = '13. Manufacturer ID';
        var currVal_263 = false;
        var currVal_264 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 246, 0, currVal_259, currVal_260, currVal_261, currVal_262, currVal_263, currVal_264);
        var currVal_265 = 'ManufacturerID';
        var currVal_266 = false;
        var currVal_267 = _co.document.ManufacturerID.Value;
        _ck(_v, 248, 0, currVal_265, currVal_266, currVal_267);
        var currVal_268 = _co.document.ManufacturerID;
        _ck(_v, 253, 0, currVal_268);
        var currVal_269 = ((core_es5["ɵnov"](_v, 246).model.hasError('required') && (!core_es5["ɵnov"](_v, 246).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.ManufacturerID.IsValid);
        _ck(_v, 256, 0, currVal_269);
        var currVal_278 = '';
        _ck(_v, 263, 0, currVal_278);
        var currVal_279 = !_co.document.ExportingCountry.IsValid;
        var currVal_280 = 'text';
        var currVal_281 = 'ExportingCountry';
        var currVal_282 = '14. Exporting Country';
        var currVal_283 = false;
        var currVal_284 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 265, 0, currVal_279, currVal_280, currVal_281, currVal_282, currVal_283, currVal_284);
        var currVal_285 = 'ExportingCountry';
        var currVal_286 = false;
        var currVal_287 = _co.document.ExportingCountry.Value;
        _ck(_v, 267, 0, currVal_285, currVal_286, currVal_287);
        var currVal_288 = _co.document.ExportingCountry;
        _ck(_v, 272, 0, currVal_288);
        var currVal_289 = ((core_es5["ɵnov"](_v, 265).model.hasError('required') && (!core_es5["ɵnov"](_v, 265).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.ExportingCountry.IsValid);
        _ck(_v, 275, 0, currVal_289);
        var currVal_297 = !_co.document.ExportDate.IsValid;
        var currVal_298 = 'text';
        var currVal_299 = 'ExportDate';
        var currVal_300 = '15. Export Date';
        var currVal_301 = false;
        var currVal_302 = core_es5["ɵnov"](_v, 3);
        var currVal_303 = 'MULTI or MM/DD/YYYY';
        var currVal_304 = true;
        _ck(_v, 282, 0, currVal_297, currVal_298, currVal_299, currVal_300, currVal_301, currVal_302, currVal_303, currVal_304);
        var currVal_305 = 'ExportDate';
        var currVal_306 = false;
        var currVal_307 = _co.document.ExportDate.Value;
        _ck(_v, 284, 0, currVal_305, currVal_306, currVal_307);
        var currVal_308 = _co.document.ExportDate;
        _ck(_v, 289, 0, currVal_308);
        var currVal_316 = !_co.document.ITNo.IsValid;
        var currVal_317 = 'text';
        var currVal_318 = 'ITNo';
        var currVal_319 = '16. I.T. No.';
        var currVal_320 = false;
        var currVal_321 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 299, 0, currVal_316, currVal_317, currVal_318, currVal_319, currVal_320, currVal_321);
        var currVal_322 = 'ITNo';
        var currVal_323 = false;
        var currVal_324 = _co.document.ITNo.Value;
        _ck(_v, 301, 0, currVal_322, currVal_323, currVal_324);
        var currVal_325 = _co.document.ITNo;
        _ck(_v, 306, 0, currVal_325);
        var currVal_334 = '';
        _ck(_v, 313, 0, currVal_334);
        var currVal_335 = !_co.document.ITDate.IsValid;
        var currVal_336 = 'text';
        var currVal_337 = 'ITDate';
        var currVal_338 = '17. I.T. Date';
        var currVal_339 = false;
        var currVal_340 = core_es5["ɵnov"](_v, 3);
        var currVal_341 = 'MM/DD/YYYY';
        var currVal_342 = true;
        _ck(_v, 315, 0, currVal_335, currVal_336, currVal_337, currVal_338, currVal_339, currVal_340, currVal_341, currVal_342);
        var currVal_343 = 'ITDate';
        var currVal_344 = false;
        var currVal_345 = _co.document.ITDate.Value;
        _ck(_v, 317, 0, currVal_343, currVal_344, currVal_345);
        var currVal_346 = _co.document.ITDate;
        _ck(_v, 322, 0, currVal_346);
        var currVal_347 = ((core_es5["ɵnov"](_v, 315).model.hasError('required') && (!core_es5["ɵnov"](_v, 315).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.ITDate.IsValid);
        _ck(_v, 325, 0, currVal_347);
        var currVal_356 = '';
        _ck(_v, 332, 0, currVal_356);
        var currVal_357 = !_co.document.MissingDocs.IsValid;
        var currVal_358 = 'text';
        var currVal_359 = 'MissingDocs';
        var currVal_360 = '18. Missing Docs';
        var currVal_361 = false;
        var currVal_362 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 334, 0, currVal_357, currVal_358, currVal_359, currVal_360, currVal_361, currVal_362);
        var currVal_363 = 'MissingDocs';
        var currVal_364 = false;
        var currVal_365 = _co.document.MissingDocs.Value;
        _ck(_v, 336, 0, currVal_363, currVal_364, currVal_365);
        var currVal_366 = _co.document.MissingDocs;
        _ck(_v, 341, 0, currVal_366);
        var currVal_367 = ((core_es5["ɵnov"](_v, 334).model.hasError('required') && (!core_es5["ɵnov"](_v, 334).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.MissingDocs.IsValid);
        _ck(_v, 344, 0, currVal_367);
        var currVal_376 = _co.numberPatternHelper.integer;
        _ck(_v, 354, 0, currVal_376);
        var currVal_377 = !_co.document.ForeignPortOfLading.IsValid;
        var currVal_378 = 'number';
        var currVal_379 = 'ForeignPortOfLading';
        var currVal_380 = '19. Foreign Port of Lading';
        var currVal_381 = false;
        var currVal_382 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 356, 0, currVal_377, currVal_378, currVal_379, currVal_380, currVal_381, currVal_382);
        var currVal_383 = 'ForeignPortOfLading';
        var currVal_384 = false;
        var currVal_385 = _co.document.ForeignPortOfLading.Value;
        _ck(_v, 358, 0, currVal_383, currVal_384, currVal_385);
        var currVal_386 = _co.document.ForeignPortOfLading;
        _ck(_v, 363, 0, currVal_386);
        var currVal_387 = ((core_es5["ɵnov"](_v, 356).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 356).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.ForeignPortOfLading.IsValid);
        _ck(_v, 366, 0, currVal_387);
        var currVal_396 = _co.numberPatternHelper.integer;
        _ck(_v, 373, 0, currVal_396);
        var currVal_397 = !_co.document.USPortOfUnlading.IsValid;
        var currVal_398 = 'number';
        var currVal_399 = 'USPortOfUnlading';
        var currVal_400 = '20. U.S. Port of Unlading';
        var currVal_401 = false;
        var currVal_402 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 375, 0, currVal_397, currVal_398, currVal_399, currVal_400, currVal_401, currVal_402);
        var currVal_403 = 'USPortOfUnlading';
        var currVal_404 = false;
        var currVal_405 = _co.document.USPortOfUnlading.Value;
        _ck(_v, 377, 0, currVal_403, currVal_404, currVal_405);
        var currVal_406 = _co.document.USPortOfUnlading;
        _ck(_v, 382, 0, currVal_406);
        var currVal_407 = ((core_es5["ɵnov"](_v, 375).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 375).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.USPortOfUnlading.IsValid);
        _ck(_v, 385, 0, currVal_407);
        var currVal_416 = '';
        _ck(_v, 392, 0, currVal_416);
        var currVal_417 = !_co.document.LocationOfGoodsGONo.IsValid;
        var currVal_418 = 'text';
        var currVal_419 = 'LocationOfGoodsGONo';
        var currVal_420 = '21. Location of Goods/G.O. No.';
        var currVal_421 = false;
        var currVal_422 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 394, 0, currVal_417, currVal_418, currVal_419, currVal_420, currVal_421, currVal_422);
        var currVal_423 = 'LocationOfGoodsGONo';
        var currVal_424 = false;
        var currVal_425 = _co.document.LocationOfGoodsGONo.Value;
        _ck(_v, 396, 0, currVal_423, currVal_424, currVal_425);
        var currVal_426 = _co.document.LocationOfGoodsGONo;
        _ck(_v, 401, 0, currVal_426);
        var currVal_427 = ((core_es5["ɵnov"](_v, 394).model.hasError('required') && (!core_es5["ɵnov"](_v, 394).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.LocationOfGoodsGONo.IsValid);
        _ck(_v, 404, 0, currVal_427);
        var currVal_436 = '';
        _ck(_v, 414, 0, currVal_436);
        var currVal_437 = !_co.document.ConsigneeNo.IsValid;
        var currVal_438 = 'text';
        var currVal_439 = 'ConsigneeNo';
        var currVal_440 = '22. Consignee No.';
        var currVal_441 = false;
        var currVal_442 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 416, 0, currVal_437, currVal_438, currVal_439, currVal_440, currVal_441, currVal_442);
        var currVal_443 = 'ConsigneeNo';
        var currVal_444 = false;
        var currVal_445 = _co.document.ConsigneeNo.Value;
        _ck(_v, 418, 0, currVal_443, currVal_444, currVal_445);
        var currVal_446 = _co.document.ConsigneeNo;
        _ck(_v, 423, 0, currVal_446);
        var currVal_447 = ((core_es5["ɵnov"](_v, 416).model.hasError('required') && (!core_es5["ɵnov"](_v, 416).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.ConsigneeNo.IsValid);
        _ck(_v, 426, 0, currVal_447);
        var currVal_456 = '';
        _ck(_v, 433, 0, currVal_456);
        var currVal_457 = !_co.document.ImporterNo.IsValid;
        var currVal_458 = 'text';
        var currVal_459 = 'ImporterNo';
        var currVal_460 = '23. Importer No.';
        var currVal_461 = false;
        var currVal_462 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 435, 0, currVal_457, currVal_458, currVal_459, currVal_460, currVal_461, currVal_462);
        var currVal_463 = 'ImporterNo';
        var currVal_464 = false;
        var currVal_465 = _co.document.ImporterNo.Value;
        _ck(_v, 437, 0, currVal_463, currVal_464, currVal_465);
        var currVal_466 = _co.document.ImporterNo;
        _ck(_v, 442, 0, currVal_466);
        var currVal_467 = ((core_es5["ɵnov"](_v, 435).model.hasError('required') && (!core_es5["ɵnov"](_v, 435).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.ImporterNo.IsValid);
        _ck(_v, 445, 0, currVal_467);
        var currVal_476 = '';
        _ck(_v, 452, 0, currVal_476);
        var currVal_477 = !_co.document.ReferenceNo.IsValid;
        var currVal_478 = 'text';
        var currVal_479 = 'ReferenceNo';
        var currVal_480 = '24. Reference No.';
        var currVal_481 = false;
        var currVal_482 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 454, 0, currVal_477, currVal_478, currVal_479, currVal_480, currVal_481, currVal_482);
        var currVal_483 = 'ReferenceNo';
        var currVal_484 = false;
        var currVal_485 = _co.document.ReferenceNo.Value;
        _ck(_v, 456, 0, currVal_483, currVal_484, currVal_485);
        var currVal_486 = _co.document.ReferenceNo;
        _ck(_v, 461, 0, currVal_486);
        var currVal_487 = ((core_es5["ɵnov"](_v, 454).model.hasError('required') && (!core_es5["ɵnov"](_v, 454).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.ReferenceNo.IsValid);
        _ck(_v, 464, 0, currVal_487);
        var currVal_495 = !_co.document.UltimateConsigneeNameAndAddress.Name.IsValid;
        var currVal_496 = 'text';
        var currVal_497 = 'UltimateConsigneeNameAndAddress.Name';
        var currVal_498 = '25. Ultimate Consignee Name and Address';
        var currVal_499 = false;
        var currVal_500 = core_es5["ɵnov"](_v, 3);
        var currVal_501 = 'Name';
        var currVal_502 = true;
        _ck(_v, 474, 0, currVal_495, currVal_496, currVal_497, currVal_498, currVal_499, currVal_500, currVal_501, currVal_502);
        var currVal_503 = 'UltimateConsigneeNameAndAddress.Name';
        var currVal_504 = false;
        var currVal_505 = _co.document.UltimateConsigneeNameAndAddress.Name.Value;
        _ck(_v, 476, 0, currVal_503, currVal_504, currVal_505);
        var currVal_506 = _co.document.UltimateConsigneeNameAndAddress.Name;
        _ck(_v, 481, 0, currVal_506);
        var currVal_514 = !_co.document.UltimateConsigneeNameAndAddress.City.IsValid;
        var currVal_515 = 'text';
        var currVal_516 = 'UltimateConsigneeNameAndAddress.City';
        var currVal_517 = false;
        var currVal_518 = core_es5["ɵnov"](_v, 3);
        var currVal_519 = 'City';
        var currVal_520 = true;
        _ck(_v, 488, 0, currVal_514, currVal_515, currVal_516, currVal_517, currVal_518, currVal_519, currVal_520);
        var currVal_521 = 'UltimateConsigneeNameAndAddress.City';
        var currVal_522 = false;
        var currVal_523 = _co.document.UltimateConsigneeNameAndAddress.City.Value;
        _ck(_v, 490, 0, currVal_521, currVal_522, currVal_523);
        var currVal_524 = _co.document.UltimateConsigneeNameAndAddress.City;
        _ck(_v, 495, 0, currVal_524);
        var currVal_532 = !_co.document.UltimateConsigneeNameAndAddress.State.IsValid;
        var currVal_533 = 'text';
        var currVal_534 = 'UltimateConsigneeNameAndAddress.State';
        var currVal_535 = false;
        var currVal_536 = core_es5["ɵnov"](_v, 3);
        var currVal_537 = 'State';
        var currVal_538 = true;
        _ck(_v, 502, 0, currVal_532, currVal_533, currVal_534, currVal_535, currVal_536, currVal_537, currVal_538);
        var currVal_539 = 'UltimateConsigneeNameAndAddress.State';
        var currVal_540 = false;
        var currVal_541 = _co.document.UltimateConsigneeNameAndAddress.State.Value;
        _ck(_v, 504, 0, currVal_539, currVal_540, currVal_541);
        var currVal_542 = _co.document.UltimateConsigneeNameAndAddress.State;
        _ck(_v, 509, 0, currVal_542);
        var currVal_550 = !_co.document.UltimateConsigneeNameAndAddress.Zip.IsValid;
        var currVal_551 = 'text';
        var currVal_552 = 'UltimateConsigneeNameAndAddress.Zip';
        var currVal_553 = false;
        var currVal_554 = core_es5["ɵnov"](_v, 3);
        var currVal_555 = 'Zip';
        var currVal_556 = true;
        _ck(_v, 516, 0, currVal_550, currVal_551, currVal_552, currVal_553, currVal_554, currVal_555, currVal_556);
        var currVal_557 = 'UltimateConsigneeNameAndAddress.Zip';
        var currVal_558 = false;
        var currVal_559 = _co.document.UltimateConsigneeNameAndAddress.Zip.Value;
        _ck(_v, 518, 0, currVal_557, currVal_558, currVal_559);
        var currVal_560 = _co.document.UltimateConsigneeNameAndAddress.Zip;
        _ck(_v, 523, 0, currVal_560);
        var currVal_569 = '';
        _ck(_v, 533, 0, currVal_569);
        var currVal_570 = !_co.document.ImporterOfRecordNameAndAddress.Name.IsValid;
        var currVal_571 = 'text';
        var currVal_572 = 'ImporterOfRecordNameAndAddress.Name';
        var currVal_573 = '26. Importer of Record Name and Address';
        var currVal_574 = false;
        var currVal_575 = core_es5["ɵnov"](_v, 3);
        var currVal_576 = 'Name';
        var currVal_577 = true;
        _ck(_v, 535, 0, currVal_570, currVal_571, currVal_572, currVal_573, currVal_574, currVal_575, currVal_576, currVal_577);
        var currVal_578 = 'ImporterOfRecordNameAndAddress.Name';
        var currVal_579 = false;
        var currVal_580 = _co.document.ImporterOfRecordNameAndAddress.Name.Value;
        _ck(_v, 537, 0, currVal_578, currVal_579, currVal_580);
        var currVal_581 = _co.document.ImporterOfRecordNameAndAddress.Name;
        _ck(_v, 542, 0, currVal_581);
        var currVal_582 = ((core_es5["ɵnov"](_v, 535).model.hasError('required') && (!core_es5["ɵnov"](_v, 535).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.ImporterOfRecordNameAndAddress.Name.IsValid);
        _ck(_v, 545, 0, currVal_582);
        var currVal_591 = '';
        _ck(_v, 552, 0, currVal_591);
        var currVal_592 = !_co.document.ImporterOfRecordNameAndAddress.City.IsValid;
        var currVal_593 = 'text';
        var currVal_594 = 'ImporterOfRecordNameAndAddress.City';
        var currVal_595 = false;
        var currVal_596 = core_es5["ɵnov"](_v, 3);
        var currVal_597 = 'City';
        var currVal_598 = true;
        _ck(_v, 554, 0, currVal_592, currVal_593, currVal_594, currVal_595, currVal_596, currVal_597, currVal_598);
        var currVal_599 = 'ImporterOfRecordNameAndAddress.City';
        var currVal_600 = false;
        var currVal_601 = _co.document.ImporterOfRecordNameAndAddress.City.Value;
        _ck(_v, 556, 0, currVal_599, currVal_600, currVal_601);
        var currVal_602 = _co.document.ImporterOfRecordNameAndAddress.City;
        _ck(_v, 561, 0, currVal_602);
        var currVal_603 = ((core_es5["ɵnov"](_v, 554).model.hasError('required') && (!core_es5["ɵnov"](_v, 554).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.ImporterOfRecordNameAndAddress.City.IsValid);
        _ck(_v, 564, 0, currVal_603);
        var currVal_612 = '';
        _ck(_v, 571, 0, currVal_612);
        var currVal_613 = !_co.document.ImporterOfRecordNameAndAddress.State.IsValid;
        var currVal_614 = 'text';
        var currVal_615 = 'ImporterOfRecordNameAndAddress.State';
        var currVal_616 = false;
        var currVal_617 = core_es5["ɵnov"](_v, 3);
        var currVal_618 = 'State';
        var currVal_619 = true;
        _ck(_v, 573, 0, currVal_613, currVal_614, currVal_615, currVal_616, currVal_617, currVal_618, currVal_619);
        var currVal_620 = 'ImporterOfRecordNameAndAddress.State';
        var currVal_621 = false;
        var currVal_622 = _co.document.ImporterOfRecordNameAndAddress.State.Value;
        _ck(_v, 575, 0, currVal_620, currVal_621, currVal_622);
        var currVal_623 = _co.document.ImporterOfRecordNameAndAddress.State;
        _ck(_v, 580, 0, currVal_623);
        var currVal_624 = ((core_es5["ɵnov"](_v, 573).model.hasError('required') && (!core_es5["ɵnov"](_v, 573).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.ImporterOfRecordNameAndAddress.State.IsValid);
        _ck(_v, 583, 0, currVal_624);
        var currVal_633 = '';
        _ck(_v, 590, 0, currVal_633);
        var currVal_634 = !_co.document.ImporterOfRecordNameAndAddress.Zip.IsValid;
        var currVal_635 = 'text';
        var currVal_636 = 'ImporterOfRecordNameAndAddress.Zip';
        var currVal_637 = false;
        var currVal_638 = core_es5["ɵnov"](_v, 3);
        var currVal_639 = 'Zip';
        var currVal_640 = true;
        _ck(_v, 592, 0, currVal_634, currVal_635, currVal_636, currVal_637, currVal_638, currVal_639, currVal_640);
        var currVal_641 = 'ImporterOfRecordNameAndAddress.Zip';
        var currVal_642 = false;
        var currVal_643 = _co.document.ImporterOfRecordNameAndAddress.Zip.Value;
        _ck(_v, 594, 0, currVal_641, currVal_642, currVal_643);
        var currVal_644 = _co.document.ImporterOfRecordNameAndAddress.Zip;
        _ck(_v, 599, 0, currVal_644);
        var currVal_645 = ((core_es5["ɵnov"](_v, 592).model.hasError('required') && (!core_es5["ɵnov"](_v, 592).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.ImporterOfRecordNameAndAddress.Zip.IsValid);
        _ck(_v, 602, 0, currVal_645);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 5).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 5).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 5).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 5).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 5).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 5).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 5).ngClassPending;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (core_es5["ɵnov"](_v, 12).required ? '' : null);
        var currVal_8 = core_es5["ɵnov"](_v, 18).ngClassUntouched;
        var currVal_9 = core_es5["ɵnov"](_v, 18).ngClassTouched;
        var currVal_10 = core_es5["ɵnov"](_v, 18).ngClassPristine;
        var currVal_11 = core_es5["ɵnov"](_v, 18).ngClassDirty;
        var currVal_12 = core_es5["ɵnov"](_v, 18).ngClassValid;
        var currVal_13 = core_es5["ɵnov"](_v, 18).ngClassInvalid;
        var currVal_14 = core_es5["ɵnov"](_v, 18).ngClassPending;
        _ck(_v, 11, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_27 = (core_es5["ɵnov"](_v, 31).required ? '' : null);
        var currVal_28 = core_es5["ɵnov"](_v, 37).ngClassUntouched;
        var currVal_29 = core_es5["ɵnov"](_v, 37).ngClassTouched;
        var currVal_30 = core_es5["ɵnov"](_v, 37).ngClassPristine;
        var currVal_31 = core_es5["ɵnov"](_v, 37).ngClassDirty;
        var currVal_32 = core_es5["ɵnov"](_v, 37).ngClassValid;
        var currVal_33 = core_es5["ɵnov"](_v, 37).ngClassInvalid;
        var currVal_34 = core_es5["ɵnov"](_v, 37).ngClassPending;
        _ck(_v, 30, 0, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34);
        var currVal_47 = core_es5["ɵnov"](_v, 54).ngClassUntouched;
        var currVal_48 = core_es5["ɵnov"](_v, 54).ngClassTouched;
        var currVal_49 = core_es5["ɵnov"](_v, 54).ngClassPristine;
        var currVal_50 = core_es5["ɵnov"](_v, 54).ngClassDirty;
        var currVal_51 = core_es5["ɵnov"](_v, 54).ngClassValid;
        var currVal_52 = core_es5["ɵnov"](_v, 54).ngClassInvalid;
        var currVal_53 = core_es5["ɵnov"](_v, 54).ngClassPending;
        _ck(_v, 49, 0, currVal_47, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53);
        var currVal_66 = (core_es5["ɵnov"](_v, 67).required ? '' : null);
        var currVal_67 = (core_es5["ɵnov"](_v, 68).pattern ? core_es5["ɵnov"](_v, 68).pattern : null);
        var currVal_68 = core_es5["ɵnov"](_v, 74).ngClassUntouched;
        var currVal_69 = core_es5["ɵnov"](_v, 74).ngClassTouched;
        var currVal_70 = core_es5["ɵnov"](_v, 74).ngClassPristine;
        var currVal_71 = core_es5["ɵnov"](_v, 74).ngClassDirty;
        var currVal_72 = core_es5["ɵnov"](_v, 74).ngClassValid;
        var currVal_73 = core_es5["ɵnov"](_v, 74).ngClassInvalid;
        var currVal_74 = core_es5["ɵnov"](_v, 74).ngClassPending;
        _ck(_v, 66, 0, currVal_66, currVal_67, currVal_68, currVal_69, currVal_70, currVal_71, currVal_72, currVal_73, currVal_74);
        var currVal_89 = (core_es5["ɵnov"](_v, 90).required ? '' : null);
        var currVal_90 = (core_es5["ɵnov"](_v, 91).pattern ? core_es5["ɵnov"](_v, 91).pattern : null);
        var currVal_91 = core_es5["ɵnov"](_v, 97).ngClassUntouched;
        var currVal_92 = core_es5["ɵnov"](_v, 97).ngClassTouched;
        var currVal_93 = core_es5["ɵnov"](_v, 97).ngClassPristine;
        var currVal_94 = core_es5["ɵnov"](_v, 97).ngClassDirty;
        var currVal_95 = core_es5["ɵnov"](_v, 97).ngClassValid;
        var currVal_96 = core_es5["ɵnov"](_v, 97).ngClassInvalid;
        var currVal_97 = core_es5["ɵnov"](_v, 97).ngClassPending;
        _ck(_v, 89, 0, currVal_89, currVal_90, currVal_91, currVal_92, currVal_93, currVal_94, currVal_95, currVal_96, currVal_97);
        var currVal_112 = (core_es5["ɵnov"](_v, 113).required ? '' : null);
        var currVal_113 = (core_es5["ɵnov"](_v, 114).pattern ? core_es5["ɵnov"](_v, 114).pattern : null);
        var currVal_114 = core_es5["ɵnov"](_v, 120).ngClassUntouched;
        var currVal_115 = core_es5["ɵnov"](_v, 120).ngClassTouched;
        var currVal_116 = core_es5["ɵnov"](_v, 120).ngClassPristine;
        var currVal_117 = core_es5["ɵnov"](_v, 120).ngClassDirty;
        var currVal_118 = core_es5["ɵnov"](_v, 120).ngClassValid;
        var currVal_119 = core_es5["ɵnov"](_v, 120).ngClassInvalid;
        var currVal_120 = core_es5["ɵnov"](_v, 120).ngClassPending;
        _ck(_v, 112, 0, currVal_112, currVal_113, currVal_114, currVal_115, currVal_116, currVal_117, currVal_118, currVal_119, currVal_120);
        var currVal_135 = core_es5["ɵnov"](_v, 143).ngClassUntouched;
        var currVal_136 = core_es5["ɵnov"](_v, 143).ngClassTouched;
        var currVal_137 = core_es5["ɵnov"](_v, 143).ngClassPristine;
        var currVal_138 = core_es5["ɵnov"](_v, 143).ngClassDirty;
        var currVal_139 = core_es5["ɵnov"](_v, 143).ngClassValid;
        var currVal_140 = core_es5["ɵnov"](_v, 143).ngClassInvalid;
        var currVal_141 = core_es5["ɵnov"](_v, 143).ngClassPending;
        _ck(_v, 138, 0, currVal_135, currVal_136, currVal_137, currVal_138, currVal_139, currVal_140, currVal_141);
        var currVal_154 = core_es5["ɵnov"](_v, 157).ngClassUntouched;
        var currVal_155 = core_es5["ɵnov"](_v, 157).ngClassTouched;
        var currVal_156 = core_es5["ɵnov"](_v, 157).ngClassPristine;
        var currVal_157 = core_es5["ɵnov"](_v, 157).ngClassDirty;
        var currVal_158 = core_es5["ɵnov"](_v, 157).ngClassValid;
        var currVal_159 = core_es5["ɵnov"](_v, 157).ngClassInvalid;
        var currVal_160 = core_es5["ɵnov"](_v, 157).ngClassPending;
        _ck(_v, 152, 0, currVal_154, currVal_155, currVal_156, currVal_157, currVal_158, currVal_159, currVal_160);
        var currVal_171 = (core_es5["ɵnov"](_v, 167).pattern ? core_es5["ɵnov"](_v, 167).pattern : null);
        var currVal_172 = core_es5["ɵnov"](_v, 173).ngClassUntouched;
        var currVal_173 = core_es5["ɵnov"](_v, 173).ngClassTouched;
        var currVal_174 = core_es5["ɵnov"](_v, 173).ngClassPristine;
        var currVal_175 = core_es5["ɵnov"](_v, 173).ngClassDirty;
        var currVal_176 = core_es5["ɵnov"](_v, 173).ngClassValid;
        var currVal_177 = core_es5["ɵnov"](_v, 173).ngClassInvalid;
        var currVal_178 = core_es5["ɵnov"](_v, 173).ngClassPending;
        _ck(_v, 166, 0, currVal_171, currVal_172, currVal_173, currVal_174, currVal_175, currVal_176, currVal_177, currVal_178);
        var currVal_191 = (core_es5["ɵnov"](_v, 189).required ? '' : null);
        var currVal_192 = core_es5["ɵnov"](_v, 195).ngClassUntouched;
        var currVal_193 = core_es5["ɵnov"](_v, 195).ngClassTouched;
        var currVal_194 = core_es5["ɵnov"](_v, 195).ngClassPristine;
        var currVal_195 = core_es5["ɵnov"](_v, 195).ngClassDirty;
        var currVal_196 = core_es5["ɵnov"](_v, 195).ngClassValid;
        var currVal_197 = core_es5["ɵnov"](_v, 195).ngClassInvalid;
        var currVal_198 = core_es5["ɵnov"](_v, 195).ngClassPending;
        _ck(_v, 188, 0, currVal_191, currVal_192, currVal_193, currVal_194, currVal_195, currVal_196, currVal_197, currVal_198);
        var currVal_211 = core_es5["ɵnov"](_v, 212).ngClassUntouched;
        var currVal_212 = core_es5["ɵnov"](_v, 212).ngClassTouched;
        var currVal_213 = core_es5["ɵnov"](_v, 212).ngClassPristine;
        var currVal_214 = core_es5["ɵnov"](_v, 212).ngClassDirty;
        var currVal_215 = core_es5["ɵnov"](_v, 212).ngClassValid;
        var currVal_216 = core_es5["ɵnov"](_v, 212).ngClassInvalid;
        var currVal_217 = core_es5["ɵnov"](_v, 212).ngClassPending;
        _ck(_v, 207, 0, currVal_211, currVal_212, currVal_213, currVal_214, currVal_215, currVal_216, currVal_217);
        var currVal_230 = (core_es5["ɵnov"](_v, 222).required ? '' : null);
        var currVal_231 = core_es5["ɵnov"](_v, 228).ngClassUntouched;
        var currVal_232 = core_es5["ɵnov"](_v, 228).ngClassTouched;
        var currVal_233 = core_es5["ɵnov"](_v, 228).ngClassPristine;
        var currVal_234 = core_es5["ɵnov"](_v, 228).ngClassDirty;
        var currVal_235 = core_es5["ɵnov"](_v, 228).ngClassValid;
        var currVal_236 = core_es5["ɵnov"](_v, 228).ngClassInvalid;
        var currVal_237 = core_es5["ɵnov"](_v, 228).ngClassPending;
        _ck(_v, 221, 0, currVal_230, currVal_231, currVal_232, currVal_233, currVal_234, currVal_235, currVal_236, currVal_237);
        var currVal_250 = (core_es5["ɵnov"](_v, 244).required ? '' : null);
        var currVal_251 = core_es5["ɵnov"](_v, 250).ngClassUntouched;
        var currVal_252 = core_es5["ɵnov"](_v, 250).ngClassTouched;
        var currVal_253 = core_es5["ɵnov"](_v, 250).ngClassPristine;
        var currVal_254 = core_es5["ɵnov"](_v, 250).ngClassDirty;
        var currVal_255 = core_es5["ɵnov"](_v, 250).ngClassValid;
        var currVal_256 = core_es5["ɵnov"](_v, 250).ngClassInvalid;
        var currVal_257 = core_es5["ɵnov"](_v, 250).ngClassPending;
        _ck(_v, 243, 0, currVal_250, currVal_251, currVal_252, currVal_253, currVal_254, currVal_255, currVal_256, currVal_257);
        var currVal_270 = (core_es5["ɵnov"](_v, 263).required ? '' : null);
        var currVal_271 = core_es5["ɵnov"](_v, 269).ngClassUntouched;
        var currVal_272 = core_es5["ɵnov"](_v, 269).ngClassTouched;
        var currVal_273 = core_es5["ɵnov"](_v, 269).ngClassPristine;
        var currVal_274 = core_es5["ɵnov"](_v, 269).ngClassDirty;
        var currVal_275 = core_es5["ɵnov"](_v, 269).ngClassValid;
        var currVal_276 = core_es5["ɵnov"](_v, 269).ngClassInvalid;
        var currVal_277 = core_es5["ɵnov"](_v, 269).ngClassPending;
        _ck(_v, 262, 0, currVal_270, currVal_271, currVal_272, currVal_273, currVal_274, currVal_275, currVal_276, currVal_277);
        var currVal_290 = core_es5["ɵnov"](_v, 286).ngClassUntouched;
        var currVal_291 = core_es5["ɵnov"](_v, 286).ngClassTouched;
        var currVal_292 = core_es5["ɵnov"](_v, 286).ngClassPristine;
        var currVal_293 = core_es5["ɵnov"](_v, 286).ngClassDirty;
        var currVal_294 = core_es5["ɵnov"](_v, 286).ngClassValid;
        var currVal_295 = core_es5["ɵnov"](_v, 286).ngClassInvalid;
        var currVal_296 = core_es5["ɵnov"](_v, 286).ngClassPending;
        _ck(_v, 281, 0, currVal_290, currVal_291, currVal_292, currVal_293, currVal_294, currVal_295, currVal_296);
        var currVal_309 = core_es5["ɵnov"](_v, 303).ngClassUntouched;
        var currVal_310 = core_es5["ɵnov"](_v, 303).ngClassTouched;
        var currVal_311 = core_es5["ɵnov"](_v, 303).ngClassPristine;
        var currVal_312 = core_es5["ɵnov"](_v, 303).ngClassDirty;
        var currVal_313 = core_es5["ɵnov"](_v, 303).ngClassValid;
        var currVal_314 = core_es5["ɵnov"](_v, 303).ngClassInvalid;
        var currVal_315 = core_es5["ɵnov"](_v, 303).ngClassPending;
        _ck(_v, 298, 0, currVal_309, currVal_310, currVal_311, currVal_312, currVal_313, currVal_314, currVal_315);
        var currVal_326 = (core_es5["ɵnov"](_v, 313).required ? '' : null);
        var currVal_327 = core_es5["ɵnov"](_v, 319).ngClassUntouched;
        var currVal_328 = core_es5["ɵnov"](_v, 319).ngClassTouched;
        var currVal_329 = core_es5["ɵnov"](_v, 319).ngClassPristine;
        var currVal_330 = core_es5["ɵnov"](_v, 319).ngClassDirty;
        var currVal_331 = core_es5["ɵnov"](_v, 319).ngClassValid;
        var currVal_332 = core_es5["ɵnov"](_v, 319).ngClassInvalid;
        var currVal_333 = core_es5["ɵnov"](_v, 319).ngClassPending;
        _ck(_v, 312, 0, currVal_326, currVal_327, currVal_328, currVal_329, currVal_330, currVal_331, currVal_332, currVal_333);
        var currVal_348 = (core_es5["ɵnov"](_v, 332).required ? '' : null);
        var currVal_349 = core_es5["ɵnov"](_v, 338).ngClassUntouched;
        var currVal_350 = core_es5["ɵnov"](_v, 338).ngClassTouched;
        var currVal_351 = core_es5["ɵnov"](_v, 338).ngClassPristine;
        var currVal_352 = core_es5["ɵnov"](_v, 338).ngClassDirty;
        var currVal_353 = core_es5["ɵnov"](_v, 338).ngClassValid;
        var currVal_354 = core_es5["ɵnov"](_v, 338).ngClassInvalid;
        var currVal_355 = core_es5["ɵnov"](_v, 338).ngClassPending;
        _ck(_v, 331, 0, currVal_348, currVal_349, currVal_350, currVal_351, currVal_352, currVal_353, currVal_354, currVal_355);
        var currVal_368 = (core_es5["ɵnov"](_v, 354).pattern ? core_es5["ɵnov"](_v, 354).pattern : null);
        var currVal_369 = core_es5["ɵnov"](_v, 360).ngClassUntouched;
        var currVal_370 = core_es5["ɵnov"](_v, 360).ngClassTouched;
        var currVal_371 = core_es5["ɵnov"](_v, 360).ngClassPristine;
        var currVal_372 = core_es5["ɵnov"](_v, 360).ngClassDirty;
        var currVal_373 = core_es5["ɵnov"](_v, 360).ngClassValid;
        var currVal_374 = core_es5["ɵnov"](_v, 360).ngClassInvalid;
        var currVal_375 = core_es5["ɵnov"](_v, 360).ngClassPending;
        _ck(_v, 353, 0, currVal_368, currVal_369, currVal_370, currVal_371, currVal_372, currVal_373, currVal_374, currVal_375);
        var currVal_388 = (core_es5["ɵnov"](_v, 373).pattern ? core_es5["ɵnov"](_v, 373).pattern : null);
        var currVal_389 = core_es5["ɵnov"](_v, 379).ngClassUntouched;
        var currVal_390 = core_es5["ɵnov"](_v, 379).ngClassTouched;
        var currVal_391 = core_es5["ɵnov"](_v, 379).ngClassPristine;
        var currVal_392 = core_es5["ɵnov"](_v, 379).ngClassDirty;
        var currVal_393 = core_es5["ɵnov"](_v, 379).ngClassValid;
        var currVal_394 = core_es5["ɵnov"](_v, 379).ngClassInvalid;
        var currVal_395 = core_es5["ɵnov"](_v, 379).ngClassPending;
        _ck(_v, 372, 0, currVal_388, currVal_389, currVal_390, currVal_391, currVal_392, currVal_393, currVal_394, currVal_395);
        var currVal_408 = (core_es5["ɵnov"](_v, 392).required ? '' : null);
        var currVal_409 = core_es5["ɵnov"](_v, 398).ngClassUntouched;
        var currVal_410 = core_es5["ɵnov"](_v, 398).ngClassTouched;
        var currVal_411 = core_es5["ɵnov"](_v, 398).ngClassPristine;
        var currVal_412 = core_es5["ɵnov"](_v, 398).ngClassDirty;
        var currVal_413 = core_es5["ɵnov"](_v, 398).ngClassValid;
        var currVal_414 = core_es5["ɵnov"](_v, 398).ngClassInvalid;
        var currVal_415 = core_es5["ɵnov"](_v, 398).ngClassPending;
        _ck(_v, 391, 0, currVal_408, currVal_409, currVal_410, currVal_411, currVal_412, currVal_413, currVal_414, currVal_415);
        var currVal_428 = (core_es5["ɵnov"](_v, 414).required ? '' : null);
        var currVal_429 = core_es5["ɵnov"](_v, 420).ngClassUntouched;
        var currVal_430 = core_es5["ɵnov"](_v, 420).ngClassTouched;
        var currVal_431 = core_es5["ɵnov"](_v, 420).ngClassPristine;
        var currVal_432 = core_es5["ɵnov"](_v, 420).ngClassDirty;
        var currVal_433 = core_es5["ɵnov"](_v, 420).ngClassValid;
        var currVal_434 = core_es5["ɵnov"](_v, 420).ngClassInvalid;
        var currVal_435 = core_es5["ɵnov"](_v, 420).ngClassPending;
        _ck(_v, 413, 0, currVal_428, currVal_429, currVal_430, currVal_431, currVal_432, currVal_433, currVal_434, currVal_435);
        var currVal_448 = (core_es5["ɵnov"](_v, 433).required ? '' : null);
        var currVal_449 = core_es5["ɵnov"](_v, 439).ngClassUntouched;
        var currVal_450 = core_es5["ɵnov"](_v, 439).ngClassTouched;
        var currVal_451 = core_es5["ɵnov"](_v, 439).ngClassPristine;
        var currVal_452 = core_es5["ɵnov"](_v, 439).ngClassDirty;
        var currVal_453 = core_es5["ɵnov"](_v, 439).ngClassValid;
        var currVal_454 = core_es5["ɵnov"](_v, 439).ngClassInvalid;
        var currVal_455 = core_es5["ɵnov"](_v, 439).ngClassPending;
        _ck(_v, 432, 0, currVal_448, currVal_449, currVal_450, currVal_451, currVal_452, currVal_453, currVal_454, currVal_455);
        var currVal_468 = (core_es5["ɵnov"](_v, 452).required ? '' : null);
        var currVal_469 = core_es5["ɵnov"](_v, 458).ngClassUntouched;
        var currVal_470 = core_es5["ɵnov"](_v, 458).ngClassTouched;
        var currVal_471 = core_es5["ɵnov"](_v, 458).ngClassPristine;
        var currVal_472 = core_es5["ɵnov"](_v, 458).ngClassDirty;
        var currVal_473 = core_es5["ɵnov"](_v, 458).ngClassValid;
        var currVal_474 = core_es5["ɵnov"](_v, 458).ngClassInvalid;
        var currVal_475 = core_es5["ɵnov"](_v, 458).ngClassPending;
        _ck(_v, 451, 0, currVal_468, currVal_469, currVal_470, currVal_471, currVal_472, currVal_473, currVal_474, currVal_475);
        var currVal_488 = core_es5["ɵnov"](_v, 478).ngClassUntouched;
        var currVal_489 = core_es5["ɵnov"](_v, 478).ngClassTouched;
        var currVal_490 = core_es5["ɵnov"](_v, 478).ngClassPristine;
        var currVal_491 = core_es5["ɵnov"](_v, 478).ngClassDirty;
        var currVal_492 = core_es5["ɵnov"](_v, 478).ngClassValid;
        var currVal_493 = core_es5["ɵnov"](_v, 478).ngClassInvalid;
        var currVal_494 = core_es5["ɵnov"](_v, 478).ngClassPending;
        _ck(_v, 473, 0, currVal_488, currVal_489, currVal_490, currVal_491, currVal_492, currVal_493, currVal_494);
        var currVal_507 = core_es5["ɵnov"](_v, 492).ngClassUntouched;
        var currVal_508 = core_es5["ɵnov"](_v, 492).ngClassTouched;
        var currVal_509 = core_es5["ɵnov"](_v, 492).ngClassPristine;
        var currVal_510 = core_es5["ɵnov"](_v, 492).ngClassDirty;
        var currVal_511 = core_es5["ɵnov"](_v, 492).ngClassValid;
        var currVal_512 = core_es5["ɵnov"](_v, 492).ngClassInvalid;
        var currVal_513 = core_es5["ɵnov"](_v, 492).ngClassPending;
        _ck(_v, 487, 0, currVal_507, currVal_508, currVal_509, currVal_510, currVal_511, currVal_512, currVal_513);
        var currVal_525 = core_es5["ɵnov"](_v, 506).ngClassUntouched;
        var currVal_526 = core_es5["ɵnov"](_v, 506).ngClassTouched;
        var currVal_527 = core_es5["ɵnov"](_v, 506).ngClassPristine;
        var currVal_528 = core_es5["ɵnov"](_v, 506).ngClassDirty;
        var currVal_529 = core_es5["ɵnov"](_v, 506).ngClassValid;
        var currVal_530 = core_es5["ɵnov"](_v, 506).ngClassInvalid;
        var currVal_531 = core_es5["ɵnov"](_v, 506).ngClassPending;
        _ck(_v, 501, 0, currVal_525, currVal_526, currVal_527, currVal_528, currVal_529, currVal_530, currVal_531);
        var currVal_543 = core_es5["ɵnov"](_v, 520).ngClassUntouched;
        var currVal_544 = core_es5["ɵnov"](_v, 520).ngClassTouched;
        var currVal_545 = core_es5["ɵnov"](_v, 520).ngClassPristine;
        var currVal_546 = core_es5["ɵnov"](_v, 520).ngClassDirty;
        var currVal_547 = core_es5["ɵnov"](_v, 520).ngClassValid;
        var currVal_548 = core_es5["ɵnov"](_v, 520).ngClassInvalid;
        var currVal_549 = core_es5["ɵnov"](_v, 520).ngClassPending;
        _ck(_v, 515, 0, currVal_543, currVal_544, currVal_545, currVal_546, currVal_547, currVal_548, currVal_549);
        var currVal_561 = (core_es5["ɵnov"](_v, 533).required ? '' : null);
        var currVal_562 = core_es5["ɵnov"](_v, 539).ngClassUntouched;
        var currVal_563 = core_es5["ɵnov"](_v, 539).ngClassTouched;
        var currVal_564 = core_es5["ɵnov"](_v, 539).ngClassPristine;
        var currVal_565 = core_es5["ɵnov"](_v, 539).ngClassDirty;
        var currVal_566 = core_es5["ɵnov"](_v, 539).ngClassValid;
        var currVal_567 = core_es5["ɵnov"](_v, 539).ngClassInvalid;
        var currVal_568 = core_es5["ɵnov"](_v, 539).ngClassPending;
        _ck(_v, 532, 0, currVal_561, currVal_562, currVal_563, currVal_564, currVal_565, currVal_566, currVal_567, currVal_568);
        var currVal_583 = (core_es5["ɵnov"](_v, 552).required ? '' : null);
        var currVal_584 = core_es5["ɵnov"](_v, 558).ngClassUntouched;
        var currVal_585 = core_es5["ɵnov"](_v, 558).ngClassTouched;
        var currVal_586 = core_es5["ɵnov"](_v, 558).ngClassPristine;
        var currVal_587 = core_es5["ɵnov"](_v, 558).ngClassDirty;
        var currVal_588 = core_es5["ɵnov"](_v, 558).ngClassValid;
        var currVal_589 = core_es5["ɵnov"](_v, 558).ngClassInvalid;
        var currVal_590 = core_es5["ɵnov"](_v, 558).ngClassPending;
        _ck(_v, 551, 0, currVal_583, currVal_584, currVal_585, currVal_586, currVal_587, currVal_588, currVal_589, currVal_590);
        var currVal_604 = (core_es5["ɵnov"](_v, 571).required ? '' : null);
        var currVal_605 = core_es5["ɵnov"](_v, 577).ngClassUntouched;
        var currVal_606 = core_es5["ɵnov"](_v, 577).ngClassTouched;
        var currVal_607 = core_es5["ɵnov"](_v, 577).ngClassPristine;
        var currVal_608 = core_es5["ɵnov"](_v, 577).ngClassDirty;
        var currVal_609 = core_es5["ɵnov"](_v, 577).ngClassValid;
        var currVal_610 = core_es5["ɵnov"](_v, 577).ngClassInvalid;
        var currVal_611 = core_es5["ɵnov"](_v, 577).ngClassPending;
        _ck(_v, 570, 0, currVal_604, currVal_605, currVal_606, currVal_607, currVal_608, currVal_609, currVal_610, currVal_611);
        var currVal_625 = (core_es5["ɵnov"](_v, 590).required ? '' : null);
        var currVal_626 = core_es5["ɵnov"](_v, 596).ngClassUntouched;
        var currVal_627 = core_es5["ɵnov"](_v, 596).ngClassTouched;
        var currVal_628 = core_es5["ɵnov"](_v, 596).ngClassPristine;
        var currVal_629 = core_es5["ɵnov"](_v, 596).ngClassDirty;
        var currVal_630 = core_es5["ɵnov"](_v, 596).ngClassValid;
        var currVal_631 = core_es5["ɵnov"](_v, 596).ngClassInvalid;
        var currVal_632 = core_es5["ɵnov"](_v, 596).ngClassPending;
        _ck(_v, 589, 0, currVal_625, currVal_626, currVal_627, currVal_628, currVal_629, currVal_630, currVal_631, currVal_632);
    });
}
function View_FirstBlock7501Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'first-block-7501', [], null, null, null, View_FirstBlock7501Component_0, RenderType_FirstBlock7501Component)), core_es5["ɵdid"](49152, null, 0, first_block_7501_component_FirstBlock7501Component, [], null, null)], null, null);
}
var FirstBlock7501ComponentNgFactory = core_es5["ɵccf"]('first-block-7501', first_block_7501_component_FirstBlock7501Component, View_FirstBlock7501Component_Host_0, { document: 'document' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=first-block-7501.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/export-documents/cbp-7501/document-blocks/table-block-7501.component.ts

var table_block_7501_component_TableBlock7501Component = /** @class */ (function () {
    function TableBlock7501Component() {
        this.numberPatternHelper = ValidationPatterns;
    }
    TableBlock7501Component.prototype.submitFormAndValidity = function () {
        this.tableBlockForm.onSubmit(null);
        return this.isFormValid();
    };
    TableBlock7501Component.prototype.isFormValid = function () {
        return this.tableBlockForm.valid;
    };
    return TableBlock7501Component;
}());

//# sourceMappingURL=table-block-7501.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/export-documents/cbp-7501/document-blocks/table-block-7501.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_TableBlock7501Component = [];
var RenderType_TableBlock7501Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_TableBlock7501Component, data: {} });
function View_TableBlock7501Component_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Line Number is required ']))], null, null);
}
function View_TableBlock7501Component_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Line Number should contain only digits']))], null, null);
}
function View_TableBlock7501Component_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' HTSUS No is required ']))], null, null);
}
function View_TableBlock7501Component_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ADACVD No is required ']))], null, null);
}
function View_TableBlock7501Component_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Grossweight is required ']))], null, null);
}
function View_TableBlock7501Component_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Grossweight should contain only digits']))], null, null);
}
function View_TableBlock7501Component_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Manifest Qty. is required ']))], null, null);
}
function View_TableBlock7501Component_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Manifest Qty. should contain only digits']))], null, null);
}
function View_TableBlock7501Component_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Net Quantity is required ']))], null, null);
}
function View_TableBlock7501Component_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Entered Value is required ']))], null, null);
}
function View_TableBlock7501Component_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' CHGS is required ']))], null, null);
}
function View_TableBlock7501Component_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Relationship is required ']))], null, null);
}
function View_TableBlock7501Component_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' HTSUS Rate is required ']))], null, null);
}
function View_TableBlock7501Component_15(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ADA/CVD Rate is required ']))], null, null);
}
function View_TableBlock7501Component_16(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' IRC Rate is required ']))], null, null);
}
function View_TableBlock7501Component_17(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Visa No. is required ']))], null, null);
}
function View_TableBlock7501Component_18(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Dollars is required ']))], null, null);
}
function View_TableBlock7501Component_19(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Dollars should contain only digits']))], null, null);
}
function View_TableBlock7501Component_20(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Cents is required ']))], null, null);
}
function View_TableBlock7501Component_21(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Cents should contain only digits']))], null, null);
}
function View_TableBlock7501Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 286, 'tr', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'td', [['class', 'padding-left-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 18, 'form-input', [['class', 'input-margin-bottom'],
                ['placeholder', '1.'], ['required', '']], [[1, 'required', 0], [1, 'pattern', 0],
                [2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                    null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
                [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                    'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_v.context.$implicit.LineNumber.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['LineNumber',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'],
            form: [4, 'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 33, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['class', 'input-margin-bottom'],
            ['placeholder', 'HTSUS No.'], ['required', '']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.context.$implicit.HTSUSNo.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['HTSUSNo', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'],
            placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['class',
                'input-margin-bottom'], ['placeholder', 'ADA/CVD No.'], ['required', '']], [[1,
                'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.context.$implicit.ADACVDNo.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['ADACVDNo', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'],
            placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 41, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 18, 'form-input', [['class', 'input-margin-bottom'],
                ['placeholder', 'Grossweight'], ['required', '']], [[1, 'required', 0], [1,
                    'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                    null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_v.context.$implicit.Grossweight.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['Grossweight',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'],
            form: [4, 'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_7)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['class', 'input-margin-bottom'],
            ['placeholder', 'Manifest Qty.'], ['required', '']], [[1, 'required', 0], [1, 'pattern',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.context.$implicit.ManifestQty.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['ManifestQty',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'],
            form: [4, 'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_8)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_9)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['class', 'input-margin-bottom'],
            ['placeholder', 'Net Quantity'], ['required', '']], [[1, 'required', 0], [2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.context.$implicit.NetQuantityInHTSUSUnits.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['NetQuantityInHTSUSUnits', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'],
            form: [4, 'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_10)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 50, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 15, 'form-input', [['class', 'input-margin-bottom'],
                ['placeholder', ' Entered Value'], ['required', '']], [[1, 'required', 0],
                [1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                    null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_v.context.$implicit.EnteredValue.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['EnteredValue',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'],
            form: [4, 'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_11)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['class',
                'input-margin-bottom'], ['placeholder', 'CHGS'], ['required', '']], [[1, 'required',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.context.$implicit.CHGS.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['CHGS', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'],
            placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_12)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['class',
                'input-margin-bottom'], ['placeholder', 'Relationship'], ['required', '']], [[1,
                'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.context.$implicit.Relationship.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['Relationship', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'],
            placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_13)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 65, 'td', [['class', 'padding-bottom-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['class',
                'input-margin-bottom'], ['placeholder', 'HTSUS Rate'], ['required', '']], [[1,
                'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.context.$implicit.HTSUSRate.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['HTSUSRate', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'],
            placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_14)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['class',
                'input-margin-bottom'], ['placeholder', 'ADA/CVD Rate'], ['required', '']], [[1,
                'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.context.$implicit.ADACVDRate.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['ADACVDRate', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'],
            placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_15)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['class',
                'input-margin-bottom'], ['placeholder', 'IRC Rate'], ['required', '']], [[1, 'required',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.context.$implicit.IRCRate.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['IRCRate', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'],
            placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_16)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['class',
                'input-margin-bottom'], ['placeholder', 'Visa No.'], ['required', '']], [[1, 'required',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.context.$implicit.VisaNo.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['VisaNo', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'], form: [4, 'form'],
            placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_17)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'td', [['style', 'width:70px']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['class',
                'input-margin-bottom'], ['placeholder', 'Dollars'], ['required', '']], [[1, 'required',
                0], [1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.context.$implicit.Dollars.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['Dollars',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'],
            form: [4, 'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_18)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_19)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'td', [['class', 'padding-right-30'], ['style', 'width:90px']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['class',
                'input-margin-bottom'], ['placeholder', 'Cents'], ['required', '']], [[1, 'required',
                0], [1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.context.$implicit.Cents.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['Cents',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], disabled: [3, 'disabled'],
            form: [4, 'form'], placeholder: [5, 'placeholder'], isPlaceholderNeed: [6, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_20)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_TableBlock7501Component_21)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_9 = '';
        _ck(_v, 5, 0, currVal_9);
        var currVal_10 = _co.numberPatternHelper.integer;
        _ck(_v, 6, 0, currVal_10);
        var currVal_11 = !_v.context.$implicit.LineNumber.IsValid;
        var currVal_12 = 'number';
        var currVal_13 = 'TableLineInputsLineNumber';
        var currVal_14 = false;
        var currVal_15 = core_es5["ɵnov"](_v.parent, 3);
        var currVal_16 = '1.';
        var currVal_17 = true;
        _ck(_v, 8, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17);
        var currVal_18 = 'TableLineInputsLineNumber';
        var currVal_19 = false;
        var currVal_20 = _v.context.$implicit.LineNumber.Value;
        _ck(_v, 10, 0, currVal_18, currVal_19, currVal_20);
        var currVal_21 = _v.context.$implicit.LineNumber;
        _ck(_v, 15, 0, currVal_21);
        var currVal_22 = ((core_es5["ɵnov"](_v, 8).model.hasError('required') && (!core_es5["ɵnov"](_v, 8).model.pristine || core_es5["ɵnov"](_v.parent, 3).submittedted)) && _v.context.$implicit.LineNumber.IsValid);
        _ck(_v, 18, 0, currVal_22);
        var currVal_23 = ((core_es5["ɵnov"](_v, 8).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 8).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.LineNumber.IsValid);
        _ck(_v, 21, 0, currVal_23);
        var currVal_32 = '';
        _ck(_v, 28, 0, currVal_32);
        var currVal_33 = !_v.context.$implicit.HTSUSNo.IsValid;
        var currVal_34 = 'text';
        var currVal_35 = 'HTSUSNo';
        var currVal_36 = false;
        var currVal_37 = core_es5["ɵnov"](_v.parent, 3);
        var currVal_38 = 'HTSUS No.';
        var currVal_39 = true;
        _ck(_v, 30, 0, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39);
        var currVal_40 = 'HTSUSNo';
        var currVal_41 = false;
        var currVal_42 = _v.context.$implicit.HTSUSNo.Value;
        _ck(_v, 32, 0, currVal_40, currVal_41, currVal_42);
        var currVal_43 = _v.context.$implicit.HTSUSNo;
        _ck(_v, 37, 0, currVal_43);
        var currVal_44 = ((core_es5["ɵnov"](_v, 30).model.hasError('required') && (!core_es5["ɵnov"](_v, 30).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.HTSUSNo.IsValid);
        _ck(_v, 40, 0, currVal_44);
        var currVal_53 = '';
        _ck(_v, 44, 0, currVal_53);
        var currVal_54 = !_v.context.$implicit.ADACVDNo.IsValid;
        var currVal_55 = 'text';
        var currVal_56 = 'ADACVDNo';
        var currVal_57 = false;
        var currVal_58 = core_es5["ɵnov"](_v.parent, 3);
        var currVal_59 = 'ADA/CVD No.';
        var currVal_60 = true;
        _ck(_v, 46, 0, currVal_54, currVal_55, currVal_56, currVal_57, currVal_58, currVal_59, currVal_60);
        var currVal_61 = 'ADACVDNo';
        var currVal_62 = false;
        var currVal_63 = _v.context.$implicit.ADACVDNo.Value;
        _ck(_v, 48, 0, currVal_61, currVal_62, currVal_63);
        var currVal_64 = _v.context.$implicit.ADACVDNo;
        _ck(_v, 53, 0, currVal_64);
        var currVal_65 = ((core_es5["ɵnov"](_v, 46).model.hasError('required') && (!core_es5["ɵnov"](_v, 46).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.ADACVDNo.IsValid);
        _ck(_v, 56, 0, currVal_65);
        var currVal_75 = '';
        _ck(_v, 63, 0, currVal_75);
        var currVal_76 = _co.numberPatternHelper.integer;
        _ck(_v, 64, 0, currVal_76);
        var currVal_77 = !_v.context.$implicit.Grossweight.IsValid;
        var currVal_78 = 'number';
        var currVal_79 = 'Grossweight';
        var currVal_80 = false;
        var currVal_81 = core_es5["ɵnov"](_v.parent, 3);
        var currVal_82 = 'Grossweight';
        var currVal_83 = true;
        _ck(_v, 66, 0, currVal_77, currVal_78, currVal_79, currVal_80, currVal_81, currVal_82, currVal_83);
        var currVal_84 = 'Grossweight';
        var currVal_85 = false;
        var currVal_86 = _v.context.$implicit.Grossweight.Value;
        _ck(_v, 68, 0, currVal_84, currVal_85, currVal_86);
        var currVal_87 = _v.context.$implicit.Grossweight;
        _ck(_v, 73, 0, currVal_87);
        var currVal_88 = ((core_es5["ɵnov"](_v, 66).model.hasError('required') && (!core_es5["ɵnov"](_v, 66).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.Grossweight.IsValid);
        _ck(_v, 76, 0, currVal_88);
        var currVal_89 = ((core_es5["ɵnov"](_v, 66).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 66).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.Grossweight.IsValid);
        _ck(_v, 79, 0, currVal_89);
        var currVal_99 = '';
        _ck(_v, 83, 0, currVal_99);
        var currVal_100 = _co.numberPatternHelper.integer;
        _ck(_v, 84, 0, currVal_100);
        var currVal_101 = !_v.context.$implicit.ManifestQty.IsValid;
        var currVal_102 = 'number';
        var currVal_103 = 'ManifestQty';
        var currVal_104 = false;
        var currVal_105 = core_es5["ɵnov"](_v.parent, 3);
        var currVal_106 = 'Manifest Qty.';
        var currVal_107 = true;
        _ck(_v, 86, 0, currVal_101, currVal_102, currVal_103, currVal_104, currVal_105, currVal_106, currVal_107);
        var currVal_108 = 'ManifestQty';
        var currVal_109 = false;
        var currVal_110 = _v.context.$implicit.ManifestQty.Value;
        _ck(_v, 88, 0, currVal_108, currVal_109, currVal_110);
        var currVal_111 = _v.context.$implicit.ManifestQty;
        _ck(_v, 93, 0, currVal_111);
        var currVal_112 = ((core_es5["ɵnov"](_v, 86).model.hasError('required') && (!core_es5["ɵnov"](_v, 86).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.ManifestQty.IsValid);
        _ck(_v, 96, 0, currVal_112);
        var currVal_113 = ((core_es5["ɵnov"](_v, 86).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 86).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.ManifestQty.IsValid);
        _ck(_v, 99, 0, currVal_113);
        var currVal_122 = '';
        _ck(_v, 106, 0, currVal_122);
        var currVal_123 = !_v.context.$implicit.NetQuantityInHTSUSUnits.IsValid;
        var currVal_124 = 'text';
        var currVal_125 = 'NetQuantityInHTSUSUnits';
        var currVal_126 = false;
        var currVal_127 = core_es5["ɵnov"](_v.parent, 3);
        var currVal_128 = 'Net Quantity';
        var currVal_129 = true;
        _ck(_v, 108, 0, currVal_123, currVal_124, currVal_125, currVal_126, currVal_127, currVal_128, currVal_129);
        var currVal_130 = 'NetQuantityInHTSUSUnits';
        var currVal_131 = false;
        var currVal_132 = _v.context.$implicit.NetQuantityInHTSUSUnits.Value;
        _ck(_v, 110, 0, currVal_130, currVal_131, currVal_132);
        var currVal_133 = _v.context.$implicit.NetQuantityInHTSUSUnits;
        _ck(_v, 115, 0, currVal_133);
        var currVal_134 = ((core_es5["ɵnov"](_v, 108).model.hasError('required') && (!core_es5["ɵnov"](_v, 108).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.NetQuantityInHTSUSUnits.IsValid);
        _ck(_v, 118, 0, currVal_134);
        var currVal_144 = '';
        _ck(_v, 125, 0, currVal_144);
        var currVal_145 = _co.numberPatternHelper.integer;
        _ck(_v, 126, 0, currVal_145);
        var currVal_146 = !_v.context.$implicit.EnteredValue.IsValid;
        var currVal_147 = 'number';
        var currVal_148 = 'EnteredValue';
        var currVal_149 = false;
        var currVal_150 = core_es5["ɵnov"](_v.parent, 3);
        var currVal_151 = ' Entered Value';
        var currVal_152 = true;
        _ck(_v, 128, 0, currVal_146, currVal_147, currVal_148, currVal_149, currVal_150, currVal_151, currVal_152);
        var currVal_153 = 'EnteredValue';
        var currVal_154 = false;
        var currVal_155 = _v.context.$implicit.EnteredValue.Value;
        _ck(_v, 130, 0, currVal_153, currVal_154, currVal_155);
        var currVal_156 = _v.context.$implicit.EnteredValue;
        _ck(_v, 135, 0, currVal_156);
        var currVal_157 = ((core_es5["ɵnov"](_v, 128).model.hasError('required') && (!core_es5["ɵnov"](_v, 128).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.EnteredValue.IsValid);
        _ck(_v, 138, 0, currVal_157);
        var currVal_166 = '';
        _ck(_v, 142, 0, currVal_166);
        var currVal_167 = !_v.context.$implicit.CHGS.IsValid;
        var currVal_168 = 'text';
        var currVal_169 = 'CHGS';
        var currVal_170 = false;
        var currVal_171 = core_es5["ɵnov"](_v.parent, 3);
        var currVal_172 = 'CHGS';
        var currVal_173 = true;
        _ck(_v, 144, 0, currVal_167, currVal_168, currVal_169, currVal_170, currVal_171, currVal_172, currVal_173);
        var currVal_174 = 'CHGS';
        var currVal_175 = false;
        var currVal_176 = _v.context.$implicit.CHGS.Value;
        _ck(_v, 146, 0, currVal_174, currVal_175, currVal_176);
        var currVal_177 = _v.context.$implicit.CHGS;
        _ck(_v, 151, 0, currVal_177);
        var currVal_178 = ((core_es5["ɵnov"](_v, 144).model.hasError('required') && (!core_es5["ɵnov"](_v, 144).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.CHGS.IsValid);
        _ck(_v, 154, 0, currVal_178);
        var currVal_187 = '';
        _ck(_v, 158, 0, currVal_187);
        var currVal_188 = !_v.context.$implicit.Relationship.IsValid;
        var currVal_189 = 'text';
        var currVal_190 = 'Relationship';
        var currVal_191 = false;
        var currVal_192 = core_es5["ɵnov"](_v.parent, 3);
        var currVal_193 = 'Relationship';
        var currVal_194 = true;
        _ck(_v, 160, 0, currVal_188, currVal_189, currVal_190, currVal_191, currVal_192, currVal_193, currVal_194);
        var currVal_195 = 'Relationship';
        var currVal_196 = false;
        var currVal_197 = _v.context.$implicit.Relationship.Value;
        _ck(_v, 162, 0, currVal_195, currVal_196, currVal_197);
        var currVal_198 = _v.context.$implicit.Relationship;
        _ck(_v, 167, 0, currVal_198);
        var currVal_199 = ((core_es5["ɵnov"](_v, 160).model.hasError('required') && (!core_es5["ɵnov"](_v, 160).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.Relationship.IsValid);
        _ck(_v, 170, 0, currVal_199);
        var currVal_208 = '';
        _ck(_v, 177, 0, currVal_208);
        var currVal_209 = !_v.context.$implicit.HTSUSRate.IsValid;
        var currVal_210 = 'text';
        var currVal_211 = 'HTSUSRate';
        var currVal_212 = false;
        var currVal_213 = core_es5["ɵnov"](_v.parent, 3);
        var currVal_214 = 'HTSUS Rate';
        var currVal_215 = true;
        _ck(_v, 179, 0, currVal_209, currVal_210, currVal_211, currVal_212, currVal_213, currVal_214, currVal_215);
        var currVal_216 = 'HTSUSRate';
        var currVal_217 = false;
        var currVal_218 = _v.context.$implicit.HTSUSRate.Value;
        _ck(_v, 181, 0, currVal_216, currVal_217, currVal_218);
        var currVal_219 = _v.context.$implicit.HTSUSRate;
        _ck(_v, 186, 0, currVal_219);
        var currVal_220 = ((core_es5["ɵnov"](_v, 179).model.hasError('required') && (!core_es5["ɵnov"](_v, 179).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.HTSUSRate.IsValid);
        _ck(_v, 189, 0, currVal_220);
        var currVal_229 = '';
        _ck(_v, 193, 0, currVal_229);
        var currVal_230 = !_v.context.$implicit.ADACVDRate.IsValid;
        var currVal_231 = 'text';
        var currVal_232 = 'ADACVDRate';
        var currVal_233 = false;
        var currVal_234 = core_es5["ɵnov"](_v.parent, 3);
        var currVal_235 = 'ADA/CVD Rate';
        var currVal_236 = true;
        _ck(_v, 195, 0, currVal_230, currVal_231, currVal_232, currVal_233, currVal_234, currVal_235, currVal_236);
        var currVal_237 = 'ADACVDRate';
        var currVal_238 = false;
        var currVal_239 = _v.context.$implicit.ADACVDRate.Value;
        _ck(_v, 197, 0, currVal_237, currVal_238, currVal_239);
        var currVal_240 = _v.context.$implicit.ADACVDRate;
        _ck(_v, 202, 0, currVal_240);
        var currVal_241 = ((core_es5["ɵnov"](_v, 195).model.hasError('required') && (!core_es5["ɵnov"](_v, 195).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.ADACVDRate.IsValid);
        _ck(_v, 205, 0, currVal_241);
        var currVal_250 = '';
        _ck(_v, 209, 0, currVal_250);
        var currVal_251 = !_v.context.$implicit.IRCRate.IsValid;
        var currVal_252 = 'text';
        var currVal_253 = 'IRCRate';
        var currVal_254 = false;
        var currVal_255 = core_es5["ɵnov"](_v.parent, 3);
        var currVal_256 = 'IRC Rate';
        var currVal_257 = true;
        _ck(_v, 211, 0, currVal_251, currVal_252, currVal_253, currVal_254, currVal_255, currVal_256, currVal_257);
        var currVal_258 = 'IRCRate';
        var currVal_259 = false;
        var currVal_260 = _v.context.$implicit.IRCRate.Value;
        _ck(_v, 213, 0, currVal_258, currVal_259, currVal_260);
        var currVal_261 = _v.context.$implicit.IRCRate;
        _ck(_v, 218, 0, currVal_261);
        var currVal_262 = ((core_es5["ɵnov"](_v, 211).model.hasError('required') && (!core_es5["ɵnov"](_v, 211).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.IRCRate.IsValid);
        _ck(_v, 221, 0, currVal_262);
        var currVal_271 = '';
        _ck(_v, 225, 0, currVal_271);
        var currVal_272 = !_v.context.$implicit.VisaNo.IsValid;
        var currVal_273 = 'text';
        var currVal_274 = 'VisaNo';
        var currVal_275 = false;
        var currVal_276 = core_es5["ɵnov"](_v.parent, 3);
        var currVal_277 = 'Visa No.';
        var currVal_278 = true;
        _ck(_v, 227, 0, currVal_272, currVal_273, currVal_274, currVal_275, currVal_276, currVal_277, currVal_278);
        var currVal_279 = 'VisaNo';
        var currVal_280 = false;
        var currVal_281 = _v.context.$implicit.VisaNo.Value;
        _ck(_v, 229, 0, currVal_279, currVal_280, currVal_281);
        var currVal_282 = _v.context.$implicit.VisaNo;
        _ck(_v, 234, 0, currVal_282);
        var currVal_283 = ((core_es5["ɵnov"](_v, 227).model.hasError('required') && (!core_es5["ɵnov"](_v, 227).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.VisaNo.IsValid);
        _ck(_v, 237, 0, currVal_283);
        var currVal_293 = '';
        _ck(_v, 244, 0, currVal_293);
        var currVal_294 = _co.numberPatternHelper.integer;
        _ck(_v, 245, 0, currVal_294);
        var currVal_295 = !_v.context.$implicit.Dollars.IsValid;
        var currVal_296 = 'number';
        var currVal_297 = 'Dollars';
        var currVal_298 = false;
        var currVal_299 = core_es5["ɵnov"](_v.parent, 3);
        var currVal_300 = 'Dollars';
        var currVal_301 = true;
        _ck(_v, 247, 0, currVal_295, currVal_296, currVal_297, currVal_298, currVal_299, currVal_300, currVal_301);
        var currVal_302 = 'Dollars';
        var currVal_303 = false;
        var currVal_304 = _v.context.$implicit.Dollars.Value;
        _ck(_v, 249, 0, currVal_302, currVal_303, currVal_304);
        var currVal_305 = _v.context.$implicit.Dollars;
        _ck(_v, 254, 0, currVal_305);
        var currVal_306 = ((core_es5["ɵnov"](_v, 247).model.hasError('required') && (!core_es5["ɵnov"](_v, 247).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.Dollars.IsValid);
        _ck(_v, 257, 0, currVal_306);
        var currVal_307 = ((core_es5["ɵnov"](_v, 247).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 247).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.Dollars.IsValid);
        _ck(_v, 260, 0, currVal_307);
        var currVal_317 = '';
        _ck(_v, 267, 0, currVal_317);
        var currVal_318 = _co.numberPatternHelper.integer;
        _ck(_v, 268, 0, currVal_318);
        var currVal_319 = !_v.context.$implicit.Cents.IsValid;
        var currVal_320 = 'number';
        var currVal_321 = 'Cents';
        var currVal_322 = false;
        var currVal_323 = core_es5["ɵnov"](_v.parent, 3);
        var currVal_324 = 'Cents';
        var currVal_325 = true;
        _ck(_v, 270, 0, currVal_319, currVal_320, currVal_321, currVal_322, currVal_323, currVal_324, currVal_325);
        var currVal_326 = 'Cents';
        var currVal_327 = false;
        var currVal_328 = _v.context.$implicit.Cents.Value;
        _ck(_v, 272, 0, currVal_326, currVal_327, currVal_328);
        var currVal_329 = _v.context.$implicit.Cents;
        _ck(_v, 277, 0, currVal_329);
        var currVal_330 = ((core_es5["ɵnov"](_v, 270).model.hasError('required') && (!core_es5["ɵnov"](_v, 270).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.Cents.IsValid);
        _ck(_v, 280, 0, currVal_330);
        var currVal_331 = ((core_es5["ɵnov"](_v, 270).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 270).model.pristine || core_es5["ɵnov"](_v.parent, 3).submitted)) && _v.context.$implicit.Cents.IsValid);
        _ck(_v, 283, 0, currVal_331);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 5).required ? '' : null);
        var currVal_1 = (core_es5["ɵnov"](_v, 6).pattern ? core_es5["ɵnov"](_v, 6).pattern : null);
        var currVal_2 = core_es5["ɵnov"](_v, 12).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 12).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 12).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 12).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 12).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 12).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 12).ngClassPending;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
        var currVal_24 = (core_es5["ɵnov"](_v, 28).required ? '' : null);
        var currVal_25 = core_es5["ɵnov"](_v, 34).ngClassUntouched;
        var currVal_26 = core_es5["ɵnov"](_v, 34).ngClassTouched;
        var currVal_27 = core_es5["ɵnov"](_v, 34).ngClassPristine;
        var currVal_28 = core_es5["ɵnov"](_v, 34).ngClassDirty;
        var currVal_29 = core_es5["ɵnov"](_v, 34).ngClassValid;
        var currVal_30 = core_es5["ɵnov"](_v, 34).ngClassInvalid;
        var currVal_31 = core_es5["ɵnov"](_v, 34).ngClassPending;
        _ck(_v, 27, 0, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31);
        var currVal_45 = (core_es5["ɵnov"](_v, 44).required ? '' : null);
        var currVal_46 = core_es5["ɵnov"](_v, 50).ngClassUntouched;
        var currVal_47 = core_es5["ɵnov"](_v, 50).ngClassTouched;
        var currVal_48 = core_es5["ɵnov"](_v, 50).ngClassPristine;
        var currVal_49 = core_es5["ɵnov"](_v, 50).ngClassDirty;
        var currVal_50 = core_es5["ɵnov"](_v, 50).ngClassValid;
        var currVal_51 = core_es5["ɵnov"](_v, 50).ngClassInvalid;
        var currVal_52 = core_es5["ɵnov"](_v, 50).ngClassPending;
        _ck(_v, 43, 0, currVal_45, currVal_46, currVal_47, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52);
        var currVal_66 = (core_es5["ɵnov"](_v, 63).required ? '' : null);
        var currVal_67 = (core_es5["ɵnov"](_v, 64).pattern ? core_es5["ɵnov"](_v, 64).pattern : null);
        var currVal_68 = core_es5["ɵnov"](_v, 70).ngClassUntouched;
        var currVal_69 = core_es5["ɵnov"](_v, 70).ngClassTouched;
        var currVal_70 = core_es5["ɵnov"](_v, 70).ngClassPristine;
        var currVal_71 = core_es5["ɵnov"](_v, 70).ngClassDirty;
        var currVal_72 = core_es5["ɵnov"](_v, 70).ngClassValid;
        var currVal_73 = core_es5["ɵnov"](_v, 70).ngClassInvalid;
        var currVal_74 = core_es5["ɵnov"](_v, 70).ngClassPending;
        _ck(_v, 62, 0, currVal_66, currVal_67, currVal_68, currVal_69, currVal_70, currVal_71, currVal_72, currVal_73, currVal_74);
        var currVal_90 = (core_es5["ɵnov"](_v, 83).required ? '' : null);
        var currVal_91 = (core_es5["ɵnov"](_v, 84).pattern ? core_es5["ɵnov"](_v, 84).pattern : null);
        var currVal_92 = core_es5["ɵnov"](_v, 90).ngClassUntouched;
        var currVal_93 = core_es5["ɵnov"](_v, 90).ngClassTouched;
        var currVal_94 = core_es5["ɵnov"](_v, 90).ngClassPristine;
        var currVal_95 = core_es5["ɵnov"](_v, 90).ngClassDirty;
        var currVal_96 = core_es5["ɵnov"](_v, 90).ngClassValid;
        var currVal_97 = core_es5["ɵnov"](_v, 90).ngClassInvalid;
        var currVal_98 = core_es5["ɵnov"](_v, 90).ngClassPending;
        _ck(_v, 82, 0, currVal_90, currVal_91, currVal_92, currVal_93, currVal_94, currVal_95, currVal_96, currVal_97, currVal_98);
        var currVal_114 = (core_es5["ɵnov"](_v, 106).required ? '' : null);
        var currVal_115 = core_es5["ɵnov"](_v, 112).ngClassUntouched;
        var currVal_116 = core_es5["ɵnov"](_v, 112).ngClassTouched;
        var currVal_117 = core_es5["ɵnov"](_v, 112).ngClassPristine;
        var currVal_118 = core_es5["ɵnov"](_v, 112).ngClassDirty;
        var currVal_119 = core_es5["ɵnov"](_v, 112).ngClassValid;
        var currVal_120 = core_es5["ɵnov"](_v, 112).ngClassInvalid;
        var currVal_121 = core_es5["ɵnov"](_v, 112).ngClassPending;
        _ck(_v, 105, 0, currVal_114, currVal_115, currVal_116, currVal_117, currVal_118, currVal_119, currVal_120, currVal_121);
        var currVal_135 = (core_es5["ɵnov"](_v, 125).required ? '' : null);
        var currVal_136 = (core_es5["ɵnov"](_v, 126).pattern ? core_es5["ɵnov"](_v, 126).pattern : null);
        var currVal_137 = core_es5["ɵnov"](_v, 132).ngClassUntouched;
        var currVal_138 = core_es5["ɵnov"](_v, 132).ngClassTouched;
        var currVal_139 = core_es5["ɵnov"](_v, 132).ngClassPristine;
        var currVal_140 = core_es5["ɵnov"](_v, 132).ngClassDirty;
        var currVal_141 = core_es5["ɵnov"](_v, 132).ngClassValid;
        var currVal_142 = core_es5["ɵnov"](_v, 132).ngClassInvalid;
        var currVal_143 = core_es5["ɵnov"](_v, 132).ngClassPending;
        _ck(_v, 124, 0, currVal_135, currVal_136, currVal_137, currVal_138, currVal_139, currVal_140, currVal_141, currVal_142, currVal_143);
        var currVal_158 = (core_es5["ɵnov"](_v, 142).required ? '' : null);
        var currVal_159 = core_es5["ɵnov"](_v, 148).ngClassUntouched;
        var currVal_160 = core_es5["ɵnov"](_v, 148).ngClassTouched;
        var currVal_161 = core_es5["ɵnov"](_v, 148).ngClassPristine;
        var currVal_162 = core_es5["ɵnov"](_v, 148).ngClassDirty;
        var currVal_163 = core_es5["ɵnov"](_v, 148).ngClassValid;
        var currVal_164 = core_es5["ɵnov"](_v, 148).ngClassInvalid;
        var currVal_165 = core_es5["ɵnov"](_v, 148).ngClassPending;
        _ck(_v, 141, 0, currVal_158, currVal_159, currVal_160, currVal_161, currVal_162, currVal_163, currVal_164, currVal_165);
        var currVal_179 = (core_es5["ɵnov"](_v, 158).required ? '' : null);
        var currVal_180 = core_es5["ɵnov"](_v, 164).ngClassUntouched;
        var currVal_181 = core_es5["ɵnov"](_v, 164).ngClassTouched;
        var currVal_182 = core_es5["ɵnov"](_v, 164).ngClassPristine;
        var currVal_183 = core_es5["ɵnov"](_v, 164).ngClassDirty;
        var currVal_184 = core_es5["ɵnov"](_v, 164).ngClassValid;
        var currVal_185 = core_es5["ɵnov"](_v, 164).ngClassInvalid;
        var currVal_186 = core_es5["ɵnov"](_v, 164).ngClassPending;
        _ck(_v, 157, 0, currVal_179, currVal_180, currVal_181, currVal_182, currVal_183, currVal_184, currVal_185, currVal_186);
        var currVal_200 = (core_es5["ɵnov"](_v, 177).required ? '' : null);
        var currVal_201 = core_es5["ɵnov"](_v, 183).ngClassUntouched;
        var currVal_202 = core_es5["ɵnov"](_v, 183).ngClassTouched;
        var currVal_203 = core_es5["ɵnov"](_v, 183).ngClassPristine;
        var currVal_204 = core_es5["ɵnov"](_v, 183).ngClassDirty;
        var currVal_205 = core_es5["ɵnov"](_v, 183).ngClassValid;
        var currVal_206 = core_es5["ɵnov"](_v, 183).ngClassInvalid;
        var currVal_207 = core_es5["ɵnov"](_v, 183).ngClassPending;
        _ck(_v, 176, 0, currVal_200, currVal_201, currVal_202, currVal_203, currVal_204, currVal_205, currVal_206, currVal_207);
        var currVal_221 = (core_es5["ɵnov"](_v, 193).required ? '' : null);
        var currVal_222 = core_es5["ɵnov"](_v, 199).ngClassUntouched;
        var currVal_223 = core_es5["ɵnov"](_v, 199).ngClassTouched;
        var currVal_224 = core_es5["ɵnov"](_v, 199).ngClassPristine;
        var currVal_225 = core_es5["ɵnov"](_v, 199).ngClassDirty;
        var currVal_226 = core_es5["ɵnov"](_v, 199).ngClassValid;
        var currVal_227 = core_es5["ɵnov"](_v, 199).ngClassInvalid;
        var currVal_228 = core_es5["ɵnov"](_v, 199).ngClassPending;
        _ck(_v, 192, 0, currVal_221, currVal_222, currVal_223, currVal_224, currVal_225, currVal_226, currVal_227, currVal_228);
        var currVal_242 = (core_es5["ɵnov"](_v, 209).required ? '' : null);
        var currVal_243 = core_es5["ɵnov"](_v, 215).ngClassUntouched;
        var currVal_244 = core_es5["ɵnov"](_v, 215).ngClassTouched;
        var currVal_245 = core_es5["ɵnov"](_v, 215).ngClassPristine;
        var currVal_246 = core_es5["ɵnov"](_v, 215).ngClassDirty;
        var currVal_247 = core_es5["ɵnov"](_v, 215).ngClassValid;
        var currVal_248 = core_es5["ɵnov"](_v, 215).ngClassInvalid;
        var currVal_249 = core_es5["ɵnov"](_v, 215).ngClassPending;
        _ck(_v, 208, 0, currVal_242, currVal_243, currVal_244, currVal_245, currVal_246, currVal_247, currVal_248, currVal_249);
        var currVal_263 = (core_es5["ɵnov"](_v, 225).required ? '' : null);
        var currVal_264 = core_es5["ɵnov"](_v, 231).ngClassUntouched;
        var currVal_265 = core_es5["ɵnov"](_v, 231).ngClassTouched;
        var currVal_266 = core_es5["ɵnov"](_v, 231).ngClassPristine;
        var currVal_267 = core_es5["ɵnov"](_v, 231).ngClassDirty;
        var currVal_268 = core_es5["ɵnov"](_v, 231).ngClassValid;
        var currVal_269 = core_es5["ɵnov"](_v, 231).ngClassInvalid;
        var currVal_270 = core_es5["ɵnov"](_v, 231).ngClassPending;
        _ck(_v, 224, 0, currVal_263, currVal_264, currVal_265, currVal_266, currVal_267, currVal_268, currVal_269, currVal_270);
        var currVal_284 = (core_es5["ɵnov"](_v, 244).required ? '' : null);
        var currVal_285 = (core_es5["ɵnov"](_v, 245).pattern ? core_es5["ɵnov"](_v, 245).pattern : null);
        var currVal_286 = core_es5["ɵnov"](_v, 251).ngClassUntouched;
        var currVal_287 = core_es5["ɵnov"](_v, 251).ngClassTouched;
        var currVal_288 = core_es5["ɵnov"](_v, 251).ngClassPristine;
        var currVal_289 = core_es5["ɵnov"](_v, 251).ngClassDirty;
        var currVal_290 = core_es5["ɵnov"](_v, 251).ngClassValid;
        var currVal_291 = core_es5["ɵnov"](_v, 251).ngClassInvalid;
        var currVal_292 = core_es5["ɵnov"](_v, 251).ngClassPending;
        _ck(_v, 243, 0, currVal_284, currVal_285, currVal_286, currVal_287, currVal_288, currVal_289, currVal_290, currVal_291, currVal_292);
        var currVal_308 = (core_es5["ɵnov"](_v, 267).required ? '' : null);
        var currVal_309 = (core_es5["ɵnov"](_v, 268).pattern ? core_es5["ɵnov"](_v, 268).pattern : null);
        var currVal_310 = core_es5["ɵnov"](_v, 274).ngClassUntouched;
        var currVal_311 = core_es5["ɵnov"](_v, 274).ngClassTouched;
        var currVal_312 = core_es5["ɵnov"](_v, 274).ngClassPristine;
        var currVal_313 = core_es5["ɵnov"](_v, 274).ngClassDirty;
        var currVal_314 = core_es5["ɵnov"](_v, 274).ngClassValid;
        var currVal_315 = core_es5["ɵnov"](_v, 274).ngClassInvalid;
        var currVal_316 = core_es5["ɵnov"](_v, 274).ngClassPending;
        _ck(_v, 266, 0, currVal_308, currVal_309, currVal_310, currVal_311, currVal_312, currVal_313, currVal_314, currVal_315, currVal_316);
    });
}
function View_TableBlock7501Component_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { tableBlockForm: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 142, 'form', [['class', 'padding-0'], ['novalidate', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'submit'],
            [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 3).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[1, 4], ['tableBlockForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 135, 'div', [['class', 'container-table row margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 132, 'div', [['class',
                'col-md-12 padding-0']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 129, 'div', [['class', 'table-inner']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 126, 'table', [['class',
                'table']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'thead', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'th', [['class', 'padding-left-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'th', [['colspan', '3']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'checkbox-label text-transform-none']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['28. Description of Merchandise'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'th', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'checkbox-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['32.'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'th', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['33.'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 2, 'th', [['class', 'padding-right-30'],
            ['colspan', '2']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'checkbox-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['34.'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 99, 'tbody', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 78, 'tr', [['class', 'background-light-orange']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'td', [['class', 'padding-left-30'],
            ['rowspan', '2']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label text-transform-none display-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['27.'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label text-transform-none display-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Line No.'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'td', [['rowspan', '2']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label text-transform-none display-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['29.'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label text-transform-none display-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['A. HTSUS No.'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'checkbox-label text-transform-none display-block']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['B. ADA/CVD No.'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'td', [['rowspan',
                '2']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label text-transform-none display-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['30.'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label text-transform-none display-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['A. Grossweight'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'checkbox-label text-transform-none display-block']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['B. Manifest Qty.'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'td', [['rowspan',
                '2']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label text-transform-none display-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['31.'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'span', [['class', 'checkbox-label text-transform-none display-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Net Quantity in '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' HTSUS Units'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 10, 'td', [['rowspan', '2']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'checkbox-label text-transform-none display-block']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['A. Entered Value'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label text-transform-none display-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['B. CHGS'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label text-transform-none display-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['C. Relationship'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'td', [['rowspan', '2']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label text-transform-none display-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['A. HTSUS Rate'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'checkbox-label text-transform-none display-block']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['B. ADA/CVD Rate'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label text-transform-none display-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['C. IRC Rate'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'checkbox-label text-transform-none display-block']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['D. Visa No.'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'td', [['class', 'padding-right-30'],
            ['colspan', '2']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label text-transform-none display-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Duty and I.R. Tax'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'tr', [['class',
                'background-light-orange']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'checkbox-label text-transform-none display-block']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Dollars'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'td', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label text-transform-none display-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Cents'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TableBlock7501Component_1)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.document.TableLineInputs;
        _ck(_v, 137, 0, currVal_7);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 5).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 5).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 5).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 5).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 5).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 5).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 5).ngClassPending;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_TableBlock7501Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'table-block-7501', [], null, null, null, View_TableBlock7501Component_0, RenderType_TableBlock7501Component)), core_es5["ɵdid"](49152, null, 0, table_block_7501_component_TableBlock7501Component, [], null, null)], null, null);
}
var TableBlock7501ComponentNgFactory = core_es5["ɵccf"]('table-block-7501', table_block_7501_component_TableBlock7501Component, View_TableBlock7501Component_Host_0, { document: 'document' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=table-block-7501.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/export-documents/cbp-7501/document-blocks/third-block-7501.component.ts

var third_block_7501_component_ThirdBlock7501Component = /** @class */ (function () {
    function ThirdBlock7501Component() {
        this.numberPatternHelper = ValidationPatterns;
    }
    ThirdBlock7501Component.prototype.submitFormAndValidity = function () {
        this.thirdBlockForm.onSubmit(null);
        return this.isFormValid();
    };
    ThirdBlock7501Component.prototype.isFormValid = function () {
        return this.thirdBlockForm.valid;
    };
    return ThirdBlock7501Component;
}());

//# sourceMappingURL=third-block-7501.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/export-documents/cbp-7501/document-blocks/third-block-7501.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_ThirdBlock7501Component = [];
var RenderType_ThirdBlock7501Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ThirdBlock7501Component, data: {} });
function View_ThirdBlock7501Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Other Fee Summary for Block 39 is required ']))], null, null);
}
function View_ThirdBlock7501Component_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Total Entered Value is required ']))], null, null);
}
function View_ThirdBlock7501Component_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Total Entered Value contain only numbers']))], null, null);
}
function View_ThirdBlock7501Component_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Total Other Fees is required ']))], null, null);
}
function View_ThirdBlock7501Component_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Total Other Fees should contain only numbers']))], null, null);
}
function View_ThirdBlock7501Component_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['This field should contain only numbers']))], null, null);
}
function View_ThirdBlock7501Component_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['This field should contain only numbers']))], null, null);
}
function View_ThirdBlock7501Component_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['This field should contain only numbers']))], null, null);
}
function View_ThirdBlock7501Component_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['This field should contain only numbers']))], null, null);
}
function View_ThirdBlock7501Component_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Duty is required ']))], null, null);
}
function View_ThirdBlock7501Component_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Duty should contain only numbers']))], null, null);
}
function View_ThirdBlock7501Component_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Tax is required ']))], null, null);
}
function View_ThirdBlock7501Component_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Tax should contain only numbers']))], null, null);
}
function View_ThirdBlock7501Component_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Other is required ']))], null, null);
}
function View_ThirdBlock7501Component_15(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Other should contain only numbers']))], null, null);
}
function View_ThirdBlock7501Component_16(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Total is required ']))], null, null);
}
function View_ThirdBlock7501Component_17(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Total should contain only numbers']))], null, null);
}
function View_ThirdBlock7501Component_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { thirdBlockForm: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 316, 'form', [['class', 'padding-0'], ['novalidate', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'submit'],
            [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 3).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[1, 4], ['thirdBlockForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 309, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 74, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 71, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'col-md-12 margin-bottom-20']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'col-md-12 margin-bottom-15']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'form-input', [['class', 'long-label'],
                ['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
                [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                    null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
                [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.OtherFeeSummaryForBlock39.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['OtherFeeSummaryForBlock39', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'col-md-12 margin-bottom-15']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['placeholder',
                '$ 0.00'], ['required', '']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.TotalEnteredValue.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['TotalEnteredValue',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'], placeholder: [6, 'placeholder'],
            isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'col-md-12 margin-bottom-15']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['placeholder',
                '$ 0.00'], ['required', '']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.TotalOtherFees.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['TotalOtherFees',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'], placeholder: [6, 'placeholder'],
            isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 126, 'div', [['class', 'col-md-5 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 123, 'div', [['class',
                'row background-grey']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['CBP USE ONLY'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 32, 'div', [['class', 'col-md-5']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 29, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-md-12 margin-bottom-15']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.LIQCode.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['LIQCode', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'col-md-12 margin-bottom-15']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched',
                    null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
                [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                    null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.ReasonCode.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['ReasonCode', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 80, 'div', [['class',
                'col-md-7']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 77, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-12 margin-bottom-15']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['placeholder', '$ 0.00']], [[1, 'pattern', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.AscertainedDuty.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['AscertainedDuty', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'], placeholder: [6, 'placeholder'], isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-12 margin-bottom-15']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['placeholder',
                '$ 0.00']], [[1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.AscertainedTax.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['AscertainedTax', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'], placeholder: [6, 'placeholder'], isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-12 margin-bottom-15']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['placeholder',
                '$ 0.00']], [[1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.AscertainedOther.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['AscertainedOther', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'], placeholder: [6, 'placeholder'], isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_8)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-12 margin-bottom-15']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['placeholder',
                '$ 0.00']], [[1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.AscertainedTotal.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['AscertainedTotal', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'], placeholder: [6, 'placeholder'], isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_9)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 102, 'div', [['class', 'col-md-3 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 99, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['TOTALS'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class',
                'col-md-12 margin-bottom-15']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 18, 'form-input', [['placeholder', '$ 0.00'],
                ['required', '']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched',
                    null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
                [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                    null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.Duty.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['Duty', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'], placeholder: [6, 'placeholder'],
            isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_10)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_11)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'col-md-12 margin-bottom-15']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['placeholder',
                '$ 0.00'], ['required', '']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.Tax.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['Tax', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'], placeholder: [6, 'placeholder'],
            isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_12)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_13)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'col-md-12 margin-bottom-15']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['placeholder',
                '$ 0.00'], ['required', '']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.Other.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['Other',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'], placeholder: [6, 'placeholder'],
            isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_14)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_15)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'col-md-12 margin-bottom-15']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['placeholder',
                '$ 0.00'], ['required', '']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.Total.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['Total',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'], placeholder: [6, 'placeholder'],
            isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_16)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ThirdBlock7501Component_17)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_15 = '';
        _ck(_v, 21, 0, currVal_15);
        var currVal_16 = !_co.document.OtherFeeSummaryForBlock39.IsValid;
        var currVal_17 = 'text';
        var currVal_18 = 'OtherFeeSummaryForBlock39';
        var currVal_19 = 'Other Fee Summary for Block 39';
        var currVal_20 = false;
        var currVal_21 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 23, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21);
        var currVal_22 = 'OtherFeeSummaryForBlock39';
        var currVal_23 = false;
        var currVal_24 = _co.document.OtherFeeSummaryForBlock39.Value;
        _ck(_v, 25, 0, currVal_22, currVal_23, currVal_24);
        var currVal_25 = _co.document.OtherFeeSummaryForBlock39;
        _ck(_v, 30, 0, currVal_25);
        var currVal_26 = ((core_es5["ɵnov"](_v, 23).model.hasError('required') && (!core_es5["ɵnov"](_v, 23).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.OtherFeeSummaryForBlock39.IsValid);
        _ck(_v, 33, 0, currVal_26);
        var currVal_36 = '';
        _ck(_v, 40, 0, currVal_36);
        var currVal_37 = _co.numberPatternHelper.doubleNumber;
        _ck(_v, 41, 0, currVal_37);
        var currVal_38 = !_co.document.TotalEnteredValue.IsValid;
        var currVal_39 = 'number';
        var currVal_40 = 'TotalEnteredValue';
        var currVal_41 = '35. Total Entered Value';
        var currVal_42 = false;
        var currVal_43 = core_es5["ɵnov"](_v, 3);
        var currVal_44 = '$ 0.00';
        var currVal_45 = true;
        _ck(_v, 43, 0, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44, currVal_45);
        var currVal_46 = 'TotalEnteredValue';
        var currVal_47 = false;
        var currVal_48 = _co.document.TotalEnteredValue.Value;
        _ck(_v, 45, 0, currVal_46, currVal_47, currVal_48);
        var currVal_49 = _co.document.TotalEnteredValue;
        _ck(_v, 50, 0, currVal_49);
        var currVal_50 = ((core_es5["ɵnov"](_v, 43).model.hasError('required') && (!core_es5["ɵnov"](_v, 43).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.TotalEnteredValue.IsValid);
        _ck(_v, 53, 0, currVal_50);
        var currVal_51 = ((core_es5["ɵnov"](_v, 43).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 43).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.TotalEnteredValue.IsValid);
        _ck(_v, 56, 0, currVal_51);
        var currVal_61 = '';
        _ck(_v, 63, 0, currVal_61);
        var currVal_62 = _co.numberPatternHelper.doubleNumber;
        _ck(_v, 64, 0, currVal_62);
        var currVal_63 = !_co.document.TotalOtherFees.IsValid;
        var currVal_64 = 'number';
        var currVal_65 = 'TotalOtherFees';
        var currVal_66 = 'Total Other Fees';
        var currVal_67 = false;
        var currVal_68 = core_es5["ɵnov"](_v, 3);
        var currVal_69 = '$ 0.00';
        var currVal_70 = true;
        _ck(_v, 66, 0, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67, currVal_68, currVal_69, currVal_70);
        var currVal_71 = 'TotalOtherFees';
        var currVal_72 = false;
        var currVal_73 = _co.document.TotalOtherFees.Value;
        _ck(_v, 68, 0, currVal_71, currVal_72, currVal_73);
        var currVal_74 = _co.document.TotalOtherFees;
        _ck(_v, 73, 0, currVal_74);
        var currVal_75 = ((core_es5["ɵnov"](_v, 66).model.hasError('required') && (!core_es5["ɵnov"](_v, 66).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.TotalOtherFees.IsValid);
        _ck(_v, 76, 0, currVal_75);
        var currVal_76 = ((core_es5["ɵnov"](_v, 66).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 66).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.TotalOtherFees.IsValid);
        _ck(_v, 79, 0, currVal_76);
        var currVal_84 = !_co.document.LIQCode.IsValid;
        var currVal_85 = 'number';
        var currVal_86 = 'LIQCode';
        var currVal_87 = 'A. LIQ CODE';
        var currVal_88 = false;
        var currVal_89 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 102, 0, currVal_84, currVal_85, currVal_86, currVal_87, currVal_88, currVal_89);
        var currVal_90 = 'LIQCode';
        var currVal_91 = false;
        var currVal_92 = _co.document.LIQCode.Value;
        _ck(_v, 104, 0, currVal_90, currVal_91, currVal_92);
        var currVal_93 = _co.document.LIQCode;
        _ck(_v, 109, 0, currVal_93);
        var currVal_101 = !_co.document.ReasonCode.IsValid;
        var currVal_102 = 'number';
        var currVal_103 = 'ReasonCode';
        var currVal_104 = 'REASON CODE';
        var currVal_105 = false;
        var currVal_106 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 116, 0, currVal_101, currVal_102, currVal_103, currVal_104, currVal_105, currVal_106);
        var currVal_107 = 'ReasonCode';
        var currVal_108 = false;
        var currVal_109 = _co.document.ReasonCode.Value;
        _ck(_v, 118, 0, currVal_107, currVal_108, currVal_109);
        var currVal_110 = _co.document.ReasonCode;
        _ck(_v, 123, 0, currVal_110);
        var currVal_119 = _co.numberPatternHelper.doubleNumber;
        _ck(_v, 136, 0, currVal_119);
        var currVal_120 = !_co.document.AscertainedDuty.IsValid;
        var currVal_121 = 'number';
        var currVal_122 = 'AscertainedDuty';
        var currVal_123 = 'B. Ascertained Duty';
        var currVal_124 = false;
        var currVal_125 = core_es5["ɵnov"](_v, 3);
        var currVal_126 = '$ 0.00';
        var currVal_127 = true;
        _ck(_v, 138, 0, currVal_120, currVal_121, currVal_122, currVal_123, currVal_124, currVal_125, currVal_126, currVal_127);
        var currVal_128 = 'AscertainedDuty';
        var currVal_129 = false;
        var currVal_130 = _co.document.AscertainedDuty.Value;
        _ck(_v, 140, 0, currVal_128, currVal_129, currVal_130);
        var currVal_131 = _co.document.AscertainedDuty;
        _ck(_v, 145, 0, currVal_131);
        var currVal_132 = core_es5["ɵnov"](_v, 138).model.hasError('pattern');
        _ck(_v, 148, 0, currVal_132);
        var currVal_141 = _co.numberPatternHelper.doubleNumber;
        _ck(_v, 155, 0, currVal_141);
        var currVal_142 = !_co.document.AscertainedTax.IsValid;
        var currVal_143 = 'number';
        var currVal_144 = 'AscertainedTax';
        var currVal_145 = 'C. Ascertained Tax';
        var currVal_146 = false;
        var currVal_147 = core_es5["ɵnov"](_v, 3);
        var currVal_148 = '$ 0.00';
        var currVal_149 = true;
        _ck(_v, 157, 0, currVal_142, currVal_143, currVal_144, currVal_145, currVal_146, currVal_147, currVal_148, currVal_149);
        var currVal_150 = 'AscertainedTax';
        var currVal_151 = false;
        var currVal_152 = _co.document.AscertainedTax.Value;
        _ck(_v, 159, 0, currVal_150, currVal_151, currVal_152);
        var currVal_153 = _co.document.AscertainedTax;
        _ck(_v, 164, 0, currVal_153);
        var currVal_154 = core_es5["ɵnov"](_v, 157).model.hasError('pattern');
        _ck(_v, 167, 0, currVal_154);
        var currVal_163 = _co.numberPatternHelper.doubleNumber;
        _ck(_v, 174, 0, currVal_163);
        var currVal_164 = !_co.document.AscertainedOther.IsValid;
        var currVal_165 = 'number';
        var currVal_166 = 'AscertainedOther';
        var currVal_167 = 'D. Ascertained Other';
        var currVal_168 = false;
        var currVal_169 = core_es5["ɵnov"](_v, 3);
        var currVal_170 = '$ 0.00';
        var currVal_171 = true;
        _ck(_v, 176, 0, currVal_164, currVal_165, currVal_166, currVal_167, currVal_168, currVal_169, currVal_170, currVal_171);
        var currVal_172 = 'AscertainedOther';
        var currVal_173 = false;
        var currVal_174 = _co.document.AscertainedOther.Value;
        _ck(_v, 178, 0, currVal_172, currVal_173, currVal_174);
        var currVal_175 = _co.document.AscertainedOther;
        _ck(_v, 183, 0, currVal_175);
        var currVal_176 = core_es5["ɵnov"](_v, 176).model.hasError('pattern');
        _ck(_v, 186, 0, currVal_176);
        var currVal_185 = _co.numberPatternHelper.doubleNumber;
        _ck(_v, 193, 0, currVal_185);
        var currVal_186 = !_co.document.AscertainedTotal.IsValid;
        var currVal_187 = 'number';
        var currVal_188 = 'AscertainedTotal';
        var currVal_189 = 'E. Ascertained Total';
        var currVal_190 = false;
        var currVal_191 = core_es5["ɵnov"](_v, 3);
        var currVal_192 = '$ 0.00';
        var currVal_193 = true;
        _ck(_v, 195, 0, currVal_186, currVal_187, currVal_188, currVal_189, currVal_190, currVal_191, currVal_192, currVal_193);
        var currVal_194 = 'AscertainedTotal';
        var currVal_195 = false;
        var currVal_196 = _co.document.AscertainedTotal.Value;
        _ck(_v, 197, 0, currVal_194, currVal_195, currVal_196);
        var currVal_197 = _co.document.AscertainedTotal;
        _ck(_v, 202, 0, currVal_197);
        var currVal_198 = core_es5["ɵnov"](_v, 195).model.hasError('pattern');
        _ck(_v, 205, 0, currVal_198);
        var currVal_208 = '';
        _ck(_v, 226, 0, currVal_208);
        var currVal_209 = _co.numberPatternHelper.doubleNumber;
        _ck(_v, 227, 0, currVal_209);
        var currVal_210 = !_co.document.Duty.IsValid;
        var currVal_211 = 'number';
        var currVal_212 = 'Duty';
        var currVal_213 = '37. Duty';
        var currVal_214 = false;
        var currVal_215 = core_es5["ɵnov"](_v, 3);
        var currVal_216 = '$ 0.00';
        var currVal_217 = true;
        _ck(_v, 229, 0, currVal_210, currVal_211, currVal_212, currVal_213, currVal_214, currVal_215, currVal_216, currVal_217);
        var currVal_218 = 'Duty';
        var currVal_219 = false;
        var currVal_220 = _co.document.Duty.Value;
        _ck(_v, 231, 0, currVal_218, currVal_219, currVal_220);
        var currVal_221 = _co.document.Duty;
        _ck(_v, 236, 0, currVal_221);
        var currVal_222 = ((core_es5["ɵnov"](_v, 229).model.hasError('required') && (!core_es5["ɵnov"](_v, 229).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.Duty.IsValid);
        _ck(_v, 239, 0, currVal_222);
        var currVal_223 = ((core_es5["ɵnov"](_v, 229).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 229).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.Duty.IsValid);
        _ck(_v, 242, 0, currVal_223);
        var currVal_233 = '';
        _ck(_v, 249, 0, currVal_233);
        var currVal_234 = _co.numberPatternHelper.doubleNumber;
        _ck(_v, 250, 0, currVal_234);
        var currVal_235 = !_co.document.Tax.IsValid;
        var currVal_236 = 'number';
        var currVal_237 = 'Tax';
        var currVal_238 = '38. Tax';
        var currVal_239 = false;
        var currVal_240 = core_es5["ɵnov"](_v, 3);
        var currVal_241 = '$ 0.00';
        var currVal_242 = true;
        _ck(_v, 252, 0, currVal_235, currVal_236, currVal_237, currVal_238, currVal_239, currVal_240, currVal_241, currVal_242);
        var currVal_243 = 'Tax';
        var currVal_244 = false;
        var currVal_245 = _co.document.Tax.Value;
        _ck(_v, 254, 0, currVal_243, currVal_244, currVal_245);
        var currVal_246 = _co.document.Tax;
        _ck(_v, 259, 0, currVal_246);
        var currVal_247 = ((core_es5["ɵnov"](_v, 252).model.hasError('required') && (!core_es5["ɵnov"](_v, 252).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.Tax.IsValid);
        _ck(_v, 262, 0, currVal_247);
        var currVal_248 = ((core_es5["ɵnov"](_v, 252).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 252).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.Tax.IsValid);
        _ck(_v, 265, 0, currVal_248);
        var currVal_258 = '';
        _ck(_v, 272, 0, currVal_258);
        var currVal_259 = _co.numberPatternHelper.doubleNumber;
        _ck(_v, 273, 0, currVal_259);
        var currVal_260 = !_co.document.Other.IsValid;
        var currVal_261 = 'number';
        var currVal_262 = 'Other';
        var currVal_263 = '39. Other';
        var currVal_264 = false;
        var currVal_265 = core_es5["ɵnov"](_v, 3);
        var currVal_266 = '$ 0.00';
        var currVal_267 = true;
        _ck(_v, 275, 0, currVal_260, currVal_261, currVal_262, currVal_263, currVal_264, currVal_265, currVal_266, currVal_267);
        var currVal_268 = 'Other';
        var currVal_269 = false;
        var currVal_270 = _co.document.Other.Value;
        _ck(_v, 277, 0, currVal_268, currVal_269, currVal_270);
        var currVal_271 = _co.document.Other;
        _ck(_v, 282, 0, currVal_271);
        var currVal_272 = ((core_es5["ɵnov"](_v, 275).model.hasError('required') && (!core_es5["ɵnov"](_v, 275).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.Other.IsValid);
        _ck(_v, 285, 0, currVal_272);
        var currVal_273 = ((core_es5["ɵnov"](_v, 275).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 275).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.Other.IsValid);
        _ck(_v, 288, 0, currVal_273);
        var currVal_283 = '';
        _ck(_v, 295, 0, currVal_283);
        var currVal_284 = _co.numberPatternHelper.doubleNumber;
        _ck(_v, 296, 0, currVal_284);
        var currVal_285 = !_co.document.Total.IsValid;
        var currVal_286 = 'number';
        var currVal_287 = 'Total';
        var currVal_288 = '40. Total';
        var currVal_289 = false;
        var currVal_290 = core_es5["ɵnov"](_v, 3);
        var currVal_291 = '$ 0.00';
        var currVal_292 = true;
        _ck(_v, 298, 0, currVal_285, currVal_286, currVal_287, currVal_288, currVal_289, currVal_290, currVal_291, currVal_292);
        var currVal_293 = 'Total';
        var currVal_294 = false;
        var currVal_295 = _co.document.Total.Value;
        _ck(_v, 300, 0, currVal_293, currVal_294, currVal_295);
        var currVal_296 = _co.document.Total;
        _ck(_v, 305, 0, currVal_296);
        var currVal_297 = ((core_es5["ɵnov"](_v, 298).model.hasError('required') && (!core_es5["ɵnov"](_v, 298).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.Total.IsValid);
        _ck(_v, 308, 0, currVal_297);
        var currVal_298 = ((core_es5["ɵnov"](_v, 298).model.hasError('pattern') && (!core_es5["ɵnov"](_v, 298).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.Total.IsValid);
        _ck(_v, 311, 0, currVal_298);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 5).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 5).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 5).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 5).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 5).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 5).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 5).ngClassPending;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (core_es5["ɵnov"](_v, 21).required ? '' : null);
        var currVal_8 = core_es5["ɵnov"](_v, 27).ngClassUntouched;
        var currVal_9 = core_es5["ɵnov"](_v, 27).ngClassTouched;
        var currVal_10 = core_es5["ɵnov"](_v, 27).ngClassPristine;
        var currVal_11 = core_es5["ɵnov"](_v, 27).ngClassDirty;
        var currVal_12 = core_es5["ɵnov"](_v, 27).ngClassValid;
        var currVal_13 = core_es5["ɵnov"](_v, 27).ngClassInvalid;
        var currVal_14 = core_es5["ɵnov"](_v, 27).ngClassPending;
        _ck(_v, 20, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_27 = (core_es5["ɵnov"](_v, 40).required ? '' : null);
        var currVal_28 = (core_es5["ɵnov"](_v, 41).pattern ? core_es5["ɵnov"](_v, 41).pattern : null);
        var currVal_29 = core_es5["ɵnov"](_v, 47).ngClassUntouched;
        var currVal_30 = core_es5["ɵnov"](_v, 47).ngClassTouched;
        var currVal_31 = core_es5["ɵnov"](_v, 47).ngClassPristine;
        var currVal_32 = core_es5["ɵnov"](_v, 47).ngClassDirty;
        var currVal_33 = core_es5["ɵnov"](_v, 47).ngClassValid;
        var currVal_34 = core_es5["ɵnov"](_v, 47).ngClassInvalid;
        var currVal_35 = core_es5["ɵnov"](_v, 47).ngClassPending;
        _ck(_v, 39, 0, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35);
        var currVal_52 = (core_es5["ɵnov"](_v, 63).required ? '' : null);
        var currVal_53 = (core_es5["ɵnov"](_v, 64).pattern ? core_es5["ɵnov"](_v, 64).pattern : null);
        var currVal_54 = core_es5["ɵnov"](_v, 70).ngClassUntouched;
        var currVal_55 = core_es5["ɵnov"](_v, 70).ngClassTouched;
        var currVal_56 = core_es5["ɵnov"](_v, 70).ngClassPristine;
        var currVal_57 = core_es5["ɵnov"](_v, 70).ngClassDirty;
        var currVal_58 = core_es5["ɵnov"](_v, 70).ngClassValid;
        var currVal_59 = core_es5["ɵnov"](_v, 70).ngClassInvalid;
        var currVal_60 = core_es5["ɵnov"](_v, 70).ngClassPending;
        _ck(_v, 62, 0, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56, currVal_57, currVal_58, currVal_59, currVal_60);
        var currVal_77 = core_es5["ɵnov"](_v, 106).ngClassUntouched;
        var currVal_78 = core_es5["ɵnov"](_v, 106).ngClassTouched;
        var currVal_79 = core_es5["ɵnov"](_v, 106).ngClassPristine;
        var currVal_80 = core_es5["ɵnov"](_v, 106).ngClassDirty;
        var currVal_81 = core_es5["ɵnov"](_v, 106).ngClassValid;
        var currVal_82 = core_es5["ɵnov"](_v, 106).ngClassInvalid;
        var currVal_83 = core_es5["ɵnov"](_v, 106).ngClassPending;
        _ck(_v, 101, 0, currVal_77, currVal_78, currVal_79, currVal_80, currVal_81, currVal_82, currVal_83);
        var currVal_94 = core_es5["ɵnov"](_v, 120).ngClassUntouched;
        var currVal_95 = core_es5["ɵnov"](_v, 120).ngClassTouched;
        var currVal_96 = core_es5["ɵnov"](_v, 120).ngClassPristine;
        var currVal_97 = core_es5["ɵnov"](_v, 120).ngClassDirty;
        var currVal_98 = core_es5["ɵnov"](_v, 120).ngClassValid;
        var currVal_99 = core_es5["ɵnov"](_v, 120).ngClassInvalid;
        var currVal_100 = core_es5["ɵnov"](_v, 120).ngClassPending;
        _ck(_v, 115, 0, currVal_94, currVal_95, currVal_96, currVal_97, currVal_98, currVal_99, currVal_100);
        var currVal_111 = (core_es5["ɵnov"](_v, 136).pattern ? core_es5["ɵnov"](_v, 136).pattern : null);
        var currVal_112 = core_es5["ɵnov"](_v, 142).ngClassUntouched;
        var currVal_113 = core_es5["ɵnov"](_v, 142).ngClassTouched;
        var currVal_114 = core_es5["ɵnov"](_v, 142).ngClassPristine;
        var currVal_115 = core_es5["ɵnov"](_v, 142).ngClassDirty;
        var currVal_116 = core_es5["ɵnov"](_v, 142).ngClassValid;
        var currVal_117 = core_es5["ɵnov"](_v, 142).ngClassInvalid;
        var currVal_118 = core_es5["ɵnov"](_v, 142).ngClassPending;
        _ck(_v, 135, 0, currVal_111, currVal_112, currVal_113, currVal_114, currVal_115, currVal_116, currVal_117, currVal_118);
        var currVal_133 = (core_es5["ɵnov"](_v, 155).pattern ? core_es5["ɵnov"](_v, 155).pattern : null);
        var currVal_134 = core_es5["ɵnov"](_v, 161).ngClassUntouched;
        var currVal_135 = core_es5["ɵnov"](_v, 161).ngClassTouched;
        var currVal_136 = core_es5["ɵnov"](_v, 161).ngClassPristine;
        var currVal_137 = core_es5["ɵnov"](_v, 161).ngClassDirty;
        var currVal_138 = core_es5["ɵnov"](_v, 161).ngClassValid;
        var currVal_139 = core_es5["ɵnov"](_v, 161).ngClassInvalid;
        var currVal_140 = core_es5["ɵnov"](_v, 161).ngClassPending;
        _ck(_v, 154, 0, currVal_133, currVal_134, currVal_135, currVal_136, currVal_137, currVal_138, currVal_139, currVal_140);
        var currVal_155 = (core_es5["ɵnov"](_v, 174).pattern ? core_es5["ɵnov"](_v, 174).pattern : null);
        var currVal_156 = core_es5["ɵnov"](_v, 180).ngClassUntouched;
        var currVal_157 = core_es5["ɵnov"](_v, 180).ngClassTouched;
        var currVal_158 = core_es5["ɵnov"](_v, 180).ngClassPristine;
        var currVal_159 = core_es5["ɵnov"](_v, 180).ngClassDirty;
        var currVal_160 = core_es5["ɵnov"](_v, 180).ngClassValid;
        var currVal_161 = core_es5["ɵnov"](_v, 180).ngClassInvalid;
        var currVal_162 = core_es5["ɵnov"](_v, 180).ngClassPending;
        _ck(_v, 173, 0, currVal_155, currVal_156, currVal_157, currVal_158, currVal_159, currVal_160, currVal_161, currVal_162);
        var currVal_177 = (core_es5["ɵnov"](_v, 193).pattern ? core_es5["ɵnov"](_v, 193).pattern : null);
        var currVal_178 = core_es5["ɵnov"](_v, 199).ngClassUntouched;
        var currVal_179 = core_es5["ɵnov"](_v, 199).ngClassTouched;
        var currVal_180 = core_es5["ɵnov"](_v, 199).ngClassPristine;
        var currVal_181 = core_es5["ɵnov"](_v, 199).ngClassDirty;
        var currVal_182 = core_es5["ɵnov"](_v, 199).ngClassValid;
        var currVal_183 = core_es5["ɵnov"](_v, 199).ngClassInvalid;
        var currVal_184 = core_es5["ɵnov"](_v, 199).ngClassPending;
        _ck(_v, 192, 0, currVal_177, currVal_178, currVal_179, currVal_180, currVal_181, currVal_182, currVal_183, currVal_184);
        var currVal_199 = (core_es5["ɵnov"](_v, 226).required ? '' : null);
        var currVal_200 = (core_es5["ɵnov"](_v, 227).pattern ? core_es5["ɵnov"](_v, 227).pattern : null);
        var currVal_201 = core_es5["ɵnov"](_v, 233).ngClassUntouched;
        var currVal_202 = core_es5["ɵnov"](_v, 233).ngClassTouched;
        var currVal_203 = core_es5["ɵnov"](_v, 233).ngClassPristine;
        var currVal_204 = core_es5["ɵnov"](_v, 233).ngClassDirty;
        var currVal_205 = core_es5["ɵnov"](_v, 233).ngClassValid;
        var currVal_206 = core_es5["ɵnov"](_v, 233).ngClassInvalid;
        var currVal_207 = core_es5["ɵnov"](_v, 233).ngClassPending;
        _ck(_v, 225, 0, currVal_199, currVal_200, currVal_201, currVal_202, currVal_203, currVal_204, currVal_205, currVal_206, currVal_207);
        var currVal_224 = (core_es5["ɵnov"](_v, 249).required ? '' : null);
        var currVal_225 = (core_es5["ɵnov"](_v, 250).pattern ? core_es5["ɵnov"](_v, 250).pattern : null);
        var currVal_226 = core_es5["ɵnov"](_v, 256).ngClassUntouched;
        var currVal_227 = core_es5["ɵnov"](_v, 256).ngClassTouched;
        var currVal_228 = core_es5["ɵnov"](_v, 256).ngClassPristine;
        var currVal_229 = core_es5["ɵnov"](_v, 256).ngClassDirty;
        var currVal_230 = core_es5["ɵnov"](_v, 256).ngClassValid;
        var currVal_231 = core_es5["ɵnov"](_v, 256).ngClassInvalid;
        var currVal_232 = core_es5["ɵnov"](_v, 256).ngClassPending;
        _ck(_v, 248, 0, currVal_224, currVal_225, currVal_226, currVal_227, currVal_228, currVal_229, currVal_230, currVal_231, currVal_232);
        var currVal_249 = (core_es5["ɵnov"](_v, 272).required ? '' : null);
        var currVal_250 = (core_es5["ɵnov"](_v, 273).pattern ? core_es5["ɵnov"](_v, 273).pattern : null);
        var currVal_251 = core_es5["ɵnov"](_v, 279).ngClassUntouched;
        var currVal_252 = core_es5["ɵnov"](_v, 279).ngClassTouched;
        var currVal_253 = core_es5["ɵnov"](_v, 279).ngClassPristine;
        var currVal_254 = core_es5["ɵnov"](_v, 279).ngClassDirty;
        var currVal_255 = core_es5["ɵnov"](_v, 279).ngClassValid;
        var currVal_256 = core_es5["ɵnov"](_v, 279).ngClassInvalid;
        var currVal_257 = core_es5["ɵnov"](_v, 279).ngClassPending;
        _ck(_v, 271, 0, currVal_249, currVal_250, currVal_251, currVal_252, currVal_253, currVal_254, currVal_255, currVal_256, currVal_257);
        var currVal_274 = (core_es5["ɵnov"](_v, 295).required ? '' : null);
        var currVal_275 = (core_es5["ɵnov"](_v, 296).pattern ? core_es5["ɵnov"](_v, 296).pattern : null);
        var currVal_276 = core_es5["ɵnov"](_v, 302).ngClassUntouched;
        var currVal_277 = core_es5["ɵnov"](_v, 302).ngClassTouched;
        var currVal_278 = core_es5["ɵnov"](_v, 302).ngClassPristine;
        var currVal_279 = core_es5["ɵnov"](_v, 302).ngClassDirty;
        var currVal_280 = core_es5["ɵnov"](_v, 302).ngClassValid;
        var currVal_281 = core_es5["ɵnov"](_v, 302).ngClassInvalid;
        var currVal_282 = core_es5["ɵnov"](_v, 302).ngClassPending;
        _ck(_v, 294, 0, currVal_274, currVal_275, currVal_276, currVal_277, currVal_278, currVal_279, currVal_280, currVal_281, currVal_282);
    });
}
function View_ThirdBlock7501Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'third-block-7501', [], null, null, null, View_ThirdBlock7501Component_0, RenderType_ThirdBlock7501Component)), core_es5["ɵdid"](49152, null, 0, third_block_7501_component_ThirdBlock7501Component, [], null, null)], null, null);
}
var ThirdBlock7501ComponentNgFactory = core_es5["ɵccf"]('third-block-7501', third_block_7501_component_ThirdBlock7501Component, View_ThirdBlock7501Component_Host_0, { document: 'document' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=third-block-7501.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/export-documents/cbp-7501/document-blocks/declaration-block-7501.component.ts
var DeclarationBlock7501Component = /** @class */ (function () {
    function DeclarationBlock7501Component() {
    }
    DeclarationBlock7501Component.prototype.submitFormAndValidity = function () {
        this.declarationForm.onSubmit(null);
        return this.isFormValid();
    };
    DeclarationBlock7501Component.prototype.isFormValid = function () {
        return this.declarationForm.valid;
    };
    return DeclarationBlock7501Component;
}());

//# sourceMappingURL=declaration-block-7501.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/export-documents/cbp-7501/document-blocks/declaration-block-7501.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_DeclarationBlock7501Component = [];
var RenderType_DeclarationBlock7501Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DeclarationBlock7501Component, data: {} });
function View_DeclarationBlock7501Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Declarant name is required ']))], null, null);
}
function View_DeclarationBlock7501Component_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Title is required ']))], null, null);
}
function View_DeclarationBlock7501Component_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Date is required ']))], null, null);
}
function View_DeclarationBlock7501Component_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Broker/Filer Information is required ']))], null, null);
}
function View_DeclarationBlock7501Component_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Broker/importer file no. is required ']))], null, null);
}
function View_DeclarationBlock7501Component_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { declarationForm: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 188, 'form', [['class', 'padding-0'], ['novalidate', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'submit'],
            [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 3).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[1, 4], ['declarationForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12 margin-bottom-15']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checkbox-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['36. DECLARATION OF IMPORTER OF RECORD (OWNER OR PURCHASER) OR AUTHORIZED AGENT'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 57, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 51, 'div', [['class', 'col-md-6 margin-bottom-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 23, 'div', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'has-error': 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'bold display-block declaration-block-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['I declare that I am the'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.DeclarationOfImporterOfRecord.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.DeclarationOfImporterOfRecord.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 23, 'div', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'has-error': 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'bold display-block declaration-block-title margin-top-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['I further declare that the merchandise'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.DeclarationOfMerchandiseOfRecord.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'radio', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.DeclarationOfMerchandiseOfRecord.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RadioComponent_0, RenderType_RadioComponent)), core_es5["ɵdid"](4243456, null, 0, radio_component_RadioComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], radioValue: [2, 'radioValue'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [radio_component_RadioComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'col-md-6 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' I also declare that the statements in the documents herein filed fully disclose to the best of my knowledge and belief the true prices, values, quantities, rebates, drawbacks, fees, commissions, and royalties and are true and correct, and that all goods or services provided to the seller of the merchandise either free or at reduced cost are fully disclosed. I will immediately furnish to the appropriate CBP officer any information showing a different statement of facts. '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 72, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'col-md-3 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2,
                    'ng-valid', null], [2, 'ng-invalid', null], [2,
                    'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.DeclarantName.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['DeclarantName', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_DeclarationBlock7501Component_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-3 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.Title.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['Title', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_DeclarationBlock7501Component_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-md-3 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'form-input', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.Signature.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['Signature', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'], type: [1, 'type'], name: [2, 'name'], label: [3, 'label'],
            disabled: [4, 'disabled'], form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'col-md-3 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'form-input', [['placeholder', 'MM/DD/YYYY'],
                ['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null],
                [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                    null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
                [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.document.DeclarantDate.Value = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['DeclarantDate', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'], placeholder: [6, 'placeholder'], isPlaceholderNeed: [7, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_DeclarationBlock7501Component_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 39, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-8 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.BrokerInformation.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['BrokerInformation', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_DeclarationBlock7501Component_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'col-md-4 margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form-input', [['required',
                '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.document.BrokerFileNo.Value = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['BrokerFileNo', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { hasErrors: [0, 'hasErrors'],
            type: [1, 'type'], name: [2, 'name'], label: [3, 'label'], disabled: [4, 'disabled'],
            form: [5, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'form-input-errors', [], null, null, null, View_FormInputErrorsComponent_0, RenderType_FormInputErrorsComponent)), core_es5["ɵdid"](49152, null, 0, FormInputErrorsComponent, [], { inputField: [0, 'inputField'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_DeclarationBlock7501Component_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _ck(_v, 22, 0, (core_es5["ɵnov"](_v, 3).submitted && (_co.document.DeclarationOfImporterOfRecord.Value == null)));
        _ck(_v, 21, 0, currVal_7);
        var currVal_15 = 'Importer';
        var currVal_16 = 'Importer of record and that the actual owner, purchaser, or consignee for CBP purposes is as shown above,';
        var currVal_17 = 0;
        _ck(_v, 28, 0, currVal_15, currVal_16, currVal_17);
        var currVal_18 = 'Importer';
        var currVal_19 = _co.document.DeclarationOfImporterOfRecord.Value;
        _ck(_v, 30, 0, currVal_18, currVal_19);
        var currVal_27 = 'owner';
        var currVal_28 = 'owner or purchaser or agent thereof.';
        var currVal_29 = 1;
        _ck(_v, 35, 0, currVal_27, currVal_28, currVal_29);
        var currVal_30 = 'owner';
        var currVal_31 = _co.document.DeclarationOfImporterOfRecord.Value;
        _ck(_v, 37, 0, currVal_30, currVal_31);
        var currVal_32 = _co.document.DeclarationOfImporterOfRecord;
        _ck(_v, 42, 0, currVal_32);
        var currVal_33 = _ck(_v, 47, 0, (core_es5["ɵnov"](_v, 3).submitted && (_co.document.DeclarationOfMerchandiseOfRecord.Value == null)));
        _ck(_v, 46, 0, currVal_33);
        var currVal_41 = 'obtained';
        var currVal_42 = 'was obtained pursuant to a purchase or agreement to purchase and that the prices set forth in the invoices are true,';
        var currVal_43 = 0;
        _ck(_v, 53, 0, currVal_41, currVal_42, currVal_43);
        var currVal_44 = 'obtained';
        var currVal_45 = _co.document.DeclarationOfMerchandiseOfRecord.Value;
        _ck(_v, 55, 0, currVal_44, currVal_45);
        var currVal_53 = 'notObtained';
        var currVal_54 = 'was not obtained pursuant to a purchase or agreement to purchase and the statements in the invoices as to value or price are true to the best of my knowledge and belief.';
        var currVal_55 = 1;
        _ck(_v, 60, 0, currVal_53, currVal_54, currVal_55);
        var currVal_56 = 'notObtained';
        var currVal_57 = _co.document.DeclarationOfMerchandiseOfRecord.Value;
        _ck(_v, 62, 0, currVal_56, currVal_57);
        var currVal_58 = _co.document.DeclarationOfMerchandiseOfRecord;
        _ck(_v, 67, 0, currVal_58);
        var currVal_67 = '';
        _ck(_v, 80, 0, currVal_67);
        var currVal_68 = !_co.document.DeclarantName.IsValid;
        var currVal_69 = 'text';
        var currVal_70 = 'Declarant name';
        var currVal_71 = '41. Declarant name';
        var currVal_72 = false;
        var currVal_73 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 82, 0, currVal_68, currVal_69, currVal_70, currVal_71, currVal_72, currVal_73);
        var currVal_74 = 'Declarant name';
        var currVal_75 = false;
        var currVal_76 = _co.document.DeclarantName.Value;
        _ck(_v, 84, 0, currVal_74, currVal_75, currVal_76);
        var currVal_77 = _co.document.DeclarantName;
        _ck(_v, 89, 0, currVal_77);
        var currVal_78 = ((core_es5["ɵnov"](_v, 82).model.hasError('required') && (!core_es5["ɵnov"](_v, 82).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.DeclarantName.IsValid);
        _ck(_v, 92, 0, currVal_78);
        var currVal_87 = '';
        _ck(_v, 99, 0, currVal_87);
        var currVal_88 = !_co.document.Title.IsValid;
        var currVal_89 = 'text';
        var currVal_90 = 'Title';
        var currVal_91 = 'Title';
        var currVal_92 = false;
        var currVal_93 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 101, 0, currVal_88, currVal_89, currVal_90, currVal_91, currVal_92, currVal_93);
        var currVal_94 = 'Title';
        var currVal_95 = false;
        var currVal_96 = _co.document.Title.Value;
        _ck(_v, 103, 0, currVal_94, currVal_95, currVal_96);
        var currVal_97 = _co.document.Title;
        _ck(_v, 108, 0, currVal_97);
        var currVal_98 = ((core_es5["ɵnov"](_v, 101).model.hasError('required') && (!core_es5["ɵnov"](_v, 101).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.Title.IsValid);
        _ck(_v, 111, 0, currVal_98);
        var currVal_106 = !_co.document.Signature.IsValid;
        var currVal_107 = 'text';
        var currVal_108 = 'Signature';
        var currVal_109 = 'Signature';
        var currVal_110 = false;
        var currVal_111 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 118, 0, currVal_106, currVal_107, currVal_108, currVal_109, currVal_110, currVal_111);
        var currVal_112 = 'Signature';
        var currVal_113 = false;
        var currVal_114 = _co.document.Signature.Value;
        _ck(_v, 120, 0, currVal_112, currVal_113, currVal_114);
        var currVal_115 = _co.document.Signature;
        _ck(_v, 125, 0, currVal_115);
        var currVal_124 = '';
        _ck(_v, 132, 0, currVal_124);
        var currVal_125 = !_co.document.DeclarantDate.IsValid;
        var currVal_126 = 'text';
        var currVal_127 = 'Date';
        var currVal_128 = 'Date';
        var currVal_129 = false;
        var currVal_130 = core_es5["ɵnov"](_v, 3);
        var currVal_131 = 'MM/DD/YYYY';
        var currVal_132 = true;
        _ck(_v, 134, 0, currVal_125, currVal_126, currVal_127, currVal_128, currVal_129, currVal_130, currVal_131, currVal_132);
        var currVal_133 = 'Date';
        var currVal_134 = false;
        var currVal_135 = _co.document.DeclarantDate.Value;
        _ck(_v, 136, 0, currVal_133, currVal_134, currVal_135);
        var currVal_136 = _co.document.DeclarantDate;
        _ck(_v, 141, 0, currVal_136);
        var currVal_137 = ((core_es5["ɵnov"](_v, 134).model.hasError('required') && (!core_es5["ɵnov"](_v, 134).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.DeclarantDate.IsValid);
        _ck(_v, 144, 0, currVal_137);
        var currVal_146 = '';
        _ck(_v, 154, 0, currVal_146);
        var currVal_147 = !_co.document.BrokerInformation.IsValid;
        var currVal_148 = 'text';
        var currVal_149 = 'BrokerInformation';
        var currVal_150 = '42. Broker/Filer Information (Name, Address, Phone Number)';
        var currVal_151 = false;
        var currVal_152 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 156, 0, currVal_147, currVal_148, currVal_149, currVal_150, currVal_151, currVal_152);
        var currVal_153 = 'BrokerInformation';
        var currVal_154 = false;
        var currVal_155 = _co.document.BrokerInformation.Value;
        _ck(_v, 158, 0, currVal_153, currVal_154, currVal_155);
        var currVal_156 = _co.document.BrokerInformation;
        _ck(_v, 163, 0, currVal_156);
        var currVal_157 = ((core_es5["ɵnov"](_v, 156).model.hasError('required') && (!core_es5["ɵnov"](_v, 156).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.BrokerInformation.IsValid);
        _ck(_v, 166, 0, currVal_157);
        var currVal_166 = '';
        _ck(_v, 173, 0, currVal_166);
        var currVal_167 = !_co.document.BrokerFileNo.IsValid;
        var currVal_168 = 'text';
        var currVal_169 = 'BrokerFileNo';
        var currVal_170 = '43. Broker/importer file no.';
        var currVal_171 = false;
        var currVal_172 = core_es5["ɵnov"](_v, 3);
        _ck(_v, 175, 0, currVal_167, currVal_168, currVal_169, currVal_170, currVal_171, currVal_172);
        var currVal_173 = 'BrokerFileNo';
        var currVal_174 = false;
        var currVal_175 = _co.document.BrokerFileNo.Value;
        _ck(_v, 177, 0, currVal_173, currVal_174, currVal_175);
        var currVal_176 = _co.document.BrokerFileNo;
        _ck(_v, 182, 0, currVal_176);
        var currVal_177 = ((core_es5["ɵnov"](_v, 175).model.hasError('required') && (!core_es5["ɵnov"](_v, 175).model.pristine || core_es5["ɵnov"](_v, 3).submitted)) && _co.document.BrokerFileNo.IsValid);
        _ck(_v, 185, 0, currVal_177);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 5).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 5).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 5).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 5).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 5).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 5).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 5).ngClassPending;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_8 = core_es5["ɵnov"](_v, 32).ngClassUntouched;
        var currVal_9 = core_es5["ɵnov"](_v, 32).ngClassTouched;
        var currVal_10 = core_es5["ɵnov"](_v, 32).ngClassPristine;
        var currVal_11 = core_es5["ɵnov"](_v, 32).ngClassDirty;
        var currVal_12 = core_es5["ɵnov"](_v, 32).ngClassValid;
        var currVal_13 = core_es5["ɵnov"](_v, 32).ngClassInvalid;
        var currVal_14 = core_es5["ɵnov"](_v, 32).ngClassPending;
        _ck(_v, 27, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_20 = core_es5["ɵnov"](_v, 39).ngClassUntouched;
        var currVal_21 = core_es5["ɵnov"](_v, 39).ngClassTouched;
        var currVal_22 = core_es5["ɵnov"](_v, 39).ngClassPristine;
        var currVal_23 = core_es5["ɵnov"](_v, 39).ngClassDirty;
        var currVal_24 = core_es5["ɵnov"](_v, 39).ngClassValid;
        var currVal_25 = core_es5["ɵnov"](_v, 39).ngClassInvalid;
        var currVal_26 = core_es5["ɵnov"](_v, 39).ngClassPending;
        _ck(_v, 34, 0, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26);
        var currVal_34 = core_es5["ɵnov"](_v, 57).ngClassUntouched;
        var currVal_35 = core_es5["ɵnov"](_v, 57).ngClassTouched;
        var currVal_36 = core_es5["ɵnov"](_v, 57).ngClassPristine;
        var currVal_37 = core_es5["ɵnov"](_v, 57).ngClassDirty;
        var currVal_38 = core_es5["ɵnov"](_v, 57).ngClassValid;
        var currVal_39 = core_es5["ɵnov"](_v, 57).ngClassInvalid;
        var currVal_40 = core_es5["ɵnov"](_v, 57).ngClassPending;
        _ck(_v, 52, 0, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40);
        var currVal_46 = core_es5["ɵnov"](_v, 64).ngClassUntouched;
        var currVal_47 = core_es5["ɵnov"](_v, 64).ngClassTouched;
        var currVal_48 = core_es5["ɵnov"](_v, 64).ngClassPristine;
        var currVal_49 = core_es5["ɵnov"](_v, 64).ngClassDirty;
        var currVal_50 = core_es5["ɵnov"](_v, 64).ngClassValid;
        var currVal_51 = core_es5["ɵnov"](_v, 64).ngClassInvalid;
        var currVal_52 = core_es5["ɵnov"](_v, 64).ngClassPending;
        _ck(_v, 59, 0, currVal_46, currVal_47, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52);
        var currVal_59 = (core_es5["ɵnov"](_v, 80).required ? '' : null);
        var currVal_60 = core_es5["ɵnov"](_v, 86).ngClassUntouched;
        var currVal_61 = core_es5["ɵnov"](_v, 86).ngClassTouched;
        var currVal_62 = core_es5["ɵnov"](_v, 86).ngClassPristine;
        var currVal_63 = core_es5["ɵnov"](_v, 86).ngClassDirty;
        var currVal_64 = core_es5["ɵnov"](_v, 86).ngClassValid;
        var currVal_65 = core_es5["ɵnov"](_v, 86).ngClassInvalid;
        var currVal_66 = core_es5["ɵnov"](_v, 86).ngClassPending;
        _ck(_v, 79, 0, currVal_59, currVal_60, currVal_61, currVal_62, currVal_63, currVal_64, currVal_65, currVal_66);
        var currVal_79 = (core_es5["ɵnov"](_v, 99).required ? '' : null);
        var currVal_80 = core_es5["ɵnov"](_v, 105).ngClassUntouched;
        var currVal_81 = core_es5["ɵnov"](_v, 105).ngClassTouched;
        var currVal_82 = core_es5["ɵnov"](_v, 105).ngClassPristine;
        var currVal_83 = core_es5["ɵnov"](_v, 105).ngClassDirty;
        var currVal_84 = core_es5["ɵnov"](_v, 105).ngClassValid;
        var currVal_85 = core_es5["ɵnov"](_v, 105).ngClassInvalid;
        var currVal_86 = core_es5["ɵnov"](_v, 105).ngClassPending;
        _ck(_v, 98, 0, currVal_79, currVal_80, currVal_81, currVal_82, currVal_83, currVal_84, currVal_85, currVal_86);
        var currVal_99 = core_es5["ɵnov"](_v, 122).ngClassUntouched;
        var currVal_100 = core_es5["ɵnov"](_v, 122).ngClassTouched;
        var currVal_101 = core_es5["ɵnov"](_v, 122).ngClassPristine;
        var currVal_102 = core_es5["ɵnov"](_v, 122).ngClassDirty;
        var currVal_103 = core_es5["ɵnov"](_v, 122).ngClassValid;
        var currVal_104 = core_es5["ɵnov"](_v, 122).ngClassInvalid;
        var currVal_105 = core_es5["ɵnov"](_v, 122).ngClassPending;
        _ck(_v, 117, 0, currVal_99, currVal_100, currVal_101, currVal_102, currVal_103, currVal_104, currVal_105);
        var currVal_116 = (core_es5["ɵnov"](_v, 132).required ? '' : null);
        var currVal_117 = core_es5["ɵnov"](_v, 138).ngClassUntouched;
        var currVal_118 = core_es5["ɵnov"](_v, 138).ngClassTouched;
        var currVal_119 = core_es5["ɵnov"](_v, 138).ngClassPristine;
        var currVal_120 = core_es5["ɵnov"](_v, 138).ngClassDirty;
        var currVal_121 = core_es5["ɵnov"](_v, 138).ngClassValid;
        var currVal_122 = core_es5["ɵnov"](_v, 138).ngClassInvalid;
        var currVal_123 = core_es5["ɵnov"](_v, 138).ngClassPending;
        _ck(_v, 131, 0, currVal_116, currVal_117, currVal_118, currVal_119, currVal_120, currVal_121, currVal_122, currVal_123);
        var currVal_138 = (core_es5["ɵnov"](_v, 154).required ? '' : null);
        var currVal_139 = core_es5["ɵnov"](_v, 160).ngClassUntouched;
        var currVal_140 = core_es5["ɵnov"](_v, 160).ngClassTouched;
        var currVal_141 = core_es5["ɵnov"](_v, 160).ngClassPristine;
        var currVal_142 = core_es5["ɵnov"](_v, 160).ngClassDirty;
        var currVal_143 = core_es5["ɵnov"](_v, 160).ngClassValid;
        var currVal_144 = core_es5["ɵnov"](_v, 160).ngClassInvalid;
        var currVal_145 = core_es5["ɵnov"](_v, 160).ngClassPending;
        _ck(_v, 153, 0, currVal_138, currVal_139, currVal_140, currVal_141, currVal_142, currVal_143, currVal_144, currVal_145);
        var currVal_158 = (core_es5["ɵnov"](_v, 173).required ? '' : null);
        var currVal_159 = core_es5["ɵnov"](_v, 179).ngClassUntouched;
        var currVal_160 = core_es5["ɵnov"](_v, 179).ngClassTouched;
        var currVal_161 = core_es5["ɵnov"](_v, 179).ngClassPristine;
        var currVal_162 = core_es5["ɵnov"](_v, 179).ngClassDirty;
        var currVal_163 = core_es5["ɵnov"](_v, 179).ngClassValid;
        var currVal_164 = core_es5["ɵnov"](_v, 179).ngClassInvalid;
        var currVal_165 = core_es5["ɵnov"](_v, 179).ngClassPending;
        _ck(_v, 172, 0, currVal_158, currVal_159, currVal_160, currVal_161, currVal_162, currVal_163, currVal_164, currVal_165);
    });
}
function View_DeclarationBlock7501Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'declaration-block-7501', [], null, null, null, View_DeclarationBlock7501Component_0, RenderType_DeclarationBlock7501Component)), core_es5["ɵdid"](49152, null, 0, DeclarationBlock7501Component, [], null, null)], null, null);
}
var DeclarationBlock7501ComponentNgFactory = core_es5["ɵccf"]('declaration-block-7501', DeclarationBlock7501Component, View_DeclarationBlock7501Component_Host_0, { document: 'document' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=declaration-block-7501.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/objects/documents/CBP7501.ts



var CBP7501_CBP7501 = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](CBP7501, _super);
    function CBP7501() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.FilerCode = new DocumentProperty();
        _this.EntryType = new DocumentProperty();
        _this.SummaryDate = new DocumentProperty();
        _this.SuretyNo = new DocumentProperty();
        _this.BondType = new DocumentProperty();
        _this.PortCode = new DocumentProperty();
        _this.EntryDate = new DocumentProperty();
        _this.ImportingCarrier = new DocumentProperty();
        _this.ModeOfTransport = new DocumentProperty();
        _this.CountryOfOrigin = new DocumentProperty();
        _this.ImportDate = new DocumentProperty();
        _this.BillOfLading = new DocumentProperty();
        _this.ManufacturerID = new DocumentProperty();
        _this.ExportingCountry = new DocumentProperty();
        _this.ExportDate = new DocumentProperty();
        _this.ITNo = new DocumentProperty();
        _this.ITDate = new DocumentProperty();
        _this.MissingDocs = new DocumentProperty();
        _this.ForeignPortOfLading = new DocumentProperty();
        _this.USPortOfUnlading = new DocumentProperty();
        _this.LocationOfGoodsGONo = new DocumentProperty();
        _this.ConsigneeNo = new DocumentProperty();
        _this.ImporterNo = new DocumentProperty();
        _this.ReferenceNo = new DocumentProperty();
        _this.UltimateConsigneeNameAndAddress = new CBP7501_NameAndAddress();
        _this.ImporterOfRecordNameAndAddress = new CBP7501_NameAndAddress();
        _this.OtherFeeSummaryForBlock39 = new DocumentProperty();
        _this.TotalEnteredValue = new DocumentProperty();
        _this.TotalOtherFees = new DocumentProperty();
        //CBP use only
        _this.LIQCode = new DocumentProperty();
        _this.ReasonCode = new DocumentProperty();
        _this.AscertainedDuty = new DocumentProperty();
        _this.AscertainedTax = new DocumentProperty();
        _this.AscertainedOther = new DocumentProperty();
        _this.AscertainedTotal = new DocumentProperty();
        //Totals
        _this.Duty = new DocumentProperty();
        _this.Tax = new DocumentProperty();
        _this.Other = new DocumentProperty();
        _this.Total = new DocumentProperty();
        _this.DeclarationOfImporterOfRecord = new DocumentProperty();
        _this.DeclarationOfMerchandiseOfRecord = new DocumentProperty();
        _this.DeclarantName = new DocumentProperty();
        _this.Title = new DocumentProperty();
        _this.Signature = new DocumentProperty();
        _this.DeclarantDate = new DocumentProperty();
        _this.BrokerInformation = new DocumentProperty();
        _this.BrokerFileNo = new DocumentProperty();
        //Table
        _this.TableLineInputs = new Array();
        return _this;
    }
    return CBP7501;
}(baseEntity["a" /* BaseEntity */]));

var CBP7501_LineInputs = /** @class */ (function () {
    function LineInputs() {
        this.LineNumber = new DocumentProperty();
        this.HTSUSNo = new DocumentProperty();
        this.ADACVDNo = new DocumentProperty();
        this.Grossweight = new DocumentProperty();
        this.ManifestQty = new DocumentProperty();
        this.NetQuantityInHTSUSUnits = new DocumentProperty();
        this.EnteredValue = new DocumentProperty();
        this.CHGS = new DocumentProperty();
        this.Relationship = new DocumentProperty();
        this.HTSUSRate = new DocumentProperty();
        this.ADACVDRate = new DocumentProperty();
        this.IRCRate = new DocumentProperty();
        this.VisaNo = new DocumentProperty();
        this.Dollars = new DocumentProperty();
        this.Cents = new DocumentProperty();
    }
    return LineInputs;
}());

var CBP7501_NameAndAddress = /** @class */ (function () {
    function NameAndAddress() {
        this.Name = new DocumentProperty();
        this.City = new DocumentProperty();
        this.State = new DocumentProperty();
        this.Zip = new DocumentProperty();
    }
    return NameAndAddress;
}());

//# sourceMappingURL=CBP7501.js.map
// CONCATENATED MODULE: ./app/components/export-documents/cbp-7501/document-7501.component.ts






var document_7501_component_Document7501Component = /** @class */ (function () {
    function Document7501Component(documentService) {
        this.documentService = documentService;
        this.documentModified = new core_es5["EventEmitter"]();
        this.processing = false;
        this.document = new CBP7501_CBP7501();
        this.isFormSubmitted = false;
    }
    Document7501Component.prototype.onScroll = function (scrollY) {
        scrollHelper_ScrollHelper.stickyElementOnScroll(scrollY, [this.saveBtn.nativeElement, this.closeBtn.nativeElement], 150);
    };
    ;
    Document7501Component.prototype.show = function (document) {
        if (document === void 0) { document = new CBP7501_CBP7501(); }
        this.document = document;
        if (this.document.TableLineInputs.length == 0 || this.document.TableLineInputs == null)
            this.document.TableLineInputs.push(new CBP7501_LineInputs());
        this.documentModal.show();
    };
    Document7501Component.prototype.isDocumentValid = function () {
        if (!this.firstBlock7501Component || !this.tableBlock7501Component ||
            !this.thirdBlock7501Component || !this.declarationBlock7501Component) {
            return false;
        }
        return (this.firstBlock7501Component.isFormValid() && this.tableBlock7501Component.isFormValid() &&
            this.thirdBlock7501Component.isFormValid() && this.declarationBlock7501Component.isFormValid());
    };
    Document7501Component.prototype.closeDocumentModal = function (hideModal) {
        this.firstBlock7501Component.firstBlockForm.resetForm();
        this.tableBlock7501Component.tableBlockForm.resetForm();
        this.thirdBlock7501Component.thirdBlockForm.resetForm();
        this.declarationBlock7501Component.declarationForm.resetForm();
        this.isFormSubmitted = false;
        if (hideModal)
            this.documentModal.hide();
    };
    Document7501Component.prototype.save = function () {
        var _this = this;
        this.firstBlock7501Component.submitFormAndValidity();
        this.tableBlock7501Component.submitFormAndValidity();
        this.thirdBlock7501Component.submitFormAndValidity();
        this.declarationBlock7501Component.submitFormAndValidity();
        if (!this.isDocumentValid()) {
            this.isFormSubmitted = true;
            return;
        }
        this.document.OrderId = this.order.Id;
        this.document.Name = 'CBP7501';
        this.documentService.save(this.document, 'CBP7501').then(function (resp) {
            _this.document = resp.Data;
            var isValid = PropertyHelper.isPropsValid(resp.Data);
            for (var _i = 0, _a = _this.document.TableLineInputs; _i < _a.length; _i++) {
                var table = _a[_i];
                if (!PropertyHelper.isPropsValid(table)) {
                    isValid = false;
                    break;
                }
            }
            if (isValid) {
                _this.documentModified.emit(resp);
                _this.closeDocumentModal(true);
            }
        });
    };
    Document7501Component.prototype.ngOnInit = function () {
        perfect_scrollbar["initialize"](this.documentModalRef.nativeElement);
    };
    Document7501Component.ctorParameters = function () { return [{ type: documentService_DocumentService }]; };
    return Document7501Component;
}());

//# sourceMappingURL=document-7501.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/export-documents/cbp-7501/document-7501.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
















var styles_Document7501Component = [];
var RenderType_Document7501Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_Document7501Component, data: {} });
function View_Document7501Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 23, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'form', [['class', 'form-horizontal'], ['novalidate', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'submit'],
            [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 4).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[2, 4], ['documentForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'first-block-7501', [], null, [[null, 'documentChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('documentChange' === en)) {
                    var pd_0 = ((_co.document = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_FirstBlock7501Component_0, RenderType_FirstBlock7501Component)),
        core_es5["ɵdid"](49152, [[4, 4]], 0, first_block_7501_component_FirstBlock7501Component, [], { document: [0,
                'document'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'table-block-7501', [], null, [[null, 'documentChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('documentChange' === en)) {
                    var pd_0 = ((_co.document = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_TableBlock7501Component_0, RenderType_TableBlock7501Component)),
        core_es5["ɵdid"](49152, [[5, 4]], 0, table_block_7501_component_TableBlock7501Component, [], { document: [0,
                'document'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'third-block-7501', [], null, [[null, 'documentChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('documentChange' === en)) {
                    var pd_0 = ((_co.document = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_ThirdBlock7501Component_0, RenderType_ThirdBlock7501Component)),
        core_es5["ɵdid"](49152, [[6, 4]], 0, third_block_7501_component_ThirdBlock7501Component, [], { document: [0,
                'document'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'declaration-block-7501', [], null, [[null, 'documentChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('documentChange' === en)) {
                    var pd_0 = ((_co.document = $event) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_DeclarationBlock7501Component_0, RenderType_DeclarationBlock7501Component)),
        core_es5["ɵdid"](49152, [[7, 4]], 0, DeclarationBlock7501Component, [], { document: [0,
                'document'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.document;
        _ck(_v, 11, 0, currVal_7);
        var currVal_8 = _co.document;
        _ck(_v, 14, 0, currVal_8);
        var currVal_9 = _co.document;
        _ck(_v, 17, 0, currVal_9);
        var currVal_10 = _co.document;
        _ck(_v, 20, 0, currVal_10);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 6).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 6).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 6).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 6).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 6).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 6).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 6).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_Document7501Component_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { documentModal: 0 }), core_es5["ɵqud"](671088640, 2, { documentForm: 0 }),
        core_es5["ɵqud"](402653184, 3, { documentModalRef: 0 }), core_es5["ɵqud"](671088640, 4, { firstBlock7501Component: 0 }),
        core_es5["ɵqud"](671088640, 5, { tableBlock7501Component: 0 }), core_es5["ɵqud"](671088640, 6, { thirdBlock7501Component: 0 }),
        core_es5["ɵqud"](671088640, 7, { declarationBlock7501Component: 0 }), core_es5["ɵqud"](402653184, 8, { saveBtn: 0 }),
        core_es5["ɵqud"](402653184, 9, { closeBtn: 0 }), (_l()(), core_es5["ɵeld"](16777216, [[3, 0], ['documentModalRef',
                1]], null, 39, 'div', [['bsModal', ''], ['class', 'modal document document-7501 fade customer-modal'],
            ['id', 'myModal'], ['role', 'dialog']], null, [[null, 'onHide'],
            [null, 'scroll'], [null, 'click'], [null, 'keydown.esc']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 10).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown.esc' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 10).onEsc() !== false);
                ad = (pd_1 && ad);
            }
            if (('onHide' === en)) {
                var pd_2 = (_co.closeDocumentModal(false) !== false);
                ad = (pd_2 && ad);
            }
            if (('scroll' === en)) {
                var pd_3 = (_co.onScroll($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4341760, [[1, 4], ['documentModal',
                4]], 0, modal_component["a" /* ModalDirective */], [core_es5["ElementRef"], core_es5["ViewContainerRef"], core_es5["Renderer"],
            component_loader_factory["a" /* ComponentLoaderFactory */]], { config: [0, 'config'] }, { onHide: 'onHide' }), core_es5["ɵpod"]({ keyboard: 0,
            backdrop: 1 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 34, 'div', [['class', 'modal-dialog modal-lg'], ['role', 'document']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 31, 'div', [['class', 'modal-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'modal-header header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'modal-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['CBP 7501 ENTRY SUMMARY'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, [[9, 0], ['closeBtn', 1]], null, 4, 'button', [['aria-label',
                'Close'], ['class', 'close pull-right btn btn-round btn-white modal-close-btn'],
            ['data-dismiss', 'modal'], ['type', 'button']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.closeDocumentModal(true) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons modal-close-icon']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['close'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, [[8, 0], ['saveBtn', 1]], null, 7, 'button', [['class', 'save pull-right btn btn-round btn-white-orange padding-0'],
            ['type', 'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.save() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'disabled': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons modal-close-icon']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['save'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'modal-body']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_Document7501Component_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 11, 0, false, 'static');
        _ck(_v, 10, 0, currVal_0);
        var currVal_2 = 'save pull-right btn btn-round btn-white-orange padding-0';
        var currVal_3 = _ck(_v, 31, 0, (_co.isFormSubmitted && !_co.isDocumentValid()));
        _ck(_v, 30, 0, currVal_2, currVal_3);
        var currVal_4 = core_es5["ɵnov"](_v, 10).isShown;
        _ck(_v, 43, 0, currVal_4);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = (_co.isFormSubmitted && !_co.isDocumentValid());
        _ck(_v, 29, 0, currVal_1);
    });
}
function View_Document7501Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'document-7501', [], null, null, null, View_Document7501Component_0, RenderType_Document7501Component)), core_es5["ɵdid"](114688, null, 0, document_7501_component_Document7501Component, [documentService_DocumentService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var Document7501ComponentNgFactory = core_es5["ɵccf"]('document-7501', document_7501_component_Document7501Component, View_Document7501Component_Host_0, { order: 'order' }, { documentModified: 'documentModified' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=document-7501.component.ngfactory.js.map
// CONCATENATED MODULE: ./node_modules/ngx-uploader/src/ngx-uploader/classes/ngx-uploader.class.ts







var ngx_uploader_class_UploadStatus;
(function (UploadStatus) {
    UploadStatus[UploadStatus["Queue"] = 0] = "Queue";
    UploadStatus[UploadStatus["Uploading"] = 1] = "Uploading";
    UploadStatus[UploadStatus["Done"] = 2] = "Done";
    UploadStatus[UploadStatus["Cancelled"] = 3] = "Cancelled";
})(ngx_uploader_class_UploadStatus || (ngx_uploader_class_UploadStatus = {}));
function ngx_uploader_class_humanizeBytes(bytes) {
    if (bytes === 0) {
        return '0 Byte';
    }
    var k = 1024;
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}
var classes_ngx_uploader_class_NgUploaderService = /** @class */ (function () {
    function NgUploaderService(concurrency) {
        if (concurrency === void 0) { concurrency = Number.POSITIVE_INFINITY; }
        var _this = this;
        this.queue = [];
        this.serviceEvents = new core_es5["EventEmitter"]();
        this.uploadScheduler = new Subject["Subject"]();
        this.subs = [];
        this.uploadScheduler
            .mergeMap(function (upload) { return _this.startUpload(upload); }, concurrency)
            .subscribe(function (uploadOutput) { return _this.serviceEvents.emit(uploadOutput); });
    }
    NgUploaderService.prototype.handleFiles = function (incomingFiles) {
        var _this = this;
        (_a = this.queue).push.apply(_a, [].map.call(incomingFiles, function (file, i) {
            var uploadFile = {
                fileIndex: i,
                id: _this.generateId(),
                name: file.name,
                size: file.size,
                type: file.type,
                form: new FormData(),
                progress: {
                    status: ngx_uploader_class_UploadStatus.Queue,
                    data: {
                        percentage: 0,
                        speed: 0,
                        speedHuman: ngx_uploader_class_humanizeBytes(0) + "/s",
                        startTime: null,
                        endTime: null,
                        eta: null,
                        etaHuman: null
                    }
                },
                lastModifiedDate: file.lastModifiedDate,
                sub: undefined,
                nativeFile: file
            };
            _this.serviceEvents.emit({ type: 'addedToQueue', file: uploadFile });
            return uploadFile;
        }));
        this.serviceEvents.emit({ type: 'allAddedToQueue' });
        var _a;
    };
    NgUploaderService.prototype.initInputEvents = function (input) {
        var _this = this;
        input.subscribe(function (event) {
            switch (event.type) {
                case 'uploadFile':
                    var uploadFileIndex = _this.queue.findIndex(function (file) { return file === event.file; });
                    if (uploadFileIndex !== -1 && event.file) {
                        _this.uploadScheduler.next({ file: _this.queue[uploadFileIndex], event: event });
                    }
                    break;
                case 'uploadAll':
                    var files = _this.queue.filter(function (file) { return file.progress.status === ngx_uploader_class_UploadStatus.Queue; });
                    files.forEach(function (file) { return _this.uploadScheduler.next({ file: file, event: event }); });
                    break;
                case 'cancel':
                    var id_1 = event.id || null;
                    if (!id_1) {
                        return;
                    }
                    var index = _this.subs.findIndex(function (sub) { return sub.id === id_1; });
                    if (index !== -1 && _this.subs[index].sub) {
                        _this.subs[index].sub.unsubscribe();
                        var fileIndex = _this.queue.findIndex(function (file) { return file.id === id_1; });
                        if (fileIndex !== -1) {
                            _this.queue[fileIndex].progress.status = ngx_uploader_class_UploadStatus.Cancelled;
                            _this.serviceEvents.emit({ type: 'cancelled', file: _this.queue[fileIndex] });
                        }
                    }
                    break;
                case 'cancelAll':
                    _this.subs.forEach(function (sub) {
                        if (sub.sub) {
                            sub.sub.unsubscribe();
                        }
                        var file = _this.queue.find(function (uploadFile) { return uploadFile.id === sub.id; });
                        if (file) {
                            file.progress.status = ngx_uploader_class_UploadStatus.Cancelled;
                            _this.serviceEvents.emit({ type: 'cancelled', file: file });
                        }
                    });
                    break;
                case 'remove':
                    if (!event.id) {
                        return;
                    }
                    var i = _this.queue.findIndex(function (file) { return file.id === event.id; });
                    if (i !== -1) {
                        var file = _this.queue[i];
                        _this.queue.splice(i, 1);
                        _this.serviceEvents.emit({ type: 'removed', file: file });
                    }
                    break;
                case 'removeAll':
                    if (_this.queue.length) {
                        _this.queue = [];
                        _this.serviceEvents.emit({ type: 'removedAll' });
                    }
                    break;
            }
        });
    };
    NgUploaderService.prototype.startUpload = function (upload) {
        var _this = this;
        return new Observable["Observable"](function (observer) {
            var sub = _this.uploadFile(upload.file, upload.event)
                .subscribe(function (output) {
                observer.next(output);
            }, function (err) {
                observer.error(err);
                observer.complete();
            }, function () {
                observer.complete();
            });
            _this.subs.push({ id: upload.file.id, sub: sub });
        });
    };
    NgUploaderService.prototype.uploadFile = function (file, event) {
        var _this = this;
        return new Observable["Observable"](function (observer) {
            var url = event.url || '';
            var method = event.method || 'POST';
            var data = event.data || {};
            var headers = event.headers || {};
            var reader = new FileReader();
            var xhr = new XMLHttpRequest();
            var time = new Date().getTime();
            var progressStartTime = (file.progress.data && file.progress.data.startTime) || time;
            var speed = 0;
            var eta = null;
            xhr.upload.addEventListener('progress', function (e) {
                if (e.lengthComputable) {
                    var percentage = Math.round((e.loaded * 100) / e.total);
                    var diff = new Date().getTime() - time;
                    speed = Math.round(e.loaded / diff * 1000);
                    progressStartTime = (file.progress.data && file.progress.data.startTime) || new Date().getTime();
                    eta = Math.ceil((e.total - e.loaded) / speed);
                    file.progress = {
                        status: ngx_uploader_class_UploadStatus.Uploading,
                        data: {
                            percentage: percentage,
                            speed: speed,
                            speedHuman: ngx_uploader_class_humanizeBytes(speed) + "/s",
                            startTime: progressStartTime,
                            endTime: null,
                            eta: eta,
                            etaHuman: _this.secondsToHuman(eta)
                        }
                    };
                    observer.next({ type: 'uploading', file: file });
                }
            }, false);
            xhr.upload.addEventListener('error', function (e) {
                observer.error(e);
                observer.complete();
            });
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    var speedAverage = Math.round(file.size / (new Date().getTime() - progressStartTime) * 1000);
                    file.progress = {
                        status: ngx_uploader_class_UploadStatus.Done,
                        data: {
                            percentage: 100,
                            speed: speedAverage,
                            speedHuman: ngx_uploader_class_humanizeBytes(speedAverage) + "/s",
                            startTime: progressStartTime,
                            endTime: new Date().getTime(),
                            eta: eta,
                            etaHuman: _this.secondsToHuman(eta || 0)
                        }
                    };
                    file.responseStatus = xhr.status;
                    try {
                        file.response = JSON.parse(xhr.response);
                    }
                    catch (e) {
                        file.response = xhr.response;
                    }
                    observer.next({ type: 'done', file: file });
                    observer.complete();
                }
            };
            xhr.open(method, url, true);
            xhr.withCredentials = event.withCredentials ? true : false;
            try {
                var uploadFile_1 = file.nativeFile;
                var uploadIndex = _this.queue.findIndex(function (file) { return file.nativeFile === uploadFile_1; });
                if (_this.queue[uploadIndex].progress.status === ngx_uploader_class_UploadStatus.Cancelled) {
                    observer.complete();
                }
                file.form.append(event.fieldName || 'file', uploadFile_1, uploadFile_1.name);
                Object.keys(data).forEach(function (key) { return file.form.append(key, data[key]); });
                Object.keys(headers).forEach(function (key) { return xhr.setRequestHeader(key, headers[key]); });
                _this.serviceEvents.emit({ type: 'start', file: file });
                xhr.send(file.form);
            }
            catch (e) {
                observer.complete();
            }
            return function () {
                xhr.abort();
                reader.abort();
            };
        });
    };
    NgUploaderService.prototype.secondsToHuman = function (sec) {
        return new Date(sec * 1000).toISOString().substr(11, 8);
    };
    NgUploaderService.prototype.generateId = function () {
        return Math.random().toString(36).substring(7);
    };
    return NgUploaderService;
}());

//# sourceMappingURL=ngx-uploader.class.js.map
// CONCATENATED MODULE: ./node_modules/ngx-uploader/src/ngx-uploader/directives/ng-file-select.directive.ts


var directives_ng_file_select_directive_NgFileSelectDirective = /** @class */ (function () {
    function NgFileSelectDirective(elementRef) {
        var _this = this;
        this.elementRef = elementRef;
        this.fileListener = function () {
            if (_this.el.files) {
                _this.upload.handleFiles(_this.el.files);
            }
        };
        this.uploadOutput = new core_es5["EventEmitter"]();
    }
    NgFileSelectDirective.prototype.ngOnInit = function () {
        var _this = this;
        var concurrency = this.options && this.options.concurrency || Number.POSITIVE_INFINITY;
        this.upload = new classes_ngx_uploader_class_NgUploaderService(concurrency);
        this.el = this.elementRef.nativeElement;
        this.el.addEventListener('change', this.fileListener, false);
        this.upload.serviceEvents.subscribe(function (event) {
            _this.uploadOutput.emit(event);
        });
        if (this.uploadInput instanceof core_es5["EventEmitter"]) {
            this.upload.initInputEvents(this.uploadInput);
        }
    };
    NgFileSelectDirective.prototype.ngOnDestroy = function () {
        this.el.removeEventListener('change', this.fileListener, false);
        if (this.uploadInput) {
            this.uploadInput.unsubscribe();
        }
    };
    NgFileSelectDirective.ctorParameters = function () { return [{ type: core_es5["ElementRef"] }]; };
    return NgFileSelectDirective;
}());

//# sourceMappingURL=ng-file-select.directive.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/orderManagement/orderData/tabs/advancedDocSelector.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
























var styles_AdvancedDocSelectorComponent = [];
var RenderType_AdvancedDocSelectorComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AdvancedDocSelectorComponent, data: {} });
function View_AdvancedDocSelectorComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class',
                'spinner-circle opacity-background'], ['id', 'spinner']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, ':svg:svg', [['class', 'spinner-circular'],
            ['viewBox', '25 25 50 50']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, ':svg:circle', [['class', 'path'], ['cx', '50'],
            ['cy', '50'], ['fill', 'none'], ['r', '20'], ['stroke-miterlimit', '10'], ['stroke-width',
                '2']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_AdvancedDocSelectorComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, 'ul', [['aria-labelledby',
                'basic-link'], ['class', 'dropdown-menu'], ['id', 'dropdown-basic'], ['role', 'menu']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v.parent, 8).show() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['CBP 7501'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v.parent, 5).show() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['CBP 3461'])),
        (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_AdvancedDocSelectorComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'margin-left-5']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.Data.Data.Data.toString();
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_AdvancedDocSelectorComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.Data.Data.Data.toString().substring(37);
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_AdvancedDocSelectorComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 6, 'button', [['class',
                'margin-auto margin-top-0 margin-bottom-0 btn-just-icon btn-white btn btn-no-styles']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.showDocument(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'disabled': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['edit']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'margin-auto margin-top-0 margin-bottom-0 btn-just-icon btn-white btn btn-no-styles';
        var currVal_2 = _ck(_v, 2, 0, !(_co.tabNumber >= _co.order.Status));
        _ck(_v, 1, 0, currVal_1, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !(_co.tabNumber >= _co.order.Status);
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_AdvancedDocSelectorComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, 'button', [['class',
                'margin-auto margin-top-0 margin-bottom-0 btn-just-icon btn-white btn btn-no-styles']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.delete(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'disabled': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['delete'])),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'margin-auto margin-top-0 margin-bottom-0 btn-just-icon btn-white btn btn-no-styles';
        var currVal_2 = _ck(_v, 2, 0, !(_co.tabNumber >= _co.order.Status));
        _ck(_v, 1, 0, currVal_1, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !(_co.tabNumber >= _co.order.Status);
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_AdvancedDocSelectorComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 38, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 35, 'li', [['class', 'row row-doc margin-bottom-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'div', [['class',
                'col-xs-7 display-flex']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'checkbox', [['class', 'doc-check']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_v.context.$implicit.IsSelected = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AdvancedDocSelectorComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AdvancedDocSelectorComponent_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-2 display-flex']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'width-100-pct'], ['style',
                'display:none']], [[8, 'hidden', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Status '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-1 display-flex']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AdvancedDocSelectorComponent_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-2 display-flex padding-right-0']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AdvancedDocSelectorComponent_7)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _v.context.$implicit.Data.Data.Data;
        _ck(_v, 7, 0, currVal_7);
        var currVal_8 = _v.context.$implicit.Data.Data.Data;
        var currVal_9 = _v.context.$implicit.IsSelected;
        _ck(_v, 9, 0, currVal_8, currVal_9);
        var currVal_10 = (_v.context.$implicit.Data.Data.Type != _co.orderDataType.File);
        _ck(_v, 14, 0, currVal_10);
        var currVal_11 = _co.orderDataType.File;
        _ck(_v, 17, 0, currVal_11);
        var currVal_13 = (_v.context.$implicit.Data.Data.Type !== _co.orderDataType.File);
        _ck(_v, 29, 0, currVal_13);
        var currVal_14 = ((_v.context.$implicit.Data.Data.Status > 0) || (_v.context.$implicit.Data.Data.Type == _co.orderDataType.File));
        _ck(_v, 35, 0, currVal_14);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 11).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 11).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 11).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 11).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 11).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 11).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 11).ngClassPending;
        _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_12 = !_v.context.$implicit.Data.Data.Status;
        _ck(_v, 22, 0, currVal_12);
    });
}
function View_AdvancedDocSelectorComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { docSelectorRef: 0 }), core_es5["ɵqud"](402653184, 2, { dropdownDirective: 0 }),
        core_es5["ɵqud"](402653184, 3, { doc3461ModalDir: 0 }), core_es5["ɵqud"](402653184, 4, { doc7501ModalDir: 0 }),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'document-3461', [], null, [[null, 'documentModified']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('documentModified' === en)) {
                var pd_0 = (_co.handleDocModified($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_Document3461Component_0, RenderType_Document3461Component)),
        core_es5["ɵdid"](114688, [[3, 4], ['doc3461Modal', 4]], 0, document_3461_component_Document3461Component, [documentService_DocumentService], { order: [0, 'order'] }, { documentModified: 'documentModified' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'document-7501', [], null, [[null, 'documentModified']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('documentModified' === en)) {
                var pd_0 = (_co.handleDoc7501Modified($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_Document7501Component_0, RenderType_Document7501Component)),
        core_es5["ɵdid"](114688, [[4, 4], ['doc7501Modal', 4]], 0, document_7501_component_Document7501Component, [documentService_DocumentService], { order: [0, 'order'] }, { documentModified: 'documentModified' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 87, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 84, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_AdvancedDocSelectorComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 78, 'div', [['class', 'card']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 66, 'div', [['class',
                'card-header header card-header-text width-100-pct margin-left-0'], ['data-background-color',
                '#E07E3C']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 63, 'div', [['class', 'row display-flex flex-items-center margin-right-0']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'margin-right-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'brand bold']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Documents'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'margin-left-auto']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class',
                'new-document-dropdown text-center']], null, [[null, 'clickOutside'],
            ['document', 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('document:click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 32).onDocumentClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('clickOutside' === en)) {
                var pd_1 = (_co.dropdownDirective.hide() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, click_outside_directive_ClickOutsideDirective, [core_es5["ElementRef"]], null, { clickOutside: 'clickOutside' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](16777216, null, null, 18, 'div', [['class',
                'bs-dropdown'], ['dropdown', '']], [[2, 'dropup', null], [2, 'open', null],
            [2, 'show', null]], null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'disabled': 0 }), core_es5["ɵprd"](512, null, bs_dropdown_state["a" /* BsDropdownState */], bs_dropdown_state["a" /* BsDropdownState */], []), core_es5["ɵdid"](212992, [[2, 4], ['dropdownRef', 4]], 0, bs_dropdown_directive["a" /* BsDropdownDirective */], [core_es5["ElementRef"], core_es5["Renderer"], core_es5["ViewContainerRef"], component_loader_factory["a" /* ComponentLoaderFactory */],
            bs_dropdown_config["a" /* BsDropdownConfig */], bs_dropdown_state["a" /* BsDropdownState */]], { autoClose: [0, 'autoClose'],
            isDisabled: [1, 'isDisabled'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'a', [['aria-controls',
                'dropdown-basic'], ['dropdownToggle', ''], ['role', 'button']], [[1, 'aria-haspopup',
                0], [1, 'disabled', 0], [1, 'aria-expanded', 0]], [[null, 'click'], ['document',
                'click'], [null, 'keyup.esc']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 41).onClick() !== false);
                ad = (pd_0 && ad);
            }
            if (('document:click' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 41).onDocumentClick($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('keyup.esc' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 41).onEsc() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](147456, null, 0, bs_dropdown_toggle_directive["a" /* BsDropdownToggleDirective */], [bs_dropdown_state["a" /* BsDropdownState */], core_es5["ElementRef"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'text-gray']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' New document '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons text-gray']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AdvancedDocSelectorComponent_2)), core_es5["ɵdid"](16384, null, 0, bs_dropdown_menu_directive["a" /* BsDropdownMenuDirective */], [bs_dropdown_state["a" /* BsDropdownState */], core_es5["ViewContainerRef"], core_es5["TemplateRef"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 27, 'div', [['class', 'margin-left-10']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 24, 'div', [['class', 'pull-right']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 12, 'label', [['class', 'upload-button btn btn-white btn-round btn-just-icon']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'disabled': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"],
            core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'input', [['ngFileSelect',
                ''], ['style', 'display:none'], ['type', 'file']], [[8, 'disabled', 0]], [[null,
                'uploadOutput']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('uploadOutput' === en)) {
                var pd_0 = (_co.onUploadOutput($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, directives_ng_file_select_directive_NgFileSelectDirective, [core_es5["ElementRef"]], { options: [0, 'options'], uploadInput: [1, 'uploadInput'] }, { uploadOutput: 'uploadOutput' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'ripple-container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['publish'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'label', [['class', 'upload-button btn btn-white btn-round btn-just-icon']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.downloadSelectedFiles() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'disabled': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons fa-rotate-180']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['publish'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, [[1, 0], ['docSelector',
                1]], null, 7, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [['class', 'file-selector']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AdvancedDocSelectorComponent_3)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, null, null, null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 18, 'div', [['class', 'row margin-0']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'display-inline-block margin-left-15']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'checkbox', [], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.isSelectAll = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](4243456, null, 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { label: [0, 'label'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'display-inline-block pull-right']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class',
                'btn btn-round btn-dark-orange btn-wide complete-button margin-top-10 padding-left-0 padding-right-0']], [[8, 'disabled', 0]], null, null, null, null)),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order;
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = _co.order;
        _ck(_v, 8, 0, currVal_1);
        var currVal_2 = _co.isFileUploading;
        _ck(_v, 15, 0, currVal_2);
        var currVal_6 = 'bs-dropdown';
        var currVal_7 = _ck(_v, 36, 0, !(_co.tabNumber >= _co.order.Status));
        _ck(_v, 35, 0, currVal_6, currVal_7);
        var currVal_8 = false;
        var currVal_9 = !(_co.tabNumber >= _co.order.Status);
        _ck(_v, 38, 0, currVal_8, currVal_9);
        var currVal_13 = 'upload-button btn btn-white btn-round btn-just-icon';
        var currVal_14 = _ck(_v, 62, 0, ((_co.isFileUploading == true) || !(_co.tabNumber >= _co.order.Status)));
        _ck(_v, 61, 0, currVal_13, currVal_14);
        var currVal_16 = _co.options;
        var currVal_17 = _co.uploadInput;
        _ck(_v, 66, 0, currVal_16, currVal_17);
        var currVal_18 = 'upload-button btn btn-white btn-round btn-just-icon';
        var currVal_19 = _ck(_v, 76, 0, (!_co.IsAnySelect == true));
        _ck(_v, 75, 0, currVal_18, currVal_19);
        var currVal_20 = _co.docs;
        _ck(_v, 92, 0, currVal_20);
        var currVal_28 = 'Select all documents';
        _ck(_v, 106, 0, currVal_28);
        var currVal_29 = _co.isSelectAll;
        _ck(_v, 108, 0, currVal_29);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = core_es5["ɵnov"](_v, 38).dropup;
        var currVal_4 = core_es5["ɵnov"](_v, 38).isOpen;
        var currVal_5 = (core_es5["ɵnov"](_v, 38).isOpen && core_es5["ɵnov"](_v, 38).isBs4);
        _ck(_v, 34, 0, currVal_3, currVal_4, currVal_5);
        var currVal_10 = true;
        var currVal_11 = core_es5["ɵnov"](_v, 41).isDisabled;
        var currVal_12 = core_es5["ɵnov"](_v, 41).isOpen;
        _ck(_v, 40, 0, currVal_10, currVal_11, currVal_12);
        var currVal_15 = (_co.isFileUploading || !(_co.tabNumber >= _co.order.Status));
        _ck(_v, 65, 0, currVal_15);
        var currVal_21 = core_es5["ɵnov"](_v, 110).ngClassUntouched;
        var currVal_22 = core_es5["ɵnov"](_v, 110).ngClassTouched;
        var currVal_23 = core_es5["ɵnov"](_v, 110).ngClassPristine;
        var currVal_24 = core_es5["ɵnov"](_v, 110).ngClassDirty;
        var currVal_25 = core_es5["ɵnov"](_v, 110).ngClassValid;
        var currVal_26 = core_es5["ɵnov"](_v, 110).ngClassInvalid;
        var currVal_27 = core_es5["ɵnov"](_v, 110).ngClassPending;
        _ck(_v, 105, 0, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27);
        var currVal_30 = true;
        _ck(_v, 115, 0, currVal_30);
        var currVal_31 = 'Send documents';
        _ck(_v, 117, 0, currVal_31);
    });
}
function View_AdvancedDocSelectorComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'advanced-doc-selector', [], null, null, null, View_AdvancedDocSelectorComponent_0, RenderType_AdvancedDocSelectorComponent)), core_es5["ɵdid"](638976, null, 0, advancedDocSelector_component_AdvancedDocSelectorComponent, [services_configService["a" /* ConfigService */], uploadService_UploadService, toast_manager["ToastsManager"], orderContentService_OrderContentService,
            documentService_DocumentService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AdvancedDocSelectorComponentNgFactory = core_es5["ɵccf"]('advanced-doc-selector', advancedDocSelector_component_AdvancedDocSelectorComponent, View_AdvancedDocSelectorComponent_Host_0, { order: 'order',
    tabNumber: 'tabNumber', documents3461: 'documents3461', documents7501: 'documents7501' }, { completeOrderEvent: 'completeOrderEvent' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=advancedDocSelector.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/Managment/orderManagement/orderData/tabs/docSelector.component.ts









/**
 * Created by alex.y on 10/2/2017.
 */
var docSelector_component_DocSelectorComponent = /** @class */ (function () {
    /*file uploader options end*/
    function DocSelectorComponent(configService, uploadService, toastrService) {
        this.configService = configService;
        this.uploadService = uploadService;
        this.toastrService = toastrService;
        this.completeOrderEvent = new core_es5["EventEmitter"]();
        this.orderStatus = orders_orderStatus["a" /* OrderStatus */];
        this.docs = [];
        this.uploadInput = new core_es5["EventEmitter"]();
        this.isFileUploading = false;
        this.files = []; // local uploading files array
        this.uploadInput = new core_es5["EventEmitter"](); // input events, we use this to emit data to ngx-uploader
        this.humanizeBytes = humanizeBytes;
    }
    DocSelectorComponent.prototype.ngOnInit = function () {
        this.getDocs();
        perfect_scrollbar["initialize"](this.docSelectorRef.nativeElement);
    };
    DocSelectorComponent.prototype.ngOnChanges = function () {
        this.getDocs();
    };
    DocSelectorComponent.prototype.getDocs = function () {
        this.docs = [];
        for (var _i = 0, _a = this.order.DataList; _i < _a.length; _i++) {
            var orderData = _a[_i];
            if (orderData.Data.Type == OrderDataType.File && (orderData.OrderStatus == this.tabNumber))
                this.docs.push(orderData.Data.Data);
        }
    };
    DocSelectorComponent.prototype.startUpload = function () {
        if (this.files.length == 0 || !this.files[0].name || this.files[0].size > 4000000)
            return;
        this.files = this.files.filter(function (file) { return file.size <= 4000000; });
        this.isFileUploading = true;
        var cookie = ng2_cookies["Cookie"].get(this.configService.config.ApiTokenCookieName);
        var event = {
            type: 'uploadFile',
            url: this.configService.config.ApiUrl + "/upload?orderId=" + this.order.Id + "&orderstatus=" + this.order.Status,
            method: 'POST',
            fieldName: "file",
            file: this.files[0],
            data: { 'name': this.files[0].name },
            headers: { Authorization: "Bearer " + cookie }
        };
        this.files = [];
        this.uploadInput.emit(event);
    };
    DocSelectorComponent.prototype.onUploadOutput = function (output) {
        if (output.type === 'allAddedToQueue') {
            this.startUpload();
        }
        else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') {
            if (output.file.size > 4000000) {
                this.toastrService.error('size must be less than 4 mb', null, { preventDuplicates: true });
                this.files = [];
            }
            else
                this.files.push(output.file);
        }
        else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
            // update current data in files array for uploading file
            var index = this.files.findIndex(function (file) { return typeof output.file !== 'undefined' && file.id === output.file.id; });
            this.files[index] = output.file;
        }
        else if (output.type === 'removed') {
            // remove file from array when removed
            this.files = this.files.filter(function (file) { return file !== output.file; });
        }
        else if (output.type === 'dragOver') {
            this.dragOver = true;
        }
        else if (output.type === 'dragOut') {
            this.dragOver = false;
        }
        else if (output.type === 'drop') {
            this.dragOver = false;
        }
        else if (output.type == "done")
            this.handleUploaded(output.file.response);
    };
    DocSelectorComponent.prototype.handleUploaded = function (response) {
        this.isFileUploading = false;
        if (!response.Data)
            return;
        if (response.Data.OrderStatus == this.tabNumber)
            this.docs.push(response.Data.Data.Data);
        this.order.DataList.push(response.Data);
    };
    DocSelectorComponent.ctorParameters = function () { return [{ type: services_configService["a" /* ConfigService */] }, { type: uploadService_UploadService }, { type: ng2_toastr["ToastsManager"] }]; };
    return DocSelectorComponent;
}());

//# sourceMappingURL=docSelector.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/orderManagement/orderData/tabs/docSelector.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_DocSelectorComponent = [];
var RenderType_DocSelectorComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DocSelectorComponent, data: {} });
function View_DocSelectorComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class',
                'spinner-circle opacity-background'], ['id', 'spinner']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, ':svg:svg', [['class', 'spinner-circular'],
            ['viewBox', '25 25 50 50']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, ':svg:circle', [['class', 'path'], ['cx', '50'],
            ['cy', '50'], ['fill', 'none'], ['r', '20'], ['stroke-miterlimit', '10'], ['stroke-width',
                '2']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_DocSelectorComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 10, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'li', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.uploadService.downloadFile(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons icon-orange']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['insert_drive_file'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.toString().substring(37);
        _ck(_v, 8, 0, currVal_0);
    });
}
function View_DocSelectorComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'col-md-12 text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class',
                'btn btn-round btn-dark-orange btn-wide complete-button margin-top-10']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.completeOrderEvent.emit(true) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isFileUploading;
        _ck(_v, 4, 0, currVal_0);
        var currVal_1 = ((_co.tabNumber == _co.orderStatus.Quoted) ? 'PAY MANUALLY' : 'COMPLETE');
        _ck(_v, 6, 0, currVal_1);
    });
}
function View_DocSelectorComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { docSelectorRef: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 16, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DocSelectorComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'card margin-top-5']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, [[1, 0], ['docSelector', 1]], null, 7, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'ul', [['class', 'file-selector']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DocSelectorComponent_2)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 22, null, null, null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'div', [['class', 'row']], [[8, 'hidden', 0]], null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class', 'col-md-12 text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 10, 'button', [['class', 'btn btn-round btn-white-orange upload-button btn-wide']], [[8, 'disabled', 0]], null, null, null, null)),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 6, 'label', [['class', 'upload-button']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'disabled': 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'input', [['ngFileSelect', ''], ['style', 'display:none'],
            ['type', 'file']], [[8, 'disabled', 0]], [[null, 'uploadOutput']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('uploadOutput' === en)) {
                var pd_0 = (_co.onUploadOutput($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, directives_ng_file_select_directive_NgFileSelectDirective, [core_es5["ElementRef"]], { options: [0, 'options'], uploadInput: [1, 'uploadInput'] }, { uploadOutput: 'uploadOutput' }),
        (_l()(), core_es5["ɵted"](null, [' UPLOAD FILE '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DocSelectorComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isFileUploading;
        _ck(_v, 6, 0, currVal_0);
        var currVal_1 = _co.docs;
        _ck(_v, 15, 0, currVal_1);
        var currVal_4 = 'upload-button';
        var currVal_5 = _ck(_v, 33, 0, (_co.isFileUploading == true));
        _ck(_v, 32, 0, currVal_4, currVal_5);
        var currVal_7 = _co.options;
        var currVal_8 = _co.uploadInput;
        _ck(_v, 36, 0, currVal_7, currVal_8);
        var currVal_9 = (_co.tabNumber >= _co.order.Status);
        _ck(_v, 43, 0, currVal_9);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = !(_co.tabNumber >= _co.order.Status);
        _ck(_v, 24, 0, currVal_2);
        var currVal_3 = _co.isFileUploading;
        _ck(_v, 28, 0, currVal_3);
        var currVal_6 = _co.isFileUploading;
        _ck(_v, 35, 0, currVal_6);
    });
}
function View_DocSelectorComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-doc-selector-tab', [], null, null, null, View_DocSelectorComponent_0, RenderType_DocSelectorComponent)), core_es5["ɵdid"](638976, null, 0, docSelector_component_DocSelectorComponent, [services_configService["a" /* ConfigService */], uploadService_UploadService, toast_manager["ToastsManager"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var DocSelectorComponentNgFactory = core_es5["ɵccf"]('order-doc-selector-tab', docSelector_component_DocSelectorComponent, View_DocSelectorComponent_Host_0, { order: 'order', tabNumber: 'tabNumber' }, { completeOrderEvent: 'completeOrderEvent' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=docSelector.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/Managment/orderManagement/orderData/tabs/leftTab.component.ts
/**
 * Created by alex.y on 10/2/2017.
 */
var LeftTabComponent = /** @class */ (function () {
    function LeftTabComponent() {
        this.isPassed = false;
        this.isCurrent = false;
    }
    return LeftTabComponent;
}());

//# sourceMappingURL=leftTab.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/orderManagement/orderData/tabs/leftTab.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_LeftTabComponent = [];
var RenderType_LeftTabComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_LeftTabComponent, data: {} });
function View_LeftTabComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class',
                'card left-tab-card']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'left-tab-selected': 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'div', [['class', 'left-tab']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'i', [['class', 'material-icons']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'icon-grey': 0, 'icon-green': 1,
            'icon-white': 2 }), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'span', [['class', 'left-tab-text']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'span', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'icon-grey': 0, 'icon-green': 1, 'icon-white': 2 }), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'card left-tab-card';
        var currVal_1 = _ck(_v, 2, 0, _co.isCurrent);
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_2 = 'material-icons';
        var currVal_3 = _ck(_v, 10, 0, (!_co.isPassed && !_co.isCurrent), _co.isPassed, _co.isCurrent);
        _ck(_v, 9, 0, currVal_2, currVal_3);
        var currVal_5 = _ck(_v, 17, 0, (!_co.isPassed && !_co.isCurrent), _co.isPassed, _co.isCurrent);
        _ck(_v, 16, 0, currVal_5);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_4 = _co.icon;
        _ck(_v, 11, 0, currVal_4);
        var currVal_6 = _co.title;
        _ck(_v, 18, 0, currVal_6);
    });
}
function View_LeftTabComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-left-tab', [], null, null, null, View_LeftTabComponent_0, RenderType_LeftTabComponent)), core_es5["ɵdid"](49152, null, 0, LeftTabComponent, [], null, null)], null, null);
}
var LeftTabComponentNgFactory = core_es5["ɵccf"]('order-left-tab', LeftTabComponent, View_LeftTabComponent_Host_0, { title: 'title', icon: 'icon', isPassed: 'isPassed',
    isCurrent: 'isCurrent' }, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L29yZGVyTWFuYWdlbWVudC9vcmRlckRhdGEvdGFicy9sZWZ0VGFiLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9NYW5hZ21lbnQvb3JkZXJNYW5hZ2VtZW50L29yZGVyRGF0YS90YWJzL2xlZnRUYWIuY29tcG9uZW50LnRzIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L29yZGVyTWFuYWdlbWVudC9vcmRlckRhdGEvdGFicy9sZWZ0VGFiLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L29yZGVyTWFuYWdlbWVudC9vcmRlckRhdGEvdGFicy9sZWZ0VGFiLmNvbXBvbmVudC50cy5MZWZ0VGFiQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImNhcmQgbGVmdC10YWItY2FyZFwiIFtuZ0NsYXNzXT1cInsnbGVmdC10YWItc2VsZWN0ZWQnOiBpc0N1cnJlbnR9XCI+IDxkaXYgY2xhc3M9XCJjYXJkLWNvbnRlbnRcIj4gPGRpdiBjbGFzcz1cImxlZnQtdGFiXCI+IDxpIGNsYXNzPVwibWF0ZXJpYWwtaWNvbnNcIiBbbmdDbGFzc109XCJ7J2ljb24tZ3JleSc6ICFpc1Bhc3NlZCAmJiAhaXNDdXJyZW50LFxyXG4gICAgICAgICAgICAgICAgICAgICdpY29uLWdyZWVuJzogaXNQYXNzZWQsICdpY29uLXdoaXRlJzogaXNDdXJyZW50IH1cIj4ge3tpY29ufX0gPC9pPiA8c3BhbiBjbGFzcz1cImxlZnQtdGFiLXRleHRcIj4gPHNwYW4gW25nQ2xhc3NdPVwieydpY29uLWdyZXknOiAhaXNQYXNzZWQgJiYgIWlzQ3VycmVudCxcclxuICAgICAgICAgICAgICAgICAgICAgICAgJ2ljb24tZ3JlZW4nOiBpc1Bhc3NlZCwgJ2ljb24td2hpdGUnOiBpc0N1cnJlbnQgfVwiPiB7e3RpdGxlfX0gPC9zcGFuPiA8L3NwYW4+IDwvZGl2PiA8L2Rpdj4gPC9kaXY+IiwiPG9yZGVyLWxlZnQtdGFiPjwvb3JkZXItbGVmdC10YWI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBQSx1QkFBQTtrREFBQTtNQUFBLGtDQUFnQywwQkFBNkM7TUFBQSxRQUFDO01BQUEsd0VBQTBCO2FBQUEsdUJBQUM7TUFBQTtNQUFBLGdCQUFzQixzQ0FBQztNQUFBO01BQUEsbURBQUE7TUFBQTtVQUFBLHNEQUEwQjtNQUFBLGlCQUNuRiwwQ0FBYztNQUFBLFFBQUM7TUFBQSx3RUFBNEI7YUFBQSx1QkFBQztNQUFBO01BQUEsdUJBQUE7a0RBQUE7YUFBTSxnREFDOUM7VUFBQSxZQUFrQixzQ0FBUTtVQUFBLFFBQU8sc0NBQU87VUFBQTs7SUFGOUc7SUFBMkI7SUFBaEMsV0FBSyxVQUEyQixTQUFoQztJQUFtSTtJQUF1QjtRQUFBO0lBQTFCLFdBQUcsVUFBdUIsU0FBMUI7SUFDUDtRQUFBO0lBQU4sWUFBTSxTQUFOOzs7SUFBNUM7SUFBQTtJQUNJO0lBQUE7Ozs7b0JDRjNFO01BQUE7aUNBQUEsVUFBQTtNQUFBOzs7OyJ9
//# sourceMappingURL=leftTab.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/Managment/orderManagement/orderData/orderData.component.ts















/**
 * Created by alex.y on 9/29/2017.
 */
var orderData_component_OrderDataComponent = /** @class */ (function () {
    function OrderDataComponent(toastr, orderService, configService, orderContentService, emailService, route) {
        this.toastr = toastr;
        this.orderService = orderService;
        this.configService = configService;
        this.orderContentService = orderContentService;
        this.emailService = emailService;
        this.route = route;
        this.orderChange = new core_es5["EventEmitter"]();
        this.tabChanged = new core_es5["EventEmitter"]();
        this.orderStatus = orders_orderStatus["a" /* OrderStatus */];
        this.isProcessing = false;
        this.orderContentComment = new orderContent_OrderContent();
        this.dataList = [];
        this.documents3461 = [];
        this.documents7501 = [];
    }
    OrderDataComponent.prototype.ngOnInit = function () {
        //this.documents3461 = this.route.snapshot.data.documents3461.Data;
        //this.documents7501 = this.route.snapshot.data.documents7501.Data;
        this.tabNumber = this.order.Status;
        /*because when order has been updated on order details,
         * tab number has been inited as OrderStatus.Calculated*/
        // if(this.order.Status == OrderStatus.Calculated)
        //     this.tabNumber = OrderStatus.Quoted;
        if (this.order.Status >= orders_orderStatus["a" /* OrderStatus */].BorderCrossed)
            this.tabNumber = orders_orderStatus["a" /* OrderStatus */].CustomReleased;
        this.isProcessing = true;
        this.paypalDisabled = false;
        this.getOrderContent();
    };
    OrderDataComponent.prototype.getOrderContent = function () {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            var response, e_1;
            return tslib_es6["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.order || !this.order.Id)
                            return [2 /*return*/, null];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.orderContentService.getByOrderIdAndStatus(this.order.Id, null)];
                    case 2:
                        response = _a.sent();
                        this.isProcessing = false;
                        if (!response.Data)
                            return [2 /*return*/];
                        this.order.DataList = response.Data;
                        this.dataList = response.Data;
                        this.getCurrentComment();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OrderDataComponent.prototype.ngOnChanges = function () {
        if (this.order.DataList.length != 0 || this.dataList.length == 0)
            return;
        if (this.order.Id == this.dataList[0].OrderId)
            this.order.DataList = this.dataList;
        else
            this.getOrderContent();
    };
    OrderDataComponent.prototype.createOrder = function (isOpenPayPal) {
        if (isOpenPayPal === void 0) { isOpenPayPal = false; }
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            var googleWindow, response, e_2;
            return tslib_es6["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        googleWindow = window.open(window.location.origin + "/paymentredirect");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.paypalDisabled = true;
                        return [4 /*yield*/, this.orderService.createInvoice(this.order.Id)];
                    case 2:
                        response = _a.sent();
                        if (isOpenPayPal && response.Data) {
                            googleWindow.location.replace(this.configService.config.PayPalUrl + "/invoice/payerView/details/" + response.Data.Invoice.Id);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        e_2 = _a.sent();
                        console.log(e_2);
                        return [3 /*break*/, 5];
                    case 4:
                        this.paypalDisabled = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    OrderDataComponent.prototype.selectTab = function (tabNumber) {
        if (tabNumber > this.order.Status)
            return;
        this.tabNumber = tabNumber;
        this.tabChanged.emit(this.tabNumber);
        if (tabNumber >= orders_orderStatus["a" /* OrderStatus */].BorderCrossed)
            this.tabNumber = orders_orderStatus["a" /* OrderStatus */].CustomReleased;
        this.getCurrentComment();
    };
    OrderDataComponent.prototype.getCurrentComment = function () {
        var _this = this;
        this.orderContentComment = this.order.DataList.find(function (x) { return x.OrderStatus == _this.tabNumber && x.Data.Type == OrderDataType.Comment; });
        if (this.orderContentComment == null) {
            this.orderContentComment = new orderContent_OrderContent({
                OrderId: this.order.Id,
                OrderStatus: this.order.Status,
                Data: new OrderContentData({
                    Data: '',
                    Type: OrderDataType.Comment
                })
            });
            this.order.DataList.push(this.orderContentComment);
        }
    };
    OrderDataComponent.prototype.completeOrder = function () {
        var _this = this;
        if (this.order.Status == orders_orderStatus["a" /* OrderStatus */].Paid)
            this.order.Status = this.order.Status + 2;
        else
            this.order.Status = this.order.Status + 1;
        var doc = this.order.DataList;
        this.orderService.modify(this.order).then(function (x) {
            if (!x.Data)
                return;
            _this.order = x.Data;
            _this.order.CalculatorType = calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(_this.order.Locations);
            _this.orderChange.emit(_this.order);
            document.getElementById('mainPanel').scrollTop = 0;
            _this.order.DataList = doc;
            _this.selectTab(_this.order.Status);
        });
    };
    OrderDataComponent.prototype.sendToCustomer = function () {
        var _this = this;
        this.emailService.sendOrderToCustomer(new EmailRequest({ OrderId: this.order.Id, EmailType: emailTemplateType["a" /* EmailTemplateType */].OrderToCustomerPay })).then(function (x) {
            _this.toastr.success("Sending mail succeeded");
        }).catch(function () {
            _this.toastr.error("Sending mail failed");
        });
    };
    OrderDataComponent.ctorParameters = function () { return [{ type: ng2_toastr["ToastsManager"] }, { type: services_orderService["a" /* OrderService */] }, { type: services_configService["a" /* ConfigService */] }, { type: orderContentService_OrderContentService }, { type: services_emailService["a" /* EmailService */] }, { type: router_es5["a" /* ActivatedRoute */] }]; };
    return OrderDataComponent;
}());

//# sourceMappingURL=orderData.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/orderManagement/orderData/orderData.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




















var styles_OrderDataComponent = [];
var RenderType_OrderDataComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_OrderDataComponent, data: {} });
function View_OrderDataComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'spinner']], null, null, null, null, null))], null, null);
}
function View_OrderDataComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'order-prep-doc-tab', [], null, null, null, View_PreparingDocTabComponent_0, RenderType_PreparingDocTabComponent)), core_es5["ɵdid"](49152, null, 0, preparingDocTab_component_PreparingDocTabComponent, [orderContentService_OrderContentService], { orderContent: [0, 'orderContent'], tabNumber: [1, 'tabNumber'],
            isReadOnly: [2, 'isReadOnly'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.orderContentComment;
        var currVal_1 = _co.tabNumber;
        var currVal_2 = (_co.tabNumber < _co.order.Status);
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2);
    }, null);
}
function View_OrderDataComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'advanced-doc-selector', [['class', 'advanced-doc-selector']], null, [[null, 'orderChange'],
            [null, 'completeOrderEvent']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('orderChange' === en)) {
                var pd_0 = ((_co.order = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('completeOrderEvent' === en)) {
                var pd_1 = (_co.completeOrder() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_AdvancedDocSelectorComponent_0, RenderType_AdvancedDocSelectorComponent)),
        core_es5["ɵdid"](638976, null, 0, advancedDocSelector_component_AdvancedDocSelectorComponent, [services_configService["a" /* ConfigService */],
            uploadService_UploadService, toast_manager["ToastsManager"], orderContentService_OrderContentService, documentService_DocumentService], { order: [0, 'order'], tabNumber: [1, 'tabNumber'], documents3461: [2, 'documents3461'],
            documents7501: [3, 'documents7501'] }, { completeOrderEvent: 'completeOrderEvent' }),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order;
        var currVal_1 = _co.tabNumber;
        var currVal_2 = _co.documents3461;
        var currVal_3 = _co.documents7501;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_OrderDataComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-dark-orange btn-round btn-wide']], [[8, 'disabled',
                0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.createOrder(true) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' PAY NOW '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-white-orange btn-round pull-right btn-wide']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.sendToCustomer() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' SEND TO CUSTOMER '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var currVal_0 = true;
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = true;
        _ck(_v, 6, 0, currVal_1);
    });
}
function View_OrderDataComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'order-doc-selector-tab', [], null, [[null, 'orderChange'], [null, 'completeOrderEvent']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('orderChange' === en)) {
                var pd_0 = ((_co.order = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('completeOrderEvent' === en)) {
                var pd_1 = (_co.completeOrder() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_DocSelectorComponent_0, RenderType_DocSelectorComponent)), core_es5["ɵdid"](638976, null, 0, docSelector_component_DocSelectorComponent, [services_configService["a" /* ConfigService */], uploadService_UploadService,
            toast_manager["ToastsManager"]], { order: [0, 'order'], tabNumber: [1, 'tabNumber'] }, { completeOrderEvent: 'completeOrderEvent' }),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order;
        var currVal_1 = _co.tabNumber;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_OrderDataComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'order-prep-doc-tab', [['class', 'order-prep-doc-tab']], null, [[null, 'completeOrderEvent']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('completeOrderEvent' === en)) {
                var pd_0 = (_co.completeOrder() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_PreparingDocTabComponent_0, RenderType_PreparingDocTabComponent)),
        core_es5["ɵdid"](49152, null, 0, preparingDocTab_component_PreparingDocTabComponent, [orderContentService_OrderContentService], { orderContent: [0, 'orderContent'], tabNumber: [1, 'tabNumber'], isReadOnly: [2,
                'isReadOnly'], showTitle: [3, 'showTitle'], showContinue: [4, 'showContinue'] }, { completeOrderEvent: 'completeOrderEvent' }), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.orderContentComment;
        var currVal_1 = _co.tabNumber;
        var currVal_2 = (_co.tabNumber < _co.order.Status);
        var currVal_3 = false;
        var currVal_4 = true;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4);
    }, null);
}
function View_OrderDataComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 52, 'div', [['class',
                'row order-data']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'col-md-3 col-sm-6 mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'order-left-tab', [['icon', 'iso'], ['title', 'Quoted']], null, null, null, View_LeftTabComponent_0, RenderType_LeftTabComponent)), core_es5["ɵdid"](49152, null, 0, LeftTabComponent, [], { title: [0, 'title'], icon: [1,
                'icon'], isPassed: [2, 'isPassed'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'order-left-tab', [['icon', 'payment'], ['title', 'Paid']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectTab(1) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_LeftTabComponent_0, RenderType_LeftTabComponent)), core_es5["ɵdid"](49152, null, 0, LeftTabComponent, [], { title: [0, 'title'], icon: [1,
                'icon'], isPassed: [2, 'isPassed'], isCurrent: [3, 'isCurrent'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 2, 'order-left-tab', [['icon', 'description'],
            ['title', 'Prepared Documents']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectTab(2) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_LeftTabComponent_0, RenderType_LeftTabComponent)), core_es5["ɵdid"](49152, null, 0, LeftTabComponent, [], { title: [0, 'title'], icon: [1,
                'icon'], isPassed: [2, 'isPassed'], isCurrent: [3, 'isCurrent'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 2, 'order-left-tab', [['icon', 'contact_mail'],
            ['title', 'Sent to customs']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectTab(4) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_LeftTabComponent_0, RenderType_LeftTabComponent)), core_es5["ɵdid"](49152, null, 0, LeftTabComponent, [], { title: [0, 'title'], icon: [1,
                'icon'], isPassed: [2, 'isPassed'], isCurrent: [3, 'isCurrent'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 2, 'order-left-tab', [['icon', 'local_shipping'],
            ['title', 'Customs released']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectTab(5) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_LeftTabComponent_0, RenderType_LeftTabComponent)), core_es5["ɵdid"](49152, null, 0, LeftTabComponent, [], { title: [0, 'title'], icon: [1,
                'icon'], isPassed: [2, 'isPassed'], isCurrent: [3, 'isCurrent'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 2, 'order-left-tab', [['icon', 'beenhere'],
            ['title', 'Case closed']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectTab(6) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_LeftTabComponent_0, RenderType_LeftTabComponent)), core_es5["ɵdid"](49152, null, 0, LeftTabComponent, [], { title: [0, 'title'], icon: [1,
                'icon'], isPassed: [2, 'isPassed'], isCurrent: [3, 'isCurrent'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class', 'col-md-6 col-sm-6 center-block']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderDataComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderDataComponent_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderDataComponent_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-md-3 col-xs-12 right-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderDataComponent_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderDataComponent_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Quoted';
        var currVal_1 = 'iso';
        var currVal_2 = true;
        _ck(_v, 5, 0, currVal_0, currVal_1, currVal_2);
        var currVal_3 = 'Paid';
        var currVal_4 = 'payment';
        var currVal_5 = (_co.order.Status >= _co.orderStatus.Paid);
        var currVal_6 = (_co.tabNumber == _co.orderStatus.Quoted);
        _ck(_v, 9, 0, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = 'Prepared Documents';
        var currVal_8 = 'description';
        var currVal_9 = (_co.order.Status >= _co.orderStatus.PrepareDoc);
        var currVal_10 = (_co.tabNumber == _co.orderStatus.Paid);
        _ck(_v, 13, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'Sent to customs';
        var currVal_12 = 'contact_mail';
        var currVal_13 = (_co.order.Status >= _co.orderStatus.SentToCustom);
        var currVal_14 = (_co.tabNumber == _co.orderStatus.PrepareDoc);
        _ck(_v, 17, 0, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_15 = 'Customs released';
        var currVal_16 = 'local_shipping';
        var currVal_17 = (_co.order.Status >= _co.orderStatus.CustomReleased);
        var currVal_18 = (_co.tabNumber == _co.orderStatus.SentToCustom);
        _ck(_v, 21, 0, currVal_15, currVal_16, currVal_17, currVal_18);
        var currVal_19 = 'Case closed';
        var currVal_20 = 'beenhere';
        var currVal_21 = (_co.order.Status >= _co.orderStatus.BorderCrossed);
        var currVal_22 = (_co.tabNumber >= _co.orderStatus.CustomReleased);
        _ck(_v, 25, 0, currVal_19, currVal_20, currVal_21, currVal_22);
        var currVal_23 = (_co.tabNumber != _co.orderStatus.Paid);
        _ck(_v, 34, 0, currVal_23);
        var currVal_24 = (_co.tabNumber == _co.orderStatus.Paid);
        _ck(_v, 37, 0, currVal_24);
        var currVal_25 = ((_co.tabNumber == _co.orderStatus.Quoted) && (_co.order.Status == _co.orderStatus.Quoted));
        _ck(_v, 41, 0, currVal_25);
        var currVal_26 = (_co.tabNumber != _co.orderStatus.Paid);
        _ck(_v, 47, 0, currVal_26);
        var currVal_27 = (_co.tabNumber == _co.orderStatus.Paid);
        _ck(_v, 50, 0, currVal_27);
    }, null);
}
function View_OrderDataComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderDataComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderDataComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isProcessing;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = !_co.isProcessing;
        _ck(_v, 4, 0, currVal_1);
    }, null);
}
function View_OrderDataComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-data', [], null, null, null, View_OrderDataComponent_0, RenderType_OrderDataComponent)),
        core_es5["ɵdid"](638976, null, 0, orderData_component_OrderDataComponent, [toast_manager["ToastsManager"], services_orderService["a" /* OrderService */],
            services_configService["a" /* ConfigService */], orderContentService_OrderContentService, services_emailService["a" /* EmailService */], router_es5["a" /* ActivatedRoute */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var OrderDataComponentNgFactory = core_es5["ɵccf"]('order-data', orderData_component_OrderDataComponent, View_OrderDataComponent_Host_0, { order: 'order' }, { orderChange: 'orderChange',
    tabChanged: 'tabChanged' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=orderData.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/objects/extraData/extraData.ts
var extraData_extraData = __webpack_require__("KGeA");

// EXTERNAL MODULE: ./app/common/helpers/HScodeHelper.ts
var HScodeHelper = __webpack_require__("uPA9");

// EXTERNAL MODULE: ./node_modules/angular2-uuid/index.js
var angular2_uuid = __webpack_require__("WlhA");
var angular2_uuid_default = /*#__PURE__*/__webpack_require__.n(angular2_uuid);

// CONCATENATED MODULE: ./app/services/publisher.service.ts




var publisher_service_PublisherService = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](PublisherService, _super);
    function PublisherService(http, configService) {
        return _super.call(this, http, configService) || this;
    }
    PublisherService.prototype.bbPublisherRequest = function (uniqueRequestId, data) {
        return this.http.post(this.config.BBPublisherUrl + '/' + uniqueRequestId, data);
    };
    PublisherService.ctorParameters = function () { return [{ type: http_es5["e" /* Http */] }, { type: services_configService["a" /* ConfigService */] }]; };
    return PublisherService;
}(baseService["a" /* BaseApi */]));

//# sourceMappingURL=publisher.service.js.map
// CONCATENATED MODULE: ./app/components/calculator/calculator.component.ts
/**
 * Created by alex.y on 8/8/2017.
 */



















var calculator_component_CalculatorComponent = /** @class */ (function () {
    function CalculatorComponent(orderService, route, extraDataService, router, publisherService) {
        this.orderService = orderService;
        this.route = route;
        this.extraDataService = extraDataService;
        this.router = router;
        this.publisherService = publisherService;
        this.order = new orders_order["a" /* Order */]();
        this.extraData = new extraData_extraData["a" /* ExtraData */]();
        this.orderChange = new core_es5["EventEmitter"]();
        this.tabChanged = new core_es5["EventEmitter"]();
        this.isOrderDetails = false;
        this.isPublic = false;
        this.isProcessing = true;
        this.canadianCurrencyCodes = [];
        this.firstAttempt = false;
        this.orderStatus = orders_orderStatus["a" /* OrderStatus */];
        this.calculatorHelper = calculatorHelper["a" /* CalculatorHelper */];
        this.stringLink = String;
        this.query = "";
        this.hideQuote = false;
        this.isFirstTabOpened = false;
        this.validateFrom = true;
        this.clonedOrder = new orders_order["a" /* Order */]();
        this.sendCustomer = true;
        this.isModalChnageShown = false;
    }
    Object.defineProperty(CalculatorComponent.prototype, "disableChanges", {
        get: function () {
            if (this.order.Status >= orders_orderStatus["a" /* OrderStatus */].Paid || (this.isPublic && this.order.Status >= orders_orderStatus["a" /* OrderStatus */].Quoted)) {
                return true;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    CalculatorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.canadianCurrencyCodes = this.route.snapshot.data.canadianCurrencyCodes.Data;
        this.viewTypeEnum = screenHelper["a" /* ScreenHelper */].getViewType();
        this.viewType = users_viewType["a" /* ViewType */][this.viewTypeEnum];
        if (!this.router.url.includes('calculator/agent'))
            this.hideQuote = true;
        this.order.Source = "Agent Calculator";
        if (this.router.url == '/calculator/public') {
            this.order.Flag |= orderOptions["a" /* OrderOptions */].IsPulic;
            this.order.Source = "Public Calculator";
        }
        if (this.router.url == '/calculator2/public') {
            this.order.Source = "Public Calculator";
        }
        this.clonedOrder = JSON.parse(JSON.stringify(this.order));
        if (this.order.Id) {
            this.firstAttempt = true;
            this.order.CalculatorType = calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(this.order.Locations);
            if (this.order.Status == orders_orderStatus["a" /* OrderStatus */].Calculated || this.order.Status == orders_orderStatus["a" /* OrderStatus */].Quoted) {
                this.isProcessing = true;
                this.orderService.modify(this.order).then(function (x) {
                    _this.isProcessing = false;
                    if (!x || !x.Data)
                        return;
                    _this.order = x.Data;
                    _this.order.CalculatorType = calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(_this.order.Locations);
                    _this.orderChange.emit(_this.order);
                    setTimeout(function () {
                        if (_this.calculatorTabComponent && orderHelper_OrderHelper.hasOption(_this.order, orderOptions["a" /* OrderOptions */].IsBBFeeEdited))
                            _this.calculatorTabComponent.recalculateTaxesToSelected(_this.order);
                        _this.calculatorTabComponent.recalculateTotals();
                    });
                });
            }
        }
    };
    CalculatorComponent.prototype.checkFillOrderForm = function (event) {
        if (!this.validateFrom) {
            this.validateFrom = true;
            return;
        }
        if (!this.firstAttempt && !this.fillOrderTab.checkForm())
            event.preventDefault();
    };
    CalculatorComponent.prototype.calculateOrder = function (event) {
        var _this = this;
        if (this.firstAttempt || this.disableChanges) {
            this.isProcessing = false;
            if (this.mainElement)
                this.mainElement.nativeElement.scrollTop = 0;
            return;
        }
        this.isFirstTabOpened = false;
        this.isProcessing = true;
        if (this.order.CalculatorType == orders_calculatorType["a" /* CalculatorType */].UsaImport) {
            this.order.Currency = this.canadianCurrencyCodes.find(function (x) { return x.Name == 'USD'; });
        }
        else {
            this.order.Currency = this.canadianCurrencyCodes.find(function (x) { return x.Name == 'CAD'; });
        }
        this.order.OrderItems.forEach(function (item) {
            item.Product.HsCode = HScodeHelper["a" /* HScodeHelper */].addDotAfterLastTwoNumb(item.Product.HsCode);
        });
        if (orderHelper_OrderHelper.hasOption(this.order, orderOptions["a" /* OrderOptions */].IsBBFeeEdited)) {
            this.moveTaxes();
            if (this.calculatorTabComponent)
                this.calculatorTabComponent.recalculateTaxes(this.order);
        }
        var requestId = angular2_uuid["UUID"].UUID();
        var isNewOrder = this.order.Id === null || this.order.Id === undefined;
        if (isNewOrder) {
            this.publisherService
                .bbPublisherRequest(requestId, this.order)
                .subscribe();
        }
        this.orderService.create(this.order, this.viewType).then(function (response) {
            if (!response || !response.Data) {
                _this.isProcessing = false;
                throw new Error("Extra data was not created");
            }
            if (isNewOrder) {
                _this.publisherService
                    .bbPublisherRequest(requestId, { 'quote_id': response.Data.Id })
                    .subscribe();
            }
            _this.saveExtraData(response.Data.Customer.Id);
            if (!_this.clonedOrder.Id)
                _this.clonedOrder = JSON.parse(JSON.stringify(response.Data));
            else
                _this.addItemsToClonedOrder(response.Data);
            _this.sendCustomer = false;
            _this.order = response.Data;
            _this.order.CalculatorType = calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(_this.order.Locations);
            _this.orderChange.emit(_this.order);
            _this.isProcessing = false;
            setTimeout(function (x) {
                _this.sendCustomer = true;
            }, 1250);
            if (_this.orderDataComponent)
                _this.orderDataComponent.selectTab(1);
            if (_this.mainElement)
                _this.mainElement.nativeElement.scrollTop = 0;
        });
    };
    CalculatorComponent.prototype.moveTaxes = function () {
        if (this.order.OrderItems.length == this.clonedOrder.OrderItems.length) {
            for (var i = 0; i < this.order.OrderItems.length; i++) {
                var currentAATax = tax_helper_TaxHelper.getItemTaxOrNull(this.order.OrderItems[i], orders_taxType["a" /* TaxType */].AAFee);
                var previousAATax = tax_helper_TaxHelper.getItemTaxOrNull(this.clonedOrder.OrderItems[i], orders_taxType["a" /* TaxType */].AAFee);
                if (currentAATax == null) {
                    this.order.OrderItems[i].Taxes.push(new orders_orderItem["a" /* ItemTax */]({
                        Value: previousAATax.Value,
                        TaxType: orders_taxType["a" /* TaxType */].AAFee
                    }));
                    continue;
                }
                currentAATax.Value = previousAATax.Value;
            }
            return;
        }
        var total = 0;
        this.clonedOrder.OrderItems.forEach(function (orderItem) {
            var previousAATax = tax_helper_TaxHelper.getItemTaxOrNull(orderItem, orders_taxType["a" /* TaxType */].AAFee);
            total += previousAATax.Value;
        });
        this.order.OrderItems.forEach(function (orderItem) {
            var aaTax = tax_helper_TaxHelper.getItemTaxOrNull(orderItem, orders_taxType["a" /* TaxType */].AAFee);
            if (aaTax == null) {
                orderItem.Taxes.push(new orders_orderItem["a" /* ItemTax */]({
                    Value: 0,
                    TaxType: orders_taxType["a" /* TaxType */].AAFee
                }));
            }
        });
        this.order = tax_helper_TaxHelper.convertTotalToTaxes(total, this.order);
        // get Total and then apply it to all order items
    };
    CalculatorComponent.prototype.addItemsToClonedOrder = function (order) {
        // if(this.clonedOrder.OrderItems.length < order.OrderItems.length){
        //     for(let i = 0; i < order.OrderItems.length - this.clonedOrder.OrderItems.length; i++){
        //         this.clonedOrder.OrderItems.push(new OrderItem());
        //     }
        // }
        var orderItems = new Array();
        var _loop_1 = function (orderItem) {
            var foundItem = this_1.clonedOrder.OrderItems.find(function (x) { return x.Id == orderItem.Id; });
            if (foundItem != null)
                orderItems.push(foundItem);
            else
                orderItems.push(orderItem);
        };
        var this_1 = this;
        for (var _i = 0, _a = order.OrderItems; _i < _a.length; _i++) {
            var orderItem = _a[_i];
            _loop_1(orderItem);
        }
        this.clonedOrder.OrderItems = JSON.parse(JSON.stringify(orderItems));
    };
    CalculatorComponent.prototype.saveExtraData = function (customerId) {
        this.extraData.ReferenceId = customerId ? customerId.toString() : null;
        this.extraData.ReferenceType = 0;
        this.extraData.Name = "marketing text";
        this.extraDataService.modify(this.extraData).then();
    };
    CalculatorComponent.prototype.createEvent = function () {
        this.order = new orders_order["a" /* Order */]();
        this.order.Source = "Agent Calculator";
        if (this.router.url == '/calculator/public' || this.router.url == '/calculator2/public')
            this.order.Source = "Public Calculator";
        this.order.OrderItems = [new orders_orderItem["b" /* OrderItem */]()];
        this.extraData = new extraData_extraData["a" /* ExtraData */]();
        this.fillOrderTab.resetForm();
        // this.validateFrom = false;
        if (!this.tabDirective.active)
            this.tabDirective.active = true;
        if (this.isOrderDetails)
            this.router.navigate(['/calculator/agent']);
    };
    CalculatorComponent.prototype.goToSearch = function () {
        this.router.navigate(['/management/order', { query: this.query }]);
    };
    CalculatorComponent.prototype.setOrderDataTab = function (num) {
        if (!this.tabDirective.active)
            this.tabDirective.active = true;
        this.calculatorWizard.tabs[2].active = true;
        this.orderDataComponent.selectTab(num);
    };
    CalculatorComponent.prototype.cloneOrder = function () {
        this.clonedOrder = JSON.parse(JSON.stringify(this.order));
        this.isProcessing = false;
    };
    CalculatorComponent.prototype.showModal = function (event) {
        if (this.isModalChnageShown == true) {
            this.isModalChnageShown = false;
            return;
        }
        if (this.order.Status >= orders_orderStatus["a" /* OrderStatus */].Paid) {
            this.isProcessing = false;
            return;
        }
        if (!this.isFirstTabOpened)
            return;
        if (!orderHelper_OrderHelper.hasOption(this.order, orderOptions["a" /* OrderOptions */].IsBBFeeEdited)) {
            this.calculateOrder(null);
            return;
        }
        this.isModalChnageShown = true;
        event.preventDefault();
        this.aaChangeModal.show();
    };
    CalculatorComponent.prototype.onFistTabSelected = function () {
        this.isProcessing = true;
        this.firstAttempt = false;
        this.cloneOrder();
        this.isModalChnageShown = false;
        this.isFirstTabOpened = true;
    };
    CalculatorComponent.prototype.modalHiddenHandler = function (event) {
        if (this.isFirstTabOpened)
            this.calculatorWizard.nextTab(false);
        else {
            this.calculatorWizard.previousTab(false);
        }
        this.firstAttempt = false;
        if (this.disableChanges)
            return;
        this.calculateOrder(event);
    };
    CalculatorComponent.ctorParameters = function () { return [{ type: services_orderService["a" /* OrderService */] }, { type: router_es5["a" /* ActivatedRoute */] }, { type: services_extraDataService["a" /* ExtraDataService */] }, { type: router_es5["n" /* Router */] }, { type: publisher_service_PublisherService }]; };
    return CalculatorComponent;
}());

//# sourceMappingURL=calculator.component.js.map
// CONCATENATED MODULE: ./app/components/calculator/modals/aafee-change-modal.component.ts






var aafee_change_modal_component_AaFeeChangeModalComponent = /** @class */ (function () {
    function AaFeeChangeModalComponent() {
        this.idsToBlur = ["calculator", "order-id", "order-details"];
        this.modalHidden = new core_es5["EventEmitter"]();
    }
    AaFeeChangeModalComponent.prototype.show = function () {
        if (!this.changeConfirmation || !this.changeConfirmation.config) {
            this.onModalHidden();
            return;
        }
        if (!orderHelper_OrderHelper.hasOption(this.order, orderOptions["a" /* OrderOptions */].IsBBFeeEdited)) {
            this.onModalHidden();
            return;
        }
        this.changeConfirmation.show();
        this.blurBackContent(this.idsToBlur);
    };
    AaFeeChangeModalComponent.prototype.onModalHidden = function () {
        var _this = this;
        setTimeout(function () {
            _this.modalHidden.emit();
        });
    };
    AaFeeChangeModalComponent.prototype.save = function (resetAaFee) {
        if (resetAaFee) {
            this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsBBFeeEdited;
            this.order.OrderItems.forEach(function (x) {
                var aaTax = tax_helper_TaxHelper.getItemTaxOrNull(x, orders_taxType["a" /* TaxType */].AAFee);
                if (aaTax != null) {
                    x.Taxes.splice(x.Taxes.indexOf(aaTax), 1);
                }
            });
        }
        this.changeConfirmation.hide();
        this.unblurBackContent(this.idsToBlur);
    };
    AaFeeChangeModalComponent.prototype.blurBackContent = function (idNames) {
        for (var _i = 0, idNames_1 = idNames; _i < idNames_1.length; _i++) {
            var idName = idNames_1[_i];
            blurUtil["a" /* BlurUtil */].blurMenu(idName);
        }
    };
    AaFeeChangeModalComponent.prototype.unblurBackContent = function (idNames) {
        for (var _i = 0, idNames_2 = idNames; _i < idNames_2.length; _i++) {
            var idName = idNames_2[_i];
            blurUtil["a" /* BlurUtil */].unBlurMenu(idName);
        }
    };
    return AaFeeChangeModalComponent;
}());

//# sourceMappingURL=aafee-change-modal.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/modals/aafee-change-modal.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_AaFeeChangeModalComponent = [];
var RenderType_AaFeeChangeModalComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AaFeeChangeModalComponent, data: {} });
function View_AaFeeChangeModalComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['', ''])), core_es5["ɵppd"](3)], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent, 0), ((_co.order == null) ? null : ((_co.order.Totals == null) ? null : _co.order.Totals.BorderBuddyCustoms)), ((_co.order == null) ? null : ((_co.order.Currency == null) ? null : _co.order.Currency.Name)), true));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_AaFeeChangeModalComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['0']))], null, null);
}
function View_AaFeeChangeModalComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["CurrencyPipe"], [core_es5["LOCALE_ID"]]), core_es5["ɵqud"](402653184, 1, { changeConfirmation: 0 }), (_l()(), core_es5["ɵeld"](16777216, [['ch', 1]], null, 47, 'div', [['bsModal', ''], ['class', 'modal fade agent-modal aafee-change-modal'],
            ['id', 'myModal'], ['role', 'dialog']], null, [[null, 'onHidden'],
            [null, 'click'], [null, 'keydown.esc']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown.esc' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 3).onEsc() !== false);
                ad = (pd_1 && ad);
            }
            if (('onHidden' === en)) {
                var pd_2 = (_co.onModalHidden() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4341760, [[1, 4], ['changeConfirmation',
                4]], 0, modal_component["a" /* ModalDirective */], [core_es5["ElementRef"], core_es5["ViewContainerRef"], core_es5["Renderer"], component_loader_factory["a" /* ComponentLoaderFactory */]], { config: [0, 'config'] }, { onHidden: 'onHidden' }), core_es5["ɵpod"]({ ignoreBackdropClick: 0,
            keyboard: 1 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 42, 'div', [['class', 'modal-dialog modal-lg'], ['role', 'document']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 39, 'div', [['class', 'modal-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'modal-header header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'modal-title'], ['id', 'myModalLabel']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' CHANGE CONFIRMATION'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 30, 'div', [['class', 'modal-body']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 27, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class',
                'col-sm-12 font-size-18 bold margin-top-20']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['BorderBuddy Clearance Fee was manually changed to '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AaFeeChangeModalComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AaFeeChangeModalComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Do you want to recalculate it?'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'col-sm-6 col-sm-offset-3 margin-top-20']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-primary btn-round'], ['type', 'submit']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.save(true) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Yes '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-white btn-round pull-right'],
            ['type', 'submit']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.save(false) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' No '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 4, 0, true, false);
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = (((_co.order == null) ? null : ((_co.order.Currency == null) ? null : _co.order.Currency.Name)) && ((_co.order == null) ? null : ((_co.order.Totals == null) ? null : _co.order.Totals.BorderBuddyCustoms)));
        _ck(_v, 25, 0, currVal_1);
        var currVal_2 = (!((_co.order == null) ? null : ((_co.order.Currency == null) ? null : _co.order.Currency.Name)) || !((_co.order == null) ? null : ((_co.order.Totals == null) ? null : _co.order.Totals.BorderBuddyCustoms)));
        _ck(_v, 28, 0, currVal_2);
    }, null);
}
function View_AaFeeChangeModalComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'aa-fee-change-modal', [], null, null, null, View_AaFeeChangeModalComponent_0, RenderType_AaFeeChangeModalComponent)), core_es5["ɵdid"](49152, null, 0, aafee_change_modal_component_AaFeeChangeModalComponent, [], null, null)], null, null);
}
var AaFeeChangeModalComponentNgFactory = core_es5["ɵccf"]('aa-fee-change-modal', aafee_change_modal_component_AaFeeChangeModalComponent, View_AaFeeChangeModalComponent_Host_0, { order: 'order' }, { modalHidden: 'modalHidden' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=aafee-change-modal.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/ngx-wizard/ngx-wizard.es5.js
var ngx_wizard_es5 = __webpack_require__("0emy");

// CONCATENATED MODULE: ./compiled/node_modules/ngx-wizard/ngx-wizard.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var WizardModuleNgFactory = core_es5["ɵcmf"](ngx_wizard_es5["e" /* WizardModule */], [], function (_l) {
    return core_es5["ɵmod"]([core_es5["ɵmpd"](512, core_es5["ComponentFactoryResolver"], core_es5["ɵCodegenComponentFactoryResolver"], [[8, []], [3, core_es5["ComponentFactoryResolver"]], core_es5["NgModuleRef"]]), core_es5["ɵmpd"](4608, common_es5["NgLocalization"], common_es5["NgLocaleLocalization"], [core_es5["LOCALE_ID"]]), core_es5["ɵmpd"](512, common_es5["CommonModule"], common_es5["CommonModule"], []), core_es5["ɵmpd"](512, ngx_wizard_es5["e" /* WizardModule */], ngx_wizard_es5["e" /* WizardModule */], [])]);
});
var styles_WizardComponent = [];
var RenderType_WizardComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_WizardComponent, data: {} });
function View_WizardComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class',
                'progress']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['\n              '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'progress-bar'], ['role', 'progressbar']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), core_es5["ɵpod"]({ 'width': 0 }),
        (_l()(), core_es5["ɵted"](null, ['\n              '])), (_l()(), core_es5["ɵted"](null, ['\n          ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 4, 0, (_co.progress + '%'));
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_WizardComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 14, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['\n                      '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'li', [], [[2, 'active', null]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = ((_v.context.$implicit.active = true) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['\n                          '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 8, 'a', [['data-toggle', 'tab'], ['role',
                'tab']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), (_l()(),
            core_es5["ɵted"](null, ['\n                              '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, ['\n                              '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'tab-info']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['\n                                  ', '\n                              '])),
        (_l()(), core_es5["ɵted"](null, ['\n                          '])), (_l()(), core_es5["ɵted"](null, ['\n                      '])), (_l()(), core_es5["ɵted"](null, ['\n                  ']))], function (_ck, _v) {
        var currVal_1 = _v.context.$implicit.customClass;
        _ck(_v, 5, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.active;
        _ck(_v, 2, 0, currVal_0);
        var currVal_2 = _v.context.$implicit.icon;
        _ck(_v, 8, 0, currVal_2);
        var currVal_3 = _v.context.$implicit.heading;
        _ck(_v, 11, 0, currVal_3);
    });
}
function View_WizardComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'nav-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['\n              '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [['class', 'nav nav-pills nav-pills-warning nav-pills-icons'],
            ['role', 'tablist']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n                  '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WizardComponent_3)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n              '])), (_l()(), core_es5["ɵted"](null, ['\n          ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.tabs;
        _ck(_v, 5, 0, currVal_0);
    }, null);
}
function View_WizardComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 9, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['\n                      '])), (_l()(), core_es5["ɵeld"](16777216, null, null, 1, null, null, null, null, null, null, null)), core_es5["ɵdid"](540672, null, 0, common_es5["NgTemplateOutlet"], [core_es5["ViewContainerRef"]], { ngTemplateOutlet: [0,
                'ngTemplateOutlet'] }, null), (_l()(), core_es5["ɵted"](null, ['\n                      '])),
        (_l()(), core_es5["ɵeld"](16777216, null, null, 1, null, null, null, null, null, null, null)),
        core_es5["ɵdid"](540672, null, 0, common_es5["NgTemplateOutlet"], [core_es5["ViewContainerRef"]], { ngTemplateOutlet: [0,
                'ngTemplateOutlet'] }, null), (_l()(), core_es5["ɵted"](null, ['\n                      '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'clearfix']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['\n                  ']))], function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v.parent.parent, 25);
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = core_es5["ɵnov"](_v.parent.parent, 27);
        _ck(_v, 6, 0, currVal_1);
    }, null);
}
function View_WizardComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](16777216, null, null, 2, null, null, null, null, null, null, null)),
        core_es5["ɵdid"](540672, null, 0, common_es5["NgTemplateOutlet"], [core_es5["ViewContainerRef"]], { ngTemplateOutlet: [0,
                'ngTemplateOutlet'] }, null), (_l()(), core_es5["ɵted"](null, ['\n\n                  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.activeTab.buttonTemplate;
        _ck(_v, 1, 0, currVal_0);
    }, null);
}
function View_WizardComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'wizard-footer']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['\n                  '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WizardComponent_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n\n                  '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WizardComponent_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n              ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.activeTab.buttonTemplate;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _co.activeTab.buttonTemplate;
        _ck(_v, 6, 0, currVal_1);
    }, null);
}
function View_WizardComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'i', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpad"](1), (_l()(), core_es5["ɵted"](null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, _co.nextIconClass);
        _ck(_v, 1, 0, currVal_0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.nextIconText;
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_WizardComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class',
                'btn-container nextButton']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.nextTab() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpad"](2), (_l()(), core_es5["ɵted"](null, ['\n              '])),
        (_l()(), core_es5["ɵeld"](0, [['nextButton', 1]], null, 2, 'input', [['name', 'next'],
            ['type', 'button']], [[8, 'value', 0]], null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null),
        core_es5["ɵpad"](1), (_l()(), core_es5["ɵted"](null, ['\n              '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WizardComponent_9)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n          ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'btn-container nextButton';
        var currVal_1 = _ck(_v, 2, 0, (_co.activeTab.isNextButtonDisabled ? 'disabled' : ''), _co.nextButtonContainerClass);
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_3 = _ck(_v, 6, 0, _co.nextButtonClass);
        _ck(_v, 5, 0, currVal_3);
        var currVal_4 = (_co.nextIconText && _co.nextIconClass);
        _ck(_v, 9, 0, currVal_4);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.nextButtonText;
        _ck(_v, 4, 0, currVal_2);
    });
}
function View_WizardComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, ['\n          '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WizardComponent_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.nextButtonVisible;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_WizardComponent_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'i', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpad"](1), (_l()(), core_es5["ɵted"](null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, _co.prevIconClass);
        _ck(_v, 1, 0, currVal_0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.prevIconText;
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_WizardComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class',
                'btn-container previousButton']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.previousTab() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpad"](2), (_l()(), core_es5["ɵted"](null, ['\n              '])),
        (_l()(), core_es5["ɵeld"](0, [['previosButton', 1]], null, 2, 'input', [['name', 'previous'],
            ['type', 'button']], [[8, 'value', 0]], null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null),
        core_es5["ɵpad"](1), (_l()(), core_es5["ɵted"](null, ['\n              '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WizardComponent_12)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n          ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'btn-container previousButton';
        var currVal_1 = _ck(_v, 2, 0, (_co.activeTab.isPrevButtonDisabled ? 'disabled' : ''), _co.previousButtonContainerClass);
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_3 = _ck(_v, 6, 0, _co.prevButtonClass);
        _ck(_v, 5, 0, currVal_3);
        var currVal_4 = (_co.prevIconText && _co.prevIconClass);
        _ck(_v, 9, 0, currVal_4);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.previousButtonText;
        _ck(_v, 4, 0, currVal_2);
    });
}
function View_WizardComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, ['\n          '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WizardComponent_11)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.previousButtonVisible;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_WizardComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { previousButtonRef: 0 }), core_es5["ɵqud"](402653184, 2, { continueButtonRef: 0 }), (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'wizard-container']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['\n\n          '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WizardComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n\n          '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_WizardComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n\n          '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['id', 'wizardProfile']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['\n              '])), core_es5["ɵncd"](null, 0),
        (_l()(), core_es5["ɵted"](null, ['\n\n              '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'tab-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['\n                  '])), core_es5["ɵncd"](null, 1), (_l()(), core_es5["ɵted"](null, ['\n              '])), (_l()(), core_es5["ɵted"](null, ['\n\n              '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WizardComponent_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n          '])),
        (_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵted"](null, ['\n\n      '])),
        (_l()(), core_es5["ɵand"](0, [[2, 2], ['continueButton', 2]], null, 0, null, View_WizardComponent_7)), (_l()(), core_es5["ɵted"](null, ['\n\n      '])),
        (_l()(), core_es5["ɵand"](0, [[1, 2], ['prevButton', 2]], null, 0, null, View_WizardComponent_10)),
        (_l()(), core_es5["ɵted"](null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.showProgressBar;
        _ck(_v, 6, 0, currVal_0);
        var currVal_1 = _co.showHeader;
        _ck(_v, 9, 0, currVal_1);
        var currVal_2 = _co.activeTab;
        _ck(_v, 21, 0, currVal_2);
    }, null);
}
function View_WizardComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'wizard', [], null, null, null, View_WizardComponent_0, RenderType_WizardComponent)),
        core_es5["ɵprd"](6144, null, ngx_wizard_es5["c" /* TabsComponent */], null, [ngx_wizard_es5["d" /* WizardComponent */]]),
        core_es5["ɵdid"](4440064, null, 0, ngx_wizard_es5["d" /* WizardComponent */], [core_es5["ElementRef"]], null, null)], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
var WizardComponentNgFactory = core_es5["ɵccf"]('wizard', ngx_wizard_es5["d" /* WizardComponent */], View_WizardComponent_Host_0, { tabsClass: 'class', tabsType: 'type',
    classMap: 'navClass', nextButtonClass: 'nextButtonClass', prevButtonClass: 'prevButtonClass',
    nextIconClass: 'nextIconClass', nextIconText: 'nextIconText', prevIconClass: 'prevIconClass',
    prevIconText: 'prevIconText', previousButtonContainerClass: 'previousButtonContainerClass',
    nextButtonContainerClass: 'nextButtonContainerClass', previousButton: 'previousButton',
    nextButton: 'nextButton', showProgressBar: 'showProgressBar', showHeader: 'showHeader',
    scrollClassRef: 'scrollClassRef' }, { finish: 'finish' }, ['.wizard-header', '*']);
var styles_TabsComponent = [];
var RenderType_TabsComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_TabsComponent, data: {} });
function View_TabsComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class',
                'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.icon;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_TabsComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 12, 'li', [], [[2, 'active', null], [2, 'disabled', null]], null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null),
        core_es5["ɵpad"](2), (_l()(), core_es5["ɵted"](null, ['\n                  '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'a', [['class', 'nav-link'], ['href',
                    'javascript:void(0);']], [[2, 'active', null], [2, 'disabled', null]], [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                if (('click' === en)) {
                    var pd_0 = ((_v.context.$implicit.active = true) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), (_l()(), core_es5["ɵted"](null, ['\n                      '])),
        (_l()(), core_es5["ɵeld"](16777216, null, null, 4, 'span', [], null, null, null, null, null)),
        core_es5["ɵdid"](16384, null, 0, ngx_wizard_es5["a" /* NgTranscludeDirective */], [core_es5["ViewContainerRef"]], { ngTransclude: [0, 'ngTransclude'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TabsComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, ['\n                  '])), (_l()(), core_es5["ɵted"](null, ['\n              ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _ck(_v, 2, 0, 'nav-item', (_v.context.$implicit.customClass || ''));
        _ck(_v, 1, 0, currVal_2);
        var currVal_5 = _v.context.$implicit.headingRef;
        _ck(_v, 7, 0, currVal_5);
        var currVal_6 = !_co.stringHelper.isNullOrEmpty(_v.context.$implicit.icon);
        _ck(_v, 9, 0, currVal_6);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.active;
        var currVal_1 = _v.context.$implicit.disabled;
        _ck(_v, 0, 0, currVal_0, currVal_1);
        var currVal_3 = _v.context.$implicit.active;
        var currVal_4 = _v.context.$implicit.disabled;
        _ck(_v, 4, 0, currVal_3, currVal_4);
        var currVal_7 = _v.context.$implicit.heading;
        _ck(_v, 10, 0, currVal_7);
    });
}
function View_TabsComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), (_l()(), core_es5["ɵted"](null, ['\n          '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 5, 'ul', [['class', 'nav']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = ($event.preventDefault() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), (_l()(), core_es5["ɵted"](null, ['\n              '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TabsComponent_1)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, ['\n          '])), (_l()(),
            core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵted"](null, ['\n      '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'tab-content']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['\n          '])), core_es5["ɵncd"](null, 0), (_l()(),
            core_es5["ɵted"](null, ['\n      '])), (_l()(), core_es5["ɵted"](null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.tabsClass;
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = 'nav';
        var currVal_2 = _co.classMap;
        _ck(_v, 5, 0, currVal_1, currVal_2);
        var currVal_3 = _co.tabs;
        _ck(_v, 8, 0, currVal_3);
    }, null);
}
function View_TabsComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'tabs', [], null, null, null, View_TabsComponent_0, RenderType_TabsComponent)),
        core_es5["ɵdid"](4440064, null, 0, ngx_wizard_es5["c" /* TabsComponent */], [], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var TabsComponentNgFactory = core_es5["ɵccf"]('tabs', ngx_wizard_es5["c" /* TabsComponent */], View_TabsComponent_Host_0, { tabsClass: 'class', tabsType: 'type',
    classMap: 'navClass' }, {}, ['*']);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=ngx-wizard.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/calculator.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
























var styles_CalculatorComponent = [];
var RenderType_CalculatorComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CalculatorComponent, data: {} });
function View_CalculatorComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class',
                'row order-id mobile-show']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'order-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Quote ID:'])),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order.Id;
        _ck(_v, 5, 0, currVal_0);
    });
}
function View_CalculatorComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'management-search', [['createIcon', 'iso']], null, [[null, 'searchEventEmitter'], [null,
                'queryChange'], [null, 'createEventEmitter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('searchEventEmitter' === en)) {
                var pd_0 = (_co.goToSearch() !== false);
                ad = (pd_0 && ad);
            }
            if (('queryChange' === en)) {
                var pd_1 = ((_co.query = $event) !== false);
                ad = (pd_1 && ad);
            }
            if (('createEventEmitter' === en)) {
                var pd_2 = (_co.createEvent() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, View_ManagementSearchComponent_0, RenderType_ManagementSearchComponent)),
        core_es5["ɵdid"](49152, null, 0, managementSearch_component_ManagementSearchComponent, [], { showCreate: [0,
                'showCreate'], createIcon: [1, 'createIcon'], query: [2, 'query'], showCleanFilter: [3,
                'showCleanFilter'] }, { searchEventEmitter: 'searchEventEmitter', createEventEmitter: 'createEventEmitter',
            queryChange: 'queryChange' }), (_l()(), core_es5["ɵted"](0, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = true;
        var currVal_1 = 'iso';
        var currVal_2 = _co.query;
        var currVal_3 = !_co.stringLink.isNullOrEmpty(_co.query);
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_CalculatorComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'spinner']], null, null, null, null, null))], null, null);
}
function View_CalculatorComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'fill-order-tab', [], null, [[null, 'orderChange'], [null, 'extraDataChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('orderChange' === en)) {
                var pd_0 = ((_co.order = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('extraDataChange' === en)) {
                var pd_1 = ((_co.extraData = $event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_FillOrderTabComponent_0, RenderType_FillOrderTabComponent)), core_es5["ɵdid"](49152, [[1, 4], ['fillOrder', 4]], 0, fill_order_tab_component_FillOrderTabComponent, [core_es5["Renderer2"]], { order: [0,
                'order'], canadianCurrencyCodes: [1, 'canadianCurrencyCodes'], wizard: [2, 'wizard'],
            extraData: [3, 'extraData'], disableChanges: [4, 'disableChanges'], isPublic: [5,
                'isPublic'], isOrderDetails: [6, 'isOrderDetails'], sendCustomer: [7, 'sendCustomer'] }, { extraDataChange: 'extraDataChange' })], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order;
        var currVal_1 = _co.canadianCurrencyCodes;
        var currVal_2 = core_es5["ɵnov"](_v.parent, 23);
        var currVal_3 = _co.extraData;
        var currVal_4 = _co.disableChanges;
        var currVal_5 = _co.isPublic;
        var currVal_6 = _co.isOrderDetails;
        var currVal_7 = _co.sendCustomer;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
    }, null);
}
function View_CalculatorComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'spinner']], null, null, null, null, null))], null, null);
}
function View_CalculatorComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'calculator-tab', [], null, [[null, 'orderChange'], [null, 'clonedOrderChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('orderChange' === en)) {
                var pd_0 = ((_co.order = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('orderChange' === en)) {
                var pd_1 = (_co.orderChange.emit($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('clonedOrderChange' === en)) {
                var pd_2 = ((_co.clonedOrder = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, View_CalculatorTabComponent_0, RenderType_CalculatorTabComponent)), core_es5["ɵdid"](4243456, [[6, 4]], 0, calculatorTab_component_CalculatorTabComponent, [toast_manager["ToastsManager"], services_orderService["a" /* OrderService */], router_es5["n" /* Router */],
            services_emailService["a" /* EmailService */], services_configService["a" /* ConfigService */], uploadService_UploadService], { isPublic: [0, 'isPublic'],
            order: [1, 'order'], wizard: [2, 'wizard'], canadianCurrencyCodes: [3, 'canadianCurrencyCodes'],
            disableChanges: [4, 'disableChanges'], isOrderDetails: [5, 'isOrderDetails'],
            orderDataComp: [6, 'orderDataComp'], clonedOrder: [7, 'clonedOrder'] }, { orderChange: 'orderChange' })], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isPublic;
        var currVal_1 = _co.order;
        var currVal_2 = core_es5["ɵnov"](_v.parent, 23);
        var currVal_3 = _co.canadianCurrencyCodes;
        var currVal_4 = _co.disableChanges;
        var currVal_5 = _co.isOrderDetails;
        var currVal_6 = _co.orderDataComponent;
        var currVal_7 = _co.clonedOrder;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
    }, null);
}
function View_CalculatorComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'spinner']], null, null, null, null, null))], null, null);
}
function View_CalculatorComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'order-data', [], null, [[null, 'orderChange'], [null, 'tabChanged']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('orderChange' === en)) {
                var pd_0 = ((_co.order = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('orderChange' === en)) {
                var pd_1 = (_co.orderChange.emit($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('tabChanged' === en)) {
                var pd_2 = (_co.tabChanged.emit($event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, View_OrderDataComponent_0, RenderType_OrderDataComponent)), core_es5["ɵdid"](638976, [[4, 4]], 0, orderData_component_OrderDataComponent, [toast_manager["ToastsManager"], services_orderService["a" /* OrderService */], services_configService["a" /* ConfigService */],
            orderContentService_OrderContentService, services_emailService["a" /* EmailService */], router_es5["a" /* ActivatedRoute */]], { order: [0, 'order'] }, { orderChange: 'orderChange', tabChanged: 'tabChanged' }), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order;
        _ck(_v, 1, 0, currVal_0);
    }, null);
}
function View_CalculatorComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](671088640, 1, { fillOrderTab: 0 }), core_es5["ɵqud"](402653184, 2, { calculatorWizard: 0 }),
        core_es5["ɵqud"](402653184, 3, { tabDirective: 0 }), core_es5["ɵqud"](671088640, 4, { orderDataComponent: 0 }),
        core_es5["ɵqud"](402653184, 5, { orderDataTab: 0 }), core_es5["ɵqud"](671088640, 6, { calculatorTabComponent: 0 }),
        core_es5["ɵqud"](402653184, 7, { aaChangeModal: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'aa-fee-change-modal', [], null, [[null, 'modalHidden']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('modalHidden' === en)) {
                var pd_0 = (_co.modalHiddenHandler($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_AaFeeChangeModalComponent_0, RenderType_AaFeeChangeModalComponent)),
        core_es5["ɵdid"](49152, [[7, 4], ['aaChangeModal', 4]], 0, aafee_change_modal_component_AaFeeChangeModalComponent, [], { order: [0, 'order'] }, { modalHidden: 'modalHidden' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 52, 'div', [['class',
                'main-content calculator'], ['id', 'calculator']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 46, 'div', [['class',
                'container-fluid']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 40, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 37, 'wizard', [['data-color',
                'cyan']], null, null, null, View_WizardComponent_0, RenderType_WizardComponent)), core_es5["ɵdid"](4440064, [[2, 4], ['calculatorWizard',
                4]], 0, ngx_wizard_es5["d" /* WizardComponent */], [core_es5["ElementRef"]], null, null), core_es5["ɵprd"](2048, null, ngx_wizard_es5["c" /* TabsComponent */], null, [ngx_wizard_es5["d" /* WizardComponent */]]), (_l()(),
            core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 8, 'tab', [['heading',
                'Customer and Product Information'], ['icon', 'info_outline'], ['nextButton',
                'hidden']], [[2, 'active', null], [2, 'tab-pane', null]], [[null,
                'check'], [null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('check' === en)) {
                var pd_0 = (_co.checkFillOrderForm($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('isSelect' === en)) {
                var pd_1 = (_co.onFistTabSelected() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, [[3, 4]], 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */],
            core_es5["ElementRef"]], { heading: [0, 'heading'], icon: [1, 'icon'], nextButton: [2, 'nextButton'],
            index: [3, 'index'], active: [4, 'active'] }, { check: 'check', isSelect: 'isSelect' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorComponent_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 8, 'tab', [['heading',
                'Rate Calculator'], ['nextButton', 'hidden'], ['previousButton', 'hidden']], [[2, 'active', null], [2, 'tab-pane', null]], [[null,
                'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('isSelect' === en)) {
                var pd_0 = ((((_co.firstAttempt && (_co.order.Status == _co.orderStatus.Calculated)) && _co.isFirstTabOpened) ? _co.calculateOrder($event) : _co.showModal($event)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, [[3, 4]], 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { heading: [0, 'heading'], icon: [1, 'icon'],
            previousButton: [2, 'previousButton'], nextButton: [3, 'nextButton'], index: [4,
                'index'], active: [5, 'active'] }, { isSelect: 'isSelect' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorComponent_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorComponent_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, [[5, 0], ['orderDataTab',
                1]], 1, 8, 'tab', [['heading', 'Order Data'], ['icon', 'assignment'], ['nextButton',
                'hidden'], ['previousButton', 'hidden']], [[2, 'active', null], [2, 'tab-pane',
                null]], [[null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('isSelect' === en)) {
                var pd_0 = ((_co.isFirstTabOpened = false) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, [[3, 4]], 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */],
            core_es5["ElementRef"]], { heading: [0, 'heading'], disabled: [1, 'disabled'], icon: [2, 'icon'],
            previousButton: [3, 'previousButton'], nextButton: [4, 'nextButton'], index: [5,
                'index'], active: [6, 'active'] }, { isSelect: 'isSelect' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorComponent_7)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalculatorComponent_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 2, 'tab', [['nextButton', 'hidden'], ['previousButton', 'hidden']], [[2, 'active', null],
            [2, 'tab-pane', null]], null, null, null, null)), core_es5["ɵdid"](212992, [[3, 4]], 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */],
            core_es5["ElementRef"]], { heading: [0, 'heading'], disabled: [1, 'disabled'], icon: [2, 'icon'],
            previousButton: [3, 'previousButton'], nextButton: [4, 'nextButton'], index: [5,
                'index'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order;
        _ck(_v, 8, 0, currVal_0);
        var currVal_1 = ((core_es5["ɵnov"](_v, 23).activeTab && (core_es5["ɵnov"](_v, 23).activeTab.index == 1)) && !_co.hideQuote);
        _ck(_v, 13, 0, currVal_1);
        var currVal_2 = !_co.isPublic;
        _ck(_v, 18, 0, currVal_2);
        _ck(_v, 23, 0);
        var currVal_5 = 'Customer and Product Information';
        var currVal_6 = 'info_outline';
        var currVal_7 = 'hidden';
        var currVal_8 = 0;
        var currVal_9 = (_co.order.Status < _co.orderStatus.Calculated);
        _ck(_v, 27, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9);
        var currVal_10 = !_co.order;
        _ck(_v, 30, 0, currVal_10);
        var currVal_11 = _co.order;
        _ck(_v, 33, 0, currVal_11);
        var currVal_14 = 'Rate Calculator';
        var currVal_15 = 'iso';
        var currVal_16 = 'hidden';
        var currVal_17 = 'hidden';
        var currVal_18 = 1;
        var currVal_19 = ((_co.firstAttempt && (_co.order.Status == _co.orderStatus.Calculated)) ? 'class.active' : '');
        _ck(_v, 37, 0, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19);
        var currVal_20 = _co.isProcessing;
        _ck(_v, 40, 0, currVal_20);
        var currVal_21 = !_co.isProcessing;
        _ck(_v, 43, 0, currVal_21);
        var currVal_24 = 'Order Data';
        var currVal_25 = ((_co.order.Status == _co.orderStatus.Calculated) || _co.isPublic);
        var currVal_26 = 'assignment';
        var currVal_27 = 'hidden';
        var currVal_28 = 'hidden';
        var currVal_29 = 2;
        var currVal_30 = ((_co.firstAttempt && (_co.order.Status > _co.orderStatus.Calculated)) ? 'class.active' : '');
        _ck(_v, 47, 0, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30);
        var currVal_31 = !_co.order;
        _ck(_v, 50, 0, currVal_31);
        var currVal_32 = (_co.order && _co.isOrderDetails);
        _ck(_v, 53, 0, currVal_32);
        var currVal_35 = 'Other Information';
        var currVal_36 = true;
        var currVal_37 = 'help_outline';
        var currVal_38 = 'hidden';
        var currVal_39 = 'hidden';
        var currVal_40 = 3;
        _ck(_v, 57, 0, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40);
    }, function (_ck, _v) {
        var currVal_3 = core_es5["ɵnov"](_v, 27).active;
        var currVal_4 = core_es5["ɵnov"](_v, 27).addClass;
        _ck(_v, 26, 0, currVal_3, currVal_4);
        var currVal_12 = core_es5["ɵnov"](_v, 37).active;
        var currVal_13 = core_es5["ɵnov"](_v, 37).addClass;
        _ck(_v, 36, 0, currVal_12, currVal_13);
        var currVal_22 = core_es5["ɵnov"](_v, 47).active;
        var currVal_23 = core_es5["ɵnov"](_v, 47).addClass;
        _ck(_v, 46, 0, currVal_22, currVal_23);
        var currVal_33 = core_es5["ɵnov"](_v, 57).active;
        var currVal_34 = core_es5["ɵnov"](_v, 57).addClass;
        _ck(_v, 56, 0, currVal_33, currVal_34);
    });
}
function View_CalculatorComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'calculator', [], null, null, null, View_CalculatorComponent_0, RenderType_CalculatorComponent)),
        core_es5["ɵdid"](114688, null, 0, calculator_component_CalculatorComponent, [services_orderService["a" /* OrderService */], router_es5["a" /* ActivatedRoute */],
            services_extraDataService["a" /* ExtraDataService */], router_es5["n" /* Router */], publisher_service_PublisherService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CalculatorComponentNgFactory = core_es5["ɵccf"]('calculator', calculator_component_CalculatorComponent, View_CalculatorComponent_Host_0, { order: 'order', extraData: 'extraData',
    isOrderDetails: 'isOrderDetails', isPublic: 'isPublic', mainElement: 'mainElement' }, { orderChange: 'orderChange', tabChanged: 'tabChanged' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=calculator.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/objects/currencyExchange/currencyEnum.ts
var currencyEnum = __webpack_require__("7P1x");

// CONCATENATED MODULE: ./app/common/helpers/colorHelper.ts
/**
 * Created by alex.y on 7/21/2017.
 */
var ColorHelper = /** @class */ (function () {
    function ColorHelper() {
    }
    ColorHelper.colorGenerate = function (numOfSteps, step) {
        var r, g, b;
        var h = step / numOfSteps;
        var i = ~~(h * 6);
        var f = h * 6 - i;
        var q = 1 - f;
        switch (i % 6) {
            case 0:
                r = 1;
                g = f;
                b = 0;
                break;
            case 1:
                r = q;
                g = 1;
                b = 0;
                break;
            case 2:
                r = 0;
                g = 1;
                b = f;
                break;
            case 3:
                r = 0;
                g = q;
                b = 1;
                break;
            case 4:
                r = f;
                g = 0;
                b = 1;
                break;
            case 5:
                r = 1;
                g = 0;
                b = q;
                break;
        }
        var c = "#" + ("00" + (~~(r * 255)).toString(16)).slice(-2) + ("00" + (~~(g * 255)).toString(16)).slice(-2) + ("00" + (~~(b * 255)).toString(16)).slice(-2);
        return (c);
    };
    ColorHelper.intToRGB = function (i) {
        var c = (i & 0x00FFFFFF)
            .toString(16)
            .toUpperCase();
        return "00000".substring(0, 6 - c.length) + c;
    };
    return ColorHelper;
}());

//# sourceMappingURL=colorHelper.js.map
// CONCATENATED MODULE: ./app/components/currencyExchange/currencyChart/currencyChart.component.ts


/**
 * Created by alex.y on 7/19/2017.
 */
var currencyChart_component_CurrencyChartComponent = /** @class */ (function () {
    function CurrencyChartComponent() {
        this.currencyItems = [];
        /* Chart Settings Start */
        // lineChart
        this.lineChartData = [];
        this.lineChartLabels = [];
        this.lineChartOptions = {
            responsive: true,
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true
                },
            }
        };
        this.lineChartColors = [];
        this.lineChartLegend = true;
        this.lineChartType = 'line';
        /* Chart Settings End*/
        this.excludeArray = [currencyEnum["a" /* CurrencyEnum */].FXBRLCAD, currencyEnum["a" /* CurrencyEnum */].FXCNYCAD,
            currencyEnum["a" /* CurrencyEnum */].FXHKDCAD, currencyEnum["a" /* CurrencyEnum */].FXINRCAD, currencyEnum["a" /* CurrencyEnum */].FXIDRCAD, currencyEnum["a" /* CurrencyEnum */].FXMYRCAD, currencyEnum["a" /* CurrencyEnum */].FXNOKCAD, currencyEnum["a" /* CurrencyEnum */].FXPENCAD,
            currencyEnum["a" /* CurrencyEnum */].FXRUBCAD, currencyEnum["a" /* CurrencyEnum */].FXSARCAD, currencyEnum["a" /* CurrencyEnum */].FXSGDCAD, currencyEnum["a" /* CurrencyEnum */].FXZARCAD, currencyEnum["a" /* CurrencyEnum */].FXKRWCAD, currencyEnum["a" /* CurrencyEnum */].FXCHFCAD,
            currencyEnum["a" /* CurrencyEnum */].FXTWDCAD, currencyEnum["a" /* CurrencyEnum */].FXTHBCAD, currencyEnum["a" /* CurrencyEnum */].FXTRYCAD, currencyEnum["a" /* CurrencyEnum */].FXVNDCAD];
    }
    CurrencyChartComponent.prototype.ngOnInit = function () {
        this.setChartData();
        this.generateColors();
    };
    CurrencyChartComponent.prototype.setChartData = function () {
        var i = 0;
        var _loop_1 = function (item) {
            if (++i == 26)
                return "break";
            if (this_1.excludeArray.find(function (x) { return x.toString() == String.getEnumValue(item.Name, currencyEnum["a" /* CurrencyEnum */]); })) {
                return "continue";
            }
            data = this_1.getCurrencyValues(item.Name);
            this_1.lineChartData.push({
                data: data,
                label: String.getEnumValue(item.Name, currencyEnum["a" /* CurrencyEnum */])
            });
        };
        var this_1 = this, data;
        for (var _i = 0, _a = this.currencyItems; _i < _a.length; _i++) {
            var item = _a[_i];
            var state_1 = _loop_1(item);
            if (state_1 === "break")
                break;
        }
    };
    CurrencyChartComponent.prototype.getCurrencyValues = function (name, addLabel) {
        if (addLabel === void 0) { addLabel = true; }
        var items = this.currencyItems.filter(function (x) { return x.Name == name; });
        var itemValues = new Array();
        var _loop_2 = function (it) {
            if (it.Value < 0)
                return "continue";
            itemValues.push(it.Value);
            if (!addLabel)
                return "continue";
            var date = String.formatDateMMDDYYYY(it.Date.toString());
            if (!this_2.lineChartLabels.find(function (x) { return x == date; }))
                this_2.lineChartLabels.push(date);
        };
        var this_2 = this;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var it = items_1[_i];
            _loop_2(it);
        }
        return itemValues;
    };
    CurrencyChartComponent.prototype.generateColors = function () {
        for (var i = 1; i < /*this.lineChartLabels.length + 1*/ 9; i++) {
            var color = ColorHelper.colorGenerate(this.lineChartLabels.length + 1, i * 8);
            this.lineChartColors.push({
                fill: false,
                backgroundColor: color,
                borderColor: color,
                pointBackgroundColor: color,
                pointBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: color,
            });
        }
    };
    return CurrencyChartComponent;
}());

//# sourceMappingURL=currencyChart.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/currencyExchange/currencyChart/currencyChart.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_CurrencyChartComponent = [];
var RenderType_CurrencyChartComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CurrencyChartComponent, data: {} });
function View_CurrencyChartComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'chart-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'canvas', [['baseChart', ''], ['height', '150'], ['width', '400']], null, null, null, null, null)), core_es5["ɵdid"](737280, null, 0, charts["BaseChartDirective"], [core_es5["ElementRef"]], { datasets: [0, 'datasets'],
            labels: [1, 'labels'], options: [2, 'options'], chartType: [3, 'chartType'],
            colors: [4, 'colors'], legend: [5, 'legend'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.lineChartData;
        var currVal_1 = _co.lineChartLabels;
        var currVal_2 = _co.lineChartOptions;
        var currVal_3 = _co.lineChartType;
        var currVal_4 = _co.lineChartColors;
        var currVal_5 = _co.lineChartLegend;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    }, null);
}
function View_CurrencyChartComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'currency-chart', [], null, null, null, View_CurrencyChartComponent_0, RenderType_CurrencyChartComponent)), core_es5["ɵdid"](114688, null, 0, currencyChart_component_CurrencyChartComponent, [], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CurrencyChartComponentNgFactory = core_es5["ɵccf"]('currency-chart', currencyChart_component_CurrencyChartComponent, View_CurrencyChartComponent_Host_0, { currencyItems: 'currencyItems' }, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY3VycmVuY3lFeGNoYW5nZS9jdXJyZW5jeUNoYXJ0L2N1cnJlbmN5Q2hhcnQuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL2N1cnJlbmN5RXhjaGFuZ2UvY3VycmVuY3lDaGFydC9jdXJyZW5jeUNoYXJ0LmNvbXBvbmVudC50cyIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL2N1cnJlbmN5RXhjaGFuZ2UvY3VycmVuY3lDaGFydC9jdXJyZW5jeUNoYXJ0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY3VycmVuY3lFeGNoYW5nZS9jdXJyZW5jeUNoYXJ0L2N1cnJlbmN5Q2hhcnQuY29tcG9uZW50LnRzLkN1cnJlbmN5Q2hhcnRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwiY2hhcnQtd3JhcHBlclwiPiA8Y2FudmFzIGJhc2VDaGFydCB3aWR0aD1cIjQwMFwiIGhlaWdodD1cIjE1MFwiIFtkYXRhc2V0c109XCJsaW5lQ2hhcnREYXRhXCIgW2xhYmVsc109XCJsaW5lQ2hhcnRMYWJlbHNcIiBbb3B0aW9uc109XCJsaW5lQ2hhcnRPcHRpb25zXCIgW2NvbG9yc109XCJsaW5lQ2hhcnRDb2xvcnNcIiBbbGVnZW5kXT1cImxpbmVDaGFydExlZ2VuZFwiIFtjaGFydFR5cGVdPVwibGluZUNoYXJ0VHlwZVwiPiA8L2NhbnZhcz4gPC9kaXY+IiwiPGN1cnJlbmN5LWNoYXJ0PjwvY3VycmVuY3ktY2hhcnQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBMkIsc0NBQUM7VUFBQTtVQUFBLGlFQUFBO1VBQUE7Y0FBQTtjQUFBLHdEQUFnTjtVQUFBLFFBQVU7O0lBQS9LO0lBQTJCO0lBQTJCO0lBQW1GO0lBQXREO0lBQTJCO0lBQXpKLFdBQTJDLFVBQTJCLFVBQTJCLFVBQW1GLFVBQXRELFVBQTJCLFNBQXpKOzs7O29CQ0E1QjtNQUFBO3VDQUFBLFVBQUE7TUFBQTtJQUFBOzs7OzsifQ==
//# sourceMappingURL=currencyChart.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/objects/currencyExchange/currencyTableItem.ts
/**
 * Created by alex.y on 7/20/2017.
 */
var TableItem = /** @class */ (function () {
    function TableItem(obj) {
        this.Items = [];
        Object.assign(this, obj);
    }
    return TableItem;
}());

//# sourceMappingURL=currencyTableItem.js.map
// CONCATENATED MODULE: ./app/components/currencyExchange/currencyTable/currencyTable.component.ts


/**
 * Created by alex.y on 7/20/2017.
 */
var currencyTable_component_CurrencyTableComponent = /** @class */ (function () {
    function CurrencyTableComponent() {
        this.currencyItems = [];
        this.tableItems = [];
        this.columns = [];
    }
    CurrencyTableComponent.prototype.ngOnInit = function () {
        this.initData();
    };
    CurrencyTableComponent.prototype.initData = function () {
        var i = 0;
        var _loop_1 = function (item) {
            if (++i == 26)
                return "break";
            var items = this_1.currencyItems.filter(function (x) { return x.Name == item.Name; }).splice(0, 5); //take only first 5 elements
            this_1.tableItems.push(new TableItem({
                Name: item.Name,
                Items: items
            }));
        };
        var this_1 = this;
        for (var _i = 0, _a = this.currencyItems; _i < _a.length; _i++) {
            var item = _a[_i];
            var state_1 = _loop_1(item);
            if (state_1 === "break")
                break;
        }
        if (this.tableItems.length <= 0)
            return;
        this.columns = [{
                cellTemplate: this.editTmpl,
                headerTemplate: this.hdrTpl,
                name: 'Currency'
            }];
        for (var i_1 = 0; i_1 < this.tableItems[0].Items.length; i_1++) {
            this.columns.push({
                cellTemplate: this.editTmp2,
                headerTemplate: this.hdrTp2,
                name: this.tableItems[0].Items[i_1].Date,
                index: i_1,
            });
        }
    };
    CurrencyTableComponent.prototype.convertName = function (name) {
        return String.getEnumValue(name, currencyEnum["a" /* CurrencyEnum */]);
    };
    return CurrencyTableComponent;
}());

//# sourceMappingURL=currencyTable.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/currencyExchange/currencyTable/currencyTable.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */







var styles_CurrencyTableComponent = [];
var RenderType_CurrencyTableComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CurrencyTableComponent, data: {} });
function View_CurrencyTableComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' ', ' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.column.name;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_CurrencyTableComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' ', ' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.convertName(_v.context.row.Name);
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_CurrencyTableComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' ', ' '])), core_es5["ɵppd"](2)], null, function (_ck, _v) {
        var currVal_0 = core_es5["ɵunv"](_v, 0, 0, _ck(_v, 1, 0, core_es5["ɵnov"](_v.parent, 0), _v.context.column.name, 'yMd'));
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_CurrencyTableComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' ', ' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.row.Items[_v.context.column.index].Value;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_CurrencyTableComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DatePipe"], [core_es5["LOCALE_ID"]]), core_es5["ɵqud"](402653184, 1, { editTmpl: 0 }),
        core_es5["ɵqud"](402653184, 2, { hdrTpl: 0 }), core_es5["ɵqud"](402653184, 3, { editTmp2: 0 }), core_es5["ɵqud"](402653184, 4, { hdrTp2: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'ngx-datatable', [['class', 'material striped table-bordered ngx-datatable']], [[2, 'fixed-header',
                null], [2, 'fixed-row', null], [2, 'scroll-vertical', null],
            [2, 'scroll-horz', null], [2, 'selectable', null], [2, 'checkbox-selection',
                null], [2, 'cell-selection', null], [2, 'single-selection',
                null], [2, 'multi-selection', null], [2, 'multi-click-selection',
                null]], [['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 6).onWindowResize() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_DatatableComponent_0, RenderType_DatatableComponent)), core_es5["ɵdid"](5619712, null, 4, datatable_component["DatatableComponent"], [[1, scrollbar_helper_service["ScrollbarHelper"]], [1, dimensions_helper_service["DimensionsHelper"]],
            core_es5["ChangeDetectorRef"], core_es5["ElementRef"], core_es5["KeyValueDiffers"]], { rows: [0, 'rows'],
            columns: [1, 'columns'], rowHeight: [2, 'rowHeight'], columnMode: [3, 'columnMode'] }, null), core_es5["ɵqud"](603979776, 5, { columnTemplates: 1 }), core_es5["ɵqud"](335544320, 6, { rowDetail: 0 }), core_es5["ɵqud"](335544320, 7, { groupHeader: 0 }), core_es5["ɵqud"](335544320, 8, { footer: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, [[2, 2], ['hdrTpl', 2]], null, 0, null, View_CurrencyTableComponent_1)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](0, [[1, 2], ['editTmpl', 2]], null, 0, null, View_CurrencyTableComponent_2)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, [[4, 2], ['hdrTp2', 2]], null, 0, null, View_CurrencyTableComponent_3)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, [[3, 2], ['editTmp2', 2]], null, 0, null, View_CurrencyTableComponent_4)), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_10 = _co.tableItems;
        var currVal_11 = _co.columns;
        var currVal_12 = 'auto';
        var currVal_13 = 'force';
        _ck(_v, 6, 0, currVal_10, currVal_11, currVal_12, currVal_13);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 6).isFixedHeader;
        var currVal_1 = core_es5["ɵnov"](_v, 6).isFixedRow;
        var currVal_2 = core_es5["ɵnov"](_v, 6).isVertScroll;
        var currVal_3 = core_es5["ɵnov"](_v, 6).isHorScroll;
        var currVal_4 = core_es5["ɵnov"](_v, 6).isSelectable;
        var currVal_5 = core_es5["ɵnov"](_v, 6).isCheckboxSelection;
        var currVal_6 = core_es5["ɵnov"](_v, 6).isCellSelection;
        var currVal_7 = core_es5["ɵnov"](_v, 6).isSingleSelection;
        var currVal_8 = core_es5["ɵnov"](_v, 6).isMultiSelection;
        var currVal_9 = core_es5["ɵnov"](_v, 6).isMultiClickSelection;
        _ck(_v, 5, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9);
    });
}
function View_CurrencyTableComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'currency-table', [], null, null, null, View_CurrencyTableComponent_0, RenderType_CurrencyTableComponent)), core_es5["ɵdid"](114688, null, 0, currencyTable_component_CurrencyTableComponent, [], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CurrencyTableComponentNgFactory = core_es5["ɵccf"]('currency-table', currencyTable_component_CurrencyTableComponent, View_CurrencyTableComponent_Host_0, { currencyItems: 'currencyItems' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=currencyTable.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/currencyExchange/currencyDashBoard.component.ts
/**
 * Created by alex.y on 7/19/2017.
 */

var currencyDashBoard_component_CurrencyDashBoardComponent = /** @class */ (function () {
    function CurrencyDashBoardComponent(route) {
        this.route = route;
        this.currencyArray = [];
    }
    CurrencyDashBoardComponent.prototype.ngOnInit = function () {
        this.currencyArray = this.route.snapshot.data.currencyItems;
    };
    CurrencyDashBoardComponent.ctorParameters = function () { return [{ type: router_es5["a" /* ActivatedRoute */] }]; };
    return CurrencyDashBoardComponent;
}());

//# sourceMappingURL=currencyDashBoard.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/currencyExchange/currencyDashBoard.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */







var styles_CurrencyDashBoardComponent = [];
var RenderType_CurrencyDashBoardComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CurrencyDashBoardComponent, data: {} });
function View_CurrencyDashBoardComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 30, 'div', [['class',
                'main-content']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 27, 'div', [['class', 'container-fluid']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 24, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class',
                'col-md-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h2', [['class', 'text-center currency-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Exchange Rates'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'currency-chart', [], null, null, null, View_CurrencyChartComponent_0, RenderType_CurrencyChartComponent)),
        core_es5["ɵdid"](114688, null, 0, currencyChart_component_CurrencyChartComponent, [], { currencyItems: [0,
                'currencyItems'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'separation']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'currency-table', [], null, null, null, View_CurrencyTableComponent_0, RenderType_CurrencyTableComponent)), core_es5["ɵdid"](114688, null, 0, currencyTable_component_CurrencyTableComponent, [], { currencyItems: [0, 'currencyItems'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.currencyArray;
        _ck(_v, 17, 0, currVal_0);
        var currVal_1 = _co.currencyArray;
        _ck(_v, 25, 0, currVal_1);
    }, null);
}
function View_CurrencyDashBoardComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'currency-dashboard', [], null, null, null, View_CurrencyDashBoardComponent_0, RenderType_CurrencyDashBoardComponent)), core_es5["ɵdid"](114688, null, 0, currencyDashBoard_component_CurrencyDashBoardComponent, [router_es5["a" /* ActivatedRoute */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CurrencyDashBoardComponentNgFactory = core_es5["ɵccf"]('currency-dashboard', currencyDashBoard_component_CurrencyDashBoardComponent, View_CurrencyDashBoardComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY3VycmVuY3lFeGNoYW5nZS9jdXJyZW5jeURhc2hCb2FyZC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY3VycmVuY3lFeGNoYW5nZS9jdXJyZW5jeURhc2hCb2FyZC5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9jdXJyZW5jeUV4Y2hhbmdlL2N1cnJlbmN5RGFzaEJvYXJkLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY3VycmVuY3lFeGNoYW5nZS9jdXJyZW5jeURhc2hCb2FyZC5jb21wb25lbnQudHMuQ3VycmVuY3lEYXNoQm9hcmRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwibWFpbi1jb250ZW50XCI+IDxkaXYgY2xhc3M9XCJjb250YWluZXItZmx1aWRcIj4gPGRpdiBjbGFzcz1cInJvd1wiPiA8ZGl2IGNsYXNzPVwiY29sLW1kLTEyXCI+IDxkaXYgY2xhc3M9XCJyb3dcIj4gPGgyIGNsYXNzPVwidGV4dC1jZW50ZXIgY3VycmVuY3ktdGl0bGVcIj5FeGNoYW5nZSBSYXRlczwvaDI+IDwvZGl2PiA8ZGl2IGNsYXNzPVwicm93XCI+IDxjdXJyZW5jeS1jaGFydCBbY3VycmVuY3lJdGVtc109XCJjdXJyZW5jeUFycmF5XCI+PC9jdXJyZW5jeS1jaGFydD4gPC9kaXY+IDxkaXYgY2xhc3M9XCJzZXBhcmF0aW9uXCI+PC9kaXY+IDxkaXYgY2xhc3M9XCJyb3dcIj4gPGN1cnJlbmN5LXRhYmxlIFtjdXJyZW5jeUl0ZW1zXT1cImN1cnJlbmN5QXJyYXlcIj48L2N1cnJlbmN5LXRhYmxlPiA8L2Rpdj4gPC9kaXY+IDwvZGl2PiA8L2Rpdj4gPC9kaXY+IiwiPGN1cnJlbmN5LWRhc2hib2FyZD48L2N1cnJlbmN5LWRhc2hib2FyZD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBMEIsc0NBQUM7VUFBQTtVQUFBLDhCQUE2QixzQ0FBQztpQkFBQTtjQUFBLDBEQUFpQjtVQUFBLFFBQUM7VUFBQTtNQUF1QixzQ0FBQztVQUFBO1VBQUEsZ0JBQWlCLHNDQUFDO1VBQUE7VUFBQTtNQUF1QyxtREFBbUI7VUFBQSxRQUFPLHNDQUFDO1VBQUE7VUFBQSw4QkFBaUIsc0NBQUM7aUJBQUE7Y0FBQTthQUFBO1VBQUEsaUNBQWlFLHNDQUFPO2lCQUFBLHVCQUFDO1VBQUE7VUFBQSw4QkFBOEIsc0NBQUM7aUJBQUE7Y0FBQSwwREFBaUI7VUFBQSxRQUFDO1VBQUE7OENBQUEsVUFBQTtVQUFBLGlFQUFpRTtpQkFBQSx1QkFBTyxzQ0FBTztpQkFBQSx1QkFBTyxzQ0FBTztpQkFBQTs7SUFBdk07SUFBaEIsWUFBZ0IsU0FBaEI7SUFBMEk7SUFBaEIsWUFBZ0IsU0FBaEI7Ozs7b0JDQW5VO01BQUE7MkNBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=
//# sourceMappingURL=currencyDashBoard.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/Managment/orderManagement/orderDetails/orderDetails.component.ts



var orderDetails_component_OrderDetails = /** @class */ (function () {
    function OrderDetails(route, router) {
        this.route = route;
        this.router = router;
        this.query = "";
        this.agentId = null;
        this.customerId = null;
        this.orderStatus = orders_orderStatus["a" /* OrderStatus */];
        this.extraData = new extraData_extraData["a" /* ExtraData */]();
        this.isMobile = false;
    }
    OrderDetails.prototype.checkIfMobile = function (event) {
        if (event.target.innerWidth <= 768)
            this.isMobile = true;
        else
            this.isMobile = false;
    };
    OrderDetails.prototype.ngOnInit = function () {
        var _this = this;
        this.order = this.route.snapshot.data.order.Data;
        var extraData;
        if (this.route.snapshot.data.extraData)
            extraData = this.route.snapshot.data.extraData.Data;
        if (extraData && extraData.length > 0) {
            var extr = extraData.find(function (x) { return x.Name == 'marketing text'; });
            if (extr)
                this.extraData = extr;
        }
        this.tabNumber = this.order.Status;
        // if (this.order.Status == OrderStatus.Calculated)
        //     this.tabNumber = OrderStatus.Quoted;
        if (this.order.Status >= orders_orderStatus["a" /* OrderStatus */].BorderCrossed)
            this.tabNumber = orders_orderStatus["a" /* OrderStatus */].CustomReleased;
        if (window.screen.width <= 768)
            this.isMobile = true;
        this.route.params.subscribe(function (params) {
            var query = params['query'];
            var agentId = params['agentid'];
            var customerId = params['customerid'];
            if (query)
                _this.query = query;
            if (agentId)
                _this.agentId = agentId;
            if (customerId)
                _this.customerId = customerId;
        });
    };
    OrderDetails.prototype.search = function () {
        this.router.navigate(["management/order", { query: this.query }]);
    };
    OrderDetails.prototype.getPageHeader = function (status) {
        switch (status) {
            case 0:
                return 'Calculated';
            case 1:
                return 'Quoted';
            case 2:
                return 'Paid';
            case 3:
                return 'Preparing Documents';
            case 4:
                return 'Sent to Customs';
            case 5:
                return 'Customs Released';
            case 6:
                return 'Border Crossed';
            case 7:
                return 'Case Closed';
            default:
                return '';
        }
    };
    OrderDetails.prototype.getIconClass = function (status) {
        if (this.order.Status == orders_orderStatus["a" /* OrderStatus */].Calculated && status == orders_orderStatus["a" /* OrderStatus */].Quoted && this.tabNumber == 0)
            return "in-progress";
        if (this.isMobile) {
            if (this.tabNumber == 0 && status == orders_orderStatus["a" /* OrderStatus */].Calculated)
                return "in-progress";
            else if (status == this.tabNumber + 1)
                return "in-progress";
            if (this.tabNumber == orders_orderStatus["a" /* OrderStatus */].Paid) {
                if (status == this.tabNumber + 2)
                    return "in-progress";
            }
            if (status <= this.order.Status)
                return "passed";
            return "non-clickable";
        }
        if (status <= this.order.Status)
            return "passed";
        if (status == this.order.Status + 1)
            return "in-progress";
        if (this.order.Status == orders_orderStatus["a" /* OrderStatus */].Paid) {
            if (status == this.order.Status + 2)
                return "in-progress";
        }
        return "non-clickable";
    };
    OrderDetails.prototype.setTab = function (num) {
        if (num > this.order.Status || this.isMobile == false)
            return;
        this.tabNumber = num;
        document.getElementById('mainPanel').scrollTop = 0;
        this.calculator.setOrderDataTab(num);
    };
    OrderDetails.ctorParameters = function () { return [{ type: router_es5["a" /* ActivatedRoute */] }, { type: router_es5["n" /* Router */] }]; };
    return OrderDetails;
}());

//# sourceMappingURL=orderDetails.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/orderManagement/orderDetails/orderDetails.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */









var styles_OrderDetails = [];
var RenderType_OrderDetails = core_es5["ɵcrt"]({ encapsulation: 2, styles: styles_OrderDetails,
    data: {} });
function View_OrderDetails_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { calculator: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 81, 'div', [['class', 'main-content order-details-content'], ['id',
                'customer-management']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 78, 'div', [['class', 'container-fluid']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 75, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class',
                'row order-id text-capitalize'], ['id', 'order-id']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'order-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Order ID:'])), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 58, 'div', [['class',
                'row order-details'], ['id', 'order-details']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 55, 'ul', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'li', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'number mobile-hide']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['1'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons mobile-show']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['iso'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Quoted'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'li', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setTab(1) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'number mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['2'])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons mobile-show']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['payment'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Paid'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'li', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setTab(2) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'number mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['3'])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons mobile-show']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['description'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Prepared Documents'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'li', [], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setTab(4) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'number mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['4'])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons mobile-show']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['contact_mail'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Sent to customs'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'li', [], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setTab(5) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'number mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['5'])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons mobile-show']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['local_shipping'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Customs released'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'li', [], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setTab(6) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'number mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['6'])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons mobile-show']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['beenhere'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'mobile-hide']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Case closed'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'calculator', [], null, [[null, 'orderChange'], [null, 'tabChanged']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('orderChange' === en)) {
                    var pd_0 = ((_co.order = $event) !== false);
                    ad = (pd_0 && ad);
                }
                if (('tabChanged' === en)) {
                    var pd_1 = ((_co.tabNumber = $event) !== false);
                    ad = (pd_1 && ad);
                }
                if (('orderChange' === en)) {
                    var pd_2 = ((_co.order = $event) !== false);
                    ad = (pd_2 && ad);
                }
                return ad;
            }, View_CalculatorComponent_0, RenderType_CalculatorComponent)),
        core_es5["ɵdid"](114688, [[1, 4], ['calculator', 4]], 0, calculator_component_CalculatorComponent, [services_orderService["a" /* OrderService */],
            router_es5["a" /* ActivatedRoute */], services_extraDataService["a" /* ExtraDataService */], router_es5["n" /* Router */], publisher_service_PublisherService], { order: [0,
                'order'], extraData: [1, 'extraData'], isOrderDetails: [2, 'isOrderDetails'] }, { orderChange: 'orderChange', tabChanged: 'tabChanged' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.getIconClass(_co.orderStatus.Quoted);
        _ck(_v, 20, 0, currVal_1);
        var currVal_2 = _co.getIconClass(_co.orderStatus.Paid);
        _ck(_v, 29, 0, currVal_2);
        var currVal_3 = _co.getIconClass(_co.orderStatus.PrepareDoc);
        _ck(_v, 38, 0, currVal_3);
        var currVal_4 = _co.getIconClass(_co.orderStatus.SentToCustom);
        _ck(_v, 47, 0, currVal_4);
        var currVal_5 = _co.getIconClass(_co.orderStatus.CustomReleased);
        _ck(_v, 56, 0, currVal_5);
        var currVal_6 = _co.getIconClass(_co.orderStatus.BorderCrossed);
        _ck(_v, 65, 0, currVal_6);
        var currVal_7 = _co.order;
        var currVal_8 = _co.extraData;
        var currVal_9 = true;
        _ck(_v, 78, 0, currVal_7, currVal_8, currVal_9);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ('BB-' + _co.order.Id);
        _ck(_v, 12, 0, currVal_0);
    });
}
function View_OrderDetails_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-details', [], null, [['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).checkIfMobile($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_OrderDetails_0, RenderType_OrderDetails)), core_es5["ɵdid"](114688, null, 0, orderDetails_component_OrderDetails, [router_es5["a" /* ActivatedRoute */], router_es5["n" /* Router */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var OrderDetailsNgFactory = core_es5["ɵccf"]('order-details', orderDetails_component_OrderDetails, View_OrderDetails_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=orderDetails.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/components/reports/filterSelectors/agentSelector/agentSelector.component.ts
var agentSelector_component = __webpack_require__("Rzwq");

// CONCATENATED MODULE: ./compiled/app/components/reports/filterSelectors/agentSelector/agentSelector.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_AgentSelectorComponent = [];
var RenderType_AgentSelectorComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AgentSelectorComponent, data: {} });
function View_AgentSelectorComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, [['agentSelect', 1]], null, 1, 'select', [['class', 'form-control select2'], ['name', 'agentSelect'], ['required', '']], [[1,
                'id', 0]], null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.select2Id;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_AgentSelectorComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'agent-selector', [], null, null, null, View_AgentSelectorComponent_0, RenderType_AgentSelectorComponent)), core_es5["ɵdid"](4243456, null, 0, agentSelector_component["a" /* AgentSelectorComponent */], [services_configService["a" /* ConfigService */]], null, null)], null, null);
}
var AgentSelectorComponentNgFactory = core_es5["ɵccf"]('agent-selector', agentSelector_component["a" /* AgentSelectorComponent */], View_AgentSelectorComponent_Host_0, { currentAgent: 'currentAgent',
    select2Id: 'select2Id', agentColors: 'agentColors', allAgents: 'allAgents' }, { agentsChange: 'agentsChange' }, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy9maWx0ZXJTZWxlY3RvcnMvYWdlbnRTZWxlY3Rvci9hZ2VudFNlbGVjdG9yLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9yZXBvcnRzL2ZpbHRlclNlbGVjdG9ycy9hZ2VudFNlbGVjdG9yL2FnZW50U2VsZWN0b3IuY29tcG9uZW50LnRzIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy9maWx0ZXJTZWxlY3RvcnMvYWdlbnRTZWxlY3Rvci9hZ2VudFNlbGVjdG9yLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy9maWx0ZXJTZWxlY3RvcnMvYWdlbnRTZWxlY3Rvci9hZ2VudFNlbGVjdG9yLmNvbXBvbmVudC50cy5BZ2VudFNlbGVjdG9yQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHNlbGVjdCAjYWdlbnRTZWxlY3QgW2F0dHIuaWRdPVwic2VsZWN0MklkXCIgY2xhc3M9XCJmb3JtLWNvbnRyb2wgc2VsZWN0MlwiIHJlcXVpcmVkIG5hbWU9XCJhZ2VudFNlbGVjdFwiPiA8L3NlbGVjdD4iLCI8YWdlbnQtc2VsZWN0b3I+PC9hZ2VudC1zZWxlY3Rvcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtVQUFBLG1FQUFvRzthQUFBOztJQUEvRTtJQUFyQixXQUFxQixTQUFyQjs7OztvQkNBQTtNQUFBO3VDQUFBLFVBQUE7TUFBQTs7Ozs7In0=
//# sourceMappingURL=agentSelector.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/reports/filterSelectors/dateSelector/dateRangeSelector.component.ts

/**
 * Created by alex.y on 9/20/2017.
 */
var dateRangeSelector_component_DateRangeSelectorComponent = /** @class */ (function () {
    function DateRangeSelectorComponent() {
        this.dateChange = new core_es5["EventEmitter"]();
        this.myDateRangePickerOptions = {
            dateFormat: 'dd-mmm-yyyy',
        };
        this.dateRangeModel = {};
    }
    DateRangeSelectorComponent.prototype.ngOnInit = function () {
        this.setCurrentLocalDate();
    };
    DateRangeSelectorComponent.prototype.setCurrentLocalDate = function () {
        var beginDate = new Date((new Date()).setDate(new Date().getDate() - 7));
        var endDate = new Date();
        this.dateRangeModel['beginDate'] = {
            year: beginDate.getFullYear(),
            month: beginDate.getMonth() + 1,
            day: beginDate.getDate()
        };
        this.dateRangeModel['endDate'] = {
            year: endDate.getFullYear(),
            month: endDate.getMonth() + 1,
            day: endDate.getDate()
        };
    };
    DateRangeSelectorComponent.prototype.onDateChangeHandler = function () {
        if (this.dateRangeModel == null) {
            this.dateRangeModel = {};
            this.setCurrentLocalDate();
        }
        this.dateChange.emit(this.dateRangeModel);
    };
    DateRangeSelectorComponent.prototype.getCurrentDateModel = function () {
        return this.dateRangeModel;
    };
    return DateRangeSelectorComponent;
}());

//# sourceMappingURL=dateRangeSelector.component.js.map
// EXTERNAL MODULE: ./node_modules/mydaterangepicker/dist/directives/my-date-range-picker.focus.directive.js
var my_date_range_picker_focus_directive = __webpack_require__("JipF");

// EXTERNAL MODULE: ./node_modules/mydaterangepicker/dist/my-date-range-picker.component.js
var my_date_range_picker_component = __webpack_require__("12iJ");

// EXTERNAL MODULE: ./node_modules/mydaterangepicker/dist/services/my-date-range-picker.date.range.util.service.js
var my_date_range_picker_date_range_util_service = __webpack_require__("fOqb");

// CONCATENATED MODULE: ./compiled/node_modules/mydaterangepicker/dist/my-date-range-picker.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_MyDateRangePicker = ['.mydrp .monthcell,.mydrp .selection,.mydrp .weekdaytitle{overflow:hidden;white-space:nowrap}.mydrp{line-height:1;display:inline-block;position:relative}.mydrp *{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:Arial,Helvetica,sans-serif;padding:0;margin:0}.mydrp,.mydrp .headertodaybtn,.mydrp .selection,.mydrp .selectiongroup,.mydrp .selector{border-radius:4px}.mydrp .header,.mydrp .titlearea,.mydrp .titleareatxt{border-radius:4px 4px 0 0}.mydrp .caltable,.mydrp .monthtable,.mydrp .yeartable{border-radius:0 0 4px 4px}.mydrp .caltable tbody tr:nth-child(6) td:first-child,.mydrp .monthtable tbody tr:nth-child(4) td:first-child,.mydrp .yeartable tbody tr:nth-child(7) td:first-child{border-bottom-left-radius:4px}.mydrp .caltable tbody tr:nth-child(6) td:last-child,.mydrp .monthtable tbody tr:nth-child(4) td:last-child,.mydrp .yeartable tbody tr:nth-child(7) td:last-child{border-bottom-right-radius:4px}.mydrp .btnpicker{border-radius:0 4px 4px 0}.mydrp .selector{margin-top:2px;margin-left:-1px;position:absolute;padding:0;border:1px solid #CCC;z-index:100;animation:selectorfadein 60ms}.mydrp .selector:focus{border:1px solid #ADD8E6;outline:0}@keyframes selectorfadein{from{opacity:0}to{opacity:1}}.mydrp .selectorarrow{background:#FFF;border:1px solid #CCC;margin-top:12px;padding:0}.mydrp .selectorarrow:after,.mydrp .selectorarrow:before{bottom:100%;border:solid transparent;content:" ";height:0;width:0;position:absolute}.mydrp .selectorarrow:after{border-color:rgba(250,250,250,0);border-bottom-color:#FFF;border-width:10px;margin-left:-10px}.mydrp .selectorarrow:before{border-color:rgba(204,204,204,0);border-bottom-color:#CCC;border-width:11px;margin-left:-11px}.mydrp .selectorarrow:focus:before{border-bottom-color:#ADD8E6}.mydrp .selectorarrowleft:after,.mydrp .selectorarrowleft:before{left:24px}.mydrp .selectorarrowright:after,.mydrp .selectorarrowright:before{left:224px}.mydrp .alignselectorright{right:-1px}.mydrp .selectiongroup{position:relative;display:table;border:none;border-spacing:0;background-color:#FFF}.mydrp .selection{outline:0;background-color:#FFF;display:table-cell;position:absolute;width:100%;padding:0 64px 0 6px;text-overflow:ellipsis;border:none;color:#555}.mydrp .invaliddaterange{background-color:#F1DEDE}.mydrp ::-ms-clear{display:none}.mydrp .selbtngroup{position:relative;vertical-align:middle;white-space:nowrap;width:1%;display:table-cell;font-size:0}.mydrp .btnclear,.mydrp .btnpicker{height:100%;width:26px;border:none;padding:0;outline:0;font:inherit;-moz-user-select:none}.mydrp .headerclearbtn,.mydrp .headerokbtn{border-radius:2px;cursor:pointer;font-size:11px;height:20px;width:28px;outline:0}.mydrp .btnclearenabled,.mydrp .btnpickerenabled,.mydrp .headerbtnenabled,.mydrp .yearchangebtnenabled{cursor:pointer}.mydrp .btncleardisabled,.mydrp .btnpickerdisabled,.mydrp .clearbtndisabled,.mydrp .headerbtndisabled,.mydrp .okbtndisabled,.mydrp .selectiondisabled,.mydrp .yearchangebtndisabled{cursor:not-allowed;opacity:.65}.mydrp .selectiondisabled{background-color:#EEE}.mydrp .btnclear,.mydrp .btnpicker,.mydrp .headerclearbtn,.mydrp .headerokbtn{background:#FFF}.mydrp .header{width:100%;height:30px;background-color:#FFF}.mydrp .header td{vertical-align:middle;border:none;line-height:0}.mydrp .header td:nth-child(1){padding-left:4px}.mydrp .header td:nth-child(2){text-align:center}.mydrp .header td:nth-child(3){padding-right:4px}.mydrp .titlearea{text-align:center;background-color:#FFF}.mydrp .titleareatxt{height:24px;line-height:24px;font-size:12px;border-bottom:1px solid #EEE}.mydrp .inline{position:relative;margin-top:-1px}.mydrp .caltable,.mydrp .monthtable,.mydrp .yeartable{table-layout:fixed;width:100%;background-color:#FFF;font-size:14px}.mydrp .caltable,.mydrp .daycell,.mydrp .monthcell,.mydrp .monthtable,.mydrp .weekdaytitle,.mydrp .yearcell,.mydrp .yeartable{border-collapse:collapse;color:#036;line-height:1.1}.mydrp .daycell,.mydrp .monthcell,.mydrp .weekdaytitle,.mydrp .yearcell{padding:4px;text-align:center}.mydrp .weekdaytitle{background-color:#DDD;font-size:11px;font-weight:400;vertical-align:middle;max-width:36px}.mydrp .weekdaytitleweeknbr{width:20px;border-right:1px solid #BBB}.mydrp .monthcell{background-color:#FAFAFA}.mydrp .yearcell{background-color:#FAFAFA;width:20%}.mydrp .daycellweeknbr{font-size:10px;border-right:1px solid #CCC;cursor:default;color:#000}.mydrp .nextmonth,.mydrp .prevmonth{color:#444}.mydrp .disabled{cursor:default!important;color:#444!important;background:#FBEFEF!important}.mydrp .sunday{color:#C30000}.mydrp .sundayDim{opacity:.5}.mydrp .currmonth{background-color:#F6F6F6;font-weight:400}.mydrp .range{background-color:#D9F2E6}.mydrp .markcurrday,.mydrp .markcurrmonth,.mydrp .markcurryear{text-decoration:underline}.mydrp .datevalue{background-color:inherit}.mydrp .selecteddaybegin,.mydrp .selecteddayend,.mydrp .selectedmonth .monthvalue,.mydrp .selectedyear .yearvalue{border:none;background-color:#8EBFFF;border-radius:2px}.mydrp .headerbtncell{background-color:#FFF;cursor:pointer;display:table-cell;vertical-align:middle}.mydrp .yearchangebtncell{text-align:center;background-color:#FAFAFA}.mydrp .headerbtn,.mydrp .headerlabelbtn,.mydrp .yearchangebtn{background:#FFF;border:none;height:22px}.mydrp .headerbtn{width:16px}.mydrp .headerlabelbtn{font-size:14px;outline:0;cursor:default}.mydrp,.mydrp .headerclearbtn,.mydrp .headerokbtn{border:1px solid #CCC}.mydrp .btnclear,.mydrp .btnpicker,.mydrp .headerbtn,.mydrp .headerclearbtn,.mydrp .headermonthtxt,.mydrp .headerokbtn,.mydrp .headeryeartxt,.mydrp .yearchangebtn{color:#000}.mydrp button::-moz-focus-inner{border:0}.mydrp .headermonthtxt,.mydrp .headeryeartxt{text-align:center;display:table-cell;vertical-align:middle;font-size:14px;height:26px;width:40px;max-width:40px;overflow:hidden;white-space:nowrap}.mydrp .btnclear:focus,.mydrp .btnpicker:focus,.mydrp .headerclearbtn:focus,.mydrp .headerokbtn:focus{background:#ADD8E6}.mydrp .headerbtn:focus,.mydrp .monthlabel:focus,.mydrp .yearchangebtn:focus,.mydrp .yearlabel:focus{color:#ADD8E6;outline:0}.mydrp .daycell:focus,.mydrp .monthcell:focus,.mydrp .yearcell:focus{outline:#CCC solid 1px}.mydrp .icon-mydrpcalendar,.mydrp .icon-mydrpok,.mydrp .icon-mydrpremove{font-size:16px}.mydrp .icon-mydrpdown,.mydrp .icon-mydrpleft,.mydrp .icon-mydrpright,.mydrp .icon-mydrpup{color:#222;font-size:20px}.mydrp table{display:table;border-spacing:0}.mydrp table td{padding:0}.mydrp table,.mydrp td,.mydrp th{border:none}.mydrp .btnclearenabled:hover,.mydrp .btnpickerenabled:hover,.mydrp .headerclearbtnenabled:hover,.mydrp .headerokbtnenabled:hover{background-color:#E6E6E6}.mydrp .daycell:hover,.mydrp .monthcell:hover,.mydrp .yearcell:hover{background-color:#DDD}.mydrp .daycell,.mydrp .inputnoteditable,.mydrp .monthcell,.mydrp .monthlabel,.mydrp .yearcell,.mydrp .yearlabel{cursor:pointer}.mydrp .headerbtnenabled:hover,.mydrp .monthlabel:hover,.mydrp .yearchangebtnenabled:hover,.mydrp .yearlabel:hover{color:#777}@font-face{font-family:mydaterangepicker;src:url(data:application/octet-stream;base64,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) format(\'truetype\');font-weight:400;font-style:normal}.mydrp .mydrpicon{font-family:mydaterangepicker;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.mydrp .icon-mydrpright:before{content:"\\e800"}.mydrp .icon-mydrpleft:before{content:"\\e801"}.mydrp .icon-mydrpup:before{content:"\\e802"}.mydrp .icon-mydrpdown:before{content:"\\e803"}.mydrp .icon-mydrpcalendar:before{content:"\\e804"}.mydrp .icon-mydrpok:before{content:"\\e805"}.mydrp .icon-mydrpremove:before{content:"\\e806"}'];
var RenderType_MyDateRangePicker = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_MyDateRangePicker, data: {} });
function View_MyDateRangePicker_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['class',
                'btnclear'], ['type', 'button']], [[1, 'aria-label', 0], [8, 'disabled', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                _co.removeBtnClicked();
                var pd_0 = ($event.stopPropagation() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'btnclearenabled': 0, 'btncleardisabled': 1 }),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'mydrpicon icon-mydrpremove']], null, null, null, null, null))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = 'btnclear';
        var currVal_3 = _ck(_v, 2, 0, !_co.opts.componentDisabled, _co.opts.componentDisabled);
        _ck(_v, 1, 0, currVal_2, currVal_3);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.opts.ariaLabelClearDateRange;
        var currVal_1 = _co.opts.componentDisabled;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
function View_MyDateRangePicker_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class',
                'selectiongroup']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 9, 'input', [['autocomplete', 'off'],
            ['autocorrect', 'off'], ['class', 'selection'], ['spellcheck', 'false'], ['type',
                'text']], [[1, 'aria-label', 0], [1, 'maxlength', 0], [8, 'placeholder', 0], [8,
                'value', 0], [8, 'readOnly', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'click'], [null, 'ngModelChange'],
            [null, 'keyup'], [null, 'focus'], [null, 'blur'], [null,
                'input'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 6)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 6)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 6)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('click' === en)) {
                var pd_4 = (((_co.opts.openSelectorOnInputClick && !_co.opts.editableDateRangeField) && _co.openBtnClicked()) !== false);
                ad = (pd_4 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_5 = (_co.onUserDateRangeInput($event) !== false);
                ad = (pd_5 && ad);
            }
            if (('keyup' === en)) {
                var pd_6 = (_co.onCloseSelector($event) !== false);
                ad = (pd_6 && ad);
            }
            if (('focus' === en)) {
                var pd_7 = ((_co.opts.editableDateRangeField && _co.onFocusInput($event)) !== false);
                ad = (pd_7 && ad);
            }
            if (('blur' === en)) {
                var pd_8 = ((_co.opts.editableDateRangeField && _co.onBlurInput($event)) !== false);
                ad = (pd_8 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'invaliddaterange': 0,
            'inputnoteditable': 1, 'selectiondisabled': 2 }), core_es5["ɵdid"](278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngStyle: [0,
                'ngStyle'] }, null), core_es5["ɵpod"]({ 'height': 0, 'font-size': 1 }), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { isDisabled: [0, 'isDisabled'], model: [1, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'span', [['class', 'selbtngroup']], [[4, 'height', null]], null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['class', 'btnpicker'], ['type', 'button']], [[1, 'aria-label', 0],
            [8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.openBtnClicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'btnpickerenabled': 0,
            'btnpickerdisabled': 1 }), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'mydrpicon icon-mydrpcalendar']], null, null, null, null, null))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_12 = 'selection';
        var currVal_13 = _ck(_v, 3, 0, (_co.invalidDateRange && _co.opts.indicateInvalidDateRange), (_co.opts.openSelectorOnInputClick && !_co.opts.editableDateRangeField), _co.opts.componentDisabled);
        _ck(_v, 2, 0, currVal_12, currVal_13);
        var currVal_14 = _ck(_v, 5, 0, _co.opts.height, _co.opts.selectionTxtFontSize);
        _ck(_v, 4, 0, currVal_14);
        var currVal_15 = _co.opts.componentDisabled;
        var currVal_16 = _co.selectionDayTxt;
        _ck(_v, 8, 0, currVal_15, currVal_16);
        var currVal_18 = ((_co.selectionDayTxt.length > 0) && _co.opts.showClearDateRangeBtn);
        _ck(_v, 14, 0, currVal_18);
        var currVal_21 = 'btnpicker';
        var currVal_22 = _ck(_v, 18, 0, !_co.opts.componentDisabled, _co.opts.componentDisabled);
        _ck(_v, 17, 0, currVal_21, currVal_22);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.opts.ariaLabelInputField;
        var currVal_1 = _co.dateRangeFormat.length;
        var currVal_2 = core_es5["ɵinlineInterpolate"](1, '', _co.placeholder, '');
        var currVal_3 = _co.selectionDayTxt;
        var currVal_4 = !_co.opts.editableDateRangeField;
        var currVal_5 = core_es5["ɵnov"](_v, 10).ngClassUntouched;
        var currVal_6 = core_es5["ɵnov"](_v, 10).ngClassTouched;
        var currVal_7 = core_es5["ɵnov"](_v, 10).ngClassPristine;
        var currVal_8 = core_es5["ɵnov"](_v, 10).ngClassDirty;
        var currVal_9 = core_es5["ɵnov"](_v, 10).ngClassValid;
        var currVal_10 = core_es5["ɵnov"](_v, 10).ngClassInvalid;
        var currVal_11 = core_es5["ɵnov"](_v, 10).ngClassPending;
        _ck(_v, 1, 1, [currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6,
            currVal_7, currVal_8, currVal_9, currVal_10, currVal_11]);
        var currVal_17 = _co.opts.height;
        _ck(_v, 12, 0, currVal_17);
        var currVal_19 = _co.opts.ariaLabelOpenCalendar;
        var currVal_20 = _co.opts.componentDisabled;
        _ck(_v, 16, 0, currVal_19, currVal_20);
    });
}
function View_MyDateRangePicker_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'div', [['class',
                'titlearea']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'titleareatxt']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ((_co.titleAreaText !== '') ? _co.titleAreaText : _co.opts.selectBeginDateTxt);
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_MyDateRangePicker_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['class',
                'headerclearbtn'], ['type', 'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clearDateRange() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'clearbtndisabled': 0, 'headerclearbtnenabled': 1 }),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'mydrpicon icon-mydrpremove']], null, null, null, null, null))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'headerclearbtn';
        var currVal_2 = _ck(_v, 2, 0, ((_co.beginDate.year === 0) && (_co.endDate.year === 0)), ((_co.beginDate.year !== 0) || (_co.endDate.year !== 0)));
        _ck(_v, 1, 0, currVal_1, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ((_co.beginDate.year === 0) && (_co.endDate.year === 0));
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_MyDateRangePicker_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['class',
                'headerokbtn'], ['type', 'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.rangeSelected() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'okbtndisabled': 0, 'headerokbtnenabled': 1 }),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'mydrpicon icon-mydrpok']], null, null, null, null, null))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'headerokbtn';
        var currVal_2 = _ck(_v, 2, 0, (_co.endDate.year === 0), (_co.endDate.year !== 0));
        _ck(_v, 1, 0, currVal_1, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.endDate.year === 0);
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_MyDateRangePicker_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'th', [['class',
                'weekdaytitle weekdaytitleweeknbr']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['#']))], null, null);
}
function View_MyDateRangePicker_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'th', [['class',
                'weekdaytitle'], ['scope', 'col']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_MyDateRangePicker_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'td', [['class',
                'daycell daycellweeknbr']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.weekNbr;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_MyDateRangePicker_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 9, 'td', [['class',
                'daycell'], ['tabindex', '0']], null, [[null, 'click'], [null,
                'keydown'], [null, 'mouseenter'], [null, 'mouseleave']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                (!_v.context.$implicit.disabled && _co.onCellClicked(_v.context.$implicit));
                var pd_0 = ($event.stopPropagation() !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown' === en)) {
                var pd_1 = (_co.onCellKeyDown($event, _v.context.$implicit) !== false);
                ad = (pd_1 && ad);
            }
            if (('mouseenter' === en)) {
                var pd_2 = (_co.onCellMouseEnter(_v.context.$implicit) !== false);
                ad = (pd_2 && ad);
            }
            if (('mouseleave' === en)) {
                var pd_3 = (_co.onCellMouseLeave() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'currmonth': 0, 'range': 1, 'disabled': 2 }), (_l()(),
            core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'datevalue']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'prevmonth': 0,
            'selecteddaybegin': 1, 'selecteddayend': 2, 'currmonth': 3, 'nextmonth': 4, 'sunday': 5 }),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'span', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), core_es5["ɵpod"]({ 'markcurrday': 0,
            'sundayDim': 1 }), (_l()(), core_es5["ɵted"](null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'daycell';
        var currVal_1 = _ck(_v, 2, 0, ((_v.context.$implicit.cmo === _co.currMonthId) && !_v.context.$implicit.disabled), (_co.isInRange(_v.context.$implicit) || _v.context.$implicit.range), _v.context.$implicit.disabled);
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_2 = 'datevalue';
        var currVal_3 = _ck(_v, 5, 0, (_v.context.$implicit.cmo === _co.prevMonthId), (((_co.beginDate.day === _v.context.$implicit.dateObj.day) && (_co.beginDate.month === _v.context.$implicit.dateObj.month)) && (_co.beginDate.year === _v.context.$implicit.dateObj.year)), (((_co.endDate.day === _v.context.$implicit.dateObj.day) && (_co.endDate.month === _v.context.$implicit.dateObj.month)) && (_co.endDate.year === _v.context.$implicit.dateObj.year)), (_v.context.$implicit.cmo === _co.currMonthId), (_v.context.$implicit.cmo === _co.nextMonthId), ((_v.context.$implicit.dayNbr === 0) && _co.opts.sunHighlight));
        _ck(_v, 4, 0, currVal_2, currVal_3);
        var currVal_4 = _ck(_v, 8, 0, (_v.context.$implicit.currDay && _co.opts.markCurrentDay), ((_co.opts.sunHighlight && (_v.context.$implicit.dayNbr === 0)) && (((_v.context.$implicit.cmo === _co.prevMonthId) || (_v.context.$implicit.cmo === _co.nextMonthId)) || _v.context.$implicit.disabled)));
        _ck(_v, 7, 0, currVal_4);
    }, function (_ck, _v) {
        var currVal_5 = _v.context.$implicit.dateObj.day;
        _ck(_v, 9, 0, currVal_5);
    });
}
function View_MyDateRangePicker_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'tr', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_11)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_12)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.opts.showWeekNumbers && (_co.opts.firstDayOfWeek === 'mo'));
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.week;
        _ck(_v, 4, 0, currVal_1);
    }, null);
}
function View_MyDateRangePicker_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 11, 'table', [['class',
                'caltable']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), core_es5["ɵpod"]({ 'height': 0 }),
        (_l()(), core_es5["ɵeld"](0, null, null, 5, 'thead', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_9)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'tbody', [], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_10)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, (_co.opts.showSelectDateText ? 'calc(100% - 54px)' : 'calc(100% - 30px)'));
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = (_co.opts.showWeekNumbers && (_co.opts.firstDayOfWeek === 'mo'));
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = _co.weekDays;
        _ck(_v, 8, 0, currVal_2);
        var currVal_3 = _co.dates;
        _ck(_v, 11, 0, currVal_3);
    }, null);
}
function View_MyDateRangePicker_15(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 6, 'td', [['class',
                'monthcell tablesinglemonth'], ['tabindex', '0']], null, [[null,
                'click'], [null, 'keydown']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                (!_v.context.$implicit.disabled && _co.onMonthCellClicked(_v.context.$implicit));
                var pd_0 = ($event.stopPropagation() !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown' === en)) {
                var pd_1 = (_co.onMonthCellKeyDown($event, _v.context.$implicit) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'selectedmonth': 0, 'disabled': 1 }), (_l()(),
            core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'monthvalue']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'markcurrmonth': 0 }),
        (_l()(), core_es5["ɵted"](null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'monthcell tablesinglemonth';
        var currVal_1 = _ck(_v, 2, 0, _v.context.$implicit.selected, _v.context.$implicit.disabled);
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_2 = 'monthvalue';
        var currVal_3 = _ck(_v, 5, 0, (_v.context.$implicit.currMonth && _co.opts.markCurrentMonth));
        _ck(_v, 4, 0, currVal_2, currVal_3);
    }, function (_ck, _v) {
        var currVal_4 = _v.context.$implicit.name;
        _ck(_v, 6, 0, currVal_4);
    });
}
function View_MyDateRangePicker_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'tr', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_15)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_MyDateRangePicker_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, 'table', [['class',
                'monthtable']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), core_es5["ɵpod"]({ 'height': 0 }),
        (_l()(), core_es5["ɵeld"](0, null, null, 2, 'tbody', [], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_14)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, (_co.opts.showSelectDateText ? 'calc(100% - 54px)' : 'calc(100% - 30px)'));
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _co.months;
        _ck(_v, 5, 0, currVal_1);
    }, null);
}
function View_MyDateRangePicker_18(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 6, 'td', [['class',
                'yearcell tablesingleyear'], ['tabindex', '0']], null, [[null,
                'click'], [null, 'keydown']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                (!_v.context.$implicit.disabled && _co.onYearCellClicked(_v.context.$implicit));
                var pd_0 = ($event.stopPropagation() !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown' === en)) {
                var pd_1 = (_co.onYearCellKeyDown($event, _v.context.$implicit) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'selectedyear': 0, 'disabled': 1 }), (_l()(),
            core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'yearvalue']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'markcurryear': 0 }),
        (_l()(), core_es5["ɵted"](null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'yearcell tablesingleyear';
        var currVal_1 = _ck(_v, 2, 0, _v.context.$implicit.selected, _v.context.$implicit.disabled);
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_2 = 'yearvalue';
        var currVal_3 = _ck(_v, 5, 0, (_v.context.$implicit.currYear && _co.opts.markCurrentYear));
        _ck(_v, 4, 0, currVal_2, currVal_3);
    }, function (_ck, _v) {
        var currVal_4 = _v.context.$implicit.year;
        _ck(_v, 6, 0, currVal_4);
    });
}
function View_MyDateRangePicker_17(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'tr', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_18)),
        core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_MyDateRangePicker_16(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 15, 'table', [['class',
                'yeartable']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), core_es5["ɵpod"]({ 'height': 0 }),
        (_l()(), core_es5["ɵeld"](0, null, null, 12, 'tbody', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'td', [['class', 'yearchangebtncell'], ['colspan', '5']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = ($event.stopPropagation() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'yearchangebtn mydrpicon icon-mydrpup'], ['type', 'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onPrevYears($event, _co.years[0][0].year) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'yearchangebtnenabled': 0,
            'yearchangebtndisabled': 1 }), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_17)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'td', [['class',
                'yearchangebtncell'], ['colspan', '5']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = ($event.stopPropagation() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'yearchangebtn mydrpicon icon-mydrpdown'], ['type', 'button']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onNextYears($event, _co.years[0][0].year) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'yearchangebtnenabled': 0,
            'yearchangebtndisabled': 1 })], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, (_co.opts.showSelectDateText ? 'calc(100% - 54px)' : 'calc(100% - 30px)'));
        _ck(_v, 1, 0, currVal_0);
        var currVal_2 = 'yearchangebtn mydrpicon icon-mydrpup';
        var currVal_3 = _ck(_v, 8, 0, !_co.prevYearsDisabled, _co.prevYearsDisabled);
        _ck(_v, 7, 0, currVal_2, currVal_3);
        var currVal_4 = _co.years;
        _ck(_v, 10, 0, currVal_4);
        var currVal_6 = 'yearchangebtn mydrpicon icon-mydrpdown';
        var currVal_7 = _ck(_v, 15, 0, !_co.nextYearsDisabled, _co.nextYearsDisabled);
        _ck(_v, 14, 0, currVal_6, currVal_7);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.prevYearsDisabled;
        _ck(_v, 6, 0, currVal_1);
        var currVal_5 = _co.nextYearsDisabled;
        _ck(_v, 13, 0, currVal_5);
    });
}
function View_MyDateRangePicker_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, [[1, 0], ['selectorEl', 1]], null, 52, 'div', [['class', 'selector'], ['tabindex', '0']], null, [[null, 'keyup']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('keyup' === en)) {
                var pd_0 = (_co.onCloseSelector($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'inline': 0, 'alignselectorright': 1, 'selectorarrow': 2,
            'selectorarrowleft': 3, 'selectorarrowright': 4 }), core_es5["ɵdid"](278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), core_es5["ɵpod"]({ 'width': 0, 'height': 1 }), core_es5["ɵdid"](4210688, null, 0, my_date_range_picker_focus_directive["a" /* FocusDirective */], [core_es5["ElementRef"], core_es5["Renderer"]], { value: [0, 'value'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵeld"](0, null, null, 38, 'table', [['class', 'header']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 37, 'tbody', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 36, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['style', 'float:left']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'headerbtncell']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'headerbtn mydrpicon icon-mydrpleft'],
            ['type', 'button']], [[1, 'aria-label', 0], [8, 'disabled', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onPrevMonth() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'headerbtnenabled': 0,
            'headerbtndisabled': 1 }), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'headermonthtxt']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['class', 'headerlabelbtn'], ['type', 'button']], [[8, 'tabIndex',
                0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = ((_co.opts.monthSelector && _co.onSelectMonthClicked($event)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'monthlabel': 0 }),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'headerbtncell']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'headerbtn mydrpicon icon-mydrpright'], ['type', 'button']], [[1, 'aria-label', 0], [8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onNextMonth() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'headerbtnenabled': 0,
            'headerbtndisabled': 1 }), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['style', 'float:right']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'headerbtncell']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'headerbtn mydrpicon icon-mydrpleft'], ['type', 'button']], [[1, 'aria-label', 0], [8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onPrevYear() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'headerbtnenabled': 0,
            'headerbtndisabled': 1 }), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'headeryeartxt']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['class', 'headerlabelbtn'], ['type', 'button']], [[8, 'tabIndex',
                0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = ((_co.opts.yearSelector && _co.onSelectYearClicked($event)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'yearlabel': 0 }),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'headerbtncell']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'headerbtn mydrpicon icon-mydrpright'], ['type', 'button']], [[1, 'aria-label', 0], [8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onNextYear() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'headerbtnenabled': 0,
            'headerbtndisabled': 1 }), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_7)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_13)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_16)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'selector';
        var currVal_1 = _ck(_v, 2, 0, _co.opts.inline, _co.opts.alignSelectorRight, (_co.opts.showSelectorArrow && !_co.opts.inline), ((_co.opts.showSelectorArrow && !_co.opts.alignSelectorRight) && !_co.opts.inline), ((_co.opts.showSelectorArrow && _co.opts.alignSelectorRight) && !_co.opts.inline));
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_2 = _ck(_v, 4, 0, _co.opts.selectorWidth, _co.opts.selectorHeight);
        _ck(_v, 3, 0, currVal_2);
        var currVal_3 = (_co.opts.inline ? '0' : '1');
        _ck(_v, 5, 0, currVal_3);
        var currVal_4 = _co.opts.showSelectDateText;
        _ck(_v, 7, 0, currVal_4);
        var currVal_7 = 'headerbtn mydrpicon icon-mydrpleft';
        var currVal_8 = _ck(_v, 16, 0, !_co.prevMonthDisabled, _co.prevMonthDisabled);
        _ck(_v, 15, 0, currVal_7, currVal_8);
        var currVal_10 = 'headerlabelbtn';
        var currVal_11 = _ck(_v, 20, 0, _co.opts.monthSelector);
        _ck(_v, 19, 0, currVal_10, currVal_11);
        var currVal_15 = 'headerbtn mydrpicon icon-mydrpright';
        var currVal_16 = _ck(_v, 25, 0, !_co.nextMonthDisabled, _co.nextMonthDisabled);
        _ck(_v, 24, 0, currVal_15, currVal_16);
        var currVal_17 = _co.opts.showClearBtn;
        _ck(_v, 28, 0, currVal_17);
        var currVal_18 = _co.opts.showApplyBtn;
        _ck(_v, 31, 0, currVal_18);
        var currVal_21 = 'headerbtn mydrpicon icon-mydrpleft';
        var currVal_22 = _ck(_v, 37, 0, !_co.prevYearDisabled, _co.prevYearDisabled);
        _ck(_v, 36, 0, currVal_21, currVal_22);
        var currVal_24 = 'headerlabelbtn';
        var currVal_25 = _ck(_v, 41, 0, _co.opts.yearSelector);
        _ck(_v, 40, 0, currVal_24, currVal_25);
        var currVal_29 = 'headerbtn mydrpicon icon-mydrpright';
        var currVal_30 = _ck(_v, 46, 0, !_co.nextYearDisabled, _co.nextYearDisabled);
        _ck(_v, 45, 0, currVal_29, currVal_30);
        var currVal_31 = (!_co.selectMonth && !_co.selectYear);
        _ck(_v, 48, 0, currVal_31);
        var currVal_32 = _co.selectMonth;
        _ck(_v, 50, 0, currVal_32);
        var currVal_33 = _co.selectYear;
        _ck(_v, 52, 0, currVal_33);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_5 = _co.opts.ariaLabelPrevMonth;
        var currVal_6 = _co.prevMonthDisabled;
        _ck(_v, 14, 0, currVal_5, currVal_6);
        var currVal_9 = core_es5["ɵinlineInterpolate"](1, '', (_co.opts.monthSelector ? '0' : '-1'), '');
        _ck(_v, 18, 0, currVal_9);
        var currVal_12 = _co.visibleMonth.monthTxt;
        _ck(_v, 21, 0, currVal_12);
        var currVal_13 = _co.opts.ariaLabelNextMonth;
        var currVal_14 = _co.nextMonthDisabled;
        _ck(_v, 23, 0, currVal_13, currVal_14);
        var currVal_19 = _co.opts.ariaLabelPrevYear;
        var currVal_20 = _co.prevYearDisabled;
        _ck(_v, 35, 0, currVal_19, currVal_20);
        var currVal_23 = core_es5["ɵinlineInterpolate"](1, '', (_co.opts.yearSelector ? '0' : '-1'), '');
        _ck(_v, 39, 0, currVal_23);
        var currVal_26 = _co.visibleMonth.year;
        _ck(_v, 42, 0, currVal_26);
        var currVal_27 = _co.opts.ariaLabelNextYear;
        var currVal_28 = _co.nextYearDisabled;
        _ck(_v, 44, 0, currVal_27, currVal_28);
    });
}
function View_MyDateRangePicker_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](671088640, 1, { selectorEl: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'mydrp']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), core_es5["ɵpod"]({ 'width': 0,
            'border': 1 }), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_MyDateRangePicker_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 3, 0, _co.opts.width, (_co.opts.inline ? 'none' : null));
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = !_co.opts.inline;
        _ck(_v, 5, 0, currVal_1);
        var currVal_2 = (_co.showSelector || _co.opts.inline);
        _ck(_v, 7, 0, currVal_2);
    }, null);
}
function View_MyDateRangePicker_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'my-date-range-picker', [], null, null, null, View_MyDateRangePicker_0, RenderType_MyDateRangePicker)), core_es5["ɵprd"](5120, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [my_date_range_picker_component["a" /* MyDateRangePicker */]]), core_es5["ɵprd"](512, null, my_date_range_picker_date_range_util_service["a" /* DateRangeUtilService */], my_date_range_picker_date_range_util_service["a" /* DateRangeUtilService */], []), core_es5["ɵdid"](573440, null, 0, my_date_range_picker_component["a" /* MyDateRangePicker */], [core_es5["ElementRef"], core_es5["Renderer"], core_es5["ChangeDetectorRef"], my_date_range_picker_date_range_util_service["a" /* DateRangeUtilService */]], null, null)], null, null);
}
var MyDateRangePickerNgFactory = core_es5["ɵccf"]('my-date-range-picker', my_date_range_picker_component["a" /* MyDateRangePicker */], View_MyDateRangePicker_Host_0, { options: 'options', defaultMonth: 'defaultMonth',
    selDateRange: 'selDateRange', placeholder: 'placeholder' }, { dateRangeChanged: 'dateRangeChanged',
    inputFieldChanged: 'inputFieldChanged', calendarViewChanged: 'calendarViewChanged',
    inputFocusBlur: 'inputFocusBlur', dateSelected: 'dateSelected' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=my-date-range-picker.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/app/components/reports/filterSelectors/dateSelector/dateRangeSelector.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_DateRangeSelectorComponent = [];
var RenderType_DateRangeSelectorComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DateRangeSelectorComponent, data: {} });
function View_DateRangeSelectorComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 19, 'form', [['novalidate',
                '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null], [2,
                'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 2).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 2).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['dateForm', 4]], 0, forms_es5["NgForm"], [[8,
                null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'my-date-range-picker', [['name',
                    'mydaterange'], ['required', '']], [[1, 'required', 0], [2, 'ng-untouched',
                    null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
                [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                    null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.dateRangeModel = $event) !== false);
                    ad = (pd_0 && ad);
                }
                if (('ngModelChange' === en)) {
                    var pd_1 = (_co.onDateChangeHandler() !== false);
                    ad = (pd_1 && ad);
                }
                return ad;
            }, View_MyDateRangePicker_0, RenderType_MyDateRangePicker)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵprd"](512, null, my_date_range_picker_date_range_util_service["a" /* DateRangeUtilService */], my_date_range_picker_date_range_util_service["a" /* DateRangeUtilService */], []), core_es5["ɵdid"](573440, null, 0, my_date_range_picker_component["a" /* MyDateRangePicker */], [core_es5["ElementRef"], core_es5["Renderer"], core_es5["ChangeDetectorRef"], my_date_range_picker_date_range_util_service["a" /* DateRangeUtilService */]], { options: [0, 'options'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [my_date_range_picker_component["a" /* MyDateRangePicker */]]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_15 = '';
        _ck(_v, 9, 0, currVal_15);
        var currVal_16 = _co.myDateRangePickerOptions;
        _ck(_v, 12, 0, currVal_16);
        var currVal_17 = 'mydaterange';
        var currVal_18 = _co.dateRangeModel;
        _ck(_v, 14, 0, currVal_17, currVal_18);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 4).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 4).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 4).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 4).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 4).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 4).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 4).ngClassPending;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (core_es5["ɵnov"](_v, 9).required ? '' : null);
        var currVal_8 = core_es5["ɵnov"](_v, 16).ngClassUntouched;
        var currVal_9 = core_es5["ɵnov"](_v, 16).ngClassTouched;
        var currVal_10 = core_es5["ɵnov"](_v, 16).ngClassPristine;
        var currVal_11 = core_es5["ɵnov"](_v, 16).ngClassDirty;
        var currVal_12 = core_es5["ɵnov"](_v, 16).ngClassValid;
        var currVal_13 = core_es5["ɵnov"](_v, 16).ngClassInvalid;
        var currVal_14 = core_es5["ɵnov"](_v, 16).ngClassPending;
        _ck(_v, 8, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
    });
}
function View_DateRangeSelectorComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'date-range-selector', [], null, null, null, View_DateRangeSelectorComponent_0, RenderType_DateRangeSelectorComponent)), core_es5["ɵdid"](114688, null, 0, dateRangeSelector_component_DateRangeSelectorComponent, [], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var DateRangeSelectorComponentNgFactory = core_es5["ɵccf"]('date-range-selector', dateRangeSelector_component_DateRangeSelectorComponent, View_DateRangeSelectorComponent_Host_0, {}, { dateChange: 'dateChange' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=dateRangeSelector.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/services/reportService.ts





/**
 * Created by alex.y on 9/20/2017.
 */
var reportService_ReportService = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](ReportService, _super);
    function ReportService(http, configService) {
        var _this = _super.call(this, http, configService) || this;
        _this.http = http;
        _this.configService = configService;
        return _this;
    }
    ReportService.prototype.getTotalFee = function (searchRequest) {
        return this.post(new http_es5["i" /* RequestOptions */]({
            url: "report",
            body: searchRequest
        }));
    };
    ReportService.prototype.getRNSStatusReport = function (searchRequest) {
        return this.post(new http_es5["i" /* RequestOptions */]({
            url: "report/rns/status",
            body: searchRequest
        }));
    };
    ReportService.prototype.downloadRNSStatusReport = function (searchRequest) {
        var params = new http_es5["i" /* RequestOptions */]();
        params.headers = new http_es5["d" /* Headers */]();
        params.headers.append("Content-Type", 'application/json');
        params.headers.append("Authorization", "Bearer " + ng2_cookies["Cookie"].get(this.config.ApiTokenCookieName));
        params.method = http_es5["h" /* RequestMethod */].Get;
        params.url = this.config.ApiUrl + "/report/export/rns/status";
        params.params = new http_es5["l" /* URLSearchParams */]();
        params.responseType = http_es5["j" /* ResponseContentType */].Blob;
        return this.http.post(params.url, searchRequest, params).toPromise().then(function (res) {
            var url = window.URL.createObjectURL(res.blob());
            var link = document.createElement('a');
            link.download = 'RNSStatusData.csv';
            link.href = url;
            link.click();
            window.URL.revokeObjectURL(url);
            return new Promise(function (resolve, reject) { return resolve(true); });
        });
    };
    ReportService.ctorParameters = function () { return [{ type: http_es5["e" /* Http */] }, { type: services_configService["a" /* ConfigService */] }]; };
    return ReportService;
}(baseService["a" /* BaseApi */]));

//# sourceMappingURL=reportService.js.map
// CONCATENATED MODULE: ./app/objects/requests/reportSearchRequest.ts
/**
 * Created by alex.y on 9/20/2017.
 */
var ReportSearchRequest = /** @class */ (function () {
    function ReportSearchRequest(obj) {
        this.AgentIds = [];
        Object.assign(this, obj);
    }
    return ReportSearchRequest;
}());

//# sourceMappingURL=reportSearchRequest.js.map
// CONCATENATED MODULE: ./app/objects/report/reportType.ts
/**
 * Created by alex.y on 9/26/2017.
 */
var ReportType;
(function (ReportType) {
    ReportType[ReportType["TotalFee"] = 0] = "TotalFee";
    ReportType[ReportType["TotalQuantity"] = 1] = "TotalQuantity";
})(ReportType || (ReportType = {}));
//# sourceMappingURL=reportType.js.map
// CONCATENATED MODULE: ./app/objects/report/agentColorLink.ts
/**
 * Created by alex.y on 10/24/2017.
 */
var AgentColorLink = /** @class */ (function () {
    function AgentColorLink(obj) {
        Object.assign(this, obj);
    }
    return AgentColorLink;
}());

//# sourceMappingURL=agentColorLink.js.map
// EXTERNAL MODULE: ./node_modules/ng2-cookies/ng2-cookies.js
var ng2_cookies_ng2_cookies = __webpack_require__("46qw");
var ng2_cookies_ng2_cookies_default = /*#__PURE__*/__webpack_require__.n(ng2_cookies_ng2_cookies);

// CONCATENATED MODULE: ./app/common/helpers/hashHelper.ts
/**
 * Created by svitlana.i on 10/26/2017.
 */
var HashHelper = /** @class */ (function () {
    function HashHelper() {
    }
    HashHelper.hashCode = function (str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return hash;
    };
    return HashHelper;
}());

//# sourceMappingURL=hashHelper.js.map
// CONCATENATED MODULE: ./app/components/reports/totalAmount/totalAmount.component.ts













/**
 * Created by alex.y on 9/20/2017.
 */
var totalAmount_component_TotalAmountComponent = /** @class */ (function () {
    function TotalAmountComponent(reportService, route, storageManager, configService) {
        this.reportService = reportService;
        this.route = route;
        this.storageManager = storageManager;
        this.configService = configService;
        this.repType = ReportType;
        this.totalFees = [];
        this.currentAgent = new users_user["c" /* User */]();
        this.startDate = null;
        this.endDate = null;
        this.agentIds = [];
        this.isProcessing = false;
        this.agentColors = [];
        this.allAgents = [];
    }
    TotalAmountComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.totalFees = this.route.snapshot.data.totalFee;
        this.storageManager.getCurrentUser().then(function (x) {
            _this.currentAgent = x;
            if (!_this.canAccess())
                _this.allAgents = _this.route.snapshot.data.allAgents.find(function (x) { return x.Id == ng2_cookies_ng2_cookies["Cookie"].get(_this.configService.config.UserCookieName); });
            else
                _this.allAgents = _this.route.snapshot.data.allAgents;
            _this.generateColors();
            _this.convertDateModelToDate(_this.dateRangeSelectorDate.getCurrentDateModel());
            chartsHelper_ChartsHelper.convertAndCutDate(_this.totalFees, _this.startDate, _this.endDate);
        });
    };
    TotalAmountComponent.prototype.handleDayChanging = function (date) {
        this.convertDateModelToDate(date);
        this.search();
    };
    TotalAmountComponent.prototype.handleAgentsChanging = function (agentIds) {
        this.agentIds = agentIds;
        if (this.agentIds.length == 0) {
            this.totalFees = [];
            return;
        }
        this.search();
    };
    TotalAmountComponent.prototype.searchByAgentId = function () {
        this.startDate = new Date((new Date()).setDate(new Date().getDate() - 7));
        this.endDate = new Date();
        this.agentSelector.setValue();
    };
    TotalAmountComponent.prototype.searchByDate = function () {
        this.agentIds = [];
        this.handleDayChanging(this.dateRangeSelectorDate.getCurrentDateModel());
    };
    TotalAmountComponent.prototype.combinedSearch = function () {
        this.convertDateModelToDate(this.dateRangeSelectorCombined.getCurrentDateModel());
        if (this.agentSelectorCombined)
            this.agentSelectorCombined.setValue();
        else {
            this.search();
        }
    };
    TotalAmountComponent.prototype.search = function () {
        var _this = this;
        this.isProcessing = true;
        this.reportService.getTotalFee(new ReportSearchRequest({
            StartDate: this.startDate,
            EndDate: this.endDate,
            AgentIds: !this.canAccess() ? [this.currentAgent.Id] : (this.agentIds == null ? [] : this.agentIds),
            ReportType: this.reportType
        })).then(function (response) {
            _this.isProcessing = false;
            if (!response || !response.Data)
                return;
            _this.totalFees = response.Data;
            chartsHelper_ChartsHelper.convertAndCutDate(_this.totalFees, _this.startDate, _this.endDate);
        });
    };
    TotalAmountComponent.prototype.convertDateModelToDate = function (date) {
        var startDate = date['beginDate'];
        var endDate = date['endDate'];
        this.startDate = new Date(startDate['year'], startDate['month'] - 1, startDate['day'], 0, 0, 0);
        this.endDate = new Date(endDate['year'], endDate['month'] - 1, endDate['day'], 0, 0, 0);
    };
    TotalAmountComponent.prototype.canAccess = function () {
        if (this.currentAgent.Groups.find(function (x) { return x.Name == "Super Admin"; }))
            return true;
        return false;
    };
    TotalAmountComponent.prototype.generateColors = function () {
        for (var i = 0; i < this.allAgents.length; i++) {
            var color = '#' + ColorHelper.intToRGB(HashHelper.hashCode(this.allAgents[i].Email + guidHelper["a" /* Guid */].newGuid()));
            this.agentColors.push(new AgentColorLink({
                Email: this.allAgents[i].Email,
                color: color
            }));
        }
    };
    TotalAmountComponent.ctorParameters = function () { return [{ type: reportService_ReportService }, { type: router_es5["a" /* ActivatedRoute */] }, { type: managers_storageManager["a" /* StorageManager */] }, { type: services_configService["a" /* ConfigService */] }]; };
    return TotalAmountComponent;
}());

//# sourceMappingURL=totalAmount.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/reports/totalAmount/totalAmount.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */















var styles_TotalAmountComponent = [];
var RenderType_TotalAmountComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_TotalAmountComponent, data: {} });
function View_TotalAmountComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'spinner']], null, null, null, null, null))], null, null);
}
function View_TotalAmountComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [['class',
                'report-title margin-bottom-20 margin-top-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ',
            ' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.canAccess() ? 'Total Amount per Day by Company' : ((('Total Amount per Day by ' + _co.currentAgent.FirstName) + ' ') + _co.currentAgent.LastName));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_TotalAmountComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [['class',
                'report-title margin-bottom-20 margin-top-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ',
            ' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.canAccess() ? 'Total Quotes per Day by Company' : ((('Total Quotes per Day by ' + _co.currentAgent.FirstName) + ' ') + _co.currentAgent.LastName));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_TotalAmountComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'spinner']], null, null, null, null, null))], null, null);
}
function View_TotalAmountComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'chart-total-fee', [], null, [['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).changeHeight() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_TotalFeeChartComponent_0, RenderType_TotalFeeChartComponent)),
        core_es5["ɵdid"](114688, null, 0, TotalFeeChartComponent, [], { totalFeeResponses: [0,
                'totalFeeResponses'], showCurrency: [1, 'showCurrency'], showTotal: [2, 'showTotal'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.totalFees;
        var currVal_1 = (_co.reportType == _co.repType.TotalFee);
        var currVal_2 = true;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2);
    }, null);
}
function View_TotalAmountComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [['class', 'text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['No matching results'])),
        (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_TotalAmountComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [['class',
                'report-title margin-bottom-20 margin-top-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ',
            ' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.canAccess() ? 'Weekly Amount per Agent' : ((('Weekly Amount per Agent by' + _co.currentAgent.FirstName) + ' ') + _co.currentAgent.LastName));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_TotalAmountComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [['class',
                'report-title margin-bottom-20 margin-top-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ',
            ' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.canAccess() ? 'Weekly Quotes per Agent' : ((('Weekly Quotes per Agent by' + _co.currentAgent.FirstName) + ' ') + _co.currentAgent.LastName));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_TotalAmountComponent_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'spinner']], null, null, null, null, null))], null, null);
}
function View_TotalAmountComponent_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'chart-total-fee', [], null, [['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).changeHeight() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_TotalFeeChartComponent_0, RenderType_TotalFeeChartComponent)),
        core_es5["ɵdid"](114688, null, 0, TotalFeeChartComponent, [], { totalFeeResponses: [0,
                'totalFeeResponses'], showCurrency: [1, 'showCurrency'], agentColors: [2, 'agentColors'],
            agentSelectorComponent: [3, 'agentSelectorComponent'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.totalFees;
        var currVal_1 = (_co.reportType == _co.repType.TotalFee);
        var currVal_2 = _co.agentColors;
        var currVal_3 = core_es5["ɵnov"](_v.parent, 36);
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_TotalAmountComponent_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [['class', 'text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['No matching results'])),
        (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_TotalAmountComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 42, 'tab', [['nextButton',
                'hidden'], ['previousButton', 'hidden']], [[2, 'active', null], [2, 'tab-pane',
                null]], [[null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('isSelect' === en)) {
                var pd_0 = (_co.searchByAgentId() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */],
            core_es5["ElementRef"]], { heading: [0, 'heading'], customClass: [1, 'customClass'], previousButton: [2,
                'previousButton'], nextButton: [3, 'nextButton'], index: [4, 'index'] }, { isSelect: 'isSelect' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 38, 'div', [['class', 'card']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 35, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_10)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_11)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 23, 'div', [['class',
                'row combined']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-sm-9']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_12)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_13)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_14)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'col-sm-3 col-xs-12 select-agents']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['perm_contact_calendar'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'agent-selector', [], null, [[null, 'agentsChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('agentsChange' === en)) {
                var pd_0 = (_co.handleAgentsChanging($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_AgentSelectorComponent_0, RenderType_AgentSelectorComponent)),
        core_es5["ɵdid"](4243456, [[2, 4], ['agentSelector', 4]], 0, agentSelector_component["a" /* AgentSelectorComponent */], [services_configService["a" /* ConfigService */]], { currentAgent: [0, 'currentAgent'], select2Id: [1, 'select2Id'], agentColors: [2,
                'agentColors'], allAgents: [3, 'allAgents'] }, { agentsChange: 'agentsChange' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = 'By Person';
        var currVal_3 = 'thin-tab';
        var currVal_4 = 'hidden';
        var currVal_5 = 'hidden';
        var currVal_6 = 1;
        _ck(_v, 1, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (_co.reportType == _co.repType.TotalFee);
        _ck(_v, 10, 0, currVal_7);
        var currVal_8 = (_co.reportType == _co.repType.TotalQuantity);
        _ck(_v, 13, 0, currVal_8);
        var currVal_9 = _co.isProcessing;
        _ck(_v, 21, 0, currVal_9);
        var currVal_10 = (((_co.totalFees.length > 0) && !_co.isProcessing) && ((_co.wizard && _co.wizard.tabs[1]) && _co.wizard.tabs[1].active));
        _ck(_v, 24, 0, currVal_10);
        var currVal_11 = ((_co.totalFees.length == 0) && !_co.isProcessing);
        _ck(_v, 27, 0, currVal_11);
        var currVal_12 = _co.currentAgent;
        var currVal_13 = 'select2AgentId';
        var currVal_14 = _co.agentColors;
        var currVal_15 = _co.allAgents;
        _ck(_v, 36, 0, currVal_12, currVal_13, currVal_14, currVal_15);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).active;
        var currVal_1 = core_es5["ɵnov"](_v, 1).addClass;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
function View_TotalAmountComponent_16(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [['class',
                'report-title margin-bottom-20 margin-top-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ',
            ' ']))], null, function (_ck, _v) {
        var currVal_0 = 'Total Amount Combined (per Agent|per Day)';
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_TotalAmountComponent_17(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [['class',
                'report-title margin-bottom-20 margin-top-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ',
            ' ']))], null, function (_ck, _v) {
        var currVal_0 = 'Total Quotes Combined (per Agent|per Day)';
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_TotalAmountComponent_18(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'spinner']], null, null, null, null, null))], null, null);
}
function View_TotalAmountComponent_19(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 5, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'chart-total-fee', [], null, [[null, 'heightChange'],
            ['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).changeHeight() !== false);
                ad = (pd_0 && ad);
            }
            if (('heightChange' === en)) {
                var pd_1 = ((_co.canvasHeightCombined = $event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_TotalFeeChartComponent_0, RenderType_TotalFeeChartComponent)),
        core_es5["ɵdid"](114688, null, 0, TotalFeeChartComponent, [], { totalFeeResponses: [0,
                'totalFeeResponses'], showCurrency: [1, 'showCurrency'], agentColors: [2, 'agentColors'],
            agentSelectorComponent: [3, 'agentSelectorComponent'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.totalFees;
        var currVal_1 = (_co.reportType == _co.repType.TotalFee);
        var currVal_2 = _co.agentColors;
        var currVal_3 = _co.agentSelectorCombined;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_TotalAmountComponent_20(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [['class', 'text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['No matching results'])),
        (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_TotalAmountComponent_21(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'col-sm-3 select-agents']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['perm_contact_calendar'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'agent-selector', [], null, [[null, 'agentsChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('agentsChange' === en)) {
                var pd_0 = (_co.handleAgentsChanging($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_AgentSelectorComponent_0, RenderType_AgentSelectorComponent)),
        core_es5["ɵdid"](4243456, [[3, 4], ['agentSelectorCombined', 4]], 0, agentSelector_component["a" /* AgentSelectorComponent */], [services_configService["a" /* ConfigService */]], { currentAgent: [0, 'currentAgent'], select2Id: [1, 'select2Id'],
            agentColors: [2, 'agentColors'], allAgents: [3, 'allAgents'] }, { agentsChange: 'agentsChange' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.currentAgent;
        var currVal_1 = 'select2AgentId2';
        var currVal_2 = _co.agentColors;
        var currVal_3 = _co.allAgents;
        _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_TotalAmountComponent_15(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 44, 'tab', [['nextButton',
                'hidden'], ['previousButton', 'hidden']], [[2, 'active', null], [2, 'tab-pane',
                null]], [[null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('isSelect' === en)) {
                var pd_0 = (_co.combinedSearch() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */],
            core_es5["ElementRef"]], { heading: [0, 'heading'], customClass: [1, 'customClass'], previousButton: [2,
                'previousButton'], nextButton: [3, 'nextButton'], index: [4, 'index'] }, { isSelect: 'isSelect' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 40, 'div', [['class', 'card combined']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 37, 'div', [['class', 'card-content']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'text-center report-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_16)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_17)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row calendar']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-md-4 col-xs-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'date-range-selector', [['class', '']], null, [[null, 'dateChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('dateChange' === en)) {
                var pd_0 = (_co.handleDayChanging($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_DateRangeSelectorComponent_0, RenderType_DateRangeSelectorComponent)),
        core_es5["ɵdid"](114688, [[4, 4], ['dateRangeSelectorCombined', 4]], 0, dateRangeSelector_component_DateRangeSelectorComponent, [], null, { dateChange: 'dateChange' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'div', [['class',
                'row combined']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-sm-9']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_18)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_19)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_20)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_21)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = 'Combined';
        var currVal_3 = 'thin-tab';
        var currVal_4 = 'hidden';
        var currVal_5 = 'hidden';
        var currVal_6 = 2;
        _ck(_v, 1, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (_co.reportType == _co.repType.TotalFee);
        _ck(_v, 10, 0, currVal_7);
        var currVal_8 = (_co.reportType == _co.repType.TotalQuantity);
        _ck(_v, 13, 0, currVal_8);
        _ck(_v, 21, 0);
        var currVal_9 = _co.isProcessing;
        _ck(_v, 30, 0, currVal_9);
        var currVal_10 = (((_co.totalFees.length > 0) && !_co.isProcessing) && ((_co.wizard && _co.wizard.tabs[2]) && _co.wizard.tabs[2].active));
        _ck(_v, 33, 0, currVal_10);
        var currVal_11 = ((_co.totalFees.length == 0) && !_co.isProcessing);
        _ck(_v, 36, 0, currVal_11);
        var currVal_12 = (_co.allAgents.length > 0);
        _ck(_v, 40, 0, currVal_12);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).active;
        var currVal_1 = core_es5["ɵnov"](_v, 1).addClass;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
function View_TotalAmountComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 52, 'wizard', [['data-color',
                'cyan']], null, null, null, View_WizardComponent_0, RenderType_WizardComponent)), core_es5["ɵdid"](4440064, [[1, 4], ['reportWizard', 4]], 0, ngx_wizard_es5["d" /* WizardComponent */], [core_es5["ElementRef"]], null, null), core_es5["ɵprd"](2048, null, ngx_wizard_es5["c" /* TabsComponent */], null, [ngx_wizard_es5["d" /* WizardComponent */]]), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 41, 'tab', [['nextButton', 'hidden']], [[2, 'active', null], [2, 'tab-pane', null]], [[null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('isSelect' === en)) {
                var pd_0 = (_co.searchByDate() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { heading: [0, 'heading'], customClass: [1, 'customClass'],
            nextButton: [2, 'nextButton'], index: [3, 'index'] }, { isSelect: 'isSelect' }), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 37, 'div', [['class', 'card']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 34, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'text-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'row calendar']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-4 col-xs-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'date-range-selector', [], null, [[null, 'dateChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('dateChange' === en)) {
                var pd_0 = (_co.handleDayChanging($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_DateRangeSelectorComponent_0, RenderType_DateRangeSelectorComponent)),
        core_es5["ɵdid"](114688, [[5, 4], ['dateRangeSelectorDate', 4]], 0, dateRangeSelector_component_DateRangeSelectorComponent, [], null, { dateChange: 'dateChange' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_8)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, 1, 1, null, View_TotalAmountComponent_9)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 1, 1, null, View_TotalAmountComponent_15)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](1, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        _ck(_v, 1, 0);
        var currVal_2 = 'Per Day';
        var currVal_3 = 'thin-tab';
        var currVal_4 = 'hidden';
        var currVal_5 = 0;
        _ck(_v, 5, 0, currVal_2, currVal_3, currVal_4, currVal_5);
        var currVal_6 = (_co.reportType == _co.repType.TotalFee);
        _ck(_v, 14, 0, currVal_6);
        var currVal_7 = (_co.reportType == _co.repType.TotalQuantity);
        _ck(_v, 17, 0, currVal_7);
        _ck(_v, 25, 0);
        var currVal_8 = _co.isProcessing;
        _ck(_v, 34, 0, currVal_8);
        var currVal_9 = (((_co.totalFees.length > 0) && !_co.isProcessing) && ((_co.wizard && _co.wizard.tabs[0]) && _co.wizard.tabs[0].active));
        _ck(_v, 37, 0, currVal_9);
        var currVal_10 = ((_co.totalFees.length == 0) && !_co.isProcessing);
        _ck(_v, 40, 0, currVal_10);
        var currVal_11 = _co.canAccess();
        _ck(_v, 48, 0, currVal_11);
        var currVal_12 = _co.canAccess();
        _ck(_v, 51, 0, currVal_12);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 5).active;
        var currVal_1 = core_es5["ɵnov"](_v, 5).addClass;
        _ck(_v, 4, 0, currVal_0, currVal_1);
    });
}
function View_TotalAmountComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.totalFees;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_TotalAmountComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](671088640, 1, { wizard: 0 }), core_es5["ɵqud"](671088640, 2, { agentSelector: 0 }),
        core_es5["ɵqud"](671088640, 3, { agentSelectorCombined: 0 }), core_es5["ɵqud"](671088640, 4, { dateRangeSelectorCombined: 0 }),
        core_es5["ɵqud"](671088640, 5, { dateRangeSelectorDate: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'main-content report total-fee']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'container-fluid']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TotalAmountComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.currentAgent;
        _ck(_v, 10, 0, currVal_0);
        var currVal_1 = _co.currentAgent;
        _ck(_v, 13, 0, currVal_1);
    }, null);
}
function View_TotalAmountComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'report-total-fee', [], null, null, null, View_TotalAmountComponent_0, RenderType_TotalAmountComponent)), core_es5["ɵdid"](114688, null, 0, totalAmount_component_TotalAmountComponent, [reportService_ReportService, router_es5["a" /* ActivatedRoute */], managers_storageManager["a" /* StorageManager */], services_configService["a" /* ConfigService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var TotalAmountComponentNgFactory = core_es5["ɵccf"]('report-total-fee', totalAmount_component_TotalAmountComponent, View_TotalAmountComponent_Host_0, { reportType: 'reportType' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=totalAmount.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/reports/totalFeeReport.component.ts

/**
 * Created by alex.y on 9/26/2017.
 */
var totalFeeReport_component_TotalFeeReportComponent = /** @class */ (function () {
    function TotalFeeReportComponent() {
        this.reportType = ReportType;
    }
    return TotalFeeReportComponent;
}());

//# sourceMappingURL=totalFeeReport.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/reports/totalFeeReport.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_TotalFeeReportComponent = [];
var RenderType_TotalFeeReportComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_TotalFeeReportComponent, data: {} });
function View_TotalFeeReportComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'report-total-fee', [], null, null, null, View_TotalAmountComponent_0, RenderType_TotalAmountComponent)), core_es5["ɵdid"](114688, null, 0, totalAmount_component_TotalAmountComponent, [reportService_ReportService, router_es5["a" /* ActivatedRoute */], managers_storageManager["a" /* StorageManager */], services_configService["a" /* ConfigService */]], { reportType: [0,
                'reportType'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.reportType.TotalFee;
        _ck(_v, 1, 0, currVal_0);
    }, null);
}
function View_TotalFeeReportComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'report-total-fee-container', [], null, null, null, View_TotalFeeReportComponent_0, RenderType_TotalFeeReportComponent)), core_es5["ɵdid"](49152, null, 0, totalFeeReport_component_TotalFeeReportComponent, [], null, null)], null, null);
}
var TotalFeeReportComponentNgFactory = core_es5["ɵccf"]('report-total-fee-container', totalFeeReport_component_TotalFeeReportComponent, View_TotalFeeReportComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy90b3RhbEZlZVJlcG9ydC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy90b3RhbEZlZVJlcG9ydC5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9yZXBvcnRzL3RvdGFsRmVlUmVwb3J0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy90b3RhbEZlZVJlcG9ydC5jb21wb25lbnQudHMuVG90YWxGZWVSZXBvcnRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8cmVwb3J0LXRvdGFsLWZlZSBbcmVwb3J0VHlwZV09XCJyZXBvcnRUeXBlLlRvdGFsRmVlXCI+PC9yZXBvcnQtdG90YWwtZmVlPiIsIjxyZXBvcnQtdG90YWwtZmVlLWNvbnRhaW5lcj48L3JlcG9ydC10b3RhbC1mZWUtY29udGFpbmVyPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7d0NBQUEsVUFBQTtNQUFBO1VBQUE7O0lBQWtCO0lBQWxCLFdBQWtCLFNBQWxCOzs7O29CQ0FBO01BQUE7d0NBQUEsVUFBQTtNQUFBOzs7In0=
//# sourceMappingURL=totalFeeReport.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/reports/totalQuantityReport.component.ts

/**
 * Created by alex.y on 9/26/2017.
 */
var totalQuantityReport_component_TotalQuantityReportComponent = /** @class */ (function () {
    function TotalQuantityReportComponent() {
        this.reportType = ReportType;
    }
    return TotalQuantityReportComponent;
}());

//# sourceMappingURL=totalQuantityReport.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/reports/totalQuantityReport.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_TotalQuantityReportComponent = [];
var RenderType_TotalQuantityReportComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_TotalQuantityReportComponent, data: {} });
function View_TotalQuantityReportComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'report-total-fee', [], null, null, null, View_TotalAmountComponent_0, RenderType_TotalAmountComponent)), core_es5["ɵdid"](114688, null, 0, totalAmount_component_TotalAmountComponent, [reportService_ReportService, router_es5["a" /* ActivatedRoute */], managers_storageManager["a" /* StorageManager */], services_configService["a" /* ConfigService */]], { reportType: [0,
                'reportType'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.reportType.TotalQuantity;
        _ck(_v, 1, 0, currVal_0);
    }, null);
}
function View_TotalQuantityReportComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'report-total-quantity-container', [], null, null, null, View_TotalQuantityReportComponent_0, RenderType_TotalQuantityReportComponent)), core_es5["ɵdid"](49152, null, 0, totalQuantityReport_component_TotalQuantityReportComponent, [], null, null)], null, null);
}
var TotalQuantityReportComponentNgFactory = core_es5["ɵccf"]('report-total-quantity-container', totalQuantityReport_component_TotalQuantityReportComponent, View_TotalQuantityReportComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy90b3RhbFF1YW50aXR5UmVwb3J0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9yZXBvcnRzL3RvdGFsUXVhbnRpdHlSZXBvcnQuY29tcG9uZW50LnRzIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy90b3RhbFF1YW50aXR5UmVwb3J0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy90b3RhbFF1YW50aXR5UmVwb3J0LmNvbXBvbmVudC50cy5Ub3RhbFF1YW50aXR5UmVwb3J0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHJlcG9ydC10b3RhbC1mZWUgW3JlcG9ydFR5cGVdPVwicmVwb3J0VHlwZS5Ub3RhbFF1YW50aXR5XCI+PC9yZXBvcnQtdG90YWwtZmVlPiIsIjxyZXBvcnQtdG90YWwtcXVhbnRpdHktY29udGFpbmVyPjwvcmVwb3J0LXRvdGFsLXF1YW50aXR5LWNvbnRhaW5lcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO3dDQUFBLFVBQUE7TUFBQTtVQUFBOztJQUFrQjtJQUFsQixXQUFrQixTQUFsQjs7OztvQkNBQTtNQUFBOzZDQUFBLFVBQUE7TUFBQTs7OzsifQ==
//# sourceMappingURL=totalQuantityReport.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/objects/pars-status-widget/RNS-status.ts
var RNSStatus;
(function (RNSStatus) {
    RNSStatus[RNSStatus["Other"] = 1] = "Other";
    RNSStatus[RNSStatus["Error"] = 2] = "Error";
    RNSStatus[RNSStatus["NumberNotOnFile"] = 3] = "NumberNotOnFile";
    RNSStatus[RNSStatus["DeclarationAccepted"] = 4] = "DeclarationAccepted";
    RNSStatus[RNSStatus["GoodsReleased"] = 5] = "GoodsReleased";
    RNSStatus[RNSStatus["GoodsRequiredForExamination"] = 6] = "GoodsRequiredForExamination";
})(RNSStatus || (RNSStatus = {}));
//# sourceMappingURL=RNS-status.js.map
// CONCATENATED MODULE: ./app/objects/requests/RNSStatusReportRequest.ts
var RNSStatusReportRequest = /** @class */ (function () {
    function RNSStatusReportRequest(obj) {
        this.Skip = 0;
        this.Top = 20;
        Object.assign(this, obj);
    }
    return RNSStatusReportRequest;
}());

//# sourceMappingURL=RNSStatusReportRequest.js.map
// CONCATENATED MODULE: ./app/components/reports/rnsStatus/rns-status.component.ts








var DateRangeModel = /** @class */ (function () {
    function DateRangeModel(obj) {
        Object.assign(this, obj);
    }
    return DateRangeModel;
}());

var rns_status_component_RnsStatusComponent = /** @class */ (function () {
    function RnsStatusComponent(reportService, el, route, cdr, toast) {
        this.reportService = reportService;
        this.el = el;
        this.route = route;
        this.cdr = cdr;
        this.toast = toast;
        this.orders$ = new BehaviorSubject["BehaviorSubject"]([]);
        this.selectedRnsStatus$ = new BehaviorSubject["BehaviorSubject"](null);
        this.RNSStatus = RNSStatus;
        this.isLoading = false;
        this.config = {
            id: 'custom-rns-status-report',
            itemsPerPage: 20,
            currentPage: 1,
            totalItems: 0
        };
        this.tableColumns = [
            new users_user["a" /* Column */]({ Index: 1, Name: 'Date', Property: 'Date', IsSelected: true }),
            new users_user["a" /* Column */]({ Index: 2, Name: 'CCN', Property: 'CCN', IsSelected: true }),
            new users_user["a" /* Column */]({ Index: 3, Name: 'Transaction Number', Property: 'TransactionNumber', IsSelected: true }),
        ];
        this.headerHeight = 60;
        this.rowHeight = 50;
    }
    RnsStatusComponent.prototype.ngOnInit = function () {
        var currentDate = new Date();
        currentDate.setHours(0);
        currentDate.setMinutes(0);
        currentDate.setSeconds(0);
        var previousMonthDate = new Date();
        previousMonthDate.setHours(0);
        previousMonthDate.setMinutes(0);
        previousMonthDate.setSeconds(0);
        previousMonthDate.setDate(currentDate.getDate() - 7);
        this.selectedDateRange$ = new BehaviorSubject["BehaviorSubject"](new DateRangeModel({
            from: previousMonthDate,
            to: currentDate
        }));
    };
    RnsStatusComponent.prototype.getReportRequest = function () {
        return new RNSStatusReportRequest({
            From: this.selectedDateRange$.value.from,
            To: this.selectedDateRange$.value.to,
            Status: this.selectedRnsStatus$.value,
            Top: this.config.itemsPerPage,
            Skip: (this.config.currentPage - 1) * this.config.itemsPerPage
        });
    };
    RnsStatusComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var timeoutId = setTimeout(function () {
            _this.cdr.detectChanges();
            clearTimeout(timeoutId);
        }, 100);
    };
    RnsStatusComponent.prototype.ngOnDestroy = function () {
    };
    RnsStatusComponent.prototype.loadData = function () {
        var _this = this;
        this.isLoading = true;
        this.reportService.getRNSStatusReport(this.getReportRequest())
            .then(function (d) {
            _this.isLoading = false;
            _this.config.totalItems = d.Data.TotalCount;
            _this.orders$.next(d.Data.Items);
        }, function () {
            _this.isLoading = false;
        });
    };
    RnsStatusComponent.prototype.handleDayChanging = function (date) {
        this.selectedDateRange$.next(new DateRangeModel({
            from: date['beginJsDate'],
            to: date['endJsDate']
        }));
    };
    RnsStatusComponent.prototype.downloadFile = function () {
        var _this = this;
        if (!this.selectedRnsStatus$.value) {
            this.toast.error('Please select RNS Status');
            return;
        }
        this.isLoading = true;
        var request = this.getReportRequest();
        request.Top = null;
        this.reportService.downloadRNSStatusReport(request).then(function () {
            _this.isLoading = false;
        }, function () {
            _this.isLoading = false;
        });
    };
    RnsStatusComponent.prototype.search = function () {
        this.loadData();
    };
    RnsStatusComponent.prototype.apply = function () {
        if (!this.selectedRnsStatus$.value) {
            this.toast.error('Please select RNS Status');
            return;
        }
        this.loadData();
    };
    RnsStatusComponent.ctorParameters = function () { return [{ type: reportService_ReportService }, { type: core_es5["ElementRef"] }, { type: router_es5["a" /* ActivatedRoute */] }, { type: core_es5["ChangeDetectorRef"] }, { type: ng2_toastr["ToastsManager"] }]; };
    return RnsStatusComponent;
}());

//# sourceMappingURL=rns-status.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/reports/rnsStatus/rns-status.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



















var styles_RnsStatusComponent = [];
var RenderType_RnsStatusComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_RnsStatusComponent, data: {} });
function View_RnsStatusComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['', ''])), core_es5["ɵppd"](2)], null, function (_ck, _v) {
        var currVal_0 = core_es5["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent.parent.parent, 0), _v.parent.context.value, 'shortDate'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_RnsStatusComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.value;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_RnsStatusComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_RnsStatusComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_RnsStatusComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_0 = (_v.parent.context.$implicit.Index == 1);
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = (_v.parent.context.$implicit.Index != 1);
        _ck(_v, 5, 0, currVal_1);
    }, null);
}
function View_RnsStatusComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 10, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ngx-datatable-column', [], null, null, null, null, null)), core_es5["ɵdid"](16384, [[1, 4]], 2, column_directive["DataTableColumnDirective"], [], { name: [0, 'name'], prop: [1, 'prop'], resizeable: [2, 'resizeable'] }, null), core_es5["ɵqud"](335544320, 5, { cellTemplate: 0 }), core_es5["ɵqud"](335544320, 6, { headerTemplate: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, [[5, 2]], null, 1, null, View_RnsStatusComponent_2)), core_es5["ɵdid"](16384, null, 0, column_cell_directive["DataTableColumnCellDirective"], [core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.Name;
        var currVal_1 = _v.context.$implicit.Property;
        var currVal_2 = false;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2);
    }, null);
}
function View_RnsStatusComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'management-pagination', [], null, [[null, 'searchEventEmitter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('searchEventEmitter' === en)) {
                var pd_0 = (_co.search() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ManagementPaginationComponent_0, RenderType_ManagementPaginationComponent)),
        core_es5["ɵdid"](49152, null, 0, managementPagination_component_ManagementPaginationComponent, [], { config: [0, 'config'] }, { searchEventEmitter: 'searchEventEmitter' }), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.config;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_RnsStatusComponent_0(_l) {
    return core_es5["ɵvid"](2, [core_es5["ɵpid"](0, common_es5["DatePipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](0, null, null, 101, 'div', [['class', 'main-content report total-fee']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 77, 'div', [['class', 'container-fluid']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 74, 'div', [['class', 'calendar rns-header-row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col col-calendar']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'date-range-selector', [], null, [[null, 'dateChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('dateChange' === en)) {
                var pd_0 = (_co.handleDayChanging($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_DateRangeSelectorComponent_0, RenderType_DateRangeSelectorComponent)),
        core_es5["ɵdid"](114688, [['dateRangeSelectorDate', 4]], 0, dateRangeSelector_component_DateRangeSelectorComponent, [], null, { dateChange: 'dateChange' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 48, 'div', [['class', 'col col-status'], ['style', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 45, 'div', [['class',
                'form-group label-floating']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'control-label text-ellipsis-inline']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['RNS Status'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 39, 'select', [['class',
                'form-control'], ['name', 'selectedRnsStatus'], ['placeholder', 'Select RNS status'],
            ['required', '']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'change'],
            [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 21).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 21).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = (_co.selectedRnsStatus$.next($event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[8, null], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵpid"](131072, common_es5["AsyncPipe"], [core_es5["ChangeDetectorRef"]]), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'option', [['disabled',
                'disabled'], ['selected', 'selected']], null, null, null, null, null)), core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"], core_es5["Renderer2"], [2, forms_es5["SelectControlValueAccessor"]]], { value: [0,
                'value'] }, null), core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"],
            core_es5["Renderer2"], [8, null]], { value: [0, 'value'] }, null), (_l()(),
            core_es5["ɵted"](null, ['Select RNS status'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'option', [], null, null, null, null, null)),
        core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"], core_es5["Renderer2"],
            [2, forms_es5["SelectControlValueAccessor"]]], { value: [0, 'value'] }, null), core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], { value: [0,
                'value'] }, null), (_l()(), core_es5["ɵted"](null, ['Number Not On File'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'option', [], null, null, null, null, null)), core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"],
            core_es5["Renderer2"], [2, forms_es5["SelectControlValueAccessor"]]], { value: [0, 'value'] }, null),
        core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], { value: [0, 'value'] }, null), (_l()(), core_es5["ɵted"](null, ['Pending Clearance'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'option', [], null, null, null, null, null)), core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"],
            core_es5["Renderer2"], [2, forms_es5["SelectControlValueAccessor"]]], { value: [0, 'value'] }, null),
        core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], { value: [0, 'value'] }, null), (_l()(), core_es5["ɵted"](null, ['Approved - ready to cross'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'option', [], null, null, null, null, null)), core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"],
            core_es5["Renderer2"], [2, forms_es5["SelectControlValueAccessor"]]], { value: [0, 'value'] }, null),
        core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], { value: [0, 'value'] }, null), (_l()(), core_es5["ɵted"](null, ['Released'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'option', [], null, null, null, null, null)), core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"],
            core_es5["Renderer2"], [2, forms_es5["SelectControlValueAccessor"]]], { value: [0, 'value'] }, null),
        core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], { value: [0, 'value'] }, null), (_l()(), core_es5["ɵted"](null, ['Held for examination'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'col'], ['style',
                'text-align:right']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-white btn-round']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.apply() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Apply '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'col'], ['style', 'text-align:right']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 5, 'button', [['class', 'btn btn-white btn-round btn-just-icon create-icon']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.downloadFile() !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['file_download'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class',
                'container-fluid datatable-custom']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 11, 'ngx-datatable', [['class', 'material ngx-datatable']], [[2, 'fixed-header', null], [2, 'fixed-row', null], [2, 'scroll-vertical',
                    null], [2, 'scroll-horz', null], [2, 'selectable', null],
                [2, 'checkbox-selection', null], [2, 'cell-selection', null],
                [2, 'single-selection', null], [2, 'multi-selection', null],
                [2, 'multi-click-selection', null]], [['window', 'resize']], function (_v, en, $event) {
                var ad = true;
                if (('window:resize' === en)) {
                    var pd_0 = (core_es5["ɵnov"](_v, 85).onWindowResize() !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, View_DatatableComponent_0, RenderType_DatatableComponent)),
        core_es5["ɵdid"](5619712, null, 4, datatable_component["DatatableComponent"], [[1, scrollbar_helper_service["ScrollbarHelper"]],
            [1, dimensions_helper_service["DimensionsHelper"]], core_es5["ChangeDetectorRef"], core_es5["ElementRef"], core_es5["KeyValueDiffers"]], { rows: [0, 'rows'], rowHeight: [1, 'rowHeight'], columnMode: [2, 'columnMode'], headerHeight: [3,
                'headerHeight'], loadingIndicator: [4, 'loadingIndicator'], sortType: [5,
                'sortType'] }, null), core_es5["ɵqud"](603979776, 1, { columnTemplates: 1 }),
        core_es5["ɵqud"](335544320, 2, { rowDetail: 0 }), core_es5["ɵqud"](335544320, 3, { groupHeader: 0 }), core_es5["ɵqud"](335544320, 4, { footer: 0 }), core_es5["ɵpid"](131072, common_es5["AsyncPipe"], [core_es5["ChangeDetectorRef"]]), core_es5["ɵpid"](0, PaginatePipe, [ngx_pagination_PaginationService]), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_RnsStatusComponent_1)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 3, null, View_RnsStatusComponent_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵpid"](131072, common_es5["AsyncPipe"], [core_es5["ChangeDetectorRef"]]),
        core_es5["ɵpid"](131072, common_es5["AsyncPipe"], [core_es5["ChangeDetectorRef"]]), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        _ck(_v, 10, 0);
        var currVal_8 = '';
        _ck(_v, 22, 0, currVal_8);
        var currVal_9 = 'selectedRnsStatus';
        var currVal_10 = core_es5["ɵunv"](_v, 25, 1, core_es5["ɵnov"](_v, 26).transform(_co.selectedRnsStatus$));
        _ck(_v, 25, 0, currVal_9, currVal_10);
        var currVal_11 = null;
        _ck(_v, 31, 0, currVal_11);
        var currVal_12 = null;
        _ck(_v, 32, 0, currVal_12);
        var currVal_13 = _co.RNSStatus.Error;
        _ck(_v, 36, 0, currVal_13);
        var currVal_14 = _co.RNSStatus.Error;
        _ck(_v, 37, 0, currVal_14);
        var currVal_15 = _co.RNSStatus.NumberNotOnFile;
        _ck(_v, 41, 0, currVal_15);
        var currVal_16 = _co.RNSStatus.NumberNotOnFile;
        _ck(_v, 42, 0, currVal_16);
        var currVal_17 = _co.RNSStatus.DeclarationAccepted;
        _ck(_v, 46, 0, currVal_17);
        var currVal_18 = _co.RNSStatus.DeclarationAccepted;
        _ck(_v, 47, 0, currVal_18);
        var currVal_19 = _co.RNSStatus.GoodsReleased;
        _ck(_v, 51, 0, currVal_19);
        var currVal_20 = _co.RNSStatus.GoodsReleased;
        _ck(_v, 52, 0, currVal_20);
        var currVal_21 = _co.RNSStatus.GoodsRequiredForExamination;
        _ck(_v, 56, 0, currVal_21);
        var currVal_22 = _co.RNSStatus.GoodsRequiredForExamination;
        _ck(_v, 57, 0, currVal_22);
        var currVal_35 = core_es5["ɵunv"](_v, 85, 0, core_es5["ɵnov"](_v, 91).transform(core_es5["ɵunv"](_v, 85, 0, core_es5["ɵnov"](_v, 90).transform(_co.orders$)), _co.config));
        var currVal_36 = _co.rowHeight;
        var currVal_37 = 'force';
        var currVal_38 = _co.headerHeight;
        var currVal_39 = _co.isLoading;
        var currVal_40 = 'single';
        _ck(_v, 85, 0, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40);
        var currVal_41 = _co.tableColumns;
        _ck(_v, 94, 0, currVal_41);
        var tmp_42_0 = null;
        var currVal_42 = (core_es5["ɵunv"](_v, 98, 0, core_es5["ɵnov"](_v, 99).transform(_co.orders$)) && ((((tmp_42_0 = core_es5["ɵunv"](_v, 98, 0, core_es5["ɵnov"](_v, 100).transform(_co.orders$))) == null) ? null : tmp_42_0.length) > 0));
        _ck(_v, 98, 0, currVal_42);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (core_es5["ɵnov"](_v, 22).required ? '' : null);
        var currVal_1 = core_es5["ɵnov"](_v, 28).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 28).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 28).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 28).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 28).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 28).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 28).ngClassPending;
        _ck(_v, 20, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_23 = _co.isLoading;
        _ck(_v, 65, 0, currVal_23);
        var currVal_24 = _co.isLoading;
        _ck(_v, 72, 0, currVal_24);
        var currVal_25 = core_es5["ɵnov"](_v, 85).isFixedHeader;
        var currVal_26 = core_es5["ɵnov"](_v, 85).isFixedRow;
        var currVal_27 = core_es5["ɵnov"](_v, 85).isVertScroll;
        var currVal_28 = core_es5["ɵnov"](_v, 85).isHorScroll;
        var currVal_29 = core_es5["ɵnov"](_v, 85).isSelectable;
        var currVal_30 = core_es5["ɵnov"](_v, 85).isCheckboxSelection;
        var currVal_31 = core_es5["ɵnov"](_v, 85).isCellSelection;
        var currVal_32 = core_es5["ɵnov"](_v, 85).isSingleSelection;
        var currVal_33 = core_es5["ɵnov"](_v, 85).isMultiSelection;
        var currVal_34 = core_es5["ɵnov"](_v, 85).isMultiClickSelection;
        _ck(_v, 84, 0, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34);
    });
}
function View_RnsStatusComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'rns-status', [], null, null, null, View_RnsStatusComponent_0, RenderType_RnsStatusComponent)),
        core_es5["ɵdid"](4440064, null, 0, rns_status_component_RnsStatusComponent, [reportService_ReportService, core_es5["ElementRef"],
            router_es5["a" /* ActivatedRoute */], core_es5["ChangeDetectorRef"], toast_manager["ToastsManager"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var RnsStatusComponentNgFactory = core_es5["ɵccf"]('rns-status', rns_status_component_RnsStatusComponent, View_RnsStatusComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=rns-status.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/objects/zonos/classificationRequest.ts
var ClassificationRequest = /** @class */ (function () {
    function ClassificationRequest() {
    }
    return ClassificationRequest;
}());

var ClassificationRequestItem = /** @class */ (function () {
    function ClassificationRequestItem() {
    }
    return ClassificationRequestItem;
}());

//# sourceMappingURL=classificationRequest.js.map
// CONCATENATED MODULE: ./app/objects/zonos/landedCostRequest.ts
var LandedCostRequest = /** @class */ (function () {
    function LandedCostRequest() {
    }
    return LandedCostRequest;
}());

//# sourceMappingURL=landedCostRequest.js.map
// CONCATENATED MODULE: ./app/services/zonos.service.ts




var zonos_service_ZonosService = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](ZonosService, _super);
    function ZonosService(http, configService) {
        return _super.call(this, http, configService) || this;
    }
    ZonosService.prototype.classification = function (request) {
        return this.post(new http_es5["i" /* RequestOptions */]({
            url: "product/classification",
            body: request
        }));
    };
    ZonosService.prototype.landedCost = function (request) {
        return this.post(new http_es5["i" /* RequestOptions */]({
            url: "product/landedcost",
            body: request
        }));
    };
    ZonosService.ctorParameters = function () { return [{ type: http_es5["e" /* Http */] }, { type: services_configService["a" /* ConfigService */] }]; };
    return ZonosService;
}(baseService["a" /* BaseApi */]));

//# sourceMappingURL=zonos.service.js.map
// CONCATENATED MODULE: ./app/objects/zonos/dutyTaxRequest.ts
var DutyTaxRequest = /** @class */ (function () {
    function DutyTaxRequest() {
        this.items = [new DutyTaxItem()];
        this.ship_to = new DutyTaxShipTo();
        this.shipping = new DutyTaxShipping();
    }
    return DutyTaxRequest;
}());

var DutyTaxItem = /** @class */ (function () {
    function DutyTaxItem() {
        this.dimensions = new DutyTaxDimensions();
    }
    return DutyTaxItem;
}());

var DutyTaxDimensions = /** @class */ (function () {
    function DutyTaxDimensions() {
    }
    return DutyTaxDimensions;
}());

var DutyTaxShipTo = /** @class */ (function () {
    function DutyTaxShipTo() {
    }
    return DutyTaxShipTo;
}());

var DutyTaxShipping = /** @class */ (function () {
    function DutyTaxShipping() {
    }
    return DutyTaxShipping;
}());

//# sourceMappingURL=dutyTaxRequest.js.map
// CONCATENATED MODULE: ./app/components/zonos/zonos.component.ts




var zonos_component_ZonosComponent = /** @class */ (function () {
    function ZonosComponent(zonosService) {
        this.zonosService = zonosService;
        this.classificationResponseStr = "";
        this.landedCostResponseStr = "";
    }
    ZonosComponent.prototype.ngOnInit = function () {
        this.classificationRequest = new ClassificationRequest();
        this.classificationRequest.item = new ClassificationRequestItem();
        this.dutyTaxRequest = new DutyTaxRequest();
        this.landedCostRequest = new LandedCostRequest();
    };
    ZonosComponent.prototype.SendClassificationRequest = function (valid) {
        var _this = this;
        if (!valid)
            return;
        this.dutyTaxRequest.ship_to.country = this.classificationRequest.ship_to_country;
        this.dutyTaxRequest.items[0].id = this.classificationRequest.item.id;
        this.dutyTaxRequest.items[0].brand = this.classificationRequest.item.brand;
        this.dutyTaxRequest.items[0].category = this.classificationRequest.item.category;
        this.dutyTaxRequest.items[0].description_retail = this.classificationRequest.item.description;
        this.dutyTaxRequest.items[0].detail = this.classificationRequest.item.detail;
        this.dutyTaxRequest.items[0].hs_code = this.classificationRequest.item.hs_code;
        this.dutyTaxRequest.items[0].image_url = this.classificationRequest.item.image_url;
        this.dutyTaxRequest.items[0].upc_code = this.classificationRequest.item.upc_code;
        this.zonosService.classification({ ClassificationRequest: this.classificationRequest, DutyTaxRequest: this.dutyTaxRequest }).then(function (data) {
            _this.classificationResponseStr = JSON.stringify(data.Data);
        });
    };
    ZonosComponent.prototype.SendLandedCostRequest = function (valid) {
        var _this = this;
        if (!valid)
            return;
        this.zonosService.landedCost(this.landedCostRequest).then(function (data) {
            _this.landedCostResponseStr = JSON.stringify(data.Data);
        });
    };
    ZonosComponent.ctorParameters = function () { return [{ type: zonos_service_ZonosService }]; };
    return ZonosComponent;
}());

//# sourceMappingURL=zonos.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/zonos/zonos.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */












var styles_ZonosComponent = [];
var RenderType_ZonosComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ZonosComponent, data: {} });
function View_ZonosComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Currency is required']))], null, null);
}
function View_ZonosComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Item Id is required']))], null, null);
}
function View_ZonosComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Item Amount is required']))], null, null);
}
function View_ZonosComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Item Quantity is required']))], null, null);
}
function View_ZonosComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Item Description is required']))], null, null);
}
function View_ZonosComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Ship From Country is required']))], null, null);
}
function View_ZonosComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Ship To Country is required']))], null, null);
}
function View_ZonosComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Ship To City is required']))], null, null);
}
function View_ZonosComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Ship To Postal Code is required']))], null, null);
}
function View_ZonosComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Ship To State is required']))], null, null);
}
function View_ZonosComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Shipping Amount is required']))], null, null);
}
function View_ZonosComponent_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Currency is required']))], null, null);
}
function View_ZonosComponent_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Items Amount is required']))], null, null);
}
function View_ZonosComponent_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Ship From Country is required']))], null, null);
}
function View_ZonosComponent_15(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Ship To Country is required']))], null, null);
}
function View_ZonosComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 464, 'div', [['class',
                'main-content']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 461, 'div', [['class', 'container-fluid']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 19, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', 'https://docs.zonos.com/api-reference/request-a-classification']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Classification API documentation'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', 'https://docs.zonos.com/api-reference/request-duties-and-taxes']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Duty tax API documentation'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', 'https://docs.zonos.com/api-reference/request-a-landed-cost']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Landed cost API documentation'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 437, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 434, 'wizard', [], null, null, null, View_WizardComponent_0, RenderType_WizardComponent)), core_es5["ɵdid"](4440064, null, 0, ngx_wizard_es5["d" /* WizardComponent */], [core_es5["ElementRef"]], null, null), core_es5["ɵprd"](2048, null, ngx_wizard_es5["c" /* TabsComponent */], null, [ngx_wizard_es5["d" /* WizardComponent */]]), (_l()(), core_es5["ɵted"](1, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, 1, 307, 'tab', [['nextButton', 'hidden'], ['previousButton',
                'hidden']], [[2, 'active', null], [2, 'tab-pane', null]], null, null, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { heading: [0, 'heading'],
            previousButton: [1, 'previousButton'], nextButton: [2, 'nextButton'], index: [3,
                'index'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 303, 'div', [['class', 'col-xs-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 300, 'form', [['class', 'form-horizontal'], ['id', 'test'], ['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngSubmit'], [null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 38).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 38).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.SendClassificationRequest(core_es5["ɵnov"](_v, 38).valid) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['testForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['label', 'Currency'], ['name', 'currency'],
            ['required', ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.currency = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['currency', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ZonosComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['label', 'Item Id'], ['name', 'itemId'], ['required', ''], ['type',
                'text']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.classificationRequest.item.id = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['itemId', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ZonosComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['label', 'Item Amount'], ['name', 'itemAmount'], ['required',
                ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.items[0].amount = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['itemAmount', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ZonosComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['label', 'Item Quantity'], ['name', 'itemQuantity'], ['required',
                ''], ['type', 'number']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.items[0].quantity = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['itemQuantity', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ZonosComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Item Brand'], ['name', 'itemBrand'], ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.classificationRequest.item.brand = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Item Category'], ['name', 'itemCategory'], ['type',
                'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.classificationRequest.item.category = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['label', 'Item Description'], ['name', 'itemDescription'],
            ['required', ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.classificationRequest.item.description = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['itemDescription', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ZonosComponent_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Item Detail'], ['name', 'itemDetail'], ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.classificationRequest.item.detail = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Item HS Code'], ['name', 'itemHsCode'], ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.classificationRequest.item.hs_code = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Item Image Url'], ['name', 'itemImageUrl'], ['type',
                'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.classificationRequest.item.image_url = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Item Language Code'], ['name', 'itemLanguageCode'],
            ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.classificationRequest.item.language_code = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Item UPC Code'], ['name', 'itemUpcCode'], ['type',
                'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.classificationRequest.item.upc_code = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Item Country of Origin'], ['name', 'countryOfOrigin'],
            ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.items[0].country_of_origin = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Item Weight'], ['name', 'itemWeight'], ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.items[0].weight = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Item Weight Unit'], ['name', 'itemWeightUnit'], ['type',
                'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.items[0].weight_unit = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Item Width'], ['name', 'itemWidth'], ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.items[0].dimensions.width = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Item Length'], ['name', 'itemLength'], ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.items[0].dimensions.length = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Item Height'], ['name', 'itemHeight'], ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.items[0].dimensions.height = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Item Dimensions Unit'], ['name', 'itemDimensionsUnit'],
            ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.items[0].dimensions.unit = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['label', 'Ship From Country'], ['name', 'shipFromCountry'],
            ['required', ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.ship_from_country = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['shipFromCountry', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ZonosComponent_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['label', 'Ship To Country'], ['name', 'shipToCountry'], ['required',
                ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.classificationRequest.ship_to_country = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['shipToCountry', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ZonosComponent_7)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['label', 'Ship To City'], ['name', 'shipToCity'], ['required',
                ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.ship_to.city = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['shipToCity', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ZonosComponent_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['label', 'Ship To Postal Code'], ['name', 'shipToPostalCode'],
            ['required', ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.ship_to.postal_code = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['shipToPostalCode', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ZonosComponent_9)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['label', 'Ship To State'], ['name', 'shipToState'], ['required',
                ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.ship_to.state = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['shipToState', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ZonosComponent_10)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['label', 'Shipping Amount'], ['name', 'shippingAmount'], ['required',
                ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.shipping.amount = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['shippingAmount', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ZonosComponent_11)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Shipping Service Level'], ['name', 'shippingServiceLevel'],
            ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.shipping.service_level = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Sale Type'], ['name', 'saleType'], ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.sale_type = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Landed Cost'], ['name', 'landedCost'], ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.dutyTaxRequest.landed_cost = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn btn-orange'], ['type', 'submit']], null, null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Send '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'ripple-container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'textarea', [['auto-size', ''], ['class', 'form-control'], ['style',
                'border:solid 1px #000'], ['wrap', 'soft']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend'], ['window', 'keyup']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 328)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 328).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 328)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 328)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 329).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('window:keyup' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 335).onKeyUp() !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.classificationResponseStr = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"],
            core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'], options: [1, 'options'] }, { update: 'ngModelChange' }), core_es5["ɵpod"]({ standalone: 0 }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), core_es5["ɵdid"](540672, null, 0, elementAutoSize_directive_ElementAutoSize, [core_es5["ElementRef"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 120, 'tab', [['nextButton', 'hidden'], ['previousButton', 'hidden']], [[2, 'active', null], [2, 'tab-pane', null]], null, null, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { heading: [0, 'heading'],
            previousButton: [1, 'previousButton'], nextButton: [2, 'nextButton'], index: [3,
                'index'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 116, 'div', [['class', 'col-xs-12'], ['lang',
                    'en-US']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 113, 'form', [['class', 'form-horizontal'], ['id', 'test2'], ['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngSubmit'], [null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 347).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 347).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.SendLandedCostRequest(core_es5["ɵnov"](_v, 347).valid) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['test2Form', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['label', 'Currency'], ['name', 'lcCurrency'],
            ['required', ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.landedCostRequest.currency = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['lcCurrency', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ZonosComponent_12)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['label', 'Items Amount'], ['name', 'itemsAmount'], ['required',
                ''], ['type', 'number']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.landedCostRequest.items_amount = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['itemsAmount', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ZonosComponent_13)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Landed Cost'], ['name', 'lcLandedCost'], ['type',
                'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.landedCostRequest.landed_cost = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Sale Type'], ['name', 'lcSaleType'], ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.landedCostRequest.sale_type = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Shipping Amount'], ['name', 'lcShippingAmount'],
            ['type', 'number']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.landedCostRequest.shipping_amount = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['label', 'Ship From Country'], ['name', 'lcShipFromCountry'],
            ['required', ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.landedCostRequest.ship_from_country = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['lcShipFromCountry', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ZonosComponent_14)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['label', 'Ship To Country'], ['name', 'lcShipToCountry'],
            ['required', ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.landedCostRequest.ship_to_country = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['lcShipToCountry', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], label: [2, 'label'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ZonosComponent_15)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Ship To State'], ['name', 'lcShipToState'], ['type',
                'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.landedCostRequest.ship_to_state = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'form-input', [['label', 'Shipping Service Level'], ['name', 'lcShippingServiceLevel'],
            ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.landedCostRequest.shipping_service_level = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, null, 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn btn-orange'], ['type', 'submit']], null, null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Send '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'ripple-container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'textarea', [['auto-size', ''], ['class', 'form-control'], ['style',
                'border:solid 1px #000'], ['wrap', 'soft']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend'], ['window', 'keyup']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 450)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 450).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 450)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 450)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 451).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('window:keyup' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 457).onKeyUp() !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.landedCostResponseStr = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"],
            core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'], options: [1, 'options'] }, { update: 'ngModelChange' }), core_es5["ɵpod"]({ standalone: 0 }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), core_es5["ɵdid"](540672, null, 0, elementAutoSize_directive_ElementAutoSize, [core_es5["ElementRef"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        _ck(_v, 28, 0);
        var currVal_2 = 'Classification and Duty tax';
        var currVal_3 = 'hidden';
        var currVal_4 = 'hidden';
        var currVal_5 = 0;
        _ck(_v, 32, 0, currVal_2, currVal_3, currVal_4, currVal_5);
        var currVal_21 = '';
        _ck(_v, 43, 0, currVal_21);
        var currVal_22 = 'text';
        var currVal_23 = 'currency';
        var currVal_24 = 'Currency';
        var currVal_25 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 45, 0, currVal_22, currVal_23, currVal_24, currVal_25);
        var currVal_26 = 'currency';
        var currVal_27 = _co.dutyTaxRequest.currency;
        _ck(_v, 47, 0, currVal_26, currVal_27);
        var currVal_28 = ((!core_es5["ɵnov"](_v, 45).model.pristine || core_es5["ɵnov"](_v, 38).submitted) && core_es5["ɵnov"](_v, 45).model.hasError('required'));
        _ck(_v, 52, 0, currVal_28);
        var currVal_37 = '';
        _ck(_v, 56, 0, currVal_37);
        var currVal_38 = 'text';
        var currVal_39 = 'itemId';
        var currVal_40 = 'Item Id';
        var currVal_41 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 58, 0, currVal_38, currVal_39, currVal_40, currVal_41);
        var currVal_42 = 'itemId';
        var currVal_43 = _co.classificationRequest.item.id;
        _ck(_v, 60, 0, currVal_42, currVal_43);
        var currVal_44 = ((!core_es5["ɵnov"](_v, 58).model.pristine || core_es5["ɵnov"](_v, 38).submitted) && core_es5["ɵnov"](_v, 58).model.hasError('required'));
        _ck(_v, 65, 0, currVal_44);
        var currVal_53 = '';
        _ck(_v, 69, 0, currVal_53);
        var currVal_54 = 'text';
        var currVal_55 = 'itemAmount';
        var currVal_56 = 'Item Amount';
        var currVal_57 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 71, 0, currVal_54, currVal_55, currVal_56, currVal_57);
        var currVal_58 = 'itemAmount';
        var currVal_59 = _co.dutyTaxRequest.items[0].amount;
        _ck(_v, 73, 0, currVal_58, currVal_59);
        var currVal_60 = ((!core_es5["ɵnov"](_v, 71).model.pristine || core_es5["ɵnov"](_v, 38).submitted) && core_es5["ɵnov"](_v, 71).model.hasError('required'));
        _ck(_v, 78, 0, currVal_60);
        var currVal_69 = '';
        _ck(_v, 82, 0, currVal_69);
        var currVal_70 = 'number';
        var currVal_71 = 'itemQuantity';
        var currVal_72 = 'Item Quantity';
        var currVal_73 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 84, 0, currVal_70, currVal_71, currVal_72, currVal_73);
        var currVal_74 = 'itemQuantity';
        var currVal_75 = _co.dutyTaxRequest.items[0].quantity;
        _ck(_v, 86, 0, currVal_74, currVal_75);
        var currVal_76 = ((!core_es5["ɵnov"](_v, 84).model.pristine || core_es5["ɵnov"](_v, 38).submitted) && core_es5["ɵnov"](_v, 84).model.hasError('required'));
        _ck(_v, 91, 0, currVal_76);
        var currVal_84 = 'text';
        var currVal_85 = 'itemBrand';
        var currVal_86 = 'Item Brand';
        var currVal_87 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 95, 0, currVal_84, currVal_85, currVal_86, currVal_87);
        var currVal_88 = 'itemBrand';
        var currVal_89 = _co.classificationRequest.item.brand;
        _ck(_v, 97, 0, currVal_88, currVal_89);
        var currVal_97 = 'text';
        var currVal_98 = 'itemCategory';
        var currVal_99 = 'Item Category';
        var currVal_100 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 103, 0, currVal_97, currVal_98, currVal_99, currVal_100);
        var currVal_101 = 'itemCategory';
        var currVal_102 = _co.classificationRequest.item.category;
        _ck(_v, 105, 0, currVal_101, currVal_102);
        var currVal_111 = '';
        _ck(_v, 111, 0, currVal_111);
        var currVal_112 = 'text';
        var currVal_113 = 'itemDescription';
        var currVal_114 = 'Item Description';
        var currVal_115 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 113, 0, currVal_112, currVal_113, currVal_114, currVal_115);
        var currVal_116 = 'itemDescription';
        var currVal_117 = _co.classificationRequest.item.description;
        _ck(_v, 115, 0, currVal_116, currVal_117);
        var currVal_118 = ((!core_es5["ɵnov"](_v, 113).model.pristine || core_es5["ɵnov"](_v, 38).submitted) && core_es5["ɵnov"](_v, 113).model.hasError('required'));
        _ck(_v, 120, 0, currVal_118);
        var currVal_126 = 'text';
        var currVal_127 = 'itemDetail';
        var currVal_128 = 'Item Detail';
        var currVal_129 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 124, 0, currVal_126, currVal_127, currVal_128, currVal_129);
        var currVal_130 = 'itemDetail';
        var currVal_131 = _co.classificationRequest.item.detail;
        _ck(_v, 126, 0, currVal_130, currVal_131);
        var currVal_139 = 'text';
        var currVal_140 = 'itemHsCode';
        var currVal_141 = 'Item HS Code';
        var currVal_142 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 132, 0, currVal_139, currVal_140, currVal_141, currVal_142);
        var currVal_143 = 'itemHsCode';
        var currVal_144 = _co.classificationRequest.item.hs_code;
        _ck(_v, 134, 0, currVal_143, currVal_144);
        var currVal_152 = 'text';
        var currVal_153 = 'itemImageUrl';
        var currVal_154 = 'Item Image Url';
        var currVal_155 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 140, 0, currVal_152, currVal_153, currVal_154, currVal_155);
        var currVal_156 = 'itemImageUrl';
        var currVal_157 = _co.classificationRequest.item.image_url;
        _ck(_v, 142, 0, currVal_156, currVal_157);
        var currVal_165 = 'text';
        var currVal_166 = 'itemLanguageCode';
        var currVal_167 = 'Item Language Code';
        var currVal_168 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 148, 0, currVal_165, currVal_166, currVal_167, currVal_168);
        var currVal_169 = 'itemLanguageCode';
        var currVal_170 = _co.classificationRequest.item.language_code;
        _ck(_v, 150, 0, currVal_169, currVal_170);
        var currVal_178 = 'text';
        var currVal_179 = 'itemUpcCode';
        var currVal_180 = 'Item UPC Code';
        var currVal_181 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 156, 0, currVal_178, currVal_179, currVal_180, currVal_181);
        var currVal_182 = 'itemUpcCode';
        var currVal_183 = _co.classificationRequest.item.upc_code;
        _ck(_v, 158, 0, currVal_182, currVal_183);
        var currVal_191 = 'text';
        var currVal_192 = 'countryOfOrigin';
        var currVal_193 = 'Item Country of Origin';
        var currVal_194 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 164, 0, currVal_191, currVal_192, currVal_193, currVal_194);
        var currVal_195 = 'countryOfOrigin';
        var currVal_196 = _co.dutyTaxRequest.items[0].country_of_origin;
        _ck(_v, 166, 0, currVal_195, currVal_196);
        var currVal_204 = 'text';
        var currVal_205 = 'itemWeight';
        var currVal_206 = 'Item Weight';
        var currVal_207 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 172, 0, currVal_204, currVal_205, currVal_206, currVal_207);
        var currVal_208 = 'itemWeight';
        var currVal_209 = _co.dutyTaxRequest.items[0].weight;
        _ck(_v, 174, 0, currVal_208, currVal_209);
        var currVal_217 = 'text';
        var currVal_218 = 'itemWeightUnit';
        var currVal_219 = 'Item Weight Unit';
        var currVal_220 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 180, 0, currVal_217, currVal_218, currVal_219, currVal_220);
        var currVal_221 = 'itemWeightUnit';
        var currVal_222 = _co.dutyTaxRequest.items[0].weight_unit;
        _ck(_v, 182, 0, currVal_221, currVal_222);
        var currVal_230 = 'text';
        var currVal_231 = 'itemWidth';
        var currVal_232 = 'Item Width';
        var currVal_233 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 188, 0, currVal_230, currVal_231, currVal_232, currVal_233);
        var currVal_234 = 'itemWidth';
        var currVal_235 = _co.dutyTaxRequest.items[0].dimensions.width;
        _ck(_v, 190, 0, currVal_234, currVal_235);
        var currVal_243 = 'text';
        var currVal_244 = 'itemLength';
        var currVal_245 = 'Item Length';
        var currVal_246 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 196, 0, currVal_243, currVal_244, currVal_245, currVal_246);
        var currVal_247 = 'itemLength';
        var currVal_248 = _co.dutyTaxRequest.items[0].dimensions.length;
        _ck(_v, 198, 0, currVal_247, currVal_248);
        var currVal_256 = 'text';
        var currVal_257 = 'itemHeight';
        var currVal_258 = 'Item Height';
        var currVal_259 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 204, 0, currVal_256, currVal_257, currVal_258, currVal_259);
        var currVal_260 = 'itemHeight';
        var currVal_261 = _co.dutyTaxRequest.items[0].dimensions.height;
        _ck(_v, 206, 0, currVal_260, currVal_261);
        var currVal_269 = 'text';
        var currVal_270 = 'itemDimensionsUnit';
        var currVal_271 = 'Item Dimensions Unit';
        var currVal_272 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 212, 0, currVal_269, currVal_270, currVal_271, currVal_272);
        var currVal_273 = 'itemDimensionsUnit';
        var currVal_274 = _co.dutyTaxRequest.items[0].dimensions.unit;
        _ck(_v, 214, 0, currVal_273, currVal_274);
        var currVal_283 = '';
        _ck(_v, 220, 0, currVal_283);
        var currVal_284 = 'text';
        var currVal_285 = 'shipFromCountry';
        var currVal_286 = 'Ship From Country';
        var currVal_287 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 222, 0, currVal_284, currVal_285, currVal_286, currVal_287);
        var currVal_288 = 'shipFromCountry';
        var currVal_289 = _co.dutyTaxRequest.ship_from_country;
        _ck(_v, 224, 0, currVal_288, currVal_289);
        var currVal_290 = ((!core_es5["ɵnov"](_v, 222).model.pristine || core_es5["ɵnov"](_v, 38).submitted) && core_es5["ɵnov"](_v, 222).model.hasError('required'));
        _ck(_v, 229, 0, currVal_290);
        var currVal_299 = '';
        _ck(_v, 233, 0, currVal_299);
        var currVal_300 = 'text';
        var currVal_301 = 'shipToCountry';
        var currVal_302 = 'Ship To Country';
        var currVal_303 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 235, 0, currVal_300, currVal_301, currVal_302, currVal_303);
        var currVal_304 = 'shipToCountry';
        var currVal_305 = _co.classificationRequest.ship_to_country;
        _ck(_v, 237, 0, currVal_304, currVal_305);
        var currVal_306 = ((!core_es5["ɵnov"](_v, 235).model.pristine || core_es5["ɵnov"](_v, 38).submitted) && core_es5["ɵnov"](_v, 235).model.hasError('required'));
        _ck(_v, 242, 0, currVal_306);
        var currVal_315 = '';
        _ck(_v, 246, 0, currVal_315);
        var currVal_316 = 'text';
        var currVal_317 = 'shipToCity';
        var currVal_318 = 'Ship To City';
        var currVal_319 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 248, 0, currVal_316, currVal_317, currVal_318, currVal_319);
        var currVal_320 = 'shipToCity';
        var currVal_321 = _co.dutyTaxRequest.ship_to.city;
        _ck(_v, 250, 0, currVal_320, currVal_321);
        var currVal_322 = ((!core_es5["ɵnov"](_v, 248).model.pristine || core_es5["ɵnov"](_v, 38).submitted) && core_es5["ɵnov"](_v, 248).model.hasError('required'));
        _ck(_v, 255, 0, currVal_322);
        var currVal_331 = '';
        _ck(_v, 259, 0, currVal_331);
        var currVal_332 = 'text';
        var currVal_333 = 'shipToPostalCode';
        var currVal_334 = 'Ship To Postal Code';
        var currVal_335 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 261, 0, currVal_332, currVal_333, currVal_334, currVal_335);
        var currVal_336 = 'shipToPostalCode';
        var currVal_337 = _co.dutyTaxRequest.ship_to.postal_code;
        _ck(_v, 263, 0, currVal_336, currVal_337);
        var currVal_338 = ((!core_es5["ɵnov"](_v, 261).model.pristine || core_es5["ɵnov"](_v, 38).submitted) && core_es5["ɵnov"](_v, 261).model.hasError('required'));
        _ck(_v, 268, 0, currVal_338);
        var currVal_347 = '';
        _ck(_v, 272, 0, currVal_347);
        var currVal_348 = 'text';
        var currVal_349 = 'shipToState';
        var currVal_350 = 'Ship To State';
        var currVal_351 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 274, 0, currVal_348, currVal_349, currVal_350, currVal_351);
        var currVal_352 = 'shipToState';
        var currVal_353 = _co.dutyTaxRequest.ship_to.state;
        _ck(_v, 276, 0, currVal_352, currVal_353);
        var currVal_354 = ((!core_es5["ɵnov"](_v, 274).model.pristine || core_es5["ɵnov"](_v, 38).submitted) && core_es5["ɵnov"](_v, 274).model.hasError('required'));
        _ck(_v, 281, 0, currVal_354);
        var currVal_363 = '';
        _ck(_v, 285, 0, currVal_363);
        var currVal_364 = 'text';
        var currVal_365 = 'shippingAmount';
        var currVal_366 = 'Shipping Amount';
        var currVal_367 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 287, 0, currVal_364, currVal_365, currVal_366, currVal_367);
        var currVal_368 = 'shippingAmount';
        var currVal_369 = _co.dutyTaxRequest.shipping.amount;
        _ck(_v, 289, 0, currVal_368, currVal_369);
        var currVal_370 = ((!core_es5["ɵnov"](_v, 287).model.pristine || core_es5["ɵnov"](_v, 38).submitted) && core_es5["ɵnov"](_v, 287).model.hasError('required'));
        _ck(_v, 294, 0, currVal_370);
        var currVal_378 = 'text';
        var currVal_379 = 'shippingServiceLevel';
        var currVal_380 = 'Shipping Service Level';
        var currVal_381 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 298, 0, currVal_378, currVal_379, currVal_380, currVal_381);
        var currVal_382 = 'shippingServiceLevel';
        var currVal_383 = _co.dutyTaxRequest.shipping.service_level;
        _ck(_v, 300, 0, currVal_382, currVal_383);
        var currVal_391 = 'text';
        var currVal_392 = 'saleType';
        var currVal_393 = 'Sale Type';
        var currVal_394 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 306, 0, currVal_391, currVal_392, currVal_393, currVal_394);
        var currVal_395 = 'saleType';
        var currVal_396 = _co.dutyTaxRequest.sale_type;
        _ck(_v, 308, 0, currVal_395, currVal_396);
        var currVal_404 = 'text';
        var currVal_405 = 'landedCost';
        var currVal_406 = 'Landed Cost';
        var currVal_407 = core_es5["ɵnov"](_v, 38);
        _ck(_v, 314, 0, currVal_404, currVal_405, currVal_406, currVal_407);
        var currVal_408 = 'landedCost';
        var currVal_409 = _co.dutyTaxRequest.landed_cost;
        _ck(_v, 316, 0, currVal_408, currVal_409);
        var currVal_417 = _co.classificationResponseStr;
        var currVal_418 = _ck(_v, 332, 0, true);
        _ck(_v, 331, 0, currVal_417, currVal_418);
        var currVal_421 = 'Landed Cost';
        var currVal_422 = 'hidden';
        var currVal_423 = 'hidden';
        var currVal_424 = 1;
        _ck(_v, 341, 0, currVal_421, currVal_422, currVal_423, currVal_424);
        var currVal_440 = '';
        _ck(_v, 352, 0, currVal_440);
        var currVal_441 = 'text';
        var currVal_442 = 'lcCurrency';
        var currVal_443 = 'Currency';
        var currVal_444 = core_es5["ɵnov"](_v, 347);
        _ck(_v, 354, 0, currVal_441, currVal_442, currVal_443, currVal_444);
        var currVal_445 = 'lcCurrency';
        var currVal_446 = _co.landedCostRequest.currency;
        _ck(_v, 356, 0, currVal_445, currVal_446);
        var currVal_447 = ((!core_es5["ɵnov"](_v, 354).model.pristine || core_es5["ɵnov"](_v, 347).submitted) && core_es5["ɵnov"](_v, 354).model.hasError('required'));
        _ck(_v, 361, 0, currVal_447);
        var currVal_456 = '';
        _ck(_v, 365, 0, currVal_456);
        var currVal_457 = 'number';
        var currVal_458 = 'itemsAmount';
        var currVal_459 = 'Items Amount';
        var currVal_460 = core_es5["ɵnov"](_v, 347);
        _ck(_v, 367, 0, currVal_457, currVal_458, currVal_459, currVal_460);
        var currVal_461 = 'itemsAmount';
        var currVal_462 = _co.landedCostRequest.items_amount;
        _ck(_v, 369, 0, currVal_461, currVal_462);
        var currVal_463 = ((!core_es5["ɵnov"](_v, 367).model.pristine || core_es5["ɵnov"](_v, 347).submitted) && core_es5["ɵnov"](_v, 367).model.hasError('required'));
        _ck(_v, 374, 0, currVal_463);
        var currVal_471 = 'text';
        var currVal_472 = 'lcLandedCost';
        var currVal_473 = 'Landed Cost';
        var currVal_474 = core_es5["ɵnov"](_v, 347);
        _ck(_v, 378, 0, currVal_471, currVal_472, currVal_473, currVal_474);
        var currVal_475 = 'lcLandedCost';
        var currVal_476 = _co.landedCostRequest.landed_cost;
        _ck(_v, 380, 0, currVal_475, currVal_476);
        var currVal_484 = 'text';
        var currVal_485 = 'lcSaleType';
        var currVal_486 = 'Sale Type';
        var currVal_487 = core_es5["ɵnov"](_v, 347);
        _ck(_v, 386, 0, currVal_484, currVal_485, currVal_486, currVal_487);
        var currVal_488 = 'lcSaleType';
        var currVal_489 = _co.landedCostRequest.sale_type;
        _ck(_v, 388, 0, currVal_488, currVal_489);
        var currVal_497 = 'number';
        var currVal_498 = 'lcShippingAmount';
        var currVal_499 = 'Shipping Amount';
        var currVal_500 = core_es5["ɵnov"](_v, 347);
        _ck(_v, 394, 0, currVal_497, currVal_498, currVal_499, currVal_500);
        var currVal_501 = 'lcShippingAmount';
        var currVal_502 = _co.landedCostRequest.shipping_amount;
        _ck(_v, 396, 0, currVal_501, currVal_502);
        var currVal_511 = '';
        _ck(_v, 402, 0, currVal_511);
        var currVal_512 = 'text';
        var currVal_513 = 'lcShipFromCountry';
        var currVal_514 = 'Ship From Country';
        var currVal_515 = core_es5["ɵnov"](_v, 347);
        _ck(_v, 404, 0, currVal_512, currVal_513, currVal_514, currVal_515);
        var currVal_516 = 'lcShipFromCountry';
        var currVal_517 = _co.landedCostRequest.ship_from_country;
        _ck(_v, 406, 0, currVal_516, currVal_517);
        var currVal_518 = ((!core_es5["ɵnov"](_v, 404).model.pristine || core_es5["ɵnov"](_v, 347).submitted) && core_es5["ɵnov"](_v, 404).model.hasError('required'));
        _ck(_v, 411, 0, currVal_518);
        var currVal_527 = '';
        _ck(_v, 415, 0, currVal_527);
        var currVal_528 = 'text';
        var currVal_529 = 'lcShipToCountry';
        var currVal_530 = 'Ship To Country';
        var currVal_531 = core_es5["ɵnov"](_v, 347);
        _ck(_v, 417, 0, currVal_528, currVal_529, currVal_530, currVal_531);
        var currVal_532 = 'lcShipToCountry';
        var currVal_533 = _co.landedCostRequest.ship_to_country;
        _ck(_v, 419, 0, currVal_532, currVal_533);
        var currVal_534 = ((!core_es5["ɵnov"](_v, 417).model.pristine || core_es5["ɵnov"](_v, 347).submitted) && core_es5["ɵnov"](_v, 417).model.hasError('required'));
        _ck(_v, 424, 0, currVal_534);
        var currVal_542 = 'text';
        var currVal_543 = 'lcShipToState';
        var currVal_544 = 'Ship To State';
        var currVal_545 = core_es5["ɵnov"](_v, 347);
        _ck(_v, 428, 0, currVal_542, currVal_543, currVal_544, currVal_545);
        var currVal_546 = 'lcShipToState';
        var currVal_547 = _co.landedCostRequest.ship_to_state;
        _ck(_v, 430, 0, currVal_546, currVal_547);
        var currVal_555 = 'text';
        var currVal_556 = 'lcShippingServiceLevel';
        var currVal_557 = 'Shipping Service Level';
        var currVal_558 = core_es5["ɵnov"](_v, 347);
        _ck(_v, 436, 0, currVal_555, currVal_556, currVal_557, currVal_558);
        var currVal_559 = 'lcShippingServiceLevel';
        var currVal_560 = _co.landedCostRequest.shipping_service_level;
        _ck(_v, 438, 0, currVal_559, currVal_560);
        var currVal_568 = _co.landedCostResponseStr;
        var currVal_569 = _ck(_v, 454, 0, true);
        _ck(_v, 453, 0, currVal_568, currVal_569);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 32).active;
        var currVal_1 = core_es5["ɵnov"](_v, 32).addClass;
        _ck(_v, 31, 0, currVal_0, currVal_1);
        var currVal_6 = core_es5["ɵnov"](_v, 40).ngClassUntouched;
        var currVal_7 = core_es5["ɵnov"](_v, 40).ngClassTouched;
        var currVal_8 = core_es5["ɵnov"](_v, 40).ngClassPristine;
        var currVal_9 = core_es5["ɵnov"](_v, 40).ngClassDirty;
        var currVal_10 = core_es5["ɵnov"](_v, 40).ngClassValid;
        var currVal_11 = core_es5["ɵnov"](_v, 40).ngClassInvalid;
        var currVal_12 = core_es5["ɵnov"](_v, 40).ngClassPending;
        _ck(_v, 36, 0, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12);
        var currVal_13 = (core_es5["ɵnov"](_v, 43).required ? '' : null);
        var currVal_14 = core_es5["ɵnov"](_v, 49).ngClassUntouched;
        var currVal_15 = core_es5["ɵnov"](_v, 49).ngClassTouched;
        var currVal_16 = core_es5["ɵnov"](_v, 49).ngClassPristine;
        var currVal_17 = core_es5["ɵnov"](_v, 49).ngClassDirty;
        var currVal_18 = core_es5["ɵnov"](_v, 49).ngClassValid;
        var currVal_19 = core_es5["ɵnov"](_v, 49).ngClassInvalid;
        var currVal_20 = core_es5["ɵnov"](_v, 49).ngClassPending;
        _ck(_v, 42, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20);
        var currVal_29 = (core_es5["ɵnov"](_v, 56).required ? '' : null);
        var currVal_30 = core_es5["ɵnov"](_v, 62).ngClassUntouched;
        var currVal_31 = core_es5["ɵnov"](_v, 62).ngClassTouched;
        var currVal_32 = core_es5["ɵnov"](_v, 62).ngClassPristine;
        var currVal_33 = core_es5["ɵnov"](_v, 62).ngClassDirty;
        var currVal_34 = core_es5["ɵnov"](_v, 62).ngClassValid;
        var currVal_35 = core_es5["ɵnov"](_v, 62).ngClassInvalid;
        var currVal_36 = core_es5["ɵnov"](_v, 62).ngClassPending;
        _ck(_v, 55, 0, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36);
        var currVal_45 = (core_es5["ɵnov"](_v, 69).required ? '' : null);
        var currVal_46 = core_es5["ɵnov"](_v, 75).ngClassUntouched;
        var currVal_47 = core_es5["ɵnov"](_v, 75).ngClassTouched;
        var currVal_48 = core_es5["ɵnov"](_v, 75).ngClassPristine;
        var currVal_49 = core_es5["ɵnov"](_v, 75).ngClassDirty;
        var currVal_50 = core_es5["ɵnov"](_v, 75).ngClassValid;
        var currVal_51 = core_es5["ɵnov"](_v, 75).ngClassInvalid;
        var currVal_52 = core_es5["ɵnov"](_v, 75).ngClassPending;
        _ck(_v, 68, 0, currVal_45, currVal_46, currVal_47, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52);
        var currVal_61 = (core_es5["ɵnov"](_v, 82).required ? '' : null);
        var currVal_62 = core_es5["ɵnov"](_v, 88).ngClassUntouched;
        var currVal_63 = core_es5["ɵnov"](_v, 88).ngClassTouched;
        var currVal_64 = core_es5["ɵnov"](_v, 88).ngClassPristine;
        var currVal_65 = core_es5["ɵnov"](_v, 88).ngClassDirty;
        var currVal_66 = core_es5["ɵnov"](_v, 88).ngClassValid;
        var currVal_67 = core_es5["ɵnov"](_v, 88).ngClassInvalid;
        var currVal_68 = core_es5["ɵnov"](_v, 88).ngClassPending;
        _ck(_v, 81, 0, currVal_61, currVal_62, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67, currVal_68);
        var currVal_77 = core_es5["ɵnov"](_v, 99).ngClassUntouched;
        var currVal_78 = core_es5["ɵnov"](_v, 99).ngClassTouched;
        var currVal_79 = core_es5["ɵnov"](_v, 99).ngClassPristine;
        var currVal_80 = core_es5["ɵnov"](_v, 99).ngClassDirty;
        var currVal_81 = core_es5["ɵnov"](_v, 99).ngClassValid;
        var currVal_82 = core_es5["ɵnov"](_v, 99).ngClassInvalid;
        var currVal_83 = core_es5["ɵnov"](_v, 99).ngClassPending;
        _ck(_v, 94, 0, currVal_77, currVal_78, currVal_79, currVal_80, currVal_81, currVal_82, currVal_83);
        var currVal_90 = core_es5["ɵnov"](_v, 107).ngClassUntouched;
        var currVal_91 = core_es5["ɵnov"](_v, 107).ngClassTouched;
        var currVal_92 = core_es5["ɵnov"](_v, 107).ngClassPristine;
        var currVal_93 = core_es5["ɵnov"](_v, 107).ngClassDirty;
        var currVal_94 = core_es5["ɵnov"](_v, 107).ngClassValid;
        var currVal_95 = core_es5["ɵnov"](_v, 107).ngClassInvalid;
        var currVal_96 = core_es5["ɵnov"](_v, 107).ngClassPending;
        _ck(_v, 102, 0, currVal_90, currVal_91, currVal_92, currVal_93, currVal_94, currVal_95, currVal_96);
        var currVal_103 = (core_es5["ɵnov"](_v, 111).required ? '' : null);
        var currVal_104 = core_es5["ɵnov"](_v, 117).ngClassUntouched;
        var currVal_105 = core_es5["ɵnov"](_v, 117).ngClassTouched;
        var currVal_106 = core_es5["ɵnov"](_v, 117).ngClassPristine;
        var currVal_107 = core_es5["ɵnov"](_v, 117).ngClassDirty;
        var currVal_108 = core_es5["ɵnov"](_v, 117).ngClassValid;
        var currVal_109 = core_es5["ɵnov"](_v, 117).ngClassInvalid;
        var currVal_110 = core_es5["ɵnov"](_v, 117).ngClassPending;
        _ck(_v, 110, 0, currVal_103, currVal_104, currVal_105, currVal_106, currVal_107, currVal_108, currVal_109, currVal_110);
        var currVal_119 = core_es5["ɵnov"](_v, 128).ngClassUntouched;
        var currVal_120 = core_es5["ɵnov"](_v, 128).ngClassTouched;
        var currVal_121 = core_es5["ɵnov"](_v, 128).ngClassPristine;
        var currVal_122 = core_es5["ɵnov"](_v, 128).ngClassDirty;
        var currVal_123 = core_es5["ɵnov"](_v, 128).ngClassValid;
        var currVal_124 = core_es5["ɵnov"](_v, 128).ngClassInvalid;
        var currVal_125 = core_es5["ɵnov"](_v, 128).ngClassPending;
        _ck(_v, 123, 0, currVal_119, currVal_120, currVal_121, currVal_122, currVal_123, currVal_124, currVal_125);
        var currVal_132 = core_es5["ɵnov"](_v, 136).ngClassUntouched;
        var currVal_133 = core_es5["ɵnov"](_v, 136).ngClassTouched;
        var currVal_134 = core_es5["ɵnov"](_v, 136).ngClassPristine;
        var currVal_135 = core_es5["ɵnov"](_v, 136).ngClassDirty;
        var currVal_136 = core_es5["ɵnov"](_v, 136).ngClassValid;
        var currVal_137 = core_es5["ɵnov"](_v, 136).ngClassInvalid;
        var currVal_138 = core_es5["ɵnov"](_v, 136).ngClassPending;
        _ck(_v, 131, 0, currVal_132, currVal_133, currVal_134, currVal_135, currVal_136, currVal_137, currVal_138);
        var currVal_145 = core_es5["ɵnov"](_v, 144).ngClassUntouched;
        var currVal_146 = core_es5["ɵnov"](_v, 144).ngClassTouched;
        var currVal_147 = core_es5["ɵnov"](_v, 144).ngClassPristine;
        var currVal_148 = core_es5["ɵnov"](_v, 144).ngClassDirty;
        var currVal_149 = core_es5["ɵnov"](_v, 144).ngClassValid;
        var currVal_150 = core_es5["ɵnov"](_v, 144).ngClassInvalid;
        var currVal_151 = core_es5["ɵnov"](_v, 144).ngClassPending;
        _ck(_v, 139, 0, currVal_145, currVal_146, currVal_147, currVal_148, currVal_149, currVal_150, currVal_151);
        var currVal_158 = core_es5["ɵnov"](_v, 152).ngClassUntouched;
        var currVal_159 = core_es5["ɵnov"](_v, 152).ngClassTouched;
        var currVal_160 = core_es5["ɵnov"](_v, 152).ngClassPristine;
        var currVal_161 = core_es5["ɵnov"](_v, 152).ngClassDirty;
        var currVal_162 = core_es5["ɵnov"](_v, 152).ngClassValid;
        var currVal_163 = core_es5["ɵnov"](_v, 152).ngClassInvalid;
        var currVal_164 = core_es5["ɵnov"](_v, 152).ngClassPending;
        _ck(_v, 147, 0, currVal_158, currVal_159, currVal_160, currVal_161, currVal_162, currVal_163, currVal_164);
        var currVal_171 = core_es5["ɵnov"](_v, 160).ngClassUntouched;
        var currVal_172 = core_es5["ɵnov"](_v, 160).ngClassTouched;
        var currVal_173 = core_es5["ɵnov"](_v, 160).ngClassPristine;
        var currVal_174 = core_es5["ɵnov"](_v, 160).ngClassDirty;
        var currVal_175 = core_es5["ɵnov"](_v, 160).ngClassValid;
        var currVal_176 = core_es5["ɵnov"](_v, 160).ngClassInvalid;
        var currVal_177 = core_es5["ɵnov"](_v, 160).ngClassPending;
        _ck(_v, 155, 0, currVal_171, currVal_172, currVal_173, currVal_174, currVal_175, currVal_176, currVal_177);
        var currVal_184 = core_es5["ɵnov"](_v, 168).ngClassUntouched;
        var currVal_185 = core_es5["ɵnov"](_v, 168).ngClassTouched;
        var currVal_186 = core_es5["ɵnov"](_v, 168).ngClassPristine;
        var currVal_187 = core_es5["ɵnov"](_v, 168).ngClassDirty;
        var currVal_188 = core_es5["ɵnov"](_v, 168).ngClassValid;
        var currVal_189 = core_es5["ɵnov"](_v, 168).ngClassInvalid;
        var currVal_190 = core_es5["ɵnov"](_v, 168).ngClassPending;
        _ck(_v, 163, 0, currVal_184, currVal_185, currVal_186, currVal_187, currVal_188, currVal_189, currVal_190);
        var currVal_197 = core_es5["ɵnov"](_v, 176).ngClassUntouched;
        var currVal_198 = core_es5["ɵnov"](_v, 176).ngClassTouched;
        var currVal_199 = core_es5["ɵnov"](_v, 176).ngClassPristine;
        var currVal_200 = core_es5["ɵnov"](_v, 176).ngClassDirty;
        var currVal_201 = core_es5["ɵnov"](_v, 176).ngClassValid;
        var currVal_202 = core_es5["ɵnov"](_v, 176).ngClassInvalid;
        var currVal_203 = core_es5["ɵnov"](_v, 176).ngClassPending;
        _ck(_v, 171, 0, currVal_197, currVal_198, currVal_199, currVal_200, currVal_201, currVal_202, currVal_203);
        var currVal_210 = core_es5["ɵnov"](_v, 184).ngClassUntouched;
        var currVal_211 = core_es5["ɵnov"](_v, 184).ngClassTouched;
        var currVal_212 = core_es5["ɵnov"](_v, 184).ngClassPristine;
        var currVal_213 = core_es5["ɵnov"](_v, 184).ngClassDirty;
        var currVal_214 = core_es5["ɵnov"](_v, 184).ngClassValid;
        var currVal_215 = core_es5["ɵnov"](_v, 184).ngClassInvalid;
        var currVal_216 = core_es5["ɵnov"](_v, 184).ngClassPending;
        _ck(_v, 179, 0, currVal_210, currVal_211, currVal_212, currVal_213, currVal_214, currVal_215, currVal_216);
        var currVal_223 = core_es5["ɵnov"](_v, 192).ngClassUntouched;
        var currVal_224 = core_es5["ɵnov"](_v, 192).ngClassTouched;
        var currVal_225 = core_es5["ɵnov"](_v, 192).ngClassPristine;
        var currVal_226 = core_es5["ɵnov"](_v, 192).ngClassDirty;
        var currVal_227 = core_es5["ɵnov"](_v, 192).ngClassValid;
        var currVal_228 = core_es5["ɵnov"](_v, 192).ngClassInvalid;
        var currVal_229 = core_es5["ɵnov"](_v, 192).ngClassPending;
        _ck(_v, 187, 0, currVal_223, currVal_224, currVal_225, currVal_226, currVal_227, currVal_228, currVal_229);
        var currVal_236 = core_es5["ɵnov"](_v, 200).ngClassUntouched;
        var currVal_237 = core_es5["ɵnov"](_v, 200).ngClassTouched;
        var currVal_238 = core_es5["ɵnov"](_v, 200).ngClassPristine;
        var currVal_239 = core_es5["ɵnov"](_v, 200).ngClassDirty;
        var currVal_240 = core_es5["ɵnov"](_v, 200).ngClassValid;
        var currVal_241 = core_es5["ɵnov"](_v, 200).ngClassInvalid;
        var currVal_242 = core_es5["ɵnov"](_v, 200).ngClassPending;
        _ck(_v, 195, 0, currVal_236, currVal_237, currVal_238, currVal_239, currVal_240, currVal_241, currVal_242);
        var currVal_249 = core_es5["ɵnov"](_v, 208).ngClassUntouched;
        var currVal_250 = core_es5["ɵnov"](_v, 208).ngClassTouched;
        var currVal_251 = core_es5["ɵnov"](_v, 208).ngClassPristine;
        var currVal_252 = core_es5["ɵnov"](_v, 208).ngClassDirty;
        var currVal_253 = core_es5["ɵnov"](_v, 208).ngClassValid;
        var currVal_254 = core_es5["ɵnov"](_v, 208).ngClassInvalid;
        var currVal_255 = core_es5["ɵnov"](_v, 208).ngClassPending;
        _ck(_v, 203, 0, currVal_249, currVal_250, currVal_251, currVal_252, currVal_253, currVal_254, currVal_255);
        var currVal_262 = core_es5["ɵnov"](_v, 216).ngClassUntouched;
        var currVal_263 = core_es5["ɵnov"](_v, 216).ngClassTouched;
        var currVal_264 = core_es5["ɵnov"](_v, 216).ngClassPristine;
        var currVal_265 = core_es5["ɵnov"](_v, 216).ngClassDirty;
        var currVal_266 = core_es5["ɵnov"](_v, 216).ngClassValid;
        var currVal_267 = core_es5["ɵnov"](_v, 216).ngClassInvalid;
        var currVal_268 = core_es5["ɵnov"](_v, 216).ngClassPending;
        _ck(_v, 211, 0, currVal_262, currVal_263, currVal_264, currVal_265, currVal_266, currVal_267, currVal_268);
        var currVal_275 = (core_es5["ɵnov"](_v, 220).required ? '' : null);
        var currVal_276 = core_es5["ɵnov"](_v, 226).ngClassUntouched;
        var currVal_277 = core_es5["ɵnov"](_v, 226).ngClassTouched;
        var currVal_278 = core_es5["ɵnov"](_v, 226).ngClassPristine;
        var currVal_279 = core_es5["ɵnov"](_v, 226).ngClassDirty;
        var currVal_280 = core_es5["ɵnov"](_v, 226).ngClassValid;
        var currVal_281 = core_es5["ɵnov"](_v, 226).ngClassInvalid;
        var currVal_282 = core_es5["ɵnov"](_v, 226).ngClassPending;
        _ck(_v, 219, 0, currVal_275, currVal_276, currVal_277, currVal_278, currVal_279, currVal_280, currVal_281, currVal_282);
        var currVal_291 = (core_es5["ɵnov"](_v, 233).required ? '' : null);
        var currVal_292 = core_es5["ɵnov"](_v, 239).ngClassUntouched;
        var currVal_293 = core_es5["ɵnov"](_v, 239).ngClassTouched;
        var currVal_294 = core_es5["ɵnov"](_v, 239).ngClassPristine;
        var currVal_295 = core_es5["ɵnov"](_v, 239).ngClassDirty;
        var currVal_296 = core_es5["ɵnov"](_v, 239).ngClassValid;
        var currVal_297 = core_es5["ɵnov"](_v, 239).ngClassInvalid;
        var currVal_298 = core_es5["ɵnov"](_v, 239).ngClassPending;
        _ck(_v, 232, 0, currVal_291, currVal_292, currVal_293, currVal_294, currVal_295, currVal_296, currVal_297, currVal_298);
        var currVal_307 = (core_es5["ɵnov"](_v, 246).required ? '' : null);
        var currVal_308 = core_es5["ɵnov"](_v, 252).ngClassUntouched;
        var currVal_309 = core_es5["ɵnov"](_v, 252).ngClassTouched;
        var currVal_310 = core_es5["ɵnov"](_v, 252).ngClassPristine;
        var currVal_311 = core_es5["ɵnov"](_v, 252).ngClassDirty;
        var currVal_312 = core_es5["ɵnov"](_v, 252).ngClassValid;
        var currVal_313 = core_es5["ɵnov"](_v, 252).ngClassInvalid;
        var currVal_314 = core_es5["ɵnov"](_v, 252).ngClassPending;
        _ck(_v, 245, 0, currVal_307, currVal_308, currVal_309, currVal_310, currVal_311, currVal_312, currVal_313, currVal_314);
        var currVal_323 = (core_es5["ɵnov"](_v, 259).required ? '' : null);
        var currVal_324 = core_es5["ɵnov"](_v, 265).ngClassUntouched;
        var currVal_325 = core_es5["ɵnov"](_v, 265).ngClassTouched;
        var currVal_326 = core_es5["ɵnov"](_v, 265).ngClassPristine;
        var currVal_327 = core_es5["ɵnov"](_v, 265).ngClassDirty;
        var currVal_328 = core_es5["ɵnov"](_v, 265).ngClassValid;
        var currVal_329 = core_es5["ɵnov"](_v, 265).ngClassInvalid;
        var currVal_330 = core_es5["ɵnov"](_v, 265).ngClassPending;
        _ck(_v, 258, 0, currVal_323, currVal_324, currVal_325, currVal_326, currVal_327, currVal_328, currVal_329, currVal_330);
        var currVal_339 = (core_es5["ɵnov"](_v, 272).required ? '' : null);
        var currVal_340 = core_es5["ɵnov"](_v, 278).ngClassUntouched;
        var currVal_341 = core_es5["ɵnov"](_v, 278).ngClassTouched;
        var currVal_342 = core_es5["ɵnov"](_v, 278).ngClassPristine;
        var currVal_343 = core_es5["ɵnov"](_v, 278).ngClassDirty;
        var currVal_344 = core_es5["ɵnov"](_v, 278).ngClassValid;
        var currVal_345 = core_es5["ɵnov"](_v, 278).ngClassInvalid;
        var currVal_346 = core_es5["ɵnov"](_v, 278).ngClassPending;
        _ck(_v, 271, 0, currVal_339, currVal_340, currVal_341, currVal_342, currVal_343, currVal_344, currVal_345, currVal_346);
        var currVal_355 = (core_es5["ɵnov"](_v, 285).required ? '' : null);
        var currVal_356 = core_es5["ɵnov"](_v, 291).ngClassUntouched;
        var currVal_357 = core_es5["ɵnov"](_v, 291).ngClassTouched;
        var currVal_358 = core_es5["ɵnov"](_v, 291).ngClassPristine;
        var currVal_359 = core_es5["ɵnov"](_v, 291).ngClassDirty;
        var currVal_360 = core_es5["ɵnov"](_v, 291).ngClassValid;
        var currVal_361 = core_es5["ɵnov"](_v, 291).ngClassInvalid;
        var currVal_362 = core_es5["ɵnov"](_v, 291).ngClassPending;
        _ck(_v, 284, 0, currVal_355, currVal_356, currVal_357, currVal_358, currVal_359, currVal_360, currVal_361, currVal_362);
        var currVal_371 = core_es5["ɵnov"](_v, 302).ngClassUntouched;
        var currVal_372 = core_es5["ɵnov"](_v, 302).ngClassTouched;
        var currVal_373 = core_es5["ɵnov"](_v, 302).ngClassPristine;
        var currVal_374 = core_es5["ɵnov"](_v, 302).ngClassDirty;
        var currVal_375 = core_es5["ɵnov"](_v, 302).ngClassValid;
        var currVal_376 = core_es5["ɵnov"](_v, 302).ngClassInvalid;
        var currVal_377 = core_es5["ɵnov"](_v, 302).ngClassPending;
        _ck(_v, 297, 0, currVal_371, currVal_372, currVal_373, currVal_374, currVal_375, currVal_376, currVal_377);
        var currVal_384 = core_es5["ɵnov"](_v, 310).ngClassUntouched;
        var currVal_385 = core_es5["ɵnov"](_v, 310).ngClassTouched;
        var currVal_386 = core_es5["ɵnov"](_v, 310).ngClassPristine;
        var currVal_387 = core_es5["ɵnov"](_v, 310).ngClassDirty;
        var currVal_388 = core_es5["ɵnov"](_v, 310).ngClassValid;
        var currVal_389 = core_es5["ɵnov"](_v, 310).ngClassInvalid;
        var currVal_390 = core_es5["ɵnov"](_v, 310).ngClassPending;
        _ck(_v, 305, 0, currVal_384, currVal_385, currVal_386, currVal_387, currVal_388, currVal_389, currVal_390);
        var currVal_397 = core_es5["ɵnov"](_v, 318).ngClassUntouched;
        var currVal_398 = core_es5["ɵnov"](_v, 318).ngClassTouched;
        var currVal_399 = core_es5["ɵnov"](_v, 318).ngClassPristine;
        var currVal_400 = core_es5["ɵnov"](_v, 318).ngClassDirty;
        var currVal_401 = core_es5["ɵnov"](_v, 318).ngClassValid;
        var currVal_402 = core_es5["ɵnov"](_v, 318).ngClassInvalid;
        var currVal_403 = core_es5["ɵnov"](_v, 318).ngClassPending;
        _ck(_v, 313, 0, currVal_397, currVal_398, currVal_399, currVal_400, currVal_401, currVal_402, currVal_403);
        var currVal_410 = core_es5["ɵnov"](_v, 334).ngClassUntouched;
        var currVal_411 = core_es5["ɵnov"](_v, 334).ngClassTouched;
        var currVal_412 = core_es5["ɵnov"](_v, 334).ngClassPristine;
        var currVal_413 = core_es5["ɵnov"](_v, 334).ngClassDirty;
        var currVal_414 = core_es5["ɵnov"](_v, 334).ngClassValid;
        var currVal_415 = core_es5["ɵnov"](_v, 334).ngClassInvalid;
        var currVal_416 = core_es5["ɵnov"](_v, 334).ngClassPending;
        _ck(_v, 327, 0, currVal_410, currVal_411, currVal_412, currVal_413, currVal_414, currVal_415, currVal_416);
        var currVal_419 = core_es5["ɵnov"](_v, 341).active;
        var currVal_420 = core_es5["ɵnov"](_v, 341).addClass;
        _ck(_v, 340, 0, currVal_419, currVal_420);
        var currVal_425 = core_es5["ɵnov"](_v, 349).ngClassUntouched;
        var currVal_426 = core_es5["ɵnov"](_v, 349).ngClassTouched;
        var currVal_427 = core_es5["ɵnov"](_v, 349).ngClassPristine;
        var currVal_428 = core_es5["ɵnov"](_v, 349).ngClassDirty;
        var currVal_429 = core_es5["ɵnov"](_v, 349).ngClassValid;
        var currVal_430 = core_es5["ɵnov"](_v, 349).ngClassInvalid;
        var currVal_431 = core_es5["ɵnov"](_v, 349).ngClassPending;
        _ck(_v, 345, 0, currVal_425, currVal_426, currVal_427, currVal_428, currVal_429, currVal_430, currVal_431);
        var currVal_432 = (core_es5["ɵnov"](_v, 352).required ? '' : null);
        var currVal_433 = core_es5["ɵnov"](_v, 358).ngClassUntouched;
        var currVal_434 = core_es5["ɵnov"](_v, 358).ngClassTouched;
        var currVal_435 = core_es5["ɵnov"](_v, 358).ngClassPristine;
        var currVal_436 = core_es5["ɵnov"](_v, 358).ngClassDirty;
        var currVal_437 = core_es5["ɵnov"](_v, 358).ngClassValid;
        var currVal_438 = core_es5["ɵnov"](_v, 358).ngClassInvalid;
        var currVal_439 = core_es5["ɵnov"](_v, 358).ngClassPending;
        _ck(_v, 351, 0, currVal_432, currVal_433, currVal_434, currVal_435, currVal_436, currVal_437, currVal_438, currVal_439);
        var currVal_448 = (core_es5["ɵnov"](_v, 365).required ? '' : null);
        var currVal_449 = core_es5["ɵnov"](_v, 371).ngClassUntouched;
        var currVal_450 = core_es5["ɵnov"](_v, 371).ngClassTouched;
        var currVal_451 = core_es5["ɵnov"](_v, 371).ngClassPristine;
        var currVal_452 = core_es5["ɵnov"](_v, 371).ngClassDirty;
        var currVal_453 = core_es5["ɵnov"](_v, 371).ngClassValid;
        var currVal_454 = core_es5["ɵnov"](_v, 371).ngClassInvalid;
        var currVal_455 = core_es5["ɵnov"](_v, 371).ngClassPending;
        _ck(_v, 364, 0, currVal_448, currVal_449, currVal_450, currVal_451, currVal_452, currVal_453, currVal_454, currVal_455);
        var currVal_464 = core_es5["ɵnov"](_v, 382).ngClassUntouched;
        var currVal_465 = core_es5["ɵnov"](_v, 382).ngClassTouched;
        var currVal_466 = core_es5["ɵnov"](_v, 382).ngClassPristine;
        var currVal_467 = core_es5["ɵnov"](_v, 382).ngClassDirty;
        var currVal_468 = core_es5["ɵnov"](_v, 382).ngClassValid;
        var currVal_469 = core_es5["ɵnov"](_v, 382).ngClassInvalid;
        var currVal_470 = core_es5["ɵnov"](_v, 382).ngClassPending;
        _ck(_v, 377, 0, currVal_464, currVal_465, currVal_466, currVal_467, currVal_468, currVal_469, currVal_470);
        var currVal_477 = core_es5["ɵnov"](_v, 390).ngClassUntouched;
        var currVal_478 = core_es5["ɵnov"](_v, 390).ngClassTouched;
        var currVal_479 = core_es5["ɵnov"](_v, 390).ngClassPristine;
        var currVal_480 = core_es5["ɵnov"](_v, 390).ngClassDirty;
        var currVal_481 = core_es5["ɵnov"](_v, 390).ngClassValid;
        var currVal_482 = core_es5["ɵnov"](_v, 390).ngClassInvalid;
        var currVal_483 = core_es5["ɵnov"](_v, 390).ngClassPending;
        _ck(_v, 385, 0, currVal_477, currVal_478, currVal_479, currVal_480, currVal_481, currVal_482, currVal_483);
        var currVal_490 = core_es5["ɵnov"](_v, 398).ngClassUntouched;
        var currVal_491 = core_es5["ɵnov"](_v, 398).ngClassTouched;
        var currVal_492 = core_es5["ɵnov"](_v, 398).ngClassPristine;
        var currVal_493 = core_es5["ɵnov"](_v, 398).ngClassDirty;
        var currVal_494 = core_es5["ɵnov"](_v, 398).ngClassValid;
        var currVal_495 = core_es5["ɵnov"](_v, 398).ngClassInvalid;
        var currVal_496 = core_es5["ɵnov"](_v, 398).ngClassPending;
        _ck(_v, 393, 0, currVal_490, currVal_491, currVal_492, currVal_493, currVal_494, currVal_495, currVal_496);
        var currVal_503 = (core_es5["ɵnov"](_v, 402).required ? '' : null);
        var currVal_504 = core_es5["ɵnov"](_v, 408).ngClassUntouched;
        var currVal_505 = core_es5["ɵnov"](_v, 408).ngClassTouched;
        var currVal_506 = core_es5["ɵnov"](_v, 408).ngClassPristine;
        var currVal_507 = core_es5["ɵnov"](_v, 408).ngClassDirty;
        var currVal_508 = core_es5["ɵnov"](_v, 408).ngClassValid;
        var currVal_509 = core_es5["ɵnov"](_v, 408).ngClassInvalid;
        var currVal_510 = core_es5["ɵnov"](_v, 408).ngClassPending;
        _ck(_v, 401, 0, currVal_503, currVal_504, currVal_505, currVal_506, currVal_507, currVal_508, currVal_509, currVal_510);
        var currVal_519 = (core_es5["ɵnov"](_v, 415).required ? '' : null);
        var currVal_520 = core_es5["ɵnov"](_v, 421).ngClassUntouched;
        var currVal_521 = core_es5["ɵnov"](_v, 421).ngClassTouched;
        var currVal_522 = core_es5["ɵnov"](_v, 421).ngClassPristine;
        var currVal_523 = core_es5["ɵnov"](_v, 421).ngClassDirty;
        var currVal_524 = core_es5["ɵnov"](_v, 421).ngClassValid;
        var currVal_525 = core_es5["ɵnov"](_v, 421).ngClassInvalid;
        var currVal_526 = core_es5["ɵnov"](_v, 421).ngClassPending;
        _ck(_v, 414, 0, currVal_519, currVal_520, currVal_521, currVal_522, currVal_523, currVal_524, currVal_525, currVal_526);
        var currVal_535 = core_es5["ɵnov"](_v, 432).ngClassUntouched;
        var currVal_536 = core_es5["ɵnov"](_v, 432).ngClassTouched;
        var currVal_537 = core_es5["ɵnov"](_v, 432).ngClassPristine;
        var currVal_538 = core_es5["ɵnov"](_v, 432).ngClassDirty;
        var currVal_539 = core_es5["ɵnov"](_v, 432).ngClassValid;
        var currVal_540 = core_es5["ɵnov"](_v, 432).ngClassInvalid;
        var currVal_541 = core_es5["ɵnov"](_v, 432).ngClassPending;
        _ck(_v, 427, 0, currVal_535, currVal_536, currVal_537, currVal_538, currVal_539, currVal_540, currVal_541);
        var currVal_548 = core_es5["ɵnov"](_v, 440).ngClassUntouched;
        var currVal_549 = core_es5["ɵnov"](_v, 440).ngClassTouched;
        var currVal_550 = core_es5["ɵnov"](_v, 440).ngClassPristine;
        var currVal_551 = core_es5["ɵnov"](_v, 440).ngClassDirty;
        var currVal_552 = core_es5["ɵnov"](_v, 440).ngClassValid;
        var currVal_553 = core_es5["ɵnov"](_v, 440).ngClassInvalid;
        var currVal_554 = core_es5["ɵnov"](_v, 440).ngClassPending;
        _ck(_v, 435, 0, currVal_548, currVal_549, currVal_550, currVal_551, currVal_552, currVal_553, currVal_554);
        var currVal_561 = core_es5["ɵnov"](_v, 456).ngClassUntouched;
        var currVal_562 = core_es5["ɵnov"](_v, 456).ngClassTouched;
        var currVal_563 = core_es5["ɵnov"](_v, 456).ngClassPristine;
        var currVal_564 = core_es5["ɵnov"](_v, 456).ngClassDirty;
        var currVal_565 = core_es5["ɵnov"](_v, 456).ngClassValid;
        var currVal_566 = core_es5["ɵnov"](_v, 456).ngClassInvalid;
        var currVal_567 = core_es5["ɵnov"](_v, 456).ngClassPending;
        _ck(_v, 449, 0, currVal_561, currVal_562, currVal_563, currVal_564, currVal_565, currVal_566, currVal_567);
    });
}
function View_ZonosComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'classification', [], null, null, null, View_ZonosComponent_0, RenderType_ZonosComponent)), core_es5["ɵdid"](114688, null, 0, zonos_component_ZonosComponent, [zonos_service_ZonosService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ZonosComponentNgFactory = core_es5["ɵccf"]('classification', zonos_component_ZonosComponent, View_ZonosComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=zonos.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/Managment/amazon-management/store/amazon-product-export.component.ts



var amazon_product_export_component_AmazonProductExportComponent = /** @class */ (function () {
    function AmazonProductExportComponent(route, uploadService, renderer) {
        this.route = route;
        this.uploadService = uploadService;
        this.renderer = renderer;
    }
    AmazonProductExportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (param) {
            var sellerId = param['sellerId'];
            var storeId = param['storeId'];
            _this.uploadService.downloadFile(null, "amazon/seller/" + sellerId + "/store/" + storeId + "/export", [], "amazon_products.csv").then(function (x) {
                setTimeout(function (_) {
                    window.close();
                }, 1000);
            });
        });
    };
    AmazonProductExportComponent.prototype.ngAfterViewInit = function () {
        var spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");
    };
    AmazonProductExportComponent.ctorParameters = function () { return [{ type: router_es5["a" /* ActivatedRoute */] }, { type: uploadService_UploadService }, { type: core_es5["Renderer2"] }]; };
    return AmazonProductExportComponent;
}());

//# sourceMappingURL=amazon-product-export.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/Managment/amazon-management/store/amazon-product-export.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_AmazonProductExportComponent = [];
var RenderType_AmazonProductExportComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AmazonProductExportComponent, data: {} });
function View_AmazonProductExportComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'text-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Please wait...'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class',
                'spinner-container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'spinner']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_AmazonProductExportComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'amazon-product-export', [], null, null, null, View_AmazonProductExportComponent_0, RenderType_AmazonProductExportComponent)), core_es5["ɵdid"](4308992, null, 0, amazon_product_export_component_AmazonProductExportComponent, [router_es5["a" /* ActivatedRoute */], uploadService_UploadService, core_es5["Renderer2"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AmazonProductExportComponentNgFactory = core_es5["ɵccf"]('amazon-product-export', amazon_product_export_component_AmazonProductExportComponent, View_AmazonProductExportComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L2FtYXpvbi1tYW5hZ2VtZW50L3N0b3JlL2FtYXpvbi1wcm9kdWN0LWV4cG9ydC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L2FtYXpvbi1tYW5hZ2VtZW50L3N0b3JlL2FtYXpvbi1wcm9kdWN0LWV4cG9ydC5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9NYW5hZ21lbnQvYW1hem9uLW1hbmFnZW1lbnQvc3RvcmUvYW1hem9uLXByb2R1Y3QtZXhwb3J0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvTWFuYWdtZW50L2FtYXpvbi1tYW5hZ2VtZW50L3N0b3JlL2FtYXpvbi1wcm9kdWN0LWV4cG9ydC5jb21wb25lbnQudHMuQW1hem9uUHJvZHVjdEV4cG9ydENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJ0ZXh0LWNlbnRlclwiPlBsZWFzZSB3YWl0Li4uPC9kaXY+IDxkaXYgY2xhc3M9XCJzcGlubmVyLWNvbnRhaW5lclwiPiA8ZGl2IGNsYXNzPVwic3Bpbm5lclwiPjwvZGl2PiA8L2Rpdj4iLCI8YW1hem9uLXByb2R1Y3QtZXhwb3J0PjwvYW1hem9uLXByb2R1Y3QtZXhwb3J0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUF5QixtREFBb0I7VUFBQSxRQUFDO1VBQUE7VUFBQSxnQkFBK0Isc0NBQUM7VUFBQTtVQUFBLDBEQUEyQjtVQUFBOzs7b0JDQXpHO01BQUE7NkNBQUEsVUFBQTtNQUFBOztRQUFBOzs7OzsifQ==
//# sourceMappingURL=amazon-product-export.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/export/order-export.component.ts




var order_export_component_OrderExportComponent = /** @class */ (function () {
    function OrderExportComponent(route, uploadService, renderer) {
        this.route = route;
        this.uploadService = uploadService;
        this.renderer = renderer;
    }
    OrderExportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (param) {
            var dateFrom = param['datefrom'];
            var dateTo = param['dateto'];
            var fileName = "order_export_" + guidHelper["a" /* Guid */].newGuid() + ".csv";
            _this.uploadService.exportOrders(fileName, dateFrom, dateTo).then(function () {
                setTimeout(function (_) {
                    window.close();
                }, 1000);
            });
        });
    };
    OrderExportComponent.prototype.ngAfterViewInit = function () {
        var spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");
    };
    OrderExportComponent.ctorParameters = function () { return [{ type: router_es5["a" /* ActivatedRoute */] }, { type: uploadService_UploadService }, { type: core_es5["Renderer2"] }]; };
    return OrderExportComponent;
}());

//# sourceMappingURL=order-export.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/export/order-export.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_OrderExportComponent = [];
var RenderType_OrderExportComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_OrderExportComponent, data: {} });
function View_OrderExportComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'text-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Please wait...'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class',
                'spinner-container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'spinner']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_OrderExportComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-export', [], null, null, null, View_OrderExportComponent_0, RenderType_OrderExportComponent)), core_es5["ɵdid"](4308992, null, 0, order_export_component_OrderExportComponent, [router_es5["a" /* ActivatedRoute */], uploadService_UploadService, core_es5["Renderer2"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var OrderExportComponentNgFactory = core_es5["ɵccf"]('order-export', order_export_component_OrderExportComponent, View_OrderExportComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvZXhwb3J0L29yZGVyLWV4cG9ydC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvZXhwb3J0L29yZGVyLWV4cG9ydC5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9leHBvcnQvb3JkZXItZXhwb3J0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvZXhwb3J0L29yZGVyLWV4cG9ydC5jb21wb25lbnQudHMuT3JkZXJFeHBvcnRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwidGV4dC1jZW50ZXJcIj5QbGVhc2Ugd2FpdC4uLjwvZGl2PiA8ZGl2IGNsYXNzPVwic3Bpbm5lci1jb250YWluZXJcIj4gPGRpdiBjbGFzcz1cInNwaW5uZXJcIj48L2Rpdj4gPC9kaXY+IiwiPG9yZGVyLWV4cG9ydD48L29yZGVyLWV4cG9ydD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBeUIsbURBQW9CO1VBQUEsUUFBQztVQUFBO1VBQUEsZ0JBQStCLHNDQUFDO1VBQUE7VUFBQSwwREFBMkI7VUFBQTs7O29CQ0F6RztNQUFBO3FDQUFBLFVBQUE7TUFBQTs7UUFBQTs7OzsifQ==
//# sourceMappingURL=order-export.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/node_modules/slick-carousel/slick/slick.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var slick_css_ngstyle_styles = ['.slick-slider{box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-khtml-user-select:none;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-tap-highlight-color:transparent}.slick-list,.slick-slider{position:relative;display:block}.slick-list{overflow:hidden;margin:0;padding:0}.slick-list:focus{outline:none}.slick-list.dragging{cursor:pointer;cursor:hand}.slick-slider .slick-list,.slick-slider .slick-track{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0)}.slick-track{position:relative;top:0;left:0;display:block;margin-left:auto;margin-right:auto}.slick-track:after,.slick-track:before{display:table;content:""}.slick-track:after{clear:both}.slick-loading .slick-track{visibility:hidden}.slick-slide{display:none;float:left;height:100%;min-height:1px}[dir=rtl] .slick-slide{float:right}.slick-slide img{display:block}.slick-slide.slick-loading img{display:none}.slick-slide.dragging img{pointer-events:none}.slick-initialized .slick-slide{display:block}.slick-loading .slick-slide{visibility:hidden}.slick-vertical .slick-slide{display:block;height:auto;border:1px solid transparent}.slick-arrow.slick-hidden{display:none}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL3NsaWNrLWNhcm91c2VsL3NsaWNrL3NsaWNrLmNzcy5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL3NsaWNrLWNhcm91c2VsL3NsaWNrL3NsaWNrLmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=slick.css.ngstyle.js.map
// CONCATENATED MODULE: ./compiled/node_modules/slick-carousel/slick/slick-theme.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var slick_theme_css_ngstyle_styles = ['.slick-loading .slick-list{background:#fff url(assets/ajax-loader.c5cd7f5300576ab4c88202b42f6ded62.gif) 50% no-repeat}@font-face{font-family:slick;font-weight:400;font-style:normal;src:url(assets/slick.ced611daf7709cc778da928fec876475.eot);src:url(assets/slick.ced611daf7709cc778da928fec876475.eot?#iefix) format("embedded-opentype"),url(assets/slick.b7c9e1e479de3b53f1e4e30ebac2403a.woff) format("woff"),url(assets/slick.d41f55a78e6f49a5512878df1737e58a.ttf) format("truetype"),url(assets/slick.f97e3bbf73254b0112091d0192f17aec.svg#slick) format("svg")}.slick-next,.slick-prev{font-size:0;line-height:0;position:absolute;top:50%;display:block;width:20px;height:20px;padding:0;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);cursor:pointer;border:none}.slick-next,.slick-next:focus,.slick-next:hover,.slick-prev,.slick-prev:focus,.slick-prev:hover{color:transparent;outline:none;background:transparent}.slick-next:focus:before,.slick-next:hover:before,.slick-prev:focus:before,.slick-prev:hover:before{opacity:1}.slick-next.slick-disabled:before,.slick-prev.slick-disabled:before{opacity:.25}.slick-next:before,.slick-prev:before{font-family:slick;font-size:20px;line-height:1;opacity:.75;color:#fff;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-prev{left:-25px}[dir=rtl] .slick-prev{right:-25px;left:auto}.slick-prev:before{content:"\\2190"}[dir=rtl] .slick-prev:before{content:"\\2192"}.slick-next{right:-25px}[dir=rtl] .slick-next{right:auto;left:-25px}.slick-next:before{content:"\\2192"}[dir=rtl] .slick-next:before{content:"\\2190"}.slick-dotted.slick-slider{margin-bottom:30px}.slick-dots{position:absolute;bottom:-25px;display:block;width:100%;padding:0;margin:0;list-style:none;text-align:center}.slick-dots li{position:relative;display:inline-block;margin:0 5px;padding:0}.slick-dots li,.slick-dots li button{width:20px;height:20px;cursor:pointer}.slick-dots li button{font-size:0;line-height:0;display:block;padding:5px;color:transparent;border:0;outline:none;background:transparent}.slick-dots li button:focus,.slick-dots li button:hover{outline:none}.slick-dots li button:focus:before,.slick-dots li button:hover:before{opacity:1}.slick-dots li button:before{font-family:slick;font-size:6px;line-height:20px;position:absolute;top:0;left:0;width:20px;height:20px;content:"\\2022";text-align:center;opacity:.25;color:#000;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-dots li.slick-active button:before{opacity:.75;color:#000}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL3NsaWNrLWNhcm91c2VsL3NsaWNrL3NsaWNrLXRoZW1lLmNzcy5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL3NsaWNrLWNhcm91c2VsL3NsaWNrL3NsaWNrLXRoZW1lLmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=slick-theme.css.ngstyle.js.map
// EXTERNAL MODULE: ./app/components/amazon/amazon.component.ts
var amazon_component = __webpack_require__("+W9T");

// CONCATENATED MODULE: ./compiled/app/components/amazon/amazon.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */









var styles_AmazonComponent = [slick_css_ngstyle_styles, slick_theme_css_ngstyle_styles];
var RenderType_AmazonComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AmazonComponent, data: {} });
function View_AmazonComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'spinner']], null, null, null, null, null))], null, null);
}
function View_AmazonComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { wizardComponent: 0 }), core_es5["ɵqud"](402653184, 2, { wizardFooterTemplate: 0 }),
        core_es5["ɵqud"](402653184, 3, { amazonPanel: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, [[3, 0], ['amazonPanel', 1]], null, 18, 'div', [['class', 'wrapper public-calc-v2 amazon']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'logo']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class',
                'logo-normal']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'logo-img text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['height',
                '24'], ['src', 'assets/logo.437b02847d771cc3f66f87a5dbeb3d66.png'], ['width',
                '140']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.showInfo;
        _ck(_v, 20, 0, currVal_0);
    }, null);
}
function View_AmazonComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'amazon', [], null, null, null, View_AmazonComponent_0, RenderType_AmazonComponent)),
        core_es5["ɵdid"](4308992, null, 0, amazon_component["a" /* AmazonComponent */], [core_es5["Renderer2"], amazon_service["a" /* AmazonService */],
            services_configService["a" /* ConfigService */], services_userService["a" /* UserService */], router_es5["n" /* Router */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AmazonComponentNgFactory = core_es5["ɵccf"]('amazon', amazon_component["a" /* AmazonComponent */], View_AmazonComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvYW1hem9uL2FtYXpvbi5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvYW1hem9uL2FtYXpvbi5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9hbWF6b24vYW1hem9uLWVtcHR5LXBhZ2UuY29tcG9uZW50Lmh0bWwiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9hbWF6b24vYW1hem9uLmNvbXBvbmVudC50cy5BbWF6b25Db21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCIgPGRpdiBjbGFzcz1cIndyYXBwZXIgcHVibGljLWNhbGMtdjIgYW1hem9uXCIgI2FtYXpvblBhbmVsPiA8ZGl2IGNsYXNzPVwiY29udGFpbmVyXCI+IDxkaXYgY2xhc3M9XCJsb2dvXCI+IDxkaXYgY2xhc3M9XCJsb2dvLW5vcm1hbFwiPiA8ZGl2IGNsYXNzPVwibG9nby1pbWcgdGV4dC1jZW50ZXJcIj4gPGltZyBoZWlnaHQ9XCIyNFwiIHNyYz1cImFzc2V0cy9sb2dvLjQzN2IwMjg0N2Q3NzFjYzNmNjZmODdhNWRiZWIzZDY2LnBuZ1wiIHdpZHRoPVwiMTQwXCI+IDwvZGl2PiA8L2Rpdj4gPC9kaXY+IDxkaXYgY2xhc3M9XCJzcGlubmVyXCIgKm5nSWY9XCIhc2hvd0luZm9cIj48L2Rpdj4gPC9kaXY+IDwvZGl2PiIsIjxhbWF6b24+PC9hbWF6b24+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0E0UTtNQUFBOzs7OzsyQ0FBNVEsc0NBQUM7aUJBQUE7Y0FBQTtNQUF3RCxzQ0FBQztVQUFBO1VBQUEsOEJBQXVCLHNDQUFDO2lCQUFBO2NBQUEsMERBQWtCO1VBQUEsUUFBQztVQUFBO1VBQUEsZ0JBQXlCLHNDQUFDO1VBQUE7VUFBQSwwREFBa0M7VUFBQSxRQUFDO1VBQUE7VUFBQTtNQUFvRixzQ0FBTztNQUFPLHNDQUFPO01BQUM7YUFBQTtVQUFBLHdCQUE2QyxzQ0FBTztVQUFBOztJQUEvQjtJQUFyQixZQUFxQixTQUFyQjs7OztvQkNBNVE7TUFBQTthQUFBO21EQUFBOztRQUFBOzs7OyJ9
//# sourceMappingURL=amazon.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/amazon/amazon-info/amazon-info.component.ts








var amazon_info_component_AmazonInfoComponent = /** @class */ (function () {
    function AmazonInfoComponent(route, userService, amazonService, renderer, router) {
        this.route = route;
        this.userService = userService;
        this.amazonService = amazonService;
        this.renderer = renderer;
        this.router = router;
        this.currentSeller = new amazon_seller["a" /* Seller */]();
        this.storeCredentials = new AmazonStoreCredentials_AmazonStoreCredentials();
        this.showStoreCredentials = false;
    }
    AmazonInfoComponent.prototype.ngOnInit = function () {
        this.body = document.getElementsByTagName('body')[0];
        if (window.navigator.userAgent.indexOf("Edge") > -1)
            return;
        this.body.classList.add("perfect-scrollbar-on");
        perfect_scrollbar["initialize"](this.amazonInfo.nativeElement);
    };
    AmazonInfoComponent.prototype.ngAfterViewInit = function () {
        var spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");
        if (window.navigator.userAgent.indexOf("Edge") > -1) {
            this.amazonInfo.nativeElement.style["height"] = 'auto';
            scrollHelper_ScrollHelper.forceSetVerticalScroll(this.body);
        }
    };
    AmazonInfoComponent.ctorParameters = function () { return [{ type: router_es5["a" /* ActivatedRoute */] }, { type: services_userService["a" /* UserService */] }, { type: amazon_service["a" /* AmazonService */] }, { type: core_es5["Renderer2"] }, { type: router_es5["n" /* Router */] }]; };
    return AmazonInfoComponent;
}());

//# sourceMappingURL=amazon-info.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/amazon/amazon-info/amazon-info.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */









var styles_AmazonInfoComponent = [];
var RenderType_AmazonInfoComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AmazonInfoComponent, data: {} });
function View_AmazonInfoComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { amazonInfo: 0 }), (_l()(), core_es5["ɵeld"](0, [[1, 0], ['amazonInfo',
                1]], null, 28, 'div', [['class', 'wrapper public-calc-v2 amazon'], ['id',
                'amazonInfo']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 19, 'div', [['class', 'logo navbar-inner'],
                ['id', 'navbar-top']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'logo-normal']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class',
                'logo-img text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['height', '24'], ['src', 'assets/logo.437b02847d771cc3f66f87a5dbeb3d66.png'],
            ['width', '140']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'ul', [['class', 'nav navbar-right pull-right']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](16777216, null, null, 3, 'li', [['dropdown',
                '']], [[2, 'dropup', null], [2, 'open', null], [2, 'show', null]], null, null, null, null)), core_es5["ɵprd"](512, null, bs_dropdown_state["a" /* BsDropdownState */], bs_dropdown_state["a" /* BsDropdownState */], []), core_es5["ɵdid"](212992, null, 0, bs_dropdown_directive["a" /* BsDropdownDirective */], [core_es5["ElementRef"], core_es5["Renderer"], core_es5["ViewContainerRef"],
            component_loader_factory["a" /* ComponentLoaderFactory */], bs_dropdown_config["a" /* BsDropdownConfig */], bs_dropdown_state["a" /* BsDropdownState */]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'li', [['class', 'separator hidden-lg hidden-md']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](16777216, null, null, 1, 'router-outlet', [], null, null, null, null, null)), core_es5["ɵdid"](212992, null, 0, router_es5["r" /* RouterOutlet */], [router_es5["b" /* ChildrenOutletContexts */], core_es5["ViewContainerRef"], core_es5["ComponentFactoryResolver"],
            [8, null], core_es5["ChangeDetectorRef"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        _ck(_v, 19, 0);
        _ck(_v, 27, 0);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 19).dropup;
        var currVal_1 = core_es5["ɵnov"](_v, 19).isOpen;
        var currVal_2 = (core_es5["ɵnov"](_v, 19).isOpen && core_es5["ɵnov"](_v, 19).isBs4);
        _ck(_v, 17, 0, currVal_0, currVal_1, currVal_2);
    });
}
function View_AmazonInfoComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'amazon-info', [], null, null, null, View_AmazonInfoComponent_0, RenderType_AmazonInfoComponent)), core_es5["ɵdid"](4308992, null, 0, amazon_info_component_AmazonInfoComponent, [router_es5["a" /* ActivatedRoute */], services_userService["a" /* UserService */], amazon_service["a" /* AmazonService */], core_es5["Renderer2"], router_es5["n" /* Router */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AmazonInfoComponentNgFactory = core_es5["ɵccf"]('amazon-info', amazon_info_component_AmazonInfoComponent, View_AmazonInfoComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvYW1hem9uL2FtYXpvbi1pbmZvL2FtYXpvbi1pbmZvLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9hbWF6b24vYW1hem9uLWluZm8vYW1hem9uLWluZm8uY29tcG9uZW50LnRzIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvYW1hem9uL2FtYXpvbi1pbmZvL2FtYXpvbi1pbmZvLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvYW1hem9uL2FtYXpvbi1pbmZvL2FtYXpvbi1pbmZvLmNvbXBvbmVudC50cy5BbWF6b25JbmZvQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cIndyYXBwZXIgcHVibGljLWNhbGMtdjIgYW1hem9uXCIgI2FtYXpvbkluZm8gaWQ9XCJhbWF6b25JbmZvXCI+IDxkaXYgY2xhc3M9XCJjb250YWluZXJcIj4gPGRpdiBjbGFzcz1cImxvZ28gbmF2YmFyLWlubmVyXCIgaWQ9XCJuYXZiYXItdG9wXCI+IDxkaXYgY2xhc3M9XCJsb2dvLW5vcm1hbFwiPiA8ZGl2IGNsYXNzPVwibG9nby1pbWcgdGV4dC1jZW50ZXJcIj4gPGltZyBoZWlnaHQ9XCIyNFwiIHNyYz1cImFzc2V0cy9sb2dvLjQzN2IwMjg0N2Q3NzFjYzNmNjZmODdhNWRiZWIzZDY2LnBuZ1wiIHdpZHRoPVwiMTQwXCI+IDwvZGl2PiA8L2Rpdj4gPHVsIGNsYXNzPVwibmF2IG5hdmJhci1yaWdodCBwdWxsLXJpZ2h0XCI+IDxsaSBkcm9wZG93bj4gPC9saT4gPGxpIGNsYXNzPVwic2VwYXJhdG9yIGhpZGRlbi1sZyBoaWRkZW4tbWRcIj48L2xpPiA8L3VsPiA8L2Rpdj4gPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PiA8L2Rpdj4gPC9kaXY+ICIsIjxhbWF6b24taW5mbz48L2FtYXpvbi1pbmZvPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozt3RENBQTtNQUFBO01BQUE7TUFBdUUsc0NBQUM7VUFBQTtVQUFBLDhCQUF1QixzQ0FBQztpQkFBQTtjQUFBO2NBQUEsZ0JBQStDLHNDQUFDO1VBQUE7VUFBQSwwREFBeUI7VUFBQSxRQUFDO1VBQUE7VUFBQSxnQkFBa0Msc0NBQUM7VUFBQTtjQUFBO1VBQUEsZ0JBQW9GLHNDQUFPO1VBQUEsUUFBTyxzQ0FBQztVQUFBO1VBQUEsMERBQXdDO1VBQUEsUUFBQztVQUFBO1VBQUE7Z0RBQUEsc0JBQUE7VUFBQTs4RUFBQTtVQUFBLGVBQWEsc0NBQU07VUFBQSxRQUFDO1VBQUE7TUFBK0Msc0NBQU07TUFBTyxzQ0FBQztVQUFBO1VBQUEsbURBQUE7VUFBQTtjQUFBO01BQStCLHNDQUFPO01BQU87SUFBOUg7SUFBaUY7O0lBQWpGO0lBQUE7SUFBQTtJQUFBLFlBQUEsNkJBQUE7Ozs7b0JDQXpWO01BQUE7b0NBQUEsVUFBQTtNQUFBO01BQUE7SUFBQTs7OzsifQ==
//# sourceMappingURL=amazon-info.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/amazon/seller-form/amazon-seller-form.component.ts




var amazon_seller_form_component_AmazonSellerFormComponent = /** @class */ (function () {
    function AmazonSellerFormComponent(route, userService, amazonService, renderer, router) {
        this.route = route;
        this.userService = userService;
        this.amazonService = amazonService;
        this.renderer = renderer;
        this.router = router;
    }
    AmazonSellerFormComponent.prototype.ngOnInit = function () {
    };
    AmazonSellerFormComponent.prototype.createSeller = function (valid) {
        if (!valid) {
            return;
        }
        this.amazonService.setCurrentSeller(this.amazonService.seller);
        this.router.navigate(["amazon/info/store"]);
    };
    AmazonSellerFormComponent.ctorParameters = function () { return [{ type: router_es5["a" /* ActivatedRoute */] }, { type: services_userService["a" /* UserService */] }, { type: amazon_service["a" /* AmazonService */] }, { type: core_es5["Renderer2"] }, { type: router_es5["n" /* Router */] }]; };
    return AmazonSellerFormComponent;
}());

//# sourceMappingURL=amazon-seller-form.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/amazon/seller-form/amazon-seller-form.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */











var styles_AmazonSellerFormComponent = [];
var RenderType_AmazonSellerFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AmazonSellerFormComponent, data: {} });
function View_AmazonSellerFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Company name is required']))], null, null);
}
function View_AmazonSellerFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Billing address is required']))], null, null);
}
function View_AmazonSellerFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Billing city is required']))], null, null);
}
function View_AmazonSellerFormComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Billing Province / State is required']))], null, null);
}
function View_AmazonSellerFormComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Billing Postal / Zip Code is required']))], null, null);
}
function View_AmazonSellerFormComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Billing Country is required']))], null, null);
}
function View_AmazonSellerFormComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Contact Name is required']))], null, null);
}
function View_AmazonSellerFormComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Phone Number is required']))], null, null);
}
function View_AmazonSellerFormComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Is not a countryCode']))], null, null);
}
function View_AmazonSellerFormComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Phone Number is incorrect ']))], null, null);
}
function View_AmazonSellerFormComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Job Title is required']))], null, null);
}
function View_AmazonSellerFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 157, 'div', [['class',
                'text-center page-container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Amazon seller'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 151, 'form', [['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngSubmit'], [null, 'submit'],
            [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 7).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 7).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.createSeller(core_es5["ɵnov"](_v, 7).valid) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['amazonForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 144, 'div', [['class', 'row margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 128, 'div', [['class',
                'col-sm-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 125, 'div', [['class', 'col-sm-6 col-md-6 col-sm-offset-3']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['class',
                'required'], ['name', 'sellerCompanyName'], ['placeholder', 'Please enter - Company name'],
            ['required', ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.amazonService.seller.CompanyName = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['sellerCompanyNameInput', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], form: [2, 'form'], placeholder: [3, 'placeholder'], isPlaceholderNeed: [4,
                'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AmazonSellerFormComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['class', 'required'], ['name',
                'sellerBillingAddress'], ['placeholder', 'Please enter - Billing address'],
            ['required', ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.amazonService.seller.BillingAddress = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['sellerBillingAddressInput', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], form: [2, 'form'], placeholder: [3, 'placeholder'],
            isPlaceholderNeed: [4, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AmazonSellerFormComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['class', 'required'], ['name',
                'sellerCity'], ['placeholder', 'Please enter - Billing city'], ['required',
                ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.amazonService.seller.City = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['sellerCityInput', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], form: [2, 'form'], placeholder: [3, 'placeholder'], isPlaceholderNeed: [4,
                'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AmazonSellerFormComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['class', 'required'], ['name',
                'sellerState'], ['placeholder', 'Please enter - Billing Province / State'],
            ['required', ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.amazonService.seller.State = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['sellerStateInput', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], form: [2, 'form'], placeholder: [3, 'placeholder'], isPlaceholderNeed: [4,
                'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AmazonSellerFormComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['class', 'required'], ['name',
                'sellerPostalCode'], ['placeholder', 'Please enter - Billing Postal / Zip Code'],
            ['required', ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.amazonService.seller.PostalCode = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['sellerPostalCodeInput', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], form: [2, 'form'], placeholder: [3, 'placeholder'], isPlaceholderNeed: [4,
                'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AmazonSellerFormComponent_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['class', 'required'], ['name',
                'sellerBillingCountry'], ['placeholder', 'Please enter - Some Billing Country'],
            ['required', ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.amazonService.seller.BillingCountry = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['sellerBillingCountryInput', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], form: [2, 'form'], placeholder: [3, 'placeholder'],
            isPlaceholderNeed: [4, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AmazonSellerFormComponent_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['class', 'required'], ['name',
                'sellerName'], ['placeholder', 'Please enter - Contact Name'], ['required',
                ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.amazonService.seller.ContactName = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['sellerContactNameInput', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], form: [2, 'form'], placeholder: [3, 'placeholder'], isPlaceholderNeed: [4,
                'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AmazonSellerFormComponent_7)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['class', 'required'], ['name',
                'sellerPhone'], ['placeholder', 'Please enter - Phone Number'], ['possiblePhone',
                'CA'], ['required', ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.amazonService.seller.Phone = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](81920, null, 0, phone_directive_PossiblePhoneValidatorDirective, [], { possiblePhone: [0, 'possiblePhone'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], phone_directive_PossiblePhoneValidatorDirective]), core_es5["ɵdid"](4308992, [['sellerPhoneInput', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2,
                forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], form: [2, 'form'],
            placeholder: [3, 'placeholder'], isPlaceholderNeed: [4, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, 0, 1, null, View_AmazonSellerFormComponent_8)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AmazonSellerFormComponent_9)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AmazonSellerFormComponent_10)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['class', 'required'], ['name',
                'sellerJobTitle'], ['placeholder', 'Please enter - Job Title'], ['required',
                ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.amazonService.seller.JobTitle = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['sellerJobTitleInput', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], form: [2, 'form'], placeholder: [3, 'placeholder'], isPlaceholderNeed: [4,
                'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AmazonSellerFormComponent_11)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'btn-container nextButton']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'button', [['class', 'btn btn-round btn-wide bold text-uppercase btn-balck-white continue'],
            ['type', 'submit']], [[8, 'disabled', 0]], null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"],
            core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class',
                'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['trending_flat'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_15 = '';
        _ck(_v, 18, 0, currVal_15);
        var currVal_16 = 'text';
        var currVal_17 = 'sellerCompanyName';
        var currVal_18 = core_es5["ɵnov"](_v, 7);
        var currVal_19 = 'Please enter - Company name';
        var currVal_20 = true;
        _ck(_v, 20, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20);
        var currVal_21 = 'sellerCompanyName';
        var currVal_22 = _co.amazonService.seller.CompanyName;
        _ck(_v, 22, 0, currVal_21, currVal_22);
        var currVal_23 = (core_es5["ɵnov"](_v, 20).model.hasError('required') && (!core_es5["ɵnov"](_v, 20).model.pristine || core_es5["ɵnov"](_v, 7).submitted));
        _ck(_v, 27, 0, currVal_23);
        var currVal_32 = '';
        _ck(_v, 31, 0, currVal_32);
        var currVal_33 = 'text';
        var currVal_34 = 'sellerBillingAddress';
        var currVal_35 = core_es5["ɵnov"](_v, 7);
        var currVal_36 = 'Please enter - Billing address';
        var currVal_37 = true;
        _ck(_v, 33, 0, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37);
        var currVal_38 = 'sellerBillingAddress';
        var currVal_39 = _co.amazonService.seller.BillingAddress;
        _ck(_v, 35, 0, currVal_38, currVal_39);
        var currVal_40 = (core_es5["ɵnov"](_v, 33).model.hasError('required') && (!core_es5["ɵnov"](_v, 33).model.pristine || core_es5["ɵnov"](_v, 7).submitted));
        _ck(_v, 40, 0, currVal_40);
        var currVal_49 = '';
        _ck(_v, 44, 0, currVal_49);
        var currVal_50 = 'text';
        var currVal_51 = 'sellerCity';
        var currVal_52 = core_es5["ɵnov"](_v, 7);
        var currVal_53 = 'Please enter - Billing city';
        var currVal_54 = true;
        _ck(_v, 46, 0, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54);
        var currVal_55 = 'sellerCity';
        var currVal_56 = _co.amazonService.seller.City;
        _ck(_v, 48, 0, currVal_55, currVal_56);
        var currVal_57 = (core_es5["ɵnov"](_v, 46).model.hasError('required') && (!core_es5["ɵnov"](_v, 46).model.pristine || core_es5["ɵnov"](_v, 7).submitted));
        _ck(_v, 53, 0, currVal_57);
        var currVal_66 = '';
        _ck(_v, 57, 0, currVal_66);
        var currVal_67 = 'text';
        var currVal_68 = 'sellerState';
        var currVal_69 = core_es5["ɵnov"](_v, 7);
        var currVal_70 = 'Please enter - Billing Province / State';
        var currVal_71 = true;
        _ck(_v, 59, 0, currVal_67, currVal_68, currVal_69, currVal_70, currVal_71);
        var currVal_72 = 'sellerState';
        var currVal_73 = _co.amazonService.seller.State;
        _ck(_v, 61, 0, currVal_72, currVal_73);
        var currVal_74 = (core_es5["ɵnov"](_v, 59).model.hasError('required') && (!core_es5["ɵnov"](_v, 59).model.pristine || core_es5["ɵnov"](_v, 7).submitted));
        _ck(_v, 66, 0, currVal_74);
        var currVal_83 = '';
        _ck(_v, 70, 0, currVal_83);
        var currVal_84 = 'text';
        var currVal_85 = 'sellerPostalCode';
        var currVal_86 = core_es5["ɵnov"](_v, 7);
        var currVal_87 = 'Please enter - Billing Postal / Zip Code';
        var currVal_88 = true;
        _ck(_v, 72, 0, currVal_84, currVal_85, currVal_86, currVal_87, currVal_88);
        var currVal_89 = 'sellerPostalCode';
        var currVal_90 = _co.amazonService.seller.PostalCode;
        _ck(_v, 74, 0, currVal_89, currVal_90);
        var currVal_91 = (core_es5["ɵnov"](_v, 72).model.hasError('required') && (!core_es5["ɵnov"](_v, 72).model.pristine || core_es5["ɵnov"](_v, 7).submitted));
        _ck(_v, 79, 0, currVal_91);
        var currVal_100 = '';
        _ck(_v, 83, 0, currVal_100);
        var currVal_101 = 'text';
        var currVal_102 = 'sellerBillingCountry';
        var currVal_103 = core_es5["ɵnov"](_v, 7);
        var currVal_104 = 'Please enter - Some Billing Country';
        var currVal_105 = true;
        _ck(_v, 85, 0, currVal_101, currVal_102, currVal_103, currVal_104, currVal_105);
        var currVal_106 = 'sellerBillingCountry';
        var currVal_107 = _co.amazonService.seller.BillingCountry;
        _ck(_v, 87, 0, currVal_106, currVal_107);
        var currVal_108 = (core_es5["ɵnov"](_v, 85).model.hasError('required') && (!core_es5["ɵnov"](_v, 85).model.pristine || core_es5["ɵnov"](_v, 7).submitted));
        _ck(_v, 92, 0, currVal_108);
        var currVal_117 = '';
        _ck(_v, 96, 0, currVal_117);
        var currVal_118 = 'text';
        var currVal_119 = 'sellerName';
        var currVal_120 = core_es5["ɵnov"](_v, 7);
        var currVal_121 = 'Please enter - Contact Name';
        var currVal_122 = true;
        _ck(_v, 98, 0, currVal_118, currVal_119, currVal_120, currVal_121, currVal_122);
        var currVal_123 = 'sellerName';
        var currVal_124 = _co.amazonService.seller.ContactName;
        _ck(_v, 100, 0, currVal_123, currVal_124);
        var currVal_125 = (core_es5["ɵnov"](_v, 98).model.hasError('required') && (!core_es5["ɵnov"](_v, 98).model.pristine || core_es5["ɵnov"](_v, 7).submitted));
        _ck(_v, 105, 0, currVal_125);
        var currVal_134 = '';
        _ck(_v, 109, 0, currVal_134);
        var currVal_135 = 'CA';
        _ck(_v, 110, 0, currVal_135);
        var currVal_136 = 'text';
        var currVal_137 = 'sellerPhone';
        var currVal_138 = core_es5["ɵnov"](_v, 7);
        var currVal_139 = 'Please enter - Phone Number';
        var currVal_140 = true;
        _ck(_v, 112, 0, currVal_136, currVal_137, currVal_138, currVal_139, currVal_140);
        var currVal_141 = 'sellerPhone';
        var currVal_142 = _co.amazonService.seller.Phone;
        _ck(_v, 114, 0, currVal_141, currVal_142);
        var currVal_143 = (core_es5["ɵnov"](_v, 112).model.hasError('required') && (!core_es5["ɵnov"](_v, 112).model.pristine || core_es5["ɵnov"](_v, 7).submitted));
        _ck(_v, 119, 0, currVal_143);
        var currVal_144 = core_es5["ɵnov"](_v, 112).model.hasError('noValidRegionCode');
        _ck(_v, 122, 0, currVal_144);
        var currVal_145 = ((core_es5["ɵnov"](_v, 112).model.hasError('noPhoneNumber') || core_es5["ɵnov"](_v, 112).model.hasError('phoneNumberTooLong')) || core_es5["ɵnov"](_v, 112).model.hasError('phoneNumberTooShort'));
        _ck(_v, 125, 0, currVal_145);
        var currVal_154 = '';
        _ck(_v, 129, 0, currVal_154);
        var currVal_155 = 'text';
        var currVal_156 = 'sellerJobTitle';
        var currVal_157 = core_es5["ɵnov"](_v, 7);
        var currVal_158 = 'Please enter - Job Title';
        var currVal_159 = true;
        _ck(_v, 131, 0, currVal_155, currVal_156, currVal_157, currVal_158, currVal_159);
        var currVal_160 = 'sellerJobTitle';
        var currVal_161 = _co.amazonService.seller.JobTitle;
        _ck(_v, 133, 0, currVal_160, currVal_161);
        var currVal_162 = (core_es5["ɵnov"](_v, 131).model.hasError('required') && (!core_es5["ɵnov"](_v, 131).model.pristine || core_es5["ɵnov"](_v, 7).submitted));
        _ck(_v, 138, 0, currVal_162);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵnov"](_v, 9).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 9).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 9).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 9).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 9).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 9).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 9).ngClassPending;
        _ck(_v, 5, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (core_es5["ɵnov"](_v, 18).required ? '' : null);
        var currVal_8 = core_es5["ɵnov"](_v, 24).ngClassUntouched;
        var currVal_9 = core_es5["ɵnov"](_v, 24).ngClassTouched;
        var currVal_10 = core_es5["ɵnov"](_v, 24).ngClassPristine;
        var currVal_11 = core_es5["ɵnov"](_v, 24).ngClassDirty;
        var currVal_12 = core_es5["ɵnov"](_v, 24).ngClassValid;
        var currVal_13 = core_es5["ɵnov"](_v, 24).ngClassInvalid;
        var currVal_14 = core_es5["ɵnov"](_v, 24).ngClassPending;
        _ck(_v, 17, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_24 = (core_es5["ɵnov"](_v, 31).required ? '' : null);
        var currVal_25 = core_es5["ɵnov"](_v, 37).ngClassUntouched;
        var currVal_26 = core_es5["ɵnov"](_v, 37).ngClassTouched;
        var currVal_27 = core_es5["ɵnov"](_v, 37).ngClassPristine;
        var currVal_28 = core_es5["ɵnov"](_v, 37).ngClassDirty;
        var currVal_29 = core_es5["ɵnov"](_v, 37).ngClassValid;
        var currVal_30 = core_es5["ɵnov"](_v, 37).ngClassInvalid;
        var currVal_31 = core_es5["ɵnov"](_v, 37).ngClassPending;
        _ck(_v, 30, 0, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31);
        var currVal_41 = (core_es5["ɵnov"](_v, 44).required ? '' : null);
        var currVal_42 = core_es5["ɵnov"](_v, 50).ngClassUntouched;
        var currVal_43 = core_es5["ɵnov"](_v, 50).ngClassTouched;
        var currVal_44 = core_es5["ɵnov"](_v, 50).ngClassPristine;
        var currVal_45 = core_es5["ɵnov"](_v, 50).ngClassDirty;
        var currVal_46 = core_es5["ɵnov"](_v, 50).ngClassValid;
        var currVal_47 = core_es5["ɵnov"](_v, 50).ngClassInvalid;
        var currVal_48 = core_es5["ɵnov"](_v, 50).ngClassPending;
        _ck(_v, 43, 0, currVal_41, currVal_42, currVal_43, currVal_44, currVal_45, currVal_46, currVal_47, currVal_48);
        var currVal_58 = (core_es5["ɵnov"](_v, 57).required ? '' : null);
        var currVal_59 = core_es5["ɵnov"](_v, 63).ngClassUntouched;
        var currVal_60 = core_es5["ɵnov"](_v, 63).ngClassTouched;
        var currVal_61 = core_es5["ɵnov"](_v, 63).ngClassPristine;
        var currVal_62 = core_es5["ɵnov"](_v, 63).ngClassDirty;
        var currVal_63 = core_es5["ɵnov"](_v, 63).ngClassValid;
        var currVal_64 = core_es5["ɵnov"](_v, 63).ngClassInvalid;
        var currVal_65 = core_es5["ɵnov"](_v, 63).ngClassPending;
        _ck(_v, 56, 0, currVal_58, currVal_59, currVal_60, currVal_61, currVal_62, currVal_63, currVal_64, currVal_65);
        var currVal_75 = (core_es5["ɵnov"](_v, 70).required ? '' : null);
        var currVal_76 = core_es5["ɵnov"](_v, 76).ngClassUntouched;
        var currVal_77 = core_es5["ɵnov"](_v, 76).ngClassTouched;
        var currVal_78 = core_es5["ɵnov"](_v, 76).ngClassPristine;
        var currVal_79 = core_es5["ɵnov"](_v, 76).ngClassDirty;
        var currVal_80 = core_es5["ɵnov"](_v, 76).ngClassValid;
        var currVal_81 = core_es5["ɵnov"](_v, 76).ngClassInvalid;
        var currVal_82 = core_es5["ɵnov"](_v, 76).ngClassPending;
        _ck(_v, 69, 0, currVal_75, currVal_76, currVal_77, currVal_78, currVal_79, currVal_80, currVal_81, currVal_82);
        var currVal_92 = (core_es5["ɵnov"](_v, 83).required ? '' : null);
        var currVal_93 = core_es5["ɵnov"](_v, 89).ngClassUntouched;
        var currVal_94 = core_es5["ɵnov"](_v, 89).ngClassTouched;
        var currVal_95 = core_es5["ɵnov"](_v, 89).ngClassPristine;
        var currVal_96 = core_es5["ɵnov"](_v, 89).ngClassDirty;
        var currVal_97 = core_es5["ɵnov"](_v, 89).ngClassValid;
        var currVal_98 = core_es5["ɵnov"](_v, 89).ngClassInvalid;
        var currVal_99 = core_es5["ɵnov"](_v, 89).ngClassPending;
        _ck(_v, 82, 0, currVal_92, currVal_93, currVal_94, currVal_95, currVal_96, currVal_97, currVal_98, currVal_99);
        var currVal_109 = (core_es5["ɵnov"](_v, 96).required ? '' : null);
        var currVal_110 = core_es5["ɵnov"](_v, 102).ngClassUntouched;
        var currVal_111 = core_es5["ɵnov"](_v, 102).ngClassTouched;
        var currVal_112 = core_es5["ɵnov"](_v, 102).ngClassPristine;
        var currVal_113 = core_es5["ɵnov"](_v, 102).ngClassDirty;
        var currVal_114 = core_es5["ɵnov"](_v, 102).ngClassValid;
        var currVal_115 = core_es5["ɵnov"](_v, 102).ngClassInvalid;
        var currVal_116 = core_es5["ɵnov"](_v, 102).ngClassPending;
        _ck(_v, 95, 0, currVal_109, currVal_110, currVal_111, currVal_112, currVal_113, currVal_114, currVal_115, currVal_116);
        var currVal_126 = (core_es5["ɵnov"](_v, 109).required ? '' : null);
        var currVal_127 = core_es5["ɵnov"](_v, 116).ngClassUntouched;
        var currVal_128 = core_es5["ɵnov"](_v, 116).ngClassTouched;
        var currVal_129 = core_es5["ɵnov"](_v, 116).ngClassPristine;
        var currVal_130 = core_es5["ɵnov"](_v, 116).ngClassDirty;
        var currVal_131 = core_es5["ɵnov"](_v, 116).ngClassValid;
        var currVal_132 = core_es5["ɵnov"](_v, 116).ngClassInvalid;
        var currVal_133 = core_es5["ɵnov"](_v, 116).ngClassPending;
        _ck(_v, 108, 0, currVal_126, currVal_127, currVal_128, currVal_129, currVal_130, currVal_131, currVal_132, currVal_133);
        var currVal_146 = (core_es5["ɵnov"](_v, 129).required ? '' : null);
        var currVal_147 = core_es5["ɵnov"](_v, 135).ngClassUntouched;
        var currVal_148 = core_es5["ɵnov"](_v, 135).ngClassTouched;
        var currVal_149 = core_es5["ɵnov"](_v, 135).ngClassPristine;
        var currVal_150 = core_es5["ɵnov"](_v, 135).ngClassDirty;
        var currVal_151 = core_es5["ɵnov"](_v, 135).ngClassValid;
        var currVal_152 = core_es5["ɵnov"](_v, 135).ngClassInvalid;
        var currVal_153 = core_es5["ɵnov"](_v, 135).ngClassPending;
        _ck(_v, 128, 0, currVal_146, currVal_147, currVal_148, currVal_149, currVal_150, currVal_151, currVal_152, currVal_153);
        var currVal_163 = (core_es5["ɵnov"](_v, 7).submitted && !core_es5["ɵnov"](_v, 7).valid);
        _ck(_v, 147, 0, currVal_163);
        var currVal_164 = (((_co.amazonService.seller.Id && (_co.amazonService.seller.Stores.length != 0)) && _co.amazonService.seller.Stores[0].StoreName) ? 'Update' : 'Add amazon store');
        _ck(_v, 149, 0, currVal_164);
    });
}
function View_AmazonSellerFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'amazon-seller-form', [], null, null, null, View_AmazonSellerFormComponent_0, RenderType_AmazonSellerFormComponent)), core_es5["ɵdid"](114688, null, 0, amazon_seller_form_component_AmazonSellerFormComponent, [router_es5["a" /* ActivatedRoute */], services_userService["a" /* UserService */], amazon_service["a" /* AmazonService */], core_es5["Renderer2"], router_es5["n" /* Router */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AmazonSellerFormComponentNgFactory = core_es5["ɵccf"]('amazon-seller-form', amazon_seller_form_component_AmazonSellerFormComponent, View_AmazonSellerFormComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=amazon-seller-form.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/amazon/store-credentials/amazon-credentials.component.ts




var amazon_credentials_component_AmazonCredentialsComponent = /** @class */ (function () {
    function AmazonCredentialsComponent(renderer, amazonService, router) {
        this.renderer = renderer;
        this.amazonService = amazonService;
        this.router = router;
        this.storeCredentials = new AmazonStoreCredentials_AmazonStoreCredentials();
        this.isProcessing = false;
        this.idToBlur = "amazon-credentials";
        this.title = "Store Credentials";
        this.hasCredentialsError = false;
        this.errorString = '';
        this.credentialsErrorType = CredentialsErrorType;
    }
    AmazonCredentialsComponent.prototype.ngOnInit = function () {
        if (this.amazonService.seller.Stores && this.amazonService.seller.Stores.length > 0) {
            this.storeCredentials = this.amazonService.seller.Stores[0];
        }
        var el = document.querySelector("#amazonInfo");
        if (el) {
            el.scrollTop = 0;
        }
    };
    AmazonCredentialsComponent.prototype.createStore = function (valid) {
        var _this = this;
        if (!valid)
            return;
        this.amazonService.seller.Stores[0] = this.storeCredentials;
        this.amazonService.setCurrentSeller(this.amazonService.seller).then(function (resp) {
            _this.exportStoreProducts();
        }).catch(function (err) {
            _this.isProcessing = false;
        });
    };
    AmazonCredentialsComponent.prototype.goToStore = function () {
        var store = this.amazonService.seller.Stores[0];
        this.router.navigate(["amazon/info/" + this.amazonService.seller.Id + "/store/" + store.Id + "/products"]);
    };
    AmazonCredentialsComponent.prototype.exportStoreProducts = function () {
        var _this = this;
        this.isProcessing = true;
        this.title = this.amazonService.seller.Stores[0].StoreName;
        this.amazonService.exportAndSaveProducts(this.amazonService.seller.Id, this.amazonService.seller.Stores[0].Id).then(function (resp) {
            _this.isProcessing = false;
            // if (this.amazonService.seller.PoaNumber == SellerStatus.NotStarted && !hasSignModalShown) {
            //     this.signForm.show();
            //     return;
            // }
            _this.goToStore();
        }).catch(function (err) {
            _this.isProcessing = false;
            _this.hasCredentialsError = true;
            if (err.Errors && err.Errors.length > 0 && err.Errors[0].Value && err.Errors[0].Value.length > 0)
                _this.errorString = err.Errors[0].Value[0];
            else
                return;
            // let errorArray = this.errorString.split(' ');
            if (_this.errorString.includes('Marketplace'))
                _this.credentialsError = CredentialsErrorType.Marketplace;
            if (_this.errorString.includes('seller'))
                _this.credentialsError = CredentialsErrorType.SellerID;
            if (_this.errorString.includes('MWS'))
                _this.credentialsError = CredentialsErrorType.MWSAuthToken;
            // Request is throttled
            if (_this.errorString.includes('throttled')) {
                _this.credentialsError = CredentialsErrorType.Throttled;
                _this.errorString = 'Something went wrong, please wait for a few seconds and try again';
            }
        });
    };
    AmazonCredentialsComponent.prototype.userNavigate = function (routing) {
        this.amazonService.setPrevUrl(this.router.url);
        this.router.navigate([routing]);
    };
    AmazonCredentialsComponent.ctorParameters = function () { return [{ type: core_es5["Renderer2"] }, { type: amazon_service["a" /* AmazonService */] }, { type: router_es5["n" /* Router */] }]; };
    return AmazonCredentialsComponent;
}());

var CredentialsErrorType;
(function (CredentialsErrorType) {
    CredentialsErrorType[CredentialsErrorType["Marketplace"] = 0] = "Marketplace";
    CredentialsErrorType[CredentialsErrorType["SellerID"] = 1] = "SellerID";
    CredentialsErrorType[CredentialsErrorType["MWSAuthToken"] = 2] = "MWSAuthToken";
    CredentialsErrorType[CredentialsErrorType["Throttled"] = 3] = "Throttled";
})(CredentialsErrorType || (CredentialsErrorType = {}));
//# sourceMappingURL=amazon-credentials.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/amazon/store-credentials/amazon-credentials.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */









var styles_AmazonCredentialsComponent = [];
var RenderType_AmazonCredentialsComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AmazonCredentialsComponent, data: {} });
function View_AmazonCredentialsComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Store Name is required']))], null, null);
}
function View_AmazonCredentialsComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Seller ID is required']))], null, null);
}
function View_AmazonCredentialsComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Marketplace id is required']))], null, null);
}
function View_AmazonCredentialsComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['MWS Auth token is required']))], null, null);
}
function View_AmazonCredentialsComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' ', ' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.errorString;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_AmazonCredentialsComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' Something went wrong, please, check your credentials ']))], null, null);
}
function View_AmazonCredentialsComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, 'span', [['class',
                'margin-bottom-30 display-block help-block']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonCredentialsComponent_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonCredentialsComponent_8)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.errorString;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = !_co.errorString;
        _ck(_v, 6, 0, currVal_1);
    }, null);
}
function View_AmazonCredentialsComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 91, 'form', [['novalidate',
                '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null], [2,
                'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngSubmit'], [null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 2).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 2).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.createStore(core_es5["ɵnov"](_v, 2).valid) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['amazonStoreForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 84, 'div', [['class', 'row margin-bottom-30 margin-top-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 62, 'div', [['class',
                'col-sm-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 59, 'div', [['class', 'col-sm-6 col-md-6 col-sm-offset-3']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['class',
                'required'], ['name', 'storesStoreName'], ['placeholder', 'Store Name'], ['required',
                ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.storeCredentials.StoreName = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['sellerStoreCredentialsStoreName',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], form: [2, 'form'], placeholder: [3, 'placeholder'],
            isPlaceholderNeed: [4, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AmazonCredentialsComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'form-input', [['class', 'required'], ['name',
                'storesSellerID'], ['placeholder', 'Seller ID'], ['required', ''], ['type',
                'text']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.storeCredentials.SellerId = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_1 = ((_co.hasCredentialsError = false) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'has-error': 0 }), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['sellerStoreCredentialsSellerId',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], form: [2, 'form'], placeholder: [3, 'placeholder'],
            isPlaceholderNeed: [4, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AmazonCredentialsComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'form-input', [['class', 'required'], ['name',
                'storesMarketplaceId'], ['placeholder', 'Marketplace id'], ['required',
                ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.storeCredentials.MarketplaceId = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_1 = ((_co.hasCredentialsError = false) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'has-error': 0 }), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['sellerStoreCredentialsMarketplaceId',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], form: [2, 'form'], placeholder: [3, 'placeholder'],
            isPlaceholderNeed: [4, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AmazonCredentialsComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'form-input', [['class', 'required'], ['name',
                'storesMwsAuthToken'], ['placeholder', 'MWS Auth Token'], ['required', ''],
            ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.storeCredentials.MwsAuthToken = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_1 = ((_co.hasCredentialsError = false) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'has-error': 0 }), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['sellerStoreCredentialsMwsAuthToken',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], form: [2, 'form'], placeholder: [3, 'placeholder'],
            isPlaceholderNeed: [4, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AmazonCredentialsComponent_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['class', 'text-white cursor-pointer text-underline display-inline-block margin-bottom-10']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.userNavigate('amazon/info/instructions') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['Where do I get these credentials?'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'btn-container nextButton']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'button', [['class', 'btn btn-round btn-wide bold text-uppercase btn-balck-white continue margin-bottom-20'],
            ['type', 'submit']], [[8, 'disabled', 0]], null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"],
            core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Continue '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class',
                'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['trending_flat'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonCredentialsComponent_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_15 = '';
        _ck(_v, 13, 0, currVal_15);
        var currVal_16 = 'text';
        var currVal_17 = 'storesStoreName';
        var currVal_18 = core_es5["ɵnov"](_v, 2);
        var currVal_19 = 'Store Name';
        var currVal_20 = true;
        _ck(_v, 15, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20);
        var currVal_21 = 'storesStoreName';
        var currVal_22 = _co.storeCredentials.StoreName;
        _ck(_v, 17, 0, currVal_21, currVal_22);
        var currVal_23 = (core_es5["ɵnov"](_v, 15).model.hasError('required') && !core_es5["ɵnov"](_v, 15).model.pristine);
        _ck(_v, 22, 0, currVal_23);
        var currVal_32 = 'required';
        var currVal_33 = _ck(_v, 27, 0, (_co.credentialsError == _co.credentialsErrorType.SellerID));
        _ck(_v, 26, 0, currVal_32, currVal_33);
        var currVal_34 = '';
        _ck(_v, 28, 0, currVal_34);
        var currVal_35 = 'text';
        var currVal_36 = 'storesSellerID';
        var currVal_37 = core_es5["ɵnov"](_v, 2);
        var currVal_38 = 'Seller ID';
        var currVal_39 = true;
        _ck(_v, 30, 0, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39);
        var currVal_40 = 'storesSellerID';
        var currVal_41 = _co.storeCredentials.SellerId;
        _ck(_v, 32, 0, currVal_40, currVal_41);
        var currVal_42 = (core_es5["ɵnov"](_v, 30).model.hasError('required') && !core_es5["ɵnov"](_v, 30).model.pristine);
        _ck(_v, 37, 0, currVal_42);
        var currVal_51 = 'required';
        var currVal_52 = _ck(_v, 42, 0, (_co.credentialsError == _co.credentialsErrorType.Marketplace));
        _ck(_v, 41, 0, currVal_51, currVal_52);
        var currVal_53 = '';
        _ck(_v, 43, 0, currVal_53);
        var currVal_54 = 'text';
        var currVal_55 = 'storesMarketplaceId';
        var currVal_56 = core_es5["ɵnov"](_v, 2);
        var currVal_57 = 'Marketplace id';
        var currVal_58 = true;
        _ck(_v, 45, 0, currVal_54, currVal_55, currVal_56, currVal_57, currVal_58);
        var currVal_59 = 'storesMarketplaceId';
        var currVal_60 = _co.storeCredentials.MarketplaceId;
        _ck(_v, 47, 0, currVal_59, currVal_60);
        var currVal_61 = (core_es5["ɵnov"](_v, 45).model.hasError('required') && !core_es5["ɵnov"](_v, 45).model.pristine);
        _ck(_v, 52, 0, currVal_61);
        var currVal_70 = 'required';
        var currVal_71 = _ck(_v, 57, 0, (_co.credentialsError == _co.credentialsErrorType.MWSAuthToken));
        _ck(_v, 56, 0, currVal_70, currVal_71);
        var currVal_72 = '';
        _ck(_v, 58, 0, currVal_72);
        var currVal_73 = 'text';
        var currVal_74 = 'storesMwsAuthToken';
        var currVal_75 = core_es5["ɵnov"](_v, 2);
        var currVal_76 = 'MWS Auth Token';
        var currVal_77 = true;
        _ck(_v, 60, 0, currVal_73, currVal_74, currVal_75, currVal_76, currVal_77);
        var currVal_78 = 'storesMwsAuthToken';
        var currVal_79 = _co.storeCredentials.MwsAuthToken;
        _ck(_v, 62, 0, currVal_78, currVal_79);
        var currVal_80 = (core_es5["ɵnov"](_v, 60).model.hasError('required') && !core_es5["ɵnov"](_v, 60).model.pristine);
        _ck(_v, 67, 0, currVal_80);
        var currVal_82 = (_co.hasCredentialsError == true);
        _ck(_v, 87, 0, currVal_82);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵnov"](_v, 4).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 4).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 4).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 4).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 4).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 4).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 4).ngClassPending;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (core_es5["ɵnov"](_v, 13).required ? '' : null);
        var currVal_8 = core_es5["ɵnov"](_v, 19).ngClassUntouched;
        var currVal_9 = core_es5["ɵnov"](_v, 19).ngClassTouched;
        var currVal_10 = core_es5["ɵnov"](_v, 19).ngClassPristine;
        var currVal_11 = core_es5["ɵnov"](_v, 19).ngClassDirty;
        var currVal_12 = core_es5["ɵnov"](_v, 19).ngClassValid;
        var currVal_13 = core_es5["ɵnov"](_v, 19).ngClassInvalid;
        var currVal_14 = core_es5["ɵnov"](_v, 19).ngClassPending;
        _ck(_v, 12, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_24 = (core_es5["ɵnov"](_v, 28).required ? '' : null);
        var currVal_25 = core_es5["ɵnov"](_v, 34).ngClassUntouched;
        var currVal_26 = core_es5["ɵnov"](_v, 34).ngClassTouched;
        var currVal_27 = core_es5["ɵnov"](_v, 34).ngClassPristine;
        var currVal_28 = core_es5["ɵnov"](_v, 34).ngClassDirty;
        var currVal_29 = core_es5["ɵnov"](_v, 34).ngClassValid;
        var currVal_30 = core_es5["ɵnov"](_v, 34).ngClassInvalid;
        var currVal_31 = core_es5["ɵnov"](_v, 34).ngClassPending;
        _ck(_v, 25, 0, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31);
        var currVal_43 = (core_es5["ɵnov"](_v, 43).required ? '' : null);
        var currVal_44 = core_es5["ɵnov"](_v, 49).ngClassUntouched;
        var currVal_45 = core_es5["ɵnov"](_v, 49).ngClassTouched;
        var currVal_46 = core_es5["ɵnov"](_v, 49).ngClassPristine;
        var currVal_47 = core_es5["ɵnov"](_v, 49).ngClassDirty;
        var currVal_48 = core_es5["ɵnov"](_v, 49).ngClassValid;
        var currVal_49 = core_es5["ɵnov"](_v, 49).ngClassInvalid;
        var currVal_50 = core_es5["ɵnov"](_v, 49).ngClassPending;
        _ck(_v, 40, 0, currVal_43, currVal_44, currVal_45, currVal_46, currVal_47, currVal_48, currVal_49, currVal_50);
        var currVal_62 = (core_es5["ɵnov"](_v, 58).required ? '' : null);
        var currVal_63 = core_es5["ɵnov"](_v, 64).ngClassUntouched;
        var currVal_64 = core_es5["ɵnov"](_v, 64).ngClassTouched;
        var currVal_65 = core_es5["ɵnov"](_v, 64).ngClassPristine;
        var currVal_66 = core_es5["ɵnov"](_v, 64).ngClassDirty;
        var currVal_67 = core_es5["ɵnov"](_v, 64).ngClassValid;
        var currVal_68 = core_es5["ɵnov"](_v, 64).ngClassInvalid;
        var currVal_69 = core_es5["ɵnov"](_v, 64).ngClassPending;
        _ck(_v, 55, 0, currVal_62, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67, currVal_68, currVal_69);
        var currVal_81 = ((core_es5["ɵnov"](_v, 2).submitted && !core_es5["ɵnov"](_v, 2).valid) || ((_co.hasCredentialsError == true) && !(_co.credentialsError == _co.credentialsErrorType.Throttled)));
        _ck(_v, 79, 0, currVal_81);
    });
}
function View_AmazonCredentialsComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' Please wait, we are validating your credentials and exporting products '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'loader']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_AmazonCredentialsComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { signForm: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'text-center page-container']], [[1, 'id', 0]], null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'title panel-heading']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonCredentialsComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonCredentialsComponent_9)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = !_co.isProcessing;
        _ck(_v, 8, 0, currVal_2);
        var currVal_3 = _co.isProcessing;
        _ck(_v, 11, 0, currVal_3);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.idToBlur;
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = _co.title;
        _ck(_v, 5, 0, currVal_1);
    });
}
function View_AmazonCredentialsComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'amazon-credentials', [], null, null, null, View_AmazonCredentialsComponent_0, RenderType_AmazonCredentialsComponent)), core_es5["ɵdid"](114688, null, 0, amazon_credentials_component_AmazonCredentialsComponent, [core_es5["Renderer2"], amazon_service["a" /* AmazonService */], router_es5["n" /* Router */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AmazonCredentialsComponentNgFactory = core_es5["ɵccf"]('amazon-credentials', amazon_credentials_component_AmazonCredentialsComponent, View_AmazonCredentialsComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=amazon-credentials.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/hellosign-embedded/index.js
var hellosign_embedded = __webpack_require__("7A4S");
var hellosign_embedded_default = /*#__PURE__*/__webpack_require__.n(hellosign_embedded);

// CONCATENATED MODULE: ./app/components/amazon/sign/amazon-sign-form-modal.component.ts







var amazon_sign_form_modal_component_AmazonSignFormComponent = /** @class */ (function () {
    function AmazonSignFormComponent(router, amazonService) {
        this.router = router;
        this.amazonService = amazonService;
        this.signEventEmitter = new core_es5["EventEmitter"]();
    }
    AmazonSignFormComponent.prototype.show = function () {
        this.signModal.show();
        blurUtil["a" /* BlurUtil */].blurMenu(this.idToBlur);
    };
    AmazonSignFormComponent.prototype.ngOnInit = function () {
    };
    AmazonSignFormComponent.prototype.onModalHidden = function () {
        blurUtil["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
    };
    AmazonSignFormComponent.prototype.emitEvent = function () {
        this.signEventEmitter.emit(true);
        blurUtil["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
    };
    AmazonSignFormComponent.prototype.goToSign = function () {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            var _this = this;
            return tslib_es6["d" /* __generator */](this, function (_a) {
                this.amazonService.getHelloSignUrl(this.amazonService.seller).then(function (resp) {
                    if (!resp)
                        return;
                    var signURL = resp.Data.signUrl.toString();
                    var clientId = resp.Data.clientId.toString();
                    _this.signModal.hide();
                    _this.goToHelloSign(signURL, clientId).then(function (r) {
                        _this.amazonService.setCurrentSeller(_this.amazonService.seller).then(function (resp) {
                            blurUtil["a" /* BlurUtil */].unBlurMenu(_this.idToBlur);
                            _this.signEventEmitter.emit(true);
                        });
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    AmazonSignFormComponent.prototype.goToHelloSign = function (url, clientId) {
        blurUtil["a" /* BlurUtil */].blurMenu(this.idToBlur);
        var self = this;
        return new Promise(function (resolve, reject) {
            hellosign_embedded["init"](clientId);
            hellosign_embedded["open"]({
                url: url,
                allowCancel: true,
                skipDomainVerification: false,
                uxVersion: 2,
                height: 480,
                debug: false,
                messageListener: function (eventData) {
                    if (eventData.event == hellosign_embedded["EVENT_SIGNED"]) {
                        self.amazonService.seller.BnNumberStatus = amazon_seller["b" /* SellerStatus */].Done;
                        self.amazonService.seller.PoaNumber = amazon_seller["b" /* SellerStatus */].Done;
                    }
                    resolve(eventData);
                }
            });
        });
    };
    AmazonSignFormComponent.ctorParameters = function () { return [{ type: router_es5["n" /* Router */] }, { type: amazon_service["a" /* AmazonService */] }]; };
    return AmazonSignFormComponent;
}());

//# sourceMappingURL=amazon-sign-form-modal.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/amazon/sign/amazon-sign-form-modal.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */







var styles_AmazonSignFormComponent = [];
var RenderType_AmazonSignFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AmazonSignFormComponent, data: {} });
function View_AmazonSignFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { signModal: 0 }), core_es5["ɵqud"](402653184, 2, { signModalRef: 0 }),
        (_l()(), core_es5["ɵeld"](16777216, [[2, 0], ['signModalRef', 1]], null, 50, 'div', [['bsModal',
                ''], ['class', 'modal fade customer-modal'], ['id', 'myModal'], ['role', 'dialog']], null, [[null, 'onHidden'], [null, 'click'], [null,
                'keydown.esc']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown.esc' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 3).onEsc() !== false);
                ad = (pd_1 && ad);
            }
            if (('onHidden' === en)) {
                var pd_2 = (_co.onModalHidden() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4341760, [[1, 4], ['signModal', 4]], 0, modal_component["a" /* ModalDirective */], [core_es5["ElementRef"], core_es5["ViewContainerRef"], core_es5["Renderer"], component_loader_factory["a" /* ComponentLoaderFactory */]], { config: [0, 'config'] }, { onHidden: 'onHidden' }), core_es5["ɵpod"]({ ignoreBackdropClick: 0,
            keyboard: 1 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 45, 'div', [['class', 'modal-dialog modal-sm'], ['role', 'document']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 42, 'div', [['class', 'modal-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 3, 'button', [['aria-label', 'Close'],
                ['class', 'close pull-right btn btn-round btn-white modal-close-btn'],
                ['data-dismiss', 'modal'], ['type', 'button']], null, [[null,
                    'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    core_es5["ɵnov"](_v, 3).hide();
                    var pd_0 = (_co.emitEvent() !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons modal-close-icon']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['close'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 18, 'div', [['class', 'modal-body']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'text-black']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Power of Attorney (POA) and Agency Agreement'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'p', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Do you verify the information above is correct?'])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' If yes, please sign below to grant us Power of Attorney. Granting Power of Attorney allows us to send the information above, details about your shipments, payment of duties and taxes as well as the business number registration detail to the Canadian government. '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Click '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', 'https://drive.google.com/file/d/12tNDZ7SRnbX55k7b-e1L-qK-EIdRd2vL/view'],
            ['rel', 'noopener noreferrer'], ['target', '_blank']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['here'])), (_l()(), core_es5["ɵted"](null, [' to read the entire POA'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'div', [['class', 'modal-footer']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'col-sm-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'btn-container nextButton text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class',
                'btn btn-round bold text-uppercase btn-orange width-100-pct margin-0 continue'],
            ['type', 'button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.goToSign() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' SIGN '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_0 = _ck(_v, 4, 0, true, false);
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_AmazonSignFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'amazon-sign-form-modal', [], null, null, null, View_AmazonSignFormComponent_0, RenderType_AmazonSignFormComponent)), core_es5["ɵdid"](114688, null, 0, amazon_sign_form_modal_component_AmazonSignFormComponent, [router_es5["n" /* Router */], amazon_service["a" /* AmazonService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AmazonSignFormComponentNgFactory = core_es5["ɵccf"]('amazon-sign-form-modal', amazon_sign_form_modal_component_AmazonSignFormComponent, View_AmazonSignFormComponent_Host_0, { idToBlur: 'idToBlur' }, { signEventEmitter: 'signEventEmitter' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=amazon-sign-form-modal.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/common/helpers/navigateHelper.ts
var NavigateHelper = /** @class */ (function () {
    function NavigateHelper() {
    }
    NavigateHelper.amazonSellerRouting = function (seller) {
        if (seller.Stores && seller.Stores.length > 0) {
            var store = seller.Stores[0];
            return "amazon/info/" + seller.Id + "/store/" + store.Id + "/products";
        }
        else {
            return 'amazon/info/store';
        }
    };
    return NavigateHelper;
}());

//# sourceMappingURL=navigateHelper.js.map
// CONCATENATED MODULE: ./app/components/amazon/amazon-dashboard/amazon-dashboard.component.ts




var amazon_dashboard_component_AmazonDashboardComponent = /** @class */ (function () {
    function AmazonDashboardComponent(router, amazonService) {
        this.router = router;
        this.amazonService = amazonService;
        this.storeProductsRouting = null;
        this.idToBlur = "amazon-dashboard";
    }
    AmazonDashboardComponent.prototype.ngOnInit = function () {
        this.storeProductsRouting = NavigateHelper.amazonSellerRouting(this.amazonService.seller);
        var el = document.querySelector("#amazonInfo");
        if (el) {
            el.scrollTop = 0;
        }
    };
    AmazonDashboardComponent.prototype.showSignForm = function () {
        // if(this.amazonService.seller.PoaNumber == SellerStatus.NotStarted || this.amazonService.seller.BnNumberStatus == SellerStatus.NotStarted){
        //     this.signForm.show();
        // }
        this.signForm.show();
    };
    AmazonDashboardComponent.prototype.setButtonClass = function (sellerStatus) {
        switch (sellerStatus) {
            case amazon_seller["b" /* SellerStatus */].Done:
                return 'btn-green-style';
            case amazon_seller["b" /* SellerStatus */].InProgress:
                return 'btn-yellow-style';
            case amazon_seller["b" /* SellerStatus */].NotStarted:
                return 'btn-red-style';
        }
    };
    AmazonDashboardComponent.prototype.userNavigate = function (routing) {
        this.amazonService.setPrevUrl(this.router.url);
        this.router.navigate([routing]);
    };
    AmazonDashboardComponent.ctorParameters = function () { return [{ type: router_es5["n" /* Router */] }, { type: amazon_service["a" /* AmazonService */] }]; };
    return AmazonDashboardComponent;
}());

//# sourceMappingURL=amazon-dashboard.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/amazon/amazon-dashboard/amazon-dashboard.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_AmazonDashboardComponent = [];
var RenderType_AmazonDashboardComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AmazonDashboardComponent, data: {} });
function View_AmazonDashboardComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { signForm: 0 }), core_es5["ɵqud"](402653184, 2, { dashboard: 0 }),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'amazon-sign-form-modal', [], null, null, null, View_AmazonSignFormComponent_0, RenderType_AmazonSignFormComponent)), core_es5["ɵdid"](114688, [[1, 4], ['signModal',
                4]], 0, amazon_sign_form_modal_component_AmazonSignFormComponent, [router_es5["n" /* Router */], amazon_service["a" /* AmazonService */]], { idToBlur: [0,
                'idToBlur'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, [[2, 0], ['dashboard', 1]], null, 63, 'div', [['class', 'text-center page-container dashboard']], [[1, 'id', 0]], null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'title panel-heading']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Dashboard'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 57, 'div', [['class', 'btn-container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 44, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'col-sm-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'a', [['class', 'btn btn-round bold width-100-pct text-uppercase btn-white btn-green-style']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.userNavigate('amazon/info/seller') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['label'])), (_l()(), core_es5["ɵted"](null, [' Registration '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'col-sm-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'a', [['class', 'btn btn-round bold width-100-pct text-uppercase btn-white']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.showSignForm() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['label'])),
        (_l()(), core_es5["ɵted"](null, [' Business Number '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'a', [['class', 'btn btn-round bold width-100-pct text-uppercase btn-white']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.showSignForm() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['label'])),
        (_l()(), core_es5["ɵted"](null, [' NRI Number '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'a', [['class', 'btn btn-round bold width-100-pct text-uppercase btn-white']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.userNavigate(_co.storeProductsRouting) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['label'])),
        (_l()(), core_es5["ɵted"](null, [' Products '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'row bottom']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 2, 'a', [['class', 'btn text-center btn-round bold width-100-pct text-uppercase btn-white-orange']], null, [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.userNavigate('amazon/info/instructions') !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Instructions '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.idToBlur;
        _ck(_v, 3, 0, currVal_0);
        var currVal_2 = 'btn btn-round bold width-100-pct text-uppercase btn-white';
        var currVal_3 = _co.setButtonClass(_co.amazonService.seller.BnNumberStatus);
        _ck(_v, 27, 0, currVal_2, currVal_3);
        var currVal_4 = 'btn btn-round bold width-100-pct text-uppercase btn-white';
        var currVal_5 = _co.setButtonClass(_co.amazonService.seller.PoaNumber);
        _ck(_v, 38, 0, currVal_4, currVal_5);
        var currVal_6 = 'btn btn-round bold width-100-pct text-uppercase btn-white';
        var currVal_7 = _co.setButtonClass(_co.amazonService.seller.ProductmanageStatus);
        _ck(_v, 49, 0, currVal_6, currVal_7);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.idToBlur;
        _ck(_v, 5, 0, currVal_1);
    });
}
function View_AmazonDashboardComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'amazon-dashboard', [], null, null, null, View_AmazonDashboardComponent_0, RenderType_AmazonDashboardComponent)), core_es5["ɵdid"](114688, null, 0, amazon_dashboard_component_AmazonDashboardComponent, [router_es5["n" /* Router */], amazon_service["a" /* AmazonService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AmazonDashboardComponentNgFactory = core_es5["ɵccf"]('amazon-dashboard', amazon_dashboard_component_AmazonDashboardComponent, View_AmazonDashboardComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=amazon-dashboard.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/theme/css/datatable-ms-fix.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var datatable_ms_fix_css_ngstyle_styles = ['.datatable-body{-ms-overflow-style:auto;overflow-y:auto}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvdGhlbWUvY3NzL2RhdGF0YWJsZS1tcy1maXguY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi90aGVtZS9jc3MvZGF0YXRhYmxlLW1zLWZpeC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=datatable-ms-fix.css.ngstyle.js.map
// CONCATENATED MODULE: ./app/components/amazon/products/amazon-store-products.component.ts







var amazon_store_products_component_AmazonStoreProductsComponent = /** @class */ (function () {
    function AmazonStoreProductsComponent(amazonService, route, el, router, configService, emailService) {
        this.amazonService = amazonService;
        this.route = route;
        this.el = el;
        this.router = router;
        this.configService = configService;
        this.emailService = emailService;
        this.products = Array();
        this.selectedProducts = Array();
        this.currentStore = new AmazonStoreCredentials_AmazonStoreCredentials();
        this.HTCCodeHelper = HTCCodeHelper;
        this.headerHeight = 0;
        this.rowHeight = 140;
        this.idToBlur = "amazon-credentials";
        this.hasSignModalShown = false;
        this.config = {
            currentPage: 0,
            itemsPerPage: 10,
            totalItems: 0
        };
    }
    Object.defineProperty(AmazonStoreProductsComponent.prototype, "currentSeller", {
        get: function () {
            return this.amazonService.seller;
        },
        enumerable: true,
        configurable: true
    });
    AmazonStoreProductsComponent.prototype.ngOnInit = function () {
        this.currentStore = this.currentSeller.Stores[0];
        this.currentStore.Products = this.route.snapshot.data.products.Items;
        this.config.totalItems = this.route.snapshot.data.products.TotalCount;
        this.checkIfAllProductsSelected(this.currentStore.Products);
    };
    AmazonStoreProductsComponent.prototype.loadProducts = function (reset) {
        var _this = this;
        if (reset === void 0) { reset = false; }
        this.amazonService.getProducts(this.currentSeller.Id, this.currentStore.Id, this.config.currentPage * this.config.itemsPerPage, this.config.itemsPerPage, false)
            .then(function (response) {
            if (reset)
                _this.currentStore.Products = response.Data.Items;
            else
                (_a = _this.currentStore.Products).push.apply(_a, response.Data.Items);
            _this.currentStore.Products = _this.currentStore.Products.slice();
            _this.checkIfAllProductsSelected(_this.currentStore.Products);
            _this.config.currentPage++;
            var _a;
        });
    };
    AmazonStoreProductsComponent.prototype.onScroll = function (scrollY) {
        if (!scrollY || !scrollY.offsetY)
            return;
        // total height of all rows in the viewport
        var viewHeight = this.el.nativeElement.getBoundingClientRect().height - this.headerHeight;
        if (this.config.currentPage * this.config.itemsPerPage >= this.config.totalItems)
            return;
        if (viewHeight + scrollY.offsetY >= this.currentStore.Products.length * this.rowHeight) {
            this.config.currentPage++;
            this.loadProducts();
        }
    };
    AmazonStoreProductsComponent.prototype.selectProduct = function (product) {
        product.IsSelected = !product.IsSelected;
        this.amazonService.updateProduct(this.currentSeller.Id, this.currentStore.Id, product);
        this.checkIfAllProductsSelected(this.currentStore.Products);
    };
    AmazonStoreProductsComponent.prototype.selectAll = function () {
        var isSelect = false;
        if (!this.checkIfAllProductsSelected(this.currentStore.Products)) {
            isSelect = true;
        }
        this.selectedProducts = [];
        for (var _i = 0, _a = this.currentStore.Products; _i < _a.length; _i++) {
            var product = _a[_i];
            product.IsSelected = isSelect;
            this.selectedProducts.push(product);
            this.isAllSelected = isSelect;
        }
        this.amazonService.updateProducts(this.currentSeller.Id, this.currentStore.Id, this.selectedProducts);
    };
    AmazonStoreProductsComponent.prototype.userNavigate = function () {
        //     if (this.amazonService.seller.PoaNumber == SellerStatus.NotStarted && !this.hasSignModalShown) {
        this.signForm.show();
        //    } else {
        //       this.goToCongrats();
        //  }
        this.emailService.sendProductsToBB(this.amazonService.seller.Id, this.currentStore.Id);
    };
    AmazonStoreProductsComponent.prototype.onModalAction = function (event) {
        this.hasSignModalShown = event;
        this.goToCongrats();
    };
    AmazonStoreProductsComponent.prototype.goToCongrats = function () {
        this.emailService.sendNotificationToSalesEmail(this.amazonService.seller.Email);
        this.router.navigate(['amazon/info/congratulations']);
        var sellerId = this.amazonService.seller.Id;
        var storeId = this.currentStore.Id;
        // let iframe = document.createElement("iframe");
        // iframe.setAttribute("style", "display:none");
        // iframe.setAttribute("src", `${this.configService.config.AdminUrl}/amazon/info/seller/${sellerId}/store/${storeId}/export`);
        // document.querySelector("body").appendChild(iframe);
    };
    AmazonStoreProductsComponent.prototype.checkIfAllProductsSelected = function (products) {
        var selectedProduct = products.find(function (product) { return product.IsSelected == false; });
        if (selectedProduct) {
            this.isAllSelected = false;
            return false;
        }
        this.isAllSelected = true;
        return true;
    };
    AmazonStoreProductsComponent.ctorParameters = function () { return [{ type: amazon_service["a" /* AmazonService */] }, { type: router_es5["a" /* ActivatedRoute */] }, { type: core_es5["ElementRef"] }, { type: router_es5["n" /* Router */] }, { type: services_configService["a" /* ConfigService */] }, { type: services_emailService["a" /* EmailService */] }]; };
    return AmazonStoreProductsComponent;
}());

//# sourceMappingURL=amazon-store-products.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/amazon/products/amazon-store-products.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */

















var styles_AmazonStoreProductsComponent = [datatable_ms_fix_css_ngstyle_styles];
var RenderType_AmazonStoreProductsComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AmazonStoreProductsComponent, data: {} });
function View_AmazonStoreProductsComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'text-center margin-top-20 margin-bottom-50']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' There are no products in ',
            ' store. ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.currentStore.StoreName;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_AmazonStoreProductsComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 26, 'div', [['class',
                'store-menu']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 23, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [['class',
                'products-count']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['filter_list'])), (_l()(), core_es5["ɵted"](null, [' ', ' items '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'select-all checkbox checkbox-inline checkbox-top padding-left-0 margin-bottom-10']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'input', [['name', 'role'], ['type', 'checkbox']], [[8, 'checked', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'span', [['class',
                'checkbox-material']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectAll() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'check']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Select all products'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.config.totalItems;
        _ck(_v, 10, 0, currVal_0);
        var currVal_1 = _co.isAllSelected;
        _ck(_v, 16, 0, currVal_1);
    });
}
function View_AmazonStoreProductsComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'checkbox checkbox-inline checkbox-top padding-left-0']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'input', [['name', 'role'], ['type', 'checkbox']], [[8, 'checked', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [['class', 'checkbox-material']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectProduct(_v.context.row) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'check']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_1 = core_es5["ɵinlineInterpolate"](1, '', (_v.context.row.IsSelected ? 'selected' : ''), '');
        _ck(_v, 11, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.row.IsSelected;
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_AmazonStoreProductsComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'selected-icon']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['done'])), (_l()(),
            core_es5["ɵted"](null, [' ']))], null, null);
}
function View_AmazonStoreProductsComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'basic-info']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectProduct(_v.context.row) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'basic-info-item product-image']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonStoreProductsComponent_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt', '']], [[8, 'src', 4]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_0 = _v.context.row.IsSelected;
        _ck(_v, 6, 0, currVal_0);
        var currVal_2 = core_es5["ɵinlineInterpolate"](1, '', (_v.context.row.IsSelected ? 'selected' : ''), '');
        _ck(_v, 13, 0, currVal_2);
    }, function (_ck, _v) {
        var currVal_1 = core_es5["ɵinlineInterpolate"](1, '', _v.context.value, '');
        _ck(_v, 8, 0, currVal_1);
    });
}
function View_AmazonStoreProductsComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'basic-info']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectProduct(_v.context.row) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'basic-info-item product-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'brand margin-bottom-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Product name'])), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.value;
        _ck(_v, 7, 0, currVal_0);
    });
}
function View_AmazonStoreProductsComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'basic-info']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectProduct(_v.context.row) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'basic-info-item']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'brand margin-bottom-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Category'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.value;
        _ck(_v, 8, 0, currVal_0);
    });
}
function View_AmazonStoreProductsComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'basic-info']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectProduct(_v.context.row) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'basic-info-item']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'brand margin-bottom-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Amazon Hs Code'])), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.HTCCodeHelper.formatHTCCode(_v.context.value);
        _ck(_v, 7, 0, currVal_0);
    });
}
function View_AmazonStoreProductsComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'basic-info']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.selectProduct(_v.context.row) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'basic-info-item']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'brand margin-bottom-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['HS code'])), (_l()(), core_es5["ɵted"](null, [' ', ' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.HTCCodeHelper.formatHTCCode(_v.context.value);
        _ck(_v, 7, 0, currVal_0);
    });
}
function View_AmazonStoreProductsComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'basic-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'basic-info-item']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'brand margin-bottom-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Description'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [], [[1, 'href', 4]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.value;
        _ck(_v, 8, 0, currVal_0);
        var currVal_1 = _v.context.value;
        _ck(_v, 9, 0, currVal_1);
    });
}
function View_AmazonStoreProductsComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 69, 'ngx-datatable', [['class', 'material ngx-datatable']], [[2, 'fixed-header', null], [2, 'fixed-row',
                null], [2, 'scroll-vertical', null], [2, 'scroll-horz', null],
            [2, 'selectable', null], [2, 'checkbox-selection', null], [2,
                'cell-selection', null], [2, 'single-selection', null],
            [2, 'multi-selection', null], [2, 'multi-click-selection', null]], [[null, 'scroll'], ['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onWindowResize() !== false);
                ad = (pd_0 && ad);
            }
            if (('scroll' === en)) {
                var pd_1 = (_co.onScroll($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_DatatableComponent_0, RenderType_DatatableComponent)), core_es5["ɵdid"](5619712, null, 4, datatable_component["DatatableComponent"], [[1, scrollbar_helper_service["ScrollbarHelper"]], [1, dimensions_helper_service["DimensionsHelper"]],
            core_es5["ChangeDetectorRef"], core_es5["ElementRef"], core_es5["KeyValueDiffers"]], { rows: [0, 'rows'],
            scrollbarV: [1, 'scrollbarV'], scrollbarH: [2, 'scrollbarH'], rowHeight: [3, 'rowHeight'],
            columnMode: [4, 'columnMode'], headerHeight: [5, 'headerHeight'], externalSorting: [6,
                'externalSorting'], reorderable: [7, 'reorderable'], sortType: [8, 'sortType'] }, { scroll: 'scroll' }), core_es5["ɵqud"](603979776, 2, { columnTemplates: 1 }), core_es5["ɵqud"](335544320, 3, { rowDetail: 0 }), core_es5["ɵqud"](335544320, 4, { groupHeader: 0 }), core_es5["ɵqud"](335544320, 5, { footer: 0 }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ngx-datatable-column', [['prop', 'SmallImage']], null, null, null, null, null)), core_es5["ɵdid"](16384, [[2, 4]], 2, column_directive["DataTableColumnDirective"], [], { prop: [0, 'prop'], width: [1, 'width'] }, null), core_es5["ɵqud"](335544320, 6, { cellTemplate: 0 }), core_es5["ɵqud"](335544320, 7, { headerTemplate: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, [[6, 2]], null, 1, null, View_AmazonStoreProductsComponent_4)),
        core_es5["ɵdid"](16384, null, 0, column_cell_directive["DataTableColumnCellDirective"], [core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ngx-datatable-column', [['prop', 'SmallImage']], null, null, null, null, null)), core_es5["ɵdid"](16384, [[2, 4]], 2, column_directive["DataTableColumnDirective"], [], { prop: [0, 'prop'], width: [1, 'width'] }, null), core_es5["ɵqud"](335544320, 8, { cellTemplate: 0 }), core_es5["ɵqud"](335544320, 9, { headerTemplate: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, [[8, 2]], null, 1, null, View_AmazonStoreProductsComponent_5)),
        core_es5["ɵdid"](16384, null, 0, column_cell_directive["DataTableColumnCellDirective"], [core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ngx-datatable-column', [['prop', 'Title']], null, null, null, null, null)), core_es5["ɵdid"](16384, [[2, 4]], 2, column_directive["DataTableColumnDirective"], [], { prop: [0, 'prop'], width: [1, 'width'] }, null), core_es5["ɵqud"](335544320, 10, { cellTemplate: 0 }), core_es5["ɵqud"](335544320, 11, { headerTemplate: 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, [[10, 2]], null, 1, null, View_AmazonStoreProductsComponent_7)),
        core_es5["ɵdid"](16384, null, 0, column_cell_directive["DataTableColumnCellDirective"], [core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ngx-datatable-column', [['prop', 'Model']], null, null, null, null, null)), core_es5["ɵdid"](16384, [[2, 4]], 2, column_directive["DataTableColumnDirective"], [], { prop: [0, 'prop'] }, null), core_es5["ɵqud"](335544320, 12, { cellTemplate: 0 }),
        core_es5["ɵqud"](335544320, 13, { headerTemplate: 0 }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](0, [[12, 2]], null, 1, null, View_AmazonStoreProductsComponent_8)),
        core_es5["ɵdid"](16384, null, 0, column_cell_directive["DataTableColumnCellDirective"], [core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ngx-datatable-column', [['prop', 'HsCode']], null, null, null, null, null)), core_es5["ɵdid"](16384, [[2, 4]], 2, column_directive["DataTableColumnDirective"], [], { prop: [0, 'prop'] }, null), core_es5["ɵqud"](335544320, 14, { cellTemplate: 0 }),
        core_es5["ɵqud"](335544320, 15, { headerTemplate: 0 }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](0, [[14, 2]], null, 1, null, View_AmazonStoreProductsComponent_9)),
        core_es5["ɵdid"](16384, null, 0, column_cell_directive["DataTableColumnCellDirective"], [core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ngx-datatable-column', [['prop', 'HsCode']], null, null, null, null, null)), core_es5["ɵdid"](16384, [[2, 4]], 2, column_directive["DataTableColumnDirective"], [], { prop: [0, 'prop'] }, null), core_es5["ɵqud"](335544320, 16, { cellTemplate: 0 }),
        core_es5["ɵqud"](335544320, 17, { headerTemplate: 0 }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](0, [[16, 2]], null, 1, null, View_AmazonStoreProductsComponent_10)),
        core_es5["ɵdid"](16384, null, 0, column_cell_directive["DataTableColumnCellDirective"], [core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ngx-datatable-column', [['prop', 'LinkToProduct']], null, null, null, null, null)), core_es5["ɵdid"](16384, [[2, 4]], 2, column_directive["DataTableColumnDirective"], [], { prop: [0, 'prop'] }, null), core_es5["ɵqud"](335544320, 18, { cellTemplate: 0 }),
        core_es5["ɵqud"](335544320, 19, { headerTemplate: 0 }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](0, [[18, 2]], null, 1, null, View_AmazonStoreProductsComponent_11)),
        core_es5["ɵdid"](16384, null, 0, column_cell_directive["DataTableColumnCellDirective"], [core_es5["TemplateRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_10 = _co.currentStore.Products;
        var currVal_11 = true;
        var currVal_12 = true;
        var currVal_13 = _co.rowHeight;
        var currVal_14 = 'force';
        var currVal_15 = _co.headerHeight;
        var currVal_16 = true;
        var currVal_17 = false;
        var currVal_18 = 'single';
        _ck(_v, 1, 0, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18);
        var currVal_19 = 'SmallImage';
        var currVal_20 = 60;
        _ck(_v, 8, 0, currVal_19, currVal_20);
        var currVal_21 = 'SmallImage';
        var currVal_22 = 120;
        _ck(_v, 17, 0, currVal_21, currVal_22);
        var currVal_23 = 'Title';
        var currVal_24 = 200;
        _ck(_v, 26, 0, currVal_23, currVal_24);
        var currVal_25 = 'Model';
        _ck(_v, 35, 0, currVal_25);
        var currVal_26 = 'HsCode';
        _ck(_v, 44, 0, currVal_26);
        var currVal_27 = 'HsCode';
        _ck(_v, 53, 0, currVal_27);
        var currVal_28 = 'LinkToProduct';
        _ck(_v, 62, 0, currVal_28);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).isFixedHeader;
        var currVal_1 = core_es5["ɵnov"](_v, 1).isFixedRow;
        var currVal_2 = core_es5["ɵnov"](_v, 1).isVertScroll;
        var currVal_3 = core_es5["ɵnov"](_v, 1).isHorScroll;
        var currVal_4 = core_es5["ɵnov"](_v, 1).isSelectable;
        var currVal_5 = core_es5["ɵnov"](_v, 1).isCheckboxSelection;
        var currVal_6 = core_es5["ɵnov"](_v, 1).isCellSelection;
        var currVal_7 = core_es5["ɵnov"](_v, 1).isSingleSelection;
        var currVal_8 = core_es5["ɵnov"](_v, 1).isMultiSelection;
        var currVal_9 = core_es5["ɵnov"](_v, 1).isMultiClickSelection;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9);
    });
}
function View_AmazonStoreProductsComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { signForm: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'amazon-sign-form-modal', [], null, [[null,
                'signEventEmitter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('signEventEmitter' === en)) {
                var pd_0 = (_co.onModalAction($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_AmazonSignFormComponent_0, RenderType_AmazonSignFormComponent)),
        core_es5["ɵdid"](114688, [[1, 4], ['signModal', 4]], 0, amazon_sign_form_modal_component_AmazonSignFormComponent, [router_es5["n" /* Router */],
            amazon_service["a" /* AmazonService */]], { idToBlur: [0, 'idToBlur'] }, { signEventEmitter: 'signEventEmitter' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 65, 'div', [['class', 'calculator-v2-tab-result amazon-store-products']], [[1,
                'id', 0]], null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 52, 'div', [['class', 'panel card accordion-open']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 31, 'div', [['class',
                'panel-heading card-header'], ['role', 'tab']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 28, 'div', [['class',
                'panel-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['aria-expanded', 'true'], ['class',
                'accordion-toggle'], ['role', 'button']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 22, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class',
                'row product']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'div', [['class', 'col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-10']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'index bold']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-2 btn-close']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons brand']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['expand_more'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'div', [['class',
                'store-content navbar-inner']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonStoreProductsComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonStoreProductsComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'store-products']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'amazon-product-card-container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonStoreProductsComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'row bottom']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'col-sm-12 text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'a', [['class', 'btn text-center btn-round bold width-100-pct text-uppercase btn-white-orange']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.userNavigate() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Next '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.idToBlur;
        _ck(_v, 2, 0, currVal_0);
        var currVal_3 = ((_co.currentStore && !_co.currentStore.Products) || (_co.currentStore.Products.length == 0));
        _ck(_v, 44, 0, currVal_3);
        var currVal_4 = ((_co.currentStore && _co.currentStore.Products) && (_co.currentStore.Products.length > 0));
        _ck(_v, 47, 0, currVal_4);
        var currVal_5 = ((_co.currentStore && _co.currentStore.Products) && (_co.currentStore.Products.length > 0));
        _ck(_v, 54, 0, currVal_5);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.idToBlur;
        _ck(_v, 4, 0, currVal_1);
        var currVal_2 = _co.currentStore.StoreName;
        _ck(_v, 25, 0, currVal_2);
    });
}
function View_AmazonStoreProductsComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'amazon-store-products', [], null, null, null, View_AmazonStoreProductsComponent_0, RenderType_AmazonStoreProductsComponent)), core_es5["ɵdid"](114688, null, 0, amazon_store_products_component_AmazonStoreProductsComponent, [amazon_service["a" /* AmazonService */], router_es5["a" /* ActivatedRoute */], core_es5["ElementRef"], router_es5["n" /* Router */], services_configService["a" /* ConfigService */],
            services_emailService["a" /* EmailService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AmazonStoreProductsComponentNgFactory = core_es5["ɵccf"]('amazon-store-products', amazon_store_products_component_AmazonStoreProductsComponent, View_AmazonStoreProductsComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=amazon-store-products.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/amazon/instructions/amazon-instructions.component.ts


var amazon_instructions_component_AmazonInstructionsComponent = /** @class */ (function () {
    function AmazonInstructionsComponent(amazonService, router) {
        this.amazonService = amazonService;
        this.router = router;
        this.showMore = false;
    }
    AmazonInstructionsComponent.prototype.navigateUser = function () {
        if (!this.amazonService.prevUrl) {
            this.router.navigate(['amazon/info/dashboard']);
        }
        else {
            this.router.navigate([this.amazonService.prevUrl]);
        }
    };
    AmazonInstructionsComponent.prototype.showOtherInstructions = function () {
        this.showMore = true;
        var el = document.querySelector("#amazonInfo");
        if (el) {
            el.scrollTop = 0;
        }
    };
    AmazonInstructionsComponent.ctorParameters = function () { return [{ type: amazon_service["a" /* AmazonService */] }, { type: router_es5["n" /* Router */] }]; };
    return AmazonInstructionsComponent;
}());

//# sourceMappingURL=amazon-instructions.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/amazon/instructions/amazon-instructions.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_AmazonInstructionsComponent = [];
var RenderType_AmazonInstructionsComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AmazonInstructionsComponent, data: {} });
function View_AmazonInstructionsComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 52, 'ul', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['1. Make sure that your Amazon account can use MWS at this link.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['2. Navigate to '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'a', [['class', 'text-white text-underline'],
                ['href', 'https://developer.amazonservices.com/'], ['target', '_blank']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['https://developer.amazonservices.com/'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['3. Click on “Sign up For MWS”. Sign in if needed. '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt', ''], ['src', 'assets/amazon3.0382244c383ef07dc4a5646cefc46e8e.png']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 12, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['4. Select “I want to use an application to access my Amazon seller account with MWS” fill in the fields with: '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['i. Application Name = Borderbuddy MWS'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['ii. Application’s Developer Account Number: 4682-1200-7728'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt', ''], ['src', 'assets/amazon4.913580b2bdfc8b4eae35feb6f8161ea5.png']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['5. Click “Next”'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['6. Tick all the checkboxes and click “Next”'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['7. Print the resulting page for your records and write down the following three items: '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 10, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['i. Seller ID'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['ii. Marketplace ID'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['iii. MWS Auth Token'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt', ''], ['src', 'assets/anazon7.9cb00371855eecd515408257b833d877.png']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_AmazonInstructionsComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['class',
                'text-white text-underline display-inline-block margin-10']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.showOtherInstructions() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['If you have more than one application added, please follow this guide']))], null, null);
}
function View_AmazonInstructionsComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 47, 'ul', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['1. Make sure that your Amazon account can use MWS at this link.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['2. Navigate to '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'a', [['class', 'text-white text-underline'],
                ['href', 'https://developer.amazonservices.com/'], ['target', '_blank']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['https://developer.amazonservices.com/'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['3. Click on “Sign up For MWS”. Sign in if needed. '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt', ''], ['src', 'assets/amazon3.0382244c383ef07dc4a5646cefc46e8e.png']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['4. Click on Authorize a Developer '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt', ''], ['src', 'assets/amazon1.4.af6fed630e66e707380d184ca9aa5250.png']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['5. Fill in Developer Name and ID. Click on Next. '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt', ''], ['src', 'assets/amazon1.5.ba6bd4f9673ceef8cefdd15e5459471d.png']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['6. Tick all the checkboxes and click “Next”. '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt', ''], ['src', 'assets/amazon1.6.6c9690d3ce0bc55196e4a3086ca9201b.png']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 15, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['7. Print the resulting page for your records and write down the following three items: '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 10, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['i. Seller ID'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['ii. Marketplace ID'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['iii. MWS Auth Token'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt', ''], ['src', 'assets/amazon1.7.99599e7145301ad5450fc1974636d330.png']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_AmazonInstructionsComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, [['instructions', 1]], null, 26, 'div', [['class', 'text-center page-container instructions']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'title panel-heading']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Approving the Borderbuddy application in Amazon'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'row margin-bottom-30']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'col-sm-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonInstructionsComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonInstructionsComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AmazonInstructionsComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'col-sm-12 dashboard']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'a', [['class', 'btn text-center btn-round bold width-100-pct text-uppercase btn-white-orange']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.navigateUser() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Close '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.showMore;
        _ck(_v, 10, 0, currVal_0);
        var currVal_1 = !_co.showMore;
        _ck(_v, 13, 0, currVal_1);
        var currVal_2 = _co.showMore;
        _ck(_v, 16, 0, currVal_2);
    }, null);
}
function View_AmazonInstructionsComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'amazon-instructions', [], null, null, null, View_AmazonInstructionsComponent_0, RenderType_AmazonInstructionsComponent)), core_es5["ɵdid"](49152, null, 0, amazon_instructions_component_AmazonInstructionsComponent, [amazon_service["a" /* AmazonService */], router_es5["n" /* Router */]], null, null)], null, null);
}
var AmazonInstructionsComponentNgFactory = core_es5["ɵccf"]('amazon-instructions', amazon_instructions_component_AmazonInstructionsComponent, View_AmazonInstructionsComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=amazon-instructions.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/amazon/congratulation/amazon-congratulation.component.ts
var AmazonCongratulationComponent = /** @class */ (function () {
    function AmazonCongratulationComponent() {
    }
    return AmazonCongratulationComponent;
}());

//# sourceMappingURL=amazon-congratulation.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/amazon/congratulation/amazon-congratulation.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_AmazonCongratulationComponent = [];
var RenderType_AmazonCongratulationComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AmazonCongratulationComponent, data: {} });
function View_AmazonCongratulationComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 38, 'div', [['class', 'calculator-v2-tab-result amazon-store-products']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 35, 'div', [['class', 'page-container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'slide-inner']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'img-sector step-5']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt', ''], ['src', 'assets/step5.907adfc9456f7ed986c9c466e424391d.png']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'title-wizard text-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Congratulations!'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'bold margin-bottom-20 text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['You\'ve made the smart choice.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'bold']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Your business will be protected from border-crossing delays. Your data is secure. And a new market of customers awaits.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' The BorderBuddy team are working on your products. We\'ll help you register for a BN and Non-Resident Importer number through the Canada Revenue Agency, once your products are classified and on amazon.ca. You\'ll receive a notification within 72 hours upon completion of your products being pushed into your Amazon.ca account. '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'row bottom margin-top-20']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-sm-12 text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'a', [['class', 'btn text-center btn-round bold width-100-pct text-uppercase btn-white-orange']], [[1, 'target', 0], [8, 'href', 4]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 32).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](671744, null, 0, router_es5["p" /* RouterLinkWithHref */], [router_es5["n" /* Router */], router_es5["a" /* ActivatedRoute */], common_es5["LocationStrategy"]], { routerLink: [0, 'routerLink'] }, null), core_es5["ɵpad"](2), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Check back here '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_2 = _ck(_v, 33, 0, '/amazon/info', 'dashboard');
        _ck(_v, 32, 0, currVal_2);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 32).target;
        var currVal_1 = core_es5["ɵnov"](_v, 32).href;
        _ck(_v, 31, 0, currVal_0, currVal_1);
    });
}
function View_AmazonCongratulationComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'amazon-congratulation', [], null, null, null, View_AmazonCongratulationComponent_0, RenderType_AmazonCongratulationComponent)), core_es5["ɵdid"](49152, null, 0, AmazonCongratulationComponent, [], null, null)], null, null);
}
var AmazonCongratulationComponentNgFactory = core_es5["ɵccf"]('amazon-congratulation', AmazonCongratulationComponent, View_AmazonCongratulationComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=amazon-congratulation.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/theme/css/auth.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var auth_css_ngstyle_styles = ['.full-page-background{background-image:url(assets/background.59fc83e26c663ade5dcae6e7d56ca970.jpg)}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvdGhlbWUvY3NzL2F1dGguY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi90aGVtZS9jc3MvYXV0aC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=auth.css.ngstyle.js.map
// CONCATENATED MODULE: ./app/components/auth/authLayout/authLayout.component.ts



var authLayout_component_AuthLayoutComponent = /** @class */ (function () {
    function AuthLayoutComponent(element, router, renderer) {
        this.element = element;
        this.router = router;
        this.renderer = renderer;
        this.loading = false;
    }
    AuthLayoutComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sidebarVisible = false;
        this.isMobileMenu = screenHelper["a" /* ScreenHelper */].isTabletOrPhone();
        this.router.events.subscribe(function (val) {
            if (val instanceof router_es5["f" /* NavigationStart */])
                _this.loading = true;
            else if (val instanceof router_es5["e" /* NavigationEnd */])
                _this.loading = false;
        });
    };
    AuthLayoutComponent.prototype.ngAfterViewInit = function () {
        var spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");
    };
    AuthLayoutComponent.prototype.onResize = function (event) {
        this.isMobileMenu = screenHelper["a" /* ScreenHelper */].isTabletOrPhone();
    };
    AuthLayoutComponent.ctorParameters = function () { return [{ type: core_es5["ElementRef"] }, { type: router_es5["n" /* Router */] }, { type: core_es5["Renderer2"] }]; };
    return AuthLayoutComponent;
}());

//# sourceMappingURL=authLayout.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/auth/authLayout/authLayout.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_AuthLayoutComponent = [auth_css_ngstyle_styles];
var RenderType_AuthLayoutComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AuthLayoutComponent, data: {} });
function View_AuthLayoutComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class',
                'spinner-circle']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, ':svg:svg', [['class', 'spinner-circular'], ['viewBox', '25 25 50 50']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, ':svg:circle', [['class',
                'path'], ['cx', '50'], ['cy', '50'], ['fill', 'none'], ['r', '20'], ['stroke-miterlimit',
                '10'], ['stroke-width', '2']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_AuthLayoutComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'wrapper wrapper-full-page']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'main-panel': 0 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](16777216, null, null, 1, 'router-outlet', [], null, null, null, null, null)), core_es5["ɵdid"](212992, null, 0, router_es5["r" /* RouterOutlet */], [router_es5["b" /* ChildrenOutletContexts */], core_es5["ViewContainerRef"],
            core_es5["ComponentFactoryResolver"], [8, null], core_es5["ChangeDetectorRef"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_AuthLayoutComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 4, 0, _co.isMobileMenu);
        _ck(_v, 3, 0, currVal_0);
        _ck(_v, 7, 0);
        var currVal_1 = _co.loading;
        _ck(_v, 10, 0, currVal_1);
    }, null);
}
function View_AuthLayoutComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'auth-layout', [], null, [['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onResize($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_AuthLayoutComponent_0, RenderType_AuthLayoutComponent)), core_es5["ɵdid"](4308992, null, 0, authLayout_component_AuthLayoutComponent, [core_es5["ElementRef"], router_es5["n" /* Router */], core_es5["Renderer2"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AuthLayoutComponentNgFactory = core_es5["ɵccf"]('auth-layout', authLayout_component_AuthLayoutComponent, View_AuthLayoutComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvYXV0aC9hdXRoTGF5b3V0L2F1dGhMYXlvdXQuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL2F1dGgvYXV0aExheW91dC9hdXRoTGF5b3V0LmNvbXBvbmVudC50cyIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL2F1dGgvYXV0aExheW91dC9hdXRoTGF5b3V0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvYXV0aC9hdXRoTGF5b3V0L2F1dGhMYXlvdXQuY29tcG9uZW50LnRzLkF1dGhMYXlvdXRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwid3JhcHBlciB3cmFwcGVyLWZ1bGwtcGFnZVwiPiA8ZGl2IFtuZ0NsYXNzXT1cInsnbWFpbi1wYW5lbCc6IGlzTW9iaWxlTWVudX1cIj4gPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PiA8ZGl2IGNsYXNzPVwic3Bpbm5lci1jaXJjbGVcIiAqbmdJZj1cImxvYWRpbmdcIj4gPHN2ZyBjbGFzcz1cInNwaW5uZXItY2lyY3VsYXJcIiB2aWV3Qm94PVwiMjUgMjUgNTAgNTBcIj4gPGNpcmNsZSBjbGFzcz1cInBhdGhcIiBjeD1cIjUwXCIgY3k9XCI1MFwiIHI9XCIyMFwiIGZpbGw9XCJub25lXCIgc3Ryb2tlLXdpZHRoPVwiMlwiIHN0cm9rZS1taXRlcmxpbWl0PVwiMTBcIj48L2NpcmNsZT4gPC9zdmc+IDwvZGl2PiA8L2Rpdj4gPC9kaXY+IiwiPGF1dGgtbGF5b3V0PjwvYXV0aC1sYXlvdXQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQXVIO01BQUE7TUFBNEMsc0NBQUM7VUFBQTtVQUFBLDBEQUFvRDtVQUFBLFFBQUM7VUFBQTtVQUFBO1VBQUEsZ0JBQXlHLHNDQUFPO1VBQUE7OztvQkFBelU7TUFBQTtNQUFBLGdCQUF1QyxzQ0FBQztNQUFBO01BQUEscUNBQUE7a0RBQUE7YUFBSyxtQkFBeUMsc0NBQUM7VUFBQTtVQUFBLGlFQUFBO1VBQUE7MENBQUE7VUFBQSw2QkFBK0Isc0NBQUM7aUJBQUE7YUFBQTtVQUFBLHdCQUF5TixzQ0FBTztVQUFBOztJQUExUztJQUFMLFdBQUssU0FBTDtJQUErQztJQUE0RDtJQUE1QixZQUE0QixTQUE1Qjs7OztvQkNBdkg7TUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLHFFQUFBO01BQUE7TUFBQTtJQUFBOzs7OyJ9
//# sourceMappingURL=authLayout.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/auth/googleLogin/googleLogin.component.ts
/**
 * Created by alex.y on 7/14/2017.
 */




var googleLogin_component_GoogleLoginComponent = /** @class */ (function () {
    function GoogleLoginComponent(userService, configService, router, route) {
        this.userService = userService;
        this.configService = configService;
        this.router = router;
        this.route = route;
        this.errors = [];
    }
    GoogleLoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hash = location.hash;
        if (String.isNullOrEmpty(hash))
            return;
        if (!location.hash.split('access_token='))
            return;
        this.accessToken = location.hash.match(/access_token=([^&]*)&/)[1];
        if (!this.accessToken)
            return;
        this.userService.getExternalUserInfo(this.accessToken).then(function (resp) {
            ng2_cookies_ng2_cookies["Cookie"].set(_this.configService.config.ApiTokenCookieName, _this.accessToken, 1, '/');
            ng2_cookies_ng2_cookies["Cookie"].set(_this.configService.config.UserCookieName, resp.Data.Id.toString(), 1, '/');
            _this.router.navigate(["calculator/agent"]);
        });
    };
    /**
     * redirect user to google authorization
     */
    GoogleLoginComponent.prototype.login = function () {
        var _this = this;
        ng2_cookies_ng2_cookies["Cookie"].delete(this.configService.config.ApiTokenCookieName);
        ng2_cookies_ng2_cookies["Cookie"].delete(this.configService.config.UserCookieName);
        ng2_cookies_ng2_cookies["Cookie"].delete(this.configService.config.UserAmazonCookieName);
        this.userService.prepareExternalLogin().then(function (x) {
            window.location.href =
                _this.configService.config.ApiUrl + "/api/Account/ExternalLogin?provider=Google&response_type=token&client_id=self&redirect_uri=" + _this.configService.config.ApiUrl +
                    "/api/Account/ExternalLogin&state=0eYM9Qg6Gu3Z8H3CqEQUfmI3i_XM59C-q5UUdAONOpw1";
        });
    };
    GoogleLoginComponent.ctorParameters = function () { return [{ type: services_userService["a" /* UserService */] }, { type: services_configService["a" /* ConfigService */] }, { type: router_es5["n" /* Router */] }, { type: router_es5["a" /* ActivatedRoute */] }]; };
    return GoogleLoginComponent;
}());

//# sourceMappingURL=googleLogin.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/auth/googleLogin/googleLogin.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */









var styles_GoogleLoginComponent = [];
var RenderType_GoogleLoginComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_GoogleLoginComponent, data: {} });
function View_GoogleLoginComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 36, 'div', [['class',
                'full-page login-page'], ['filter-color', 'black']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 31, 'div', [['class', 'content']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 28, 'div', [['class', 'container-fluid text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class', 'col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'form', [['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 12).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 12).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['loginForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'button', [['class', 'btn btn-google btn-just-icon']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.login() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['src', 'assets/google.ee10454df878ed1e6f99586233f7e7d6.png']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Sign in with Google'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'text-divider']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'errors-summary', [], null, null, null, View_ErrorsSummaryComponent_0, RenderType_ErrorsSummaryComponent)),
        core_es5["ɵdid"](49152, null, 0, errorsSummary_component_ErrorsSummaryComponent, [], { errors: [0,
                'errors'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'full-page-background']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.errors;
        _ck(_v, 28, 0, currVal_7);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 14).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 14).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 14).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 14).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 14).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 14).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 14).ngClassPending;
        _ck(_v, 10, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_GoogleLoginComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'google-login', [], null, null, null, View_GoogleLoginComponent_0, RenderType_GoogleLoginComponent)), core_es5["ɵdid"](114688, null, 0, googleLogin_component_GoogleLoginComponent, [services_userService["a" /* UserService */], services_configService["a" /* ConfigService */], router_es5["n" /* Router */], router_es5["a" /* ActivatedRoute */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var GoogleLoginComponentNgFactory = core_es5["ɵccf"]('google-login', googleLogin_component_GoogleLoginComponent, View_GoogleLoginComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=googleLogin.component.ngfactory.js.map
// CONCATENATED MODULE: ./node_modules/ngx-validators/src/email/email-validators.js

var email_validators_EmailValidators = (function () {
    function EmailValidators() {
    }
    EmailValidators.simple = function (control) {
        if (Util.isNotPresent(control))
            return undefined;
        var pattern = '^.+@.+\\..+$';
        if (new RegExp(pattern).test(control.value)) {
            return undefined;
        }
        return { 'simpleEmailRule': true };
    };
    ;
    // https://www.w3.org/TR/html5/forms.html#valid-e-mail-address
    EmailValidators.normal = function (control) {
        if (Util.isNotPresent(control))
            return undefined;
        // tslint:disable-next-line:max-line-length
        var pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        if (pattern.test(control.value)) {
            return undefined;
        }
        return { 'normalEmailRule': true };
    };
    ;
    return EmailValidators;
}());

//# sourceMappingURL=email-validators.js.map
// CONCATENATED MODULE: ./node_modules/ngx-validators/src/email/email.directive.js



var email_directive_EmailValidatorDirective = (function () {
    function EmailValidatorDirective() {
        this.email = 'normal';
    }
    EmailValidatorDirective.prototype.ngOnInit = function () {
        switch (this.email) {
            case 'simple':
                this.validator = email_validators_EmailValidators.simple;
                break;
            case 'normal':
                this.validator = email_validators_EmailValidators.normal;
                break;
            default:
                this.validator = email_validators_EmailValidators.normal;
                break;
        }
    };
    EmailValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    return EmailValidatorDirective;
}());

email_directive_EmailValidatorDirective.decorators = [
    { type: core_es5["Directive"], args: [{
                selector: '[email][formControlName],[email][formControl],[email][ngModel]',
                providers: [{
                        provide: forms_es5["NG_VALIDATORS"],
                        // tslint:disable-next-line:no-forward-ref
                        useExisting: Object(core_es5["forwardRef"])(function () { return email_directive_EmailValidatorDirective; }),
                        multi: true
                    }]
            },] },
];
/** @nocollapse */
email_directive_EmailValidatorDirective.ctorParameters = function () { return []; };
email_directive_EmailValidatorDirective.propDecorators = {
    'email': [{ type: core_es5["Input"] },],
};
//# sourceMappingURL=email.directive.js.map
// CONCATENATED MODULE: ./app/common/directives/validators/equalValidator.ts
var EqualValidatorDirective = /** @class */ (function () {
    function EqualValidatorDirective() {
    }
    EqualValidatorDirective.prototype.validate = function (control) {
        if (!control.value)
            return null;
        if (this.validateEqual && control.value !== this.validateEqual.value)
            return { validateEqual: false };
        return null;
    };
    EqualValidatorDirective.ctorParameters = function () { return []; };
    return EqualValidatorDirective;
}());

//# sourceMappingURL=equalValidator.js.map
// CONCATENATED MODULE: ./app/common/directives/validators/checkboxRequiredValidator.ts


var checkboxRequiredValidator_CheckboxRequiredValidatorDirective = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](CheckboxRequiredValidatorDirective, _super);
    function CheckboxRequiredValidatorDirective() {
        var _this = _super.call(this) || this;
        _this.required = true;
        return _this;
    }
    CheckboxRequiredValidatorDirective.ctorParameters = function () { return []; };
    return CheckboxRequiredValidatorDirective;
}(forms_es5["CheckboxRequiredValidator"]));

//# sourceMappingURL=checkboxRequiredValidator.js.map
// EXTERNAL MODULE: ./app/common/helpers/stringHelper.ts
var stringHelper = __webpack_require__("xFNE");
var stringHelper_default = /*#__PURE__*/__webpack_require__.n(stringHelper);

// CONCATENATED MODULE: ./app/objects/users/registerModel.ts
var RegisterModel = /** @class */ (function () {
    function RegisterModel() {
        this.FirstName = "";
        this.LastName = "";
        this.Email = "";
        this.Password = "";
        this.ConfirmPassword = "";
        this.TermsAgree = false;
        this.Source = 1;
    }
    return RegisterModel;
}());

//# sourceMappingURL=registerModel.js.map
// CONCATENATED MODULE: ./app/components/auth/register/register.component.ts






var register_component_RegisterComponent = /** @class */ (function () {
    function RegisterComponent(userService, cookieService, configService, router, route) {
        this.userService = userService;
        this.cookieService = cookieService;
        this.configService = configService;
        this.router = router;
        this.route = route;
        this.errors = [];
    }
    RegisterComponent.prototype.ngOnInit = function () {
        var _this = this;
        var userId = this.route.snapshot.queryParams['userId'] || '';
        this.model = new RegisterModel();
        if (!String.isNullOrEmpty(userId)) {
            this.block = true;
            this.userService.getUserInfo(userId).then(function (response) {
                var user = response.Data;
                _this.model.Email = user.Email;
                _this.model.FirstName = user.FirstName;
                _this.model.LastName = user.LastName;
            });
        }
    };
    RegisterComponent.prototype.register = function (isValid) {
        var _this = this;
        this.errors = [];
        if (!isValid)
            return;
        this.processing = true;
        this.userService.register(this.model).then(function (response) {
            var returnUrl = response.Data.ReturnUrl;
            _this.userService.login(_this.model.Email, _this.model.Password).then(function (x) {
                var response = x.json();
                _this.cookieService.set(_this.configService.config.ApiTokenCookieName, response.access_token);
                _this.cookieService.set(_this.configService.config.UserCookieName, response.userID);
                _this.router.navigate([returnUrl]);
            }).catch(function (x) {
                _this.processing = false;
                _this.errors.push({
                    Key: "",
                    Value: [x.json().error_description]
                });
            });
        }).catch(function (response) {
            _this.processing = false;
            _this.errors = _this.errors.concat(response.Errors);
        });
    };
    RegisterComponent.ctorParameters = function () { return [{ type: services_userService["a" /* UserService */] }, { type: ng2_cookies["CookieService"] }, { type: services_configService["a" /* ConfigService */] }, { type: router_es5["n" /* Router */] }, { type: router_es5["a" /* ActivatedRoute */] }]; };
    return RegisterComponent;
}());

//# sourceMappingURL=register.component.js.map
// EXTERNAL MODULE: ./node_modules/ng2-cookies/cookie.js
var ng2_cookies_cookie = __webpack_require__("KJe9");
var cookie_default = /*#__PURE__*/__webpack_require__.n(ng2_cookies_cookie);

// CONCATENATED MODULE: ./compiled/app/components/auth/register/register.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





















var styles_RegisterComponent = [];
var RenderType_RegisterComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_RegisterComponent, data: {} });
function View_RegisterComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' First Name is required. ']))], null, null);
}
function View_RegisterComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' First Name can only contain letters from a to z, A to Z. ']))], null, null);
}
function View_RegisterComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Last Name is required. ']))], null, null);
}
function View_RegisterComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Last Name can only contain letters from a to z, A to Z. ']))], null, null);
}
function View_RegisterComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Email is required. ']))], null, null);
}
function View_RegisterComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Your email address is invalid. ']))], null, null);
}
function View_RegisterComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Password is required ']))], null, null);
}
function View_RegisterComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Password should be more then 6 chars ']))], null, null);
}
function View_RegisterComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Confirm Password is required ']))], null, null);
}
function View_RegisterComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Password and its confirm are not the same ']))], null, null);
}
function View_RegisterComponent_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'small', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' You must agree with the terms and conditions ']))], null, null);
}
function View_RegisterComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 184, 'div', [['class',
                'col-md-5']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 181, 'form', [['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngSubmit'], [null, 'submit'],
            [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 4).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.register(core_es5["ɵnov"](_v, 4).valid) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['registerForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 167, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 26, 'div', [['class',
                'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [['class', 'input-group-addon']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['face'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'form-input', [['label', 'First Name'], ['name', 'fisrtName'], ['pattern',
                '[a-z A-Z]*'], ['required', '']], [[1, 'required', 0], [1, 'pattern', 0], [2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.model.FirstName = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['firstNameModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], disabled: [2, 'disabled'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_RegisterComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_RegisterComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 26, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [['class',
                'input-group-addon']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['face'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'form-input', [['label',
                'Last Name'], ['name', 'lastName'], ['pattern', '[a-z A-Z]*'], ['required', '']], [[1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.model.LastName = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['lastNameModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], label: [1, 'label'], disabled: [2, 'disabled'], form: [3, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_RegisterComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_RegisterComponent_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 27, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [['class',
                'input-group-addon']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['email'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['email',
                ''], ['label', 'Email'], ['name', 'email'], ['required', ''], ['type', 'email']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.model.Email = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](16384, null, 0, forms_es5["EmailValidator"], [], { email: [0, 'email'] }, null), core_es5["ɵdid"](81920, null, 0, email_directive_EmailValidatorDirective, [], { email: [0, 'email'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0, p2_0) {
            return [p0_0, p1_0, p2_0];
        }, [forms_es5["RequiredValidator"], forms_es5["EmailValidator"], email_directive_EmailValidatorDirective]), core_es5["ɵdid"](4308992, [['emailModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], disabled: [3, 'disabled'],
            form: [4, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_RegisterComponent_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_RegisterComponent_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 26, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [['class',
                'input-group-addon']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['lock_outline'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'form-input', [['label',
                'Password'], ['minlength', '6'], ['name', 'password'], ['required', ''], ['type',
                'password']], [[1, 'required', 0], [1, 'minlength', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.model.Password = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["MinLengthValidator"], [], { minlength: [0, 'minlength'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["MinLengthValidator"]]), core_es5["ɵdid"](4308992, [['passwordModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, 0, 2, null, View_RegisterComponent_8)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_RegisterComponent_9)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 26, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [['class',
                'input-group-addon']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['lock_outline'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'form-input', [['label',
                'Confirm Password'], ['name', 'confirmPassword'], ['required', ''], ['type', 'password']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.model.ConfirmPassword = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](16384, null, 0, EqualValidatorDirective, [], { validateEqual: [0, 'validateEqual'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], EqualValidatorDirective]), core_es5["ɵdid"](4308992, [['confirmPasswordModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, 0, 2, null, View_RegisterComponent_10)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_RegisterComponent_11)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'checkbox', [['name', 'agree'], ['required', '']], [[1, 'required',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.model.TermsAgree = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CheckboxComponent_0, RenderType_CheckboxComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](16384, null, 0, checkboxRequiredValidator_CheckboxRequiredValidatorDirective, [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], checkboxRequiredValidator_CheckboxRequiredValidatorDirective]), core_es5["ɵdid"](4243456, [['agreeModel', 4]], 0, checkbox_component_CheckboxComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { name: [0, 'name'], form: [1, 'form'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [checkbox_component_CheckboxComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' I accept and agree to Constant Retail\'s '])), (_l()(), core_es5["ɵeld"](0, null, 0, 1, 'a', [['role', 'button']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                core_es5["ɵnov"](_v.parent, 88).show();
                var pd_0 = ($event.preventDefault() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['Terms and Conditions'])),
        (_l()(), core_es5["ɵted"](0, ['.'])), (_l()(), core_es5["ɵeld"](0, null, 0, 0, 'br', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_RegisterComponent_12)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'text-divider']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'errors-summary', [], null, null, null, View_ErrorsSummaryComponent_0, RenderType_ErrorsSummaryComponent)), core_es5["ɵdid"](49152, null, 0, errorsSummary_component_ErrorsSummaryComponent, [], { errors: [0, 'errors'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'footer text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class',
                'btn btn-primary btn-round'], ['type', 'submit']], [[8, 'disabled', 0]], null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, ['Register'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_16 = '';
        _ck(_v, 19, 0, currVal_16);
        var currVal_17 = '[a-z A-Z]*';
        _ck(_v, 20, 0, currVal_17);
        var currVal_18 = 'fisrtName';
        var currVal_19 = 'First Name';
        var currVal_20 = _co.block;
        var currVal_21 = core_es5["ɵnov"](_v, 4);
        _ck(_v, 22, 0, currVal_18, currVal_19, currVal_20, currVal_21);
        var currVal_22 = 'fisrtName';
        var currVal_23 = _co.block;
        var currVal_24 = _co.model.FirstName;
        _ck(_v, 24, 0, currVal_22, currVal_23, currVal_24);
        var currVal_25 = ((!_co.block && (core_es5["ɵunv"](_v, 29, 0, _ck(_v, 30, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 22).model.errors)) == 'required')) && (!core_es5["ɵnov"](_v, 22).model.pristine || core_es5["ɵnov"](_v, 4).submitted));
        _ck(_v, 29, 0, currVal_25);
        var currVal_26 = ((!_co.block && (core_es5["ɵunv"](_v, 33, 0, _ck(_v, 34, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 22).model.errors)) == 'pattern')) && (!core_es5["ɵnov"](_v, 22).model.pristine || core_es5["ɵnov"](_v, 4).submitted));
        _ck(_v, 33, 0, currVal_26);
        var currVal_36 = '';
        _ck(_v, 47, 0, currVal_36);
        var currVal_37 = '[a-z A-Z]*';
        _ck(_v, 48, 0, currVal_37);
        var currVal_38 = 'lastName';
        var currVal_39 = 'Last Name';
        var currVal_40 = _co.block;
        var currVal_41 = core_es5["ɵnov"](_v, 4);
        _ck(_v, 50, 0, currVal_38, currVal_39, currVal_40, currVal_41);
        var currVal_42 = 'lastName';
        var currVal_43 = _co.block;
        var currVal_44 = _co.model.LastName;
        _ck(_v, 52, 0, currVal_42, currVal_43, currVal_44);
        var currVal_45 = ((!_co.block && (core_es5["ɵunv"](_v, 57, 0, _ck(_v, 58, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 50).model.errors)) == 'required')) && (!core_es5["ɵnov"](_v, 50).model.pristine || core_es5["ɵnov"](_v, 4).submitted));
        _ck(_v, 57, 0, currVal_45);
        var currVal_46 = ((!_co.block && (core_es5["ɵunv"](_v, 61, 0, _ck(_v, 62, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 50).model.errors)) == 'pattern')) && (!core_es5["ɵnov"](_v, 50).model.pristine || core_es5["ɵnov"](_v, 4).submitted));
        _ck(_v, 61, 0, currVal_46);
        var currVal_55 = '';
        _ck(_v, 75, 0, currVal_55);
        var currVal_56 = '';
        _ck(_v, 76, 0, currVal_56);
        var currVal_57 = '';
        _ck(_v, 77, 0, currVal_57);
        var currVal_58 = 'email';
        var currVal_59 = 'email';
        var currVal_60 = 'Email';
        var currVal_61 = _co.block;
        var currVal_62 = core_es5["ɵnov"](_v, 4);
        _ck(_v, 79, 0, currVal_58, currVal_59, currVal_60, currVal_61, currVal_62);
        var currVal_63 = 'email';
        var currVal_64 = _co.block;
        var currVal_65 = _co.model.Email;
        _ck(_v, 81, 0, currVal_63, currVal_64, currVal_65);
        var currVal_66 = ((!_co.block && (core_es5["ɵunv"](_v, 86, 0, _ck(_v, 87, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 79).model.errors)) == 'required')) && (!core_es5["ɵnov"](_v, 79).model.pristine || core_es5["ɵnov"](_v, 4).submitted));
        _ck(_v, 86, 0, currVal_66);
        var currVal_67 = ((!_co.block && (core_es5["ɵunv"](_v, 90, 0, _ck(_v, 91, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 79).model.errors)) == 'email')) && (!core_es5["ɵnov"](_v, 79).model.pristine || core_es5["ɵnov"](_v, 4).submitted));
        _ck(_v, 90, 0, currVal_67);
        var currVal_77 = '';
        _ck(_v, 104, 0, currVal_77);
        var currVal_78 = '6';
        _ck(_v, 105, 0, currVal_78);
        var currVal_79 = 'password';
        var currVal_80 = 'password';
        var currVal_81 = 'Password';
        var currVal_82 = core_es5["ɵnov"](_v, 4);
        _ck(_v, 107, 0, currVal_79, currVal_80, currVal_81, currVal_82);
        var currVal_83 = 'password';
        var currVal_84 = _co.model.Password;
        _ck(_v, 109, 0, currVal_83, currVal_84);
        var currVal_85 = ((core_es5["ɵunv"](_v, 114, 0, _ck(_v, 115, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 107).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 107).model.pristine || core_es5["ɵnov"](_v, 4).submitted));
        _ck(_v, 114, 0, currVal_85);
        var currVal_86 = ((core_es5["ɵunv"](_v, 118, 0, _ck(_v, 119, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 107).model.errors)) == 'minlength') && (!core_es5["ɵnov"](_v, 107).model.pristine || core_es5["ɵnov"](_v, 4).submitted));
        _ck(_v, 118, 0, currVal_86);
        var currVal_95 = '';
        _ck(_v, 132, 0, currVal_95);
        var currVal_96 = core_es5["ɵnov"](_v, 107);
        _ck(_v, 133, 0, currVal_96);
        var currVal_97 = 'password';
        var currVal_98 = 'confirmPassword';
        var currVal_99 = 'Confirm Password';
        var currVal_100 = core_es5["ɵnov"](_v, 4);
        _ck(_v, 135, 0, currVal_97, currVal_98, currVal_99, currVal_100);
        var currVal_101 = 'confirmPassword';
        var currVal_102 = _co.model.ConfirmPassword;
        _ck(_v, 137, 0, currVal_101, currVal_102);
        var currVal_103 = ((core_es5["ɵunv"](_v, 142, 0, _ck(_v, 143, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 135).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 135).model.pristine || core_es5["ɵnov"](_v, 4).submitted));
        _ck(_v, 142, 0, currVal_103);
        var currVal_104 = ((core_es5["ɵunv"](_v, 146, 0, _ck(_v, 147, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 135).model.errors)) == 'validateEqual') && (!core_es5["ɵnov"](_v, 135).model.pristine || core_es5["ɵnov"](_v, 4).submitted));
        _ck(_v, 146, 0, currVal_104);
        var currVal_113 = '';
        _ck(_v, 152, 0, currVal_113);
        var currVal_114 = '';
        _ck(_v, 153, 0, currVal_114);
        var currVal_115 = 'agree';
        var currVal_116 = core_es5["ɵnov"](_v, 4);
        _ck(_v, 155, 0, currVal_115, currVal_116);
        var currVal_117 = 'agree';
        var currVal_118 = _co.model.TermsAgree;
        _ck(_v, 157, 0, currVal_117, currVal_118);
        var currVal_119 = ((core_es5["ɵunv"](_v, 167, 0, _ck(_v, 168, 0, core_es5["ɵnov"](_v.parent, 0), core_es5["ɵnov"](_v, 155).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 155).model.pristine || core_es5["ɵnov"](_v, 4).submitted));
        _ck(_v, 167, 0, currVal_119);
        var currVal_120 = _co.errors;
        _ck(_v, 174, 0, currVal_120);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵnov"](_v, 6).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 6).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 6).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 6).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 6).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 6).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 6).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (core_es5["ɵnov"](_v, 19).required ? '' : null);
        var currVal_8 = (core_es5["ɵnov"](_v, 20).pattern ? core_es5["ɵnov"](_v, 20).pattern : null);
        var currVal_9 = core_es5["ɵnov"](_v, 26).ngClassUntouched;
        var currVal_10 = core_es5["ɵnov"](_v, 26).ngClassTouched;
        var currVal_11 = core_es5["ɵnov"](_v, 26).ngClassPristine;
        var currVal_12 = core_es5["ɵnov"](_v, 26).ngClassDirty;
        var currVal_13 = core_es5["ɵnov"](_v, 26).ngClassValid;
        var currVal_14 = core_es5["ɵnov"](_v, 26).ngClassInvalid;
        var currVal_15 = core_es5["ɵnov"](_v, 26).ngClassPending;
        _ck(_v, 18, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15);
        var currVal_27 = (core_es5["ɵnov"](_v, 47).required ? '' : null);
        var currVal_28 = (core_es5["ɵnov"](_v, 48).pattern ? core_es5["ɵnov"](_v, 48).pattern : null);
        var currVal_29 = core_es5["ɵnov"](_v, 54).ngClassUntouched;
        var currVal_30 = core_es5["ɵnov"](_v, 54).ngClassTouched;
        var currVal_31 = core_es5["ɵnov"](_v, 54).ngClassPristine;
        var currVal_32 = core_es5["ɵnov"](_v, 54).ngClassDirty;
        var currVal_33 = core_es5["ɵnov"](_v, 54).ngClassValid;
        var currVal_34 = core_es5["ɵnov"](_v, 54).ngClassInvalid;
        var currVal_35 = core_es5["ɵnov"](_v, 54).ngClassPending;
        _ck(_v, 46, 0, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35);
        var currVal_47 = (core_es5["ɵnov"](_v, 75).required ? '' : null);
        var currVal_48 = core_es5["ɵnov"](_v, 83).ngClassUntouched;
        var currVal_49 = core_es5["ɵnov"](_v, 83).ngClassTouched;
        var currVal_50 = core_es5["ɵnov"](_v, 83).ngClassPristine;
        var currVal_51 = core_es5["ɵnov"](_v, 83).ngClassDirty;
        var currVal_52 = core_es5["ɵnov"](_v, 83).ngClassValid;
        var currVal_53 = core_es5["ɵnov"](_v, 83).ngClassInvalid;
        var currVal_54 = core_es5["ɵnov"](_v, 83).ngClassPending;
        _ck(_v, 74, 0, currVal_47, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54);
        var currVal_68 = (core_es5["ɵnov"](_v, 104).required ? '' : null);
        var currVal_69 = (core_es5["ɵnov"](_v, 105).minlength ? core_es5["ɵnov"](_v, 105).minlength : null);
        var currVal_70 = core_es5["ɵnov"](_v, 111).ngClassUntouched;
        var currVal_71 = core_es5["ɵnov"](_v, 111).ngClassTouched;
        var currVal_72 = core_es5["ɵnov"](_v, 111).ngClassPristine;
        var currVal_73 = core_es5["ɵnov"](_v, 111).ngClassDirty;
        var currVal_74 = core_es5["ɵnov"](_v, 111).ngClassValid;
        var currVal_75 = core_es5["ɵnov"](_v, 111).ngClassInvalid;
        var currVal_76 = core_es5["ɵnov"](_v, 111).ngClassPending;
        _ck(_v, 103, 0, currVal_68, currVal_69, currVal_70, currVal_71, currVal_72, currVal_73, currVal_74, currVal_75, currVal_76);
        var currVal_87 = (core_es5["ɵnov"](_v, 132).required ? '' : null);
        var currVal_88 = core_es5["ɵnov"](_v, 139).ngClassUntouched;
        var currVal_89 = core_es5["ɵnov"](_v, 139).ngClassTouched;
        var currVal_90 = core_es5["ɵnov"](_v, 139).ngClassPristine;
        var currVal_91 = core_es5["ɵnov"](_v, 139).ngClassDirty;
        var currVal_92 = core_es5["ɵnov"](_v, 139).ngClassValid;
        var currVal_93 = core_es5["ɵnov"](_v, 139).ngClassInvalid;
        var currVal_94 = core_es5["ɵnov"](_v, 139).ngClassPending;
        _ck(_v, 131, 0, currVal_87, currVal_88, currVal_89, currVal_90, currVal_91, currVal_92, currVal_93, currVal_94);
        var currVal_105 = (core_es5["ɵnov"](_v, 152).required ? '' : null);
        var currVal_106 = core_es5["ɵnov"](_v, 159).ngClassUntouched;
        var currVal_107 = core_es5["ɵnov"](_v, 159).ngClassTouched;
        var currVal_108 = core_es5["ɵnov"](_v, 159).ngClassPristine;
        var currVal_109 = core_es5["ɵnov"](_v, 159).ngClassDirty;
        var currVal_110 = core_es5["ɵnov"](_v, 159).ngClassValid;
        var currVal_111 = core_es5["ɵnov"](_v, 159).ngClassInvalid;
        var currVal_112 = core_es5["ɵnov"](_v, 159).ngClassPending;
        _ck(_v, 151, 0, currVal_105, currVal_106, currVal_107, currVal_108, currVal_109, currVal_110, currVal_111, currVal_112);
        var currVal_121 = (_co.processing || (core_es5["ɵnov"](_v, 4).submitted && !core_es5["ɵnov"](_v, 4).valid));
        _ck(_v, 179, 0, currVal_121);
    });
}
function View_RegisterComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, FirstKeyPipe, []), (_l()(), core_es5["ɵeld"](0, null, null, 84, 'div', [['class', 'full-page register-page'], ['filter-color',
                'black']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 79, 'div', [['class', 'container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 76, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 73, 'div', [['class',
                'col-md-10 col-md-offset-1']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 70, 'div', [['class', 'card card-signup']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h2', [['class', 'card-title text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Register'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 64, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 58, 'div', [['class', 'col-md-5 col-md-offset-1']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 55, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 16, 'div', [['class', 'info info-horizontal']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'icon icon-rose']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['timeline'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'info-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Marketshare Data'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' We package data from different channels to get valuable insight on marketshare ownership. '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'div', [['class', 'info info-horizontal']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'icon icon-primary']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['code'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'info-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Predictive Analytics'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' We combine user data into business intelligence reports to help clients determine gaps in market and explore opportunities in product development. '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'div', [['class', 'info info-horizontal']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'icon icon-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['group'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'info-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Pricing Intelligence'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' We integrate with key data sources to gather competitive data and statistics, and combine them with market intelligence to provide recommendation in optimal pricing. '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_RegisterComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'full-page-background']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](16777216, null, null, 865, 'div', [['aria-hidden',
                'true'], ['aria-labelledby', 'termsTitle'], ['bsModal', ''], ['class', 'modal fade'],
            ['role', 'dialog'], ['tabindex', '-1']], null, [[null, 'click'],
            [null, 'keydown.esc']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 88).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('keydown.esc' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 88).onEsc() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4341760, [['termsConditions', 4]], 0, modal_component["a" /* ModalDirective */], [core_es5["ElementRef"], core_es5["ViewContainerRef"], core_es5["Renderer"], component_loader_factory["a" /* ComponentLoaderFactory */]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 861, 'div', [['class', 'modal-dialog modal-lg'],
                ['role', 'document']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 858, 'div', [['class', 'modal-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class',
                'modal-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['aria-label', 'Close'], ['class',
                'close'], ['type', 'button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 88).hide() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['aria-hidden', 'true']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['×'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'modal-title'], ['id', 'termsTitle']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Constant Retail Click-Through Agreement'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 837, 'div', [['class', 'modal-body']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'p', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['By clicking “I accept and agree” below, you (the “'])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Client'])), (_l()(), core_es5["ɵted"](null, ['”) agree to be bound by, adhere to and perform the terms below and Constant Retail shall likewise perform its respective obligations below, subject to the following addendum of terms and conditions (the “'])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Terms and Conditions'])), (_l()(), core_es5["ɵted"](null, ['”) which are incorporated herein by reference and made a part of this agreement.  Capitalized words and phrases are further defined in '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 10'])), (_l()(), core_es5["ɵted"](null, [' of the Terms and Conditions.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'strong', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Designated URLs'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Client is the registered owner of the URLs provided to Constant Retail for the Hosted Site.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'strong', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Selection of Brands'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Client has or shall select the brands that Client would like to offer on the Hosted Site, as an authorized and approved retailer for such brands.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Client understands that fees and charges for services provided by Constant Retail to the Client are based on the number of brands selected.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'strong', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Generation of the Hosted Site '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['In accordance with the selections made or to be made by the Client, the Hosted Site shall be generated by the Constant Retail Platform, utilizing Constant Retail’s proprietary templates, designs and interfaces.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['The Hosted Site shall bear the phrase “Powered by Constant Retail” or such other indication of the generation of the Hosted Site by the Constant Retail Platform.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Constant Retail shall provide updates on the products being offered on the Hosted Site.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'strong', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Constant Retail Responsibilities; Client Responsibilities'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Constant Retail hosts the Hosted Site as a third-party service provider, with no responsibility otherwise for the e-commerce business operated through the Hosted Site.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Such business is the Client’s sole responsibility, as the owner and proprietor of such e-commerce business and, other than hosting the Hosted Site, Client shall be responsible for all other aspect of such business, including the fulfilment of orders, administration of returns and the collection and remittance of sales taxes.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'strong', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Fees and Charges'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Fees and charges to the Client are based on the number of brands selected and a percentage of revenue from sales through the Hosted Site and as set forth in further detail in the current fee schedule which may be viewed by clicking [here]'])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '#_ftn1'], ['name',
                '_ftnref1']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['[1]'])), (_l()(), core_es5["ɵted"](null, ['.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Valid credit card information must be provided and fees and charges for services provided by Constant Retail shall be charged to such credit card account.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Fees and charges are subject to change at Constant Retail’s discretion.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Refunds attributable to returns of merchandise shall be made at such time Client has fully processed the return and returned the end-customer’s payment for the merchandise.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'strong', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Reporting'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Client will be able to generate reports on usage and sales activity on the Hosted Site.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'strong', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Protection of End-Customer Information'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Constant Retail will not use or disclose any personally identifiable information, such as names and contact information, regarding the Client’s end-customers making purchases through the Hosted Site.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'strong', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Privacy Policy for Hosted Site'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Client must generate and adopt for the Hosted Site a privacy policy and include the following statement in such policy:'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 2, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“Our site is hosted and maintained by a third-party service provider known as “Constant Retail”.  Notwithstanding any other provisions of this privacy policy, in connection with the provision of such services, Constant Retail may collect and use for any purpose data and information derived from our site and your usage thereof.  However, Constant Retail will not make use of your name, email address, billing and ship-to addresses, phone number(s), and the credit card, bank account or other payment information provided by you.”'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'strong', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Addendum – Terms and Conditions'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 680, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 677, 'ol', [['class',
                'nested-numeric-list']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 50, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Hosted Site. '])), (_l()(), core_es5["ɵeld"](0, null, null, 47, 'ol', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['General'])), (_l()(), core_es5["ɵted"](null, ['. Client is hereby engaging Constant Retail to generate the Hosted Site through the Constant Retail Platform and based upon the input provided by the Client in the Enrollment Process as well as to host and maintain such site in accordance with the provisions of '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 1.4'])), (_l()(), core_es5["ɵted"](null, ['  Client agrees, understands and acknowledges that at all times: (a) generation of the Hosted Site and the design, interface, appearance and other visual and functional features of the Hosted Site are to be in accordance with Constant Retail’s established templates, looks, views and format (which Constant Retail may, in its sole discretion, update and revise from time to time), and (b) the Hosted Site shall bear the phrase “Powered by Constant Retail” or such other indication of the generation and/or hosting of the Hosted Site by Constant Retail and the Constant Retail Platform.  Constant Retail, at its election, may, but is not obligated to and does not guarantee that it will, work with a Client, upon request to customize its Hosted Site through the addition or modification of any design or function features of the Hosted Site as may be agreed upon between Client and Constant Retail, and for additional charges, as may be agreed upon, for such work.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Selected Brands'])), (_l()(), core_es5["ɵted"](null, ['. Constant Retail shall make available the Selected Brands through the Hosted Site whose underlying products Client may make available and offer for sale through the Hosted Site, '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['provided'])), (_l()(), core_es5["ɵted"](null, [' that in the event the Client has selected Additional Brands to be offered through the Hosted Site, the inclusion of such Additional Brands on the Hosted Site shall be subject to Constant Retail first obtaining authorization and approval, as well as requisite technical support, from the Vendors for such requested Additional Brands required to include such Additional Brands in the Hosted Site, with  additional fees therefor being payable by the Client to Constant Retail as provided for in the Fee Addendum.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Enrollment Process'])), (_l()(), core_es5["ɵted"](null, ['. The Client represents and warrants to Constant Retail that all of the following are true and correct and shall remain so during the Term: (a) the Client is an authorized retailer, in good standing, for the Selected Brands, and possess all approvals, licenses, consents and permits required to sell and market the products related to the Selected Brands on the Hosted Site; (b) with respect to any content or information, whether in the form of images, text, specifications, graphics, video or audio recordings or any other medium whatsoever, used in the Hosted Site and that is not Constant Retail Content, whether provided by the Client to Constant Retail or obtained from a third-party source at the direction of the Client, the Client has all rights, consent, permission and authorization to use such content or information on the Hosted Site, whether as the owner thereof, valid licensee thereof, or otherwise; (c) the Client is the valid, authorized, record holder of the credit card account information provided during the Enrollment Process and that such account possess sufficient lines of available credit to cover the costs to the Client of the services provided hereunder; (d) the Applicable Sales Tax Rates have been determined through advice and consultation with tax consultants or experts or a certified public accountant; and (e) the Designated URLS are registered in the name of the Client or one of its Affiliates and the Client has all authorization and right to use the Designated URLs.  Client further represents and warrants that all information otherwise provided to Constant Retail by the Client in connection with the Enrollment Process is true and correct and shall remain so during the Term.  Any individual or entity acting on behalf of the Client in accepting these Terms and Conditions as part of the Enrollment Process represents and warrants that he, she or it has the right to act on behalf of the Client and to legally bind Client to these Terms and Conditions and Constant Retail may rely on such representation and warranty for all purposes.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Hosting and Maintenance of the Hosted Site'])),
        (_l()(), core_es5["ɵted"](null, ['. Constant Retail agrees to take commercially reasonable efforts to host and maintain the Hosted Site as provided for in these Terms and Conditions, including, without limitation, taking commercially reasonable efforts to: (a) operate the Hosted Site at the Designated URLs; (b) make the Hosted Site accessible to all visitors to the Hosted Site 24 hours a day, seven days a week, except for such times during which maintenance and repairs are scheduled for the Hosted Site; and (c) ensure that Customer Information is protected in accordance with the terms of '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 5.1'])), (_l()(), core_es5["ɵted"](null, [' of these Terms and Conditions and is kept separate from, and not used for or with other e-commerce sites developed and/or hosted by Constant Retail.  Client agrees, understands and acknowledges: (x) that the engagement contemplated hereunder is non-exclusive in nature and that Constant Retail may, without any obligation or liability to Client, engage with any third-party whatsoever, either in connection with the provision of similar services provided to the Client or otherwise; (y) that such third parties may be competitors of the Client or Persons with interests adverse to or in conflict with those of the Client; and (z) that nothing herein shall be construed, deemed or interpreted as a commitment on the part of Constant Retail to devote any time, resources, or efforts to the Client and the Hosted Site to a greater or lesser extent than what Constant Retail devotes to any third party receiving the same or substantially similar services as those contemplated in these Terms and Conditions or being serviced otherwise.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Operation of Client’s E-Commerce Business'])),
        (_l()(), core_es5["ɵted"](null, ['. The parties agree, understand and acknowledge that the Hosted Site is being hosted and maintained by Constant Retail for operation by the Client of its e-commerce retail business through the Hosted Site and, for the avoidance of doubt, all responsibilities and liabilities for and regarding the operation, management and administration of such business are the Client’s, and not that of either Constant Retail or any of its Affiliates, and in no event shall either Constant Retail or any of its Affiliates have any liability or responsibility whatsoever to any Customers or any Vendors, including without limitation with respect to the fulfillment of orders or for refunds or credits upon the return of any Merchandise, both of which are solely the responsibility of the Client.  Furthermore, in connection with fulfilment of Merchandise orders, Client shall be responsible for arranging shipping and freight services for delivery of such Merchandise to the applicable Customer, '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['provided'])), (_l()(), core_es5["ɵted"](null, [' that Client may elect to have such shipping requirements within the continental United States of America (i.e. the lower 48 states of the United States of America and not Alaska and Hawaii) fulfilled through those services offered by Constant Retail under “Freight Club”, as offered, and as may be elected by the Client, during the Enrollment Process and subject to acceptance of the applicable terms and conditions for purchase of shipping and freight services through “Freight Club”.   While Constant Retail hosts the Hosted Site, the Client is the seller of all Merchandise sold through the Hosted and, as such, all revenues from the sale of Merchandise through the Hosted Site shall be deemed for all purposes Client revenues.  All proceeds from the sale of Merchandise through the Hosted Site on the Hosted Site will be collected and processed by the Client and the Client will be responsible for (a) establishing the selling price for such Merchandise, '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['(b) determining the Applicable Sales Tax Rates and correctly entering them during the Enrollment Process for incorporation into the payment process of the Hosted Site by the Constant Retail Platform; '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['and (c) collecting and paying all '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['federal and state '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['sales, use, transfer, or similar taxes payable to any governmental authority on any sale of Merchandise through the Hosted Site as well as on any other charge made in connection with such sale based on the Applicable Sales Tax Rates'])),
        (_l()(), core_es5["ɵted"](null, ['. '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 55, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Marketing and Advertising Services. '])), (_l()(), core_es5["ɵeld"](0, null, null, 52, 'ol', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 12, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Marketing Services'])), (_l()(), core_es5["ɵted"](null, ['. In the event the Client has elected to receive marketing services during the Enrollment Process, Constant Retail agrees to provide to Client such services as described in this '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 2.1'])), (_l()(), core_es5["ɵted"](null, ['. Constant Retail shall designate and make available for Client during ordinary business hours a marketing manager to assist and consult with the Client in the provision of such services.  Constant Retail shall cause such marketing manager to work with the Client to identify those marketing channels (such as Google, Microsoft-Bing, Shopping.com, and Nextag.com) through whom Client desires Constant Retail to market the Hosted Site and, upon approval by Constant Retail of those marketing channels selected by Client, marketing accounts with such marketing channels shall be established by the Client.  Through such marketing accounts, Constant Retail shall market the Hosted Site and the products being offered on the Hosted Site by purchasing search words on search engines and listings on comparison shopping engines which, in Constant Retail’s sole discretion, may generate Customers or direct users towards the Hosted Site, with such costs related to such purchases to be covered by the Client.  Monthly Fees payable by Client and costs and charges to be covered by the Client for the services described in this '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 2.1'])), (_l()(), core_es5["ɵted"](null, [' shall be in accordance with Constant Retail’s current rates in effect for such services as set forth in the Fee Addendum and payable as further described in '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 4'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Advertising Services'])), (_l()(), core_es5["ɵted"](null, ['. In the event the Client has elected to receive advertising services during the Enrollment Process, Constant Retail agrees to provide to Client such services as described in this '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 2.2'])), (_l()(), core_es5["ɵted"](null, ['.  Client hereby authorizes and instructs Constant Retail to purchase and place, on behalf of the Client, advertising for the Hosted Site, along with the products being offered on the Hosted Site, on such other websites as Constant Retail may select in its sole discretion.  Costs related to such purchases are to be covered by the Client.  All advertising services agreements and other similar contracts to be entered into in connection with the placement of such advertising shall be with Client, on the one hand (and not, for the avoidance of doubt, Constant Retail or any of its Affiliates), and the applicable advertising service provider, on the other hand.  Constant Retail shall ensure that all such advertising so purchased shall be capable of directing any viewer thereof online to the Hosted Site through clicking of an embedded hyperlink.   Monthly Fees payable by Client and costs and charges to be covered by the Client for the services described in this '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 2.2'])), (_l()(), core_es5["ɵted"](null, [' shall be in accordance with Constant Retail’s current rates in effect for such services as set forth in the Fee Addendum and payable as further described in '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 4'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['General Statement Regarding Marketing and Advertising'])), (_l()(), core_es5["ɵted"](null, ['. Except for such services pursuant to either '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 2.1'])),
        (_l()(), core_es5["ɵted"](null, [' or '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 2.2'])), (_l()(),
            core_es5["ɵted"](null, [' above as may have been elected for by the Client, the Client shall otherwise be responsible in all respects for all advertising, promotion and marketing of the Hosted Site, the Merchandise for sale on the Hosted Site and the Selected Brands available on the Hosted Site, as well as costs thereof (which costs shall not, for the avoidance of doubt, be deemed to reduce Net Sales Revenue).  The Client hereby assumes all risk of losses or costs from ineffectiveness of any advertising, promotion and marketing, whether obtained through either '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 2.1'])), (_l()(), core_es5["ɵted"](null, [' or '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 2.2'])), (_l()(), core_es5["ɵted"](null, [' above or otherwise, and waives and releases any and all claims it may have against Constant Retail with respect thereto including without limitation for the number of visitors to the Hosted Site and value of resulting sales.  The Client acknowledges, agrees and understands that at no time, including in the event it elects services under either '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 2.1'])), (_l()(), core_es5["ɵted"](null, [' or '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 2.2'])), (_l()(), core_es5["ɵted"](null, [' above, shall Client have any entitlement, license, or right to use any of the Constant Retail Intellectual Property, regarding search terms or other marketing knowledge utilized to attract visitors to the Hosted Site or any other websites hosted or operated by Constant Retail or any of its Affiliates. '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Reporting; Data Feeds. '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 14, 'ol', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Reporting'])), (_l()(), core_es5["ɵted"](null, ['. Constant Retail will provide the Client with the ability to access reports on the performance of the e-commerce business of the Hosted Site which reports may include the following information: (a) the number of visitors to the Hosted Site, as measured by Constant Retail; and (b) sales data for the Hosted Site, as measured by Constant Retail, consisting of: (i) the aggregate amount of sales in dollars of Merchandise for such month and a breakdown of such sales into a list of all Merchandise shipped, along with the name, quantity, price, category and item numbers for such Merchandise, (ii) a list of all Customer returns, chargebacks and refunds received or accepted for sales of Merchandise through the Hosted Site, (iii) a list of all Customers that have placed orders for Merchandise through the Hosted Site, including their respective names and the bill to and ship to addresses for such Customers, and (iv) data regarding the sales, use, transfer, or similar taxes collected and remitted by the Client through the Hosted Site based on the Applicable Sales Tax Rates for sales of Merchandise made.  The time period over which the reports referenced in this '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 3.1'])), (_l()(), core_es5["ɵted"](null, [' may be generated shall be established by Constant Retail.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Data Feeds'])), (_l()(), core_es5["ɵted"](null, ['. Constant Retail will periodically provide data feeds to the Client in order to update information concerning Merchandise then available for sale through the Hosted Site.  Such information may include product names, product descriptions, stock keeping unit or “SKU” numbers, product prices, shipping costs, availability, other descriptive attributes, and/or links to products within the Hosted Site.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 61, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Payment Terms. '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 58, 'ol', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Fees'])), (_l()(), core_es5["ɵted"](null, ['. Based on the selections made by the Client in connection with the Enrollment Process, the Client shall pay to Constant Retail the applicable charge in U.S. dollars as set forth on the then-current Fee Addendum, as calculated by Constant Retail and in the manner provided for in this '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 4'])), (_l()(), core_es5["ɵted"](null, [' of these Terms and Conditions.  The current Fee Addendum in effect can be viewed [here]'])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '#_ftn2'], ['name',
                '_ftnref2']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['[2]'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'strong', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['.'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Payment'])), (_l()(), core_es5["ɵted"](null, ['. Valid credit card account information as well as pre-authorization of the charges for payment for services hereunder are required from the Client as part of the Enrollment Process and all payments for services provided by Constant Retail shall be by such pre-authorized charges to such Client’s credit card account provided as part of the Enrollment Process (or any updated account).  Monthly Fees shall be charged on the first business day of every month during the Term, prior to service for such month (with such Monthly Fee being pro-rated for any partial initial month in the Term).  Where any part of the fees payable hereunder are based on a percentage of Net Sales Revenue as provided for in the Fee Addendum, such fee shall be charged upon confirmation by Client of completion of the applicable transaction generating such Net Sales Revenues and as calculated by the Constant Retail Platform.  Other than any Monthly Fee associated with any of the services provided under '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 2'])), (_l()(), core_es5["ɵted"](null, [' of these Terms and Conditions (which Monthly Fee shall be charged as provided for in the second sentence of this '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 4.2'])), (_l()(), core_es5["ɵted"](null, ['), the costs and charges payable by the Client associated with any services elected pursuant to '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 2'])), (_l()(), core_es5["ɵted"](null, [' above shall be charged at the time such costs and charges are incurred by Constant Retail.  Regardless of whether or not Client has a valid dispute of any Monthly Fee, in the event of any non-payment when due by the Client of any fees payable to Constant Retail due to a charge on the Client’s credit card being declined and the Client, following notification, failing to update such payment information with a valid credit card, for five business days or longer, Constant Retail shall be entitled to cease to host and to provide all related services to the Hosted Site and shall have no liability whatsoever to the Client related to any interruption of the Client’s e-commerce business as result of such cessation or other matters related thereto.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Returns of Merchandise'])), (_l()(), core_es5["ɵted"](null, ['.  In the event that Client’s fees are calculated based on a percentage of Net Sales Revenue, Client shall be entitled to a refund or credit based on returns of Merchandise by Customers, the sale of which factored into the calculation of Net Sales Revenue, as provided for in this '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 4.3'])), (_l()(), core_es5["ɵted"](null, ['.  For the avoidance of doubt, Client, as established in '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 1.5'])), (_l()(), core_es5["ɵted"](null, [' above, shall be responsible in all respects for processing and completing any return of any Merchandise by a Customer, including, without limitation, making any refund to the Customer for such return, which are to be processed through the Hosted Site and which Constant Retail, as host of the Hosted Site pursuant to these Terms and Conditions, shall be entitled to track and monitor.  Upon Constant Retail’s confirmation through the Hosted Site and the Constant Retail Platform that such a refund to a Customer has been completed and all funds related thereto have been remitted to the Customer or the Customer’s account, Constant Retail shall calculate the amount of any fees previously charged and paid to Constant Retail by the Client based on the amount so refunded and such portion of the fee so determined by Constant Retail shall represent the amount of refund or credit to which the Client is entitled.  At the election of Constant Retail in its sole discretion, such amount may either be applied against the outstanding amount of any fees payable to Constant Retail by the Client or paid directly to Client.  Client’s entitlement to the foregoing refund or credit shall be subject to Client providing Constant Retail with any cooperation, assistance, or information reasonably requested by Constant Retail in connection with calculating the amount of any refund or credit owing to Client and based on a return of Merchandise by a Customer.   '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Payment Reporting'])), (_l()(), core_es5["ɵted"](null, ['. Immediately following the end of each month in the Term, upon the request of the Client, Constant Retail shall deliver a report to the Client of the applicable fees charged for such month.      '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Client Accounts'])), (_l()(), core_es5["ɵted"](null, ['. The foregoing provisions of this '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 4'])),
        (_l()(), core_es5["ɵted"](null, [' regarding payment for the services provided hereunder are intended to apply to all Persons agreeing to these Terms and Conditions, including the Client.  However, certain clients may, by specific written agreement with Constant Retail separate from these Terms and Conditions, establish an account for payment, subject to payment terms different from those set forth in this '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 4'])), (_l()(), core_es5["ɵted"](null, [', including without limitation the carrying of an outstanding balance for Monthly Fees, incurred but not overdue after the 30'])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'sup', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['th'])), (_l()(), core_es5["ɵted"](null, [' day of receipt of the invoice therefor.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 35, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Customer Information; Proprietary Rights; Privacy Policy. '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 32, 'ol', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Customer Information'])), (_l()(), core_es5["ɵted"](null, ['. Constant Retail shall not, and shall ensure that its Representatives do not, disclose to any third party or use for any other purpose other than for the performance of services contemplated under these Terms and Conditions any Customer Information and, except as permitted hereunder, shall in no way use, sell, transfer or otherwise exploit any Customer Information for any purpose without the express written consent of the Client.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Privacy Policy'])), (_l()(), core_es5["ɵted"](null, ['. Client shall develop and adopt a Privacy Policy and provide a copy of such Privacy Policy to Constant Retail for inclusion of such Privacy Policy by Constant Retail in the Hosted Site.  Any such Privacy Policy shall include the following statement regarding User Data: '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 2, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“Our site is hosted and maintained by a third-party service provider known as “Constant Retail”.  Notwithstanding any other provisions of this privacy policy, in connection with the provision of such services, Constant Retail may collect and use for any purpose data and information derived from our site and your usage thereof.  However, Constant Retail will not make use of your name, email address, billing and ship-to addresses, phone number(s), and the credit card, bank account or other payment information provided by you.”'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Client shall relay to Constant Retail any communications pertaining to Constant Retail received from any Customer in response to Client’s Privacy Policy.  Client represents and warrants that its Privacy Policy shall be in compliance at all times during the Term with applicable law and regulations. '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Proprietary Rights'])), (_l()(), core_es5["ɵted"](null, ['. At all times, Constant Retail and its Affiliates reserve all right, title and interest in and to the Constant Retail Intellectual Property and in no event shall any provision in these Terms and Conditions and the performance thereof, be deemed or construed as a transfer, assignment or license of any interest or right therein, whether to use any Constant Retail Intellectual Property or otherwise (except for the following sentence).  Constant Retail hereby grants to the Client, during the Term, a worldwide, non-transferable, non-sub licensable, fully paid license to use the Hosted Site solely for the purposes of operating the Client’s e-commerce business of selling to Customers products related to the Selected Brands.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Constant Retail Website Use Data'])), (_l()(),
            core_es5["ɵted"](null, ['. Certain data regarding the Client’s interaction with the Constant Retail Platform prior to the Enrollment Process is also governed by Constant Retail’s Privacy Policy, which is incorporated into these Terms and Conditions by reference and a copy of which is available at the following link: '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', 'http://www.constantretail.com/privacypolicy']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['constantretail.com/privacypolicy'])), (_l()(),
            core_es5["ɵted"](null, ['.'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 43, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Termination. '])), (_l()(), core_es5["ɵeld"](0, null, null, 40, 'ol', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Termination by the Client'])), (_l()(), core_es5["ɵted"](null, ['. Client shall be entitled to terminate these Terms and Conditions upon no less than 60 days’ prior written notice to Constant Retail.  '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Termination by Constant Retail'])), (_l()(), core_es5["ɵted"](null, ['. Constant Retail shall be entitled to terminate these Terms and Conditions upon no less than 60 days’ prior written notice to the Client. In addition, Constant Retail shall be entitled to terminate these Terms and Conditions immediately upon written notice to Client if Constant Retail is unable to fulfil payment of any fees through Client’s credit card pre-authorization, as provided for in the last sentence of '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 4.2'])), (_l()(), core_es5["ɵted"](null, ['.'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 24, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Effect of Termination'])), (_l()(), core_es5["ɵted"](null, ['. Upon termination of these Terms and Conditions, each Party in receipt, possession or control of the other Party’s intellectual or proprietary property, information and materials (including any confidential information) pursuant to these Terms and Conditions must return to the other Party (or at the other Party’s written request, destroy) such property, information and materials.  '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Sections 1.3'])), (_l()(), core_es5["ɵted"](null, [', '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['4'])), (_l()(), core_es5["ɵted"](null, [', '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['5'])), (_l()(),
            core_es5["ɵted"](null, [', '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['6'])), (_l()(), core_es5["ɵted"](null, [', '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['7'])), (_l()(), core_es5["ɵted"](null, [', '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['8'])), (_l()(), core_es5["ɵted"](null, [' and '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['9'])), (_l()(),
            core_es5["ɵted"](null, [' (together with all other provisions that reasonably may be interpreted as surviving termination or expiration of these Terms and Conditions) will survive the termination or expiration of these Terms and Conditions.  Notwithstanding the foregoing, termination of these Terms and Conditions shall not relieve either Party from its obligation to pay any amounts due to the other Party for any period prior to the effective date of termination.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 29, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Indemnification. '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 26, 'ol', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Indemnification by the Client'])), (_l()(), core_es5["ɵted"](null, ['. The Client will defend, indemnify and hold Constant Retail, its Affiliates, and their respective Representatives harmless from and against any and all Damages resulting from, arising out of or in connection with (whether a result of any third party claims, actions or demands or otherwise): (a) any claim, action, demand, or allegation that either the Hosted Site or any content or information on the Hosted Site, whether Constant Retail Intellectual Property or not,  is or may be infringing upon, or is the unauthorized use of any of, the Intellectual Property of any other Person; (b) any breach by Client of any representation and warranty contained herein, including without limitation any of those in '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 1.3'])), (_l()(), core_es5["ɵted"](null, [' or covenant, obligation or agreement to be performed by Client hereunder; (c) any sales, use, transfer or similar tax payable to any governmental authority, whether federal, state, municipal or local, on any sale of Merchandise through the Hosted Site as well as on any other charge made in connection with such sale; or (d) the design, manufacture or sale of any Merchandise or other products sold or offered through the Hosted Site.  In furtherance and not in limitation of the foregoing, the Client shall defend, indemnify and hold harmless Constant Retail from and against any and all Damages resulting from any actual or threatened tort claims or product liability claims relating to Merchandise or other products sold or offered through the Hosted Site.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Procedures for Indemnification'])), (_l()(), core_es5["ɵted"](null, ['.  Constant Retail will promptly notify Client of any claim subject to '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 7.1'])), (_l()(), core_es5["ɵted"](null, [' above, but failure to promptly notify Client will only affect Client’s obligations under '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 7.1'])), (_l()(), core_es5["ɵted"](null, [' to the extent that such failure materially prejudices Client’s ability to defend the claim. Client may: (a) use counsel of its own choosing to defend against any claim, subject first to Constant Retail’s written consent and Client’s written acknowledgement of its liability for its obligations under '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 7.1'])), (_l()(), core_es5["ɵted"](null, [' with respect to such claim; and (b) settle the claim as the Client may deem appropriate, '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['provided'])), (_l()(), core_es5["ɵted"](null, [' that Client obtain Constant Retail’s prior written consent before entering into any such settlement.  Constant Retail may also assume control of the defense and settlement of any such claim at any time, with counsel of its choosing.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 27, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Disclaimers; Limitations on Liability. '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 24, 'ol', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Disclaimer of Warranties'])), (_l()(), core_es5["ɵted"](null, ['. EXCEPT AS OTHERWISE EXPRESSLY SET FORTH IN THESE TERMS AND CONDITIONS, NEITHER PARTY MAKES, AND EACH PARTY HEREBY WAIVES AND DISCLAIMS, ANY REPRESENTATIONS OR WARRANTIES REGARDING THE TRANSACTIONS CONTEMPLATED HEREBY, INCLUDING ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR NON-INFRINGEMENT OR IMPLIED WARRANTIES ARISING OUT OF COURSE OF DEALING, COURSE OF PERFORMANCE OR USAGE OF TRADE.  WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, EACH PARTY SPECIFICALLY DISCLAIMS ANY REPRESENTATION OR WARRANTY REGARDING (A) THE AMOUNT OF SALES REVENUES THAT MAY OCCUR DURING THE TERM, AND (B) ANY ECONOMIC OR OTHER BENEFIT THAT IT MIGHT OBTAIN THROUGH ENTRANCE INTO THESE TERMS AND CONDITIONS (OTHER THAN THE SPECIFIC SUMS TO BE PAID PURSUANT TO THESE TERMS AND CONDITIONS).'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Compliance with Laws'])), (_l()(), core_es5["ɵted"](null, ['. In its performance of these Terms and Conditions, each Party will comply in all material respects with all applicable laws, regulations, orders and other requirements, now or hereafter in effect, of governmental authorities having jurisdiction.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Limitation of Liability'])), (_l()(), core_es5["ɵted"](null, ['. NEITHER PARTY WILL BE LIABLE (IN TORT (INCLUDING NEGLIGENCE), CONTRACT OR OTHERWISE) FOR ANY INDIRECT, CONSEQUENTIAL, PUNITIVE OR SPECIAL DAMAGES (INCLUDING LOST BUSINESS, REVENUE OR DATA) ARISING OUT OF OR IN CONNECTION WITH THESE TERMS AND CONDITIONS (INCLUDING ANY BREACH HEREOF), EVEN IF SUCH PARTY HAS BEEN ADVISED OF THE POSSIBILITY THEREOF.  THE MAXIMUM AGGREGATE LIABILITY OF EACH PARTY UNDER ANY THEORY, INCLUDING, CONTRACT, NEGLIGENCE OR STRICT LIABILITY, WILL NOT EXCEED THE TOTAL PAYMENTS OF MONTHLY FEES MADE TO CONSTANT RETAIL DURING THE THIRTY (30) DAYS PRIOR TO THE DATE THE LIABILITY AROSE.  NOTWITHSTANDING ANYTHING ELSE HEREIN, THE LIMITATIONS ON LIABILITY IN THE FOREGOING TWO SENTENCES SHALL IN NO EVENT APPLY TO EITHER (A) CLIENT’S INDEMNIFICATION OBLIGATIONS UNDER '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['SECTION 7'])), (_l()(), core_es5["ɵted"](null, ['; AND (B) ANY OBLIGATION OF THE CLIENT TO MAKE PAYMENT OF A MONTHLY FEE OR OF ANY OTHER CHARGES FOR ANY SERVICE PROVIDED BY CONSTANT RETAIL OR ANY OF ITS AFFILIATES IN CONNECTION WITH THESE TERMS AND CONDITIONS. '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['No Guarantee of Traffic'])), (_l()(), core_es5["ɵted"](null, ['. The Client acknowledges and agrees that Constant Retail has made no representation, warranty or guarantee regarding the number of visitors to the Hosted Site, the amounts of purchases through the Hosted Site, the amounts of revenues from Merchandise sold to Customers or any other projection relating to the performance of the Hosted Site, and Constant Retail hereby disclaims any and all such representations, warranties or guarantees.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 62, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Miscellaneous. '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 59, 'ol', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Independent Contractors'])), (_l()(), core_es5["ɵted"](null, ['. The Parties are entering into these Terms and Conditions as independent contractors, and these Terms and Conditions will not be construed to create a partnership, joint venture or employment relationship between them.  Neither Party will represent itself to be an employee or agent of the other or enter into any agreement or legally binding commitment or statement on the other’s behalf of or in the other’s name (other than to the extent that Customer orders of Merchandise through the Hosted Site shall obligate the Client to fulfill and ship such orders and otherwise honor the agreement formed by the Client and such Customer due to such order).'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Governing Law and Venue'])), (_l()(), core_es5["ɵted"](null, ['. These Terms and Conditions shall be construed according to the laws of the State of California without giving consideration to principles of conflict of law.  All disputes arising hereunder shall be resolved in Los Angeles, California and at no other place.  Client (a) irrevocably consents to the jurisdiction and venue of the State and Federal courts located in the City of Los Angeles, California, (b) agrees that any action relating to the services provided by Constant Retail shall only be brought in said courts, (c) consents to the exercise of '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['in personam'])), (_l()(), core_es5["ɵted"](null, [' jurisdiction by said courts over it, and (d) further agrees that any action to enforce a judgment may be instituted in any jurisdiction.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Entire Agreement'])), (_l()(), core_es5["ɵted"](null, ['. These Terms and Conditions, along with the Fee Addendum as well as any terms and conditions regarding “Freight Club” accepted and agreed to by the Client, represent the entire agreement between the Parties with respect to the subject matter hereof and supersedes all prior agreements and communications of the Parties with respect to the subject matter hereof, oral or written.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Similar Agreements'])), (_l()(), core_es5["ɵted"](null, ['. Nothing herein will be deemed to limit or restrict either Party or its Affiliates from entering into agreements with any other Person covering services similar to those contemplated by these Terms and Conditions or from offering such similar services itself.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Press Releases'])), (_l()(), core_es5["ɵted"](null, ['. Neither Party will make or issue any external press statement regarding these Terms and Conditions unless: (a) it has received the express written consent of the other Party, which will not be unreasonably withheld, or (b) it is required to do so by law or the rules of any securities market; provided that Constant Retail and its Affiliates shall be permitted to identify the Client, using the Client’s name and logo, if any, as a client of its business in any promotional materials, including, without limitation, on the Constant Retail website, and Client consents to such use.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Notices'])), (_l()(), core_es5["ɵted"](null, ['. All notices, requests and other communications to any Party will be in writing (including electronic mail, facsimile transmission or similar writing) and will be given in accordance with, in the case of Client, such contact information provided in connection with the Enrollment Process, and in the case of Constant Retail, such contact information provide by Constant Retail in connection with confirmation of Client’s engagement for the services to be provided hereunder, or as such Party may thereafter specify for such purposes.  Each such notice, request or other communication will be effective (a) if given by electronic mail or facsimile, when confirmation of receipt is obtained, or (b) if given by any other means when received by a Party at its specified address.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Amendments; Waivers'])), (_l()(), core_es5["ɵted"](null, ['. Except for the Fee Addendum, these Terms and Conditions may not be amended, modified or superseded, unless expressly agreed to in writing by both Parties.  No provision of these Terms and Conditions may be waived except by an instrument in writing executed by the Party against who the waiver is to be effective.  The failure of either Party at any time or times to require full performance of any provision hereof will in no manner affect the right of such Party at a later time to enforce the same.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Severability'])), (_l()(), core_es5["ɵted"](null, ['. If any provision or term of these Terms and Conditions, not being of a fundamental nature, is held to be invalid, illegal or unenforceable, the validity, legality and enforceability of the remainder of these Terms and Conditions will not be affected.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Force Majeure'])), (_l()(), core_es5["ɵted"](null, ['. Neither Party will be responsible for any failure or delay in its performance under these Terms and Conditions due to cause beyond its reasonable control, including but not limited to, labor disputes, strikes, lockouts, shortages or inability to obtain labor, energy, raw materials or supplies, war, riot, act of God or governmental action.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Assignment; Successors'])), (_l()(), core_es5["ɵted"](null, ['. Neither Party may assign these Terms Conditions without the prior written consent of the other Party and any such assignment without prior written consent shall be null and void, except that Constant Retail may assign these Terms and Conditions without prior written consent (a) to an Affiliate or (b) as part of a bona fide corporate reorganization or a sale of its business and, in connection therewith, Constant Retail may, and Client consents to, transfer of Customer Information as part of any such transaction.  For the avoidance of doubt, any acquirer of Constant Retail or any of its Affiliates, or of their respective business or all or substantially all of their respective assets, whether by direct purchase of capital stock or equity, merger, consolidation, reorganization, amalgamation or similar transaction, or other similar successor shall, for all purposes herein, be deemed to be “Constant Retail” or an “Affiliate” as applicable. '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Headings'])), (_l()(), core_es5["ɵted"](null, ['. The headings of the Sections of these Terms and Conditions have been included for the convenience of the Parties and are not part of the Agreement, nor are the headings to be used to alter or interpret the terms hereof.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 277, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Definitions. '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Whenever used in these Terms and Conditions, the following capitalized terms shall have the following specified meanings:'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 271, 'ol', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Additional Brands'])), (_l()(), core_es5["ɵted"](null, ['”'])), (_l()(), core_es5["ɵted"](null, [' means any brands related to and associated with particular products of a Vendor that is not an Authorized Brand.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Advertising'])),
        (_l()(), core_es5["ɵted"](null, ['” means any third-party-and/or Client-generated advertising displayed on the Hosted Site.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Advertising Revenue'])),
        (_l()(), core_es5["ɵted"](null, ['” means revenues generated by Advertising on the Hosted Site, including, without limitation, any as a result of Customers visiting the Hosted Site where such Customers click on or otherwise interact with such Advertising and any product placements.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Affiliate'])),
        (_l()(), core_es5["ɵted"](null, ['” means, as to any Person, any other Person that, directly or indirectly, is controlled by, is under common control with or controls such Person. For this purpose, control means ownership or voting rights over at least 50% of the outstanding voting or equity securities of the Person in question or the power to direct or cause the direction of management or policies of such Person, whether through voting securities, by contract or otherwise. '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'em', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Applicable Sales Tax Rates'])),
        (_l()(), core_es5["ɵted"](null, ['”'])), (_l()(), core_es5["ɵted"](null, [' means those rates of sales, use, transfer or similar tax payable to any governmental authority, whether federal, state, municipal or local, on any sale of Merchandise through the Hosted Site as well as on any other charge made in connection with such sale, as determined by the Client, entered into the Constant Retail Platform as part of the Enrollment Process, and, based on such determinations and entries by the Client, reflected and incorporated into the payment calculation processes of the Hosted Site. Constant Retail is relying upon for all purposes the Client’s determination of such Applicable Sales Tax Rates and, notwithstanding anything else herein, neither Constant Retail, any of its Affiliates nor any of their respective Representatives shall have any liability whatsoever related to the Applicable Sales Tax Rates.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'em', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Authorized Brands'])), (_l()(),
            core_es5["ɵted"](null, ['”'])), (_l()(), core_es5["ɵted"](null, [' means the brands related to and associated with particular products offered through the Constant Retail Platform that may be selected by the Client during the Enrollment Process as those the underlying products of which may be offered on the Hosted Site.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'em', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Client'])), (_l()(), core_es5["ɵted"](null, ['”'])), (_l()(), core_es5["ɵted"](null, [' means the Person transacting with Constant Retail and accepting these Terms and Conditions in connection with the enrollment for the services of Constant Retail through the Constant Retail Platform, whether at the time of enrollment or a subsequent time.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Constant Retail'])),
        (_l()(), core_es5["ɵted"](null, ['” means Cymax Services USA LLC (or any successor or assign of such entity).'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Constant Retail Content'])),
        (_l()(), core_es5["ɵted"](null, ['” means any and all content or information owned or controlled (e.g., by license or otherwise) by Constant Retail or its Affiliates, including, without limitation, text, graphics, photographs, video and audio.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Constant Retail-Furnished Item'])),
        (_l()(), core_es5["ɵted"](null, ['” means any Constant Retail Content or any other Intellectual Property owned or controlled (e.g., by license or otherwise) by Constant Retail or its Affiliates, as the case may be, that is furnished by Constant Retail or its Affiliates in connection with generation of the Hosted Site or otherwise in connection with the performance of Constant Retail’s obligations under these Terms and Conditions.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Constant Retail Intellectual Property'])),
        (_l()(), core_es5["ɵted"](null, ['” means, collectively, the Hosted Site (other than the Designated URLs), the Constant Retail Platform, the Constant Retail-Furnished Items, the Constant Retail-Owned Developments, and all Intellectual Property associated with any of the foregoing.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Constant Retail-Owned Developments'])),
        (_l()(), core_es5["ɵted"](null, ['” means any technology (including any adaptation, modification, improvement or derivative work of any Constant Retail-Furnished Item) that is developed by, or on behalf of, Constant Retail or any of its Affiliates, for use in connection with the Hosted Site or to implement the activities contemplated by these Terms and Conditions or that is developed by, or on behalf of, Constant Retail or any of its Affiliates for use on other websites hosted and maintained by Constant Retail or its Affiliates, besides the Hosted Site, along with all adaptations, modifications, improvements or derivative works thereof.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'em', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Constant Retail Platform'])),
        (_l()(), core_es5["ɵted"](null, ['”'])), (_l()(), core_es5["ɵted"](null, [' means the proprietary online platform of Constant Retail and/or its Affiliates for the generation, operation and management of hosted e-commerce websites.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Customer'])),
        (_l()(), core_es5["ɵted"](null, ['” means a Person who accesses the Hosted Site in any manner, whether or not a purchase is made.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Customer Information'])),
        (_l()(), core_es5["ɵted"](null, ['” means, with respect to any order of Merchandise made through the Hosted Site by a Customer, collectively, the name of the Customer, the Customer’s email address, the Customer’s billing and ship to addresses, the Customer’s phone number(s), and the credit card, bank account or other payment information for such order. For the avoidance of doubt, no customer data that does not contain any of the foregoing information shall be deemed Customer Information.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Damages'])),
        (_l()(), core_es5["ɵted"](null, ['” means liabilities, damages, awards, settlements, losses, claims and expenses, including reasonable attorney’s fees and expenses and costs of investigation.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Designated URLs'])),
        (_l()(), core_es5["ɵted"](null, ['” means those uniform resource locators registered to the Client or its Affiliates (or any successor or replacement URL thereof) identified by the Client and entered into the Constant Retail Platform in connection with the Enrollment Process.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'em', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Enrollment Process'])), (_l()(),
            core_es5["ɵted"](null, ['”'])), (_l()(), core_es5["ɵted"](null, [' means the process of the Client enrolling for the provision of the services contemplated by these Terms and Conditions through the Constant Retail website, including, without limitation, the Client’s selection of the Selected Brands, identification of the Designated URLs, provision of credit card account information, and the preauthorization of charges thereon to be made by Constant Retail, and, in connection with such process, the Client is accepting and agreeing to be bound by these Terms and Conditions, whether simultaneously or at a subsequent time.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'em', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Fee Addendum'])), (_l()(),
            core_es5["ɵted"](null, ['”'])), (_l()(), core_es5["ɵted"](null, [' means the schedule setting forth the charges to the Client for the services contemplated hereunder and the method of calculation thereof, including, without limitation: (a) Monthly Fees, including without limitation the fixed monthly charge for hosting the Hosted Site depending on the number of Selected Brands offered on it and for any services pursuant to '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 2'])), (_l()(), core_es5["ɵted"](null, [', if elected by the Client, (b) charges for inclusion of any Additional Brands on the Hosted Site, (c) costs and expenses related to marketing and advertising services pursuant to '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 2'])), (_l()(), core_es5["ɵted"](null, [' to be passed onto Client, and (d) the then-applicable percentage of Net Sales Revenue payable to Constant Retail as a charge for the services hereunder. The Fee Addendum is subject to change from time to time by Constant Retail and its Affiliates, which updated form Constant Retail shall make available to Clients, and the current Fee Addendum in effect can be viewed [here]'])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '#_ftn3'], ['name',
                '_ftnref3']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['[3]'])), (_l()(), core_es5["ɵted"](null, [' and is incorporated and made part of these Terms and Conditions by reference.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Hosted Site'])),
        (_l()(), core_es5["ɵted"](null, ['” means the e-commerce web site designated by, and accessible via, the Designated URLs, generated by the Constant Retail Platform and hosted by Constant Retail in accordance with these Terms and Conditions.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Intellectual Property'])),
        (_l()(), core_es5["ɵted"](null, ['” means any and all now known or hereafter known tangible and intangible intellectual property and rights related thereto, including without limitation: (a) rights associated with works of authorship throughout the universe, including but not limited to copyrights, moral rights, and mask-works, (b) trademark, service mark, trade dress and trade name rights and similar rights, (c) trade secret rights, (d) technology, (e) patents, designs, algorithms and other industrial property rights, (f) all other intellectual and industrial property rights of every kind and nature throughout the universe and however designated (including domain names, logos, “rental” rights and rights to remuneration), whether arising by operation of law, contract, license, or otherwise, and (g) all registrations, initial applications, renewals, extensions, continuations, divisions or reissues hereof now or hereafter in force (including any rights in any of the foregoing).'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Merchandise'])),
        (_l()(), core_es5["ɵted"](null, ['” means products offered for sale on the Hosted Site.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'em', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Monthly Fee'])), (_l()(),
            core_es5["ɵted"](null, ['”'])), (_l()(), core_es5["ɵted"](null, [' means the monthly charge to the Client for the services contemplated hereunder and as calculated in accordance with and set forth on the Fee Addendum. The current Fee Addendum in effect can be viewed [here]'])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '#_ftn4'], ['name',
                '_ftnref4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['[4]'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'strong', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['.  '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Net Return'])), (_l()(), core_es5["ɵted"](null, ['” means the original amount paid for Merchandise that has been returned, including Customer charge backs.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Net Sales Revenue'])),
        (_l()(), core_es5["ɵted"](null, ['” means all revenues from the Hosted Site, including without limitation: (a) all Advertising Revenue, and (b) revenues generated by Merchandise sales through the Hosted Site, including, without limitation, as a result of Customers visiting the Hosted Site where such Customers purchase Merchandise through the Hosted Site using Constant Retail’s automated ordering system, '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['provided'])), (_l()(), core_es5["ɵted"](null, [' such Customers accept delivery of Merchandise at the shipping destination and remit full payment therefore to the Client.  Net Sales Revenue includes all shipping charges paid by Customers but does not include taxes or Net Returns.  Depending on the particular choices made by the Client during the Enrollment Process, the Client shall be charged a fee based on a percentage of Net Sales Revenue, with such percentage being set forth on the Fee Addendum, payable immediately upon completion of a transaction generating Net Sales Revenue by pre-authorized charge to the Client’s credit card.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Parties'])),
        (_l()(), core_es5["ɵted"](null, ['” means, together, Client and Constant Retail and each, a “'])),
        (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Party'])), (_l()(), core_es5["ɵted"](null, ['”.'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Person'])), (_l()(), core_es5["ɵted"](null, ['” means any individual, corporation, limited-liability company, partnership, firm, joint venture, association, joint-stock company, trust, or other entity or organization, including a government or political subdivision or an agency or instrumentality thereof.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'em', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Privacy Policy'])), (_l()(),
            core_es5["ɵted"](null, ['”'])), (_l()(), core_es5["ɵted"](null, [' means a standard privacy policy for the Hosted Site, governing the collection, use and protection of all information provided and collected through the Hosted Site.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'em', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Representatives'])), (_l()(),
            core_es5["ɵted"](null, ['”'])), (_l()(), core_es5["ɵted"](null, [' means, with respect to any Person, any and all directors, officers, employees, consultants, financial advisors, counsel, accountants and other agents of such Person'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'em', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Selected Brands'])), (_l()(),
            core_es5["ɵted"](null, ['”'])), (_l()(), core_es5["ɵted"](null, [' means, collectively, (a) the Authorized Brands selected by the Client during the Enrollment Process, and (b) any Additional Brands also identified and selected by the Client and whose products may be marketed through the Hosted Site, as established in accordance with '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 1.2'])), (_l()(), core_es5["ɵted"](null, [' of these Terms and Conditions, subject to (x) Constant Retail, from time to time and its sole discretion, no longer offering any Authorized Brand or Additional Brand through the Hosted Site, or (y) Client notifying Constant Retail that it no longer wishes to offer an Authorized Brand or Additional Brand, in which case such Authorized Brand and/or Additional Brand, as the case may be, shall no longer be included in this definition of Selected Brands.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'em', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Term'])), (_l()(), core_es5["ɵted"](null, ['”'])), (_l()(), core_es5["ɵted"](null, [' means the period of time during which these Terms and Conditions are in full force and effect and not terminated pursuant to '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Section 6'])), (_l()(), core_es5["ɵted"](null, [' of these Terms and Conditions.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'em', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['User Data'])),
        (_l()(), core_es5["ɵted"](null, ['” means all data and information derived by any means from the Hosted Site, including, without limitation, regarding visits to and use of the Hosted Site and all data and information regarding transactions effected on the Hosted Site, other than, in each case, Customer Information.  User Data is tracked and collected through the Constant Retail Platform and as such is the Intellectual Property of Constant Retail, and may be used by Constant Retail and its Affiliates for any purpose whatsoever.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'em', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['“'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'u', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Vendor'])), (_l()(), core_es5["ɵted"](null, ['”'])), (_l()(), core_es5["ɵted"](null, [' means a seller of products that may be offered through the Hosted Site, whether under an Authorized Brand or Additional Brand.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'modal-footer']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['class', 'btn btn-default btn-lg pull-left'], ['type', 'button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 88).hide() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'i', [['aria-hidden', 'true'], ['class', 'icon wb-close']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Close'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.model != null);
        _ck(_v, 77, 0, currVal_0);
    }, null);
}
function View_RegisterComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'register', [], null, null, null, View_RegisterComponent_0, RenderType_RegisterComponent)),
        core_es5["ɵdid"](114688, null, 0, register_component_RegisterComponent, [services_userService["a" /* UserService */], ng2_cookies_cookie["CookieService"],
            services_configService["a" /* ConfigService */], router_es5["n" /* Router */], router_es5["a" /* ActivatedRoute */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var RegisterComponentNgFactory = core_es5["ɵccf"]('register', register_component_RegisterComponent, View_RegisterComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvYXV0aC9yZWdpc3Rlci9yZWdpc3Rlci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvYXV0aC9yZWdpc3Rlci9yZWdpc3Rlci5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9hdXRoL3JlZ2lzdGVyL3JlZ2lzdGVyLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvYXV0aC9yZWdpc3Rlci9yZWdpc3Rlci5jb21wb25lbnQudHMuUmVnaXN0ZXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwiZnVsbC1wYWdlIHJlZ2lzdGVyLXBhZ2VcIiBmaWx0ZXItY29sb3I9XCJibGFja1wiPiA8ZGl2IGNsYXNzPVwiY29udGFpbmVyXCI+IDxkaXYgY2xhc3M9XCJyb3dcIj4gPGRpdiBjbGFzcz1cImNvbC1tZC0xMCBjb2wtbWQtb2Zmc2V0LTFcIj4gPGRpdiBjbGFzcz1cImNhcmQgY2FyZC1zaWdudXBcIj4gPGgyIGNsYXNzPVwiY2FyZC10aXRsZSB0ZXh0LWNlbnRlclwiPlJlZ2lzdGVyPC9oMj4gPGRpdiBjbGFzcz1cInJvd1wiPiA8ZGl2IGNsYXNzPVwiY29sLW1kLTUgY29sLW1kLW9mZnNldC0xXCI+IDxkaXYgY2xhc3M9XCJjYXJkLWNvbnRlbnRcIj4gPGRpdiBjbGFzcz1cImluZm8gaW5mby1ob3Jpem9udGFsXCI+IDxkaXYgY2xhc3M9XCJpY29uIGljb24tcm9zZVwiPiA8aSBjbGFzcz1cIm1hdGVyaWFsLWljb25zXCI+dGltZWxpbmU8L2k+IDwvZGl2PiA8ZGl2IGNsYXNzPVwiZGVzY3JpcHRpb25cIj4gPGg0IGNsYXNzPVwiaW5mby10aXRsZVwiPk1hcmtldHNoYXJlIERhdGE8L2g0PiA8cCBjbGFzcz1cImRlc2NyaXB0aW9uXCI+IFdlIHBhY2thZ2UgZGF0YSBmcm9tIGRpZmZlcmVudCBjaGFubmVscyB0byBnZXQgdmFsdWFibGUgaW5zaWdodCBvbiBtYXJrZXRzaGFyZSBvd25lcnNoaXAuIDwvcD4gPC9kaXY+IDwvZGl2PiA8ZGl2IGNsYXNzPVwiaW5mbyBpbmZvLWhvcml6b250YWxcIj4gPGRpdiBjbGFzcz1cImljb24gaWNvbi1wcmltYXJ5XCI+IDxpIGNsYXNzPVwibWF0ZXJpYWwtaWNvbnNcIj5jb2RlPC9pPiA8L2Rpdj4gPGRpdiBjbGFzcz1cImRlc2NyaXB0aW9uXCI+IDxoNCBjbGFzcz1cImluZm8tdGl0bGVcIj5QcmVkaWN0aXZlIEFuYWx5dGljczwvaDQ+IDxwIGNsYXNzPVwiZGVzY3JpcHRpb25cIj4gV2UgY29tYmluZSB1c2VyIGRhdGEgaW50byBidXNpbmVzcyBpbnRlbGxpZ2VuY2UgcmVwb3J0cyB0byBoZWxwIGNsaWVudHMgZGV0ZXJtaW5lIGdhcHMgaW4gbWFya2V0IGFuZCBleHBsb3JlIG9wcG9ydHVuaXRpZXMgaW4gcHJvZHVjdCBkZXZlbG9wbWVudC4gPC9wPiA8L2Rpdj4gPC9kaXY+IDxkaXYgY2xhc3M9XCJpbmZvIGluZm8taG9yaXpvbnRhbFwiPiA8ZGl2IGNsYXNzPVwiaWNvbiBpY29uLWluZm9cIj4gPGkgY2xhc3M9XCJtYXRlcmlhbC1pY29uc1wiPmdyb3VwPC9pPiA8L2Rpdj4gPGRpdiBjbGFzcz1cImRlc2NyaXB0aW9uXCI+IDxoNCBjbGFzcz1cImluZm8tdGl0bGVcIj5QcmljaW5nIEludGVsbGlnZW5jZTwvaDQ+IDxwIGNsYXNzPVwiZGVzY3JpcHRpb25cIj4gV2UgaW50ZWdyYXRlIHdpdGgga2V5IGRhdGEgc291cmNlcyB0byBnYXRoZXIgY29tcGV0aXRpdmUgZGF0YSBhbmQgc3RhdGlzdGljcywgYW5kIGNvbWJpbmUgdGhlbSB3aXRoIG1hcmtldCBpbnRlbGxpZ2VuY2UgdG8gcHJvdmlkZSByZWNvbW1lbmRhdGlvbiBpbiBvcHRpbWFsIHByaWNpbmcuIDwvcD4gPC9kaXY+IDwvZGl2PiA8L2Rpdj4gPC9kaXY+IDxkaXYgY2xhc3M9XCJjb2wtbWQtNVwiICpuZ0lmPVwibW9kZWwgIT0gbnVsbFwiPiA8Zm9ybSAjcmVnaXN0ZXJGb3JtPVwibmdGb3JtXCIgbm92YWxpZGF0ZSAobmdTdWJtaXQpPVwicmVnaXN0ZXIocmVnaXN0ZXJGb3JtLnZhbGlkKVwiPiA8ZGl2IGNsYXNzPVwiY2FyZC1jb250ZW50XCI+IDxkaXYgY2xhc3M9XCJpbnB1dC1ncm91cFwiPiA8c3BhbiBjbGFzcz1cImlucHV0LWdyb3VwLWFkZG9uXCI+IDxpIGNsYXNzPVwibWF0ZXJpYWwtaWNvbnNcIj5mYWNlPC9pPiA8L3NwYW4+IDxmb3JtLWlucHV0ICNmaXJzdE5hbWVNb2RlbCBuYW1lPVwiZmlzcnROYW1lXCIgbGFiZWw9XCJGaXJzdCBOYW1lXCIgW2Rpc2FibGVkXT1cImJsb2NrXCIgW2Zvcm1dPVwicmVnaXN0ZXJGb3JtXCIgWyhuZ01vZGVsKV09XCJtb2RlbC5GaXJzdE5hbWVcIiByZXF1aXJlZCBwYXR0ZXJuPVwiW2EteiBBLVpdKlwiPiA8c3BhbiBjbGFzcz1cImhlbHAtYmxvY2tcIiAqbmdJZj1cIiFibG9jayAmJiAoZmlyc3ROYW1lTW9kZWwubW9kZWwuZXJyb3JzIHwgZmlyc3RLZXkpID09ICdyZXF1aXJlZCcgJiYgKCFmaXJzdE5hbWVNb2RlbC5tb2RlbC5wcmlzdGluZSB8fCByZWdpc3RlckZvcm0uc3VibWl0dGVkKVwiPiBGaXJzdCBOYW1lIGlzIHJlcXVpcmVkLiA8L3NwYW4+IDxzcGFuIGNsYXNzPVwiaGVscC1ibG9ja1wiICpuZ0lmPVwiIWJsb2NrICYmIChmaXJzdE5hbWVNb2RlbC5tb2RlbC5lcnJvcnMgfCBmaXJzdEtleSkgPT0gJ3BhdHRlcm4nICYmICghZmlyc3ROYW1lTW9kZWwubW9kZWwucHJpc3RpbmUgfHwgcmVnaXN0ZXJGb3JtLnN1Ym1pdHRlZClcIj4gRmlyc3QgTmFtZSBjYW4gb25seSBjb250YWluIGxldHRlcnMgZnJvbSBhIHRvIHosIEEgdG8gWi4gPC9zcGFuPiA8L2Zvcm0taW5wdXQ+IDwvZGl2PiA8ZGl2IGNsYXNzPVwiaW5wdXQtZ3JvdXBcIj4gPHNwYW4gY2xhc3M9XCJpbnB1dC1ncm91cC1hZGRvblwiPiA8aSBjbGFzcz1cIm1hdGVyaWFsLWljb25zXCI+ZmFjZTwvaT4gPC9zcGFuPiA8Zm9ybS1pbnB1dCAjbGFzdE5hbWVNb2RlbCBuYW1lPVwibGFzdE5hbWVcIiBsYWJlbD1cIkxhc3QgTmFtZVwiIFtkaXNhYmxlZF09XCJibG9ja1wiIFtmb3JtXT1cInJlZ2lzdGVyRm9ybVwiIFsobmdNb2RlbCldPVwibW9kZWwuTGFzdE5hbWVcIiByZXF1aXJlZCBwYXR0ZXJuPVwiW2EteiBBLVpdKlwiPiA8c3BhbiBjbGFzcz1cImhlbHAtYmxvY2tcIiAqbmdJZj1cIiFibG9jayAmJiAobGFzdE5hbWVNb2RlbC5tb2RlbC5lcnJvcnMgfCBmaXJzdEtleSkgPT0gJ3JlcXVpcmVkJyAmJiAoIWxhc3ROYW1lTW9kZWwubW9kZWwucHJpc3RpbmUgfHwgcmVnaXN0ZXJGb3JtLnN1Ym1pdHRlZClcIj4gTGFzdCBOYW1lIGlzIHJlcXVpcmVkLiA8L3NwYW4+IDxzcGFuIGNsYXNzPVwiaGVscC1ibG9ja1wiICpuZ0lmPVwiIWJsb2NrICYmIChsYXN0TmFtZU1vZGVsLm1vZGVsLmVycm9ycyB8IGZpcnN0S2V5KSA9PSAncGF0dGVybicgJiYgKCFsYXN0TmFtZU1vZGVsLm1vZGVsLnByaXN0aW5lIHx8IHJlZ2lzdGVyRm9ybS5zdWJtaXR0ZWQpXCI+IExhc3QgTmFtZSBjYW4gb25seSBjb250YWluIGxldHRlcnMgZnJvbSBhIHRvIHosIEEgdG8gWi4gPC9zcGFuPiA8L2Zvcm0taW5wdXQ+IDwvZGl2PiA8ZGl2IGNsYXNzPVwiaW5wdXQtZ3JvdXBcIj4gPHNwYW4gY2xhc3M9XCJpbnB1dC1ncm91cC1hZGRvblwiPiA8aSBjbGFzcz1cIm1hdGVyaWFsLWljb25zXCI+ZW1haWw8L2k+IDwvc3Bhbj4gPGZvcm0taW5wdXQgI2VtYWlsTW9kZWwgdHlwZT1cImVtYWlsXCIgbmFtZT1cImVtYWlsXCIgbGFiZWw9XCJFbWFpbFwiIFtkaXNhYmxlZF09XCJibG9ja1wiIFtmb3JtXT1cInJlZ2lzdGVyRm9ybVwiIFsobmdNb2RlbCldPVwibW9kZWwuRW1haWxcIiByZXF1aXJlZCBlbWFpbD4gPHNwYW4gY2xhc3M9XCJoZWxwLWJsb2NrXCIgKm5nSWY9XCIhYmxvY2sgJiYgKGVtYWlsTW9kZWwubW9kZWwuZXJyb3JzIHwgZmlyc3RLZXkpID09ICdyZXF1aXJlZCcgJiYgKCFlbWFpbE1vZGVsLm1vZGVsLnByaXN0aW5lIHx8IHJlZ2lzdGVyRm9ybS5zdWJtaXR0ZWQpXCI+IEVtYWlsIGlzIHJlcXVpcmVkLiA8L3NwYW4+IDxzcGFuIGNsYXNzPVwiaGVscC1ibG9ja1wiICpuZ0lmPVwiIWJsb2NrICYmIChlbWFpbE1vZGVsLm1vZGVsLmVycm9ycyB8IGZpcnN0S2V5KSA9PSAnZW1haWwnICYmICghZW1haWxNb2RlbC5tb2RlbC5wcmlzdGluZSB8fCByZWdpc3RlckZvcm0uc3VibWl0dGVkKVwiPiBZb3VyIGVtYWlsIGFkZHJlc3MgaXMgaW52YWxpZC4gPC9zcGFuPiA8L2Zvcm0taW5wdXQ+IDwvZGl2PiA8ZGl2IGNsYXNzPVwiaW5wdXQtZ3JvdXBcIj4gPHNwYW4gY2xhc3M9XCJpbnB1dC1ncm91cC1hZGRvblwiPiA8aSBjbGFzcz1cIm1hdGVyaWFsLWljb25zXCI+bG9ja19vdXRsaW5lPC9pPiA8L3NwYW4+IDxmb3JtLWlucHV0ICNwYXNzd29yZE1vZGVsIHR5cGU9XCJwYXNzd29yZFwiIG5hbWU9XCJwYXNzd29yZFwiIGxhYmVsPVwiUGFzc3dvcmRcIiBbZm9ybV09XCJyZWdpc3RlckZvcm1cIiBbKG5nTW9kZWwpXT1cIm1vZGVsLlBhc3N3b3JkXCIgcmVxdWlyZWQgbWlubGVuZ3RoPVwiNlwiPiA8c3BhbiBjbGFzcz1cImhlbHAtYmxvY2tcIiAqbmdJZj1cIihwYXNzd29yZE1vZGVsLm1vZGVsLmVycm9ycyB8IGZpcnN0S2V5KSA9PSAncmVxdWlyZWQnICYmICghcGFzc3dvcmRNb2RlbC5tb2RlbC5wcmlzdGluZSB8fCByZWdpc3RlckZvcm0uc3VibWl0dGVkKVwiPiBQYXNzd29yZCBpcyByZXF1aXJlZCA8L3NwYW4+IDxzcGFuIGNsYXNzPVwiaGVscC1ibG9ja1wiICpuZ0lmPVwiKHBhc3N3b3JkTW9kZWwubW9kZWwuZXJyb3JzIHwgZmlyc3RLZXkpID09ICdtaW5sZW5ndGgnICYmICghcGFzc3dvcmRNb2RlbC5tb2RlbC5wcmlzdGluZSB8fCByZWdpc3RlckZvcm0uc3VibWl0dGVkKVwiPiBQYXNzd29yZCBzaG91bGQgYmUgbW9yZSB0aGVuIDYgY2hhcnMgPC9zcGFuPiA8L2Zvcm0taW5wdXQ+IDwvZGl2PiA8ZGl2IGNsYXNzPVwiaW5wdXQtZ3JvdXBcIj4gPHNwYW4gY2xhc3M9XCJpbnB1dC1ncm91cC1hZGRvblwiPiA8aSBjbGFzcz1cIm1hdGVyaWFsLWljb25zXCI+bG9ja19vdXRsaW5lPC9pPiA8L3NwYW4+IDxmb3JtLWlucHV0ICNjb25maXJtUGFzc3dvcmRNb2RlbCB0eXBlPVwicGFzc3dvcmRcIiBuYW1lPVwiY29uZmlybVBhc3N3b3JkXCIgbGFiZWw9XCJDb25maXJtIFBhc3N3b3JkXCIgW2Zvcm1dPVwicmVnaXN0ZXJGb3JtXCIgWyhuZ01vZGVsKV09XCJtb2RlbC5Db25maXJtUGFzc3dvcmRcIiByZXF1aXJlZCBbdmFsaWRhdGVFcXVhbF09XCJwYXNzd29yZE1vZGVsXCI+IDxzcGFuIGNsYXNzPVwiaGVscC1ibG9ja1wiICpuZ0lmPVwiKGNvbmZpcm1QYXNzd29yZE1vZGVsLm1vZGVsLmVycm9ycyB8IGZpcnN0S2V5KSA9PSAncmVxdWlyZWQnICYmICghY29uZmlybVBhc3N3b3JkTW9kZWwubW9kZWwucHJpc3RpbmUgfHwgcmVnaXN0ZXJGb3JtLnN1Ym1pdHRlZClcIj4gQ29uZmlybSBQYXNzd29yZCBpcyByZXF1aXJlZCA8L3NwYW4+IDxzcGFuIGNsYXNzPVwiaGVscC1ibG9ja1wiICpuZ0lmPVwiKGNvbmZpcm1QYXNzd29yZE1vZGVsLm1vZGVsLmVycm9ycyB8IGZpcnN0S2V5KSA9PSAndmFsaWRhdGVFcXVhbCcgJiYgKCFjb25maXJtUGFzc3dvcmRNb2RlbC5tb2RlbC5wcmlzdGluZSB8fCByZWdpc3RlckZvcm0uc3VibWl0dGVkKVwiPiBQYXNzd29yZCBhbmQgaXRzIGNvbmZpcm0gYXJlIG5vdCB0aGUgc2FtZSA8L3NwYW4+IDwvZm9ybS1pbnB1dD4gPC9kaXY+IDxjaGVja2JveCAjYWdyZWVNb2RlbCBuYW1lPVwiYWdyZWVcIiBbZm9ybV09XCJyZWdpc3RlckZvcm1cIiBbKG5nTW9kZWwpXT1cIm1vZGVsLlRlcm1zQWdyZWVcIiByZXF1aXJlZD4gSSBhY2NlcHQgYW5kIGFncmVlIHRvIENvbnN0YW50IFJldGFpbCdzIDxhIHJvbGU9XCJidXR0b25cIiAoY2xpY2spPVwidGVybXNDb25kaXRpb25zLnNob3coKTsgJGV2ZW50LnByZXZlbnREZWZhdWx0KClcIj5UZXJtcyBhbmQgQ29uZGl0aW9uczwvYT4uPGJyPiA8c21hbGwgKm5nSWY9XCIoYWdyZWVNb2RlbC5tb2RlbC5lcnJvcnMgfCBmaXJzdEtleSkgPT0gJ3JlcXVpcmVkJyAmJiAoIWFncmVlTW9kZWwubW9kZWwucHJpc3RpbmUgfHwgcmVnaXN0ZXJGb3JtLnN1Ym1pdHRlZClcIj4gWW91IG11c3QgYWdyZWUgd2l0aCB0aGUgdGVybXMgYW5kIGNvbmRpdGlvbnMgPC9zbWFsbD4gPC9jaGVja2JveD4gPGRpdiBjbGFzcz1cInRleHQtZGl2aWRlclwiPjwvZGl2PiA8ZXJyb3JzLXN1bW1hcnkgW2Vycm9yc109XCJlcnJvcnNcIj48L2Vycm9ycy1zdW1tYXJ5PiA8L2Rpdj4gPGRpdiBjbGFzcz1cImZvb3RlciB0ZXh0LWNlbnRlclwiPiA8YnV0dG9uIHR5cGU9XCJzdWJtaXRcIiBjbGFzcz1cImJ0biBidG4tcHJpbWFyeSBidG4tcm91bmRcIiBbZGlzYWJsZWRdPVwicHJvY2Vzc2luZyB8fCAocmVnaXN0ZXJGb3JtLnN1Ym1pdHRlZCAmJiAhcmVnaXN0ZXJGb3JtLnZhbGlkKVwiPlJlZ2lzdGVyPC9idXR0b24+IDwvZGl2PiA8L2Zvcm0+IDwvZGl2PiA8L2Rpdj4gPC9kaXY+IDwvZGl2PiA8L2Rpdj4gPC9kaXY+IDxkaXYgY2xhc3M9XCJmdWxsLXBhZ2UtYmFja2dyb3VuZFwiPjwvZGl2PiA8L2Rpdj4gPGRpdiBjbGFzcz1cIm1vZGFsIGZhZGVcIiBic01vZGFsICN0ZXJtc0NvbmRpdGlvbnM9XCJicy1tb2RhbFwiIHRhYmluZGV4PVwiLTFcIiByb2xlPVwiZGlhbG9nXCIgYXJpYS1sYWJlbGxlZGJ5PVwidGVybXNUaXRsZVwiIGFyaWEtaGlkZGVuPVwidHJ1ZVwiPiA8ZGl2IGNsYXNzPVwibW9kYWwtZGlhbG9nIG1vZGFsLWxnXCIgcm9sZT1cImRvY3VtZW50XCI+IDxkaXYgY2xhc3M9XCJtb2RhbC1jb250ZW50XCI+IDxkaXYgY2xhc3M9XCJtb2RhbC1oZWFkZXJcIj4gPGJ1dHRvbiB0eXBlPVwiYnV0dG9uXCIgY2xhc3M9XCJjbG9zZVwiIGFyaWEtbGFiZWw9XCJDbG9zZVwiIChjbGljayk9XCJ0ZXJtc0NvbmRpdGlvbnMuaGlkZSgpXCI+PHNwYW4gYXJpYS1oaWRkZW49XCJ0cnVlXCI+JnRpbWVzOzwvc3Bhbj48L2J1dHRvbj4gPGg0IGNsYXNzPVwibW9kYWwtdGl0bGVcIiBpZD1cInRlcm1zVGl0bGVcIj5Db25zdGFudCBSZXRhaWwgQ2xpY2stVGhyb3VnaCBBZ3JlZW1lbnQ8L2g0PiA8L2Rpdj4gPGRpdiBjbGFzcz1cIm1vZGFsLWJvZHlcIj4gPHA+QnkgY2xpY2tpbmcgJmxkcXVvO0kgYWNjZXB0IGFuZCBhZ3JlZSZyZHF1bzsgYmVsb3csIHlvdSAodGhlICZsZHF1bzs8dT5DbGllbnQ8L3U+JnJkcXVvOykgYWdyZWUgdG8gYmUgYm91bmQgYnksIGFkaGVyZSB0byBhbmQgcGVyZm9ybSB0aGUgdGVybXMgYmVsb3cgYW5kIENvbnN0YW50IFJldGFpbCBzaGFsbCBsaWtld2lzZSBwZXJmb3JtIGl0cyByZXNwZWN0aXZlIG9ibGlnYXRpb25zIGJlbG93LCBzdWJqZWN0IHRvIHRoZSBmb2xsb3dpbmcgYWRkZW5kdW0gb2YgdGVybXMgYW5kIGNvbmRpdGlvbnMgKHRoZSAmbGRxdW87PHU+VGVybXMgYW5kIENvbmRpdGlvbnM8L3U+JnJkcXVvOykgd2hpY2ggYXJlIGluY29ycG9yYXRlZCBoZXJlaW4gYnkgcmVmZXJlbmNlIGFuZCBtYWRlIGEgcGFydCBvZiB0aGlzIGFncmVlbWVudC4mbmJzcDsgQ2FwaXRhbGl6ZWQgd29yZHMgYW5kIHBocmFzZXMgYXJlIGZ1cnRoZXIgZGVmaW5lZCBpbiA8dT5TZWN0aW9uIDEwPC91PiBvZiB0aGUgVGVybXMgYW5kIENvbmRpdGlvbnMuPC9wPiA8cD48c3Ryb25nPjx1PkRlc2lnbmF0ZWQgVVJMczwvdT48L3N0cm9uZz48L3A+IDx1bD4gPGxpPkNsaWVudCBpcyB0aGUgcmVnaXN0ZXJlZCBvd25lciBvZiB0aGUgVVJMcyBwcm92aWRlZCB0byBDb25zdGFudCBSZXRhaWwgZm9yIHRoZSBIb3N0ZWQgU2l0ZS48L2xpPiA8L3VsPiA8cD48c3Ryb25nPjx1PlNlbGVjdGlvbiBvZiBCcmFuZHM8L3U+PC9zdHJvbmc+PC9wPiA8dWw+IDxsaT5DbGllbnQgaGFzIG9yIHNoYWxsIHNlbGVjdCB0aGUgYnJhbmRzIHRoYXQgQ2xpZW50IHdvdWxkIGxpa2UgdG8gb2ZmZXIgb24gdGhlIEhvc3RlZCBTaXRlLCBhcyBhbiBhdXRob3JpemVkIGFuZCBhcHByb3ZlZCByZXRhaWxlciBmb3Igc3VjaCBicmFuZHMuPC9saT4gPC91bD4gPHVsPiA8bGk+Q2xpZW50IHVuZGVyc3RhbmRzIHRoYXQgZmVlcyBhbmQgY2hhcmdlcyBmb3Igc2VydmljZXMgcHJvdmlkZWQgYnkgQ29uc3RhbnQgUmV0YWlsIHRvIHRoZSBDbGllbnQgYXJlIGJhc2VkIG9uIHRoZSBudW1iZXIgb2YgYnJhbmRzIHNlbGVjdGVkLjwvbGk+IDwvdWw+IDxwPjxzdHJvbmc+PHU+R2VuZXJhdGlvbiBvZiB0aGUgSG9zdGVkIFNpdGUgPC91Pjwvc3Ryb25nPjwvcD4gPHVsPiA8bGk+SW4gYWNjb3JkYW5jZSB3aXRoIHRoZSBzZWxlY3Rpb25zIG1hZGUgb3IgdG8gYmUgbWFkZSBieSB0aGUgQ2xpZW50LCB0aGUgSG9zdGVkIFNpdGUgc2hhbGwgYmUgZ2VuZXJhdGVkIGJ5IHRoZSBDb25zdGFudCBSZXRhaWwgUGxhdGZvcm0sIHV0aWxpemluZyBDb25zdGFudCBSZXRhaWwmcnNxdW87cyBwcm9wcmlldGFyeSB0ZW1wbGF0ZXMsIGRlc2lnbnMgYW5kIGludGVyZmFjZXMuPC9saT4gPC91bD4gPHVsPiA8bGk+VGhlIEhvc3RlZCBTaXRlIHNoYWxsIGJlYXIgdGhlIHBocmFzZSAmbGRxdW87UG93ZXJlZCBieSBDb25zdGFudCBSZXRhaWwmcmRxdW87IG9yIHN1Y2ggb3RoZXIgaW5kaWNhdGlvbiBvZiB0aGUgZ2VuZXJhdGlvbiBvZiB0aGUgSG9zdGVkIFNpdGUgYnkgdGhlIENvbnN0YW50IFJldGFpbCBQbGF0Zm9ybS48L2xpPiA8L3VsPiA8dWw+IDxsaT5Db25zdGFudCBSZXRhaWwgc2hhbGwgcHJvdmlkZSB1cGRhdGVzIG9uIHRoZSBwcm9kdWN0cyBiZWluZyBvZmZlcmVkIG9uIHRoZSBIb3N0ZWQgU2l0ZS48L2xpPiA8L3VsPiA8cD48c3Ryb25nPjx1PkNvbnN0YW50IFJldGFpbCBSZXNwb25zaWJpbGl0aWVzOyBDbGllbnQgUmVzcG9uc2liaWxpdGllczwvdT48L3N0cm9uZz48L3A+IDx1bD4gPGxpPkNvbnN0YW50IFJldGFpbCBob3N0cyB0aGUgSG9zdGVkIFNpdGUgYXMgYSB0aGlyZC1wYXJ0eSBzZXJ2aWNlIHByb3ZpZGVyLCB3aXRoIG5vIHJlc3BvbnNpYmlsaXR5IG90aGVyd2lzZSBmb3IgdGhlIGUtY29tbWVyY2UgYnVzaW5lc3Mgb3BlcmF0ZWQgdGhyb3VnaCB0aGUgSG9zdGVkIFNpdGUuPC9saT4gPC91bD4gPHVsPiA8bGk+U3VjaCBidXNpbmVzcyBpcyB0aGUgQ2xpZW50JnJzcXVvO3Mgc29sZSByZXNwb25zaWJpbGl0eSwgYXMgdGhlIG93bmVyIGFuZCBwcm9wcmlldG9yIG9mIHN1Y2ggZS1jb21tZXJjZSBidXNpbmVzcyBhbmQsIG90aGVyIHRoYW4gaG9zdGluZyB0aGUgSG9zdGVkIFNpdGUsIENsaWVudCBzaGFsbCBiZSByZXNwb25zaWJsZSBmb3IgYWxsIG90aGVyIGFzcGVjdCBvZiBzdWNoIGJ1c2luZXNzLCBpbmNsdWRpbmcgdGhlIGZ1bGZpbG1lbnQgb2Ygb3JkZXJzLCBhZG1pbmlzdHJhdGlvbiBvZiByZXR1cm5zIGFuZCB0aGUgY29sbGVjdGlvbiBhbmQgcmVtaXR0YW5jZSBvZiBzYWxlcyB0YXhlcy48L2xpPiA8L3VsPiA8cD48c3Ryb25nPjx1PkZlZXMgYW5kIENoYXJnZXM8L3U+PC9zdHJvbmc+PC9wPiA8dWw+IDxsaT5GZWVzIGFuZCBjaGFyZ2VzIHRvIHRoZSBDbGllbnQgYXJlIGJhc2VkIG9uIHRoZSBudW1iZXIgb2YgYnJhbmRzIHNlbGVjdGVkIGFuZCBhIHBlcmNlbnRhZ2Ugb2YgcmV2ZW51ZSBmcm9tIHNhbGVzIHRocm91Z2ggdGhlIEhvc3RlZCBTaXRlIGFuZCBhcyBzZXQgZm9ydGggaW4gZnVydGhlciBkZXRhaWwgaW4gdGhlIGN1cnJlbnQgZmVlIHNjaGVkdWxlIHdoaWNoIG1heSBiZSB2aWV3ZWQgYnkgY2xpY2tpbmcgW2hlcmVdPGEgaHJlZj1cIiNfZnRuMVwiIG5hbWU9XCJfZnRucmVmMVwiPlsxXTwvYT4uPC9saT4gPC91bD4gPHVsPiA8bGk+VmFsaWQgY3JlZGl0IGNhcmQgaW5mb3JtYXRpb24gbXVzdCBiZSBwcm92aWRlZCBhbmQgZmVlcyBhbmQgY2hhcmdlcyBmb3Igc2VydmljZXMgcHJvdmlkZWQgYnkgQ29uc3RhbnQgUmV0YWlsIHNoYWxsIGJlIGNoYXJnZWQgdG8gc3VjaCBjcmVkaXQgY2FyZCBhY2NvdW50LjwvbGk+IDwvdWw+IDx1bD4gPGxpPkZlZXMgYW5kIGNoYXJnZXMgYXJlIHN1YmplY3QgdG8gY2hhbmdlIGF0IENvbnN0YW50IFJldGFpbCZyc3F1bztzIGRpc2NyZXRpb24uPC9saT4gPC91bD4gPHVsPiA8bGk+UmVmdW5kcyBhdHRyaWJ1dGFibGUgdG8gcmV0dXJucyBvZiBtZXJjaGFuZGlzZSBzaGFsbCBiZSBtYWRlIGF0IHN1Y2ggdGltZSBDbGllbnQgaGFzIGZ1bGx5IHByb2Nlc3NlZCB0aGUgcmV0dXJuIGFuZCByZXR1cm5lZCB0aGUgZW5kLWN1c3RvbWVyJnJzcXVvO3MgcGF5bWVudCBmb3IgdGhlIG1lcmNoYW5kaXNlLjwvbGk+IDwvdWw+IDxwPjxzdHJvbmc+PHU+UmVwb3J0aW5nPC91Pjwvc3Ryb25nPjwvcD4gPHVsPiA8bGk+Q2xpZW50IHdpbGwgYmUgYWJsZSB0byBnZW5lcmF0ZSByZXBvcnRzIG9uIHVzYWdlIGFuZCBzYWxlcyBhY3Rpdml0eSBvbiB0aGUgSG9zdGVkIFNpdGUuPC9saT4gPC91bD4gPHA+PHN0cm9uZz48dT5Qcm90ZWN0aW9uIG9mIEVuZC1DdXN0b21lciBJbmZvcm1hdGlvbjwvdT48L3N0cm9uZz48L3A+IDx1bD4gPGxpPkNvbnN0YW50IFJldGFpbCB3aWxsIG5vdCB1c2Ugb3IgZGlzY2xvc2UgYW55IHBlcnNvbmFsbHkgaWRlbnRpZmlhYmxlIGluZm9ybWF0aW9uLCBzdWNoIGFzIG5hbWVzIGFuZCBjb250YWN0IGluZm9ybWF0aW9uLCByZWdhcmRpbmcgdGhlIENsaWVudCZyc3F1bztzIGVuZC1jdXN0b21lcnMgbWFraW5nIHB1cmNoYXNlcyB0aHJvdWdoIHRoZSBIb3N0ZWQgU2l0ZS48L2xpPiA8L3VsPiA8cD48c3Ryb25nPjx1PlByaXZhY3kgUG9saWN5IGZvciBIb3N0ZWQgU2l0ZTwvdT48L3N0cm9uZz48L3A+IDx1bD4gPGxpPkNsaWVudCBtdXN0IGdlbmVyYXRlIGFuZCBhZG9wdCBmb3IgdGhlIEhvc3RlZCBTaXRlIGEgcHJpdmFjeSBwb2xpY3kgYW5kIGluY2x1ZGUgdGhlIGZvbGxvd2luZyBzdGF0ZW1lbnQgaW4gc3VjaCBwb2xpY3k6PC9saT4gPC91bD4gPHA+PGVtPiZsZHF1bztPdXIgc2l0ZSBpcyBob3N0ZWQgYW5kIG1haW50YWluZWQgYnkgYSB0aGlyZC1wYXJ0eSBzZXJ2aWNlIHByb3ZpZGVyIGtub3duIGFzICZsZHF1bztDb25zdGFudCBSZXRhaWwmcmRxdW87LiZuYnNwOyBOb3R3aXRoc3RhbmRpbmcgYW55IG90aGVyIHByb3Zpc2lvbnMgb2YgdGhpcyBwcml2YWN5IHBvbGljeSwgaW4gY29ubmVjdGlvbiB3aXRoIHRoZSBwcm92aXNpb24gb2Ygc3VjaCBzZXJ2aWNlcywgQ29uc3RhbnQgUmV0YWlsIG1heSBjb2xsZWN0IGFuZCB1c2UgZm9yIGFueSBwdXJwb3NlIGRhdGEgYW5kIGluZm9ybWF0aW9uIGRlcml2ZWQgZnJvbSBvdXIgc2l0ZSBhbmQgeW91ciB1c2FnZSB0aGVyZW9mLiZuYnNwOyBIb3dldmVyLCBDb25zdGFudCBSZXRhaWwgd2lsbCBub3QgbWFrZSB1c2Ugb2YgeW91ciBuYW1lLCBlbWFpbCBhZGRyZXNzLCBiaWxsaW5nIGFuZCBzaGlwLXRvIGFkZHJlc3NlcywgcGhvbmUgbnVtYmVyKHMpLCBhbmQgdGhlIGNyZWRpdCBjYXJkLCBiYW5rIGFjY291bnQgb3Igb3RoZXIgcGF5bWVudCBpbmZvcm1hdGlvbiBwcm92aWRlZCBieSB5b3UuJnJkcXVvOzwvZW0+PC9wPiA8cD48c3Ryb25nPjx1PkFkZGVuZHVtICZuZGFzaDsgVGVybXMgYW5kIENvbmRpdGlvbnM8L3U+PC9zdHJvbmc+PC9wPiA8ZGl2PiA8b2wgY2xhc3M9XCJuZXN0ZWQtbnVtZXJpYy1saXN0XCI+IDxsaT4gSG9zdGVkIFNpdGUuIDxvbD4gPGxpPjx1PkdlbmVyYWw8L3U+LiBDbGllbnQgaXMgaGVyZWJ5IGVuZ2FnaW5nIENvbnN0YW50IFJldGFpbCB0byBnZW5lcmF0ZSB0aGUgSG9zdGVkIFNpdGUgdGhyb3VnaCB0aGUgQ29uc3RhbnQgUmV0YWlsIFBsYXRmb3JtIGFuZCBiYXNlZCB1cG9uIHRoZSBpbnB1dCBwcm92aWRlZCBieSB0aGUgQ2xpZW50IGluIHRoZSBFbnJvbGxtZW50IFByb2Nlc3MgYXMgd2VsbCBhcyB0byBob3N0IGFuZCBtYWludGFpbiBzdWNoIHNpdGUgaW4gYWNjb3JkYW5jZSB3aXRoIHRoZSBwcm92aXNpb25zIG9mIDx1PlNlY3Rpb24gMS40PC91PiZuYnNwOyBDbGllbnQgYWdyZWVzLCB1bmRlcnN0YW5kcyBhbmQgYWNrbm93bGVkZ2VzIHRoYXQgYXQgYWxsIHRpbWVzOiAoYSkgZ2VuZXJhdGlvbiBvZiB0aGUgSG9zdGVkIFNpdGUgYW5kIHRoZSBkZXNpZ24sIGludGVyZmFjZSwgYXBwZWFyYW5jZSBhbmQgb3RoZXIgdmlzdWFsIGFuZCBmdW5jdGlvbmFsIGZlYXR1cmVzIG9mIHRoZSBIb3N0ZWQgU2l0ZSBhcmUgdG8gYmUgaW4gYWNjb3JkYW5jZSB3aXRoIENvbnN0YW50IFJldGFpbCZyc3F1bztzIGVzdGFibGlzaGVkIHRlbXBsYXRlcywgbG9va3MsIHZpZXdzIGFuZCBmb3JtYXQgKHdoaWNoIENvbnN0YW50IFJldGFpbCBtYXksIGluIGl0cyBzb2xlIGRpc2NyZXRpb24sIHVwZGF0ZSBhbmQgcmV2aXNlIGZyb20gdGltZSB0byB0aW1lKSwgYW5kIChiKSB0aGUgSG9zdGVkIFNpdGUgc2hhbGwgYmVhciB0aGUgcGhyYXNlICZsZHF1bztQb3dlcmVkIGJ5IENvbnN0YW50IFJldGFpbCZyZHF1bzsgb3Igc3VjaCBvdGhlciBpbmRpY2F0aW9uIG9mIHRoZSBnZW5lcmF0aW9uIGFuZC9vciBob3N0aW5nIG9mIHRoZSBIb3N0ZWQgU2l0ZSBieSBDb25zdGFudCBSZXRhaWwgYW5kIHRoZSBDb25zdGFudCBSZXRhaWwgUGxhdGZvcm0uJm5ic3A7IENvbnN0YW50IFJldGFpbCwgYXQgaXRzIGVsZWN0aW9uLCBtYXksIGJ1dCBpcyBub3Qgb2JsaWdhdGVkIHRvIGFuZCBkb2VzIG5vdCBndWFyYW50ZWUgdGhhdCBpdCB3aWxsLCB3b3JrIHdpdGggYSBDbGllbnQsIHVwb24gcmVxdWVzdCB0byBjdXN0b21pemUgaXRzIEhvc3RlZCBTaXRlIHRocm91Z2ggdGhlIGFkZGl0aW9uIG9yIG1vZGlmaWNhdGlvbiBvZiBhbnkgZGVzaWduIG9yIGZ1bmN0aW9uIGZlYXR1cmVzIG9mIHRoZSBIb3N0ZWQgU2l0ZSBhcyBtYXkgYmUgYWdyZWVkIHVwb24gYmV0d2VlbiBDbGllbnQgYW5kIENvbnN0YW50IFJldGFpbCwgYW5kIGZvciBhZGRpdGlvbmFsIGNoYXJnZXMsIGFzIG1heSBiZSBhZ3JlZWQgdXBvbiwgZm9yIHN1Y2ggd29yay48L2xpPiA8bGk+PHU+U2VsZWN0ZWQgQnJhbmRzPC91Pi4gQ29uc3RhbnQgUmV0YWlsIHNoYWxsIG1ha2UgYXZhaWxhYmxlIHRoZSBTZWxlY3RlZCBCcmFuZHMgdGhyb3VnaCB0aGUgSG9zdGVkIFNpdGUgd2hvc2UgdW5kZXJseWluZyBwcm9kdWN0cyBDbGllbnQgbWF5IG1ha2UgYXZhaWxhYmxlIGFuZCBvZmZlciBmb3Igc2FsZSB0aHJvdWdoIHRoZSBIb3N0ZWQgU2l0ZSwgPHU+cHJvdmlkZWQ8L3U+IHRoYXQgaW4gdGhlIGV2ZW50IHRoZSBDbGllbnQgaGFzIHNlbGVjdGVkIEFkZGl0aW9uYWwgQnJhbmRzIHRvIGJlIG9mZmVyZWQgdGhyb3VnaCB0aGUgSG9zdGVkIFNpdGUsIHRoZSBpbmNsdXNpb24gb2Ygc3VjaCBBZGRpdGlvbmFsIEJyYW5kcyBvbiB0aGUgSG9zdGVkIFNpdGUgc2hhbGwgYmUgc3ViamVjdCB0byBDb25zdGFudCBSZXRhaWwgZmlyc3Qgb2J0YWluaW5nIGF1dGhvcml6YXRpb24gYW5kIGFwcHJvdmFsLCBhcyB3ZWxsIGFzIHJlcXVpc2l0ZSB0ZWNobmljYWwgc3VwcG9ydCwgZnJvbSB0aGUgVmVuZG9ycyBmb3Igc3VjaCByZXF1ZXN0ZWQgQWRkaXRpb25hbCBCcmFuZHMgcmVxdWlyZWQgdG8gaW5jbHVkZSBzdWNoIEFkZGl0aW9uYWwgQnJhbmRzIGluIHRoZSBIb3N0ZWQgU2l0ZSwgd2l0aCZuYnNwOyBhZGRpdGlvbmFsIGZlZXMgdGhlcmVmb3IgYmVpbmcgcGF5YWJsZSBieSB0aGUgQ2xpZW50IHRvIENvbnN0YW50IFJldGFpbCBhcyBwcm92aWRlZCBmb3IgaW4gdGhlIEZlZSBBZGRlbmR1bS48L2xpPiA8bGk+PHU+RW5yb2xsbWVudCBQcm9jZXNzPC91Pi4gVGhlIENsaWVudCByZXByZXNlbnRzIGFuZCB3YXJyYW50cyB0byBDb25zdGFudCBSZXRhaWwgdGhhdCBhbGwgb2YgdGhlIGZvbGxvd2luZyBhcmUgdHJ1ZSBhbmQgY29ycmVjdCBhbmQgc2hhbGwgcmVtYWluIHNvIGR1cmluZyB0aGUgVGVybTogKGEpIHRoZSBDbGllbnQgaXMgYW4gYXV0aG9yaXplZCByZXRhaWxlciwgaW4gZ29vZCBzdGFuZGluZywgZm9yIHRoZSBTZWxlY3RlZCBCcmFuZHMsIGFuZCBwb3NzZXNzIGFsbCBhcHByb3ZhbHMsIGxpY2Vuc2VzLCBjb25zZW50cyBhbmQgcGVybWl0cyByZXF1aXJlZCB0byBzZWxsIGFuZCBtYXJrZXQgdGhlIHByb2R1Y3RzIHJlbGF0ZWQgdG8gdGhlIFNlbGVjdGVkIEJyYW5kcyBvbiB0aGUgSG9zdGVkIFNpdGU7IChiKSB3aXRoIHJlc3BlY3QgdG8gYW55IGNvbnRlbnQgb3IgaW5mb3JtYXRpb24sIHdoZXRoZXIgaW4gdGhlIGZvcm0gb2YgaW1hZ2VzLCB0ZXh0LCBzcGVjaWZpY2F0aW9ucywgZ3JhcGhpY3MsIHZpZGVvIG9yIGF1ZGlvIHJlY29yZGluZ3Mgb3IgYW55IG90aGVyIG1lZGl1bSB3aGF0c29ldmVyLCB1c2VkIGluIHRoZSBIb3N0ZWQgU2l0ZSBhbmQgdGhhdCBpcyBub3QgQ29uc3RhbnQgUmV0YWlsIENvbnRlbnQsIHdoZXRoZXIgcHJvdmlkZWQgYnkgdGhlIENsaWVudCB0byBDb25zdGFudCBSZXRhaWwgb3Igb2J0YWluZWQgZnJvbSBhIHRoaXJkLXBhcnR5IHNvdXJjZSBhdCB0aGUgZGlyZWN0aW9uIG9mIHRoZSBDbGllbnQsIHRoZSBDbGllbnQgaGFzIGFsbCByaWdodHMsIGNvbnNlbnQsIHBlcm1pc3Npb24gYW5kIGF1dGhvcml6YXRpb24gdG8gdXNlIHN1Y2ggY29udGVudCBvciBpbmZvcm1hdGlvbiBvbiB0aGUgSG9zdGVkIFNpdGUsIHdoZXRoZXIgYXMgdGhlIG93bmVyIHRoZXJlb2YsIHZhbGlkIGxpY2Vuc2VlIHRoZXJlb2YsIG9yIG90aGVyd2lzZTsgKGMpIHRoZSBDbGllbnQgaXMgdGhlIHZhbGlkLCBhdXRob3JpemVkLCByZWNvcmQgaG9sZGVyIG9mIHRoZSBjcmVkaXQgY2FyZCBhY2NvdW50IGluZm9ybWF0aW9uIHByb3ZpZGVkIGR1cmluZyB0aGUgRW5yb2xsbWVudCBQcm9jZXNzIGFuZCB0aGF0IHN1Y2ggYWNjb3VudCBwb3NzZXNzIHN1ZmZpY2llbnQgbGluZXMgb2YgYXZhaWxhYmxlIGNyZWRpdCB0byBjb3ZlciB0aGUgY29zdHMgdG8gdGhlIENsaWVudCBvZiB0aGUgc2VydmljZXMgcHJvdmlkZWQgaGVyZXVuZGVyOyAoZCkgdGhlIEFwcGxpY2FibGUgU2FsZXMgVGF4IFJhdGVzIGhhdmUgYmVlbiBkZXRlcm1pbmVkIHRocm91Z2ggYWR2aWNlIGFuZCBjb25zdWx0YXRpb24gd2l0aCB0YXggY29uc3VsdGFudHMgb3IgZXhwZXJ0cyBvciBhIGNlcnRpZmllZCBwdWJsaWMgYWNjb3VudGFudDsgYW5kIChlKSB0aGUgRGVzaWduYXRlZCBVUkxTIGFyZSByZWdpc3RlcmVkIGluIHRoZSBuYW1lIG9mIHRoZSBDbGllbnQgb3Igb25lIG9mIGl0cyBBZmZpbGlhdGVzIGFuZCB0aGUgQ2xpZW50IGhhcyBhbGwgYXV0aG9yaXphdGlvbiBhbmQgcmlnaHQgdG8gdXNlIHRoZSBEZXNpZ25hdGVkIFVSTHMuJm5ic3A7IENsaWVudCBmdXJ0aGVyIHJlcHJlc2VudHMgYW5kIHdhcnJhbnRzIHRoYXQgYWxsIGluZm9ybWF0aW9uIG90aGVyd2lzZSBwcm92aWRlZCB0byBDb25zdGFudCBSZXRhaWwgYnkgdGhlIENsaWVudCBpbiBjb25uZWN0aW9uIHdpdGggdGhlIEVucm9sbG1lbnQgUHJvY2VzcyBpcyB0cnVlIGFuZCBjb3JyZWN0IGFuZCBzaGFsbCByZW1haW4gc28gZHVyaW5nIHRoZSBUZXJtLiAmbmJzcDtBbnkgaW5kaXZpZHVhbCBvciBlbnRpdHkgYWN0aW5nIG9uIGJlaGFsZiBvZiB0aGUgQ2xpZW50IGluIGFjY2VwdGluZyB0aGVzZSBUZXJtcyBhbmQgQ29uZGl0aW9ucyBhcyBwYXJ0IG9mIHRoZSBFbnJvbGxtZW50IFByb2Nlc3MgcmVwcmVzZW50cyBhbmQgd2FycmFudHMgdGhhdCBoZSwgc2hlIG9yIGl0IGhhcyB0aGUgcmlnaHQgdG8gYWN0IG9uIGJlaGFsZiBvZiB0aGUgQ2xpZW50IGFuZCB0byBsZWdhbGx5IGJpbmQgQ2xpZW50IHRvIHRoZXNlIFRlcm1zIGFuZCBDb25kaXRpb25zIGFuZCBDb25zdGFudCBSZXRhaWwgbWF5IHJlbHkgb24gc3VjaCByZXByZXNlbnRhdGlvbiBhbmQgd2FycmFudHkgZm9yIGFsbCBwdXJwb3Nlcy48L2xpPiA8bGk+PHU+SG9zdGluZyBhbmQgTWFpbnRlbmFuY2Ugb2YgdGhlIEhvc3RlZCBTaXRlPC91Pi4gQ29uc3RhbnQgUmV0YWlsIGFncmVlcyB0byB0YWtlIGNvbW1lcmNpYWxseSByZWFzb25hYmxlIGVmZm9ydHMgdG8gaG9zdCBhbmQgbWFpbnRhaW4gdGhlIEhvc3RlZCBTaXRlIGFzIHByb3ZpZGVkIGZvciBpbiB0aGVzZSBUZXJtcyBhbmQgQ29uZGl0aW9ucywgaW5jbHVkaW5nLCB3aXRob3V0IGxpbWl0YXRpb24sIHRha2luZyBjb21tZXJjaWFsbHkgcmVhc29uYWJsZSBlZmZvcnRzIHRvOiAoYSkgb3BlcmF0ZSB0aGUgSG9zdGVkIFNpdGUgYXQgdGhlIERlc2lnbmF0ZWQgVVJMczsgKGIpIG1ha2UgdGhlIEhvc3RlZCBTaXRlIGFjY2Vzc2libGUgdG8gYWxsIHZpc2l0b3JzIHRvIHRoZSBIb3N0ZWQgU2l0ZSAyNCBob3VycyBhIGRheSwgc2V2ZW4gZGF5cyBhIHdlZWssIGV4Y2VwdCBmb3Igc3VjaCB0aW1lcyBkdXJpbmcgd2hpY2ggbWFpbnRlbmFuY2UgYW5kIHJlcGFpcnMgYXJlIHNjaGVkdWxlZCBmb3IgdGhlIEhvc3RlZCBTaXRlOyBhbmQgKGMpIGVuc3VyZSB0aGF0IEN1c3RvbWVyIEluZm9ybWF0aW9uIGlzIHByb3RlY3RlZCBpbiBhY2NvcmRhbmNlIHdpdGggdGhlIHRlcm1zIG9mIDx1PlNlY3Rpb24gNS4xPC91PiBvZiB0aGVzZSBUZXJtcyBhbmQgQ29uZGl0aW9ucyBhbmQgaXMga2VwdCBzZXBhcmF0ZSBmcm9tLCBhbmQgbm90IHVzZWQgZm9yIG9yIHdpdGggb3RoZXIgZS1jb21tZXJjZSBzaXRlcyBkZXZlbG9wZWQgYW5kL29yIGhvc3RlZCBieSBDb25zdGFudCBSZXRhaWwuJm5ic3A7IENsaWVudCBhZ3JlZXMsIHVuZGVyc3RhbmRzIGFuZCBhY2tub3dsZWRnZXM6ICh4KSB0aGF0IHRoZSBlbmdhZ2VtZW50IGNvbnRlbXBsYXRlZCBoZXJldW5kZXIgaXMgbm9uLWV4Y2x1c2l2ZSBpbiBuYXR1cmUgYW5kIHRoYXQgQ29uc3RhbnQgUmV0YWlsIG1heSwgd2l0aG91dCBhbnkgb2JsaWdhdGlvbiBvciBsaWFiaWxpdHkgdG8gQ2xpZW50LCBlbmdhZ2Ugd2l0aCBhbnkgdGhpcmQtcGFydHkgd2hhdHNvZXZlciwgZWl0aGVyIGluIGNvbm5lY3Rpb24gd2l0aCB0aGUgcHJvdmlzaW9uIG9mIHNpbWlsYXIgc2VydmljZXMgcHJvdmlkZWQgdG8gdGhlIENsaWVudCBvciBvdGhlcndpc2U7ICh5KSB0aGF0IHN1Y2ggdGhpcmQgcGFydGllcyBtYXkgYmUgY29tcGV0aXRvcnMgb2YgdGhlIENsaWVudCBvciBQZXJzb25zIHdpdGggaW50ZXJlc3RzIGFkdmVyc2UgdG8gb3IgaW4gY29uZmxpY3Qgd2l0aCB0aG9zZSBvZiB0aGUgQ2xpZW50OyBhbmQgKHopIHRoYXQgbm90aGluZyBoZXJlaW4gc2hhbGwgYmUgY29uc3RydWVkLCBkZWVtZWQgb3IgaW50ZXJwcmV0ZWQgYXMgYSBjb21taXRtZW50IG9uIHRoZSBwYXJ0IG9mIENvbnN0YW50IFJldGFpbCB0byBkZXZvdGUgYW55IHRpbWUsIHJlc291cmNlcywgb3IgZWZmb3J0cyB0byB0aGUgQ2xpZW50IGFuZCB0aGUgSG9zdGVkIFNpdGUgdG8gYSBncmVhdGVyIG9yIGxlc3NlciBleHRlbnQgdGhhbiB3aGF0IENvbnN0YW50IFJldGFpbCBkZXZvdGVzIHRvIGFueSB0aGlyZCBwYXJ0eSByZWNlaXZpbmcgdGhlIHNhbWUgb3Igc3Vic3RhbnRpYWxseSBzaW1pbGFyIHNlcnZpY2VzIGFzIHRob3NlIGNvbnRlbXBsYXRlZCBpbiB0aGVzZSBUZXJtcyBhbmQgQ29uZGl0aW9ucyBvciBiZWluZyBzZXJ2aWNlZCBvdGhlcndpc2UuPC9saT4gPGxpPjx1Pk9wZXJhdGlvbiBvZiBDbGllbnQmcnNxdW87cyBFLUNvbW1lcmNlIEJ1c2luZXNzPC91Pi4gVGhlIHBhcnRpZXMgYWdyZWUsIHVuZGVyc3RhbmQgYW5kIGFja25vd2xlZGdlIHRoYXQgdGhlIEhvc3RlZCBTaXRlIGlzIGJlaW5nIGhvc3RlZCBhbmQgbWFpbnRhaW5lZCBieSBDb25zdGFudCBSZXRhaWwgZm9yIG9wZXJhdGlvbiBieSB0aGUgQ2xpZW50IG9mIGl0cyBlLWNvbW1lcmNlIHJldGFpbCBidXNpbmVzcyB0aHJvdWdoIHRoZSBIb3N0ZWQgU2l0ZSBhbmQsIGZvciB0aGUgYXZvaWRhbmNlIG9mIGRvdWJ0LCBhbGwgcmVzcG9uc2liaWxpdGllcyBhbmQgbGlhYmlsaXRpZXMgZm9yIGFuZCByZWdhcmRpbmcgdGhlIG9wZXJhdGlvbiwgbWFuYWdlbWVudCBhbmQgYWRtaW5pc3RyYXRpb24gb2Ygc3VjaCBidXNpbmVzcyBhcmUgdGhlIENsaWVudCZyc3F1bztzLCBhbmQgbm90IHRoYXQgb2YgZWl0aGVyIENvbnN0YW50IFJldGFpbCBvciBhbnkgb2YgaXRzIEFmZmlsaWF0ZXMsIGFuZCBpbiBubyBldmVudCBzaGFsbCBlaXRoZXIgQ29uc3RhbnQgUmV0YWlsIG9yIGFueSBvZiBpdHMgQWZmaWxpYXRlcyBoYXZlIGFueSBsaWFiaWxpdHkgb3IgcmVzcG9uc2liaWxpdHkgd2hhdHNvZXZlciB0byBhbnkgQ3VzdG9tZXJzIG9yIGFueSBWZW5kb3JzLCBpbmNsdWRpbmcgd2l0aG91dCBsaW1pdGF0aW9uIHdpdGggcmVzcGVjdCB0byB0aGUgZnVsZmlsbG1lbnQgb2Ygb3JkZXJzIG9yIGZvciByZWZ1bmRzIG9yIGNyZWRpdHMgdXBvbiB0aGUgcmV0dXJuIG9mIGFueSBNZXJjaGFuZGlzZSwgYm90aCBvZiB3aGljaCBhcmUgc29sZWx5IHRoZSByZXNwb25zaWJpbGl0eSBvZiB0aGUgQ2xpZW50LiZuYnNwOyBGdXJ0aGVybW9yZSwgaW4gY29ubmVjdGlvbiB3aXRoIGZ1bGZpbG1lbnQgb2YgTWVyY2hhbmRpc2Ugb3JkZXJzLCBDbGllbnQgc2hhbGwgYmUgcmVzcG9uc2libGUgZm9yIGFycmFuZ2luZyBzaGlwcGluZyBhbmQgZnJlaWdodCBzZXJ2aWNlcyBmb3IgZGVsaXZlcnkgb2Ygc3VjaCBNZXJjaGFuZGlzZSB0byB0aGUgYXBwbGljYWJsZSBDdXN0b21lciwgPHU+cHJvdmlkZWQ8L3U+IHRoYXQgQ2xpZW50IG1heSBlbGVjdCB0byBoYXZlIHN1Y2ggc2hpcHBpbmcgcmVxdWlyZW1lbnRzIHdpdGhpbiB0aGUgY29udGluZW50YWwgVW5pdGVkIFN0YXRlcyBvZiBBbWVyaWNhIChpLmUuIHRoZSBsb3dlciA0OCBzdGF0ZXMgb2YgdGhlIFVuaXRlZCBTdGF0ZXMgb2YgQW1lcmljYSBhbmQgbm90IEFsYXNrYSBhbmQgSGF3YWlpKSBmdWxmaWxsZWQgdGhyb3VnaCB0aG9zZSBzZXJ2aWNlcyBvZmZlcmVkIGJ5IENvbnN0YW50IFJldGFpbCB1bmRlciAmbGRxdW87RnJlaWdodCBDbHViJnJkcXVvOywgYXMgb2ZmZXJlZCwgYW5kIGFzIG1heSBiZSBlbGVjdGVkIGJ5IHRoZSBDbGllbnQsIGR1cmluZyB0aGUgRW5yb2xsbWVudCBQcm9jZXNzIGFuZCBzdWJqZWN0IHRvIGFjY2VwdGFuY2Ugb2YgdGhlIGFwcGxpY2FibGUgdGVybXMgYW5kIGNvbmRpdGlvbnMgZm9yIHB1cmNoYXNlIG9mIHNoaXBwaW5nIGFuZCBmcmVpZ2h0IHNlcnZpY2VzIHRocm91Z2ggJmxkcXVvO0ZyZWlnaHQgQ2x1YiZyZHF1bzsuICZuYnNwOyZuYnNwO1doaWxlIENvbnN0YW50IFJldGFpbCBob3N0cyB0aGUgSG9zdGVkIFNpdGUsIHRoZSBDbGllbnQgaXMgdGhlIHNlbGxlciBvZiBhbGwgTWVyY2hhbmRpc2Ugc29sZCB0aHJvdWdoIHRoZSBIb3N0ZWQgYW5kLCBhcyBzdWNoLCBhbGwgcmV2ZW51ZXMgZnJvbSB0aGUgc2FsZSBvZiBNZXJjaGFuZGlzZSB0aHJvdWdoIHRoZSBIb3N0ZWQgU2l0ZSBzaGFsbCBiZSBkZWVtZWQgZm9yIGFsbCBwdXJwb3NlcyBDbGllbnQgcmV2ZW51ZXMuJm5ic3A7IEFsbCBwcm9jZWVkcyBmcm9tIHRoZSBzYWxlIG9mIE1lcmNoYW5kaXNlIHRocm91Z2ggdGhlIEhvc3RlZCBTaXRlIG9uIHRoZSBIb3N0ZWQgU2l0ZSB3aWxsIGJlIGNvbGxlY3RlZCBhbmQgcHJvY2Vzc2VkIGJ5IHRoZSBDbGllbnQgYW5kIHRoZSBDbGllbnQgd2lsbCBiZSByZXNwb25zaWJsZSBmb3IgKGEpIGVzdGFibGlzaGluZyB0aGUgc2VsbGluZyBwcmljZSBmb3Igc3VjaCBNZXJjaGFuZGlzZSwgPHU+KGIpIGRldGVybWluaW5nIHRoZSBBcHBsaWNhYmxlIFNhbGVzIFRheCBSYXRlcyBhbmQgY29ycmVjdGx5IGVudGVyaW5nIHRoZW0gZHVyaW5nIHRoZSBFbnJvbGxtZW50IFByb2Nlc3MgZm9yIGluY29ycG9yYXRpb24gaW50byB0aGUgcGF5bWVudCBwcm9jZXNzIG9mIHRoZSBIb3N0ZWQgU2l0ZSBieSB0aGUgQ29uc3RhbnQgUmV0YWlsIFBsYXRmb3JtOyA8L3U+PHU+YW5kIChjKSBjb2xsZWN0aW5nIGFuZCBwYXlpbmcgYWxsIDwvdT48dT5mZWRlcmFsIGFuZCBzdGF0ZSA8L3U+PHU+c2FsZXMsIHVzZSwgdHJhbnNmZXIsIG9yIHNpbWlsYXIgdGF4ZXMgcGF5YWJsZSB0byBhbnkgZ292ZXJubWVudGFsIGF1dGhvcml0eSBvbiBhbnkgc2FsZSBvZiBNZXJjaGFuZGlzZSB0aHJvdWdoIHRoZSBIb3N0ZWQgU2l0ZSBhcyB3ZWxsIGFzIG9uIGFueSBvdGhlciBjaGFyZ2UgbWFkZSBpbiBjb25uZWN0aW9uIHdpdGggc3VjaCBzYWxlIGJhc2VkIG9uIHRoZSBBcHBsaWNhYmxlIFNhbGVzIFRheCBSYXRlczwvdT4uJm5ic3A7PC9saT4gPC9vbD4gPC9saT4gPGxpPiBNYXJrZXRpbmcgYW5kIEFkdmVydGlzaW5nIFNlcnZpY2VzLiA8b2w+IDxsaT48dT5NYXJrZXRpbmcgU2VydmljZXM8L3U+LiBJbiB0aGUgZXZlbnQgdGhlIENsaWVudCBoYXMgZWxlY3RlZCB0byByZWNlaXZlIG1hcmtldGluZyBzZXJ2aWNlcyBkdXJpbmcgdGhlIEVucm9sbG1lbnQgUHJvY2VzcywgQ29uc3RhbnQgUmV0YWlsIGFncmVlcyB0byBwcm92aWRlIHRvIENsaWVudCBzdWNoIHNlcnZpY2VzIGFzIGRlc2NyaWJlZCBpbiB0aGlzIDx1PlNlY3Rpb24gMi4xPC91Pi4gQ29uc3RhbnQgUmV0YWlsIHNoYWxsIGRlc2lnbmF0ZSBhbmQgbWFrZSBhdmFpbGFibGUgZm9yIENsaWVudCBkdXJpbmcgb3JkaW5hcnkgYnVzaW5lc3MgaG91cnMgYSBtYXJrZXRpbmcgbWFuYWdlciB0byBhc3Npc3QgYW5kIGNvbnN1bHQgd2l0aCB0aGUgQ2xpZW50IGluIHRoZSBwcm92aXNpb24gb2Ygc3VjaCBzZXJ2aWNlcy4mbmJzcDsgQ29uc3RhbnQgUmV0YWlsIHNoYWxsIGNhdXNlIHN1Y2ggbWFya2V0aW5nIG1hbmFnZXIgdG8gd29yayB3aXRoIHRoZSBDbGllbnQgdG8gaWRlbnRpZnkgdGhvc2UgbWFya2V0aW5nIGNoYW5uZWxzIChzdWNoIGFzIEdvb2dsZSwgTWljcm9zb2Z0LUJpbmcsIFNob3BwaW5nLmNvbSwgYW5kIE5leHRhZy5jb20pIHRocm91Z2ggd2hvbSBDbGllbnQgZGVzaXJlcyBDb25zdGFudCBSZXRhaWwgdG8gbWFya2V0IHRoZSBIb3N0ZWQgU2l0ZSBhbmQsIHVwb24gYXBwcm92YWwgYnkgQ29uc3RhbnQgUmV0YWlsIG9mIHRob3NlIG1hcmtldGluZyBjaGFubmVscyBzZWxlY3RlZCBieSBDbGllbnQsIG1hcmtldGluZyBhY2NvdW50cyB3aXRoIHN1Y2ggbWFya2V0aW5nIGNoYW5uZWxzIHNoYWxsIGJlIGVzdGFibGlzaGVkIGJ5IHRoZSBDbGllbnQuJm5ic3A7IFRocm91Z2ggc3VjaCBtYXJrZXRpbmcgYWNjb3VudHMsIENvbnN0YW50IFJldGFpbCBzaGFsbCBtYXJrZXQgdGhlIEhvc3RlZCBTaXRlIGFuZCB0aGUgcHJvZHVjdHMgYmVpbmcgb2ZmZXJlZCBvbiB0aGUgSG9zdGVkIFNpdGUgYnkgcHVyY2hhc2luZyBzZWFyY2ggd29yZHMgb24gc2VhcmNoIGVuZ2luZXMgYW5kIGxpc3RpbmdzIG9uIGNvbXBhcmlzb24gc2hvcHBpbmcgZW5naW5lcyB3aGljaCwgaW4gQ29uc3RhbnQgUmV0YWlsJnJzcXVvO3Mgc29sZSBkaXNjcmV0aW9uLCBtYXkgZ2VuZXJhdGUgQ3VzdG9tZXJzIG9yIGRpcmVjdCB1c2VycyB0b3dhcmRzIHRoZSBIb3N0ZWQgU2l0ZSwgd2l0aCBzdWNoIGNvc3RzIHJlbGF0ZWQgdG8gc3VjaCBwdXJjaGFzZXMgdG8gYmUgY292ZXJlZCBieSB0aGUgQ2xpZW50LiZuYnNwOyBNb250aGx5IEZlZXMgcGF5YWJsZSBieSBDbGllbnQgYW5kIGNvc3RzIGFuZCBjaGFyZ2VzIHRvIGJlIGNvdmVyZWQgYnkgdGhlIENsaWVudCBmb3IgdGhlIHNlcnZpY2VzIGRlc2NyaWJlZCBpbiB0aGlzIDx1PlNlY3Rpb24gMi4xPC91PiBzaGFsbCBiZSBpbiBhY2NvcmRhbmNlIHdpdGggQ29uc3RhbnQgUmV0YWlsJnJzcXVvO3MgY3VycmVudCByYXRlcyBpbiBlZmZlY3QgZm9yIHN1Y2ggc2VydmljZXMgYXMgc2V0IGZvcnRoIGluIHRoZSBGZWUgQWRkZW5kdW0gYW5kIHBheWFibGUgYXMgZnVydGhlciBkZXNjcmliZWQgaW4gPHU+U2VjdGlvbiA0PC91PiZuYnNwOzwvbGk+IDxsaT48dT5BZHZlcnRpc2luZyBTZXJ2aWNlczwvdT4uIEluIHRoZSBldmVudCB0aGUgQ2xpZW50IGhhcyBlbGVjdGVkIHRvIHJlY2VpdmUgYWR2ZXJ0aXNpbmcgc2VydmljZXMgZHVyaW5nIHRoZSBFbnJvbGxtZW50IFByb2Nlc3MsIENvbnN0YW50IFJldGFpbCBhZ3JlZXMgdG8gcHJvdmlkZSB0byBDbGllbnQgc3VjaCBzZXJ2aWNlcyBhcyBkZXNjcmliZWQgaW4gdGhpcyA8dT5TZWN0aW9uIDIuMjwvdT4uJm5ic3A7IENsaWVudCBoZXJlYnkgYXV0aG9yaXplcyBhbmQgaW5zdHJ1Y3RzIENvbnN0YW50IFJldGFpbCB0byBwdXJjaGFzZSBhbmQgcGxhY2UsIG9uIGJlaGFsZiBvZiB0aGUgQ2xpZW50LCBhZHZlcnRpc2luZyBmb3IgdGhlIEhvc3RlZCBTaXRlLCBhbG9uZyB3aXRoIHRoZSBwcm9kdWN0cyBiZWluZyBvZmZlcmVkIG9uIHRoZSBIb3N0ZWQgU2l0ZSwgb24gc3VjaCBvdGhlciB3ZWJzaXRlcyBhcyBDb25zdGFudCBSZXRhaWwgbWF5IHNlbGVjdCBpbiBpdHMgc29sZSBkaXNjcmV0aW9uLiZuYnNwOyBDb3N0cyByZWxhdGVkIHRvIHN1Y2ggcHVyY2hhc2VzIGFyZSB0byBiZSBjb3ZlcmVkIGJ5IHRoZSBDbGllbnQuJm5ic3A7IEFsbCBhZHZlcnRpc2luZyBzZXJ2aWNlcyBhZ3JlZW1lbnRzIGFuZCBvdGhlciBzaW1pbGFyIGNvbnRyYWN0cyB0byBiZSBlbnRlcmVkIGludG8gaW4gY29ubmVjdGlvbiB3aXRoIHRoZSBwbGFjZW1lbnQgb2Ygc3VjaCBhZHZlcnRpc2luZyBzaGFsbCBiZSB3aXRoIENsaWVudCwgb24gdGhlIG9uZSBoYW5kIChhbmQgbm90LCBmb3IgdGhlIGF2b2lkYW5jZSBvZiBkb3VidCwgQ29uc3RhbnQgUmV0YWlsIG9yIGFueSBvZiBpdHMgQWZmaWxpYXRlcyksIGFuZCB0aGUgYXBwbGljYWJsZSBhZHZlcnRpc2luZyBzZXJ2aWNlIHByb3ZpZGVyLCBvbiB0aGUgb3RoZXIgaGFuZC4mbmJzcDsgQ29uc3RhbnQgUmV0YWlsIHNoYWxsIGVuc3VyZSB0aGF0IGFsbCBzdWNoIGFkdmVydGlzaW5nIHNvIHB1cmNoYXNlZCBzaGFsbCBiZSBjYXBhYmxlIG9mIGRpcmVjdGluZyBhbnkgdmlld2VyIHRoZXJlb2Ygb25saW5lIHRvIHRoZSBIb3N0ZWQgU2l0ZSB0aHJvdWdoIGNsaWNraW5nIG9mIGFuIGVtYmVkZGVkIGh5cGVybGluay4mbmJzcDsgJm5ic3A7TW9udGhseSBGZWVzIHBheWFibGUgYnkgQ2xpZW50IGFuZCBjb3N0cyBhbmQgY2hhcmdlcyB0byBiZSBjb3ZlcmVkIGJ5IHRoZSBDbGllbnQgZm9yIHRoZSBzZXJ2aWNlcyBkZXNjcmliZWQgaW4gdGhpcyA8dT5TZWN0aW9uIDIuMjwvdT4gc2hhbGwgYmUgaW4gYWNjb3JkYW5jZSB3aXRoIENvbnN0YW50IFJldGFpbCZyc3F1bztzIGN1cnJlbnQgcmF0ZXMgaW4gZWZmZWN0IGZvciBzdWNoIHNlcnZpY2VzIGFzIHNldCBmb3J0aCBpbiB0aGUgRmVlIEFkZGVuZHVtIGFuZCBwYXlhYmxlIGFzIGZ1cnRoZXIgZGVzY3JpYmVkIGluIDx1PlNlY3Rpb24gNDwvdT4mbmJzcDs8L2xpPiA8bGk+PHU+R2VuZXJhbCBTdGF0ZW1lbnQgUmVnYXJkaW5nIE1hcmtldGluZyBhbmQgQWR2ZXJ0aXNpbmc8L3U+LiBFeGNlcHQgZm9yIHN1Y2ggc2VydmljZXMgcHVyc3VhbnQgdG8gZWl0aGVyIDx1PlNlY3Rpb24gMi4xPC91PiBvciA8dT5TZWN0aW9uIDIuMjwvdT4gYWJvdmUgYXMgbWF5IGhhdmUgYmVlbiBlbGVjdGVkIGZvciBieSB0aGUgQ2xpZW50LCB0aGUgQ2xpZW50IHNoYWxsIG90aGVyd2lzZSBiZSByZXNwb25zaWJsZSBpbiBhbGwgcmVzcGVjdHMgZm9yIGFsbCBhZHZlcnRpc2luZywgcHJvbW90aW9uIGFuZCBtYXJrZXRpbmcgb2YgdGhlIEhvc3RlZCBTaXRlLCB0aGUgTWVyY2hhbmRpc2UgZm9yIHNhbGUgb24gdGhlIEhvc3RlZCBTaXRlIGFuZCB0aGUgU2VsZWN0ZWQgQnJhbmRzIGF2YWlsYWJsZSBvbiB0aGUgSG9zdGVkIFNpdGUsIGFzIHdlbGwgYXMgY29zdHMgdGhlcmVvZiAod2hpY2ggY29zdHMgc2hhbGwgbm90LCBmb3IgdGhlIGF2b2lkYW5jZSBvZiBkb3VidCwgYmUgZGVlbWVkIHRvIHJlZHVjZSBOZXQgU2FsZXMgUmV2ZW51ZSkuJm5ic3A7IFRoZSBDbGllbnQgaGVyZWJ5IGFzc3VtZXMgYWxsIHJpc2sgb2YgbG9zc2VzIG9yIGNvc3RzIGZyb20gaW5lZmZlY3RpdmVuZXNzIG9mIGFueSBhZHZlcnRpc2luZywgcHJvbW90aW9uIGFuZCBtYXJrZXRpbmcsIHdoZXRoZXIgb2J0YWluZWQgdGhyb3VnaCBlaXRoZXIgPHU+U2VjdGlvbiAyLjE8L3U+IG9yIDx1PlNlY3Rpb24gMi4yPC91PiBhYm92ZSBvciBvdGhlcndpc2UsIGFuZCB3YWl2ZXMgYW5kIHJlbGVhc2VzIGFueSBhbmQgYWxsIGNsYWltcyBpdCBtYXkgaGF2ZSBhZ2FpbnN0IENvbnN0YW50IFJldGFpbCB3aXRoIHJlc3BlY3QgdGhlcmV0byBpbmNsdWRpbmcgd2l0aG91dCBsaW1pdGF0aW9uIGZvciB0aGUgbnVtYmVyIG9mIHZpc2l0b3JzIHRvIHRoZSBIb3N0ZWQgU2l0ZSBhbmQgdmFsdWUgb2YgcmVzdWx0aW5nIHNhbGVzLiZuYnNwOyBUaGUgQ2xpZW50IGFja25vd2xlZGdlcywgYWdyZWVzIGFuZCB1bmRlcnN0YW5kcyB0aGF0IGF0IG5vIHRpbWUsIGluY2x1ZGluZyBpbiB0aGUgZXZlbnQgaXQgZWxlY3RzIHNlcnZpY2VzIHVuZGVyIGVpdGhlciA8dT5TZWN0aW9uIDIuMTwvdT4gb3IgPHU+U2VjdGlvbiAyLjI8L3U+IGFib3ZlLCBzaGFsbCBDbGllbnQgaGF2ZSBhbnkgZW50aXRsZW1lbnQsIGxpY2Vuc2UsIG9yIHJpZ2h0IHRvIHVzZSBhbnkgb2YgdGhlIENvbnN0YW50IFJldGFpbCBJbnRlbGxlY3R1YWwgUHJvcGVydHksIHJlZ2FyZGluZyBzZWFyY2ggdGVybXMgb3Igb3RoZXIgbWFya2V0aW5nIGtub3dsZWRnZSB1dGlsaXplZCB0byBhdHRyYWN0IHZpc2l0b3JzIHRvIHRoZSBIb3N0ZWQgU2l0ZSBvciBhbnkgb3RoZXIgd2Vic2l0ZXMgaG9zdGVkIG9yIG9wZXJhdGVkIGJ5IENvbnN0YW50IFJldGFpbCBvciBhbnkgb2YgaXRzIEFmZmlsaWF0ZXMuJm5ic3A7PC9saT4gPC9vbD4gPC9saT4gPGxpPiBSZXBvcnRpbmc7IERhdGEgRmVlZHMuIDxvbD4gPGxpPjx1PlJlcG9ydGluZzwvdT4uIENvbnN0YW50IFJldGFpbCB3aWxsIHByb3ZpZGUgdGhlIENsaWVudCB3aXRoIHRoZSBhYmlsaXR5IHRvIGFjY2VzcyByZXBvcnRzIG9uIHRoZSBwZXJmb3JtYW5jZSBvZiB0aGUgZS1jb21tZXJjZSBidXNpbmVzcyBvZiB0aGUgSG9zdGVkIFNpdGUgd2hpY2ggcmVwb3J0cyBtYXkgaW5jbHVkZSB0aGUgZm9sbG93aW5nIGluZm9ybWF0aW9uOiAoYSkgdGhlIG51bWJlciBvZiB2aXNpdG9ycyB0byB0aGUgSG9zdGVkIFNpdGUsIGFzIG1lYXN1cmVkIGJ5IENvbnN0YW50IFJldGFpbDsgYW5kIChiKSBzYWxlcyBkYXRhIGZvciB0aGUgSG9zdGVkIFNpdGUsIGFzIG1lYXN1cmVkIGJ5IENvbnN0YW50IFJldGFpbCwgY29uc2lzdGluZyBvZjogKGkpIHRoZSBhZ2dyZWdhdGUgYW1vdW50IG9mIHNhbGVzIGluIGRvbGxhcnMgb2YgTWVyY2hhbmRpc2UgZm9yIHN1Y2ggbW9udGggYW5kIGEgYnJlYWtkb3duIG9mIHN1Y2ggc2FsZXMgaW50byBhIGxpc3Qgb2YgYWxsIE1lcmNoYW5kaXNlIHNoaXBwZWQsIGFsb25nIHdpdGggdGhlIG5hbWUsIHF1YW50aXR5LCBwcmljZSwgY2F0ZWdvcnkgYW5kIGl0ZW0gbnVtYmVycyBmb3Igc3VjaCBNZXJjaGFuZGlzZSwgKGlpKSBhIGxpc3Qgb2YgYWxsIEN1c3RvbWVyIHJldHVybnMsIGNoYXJnZWJhY2tzIGFuZCByZWZ1bmRzIHJlY2VpdmVkIG9yIGFjY2VwdGVkIGZvciBzYWxlcyBvZiBNZXJjaGFuZGlzZSB0aHJvdWdoIHRoZSBIb3N0ZWQgU2l0ZSwgKGlpaSkgYSBsaXN0IG9mIGFsbCBDdXN0b21lcnMgdGhhdCBoYXZlIHBsYWNlZCBvcmRlcnMgZm9yIE1lcmNoYW5kaXNlIHRocm91Z2ggdGhlIEhvc3RlZCBTaXRlLCBpbmNsdWRpbmcgdGhlaXIgcmVzcGVjdGl2ZSBuYW1lcyBhbmQgdGhlIGJpbGwgdG8gYW5kIHNoaXAgdG8gYWRkcmVzc2VzIGZvciBzdWNoIEN1c3RvbWVycywgYW5kIChpdikgZGF0YSByZWdhcmRpbmcgdGhlIHNhbGVzLCB1c2UsIHRyYW5zZmVyLCBvciBzaW1pbGFyIHRheGVzIGNvbGxlY3RlZCBhbmQgcmVtaXR0ZWQgYnkgdGhlIENsaWVudCB0aHJvdWdoIHRoZSBIb3N0ZWQgU2l0ZSBiYXNlZCBvbiB0aGUgQXBwbGljYWJsZSBTYWxlcyBUYXggUmF0ZXMgZm9yIHNhbGVzIG9mIE1lcmNoYW5kaXNlIG1hZGUuJm5ic3A7IFRoZSB0aW1lIHBlcmlvZCBvdmVyIHdoaWNoIHRoZSByZXBvcnRzIHJlZmVyZW5jZWQgaW4gdGhpcyA8dT5TZWN0aW9uIDMuMTwvdT4gbWF5IGJlIGdlbmVyYXRlZCBzaGFsbCBiZSBlc3RhYmxpc2hlZCBieSBDb25zdGFudCBSZXRhaWwuPC9saT4gPGxpPjx1PkRhdGEgRmVlZHM8L3U+LiBDb25zdGFudCBSZXRhaWwgd2lsbCBwZXJpb2RpY2FsbHkgcHJvdmlkZSBkYXRhIGZlZWRzIHRvIHRoZSBDbGllbnQgaW4gb3JkZXIgdG8gdXBkYXRlIGluZm9ybWF0aW9uIGNvbmNlcm5pbmcgTWVyY2hhbmRpc2UgdGhlbiBhdmFpbGFibGUgZm9yIHNhbGUgdGhyb3VnaCB0aGUgSG9zdGVkIFNpdGUuICZuYnNwO1N1Y2ggaW5mb3JtYXRpb24gbWF5IGluY2x1ZGUgcHJvZHVjdCBuYW1lcywgcHJvZHVjdCBkZXNjcmlwdGlvbnMsIHN0b2NrIGtlZXBpbmcgdW5pdCBvciAmbGRxdW87U0tVJnJkcXVvOyBudW1iZXJzLCBwcm9kdWN0IHByaWNlcywgc2hpcHBpbmcgY29zdHMsIGF2YWlsYWJpbGl0eSwgb3RoZXIgZGVzY3JpcHRpdmUgYXR0cmlidXRlcywgYW5kL29yIGxpbmtzIHRvIHByb2R1Y3RzIHdpdGhpbiB0aGUgSG9zdGVkIFNpdGUuPC9saT4gPC9vbD4gPC9saT4gPGxpPiBQYXltZW50IFRlcm1zLiA8b2w+IDxsaT48dT5GZWVzPC91Pi4gQmFzZWQgb24gdGhlIHNlbGVjdGlvbnMgbWFkZSBieSB0aGUgQ2xpZW50IGluIGNvbm5lY3Rpb24gd2l0aCB0aGUgRW5yb2xsbWVudCBQcm9jZXNzLCB0aGUgQ2xpZW50IHNoYWxsIHBheSB0byBDb25zdGFudCBSZXRhaWwgdGhlIGFwcGxpY2FibGUgY2hhcmdlIGluIFUuUy4gZG9sbGFycyBhcyBzZXQgZm9ydGggb24gdGhlIHRoZW4tY3VycmVudCBGZWUgQWRkZW5kdW0sIGFzIGNhbGN1bGF0ZWQgYnkgQ29uc3RhbnQgUmV0YWlsIGFuZCBpbiB0aGUgbWFubmVyIHByb3ZpZGVkIGZvciBpbiB0aGlzIDx1PlNlY3Rpb24gNDwvdT4gb2YgdGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMuJm5ic3A7IFRoZSBjdXJyZW50IEZlZSBBZGRlbmR1bSBpbiBlZmZlY3QgY2FuIGJlIHZpZXdlZCBbaGVyZV08YSBocmVmPVwiI19mdG4yXCIgbmFtZT1cIl9mdG5yZWYyXCI+WzJdPC9hPjxzdHJvbmc+Ljwvc3Ryb25nPiZuYnNwOzwvbGk+IDxsaT48dT5QYXltZW50PC91Pi4gVmFsaWQgY3JlZGl0IGNhcmQgYWNjb3VudCBpbmZvcm1hdGlvbiBhcyB3ZWxsIGFzIHByZS1hdXRob3JpemF0aW9uIG9mIHRoZSBjaGFyZ2VzIGZvciBwYXltZW50IGZvciBzZXJ2aWNlcyBoZXJldW5kZXIgYXJlIHJlcXVpcmVkIGZyb20gdGhlIENsaWVudCBhcyBwYXJ0IG9mIHRoZSBFbnJvbGxtZW50IFByb2Nlc3MgYW5kIGFsbCBwYXltZW50cyBmb3Igc2VydmljZXMgcHJvdmlkZWQgYnkgQ29uc3RhbnQgUmV0YWlsIHNoYWxsIGJlIGJ5IHN1Y2ggcHJlLWF1dGhvcml6ZWQgY2hhcmdlcyB0byBzdWNoIENsaWVudCZyc3F1bztzIGNyZWRpdCBjYXJkIGFjY291bnQgcHJvdmlkZWQgYXMgcGFydCBvZiB0aGUgRW5yb2xsbWVudCBQcm9jZXNzIChvciBhbnkgdXBkYXRlZCBhY2NvdW50KS4mbmJzcDsgTW9udGhseSBGZWVzIHNoYWxsIGJlIGNoYXJnZWQgb24gdGhlIGZpcnN0IGJ1c2luZXNzIGRheSBvZiBldmVyeSBtb250aCBkdXJpbmcgdGhlIFRlcm0sIHByaW9yIHRvIHNlcnZpY2UgZm9yIHN1Y2ggbW9udGggKHdpdGggc3VjaCBNb250aGx5IEZlZSBiZWluZyBwcm8tcmF0ZWQgZm9yIGFueSBwYXJ0aWFsIGluaXRpYWwgbW9udGggaW4gdGhlIFRlcm0pLiZuYnNwOyBXaGVyZSBhbnkgcGFydCBvZiB0aGUgZmVlcyBwYXlhYmxlIGhlcmV1bmRlciBhcmUgYmFzZWQgb24gYSBwZXJjZW50YWdlIG9mIE5ldCBTYWxlcyBSZXZlbnVlIGFzIHByb3ZpZGVkIGZvciBpbiB0aGUgRmVlIEFkZGVuZHVtLCBzdWNoIGZlZSBzaGFsbCBiZSBjaGFyZ2VkIHVwb24gY29uZmlybWF0aW9uIGJ5IENsaWVudCBvZiBjb21wbGV0aW9uIG9mIHRoZSBhcHBsaWNhYmxlIHRyYW5zYWN0aW9uIGdlbmVyYXRpbmcgc3VjaCBOZXQgU2FsZXMgUmV2ZW51ZXMgYW5kIGFzIGNhbGN1bGF0ZWQgYnkgdGhlIENvbnN0YW50IFJldGFpbCBQbGF0Zm9ybS4mbmJzcDsgT3RoZXIgdGhhbiBhbnkgTW9udGhseSBGZWUgYXNzb2NpYXRlZCB3aXRoIGFueSBvZiB0aGUgc2VydmljZXMgcHJvdmlkZWQgdW5kZXIgPHU+U2VjdGlvbiAyPC91PiBvZiB0aGVzZSBUZXJtcyBhbmQgQ29uZGl0aW9ucyAod2hpY2ggTW9udGhseSBGZWUgc2hhbGwgYmUgY2hhcmdlZCBhcyBwcm92aWRlZCBmb3IgaW4gdGhlIHNlY29uZCBzZW50ZW5jZSBvZiB0aGlzIDx1PlNlY3Rpb24gNC4yPC91PiksIHRoZSBjb3N0cyBhbmQgY2hhcmdlcyBwYXlhYmxlIGJ5IHRoZSBDbGllbnQgYXNzb2NpYXRlZCB3aXRoIGFueSBzZXJ2aWNlcyBlbGVjdGVkIHB1cnN1YW50IHRvIDx1PlNlY3Rpb24gMjwvdT4gYWJvdmUgc2hhbGwgYmUgY2hhcmdlZCBhdCB0aGUgdGltZSBzdWNoIGNvc3RzIGFuZCBjaGFyZ2VzIGFyZSBpbmN1cnJlZCBieSBDb25zdGFudCBSZXRhaWwuICZuYnNwO1JlZ2FyZGxlc3Mgb2Ygd2hldGhlciBvciBub3QgQ2xpZW50IGhhcyBhIHZhbGlkIGRpc3B1dGUgb2YgYW55IE1vbnRobHkgRmVlLCBpbiB0aGUgZXZlbnQgb2YgYW55IG5vbi1wYXltZW50IHdoZW4gZHVlIGJ5IHRoZSBDbGllbnQgb2YgYW55IGZlZXMgcGF5YWJsZSB0byBDb25zdGFudCBSZXRhaWwgZHVlIHRvIGEgY2hhcmdlIG9uIHRoZSBDbGllbnQmcnNxdW87cyBjcmVkaXQgY2FyZCBiZWluZyBkZWNsaW5lZCBhbmQgdGhlIENsaWVudCwgZm9sbG93aW5nIG5vdGlmaWNhdGlvbiwgZmFpbGluZyB0byB1cGRhdGUgc3VjaCBwYXltZW50IGluZm9ybWF0aW9uIHdpdGggYSB2YWxpZCBjcmVkaXQgY2FyZCwgZm9yIGZpdmUgYnVzaW5lc3MgZGF5cyBvciBsb25nZXIsIENvbnN0YW50IFJldGFpbCBzaGFsbCBiZSBlbnRpdGxlZCB0byBjZWFzZSB0byBob3N0IGFuZCB0byBwcm92aWRlIGFsbCByZWxhdGVkIHNlcnZpY2VzIHRvIHRoZSBIb3N0ZWQgU2l0ZSBhbmQgc2hhbGwgaGF2ZSBubyBsaWFiaWxpdHkgd2hhdHNvZXZlciB0byB0aGUgQ2xpZW50IHJlbGF0ZWQgdG8gYW55IGludGVycnVwdGlvbiBvZiB0aGUgQ2xpZW50JnJzcXVvO3MgZS1jb21tZXJjZSBidXNpbmVzcyBhcyByZXN1bHQgb2Ygc3VjaCBjZXNzYXRpb24gb3Igb3RoZXIgbWF0dGVycyByZWxhdGVkIHRoZXJldG8uPC9saT4gPGxpPjx1PlJldHVybnMgb2YgTWVyY2hhbmRpc2U8L3U+LiZuYnNwOyBJbiB0aGUgZXZlbnQgdGhhdCBDbGllbnQmcnNxdW87cyBmZWVzIGFyZSBjYWxjdWxhdGVkIGJhc2VkIG9uIGEgcGVyY2VudGFnZSBvZiBOZXQgU2FsZXMgUmV2ZW51ZSwgQ2xpZW50IHNoYWxsIGJlIGVudGl0bGVkIHRvIGEgcmVmdW5kIG9yIGNyZWRpdCBiYXNlZCBvbiByZXR1cm5zIG9mIE1lcmNoYW5kaXNlIGJ5IEN1c3RvbWVycywgdGhlIHNhbGUgb2Ygd2hpY2ggZmFjdG9yZWQgaW50byB0aGUgY2FsY3VsYXRpb24gb2YgTmV0IFNhbGVzIFJldmVudWUsIGFzIHByb3ZpZGVkIGZvciBpbiB0aGlzIDx1PlNlY3Rpb24gNC4zPC91Pi4mbmJzcDsgRm9yIHRoZSBhdm9pZGFuY2Ugb2YgZG91YnQsIENsaWVudCwgYXMgZXN0YWJsaXNoZWQgaW4gPHU+U2VjdGlvbiAxLjU8L3U+IGFib3ZlLCBzaGFsbCBiZSByZXNwb25zaWJsZSBpbiBhbGwgcmVzcGVjdHMgZm9yIHByb2Nlc3NpbmcgYW5kIGNvbXBsZXRpbmcgYW55IHJldHVybiBvZiBhbnkgTWVyY2hhbmRpc2UgYnkgYSBDdXN0b21lciwgaW5jbHVkaW5nLCB3aXRob3V0IGxpbWl0YXRpb24sIG1ha2luZyBhbnkgcmVmdW5kIHRvIHRoZSBDdXN0b21lciBmb3Igc3VjaCByZXR1cm4sIHdoaWNoIGFyZSB0byBiZSBwcm9jZXNzZWQgdGhyb3VnaCB0aGUgSG9zdGVkIFNpdGUgYW5kIHdoaWNoIENvbnN0YW50IFJldGFpbCwgYXMgaG9zdCBvZiB0aGUgSG9zdGVkIFNpdGUgcHVyc3VhbnQgdG8gdGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMsIHNoYWxsIGJlIGVudGl0bGVkIHRvIHRyYWNrIGFuZCBtb25pdG9yLiZuYnNwOyBVcG9uIENvbnN0YW50IFJldGFpbCZyc3F1bztzIGNvbmZpcm1hdGlvbiB0aHJvdWdoIHRoZSBIb3N0ZWQgU2l0ZSBhbmQgdGhlIENvbnN0YW50IFJldGFpbCBQbGF0Zm9ybSB0aGF0IHN1Y2ggYSByZWZ1bmQgdG8gYSBDdXN0b21lciBoYXMgYmVlbiBjb21wbGV0ZWQgYW5kIGFsbCBmdW5kcyByZWxhdGVkIHRoZXJldG8gaGF2ZSBiZWVuIHJlbWl0dGVkIHRvIHRoZSBDdXN0b21lciBvciB0aGUgQ3VzdG9tZXImcnNxdW87cyBhY2NvdW50LCBDb25zdGFudCBSZXRhaWwgc2hhbGwgY2FsY3VsYXRlIHRoZSBhbW91bnQgb2YgYW55IGZlZXMgcHJldmlvdXNseSBjaGFyZ2VkIGFuZCBwYWlkIHRvIENvbnN0YW50IFJldGFpbCBieSB0aGUgQ2xpZW50IGJhc2VkIG9uIHRoZSBhbW91bnQgc28gcmVmdW5kZWQgYW5kIHN1Y2ggcG9ydGlvbiBvZiB0aGUgZmVlIHNvIGRldGVybWluZWQgYnkgQ29uc3RhbnQgUmV0YWlsIHNoYWxsIHJlcHJlc2VudCB0aGUgYW1vdW50IG9mIHJlZnVuZCBvciBjcmVkaXQgdG8gd2hpY2ggdGhlIENsaWVudCBpcyBlbnRpdGxlZC4mbmJzcDsgQXQgdGhlIGVsZWN0aW9uIG9mIENvbnN0YW50IFJldGFpbCBpbiBpdHMgc29sZSBkaXNjcmV0aW9uLCBzdWNoIGFtb3VudCBtYXkgZWl0aGVyIGJlIGFwcGxpZWQgYWdhaW5zdCB0aGUgb3V0c3RhbmRpbmcgYW1vdW50IG9mIGFueSBmZWVzIHBheWFibGUgdG8gQ29uc3RhbnQgUmV0YWlsIGJ5IHRoZSBDbGllbnQgb3IgcGFpZCBkaXJlY3RseSB0byBDbGllbnQuJm5ic3A7IENsaWVudCZyc3F1bztzIGVudGl0bGVtZW50IHRvIHRoZSBmb3JlZ29pbmcgcmVmdW5kIG9yIGNyZWRpdCBzaGFsbCBiZSBzdWJqZWN0IHRvIENsaWVudCBwcm92aWRpbmcgQ29uc3RhbnQgUmV0YWlsIHdpdGggYW55IGNvb3BlcmF0aW9uLCBhc3Npc3RhbmNlLCBvciBpbmZvcm1hdGlvbiByZWFzb25hYmx5IHJlcXVlc3RlZCBieSBDb25zdGFudCBSZXRhaWwgaW4gY29ubmVjdGlvbiB3aXRoIGNhbGN1bGF0aW5nIHRoZSBhbW91bnQgb2YgYW55IHJlZnVuZCBvciBjcmVkaXQgb3dpbmcgdG8gQ2xpZW50IGFuZCBiYXNlZCBvbiBhIHJldHVybiBvZiBNZXJjaGFuZGlzZSBieSBhIEN1c3RvbWVyLiAmbmJzcDsmbmJzcDs8L2xpPiA8bGk+PHU+UGF5bWVudCBSZXBvcnRpbmc8L3U+LiBJbW1lZGlhdGVseSBmb2xsb3dpbmcgdGhlIGVuZCBvZiBlYWNoIG1vbnRoIGluIHRoZSBUZXJtLCB1cG9uIHRoZSByZXF1ZXN0IG9mIHRoZSBDbGllbnQsIENvbnN0YW50IFJldGFpbCBzaGFsbCBkZWxpdmVyIGEgcmVwb3J0IHRvIHRoZSBDbGllbnQgb2YgdGhlIGFwcGxpY2FibGUgZmVlcyBjaGFyZ2VkIGZvciBzdWNoIG1vbnRoLiZuYnNwOyZuYnNwOyZuYnNwOyAmbmJzcDsmbmJzcDs8L2xpPiA8bGk+PHU+Q2xpZW50IEFjY291bnRzPC91Pi4gVGhlIGZvcmVnb2luZyBwcm92aXNpb25zIG9mIHRoaXMgPHU+U2VjdGlvbiA0PC91PiByZWdhcmRpbmcgcGF5bWVudCBmb3IgdGhlIHNlcnZpY2VzIHByb3ZpZGVkIGhlcmV1bmRlciBhcmUgaW50ZW5kZWQgdG8gYXBwbHkgdG8gYWxsIFBlcnNvbnMgYWdyZWVpbmcgdG8gdGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMsIGluY2x1ZGluZyB0aGUgQ2xpZW50LiZuYnNwOyBIb3dldmVyLCBjZXJ0YWluIGNsaWVudHMgbWF5LCBieSBzcGVjaWZpYyB3cml0dGVuIGFncmVlbWVudCB3aXRoIENvbnN0YW50IFJldGFpbCBzZXBhcmF0ZSBmcm9tIHRoZXNlIFRlcm1zIGFuZCBDb25kaXRpb25zLCBlc3RhYmxpc2ggYW4gYWNjb3VudCBmb3IgcGF5bWVudCwgc3ViamVjdCB0byBwYXltZW50IHRlcm1zIGRpZmZlcmVudCBmcm9tIHRob3NlIHNldCBmb3J0aCBpbiB0aGlzIDx1PlNlY3Rpb24gNDwvdT4sIGluY2x1ZGluZyB3aXRob3V0IGxpbWl0YXRpb24gdGhlIGNhcnJ5aW5nIG9mIGFuIG91dHN0YW5kaW5nIGJhbGFuY2UgZm9yIE1vbnRobHkgRmVlcywgaW5jdXJyZWQgYnV0IG5vdCBvdmVyZHVlIGFmdGVyIHRoZSAzMDxzdXA+dGg8L3N1cD4gZGF5IG9mIHJlY2VpcHQgb2YgdGhlIGludm9pY2UgdGhlcmVmb3IuPC9saT4gPC9vbD4gPC9saT4gPGxpPiBDdXN0b21lciBJbmZvcm1hdGlvbjsgUHJvcHJpZXRhcnkgUmlnaHRzOyBQcml2YWN5IFBvbGljeS4gPG9sPiA8bGk+PHU+Q3VzdG9tZXIgSW5mb3JtYXRpb248L3U+LiBDb25zdGFudCBSZXRhaWwgc2hhbGwgbm90LCBhbmQgc2hhbGwgZW5zdXJlIHRoYXQgaXRzIFJlcHJlc2VudGF0aXZlcyBkbyBub3QsIGRpc2Nsb3NlIHRvIGFueSB0aGlyZCBwYXJ0eSBvciB1c2UgZm9yIGFueSBvdGhlciBwdXJwb3NlIG90aGVyIHRoYW4gZm9yIHRoZSBwZXJmb3JtYW5jZSBvZiBzZXJ2aWNlcyBjb250ZW1wbGF0ZWQgdW5kZXIgdGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMgYW55IEN1c3RvbWVyIEluZm9ybWF0aW9uIGFuZCwgZXhjZXB0IGFzIHBlcm1pdHRlZCBoZXJldW5kZXIsIHNoYWxsIGluIG5vIHdheSB1c2UsIHNlbGwsIHRyYW5zZmVyIG9yIG90aGVyd2lzZSBleHBsb2l0IGFueSBDdXN0b21lciBJbmZvcm1hdGlvbiBmb3IgYW55IHB1cnBvc2Ugd2l0aG91dCB0aGUgZXhwcmVzcyB3cml0dGVuIGNvbnNlbnQgb2YgdGhlIENsaWVudC48L2xpPiA8bGk+IDx1PlByaXZhY3kgUG9saWN5PC91Pi4gQ2xpZW50IHNoYWxsIGRldmVsb3AgYW5kIGFkb3B0IGEgUHJpdmFjeSBQb2xpY3kgYW5kIHByb3ZpZGUgYSBjb3B5IG9mIHN1Y2ggUHJpdmFjeSBQb2xpY3kgdG8gQ29uc3RhbnQgUmV0YWlsIGZvciBpbmNsdXNpb24gb2Ygc3VjaCBQcml2YWN5IFBvbGljeSBieSBDb25zdGFudCBSZXRhaWwgaW4gdGhlIEhvc3RlZCBTaXRlLiZuYnNwOyBBbnkgc3VjaCBQcml2YWN5IFBvbGljeSBzaGFsbCBpbmNsdWRlIHRoZSBmb2xsb3dpbmcgc3RhdGVtZW50IHJlZ2FyZGluZyBVc2VyIERhdGE6IDxwPjxlbT4mbGRxdW87T3VyIHNpdGUgaXMgaG9zdGVkIGFuZCBtYWludGFpbmVkIGJ5IGEgdGhpcmQtcGFydHkgc2VydmljZSBwcm92aWRlciBrbm93biBhcyAmbGRxdW87Q29uc3RhbnQgUmV0YWlsJnJkcXVvOy4mbmJzcDsgTm90d2l0aHN0YW5kaW5nIGFueSBvdGhlciBwcm92aXNpb25zIG9mIHRoaXMgcHJpdmFjeSBwb2xpY3ksIGluIGNvbm5lY3Rpb24gd2l0aCB0aGUgcHJvdmlzaW9uIG9mIHN1Y2ggc2VydmljZXMsIENvbnN0YW50IFJldGFpbCBtYXkgY29sbGVjdCBhbmQgdXNlIGZvciBhbnkgcHVycG9zZSBkYXRhIGFuZCBpbmZvcm1hdGlvbiBkZXJpdmVkIGZyb20gb3VyIHNpdGUgYW5kIHlvdXIgdXNhZ2UgdGhlcmVvZi4mbmJzcDsgSG93ZXZlciwgQ29uc3RhbnQgUmV0YWlsIHdpbGwgbm90IG1ha2UgdXNlIG9mIHlvdXIgbmFtZSwgZW1haWwgYWRkcmVzcywgYmlsbGluZyBhbmQgc2hpcC10byBhZGRyZXNzZXMsIHBob25lIG51bWJlcihzKSwgYW5kIHRoZSBjcmVkaXQgY2FyZCwgYmFuayBhY2NvdW50IG9yIG90aGVyIHBheW1lbnQgaW5mb3JtYXRpb24gcHJvdmlkZWQgYnkgeW91LiZyZHF1bzs8L2VtPjwvcD4gPHA+Q2xpZW50IHNoYWxsIHJlbGF5IHRvIENvbnN0YW50IFJldGFpbCBhbnkgY29tbXVuaWNhdGlvbnMgcGVydGFpbmluZyB0byBDb25zdGFudCBSZXRhaWwgcmVjZWl2ZWQgZnJvbSBhbnkgQ3VzdG9tZXIgaW4gcmVzcG9uc2UgdG8gQ2xpZW50JnJzcXVvO3MgUHJpdmFjeSBQb2xpY3kuJm5ic3A7IENsaWVudCByZXByZXNlbnRzIGFuZCB3YXJyYW50cyB0aGF0IGl0cyBQcml2YWN5IFBvbGljeSBzaGFsbCBiZSBpbiBjb21wbGlhbmNlIGF0IGFsbCB0aW1lcyBkdXJpbmcgdGhlIFRlcm0gd2l0aCBhcHBsaWNhYmxlIGxhdyBhbmQgcmVndWxhdGlvbnMuJm5ic3A7PC9wPiA8L2xpPiA8bGk+PHU+UHJvcHJpZXRhcnkgUmlnaHRzPC91Pi4gQXQgYWxsIHRpbWVzLCBDb25zdGFudCBSZXRhaWwgYW5kIGl0cyBBZmZpbGlhdGVzIHJlc2VydmUgYWxsIHJpZ2h0LCB0aXRsZSBhbmQgaW50ZXJlc3QgaW4gYW5kIHRvIHRoZSBDb25zdGFudCBSZXRhaWwgSW50ZWxsZWN0dWFsIFByb3BlcnR5IGFuZCBpbiBubyBldmVudCBzaGFsbCBhbnkgcHJvdmlzaW9uIGluIHRoZXNlIFRlcm1zIGFuZCBDb25kaXRpb25zIGFuZCB0aGUgcGVyZm9ybWFuY2UgdGhlcmVvZiwgYmUgZGVlbWVkIG9yIGNvbnN0cnVlZCBhcyBhIHRyYW5zZmVyLCBhc3NpZ25tZW50IG9yIGxpY2Vuc2Ugb2YgYW55IGludGVyZXN0IG9yIHJpZ2h0IHRoZXJlaW4sIHdoZXRoZXIgdG8gdXNlIGFueSBDb25zdGFudCBSZXRhaWwgSW50ZWxsZWN0dWFsIFByb3BlcnR5IG9yIG90aGVyd2lzZSAoZXhjZXB0IGZvciB0aGUgZm9sbG93aW5nIHNlbnRlbmNlKS4mbmJzcDsgQ29uc3RhbnQgUmV0YWlsIGhlcmVieSBncmFudHMgdG8gdGhlIENsaWVudCwgZHVyaW5nIHRoZSBUZXJtLCBhIHdvcmxkd2lkZSwgbm9uLXRyYW5zZmVyYWJsZSwgbm9uLXN1YiBsaWNlbnNhYmxlLCBmdWxseSBwYWlkIGxpY2Vuc2UgdG8gdXNlIHRoZSBIb3N0ZWQgU2l0ZSBzb2xlbHkgZm9yIHRoZSBwdXJwb3NlcyBvZiBvcGVyYXRpbmcgdGhlIENsaWVudCZyc3F1bztzIGUtY29tbWVyY2UgYnVzaW5lc3Mgb2Ygc2VsbGluZyB0byBDdXN0b21lcnMgcHJvZHVjdHMgcmVsYXRlZCB0byB0aGUgU2VsZWN0ZWQgQnJhbmRzLjwvbGk+IDxsaT48dT5Db25zdGFudCBSZXRhaWwgV2Vic2l0ZSBVc2UgRGF0YTwvdT4uIENlcnRhaW4gZGF0YSByZWdhcmRpbmcgdGhlIENsaWVudCZyc3F1bztzIGludGVyYWN0aW9uIHdpdGggdGhlIENvbnN0YW50IFJldGFpbCBQbGF0Zm9ybSBwcmlvciB0byB0aGUgRW5yb2xsbWVudCBQcm9jZXNzIGlzIGFsc28gZ292ZXJuZWQgYnkgQ29uc3RhbnQgUmV0YWlsJnJzcXVvO3MgUHJpdmFjeSBQb2xpY3ksIHdoaWNoIGlzIGluY29ycG9yYXRlZCBpbnRvIHRoZXNlIFRlcm1zIGFuZCBDb25kaXRpb25zIGJ5IHJlZmVyZW5jZSBhbmQgYSBjb3B5IG9mIHdoaWNoIGlzIGF2YWlsYWJsZSBhdCB0aGUgZm9sbG93aW5nIGxpbms6IDxhIGhyZWY9XCJodHRwOi8vd3d3LmNvbnN0YW50cmV0YWlsLmNvbS9wcml2YWN5cG9saWN5XCI+Y29uc3RhbnRyZXRhaWwuY29tL3ByaXZhY3lwb2xpY3k8L2E+LjwvbGk+IDwvb2w+IDwvbGk+IDxsaT4gVGVybWluYXRpb24uIDxvbD4gPGxpPjx1PlRlcm1pbmF0aW9uIGJ5IHRoZSBDbGllbnQ8L3U+LiBDbGllbnQgc2hhbGwgYmUgZW50aXRsZWQgdG8gdGVybWluYXRlIHRoZXNlIFRlcm1zIGFuZCBDb25kaXRpb25zIHVwb24gbm8gbGVzcyB0aGFuIDYwIGRheXMmcnNxdW87IHByaW9yIHdyaXR0ZW4gbm90aWNlIHRvIENvbnN0YW50IFJldGFpbC4mbmJzcDsmbmJzcDs8L2xpPiA8bGk+PHU+VGVybWluYXRpb24gYnkgQ29uc3RhbnQgUmV0YWlsPC91Pi4gQ29uc3RhbnQgUmV0YWlsIHNoYWxsIGJlIGVudGl0bGVkIHRvIHRlcm1pbmF0ZSB0aGVzZSBUZXJtcyBhbmQgQ29uZGl0aW9ucyB1cG9uIG5vIGxlc3MgdGhhbiA2MCBkYXlzJnJzcXVvOyBwcmlvciB3cml0dGVuIG5vdGljZSB0byB0aGUgQ2xpZW50LiBJbiBhZGRpdGlvbiwgQ29uc3RhbnQgUmV0YWlsIHNoYWxsIGJlIGVudGl0bGVkIHRvIHRlcm1pbmF0ZSB0aGVzZSBUZXJtcyBhbmQgQ29uZGl0aW9ucyBpbW1lZGlhdGVseSB1cG9uIHdyaXR0ZW4gbm90aWNlIHRvIENsaWVudCBpZiBDb25zdGFudCBSZXRhaWwgaXMgdW5hYmxlIHRvIGZ1bGZpbCBwYXltZW50IG9mIGFueSBmZWVzIHRocm91Z2ggQ2xpZW50JnJzcXVvO3MgY3JlZGl0IGNhcmQgcHJlLWF1dGhvcml6YXRpb24sIGFzIHByb3ZpZGVkIGZvciBpbiB0aGUgbGFzdCBzZW50ZW5jZSBvZiA8dT5TZWN0aW9uIDQuMjwvdT4uPC9saT4gPGxpPjx1PkVmZmVjdCBvZiBUZXJtaW5hdGlvbjwvdT4uIFVwb24gdGVybWluYXRpb24gb2YgdGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMsIGVhY2ggUGFydHkgaW4gcmVjZWlwdCwgcG9zc2Vzc2lvbiBvciBjb250cm9sIG9mIHRoZSBvdGhlciBQYXJ0eSZyc3F1bztzIGludGVsbGVjdHVhbCBvciBwcm9wcmlldGFyeSBwcm9wZXJ0eSwgaW5mb3JtYXRpb24gYW5kIG1hdGVyaWFscyAoaW5jbHVkaW5nIGFueSBjb25maWRlbnRpYWwgaW5mb3JtYXRpb24pIHB1cnN1YW50IHRvIHRoZXNlIFRlcm1zIGFuZCBDb25kaXRpb25zIG11c3QgcmV0dXJuIHRvIHRoZSBvdGhlciBQYXJ0eSAob3IgYXQgdGhlIG90aGVyIFBhcnR5JnJzcXVvO3Mgd3JpdHRlbiByZXF1ZXN0LCBkZXN0cm95KSBzdWNoIHByb3BlcnR5LCBpbmZvcm1hdGlvbiBhbmQgbWF0ZXJpYWxzLiZuYnNwOyA8dT5TZWN0aW9ucyAxLjM8L3U+LCA8dT40PC91PiwgPHU+NTwvdT4sIDx1PjY8L3U+LCA8dT43PC91PiwgPHU+ODwvdT4gYW5kIDx1Pjk8L3U+ICh0b2dldGhlciB3aXRoIGFsbCBvdGhlciBwcm92aXNpb25zIHRoYXQgcmVhc29uYWJseSBtYXkgYmUgaW50ZXJwcmV0ZWQgYXMgc3Vydml2aW5nIHRlcm1pbmF0aW9uIG9yIGV4cGlyYXRpb24gb2YgdGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMpIHdpbGwgc3Vydml2ZSB0aGUgdGVybWluYXRpb24gb3IgZXhwaXJhdGlvbiBvZiB0aGVzZSBUZXJtcyBhbmQgQ29uZGl0aW9ucy4mbmJzcDsgTm90d2l0aHN0YW5kaW5nIHRoZSBmb3JlZ29pbmcsIHRlcm1pbmF0aW9uIG9mIHRoZXNlIFRlcm1zIGFuZCBDb25kaXRpb25zIHNoYWxsIG5vdCByZWxpZXZlIGVpdGhlciBQYXJ0eSBmcm9tIGl0cyBvYmxpZ2F0aW9uIHRvIHBheSBhbnkgYW1vdW50cyBkdWUgdG8gdGhlIG90aGVyIFBhcnR5IGZvciBhbnkgcGVyaW9kIHByaW9yIHRvIHRoZSBlZmZlY3RpdmUgZGF0ZSBvZiB0ZXJtaW5hdGlvbi48L2xpPiA8L29sPiA8L2xpPiA8bGk+IEluZGVtbmlmaWNhdGlvbi4gPG9sPiA8bGk+PHU+SW5kZW1uaWZpY2F0aW9uIGJ5IHRoZSBDbGllbnQ8L3U+LiBUaGUgQ2xpZW50IHdpbGwgZGVmZW5kLCBpbmRlbW5pZnkgYW5kIGhvbGQgQ29uc3RhbnQgUmV0YWlsLCBpdHMgQWZmaWxpYXRlcywgYW5kIHRoZWlyIHJlc3BlY3RpdmUgUmVwcmVzZW50YXRpdmVzIGhhcm1sZXNzIGZyb20gYW5kIGFnYWluc3QgYW55IGFuZCBhbGwgRGFtYWdlcyByZXN1bHRpbmcgZnJvbSwgYXJpc2luZyBvdXQgb2Ygb3IgaW4gY29ubmVjdGlvbiB3aXRoICh3aGV0aGVyIGEgcmVzdWx0IG9mIGFueSB0aGlyZCBwYXJ0eSBjbGFpbXMsIGFjdGlvbnMgb3IgZGVtYW5kcyBvciBvdGhlcndpc2UpOiAoYSkgYW55IGNsYWltLCBhY3Rpb24sIGRlbWFuZCwgb3IgYWxsZWdhdGlvbiB0aGF0IGVpdGhlciB0aGUgSG9zdGVkIFNpdGUgb3IgYW55IGNvbnRlbnQgb3IgaW5mb3JtYXRpb24gb24gdGhlIEhvc3RlZCBTaXRlLCB3aGV0aGVyIENvbnN0YW50IFJldGFpbCBJbnRlbGxlY3R1YWwgUHJvcGVydHkgb3Igbm90LCAmbmJzcDtpcyBvciBtYXkgYmUgaW5mcmluZ2luZyB1cG9uLCBvciBpcyB0aGUgdW5hdXRob3JpemVkIHVzZSBvZiBhbnkgb2YsIHRoZSBJbnRlbGxlY3R1YWwgUHJvcGVydHkgb2YgYW55IG90aGVyIFBlcnNvbjsgKGIpIGFueSBicmVhY2ggYnkgQ2xpZW50IG9mIGFueSByZXByZXNlbnRhdGlvbiBhbmQgd2FycmFudHkgY29udGFpbmVkIGhlcmVpbiwgaW5jbHVkaW5nIHdpdGhvdXQgbGltaXRhdGlvbiBhbnkgb2YgdGhvc2UgaW4gPHU+U2VjdGlvbiAxLjM8L3U+IG9yIGNvdmVuYW50LCBvYmxpZ2F0aW9uIG9yIGFncmVlbWVudCB0byBiZSBwZXJmb3JtZWQgYnkgQ2xpZW50IGhlcmV1bmRlcjsgKGMpIGFueSBzYWxlcywgdXNlLCB0cmFuc2ZlciBvciBzaW1pbGFyIHRheCBwYXlhYmxlIHRvIGFueSBnb3Zlcm5tZW50YWwgYXV0aG9yaXR5LCB3aGV0aGVyIGZlZGVyYWwsIHN0YXRlLCBtdW5pY2lwYWwgb3IgbG9jYWwsIG9uIGFueSBzYWxlIG9mIE1lcmNoYW5kaXNlIHRocm91Z2ggdGhlIEhvc3RlZCBTaXRlIGFzIHdlbGwgYXMgb24gYW55IG90aGVyIGNoYXJnZSBtYWRlIGluIGNvbm5lY3Rpb24gd2l0aCBzdWNoIHNhbGU7IG9yIChkKSB0aGUgZGVzaWduLCBtYW51ZmFjdHVyZSBvciBzYWxlIG9mIGFueSBNZXJjaGFuZGlzZSBvciBvdGhlciBwcm9kdWN0cyBzb2xkIG9yIG9mZmVyZWQgdGhyb3VnaCB0aGUgSG9zdGVkIFNpdGUuJm5ic3A7IEluIGZ1cnRoZXJhbmNlIGFuZCBub3QgaW4gbGltaXRhdGlvbiBvZiB0aGUgZm9yZWdvaW5nLCB0aGUgQ2xpZW50IHNoYWxsIGRlZmVuZCwgaW5kZW1uaWZ5IGFuZCBob2xkIGhhcm1sZXNzIENvbnN0YW50IFJldGFpbCBmcm9tIGFuZCBhZ2FpbnN0IGFueSBhbmQgYWxsIERhbWFnZXMgcmVzdWx0aW5nIGZyb20gYW55IGFjdHVhbCBvciB0aHJlYXRlbmVkIHRvcnQgY2xhaW1zIG9yIHByb2R1Y3QgbGlhYmlsaXR5IGNsYWltcyByZWxhdGluZyB0byBNZXJjaGFuZGlzZSBvciBvdGhlciBwcm9kdWN0cyBzb2xkIG9yIG9mZmVyZWQgdGhyb3VnaCB0aGUgSG9zdGVkIFNpdGUuPC9saT4gPGxpPjx1PlByb2NlZHVyZXMgZm9yIEluZGVtbmlmaWNhdGlvbjwvdT4uJm5ic3A7IENvbnN0YW50IFJldGFpbCB3aWxsIHByb21wdGx5IG5vdGlmeSBDbGllbnQgb2YgYW55IGNsYWltIHN1YmplY3QgdG8gPHU+U2VjdGlvbiA3LjE8L3U+IGFib3ZlLCBidXQgZmFpbHVyZSB0byBwcm9tcHRseSBub3RpZnkgQ2xpZW50IHdpbGwgb25seSBhZmZlY3QgQ2xpZW50JnJzcXVvO3Mgb2JsaWdhdGlvbnMgdW5kZXIgPHU+U2VjdGlvbiA3LjE8L3U+IHRvIHRoZSBleHRlbnQgdGhhdCBzdWNoIGZhaWx1cmUgbWF0ZXJpYWxseSBwcmVqdWRpY2VzIENsaWVudCZyc3F1bztzIGFiaWxpdHkgdG8gZGVmZW5kIHRoZSBjbGFpbS4gQ2xpZW50IG1heTogKGEpIHVzZSBjb3Vuc2VsIG9mIGl0cyBvd24gY2hvb3NpbmcgdG8gZGVmZW5kIGFnYWluc3QgYW55IGNsYWltLCBzdWJqZWN0IGZpcnN0IHRvIENvbnN0YW50IFJldGFpbCZyc3F1bztzIHdyaXR0ZW4gY29uc2VudCBhbmQgQ2xpZW50JnJzcXVvO3Mgd3JpdHRlbiBhY2tub3dsZWRnZW1lbnQgb2YgaXRzIGxpYWJpbGl0eSBmb3IgaXRzIG9ibGlnYXRpb25zIHVuZGVyIDx1PlNlY3Rpb24gNy4xPC91PiB3aXRoIHJlc3BlY3QgdG8gc3VjaCBjbGFpbTsgYW5kIChiKSBzZXR0bGUgdGhlIGNsYWltIGFzIHRoZSBDbGllbnQgbWF5IGRlZW0gYXBwcm9wcmlhdGUsIDx1PnByb3ZpZGVkPC91PiB0aGF0IENsaWVudCBvYnRhaW4gQ29uc3RhbnQgUmV0YWlsJnJzcXVvO3MgcHJpb3Igd3JpdHRlbiBjb25zZW50IGJlZm9yZSBlbnRlcmluZyBpbnRvIGFueSBzdWNoIHNldHRsZW1lbnQuICZuYnNwO0NvbnN0YW50IFJldGFpbCBtYXkgYWxzbyBhc3N1bWUgY29udHJvbCBvZiB0aGUgZGVmZW5zZSBhbmQgc2V0dGxlbWVudCBvZiBhbnkgc3VjaCBjbGFpbSBhdCBhbnkgdGltZSwgd2l0aCBjb3Vuc2VsIG9mIGl0cyBjaG9vc2luZy48L2xpPiA8L29sPiA8L2xpPiA8bGk+IERpc2NsYWltZXJzOyBMaW1pdGF0aW9ucyBvbiBMaWFiaWxpdHkuIDxvbD4gPGxpPjx1PkRpc2NsYWltZXIgb2YgV2FycmFudGllczwvdT4uIEVYQ0VQVCBBUyBPVEhFUldJU0UgRVhQUkVTU0xZIFNFVCBGT1JUSCBJTiBUSEVTRSBURVJNUyBBTkQgQ09ORElUSU9OUywgTkVJVEhFUiBQQVJUWSBNQUtFUywgQU5EIEVBQ0ggUEFSVFkgSEVSRUJZIFdBSVZFUyBBTkQgRElTQ0xBSU1TLCBBTlkgUkVQUkVTRU5UQVRJT05TIE9SIFdBUlJBTlRJRVMgUkVHQVJESU5HIFRIRSBUUkFOU0FDVElPTlMgQ09OVEVNUExBVEVEIEhFUkVCWSwgSU5DTFVESU5HIEFOWSBJTVBMSUVEIFdBUlJBTlRJRVMgT0YgTUVSQ0hBTlRBQklMSVRZLCBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRSBPUiBOT04tSU5GUklOR0VNRU5UIE9SIElNUExJRUQgV0FSUkFOVElFUyBBUklTSU5HIE9VVCBPRiBDT1VSU0UgT0YgREVBTElORywgQ09VUlNFIE9GIFBFUkZPUk1BTkNFIE9SIFVTQUdFIE9GIFRSQURFLiZuYnNwOyBXSVRIT1VUIExJTUlUSU5HIFRIRSBHRU5FUkFMSVRZIE9GIFRIRSBGT1JFR09JTkcsIEVBQ0ggUEFSVFkgU1BFQ0lGSUNBTExZIERJU0NMQUlNUyBBTlkgUkVQUkVTRU5UQVRJT04gT1IgV0FSUkFOVFkgUkVHQVJESU5HIChBKSBUSEUgQU1PVU5UIE9GIFNBTEVTIFJFVkVOVUVTIFRIQVQgTUFZIE9DQ1VSIERVUklORyBUSEUgVEVSTSwgQU5EIChCKSBBTlkgRUNPTk9NSUMgT1IgT1RIRVIgQkVORUZJVCBUSEFUIElUIE1JR0hUIE9CVEFJTiBUSFJPVUdIIEVOVFJBTkNFIElOVE8gVEhFU0UgVEVSTVMgQU5EIENPTkRJVElPTlMgKE9USEVSIFRIQU4gVEhFIFNQRUNJRklDIFNVTVMgVE8gQkUgUEFJRCBQVVJTVUFOVCBUTyBUSEVTRSBURVJNUyBBTkQgQ09ORElUSU9OUykuPC9saT4gPGxpPjx1PkNvbXBsaWFuY2Ugd2l0aCBMYXdzPC91Pi4gSW4gaXRzIHBlcmZvcm1hbmNlIG9mIHRoZXNlIFRlcm1zIGFuZCBDb25kaXRpb25zLCBlYWNoIFBhcnR5IHdpbGwgY29tcGx5IGluIGFsbCBtYXRlcmlhbCByZXNwZWN0cyB3aXRoIGFsbCBhcHBsaWNhYmxlIGxhd3MsIHJlZ3VsYXRpb25zLCBvcmRlcnMgYW5kIG90aGVyIHJlcXVpcmVtZW50cywgbm93IG9yIGhlcmVhZnRlciBpbiBlZmZlY3QsIG9mIGdvdmVybm1lbnRhbCBhdXRob3JpdGllcyBoYXZpbmcganVyaXNkaWN0aW9uLjwvbGk+IDxsaT48dT5MaW1pdGF0aW9uIG9mIExpYWJpbGl0eTwvdT4uIE5FSVRIRVIgUEFSVFkgV0lMTCBCRSBMSUFCTEUgKElOIFRPUlQgKElOQ0xVRElORyBORUdMSUdFTkNFKSwgQ09OVFJBQ1QgT1IgT1RIRVJXSVNFKSBGT1IgQU5ZIElORElSRUNULCBDT05TRVFVRU5USUFMLCBQVU5JVElWRSBPUiBTUEVDSUFMIERBTUFHRVMgKElOQ0xVRElORyBMT1NUIEJVU0lORVNTLCBSRVZFTlVFIE9SIERBVEEpIEFSSVNJTkcgT1VUIE9GIE9SIElOIENPTk5FQ1RJT04gV0lUSCBUSEVTRSBURVJNUyBBTkQgQ09ORElUSU9OUyAoSU5DTFVESU5HIEFOWSBCUkVBQ0ggSEVSRU9GKSwgRVZFTiBJRiBTVUNIIFBBUlRZIEhBUyBCRUVOIEFEVklTRUQgT0YgVEhFIFBPU1NJQklMSVRZIFRIRVJFT0YuJm5ic3A7IFRIRSBNQVhJTVVNIEFHR1JFR0FURSBMSUFCSUxJVFkgT0YgRUFDSCBQQVJUWSBVTkRFUiBBTlkgVEhFT1JZLCBJTkNMVURJTkcsIENPTlRSQUNULCBORUdMSUdFTkNFIE9SIFNUUklDVCBMSUFCSUxJVFksIFdJTEwgTk9UIEVYQ0VFRCBUSEUgVE9UQUwgUEFZTUVOVFMgT0YgTU9OVEhMWSBGRUVTIE1BREUgVE8gQ09OU1RBTlQgUkVUQUlMIERVUklORyBUSEUgVEhJUlRZICgzMCkgREFZUyBQUklPUiBUTyBUSEUgREFURSBUSEUgTElBQklMSVRZIEFST1NFLiZuYnNwOyBOT1RXSVRIU1RBTkRJTkcgQU5ZVEhJTkcgRUxTRSBIRVJFSU4sIFRIRSBMSU1JVEFUSU9OUyBPTiBMSUFCSUxJVFkgSU4gVEhFIEZPUkVHT0lORyBUV08gU0VOVEVOQ0VTIFNIQUxMIElOIE5PIEVWRU5UIEFQUExZIFRPIEVJVEhFUiAoQSkgQ0xJRU5UJnJzcXVvO1MgSU5ERU1OSUZJQ0FUSU9OIE9CTElHQVRJT05TIFVOREVSIDx1PlNFQ1RJT04gNzwvdT47IEFORCAoQikgQU5ZIE9CTElHQVRJT04gT0YgVEhFIENMSUVOVCBUTyBNQUtFIFBBWU1FTlQgT0YgQSBNT05USExZIEZFRSBPUiBPRiBBTlkgT1RIRVIgQ0hBUkdFUyBGT1IgQU5ZIFNFUlZJQ0UgUFJPVklERUQgQlkgQ09OU1RBTlQgUkVUQUlMIE9SIEFOWSBPRiBJVFMgQUZGSUxJQVRFUyBJTiBDT05ORUNUSU9OIFdJVEggVEhFU0UgVEVSTVMgQU5EIENPTkRJVElPTlMuJm5ic3A7PC9saT4gPGxpPjx1Pk5vIEd1YXJhbnRlZSBvZiBUcmFmZmljPC91Pi4gVGhlIENsaWVudCBhY2tub3dsZWRnZXMgYW5kIGFncmVlcyB0aGF0IENvbnN0YW50IFJldGFpbCBoYXMgbWFkZSBubyByZXByZXNlbnRhdGlvbiwgd2FycmFudHkgb3IgZ3VhcmFudGVlIHJlZ2FyZGluZyB0aGUgbnVtYmVyIG9mIHZpc2l0b3JzIHRvIHRoZSBIb3N0ZWQgU2l0ZSwgdGhlIGFtb3VudHMgb2YgcHVyY2hhc2VzIHRocm91Z2ggdGhlIEhvc3RlZCBTaXRlLCB0aGUgYW1vdW50cyBvZiByZXZlbnVlcyBmcm9tIE1lcmNoYW5kaXNlIHNvbGQgdG8gQ3VzdG9tZXJzIG9yIGFueSBvdGhlciBwcm9qZWN0aW9uIHJlbGF0aW5nIHRvIHRoZSBwZXJmb3JtYW5jZSBvZiB0aGUgSG9zdGVkIFNpdGUsIGFuZCBDb25zdGFudCBSZXRhaWwgaGVyZWJ5IGRpc2NsYWltcyBhbnkgYW5kIGFsbCBzdWNoIHJlcHJlc2VudGF0aW9ucywgd2FycmFudGllcyBvciBndWFyYW50ZWVzLjwvbGk+IDwvb2w+IDwvbGk+IDxsaT4gTWlzY2VsbGFuZW91cy4gPG9sPiA8bGk+PHU+SW5kZXBlbmRlbnQgQ29udHJhY3RvcnM8L3U+LiBUaGUgUGFydGllcyBhcmUgZW50ZXJpbmcgaW50byB0aGVzZSBUZXJtcyBhbmQgQ29uZGl0aW9ucyBhcyBpbmRlcGVuZGVudCBjb250cmFjdG9ycywgYW5kIHRoZXNlIFRlcm1zIGFuZCBDb25kaXRpb25zIHdpbGwgbm90IGJlIGNvbnN0cnVlZCB0byBjcmVhdGUgYSBwYXJ0bmVyc2hpcCwgam9pbnQgdmVudHVyZSBvciBlbXBsb3ltZW50IHJlbGF0aW9uc2hpcCBiZXR3ZWVuIHRoZW0uJm5ic3A7IE5laXRoZXIgUGFydHkgd2lsbCByZXByZXNlbnQgaXRzZWxmIHRvIGJlIGFuIGVtcGxveWVlIG9yIGFnZW50IG9mIHRoZSBvdGhlciBvciBlbnRlciBpbnRvIGFueSBhZ3JlZW1lbnQgb3IgbGVnYWxseSBiaW5kaW5nIGNvbW1pdG1lbnQgb3Igc3RhdGVtZW50IG9uIHRoZSBvdGhlciZyc3F1bztzIGJlaGFsZiBvZiBvciBpbiB0aGUgb3RoZXImcnNxdW87cyBuYW1lIChvdGhlciB0aGFuIHRvIHRoZSBleHRlbnQgdGhhdCBDdXN0b21lciBvcmRlcnMgb2YgTWVyY2hhbmRpc2UgdGhyb3VnaCB0aGUgSG9zdGVkIFNpdGUgc2hhbGwgb2JsaWdhdGUgdGhlIENsaWVudCB0byBmdWxmaWxsIGFuZCBzaGlwIHN1Y2ggb3JkZXJzIGFuZCBvdGhlcndpc2UgaG9ub3IgdGhlIGFncmVlbWVudCBmb3JtZWQgYnkgdGhlIENsaWVudCBhbmQgc3VjaCBDdXN0b21lciBkdWUgdG8gc3VjaCBvcmRlcikuPC9saT4gPGxpPjx1PkdvdmVybmluZyBMYXcgYW5kIFZlbnVlPC91Pi4gVGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMgc2hhbGwgYmUgY29uc3RydWVkIGFjY29yZGluZyB0byB0aGUgbGF3cyBvZiB0aGUgU3RhdGUgb2YgQ2FsaWZvcm5pYSB3aXRob3V0IGdpdmluZyBjb25zaWRlcmF0aW9uIHRvIHByaW5jaXBsZXMgb2YgY29uZmxpY3Qgb2YgbGF3LiZuYnNwOyBBbGwgZGlzcHV0ZXMgYXJpc2luZyBoZXJldW5kZXIgc2hhbGwgYmUgcmVzb2x2ZWQgaW4gTG9zIEFuZ2VsZXMsIENhbGlmb3JuaWEgYW5kIGF0IG5vIG90aGVyIHBsYWNlLiZuYnNwOyBDbGllbnQgKGEpIGlycmV2b2NhYmx5IGNvbnNlbnRzIHRvIHRoZSBqdXJpc2RpY3Rpb24gYW5kIHZlbnVlIG9mIHRoZSBTdGF0ZSBhbmQgRmVkZXJhbCBjb3VydHMgbG9jYXRlZCBpbiB0aGUgQ2l0eSBvZiBMb3MgQW5nZWxlcywgQ2FsaWZvcm5pYSwgKGIpIGFncmVlcyB0aGF0IGFueSBhY3Rpb24gcmVsYXRpbmcgdG8gdGhlIHNlcnZpY2VzIHByb3ZpZGVkIGJ5IENvbnN0YW50IFJldGFpbCBzaGFsbCBvbmx5IGJlIGJyb3VnaHQgaW4gc2FpZCBjb3VydHMsIChjKSBjb25zZW50cyB0byB0aGUgZXhlcmNpc2Ugb2YgPGVtPmluIHBlcnNvbmFtPC9lbT4ganVyaXNkaWN0aW9uIGJ5IHNhaWQgY291cnRzIG92ZXIgaXQsIGFuZCAoZCkgZnVydGhlciBhZ3JlZXMgdGhhdCBhbnkgYWN0aW9uIHRvIGVuZm9yY2UgYSBqdWRnbWVudCBtYXkgYmUgaW5zdGl0dXRlZCBpbiBhbnkganVyaXNkaWN0aW9uLjwvbGk+IDxsaT48dT5FbnRpcmUgQWdyZWVtZW50PC91Pi4gVGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMsIGFsb25nIHdpdGggdGhlIEZlZSBBZGRlbmR1bSBhcyB3ZWxsIGFzIGFueSB0ZXJtcyBhbmQgY29uZGl0aW9ucyByZWdhcmRpbmcgJmxkcXVvO0ZyZWlnaHQgQ2x1YiZyZHF1bzsgYWNjZXB0ZWQgYW5kIGFncmVlZCB0byBieSB0aGUgQ2xpZW50LCByZXByZXNlbnQgdGhlIGVudGlyZSBhZ3JlZW1lbnQgYmV0d2VlbiB0aGUgUGFydGllcyB3aXRoIHJlc3BlY3QgdG8gdGhlIHN1YmplY3QgbWF0dGVyIGhlcmVvZiBhbmQgc3VwZXJzZWRlcyBhbGwgcHJpb3IgYWdyZWVtZW50cyBhbmQgY29tbXVuaWNhdGlvbnMgb2YgdGhlIFBhcnRpZXMgd2l0aCByZXNwZWN0IHRvIHRoZSBzdWJqZWN0IG1hdHRlciBoZXJlb2YsIG9yYWwgb3Igd3JpdHRlbi48L2xpPiA8bGk+PHU+U2ltaWxhciBBZ3JlZW1lbnRzPC91Pi4gTm90aGluZyBoZXJlaW4gd2lsbCBiZSBkZWVtZWQgdG8gbGltaXQgb3IgcmVzdHJpY3QgZWl0aGVyIFBhcnR5IG9yIGl0cyBBZmZpbGlhdGVzIGZyb20gZW50ZXJpbmcgaW50byBhZ3JlZW1lbnRzIHdpdGggYW55IG90aGVyIFBlcnNvbiBjb3ZlcmluZyBzZXJ2aWNlcyBzaW1pbGFyIHRvIHRob3NlIGNvbnRlbXBsYXRlZCBieSB0aGVzZSBUZXJtcyBhbmQgQ29uZGl0aW9ucyBvciBmcm9tIG9mZmVyaW5nIHN1Y2ggc2ltaWxhciBzZXJ2aWNlcyBpdHNlbGYuPC9saT4gPGxpPjx1PlByZXNzIFJlbGVhc2VzPC91Pi4gTmVpdGhlciBQYXJ0eSB3aWxsIG1ha2Ugb3IgaXNzdWUgYW55IGV4dGVybmFsIHByZXNzIHN0YXRlbWVudCByZWdhcmRpbmcgdGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMgdW5sZXNzOiAoYSkgaXQgaGFzIHJlY2VpdmVkIHRoZSBleHByZXNzIHdyaXR0ZW4gY29uc2VudCBvZiB0aGUgb3RoZXIgUGFydHksIHdoaWNoIHdpbGwgbm90IGJlIHVucmVhc29uYWJseSB3aXRoaGVsZCwgb3IgKGIpIGl0IGlzIHJlcXVpcmVkIHRvIGRvIHNvIGJ5IGxhdyBvciB0aGUgcnVsZXMgb2YgYW55IHNlY3VyaXRpZXMgbWFya2V0OyBwcm92aWRlZCB0aGF0IENvbnN0YW50IFJldGFpbCBhbmQgaXRzIEFmZmlsaWF0ZXMgc2hhbGwgYmUgcGVybWl0dGVkIHRvIGlkZW50aWZ5IHRoZSBDbGllbnQsIHVzaW5nIHRoZSBDbGllbnQmcnNxdW87cyBuYW1lIGFuZCBsb2dvLCBpZiBhbnksIGFzIGEgY2xpZW50IG9mIGl0cyBidXNpbmVzcyBpbiBhbnkgcHJvbW90aW9uYWwgbWF0ZXJpYWxzLCBpbmNsdWRpbmcsIHdpdGhvdXQgbGltaXRhdGlvbiwgb24gdGhlIENvbnN0YW50IFJldGFpbCB3ZWJzaXRlLCBhbmQgQ2xpZW50IGNvbnNlbnRzIHRvIHN1Y2ggdXNlLjwvbGk+IDxsaT48dT5Ob3RpY2VzPC91Pi4gQWxsIG5vdGljZXMsIHJlcXVlc3RzIGFuZCBvdGhlciBjb21tdW5pY2F0aW9ucyB0byBhbnkgUGFydHkgd2lsbCBiZSBpbiB3cml0aW5nIChpbmNsdWRpbmcgZWxlY3Ryb25pYyBtYWlsLCBmYWNzaW1pbGUgdHJhbnNtaXNzaW9uIG9yIHNpbWlsYXIgd3JpdGluZykgYW5kIHdpbGwgYmUgZ2l2ZW4gaW4gYWNjb3JkYW5jZSB3aXRoLCBpbiB0aGUgY2FzZSBvZiBDbGllbnQsIHN1Y2ggY29udGFjdCBpbmZvcm1hdGlvbiBwcm92aWRlZCBpbiBjb25uZWN0aW9uIHdpdGggdGhlIEVucm9sbG1lbnQgUHJvY2VzcywgYW5kIGluIHRoZSBjYXNlIG9mIENvbnN0YW50IFJldGFpbCwgc3VjaCBjb250YWN0IGluZm9ybWF0aW9uIHByb3ZpZGUgYnkgQ29uc3RhbnQgUmV0YWlsIGluIGNvbm5lY3Rpb24gd2l0aCBjb25maXJtYXRpb24gb2YgQ2xpZW50JnJzcXVvO3MgZW5nYWdlbWVudCBmb3IgdGhlIHNlcnZpY2VzIHRvIGJlIHByb3ZpZGVkIGhlcmV1bmRlciwgb3IgYXMgc3VjaCBQYXJ0eSBtYXkgdGhlcmVhZnRlciBzcGVjaWZ5IGZvciBzdWNoIHB1cnBvc2VzLiZuYnNwOyBFYWNoIHN1Y2ggbm90aWNlLCByZXF1ZXN0IG9yIG90aGVyIGNvbW11bmljYXRpb24gd2lsbCBiZSBlZmZlY3RpdmUgKGEpIGlmIGdpdmVuIGJ5IGVsZWN0cm9uaWMgbWFpbCBvciBmYWNzaW1pbGUsIHdoZW4gY29uZmlybWF0aW9uIG9mIHJlY2VpcHQgaXMgb2J0YWluZWQsIG9yIChiKSBpZiBnaXZlbiBieSBhbnkgb3RoZXIgbWVhbnMgd2hlbiByZWNlaXZlZCBieSBhIFBhcnR5IGF0IGl0cyBzcGVjaWZpZWQgYWRkcmVzcy48L2xpPiA8bGk+PHU+QW1lbmRtZW50czsgV2FpdmVyczwvdT4uIEV4Y2VwdCBmb3IgdGhlIEZlZSBBZGRlbmR1bSwgdGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMgbWF5IG5vdCBiZSBhbWVuZGVkLCBtb2RpZmllZCBvciBzdXBlcnNlZGVkLCB1bmxlc3MgZXhwcmVzc2x5IGFncmVlZCB0byBpbiB3cml0aW5nIGJ5IGJvdGggUGFydGllcy4mbmJzcDsgTm8gcHJvdmlzaW9uIG9mIHRoZXNlIFRlcm1zIGFuZCBDb25kaXRpb25zIG1heSBiZSB3YWl2ZWQgZXhjZXB0IGJ5IGFuIGluc3RydW1lbnQgaW4gd3JpdGluZyBleGVjdXRlZCBieSB0aGUgUGFydHkgYWdhaW5zdCB3aG8gdGhlIHdhaXZlciBpcyB0byBiZSBlZmZlY3RpdmUuJm5ic3A7IFRoZSBmYWlsdXJlIG9mIGVpdGhlciBQYXJ0eSBhdCBhbnkgdGltZSBvciB0aW1lcyB0byByZXF1aXJlIGZ1bGwgcGVyZm9ybWFuY2Ugb2YgYW55IHByb3Zpc2lvbiBoZXJlb2Ygd2lsbCBpbiBubyBtYW5uZXIgYWZmZWN0IHRoZSByaWdodCBvZiBzdWNoIFBhcnR5IGF0IGEgbGF0ZXIgdGltZSB0byBlbmZvcmNlIHRoZSBzYW1lLjwvbGk+IDxsaT48dT5TZXZlcmFiaWxpdHk8L3U+LiBJZiBhbnkgcHJvdmlzaW9uIG9yIHRlcm0gb2YgdGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMsIG5vdCBiZWluZyBvZiBhIGZ1bmRhbWVudGFsIG5hdHVyZSwgaXMgaGVsZCB0byBiZSBpbnZhbGlkLCBpbGxlZ2FsIG9yIHVuZW5mb3JjZWFibGUsIHRoZSB2YWxpZGl0eSwgbGVnYWxpdHkgYW5kIGVuZm9yY2VhYmlsaXR5IG9mIHRoZSByZW1haW5kZXIgb2YgdGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMgd2lsbCBub3QgYmUgYWZmZWN0ZWQuPC9saT4gPGxpPjx1PkZvcmNlIE1hamV1cmU8L3U+LiBOZWl0aGVyIFBhcnR5IHdpbGwgYmUgcmVzcG9uc2libGUgZm9yIGFueSBmYWlsdXJlIG9yIGRlbGF5IGluIGl0cyBwZXJmb3JtYW5jZSB1bmRlciB0aGVzZSBUZXJtcyBhbmQgQ29uZGl0aW9ucyBkdWUgdG8gY2F1c2UgYmV5b25kIGl0cyByZWFzb25hYmxlIGNvbnRyb2wsIGluY2x1ZGluZyBidXQgbm90IGxpbWl0ZWQgdG8sIGxhYm9yIGRpc3B1dGVzLCBzdHJpa2VzLCBsb2Nrb3V0cywgc2hvcnRhZ2VzIG9yIGluYWJpbGl0eSB0byBvYnRhaW4gbGFib3IsIGVuZXJneSwgcmF3IG1hdGVyaWFscyBvciBzdXBwbGllcywgd2FyLCByaW90LCBhY3Qgb2YgR29kIG9yIGdvdmVybm1lbnRhbCBhY3Rpb24uPC9saT4gPGxpPjx1PkFzc2lnbm1lbnQ7IFN1Y2Nlc3NvcnM8L3U+LiBOZWl0aGVyIFBhcnR5IG1heSBhc3NpZ24gdGhlc2UgVGVybXMgQ29uZGl0aW9ucyB3aXRob3V0IHRoZSBwcmlvciB3cml0dGVuIGNvbnNlbnQgb2YgdGhlIG90aGVyIFBhcnR5IGFuZCBhbnkgc3VjaCBhc3NpZ25tZW50IHdpdGhvdXQgcHJpb3Igd3JpdHRlbiBjb25zZW50IHNoYWxsIGJlIG51bGwgYW5kIHZvaWQsIGV4Y2VwdCB0aGF0IENvbnN0YW50IFJldGFpbCBtYXkgYXNzaWduIHRoZXNlIFRlcm1zIGFuZCBDb25kaXRpb25zIHdpdGhvdXQgcHJpb3Igd3JpdHRlbiBjb25zZW50IChhKSB0byBhbiBBZmZpbGlhdGUgb3IgKGIpIGFzIHBhcnQgb2YgYSBib25hIGZpZGUgY29ycG9yYXRlIHJlb3JnYW5pemF0aW9uIG9yIGEgc2FsZSBvZiBpdHMgYnVzaW5lc3MgYW5kLCBpbiBjb25uZWN0aW9uIHRoZXJld2l0aCwgQ29uc3RhbnQgUmV0YWlsIG1heSwgYW5kIENsaWVudCBjb25zZW50cyB0bywgdHJhbnNmZXIgb2YgQ3VzdG9tZXIgSW5mb3JtYXRpb24gYXMgcGFydCBvZiBhbnkgc3VjaCB0cmFuc2FjdGlvbi4mbmJzcDsgRm9yIHRoZSBhdm9pZGFuY2Ugb2YgZG91YnQsIGFueSBhY3F1aXJlciBvZiBDb25zdGFudCBSZXRhaWwgb3IgYW55IG9mIGl0cyBBZmZpbGlhdGVzLCBvciBvZiB0aGVpciByZXNwZWN0aXZlIGJ1c2luZXNzIG9yIGFsbCBvciBzdWJzdGFudGlhbGx5IGFsbCBvZiB0aGVpciByZXNwZWN0aXZlIGFzc2V0cywgd2hldGhlciBieSBkaXJlY3QgcHVyY2hhc2Ugb2YgY2FwaXRhbCBzdG9jayBvciBlcXVpdHksIG1lcmdlciwgY29uc29saWRhdGlvbiwgcmVvcmdhbml6YXRpb24sIGFtYWxnYW1hdGlvbiBvciBzaW1pbGFyIHRyYW5zYWN0aW9uLCBvciBvdGhlciBzaW1pbGFyIHN1Y2Nlc3NvciBzaGFsbCwgZm9yIGFsbCBwdXJwb3NlcyBoZXJlaW4sIGJlIGRlZW1lZCB0byBiZSAmbGRxdW87Q29uc3RhbnQgUmV0YWlsJnJkcXVvOyBvciBhbiAmbGRxdW87QWZmaWxpYXRlJnJkcXVvOyBhcyBhcHBsaWNhYmxlLiZuYnNwOzwvbGk+IDxsaT48dT5IZWFkaW5nczwvdT4uIFRoZSBoZWFkaW5ncyBvZiB0aGUgU2VjdGlvbnMgb2YgdGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMgaGF2ZSBiZWVuIGluY2x1ZGVkIGZvciB0aGUgY29udmVuaWVuY2Ugb2YgdGhlIFBhcnRpZXMgYW5kIGFyZSBub3QgcGFydCBvZiB0aGUgQWdyZWVtZW50LCBub3IgYXJlIHRoZSBoZWFkaW5ncyB0byBiZSB1c2VkIHRvIGFsdGVyIG9yIGludGVycHJldCB0aGUgdGVybXMgaGVyZW9mLjwvbGk+IDwvb2w+IDwvbGk+IDxsaT4gRGVmaW5pdGlvbnMuIDxwPldoZW5ldmVyIHVzZWQgaW4gdGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMsIHRoZSBmb2xsb3dpbmcgY2FwaXRhbGl6ZWQgdGVybXMgc2hhbGwgaGF2ZSB0aGUgZm9sbG93aW5nIHNwZWNpZmllZCBtZWFuaW5nczo8L3A+IDxvbD4gPGxpPjxlbT4mbGRxdW87PHU+QWRkaXRpb25hbCBCcmFuZHM8L3U+JnJkcXVvOzwvZW0+IG1lYW5zIGFueSBicmFuZHMgcmVsYXRlZCB0byBhbmQgYXNzb2NpYXRlZCB3aXRoIHBhcnRpY3VsYXIgcHJvZHVjdHMgb2YgYSBWZW5kb3IgdGhhdCBpcyBub3QgYW4gQXV0aG9yaXplZCBCcmFuZC48L2xpPiA8bGk+JmxkcXVvOzxlbT48dT5BZHZlcnRpc2luZzwvdT48L2VtPiZyZHF1bzsgbWVhbnMgYW55IHRoaXJkLXBhcnR5LWFuZC9vciBDbGllbnQtZ2VuZXJhdGVkIGFkdmVydGlzaW5nIGRpc3BsYXllZCBvbiB0aGUgSG9zdGVkIFNpdGUuPC9saT4gPGxpPiZsZHF1bzs8ZW0+PHU+QWR2ZXJ0aXNpbmcgUmV2ZW51ZTwvdT48L2VtPiZyZHF1bzsgbWVhbnMgcmV2ZW51ZXMgZ2VuZXJhdGVkIGJ5IEFkdmVydGlzaW5nIG9uIHRoZSBIb3N0ZWQgU2l0ZSwgaW5jbHVkaW5nLCB3aXRob3V0IGxpbWl0YXRpb24sIGFueSBhcyBhIHJlc3VsdCBvZiBDdXN0b21lcnMgdmlzaXRpbmcgdGhlIEhvc3RlZCBTaXRlIHdoZXJlIHN1Y2ggQ3VzdG9tZXJzIGNsaWNrIG9uIG9yIG90aGVyd2lzZSBpbnRlcmFjdCB3aXRoIHN1Y2ggQWR2ZXJ0aXNpbmcgYW5kIGFueSBwcm9kdWN0IHBsYWNlbWVudHMuPC9saT4gPGxpPiZsZHF1bzs8ZW0+PHU+QWZmaWxpYXRlPC91PjwvZW0+JnJkcXVvOyBtZWFucywgYXMgdG8gYW55IFBlcnNvbiwgYW55IG90aGVyIFBlcnNvbiB0aGF0LCBkaXJlY3RseSBvciBpbmRpcmVjdGx5LCBpcyBjb250cm9sbGVkIGJ5LCBpcyB1bmRlciBjb21tb24gY29udHJvbCB3aXRoIG9yIGNvbnRyb2xzIHN1Y2ggUGVyc29uLiBGb3IgdGhpcyBwdXJwb3NlLCBjb250cm9sIG1lYW5zIG93bmVyc2hpcCBvciB2b3RpbmcgcmlnaHRzIG92ZXIgYXQgbGVhc3QgNTAlIG9mIHRoZSBvdXRzdGFuZGluZyB2b3Rpbmcgb3IgZXF1aXR5IHNlY3VyaXRpZXMgb2YgdGhlIFBlcnNvbiBpbiBxdWVzdGlvbiBvciB0aGUgcG93ZXIgdG8gZGlyZWN0IG9yIGNhdXNlIHRoZSBkaXJlY3Rpb24gb2YgbWFuYWdlbWVudCBvciBwb2xpY2llcyBvZiBzdWNoIFBlcnNvbiwgd2hldGhlciB0aHJvdWdoIHZvdGluZyBzZWN1cml0aWVzLCBieSBjb250cmFjdCBvciBvdGhlcndpc2UuJm5ic3A7PC9saT4gPGxpPjxlbT4mbGRxdW87PHU+QXBwbGljYWJsZSBTYWxlcyBUYXggUmF0ZXM8L3U+JnJkcXVvOzwvZW0+IG1lYW5zIHRob3NlIHJhdGVzIG9mIHNhbGVzLCB1c2UsIHRyYW5zZmVyIG9yIHNpbWlsYXIgdGF4IHBheWFibGUgdG8gYW55IGdvdmVybm1lbnRhbCBhdXRob3JpdHksIHdoZXRoZXIgZmVkZXJhbCwgc3RhdGUsIG11bmljaXBhbCBvciBsb2NhbCwgb24gYW55IHNhbGUgb2YgTWVyY2hhbmRpc2UgdGhyb3VnaCB0aGUgSG9zdGVkIFNpdGUgYXMgd2VsbCBhcyBvbiBhbnkgb3RoZXIgY2hhcmdlIG1hZGUgaW4gY29ubmVjdGlvbiB3aXRoIHN1Y2ggc2FsZSwgYXMgZGV0ZXJtaW5lZCBieSB0aGUgQ2xpZW50LCBlbnRlcmVkIGludG8gdGhlIENvbnN0YW50IFJldGFpbCBQbGF0Zm9ybSBhcyBwYXJ0IG9mIHRoZSBFbnJvbGxtZW50IFByb2Nlc3MsIGFuZCwgYmFzZWQgb24gc3VjaCBkZXRlcm1pbmF0aW9ucyBhbmQgZW50cmllcyBieSB0aGUgQ2xpZW50LCByZWZsZWN0ZWQgYW5kIGluY29ycG9yYXRlZCBpbnRvIHRoZSBwYXltZW50IGNhbGN1bGF0aW9uIHByb2Nlc3NlcyBvZiB0aGUgSG9zdGVkIFNpdGUuIENvbnN0YW50IFJldGFpbCBpcyByZWx5aW5nIHVwb24gZm9yIGFsbCBwdXJwb3NlcyB0aGUgQ2xpZW50JnJzcXVvO3MgZGV0ZXJtaW5hdGlvbiBvZiBzdWNoIEFwcGxpY2FibGUgU2FsZXMgVGF4IFJhdGVzIGFuZCwgbm90d2l0aHN0YW5kaW5nIGFueXRoaW5nIGVsc2UgaGVyZWluLCBuZWl0aGVyIENvbnN0YW50IFJldGFpbCwgYW55IG9mIGl0cyBBZmZpbGlhdGVzIG5vciBhbnkgb2YgdGhlaXIgcmVzcGVjdGl2ZSBSZXByZXNlbnRhdGl2ZXMgc2hhbGwgaGF2ZSBhbnkgbGlhYmlsaXR5IHdoYXRzb2V2ZXIgcmVsYXRlZCB0byB0aGUgQXBwbGljYWJsZSBTYWxlcyBUYXggUmF0ZXMuPC9saT4gPGxpPjxlbT4mbGRxdW87PHU+QXV0aG9yaXplZCBCcmFuZHM8L3U+JnJkcXVvOzwvZW0+IG1lYW5zIHRoZSBicmFuZHMgcmVsYXRlZCB0byBhbmQgYXNzb2NpYXRlZCB3aXRoIHBhcnRpY3VsYXIgcHJvZHVjdHMgb2ZmZXJlZCB0aHJvdWdoIHRoZSBDb25zdGFudCBSZXRhaWwgUGxhdGZvcm0gdGhhdCBtYXkgYmUgc2VsZWN0ZWQgYnkgdGhlIENsaWVudCBkdXJpbmcgdGhlIEVucm9sbG1lbnQgUHJvY2VzcyBhcyB0aG9zZSB0aGUgdW5kZXJseWluZyBwcm9kdWN0cyBvZiB3aGljaCBtYXkgYmUgb2ZmZXJlZCBvbiB0aGUgSG9zdGVkIFNpdGUuPC9saT4gPGxpPjxlbT4mbGRxdW87PHU+Q2xpZW50PC91PiZyZHF1bzs8L2VtPiBtZWFucyB0aGUgUGVyc29uIHRyYW5zYWN0aW5nIHdpdGggQ29uc3RhbnQgUmV0YWlsIGFuZCBhY2NlcHRpbmcgdGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMgaW4gY29ubmVjdGlvbiB3aXRoIHRoZSBlbnJvbGxtZW50IGZvciB0aGUgc2VydmljZXMgb2YgQ29uc3RhbnQgUmV0YWlsIHRocm91Z2ggdGhlIENvbnN0YW50IFJldGFpbCBQbGF0Zm9ybSwgd2hldGhlciBhdCB0aGUgdGltZSBvZiBlbnJvbGxtZW50IG9yIGEgc3Vic2VxdWVudCB0aW1lLjwvbGk+IDxsaT4mbGRxdW87PGVtPjx1PkNvbnN0YW50IFJldGFpbDwvdT48L2VtPiZyZHF1bzsgbWVhbnMgQ3ltYXggU2VydmljZXMgVVNBIExMQyAob3IgYW55IHN1Y2Nlc3NvciBvciBhc3NpZ24gb2Ygc3VjaCBlbnRpdHkpLjwvbGk+IDxsaT4mbGRxdW87PGVtPjx1PkNvbnN0YW50IFJldGFpbCBDb250ZW50PC91PjwvZW0+JnJkcXVvOyBtZWFucyBhbnkgYW5kIGFsbCBjb250ZW50IG9yIGluZm9ybWF0aW9uIG93bmVkIG9yIGNvbnRyb2xsZWQgKGUuZy4sIGJ5IGxpY2Vuc2Ugb3Igb3RoZXJ3aXNlKSBieSBDb25zdGFudCBSZXRhaWwgb3IgaXRzIEFmZmlsaWF0ZXMsIGluY2x1ZGluZywgd2l0aG91dCBsaW1pdGF0aW9uLCB0ZXh0LCBncmFwaGljcywgcGhvdG9ncmFwaHMsIHZpZGVvIGFuZCBhdWRpby48L2xpPiA8bGk+JmxkcXVvOzxlbT48dT5Db25zdGFudCBSZXRhaWwtRnVybmlzaGVkIEl0ZW08L3U+PC9lbT4mcmRxdW87IG1lYW5zIGFueSBDb25zdGFudCBSZXRhaWwgQ29udGVudCBvciBhbnkgb3RoZXIgSW50ZWxsZWN0dWFsIFByb3BlcnR5IG93bmVkIG9yIGNvbnRyb2xsZWQgKGUuZy4sIGJ5IGxpY2Vuc2Ugb3Igb3RoZXJ3aXNlKSBieSBDb25zdGFudCBSZXRhaWwgb3IgaXRzIEFmZmlsaWF0ZXMsIGFzIHRoZSBjYXNlIG1heSBiZSwgdGhhdCBpcyBmdXJuaXNoZWQgYnkgQ29uc3RhbnQgUmV0YWlsIG9yIGl0cyBBZmZpbGlhdGVzIGluIGNvbm5lY3Rpb24gd2l0aCBnZW5lcmF0aW9uIG9mIHRoZSBIb3N0ZWQgU2l0ZSBvciBvdGhlcndpc2UgaW4gY29ubmVjdGlvbiB3aXRoIHRoZSBwZXJmb3JtYW5jZSBvZiBDb25zdGFudCBSZXRhaWwmcnNxdW87cyBvYmxpZ2F0aW9ucyB1bmRlciB0aGVzZSBUZXJtcyBhbmQgQ29uZGl0aW9ucy48L2xpPiA8bGk+JmxkcXVvOzxlbT48dT5Db25zdGFudCBSZXRhaWwgSW50ZWxsZWN0dWFsIFByb3BlcnR5PC91PjwvZW0+JnJkcXVvOyBtZWFucywgY29sbGVjdGl2ZWx5LCB0aGUgSG9zdGVkIFNpdGUgKG90aGVyIHRoYW4gdGhlIERlc2lnbmF0ZWQgVVJMcyksIHRoZSBDb25zdGFudCBSZXRhaWwgUGxhdGZvcm0sIHRoZSBDb25zdGFudCBSZXRhaWwtRnVybmlzaGVkIEl0ZW1zLCB0aGUgQ29uc3RhbnQgUmV0YWlsLU93bmVkIERldmVsb3BtZW50cywgYW5kIGFsbCBJbnRlbGxlY3R1YWwgUHJvcGVydHkgYXNzb2NpYXRlZCB3aXRoIGFueSBvZiB0aGUgZm9yZWdvaW5nLjwvbGk+IDxsaT4mbGRxdW87PGVtPjx1PkNvbnN0YW50IFJldGFpbC1Pd25lZCBEZXZlbG9wbWVudHM8L3U+PC9lbT4mcmRxdW87IG1lYW5zIGFueSB0ZWNobm9sb2d5IChpbmNsdWRpbmcgYW55IGFkYXB0YXRpb24sIG1vZGlmaWNhdGlvbiwgaW1wcm92ZW1lbnQgb3IgZGVyaXZhdGl2ZSB3b3JrIG9mIGFueSBDb25zdGFudCBSZXRhaWwtRnVybmlzaGVkIEl0ZW0pIHRoYXQgaXMgZGV2ZWxvcGVkIGJ5LCBvciBvbiBiZWhhbGYgb2YsIENvbnN0YW50IFJldGFpbCBvciBhbnkgb2YgaXRzIEFmZmlsaWF0ZXMsIGZvciB1c2UgaW4gY29ubmVjdGlvbiB3aXRoIHRoZSBIb3N0ZWQgU2l0ZSBvciB0byBpbXBsZW1lbnQgdGhlIGFjdGl2aXRpZXMgY29udGVtcGxhdGVkIGJ5IHRoZXNlIFRlcm1zIGFuZCBDb25kaXRpb25zIG9yIHRoYXQgaXMgZGV2ZWxvcGVkIGJ5LCBvciBvbiBiZWhhbGYgb2YsIENvbnN0YW50IFJldGFpbCBvciBhbnkgb2YgaXRzIEFmZmlsaWF0ZXMgZm9yIHVzZSBvbiBvdGhlciB3ZWJzaXRlcyBob3N0ZWQgYW5kIG1haW50YWluZWQgYnkgQ29uc3RhbnQgUmV0YWlsIG9yIGl0cyBBZmZpbGlhdGVzLCBiZXNpZGVzIHRoZSBIb3N0ZWQgU2l0ZSwgYWxvbmcgd2l0aCBhbGwgYWRhcHRhdGlvbnMsIG1vZGlmaWNhdGlvbnMsIGltcHJvdmVtZW50cyBvciBkZXJpdmF0aXZlIHdvcmtzIHRoZXJlb2YuPC9saT4gPGxpPjxlbT4mbGRxdW87PHU+Q29uc3RhbnQgUmV0YWlsIFBsYXRmb3JtPC91PiZyZHF1bzs8L2VtPiBtZWFucyB0aGUgcHJvcHJpZXRhcnkgb25saW5lIHBsYXRmb3JtIG9mIENvbnN0YW50IFJldGFpbCBhbmQvb3IgaXRzIEFmZmlsaWF0ZXMgZm9yIHRoZSBnZW5lcmF0aW9uLCBvcGVyYXRpb24gYW5kIG1hbmFnZW1lbnQgb2YgaG9zdGVkIGUtY29tbWVyY2Ugd2Vic2l0ZXMuPC9saT4gPGxpPiZsZHF1bzs8ZW0+PHU+Q3VzdG9tZXI8L3U+PC9lbT4mcmRxdW87IG1lYW5zIGEgUGVyc29uIHdobyBhY2Nlc3NlcyB0aGUgSG9zdGVkIFNpdGUgaW4gYW55IG1hbm5lciwgd2hldGhlciBvciBub3QgYSBwdXJjaGFzZSBpcyBtYWRlLjwvbGk+IDxsaT4mbGRxdW87PGVtPjx1PkN1c3RvbWVyIEluZm9ybWF0aW9uPC91PjwvZW0+JnJkcXVvOyBtZWFucywgd2l0aCByZXNwZWN0IHRvIGFueSBvcmRlciBvZiBNZXJjaGFuZGlzZSBtYWRlIHRocm91Z2ggdGhlIEhvc3RlZCBTaXRlIGJ5IGEgQ3VzdG9tZXIsIGNvbGxlY3RpdmVseSwgdGhlIG5hbWUgb2YgdGhlIEN1c3RvbWVyLCB0aGUgQ3VzdG9tZXImcnNxdW87cyBlbWFpbCBhZGRyZXNzLCB0aGUgQ3VzdG9tZXImcnNxdW87cyBiaWxsaW5nIGFuZCBzaGlwIHRvIGFkZHJlc3NlcywgdGhlIEN1c3RvbWVyJnJzcXVvO3MgcGhvbmUgbnVtYmVyKHMpLCBhbmQgdGhlIGNyZWRpdCBjYXJkLCBiYW5rIGFjY291bnQgb3Igb3RoZXIgcGF5bWVudCBpbmZvcm1hdGlvbiBmb3Igc3VjaCBvcmRlci4gRm9yIHRoZSBhdm9pZGFuY2Ugb2YgZG91YnQsIG5vIGN1c3RvbWVyIGRhdGEgdGhhdCBkb2VzIG5vdCBjb250YWluIGFueSBvZiB0aGUgZm9yZWdvaW5nIGluZm9ybWF0aW9uIHNoYWxsIGJlIGRlZW1lZCBDdXN0b21lciBJbmZvcm1hdGlvbi48L2xpPiA8bGk+JmxkcXVvOzxlbT48dT5EYW1hZ2VzPC91PjwvZW0+JnJkcXVvOyBtZWFucyBsaWFiaWxpdGllcywgZGFtYWdlcywgYXdhcmRzLCBzZXR0bGVtZW50cywgbG9zc2VzLCBjbGFpbXMgYW5kIGV4cGVuc2VzLCBpbmNsdWRpbmcgcmVhc29uYWJsZSBhdHRvcm5leSZyc3F1bztzIGZlZXMgYW5kIGV4cGVuc2VzIGFuZCBjb3N0cyBvZiBpbnZlc3RpZ2F0aW9uLjwvbGk+IDxsaT4mbGRxdW87PGVtPjx1PkRlc2lnbmF0ZWQgVVJMczwvdT48L2VtPiZyZHF1bzsgbWVhbnMgdGhvc2UgdW5pZm9ybSByZXNvdXJjZSBsb2NhdG9ycyByZWdpc3RlcmVkIHRvIHRoZSBDbGllbnQgb3IgaXRzIEFmZmlsaWF0ZXMgKG9yIGFueSBzdWNjZXNzb3Igb3IgcmVwbGFjZW1lbnQgVVJMIHRoZXJlb2YpIGlkZW50aWZpZWQgYnkgdGhlIENsaWVudCBhbmQgZW50ZXJlZCBpbnRvIHRoZSBDb25zdGFudCBSZXRhaWwgUGxhdGZvcm0gaW4gY29ubmVjdGlvbiB3aXRoIHRoZSBFbnJvbGxtZW50IFByb2Nlc3MuPC9saT4gPGxpPjxlbT4mbGRxdW87PHU+RW5yb2xsbWVudCBQcm9jZXNzPC91PiZyZHF1bzs8L2VtPiBtZWFucyB0aGUgcHJvY2VzcyBvZiB0aGUgQ2xpZW50IGVucm9sbGluZyBmb3IgdGhlIHByb3Zpc2lvbiBvZiB0aGUgc2VydmljZXMgY29udGVtcGxhdGVkIGJ5IHRoZXNlIFRlcm1zIGFuZCBDb25kaXRpb25zIHRocm91Z2ggdGhlIENvbnN0YW50IFJldGFpbCB3ZWJzaXRlLCBpbmNsdWRpbmcsIHdpdGhvdXQgbGltaXRhdGlvbiwgdGhlIENsaWVudCZyc3F1bztzIHNlbGVjdGlvbiBvZiB0aGUgU2VsZWN0ZWQgQnJhbmRzLCBpZGVudGlmaWNhdGlvbiBvZiB0aGUgRGVzaWduYXRlZCBVUkxzLCBwcm92aXNpb24gb2YgY3JlZGl0IGNhcmQgYWNjb3VudCBpbmZvcm1hdGlvbiwgYW5kIHRoZSBwcmVhdXRob3JpemF0aW9uIG9mIGNoYXJnZXMgdGhlcmVvbiB0byBiZSBtYWRlIGJ5IENvbnN0YW50IFJldGFpbCwgYW5kLCBpbiBjb25uZWN0aW9uIHdpdGggc3VjaCBwcm9jZXNzLCB0aGUgQ2xpZW50IGlzIGFjY2VwdGluZyBhbmQgYWdyZWVpbmcgdG8gYmUgYm91bmQgYnkgdGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMsIHdoZXRoZXIgc2ltdWx0YW5lb3VzbHkgb3IgYXQgYSBzdWJzZXF1ZW50IHRpbWUuPC9saT4gPGxpPjxlbT4mbGRxdW87PHU+RmVlIEFkZGVuZHVtPC91PiZyZHF1bzs8L2VtPiBtZWFucyB0aGUgc2NoZWR1bGUgc2V0dGluZyBmb3J0aCB0aGUgY2hhcmdlcyB0byB0aGUgQ2xpZW50IGZvciB0aGUgc2VydmljZXMgY29udGVtcGxhdGVkIGhlcmV1bmRlciBhbmQgdGhlIG1ldGhvZCBvZiBjYWxjdWxhdGlvbiB0aGVyZW9mLCBpbmNsdWRpbmcsIHdpdGhvdXQgbGltaXRhdGlvbjogKGEpIE1vbnRobHkgRmVlcywgaW5jbHVkaW5nIHdpdGhvdXQgbGltaXRhdGlvbiB0aGUgZml4ZWQgbW9udGhseSBjaGFyZ2UgZm9yIGhvc3RpbmcgdGhlIEhvc3RlZCBTaXRlIGRlcGVuZGluZyBvbiB0aGUgbnVtYmVyIG9mIFNlbGVjdGVkIEJyYW5kcyBvZmZlcmVkIG9uIGl0IGFuZCBmb3IgYW55IHNlcnZpY2VzIHB1cnN1YW50IHRvIDx1PlNlY3Rpb24gMjwvdT4sIGlmIGVsZWN0ZWQgYnkgdGhlIENsaWVudCwgKGIpIGNoYXJnZXMgZm9yIGluY2x1c2lvbiBvZiBhbnkgQWRkaXRpb25hbCBCcmFuZHMgb24gdGhlIEhvc3RlZCBTaXRlLCAoYykgY29zdHMgYW5kIGV4cGVuc2VzIHJlbGF0ZWQgdG8gbWFya2V0aW5nIGFuZCBhZHZlcnRpc2luZyBzZXJ2aWNlcyBwdXJzdWFudCB0byA8dT5TZWN0aW9uIDI8L3U+IHRvIGJlIHBhc3NlZCBvbnRvIENsaWVudCwgYW5kIChkKSB0aGUgdGhlbi1hcHBsaWNhYmxlIHBlcmNlbnRhZ2Ugb2YgTmV0IFNhbGVzIFJldmVudWUgcGF5YWJsZSB0byBDb25zdGFudCBSZXRhaWwgYXMgYSBjaGFyZ2UgZm9yIHRoZSBzZXJ2aWNlcyBoZXJldW5kZXIuIFRoZSBGZWUgQWRkZW5kdW0gaXMgc3ViamVjdCB0byBjaGFuZ2UgZnJvbSB0aW1lIHRvIHRpbWUgYnkgQ29uc3RhbnQgUmV0YWlsIGFuZCBpdHMgQWZmaWxpYXRlcywgd2hpY2ggdXBkYXRlZCBmb3JtIENvbnN0YW50IFJldGFpbCBzaGFsbCBtYWtlIGF2YWlsYWJsZSB0byBDbGllbnRzLCBhbmQgdGhlIGN1cnJlbnQgRmVlIEFkZGVuZHVtIGluIGVmZmVjdCBjYW4gYmUgdmlld2VkIFtoZXJlXTxhIGhyZWY9XCIjX2Z0bjNcIiBuYW1lPVwiX2Z0bnJlZjNcIj5bM108L2E+IGFuZCBpcyBpbmNvcnBvcmF0ZWQgYW5kIG1hZGUgcGFydCBvZiB0aGVzZSBUZXJtcyBhbmQgQ29uZGl0aW9ucyBieSByZWZlcmVuY2UuPC9saT4gPGxpPiZsZHF1bzs8ZW0+PHU+SG9zdGVkIFNpdGU8L3U+PC9lbT4mcmRxdW87IG1lYW5zIHRoZSBlLWNvbW1lcmNlIHdlYiBzaXRlIGRlc2lnbmF0ZWQgYnksIGFuZCBhY2Nlc3NpYmxlIHZpYSwgdGhlIERlc2lnbmF0ZWQgVVJMcywgZ2VuZXJhdGVkIGJ5IHRoZSBDb25zdGFudCBSZXRhaWwgUGxhdGZvcm0gYW5kIGhvc3RlZCBieSBDb25zdGFudCBSZXRhaWwgaW4gYWNjb3JkYW5jZSB3aXRoIHRoZXNlIFRlcm1zIGFuZCBDb25kaXRpb25zLjwvbGk+IDxsaT4mbGRxdW87PGVtPjx1PkludGVsbGVjdHVhbCBQcm9wZXJ0eTwvdT48L2VtPiZyZHF1bzsgbWVhbnMgYW55IGFuZCBhbGwgbm93IGtub3duIG9yIGhlcmVhZnRlciBrbm93biB0YW5naWJsZSBhbmQgaW50YW5naWJsZSBpbnRlbGxlY3R1YWwgcHJvcGVydHkgYW5kIHJpZ2h0cyByZWxhdGVkIHRoZXJldG8sIGluY2x1ZGluZyB3aXRob3V0IGxpbWl0YXRpb246IChhKSByaWdodHMgYXNzb2NpYXRlZCB3aXRoIHdvcmtzIG9mIGF1dGhvcnNoaXAgdGhyb3VnaG91dCB0aGUgdW5pdmVyc2UsIGluY2x1ZGluZyBidXQgbm90IGxpbWl0ZWQgdG8gY29weXJpZ2h0cywgbW9yYWwgcmlnaHRzLCBhbmQgbWFzay13b3JrcywgKGIpIHRyYWRlbWFyaywgc2VydmljZSBtYXJrLCB0cmFkZSBkcmVzcyBhbmQgdHJhZGUgbmFtZSByaWdodHMgYW5kIHNpbWlsYXIgcmlnaHRzLCAoYykgdHJhZGUgc2VjcmV0IHJpZ2h0cywgKGQpIHRlY2hub2xvZ3ksIChlKSBwYXRlbnRzLCBkZXNpZ25zLCBhbGdvcml0aG1zIGFuZCBvdGhlciBpbmR1c3RyaWFsIHByb3BlcnR5IHJpZ2h0cywgKGYpIGFsbCBvdGhlciBpbnRlbGxlY3R1YWwgYW5kIGluZHVzdHJpYWwgcHJvcGVydHkgcmlnaHRzIG9mIGV2ZXJ5IGtpbmQgYW5kIG5hdHVyZSB0aHJvdWdob3V0IHRoZSB1bml2ZXJzZSBhbmQgaG93ZXZlciBkZXNpZ25hdGVkIChpbmNsdWRpbmcgZG9tYWluIG5hbWVzLCBsb2dvcywgJmxkcXVvO3JlbnRhbCZyZHF1bzsgcmlnaHRzIGFuZCByaWdodHMgdG8gcmVtdW5lcmF0aW9uKSwgd2hldGhlciBhcmlzaW5nIGJ5IG9wZXJhdGlvbiBvZiBsYXcsIGNvbnRyYWN0LCBsaWNlbnNlLCBvciBvdGhlcndpc2UsIGFuZCAoZykgYWxsIHJlZ2lzdHJhdGlvbnMsIGluaXRpYWwgYXBwbGljYXRpb25zLCByZW5ld2FscywgZXh0ZW5zaW9ucywgY29udGludWF0aW9ucywgZGl2aXNpb25zIG9yIHJlaXNzdWVzIGhlcmVvZiBub3cgb3IgaGVyZWFmdGVyIGluIGZvcmNlIChpbmNsdWRpbmcgYW55IHJpZ2h0cyBpbiBhbnkgb2YgdGhlIGZvcmVnb2luZykuPC9saT4gPGxpPiZsZHF1bzs8ZW0+PHU+TWVyY2hhbmRpc2U8L3U+PC9lbT4mcmRxdW87IG1lYW5zIHByb2R1Y3RzIG9mZmVyZWQgZm9yIHNhbGUgb24gdGhlIEhvc3RlZCBTaXRlLjwvbGk+IDxsaT48ZW0+JmxkcXVvOzx1Pk1vbnRobHkgRmVlPC91PiZyZHF1bzs8L2VtPiBtZWFucyB0aGUgbW9udGhseSBjaGFyZ2UgdG8gdGhlIENsaWVudCBmb3IgdGhlIHNlcnZpY2VzIGNvbnRlbXBsYXRlZCBoZXJldW5kZXIgYW5kIGFzIGNhbGN1bGF0ZWQgaW4gYWNjb3JkYW5jZSB3aXRoIGFuZCBzZXQgZm9ydGggb24gdGhlIEZlZSBBZGRlbmR1bS4gVGhlIGN1cnJlbnQgRmVlIEFkZGVuZHVtIGluIGVmZmVjdCBjYW4gYmUgdmlld2VkIFtoZXJlXTxhIGhyZWY9XCIjX2Z0bjRcIiBuYW1lPVwiX2Z0bnJlZjRcIj5bNF08L2E+PHN0cm9uZz4uJm5ic3A7IDwvc3Ryb25nPjwvbGk+IDxsaT4mbGRxdW87PGVtPjx1Pk5ldCBSZXR1cm48L3U+PC9lbT4mcmRxdW87IG1lYW5zIHRoZSBvcmlnaW5hbCBhbW91bnQgcGFpZCBmb3IgTWVyY2hhbmRpc2UgdGhhdCBoYXMgYmVlbiByZXR1cm5lZCwgaW5jbHVkaW5nIEN1c3RvbWVyIGNoYXJnZSBiYWNrcy48L2xpPiA8bGk+JmxkcXVvOzxlbT48dT5OZXQgU2FsZXMgUmV2ZW51ZTwvdT48L2VtPiZyZHF1bzsgbWVhbnMgYWxsIHJldmVudWVzIGZyb20gdGhlIEhvc3RlZCBTaXRlLCBpbmNsdWRpbmcgd2l0aG91dCBsaW1pdGF0aW9uOiAoYSkgYWxsIEFkdmVydGlzaW5nIFJldmVudWUsIGFuZCAoYikgcmV2ZW51ZXMgZ2VuZXJhdGVkIGJ5IE1lcmNoYW5kaXNlIHNhbGVzIHRocm91Z2ggdGhlIEhvc3RlZCBTaXRlLCBpbmNsdWRpbmcsIHdpdGhvdXQgbGltaXRhdGlvbiwgYXMgYSByZXN1bHQgb2YgQ3VzdG9tZXJzIHZpc2l0aW5nIHRoZSBIb3N0ZWQgU2l0ZSB3aGVyZSBzdWNoIEN1c3RvbWVycyBwdXJjaGFzZSBNZXJjaGFuZGlzZSB0aHJvdWdoIHRoZSBIb3N0ZWQgU2l0ZSB1c2luZyBDb25zdGFudCBSZXRhaWwmcnNxdW87cyBhdXRvbWF0ZWQgb3JkZXJpbmcgc3lzdGVtLCA8dT5wcm92aWRlZDwvdT4gc3VjaCBDdXN0b21lcnMgYWNjZXB0IGRlbGl2ZXJ5IG9mIE1lcmNoYW5kaXNlIGF0IHRoZSBzaGlwcGluZyBkZXN0aW5hdGlvbiBhbmQgcmVtaXQgZnVsbCBwYXltZW50IHRoZXJlZm9yZSB0byB0aGUgQ2xpZW50LiZuYnNwOyBOZXQgU2FsZXMgUmV2ZW51ZSBpbmNsdWRlcyBhbGwgc2hpcHBpbmcgY2hhcmdlcyBwYWlkIGJ5IEN1c3RvbWVycyBidXQgZG9lcyBub3QgaW5jbHVkZSB0YXhlcyBvciBOZXQgUmV0dXJucy4mbmJzcDsgRGVwZW5kaW5nIG9uIHRoZSBwYXJ0aWN1bGFyIGNob2ljZXMgbWFkZSBieSB0aGUgQ2xpZW50IGR1cmluZyB0aGUgRW5yb2xsbWVudCBQcm9jZXNzLCB0aGUgQ2xpZW50IHNoYWxsIGJlIGNoYXJnZWQgYSBmZWUgYmFzZWQgb24gYSBwZXJjZW50YWdlIG9mIE5ldCBTYWxlcyBSZXZlbnVlLCB3aXRoIHN1Y2ggcGVyY2VudGFnZSBiZWluZyBzZXQgZm9ydGggb24gdGhlIEZlZSBBZGRlbmR1bSwgcGF5YWJsZSBpbW1lZGlhdGVseSB1cG9uIGNvbXBsZXRpb24gb2YgYSB0cmFuc2FjdGlvbiBnZW5lcmF0aW5nIE5ldCBTYWxlcyBSZXZlbnVlIGJ5IHByZS1hdXRob3JpemVkIGNoYXJnZSB0byB0aGUgQ2xpZW50JnJzcXVvO3MgY3JlZGl0IGNhcmQuPC9saT4gPGxpPiZsZHF1bzs8ZW0+PHU+UGFydGllczwvdT48L2VtPiZyZHF1bzsgbWVhbnMsIHRvZ2V0aGVyLCBDbGllbnQgYW5kIENvbnN0YW50IFJldGFpbCBhbmQgZWFjaCwgYSAmbGRxdW87PGVtPjx1PlBhcnR5PC91PjwvZW0+JnJkcXVvOy48L2xpPiA8bGk+JmxkcXVvOzxlbT48dT5QZXJzb248L3U+PC9lbT4mcmRxdW87IG1lYW5zIGFueSBpbmRpdmlkdWFsLCBjb3Jwb3JhdGlvbiwgbGltaXRlZC1saWFiaWxpdHkgY29tcGFueSwgcGFydG5lcnNoaXAsIGZpcm0sIGpvaW50IHZlbnR1cmUsIGFzc29jaWF0aW9uLCBqb2ludC1zdG9jayBjb21wYW55LCB0cnVzdCwgb3Igb3RoZXIgZW50aXR5IG9yIG9yZ2FuaXphdGlvbiwgaW5jbHVkaW5nIGEgZ292ZXJubWVudCBvciBwb2xpdGljYWwgc3ViZGl2aXNpb24gb3IgYW4gYWdlbmN5IG9yIGluc3RydW1lbnRhbGl0eSB0aGVyZW9mLjwvbGk+IDxsaT48ZW0+JmxkcXVvOzx1PlByaXZhY3kgUG9saWN5PC91PiZyZHF1bzs8L2VtPiBtZWFucyBhIHN0YW5kYXJkIHByaXZhY3kgcG9saWN5IGZvciB0aGUgSG9zdGVkIFNpdGUsIGdvdmVybmluZyB0aGUgY29sbGVjdGlvbiwgdXNlIGFuZCBwcm90ZWN0aW9uIG9mIGFsbCBpbmZvcm1hdGlvbiBwcm92aWRlZCBhbmQgY29sbGVjdGVkIHRocm91Z2ggdGhlIEhvc3RlZCBTaXRlLjwvbGk+IDxsaT48ZW0+JmxkcXVvOzx1PlJlcHJlc2VudGF0aXZlczwvdT4mcmRxdW87PC9lbT4gbWVhbnMsIHdpdGggcmVzcGVjdCB0byBhbnkgUGVyc29uLCBhbnkgYW5kIGFsbCBkaXJlY3RvcnMsIG9mZmljZXJzLCBlbXBsb3llZXMsIGNvbnN1bHRhbnRzLCBmaW5hbmNpYWwgYWR2aXNvcnMsIGNvdW5zZWwsIGFjY291bnRhbnRzIGFuZCBvdGhlciBhZ2VudHMgb2Ygc3VjaCBQZXJzb248L2xpPiA8bGk+PGVtPiZsZHF1bzs8dT5TZWxlY3RlZCBCcmFuZHM8L3U+JnJkcXVvOzwvZW0+IG1lYW5zLCBjb2xsZWN0aXZlbHksIChhKSB0aGUgQXV0aG9yaXplZCBCcmFuZHMgc2VsZWN0ZWQgYnkgdGhlIENsaWVudCBkdXJpbmcgdGhlIEVucm9sbG1lbnQgUHJvY2VzcywgYW5kIChiKSBhbnkgQWRkaXRpb25hbCBCcmFuZHMgYWxzbyBpZGVudGlmaWVkIGFuZCBzZWxlY3RlZCBieSB0aGUgQ2xpZW50IGFuZCB3aG9zZSBwcm9kdWN0cyBtYXkgYmUgbWFya2V0ZWQgdGhyb3VnaCB0aGUgSG9zdGVkIFNpdGUsIGFzIGVzdGFibGlzaGVkIGluIGFjY29yZGFuY2Ugd2l0aCA8dT5TZWN0aW9uIDEuMjwvdT4gb2YgdGhlc2UgVGVybXMgYW5kIENvbmRpdGlvbnMsIHN1YmplY3QgdG8gKHgpIENvbnN0YW50IFJldGFpbCwgZnJvbSB0aW1lIHRvIHRpbWUgYW5kIGl0cyBzb2xlIGRpc2NyZXRpb24sIG5vIGxvbmdlciBvZmZlcmluZyBhbnkgQXV0aG9yaXplZCBCcmFuZCBvciBBZGRpdGlvbmFsIEJyYW5kIHRocm91Z2ggdGhlIEhvc3RlZCBTaXRlLCBvciAoeSkgQ2xpZW50IG5vdGlmeWluZyBDb25zdGFudCBSZXRhaWwgdGhhdCBpdCBubyBsb25nZXIgd2lzaGVzIHRvIG9mZmVyIGFuIEF1dGhvcml6ZWQgQnJhbmQgb3IgQWRkaXRpb25hbCBCcmFuZCwgaW4gd2hpY2ggY2FzZSBzdWNoIEF1dGhvcml6ZWQgQnJhbmQgYW5kL29yIEFkZGl0aW9uYWwgQnJhbmQsIGFzIHRoZSBjYXNlIG1heSBiZSwgc2hhbGwgbm8gbG9uZ2VyIGJlIGluY2x1ZGVkIGluIHRoaXMgZGVmaW5pdGlvbiBvZiBTZWxlY3RlZCBCcmFuZHMuPC9saT4gPGxpPjxlbT4mbGRxdW87PHU+VGVybTwvdT4mcmRxdW87PC9lbT4gbWVhbnMgdGhlIHBlcmlvZCBvZiB0aW1lIGR1cmluZyB3aGljaCB0aGVzZSBUZXJtcyBhbmQgQ29uZGl0aW9ucyBhcmUgaW4gZnVsbCBmb3JjZSBhbmQgZWZmZWN0IGFuZCBub3QgdGVybWluYXRlZCBwdXJzdWFudCB0byA8dT5TZWN0aW9uIDY8L3U+IG9mIHRoZXNlIFRlcm1zIGFuZCBDb25kaXRpb25zLjwvbGk+IDxsaT4mbGRxdW87PGVtPjx1PlVzZXIgRGF0YTwvdT48L2VtPiZyZHF1bzsgbWVhbnMgYWxsIGRhdGEgYW5kIGluZm9ybWF0aW9uIGRlcml2ZWQgYnkgYW55IG1lYW5zIGZyb20gdGhlIEhvc3RlZCBTaXRlLCBpbmNsdWRpbmcsIHdpdGhvdXQgbGltaXRhdGlvbiwgcmVnYXJkaW5nIHZpc2l0cyB0byBhbmQgdXNlIG9mIHRoZSBIb3N0ZWQgU2l0ZSBhbmQgYWxsIGRhdGEgYW5kIGluZm9ybWF0aW9uIHJlZ2FyZGluZyB0cmFuc2FjdGlvbnMgZWZmZWN0ZWQgb24gdGhlIEhvc3RlZCBTaXRlLCBvdGhlciB0aGFuLCBpbiBlYWNoIGNhc2UsIEN1c3RvbWVyIEluZm9ybWF0aW9uLiZuYnNwOyBVc2VyIERhdGEgaXMgdHJhY2tlZCBhbmQgY29sbGVjdGVkIHRocm91Z2ggdGhlIENvbnN0YW50IFJldGFpbCBQbGF0Zm9ybSBhbmQgYXMgc3VjaCBpcyB0aGUgSW50ZWxsZWN0dWFsIFByb3BlcnR5IG9mIENvbnN0YW50IFJldGFpbCwgYW5kIG1heSBiZSB1c2VkIGJ5IENvbnN0YW50IFJldGFpbCBhbmQgaXRzIEFmZmlsaWF0ZXMgZm9yIGFueSBwdXJwb3NlIHdoYXRzb2V2ZXIuPC9saT4gPGxpPjxlbT4mbGRxdW87PHU+VmVuZG9yPC91PiZyZHF1bzs8L2VtPiBtZWFucyBhIHNlbGxlciBvZiBwcm9kdWN0cyB0aGF0IG1heSBiZSBvZmZlcmVkIHRocm91Z2ggdGhlIEhvc3RlZCBTaXRlLCB3aGV0aGVyIHVuZGVyIGFuIEF1dGhvcml6ZWQgQnJhbmQgb3IgQWRkaXRpb25hbCBCcmFuZC48L2xpPiA8L29sPiA8L2xpPiA8L29sPiA8L2Rpdj4gPC9kaXY+IDxkaXYgY2xhc3M9XCJtb2RhbC1mb290ZXJcIj4gPGJ1dHRvbiB0eXBlPVwiYnV0dG9uXCIgY2xhc3M9XCJidG4gYnRuLWRlZmF1bHQgYnRuLWxnIHB1bGwtbGVmdFwiIChjbGljayk9XCJ0ZXJtc0NvbmRpdGlvbnMuaGlkZSgpXCI+PGkgY2xhc3M9XCJpY29uIHdiLWNsb3NlXCIgYXJpYS1oaWRkZW49XCJ0cnVlXCI+PC9pPkNsb3NlPC9idXR0b24+IDwvZGl2PiA8L2Rpdj4gPC9kaXY+IDwvZGl2PiAiLCI8cmVnaXN0ZXI+PC9yZWdpc3Rlcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQTZ4RDtNQUFBO01BQWdLOzs7O29CQUFpQztNQUFBO01BQStKOzs7O29CQUErVjtNQUFBO01BQThKOzs7O29CQUFnQztNQUFBO01BQTZKOzs7O29CQUFnVjtNQUFBO01BQXdKOzs7b0JBQTRCO01BQUE7TUFBcUo7Ozs7b0JBQWtVO01BQUE7TUFBb0o7OztvQkFBOEI7TUFBQTtNQUFxSjs7OztvQkFBdVg7TUFBQTtNQUFrSzs7OztvQkFBc0M7TUFBQTtNQUF1Szs7OztvQkFBMlQ7TUFBQSx3RUFBNEg7YUFBQTs7OztvQkFBaDRIO01BQUE7TUFBNEMsc0NBQUM7VUFBQTtjQUFBO2NBQUE7a0JBQUE7Y0FBQTtZQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQXdDO2NBQUE7Y0FBQTtZQUFBO1lBQXhDO1VBQUEsdUNBQUE7VUFBQSxvQ0FBQTtVQUFBO2FBQUEsMEVBQUE7VUFBQTtVQUFBLGVBQWtGLHNDQUFDO1VBQUE7VUFBQSw0Q0FBMEI7VUFBQSxRQUFDO1VBQUE7VUFBQSxnQkFBeUIsc0NBQUM7VUFBQTtVQUFBLDBEQUFnQztVQUFBLFFBQUM7VUFBQTtNQUEwQix5Q0FBUTtNQUFRLHNDQUFDO1VBQUE7Y0FBQTtjQUFBO2NBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtZQUF5RztjQUFBO2NBQUE7WUFBQTtZQUF6RztVQUFBLHlFQUFBO1VBQUE7VUFBQSxzQkFBQTtVQUFBLDhDQUFBO1VBQUE7WUFBQTtVQUFBLHFEQUFBO1VBQUE7VUFBQTtVQUFBLHNCQUFBO1FBQUE7TUFBQSxrQ0FBQTtVQUFBO1VBQUE7YUFBQSxvRUFBQTtVQUFBO01BQXFLLDBCQUFDO1VBQUEsa0NBQUE7d0JBQUEsMENBQXlCLElBQXVLO1VBQUEsUUFBQzthQUFBO1VBQUEsK0JBQXlCLElBQXVNLDBCQUFjO1VBQUEsUUFBTyxzQ0FBQztVQUFBO1VBQUEsNENBQXlCO1VBQUEsUUFBQztVQUFBO1VBQUEsZ0JBQWdDLHNDQUFDO1VBQUE7VUFBQSwwREFBMEI7VUFBQSxXQUFRLHNDQUFRO1VBQUEsUUFBQztVQUFBO1VBQUE7Y0FBQTtjQUFBO2tCQUFBO1lBQUE7WUFBQTtZQUFzRztjQUFBO2NBQUE7WUFBQTtZQUF0RztVQUFBLHlFQUFBO1VBQUE7VUFBQSxzQkFBQTtVQUFBLDhDQUFBO1VBQUE7WUFBQTtVQUFBLHFEQUFBO1VBQUE7VUFBQTtVQUFBLHNCQUFBO1FBQUE7TUFBQSxrQ0FBQTtVQUFBO1VBQUE7YUFBQSxvRUFBQTtVQUFBO01BQWlLLDBCQUFDO1VBQUEsa0NBQUE7d0JBQUEsMENBQXlCLElBQW9LO1VBQUEsUUFBQzthQUFBO1VBQUEsK0JBQXlCLElBQW9NLDBCQUFjO1VBQUEsUUFBTyxzQ0FBQztVQUFBO1VBQUEsNENBQXlCO1VBQUEsUUFBQztVQUFBO1VBQUEsZ0JBQWdDLHNDQUFDO1VBQUE7VUFBQSwwREFBMEI7VUFBQSxZQUFTLHNDQUFRO1VBQUEsUUFBQztVQUFBO1VBQUE7Y0FBQTtrQkFBQTtVQUFBO1lBQUE7WUFBQTtZQUF5RztjQUFBO2NBQUE7WUFBQTtZQUF6RztVQUFBLHlFQUFBO1VBQUE7VUFBQSxzQkFBQTtVQUFBLDBDQUFBO1VBQUEsd0RBQUE7MkJBQUE7WUFBQTtVQUFBLDhFQUFBO1VBQUE7VUFBQTtjQUFBLHVDQUFBO1VBQUE7WUFBQTtVQUFBLGtDQUFBOzZCQUFBO1VBQUE7YUFBQSxvRUFBQTtVQUFBO01BQWtKLDBCQUFDO1VBQUEsa0NBQUE7d0JBQUEsMENBQXlCLElBQTBKO1VBQUEsUUFBQzthQUFBO1VBQUEsK0JBQXlCLElBQW1LLDBCQUFjO1VBQUEsUUFBTyxzQ0FBQztVQUFBO1VBQUEsNENBQXlCO1VBQUEsUUFBQztVQUFBO1VBQUEsZ0JBQWdDLHNDQUFDO1VBQUE7VUFBQSwwREFBMEI7VUFBQSxtQkFBZ0Isc0NBQVE7VUFBQSxRQUFDO1VBQUE7VUFBQTtVQUFBO2NBQUE7VUFBQTtnQkFBQTtRQUFBO1FBQUE7UUFBa0c7VUFBQTtVQUFBO1FBQUE7UUFBbEc7TUFBQSx5RUFBQTtVQUFBO1VBQUEsc0JBQUE7VUFBQSxrREFBQTtVQUFBO1lBQUE7VUFBQSx1REFBQTtVQUFBO1VBQUE7YUFBQTtRQUFBO01BQUEsa0NBQUE7VUFBQTtVQUFBLDREQUFBO3VCQUFBLG1DQUFBO1VBQUEsNENBQXNKLDBCQUFDO2lCQUFBO2FBQUE7VUFBQSwrQkFBeUIsSUFBd0osMEJBQUM7VUFBQSxrRUFBQTtVQUFBO1VBQUEsc0JBQXlCLElBQXlLLDBCQUFjO1VBQUEsUUFBTyxzQ0FBQztVQUFBO1VBQUEsNENBQXlCO1VBQUEsUUFBQztVQUFBO1VBQUEsZ0JBQWdDLHNDQUFDO1VBQUE7VUFBQSwwREFBMEI7VUFBQSxtQkFBZ0Isc0NBQVE7VUFBQSxRQUFDO1VBQUE7VUFBQTtjQUFBO2tCQUFBO1VBQUE7WUFBQTtZQUFBO1lBQXdIO2NBQUE7Y0FBQTtZQUFBO1lBQXhIO1VBQUEseUVBQUE7VUFBQTtVQUFBLHNCQUFBO1VBQUEsd0VBQUE7VUFBQTtZQUFBO1VBQUEsNERBQUE7VUFBQTtVQUFBO2FBQUE7UUFBQTtNQUFBLGtDQUFBO1VBQUE7VUFBQSw0REFBQTt1QkFBQSxtQ0FBQTtVQUFBLDRDQUFxTSwwQkFBQztpQkFBQTthQUFBO1VBQUEsK0JBQXlCLElBQThLLDBCQUFDO1VBQUEsbUVBQUE7VUFBQTtVQUFBLHNCQUF5QixJQUFnTSwwQkFBYztVQUFBLFFBQU8sc0NBQUM7VUFBQTtjQUFBO2NBQUE7Y0FBQTtVQUFBO1lBQUE7WUFBQTtZQUF5RDtjQUFBO2NBQUE7WUFBQTtZQUF6RDtVQUFBLHVFQUFBO1VBQUE7VUFBQSxzQkFBQTtVQUFBLDhEQUFBOzJCQUFBO1lBQUE7VUFBQSx1RUFBQTtVQUFBO1VBQUEsd0RBQUE7K0JBQUE7WUFBQTtVQUFBLGlDQUFBOzZCQUFBO1VBQUEscUVBQUE7VUFBQSw4REFBQTtVQUFBLGlFQUFpRztpQkFBQSxvREFBeUM7VUFBQTtjQUFBO1lBQUE7WUFBaUI7cUJBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBakI7VUFBQSxnQ0FBMkU7TUFBd0IsMEJBQUM7VUFBQTtNQUFJLDBCQUFDO1VBQUEsbUNBQUE7d0JBQUEsMENBQU8sSUFBMks7VUFBQSxRQUFZLHNDQUFDO1VBQUE7VUFBQSw0Q0FBZ0M7VUFBQSxRQUFDO1VBQUE7K0NBQUEsVUFBQTtVQUFBLG1EQUFtRDtVQUFBLFFBQU8sc0NBQUM7VUFBQTtVQUFBLDRDQUFnQztVQUFBLFFBQUM7VUFBQTtVQUFBLG1EQUFBO1VBQUE7TUFBbUksNkNBQWlCO01BQU8sc0NBQVE7OztRQUEzMUg7UUFBdkksWUFBdUksVUFBdkk7UUFBZ0o7UUFBaEosWUFBZ0osVUFBaEo7UUFBNEI7UUFBaUI7UUFBbUI7UUFBbUI7UUFBbkYsWUFBNEIsV0FBaUIsV0FBbUIsV0FBbUIsVUFBbkY7UUFBNEI7UUFBb0M7UUFBeUM7UUFBekcsWUFBNEIsV0FBb0MsV0FBeUMsVUFBekc7UUFBK0w7WUFBQTtZQUFBO1FBQXpCLFlBQXlCLFVBQXpCO1FBQTBOO1lBQUE7WUFBQTtRQUF6QixZQUF5QixVQUF6QjtRQUErZDtRQUFuSSxZQUFtSSxVQUFuSTtRQUE0STtRQUE1SSxZQUE0SSxVQUE1STtRQUEyQjtRQUFnQjtRQUFrQjtRQUFtQjtRQUFoRixZQUEyQixXQUFnQixXQUFrQixXQUFtQixVQUFoRjtRQUEyQjtRQUFrQztRQUF5QztRQUF0RyxZQUEyQixXQUFrQyxXQUF5QyxVQUF0RztRQUEyTDtZQUFBO1lBQUE7UUFBekIsWUFBeUIsVUFBekI7UUFBdU47WUFBQTtZQUFBO1FBQXpCLFlBQXlCLFVBQXpCO1FBQTZkO1FBQW5JLFlBQW1JLFVBQW5JO1FBQTRJO1FBQTVJLFlBQTRJLFVBQTVJO1FBQTRJO1FBQTVJLFlBQTRJLFVBQTVJO1FBQXdCO1FBQWE7UUFBYTtRQUFjO1FBQW1CO1FBQW5GLFlBQXdCLFdBQWEsV0FBYSxXQUFjLFdBQW1CLFVBQW5GO1FBQXFDO1FBQTJCO1FBQXlDO1FBQXpHLFlBQXFDLFdBQTJCLFdBQXlDLFVBQXpHO1FBQTRLO1lBQUE7WUFBQTtRQUF6QixZQUF5QixVQUF6QjtRQUE2TTtZQUFBO1lBQUE7UUFBekIsWUFBeUIsVUFBekI7UUFBK2I7UUFBL0gsYUFBK0gsVUFBL0g7UUFBd0k7UUFBeEksYUFBd0ksVUFBeEk7UUFBMkI7UUFBZ0I7UUFBZ0I7UUFBaUI7UUFBNUUsYUFBMkIsV0FBZ0IsV0FBZ0IsV0FBaUIsVUFBNUU7UUFBMkM7UUFBdUQ7UUFBbEcsYUFBMkMsV0FBdUQsVUFBbEc7UUFBZ0w7WUFBQTtZQUFBO1FBQXpCLGFBQXlCLFVBQXpCO1FBQTJNO1lBQUE7WUFBQTtRQUF6QixhQUF5QixVQUF6QjtRQUFrZTtRQUE1SixhQUE0SixVQUE1SjtRQUFxSztRQUFySyxhQUFxSyxVQUFySztRQUFrQztRQUFnQjtRQUF1QjtRQUF5QjtRQUFsRyxhQUFrQyxXQUFnQixXQUF1QixXQUF5QixXQUFsRztRQUFrRDtRQUFzRTtRQUF4SCxhQUFrRCxZQUFzRSxXQUF4SDtRQUErTjtZQUFBO1lBQUE7UUFBekIsYUFBeUIsV0FBekI7UUFBaU87WUFBQTtZQUFBO1FBQXpCLGFBQXlCLFdBQXpCO1FBQXVVO1FBQXhGLGFBQXdGLFdBQXhGO1FBQXdGO1FBQXhGLGFBQXdGLFdBQXhGO1FBQXNCO1FBQWE7UUFBbkMsYUFBc0IsWUFBYSxXQUFuQztRQUFzQjtRQUFtQztRQUF6RCxhQUFzQixZQUFtQyxXQUF6RDtRQUEwUDtZQUFBO1lBQUE7UUFBUCxhQUFPLFdBQVA7UUFBZ1A7UUFBaEIsYUFBZ0IsV0FBaEI7OztRQUF2N0g7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQSxXQUFBLHFFQUFBO1FBQW9OO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBLFlBQUEsVUFBQSxVQUFBO1lBQUEsZ0NBQUE7UUFBbXNCO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBLFlBQUEsV0FBQSxXQUFBO1lBQUEsZ0NBQUE7UUFBMHJCO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQSxZQUFBLFdBQUE7WUFBQSxxQkFBQTtRQUF1b0I7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUEsYUFBQSxXQUFBLFdBQUE7WUFBQSxnQ0FBQTtRQUErb0I7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBLGFBQUEsV0FBQTtZQUFBLHFCQUFBO1FBQTZuQjtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUEsYUFBQSxZQUFBO1lBQUEsdUJBQUE7UUFBdW1CO1lBQUE7UUFBeEQsYUFBd0QsV0FBeEQ7Ozs7OERBQXQ3SztNQUFBO1VBQUE7TUFBMEQsc0NBQUM7VUFBQTtVQUFBLDhCQUF1QixzQ0FBQztpQkFBQTtjQUFBLDBEQUFpQjtVQUFBLFFBQUM7VUFBQTtVQUFBLDhCQUF1QyxzQ0FBQztpQkFBQTtjQUFBO01BQThCLHNDQUFDO1VBQUE7VUFBQSw0Q0FBbUM7VUFBQSxlQUFhLHNDQUFDO1VBQUE7VUFBQSw4QkFBaUIsc0NBQUM7aUJBQUE7Y0FBQTtNQUFzQyxzQ0FBQztVQUFBO1VBQUEsOEJBQTBCLHNDQUFDO2lCQUFBO2NBQUE7TUFBa0Msc0NBQUM7VUFBQTtVQUFBLDhCQUE0QixzQ0FBQztpQkFBQTtjQUFBO01BQTBCLDZDQUFZO01BQU8sc0NBQUM7VUFBQTtVQUFBLDhCQUF5QixzQ0FBQztpQkFBQTtjQUFBLDBEQUF1QjtVQUFBLHVCQUFxQixzQ0FBQztVQUFBO1VBQUEsMERBQXVCO1VBQUE7TUFBK0Ysc0NBQU87TUFBTyxzQ0FBQztVQUFBO1VBQUEsNENBQWtDO1VBQUEsUUFBQztVQUFBO1VBQUEsZ0JBQStCLHNDQUFDO1VBQUE7VUFBQSwwREFBMEI7VUFBQSxXQUFRLHNDQUFPO1VBQUEsUUFBQztVQUFBO1VBQUEsZ0JBQXlCLHNDQUFDO1VBQUE7VUFBQSwwREFBdUI7VUFBQSwyQkFBeUIsc0NBQUM7aUJBQUE7Y0FBQSwwREFBdUI7VUFBQTtNQUF3SixzQ0FBTztNQUFPLHNDQUFDO1VBQUE7VUFBQSw0Q0FBa0M7VUFBQSxRQUFDO1VBQUE7VUFBQSxnQkFBNEIsc0NBQUM7VUFBQTtVQUFBLDBEQUEwQjtVQUFBLFlBQVMsc0NBQU87VUFBQSxRQUFDO1VBQUE7VUFBQSxnQkFBeUIsc0NBQUM7VUFBQTtVQUFBLDBEQUF1QjtVQUFBLDJCQUF5QixzQ0FBQztpQkFBQTtjQUFBLDBEQUF1QjtVQUFBO01BQTJLLHNDQUFPO01BQU8sc0NBQU87TUFBTyxzQ0FBQztVQUFBLGdFQUFBO1VBQUE7TUFBMHVJLHNDQUFPO01BQU8sc0NBQU87TUFBTyxzQ0FBTztNQUFDO1VBQUE7TUFBd0Msc0NBQU87TUFBQztVQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO01BQUEsdUNBQUE7VUFBQTtVQUFBLDZCQUF3SSxzQ0FBQztpQkFBQTtjQUFBO2NBQUEsZ0JBQW1ELHNDQUFDO1VBQUE7VUFBQSwwREFBMkI7VUFBQSxRQUFDO1VBQUE7VUFBQSxnQkFBMEIsc0NBQUM7VUFBQTtjQUFBO1VBQUE7WUFBQTtZQUF1RDtjQUFBO2NBQUE7WUFBQTtZQUF2RDtVQUFBLGdDQUF3RjtVQUFBO1VBQUEsOEJBQXlCLHNDQUF1QjtpQkFBQSx1QkFBQztVQUFBO1VBQUEsNENBQXdDO1VBQUEsOENBQTRDO1VBQUEsUUFBTyxzQ0FBQztVQUFBO1VBQUEsNENBQXdCO1VBQUEsUUFBQztVQUFBO01BQUc7TUFBb0U7VUFBQSwwREFBRztVQUFBLGFBQVU7TUFBd047VUFBQSwwREFBRztVQUFBLDJCQUF3QjtNQUFrSjtVQUFBLDBEQUFHO1VBQUEsaUJBQWM7TUFBaUMsc0NBQUM7VUFBQTtVQUFBLGdCQUFHO1VBQUE7TUFBUTtVQUFBLDBEQUFHO1VBQUEsc0JBQWdDLHNDQUFDO1VBQUE7VUFBQSw0Q0FBSTtVQUFBLFFBQUM7VUFBQTtNQUFJO01BQWdHLHNDQUFNO01BQUM7VUFBQSwwREFBRztVQUFBO1VBQUEsNENBQVE7VUFBQTtVQUFBLDhCQUFHO01BQW9DLHNDQUFDO1VBQUE7VUFBQSxnQkFBSSxzQ0FBQztVQUFBO1VBQUEsNENBQUk7VUFBQTtNQUFzSixzQ0FBTTtNQUFDO1VBQUEsMERBQUk7VUFBQSxRQUFDO1VBQUE7TUFBSTtNQUFnSixzQ0FBTTtNQUFDO1VBQUEsMERBQUc7VUFBQTtVQUFBLDRDQUFRO1VBQUE7VUFBQSw4QkFBRztNQUErQyxzQ0FBQztVQUFBO1VBQUEsZ0JBQUksc0NBQUM7VUFBQTtVQUFBLDRDQUFJO1VBQUE7TUFBNk4sc0NBQU07TUFBQztVQUFBLDBEQUFJO1VBQUEsUUFBQztVQUFBO01BQUk7TUFBa0wsc0NBQU07TUFBQztVQUFBLDBEQUFJO1VBQUEsUUFBQztVQUFBO01BQUk7TUFBNEYsc0NBQU07TUFBQztVQUFBLDBEQUFHO1VBQUE7VUFBQSw0Q0FBUTtVQUFBO1VBQUEsOEJBQUc7TUFBMEUsc0NBQUM7VUFBQTtVQUFBLGdCQUFJLHNDQUFDO1VBQUE7VUFBQSw0Q0FBSTtVQUFBO01BQTRLLHNDQUFNO01BQUM7VUFBQSwwREFBSTtVQUFBLFFBQUM7VUFBQTtNQUFJO01BQWlWLHNDQUFNO01BQUM7VUFBQSwwREFBRztVQUFBO1VBQUEsNENBQVE7VUFBQTtVQUFBLDhCQUFHO01BQWlDLHNDQUFDO1VBQUE7VUFBQSxnQkFBSSxzQ0FBQztVQUFBO1VBQUEsNENBQUk7VUFBQTtNQUE4TztVQUFBO01BQWlDLHdDQUFPO01BQU0sc0NBQU07TUFBQztVQUFBLDBEQUFJO1VBQUEsUUFBQztVQUFBO01BQUk7TUFBK0osc0NBQU07TUFBQztVQUFBLDBEQUFJO1VBQUEsUUFBQztVQUFBO01BQUk7TUFBa0Ysc0NBQU07TUFBQztVQUFBLDBEQUFJO1VBQUEsUUFBQztVQUFBO01BQUk7TUFBdUwsc0NBQU07TUFBQztVQUFBLDBEQUFHO1VBQUE7VUFBQSw0Q0FBUTtVQUFBO1VBQUEsOEJBQUc7TUFBMEIsc0NBQUM7VUFBQTtVQUFBLGdCQUFJLHNDQUFDO1VBQUE7VUFBQSw0Q0FBSTtVQUFBO01BQTRGLHNDQUFNO01BQUM7VUFBQSwwREFBRztVQUFBO1VBQUEsNENBQVE7VUFBQTtVQUFBLDhCQUFHO01BQXVELHNDQUFDO1VBQUE7VUFBQSxnQkFBSSxzQ0FBQztVQUFBO1VBQUEsNENBQUk7VUFBQTtNQUFrTixzQ0FBTTtNQUFDO1VBQUEsMERBQUc7VUFBQTtVQUFBLDRDQUFRO1VBQUE7VUFBQSw4QkFBRztNQUErQyxzQ0FBQztVQUFBO1VBQUEsZ0JBQUksc0NBQUM7VUFBQTtVQUFBLDRDQUFJO1VBQUE7TUFBNEgsc0NBQU07TUFBQztVQUFBLDBEQUFHO1VBQUE7VUFBQSw0Q0FBSTtVQUFBO01BQTZqQixzQ0FBQztVQUFBO1VBQUEsZ0JBQUc7VUFBQTtNQUFRO1VBQUEsMERBQUc7VUFBQSxzQ0FBc0Q7TUFBQztVQUFBLDBEQUFLO1VBQUEsUUFBQztVQUFBO1VBQUEsZ0JBQWdDLHNDQUFDO1VBQUE7VUFBQSw0Q0FBSTtVQUFBLHFCQUFjO1VBQUE7TUFBSSxzQ0FBQztVQUFBO1VBQUEsZ0JBQUk7VUFBQTtNQUFHLDRDQUFXO01BQXNRO1VBQUEsMERBQUc7VUFBQSxrQkFBZTtNQUFvK0Isc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBRyxvREFBbUI7VUFBQTtNQUFtTDtVQUFBLDBEQUFHO1VBQUEsZUFBWTtNQUF3Z0Isc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBRyx1REFBc0I7VUFBQTtNQUE4aUUsc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBRztNQUE4QztNQUFpakI7VUFBQSwwREFBRztVQUFBLGtCQUFlO01BQWtoQyxzQ0FBQztVQUFBO1VBQUEsZ0JBQUk7VUFBQTtNQUFHO01BQW1EO01BQWcrQjtVQUFBLDBEQUFHO1VBQUEsZUFBWTtNQUF1K0I7VUFBQSwwREFBRztVQUFBO01BQTRNO1VBQUEsMERBQUc7VUFBQSx5Q0FBc0M7VUFBQTtVQUFBLDhCQUFHO01BQXNCO1VBQUEsMERBQUc7VUFBQTtNQUE0Tyx1Q0FBWTtNQUFNLHNDQUFNO01BQUM7VUFBQSwwREFBSTtVQUFBLDRDQUFxQztVQUFBO1VBQUEsOEJBQUksc0NBQUM7aUJBQUE7Y0FBQSwwREFBSTtVQUFBO1VBQUEsNENBQUc7VUFBQSx5QkFBc0I7TUFBa0w7VUFBQSwwREFBRztVQUFBLGtCQUFlO01BQW9uQztVQUFBLDBEQUFHO1VBQUEsa0JBQWU7TUFBb0s7VUFBQSwwREFBRztVQUFBLGdCQUFhLHNDQUFXO1VBQUEsUUFBQztVQUFBO01BQUk7VUFBQSwwREFBRztVQUFBLDJCQUF3QjtNQUFvTDtVQUFBLDBEQUFHO1VBQUEsa0JBQWU7TUFBdStCO1VBQUEsMERBQUc7VUFBQSxrQkFBZTtNQUFvSztVQUFBLDBEQUFHO1VBQUEsZ0JBQWEsc0NBQVc7VUFBQSxRQUFDO1VBQUE7TUFBSTtVQUFBLDBEQUFHO1VBQUEsNERBQXlEO1VBQUEscURBQThDO1VBQUE7VUFBQSw4QkFBRztNQUFlLHlDQUFJO1VBQUE7VUFBQSxnQkFBRyxnREFBZTtpQkFBQTtNQUFtaUI7VUFBQSwwREFBRztVQUFBLGtCQUFlLHlDQUFJO1VBQUE7VUFBQSw0Q0FBRztVQUFBLGtCQUFlO01BQWdXO1VBQUEsMERBQUc7VUFBQSxrQkFBZSx5Q0FBSTtVQUFBO1VBQUEsNENBQUc7VUFBQSxrQkFBZTtNQUEwVCxzQ0FBTTtNQUFNLHNDQUFDO1VBQUE7VUFBQSxnQkFBSTtNQUF3QjtVQUFBLDBEQUFJO1VBQUEsUUFBQztVQUFBO01BQUk7VUFBQSwwREFBRztVQUFBLGdCQUFhO01BQXFwQztVQUFBLDBEQUFHO1VBQUEsa0JBQWU7TUFBK0Qsc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBRywrQ0FBYztVQUFBO01BQXNhLHNDQUFNO01BQU0sc0NBQUM7VUFBQTtVQUFBLGdCQUFJLHFEQUFnQjtpQkFBQTtjQUFBLDBEQUFJO1VBQUEsUUFBQztVQUFBO01BQUk7VUFBQSwwREFBRztVQUFBLFdBQVE7TUFBNlI7VUFBQSwwREFBRztVQUFBLGdCQUFhO01BQTZGO1VBQUE7TUFBaUMsd0NBQU87VUFBQTtVQUFBLGdCQUFRLHNDQUFVO1VBQUEsUUFBVyxzQ0FBQztVQUFBO1VBQUEsOEJBQUk7VUFBQTtVQUFBLGdCQUFHLDRDQUFXO1VBQUE7TUFBNCtCO1VBQUEsMERBQUc7VUFBQSxnQkFBYTtNQUFrSDtVQUFBLDBEQUFHO1VBQUEsa0JBQWU7TUFBZ0c7VUFBQSwwREFBRztVQUFBLGdCQUFhO01BQW13QixzQ0FBQztVQUFBO1VBQUEsZ0JBQUk7VUFBQTtNQUFHLDJEQUEwQjtVQUFBO01BQW9TO1VBQUEsMERBQUc7VUFBQSxrQkFBZTtNQUE4RDtVQUFBLDBEQUFHO1VBQUEsa0JBQWU7TUFBNjlDLHNDQUFDO1VBQUE7VUFBQSxnQkFBSTtVQUFBO01BQUcsc0RBQXFCO1VBQUE7TUFBa08sc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBRyxvREFBbUI7VUFBQSwwQ0FBbUM7VUFBQTtVQUFBLDhCQUFHO01BQWE7TUFBNlg7VUFBQSwwREFBRztVQUFBLGdCQUFhO01BQTZIO1VBQUEsMERBQUs7VUFBQSxTQUFRO01BQTZDLHNDQUFNO01BQU0sc0NBQUM7VUFBQTtVQUFBLGdCQUFJO01BQTJEO1VBQUEsMERBQUk7VUFBQSxRQUFDO1VBQUE7TUFBSTtVQUFBLDBEQUFHO1VBQUEsMkJBQXdCO01BQXViLHNDQUFDO1VBQUE7VUFBQSxnQkFBSSxzQ0FBQztVQUFBO1VBQUEsNENBQUc7VUFBQSxxQkFBa0I7TUFBb1I7VUFBQSwwREFBRztVQUFBO1VBQUEsNENBQUk7VUFBQTtNQUE2akIsc0NBQUM7VUFBQTtVQUFBLGdCQUFHO01BQStULHNDQUFNO01BQUM7VUFBQSwwREFBSTtVQUFBO1VBQUEsNENBQUc7VUFBQSx5QkFBc0I7TUFBdXVCLHNDQUFDO1VBQUE7VUFBQSxnQkFBSTtVQUFBO01BQUcscUVBQW9DO2lCQUFBO01BQWlUO1VBQUE7TUFBc0QscUVBQW9DO2lCQUFBLHVCQUFNLHNDQUFNO2lCQUFBLHVCQUFNLHNDQUFDO2lCQUFBO2NBQUEsMERBQUk7VUFBQSxxQkFBYztVQUFBO01BQUksc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBRyw4REFBNkI7VUFBQTtNQUE2SixzQ0FBQztVQUFBO1VBQUEsZ0JBQUk7VUFBQTtNQUFHLG1FQUFrQztVQUFBO01BQTJhO1VBQUEsMERBQUc7VUFBQSxrQkFBZSxzQ0FBTTtVQUFBLFFBQUM7VUFBQTtNQUFJO1VBQUEsMERBQUc7VUFBQSw0QkFBeUI7TUFBa1o7VUFBQSwwREFBRztVQUFBLG1CQUFnQix1Q0FBRTtVQUFBO1VBQUEsNENBQUc7VUFBQSxRQUFLLHVDQUFFO1VBQUE7VUFBQSw4QkFBRyxzQ0FBSztpQkFBQSx3QkFBRTtVQUFBO1VBQUEsZ0JBQUcsc0NBQUs7VUFBQSxTQUFFO1VBQUE7TUFBRyxzQ0FBSztNQUFFO1VBQUEsMERBQUc7VUFBQSxRQUFLLDBDQUFLO1VBQUE7VUFBQSw4QkFBRyxzQ0FBSztpQkFBQTtNQUFtYyxzQ0FBTTtNQUFNLHNDQUFDO1VBQUE7VUFBQSxnQkFBSSx1REFBa0I7aUJBQUE7Y0FBQSwwREFBSTtVQUFBLFFBQUM7VUFBQTtNQUFJO1VBQUEsMERBQUc7VUFBQSxvQ0FBaUM7TUFBMHNCO1VBQUEsMERBQUc7VUFBQSxrQkFBZTtNQUFrd0Isc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBRyxtRUFBa0M7VUFBQTtNQUE0RTtVQUFBLDBEQUFHO1VBQUEsa0JBQWU7TUFBZ0c7VUFBQSwwREFBRztVQUFBLGtCQUFlO01BQStUO1VBQUEsMERBQUc7VUFBQSxrQkFBZTtNQUEwRjtVQUFBLDBEQUFHO1VBQUEsZUFBWTtNQUF5UCxzQ0FBTTtNQUFNLHNDQUFDO1VBQUE7VUFBQSxnQkFBSTtNQUF3QztVQUFBLDBEQUFJO1VBQUEsUUFBQztVQUFBO01BQUk7VUFBQSwwREFBRztVQUFBLCtCQUE0QjtNQUE2eUIsc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBRyx5REFBd0I7VUFBQTtNQUEyUCxzQ0FBQztVQUFBO1VBQUEsZ0JBQUk7VUFBQTtNQUFHLDREQUEyQjtVQUFBO01BQXN5QjtVQUFBLDBEQUFHO1VBQUEsZ0JBQWE7TUFBOE4sc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBRyw0REFBMkI7VUFBQTtNQUEyYixzQ0FBTTtNQUFNLHNDQUFDO1VBQUE7VUFBQSxnQkFBSSxxREFBZ0I7aUJBQUE7Y0FBQSwwREFBSTtVQUFBLFFBQUM7VUFBQTtNQUFJO1VBQUEsMERBQUc7VUFBQSw4QkFBMkI7TUFBa3FCLHNDQUFDO1VBQUE7VUFBQSxnQkFBSTtVQUFBO01BQUcsNERBQTJCO1VBQUE7TUFBbWpCO1VBQUEsMERBQUk7VUFBQSxrQkFBZ0I7TUFBOEksc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBRyxxREFBb0I7VUFBQTtNQUE0WSxzQ0FBQztVQUFBO1VBQUEsZ0JBQUk7VUFBQTtNQUFHLHVEQUFzQjtVQUFBO01BQXlRLHNDQUFDO1VBQUE7VUFBQSxnQkFBSTtVQUFBO01BQUcsbURBQWtCO1VBQUE7TUFBaWxCLHNDQUFDO1VBQUE7VUFBQSxnQkFBSTtVQUFBO01BQUcsNENBQVc7TUFBd3hCLHNDQUFDO1VBQUE7VUFBQSxnQkFBSTtVQUFBO01BQUcsd0RBQXVCO1VBQUE7TUFBcWdCLHNDQUFDO1VBQUE7VUFBQSxnQkFBSTtVQUFBO01BQUcsaURBQWdCO1VBQUE7TUFBaVEsc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBRyxrREFBaUI7VUFBQTtNQUEyVixzQ0FBQztVQUFBO1VBQUEsZ0JBQUk7VUFBQTtNQUFHLDJEQUEwQjtVQUFBO01BQTg5QixzQ0FBQztVQUFBO1VBQUEsZ0JBQUk7VUFBQTtNQUFHLDZDQUFZO01BQWtPLHNDQUFNO01BQU0sc0NBQUM7VUFBQTtVQUFBLGdCQUFJLG1EQUFjO2lCQUFBO2NBQUEsMERBQUc7VUFBQTtNQUE2SCxzQ0FBQztVQUFBO1VBQUEsZ0JBQUksc0NBQUM7VUFBQTtVQUFBLDRDQUFJO1VBQUE7VUFBQSw4QkFBSSxzQ0FBTztpQkFBQTtjQUFBLDBEQUFHO1VBQUEsd0JBQXFCLHNDQUFZO1VBQUE7TUFBc0gsc0NBQUM7VUFBQTtVQUFBLGdCQUFJLHNDQUFPO1VBQUE7VUFBQSw0Q0FBSTtVQUFBO1VBQUEsOEJBQUc7TUFBb0I7TUFBb0csc0NBQUM7VUFBQTtVQUFBLGdCQUFJLHNDQUFPO1VBQUE7VUFBQSw0Q0FBSTtVQUFBO1VBQUEsOEJBQUc7TUFBNEI7TUFBbVEsc0NBQUM7VUFBQTtVQUFBLGdCQUFJLHNDQUFPO1VBQUE7VUFBQSw0Q0FBSTtVQUFBO1VBQUEsOEJBQUc7TUFBa0I7TUFBNmMsc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBSSxzQ0FBTztVQUFBO1VBQUEsZ0JBQUc7TUFBOEIsc0NBQVk7TUFBNjBCLHNDQUFDO1VBQUE7VUFBQSxnQkFBSTtVQUFBO01BQUksc0NBQU87VUFBQTtVQUFBLGdCQUFHLHNEQUFxQjtpQkFBQSx1QkFBWTtNQUFvUSxzQ0FBQztVQUFBO1VBQUEsZ0JBQUk7VUFBQTtNQUFJLHNDQUFPO1VBQUE7VUFBQSxnQkFBRywyQ0FBVTtVQUFBLFFBQVk7TUFBb1Esc0NBQUM7VUFBQTtVQUFBLGdCQUFJLHNDQUFPO1VBQUE7VUFBQSw0Q0FBSTtVQUFBO1VBQUEsOEJBQUc7TUFBd0I7TUFBc0Ysc0NBQUM7VUFBQTtVQUFBLGdCQUFJLHNDQUFPO1VBQUE7VUFBQSw0Q0FBSTtVQUFBO1VBQUEsOEJBQUc7TUFBZ0M7TUFBNE4sc0NBQUM7VUFBQTtVQUFBLGdCQUFJLHNDQUFPO1VBQUE7VUFBQSw0Q0FBSTtVQUFBO1VBQUEsOEJBQUc7TUFBdUM7TUFBZ2Esc0NBQUM7VUFBQTtVQUFBLGdCQUFJLHNDQUFPO1VBQUE7VUFBQSw0Q0FBSTtVQUFBO1VBQUEsOEJBQUc7TUFBOEM7TUFBa1Esc0NBQUM7VUFBQTtVQUFBLGdCQUFJLHNDQUFPO1VBQUE7VUFBQSw0Q0FBSTtVQUFBO1VBQUEsOEJBQUc7TUFBMkM7TUFBNm1CLHNDQUFDO1VBQUE7VUFBQSxnQkFBSTtVQUFBO01BQUksc0NBQU87VUFBQTtVQUFBLGdCQUFHO01BQTRCLHNDQUFZO01BQWdLLHNDQUFDO1VBQUE7VUFBQSxnQkFBSSxzQ0FBTztVQUFBO1VBQUEsNENBQUk7VUFBQTtVQUFBLDhCQUFHO01BQWlCO01BQTBHLHNDQUFDO1VBQUE7VUFBQSxnQkFBSSxzQ0FBTztVQUFBO1VBQUEsNENBQUk7VUFBQTtVQUFBLDhCQUFHO01BQTZCO01BQXVlLHNDQUFDO1VBQUE7VUFBQSxnQkFBSSxzQ0FBTztVQUFBO1VBQUEsNENBQUk7VUFBQTtVQUFBLDhCQUFHO01BQWdCO01BQThLLHNDQUFDO1VBQUE7VUFBQSxnQkFBSSxzQ0FBTztVQUFBO1VBQUEsNENBQUk7VUFBQTtVQUFBLDhCQUFHO01BQXdCO01BQTZQLHNDQUFDO1VBQUE7VUFBQSxnQkFBSTtVQUFBO01BQUksc0NBQU87VUFBQTtVQUFBLGdCQUFHLHVEQUFzQjtpQkFBQSx1QkFBWTtNQUEyakIsc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBSSxzQ0FBTztVQUFBO1VBQUEsZ0JBQUcsaURBQWdCO2lCQUFBLHVCQUFZO01BQXdXO1VBQUEsMERBQUc7VUFBQSxnQkFBYTtNQUFvTDtVQUFBLDBEQUFHO1VBQUEsZ0JBQWE7TUFBd1g7VUFBQTtNQUFpQyx3Q0FBTztNQUFtRixzQ0FBQztVQUFBO1VBQUEsZ0JBQUksc0NBQU87VUFBQTtVQUFBLDRDQUFJO1VBQUE7VUFBQSw4QkFBRztNQUFvQjtNQUF5TixzQ0FBQztVQUFBO1VBQUEsZ0JBQUksc0NBQU87VUFBQTtVQUFBLDRDQUFJO1VBQUE7VUFBQSw4QkFBRztNQUE4QjtNQUFtOUIsc0NBQUM7VUFBQTtVQUFBLGdCQUFJLHNDQUFPO1VBQUE7VUFBQSw0Q0FBSTtVQUFBO1VBQUEsOEJBQUc7TUFBb0I7TUFBZ0Usc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBSSxzQ0FBTztVQUFBO1VBQUEsZ0JBQUcsZ0RBQWU7aUJBQUEsdUJBQVk7TUFBK007VUFBQTtNQUFpQyx3Q0FBTztVQUFBO1VBQUEsZ0JBQVEsd0NBQXNCO1VBQUEsUUFBQztVQUFBO01BQUksc0NBQU87VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBRywrQ0FBbUI7VUFBQTtNQUFvSCxzQ0FBQztVQUFBO1VBQUEsZ0JBQUksc0NBQU87VUFBQTtVQUFBLDRDQUFJO1VBQUE7VUFBQSw4QkFBRztNQUEwQjtNQUFpWTtVQUFBLDBEQUFHO1VBQUEsZUFBWTtNQUFvbUIsc0NBQUM7VUFBQTtVQUFBLGdCQUFJLHNDQUFPO1VBQUE7VUFBQSw0Q0FBSTtVQUFBO1VBQUEsOEJBQUc7TUFBZ0I7TUFBdUU7VUFBQSwwREFBSTtVQUFBO1VBQUEsNENBQUc7VUFBQSxZQUFjLHVDQUFhO1VBQUEsUUFBQztVQUFBO01BQUksc0NBQU87VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBRywyQ0FBZTtNQUErUSxzQ0FBQztVQUFBO1VBQUEsZ0JBQUk7VUFBQTtNQUFJLHNDQUFPO1VBQUE7VUFBQSxnQkFBRyxtREFBa0I7aUJBQUEsdUJBQVk7TUFBMEssc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBSSxzQ0FBTztVQUFBO1VBQUEsZ0JBQUcsb0RBQW1CO2lCQUFBLHVCQUFZO01BQTBLLHNDQUFDO1VBQUE7VUFBQSxnQkFBSTtVQUFBO01BQUksc0NBQU87VUFBQTtVQUFBLGdCQUFHLG9EQUFtQjtpQkFBQSx1QkFBWTtNQUE2UTtVQUFBLDBEQUFHO1VBQUEsa0JBQWU7TUFBMmMsc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBSSxzQ0FBTztVQUFBO1VBQUEsZ0JBQUcseUNBQVE7VUFBQSxRQUFZO01BQThIO1VBQUEsMERBQUc7VUFBQSxnQkFBYTtNQUFvQyxzQ0FBQztVQUFBO1VBQUEsZ0JBQUksc0NBQU87VUFBQTtVQUFBLDRDQUFJO1VBQUE7VUFBQSw4QkFBRztNQUFrQjtNQUFrZ0Isc0NBQUM7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBSSxzQ0FBTztVQUFBO1VBQUEsZ0JBQUcsMkNBQVU7VUFBQSxRQUFZO01BQW9JLHNDQUFNO01BQU0sc0NBQU07TUFBTyxzQ0FBTztNQUFDO1VBQUE7TUFBMEIsc0NBQUM7VUFBQTtVQUFBO1lBQUE7WUFBK0Q7Y0FBQTtjQUFBO1lBQUE7WUFBL0Q7VUFBQSx1Q0FBQTtVQUFBLDBEQUFnRztVQUFBO1VBQUE7TUFBZ0QsMENBQWM7TUFBTyxzQ0FBTztNQUFPLHNDQUFPOzs7UUFBM3d6RDtRQUF0QixZQUFzQixTQUF0Qjs7OztvQkNBdDNDO01BQUE7YUFBQTt5REFBQTs7UUFBQTs7OzsifQ==
//# sourceMappingURL=register.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/objects/users/forgotPasswordModel.ts
var ForgotPasswordModel = /** @class */ (function () {
    function ForgotPasswordModel() {
        this.Email = "";
    }
    return ForgotPasswordModel;
}());

//# sourceMappingURL=forgotPasswordModel.js.map
// CONCATENATED MODULE: ./app/components/auth/forgotPassword/forgotPassword.component.ts


var forgotPassword_component_ForgotPasswordComponent = /** @class */ (function () {
    function ForgotPasswordComponent(userService) {
        this.userService = userService;
        this.errors = [];
    }
    ForgotPasswordComponent.prototype.ngOnInit = function () {
        this.model = new ForgotPasswordModel();
    };
    ForgotPasswordComponent.prototype.forgotPassword = function (isValid) {
        var _this = this;
        this.errors = [];
        if (!isValid)
            return;
        this.processing = true;
        this.userService.forgotPassword(this.model).then(function (response) {
            _this.processing = false;
            _this.success = true;
        }).catch(function (response) {
            _this.processing = false;
            _this.errors = _this.errors.concat(response.Errors);
        });
    };
    ForgotPasswordComponent.ctorParameters = function () { return [{ type: services_userService["a" /* UserService */] }]; };
    return ForgotPasswordComponent;
}());

//# sourceMappingURL=forgotPassword.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/auth/forgotPassword/forgotPassword.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */












var styles_ForgotPasswordComponent = [];
var RenderType_ForgotPasswordComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ForgotPasswordComponent, data: {} });
function View_ForgotPasswordComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Email is required. ']))], null, null);
}
function View_ForgotPasswordComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Your email address is invalid. ']))], null, null);
}
function View_ForgotPasswordComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, FirstKeyPipe, []), (_l()(), core_es5["ɵeld"](0, null, null, 79, 'div', [['class', 'full-page login-page'], ['filter-color', 'black']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 74, 'div', [['class', 'content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 71, 'div', [['class', 'container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 68, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 65, 'div', [['class', 'col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 62, 'div', [['class', 'card card-login']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-header text-center'],
                ['data-background-color', 'rose']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'card-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Forgot Password'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 53, 'form', [['novalidate',
                '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null], [2,
                'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngSubmit'], [null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 21).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 21).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.forgotPassword(core_es5["ɵnov"](_v, 21).valid) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['forgotForm', 4]], 0, forms_es5["NgForm"], [[8,
                null], [8, null]], null, { ngSubmit: 'ngSubmit' }), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 39, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 27, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [['class', 'input-group-addon']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['email'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form-input', [['email', ''], ['label', 'Email'], ['name', 'email'], ['required',
                ''], ['type', 'email']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.model.Email = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](16384, null, 0, forms_es5["EmailValidator"], [], { email: [0, 'email'] }, null), core_es5["ɵdid"](81920, null, 0, email_directive_EmailValidatorDirective, [], { email: [0, 'email'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0, p2_0) {
            return [p0_0, p1_0, p2_0];
        }, [forms_es5["RequiredValidator"], forms_es5["EmailValidator"], email_directive_EmailValidatorDirective]), core_es5["ɵdid"](4308992, [['emailModel', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, 0, 2, null, View_ForgotPasswordComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_ForgotPasswordComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'text-divider']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'errors-summary', [], null, null, null, View_ErrorsSummaryComponent_0, RenderType_ErrorsSummaryComponent)), core_es5["ɵdid"](49152, null, 0, errorsSummary_component_ErrorsSummaryComponent, [], { errors: [0, 'errors'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'h5', [['class', 'text-right']], [[8, 'hidden', 0]], null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'small', [['class', 'text-success']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Your recovery url was sent to your email. Thank you!'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'footer text-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-primary btn-round'], ['type', 'submit']], [[8,
                'disabled', 0]], null, null, null, null)),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, ['Recover'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'full-page-background']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_15 = '';
        _ck(_v, 36, 0, currVal_15);
        var currVal_16 = '';
        _ck(_v, 37, 0, currVal_16);
        var currVal_17 = '';
        _ck(_v, 38, 0, currVal_17);
        var currVal_18 = 'email';
        var currVal_19 = 'email';
        var currVal_20 = 'Email';
        var currVal_21 = core_es5["ɵnov"](_v, 21);
        _ck(_v, 40, 0, currVal_18, currVal_19, currVal_20, currVal_21);
        var currVal_22 = 'email';
        var currVal_23 = _co.model.Email;
        _ck(_v, 42, 0, currVal_22, currVal_23);
        var currVal_24 = ((core_es5["ɵunv"](_v, 47, 0, _ck(_v, 48, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 40).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 40).model.pristine || core_es5["ɵnov"](_v, 21).submitted));
        _ck(_v, 47, 0, currVal_24);
        var currVal_25 = ((core_es5["ɵunv"](_v, 51, 0, _ck(_v, 52, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 40).model.errors)) == 'email') && (!core_es5["ɵnov"](_v, 40).model.pristine || core_es5["ɵnov"](_v, 21).submitted));
        _ck(_v, 51, 0, currVal_25);
        var currVal_26 = _co.errors;
        _ck(_v, 59, 0, currVal_26);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵnov"](_v, 23).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 23).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 23).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 23).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 23).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 23).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 23).ngClassPending;
        _ck(_v, 19, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (core_es5["ɵnov"](_v, 36).required ? '' : null);
        var currVal_8 = core_es5["ɵnov"](_v, 44).ngClassUntouched;
        var currVal_9 = core_es5["ɵnov"](_v, 44).ngClassTouched;
        var currVal_10 = core_es5["ɵnov"](_v, 44).ngClassPristine;
        var currVal_11 = core_es5["ɵnov"](_v, 44).ngClassDirty;
        var currVal_12 = core_es5["ɵnov"](_v, 44).ngClassValid;
        var currVal_13 = core_es5["ɵnov"](_v, 44).ngClassInvalid;
        var currVal_14 = core_es5["ɵnov"](_v, 44).ngClassPending;
        _ck(_v, 35, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_27 = !_co.success;
        _ck(_v, 61, 0, currVal_27);
        var currVal_28 = (_co.processing || (core_es5["ɵnov"](_v, 21).submitted && !core_es5["ɵnov"](_v, 21).valid));
        _ck(_v, 68, 0, currVal_28);
    });
}
function View_ForgotPasswordComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'forgot-password', [], null, null, null, View_ForgotPasswordComponent_0, RenderType_ForgotPasswordComponent)), core_es5["ɵdid"](114688, null, 0, forgotPassword_component_ForgotPasswordComponent, [services_userService["a" /* UserService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ForgotPasswordComponentNgFactory = core_es5["ɵccf"]('forgot-password', forgotPassword_component_ForgotPasswordComponent, View_ForgotPasswordComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=forgotPassword.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/objects/users/resetPasswordModel.ts
var ResetPasswordModel = /** @class */ (function () {
    function ResetPasswordModel() {
        this.Id = "";
        this.Code = "";
        this.Password = "";
        this.ConfirmPassword = "";
    }
    return ResetPasswordModel;
}());

//# sourceMappingURL=resetPasswordModel.js.map
// CONCATENATED MODULE: ./app/components/auth/resetPassword/resetPassword.component.ts



var resetPassword_component_ResetPasswordComponent = /** @class */ (function () {
    function ResetPasswordComponent(userService, route) {
        this.userService = userService;
        this.route = route;
        this.errors = [];
    }
    ResetPasswordComponent.prototype.ngOnInit = function () {
        this.model = new ResetPasswordModel();
        this.model.Id = this.route.snapshot.queryParams['userid'] || '';
        this.model.Code = this.route.snapshot.queryParams['token'] || '';
    };
    ResetPasswordComponent.prototype.forgotPassword = function (isValid) {
        var _this = this;
        this.errors = [];
        if (!isValid)
            return;
        this.processing = true;
        this.userService.resetPassword(this.model).then(function (response) {
            _this.processing = false;
            _this.success = true;
        }).catch(function (response) {
            _this.processing = false;
            _this.errors = _this.errors.concat(response.Errors);
        });
    };
    ResetPasswordComponent.ctorParameters = function () { return [{ type: services_userService["a" /* UserService */] }, { type: router_es5["a" /* ActivatedRoute */] }]; };
    return ResetPasswordComponent;
}());

//# sourceMappingURL=resetPassword.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/auth/resetPassword/resetPassword.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */













var styles_ResetPasswordComponent = [];
var RenderType_ResetPasswordComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ResetPasswordComponent, data: {} });
function View_ResetPasswordComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Password is required ']))], null, null);
}
function View_ResetPasswordComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Password should be more then 6 chars ']))], null, null);
}
function View_ResetPasswordComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Confirm Password is required ']))], null, null);
}
function View_ResetPasswordComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Password and its confirm are not the same ']))], null, null);
}
function View_ResetPasswordComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, FirstKeyPipe, []), (_l()(), core_es5["ɵeld"](0, null, null, 106, 'div', [['class', 'full-page login-page'], ['filter-color', 'black']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 101, 'div', [['class', 'content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 98, 'div', [['class', 'container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 95, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 92, 'div', [['class', 'col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 89, 'div', [['class', 'card card-login']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'card-header text-center'],
                ['data-background-color', 'rose']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'card-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Reset Password'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 80, 'form', [['novalidate',
                '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null], [2,
                'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngSubmit'], [null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 21).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 21).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.forgotPassword(core_es5["ɵnov"](_v, 21).valid) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['resetForm', 4]], 0, forms_es5["NgForm"], [[8,
                null], [8, null]], null, { ngSubmit: 'ngSubmit' }), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 66, 'div', [['class', 'card-content']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 26, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [['class', 'input-group-addon']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['lock_outline'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'form-input', [['label', 'Password'], ['minlength', '6'], ['name',
                'password'], ['required', ''], ['type', 'password']], [[1, 'required', 0], [1,
                'minlength', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.model.Password = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["MinLengthValidator"], [], { minlength: [0, 'minlength'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["MinLengthValidator"]]), core_es5["ɵdid"](4308992, [['passwordModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, 0, 2, null, View_ResetPasswordComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_ResetPasswordComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 26, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [['class',
                'input-group-addon']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['lock_outline'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'form-input', [['label',
                'Confirm Password'], ['name', 'confirmPassword'], ['required', ''], ['type', 'password']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.model.ConfirmPassword = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](16384, null, 0, EqualValidatorDirective, [], { validateEqual: [0, 'validateEqual'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], EqualValidatorDirective]), core_es5["ɵdid"](4308992, [['confirmPasswordModel',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], label: [2, 'label'], form: [3, 'form'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, 0, 2, null, View_ResetPasswordComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 2, null, View_ResetPasswordComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), core_es5["ɵppd"](1), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'text-divider']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'errors-summary', [], null, null, null, View_ErrorsSummaryComponent_0, RenderType_ErrorsSummaryComponent)), core_es5["ɵdid"](49152, null, 0, errorsSummary_component_ErrorsSummaryComponent, [], { errors: [0, 'errors'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'h5', [['class', 'text-center']], [[8, 'hidden', 0]], null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'small', [['class', 'text-success']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['We changed your password. Thank you!'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'footer text-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn btn-primary btn-round'], ['type', 'submit']], [[8,
                'disabled', 0]], null, null, null, null)),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, ['Reset'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'full-page-background']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_16 = '';
        _ck(_v, 36, 0, currVal_16);
        var currVal_17 = '6';
        _ck(_v, 37, 0, currVal_17);
        var currVal_18 = 'password';
        var currVal_19 = 'password';
        var currVal_20 = 'Password';
        var currVal_21 = core_es5["ɵnov"](_v, 21);
        _ck(_v, 39, 0, currVal_18, currVal_19, currVal_20, currVal_21);
        var currVal_22 = 'password';
        var currVal_23 = _co.model.Password;
        _ck(_v, 41, 0, currVal_22, currVal_23);
        var currVal_24 = ((core_es5["ɵunv"](_v, 46, 0, _ck(_v, 47, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 39).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 39).model.pristine || core_es5["ɵnov"](_v, 21).submitted));
        _ck(_v, 46, 0, currVal_24);
        var currVal_25 = ((core_es5["ɵunv"](_v, 50, 0, _ck(_v, 51, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 39).model.errors)) == 'minlength') && (!core_es5["ɵnov"](_v, 39).model.pristine || core_es5["ɵnov"](_v, 21).submitted));
        _ck(_v, 50, 0, currVal_25);
        var currVal_34 = '';
        _ck(_v, 64, 0, currVal_34);
        var currVal_35 = core_es5["ɵnov"](_v, 39);
        _ck(_v, 65, 0, currVal_35);
        var currVal_36 = 'password';
        var currVal_37 = 'confirmPassword';
        var currVal_38 = 'Confirm Password';
        var currVal_39 = core_es5["ɵnov"](_v, 21);
        _ck(_v, 67, 0, currVal_36, currVal_37, currVal_38, currVal_39);
        var currVal_40 = 'confirmPassword';
        var currVal_41 = _co.model.ConfirmPassword;
        _ck(_v, 69, 0, currVal_40, currVal_41);
        var currVal_42 = ((core_es5["ɵunv"](_v, 74, 0, _ck(_v, 75, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 67).model.errors)) == 'required') && (!core_es5["ɵnov"](_v, 67).model.pristine || core_es5["ɵnov"](_v, 21).submitted));
        _ck(_v, 74, 0, currVal_42);
        var currVal_43 = ((core_es5["ɵunv"](_v, 78, 0, _ck(_v, 79, 0, core_es5["ɵnov"](_v, 0), core_es5["ɵnov"](_v, 67).model.errors)) == 'validateEqual') && (!core_es5["ɵnov"](_v, 67).model.pristine || core_es5["ɵnov"](_v, 21).submitted));
        _ck(_v, 78, 0, currVal_43);
        var currVal_44 = _co.errors;
        _ck(_v, 86, 0, currVal_44);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵnov"](_v, 23).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 23).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 23).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 23).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 23).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 23).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 23).ngClassPending;
        _ck(_v, 19, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (core_es5["ɵnov"](_v, 36).required ? '' : null);
        var currVal_8 = (core_es5["ɵnov"](_v, 37).minlength ? core_es5["ɵnov"](_v, 37).minlength : null);
        var currVal_9 = core_es5["ɵnov"](_v, 43).ngClassUntouched;
        var currVal_10 = core_es5["ɵnov"](_v, 43).ngClassTouched;
        var currVal_11 = core_es5["ɵnov"](_v, 43).ngClassPristine;
        var currVal_12 = core_es5["ɵnov"](_v, 43).ngClassDirty;
        var currVal_13 = core_es5["ɵnov"](_v, 43).ngClassValid;
        var currVal_14 = core_es5["ɵnov"](_v, 43).ngClassInvalid;
        var currVal_15 = core_es5["ɵnov"](_v, 43).ngClassPending;
        _ck(_v, 35, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15);
        var currVal_26 = (core_es5["ɵnov"](_v, 64).required ? '' : null);
        var currVal_27 = core_es5["ɵnov"](_v, 71).ngClassUntouched;
        var currVal_28 = core_es5["ɵnov"](_v, 71).ngClassTouched;
        var currVal_29 = core_es5["ɵnov"](_v, 71).ngClassPristine;
        var currVal_30 = core_es5["ɵnov"](_v, 71).ngClassDirty;
        var currVal_31 = core_es5["ɵnov"](_v, 71).ngClassValid;
        var currVal_32 = core_es5["ɵnov"](_v, 71).ngClassInvalid;
        var currVal_33 = core_es5["ɵnov"](_v, 71).ngClassPending;
        _ck(_v, 63, 0, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33);
        var currVal_45 = !_co.success;
        _ck(_v, 88, 0, currVal_45);
        var currVal_46 = (_co.processing || (core_es5["ɵnov"](_v, 21).submitted && !core_es5["ɵnov"](_v, 21).valid));
        _ck(_v, 95, 0, currVal_46);
    });
}
function View_ResetPasswordComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'reset-password', [], null, null, null, View_ResetPasswordComponent_0, RenderType_ResetPasswordComponent)), core_es5["ɵdid"](114688, null, 0, resetPassword_component_ResetPasswordComponent, [services_userService["a" /* UserService */], router_es5["a" /* ActivatedRoute */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ResetPasswordComponentNgFactory = core_es5["ɵccf"]('reset-password', resetPassword_component_ResetPasswordComponent, View_ResetPasswordComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=resetPassword.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/payment/paymentRedirect.component.ts
var PaymentRedirectComponent = /** @class */ (function () {
    function PaymentRedirectComponent() {
    }
    PaymentRedirectComponent.ctorParameters = function () { return []; };
    return PaymentRedirectComponent;
}());

//# sourceMappingURL=paymentRedirect.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/payment/paymentRedirect.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


var styles_PaymentRedirectComponent = [];
var RenderType_PaymentRedirectComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_PaymentRedirectComponent, data: {} });
function View_PaymentRedirectComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [], null, null, null, null, null))], null, null);
}
function View_PaymentRedirectComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'payment-redirect', [], null, null, null, View_PaymentRedirectComponent_0, RenderType_PaymentRedirectComponent)), core_es5["ɵdid"](49152, null, 0, PaymentRedirectComponent, [], null, null)], null, null);
}
var PaymentRedirectComponentNgFactory = core_es5["ɵccf"]('payment-redirect', PaymentRedirectComponent, View_PaymentRedirectComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcGF5bWVudC9wYXltZW50UmVkaXJlY3QuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL3BheW1lbnQvcGF5bWVudFJlZGlyZWN0LmNvbXBvbmVudC50cyIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL3BheW1lbnQvcGF5bWVudFJlZGlyZWN0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcGF5bWVudC9wYXltZW50UmVkaXJlY3QuY29tcG9uZW50LnRzLlBheW1lbnRSZWRpcmVjdENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXY+PC9kaXY+IiwiPHBheW1lbnQtcmVkaXJlY3Q+PC9wYXltZW50LXJlZGlyZWN0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7Ozs7b0JDQUE7TUFBQTt5Q0FBQSxVQUFBO01BQUE7OzsifQ==
//# sourceMappingURL=paymentRedirect.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/common/publick-calculator-v2-title/publick-calculator-v2-title.component.ts
var PublicCalculatorV2TitleComponent = /** @class */ (function () {
    function PublicCalculatorV2TitleComponent() {
        this.showTitle = true;
        this.showNote = true;
    }
    PublicCalculatorV2TitleComponent.ctorParameters = function () { return []; };
    return PublicCalculatorV2TitleComponent;
}());

//# sourceMappingURL=publick-calculator-v2-title.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/common/publick-calculator-v2-title/publick-calculator-v2-title.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_PublicCalculatorV2TitleComponent = [];
var RenderType_PublicCalculatorV2TitleComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_PublicCalculatorV2TitleComponent, data: {} });
function View_PublicCalculatorV2TitleComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.title;
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_PublicCalculatorV2TitleComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'note']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.note;
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_PublicCalculatorV2TitleComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'row text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PublicCalculatorV2TitleComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PublicCalculatorV2TitleComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.showTitle;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _co.showNote;
        _ck(_v, 6, 0, currVal_1);
    }, null);
}
function View_PublicCalculatorV2TitleComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)), core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], null, null)], null, null);
}
var PublicCalculatorV2TitleComponentNgFactory = core_es5["ɵccf"]('publick-calculator-v2-title', PublicCalculatorV2TitleComponent, View_PublicCalculatorV2TitleComponent_Host_0, { title: 'title', note: 'note', showTitle: 'showTitle', showNote: 'showNote' }, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL3B1YmxpY2stY2FsY3VsYXRvci12Mi10aXRsZS9wdWJsaWNrLWNhbGN1bGF0b3ItdjItdGl0bGUuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL2NvbW1vbi9wdWJsaWNrLWNhbGN1bGF0b3ItdjItdGl0bGUvcHVibGljay1jYWxjdWxhdG9yLXYyLXRpdGxlLmNvbXBvbmVudC50cyIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL2NvbW1vbi9wdWJsaWNrLWNhbGN1bGF0b3ItdjItdGl0bGUvcHVibGljay1jYWxjdWxhdG9yLXYyLXRpdGxlLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL3B1YmxpY2stY2FsY3VsYXRvci12Mi10aXRsZS9wdWJsaWNrLWNhbGN1bGF0b3ItdjItdGl0bGUuY29tcG9uZW50LnRzLlB1YmxpY0NhbGN1bGF0b3JWMlRpdGxlQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cInJvdyB0ZXh0LWNlbnRlclwiPiA8ZGl2IGNsYXNzPVwiY29sLXhzLTEyXCIgKm5nSWY9XCJzaG93VGl0bGVcIj4gPGRpdiBjbGFzcz1cInRpdGxlXCI+e3t0aXRsZX19PC9kaXY+IDwvZGl2PiA8ZGl2IGNsYXNzPVwiY29sLXhzLTEyXCIgKm5nSWY9XCJzaG93Tm90ZVwiPiA8ZGl2IGNsYXNzPVwibm90ZVwiPnt7bm90ZX19PC9kaXY+IDwvZGl2PiA8L2Rpdj4gIiwiPHB1YmxpY2stY2FsY3VsYXRvci12Mi10aXRsZT48L3B1YmxpY2stY2FsY3VsYXRvci12Mi10aXRsZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7b0JDQThCO01BQUE7TUFBeUMsc0NBQUM7VUFBQTtVQUFBLGdCQUFtQix3Q0FBZTtVQUFBOztJQUFmO0lBQUE7Ozs7b0JBQXVCO01BQUE7TUFBd0Msc0NBQUM7VUFBQTtVQUFBLGdCQUFrQix3Q0FBYztVQUFBOztJQUFkO0lBQUE7Ozs7b0JBQTdLO01BQUE7TUFBQSxnQkFBNkIsc0NBQUM7TUFBQTthQUFBO1VBQUEsd0JBQW1GLHNDQUFDO1VBQUE7YUFBQTtVQUFBLHdCQUFnRixzQ0FBTztVQUFBOztJQUFwSjtJQUF2QixXQUF1QixTQUF2QjtJQUEyRztJQUF2QixXQUF1QixTQUF2Qjs7OztvQkNBbEg7TUFBQTtpREFBQSxVQUFBOzBDQUFBOzs7OzsifQ==
//# sourceMappingURL=publick-calculator-v2-title.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/components/calculator/public/mobile/wizard/public-wizard-v2.component.ts
var public_wizard_v2_component = __webpack_require__("W2+g");

// EXTERNAL MODULE: ./app/objects/calculator/public/types/type.ts
var types_type = __webpack_require__("LOzE");

// EXTERNAL MODULE: ./app/services/google-tag.service.ts
var google_tag_service = __webpack_require__("nz7M");

// CONCATENATED MODULE: ./app/components/calculator/public/mobile/locationTo-tab/locationTo-tab-v2.component.ts








var locationTo_tab_v2_component_LocationToTabsV2Component = /** @class */ (function () {
    function LocationToTabsV2Component(detectChanges, googleTagService) {
        this.detectChanges = detectChanges;
        this.googleTagService = googleTagService;
        this.provinceArray = new Array();
        this.hideWizard = new core_es5["EventEmitter"]();
        this.setOrderItem = new core_es5["EventEmitter"]();
        this.showFirstTab = false;
        this.isSelfServeApp = false;
        this.onTabSelected = new core_es5["EventEmitter"]();
        this.currentLocationTo = null;
        this.importToTypeRef = types_type["a" /* ImportToType */];
    }
    Object.defineProperty(LocationToTabsV2Component.prototype, "isCanadianCalculator", {
        get: function () {
            return calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(this.order.Locations) == orders_calculatorType["a" /* CalculatorType */].CanadianImport;
        },
        enumerable: true,
        configurable: true
    });
    LocationToTabsV2Component.prototype.setImportTo = function (importToType) {
        if (this.currentLocationTo == importToType) {
            this.currentLocationTo = null;
            return;
        }
        this.currentLocationTo = importToType;
        this.detectChanges.detectChanges();
    };
    LocationToTabsV2Component.prototype.setCountryToOrder = function (event) {
        var _this = this;
        event.preventDefault();
        var location = new order_orderLocation["a" /* OrderLocation */]({
            Type: 2
        });
        var orderLocation = this.order.Locations.find(function (loc) { return loc.Type == 2; });
        if (orderLocation)
            location = orderLocation;
        if (this.order && !this.order.Flag) {
            this.order.Flag = orderOptions["a" /* OrderOptions */].None;
        }
        switch (this.currentLocationTo) {
            case types_type["a" /* ImportToType */].Canada:
                location.Country = "Canada";
                if (this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsCommercialCarrier))
                    this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsCommercialCarrier;
                if (this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsDrivingAcross))
                    this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsDrivingAcross;
                this.shipmentFrom.showUSABtn = true;
                this.shipmentFrom.showCanadaBtn = false;
                break;
            case types_type["a" /* ImportToType */].Usa:
                location.Country = "United States";
                if (this.order.Locations.length > 0) {
                    this.order.Locations[0].State = null;
                }
                this.shipmentFrom.showUSABtn = false;
                this.shipmentFrom.showCanadaBtn = true;
                break;
        }
        console.log(this.order.Flag);
        this.order.Locations = this.order.Locations.filter(function (x) { return x.Type != 2; }).concat([location]);
        setTimeout(function (_) {
            _this.wizardComponent.nextTab(false);
        }, 100);
    };
    LocationToTabsV2Component.prototype.setProvincial = function (provincial /*TODO create an object*/) {
        var orderLocation = this.order.Locations.find(function (loc) { return loc.Type == 2; });
        orderLocation.State = provincial.name;
        if (provincial == this.currentState) {
            this.currentState = null;
            return;
        }
        this.currentState = provincial;
        this.detectChanges.detectChanges();
    };
    LocationToTabsV2Component.prototype.checkIfMobile = function () {
        this.isMobile = screenHelper["a" /* ScreenHelper */].isTabletOrPhone();
    };
    LocationToTabsV2Component.prototype.backToCalculatorFirstPage = function () {
        if (!this.showFirstTab) {
            this.hideWizard.emit(true);
            this.setOrderItem.emit(this.orderItem);
        }
    };
    LocationToTabsV2Component.prototype.setToCanadaImport = function () {
        var _this = this;
        if (!this.isSelfServeApp) {
            return;
        }
        this.setImportTo(types_type["a" /* ImportToType */].Canada);
        setTimeout(function () { return _this.wizardComponent.nextTab(true); }, 0);
    };
    LocationToTabsV2Component.ctorParameters = function () { return [{ type: core_es5["ChangeDetectorRef"] }, { type: google_tag_service["a" /* GoogleTagService */] }]; };
    return LocationToTabsV2Component;
}());

//# sourceMappingURL=locationTo-tab-v2.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/public/mobile/locationTo-tab/locationTo-tab-v2.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_LocationToTabsV2Component = [];
var RenderType_LocationToTabsV2Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_LocationToTabsV2Component, data: {} });
function View_LocationToTabsV2Component_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn size-3 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setProvincial(_v.parent.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'btn size-3 bold';
        var currVal_1 = _ck(_v, 2, 0, (_co.currentState == _v.parent.parent.context.$implicit));
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.parent.parent.context.$implicit.code;
        _ck(_v, 4, 0, currVal_2);
    });
}
function View_LocationToTabsV2Component_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationToTabsV2Component_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isMobile;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_LocationToTabsV2Component_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn size-3 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setProvincial(_v.parent.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'btn size-3 bold';
        var currVal_1 = _ck(_v, 2, 0, (_co.currentState == _v.parent.parent.context.$implicit));
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.parent.parent.context.$implicit.name;
        _ck(_v, 4, 0, currVal_2);
    });
}
function View_LocationToTabsV2Component_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationToTabsV2Component_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.isMobile;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_LocationToTabsV2Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationToTabsV2Component_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationToTabsV2Component_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isMobile;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = !_co.isMobile;
        _ck(_v, 6, 0, currVal_1);
    }, null);
}
function View_LocationToTabsV2Component_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 32, 'tab', [['nextButtonClass',
                'disable'], ['previousButton', 'back']], [[2, 'active', null], [2, 'tab-pane',
                null]], [[null, 'onPreviousClicked'], [null, 'onContinueClicked'],
            [null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onPreviousClicked' === en)) {
                _co.backToCalculatorFirstPage();
                var pd_0 = (_co.googleTagService.clearEventsArray() !== false);
                ad = (pd_0 && ad);
            }
            if (('onContinueClicked' === en)) {
                _co.setCountryToOrder($event);
                var pd_1 = (_co.focusInput((_co.isVehicle ? ((_co.currentLocationTo == _co.importToTypeRef.Canada) ? (0 - 1) : 3) : ((_co.currentLocationTo == _co.importToTypeRef.Canada) ? (0 - 1) : 4))) !== false);
                ad = (pd_1 && ad);
            }
            if (('isSelect' === en)) {
                _co.onTabSelected.emit({ pageTitle: 'What country is it going to?', pageOrder: 20 });
                _co.googleTagService.pushData('country');
                var pd_2 = (_co.setToCanadaImport() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */],
            core_es5["ElementRef"]], { heading: [0, 'heading'], previousButton: [1, 'previousButton'], isNextButtonDisabled: [2,
                'isNextButtonDisabled'], buttonTemplate: [3, 'buttonTemplate'], nextButton: [4, 'nextButton'],
            index: [5, 'index'] }, { isSelect: 'isSelect', onContinueClicked: 'onContinueClicked',
            onPreviousClicked: 'onPreviousClicked' }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', 'Different rules and rates apply.'], ['title', 'What country is it going to?']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)), core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1,
                'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'row no-gutter']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-xs-12 col-md-6 text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'buttons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-2 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setImportTo(_co.importToTypeRef.Canada) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Canada '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-xs-12 col-md-6 text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'buttons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-2 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setImportTo(_co.importToTypeRef.Usa) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' USA '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'tab', [['previousButton', 'back']], [[2, 'active', null], [2, 'tab-pane',
                null]], [[null, 'onContinueClicked'], [null,
                'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onContinueClicked' === en)) {
                var pd_0 = (_co.focusInput((_co.isVehicle ? 3 : ((_co.currentLocationTo == _co.importToTypeRef.Canada) ? 4 : (0 - 1)))) !== false);
                ad = (pd_0 && ad);
            }
            if (('isSelect' === en)) {
                _co.onTabSelected.emit({ pageTitle: 'What province is it going to?', pageOrder: 30 });
                _co.googleTagService.pushData('province');
                var pd_1 = (_co.checkIfMobile() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { heading: [0, 'heading'], previousButton: [1,
                'previousButton'], isNextButtonDisabled: [2, 'isNextButtonDisabled'], buttonTemplate: [3,
                'buttonTemplate'], nextButton: [4, 'nextButton'], index: [5, 'index'] }, { isSelect: 'isSelect',
            onContinueClicked: 'onContinueClicked' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', 'Taxes are different for each province.'], ['title', 'What province is it going to?']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)), core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1,
                'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'row no-gutter d-flex justify-content-center flex-wrap']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_LocationToTabsV2Component_1)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = 1;
        var currVal_3 = 'back';
        var currVal_4 = (_co.currentLocationTo == null);
        var currVal_5 = _co.wizardFooterTemplate;
        var currVal_6 = 'Continue';
        var currVal_7 = 1;
        _ck(_v, 1, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_8 = 'What country is it going to?';
        var currVal_9 = 'Different rules and rates apply.';
        _ck(_v, 4, 0, currVal_8, currVal_9);
        var currVal_10 = 'btn size-2 bold';
        var currVal_11 = _ck(_v, 14, 0, (_co.currentLocationTo == _co.importToTypeRef.Canada));
        _ck(_v, 13, 0, currVal_10, currVal_11);
        var currVal_12 = 'btn size-2 bold';
        var currVal_13 = _ck(_v, 26, 0, (_co.currentLocationTo == _co.importToTypeRef.Usa));
        _ck(_v, 25, 0, currVal_12, currVal_13);
        var currVal_16 = 2;
        var currVal_17 = 'back';
        var currVal_18 = (_co.currentState == null);
        var currVal_19 = _co.wizardFooterTemplate;
        var currVal_20 = 'Continue';
        var currVal_21 = (_co.isCanadianCalculator ? 2 : (0 - 1));
        _ck(_v, 35, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21);
        var currVal_22 = 'What province is it going to?';
        var currVal_23 = 'Taxes are different for each province.';
        _ck(_v, 38, 0, currVal_22, currVal_23);
        var currVal_24 = _co.provinceArray;
        _ck(_v, 43, 0, currVal_24);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).active;
        var currVal_1 = core_es5["ɵnov"](_v, 1).addClass;
        _ck(_v, 0, 0, currVal_0, currVal_1);
        var currVal_14 = core_es5["ɵnov"](_v, 35).active;
        var currVal_15 = core_es5["ɵnov"](_v, 35).addClass;
        _ck(_v, 34, 0, currVal_14, currVal_15);
    });
}
function View_LocationToTabsV2Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'locationTo-tabs-v2', [], null, [['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).checkIfMobile() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_LocationToTabsV2Component_0, RenderType_LocationToTabsV2Component)), core_es5["ɵdid"](49152, null, 0, locationTo_tab_v2_component_LocationToTabsV2Component, [core_es5["ChangeDetectorRef"], google_tag_service["a" /* GoogleTagService */]], null, null)], null, null);
}
var LocationToTabsV2ComponentNgFactory = core_es5["ɵccf"]('locationTo-tabs-v2', locationTo_tab_v2_component_LocationToTabsV2Component, View_LocationToTabsV2Component_Host_0, { order: 'order',
    orderItem: 'orderItem', wizardComponent: 'wizardComponent', provinceArray: 'provinceArray',
    wizardFooterTemplate: 'wizardFooterTemplate', showFirstTab: 'showFirstTab', isSelfServeApp: 'isSelfServeApp',
    shipmentFrom: 'shipmentFrom', focusInput: 'focusInput', isVehicle: 'isVehicle' }, { hideWizard: 'hideWizard', setOrderItem: 'setOrderItem', onTabSelected: 'onTabSelected' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=locationTo-tab-v2.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/components/calculator/public/mobile/shipment-from-tab/shipment-from-tab.component.ts
var shipment_from_tab_component = __webpack_require__("nnCU");

// CONCATENATED MODULE: ./compiled/app/components/calculator/public/mobile/shipment-from-tab/shipment-from-tab.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_ShipmentFromTabComponent = [];
var RenderType_ShipmentFromTabComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ShipmentFromTabComponent, data: {} });
function View_ShipmentFromTabComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setManufacturer(_co.getCountry('CA')) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' Canada ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'btn size-1 bold';
        var currVal_1 = _ck(_v, 2, 0, (_co.locationFrom && (_co.locationFrom.Code == 'CA')));
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_ShipmentFromTabComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-6 col-sm-6 col-md-4']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ShipmentFromTabComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.showCanadaBtn;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_ShipmentFromTabComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setManufacturer(_co.getCountry('US')) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' USA ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'btn size-1 bold';
        var currVal_1 = _ck(_v, 2, 0, (_co.locationFrom && (_co.locationFrom.Code == 'US')));
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_ShipmentFromTabComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-6 col-sm-6 col-md-4']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ShipmentFromTabComponent_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.showUSABtn;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_ShipmentFromTabComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 73, 'tab', [['heading',
                'Manufacturer'], ['nextButton', 'Continue'], ['previousButton', 'back']], [[2, 'active',
                null], [2, 'tab-pane', null]], [[null, 'isSelect'], [null,
                'onContinueClicked']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('isSelect' === en)) {
                _co.onTabSelected.emit({ pageTitle: 'Where are you shipping from?', pageOrder: 50 });
                var pd_0 = (_co.googleTagService.pushData('shipment-from') !== false);
                ad = (pd_0 && ad);
            }
            if (('onContinueClicked' === en)) {
                _co.setShipFrom();
                var pd_1 = (_co.focusInput((_co.isVehicle ? 7 : 6)) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */],
            core_es5["ElementRef"]], { heading: [0, 'heading'], previousButton: [1, 'previousButton'], isNextButtonDisabled: [2,
                'isNextButtonDisabled'], buttonTemplate: [3, 'buttonTemplate'], nextButton: [4, 'nextButton'],
            index: [5, 'index'] }, { isSelect: 'isSelect', onContinueClicked: 'onContinueClicked' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', 'Different countries have different duty rates.'],
            ['title', 'Where are you shipping from?']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)),
        core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1, 'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 66, 'div', [['class',
                'row no-gutter manufacturer']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_ShipmentFromTabComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-xs-6 col-sm-6 col-md-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setManufacturer(_co.getCountry('CN')) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' China '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-xs-6 col-sm-6 col-md-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setManufacturer(_co.getCountry('JP')) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Japan '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-xs-6 col-sm-6 col-md-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setManufacturer(_co.getCountry('DE')) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Germany '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ShipmentFromTabComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 30, 'div', [['class', 'col-xs-12 col-md-8 btn-select-container']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 27, 'form', [['class', 'btn-select-container_form w-100'], ['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 45).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 45).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['manufacturerFrom', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'form-group label-floating btn bold size-1 select-2']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'has-error': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"],
            core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'select', [['class',
                'form-control select2'], ['data-autofocus', ''], ['id', 'shipFromSelect'], ['name',
                'manufacturerSelect'], ['required', '']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 55).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 55).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.locationFrom = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, [['shipFromSelect', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'option', [], null, null, null, null, null)), core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"],
            core_es5["Renderer2"], [2, forms_es5["SelectControlValueAccessor"]]], null, null),
        core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'material-input']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = 'Manufacturer';
        var currVal_3 = 'back';
        var currVal_4 = (((_co.locationFrom == null) ? null : _co.locationFrom.Code) == null);
        var currVal_5 = _co.wizardFooterTemplate;
        var currVal_6 = 'Continue';
        var currVal_7 = 4;
        _ck(_v, 1, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_8 = 'Where are you shipping from?';
        var currVal_9 = 'Different countries have different duty rates.';
        _ck(_v, 4, 0, currVal_8, currVal_9);
        var currVal_10 = _co.showCanadaBtn;
        _ck(_v, 9, 0, currVal_10);
        var currVal_11 = 'btn size-1 bold';
        var currVal_12 = _ck(_v, 15, 0, (_co.locationFrom && (_co.locationFrom.Code == 'CN')));
        _ck(_v, 14, 0, currVal_11, currVal_12);
        var currVal_13 = 'btn size-1 bold';
        var currVal_14 = _ck(_v, 24, 0, (_co.locationFrom && (_co.locationFrom.Code == 'JP')));
        _ck(_v, 23, 0, currVal_13, currVal_14);
        var currVal_15 = 'btn size-1 bold';
        var currVal_16 = _ck(_v, 33, 0, (_co.locationFrom && (_co.locationFrom.Code == 'DE')));
        _ck(_v, 32, 0, currVal_15, currVal_16);
        var currVal_17 = _co.showUSABtn;
        _ck(_v, 39, 0, currVal_17);
        var currVal_25 = 'form-group label-floating btn bold size-1 select-2';
        var currVal_26 = _ck(_v, 51, 0, (core_es5["ɵnov"](_v, 45) && (core_es5["ɵnov"](_v, 59).invalid && (!core_es5["ɵnov"](_v, 59).pristine || core_es5["ɵnov"](_v, 45).submitted))));
        _ck(_v, 50, 0, currVal_25, currVal_26);
        var currVal_35 = '';
        _ck(_v, 56, 0, currVal_35);
        var currVal_36 = 'manufacturerSelect';
        var currVal_37 = _co.locationFrom;
        _ck(_v, 59, 0, currVal_36, currVal_37);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).active;
        var currVal_1 = core_es5["ɵnov"](_v, 1).addClass;
        _ck(_v, 0, 0, currVal_0, currVal_1);
        var currVal_18 = core_es5["ɵnov"](_v, 47).ngClassUntouched;
        var currVal_19 = core_es5["ɵnov"](_v, 47).ngClassTouched;
        var currVal_20 = core_es5["ɵnov"](_v, 47).ngClassPristine;
        var currVal_21 = core_es5["ɵnov"](_v, 47).ngClassDirty;
        var currVal_22 = core_es5["ɵnov"](_v, 47).ngClassValid;
        var currVal_23 = core_es5["ɵnov"](_v, 47).ngClassInvalid;
        var currVal_24 = core_es5["ɵnov"](_v, 47).ngClassPending;
        _ck(_v, 43, 0, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24);
        var currVal_27 = (core_es5["ɵnov"](_v, 56).required ? '' : null);
        var currVal_28 = core_es5["ɵnov"](_v, 61).ngClassUntouched;
        var currVal_29 = core_es5["ɵnov"](_v, 61).ngClassTouched;
        var currVal_30 = core_es5["ɵnov"](_v, 61).ngClassPristine;
        var currVal_31 = core_es5["ɵnov"](_v, 61).ngClassDirty;
        var currVal_32 = core_es5["ɵnov"](_v, 61).ngClassValid;
        var currVal_33 = core_es5["ɵnov"](_v, 61).ngClassInvalid;
        var currVal_34 = core_es5["ɵnov"](_v, 61).ngClassPending;
        _ck(_v, 54, 0, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34);
    });
}
function View_ShipmentFromTabComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'shipment-from-tab', [], null, null, null, View_ShipmentFromTabComponent_0, RenderType_ShipmentFromTabComponent)), core_es5["ɵdid"](4243456, null, 0, shipment_from_tab_component["a" /* ShipmentFromTabComponent */], [services_configService["a" /* ConfigService */], core_es5["ChangeDetectorRef"], google_tag_service["a" /* GoogleTagService */]], null, null)], null, null);
}
var ShipmentFromTabComponentNgFactory = core_es5["ɵccf"]('shipment-from-tab', shipment_from_tab_component["a" /* ShipmentFromTabComponent */], View_ShipmentFromTabComponent_Host_0, { order: 'order',
    orderItem: 'orderItem', wizardComponent: 'wizardComponent', wizardFooterTemplate: 'wizardFooterTemplate',
    focusInput: 'focusInput' }, { onTabSelected: 'onTabSelected' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=shipment-from-tab.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/components/calculator/public/mobile/manufacturer-tab/manufacturer-tab-v2.component.ts
var manufacturer_tab_v2_component = __webpack_require__("jUPs");

// CONCATENATED MODULE: ./compiled/app/components/calculator/public/mobile/manufacturer-tab/manufacturer-tab-v2.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_ManufacturerTabV2Component = [];
var RenderType_ManufacturerTabV2Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ManufacturerTabV2Component, data: {} });
function View_ManufacturerTabV2Component_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 85, 'tab', [['heading',
                'Manufacturer'], ['nextButton', 'Continue'], ['previousButton', 'back']], [[2, 'active',
                null], [2, 'tab-pane', null]], [[null, 'isSelect'], [null,
                'onContinueClicked']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('isSelect' === en)) {
                _co.onTabSelected.emit({ pageTitle: 'Where is the product made?', pageOrder: 80 });
                var pd_0 = (_co.googleTagService.pushData('manufacturer') !== false);
                ad = (pd_0 && ad);
            }
            if (('onContinueClicked' === en)) {
                var pd_1 = (_co.focusInput(8) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */],
            core_es5["ElementRef"]], { heading: [0, 'heading'], previousButton: [1, 'previousButton'], isNextButtonDisabled: [2,
                'isNextButtonDisabled'], buttonTemplate: [3, 'buttonTemplate'], nextButton: [4, 'nextButton'],
            index: [5, 'index'] }, { isSelect: 'isSelect', onContinueClicked: 'onContinueClicked' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', '']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)),
        core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1, 'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 78, 'div', [['class',
                'row manufacturer no-gutter']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-xs-6 col-md-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setManufacturer(_co.getCountry('US')) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' USA '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-xs-6 col-md-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setManufacturer(_co.getCountry('CA')) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Canada '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-xs-6 col-md-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setManufacturer(_co.getCountry('CN')) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' China '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-xs-6 col-md-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setManufacturer(_co.getCountry('JP')) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Japan '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-xs-6 col-md-4']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setManufacturer(_co.getCountry('DE')) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Germany '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 30, 'div', [['class', 'col-xs-6 col-md-4 btn-select-container']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 27, 'form', [['class', 'btn-select-container_form w-100'], ['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 57).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 57).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['manufacturerFrom', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'form-group label-floating btn bold select-2 size-1']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'has-error': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"],
            core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'select', [['class',
                'form-control select2'], ['data-autofocus', ''], ['id', 'manufacturerSelect'],
            ['name', 'manufacturerSelect'], ['required', '']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 67).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 67).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.orderItem.Manufacturer = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, [['manufacturerSelect', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'option', [], null, null, null, null, null)), core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"],
            core_es5["Renderer2"], [2, forms_es5["SelectControlValueAccessor"]]], null, null),
        core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'span', [['class', 'material-input']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = 'Manufacturer';
        var currVal_3 = 'back';
        var currVal_4 = (_co.orderItem.Manufacturer.Code == null);
        var currVal_5 = _co.wizardFooterTemplate;
        var currVal_6 = 'Continue';
        var currVal_7 = 7;
        _ck(_v, 1, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_8 = core_es5["ɵinlineInterpolate"](1, 'Where is the ', (_co.isVehicle ? 'vehicle' : 'product'), ' made?');
        var currVal_9 = '';
        _ck(_v, 4, 0, currVal_8, currVal_9);
        var currVal_10 = 'btn size-1 bold';
        var currVal_11 = _ck(_v, 12, 0, (_co.orderItem.Manufacturer && (_co.orderItem.Manufacturer.Code == 'US')));
        _ck(_v, 11, 0, currVal_10, currVal_11);
        var currVal_12 = 'btn size-1 bold';
        var currVal_13 = _ck(_v, 21, 0, (_co.orderItem.Manufacturer && (_co.orderItem.Manufacturer.Code == 'CA')));
        _ck(_v, 20, 0, currVal_12, currVal_13);
        var currVal_14 = 'btn size-1 bold';
        var currVal_15 = _ck(_v, 30, 0, (_co.orderItem.Manufacturer && (_co.orderItem.Manufacturer.Code == 'CN')));
        _ck(_v, 29, 0, currVal_14, currVal_15);
        var currVal_16 = 'btn size-1 bold';
        var currVal_17 = _ck(_v, 39, 0, (_co.orderItem.Manufacturer && (_co.orderItem.Manufacturer.Code == 'JP')));
        _ck(_v, 38, 0, currVal_16, currVal_17);
        var currVal_18 = 'btn size-1 bold';
        var currVal_19 = _ck(_v, 48, 0, (_co.orderItem.Manufacturer && (_co.orderItem.Manufacturer.Code == 'DE')));
        _ck(_v, 47, 0, currVal_18, currVal_19);
        var currVal_27 = 'form-group label-floating btn bold select-2 size-1';
        var currVal_28 = _ck(_v, 63, 0, (core_es5["ɵnov"](_v, 57) && (core_es5["ɵnov"](_v, 71).invalid && (!core_es5["ɵnov"](_v, 71).pristine || core_es5["ɵnov"](_v, 57).submitted))));
        _ck(_v, 62, 0, currVal_27, currVal_28);
        var currVal_37 = '';
        _ck(_v, 68, 0, currVal_37);
        var currVal_38 = 'manufacturerSelect';
        var currVal_39 = _co.orderItem.Manufacturer;
        _ck(_v, 71, 0, currVal_38, currVal_39);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).active;
        var currVal_1 = core_es5["ɵnov"](_v, 1).addClass;
        _ck(_v, 0, 0, currVal_0, currVal_1);
        var currVal_20 = core_es5["ɵnov"](_v, 59).ngClassUntouched;
        var currVal_21 = core_es5["ɵnov"](_v, 59).ngClassTouched;
        var currVal_22 = core_es5["ɵnov"](_v, 59).ngClassPristine;
        var currVal_23 = core_es5["ɵnov"](_v, 59).ngClassDirty;
        var currVal_24 = core_es5["ɵnov"](_v, 59).ngClassValid;
        var currVal_25 = core_es5["ɵnov"](_v, 59).ngClassInvalid;
        var currVal_26 = core_es5["ɵnov"](_v, 59).ngClassPending;
        _ck(_v, 55, 0, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26);
        var currVal_29 = (core_es5["ɵnov"](_v, 68).required ? '' : null);
        var currVal_30 = core_es5["ɵnov"](_v, 73).ngClassUntouched;
        var currVal_31 = core_es5["ɵnov"](_v, 73).ngClassTouched;
        var currVal_32 = core_es5["ɵnov"](_v, 73).ngClassPristine;
        var currVal_33 = core_es5["ɵnov"](_v, 73).ngClassDirty;
        var currVal_34 = core_es5["ɵnov"](_v, 73).ngClassValid;
        var currVal_35 = core_es5["ɵnov"](_v, 73).ngClassInvalid;
        var currVal_36 = core_es5["ɵnov"](_v, 73).ngClassPending;
        _ck(_v, 66, 0, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36);
    });
}
function View_ManufacturerTabV2Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'manufacturer-tab-v2', [], null, null, null, View_ManufacturerTabV2Component_0, RenderType_ManufacturerTabV2Component)), core_es5["ɵdid"](4243456, null, 0, manufacturer_tab_v2_component["a" /* ManufacturerTabV2Component */], [services_configService["a" /* ConfigService */], core_es5["ChangeDetectorRef"], google_tag_service["a" /* GoogleTagService */]], null, null)], null, null);
}
var ManufacturerTabV2ComponentNgFactory = core_es5["ɵccf"]('manufacturer-tab-v2', manufacturer_tab_v2_component["a" /* ManufacturerTabV2Component */], View_ManufacturerTabV2Component_Host_0, { order: 'order',
    orderItem: 'orderItem', wizardComponent: 'wizardComponent', wizardFooterTemplate: 'wizardFooterTemplate',
    focusInput: 'focusInput' }, { onTabSelected: 'onTabSelected' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=manufacturer-tab-v2.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/text-mask-addons/dist/createNumberMask.js
var createNumberMask = __webpack_require__("cfoZ");
var createNumberMask_default = /*#__PURE__*/__webpack_require__.n(createNumberMask);

// CONCATENATED MODULE: ./app/components/calculator/public/mobile/price-tab/price-tab-v2.component.ts




var price_tab_v2_component_PriceTabV2Component = /** @class */ (function () {
    /*getters end*/
    function PriceTabV2Component(detectChanges, googleTagService) {
        this.detectChanges = detectChanges;
        this.googleTagService = googleTagService;
        this.canadianCurrencyCodes = [];
        this.onTabSelected = new core_es5["EventEmitter"]();
        this.currentValue = null;
        this.currentValueRange = null;
        this.numberMask = createNumberMask_default()({
            prefix: '',
            allowDecimal: true
        });
        this.getMeanValue = function (from, to) { return calculatorHelper["a" /* CalculatorHelper */].getMeanValue(from, to); };
    }
    Object.defineProperty(PriceTabV2Component.prototype, "isVehicle", {
        /*getters*/
        get: function () {
            return calculatorHelper["a" /* CalculatorHelper */].isVehicle(this.order);
        },
        enumerable: true,
        configurable: true
    });
    PriceTabV2Component.prototype.setPrice = function (from, to) {
        this.currentValueRange = calculatorHelper["a" /* CalculatorHelper */].getButtonValue(calculatorHelper["a" /* CalculatorHelper */].getMeanValue(from, to), this.currentValueRange);
        this.currentValue = null;
        this.detectChanges.detectChanges();
    };
    PriceTabV2Component.prototype.setPriceToOI = function () {
        if (this.currentValue)
            this.orderItem.Price = +(this.currentValue.replace(new RegExp(',', 'g'), ''));
        this.orderItem.CanadianCurrencyCode = this.currency;
    };
    PriceTabV2Component.prototype.setCurrency = function (currencyName) {
        this.currency = this.canadianCurrencyCodes.find(function (code) { return code.Name == currencyName; });
    };
    PriceTabV2Component.prototype.checkAndSetCurrency = function () {
        // const calculatorType = CalculatorHelper.getCalculatorType(this.order.Locations);
        //
        // if (calculatorType == CalculatorType.UsaImport)
        //     this.setCurrency('CAD');
        // else this.setCurrency('USD');
        //According to BB-1745 default currency must be 1745
        this.setCurrency('USD');
        if (this.orderItem.Price === undefined || this.orderItem.Price === null) {
            this.currentValueRange = null;
        }
    };
    PriceTabV2Component.prototype.decimalHandler = function (event) {
        var val = event.target.value + String.fromCharCode(event.charCode);
        // (event.charCode != 0) For Mozilla Firefox
        if (!/^[0-9]+([,.][0-9]{0,2})?$/.test(val) && (event.charCode != 0)) {
            event.preventDefault();
        }
    };
    PriceTabV2Component.ctorParameters = function () { return [{ type: core_es5["ChangeDetectorRef"] }, { type: google_tag_service["a" /* GoogleTagService */] }]; };
    return PriceTabV2Component;
}());

//# sourceMappingURL=price-tab-v2.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/public/mobile/price-tab/price-tab-v2.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */











var styles_PriceTabV2Component = [];
var RenderType_PriceTabV2Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_PriceTabV2Component, data: {} });
function View_PriceTabV2Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 30, 'div', [['class',
                'row value']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 27, 'div', [['class', 'buttons price-block col-sm-12 height-size-2']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['class',
                'btn-arrow cad']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setCurrency('CAD') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }), (_l()(), core_es5["ɵted"](null, ['CAD'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form', [['novalidate', '']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'submit'], [null,
                'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 11).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 11).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['priceForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'form-input', [['class', 'btn no-triangle bold'], ['name', 'productValueInput'],
            ['placeholder', 'Enter value'], ['step', '0,1'], ['type', 'number']], [[2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'keypress'], [null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('keypress' === en)) {
                var pd_0 = (_co.decimalHandler($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_1 = ((_co.currentValue = $event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](4308992, [['productValueInput', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]],
            [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], form: [2,
                'form'], placeholder: [3, 'placeholder'], isPlaceholderNeed: [4, 'isPlaceholderNeed'],
            autofocus: [5, 'autofocus'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'button', [['class', 'btn-arrow usd']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setCurrency('USD') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        (_l()(), core_es5["ɵted"](null, ['USD'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'btn-arrow cad';
        var currVal_1 = _ck(_v, 6, 0, (_co.currency.Name == 'CAD'));
        _ck(_v, 5, 0, currVal_0, currVal_1);
        var currVal_16 = 'number';
        var currVal_17 = 'productValueInput';
        var currVal_18 = core_es5["ɵnov"](_v, 11);
        var currVal_19 = 'Enter value';
        var currVal_20 = true;
        var currVal_21 = true;
        _ck(_v, 16, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21);
        var currVal_22 = 'productValueInput';
        var currVal_23 = _co.currentValue;
        _ck(_v, 18, 0, currVal_22, currVal_23);
        var currVal_24 = 'btn-arrow usd';
        var currVal_25 = _ck(_v, 27, 0, (_co.currency.Name == 'USD'));
        _ck(_v, 26, 0, currVal_24, currVal_25);
    }, function (_ck, _v) {
        var currVal_2 = core_es5["ɵnov"](_v, 13).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 13).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 13).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 13).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 13).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 13).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 13).ngClassPending;
        _ck(_v, 9, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
        var currVal_9 = core_es5["ɵnov"](_v, 20).ngClassUntouched;
        var currVal_10 = core_es5["ɵnov"](_v, 20).ngClassTouched;
        var currVal_11 = core_es5["ɵnov"](_v, 20).ngClassPristine;
        var currVal_12 = core_es5["ɵnov"](_v, 20).ngClassDirty;
        var currVal_13 = core_es5["ɵnov"](_v, 20).ngClassValid;
        var currVal_14 = core_es5["ɵnov"](_v, 20).ngClassInvalid;
        var currVal_15 = core_es5["ɵnov"](_v, 20).ngClassPending;
        _ck(_v, 15, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15);
    });
}
function View_PriceTabV2Component_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 8, 'tab', [['heading',
                'Value'], ['previousButton', 'back']], [[2, 'active', null], [2, 'tab-pane',
                null]], [[null, 'onContinueClicked'], [null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onContinueClicked' === en)) {
                _co.setPriceToOI();
                var pd_0 = (_co.focusInput(9) !== false);
                ad = (pd_0 && ad);
            }
            if (('isSelect' === en)) {
                _co.onTabSelected.emit({ pageTitle: 'What is the approximate value?', pageOrder: 90 });
                _co.checkAndSetCurrency();
                var pd_1 = (_co.googleTagService.pushData('price') !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { heading: [0, 'heading'], previousButton: [1, 'previousButton'],
            isNextButtonDisabled: [2, 'isNextButtonDisabled'], buttonTemplate: [3, 'buttonTemplate'],
            nextButton: [4, 'nextButton'], index: [5, 'index'] }, { isSelect: 'isSelect', onContinueClicked: 'onContinueClicked' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', 'The value of product can determine duty and tax.'],
            ['title', 'What is the approximate value?']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)),
        core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1, 'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PriceTabV2Component_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = 'Value';
        var currVal_3 = 'back';
        var currVal_4 = !_co.currentValue;
        var currVal_5 = _co.wizardFooterTemplate;
        var currVal_6 = 'Continue';
        var currVal_7 = 8;
        _ck(_v, 1, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_8 = 'What is the approximate value?';
        var currVal_9 = 'The value of product can determine duty and tax.';
        _ck(_v, 4, 0, currVal_8, currVal_9);
        var currVal_10 = _co.currency;
        _ck(_v, 7, 0, currVal_10);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).active;
        var currVal_1 = core_es5["ɵnov"](_v, 1).addClass;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
function View_PriceTabV2Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'price-tab-v2', [], null, null, null, View_PriceTabV2Component_0, RenderType_PriceTabV2Component)), core_es5["ɵdid"](49152, null, 0, price_tab_v2_component_PriceTabV2Component, [core_es5["ChangeDetectorRef"], google_tag_service["a" /* GoogleTagService */]], null, null)], null, null);
}
var PriceTabV2ComponentNgFactory = core_es5["ɵccf"]('price-tab-v2', price_tab_v2_component_PriceTabV2Component, View_PriceTabV2Component_Host_0, { wizardComponent: 'wizardComponent',
    order: 'order', orderItem: 'orderItem', canadianCurrencyCodes: 'canadianCurrencyCodes',
    wizardFooterTemplate: 'wizardFooterTemplate', focusInput: 'focusInput' }, { onTabSelected: 'onTabSelected' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=price-tab-v2.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/calculator/public/mobile/canadian-questions-tab/canadian-questions-tab-v2.component.ts





var canadian_questions_tab_v2_component_CanadianQuestionsTabV2Component = /** @class */ (function () {
    /*getters end*/
    function CanadianQuestionsTabV2Component(detectChanges, googleTagService) {
        this.detectChanges = detectChanges;
        this.googleTagService = googleTagService;
        this.onTabSelected = new core_es5["EventEmitter"]();
        this.isAirCond = null;
        this.calculatorHelper = calculatorHelper["a" /* CalculatorHelper */];
    }
    Object.defineProperty(CanadianQuestionsTabV2Component.prototype, "isVehicle", {
        /*getters*/
        get: function () {
            return calculatorHelper["a" /* CalculatorHelper */].isVehicle(this.order);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CanadianQuestionsTabV2Component.prototype, "isCanadianCalculator", {
        get: function () {
            return calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(this.order.Locations) == orders_calculatorType["a" /* CalculatorType */].CanadianImport;
        },
        enumerable: true,
        configurable: true
    });
    CanadianQuestionsTabV2Component.prototype.setAirCondToOrder = function () {
        if (this.isAirCond)
            this.orderItem.Flags |= orderItemOptions["a" /* OrderItemOptions */].IsAC;
        else if (this.orderItem.Flags)
            this.orderItem.Flags &= ~orderItemOptions["a" /* OrderItemOptions */].IsAC;
    };
    CanadianQuestionsTabV2Component.prototype.getAirCond = function (value, isAirCond) {
        this.isAirCond = this.calculatorHelper.getButtonValue(value, isAirCond);
        this.detectChanges.detectChanges();
    };
    CanadianQuestionsTabV2Component.prototype.getCommercial = function (value, IsCommercial) {
        this.order.IsCommercial = this.calculatorHelper.getButtonValue(value, IsCommercial);
        this.detectChanges.detectChanges();
    };
    CanadianQuestionsTabV2Component.ctorParameters = function () { return [{ type: core_es5["ChangeDetectorRef"] }, { type: google_tag_service["a" /* GoogleTagService */] }]; };
    return CanadianQuestionsTabV2Component;
}());

//# sourceMappingURL=canadian-questions-tab-v2.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/public/mobile/canadian-questions-tab/canadian-questions-tab-v2.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_CanadianQuestionsTabV2Component = [];
var RenderType_CanadianQuestionsTabV2Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CanadianQuestionsTabV2Component, data: {} });
function View_CanadianQuestionsTabV2Component_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 32, 'tab', [['previousButton',
                'back']], [[2, 'active', null], [2, 'tab-pane', null]], [[null,
                'onContinueClicked'], [null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onContinueClicked' === en)) {
                _co.setAirCondToOrder();
                var pd_0 = (_co.focusInput((_co.isCanadianCalculator ? 10 : (0 - 1))) !== false);
                ad = (pd_0 && ad);
            }
            if (('isSelect' === en)) {
                _co.onTabSelected.emit({ pageTitle: 'Does the vehicle have Air Conditioning?',
                    pageOrder: 100 });
                var pd_1 = (_co.googleTagService.pushData('air_condition') !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */],
            core_es5["ElementRef"]], { previousButton: [0, 'previousButton'], isNextButtonDisabled: [1,
                'isNextButtonDisabled'], buttonTemplate: [2, 'buttonTemplate'], nextButton: [3, 'nextButton'],
            index: [4, 'index'] }, { isSelect: 'isSelect', onContinueClicked: 'onContinueClicked' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', 'Individuals pay PST, Businesses pay GST.'],
            ['title', 'Does the vehicle have Air Conditioning?']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)),
        core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1, 'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class',
                'row no-gutter']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-xs-12 col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'buttons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-2 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.getAirCond(true, _co.isAirCond) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Yes '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-xs-12 col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'buttons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn size-2 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.getAirCond(false, _co.isAirCond) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' No '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 32, 'tab', [['previousButton', 'back']], [[2, 'active', null], [2, 'tab-pane', null]], [[null,
                'onContinueClicked'], [null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onContinueClicked' === en)) {
                var pd_0 = (_co.focusInput(11) !== false);
                ad = (pd_0 && ad);
            }
            if (('isSelect' === en)) {
                _co.onTabSelected.emit({ pageTitle: 'Individual or Business use?', pageOrder: 110 });
                var pd_1 = (_co.googleTagService.pushData('type_of_use') !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { previousButton: [0, 'previousButton'], isNextButtonDisabled: [1,
                'isNextButtonDisabled'], buttonTemplate: [2, 'buttonTemplate'], nextButton: [3,
                'nextButton'], index: [4, 'index'] }, { isSelect: 'isSelect', onContinueClicked: 'onContinueClicked' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', ''], ['title', 'Individual or Business use?']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)), core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1,
                'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'row no-gutter']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-xs-12 col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'buttons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn size-2 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.getCommercial(false, _co.order.IsCommercial) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' Individual '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class',
                'col-xs-12 col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'buttons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn size-2 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.getCommercial(true, _co.order.IsCommercial) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' Business '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = 'back';
        var currVal_3 = (_co.isAirCond == null);
        var currVal_4 = _co.wizardFooterTemplate;
        var currVal_5 = 'Continue';
        var currVal_6 = ((_co.isVehicle && _co.isCanadianCalculator) ? 9 : (0 - 1));
        _ck(_v, 1, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = 'Does the vehicle have Air Conditioning?';
        var currVal_8 = 'Individuals pay PST, Businesses pay GST.';
        _ck(_v, 4, 0, currVal_7, currVal_8);
        var currVal_9 = 'btn size-2 bold';
        var currVal_10 = _ck(_v, 14, 0, (_co.isAirCond == true));
        _ck(_v, 13, 0, currVal_9, currVal_10);
        var currVal_11 = 'btn size-2 bold';
        var currVal_12 = _ck(_v, 26, 0, (_co.isAirCond == false));
        _ck(_v, 25, 0, currVal_11, currVal_12);
        var currVal_15 = 'back';
        var currVal_16 = (_co.order.IsCommercial == null);
        var currVal_17 = _co.wizardFooterTemplate;
        var currVal_18 = 'Continue';
        var currVal_19 = 10;
        _ck(_v, 35, 0, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19);
        var currVal_20 = 'Individual or Business use?';
        var currVal_21 = '';
        _ck(_v, 38, 0, currVal_20, currVal_21);
        var currVal_22 = 'btn size-2 bold';
        var currVal_23 = _ck(_v, 48, 0, (_co.order.IsCommercial == false));
        _ck(_v, 47, 0, currVal_22, currVal_23);
        var currVal_24 = 'btn size-2 bold';
        var currVal_25 = _ck(_v, 60, 0, (_co.order.IsCommercial == true));
        _ck(_v, 59, 0, currVal_24, currVal_25);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).active;
        var currVal_1 = core_es5["ɵnov"](_v, 1).addClass;
        _ck(_v, 0, 0, currVal_0, currVal_1);
        var currVal_13 = core_es5["ɵnov"](_v, 35).active;
        var currVal_14 = core_es5["ɵnov"](_v, 35).addClass;
        _ck(_v, 34, 0, currVal_13, currVal_14);
    });
}
function View_CanadianQuestionsTabV2Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'canadian-questions-tab-v2', [], null, null, null, View_CanadianQuestionsTabV2Component_0, RenderType_CanadianQuestionsTabV2Component)), core_es5["ɵdid"](49152, null, 0, canadian_questions_tab_v2_component_CanadianQuestionsTabV2Component, [core_es5["ChangeDetectorRef"], google_tag_service["a" /* GoogleTagService */]], null, null)], null, null);
}
var CanadianQuestionsTabV2ComponentNgFactory = core_es5["ɵccf"]('canadian-questions-tab-v2', canadian_questions_tab_v2_component_CanadianQuestionsTabV2Component, View_CanadianQuestionsTabV2Component_Host_0, { wizardComponent: 'wizardComponent', order: 'order', orderItem: 'orderItem', wizardFooterTemplate: 'wizardFooterTemplate',
    focusInput: 'focusInput' }, { onTabSelected: 'onTabSelected' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=canadian-questions-tab-v2.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/calculator/public/mobile/email-tab/email-tab-v2.component.ts



var email_tab_v2_component_EmailTabsV2Component = /** @class */ (function () {
    function EmailTabsV2Component(detectChanges, googleTagService) {
        this.detectChanges = detectChanges;
        this.googleTagService = googleTagService;
        this.isNeedSendEmail = new core_es5["EventEmitter"]();
        this.isEmailCopy = null;
        this.currentEmail = null;
        this.currentPhone = null;
        this.currentName = null;
        this.isEmailShow = false;
        this.calculatorHelper = calculatorHelper["a" /* CalculatorHelper */];
        this.communicationSwitcher = true;
        this.onTabSelected = new core_es5["EventEmitter"]();
    }
    EmailTabsV2Component.prototype.toggleSwitcher = function () {
        this.communicationSwitcher = !this.communicationSwitcher;
    };
    EmailTabsV2Component.prototype.showEmailTab = function (event) {
        var _this = this;
        event.preventDefault();
        this.isEmailShow = this.isEmailCopy;
        setTimeout(function (_) { return _this.wizardComponent.nextTab(false); }, 100);
    };
    EmailTabsV2Component.prototype.setEmailToCustomer = function () {
        this.order.Customer.Email = this.currentEmail;
    };
    EmailTabsV2Component.prototype.setPhoneToCustomer = function () {
        this.order.Customer.Phone = this.currentPhone;
        this.order.Customer.FirstName = this.currentName;
    };
    EmailTabsV2Component.prototype.hnadleDisableContinueButton = function () {
        var _this = this;
        setTimeout(function (_) {
            if (!_this.currentEmail || !_this.emailFormRef.valid)
                _this.wizardComponent.activeTab.isNextButtonDisabled = true;
            else
                _this.wizardComponent.activeTab.isNextButtonDisabled = false;
        }, 25);
    };
    EmailTabsV2Component.prototype.getEmailCopy = function (value, isEmailCopy) {
        this.isEmailCopy = this.calculatorHelper.getButtonValue(value, isEmailCopy);
        this.isNeedSendEmail.emit(this.isEmailCopy);
        this.detectChanges.detectChanges();
    };
    EmailTabsV2Component.ctorParameters = function () { return [{ type: core_es5["ChangeDetectorRef"] }, { type: google_tag_service["a" /* GoogleTagService */] }]; };
    return EmailTabsV2Component;
}());

//# sourceMappingURL=email-tab-v2.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/public/mobile/email-tab/email-tab-v2.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */











var styles_EmailTabsV2Component = [];
var RenderType_EmailTabsV2Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_EmailTabsV2Component, data: {} });
function View_EmailTabsV2Component_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Phone is required']))], null, null);
}
function View_EmailTabsV2Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 12, 'form-input', [['class', 'btn bold'], ['id', 'nameInput'], ['name', 'nameInput'], ['placeholder',
                'Type name here'], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentName = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['nameInput', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'],
            form: [2, 'form'], placeholder: [3, 'placeholder'], isPlaceholderNeed: [4, 'isPlaceholderNeed'],
            autofocus: [5, 'autofocus'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_EmailTabsV2Component_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_8 = _co.communicationSwitcher;
        _ck(_v, 1, 0, currVal_8);
        var currVal_9 = 'text';
        var currVal_10 = 'nameInput';
        var currVal_11 = core_es5["ɵnov"](_v.parent, 81);
        var currVal_12 = 'Type name here';
        var currVal_13 = true;
        var currVal_14 = true;
        _ck(_v, 3, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_15 = 'nameInput';
        var currVal_16 = _co.currentName;
        _ck(_v, 5, 0, currVal_15, currVal_16);
        var currVal_17 = (core_es5["ɵnov"](_v, 3).model.hasError('required') && !core_es5["ɵnov"](_v, 3).model.pristine);
        _ck(_v, 11, 0, currVal_17);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 1).required ? '' : null);
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
    });
}
function View_EmailTabsV2Component_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Phone is required']))], null, null);
}
function View_EmailTabsV2Component_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 12, 'form-input', [['class', 'btn bold'], ['id', 'phoneInput'], ['name', 'phoneInput'], ['placeholder',
                'Phone number'], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentPhone = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['phoneInput', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'],
            form: [2, 'form'], placeholder: [3, 'placeholder'], isPlaceholderNeed: [4, 'isPlaceholderNeed'],
            autofocus: [5, 'autofocus'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_EmailTabsV2Component_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_8 = _co.communicationSwitcher;
        _ck(_v, 1, 0, currVal_8);
        var currVal_9 = 'text';
        var currVal_10 = 'phoneInput';
        var currVal_11 = core_es5["ɵnov"](_v.parent, 81);
        var currVal_12 = 'Phone number';
        var currVal_13 = true;
        var currVal_14 = true;
        _ck(_v, 3, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_15 = 'phoneInput';
        var currVal_16 = _co.currentPhone;
        _ck(_v, 5, 0, currVal_15, currVal_16);
        var currVal_17 = (core_es5["ɵnov"](_v, 3).model.hasError('required') && !core_es5["ɵnov"](_v, 3).model.pristine);
        _ck(_v, 11, 0, currVal_17);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 1).required ? '' : null);
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
    });
}
function View_EmailTabsV2Component_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Email is invalid']))], null, null);
}
function View_EmailTabsV2Component_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Email is required']))], null, null);
}
function View_EmailTabsV2Component_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 16, 'form-input', [['class', 'btn bold'], ['id', 'emailInput'], ['name', 'emailInput'], ['pattern', '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'],
            ['placeholder', 'Type here'], ['type', 'text']], [[1, 'required', 0], [1, 'pattern',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = (_co.hnadleDisableContinueButton() !== false);
                ad = (pd_0 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_1 = ((_co.currentEmail = $event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['emailInput',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], form: [2, 'form'], placeholder: [3, 'placeholder'],
            isPlaceholderNeed: [4, 'isPlaceholderNeed'], autofocus: [5, 'autofocus'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0,
                'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_EmailTabsV2Component_6)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_EmailTabsV2Component_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_9 = !_co.communicationSwitcher;
        _ck(_v, 1, 0, currVal_9);
        var currVal_10 = '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
        _ck(_v, 2, 0, currVal_10);
        var currVal_11 = 'text';
        var currVal_12 = 'emailInput';
        var currVal_13 = core_es5["ɵnov"](_v.parent, 81);
        var currVal_14 = 'Type here';
        var currVal_15 = true;
        var currVal_16 = true;
        _ck(_v, 4, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16);
        var currVal_17 = 'emailInput';
        var currVal_18 = _co.currentEmail;
        _ck(_v, 6, 0, currVal_17, currVal_18);
        var currVal_19 = (core_es5["ɵnov"](_v, 4).model.hasError('pattern') && !core_es5["ɵnov"](_v, 4).model.pristine);
        _ck(_v, 12, 0, currVal_19);
        var currVal_20 = (core_es5["ɵnov"](_v, 4).model.hasError('required') && !core_es5["ɵnov"](_v, 4).model.pristine);
        _ck(_v, 15, 0, currVal_20);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 1).required ? '' : null);
        var currVal_1 = (core_es5["ɵnov"](_v, 2).pattern ? core_es5["ɵnov"](_v, 2).pattern : null);
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    });
}
function View_EmailTabsV2Component_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { emailFormRef: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 32, 'tab', [['nextButton', 'Continue'], ['previousButton', 'back']], [[2, 'active', null], [2, 'tab-pane', null]], [[null, 'onContinueClicked'],
            [null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onContinueClicked' === en)) {
                _co.showEmailTab($event);
                var pd_0 = (_co.focusInput(12) !== false);
                ad = (pd_0 && ad);
            }
            if (('isSelect' === en)) {
                _co.onTabSelected.emit({ pageTitle: 'Would you like us to send you a copy of the quote?',
                    pageOrder: 120 });
                var pd_1 = (_co.googleTagService.pushData('email_question') !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { previousButton: [0, 'previousButton'], isNextButtonDisabled: [1,
                'isNextButtonDisabled'], buttonTemplate: [2, 'buttonTemplate'], nextButton: [3,
                'nextButton'], index: [4, 'index'] }, { isSelect: 'isSelect', onContinueClicked: 'onContinueClicked' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', 'We won\'t ever share your email with anyone else.'],
            ['title', 'Would you like us to send you a copy of the quote?']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)),
        core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1, 'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class',
                'row no-gutter']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-xs-12 col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'buttons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-2 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.getEmailCopy(true, _co.isEmailCopy) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Yes '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-xs-12 col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'buttons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn size-2 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.getEmailCopy(false, _co.isEmailCopy) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' No '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 32, 'tab', [['nextButton', 'Continue'],
            ['previousButton', 'back']], [[2, 'active', null], [2, 'tab-pane', null]], [[null, 'onContinueClicked'], [null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onContinueClicked' === en)) {
                var pd_0 = (_co.focusInput(13) !== false);
                ad = (pd_0 && ad);
            }
            if (('isSelect' === en)) {
                var pd_1 = (_co.onTabSelected.emit({ pageTitle: 'What is your preferred communication method?',
                    pageOrder: 130 }) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { previousButton: [0, 'previousButton'], isNextButtonDisabled: [1,
                'isNextButtonDisabled'], buttonTemplate: [2, 'buttonTemplate'], nextButton: [3,
                'nextButton'], index: [4, 'index'] }, { isSelect: 'isSelect', onContinueClicked: 'onContinueClicked' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', 'Tap or click on the word below to choose, then enter your information.'],
            ['title', 'What is your preferred communication method?']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)),
        core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1, 'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class',
                'row no-gutter']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-xs-12 col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'buttons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-2 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.toggleSwitcher() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Phone '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-xs-12 col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'buttons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn size-2 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.toggleSwitcher() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' Email '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 27, 'tab', [['nextButton', 'Continue'],
            ['previousButton', 'back']], [[2, 'active', null], [2, 'tab-pane', null]], [[null, 'onContinueClicked'], [null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onContinueClicked' === en)) {
                _co.setEmailToCustomer();
                _co.setPhoneToCustomer();
                var pd_0 = (_co.focusInput(14) !== false);
                ad = (pd_0 && ad);
            }
            if (('isSelect' === en)) {
                _co.onTabSelected.emit({ pageTitle: 'Enter your information or email',
                    pageOrder: 140 });
                var pd_1 = (_co.googleTagService.pushData('email') !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { previousButton: [0, 'previousButton'], isNextButtonDisabled: [1,
                'isNextButtonDisabled'], buttonTemplate: [2, 'buttonTemplate'], nextButton: [3,
                'nextButton'], index: [4, 'index'] }, { isSelect: 'isSelect', onContinueClicked: 'onContinueClicked' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', '']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)),
        core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1, 'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'buttons new-input-wrapper bg-brand-prymary display-flex justify-content-center align-items-center flex-row col-sm-8 col-sm-offset-2 col-md-12 col-md-offset-0 height-size-2']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'form', [['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 81).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 81).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[1, 4], ['emailForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EmailTabsV2Component_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EmailTabsV2Component_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EmailTabsV2Component_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = 'back';
        var currVal_3 = (_co.isEmailCopy == null);
        var currVal_4 = _co.wizardFooterTemplate;
        var currVal_5 = 'Continue';
        var currVal_6 = 11;
        _ck(_v, 2, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = 'Would you like us to send you a copy of the quote?';
        var currVal_8 = 'We won\'t ever share your email with anyone else.';
        _ck(_v, 5, 0, currVal_7, currVal_8);
        var currVal_9 = 'btn size-2 bold';
        var currVal_10 = _ck(_v, 15, 0, (_co.isEmailCopy == true));
        _ck(_v, 14, 0, currVal_9, currVal_10);
        var currVal_11 = 'btn size-2 bold';
        var currVal_12 = _ck(_v, 27, 0, (_co.isEmailCopy == false));
        _ck(_v, 26, 0, currVal_11, currVal_12);
        var currVal_15 = 'back';
        var currVal_16 = false;
        var currVal_17 = _co.wizardFooterTemplate;
        var currVal_18 = 'Continue';
        var currVal_19 = (_co.isEmailCopy ? 12 : (0 - 1));
        _ck(_v, 36, 0, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19);
        var currVal_20 = 'What is your preferred communication method?';
        var currVal_21 = 'Tap or click on the word below to choose, then enter your information.';
        _ck(_v, 39, 0, currVal_20, currVal_21);
        var currVal_22 = 'btn size-2 bold';
        var currVal_23 = _ck(_v, 49, 0, _co.communicationSwitcher);
        _ck(_v, 48, 0, currVal_22, currVal_23);
        var currVal_24 = 'btn size-2 bold';
        var currVal_25 = _ck(_v, 61, 0, !_co.communicationSwitcher);
        _ck(_v, 60, 0, currVal_24, currVal_25);
        var currVal_28 = 'back';
        var currVal_29 = !core_es5["ɵnov"](_v, 81).valid;
        var currVal_30 = _co.wizardFooterTemplate;
        var currVal_31 = 'Continue';
        var currVal_32 = (_co.isEmailCopy ? 13 : (0 - 1));
        _ck(_v, 70, 0, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32);
        var currVal_33 = core_es5["ɵinlineInterpolate"](1, '', (_co.communicationSwitcher ? 'Enter your information' : 'Enter your email'), '');
        var currVal_34 = '';
        _ck(_v, 73, 0, currVal_33, currVal_34);
        var currVal_42 = _co.communicationSwitcher;
        _ck(_v, 86, 0, currVal_42);
        var currVal_43 = _co.communicationSwitcher;
        _ck(_v, 89, 0, currVal_43);
        var currVal_44 = !_co.communicationSwitcher;
        _ck(_v, 92, 0, currVal_44);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 2).active;
        var currVal_1 = core_es5["ɵnov"](_v, 2).addClass;
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_13 = core_es5["ɵnov"](_v, 36).active;
        var currVal_14 = core_es5["ɵnov"](_v, 36).addClass;
        _ck(_v, 35, 0, currVal_13, currVal_14);
        var currVal_26 = core_es5["ɵnov"](_v, 70).active;
        var currVal_27 = core_es5["ɵnov"](_v, 70).addClass;
        _ck(_v, 69, 0, currVal_26, currVal_27);
        var currVal_35 = core_es5["ɵnov"](_v, 83).ngClassUntouched;
        var currVal_36 = core_es5["ɵnov"](_v, 83).ngClassTouched;
        var currVal_37 = core_es5["ɵnov"](_v, 83).ngClassPristine;
        var currVal_38 = core_es5["ɵnov"](_v, 83).ngClassDirty;
        var currVal_39 = core_es5["ɵnov"](_v, 83).ngClassValid;
        var currVal_40 = core_es5["ɵnov"](_v, 83).ngClassInvalid;
        var currVal_41 = core_es5["ɵnov"](_v, 83).ngClassPending;
        _ck(_v, 79, 0, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41);
    });
}
function View_EmailTabsV2Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'email-tabs-v2', [], null, null, null, View_EmailTabsV2Component_0, RenderType_EmailTabsV2Component)), core_es5["ɵdid"](49152, null, 0, email_tab_v2_component_EmailTabsV2Component, [core_es5["ChangeDetectorRef"], google_tag_service["a" /* GoogleTagService */]], null, null)], null, null);
}
var EmailTabsV2ComponentNgFactory = core_es5["ɵccf"]('email-tabs-v2', email_tab_v2_component_EmailTabsV2Component, View_EmailTabsV2Component_Host_0, { wizardComponent: 'wizardComponent',
    order: 'order', wizardFooterTemplate: 'wizardFooterTemplate', focusInput: 'focusInput' }, { isNeedSendEmail: 'isNeedSendEmail', onTabSelected: 'onTabSelected' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=email-tab-v2.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/calculator/public/mobile/carrying/how-carrying.component.ts



var how_carrying_component_HowCarryingComponent = /** @class */ (function () {
    function HowCarryingComponent(googleTagService) {
        this.googleTagService = googleTagService;
        this.onTabSelected = new core_es5["EventEmitter"]();
        this.isWhoShippingTabNeed = false;
        this.orderOptions = orderOptions["a" /* OrderOptions */];
        this.showCarryingTrackOption = true;
        this.showCarryingAirOption = true;
        this.showCarryingOceanOption = true;
        this.showShippingTab = true;
    }
    HowCarryingComponent.prototype.setHowHipping = function (value) {
        if (this.howShipping == value) {
            this.howShipping = null;
            return;
        }
        this.howShipping = value;
    };
    HowCarryingComponent.prototype.showCarryingOptions = function () {
        var _this = this;
        var shipToLoc = this.order.Locations.find(function (x) { return x.Type == 2; });
        var shipFromLoc = this.order.Customer.Location.Country;
        if (shipFromLoc == "United States" && shipToLoc.Country == "Canada" || shipFromLoc == "Canada" && shipToLoc.Country == "United States") {
            this.showShippingTab = false;
            this.googleTagService.pushData('how-carrying');
            this.setHowHipping(1);
            this.setCarryingType();
        }
        else {
            this.showCarryingTrackOption = false;
            this.showCarryingAirOption = true;
            this.showCarryingOceanOption = true;
        }
        if (this.showShippingTab) {
            setTimeout(function (_) { return _this.wizardComponent.nextTab(false); }, 0);
        }
    };
    HowCarryingComponent.prototype.setCarryingType = function () {
        var _this = this;
        this.order.CarryingType = this.howShipping;
        if (!this.order.Flag)
            this.order.Flag = orderOptions["a" /* OrderOptions */].None;
        if (this.order.CarryingType == 1) {
            this.isWhoShippingTabNeed = true;
        }
        else {
            this.isWhoShippingTabNeed = false;
        }
        if (this.howShipping == 3) {
            this.order.Flag |= orderOptions["a" /* OrderOptions */].IsOcean;
        }
        else {
            this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsOcean;
        }
        setTimeout(function (_) { return _this.wizardComponent.nextTab(false); }, 0);
    };
    HowCarryingComponent.prototype.showShippingTypeTab = function () {
        this.showShippingTab = true;
        this.isWhoShippingTabNeed = false;
        this.howShipping = null;
    };
    HowCarryingComponent.ctorParameters = function () { return [{ type: google_tag_service["a" /* GoogleTagService */] }]; };
    return HowCarryingComponent;
}());

//# sourceMappingURL=how-carrying.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/public/mobile/carrying/how-carrying.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_HowCarryingComponent = [];
var RenderType_HowCarryingComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_HowCarryingComponent, data: {} });
function View_HowCarryingComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setHowHipping(1) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0, 'size-1': 1, 'size-2': 2 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Truck ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'btn bold';
        var currVal_1 = _ck(_v, 2, 0, (_co.howShipping == 1), _co.showCarryingTrackOption, !_co.showCarryingTrackOption);
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_HowCarryingComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class',
                'col-xs-12']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'col-md-4': 0, 'col-md-6': 1 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'buttons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_HowCarryingComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'col-xs-12';
        var currVal_1 = _ck(_v, 2, 0, _co.showCarryingTrackOption, !_co.showCarryingTrackOption);
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_2 = _co.showCarryingTrackOption;
        _ck(_v, 7, 0, currVal_2);
    }, null);
}
function View_HowCarryingComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setHowHipping(2) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0, 'size-1': 1, 'size-2': 2 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Air ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'btn bold';
        var currVal_1 = _ck(_v, 2, 0, (_co.howShipping == 2), _co.showCarryingTrackOption, !_co.showCarryingTrackOption);
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_HowCarryingComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setHowHipping(3) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0, 'size-1': 1, 'size-2': 2 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Ocean ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'btn bold';
        var currVal_1 = _ck(_v, 2, 0, (_co.howShipping == 3), _co.showCarryingTrackOption, !_co.showCarryingTrackOption);
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_HowCarryingComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 33, 'tab', [['previousButton',
                'back']], [[2, 'active', null], [2, 'tab-pane', null]], [[null,
                'onContinueClicked'], [null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onContinueClicked' === en)) {
                _co.setCarryingType();
                $event.preventDefault();
                var pd_0 = (_co.focusInput() !== false);
                ad = (pd_0 && ad);
            }
            if (('isSelect' === en)) {
                _co.onTabSelected.emit({ pageTitle: 'How are you shipping?', pageOrder: 160 });
                var pd_1 = (_co.googleTagService.pushData('how-carrying') !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */],
            core_es5["ElementRef"]], { previousButton: [0, 'previousButton'], isNextButtonDisabled: [1,
                'isNextButtonDisabled'], buttonTemplate: [2, 'buttonTemplate'], nextButton: [3, 'nextButton'],
            index: [4, 'index'] }, { isSelect: 'isSelect', onContinueClicked: 'onContinueClicked' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', ''], ['title', 'How are you shipping?']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)), core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1,
                'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 26, 'div', [['class', 'row no-gutter']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_HowCarryingComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'col-md-4': 0,
            'col-md-6': 1 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'buttons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_HowCarryingComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class',
                'col-xs-12']], null, null, null, null, null)),
        core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"]({ 'col-md-4': 0, 'col-md-6': 1 }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'buttons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_HowCarryingComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = 'back';
        var currVal_3 = !_co.howShipping;
        var currVal_4 = _co.wizardFooterTemplate;
        var currVal_5 = 'Continue';
        var currVal_6 = (_co.showShippingTab ? 15 : (0 - 1));
        _ck(_v, 1, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = 'How are you shipping?';
        var currVal_8 = '';
        _ck(_v, 4, 0, currVal_7, currVal_8);
        var currVal_9 = _co.showCarryingTrackOption;
        _ck(_v, 9, 0, currVal_9);
        var currVal_10 = 'col-xs-12';
        var currVal_11 = _ck(_v, 13, 0, _co.showCarryingTrackOption, !_co.showCarryingTrackOption);
        _ck(_v, 12, 0, currVal_10, currVal_11);
        var currVal_12 = _co.showCarryingAirOption;
        _ck(_v, 18, 0, currVal_12);
        var currVal_13 = 'col-xs-12';
        var currVal_14 = _ck(_v, 24, 0, _co.showCarryingTrackOption, !_co.showCarryingTrackOption);
        _ck(_v, 23, 0, currVal_13, currVal_14);
        var currVal_15 = _co.showCarryingOceanOption;
        _ck(_v, 29, 0, currVal_15);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 1).active;
        var currVal_1 = core_es5["ɵnov"](_v, 1).addClass;
        _ck(_v, 0, 0, currVal_0, currVal_1);
    });
}
function View_HowCarryingComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'how-carrying', [], null, null, null, View_HowCarryingComponent_0, RenderType_HowCarryingComponent)), core_es5["ɵdid"](49152, null, 0, how_carrying_component_HowCarryingComponent, [google_tag_service["a" /* GoogleTagService */]], null, null)], null, null);
}
var HowCarryingComponentNgFactory = core_es5["ɵccf"]('how-carrying', how_carrying_component_HowCarryingComponent, View_HowCarryingComponent_Host_0, { wizardComponent: 'wizardComponent',
    order: 'order', wizardFooterTemplate: 'wizardFooterTemplate', focusInput: 'focusInput' }, { onTabSelected: 'onTabSelected' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=how-carrying.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/calculator/public/mobile/result-tab/canadian/canadian-results-v2.component.ts





var canadian_results_v2_component_CanadianResultsV2Component = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](CanadianResultsV2Component, _super);
    function CanadianResultsV2Component(taxService) {
        var _this = _super.call(this) || this;
        _this.taxService = taxService;
        _this.showHst = false;
        _this.showQst = false;
        _this.OrderOptions = orderOptions["a" /* OrderOptions */];
        _this.calculatorHelper = calculatorHelper["a" /* CalculatorHelper */];
        return _this;
    }
    Object.defineProperty(CanadianResultsV2Component.prototype, "currency", {
        get: function () {
            return calculatorHelper["a" /* CalculatorHelper */].getCurrencyName(this.order);
        },
        enumerable: true,
        configurable: true
    });
    CanadianResultsV2Component.prototype.ngOnInit = function () {
        this.setHQst();
    };
    CanadianResultsV2Component.prototype.setHQst = function () {
        var isHQst = calculatorHelper["a" /* CalculatorHelper */].isHQst(this.order);
        if (isHQst == null)
            return;
        if (isHQst == true)
            this.showHst = true;
        if (isHQst == false)
            this.showQst = true;
    };
    CanadianResultsV2Component.ctorParameters = function () { return [{ type: tax_service["a" /* TaxService */] }]; };
    return CanadianResultsV2Component;
}(baseCalculatorTab_BaseCalculatorTab));

//# sourceMappingURL=canadian-results-v2.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/public/mobile/result-tab/canadian/canadian-results-v2.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_CanadianResultsV2Component = [];
var RenderType_CanadianResultsV2Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CanadianResultsV2Component, data: {} });
function View_CanadianResultsV2Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2, 'isBigRow'],
            currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Internal Transaction Number (ITN)';
        var currVal_1 = _co.findTax(_co.taxType.ITN, _co.orderItem).Value;
        var currVal_2 = true;
        var currVal_3 = _co.getCurrency(_co.currency);
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_CanadianResultsV2Component_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2, 'isBigRow'],
            currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Vehicle Inspection Fee';
        var currVal_1 = _co.findTax(_co.taxType.RIV, _co.orderItem).Value;
        var currVal_2 = true;
        var currVal_3 = _co.getCurrency(_co.currency);
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_CanadianResultsV2Component_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2, 'isBigRow'],
            currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'AC';
        var currVal_1 = _co.findTax(_co.taxType.AC, _co.orderItem).Value;
        var currVal_2 = true;
        var currVal_3 = _co.getCurrency(_co.currency);
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_CanadianResultsV2Component_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2, 'isBigRow'],
            currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Form 1';
        var currVal_1 = _co.findTax(_co.taxType.FormOne, _co.orderItem).Value;
        var currVal_2 = true;
        var currVal_3 = _co.getCurrency(_co.currency);
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_CanadianResultsV2Component_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2, 'isBigRow'],
            currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Agent Port Fee';
        var currVal_1 = _co.findTax(_co.taxType.AgentPortFee, _co.orderItem).Value;
        var currVal_2 = true;
        var currVal_3 = _co.getCurrency(_co.currency);
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_CanadianResultsV2Component_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2, 'isBigRow'],
            currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Soil Exam Fee';
        var currVal_1 = _co.findTax(_co.taxType.SoilExamFee, _co.orderItem).Value;
        var currVal_2 = true;
        var currVal_3 = _co.getCurrency(_co.currency);
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_CanadianResultsV2Component_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ('Customs ' + (_co.showQst ? 'Taxes' : 'Taxes'));
        var currVal_1 = _co.findTax(_co.taxType.CustomPST, _co.orderItem).Percentage;
        var currVal_2 = _co.findTax(_co.taxType.CustomPST, _co.orderItem).Value;
        var currVal_3 = _co.getCurrency(_co.currency);
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_CanadianResultsV2Component_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Customs Taxes']], null, [['document',
                'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianResultsV2Component_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Customs Taxes';
        var currVal_1 = _co.findTax(_co.taxType.CustomGST, _co.orderItem).Percentage;
        var currVal_2 = _co.findTax(_co.taxType.CustomGST, _co.orderItem).Value;
        var currVal_3 = _co.getCurrency(_co.currency);
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3);
        var currVal_4 = (!_co.order.Flag.hasFlag(_co.OrderOptions.IsVehicle) || _co.order.IsCommercial);
        _ck(_v, 6, 0, currVal_4);
    }, null);
}
function View_CanadianResultsV2Component_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 6, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'calc-info-row', [['title', 'Customs Taxes']], null, [['document',
                'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], currency: [3, 'currency'] }, null), core_es5["ɵpad"](2), core_es5["ɵpad"](2),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Customs Taxes';
        var currVal_1 = _co.findTaxesPersentSum(_co.orderItem, _ck(_v, 4, 0, _co.taxType.CustomGST, _co.taxType.CustomPST));
        var currVal_2 = _co.findTaxesSum(_co.orderItem, _ck(_v, 5, 0, _co.taxType.CustomGST, _co.taxType.CustomPST));
        var currVal_3 = _co.getCurrency(_co.currency);
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_CanadianResultsV2Component_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 9, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['title', 'Customs Clearance Taxes']], null, [['document',
                'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [], null, [['document',
                'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 7).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Customs Clearance Taxes';
        var currVal_1 = _co.findTax(_co.taxType.AAFeeGST, _co.orderItem).Percentage;
        var currVal_2 = _co.findTax(_co.taxType.AAFeeGST, _co.orderItem).Value;
        var currVal_3 = _co.getCurrency(_co.currency);
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3);
        var currVal_4 = ('Customs Clearance ' + (_co.showQst ? 'Taxes' : 'Taxes'));
        var currVal_5 = _co.findTax(_co.taxType.AAFeePST, _co.orderItem).Percentage;
        var currVal_6 = _co.findTax(_co.taxType.AAFeePST, _co.orderItem).Value;
        var currVal_7 = _co.getCurrency(_co.currency);
        _ck(_v, 7, 0, currVal_4, currVal_5, currVal_6, currVal_7);
    }, null);
}
function View_CanadianResultsV2Component_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 6, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'calc-info-row', [['title', 'Customs Clearance Taxes']], null, [['document',
                'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], currency: [3, 'currency'] }, null), core_es5["ɵpad"](2), core_es5["ɵpad"](2),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Customs Clearance Taxes';
        var currVal_1 = _co.findTaxesPersentSum(_co.orderItem, _ck(_v, 4, 0, _co.taxType.AAFeeGST, _co.taxType.AAFeePST));
        var currVal_2 = _co.findTaxesSum(_co.orderItem, _ck(_v, 5, 0, _co.taxType.AAFeeGST, _co.taxType.AAFeePST));
        var currVal_3 = _co.getCurrency(_co.currency);
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_CanadianResultsV2Component_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2, 'isBigRow'],
            currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (('Administration Fee (' + _co.getCurrency(_co.currency)) + ')');
        var currVal_1 = _co.findTax(_co.taxType.AdminFee, _co.orderItem).Value;
        var currVal_2 = true;
        var currVal_3 = _co.getCurrency(_co.currency);
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3);
    }, null);
}
function View_CanadianResultsV2Component_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2, 'isBigRow'],
            currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'long-currency-text'], ['title', 'Exchange Rate']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 5).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], class: [2,
                'class'], isBigRow: [3, 'isBigRow'], currencyExchange: [4, 'currencyExchange'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['title', 'Value for Customs']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 9).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianResultsV2Component_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianResultsV2Component_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianResultsV2Component_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianResultsV2Component_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianResultsV2Component_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianResultsV2Component_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['title', 'Customs Duties']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 31).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, ['> '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianResultsV2Component_7)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianResultsV2Component_9)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['title', 'Customs Clearance']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 41).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianResultsV2Component_10)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianResultsV2Component_11)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CanadianResultsV2Component_12)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'border-0 margin-bottom-10 bold']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 54).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], class: [2,
                'class'], isBigRow: [3, 'isBigRow'], currency: [4, 'currency'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (('Value (' + _co.orderItem.CanadianCurrencyCode.Name) + ')');
        var currVal_1 = _co.orderItem.Price;
        var currVal_2 = true;
        var currVal_3 = _co.getCurrency(_co.orderItem.CanadianCurrencyCode.Name);
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3);
        var currVal_4 = 'Exchange Rate';
        var currVal_5 = _co.getCurrencyRate(_co.orderItem.CanadianCurrencyCode, _co.order.Currency);
        var currVal_6 = 'long-currency-text';
        var currVal_7 = true;
        var currVal_8 = ((_co.getCurrency(_co.orderItem.CanadianCurrencyCode.Name) + '/') + _co.getCurrency(_co.currency));
        _ck(_v, 5, 0, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
        var currVal_9 = 'Value for Customs';
        var currVal_10 = _co.getCadValue(_co.orderItem.Price, _co.orderItem.CanadianCurrencyCode, _co.order.Currency);
        var currVal_11 = true;
        var currVal_12 = _co.getCurrency(_co.currency);
        _ck(_v, 9, 0, currVal_9, currVal_10, currVal_11, currVal_12);
        var currVal_13 = _co.calculatorHelper.isCanadianVehicleCalculator(_co.order);
        _ck(_v, 13, 0, currVal_13);
        var currVal_14 = _co.calculatorHelper.isCanadianVehicleCalculator(_co.order);
        _ck(_v, 16, 0, currVal_14);
        var currVal_15 = _co.calculatorHelper.isCanadianVehicleCalculator(_co.order);
        _ck(_v, 19, 0, currVal_15);
        var currVal_16 = _co.calculatorHelper.isCanadianVehicleCalculator(_co.order);
        _ck(_v, 22, 0, currVal_16);
        var currVal_17 = _co.calculatorHelper.isCanadianVehicleCalculator(_co.order);
        _ck(_v, 25, 0, currVal_17);
        var currVal_18 = _co.calculatorHelper.isCanadianVehicleCalculator(_co.order);
        _ck(_v, 28, 0, currVal_18);
        var currVal_19 = 'Customs Duties';
        var currVal_20 = (_co.calculatorHelper.isMoreOrEqThanTwentyFive(_co.order, _co.orderItem) ? 'Free' : _co.calculatorHelper.getTariff(_co.orderItem, _co.order, _co.order.Flag.hasFlag(_co.OrderOptions.IsVehicle), _co.taxService.canadianHsCodesAlAndSteel10, _co.taxService.canadianHsCodesAlAndSteel25, _co.taxService.canadianHsCodesChina0, _co.taxService.usaHsCodesChina25));
        var currVal_21 = _co.findTax(_co.taxType.CustomDuty, _co.orderItem).Value;
        var currVal_22 = _co.getCurrency(_co.currency);
        _ck(_v, 31, 0, currVal_19, currVal_20, currVal_21, currVal_22);
        var currVal_23 = !_co.showHst;
        _ck(_v, 35, 0, currVal_23);
        var currVal_24 = _co.showHst;
        _ck(_v, 38, 0, currVal_24);
        var currVal_25 = 'Customs Clearance';
        var currVal_26 = _co.findTax(_co.taxType.AAFee, _co.orderItem).Value;
        var currVal_27 = true;
        var currVal_28 = _co.getCurrency(_co.currency);
        _ck(_v, 41, 0, currVal_25, currVal_26, currVal_27, currVal_28);
        var currVal_29 = !_co.showHst;
        _ck(_v, 45, 0, currVal_29);
        var currVal_30 = _co.showHst;
        _ck(_v, 48, 0, currVal_30);
        var currVal_31 = !_co.order.Flag.hasFlag(_co.OrderOptions.IsVehicle);
        _ck(_v, 51, 0, currVal_31);
        var currVal_32 = (('Grand Total Fees (' + _co.getCurrency(_co.currency)) + ')');
        var currVal_33 = _co.calculateGrantTotalForItem(_co.orderItem, _co.order);
        var currVal_34 = 'border-0 margin-bottom-10 bold';
        var currVal_35 = true;
        var currVal_36 = _co.getCurrency(_co.currency);
        _ck(_v, 54, 0, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36);
    }, null);
}
function View_CanadianResultsV2Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'canadian-results-v2', [], null, null, null, View_CanadianResultsV2Component_0, RenderType_CanadianResultsV2Component)), core_es5["ɵdid"](114688, null, 0, canadian_results_v2_component_CanadianResultsV2Component, [tax_service["a" /* TaxService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CanadianResultsV2ComponentNgFactory = core_es5["ɵccf"]('canadian-results-v2', canadian_results_v2_component_CanadianResultsV2Component, View_CanadianResultsV2Component_Host_0, { isPublic: 'isPublic',
    order: 'order', orderItem: 'orderItem' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=canadian-results-v2.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/calculator/public/mobile/result-tab/usa/usa-results-v2.component.ts



var usa_results_v2_component_USAResultsV2Component = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](USAResultsV2Component, _super);
    function USAResultsV2Component() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(USAResultsV2Component.prototype, "currency", {
        get: function () {
            return calculatorHelper["a" /* CalculatorHelper */].getCurrencyName(this.order);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(USAResultsV2Component.prototype, "isVehicle", {
        get: function () {
            return calculatorHelper["a" /* CalculatorHelper */].isVehicle(this.order);
        },
        enumerable: true,
        configurable: true
    });
    USAResultsV2Component.prototype.ngOnInit = function () {
    };
    return USAResultsV2Component;
}(baseCalculatorTab_BaseCalculatorTab));

//# sourceMappingURL=usa-results-v2.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/public/mobile/result-tab/usa/usa-results-v2.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_USAResultsV2Component = [];
var RenderType_USAResultsV2Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_USAResultsV2Component, data: {} });
function View_USAResultsV2Component_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2, 'isBigRow'],
            currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Value for Customs']], null, [['document',
                'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 5).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['class', 'long-currency-text'], ['title', 'Exchange Rate']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 8).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], class: [2,
                'class'], isBigRow: [3, 'isBigRow'], currencyExchange: [4, 'currencyExchange'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Customs Duties']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 11).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], percent: [1, 'percent'], value: [2,
                'value'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['title', 'Customs MPF']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 14).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['title', 'Customs HMF']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 18).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Entry Fee']], null, [['document',
                'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 22).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Classification Fee']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 25).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Bond']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 28).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Bond Underwriting Fee']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 31).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Customs ISF']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 34).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Duty Disbursement Fee']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 37).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'NAFTA']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 40).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'ABI Fee']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 43).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'DOT/EPA']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 46).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'Importer Registration Fee']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 49).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'One time PAPS Exemption']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 52).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'calc-info-row', [['title', 'E-Manifest']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 55).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 58).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], isBigRow: [2,
                'isBigRow'], currency: [3, 'currency'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'calc-info-row', [['class', 'border-0 margin-bottom-10 bold']], null, [['document', 'mousedown']], function (_v, en, $event) {
            var ad = true;
            if (('document:mousedown' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 62).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CalcInfoRowComponent_0, RenderType_CalcInfoRowComponent)), core_es5["ɵdid"](114688, null, 0, calcInfoRow_component_CalcInfoRowComponent, [calculator_calculatorService["a" /* CalculatorService */], services_orderService["a" /* OrderService */],
            core_es5["ChangeDetectorRef"]], { title: [0, 'title'], value: [1, 'value'], class: [2,
                'class'], isBigRow: [3, 'isBigRow'], currency: [4, 'currency'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (('Value (' + _co.orderItem.CanadianCurrencyCode.Name) + ')');
        var currVal_1 = _co.orderItem.Price;
        var currVal_2 = true;
        var currVal_3 = _co.getCurrency(_co.orderItem.CanadianCurrencyCode.Name);
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3);
        var currVal_4 = 'Value for Customs';
        var currVal_5 = _co.getCadValue(_co.orderItem.Price, _co.orderItem.CanadianCurrencyCode, _co.order.Currency);
        var currVal_6 = true;
        var currVal_7 = _co.getCurrency(_co.currency);
        _ck(_v, 5, 0, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_8 = 'Exchange Rate';
        var currVal_9 = _co.getCurrencyRate(_co.orderItem.CanadianCurrencyCode, _co.order.Currency);
        var currVal_10 = 'long-currency-text';
        var currVal_11 = true;
        var currVal_12 = ((_co.getCurrency(_co.orderItem.CanadianCurrencyCode.Name) + '/') + _co.getCurrency(_co.currency));
        _ck(_v, 8, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12);
        var currVal_13 = 'Customs Duties';
        var currVal_14 = _co.calculatorHelper.getTariff(_co.orderItem, _co.order, _co.isVehicle);
        var currVal_15 = _co.findTax(_co.taxType.CustomDuty, _co.orderItem).Value;
        var currVal_16 = _co.getCurrency(_co.currency);
        _ck(_v, 11, 0, currVal_13, currVal_14, currVal_15, currVal_16);
        var currVal_17 = 'Customs MPF';
        var currVal_18 = _co.findTax(_co.taxType.CustomMPF, _co.orderItem).Value;
        var currVal_19 = true;
        var currVal_20 = _co.getCurrency(_co.currency);
        _ck(_v, 14, 0, currVal_17, currVal_18, currVal_19, currVal_20);
        var currVal_21 = 'Customs HMF';
        var currVal_22 = _co.findTax(_co.taxType.CustomHMF, _co.orderItem).Value;
        var currVal_23 = true;
        var currVal_24 = _co.getCurrency(_co.currency);
        _ck(_v, 18, 0, currVal_21, currVal_22, currVal_23, currVal_24);
        var currVal_25 = 'Entry Fee';
        var currVal_26 = _co.findTax(_co.taxType.AAFee, _co.orderItem).Value;
        var currVal_27 = true;
        var currVal_28 = _co.getCurrency(_co.currency);
        _ck(_v, 22, 0, currVal_25, currVal_26, currVal_27, currVal_28);
        var currVal_29 = 'Classification Fee';
        var currVal_30 = _co.findTax(_co.taxType.ClassificationFee, _co.orderItem).Value;
        var currVal_31 = true;
        var currVal_32 = _co.getCurrency(_co.currency);
        _ck(_v, 25, 0, currVal_29, currVal_30, currVal_31, currVal_32);
        var currVal_33 = 'Bond';
        var currVal_34 = _co.findTax(_co.taxType.Bond, _co.orderItem).Value;
        var currVal_35 = true;
        var currVal_36 = _co.getCurrency(_co.currency);
        _ck(_v, 28, 0, currVal_33, currVal_34, currVal_35, currVal_36);
        var currVal_37 = 'Bond Underwriting Fee';
        var currVal_38 = _co.findTax(_co.taxType.BondUnderFee, _co.orderItem).Value;
        var currVal_39 = true;
        var currVal_40 = _co.getCurrency(_co.currency);
        _ck(_v, 31, 0, currVal_37, currVal_38, currVal_39, currVal_40);
        var currVal_41 = 'Customs ISF';
        var currVal_42 = _co.findTax(_co.taxType.CustomISF, _co.orderItem).Value;
        var currVal_43 = true;
        var currVal_44 = _co.getCurrency(_co.currency);
        _ck(_v, 34, 0, currVal_41, currVal_42, currVal_43, currVal_44);
        var currVal_45 = 'Duty Disbursement Fee';
        var currVal_46 = _co.findTax(_co.taxType.DutyDistRate, _co.orderItem).Value;
        var currVal_47 = true;
        var currVal_48 = _co.getCurrency(_co.currency);
        _ck(_v, 37, 0, currVal_45, currVal_46, currVal_47, currVal_48);
        var currVal_49 = 'NAFTA';
        var currVal_50 = _co.findTax(_co.taxType.NAFTA, _co.orderItem).Value;
        var currVal_51 = true;
        var currVal_52 = _co.getCurrency(_co.currency);
        _ck(_v, 40, 0, currVal_49, currVal_50, currVal_51, currVal_52);
        var currVal_53 = 'ABI Fee';
        var currVal_54 = _co.findTax(_co.taxType.ABIFee, _co.orderItem).Value;
        var currVal_55 = true;
        var currVal_56 = _co.getCurrency(_co.currency);
        _ck(_v, 43, 0, currVal_53, currVal_54, currVal_55, currVal_56);
        var currVal_57 = 'DOT/EPA';
        var currVal_58 = _co.findTax(_co.taxType.FDA, _co.orderItem).Value;
        var currVal_59 = true;
        var currVal_60 = _co.getCurrency(_co.currency);
        _ck(_v, 46, 0, currVal_57, currVal_58, currVal_59, currVal_60);
        var currVal_61 = 'Importer Registration Fee';
        var currVal_62 = _co.findTax(_co.taxType.ImportRegisterFee, _co.orderItem).Value;
        var currVal_63 = true;
        var currVal_64 = _co.getCurrency(_co.currency);
        _ck(_v, 49, 0, currVal_61, currVal_62, currVal_63, currVal_64);
        var currVal_65 = 'One time PAPS Exemption';
        var currVal_66 = _co.findTax(_co.taxType.PAPSFee, _co.orderItem).Value;
        var currVal_67 = true;
        var currVal_68 = _co.getCurrency(_co.currency);
        _ck(_v, 52, 0, currVal_65, currVal_66, currVal_67, currVal_68);
        var currVal_69 = 'E-Manifest';
        var currVal_70 = _co.findTax(_co.taxType.EManifest, _co.orderItem).Value;
        var currVal_71 = true;
        var currVal_72 = _co.getCurrency(_co.currency);
        _ck(_v, 55, 0, currVal_69, currVal_70, currVal_71, currVal_72);
        var currVal_73 = (('Administration Fee (' + _co.getCurrency(_co.currency)) + ')');
        var currVal_74 = _co.findTax(_co.taxType.AdminFee, _co.orderItem).Value;
        var currVal_75 = true;
        var currVal_76 = _co.getCurrency(_co.currency);
        _ck(_v, 58, 0, currVal_73, currVal_74, currVal_75, currVal_76);
        var currVal_77 = (('Grand Total Fees (' + _co.getCurrency(_co.currency)) + ')');
        var currVal_78 = _co.calculateGrantTotalForItem(_co.orderItem, _co.order);
        var currVal_79 = 'border-0 margin-bottom-10 bold';
        var currVal_80 = true;
        var currVal_81 = _co.getCurrency(_co.currency);
        _ck(_v, 62, 0, currVal_77, currVal_78, currVal_79, currVal_80, currVal_81);
    }, null);
}
function View_USAResultsV2Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'usa-results-v2', [], null, null, null, View_USAResultsV2Component_0, RenderType_USAResultsV2Component)), core_es5["ɵdid"](114688, null, 0, usa_results_v2_component_USAResultsV2Component, [], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var USAResultsV2ComponentNgFactory = core_es5["ɵccf"]('usa-results-v2', usa_results_v2_component_USAResultsV2Component, View_USAResultsV2Component_Host_0, { isPublic: 'isPublic',
    order: 'order', orderItem: 'orderItem' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=usa-results-v2.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/objects/orders/PdaType.ts
var PdaType = __webpack_require__("xDjd");

// EXTERNAL MODULE: ./app/objects/tariffs/tariffSource.ts
var tariffSource = __webpack_require__("kxTq");

// CONCATENATED MODULE: ./app/components/calculator/public/mobile/result-tab/result-tab-v2.component.ts



















var result_tab_v2_component_ResultTabV2Component = /** @class */ (function () {
    function ResultTabV2Component(orderService, emailService, toastrService, googleTagService, taxService, router, config) {
        this.orderService = orderService;
        this.emailService = emailService;
        this.toastrService = toastrService;
        this.googleTagService = googleTagService;
        this.taxService = taxService;
        this.router = router;
        this.config = config;
        this.defaultProducts = [];
        this.canadianCurrencyCodes = [];
        this.marketingURL = null;
        this.getAnotherQuote = new core_es5["EventEmitter"]();
        this.isThanksTabShow = new core_es5["EventEmitter"]();
        this.isQuestionOrCallTabShow = new core_es5["EventEmitter"]();
        this.showEmailText = new core_es5["EventEmitter"]();
        this.createdOrder = new core_es5["EventEmitter"]();
        this.onTabSelected = new core_es5["EventEmitter"]();
        this.initialized = false;
        this.calculatorHelper = calculatorHelper["a" /* CalculatorHelper */];
        this.isEmailSending = false;
        this.isProcessing = false;
        this.isSendQuoteEmail = false;
    }
    Object.defineProperty(ResultTabV2Component.prototype, "isVehicle", {
        get: function () {
            return calculatorHelper["a" /* CalculatorHelper */].isVehicle(this.order);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResultTabV2Component.prototype, "currency", {
        get: function () {
            if (!this.order || !this.order.Currency)
                return 'CAD';
            return this.order.Currency.Name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResultTabV2Component.prototype, "isCanadianCalculator", {
        get: function () {
            return calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(this.order.Locations) == orders_calculatorType["a" /* CalculatorType */].CanadianImport;
        },
        enumerable: true,
        configurable: true
    });
    ResultTabV2Component.prototype.ngOnInit = function () {
        this.initialized = true;
        this.viewTypeEnum = screenHelper["a" /* ScreenHelper */].getViewType();
        this.viewType = users_viewType["a" /* ViewType */][this.viewTypeEnum];
    };
    ResultTabV2Component.prototype.ngAfterViewInit = function () {
        this.scrollBottom();
    };
    ResultTabV2Component.prototype.calculateOrder = function () {
        var _this = this;
        this.isProcessing = true;
        this.order.CalculatorType = calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(this.order.Locations);
        if (this.order.CalculatorType == orders_calculatorType["a" /* CalculatorType */].UsaImport) {
            this.order.Currency = this.canadianCurrencyCodes.find(function (x) { return x.Name == 'USD'; });
        }
        else {
            this.order.Currency = this.canadianCurrencyCodes.find(function (x) { return x.Name == 'CAD'; });
        }
        var lastHsNumber = this.isVehicle ? '99' : '98';
        var source = this.isCanadianCalculator ? tariffSource["a" /* TariffSource */].Canada : tariffSource["a" /* TariffSource */].Usa;
        this.orderItem.Product = this.defaultProducts.find(function (x) { return x.Source == source && x.HsCode == "9999.99.99." + lastHsNumber; });
        if (this.isVehicle && this.order.OrderItems.length > 0) {
            this.productName = null;
        }
        if (this.router.url.startsWith('/calculator2/public')) {
            this.order.Source = "Public Calculator";
        }
        this.orderItem.Product.Name = this.productName ? this.productName : this.orderItem.Product.Description;
        if (this.isVehicle) {
            if (this.isCanadianCalculator) {
                this.orderItem.Flags |= orderItemOptions["a" /* OrderItemOptions */].IsPassVehicle; // Always yes as in requirements
                this.orderItem.Flags |= orderItemOptions["a" /* OrderItemOptions */].IsVehicleParts; //RIV => use lesser amount as in requirements
            }
            else {
                this.orderItem.Type |= PdaType["a" /* PdaType */].DOT;
                this.orderItem.Type |= PdaType["a" /* PdaType */].EPA;
            } //Set static 40$ only for vehicle
        }
        calculatorHelper["a" /* CalculatorHelper */].getTariffs(this.orderItem.Product.Source, calculatorHelper["a" /* CalculatorHelper */].getTariff(this.orderItem, this.order, false, this.taxService.canadianHsCodesAlAndSteel10, this.taxService.canadianHsCodesAlAndSteel25, this.taxService.canadianHsCodesChina0, this.taxService.usaHsCodesChina25), this.orderItem);
        this.order.OrderItems = [this.orderItem];
        if (this.order.IsCommercial == null)
            this.order.IsCommercial = false;
        if (this.order.Flag && !this.order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsPulic))
            this.order.Flag |= orderOptions["a" /* OrderOptions */].IsPulic;
        if (!this.order.Flag)
            this.order.Flag = orderOptions["a" /* OrderOptions */].IsPulic;
        this.orderService.publicCreate(this.order, this.marketingURL, this.viewType).then(function (response) {
            _this.isProcessing = false;
            if (!response || !response.Data)
                throw new Error("Order was not created");
            _this.order = response.Data;
            _this.orderItem = _this.order.OrderItems[0];
            _this.order.CalculatorType = calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(_this.order.Locations);
            _this.scrollPanel();
            if (_this.order.Customer.Email && _this.isNeedSendEmail) {
                var emailRequest = (new EmailRequest({ OrderId: _this.order.Id, EmailType: emailTemplateType["a" /* EmailTemplateType */].OrderToCustomer, Comment: "" }));
                _this.emailService.sendOrderToCustomer(emailRequest);
                _this.toastrService.success("Sending mail succeeded");
            }
        }).catch(function (_) { return _this.isProcessing = false; });
    };
    ResultTabV2Component.prototype.getClass = function () {
        if (!this.initialized || !this.accordion)
            return "panel-default";
        if (this.accordion.isOpen)
            return "accordion-open";
        else
            return "";
    };
    ResultTabV2Component.prototype.sendEmail = function (event, action) {
        if (event != null)
            event.preventDefault();
        switch (action) {
            case ('goToGetAnotherQuote'): {
                this.getAnotherQuote.emit(true);
                break;
            }
            case ('goToThanksTab'): {
                //Continue Clicked then show last tab with email
                this.isQuestionOrCallTabShow.emit(false);
                this.isThanksTabShow.emit(true);
                this.moveToNextTab(false);
                break;
            }
            case ('goToGetStarted'): {
                this.goToGetStarted();
                break;
            }
            case ('sendEmailToCustomer'): {
                this.sendEmailToCustomer();
                break;
            }
        }
        this.createdOrder.emit(this.order);
        this.googleTagService.clearEventsArray();
    };
    ResultTabV2Component.prototype.sendEmailToCustomer = function () {
        var _this = this;
        if (this.currentEmail) {
            this.order.Customer.Email = this.currentEmail;
            this.isEmailSending = true;
            var emailRequest_1 = (new EmailRequest({ OrderId: this.order.Id, EmailType: emailTemplateType["a" /* EmailTemplateType */].OrderToCustomer, Comment: "" }));
            this.orderService.create(this.order, this.viewType).then(function (x) {
                _this.emailService.sendOrderToCustomer(emailRequest_1);
            });
            this.toastrService.success("Sending mail succeeded");
            this.googleTagService.pushData('quota', { 'event': 'formSubmitted', 'formName': 'Completed Quote Page - Email' });
            this.isEmailSending = false;
            this.isSendQuoteEmail = true;
            this.showEmailText.emit(true);
        }
    };
    ResultTabV2Component.prototype.goToGetStarted = function () {
        this.isQuestionOrCallTabShow.emit(true);
        this.isThanksTabShow.emit(false);
        this.moveToNextTab(false);
        //  // TEMP REMOVE FOR TEST BY TASK https://jira.ak-tech.org/browse/BB-2852
        // if (this.config.config.SelfServeAppUrl) {
        //     window.location.href = this.config.config.SelfServeAppUrl;
        // }
    };
    ResultTabV2Component.prototype.moveBack = function () {
        var _this = this;
        this.order.Id = null;
        this.orderItem.Id = null;
        this.createdOrder.emit(this.order);
        setTimeout(function (_) { return _this.wizard.previousTab(true); }, 0);
    };
    ResultTabV2Component.prototype.moveToNextTab = function (move) {
        var _this = this;
        setTimeout(function (_) { return _this.wizard.nextTab(move); }, 0);
    };
    ResultTabV2Component.prototype.scrollPanel = function () {
        var _this = this;
        setTimeout(function () {
            _this.scrollBottom();
            _this.addScroll();
        }, 150);
    };
    ResultTabV2Component.prototype.scrollBottom = function () {
        var el = this.mainElement.nativeElement.querySelector('.panel-body');
        if (el)
            try {
                el.scrollTop = el.scrollHeight;
            }
            catch (err) {
            }
    };
    ResultTabV2Component.prototype.addScroll = function () {
        var el = this.accordionRef.nativeElement.querySelector('.panel-body');
        perfect_scrollbar["initialize"](el);
    };
    ResultTabV2Component.ctorParameters = function () { return [{ type: services_orderService["a" /* OrderService */] }, { type: services_emailService["a" /* EmailService */] }, { type: ng2_toastr["ToastsManager"] }, { type: google_tag_service["a" /* GoogleTagService */] }, { type: tax_service["a" /* TaxService */] }, { type: router_es5["n" /* Router */] }, { type: services_configService["a" /* ConfigService */] }]; };
    return ResultTabV2Component;
}());

//# sourceMappingURL=result-tab-v2.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/public/mobile/result-tab/result-tab-v2.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
























var styles_ResultTabV2Component = [];
var RenderType_ResultTabV2Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ResultTabV2Component, data: {} });
function View_ResultTabV2Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'spinner']], null, null, null, null, null))], null, null);
}
function View_ResultTabV2Component_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'col-xs-12 col-md-6 quote-send d-sm-none']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Your quote has been sent ']))], null, null);
}
function View_ResultTabV2Component_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Email is invalid']))], null, null);
}
function View_ResultTabV2Component_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class',
                'col-xs-12 col-md-4 padding-right-md-0 margin-bottom-xs-0 d-sm-none']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'form', [['novalidate',
                '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null], [2,
                'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngSubmit'], [null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 4).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.sendEmail(null, 'sendEmailToCustomer') !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[3, 4], ['emailForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'form-input', [['class', 'btn bold form-email custom-from'], ['name', 'emailInputForm'],
            ['pattern', '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'],
            ['placeholder', 'Enter email to send to yourself'], ['type', 'text']], [[1,
                'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentEmail = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['emailInputForm', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], form: [2, 'form'], placeholder: [3, 'placeholder'], isPlaceholderNeed: [4,
                'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ResultTabV2Component_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_15 = '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
        _ck(_v, 9, 0, currVal_15);
        var currVal_16 = 'text';
        var currVal_17 = 'emailInputForm';
        var currVal_18 = core_es5["ɵnov"](_v, 4);
        var currVal_19 = 'Enter email to send to yourself';
        var currVal_20 = true;
        _ck(_v, 11, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20);
        var currVal_21 = 'emailInputForm';
        var currVal_22 = _co.currentEmail;
        _ck(_v, 13, 0, currVal_21, currVal_22);
        var currVal_23 = (core_es5["ɵnov"](_v, 11).model.hasError('pattern') && !core_es5["ɵnov"](_v, 11).model.pristine);
        _ck(_v, 19, 0, currVal_23);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 6).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 6).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 6).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 6).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 6).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 6).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 6).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (core_es5["ɵnov"](_v, 9).pattern ? core_es5["ɵnov"](_v, 9).pattern : null);
        var currVal_8 = core_es5["ɵnov"](_v, 15).ngClassUntouched;
        var currVal_9 = core_es5["ɵnov"](_v, 15).ngClassTouched;
        var currVal_10 = core_es5["ɵnov"](_v, 15).ngClassPristine;
        var currVal_11 = core_es5["ɵnov"](_v, 15).ngClassDirty;
        var currVal_12 = core_es5["ɵnov"](_v, 15).ngClassValid;
        var currVal_13 = core_es5["ɵnov"](_v, 15).ngClassInvalid;
        var currVal_14 = core_es5["ɵnov"](_v, 15).ngClassPending;
        _ck(_v, 8, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
    });
}
function View_ResultTabV2Component_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn bold customer-padding']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.sendEmail(null, 'sendEmailToCustomer') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' Send']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'btn bold customer-padding';
        var currVal_2 = _ck(_v, 2, 0, (_co.isEmailCopy == true));
        _ck(_v, 1, 0, currVal_1, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (!_co.order.Customer.Email && ((_co.currentEmail && _co.emailInputForm) && !_co.emailInputForm.model.valid));
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ResultTabV2Component_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-12 col-md-2 padding-left-md-0 margin-bottom-xs-45 d-sm-none']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ResultTabV2Component_7)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.isProcessing;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_ResultTabV2Component_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn bold customer-padding get-started']], [[8, 'disabled', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.sendEmail(null, 'goToGetStarted') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' Get Started']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'btn bold customer-padding get-started';
        var currVal_2 = _ck(_v, 2, 0, (_co.isEmailCopy == true));
        _ck(_v, 1, 0, currVal_1, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (!_co.order.Customer.Email && ((_co.currentEmail && _co.emailInputForm) && !_co.emailInputForm.model.valid));
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ResultTabV2Component_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn bold customer-padding']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.sendEmail(null, 'goToGetAnotherQuote') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' Get a new quote']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'btn bold customer-padding';
        var currVal_2 = _ck(_v, 2, 0, (_co.isEmailCopy == true));
        _ck(_v, 1, 0, currVal_1, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (!_co.order.Customer.Email && ((_co.currentEmail && _co.emailInputForm) && !_co.emailInputForm.model.valid));
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ResultTabV2Component_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'canadian-results-v2', [], null, null, null, View_CanadianResultsV2Component_0, RenderType_CanadianResultsV2Component)), core_es5["ɵdid"](114688, null, 0, canadian_results_v2_component_CanadianResultsV2Component, [tax_service["a" /* TaxService */]], { order: [0, 'order'], orderItem: [1, 'orderItem'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order;
        var currVal_1 = _co.orderItem;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_ResultTabV2Component_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'usa-results-v2', [], null, null, null, View_USAResultsV2Component_0, RenderType_USAResultsV2Component)), core_es5["ɵdid"](114688, null, 0, usa_results_v2_component_USAResultsV2Component, [], { order: [0, 'order'], orderItem: [1, 'orderItem'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order;
        var currVal_1 = _co.orderItem;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_ResultTabV2Component_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'result-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ResultTabV2Component_11)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ResultTabV2Component_12)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isCanadianCalculator;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = !_co.isCanadianCalculator;
        _ck(_v, 6, 0, currVal_1);
    }, null);
}
function View_ResultTabV2Component_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'col-xs-12 col-md-6 quote-send']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Your quote has been sent ']))], null, null);
}
function View_ResultTabV2Component_15(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Email is invalid']))], null, null);
}
function View_ResultTabV2Component_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class',
                'col-xs-12 col-md-4 padding-right-md-0 margin-bottom-xs-0']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 19, 'form', [['novalidate', '']], [[8, 'hidden', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngSubmit'], [null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 4).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.sendEmail(null, 'sendEmailToCustomer') !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [[3, 4], ['emailForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'form-input', [['class', 'btn bold form-email custom-from'],
            ['name', 'emailInputForm'], ['pattern', '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'],
            ['placeholder', 'Enter email to send to yourself'], ['type', 'text']], [[1,
                'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.currentEmail = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['emailInputForm', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], form: [2, 'form'], placeholder: [3, 'placeholder'], isPlaceholderNeed: [4,
                'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ResultTabV2Component_15)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_16 = '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
        _ck(_v, 9, 0, currVal_16);
        var currVal_17 = 'text';
        var currVal_18 = 'emailInputForm';
        var currVal_19 = core_es5["ɵnov"](_v, 4);
        var currVal_20 = 'Enter email to send to yourself';
        var currVal_21 = true;
        _ck(_v, 11, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21);
        var currVal_22 = 'emailInputForm';
        var currVal_23 = _co.currentEmail;
        _ck(_v, 13, 0, currVal_22, currVal_23);
        var currVal_24 = (core_es5["ɵnov"](_v, 11).model.hasError('pattern') && !core_es5["ɵnov"](_v, 11).model.pristine);
        _ck(_v, 19, 0, currVal_24);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ((_co.order.Customer.Email && _co.isNeedSendEmail) && !_co.isSendQuoteEmail);
        var currVal_1 = core_es5["ɵnov"](_v, 6).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 6).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 6).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 6).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 6).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 6).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 6).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_8 = (core_es5["ɵnov"](_v, 9).pattern ? core_es5["ɵnov"](_v, 9).pattern : null);
        var currVal_9 = core_es5["ɵnov"](_v, 15).ngClassUntouched;
        var currVal_10 = core_es5["ɵnov"](_v, 15).ngClassTouched;
        var currVal_11 = core_es5["ɵnov"](_v, 15).ngClassPristine;
        var currVal_12 = core_es5["ɵnov"](_v, 15).ngClassDirty;
        var currVal_13 = core_es5["ɵnov"](_v, 15).ngClassValid;
        var currVal_14 = core_es5["ɵnov"](_v, 15).ngClassInvalid;
        var currVal_15 = core_es5["ɵnov"](_v, 15).ngClassPending;
        _ck(_v, 8, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15);
    });
}
function View_ResultTabV2Component_17(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn bold customer-padding']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.sendEmail(null, 'sendEmailToCustomer') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' Send']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'btn bold customer-padding';
        var currVal_2 = _ck(_v, 2, 0, (_co.isEmailCopy == true));
        _ck(_v, 1, 0, currVal_1, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (!_co.order.Customer.Email && ((_co.currentEmail && _co.emailInputForm) && !_co.emailInputForm.model.valid));
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ResultTabV2Component_16(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-12 col-md-2 padding-left-md-0 margin-bottom-xs-45']], [[8, 'hidden', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ResultTabV2Component_17)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = !_co.isProcessing;
        _ck(_v, 3, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.order.Customer.Email && _co.isNeedSendEmail);
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ResultTabV2Component_18(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn bold customer-padding']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.sendEmail(null, 'goToGetAnotherQuote') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' Get a new quote']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'btn bold customer-padding';
        var currVal_2 = _ck(_v, 2, 0, (_co.isEmailCopy == true));
        _ck(_v, 1, 0, currVal_1, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (!_co.order.Customer.Email && ((_co.currentEmail && _co.emailInputForm) && !_co.emailInputForm.model.valid));
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ResultTabV2Component_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 122, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 34, 'div', [['class', 'header-side']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 31, 'div', [['class', 'container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 28, 'div', [['class',
                'row wizard-footer result']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'col-xs-12 block-2 block-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ResultTabV2Component_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ResultTabV2Component_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ResultTabV2Component_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-12 margin-left-auto text-right']], [[2, 'col-md-6', null], [2, 'col-md-3', null]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ResultTabV2Component_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-12 d-sm-none']], [[2, 'col-md-6', null],
            [2, 'col-md-3', null]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ResultTabV2Component_9)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'tab-background']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 81, 'accordion', [['class',
                'panel-group'], ['role', 'tablist'], ['style', 'display: block']], [[1, 'aria-multiselectable',
                0]], null, null, View_AccordionComponent_0, RenderType_AccordionComponent)),
        core_es5["ɵdid"](49152, null, 0, accordion_component_AccordionComponent, [accordion_config_AccordionConfig], { closeOthers: [0,
                'closeOthers'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 77, 'accordion-group', [['class', 'panel'], ['style', 'display: block']], [[2, 'panel-open', null]], null, null, View_AccordionPanelComponent_0, RenderType_AccordionPanelComponent)), core_es5["ɵdid"](245760, [[4, 4], ['group',
                4]], 0, accordion_group_component_AccordionPanelComponent, [accordion_component_AccordionComponent], { panelClass: [0,
                'panelClass'], isDisabled: [1, 'isDisabled'], isOpen: [2, 'isOpen'] }, null),
        (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 0, 10, 'div', [['accordion-heading',
                '']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row product']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-md-12 text-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'index']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Quote ID: BB-', ''])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 1, 1, null, View_ResultTabV2Component_10)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 22, 'div', [['class', 'row wizard-footer result padding-top-25 d-md-none']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class', 'col-xs-12 col-md-8 block-2 block-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 16, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ResultTabV2Component_13)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ResultTabV2Component_14)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ResultTabV2Component_16)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-12 col-md-3']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ResultTabV2Component_18)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, 1, 7, 'div', [['class', 'row disclaimer-block text-center padding-top-20 padding-bottom-20 pull-bottom line-height-30']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-xs-12 col-md-8 col-md-offset-2 padding-top-5 padding-bottom-5']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' * We need more information to get you a precise estimate, but this is close. We would love to customize a quote for you, please call or email us to move forward. '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'col-xs-12 col-md-8 col-md-offset-2 padding-top-5 padding-bottom-5']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' ** 3.25% charge applies for payments made by credit card or PayPal. '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 25, 'div', [['class', 'row wizard-footer result']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class',
                'col-xs-6 col-md-2 block-1']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'btn-container previousButton']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn back']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.moveBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, ['Back '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class',
                'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['trending_flat'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-xs-6 col-md-2 col-md-offset-8 block-3']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'btn-container nextButton']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn continue']], [[8, 'disabled',
                0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.sendEmail($event, 'goToThanksTab') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, ['Continue '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class',
                'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['trending_flat'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isSendQuoteEmail;
        _ck(_v, 13, 0, currVal_0);
        var currVal_1 = (!_co.isSendQuoteEmail && !(_co.order.Customer.Email && _co.isNeedSendEmail));
        _ck(_v, 16, 0, currVal_1);
        var currVal_2 = (!_co.isSendQuoteEmail && !(_co.order.Customer.Email && _co.isNeedSendEmail));
        _ck(_v, 19, 0, currVal_2);
        var currVal_5 = !_co.isProcessing;
        _ck(_v, 24, 0, currVal_5);
        var currVal_8 = !_co.isProcessing;
        _ck(_v, 30, 0, currVal_8);
        var currVal_10 = true;
        _ck(_v, 41, 0, currVal_10);
        var currVal_12 = _co.getClass();
        var currVal_13 = true;
        var currVal_14 = true;
        _ck(_v, 44, 0, currVal_12, currVal_13, currVal_14);
        var currVal_16 = (_co.order && _co.orderItem);
        _ck(_v, 59, 0, currVal_16);
        var currVal_17 = _co.isSendQuoteEmail;
        _ck(_v, 68, 0, currVal_17);
        var currVal_18 = !_co.isSendQuoteEmail;
        _ck(_v, 71, 0, currVal_18);
        var currVal_19 = !_co.isSendQuoteEmail;
        _ck(_v, 74, 0, currVal_19);
        var currVal_20 = !_co.isProcessing;
        _ck(_v, 79, 0, currVal_20);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = ((_co.order.Customer.Email && _co.isNeedSendEmail) && !_co.isSendQuoteEmail);
        var currVal_4 = !((_co.order.Customer.Email && _co.isNeedSendEmail) && !_co.isSendQuoteEmail);
        _ck(_v, 21, 0, currVal_3, currVal_4);
        var currVal_6 = ((_co.order.Customer.Email && _co.isNeedSendEmail) && !_co.isSendQuoteEmail);
        var currVal_7 = !((_co.order.Customer.Email && _co.isNeedSendEmail) && !_co.isSendQuoteEmail);
        _ck(_v, 27, 0, currVal_6, currVal_7);
        var currVal_9 = core_es5["ɵnov"](_v, 41).closeOthers;
        _ck(_v, 40, 0, currVal_9);
        var currVal_11 = core_es5["ɵnov"](_v, 44).isOpen;
        _ck(_v, 43, 0, currVal_11);
        var currVal_15 = (_co.order ? _co.order.Id : '');
        _ck(_v, 53, 0, currVal_15);
        var currVal_21 = (!_co.order.Customer.Email && ((_co.currentEmail && _co.emailInputForm) && !_co.emailInputForm.model.valid));
        _ck(_v, 112, 0, currVal_21);
    });
}
function View_ResultTabV2Component_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { accordionRef: 0 }), core_es5["ɵqud"](402653184, 2, { tab: 0 }),
        core_es5["ɵqud"](671088640, 3, { emailFormRef: 0 }), core_es5["ɵqud"](671088640, 4, { accordion: 0 }), (_l()(),
            core_es5["ɵeld"](0, [[1, 0], [2, 0], ['accordionRef', 1]], null, 8, 'tab', [['class',
                    'text-center accordion']], [[2, 'active', null], [2, 'tab-pane',
                    null]], [[null, 'onContinueClicked'], [null,
                    'isSelect']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('onContinueClicked' === en)) {
                    _co.focusInput(18);
                    var pd_0 = (_co.googleTagService.clearEventsArray() !== false);
                    ad = (pd_0 && ad);
                }
                if (('isSelect' === en)) {
                    _co.onTabSelected.emit({ pageTitle: 'Results tab', pageOrder: 180 });
                    _co.calculateOrder();
                    var pd_1 = (_co.googleTagService.pushData('quota') !== false);
                    ad = (pd_1 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { previousButton: [0, 'previousButton'], nextButton: [1,
                'nextButton'], index: [2, 'index'] }, { isSelect: 'isSelect', onContinueClicked: 'onContinueClicked' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ResultTabV2Component_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ResultTabV2Component_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = 'hidden';
        var currVal_3 = 'hidden';
        var currVal_4 = 17;
        _ck(_v, 5, 0, currVal_2, currVal_3, currVal_4);
        var currVal_5 = _co.isProcessing;
        _ck(_v, 8, 0, currVal_5);
        var currVal_6 = !_co.isProcessing;
        _ck(_v, 11, 0, currVal_6);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 5).active;
        var currVal_1 = core_es5["ɵnov"](_v, 5).addClass;
        _ck(_v, 4, 0, currVal_0, currVal_1);
    });
}
function View_ResultTabV2Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'result-tab-v2', [], null, null, null, View_ResultTabV2Component_0, RenderType_ResultTabV2Component)), core_es5["ɵdid"](4308992, null, 0, result_tab_v2_component_ResultTabV2Component, [services_orderService["a" /* OrderService */], services_emailService["a" /* EmailService */], toast_manager["ToastsManager"], google_tag_service["a" /* GoogleTagService */], tax_service["a" /* TaxService */],
            router_es5["n" /* Router */], services_configService["a" /* ConfigService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ResultTabV2ComponentNgFactory = core_es5["ɵccf"]('result-tab-v2', result_tab_v2_component_ResultTabV2Component, View_ResultTabV2Component_Host_0, { order: 'order', defaultProducts: 'defaultProducts',
    canadianCurrencyCodes: 'canadianCurrencyCodes', productName: 'productName', orderItem: 'orderItem',
    wizard: 'wizard', isNeedSendEmail: 'isNeedSendEmail', marketingURL: 'marketingURL',
    mainElement: 'mainElement', focusInput: 'focusInput' }, { getAnotherQuote: 'getAnotherQuote',
    isThanksTabShow: 'isThanksTabShow', isQuestionOrCallTabShow: 'isQuestionOrCallTabShow',
    showEmailText: 'showEmailText', createdOrder: 'createdOrder', onTabSelected: 'onTabSelected' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=result-tab-v2.component.ngfactory.js.map
// CONCATENATED MODULE: ./app/components/calculator/public/mobile/ask-question-tab/ask-question-tab.component.ts



var ask_question_tab_component_AskQuestionTabComponent = /** @class */ (function () {
    function AskQuestionTabComponent(emailService, googleTagService) {
        this.emailService = emailService;
        this.googleTagService = googleTagService;
        this.thanksTabShow = new core_es5["EventEmitter"]();
        this.onTabSelected = new core_es5["EventEmitter"]();
    }
    AskQuestionTabComponent.prototype.backToThanksTab = function () {
        var _this = this;
        var isTextEmpty = String.isNullOrEmpty(this.questionText.nativeElement.value);
        if (!isTextEmpty) {
            this.emailText = this.questionText.nativeElement.value;
            this.emailService.sendQuestionEmailToAgent(this.order.Customer.Email, this.emailText);
        }
        this.thanksTabShow.emit(true);
        setTimeout(function (_) { return _this.wizard.previousTab(false); }, 0);
    };
    AskQuestionTabComponent.prototype.backToQuestionOrCallTab = function (backEvent) {
        var _this = this;
        backEvent.preventDefault();
        this.thanksTabShow.emit(false);
        setTimeout(function (_) { return _this.wizard.previousTab(false); }, 0);
    };
    AskQuestionTabComponent.ctorParameters = function () { return [{ type: services_emailService["a" /* EmailService */] }, { type: google_tag_service["a" /* GoogleTagService */] }]; };
    return AskQuestionTabComponent;
}());

//# sourceMappingURL=ask-question-tab.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/public/mobile/ask-question-tab/ask-question-tab.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */











var styles_AskQuestionTabComponent = [];
var RenderType_AskQuestionTabComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AskQuestionTabComponent, data: {} });
function View_AskQuestionTabComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Email is invalid']))], null, null);
}
function View_AskQuestionTabComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { questionText: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 36, 'tab', [['nextButton', 'Continue'], ['previousButton', 'back']], [[2, 'active', null], [2, 'tab-pane', null]], [[null, 'onContinueClicked'],
            [null, 'onPreviousClicked'], [null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onContinueClicked' === en)) {
                var pd_0 = (_co.backToThanksTab() !== false);
                ad = (pd_0 && ad);
            }
            if (('onPreviousClicked' === en)) {
                var pd_1 = (_co.backToQuestionOrCallTab($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('isSelect' === en)) {
                _co.onTabSelected.emit({ pageTitle: 'Ask Questions', pageOrder: 210 });
                var pd_2 = (_co.googleTagService.pushData('ask_question') !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { previousButton: [0, 'previousButton'], isNextButtonDisabled: [1,
                'isNextButtonDisabled'], buttonTemplate: [2, 'buttonTemplate'], nextButton: [3,
                'nextButton'], index: [4, 'index'] }, { isSelect: 'isSelect', onContinueClicked: 'onContinueClicked',
            onPreviousClicked: 'onPreviousClicked' }), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', ''], ['title', 'Ask Questions']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)),
        core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1, 'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 29, 'div', [['class',
                'row bg-brand-prymary margin-bottom-20 margin-top-20 padding-top-45 padding-bottom-45']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'col-xs-12 col-md-6 col-md-offset-3 text-center question-tab']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form', [['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 13).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 13).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['emailForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'form-input', [['class', 'input-email'], ['name', 'emailInputForm'],
            ['pattern', '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'],
            ['placeholder', 'Add your email here'], ['type', 'text']], [[1, 'pattern',
                0], [2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.order.Customer.Email = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["PatternValidator"]]), core_es5["ɵdid"](4308992, [['emailInputForm', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], form: [2, 'form'], placeholder: [3, 'placeholder'], isPlaceholderNeed: [4,
                'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_AskQuestionTabComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class', 'col-xs-12 col-md-6 col-md-offset-3 textarea-container margin-top-20']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, [[1, 0], ['questionText',
                1]], null, 0, 'textarea', [['class', 'form-control'], ['placeholder',
                'Ask your questions here'], ['rows', '12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = 'back';
        var currVal_3 = !core_es5["ɵnov"](_v, 20).model.valid;
        var currVal_4 = _co.wizardFooterTemplate;
        var currVal_5 = 'Continue';
        var currVal_6 = (_co.isAskQuestionTabShow ? 21 : (0 - 1));
        _ck(_v, 2, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = 'Ask Questions';
        var currVal_8 = '';
        _ck(_v, 5, 0, currVal_7, currVal_8);
        var currVal_24 = '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
        _ck(_v, 18, 0, currVal_24);
        var currVal_25 = 'text';
        var currVal_26 = 'emailInputForm';
        var currVal_27 = core_es5["ɵnov"](_v, 13);
        var currVal_28 = 'Add your email here';
        var currVal_29 = true;
        _ck(_v, 20, 0, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29);
        var currVal_30 = 'emailInputForm';
        var currVal_31 = _co.order.Customer.Email;
        _ck(_v, 22, 0, currVal_30, currVal_31);
        var currVal_32 = (core_es5["ɵnov"](_v, 20).model.hasError('pattern') && !core_es5["ɵnov"](_v, 20).model.pristine);
        _ck(_v, 27, 0, currVal_32);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 2).active;
        var currVal_1 = core_es5["ɵnov"](_v, 2).addClass;
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_9 = core_es5["ɵnov"](_v, 15).ngClassUntouched;
        var currVal_10 = core_es5["ɵnov"](_v, 15).ngClassTouched;
        var currVal_11 = core_es5["ɵnov"](_v, 15).ngClassPristine;
        var currVal_12 = core_es5["ɵnov"](_v, 15).ngClassDirty;
        var currVal_13 = core_es5["ɵnov"](_v, 15).ngClassValid;
        var currVal_14 = core_es5["ɵnov"](_v, 15).ngClassInvalid;
        var currVal_15 = core_es5["ɵnov"](_v, 15).ngClassPending;
        _ck(_v, 11, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15);
        var currVal_16 = (core_es5["ɵnov"](_v, 18).pattern ? core_es5["ɵnov"](_v, 18).pattern : null);
        var currVal_17 = core_es5["ɵnov"](_v, 24).ngClassUntouched;
        var currVal_18 = core_es5["ɵnov"](_v, 24).ngClassTouched;
        var currVal_19 = core_es5["ɵnov"](_v, 24).ngClassPristine;
        var currVal_20 = core_es5["ɵnov"](_v, 24).ngClassDirty;
        var currVal_21 = core_es5["ɵnov"](_v, 24).ngClassValid;
        var currVal_22 = core_es5["ɵnov"](_v, 24).ngClassInvalid;
        var currVal_23 = core_es5["ɵnov"](_v, 24).ngClassPending;
        _ck(_v, 17, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23);
    });
}
function View_AskQuestionTabComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'ask-question-tab', [], null, null, null, View_AskQuestionTabComponent_0, RenderType_AskQuestionTabComponent)), core_es5["ɵdid"](49152, null, 0, ask_question_tab_component_AskQuestionTabComponent, [services_emailService["a" /* EmailService */], google_tag_service["a" /* GoogleTagService */]], null, null)], null, null);
}
var AskQuestionTabComponentNgFactory = core_es5["ɵccf"]('ask-question-tab', ask_question_tab_component_AskQuestionTabComponent, View_AskQuestionTabComponent_Host_0, { order: 'order',
    wizard: 'wizard', wizardFooterTemplate: 'wizardFooterTemplate', isAskQuestionTabShow: 'isAskQuestionTabShow',
    isQuestionOrCallTabShow: 'isQuestionOrCallTabShow' }, { thanksTabShow: 'thanksTabShow',
    onTabSelected: 'onTabSelected' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=ask-question-tab.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/services/pageVisitService.ts
var pageVisitService = __webpack_require__("qyLN");

// CONCATENATED MODULE: ./compiled/app/components/calculator/public/mobile/wizard/public-wizard-v2.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





































var styles_PublicWizardV2Component = [];
var RenderType_PublicWizardV2Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_PublicWizardV2Component, data: {} });
function View_PublicWizardV2Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Year can be 4 digits only']))], null, null);
}
function View_PublicWizardV2Component_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Year can be 4 digits only']))], null, null);
}
function View_PublicWizardV2Component_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'help-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Product description is required']))], null, null);
}
function View_PublicWizardV2Component_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class',
                'title thanksTab']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Thanks! We\'ve sent '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' you the quote.']))], null, null);
}
function View_PublicWizardV2Component_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'title thanksTab']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Thanks for choosing us.']))], null, null);
}
function View_PublicWizardV2Component_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](16777216, null, null, 1, null, null, null, null, null, null, null)),
        core_es5["ɵdid"](540672, null, 0, common_es5["NgTemplateOutlet"], [core_es5["ViewContainerRef"]], { ngTemplateOutlet: [0,
                'ngTemplateOutlet'] }, null), (_l()(), core_es5["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.wizardComponent.previousButtonRef;
        _ck(_v, 1, 0, currVal_0);
    }, null);
}
function View_PublicWizardV2Component_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class', 'row no-gutter']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-6 text-left']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PublicWizardV2Component_7)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-6 text-right']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](16777216, null, null, 1, null, null, null, null, null, null, null)), core_es5["ɵdid"](540672, null, 0, common_es5["NgTemplateOutlet"], [core_es5["ViewContainerRef"]], { ngTemplateOutlet: [0,
                'ngTemplateOutlet'] }, null), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'note text-italic-gray col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.showFirstTab || (_co.wizardComponent.activeTab.index != 1));
        _ck(_v, 6, 0, currVal_0);
        var currVal_1 = _co.wizardComponent.continueButtonRef;
        _ck(_v, 12, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.showBottomText(_co.isVehicle);
        _ck(_v, 19, 0, currVal_2);
    });
}
function View_PublicWizardV2Component_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { wizardComponent: 0 }), core_es5["ɵqud"](402653184, 2, { wizardFooterTemplate: 0 }),
        (_l()(), core_es5["ɵeld"](0, null, null, 235, 'wizard', [], null, [[null, 'keydown.enter']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('keydown.enter' === en)) {
                var pd_0 = (_co.customBlur() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_WizardComponent_0, RenderType_WizardComponent)), core_es5["ɵdid"](4440064, [[1, 4]], 0, ngx_wizard_es5["d" /* WizardComponent */], [core_es5["ElementRef"]], { nextButtonClass: [0, 'nextButtonClass'],
            prevButtonClass: [1, 'prevButtonClass'], nextIconText: [2, 'nextIconText'],
            prevIconText: [3, 'prevIconText'], previousButtonContainerClass: [4, 'previousButtonContainerClass'],
            nextButtonContainerClass: [5, 'nextButtonContainerClass'], showProgressBar: [6,
                'showProgressBar'], showHeader: [7, 'showHeader'], scrollClassRef: [8,
                'scrollClassRef'] }, null), core_es5["ɵprd"](2048, null, ngx_wizard_es5["c" /* TabsComponent */], null, [ngx_wizard_es5["d" /* WizardComponent */]]), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 28, 'tab', [], [[2, 'active', null], [2, 'tab-pane',
                null]], [[null, 'onContinueClicked'], [null,
                'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onContinueClicked' === en)) {
                _co.setImportTypeToOrder();
                var pd_0 = (_co.focusInput((_co.isVehicle ? 3 : (0 - 1))) !== false);
                ad = (pd_0 && ad);
            }
            if (('isSelect' === en)) {
                _co.addPageVisit({ pageTitle: 'ORDERS WITHOUT BORDERS', pageOrder: 10 });
                var pd_1 = (_co.googleTagService.pushData('import') !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { heading: [0, 'heading'], previousButton: [1,
                'previousButton'], isNextButtonDisabled: [2, 'isNextButtonDisabled'], buttonTemplate: [3,
                'buttonTemplate'], nextButton: [4, 'nextButton'], index: [5, 'index'] }, { isSelect: 'isSelect',
            onContinueClicked: 'onContinueClicked' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', 'I want to:'], ['title', 'ORDERS WITHOUT BORDERS']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)),
        core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1, 'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class',
                'row no-gutter first-page-new']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'col-xs-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'buttons']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setImportType(_co.importerTypeRef.Vehicle) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Import a Vehicle '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'col-xs-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'buttons']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setImportType(_co.importerTypeRef.Product) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Import any item '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 1, 'locationTo-tabs-v2', [['class', 'tab-content calculator-v2-tab']], null, [[null, 'setOrderItem'], [null, 'hideWizard'],
            [null, 'onTabSelected'], ['window', 'resize']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('window:resize' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 37).checkIfMobile() !== false);
                ad = (pd_0 && ad);
            }
            if (('setOrderItem' === en)) {
                var pd_1 = (_co.setOrderItem.emit($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('hideWizard' === en)) {
                var pd_2 = (_co.hideWizard.emit($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('onTabSelected' === en)) {
                var pd_3 = (_co.addPageVisit($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, View_LocationToTabsV2Component_0, RenderType_LocationToTabsV2Component)),
        core_es5["ɵdid"](49152, null, 0, locationTo_tab_v2_component_LocationToTabsV2Component, [core_es5["ChangeDetectorRef"],
            google_tag_service["a" /* GoogleTagService */]], { order: [0, 'order'], orderItem: [1, 'orderItem'], wizardComponent: [2,
                'wizardComponent'], provinceArray: [3, 'provinceArray'], wizardFooterTemplate: [4,
                'wizardFooterTemplate'], showFirstTab: [5, 'showFirstTab'], isSelfServeApp: [6,
                'isSelfServeApp'], shipmentFrom: [7, 'shipmentFrom'], focusInput: [8, 'focusInput'],
            isVehicle: [9, 'isVehicle'] }, { hideWizard: 'hideWizard', setOrderItem: 'setOrderItem',
            onTabSelected: 'onTabSelected' }), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 2, 'shipment-from-tab', [['class', 'tab-content calculator-v2-tab']], null, [[null, 'onTabSelected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onTabSelected' === en)) {
                var pd_0 = (_co.addPageVisit($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ShipmentFromTabComponent_0, RenderType_ShipmentFromTabComponent)),
        core_es5["ɵdid"](4243456, [['shipmentFrom', 4]], 0, shipment_from_tab_component["a" /* ShipmentFromTabComponent */], [services_configService["a" /* ConfigService */],
            core_es5["ChangeDetectorRef"], google_tag_service["a" /* GoogleTagService */]], { order: [0, 'order'], orderItem: [1,
                'orderItem'], wizardComponent: [2, 'wizardComponent'], wizardFooterTemplate: [3,
                'wizardFooterTemplate'], focusInput: [4, 'focusInput'] }, { onTabSelected: 'onTabSelected' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 66, 'tab', [['previousButton', 'back']], [[2, 'active', null],
            [2, 'tab-pane', null]], [[null, 'onContinueClicked'], [null,
                'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onContinueClicked' === en)) {
                _co.setYearToOI();
                var pd_0 = (_co.focusInput(4) !== false);
                ad = (pd_0 && ad);
            }
            if (('isSelect' === en)) {
                _co.addPageVisit({ pageTitle: 'What year vehicle?', pageOrder: 40 });
                var pd_1 = (_co.googleTagService.pushData('year') !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { heading: [0, 'heading'], previousButton: [1,
                'previousButton'], isNextButtonDisabled: [2, 'isNextButtonDisabled'], buttonTemplate: [3,
                'buttonTemplate'], nextButton: [4, 'nextButton'], index: [5, 'index'] }, { isSelect: 'isSelect',
            onContinueClicked: 'onContinueClicked' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', 'The year of vehicle can determine duty rate.'], ['title', 'What year vehicle?']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)), core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1,
                'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 59, 'div', [['class', 'row no-gutter']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-xs-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.setYear(1800, 1996) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, ['1800-1996'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-xs-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setYear(1997, 2005) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, ['1997-2005'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-xs-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setYear(2006, 2021) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, ['2006-2021'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 29, 'div', [['class', 'col-xs-6 small-form']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 26, 'div', [['class', 'btn bold no-hover']], null, null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'form', [['class',
                'display-inline'], ['novalidate', '']], [[2, 'ng-untouched', null], [2,
                'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'submit'], [null,
                'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 85).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 85).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['priceForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'form-input', [['class', ''], ['maxlength', '4'], ['minlength',
                '4'], ['name', 'emailInput'], ['placeholder', 'Or enter exact year'], ['type',
                'number']], [[1, 'minlength', 0], [1, 'maxlength', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'keypress'], [null,
                'ngModelChange'], [null, 'input']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('keypress' === en)) {
                var pd_0 = (_co.eventHandler($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_1 = ((_co.currentYear = $event) !== false);
                ad = (pd_1 && ad);
            }
            if (('input' === en)) {
                var pd_2 = ((_co.currentYearRange = null) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](540672, null, 0, forms_es5["MinLengthValidator"], [], { minlength: [0, 'minlength'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["MaxLengthValidator"], [], { maxlength: [0, 'maxlength'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["MinLengthValidator"], forms_es5["MaxLengthValidator"]]), core_es5["ɵdid"](4308992, [['yaerInput',
                4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1, 'name'], form: [2, 'form'], placeholder: [3, 'placeholder'],
            isPlaceholderNeed: [4, 'isPlaceholderNeed'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_PublicWizardV2Component_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_PublicWizardV2Component_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 31, 'tab', [['heading', 'What are you importing?'], ['previousButton', 'back']], [[2, 'active',
                null], [2, 'tab-pane', null]], [[null, 'onContinueClicked'],
            [null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onContinueClicked' === en)) {
                var pd_0 = (_co.focusInput(7) !== false);
                ad = (pd_0 && ad);
            }
            if (('isSelect' === en)) {
                _co.addPageVisit({ pageTitle: 'What are you importing?', pageOrder: 70 });
                var pd_1 = (_co.googleTagService.pushData('product_description') !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { heading: [0, 'heading'], previousButton: [1,
                'previousButton'], isNextButtonDisabled: [2, 'isNextButtonDisabled'], buttonTemplate: [3,
                'buttonTemplate'], nextButton: [4, 'nextButton'], index: [5, 'index'] }, { isSelect: 'isSelect',
            onContinueClicked: 'onContinueClicked' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', 'Describe your item in detail.'], ['title', 'What are you importing?']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)), core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1,
                'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 24, 'div', [['class', 'row bg-brand-prymary']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'col-xs-12 col-md-6 col-md-offset-3 item_desc_block height-size-2 text-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'form', [['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 123).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 123).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['productDescriptionFrom', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]),
        core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 11, 'form-input', [['class', ''], ['name',
                    'productDescription'], ['placeholder', 'Item description'], ['required',
                    ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
                [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                    null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
                [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                    'input']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.currentDescription = $event) !== false);
                    ad = (pd_0 && ad);
                }
                if (('input' === en)) {
                    var pd_1 = ((_co.currentYearRange = null) !== false);
                    ad = (pd_1 && ad);
                }
                return ad;
            }, View_FormInputComponent_0, RenderType_FormInputComponent)), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](4308992, [['productDescription', 4]], 0, formInput_component_FormInputComponent, [[2, forms_es5["NG_VALIDATORS"]], [2, forms_es5["NG_ASYNC_VALIDATORS"]]], { type: [0, 'type'], name: [1,
                'name'], form: [2, 'form'], placeholder: [3, 'placeholder'], isPlaceholderNeed: [4,
                'isPlaceholderNeed'], autofocus: [5, 'autofocus'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [formInput_component_FormInputComponent]), core_es5["ɵdid"](671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵted"](0, [' '])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_PublicWizardV2Component_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](0, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 2, 'manufacturer-tab-v2', [['class', 'tab-content calculator-v2-tab']], null, [[null,
                'onTabSelected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onTabSelected' === en)) {
                var pd_0 = (_co.addPageVisit($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ManufacturerTabV2Component_0, RenderType_ManufacturerTabV2Component)),
        core_es5["ɵdid"](4243456, null, 0, manufacturer_tab_v2_component["a" /* ManufacturerTabV2Component */], [services_configService["a" /* ConfigService */],
            core_es5["ChangeDetectorRef"], google_tag_service["a" /* GoogleTagService */]], { order: [0, 'order'], orderItem: [1,
                'orderItem'], wizardComponent: [2, 'wizardComponent'], wizardFooterTemplate: [3,
                'wizardFooterTemplate'], focusInput: [4, 'focusInput'] }, { onTabSelected: 'onTabSelected' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 2, 'price-tab-v2', [['class', 'tab-content calculator-v2-tab']], null, [[null, 'onTabSelected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onTabSelected' === en)) {
                var pd_0 = (_co.addPageVisit($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_PriceTabV2Component_0, RenderType_PriceTabV2Component)), core_es5["ɵdid"](49152, null, 0, price_tab_v2_component_PriceTabV2Component, [core_es5["ChangeDetectorRef"], google_tag_service["a" /* GoogleTagService */]], { wizardComponent: [0, 'wizardComponent'], order: [1, 'order'], orderItem: [2, 'orderItem'],
            canadianCurrencyCodes: [3, 'canadianCurrencyCodes'], wizardFooterTemplate: [4,
                'wizardFooterTemplate'], focusInput: [5, 'focusInput'] }, { onTabSelected: 'onTabSelected' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 1, 'canadian-questions-tab-v2', [['class', 'tab-content calculator-v2-tab']], null, [[null, 'onTabSelected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onTabSelected' === en)) {
                var pd_0 = (_co.addPageVisit($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CanadianQuestionsTabV2Component_0, RenderType_CanadianQuestionsTabV2Component)),
        core_es5["ɵdid"](49152, null, 0, canadian_questions_tab_v2_component_CanadianQuestionsTabV2Component, [core_es5["ChangeDetectorRef"],
            google_tag_service["a" /* GoogleTagService */]], { wizardComponent: [0, 'wizardComponent'], order: [1, 'order'],
            orderItem: [2, 'orderItem'], wizardFooterTemplate: [3, 'wizardFooterTemplate'],
            focusInput: [4, 'focusInput'] }, { onTabSelected: 'onTabSelected' }), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 1, 'email-tabs-v2', [['class', 'tab-content calculator-v2-tab']], null, [[null, 'onTabSelected'], [null, 'isNeedSendEmail']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onTabSelected' === en)) {
                var pd_0 = (_co.addPageVisit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('isNeedSendEmail' === en)) {
                var pd_1 = ((_co.isNeedSendEmail = $event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_EmailTabsV2Component_0, RenderType_EmailTabsV2Component)),
        core_es5["ɵdid"](49152, null, 0, email_tab_v2_component_EmailTabsV2Component, [core_es5["ChangeDetectorRef"],
            google_tag_service["a" /* GoogleTagService */]], { wizardComponent: [0, 'wizardComponent'], order: [1, 'order'],
            wizardFooterTemplate: [2, 'wizardFooterTemplate'], focusInput: [3, 'focusInput'] }, { isNeedSendEmail: 'isNeedSendEmail', onTabSelected: 'onTabSelected' }), (_l()(),
            core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 32, 'tab', [['previousButton',
                'back']], [[2, 'active', null], [2, 'tab-pane', null]], [[null,
                'onContinueClicked'], [null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onContinueClicked' === en)) {
                core_es5["ɵnov"](_v, 193).showCarryingOptions();
                $event.preventDefault();
                var pd_0 = (_co.focusInput(15) !== false);
                ad = (pd_0 && ad);
            }
            if (('isSelect' === en)) {
                _co.addPageVisit({ pageTitle: 'Have you purchased the product, yet?', pageOrder: 150 });
                var pd_1 = (_co.googleTagService.pushData('is_purchased') !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { heading: [0, 'heading'], previousButton: [1,
                'previousButton'], isNextButtonDisabled: [2, 'isNextButtonDisabled'], buttonTemplate: [3,
                'buttonTemplate'], nextButton: [4, 'nextButton'], index: [5, 'index'] }, { isSelect: 'isSelect',
            onContinueClicked: 'onContinueClicked' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', '']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)), core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1,
                'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 25, 'div', [['class', 'row no-gutter']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-xs-12 col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'buttons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['class',
                'btn size-2 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setPurchased(true) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' Yes '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-xs-12 col-md-6']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'buttons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'button', [['class', 'btn size-2 bold']], null, [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.setPurchased(false) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"]({ 'active': 0 }),
        core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' No '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 2, 'how-carrying', [['class',
                'tab-content calculator-v2-tab']], null, [[null, 'onTabSelected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onTabSelected' === en)) {
                var pd_0 = (_co.addPageVisit($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_HowCarryingComponent_0, RenderType_HowCarryingComponent)),
        core_es5["ɵdid"](49152, [['carrying', 4]], 0, how_carrying_component_HowCarryingComponent, [google_tag_service["a" /* GoogleTagService */]], { wizardComponent: [0, 'wizardComponent'], order: [1, 'order'], wizardFooterTemplate: [2,
                'wizardFooterTemplate'], focusInput: [3, 'focusInput'] }, { onTabSelected: 'onTabSelected' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 2, 'result-tab-v2', [['class', 'tab-content calculator-v2-tab-result']], null, [[null, 'showEmailText'], [null, 'isThanksTabShow'],
            [null, 'getAnotherQuote'], [null, 'createdOrder'], [null,
                'isQuestionOrCallTabShow'], [null, 'onTabSelected'], [null,
                'isQuote']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('showEmailText' === en)) {
                var pd_0 = (_co.showEmailText($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('isThanksTabShow' === en)) {
                var pd_1 = (_co.showThanksTab($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('getAnotherQuote' === en)) {
                var pd_2 = (_co.getAnotherQuote.emit($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('createdOrder' === en)) {
                var pd_3 = (_co.createdOrder($event) !== false);
                ad = (pd_3 && ad);
            }
            if (('isQuestionOrCallTabShow' === en)) {
                var pd_4 = (_co.showQuestionOrCallTab($event) !== false);
                ad = (pd_4 && ad);
            }
            if (('onTabSelected' === en)) {
                var pd_5 = (_co.addPageVisit($event) !== false);
                ad = (pd_5 && ad);
            }
            if (('isQuote' === en)) {
                var pd_6 = (_co.isQuotePage.emit(true) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, View_ResultTabV2Component_0, RenderType_ResultTabV2Component)),
        core_es5["ɵdid"](4308992, null, 0, result_tab_v2_component_ResultTabV2Component, [services_orderService["a" /* OrderService */], services_emailService["a" /* EmailService */],
            toast_manager["ToastsManager"], google_tag_service["a" /* GoogleTagService */], tax_service["a" /* TaxService */], router_es5["n" /* Router */], services_configService["a" /* ConfigService */]], { order: [0, 'order'], defaultProducts: [1, 'defaultProducts'], canadianCurrencyCodes: [2,
                'canadianCurrencyCodes'], productName: [3, 'productName'], orderItem: [4,
                'orderItem'], wizard: [5, 'wizard'], isNeedSendEmail: [6, 'isNeedSendEmail'],
            marketingURL: [7, 'marketingURL'], mainElement: [8, 'mainElement'], focusInput: [9,
                'focusInput'] }, { getAnotherQuote: 'getAnotherQuote', isThanksTabShow: 'isThanksTabShow',
            isQuestionOrCallTabShow: 'isQuestionOrCallTabShow', showEmailText: 'showEmailText',
            createdOrder: 'createdOrder', onTabSelected: 'onTabSelected' }), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 22, 'tab', [['nextButton', 'Continue'], ['previousButton', 'back']], [[2, 'active', null], [2, 'tab-pane', null]], [[null,
                'onContinueClicked'], [null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onContinueClicked' === en)) {
                _co.goToThanksTab();
                _co.focusInput((0 - 1));
                var pd_0 = ($event.preventDefault() !== false);
                ad = (pd_0 && ad);
            }
            if (('isSelect' === en)) {
                _co.addPageVisit({ pageTitle: 'We can handle the entire customs clearance for you.',
                    pageOrder: 190 });
                _co.scrollTop();
                var pd_1 = (_co.googleTagService.pushData('info') !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { previousButton: [0, 'previousButton'], buttonTemplate: [1,
                'buttonTemplate'], nextButton: [2, 'nextButton'], index: [3, 'index'] }, { isSelect: 'isSelect',
            onContinueClicked: 'onContinueClicked' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', 'What would you like to do next?'], ['title', 'We can handle the entire customs clearance for you.']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)), core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1,
                'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'row no-gutter']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'col-xs-12 col-md-6 ask-tab']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class',
                'btn size-2 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.goToAskQuestionTab() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, ['Ask Questions'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'col-xs-12 col-md-6 ask-tab']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 2, 'a', [['class', 'btn size-2 bold'],
                ['href', 'tel:1-877-409-8163']], null, null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, ['Call us Toll Free'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, 1, 8, 'tab', [['nextButton', 'Get another quote'],
            ['previousButton', 'back']], [[2, 'active', null], [2, 'tab-pane', null]], [[null, 'onContinueClicked'], [null, 'onPreviousClicked'],
            [null, 'isSelect']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onContinueClicked' === en)) {
                _co.getAnotherQuote.emit(true);
                var pd_0 = (_co.focusInput((0 - 1)) !== false);
                ad = (pd_0 && ad);
            }
            if (('onPreviousClicked' === en)) {
                var pd_1 = (_co.backToAskQuestionTab($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('isSelect' === en)) {
                _co.addPageVisit({ pageTitle: 'Thanks tab', pageOrder: 200 });
                _co.googleTagService.pushData('thanks');
                var pd_2 = (_co.googleTagService.clearEventsArray() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](212992, null, 0, ngx_wizard_es5["b" /* TabDirective */], [ngx_wizard_es5["c" /* TabsComponent */], core_es5["ElementRef"]], { previousButton: [0, 'previousButton'], buttonTemplate: [1,
                'buttonTemplate'], nextButton: [2, 'nextButton'], index: [3, 'index'] }, { isSelect: 'isSelect',
            onContinueClicked: 'onContinueClicked', onPreviousClicked: 'onPreviousClicked' }),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PublicWizardV2Component_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PublicWizardV2Component_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵeld"](0, null, 1, 2, 'ask-question-tab', [['class',
                'tab-content']], null, [[null, 'thanksTabShow'], [null,
                'onTabSelected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('thanksTabShow' === en)) {
                var pd_0 = (_co.showThanksTab($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('onTabSelected' === en)) {
                var pd_1 = (_co.addPageVisit($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_AskQuestionTabComponent_0, RenderType_AskQuestionTabComponent)),
        core_es5["ɵdid"](49152, null, 0, ask_question_tab_component_AskQuestionTabComponent, [services_emailService["a" /* EmailService */],
            google_tag_service["a" /* GoogleTagService */]], { order: [0, 'order'], wizard: [1, 'wizard'], wizardFooterTemplate: [2,
                'wizardFooterTemplate'], isAskQuestionTabShow: [3, 'isAskQuestionTabShow'],
            isQuestionOrCallTabShow: [4, 'isQuestionOrCallTabShow'] }, { thanksTabShow: 'thanksTabShow',
            onTabSelected: 'onTabSelected' }), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](1, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, [[2, 2], ['wizardFooterTemplate', 2]], null, 0, null, View_PublicWizardV2Component_6)),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (('btn continue ' + (!_co.isIconShow() ? 'btn-no-arrow ' : '')) + (_co.isFullWidth() ? 'next-full-width' : ''));
        var currVal_1 = ('btn back ' + (_co.isFullWidth() ? 'back-full-width' : ''));
        var currVal_2 = (!_co.isIconShow() ? '' : 'trending_flat');
        var currVal_3 = 'trending_flat';
        var currVal_4 = (_co.isFullWidth() ? 'btn-container-full-width' : '');
        var currVal_5 = (_co.isFullWidth() ? 'btn-container-full-width' : '');
        var currVal_6 = true;
        var currVal_7 = false;
        var currVal_8 = '.public-calc';
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
        var currVal_11 = 12;
        var currVal_12 = 'back';
        var currVal_13 = (_co.currentImportType == null);
        var currVal_14 = core_es5["ɵnov"](_v, 239);
        var currVal_15 = 'Continue';
        var currVal_16 = (_co.showFirstTab ? 0 : (0 - 1));
        _ck(_v, 7, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16);
        var currVal_17 = 'ORDERS WITHOUT BORDERS';
        var currVal_18 = 'I want to:';
        _ck(_v, 10, 0, currVal_17, currVal_18);
        var currVal_19 = 'btn size-1 bold';
        var currVal_20 = _ck(_v, 19, 0, (_co.currentImportType == _co.importerTypeRef.Vehicle));
        _ck(_v, 18, 0, currVal_19, currVal_20);
        var currVal_21 = 'btn size-1 bold';
        var currVal_22 = _ck(_v, 29, 0, (_co.currentImportType == _co.importerTypeRef.Product));
        _ck(_v, 28, 0, currVal_21, currVal_22);
        var currVal_23 = _co.order;
        var currVal_24 = _co.orderItem;
        var currVal_25 = _co.wizardComponent;
        var currVal_26 = _co.provinceArray;
        var currVal_27 = core_es5["ɵnov"](_v, 239);
        var currVal_28 = _co.showFirstTab;
        var currVal_29 = _co.isSelfServeApp;
        var currVal_30 = core_es5["ɵnov"](_v, 40);
        var currVal_31 = _co.focusInput;
        var currVal_32 = _co.isVehicle;
        _ck(_v, 37, 0, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32);
        var currVal_33 = _co.order;
        var currVal_34 = _co.orderItem;
        var currVal_35 = _co.wizardComponent;
        var currVal_36 = core_es5["ɵnov"](_v, 239);
        var currVal_37 = _co.focusInput;
        _ck(_v, 40, 0, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37);
        var currVal_40 = 'What Year vehicle?';
        var currVal_41 = 'back';
        var currVal_42 = ((!_co.currentYear || core_es5["ɵnov"](_v, 93).model.invalid) && (_co.currentYearRange == null));
        var currVal_43 = core_es5["ɵnov"](_v, 239);
        var currVal_44 = 'Continue';
        var currVal_45 = (_co.isVehicle ? 3 : (0 - 1));
        _ck(_v, 44, 0, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44, currVal_45);
        var currVal_46 = 'What year vehicle?';
        var currVal_47 = 'The year of vehicle can determine duty rate.';
        _ck(_v, 47, 0, currVal_46, currVal_47);
        var currVal_48 = 'btn size-1 bold';
        var currVal_49 = _ck(_v, 55, 0, (_co.currentYearRange == _co.getMeanValue(1800, 1996)));
        _ck(_v, 54, 0, currVal_48, currVal_49);
        var currVal_50 = 'btn size-1 bold';
        var currVal_51 = _ck(_v, 64, 0, (_co.currentYearRange == _co.getMeanValue(1997, 2005)));
        _ck(_v, 63, 0, currVal_50, currVal_51);
        var currVal_52 = 'btn size-1 bold';
        var currVal_53 = _ck(_v, 73, 0, (_co.currentYearRange == _co.getMeanValue(2006, 2021)));
        _ck(_v, 72, 0, currVal_52, currVal_53);
        var currVal_70 = '4';
        _ck(_v, 90, 0, currVal_70);
        var currVal_71 = '4';
        _ck(_v, 91, 0, currVal_71);
        var currVal_72 = 'number';
        var currVal_73 = 'emailInput';
        var currVal_74 = core_es5["ɵnov"](_v, 85);
        var currVal_75 = 'Or enter exact year';
        var currVal_76 = true;
        _ck(_v, 93, 0, currVal_72, currVal_73, currVal_74, currVal_75, currVal_76);
        var currVal_77 = 'emailInput';
        var currVal_78 = _co.currentYear;
        _ck(_v, 95, 0, currVal_77, currVal_78);
        var currVal_79 = (core_es5["ɵnov"](_v, 93).model.hasError('maxlength') && !core_es5["ɵnov"](_v, 93).model.pristine);
        _ck(_v, 100, 0, currVal_79);
        var currVal_80 = (core_es5["ɵnov"](_v, 93).model.hasError('minlength') && !core_es5["ɵnov"](_v, 93).model.pristine);
        _ck(_v, 103, 0, currVal_80);
        var currVal_83 = 'What are you importing?';
        var currVal_84 = 'back';
        var currVal_85 = (_co.currentDescription == null);
        var currVal_86 = core_es5["ɵnov"](_v, 239);
        var currVal_87 = 'Continue';
        var currVal_88 = ((_co.isVehicle == false) ? 6 : (0 - 1));
        _ck(_v, 112, 0, currVal_83, currVal_84, currVal_85, currVal_86, currVal_87, currVal_88);
        var currVal_89 = 'What are you importing?';
        var currVal_90 = 'Describe your item in detail.';
        _ck(_v, 115, 0, currVal_89, currVal_90);
        var currVal_106 = '';
        _ck(_v, 128, 0, currVal_106);
        var currVal_107 = 'text';
        var currVal_108 = 'productDescription';
        var currVal_109 = core_es5["ɵnov"](_v, 123);
        var currVal_110 = 'Item description';
        var currVal_111 = true;
        var currVal_112 = true;
        _ck(_v, 130, 0, currVal_107, currVal_108, currVal_109, currVal_110, currVal_111, currVal_112);
        var currVal_113 = 'productDescription';
        var currVal_114 = _co.currentDescription;
        _ck(_v, 132, 0, currVal_113, currVal_114);
        var currVal_115 = (core_es5["ɵnov"](_v, 130).model.hasError('required') && !core_es5["ɵnov"](_v, 130).model.pristine);
        _ck(_v, 137, 0, currVal_115);
        var currVal_116 = _co.order;
        var currVal_117 = _co.orderItem;
        var currVal_118 = _co.wizardComponent;
        var currVal_119 = core_es5["ɵnov"](_v, 239);
        var currVal_120 = _co.focusInput;
        _ck(_v, 145, 0, currVal_116, currVal_117, currVal_118, currVal_119, currVal_120);
        var currVal_121 = _co.wizardComponent;
        var currVal_122 = _co.order;
        var currVal_123 = _co.orderItem;
        var currVal_124 = _co.canadianCurrencyCodes;
        var currVal_125 = core_es5["ɵnov"](_v, 239);
        var currVal_126 = _co.focusInput;
        _ck(_v, 149, 0, currVal_121, currVal_122, currVal_123, currVal_124, currVal_125, currVal_126);
        var currVal_127 = _co.wizardComponent;
        var currVal_128 = _co.order;
        var currVal_129 = _co.orderItem;
        var currVal_130 = core_es5["ɵnov"](_v, 239);
        var currVal_131 = _co.focusInput;
        _ck(_v, 153, 0, currVal_127, currVal_128, currVal_129, currVal_130, currVal_131);
        var currVal_132 = _co.wizardComponent;
        var currVal_133 = _co.order;
        var currVal_134 = core_es5["ɵnov"](_v, 239);
        var currVal_135 = _co.focusInput;
        _ck(_v, 156, 0, currVal_132, currVal_133, currVal_134, currVal_135);
        var currVal_138 = core_es5["ɵinlineInterpolate"](1, 'Have you purchased the ', (_co.isVehicle ? 'vehicle' : _co.currentDescription), ', yet?');
        var currVal_139 = 'back';
        var currVal_140 = (_co.isPusrchased == null);
        var currVal_141 = core_es5["ɵnov"](_v, 239);
        var currVal_142 = 'Continue';
        var currVal_143 = 14;
        _ck(_v, 159, 0, currVal_138, currVal_139, currVal_140, currVal_141, currVal_142, currVal_143);
        var currVal_144 = core_es5["ɵinlineInterpolate"](1, 'Have you purchased the ', (_co.isVehicle ? 'vehicle' : _co.currentDescription), ', yet?');
        var currVal_145 = '';
        _ck(_v, 162, 0, currVal_144, currVal_145);
        var currVal_146 = 'btn size-2 bold';
        var currVal_147 = _ck(_v, 172, 0, (_co.isPusrchased == true));
        _ck(_v, 171, 0, currVal_146, currVal_147);
        var currVal_148 = 'btn size-2 bold';
        var currVal_149 = _ck(_v, 184, 0, (_co.isPusrchased == false));
        _ck(_v, 183, 0, currVal_148, currVal_149);
        var currVal_150 = _co.wizardComponent;
        var currVal_151 = _co.order;
        var currVal_152 = core_es5["ɵnov"](_v, 239);
        var currVal_153 = _co.focusInput;
        _ck(_v, 193, 0, currVal_150, currVal_151, currVal_152, currVal_153);
        var currVal_154 = _co.order;
        var currVal_155 = _co.defaultProducts;
        var currVal_156 = _co.canadianCurrencyCodes;
        var currVal_157 = _co.currentDescription;
        var currVal_158 = _co.orderItem;
        var currVal_159 = _co.wizardComponent;
        var currVal_160 = _co.isNeedSendEmail;
        var currVal_161 = _co.marketingURL;
        var currVal_162 = _co.mainElement;
        var currVal_163 = _co.focusInput;
        _ck(_v, 197, 0, currVal_154, currVal_155, currVal_156, currVal_157, currVal_158, currVal_159, currVal_160, currVal_161, currVal_162, currVal_163);
        var currVal_166 = 'back';
        var currVal_167 = core_es5["ɵnov"](_v, 239);
        var currVal_168 = 'Continue';
        var currVal_169 = (_co.isQuestionOrCallTabShow ? 19 : (0 - 1));
        _ck(_v, 201, 0, currVal_166, currVal_167, currVal_168, currVal_169);
        var currVal_170 = 'We can handle the entire customs clearance for you.';
        var currVal_171 = 'What would you like to do next?';
        _ck(_v, 204, 0, currVal_170, currVal_171);
        var currVal_174 = 'back';
        var currVal_175 = core_es5["ɵnov"](_v, 239);
        var currVal_176 = 'Get another quote';
        var currVal_177 = (_co.isThanksTabShow ? 20 : (0 - 1));
        _ck(_v, 225, 0, currVal_174, currVal_175, currVal_176, currVal_177);
        var currVal_178 = _co.isEmailTextShow;
        _ck(_v, 228, 0, currVal_178);
        var currVal_179 = !_co.isEmailTextShow;
        _ck(_v, 231, 0, currVal_179);
        var currVal_180 = _co.order;
        var currVal_181 = _co.wizardComponent;
        var currVal_182 = core_es5["ɵnov"](_v, 239);
        var currVal_183 = _co.isAskQuestionTabShow;
        var currVal_184 = _co.isQuestionOrCallTabShow;
        _ck(_v, 235, 0, currVal_180, currVal_181, currVal_182, currVal_183, currVal_184);
    }, function (_ck, _v) {
        var currVal_9 = core_es5["ɵnov"](_v, 7).active;
        var currVal_10 = core_es5["ɵnov"](_v, 7).addClass;
        _ck(_v, 6, 0, currVal_9, currVal_10);
        var currVal_38 = core_es5["ɵnov"](_v, 44).active;
        var currVal_39 = core_es5["ɵnov"](_v, 44).addClass;
        _ck(_v, 43, 0, currVal_38, currVal_39);
        var currVal_54 = core_es5["ɵnov"](_v, 87).ngClassUntouched;
        var currVal_55 = core_es5["ɵnov"](_v, 87).ngClassTouched;
        var currVal_56 = core_es5["ɵnov"](_v, 87).ngClassPristine;
        var currVal_57 = core_es5["ɵnov"](_v, 87).ngClassDirty;
        var currVal_58 = core_es5["ɵnov"](_v, 87).ngClassValid;
        var currVal_59 = core_es5["ɵnov"](_v, 87).ngClassInvalid;
        var currVal_60 = core_es5["ɵnov"](_v, 87).ngClassPending;
        _ck(_v, 83, 0, currVal_54, currVal_55, currVal_56, currVal_57, currVal_58, currVal_59, currVal_60);
        var currVal_61 = (core_es5["ɵnov"](_v, 90).minlength ? core_es5["ɵnov"](_v, 90).minlength : null);
        var currVal_62 = (core_es5["ɵnov"](_v, 91).maxlength ? core_es5["ɵnov"](_v, 91).maxlength : null);
        var currVal_63 = core_es5["ɵnov"](_v, 97).ngClassUntouched;
        var currVal_64 = core_es5["ɵnov"](_v, 97).ngClassTouched;
        var currVal_65 = core_es5["ɵnov"](_v, 97).ngClassPristine;
        var currVal_66 = core_es5["ɵnov"](_v, 97).ngClassDirty;
        var currVal_67 = core_es5["ɵnov"](_v, 97).ngClassValid;
        var currVal_68 = core_es5["ɵnov"](_v, 97).ngClassInvalid;
        var currVal_69 = core_es5["ɵnov"](_v, 97).ngClassPending;
        _ck(_v, 89, 0, currVal_61, currVal_62, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67, currVal_68, currVal_69);
        var currVal_81 = core_es5["ɵnov"](_v, 112).active;
        var currVal_82 = core_es5["ɵnov"](_v, 112).addClass;
        _ck(_v, 111, 0, currVal_81, currVal_82);
        var currVal_91 = core_es5["ɵnov"](_v, 125).ngClassUntouched;
        var currVal_92 = core_es5["ɵnov"](_v, 125).ngClassTouched;
        var currVal_93 = core_es5["ɵnov"](_v, 125).ngClassPristine;
        var currVal_94 = core_es5["ɵnov"](_v, 125).ngClassDirty;
        var currVal_95 = core_es5["ɵnov"](_v, 125).ngClassValid;
        var currVal_96 = core_es5["ɵnov"](_v, 125).ngClassInvalid;
        var currVal_97 = core_es5["ɵnov"](_v, 125).ngClassPending;
        _ck(_v, 121, 0, currVal_91, currVal_92, currVal_93, currVal_94, currVal_95, currVal_96, currVal_97);
        var currVal_98 = (core_es5["ɵnov"](_v, 128).required ? '' : null);
        var currVal_99 = core_es5["ɵnov"](_v, 134).ngClassUntouched;
        var currVal_100 = core_es5["ɵnov"](_v, 134).ngClassTouched;
        var currVal_101 = core_es5["ɵnov"](_v, 134).ngClassPristine;
        var currVal_102 = core_es5["ɵnov"](_v, 134).ngClassDirty;
        var currVal_103 = core_es5["ɵnov"](_v, 134).ngClassValid;
        var currVal_104 = core_es5["ɵnov"](_v, 134).ngClassInvalid;
        var currVal_105 = core_es5["ɵnov"](_v, 134).ngClassPending;
        _ck(_v, 127, 0, currVal_98, currVal_99, currVal_100, currVal_101, currVal_102, currVal_103, currVal_104, currVal_105);
        var currVal_136 = core_es5["ɵnov"](_v, 159).active;
        var currVal_137 = core_es5["ɵnov"](_v, 159).addClass;
        _ck(_v, 158, 0, currVal_136, currVal_137);
        var currVal_164 = core_es5["ɵnov"](_v, 201).active;
        var currVal_165 = core_es5["ɵnov"](_v, 201).addClass;
        _ck(_v, 200, 0, currVal_164, currVal_165);
        var currVal_172 = core_es5["ɵnov"](_v, 225).active;
        var currVal_173 = core_es5["ɵnov"](_v, 225).addClass;
        _ck(_v, 224, 0, currVal_172, currVal_173);
    });
}
function View_PublicWizardV2Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'public-wizard-v2', [], null, null, null, View_PublicWizardV2Component_0, RenderType_PublicWizardV2Component)), core_es5["ɵdid"](4308992, null, 0, public_wizard_v2_component["a" /* PublicWizardV2Component */], [services_configService["a" /* ConfigService */], services_orderService["a" /* OrderService */], router_es5["a" /* ActivatedRoute */], core_es5["ChangeDetectorRef"],
            google_tag_service["a" /* GoogleTagService */], pageVisitService["a" /* PageVisitService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var PublicWizardV2ComponentNgFactory = core_es5["ɵccf"]('public-wizard-v2', public_wizard_v2_component["a" /* PublicWizardV2Component */], View_PublicWizardV2Component_Host_0, { order: 'order',
    orderItem: 'orderItem', showFirstTab: 'showFirstTab', mainElement: 'mainElement',
    marketingURL: 'marketingURL' }, { getAnotherQuote: 'getAnotherQuote', hideWizard: 'hideWizard',
    setOrderItem: 'setOrderItem', createNewOrder: 'createNewOrder', isQuotePage: 'isQuotePage' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=public-wizard-v2.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/common/helpers/formHelper.ts
var formHelper = __webpack_require__("Pb0k");

// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/collapse/collapse.module.js
var collapse_module = __webpack_require__("7QEy");

// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/accordion/accordion.module.js






var accordion_module_AccordionModule = (function () {
    function AccordionModule() {
    }
    AccordionModule.forRoot = function () { return { ngModule: AccordionModule, providers: [accordion_config_AccordionConfig] }; };
    AccordionModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    imports: [common_es5["CommonModule"], collapse_module["a" /* CollapseModule */]],
                    declarations: [accordion_component_AccordionComponent, accordion_group_component_AccordionPanelComponent],
                    exports: [accordion_component_AccordionComponent, accordion_group_component_AccordionPanelComponent]
                },] },
    ];
    /** @nocollapse */
    AccordionModule.ctorParameters = function () { return []; };
    return AccordionModule;
}());

//# sourceMappingURL=accordion.module.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/alert/alert.config.js

var alert_config_AlertConfig = (function () {
    function AlertConfig() {
        /** default alert type */
        this.type = 'warning';
        /** is alerts are dismissible by default */
        this.dismissible = false;
        /** default time before alert will dismiss */
        this.dismissOnTimeout = undefined;
    }
    AlertConfig.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    AlertConfig.ctorParameters = function () { return []; };
    return AlertConfig;
}());

//# sourceMappingURL=alert.config.js.map
// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/utils/decorators.js
var decorators = __webpack_require__("kHJW");

// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/alert/alert.component.js
var alert_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var alert_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var alert_component_AlertComponent = (function () {
    function AlertComponent(_config) {
        var _this = this;
        /** Alert type. Provides one of four bootstrap supported contextual classes: `success`, `info`, `warning` and `danger` */
        this.type = 'warning';
        /** If set, displays an inline "Close" button */
        this.dismissible = false;
        /** This event fires immediately after close instance method is called, $event is an instance of Alert component. */
        this.onClose = new core_es5["EventEmitter"]();
        /** This event fires when alert closed, $event is an instance of Alert component */
        this.onClosed = new core_es5["EventEmitter"]();
        this.isClosed = false;
        this.classes = '';
        this.dismissibleChange = new core_es5["EventEmitter"]();
        Object.assign(this, _config);
        this.dismissibleChange.subscribe(function (dismissible) {
            _this.classes = _this.dismissible ? 'alert-dismissible' : '';
        });
    }
    AlertComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.dismissOnTimeout) {
            // if dismissOnTimeout used as attr without binding, it will be a string
            setTimeout(function () { return _this.close(); }, parseInt(this.dismissOnTimeout, 10));
        }
    };
    // todo: animation ` If the .fade and .in classes are present on the element,
    // the alert will fade out before it is removed`
    /**
     * Closes an alert by removing it from the DOM.
     */
    AlertComponent.prototype.close = function () {
        if (this.isClosed) {
            return;
        }
        this.onClose.emit(this);
        this.isClosed = true;
        this.onClosed.emit(this);
    };
    AlertComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'alert,ngx-alert',
                    template: "\n<template [ngIf]=\"!isClosed\">\n  <div [class]=\"'alert alert-' + type\" role=\"alert\" [ngClass]=\"classes\">\n    <template [ngIf]=\"dismissible\">\n      <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"close()\">\n        <span aria-hidden=\"true\">&times;</span>\n        <span class=\"sr-only\">Close</span>\n      </button>\n    </template>\n    <ng-content></ng-content>\n  </div>\n</template>\n  "
                },] },
    ];
    /** @nocollapse */
    AlertComponent.ctorParameters = function () { return [
        { type: alert_config_AlertConfig, },
    ]; };
    AlertComponent.propDecorators = {
        'type': [{ type: core_es5["Input"] },],
        'dismissible': [{ type: core_es5["Input"] },],
        'dismissOnTimeout': [{ type: core_es5["Input"] },],
        'onClose': [{ type: core_es5["Output"] },],
        'onClosed': [{ type: core_es5["Output"] },],
    };
    alert_component___decorate([
        Object(decorators["a" /* OnChange */])(),
        alert_component___metadata("design:type", Boolean)
    ], AlertComponent.prototype, "dismissible", void 0);
    return AlertComponent;
}());

//# sourceMappingURL=alert.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/alert/alert.module.js




var alert_module_AlertModule = (function () {
    function AlertModule() {
    }
    AlertModule.forRoot = function () {
        return { ngModule: AlertModule, providers: [alert_config_AlertConfig] };
    };
    AlertModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    imports: [common_es5["CommonModule"]],
                    declarations: [alert_component_AlertComponent],
                    exports: [alert_component_AlertComponent],
                    entryComponents: [alert_component_AlertComponent]
                },] },
    ];
    /** @nocollapse */
    AlertModule.ctorParameters = function () { return []; };
    return AlertModule;
}());

//# sourceMappingURL=alert.module.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/buttons/button-checkbox.directive.js


// TODO: config: activeClass - Class to apply to the checked buttons
var CHECKBOX_CONTROL_VALUE_ACCESSOR = {
    provide: forms_es5["NG_VALUE_ACCESSOR"],
    useExisting: Object(core_es5["forwardRef"])(function () { return button_checkbox_directive_ButtonCheckboxDirective; }),
    multi: true
};
/**
 * Add checkbox functionality to any element
 */
var button_checkbox_directive_ButtonCheckboxDirective = (function () {
    function ButtonCheckboxDirective() {
        /** Truthy value, will be set to ngModel */
        this.btnCheckboxTrue = true;
        /** Falsy value, will be set to ngModel */
        this.btnCheckboxFalse = false;
        this.state = false;
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
    }
    // view -> model
    ButtonCheckboxDirective.prototype.onClick = function () {
        if (this.isDisabled) {
            return;
        }
        this.toggle(!this.state);
        this.onChange(this.value);
    };
    ButtonCheckboxDirective.prototype.ngOnInit = function () {
        this.toggle(this.trueValue === this.value);
    };
    Object.defineProperty(ButtonCheckboxDirective.prototype, "trueValue", {
        get: function () {
            return typeof this.btnCheckboxTrue !== 'undefined'
                ? this.btnCheckboxTrue
                : true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonCheckboxDirective.prototype, "falseValue", {
        get: function () {
            return typeof this.btnCheckboxFalse !== 'undefined'
                ? this.btnCheckboxFalse
                : false;
        },
        enumerable: true,
        configurable: true
    });
    ButtonCheckboxDirective.prototype.toggle = function (state) {
        this.state = state;
        this.value = this.state ? this.trueValue : this.falseValue;
    };
    // ControlValueAccessor
    // model -> view
    ButtonCheckboxDirective.prototype.writeValue = function (value) {
        this.state = this.trueValue === value;
        this.value = value ? this.trueValue : this.falseValue;
    };
    ButtonCheckboxDirective.prototype.setDisabledState = function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    ButtonCheckboxDirective.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    ButtonCheckboxDirective.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    ButtonCheckboxDirective.decorators = [
        { type: core_es5["Directive"], args: [{ selector: '[btnCheckbox]', providers: [CHECKBOX_CONTROL_VALUE_ACCESSOR] },] },
    ];
    /** @nocollapse */
    ButtonCheckboxDirective.ctorParameters = function () { return []; };
    ButtonCheckboxDirective.propDecorators = {
        'btnCheckboxTrue': [{ type: core_es5["Input"] },],
        'btnCheckboxFalse': [{ type: core_es5["Input"] },],
        'state': [{ type: core_es5["HostBinding"], args: ['class.active',] },],
        'onClick': [{ type: core_es5["HostListener"], args: ['click',] },],
    };
    return ButtonCheckboxDirective;
}());

//# sourceMappingURL=button-checkbox.directive.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/buttons/button-radio.directive.js


var RADIO_CONTROL_VALUE_ACCESSOR = {
    provide: forms_es5["NG_VALUE_ACCESSOR"],
    useExisting: Object(core_es5["forwardRef"])(function () { return button_radio_directive_ButtonRadioDirective; }),
    multi: true
};
/**
 * Create radio buttons or groups of buttons.
 * A value of a selected button is bound to a variable specified via ngModel.
 */
var button_radio_directive_ButtonRadioDirective = (function () {
    function ButtonRadioDirective(el, cdr) {
        this.cdr = cdr;
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.el = el;
    }
    Object.defineProperty(ButtonRadioDirective.prototype, "isActive", {
        get: function () {
            return this.btnRadio === this.value;
        },
        enumerable: true,
        configurable: true
    });
    ButtonRadioDirective.prototype.onClick = function () {
        if (this.el.nativeElement.attributes.disabled) {
            return;
        }
        if (this.uncheckable && this.btnRadio === this.value) {
            this.value = undefined;
            this.onTouched();
            this.onChange(this.value);
            return;
        }
        if (this.btnRadio !== this.value) {
            this.value = this.btnRadio;
            this.onTouched();
            this.onChange(this.value);
            return;
        }
    };
    ButtonRadioDirective.prototype.ngOnInit = function () {
        this.uncheckable = typeof this.uncheckable !== 'undefined';
    };
    ButtonRadioDirective.prototype.onBlur = function () {
        this.onTouched();
    };
    // ControlValueAccessor
    // model -> view
    ButtonRadioDirective.prototype.writeValue = function (value) {
        this.value = value;
        this.cdr.markForCheck();
    };
    ButtonRadioDirective.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    ButtonRadioDirective.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    ButtonRadioDirective.decorators = [
        { type: core_es5["Directive"], args: [{ selector: '[btnRadio]', providers: [RADIO_CONTROL_VALUE_ACCESSOR] },] },
    ];
    /** @nocollapse */
    ButtonRadioDirective.ctorParameters = function () { return [
        { type: core_es5["ElementRef"], },
        { type: core_es5["ChangeDetectorRef"], },
    ]; };
    ButtonRadioDirective.propDecorators = {
        'btnRadio': [{ type: core_es5["Input"] },],
        'uncheckable': [{ type: core_es5["Input"] },],
        'value': [{ type: core_es5["Input"] },],
        'isActive': [{ type: core_es5["HostBinding"], args: ['class.active',] },],
        'onClick': [{ type: core_es5["HostListener"], args: ['click',] },],
    };
    return ButtonRadioDirective;
}());

//# sourceMappingURL=button-radio.directive.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/buttons/buttons.module.js



var buttons_module_ButtonsModule = (function () {
    function ButtonsModule() {
    }
    ButtonsModule.forRoot = function () {
        return { ngModule: ButtonsModule, providers: [] };
    };
    ButtonsModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    declarations: [button_checkbox_directive_ButtonCheckboxDirective, button_radio_directive_ButtonRadioDirective],
                    exports: [button_checkbox_directive_ButtonCheckboxDirective, button_radio_directive_ButtonRadioDirective]
                },] },
    ];
    /** @nocollapse */
    ButtonsModule.ctorParameters = function () { return []; };
    return ButtonsModule;
}());

//# sourceMappingURL=buttons.module.js.map
// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/utils/index.js + 1 modules
var utils = __webpack_require__("zhfR");

// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/carousel/carousel.config.js

var carousel_config_CarouselConfig = (function () {
    function CarouselConfig() {
        /** Default interval of auto changing of slides */
        this.interval = 5000;
        /** Is loop of auto changing of slides can be paused */
        this.noPause = false;
        /** Is slides can wrap from the last to the first slide */
        this.noWrap = false;
    }
    CarouselConfig.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    CarouselConfig.ctorParameters = function () { return []; };
    return CarouselConfig;
}());

//# sourceMappingURL=carousel.config.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/carousel/carousel.component.js
// todo: add animation
/***
 * pause (not yet supported) (?string='hover') - event group name which pauses the cycling of the carousel, if hover pauses on mouseenter and resumes on mouseleave
 keyboard (not yet supported) (?boolean=true) - if false carousel will not react to keyboard events
 note: swiping not yet supported
 */
/****
 * Problems:
 * 1) if we set an active slide via model changes, .active class remains on a current slide.
 * 2) if we have only one slide, we shouldn't show prev/next nav buttons
 * 3) if first or last slide is active and noWrap is true, there should be "disabled" class on the nav buttons.
 * 4) default interval should be equal 5000
 */



var Direction;
(function (Direction) {
    Direction[Direction["UNKNOWN"] = 0] = "UNKNOWN";
    Direction[Direction["NEXT"] = 1] = "NEXT";
    Direction[Direction["PREV"] = 2] = "PREV";
})(Direction || (Direction = {}));
/**
 * Base element to create carousel
 */
var carousel_component_CarouselComponent = (function () {
    function CarouselComponent(config, ngZone) {
        this.ngZone = ngZone;
        /** Will be emitted when active slide has been changed. Part of two-way-bindable [(activeSlide)] property */
        this.activeSlideChange = new core_es5["EventEmitter"](false);
        this._slides = new utils["a" /* LinkedList */]();
        this.destroyed = false;
        Object.assign(this, config);
    }
    Object.defineProperty(CarouselComponent.prototype, "activeSlide", {
        get: function () {
            return this._currentActiveSlide;
        },
        /** Index of currently displayed slide(started for 0) */
        set: function (index) {
            if (this._slides.length && index !== this._currentActiveSlide) {
                this._select(index);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselComponent.prototype, "interval", {
        /**
         * Delay of item cycling in milliseconds. If false, carousel won't cycle automatically.
         */
        get: function () {
            return this._interval;
        },
        set: function (value) {
            this._interval = value;
            this.restartTimer();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselComponent.prototype, "slides", {
        get: function () {
            return this._slides.toArray();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselComponent.prototype, "isBs4", {
        get: function () {
            return !Object(utils["b" /* isBs3 */])();
        },
        enumerable: true,
        configurable: true
    });
    CarouselComponent.prototype.ngOnDestroy = function () {
        this.destroyed = true;
    };
    /**
     * Adds new slide. If this slide is first in collection - set it as active and starts auto changing
     * @param slide
     */
    CarouselComponent.prototype.addSlide = function (slide) {
        this._slides.add(slide);
        if (this._slides.length === 1) {
            this._currentActiveSlide = void 0;
            this.activeSlide = 0;
            this.play();
        }
    };
    /**
     * Removes specified slide. If this slide is active - will roll to another slide
     * @param slide
     */
    CarouselComponent.prototype.removeSlide = function (slide) {
        var _this = this;
        var remIndex = this._slides.indexOf(slide);
        if (this._currentActiveSlide === remIndex) {
            // removing of active slide
            var nextSlideIndex_1 = void 0;
            if (this._slides.length > 1) {
                // if this slide last - will roll to first slide, if noWrap flag is FALSE or to previous, if noWrap is TRUE
                // in case, if this slide in middle of collection, index of next slide is same to removed
                nextSlideIndex_1 = !this.isLast(remIndex) ? remIndex :
                    this.noWrap ? remIndex - 1 : 0;
            }
            this._slides.remove(remIndex);
            // prevents exception with changing some value after checking
            setTimeout(function () {
                _this._select(nextSlideIndex_1);
            }, 0);
        }
        else {
            this._slides.remove(remIndex);
            var currentSlideIndex_1 = this.getCurrentSlideIndex();
            setTimeout(function () {
                // after removing, need to actualize index of current active slide
                _this._currentActiveSlide = currentSlideIndex_1;
                _this.activeSlideChange.emit(_this._currentActiveSlide);
            }, 0);
        }
    };
    /**
     * Rolling to next slide
     * @param force: {boolean} if true - will ignore noWrap flag
     */
    CarouselComponent.prototype.nextSlide = function (force) {
        if (force === void 0) { force = false; }
        this.activeSlide = this.findNextSlideIndex(Direction.NEXT, force);
    };
    /**
     * Rolling to previous slide
     * @param force: {boolean} if true - will ignore noWrap flag
     */
    CarouselComponent.prototype.previousSlide = function (force) {
        if (force === void 0) { force = false; }
        this.activeSlide = this.findNextSlideIndex(Direction.PREV, force);
    };
    /**
     * Rolling to specified slide
     * @param index: {number} index of slide, which must be shown
     */
    CarouselComponent.prototype.selectSlide = function (index) {
        this.activeSlide = index;
    };
    /**
     * Starts a auto changing of slides
     */
    CarouselComponent.prototype.play = function () {
        if (!this.isPlaying) {
            this.isPlaying = true;
            this.restartTimer();
        }
    };
    /**
     * Stops a auto changing of slides
     */
    CarouselComponent.prototype.pause = function () {
        if (!this.noPause) {
            this.isPlaying = false;
            this.resetTimer();
        }
    };
    /**
     * Finds and returns index of currently displayed slide
     * @returns {number}
     */
    CarouselComponent.prototype.getCurrentSlideIndex = function () {
        return this._slides.findIndex(function (slide) { return slide.active; });
    };
    /**
     * Defines, whether the specified index is last in collection
     * @param index
     * @returns {boolean}
     */
    CarouselComponent.prototype.isLast = function (index) {
        return index + 1 >= this._slides.length;
    };
    /**
     * Defines next slide index, depending of direction
     * @param direction: Direction(UNKNOWN|PREV|NEXT)
     * @param force: {boolean} if TRUE - will ignore noWrap flag, else will return undefined if next slide require wrapping
     * @returns {any}
     */
    CarouselComponent.prototype.findNextSlideIndex = function (direction, force) {
        var nextSlideIndex = 0;
        if (!force && (this.isLast(this.activeSlide) && direction !== Direction.PREV && this.noWrap)) {
            return void 0;
        }
        switch (direction) {
            case Direction.NEXT:
                // if this is last slide, not force, looping is disabled and need to going forward - select current slide, as a next
                nextSlideIndex = (!this.isLast(this._currentActiveSlide)) ? this._currentActiveSlide + 1 :
                    (!force && this.noWrap) ? this._currentActiveSlide : 0;
                break;
            case Direction.PREV:
                // if this is first slide, not force, looping is disabled and need to going backward - select current slide, as a next
                nextSlideIndex = (this._currentActiveSlide > 0) ? this._currentActiveSlide - 1 :
                    (!force && this.noWrap) ? this._currentActiveSlide : this._slides.length - 1;
                break;
            default:
                throw new Error('Unknown direction');
        }
        return nextSlideIndex;
    };
    /**
     * Sets a slide, which specified through index, as active
     * @param index
     * @private
     */
    CarouselComponent.prototype._select = function (index) {
        if (isNaN(index)) {
            this.pause();
            return;
        }
        var currentSlide = this._slides.get(this._currentActiveSlide);
        if (currentSlide) {
            currentSlide.active = false;
        }
        var nextSlide = this._slides.get(index);
        if (nextSlide) {
            this._currentActiveSlide = index;
            nextSlide.active = true;
            this.activeSlide = index;
            this.activeSlideChange.emit(index);
        }
    };
    /**
     * Starts loop of auto changing of slides
     */
    CarouselComponent.prototype.restartTimer = function () {
        var _this = this;
        this.resetTimer();
        var interval = +this.interval;
        if (!isNaN(interval) && interval > 0) {
            this.currentInterval = this.ngZone.runOutsideAngular(function () {
                return setInterval(function () {
                    var nInterval = +_this.interval;
                    _this.ngZone.run(function () {
                        if (_this.isPlaying && !isNaN(_this.interval) && nInterval > 0 && _this.slides.length) {
                            _this.nextSlide();
                        }
                        else {
                            _this.pause();
                        }
                    });
                }, interval);
            });
        }
    };
    /**
     * Stops loop of auto changing of slides
     */
    CarouselComponent.prototype.resetTimer = function () {
        if (this.currentInterval) {
            clearInterval(this.currentInterval);
            this.currentInterval = void 0;
        }
    };
    CarouselComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'carousel',
                    template: "\n    <div (mouseenter)=\"pause()\" (mouseleave)=\"play()\" (mouseup)=\"play()\" class=\"carousel slide\">\n      <ol class=\"carousel-indicators\" *ngIf=\"slides.length > 1\">\n         <li *ngFor=\"let slidez of slides; let i = index;\" [class.active]=\"slidez.active === true\" (click)=\"selectSlide(i)\"></li>\n      </ol>\n      <div class=\"carousel-inner\"><ng-content></ng-content></div>\n      <a class=\"left carousel-control carousel-control-prev\" [class.disabled]=\"activeSlide === 0 && noWrap\" (click)=\"previousSlide()\" *ngIf=\"slides.length > 1\">\n        <span class=\"icon-prev carousel-control-prev-icon\" aria-hidden=\"true\"></span>\n        <span *ngIf=\"isBs4\" class=\"sr-only\">Previous</span>\n      </a>\n      <a class=\"right carousel-control carousel-control-next\" (click)=\"nextSlide()\"  [class.disabled]=\"isLast(activeSlide) && noWrap\" *ngIf=\"slides.length > 1\">\n        <span class=\"icon-next carousel-control-next-icon\" aria-hidden=\"true\"></span>\n        <span class=\"sr-only\">Next</span>\n      </a>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    CarouselComponent.ctorParameters = function () { return [
        { type: carousel_config_CarouselConfig, },
        { type: core_es5["NgZone"], },
    ]; };
    CarouselComponent.propDecorators = {
        'noWrap': [{ type: core_es5["Input"] },],
        'noPause': [{ type: core_es5["Input"] },],
        'activeSlideChange': [{ type: core_es5["Output"] },],
        'activeSlide': [{ type: core_es5["Input"] },],
        'interval': [{ type: core_es5["Input"] },],
    };
    return CarouselComponent;
}());

//# sourceMappingURL=carousel.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/carousel/slide.component.js


var slide_component_SlideComponent = (function () {
    function SlideComponent(carousel) {
        /** Wraps element by appropriate CSS classes */
        this.addClass = true;
        this.carousel = carousel;
    }
    /** Fires changes in container collection after adding a new slide instance */
    SlideComponent.prototype.ngOnInit = function () {
        this.carousel.addSlide(this);
    };
    /** Fires changes in container collection after removing of this slide instance */
    SlideComponent.prototype.ngOnDestroy = function () {
        this.carousel.removeSlide(this);
    };
    SlideComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'slide',
                    template: "\n    <div [class.active]=\"active\" class=\"item\">\n      <ng-content></ng-content>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    SlideComponent.ctorParameters = function () { return [
        { type: carousel_component_CarouselComponent, },
    ]; };
    SlideComponent.propDecorators = {
        'active': [{ type: core_es5["HostBinding"], args: ['class.active',] }, { type: core_es5["Input"] },],
        'addClass': [{ type: core_es5["HostBinding"], args: ['class.item',] }, { type: core_es5["HostBinding"], args: ['class.carousel-item',] },],
    };
    return SlideComponent;
}());

//# sourceMappingURL=slide.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/carousel/carousel.module.js





var carousel_module_CarouselModule = (function () {
    function CarouselModule() {
    }
    CarouselModule.forRoot = function () {
        return { ngModule: CarouselModule, providers: [] };
    };
    CarouselModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    imports: [common_es5["CommonModule"]],
                    declarations: [slide_component_SlideComponent, carousel_component_CarouselComponent],
                    exports: [slide_component_SlideComponent, carousel_component_CarouselComponent],
                    providers: [carousel_config_CarouselConfig]
                },] },
    ];
    /** @nocollapse */
    CarouselModule.ctorParameters = function () { return []; };
    return CarouselModule;
}());

//# sourceMappingURL=carousel.module.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/utils.js
function zeroFill(num, targetLength, forceSign) {
    var absNumber = "" + Math.abs(num);
    var zerosToFill = targetLength - absNumber.length;
    var sign = num >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}
function mod(n, x) {
    return ((n % x) + x) % x;
}
function utils_absFloor(number) {
    return number < 0
        ? Math.ceil(number) || 0
        : Math.floor(number);
}
function createUTCDate(y, m, d, h, M, s, ms) {
    var date = new Date(Date.UTC.apply(null, arguments));
    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}
//# sourceMappingURL=utils.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/utils/type-checks.js

function isDateValid(date) {
    return date && !isNaN(date.getTime());
}
function isFunction(fn) {
    return fn instanceof Function || Object.prototype.toString.call(fn) === '[object Function]';
}
function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}
function hasOwnProp(a /*object*/, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}
function isObject(input /*object*/) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}
function isUndefined(input) {
    return input === void 0;
}
function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion;
    var value = 0;
    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = utils_absFloor(coercedNumber);
    }
    return value;
}
//# sourceMappingURL=type-checks.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/format-functions.js


var formatFunctions = {};
var formatTokenFunctions = {};
var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken(token, padded, ordinal, callback) {
    var func = callback;
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        var key = padded[0];
        formatTokenFunctions[key] = function (date, format, locale) {
            return zeroFill(func.apply(null, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function (date, format, locale) {
            // todo: fix this
            return locale.ordinal(func.apply(null, arguments), token);
        };
    }
}
function makeFormatFunction(format) {
    var array = format.match(formattingTokens);
    var length = array.length;
    var formatArr = new Array(length);
    for (var i = 0; i < length; i++) {
        formatArr[i] = formatTokenFunctions[array[i]]
            ? formatTokenFunctions[array[i]]
            : removeFormattingTokens(array[i]);
    }
    return function (date, locale) {
        var output = '';
        for (var j = 0; j < length; j++) {
            output += isFunction(formatArr[j])
                ? formatArr[j].call(null, date, format, locale)
                : formatArr[j];
        }
        return output;
    };
}
function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}
//# sourceMappingURL=format-functions.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/utils/date-setters.js
var defaultTimeUnit = {
    year: 0, month: 0, day: 0, hour: 0, minute: 0, seconds: 0
};
function createDate(year, month, day, hour, minute, seconds) {
    if (month === void 0) { month = 0; }
    if (day === void 0) { day = 1; }
    if (hour === void 0) { hour = 0; }
    if (minute === void 0) { minute = 0; }
    if (seconds === void 0) { seconds = 0; }
    var _date = new Date();
    return new Date(year || _date.getFullYear(), month, day, hour, minute, seconds);
}
function shiftDate(date, unit) {
    var _unit = Object.assign({}, defaultTimeUnit, unit);
    return createDate(date.getFullYear() + _unit.year, date.getMonth() + _unit.month, date.getDate() + _unit.day, date.getHours() + _unit.hour, date.getMinutes() + _unit.minute, date.getSeconds() + _unit.seconds);
}
function setDate(date, unit) {
    return createDate(getNum(date.getFullYear(), unit.year), getNum(date.getMonth(), unit.month), getNum(date.getDate(), unit.day), getNum(date.getHours(), unit.hour), getNum(date.getMinutes(), unit.minute), getNum(date.getSeconds(), unit.seconds));
}
function getNum(def, num) {
    return typeof num === 'number' ? num : def;
}
//# sourceMappingURL=date-setters.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/utils/date-getters.js

function getHours(date, isUTC) {
    if (isUTC === void 0) { isUTC = false; }
    return isUTC ? date.getUTCHours() : date.getHours();
}
function getMinutes(date, isUTC) {
    if (isUTC === void 0) { isUTC = false; }
    return isUTC ? date.getUTCMinutes() : date.getMinutes();
}
function getSeconds(date, isUTC) {
    if (isUTC === void 0) { isUTC = false; }
    return isUTC ? date.getUTCSeconds() : date.getSeconds();
}
function getDayOfWeek(date, isUTC) {
    if (isUTC === void 0) { isUTC = false; }
    return isUTC ? date.getUTCDay() : date.getDay();
}
function getDate(date, isUTC) {
    if (isUTC === void 0) { isUTC = false; }
    return isUTC ? date.getUTCDate() : date.getDate();
}
function getMonth(date, isUTC) {
    if (isUTC === void 0) { isUTC = false; }
    return isUTC ? date.getUTCMonth() : date.getMonth();
}
function getFullYear(date, isUTC) {
    if (isUTC === void 0) { isUTC = false; }
    return isUTC ? date.getUTCFullYear() : date.getFullYear();
}
function getFirstDayOfMonth(date) {
    return createDate(date.getFullYear(), date.getMonth(), 1, date.getHours(), date.getMinutes(), date.getSeconds());
}
function daysInMonth(date) {
    return _daysInMonth(date.getFullYear(), date.getMonth());
}
function _daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}
function isFirstDayOfWeek(date, firstDayOfWeek) {
    return date.getDay() === firstDayOfWeek;
}
function isSameMonth(date1, date2) {
    if (!date1 || !date2) {
        return false;
    }
    return isSameYear(date1, date2) && getMonth(date1) === getMonth(date2);
}
function isSameYear(date1, date2) {
    if (!date1 || !date2) {
        return false;
    }
    return getFullYear(date1) === getFullYear(date2);
}
function isSameDay(date1, date2) {
    if (!date1 || !date2) {
        return false;
    }
    return isSameYear(date1, date2) && isSameMonth(date1, date2)
        && getDate(date1) === getDate(date2);
}
//# sourceMappingURL=date-getters.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/units/year.js


// FORMATTING
function getYear(date) {
    return getFullYear(date).toString();
}
addFormatToken('Y', null, null, function (date) {
    var y = getFullYear(date);
    return y <= 9999 ? '' + y : '+' + y;
});
addFormatToken(null, ['YY', 2], null, function (date) {
    return (getFullYear(date) % 100).toString(10);
});
addFormatToken(null, ['YYYY', 4], null, getYear);
addFormatToken(null, ['YYYYY', 5], null, getYear);
addFormatToken(null, ['YYYYYY', 6, true], null, getYear);
function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}
function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}
//# sourceMappingURL=year.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/utils/start-end-of.js

function startOf(date, units) {
    var unit = getDateShift(units);
    return setDate(date, unit);
}
function endOf(date, units) {
    var start = startOf(date, units);
    var shift = (_a = {}, _a[units] = 1, _a);
    var change = shiftDate(start, shift);
    change.setMilliseconds(-1);
    return change;
    var _a;
}
function getDateShift(units) {
    var unit = {};
    switch (units) {
        case 'year':
            unit.month = 0;
        /* falls through */
        case 'month':
            unit.day = 1;
        /* falls through */
        case 'week':
        case 'day':
            unit.hour = 0;
        /* falls through */
        case 'hour':
            unit.minute = 0;
        /* falls through */
        case 'minute':
            unit.seconds = 0;
    }
    return unit;
}
//# sourceMappingURL=start-end-of.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/units/day-of-year.js


// FORMATTING
addFormatToken('DDD', ['DDDD', 3], 'DDDo', function (date) {
    return getDayOfYear(date).toString(10);
});
function getDayOfYear(date) {
    var date1 = +startOf(date, 'day');
    var date2 = +startOf(date, 'year');
    var someDate = date1 - date2;
    var oneDay = 1000 * 60 * 60 * 24;
    return Math.round(someDate / oneDay) + 1;
}
function _getDayOfYear(date) {
    var start = new Date(date.getFullYear(), 0, 0);
    var diff = date.getTime() - start.getTime();
    var oneDay = 1000 * 60 * 60 * 24;
    return Math.round(diff / oneDay) + 1;
}
//# sourceMappingURL=day-of-year.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/units/week-calendar-utils.js
/**
 *
 * @param {number} year
 * @param {number} dow - start-of-first-week
 * @param {number} doy - start-of-year
 * @returns {number}
 */




function firstWeekOffset(year, dow, doy) {
    // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    var fwd = 7 + dow - doy;
    // first-week day local weekday -- which local weekday is fwd
    var fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7;
    var weekOffset = firstWeekOffset(year, dow, doy);
    var dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset;
    var resYear;
    var resDayOfYear;
    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    }
    else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    }
    else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }
    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}
function weekOfYear(date, dow, doy) {
    var weekOffset = firstWeekOffset(getFullYear(date), dow, doy);
    var week = Math.floor((getDayOfYear(date) - weekOffset - 1) / 7) + 1;
    var resWeek;
    var resYear;
    if (week < 1) {
        resYear = getFullYear(date) - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    }
    else if (week > weeksInYear(getFullYear(date), dow, doy)) {
        resWeek = week - weeksInYear(getFullYear(date), dow, doy);
        resYear = getFullYear(date) + 1;
    }
    else {
        resYear = getFullYear(date);
        resWeek = week;
    }
    return {
        week: resWeek,
        year: resYear
    };
}
function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy);
    var weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}
//# sourceMappingURL=week-calendar-utils.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/locale/locale.class.js



var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
var defaultLongDateFormat = {
    LTS: 'h:mm:ss A',
    LT: 'h:mm A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    LLL: 'MMMM D, YYYY h:mm A',
    LLLL: 'dddd, MMMM D, YYYY h:mm A'
};
var locale_class_Locale = (function () {
    function Locale(config) {
        if (!!config) {
            this.set(config);
        }
    }
    Locale.prototype.set = function (config) {
        for (var i in config) {
            if (!config.hasOwnProperty(i)) {
                continue;
            }
            var prop = config[i];
            var key = isFunction(prop) ? i : "_" + i;
            this[key] = prop;
        }
        this._config = config;
    };
    // Months
    // LOCALES
    Locale.prototype.months = function (date, format) {
        if (!date) {
            return isArray(this._months)
                ? this._months
                : this._months.standalone;
        }
        if (isArray(this._months)) {
            return this._months[getMonth(date)];
        }
        var key = (this._months.isFormat || MONTHS_IN_FORMAT)
            .test(format) ? 'format' : 'standalone';
        return this._months[key][getMonth(date)];
    };
    Locale.prototype.monthsShort = function (date, format) {
        if (!date) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort.standalone;
        }
        if (isArray(this._monthsShort)) {
            return this._monthsShort[getMonth(date)];
        }
        var key = MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone';
        return this._monthsShort[key][getMonth(date)];
    };
    // Days of week
    // LOCALES
    Locale.prototype.weekdays = function (date, format) {
        var _isArray = isArray(this._weekdays);
        if (!date) {
            return _isArray
                ? this._weekdays
                : this._weekdays.standalone;
        }
        if (_isArray) {
            return this._weekdays[getDayOfWeek(date)];
        }
        var _key = this._weekdays.isFormat.test(format) ? 'format' : 'standalone';
        return this._weekdays[_key][getDayOfWeek(date)];
    };
    Locale.prototype.weekdaysMin = function (date) {
        return (date) ? this._weekdaysShort[getDayOfWeek(date)] : this._weekdaysShort;
    };
    Locale.prototype.weekdaysShort = function (date) {
        return (date) ? this._weekdaysMin[getDayOfWeek(date)] : this._weekdaysMin;
    };
    Locale.prototype.week = function (date) {
        return weekOfYear(date, this._week.dow, this._week.doy).week;
    };
    Locale.prototype.firstDayOfWeek = function () {
        return this._week.dow;
    };
    Locale.prototype.firstDayOfYear = function () {
        return this._week.doy;
    };
    Locale.prototype.meridiem = function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        }
        return isLower ? 'am' : 'AM';
    };
    Locale.prototype.ordinal = function (num, token) {
        return this._ordinal.replace('%d', num.toString(10));
    };
    Locale.prototype.preparse = function (str) { return str; };
    Locale.prototype.postformat = function (str) { return str; };
    Locale.prototype.longDateFormat = function (key) {
        var format = defaultLongDateFormat[key];
        var formatUpper = defaultLongDateFormat[key.toUpperCase()];
        if (format || !formatUpper) {
            return format;
        }
        defaultLongDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });
        return defaultLongDateFormat[key];
    };
    return Locale;
}());

//# sourceMappingURL=locale.class.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/locale/locale.defaults.js

var defaultInvalidDate = 'Invalid date';
var defaultLocaleWeek = {
    dow: 0,
    doy: 6 // The week that contains Jan 1st is the first week of the year.
};
var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
var baseConfig = {
    // calendar: defaultCalendar,
    // longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    // ordinal: defaultOrdinal,
    // dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    // relativeTime: defaultRelativeTime,
    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,
    week: defaultLocaleWeek,
    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,
    meridiemParse: defaultLocaleMeridiemParse
};
//# sourceMappingURL=locale.defaults.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/locale/locales.service.js
// internal storage for locale config files



var locales = {};
var localeFamilies = {};
var globalLocale;
function chooseLocale(name) {
    return locales[name];
}
// returns locale data
function getLocale(key) {
    if (!key) {
        return globalLocale;
    }
    return chooseLocale(key);
}
function listLocales() {
    return Object.keys(locales);
}
function mergeConfigs(parentConfig, childConfig) {
    var res = Object.assign({}, parentConfig);
    for (var childProp in childConfig) {
        if (!hasOwnProp(childConfig, childProp)) {
            continue;
        }
        if (isObject(parentConfig[childProp]) && isObject(childConfig[childProp])) {
            (res[childProp]) = {};
            Object.assign(res[childProp], parentConfig[childProp]);
            Object.assign(res[childProp], childConfig[childProp]);
        }
        else if (childConfig[childProp] != null) {
            (res[childProp]) = childConfig[childProp];
        }
        else {
            delete res[childProp];
        }
    }
    for (var parentProp in parentConfig) {
        if (hasOwnProp(parentConfig, parentProp) &&
            !hasOwnProp(childConfig, parentProp) &&
            isObject(parentConfig[parentProp])) {
            // make sure changes to properties don't modify parent config
            (res[parentProp]) = Object.assign({}, res[parentProp]);
        }
    }
    return res;
}
// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale(key, values) {
    var data;
    if (key) {
        data = isUndefined(values) ? getLocale(key) : defineLocale(key, values);
        if (data) {
            globalLocale = data;
        }
    }
    return globalLocale._abbr;
}
function defineLocale(name, config) {
    if (config === null) {
        // useful for testing
        delete locales[name];
        return null;
    }
    config.abbr = name;
    locales[name] = new locale_class_Locale(mergeConfigs(baseConfig, config));
    if (localeFamilies[name]) {
        localeFamilies[name].forEach(function (x) {
            defineLocale(x.name, x.config);
        });
    }
    // backwards compat for now: also set the locale
    // make sure we set the locale AFTER all child locales have been
    // created, so we won't end up with the child locale set.
    getSetGlobalLocale(name);
    return locales[name];
}
//# sourceMappingURL=locales.service.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/locale/en.js


getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function (num) {
        var b = num % 10;
        var output = (toInt(num % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                    (b === 3) ? 'rd' : 'th';
        return num + output;
    }
});
//# sourceMappingURL=en.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/locale/index.js

//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/units/day-of-month.js


addFormatToken('D', ['DD', 2], 'Do', function (date) {
    return getDate(date).toString(10);
});
//# sourceMappingURL=day-of-month.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/units/day-of-week.js


// FORMATTING
addFormatToken('d', null, 'do', function (date) {
    return getDayOfWeek(date).toString(10);
});
addFormatToken('dd', null, null, function (date, format, locale) {
    return locale.weekdaysShort(date);
});
addFormatToken('ddd', null, null, function (date, format, locale) {
    return locale.weekdaysMin(date);
});
addFormatToken('dddd', null, null, function (date, format, locale) {
    return locale.weekdays(date, format);
});
addFormatToken('e', null, null, function (date) {
    return getDayOfWeek(date).toString(10);
});
addFormatToken('E', null, null, function (date) {
    return getISODayOfWeek(date).toString(10);
});
function getLocaleDayOfWeek(date, locale) {
    return (getDayOfWeek(date) + 7 - locale.firstDayOfWeek()) % 7;
}
function getISODayOfWeek(date) {
    return getDayOfWeek(date) || 7;
}
//# sourceMappingURL=day-of-week.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/units/hour.js
// import { makeGetSet } from '../moment/get-set';
// import { addFormatToken } from '../format/format';
// import { addUnitAlias } from './aliases';
// import { addUnitPriority } from './priorities';
// import { addRegexToken, match1to2, match2, match3to4, match5to6 } from '../parse/regex';
// import { addParseToken } from '../parse/token';
// import { HOUR, MINUTE, SECOND } from './constants';
// import toInt from '../utils/to-int';
// import zeroFill from '../utils/zero-fill';
// import getParsingFlags from '../create/parsing-flags';
// FORMATTING



function hFormat(date) {
    return getHours(date) % 12 || 12;
}
function kFormat(date) {
    return getHours(date) || 24;
}
addFormatToken('H', ['HH', 2], null, function (date, format, locale) {
    return getHours(date).toString(10);
});
addFormatToken('h', ['hh', 2], null, function (date, format, locale) {
    return hFormat(date).toString(10);
});
addFormatToken('k', ['kk', 2], null, function (date, format, locale) {
    return kFormat(date).toString(10);
});
addFormatToken('hmm', null, null, function (date, format, locale) {
    return "" + hFormat(date) + zeroFill(getMinutes(date), 2);
});
addFormatToken('hmmss', null, null, function (date, format, locale) {
    return "" + hFormat(date) + zeroFill(getMinutes(date), 2) + zeroFill(getSeconds(date), 2);
});
addFormatToken('Hmm', null, null, function (date, format, locale) {
    return "" + getHours(date) + zeroFill(getMinutes(date), 2);
});
addFormatToken('Hmmss', null, null, function (date, format, locale) {
    return "" + getHours(date) + zeroFill(getMinutes(date), 2) + zeroFill(getSeconds(date), 2);
});
function meridiem(token, lowercase) {
    addFormatToken(token, null, null, function (date, format, locale) {
        return locale.meridiem(getHours(date), getMinutes(date), lowercase);
    });
}
meridiem('a', true);
meridiem('A', false);
//# sourceMappingURL=hour.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/units/minute.js


addFormatToken('m', ['mm', 2], null, function (date) {
    return getMinutes(date).toString(10);
});
//# sourceMappingURL=minute.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/units/month.js




function month_daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}
// FORMATTING
addFormatToken('M', ['MM', 2], 'Mo', function (date, format) {
    return (getMonth(date) + 1).toString();
});
addFormatToken('MMM', null, null, function (date, format, locale) {
    return locale.monthsShort(date, format);
});
addFormatToken('MMMM', null, null, function (date, format, locale) {
    return locale.months(date, format);
});
//# sourceMappingURL=month.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/units/second.js


addFormatToken('s', ['ss', 2], null, function (date) {
    return getSeconds(date).toString(10);
});
//# sourceMappingURL=second.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/units/week.js


addFormatToken('w', ['ww', 2], 'wo', function (date, format, locale) {
    return getWeek(date, locale).toString(10);
});
addFormatToken('W', ['WW', 2], 'Wo', function (date) {
    return getISOWeek(date).toString(10);
});
function getWeek(date, locale) {
    return locale.week(date);
}
function getISOWeek(date) {
    return weekOfYear(date, 1, 4).week;
}
//# sourceMappingURL=week.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/units/index.js










//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/format.js
// moment.js
// version : 2.18.1
// authors : Tim Wood, Iskren Chernev, Moment.js contributors
// license : MIT
// momentjs.com





function formatDate(date, format, locale) {
    if (locale === void 0) { locale = 'en'; }
    var _locale = getLocale(locale);
    if (!_locale) {
        throw new Error("Locale \"" + locale + "\" is not defined, please add it with \"defineLocale(...)\"");
    }
    var output = formatMoment(date, format, _locale);
    return _locale.postformat(output);
}
// format date using native date object
function formatMoment(date, format, locale) {
    if (!isDateValid(date)) {
        return locale.invalidDate;
    }
    format = expandFormat(format, locale);
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
    return formatFunctions[format](date, locale);
}
function expandFormat(format, locale) {
    var i = 5;
    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
    var replaceLongDateFormatTokens = function (input) {
        return locale.longDateFormat(input) || input;
    };
    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }
    return format;
}
//# sourceMappingURL=format.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/date-formatter.js

var date_formatter_DateFormatter = (function () {
    function DateFormatter() {
    }
    DateFormatter.prototype.format = function (date, format, locale) {
        return formatDate(date, format, locale);
    };
    return DateFormatter;
}());

//# sourceMappingURL=date-formatter.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/datepicker-inner.component.js
/* tslint:disable:max-file-line-count */


// const MIN_DATE:Date = void 0;
// const MAX_DATE:Date = void 0;
// const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
/*
 const KEYS = {
 13: 'enter',
 32: 'space',
 33: 'pageup',
 34: 'pagedown',
 35: 'end',
 36: 'home',
 37: 'left',
 38: 'up',
 39: 'right',
 40: 'down'
 };
 */
var datepicker_inner_component_DatePickerInnerComponent = (function () {
    function DatePickerInnerComponent() {
        this.selectionDone = new core_es5["EventEmitter"](undefined);
        this.update = new core_es5["EventEmitter"](false);
        this.activeDateChange = new core_es5["EventEmitter"](undefined);
        this.stepDay = {};
        this.stepMonth = {};
        this.stepYear = {};
        this.modes = ['day', 'month', 'year'];
        this.dateFormatter = new date_formatter_DateFormatter();
    }
    Object.defineProperty(DatePickerInnerComponent.prototype, "activeDate", {
        get: function () {
            return this._activeDate;
        },
        set: function (value) {
            this._activeDate = value;
        },
        enumerable: true,
        configurable: true
    });
    // todo: add formatter value to Date object
    DatePickerInnerComponent.prototype.ngOnInit = function () {
        // todo: use date for unique value
        this.uniqueId = 'datepicker-' + '-' + Math.floor(Math.random() * 10000);
        if (this.initDate) {
            this.activeDate = this.initDate;
            this.selectedDate = new Date(this.activeDate.valueOf());
            this.update.emit(this.activeDate);
        }
        else if (this.activeDate === undefined) {
            this.activeDate = new Date();
        }
    };
    // this.refreshView should be called here to reflect the changes on the fly
    // tslint:disable-next-line:no-unused-variable
    DatePickerInnerComponent.prototype.ngOnChanges = function (changes) {
        this.refreshView();
        this.checkIfActiveDateGotUpdated(changes['activeDate']);
    };
    // Check if activeDate has been update and then emit the activeDateChange with the new date
    DatePickerInnerComponent.prototype.checkIfActiveDateGotUpdated = function (activeDate) {
        if (activeDate && !activeDate.firstChange) {
            var previousValue = activeDate.previousValue;
            if (previousValue && previousValue instanceof Date && previousValue.getTime() !== activeDate.currentValue.getTime()) {
                this.activeDateChange.emit(this.activeDate);
            }
        }
    };
    DatePickerInnerComponent.prototype.setCompareHandler = function (handler, type) {
        if (type === 'day') {
            this.compareHandlerDay = handler;
        }
        if (type === 'month') {
            this.compareHandlerMonth = handler;
        }
        if (type === 'year') {
            this.compareHandlerYear = handler;
        }
    };
    DatePickerInnerComponent.prototype.compare = function (date1, date2) {
        if (date1 === undefined || date2 === undefined) {
            return undefined;
        }
        if (this.datepickerMode === 'day' && this.compareHandlerDay) {
            return this.compareHandlerDay(date1, date2);
        }
        if (this.datepickerMode === 'month' && this.compareHandlerMonth) {
            return this.compareHandlerMonth(date1, date2);
        }
        if (this.datepickerMode === 'year' && this.compareHandlerYear) {
            return this.compareHandlerYear(date1, date2);
        }
        return void 0;
    };
    DatePickerInnerComponent.prototype.setRefreshViewHandler = function (handler, type) {
        if (type === 'day') {
            this.refreshViewHandlerDay = handler;
        }
        if (type === 'month') {
            this.refreshViewHandlerMonth = handler;
        }
        if (type === 'year') {
            this.refreshViewHandlerYear = handler;
        }
    };
    DatePickerInnerComponent.prototype.refreshView = function () {
        if (this.datepickerMode === 'day' && this.refreshViewHandlerDay) {
            this.refreshViewHandlerDay();
        }
        if (this.datepickerMode === 'month' && this.refreshViewHandlerMonth) {
            this.refreshViewHandlerMonth();
        }
        if (this.datepickerMode === 'year' && this.refreshViewHandlerYear) {
            this.refreshViewHandlerYear();
        }
    };
    DatePickerInnerComponent.prototype.dateFilter = function (date, format) {
        return this.dateFormatter.format(date, format, this.locale);
    };
    DatePickerInnerComponent.prototype.isActive = function (dateObject) {
        if (this.compare(dateObject.date, this.activeDate) === 0) {
            this.activeDateId = dateObject.uid;
            return true;
        }
        return false;
    };
    DatePickerInnerComponent.prototype.createDateObject = function (date, format) {
        var dateObject = {};
        dateObject.date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        dateObject.label = this.dateFilter(date, format);
        dateObject.selected = this.compare(date, this.selectedDate) === 0;
        dateObject.disabled = this.isDisabled(date);
        dateObject.current = this.compare(date, new Date()) === 0;
        dateObject.customClass = this.getCustomClassForDate(dateObject.date);
        return dateObject;
    };
    DatePickerInnerComponent.prototype.split = function (arr, size) {
        var arrays = [];
        while (arr.length > 0) {
            arrays.push(arr.splice(0, size));
        }
        return arrays;
    };
    // Fix a hard-reproducible bug with timezones
    // The bug depends on OS, browser, current timezone and current date
    // i.e.
    // var date = new Date(2014, 0, 1);
    // console.log(date.getFullYear(), date.getMonth(), date.getDate(),
    // date.getHours()); can result in "2013 11 31 23" because of the bug.
    DatePickerInnerComponent.prototype.fixTimeZone = function (date) {
        var hours = date.getHours();
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours === 23 ? hours + 2 : 0);
    };
    DatePickerInnerComponent.prototype.select = function (date, isManual) {
        if (isManual === void 0) { isManual = true; }
        if (this.datepickerMode === this.minMode) {
            if (!this.activeDate) {
                this.activeDate = new Date(0, 0, 0, 0, 0, 0, 0);
            }
            this.activeDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            if (isManual) {
                this.selectionDone.emit(this.activeDate);
            }
        }
        else {
            this.activeDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            if (isManual) {
                this.datepickerMode = this.modes[this.modes.indexOf(this.datepickerMode) - 1];
            }
        }
        this.selectedDate = new Date(this.activeDate.valueOf());
        this.update.emit(this.activeDate);
        this.refreshView();
    };
    DatePickerInnerComponent.prototype.move = function (direction) {
        var expectedStep;
        if (this.datepickerMode === 'day') {
            expectedStep = this.stepDay;
        }
        if (this.datepickerMode === 'month') {
            expectedStep = this.stepMonth;
        }
        if (this.datepickerMode === 'year') {
            expectedStep = this.stepYear;
        }
        if (expectedStep) {
            var year = this.activeDate.getFullYear() + direction * (expectedStep.years || 0);
            var month = this.activeDate.getMonth() + direction * (expectedStep.months || 0);
            this.activeDate = new Date(year, month, 1);
            this.refreshView();
            this.activeDateChange.emit(this.activeDate);
        }
    };
    DatePickerInnerComponent.prototype.toggleMode = function (direction) {
        direction = direction || 1;
        if ((this.datepickerMode === this.maxMode && direction === 1) ||
            (this.datepickerMode === this.minMode && direction === -1)) {
            return;
        }
        this.datepickerMode = this.modes[this.modes.indexOf(this.datepickerMode) + direction];
        this.refreshView();
    };
    DatePickerInnerComponent.prototype.getCustomClassForDate = function (date) {
        var _this = this;
        if (!this.customClass) {
            return '';
        }
        // todo: build a hash of custom classes, it will work faster
        var customClassObject = this.customClass
            .find(function (customClass) {
            return customClass.date.valueOf() === date.valueOf() &&
                customClass.mode === _this.datepickerMode;
        }, this);
        return customClassObject === undefined ? '' : customClassObject.clazz;
    };
    DatePickerInnerComponent.prototype.compareDateDisabled = function (date1Disabled, date2) {
        if (date1Disabled === undefined || date2 === undefined) {
            return undefined;
        }
        if (date1Disabled.mode === 'day' && this.compareHandlerDay) {
            return this.compareHandlerDay(date1Disabled.date, date2);
        }
        if (date1Disabled.mode === 'month' && this.compareHandlerMonth) {
            return this.compareHandlerMonth(date1Disabled.date, date2);
        }
        if (date1Disabled.mode === 'year' && this.compareHandlerYear) {
            return this.compareHandlerYear(date1Disabled.date, date2);
        }
        return undefined;
    };
    DatePickerInnerComponent.prototype.isDisabled = function (date) {
        var _this = this;
        var isDateDisabled = false;
        if (this.dateDisabled) {
            this.dateDisabled.forEach(function (disabledDate) {
                if (_this.compareDateDisabled(disabledDate, date) === 0) {
                    isDateDisabled = true;
                }
            });
        }
        return (isDateDisabled || (this.minDate && this.compare(date, this.minDate) < 0) ||
            (this.maxDate && this.compare(date, this.maxDate) > 0));
    };
    DatePickerInnerComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'datepicker-inner',
                    template: "\n    <div *ngIf=\"datepickerMode\" class=\"well well-sm bg-faded p-a card\" role=\"application\" ><!--&lt;!&ndash;ng-keydown=\"keydown($event)\"&ndash;&gt;-->\n      <ng-content></ng-content>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    DatePickerInnerComponent.ctorParameters = function () { return []; };
    DatePickerInnerComponent.propDecorators = {
        'locale': [{ type: core_es5["Input"] },],
        'datepickerMode': [{ type: core_es5["Input"] },],
        'startingDay': [{ type: core_es5["Input"] },],
        'yearRange': [{ type: core_es5["Input"] },],
        'minDate': [{ type: core_es5["Input"] },],
        'maxDate': [{ type: core_es5["Input"] },],
        'minMode': [{ type: core_es5["Input"] },],
        'maxMode': [{ type: core_es5["Input"] },],
        'showWeeks': [{ type: core_es5["Input"] },],
        'formatDay': [{ type: core_es5["Input"] },],
        'formatMonth': [{ type: core_es5["Input"] },],
        'formatYear': [{ type: core_es5["Input"] },],
        'formatDayHeader': [{ type: core_es5["Input"] },],
        'formatDayTitle': [{ type: core_es5["Input"] },],
        'formatMonthTitle': [{ type: core_es5["Input"] },],
        'onlyCurrentMonth': [{ type: core_es5["Input"] },],
        'shortcutPropagation': [{ type: core_es5["Input"] },],
        'customClass': [{ type: core_es5["Input"] },],
        'monthColLimit': [{ type: core_es5["Input"] },],
        'yearColLimit': [{ type: core_es5["Input"] },],
        'dateDisabled': [{ type: core_es5["Input"] },],
        'initDate': [{ type: core_es5["Input"] },],
        'selectionDone': [{ type: core_es5["Output"] },],
        'update': [{ type: core_es5["Output"] },],
        'activeDateChange': [{ type: core_es5["Output"] },],
        'activeDate': [{ type: core_es5["Input"] },],
    };
    return DatePickerInnerComponent;
}());

//# sourceMappingURL=datepicker-inner.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/datepicker.config.js

var datepicker_config_DatepickerConfig = (function () {
    function DatepickerConfig() {
        this.locale = 'en';
        this.datepickerMode = 'day';
        this.startingDay = 0;
        this.yearRange = 20;
        this.minMode = 'day';
        this.maxMode = 'year';
        this.showWeeks = true;
        this.formatDay = 'DD';
        this.formatMonth = 'MMMM';
        this.formatYear = 'YYYY';
        this.formatDayHeader = 'dd';
        this.formatDayTitle = 'MMMM YYYY';
        this.formatMonthTitle = 'YYYY';
        this.onlyCurrentMonth = false;
        this.monthColLimit = 3;
        this.yearColLimit = 5;
        this.shortcutPropagation = false;
    }
    DatepickerConfig.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    DatepickerConfig.ctorParameters = function () { return []; };
    return DatepickerConfig;
}());

//# sourceMappingURL=datepicker.config.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/datepicker.component.js




var DATEPICKER_CONTROL_VALUE_ACCESSOR = {
    provide: forms_es5["NG_VALUE_ACCESSOR"],
    useExisting: Object(core_es5["forwardRef"])(function () { return datepicker_datepicker_component_DatePickerComponent; }),
    multi: true
};
/* tslint:disable:component-selector-name component-selector-type */
/* tslint:enable:component-selector-name component-selector-type */
var datepicker_datepicker_component_DatePickerComponent = (function () {
    function DatePickerComponent(config) {
        /** sets datepicker mode, supports: `day`, `month`, `year` */
        this.datepickerMode = 'day';
        /** if false week numbers will be hidden */
        this.showWeeks = true;
        this.selectionDone = new core_es5["EventEmitter"](undefined);
        /** callback to invoke when the activeDate is changed. */
        this.activeDateChange = new core_es5["EventEmitter"](undefined);
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this._now = new Date();
        this.config = config;
        this.configureOptions();
    }
    Object.defineProperty(DatePickerComponent.prototype, "activeDate", {
        /** currently active date */
        get: function () {
            return this._activeDate || this._now;
        },
        set: function (value) {
            this._activeDate = value;
        },
        enumerable: true,
        configurable: true
    });
    DatePickerComponent.prototype.configureOptions = function () {
        Object.assign(this, this.config);
    };
    DatePickerComponent.prototype.onUpdate = function (event) {
        this.activeDate = event;
        this.onChange(event);
    };
    DatePickerComponent.prototype.onSelectionDone = function (event) {
        this.selectionDone.emit(event);
    };
    DatePickerComponent.prototype.onActiveDateChange = function (event) {
        this.activeDateChange.emit(event);
    };
    // todo: support null value
    DatePickerComponent.prototype.writeValue = function (value) {
        if (this._datePicker.compare(value, this._activeDate) === 0) {
            return;
        }
        if (value && value instanceof Date) {
            this.activeDate = value;
            this._datePicker.select(value, false);
            return;
        }
        this.activeDate = value ? new Date(value) : void 0;
    };
    DatePickerComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    DatePickerComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    DatePickerComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'datepicker',
                    template: "\n    <datepicker-inner [activeDate]=\"activeDate\"\n                      (update)=\"onUpdate($event)\"\n                      [locale]=\"config.locale\"\n                      [datepickerMode]=\"datepickerMode\"\n                      [initDate]=\"initDate\"\n                      [minDate]=\"minDate\"\n                      [maxDate]=\"maxDate\"\n                      [minMode]=\"minMode\"\n                      [maxMode]=\"maxMode\"\n                      [showWeeks]=\"showWeeks\"\n                      [formatDay]=\"formatDay\"\n                      [formatMonth]=\"formatMonth\"\n                      [formatYear]=\"formatYear\"\n                      [formatDayHeader]=\"formatDayHeader\"\n                      [formatDayTitle]=\"formatDayTitle\"\n                      [formatMonthTitle]=\"formatMonthTitle\"\n                      [startingDay]=\"startingDay\"\n                      [yearRange]=\"yearRange\"\n                      [customClass]=\"customClass\"\n                      [dateDisabled]=\"dateDisabled\"\n                      [onlyCurrentMonth]=\"onlyCurrentMonth\"\n                      [shortcutPropagation]=\"shortcutPropagation\"\n                      [monthColLimit]=\"monthColLimit\"\n                      [yearColLimit]=\"yearColLimit\"\n                      (selectionDone)=\"onSelectionDone($event)\"\n                      (activeDateChange)=\"onActiveDateChange($event)\">\n      <daypicker tabindex=\"0\"></daypicker>\n      <monthpicker tabindex=\"0\"></monthpicker>\n      <yearpicker tabindex=\"0\"></yearpicker>\n    </datepicker-inner>\n    ",
                    providers: [DATEPICKER_CONTROL_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    DatePickerComponent.ctorParameters = function () { return [
        { type: datepicker_config_DatepickerConfig, },
    ]; };
    DatePickerComponent.propDecorators = {
        'datepickerMode': [{ type: core_es5["Input"] },],
        'initDate': [{ type: core_es5["Input"] },],
        'minDate': [{ type: core_es5["Input"] },],
        'maxDate': [{ type: core_es5["Input"] },],
        'minMode': [{ type: core_es5["Input"] },],
        'maxMode': [{ type: core_es5["Input"] },],
        'showWeeks': [{ type: core_es5["Input"] },],
        'formatDay': [{ type: core_es5["Input"] },],
        'formatMonth': [{ type: core_es5["Input"] },],
        'formatYear': [{ type: core_es5["Input"] },],
        'formatDayHeader': [{ type: core_es5["Input"] },],
        'formatDayTitle': [{ type: core_es5["Input"] },],
        'formatMonthTitle': [{ type: core_es5["Input"] },],
        'startingDay': [{ type: core_es5["Input"] },],
        'yearRange': [{ type: core_es5["Input"] },],
        'onlyCurrentMonth': [{ type: core_es5["Input"] },],
        'shortcutPropagation': [{ type: core_es5["Input"] },],
        'monthColLimit': [{ type: core_es5["Input"] },],
        'yearColLimit': [{ type: core_es5["Input"] },],
        'customClass': [{ type: core_es5["Input"] },],
        'dateDisabled': [{ type: core_es5["Input"] },],
        'activeDate': [{ type: core_es5["Input"] },],
        'selectionDone': [{ type: core_es5["Output"] },],
        'activeDateChange': [{ type: core_es5["Output"] },],
        '_datePicker': [{ type: core_es5["ViewChild"], args: [datepicker_inner_component_DatePickerInnerComponent,] },],
    };
    return DatePickerComponent;
}());

//# sourceMappingURL=datepicker.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/daypicker.component.js



var daypicker_component_DayPickerComponent = (function () {
    function DayPickerComponent(datePicker) {
        this.labels = [];
        this.rows = [];
        this.weekNumbers = [];
        this.datePicker = datePicker;
    }
    Object.defineProperty(DayPickerComponent.prototype, "isBs4", {
        get: function () {
            return !Object(ng2_bootstrap_config["a" /* isBs3 */])();
        },
        enumerable: true,
        configurable: true
    });
    /*protected getDaysInMonth(year:number, month:number) {
     return ((month === 1) && (year % 4 === 0) &&
     ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
     }*/
    DayPickerComponent.prototype.ngOnInit = function () {
        var self = this;
        this.datePicker.stepDay = { months: 1 };
        this.datePicker.setRefreshViewHandler(function () {
            var year = this.activeDate.getFullYear();
            var month = this.activeDate.getMonth();
            var firstDayOfMonth = new Date(year, month, 1);
            var difference = this.startingDay - firstDayOfMonth.getDay();
            var numDisplayedFromPreviousMonth = (difference > 0)
                ? 7 - difference
                : -difference;
            var firstDate = new Date(firstDayOfMonth.getTime());
            if (numDisplayedFromPreviousMonth > 0) {
                firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
            }
            // 42 is the number of days on a six-week calendar
            var _days = self.getDates(firstDate, 42);
            var days = [];
            for (var i = 0; i < 42; i++) {
                var _dateObject = this.createDateObject(_days[i], this.formatDay);
                _dateObject.secondary = _days[i].getMonth() !== month;
                _dateObject.uid = this.uniqueId + '-' + i;
                days[i] = _dateObject;
            }
            self.labels = [];
            for (var j = 0; j < 7; j++) {
                self.labels[j] = {};
                self.labels[j].abbr = this.dateFilter(days[j].date, this.formatDayHeader);
                self.labels[j].full = this.dateFilter(days[j].date, 'EEEE');
            }
            self.title = this.dateFilter(this.activeDate, this.formatDayTitle);
            self.rows = this.split(days, 7);
            if (this.showWeeks) {
                self.weekNumbers = [];
                var thursdayIndex = (4 + 7 - this.startingDay) % 7;
                var numWeeks = self.rows.length;
                for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
                    self.weekNumbers.push(self.getISO8601WeekNumber(self.rows[curWeek][thursdayIndex].date));
                }
            }
        }, 'day');
        this.datePicker.setCompareHandler(function (date1, date2) {
            var d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
            var d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
            return d1.getTime() - d2.getTime();
        }, 'day');
        this.datePicker.refreshView();
    };
    DayPickerComponent.prototype.getDates = function (startDate, n) {
        var dates = new Array(n);
        var current = new Date(startDate.getTime());
        var i = 0;
        var date;
        while (i < n) {
            date = new Date(current.getTime());
            date = this.datePicker.fixTimeZone(date);
            dates[i++] = date;
            current = new Date(current.getFullYear(), current.getMonth(), current.getDate() + 1);
        }
        return dates;
    };
    DayPickerComponent.prototype.getISO8601WeekNumber = function (date) {
        var checkDate = new Date(date.getTime());
        // Thursday
        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));
        var time = checkDate.getTime();
        // Compare with Jan 1
        checkDate.setMonth(0);
        checkDate.setDate(1);
        return Math.floor(Math.round((time - checkDate.getTime()) / 86400000) / 7) + 1;
    };
    // todo: key events implementation
    DayPickerComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'daypicker',
                    template: "\n<table *ngIf=\"datePicker.datepickerMode==='day'\" role=\"grid\" [attr.aria-labelledby]=\"datePicker.uniqueId+'-title'\" aria-activedescendant=\"activeDateId\">\n  <thead>\n    <tr>\n      <th>\n        <button *ngIf=\"!isBs4\"\n                type=\"button\"\n                class=\"btn btn-default btn-secondary btn-sm pull-left float-left\"\n                (click)=\"datePicker.move(-1)\"\n                tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-left\"></i>\n        </button>\n        <button *ngIf=\"isBs4\"\n                type=\"button\"\n                class=\"btn btn-default btn-secondary btn-sm pull-left float-left\"\n                (click)=\"datePicker.move(-1)\"\n                tabindex=\"-1\">&lt;\n        </button>\n      </th>\n      <th [attr.colspan]=\"5 + (datePicker.showWeeks ? 1 : 0)\">\n        <button [id]=\"datePicker.uniqueId + '-title'\"\n                type=\"button\" class=\"btn btn-default btn-secondary btn-sm\"\n                (click)=\"datePicker.toggleMode()\"\n                [disabled]=\"datePicker.datepickerMode === datePicker.maxMode\"\n                [ngClass]=\"{disabled: datePicker.datepickerMode === datePicker.maxMode}\" tabindex=\"-1\" style=\"width:100%;\">\n          <strong>{{title}}</strong>\n        </button>\n      </th>\n      <th>\n        <button *ngIf=\"!isBs4\"\n                type=\"button\"\n                class=\"btn btn-default btn-secondary btn-sm pull-right float-right\"\n                (click)=\"datePicker.move(1)\"\n                tabindex=\"-1\">\n          <i  class=\"glyphicon glyphicon-chevron-right\"></i>\n        </button>\n        <button *ngIf=\"isBs4\"\n                type=\"button\"\n                class=\"btn btn-default btn-secondary btn-sm pull-right float-right\"\n                (click)=\"datePicker.move(1)\"\n                tabindex=\"-1\">&gt;\n        </button>\n      </th>\n    </tr>\n    <tr>\n      <th *ngIf=\"datePicker.showWeeks\"></th>\n      <th *ngFor=\"let labelz of labels\" class=\"text-center\">\n        <small aria-label=\"labelz.full\"><b>{{labelz.abbr}}</b></small>\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <template ngFor [ngForOf]=\"rows\" let-rowz=\"$implicit\" let-index=\"index\">\n      <tr *ngIf=\"!(datePicker.onlyCurrentMonth && rowz[0].secondary && rowz[6].secondary)\">\n        <td *ngIf=\"datePicker.showWeeks\" class=\"h6\" class=\"text-center\">\n          <em>{{ weekNumbers[index] }}</em>\n        </td>\n        <td *ngFor=\"let dtz of rowz\" class=\"text-center\" role=\"gridcell\" [id]=\"dtz.uid\">\n          <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-sm {{dtz.customClass}}\"\n                  *ngIf=\"!(datePicker.onlyCurrentMonth && dtz.secondary)\"\n                  [ngClass]=\"{'btn-secondary': isBs4 && !dtz.selected && !datePicker.isActive(dtz), 'btn-info': dtz.selected, disabled: dtz.disabled, active: !isBs4 && datePicker.isActive(dtz), 'btn-default': !isBs4}\"\n                  [disabled]=\"dtz.disabled\"\n                  (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\">\n            <span [ngClass]=\"{'text-muted': dtz.secondary || dtz.current, 'text-info': !isBs4 && dtz.current}\">{{dtz.label}}</span>\n          </button>\n        </td>\n      </tr>\n    </template>\n  </tbody>\n</table>\n  ",
                    styles: ["\n    :host .btn-secondary {\n      color: #292b2c;\n      background-color: #fff;\n      border-color: #ccc;\n    }\n    :host .btn-info .text-muted {\n      color: #292b2c !important;\n    }\n  "]
                },] },
    ];
    /** @nocollapse */
    DayPickerComponent.ctorParameters = function () { return [
        { type: datepicker_inner_component_DatePickerInnerComponent, },
    ]; };
    return DayPickerComponent;
}());

//# sourceMappingURL=daypicker.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/monthpicker.component.js



var monthpicker_component_MonthPickerComponent = (function () {
    function MonthPickerComponent(datePicker) {
        this.rows = [];
        this.datePicker = datePicker;
    }
    Object.defineProperty(MonthPickerComponent.prototype, "isBs4", {
        get: function () {
            return !Object(ng2_bootstrap_config["a" /* isBs3 */])();
        },
        enumerable: true,
        configurable: true
    });
    MonthPickerComponent.prototype.ngOnInit = function () {
        var self = this;
        this.datePicker.stepMonth = { years: 1 };
        this.datePicker.setRefreshViewHandler(function () {
            var months = new Array(12);
            var year = this.activeDate.getFullYear();
            var date;
            for (var i = 0; i < 12; i++) {
                date = new Date(year, i, 1);
                date = this.fixTimeZone(date);
                months[i] = this.createDateObject(date, this.formatMonth);
                months[i].uid = this.uniqueId + '-' + i;
            }
            self.title = this.dateFilter(this.activeDate, this.formatMonthTitle);
            self.rows = this.split(months, self.datePicker.monthColLimit);
        }, 'month');
        this.datePicker.setCompareHandler(function (date1, date2) {
            var d1 = new Date(date1.getFullYear(), date1.getMonth());
            var d2 = new Date(date2.getFullYear(), date2.getMonth());
            return d1.getTime() - d2.getTime();
        }, 'month');
        this.datePicker.refreshView();
    };
    // todo: key events implementation
    MonthPickerComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'monthpicker',
                    template: "\n<table *ngIf=\"datePicker.datepickerMode==='month'\" role=\"grid\">\n  <thead>\n    <tr>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-left float-left\"\n                (click)=\"datePicker.move(-1)\" tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-left\"></i>\n        </button></th>\n      <th [attr.colspan]=\"((datePicker.monthColLimit - 2) <= 0) ? 1 : datePicker.monthColLimit - 2\">\n        <button [id]=\"datePicker.uniqueId + '-title'\"\n                type=\"button\" class=\"btn btn-default btn-sm\"\n                (click)=\"datePicker.toggleMode()\"\n                [disabled]=\"datePicker.datepickerMode === maxMode\"\n                [ngClass]=\"{disabled: datePicker.datepickerMode === maxMode}\" tabindex=\"-1\" style=\"width:100%;\">\n          <strong>{{title}}</strong>\n        </button>\n      </th>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-right float-right\"\n                (click)=\"datePicker.move(1)\" tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-right\"></i>\n        </button>\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr *ngFor=\"let rowz of rows\">\n      <td *ngFor=\"let dtz of rowz\" class=\"text-center\" role=\"gridcell\" id=\"{{dtz.uid}}\" [ngClass]=\"dtz.customClass\">\n        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\"\n                [ngClass]=\"{'btn-link': isBs4 && !dtz.selected && !datePicker.isActive(dtz), 'btn-info': dtz.selected || (isBs4 && !dtz.selected && datePicker.isActive(dtz)), disabled: dtz.disabled, active: !isBs4 && datePicker.isActive(dtz)}\"\n                [disabled]=\"dtz.disabled\"\n                (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\">\n          <span [ngClass]=\"{'text-success': isBs4 && dtz.current, 'text-info': !isBs4 && dtz.current}\">{{dtz.label}}</span>\n        </button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n  ",
                    styles: ["\n    :host .btn-info .text-success {\n      color: #fff !important;\n    }\n  "]
                },] },
    ];
    /** @nocollapse */
    MonthPickerComponent.ctorParameters = function () { return [
        { type: datepicker_inner_component_DatePickerInnerComponent, },
    ]; };
    return MonthPickerComponent;
}());

//# sourceMappingURL=monthpicker.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/yearpicker.component.js



var yearpicker_component_YearPickerComponent = (function () {
    function YearPickerComponent(datePicker) {
        this.rows = [];
        this.datePicker = datePicker;
    }
    Object.defineProperty(YearPickerComponent.prototype, "isBs4", {
        get: function () {
            return !Object(ng2_bootstrap_config["a" /* isBs3 */])();
        },
        enumerable: true,
        configurable: true
    });
    YearPickerComponent.prototype.ngOnInit = function () {
        var self = this;
        this.datePicker.stepYear = { years: this.datePicker.yearRange };
        this.datePicker.setRefreshViewHandler(function () {
            var years = new Array(this.yearRange);
            var date;
            var start = self.getStartingYear(this.activeDate.getFullYear());
            for (var i = 0; i < this.yearRange; i++) {
                date = new Date(start + i, 0, 1);
                date = this.fixTimeZone(date);
                years[i] = this.createDateObject(date, this.formatYear);
                years[i].uid = this.uniqueId + '-' + i;
            }
            self.title = [years[0].label,
                years[this.yearRange - 1].label].join(' - ');
            self.rows = this.split(years, self.datePicker.yearColLimit);
        }, 'year');
        this.datePicker.setCompareHandler(function (date1, date2) {
            return date1.getFullYear() - date2.getFullYear();
        }, 'year');
        this.datePicker.refreshView();
    };
    YearPickerComponent.prototype.getStartingYear = function (year) {
        // todo: parseInt
        return ((year - 1) / this.datePicker.yearRange) * this.datePicker.yearRange + 1;
    };
    YearPickerComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'yearpicker',
                    template: "\n<table *ngIf=\"datePicker.datepickerMode==='year'\" role=\"grid\">\n  <thead>\n    <tr>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-left float-left\"\n                (click)=\"datePicker.move(-1)\" tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-left\"></i>\n        </button>\n      </th>\n      <th [attr.colspan]=\"((datePicker.yearColLimit - 2) <= 0) ? 1 : datePicker.yearColLimit - 2\">\n        <button [id]=\"datePicker.uniqueId + '-title'\" role=\"heading\"\n                type=\"button\" class=\"btn btn-default btn-sm\"\n                (click)=\"datePicker.toggleMode()\"\n                [disabled]=\"datePicker.datepickerMode === datePicker.maxMode\"\n                [ngClass]=\"{disabled: datePicker.datepickerMode === datePicker.maxMode}\" tabindex=\"-1\" style=\"width:100%;\">\n          <strong>{{title}}</strong>\n        </button>\n      </th>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-right float-right\"\n                (click)=\"datePicker.move(1)\" tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-right\"></i>\n        </button>\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr *ngFor=\"let rowz of rows\">\n      <td *ngFor=\"let dtz of rowz\" class=\"text-center\" role=\"gridcell\">\n        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\"\n                [ngClass]=\"{'btn-link': isBs4 && !dtz.selected && !datePicker.isActive(dtz), 'btn-info': dtz.selected || (isBs4 && !dtz.selected && datePicker.isActive(dtz)), disabled: dtz.disabled, active: !isBs4 && datePicker.isActive(dtz)}\"\n                [disabled]=\"dtz.disabled\"\n                (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\">\n          <span [ngClass]=\"{'text-success': isBs4 && dtz.current, 'text-info': !isBs4 && dtz.current}\">{{dtz.label}}</span>\n        </button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n  ",
                    styles: ["\n    :host .btn-info .text-success {\n      color: #fff !important;\n    }\n  "]
                },] },
    ];
    /** @nocollapse */
    YearPickerComponent.ctorParameters = function () { return [
        { type: datepicker_inner_component_DatePickerInnerComponent, },
    ]; };
    return YearPickerComponent;
}());

//# sourceMappingURL=yearpicker.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/datepicker.module.js









var datepicker_module_DatepickerModule = (function () {
    function DatepickerModule() {
    }
    DatepickerModule.forRoot = function () {
        return { ngModule: DatepickerModule, providers: [datepicker_config_DatepickerConfig] };
    };
    DatepickerModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    imports: [common_es5["CommonModule"], forms_es5["FormsModule"]],
                    declarations: [datepicker_datepicker_component_DatePickerComponent, datepicker_inner_component_DatePickerInnerComponent, daypicker_component_DayPickerComponent,
                        monthpicker_component_MonthPickerComponent, yearpicker_component_YearPickerComponent],
                    exports: [datepicker_datepicker_component_DatePickerComponent, datepicker_inner_component_DatePickerInnerComponent, daypicker_component_DayPickerComponent,
                        monthpicker_component_MonthPickerComponent, yearpicker_component_YearPickerComponent],
                    entryComponents: [datepicker_datepicker_component_DatePickerComponent]
                },] },
    ];
    /** @nocollapse */
    DatepickerModule.ctorParameters = function () { return []; };
    return DatepickerModule;
}());

//# sourceMappingURL=datepicker.module.js.map
// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/dropdown/bs-dropdown.module.js
var bs_dropdown_module = __webpack_require__("xvT5");

// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/modal/modal.module.js
var modal_module = __webpack_require__("h+R6");

// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/pagination/pagination.config.js
// todo: split

/** Provides default values for Pagination and pager components */
var pagination_config_PaginationConfig = (function () {
    function PaginationConfig() {
        this.main = {
            maxSize: void 0,
            itemsPerPage: 10,
            boundaryLinks: false,
            directionLinks: true,
            firstText: 'First',
            previousText: 'Previous',
            nextText: 'Next',
            lastText: 'Last',
            pageBtnClass: '',
            rotate: true
        };
        this.pager = {
            itemsPerPage: 15,
            previousText: '« Previous',
            nextText: 'Next »',
            pageBtnClass: '',
            align: true
        };
    }
    PaginationConfig.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    PaginationConfig.ctorParameters = function () { return []; };
    return PaginationConfig;
}());

//# sourceMappingURL=pagination.config.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/pagination/pager.component.js



var PAGER_CONTROL_VALUE_ACCESSOR = {
    provide: forms_es5["NG_VALUE_ACCESSOR"],
    useExisting: Object(core_es5["forwardRef"])(function () { return pager_component_PagerComponent; }),
    multi: true
};
var PAGER_TEMPLATE = "\n    <ul class=\"pager\">\n      <li [class.disabled]=\"noPrevious()\" [class.previous]=\"align\" [ngClass]=\"{'pull-right': align, 'float-right': align}\" class=\"{{ pageBtnClass }}\">\n        <a href (click)=\"selectPage(page - 1, $event)\">{{getText('previous')}}</a>\n      </li>\n      <li [class.disabled]=\"noNext()\" [class.next]=\"align\" [ngClass]=\"{'pull-right': align, 'float-right': align}\" class=\"{{ pageBtnClass }}\">\n        <a href (click)=\"selectPage(page + 1, $event)\">{{getText('next')}}</a>\n      </li>\n  </ul>\n";
var pager_component_PagerComponent = (function () {
    function PagerComponent(renderer, elementRef, paginationConfig) {
        /** fired when total pages count changes, $event:number equals to total pages count */
        this.numPages = new core_es5["EventEmitter"]();
        /** fired when page was changed, $event:{page, itemsPerPage} equals to object with current page index and number of items per page */
        this.pageChanged = new core_es5["EventEmitter"]();
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.inited = false;
        this._page = 1;
        this.renderer = renderer;
        this.elementRef = elementRef;
        if (!this.config) {
            this.configureOptions(Object.assign({}, paginationConfig.main, paginationConfig.pager));
        }
    }
    Object.defineProperty(PagerComponent.prototype, "itemsPerPage", {
        /** maximum number of items per page. If value less than 1 will display all items on one page */
        get: function () {
            return this._itemsPerPage;
        },
        set: function (v) {
            this._itemsPerPage = v;
            this.totalPages = this.calculateTotalPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagerComponent.prototype, "totalItems", {
        /** total number of items in all pages */
        get: function () {
            return this._totalItems;
        },
        set: function (v) {
            this._totalItems = v;
            this.totalPages = this.calculateTotalPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagerComponent.prototype, "totalPages", {
        get: function () {
            return this._totalPages;
        },
        set: function (v) {
            this._totalPages = v;
            this.numPages.emit(v);
            if (this.inited) {
                this.selectPage(this.page);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagerComponent.prototype, "page", {
        get: function () {
            return this._page;
        },
        set: function (value) {
            var _previous = this._page;
            this._page = (value > this.totalPages) ? this.totalPages : (value || 1);
            if (_previous === this._page || typeof _previous === 'undefined') {
                return;
            }
            this.pageChanged.emit({
                page: this._page,
                itemsPerPage: this.itemsPerPage
            });
        },
        enumerable: true,
        configurable: true
    });
    PagerComponent.prototype.configureOptions = function (config) {
        this.config = Object.assign({}, config);
    };
    PagerComponent.prototype.ngOnInit = function () {
        this.classMap = this.elementRef.nativeElement.getAttribute('class') || '';
        // watch for maxSize
        this.maxSize = typeof this.maxSize !== 'undefined'
            ? this.maxSize
            : this.config.maxSize;
        this.rotate = typeof this.rotate !== 'undefined'
            ? this.rotate
            : this.config.rotate;
        this.boundaryLinks = typeof this.boundaryLinks !== 'undefined'
            ? this.boundaryLinks
            : this.config.boundaryLinks;
        this.directionLinks = typeof this.directionLinks !== 'undefined'
            ? this.directionLinks
            : this.config.directionLinks;
        this.pageBtnClass = typeof this.pageBtnClass !== 'undefined'
            ? this.pageBtnClass
            : this.config.pageBtnClass;
        // base class
        this.itemsPerPage = typeof this.itemsPerPage !== 'undefined'
            ? this.itemsPerPage
            : this.config.itemsPerPage;
        this.totalPages = this.calculateTotalPages();
        // this class
        this.pages = this.getPages(this.page, this.totalPages);
        this.inited = true;
    };
    PagerComponent.prototype.writeValue = function (value) {
        this.page = value;
        this.pages = this.getPages(this.page, this.totalPages);
    };
    PagerComponent.prototype.getText = function (key) {
        return this[key + 'Text'] || this.config[key + 'Text'];
    };
    PagerComponent.prototype.noPrevious = function () {
        return this.page === 1;
    };
    PagerComponent.prototype.noNext = function () {
        return this.page === this.totalPages;
    };
    PagerComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    PagerComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    PagerComponent.prototype.selectPage = function (page, event) {
        if (event) {
            event.preventDefault();
        }
        if (!this.disabled) {
            if (event && event.target) {
                var target = event.target;
                target.blur();
            }
            this.writeValue(page);
            this.onChange(this.page);
        }
    };
    // Create page object used in template
    PagerComponent.prototype.makePage = function (num, text, active) {
        return { text: text, number: num, active: active };
    };
    PagerComponent.prototype.getPages = function (currentPage, totalPages) {
        var pages = [];
        // Default page limits
        var startPage = 1;
        var endPage = totalPages;
        var isMaxSized = typeof this.maxSize !== 'undefined' && this.maxSize < totalPages;
        // recompute if maxSize
        if (isMaxSized) {
            if (this.rotate) {
                // Current page is displayed in the middle of the visible ones
                startPage = Math.max(currentPage - Math.floor(this.maxSize / 2), 1);
                endPage = startPage + this.maxSize - 1;
                // Adjust if limit is exceeded
                if (endPage > totalPages) {
                    endPage = totalPages;
                    startPage = endPage - this.maxSize + 1;
                }
            }
            else {
                // Visible pages are paginated with maxSize
                startPage = ((Math.ceil(currentPage / this.maxSize) - 1) * this.maxSize) + 1;
                // Adjust last page if limit is exceeded
                endPage = Math.min(startPage + this.maxSize - 1, totalPages);
            }
        }
        // Add page number links
        for (var num = startPage; num <= endPage; num++) {
            var page = this.makePage(num, num.toString(), num === currentPage);
            pages.push(page);
        }
        // Add links to move between page sets
        if (isMaxSized && !this.rotate) {
            if (startPage > 1) {
                var previousPageSet = this.makePage(startPage - 1, '...', false);
                pages.unshift(previousPageSet);
            }
            if (endPage < totalPages) {
                var nextPageSet = this.makePage(endPage + 1, '...', false);
                pages.push(nextPageSet);
            }
        }
        return pages;
    };
    // base class
    PagerComponent.prototype.calculateTotalPages = function () {
        var totalPages = this.itemsPerPage < 1
            ? 1
            : Math.ceil(this.totalItems / this.itemsPerPage);
        return Math.max(totalPages || 0, 1);
    };
    PagerComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'pager',
                    template: PAGER_TEMPLATE,
                    providers: [PAGER_CONTROL_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    PagerComponent.ctorParameters = function () { return [
        { type: core_es5["Renderer"], },
        { type: core_es5["ElementRef"], },
        { type: pagination_config_PaginationConfig, },
    ]; };
    PagerComponent.propDecorators = {
        'align': [{ type: core_es5["Input"] },],
        'maxSize': [{ type: core_es5["Input"] },],
        'boundaryLinks': [{ type: core_es5["Input"] },],
        'directionLinks': [{ type: core_es5["Input"] },],
        'firstText': [{ type: core_es5["Input"] },],
        'previousText': [{ type: core_es5["Input"] },],
        'nextText': [{ type: core_es5["Input"] },],
        'lastText': [{ type: core_es5["Input"] },],
        'rotate': [{ type: core_es5["Input"] },],
        'pageBtnClass': [{ type: core_es5["Input"] },],
        'disabled': [{ type: core_es5["Input"] },],
        'numPages': [{ type: core_es5["Output"] },],
        'pageChanged': [{ type: core_es5["Output"] },],
        'itemsPerPage': [{ type: core_es5["Input"] },],
        'totalItems': [{ type: core_es5["Input"] },],
    };
    return PagerComponent;
}());

//# sourceMappingURL=pager.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/pagination/pagination.component.js



var PAGINATION_CONTROL_VALUE_ACCESSOR = {
    provide: forms_es5["NG_VALUE_ACCESSOR"],
    useExisting: Object(core_es5["forwardRef"])(function () { return pagination_component_PaginationComponent; }),
    multi: true
};
var PAGINATION_TEMPLATE = "\n  <ul class=\"pagination\" [ngClass]=\"classMap\">\n    <li class=\"pagination-first page-item\"\n        *ngIf=\"boundaryLinks\"\n        [class.disabled]=\"noPrevious()||disabled\">\n      <a class=\"page-link\" href (click)=\"selectPage(1, $event)\" [innerHTML]=\"getText('first')\"></a>\n    </li>\n\n    <li class=\"pagination-prev page-item\"\n        *ngIf=\"directionLinks\"\n        [class.disabled]=\"noPrevious()||disabled\">\n      <a class=\"page-link\" href (click)=\"selectPage(page - 1, $event)\" [innerHTML]=\"getText('previous')\"></a>\n      </li>\n\n    <li *ngFor=\"let pg of pages\"\n        [class.active]=\"pg.active\"\n        [class.disabled]=\"disabled&&!pg.active\"\n        class=\"pagination-page page-item\">\n      <a class=\"page-link\" href (click)=\"selectPage(pg.number, $event)\" [innerHTML]=\"pg.text\"></a>\n    </li>\n\n    <li class=\"pagination-next page-item\"\n        *ngIf=\"directionLinks\"\n        [class.disabled]=\"noNext()||disabled\">\n      <a class=\"page-link\" href (click)=\"selectPage(page + 1, $event)\" [innerHTML]=\"getText('next')\"></a></li>\n\n    <li class=\"pagination-last page-item\"\n        *ngIf=\"boundaryLinks\"\n        [class.disabled]=\"noNext()||disabled\">\n      <a class=\"page-link\" href (click)=\"selectPage(totalPages, $event)\" [innerHTML]=\"getText('last')\"></a></li>\n  </ul>\n  ";
var pagination_component_PaginationComponent = (function () {
    function PaginationComponent(renderer, elementRef, paginationConfig) {
        /** fired when total pages count changes, $event:number equals to total pages count */
        this.numPages = new core_es5["EventEmitter"]();
        /** fired when page was changed, $event:{page, itemsPerPage} equals to object with current page index and number of items per page */
        this.pageChanged = new core_es5["EventEmitter"]();
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.inited = false;
        this._page = 1;
        this.renderer = renderer;
        this.elementRef = elementRef;
        if (!this.config) {
            this.configureOptions(paginationConfig.main);
        }
    }
    Object.defineProperty(PaginationComponent.prototype, "itemsPerPage", {
        /** maximum number of items per page. If value less than 1 will display all items on one page */
        get: function () {
            return this._itemsPerPage;
        },
        set: function (v) {
            this._itemsPerPage = v;
            this.totalPages = this.calculateTotalPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "totalItems", {
        /** total number of items in all pages */
        get: function () {
            return this._totalItems;
        },
        set: function (v) {
            this._totalItems = v;
            this.totalPages = this.calculateTotalPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "totalPages", {
        get: function () {
            return this._totalPages;
        },
        set: function (v) {
            this._totalPages = v;
            this.numPages.emit(v);
            if (this.inited) {
                this.selectPage(this.page);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "page", {
        get: function () {
            return this._page;
        },
        set: function (value) {
            var _previous = this._page;
            this._page = (value > this.totalPages) ? this.totalPages : (value || 1);
            if (_previous === this._page || typeof _previous === 'undefined') {
                return;
            }
            this.pageChanged.emit({
                page: this._page,
                itemsPerPage: this.itemsPerPage
            });
        },
        enumerable: true,
        configurable: true
    });
    PaginationComponent.prototype.configureOptions = function (config) {
        this.config = Object.assign({}, config);
    };
    PaginationComponent.prototype.ngOnInit = function () {
        this.classMap = this.elementRef.nativeElement.getAttribute('class') || '';
        // watch for maxSize
        this.maxSize = typeof this.maxSize !== 'undefined'
            ? this.maxSize
            : this.config.maxSize;
        this.rotate = typeof this.rotate !== 'undefined'
            ? this.rotate
            : this.config.rotate;
        this.boundaryLinks = typeof this.boundaryLinks !== 'undefined'
            ? this.boundaryLinks
            : this.config.boundaryLinks;
        this.directionLinks = typeof this.directionLinks !== 'undefined'
            ? this.directionLinks
            : this.config.directionLinks;
        this.pageBtnClass = typeof this.pageBtnClass !== 'undefined'
            ? this.pageBtnClass
            : this.config.pageBtnClass;
        // base class
        this.itemsPerPage = typeof this.itemsPerPage !== 'undefined'
            ? this.itemsPerPage
            : this.config.itemsPerPage;
        this.totalPages = this.calculateTotalPages();
        // this class
        this.pages = this.getPages(this.page, this.totalPages);
        this.inited = true;
    };
    PaginationComponent.prototype.writeValue = function (value) {
        this.page = value;
        this.pages = this.getPages(this.page, this.totalPages);
    };
    PaginationComponent.prototype.getText = function (key) {
        return this[key + 'Text'] || this.config[key + 'Text'];
    };
    PaginationComponent.prototype.noPrevious = function () {
        return this.page === 1;
    };
    PaginationComponent.prototype.noNext = function () {
        return this.page === this.totalPages;
    };
    PaginationComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    PaginationComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    PaginationComponent.prototype.selectPage = function (page, event) {
        if (event) {
            event.preventDefault();
        }
        if (!this.disabled) {
            if (event && event.target) {
                var target = event.target;
                target.blur();
            }
            this.writeValue(page);
            this.onChange(this.page);
        }
    };
    // Create page object used in template
    PaginationComponent.prototype.makePage = function (num, text, active) {
        return { text: text, number: num, active: active };
    };
    PaginationComponent.prototype.getPages = function (currentPage, totalPages) {
        var pages = [];
        // Default page limits
        var startPage = 1;
        var endPage = totalPages;
        var isMaxSized = typeof this.maxSize !== 'undefined' && this.maxSize < totalPages;
        // recompute if maxSize
        if (isMaxSized) {
            if (this.rotate) {
                // Current page is displayed in the middle of the visible ones
                startPage = Math.max(currentPage - Math.floor(this.maxSize / 2), 1);
                endPage = startPage + this.maxSize - 1;
                // Adjust if limit is exceeded
                if (endPage > totalPages) {
                    endPage = totalPages;
                    startPage = endPage - this.maxSize + 1;
                }
            }
            else {
                // Visible pages are paginated with maxSize
                startPage = ((Math.ceil(currentPage / this.maxSize) - 1) * this.maxSize) + 1;
                // Adjust last page if limit is exceeded
                endPage = Math.min(startPage + this.maxSize - 1, totalPages);
            }
        }
        // Add page number links
        for (var num = startPage; num <= endPage; num++) {
            var page = this.makePage(num, num.toString(), num === currentPage);
            pages.push(page);
        }
        // Add links to move between page sets
        if (isMaxSized && !this.rotate) {
            if (startPage > 1) {
                var previousPageSet = this.makePage(startPage - 1, '...', false);
                pages.unshift(previousPageSet);
            }
            if (endPage < totalPages) {
                var nextPageSet = this.makePage(endPage + 1, '...', false);
                pages.push(nextPageSet);
            }
        }
        return pages;
    };
    // base class
    PaginationComponent.prototype.calculateTotalPages = function () {
        var totalPages = this.itemsPerPage < 1
            ? 1
            : Math.ceil(this.totalItems / this.itemsPerPage);
        return Math.max(totalPages || 0, 1);
    };
    PaginationComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'pagination',
                    template: PAGINATION_TEMPLATE,
                    providers: [PAGINATION_CONTROL_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    PaginationComponent.ctorParameters = function () { return [
        { type: core_es5["Renderer"], },
        { type: core_es5["ElementRef"], },
        { type: pagination_config_PaginationConfig, },
    ]; };
    PaginationComponent.propDecorators = {
        'align': [{ type: core_es5["Input"] },],
        'maxSize': [{ type: core_es5["Input"] },],
        'boundaryLinks': [{ type: core_es5["Input"] },],
        'directionLinks': [{ type: core_es5["Input"] },],
        'firstText': [{ type: core_es5["Input"] },],
        'previousText': [{ type: core_es5["Input"] },],
        'nextText': [{ type: core_es5["Input"] },],
        'lastText': [{ type: core_es5["Input"] },],
        'rotate': [{ type: core_es5["Input"] },],
        'pageBtnClass': [{ type: core_es5["Input"] },],
        'disabled': [{ type: core_es5["Input"] },],
        'numPages': [{ type: core_es5["Output"] },],
        'pageChanged': [{ type: core_es5["Output"] },],
        'itemsPerPage': [{ type: core_es5["Input"] },],
        'totalItems': [{ type: core_es5["Input"] },],
    };
    return PaginationComponent;
}());

//# sourceMappingURL=pagination.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/pagination/pagination.module.js





var pagination_module_PaginationModule = (function () {
    function PaginationModule() {
    }
    PaginationModule.forRoot = function () {
        return { ngModule: PaginationModule, providers: [pagination_config_PaginationConfig] };
    };
    PaginationModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    imports: [common_es5["CommonModule"]],
                    declarations: [pager_component_PagerComponent, pagination_component_PaginationComponent],
                    exports: [pager_component_PagerComponent, pagination_component_PaginationComponent]
                },] },
    ];
    /** @nocollapse */
    PaginationModule.ctorParameters = function () { return []; };
    return PaginationModule;
}());

//# sourceMappingURL=pagination.module.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/progressbar/progress.directive.js

// todo: progress element conflict with bootstrap.css
// todo: need hack: replace host element with div
var progress_directive_ProgressDirective = (function () {
    function ProgressDirective() {
        this.addClass = true;
        this.bars = [];
        this._max = 100;
    }
    Object.defineProperty(ProgressDirective.prototype, "max", {
        /** maximum total value of progress element */
        get: function () {
            return this._max;
        },
        set: function (v) {
            this._max = v;
            this.bars.forEach(function (bar) {
                bar.recalculatePercentage();
            });
        },
        enumerable: true,
        configurable: true
    });
    ProgressDirective.prototype.addBar = function (bar) {
        if (!this.animate) {
            bar.transition = 'none';
        }
        this.bars.push(bar);
    };
    ProgressDirective.prototype.removeBar = function (bar) {
        this.bars.splice(this.bars.indexOf(bar), 1);
    };
    ProgressDirective.decorators = [
        { type: core_es5["Directive"], args: [{ selector: 'bs-progress, [progress]' },] },
    ];
    /** @nocollapse */
    ProgressDirective.ctorParameters = function () { return []; };
    ProgressDirective.propDecorators = {
        'animate': [{ type: core_es5["Input"] },],
        'max': [{ type: core_es5["HostBinding"], args: ['attr.max',] }, { type: core_es5["Input"] },],
        'addClass': [{ type: core_es5["HostBinding"], args: ['class.progress',] },],
    };
    return ProgressDirective;
}());

//# sourceMappingURL=progress.directive.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/progressbar/bar.component.js



// todo: number pipe
// todo: use query from progress?
var bar_component_BarComponent = (function () {
    function BarComponent(progress) {
        this.percent = 0;
        this.progress = progress;
    }
    Object.defineProperty(BarComponent.prototype, "value", {
        /** current value of progress bar */
        get: function () {
            return this._value;
        },
        set: function (v) {
            if (!v && v !== 0) {
                return;
            }
            this._value = v;
            this.recalculatePercentage();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarComponent.prototype, "setBarWidth", {
        get: function () {
            this.recalculatePercentage();
            return this.isBs3 ? '' : this.percent;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(BarComponent.prototype, "isBs3", {
        get: function () {
            return Object(ng2_bootstrap_config["a" /* isBs3 */])();
        },
        enumerable: true,
        configurable: true
    });
    BarComponent.prototype.ngOnInit = function () {
        this.progress.addBar(this);
    };
    BarComponent.prototype.ngOnDestroy = function () {
        this.progress.removeBar(this);
    };
    BarComponent.prototype.recalculatePercentage = function () {
        this.percent = +(100 * this.value / this.progress.max).toFixed(2);
        var totalPercentage = this.progress.bars.reduce(function (total, bar) {
            return total + bar.percent;
        }, 0);
        if (totalPercentage > 100) {
            this.percent -= totalPercentage - 100;
        }
    };
    BarComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'bar',
                    template: "\n  <div class=\"progress-bar\"\n    style=\"min-width: 0;\"\n    role=\"progressbar\"\n    [ngClass]=\"type && 'progress-bar-' + type + ' bg-' + type\"\n    [ngStyle]=\"{width: (isBs3 ? (percent < 100 ? percent : 100) + '%' : '100%'), transition: transition}\"\n    aria-valuemin=\"0\"\n    [attr.aria-valuenow]=\"value\"\n    [attr.aria-valuetext]=\"percent.toFixed(0) + '%'\"\n    [attr.aria-valuemax]=\"max\"><ng-content></ng-content></div>\n"
                },] },
    ];
    /** @nocollapse */
    BarComponent.ctorParameters = function () { return [
        { type: progress_directive_ProgressDirective, decorators: [{ type: core_es5["Host"] },] },
    ]; };
    BarComponent.propDecorators = {
        'type': [{ type: core_es5["Input"] },],
        'value': [{ type: core_es5["Input"] },],
        'setBarWidth': [{ type: core_es5["HostBinding"], args: ['style.width.%',] },],
    };
    return BarComponent;
}());

//# sourceMappingURL=bar.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/progressbar/progressbar.config.js

var progressbar_config_ProgressbarConfig = (function () {
    function ProgressbarConfig() {
        /** if `true` changing value of progress bar will be animated (note: not supported by Bootstrap 4) */
        this.animate = true;
        /** maximum total value of progress element */
        this.max = 100;
    }
    ProgressbarConfig.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    ProgressbarConfig.ctorParameters = function () { return []; };
    return ProgressbarConfig;
}());

//# sourceMappingURL=progressbar.config.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/progressbar/progressbar.component.js



var progressbar_component_ProgressbarComponent = (function () {
    function ProgressbarComponent(config) {
        this.isStacked = false;
        Object.assign(this, config);
    }
    Object.defineProperty(ProgressbarComponent.prototype, "value", {
        /** current value of progress bar. Could be a number or array of objects like {"value":15,"type":"info","label":"15 %"} */
        set: function (value) {
            this.isStacked = Array.isArray(value);
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ProgressbarComponent.prototype, "isBs3", {
        get: function () {
            return Object(utils["b" /* isBs3 */])();
        },
        enumerable: true,
        configurable: true
    });
    ProgressbarComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'progressbar',
                    template: "\n    <div progress [animate]=\"animate\" [max]=\"max\" [style.width]=\"!isBs3 ? '100%' : 'auto'\">\n      <bar [type]=\"type\" [value]=\"_value\" *ngIf=\"!isStacked\">\n          <ng-content></ng-content>\n      </bar>\n      <template [ngIf]=\"isStacked\">\n        <bar *ngFor=\"let item of _value\" [type]=\"item.type\" [value]=\"item.value\">{{item.label}}</bar>\n      </template>\n    </div>\n  ",
                    styles: ["\n    :host {\n      width: 100%;\n    }\n  "]
                },] },
    ];
    /** @nocollapse */
    ProgressbarComponent.ctorParameters = function () { return [
        { type: progressbar_config_ProgressbarConfig, },
    ]; };
    ProgressbarComponent.propDecorators = {
        'animate': [{ type: core_es5["Input"] },],
        'max': [{ type: core_es5["Input"] },],
        'type': [{ type: core_es5["Input"] },],
        'value': [{ type: core_es5["Input"] },],
    };
    return ProgressbarComponent;
}());

//# sourceMappingURL=progressbar.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/progressbar/progressbar.module.js






var progressbar_module_ProgressbarModule = (function () {
    function ProgressbarModule() {
    }
    ProgressbarModule.forRoot = function () {
        return { ngModule: ProgressbarModule, providers: [progressbar_config_ProgressbarConfig] };
    };
    ProgressbarModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    imports: [common_es5["CommonModule"]],
                    declarations: [progress_directive_ProgressDirective, bar_component_BarComponent, progressbar_component_ProgressbarComponent],
                    exports: [progress_directive_ProgressDirective, bar_component_BarComponent, progressbar_component_ProgressbarComponent]
                },] },
    ];
    /** @nocollapse */
    ProgressbarModule.ctorParameters = function () { return []; };
    return ProgressbarModule;
}());

//# sourceMappingURL=progressbar.module.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/rating/rating.component.js


var RATING_CONTROL_VALUE_ACCESSOR = {
    provide: forms_es5["NG_VALUE_ACCESSOR"],
    useExisting: Object(core_es5["forwardRef"])(function () { return rating_component_RatingComponent; }),
    multi: true
};
var rating_component_RatingComponent = (function () {
    function RatingComponent() {
        /** number of icons */
        this.max = 5;
        /** fired when icon selected, $event:number equals to selected rating */
        this.onHover = new core_es5["EventEmitter"]();
        /** fired when icon selected, $event:number equals to previous rating value */
        this.onLeave = new core_es5["EventEmitter"]();
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
    }
    RatingComponent.prototype.onKeydown = function (event) {
        if ([37, 38, 39, 40].indexOf(event.which) === -1) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        var sign = event.which === 38 || event.which === 39 ? 1 : -1;
        this.rate(this.value + sign);
    };
    RatingComponent.prototype.ngOnInit = function () {
        this.max = typeof this.max !== 'undefined' ? this.max : 5;
        this.readonly = this.readonly === true;
        this.stateOn = typeof this.stateOn !== 'undefined'
            ? this.stateOn
            : 'glyphicon-star';
        this.stateOff = typeof this.stateOff !== 'undefined'
            ? this.stateOff
            : 'glyphicon-star-empty';
        this.titles = typeof this.titles !== 'undefined' && this.titles.length > 0
            ? this.titles
            : ['one', 'two', 'three', 'four', 'five'];
        this.range = this.buildTemplateObjects(this.ratingStates, this.max);
    };
    // model -> view
    RatingComponent.prototype.writeValue = function (value) {
        if (value % 1 !== value) {
            this.value = Math.round(value);
            this.preValue = value;
            return;
        }
        this.preValue = value;
        this.value = value;
    };
    RatingComponent.prototype.enter = function (value) {
        if (!this.readonly) {
            this.value = value;
            this.onHover.emit(value);
        }
    };
    RatingComponent.prototype.reset = function () {
        this.value = this.preValue;
        this.onLeave.emit(this.value);
    };
    RatingComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    RatingComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    RatingComponent.prototype.rate = function (value) {
        if (!this.readonly && value >= 0 && value <= this.range.length) {
            this.writeValue(value);
            this.onChange(value);
        }
    };
    RatingComponent.prototype.buildTemplateObjects = function (ratingStates, max) {
        ratingStates = ratingStates || [];
        var count = ratingStates.length || max;
        var result = [];
        for (var i = 0; i < count; i++) {
            result.push(Object.assign({
                index: i,
                stateOn: this.stateOn,
                stateOff: this.stateOff,
                title: this.titles[i] || i + 1
            }, ratingStates[i] || {}));
        }
        return result;
    };
    RatingComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'rating',
                    template: "\n    <span (mouseleave)=\"reset()\" (keydown)=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" [attr.aria-valuemax]=\"range.length\" [attr.aria-valuenow]=\"value\">\n      <template ngFor let-r [ngForOf]=\"range\" let-index=\"index\">\n        <span class=\"sr-only\">({{ index < value ? '*' : ' ' }})</span>\n        <i (mouseenter)=\"enter(index + 1)\" (click)=\"rate(index + 1)\" class=\"glyphicon\" [ngClass]=\"index < value ? r.stateOn : r.stateOff\" [title]=\"r.title\" ></i>\n      </template>\n    </span>\n  ",
                    providers: [RATING_CONTROL_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    RatingComponent.ctorParameters = function () { return []; };
    RatingComponent.propDecorators = {
        'max': [{ type: core_es5["Input"] },],
        'stateOn': [{ type: core_es5["Input"] },],
        'stateOff': [{ type: core_es5["Input"] },],
        'readonly': [{ type: core_es5["Input"] },],
        'titles': [{ type: core_es5["Input"] },],
        'ratingStates': [{ type: core_es5["Input"] },],
        'onHover': [{ type: core_es5["Output"] },],
        'onLeave': [{ type: core_es5["Output"] },],
        'onKeydown': [{ type: core_es5["HostListener"], args: ['keydown', ['$event'],] },],
    };
    return RatingComponent;
}());

//# sourceMappingURL=rating.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/rating/rating.module.js



var rating_module_RatingModule = (function () {
    function RatingModule() {
    }
    RatingModule.forRoot = function () {
        return {
            ngModule: RatingModule,
            providers: []
        };
    };
    RatingModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    imports: [common_es5["CommonModule"]],
                    declarations: [rating_component_RatingComponent],
                    exports: [rating_component_RatingComponent]
                },] },
    ];
    /** @nocollapse */
    RatingModule.ctorParameters = function () { return []; };
    return RatingModule;
}());

//# sourceMappingURL=rating.module.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/sortable/draggable-item.service.js


var draggable_item_service_DraggableItemService = (function () {
    function DraggableItemService() {
        this.onCapture = new Subject["Subject"]();
    }
    DraggableItemService.prototype.dragStart = function (item) {
        this.draggableItem = item;
    };
    DraggableItemService.prototype.getItem = function () {
        return this.draggableItem;
    };
    DraggableItemService.prototype.captureItem = function (overZoneIndex, newIndex) {
        if (this.draggableItem.overZoneIndex !== overZoneIndex) {
            this.draggableItem.lastZoneIndex = this.draggableItem.overZoneIndex;
            this.draggableItem.overZoneIndex = overZoneIndex;
            this.onCapture.next(this.draggableItem);
            this.draggableItem = Object.assign({}, this.draggableItem, { overZoneIndex: overZoneIndex, i: newIndex });
        }
        return this.draggableItem;
    };
    DraggableItemService.prototype.onCaptureItem = function () {
        return this.onCapture;
    };
    DraggableItemService.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    DraggableItemService.ctorParameters = function () { return []; };
    return DraggableItemService;
}());

//# sourceMappingURL=draggable-item.service.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/sortable/sortable.component.js



/* tslint:disable */
/* tslint:enable */
var sortable_component_SortableComponent = (function () {
    function SortableComponent(transfer) {
        var _this = this;
        /** class name for items wrapper */
        this.wrapperClass = '';
        /** style object for items wrapper */
        this.wrapperStyle = {};
        /** class name for item */
        this.itemClass = '';
        /** style object for item */
        this.itemStyle = {};
        /** class name for active item */
        this.itemActiveClass = '';
        /** style object for active item */
        this.itemActiveStyle = {};
        /** class name for placeholder */
        this.placeholderClass = '';
        /** style object for placeholder */
        this.placeholderStyle = {};
        /** placeholder item which will be shown if collection is empty */
        this.placeholderItem = '';
        /** fired on array change (reordering, insert, remove), same as <code>ngModelChange</code>.
         *  Returns new items collection as a payload.
         */
        this.onChange = new core_es5["EventEmitter"]();
        this.showPlaceholder = false;
        this.activeItem = -1;
        this.onTouched = Function.prototype;
        this.onChanged = Function.prototype;
        this.transfer = transfer;
        this.currentZoneIndex = SortableComponent.globalZoneIndex++;
        this.transfer.onCaptureItem()
            .subscribe(function (item) { return _this.onDrop(item); });
    }
    Object.defineProperty(SortableComponent.prototype, "items", {
        get: function () {
            return this._items;
        },
        set: function (value) {
            this._items = value;
            var out = this.items.map(function (x) { return x.initData; });
            this.onChanged(out);
            this.onChange.emit(out);
        },
        enumerable: true,
        configurable: true
    });
    SortableComponent.prototype.onItemDragstart = function (event, item, i) {
        this.initDragstartEvent(event);
        this.onTouched();
        this.transfer.dragStart({
            event: event,
            item: item,
            i: i,
            initialIndex: i,
            lastZoneIndex: this.currentZoneIndex,
            overZoneIndex: this.currentZoneIndex
        });
    };
    SortableComponent.prototype.onItemDragover = function (event, i) {
        if (!this.transfer.getItem()) {
            return;
        }
        event.preventDefault();
        var dragItem = this.transfer.captureItem(this.currentZoneIndex, this.items.length);
        var newArray = [];
        if (!this.items.length) {
            newArray = [dragItem.item];
        }
        else if (dragItem.i > i) {
            newArray = this.items.slice(0, i).concat([
                dragItem.item
            ], this.items.slice(i, dragItem.i), this.items.slice(dragItem.i + 1));
        }
        else {
            newArray = this.items.slice(0, dragItem.i).concat(this.items.slice(dragItem.i + 1, i + 1), [
                dragItem.item
            ], this.items.slice(i + 1));
        }
        this.items = newArray;
        dragItem.i = i;
        this.activeItem = i;
        this.updatePlaceholderState();
    };
    SortableComponent.prototype.cancelEvent = function (event) {
        if (!this.transfer.getItem() || !event) {
            return;
        }
        event.preventDefault();
    };
    SortableComponent.prototype.onDrop = function (item) {
        if (item &&
            item.overZoneIndex !== this.currentZoneIndex &&
            item.lastZoneIndex === this.currentZoneIndex) {
            this.items = this.items.filter(function (x, i) { return i !== item.i; });
            this.updatePlaceholderState();
        }
        this.resetActiveItem(undefined);
    };
    SortableComponent.prototype.resetActiveItem = function (event) {
        this.cancelEvent(event);
        this.activeItem = -1;
    };
    SortableComponent.prototype.registerOnChange = function (callback) {
        this.onChanged = callback;
    };
    SortableComponent.prototype.registerOnTouched = function (callback) {
        this.onTouched = callback;
    };
    SortableComponent.prototype.writeValue = function (value) {
        var _this = this;
        if (value) {
            this.items = value.map(function (x, i) { return ({
                id: i,
                initData: x,
                value: _this.fieldName ? x[_this.fieldName] : x
            }); });
        }
        else {
            this.items = [];
        }
        this.updatePlaceholderState();
    };
    SortableComponent.prototype.updatePlaceholderState = function () {
        this.showPlaceholder = !this._items.length;
    };
    SortableComponent.prototype.getItemStyle = function (isActive) {
        return isActive
            ? Object.assign({}, this.itemStyle, this.itemActiveStyle)
            : this.itemStyle;
    };
    SortableComponent.prototype.initDragstartEvent = function (event) {
        // it is necessary for mozilla
        // data type should be 'Text' instead of 'text/plain' to keep compatibility
        // with IE
        event.dataTransfer.setData('Text', 'placeholder');
    };
    SortableComponent.globalZoneIndex = 0;
    SortableComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'bs-sortable',
                    exportAs: 'bs-sortable',
                    template: "\n<div\n    [ngClass]=\"wrapperClass\"\n    [ngStyle]=\"wrapperStyle\"\n    [ngStyle]=\"wrapperStyle\"\n    (dragover)=\"cancelEvent($event)\"\n    (dragenter)=\"cancelEvent($event)\"\n    (drop)=\"resetActiveItem($event)\"\n    (mouseleave)=\"resetActiveItem($event)\">\n  <div\n        *ngIf=\"showPlaceholder\"\n        [ngClass]=\"placeholderClass\"\n        [ngStyle]=\"placeholderStyle\"\n        (dragover)=\"onItemDragover($event, 0)\"\n        (dragenter)=\"cancelEvent($event)\"\n    >{{placeholderItem}}</div>\n    <div\n        *ngFor=\"let item of items; let i=index;\"\n        [ngClass]=\"[ itemClass, i === activeItem ? itemActiveClass : '' ]\"\n        [ngStyle]=\"getItemStyle(i === activeItem)\"\n        draggable=\"true\"\n        (dragstart)=\"onItemDragstart($event, item, i)\"\n        (dragend)=\"resetActiveItem($event)\"\n        (dragover)=\"onItemDragover($event, i)\"\n        (dragenter)=\"cancelEvent($event)\"\n    ><template [ngTemplateOutlet]=\"itemTemplate || defItemTemplate\"\n  [ngOutletContext]=\"{item:item, index: i}\"></template></div>\n</div>\n\n<template #defItemTemplate let-item=\"item\">{{item.value}}</template>  \n",
                    providers: [{
                            provide: forms_es5["NG_VALUE_ACCESSOR"],
                            useExisting: Object(core_es5["forwardRef"])(function () { return SortableComponent; }),
                            multi: true
                        }],
                },] },
    ];
    /** @nocollapse */
    SortableComponent.ctorParameters = function () { return [
        { type: draggable_item_service_DraggableItemService, },
    ]; };
    SortableComponent.propDecorators = {
        'fieldName': [{ type: core_es5["Input"] },],
        'wrapperClass': [{ type: core_es5["Input"] },],
        'wrapperStyle': [{ type: core_es5["Input"] },],
        'itemClass': [{ type: core_es5["Input"] },],
        'itemStyle': [{ type: core_es5["Input"] },],
        'itemActiveClass': [{ type: core_es5["Input"] },],
        'itemActiveStyle': [{ type: core_es5["Input"] },],
        'placeholderClass': [{ type: core_es5["Input"] },],
        'placeholderStyle': [{ type: core_es5["Input"] },],
        'placeholderItem': [{ type: core_es5["Input"] },],
        'itemTemplate': [{ type: core_es5["Input"] },],
        'onChange': [{ type: core_es5["Output"] },],
    };
    return SortableComponent;
}());

//# sourceMappingURL=sortable.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/sortable/sortable.module.js




var sortable_module_SortableModule = (function () {
    function SortableModule() {
    }
    SortableModule.forRoot = function () {
        return { ngModule: SortableModule, providers: [draggable_item_service_DraggableItemService] };
    };
    SortableModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    declarations: [sortable_component_SortableComponent],
                    imports: [common_es5["CommonModule"]],
                    exports: [sortable_component_SortableComponent]
                },] },
    ];
    /** @nocollapse */
    SortableModule.ctorParameters = function () { return []; };
    return SortableModule;
}());

//# sourceMappingURL=sortable.module.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/sortable/index.js



//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/tabs/ng-transclude.directive.js

var ng_transclude_directive_NgTranscludeDirective = (function () {
    function NgTranscludeDirective(viewRef) {
        this.viewRef = viewRef;
    }
    Object.defineProperty(NgTranscludeDirective.prototype, "ngTransclude", {
        get: function () {
            return this._ngTransclude;
        },
        set: function (templateRef) {
            this._ngTransclude = templateRef;
            if (templateRef) {
                this.viewRef.createEmbeddedView(templateRef);
            }
        },
        enumerable: true,
        configurable: true
    });
    NgTranscludeDirective.decorators = [
        { type: core_es5["Directive"], args: [{
                    selector: '[ngTransclude]'
                },] },
    ];
    /** @nocollapse */
    NgTranscludeDirective.ctorParameters = function () { return [
        { type: core_es5["ViewContainerRef"], },
    ]; };
    NgTranscludeDirective.propDecorators = {
        'ngTransclude': [{ type: core_es5["Input"] },],
    };
    return NgTranscludeDirective;
}());

//# sourceMappingURL=ng-transclude.directive.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/tabs/tabset.config.js

var tabset_config_TabsetConfig = (function () {
    function TabsetConfig() {
        /** provides default navigation context class: 'tabs' or 'pills' */
        this.type = 'tabs';
    }
    TabsetConfig.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    TabsetConfig.ctorParameters = function () { return []; };
    return TabsetConfig;
}());

//# sourceMappingURL=tabset.config.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/tabs/tabset.component.js


// todo: add active event to tab
// todo: fix? mixing static and dynamic tabs position tabs in order of creation
var tabset_component_TabsetComponent = (function () {
    function TabsetComponent(config) {
        this.clazz = true;
        this.tabs = [];
        this.classMap = {};
        Object.assign(this, config);
    }
    Object.defineProperty(TabsetComponent.prototype, "vertical", {
        /** if true tabs will be placed vertically */
        get: function () {
            return this._vertical;
        },
        set: function (value) {
            this._vertical = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabsetComponent.prototype, "justified", {
        /** if true tabs fill the container and have a consistent width */
        get: function () {
            return this._justified;
        },
        set: function (value) {
            this._justified = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabsetComponent.prototype, "type", {
        /** navigation context class: 'tabs' or 'pills' */
        get: function () {
            return this._type;
        },
        set: function (value) {
            this._type = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    TabsetComponent.prototype.ngOnDestroy = function () {
        this.isDestroyed = true;
    };
    TabsetComponent.prototype.addTab = function (tab) {
        this.tabs.push(tab);
        tab.active = this.tabs.length === 1 && tab.active !== false;
    };
    TabsetComponent.prototype.removeTab = function (tab, options) {
        if (options === void 0) { options = { reselect: true, emit: true }; }
        var index = this.tabs.indexOf(tab);
        if (index === -1 || this.isDestroyed) {
            return;
        }
        // Select a new tab if the tab to be removed is selected and not destroyed
        if (options.reselect && tab.active && this.hasAvailableTabs(index)) {
            var newActiveIndex = this.getClosestTabIndex(index);
            this.tabs[newActiveIndex].active = true;
        }
        if (options.emit) {
            tab.removed.emit(tab);
        }
        this.tabs.splice(index, 1);
        if (tab.elementRef.nativeElement.parentNode) {
            tab.elementRef.nativeElement.parentNode.removeChild(tab.elementRef.nativeElement);
        }
    };
    TabsetComponent.prototype.getClosestTabIndex = function (index) {
        var tabsLength = this.tabs.length;
        if (!tabsLength) {
            return -1;
        }
        for (var step = 1; step <= tabsLength; step += 1) {
            var prevIndex = index - step;
            var nextIndex = index + step;
            if (this.tabs[prevIndex] && !this.tabs[prevIndex].disabled) {
                return prevIndex;
            }
            if (this.tabs[nextIndex] && !this.tabs[nextIndex].disabled) {
                return nextIndex;
            }
        }
        return -1;
    };
    TabsetComponent.prototype.hasAvailableTabs = function (index) {
        var tabsLength = this.tabs.length;
        if (!tabsLength) {
            return false;
        }
        for (var i = 0; i < tabsLength; i += 1) {
            if (!this.tabs[i].disabled && i !== index) {
                return true;
            }
        }
        return false;
    };
    TabsetComponent.prototype.setClassMap = function () {
        this.classMap = (_a = {
                'nav-stacked': this.vertical,
                'flex-column': this.vertical,
                'nav-justified': this.justified
            },
            _a["nav-" + this.type] = true,
            _a);
        var _a;
    };
    TabsetComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'tabset',
                    template: "\n    <ul class=\"nav\" [ngClass]=\"classMap\" (click)=\"$event.preventDefault()\">\n        <li *ngFor=\"let tabz of tabs\" [ngClass]=\"['nav-item', tabz.customClass || '']\"\n          [class.active]=\"tabz.active\" [class.disabled]=\"tabz.disabled\">\n          <a href=\"javascript:void(0);\" class=\"nav-link\"\n            [class.active]=\"tabz.active\" [class.disabled]=\"tabz.disabled\"\n            (click)=\"tabz.active = true\">\n            <span [ngTransclude]=\"tabz.headingRef\">{{tabz.heading}}</span>\n            <span *ngIf=\"tabz.removable\">\n              <span (click)=\"$event.preventDefault(); removeTab(tabz);\" class=\"glyphicon glyphicon-remove-circle\"></span>\n            </span>\n          </a>\n        </li>\n    </ul>\n    <div class=\"tab-content\">\n      <ng-content></ng-content>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    TabsetComponent.ctorParameters = function () { return [
        { type: tabset_config_TabsetConfig, },
    ]; };
    TabsetComponent.propDecorators = {
        'vertical': [{ type: core_es5["Input"] },],
        'justified': [{ type: core_es5["Input"] },],
        'type': [{ type: core_es5["Input"] },],
        'clazz': [{ type: core_es5["HostBinding"], args: ['class.tab-container',] },],
    };
    return TabsetComponent;
}());

//# sourceMappingURL=tabset.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/tabs/tab.directive.js


var tab_directive_TabDirective = (function () {
    function TabDirective(tabset, elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        /** fired when tab became active, $event:Tab equals to selected instance of Tab component */
        this.select = new core_es5["EventEmitter"]();
        /** fired when tab became inactive, $event:Tab equals to deselected instance of Tab component */
        this.deselect = new core_es5["EventEmitter"]();
        /** fired before tab will be removed, $event:Tab equals to instance of removed tab */
        this.removed = new core_es5["EventEmitter"]();
        this.addClass = true;
        this.tabset = tabset;
        this.tabset.addTab(this);
    }
    Object.defineProperty(TabDirective.prototype, "customClass", {
        /** if set, will be added to the tab's class atribute */
        get: function () {
            return this._customClass;
        },
        set: function (customClass) {
            if (this._customClass && this._customClass !== customClass) {
                this.renderer.setElementClass(this.elementRef.nativeElement, this._customClass, false);
            }
            this._customClass = customClass;
            if (this._customClass) {
                this.renderer.setElementClass(this.elementRef.nativeElement, this._customClass, true);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabDirective.prototype, "active", {
        /** tab active state toggle */
        get: function () {
            return this._active;
        },
        set: function (active) {
            var _this = this;
            if (this._active === active) {
                return;
            }
            if (this.disabled && active || !active) {
                if (this._active && !active) {
                    this.deselect.emit(this);
                    this._active = active;
                }
                return;
            }
            this._active = active;
            this.select.emit(this);
            this.tabset.tabs.forEach(function (tab) {
                if (tab !== _this) {
                    tab.active = false;
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    TabDirective.prototype.ngOnInit = function () {
        this.removable = this.removable;
    };
    TabDirective.prototype.ngOnDestroy = function () {
        this.tabset.removeTab(this, { reselect: false, emit: false });
    };
    TabDirective.decorators = [
        { type: core_es5["Directive"], args: [{ selector: 'tab, [tab]' },] },
    ];
    /** @nocollapse */
    TabDirective.ctorParameters = function () { return [
        { type: tabset_component_TabsetComponent, },
        { type: core_es5["ElementRef"], },
        { type: core_es5["Renderer"], },
    ]; };
    TabDirective.propDecorators = {
        'heading': [{ type: core_es5["Input"] },],
        'id': [{ type: core_es5["Input"] },],
        'disabled': [{ type: core_es5["Input"] },],
        'removable': [{ type: core_es5["Input"] },],
        'customClass': [{ type: core_es5["Input"] },],
        'active': [{ type: core_es5["HostBinding"], args: ['class.active',] }, { type: core_es5["Input"] },],
        'select': [{ type: core_es5["Output"] },],
        'deselect': [{ type: core_es5["Output"] },],
        'removed': [{ type: core_es5["Output"] },],
        'addClass': [{ type: core_es5["HostBinding"], args: ['class.tab-pane',] },],
    };
    return TabDirective;
}());

//# sourceMappingURL=tab.directive.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/tabs/tab-heading.directive.js


/** Should be used to mark <template> element as a template for tab heading */
var tab_heading_directive_TabHeadingDirective = (function () {
    function TabHeadingDirective(templateRef, tab) {
        tab.headingRef = templateRef;
    }
    TabHeadingDirective.decorators = [
        { type: core_es5["Directive"], args: [{ selector: '[tabHeading]' },] },
    ];
    /** @nocollapse */
    TabHeadingDirective.ctorParameters = function () { return [
        { type: core_es5["TemplateRef"], },
        { type: tab_directive_TabDirective, },
    ]; };
    return TabHeadingDirective;
}());

//# sourceMappingURL=tab-heading.directive.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/tabs/tabs.module.js







var tabs_module_TabsModule = (function () {
    function TabsModule() {
    }
    TabsModule.forRoot = function () {
        return {
            ngModule: TabsModule,
            providers: [tabset_config_TabsetConfig]
        };
    };
    TabsModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    imports: [common_es5["CommonModule"]],
                    declarations: [ng_transclude_directive_NgTranscludeDirective, tab_directive_TabDirective, tabset_component_TabsetComponent, tab_heading_directive_TabHeadingDirective],
                    exports: [tab_directive_TabDirective, tabset_component_TabsetComponent, tab_heading_directive_TabHeadingDirective, ng_transclude_directive_NgTranscludeDirective]
                },] },
    ];
    /** @nocollapse */
    TabsModule.ctorParameters = function () { return []; };
    return TabsModule;
}());

//# sourceMappingURL=tabs.module.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/timepicker/reducer/timepicker.actions.js

var timepicker_actions_TimepickerActions = (function () {
    function TimepickerActions() {
    }
    TimepickerActions.prototype.writeValue = function (value) {
        return {
            type: TimepickerActions.WRITE_VALUE,
            payload: value
        };
    };
    TimepickerActions.prototype.changeHours = function (event) {
        return {
            type: TimepickerActions.CHANGE_HOURS,
            payload: event
        };
    };
    TimepickerActions.prototype.changeMinutes = function (event) {
        return {
            type: TimepickerActions.CHANGE_MINUTES,
            payload: event
        };
    };
    TimepickerActions.prototype.changeSeconds = function (event) {
        return {
            type: TimepickerActions.CHANGE_SECONDS,
            payload: event
        };
    };
    TimepickerActions.prototype.setTime = function (value) {
        return {
            type: TimepickerActions.SET_TIME_UNIT,
            payload: value
        };
    };
    TimepickerActions.prototype.updateControls = function (value) {
        return {
            type: TimepickerActions.UPDATE_CONTROLS,
            payload: value
        };
    };
    TimepickerActions.WRITE_VALUE = '[timepicker] write value from ng model';
    TimepickerActions.CHANGE_HOURS = '[timepicker] change hours';
    TimepickerActions.CHANGE_MINUTES = '[timepicker] change minutes';
    TimepickerActions.CHANGE_SECONDS = '[timepicker] change seconds';
    TimepickerActions.SET_TIME_UNIT = '[timepicker] set time unit';
    TimepickerActions.UPDATE_CONTROLS = '[timepicker] update controls';
    TimepickerActions.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    TimepickerActions.ctorParameters = function () { return []; };
    return TimepickerActions;
}());

//# sourceMappingURL=timepicker.actions.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/timepicker/timepicker.utils.js
var dex = 10;
var hoursPerDay = 24;
var hoursPerDayHalf = 12;
var minutesPerHour = 60;
var secondsPerMinute = 60;
function timepicker_utils_isValidDate(value) {
    if (!value) {
        return false;
    }
    if (value instanceof Date && isNaN(value.getHours())) {
        return false;
    }
    if (typeof value === 'string') {
        return timepicker_utils_isValidDate(new Date(value));
    }
    return true;
}
function timepicker_utils_toNumber(value) {
    if (typeof value === 'number') {
        return value;
    }
    return parseInt(value, dex);
}
function isNumber(value) {
    return !isNaN(timepicker_utils_toNumber(value));
}
function parseHours(value, isPM) {
    if (isPM === void 0) { isPM = false; }
    var hour = timepicker_utils_toNumber(value);
    if (isNaN(hour) || hour < 0 || hour > (isPM ? hoursPerDayHalf : hoursPerDay)) {
        return NaN;
    }
    return hour;
}
function parseMinutes(value) {
    var minute = timepicker_utils_toNumber(value);
    if (isNaN(minute) || minute < 0 || minute > minutesPerHour) {
        return NaN;
    }
    return minute;
}
function parseSeconds(value) {
    var seconds = timepicker_utils_toNumber(value);
    if (isNaN(seconds) || seconds < 0 || seconds > secondsPerMinute) {
        return NaN;
    }
    return seconds;
}
function parseTime(value) {
    if (typeof value === 'string') {
        return new Date(value);
    }
    return value;
}
function changeTime(value, diff) {
    if (!value) {
        return changeTime(timepicker_utils_createDate(new Date(), 0, 0, 0), diff);
    }
    var hour = value.getHours();
    var minutes = value.getMinutes();
    var seconds = value.getSeconds();
    if (diff.hour) {
        hour = (hour + timepicker_utils_toNumber(diff.hour)) % hoursPerDay;
        if (hour < 0) {
            hour += hoursPerDay;
        }
    }
    if (diff.minute) {
        minutes = (minutes + timepicker_utils_toNumber(diff.minute));
    }
    if (diff.seconds) {
        seconds = (seconds + timepicker_utils_toNumber(diff.seconds));
    }
    return timepicker_utils_createDate(value, hour, minutes, seconds);
}
function setTime(value, opts) {
    var hour = parseHours(opts.hour);
    var minute = parseMinutes(opts.minute);
    var seconds = parseSeconds(opts.seconds) || 0;
    if (opts.isPM) {
        hour += hoursPerDayHalf;
    }
    // fixme: unreachable code, value is mandatory
    if (!value) {
        if (!isNaN(hour) && !isNaN(minute)) {
            return timepicker_utils_createDate(new Date(), hour, minute, seconds);
        }
        return value;
    }
    if (isNaN(hour) || isNaN(minute)) {
        return value;
    }
    return timepicker_utils_createDate(value, hour, minute, seconds);
}
function timepicker_utils_createDate(value, hours, minutes, seconds) {
    // fixme: unreachable code, value is mandatory
    var _value = value || new Date();
    return new Date(_value.getFullYear(), _value.getMonth(), _value.getDate(), hours, minutes, seconds, _value.getMilliseconds());
}
function padNumber(value) {
    var _value = value.toString();
    if (_value.length > 1) {
        return _value;
    }
    return "0" + _value;
}
function isInputValid(hours, minutes, seconds, isPM) {
    if (seconds === void 0) { seconds = '0'; }
    if (isNaN(parseHours(hours, isPM)) || isNaN(parseMinutes(minutes)) || isNaN(parseSeconds(seconds))) {
        return false;
    }
    return true;
}
//# sourceMappingURL=timepicker.utils.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/timepicker/timepicker-controls.util.js

function canChangeValue(state, event) {
    if (state.readonlyInput) {
        return false;
    }
    if (event) {
        if (event.source === 'wheel' && !state.mousewheel) {
            return false;
        }
        if (event.source === 'key' && !state.arrowkeys) {
            return false;
        }
    }
    return true;
}
function canChangeHours(event, controls) {
    if (!event.step) {
        return false;
    }
    if (event.step > 0 && !controls.canIncrementHours) {
        return false;
    }
    if (event.step < 0 && !controls.canDecrementHours) {
        return false;
    }
    return true;
}
function canChangeMinutes(event, controls) {
    if (!event.step) {
        return false;
    }
    if (event.step > 0 && !controls.canIncrementMinutes) {
        return false;
    }
    if (event.step < 0 && !controls.canDecrementMinutes) {
        return false;
    }
    return true;
}
function canChangeSeconds(event, controls) {
    if (!event.step) {
        return false;
    }
    if (event.step > 0 && !controls.canIncrementSeconds) {
        return false;
    }
    if (event.step < 0 && !controls.canDecrementSeconds) {
        return false;
    }
    return true;
}
function getControlsValue(state) {
    var hourStep = state.hourStep, minuteStep = state.minuteStep, secondsStep = state.secondsStep, readonlyInput = state.readonlyInput, mousewheel = state.mousewheel, arrowkeys = state.arrowkeys, showSpinners = state.showSpinners, showMeridian = state.showMeridian, showSeconds = state.showSeconds, meridians = state.meridians, min = state.min, max = state.max;
    return {
        hourStep: hourStep, minuteStep: minuteStep, secondsStep: secondsStep,
        readonlyInput: readonlyInput, mousewheel: mousewheel, arrowkeys: arrowkeys,
        showSpinners: showSpinners, showMeridian: showMeridian, showSeconds: showSeconds,
        meridians: meridians, min: min, max: max
    };
}
function timepickerControls(value, state) {
    var min = state.min, max = state.max, hourStep = state.hourStep, minuteStep = state.minuteStep, secondsStep = state.secondsStep, showSeconds = state.showSeconds;
    var res = {
        canIncrementHours: true,
        canIncrementMinutes: true,
        canIncrementSeconds: true,
        canDecrementHours: true,
        canDecrementMinutes: true,
        canDecrementSeconds: true
    };
    if (!value) {
        return res;
    }
    // compare dates
    if (max) {
        var _newHour = changeTime(value, { hour: hourStep });
        res.canIncrementHours = max > _newHour;
        if (!res.canIncrementHours) {
            var _newMinutes = changeTime(value, { minute: minuteStep });
            res.canIncrementMinutes = showSeconds ? max > _newMinutes : max >= _newMinutes;
        }
        if (!res.canIncrementMinutes) {
            var _newSeconds = changeTime(value, { seconds: secondsStep });
            res.canIncrementSeconds = max >= _newSeconds;
        }
    }
    if (min) {
        var _newHour = changeTime(value, { hour: -hourStep });
        res.canDecrementHours = min < _newHour;
        if (!res.canDecrementHours) {
            var _newMinutes = changeTime(value, { minute: -minuteStep });
            res.canDecrementMinutes = showSeconds ? min < _newMinutes : min <= _newMinutes;
        }
        if (!res.canDecrementMinutes) {
            var _newSeconds = changeTime(value, { seconds: -secondsStep });
            res.canDecrementSeconds = min <= _newSeconds;
        }
    }
    return res;
}
//# sourceMappingURL=timepicker-controls.util.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/timepicker/timepicker.config.js

/** Provides default configuration values for timepicker */
var timepicker_config_TimepickerConfig = (function () {
    function TimepickerConfig() {
        /** hours change step */
        this.hourStep = 1;
        /** hours change step */
        this.minuteStep = 5;
        /** seconds changes step */
        this.secondsStep = 10;
        /** if true works in 12H mode and displays AM/PM. If false works in 24H mode and hides AM/PM */
        this.showMeridian = true;
        /** meridian labels based on locale */
        this.meridians = ['AM', 'PM'];
        /** if true hours and minutes fields will be readonly */
        this.readonlyInput = false;
        /** if true scroll inside hours and minutes inputs will change time */
        this.mousewheel = true;
        /** if true up/down arrowkeys inside hours and minutes inputs will change time */
        this.arrowkeys = true;
        /** if true spinner arrows above and below the inputs will be shown */
        this.showSpinners = true;
        /** show seconds in timepicker */
        this.showSeconds = false;
    }
    TimepickerConfig.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    TimepickerConfig.ctorParameters = function () { return []; };
    return TimepickerConfig;
}());

//# sourceMappingURL=timepicker.config.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/timepicker/reducer/timepicker.reducer.js




var TimepickerState = (function () {
    function TimepickerState() {
    }
    return TimepickerState;
}());

var initialState = {
    value: null,
    config: new timepicker_config_TimepickerConfig(),
    controls: {
        canIncrementHours: true,
        canIncrementMinutes: true,
        canIncrementSeconds: true,
        canDecrementHours: true,
        canDecrementMinutes: true,
        canDecrementSeconds: true
    }
};
function timepickerReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case (timepicker_actions_TimepickerActions.WRITE_VALUE): {
            return Object.assign({}, state, { value: action.payload });
        }
        case (timepicker_actions_TimepickerActions.CHANGE_HOURS): {
            if (!canChangeValue(state.config, action.payload) ||
                !canChangeHours(action.payload, state.controls)) {
                return state;
            }
            var _newTime = changeTime(state.value, { hour: action.payload.step });
            return Object.assign({}, state, { value: _newTime });
        }
        case (timepicker_actions_TimepickerActions.CHANGE_MINUTES): {
            if (!canChangeValue(state.config, action.payload) ||
                !canChangeMinutes(action.payload, state.controls)) {
                return state;
            }
            var _newTime = changeTime(state.value, { minute: action.payload.step });
            return Object.assign({}, state, { value: _newTime });
        }
        case (timepicker_actions_TimepickerActions.CHANGE_SECONDS): {
            if (!canChangeValue(state.config, action.payload) ||
                !canChangeSeconds(action.payload, state.controls)) {
                return state;
            }
            var _newTime = changeTime(state.value, { seconds: action.payload.step });
            return Object.assign({}, state, { value: _newTime });
        }
        case (timepicker_actions_TimepickerActions.SET_TIME_UNIT): {
            if (!canChangeValue(state.config)) {
                return state;
            }
            var _newTime = setTime(state.value, action.payload);
            return Object.assign({}, state, { value: _newTime });
        }
        case (timepicker_actions_TimepickerActions.UPDATE_CONTROLS): {
            var _newControlsState = timepickerControls(state.value, action.payload);
            var _newState = {
                value: state.value,
                config: action.payload,
                controls: _newControlsState
            };
            if (state.config.showMeridian !== _newState.config.showMeridian) {
                _newState.value = new Date(state.value);
            }
            return Object.assign({}, state, _newState);
        }
        default:
            return state;
    }
}
//# sourceMappingURL=timepicker.reducer.js.map
// EXTERNAL MODULE: ./node_modules/rxjs/operator/distinctUntilChanged.js
var operator_distinctUntilChanged = __webpack_require__("8hgl");
var operator_distinctUntilChanged_default = /*#__PURE__*/__webpack_require__.n(operator_distinctUntilChanged);

// EXTERNAL MODULE: ./node_modules/rxjs/operator/map.js
var operator_map = __webpack_require__("xAJs");
var operator_map_default = /*#__PURE__*/__webpack_require__.n(operator_map);

// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/mini-ngrx/store.class.js
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @copyright ngrx
 */



var store_class_MiniStore = (function (_super) {
    __extends(MiniStore, _super);
    function MiniStore(_dispatcher, _reducer, state$) {
        var _this = _super.call(this) || this;
        _this._dispatcher = _dispatcher;
        _this._reducer = _reducer;
        _this.source = state$;
        return _this;
    }
    MiniStore.prototype.select = function (pathOrMapFn) {
        var mapped$ = operator_map["map"].call(this, pathOrMapFn);
        return operator_distinctUntilChanged["distinctUntilChanged"].call(mapped$);
    };
    MiniStore.prototype.lift = function (operator) {
        var store = new MiniStore(this._dispatcher, this._reducer, this);
        store.operator = operator;
        return store;
    };
    MiniStore.prototype.dispatch = function (action) { this._dispatcher.next(action); };
    MiniStore.prototype.next = function (action) { this._dispatcher.next(action); };
    MiniStore.prototype.error = function (err) { this._dispatcher.error(err); };
    MiniStore.prototype.complete = function () { };
    return MiniStore;
}(Observable["Observable"]));

//# sourceMappingURL=store.class.js.map
// EXTERNAL MODULE: ./node_modules/rxjs/operator/observeOn.js
var observeOn = __webpack_require__("Ji1B");
var observeOn_default = /*#__PURE__*/__webpack_require__.n(observeOn);

// EXTERNAL MODULE: ./node_modules/rxjs/scheduler/queue.js
var queue = __webpack_require__("RA5l");
var queue_default = /*#__PURE__*/__webpack_require__.n(queue);

// EXTERNAL MODULE: ./node_modules/rxjs/operator/scan.js
var scan = __webpack_require__("td8d");
var scan_default = /*#__PURE__*/__webpack_require__.n(scan);

// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/mini-ngrx/state.class.js
var state_class___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @copyright ngrx
 */




var state_class_MiniState = (function (_super) {
    state_class___extends(MiniState, _super);
    function MiniState(_initialState, actionsDispatcher$, reducer) {
        var _this = _super.call(this, _initialState) || this;
        var actionInQueue$ = observeOn["observeOn"].call(actionsDispatcher$, queue["queue"]);
        var state$ = scan["scan"].call(actionInQueue$, function (state, action) {
            if (!action) {
                return state;
            }
            return reducer(state, action);
        }, _initialState);
        state$.subscribe(function (value) { return _this.next(value); });
        return _this;
    }
    return MiniState;
}(BehaviorSubject["BehaviorSubject"]));

//# sourceMappingURL=state.class.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/timepicker/reducer/timepicker.store.js
var timepicker_store___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var timepicker_store_TimepickerStore = (function (_super) {
    timepicker_store___extends(TimepickerStore, _super);
    function TimepickerStore() {
        var _this = this;
        var _dispatcher = new BehaviorSubject["BehaviorSubject"]({ type: '[mini-ngrx] dispatcher init' });
        var state = new state_class_MiniState(initialState, _dispatcher, timepickerReducer);
        _this = _super.call(this, _dispatcher, timepickerReducer, state) || this;
        return _this;
    }
    TimepickerStore.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    TimepickerStore.ctorParameters = function () { return []; };
    return TimepickerStore;
}(store_class_MiniStore));

//# sourceMappingURL=timepicker.store.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/timepicker/timepicker.component.js
/* tslint:disable:no-forward-ref max-file-line-count */







var TIMEPICKER_CONTROL_VALUE_ACCESSOR = {
    provide: forms_es5["NG_VALUE_ACCESSOR"],
    // tslint:disable-next-line
    useExisting: Object(core_es5["forwardRef"])(function () { return timepicker_component_TimepickerComponent; }),
    multi: true
};
var timepicker_component_TimepickerComponent = (function () {
    function TimepickerComponent(_config, _cd, _store, _timepickerActions) {
        var _this = this;
        this._cd = _cd;
        this._store = _store;
        this._timepickerActions = _timepickerActions;
        /** emits true if value is a valid date */
        this.isValid = new core_es5["EventEmitter"]();
        // min\max validation for input fields
        this.invalidHours = false;
        this.invalidMinutes = false;
        this.invalidSeconds = false;
        // control value accessor methods
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        Object.assign(this, _config);
        // todo: add unsubscribe
        _store
            .select(function (state) { return state.value; })
            .subscribe(function (value) {
            // update UI values if date changed
            _this._renderTime(value);
            _this.onChange(value);
            _this._store.dispatch(_this._timepickerActions.updateControls(getControlsValue(_this)));
        });
        _store
            .select(function (state) { return state.controls; })
            .subscribe(function (controlsState) {
            _this.isValid.emit(isInputValid(_this.hours, _this.minutes, _this.seconds, _this.isPM()));
            Object.assign(_this, controlsState);
            _cd.markForCheck();
        });
    }
    Object.defineProperty(TimepickerComponent.prototype, "isSpinnersVisible", {
        get: function () {
            return this.showSpinners && !this.readonlyInput;
        },
        enumerable: true,
        configurable: true
    });
    TimepickerComponent.prototype.isPM = function () {
        return this.showMeridian && this.meridian === this.meridians[1];
    };
    TimepickerComponent.prototype.prevDef = function ($event) {
        $event.preventDefault();
    };
    TimepickerComponent.prototype.wheelSign = function ($event) {
        return Math.sign($event.deltaY) * -1;
    };
    TimepickerComponent.prototype.ngOnChanges = function (changes) {
        this._store.dispatch(this._timepickerActions.updateControls(getControlsValue(this)));
    };
    TimepickerComponent.prototype.changeHours = function (step, source) {
        if (source === void 0) { source = ''; }
        this._store.dispatch(this._timepickerActions.changeHours({ step: step, source: source }));
    };
    TimepickerComponent.prototype.changeMinutes = function (step, source) {
        if (source === void 0) { source = ''; }
        this._store.dispatch(this._timepickerActions.changeMinutes({ step: step, source: source }));
    };
    TimepickerComponent.prototype.changeSeconds = function (step, source) {
        if (source === void 0) { source = ''; }
        this._store.dispatch(this._timepickerActions.changeSeconds({ step: step, source: source }));
    };
    TimepickerComponent.prototype.updateHours = function (hours) {
        this.hours = hours;
        this._updateTime();
    };
    TimepickerComponent.prototype.updateMinutes = function (minutes) {
        this.minutes = minutes;
        this._updateTime();
    };
    TimepickerComponent.prototype.updateSeconds = function (seconds) {
        this.seconds = seconds;
        this._updateTime();
    };
    TimepickerComponent.prototype._updateTime = function () {
        if (!isInputValid(this.hours, this.minutes, this.seconds, this.isPM())) {
            this.onChange(null);
            return;
        }
        this._store.dispatch(this._timepickerActions
            .setTime({
            hour: this.hours,
            minute: this.minutes,
            seconds: this.seconds,
            isPM: this.isPM()
        }));
    };
    TimepickerComponent.prototype.toggleMeridian = function () {
        if (!this.showMeridian || this.readonlyInput) {
            return;
        }
        var _hoursPerDayHalf = 12;
        this._store.dispatch(this._timepickerActions.changeHours({ step: _hoursPerDayHalf, source: '' }));
    };
    /**
     * Write a new value to the element.
     */
    TimepickerComponent.prototype.writeValue = function (obj) {
        if (timepicker_utils_isValidDate(obj)) {
            this._store.dispatch(this._timepickerActions.writeValue(parseTime(obj)));
        }
    };
    /**
     * Set the function to be called when the control receives a change event.
     */
    TimepickerComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * Set the function to be called when the control receives a touch event.
     */
    TimepickerComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * This function is called when the control status changes to or from "DISABLED".
     * Depending on the value, it will enable or disable the appropriate DOM element.
     *
     * @param isDisabled
     */
    TimepickerComponent.prototype.setDisabledState = function (isDisabled) {
        this.readonlyInput = isDisabled;
    };
    TimepickerComponent.prototype._renderTime = function (value) {
        if (!timepicker_utils_isValidDate(value)) {
            this.hours = '';
            this.minutes = '';
            this.seconds = '';
            this.meridian = this.meridians[0];
            return;
        }
        var _value = parseTime(value);
        var _hoursPerDayHalf = 12;
        var _hours = _value.getHours();
        if (this.showMeridian) {
            this.meridian = this.meridians[_hours >= _hoursPerDayHalf ? 1 : 0];
            _hours = _hours % _hoursPerDayHalf;
            // should be 12 PM, not 00 PM
            if (_hours === 0) {
                _hours = _hoursPerDayHalf;
            }
        }
        this.hours = padNumber(_hours);
        this.minutes = padNumber(_value.getMinutes());
        this.seconds = padNumber(_value.getUTCSeconds());
    };
    TimepickerComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'timepicker',
                    changeDetection: core_es5["ChangeDetectionStrategy"].OnPush,
                    providers: [TIMEPICKER_CONTROL_VALUE_ACCESSOR, timepicker_store_TimepickerStore],
                    template: "\n    <table>\n      <tbody>\n      <tr class=\"text-center\" [class.hidden]=\"!isSpinnersVisible\">\n        <!-- increment hours button-->\n        <td>\n          <a class=\"btn btn-link\" [class.disabled]=\"!canIncrementHours\"\n             (click)=\"changeHours(hourStep)\"\n          ><span class=\"glyphicon glyphicon-chevron-up\"></span></a>\n        </td>\n        <!-- divider -->\n        <td>&nbsp;&nbsp;&nbsp;</td>\n        <!-- increment minutes button -->\n        <td>\n          <a class=\"btn btn-link\" [class.disabled]=\"!canIncrementMinutes\"\n             (click)=\"changeMinutes(minuteStep)\"\n          ><span class=\"glyphicon glyphicon-chevron-up\"></span></a>\n        </td>\n        <!-- divider -->\n        <td *ngIf=\"showSeconds\">&nbsp;</td>\n        <!-- increment seconds button -->\n        <td *ngIf=\"showSeconds\">\n          <a class=\"btn btn-link\" [class.disabled]=\"!canIncrementSeconds\"\n             (click)=\"changeSeconds(secondsStep)\">\n            <span class=\"glyphicon glyphicon-chevron-up\"></span>\n          </a>\n        </td>\n        <!-- space between -->\n        <td>&nbsp;&nbsp;&nbsp;</td>\n        <!-- meridian placeholder-->\n        <td *ngIf=\"showMeridian\"></td>\n      </tr>\n      <tr>\n        <!-- hours -->\n        <td class=\"form-group\" [class.has-error]=\"invalidHours\">\n          <input type=\"text\" style=\"width:50px;\"\n                 class=\"form-control text-center\"\n                 placeholder=\"HH\"\n                 maxlength=\"2\"\n                 [readonly]=\"readonlyInput\"\n                 [value]=\"hours\"\n                 (wheel)=\"prevDef($event);changeHours(hourStep * wheelSign($event), 'wheel')\"\n                 (keydown.ArrowUp)=\"changeHours(hourStep, 'key')\"\n                 (keydown.ArrowDown)=\"changeHours(-hourStep, 'key')\"\n                 (change)=\"updateHours($event.target.value)\"></td>\n        <!-- divider -->\n        <td>&nbsp;:&nbsp;</td>\n        <!-- minutes -->\n        <td class=\"form-group\" [class.has-error]=\"invalidMinutes\">\n          <input style=\"width:50px;\" type=\"text\"\n                 class=\"form-control text-center\"\n                 placeholder=\"MM\"\n                 maxlength=\"2\"\n                 [readonly]=\"readonlyInput\"\n                 [value]=\"minutes\"\n                 (wheel)=\"prevDef($event);changeMinutes(minuteStep * wheelSign($event), 'wheel')\"\n                 (keydown.ArrowUp)=\"changeMinutes(minuteStep, 'key')\"\n                 (keydown.ArrowDown)=\"changeMinutes(-minuteStep, 'key')\"\n                 (change)=\"updateMinutes($event.target.value)\">\n        </td>\n        <!-- divider -->\n        <td *ngIf=\"showSeconds\">&nbsp;:&nbsp;</td>\n        <!-- seconds -->\n        <td class=\"form-group\" *ngIf=\"showSeconds\" [class.has-error]=\"invalidSeconds\">\n          <input style=\"width:50px;\" type=\"text\"\n                 class=\"form-control text-center\"\n                 placeholder=\"SS\"\n                 maxlength=\"2\"\n                 [readonly]=\"readonlyInput\"\n                 [value]=\"seconds\"\n                 (wheel)=\"prevDef($event);changeSeconds(secondsStep * wheelSign($event), 'wheel')\"\n                 (keydown.ArrowUp)=\"changeSeconds(secondsStep, 'key')\"\n                 (keydown.ArrowDown)=\"changeSeconds(-secondsStep, 'key')\"\n                 (change)=\"updateSeconds($event.target.value)\">\n        </td>\n        <!-- space between -->\n        <td>&nbsp;&nbsp;&nbsp;</td>\n        <!-- meridian -->\n        <td *ngIf=\"showMeridian\">\n          <button type=\"button\" class=\"btn btn-default text-center\"\n                  [disabled]=\"readonlyInput\"\n                  [class.disabled]=\"readonlyInput\"\n                  (click)=\"toggleMeridian()\"\n          >{{ meridian }}\n          </button>\n        </td>\n      </tr>\n      <tr class=\"text-center\" [class.hidden]=\"!isSpinnersVisible\">\n        <!-- decrement hours button-->\n        <td>\n          <a class=\"btn btn-link\" [class.disabled]=\"!canDecrementHours\" (click)=\"changeHours(-hourStep)\">\n            <span class=\"glyphicon glyphicon-chevron-down\"></span>\n          </a>\n        </td>\n        <!-- divider -->\n        <td>&nbsp;&nbsp;&nbsp;</td>\n        <!-- decrement minutes button-->\n        <td>\n          <a class=\"btn btn-link\" [class.disabled]=\"!canDecrementMinutes\" (click)=\"changeMinutes(-minuteStep)\">\n            <span class=\"glyphicon glyphicon-chevron-down\"></span>\n          </a>\n        </td>\n        <!-- divider -->\n        <td *ngIf=\"showSeconds\">&nbsp;</td>\n        <!-- decrement seconds button-->\n        <td *ngIf=\"showSeconds\">\n          <a class=\"btn btn-link\" [class.disabled]=\"!canDecrementSeconds\" (click)=\"changeSeconds(-secondsStep)\">\n            <span class=\"glyphicon glyphicon-chevron-down\"></span>\n          </a>\n        </td>\n        <!-- space between -->\n        <td>&nbsp;&nbsp;&nbsp;</td>\n        <!-- meridian placeholder-->\n        <td *ngIf=\"showMeridian\"></td>\n      </tr>\n      </tbody>\n    </table>\n  "
                },] },
    ];
    /** @nocollapse */
    TimepickerComponent.ctorParameters = function () { return [
        { type: timepicker_config_TimepickerConfig, },
        { type: core_es5["ChangeDetectorRef"], },
        { type: timepicker_store_TimepickerStore, },
        { type: timepicker_actions_TimepickerActions, },
    ]; };
    TimepickerComponent.propDecorators = {
        'hourStep': [{ type: core_es5["Input"] },],
        'minuteStep': [{ type: core_es5["Input"] },],
        'secondsStep': [{ type: core_es5["Input"] },],
        'readonlyInput': [{ type: core_es5["Input"] },],
        'mousewheel': [{ type: core_es5["Input"] },],
        'arrowkeys': [{ type: core_es5["Input"] },],
        'showSpinners': [{ type: core_es5["Input"] },],
        'showMeridian': [{ type: core_es5["Input"] },],
        'showSeconds': [{ type: core_es5["Input"] },],
        'meridians': [{ type: core_es5["Input"] },],
        'min': [{ type: core_es5["Input"] },],
        'max': [{ type: core_es5["Input"] },],
        'isValid': [{ type: core_es5["Output"] },],
    };
    return TimepickerComponent;
}());

//# sourceMappingURL=timepicker.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/timepicker/timepicker.module.js






var timepicker_module_TimepickerModule = (function () {
    function TimepickerModule() {
    }
    TimepickerModule.forRoot = function () {
        return {
            ngModule: TimepickerModule,
            providers: [timepicker_config_TimepickerConfig, timepicker_actions_TimepickerActions, timepicker_store_TimepickerStore]
        };
    };
    TimepickerModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    imports: [common_es5["CommonModule"]],
                    declarations: [timepicker_component_TimepickerComponent],
                    exports: [timepicker_component_TimepickerComponent]
                },] },
    ];
    /** @nocollapse */
    TimepickerModule.ctorParameters = function () { return []; };
    return TimepickerModule;
}());

//# sourceMappingURL=timepicker.module.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/tooltip/tooltip.config.js

/** Default values provider for tooltip */
var tooltip_config_TooltipConfig = (function () {
    function TooltipConfig() {
        /** tooltip placement, supported positions: 'top', 'bottom', 'left', 'right' */
        this.placement = 'top';
        /** array of event names which triggers tooltip opening */
        this.triggers = 'hover focus';
    }
    TooltipConfig.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    TooltipConfig.ctorParameters = function () { return []; };
    return TooltipConfig;
}());

//# sourceMappingURL=tooltip.config.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/tooltip/tooltip-container.component.js



var tooltip_container_component_TooltipContainerComponent = (function () {
    function TooltipContainerComponent(config) {
        Object.assign(this, config);
    }
    Object.defineProperty(TooltipContainerComponent.prototype, "isBs3", {
        get: function () {
            return Object(ng2_bootstrap_config["a" /* isBs3 */])();
        },
        enumerable: true,
        configurable: true
    });
    TooltipContainerComponent.prototype.ngAfterViewInit = function () {
        this.classMap = { in: false, fade: false };
        this.classMap[this.placement] = true;
        this.classMap['tooltip-' + this.placement] = true;
        this.classMap.in = true;
        if (this.animation) {
            this.classMap.fade = true;
        }
        if (this.containerClass) {
            this.classMap[this.containerClass] = true;
        }
    };
    TooltipContainerComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'bs-tooltip-container',
                    changeDetection: core_es5["ChangeDetectionStrategy"].OnPush,
                    // tslint:disable-next-line
                    host: {
                        '[class]': '"tooltip in tooltip-" + placement + " " + "bs-tooltip-" + placement + " " + placement + " " + containerClass',
                        '[class.show]': '!isBs3',
                        role: 'tooltip'
                    },
                    styles: ["    \n    :host.tooltip {\n      display: block;\n    }\n    :host.bs-tooltip-top .arrow, :host.bs-tooltip-bottom .arrow {\n      left: calc(50% - 2.5px);\n    }\n    :host.bs-tooltip-left .arrow, :host.bs-tooltip-right .arrow {\n      top: calc(50% - 2.5px);\n    }\n  "],
                    template: "\n    <div class=\"tooltip-arrow arrow\"></div>\n    <div class=\"tooltip-inner\"><ng-content></ng-content></div>\n    "
                    // template: `<div class="tooltip" role="tooltip"
                    //    [ngStyle]="{top: top, left: left, display: display}"
                    //    [ngClass]="classMap">
                    //     <div class="tooltip-arrow"></div>
                    //     <div class="tooltip-inner"
                    //          *ngIf="htmlContent && !isTemplate"
                    //          innerHtml="{{htmlContent}}">
                    //     </div>
                    //     <div class="tooltip-inner"
                    //          *ngIf="htmlContent && isTemplate">
                    //       <template [ngTemplateOutlet]="htmlContent"
                    //                 [ngOutletContext]="{model: context}">
                    //       </template>
                    //     </div>
                    //     <div class="tooltip-inner"
                    //          *ngIf="content">
                    //       {{content}}
                    //     </div>
                    //   </div>`
                },] },
    ];
    /** @nocollapse */
    TooltipContainerComponent.ctorParameters = function () { return [
        { type: tooltip_config_TooltipConfig, },
    ]; };
    return TooltipContainerComponent;
}());

//# sourceMappingURL=tooltip-container.component.js.map
// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/component-loader/index.js
var component_loader = __webpack_require__("3Iag");

// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/utils/warn-once.js

var _messagesHash = {};
var _hideMsg = typeof console === 'undefined' || !console.warn;
function warnOnce(msg) {
    if (!Object(core_es5["isDevMode"])() || _hideMsg || msg in _messagesHash) {
        return;
    }
    _messagesHash[msg] = true;
    /*tslint:disable-next-line*/
    console.warn(msg);
}
//# sourceMappingURL=warn-once.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/tooltip/tooltip.directive.js
var tooltip_directive___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var tooltip_directive___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var tooltip_directive_TooltipDirective = (function () {
    // tslint:disable-next-line
    function TooltipDirective(_viewContainerRef, _renderer, _elementRef, cis, config) {
        /** Fired when tooltip content changes */
        this.tooltipChange = new core_es5["EventEmitter"]();
        /**
         * Css class for tooltip container
         */
        this.containerClass = '';
        /** @deprecated - removed, will be added to configuration */
        this._animation = true;
        /** @deprecated */
        this._delay = 0;
        /** @deprecated */
        this._fadeDuration = 150;
        /** @deprecated */
        this.tooltipStateChanged = new core_es5["EventEmitter"]();
        this._tooltip = cis
            .createLoader(_elementRef, _viewContainerRef, _renderer)
            .provide({ provide: tooltip_config_TooltipConfig, useValue: config });
        Object.assign(this, config);
        this.onShown = this._tooltip.onShown;
        this.onHidden = this._tooltip.onHidden;
    }
    Object.defineProperty(TooltipDirective.prototype, "isOpen", {
        /**
         * Returns whether or not the tooltip is currently being shown
         */
        get: function () { return this._tooltip.isShown; },
        set: function (value) {
            if (value) {
                this.show();
            }
            else {
                this.hide();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TooltipDirective.prototype, "htmlContent", {
        /* tslint:disable */
        /** @deprecated - please use `tooltip` instead */
        set: function (value) {
            warnOnce('tooltipHtml was deprecated, please use `tooltip` instead');
            this.tooltip = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TooltipDirective.prototype, "_placement", {
        /** @deprecated - please use `placement` instead */
        set: function (value) {
            warnOnce('tooltipPlacement was deprecated, please use `placement` instead');
            this.placement = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TooltipDirective.prototype, "_isOpen", {
        get: function () {
            warnOnce('tooltipIsOpen was deprecated, please use `isOpen` instead');
            return this.isOpen;
        },
        /** @deprecated - please use `isOpen` instead*/
        set: function (value) {
            warnOnce('tooltipIsOpen was deprecated, please use `isOpen` instead');
            this.isOpen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TooltipDirective.prototype, "_enable", {
        get: function () {
            warnOnce('tooltipEnable was deprecated, please use `isDisabled` instead');
            return this.isDisabled === true;
        },
        /** @deprecated - please use `isDisabled` instead */
        set: function (value) {
            warnOnce('tooltipEnable was deprecated, please use `isDisabled` instead');
            this.isDisabled = value === true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TooltipDirective.prototype, "_appendToBody", {
        get: function () {
            warnOnce('tooltipAppendToBody was deprecated, please use `container="body"` instead');
            return this.container === 'body';
        },
        /** @deprecated - please use `container="body"` instead */
        set: function (value) {
            warnOnce('tooltipAppendToBody was deprecated, please use `container="body"` instead');
            this.container = value ? 'body' : this.container;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TooltipDirective.prototype, "_popupClass", {
        /** @deprecated - will replaced with customClass */
        set: function (value) {
            warnOnce('tooltipClass deprecated');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TooltipDirective.prototype, "_tooltipContext", {
        /** @deprecated - removed */
        set: function (value) {
            warnOnce('tooltipContext deprecated');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TooltipDirective.prototype, "_tooltipTrigger", {
        /** @deprecated -  please use `triggers` instead */
        get: function () {
            warnOnce('tooltipTrigger was deprecated, please use `triggers` instead');
            return this.triggers;
        },
        set: function (value) {
            warnOnce('tooltipTrigger was deprecated, please use `triggers` instead');
            this.triggers = (value || '').toString();
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    TooltipDirective.prototype.ngOnInit = function () {
        var _this = this;
        this._tooltip.listen({
            triggers: this.triggers,
            show: function () { return _this.show(); }
        });
        this.tooltipChange.subscribe(function (value) {
            if (!value) {
                _this._tooltip.hide();
            }
        });
    };
    /**
     * Toggles an element’s tooltip. This is considered a “manual” triggering of
     * the tooltip.
     */
    TooltipDirective.prototype.toggle = function () {
        if (this.isOpen) {
            return this.hide();
        }
        this.show();
    };
    /**
     * Opens an element’s tooltip. This is considered a “manual” triggering of
     * the tooltip.
     */
    TooltipDirective.prototype.show = function () {
        var _this = this;
        if (this.isOpen || this.isDisabled || this._delayTimeoutId || !this.tooltip) {
            return;
        }
        var showTooltip = function () { return _this._tooltip
            .attach(tooltip_container_component_TooltipContainerComponent)
            .to(_this.container)
            .position({ attachment: _this.placement })
            .show({
            content: _this.tooltip,
            placement: _this.placement,
            containerClass: _this.containerClass
        }); };
        if (this._delay) {
            this._delayTimeoutId = setTimeout(function () { showTooltip(); }, this._delay);
        }
        else {
            showTooltip();
        }
    };
    /**
     * Closes an element’s tooltip. This is considered a “manual” triggering of
     * the tooltip.
     */
    TooltipDirective.prototype.hide = function () {
        var _this = this;
        if (this._delayTimeoutId) {
            clearTimeout(this._delayTimeoutId);
            this._delayTimeoutId = undefined;
        }
        if (!this._tooltip.isShown) {
            return;
        }
        this._tooltip.instance.classMap.in = false;
        setTimeout(function () {
            _this._tooltip.hide();
        }, this._fadeDuration);
    };
    TooltipDirective.prototype.ngOnDestroy = function () {
        this._tooltip.dispose();
    };
    TooltipDirective.decorators = [
        { type: core_es5["Directive"], args: [{
                    selector: '[tooltip], [tooltipHtml]',
                    exportAs: 'bs-tooltip'
                },] },
    ];
    /** @nocollapse */
    TooltipDirective.ctorParameters = function () { return [
        { type: core_es5["ViewContainerRef"], },
        { type: core_es5["Renderer"], },
        { type: core_es5["ElementRef"], },
        { type: component_loader["a" /* ComponentLoaderFactory */], },
        { type: tooltip_config_TooltipConfig, },
    ]; };
    TooltipDirective.propDecorators = {
        'tooltip': [{ type: core_es5["Input"] },],
        'tooltipChange': [{ type: core_es5["Output"] },],
        'placement': [{ type: core_es5["Input"] },],
        'triggers': [{ type: core_es5["Input"] },],
        'container': [{ type: core_es5["Input"] },],
        'isOpen': [{ type: core_es5["Input"] },],
        'isDisabled': [{ type: core_es5["Input"] },],
        'containerClass': [{ type: core_es5["Input"] },],
        'onShown': [{ type: core_es5["Output"] },],
        'onHidden': [{ type: core_es5["Output"] },],
        'htmlContent': [{ type: core_es5["Input"], args: ['tooltipHtml',] },],
        '_placement': [{ type: core_es5["Input"], args: ['tooltipPlacement',] },],
        '_isOpen': [{ type: core_es5["Input"], args: ['tooltipIsOpen',] },],
        '_enable': [{ type: core_es5["Input"], args: ['tooltipEnable',] },],
        '_appendToBody': [{ type: core_es5["Input"], args: ['tooltipAppendToBody',] },],
        '_animation': [{ type: core_es5["Input"], args: ['tooltipAnimation',] },],
        '_popupClass': [{ type: core_es5["Input"], args: ['tooltipClass',] },],
        '_tooltipContext': [{ type: core_es5["Input"], args: ['tooltipContext',] },],
        '_delay': [{ type: core_es5["Input"], args: ['tooltipPopupDelay',] },],
        '_fadeDuration': [{ type: core_es5["Input"], args: ['tooltipFadeDuration',] },],
        '_tooltipTrigger': [{ type: core_es5["Input"], args: ['tooltipTrigger',] },],
        'tooltipStateChanged': [{ type: core_es5["Output"] },],
    };
    tooltip_directive___decorate([
        Object(decorators["a" /* OnChange */])(),
        tooltip_directive___metadata("design:type", Object)
    ], TooltipDirective.prototype, "tooltip", void 0);
    return TooltipDirective;
}());

//# sourceMappingURL=tooltip.directive.js.map
// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/positioning/index.js
var positioning = __webpack_require__("lG5z");

// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/tooltip/tooltip.module.js







var tooltip_module_TooltipModule = (function () {
    function TooltipModule() {
    }
    TooltipModule.forRoot = function () {
        return {
            ngModule: TooltipModule,
            providers: [tooltip_config_TooltipConfig, component_loader["a" /* ComponentLoaderFactory */], positioning["a" /* PositioningService */]]
        };
    };
    ;
    TooltipModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    imports: [common_es5["CommonModule"]],
                    declarations: [tooltip_directive_TooltipDirective, tooltip_container_component_TooltipContainerComponent],
                    exports: [tooltip_directive_TooltipDirective],
                    entryComponents: [tooltip_container_component_TooltipContainerComponent]
                },] },
    ];
    /** @nocollapse */
    TooltipModule.ctorParameters = function () { return []; };
    return TooltipModule;
}());

//# sourceMappingURL=tooltip.module.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/typeahead/latin-map.js
/* tslint:disable:max-file-line-count */
var latinMap = {
    'Á': 'A',
    'Ă': 'A',
    'Ắ': 'A',
    'Ặ': 'A',
    'Ằ': 'A',
    'Ẳ': 'A',
    'Ẵ': 'A',
    'Ǎ': 'A',
    'Â': 'A',
    'Ấ': 'A',
    'Ậ': 'A',
    'Ầ': 'A',
    'Ẩ': 'A',
    'Ẫ': 'A',
    'Ä': 'A',
    'Ǟ': 'A',
    'Ȧ': 'A',
    'Ǡ': 'A',
    'Ạ': 'A',
    'Ȁ': 'A',
    'À': 'A',
    'Ả': 'A',
    'Ȃ': 'A',
    'Ā': 'A',
    'Ą': 'A',
    'Å': 'A',
    'Ǻ': 'A',
    'Ḁ': 'A',
    'Ⱥ': 'A',
    'Ã': 'A',
    'Ꜳ': 'AA',
    'Æ': 'AE',
    'Ǽ': 'AE',
    'Ǣ': 'AE',
    'Ꜵ': 'AO',
    'Ꜷ': 'AU',
    'Ꜹ': 'AV',
    'Ꜻ': 'AV',
    'Ꜽ': 'AY',
    'Ḃ': 'B',
    'Ḅ': 'B',
    'Ɓ': 'B',
    'Ḇ': 'B',
    'Ƀ': 'B',
    'Ƃ': 'B',
    'Ć': 'C',
    'Č': 'C',
    'Ç': 'C',
    'Ḉ': 'C',
    'Ĉ': 'C',
    'Ċ': 'C',
    'Ƈ': 'C',
    'Ȼ': 'C',
    'Ď': 'D',
    'Ḑ': 'D',
    'Ḓ': 'D',
    'Ḋ': 'D',
    'Ḍ': 'D',
    'Ɗ': 'D',
    'Ḏ': 'D',
    'ǲ': 'D',
    'ǅ': 'D',
    'Đ': 'D',
    'Ƌ': 'D',
    'Ǳ': 'DZ',
    'Ǆ': 'DZ',
    'É': 'E',
    'Ĕ': 'E',
    'Ě': 'E',
    'Ȩ': 'E',
    'Ḝ': 'E',
    'Ê': 'E',
    'Ế': 'E',
    'Ệ': 'E',
    'Ề': 'E',
    'Ể': 'E',
    'Ễ': 'E',
    'Ḙ': 'E',
    'Ë': 'E',
    'Ė': 'E',
    'Ẹ': 'E',
    'Ȅ': 'E',
    'È': 'E',
    'Ẻ': 'E',
    'Ȇ': 'E',
    'Ē': 'E',
    'Ḗ': 'E',
    'Ḕ': 'E',
    'Ę': 'E',
    'Ɇ': 'E',
    'Ẽ': 'E',
    'Ḛ': 'E',
    'Ꝫ': 'ET',
    'Ḟ': 'F',
    'Ƒ': 'F',
    'Ǵ': 'G',
    'Ğ': 'G',
    'Ǧ': 'G',
    'Ģ': 'G',
    'Ĝ': 'G',
    'Ġ': 'G',
    'Ɠ': 'G',
    'Ḡ': 'G',
    'Ǥ': 'G',
    'Ḫ': 'H',
    'Ȟ': 'H',
    'Ḩ': 'H',
    'Ĥ': 'H',
    'Ⱨ': 'H',
    'Ḧ': 'H',
    'Ḣ': 'H',
    'Ḥ': 'H',
    'Ħ': 'H',
    'Í': 'I',
    'Ĭ': 'I',
    'Ǐ': 'I',
    'Î': 'I',
    'Ï': 'I',
    'Ḯ': 'I',
    'İ': 'I',
    'Ị': 'I',
    'Ȉ': 'I',
    'Ì': 'I',
    'Ỉ': 'I',
    'Ȋ': 'I',
    'Ī': 'I',
    'Į': 'I',
    'Ɨ': 'I',
    'Ĩ': 'I',
    'Ḭ': 'I',
    'Ꝺ': 'D',
    'Ꝼ': 'F',
    'Ᵹ': 'G',
    'Ꞃ': 'R',
    'Ꞅ': 'S',
    'Ꞇ': 'T',
    'Ꝭ': 'IS',
    'Ĵ': 'J',
    'Ɉ': 'J',
    'Ḱ': 'K',
    'Ǩ': 'K',
    'Ķ': 'K',
    'Ⱪ': 'K',
    'Ꝃ': 'K',
    'Ḳ': 'K',
    'Ƙ': 'K',
    'Ḵ': 'K',
    'Ꝁ': 'K',
    'Ꝅ': 'K',
    'Ĺ': 'L',
    'Ƚ': 'L',
    'Ľ': 'L',
    'Ļ': 'L',
    'Ḽ': 'L',
    'Ḷ': 'L',
    'Ḹ': 'L',
    'Ⱡ': 'L',
    'Ꝉ': 'L',
    'Ḻ': 'L',
    'Ŀ': 'L',
    'Ɫ': 'L',
    'ǈ': 'L',
    'Ł': 'L',
    'Ǉ': 'LJ',
    'Ḿ': 'M',
    'Ṁ': 'M',
    'Ṃ': 'M',
    'Ɱ': 'M',
    'Ń': 'N',
    'Ň': 'N',
    'Ņ': 'N',
    'Ṋ': 'N',
    'Ṅ': 'N',
    'Ṇ': 'N',
    'Ǹ': 'N',
    'Ɲ': 'N',
    'Ṉ': 'N',
    'Ƞ': 'N',
    'ǋ': 'N',
    'Ñ': 'N',
    'Ǌ': 'NJ',
    'Ó': 'O',
    'Ŏ': 'O',
    'Ǒ': 'O',
    'Ô': 'O',
    'Ố': 'O',
    'Ộ': 'O',
    'Ồ': 'O',
    'Ổ': 'O',
    'Ỗ': 'O',
    'Ö': 'O',
    'Ȫ': 'O',
    'Ȯ': 'O',
    'Ȱ': 'O',
    'Ọ': 'O',
    'Ő': 'O',
    'Ȍ': 'O',
    'Ò': 'O',
    'Ỏ': 'O',
    'Ơ': 'O',
    'Ớ': 'O',
    'Ợ': 'O',
    'Ờ': 'O',
    'Ở': 'O',
    'Ỡ': 'O',
    'Ȏ': 'O',
    'Ꝋ': 'O',
    'Ꝍ': 'O',
    'Ō': 'O',
    'Ṓ': 'O',
    'Ṑ': 'O',
    'Ɵ': 'O',
    'Ǫ': 'O',
    'Ǭ': 'O',
    'Ø': 'O',
    'Ǿ': 'O',
    'Õ': 'O',
    'Ṍ': 'O',
    'Ṏ': 'O',
    'Ȭ': 'O',
    'Ƣ': 'OI',
    'Ꝏ': 'OO',
    'Ɛ': 'E',
    'Ɔ': 'O',
    'Ȣ': 'OU',
    'Ṕ': 'P',
    'Ṗ': 'P',
    'Ꝓ': 'P',
    'Ƥ': 'P',
    'Ꝕ': 'P',
    'Ᵽ': 'P',
    'Ꝑ': 'P',
    'Ꝙ': 'Q',
    'Ꝗ': 'Q',
    'Ŕ': 'R',
    'Ř': 'R',
    'Ŗ': 'R',
    'Ṙ': 'R',
    'Ṛ': 'R',
    'Ṝ': 'R',
    'Ȑ': 'R',
    'Ȓ': 'R',
    'Ṟ': 'R',
    'Ɍ': 'R',
    'Ɽ': 'R',
    'Ꜿ': 'C',
    'Ǝ': 'E',
    'Ś': 'S',
    'Ṥ': 'S',
    'Š': 'S',
    'Ṧ': 'S',
    'Ş': 'S',
    'Ŝ': 'S',
    'Ș': 'S',
    'Ṡ': 'S',
    'Ṣ': 'S',
    'Ṩ': 'S',
    'Ť': 'T',
    'Ţ': 'T',
    'Ṱ': 'T',
    'Ț': 'T',
    'Ⱦ': 'T',
    'Ṫ': 'T',
    'Ṭ': 'T',
    'Ƭ': 'T',
    'Ṯ': 'T',
    'Ʈ': 'T',
    'Ŧ': 'T',
    'Ɐ': 'A',
    'Ꞁ': 'L',
    'Ɯ': 'M',
    'Ʌ': 'V',
    'Ꜩ': 'TZ',
    'Ú': 'U',
    'Ŭ': 'U',
    'Ǔ': 'U',
    'Û': 'U',
    'Ṷ': 'U',
    'Ü': 'U',
    'Ǘ': 'U',
    'Ǚ': 'U',
    'Ǜ': 'U',
    'Ǖ': 'U',
    'Ṳ': 'U',
    'Ụ': 'U',
    'Ű': 'U',
    'Ȕ': 'U',
    'Ù': 'U',
    'Ủ': 'U',
    'Ư': 'U',
    'Ứ': 'U',
    'Ự': 'U',
    'Ừ': 'U',
    'Ử': 'U',
    'Ữ': 'U',
    'Ȗ': 'U',
    'Ū': 'U',
    'Ṻ': 'U',
    'Ų': 'U',
    'Ů': 'U',
    'Ũ': 'U',
    'Ṹ': 'U',
    'Ṵ': 'U',
    'Ꝟ': 'V',
    'Ṿ': 'V',
    'Ʋ': 'V',
    'Ṽ': 'V',
    'Ꝡ': 'VY',
    'Ẃ': 'W',
    'Ŵ': 'W',
    'Ẅ': 'W',
    'Ẇ': 'W',
    'Ẉ': 'W',
    'Ẁ': 'W',
    'Ⱳ': 'W',
    'Ẍ': 'X',
    'Ẋ': 'X',
    'Ý': 'Y',
    'Ŷ': 'Y',
    'Ÿ': 'Y',
    'Ẏ': 'Y',
    'Ỵ': 'Y',
    'Ỳ': 'Y',
    'Ƴ': 'Y',
    'Ỷ': 'Y',
    'Ỿ': 'Y',
    'Ȳ': 'Y',
    'Ɏ': 'Y',
    'Ỹ': 'Y',
    'Ź': 'Z',
    'Ž': 'Z',
    'Ẑ': 'Z',
    'Ⱬ': 'Z',
    'Ż': 'Z',
    'Ẓ': 'Z',
    'Ȥ': 'Z',
    'Ẕ': 'Z',
    'Ƶ': 'Z',
    'Ĳ': 'IJ',
    'Œ': 'OE',
    'ᴀ': 'A',
    'ᴁ': 'AE',
    'ʙ': 'B',
    'ᴃ': 'B',
    'ᴄ': 'C',
    'ᴅ': 'D',
    'ᴇ': 'E',
    'ꜰ': 'F',
    'ɢ': 'G',
    'ʛ': 'G',
    'ʜ': 'H',
    'ɪ': 'I',
    'ʁ': 'R',
    'ᴊ': 'J',
    'ᴋ': 'K',
    'ʟ': 'L',
    'ᴌ': 'L',
    'ᴍ': 'M',
    'ɴ': 'N',
    'ᴏ': 'O',
    'ɶ': 'OE',
    'ᴐ': 'O',
    'ᴕ': 'OU',
    'ᴘ': 'P',
    'ʀ': 'R',
    'ᴎ': 'N',
    'ᴙ': 'R',
    'ꜱ': 'S',
    'ᴛ': 'T',
    'ⱻ': 'E',
    'ᴚ': 'R',
    'ᴜ': 'U',
    'ᴠ': 'V',
    'ᴡ': 'W',
    'ʏ': 'Y',
    'ᴢ': 'Z',
    'á': 'a',
    'ă': 'a',
    'ắ': 'a',
    'ặ': 'a',
    'ằ': 'a',
    'ẳ': 'a',
    'ẵ': 'a',
    'ǎ': 'a',
    'â': 'a',
    'ấ': 'a',
    'ậ': 'a',
    'ầ': 'a',
    'ẩ': 'a',
    'ẫ': 'a',
    'ä': 'a',
    'ǟ': 'a',
    'ȧ': 'a',
    'ǡ': 'a',
    'ạ': 'a',
    'ȁ': 'a',
    'à': 'a',
    'ả': 'a',
    'ȃ': 'a',
    'ā': 'a',
    'ą': 'a',
    'ᶏ': 'a',
    'ẚ': 'a',
    'å': 'a',
    'ǻ': 'a',
    'ḁ': 'a',
    'ⱥ': 'a',
    'ã': 'a',
    'ꜳ': 'aa',
    'æ': 'ae',
    'ǽ': 'ae',
    'ǣ': 'ae',
    'ꜵ': 'ao',
    'ꜷ': 'au',
    'ꜹ': 'av',
    'ꜻ': 'av',
    'ꜽ': 'ay',
    'ḃ': 'b',
    'ḅ': 'b',
    'ɓ': 'b',
    'ḇ': 'b',
    'ᵬ': 'b',
    'ᶀ': 'b',
    'ƀ': 'b',
    'ƃ': 'b',
    'ɵ': 'o',
    'ć': 'c',
    'č': 'c',
    'ç': 'c',
    'ḉ': 'c',
    'ĉ': 'c',
    'ɕ': 'c',
    'ċ': 'c',
    'ƈ': 'c',
    'ȼ': 'c',
    'ď': 'd',
    'ḑ': 'd',
    'ḓ': 'd',
    'ȡ': 'd',
    'ḋ': 'd',
    'ḍ': 'd',
    'ɗ': 'd',
    'ᶑ': 'd',
    'ḏ': 'd',
    'ᵭ': 'd',
    'ᶁ': 'd',
    'đ': 'd',
    'ɖ': 'd',
    'ƌ': 'd',
    'ı': 'i',
    'ȷ': 'j',
    'ɟ': 'j',
    'ʄ': 'j',
    'ǳ': 'dz',
    'ǆ': 'dz',
    'é': 'e',
    'ĕ': 'e',
    'ě': 'e',
    'ȩ': 'e',
    'ḝ': 'e',
    'ê': 'e',
    'ế': 'e',
    'ệ': 'e',
    'ề': 'e',
    'ể': 'e',
    'ễ': 'e',
    'ḙ': 'e',
    'ë': 'e',
    'ė': 'e',
    'ẹ': 'e',
    'ȅ': 'e',
    'è': 'e',
    'ẻ': 'e',
    'ȇ': 'e',
    'ē': 'e',
    'ḗ': 'e',
    'ḕ': 'e',
    'ⱸ': 'e',
    'ę': 'e',
    'ᶒ': 'e',
    'ɇ': 'e',
    'ẽ': 'e',
    'ḛ': 'e',
    'ꝫ': 'et',
    'ḟ': 'f',
    'ƒ': 'f',
    'ᵮ': 'f',
    'ᶂ': 'f',
    'ǵ': 'g',
    'ğ': 'g',
    'ǧ': 'g',
    'ģ': 'g',
    'ĝ': 'g',
    'ġ': 'g',
    'ɠ': 'g',
    'ḡ': 'g',
    'ᶃ': 'g',
    'ǥ': 'g',
    'ḫ': 'h',
    'ȟ': 'h',
    'ḩ': 'h',
    'ĥ': 'h',
    'ⱨ': 'h',
    'ḧ': 'h',
    'ḣ': 'h',
    'ḥ': 'h',
    'ɦ': 'h',
    'ẖ': 'h',
    'ħ': 'h',
    'ƕ': 'hv',
    'í': 'i',
    'ĭ': 'i',
    'ǐ': 'i',
    'î': 'i',
    'ï': 'i',
    'ḯ': 'i',
    'ị': 'i',
    'ȉ': 'i',
    'ì': 'i',
    'ỉ': 'i',
    'ȋ': 'i',
    'ī': 'i',
    'į': 'i',
    'ᶖ': 'i',
    'ɨ': 'i',
    'ĩ': 'i',
    'ḭ': 'i',
    'ꝺ': 'd',
    'ꝼ': 'f',
    'ᵹ': 'g',
    'ꞃ': 'r',
    'ꞅ': 's',
    'ꞇ': 't',
    'ꝭ': 'is',
    'ǰ': 'j',
    'ĵ': 'j',
    'ʝ': 'j',
    'ɉ': 'j',
    'ḱ': 'k',
    'ǩ': 'k',
    'ķ': 'k',
    'ⱪ': 'k',
    'ꝃ': 'k',
    'ḳ': 'k',
    'ƙ': 'k',
    'ḵ': 'k',
    'ᶄ': 'k',
    'ꝁ': 'k',
    'ꝅ': 'k',
    'ĺ': 'l',
    'ƚ': 'l',
    'ɬ': 'l',
    'ľ': 'l',
    'ļ': 'l',
    'ḽ': 'l',
    'ȴ': 'l',
    'ḷ': 'l',
    'ḹ': 'l',
    'ⱡ': 'l',
    'ꝉ': 'l',
    'ḻ': 'l',
    'ŀ': 'l',
    'ɫ': 'l',
    'ᶅ': 'l',
    'ɭ': 'l',
    'ł': 'l',
    'ǉ': 'lj',
    'ſ': 's',
    'ẜ': 's',
    'ẛ': 's',
    'ẝ': 's',
    'ḿ': 'm',
    'ṁ': 'm',
    'ṃ': 'm',
    'ɱ': 'm',
    'ᵯ': 'm',
    'ᶆ': 'm',
    'ń': 'n',
    'ň': 'n',
    'ņ': 'n',
    'ṋ': 'n',
    'ȵ': 'n',
    'ṅ': 'n',
    'ṇ': 'n',
    'ǹ': 'n',
    'ɲ': 'n',
    'ṉ': 'n',
    'ƞ': 'n',
    'ᵰ': 'n',
    'ᶇ': 'n',
    'ɳ': 'n',
    'ñ': 'n',
    'ǌ': 'nj',
    'ó': 'o',
    'ŏ': 'o',
    'ǒ': 'o',
    'ô': 'o',
    'ố': 'o',
    'ộ': 'o',
    'ồ': 'o',
    'ổ': 'o',
    'ỗ': 'o',
    'ö': 'o',
    'ȫ': 'o',
    'ȯ': 'o',
    'ȱ': 'o',
    'ọ': 'o',
    'ő': 'o',
    'ȍ': 'o',
    'ò': 'o',
    'ỏ': 'o',
    'ơ': 'o',
    'ớ': 'o',
    'ợ': 'o',
    'ờ': 'o',
    'ở': 'o',
    'ỡ': 'o',
    'ȏ': 'o',
    'ꝋ': 'o',
    'ꝍ': 'o',
    'ⱺ': 'o',
    'ō': 'o',
    'ṓ': 'o',
    'ṑ': 'o',
    'ǫ': 'o',
    'ǭ': 'o',
    'ø': 'o',
    'ǿ': 'o',
    'õ': 'o',
    'ṍ': 'o',
    'ṏ': 'o',
    'ȭ': 'o',
    'ƣ': 'oi',
    'ꝏ': 'oo',
    'ɛ': 'e',
    'ᶓ': 'e',
    'ɔ': 'o',
    'ᶗ': 'o',
    'ȣ': 'ou',
    'ṕ': 'p',
    'ṗ': 'p',
    'ꝓ': 'p',
    'ƥ': 'p',
    'ᵱ': 'p',
    'ᶈ': 'p',
    'ꝕ': 'p',
    'ᵽ': 'p',
    'ꝑ': 'p',
    'ꝙ': 'q',
    'ʠ': 'q',
    'ɋ': 'q',
    'ꝗ': 'q',
    'ŕ': 'r',
    'ř': 'r',
    'ŗ': 'r',
    'ṙ': 'r',
    'ṛ': 'r',
    'ṝ': 'r',
    'ȑ': 'r',
    'ɾ': 'r',
    'ᵳ': 'r',
    'ȓ': 'r',
    'ṟ': 'r',
    'ɼ': 'r',
    'ᵲ': 'r',
    'ᶉ': 'r',
    'ɍ': 'r',
    'ɽ': 'r',
    'ↄ': 'c',
    'ꜿ': 'c',
    'ɘ': 'e',
    'ɿ': 'r',
    'ś': 's',
    'ṥ': 's',
    'š': 's',
    'ṧ': 's',
    'ş': 's',
    'ŝ': 's',
    'ș': 's',
    'ṡ': 's',
    'ṣ': 's',
    'ṩ': 's',
    'ʂ': 's',
    'ᵴ': 's',
    'ᶊ': 's',
    'ȿ': 's',
    'ɡ': 'g',
    'ᴑ': 'o',
    'ᴓ': 'o',
    'ᴝ': 'u',
    'ť': 't',
    'ţ': 't',
    'ṱ': 't',
    'ț': 't',
    'ȶ': 't',
    'ẗ': 't',
    'ⱦ': 't',
    'ṫ': 't',
    'ṭ': 't',
    'ƭ': 't',
    'ṯ': 't',
    'ᵵ': 't',
    'ƫ': 't',
    'ʈ': 't',
    'ŧ': 't',
    'ᵺ': 'th',
    'ɐ': 'a',
    'ᴂ': 'ae',
    'ǝ': 'e',
    'ᵷ': 'g',
    'ɥ': 'h',
    'ʮ': 'h',
    'ʯ': 'h',
    'ᴉ': 'i',
    'ʞ': 'k',
    'ꞁ': 'l',
    'ɯ': 'm',
    'ɰ': 'm',
    'ᴔ': 'oe',
    'ɹ': 'r',
    'ɻ': 'r',
    'ɺ': 'r',
    'ⱹ': 'r',
    'ʇ': 't',
    'ʌ': 'v',
    'ʍ': 'w',
    'ʎ': 'y',
    'ꜩ': 'tz',
    'ú': 'u',
    'ŭ': 'u',
    'ǔ': 'u',
    'û': 'u',
    'ṷ': 'u',
    'ü': 'u',
    'ǘ': 'u',
    'ǚ': 'u',
    'ǜ': 'u',
    'ǖ': 'u',
    'ṳ': 'u',
    'ụ': 'u',
    'ű': 'u',
    'ȕ': 'u',
    'ù': 'u',
    'ủ': 'u',
    'ư': 'u',
    'ứ': 'u',
    'ự': 'u',
    'ừ': 'u',
    'ử': 'u',
    'ữ': 'u',
    'ȗ': 'u',
    'ū': 'u',
    'ṻ': 'u',
    'ų': 'u',
    'ᶙ': 'u',
    'ů': 'u',
    'ũ': 'u',
    'ṹ': 'u',
    'ṵ': 'u',
    'ᵫ': 'ue',
    'ꝸ': 'um',
    'ⱴ': 'v',
    'ꝟ': 'v',
    'ṿ': 'v',
    'ʋ': 'v',
    'ᶌ': 'v',
    'ⱱ': 'v',
    'ṽ': 'v',
    'ꝡ': 'vy',
    'ẃ': 'w',
    'ŵ': 'w',
    'ẅ': 'w',
    'ẇ': 'w',
    'ẉ': 'w',
    'ẁ': 'w',
    'ⱳ': 'w',
    'ẘ': 'w',
    'ẍ': 'x',
    'ẋ': 'x',
    'ᶍ': 'x',
    'ý': 'y',
    'ŷ': 'y',
    'ÿ': 'y',
    'ẏ': 'y',
    'ỵ': 'y',
    'ỳ': 'y',
    'ƴ': 'y',
    'ỷ': 'y',
    'ỿ': 'y',
    'ȳ': 'y',
    'ẙ': 'y',
    'ɏ': 'y',
    'ỹ': 'y',
    'ź': 'z',
    'ž': 'z',
    'ẑ': 'z',
    'ʑ': 'z',
    'ⱬ': 'z',
    'ż': 'z',
    'ẓ': 'z',
    'ȥ': 'z',
    'ẕ': 'z',
    'ᵶ': 'z',
    'ᶎ': 'z',
    'ʐ': 'z',
    'ƶ': 'z',
    'ɀ': 'z',
    'ﬀ': 'ff',
    'ﬃ': 'ffi',
    'ﬄ': 'ffl',
    'ﬁ': 'fi',
    'ﬂ': 'fl',
    'ĳ': 'ij',
    'œ': 'oe',
    'ﬆ': 'st',
    'ₐ': 'a',
    'ₑ': 'e',
    'ᵢ': 'i',
    'ⱼ': 'j',
    'ₒ': 'o',
    'ᵣ': 'r',
    'ᵤ': 'u',
    'ᵥ': 'v',
    'ₓ': 'x'
};
//# sourceMappingURL=latin-map.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/typeahead/typeahead-utils.js

function latinize(str) {
    if (!str) {
        return '';
    }
    return str.replace(/[^A-Za-z0-9\[\] ]/g, function (a) {
        return latinMap[a] || a;
    });
}
function escapeRegexp(queryToEscape) {
    // Regex: capture the whole query string and replace it with the string
    // that will be used to match the results, for example if the capture is
    // 'a' the result will be \a
    return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
}
/* tslint:disable */
function tokenize(str, wordRegexDelimiters, phraseRegexDelimiters) {
    if (wordRegexDelimiters === void 0) { wordRegexDelimiters = ' '; }
    if (phraseRegexDelimiters === void 0) { phraseRegexDelimiters = ''; }
    /* tslint:enable */
    var regexStr = '(?:[' + phraseRegexDelimiters + '])([^' + phraseRegexDelimiters + ']+)(?:[' + phraseRegexDelimiters + '])|([^' + wordRegexDelimiters + ']+)';
    var preTokenized = str.split(new RegExp(regexStr, 'g'));
    var result = [];
    var preTokenizedLength = preTokenized.length;
    var token;
    var replacePhraseDelimiters = new RegExp('[' + phraseRegexDelimiters + ']+', 'g');
    for (var i = 0; i < preTokenizedLength; i += 1) {
        token = preTokenized[i];
        if (token && token.length && token !== wordRegexDelimiters) {
            result.push(token.replace(replacePhraseDelimiters, ''));
        }
    }
    return result;
}
function getValueFromObject(object, option) {
    if (!option || typeof object !== 'object') {
        return object.toString();
    }
    if (option.endsWith('()')) {
        var functionName = option.slice(0, option.length - 2);
        return object[functionName]().toString();
    }
    var properties = option.replace(/\[(\w+)\]/g, '.$1')
        .replace(/^\./, '');
    var propertiesArray = properties.split('.');
    for (var _i = 0, propertiesArray_1 = propertiesArray; _i < propertiesArray_1.length; _i++) {
        var property = propertiesArray_1[_i];
        if (property in object) {
            object = object[property];
        }
    }
    if (!object)
        return "";
    return object.toString();
}
//# sourceMappingURL=typeahead-utils.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/typeahead/typeahead-container.component.js



var typeahead_container_component_TypeaheadContainerComponent = (function () {
    function TypeaheadContainerComponent(element) {
        this.isFocused = false;
        this._matches = [];
        this.element = element;
    }
    Object.defineProperty(TypeaheadContainerComponent.prototype, "isBs4", {
        get: function () {
            return !Object(ng2_bootstrap_config["a" /* isBs3 */])();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TypeaheadContainerComponent.prototype, "active", {
        get: function () {
            return this._active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TypeaheadContainerComponent.prototype, "matches", {
        get: function () {
            return this._matches;
        },
        set: function (value) {
            this._matches = value;
            if (this._matches.length > 0) {
                this._active = this._matches[0];
                if (this._active.isHeader()) {
                    this.nextActiveMatch();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TypeaheadContainerComponent.prototype, "optionsListTemplate", {
        get: function () {
            return this.parent ? this.parent.optionsListTemplate : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TypeaheadContainerComponent.prototype, "itemTemplate", {
        get: function () {
            return this.parent ? this.parent.typeaheadItemTemplate : undefined;
        },
        enumerable: true,
        configurable: true
    });
    TypeaheadContainerComponent.prototype.selectActiveMatch = function () {
        this.selectMatch(this._active);
    };
    TypeaheadContainerComponent.prototype.prevActiveMatch = function () {
        var index = this.matches.indexOf(this._active);
        this._active = this.matches[index - 1 < 0
            ? this.matches.length - 1
            : index - 1];
        if (this._active.isHeader()) {
            this.prevActiveMatch();
        }
    };
    TypeaheadContainerComponent.prototype.nextActiveMatch = function () {
        var index = this.matches.indexOf(this._active);
        this._active = this.matches[index + 1 > this.matches.length - 1
            ? 0
            : index + 1];
        if (this._active.isHeader()) {
            this.nextActiveMatch();
        }
    };
    TypeaheadContainerComponent.prototype.selectActive = function (value) {
        this.isFocused = true;
        this._active = value;
    };
    TypeaheadContainerComponent.prototype.hightlight = function (match, query) {
        var itemStr = match.value;
        var itemStrHelper = (this.parent && this.parent.typeaheadLatinize
            ? latinize(itemStr)
            : itemStr).toLowerCase();
        var startIdx;
        var tokenLen;
        // Replaces the capture string with the same string inside of a "strong" tag
        if (typeof query === 'object') {
            var queryLen = query.length;
            for (var i = 0; i < queryLen; i += 1) {
                // query[i] is already latinized and lower case
                startIdx = itemStrHelper.indexOf(query[i]);
                tokenLen = query[i].length;
                if (startIdx >= 0 && tokenLen > 0) {
                    itemStr = itemStr.substring(0, startIdx) + '<strong>' + itemStr.substring(startIdx, startIdx + tokenLen) + '</strong>' + itemStr.substring(startIdx + tokenLen);
                    itemStrHelper = itemStrHelper.substring(0, startIdx) + '        ' + ' '.repeat(tokenLen) + '         ' + itemStrHelper.substring(startIdx + tokenLen);
                }
            }
        }
        else if (query) {
            // query is already latinized and lower case
            startIdx = itemStrHelper.indexOf(query);
            tokenLen = query.length;
            if (startIdx >= 0 && tokenLen > 0) {
                itemStr = itemStr.substring(0, startIdx) + '<strong>' + itemStr.substring(startIdx, startIdx + tokenLen) + '</strong>' + itemStr.substring(startIdx + tokenLen);
            }
        }
        return itemStr;
    };
    TypeaheadContainerComponent.prototype.focusLost = function () {
        this.isFocused = false;
    };
    TypeaheadContainerComponent.prototype.isActive = function (value) {
        return this._active === value;
    };
    TypeaheadContainerComponent.prototype.selectMatch = function (value, e) {
        var _this = this;
        if (e === void 0) { e = void 0; }
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        this.parent.changeModel(value);
        setTimeout(function () {
            return _this.parent.typeaheadOnSelect.emit(value);
        }, 0);
        return false;
    };
    TypeaheadContainerComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'typeahead-container',
                    // tslint:disable-next-line
                    template: "\n<!-- inject options list template -->\n<template [ngTemplateOutlet]=\"optionsListTemplate || (isBs4 ? bs4Template : bs3Template)\"\n  [ngOutletContext]=\"{matches:matches, itemTemplate:itemTemplate, query:query}\"></template>\n\n<!-- default options item template -->\n<template #bsItemTemplate let-match=\"match\" let-query=\"query\"><span [innerHtml]=\"hightlight(match, query)\"></span></template>\n\n<!-- Bootstrap 3 options list template -->\n<template #bs3Template>\n<ul class=\"dropdown-menu\">\n  <template ngFor let-match let-i=\"index\" [ngForOf]=\"matches\">\n    <li *ngIf=\"match.isHeader()\" class=\"dropdown-header\">{{match}}</li>\n    <li *ngIf=\"!match.isHeader()\" [class.active]=\"isActive(match)\" (mouseenter)=\"selectActive(match)\">\n      <a href=\"#\" (click)=\"selectMatch(match, $event)\" tabindex=\"-1\">\n        <template [ngTemplateOutlet]=\"itemTemplate || bsItemTemplate\" \n          [ngOutletContext]=\"{item:match.item, index:i, match:match, query:query}\"></template>\n      </a>\n    </li>\n  </template>\n</ul>\n</template>\n\n<!-- Bootstrap 4 options list template -->\n<template #bs4Template >\n<template ngFor let-match let-i=\"index\" [ngForOf]=\"matches\">\n   <h6 *ngIf=\"match.isHeader()\" class=\"dropdown-header\">{{match}}</h6>\n   <template [ngIf]=\"!match.isHeader()\">\n      <button\n        class=\"dropdown-item\"\n        (click)=\"selectMatch(match, $event)\"\n        (mouseenter)=\"selectActive(match)\"\n        [class.active]=\"isActive(match)\">\n          <template [ngTemplateOutlet]=\"itemTemplate || bsItemTemplate\" \n            [ngOutletContext]=\"{item:match.item, index:i, match:match, query:query}\"></template>\n      </button>\n  </template>\n</template>\n</template>\n",
                    // tslint:disable
                    host: {
                        'class': 'dropdown open',
                        '[class.dropdown-menu]': 'isBs4',
                        '[class.dropup]': 'dropup',
                        style: 'position: absolute;display: block;'
                    },
                    // tslint: enable
                    encapsulation: core_es5["ViewEncapsulation"].None
                },] },
    ];
    /** @nocollapse */
    TypeaheadContainerComponent.ctorParameters = function () { return [
        { type: core_es5["ElementRef"], },
    ]; };
    TypeaheadContainerComponent.propDecorators = {
        'focusLost': [{ type: core_es5["HostListener"], args: ['mouseleave',] }, { type: core_es5["HostListener"], args: ['blur',] },],
    };
    return TypeaheadContainerComponent;
}());

//# sourceMappingURL=typeahead-container.component.js.map
// EXTERNAL MODULE: ./node_modules/rxjs/add/operator/debounceTime.js
var debounceTime = __webpack_require__("aV5h");
var debounceTime_default = /*#__PURE__*/__webpack_require__.n(debounceTime);

// EXTERNAL MODULE: ./node_modules/rxjs/add/operator/filter.js
var filter = __webpack_require__("wUn1");
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);

// EXTERNAL MODULE: ./node_modules/rxjs/add/operator/toArray.js
var toArray = __webpack_require__("7axH");
var toArray_default = /*#__PURE__*/__webpack_require__.n(toArray);

// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/typeahead/typeahead-match.class.js
var TypeaheadMatch = (function () {
    function TypeaheadMatch(item, value, header) {
        if (value === void 0) { value = item; }
        if (header === void 0) { header = false; }
        this.item = item;
        this.value = value;
        this.header = header;
    }
    TypeaheadMatch.prototype.isHeader = function () {
        return this.header;
    };
    TypeaheadMatch.prototype.toString = function () {
        return this.value;
    };
    return TypeaheadMatch;
}());

//# sourceMappingURL=typeahead-match.class.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/typeahead/typeahead.directive.js













var typeahead_directive_TypeaheadDirective = (function () {
    function TypeaheadDirective(control, viewContainerRef, element, renderer, cis) {
        /** minimal no of characters that needs to be entered before typeahead kicks-in. When set to 0, typeahead shows on focus with full list of options (limited as normal by typeaheadOptionsLimit) */
        this.typeaheadMinLength = void 0;
        /** should be used only in case of typeahead attribute is array. If true - loading of options will be async, otherwise - sync. true make sense if options array is large. */
        this.typeaheadAsync = void 0;
        /** match latin symbols. If true the word súper would match super and vice versa. */
        this.typeaheadLatinize = true;
        /** break words with spaces. If true the text "exact phrase" here match would match with match exact phrase here but not with phrase here exact match (kind of "google style"). */
        this.typeaheadSingleWords = true;
        /** should be used only in case typeaheadSingleWords attribute is true. Sets the word delimiter to break words. Defaults to space. */
        this.typeaheadWordDelimiters = ' ';
        /** should be used only in case typeaheadSingleWords attribute is true. Sets the word delimiter to match exact phrase. Defaults to simple and double quotes. */
        this.typeaheadPhraseDelimiters = '\'"';
        /** fired when 'busy' state of this component was changed, fired on async mode only, returns boolean */
        this.typeaheadLoading = new core_es5["EventEmitter"]();
        /** fired on every key event and returns true in case of matches are not detected */
        this.typeaheadNoResults = new core_es5["EventEmitter"]();
        /** fired when option was selected, return object with data of this option */
        this.typeaheadOnSelect = new core_es5["EventEmitter"]();
        /** fired when blur event occurres. returns the active item */
        this.typeaheadOnBlur = new core_es5["EventEmitter"]();
        /** This attribute indicates that the dropdown should be opened upwards */
        this.dropup = false;
        this.isTypeaheadOptionsListActive = false;
        this.keyUpEventEmitter = new core_es5["EventEmitter"]();
        this.placement = 'bottom-left';
        this._subscriptions = [];
        this.element = element;
        this.ngControl = control;
        this.viewContainerRef = viewContainerRef;
        this.renderer = renderer;
        this._typeahead = cis
            .createLoader(element, viewContainerRef, renderer);
    }
    TypeaheadDirective.prototype.onChange = function (e) {
        if (this._container) {
            // esc
            if (e.keyCode === 27) {
                this.hide();
                return;
            }
            // up
            if (e.keyCode === 38) {
                this._container.prevActiveMatch();
                return;
            }
            // down
            if (e.keyCode === 40) {
                this._container.nextActiveMatch();
                return;
            }
            // enter
            if (e.keyCode === 13) {
                this._container.selectActiveMatch();
                return;
            }
        }
        // For `<input>`s, use the `value` property. For others that don't have a
        // `value` (such as `<span contenteditable="true">`), use either
        // `textContent` or `innerText` (depending on which one is supported, i.e.
        // Firefox or IE).
        var value = e.target.value !== undefined
            ? e.target.value
            : e.target.textContent !== undefined
                ? e.target.textContent
                : e.target.innerText;
        if (value != null && value.trim().length >= this.typeaheadMinLength) {
            this.typeaheadLoading.emit(true);
            this.keyUpEventEmitter.emit(e.target.value);
        }
        else {
            this.typeaheadLoading.emit(false);
            this.typeaheadNoResults.emit(false);
            this.hide();
        }
    };
    TypeaheadDirective.prototype.onFocus = function () {
        if (this.typeaheadMinLength === 0) {
            this.typeaheadLoading.emit(true);
            this.keyUpEventEmitter.emit('');
        }
    };
    TypeaheadDirective.prototype.onBlur = function () {
        if (this._container && !this._container.isFocused) {
            this.typeaheadOnBlur.emit(this._container.active);
            this.hide();
        }
    };
    TypeaheadDirective.prototype.onKeydown = function (e) {
        // no container - no problems
        if (!this._container) {
            return;
        }
        // if items is visible - prevent form submition
        if (e.keyCode === 13) {
            e.preventDefault();
            return;
        }
    };
    TypeaheadDirective.prototype.ngOnInit = function () {
        this.typeaheadOptionsLimit = this.typeaheadOptionsLimit || 20;
        this.typeaheadMinLength = this.typeaheadMinLength === void 0
            ? 1
            : this.typeaheadMinLength;
        this.typeaheadWaitMs = this.typeaheadWaitMs || 0;
        // async should be false in case of array
        if (this.typeaheadAsync === undefined && !(this.typeahead instanceof Observable["Observable"])) {
            this.typeaheadAsync = false;
        }
        if (this.typeahead instanceof Observable["Observable"]) {
            this.typeaheadAsync = true;
        }
        if (this.typeaheadAsync) {
            this.asyncActions();
        }
        else {
            this.syncActions();
        }
    };
    TypeaheadDirective.prototype.changeModel = function (match) {
        var valueStr = match.value;
        this.ngControl.viewToModelUpdate(valueStr);
        this.ngControl.control.setValue(valueStr);
        this.hide();
    };
    Object.defineProperty(TypeaheadDirective.prototype, "matches", {
        get: function () {
            return this._matches;
        },
        enumerable: true,
        configurable: true
    });
    TypeaheadDirective.prototype.show = function () {
        this._typeahead
            .attach(typeahead_container_component_TypeaheadContainerComponent)
            .to(this.container)
            .position({ attachment: (this.dropup ? 'top' : 'bottom') + " left" })
            .show({
            typeaheadRef: this,
            placement: this.placement,
            animation: false,
            dropup: this.dropup
        });
        this._container = this._typeahead.instance;
        this._container.parent = this;
        // This improves the speed as it won't have to be done for each list item
        var normalizedQuery = (this.typeaheadLatinize
            ? latinize(this.ngControl.control.value)
            : this.ngControl.control.value).toString()
            .toLowerCase();
        this._container.query = this.typeaheadSingleWords
            ? tokenize(normalizedQuery, this.typeaheadWordDelimiters, this.typeaheadPhraseDelimiters)
            : normalizedQuery;
        this._container.matches = this._matches;
        this.element.nativeElement.focus();
    };
    TypeaheadDirective.prototype.hide = function () {
        if (this._typeahead.isShown) {
            this._typeahead.hide();
            this._container = null;
        }
    };
    TypeaheadDirective.prototype.ngOnDestroy = function () {
        // clean up subscriptions
        for (var _i = 0, _a = this._subscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            sub.unsubscribe();
        }
        this._typeahead.dispose();
    };
    TypeaheadDirective.prototype.asyncActions = function () {
        var _this = this;
        this._subscriptions.push(this.keyUpEventEmitter
            .debounceTime(this.typeaheadWaitMs)
            .mergeMap(function () { return _this.typeahead; })
            .subscribe(function (matches) {
            _this.finalizeAsyncCall(matches);
        }, function (err) {
            console.error(err);
        }));
    };
    TypeaheadDirective.prototype.syncActions = function () {
        var _this = this;
        this._subscriptions.push(this.keyUpEventEmitter
            .debounceTime(this.typeaheadWaitMs)
            .mergeMap(function (value) {
            var normalizedQuery = _this.normalizeQuery(value);
            return Observable["Observable"].from(_this.typeahead)
                .filter(function (option) {
                return option && _this.testMatch(_this.normalizeOption(option), normalizedQuery);
            })
                .toArray();
        })
            .subscribe(function (matches) {
            _this.finalizeAsyncCall(matches);
        }, function (err) {
            console.error(err);
        }));
    };
    TypeaheadDirective.prototype.normalizeOption = function (option) {
        var optionValue = getValueFromObject(option, this.typeaheadOptionField);
        var normalizedOption = this.typeaheadLatinize
            ? latinize(optionValue)
            : optionValue;
        return normalizedOption.toLowerCase();
    };
    TypeaheadDirective.prototype.normalizeQuery = function (value) {
        // If singleWords, break model here to not be doing extra work on each
        // iteration
        var normalizedQuery = (this.typeaheadLatinize ? latinize(value) : value)
            .toString()
            .toLowerCase();
        normalizedQuery = this.typeaheadSingleWords
            ? tokenize(normalizedQuery, this.typeaheadWordDelimiters, this.typeaheadPhraseDelimiters)
            : normalizedQuery;
        return normalizedQuery;
    };
    TypeaheadDirective.prototype.testMatch = function (match, test) {
        var spaceLength;
        if (typeof test === 'object') {
            spaceLength = test.length;
            for (var i = 0; i < spaceLength; i += 1) {
                if (test[i].length > 0 && match.indexOf(test[i]) < 0) {
                    return false;
                }
            }
            return true;
        }
        else {
            return match.indexOf(test) >= 0;
        }
    };
    TypeaheadDirective.prototype.finalizeAsyncCall = function (matches) {
        this.prepareMatches(matches);
        this.typeaheadLoading.emit(false);
        this.typeaheadNoResults.emit(!this.hasMatches());
        if (!this.hasMatches()) {
            this.hide();
            return;
        }
        if (this._container) {
            // This improves the speed as it won't have to be done for each list item
            var normalizedQuery = (this.typeaheadLatinize
                ? latinize(this.ngControl.control.value)
                : this.ngControl.control.value).toString()
                .toLowerCase();
            this._container.query = this.typeaheadSingleWords
                ? tokenize(normalizedQuery, this.typeaheadWordDelimiters, this.typeaheadPhraseDelimiters)
                : normalizedQuery;
            this._container.matches = this._matches;
        }
        else {
            this.show();
        }
    };
    TypeaheadDirective.prototype.prepareMatches = function (options) {
        var _this = this;
        var limited = options.slice(0, this.typeaheadOptionsLimit);
        if (this.typeaheadGroupField) {
            var matches_1 = [];
            // extract all group names
            var groups = limited
                .map(function (option) { return getValueFromObject(option, _this.typeaheadGroupField); })
                .filter(function (v, i, a) { return a.indexOf(v) === i; });
            groups.forEach(function (group) {
                // add group header to array of matches
                matches_1.push(new TypeaheadMatch(group, group, true));
                // add each item of group to array of matches
                matches_1 = matches_1.concat(limited
                    .filter(function (option) { return getValueFromObject(option, _this.typeaheadGroupField) === group; })
                    .map(function (option) { return new TypeaheadMatch(option, getValueFromObject(option, _this.typeaheadOptionField)); }));
            });
            this._matches = matches_1;
        }
        else {
            this._matches = limited.map(function (option) { return new TypeaheadMatch(option, getValueFromObject(option, _this.typeaheadOptionField)); });
        }
    };
    TypeaheadDirective.prototype.hasMatches = function () {
        return this._matches.length > 0;
    };
    TypeaheadDirective.decorators = [
        { type: core_es5["Directive"], args: [{ selector: '[typeahead]', exportAs: 'bs-typeahead' },] },
    ];
    /** @nocollapse */
    TypeaheadDirective.ctorParameters = function () { return [
        { type: forms_es5["NgControl"], },
        { type: core_es5["ViewContainerRef"], },
        { type: core_es5["ElementRef"], },
        { type: core_es5["Renderer"], },
        { type: component_loader["a" /* ComponentLoaderFactory */], },
    ]; };
    TypeaheadDirective.propDecorators = {
        'typeahead': [{ type: core_es5["Input"] },],
        'typeaheadMinLength': [{ type: core_es5["Input"] },],
        'typeaheadWaitMs': [{ type: core_es5["Input"] },],
        'typeaheadOptionsLimit': [{ type: core_es5["Input"] },],
        'typeaheadOptionField': [{ type: core_es5["Input"] },],
        'typeaheadGroupField': [{ type: core_es5["Input"] },],
        'typeaheadAsync': [{ type: core_es5["Input"] },],
        'typeaheadLatinize': [{ type: core_es5["Input"] },],
        'typeaheadSingleWords': [{ type: core_es5["Input"] },],
        'typeaheadWordDelimiters': [{ type: core_es5["Input"] },],
        'typeaheadPhraseDelimiters': [{ type: core_es5["Input"] },],
        'typeaheadItemTemplate': [{ type: core_es5["Input"] },],
        'optionsListTemplate': [{ type: core_es5["Input"] },],
        'typeaheadLoading': [{ type: core_es5["Output"] },],
        'typeaheadNoResults': [{ type: core_es5["Output"] },],
        'typeaheadOnSelect': [{ type: core_es5["Output"] },],
        'typeaheadOnBlur': [{ type: core_es5["Output"] },],
        'container': [{ type: core_es5["Input"] },],
        'dropup': [{ type: core_es5["Input"] },],
        'onChange': [{ type: core_es5["HostListener"], args: ['keyup', ['$event'],] },],
        'onFocus': [{ type: core_es5["HostListener"], args: ['focus',] },],
        'onBlur': [{ type: core_es5["HostListener"], args: ['blur',] },],
        'onKeydown': [{ type: core_es5["HostListener"], args: ['keydown', ['$event'],] },],
    };
    return TypeaheadDirective;
}());

//# sourceMappingURL=typeahead.directive.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/typeahead/typeahead.module.js






var typeahead_module_TypeaheadModule = (function () {
    function TypeaheadModule() {
    }
    TypeaheadModule.forRoot = function () {
        return {
            ngModule: TypeaheadModule,
            providers: [component_loader["a" /* ComponentLoaderFactory */], positioning["a" /* PositioningService */]]
        };
    };
    ;
    TypeaheadModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    imports: [common_es5["CommonModule"]],
                    declarations: [typeahead_container_component_TypeaheadContainerComponent, typeahead_directive_TypeaheadDirective],
                    exports: [typeahead_container_component_TypeaheadContainerComponent, typeahead_directive_TypeaheadDirective],
                    entryComponents: [typeahead_container_component_TypeaheadContainerComponent]
                },] },
    ];
    /** @nocollapse */
    TypeaheadModule.ctorParameters = function () { return []; };
    return TypeaheadModule;
}());

//# sourceMappingURL=typeahead.module.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/popover/popover.config.js

/**
 * Configuration service for the Popover directive.
 * You can inject this service, typically in your root component, and customize
 * the values of its properties in order to provide default values for all the
 * popovers used in the application.
 */
var popover_config_PopoverConfig = (function () {
    function PopoverConfig() {
        /**
         * Placement of a popover. Accepts: "top", "bottom", "left", "right", "auto"
         */
        this.placement = 'top';
        /**
         * Specifies events that should trigger. Supports a space separated list of
         * event names.
         */
        this.triggers = 'click';
        this.outsideClick = false;
    }
    PopoverConfig.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    PopoverConfig.ctorParameters = function () { return []; };
    return PopoverConfig;
}());

//# sourceMappingURL=popover.config.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/popover/popover-container.component.js



var popover_container_component_PopoverContainerComponent = (function () {
    function PopoverContainerComponent(config) {
        Object.assign(this, config);
    }
    Object.defineProperty(PopoverContainerComponent.prototype, "isBs3", {
        get: function () {
            return Object(ng2_bootstrap_config["a" /* isBs3 */])();
        },
        enumerable: true,
        configurable: true
    });
    PopoverContainerComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'popover-container',
                    changeDetection: core_es5["ChangeDetectionStrategy"].OnPush,
                    // tslint:disable-next-line
                    host: {
                        '[class]': '"popover in popover-" + placement + " " + "bs-popover-" + placement + " " + placement + " " + containerClass',
                        '[class.show]': '!isBs3',
                        role: 'tooltip',
                        style: 'display:block;'
                    },
                    styles: ["\n    :host.bs-popover-top .arrow, :host.bs-popover-bottom .arrow {\n      left: calc(50% - 5px);\n    }\n    :host.bs-popover-left .arrow, :host.bs-popover-right .arrow {\n      top: calc(50% - 2.5px);\n    }\n  "],
                    template: "\n<div class=\"popover-arrow arrow\"></div>\n<h3 class=\"popover-title popover-header\" *ngIf=\"title\">{{title}}</h3><div class=\"popover-content popover-body\"><ng-content></ng-content></div>\n    "
                },] },
    ];
    /** @nocollapse */
    PopoverContainerComponent.ctorParameters = function () { return [
        { type: popover_config_PopoverConfig, },
    ]; };
    PopoverContainerComponent.propDecorators = {
        'placement': [{ type: core_es5["Input"] },],
        'title': [{ type: core_es5["Input"] },],
    };
    return PopoverContainerComponent;
}());

//# sourceMappingURL=popover-container.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/popover/popover.directive.js




/**
 * A lightweight, extensible directive for fancy popover creation.
 */
var popover_directive_PopoverDirective = (function () {
    function PopoverDirective(_elementRef, _renderer, _viewContainerRef, _config, cis) {
        /**
         * Close popover on outside click
         */
        this.outsideClick = false;
        /**
         * Css class for popover container
         */
        this.containerClass = '';
        this._isInited = false;
        this._popover = cis
            .createLoader(_elementRef, _viewContainerRef, _renderer)
            .provide({ provide: popover_config_PopoverConfig, useValue: _config });
        Object.assign(this, _config);
        this.onShown = this._popover.onShown;
        this.onHidden = this._popover.onHidden;
        // fix: no focus on button on Mac OS #1795
        _elementRef.nativeElement.addEventListener('click', function () {
            try {
                _elementRef.nativeElement.focus();
            }
            catch (err) {
                return;
            }
        });
    }
    Object.defineProperty(PopoverDirective.prototype, "isOpen", {
        /**
         * Returns whether or not the popover is currently being shown
         */
        get: function () { return this._popover.isShown; },
        set: function (value) {
            if (value) {
                this.show();
            }
            else {
                this.hide();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Opens an element’s popover. This is considered a “manual” triggering of
     * the popover.
     */
    PopoverDirective.prototype.show = function () {
        if (this._popover.isShown) {
            return;
        }
        this._popover
            .attach(popover_container_component_PopoverContainerComponent)
            .to(this.container)
            .position({ attachment: this.placement })
            .show({
            content: this.popover,
            context: this.popoverContext,
            placement: this.placement,
            title: this.popoverTitle,
            containerClass: this.containerClass
        });
        this.isOpen = true;
    };
    /**
     * Closes an element’s popover. This is considered a “manual” triggering of
     * the popover.
     */
    PopoverDirective.prototype.hide = function () {
        if (this.isOpen) {
            this._popover.hide();
            this.isOpen = false;
        }
    };
    /**
     * Toggles an element’s popover. This is considered a “manual” triggering of
     * the popover.
     */
    PopoverDirective.prototype.toggle = function () {
        if (this.isOpen) {
            return this.hide();
        }
        this.show();
    };
    PopoverDirective.prototype.ngOnInit = function () {
        var _this = this;
        // fix: seems there are an issue with `routerLinkActive`
        // which result in duplicated call ngOnInit without call to ngOnDestroy
        // read more: https://github.com/valor-software/ngx-bootstrap/issues/1885
        if (this._isInited) {
            return;
        }
        this._isInited = true;
        this._popover.listen({
            triggers: this.triggers,
            outsideClick: this.outsideClick,
            show: function () { return _this.show(); }
        });
    };
    PopoverDirective.prototype.ngOnDestroy = function () {
        this._popover.dispose();
    };
    PopoverDirective.decorators = [
        { type: core_es5["Directive"], args: [{ selector: '[popover]', exportAs: 'bs-popover' },] },
    ];
    /** @nocollapse */
    PopoverDirective.ctorParameters = function () { return [
        { type: core_es5["ElementRef"], },
        { type: core_es5["Renderer"], },
        { type: core_es5["ViewContainerRef"], },
        { type: popover_config_PopoverConfig, },
        { type: component_loader["a" /* ComponentLoaderFactory */], },
    ]; };
    PopoverDirective.propDecorators = {
        'popover': [{ type: core_es5["Input"] },],
        'popoverContext': [{ type: core_es5["Input"] },],
        'popoverTitle': [{ type: core_es5["Input"] },],
        'placement': [{ type: core_es5["Input"] },],
        'outsideClick': [{ type: core_es5["Input"] },],
        'triggers': [{ type: core_es5["Input"] },],
        'container': [{ type: core_es5["Input"] },],
        'containerClass': [{ type: core_es5["Input"] },],
        'isOpen': [{ type: core_es5["Input"] },],
        'onShown': [{ type: core_es5["Output"] },],
        'onHidden': [{ type: core_es5["Output"] },],
    };
    return PopoverDirective;
}());

//# sourceMappingURL=popover.directive.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/popover/popover.module.js







var popover_module_PopoverModule = (function () {
    function PopoverModule() {
    }
    PopoverModule.forRoot = function () {
        return {
            ngModule: PopoverModule,
            providers: [popover_config_PopoverConfig, component_loader["a" /* ComponentLoaderFactory */], positioning["a" /* PositioningService */]]
        };
    };
    PopoverModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    imports: [common_es5["CommonModule"]],
                    declarations: [popover_directive_PopoverDirective, popover_container_component_PopoverContainerComponent],
                    exports: [popover_directive_PopoverDirective],
                    entryComponents: [popover_container_component_PopoverContainerComponent]
                },] },
    ];
    /** @nocollapse */
    PopoverModule.ctorParameters = function () { return []; };
    return PopoverModule;
}());

//# sourceMappingURL=popover.module.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/accordion/index.js




//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/alert/index.js



//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/buttons/index.js



//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/carousel/index.js




//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/collapse/index.js
var collapse = __webpack_require__("vEim");

// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/reducer/bs-datepicker.actions.js

var bs_datepicker_actions_BsDatepickerActions = (function () {
    function BsDatepickerActions() {
    }
    BsDatepickerActions.prototype.calculate = function () { return { type: BsDatepickerActions.CALCULATE }; };
    BsDatepickerActions.prototype.format = function () { return { type: BsDatepickerActions.FORMAT }; };
    BsDatepickerActions.prototype.flag = function () { return { type: BsDatepickerActions.FLAG }; };
    BsDatepickerActions.prototype.select = function (date) {
        return {
            type: BsDatepickerActions.SELECT,
            payload: date
        };
    };
    BsDatepickerActions.prototype.changeViewMode = function (event) {
        return {
            type: BsDatepickerActions.CHANGE_VIEWMODE,
            payload: event
        };
    };
    BsDatepickerActions.prototype.navigateTo = function (event) {
        return {
            type: BsDatepickerActions.NAVIGATE_TO,
            payload: event
        };
    };
    BsDatepickerActions.prototype.navigateStep = function (step) {
        return {
            type: BsDatepickerActions.NAVIGATE_OFFSET,
            payload: step
        };
    };
    BsDatepickerActions.prototype.setOptions = function (options) {
        return {
            type: BsDatepickerActions.SET_OPTIONS,
            payload: options
        };
    };
    // date range picker
    BsDatepickerActions.prototype.selectRange = function (value) {
        return {
            type: BsDatepickerActions.SELECT_RANGE,
            payload: value
        };
    };
    BsDatepickerActions.prototype.hoverDay = function (event) {
        return {
            type: BsDatepickerActions.HOVER,
            payload: event.isHovered ? event.cell.date : null
        };
    };
    BsDatepickerActions.prototype.minDate = function (date) {
        return {
            type: BsDatepickerActions.SET_MIN_DATE,
            payload: date
        };
    };
    BsDatepickerActions.prototype.maxDate = function (date) {
        return {
            type: BsDatepickerActions.SET_MAX_DATE,
            payload: date
        };
    };
    BsDatepickerActions.prototype.isDisabled = function (value) {
        return {
            type: BsDatepickerActions.SET_IS_DISABLED,
            payload: value
        };
    };
    BsDatepickerActions.CALCULATE = '[datepicker] calculate dates matrix';
    BsDatepickerActions.FORMAT = '[datepicker] format datepicker values';
    BsDatepickerActions.FLAG = '[datepicker] set flags';
    BsDatepickerActions.SELECT = '[datepicker] select date';
    BsDatepickerActions.NAVIGATE_OFFSET = '[datepicker] shift view date';
    BsDatepickerActions.NAVIGATE_TO = '[datepicker] change view date';
    BsDatepickerActions.SET_OPTIONS = '[datepicker] update render options';
    BsDatepickerActions.HOVER = '[datepicker] hover date';
    BsDatepickerActions.CHANGE_VIEWMODE = '[datepicker] switch view mode';
    BsDatepickerActions.SET_MIN_DATE = '[datepicker] set min date';
    BsDatepickerActions.SET_MAX_DATE = '[datepicker] set max date';
    BsDatepickerActions.SET_IS_DISABLED = '[datepicker] set is disabled';
    BsDatepickerActions.SELECT_RANGE = '[daterangepicker] select dates range';
    BsDatepickerActions.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    BsDatepickerActions.ctorParameters = function () { return []; };
    return BsDatepickerActions;
}());

//# sourceMappingURL=bs-datepicker.actions.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/reducer/_defaults.js
var defaultMonthOptions = {
    width: 7,
    height: 6
};
//# sourceMappingURL=_defaults.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/bs-datepicker.config.js

var bs_datepicker_config_BsDatepickerConfig = (function () {
    function BsDatepickerConfig() {
        /** CSS class which will be applied to datepicker container,
         * usually used to set color theme
         */
        this.containerClass = 'theme-green';
        // DatepickerRenderOptions
        this.displayMonths = 1;
        /**
         * Allows to hide week numbers in datepicker
         */
        this.showWeekNumbers = true;
        this.dateInputFormat = 'L';
        // range picker
        this.rangeSeparator = ' - ';
        this.rangeInputFormat = 'L';
        // DatepickerFormatOptions
        /**
         * Allows to globally set default locale of datepicker,
         * see documentation on how to enable custom locales
         */
        this.locale = 'en';
        this.monthTitle = 'MMMM';
        this.yearTitle = 'YYYY';
        this.dayLabel = 'D';
        this.monthLabel = 'MMMM';
        this.yearLabel = 'YYYY';
        this.weekNumbers = 'w';
    }
    BsDatepickerConfig.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    BsDatepickerConfig.ctorParameters = function () { return []; };
    return BsDatepickerConfig;
}());

//# sourceMappingURL=bs-datepicker.config.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/reducer/bs-datepicker.state.js


var BsDatepickerState = (function () {
    function BsDatepickerState() {
    }
    return BsDatepickerState;
}());

var initialDatepickerState = Object.assign(new bs_datepicker_config_BsDatepickerConfig(), {
    view: { date: new Date(), mode: 'day' },
    selectedRange: [],
    monthViewOptions: defaultMonthOptions
});
//# sourceMappingURL=bs-datepicker.state.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/utils/date-compare.js

function isAfter(date1, date2, units) {
    if (units === void 0) { units = 'milliseconds'; }
    if (!date1 || !date2) {
        return false;
    }
    if (units === 'milliseconds') {
        return date1.valueOf() > date2.valueOf();
    }
    return date2.valueOf() < startOf(date1, units).valueOf();
}
function isBefore(date1, date2, units) {
    if (units === void 0) { units = 'milliseconds'; }
    if (!date1 || !date2) {
        return false;
    }
    if (units === 'milliseconds') {
        return date1.valueOf() < date2.valueOf();
    }
    return endOf(date1, units).valueOf() < date2.valueOf();
}
function isBetween(date, from, to, units, inclusivity) {
    if (inclusivity === void 0) { inclusivity = '()'; }
    var leftBound = inclusivity[0] === '('
        ? isAfter(date, from, units) :
        !isBefore(date, from, units);
    var rightBound = inclusivity[1] === ')'
        ? isBefore(date, to, units)
        : !isAfter(date, to, units);
    return leftBound && rightBound;
}
function isSame(date1, date2, units) {
    if (units === void 0) { units = 'milliseconds'; }
    if (!date1 || !date2) {
        return false;
    }
    if (units === 'milliseconds') {
        return date1.valueOf() === date2.valueOf();
    }
    var inputMs = date2.valueOf();
    return startOf(date1, units).valueOf() <= inputMs
        && inputMs <= endOf(date1, units).valueOf();
}
function isSameOrAfter(date1, date2, units) {
    return isSame(date1, date2, units) || isAfter(date1, date2, units);
}
function isSameOrBefore(date1, date2, units) {
    return isSame(date1, date2, units) || isBefore(date1, date2, units);
}
//# sourceMappingURL=date-compare.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/utils/bs-calendar-utils.js




function getStartingDayOfCalendar(date, options) {
    if (isFirstDayOfWeek(date, options.firstDayOfWeek)) {
        return date;
    }
    var weekDay = getDayOfWeek(date);
    return shiftDate(date, { day: -weekDay });
}
function isMonthDisabled(date, min, max) {
    var minBound = min && isSameOrBefore(endOf(date, 'month'), min, 'day');
    var maxBound = max && isSameOrAfter(startOf(date, 'month'), max, 'day');
    return minBound || maxBound;
}
function isYearDisabled(date, min, max) {
    var minBound = min && isSameOrBefore(endOf(date, 'year'), min, 'day');
    var maxBound = max && isSameOrAfter(startOf(date, 'year'), max, 'day');
    return minBound || maxBound;
}
//# sourceMappingURL=bs-calendar-utils.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/utils/matrix-utils.js

function createMatrix(options, fn) {
    var prevValue = options.initialDate;
    var matrix = new Array(options.height);
    for (var i = 0; i < options.height; i++) {
        matrix[i] = new Array(options.width);
        for (var j = 0; j < options.width; j++) {
            matrix[i][j] = fn(prevValue);
            prevValue = shiftDate(prevValue, options.shift);
        }
    }
    return matrix;
}
//# sourceMappingURL=matrix-utils.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/engine/calc-days-calendar.js



function calcDaysCalendar(startingDate, options) {
    var firstDay = getFirstDayOfMonth(startingDate);
    var initialDate = getStartingDayOfCalendar(firstDay, options);
    var matrixOptions = {
        width: options.width,
        height: options.height,
        initialDate: initialDate, shift: { day: 1 }
    };
    var daysMatrix = createMatrix(matrixOptions, function (date) { return date; });
    return {
        daysMatrix: daysMatrix,
        month: firstDay
    };
}
//# sourceMappingURL=calc-days-calendar.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/engine/format-days-calendar.js


function formatDaysCalendar(daysCalendar, formatOptions, monthIndex) {
    return {
        month: daysCalendar.month,
        monthTitle: formatDate(daysCalendar.month, formatOptions.monthTitle, formatOptions.locale),
        yearTitle: formatDate(daysCalendar.month, formatOptions.yearTitle, formatOptions.locale),
        weekNumbers: getWeekNumbers(daysCalendar.daysMatrix, formatOptions.weekNumbers, formatOptions.locale),
        weekdays: getLocale(formatOptions.locale).weekdaysShort(),
        weeks: daysCalendar.daysMatrix
            .map(function (week, weekIndex) { return ({
            days: week.map(function (date, dayIndex) { return ({
                date: date,
                label: formatDate(date, formatOptions.dayLabel, formatOptions.locale),
                monthIndex: monthIndex, weekIndex: weekIndex, dayIndex: dayIndex
            }); })
        }); })
    };
}
function getWeekNumbers(daysMatrix, format, locale) {
    return daysMatrix.map(function (days) { return days[0]
        ? formatDate(days[0], format, locale)
        : ''; });
}
//# sourceMappingURL=format-days-calendar.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/engine/flag-days-calendar.js




function flagDaysCalendar(formattedMonth, options) {
    formattedMonth.weeks
        .forEach(function (week, weekIndex) {
        week.days.forEach(function (day, dayIndex) {
            // datepicker
            var isOtherMonth = !isSameMonth(day.date, formattedMonth.month);
            var isHovered = !isOtherMonth && isSameDay(day.date, options.hoveredDate);
            // date range picker
            var isSelectionStart = !isOtherMonth
                && options.selectedRange
                && isSameDay(day.date, options.selectedRange[0]);
            var isSelectionEnd = !isOtherMonth
                && options.selectedRange
                && isSameDay(day.date, options.selectedRange[1]);
            var isSelected = !isOtherMonth && isSameDay(day.date, options.selectedDate) ||
                isSelectionStart || isSelectionEnd;
            var isInRange = !isOtherMonth
                && options.selectedRange
                && isDateInRange(day.date, options.selectedRange, options.hoveredDate);
            var isDisabled = options.isDisabled
                || isBefore(day.date, options.minDate, 'day')
                || isAfter(day.date, options.maxDate, 'day');
            // decide update or not
            var newDay = Object.assign({}, day, {
                isOtherMonth: isOtherMonth,
                isHovered: isHovered,
                isSelected: isSelected,
                isSelectionStart: isSelectionStart,
                isSelectionEnd: isSelectionEnd,
                isInRange: isInRange,
                isDisabled: isDisabled
            });
            if (day.isOtherMonth !== newDay.isOtherMonth ||
                day.isHovered !== newDay.isHovered ||
                day.isSelected !== newDay.isSelected ||
                day.isSelectionStart !== newDay.isSelectionStart ||
                day.isSelectionEnd !== newDay.isSelectionEnd ||
                day.isDisabled !== newDay.isDisabled ||
                day.isInRange !== newDay.isInRange) {
                week.days[dayIndex] = newDay;
            }
        });
    });
    // todo: add check for linked calendars
    formattedMonth.hideLeftArrow = options.isDisabled
        || (options.monthIndex > 0
            && options.monthIndex !== options.displayMonths);
    formattedMonth.hideRightArrow = options.isDisabled
        || (options.monthIndex < options.displayMonths
            && (options.monthIndex + 1) !== options.displayMonths);
    formattedMonth.disableLeftArrow = isMonthDisabled(shiftDate(formattedMonth.month, { month: -1 }), options.minDate, options.maxDate);
    formattedMonth.disableRightArrow = isMonthDisabled(shiftDate(formattedMonth.month, { month: 1 }), options.minDate, options.maxDate);
    return formattedMonth;
}
function isDateInRange(date, selectedRange, hoveredDate) {
    if (!date || !selectedRange[0]) {
        return false;
    }
    if (selectedRange[1]) {
        return date > selectedRange[0] && date <= selectedRange[1];
    }
    if (hoveredDate) {
        return date > selectedRange[0] && date <= hoveredDate;
    }
    return false;
}
//# sourceMappingURL=flag-days-calendar.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/engine/view-mode.js
function canSwitchMode(mode) {
    return true;
}
//# sourceMappingURL=view-mode.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/engine/format-months-calendar.js



var height = 4;
var width = 3;
var format_months_calendar_shift = { month: 1 };
function formatMonthsCalendar(viewDate, formatOptions) {
    var initialDate = startOf(viewDate, 'year');
    var matrixOptions = { width: width, height: height, initialDate: initialDate, shift: format_months_calendar_shift };
    var monthMatrix = createMatrix(matrixOptions, function (date) { return ({
        date: date,
        label: formatDate(date, formatOptions.monthLabel, formatOptions.locale)
    }); });
    return {
        months: monthMatrix,
        monthTitle: '',
        yearTitle: formatDate(viewDate, formatOptions.yearTitle, formatOptions.locale)
    };
}
//# sourceMappingURL=format-months-calendar.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/engine/flag-months-calendar.js



function flagMonthsCalendar(monthCalendar, options) {
    monthCalendar.months
        .forEach(function (months, rowIndex) {
        months.forEach(function (month, monthIndex) {
            var isHovered = isSameMonth(month.date, options.hoveredMonth);
            var isDisabled = options.isDisabled
                || isMonthDisabled(month.date, options.minDate, options.maxDate);
            var newMonth = Object.assign(/*{},*/ month, { isHovered: isHovered, isDisabled: isDisabled });
            if (month.isHovered !== newMonth.isHovered
                || month.isDisabled !== newMonth.isDisabled) {
                monthCalendar.months[rowIndex][monthIndex] = newMonth;
            }
        });
    });
    // todo: add check for linked calendars
    monthCalendar.hideLeftArrow = options.monthIndex > 0
        && options.monthIndex !== options.displayMonths;
    monthCalendar.hideRightArrow = options.monthIndex < options.displayMonths
        && (options.monthIndex + 1) !== options.displayMonths;
    monthCalendar.disableLeftArrow = isYearDisabled(shiftDate(monthCalendar.months[0][0].date, { year: -1 }), options.minDate, options.maxDate);
    monthCalendar.disableRightArrow = isYearDisabled(shiftDate(monthCalendar.months[0][0].date, { year: 1 }), options.minDate, options.maxDate);
    return monthCalendar;
}
//# sourceMappingURL=flag-months-calendar.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/engine/format-years-calendar.js



var format_years_calendar_height = 4;
var format_years_calendar_width = 4;
var yearsPerCalendar = format_years_calendar_height * format_years_calendar_width;
var initialShift = (Math.floor(yearsPerCalendar / 2) - 1) * -1;
var format_years_calendar_shift = { year: 1 };
function formatYearsCalendar(viewDate, formatOptions) {
    var initialDate = shiftDate(viewDate, { year: initialShift });
    var matrixOptions = { width: format_years_calendar_width, height: format_years_calendar_height, initialDate: initialDate, shift: format_years_calendar_shift };
    var yearsMatrix = createMatrix(matrixOptions, function (date) { return ({
        date: date,
        label: formatDate(date, formatOptions.yearLabel, formatOptions.locale)
    }); });
    var yearTitle = formatYearRangeTitle(yearsMatrix, formatOptions);
    return {
        years: yearsMatrix,
        monthTitle: '',
        yearTitle: yearTitle
    };
}
function formatYearRangeTitle(yearsMatrix, formatOptions) {
    var from = formatDate(yearsMatrix[0][0].date, formatOptions.yearTitle, formatOptions.locale);
    var to = formatDate(yearsMatrix[format_years_calendar_height - 1][format_years_calendar_width - 1].date, formatOptions.yearTitle, formatOptions.locale);
    return from + " - " + to;
}
//# sourceMappingURL=format-years-calendar.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/engine/flag-years-calendar.js



function flagYearsCalendar(yearsCalendar, options) {
    yearsCalendar.years
        .forEach(function (years, rowIndex) {
        years.forEach(function (year, yearIndex) {
            var isHovered = isSameYear(year.date, options.hoveredYear);
            var isDisabled = options.isDisabled
                || isYearDisabled(year.date, options.minDate, options.maxDate);
            var newMonth = Object.assign(/*{},*/ year, { isHovered: isHovered, isDisabled: isDisabled });
            if (year.isHovered !== newMonth.isHovered
                || year.isDisabled !== newMonth.isDisabled) {
                yearsCalendar.years[rowIndex][yearIndex] = newMonth;
            }
        });
    });
    // todo: add check for linked calendars
    yearsCalendar.hideLeftArrow = options.yearIndex > 0
        && options.yearIndex !== options.displayMonths;
    yearsCalendar.hideRightArrow = options.yearIndex < options.displayMonths
        && (options.yearIndex + 1) !== options.displayMonths;
    yearsCalendar.disableLeftArrow = isYearDisabled(shiftDate(yearsCalendar.years[0][0].date, { year: -1 }), options.minDate, options.maxDate);
    var i = yearsCalendar.years.length - 1;
    var j = yearsCalendar.years[i].length - 1;
    yearsCalendar.disableRightArrow = isYearDisabled(shiftDate(yearsCalendar.years[i][j].date, { year: 1 }), options.minDate, options.maxDate);
    return yearsCalendar;
}
//# sourceMappingURL=flag-years-calendar.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/reducer/bs-datepicker.reducer.js













function bsDatepickerReducer(state, action) {
    if (state === void 0) { state = initialDatepickerState; }
    switch (action.type) {
        case (bs_datepicker_actions_BsDatepickerActions.CALCULATE): {
            return calculateReducer(state);
        }
        case (bs_datepicker_actions_BsDatepickerActions.FORMAT): {
            return formatReducer(state, action);
        }
        case (bs_datepicker_actions_BsDatepickerActions.FLAG): {
            return flagReducer(state, action);
        }
        case (bs_datepicker_actions_BsDatepickerActions.NAVIGATE_OFFSET): {
            var date = shiftDate(startOf(state.view.date, 'month'), action.payload);
            var newState = {
                view: {
                    mode: state.view.mode,
                    date: date
                }
            };
            return Object.assign({}, state, newState);
        }
        case (bs_datepicker_actions_BsDatepickerActions.NAVIGATE_TO): {
            var payload = action.payload;
            var date = setDate(state.view.date, payload.unit);
            var mode = payload.viewMode;
            var newState = { view: { date: date, mode: mode } };
            return Object.assign({}, state, newState);
        }
        case (bs_datepicker_actions_BsDatepickerActions.CHANGE_VIEWMODE): {
            if (!canSwitchMode(action.payload)) {
                return state;
            }
            var date = state.view.date;
            var mode = action.payload;
            var newState = { view: { date: date, mode: mode } };
            return Object.assign({}, state, newState);
        }
        case (bs_datepicker_actions_BsDatepickerActions.HOVER): {
            return Object.assign({}, state, { hoveredDate: action.payload });
        }
        case (bs_datepicker_actions_BsDatepickerActions.SELECT): {
            var newState = {
                selectedDate: action.payload,
                view: state.view
            };
            if (action.payload) {
                newState.view = {
                    date: action.payload,
                    mode: state.view.mode
                };
            }
            return Object.assign({}, state, newState);
        }
        case (bs_datepicker_actions_BsDatepickerActions.SET_OPTIONS): {
            var newState = action.payload;
            // looks not really good
            if (newState.value) {
                newState.view = state.view;
                if (isArray(newState.value)) {
                    newState.view = {
                        mode: state.view.mode,
                        date: newState.value[0]
                    };
                    newState.selectedRange = newState.value;
                }
                else {
                    newState.view = {
                        mode: state.view.mode,
                        date: newState.value
                    };
                    newState.selectedDate = newState.value;
                }
            }
            return Object.assign({}, state, newState);
        }
        // date range picker
        case (bs_datepicker_actions_BsDatepickerActions.SELECT_RANGE): {
            return Object.assign({}, state, { selectedRange: action.payload });
        }
        case (bs_datepicker_actions_BsDatepickerActions.SET_MIN_DATE): {
            return Object.assign({}, state, {
                minDate: action.payload
            });
        }
        case (bs_datepicker_actions_BsDatepickerActions.SET_MAX_DATE): {
            return Object.assign({}, state, {
                maxDate: action.payload
            });
        }
        case (bs_datepicker_actions_BsDatepickerActions.SET_IS_DISABLED): {
            return Object.assign({}, state, {
                isDisabled: action.payload
            });
        }
        default:
            return state;
    }
}
function calculateReducer(state) {
    // how many calendars
    var displayMonths = state.displayMonths;
    // use selected date on initial rendering if set
    var viewDate = state.view.date;
    if (state.view.mode === 'day') {
        var monthsModel = new Array(displayMonths);
        for (var monthIndex = 0; monthIndex < displayMonths; monthIndex++) {
            // todo: for unlinked calendars it will be harder
            monthsModel[monthIndex] = calcDaysCalendar(viewDate, state.monthViewOptions);
            viewDate = shiftDate(viewDate, { month: 1 });
        }
        return Object.assign({}, state, { monthsModel: monthsModel });
    }
    if (state.view.mode === 'month') {
        var monthsCalendar = new Array(displayMonths);
        for (var calendarIndex = 0; calendarIndex < displayMonths; calendarIndex++) {
            // todo: for unlinked calendars it will be harder
            monthsCalendar[calendarIndex] = formatMonthsCalendar(viewDate, getFormatOptions(state));
            viewDate = shiftDate(viewDate, { year: 1 });
        }
        return Object.assign({}, state, { monthsCalendar: monthsCalendar });
    }
    if (state.view.mode === 'year') {
        var yearsCalendarModel = new Array(displayMonths);
        for (var calendarIndex = 0; calendarIndex < displayMonths; calendarIndex++) {
            // todo: for unlinked calendars it will be harder
            yearsCalendarModel[calendarIndex] = formatYearsCalendar(viewDate, getFormatOptions(state));
            viewDate = shiftDate(viewDate, { year: yearsPerCalendar });
        }
        return Object.assign({}, state, { yearsCalendarModel: yearsCalendarModel });
    }
    return state;
}
function formatReducer(state, action) {
    if (state.view.mode === 'day') {
        var formattedMonths = state.monthsModel
            .map(function (month, monthIndex) { return formatDaysCalendar(month, getFormatOptions(state), monthIndex); });
        return Object.assign({}, state, { formattedMonths: formattedMonths });
    }
    // how many calendars
    var displayMonths = state.displayMonths;
    // check initial rendering
    // use selected date on initial rendering if set
    var viewDate = state.view.date;
    if (state.view.mode === 'month') {
        var monthsCalendar = new Array(displayMonths);
        for (var calendarIndex = 0; calendarIndex < displayMonths; calendarIndex++) {
            // todo: for unlinked calendars it will be harder
            monthsCalendar[calendarIndex] = formatMonthsCalendar(viewDate, getFormatOptions(state));
            viewDate = shiftDate(viewDate, { year: 1 });
        }
        return Object.assign({}, state, { monthsCalendar: monthsCalendar });
    }
    if (state.view.mode === 'year') {
        var yearsCalendarModel = new Array(displayMonths);
        for (var calendarIndex = 0; calendarIndex < displayMonths; calendarIndex++) {
            // todo: for unlinked calendars it will be harder
            yearsCalendarModel[calendarIndex] = formatYearsCalendar(viewDate, getFormatOptions(state));
            viewDate = shiftDate(viewDate, { year: 16 });
        }
        return Object.assign({}, state, { yearsCalendarModel: yearsCalendarModel });
    }
    return state;
}
function flagReducer(state, action) {
    if (state.view.mode === 'day') {
        var flaggedMonths = state.formattedMonths
            .map(function (formattedMonth, monthIndex) { return flagDaysCalendar(formattedMonth, {
            isDisabled: state.isDisabled,
            minDate: state.minDate,
            maxDate: state.maxDate,
            hoveredDate: state.hoveredDate,
            selectedDate: state.selectedDate,
            selectedRange: state.selectedRange,
            displayMonths: state.displayMonths,
            monthIndex: monthIndex
        }); });
        return Object.assign({}, state, { flaggedMonths: flaggedMonths });
    }
    if (state.view.mode === 'month') {
        var flaggedMonthsCalendar = state.monthsCalendar
            .map(function (formattedMonth, monthIndex) { return flagMonthsCalendar(formattedMonth, {
            isDisabled: state.isDisabled,
            minDate: state.minDate,
            maxDate: state.maxDate,
            hoveredMonth: state.hoveredMonth,
            displayMonths: state.displayMonths,
            monthIndex: monthIndex
        }); });
        return Object.assign({}, state, { flaggedMonthsCalendar: flaggedMonthsCalendar });
    }
    if (state.view.mode === 'year') {
        var yearsCalendarFlagged = state.yearsCalendarModel
            .map(function (formattedMonth, yearIndex) { return flagYearsCalendar(formattedMonth, {
            isDisabled: state.isDisabled,
            minDate: state.minDate,
            maxDate: state.maxDate,
            hoveredYear: state.hoveredYear,
            displayMonths: state.displayMonths,
            yearIndex: yearIndex
        }); });
        return Object.assign({}, state, { yearsCalendarFlagged: yearsCalendarFlagged });
    }
    return state;
}
function getFormatOptions(state) {
    return {
        locale: state.locale,
        monthTitle: state.monthTitle,
        yearTitle: state.yearTitle,
        dayLabel: state.dayLabel,
        monthLabel: state.monthLabel,
        yearLabel: state.yearLabel,
        weekNumbers: state.weekNumbers
    };
}
//# sourceMappingURL=bs-datepicker.reducer.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/reducer/bs-datepicker.store.js
var bs_datepicker_store___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var bs_datepicker_store_BsDatepickerStore = (function (_super) {
    bs_datepicker_store___extends(BsDatepickerStore, _super);
    function BsDatepickerStore() {
        var _this = this;
        var _dispatcher = new BehaviorSubject["BehaviorSubject"]({ type: '[datepicker] dispatcher init' });
        var state = new state_class_MiniState(initialDatepickerState, _dispatcher, bsDatepickerReducer);
        _this = _super.call(this, _dispatcher, bsDatepickerReducer, state) || this;
        return _this;
    }
    BsDatepickerStore.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    BsDatepickerStore.ctorParameters = function () { return []; };
    return BsDatepickerStore;
}(store_class_MiniStore));

//# sourceMappingURL=bs-datepicker.store.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/base/bs-datepicker-container.js
var BsDatepickerAbstractComponent = (function () {
    function BsDatepickerAbstractComponent() {
        this._customRangesFish = [];
    }
    Object.defineProperty(BsDatepickerAbstractComponent.prototype, "minDate", {
        set: function (value) {
            this._effects.setMinDate(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BsDatepickerAbstractComponent.prototype, "maxDate", {
        set: function (value) {
            this._effects.setMaxDate(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BsDatepickerAbstractComponent.prototype, "isDisabled", {
        set: function (value) {
            this._effects.setDisabled(value);
        },
        enumerable: true,
        configurable: true
    });
    BsDatepickerAbstractComponent.prototype.setViewMode = function (event) { };
    BsDatepickerAbstractComponent.prototype.navigateTo = function (event) { };
    BsDatepickerAbstractComponent.prototype.dayHoverHandler = function (event) { };
    BsDatepickerAbstractComponent.prototype.monthHoverHandler = function (event) { };
    BsDatepickerAbstractComponent.prototype.yearHoverHandler = function (event) { };
    BsDatepickerAbstractComponent.prototype.daySelectHandler = function (day) { };
    ;
    BsDatepickerAbstractComponent.prototype.monthSelectHandler = function (event) { };
    BsDatepickerAbstractComponent.prototype.yearSelectHandler = function (event) { };
    BsDatepickerAbstractComponent.prototype._stopPropagation = function (event) {
        event.stopPropagation();
    };
    return BsDatepickerAbstractComponent;
}());

//# sourceMappingURL=bs-datepicker-container.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/reducer/bs-datepicker.effects.js





var bs_datepicker_effects_BsDatepickerEffects = (function () {
    function BsDatepickerEffects(_actions) {
        this._actions = _actions;
        this._subs = [];
    }
    BsDatepickerEffects.prototype.init = function (_bsDatepickerStore) {
        this._store = _bsDatepickerStore;
        return this;
    };
    /** setters */
    BsDatepickerEffects.prototype.setValue = function (value) {
        this._store.dispatch(this._actions.select(value));
    };
    BsDatepickerEffects.prototype.setRangeValue = function (value) {
        this._store.dispatch(this._actions.selectRange(value));
    };
    BsDatepickerEffects.prototype.setMinDate = function (value) {
        this._store.dispatch(this._actions.minDate(value));
        return this;
    };
    BsDatepickerEffects.prototype.setMaxDate = function (value) {
        this._store.dispatch(this._actions.maxDate(value));
        return this;
    };
    BsDatepickerEffects.prototype.setDisabled = function (value) {
        this._store.dispatch(this._actions.isDisabled(value));
        return this;
    };
    /* Set rendering options */
    BsDatepickerEffects.prototype.setOptions = function (_config) {
        this._store.dispatch(this._actions.setOptions(_config));
        return this;
    };
    /** view to mode bindings */
    BsDatepickerEffects.prototype.setBindings = function (container) {
        container.daysCalendar = this._store
            .select(function (state) { return state.flaggedMonths; })
            .filter(function (months) { return !!months; });
        // month calendar
        container.monthsCalendar = this._store
            .select(function (state) { return state.flaggedMonthsCalendar; })
            .filter(function (months) { return !!months; });
        // year calendar
        container.yearsCalendar = this._store
            .select(function (state) { return state.yearsCalendarFlagged; })
            .filter(function (years) { return !!years; });
        container.viewMode = this._store
            .select(function (state) { return state.view.mode; });
        container.options = this._store.select(function (state) { return state.showWeekNumbers; })
            .map(function (showWeekNumbers) { return ({ showWeekNumbers: showWeekNumbers }); });
        return this;
    };
    /** event handlers*/
    BsDatepickerEffects.prototype.setEventHandlers = function (container) {
        var _this = this;
        container.setViewMode = function (event) {
            _this._store.dispatch(_this._actions.changeViewMode(event));
        };
        container.navigateTo = function (event) {
            _this._store.dispatch(_this._actions.navigateStep(event.step));
        };
        container.dayHoverHandler = function (event) {
            var _cell = event.cell;
            if (_cell.isOtherMonth || _cell.isDisabled) {
                return;
            }
            _this._store.dispatch(_this._actions.hoverDay(event));
            _cell.isHovered = event.isHovered;
        };
        container.monthHoverHandler = function (event) {
            event.cell.isHovered = event.isHovered;
        };
        container.yearHoverHandler = function (event) {
            event.cell.isHovered = event.isHovered;
        };
        /** select handlers */
        // container.daySelectHandler = (day: DayViewModel): void => {
        //   if (day.isOtherMonth || day.isDisabled) {
        //     return;
        //   }
        //   this._store.dispatch(this._actions.select(day.date));
        // };
        container.monthSelectHandler = function (event) {
            if (event.isDisabled) {
                return;
            }
            _this._store.dispatch(_this._actions.navigateTo({
                unit: { month: getMonth(event.date) },
                viewMode: 'day'
            }));
        };
        container.yearSelectHandler = function (event) {
            if (event.isDisabled) {
                return;
            }
            _this._store.dispatch(_this._actions.navigateTo({
                unit: { year: getFullYear(event.date) },
                viewMode: 'month'
            }));
        };
        return this;
    };
    BsDatepickerEffects.prototype.registerDatepickerSideEffects = function () {
        var _this = this;
        this._subs.push(this._store.select(function (state) { return state.view; })
            .subscribe(function (view) {
            _this._store.dispatch(_this._actions.calculate());
        }));
        // format calendar values on month model change
        this._subs.push(this._store
            .select(function (state) { return state.monthsModel; })
            .filter(function (monthModel) { return !!monthModel; })
            .subscribe(function (month) {
            return _this._store.dispatch(_this._actions.format());
        }));
        // flag day values
        this._subs.push(this._store
            .select(function (state) { return state.formattedMonths; })
            .filter(function (month) { return !!month; })
            .subscribe(function (month) {
            return _this._store.dispatch(_this._actions.flag());
        }));
        // flag day values
        this._subs.push(this._store.select(function (state) { return state.selectedDate; })
            .filter(function (selectedDate) { return !!selectedDate; })
            .subscribe(function (selectedDate) {
            return _this._store.dispatch(_this._actions.flag());
        }));
        // flag for date range picker
        this._subs.push(this._store.select(function (state) { return state.selectedRange; })
            .filter(function (selectedRange) { return !!selectedRange; })
            .subscribe(function (selectedRange) {
            return _this._store.dispatch(_this._actions.flag());
        }));
        // monthsCalendar
        this._subs.push(this._store
            .select(function (state) { return state.monthsCalendar; })
            .subscribe(function () { return _this._store.dispatch(_this._actions.flag()); }));
        // years calendar
        this._subs.push(this._store
            .select(function (state) { return state.yearsCalendarModel; })
            .filter(function (state) { return !!state; })
            .subscribe(function () { return _this._store.dispatch(_this._actions.flag()); }));
        // on hover
        this._subs.push(this._store.select(function (state) { return state.hoveredDate; })
            .filter(function (hoveredDate) { return !!hoveredDate; })
            .subscribe(function (hoveredDate) {
            return _this._store.dispatch(_this._actions.flag());
        }));
        return this;
    };
    BsDatepickerEffects.prototype.destroy = function () {
        for (var _i = 0, _a = this._subs; _i < _a.length; _i++) {
            var sub = _a[_i];
            sub.unsubscribe();
        }
    };
    BsDatepickerEffects.decorators = [
        { type: core_es5["Injectable"] },
    ];
    /** @nocollapse */
    BsDatepickerEffects.ctorParameters = function () { return [
        { type: bs_datepicker_actions_BsDatepickerActions, },
    ]; };
    return BsDatepickerEffects;
}());

//# sourceMappingURL=bs-datepicker.effects.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/themes/bs/bs-datepicker-container.component.js
var bs_datepicker_container_component___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var bs_datepicker_container_component_BsDatepickerContainerComponent = (function (_super) {
    bs_datepicker_container_component___extends(BsDatepickerContainerComponent, _super);
    function BsDatepickerContainerComponent(_config, _store, _actions, _effects) {
        var _this = _super.call(this) || this;
        _this._config = _config;
        _this._store = _store;
        _this._actions = _actions;
        _this.valueChange = new core_es5["EventEmitter"]();
        _this._subs = [];
        _this._effects = _effects;
        return _this;
    }
    Object.defineProperty(BsDatepickerContainerComponent.prototype, "value", {
        set: function (value) {
            this._effects.setValue(value);
        },
        enumerable: true,
        configurable: true
    });
    BsDatepickerContainerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.containerClass = this._config.containerClass;
        this._effects
            .init(this._store)
            .setOptions(this._config)
            .setBindings(this)
            .setEventHandlers(this)
            .registerDatepickerSideEffects();
        // todo: move it somewhere else
        // on selected date change
        this._subs.push(this._store
            .select(function (state) { return state.selectedDate; })
            .subscribe(function (date) { return _this.valueChange.emit(date); }));
    };
    BsDatepickerContainerComponent.prototype.daySelectHandler = function (day) {
        if (day.isOtherMonth || day.isDisabled) {
            return;
        }
        this._store.dispatch(this._actions.select(day.date));
    };
    BsDatepickerContainerComponent.prototype.ngOnDestroy = function () {
        for (var _i = 0, _a = this._subs; _i < _a.length; _i++) {
            var sub = _a[_i];
            sub.unsubscribe();
        }
        this._effects.destroy();
    };
    BsDatepickerContainerComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'bs-datepicker-container',
                    providers: [bs_datepicker_store_BsDatepickerStore, bs_datepicker_effects_BsDatepickerEffects],
                    template: "<!-- days calendar view mode --> <div class=\"bs-datepicker\" [ngClass]=\"containerClass\" *ngIf=\"viewMode | async\"> <div class=\"bs-datepicker-container\"> <!--calendars--> <div class=\"bs-calendar-container\" [ngSwitch]=\"viewMode | async\"> <!--days calendar--> <div *ngSwitchCase=\"'day'\"> <bs-days-calendar-view *ngFor=\"let calendar of (daysCalendar | async)\" [class.bs-datepicker-multiple]=\"(daysCalendar | async).length > 1\" [calendar]=\"calendar\" [options]=\"options | async\" (onNavigate)=\"navigateTo($event)\" (onViewMode)=\"setViewMode($event)\" (onHover)=\"dayHoverHandler($event)\" (onSelect)=\"daySelectHandler($event)\" ></bs-days-calendar-view> </div> <!--months calendar--> <div *ngSwitchCase=\"'month'\"> <bs-month-calendar-view *ngFor=\"let calendar of (monthsCalendar | async)\" [class.bs-datepicker-multiple]=\"(daysCalendar | async).length > 1\" [calendar]=\"calendar\" (onNavigate)=\"navigateTo($event)\" (onViewMode)=\"setViewMode($event)\" (onHover)=\"monthHoverHandler($event)\" (onSelect)=\"monthSelectHandler($event)\" ></bs-month-calendar-view> </div> <!--years calendar--> <div *ngSwitchCase=\"'year'\"> <bs-years-calendar-view *ngFor=\"let calendar of (yearsCalendar | async)\" [class.bs-datepicker-multiple]=\"(daysCalendar | async).length > 1\" [calendar]=\"calendar\" (onNavigate)=\"navigateTo($event)\" (onViewMode)=\"setViewMode($event)\" (onHover)=\"yearHoverHandler($event)\" (onSelect)=\"yearSelectHandler($event)\" ></bs-years-calendar-view> </div> </div> <!--applycancel buttons--> <div class=\"bs-datepicker-buttons\" *ngIf=\"false\"> <button class=\"btn btn-success\">Apply</button> <button class=\"btn btn-default\">Cancel</button> </div> </div> <!--custom dates or date ranges picker--> <div class=\"bs-datepicker-custom-range\" *ngIf=\"false\"> <bs-custom-date-view [ranges]=\"_customRangesFish\"></bs-custom-date-view> </div> </div> ",
                    host: {
                        '(click)': '_stopPropagation($event)',
                        style: 'position: absolute; display: block;'
                    }
                },] },
    ];
    /** @nocollapse */
    BsDatepickerContainerComponent.ctorParameters = function () { return [
        { type: bs_datepicker_config_BsDatepickerConfig, },
        { type: bs_datepicker_store_BsDatepickerStore, },
        { type: bs_datepicker_actions_BsDatepickerActions, },
        { type: bs_datepicker_effects_BsDatepickerEffects, },
    ]; };
    return BsDatepickerContainerComponent;
}(BsDatepickerAbstractComponent));

//# sourceMappingURL=bs-datepicker-container.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/models/index.js
/** *************** */
// events
/** *************** */
var BsNavigationDirection;
(function (BsNavigationDirection) {
    BsNavigationDirection[BsNavigationDirection["UP"] = 0] = "UP";
    BsNavigationDirection[BsNavigationDirection["DOWN"] = 1] = "DOWN";
})(BsNavigationDirection || (BsNavigationDirection = {}));
//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/themes/bs/bs-datepicker-navigation-view.component.js


var bs_datepicker_navigation_view_component_BsDatepickerNavigationViewComponent = (function () {
    function BsDatepickerNavigationViewComponent() {
        this.onNavigate = new core_es5["EventEmitter"]();
        this.onViewMode = new core_es5["EventEmitter"]();
    }
    BsDatepickerNavigationViewComponent.prototype.navTo = function (down) {
        this.onNavigate.emit(down
            ? BsNavigationDirection.DOWN
            : BsNavigationDirection.UP);
    };
    BsDatepickerNavigationViewComponent.prototype.view = function (viewMode) {
        this.onViewMode.emit(viewMode);
    };
    BsDatepickerNavigationViewComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'bs-datepicker-navigation-view',
                    changeDetection: core_es5["ChangeDetectionStrategy"].OnPush,
                    template: "\n    <button class=\"previous\"\n            [disabled]=\"calendar.disableLeftArrow\"\n            [style.visibility]=\"calendar.hideLeftArrow ? 'hidden' : 'visible'\"\n            (click)=\"navTo(true)\"><span>&lsaquo;</span>\n    </button>\n\n    <button class=\"current\"\n            *ngIf=\"calendar.monthTitle\"\n            (click)=\"view('month')\"\n    ><span>{{ calendar.monthTitle }}</span>\n    </button>\n\n    <button class=\"current\" (click)=\"view('year')\"\n    ><span>{{ calendar.yearTitle }}</span></button>\n\n    <button class=\"next\"\n            [disabled]=\"calendar.disableRightArrow\"\n            [style.visibility]=\"calendar.hideRightArrow ? 'hidden' : 'visible'\"\n            (click)=\"navTo(false)\"><span>&rsaquo;</span>\n    </button>\n  "
                },] },
    ];
    /** @nocollapse */
    BsDatepickerNavigationViewComponent.ctorParameters = function () { return []; };
    BsDatepickerNavigationViewComponent.propDecorators = {
        'calendar': [{ type: core_es5["Input"] },],
        'onNavigate': [{ type: core_es5["Output"] },],
        'onViewMode': [{ type: core_es5["Output"] },],
    };
    return BsDatepickerNavigationViewComponent;
}());

//# sourceMappingURL=bs-datepicker-navigation-view.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/themes/bs/bs-days-calendar-view.component.js


var bs_days_calendar_view_component_BsDaysCalendarViewComponent = (function () {
    function BsDaysCalendarViewComponent() {
        this.onNavigate = new core_es5["EventEmitter"]();
        this.onViewMode = new core_es5["EventEmitter"]();
        this.onSelect = new core_es5["EventEmitter"]();
        this.onHover = new core_es5["EventEmitter"]();
    }
    BsDaysCalendarViewComponent.prototype.navigateTo = function (event) {
        var step = BsNavigationDirection.DOWN === event ? -1 : 1;
        this.onNavigate.emit({ step: { month: step } });
    };
    BsDaysCalendarViewComponent.prototype.changeViewMode = function (event) {
        this.onViewMode.emit(event);
    };
    BsDaysCalendarViewComponent.prototype.selectDay = function (event) {
        this.onSelect.emit(event);
    };
    BsDaysCalendarViewComponent.prototype.hoverDay = function (cell, isHovered) {
        this.onHover.emit({ cell: cell, isHovered: isHovered });
    };
    BsDaysCalendarViewComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'bs-days-calendar-view',
                    // changeDetection: ChangeDetectionStrategy.OnPush,
                    template: "\n    <bs-calendar-layout>\n      <bs-datepicker-navigation-view\n        [calendar]=\"calendar\"\n        (onNavigate)=\"navigateTo($event)\"\n        (onViewMode)=\"changeViewMode($event)\"\n      ></bs-datepicker-navigation-view>\n\n      <!--days matrix-->\n      <table role=\"grid\" class=\"days weeks\">\n        <thead>\n        <tr>\n          <!--if show weeks-->\n          <th *ngIf=\"options.showWeekNumbers\"></th>\n          <th *ngFor=\"let weekday of calendar.weekdays; let i = index\"\n              aria-label=\"weekday\">{{ calendar.weekdays[i] }}\n          </th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr *ngFor=\"let week of calendar.weeks; let i = index\">\n          <td class=\"week\" *ngIf=\"options.showWeekNumbers\">\n            <span>{{ calendar.weekNumbers[i] }}</span>\n          </td>\n          <td *ngFor=\"let day of week.days\" role=\"gridcell\">\n          <span bsDatepickerDayDecorator\n                [day]=\"day\"\n                (click)=\"selectDay(day)\"\n                (mouseenter)=\"hoverDay(day, true)\"\n                (mouseleave)=\"hoverDay(day, false)\">{{ day.label }}</span>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n\n    </bs-calendar-layout>\n  "
                },] },
    ];
    /** @nocollapse */
    BsDaysCalendarViewComponent.ctorParameters = function () { return []; };
    BsDaysCalendarViewComponent.propDecorators = {
        'calendar': [{ type: core_es5["Input"] },],
        'options': [{ type: core_es5["Input"] },],
        'onNavigate': [{ type: core_es5["Output"] },],
        'onViewMode': [{ type: core_es5["Output"] },],
        'onSelect': [{ type: core_es5["Output"] },],
        'onHover': [{ type: core_es5["Output"] },],
    };
    return BsDaysCalendarViewComponent;
}());

//# sourceMappingURL=bs-days-calendar-view.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/themes/bs/bs-daterangepicker-container.component.js
var bs_daterangepicker_container_component___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var bs_daterangepicker_container_component_BsDaterangepickerContainerComponent = (function (_super) {
    bs_daterangepicker_container_component___extends(BsDaterangepickerContainerComponent, _super);
    function BsDaterangepickerContainerComponent(_config, _store, _actions, _effects) {
        var _this = _super.call(this) || this;
        _this._config = _config;
        _this._store = _store;
        _this._actions = _actions;
        _this.valueChange = new core_es5["EventEmitter"]();
        _this._rangeStack = [];
        _this._subs = [];
        _this._effects = _effects;
        return _this;
    }
    Object.defineProperty(BsDaterangepickerContainerComponent.prototype, "value", {
        set: function (value) {
            this._effects.setRangeValue(value);
        },
        enumerable: true,
        configurable: true
    });
    BsDaterangepickerContainerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.containerClass = this._config.containerClass;
        this._effects
            .init(this._store)
            .setOptions(this._config)
            .setBindings(this)
            .setEventHandlers(this)
            .registerDatepickerSideEffects();
        // todo: move it somewhere else
        // on selected date change
        this._subs.push(this._store
            .select(function (state) { return state.selectedRange; })
            .subscribe(function (date) { return _this.valueChange.emit(date); }));
    };
    BsDaterangepickerContainerComponent.prototype.daySelectHandler = function (day) {
        if (day.isOtherMonth || day.isDisabled) {
            return;
        }
        // if only one date is already selected
        // and user clicks on previous date
        // start selection from new date
        // but if new date is after initial one
        // than finish selection
        if (this._rangeStack.length === 1) {
            this._rangeStack = day.date >= this._rangeStack[0]
                ? [this._rangeStack[0], day.date]
                : [day.date];
        }
        if (this._rangeStack.length === 0) {
            this._rangeStack = [day.date];
        }
        this._store.dispatch(this._actions.selectRange(this._rangeStack));
        if (this._rangeStack.length === 2) {
            this._rangeStack = [];
        }
    };
    BsDaterangepickerContainerComponent.prototype.ngOnDestroy = function () {
        for (var _i = 0, _a = this._subs; _i < _a.length; _i++) {
            var sub = _a[_i];
            sub.unsubscribe();
        }
        this._effects.destroy();
    };
    BsDaterangepickerContainerComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'bs-daterangepicker-container',
                    providers: [bs_datepicker_store_BsDatepickerStore, bs_datepicker_effects_BsDatepickerEffects],
                    template: "<!-- days calendar view mode --> <div class=\"bs-datepicker\" [ngClass]=\"containerClass\" *ngIf=\"viewMode | async\"> <div class=\"bs-datepicker-container\"> <!--calendars--> <div class=\"bs-calendar-container\" [ngSwitch]=\"viewMode | async\"> <!--days calendar--> <div *ngSwitchCase=\"'day'\"> <bs-days-calendar-view *ngFor=\"let calendar of (daysCalendar | async)\" [class.bs-datepicker-multiple]=\"(daysCalendar | async).length > 1\" [calendar]=\"calendar\" [options]=\"options | async\" (onNavigate)=\"navigateTo($event)\" (onViewMode)=\"setViewMode($event)\" (onHover)=\"dayHoverHandler($event)\" (onSelect)=\"daySelectHandler($event)\" ></bs-days-calendar-view> </div> <!--months calendar--> <div *ngSwitchCase=\"'month'\"> <bs-month-calendar-view *ngFor=\"let calendar of (monthsCalendar | async)\" [class.bs-datepicker-multiple]=\"(daysCalendar | async).length > 1\" [calendar]=\"calendar\" (onNavigate)=\"navigateTo($event)\" (onViewMode)=\"setViewMode($event)\" (onHover)=\"monthHoverHandler($event)\" (onSelect)=\"monthSelectHandler($event)\" ></bs-month-calendar-view> </div> <!--years calendar--> <div *ngSwitchCase=\"'year'\"> <bs-years-calendar-view *ngFor=\"let calendar of (yearsCalendar | async)\" [class.bs-datepicker-multiple]=\"(daysCalendar | async).length > 1\" [calendar]=\"calendar\" (onNavigate)=\"navigateTo($event)\" (onViewMode)=\"setViewMode($event)\" (onHover)=\"yearHoverHandler($event)\" (onSelect)=\"yearSelectHandler($event)\" ></bs-years-calendar-view> </div> </div> <!--applycancel buttons--> <div class=\"bs-datepicker-buttons\" *ngIf=\"false\"> <button class=\"btn btn-success\">Apply</button> <button class=\"btn btn-default\">Cancel</button> </div> </div> <!--custom dates or date ranges picker--> <div class=\"bs-datepicker-custom-range\" *ngIf=\"false\"> <bs-custom-date-view [ranges]=\"_customRangesFish\"></bs-custom-date-view> </div> </div> ",
                    host: {
                        '(click)': '_stopPropagation($event)',
                        style: 'position: absolute; display: block;'
                    }
                },] },
    ];
    /** @nocollapse */
    BsDaterangepickerContainerComponent.ctorParameters = function () { return [
        { type: bs_datepicker_config_BsDatepickerConfig, },
        { type: bs_datepicker_store_BsDatepickerStore, },
        { type: bs_datepicker_actions_BsDatepickerActions, },
        { type: bs_datepicker_effects_BsDatepickerEffects, },
    ]; };
    return BsDaterangepickerContainerComponent;
}(BsDatepickerAbstractComponent));

//# sourceMappingURL=bs-daterangepicker-container.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/bs-daterangepicker.component.js




var bs_daterangepicker_component_BsDaterangepickerComponent = (function () {
    function BsDaterangepickerComponent(_config, _elementRef, _renderer, _viewContainerRef, cis) {
        this._config = _config;
        /**
         * Placement of a daterangepicker. Accepts: "top", "bottom", "left", "right"
         */
        this.placement = 'bottom';
        /**
         * Specifies events that should trigger. Supports a space separated list of
         * event names.
         */
        this.triggers = 'click';
        /**
         * Close daterangepicker on outside click
         */
        this.outsideClick = true;
        /**
         * A selector specifying the element the daterangepicker should be appended to.
         * Currently only supports "body".
         */
        this.container = 'body';
        /**
         * Emits when daterangepicker value has been changed
         */
        this.bsValueChange = new core_es5["EventEmitter"]();
        this._subs = [];
        this._datepicker = cis
            .createLoader(_elementRef, _viewContainerRef, _renderer);
        Object.assign(this, _config);
        this.onShown = this._datepicker.onShown;
        this.onHidden = this._datepicker.onHidden;
    }
    Object.defineProperty(BsDaterangepickerComponent.prototype, "isOpen", {
        /**
         * Returns whether or not the daterangepicker is currently being shown
         */
        get: function () {
            return this._datepicker.isShown;
        },
        set: function (value) {
            if (value) {
                this.show();
            }
            else {
                this.hide();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BsDaterangepickerComponent.prototype, "bsValue", {
        /**
         * Initial value of daterangepicker
         */
        set: function (value) {
            if (this._bsValue === value) {
                return;
            }
            this._bsValue = value;
            this.bsValueChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    BsDaterangepickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._datepicker.listen({
            outsideClick: this.outsideClick,
            triggers: this.triggers,
            show: function () { return _this.show(); }
        });
    };
    BsDaterangepickerComponent.prototype.ngOnChanges = function (changes) {
        if (!this._datepickerRef || !this._datepickerRef.instance) {
            return;
        }
        if (changes.minDate) {
            this._datepickerRef.instance.minDate = this.minDate;
        }
        if (changes.maxDate) {
            this._datepickerRef.instance.maxDate = this.maxDate;
        }
        if (changes.isDisabled) {
            this._datepickerRef.instance.isDisabled = this.isDisabled;
        }
    };
    /**
     * Opens an element’s datepicker. This is considered a “manual” triggering of
     * the datepicker.
     */
    BsDaterangepickerComponent.prototype.show = function () {
        var _this = this;
        if (this._datepicker.isShown) {
            return;
        }
        this._config = Object.assign({}, this._config, { displayMonths: 2 }, this.bsConfig, {
            value: this._bsValue,
            isDisabled: this.isDisabled,
            minDate: this.minDate || this._config.minDate,
            maxDate: this.maxDate || this._config.maxDate
        });
        this._datepickerRef = this._datepicker
            .provide({ provide: bs_datepicker_config_BsDatepickerConfig, useValue: this._config })
            .attach(bs_daterangepicker_container_component_BsDaterangepickerContainerComponent)
            .to(this.container)
            .position({ attachment: this.placement })
            .show({ placement: this.placement });
        // if date changes from external source (model -> view)
        this._subs.push(this.bsValueChange.subscribe(function (value) {
            _this._datepickerRef.instance.value = value;
        }));
        // if date changes from picker (view -> model)
        this._subs.push(this._datepickerRef.instance
            .valueChange
            .filter(function (range) { return range && range[0] && !!range[1]; })
            .subscribe(function (value) {
            _this.bsValue = value;
            _this.hide();
        }));
    };
    /**
     * Closes an element’s datepicker. This is considered a “manual” triggering of
     * the datepicker.
     */
    BsDaterangepickerComponent.prototype.hide = function () {
        if (this.isOpen) {
            this._datepicker.hide();
        }
        for (var _i = 0, _a = this._subs; _i < _a.length; _i++) {
            var sub = _a[_i];
            sub.unsubscribe();
        }
    };
    /**
     * Toggles an element’s datepicker. This is considered a “manual” triggering of
     * the datepicker.
     */
    BsDaterangepickerComponent.prototype.toggle = function () {
        if (this.isOpen) {
            return this.hide();
        }
        this.show();
    };
    BsDaterangepickerComponent.prototype.ngOnDestroy = function () {
        this._datepicker.dispose();
    };
    BsDaterangepickerComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'bs-daterangepicker,[bsDaterangepicker]',
                    exportAs: 'bsDaterangepicker',
                    template: ' '
                },] },
    ];
    /** @nocollapse */
    BsDaterangepickerComponent.ctorParameters = function () { return [
        { type: bs_datepicker_config_BsDatepickerConfig, },
        { type: core_es5["ElementRef"], },
        { type: core_es5["Renderer"], },
        { type: core_es5["ViewContainerRef"], },
        { type: component_loader_factory["a" /* ComponentLoaderFactory */], },
    ]; };
    BsDaterangepickerComponent.propDecorators = {
        'placement': [{ type: core_es5["Input"] },],
        'triggers': [{ type: core_es5["Input"] },],
        'outsideClick': [{ type: core_es5["Input"] },],
        'container': [{ type: core_es5["Input"] },],
        'isOpen': [{ type: core_es5["Input"] },],
        'onShown': [{ type: core_es5["Output"] },],
        'onHidden': [{ type: core_es5["Output"] },],
        'bsValue': [{ type: core_es5["Input"] },],
        'bsConfig': [{ type: core_es5["Input"] },],
        'isDisabled': [{ type: core_es5["Input"] },],
        'minDate': [{ type: core_es5["Input"] },],
        'maxDate': [{ type: core_es5["Input"] },],
        'bsValueChange': [{ type: core_es5["Output"] },],
    };
    return BsDaterangepickerComponent;
}());

//# sourceMappingURL=bs-daterangepicker.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/bs-datepicker.component.js





var bs_datepicker_component_BsDatepickerComponent = (function () {
    function BsDatepickerComponent(_config, _elementRef, _renderer, _viewContainerRef, cis) {
        this._config = _config;
        /**
         * Placement of a datepicker. Accepts: "top", "bottom", "left", "right"
         */
        this.placement = 'bottom';
        /**
         * Specifies events that should trigger. Supports a space separated list of
         * event names.
         */
        this.triggers = 'click';
        /**
         * Close datepicker on outside click
         */
        this.outsideClick = true;
        /**
         * A selector specifying the element the datepicker should be appended to.
         * Currently only supports "body".
         */
        this.container = 'body';
        /**
         * Emits when datepicker value has been changed
         */
        this.bsValueChange = new core_es5["EventEmitter"]();
        this._subs = [];
        // todo: assign only subset of fields
        Object.assign(this, this._config);
        this._datepicker = cis
            .createLoader(_elementRef, _viewContainerRef, _renderer);
        this.onShown = this._datepicker.onShown;
        this.onHidden = this._datepicker.onHidden;
    }
    Object.defineProperty(BsDatepickerComponent.prototype, "isOpen", {
        /**
         * Returns whether or not the datepicker is currently being shown
         */
        get: function () {
            return this._datepicker.isShown;
        },
        set: function (value) {
            if (value) {
                this.show();
            }
            else {
                this.hide();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BsDatepickerComponent.prototype, "bsValue", {
        /**
         * Initial value of datepicker
         */
        set: function (value) {
            if (this._bsValue === value) {
                return;
            }
            this._bsValue = value;
            this.bsValueChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    BsDatepickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._datepicker.listen({
            outsideClick: this.outsideClick,
            triggers: this.triggers,
            show: function () { return _this.show(); }
        });
    };
    BsDatepickerComponent.prototype.ngOnChanges = function (changes) {
        if (!this._datepickerRef || !this._datepickerRef.instance) {
            return;
        }
        if (changes.minDate) {
            this._datepickerRef.instance.minDate = this.minDate;
        }
        if (changes.maxDate) {
            this._datepickerRef.instance.maxDate = this.maxDate;
        }
        if (changes.isDisabled) {
            this._datepickerRef.instance.isDisabled = this.isDisabled;
        }
    };
    /**
     * Opens an element’s datepicker. This is considered a “manual” triggering of
     * the datepicker.
     */
    BsDatepickerComponent.prototype.show = function () {
        var _this = this;
        if (this._datepicker.isShown) {
            return;
        }
        this._config = Object.assign({}, this._config, this.bsConfig, {
            value: this._bsValue,
            isDisabled: this.isDisabled,
            minDate: this.minDate || this._config.minDate,
            maxDate: this.maxDate || this._config.maxDate
        });
        this._datepickerRef = this._datepicker
            .provide({ provide: bs_datepicker_config_BsDatepickerConfig, useValue: this._config })
            .attach(bs_datepicker_container_component_BsDatepickerContainerComponent)
            .to(this.container)
            .position({ attachment: this.placement })
            .show({ placement: this.placement });
        // if date changes from external source (model -> view)
        this._subs.push(this.bsValueChange.subscribe(function (value) {
            _this._datepickerRef.instance.value = value;
        }));
        // if date changes from picker (view -> model)
        this._subs.push(this._datepickerRef.instance
            .valueChange.subscribe(function (value) {
            _this.bsValue = value;
            _this.hide();
        }));
    };
    /**
     * Closes an element’s datepicker. This is considered a “manual” triggering of
     * the datepicker.
     */
    BsDatepickerComponent.prototype.hide = function () {
        if (this.isOpen) {
            this._datepicker.hide();
        }
        for (var _i = 0, _a = this._subs; _i < _a.length; _i++) {
            var sub = _a[_i];
            sub.unsubscribe();
        }
    };
    /**
     * Toggles an element’s datepicker. This is considered a “manual” triggering of
     * the datepicker.
     */
    BsDatepickerComponent.prototype.toggle = function () {
        if (this.isOpen) {
            return this.hide();
        }
        this.show();
    };
    BsDatepickerComponent.prototype.ngOnDestroy = function () {
        this._datepicker.dispose();
    };
    BsDatepickerComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'bs-datepicker,[bsDatepicker]',
                    exportAs: 'bsDatepicker',
                    template: '<ng-content></ng-content>'
                },] },
    ];
    /** @nocollapse */
    BsDatepickerComponent.ctorParameters = function () { return [
        { type: bs_datepicker_config_BsDatepickerConfig, },
        { type: core_es5["ElementRef"], },
        { type: core_es5["Renderer"], },
        { type: core_es5["ViewContainerRef"], },
        { type: component_loader_factory["a" /* ComponentLoaderFactory */], },
    ]; };
    BsDatepickerComponent.propDecorators = {
        'placement': [{ type: core_es5["Input"] },],
        'triggers': [{ type: core_es5["Input"] },],
        'outsideClick': [{ type: core_es5["Input"] },],
        'container': [{ type: core_es5["Input"] },],
        'isOpen': [{ type: core_es5["Input"] },],
        'onShown': [{ type: core_es5["Output"] },],
        'onHidden': [{ type: core_es5["Output"] },],
        'bsValue': [{ type: core_es5["Input"] },],
        'bsConfig': [{ type: core_es5["Input"] },],
        'isDisabled': [{ type: core_es5["Input"] },],
        'minDate': [{ type: core_es5["Input"] },],
        'maxDate': [{ type: core_es5["Input"] },],
        'bsValueChange': [{ type: core_es5["Output"] },],
    };
    return BsDatepickerComponent;
}());

//# sourceMappingURL=bs-datepicker.component.js.map
// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/positioning/positioning.service.js
var positioning_service = __webpack_require__("/CuN");

// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/themes/bs/bs-datepicker-day-decorator.directive.js

var bs_datepicker_day_decorator_directive_BsDatepickerDayDecoratorComponent = (function () {
    function BsDatepickerDayDecoratorComponent() {
    }
    BsDatepickerDayDecoratorComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: '[bsDatepickerDayDecorator]',
                    changeDetection: core_es5["ChangeDetectionStrategy"].OnPush,
                    host: {
                        '[class.disabled]': 'day.isDisabled',
                        '[class.is-highlighted]': 'day.isHovered',
                        '[class.is-other-month]': 'day.isOtherMonth',
                        '[class.in-range]': 'day.isInRange',
                        '[class.select-start]': 'day.isSelectionStart',
                        '[class.select-end]': 'day.isSelectionEnd',
                        '[class.selected]': 'day.isSelected'
                    },
                    template: "{{ day.label }}"
                },] },
    ];
    /** @nocollapse */
    BsDatepickerDayDecoratorComponent.ctorParameters = function () { return []; };
    BsDatepickerDayDecoratorComponent.propDecorators = {
        'day': [{ type: core_es5["Input"] },],
    };
    return BsDatepickerDayDecoratorComponent;
}());

//# sourceMappingURL=bs-datepicker-day-decorator.directive.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/themes/bs/bs-months-calendar-view.component.js


var bs_months_calendar_view_component_BsMonthCalendarViewComponent = (function () {
    function BsMonthCalendarViewComponent() {
        this.onNavigate = new core_es5["EventEmitter"]();
        this.onViewMode = new core_es5["EventEmitter"]();
        this.onSelect = new core_es5["EventEmitter"]();
        this.onHover = new core_es5["EventEmitter"]();
    }
    BsMonthCalendarViewComponent.prototype.navigateTo = function (event) {
        var step = BsNavigationDirection.DOWN === event ? -1 : 1;
        this.onNavigate.emit({ step: { year: step } });
    };
    BsMonthCalendarViewComponent.prototype.viewMonth = function (month) {
        this.onSelect.emit(month);
    };
    BsMonthCalendarViewComponent.prototype.hoverMonth = function (cell, isHovered) {
        this.onHover.emit({ cell: cell, isHovered: isHovered });
    };
    BsMonthCalendarViewComponent.prototype.changeViewMode = function (event) {
        this.onViewMode.emit(event);
    };
    BsMonthCalendarViewComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'bs-month-calendar-view',
                    template: "\n    <bs-calendar-layout>\n      <bs-datepicker-navigation-view\n        [calendar]=\"calendar\"\n        (onNavigate)=\"navigateTo($event)\"\n        (onViewMode)=\"changeViewMode($event)\"\n      ></bs-datepicker-navigation-view>\n\n      <table role=\"grid\" class=\"months\">\n        <tbody>\n        <tr *ngFor=\"let row of calendar.months\">\n          <td *ngFor=\"let month of row\" role=\"gridcell\"\n              (click)=\"viewMonth(month)\"\n              (mouseenter)=\"hoverMonth(month, true)\"\n              (mouseleave)=\"hoverMonth(month, false)\"\n              [class.disabled]=\"month.isDisabled\"\n              [class.is-highlighted]=\"month.isHovered\">\n            <span>{{ month.label }}</span>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </bs-calendar-layout>\n  "
                },] },
    ];
    /** @nocollapse */
    BsMonthCalendarViewComponent.ctorParameters = function () { return []; };
    BsMonthCalendarViewComponent.propDecorators = {
        'calendar': [{ type: core_es5["Input"] },],
        'onNavigate': [{ type: core_es5["Output"] },],
        'onViewMode': [{ type: core_es5["Output"] },],
        'onSelect': [{ type: core_es5["Output"] },],
        'onHover': [{ type: core_es5["Output"] },],
    };
    return BsMonthCalendarViewComponent;
}());

//# sourceMappingURL=bs-months-calendar-view.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/themes/bs/bs-years-calendar-view.component.js



var bs_years_calendar_view_component_BsYearsCalendarViewComponent = (function () {
    function BsYearsCalendarViewComponent() {
        this.onNavigate = new core_es5["EventEmitter"]();
        this.onViewMode = new core_es5["EventEmitter"]();
        this.onSelect = new core_es5["EventEmitter"]();
        this.onHover = new core_es5["EventEmitter"]();
    }
    BsYearsCalendarViewComponent.prototype.navigateTo = function (event) {
        var step = BsNavigationDirection.DOWN === event ? -1 : 1;
        this.onNavigate.emit({ step: { year: step * yearsPerCalendar } });
    };
    BsYearsCalendarViewComponent.prototype.viewYear = function (year) {
        this.onSelect.emit(year);
    };
    BsYearsCalendarViewComponent.prototype.hoverYear = function (cell, isHovered) {
        this.onHover.emit({ cell: cell, isHovered: isHovered });
    };
    BsYearsCalendarViewComponent.prototype.changeViewMode = function (event) {
        this.onViewMode.emit(event);
    };
    BsYearsCalendarViewComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'bs-years-calendar-view',
                    template: "\n    <bs-calendar-layout>\n      <bs-datepicker-navigation-view\n        [calendar]=\"calendar\"\n        (onNavigate)=\"navigateTo($event)\"\n        (onViewMode)=\"changeViewMode($event)\"\n      ></bs-datepicker-navigation-view>\n\n      <table role=\"grid\" class=\"years\">\n        <tbody>\n        <tr *ngFor=\"let row of calendar.years\">\n          <td *ngFor=\"let year of row\" role=\"gridcell\"\n              (click)=\"viewYear(year)\"\n              (mouseenter)=\"hoverYear(year, true)\"\n              (mouseleave)=\"hoverYear(year, false)\"\n              [class.disabled]=\"year.isDisabled\"\n              [class.is-highlighted]=\"year.isHovered\">\n            <span>{{ year.label }}</span>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </bs-calendar-layout>\n  "
                },] },
    ];
    /** @nocollapse */
    BsYearsCalendarViewComponent.ctorParameters = function () { return []; };
    BsYearsCalendarViewComponent.propDecorators = {
        'calendar': [{ type: core_es5["Input"] },],
        'onNavigate': [{ type: core_es5["Output"] },],
        'onViewMode': [{ type: core_es5["Output"] },],
        'onSelect': [{ type: core_es5["Output"] },],
        'onHover': [{ type: core_es5["Output"] },],
    };
    return BsYearsCalendarViewComponent;
}());

//# sourceMappingURL=bs-years-calendar-view.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/themes/bs/bs-custom-dates-view.component.js

var bs_custom_dates_view_component_BsCustomDatesViewComponent = (function () {
    function BsCustomDatesViewComponent() {
    }
    BsCustomDatesViewComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'bs-custom-date-view',
                    template: "\n    <div class=\"bs-datepicker-predefined-btns\">\n      <button *ngFor=\"let range of ranges\">{{ range.label }}</button>\n      <button *ngIf=\"isCustomRangeShown\">Custom Range</button>\n    </div>\n  ",
                    changeDetection: core_es5["ChangeDetectionStrategy"].OnPush
                },] },
    ];
    /** @nocollapse */
    BsCustomDatesViewComponent.ctorParameters = function () { return []; };
    BsCustomDatesViewComponent.propDecorators = {
        'isCustomRangeShown': [{ type: core_es5["Input"] },],
        'ranges': [{ type: core_es5["Input"] },],
    };
    return BsCustomDatesViewComponent;
}());

//# sourceMappingURL=bs-custom-dates-view.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/themes/bs/bs-current-date-view.component.js

var bs_current_date_view_component_BsCurrentDateViewComponent = (function () {
    function BsCurrentDateViewComponent() {
    }
    BsCurrentDateViewComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'bs-current-date',
                    template: "<div class=\"current-timedate\"><span>{{ title }}</span></div>"
                },] },
    ];
    /** @nocollapse */
    BsCurrentDateViewComponent.ctorParameters = function () { return []; };
    BsCurrentDateViewComponent.propDecorators = {
        'title': [{ type: core_es5["Input"] },],
    };
    return BsCurrentDateViewComponent;
}());

//# sourceMappingURL=bs-current-date-view.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/themes/bs/bs-timepicker-view.component.js

var bs_timepicker_view_component_BsTimepickerViewComponent = (function () {
    function BsTimepickerViewComponent() {
        this.ampm = 'ok';
        this.hours = 0;
        this.minutes = 0;
    }
    BsTimepickerViewComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'bs-timepicker',
                    template: "\n<div class=\"bs-timepicker-container\">\n  <div class=\"bs-timepicker-controls\">\n    <button class=\"bs-decrease\">-</button>\n    <input type=\"text\" [value]=\"hours\" placeholder=\"00\">\n    <button class=\"bs-increase\">+</button>\n  </div>\n  <div class=\"bs-timepicker-controls\">\n    <button class=\"bs-decrease\">-</button>\n    <input type=\"text\" [value]=\"minutes\" placeholder=\"00\">\n    <button class=\"bs-increase\">+</button>\n  </div>\n  <button class=\"switch-time-format\">{{ ampm }}\n    <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAABSElEQVQYV3XQPUvDUBQG4HNuagtVqc6KgouCv6GIuIntYBLB9hcIQpLStCAIV7DYmpTcRWcXqZio3Vwc/UCc/QEqfgyKGbr0I7nS1EiHeqYzPO/h5SD0jaxUZjmSLCB+OFb+UFINFwASAEAdpu9gaGXVyAHHFQBkHpKHc6a9dzECvADyY9sqlAMsK9W0jzxDXqeytr3mhQckxSji27TJJ5/rPmIpwJJq3HrtduriYOurv1a4i1p5HnhkG9OFymi0ReoO05cGwb+ayv4dysVygjeFmsP05f8wpZQ8fsdvfmuY9zjWSNqUtgYFVnOVReILYoBFzdQI5/GGFzNHhGbeZnopDGU29sZbscgldmC99w35VOATTycIMMcBXIfpSVGzZhA6C8hh00conln6VQ9TGgV32OEAKQC4DrBq7CJwd0ggR7Vq/rPrfgB+C3sGypY5DAAAAABJRU5ErkJggg==\" alt=\"\">\n  </button>\n</div>\n"
                },] },
    ];
    /** @nocollapse */
    BsTimepickerViewComponent.ctorParameters = function () { return []; };
    return BsTimepickerViewComponent;
}());

//# sourceMappingURL=bs-timepicker-view.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/themes/bs/bs-calendar-layout.component.js

var bs_calendar_layout_component_BsCalendarLayoutComponent = (function () {
    function BsCalendarLayoutComponent() {
    }
    BsCalendarLayoutComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'bs-calendar-layout',
                    template: "\n    <!-- current date, will be added in nearest releases -->\n    <bs-current-date title=\"hey there\" *ngIf=\"false\"></bs-current-date>\n\n    <!--navigation-->\n    <div class=\"bs-datepicker-head\">\n      <ng-content select=\"bs-datepicker-navigation-view\"></ng-content>\n    </div>\n\n    <div class=\"bs-datepicker-body\">\n      <ng-content></ng-content>\n    </div>\n\n    <!--timepicker-->\n    <bs-timepicker *ngIf=\"false\"></bs-timepicker>\n  "
                },] },
    ];
    /** @nocollapse */
    BsCalendarLayoutComponent.ctorParameters = function () { return []; };
    return BsCalendarLayoutComponent;
}());

//# sourceMappingURL=bs-calendar-layout.component.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/bs-datepicker-input.directive.js






var BS_DATEPICKER_VALUE_ACCESSOR = {
    provide: forms_es5["NG_VALUE_ACCESSOR"],
    useExisting: Object(core_es5["forwardRef"])(function () { return bs_datepicker_input_directive_BsDatepickerInputDirective; }),
    multi: true
};
var bs_datepicker_input_directive_BsDatepickerInputDirective = (function () {
    function BsDatepickerInputDirective(_picker, _config, _renderer, _elRef) {
        this._picker = _picker;
        this._config = _config;
        this._renderer = _renderer;
        this._elRef = _elRef;
        this._onChange = Function.prototype;
        this._onTouched = Function.prototype;
    }
    BsDatepickerInputDirective.prototype.ngOnInit = function () {
        var _this = this;
        this._picker.bsValueChange.subscribe(function (v) {
            _this._renderer.setElementProperty(_this._elRef.nativeElement, 'value', formatDate(v, _this._picker._config.dateInputFormat, _this._picker._config.locale) || '');
            _this._onChange(v);
        });
    };
    BsDatepickerInputDirective.prototype.onChange = function (event) {
        this.writeValue(event.target.value);
        this._onTouched();
    };
    BsDatepickerInputDirective.prototype.writeValue = function (value) {
        if (!value) {
            this._picker.bsValue = null;
        }
        var _locale = getLocale(this._picker._config.locale);
        if (!_locale) {
            throw new Error("Locale \"" + this._picker._config.locale + "\" is not defined, please add it with \"defineLocale(...)\"");
        }
        if (typeof value === 'string') {
            var date = new Date(_locale.preparse(value));
            this._picker.bsValue = isNaN(date.valueOf()) ? null : date;
        }
        if (value instanceof Date) {
            this._picker.bsValue = value;
        }
    };
    BsDatepickerInputDirective.prototype.setDisabledState = function (isDisabled) {
        this._picker.isDisabled = isDisabled;
        this._renderer.setElementAttribute(this._elRef.nativeElement, 'disabled', 'disabled');
    };
    BsDatepickerInputDirective.prototype.registerOnChange = function (fn) { this._onChange = fn; };
    BsDatepickerInputDirective.prototype.registerOnTouched = function (fn) { this._onTouched = fn; };
    BsDatepickerInputDirective.prototype.onBlur = function () { this._onTouched(); };
    BsDatepickerInputDirective.prototype.hide = function () {
        this._picker.hide();
    };
    BsDatepickerInputDirective.decorators = [
        { type: core_es5["Directive"], args: [{
                    selector: "input[bsDatepicker]",
                    host: {
                        '(change)': 'onChange($event)',
                        '(keyup.esc)': 'hide()',
                        '(blur)': 'onBlur()'
                    },
                    providers: [BS_DATEPICKER_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    BsDatepickerInputDirective.ctorParameters = function () { return [
        { type: bs_datepicker_component_BsDatepickerComponent, decorators: [{ type: core_es5["Host"] },] },
        { type: bs_datepicker_config_BsDatepickerConfig, },
        { type: core_es5["Renderer"], },
        { type: core_es5["ElementRef"], },
    ]; };
    return BsDatepickerInputDirective;
}());

//# sourceMappingURL=bs-datepicker-input.directive.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/bs-daterangepicker-input.directive.js






var BS_DATERANGEPICKER_VALUE_ACCESSOR = {
    provide: forms_es5["NG_VALUE_ACCESSOR"],
    useExisting: Object(core_es5["forwardRef"])(function () { return bs_daterangepicker_input_directive_BsDaterangepickerInputDirective; }),
    multi: true
};
var bs_daterangepicker_input_directive_BsDaterangepickerInputDirective = (function () {
    function BsDaterangepickerInputDirective(_picker, _config, _renderer, _elRef) {
        this._picker = _picker;
        this._config = _config;
        this._renderer = _renderer;
        this._elRef = _elRef;
        this._onChange = Function.prototype;
        this._onTouched = Function.prototype;
    }
    BsDaterangepickerInputDirective.prototype.ngOnInit = function () {
        var _this = this;
        this._picker.bsValueChange.subscribe(function (v) {
            var range = '';
            if (v) {
                var start = formatDate(v[0], _this._picker._config.rangeInputFormat, _this._picker._config.locale);
                var end = formatDate(v[1], _this._picker._config.rangeInputFormat, _this._picker._config.locale);
                range = start + _this._picker._config.rangeSeparator + end;
            }
            _this._renderer.setElementProperty(_this._elRef.nativeElement, 'value', range);
            _this._onChange(v);
        });
    };
    BsDaterangepickerInputDirective.prototype.onChange = function (event) {
        this.writeValue(event.target.value);
        this._onTouched();
    };
    BsDaterangepickerInputDirective.prototype.writeValue = function (value) {
        if (!value) {
            this._picker.bsValue = null;
        }
        var _locale = getLocale(this._picker._config.locale);
        if (!_locale) {
            throw new Error("Locale \"" + this._picker._config.locale + "\" is not defined, please add it with \"defineLocale(...)\"");
        }
        if (typeof value === 'string') {
            this._picker.bsValue = value
                .split(this._picker._config.rangeSeparator)
                .map(function (date) { return new Date(_locale.preparse(date)); })
                .map(function (date) { return isNaN(date.valueOf()) ? null : date; });
        }
        if (Array.isArray(value)) {
            this._picker.bsValue = value;
        }
    };
    BsDaterangepickerInputDirective.prototype.setDisabledState = function (isDisabled) {
        this._picker.isDisabled = isDisabled;
        this._renderer.setElementAttribute(this._elRef.nativeElement, 'disabled', 'disabled');
    };
    BsDaterangepickerInputDirective.prototype.registerOnChange = function (fn) { this._onChange = fn; };
    BsDaterangepickerInputDirective.prototype.registerOnTouched = function (fn) { this._onTouched = fn; };
    BsDaterangepickerInputDirective.prototype.onBlur = function () { this._onTouched(); };
    BsDaterangepickerInputDirective.prototype.hide = function () {
        this._picker.hide();
    };
    BsDaterangepickerInputDirective.decorators = [
        { type: core_es5["Directive"], args: [{
                    selector: "input[bsDaterangepicker]",
                    host: {
                        '(change)': 'onChange($event)',
                        '(keyup.esc)': 'hide()',
                        '(blur)': 'onBlur()'
                    },
                    providers: [BS_DATERANGEPICKER_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    BsDaterangepickerInputDirective.ctorParameters = function () { return [
        { type: bs_daterangepicker_component_BsDaterangepickerComponent, decorators: [{ type: core_es5["Host"] },] },
        { type: bs_datepicker_config_BsDatepickerConfig, },
        { type: core_es5["Renderer"], },
        { type: core_es5["ElementRef"], },
    ]; };
    return BsDaterangepickerInputDirective;
}());

//# sourceMappingURL=bs-daterangepicker-input.directive.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/bs-datepicker.module.js
























var _exports = [
    bs_datepicker_container_component_BsDatepickerContainerComponent,
    bs_daterangepicker_container_component_BsDaterangepickerContainerComponent,
    bs_datepicker_component_BsDatepickerComponent,
    bs_datepicker_input_directive_BsDatepickerInputDirective,
    bs_daterangepicker_input_directive_BsDaterangepickerInputDirective,
    bs_daterangepicker_component_BsDaterangepickerComponent
];
var bs_datepicker_module_BsDatepickerModule = (function () {
    function BsDatepickerModule() {
        warnOnce("BsDatepickerModule is under development,\n      BREAKING CHANGES are possible,\n      PLEASE, read changelog");
    }
    BsDatepickerModule.forRoot = function () {
        return {
            ngModule: BsDatepickerModule,
            providers: [
                component_loader_factory["a" /* ComponentLoaderFactory */], positioning_service["a" /* PositioningService */],
                bs_datepicker_store_BsDatepickerStore, bs_datepicker_actions_BsDatepickerActions, bs_datepicker_config_BsDatepickerConfig, bs_datepicker_effects_BsDatepickerEffects
            ]
        };
    };
    BsDatepickerModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    imports: [common_es5["CommonModule"]],
                    declarations: [
                        bs_datepicker_day_decorator_directive_BsDatepickerDayDecoratorComponent,
                        bs_current_date_view_component_BsCurrentDateViewComponent,
                        bs_datepicker_navigation_view_component_BsDatepickerNavigationViewComponent,
                        bs_timepicker_view_component_BsTimepickerViewComponent,
                        bs_calendar_layout_component_BsCalendarLayoutComponent,
                        bs_days_calendar_view_component_BsDaysCalendarViewComponent,
                        bs_months_calendar_view_component_BsMonthCalendarViewComponent,
                        bs_years_calendar_view_component_BsYearsCalendarViewComponent,
                        bs_custom_dates_view_component_BsCustomDatesViewComponent
                    ].concat(_exports),
                    entryComponents: [bs_datepicker_container_component_BsDatepickerContainerComponent, bs_daterangepicker_container_component_BsDaterangepickerContainerComponent],
                    exports: _exports
                },] },
    ];
    /** @nocollapse */
    BsDatepickerModule.ctorParameters = function () { return []; };
    return BsDatepickerModule;
}());

//# sourceMappingURL=bs-datepicker.module.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/datepicker/index.js











//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/modal/index.js
var modal = __webpack_require__("Sfd1");

// EXTERNAL MODULE: ./node_modules/ngx-bootstrap/dropdown/index.js
var dropdown = __webpack_require__("3fEP");

// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/pagination/index.js




//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/progressbar/index.js





//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/rating/index.js


//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/tabs/index.js






//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/timepicker/index.js





//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/tooltip/index.js




//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/typeahead/typeahead-options.class.js
var TypeaheadOptions = (function () {
    function TypeaheadOptions(options) {
        Object.assign(this, options);
    }
    return TypeaheadOptions;
}());

//# sourceMappingURL=typeahead-options.class.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/typeahead/index.js







//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/popover/index.js




//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/bs-moment/index.js

//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/ngx-bootstrap/index.js
/* tslint:disable: max-classes-per-file */







































var MODULES = [
    accordion_module_AccordionModule, alert_module_AlertModule, buttons_module_ButtonsModule,
    carousel_module_CarouselModule, collapse_module["a" /* CollapseModule */], datepicker_module_DatepickerModule,
    bs_dropdown_module["a" /* BsDropdownModule */], modal_module["a" /* ModalModule */], pagination_module_PaginationModule,
    progressbar_module_ProgressbarModule, popover_module_PopoverModule, rating_module_RatingModule,
    tabs_module_TabsModule, timepicker_module_TimepickerModule, tooltip_module_TooltipModule,
    typeahead_module_TypeaheadModule
];
var ngx_bootstrap_BsRootModule = (function () {
    function BsRootModule() {
    }
    BsRootModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    imports: [
                        accordion_module_AccordionModule.forRoot(), alert_module_AlertModule.forRoot(), buttons_module_ButtonsModule.forRoot(),
                        carousel_module_CarouselModule.forRoot(), collapse_module["a" /* CollapseModule */].forRoot(),
                        datepicker_module_DatepickerModule.forRoot(),
                        bs_dropdown_module["a" /* BsDropdownModule */].forRoot(), modal_module["a" /* ModalModule */].forRoot(), pagination_module_PaginationModule.forRoot(),
                        progressbar_module_ProgressbarModule.forRoot(), popover_module_PopoverModule.forRoot(),
                        rating_module_RatingModule.forRoot(),
                        tabs_module_TabsModule.forRoot(), timepicker_module_TimepickerModule.forRoot(), tooltip_module_TooltipModule.forRoot(),
                        typeahead_module_TypeaheadModule.forRoot(), sortable_module_SortableModule.forRoot()
                    ],
                    exports: MODULES
                },] },
    ];
    /** @nocollapse */
    BsRootModule.ctorParameters = function () { return []; };
    return BsRootModule;
}());

var ngx_bootstrap_Ng2BootstrapModule = (function () {
    function Ng2BootstrapModule() {
    }
    Ng2BootstrapModule.forRoot = function () {
        return { ngModule: ngx_bootstrap_BsRootModule };
    };
    Ng2BootstrapModule.decorators = [
        { type: core_es5["NgModule"], args: [{ exports: MODULES },] },
    ];
    /** @nocollapse */
    Ng2BootstrapModule.ctorParameters = function () { return []; };
    return Ng2BootstrapModule;
}());

//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./app/components/calculator/public/mobile/public-calculator-v2.component.ts










var public_calculator_v2_component_PublicCalculatorV2Component = /** @class */ (function () {
    function PublicCalculatorV2Component(router, route, modalService, googleTagService) {
        this.router = router;
        this.route = route;
        this.modalService = modalService;
        this.googleTagService = googleTagService;
        this.order = new orders_order["a" /* Order */]();
        this.orderItem = new orders_orderItem["b" /* OrderItem */]();
        this.importerTypeRef = types_type["b" /* ImporterType */];
        this.firstPageHide = true;
        this.showWizard = true;
        this.showFirstTab = true;
        this.marketingURL = null;
        this.restoreOrder = new core_es5["EventEmitter"]();
        this.isQuotePage = false;
        this.currentYear = new Date().getFullYear().toString();
    }
    PublicCalculatorV2Component.prototype.ngOnInit = function () {
        var _this = this;
        this.marketingURL = document.referrer;
        if (this.router.url.includes('importtype')) {
            this.firstPageHide = true;
            this.showFirstTab = false;
            this.route.params.subscribe(function (params) {
                if (params['importtype'] == 'vehicle') {
                    _this.order.Flag |= orderOptions["a" /* OrderOptions */].IsVehicle;
                }
                if (params['product'] == 'product') {
                    if (_this.order && _this.order.Flag)
                        _this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsVehicle;
                }
            });
        }
        setTimeout(function () {
            _this.googleTagService.pushData("import");
        }, 350);
    };
    PublicCalculatorV2Component.prototype.setOrderItem = function (event) {
        return this.orderItem = event;
    };
    PublicCalculatorV2Component.prototype.setImportType = function (importerType) {
        this.googleTagService.pushData("country");
        var prevImporterType = calculatorHelper["a" /* CalculatorHelper */].checkOrderImporterType(this.order);
        if (prevImporterType === undefined) {
            prevImporterType = importerType;
        }
        if (importerType !== prevImporterType) {
            if (this.order.OrderItems.length > 0)
                this.order.OrderItems[0].Price = null;
            else
                this.orderItem.Price = null;
        }
        switch (importerType) {
            case types_type["b" /* ImporterType */].Vehicle:
                this.order.Flag |= orderOptions["a" /* OrderOptions */].IsVehicle;
                break;
            case types_type["b" /* ImporterType */].Product:
                if (this.order && this.order.Flag)
                    this.order.Flag &= ~orderOptions["a" /* OrderOptions */].IsVehicle;
                break;
            case types_type["b" /* ImporterType */].Enterprise:
                // TODO for now nothing;
                return;
            case types_type["b" /* ImporterType */].Regular:
                // TODO for now nothing;
                return;
        }
        formHelper["a" /* FormHelper */].scrollToTopCalcV2();
        formHelper["a" /* FormHelper */].scrollToCalcV2TabOnMobile();
        this.firstPageHide = true;
    };
    PublicCalculatorV2Component.prototype.createNewOrder = function (order) {
        this.order = order;
    };
    PublicCalculatorV2Component.prototype.restoreWizard = function () {
        var _this = this;
        this.showWizard = false;
        this.order = new orders_order["a" /* Order */]();
        this.orderItem = new orders_orderItem["b" /* OrderItem */]();
        this.showFirstTab = true;
        this.restoreOrder.emit(true);
        setTimeout(function () {
            _this.showWizard = true;
            if (_this.mainElement)
                _this.mainElement.nativeElement.scrollTop = 0;
        }, 150);
    };
    PublicCalculatorV2Component.prototype.openModal = function (template) {
        this.modalRef = this.modalService.show(template);
    };
    PublicCalculatorV2Component.ctorParameters = function () { return [{ type: router_es5["n" /* Router */] }, { type: router_es5["a" /* ActivatedRoute */] }, { type: modal["a" /* BsModalService */] }, { type: google_tag_service["a" /* GoogleTagService */] }]; };
    return PublicCalculatorV2Component;
}());

//# sourceMappingURL=public-calculator-v2.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/public/mobile/public-calculator-v2.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */














var styles_PublicCalculatorV2Component = [];
var RenderType_PublicCalculatorV2Component = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_PublicCalculatorV2Component, data: {} });
function View_PublicCalculatorV2Component_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class',
                'col-xs-12 col-sm-6 text-center text-md-left']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['class', 'logo'], ['src',
                'assets/bb_logo.022c701d33d3d8703c0d9eb023db9502.jpg']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_PublicCalculatorV2Component_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class',
                'first-page']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'publick-calculator-v2-title', [['note', 'The year of vehicle can determine duty rate.'],
            ['title', 'I want to:']], null, null, null, View_PublicCalculatorV2TitleComponent_0, RenderType_PublicCalculatorV2TitleComponent)), core_es5["ɵdid"](49152, null, 0, PublicCalculatorV2TitleComponent, [], { title: [0, 'title'], note: [1,
                'note'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'row no-gutter']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'col-xs-12 col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.setImportType(_co.importerTypeRef.Vehicle) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Import a Vehicle '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class',
                'col-xs-12 col-md-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn size-1 bold']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setImportType(_co.importerTypeRef.Product) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"], core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, [' Import any item'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_0 = 'I want to:';
        var currVal_1 = 'The year of vehicle can determine duty rate.';
        _ck(_v, 3, 0, currVal_0, currVal_1);
    }, null);
}
function View_PublicCalculatorV2Component_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'spinner']], null, null, null, null, null))], null, null);
}
function View_PublicCalculatorV2Component_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'public-wizard-v2', [], [[8, 'hidden', 0]], [[null, 'hideWizard'], [null,
                'createNewOrder'], [null, 'setOrderItem'], [null, 'getAnotherQuote'],
            [null, 'isQuotePage']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('hideWizard' === en)) {
                var pd_0 = ((_co.firstPageHide = false) !== false);
                ad = (pd_0 && ad);
            }
            if (('createNewOrder' === en)) {
                var pd_1 = (_co.createNewOrder($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('setOrderItem' === en)) {
                var pd_2 = (_co.setOrderItem($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('getAnotherQuote' === en)) {
                var pd_3 = (_co.restoreWizard() !== false);
                ad = (pd_3 && ad);
            }
            if (('isQuotePage' === en)) {
                var pd_4 = ((_co.isQuotePage = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, View_PublicWizardV2Component_0, RenderType_PublicWizardV2Component)),
        core_es5["ɵdid"](4308992, null, 0, public_wizard_v2_component["a" /* PublicWizardV2Component */], [services_configService["a" /* ConfigService */],
            services_orderService["a" /* OrderService */], router_es5["a" /* ActivatedRoute */], core_es5["ChangeDetectorRef"], google_tag_service["a" /* GoogleTagService */],
            pageVisitService["a" /* PageVisitService */]], { order: [0, 'order'], orderItem: [1, 'orderItem'], showFirstTab: [2,
                'showFirstTab'], mainElement: [3, 'mainElement'], marketingURL: [4, 'marketingURL'] }, { getAnotherQuote: 'getAnotherQuote', hideWizard: 'hideWizard', setOrderItem: 'setOrderItem',
            createNewOrder: 'createNewOrder', isQuotePage: 'isQuotePage' }), (_l()(),
            core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.order;
        var currVal_2 = _co.orderItem;
        var currVal_3 = _co.showFirstTab;
        var currVal_4 = _co.mainElement;
        var currVal_5 = _co.marketingURL;
        _ck(_v, 1, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.firstPageHide;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_PublicCalculatorV2Component_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class',
                'col-xs-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class', 'social-icon']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '/']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt', 'youtube'], ['src', 'assets/youtube.33a2d46a45325961dc6b6d0672f68513.svg']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '/']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt',
                'facebook'], ['src', 'assets/facebook.71f6d57cf486024c8bf6ecb9c69b7815.svg']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '/']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt',
                'twitter'], ['src', 'assets/twitter.f550163f114f8c9bb3d4801a22d13f37.svg']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '/']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt',
                'pinterest'], ['src', 'assets/pinterest.3a3ea91c4772177ce320c8d7c9b11de6.svg']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '/']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt',
                'instagram'], ['src', 'assets/instagram.726401ae61aa4a1b521c6e0b5b13a7d1.svg']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '/']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt',
                'linkedin'], ['src', 'assets/linkedin.92ad552dd7e1b9307c2a5c5ef410d42d.svg']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_PublicCalculatorV2Component_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'publick_calc_modal modal-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'modal-title pull-left']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['Privacy Policy'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['aria-label', 'Close'],
            ['class', 'close pull-right'], ['type', 'button']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.modalRef.hide() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['aria-hidden', 'true']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['×'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class', 'modal-body']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Your privacy is important to us. It is Border Buddy’s policy to respect your privacy regarding any information we may collect from you across our website, https://borderbuddy.com.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['We don’t ask for your personal information unless we truly need it. When we do, we’ll only collect what we need by fair and lawful means and, where appropriate, with your knowledge or consent. We’ll also let you know why we’re collecting it and how it will be used.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['We don’t share your personal information with third-parties, except where required by law. We will only retain personal information for as long as necessary to provide you with a service.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['We don’t store your personal information on our servers unless it’s required for providing a service to you. What we store, we’ll protect within commercially acceptable means to protect your personal information from loss or theft, as well as unauthorized access, disclosure, copying, use or modification. '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_PublicCalculatorV2Component_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'publick_calc_modal modal-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h4', [['class', 'modal-title pull-left']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['Terms of Use'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'button', [['aria-label', 'Close'],
            ['class', 'close pull-right'], ['type', 'button']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.modalRef.hide() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [['aria-hidden', 'true']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['×'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 88, 'div', [['class', 'modal-body']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 85, 'div', [['class', 'entry-content']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'at-above-post-page addthis_tool'], ['data-url', 'https://borderbuddy.com/terms-of-use/']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Terms'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['By accessing the website at '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', 'https://borderbuddy.com/']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['https://borderbuddy.com'])), (_l()(), core_es5["ɵted"](null, [', you are agreeing to be bound by these terms of service, all applicable laws, and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Use License'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'ol', [['type', '1']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Permission is granted to temporarily download one copy of the materials (information or software) on BorderBuddy’s website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license, you may not: '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 16, 'ol', [['type', '1']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['modify or copy the materials;'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['use the materials for any commercial purpose, or for any public display (commercial or non-commercial);'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['attempt to decompile or reverse engineer any software contained on BorderBuddy’s website;'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['remove any copyright or other proprietary notations from the materials; or'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['transfer the materials to another person or “mirror” the materials on any other server.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['This license shall automatically terminate if you violate any of these restrictions and may be terminated by BorderBuddy at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Disclaimer'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'ol', [['type', '1']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['The materials on BorderBuddy’s website are provided on an ‘as is’ basis. BorderBuddy makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Further, BorderBuddy does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Limitations'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['In no event shall BorderBuddy or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Border Buddy’s website, even if BorderBuddy or a BorderBuddy authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Accuracy of materials'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['The materials appearing on BorderBuddy website could include technical, typographical, or photographic errors. BorderBuddy does not warrant that any of the materials on its website are accurate, complete or current. BorderBuddy may make changes to the materials contained on its website at any time without notice. However BorderBuddy does not make any commitment to update the materials.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Links'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['BorderBuddy has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by BorderBuddy of the site. Use of any such linked website is at the user’s own risk.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Modifications'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['BorderBuddy may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Governing Law'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['These terms and conditions are governed by and construed in accordance with the laws of Surrey, BC and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_PublicCalculatorV2Component_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { carrying: 0 }), core_es5["ɵqud"](402653184, 2, { shipmentFrom: 0 }),
        (_l()(), core_es5["ɵeld"](0, null, null, 18, 'div', [['class', 'fixed-header']], [[2, 'quote-page', null]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'div', [['class', 'container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'row header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PublicCalculatorV2Component_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class', 'col-xs-12 col-sm-6 phone-block text-center text-md-right padding-top-md-15']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' TOLL FREE '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt', ''], ['class', 'padding-5'], ['src', 'assets/bb_phone.d616b59436472db757eb009a78355b13.png']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', 'tel:866-730-7489']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['866-730-7489'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'fake-header']], [[2, 'quote-page', null]], null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 49, 'div', [['class',
                'public-calc-v2']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 46, 'div', [['class', 'container main-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class', 'row main']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PublicCalculatorV2Component_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PublicCalculatorV2Component_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PublicCalculatorV2Component_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 28, 'div', [['class', 'row footer']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PublicCalculatorV2Component_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'col-xs-12 line']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'div', [['class', 'col-xs-12 bottom-line padding-bottom-20']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'all-rights']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['© ', ' BorderBuddy Technologies Inc., All Rights Reserved'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href',
                '#'], ['onclick', 'return!1']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.openModal(core_es5["ɵnov"](_v, 75)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['Privacy'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href',
                '#'], ['onclick', 'return!1']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.openModal(core_es5["ɵnov"](_v, 77)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](null, ['Legal Term'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'who']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, [['Privacy',
                2]], null, 0, null, View_PublicCalculatorV2Component_6)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](0, [['LegalTerm', 2]], null, 0, null, View_PublicCalculatorV2Component_7)), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.showWizard;
        _ck(_v, 9, 0, currVal_1);
        var currVal_3 = !_co.firstPageHide;
        _ck(_v, 33, 0, currVal_3);
        var currVal_4 = !_co.showWizard;
        _ck(_v, 36, 0, currVal_4);
        var currVal_5 = _co.showWizard;
        _ck(_v, 39, 0, currVal_5);
        var currVal_6 = false;
        _ck(_v, 46, 0, currVal_6);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isQuotePage;
        _ck(_v, 2, 0, currVal_0);
        var currVal_2 = _co.isQuotePage;
        _ck(_v, 22, 0, currVal_2);
        var currVal_7 = _co.currentYear;
        _ck(_v, 57, 0, currVal_7);
    });
}
function View_PublicCalculatorV2Component_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'public-calculator-v2', [], null, null, null, View_PublicCalculatorV2Component_0, RenderType_PublicCalculatorV2Component)), core_es5["ɵdid"](114688, null, 0, public_calculator_v2_component_PublicCalculatorV2Component, [router_es5["n" /* Router */], router_es5["a" /* ActivatedRoute */], bs_modal_service["a" /* BsModalService */], google_tag_service["a" /* GoogleTagService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var PublicCalculatorV2ComponentNgFactory = core_es5["ɵccf"]('public-calculator-v2', public_calculator_v2_component_PublicCalculatorV2Component, View_PublicCalculatorV2Component_Host_0, { order: 'order',
    mainElement: 'mainElement' }, { restoreOrder: 'restoreOrder' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=public-calculator-v2.component.ngfactory.js.map
// EXTERNAL MODULE: ./app/objects/extraData/extraDataSearchRequest.ts
var extraDataSearchRequest = __webpack_require__("BRKd");

// CONCATENATED MODULE: ./app/components/calculator/public/public-calculator.component.ts
/**
 * Created by vlad.p on 10/13/2017.
 */









var public_calculator_component_PublicCalculatorComponent = /** @class */ (function () {
    function PublicCalculatorComponent(renderer, route, orderService, extraDataService, router) {
        this.renderer = renderer;
        this.route = route;
        this.orderService = orderService;
        this.extraDataService = extraDataService;
        this.router = router;
        this.order = new orders_order["a" /* Order */]();
        this.extraData = new extraData_extraData["a" /* ExtraData */]();
        this.isV2 = false;
    }
    PublicCalculatorComponent.prototype.ngOnInit = function () {
        if (this.route.snapshot.data.order != null) {
            this.order = this.route.snapshot.data.order.Data;
            this.order.CalculatorType = calculatorHelper["a" /* CalculatorHelper */].getCalculatorType(this.order.Locations);
        }
        if (this.route.snapshot.data.extraData != null && this.route.snapshot.data.extraData.Data != null) {
            var marketings = this.route.snapshot.data.extraData.Data.filter(function (x) { return x.Name == 'marketing text'; });
            marketings.sort(function (e1, e2) {
                return new Date(e1.Created).getTime() - new Date(e2.Created).getTime();
            });
            var extr = marketings[0];
            if (extr)
                this.extraData = extr;
        }
        if (this.router.url.includes('/calculator2/public'))
            this.isV2 = true;
        this.getExtraData();
    };
    PublicCalculatorComponent.prototype.ngAfterViewInit = function () {
        if (this.order.Id)
            this.publicCalculator.calculatorWizard.nextTab();
        var spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");
    };
    PublicCalculatorComponent.prototype.getExtraData = function () {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            var response, extr, e_1;
            return tslib_es6["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.order || !this.order.Id || !this.order.Customer || !this.order.Customer.Id)
                            return [2 /*return*/, null];
                        if (this.extraData.Name)
                            return [2 /*return*/, null];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.extraDataService.getByRefIdandRefType(this.order.Customer.Id.toString(), extraDataSearchRequest["c" /* ReferenceType */].Order)];
                    case 2:
                        response = _a.sent();
                        if (!response.Data || response.Data.length == 0)
                            return [2 /*return*/];
                        extr = response.Data.find(function (x) { return x.Name == 'marketing text'; });
                        if (extr)
                            this.extraData = extr;
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PublicCalculatorComponent.prototype.restoreOrder = function (event) {
        if (event) {
            this.order = new orders_order["a" /* Order */]();
        }
    };
    PublicCalculatorComponent.ctorParameters = function () { return [{ type: core_es5["Renderer2"] }, { type: router_es5["a" /* ActivatedRoute */] }, { type: services_orderService["a" /* OrderService */] }, { type: services_extraDataService["a" /* ExtraDataService */] }, { type: router_es5["n" /* Router */] }]; };
    return PublicCalculatorComponent;
}());

//# sourceMappingURL=public-calculator.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/public/public-calculator.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




















var styles_PublicCalculatorComponent = [styles, select2_css_ngstyle_styles, index_css_ngstyle_styles, icons_css_ngstyle_styles,
    material_css_ngstyle_styles, bootstrap_css_ngstyle_styles, datatable_css_ngstyle_styles];
var RenderType_PublicCalculatorComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_PublicCalculatorComponent, data: {} });
function View_PublicCalculatorComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['style',
                'margin-right:15px;margin-left:15px']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'calculator', [], null, null, null, View_CalculatorComponent_0, RenderType_CalculatorComponent)),
        core_es5["ɵdid"](114688, [[2, 4], ['publicCalculator', 4]], 0, calculator_component_CalculatorComponent, [services_orderService["a" /* OrderService */],
            router_es5["a" /* ActivatedRoute */], services_extraDataService["a" /* ExtraDataService */], router_es5["n" /* Router */], publisher_service_PublisherService], { order: [0, 'order'], extraData: [1, 'extraData'], isOrderDetails: [2, 'isOrderDetails'],
            isPublic: [3, 'isPublic'], mainElement: [4, 'mainElement'] }, null),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order;
        var currVal_1 = _co.extraData;
        var currVal_2 = false;
        var currVal_3 = true;
        var currVal_4 = _co.publicPanelRef;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4);
    }, null);
}
function View_PublicCalculatorComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'public-calculator-v2', [], null, [[null, 'restoreOrder']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('restoreOrder' === en)) {
                var pd_0 = (_co.restoreOrder($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_PublicCalculatorV2Component_0, RenderType_PublicCalculatorV2Component)),
        core_es5["ɵdid"](114688, null, 0, public_calculator_v2_component_PublicCalculatorV2Component, [router_es5["n" /* Router */], router_es5["a" /* ActivatedRoute */],
            bs_modal_service["a" /* BsModalService */], google_tag_service["a" /* GoogleTagService */]], { order: [0, 'order'], mainElement: [1,
                'mainElement'] }, { restoreOrder: 'restoreOrder' })], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.order;
        var currVal_1 = _co.publicPanelRef;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_PublicCalculatorComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { publicPanelRef: 0 }), core_es5["ɵqud"](671088640, 2, { publicCalculator: 0 }),
        (_l()(), core_es5["ɵeld"](0, [[1, 0], ['publicPanel', 1]], null, 7, 'div', [['class',
                'wrapper public-calc']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PublicCalculatorComponent_1)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_PublicCalculatorComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.isV2;
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = _co.isV2;
        _ck(_v, 8, 0, currVal_1);
    }, null);
}
function View_PublicCalculatorComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'public-calculator', [], null, null, null, View_PublicCalculatorComponent_0, RenderType_PublicCalculatorComponent)), core_es5["ɵdid"](4308992, null, 0, public_calculator_component_PublicCalculatorComponent, [core_es5["Renderer2"], router_es5["a" /* ActivatedRoute */], services_orderService["a" /* OrderService */], services_extraDataService["a" /* ExtraDataService */], router_es5["n" /* Router */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var PublicCalculatorComponentNgFactory = core_es5["ɵccf"]('public-calculator', public_calculator_component_PublicCalculatorComponent, View_PublicCalculatorComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=public-calculator.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/theme/css/order-payment.css.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var order_payment_css_shim_ngstyle_styles = ['.payment_header[_ngcontent-%COMP%]{background:#e07e3c;padding-top:20px;padding-bottom:20px}.data_wrapper[_ngcontent-%COMP%]{margin-top:30px}.required[_ngcontent-%COMP%]:after{content:" *";color:red}.color-orange[_ngcontent-%COMP%]{color:orange}.name[_ngcontent-%COMP%]{font-family:Montserrat;font-style:normal;font-weight:400;font-size:20px;color:#000}.underline[_ngcontent-%COMP%]{margin:5px 0 0;border-color:#b9b9b9}.file_number[_ngcontent-%COMP%]{border-radius:10px;background:#f0f0f0;color:#464646;padding:25px;font-size:22px;line-height:1.5}.file_number[_ngcontent-%COMP%]   strong[_ngcontent-%COMP%]{color:#313131;font-size:40px}.info_block[_ngcontent-%COMP%]{color:#929292}.info_block[_ngcontent-%COMP%]   .bold[_ngcontent-%COMP%]{color:#000;font-size:16px}.info_block[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]:not(.contacts){display:flex;align-items:center;justify-content:space-between}.contacts[_ngcontent-%COMP%]{margin-top:23px;margin-bottom:23px;font-weight:700;font-size:12px}.card_info_wrapper[_ngcontent-%COMP%], .contacts[_ngcontent-%COMP%]{font-family:Montserrat;font-style:normal}.card_info_wrapper[_ngcontent-%COMP%]{overflow:auto;background:#f0f0f0;height:auto;font-weight:500;font-size:16px;line-height:20px;color:#555;padding:20px}.succ_icon[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:#e07e3c;font-size:5em}.card_info_wrapper[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:14px}.card_info_wrapper[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{color:#46ae4d}.card_info_wrapper[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font-weight:700}form[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding-top:0;padding-bottom:0;margin-top:0;margin-bottom:0}form[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%], form[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{background-image:none}form[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#555}.checkout[_ngcontent-%COMP%]{max-width:500px;margin:0 auto;color:#525252;font-size:1.1rem}.checkout[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-family:Montserrat;font-style:normal;font-weight:400;font-size:12px}.checkout[_ngcontent-%COMP%]   p.contacts[_ngcontent-%COMP%]{font-weight:700}.checkout[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:12px 37px;color:#fff;border:none;margin-top:1rem;font-weight:700;background:#e07e3c;box-shadow:0 4px 4px rgba(0,0,0,.11);border-radius:54px;font-size:16px}.checkout[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-weight:700;font-family:Montserrat;font-size:16px}.submit-btn-block[_ngcontent-%COMP%]{text-align:right}.StripeElement[_ngcontent-%COMP%], form[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{margin:1rem 0;background-color:#fff;padding:8px 12px;border-radius:2px;border:1px solid #b9bbbf}.StripeElement--focus[_ngcontent-%COMP%]{box-shadow:0 1px 3px 0 #cfd7df}.StripeElement--invalid[_ngcontent-%COMP%]{border-color:#fa755a}.StripeElement--webkit-autofill[_ngcontent-%COMP%]{background-color:#fefde5!important}.loader.order_payment_loader[_ngcontent-%COMP%]{color:#e07e3c}#card-errors[_ngcontent-%COMP%]{color:red;font-weight:700;font-size:14px}select.order-payment-select[_ngcontent-%COMP%]{height:40px;margin:10px 0;padding:8px 12px;border-color:#b9bbbf}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvdGhlbWUvY3NzL29yZGVyLXBheW1lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL3RoZW1lL2Nzcy9vcmRlci1wYXltZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=order-payment.css.shim.ngstyle.js.map
// EXTERNAL MODULE: ./node_modules/rxjs/operators.js
var operators = __webpack_require__("W+Sr");
var operators_default = /*#__PURE__*/__webpack_require__.n(operators);

// EXTERNAL MODULE: ./app/objects/payment/paymentCompany.ts
var paymentCompany = __webpack_require__("41dP");

// CONCATENATED MODULE: ./app/components/calculator/public/mobile/order-payment/order-payment.component.ts

















var order_payment_component_OrderPaymentComponent = /** @class */ (function () {
    function OrderPaymentComponent(renderer, route, cdr, configService, paymentService, customService, emailService, locationService) {
        this.renderer = renderer;
        this.route = route;
        this.cdr = cdr;
        this.configService = configService;
        this.paymentService = paymentService;
        this.customService = customService;
        this.emailService = emailService;
        this.locationService = locationService;
        this.order = new orders_order["a" /* Order */]();
        this.cardHandler = this.onChange.bind(this);
        this.showNextStep = false;
        this.isHaveBeenPayed = false;
        this.showLoader = false;
        this.showPayPalLoader = false;
        this.payPalRequestFailed = false;
        this.isSecondTry = false;
        this.stateSelectData$ = new BehaviorSubject["BehaviorSubject"]([]);
        this.cancelableSubject$ = new Subject["Subject"]();
        this.paymentCompany = this.route.snapshot.queryParams['paycom'];
        var key = this.configService.config.CanadaStripeKey;
        if (this.paymentCompany == paymentCompany["a" /* PaymentCompany */].NexGen)
            key = this.configService.config.USAStripeKey;
        this.stripe = Stripe(key);
        this.elements = this.stripe.elements();
        this.order.Currency = new canadianCurrencyCode["a" /* CanadianCurrencyCode */]();
        this.order.Totals = new orders_order["b" /* SimpleOrderTotal */]();
    }
    Object.defineProperty(OrderPaymentComponent.prototype, "firstName", {
        get: function () { return this.checkoutForm.get('firstName'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderPaymentComponent.prototype, "lastName", {
        get: function () { return this.checkoutForm.get('lastName'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderPaymentComponent.prototype, "company", {
        get: function () { return this.checkoutForm.get('company'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderPaymentComponent.prototype, "addressLineOne", {
        get: function () { return this.checkoutForm.get('addressLineOne'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderPaymentComponent.prototype, "addressLineTwo", {
        get: function () { return this.checkoutForm.get('addressLineTwo'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderPaymentComponent.prototype, "city", {
        get: function () { return this.checkoutForm.get('city'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderPaymentComponent.prototype, "state", {
        get: function () { return this.checkoutForm.get('state'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderPaymentComponent.prototype, "country", {
        get: function () { return this.checkoutForm.get('country'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderPaymentComponent.prototype, "phoneNumber", {
        get: function () { return this.checkoutForm.get('phone'); },
        enumerable: true,
        configurable: true
    });
    OrderPaymentComponent.prototype.ngOnInit = function () {
        var _this = this;
        var email = this.route.snapshot.queryParams['email'];
        this.userId = this.route.snapshot.queryParams['c'];
        this.showCustomerData = this.userId == 0;
        var emailTypeParam = this.route.snapshot.queryParams['emailtype'];
        this.amount = this.route.snapshot.queryParams['am'];
        this.currencyCode = this.route.snapshot.queryParams['ccode'];
        this.fileNumber = this.route.snapshot.queryParams['fn'];
        this.agentUserId = this.route.snapshot.queryParams['an'];
        this.agentUserEmail = this.route.snapshot.queryParams['ane'];
        this.isPayPal = this.route.snapshot.queryParams['pp'] == "1";
        this.cargoWiseOrganizationCode = this.route.snapshot.queryParams['cwoc'];
        this.pipedriveId = this.route.snapshot.queryParams['pipedriveid'];
        this.pipedriveDealId = this.route.snapshot.queryParams['pipedrivedealid'];
        this.isSecondTry = emailTypeParam == emailTemplateType["a" /* EmailTemplateType */].CreditCardDontWork;
        this.checkoutForm = new forms_es5["FormGroup"]({
            firstName: new forms_es5["FormControl"](undefined, [forms_es5["Validators"].required]),
            lastName: new forms_es5["FormControl"](undefined, [forms_es5["Validators"].required]),
            company: new forms_es5["FormControl"](undefined, [forms_es5["Validators"].maxLength(49)]),
            phone: new forms_es5["FormControl"](undefined, [forms_es5["Validators"].required]),
            addressLineOne: new forms_es5["FormControl"](undefined, [forms_es5["Validators"].required]),
            addressLineTwo: new forms_es5["FormControl"](),
            city: new forms_es5["FormControl"](),
            state: new forms_es5["FormControl"](),
            country: new forms_es5["FormControl"]()
        });
        this.customService.getCustomerPayDataById(this.userId).then(function (resp) {
            if (resp.Success) {
                _this.firstName.setValue(resp.Data.FirstName, resp.Data.LastName);
                _this.lastName.setValue(resp.Data.LastName);
                _this.company.setValue(resp.Data.CompanyName);
                _this.addressLineOne.setValue(resp.Data.AddressLine1);
                _this.addressLineTwo.setValue(resp.Data.AddressLine2);
                _this.city.setValue(resp.Data.City);
                _this.state.setValue(resp.Data.State);
                _this.country.setValue(resp.Data.Country);
                _this.phoneNumber.setValue(resp.Data.Phone);
                _this.name = _this.getFullName(resp.Data.FirstName, resp.Data.LastName);
                _this.email = resp.Data.Email;
                _this.cdr.detectChanges();
            }
        }, function (reason) {
            console.log(reason);
        });
    };
    OrderPaymentComponent.prototype.initGApi = function () {
        var _this = this;
        var baseScriptUrl = "https://maps.googleapis.com/maps/api/js?key=" + this.configService.config.GoogleApiKey;
        var head = document.getElementsByTagName('head')[0];
        var scripts = document.getElementsByTagName('script');
        // tslint:disable-next-line:prefer-for-of
        for (var i = 0; i < scripts.length; i++) {
            if (scripts[i].src.startsWith(baseScriptUrl)) {
                this.initSearchBox();
                return;
            }
        }
        var node = document.createElement('script');
        node.src = baseScriptUrl + "&libraries=places&language=en";
        node.type = 'text/javascript';
        node.charset = 'utf-8';
        head.appendChild(node);
        node.onload = function () {
            _this.initSearchBox();
        };
    };
    OrderPaymentComponent.prototype.initSearchBox = function () {
        var _this = this;
        this.addressLineOneInput = document.getElementById('pac-input');
        this.addressOneSearchBox = new google.maps.places.SearchBox(this.addressLineOneInput);
        this.addressOneSearchBox.addListener('places_changed', function () {
            _this.fillPlaces();
            _this.validationError = null;
        });
    };
    OrderPaymentComponent.prototype.fillPlaces = function () {
        var places = this.addressOneSearchBox.getPlaces();
        if (places.length == 0) {
            return;
        }
        var locality, administrative_area_level_1, administrative_area_level_2, country;
        var place = places[0];
        place.address_components.forEach(function (component) {
            if (component.types.indexOf("locality") > -1) {
                locality = component.short_name;
            }
            else if (component.types.indexOf("administrative_area_level_1") > -1) {
                administrative_area_level_1 = component.short_name;
            }
            else if (component.types.indexOf("administrative_area_level_2") > -1) {
                administrative_area_level_2 = component.short_name;
            }
            else if (component.types.indexOf("country") > -1) {
                country = component.short_name;
            }
        });
        this.city.setValue(locality);
        this.country.setValue(null);
        this.state.setValue(null);
        this.currentStates = [];
        var matchingCountry = this.countryStates.find(function (x) { return x.Code == country || x.Name == country; });
        if (matchingCountry) {
            this.country.setValue(matchingCountry.Name);
            this.currentStates = this.countryStates.find(function (x) { return x.Name == matchingCountry.Name; }).States;
        }
        this.updateStateSelectData();
        var state = administrative_area_level_1 || administrative_area_level_2;
        var matchingState = this.currentStates.find(function (x) { return x.Code == state || x.Description == state; });
        if (matchingState) {
            this.state.setValue(matchingState.Description);
        }
        if (this.addressLineOneInput) {
            var addressInputValue = this.addressLineOneInput.value;
            if (matchingCountry) {
                addressInputValue = addressInputValue.replace(", " + matchingCountry.Code, '')
                    .replace(", " + matchingCountry.Name, '');
            }
            if (matchingState) {
                addressInputValue = addressInputValue.replace(", " + matchingState.Code, '')
                    .replace(", " + matchingState.Description, '');
            }
            if (this.city.value) {
                addressInputValue = addressInputValue.replace(", " + this.city.value, '');
            }
            this.addressLineOne.setValue(addressInputValue);
        }
    };
    OrderPaymentComponent.prototype.getFullName = function (FirstName, LastName) {
        var fullName = FirstName && LastName ? FirstName + " " + LastName : FirstName ? FirstName : "";
        return fullName;
    };
    OrderPaymentComponent.prototype.ngAfterViewInit = function () {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            var _this = this;
            var spinner, countryStates, canada, usa;
            return tslib_es6["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        spinner = document.getElementById("spinner");
                        this.renderer.addClass(spinner, "hide");
                        scrollHelper_ScrollHelper.forceSetVerticalScroll(document.getElementsByTagName('body')[0]);
                        if (this.isPayPal) {
                            setTimeout(function (x) {
                                _this.sendPayPalPaymentRequest(_this.userId);
                            }, 200);
                            return [2 /*return*/];
                        }
                        this.card = this.elements.create('card');
                        this.card.mount(this.cardInfo.nativeElement);
                        this.card.addEventListener('change', this.cardHandler);
                        this.initGApi();
                        this.stateSelectData$.pipe(Object(operators["takeUntil"])(this.cancelableSubject$)).subscribe(function () { return _this.cdr.detectChanges(); });
                        return [4 /*yield*/, this.locationService.getCountryStates()];
                    case 1:
                        countryStates = (_a.sent()).Data;
                        canada = countryStates.find(function (x) { return x.Code == 'CA'; });
                        usa = countryStates.find(function (x) { return x.Code == 'US'; });
                        this.countryStates = [canada, usa].concat(countryStates.filter(function (x) { return x.Code != 'CA' && x.Code != 'US'; }));
                        this.countrySelectData = this.countryStates.map(function (x) { return x.Name; });
                        this.country.setValue(null);
                        this.state.setValue(null);
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderPaymentComponent.prototype.onCountryChange = function (val) {
        this.currentStates = this.countryStates.find(function (x) { return x.Name == val; }).States;
        this.updateStateSelectData();
        this.state.setValue(null);
    };
    OrderPaymentComponent.prototype.updateStateSelectData = function () {
        if (this.currentStates) {
            this.stateSelectData$.next(this.currentStates.map(function (x) { return x.Description; }).sort());
        }
        else {
            this.stateSelectData$.next([]);
        }
    };
    OrderPaymentComponent.prototype.ngOnDestroy = function () {
        this.cancelableSubject$.next(true);
        this.card.removeEventListener('change', this.cardHandler);
        this.card.destroy();
    };
    OrderPaymentComponent.prototype.onChange = function (error) {
        if (error) {
            this.error = error.message;
        }
        else {
            this.error = null;
        }
        this.cdr.detectChanges();
    };
    OrderPaymentComponent.prototype.sendPayPalPaymentRequest = function (customerId) {
        var _this = this;
        this.showPayPalLoader = true;
        this.payPalRequestFailed = false;
        this.emailService.sendPayPalPaymentRequest(customerId).then(function (resp) {
            _this.showPayPalLoader = false;
            _this.payPalRequestIsSent = true;
            if (!resp.Success) {
                _this.payPalRequestFailed = true;
            }
        }).catch(function (resp) {
            _this.showPayPalLoader = false;
            _this.payPalRequestIsSent = true;
            _this.payPalRequestFailed = true;
        });
    };
    OrderPaymentComponent.prototype.onSubmit = function () {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            var _this = this;
            return tslib_es6["d" /* __generator */](this, function (_a) {
                this.error = null;
                if (!this.checkoutForm.valid) {
                    this.error = "Please fill in the required fields";
                    return [2 /*return*/];
                }
                if (!this.country.value) {
                    this.validationError = "You must select address from dropdown menu in Address field";
                    return [2 /*return*/];
                }
                this.showLoader = true;
                this.stripe.createPaymentMethod({
                    type: 'card',
                    card: this.card,
                    billing_details: { name: this.firstName.value + " " + this.lastName.value, email: this.email, phone: this.phoneNumber.value }
                }).then(function (result) {
                    if (result.error) {
                        _this.showLoader = false;
                        _this.error = result.error.message;
                    }
                    else {
                        var country = _this.countryStates.find(function (i) { return i.Name.toLowerCase() == _this.country.value.toLowerCase(); });
                        var stateCode = _this.state.value ? country.States.find(function (i) { return i.Description.toLowerCase() == _this.state.value.toLowerCase(); }).Code : '';
                        _this.paymentService.save({
                            paymentMethodId: result.paymentMethod.id,
                            CustomerId: _this.userId,
                            PaymentCompany: _this.paymentCompany,
                            FirstName: _this.firstName.value,
                            LastName: _this.lastName.value,
                            CompanyName: _this.company.value,
                            AddressLine1: _this.addressLineOne.value,
                            AddressLine2: _this.addressLineTwo.value,
                            City: _this.city.value,
                            State: _this.state.value,
                            StateCode: stateCode,
                            PostalCode: result.paymentMethod.billing_details.address.postal_code,
                            Country: _this.country.value,
                            CountryCode: country.Code,
                            CargoWiseOrganizationCode: _this.cargoWiseOrganizationCode,
                            PipedriveId: _this.pipedriveId,
                            PipedriveDealId: _this.pipedriveDealId,
                            AgentUserId: _this.agentUserId,
                            AgentUserEmail: _this.agentUserEmail,
                            Phone: _this.phoneNumber.value
                        }).then(function (responce) {
                            if (_this.isSecondTry) {
                                _this.paymentService.pay(_this.fileNumber, parseFloat(_this.amount), _this.currencyCode, _this.userId, _this.agentUserId, _this.agentUserEmail, _this.paymentCompany).then(function (resp) {
                                    _this.isHaveBeenPayed = true;
                                }, function (rej) {
                                    _this.error = rej.Data.Message;
                                });
                            }
                            else {
                                _this.showNextStep = true;
                            }
                        }, function (reject) {
                            _this.showLoader = false;
                            if (reject.Errors && reject.Errors.length > 0) {
                                _this.error = reject.Errors[0].Value;
                            }
                            else if (reject.Data && reject.Data.Message) {
                                _this.error = reject.Data.Message;
                            }
                            else {
                                _this.error = "An error has occured";
                            }
                            _this.cdr.detectChanges();
                        });
                    }
                }, function (reject) {
                    _this.showLoader = false;
                    console.log(reject);
                });
                return [2 /*return*/];
            });
        });
    };
    OrderPaymentComponent.ctorParameters = function () { return [{ type: core_es5["Renderer2"] }, { type: router_es5["a" /* ActivatedRoute */] }, { type: core_es5["ChangeDetectorRef"] }, { type: services_configService["a" /* ConfigService */] }, { type: services_paymentService["a" /* PaymentService */] }, { type: services_customerService["a" /* CustomerService */] }, { type: services_emailService["a" /* EmailService */] }, { type: services_locationService["a" /* LocationService */] }]; };
    return OrderPaymentComponent;
}());

//# sourceMappingURL=order-payment.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/calculator/public/mobile/order-payment/order-payment.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */












var styles_OrderPaymentComponent = [order_payment_css_shim_ngstyle_styles];
var RenderType_OrderPaymentComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_OrderPaymentComponent, data: {} });
function View_OrderPaymentComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-xs-12 col-md-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'succ_icon text-center margin-50']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' check_circle '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h1', [['class', 'text-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Payment Success'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_OrderPaymentComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['File #']))], null, null);
}
function View_OrderPaymentComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['Quote #']))], null, null);
}
function View_OrderPaymentComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class',
                'file_number']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_4)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_5)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'br', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'strong', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isSecondTry;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = !_co.isSecondTry;
        _ck(_v, 5, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.fileNumber;
        _ck(_v, 10, 0, currVal_2);
    });
}
function View_OrderPaymentComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['Amount to be charged now:']))], null, null);
}
function View_OrderPaymentComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['Estimated future charges:']))], null, null);
}
function View_OrderPaymentComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 11, 'p', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_7)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [['class', 'bold']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), core_es5["ɵppd"](3),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isSecondTry;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = !_co.isSecondTry;
        _ck(_v, 6, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = core_es5["ɵunv"](_v, 9, 0, _ck(_v, 10, 0, core_es5["ɵnov"](_v.parent.parent, 0), _co.amount, _co.currencyCode, true));
        _ck(_v, 9, 0, currVal_2);
    });
}
function View_OrderPaymentComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, 'p', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Currency:'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'bold']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.currencyCode;
        _ck(_v, 6, 0, currVal_0);
    });
}
function View_OrderPaymentComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['Please complete payment by entering you credit card information.']))], null, null);
}
function View_OrderPaymentComponent_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, ['Please complete this form in order to pre-authorize your card. No charges are being applied at this time.']))], null, null);
}
function View_OrderPaymentComponent_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' First Name is required ']))], null, null);
}
function View_OrderPaymentComponent_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'alert alert-danger']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_14)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.firstName.errors.required;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_OrderPaymentComponent_16(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' Last Name is required ']))], null, null);
}
function View_OrderPaymentComponent_15(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'alert alert-danger']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_16)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.lastName.errors.required;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_OrderPaymentComponent_18(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' Phone is required ']))], null, null);
}
function View_OrderPaymentComponent_17(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'alert alert-danger']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_18)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.phoneNumber.errors.required;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_OrderPaymentComponent_20(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' Company name should be less than 50 digits ']))], null, null);
}
function View_OrderPaymentComponent_19(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'alert alert-danger']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_20)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.company.errors.maxlength;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_OrderPaymentComponent_22(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' Address is required ']))], null, null);
}
function View_OrderPaymentComponent_21(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'alert alert-danger']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_22)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.addressLineOne.errors.required;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_OrderPaymentComponent_23(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'option', [], null, null, null, null, null)), core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"], core_es5["Renderer2"], [2, forms_es5["SelectControlValueAccessor"]]], null, null), core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"],
            core_es5["Renderer2"], [8, null]], null, null), (_l()(), core_es5["ɵted"](null, [' ', ' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_OrderPaymentComponent_24(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'option', [], null, null, null, null, null)), core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"], core_es5["Renderer2"], [2, forms_es5["SelectControlValueAccessor"]]], { ngValue: [0, 'ngValue'] }, null), core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], { ngValue: [0, 'ngValue'] }, null),
        (_l()(), core_es5["ɵted"](null, [' ', ' ']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_OrderPaymentComponent_25(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['id', 'card-errors'],
            ['role', 'alert']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.error;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OrderPaymentComponent_26(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class', 'alert alert-danger']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' '])),
        (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.validationError;
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_OrderPaymentComponent_27(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'loader order_payment_loader']], null, null, null, null, null))], null, null);
}
function View_OrderPaymentComponent_28(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'button', [['type',
                'submit']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Submit']))], null, null);
}
function View_OrderPaymentComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 233, 'div', [['class',
                'col-xs-12 col-md-8']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 230, 'div', [['class', 'card_info_wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 227, 'form', [['class', 'checkout'],
            ['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 6).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 6).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('submit' === en)) {
                var pd_2 = (_co.onSubmit() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](540672, null, 0, forms_es5["FormGroupDirective"], [[8, null], [8, null]], { form: [0, 'form'] }, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["FormGroupDirective"]]),
        core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 220, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'div', [['class',
                'col-xs-12 title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [['class', 'steps']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'strong', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Step 1 of 2'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h2', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Sign up here.'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_11)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_12)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h5', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Card information'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 17, 'div', [['class', 'form-row col-xs-12 form-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'required'], ['for', 'firstName']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['First Name'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'input', [['class', 'form-control'], ['formControlName',
                'firstName'], ['id', 'firstName'], ['name', 'firstName'], ['required', ''],
            ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 40)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 40).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 40)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 40)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 43).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_13)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'form-row col-xs-12 form-group']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'required'], ['for',
                    'lastName']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Last Name'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'input', [['class', 'form-control'], ['formControlName', 'lastName'], ['id',
                'lastName'], ['name', 'lastName'], ['required', ''], ['type', 'text']], [[1,
                'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 59)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 59).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 59)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 59)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 62).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_15)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'form-row col-xs-12 form-group']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'required'], ['for',
                    'phoneNumber']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Phone'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'input', [['class',
                'form-control'], ['formControlName', 'phone'], ['id', 'phoneNumber'], ['name',
                'phone'], ['required', ''], ['type', 'text']], [[1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 78)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 78).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 78)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 78)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 81).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_17)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'form-row col-xs-12 form-group']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 3, 'label', [['for', 'company']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Company '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'small', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['(Please provide this only if you are importing under the company name)'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'input', [['formControlName', 'company'], ['id', 'company'], ['name', 'company'],
            ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 99)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 99).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 99)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 99)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 100).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"],
            core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_19)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'form-row col-xs-12 form-group']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'label', [['class', 'required'], ['for',
                    'pac-input']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Address'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'input', [['formControlName', 'addressLineOne'], ['id', 'pac-input'], ['name',
                'addressLineOne'], ['placeholder', 'Address...'], ['required', ''], ['type',
                'text']], [[1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'input'], [null, 'blur'],
            [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 116)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 116).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 116)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 116)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 119).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_21)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'form-row col-xs-12 form-group']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'label', [['for', 'address-line-two']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Apt, unit, etc., #'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'input', [['formControlName',
                'addressLineTwo'], ['id', 'address-line-two'], ['name', 'addressLineTwo'], ['type',
                'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 135)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 135).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 135)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 135)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 136).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"],
            core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'form-row col-xs-12 form-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['for', 'city']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['City'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'input', [['formControlName',
                'city'], ['id', 'city'], ['name', 'city'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 149)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 149).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 149)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 149)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 150).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"],
            core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'form-row col-xs-12 form-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['for', 'country']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Country'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'select', [['class', 'order-payment-select'], ['formControlName', 'country']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 163).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 163).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('change' === en)) {
                var pd_2 = (_co.onCountryChange($event.target.value) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'option', [['disabled',
                'disabled']], null, null, null, null, null)),
        core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"], core_es5["Renderer2"],
            [2, forms_es5["SelectControlValueAccessor"]]], { ngValue: [0, 'ngValue'] }, null),
        core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], { ngValue: [0, 'ngValue'] }, null), (_l()(), core_es5["ɵted"](null, ['Choose country'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_23)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 21, 'div', [['class', 'form-row col-xs-12 form-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['for', 'state']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['State / Province'])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 15, 'select', [['class', 'order-payment-select'], ['formControlName', 'state']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 185).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 185).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["SelectControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["SelectControlValueAccessor"]]), core_es5["ɵdid"](671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'option', [['disabled',
                'disabled']], null, null, null, null, null)),
        core_es5["ɵdid"](147456, null, 0, forms_es5["NgSelectOption"], [core_es5["ElementRef"], core_es5["Renderer2"],
            [2, forms_es5["SelectControlValueAccessor"]]], { ngValue: [0, 'ngValue'] }, null),
        core_es5["ɵdid"](147456, null, 0, forms_es5["ɵq"], [core_es5["ElementRef"], core_es5["Renderer2"], [8, null]], { ngValue: [0, 'ngValue'] }, null), (_l()(), core_es5["ɵted"](null, ['Choose state / province'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 2, null, View_OrderPaymentComponent_24)), core_es5["ɵdid"](802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), core_es5["ɵpid"](131072, common_es5["AsyncPipe"], [core_es5["ChangeDetectorRef"]]),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 9, 'div', [['class', 'form-row col-xs-12 form-group']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'label', [['for',
                'card-info']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Card Info'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, [[1, 0], ['cardInfo', 1]], null, 0, 'div', [['id',
                'card-info']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_25)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_26)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-12 title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['We will use this credit card for all transactions moving forward unless you request to change. A 4% fee will be applied to payments made by credit card.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-xs-12 submit-btn-block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_27)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_28)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.checkoutForm;
        _ck(_v, 6, 0, currVal_7);
        var currVal_8 = _co.isSecondTry;
        _ck(_v, 22, 0, currVal_8);
        var currVal_9 = !_co.isSecondTry;
        _ck(_v, 25, 0, currVal_9);
        var currVal_18 = '';
        _ck(_v, 41, 0, currVal_18);
        var currVal_19 = 'firstName';
        _ck(_v, 45, 0, currVal_19);
        var currVal_20 = (_co.firstName.invalid && ((_co.error || _co.firstName.dirty) || _co.firstName.touched));
        _ck(_v, 50, 0, currVal_20);
        var currVal_29 = '';
        _ck(_v, 60, 0, currVal_29);
        var currVal_30 = 'lastName';
        _ck(_v, 64, 0, currVal_30);
        var currVal_31 = (_co.lastName.invalid && ((_co.error || _co.lastName.dirty) || _co.lastName.touched));
        _ck(_v, 69, 0, currVal_31);
        var currVal_40 = '';
        _ck(_v, 79, 0, currVal_40);
        var currVal_41 = 'phone';
        _ck(_v, 83, 0, currVal_41);
        var currVal_42 = (_co.phoneNumber.invalid && ((_co.error || _co.phoneNumber.dirty) || _co.phoneNumber.touched));
        _ck(_v, 88, 0, currVal_42);
        var currVal_50 = 'company';
        _ck(_v, 102, 0, currVal_50);
        var currVal_51 = (_co.company.invalid && ((_co.error || _co.company.dirty) || _co.company.touched));
        _ck(_v, 107, 0, currVal_51);
        var currVal_60 = '';
        _ck(_v, 117, 0, currVal_60);
        var currVal_61 = 'addressLineOne';
        _ck(_v, 121, 0, currVal_61);
        var currVal_62 = (_co.addressLineOne.invalid && ((_co.error || _co.addressLineOne.dirty) || _co.addressLineOne.touched));
        _ck(_v, 126, 0, currVal_62);
        var currVal_70 = 'addressLineTwo';
        _ck(_v, 138, 0, currVal_70);
        var currVal_78 = 'city';
        _ck(_v, 152, 0, currVal_78);
        var currVal_86 = 'country';
        _ck(_v, 165, 0, currVal_86);
        var currVal_87 = null;
        _ck(_v, 170, 0, currVal_87);
        var currVal_88 = null;
        _ck(_v, 171, 0, currVal_88);
        var currVal_89 = _co.countrySelectData;
        _ck(_v, 175, 0, currVal_89);
        var currVal_97 = 'state';
        _ck(_v, 187, 0, currVal_97);
        var currVal_98 = null;
        _ck(_v, 192, 0, currVal_98);
        var currVal_99 = null;
        _ck(_v, 193, 0, currVal_99);
        var currVal_100 = core_es5["ɵunv"](_v, 197, 0, core_es5["ɵnov"](_v, 198).transform(_co.stateSelectData$));
        _ck(_v, 197, 0, currVal_100);
        var currVal_101 = _co.error;
        _ck(_v, 210, 0, currVal_101);
        var currVal_102 = _co.validationError;
        _ck(_v, 214, 0, currVal_102);
        var currVal_103 = _co.showLoader;
        _ck(_v, 225, 0, currVal_103);
        var currVal_104 = !_co.showLoader;
        _ck(_v, 228, 0, currVal_104);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_10 = (core_es5["ɵnov"](_v, 41).required ? '' : null);
        var currVal_11 = core_es5["ɵnov"](_v, 47).ngClassUntouched;
        var currVal_12 = core_es5["ɵnov"](_v, 47).ngClassTouched;
        var currVal_13 = core_es5["ɵnov"](_v, 47).ngClassPristine;
        var currVal_14 = core_es5["ɵnov"](_v, 47).ngClassDirty;
        var currVal_15 = core_es5["ɵnov"](_v, 47).ngClassValid;
        var currVal_16 = core_es5["ɵnov"](_v, 47).ngClassInvalid;
        var currVal_17 = core_es5["ɵnov"](_v, 47).ngClassPending;
        _ck(_v, 39, 0, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17);
        var currVal_21 = (core_es5["ɵnov"](_v, 60).required ? '' : null);
        var currVal_22 = core_es5["ɵnov"](_v, 66).ngClassUntouched;
        var currVal_23 = core_es5["ɵnov"](_v, 66).ngClassTouched;
        var currVal_24 = core_es5["ɵnov"](_v, 66).ngClassPristine;
        var currVal_25 = core_es5["ɵnov"](_v, 66).ngClassDirty;
        var currVal_26 = core_es5["ɵnov"](_v, 66).ngClassValid;
        var currVal_27 = core_es5["ɵnov"](_v, 66).ngClassInvalid;
        var currVal_28 = core_es5["ɵnov"](_v, 66).ngClassPending;
        _ck(_v, 58, 0, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28);
        var currVal_32 = (core_es5["ɵnov"](_v, 79).required ? '' : null);
        var currVal_33 = core_es5["ɵnov"](_v, 85).ngClassUntouched;
        var currVal_34 = core_es5["ɵnov"](_v, 85).ngClassTouched;
        var currVal_35 = core_es5["ɵnov"](_v, 85).ngClassPristine;
        var currVal_36 = core_es5["ɵnov"](_v, 85).ngClassDirty;
        var currVal_37 = core_es5["ɵnov"](_v, 85).ngClassValid;
        var currVal_38 = core_es5["ɵnov"](_v, 85).ngClassInvalid;
        var currVal_39 = core_es5["ɵnov"](_v, 85).ngClassPending;
        _ck(_v, 77, 0, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39);
        var currVal_43 = core_es5["ɵnov"](_v, 104).ngClassUntouched;
        var currVal_44 = core_es5["ɵnov"](_v, 104).ngClassTouched;
        var currVal_45 = core_es5["ɵnov"](_v, 104).ngClassPristine;
        var currVal_46 = core_es5["ɵnov"](_v, 104).ngClassDirty;
        var currVal_47 = core_es5["ɵnov"](_v, 104).ngClassValid;
        var currVal_48 = core_es5["ɵnov"](_v, 104).ngClassInvalid;
        var currVal_49 = core_es5["ɵnov"](_v, 104).ngClassPending;
        _ck(_v, 98, 0, currVal_43, currVal_44, currVal_45, currVal_46, currVal_47, currVal_48, currVal_49);
        var currVal_52 = (core_es5["ɵnov"](_v, 117).required ? '' : null);
        var currVal_53 = core_es5["ɵnov"](_v, 123).ngClassUntouched;
        var currVal_54 = core_es5["ɵnov"](_v, 123).ngClassTouched;
        var currVal_55 = core_es5["ɵnov"](_v, 123).ngClassPristine;
        var currVal_56 = core_es5["ɵnov"](_v, 123).ngClassDirty;
        var currVal_57 = core_es5["ɵnov"](_v, 123).ngClassValid;
        var currVal_58 = core_es5["ɵnov"](_v, 123).ngClassInvalid;
        var currVal_59 = core_es5["ɵnov"](_v, 123).ngClassPending;
        _ck(_v, 115, 0, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56, currVal_57, currVal_58, currVal_59);
        var currVal_63 = core_es5["ɵnov"](_v, 140).ngClassUntouched;
        var currVal_64 = core_es5["ɵnov"](_v, 140).ngClassTouched;
        var currVal_65 = core_es5["ɵnov"](_v, 140).ngClassPristine;
        var currVal_66 = core_es5["ɵnov"](_v, 140).ngClassDirty;
        var currVal_67 = core_es5["ɵnov"](_v, 140).ngClassValid;
        var currVal_68 = core_es5["ɵnov"](_v, 140).ngClassInvalid;
        var currVal_69 = core_es5["ɵnov"](_v, 140).ngClassPending;
        _ck(_v, 134, 0, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67, currVal_68, currVal_69);
        var currVal_71 = core_es5["ɵnov"](_v, 154).ngClassUntouched;
        var currVal_72 = core_es5["ɵnov"](_v, 154).ngClassTouched;
        var currVal_73 = core_es5["ɵnov"](_v, 154).ngClassPristine;
        var currVal_74 = core_es5["ɵnov"](_v, 154).ngClassDirty;
        var currVal_75 = core_es5["ɵnov"](_v, 154).ngClassValid;
        var currVal_76 = core_es5["ɵnov"](_v, 154).ngClassInvalid;
        var currVal_77 = core_es5["ɵnov"](_v, 154).ngClassPending;
        _ck(_v, 148, 0, currVal_71, currVal_72, currVal_73, currVal_74, currVal_75, currVal_76, currVal_77);
        var currVal_79 = core_es5["ɵnov"](_v, 167).ngClassUntouched;
        var currVal_80 = core_es5["ɵnov"](_v, 167).ngClassTouched;
        var currVal_81 = core_es5["ɵnov"](_v, 167).ngClassPristine;
        var currVal_82 = core_es5["ɵnov"](_v, 167).ngClassDirty;
        var currVal_83 = core_es5["ɵnov"](_v, 167).ngClassValid;
        var currVal_84 = core_es5["ɵnov"](_v, 167).ngClassInvalid;
        var currVal_85 = core_es5["ɵnov"](_v, 167).ngClassPending;
        _ck(_v, 162, 0, currVal_79, currVal_80, currVal_81, currVal_82, currVal_83, currVal_84, currVal_85);
        var currVal_90 = core_es5["ɵnov"](_v, 189).ngClassUntouched;
        var currVal_91 = core_es5["ɵnov"](_v, 189).ngClassTouched;
        var currVal_92 = core_es5["ɵnov"](_v, 189).ngClassPristine;
        var currVal_93 = core_es5["ɵnov"](_v, 189).ngClassDirty;
        var currVal_94 = core_es5["ɵnov"](_v, 189).ngClassValid;
        var currVal_95 = core_es5["ɵnov"](_v, 189).ngClassInvalid;
        var currVal_96 = core_es5["ɵnov"](_v, 189).ngClassPending;
        _ck(_v, 184, 0, currVal_90, currVal_91, currVal_92, currVal_93, currVal_94, currVal_95, currVal_96);
    });
}
function View_OrderPaymentComponent_29(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 25, 'div', [['class',
                'col-xs-12 col-md-8']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class', 'card_info_wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class', 'checkout']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [['class', 'steps']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'strong', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Step 2 of 2'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'h2', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['We are all set!'])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'i', [['class', 'material-icons']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['check_circle_outline'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Your card will automatically be charged once your shipment is prepared. We`ll email you with the final invoice .'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'br', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['You can close this window now.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_OrderPaymentComponent_32(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class',
                'loader order_payment_loader']], null, null, null, null, null))], null, null);
}
function View_OrderPaymentComponent_31(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class',
                'card_info_wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'div', [['class', 'checkout']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 2, 'span', [['class', 'steps']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'strong', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Processing...'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_32)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.showPayPalLoader;
        _ck(_v, 9, 0, currVal_0);
    }, null);
}
function View_OrderPaymentComponent_33(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 26, 'div', [['class',
                'card_info_wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 23, 'div', [['class', 'checkout']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 14, 'div', [['class', 'col-xs-12 title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Confirmed'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'hr', [['class', 'underline']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Once all charges have been calculated we will email your paypal invoice to: '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'contacts']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Talk to you soon!'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.email;
        _ck(_v, 17, 0, currVal_0);
    });
}
function View_OrderPaymentComponent_34(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 23, 'div', [['class',
                'card_info_wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 20, 'div', [['class', 'checkout']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'col-xs-12 title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Failed'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'br', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['An error has occured while sending the email'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Please try again later'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_OrderPaymentComponent_30(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class',
                'col-xs-12 col-md-8']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_31)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_33)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_34)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.payPalRequestIsSent;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = (!_co.showPayPalLoader && !_co.payPalRequestFailed);
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = (!_co.showPayPalLoader && _co.payPalRequestFailed);
        _ck(_v, 9, 0, currVal_2);
    }, null);
}
function View_OrderPaymentComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 35, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 23, 'div', [['class', 'col-xs-12 col-md-4 left_sidebar']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_3)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 17, 'div', [['class',
                'info_block']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'p', [['class', 'contacts']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'name']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'br', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'color-orange']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_9)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_10)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_29)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_30)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isSecondTry;
        _ck(_v, 5, 0, currVal_0);
        var currVal_3 = _co.isSecondTry;
        _ck(_v, 20, 0, currVal_3);
        var currVal_4 = _co.isSecondTry;
        _ck(_v, 23, 0, currVal_4);
        var currVal_5 = (!_co.showNextStep && !_co.isPayPal);
        _ck(_v, 28, 0, currVal_5);
        var currVal_6 = (_co.showNextStep && !_co.isPayPal);
        _ck(_v, 31, 0, currVal_6);
        var currVal_7 = _co.isPayPal;
        _ck(_v, 34, 0, currVal_7);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.name;
        _ck(_v, 12, 0, currVal_1);
        var currVal_2 = _co.email;
        _ck(_v, 16, 0, currVal_2);
    });
}
function View_OrderPaymentComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["CurrencyPipe"], [core_es5["LOCALE_ID"]]), core_es5["ɵqud"](671088640, 1, { cardInfo: 0 }), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class',
                'payment_header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'container-fluid']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '/']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['height',
                '24'], ['src', 'assets/logo.437b02847d771cc3f66f87a5dbeb3d66.png'], ['width',
                '140']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'data_wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OrderPaymentComponent_2)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.isHaveBeenPayed && !_co.isPayPal);
        _ck(_v, 22, 0, currVal_0);
        var currVal_1 = !_co.isHaveBeenPayed;
        _ck(_v, 25, 0, currVal_1);
    }, null);
}
function View_OrderPaymentComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'order-payment', [], null, null, null, View_OrderPaymentComponent_0, RenderType_OrderPaymentComponent)), core_es5["ɵdid"](4440064, null, 0, order_payment_component_OrderPaymentComponent, [core_es5["Renderer2"], router_es5["a" /* ActivatedRoute */], core_es5["ChangeDetectorRef"], services_configService["a" /* ConfigService */], services_paymentService["a" /* PaymentService */],
            services_customerService["a" /* CustomerService */], services_emailService["a" /* EmailService */], services_locationService["a" /* LocationService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var OrderPaymentComponentNgFactory = core_es5["ɵccf"]('order-payment', order_payment_component_OrderPaymentComponent, View_OrderPaymentComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=order-payment.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/app/components/api-documentation/api-documentation.component.scss.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var api_documentation_component_scss_ngstyle_styles = ['body{overflow:visible}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvYXBpLWRvY3VtZW50YXRpb24vYXBpLWRvY3VtZW50YXRpb24uY29tcG9uZW50LnNjc3MubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL2FwaS1kb2N1bWVudGF0aW9uL2FwaS1kb2N1bWVudGF0aW9uLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=api-documentation.component.scss.ngstyle.js.map
// CONCATENATED MODULE: ./app/components/api-documentation/api-documentation.component.ts



var api_documentation_component_ApiDocumentationComponent = /** @class */ (function () {
    function ApiDocumentationComponent(element, renderer, configService) {
        this.element = element;
        this.renderer = renderer;
        this.configService = configService;
        this.config = configService.config;
        this.currentYear = new Date().getFullYear().toString();
    }
    ApiDocumentationComponent.prototype.ngAfterViewInit = function () {
        var spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");
        this.attachDocumentationComponent();
    };
    ApiDocumentationComponent.prototype.attachDocumentationComponent = function () {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            var elem;
            return tslib_es6["d" /* __generator */](this, function (_a) {
                elem = this.element.nativeElement.querySelector('.documentation-root');
                Redoc.init(this.config.ApiUrl + "/swagger/v1/swagger.json", {}, elem);
                return [2 /*return*/];
            });
        });
    };
    ApiDocumentationComponent.prototype.ngOnDestroy = function () {
        this.element.nativeElement.querySelector('.documentation-root').remove();
    };
    ApiDocumentationComponent.ctorParameters = function () { return [{ type: core_es5["ElementRef"] }, { type: core_es5["Renderer2"] }, { type: services_configService["a" /* ConfigService */] }]; };
    return ApiDocumentationComponent;
}());

//# sourceMappingURL=api-documentation.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/api-documentation/api-documentation.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_ApiDocumentationComponent = [api_documentation_component_scss_ngstyle_styles];
var RenderType_ApiDocumentationComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ApiDocumentationComponent, data: {} });
function View_ApiDocumentationComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 76, 'div', [['class',
                'public-calc-v2']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 73, 'div', [['class', 'container-fluid main-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 14, 'div', [['class',
                'row header padding-top-25 padding-bottom-0']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class',
                'col-xs-12 col-sm-6']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['src', 'assets/bb_logo.022c701d33d3d8703c0d9eb023db9502.jpg'],
            ['width', '270']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 6, 'div', [['class',
                'col-xs-12 col-sm-6 text-right']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' TOLL FREE '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt', ''], ['class', 'padding-5'],
            ['src', 'assets/bb_phone.fb92f1dadd548c65645f8bc5a834cffd.jpg']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', 'tel:(855) 275-1100']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['(855) 275-1100'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class',
                'row main']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'documentation-root col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 49, 'div', [['class', 'row footer margin-top-45']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 22, 'div', [['class',
                'col-xs-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class', 'social-icon']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '/']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt', 'youtube'], ['src', 'assets/youtube.33a2d46a45325961dc6b6d0672f68513.svg']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '/']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt',
                'facebook'], ['src', 'assets/facebook.71f6d57cf486024c8bf6ecb9c69b7815.svg']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '/']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt',
                'twitter'], ['src', 'assets/twitter.f550163f114f8c9bb3d4801a22d13f37.svg']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '/']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt',
                'pinterest'], ['src', 'assets/pinterest.3a3ea91c4772177ce320c8d7c9b11de6.svg']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '/']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt',
                'instagram'], ['src', 'assets/instagram.726401ae61aa4a1b521c6e0b5b13a7d1.svg']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '/']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['alt',
                'linkedin'], ['src', 'assets/linkedin.92ad552dd7e1b9307c2a5c5ef410d42d.svg']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'col-xs-12 line']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'div', [['class', 'col-xs-12 bottom-line padding-bottom-20']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class',
                'all-rights']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['© ', ' BorderBuddy, All Rights Reserved'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href',
                '/']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Privacy'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 2, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '/']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Legal Term'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'who']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Who Designed This Website? '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.currentYear;
        _ck(_v, 60, 0, currVal_0);
    });
}
function View_ApiDocumentationComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'api-documentation', [], null, null, null, View_ApiDocumentationComponent_0, RenderType_ApiDocumentationComponent)), core_es5["ɵdid"](4374528, null, 0, api_documentation_component_ApiDocumentationComponent, [core_es5["ElementRef"], core_es5["Renderer2"], services_configService["a" /* ConfigService */]], null, null)], null, null);
}
var ApiDocumentationComponentNgFactory = core_es5["ɵccf"]('api-documentation', api_documentation_component_ApiDocumentationComponent, View_ApiDocumentationComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=api-documentation.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/theme/scss/pars-status-widget.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var pars_status_widget_scss_shim_ngstyle_styles = ['body[_ngcontent-%COMP%], html[_ngcontent-%COMP%]{width:100%;height:100%;padding:0;margin:0;overflow:hidden!important}body[_ngcontent-%COMP%]::-webkit-scrollbar, html[_ngcontent-%COMP%]::-webkit-scrollbar{width:0;height:0}*[_ngcontent-%COMP%]{font-family:Montserrat,sans-serif;font-weight:400;font-size:12px;font-style:normal}.sub-title[_ngcontent-%COMP%]{margin:10px 0 10px 28px}.sub-title-below-status[_ngcontent-%COMP%]{margin:10px 0 10px 28px;color:#000;font-weight:700;font-size:16px}.wrapper[_ngcontent-%COMP%]{border:2px solid #e07e3c;padding:20px}.wrapper[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-weight:700;font-size:16px;color:silver}.wrapper[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#000;display:inline;vertical-align:middle;margin-bottom:20px}.wrapper[_ngcontent-%COMP%]   .title-normal[_ngcontent-%COMP%]{font-weight:400}.wrapper[_ngcontent-%COMP%]   .status-date-info[_ngcontent-%COMP%]{float:right}.wrapper[_ngcontent-%COMP%]   .separator[_ngcontent-%COMP%]{border-top:2px solid #bbb}.wrapper[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font-weight:bolder;font-size:16px}.wrapper[_ngcontent-%COMP%]   .subscribe-result-label[_ngcontent-%COMP%]{font-weight:400}.wrapper[_ngcontent-%COMP%]   .date[_ngcontent-%COMP%]{color:silver;text-align:right}.wrapper[_ngcontent-%COMP%]   form.ng-touched[_ngcontent-%COMP%]   .form-input.ng-invalid[_ngcontent-%COMP%]{border-color:red}.wrapper[_ngcontent-%COMP%]   .notification[_ngcontent-%COMP%]   .form-input[_ngcontent-%COMP%]{text-transform:none}.wrapper[_ngcontent-%COMP%]   .form-input[_ngcontent-%COMP%]{width:100%;border:2px solid #e07e3c;outline:none;min-height:40px;font-size:16px;padding:0 10px;color:#e07e3c;text-transform:uppercase}.wrapper[_ngcontent-%COMP%]   .form-input[_ngcontent-%COMP%]::placeholder{color:#e07e3c;font-size:14px;text-transform:none}.wrapper[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{color:#fff;background:#e07e3c;font-weight:bolder;text-align:center}.wrapper[_ngcontent-%COMP%]   .status-bar-wrapper[_ngcontent-%COMP%]{position:relative}.wrapper[_ngcontent-%COMP%]   .status-bar-wrapper[_ngcontent-%COMP%]   .line[_ngcontent-%COMP%]{height:calc(100% - 4px);width:4px;background:#e07e3c;position:absolute;left:6px}.wrapper[_ngcontent-%COMP%]   .status-bar[_ngcontent-%COMP%]{margin:0;padding:0;list-style:none}.wrapper[_ngcontent-%COMP%]   .status-bar[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{margin:10px 0;display:flex;justify-content:flex-start;align-items:self-start}.wrapper[_ngcontent-%COMP%]   .status-bar[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .circle[_ngcontent-%COMP%]{border-radius:100%;border:2px solid #e07e3c;background:#fff;margin:0 10px 0 0;width:16px;height:16px;min-width:16px;min-height:16px;position:relative}.wrapper[_ngcontent-%COMP%]   .status-bar[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .circle[_ngcontent-%COMP%]   .checked[_ngcontent-%COMP%]{display:none;position:absolute;font-weight:700;top:3px;margin-top:-50%;left:7px;margin-left:-50%}.wrapper[_ngcontent-%COMP%]   .status-bar[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .circle.active[_ngcontent-%COMP%]{background:#e07e3c}.wrapper[_ngcontent-%COMP%]   .status-bar[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .circle.active[_ngcontent-%COMP%]   .checked[_ngcontent-%COMP%]{display:block}.wrapper[_ngcontent-%COMP%]   .status_timestamp[_ngcontent-%COMP%]{color:#000;font-weight:700}.unsub-wrapper[_ngcontent-%COMP%]{text-align:center}.unsub-wrapper[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#00ba1b;display:inline;vertical-align:middle;margin-bottom:20px;font-size:20px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvdGhlbWUvc2Nzcy9wYXJzLXN0YXR1cy13aWRnZXQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi90aGVtZS9zY3NzL3BhcnMtc3RhdHVzLXdpZGdldC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=pars-status-widget.scss.shim.ngstyle.js.map
// CONCATENATED MODULE: ./app/services/RNS.service.ts




var RNS_service_RNSService = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](RNSService, _super);
    function RNSService(http, configService) {
        return _super.call(this, http, configService) || this;
    }
    RNSService.prototype.CheckCCN = function (ccnNumber) {
        return this.get(new http_es5["i" /* RequestOptions */]({
            url: "status/RNSStatus/" + ccnNumber
        }));
    };
    RNSService.prototype.refreshStatus = function (statusQueryId) {
        return this.get(new http_es5["i" /* RequestOptions */]({
            url: "status/RNSStatus/" + statusQueryId + "/refresh"
        }));
    };
    RNSService.ctorParameters = function () { return [{ type: http_es5["e" /* Http */] }, { type: services_configService["a" /* ConfigService */] }]; };
    return RNSService;
}(baseService["a" /* BaseApi */]));

//# sourceMappingURL=RNS.service.js.map
// CONCATENATED MODULE: ./app/components/pars-status-widget/pars-status-widget.component.ts







var pars_status_widget_component_ParsStatusWidgetComponent = /** @class */ (function () {
    function ParsStatusWidgetComponent(renderer, rnsService, emailService, toastsManager, route) {
        this.renderer = renderer;
        this.rnsService = rnsService;
        this.emailService = emailService;
        this.toastsManager = toastsManager;
        this.route = route;
        this.statusNames = new Map([
            [RNSStatus.Other, "Number Not On File"],
            [RNSStatus.Error, "Number Not On File"],
            [RNSStatus.NumberNotOnFile, "Pending Clearance"],
            [RNSStatus.DeclarationAccepted, "Approved - ready to cross"],
            [RNSStatus.GoodsReleased, "Released"],
            [RNSStatus.GoodsRequiredForExamination, "Held for examination"],
        ]);
        this.rnsStatus = RNSStatus;
        this.isShowStatForm = true;
        this.isShowGetNotified = false;
        this.isStatusUpdates = false;
        this.isStatusReleased = false;
        this.isSubscribedSuccess = false;
    }
    ParsStatusWidgetComponent.prototype.ngOnInit = function () {
        this.ccnUnsub = this.route.snapshot.queryParams['ccn'] || "";
        this.email = this.route.snapshot.queryParams['email'] || "";
        var unsub = this.route.snapshot.queryParams['unsubscribe'] || "";
        this.unsubscribe = unsub === "1";
    };
    ParsStatusWidgetComponent.prototype.ngAfterViewInit = function () {
        this.spinner = document.getElementById("spinner");
        this.renderer.addClass(this.spinner, "hide");
        scrollHelper_ScrollHelper.forceSetVerticalScroll(document.getElementsByTagName('body')[0]);
        if (this.unsubscribe) {
            this.emailService.unsubscribeEmail(this.ccnUnsub, this.email).then(function (_) { });
        }
    };
    ParsStatusWidgetComponent.prototype.onSubmit = function (ccnForm) {
        if (ccnForm.valid) {
            this.renderer.removeClass(this.spinner, "hide");
            var ccn = ccnForm.value.ccn.trim();
            this.submitCcn(ccn);
        }
        ccnForm.resetForm();
    };
    ParsStatusWidgetComponent.prototype.onSubscribeSubmit = function (subscribeForm) {
        var _this = this;
        if (subscribeForm.valid) {
            this.renderer.removeClass(this.spinner, "hide");
            this.emailService.sendSubscribeToPARSStatus(this.ccn.trim(), subscribeForm.value.email.trim()).then(function (r) {
                _this.isStatusUpdates = false;
                _this.isShowGetNotified = false;
                _this.isShowStatForm = false;
                _this.isSubscribedSuccess = true;
                _this.renderer.addClass(_this.spinner, "hide");
            }, function (reject) {
                _this.toastsManager.error(reject.Data.Message || reject.Data);
                _this.renderer.addClass(_this.spinner, "hide");
            });
        }
        subscribeForm.form.markAsTouched();
    };
    ParsStatusWidgetComponent.prototype.onCheckAnotherShipmentFormSubmit = function (checkAnotherShipmentForm) {
        if (checkAnotherShipmentForm.valid) {
            this.renderer.removeClass(this.spinner, "hide");
            var ccn = checkAnotherShipmentForm.value.anotherParsNumber;
            this.submitCcn(ccn);
        }
        checkAnotherShipmentForm.resetForm();
    };
    ParsStatusWidgetComponent.prototype.submitCcn = function (ccn) {
        var _this = this;
        this.ccn = ccn;
        this.rnsService.CheckCCN(this.ccn).then(function (r) {
            _this.rnsStatusModel = r.Data;
            _this.isShowStatForm = false;
            _this.isSubscribedSuccess = false;
            _this.isStatusReleased = false;
            if (_this.rnsStatusModel == null) {
                _this.isStatusUpdates = true;
                _this.isStatusReleased = false;
                _this.isShowGetNotified = false;
            }
            else {
                _this.currentStatus = _this.statusNames.get(_this.rnsStatusModel.CurrentStatus);
                _this.isStatusUpdates = false;
                _this.isShowGetNotified = true;
                _this.isStatusReleased = _this.rnsStatusModel.CurrentStatus == RNSStatus.GoodsReleased;
                _this.pendingClearanceDateTimeStamp = _this.getStatusTimeStamp(RNSStatus.NumberNotOnFile);
                _this.approvedDateTimeStamp = _this.getStatusTimeStamp(RNSStatus.DeclarationAccepted);
                _this.heldToExaminationDateTimeStamp = _this.getStatusTimeStamp(RNSStatus.GoodsRequiredForExamination);
                _this.releasedDateTimeStamp = _this.getStatusTimeStamp(RNSStatus.GoodsReleased);
            }
            _this.renderer.addClass(_this.spinner, "hide");
        }, function (reject) {
            _this.toastsManager.error(reject.Data);
            _this.renderer.addClass(_this.spinner, "hide");
        });
    };
    ParsStatusWidgetComponent.prototype.getStatusTimeStamp = function (status) {
        if (status == undefined)
            return undefined;
        var filteredByStatus = this.getRNSStatusResponseByStatus(status);
        if (filteredByStatus.length > 0) {
            var statusRecord = this.getFirstRNSResponse(filteredByStatus);
            if (statusRecord) {
                return statusRecord.DateTimeStamp;
            }
        }
        return this.getStatusTimeStamp(this.getNextRNSStatusResponse(status));
    };
    ParsStatusWidgetComponent.prototype.getNextRNSStatusResponse = function (currentStatus) {
        return RNSStatus[RNSStatus[currentStatus + 1]];
    };
    ParsStatusWidgetComponent.prototype.getRNSStatusResponseByStatus = function (status) {
        return this.rnsStatusModel.StatusHistory.filter(function (x) { return x.Status == status; });
    };
    ParsStatusWidgetComponent.prototype.getFirstRNSResponse = function (responseArray) {
        return responseArray.sort(function (x, y) { return (new Date(x.ReceivedDate)).getTime() - (new Date(y.ReceivedDate)).getTime(); })[0];
    };
    ParsStatusWidgetComponent.ctorParameters = function () { return [{ type: core_es5["Renderer2"] }, { type: RNS_service_RNSService }, { type: services_emailService["a" /* EmailService */] }, { type: ng2_toastr["ToastsManager"] }, { type: router_es5["a" /* ActivatedRoute */] }]; };
    return ParsStatusWidgetComponent;
}());

//# sourceMappingURL=pars-status-widget.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/pars-status-widget/pars-status-widget.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */











var styles_ParsStatusWidgetComponent = [pars_status_widget_scss_shim_ngstyle_styles];
var RenderType_ParsStatusWidgetComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_ParsStatusWidgetComponent, data: {} });
function View_ParsStatusWidgetComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'unsub-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h1', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['You have been unsubscribed from updates for CCN – ',
            ''])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.ccnUnsub;
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_ParsStatusWidgetComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h1', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['PARS Tracker']))], null, null);
}
function View_ParsStatusWidgetComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h1', [['class', 'title title-normal']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Status:'])), (_l()(),
            core_es5["ɵted"](null, [' ']))], null, null);
}
function View_ParsStatusWidgetComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h1', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['PARS ', ''])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.ccn;
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_ParsStatusWidgetComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h1', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['New PARS number Alert!']))], null, null);
}
function View_ParsStatusWidgetComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h1', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['You are subscribed!']))], null, null);
}
function View_ParsStatusWidgetComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class',
                'margin-top-10 sub-title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Add a Cargo Control Number (CCN) and we will fetch the status for you. ']))], null, null);
}
function View_ParsStatusWidgetComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'div', [['class',
                'sub-title-below-status']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ', ' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.currentStatus;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_ParsStatusWidgetComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class',
                'sub-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' Unfortunately your PARS number was not in our database, which prevented us from giving you an immediate result. ']))], null, null);
}
function View_ParsStatusWidgetComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class',
                'sub-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' All is not lost though, as we can email you the results after we submit to CBSA on your behalf. (approximately 15 minutes) ']))], null, null);
}
function View_ParsStatusWidgetComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 31, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 28, 'div', [['class', 'margin-top-10 col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 25, 'form', [['class',
                'row'], ['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngSubmit'], [null, 'submit'],
            [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 6).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 6).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.onSubmit(core_es5["ɵnov"](_v, 6)) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['ccnForm', 4]], 0, forms_es5["NgForm"], [[8,
                null], [8, null]], null, { ngSubmit: 'ngSubmit' }), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'input', [['class',
                'form-input'], ['name', 'ccn'], ['ngModel', ''], ['placeholder', 'Type PARS number here'],
            ['required', '']], [[2, 'is-invalid', null], [1, 'required', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 13)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 13).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 13)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 13)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 16).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, [['ccn', 4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, null),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'margin-top-10 col-xs-12 text-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn']], null, null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"],
            core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, ['Submit'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_16 = '';
        _ck(_v, 14, 0, currVal_16);
        var currVal_17 = 'ccn';
        var currVal_18 = '';
        _ck(_v, 18, 0, currVal_17, currVal_18);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (core_es5["ɵnov"](_v, 18).invalid && core_es5["ɵnov"](_v, 18).touched);
        var currVal_8 = (core_es5["ɵnov"](_v, 14).required ? '' : null);
        var currVal_9 = core_es5["ɵnov"](_v, 20).ngClassUntouched;
        var currVal_10 = core_es5["ɵnov"](_v, 20).ngClassTouched;
        var currVal_11 = core_es5["ɵnov"](_v, 20).ngClassPristine;
        var currVal_12 = core_es5["ɵnov"](_v, 20).ngClassDirty;
        var currVal_13 = core_es5["ɵnov"](_v, 20).ngClassValid;
        var currVal_14 = core_es5["ɵnov"](_v, 20).ngClassInvalid;
        var currVal_15 = core_es5["ɵnov"](_v, 20).ngClassPending;
        _ck(_v, 12, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15);
    });
}
function View_ParsStatusWidgetComponent_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h2', [['class', 'text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['No results available'])),
        (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_ParsStatusWidgetComponent_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 11, 'li', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'div', [['class', 'circle']], [[2, 'active', null]], null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checked']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['✓'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' Held to examination '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'status_timestamp']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['',
            ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (((_co.rnsStatusModel == null) ? null : _co.rnsStatusModel.CurrentStatus) >= _co.rnsStatus.DeclarationAccepted);
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = _co.heldToExaminationDateTimeStamp;
        _ck(_v, 9, 0, currVal_1);
    });
}
function View_ParsStatusWidgetComponent_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 70, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_13)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 64, 'div', [['class', 'margin-top-10 col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 61, 'div', [['class',
                'status-bar-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'line']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 56, 'ul', [['class',
                'status-bar']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'div', [['class', 'circle']], [[2, 'active', null]], null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checked']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['✓'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Pending Clearance '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'status_timestamp']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 11, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'div', [['class',
                'circle']], [[2, 'active', null]], null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class',
                'checked']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['✓'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Declaration accepted by Customs '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'status_timestamp']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_14)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 2, 'div', [['class', 'circle']], [[2, 'active',
                    null]], null, null, null, null)),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checked']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['✓'])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Approved - ready to cross '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'status_timestamp']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'li', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'div', [['class', 'circle']], [[2, 'active', null]], null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'checked']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['✓'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' Released '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'status_timestamp']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['', ''])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.rnsStatusModel === null);
        _ck(_v, 3, 0, currVal_0);
        var currVal_5 = (((_co.rnsStatusModel == null) ? null : _co.rnsStatusModel.CurrentStatus) == _co.rnsStatus.GoodsRequiredForExamination);
        _ck(_v, 40, 0, currVal_5);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = (((_co.rnsStatusModel == null) ? null : _co.rnsStatusModel.CurrentStatus) >= _co.rnsStatus.NumberNotOnFile);
        _ck(_v, 15, 0, currVal_1);
        var currVal_2 = _co.pendingClearanceDateTimeStamp;
        _ck(_v, 22, 0, currVal_2);
        var currVal_3 = (((_co.rnsStatusModel == null) ? null : _co.rnsStatusModel.CurrentStatus) >= _co.rnsStatus.DeclarationAccepted);
        _ck(_v, 28, 0, currVal_3);
        var currVal_4 = _co.approvedDateTimeStamp;
        _ck(_v, 35, 0, currVal_4);
        var currVal_6 = ((((_co.rnsStatusModel == null) ? null : _co.rnsStatusModel.CurrentStatus) == _co.rnsStatus.DeclarationAccepted) || (((_co.rnsStatusModel == null) ? null : _co.rnsStatusModel.CurrentStatus) == _co.rnsStatus.GoodsReleased));
        _ck(_v, 44, 0, currVal_6);
        var currVal_7 = _co.approvedDateTimeStamp;
        _ck(_v, 51, 0, currVal_7);
        var currVal_8 = (((_co.rnsStatusModel == null) ? null : _co.rnsStatusModel.CurrentStatus) == _co.rnsStatus.GoodsReleased);
        _ck(_v, 57, 0, currVal_8);
        var currVal_9 = _co.releasedDateTimeStamp;
        _ck(_v, 64, 0, currVal_9);
    });
}
function View_ParsStatusWidgetComponent_15(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class',
                'row subscribed']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 1, 'h2', [['class', 'subscribe-result-label']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['We will send you the PARS update by email within the next couple of minutes.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h2', [['class', 'subscribe-result-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Thanks for using our PARS Tracker service.'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_ParsStatusWidgetComponent_16(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 0, 'hr', [['class',
                'separator']], null, null, null, null, null))], null, null);
}
function View_ParsStatusWidgetComponent_18(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 7, 'div', [['class',
                'margin-top-10 col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class', 'display-inline vertical-align-middle']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Get updates for: '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h1', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['PARS ',
            ''])), (_l()(), core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.ccn;
        _ck(_v, 6, 0, currVal_0);
    });
}
function View_ParsStatusWidgetComponent_19(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-xs-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'h2', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Would you like us to email you the status?'])),
        (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_ParsStatusWidgetComponent_20(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 29, 'div', [['class',
                'margin-top-10 col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 26, 'form', [['class', 'row'], ['novalidate', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngSubmit'],
            [null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 4).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.onSubscribeSubmit(core_es5["ɵnov"](_v, 4)) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['subscribeForm', 4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 12, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 9, 'input', [['class', 'form-input'],
                ['name', 'email'], ['ngModel', ''], ['pattern', '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'],
                ['placeholder', 'Add email address here'], ['required', '']], [[2, 'is-invalid',
                    null], [1, 'required', 0], [1, 'pattern', 0], [2, 'ng-untouched', null],
                [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                    null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
                [2, 'ng-pending', null]], [[null, 'input'], [null,
                    'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
                var ad = true;
                if (('input' === en)) {
                    var pd_0 = (core_es5["ɵnov"](_v, 11)._handleInput($event.target.value) !== false);
                    ad = (pd_0 && ad);
                }
                if (('blur' === en)) {
                    var pd_1 = (core_es5["ɵnov"](_v, 11).onTouched() !== false);
                    ad = (pd_1 && ad);
                }
                if (('compositionstart' === en)) {
                    var pd_2 = (core_es5["ɵnov"](_v, 11)._compositionStart() !== false);
                    ad = (pd_2 && ad);
                }
                if (('compositionend' === en)) {
                    var pd_3 = (core_es5["ɵnov"](_v, 11)._compositionEnd($event.target.value) !== false);
                    ad = (pd_3 && ad);
                }
                if (('input' === en)) {
                    var pd_4 = (core_es5["ɵnov"](_v, 15).ngOnChange($event.target.value) !== false);
                    ad = (pd_4 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵdid"](540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["RequiredValidator"], forms_es5["PatternValidator"]]), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, [['email',
                4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, null),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'margin-top-10 col-xs-12 text-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn']], null, null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"],
            core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, ['Submit'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var currVal_17 = '';
        _ck(_v, 12, 0, currVal_17);
        var currVal_18 = '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
        _ck(_v, 13, 0, currVal_18);
        var currVal_19 = 'email';
        var currVal_20 = '';
        _ck(_v, 17, 0, currVal_19, currVal_20);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 6).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 6).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 6).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 6).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 6).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 6).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 6).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = (core_es5["ɵnov"](_v, 17).invalid && core_es5["ɵnov"](_v, 17).touched);
        var currVal_8 = (core_es5["ɵnov"](_v, 12).required ? '' : null);
        var currVal_9 = (core_es5["ɵnov"](_v, 13).pattern ? core_es5["ɵnov"](_v, 13).pattern : null);
        var currVal_10 = core_es5["ɵnov"](_v, 19).ngClassUntouched;
        var currVal_11 = core_es5["ɵnov"](_v, 19).ngClassTouched;
        var currVal_12 = core_es5["ɵnov"](_v, 19).ngClassPristine;
        var currVal_13 = core_es5["ɵnov"](_v, 19).ngClassDirty;
        var currVal_14 = core_es5["ɵnov"](_v, 19).ngClassValid;
        var currVal_15 = core_es5["ɵnov"](_v, 19).ngClassInvalid;
        var currVal_16 = core_es5["ɵnov"](_v, 19).ngClassPending;
        _ck(_v, 10, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16);
    });
}
function View_ParsStatusWidgetComponent_22(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [['class',
                'margin-top-10 margin-bottom-10 text-center']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Or']))], null, null);
}
function View_ParsStatusWidgetComponent_21(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 34, 'div', [['class',
                'margin-top-10 col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_22)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Check another shipment:'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 25, 'form', [['class', 'row'], ['novalidate',
                    '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                    null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngSubmit'], [null, 'submit'], [null,
                    'reset']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('submit' === en)) {
                    var pd_0 = (core_es5["ɵnov"](_v, 10).onSubmit($event) !== false);
                    ad = (pd_0 && ad);
                }
                if (('reset' === en)) {
                    var pd_1 = (core_es5["ɵnov"](_v, 10).onReset() !== false);
                    ad = (pd_1 && ad);
                }
                if (('ngSubmit' === en)) {
                    var pd_2 = (_co.onCheckAnotherShipmentFormSubmit(core_es5["ɵnov"](_v, 10)) !== false);
                    ad = (pd_2 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16384, [['checkAnotherShipmentForm',
                4]], 0, forms_es5["NgForm"], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 11, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 8, 'input', [['class',
                'form-input'], ['name', 'anotherParsNumber'], ['ngModel', ''], ['placeholder',
                'Add PARS number here'], ['required', '']], [[2, 'is-invalid', null],
            [1, 'required', 0], [2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 17)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 17).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 17)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 17)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 20).ngOnChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](16384, null, 0, forms_es5["RequiredValidator"], [], { required: [0, 'required'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["RequiredValidator"]]), core_es5["ɵdid"](16384, null, 0, trimValueAccessor_TrimValueAccessor, [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], trimValueAccessor_TrimValueAccessor]), core_es5["ɵdid"](671744, [['anotherParsNumber',
                4]], 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, null),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 5, 'div', [['class', 'margin-top-10 col-xs-12 text-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 2, 'button', [['class', 'btn']], null, null, null, null, null)), core_es5["ɵdid"](16384, null, 0, ripples_directive_RipplesDirective, [core_es5["ElementRef"],
            core_es5["Renderer2"]], null, null), (_l()(), core_es5["ɵted"](null, ['Submit'])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.isShowGetNotified && !_co.isStatusReleased);
        _ck(_v, 3, 0, currVal_0);
        var currVal_17 = '';
        _ck(_v, 18, 0, currVal_17);
        var currVal_18 = 'anotherParsNumber';
        var currVal_19 = '';
        _ck(_v, 22, 0, currVal_18, currVal_19);
    }, function (_ck, _v) {
        var currVal_1 = core_es5["ɵnov"](_v, 12).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 12).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 12).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 12).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 12).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 12).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 12).ngClassPending;
        _ck(_v, 8, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_8 = (core_es5["ɵnov"](_v, 22).invalid && core_es5["ɵnov"](_v, 22).touched);
        var currVal_9 = (core_es5["ɵnov"](_v, 18).required ? '' : null);
        var currVal_10 = core_es5["ɵnov"](_v, 24).ngClassUntouched;
        var currVal_11 = core_es5["ɵnov"](_v, 24).ngClassTouched;
        var currVal_12 = core_es5["ɵnov"](_v, 24).ngClassPristine;
        var currVal_13 = core_es5["ɵnov"](_v, 24).ngClassDirty;
        var currVal_14 = core_es5["ɵnov"](_v, 24).ngClassValid;
        var currVal_15 = core_es5["ɵnov"](_v, 24).ngClassInvalid;
        var currVal_16 = core_es5["ɵnov"](_v, 24).ngClassPending;
        _ck(_v, 16, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16);
    });
}
function View_ParsStatusWidgetComponent_17(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class',
                'row notification']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_18)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_19)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_20)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_21)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.isShowGetNotified && !_co.isStatusReleased);
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _co.isStatusUpdates;
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = ((_co.isShowGetNotified || _co.isStatusUpdates) && !_co.isStatusReleased);
        _ck(_v, 9, 0, currVal_2);
        var currVal_3 = ((_co.isShowGetNotified || _co.isStatusReleased) || _co.isSubscribedSuccess);
        _ck(_v, 12, 0, currVal_3);
    }, null);
}
function View_ParsStatusWidgetComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 74, 'html', [['lang', 'en']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 12, 'head', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'meta', [['charset', 'UTF-8']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'meta', [['content', 'width=device-width,user-scalable=no,initial-scale=1,maximum-scale=1,minimum-scale=1'],
            ['name', 'viewport']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'meta', [['content', 'ie=edge'], ['http-equiv', 'X-UA-Compatible']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'link', [['href', '/theme/css/pars-status-widget.css'], ['rel', 'stylesheet']], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'title', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['BorderBuddy PARS Tracker'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵeld"](0, null, null, 57, 'body', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 51, 'div', [['class', 'wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 33, 'div', [['class', 'col-xs-12 widget-header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 18, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['height', '24'], ['src', 'assets/bb_logo.2d0ce4988f48e15eefe6b898b5f91fd5.png'],
            ['width', '24']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_3)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_4)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_5)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_6)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_7)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_8)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_9)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_10)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_11)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_12)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_15)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_16)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusWidgetComponent_17)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.unsubscribe;
        _ck(_v, 20, 0, currVal_0);
        var currVal_1 = _co.isShowStatForm;
        _ck(_v, 31, 0, currVal_1);
        var currVal_2 = _co.isShowGetNotified;
        _ck(_v, 34, 0, currVal_2);
        var currVal_3 = _co.isShowGetNotified;
        _ck(_v, 37, 0, currVal_3);
        var currVal_4 = _co.isStatusUpdates;
        _ck(_v, 40, 0, currVal_4);
        var currVal_5 = _co.isSubscribedSuccess;
        _ck(_v, 43, 0, currVal_5);
        var currVal_6 = _co.isShowStatForm;
        _ck(_v, 47, 0, currVal_6);
        var currVal_7 = _co.isShowGetNotified;
        _ck(_v, 50, 0, currVal_7);
        var currVal_8 = _co.isStatusUpdates;
        _ck(_v, 53, 0, currVal_8);
        var currVal_9 = _co.isStatusUpdates;
        _ck(_v, 56, 0, currVal_9);
        var currVal_10 = _co.isShowStatForm;
        _ck(_v, 60, 0, currVal_10);
        var currVal_11 = (_co.isShowGetNotified || _co.isStatusReleased);
        _ck(_v, 63, 0, currVal_11);
        var currVal_12 = _co.isSubscribedSuccess;
        _ck(_v, 66, 0, currVal_12);
        var currVal_13 = !_co.isShowStatForm;
        _ck(_v, 69, 0, currVal_13);
        var currVal_14 = !_co.isShowStatForm;
        _ck(_v, 72, 0, currVal_14);
    }, null);
}
function View_ParsStatusWidgetComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'pars-status-widget', [], null, null, null, View_ParsStatusWidgetComponent_0, RenderType_ParsStatusWidgetComponent)), core_es5["ɵdid"](4308992, null, 0, pars_status_widget_component_ParsStatusWidgetComponent, [core_es5["Renderer2"], RNS_service_RNSService, services_emailService["a" /* EmailService */], toast_manager["ToastsManager"], router_es5["a" /* ActivatedRoute */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ParsStatusWidgetComponentNgFactory = core_es5["ɵccf"]('pars-status-widget', pars_status_widget_component_ParsStatusWidgetComponent, View_ParsStatusWidgetComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=pars-status-widget.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/theme/scss/pars-status-refresh.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var pars_status_refresh_scss_shim_ngstyle_styles = ['.refresh_header[_ngcontent-%COMP%]{background:#e07e3c;padding-top:20px;padding-bottom:20px}.data_wrapper[_ngcontent-%COMP%]{margin-top:30px}.underline[_ngcontent-%COMP%]{margin:5px 0 0;border-color:#b9b9b9}.block_wrapper[_ngcontent-%COMP%]{overflow:auto;background:#f0f0f0;height:auto;font-weight:500;line-height:20px;padding:20px;max-width:500px;margin:0 auto;color:#525252;font-size:1.1rem}.block_wrapper[_ngcontent-%COMP%], .block_wrapper[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-family:Montserrat;font-style:normal}.block_wrapper[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-weight:400;font-size:12px}.block_wrapper[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-weight:700;font-family:Montserrat;font-size:16px}.loader.refresh_loader[_ngcontent-%COMP%]{color:#e07e3c}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvdGhlbWUvc2Nzcy9wYXJzLXN0YXR1cy1yZWZyZXNoLnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvdGhlbWUvc2Nzcy9wYXJzLXN0YXR1cy1yZWZyZXNoLnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=pars-status-refresh.scss.shim.ngstyle.js.map
// CONCATENATED MODULE: ./app/components/pars-status-widget/pars-status-refresh.component.ts





var pars_status_refresh_component_ParsStatusRefreshComponent = /** @class */ (function () {
    function ParsStatusRefreshComponent(renderer, route, configService, rnsService, toastsManager) {
        this.renderer = renderer;
        this.route = route;
        this.configService = configService;
        this.rnsService = rnsService;
        this.toastsManager = toastsManager;
    }
    ParsStatusRefreshComponent.prototype.ngOnInit = function () {
        this.statusQueryId = this.route.snapshot.queryParams['sq'];
        this.parsNumber = this.route.snapshot.queryParams['pn'];
        this.showLoader = true;
    };
    ParsStatusRefreshComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.spinner = document.getElementById("spinner");
        this.renderer.addClass(this.spinner, "hide");
        this.rnsService.refreshStatus(this.statusQueryId)
            .then(function () {
            _this.showLoader = false;
            _this.counter = 5;
            _this.intervalId = setInterval(function () {
                if (_this.counter === 0) {
                    clearInterval(_this.intervalId);
                    window.open('https://borderbuddy.com/PARS', "_self");
                    return;
                }
                _this.counter -= 1;
            }, 1000);
        })
            .catch(function (r) { return console.log(r); });
    };
    ParsStatusRefreshComponent.ctorParameters = function () { return [{ type: core_es5["Renderer2"] }, { type: router_es5["a" /* ActivatedRoute */] }, { type: services_configService["a" /* ConfigService */] }, { type: RNS_service_RNSService }, { type: ng2_toastr["ToastsManager"] }]; };
    return ParsStatusRefreshComponent;
}());

//# sourceMappingURL=pars-status-refresh.component.js.map
// CONCATENATED MODULE: ./compiled/app/components/pars-status-widget/pars-status-refresh.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_ParsStatusRefreshComponent = [pars_status_refresh_scss_shim_ngstyle_styles];
var RenderType_ParsStatusRefreshComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_ParsStatusRefreshComponent, data: {} });
function View_ParsStatusRefreshComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class',
                'col-xs-12 title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'span', [['class', 'title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['Confirmed'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'hr', [['class', 'underline']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, ['Thank you for subscribing to follow PARS ', '.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['We will continue our requests to CBSA.'])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, ['You will be redirected to BorderBuddy page in ', ' seconds.'])), (_l()(),
            core_es5["ɵted"](null, [' ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.parsNumber;
        _ck(_v, 10, 0, currVal_0);
        var currVal_1 = _co.counter;
        _ck(_v, 18, 0, currVal_1);
    });
}
function View_ParsStatusRefreshComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 3, 'div', [['class',
                'col-xs-12 title']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'div', [['class', 'loader refresh_loader']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' ']))], null, null);
}
function View_ParsStatusRefreshComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class',
                'refresh_header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'container-fluid']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 4, 'div', [['class',
                'col-12']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 1, 'a', [['href', '/']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](0, null, null, 0, 'img', [['height',
                '24'], ['src', 'assets/logo.437b02847d771cc3f66f87a5dbeb3d66.png'], ['width',
                '140']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 19, 'div', [['class', 'data_wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 16, 'div', [['class', 'container']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 13, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵeld"](0, null, null, 10, 'div', [['class', 'col-xs-12 col-md-8']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(),
            core_es5["ɵeld"](0, null, null, 7, 'div', [['class', 'block_wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusRefreshComponent_1)), core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ParsStatusRefreshComponent_2)),
        core_es5["ɵdid"](16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' '])), (_l()(), core_es5["ɵted"](null, [' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.showLoader;
        _ck(_v, 26, 0, currVal_0);
        var currVal_1 = _co.showLoader;
        _ck(_v, 29, 0, currVal_1);
    }, null);
}
function View_ParsStatusRefreshComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, null, null, 1, 'pars-status-refresh', [], null, null, null, View_ParsStatusRefreshComponent_0, RenderType_ParsStatusRefreshComponent)), core_es5["ɵdid"](4308992, null, 0, pars_status_refresh_component_ParsStatusRefreshComponent, [core_es5["Renderer2"], router_es5["a" /* ActivatedRoute */], services_configService["a" /* ConfigService */], RNS_service_RNSService, toast_manager["ToastsManager"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ParsStatusRefreshComponentNgFactory = core_es5["ɵccf"]('pars-status-refresh', pars_status_refresh_component_ParsStatusRefreshComponent, View_ParsStatusRefreshComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=pars-status-refresh.component.ngfactory.js.map
// CONCATENATED MODULE: ./compiled/node_modules/bootstrap/dist/css/bootstrap.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var css_bootstrap_css_ngstyle_styles = ['\nhtml{font-family:sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{margin:.67em 0;font-size:2em}mark{color:#000;background:#ff0}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{height:0;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{margin:0;font:inherit;color:inherit}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{padding:0;border:0}input{line-height:normal}input[type=checkbox],input[type=radio]{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;-webkit-appearance:textfield}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{padding:.35em .625em .75em;margin:0 2px;border:1px solid silver}textarea{overflow:auto}optgroup{font-weight:700}table{border-spacing:0;border-collapse:collapse}td,th{padding:0}\n@media print{*,:after,:before{color:#000!important;text-shadow:none!important;background:transparent!important;-webkit-box-shadow:none!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:" (" attr(href) ")"}abbr[title]:after{content:" (" attr(title) ")"}a[href^="#"]:after,a[href^="javascript:"]:after{content:""}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(assets/glyphicons-halflings-regular.f4769f9bdb7466be65088239c12046d1.eot);src:url(assets/glyphicons-halflings-regular.f4769f9bdb7466be65088239c12046d1.eot?#iefix) format("embedded-opentype"),url(assets/glyphicons-halflings-regular.448c34a56d699c29117adc64c43affeb.woff2) format("woff2"),url(assets/glyphicons-halflings-regular.fa2772327f55d8198301fdb8bcfc8158.woff) format("woff"),url(assets/glyphicons-halflings-regular.e18bbf611f2a2e43afc071aa2f4e1512.ttf) format("truetype"),url(assets/glyphicons-halflings-regular.89889688147bd7575d6327160d64e760.svg#glyphicons_halflingsregular) format("svg")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:"*"}.glyphicon-plus:before{content:"+"}.glyphicon-eur:before,.glyphicon-euro:before{content:"\\20AC"}.glyphicon-minus:before{content:"\\2212"}.glyphicon-cloud:before{content:"\\2601"}.glyphicon-envelope:before{content:"\\2709"}.glyphicon-pencil:before{content:"\\270F"}.glyphicon-glass:before{content:"\\E001"}.glyphicon-music:before{content:"\\E002"}.glyphicon-search:before{content:"\\E003"}.glyphicon-heart:before{content:"\\E005"}.glyphicon-star:before{content:"\\E006"}.glyphicon-star-empty:before{content:"\\E007"}.glyphicon-user:before{content:"\\E008"}.glyphicon-film:before{content:"\\E009"}.glyphicon-th-large:before{content:"\\E010"}.glyphicon-th:before{content:"\\E011"}.glyphicon-th-list:before{content:"\\E012"}.glyphicon-ok:before{content:"\\E013"}.glyphicon-remove:before{content:"\\E014"}.glyphicon-zoom-in:before{content:"\\E015"}.glyphicon-zoom-out:before{content:"\\E016"}.glyphicon-off:before{content:"\\E017"}.glyphicon-signal:before{content:"\\E018"}.glyphicon-cog:before{content:"\\E019"}.glyphicon-trash:before{content:"\\E020"}.glyphicon-home:before{content:"\\E021"}.glyphicon-file:before{content:"\\E022"}.glyphicon-time:before{content:"\\E023"}.glyphicon-road:before{content:"\\E024"}.glyphicon-download-alt:before{content:"\\E025"}.glyphicon-download:before{content:"\\E026"}.glyphicon-upload:before{content:"\\E027"}.glyphicon-inbox:before{content:"\\E028"}.glyphicon-play-circle:before{content:"\\E029"}.glyphicon-repeat:before{content:"\\E030"}.glyphicon-refresh:before{content:"\\E031"}.glyphicon-list-alt:before{content:"\\E032"}.glyphicon-lock:before{content:"\\E033"}.glyphicon-flag:before{content:"\\E034"}.glyphicon-headphones:before{content:"\\E035"}.glyphicon-volume-off:before{content:"\\E036"}.glyphicon-volume-down:before{content:"\\E037"}.glyphicon-volume-up:before{content:"\\E038"}.glyphicon-qrcode:before{content:"\\E039"}.glyphicon-barcode:before{content:"\\E040"}.glyphicon-tag:before{content:"\\E041"}.glyphicon-tags:before{content:"\\E042"}.glyphicon-book:before{content:"\\E043"}.glyphicon-bookmark:before{content:"\\E044"}.glyphicon-print:before{content:"\\E045"}.glyphicon-camera:before{content:"\\E046"}.glyphicon-font:before{content:"\\E047"}.glyphicon-bold:before{content:"\\E048"}.glyphicon-italic:before{content:"\\E049"}.glyphicon-text-height:before{content:"\\E050"}.glyphicon-text-width:before{content:"\\E051"}.glyphicon-align-left:before{content:"\\E052"}.glyphicon-align-center:before{content:"\\E053"}.glyphicon-align-right:before{content:"\\E054"}.glyphicon-align-justify:before{content:"\\E055"}.glyphicon-list:before{content:"\\E056"}.glyphicon-indent-left:before{content:"\\E057"}.glyphicon-indent-right:before{content:"\\E058"}.glyphicon-facetime-video:before{content:"\\E059"}.glyphicon-picture:before{content:"\\E060"}.glyphicon-map-marker:before{content:"\\E062"}.glyphicon-adjust:before{content:"\\E063"}.glyphicon-tint:before{content:"\\E064"}.glyphicon-edit:before{content:"\\E065"}.glyphicon-share:before{content:"\\E066"}.glyphicon-check:before{content:"\\E067"}.glyphicon-move:before{content:"\\E068"}.glyphicon-step-backward:before{content:"\\E069"}.glyphicon-fast-backward:before{content:"\\E070"}.glyphicon-backward:before{content:"\\E071"}.glyphicon-play:before{content:"\\E072"}.glyphicon-pause:before{content:"\\E073"}.glyphicon-stop:before{content:"\\E074"}.glyphicon-forward:before{content:"\\E075"}.glyphicon-fast-forward:before{content:"\\E076"}.glyphicon-step-forward:before{content:"\\E077"}.glyphicon-eject:before{content:"\\E078"}.glyphicon-chevron-left:before{content:"\\E079"}.glyphicon-chevron-right:before{content:"\\E080"}.glyphicon-plus-sign:before{content:"\\E081"}.glyphicon-minus-sign:before{content:"\\E082"}.glyphicon-remove-sign:before{content:"\\E083"}.glyphicon-ok-sign:before{content:"\\E084"}.glyphicon-question-sign:before{content:"\\E085"}.glyphicon-info-sign:before{content:"\\E086"}.glyphicon-screenshot:before{content:"\\E087"}.glyphicon-remove-circle:before{content:"\\E088"}.glyphicon-ok-circle:before{content:"\\E089"}.glyphicon-ban-circle:before{content:"\\E090"}.glyphicon-arrow-left:before{content:"\\E091"}.glyphicon-arrow-right:before{content:"\\E092"}.glyphicon-arrow-up:before{content:"\\E093"}.glyphicon-arrow-down:before{content:"\\E094"}.glyphicon-share-alt:before{content:"\\E095"}.glyphicon-resize-full:before{content:"\\E096"}.glyphicon-resize-small:before{content:"\\E097"}.glyphicon-exclamation-sign:before{content:"\\E101"}.glyphicon-gift:before{content:"\\E102"}.glyphicon-leaf:before{content:"\\E103"}.glyphicon-fire:before{content:"\\E104"}.glyphicon-eye-open:before{content:"\\E105"}.glyphicon-eye-close:before{content:"\\E106"}.glyphicon-warning-sign:before{content:"\\E107"}.glyphicon-plane:before{content:"\\E108"}.glyphicon-calendar:before{content:"\\E109"}.glyphicon-random:before{content:"\\E110"}.glyphicon-comment:before{content:"\\E111"}.glyphicon-magnet:before{content:"\\E112"}.glyphicon-chevron-up:before{content:"\\E113"}.glyphicon-chevron-down:before{content:"\\E114"}.glyphicon-retweet:before{content:"\\E115"}.glyphicon-shopping-cart:before{content:"\\E116"}.glyphicon-folder-close:before{content:"\\E117"}.glyphicon-folder-open:before{content:"\\E118"}.glyphicon-resize-vertical:before{content:"\\E119"}.glyphicon-resize-horizontal:before{content:"\\E120"}.glyphicon-hdd:before{content:"\\E121"}.glyphicon-bullhorn:before{content:"\\E122"}.glyphicon-bell:before{content:"\\E123"}.glyphicon-certificate:before{content:"\\E124"}.glyphicon-thumbs-up:before{content:"\\E125"}.glyphicon-thumbs-down:before{content:"\\E126"}.glyphicon-hand-right:before{content:"\\E127"}.glyphicon-hand-left:before{content:"\\E128"}.glyphicon-hand-up:before{content:"\\E129"}.glyphicon-hand-down:before{content:"\\E130"}.glyphicon-circle-arrow-right:before{content:"\\E131"}.glyphicon-circle-arrow-left:before{content:"\\E132"}.glyphicon-circle-arrow-up:before{content:"\\E133"}.glyphicon-circle-arrow-down:before{content:"\\E134"}.glyphicon-globe:before{content:"\\E135"}.glyphicon-wrench:before{content:"\\E136"}.glyphicon-tasks:before{content:"\\E137"}.glyphicon-filter:before{content:"\\E138"}.glyphicon-briefcase:before{content:"\\E139"}.glyphicon-fullscreen:before{content:"\\E140"}.glyphicon-dashboard:before{content:"\\E141"}.glyphicon-paperclip:before{content:"\\E142"}.glyphicon-heart-empty:before{content:"\\E143"}.glyphicon-link:before{content:"\\E144"}.glyphicon-phone:before{content:"\\E145"}.glyphicon-pushpin:before{content:"\\E146"}.glyphicon-usd:before{content:"\\E148"}.glyphicon-gbp:before{content:"\\E149"}.glyphicon-sort:before{content:"\\E150"}.glyphicon-sort-by-alphabet:before{content:"\\E151"}.glyphicon-sort-by-alphabet-alt:before{content:"\\E152"}.glyphicon-sort-by-order:before{content:"\\E153"}.glyphicon-sort-by-order-alt:before{content:"\\E154"}.glyphicon-sort-by-attributes:before{content:"\\E155"}.glyphicon-sort-by-attributes-alt:before{content:"\\E156"}.glyphicon-unchecked:before{content:"\\E157"}.glyphicon-expand:before{content:"\\E158"}.glyphicon-collapse-down:before{content:"\\E159"}.glyphicon-collapse-up:before{content:"\\E160"}.glyphicon-log-in:before{content:"\\E161"}.glyphicon-flash:before{content:"\\E162"}.glyphicon-log-out:before{content:"\\E163"}.glyphicon-new-window:before{content:"\\E164"}.glyphicon-record:before{content:"\\E165"}.glyphicon-save:before{content:"\\E166"}.glyphicon-open:before{content:"\\E167"}.glyphicon-saved:before{content:"\\E168"}.glyphicon-import:before{content:"\\E169"}.glyphicon-export:before{content:"\\E170"}.glyphicon-send:before{content:"\\E171"}.glyphicon-floppy-disk:before{content:"\\E172"}.glyphicon-floppy-saved:before{content:"\\E173"}.glyphicon-floppy-remove:before{content:"\\E174"}.glyphicon-floppy-save:before{content:"\\E175"}.glyphicon-floppy-open:before{content:"\\E176"}.glyphicon-credit-card:before{content:"\\E177"}.glyphicon-transfer:before{content:"\\E178"}.glyphicon-cutlery:before{content:"\\E179"}.glyphicon-header:before{content:"\\E180"}.glyphicon-compressed:before{content:"\\E181"}.glyphicon-earphone:before{content:"\\E182"}.glyphicon-phone-alt:before{content:"\\E183"}.glyphicon-tower:before{content:"\\E184"}.glyphicon-stats:before{content:"\\E185"}.glyphicon-sd-video:before{content:"\\E186"}.glyphicon-hd-video:before{content:"\\E187"}.glyphicon-subtitles:before{content:"\\E188"}.glyphicon-sound-stereo:before{content:"\\E189"}.glyphicon-sound-dolby:before{content:"\\E190"}.glyphicon-sound-5-1:before{content:"\\E191"}.glyphicon-sound-6-1:before{content:"\\E192"}.glyphicon-sound-7-1:before{content:"\\E193"}.glyphicon-copyright-mark:before{content:"\\E194"}.glyphicon-registration-mark:before{content:"\\E195"}.glyphicon-cloud-download:before{content:"\\E197"}.glyphicon-cloud-upload:before{content:"\\E198"}.glyphicon-tree-conifer:before{content:"\\E199"}.glyphicon-tree-deciduous:before{content:"\\E200"}.glyphicon-cd:before{content:"\\E201"}.glyphicon-save-file:before{content:"\\E202"}.glyphicon-open-file:before{content:"\\E203"}.glyphicon-level-up:before{content:"\\E204"}.glyphicon-copy:before{content:"\\E205"}.glyphicon-paste:before{content:"\\E206"}.glyphicon-alert:before{content:"\\E209"}.glyphicon-equalizer:before{content:"\\E210"}.glyphicon-king:before{content:"\\E211"}.glyphicon-queen:before{content:"\\E212"}.glyphicon-pawn:before{content:"\\E213"}.glyphicon-bishop:before{content:"\\E214"}.glyphicon-knight:before{content:"\\E215"}.glyphicon-baby-formula:before{content:"\\E216"}.glyphicon-tent:before{content:"\\26FA"}.glyphicon-blackboard:before{content:"\\E218"}.glyphicon-bed:before{content:"\\E219"}.glyphicon-apple:before{content:"\\F8FF"}.glyphicon-erase:before{content:"\\E221"}.glyphicon-hourglass:before{content:"\\231B"}.glyphicon-lamp:before{content:"\\E223"}.glyphicon-duplicate:before{content:"\\E224"}.glyphicon-piggy-bank:before{content:"\\E225"}.glyphicon-scissors:before{content:"\\E226"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:"\\E227"}.glyphicon-jpy:before,.glyphicon-yen:before{content:"\\A5"}.glyphicon-rub:before,.glyphicon-ruble:before{content:"\\20BD"}.glyphicon-scale:before{content:"\\E230"}.glyphicon-ice-lolly:before{content:"\\E231"}.glyphicon-ice-lolly-tasted:before{content:"\\E232"}.glyphicon-education:before{content:"\\E233"}.glyphicon-option-horizontal:before{content:"\\E234"}.glyphicon-option-vertical:before{content:"\\E235"}.glyphicon-menu-hamburger:before{content:"\\E236"}.glyphicon-modal-window:before{content:"\\E237"}.glyphicon-oil:before{content:"\\E238"}.glyphicon-grain:before{content:"\\E239"}.glyphicon-sunglasses:before{content:"\\E240"}.glyphicon-text-size:before{content:"\\E241"}.glyphicon-text-color:before{content:"\\E242"}.glyphicon-text-background:before{content:"\\E243"}.glyphicon-object-align-top:before{content:"\\E244"}.glyphicon-object-align-bottom:before{content:"\\E245"}.glyphicon-object-align-horizontal:before{content:"\\E246"}.glyphicon-object-align-left:before{content:"\\E247"}.glyphicon-object-align-vertical:before{content:"\\E248"}.glyphicon-object-align-right:before{content:"\\E249"}.glyphicon-triangle-right:before{content:"\\E250"}.glyphicon-triangle-left:before{content:"\\E251"}.glyphicon-triangle-bottom:before{content:"\\E252"}.glyphicon-triangle-top:before{content:"\\E253"}.glyphicon-console:before{content:"\\E254"}.glyphicon-superscript:before{content:"\\E255"}.glyphicon-subscript:before{content:"\\E256"}.glyphicon-menu-left:before{content:"\\E257"}.glyphicon-menu-right:before{content:"\\E258"}.glyphicon-menu-down:before{content:"\\E259"}.glyphicon-menu-up:before{content:"\\E260"}*,:after,:before{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{display:inline-block;max-width:100%;height:auto;padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;overflow:hidden;clear:left;text-align:right;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:"\\2014   \\A0"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:""}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:"\\A0   \\2014"}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.25);box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;-webkit-box-shadow:none;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{margin-right:-15px;margin-left:-15px}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0;margin:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{background-color:transparent;border:0}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{min-height:34px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm{padding-right:0;padding-left:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;background-color:#dff0d8;border-color:#3c763d}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;background-color:#f2dede;border-color:#a94442}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none;border:1px solid transparent;border-radius:4px}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0;-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;filter:alpha(opacity=65);-webkit-box-shadow:none;box-shadow:none;opacity:.65}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{font-weight:400;color:#337ab7;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;-webkit-box-shadow:none;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;-webkit-transition:opacity .15s linear;-o-transition:opacity .15s linear;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;-webkit-transition-timing-function:ease;-o-transition-timing-function:ease;transition-timing-function:ease;-webkit-transition-duration:.35s;-o-transition-duration:.35s;transition-duration:.35s;-webkit-transition-property:height,visibility;-o-transition-property:height,visibility;transition-property:height,visibility}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;background-color:#337ab7;outline:0}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false)}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:"";border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{right:auto;left:0}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-right:8px;padding-left:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-right:12px;padding-left:12px}.btn-group.open .dropdown-toggle{-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{-webkit-box-shadow:none;box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-top-right-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{display:table-cell;float:none;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;cursor:not-allowed;background-color:transparent}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;cursor:default;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{padding-right:15px;padding-left:15px;overflow-x:visible;-webkit-overflow-scrolling:touch;border-top:1px solid transparent;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1)}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;-webkit-box-shadow:none;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-right:0;padding-left:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;height:50px;padding:15px;font-size:18px;line-height:20px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;padding:9px 10px;margin-top:8px;margin-right:15px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;-webkit-box-shadow:none;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{padding:10px 15px;margin:8px -15px;border-top:1px solid transparent;border-bottom:1px solid transparent;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;padding-top:0;padding-bottom:0;margin-right:0;margin-left:0;border:0;-webkit-box-shadow:none;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-left-radius:0;border-top-right-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-right:15px;margin-left:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#555;background-color:#e7e7e7}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{color:#fff;background-color:#080808}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{padding:0 5px;color:#ccc;content:"/\\A0"}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.42857143;color:#337ab7;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#337ab7;border-color:#337ab7}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;cursor:not-allowed;background-color:#fff;border-color:#ddd}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-top-left-radius:6px;border-bottom-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-top-right-radius:6px;border-bottom-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px}.pager{padding-left:0;margin:20px 0;text-align:center;list-style:none}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:middle;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{padding-right:15px;padding-left:15px;border-radius:6px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-right:60px;padding-left:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:border .2s ease-in-out;-o-transition:border .2s ease-in-out;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-right:auto;margin-left:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.thumbnail .caption{padding:9px;color:#333}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@-o-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.1);box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-transition:width .6s ease;-o-transition:width .6s ease;transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);-webkit-background-size:40px 40px;background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;-o-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{overflow:hidden;zoom:1}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:20px}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{color:#555;text-decoration:none;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#777;cursor:not-allowed;background-color:#eee}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;-webkit-box-shadow:0 1px 1px rgba(0,0,0,.05);box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-left-radius:3px;border-top-right-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-right:15px;padding-left:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{margin-bottom:0;border:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.05);box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}button.close{-webkit-appearance:none;padding:0;cursor:pointer;background:transparent;border:0}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{-webkit-transition:-webkit-transform .3s ease-out;-o-transition:-o-transform .3s ease-out;transition:transform .3s ease-out;-webkit-transform:translateY(-25%);-ms-transform:translateY(-25%);-o-transform:translateY(-25%);transform:translateY(-25%)}.modal.in .modal-dialog{-webkit-transform:translate(0);-ms-transform:translate(0);-o-transform:translate(0);transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;outline:0;-webkit-box-shadow:0 3px 9px rgba(0,0,0,.5);box-shadow:0 3px 9px rgba(0,0,0,.5)}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{filter:alpha(opacity=0);opacity:0}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{-webkit-box-shadow:0 5px 15px rgba(0,0,0,.5);box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;filter:alpha(opacity=0);opacity:0;line-break:auto}.tooltip.in{filter:alpha(opacity=90);opacity:.9}.tooltip.top{padding:5px 0;margin-top:-3px}.tooltip.right{padding:0 5px;margin-left:3px}.tooltip.bottom{padding:5px 0;margin-top:3px}.tooltip.left{padding:0 5px;margin-left:-3px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;-webkit-box-shadow:0 5px 10px rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2);line-break:auto}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{padding:8px 14px;margin:0;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{content:"";border-width:10px}.popover.top>.arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:#999;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.top>.arrow:after{bottom:1px;margin-left:-10px;content:" ";border-top-color:#fff;border-bottom-width:0}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:#999;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.right>.arrow:after{bottom:-10px;left:1px;content:" ";border-right-color:#fff;border-left-width:0}.popover.bottom>.arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25)}.popover.bottom>.arrow:after{top:1px;margin-left:-10px;content:" ";border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{right:1px;bottom:-10px;content:" ";border-right-width:0;border-left-color:#fff}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.item{position:relative;display:none;-webkit-transition:left .6s ease-in-out;-o-transition:.6s ease-in-out left;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{-webkit-transition:-webkit-transform .6s ease-in-out;-o-transition:-o-transform .6s ease-in-out;transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{left:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{left:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{left:0;-webkit-transform:translateZ(0);transform:translateZ(0)}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent;filter:alpha(opacity=50);opacity:.5}.carousel-control.left{background-image:-webkit-linear-gradient(left,rgba(0,0,0,.5),rgba(0,0,0,.0001));background-image:-o-linear-gradient(left,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001) 100%);background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,.0001)));background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr="#80000000",endColorstr="#00000000",GradientType=1);background-repeat:repeat-x}.carousel-control.right{right:0;left:auto;background-image:-webkit-linear-gradient(left,rgba(0,0,0,.0001),rgba(0,0,0,.5));background-image:-o-linear-gradient(left,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5) 100%);background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.0001)),to(rgba(0,0,0,.5)));background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr="#00000000",endColorstr="#80000000",GradientType=1);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;filter:alpha(opacity=90);outline:0;opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-10px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;font-family:serif;line-height:1}.carousel-control .icon-prev:before{content:"\\2039"}.carousel-control .icon-next:before{content:"\\203A"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:#000\\9;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{display:table;content:" "}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-right:auto;margin-left:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL2Jvb3RzdHJhcC9kaXN0L2Nzcy9ib290c3RyYXAuY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9ub2RlX21vZHVsZXMvYm9vdHN0cmFwL2Rpc3QvY3NzL2Jvb3RzdHJhcC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=bootstrap.css.ngstyle.js.map
// CONCATENATED MODULE: ./compiled/theme/css/material-dashboard.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var material_dashboard_css_ngstyle_styles = ['.noUi-target,.noUi-target *{-webkit-touch-callout:none;-ms-touch-action:none;user-select:none;box-sizing:border-box}.noUi-base{width:100%;height:100%;position:relative}.noUi-origin{position:absolute;right:0;top:0;left:0;bottom:0}.noUi-handle{position:relative;z-index:1}.noUi-stacking .noUi-handle{z-index:10}.noUi-state-tap .noUi-origin{transition:left .3s,top .3s}.noUi-state-drag *{cursor:inherit!important}.noUi-horizontal{height:10px}.noUi-handle{box-sizing:border-box;width:14px;height:14px;left:-10px;top:-6px;cursor:pointer;border-radius:100%;transition:all .2s ease-out;border:1px solid;background:#fff;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.noUi-vertical .noUi-handle{margin-left:5px;cursor:ns-resize}.noUi-horizontal.noUi-extended{padding:0 15px}.noUi-horizontal.noUi-extended .noUi-origin{right:-15px}.noUi-background{height:2px;margin:20px 0}.noUi-origin{margin:0;border-radius:0;height:2px;background:#c8c8c8}.noUi-origin[style^="left: 0"] .noUi-handle{background-color:#fff;border:2px solid #c8c8c8}.noUi-origin[style^="left: 0"] .noUi-handle.noUi-active{border-width:1px}.noUi-target{border-radius:3px}.noUi-horizontal{height:2px;margin:15px 0}.noUi-vertical{height:100%;width:2px;margin:0 15px;display:inline-block}.noUi-handle.noUi-active{transform:scale3d(2,2,1)}[disabled].noUi-slider{opacity:.5}[disabled] .noUi-handle{cursor:not-allowed}.slider{background:#c8c8c8}.slider.noUi-connect{background-color:#e07e3c}.slider .noUi-handle{border-color:#e07e3c}.slider.slider-info.noUi-connect,.slider.slider-info .noUi-connect{background-color:#00bcd4}.slider.slider-info .noUi-handle{border-color:#00bcd4}.slider.slider-success.noUi-connect,.slider.slider-success .noUi-connect{background-color:#4caf50}.slider.slider-success .noUi-handle{border-color:#4caf50}.slider.slider-warning.noUi-connect,.slider.slider-warning .noUi-connect{background-color:#e07e3c}.slider.slider-warning .noUi-handle{border-color:#e07e3c}.slider.slider-danger.noUi-connect,.slider.slider-danger .noUi-connect{background-color:#f44336}.slider.slider-danger .noUi-handle{border-color:#f44336}.animated.infinite{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.animated.bounceIn,.animated.bounceOut,.animated.flipOutX,.animated.flipOutY{-webkit-animation-duration:.75s;animation-duration:.75s}@-webkit-keyframes shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}@keyframes shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}.shake{-webkit-animation-name:shake;animation-name:shake}@-webkit-keyframes fadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInDown{-webkit-animation-name:fadeInDown;animation-name:fadeInDown}@-webkit-keyframes fadeOut{0%{opacity:1}to{opacity:0}}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{-webkit-animation-name:fadeOut;animation-name:fadeOut}@-webkit-keyframes fadeOutDown{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@keyframes fadeOutDown{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}.fadeOutDown{-webkit-animation-name:fadeOutDown;animation-name:fadeOutDown}@-webkit-keyframes fadeOutUp{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@keyframes fadeOutUp{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}.fadeOutUp{-webkit-animation-name:fadeOutUp;animation-name:fadeOutUp}.swal2-container,body.swal2-iosfix{position:fixed;left:0;right:0}body.swal2-shown{overflow-y:hidden}.swal2-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;top:0;bottom:0;padding:10px;background-color:transparent;z-index:1060}.swal2-container.swal2-fade{-webkit-transition:background-color .1s;transition:background-color .1s}.swal2-container.swal2-shown{background-color:rgba(0,0,0,.4)}.swal2-modal{background-color:#fff;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;border-radius:5px;box-sizing:border-box;text-align:center;margin:auto;overflow-x:hidden;overflow-y:auto;display:none;position:relative}.swal2-modal:focus{outline:0}.swal2-modal.swal2-loading{overflow-y:hidden}.swal2-modal .swal2-title{color:#595959;font-size:30px;text-align:center;font-weight:600;text-transform:none;position:relative;margin:0 0 .4em;padding:0;display:block}.swal2-modal .swal2-spacer{height:10px;color:transparent;border:0}.swal2-modal .swal2-styled{border:0;border-radius:3px;box-shadow:none;color:#fff;cursor:pointer;font-size:17px;font-weight:500;margin:0 5px;padding:10px 32px}.swal2-modal .swal2-styled:not(.swal2-loading)[disabled]{opacity:.4;cursor:no-drop}.swal2-modal .swal2-styled.swal2-loading{box-sizing:border-box;border:4px solid transparent;width:40px;height:40px;padding:0;margin:-2px 30px;vertical-align:top;background-color:transparent!important;color:transparent;cursor:default;border-radius:100%;-webkit-animation:rotate-loading 1.5s linear 0s infinite normal;animation:rotate-loading 1.5s linear 0s infinite normal;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-modal .swal2-styled+.swal2-styled{margin-top:15px}.swal2-modal :not(.swal2-styled).swal2-loading:after{display:inline-block;content:"";margin-left:5px;vertical-align:-1px;height:6px;width:6px;border:3px solid #999;border-right-color:transparent;border-radius:50%;-webkit-animation:rotate-loading 1.5s linear 0s infinite normal;animation:rotate-loading 1.5s linear 0s infinite normal}.swal2-modal .swal2-checkbox input,.swal2-modal .swal2-checkbox span,.swal2-modal .swal2-radio input,.swal2-modal .swal2-radio span{vertical-align:middle}.swal2-modal .swal2-image{margin:20px auto;max-width:100%}.swal2-modal .swal2-close{font-size:36px;line-height:36px;font-family:serif;position:absolute;top:5px;right:13px;cursor:pointer;color:#ccc;-webkit-transition:color .1s ease;transition:color .1s ease}.swal2-modal .swal2-close:hover{color:#d55}.swal2-modal>.swal2-checkbox,.swal2-modal>.swal2-file,.swal2-modal>.swal2-input,.swal2-modal>.swal2-radio,.swal2-modal>.swal2-select,.swal2-modal>.swal2-textarea{display:none}.swal2-modal .swal2-content{font-size:18px;text-align:center;font-weight:300;position:relative;float:none;margin:0;padding:0;line-height:normal;color:#545454}.swal2-modal .swal2-checkbox,.swal2-modal .swal2-file,.swal2-modal .swal2-input,.swal2-modal .swal2-radio,.swal2-modal .swal2-select,.swal2-modal .swal2-textarea{margin:20px auto}.swal2-modal .swal2-file,.swal2-modal .swal2-input,.swal2-modal .swal2-textarea{width:100%;box-sizing:border-box;border-radius:3px;border:1px solid #d9d9d9;font-size:18px;box-shadow:inset 0 1px 1px rgba(0,0,0,.06);-webkit-transition:border-color box-shadow .3s;transition:border-color box-shadow .3s}.swal2-modal .swal2-file.swal2-inputerror,.swal2-modal .swal2-input.swal2-inputerror,.swal2-modal .swal2-textarea.swal2-inputerror{border-color:#f06e57!important}.swal2-modal .swal2-file:focus,.swal2-modal .swal2-input:focus,.swal2-modal .swal2-textarea:focus{outline:0;box-shadow:0 0 3px #c4e6f5;border:1px solid #b4dbed}.swal2-modal .swal2-file:focus::-webkit-input-placeholder,.swal2-modal .swal2-input:focus::-webkit-input-placeholder,.swal2-modal .swal2-textarea:focus::-webkit-input-placeholder{-webkit-transition:opacity .3s ease .03s;transition:opacity .3s ease .03s;opacity:.8}.swal2-modal .swal2-file:focus::-moz-placeholder,.swal2-modal .swal2-input:focus::-moz-placeholder,.swal2-modal .swal2-textarea:focus::-moz-placeholder{-webkit-transition:opacity .3s ease .03s;transition:opacity .3s ease .03s;opacity:.8}.swal2-modal .swal2-file:focus:-ms-input-placeholder,.swal2-modal .swal2-input:focus:-ms-input-placeholder,.swal2-modal .swal2-textarea:focus:-ms-input-placeholder{-webkit-transition:opacity .3s ease .03s;transition:opacity .3s ease .03s;opacity:.8}.swal2-modal .swal2-file:focus::placeholder,.swal2-modal .swal2-input:focus::placeholder,.swal2-modal .swal2-textarea:focus::placeholder{-webkit-transition:opacity .3s ease .03s;transition:opacity .3s ease .03s;opacity:.8}.swal2-modal .swal2-file::-webkit-input-placeholder,.swal2-modal .swal2-input::-webkit-input-placeholder,.swal2-modal .swal2-textarea::-webkit-input-placeholder{color:#e6e6e6}.swal2-modal .swal2-file::-moz-placeholder,.swal2-modal .swal2-input::-moz-placeholder,.swal2-modal .swal2-textarea::-moz-placeholder{color:#e6e6e6}.swal2-modal .swal2-file:-ms-input-placeholder,.swal2-modal .swal2-input:-ms-input-placeholder,.swal2-modal .swal2-textarea:-ms-input-placeholder{color:#e6e6e6}.swal2-modal .swal2-file::placeholder,.swal2-modal .swal2-input::placeholder,.swal2-modal .swal2-textarea::placeholder{color:#e6e6e6}.swal2-modal .swal2-range input{float:left;width:80%}.swal2-modal .swal2-range output{float:right;width:20%;font-size:20px;font-weight:600;text-align:center}.swal2-modal .swal2-range input,.swal2-modal .swal2-range output{height:43px;line-height:43px;vertical-align:middle;margin:20px auto;padding:0}.swal2-modal .swal2-input{height:43px;padding:0 12px}.swal2-modal .swal2-input[type=number]{max-width:150px}.swal2-modal .swal2-file{font-size:20px}.swal2-modal .swal2-textarea{height:108px;padding:12px}.swal2-modal .swal2-select{color:#545454;font-size:inherit;padding:5px 10px;min-width:40%;max-width:100%}.swal2-modal .swal2-radio{border:0}.swal2-modal .swal2-radio label:not(:first-child){margin-left:20px}.swal2-modal .swal2-radio input{margin:0 3px 0 0}.swal2-modal .swal2-checkbox{color:#545454}.swal2-modal .swal2-validationerror{background-color:#f0f0f0;margin:0 -20px;overflow:hidden;padding:10px;color:gray;font-size:16px;font-weight:300;display:none}.swal2-modal .swal2-validationerror:before{content:"!";display:inline-block;width:24px;height:24px;border-radius:50%;background-color:#ea7d7d;color:#fff;line-height:24px;text-align:center;margin-right:10px}.swal2-icon.swal2-info,.swal2-icon.swal2-question,.swal2-icon.swal2-warning{font-size:60px;line-height:80px;text-align:center}@supports (-ms-accelerator:true){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.swal2-range input{width:100%!important}.swal2-range output{display:none}}.swal2-icon{width:80px;height:80px;border:4px solid transparent;border-radius:50%;margin:20px auto 30px;padding:0;position:relative;box-sizing:content-box;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-icon.swal2-error{border-color:#f27474}.swal2-icon.swal2-error .x-mark{position:relative;display:block}.swal2-icon.swal2-error .line{position:absolute;height:5px;width:47px;background-color:#f27474;display:block;top:37px;border-radius:2px}.swal2-icon.swal2-error .line.left{-webkit-transform:rotate(45deg);transform:rotate(45deg);left:17px}.swal2-icon.swal2-error .line.right{-webkit-transform:rotate(-45deg);transform:rotate(-45deg);right:16px}.swal2-icon.swal2-warning{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;color:#f8bb86;border-color:#facea8}.swal2-icon.swal2-info{font-family:Open Sans,sans-serif;color:#3fc3ee;border-color:#9de0f6}.swal2-icon.swal2-question{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;color:#87adbd;border-color:#c9dae1}.swal2-icon.swal2-success{border-color:#a5dc86}.swal2-icon.swal2-success:after,.swal2-icon.swal2-success:before{content:"";position:absolute;width:60px;height:120px;background:#fff}.swal2-icon.swal2-success:before{border-radius:120px 0 0 120px;top:-7px;left:-33px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:60px 60px;transform-origin:60px 60px}.swal2-icon.swal2-success:after{border-radius:0 120px 120px 0;top:-11px;left:30px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:0 60px;transform-origin:0 60px}.swal2-icon.swal2-success .placeholder{width:80px;height:80px;border:4px solid hsla(98,55%,69%,.2);border-radius:50%;box-sizing:content-box;position:absolute;left:-4px;top:-4px;z-index:2}.swal2-icon.swal2-success .fix{width:7px;height:90px;background-color:#fff;position:absolute;left:28px;top:8px;z-index:1;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal2-icon.swal2-success .line{height:5px;background-color:#a5dc86;display:block;border-radius:2px;position:absolute;z-index:2}.swal2-icon.swal2-success .line.tip{width:25px;left:14px;top:46px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal2-icon.swal2-success .line.long{width:47px;right:8px;top:38px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal2-progresssteps{font-weight:600;margin:0 0 20px;padding:0}.swal2-progresssteps li{display:inline-block;position:relative}.swal2-progresssteps .swal2-progresscircle{background:#3085d6;border-radius:2em;color:#fff;height:2em;line-height:2em;text-align:center;width:2em;z-index:20}.swal2-progresssteps .swal2-progresscircle:first-child{margin-left:0}.swal2-progresssteps .swal2-progresscircle:last-child{margin-right:0}.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep{background:#3085d6}.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep~.swal2-progresscircle,.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep~.swal2-progressline{background:#add8e6}.swal2-progresssteps .swal2-progressline{background:#3085d6;height:.4em;margin:0 -1px;z-index:10}[class^=swal2]{-webkit-tap-highlight-color:transparent}@-webkit-keyframes showSweetAlert{0%{-webkit-transform:scale(.7);transform:scale(.7)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes showSweetAlert{0%{-webkit-transform:scale(.7);transform:scale(.7)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes hideSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}to{-webkit-transform:scale(.5);transform:scale(.5);opacity:0}}@keyframes hideSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}to{-webkit-transform:scale(.5);transform:scale(.5);opacity:0}}.swal2-show{-webkit-animation:showSweetAlert .3s;animation:showSweetAlert .3s}.swal2-show.swal2-noanimation{-webkit-animation:none;animation:none}.swal2-hide{-webkit-animation:hideSweetAlert .15s forwards;animation:hideSweetAlert .15s forwards}.swal2-hide.swal2-noanimation{-webkit-animation:none;animation:none}@-webkit-keyframes animate-success-tip{0%,54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@keyframes animate-success-tip{0%,54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@-webkit-keyframes animate-success-long{0%,65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}@keyframes animate-success-long{0%,65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}@-webkit-keyframes rotatePlaceholder{0%,5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%,to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@keyframes rotatePlaceholder{0%,5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%,to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}.animate-success-tip{-webkit-animation:animate-success-tip .75s;animation:animate-success-tip .75s}.animate-success-long{-webkit-animation:animate-success-long .75s;animation:animate-success-long .75s}.swal2-success.animate:after{-webkit-animation:rotatePlaceholder 4.25s ease-in;animation:rotatePlaceholder 4.25s ease-in}@-webkit-keyframes animate-error-icon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0);transform:rotateX(0);opacity:1}}@keyframes animate-error-icon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0);transform:rotateX(0);opacity:1}}.animate-error-icon{-webkit-animation:animate-error-icon .5s;animation:animate-error-icon .5s}@-webkit-keyframes animate-x-mark{0%,50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}@keyframes animate-x-mark{0%,50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}.animate-x-mark{-webkit-animation:animate-x-mark .5s;animation:animate-x-mark .5s}@-webkit-keyframes pulse-warning{0%{border-color:#f8d486}to{border-color:#f8bb86}}@keyframes pulse-warning{0%{border-color:#f8d486}to{border-color:#f8bb86}}.pulse-warning{-webkit-animation:pulse-warning .75s infinite alternate;animation:pulse-warning .75s infinite alternate}@-webkit-keyframes rotate-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotate-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}table.dataTable{clear:both;margin-top:6px!important;margin-bottom:6px!important;max-width:none!important;border-collapse:separate!important}table.dataTable td,table.dataTable th{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}table.dataTable td.dataTables_empty,table.dataTable th.dataTables_empty{text-align:center}table.dataTable.nowrap td,table.dataTable.nowrap th{white-space:nowrap}div.dataTables_wrapper div.dataTables_length label{font-weight:400;text-align:left;white-space:nowrap}div.dataTables_wrapper div.dataTables_length select{width:75px;display:inline-block}div.dataTables_wrapper div.dataTables_filter{text-align:right}div.dataTables_wrapper div.dataTables_filter label{font-weight:400;white-space:nowrap;text-align:left}div.dataTables_wrapper div.dataTables_filter input{margin-left:.5em;display:inline-block;width:100%}div.dataTables_wrapper div.dataTables_info{padding-top:8px;white-space:nowrap}div.dataTables_wrapper div.dataTables_paginate{margin:0;white-space:nowrap;text-align:right}div.dataTables_wrapper div.dataTables_paginate ul.pagination{margin:2px 0;white-space:nowrap}div.dataTables_wrapper div.dataTables_processing{position:absolute;top:50%;left:50%;width:200px;margin-left:-100px;margin-top:-26px;text-align:center;padding:1em 0}table.dataTable thead>tr>td.sorting,table.dataTable thead>tr>td.sorting_asc,table.dataTable thead>tr>td.sorting_desc,table.dataTable thead>tr>th.sorting,table.dataTable thead>tr>th.sorting_asc,table.dataTable thead>tr>th.sorting_desc{padding-right:30px}table.dataTable thead>tr>td:active,table.dataTable thead>tr>th:active{outline:none}table.dataTable thead .sorting,table.dataTable thead .sorting_asc,table.dataTable thead .sorting_asc_disabled,table.dataTable thead .sorting_desc,table.dataTable thead .sorting_desc_disabled{cursor:pointer;position:relative}table.dataTable thead .sorting:after,table.dataTable thead .sorting_asc:after,table.dataTable thead .sorting_asc_disabled:after,table.dataTable thead .sorting_desc:after,table.dataTable thead .sorting_desc_disabled:after{position:absolute;bottom:8px;right:8px;display:block;font-family:Glyphicons Halflings;opacity:.5}table.dataTable thead .sorting:after{opacity:.2;content:"\\E150"}table.dataTable thead .sorting_asc:after{content:"\\E155"}table.dataTable thead .sorting_desc:after{content:"\\E156"}table.dataTable thead .sorting_asc_disabled:after,table.dataTable thead .sorting_desc_disabled:after{color:#eee}div.dataTables_scrollHead table.dataTable{margin-bottom:0!important}div.dataTables_scrollBody table{border-top:none;margin-top:0!important;margin-bottom:0!important}div.dataTables_scrollBody table thead .sorting:after,div.dataTables_scrollBody table thead .sorting_asc:after,div.dataTables_scrollBody table thead .sorting_desc:after{display:none}div.dataTables_scrollBody table tbody tr:first-child td,div.dataTables_scrollBody table tbody tr:first-child th{border-top:none}div.dataTables_scrollFoot table{margin-top:0!important;border-top:none}@media screen and (max-width:767px){div.dataTables_wrapper div.dataTables_filter,div.dataTables_wrapper div.dataTables_info,div.dataTables_wrapper div.dataTables_length,div.dataTables_wrapper div.dataTables_paginate{text-align:center}}table.dataTable.table-condensed>thead>tr>th{padding-right:20px}table.dataTable.table-condensed .sorting:after,table.dataTable.table-condensed .sorting_asc:after,table.dataTable.table-condensed .sorting_desc:after{top:6px;right:6px}table.table-bordered.dataTable td,table.table-bordered.dataTable th{border-left-width:0}table.table-bordered.dataTable td:last-child,table.table-bordered.dataTable th:last-child{border-right-width:0}div.dataTables_scrollHead table.table-bordered,table.table-bordered.dataTable tbody td,table.table-bordered.dataTable tbody th{border-bottom-width:0}div.table-responsive>div.dataTables_wrapper>div.row{margin:0}table.dataTable .btn-simple.btn-icon{padding:3px}table.dataTable thead .sorting:after,table.dataTable thead .sorting_asc:after,table.dataTable thead .sorting_asc_disabled:after,table.dataTable thead .sorting_desc:after,table.dataTable thead .sorting_desc_disabled:after{position:relative;display:inline-block;bottom:1px;right:-7px;font-family:FontAwesome;opacity:.8;font-size:12px}table.dataTable thead .disabled-sorting.sorting:after,table.dataTable thead .disabled-sorting.sorting_asc:after,table.dataTable thead .disabled-sorting.sorting_asc_disabled:after,table.dataTable thead .disabled-sorting.sorting_desc:after,table.dataTable thead .disabled-sorting.sorting_desc_disabled:after{display:none}table.dataTable thead .sorting:after{opacity:.4;content:"\\F0DC"}table.dataTable thead .sorting_asc:after{content:"\\F0DE";top:2px}table.dataTable thead .sorting_desc:after{content:"\\F0DD";top:-3px}table.dataTable>tbody>tr>td,table.dataTable>tbody>tr>th,table.dataTable>tfoot>tr>td,table.dataTable>tfoot>tr>th,table.dataTable>thead>tr>td,table.dataTable>thead>tr>th{padding:5px!important;outline:0}table.dataTable>thead>tr>th{border:none}.dataTables_paginate a{outline:0}table.dataTable.dtr-inline.collapsed>tbody>tr>td.child,table.dataTable.dtr-inline.collapsed>tbody>tr>td.dataTables_empty,table.dataTable.dtr-inline.collapsed>tbody>tr>th.child{cursor:default!important}table.dataTable.dtr-inline.collapsed>tbody>tr>td.child:before,table.dataTable.dtr-inline.collapsed>tbody>tr>td.dataTables_empty:before,table.dataTable.dtr-inline.collapsed>tbody>tr>th.child:before{display:none!important}table.dataTable.dtr-inline.collapsed>tbody>tr>td:first-child,table.dataTable.dtr-inline.collapsed>tbody>tr>th:first-child{position:relative;padding-left:30px;cursor:pointer}table.dataTable.dtr-inline.collapsed>tbody>tr>td:first-child:before,table.dataTable.dtr-inline.collapsed>tbody>tr>th:first-child:before{top:50%;margin-top:-9px;left:4px;height:18px;width:18px;display:block;position:absolute;color:#4caf50;border:0 solid #fff;border-radius:14px;box-shadow:0 0 3px #444;box-sizing:content-box;text-align:center;font-family:Courier New,Courier,monospace;line-height:18px;content:"+";background-color:#fff}table.dataTable.dtr-inline.collapsed>tbody>tr.parent>td:first-child:before,table.dataTable.dtr-inline.collapsed>tbody>tr.parent>th:first-child:before{content:"-";color:#f44336}table.dataTable.dtr-inline.collapsed>tbody>tr.child td:before{display:none}table.dataTable.dtr-inline.collapsed.compact>tbody>tr>td:first-child,table.dataTable.dtr-inline.collapsed.compact>tbody>tr>th:first-child{padding-left:27px}table.dataTable.dtr-inline.collapsed.compact>tbody>tr>td:first-child:before,table.dataTable.dtr-inline.collapsed.compact>tbody>tr>th:first-child:before{top:5px;left:4px;height:14px;width:14px;border-radius:14px;line-height:14px;text-indent:3px}table.dataTable.dtr-column>tbody>tr>td.control,table.dataTable.dtr-column>tbody>tr>th.control{position:relative;cursor:pointer}table.dataTable.dtr-column>tbody>tr>td.control:before,table.dataTable.dtr-column>tbody>tr>th.control:before{top:50%;left:50%;height:16px;width:16px;margin-top:-10px;margin-left:-10px;display:block;position:absolute;color:#fff;border:2px solid #fff;border-radius:14px;box-shadow:0 0 3px #444;box-sizing:content-box;text-align:center;font-family:Courier New,Courier,monospace;line-height:14px;content:"+";background-color:#31b131}table.dataTable.dtr-column>tbody>tr.parent td.control:before,table.dataTable.dtr-column>tbody>tr.parent th.control:before{content:"-";background-color:#d33333}table.dataTable>tbody>tr.child{padding:.5em 1em}table.dataTable>tbody>tr.child:hover{background:transparent!important}table.dataTable>tbody>tr.child ul{display:inline-block;list-style-type:none;margin:0;padding:0}table.dataTable>tbody>tr.child ul li{border-bottom:1px solid #efefef;padding:.5em 0}table.dataTable>tbody>tr.child ul li:first-child{padding-top:0}table.dataTable>tbody>tr.child ul li:last-child{border-bottom:none}table.dataTable>tbody>tr.child span.dtr-title{display:inline-block;min-width:75px;font-weight:700}div.dtr-modal{position:fixed;box-sizing:border-box;top:0;left:0;height:100%;width:100%;z-index:100;padding:10em 1em}div.dtr-modal div.dtr-modal-display{position:absolute;top:0;left:0;bottom:0;right:0;width:50%;height:50%;margin:auto;z-index:102;overflow:auto;background-color:#f5f5f7;border:1px solid #000;border-radius:.5em;box-shadow:0 12px 30px rgba(0,0,0,.6)}div.dtr-modal div.dtr-modal-content{position:relative;padding:1em}div.dtr-modal div.dtr-modal-close{position:absolute;top:6px;right:6px;width:22px;height:22px;border:1px solid #eaeaea;background-color:#f9f9f9;text-align:center;border-radius:3px;cursor:pointer;z-index:12}div.dtr-modal div.dtr-modal-close:hover{background-color:#eaeaea}div.dtr-modal div.dtr-modal-background{position:fixed;top:0;left:0;right:0;bottom:0;z-index:101;background:rgba(0,0,0,.6)}.material-datatables .input-sm{height:35px;padding:0}@media screen and (max-width:767px){div.dtr-modal div.dtr-modal-display{width:95%}table.dataTable>tbody>tr>td:first-child{padding-left:30px!important}table>thead>tr>th{width:60px!important}div.dataTables_wrapper div.dataTables_filter input,div.dataTables_wrapper div.dataTables_filter label,div.dataTables_wrapper div.dataTables_length div.form-group,div.dataTables_wrapper div.dataTables_length label,div.dataTables_wrapper div.dataTables_length select{width:100%}div.dataTables_wrapper div.dataTables_filter input{margin-left:0}}@media (min-width:520px) and (max-width:730px){table.dataTable .btn-simple.btn-icon{display:block;margin:0}}svg{touch-action:none}.jvectormap-container{width:100%;height:100%;position:relative;overflow:hidden;touch-action:none}.jvectormap-tip{position:absolute;display:none;color:#555;line-height:1.5em;background:#fff;border:none;border-radius:30px;box-shadow:0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12),0 5px 5px -3px rgba(0,0,0,.2);padding:5px 10px;z-index:1040}.jvectormap-goback,.jvectormap-zoomin,.jvectormap-zoomout{position:absolute;left:10px;border-radius:3px;background:#292929;padding:3px;color:#fff;cursor:pointer;line-height:10px;text-align:center;box-sizing:content-box}.jvectormap-zoomin,.jvectormap-zoomout{width:10px;height:10px}.jvectormap-zoomin{top:10px}.jvectormap-zoomout{top:30px}.jvectormap-goback{bottom:10px;z-index:1000;padding:6px}.jvectormap-spinner{position:absolute;left:0;top:0;right:0;bottom:0;background:50% no-repeat url(data:image/gif;base64,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)}.jvectormap-legend-title{font-weight:700;font-size:14px;text-align:center}.jvectormap-legend-cnt{position:absolute}.jvectormap-legend-cnt-h{bottom:0;right:0}.jvectormap-legend-cnt-v{top:0;right:0}.jvectormap-legend{background:#000;color:#fff;border-radius:3px}.jvectormap-legend-cnt-h .jvectormap-legend{float:left;margin:0 10px 10px 0;padding:3px 3px 1px}.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick{float:left}.jvectormap-legend-cnt-v .jvectormap-legend{margin:10px 10px 0 0;padding:3px}.jvectormap-legend-cnt-h .jvectormap-legend-tick{width:40px}.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample{height:15px}.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample{height:20px;width:20px;display:inline-block;vertical-align:middle}.jvectormap-legend-tick-text{font-size:12px}.jvectormap-legend-cnt-h .jvectormap-legend-tick-text{text-align:center}.jvectormap-legend-cnt-v .jvectormap-legend-tick-text{display:inline-block;vertical-align:middle;line-height:20px;padding-left:3px}\r\n\r\n.bootstrap-datetimepicker-widget .btn[data-action=clear]:after,.bootstrap-datetimepicker-widget .btn[data-action=decrementHours]:after,.bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]:after,.bootstrap-datetimepicker-widget .btn[data-action=incrementHours]:after,.bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]:after,.bootstrap-datetimepicker-widget .btn[data-action=showHours]:after,.bootstrap-datetimepicker-widget .btn[data-action=showMinutes]:after,.bootstrap-datetimepicker-widget .btn[data-action=today]:after,.bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]:after,.bootstrap-datetimepicker-widget .picker-switch:after,.bootstrap-datetimepicker-widget table th.next:after,.bootstrap-datetimepicker-widget table th.prev:after,.sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}.bootstrap-datetimepicker-widget{list-style:none}.bootstrap-datetimepicker-widget a .btn:hover{background-color:transparent}.bootstrap-datetimepicker-widget.dropdown-menu{padding:4px;width:19em}@media (min-width:768px){.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs{width:38em}}@media (min-width:992px){.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs{width:38em}}@media (min-width:1200px){.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs{width:38em}}.bootstrap-datetimepicker-widget.dropdown-menu.bottom{visibility:visible;opacity:1}.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after,.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before{right:auto;left:12px}.bootstrap-datetimepicker-widget.dropdown-menu.top{margin-top:auto;margin-bottom:-20px}.bootstrap-datetimepicker-widget.dropdown-menu.top.open{margin-top:auto;margin-bottom:5px}.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before{left:auto;right:6px}.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after{left:auto;right:7px}.bootstrap-datetimepicker-widget .list-unstyled{margin:0}.bootstrap-datetimepicker-widget a[data-action]{padding:0;margin:0;border-width:0;background-color:transparent;color:#e07e3c;box-shadow:none}.bootstrap-datetimepicker-widget a[data-action]:hover{background-color:transparent}.bootstrap-datetimepicker-widget a[data-action]:hover span{background-color:#eee;color:#e07e3c}.bootstrap-datetimepicker-widget a[data-action]:active{box-shadow:none}.bootstrap-datetimepicker-widget .timepicker-hour,.bootstrap-datetimepicker-widget .timepicker-minute,.bootstrap-datetimepicker-widget .timepicker-second{width:40px;height:40px;line-height:40px;font-weight:300;font-size:1.3em;margin:0;border-radius:50%}.bootstrap-datetimepicker-widget button[data-action]{width:38px;height:38px;margin-right:3px;padding:0}.bootstrap-datetimepicker-widget .btn[data-action=incrementHours]:after{content:"Increment Hours"}.bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]:after{content:"Increment Minutes"}.bootstrap-datetimepicker-widget .btn[data-action=decrementHours]:after{content:"Decrement Hours"}.bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]:after{content:"Decrement Minutes"}.bootstrap-datetimepicker-widget .btn[data-action=showHours]:after{content:"Show Hours"}.bootstrap-datetimepicker-widget .btn[data-action=showMinutes]:after{content:"Show Minutes"}.bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]:after{content:"Toggle AM/PM"}.bootstrap-datetimepicker-widget .btn[data-action=clear]:after{content:"Clear the picker"}.bootstrap-datetimepicker-widget .btn[data-action=today]:after{content:"Set the date to today"}.bootstrap-datetimepicker-widget .picker-switch{text-align:center;border-radius:3px}.bootstrap-datetimepicker-widget .picker-switch:after{content:"Toggle Date and Time Screens"}.bootstrap-datetimepicker-widget .picker-switch td{padding:0;margin:0;height:auto;width:auto;line-height:inherit}.bootstrap-datetimepicker-widget .picker-switch td span{line-height:2.5;height:2.5em;width:100%;border-radius:3px;margin:2px 0!important}.bootstrap-datetimepicker-widget table{width:100%;margin:0}.bootstrap-datetimepicker-widget table.table-condensed tr>td,.bootstrap-datetimepicker-widget table td>div,.bootstrap-datetimepicker-widget table th>div{text-align:center}.bootstrap-datetimepicker-widget table th{height:20px;line-height:20px;width:20px;font-weight:500}.bootstrap-datetimepicker-widget table th.picker-switch{width:145px}.bootstrap-datetimepicker-widget table th.disabled,.bootstrap-datetimepicker-widget table th.disabled:hover{background:none;color:#eee;cursor:not-allowed}.bootstrap-datetimepicker-widget table th.next span,.bootstrap-datetimepicker-widget table th.prev span{border-radius:3px;height:27px;width:27px;line-height:28px;font-size:12px;border-radius:50%;text-align:center}.bootstrap-datetimepicker-widget table th.prev:after{content:"Previous Month"}.bootstrap-datetimepicker-widget table th.next:after{content:"Next Month"}.bootstrap-datetimepicker-widget table th.dow{text-align:center;border-bottom:1px solid #eee;font-size:12px;text-transform:uppercase;color:#333;font-weight:400;padding-bottom:5px;padding-top:10px}.bootstrap-datetimepicker-widget table thead tr:first-child th{cursor:pointer}.bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover,.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span{background:#eee}.bootstrap-datetimepicker-widget table td>div{border-radius:3px;height:54px;line-height:54px;width:54px;text-align:center}.bootstrap-datetimepicker-widget table td.cw>div{font-size:.8em;height:20px;line-height:20px;color:#999}.bootstrap-datetimepicker-widget table td.day>div{height:30px;line-height:30px;width:30px;text-align:center;padding:0;border-radius:50%}.bootstrap-datetimepicker-widget table td.hour>div,.bootstrap-datetimepicker-widget table td.minute>div{border-radius:50%}.bootstrap-datetimepicker-widget table td.day:hover>div,.bootstrap-datetimepicker-widget table td.hour:hover>div,.bootstrap-datetimepicker-widget table td.minute:hover>div,.bootstrap-datetimepicker-widget table td.second:hover>div{background:#eee;cursor:pointer}.bootstrap-datetimepicker-widget table td.new>div,.bootstrap-datetimepicker-widget table td.old>div{color:#999}.bootstrap-datetimepicker-widget table td.today>div{position:relative}.bootstrap-datetimepicker-widget table td.today>div:before{content:"";display:inline-block;border:7px solid transparent;border-bottom-color:#e07e3c;border-top-color:rgba(0,0,0,.2);position:absolute;bottom:4px;right:4px}.bootstrap-datetimepicker-widget table td.active:hover>div,.bootstrap-datetimepicker-widget table td.active>div{background-color:#e07e3c;color:#fff;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.bootstrap-datetimepicker-widget table td.active.today:before>div{border-bottom-color:#fff}.bootstrap-datetimepicker-widget table td.disabled:hover>div,.bootstrap-datetimepicker-widget table td.disabled>div{background:none;color:#eee;cursor:not-allowed}.bootstrap-datetimepicker-widget table td span{display:inline-block;width:40px;height:40px;line-height:40px;margin:3px;cursor:pointer;border-radius:50%;text-align:center}.bootstrap-datetimepicker-widget table td span:hover{background:#eee}.bootstrap-datetimepicker-widget table td span.active{background-color:#e07e3c;color:#fff}.bootstrap-datetimepicker-widget table td span.old{color:#999}.bootstrap-datetimepicker-widget table td span.disabled,.bootstrap-datetimepicker-widget table td span.disabled:hover{background:none;color:#eee;cursor:not-allowed}.bootstrap-datetimepicker-widget .timepicker-hours span,.bootstrap-datetimepicker-widget .timepicker-minutes span,.bootstrap-datetimepicker-widget .timepicker-picker span{border-radius:50%!important}.bootstrap-datetimepicker-widget.usetwentyfour td.hour{height:27px;line-height:27px}.input-group.date .input-group-addon{cursor:pointer}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:1px;text-align:center}\r\n\r\n.fc{direction:ltr;text-align:left}.fc-rtl{text-align:right}body .fc{font-size:1em}.fc-unthemed .fc-content,.fc-unthemed .fc-divider,.fc-unthemed .fc-list-heading td,.fc-unthemed .fc-list-view,.fc-unthemed .fc-popover,.fc-unthemed .fc-row,.fc-unthemed tbody,.fc-unthemed td,.fc-unthemed th,.fc-unthemed thead{border-color:#ddd}.fc-unthemed .fc-popover{background-color:#fff}.fc-unthemed .fc-divider,.fc-unthemed .fc-list-heading td,.fc-unthemed .fc-popover .fc-header{background:#999}.fc-unthemed .fc-popover .fc-header .fc-close{color:#999}.fc-unthemed .fc-today{background:#f5f5f5}.fc-highlight{background:#bce8f1;opacity:.3}.fc-bgevent{background:#8fdf82;opacity:.3}.fc-nonbusiness{background:#d7d7d7}.fc-icon{display:inline-block;height:1em;line-height:1em;font-size:1em;text-align:center;overflow:hidden;font-family:Courier New,Courier,monospace;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.fc-icon:after{position:relative}.fc-icon-left-single-arrow:after{content:"\\2039";font-weight:700;font-size:200%;top:-7%}.fc-icon-right-single-arrow:after{content:"\\203A";font-weight:700;font-size:200%;top:-7%}.fc-icon-left-double-arrow:after{content:"\\AB";font-size:160%;top:-7%}.fc-icon-right-double-arrow:after{content:"\\BB";font-size:160%;top:-7%}.fc-icon-left-triangle:after{content:"\\25C4";font-size:125%;top:3%}.fc-icon-right-triangle:after{content:"\\25BA";font-size:125%;top:3%}.fc-icon-down-triangle:after{content:"\\25BC";font-size:125%;top:2%}.fc-icon-x:after{content:"\\D7";font-size:200%;top:6%}.fc button{border:none;border-radius:30px;position:relative;padding:6px 12px;font-weight:400;letter-spacing:0;will-change:box-shadow,transform;transition:box-shadow .2s cubic-bezier(.4,0,1,1),background-color .2s cubic-bezier(.4,0,.2,1)}.fc button::-moz-focus-inner{border:0}.fc button,.fc button.btn-primary{box-shadow:0 4px 5px 0 rgba(224,126,60,.14),0 1px 10px 0 rgba(224,126,60,.12),0 2px 4px -1px rgba(224,126,60,.2)}.fc button,.fc button.active,.fc button.active:focus,.fc button.active:hover,.fc button.btn-primary,.fc button.btn-primary.active,.fc button.btn-primary.active:focus,.fc button.btn-primary.active:hover,.fc button.btn-primary:active,.fc button.btn-primary:active:focus,.fc button.btn-primary:active:hover,.fc button.btn-primary:focus,.fc button.btn-primary:hover,.fc button:active,.fc button:active:focus,.fc button:active:hover,.fc button:focus,.fc button:hover,.open>.fc button.btn-primary.dropdown-toggle,.open>.fc button.btn-primary.dropdown-toggle:focus,.open>.fc button.btn-primary.dropdown-toggle:hover,.open>.fc button.dropdown-toggle,.open>.fc button.dropdown-toggle:focus,.open>.fc button.dropdown-toggle:hover{background-color:#e07e3c;color:#fff}.fc button.btn-primary:active,.fc button.btn-primary:focus,.fc button.btn-primary:hover,.fc button:active,.fc button:focus,.fc button:hover{box-shadow:0 14px 26px -12px rgba(224,126,60,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(224,126,60,.2)}.fc button.btn-primary.disabled,.fc button.btn-primary.disabled.active,.fc button.btn-primary.disabled.focus,.fc button.btn-primary.disabled:active,.fc button.btn-primary.disabled:focus,.fc button.btn-primary.disabled:hover,.fc button.btn-primary:disabled,.fc button.btn-primary:disabled.active,.fc button.btn-primary:disabled.focus,.fc button.btn-primary:disabled:active,.fc button.btn-primary:disabled:focus,.fc button.btn-primary:disabled:hover,.fc button.btn-primary[disabled],.fc button.btn-primary[disabled].active,.fc button.btn-primary[disabled].focus,.fc button.btn-primary[disabled]:active,.fc button.btn-primary[disabled]:focus,.fc button.btn-primary[disabled]:hover,.fc button.disabled,.fc button.disabled.active,.fc button.disabled.focus,.fc button.disabled:active,.fc button.disabled:focus,.fc button.disabled:hover,.fc button:disabled,.fc button:disabled.active,.fc button:disabled.focus,.fc button:disabled:active,.fc button:disabled:focus,.fc button:disabled:hover,.fc button[disabled],.fc button[disabled].active,.fc button[disabled].focus,.fc button[disabled]:active,.fc button[disabled]:focus,.fc button[disabled]:hover,fieldset[disabled] .fc button,fieldset[disabled] .fc button.active,fieldset[disabled] .fc button.btn-primary,fieldset[disabled] .fc button.btn-primary.active,fieldset[disabled] .fc button.btn-primary.focus,fieldset[disabled] .fc button.btn-primary:active,fieldset[disabled] .fc button.btn-primary:focus,fieldset[disabled] .fc button.btn-primary:hover,fieldset[disabled] .fc button.focus,fieldset[disabled] .fc button:active,fieldset[disabled] .fc button:focus,fieldset[disabled] .fc button:hover{box-shadow:none}.fc button.btn-primary.btn-simple,.fc button.btn-simple{background-color:transparent;color:#e07e3c;box-shadow:none}.fc button.btn-primary.btn-simple:active,.fc button.btn-primary.btn-simple:focus,.fc button.btn-primary.btn-simple:hover,.fc button.btn-simple:active,.fc button.btn-simple:focus,.fc button.btn-simple:hover{background-color:transparent;color:#e07e3c}.fc button[disabled],.fc button[disabled]:focus,.fc button[disabled]:hover{cursor:default;background-color:#999;border-color:#999;box-shadow:0 2px 2px 0 hsla(0,0%,60%,.14),0 3px 1px -2px hsla(0,0%,60%,.2),0 1px 5px 0 hsla(0,0%,60%,.12)}.fc-state-default{border:1px solid}.fc button .fc-icon{position:relative;top:-.05em;margin:0 .2em;vertical-align:middle}.fc-state-active,.fc-state-disabled,.fc-state-down,.fc-state-hover{color:#333;background-color:#e6e6e6}.fc-state-hover{color:#333;text-decoration:none;background-position:0 -15px;-webkit-transition:background-position .1s linear;-moz-transition:background-position .1s linear;-o-transition:background-position .1s linear;transition:background-position .1s linear}.fc-state-active,.fc-state-down{background-color:#ccc;background-image:none;box-shadow:inset 0 2px 4px rgba(0,0,0,.15),0 1px 2px rgba(0,0,0,.05)}.fc-state-disabled{cursor:default;background-image:none;opacity:.65;box-shadow:none}.fc-button-group{display:inline-block}.fc .fc-button-group>*{float:left;margin:0 0 0 2px}.fc .fc-button-group>:first-child{margin-left:0}.fc-popover{position:absolute;box-shadow:0 2px 6px rgba(0,0,0,.15)}.fc-popover .fc-header{padding:2px 4px}.fc-popover .fc-header .fc-title{margin:0 2px}.fc-popover .fc-header .fc-close{cursor:pointer}.fc-ltr .fc-popover .fc-header .fc-title,.fc-rtl .fc-popover .fc-header .fc-close{float:left}.fc-ltr .fc-popover .fc-header .fc-close,.fc-rtl .fc-popover .fc-header .fc-title{float:right}.fc-unthemed .fc-popover{border-width:1px;border-style:solid}.fc-unthemed .fc-popover .fc-header .fc-close{font-size:.9em;margin-top:2px}.fc-popover>.ui-widget-header+.ui-widget-content{border-top:0}.fc-divider{border-style:solid;border-width:1px}hr.fc-divider{height:0;margin:0;padding:0 0 2px;border-width:1px 0}.fc-clear{clear:both}.fc-bg,.fc-bgevent-skeleton,.fc-helper-skeleton,.fc-highlight-skeleton{position:absolute;top:0;left:0;right:0}.fc-bg{bottom:0}.fc-bg table{height:100%}.fc table{width:100%;box-sizing:border-box;table-layout:fixed;border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{border-style:solid;border-width:1px;padding:0;vertical-align:top}.fc td.fc-today{border-style:double}a[data-goto]{cursor:pointer}a[data-goto]:hover{text-decoration:underline}.fc .fc-row{border-style:solid;border-width:0}.fc-row table{border-left:0 hidden transparent;border-right:0 hidden transparent;border-bottom:0 hidden transparent}.fc-row:first-child table{border-top:0 hidden transparent}.fc-row{position:relative}.fc-row .fc-bg{z-index:1}.fc-row .fc-bgevent-skeleton,.fc-row .fc-highlight-skeleton{bottom:0}.fc-row .fc-bgevent-skeleton table,.fc-row .fc-highlight-skeleton table{height:100%}.fc-row .fc-bgevent-skeleton td,.fc-row .fc-highlight-skeleton td{border-color:transparent}.fc-row .fc-bgevent-skeleton{z-index:2}.fc-row .fc-highlight-skeleton{z-index:3}.fc-row .fc-content-skeleton{position:relative;z-index:4;padding-bottom:2px}.fc-row .fc-helper-skeleton{z-index:5}.fc-row .fc-content-skeleton td,.fc-row .fc-helper-skeleton td{background:none;border-color:transparent;border-bottom:0}.fc-row .fc-content-skeleton tbody td,.fc-row .fc-helper-skeleton tbody td{border-top:0}.fc-scroller{-webkit-overflow-scrolling:touch}.fc-scroller>.fc-day-grid,.fc-scroller>.fc-time-grid{position:relative;width:100%}.fc-event{position:relative;display:block;font-size:.85em;line-height:1.3;border-radius:2px;background-color:#4caf50;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(76,175,80,.4);font-weight:400}.fc-event.event-azure{background-color:#00bcd4;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(0,188,212,.4)}.fc-event.event-green{background-color:#4caf50;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(76,175,80,.4)}.fc-event.event-orange{background-color:#e07e3c;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.fc-event.event-red{background-color:#f44336;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(244,67,54,.4)}.fc-event.event-rose{background-color:#e91e63;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(233,30,99,.4)}.fc-event.event-default{background-color:#999;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px hsla(0,0%,60%,.4)}.fc-event-dot{background-color:#3a87ad}.fc-event,.fc-event:hover,.ui-widget .fc-event{color:#fff;text-decoration:none}.fc-event.fc-draggable,.fc-event[href]{cursor:pointer}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc-event .fc-bg{z-index:1;background:#fff;opacity:.25}.fc-event .fc-content{position:relative;z-index:2}.fc-event .fc-resizer{position:absolute;z-index:4;display:none}.fc-event.fc-allow-mouse-resize .fc-resizer,.fc-event.fc-selected .fc-resizer{display:block}.fc-event.fc-selected .fc-resizer:before{content:"";position:absolute;z-index:9999;top:50%;left:50%;width:40px;height:40px;margin-left:-20px;margin-top:-20px}.fc-event.fc-selected{z-index:9999!important;box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event.fc-selected.fc-dragging{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-h-event.fc-selected:before{content:"";position:absolute;z-index:3;top:-10px;bottom:-10px;left:0;right:0}.fc-ltr .fc-h-event.fc-not-start,.fc-rtl .fc-h-event.fc-not-end{margin-left:0;border-left-width:0;padding-left:1px;border-top-left-radius:0;border-bottom-left-radius:0}.fc-ltr .fc-h-event.fc-not-end,.fc-rtl .fc-h-event.fc-not-start{margin-right:0;border-right-width:0;padding-right:1px;border-top-right-radius:0;border-bottom-right-radius:0}.fc-ltr .fc-h-event .fc-start-resizer,.fc-rtl .fc-h-event .fc-end-resizer{cursor:w-resize;left:-1px}.fc-ltr .fc-h-event .fc-end-resizer,.fc-rtl .fc-h-event .fc-start-resizer{cursor:e-resize;right:-1px}.fc-h-event.fc-allow-mouse-resize .fc-resizer{width:7px;top:-1px;bottom:-1px}.fc-h-event.fc-selected .fc-resizer{border-radius:4px;border-width:1px;width:6px;height:6px;border-style:solid;border-color:inherit;background:#fff;top:50%;margin-top:-4px}.fc-ltr .fc-h-event.fc-selected .fc-start-resizer,.fc-rtl .fc-h-event.fc-selected .fc-end-resizer{margin-left:-4px}.fc-ltr .fc-h-event.fc-selected .fc-end-resizer,.fc-rtl .fc-h-event.fc-selected .fc-start-resizer{margin-right:-4px}.fc-day-grid-event{margin:2px 5px 0;padding:0 1px}tr:first-child>td>.fc-day-grid-event{margin-top:2px}.fc-day-grid-event.fc-selected:after{content:"";position:absolute;z-index:1;top:-1px;right:-1px;bottom:-1px;left:-1px;background:#000;opacity:.25}.fc-day-grid-event .fc-content{white-space:nowrap;overflow:hidden}.fc-day-grid-event .fc-time{font-weight:700}.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer,.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer{margin-left:-2px}.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer,.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer{margin-right:-2px}a.fc-more{margin:1px 3px;font-size:.85em;cursor:pointer;text-decoration:none}a.fc-more:hover{text-decoration:underline}.fc-limited{display:none}.fc-day-grid .fc-row{z-index:1}.fc-more-popover{z-index:2;width:220px}.fc-more-popover .fc-event-container{padding:10px}.fc-now-indicator{position:absolute;border:0 solid red}.fc-unselectable{-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.fc-toolbar{text-align:center;margin-bottom:1em}.fc-toolbar .fc-left{float:left}.fc-toolbar .fc-right{float:right}.fc-toolbar .fc-center{display:inline-block}.fc .fc-toolbar>*>*{float:left;margin-left:.75em}.fc .fc-toolbar>*>:first-child{margin-left:0}.fc-toolbar h2{margin:0;font-size:1.8em}.fc-toolbar button{position:relative}.fc-toolbar .fc-state-hover,.fc-toolbar .ui-state-hover{z-index:2}.fc-toolbar .fc-state-down{z-index:3}.fc-toolbar .fc-state-active,.fc-toolbar .ui-state-active{z-index:4}.fc-toolbar button:focus{z-index:5}.fc-view-container *,.fc-view-container :after,.fc-view-container :before{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}.fc-view,.fc-view>table{position:relative;z-index:1}.fc-basicDay-view .fc-content-skeleton,.fc-basicWeek-view .fc-content-skeleton{padding-bottom:1em}.fc-basic-view .fc-body .fc-row{min-height:4em}.fc-row.fc-rigid{overflow:hidden}.fc-row.fc-rigid .fc-content-skeleton{position:absolute;top:0;left:0;right:0}.fc-day-top.fc-other-month{opacity:.3}.fc-basic-view .fc-day-number,.fc-basic-view .fc-week-number{padding:2px}.fc-basic-view th.fc-day-number,.fc-basic-view th.fc-week-number{padding:0 2px}.fc-ltr .fc-basic-view .fc-day-top .fc-day-number{float:right}.fc-rtl .fc-basic-view .fc-day-top .fc-day-number{float:left}.fc-ltr .fc-basic-view .fc-day-top .fc-week-number{float:left;border-radius:0 0 3px 0}.fc-rtl .fc-basic-view .fc-day-top .fc-week-number{float:right;border-radius:0 0 0 3px}.fc-basic-view .fc-day-top .fc-week-number{min-width:1.5em;text-align:center;background-color:#f2f2f2;color:gray}.fc-basic-view td.fc-week-number{text-align:center}.fc-basic-view td.fc-week-number>*{display:inline-block;min-width:1.25em}.fc-agenda-view .fc-day-grid{position:relative;z-index:2}.fc-agenda-view .fc-day-grid .fc-row{min-height:3em}.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton{padding-bottom:1em}.fc .fc-axis{vertical-align:middle;padding:0 4px;white-space:nowrap}.fc-ltr .fc-axis{text-align:right}.fc-rtl .fc-axis{text-align:left}.ui-widget td.fc-axis{font-weight:400}.fc-time-grid,.fc-time-grid-container{position:relative;z-index:1}.fc-time-grid{min-height:100%}.fc-time-grid table{border:0 hidden transparent}.fc-time-grid>.fc-bg{z-index:1}.fc-time-grid .fc-slats,.fc-time-grid>hr{position:relative;z-index:2}.fc-time-grid .fc-content-col{position:relative}.fc-time-grid .fc-content-skeleton{position:absolute;z-index:3;top:0;left:0;right:0}.fc-time-grid .fc-business-container{position:relative;z-index:1}.fc-time-grid .fc-bgevent-container{position:relative;z-index:2}.fc-time-grid .fc-highlight-container{z-index:3}.fc-time-grid .fc-event-container{position:relative;z-index:4}.fc-time-grid .fc-now-indicator-line{z-index:5}.fc-time-grid .fc-helper-container{position:relative;z-index:6}.fc-time-grid .fc-slats td{height:1.5em;border-bottom:0}.fc-time-grid .fc-slats .fc-minor td{border-top-style:dotted}.fc-time-grid .fc-slats .ui-widget-content{background:none}.fc-time-grid .fc-highlight-container{position:relative}.fc-time-grid .fc-highlight{position:absolute;left:0;right:0}.fc-ltr .fc-time-grid .fc-event-container{margin:0 2.5% 0 2px}.fc-rtl .fc-time-grid .fc-event-container{margin:0 2px 0 2.5%}.fc-time-grid .fc-bgevent,.fc-time-grid .fc-event{position:absolute;z-index:1}.fc-time-grid .fc-bgevent{left:0;right:0}.fc-v-event.fc-not-start{border-top-width:0;padding-top:1px;border-top-left-radius:0;border-top-right-radius:0}.fc-v-event.fc-not-end{border-bottom-width:0;padding-bottom:1px;border-bottom-left-radius:0;border-bottom-right-radius:0}.fc-time-grid-event{overflow:hidden}.fc-time-grid-event.fc-selected{overflow:visible}.fc-time-grid-event.fc-selected .fc-bg{display:none}.fc-time-grid-event .fc-content{overflow:hidden}.fc-time-grid-event .fc-time,.fc-time-grid-event .fc-title{padding:0 1px}.fc-time-grid-event .fc-time{font-size:.85em;white-space:nowrap}.fc-time-grid-event.fc-short .fc-content{white-space:nowrap}.fc-time-grid-event.fc-short .fc-time,.fc-time-grid-event.fc-short .fc-title{display:inline-block;vertical-align:top}.fc-time-grid-event.fc-short .fc-time span{display:none}.fc-time-grid-event.fc-short .fc-time:before{content:attr(data-start)}.fc-time-grid-event.fc-short .fc-time:after{content:"\\A0-\\A0"}.fc-time-grid-event.fc-short .fc-title{font-size:.85em;padding:0}.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer{left:0;right:0;bottom:0;height:8px;overflow:hidden;line-height:8px;font-size:11px;font-family:monospace;text-align:center;cursor:s-resize}.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer:after{content:"="}.fc-time-grid-event.fc-selected .fc-resizer{border-radius:5px;border-width:1px;width:8px;height:8px;border-style:solid;border-color:inherit;background:#fff;left:50%;margin-left:-5px;bottom:-5px}.fc-time-grid .fc-now-indicator-line{border-top-width:1px;left:0;right:0}.fc-time-grid .fc-now-indicator-arrow{margin-top:-5px}.fc-ltr .fc-time-grid .fc-now-indicator-arrow{left:0;border-width:5px 0 5px 6px;border-top-color:transparent;border-bottom-color:transparent}.fc-rtl .fc-time-grid .fc-now-indicator-arrow{right:0;border-width:5px 6px 5px 0;border-top-color:transparent;border-bottom-color:transparent}.fc-event-dot{display:inline-block;width:10px;height:10px;border-radius:5px}.fc-rtl .fc-list-view{direction:rtl}.fc-list-view{border-width:1px;border-style:solid}.fc .fc-list-table{table-layout:auto}.fc-list-table td{border-width:1px 0 0;padding:8px 14px}.fc-list-table tr:first-child td{border-top-width:0}.fc-list-heading{border-bottom-width:1px}.fc-list-heading td{font-weight:700}.fc-ltr .fc-list-heading-main{float:left}.fc-ltr .fc-list-heading-alt,.fc-rtl .fc-list-heading-main{float:right}.fc-rtl .fc-list-heading-alt{float:left}.fc-list-item.fc-has-url{cursor:pointer}.fc-list-item:hover td{background-color:#f5f5f5}.fc-list-item-marker,.fc-list-item-time{white-space:nowrap;width:1px}.fc-ltr .fc-list-item-marker{padding-right:0}.fc-rtl .fc-list-item-marker{padding-left:0}.fc-list-item-title a{text-decoration:none;color:inherit}.fc-list-item-title a[href]:hover{text-decoration:underline}.fc-list-empty-wrap2{position:absolute;top:0;left:0;right:0;bottom:0}.fc-list-empty-wrap1{width:100%;height:100%;display:table}.fc-list-empty{display:table-cell;vertical-align:middle;text-align:center}.fc-unthemed .fc-list-empty{background-color:#eee}.card-calendar table td{text-align:right}.card-calendar .content{padding:0!important}.card-calendar .fc-toolbar{padding-top:20px;padding-left:20px;padding-right:20px}.card-calendar .fc td:first-child{border-left:0}.card-calendar .fc td:last-child{border-right:0}.card-calendar .fc-basic-view td:last-child.fc-day-number,.card-calendar .fc-basic-view td:last-child.fc-week-number span{padding-right:20px}.card-calendar .fc .fc-day-header:last-child{padding-right:15px}.card-calendar .fc .fc-widget-header{border:0}.card-calendar .fc .fc-widget-header .fc-title{color:#fff}.card-calendar .fc th{text-align:right;color:#999}.card-calendar .title{margin-top:-9px}.card-calendar .fc .fc-body .fc-widget-content,.card-calendar .fc .fc-row:last-child td{border-bottom:0}.wizard-card{min-height:410px;box-shadow:0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.wizard-card .picture-container{position:relative;cursor:pointer;text-align:center}.wizard-card .wizard-navigation{position:relative}.wizard-card .picture{width:106px;height:106px;background-color:#999;border:4px solid #ccc;color:#fff;border-radius:50%;margin:5px auto;overflow:hidden;transition:all .2s;-webkit-transition:all .2s}.wizard-card .picture:hover{border-color:#2ca8ff}.wizard-card .moving-tab{position:absolute;text-align:center;padding:12px;font-size:12px;text-transform:uppercase;-webkit-font-smoothing:subpixel-antialiased;top:-4px;left:0;border-radius:4px;color:#fff;cursor:pointer;font-weight:500}.wizard-card[data-color=purple] .moving-tab{background-color:#e07e3c;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.wizard-card[data-color=purple] .picture:hover{border-color:#e07e3c}.wizard-card[data-color=purple] .choice.active .icon,.wizard-card[data-color=purple] .choice:hover .icon{border-color:#e07e3c;color:#e07e3c}.wizard-card[data-color=purple] .form-group .form-control{background-image:linear-gradient(#e07e3c,#e07e3c),linear-gradient(#d2d2d2,#d2d2d2)}.wizard-card[data-color=purple] .checkbox input[type=checkbox]:checked+.checkbox-material .check,.wizard-card[data-color=purple] .radio input[type=radio]:checked~.check{background-color:#e07e3c}.wizard-card[data-color=purple] .radio input[type=radio]:checked~.circle{border-color:#e07e3c}.wizard-card[data-color=green] .moving-tab{background-color:#4caf50;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(76,175,80,.4)}.wizard-card[data-color=green] .picture:hover{border-color:#4caf50}.wizard-card[data-color=green] .choice.active .icon,.wizard-card[data-color=green] .choice:hover .icon{border-color:#4caf50;color:#4caf50}.wizard-card[data-color=green] .form-group .form-control{background-image:linear-gradient(#4caf50,#4caf50),linear-gradient(#d2d2d2,#d2d2d2)}.wizard-card[data-color=green] .checkbox input[type=checkbox]:checked+.checkbox-material .check,.wizard-card[data-color=green] .radio input[type=radio]:checked~.check{background-color:#4caf50}.wizard-card[data-color=green] .radio input[type=radio]:checked~.circle{border-color:#4caf50}.wizard-card[data-color=blue] .moving-tab{background-color:#00bcd4;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(0,188,212,.4)}.wizard-card[data-color=blue] .picture:hover{border-color:#00bcd4}.wizard-card[data-color=blue] .choice.active .icon,.wizard-card[data-color=blue] .choice:hover .icon{border-color:#00bcd4;color:#00bcd4}.wizard-card[data-color=blue] .form-group .form-control{background-image:linear-gradient(#00bcd4,#00bcd4),linear-gradient(#d2d2d2,#d2d2d2)}.wizard-card[data-color=blue] .checkbox input[type=checkbox]:checked+.checkbox-material .check,.wizard-card[data-color=blue] .radio input[type=radio]:checked~.check{background-color:#00bcd4}.wizard-card[data-color=blue] .radio input[type=radio]:checked~.circle{border-color:#00bcd4}.wizard-card[data-color=orange] .moving-tab{background-color:#e07e3c;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.wizard-card[data-color=orange] .picture:hover{border-color:#e07e3c}.wizard-card[data-color=orange] .choice.active .icon,.wizard-card[data-color=orange] .choice:hover .icon{border-color:#e07e3c;color:#e07e3c}.wizard-card[data-color=orange] .form-group .form-control{background-image:linear-gradient(#e07e3c,#e07e3c),linear-gradient(#d2d2d2,#d2d2d2)}.wizard-card[data-color=orange] .checkbox input[type=checkbox]:checked+.checkbox-material .check,.wizard-card[data-color=orange] .radio input[type=radio]:checked~.check{background-color:#e07e3c}.wizard-card[data-color=orange] .radio input[type=radio]:checked~.circle{border-color:#e07e3c}.wizard-card[data-color=red] .moving-tab{background-color:#f44336;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(244,67,54,.4)}.wizard-card[data-color=red] .picture:hover{border-color:#f44336}.wizard-card[data-color=red] .choice.active .icon,.wizard-card[data-color=red] .choice:hover .icon{border-color:#f44336;color:#f44336}.wizard-card[data-color=red] .form-group .form-control{background-image:linear-gradient(#f44336,#f44336),linear-gradient(#d2d2d2,#d2d2d2)}.wizard-card[data-color=red] .checkbox input[type=checkbox]:checked+.checkbox-material .check,.wizard-card[data-color=red] .radio input[type=radio]:checked~.check{background-color:#f44336}.wizard-card[data-color=red] .radio input[type=radio]:checked~.circle{border-color:#f44336}.wizard-card[data-color=rose] .moving-tab{background-color:#e91e63;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(233,30,99,.4)}.wizard-card[data-color=rose] .picture:hover{border-color:#e91e63}.wizard-card[data-color=rose] .choice.active .icon,.wizard-card[data-color=rose] .choice:hover .icon{border-color:#e91e63;color:#e91e63}.wizard-card[data-color=rose] .form-group .form-control{background-image:linear-gradient(#e91e63,#e91e63),linear-gradient(#d2d2d2,#d2d2d2)}.wizard-card[data-color=rose] .checkbox input[type=checkbox]:checked+.checkbox-material .check,.wizard-card[data-color=rose] .radio input[type=radio]:checked~.check{background-color:#e91e63}.wizard-card[data-color=rose] .radio input[type=radio]:checked~.circle{border-color:#e91e63}.wizard-card[data-color=cyan] .moving-tab{background-color:#00bcd4;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(0,188,212,.4)}.wizard-card[data-color=cyan] .picture:hover{border-color:#00bcd4}.wizard-card[data-color=cyan] .choice.active .icon,.wizard-card[data-color=cyan] .choice:hover .icon{border-color:#00bcd4;color:#00bcd4}.wizard-card[data-color=cyan] .form-group .form-control{background-image:linear-gradient(#00bcd4,#00bcd4),linear-gradient(#d2d2d2,#d2d2d2)}.wizard-card[data-color=cyan] .checkbox input[type=checkbox]:checked+.checkbox-material .check,.wizard-card[data-color=cyan] .radio input[type=radio]:checked~.check{background-color:#00bcd4}.wizard-card[data-color=cyan] .radio input[type=radio]:checked~.circle{border-color:#00bcd4}.wizard-card .picture input[type=file]{cursor:pointer;display:block;height:100%;left:0;opacity:0!important;position:absolute;top:0;width:100%}.wizard-card .picture-src{width:100%}.wizard-card .tab-content{min-height:340px;padding:20px 15px}.wizard-card .wizard-footer{padding:0 15px}.wizard-card .wizard-footer .checkbox{margin-top:16px}.wizard-card .disabled{display:none}.wizard-card .wizard-header{text-align:center;padding:25px 0 35px}.wizard-card .wizard-header h5{margin:5px 0 0}.wizard-card .nav-pills>li{text-align:center}.wizard-card .btn{text-transform:uppercase}.wizard-card .info-text{text-align:center;font-weight:300;margin:10px 0 30px}.wizard-card .choice{text-align:center;cursor:pointer;margin-top:20px}.wizard-card .choice[disabled]{pointer-events:none;cursor:not-allowed;opacity:.26}.wizard-card .choice .icon{text-align:center;vertical-align:middle;height:116px;width:116px;border-radius:50%;color:#999;margin:0 auto 20px;border:4px solid #ccc;transition:all .2s;-webkit-transition:all .2s}.wizard-card .choice i{font-size:40px;line-height:111px}.wizard-card .choice.active .icon,.wizard-card .choice:hover .icon{border-color:#2ca8ff}.wizard-card .choice input[type=checkbox],.wizard-card .choice input[type=radio]{position:absolute;left:-10000px;z-index:-1}.wizard-card .btn-finish{display:none}.wizard-card .description{color:#999;font-size:14px}.wizard-card .wizard-title{margin:0}.wizard-card .nav-pills{background-color:hsla(0,0%,78%,.2)}.wizard-card .nav-pills>li+li{margin-left:0}.wizard-card .nav-pills>li>a{border:0!important;border-radius:0;line-height:18px;text-transform:uppercase;font-size:12px;font-weight:500;min-width:100px;text-align:center;color:#555!important}.wizard-card .nav-pills>li.active>a,.wizard-card .nav-pills>li.active>a:focus,.wizard-card .nav-pills>li.active>a:hover,.wizard-card .nav-pills>li>a:focus,.wizard-card .nav-pills>li>a:hover{background-color:inherit;box-shadow:none}.wizard-card .nav-pills>li i{display:block;font-size:30px;padding:15px 0}.ct-label{fill:rgba(0,0,0,.4);color:rgba(0,0,0,.4);font-size:1.3rem;line-height:1}.ct-chart-bar .ct-label,.ct-chart-line .ct-label{display:block;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex}.ct-label.ct-horizontal.ct-start{-webkit-box-align:flex-end;-webkit-align-items:flex-end;-ms-flex-align:flex-end;align-items:flex-end}.ct-label.ct-horizontal.ct-end,.ct-label.ct-horizontal.ct-start{-webkit-box-pack:flex-start;-webkit-justify-content:flex-start;-ms-flex-pack:flex-start;justify-content:flex-start;text-align:left;text-anchor:start}.ct-label.ct-horizontal.ct-end{-webkit-box-align:flex-start;-webkit-align-items:flex-start;-ms-flex-align:flex-start;align-items:flex-start}.ct-label.ct-vertical.ct-start{-webkit-box-align:flex-end;-webkit-align-items:flex-end;-ms-flex-align:flex-end;align-items:flex-end;-webkit-box-pack:flex-end;-webkit-justify-content:flex-end;-ms-flex-pack:flex-end;justify-content:flex-end;text-align:right;text-anchor:end}.ct-label.ct-vertical.ct-end{-webkit-box-pack:flex-start;-webkit-justify-content:flex-start;-ms-flex-pack:flex-start;justify-content:flex-start;text-align:left}.ct-chart-bar .ct-label.ct-horizontal.ct-start,.ct-label.ct-vertical.ct-end{-webkit-box-align:flex-end;-webkit-align-items:flex-end;-ms-flex-align:flex-end;align-items:flex-end;text-anchor:start}.ct-chart-bar .ct-label.ct-horizontal.ct-end,.ct-chart-bar .ct-label.ct-horizontal.ct-start{-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-align:center}.ct-chart-bar .ct-label.ct-horizontal.ct-end{-webkit-box-align:flex-start;-webkit-align-items:flex-start;-ms-flex-align:flex-start;align-items:flex-start;text-anchor:start}.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-start{-webkit-box-align:flex-end;-webkit-align-items:flex-end;-ms-flex-align:flex-end;align-items:flex-end}.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-end,.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-start{-webkit-box-pack:flex-start;-webkit-justify-content:flex-start;-ms-flex-pack:flex-start;justify-content:flex-start;text-align:left;text-anchor:start}.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-end{-webkit-box-align:flex-start;-webkit-align-items:flex-start;-ms-flex-align:flex-start;align-items:flex-start}.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-start{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:flex-end;-webkit-justify-content:flex-end;-ms-flex-pack:flex-end;justify-content:flex-end;text-align:right;text-anchor:end}.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-end{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:flex-start;-webkit-justify-content:flex-start;-ms-flex-pack:flex-start;justify-content:flex-start;text-align:left;text-anchor:end}.ct-grid{stroke:rgba(0,0,0,.2);stroke-width:1px;stroke-dasharray:2px}.ct-point{stroke-width:8px;stroke-linecap:round}.ct-line{fill:none;stroke-width:3px}.ct-area{stroke:none;fill-opacity:.8}.ct-bar{fill:none;stroke-width:10px}.ct-slice-donut{fill:none;stroke-width:60px}.ct-series-a .ct-bar,.ct-series-a .ct-line,.ct-series-a .ct-point,.ct-series-a .ct-slice-donut{stroke:#00bcd4}.ct-series-a .ct-area,.ct-series-a .ct-slice-pie{fill:#00bcd4}.ct-series-b .ct-bar,.ct-series-b .ct-line,.ct-series-b .ct-point,.ct-series-b .ct-slice-donut{stroke:#f44336}.ct-series-b .ct-area,.ct-series-b .ct-slice-pie{fill:#f44336}.ct-series-c .ct-bar,.ct-series-c .ct-line,.ct-series-c .ct-point,.ct-series-c .ct-slice-donut{stroke:#e07e3c}.ct-series-c .ct-area,.ct-series-c .ct-slice-pie{fill:#e07e3c}.ct-series-d .ct-bar,.ct-series-d .ct-line,.ct-series-d .ct-point,.ct-series-d .ct-slice-donut{stroke:#e07e3c}.ct-series-d .ct-area,.ct-series-d .ct-slice-pie{fill:#e07e3c}.ct-series-e .ct-bar,.ct-series-e .ct-line,.ct-series-e .ct-point,.ct-series-e .ct-slice-donut{stroke:#4caf50}.ct-series-e .ct-area,.ct-series-e .ct-slice-pie{fill:#4caf50}.ct-series-f .ct-bar,.ct-series-f .ct-line,.ct-series-f .ct-point,.ct-series-f .ct-slice-donut{stroke:#9c9b99}.ct-series-f .ct-area,.ct-series-f .ct-slice-pie{fill:#9c9b99}.ct-series-g .ct-bar,.ct-series-g .ct-line,.ct-series-g .ct-point,.ct-series-g .ct-slice-donut{stroke:#999}.ct-series-g .ct-area,.ct-series-g .ct-slice-pie{fill:#999}.ct-series-h .ct-bar,.ct-series-h .ct-line,.ct-series-h .ct-point,.ct-series-h .ct-slice-donut{stroke:#dd4b39}.ct-series-h .ct-area,.ct-series-h .ct-slice-pie{fill:#dd4b39}.ct-series-i .ct-bar,.ct-series-i .ct-line,.ct-series-i .ct-point,.ct-series-i .ct-slice-donut{stroke:#35465c}.ct-series-i .ct-area,.ct-series-i .ct-slice-pie{fill:#35465c}.ct-series-j .ct-bar,.ct-series-j .ct-line,.ct-series-j .ct-point,.ct-series-j .ct-slice-donut{stroke:#e52d27}.ct-series-j .ct-area,.ct-series-j .ct-slice-pie{fill:#e52d27}.ct-series-k .ct-bar,.ct-series-k .ct-line,.ct-series-k .ct-point,.ct-series-k .ct-slice-donut{stroke:#55acee}.ct-series-k .ct-area,.ct-series-k .ct-slice-pie{fill:#55acee}.ct-series-l .ct-bar,.ct-series-l .ct-line,.ct-series-l .ct-point,.ct-series-l .ct-slice-donut{stroke:#cc2127}.ct-series-l .ct-area,.ct-series-l .ct-slice-pie{fill:#cc2127}.ct-series-m .ct-bar,.ct-series-m .ct-line,.ct-series-m .ct-point,.ct-series-m .ct-slice-donut{stroke:#1769ff}.ct-series-m .ct-area,.ct-series-m .ct-slice-pie{fill:#1769ff}.ct-series-n .ct-bar,.ct-series-n .ct-line,.ct-series-n .ct-point,.ct-series-n .ct-slice-donut{stroke:#6188e2}.ct-series-n .ct-area,.ct-series-n .ct-slice-pie{fill:#6188e2}.ct-series-o .ct-bar,.ct-series-o .ct-line,.ct-series-o .ct-point,.ct-series-o .ct-slice-donut{stroke:#a748ca}.ct-series-o .ct-area,.ct-series-o .ct-slice-pie{fill:#a748ca}.ct-square{display:block;position:relative;width:100%}.ct-square:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:100%}.ct-square:after{content:"";display:table;clear:both}.ct-square>svg{display:block;position:absolute;top:0;left:0}.ct-minor-second{display:block;position:relative;width:100%}.ct-minor-second:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:93.75%}.ct-minor-second:after{content:"";display:table;clear:both}.ct-minor-second>svg{display:block;position:absolute;top:0;left:0}.ct-major-second{display:block;position:relative;width:100%}.ct-major-second:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:88.88889%}.ct-major-second:after{content:"";display:table;clear:both}.ct-major-second>svg{display:block;position:absolute;top:0;left:0}.ct-minor-third{display:block;position:relative;width:100%}.ct-minor-third:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:83.33333%}.ct-minor-third:after{content:"";display:table;clear:both}.ct-minor-third>svg{display:block;position:absolute;top:0;left:0}.ct-major-third{display:block;position:relative;width:100%}.ct-major-third:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:80%}.ct-major-third:after{content:"";display:table;clear:both}.ct-major-third>svg{display:block;position:absolute;top:0;left:0}.ct-perfect-fourth{display:block;position:relative;width:100%}.ct-perfect-fourth:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:75%}.ct-perfect-fourth:after{content:"";display:table;clear:both}.ct-perfect-fourth>svg{display:block;position:absolute;top:0;left:0}.ct-perfect-fifth{display:block;position:relative;width:100%}.ct-perfect-fifth:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:66.66667%}.ct-perfect-fifth:after{content:"";display:table;clear:both}.ct-perfect-fifth>svg{display:block;position:absolute;top:0;left:0}.ct-minor-sixth{display:block;position:relative;width:100%}.ct-minor-sixth:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:62.5%}.ct-minor-sixth:after{content:"";display:table;clear:both}.ct-minor-sixth>svg{display:block;position:absolute;top:0;left:0}.ct-golden-section{display:block;position:relative;width:100%}.ct-golden-section:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:61.8047%}.ct-golden-section:after{content:"";display:table;clear:both}.ct-golden-section>svg{display:block;position:absolute;top:0;left:0}.ct-major-sixth{display:block;position:relative;width:100%}.ct-major-sixth:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:60%}.ct-major-sixth:after{content:"";display:table;clear:both}.ct-major-sixth>svg{display:block;position:absolute;top:0;left:0}.ct-minor-seventh{display:block;position:relative;width:100%}.ct-minor-seventh:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:56.25%}.ct-minor-seventh:after{content:"";display:table;clear:both}.ct-minor-seventh>svg{display:block;position:absolute;top:0;left:0}.ct-major-seventh{display:block;position:relative;width:100%}.ct-major-seventh:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:53.33333%}.ct-major-seventh:after{content:"";display:table;clear:both}.ct-major-seventh>svg{display:block;position:absolute;top:0;left:0}.ct-octave{display:block;position:relative;width:100%}.ct-octave:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:50%}.ct-octave:after{content:"";display:table;clear:both}.ct-octave>svg{display:block;position:absolute;top:0;left:0}.ct-major-tenth{display:block;position:relative;width:100%}.ct-major-tenth:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:40%}.ct-major-tenth:after{content:"";display:table;clear:both}.ct-major-tenth>svg{display:block;position:absolute;top:0;left:0}.ct-major-eleventh{display:block;position:relative;width:100%}.ct-major-eleventh:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:37.5%}.ct-major-eleventh:after{content:"";display:table;clear:both}.ct-major-eleventh>svg{display:block;position:absolute;top:0;left:0}.ct-major-twelfth{display:block;position:relative;width:100%}.ct-major-twelfth:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:33.33333%}.ct-major-twelfth:after{content:"";display:table;clear:both}.ct-major-twelfth>svg{display:block;position:absolute;top:0;left:0}.ct-double-octave{display:block;position:relative;width:100%}.ct-double-octave:before{display:block;float:left;content:"";width:0;height:0;padding-bottom:25%}.ct-double-octave:after{content:"";display:table;clear:both}.ct-double-octave>svg{display:block;position:absolute;top:0;left:0}.ct-purple{stroke:#e07e3c!important}.ct-azure{stroke:#00bcd4!important}.ct-green{stroke:#4caf50!important}.ct-orange{stroke:#e07e3c!important}.ct-red{stroke:#f44336!important}.ct-white{stroke:#fff!important}.ct-rose{stroke:#e91e63!important}\r\n\r\nselect.bs-select-hidden,select.selectpicker{display:none!important}.bootstrap-select{width:220px \\0}.bootstrap-select>.dropdown-toggle{width:100%;padding-right:25px;z-index:1}.bootstrap-select>select{position:absolute!important;bottom:0;left:50%;display:block!important;width:.5px!important;height:100%!important;padding:0!important;opacity:0!important;border:none}.bootstrap-select>select.mobile-device{top:0;left:0;display:block!important;width:100%!important;z-index:2}.error .bootstrap-select .dropdown-toggle,.has-error .bootstrap-select .dropdown-toggle{border-color:#b94a48}.bootstrap-select.fit-width{width:auto!important}.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn){width:100%}.bootstrap-select.form-control{margin-bottom:0;padding:0;border:none}.bootstrap-select.form-control:not([class*=col-]){width:100%}.bootstrap-select.form-control.input-group-btn{z-index:auto}.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child)>.btn{border-radius:0}.bootstrap-select.btn-group:not(.input-group-btn),.bootstrap-select.btn-group[class*=col-]{float:none;display:inline-block;margin-left:0}.bootstrap-select.btn-group.dropdown-menu-right,.bootstrap-select.btn-group[class*=col-].dropdown-menu-right,.row .bootstrap-select.btn-group[class*=col-].dropdown-menu-right{float:right}.form-group .bootstrap-select.btn-group,.form-horizontal .bootstrap-select.btn-group,.form-inline .bootstrap-select.btn-group{margin-bottom:0}.form-group-lg .bootstrap-select.btn-group.form-control,.form-group-sm .bootstrap-select.btn-group.form-control{padding:0}.form-inline .bootstrap-select.btn-group .form-control{width:100%}.bootstrap-select.btn-group .dropdown-menu li.disabled a:focus,.bootstrap-select.btn-group .dropdown-menu li.disabled a:hover{box-shadow:none}.bootstrap-select.btn-group.disabled,.bootstrap-select.btn-group>.disabled{cursor:not-allowed}.bootstrap-select.btn-group.disabled:focus,.bootstrap-select.btn-group>.disabled:focus{outline:none!important}.bootstrap-select.btn-group.bs-container{position:absolute;height:0!important;padding:0!important}.bootstrap-select.btn-group.bs-container .dropdown-menu{z-index:1060}.bootstrap-select.btn-group .dropdown-toggle .filter-option{display:inline-block;overflow:hidden;width:100%;text-align:left;text-overflow:ellipsis}.bootstrap-select.btn-group .dropdown-toggle .caret{position:absolute;top:50%;right:16px;margin-top:-2px;vertical-align:middle}.bootstrap-select.btn-group[class*=col-] .dropdown-toggle{width:100%}.bootstrap-select.btn-group .dropdown-menu{border-radius:4px;padding:0;min-width:100%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.bootstrap-select.btn-group .dropdown-menu.inner{position:static;float:none;border:0;padding:5px 0;margin:0;-webkit-box-shadow:none;box-shadow:none}.bootstrap-select.btn-group .dropdown-menu li{position:relative}.bootstrap-select.btn-group .dropdown-menu li.active small{color:#fff}.bootstrap-select.btn-group .dropdown-menu li.disabled a{cursor:not-allowed}.bootstrap-select.btn-group .dropdown-menu li a{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:0}.bootstrap-select.btn-group .dropdown-menu li a:focus,.bootstrap-select.btn-group .dropdown-menu li a:hover{box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.bootstrap-select.btn-group .dropdown-menu li a.opt{position:relative;padding-left:2.25em}.bootstrap-select.btn-group .dropdown-menu li a span.check-mark{display:none}.bootstrap-select.btn-group .dropdown-menu li a span.text{display:inline-block}.bootstrap-select.btn-group .dropdown-menu li small{padding-left:.5em}.bootstrap-select.btn-group .dropdown-menu .notify{position:absolute;bottom:5px;width:96%;margin:0 2%;min-height:26px;padding:3px 5px;background:#f5f5f5;border:1px solid #e3e3e3;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.05);box-shadow:inset 0 1px 1px rgba(0,0,0,.05);pointer-events:none;opacity:.9;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.bootstrap-select.btn-group .no-results{padding:3px;background:#f5f5f5;margin:0 5px;white-space:nowrap}.bootstrap-select.btn-group.fit-width .dropdown-toggle .filter-option{position:static}.bootstrap-select.btn-group.fit-width .dropdown-toggle .caret{position:static;top:auto;margin-top:-1px}.bootstrap-select.btn-group.show-tick .dropdown-menu li.selected a span.check-mark{position:absolute;display:inline-block;right:15px;font-size:16px}.bootstrap-select.btn-group.show-tick .dropdown-menu li a span.text{margin-right:34px}.bootstrap-select.show-menu-arrow.open>.dropdown-toggle{z-index:1061}.bootstrap-select.show-menu-arrow .dropdown-toggle:before{content:"";border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid hsla(0,0%,80%,.2);position:absolute;bottom:-4px;left:9px;display:none}.bootstrap-select.show-menu-arrow .dropdown-toggle:after{content:"";border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #fff;position:absolute;bottom:-4px;left:10px;display:none}.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:before{bottom:auto;top:-3px;border-top:7px solid hsla(0,0%,80%,.2);border-bottom:0}.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:after{bottom:auto;top:-3px;border-top:6px solid #fff;border-bottom:0}.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:before{right:12px;left:auto}.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:after{right:13px;left:auto}.bootstrap-select.show-menu-arrow.open>.dropdown-toggle:after,.bootstrap-select.show-menu-arrow.open>.dropdown-toggle:before{display:block}.bs-actionsbox,.bs-donebutton,.bs-searchbox{padding:4px 8px}.bs-actionsbox{width:100%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.bs-actionsbox .btn-group button{width:50%}.bs-donebutton{float:left;width:100%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.bs-donebutton .btn-group button{width:100%}.bs-searchbox+.bs-actionsbox{padding:0 8px 4px}.bs-searchbox .form-control{margin-bottom:0;width:100%;float:none}.select-with-transition{border:0!important;background-image:linear-gradient(#e07e3c,#e07e3c),linear-gradient(#d2d2d2,#d2d2d2);background-size:0 2px,100% 1px;background-repeat:no-repeat;background-position:bottom,50% calc(100% - 1px);background-color:transparent!important;transition:background 0s ease-out!important;float:none!important;box-shadow:none!important;border-radius:0!important;color:#3c4858!important;height:34px;padding-left:0!important;padding-bottom:5px!important}.select-with-transition .caret,.select-with-transition .ripple-container{display:none}.btn-group.bootstrap-select.show-tick.open .select-with-transition{outline:none!important;background-image:linear-gradient(#e07e3c,#e07e3c),linear-gradient(#d2d2d2,#d2d2d2)!important;background-size:100% 2px,100% 1px!important;box-shadow:none;transition-duration:.3s!important}.ps-container{-ms-touch-action:auto;touch-action:auto;overflow:hidden!important;-ms-overflow-style:none}@supports (-ms-overflow-style:none){.ps-container{overflow:auto!important}}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.ps-container{overflow:auto!important}}.ps-container.ps-active-x>.ps-scrollbar-x-rail,.ps-container.ps-active-y>.ps-scrollbar-y-rail{display:block;background-color:transparent}.ps-container.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail{background-color:#eee;opacity:.9}.ps-container.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x{background-color:#999;height:11px}.ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail{background-color:#eee;opacity:.9}.ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y{background-color:#999;width:11px}.ps-container>.ps-scrollbar-x-rail{display:none;position:absolute;opacity:0;-webkit-transition:background-color .2s linear,opacity .2s linear;-o-transition:background-color .2s linear,opacity .2s linear;-moz-transition:background-color .2s linear,opacity .2s linear;transition:background-color .2s linear,opacity .2s linear;bottom:0;height:15px}.ps-container>.ps-scrollbar-x-rail>.ps-scrollbar-x{position:absolute;background-color:#aaa;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;-webkit-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;-o-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;-moz-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-webkit-border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;bottom:2px;height:6px}.ps-container>.ps-scrollbar-x-rail:active>.ps-scrollbar-x,.ps-container>.ps-scrollbar-x-rail:hover>.ps-scrollbar-x{height:11px}.ps-container>.ps-scrollbar-y-rail{display:none;position:absolute;opacity:0;-webkit-transition:background-color .2s linear,opacity .2s linear;-o-transition:background-color .2s linear,opacity .2s linear;-moz-transition:background-color .2s linear,opacity .2s linear;transition:background-color .2s linear,opacity .2s linear;right:0;width:15px}.ps-container>.ps-scrollbar-y-rail>.ps-scrollbar-y{position:absolute;background-color:#aaa;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;-webkit-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;-o-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;-moz-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-webkit-border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;right:2px;width:6px}.ps-container>.ps-scrollbar-y-rail:active>.ps-scrollbar-y,.ps-container>.ps-scrollbar-y-rail:hover>.ps-scrollbar-y{width:11px}.ps-container:hover.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail{background-color:#eee;opacity:.9}.ps-container:hover.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x{background-color:#999;height:11px}.ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail{background-color:#eee;opacity:.9}.ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y{background-color:#999;width:11px}.ps-container:hover>.ps-scrollbar-x-rail,.ps-container:hover>.ps-scrollbar-y-rail{opacity:.6}.ps-container:hover>.ps-scrollbar-x-rail:hover{background-color:#eee;opacity:.9}.ps-container:hover>.ps-scrollbar-x-rail:hover>.ps-scrollbar-x{background-color:#999}.ps-container:hover>.ps-scrollbar-y-rail:hover{background-color:#eee;opacity:.9}.ps-container:hover>.ps-scrollbar-y-rail:hover>.ps-scrollbar-y{background-color:#999}html *{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.h1,h1{font-size:3.8em;line-height:1.15em}.h2,h2{font-size:2.6em}.h3,h3{font-size:1.825em;margin:20px 0 10px}.h3,.h4,h3,h4{line-height:1.4em}.h4,h4{font-size:1.3em}.h5,h5{font-size:1.25em;line-height:1.4em;margin-bottom:15px}.h6,h6{font-size:1em;text-transform:uppercase;font-weight:500}.card-title,.card-title a,.footer-big h4,.footer-big h4 a,.footer-big h5,.footer-big h5 a,.footer-brand,.footer-brand a,.info-title,.info-title a,.media .media-heading,.media .media-heading a,.title,.title a{color:#3c4858;text-decoration:none}.card-blog .card-title{font-weight:700}h2.title{margin-bottom:30px}.card-description,.description,.footer-big p{color:#999}.text-primary,.text-warning{color:#e07e3c}.text-danger{color:#f44336}.text-success{color:#4caf50}.text-info{color:#00bcd4}.text-rose{color:#e91e63}.text-gray{color:#999}.sidebar-moving-tab{position:absolute;padding:10px 15px;top:0;left:0;border-radius:3px;color:#fff;cursor:pointer;margin:10px 15px;width:230px;display:none;-webkit-transition:transform .6s cubic-bezier(.29,1.35,.79,1);-moz-transition:transform .6s cubic-bezier(.29,1.35,.79,1);-o-transition:transform .6s cubic-bezier(.29,1.35,.79,1);-ms-transition:transform .6s cubic-bezier(.29,1.35,.79,1);transition:transform .6s cubic-bezier(.29,1.35,.79,1)}.sidebar-moving-tab.moving{display:block;overflow:hidden}.sidebar-moving-tab p{margin:0;line-height:30px}.sidebar-moving-tab i{font-size:24px;float:left;margin-right:15px;line-height:30px;width:30px;text-align:center;color:#fff}.sidebar-moving-tab .sidebar-mini{text-transform:uppercase;width:30px;text-align:center;letter-spacing:1px;position:absolute;display:inherit}.sidebar-moving-tab .sidebar-normal{margin:0;margin-left:45px;opacity:1;white-space:nowrap}.sidebar-moving-tab .nav.child{margin-left:50px;width:180px}.off-canvas-sidebar,.sidebar{position:absolute;top:0;bottom:0;left:0;z-index:1030;width:260px;background:#fff;box-shadow:0 10px 30px -12px rgba(0,0,0,.42),0 4px 25px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.off-canvas-sidebar .logo-img,.sidebar .logo-img{width:42px;max-height:42px}.off-canvas-sidebar .logo-img img,.sidebar .logo-img img{width:42px;top:16px;left:18px;position:absolute}.off-canvas-sidebar .sidebar-wrapper,.sidebar .sidebar-wrapper{position:relative;height:calc(100vh - 70px);overflow:auto;width:260px;z-index:4;padding-bottom:30px}.off-canvas-sidebar .sidebar-wrapper .dropdown .dropdown-backdrop,.sidebar .sidebar-wrapper .dropdown .dropdown-backdrop{display:none!important}.off-canvas-sidebar .sidebar-wrapper .navbar-form,.sidebar .sidebar-wrapper .navbar-form{border:none;box-shadow:none}.off-canvas-sidebar .sidebar-wrapper .nav [data-toggle=collapse]~div>ul>li>a span,.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse]~div>ul>li>a span,.sidebar .sidebar-wrapper .nav [data-toggle=collapse]~div>ul>li>a span,.sidebar .sidebar-wrapper .user .info [data-toggle=collapse]~div>ul>li>a span{display:inline-block}.off-canvas-sidebar .sidebar-wrapper .nav [data-toggle=collapse]~div>ul>li>a .sidebar-normal,.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse]~div>ul>li>a .sidebar-normal,.sidebar .sidebar-wrapper .nav [data-toggle=collapse]~div>ul>li>a .sidebar-normal,.sidebar .sidebar-wrapper .user .info [data-toggle=collapse]~div>ul>li>a .sidebar-normal{margin:0;position:relative;-webkit-transform:translate3d(45px,0,0);-moz-transform:translate3d(45px,0,0);-o-transform:translate3d(45px,0,0);-ms-transform:translate3d(45px,0,0);transform:translate3d(45px,0,0);opacity:1;white-space:nowrap;-webkit-transition:opacity .3s linear,transform .3s linear;-moz-transition:opacity .3s linear,transform .3s linear;-o-transition:opacity .3s linear,transform .3s linear;-ms-transition:opacity .3s linear,transform .3s linear;transition:opacity .3s linear,transform .3s linear}.off-canvas-sidebar .sidebar-wrapper .nav [data-toggle=collapse]~div>ul>li>a .sidebar-mini,.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse]~div>ul>li>a .sidebar-mini,.sidebar .sidebar-wrapper .nav [data-toggle=collapse]~div>ul>li>a .sidebar-mini,.sidebar .sidebar-wrapper .user .info [data-toggle=collapse]~div>ul>li>a .sidebar-mini{text-transform:uppercase;width:30px;text-align:center;letter-spacing:1px;position:absolute;display:inherit}.off-canvas-sidebar .sidebar-wrapper .nav [data-toggle=collapse]~div>ul>li>a i,.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse]~div>ul>li>a i,.sidebar .sidebar-wrapper .nav [data-toggle=collapse]~div>ul>li>a i,.sidebar .sidebar-wrapper .user .info [data-toggle=collapse]~div>ul>li>a i{font-size:17px;line-height:20px;width:26px}.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse]~div>ul>li>a .sidebar-normal,.sidebar .sidebar-wrapper .user .info [data-toggle=collapse]~div>ul>li>a .sidebar-normal{-webkit-transform:translate3d(45px,0,0);-moz-transform:translate3d(45px,0,0);-o-transform:translate3d(45px,0,0);-ms-transform:translate3d(45px,0,0);transform:translate3d(45px,0,0)}.off-canvas-sidebar .nav,.sidebar .nav{padding-top:15px}.off-canvas-sidebar .nav .caret,.sidebar .nav .caret{margin-top:13px;position:absolute;right:18px}.off-canvas-sidebar .nav li>a,.sidebar .nav li>a{margin:10px 15px 0;border-radius:3px;color:#3c4858;padding-left:10px;padding-right:10px}.off-canvas-sidebar .nav li>a:focus,.off-canvas-sidebar .nav li>a:hover,.sidebar .nav li>a:focus,.sidebar .nav li>a:hover{background-color:transparent;outline:none}.off-canvas-sidebar .nav li:first-child>a,.sidebar .nav li:first-child>a{margin:0 15px}.off-canvas-sidebar .nav li.active>[data-toggle=collapse],.off-canvas-sidebar .nav li:hover>a,.sidebar .nav li.active>[data-toggle=collapse],.sidebar .nav li:hover>a{background-color:hsla(0,0%,78%,.2);color:#3c4858;box-shadow:none}.off-canvas-sidebar .nav li.active>[data-toggle=collapse] i,.sidebar .nav li.active>[data-toggle=collapse] i{color:#a9afbb}.off-canvas-sidebar .nav li.active.visible>a,.off-canvas-sidebar .nav li.active.visible>a i,.sidebar .nav li.active.visible>a,.sidebar .nav li.active.visible>a i{color:#fff}.off-canvas-sidebar .nav li.separator,.sidebar .nav li.separator{margin:15px 0}.off-canvas-sidebar .nav li.separator:after,.sidebar .nav li.separator:after{width:calc(100% - 30px);content:"";position:absolute;height:1px;left:15px;background-color:hsla(0,0%,71%,.3)}.off-canvas-sidebar .nav li.separator+li,.sidebar .nav li.separator+li{margin-top:31px}.off-canvas-sidebar .nav p,.sidebar .nav p{margin:0;line-height:30px;font-size:14px;white-space:nowrap;opacity:1;display:block;height:auto;-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-o-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);-webkit-transition:opacity .3s linear,transform .3s linear;-moz-transition:opacity .3s linear,transform .3s linear;-o-transition:opacity .3s linear,transform .3s linear;-ms-transition:opacity .3s linear,transform .3s linear;transition:opacity .3s linear,transform .3s linear}.off-canvas-sidebar .nav i,.sidebar .nav i{font-size:24px;float:left;margin-right:15px;line-height:30px;width:30px;text-align:center;color:#a9afbb}.off-canvas-sidebar .sidebar-background,.sidebar .sidebar-background{background:#fff;position:absolute;z-index:1;height:100%;width:100%;display:block;top:0;left:0;background-size:cover;background-position:50%}.off-canvas-sidebar .sidebar-background:after,.sidebar .sidebar-background:after{position:absolute;z-index:3;width:100%;height:100%;content:"";display:block;background:#fff;opacity:.93}.off-canvas-sidebar .logo,.sidebar .logo{padding:15px 0;margin:0;display:block;position:relative;z-index:4}.off-canvas-sidebar .logo:after,.sidebar .logo:after{content:"";position:absolute;bottom:0;right:15px;height:1px;width:calc(100% - 30px);background-color:hsla(0,0%,71%,.3)}.off-canvas-sidebar .logo p,.sidebar .logo p{float:left;font-size:20px;margin:10px;color:#fff;line-height:20px}.off-canvas-sidebar .logo .simple-text,.sidebar .logo .simple-text{text-transform:uppercase;padding:5px 0;display:block;font-size:18px;color:#3c4858;text-align:center;white-space:nowrap;font-weight:400;line-height:30px;overflow:hidden}.off-canvas-sidebar .logo-tim,.sidebar .logo-tim{border-radius:50%;border:1px solid #333;display:block;height:61px;width:61px;float:left;overflow:hidden}.off-canvas-sidebar .logo-tim img,.sidebar .logo-tim img{width:60px;height:60px}.off-canvas-sidebar .user,.sidebar .user{padding-bottom:20px;margin:20px auto 0;position:relative}.off-canvas-sidebar .user:after,.sidebar .user:after{content:"";position:absolute;bottom:0;right:15px;height:1px;width:calc(100% - 30px);background-color:hsla(0,0%,71%,.3)}.off-canvas-sidebar .user .photo,.sidebar .user .photo{width:34px;height:34px;overflow:hidden;border-radius:50%;position:absolute;left:23px;z-index:5;box-shadow:0 10px 30px -12px rgba(0,0,0,.42),0 4px 25px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.off-canvas-sidebar .user .photo img,.sidebar .user .photo img{width:100%}.off-canvas-sidebar .user a,.sidebar .user a{color:#3c4858;padding:6px 10px;display:block;white-space:nowrap}.off-canvas-sidebar .user .info .caret,.sidebar .user .info .caret{position:absolute;top:16px;right:26px}.off-canvas-sidebar .user .info>a,.sidebar .user .info>a{padding-left:70px}.off-canvas-sidebar[data-background-color=black],.sidebar[data-background-color=black]{background-color:#191919}.off-canvas-sidebar[data-background-color=black] .nav li>a,.sidebar[data-background-color=black] .nav li>a{color:#fff}.off-canvas-sidebar[data-background-color=black] .nav li i,.sidebar[data-background-color=black] .nav li i{color:hsla(0,0%,100%,.8)}.off-canvas-sidebar[data-background-color=black] .nav li.active>[data-toggle=collapse],.off-canvas-sidebar[data-background-color=black] .nav li:hover>[data-toggle=collapse],.sidebar[data-background-color=black] .nav li.active>[data-toggle=collapse],.sidebar[data-background-color=black] .nav li:hover>[data-toggle=collapse]{color:#fff}.off-canvas-sidebar[data-background-color=black] .nav li.active>[data-toggle=collapse] i,.off-canvas-sidebar[data-background-color=black] .nav li:hover>[data-toggle=collapse] i,.sidebar[data-background-color=black] .nav li.active>[data-toggle=collapse] i,.sidebar[data-background-color=black] .nav li:hover>[data-toggle=collapse] i{color:hsla(0,0%,100%,.8)}.off-canvas-sidebar[data-background-color=black] .simple-text,.off-canvas-sidebar[data-background-color=black] .user a,.sidebar[data-background-color=black] .simple-text,.sidebar[data-background-color=black] .user a{color:#fff}.off-canvas-sidebar[data-background-color=black] .sidebar-background:after,.sidebar[data-background-color=black] .sidebar-background:after{background:#000;opacity:.8}.off-canvas-sidebar[data-background-color=red],.sidebar[data-background-color=red]{background-color:#e53935}.off-canvas-sidebar[data-background-color=red] .nav li>a,.sidebar[data-background-color=red] .nav li>a{color:#fff}.off-canvas-sidebar[data-background-color=red] .nav li i,.sidebar[data-background-color=red] .nav li i{color:hsla(0,0%,100%,.8)}.off-canvas-sidebar[data-background-color=red] .nav li.active>[data-toggle=collapse],.off-canvas-sidebar[data-background-color=red] .nav li:hover>[data-toggle=collapse],.sidebar[data-background-color=red] .nav li.active>[data-toggle=collapse],.sidebar[data-background-color=red] .nav li:hover>[data-toggle=collapse]{color:#fff}.off-canvas-sidebar[data-background-color=red] .nav li.active>[data-toggle=collapse] i,.off-canvas-sidebar[data-background-color=red] .nav li:hover>[data-toggle=collapse] i,.sidebar[data-background-color=red] .nav li.active>[data-toggle=collapse] i,.sidebar[data-background-color=red] .nav li:hover>[data-toggle=collapse] i{color:hsla(0,0%,100%,.8)}.off-canvas-sidebar[data-background-color=red] .simple-text,.off-canvas-sidebar[data-background-color=red] .user a,.sidebar[data-background-color=red] .simple-text,.sidebar[data-background-color=red] .user a{color:#fff}.off-canvas-sidebar[data-background-color=red] .sidebar-background:after,.sidebar[data-background-color=red] .sidebar-background:after{background:#d50000;opacity:.8}.off-canvas-sidebar[data-background-color=red] .logo:after,.off-canvas-sidebar[data-background-color=red] .nav li.separator:after,.off-canvas-sidebar[data-background-color=red] .user:after,.sidebar[data-background-color=red] .logo:after,.sidebar[data-background-color=red] .nav li.separator:after,.sidebar[data-background-color=red] .user:after{background-color:hsla(0,0%,100%,.3)}.off-canvas-sidebar[data-background-color=red] .nav li.active>[data-toggle=collapse],.off-canvas-sidebar[data-background-color=red] .nav li:hover:not(.active)>a,.sidebar[data-background-color=red] .nav li.active>[data-toggle=collapse],.sidebar[data-background-color=red] .nav li:hover:not(.active)>a{background-color:hsla(0,0%,100%,.1)}.off-canvas-sidebar[data-background-color=white],.sidebar[data-background-color=white]{background-color:#f5f5f5}.off-canvas-sidebar[data-background-color=white] .nav li>a,.sidebar[data-background-color=white] .nav li>a{color:#000}.off-canvas-sidebar[data-background-color=white] .nav li i,.sidebar[data-background-color=white] .nav li i{color:rgba(0,0,0,.8)}.off-canvas-sidebar[data-background-color=white] .nav li.active>[data-toggle=collapse],.off-canvas-sidebar[data-background-color=white] .nav li:hover>[data-toggle=collapse],.sidebar[data-background-color=white] .nav li.active>[data-toggle=collapse],.sidebar[data-background-color=white] .nav li:hover>[data-toggle=collapse]{color:#000}.off-canvas-sidebar[data-background-color=white] .nav li.active>[data-toggle=collapse] i,.off-canvas-sidebar[data-background-color=white] .nav li:hover>[data-toggle=collapse] i,.sidebar[data-background-color=white] .nav li.active>[data-toggle=collapse] i,.sidebar[data-background-color=white] .nav li:hover>[data-toggle=collapse] i{color:rgba(0,0,0,.8)}.off-canvas-sidebar[data-background-color=white] .simple-text,.off-canvas-sidebar[data-background-color=white] .user a,.sidebar[data-background-color=white] .simple-text,.sidebar[data-background-color=white] .user a{color:#000}.off-canvas-sidebar[data-background-color=white] .sidebar-background:after,.sidebar[data-background-color=white] .sidebar-background:after{background:#fff;opacity:.8}.off-canvas-sidebar[data-background-color=white] .logo:after,.off-canvas-sidebar[data-background-color=white] .nav li.separator:after,.off-canvas-sidebar[data-background-color=white] .user:after,.sidebar[data-background-color=white] .logo:after,.sidebar[data-background-color=white] .nav li.separator:after,.sidebar[data-background-color=white] .user:after{background-color:hsla(0,0%,78%,.2)}.off-canvas-sidebar[data-background-color=white] .nav li.active>[data-toggle=collapse],.off-canvas-sidebar[data-background-color=white] .nav li:hover:not(.active)>a,.sidebar[data-background-color=white] .nav li.active>[data-toggle=collapse],.sidebar[data-background-color=white] .nav li:hover:not(.active)>a{background-color:#fff7ee;color:#e07e3c;cursor:pointer;box-shadow:0 3px 6px rgba(141,86,49,.16);border-radius:5px}.off-canvas-sidebar[data-background-color=white] .nav li.active>[data-toggle=collapse] i,.off-canvas-sidebar[data-background-color=white] .nav li:hover:not(.active)>a i,.sidebar[data-background-color=white] .nav li.active>[data-toggle=collapse] i,.sidebar[data-background-color=white] .nav li:hover:not(.active)>a i{color:#e07e3c}.off-canvas-sidebar[data-active-color=purple] .sidebar-moving-tab,.off-canvas-sidebar[data-active-color=purple] li.active.visible>a,.sidebar[data-active-color=purple] .sidebar-moving-tab,.sidebar[data-active-color=purple] li.active.visible>a{background-color:#e07e3c;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.off-canvas-sidebar[data-active-color=blue] .sidebar-moving-tab,.off-canvas-sidebar[data-active-color=blue] li.active.visible>a,.sidebar[data-active-color=blue] .sidebar-moving-tab,.sidebar[data-active-color=blue] li.active.visible>a{background-color:#00bcd4;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(0,188,212,.4)}.off-canvas-sidebar[data-active-color=green] .sidebar-moving-tab,.off-canvas-sidebar[data-active-color=green] li.active.visible>a,.sidebar[data-active-color=green] .sidebar-moving-tab,.sidebar[data-active-color=green] li.active.visible>a{background-color:#4caf50;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(76,175,80,.4)}.off-canvas-sidebar[data-active-color=orange] .sidebar-moving-tab,.off-canvas-sidebar[data-active-color=orange] li.active.visible>a,.sidebar[data-active-color=orange] .sidebar-moving-tab,.sidebar[data-active-color=orange] li.active.visible>a{background-color:#e07e3c;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.off-canvas-sidebar[data-active-color=red] .sidebar-moving-tab,.off-canvas-sidebar[data-active-color=red] li.active.visible>a,.sidebar[data-active-color=red] .sidebar-moving-tab,.sidebar[data-active-color=red] li.active.visible>a{background-color:#f44336;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(244,67,54,.4)}.off-canvas-sidebar[data-active-color=rose] .sidebar-moving-tab,.off-canvas-sidebar[data-active-color=rose] li.active.visible>a,.sidebar[data-active-color=rose] .sidebar-moving-tab,.sidebar[data-active-color=rose] li.active.visible>a{background-color:#e91e63;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(233,30,99,.4)}.off-canvas-sidebar[data-active-color=white] .sidebar-moving-tab,.off-canvas-sidebar[data-active-color=white] li.active.visible>a,.sidebar[data-active-color=white] .sidebar-moving-tab,.sidebar[data-active-color=white] li.active.visible>a{background-color:#fff;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px hsla(0,0%,100%,.4)}.off-canvas-sidebar[data-active-color=white] .nav li.active.visible>a:not([data-toggle=collapse]),.sidebar[data-active-color=white] .nav li.active.visible>a:not([data-toggle=collapse]){color:#3c4858;opacity:1;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(60,72,88,.4)}.off-canvas-sidebar[data-active-color=white] .nav li.active.visible>a:not([data-toggle=collapse]) i,.sidebar[data-active-color=white] .nav li.active.visible>a:not([data-toggle=collapse]) i{color:rgba(60,72,88,.8)}.off-canvas-sidebar[data-active-color=white] .sidebar-moving-tab,.sidebar[data-active-color=white] .sidebar-moving-tab{color:#3c4858;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(60,72,88,.4)}.off-canvas-sidebar[data-active-color=white] .sidebar-moving-tab i,.sidebar[data-active-color=white] .sidebar-moving-tab i{color:rgba(60,72,88,.8)}.off-canvas-sidebar.has-image:after,.off-canvas-sidebar[data-image]:after,.sidebar.has-image:after,.sidebar[data-image]:after{opacity:.77}.sidebar{position:fixed}.off-canvas-sidebar .nav>li>a,.off-canvas-sidebar .nav>li>a:hover{color:#fff}.off-canvas-sidebar .nav>li>a:focus{background:hsla(0,0%,78%,.2)}.main-panel{position:relative;float:right;width:calc(100% - 260px);min-height:100%;-webkit-transition:all .33s cubic-bezier(.685,.0473,.346,1);-moz-transition:all .33s cubic-bezier(.685,.0473,.346,1);-o-transition:all .33s cubic-bezier(.685,.0473,.346,1);-ms-transition:all .33s cubic-bezier(.685,.0473,.346,1);transition:all .33s cubic-bezier(.685,.0473,.346,1)}.main-panel .main-content{margin-top:70px;padding:30px 15px 0;min-height:calc(100vh - 123px)}.main-panel .main-content .container-fluid h3:first-child{margin-top:0}.main-panel>.footer{border-top:1px solid #e7e7e7}.main-panel>.navbar{margin-bottom:0}.main-panel .header{margin-bottom:30px}.main-panel .header .title{margin-top:10px}.main-panel{max-height:100%;height:100%}.main-panel,.sidebar,.sidebar-wrapper{-webkit-transition-property:top,bottom,width;transition-property:top,bottom,width;-webkit-transition-duration:.2s,.2s,.35s;transition-duration:.2s,.2s,.35s;-webkit-transition-timing-function:linear,linear,ease;transition-timing-function:linear,linear,ease;-webkit-overflow-scrolling:touch}.main-panel,.perfect-scrollbar-on .main-panel,.perfect-scrollbar-on .sidebar .sidebar-wrapper,.sidebar .sidebar-wrapper{overflow:hidden}.visible-on-sidebar-regular{display:inline-block!important}.visible-on-sidebar-mini{display:none!important}@media (min-width:992px){.sidebar-mini .visible-on-sidebar-regular{display:none!important}.sidebar-mini .visible-on-sidebar-mini{display:inline-block!important}.sidebar-mini [data-background-color=black] .nav .collapse li:not(.active)>a,.sidebar-mini [data-background-color=black] .user .collapse li:not(.active)>a{color:#3c4858}.sidebar-mini .sidebar-moving-tab{width:50px}.sidebar-mini .sidebar-moving-tab.moving .sidebar-normal,.sidebar-mini .sidebar-moving-tab.moving p{display:none}.sidebar-mini .sidebar-moving-tab.moving .sidebar-mini{position:relative}.sidebar-mini .sidebar,.sidebar-mini .sidebar .sidebar-wrapper{width:80px}.sidebar-mini .sidebar .sidebar-wrapper .nav li>a p{opacity:0;-webkit-transform:translate3d(-25px,0,0);-moz-transform:translate3d(-25px,0,0);-o-transform:translate3d(-25px,0,0);-ms-transform:translate3d(-25px,0,0);transform:translate3d(-25px,0,0)}.sidebar-mini .sidebar .sidebar-wrapper .nav [data-toggle=collapse]~div>ul>li>a .sidebar-normal,.sidebar-mini .sidebar .sidebar-wrapper .user .info [data-toggle=collapse]~div>ul>li>a .sidebar-normal{-webkit-transform:translate3d(15px,0,0);-moz-transform:translate3d(15px,0,0);-o-transform:translate3d(15px,0,0);-ms-transform:translate3d(15px,0,0);transform:translate3d(15px,0,0);opacity:0}.sidebar-mini .sidebar .sidebar-wrapper .user .info [data-toggle=collapse]~div>ul>li>a .sidebar-normal{-webkit-transform:translate3d(25px,0,0);-moz-transform:translate3d(25px,0,0);-o-transform:translate3d(25px,0,0);-ms-transform:translate3d(25px,0,0);transform:translate3d(25px,0,0)}.sidebar-mini .sidebar .user .info>a{line-height:21px;padding-left:45px;opacity:0}.sidebar-mini .sidebar .logo .logo-normal a{opacity:0;text-align:center;position:relative;padding-left:40px}.sidebar-mini .main-panel{width:calc(100% - 80px);margin-left:80px}.sidebar-mini .sidebar:hover{width:260px!important}.sidebar-mini .sidebar:hover .sidebar-moving-tab{width:230px}.sidebar-mini .sidebar:hover .sidebar-moving-tab.moving .sidebar-normal,.sidebar-mini .sidebar:hover .sidebar-moving-tab.moving p{display:block}.sidebar-mini .sidebar:hover .sidebar-moving-tab.moving .sidebar-mini{position:absolute}.sidebar-mini .sidebar:hover .sidebar-wrapper{width:260px!important}.sidebar-mini .sidebar:hover .sidebar-wrapper .nav li>a p{opacity:1;-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-o-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0)}.sidebar-mini .sidebar:hover .sidebar-wrapper .nav [data-toggle=collapse]~div>ul>li>a .sidebar-normal{-webkit-transform:translate3d(45px,0,0);-moz-transform:translate3d(45px,0,0);-o-transform:translate3d(45px,0,0);-ms-transform:translate3d(45px,0,0);transform:translate3d(45px,0,0);opacity:1}.sidebar-mini .sidebar:hover .sidebar-wrapper .user{padding-bottom:20px;height:auto}.sidebar-mini .sidebar:hover .sidebar-wrapper .user .info>a{padding-left:70px;opacity:1}.sidebar-mini .sidebar:hover .sidebar-wrapper .user .info [data-toggle=collapse]~div>ul>li>a .sidebar-normal{opacity:1;transform:translateX(45px)}.sidebar-mini .sidebar:hover .logo .logo-normal a{opacity:1;padding-left:0}.sidebar-mini .sidebar:hover .logo .logo-mini{position:absolute;top:18px;opacity:0}}.btn,.navbar .navbar-nav>li>a.btn{border:none;border-radius:3px;position:relative;padding:10px 41px;margin:10px 1px;font-size:14px;font-weight:400;text-transform:uppercase;letter-spacing:0;will-change:box-shadow,transform;transition:box-shadow .2s cubic-bezier(.4,0,1,1),background-color .2s cubic-bezier(.4,0,.2,1)}.btn::-moz-focus-inner,.navbar .navbar-nav>li>a.btn::-moz-focus-inner{border:0}.btn,.btn.btn-default,.navbar .navbar-nav>li>a.btn,.navbar .navbar-nav>li>a.btn.btn-default{box-shadow:0 4px 5px 0 hsla(0,0%,60%,.14),0 1px 10px 0 hsla(0,0%,60%,.12),0 2px 4px -1px hsla(0,0%,60%,.2)}.btn,.btn.active,.btn.active:focus,.btn.active:hover,.btn.btn-default,.btn.btn-default.active,.btn.btn-default.active:focus,.btn.btn-default.active:hover,.btn.btn-default:active,.btn.btn-default:active:focus,.btn.btn-default:active:hover,.btn.btn-default:focus,.btn.btn-default:hover,.btn:active,.btn:active:focus,.btn:active:hover,.btn:focus,.btn:hover,.navbar .navbar-nav>li>a.btn,.navbar .navbar-nav>li>a.btn.active,.navbar .navbar-nav>li>a.btn.active:focus,.navbar .navbar-nav>li>a.btn.active:hover,.navbar .navbar-nav>li>a.btn.btn-default,.navbar .navbar-nav>li>a.btn.btn-default.active,.navbar .navbar-nav>li>a.btn.btn-default.active:focus,.navbar .navbar-nav>li>a.btn.btn-default.active:hover,.navbar .navbar-nav>li>a.btn.btn-default:active,.navbar .navbar-nav>li>a.btn.btn-default:active:focus,.navbar .navbar-nav>li>a.btn.btn-default:active:hover,.navbar .navbar-nav>li>a.btn.btn-default:focus,.navbar .navbar-nav>li>a.btn.btn-default:hover,.navbar .navbar-nav>li>a.btn:active,.navbar .navbar-nav>li>a.btn:active:focus,.navbar .navbar-nav>li>a.btn:active:hover,.navbar .navbar-nav>li>a.btn:focus,.navbar .navbar-nav>li>a.btn:hover,.open>.btn.btn-default.dropdown-toggle,.open>.btn.btn-default.dropdown-toggle:focus,.open>.btn.btn-default.dropdown-toggle:hover,.open>.btn.dropdown-toggle,.open>.btn.dropdown-toggle:focus,.open>.btn.dropdown-toggle:hover,.open>.navbar .navbar-nav>li>a.btn.btn-default.dropdown-toggle,.open>.navbar .navbar-nav>li>a.btn.btn-default.dropdown-toggle:focus,.open>.navbar .navbar-nav>li>a.btn.btn-default.dropdown-toggle:hover,.open>.navbar .navbar-nav>li>a.btn.dropdown-toggle,.open>.navbar .navbar-nav>li>a.btn.dropdown-toggle:focus,.open>.navbar .navbar-nav>li>a.btn.dropdown-toggle:hover{background-color:#999;color:#fff}.btn.btn-default:active,.btn.btn-default:focus,.btn.btn-default:hover,.btn:active,.btn:focus,.btn:hover,.navbar .navbar-nav>li>a.btn.btn-default:active,.navbar .navbar-nav>li>a.btn.btn-default:focus,.navbar .navbar-nav>li>a.btn.btn-default:hover,.navbar .navbar-nav>li>a.btn:active,.navbar .navbar-nav>li>a.btn:focus,.navbar .navbar-nav>li>a.btn:hover{box-shadow:0 14px 26px -12px hsla(0,0%,60%,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px hsla(0,0%,60%,.2)}.btn.btn-default.disabled,.btn.btn-default.disabled.active,.btn.btn-default.disabled.focus,.btn.btn-default.disabled:active,.btn.btn-default.disabled:focus,.btn.btn-default.disabled:hover,.btn.btn-default:disabled,.btn.btn-default:disabled.active,.btn.btn-default:disabled.focus,.btn.btn-default:disabled:active,.btn.btn-default:disabled:focus,.btn.btn-default:disabled:hover,.btn.btn-default[disabled],.btn.btn-default[disabled].active,.btn.btn-default[disabled].focus,.btn.btn-default[disabled]:active,.btn.btn-default[disabled]:focus,.btn.btn-default[disabled]:hover,.btn.disabled,.btn.disabled.active,.btn.disabled.focus,.btn.disabled:active,.btn.disabled:focus,.btn.disabled:hover,.btn:disabled,.btn:disabled.active,.btn:disabled.focus,.btn:disabled:active,.btn:disabled:focus,.btn:disabled:hover,.btn[disabled],.btn[disabled].active,.btn[disabled].focus,.btn[disabled]:active,.btn[disabled]:focus,.btn[disabled]:hover,.navbar .navbar-nav>li>a.btn.btn-default.disabled,.navbar .navbar-nav>li>a.btn.btn-default.disabled.active,.navbar .navbar-nav>li>a.btn.btn-default.disabled.focus,.navbar .navbar-nav>li>a.btn.btn-default.disabled:active,.navbar .navbar-nav>li>a.btn.btn-default.disabled:focus,.navbar .navbar-nav>li>a.btn.btn-default.disabled:hover,.navbar .navbar-nav>li>a.btn.btn-default:disabled,.navbar .navbar-nav>li>a.btn.btn-default:disabled.active,.navbar .navbar-nav>li>a.btn.btn-default:disabled.focus,.navbar .navbar-nav>li>a.btn.btn-default:disabled:active,.navbar .navbar-nav>li>a.btn.btn-default:disabled:focus,.navbar .navbar-nav>li>a.btn.btn-default:disabled:hover,.navbar .navbar-nav>li>a.btn.btn-default[disabled],.navbar .navbar-nav>li>a.btn.btn-default[disabled].active,.navbar .navbar-nav>li>a.btn.btn-default[disabled].focus,.navbar .navbar-nav>li>a.btn.btn-default[disabled]:active,.navbar .navbar-nav>li>a.btn.btn-default[disabled]:focus,.navbar .navbar-nav>li>a.btn.btn-default[disabled]:hover,.navbar .navbar-nav>li>a.btn.disabled,.navbar .navbar-nav>li>a.btn.disabled.active,.navbar .navbar-nav>li>a.btn.disabled.focus,.navbar .navbar-nav>li>a.btn.disabled:active,.navbar .navbar-nav>li>a.btn.disabled:focus,.navbar .navbar-nav>li>a.btn.disabled:hover,.navbar .navbar-nav>li>a.btn:disabled,.navbar .navbar-nav>li>a.btn:disabled.active,.navbar .navbar-nav>li>a.btn:disabled.focus,.navbar .navbar-nav>li>a.btn:disabled:active,.navbar .navbar-nav>li>a.btn:disabled:focus,.navbar .navbar-nav>li>a.btn:disabled:hover,.navbar .navbar-nav>li>a.btn[disabled],.navbar .navbar-nav>li>a.btn[disabled].active,.navbar .navbar-nav>li>a.btn[disabled].focus,.navbar .navbar-nav>li>a.btn[disabled]:active,.navbar .navbar-nav>li>a.btn[disabled]:focus,.navbar .navbar-nav>li>a.btn[disabled]:hover,fieldset[disabled] .btn,fieldset[disabled] .btn.active,fieldset[disabled] .btn.btn-default,fieldset[disabled] .btn.btn-default.active,fieldset[disabled] .btn.btn-default.focus,fieldset[disabled] .btn.btn-default:active,fieldset[disabled] .btn.btn-default:focus,fieldset[disabled] .btn.btn-default:hover,fieldset[disabled] .btn.focus,fieldset[disabled] .btn:active,fieldset[disabled] .btn:focus,fieldset[disabled] .btn:hover,fieldset[disabled] .navbar .navbar-nav>li>a.btn,fieldset[disabled] .navbar .navbar-nav>li>a.btn.active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-default,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-default.active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-default.focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-default:active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-default:focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-default:hover,fieldset[disabled] .navbar .navbar-nav>li>a.btn.focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn:active,fieldset[disabled] .navbar .navbar-nav>li>a.btn:focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn:hover{box-shadow:none}.btn.btn-default.btn-simple,.btn.btn-simple,.navbar .navbar-nav>li>a.btn.btn-default.btn-simple,.navbar .navbar-nav>li>a.btn.btn-simple{background-color:transparent;color:#999;box-shadow:none}.btn.btn-default.btn-simple:active,.btn.btn-default.btn-simple:focus,.btn.btn-default.btn-simple:hover,.btn.btn-simple:active,.btn.btn-simple:focus,.btn.btn-simple:hover,.navbar .navbar-nav>li>a.btn.btn-default.btn-simple:active,.navbar .navbar-nav>li>a.btn.btn-default.btn-simple:focus,.navbar .navbar-nav>li>a.btn.btn-default.btn-simple:hover,.navbar .navbar-nav>li>a.btn.btn-simple:active,.navbar .navbar-nav>li>a.btn.btn-simple:focus,.navbar .navbar-nav>li>a.btn.btn-simple:hover{background-color:transparent;color:#999}.btn.btn-primary,.navbar .navbar-nav>li>a.btn.btn-primary{box-shadow:0 4px 5px 0 rgba(224,126,60,.14),0 1px 10px 0 rgba(224,126,60,.12),0 2px 4px -1px rgba(224,126,60,.2)}.btn.btn-primary,.btn.btn-primary.active,.btn.btn-primary.active:focus,.btn.btn-primary.active:hover,.btn.btn-primary:active,.btn.btn-primary:active:focus,.btn.btn-primary:active:hover,.btn.btn-primary:focus,.btn.btn-primary:hover,.navbar .navbar-nav>li>a.btn.btn-primary,.navbar .navbar-nav>li>a.btn.btn-primary.active,.navbar .navbar-nav>li>a.btn.btn-primary.active:focus,.navbar .navbar-nav>li>a.btn.btn-primary.active:hover,.navbar .navbar-nav>li>a.btn.btn-primary:active,.navbar .navbar-nav>li>a.btn.btn-primary:active:focus,.navbar .navbar-nav>li>a.btn.btn-primary:active:hover,.navbar .navbar-nav>li>a.btn.btn-primary:focus,.navbar .navbar-nav>li>a.btn.btn-primary:hover,.open>.btn.btn-primary.dropdown-toggle,.open>.btn.btn-primary.dropdown-toggle:focus,.open>.btn.btn-primary.dropdown-toggle:hover,.open>.navbar .navbar-nav>li>a.btn.btn-primary.dropdown-toggle,.open>.navbar .navbar-nav>li>a.btn.btn-primary.dropdown-toggle:focus,.open>.navbar .navbar-nav>li>a.btn.btn-primary.dropdown-toggle:hover{background-color:#e07e3c;color:#fff}.btn.btn-primary:active,.btn.btn-primary:focus,.btn.btn-primary:hover,.navbar .navbar-nav>li>a.btn.btn-primary:active,.navbar .navbar-nav>li>a.btn.btn-primary:focus,.navbar .navbar-nav>li>a.btn.btn-primary:hover{box-shadow:0 14px 26px -12px rgba(224,126,60,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(224,126,60,.2)}.btn.btn-primary.disabled,.btn.btn-primary.disabled.active,.btn.btn-primary.disabled.focus,.btn.btn-primary.disabled:active,.btn.btn-primary.disabled:focus,.btn.btn-primary.disabled:hover,.btn.btn-primary:disabled,.btn.btn-primary:disabled.active,.btn.btn-primary:disabled.focus,.btn.btn-primary:disabled:active,.btn.btn-primary:disabled:focus,.btn.btn-primary:disabled:hover,.btn.btn-primary[disabled],.btn.btn-primary[disabled].active,.btn.btn-primary[disabled].focus,.btn.btn-primary[disabled]:active,.btn.btn-primary[disabled]:focus,.btn.btn-primary[disabled]:hover,.navbar .navbar-nav>li>a.btn.btn-primary.disabled,.navbar .navbar-nav>li>a.btn.btn-primary.disabled.active,.navbar .navbar-nav>li>a.btn.btn-primary.disabled.focus,.navbar .navbar-nav>li>a.btn.btn-primary.disabled:active,.navbar .navbar-nav>li>a.btn.btn-primary.disabled:focus,.navbar .navbar-nav>li>a.btn.btn-primary.disabled:hover,.navbar .navbar-nav>li>a.btn.btn-primary:disabled,.navbar .navbar-nav>li>a.btn.btn-primary:disabled.active,.navbar .navbar-nav>li>a.btn.btn-primary:disabled.focus,.navbar .navbar-nav>li>a.btn.btn-primary:disabled:active,.navbar .navbar-nav>li>a.btn.btn-primary:disabled:focus,.navbar .navbar-nav>li>a.btn.btn-primary:disabled:hover,.navbar .navbar-nav>li>a.btn.btn-primary[disabled],.navbar .navbar-nav>li>a.btn.btn-primary[disabled].active,.navbar .navbar-nav>li>a.btn.btn-primary[disabled].focus,.navbar .navbar-nav>li>a.btn.btn-primary[disabled]:active,.navbar .navbar-nav>li>a.btn.btn-primary[disabled]:focus,.navbar .navbar-nav>li>a.btn.btn-primary[disabled]:hover,fieldset[disabled] .btn.btn-primary,fieldset[disabled] .btn.btn-primary.active,fieldset[disabled] .btn.btn-primary.focus,fieldset[disabled] .btn.btn-primary:active,fieldset[disabled] .btn.btn-primary:focus,fieldset[disabled] .btn.btn-primary:hover,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-primary,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-primary.active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-primary.focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-primary:active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-primary:focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-primary:hover{box-shadow:none}.btn.btn-primary.btn-simple,.navbar .navbar-nav>li>a.btn.btn-primary.btn-simple{background-color:transparent;color:#e07e3c;box-shadow:none}.btn.btn-primary.btn-simple:active,.btn.btn-primary.btn-simple:focus,.btn.btn-primary.btn-simple:hover,.navbar .navbar-nav>li>a.btn.btn-primary.btn-simple:active,.navbar .navbar-nav>li>a.btn.btn-primary.btn-simple:focus,.navbar .navbar-nav>li>a.btn.btn-primary.btn-simple:hover{background-color:transparent;color:#e07e3c}.btn.btn-info,.navbar .navbar-nav>li>a.btn.btn-info{box-shadow:0 4px 5px 0 rgba(0,188,212,.14),0 1px 10px 0 rgba(0,188,212,.12),0 2px 4px -1px rgba(0,188,212,.2)}.btn.btn-info,.btn.btn-info.active,.btn.btn-info.active:focus,.btn.btn-info.active:hover,.btn.btn-info:active,.btn.btn-info:active:focus,.btn.btn-info:active:hover,.btn.btn-info:focus,.btn.btn-info:hover,.navbar .navbar-nav>li>a.btn.btn-info,.navbar .navbar-nav>li>a.btn.btn-info.active,.navbar .navbar-nav>li>a.btn.btn-info.active:focus,.navbar .navbar-nav>li>a.btn.btn-info.active:hover,.navbar .navbar-nav>li>a.btn.btn-info:active,.navbar .navbar-nav>li>a.btn.btn-info:active:focus,.navbar .navbar-nav>li>a.btn.btn-info:active:hover,.navbar .navbar-nav>li>a.btn.btn-info:focus,.navbar .navbar-nav>li>a.btn.btn-info:hover,.open>.btn.btn-info.dropdown-toggle,.open>.btn.btn-info.dropdown-toggle:focus,.open>.btn.btn-info.dropdown-toggle:hover,.open>.navbar .navbar-nav>li>a.btn.btn-info.dropdown-toggle,.open>.navbar .navbar-nav>li>a.btn.btn-info.dropdown-toggle:focus,.open>.navbar .navbar-nav>li>a.btn.btn-info.dropdown-toggle:hover{background-color:#00bcd4;color:#fff}.btn.btn-info:active,.btn.btn-info:focus,.btn.btn-info:hover,.navbar .navbar-nav>li>a.btn.btn-info:active,.navbar .navbar-nav>li>a.btn.btn-info:focus,.navbar .navbar-nav>li>a.btn.btn-info:hover{box-shadow:0 14px 26px -12px rgba(0,188,212,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(0,188,212,.2)}.btn.btn-info.disabled,.btn.btn-info.disabled.active,.btn.btn-info.disabled.focus,.btn.btn-info.disabled:active,.btn.btn-info.disabled:focus,.btn.btn-info.disabled:hover,.btn.btn-info:disabled,.btn.btn-info:disabled.active,.btn.btn-info:disabled.focus,.btn.btn-info:disabled:active,.btn.btn-info:disabled:focus,.btn.btn-info:disabled:hover,.btn.btn-info[disabled],.btn.btn-info[disabled].active,.btn.btn-info[disabled].focus,.btn.btn-info[disabled]:active,.btn.btn-info[disabled]:focus,.btn.btn-info[disabled]:hover,.navbar .navbar-nav>li>a.btn.btn-info.disabled,.navbar .navbar-nav>li>a.btn.btn-info.disabled.active,.navbar .navbar-nav>li>a.btn.btn-info.disabled.focus,.navbar .navbar-nav>li>a.btn.btn-info.disabled:active,.navbar .navbar-nav>li>a.btn.btn-info.disabled:focus,.navbar .navbar-nav>li>a.btn.btn-info.disabled:hover,.navbar .navbar-nav>li>a.btn.btn-info:disabled,.navbar .navbar-nav>li>a.btn.btn-info:disabled.active,.navbar .navbar-nav>li>a.btn.btn-info:disabled.focus,.navbar .navbar-nav>li>a.btn.btn-info:disabled:active,.navbar .navbar-nav>li>a.btn.btn-info:disabled:focus,.navbar .navbar-nav>li>a.btn.btn-info:disabled:hover,.navbar .navbar-nav>li>a.btn.btn-info[disabled],.navbar .navbar-nav>li>a.btn.btn-info[disabled].active,.navbar .navbar-nav>li>a.btn.btn-info[disabled].focus,.navbar .navbar-nav>li>a.btn.btn-info[disabled]:active,.navbar .navbar-nav>li>a.btn.btn-info[disabled]:focus,.navbar .navbar-nav>li>a.btn.btn-info[disabled]:hover,fieldset[disabled] .btn.btn-info,fieldset[disabled] .btn.btn-info.active,fieldset[disabled] .btn.btn-info.focus,fieldset[disabled] .btn.btn-info:active,fieldset[disabled] .btn.btn-info:focus,fieldset[disabled] .btn.btn-info:hover,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-info,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-info.active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-info.focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-info:active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-info:focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-info:hover{box-shadow:none}.btn.btn-info.btn-simple,.navbar .navbar-nav>li>a.btn.btn-info.btn-simple{background-color:transparent;color:#00bcd4;box-shadow:none}.btn.btn-info.btn-simple:active,.btn.btn-info.btn-simple:focus,.btn.btn-info.btn-simple:hover,.navbar .navbar-nav>li>a.btn.btn-info.btn-simple:active,.navbar .navbar-nav>li>a.btn.btn-info.btn-simple:focus,.navbar .navbar-nav>li>a.btn.btn-info.btn-simple:hover{background-color:transparent;color:#00bcd4}.btn.btn-success,.navbar .navbar-nav>li>a.btn.btn-success{box-shadow:0 4px 5px 0 rgba(76,175,80,.14),0 1px 10px 0 rgba(76,175,80,.12),0 2px 4px -1px rgba(76,175,80,.2)}.btn.btn-success,.btn.btn-success.active,.btn.btn-success.active:focus,.btn.btn-success.active:hover,.btn.btn-success:active,.btn.btn-success:active:focus,.btn.btn-success:active:hover,.btn.btn-success:focus,.btn.btn-success:hover,.navbar .navbar-nav>li>a.btn.btn-success,.navbar .navbar-nav>li>a.btn.btn-success.active,.navbar .navbar-nav>li>a.btn.btn-success.active:focus,.navbar .navbar-nav>li>a.btn.btn-success.active:hover,.navbar .navbar-nav>li>a.btn.btn-success:active,.navbar .navbar-nav>li>a.btn.btn-success:active:focus,.navbar .navbar-nav>li>a.btn.btn-success:active:hover,.navbar .navbar-nav>li>a.btn.btn-success:focus,.navbar .navbar-nav>li>a.btn.btn-success:hover,.open>.btn.btn-success.dropdown-toggle,.open>.btn.btn-success.dropdown-toggle:focus,.open>.btn.btn-success.dropdown-toggle:hover,.open>.navbar .navbar-nav>li>a.btn.btn-success.dropdown-toggle,.open>.navbar .navbar-nav>li>a.btn.btn-success.dropdown-toggle:focus,.open>.navbar .navbar-nav>li>a.btn.btn-success.dropdown-toggle:hover{background-color:#4caf50;color:#fff}.btn.btn-success:active,.btn.btn-success:focus,.btn.btn-success:hover,.navbar .navbar-nav>li>a.btn.btn-success:active,.navbar .navbar-nav>li>a.btn.btn-success:focus,.navbar .navbar-nav>li>a.btn.btn-success:hover{box-shadow:0 14px 26px -12px rgba(76,175,80,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(76,175,80,.2)}.btn.btn-success.disabled,.btn.btn-success.disabled.active,.btn.btn-success.disabled.focus,.btn.btn-success.disabled:active,.btn.btn-success.disabled:focus,.btn.btn-success.disabled:hover,.btn.btn-success:disabled,.btn.btn-success:disabled.active,.btn.btn-success:disabled.focus,.btn.btn-success:disabled:active,.btn.btn-success:disabled:focus,.btn.btn-success:disabled:hover,.btn.btn-success[disabled],.btn.btn-success[disabled].active,.btn.btn-success[disabled].focus,.btn.btn-success[disabled]:active,.btn.btn-success[disabled]:focus,.btn.btn-success[disabled]:hover,.navbar .navbar-nav>li>a.btn.btn-success.disabled,.navbar .navbar-nav>li>a.btn.btn-success.disabled.active,.navbar .navbar-nav>li>a.btn.btn-success.disabled.focus,.navbar .navbar-nav>li>a.btn.btn-success.disabled:active,.navbar .navbar-nav>li>a.btn.btn-success.disabled:focus,.navbar .navbar-nav>li>a.btn.btn-success.disabled:hover,.navbar .navbar-nav>li>a.btn.btn-success:disabled,.navbar .navbar-nav>li>a.btn.btn-success:disabled.active,.navbar .navbar-nav>li>a.btn.btn-success:disabled.focus,.navbar .navbar-nav>li>a.btn.btn-success:disabled:active,.navbar .navbar-nav>li>a.btn.btn-success:disabled:focus,.navbar .navbar-nav>li>a.btn.btn-success:disabled:hover,.navbar .navbar-nav>li>a.btn.btn-success[disabled],.navbar .navbar-nav>li>a.btn.btn-success[disabled].active,.navbar .navbar-nav>li>a.btn.btn-success[disabled].focus,.navbar .navbar-nav>li>a.btn.btn-success[disabled]:active,.navbar .navbar-nav>li>a.btn.btn-success[disabled]:focus,.navbar .navbar-nav>li>a.btn.btn-success[disabled]:hover,fieldset[disabled] .btn.btn-success,fieldset[disabled] .btn.btn-success.active,fieldset[disabled] .btn.btn-success.focus,fieldset[disabled] .btn.btn-success:active,fieldset[disabled] .btn.btn-success:focus,fieldset[disabled] .btn.btn-success:hover,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-success,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-success.active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-success.focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-success:active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-success:focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-success:hover{box-shadow:none}.btn.btn-success.btn-simple,.navbar .navbar-nav>li>a.btn.btn-success.btn-simple{background-color:transparent;color:#4caf50;box-shadow:none}.btn.btn-success.btn-simple:active,.btn.btn-success.btn-simple:focus,.btn.btn-success.btn-simple:hover,.navbar .navbar-nav>li>a.btn.btn-success.btn-simple:active,.navbar .navbar-nav>li>a.btn.btn-success.btn-simple:focus,.navbar .navbar-nav>li>a.btn.btn-success.btn-simple:hover{background-color:transparent;color:#4caf50}.btn.btn-warning,.navbar .navbar-nav>li>a.btn.btn-warning{box-shadow:0 4px 5px 0 rgba(224,126,60,.14),0 1px 10px 0 rgba(224,126,60,.12),0 2px 4px -1px rgba(224,126,60,.2)}.btn.btn-warning,.btn.btn-warning.active,.btn.btn-warning.active:focus,.btn.btn-warning.active:hover,.btn.btn-warning:active,.btn.btn-warning:active:focus,.btn.btn-warning:active:hover,.btn.btn-warning:focus,.btn.btn-warning:hover,.navbar .navbar-nav>li>a.btn.btn-warning,.navbar .navbar-nav>li>a.btn.btn-warning.active,.navbar .navbar-nav>li>a.btn.btn-warning.active:focus,.navbar .navbar-nav>li>a.btn.btn-warning.active:hover,.navbar .navbar-nav>li>a.btn.btn-warning:active,.navbar .navbar-nav>li>a.btn.btn-warning:active:focus,.navbar .navbar-nav>li>a.btn.btn-warning:active:hover,.navbar .navbar-nav>li>a.btn.btn-warning:focus,.navbar .navbar-nav>li>a.btn.btn-warning:hover,.open>.btn.btn-warning.dropdown-toggle,.open>.btn.btn-warning.dropdown-toggle:focus,.open>.btn.btn-warning.dropdown-toggle:hover,.open>.navbar .navbar-nav>li>a.btn.btn-warning.dropdown-toggle,.open>.navbar .navbar-nav>li>a.btn.btn-warning.dropdown-toggle:focus,.open>.navbar .navbar-nav>li>a.btn.btn-warning.dropdown-toggle:hover{background-color:#e07e3c;color:#fff}.btn.btn-warning:active,.btn.btn-warning:focus,.btn.btn-warning:hover,.navbar .navbar-nav>li>a.btn.btn-warning:active,.navbar .navbar-nav>li>a.btn.btn-warning:focus,.navbar .navbar-nav>li>a.btn.btn-warning:hover{box-shadow:0 14px 26px -12px rgba(224,126,60,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(224,126,60,.2)}.btn.btn-warning.disabled,.btn.btn-warning.disabled.active,.btn.btn-warning.disabled.focus,.btn.btn-warning.disabled:active,.btn.btn-warning.disabled:focus,.btn.btn-warning.disabled:hover,.btn.btn-warning:disabled,.btn.btn-warning:disabled.active,.btn.btn-warning:disabled.focus,.btn.btn-warning:disabled:active,.btn.btn-warning:disabled:focus,.btn.btn-warning:disabled:hover,.btn.btn-warning[disabled],.btn.btn-warning[disabled].active,.btn.btn-warning[disabled].focus,.btn.btn-warning[disabled]:active,.btn.btn-warning[disabled]:focus,.btn.btn-warning[disabled]:hover,.navbar .navbar-nav>li>a.btn.btn-warning.disabled,.navbar .navbar-nav>li>a.btn.btn-warning.disabled.active,.navbar .navbar-nav>li>a.btn.btn-warning.disabled.focus,.navbar .navbar-nav>li>a.btn.btn-warning.disabled:active,.navbar .navbar-nav>li>a.btn.btn-warning.disabled:focus,.navbar .navbar-nav>li>a.btn.btn-warning.disabled:hover,.navbar .navbar-nav>li>a.btn.btn-warning:disabled,.navbar .navbar-nav>li>a.btn.btn-warning:disabled.active,.navbar .navbar-nav>li>a.btn.btn-warning:disabled.focus,.navbar .navbar-nav>li>a.btn.btn-warning:disabled:active,.navbar .navbar-nav>li>a.btn.btn-warning:disabled:focus,.navbar .navbar-nav>li>a.btn.btn-warning:disabled:hover,.navbar .navbar-nav>li>a.btn.btn-warning[disabled],.navbar .navbar-nav>li>a.btn.btn-warning[disabled].active,.navbar .navbar-nav>li>a.btn.btn-warning[disabled].focus,.navbar .navbar-nav>li>a.btn.btn-warning[disabled]:active,.navbar .navbar-nav>li>a.btn.btn-warning[disabled]:focus,.navbar .navbar-nav>li>a.btn.btn-warning[disabled]:hover,fieldset[disabled] .btn.btn-warning,fieldset[disabled] .btn.btn-warning.active,fieldset[disabled] .btn.btn-warning.focus,fieldset[disabled] .btn.btn-warning:active,fieldset[disabled] .btn.btn-warning:focus,fieldset[disabled] .btn.btn-warning:hover,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-warning,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-warning.active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-warning.focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-warning:active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-warning:focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-warning:hover{box-shadow:none}.btn.btn-warning.btn-simple,.navbar .navbar-nav>li>a.btn.btn-warning.btn-simple{background-color:transparent;color:#e07e3c;box-shadow:none}.btn.btn-warning.btn-simple:active,.btn.btn-warning.btn-simple:focus,.btn.btn-warning.btn-simple:hover,.navbar .navbar-nav>li>a.btn.btn-warning.btn-simple:active,.navbar .navbar-nav>li>a.btn.btn-warning.btn-simple:focus,.navbar .navbar-nav>li>a.btn.btn-warning.btn-simple:hover{background-color:transparent;color:#e07e3c}.btn.btn-danger,.navbar .navbar-nav>li>a.btn.btn-danger{box-shadow:0 4px 5px 0 rgba(244,67,54,.14),0 1px 10px 0 rgba(244,67,54,.12),0 2px 4px -1px rgba(244,67,54,.2)}.btn.btn-danger,.btn.btn-danger.active,.btn.btn-danger.active:focus,.btn.btn-danger.active:hover,.btn.btn-danger:active,.btn.btn-danger:active:focus,.btn.btn-danger:active:hover,.btn.btn-danger:focus,.btn.btn-danger:hover,.navbar .navbar-nav>li>a.btn.btn-danger,.navbar .navbar-nav>li>a.btn.btn-danger.active,.navbar .navbar-nav>li>a.btn.btn-danger.active:focus,.navbar .navbar-nav>li>a.btn.btn-danger.active:hover,.navbar .navbar-nav>li>a.btn.btn-danger:active,.navbar .navbar-nav>li>a.btn.btn-danger:active:focus,.navbar .navbar-nav>li>a.btn.btn-danger:active:hover,.navbar .navbar-nav>li>a.btn.btn-danger:focus,.navbar .navbar-nav>li>a.btn.btn-danger:hover,.open>.btn.btn-danger.dropdown-toggle,.open>.btn.btn-danger.dropdown-toggle:focus,.open>.btn.btn-danger.dropdown-toggle:hover,.open>.navbar .navbar-nav>li>a.btn.btn-danger.dropdown-toggle,.open>.navbar .navbar-nav>li>a.btn.btn-danger.dropdown-toggle:focus,.open>.navbar .navbar-nav>li>a.btn.btn-danger.dropdown-toggle:hover{background-color:#f44336;color:#fff}.btn.btn-danger:active,.btn.btn-danger:focus,.btn.btn-danger:hover,.navbar .navbar-nav>li>a.btn.btn-danger:active,.navbar .navbar-nav>li>a.btn.btn-danger:focus,.navbar .navbar-nav>li>a.btn.btn-danger:hover{box-shadow:0 14px 26px -12px rgba(244,67,54,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(244,67,54,.2)}.btn.btn-danger.disabled,.btn.btn-danger.disabled.active,.btn.btn-danger.disabled.focus,.btn.btn-danger.disabled:active,.btn.btn-danger.disabled:focus,.btn.btn-danger.disabled:hover,.btn.btn-danger:disabled,.btn.btn-danger:disabled.active,.btn.btn-danger:disabled.focus,.btn.btn-danger:disabled:active,.btn.btn-danger:disabled:focus,.btn.btn-danger:disabled:hover,.btn.btn-danger[disabled],.btn.btn-danger[disabled].active,.btn.btn-danger[disabled].focus,.btn.btn-danger[disabled]:active,.btn.btn-danger[disabled]:focus,.btn.btn-danger[disabled]:hover,.navbar .navbar-nav>li>a.btn.btn-danger.disabled,.navbar .navbar-nav>li>a.btn.btn-danger.disabled.active,.navbar .navbar-nav>li>a.btn.btn-danger.disabled.focus,.navbar .navbar-nav>li>a.btn.btn-danger.disabled:active,.navbar .navbar-nav>li>a.btn.btn-danger.disabled:focus,.navbar .navbar-nav>li>a.btn.btn-danger.disabled:hover,.navbar .navbar-nav>li>a.btn.btn-danger:disabled,.navbar .navbar-nav>li>a.btn.btn-danger:disabled.active,.navbar .navbar-nav>li>a.btn.btn-danger:disabled.focus,.navbar .navbar-nav>li>a.btn.btn-danger:disabled:active,.navbar .navbar-nav>li>a.btn.btn-danger:disabled:focus,.navbar .navbar-nav>li>a.btn.btn-danger:disabled:hover,.navbar .navbar-nav>li>a.btn.btn-danger[disabled],.navbar .navbar-nav>li>a.btn.btn-danger[disabled].active,.navbar .navbar-nav>li>a.btn.btn-danger[disabled].focus,.navbar .navbar-nav>li>a.btn.btn-danger[disabled]:active,.navbar .navbar-nav>li>a.btn.btn-danger[disabled]:focus,.navbar .navbar-nav>li>a.btn.btn-danger[disabled]:hover,fieldset[disabled] .btn.btn-danger,fieldset[disabled] .btn.btn-danger.active,fieldset[disabled] .btn.btn-danger.focus,fieldset[disabled] .btn.btn-danger:active,fieldset[disabled] .btn.btn-danger:focus,fieldset[disabled] .btn.btn-danger:hover,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-danger,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-danger.active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-danger.focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-danger:active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-danger:focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-danger:hover{box-shadow:none}.btn.btn-danger.btn-simple,.navbar .navbar-nav>li>a.btn.btn-danger.btn-simple{background-color:transparent;color:#f44336;box-shadow:none}.btn.btn-danger.btn-simple:active,.btn.btn-danger.btn-simple:focus,.btn.btn-danger.btn-simple:hover,.navbar .navbar-nav>li>a.btn.btn-danger.btn-simple:active,.navbar .navbar-nav>li>a.btn.btn-danger.btn-simple:focus,.navbar .navbar-nav>li>a.btn.btn-danger.btn-simple:hover{background-color:transparent;color:#f44336}.btn.btn-rose,.navbar .navbar-nav>li>a.btn.btn-rose{box-shadow:0 4px 5px 0 rgba(233,30,99,.14),0 1px 10px 0 rgba(233,30,99,.12),0 2px 4px -1px rgba(233,30,99,.2)}.btn.btn-rose,.btn.btn-rose.active,.btn.btn-rose.active:focus,.btn.btn-rose.active:hover,.btn.btn-rose:active,.btn.btn-rose:active:focus,.btn.btn-rose:active:hover,.btn.btn-rose:focus,.btn.btn-rose:hover,.navbar .navbar-nav>li>a.btn.btn-rose,.navbar .navbar-nav>li>a.btn.btn-rose.active,.navbar .navbar-nav>li>a.btn.btn-rose.active:focus,.navbar .navbar-nav>li>a.btn.btn-rose.active:hover,.navbar .navbar-nav>li>a.btn.btn-rose:active,.navbar .navbar-nav>li>a.btn.btn-rose:active:focus,.navbar .navbar-nav>li>a.btn.btn-rose:active:hover,.navbar .navbar-nav>li>a.btn.btn-rose:focus,.navbar .navbar-nav>li>a.btn.btn-rose:hover,.open>.btn.btn-rose.dropdown-toggle,.open>.btn.btn-rose.dropdown-toggle:focus,.open>.btn.btn-rose.dropdown-toggle:hover,.open>.navbar .navbar-nav>li>a.btn.btn-rose.dropdown-toggle,.open>.navbar .navbar-nav>li>a.btn.btn-rose.dropdown-toggle:focus,.open>.navbar .navbar-nav>li>a.btn.btn-rose.dropdown-toggle:hover{background-color:#e91e63;color:#fff}.btn.btn-rose:active,.btn.btn-rose:focus,.btn.btn-rose:hover,.navbar .navbar-nav>li>a.btn.btn-rose:active,.navbar .navbar-nav>li>a.btn.btn-rose:focus,.navbar .navbar-nav>li>a.btn.btn-rose:hover{box-shadow:0 14px 26px -12px rgba(233,30,99,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(233,30,99,.2)}.btn.btn-rose.disabled,.btn.btn-rose.disabled.active,.btn.btn-rose.disabled.focus,.btn.btn-rose.disabled:active,.btn.btn-rose.disabled:focus,.btn.btn-rose.disabled:hover,.btn.btn-rose:disabled,.btn.btn-rose:disabled.active,.btn.btn-rose:disabled.focus,.btn.btn-rose:disabled:active,.btn.btn-rose:disabled:focus,.btn.btn-rose:disabled:hover,.btn.btn-rose[disabled],.btn.btn-rose[disabled].active,.btn.btn-rose[disabled].focus,.btn.btn-rose[disabled]:active,.btn.btn-rose[disabled]:focus,.btn.btn-rose[disabled]:hover,.navbar .navbar-nav>li>a.btn.btn-rose.disabled,.navbar .navbar-nav>li>a.btn.btn-rose.disabled.active,.navbar .navbar-nav>li>a.btn.btn-rose.disabled.focus,.navbar .navbar-nav>li>a.btn.btn-rose.disabled:active,.navbar .navbar-nav>li>a.btn.btn-rose.disabled:focus,.navbar .navbar-nav>li>a.btn.btn-rose.disabled:hover,.navbar .navbar-nav>li>a.btn.btn-rose:disabled,.navbar .navbar-nav>li>a.btn.btn-rose:disabled.active,.navbar .navbar-nav>li>a.btn.btn-rose:disabled.focus,.navbar .navbar-nav>li>a.btn.btn-rose:disabled:active,.navbar .navbar-nav>li>a.btn.btn-rose:disabled:focus,.navbar .navbar-nav>li>a.btn.btn-rose:disabled:hover,.navbar .navbar-nav>li>a.btn.btn-rose[disabled],.navbar .navbar-nav>li>a.btn.btn-rose[disabled].active,.navbar .navbar-nav>li>a.btn.btn-rose[disabled].focus,.navbar .navbar-nav>li>a.btn.btn-rose[disabled]:active,.navbar .navbar-nav>li>a.btn.btn-rose[disabled]:focus,.navbar .navbar-nav>li>a.btn.btn-rose[disabled]:hover,fieldset[disabled] .btn.btn-rose,fieldset[disabled] .btn.btn-rose.active,fieldset[disabled] .btn.btn-rose.focus,fieldset[disabled] .btn.btn-rose:active,fieldset[disabled] .btn.btn-rose:focus,fieldset[disabled] .btn.btn-rose:hover,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-rose,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-rose.active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-rose.focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-rose:active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-rose:focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-rose:hover{box-shadow:none}.btn.btn-rose.btn-simple,.navbar .navbar-nav>li>a.btn.btn-rose.btn-simple{background-color:transparent;color:#e91e63;box-shadow:none}.btn.btn-rose.btn-simple:active,.btn.btn-rose.btn-simple:focus,.btn.btn-rose.btn-simple:hover,.navbar .navbar-nav>li>a.btn.btn-rose.btn-simple:active,.navbar .navbar-nav>li>a.btn.btn-rose.btn-simple:focus,.navbar .navbar-nav>li>a.btn.btn-rose.btn-simple:hover{background-color:transparent;color:#e91e63}.btn.btn-cyan,.navbar .navbar-nav>li>a.btn.btn-cyan{box-shadow:0 4px 5px 0 rgba(0,188,212,.14),0 1px 10px 0 rgba(0,188,212,.12),0 2px 4px -1px rgba(0,188,212,.2)}.btn.btn-cyan,.btn.btn-cyan.active,.btn.btn-cyan.active:focus,.btn.btn-cyan.active:hover,.btn.btn-cyan:active,.btn.btn-cyan:active:focus,.btn.btn-cyan:active:hover,.btn.btn-cyan:focus,.btn.btn-cyan:hover,.navbar .navbar-nav>li>a.btn.btn-cyan,.navbar .navbar-nav>li>a.btn.btn-cyan.active,.navbar .navbar-nav>li>a.btn.btn-cyan.active:focus,.navbar .navbar-nav>li>a.btn.btn-cyan.active:hover,.navbar .navbar-nav>li>a.btn.btn-cyan:active,.navbar .navbar-nav>li>a.btn.btn-cyan:active:focus,.navbar .navbar-nav>li>a.btn.btn-cyan:active:hover,.navbar .navbar-nav>li>a.btn.btn-cyan:focus,.navbar .navbar-nav>li>a.btn.btn-cyan:hover,.open>.btn.btn-cyan.dropdown-toggle,.open>.btn.btn-cyan.dropdown-toggle:focus,.open>.btn.btn-cyan.dropdown-toggle:hover,.open>.navbar .navbar-nav>li>a.btn.btn-cyan.dropdown-toggle,.open>.navbar .navbar-nav>li>a.btn.btn-cyan.dropdown-toggle:focus,.open>.navbar .navbar-nav>li>a.btn.btn-cyan.dropdown-toggle:hover{background-color:#00bcd4;color:#fff}.btn.btn-cyan:active,.btn.btn-cyan:focus,.btn.btn-cyan:hover,.navbar .navbar-nav>li>a.btn.btn-cyan:active,.navbar .navbar-nav>li>a.btn.btn-cyan:focus,.navbar .navbar-nav>li>a.btn.btn-cyan:hover{box-shadow:0 14px 26px -12px rgba(0,188,212,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(0,188,212,.2)}.btn.btn-cyan.disabled,.btn.btn-cyan.disabled.active,.btn.btn-cyan.disabled.focus,.btn.btn-cyan.disabled:active,.btn.btn-cyan.disabled:focus,.btn.btn-cyan.disabled:hover,.btn.btn-cyan:disabled,.btn.btn-cyan:disabled.active,.btn.btn-cyan:disabled.focus,.btn.btn-cyan:disabled:active,.btn.btn-cyan:disabled:focus,.btn.btn-cyan:disabled:hover,.btn.btn-cyan[disabled],.btn.btn-cyan[disabled].active,.btn.btn-cyan[disabled].focus,.btn.btn-cyan[disabled]:active,.btn.btn-cyan[disabled]:focus,.btn.btn-cyan[disabled]:hover,.navbar .navbar-nav>li>a.btn.btn-cyan.disabled,.navbar .navbar-nav>li>a.btn.btn-cyan.disabled.active,.navbar .navbar-nav>li>a.btn.btn-cyan.disabled.focus,.navbar .navbar-nav>li>a.btn.btn-cyan.disabled:active,.navbar .navbar-nav>li>a.btn.btn-cyan.disabled:focus,.navbar .navbar-nav>li>a.btn.btn-cyan.disabled:hover,.navbar .navbar-nav>li>a.btn.btn-cyan:disabled,.navbar .navbar-nav>li>a.btn.btn-cyan:disabled.active,.navbar .navbar-nav>li>a.btn.btn-cyan:disabled.focus,.navbar .navbar-nav>li>a.btn.btn-cyan:disabled:active,.navbar .navbar-nav>li>a.btn.btn-cyan:disabled:focus,.navbar .navbar-nav>li>a.btn.btn-cyan:disabled:hover,.navbar .navbar-nav>li>a.btn.btn-cyan[disabled],.navbar .navbar-nav>li>a.btn.btn-cyan[disabled].active,.navbar .navbar-nav>li>a.btn.btn-cyan[disabled].focus,.navbar .navbar-nav>li>a.btn.btn-cyan[disabled]:active,.navbar .navbar-nav>li>a.btn.btn-cyan[disabled]:focus,.navbar .navbar-nav>li>a.btn.btn-cyan[disabled]:hover,fieldset[disabled] .btn.btn-cyan,fieldset[disabled] .btn.btn-cyan.active,fieldset[disabled] .btn.btn-cyan.focus,fieldset[disabled] .btn.btn-cyan:active,fieldset[disabled] .btn.btn-cyan:focus,fieldset[disabled] .btn.btn-cyan:hover,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-cyan,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-cyan.active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-cyan.focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-cyan:active,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-cyan:focus,fieldset[disabled] .navbar .navbar-nav>li>a.btn.btn-cyan:hover{box-shadow:none}.btn.btn-cyan.btn-simple,.navbar .navbar-nav>li>a.btn.btn-cyan.btn-simple{background-color:transparent;color:#00bcd4;box-shadow:none}.btn.btn-cyan.btn-simple:active,.btn.btn-cyan.btn-simple:focus,.btn.btn-cyan.btn-simple:hover,.navbar .navbar-nav>li>a.btn.btn-cyan.btn-simple:active,.navbar .navbar-nav>li>a.btn.btn-cyan.btn-simple:focus,.navbar .navbar-nav>li>a.btn.btn-cyan.btn-simple:hover{background-color:transparent;color:#00bcd4}.btn.btn-white,.btn.btn-white:focus,.btn.btn-white:hover,.navbar .navbar-nav>li>a.btn.btn-white,.navbar .navbar-nav>li>a.btn.btn-white:focus,.navbar .navbar-nav>li>a.btn.btn-white:hover{background-color:#fff;color:#333}.btn.btn-white.btn-simple,.navbar .navbar-nav>li>a.btn.btn-white.btn-simple{color:#fff;background:transparent;box-shadow:none}.btn.btn-facebook,.navbar .navbar-nav>li>a.btn.btn-facebook{background-color:#3b5998;color:#fff;box-shadow:0 2px 2px 0 rgba(59,89,152,.14),0 3px 1px -2px rgba(59,89,152,.2),0 1px 5px 0 rgba(59,89,152,.12)}.btn.btn-facebook:active,.btn.btn-facebook:focus,.btn.btn-facebook:hover,.navbar .navbar-nav>li>a.btn.btn-facebook:active,.navbar .navbar-nav>li>a.btn.btn-facebook:focus,.navbar .navbar-nav>li>a.btn.btn-facebook:hover{background-color:#3b5998;color:#fff;box-shadow:0 14px 26px -12px rgba(59,89,152,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(59,89,152,.2)}.btn.btn-facebook.btn-simple,.navbar .navbar-nav>li>a.btn.btn-facebook.btn-simple{color:#3b5998;background-color:transparent;box-shadow:none}.btn.btn-twitter,.navbar .navbar-nav>li>a.btn.btn-twitter{background-color:#55acee;color:#fff;box-shadow:0 2px 2px 0 rgba(85,172,238,.14),0 3px 1px -2px rgba(85,172,238,.2),0 1px 5px 0 rgba(85,172,238,.12)}.btn.btn-twitter:active,.btn.btn-twitter:focus,.btn.btn-twitter:hover,.navbar .navbar-nav>li>a.btn.btn-twitter:active,.navbar .navbar-nav>li>a.btn.btn-twitter:focus,.navbar .navbar-nav>li>a.btn.btn-twitter:hover{background-color:#55acee;color:#fff;box-shadow:0 14px 26px -12px rgba(85,172,238,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(85,172,238,.2)}.btn.btn-twitter.btn-simple,.navbar .navbar-nav>li>a.btn.btn-twitter.btn-simple{color:#55acee;background-color:transparent;box-shadow:none}.btn.btn-pinterest,.navbar .navbar-nav>li>a.btn.btn-pinterest{background-color:#cc2127;color:#fff;box-shadow:0 2px 2px 0 rgba(204,33,39,.14),0 3px 1px -2px rgba(204,33,39,.2),0 1px 5px 0 rgba(204,33,39,.12)}.btn.btn-pinterest:active,.btn.btn-pinterest:focus,.btn.btn-pinterest:hover,.navbar .navbar-nav>li>a.btn.btn-pinterest:active,.navbar .navbar-nav>li>a.btn.btn-pinterest:focus,.navbar .navbar-nav>li>a.btn.btn-pinterest:hover{background-color:#cc2127;color:#fff;box-shadow:0 14px 26px -12px rgba(204,33,39,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(204,33,39,.2)}.btn.btn-pinterest.btn-simple,.navbar .navbar-nav>li>a.btn.btn-pinterest.btn-simple{color:#cc2127;background-color:transparent;box-shadow:none}.btn.btn-google,.navbar .navbar-nav>li>a.btn.btn-google{background-color:#dd4b39;color:#fff;box-shadow:0 2px 2px 0 rgba(221,75,57,.14),0 3px 1px -2px rgba(221,75,57,.2),0 1px 5px 0 rgba(221,75,57,.12)}.btn.btn-google:active,.btn.btn-google:focus,.btn.btn-google:hover,.navbar .navbar-nav>li>a.btn.btn-google:active,.navbar .navbar-nav>li>a.btn.btn-google:focus,.navbar .navbar-nav>li>a.btn.btn-google:hover{background-color:#dd4b39;color:#fff;box-shadow:0 14px 26px -12px rgba(221,75,57,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(221,75,57,.2)}.btn.btn-google.btn-simple,.navbar .navbar-nav>li>a.btn.btn-google.btn-simple{color:#dd4b39;background-color:transparent;box-shadow:none}.btn.btn-linkedin,.navbar .navbar-nav>li>a.btn.btn-linkedin{background-color:#0976b4;color:#fff;box-shadow:0 2px 2px 0 rgba(9,118,180,.14),0 3px 1px -2px rgba(9,118,180,.2),0 1px 5px 0 rgba(9,118,180,.12)}.btn.btn-linkedin:active,.btn.btn-linkedin:focus,.btn.btn-linkedin:hover,.navbar .navbar-nav>li>a.btn.btn-linkedin:active,.navbar .navbar-nav>li>a.btn.btn-linkedin:focus,.navbar .navbar-nav>li>a.btn.btn-linkedin:hover{background-color:#0976b4;color:#fff;box-shadow:0 14px 26px -12px rgba(9,118,180,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(9,118,180,.2)}.btn.btn-linkedin.btn-simple,.navbar .navbar-nav>li>a.btn.btn-linkedin.btn-simple{color:#0976b4;background-color:transparent;box-shadow:none}.btn.btn-dribbble,.navbar .navbar-nav>li>a.btn.btn-dribbble{background-color:#ea4c89;color:#fff;box-shadow:0 2px 2px 0 rgba(234,76,137,.14),0 3px 1px -2px rgba(234,76,137,.2),0 1px 5px 0 rgba(234,76,137,.12)}.btn.btn-dribbble:active,.btn.btn-dribbble:focus,.btn.btn-dribbble:hover,.navbar .navbar-nav>li>a.btn.btn-dribbble:active,.navbar .navbar-nav>li>a.btn.btn-dribbble:focus,.navbar .navbar-nav>li>a.btn.btn-dribbble:hover{background-color:#ea4c89;color:#fff;box-shadow:0 14px 26px -12px rgba(234,76,137,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(234,76,137,.2)}.btn.btn-dribbble.btn-simple,.navbar .navbar-nav>li>a.btn.btn-dribbble.btn-simple{color:#ea4c89;background-color:transparent;box-shadow:none}.btn.btn-github,.navbar .navbar-nav>li>a.btn.btn-github{background-color:#333;color:#fff;box-shadow:0 2px 2px 0 rgba(51,51,51,.14),0 3px 1px -2px rgba(51,51,51,.2),0 1px 5px 0 rgba(51,51,51,.12)}.btn.btn-github:active,.btn.btn-github:focus,.btn.btn-github:hover,.navbar .navbar-nav>li>a.btn.btn-github:active,.navbar .navbar-nav>li>a.btn.btn-github:focus,.navbar .navbar-nav>li>a.btn.btn-github:hover{background-color:#333;color:#fff;box-shadow:0 14px 26px -12px rgba(51,51,51,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(51,51,51,.2)}.btn.btn-github.btn-simple,.navbar .navbar-nav>li>a.btn.btn-github.btn-simple{color:#333;background-color:transparent;box-shadow:none}.btn.btn-youtube,.navbar .navbar-nav>li>a.btn.btn-youtube{background-color:#e52d27;color:#fff;box-shadow:0 2px 2px 0 rgba(229,45,39,.14),0 3px 1px -2px rgba(229,45,39,.2),0 1px 5px 0 rgba(229,45,39,.12)}.btn.btn-youtube:active,.btn.btn-youtube:focus,.btn.btn-youtube:hover,.navbar .navbar-nav>li>a.btn.btn-youtube:active,.navbar .navbar-nav>li>a.btn.btn-youtube:focus,.navbar .navbar-nav>li>a.btn.btn-youtube:hover{background-color:#e52d27;color:#fff;box-shadow:0 14px 26px -12px rgba(229,45,39,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(229,45,39,.2)}.btn.btn-youtube.btn-simple,.navbar .navbar-nav>li>a.btn.btn-youtube.btn-simple{color:#e52d27;background-color:transparent;box-shadow:none}.btn.btn-instagram,.navbar .navbar-nav>li>a.btn.btn-instagram{background-color:#125688;color:#fff;box-shadow:0 2px 2px 0 rgba(18,86,136,.14),0 3px 1px -2px rgba(18,86,136,.2),0 1px 5px 0 rgba(18,86,136,.12)}.btn.btn-instagram:active,.btn.btn-instagram:focus,.btn.btn-instagram:hover,.navbar .navbar-nav>li>a.btn.btn-instagram:active,.navbar .navbar-nav>li>a.btn.btn-instagram:focus,.navbar .navbar-nav>li>a.btn.btn-instagram:hover{background-color:#125688;color:#fff;box-shadow:0 14px 26px -12px rgba(18,86,136,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(18,86,136,.2)}.btn.btn-instagram.btn-simple,.navbar .navbar-nav>li>a.btn.btn-instagram.btn-simple{color:#125688;background-color:transparent;box-shadow:none}.btn.btn-reddit,.navbar .navbar-nav>li>a.btn.btn-reddit{background-color:#ff4500;color:#fff;box-shadow:0 2px 2px 0 rgba(255,69,0,.14),0 3px 1px -2px rgba(255,69,0,.2),0 1px 5px 0 rgba(255,69,0,.12)}.btn.btn-reddit:active,.btn.btn-reddit:focus,.btn.btn-reddit:hover,.navbar .navbar-nav>li>a.btn.btn-reddit:active,.navbar .navbar-nav>li>a.btn.btn-reddit:focus,.navbar .navbar-nav>li>a.btn.btn-reddit:hover{background-color:#ff4500;color:#fff;box-shadow:0 14px 26px -12px rgba(255,69,0,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(255,69,0,.2)}.btn.btn-reddit.btn-simple,.navbar .navbar-nav>li>a.btn.btn-reddit.btn-simple{color:#ff4500;background-color:transparent;box-shadow:none}.btn.btn-tumblr,.navbar .navbar-nav>li>a.btn.btn-tumblr{background-color:#35465c;color:#fff;box-shadow:0 2px 2px 0 rgba(53,70,92,.14),0 3px 1px -2px rgba(53,70,92,.2),0 1px 5px 0 rgba(53,70,92,.12)}.btn.btn-tumblr:active,.btn.btn-tumblr:focus,.btn.btn-tumblr:hover,.navbar .navbar-nav>li>a.btn.btn-tumblr:active,.navbar .navbar-nav>li>a.btn.btn-tumblr:focus,.navbar .navbar-nav>li>a.btn.btn-tumblr:hover{background-color:#35465c;color:#fff;box-shadow:0 14px 26px -12px rgba(53,70,92,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(53,70,92,.2)}.btn.btn-tumblr.btn-simple,.navbar .navbar-nav>li>a.btn.btn-tumblr.btn-simple{color:#35465c;background-color:transparent;box-shadow:none}.btn.btn-behance,.navbar .navbar-nav>li>a.btn.btn-behance{background-color:#1769ff;color:#fff;box-shadow:0 2px 2px 0 rgba(23,105,255,.14),0 3px 1px -2px rgba(23,105,255,.2),0 1px 5px 0 rgba(23,105,255,.12)}.btn.btn-behance:active,.btn.btn-behance:focus,.btn.btn-behance:hover,.navbar .navbar-nav>li>a.btn.btn-behance:active,.navbar .navbar-nav>li>a.btn.btn-behance:focus,.navbar .navbar-nav>li>a.btn.btn-behance:hover{background-color:#1769ff;color:#fff;box-shadow:0 14px 26px -12px rgba(23,105,255,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(23,105,255,.2)}.btn.btn-behance.btn-simple,.navbar .navbar-nav>li>a.btn.btn-behance.btn-simple{color:#1769ff;background-color:transparent;box-shadow:none}.btn:active,.btn:active:focus,.btn:focus,.navbar .navbar-nav>li>a.btn:active,.navbar .navbar-nav>li>a.btn:active:focus,.navbar .navbar-nav>li>a.btn:focus{outline:0}.btn.btn-round,.navbar .navbar-nav>li>a.btn.btn-round{border-radius:30px}.btn:not(.btn-just-icon):not(.btn-fab) .fa,.navbar .navbar-nav>li>a.btn:not(.btn-just-icon):not(.btn-fab) .fa{font-size:18px;margin-top:-2px;position:relative;top:2px}.btn.btn-fab,.navbar .navbar-nav>li>a.btn.btn-fab{border-radius:50%;font-size:24px;height:56px;margin:auto;min-width:56px;width:56px;padding:0;overflow:hidden;position:relative;line-height:normal}.btn.btn-fab .ripple-container,.navbar .navbar-nav>li>a.btn.btn-fab .ripple-container{border-radius:50%}.btn-group-sm .btn.btn-fab,.btn-group-sm .navbar .navbar-nav>li>a.btn.btn-fab,.btn.btn-fab.btn-fab-mini,.navbar .navbar-nav>li>a.btn.btn-fab.btn-fab-mini{height:40px;min-width:40px;width:40px}.amazon-management .top_buttons_body .nav .btn-group-sm .btn.btn-fab.dropdown-toggle:after,.amazon-management .top_buttons_body .nav .btn-group-sm .navbar .navbar-nav>li>a.btn.btn-fab.dropdown-toggle:after,.amazon-management .top_buttons_body .nav .btn.btn-fab.btn-fab-mini.dropdown-toggle:after,.amazon-management .top_buttons_body .nav .navbar .navbar-nav>li>a.btn.btn-fab.btn-fab-mini.dropdown-toggle:after,.btn-group-sm .amazon-management .top_buttons_body .nav .btn.btn-fab.dropdown-toggle:after,.btn-group-sm .btn.btn-fab.material-icons,.btn-group-sm .navbar .amazon-management .top_buttons_body .nav .navbar-nav>li>a.btn.btn-fab.dropdown-toggle:after,.btn-group-sm .navbar .amazon-management .top_buttons_body .nav .open .navbar-nav>li>a.btn.btn-fab.dropdown-toggle:after,.btn-group-sm .navbar .navbar-nav>li>a.btn.btn-fab.material-icons,.btn.btn-fab.btn-fab-mini.material-icons,.navbar .amazon-management .top_buttons_body .nav .navbar-nav>li>a.btn.btn-fab.btn-fab-mini.dropdown-toggle:after,.navbar .amazon-management .top_buttons_body .nav .open .navbar-nav>li>a.btn.btn-fab.btn-fab-mini.dropdown-toggle:after,.navbar .navbar-nav>li>a.btn.btn-fab.btn-fab-mini.material-icons{top:-3.5px;left:-3.5px}.amazon-management .top_buttons_body .nav .btn-group-sm .btn.btn-fab .dropdown-toggle:after,.amazon-management .top_buttons_body .nav .btn-group-sm .navbar .navbar-nav>li>a.btn.btn-fab .dropdown-toggle:after,.amazon-management .top_buttons_body .nav .btn.btn-fab.btn-fab-mini .dropdown-toggle:after,.amazon-management .top_buttons_body .nav .navbar .navbar-nav>li>a.btn.btn-fab.btn-fab-mini .dropdown-toggle:after,.btn-group-sm .btn.btn-fab .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.btn-group-sm .btn.btn-fab .material-icons,.btn-group-sm .navbar .navbar-nav>li>a.btn.btn-fab .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.btn-group-sm .navbar .navbar-nav>li>a.btn.btn-fab .material-icons,.btn.btn-fab.btn-fab-mini .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.btn.btn-fab.btn-fab-mini .material-icons,.navbar .navbar-nav>li>a.btn.btn-fab.btn-fab-mini .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.navbar .navbar-nav>li>a.btn.btn-fab.btn-fab-mini .material-icons{font-size:17px}.amazon-management .top_buttons_body .nav .btn.btn-fab i.dropdown-toggle:after,.amazon-management .top_buttons_body .nav .navbar .navbar-nav>li>a.btn.btn-fab i.dropdown-toggle:after,.btn.btn-fab .amazon-management .top_buttons_body .nav i.dropdown-toggle:after,.btn.btn-fab i.material-icons,.navbar .navbar-nav>li>a.btn.btn-fab .amazon-management .top_buttons_body .nav i.dropdown-toggle:after,.navbar .navbar-nav>li>a.btn.btn-fab i.material-icons{position:absolute;top:50%;left:50%;transform:translate(-12px,-12px);line-height:24px;width:24px;font-size:24px}.btn-group-lg .btn,.btn-group-lg .navbar .navbar-nav>li>a.btn,.btn.btn-lg,.navbar .navbar-nav>li>a.btn.btn-lg{font-size:14px;padding:18px 36px}.btn-group-sm .btn,.btn-group-sm .navbar .navbar-nav>li>a.btn,.btn.btn-sm,.navbar .navbar-nav>li>a.btn.btn-sm{padding:5px 20px;font-size:11px}.btn-group-xs .btn,.btn-group-xs .navbar .navbar-nav>li>a.btn,.btn.btn-xs,.navbar .navbar-nav>li>a.btn.btn-xs{padding:4px 15px;font-size:10px}.btn.btn-just-icon,.navbar .navbar-nav>li>a.btn.btn-just-icon{font-size:20px;padding:11px;line-height:1em}.btn.btn-just-icon i,.navbar .navbar-nav>li>a.btn.btn-just-icon i{width:20px}.btn.btn-just-icon.btn-lg,.navbar .navbar-nav>li>a.btn.btn-just-icon.btn-lg{font-size:22px;padding:13px 18px}.amazon-management .top_buttons_body .nav .btn .dropdown-toggle:after,.btn .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.btn .material-icons{vertical-align:middle;font-size:17px;top:-1px;position:relative}.btn .caret{margin-left:2px}.navbar .navbar-nav>li>a.btn{margin-top:2px;margin-bottom:2px}.navbar .navbar-nav>li>a.btn.btn-fab{margin:5px 2px}.amazon-management .top_buttons_body .nav .navbar .navbar-nav>li>a:not(.btn) .dropdown-toggle:after,.navbar .navbar-nav>li>a:not(.btn) .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.navbar .navbar-nav>li>a:not(.btn) .material-icons{margin-top:-3px;top:0;position:relative;margin-right:3px}.navbar .navbar-nav>li>.profile-photo{margin:5px 2px}.navbar-default:not(.navbar-transparent) .navbar-nav>li>a.btn.btn-white.btn-simple{color:#555}.btn-group,.btn-group-vertical{position:relative;margin:10px 1px}.btn-group-vertical.open>.dropdown-toggle.btn,.btn-group-vertical.open>.dropdown-toggle.btn.btn-default,.btn-group.open>.dropdown-toggle.btn,.btn-group.open>.dropdown-toggle.btn.btn-default{background-color:#fff}.btn-group-vertical.open>.dropdown-toggle.btn.btn-inverse,.btn-group.open>.dropdown-toggle.btn.btn-inverse{background-color:#212121}.btn-group-vertical.open>.dropdown-toggle.btn.btn-primary,.btn-group.open>.dropdown-toggle.btn.btn-primary{background-color:#e07e3c}.btn-group-vertical.open>.dropdown-toggle.btn.btn-success,.btn-group.open>.dropdown-toggle.btn.btn-success{background-color:#4caf50}.btn-group-vertical.open>.dropdown-toggle.btn.btn-info,.btn-group.open>.dropdown-toggle.btn.btn-info{background-color:#00bcd4}.btn-group-vertical.open>.dropdown-toggle.btn.btn-warning,.btn-group.open>.dropdown-toggle.btn.btn-warning{background-color:#e07e3c}.btn-group-vertical.open>.dropdown-toggle.btn.btn-danger,.btn-group.open>.dropdown-toggle.btn.btn-danger{background-color:#f44336}.btn-group-vertical.open>.dropdown-toggle.btn.btn-rose,.btn-group.open>.dropdown-toggle.btn.btn-rose{background-color:#e91e63}.btn-group-vertical .dropdown-menu,.btn-group .dropdown-menu{border-radius:0 0 3px 3px}.btn-group-vertical.btn-group-raised,.btn-group.btn-group-raised{box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.btn-group-vertical .btn,.btn-group-vertical .btn+.btn,.btn-group-vertical .btn-group,.btn-group-vertical .btn:active,.btn-group .btn,.btn-group .btn+.btn,.btn-group .btn-group,.btn-group .btn:active{margin:0}.close{font-size:inherit;color:#fff;opacity:.9;text-shadow:none}.close:focus,.close:hover{opacity:1;color:#fff}.close i{font-size:11px}.loader{margin:0 auto;width:60px;position:absolute;display:block;left:0;right:0;z-index:1;-webkit-transform:translate3d(0,-50%,0);-moz-transform:translate3d(0,-50%,0);-o-transform:translate3d(0,-50%,0);-ms-transform:translate3d(0,-50%,0);transform:translate3d(0,-50%,0);text-align:center;top:50%}.loader:before{content:"";display:block;padding-top:100%}.circular{animation:rotate 2s linear infinite;height:100%;transform-origin:center center;width:100%;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}.path{stroke-dasharray:1,200;stroke-dashoffset:0;animation:dash 1.5s ease-in-out infinite,color 2s ease-in-out infinite;stroke-linecap:round}@keyframes rotate{to{transform:rotate(1turn)}}@keyframes dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:89,200;stroke-dashoffset:-35px}to{stroke-dasharray:89,200;stroke-dashoffset:-124px}}@keyframes color{0%,to{stroke:#e07e3c}50%{stroke:#e07e3c}to{stroke:#e07e3c}}body{background-color:#eee;color:#3c4858}body.inverse{background:#333}body.inverse,body.inverse .form-control{color:#fff}body.inverse .card,body.inverse .card .form-control,body.inverse .modal,body.inverse .modal .form-control,body.inverse .panel-default,body.inverse .panel-default .form-control{background-color:initial;color:initial}blockquote p{font-style:italic}.life-of-material-dashboard{background:#fff}.h1,.h2,.h3,.h4,body,h1,h2,h3,h4,h5,h6{font-family:Roboto,Helvetica,Arial,sans-serif;font-weight:300;line-height:1.5em}.serif-font{font-family:Roboto Slab,Times New Roman,serif}.page-header{height:60vh;background-position:50%;background-size:cover;margin:0;padding:0;border:0;border-bottom-left-radius:6px;border-bottom-right-radius:6px}a{color:#e07e3c}a:focus,a:hover{color:#dd6f26;text-decoration:none}a.text-info:focus,a.text-info:hover{color:#00a5bb}.amazon-management .top_buttons_body .nav .open a .dropdown-toggle:after,.amazon-management .top_buttons_body .nav a .dropdown-toggle:after,a .amazon-management .top_buttons_body .nav .dropdown-toggle:after,a .amazon-management .top_buttons_body .nav .open .dropdown-toggle:after,a .material-icons{vertical-align:middle}.btn-group.bootstrap-select.open .caret,.dropdown.open .caret,.dropup.open .caret,a[data-toggle=collapse][aria-expanded=true] .caret{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2);-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.bootstrap-tagsinput .tag,.bootstrap-tagsinput [data-role=remove],.caret{-webkit-transition:all .15s ease-in;-moz-transition:all .15s ease-in;-o-transition:all .15s ease-in;-ms-transition:all .15s ease-in;transition:all .15s ease-in}.animation-transition-general,.lock-page .card-profile,.login-page .card-login,.off-canvas-sidebar .logo .logo-normal,.off-canvas-sidebar .logo .simple-text,.off-canvas-sidebar .user .photo,.off-canvas-sidebar .user a,.sidebar .logo .logo-normal,.sidebar .logo .simple-text,.sidebar .user .photo,.sidebar .user a{-webkit-transition:all .3s linear;-moz-transition:all .3s linear;-o-transition:all .3s linear;-ms-transition:all .3s linear;transition:all .3s linear}.animation-transition-slow{-webkit-transition:all .37s linear;-moz-transition:all .37s linear;-o-transition:all .37s linear;-ms-transition:all .37s linear;transition:all .37s linear}.animation-transition-fast,.bootstrap-datetimepicker-widget table td>div,.bootstrap-datetimepicker-widget table td span,.bootstrap-datetimepicker-widget table th,.bootstrap-datetimepicker-widget table th>div,.navbar,.panel .panel-heading i{-webkit-transition:all .15s ease 0s;-moz-transition:all .15s ease 0s;-o-transition:all .15s ease 0s;-ms-transition:all .15s ease 0s;transition:all .15s ease 0s}legend{border-bottom:0}*{-webkit-tap-highlight-color:rgba(255,255,255,0);-webkit-tap-highlight-color:transparent}:focus{outline:0}a:active,a:focus,button::-moz-focus-inner,button:active,button:focus,button:hover,input[type=button]::-moz-focus-inner,input[type=file]>input[type=button]::-moz-focus-inner,input[type=reset]::-moz-focus-inner,input[type=submit]::-moz-focus-inner,select::-moz-focus-inner{outline:0!important}@-webkit-keyframes hinge{0%{-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}20%,60%{-webkit-transform:rotate(80deg);transform:rotate(80deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}40%,80%{-webkit-transform:rotate(60deg);transform:rotate(60deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;opacity:1}to{-webkit-transform:translate3d(0,700px,0);transform:translate3d(0,700px,0);opacity:0}}@keyframes hinge{0%{-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}20%,60%{-webkit-transform:rotate(80deg);transform:rotate(80deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}40%,80%{-webkit-transform:rotate(60deg);transform:rotate(60deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;opacity:1}to{-webkit-transform:translate3d(0,700px,0);transform:translate3d(0,700px,0);opacity:0}}.hinge{-webkit-animation-name:hinge;animation-name:hinge}.animated.hinge{-webkit-animation-duration:2s;animation-duration:2s}.animated{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}legend{margin-bottom:20px;font-size:21px}output{padding-top:8px}.form-control,output{font-size:14px;line-height:1.42857}.form-control{height:36px;padding:7px 0}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:36px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:24px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:44px}}.checkbox label,.radio label{min-height:20px}.form-control-static{padding-top:8px;padding-bottom:8px;min-height:34px}.input-sm .input-sm{height:24px;padding:3px 0;font-size:11px;line-height:1.5;border-radius:0}.input-sm select.input-sm{height:24px;line-height:24px}.input-sm select[multiple].input-sm,.input-sm textarea.input-sm{height:auto}.form-group-sm .form-control{height:24px;padding:3px 0;font-size:11px;line-height:1.5}.form-group-sm select.form-control{height:24px;line-height:24px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:24px;min-height:31px;padding:4px 0;font-size:11px;line-height:1.5}.input-lg .input-lg{height:44px;padding:9px 0;font-size:18px;line-height:1.33333;border-radius:0}.input-lg select.input-lg{height:44px;line-height:44px}.input-lg select[multiple].input-lg,.input-lg textarea.input-lg{height:auto}.form-group-lg .form-control{height:44px;padding:9px 0;font-size:18px;line-height:1.33333}.form-group-lg select.form-control{height:44px;line-height:44px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:44px;min-height:38px;padding:10px 0;font-size:18px;line-height:1.33333}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:8px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:28px}@media (min-width:768px){.form-horizontal .control-label{padding-top:8px}}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:13px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:4px;font-size:11px}}.label{border-radius:2px}.label,.label.label-default{background-color:#fff}.label.label-inverse{background-color:#212121}.label.label-primary{background-color:#e07e3c}.label.label-success{background-color:#4caf50}.label.label-info{background-color:#00bcd4}.label.label-warning{background-color:#e07e3c}.label.label-danger{background-color:#f44336}.label.label-rose{background-color:#e91e63}.form-control,.form-group .form-control{border:0;background-image:linear-gradient(#e07e3c,#e07e3c),linear-gradient(#d2d2d2,#d2d2d2);background-size:0 2px,100% 1px;background-repeat:no-repeat;background-position:bottom,50% calc(100% - 1px);background-color:transparent;transition:background 0s ease-out;float:none;box-shadow:none;border-radius:0;font-weight:400}.form-control::-moz-placeholder,.form-group .form-control::-moz-placeholder{color:#aaa;font-weight:400}.form-control:-ms-input-placeholder,.form-group .form-control:-ms-input-placeholder{color:#aaa;font-weight:400}.form-control::-webkit-input-placeholder,.form-group .form-control::-webkit-input-placeholder{color:#aaa;font-weight:400}.form-control[disabled],.form-control[readonly],.form-group .form-control[disabled],.form-group .form-control[readonly],fieldset[disabled] .form-control,fieldset[disabled] .form-group .form-control{background-color:transparent}.form-control[disabled],.form-group .form-control[disabled],fieldset[disabled] .form-control,fieldset[disabled] .form-group .form-control{background-image:none;border-bottom:1px dotted #d2d2d2}.form-group{position:relative}.form-group.label-floating label.control-label,.form-group.label-placeholder label.control-label,.form-group.label-static label.control-label{position:absolute;pointer-events:none;transition:all .3s ease;font-size:14px}.form-group.label-floating label.control-label{will-change:left,top,contents}.form-group.label-placeholder:not(.is-empty) label.control-label{display:none}.form-group .help-block{position:absolute;display:none}.form-group .form-control.valid:focus{background-image:linear-gradient(#4caf50,#4caf50),linear-gradient(#d2d2d2,#d2d2d2)}.form-group.is-focused .form-control{outline:none;background-image:linear-gradient(#e07e3c,#e07e3c),linear-gradient(#d2d2d2,#d2d2d2);background-size:100% 2px,100% 1px;box-shadow:none;transition-duration:.3s}.form-group.is-focused .form-control .material-input:after{background-color:#e07e3c}.form-group.is-focused.form-info .form-control{background-image:linear-gradient(#00bcd4,#00bcd4),linear-gradient(#d2d2d2,#d2d2d2)}.form-group.is-focused.form-success .form-control{background-image:linear-gradient(#4caf50,#4caf50),linear-gradient(#d2d2d2,#d2d2d2)}.form-group.is-focused.form-warning .form-control{background-image:linear-gradient(#e07e3c,#e07e3c),linear-gradient(#d2d2d2,#d2d2d2)}.form-group.is-focused.form-danger .form-control{background-image:linear-gradient(#f44336,#f44336),linear-gradient(#d2d2d2,#d2d2d2)}.form-group.is-focused.form-white .form-control{background-image:linear-gradient(#fff,#fff),linear-gradient(#d2d2d2,#d2d2d2)}.form-group.is-focused.label-placeholder label,.form-group.is-focused.label-placeholder label.control-label{color:#aaa}.form-group.is-focused .help-block{display:block}.form-group.has-warning .form-control{box-shadow:none}.form-group.has-warning.is-focused .form-control{background-image:linear-gradient(#e07e3c,#e07e3c),linear-gradient(#d2d2d2,#d2d2d2)}.form-group.has-warning .help-block,.form-group.has-warning label.control-label{color:#e07e3c}.form-group.has-error .form-control{box-shadow:none}.form-group.has-error .form-control,.form-group.has-error.is-focused .form-control{background-image:linear-gradient(#f44336,#f44336),linear-gradient(#d2d2d2,#d2d2d2)}.form-group.has-error .form-control{background-size:100% 2px,100% 1px;transition-duration:.3s}.form-group.has-error .help-block,.form-group.has-error label.control-label{color:#f44336}.form-group.has-success .form-control{box-shadow:none}.form-group.has-success.is-focused .form-control{background-image:linear-gradient(#4caf50,#4caf50),linear-gradient(#d2d2d2,#d2d2d2)}.form-group.has-success .help-block,.form-group.has-success label.control-label{color:#4caf50}.form-group.has-info .form-control{box-shadow:none}.form-group.has-info.is-focused .form-control{background-image:linear-gradient(#00bcd4,#00bcd4),linear-gradient(#d2d2d2,#d2d2d2)}.form-group.has-info .help-block,.form-group.has-info label.control-label{color:#00bcd4}.form-group textarea{resize:none}.form-group textarea~.form-control-highlight{margin-top:-11px}.form-group select{appearance:none}.form-group select~.material-input:after{display:none}.form-control::-moz-placeholder{font-size:14px;line-height:1.42857;color:#aaa;font-weight:400}.form-control:-ms-input-placeholder{font-size:14px;line-height:1.42857;color:#aaa;font-weight:400}.form-control::-webkit-input-placeholder{font-size:14px;line-height:1.42857;color:#aaa;font-weight:400}.checkbox label,.label-on-left,.label-on-right,.radio label,label{font-size:14px;line-height:1.42857;color:#aaa;font-weight:400}label.control-label{font-size:14px;line-height:1.07143;color:#aaa;font-weight:600;margin:16px 0 0}.help-block{margin-top:0;font-size:11px}.form-group{padding-bottom:10px;margin:20px 0 0}.form-group .form-control::-moz-placeholder{font-size:14px;line-height:1.42857;color:#aaa;font-weight:400}.form-group .form-control:-ms-input-placeholder{font-size:14px;line-height:1.42857;color:#aaa;font-weight:400}.form-group .form-control::-webkit-input-placeholder{font-size:14px;line-height:1.42857;color:#aaa;font-weight:400}.form-group .checkbox label,.form-group .label-on-left,.form-group .label-on-right,.form-group .radio label,.form-group label{font-size:14px;line-height:1.42857;color:#aaa;font-weight:400}.form-group label.control-label{font-size:14px;line-height:1.07143;color:#aaa;font-weight:600;margin:16px 0 0}.form-group .help-block{margin-top:0;font-size:11px}.form-group.label-floating label.control-label,.form-group.label-placeholder label.control-label{top:-7px;font-size:14px;line-height:1.42857}.form-group.label-floating.is-focused label.control-label,.form-group.label-floating:not(.is-empty) label.control-label,.form-group.label-static label.control-label{top:-28px;left:0;font-size:11px;line-height:1.42857}.form-group.label-floating input.form-control:-webkit-autofill~label.control-label label.control-label{top:-28px;left:0;font-size:11px;line-height:1.07143}.form-group.form-group-sm{padding-bottom:10px;margin:20px 0 0}.form-group.form-group-sm .form-control::-moz-placeholder{font-size:11px;line-height:1.5;color:#aaa;font-weight:400}.form-group.form-group-sm .form-control:-ms-input-placeholder{font-size:11px;line-height:1.5;color:#aaa;font-weight:400}.form-group.form-group-sm .form-control::-webkit-input-placeholder{font-size:11px;line-height:1.5;color:#aaa;font-weight:400}.form-group.form-group-sm .checkbox label,.form-group.form-group-sm .label-on-left,.form-group.form-group-sm .label-on-right,.form-group.form-group-sm .radio label,.form-group.form-group-sm label{font-size:11px;line-height:1.5;color:#aaa;font-weight:400}.form-group.form-group-sm label.control-label{font-size:14px;line-height:1.125;color:#aaa;font-weight:600;margin:16px 0 0}.form-group.form-group-sm .help-block{margin-top:0;font-size:9px}.form-group.form-group-sm.label-floating label.control-label,.form-group.form-group-sm.label-placeholder label.control-label{top:-11px;font-size:11px;line-height:1.5}.form-group.form-group-sm.label-floating.is-focused label.control-label,.form-group.form-group-sm.label-floating:not(.is-empty) label.control-label,.form-group.form-group-sm.label-static label.control-label{top:-25px;left:0;font-size:9px;line-height:1.5}.form-group.form-group-sm.label-floating input.form-control:-webkit-autofill~label.control-label label.control-label{top:-25px;left:0;font-size:9px;line-height:1.125}.form-group.form-group-lg{padding-bottom:10px;margin:20px 0 0}.form-group.form-group-lg .form-control::-moz-placeholder{font-size:18px;line-height:1.33333;color:#aaa;font-weight:400}.form-group.form-group-lg .form-control:-ms-input-placeholder{font-size:18px;line-height:1.33333;color:#aaa;font-weight:400}.form-group.form-group-lg .form-control::-webkit-input-placeholder{font-size:18px;line-height:1.33333;color:#aaa;font-weight:400}.form-group.form-group-lg .checkbox label,.form-group.form-group-lg .label-on-left,.form-group.form-group-lg .label-on-right,.form-group.form-group-lg .radio label,.form-group.form-group-lg label{font-size:18px;line-height:1.33333;color:#aaa;font-weight:400}.form-group.form-group-lg label.control-label{font-size:14px;line-height:1;color:#aaa;font-weight:600;margin:16px 0 0}.form-group.form-group-lg .help-block{margin-top:0;font-size:14px}.form-group.form-group-lg.label-floating label.control-label,.form-group.form-group-lg.label-placeholder label.control-label{top:-5px;font-size:18px;line-height:1.33333}.form-group.form-group-lg.label-floating.is-focused label.control-label,.form-group.form-group-lg.label-floating:not(.is-empty) label.control-label,.form-group.form-group-lg.label-static label.control-label{top:-32px;left:0;font-size:14px;line-height:1.33333}.form-group.form-group-lg.label-floating input.form-control:-webkit-autofill~label.control-label label.control-label{top:-32px;left:0;font-size:14px;line-height:1}select.form-control{border:0;box-shadow:none;border-radius:0}.form-group.is-focused select.form-control{box-shadow:none;border-color:#d2d2d2}.form-group.is-focused select.form-control[multiple],select.form-control[multiple]{height:85px}.input-group-btn .btn{margin:0 0 7px}.form-group.form-group-sm .input-group-btn .btn{margin:0 0 3px}.form-group.form-group-lg .input-group-btn .btn{margin:0 0 9px}.input-group .input-group-btn{padding:0 12px}.input-group .input-group-addon{border:0;background:transparent;padding:6px 15px 0}.form-group input[type=file]{opacity:0;position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;z-index:100}.form-control-feedback{opacity:0}.has-success .form-control-feedback{color:#4caf50;opacity:1}.has-error .form-control-feedback{color:#f44336;opacity:1}.btn-file{position:relative;overflow:hidden;vertical-align:middle}.btn-file>input{position:absolute;top:0;right:0;width:100%;height:100%;margin:0;font-size:23px;cursor:pointer;filter:alpha(opacity=0);opacity:0;direction:ltr}.fileinput{display:inline-block;margin-bottom:9px}.fileinput .form-control{display:inline-block;padding-top:7px;padding-bottom:5px;margin-bottom:0;vertical-align:middle;cursor:text}.fileinput .thumbnail{display:inline-block;margin-bottom:10px;overflow:hidden;text-align:center;vertical-align:middle;max-width:250px;box-shadow:0 10px 30px -12px rgba(0,0,0,.42),0 4px 25px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.fileinput .thumbnail.img-circle{border-radius:50%;max-width:100px}.fileinput .thumbnail>img{max-height:100%}.fileinput .btn{vertical-align:middle}.fileinput-exists .fileinput-new,.fileinput-new .fileinput-exists{display:none}.fileinput-inline .fileinput-controls{display:inline}.fileinput-filename{display:inline-block;overflow:hidden;vertical-align:middle}.form-control .fileinput-filename{vertical-align:bottom}.fileinput.input-group{display:table}.fileinput.input-group>*{position:relative;z-index:2}.fileinput.input-group>.btn-file{z-index:1}.fileinput-new.input-group .btn-file,.fileinput-new .input-group .btn-file{border-radius:0 4px 4px 0}.fileinput-new.input-group .btn-file.btn-sm,.fileinput-new .input-group .btn-file.btn-sm,.fileinput-new.input-group .btn-file.btn-xs,.fileinput-new .input-group .btn-file.btn-xs{border-radius:0 3px 3px 0}.fileinput-new.input-group .btn-file.btn-lg,.fileinput-new .input-group .btn-file.btn-lg{border-radius:0 6px 6px 0}.form-group.has-warning .fileinput .fileinput-preview{color:#e07e3c}.form-group.has-warning .fileinput .thumbnail{border-color:#e07e3c}.form-group.has-error .fileinput .fileinput-preview{color:#f44336}.form-group.has-error .fileinput .thumbnail{border-color:#f44336}.form-group.has-success .fileinput .fileinput-preview{color:#4caf50}.form-group.has-success .fileinput .thumbnail{border-color:#4caf50}.input-group-addon:not(:first-child){border-left:0}.thumbnail{border:0 none;border-radius:4px;padding:0}.alert{border:0;border-radius:0;position:relative;padding:20px 15px;line-height:20px}.alert b{font-weight:500;text-transform:uppercase;font-size:12px}.alert,.alert.alert-default{background-color:#fff;color:#555;border-radius:3px;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px hsla(0,0%,100%,.4)}.alert.alert-default .alert-link,.alert.alert-default a,.alert .alert-link,.alert a{color:#555}.alert.alert-inverse{background-color:#2e2e2e;color:#fff;border-radius:3px;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(33,33,33,.4)}.alert.alert-inverse .alert-link,.alert.alert-inverse a{color:#fff}.alert.alert-primary{background-color:#e38d52;color:#fff;border-radius:3px;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.alert.alert-primary .alert-link,.alert.alert-primary a{color:#fff}.alert.alert-success{background-color:#5cb860;color:#fff;border-radius:3px;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(76,175,80,.4)}.alert.alert-success .alert-link,.alert.alert-success a{color:#fff}.alert.alert-info{background-color:#00bcd4;color:#fff;border-radius:3px;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(0,188,212,.4)}.alert.alert-info .alert-link,.alert.alert-info a{color:#fff}.alert.alert-warning{background-color:#e38d52;color:#fff;border-radius:3px;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.alert.alert-warning .alert-link,.alert.alert-warning a{color:#fff}.alert.alert-danger{background-color:#f55a4e;color:#fff;border-radius:3px;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(244,67,54,.4)}.alert.alert-danger .alert-link,.alert.alert-danger a{color:#fff}.alert.alert-rose{background-color:#eb3573;color:#fff;border-radius:3px;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(233,30,99,.4)}.alert-danger,.alert-info,.alert-rose,.alert-success,.alert-warning,.alert.alert-rose .alert-link,.alert.alert-rose a{color:#fff}.alert-default .alert-link,.alert-default a{color:#000}.alert span{display:block;max-width:89%}.alert.alert-danger i{color:#f44336}.alert.alert-warning i{color:#e07e3c}.alert.alert-success i{color:#4caf50}.alert.alert-info i{color:#00bcd4}.alert.alert-primary i{color:#e07e3c}.alert.alert-rose i{color:#e91e63}.alert.alert-with-icon{margin-top:43px;padding-left:66px}.alert.alert-with-icon i[data-notify=icon]{display:block;left:15px;position:absolute;margin-top:-39px;font-size:20px;background-color:#fff;padding:9px;border-radius:50%;max-width:38px;box-shadow:0 10px 30px -12px rgba(0,0,0,.42),0 4px 25px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.alert .close i{color:#fff}.alert i[data-notify=icon]{display:none}.alert .alert-icon{display:block;float:left;margin-right:15px}.alert .alert-icon i{margin-top:-7px;top:5px;position:relative}.alert [data-notify=dismiss]{margin-right:5px}.table>thead>tr>th{border-bottom-width:1px;font-size:1.25em;font-weight:300}.tab-pane .table tbody>tr>td:first-child{width:36px}.table .checkbox,.table .radio{margin-top:-1px;margin-bottom:0;padding:0;width:15px}.table .checkbox .icons,.table .radio .icons{position:relative}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:12px 8px;vertical-align:middle}.table .th-description{max-width:150px}.table .td-price{font-size:26px;font-weight:300;margin-top:5px;text-align:right}.table .td-total{font-weight:500;font-size:1.25em;padding-top:14px;text-align:right}.table .td-actions .btn{margin:0;padding:5px}.table>tbody>tr{position:relative}.table .flag img{max-width:18px;margin-top:-2px}.table-sales{margin-top:40px}.table-shopping>thead>tr>th{font-size:.9em;text-transform:uppercase}.table-shopping>tbody>tr>td{font-size:16px}.table-shopping>tbody>tr>td b{display:block;margin-bottom:5px}.table-shopping .td-name{font-weight:400;font-size:1.5em}.table-shopping .td-name small{color:#999;font-size:.75em;font-weight:300}.table-shopping .td-number{font-weight:300;font-size:1.3em}.table-shopping .td-name{min-width:200px}.table-shopping .td-name a{color:#3c4858}.table-shopping .td-name a:focus,.table-shopping .td-name a:hover{color:#e07e3c}.table-shopping .td-number{text-align:right;min-width:145px}.table-shopping .td-number small{margin-right:3px}.table-shopping .img-container{width:120px;max-height:160px;overflow:hidden;display:block}.table-shopping .img-container img{width:100%}.star{color:red;padding-left:3px}.form-category{padding:10px 0}.form-category .checkbox{margin:0}.form-group.form-checkbox{padding-top:10px}form .form-footer .checkbox{padding-top:5px}.card .form-horizontal .label-on-left{padding:28px 5px 0 0;text-align:right}.card .form-horizontal .label-on-right{padding:28px 0 0 5px;text-align:left}.form-horizontal .form-horizontal-checkbox{margin-top:2px;margin-bottom:10px}.form-horizontal .checkbox-radios .checkbox:first-child,.form-horizontal .checkbox-radios .radio:first-child{margin-top:16px}.form-horizontal .checkbox-radios .radio{padding-top:10px}.form-horizontal .form-group{margin-left:0;margin-right:0}.form-horizontal .form-button{padding:0;margin:0}.form-horizontal .checkbox-inline{margin-top:16px;padding-left:0}.form-horizontal .radio label{padding-left:28px}.form-horizontal .radio label span{left:2px}.form-horizontal label.control-label{margin:0}.form-horizontal .form-control[type=password]{padding-top:8px;padding-bottom:6px}.form-horizontal .form-control{color:#000}.form-newsletter .form-group,.form-newsletter .input-group{float:left;width:78%;margin-right:2%;margin-top:9px}.form-newsletter .btn{float:left;width:20%;margin:9px 0 0}.checkbox label{cursor:pointer;padding-left:0}.checkbox label,.form-group.is-focused .checkbox label{color:rgba(0,0,0,.4)}.form-group.is-focused .checkbox label:focus,.form-group.is-focused .checkbox label:hover{color:rgba(0,0,0,.54)}fieldset[disabled] .form-group.is-focused .checkbox label{color:rgba(0,0,0,.4)}.checkbox input[type=checkbox]{opacity:0;position:absolute;margin:0;z-index:-1;width:0;height:0;overflow:hidden;left:0;pointer-events:none}.checkbox .checkbox-material{vertical-align:middle;position:relative;top:3px;padding-right:5px}.checkbox .checkbox-material:before{display:block;position:absolute;left:0;content:"";background-color:rgba(0,0,0,.84);height:18px;width:18px;border-radius:100%;z-index:1;opacity:0;margin:0;transform:scale3d(2.3,2.3,1)}.checkbox .checkbox-material .check{position:relative;display:inline-block;width:18px;height:18px;border:1px solid #e07e3c;overflow:hidden;z-index:1;border-radius:0}.checkbox .checkbox-material .check:before{position:absolute;content:"";transform:rotate(45deg);display:block;margin-top:-4px;margin-left:6px;width:0;height:0;background:red;box-shadow:0 0 0 0,0 0 0 0,0 0 0 0,0 0 0 0,0 0 0 0,0 0 0 0,inset 0 0 0 0;animation:checkbox-off .3s forwards}.checkbox input[type=checkbox]:focus+.checkbox-material .check:after{opacity:.2}.checkbox input[type=checkbox]:checked+.checkbox-material .check{background:#fff}.checkbox input[type=checkbox]:checked+.checkbox-material .check:before{color:#e07e3c;box-shadow:0 0 0 10px,10px -10px 0 10px,32px 0 0 20px,0 32px 0 20px,-5px 5px 0 10px,20px -12px 0 11px;animation:checkbox-on .3s forwards}.checkbox input[type=checkbox]:checked+.checkbox-material:before{animation:rippleOn .5s}.checkbox input[type=checkbox]:checked+.checkbox-material .check:after{animation:rippleOn .5s forwards}.checkbox input[type=checkbox]:not(:checked)+.checkbox-material .check:after,.checkbox input[type=checkbox]:not(:checked)+.checkbox-material:before{animation:rippleOff .5s}.checkbox input[type=checkbox][disabled]+.circle,.checkbox input[type=checkbox][disabled]~.checkbox-material .check,fieldset[disabled] .checkbox,fieldset[disabled] .checkbox input[type=checkbox]{opacity:.5}.checkbox input[type=checkbox][disabled]~.checkbox-material .check{border-color:#000;opacity:.26}.checkbox input[type=checkbox][disabled]+.checkbox-material .check:after{background-color:#000;transform:rotate(-45deg)}.checkbox.has-error label{color:#f44336}@keyframes checkbox-on{0%{box-shadow:0 0 0 10px,10px -10px 0 10px,32px 0 0 20px,0 32px 0 20px,-5px 5px 0 10px,15px 2px 0 11px}50%{box-shadow:0 0 0 10px,10px -10px 0 10px,32px 0 0 20px,0 32px 0 20px,-5px 5px 0 10px,20px 2px 0 11px}to{box-shadow:0 0 0 10px,10px -10px 0 10px,32px 0 0 20px,0 32px 0 20px,-5px 5px 0 10px,20px -12px 0 11px}}.new_style{margin:65px 0 0}.custom_switcher,.new_style{display:flex;justify-content:center;align-items:center}.custom_switcher{border-radius:30px;border:2px solid #fff;padding:2px}.custom_switcher .switcher_btn{color:#fff;text-transform:uppercase;border-radius:25px;cursor:pointer;font-weight:700;font-size:16px;padding:15px 78px}.custom_switcher .switcher_btn.active{background:#fff;color:#e07e3c}.radio label{cursor:pointer;padding-left:35px;position:relative}.form-group.is-focused .radio label,.radio label{color:rgba(0,0,0,.4)}.form-group.is-focused .radio label:focus,.form-group.is-focused .radio label:hover{color:rgba(0,0,0,.54)}fieldset[disabled] .form-group.is-focused .radio label{color:rgba(0,0,0,.4)}.radio label span{display:block;position:absolute;left:10px;top:2px;transition-duration:.2s}.radio label .circle{border:1px solid rgba(0,0,0,.54);height:15px;width:15px;border-radius:100%}.radio label .check{height:15px;width:15px;border-radius:100%;background-color:#e07e3c;transform:scale3d(0,0,0)}.radio label .check:after{display:block;position:absolute;content:"";background-color:#000;left:-18px;top:-18px;height:50px;width:50px;border-radius:100%;z-index:1;opacity:0;margin:0;transform:scale3d(1.5,1.5,1)}.radio label input[type=radio]:not(:checked)~.check:after{animation:rippleOff .5s}.radio label input[type=radio]:checked~.check:after{animation:rippleOn .5s}.radio label .radio-label{margin:0}.radio.has-error label{color:#f44336}.radio input[type=radio]{opacity:0;height:0;width:0;overflow:hidden}.radio input[type=radio]:checked~.check,.radio input[type=radio]:checked~.circle{opacity:1}.radio input[type=radio]:checked~.check{background-color:#e07e3c}.radio input[type=radio]:checked~.circle{border-color:#e07e3c}.radio input[type=radio]:checked~.check{transform:scale3d(.65,.65,1)}.radio input[type=radio]:checked~.radio-label{color:#000}.radio input[type=radio][disabled]~.check,.radio input[type=radio][disabled]~.circle{opacity:.26}.radio input[type=radio][disabled]~.check{background-color:#000}.radio input[type=radio][disabled]~.circle{border-color:#000}@keyframes rippleOn{0%{opacity:0}50%{opacity:.2}to{opacity:0}}@keyframes rippleOff{0%{opacity:0}50%{opacity:.2}to{opacity:0}}.progress{height:4px;border-radius:0;background:#ddd}.progress,.progress .progress-bar{box-shadow:none}.progress .progress-bar,.progress .progress-bar.progress-bar-default{background-color:#fff}.progress .progress-bar.progress-bar-inverse{background-color:#212121}.progress .progress-bar.progress-bar-primary{background-color:#e07e3c}.progress .progress-bar.progress-bar-success{background-color:#4caf50}.progress .progress-bar.progress-bar-info{background-color:#00bcd4}.progress .progress-bar.progress-bar-warning{background-color:#e07e3c}.progress .progress-bar.progress-bar-danger{background-color:#f44336}.progress .progress-bar.progress-bar-rose{background-color:#e91e63}.progress.progress-line-primary{background:rgba(224,126,60,.2)}.progress.progress-line-info{background:rgba(0,188,212,.2)}.progress.progress-line-success{background:rgba(76,175,80,.2)}.progress.progress-line-warning{background:rgba(224,126,60,.2)}.progress.progress-line-danger{background:rgba(244,67,54,.2)}.progress .progress-bar,.progress .progress-bar.progress-bar-default{background-color:#e07e3c}.togglebutton{vertical-align:middle}.togglebutton,.togglebutton .toggle,.togglebutton input,.togglebutton label{user-select:none}.togglebutton label{cursor:pointer}.form-group.is-focused .togglebutton label,.togglebutton label{color:rgba(0,0,0,.4)}.form-group.is-focused .togglebutton label:focus,.form-group.is-focused .togglebutton label:hover{color:rgba(0,0,0,.54)}fieldset[disabled] .form-group.is-focused .togglebutton label{color:rgba(0,0,0,.4)}.togglebutton label input[type=checkbox]{opacity:0;width:0;height:0}.togglebutton label .toggle{text-align:left;margin-left:5px}.togglebutton label .toggle,.togglebutton label input[type=checkbox][disabled]+.toggle{content:"";display:inline-block;width:30px;height:15px;background-color:rgba(80,80,80,.7);border-radius:15px;margin-right:15px;transition:background .3s ease;vertical-align:middle}.togglebutton label .toggle:after{content:"";display:inline-block;width:20px;height:20px;background-color:#fff;border-radius:20px;position:relative;box-shadow:0 1px 3px 1px rgba(0,0,0,.4);left:-5px;top:-3px;border:1px solid rgba(0,0,0,.54);transition:left .3s ease,background .3s ease,box-shadow .1s ease}.togglebutton label input[type=checkbox][disabled]+.toggle:after,.togglebutton label input[type=checkbox][disabled]:checked+.toggle:after{background-color:#bdbdbd}.togglebutton label input[type=checkbox]+.toggle:active:after,.togglebutton label input[type=checkbox][disabled]+.toggle:active:after{box-shadow:0 1px 3px 1px rgba(0,0,0,.4),0 0 0 15px rgba(0,0,0,.1)}.togglebutton label input[type=checkbox]:checked+.toggle:after{left:15px}.togglebutton label input[type=checkbox]:checked+.toggle{background-color:rgba(224,126,60,.7)}.togglebutton label input[type=checkbox]:checked+.toggle:after{border-color:#e07e3c}.togglebutton label input[type=checkbox]:checked+.toggle:active:after{box-shadow:0 1px 3px 1px rgba(0,0,0,.4),0 0 0 15px rgba(224,126,60,.1)}.wrapper{position:relative;top:0;height:100vh}.wrapper:after{display:table;clear:both;content:" "}.wrapper.wrapper-full-page{height:auto;min-height:100vh}.full-page:after,.full-page:before{display:block;content:"";position:absolute;width:100%;height:100%;top:0;left:0;z-index:2}.full-page:before{background-color:rgba(0,0,0,.5)}.full-page[filter-color=primary]:after,.full-page[filter-color=purple]:after{background:rgba(225,190,231,.56);background:-webkit-linear-gradient(60deg,rgba(225,190,231,.56),rgba(186,104,200,.95));background:-o-linear-gradient(60deg,rgba(225,190,231,.56),rgba(186,104,200,.95));background:-moz-linear-gradient(60deg,rgba(225,190,231,.56),rgba(186,104,200,.95));background:linear-gradient(60deg,rgba(225,190,231,.56),rgba(186,104,200,.95))}.full-page[filter-color=primary].lock-page .form-group .form-control,.full-page[filter-color=purple].lock-page .form-group .form-control{background-image:linear-gradient(#e07e3c,#e07e3c),linear-gradient(#d2d2d2,#d2d2d2)}.full-page[filter-color=blue]:after,.full-page[filter-color=info]:after{background:rgba(178,235,242,.56);background:-webkit-linear-gradient(60deg,rgba(178,235,242,.56),rgba(77,208,225,.95));background:-o-linear-gradient(60deg,rgba(178,235,242,.56),rgba(77,208,225,.95));background:-moz-linear-gradient(60deg,rgba(178,235,242,.56),rgba(77,208,225,.95));background:linear-gradient(60deg,rgba(178,235,242,.56),rgba(77,208,225,.95))}.full-page[filter-color=blue].lock-page .form-group .form-control,.full-page[filter-color=info].lock-page .form-group .form-control{background-image:linear-gradient(#00bcd4,#00bcd4),linear-gradient(#d2d2d2,#d2d2d2)}.full-page[filter-color=green]:after,.full-page[filter-color=success]:after{background:rgba(165,214,167,.56);background:-webkit-linear-gradient(60deg,rgba(165,214,167,.56),rgba(102,187,106,.95));background:-o-linear-gradient(60deg,rgba(165,214,167,.56),rgba(102,187,106,.95));background:-moz-linear-gradient(60deg,rgba(165,214,167,.56),rgba(102,187,106,.95));background:linear-gradient(60deg,rgba(165,214,167,.56),rgba(102,187,106,.95))}.full-page[filter-color=green].lock-page .form-group .form-control,.full-page[filter-color=success].lock-page .form-group .form-control{background-image:linear-gradient(#4caf50,#4caf50),linear-gradient(#d2d2d2,#d2d2d2)}.full-page[filter-color=orange]:after,.full-page[filter-color=warning]:after{background:rgba(255,224,178,.56);background:-webkit-linear-gradient(60deg,rgba(255,224,178,.56),rgba(255,183,77,.95));background:-o-linear-gradient(60deg,rgba(255,224,178,.56),rgba(255,183,77,.95));background:-moz-linear-gradient(60deg,rgba(255,224,178,.56),rgba(255,183,77,.95));background:linear-gradient(60deg,rgba(255,224,178,.56),rgba(255,183,77,.95))}.full-page[filter-color=orange].lock-page .form-group .form-control,.full-page[filter-color=warning].lock-page .form-group .form-control{background-image:linear-gradient(#e07e3c,#e07e3c),linear-gradient(#d2d2d2,#d2d2d2)}.full-page[filter-color=danger]:after,.full-page[filter-color=red]:after{background:hsla(0,73%,77%,.56);background:-webkit-linear-gradient(60deg,hsla(0,73%,77%,.56),rgba(239,83,80,.95));background:-o-linear-gradient(60deg,hsla(0,73%,77%,.56),rgba(239,83,80,.95));background:-moz-linear-gradient(60deg,hsla(0,73%,77%,.56),rgba(239,83,80,.95));background:linear-gradient(60deg,hsla(0,73%,77%,.56),rgba(239,83,80,.95))}.full-page[filter-color=danger].lock-page .form-group .form-control,.full-page[filter-color=red].lock-page .form-group .form-control{background-image:linear-gradient(#f44336,#f44336),linear-gradient(#d2d2d2,#d2d2d2)}.full-page[filter-color=rose]:after{background:rgba(248,187,208,.56);background:-webkit-linear-gradient(60deg,rgba(248,187,208,.56),rgba(240,98,146,.95));background:-o-linear-gradient(60deg,rgba(248,187,208,.56),rgba(240,98,146,.95));background:-moz-linear-gradient(60deg,rgba(248,187,208,.56),rgba(240,98,146,.95));background:linear-gradient(60deg,rgba(248,187,208,.56),rgba(240,98,146,.95))}.full-page[filter-color=rose].lock-page .form-group .form-control{background-image:linear-gradient(#e91e63,#e91e63),linear-gradient(#d2d2d2,#d2d2d2)}.full-page[data-image]:after{opacity:.8}.full-page>.content,.full-page>.footer{position:relative;z-index:4}.full-page>.content{min-height:100vh}.full-page .full-page-background{position:absolute;z-index:1;height:100%;width:100%;display:block;top:0;left:0;background-size:cover;background-position:50%}.full-page .footer,.full-page .footer .copyright a,.full-page .footer nav>ul a:not(.btn){color:#fff}.clear-filter:before{display:none}.lock-page>.content,.login-page>.content{padding-top:18vh}.login-page .card-login{box-shadow:0 1px 4px 0 rgba(0,0,0,.14);border-radius:6px;padding-bottom:20px;-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-o-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0)}.login-page .card-login.card-hidden{opacity:0;-webkit-transform:translate3d(0,-60px,0);-moz-transform:translate3d(0,-60px,0);-o-transform:translate3d(0,-60px,0);-ms-transform:translate3d(0,-60px,0);transform:translate3d(0,-60px,0)}.login-page .card-login .btn-wd{min-width:180px}.login-page .card-login .card-header{margin-top:-40px;margin-bottom:20px}.login-page .card-login .card-header .title{margin-top:10px}.lock-page .card-profile{width:240px;margin:60px auto 0;color:#fff;position:absolute;left:0;right:0;display:block;-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-o-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0)}.lock-page .card-profile.card-hidden{opacity:0;-webkit-transform:translate3d(0,-60px,0);-moz-transform:translate3d(0,-60px,0);-o-transform:translate3d(0,-60px,0);-ms-transform:translate3d(0,-60px,0);transform:translate3d(0,-60px,0)}.lock-page .card-profile .card-avatar{max-width:90px;max-height:90px;margin-top:-45px}.lock-page .card-profile .card-footer{border:none;padding-top:0}.lock-page .card-profile .form-group{text-align:left}.lock-page .card-profile .form-group .form-control{background-image:linear-gradient(#e91e63,#e91e63),linear-gradient(#d2d2d2,#d2d2d2)}.lock-page .card-profile.with-animation{-webkit-transition:all .3s ease-in;-moz-transition:all .3s ease-in;-o-transition:all .3s ease-in;-ms-transition:all .3s ease-in;transition:all .3s ease-in}.register-page .card-signup{border-radius:6px;box-shadow:0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2);margin-bottom:100px;padding:40px 0}.register-page .card-signup .info{max-width:360px;margin:0 auto;padding:0}.register-page .card-signup .info .info-title{color:#3c4858;margin:30px 0 15px}.register-page .card-signup .checkbox{margin-top:20px;margin-bottom:0}.register-page .card-signup .checkbox label{margin-left:17px}.register-page .card-signup .checkbox .checkbox-material{padding-right:20px}.register-page .card-signup .input-group .input-group-addon{padding-top:21px}.register-page .card-signup .info-horizontal .icon{float:left;margin-top:24px;margin-right:10px}.register-page .card-signup .info-horizontal .icon i{font-size:2.6em}.register-page .card-signup .info-horizontal .icon.icon-primary{color:#e07e3c}.register-page .card-signup .info-horizontal .icon.icon-info{color:#00bcd4}.register-page .card-signup .info-horizontal .icon.icon-success{color:#4caf50}.register-page .card-signup .info-horizontal .icon.icon-warning{color:#e07e3c}.register-page .card-signup .info-horizontal .icon.icon-danger{color:#f44336}.register-page .card-signup .info-horizontal .icon.icon-rose{color:#e91e63}.register-page .card-signup .info-horizontal .description{overflow:hidden}.register-page .card-signup .form-group{margin:27px 0 0 7px;padding-bottom:0}.register-page .container{position:relative;z-index:3;padding-top:15vh;min-height:calc(100vh - 80px)}.register-page .footer .container{padding:0}.pricing-page .title{color:#fff;margin-top:13vh}.pricing-page .section-space{display:block;height:70px}.pricing-page .card-plain .card-title,.pricing-page .card-plain .icon i,.pricing-page .description{color:#fff}.pricing-page.full-page:before{background-color:rgba(0,0,0,.65)}.bootstrap-tagsinput{display:inline-block;padding:4px 6px;max-width:100%;line-height:22px}.bootstrap-tagsinput input{outline:none;background-color:transparent;margin:0;width:74px;max-width:inherit}.bootstrap-tagsinput input,.bootstrap-tagsinput input:focus{border:none;box-shadow:none}.bootstrap-tagsinput.form-control input::-moz-placeholder{color:#777;opacity:1}.bootstrap-tagsinput.form-control input:-ms-input-placeholder,.bootstrap-tagsinput.form-control input::-webkit-input-placeholder{color:#777}.bootstrap-tagsinput .tag{cursor:pointer;margin:5px 3px 5px 0;position:relative;padding:3px 8px;border-radius:12px;color:#fff;font-weight:500;font-size:.75em;text-transform:uppercase;display:inline-block;line-height:1.5em;padding-left:.8em}.bootstrap-tagsinput .tag.tag-primary{background-color:#e07e3c;color:#fff}.bootstrap-tagsinput .tag.tag-info{background-color:#00bcd4;color:#fff}.bootstrap-tagsinput .tag.tag-success{background-color:#4caf50;color:#fff}.bootstrap-tagsinput .tag.tag-warning{background-color:#e07e3c;color:#fff}.bootstrap-tagsinput .tag.tag-danger{background-color:#f44336;color:#fff}.bootstrap-tagsinput .tag.tag-rose{background-color:#e91e63;color:#fff}.bootstrap-tagsinput .tag:hover{padding-right:18px}.bootstrap-tagsinput .tag:hover [data-role=remove]{opacity:1;padding-right:6px}.bootstrap-tagsinput .tag [data-role=remove]{cursor:pointer;position:absolute;top:3px;right:0;opacity:0}.bootstrap-tagsinput .tag [data-role=remove]:after{content:"x";padding:0 2px}.timeline{list-style:none;padding:20px 0;position:relative;margin-top:30px}.timeline:before{top:50px;bottom:0;position:absolute;content:" ";width:3px;background-color:#e5e5e5;left:50%;margin-left:-1px}.timeline h6{color:#333;font-weight:400;margin:10px 0 0}.timeline.timeline-simple{margin-top:30px;padding:0 0 20px}.timeline.timeline-simple:before{left:5%;background-color:#e5e5e5}.timeline.timeline-simple>li>.timeline-panel{width:86%}.timeline.timeline-simple>li>.timeline-badge{left:5%}.timeline>li{margin-bottom:20px;position:relative}.timeline>li:after,.timeline>li:before{content:" ";display:table}.timeline>li:after{clear:both}.timeline>li>.timeline-panel{width:45%;float:left;padding:20px;margin-bottom:20px;position:relative;box-shadow:0 1px 4px 0 rgba(0,0,0,.14);border-radius:6px;color:#000;background:#fff}.timeline>li>.timeline-panel:before{position:absolute;top:26px;right:-15px;display:inline-block;border-top:15px solid transparent;border-left:15px solid #e4e4e4;border-right:0 solid #e4e4e4;border-bottom:15px solid transparent;content:" "}.timeline>li>.timeline-panel:after{position:absolute;top:27px;right:-14px;display:inline-block;border-top:14px solid transparent;border-left:14px solid #fff;border-right:0 solid #fff;border-bottom:14px solid transparent;content:" "}.timeline>li>.timeline-badge{color:#fff;width:50px;height:50px;line-height:51px;font-size:1.4em;text-align:center;position:absolute;top:16px;left:50%;margin-left:-24px;z-index:100;border-top-right-radius:50%;border-top-left-radius:50%;border-bottom-right-radius:50%;border-bottom-left-radius:50%}.timeline>li>.timeline-badge.primary{background-color:#e07e3c;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.timeline>li>.timeline-badge.success{background-color:#4caf50;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(76,175,80,.4)}.timeline>li>.timeline-badge.warning{background-color:#e07e3c;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.timeline>li>.timeline-badge.info{background-color:#00bcd4;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(0,188,212,.4)}.timeline>li>.timeline-badge.danger{background-color:#f44336;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(244,67,54,.4)}.timeline>li>.timeline-badge [class*=" ti-"],.timeline>li>.timeline-badge [class=material-icons],.timeline>li>.timeline-badge [class^=ti-]{line-height:inherit}.timeline>li.timeline-inverted>.timeline-panel{float:right;background-color:#fff}.timeline>li.timeline-inverted>.timeline-panel:before{border-left-width:0;border-right-width:15px;left:-15px;right:auto}.timeline>li.timeline-inverted>.timeline-panel:after{border-left-width:0;border-right-width:14px;left:-14px;right:auto}.timeline-heading{margin-bottom:15px}.timeline-title{margin-top:0;color:inherit}.timeline-body hr{margin-top:10px;margin-bottom:5px}.timeline-body .btn,.timeline-body>p,.timeline-body>ul{margin-bottom:0}.timeline-body>p+p{margin-top:5px}.withripple{position:relative}.ripple-container{position:absolute;top:0;left:0;z-index:1;width:100%;height:100%;overflow:hidden;border-radius:inherit;pointer-events:none}.disabled .ripple-container{display:none}.ripple{position:absolute;width:20px;height:20px;margin-left:-10px;margin-top:-10px;border-radius:100%;background-color:#000;background-color:rgba(0,0,0,.05);transform:scale(1);transform-origin:50%;opacity:0;pointer-events:none}.ripple.ripple-on{transition:opacity .15s ease-in 0s,transform .5s cubic-bezier(.4,0,.2,1) .1s;opacity:.1}.ripple.ripple-out{transition:opacity .1s linear 0s!important;opacity:0}.panel{background-color:transparent;border:0 none;box-shadow:none}.panel .panel-heading{background-color:transparent;border-bottom:1px solid #ddd;padding:25px 10px 5px 0}.panel .panel-heading .panel-title{font-size:15px;font-weight:bolder}.panel .panel-heading a{color:#3c4858}.panel .panel-heading a:active,.panel .panel-heading a:hover,.panel .panel-heading a[aria-expanded=true]{color:#e91e63}.panel .panel-heading a.expanded .panel-title>i,.panel .panel-heading a[aria-expanded=true] .panel-title>i{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2);-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.panel .panel-heading i{float:right}.panel .panel-body{border:0 none;padding:15px 0 5px}.panel.panel-default .panel-heading+.panel-collapse .panel-body{border:0 none}.pagination>li>a,.pagination>li>span{border:0;border-radius:30px!important;transition:all .3s;padding:0 11px;margin:0 3px;min-width:30px;height:30px;line-height:30px;color:#999;font-weight:400;font-size:12px;text-transform:uppercase;background:transparent}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{color:#999}.pagination>.active>a,.pagination>.active>span{color:#999;text-align:center}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{background-color:#e07e3c;border-color:#e07e3c;color:#fff;box-shadow:0 4px 5px 0 rgba(224,126,60,.14),0 1px 10px 0 rgba(224,126,60,.12),0 2px 4px -1px rgba(224,126,60,.2)}.pagination.pagination-info>.active>a,.pagination.pagination-info>.active>a:focus,.pagination.pagination-info>.active>a:hover,.pagination.pagination-info>.active>span,.pagination.pagination-info>.active>span:focus,.pagination.pagination-info>.active>span:hover{background-color:#00bcd4;border-color:#00bcd4;box-shadow:0 4px 5px 0 rgba(0,188,212,.14),0 1px 10px 0 rgba(0,188,212,.12),0 2px 4px -1px rgba(0,188,212,.2)}.pagination.pagination-success>.active>a,.pagination.pagination-success>.active>a:focus,.pagination.pagination-success>.active>a:hover,.pagination.pagination-success>.active>span,.pagination.pagination-success>.active>span:focus,.pagination.pagination-success>.active>span:hover{background-color:#4caf50;border-color:#4caf50;box-shadow:0 4px 5px 0 rgba(76,175,80,.14),0 1px 10px 0 rgba(76,175,80,.12),0 2px 4px -1px rgba(76,175,80,.2)}.pagination.pagination-warning>.active>a,.pagination.pagination-warning>.active>a:focus,.pagination.pagination-warning>.active>a:hover,.pagination.pagination-warning>.active>span,.pagination.pagination-warning>.active>span:focus,.pagination.pagination-warning>.active>span:hover{background-color:#e07e3c;border-color:#e07e3c;box-shadow:0 4px 5px 0 rgba(224,126,60,.14),0 1px 10px 0 rgba(224,126,60,.12),0 2px 4px -1px rgba(224,126,60,.2)}.pagination.pagination-danger>.active>a,.pagination.pagination-danger>.active>a:focus,.pagination.pagination-danger>.active>a:hover,.pagination.pagination-danger>.active>span,.pagination.pagination-danger>.active>span:focus,.pagination.pagination-danger>.active>span:hover{background-color:#f44336;border-color:#f44336;box-shadow:0 4px 5px 0 rgba(244,67,54,.14),0 1px 10px 0 rgba(244,67,54,.12),0 2px 4px -1px rgba(244,67,54,.2)}.label{border-radius:12px;padding:5px 12px;text-transform:uppercase;font-size:10px}.label.label-default{background-color:#999}.section-dark .nav-pills>li>a,.section-image .nav-pills>li>a{color:#999}.section-dark .nav-pills>li>a:focus,.section-dark .nav-pills>li>a:hover,.section-image .nav-pills>li>a:focus,.section-image .nav-pills>li>a:hover{background-color:#eee}.nav-pills>li>a{line-height:24px;text-transform:uppercase;font-size:12px;font-weight:500;min-width:100px;text-align:center;color:#555;transition:all .3s}.nav-pills>li>a:hover{background-color:hsla(0,0%,78%,.2)}.nav-pills>li i{display:block;font-size:30px;padding:15px 0}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{background-color:#e07e3c;color:#fff;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.nav-pills:not(.nav-pills-icons)>li>a{border-radius:30px}.nav-pills.nav-stacked>li+li{margin:10px 0}.nav-pills.nav-pills-info>li.active>a,.nav-pills.nav-pills-info>li.active>a:focus,.nav-pills.nav-pills-info>li.active>a:hover{background-color:#00bcd4;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(0,188,212,.4)}.nav-pills.nav-pills-success>li.active>a,.nav-pills.nav-pills-success>li.active>a:focus,.nav-pills.nav-pills-success>li.active>a:hover{background-color:#4caf50;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(76,175,80,.4)}.nav-pills.nav-pills-warning>li.active>a,.nav-pills.nav-pills-warning>li.active>a:focus,.nav-pills.nav-pills-warning>li.active>a:hover{background-color:#e07e3c;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.nav-pills.nav-pills-danger>li.active>a,.nav-pills.nav-pills-danger>li.active>a:focus,.nav-pills.nav-pills-danger>li.active>a:hover{background-color:#f44336;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.nav-pills.nav-pills-rose>li.active>a,.nav-pills.nav-pills-rose>li.active>a:focus,.nav-pills.nav-pills-rose>li.active>a:hover{background-color:#e91e63;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(233,30,99,.4)}.nav-pills.nav-pills-cyan>li.active>a,.nav-pills.nav-pills-cyan>li.active>a:focus,.nav-pills.nav-pills-cyan>li.active>a:hover{background-color:#00bcd4;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(0,188,212,.4)}.tab-space{padding:20px 0}.modal-content{box-shadow:0 27px 24px 0 rgba(0,0,0,.2),0 40px 77px 0 rgba(0,0,0,.22);border-radius:6px;border:none}.modal-content .modal-header{border-bottom:none;padding:24px 24px 0}.modal-content .modal-body{padding:24px 24px 16px}.modal-content .modal-footer{border-top:none}.modal-content .modal-footer.text-center{text-align:center}.modal-content .modal-footer button{margin:0;padding-left:16px;padding-right:16px;width:auto}.modal-content .modal-footer button.pull-left{padding-left:5px;padding-right:5px;position:relative;left:-5px}.modal-content .modal-footer button+button{margin-bottom:16px}.modal-content .modal-body+.modal-footer{padding-top:0}.modal-backdrop{background:rgba(0,0,0,.3)}.modal .modal-dialog{margin-top:100px}.modal .modal-header .close{color:#999}.modal .modal-header .close:focus,.modal .modal-header .close:hover{opacity:1}.modal .modal-header .close i{font-size:16px}.modal-notice .instruction{margin-bottom:25px}.modal-notice .picture{max-width:150px}.modal-notice .modal-content .btn-raised{margin-bottom:15px}.modal-small{width:300px;margin:0 auto}.modal-small .modal-body{margin-top:20px}.navbar{border:0;border-radius:3px;border-bottom:1px solid #ededf3;padding:10px 0}.navbar .navbar-brand{position:relative;height:50px;line-height:30px;color:inherit;padding:10px 15px}.navbar .navbar-brand:focus,.navbar .navbar-brand:hover{color:inherit;background-color:transparent}.navbar .navbar-minimize{float:left;padding:3px 0 0 15px}.navbar .notification{position:absolute;top:5px;border:1px solid #fff;right:10px;font-size:9px;background:#f44336;color:#fff;min-width:20px;padding:0 5px;height:20px;border-radius:10px;text-align:center;line-height:19px;vertical-align:middle;display:block}.navbar .navbar-text{color:inherit;margin-top:15px;margin-bottom:15px}.navbar .navbar-nav>li>a{color:inherit;padding-top:15px;padding-bottom:15px;font-weight:500;font-size:12px;text-transform:uppercase;border-radius:3px}.navbar .navbar-nav>li>a:focus,.navbar .navbar-nav>li>a:hover{color:inherit;background-color:transparent}.amazon-management .top_buttons_body .nav .navbar .navbar-nav>li>a .dropdown-toggle:after,.navbar .navbar-nav>li>a .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.navbar .navbar-nav>li>a .fa,.navbar .navbar-nav>li>a .material-icons{font-size:20px}.navbar .navbar-nav>li>a.btn:not(.btn-just-icon) .fa{position:relative;top:2px;margin-top:-4px;margin-right:4px}.navbar .navbar-nav>li>.dropdown-menu{-webkit-transform:translate3d(0,-20px,0);-moz-transform:translate3d(0,-20px,0);-o-transform:translate3d(0,-20px,0);-ms-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}.navbar .navbar-nav>li.open>.dropdown-menu{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-o-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0)}.navbar .navbar-nav>.active>a,.navbar .navbar-nav>.active>a:focus,.navbar .navbar-nav>.active>a:hover{color:inherit;background-color:hsla(0,0%,100%,.1)}.navbar .navbar-nav>.disabled>a,.navbar .navbar-nav>.disabled>a:focus,.navbar .navbar-nav>.disabled>a:hover{color:inherit;background-color:transparent;opacity:.9}.navbar .navbar-nav .profile-photo{padding:0 5px}.navbar .navbar-nav .profile-photo .profile-photo-small{height:40px;width:40px}.navbar .navbar-toggle{border:0}.navbar .navbar-toggle:focus,.navbar .navbar-toggle:hover{background-color:transparent}.navbar .navbar-toggle .icon-bar{background-color:inherit;border:1px solid}.navbar .navbar-default .navbar-toggle,.navbar .navbar-inverse .navbar-toggle{border-color:transparent}.navbar .navbar-collapse,.navbar .navbar-form{border-top:none;box-shadow:none}.navbar .navbar-nav>.open>a,.navbar .navbar-nav>.open>a:focus,.navbar .navbar-nav>.open>a:hover{background-color:transparent;color:inherit}@media (max-width:767px){.navbar .navbar-nav .navbar-text{color:inherit;margin-top:15px;margin-bottom:15px}.navbar .navbar-nav .open .dropdown-menu>.dropdown-header{border:0;color:inherit}.navbar .navbar-nav .open .dropdown-menu .divider{border-bottom:1px solid;opacity:.08}.navbar .navbar-nav .open .dropdown-menu>li>a{color:inherit}.navbar .navbar-nav .open .dropdown-menu>.active>a,.navbar .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar .navbar-nav .open .dropdown-menu>.active>a:hover,.navbar .navbar-nav .open .dropdown-menu>.disabled>a,.navbar .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar .navbar-nav .open .dropdown-menu>.disabled>a:hover,.navbar .navbar-nav .open .dropdown-menu>li>a:focus,.navbar .navbar-nav .open .dropdown-menu>li>a:hover{color:inherit;background-color:transparent}}.navbar.navbar-default .logo-container .brand{color:#555}.navbar .navbar-link,.navbar .navbar-link:hover{color:inherit}.navbar .btn{margin-top:0;margin-bottom:0}.navbar .btn-link,.navbar .btn-link:focus,.navbar .btn-link:hover,.navbar .btn-link[disabled]:focus,.navbar .btn-link[disabled]:hover,fieldset[disabled] .navbar .btn-link:focus,fieldset[disabled] .navbar .btn-link:hover{color:inherit}.navbar .navbar-form{margin:4px 0 0}.navbar .navbar-form .form-group{margin:0;padding:0}.navbar .navbar-form .form-group.is-focused .material-input:after,.navbar .navbar-form .form-group .material-input:before{background-color:inherit}.navbar .navbar-form .form-control,.navbar .navbar-form .form-group .form-control{border-color:inherit;color:inherit;padding:0;margin:0;height:28px;font-size:14px;line-height:1.42857}.navbar,.navbar.navbar-default{background-color:#fff;color:#555}.navbar.navbar-default .navbar-form .form-group input.form-control::-moz-placeholder,.navbar.navbar-default .navbar-form input.form-control::-moz-placeholder,.navbar .navbar-form .form-group input.form-control::-moz-placeholder,.navbar .navbar-form input.form-control::-moz-placeholder{color:#555}.navbar.navbar-default .navbar-form .form-group input.form-control:-ms-input-placeholder,.navbar.navbar-default .navbar-form input.form-control:-ms-input-placeholder,.navbar .navbar-form .form-group input.form-control:-ms-input-placeholder,.navbar .navbar-form input.form-control:-ms-input-placeholder{color:#555}.navbar.navbar-default .navbar-form .form-group input.form-control::-webkit-input-placeholder,.navbar.navbar-default .navbar-form input.form-control::-webkit-input-placeholder,.navbar .navbar-form .form-group input.form-control::-webkit-input-placeholder,.navbar .navbar-form input.form-control::-webkit-input-placeholder{color:#555}.navbar .dropdown-menu,.navbar.navbar-default .dropdown-menu{border-radius:3px!important}.navbar .dropdown-menu li>a:focus,.navbar .dropdown-menu li>a:hover,.navbar.navbar-default .dropdown-menu li>a:focus,.navbar.navbar-default .dropdown-menu li>a:hover{color:#fff;background-color:#fff;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px hsla(0,0%,100%,.4)}.navbar .dropdown-menu .active>a,.navbar.navbar-default .dropdown-menu .active>a{background-color:#fff;color:#555;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px hsla(0,0%,100%,.4)}.navbar .dropdown-menu .active>a:focus,.navbar .dropdown-menu .active>a:hover,.navbar.navbar-default .dropdown-menu .active>a:focus,.navbar.navbar-default .dropdown-menu .active>a:hover{color:#555}.navbar.navbar-inverse{background-color:#212121;color:#fff}.navbar.navbar-inverse .navbar-form .form-group input.form-control::-moz-placeholder,.navbar.navbar-inverse .navbar-form input.form-control::-moz-placeholder{color:#fff}.navbar.navbar-inverse .navbar-form .form-group input.form-control:-ms-input-placeholder,.navbar.navbar-inverse .navbar-form input.form-control:-ms-input-placeholder{color:#fff}.navbar.navbar-inverse .navbar-form .form-group input.form-control::-webkit-input-placeholder,.navbar.navbar-inverse .navbar-form input.form-control::-webkit-input-placeholder{color:#fff}.navbar.navbar-inverse .dropdown-menu{border-radius:3px!important}.navbar.navbar-inverse .dropdown-menu .active>a,.navbar.navbar-inverse .dropdown-menu li>a:focus,.navbar.navbar-inverse .dropdown-menu li>a:hover{color:#fff;background-color:#212121;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(33,33,33,.4)}.navbar.navbar-inverse .dropdown-menu .active>a:focus,.navbar.navbar-inverse .dropdown-menu .active>a:hover{color:#fff}.navbar.navbar-primary{background-color:#e07e3c;color:#fff}.navbar.navbar-primary .navbar-form .form-group input.form-control::-moz-placeholder,.navbar.navbar-primary .navbar-form input.form-control::-moz-placeholder{color:#fff}.navbar.navbar-primary .navbar-form .form-group input.form-control:-ms-input-placeholder,.navbar.navbar-primary .navbar-form input.form-control:-ms-input-placeholder{color:#fff}.navbar.navbar-primary .navbar-form .form-group input.form-control::-webkit-input-placeholder,.navbar.navbar-primary .navbar-form input.form-control::-webkit-input-placeholder{color:#fff}.navbar.navbar-primary .dropdown-menu{border-radius:3px!important}.navbar.navbar-primary .dropdown-menu .active>a,.navbar.navbar-primary .dropdown-menu li>a:focus,.navbar.navbar-primary .dropdown-menu li>a:hover{color:#fff;background-color:#e07e3c;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.navbar.navbar-primary .dropdown-menu .active>a:focus,.navbar.navbar-primary .dropdown-menu .active>a:hover{color:#fff}.navbar.navbar-success{background-color:#4caf50;color:#fff}.navbar.navbar-success .navbar-form .form-group input.form-control::-moz-placeholder,.navbar.navbar-success .navbar-form input.form-control::-moz-placeholder{color:#fff}.navbar.navbar-success .navbar-form .form-group input.form-control:-ms-input-placeholder,.navbar.navbar-success .navbar-form input.form-control:-ms-input-placeholder{color:#fff}.navbar.navbar-success .navbar-form .form-group input.form-control::-webkit-input-placeholder,.navbar.navbar-success .navbar-form input.form-control::-webkit-input-placeholder{color:#fff}.navbar.navbar-success .dropdown-menu{border-radius:3px!important}.navbar.navbar-success .dropdown-menu .active>a,.navbar.navbar-success .dropdown-menu li>a:focus,.navbar.navbar-success .dropdown-menu li>a:hover{color:#fff;background-color:#4caf50;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(76,175,80,.4)}.navbar.navbar-success .dropdown-menu .active>a:focus,.navbar.navbar-success .dropdown-menu .active>a:hover{color:#fff}.navbar.navbar-info{background-color:#00bcd4;color:#fff}.navbar.navbar-info .navbar-form .form-group input.form-control::-moz-placeholder,.navbar.navbar-info .navbar-form input.form-control::-moz-placeholder{color:#fff}.navbar.navbar-info .navbar-form .form-group input.form-control:-ms-input-placeholder,.navbar.navbar-info .navbar-form input.form-control:-ms-input-placeholder{color:#fff}.navbar.navbar-info .navbar-form .form-group input.form-control::-webkit-input-placeholder,.navbar.navbar-info .navbar-form input.form-control::-webkit-input-placeholder{color:#fff}.navbar.navbar-info .dropdown-menu{border-radius:3px!important}.navbar.navbar-info .dropdown-menu .active>a,.navbar.navbar-info .dropdown-menu li>a:focus,.navbar.navbar-info .dropdown-menu li>a:hover{color:#fff;background-color:#00bcd4;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(0,188,212,.4)}.navbar.navbar-info .dropdown-menu .active>a:focus,.navbar.navbar-info .dropdown-menu .active>a:hover{color:#fff}.navbar.navbar-warning{background-color:#e07e3c;color:#fff}.navbar.navbar-warning .navbar-form .form-group input.form-control::-moz-placeholder,.navbar.navbar-warning .navbar-form input.form-control::-moz-placeholder{color:#fff}.navbar.navbar-warning .navbar-form .form-group input.form-control:-ms-input-placeholder,.navbar.navbar-warning .navbar-form input.form-control:-ms-input-placeholder{color:#fff}.navbar.navbar-warning .navbar-form .form-group input.form-control::-webkit-input-placeholder,.navbar.navbar-warning .navbar-form input.form-control::-webkit-input-placeholder{color:#fff}.navbar.navbar-warning .dropdown-menu{border-radius:3px!important}.navbar.navbar-warning .dropdown-menu .active>a,.navbar.navbar-warning .dropdown-menu li>a:focus,.navbar.navbar-warning .dropdown-menu li>a:hover{color:#fff;background-color:#e07e3c;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.navbar.navbar-warning .dropdown-menu .active>a:focus,.navbar.navbar-warning .dropdown-menu .active>a:hover{color:#fff}.navbar.navbar-danger{background-color:#f44336;color:#fff}.navbar.navbar-danger .navbar-form .form-group input.form-control::-moz-placeholder,.navbar.navbar-danger .navbar-form input.form-control::-moz-placeholder{color:#fff}.navbar.navbar-danger .navbar-form .form-group input.form-control:-ms-input-placeholder,.navbar.navbar-danger .navbar-form input.form-control:-ms-input-placeholder{color:#fff}.navbar.navbar-danger .navbar-form .form-group input.form-control::-webkit-input-placeholder,.navbar.navbar-danger .navbar-form input.form-control::-webkit-input-placeholder{color:#fff}.navbar.navbar-danger .dropdown-menu{border-radius:3px!important}.navbar.navbar-danger .dropdown-menu .active>a,.navbar.navbar-danger .dropdown-menu li>a:focus,.navbar.navbar-danger .dropdown-menu li>a:hover{color:#fff;background-color:#f44336;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(244,67,54,.4)}.navbar.navbar-danger .dropdown-menu .active>a:focus,.navbar.navbar-danger .dropdown-menu .active>a:hover{color:#fff}.navbar.navbar-rose{background-color:#e91e63;color:#fff}.navbar.navbar-rose .navbar-form .form-group input.form-control::-moz-placeholder,.navbar.navbar-rose .navbar-form input.form-control::-moz-placeholder{color:#fff}.navbar.navbar-rose .navbar-form .form-group input.form-control:-ms-input-placeholder,.navbar.navbar-rose .navbar-form input.form-control:-ms-input-placeholder{color:#fff}.navbar.navbar-rose .navbar-form .form-group input.form-control::-webkit-input-placeholder,.navbar.navbar-rose .navbar-form input.form-control::-webkit-input-placeholder{color:#fff}.navbar.navbar-rose .dropdown-menu{border-radius:3px!important}.navbar.navbar-rose .dropdown-menu .active>a,.navbar.navbar-rose .dropdown-menu li>a:focus,.navbar.navbar-rose .dropdown-menu li>a:hover{color:#fff;background-color:#e91e63;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(233,30,99,.4)}.navbar.navbar-rose .dropdown-menu .active>a:focus,.navbar.navbar-rose .dropdown-menu .active>a:hover{color:#fff}.navbar-inverse{background-color:#3f51b5}.navbar.navbar-transparent{background-color:transparent;box-shadow:none;border-bottom:0}.navbar.navbar-transparent .logo-container .brand{color:#fff}.navbar-fixed-top{border-radius:0}@media (max-width:1199px){.navbar .navbar-brand{height:50px;padding:10px 15px}.navbar .navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar .alert{border-radius:0;left:0;position:absolute;right:0;top:85px;width:100%;z-index:3;transition:all .3s}.nav-center{text-align:center}.nav-center .nav-pills-icons{display:inline-block}.nav-align-center{text-align:center}.nav-align-center .nav-pills{display:inline-block}.navbar-absolute{position:absolute;width:100%;padding-top:10px;z-index:1029}.nav-container{position:relative}.navbar-dashboard-fixed{position:fixed;right:0;left:0;z-index:1030}.popover,.tooltip-inner{color:#555;line-height:1.5em;background:#fff;border:none;border-radius:3px;box-shadow:0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12),0 5px 5px -3px rgba(0,0,0,.2)}.popover{padding:0;box-shadow:0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.popover.bottom>.arrow,.popover.left>.arrow,.popover.right>.arrow,.popover.top>.arrow{border:none}.popover-title{background-color:#fff;border:none;padding:15px 15px 5px;font-size:1.3em}.popover-content{padding:10px 15px 15px;line-height:1.4}.tooltip.in{opacity:1;-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-o-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0)}.tooltip{opacity:0;transition:opacity,transform .2s ease;-webkit-transform:translate3d(0,5px,0);-moz-transform:translate3d(0,5px,0);-o-transform:translate3d(0,5px,0);-ms-transform:translate3d(0,5px,0);transform:translate3d(0,5px,0)}.tooltip.left .tooltip-arrow{border-left-color:#fff}.tooltip.right .tooltip-arrow{border-right-color:#fff}.tooltip.top .tooltip-arrow{border-top-color:#fff}.tooltip.bottom .tooltip-arrow{border-bottom-color:#fff}.tooltip-inner{padding:10px 5px;min-width:150px}footer{padding:15px 0}footer ul{margin-bottom:0;padding:0;list-style:none}footer ul li{display:inline-block}footer ul li a{color:inherit;padding:15px;font-weight:500;font-size:12px;text-transform:uppercase;border-radius:3px;position:relative;display:block}footer ul li a,footer ul li a:hover{text-decoration:none}footer .copyright{padding:15px;margin:0}.amazon-management .top_buttons_body .nav footer .copyright .dropdown-toggle:after,footer .copyright .amazon-management .top_buttons_body .nav .dropdown-toggle:after,footer .copyright .material-icons{font-size:18px;position:relative;top:3px}footer .btn{margin-top:0;margin-bottom:0}.dropdown-menu{border:0;box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.dropdown-menu .divider{background-color:rgba(0,0,0,.12)}.dropdown-menu li>a{font-size:13px;padding:10px 20px;margin:0 5px;border-radius:2px;-webkit-transition:all .15s linear;-moz-transition:all .15s linear;-o-transition:all .15s linear;-ms-transition:all .15s linear;transition:all .15s linear}.dropdown-menu li>a:focus,.dropdown-menu li>a:hover{box-shadow:0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12),0 5px 5px -3px rgba(0,0,0,.2)}.dropdown-menu.dropdown-with-icons li>a{padding:12px 20px 12px 12px}.amazon-management .top_buttons_body .nav .dropdown-menu.dropdown-with-icons li>a .dropdown-toggle:after,.dropdown-menu.dropdown-with-icons li>a .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.dropdown-menu.dropdown-with-icons li>a .material-icons{vertical-align:middle;font-size:24px;position:relative;margin-top:-4px;top:1px;margin-right:12px;opacity:.5}.dropdown-menu li{position:relative}.dropdown-menu li a:active,.dropdown-menu li a:focus,.dropdown-menu li a:hover{background-color:#e07e3c;color:#fff}.dropdown-menu .divider{margin:5px 0}.bootstrap-table .dropdown-menu li a:active,.bootstrap-table .dropdown-menu li a:focus,.bootstrap-table .dropdown-menu li a:hover,.navbar .dropdown-menu li a:active,.navbar .dropdown-menu li a:focus,.navbar .dropdown-menu li a:hover,.navbar.navbar-default .dropdown-menu li a:active,.navbar.navbar-default .dropdown-menu li a:focus,.navbar.navbar-default .dropdown-menu li a:hover{background-color:#e07e3c;color:#fff;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.bootstrap-table .dropdown-menu,.btn-group.bootstrap-select .dropdown-menu,.dropdown-menu.bootstrap-datetimepicker-widget,.dropdown .dropdown-menu,.timeline .dropdown .dropdown-menu{-webkit-transition:all .15s linear;-moz-transition:all .15s linear;-o-transition:all .15s linear;-ms-transition:all .15s linear;transition:all .15s linear;-webkit-transform:translate3d(0,-20px,0);-moz-transform:translate3d(0,-20px,0);-o-transform:translate3d(0,-20px,0);-ms-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);visibility:hidden;display:block;opacity:0;filter:alpha(opacity=0)}.bootstrap-table .open .dropdown-menu,.btn-group.bootstrap-select.open .dropdown-menu,.dropdown-menu.bootstrap-datetimepicker-widget.open,.dropdown.open .dropdown-menu,.timeline .dropdown.open .dropdown-menu{opacity:1;filter:alpha(opacity=100);visibility:visible;-webkit-transform:translate3d(0,1px,0);-moz-transform:translate3d(0,1px,0);-o-transform:translate3d(0,1px,0);-ms-transform:translate3d(0,1px,0);transform:translate3d(0,1px,0)}.dropup .dropdown-menu{-webkit-transition:all .15s linear;-moz-transition:all .15s linear;-o-transition:all .15s linear;-ms-transition:all .15s linear;transition:all .15s linear;-webkit-transform:translate3d(0,20px,0);-moz-transform:translate3d(0,20px,0);-o-transform:translate3d(0,20px,0);-ms-transform:translate3d(0,20px,0);transform:translate3d(0,20px,0);visibility:hidden;display:block;opacity:0;filter:alpha(opacity=0)}.dropup.open .dropdown-menu{-webkit-transform:translate3d(0,-2px,0);-moz-transform:translate3d(0,-2px,0);-o-transform:translate3d(0,-2px,0);-ms-transform:translate3d(0,-2px,0);transform:translate3d(0,-2px,0);visibility:visible;opacity:1;filter:alpha(opacity=100)}.card{display:inline-block;position:relative;width:100%;margin:25px 0;box-shadow:0 1px 4px 0 rgba(0,0,0,.14);border-radius:6px;color:#000;background:#fff}.card .card-height-indicator{margin-top:100%}.card.row-space .header{padding:15px 20px 0}.card .map{height:280px;border-radius:6px;margin-top:15px}.card .map.map-big{height:420px}.card .card-title{margin-bottom:3px;margin-top:0;margin-bottom:5px}.card .card-image{height:60%;position:relative;overflow:hidden;margin-left:15px;margin-right:15px;margin-top:-30px;border-radius:6px;z-index:3;box-shadow:0 10px 30px -12px rgba(0,0,0,.42),0 4px 25px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.card .card-image img{width:100%;height:100%;border-radius:6px;pointer-events:none}.card .card-image .card-title{position:absolute;bottom:15px;left:15px;color:#fff;font-size:1.3em;text-shadow:0 2px 5px rgba(33,33,33,.5)}.card .category:not([class*=text-]){color:#999;font-size:14px}.card .card-content{padding:15px 20px;position:relative}.card .card-content .category{margin-bottom:0}.card .card-actions{position:absolute;z-index:1;top:-50px;width:calc(100% - 30px);left:17px;right:17px;text-align:center}.card .card-actions .btn{padding-left:12px;padding-right:12px}.card .card-actions .fix-broken-card{position:absolute;top:-65px}.card .card-header{padding:15px 20px 0;z-index:3}.card .card-header .category{margin-bottom:0}.card .card-header.card-header-text{display:inline-block}.card .card-header.card-header-text:after{content:"";display:table}.card .card-header.card-header-icon{float:left}.card .card-header.card-header-icon i{width:33px;height:33px;text-align:center;line-height:33px}.card .card-header.card-header-tabs .nav-tabs{background:transparent;padding:0}.card .card-header.card-header-tabs .nav-tabs-title{float:left;padding:10px 10px 10px 0;line-height:24px}.card .card-header.card-header-icon+.card-content .card-title{padding-bottom:15px}.card .social-line{margin-top:15px;text-align:center;padding:0}.card .social-line .btn{color:#fff;margin-left:5px;margin-right:5px}.card [data-background-color]{box-shadow:0 10px 30px -12px rgba(0,0,0,.42),0 4px 25px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2);margin:-20px 15px 0;border-radius:3px;padding:15px;background-color:#999;position:relative}.card [data-background-color] .card-title{color:#fff}.card [data-background-color] .category{margin-bottom:0;color:hsla(0,0%,100%,.62)}.card [data-background-color] .ct-label{color:hsla(0,0%,100%,.7)}.card [data-background-color] .ct-grid{stroke:hsla(0,0%,100%,.2)}.card [data-background-color] .ct-series-a .ct-bar,.card [data-background-color] .ct-series-a .ct-line,.card [data-background-color] .ct-series-a .ct-point,.card [data-background-color] .ct-series-a .ct-slice-donut{stroke:hsla(0,0%,100%,.8)}.card [data-background-color] .ct-series-a .ct-area,.card [data-background-color] .ct-series-a .ct-slice-pie{fill:hsla(0,0%,100%,.4)}.card .chart-title{position:absolute;top:25px;width:100%;text-align:center}.card .chart-title h3{margin:0;color:#fff}.card .chart-title h6{margin:0;color:hsla(0,0%,100%,.4)}.card .ct-chart~.card-footer i:nth-child(1n+2){width:18px;text-align:center}.card .card-footer{margin:0 20px 10px;padding-top:10px;border-top:1px solid #eee}.card .card-footer .form-group{margin:5px 0 0}.card .card-footer .content{display:block}.card .card-footer div{display:inline-block}.card .card-footer .author{color:#999}.card .card-footer .stats{line-height:22px;color:#424242;font-size:12px}.amazon-management .top_buttons_body .nav .card .card-footer .stats .dropdown-toggle:after,.card .card-footer .stats .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.card .card-footer .stats .material-icons{position:relative;top:4px;font-size:16px}.card .card-footer .stats .category{padding-top:7px;padding-bottom:7px;margin-bottom:0}.card .card-footer h4{margin:5px 0}.card .card-footer .btn{margin-top:5px;margin-bottom:5px}.card .card-footer h6{color:#999}.card form .card-footer{border:none}.card img{width:100%;height:auto}.amazon-management .top_buttons_body .nav .card .category .dropdown-toggle:after,.card .category .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.card .category .material-icons{position:relative;top:6px;line-height:0}.card .category-social .fa{font-size:24px;position:relative;margin-top:-4px;top:2px;margin-right:5px}.card .author .avatar{width:30px;height:30px;overflow:hidden;border-radius:50%;margin-right:5px}.card .author a{color:#3c4858;text-decoration:none}.card .author a .ripple-container{display:none}.card .table{margin-bottom:0}.card .table tr:first-child td{border-top:none}.card .nav-pills,.card .tab-content{margin-top:20px}.card [data-background-color=purple]{background:linear-gradient(60deg,#ab47bc,#8e24aa);box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.card [data-icon-bg-color=purple] i{color:#e07e3c}.card [data-background-color=blue]{background:linear-gradient(60deg,#26c6da,#00acc1);box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(0,188,212,.4)}.card [data-icon-bg-color=blue] i{color:#00bcd4}.card [data-background-color=green]{background:linear-gradient(60deg,#66bb6a,#43a047);box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(76,175,80,.4)}.card [data-background-color=green-light]{background:linear-gradient(60deg,#e8f5e9,#e8f5e9);box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(85,85,85,.4)}.card [data-icon-bg-color=green] i{color:#4caf50}.card [data-background-color=orange]{background:linear-gradient(60deg,#ffa726,#fb8c00);box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.card [data-background-color=orange-light]{background:linear-gradient(60deg,#fff7ee,#fff7ee);box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(85,85,85,.4)}.card [data-icon-bg-color=orange] i{color:#e07e3c}.card [data-background-color=orangered]{background:#ff4500;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(224,126,60,.4)}.card [data-icon-bg-color=orangered] i{color:#e07e3c}.card [data-background-color=cyan]{background:#00bcd4;box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(0,188,212,.4)}.card [data-icon-bg-color=cyan] i{color:#00bcd4}.card [data-background-color=red]{background:linear-gradient(60deg,#ef5350,#e53935);box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(244,67,54,.4)}.card [data-icon-bg-color=red] i{color:#f44336}.card [data-background-color=rose]{background:linear-gradient(60deg,#ec407a,#d81b60);box-shadow:0 4px 20px 0 rgba(0,0,0,.14),0 7px 10px -5px rgba(233,30,99,.4)}.card [data-icon-bg-color=rose] i{color:#e91e63}.card [data-header-animation=true]{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-o-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);-webkit-transition:all .3s cubic-bezier(.34,1.61,.7,1);-moz-transition:all .3s cubic-bezier(.34,1.61,.7,1);-o-transition:all .3s cubic-bezier(.34,1.61,.7,1);-ms-transition:all .3s cubic-bezier(.34,1.61,.7,1);transition:all .3s cubic-bezier(.34,1.61,.7,1)}.card:hover [data-header-animation=true]{-webkit-transform:translate3d(0,-50px,0);-moz-transform:translate3d(0,-50px,0);-o-transform:translate3d(0,-50px,0);-ms-transform:translate3d(0,-50px,0);transform:translate3d(0,-50px,0)}.card [data-background-color],.card [data-background-color] a{color:#fff}.card-chart .card-header{padding:0;min-height:160px}.card-chart .card-header+.content h4{margin-top:0}.card-calendar .card-content{padding:0}.card-stats .card-title{margin:0}.card-stats .card-header{float:left;text-align:center}.card-stats .card-header i{font-size:36px;line-height:56px;width:56px;height:56px}.card-stats .card-content{text-align:right;padding-top:10px}.card-plain{background:transparent;box-shadow:none}.card-plain .card-header{margin-left:0;margin-right:0}.card-plain .card-header-icon{margin-right:15px}.card-plain .content{padding-left:5px;padding-right:5px}.card-plain .card-image{margin:0;border-radius:3px}.card-plain .card-image img{border-radius:3px}.card-raised{box-shadow:0 10px 30px -12px rgba(0,0,0,.42),0 4px 25px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.iframe-container{margin:0 -20px}.iframe-container iframe{width:100%;height:500px;border:0;box-shadow:0 10px 30px -12px rgba(0,0,0,.42),0 4px 25px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.card-profile,.card-testimonial{margin-top:30px;text-align:center}.card-profile .btn-just-icon.btn-raised,.card-testimonial .btn-just-icon.btn-raised{margin-left:6px;margin-right:6px}.card-profile .card-avatar,.card-testimonial .card-avatar{max-width:130px;max-height:130px;margin:-50px auto 0;border-radius:50%;overflow:hidden;box-shadow:0 10px 30px -12px rgba(0,0,0,.42),0 4px 25px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.card-profile .card-avatar+.card-content,.card-testimonial .card-avatar+.card-content{margin-top:15px}.card-profile.card-plain .card-avatar,.card-testimonial.card-plain .card-avatar{margin-top:0}.card-testimonial{margin-bottom:65px}.card-testimonial .card-avatar{max-width:100px;max-height:100px}.card-testimonial .footer{margin-top:0}.card-testimonial .footer .card-avatar{margin-top:10px;margin-bottom:-50px}.card-testimonial .card-description{font-style:italic}.card-testimonial .card-description+.card-title,.card-testimonial .icon{margin-top:30px}.amazon-management .top_buttons_body .nav .card-testimonial .icon .dropdown-toggle:after,.card-testimonial .icon .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.card-testimonial .icon .material-icons{font-size:40px}.card-pricing{text-align:center}.card-pricing .card-title{margin-top:30px}.card-pricing .content{padding:15px!important}.card-pricing .icon{padding:10px 0 0;color:#999}.card-pricing .icon i{font-size:55px;border:1px solid #e5e5e5;border-radius:50%;width:130px;line-height:130px;height:130px}.card-pricing .icon.icon-primary{color:#e07e3c}.card-pricing .icon.icon-info{color:#00bcd4}.card-pricing .icon.icon-success{color:#4caf50}.card-pricing .icon.icon-warning{color:#e07e3c}.card-pricing .icon.icon-danger{color:#f44336}.card-pricing .icon.icon-rose{color:#e91e63}.card-pricing h1 small{font-size:18px}.card-pricing h1 small:first-child{position:relative;top:-17px;font-size:26px}.card-pricing ul{list-style:none;padding:0;max-width:240px;margin:10px auto}.card-pricing ul li{color:#999;text-align:center;padding:12px 0;border-bottom:1px solid hsla(0,0%,60%,.3)}.card-pricing ul li:last-child{border:0}.card-pricing ul li b{color:#3c4858}.card-pricing ul li i{top:6px;position:relative}.card-pricing.card-background ul li,.card-pricing [class*=content-] ul li{color:#fff;border-color:hsla(0,0%,100%,.3)}.card-pricing.card-background [class*=text-],.card-pricing.card-background ul li b,.card-pricing [class*=content-] [class*=text-],.card-pricing [class*=content-] ul li b{color:#fff}.card-pricing.card-background:after{background-color:rgba(0,0,0,.7)}.card-background{background-position:50%;background-size:cover;text-align:center}.card-background .content{position:relative;z-index:2;min-height:280px;padding-top:40px;padding-bottom:40px;max-width:440px;margin:0 auto}.card-background .card-description,.card-background .category,.card-background small{color:hsla(0,0%,100%,.7)}.card-background .card-title{color:#fff;margin-top:10px}.card-background:not(.card-pricing) .btn{margin-bottom:0}.card-background:after{position:absolute;z-index:1;width:100%;height:100%;display:block;left:0;top:0;content:"";background-color:rgba(0,0,0,.56);border-radius:6px}.card-product{margin-top:30px}.card-product .btn-simple.btn-just-icon{padding:0}.card-product .footer{margin-top:5px}.amazon-management .top_buttons_body .nav .card-product .footer .stats .dropdown-toggle:after,.card-product .footer .stats .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.card-product .footer .stats .material-icons{margin-top:4px;top:0}.card-product .footer .price h4{margin-bottom:0}.card-product .card-description,.card-product .card-title,.card-product .category{text-align:center}.card-product .card-image{min-height:160px;background-size:cover;background-image:url(assets/image_placeholder.ebe9884b2152a08a525fcd5054019532.jpg);background-position:50%}.card-login .card-title{margin-top:10px;margin-bottom:10px;font-weight:700}.card-login .text-divider{margin-top:30px;margin-bottom:0;text-align:center}.card-login .card-content{padding:0 30px 0 10px}.card-login .checkbox{margin-top:20px}.card-login .checkbox label{margin-left:17px}.card-login .checkbox .checkbox-material{padding-right:12px}.card-login .social-line{margin-top:15px;text-align:center;padding:0}.card-login .social-line .btn{color:#fff;margin-left:5px;margin-right:5px}.characters-limit-span{float:right;display:inline-block;background-color:#aaa;font-size:12px;font-style:italic;padding:2px 5px;margin:4px 0 0;color:#fff}.zoomWindowContainer div{background-color:#fff}.font-size-10{font-size:10px!important}.font-size-11{font-size:11px!important}.font-size-12{font-size:12px!important}.font-size-13{font-size:13px!important}.font-size-14{font-size:14px!important}.font-size-15{font-size:15px!important}.font-size-16{font-size:16px!important}.font-size-17{font-size:17px!important}.font-size-18{font-size:18px!important}.font-size-19{font-size:19px!important}.font-size-20{font-size:20px!important}.font-size-22{font-size:22px!important}.font-size-24{font-size:24px!important}.font-size-26{font-size:26px!important}.font-size-28{font-size:28px!important}.font-size-30{font-size:30px!important}.font-size-32{font-size:32px!important}.font-size-34{font-size:34px!important}.font-size-36,.font-size-38{font-size:36px!important}.font-size-40{font-size:40px!important}.font-light{font-weight:200!important}.font-normal{font-weight:400!important}.font-bold{font-weight:700!important}.font-bolder{font-weight:900!important}.font-italic{font-style:italic!important}.text-underline{text-decoration:underline!important}.text-decoration-none{text-decoration:none!important}.text-line-through{text-decoration:line-through!important}.text-left{text-align:left!important}.opacity-5-pct{opacity:.05}.opacity-10-pct{opacity:.1}.opacity-15-pct{opacity:.15}.opacity-20-pct{opacity:.2}.opacity-25-pct{opacity:.25}.opacity-30-pct{opacity:.3}.opacity-35-pct{opacity:.35}.opacity-40-pct{opacity:.4}.opacity-45-pct{opacity:.45}.opacity-50-pct{opacity:.5}.opacity-55-pct{opacity:.55}.opacity-60-pct{opacity:.6}.opacity-65-pct{opacity:.65}.opacity-75-pct{opacity:.7}.opacity-80-pct{opacity:.8}.opacity-85-pct{opacity:.85}.opacity-90-pct{opacity:.9}.opacity-95-pct{opacity:.95}.opacity-100-pct{opacity:1}.margin-top-0{margin-top:0!important}.margin-top-5{margin-top:5px!important}.margin-top-10{margin-top:10px!important}.margin-top-15{margin-top:15px!important}.margin-top-20{margin-top:20px!important}.margin-top-25{margin-top:25px!important}.margin-top-30{margin-top:30px!important}.margin-top-35{margin-top:35px!important}.margin-top-40{margin-top:40px!important}.margin-top-45{margin-top:45px!important}.margin-top-50{margin-top:50px!important}.margin-top-52{margin-top:52px!important}.margin-right--10{margin-right:-10px!important}.margin-right-0{margin-right:0!important}.margin-right-5{margin-right:5px!important}.margin-right-10{margin-right:10px!important}.margin-right-15{margin-right:15px!important}.margin-right-20{margin-right:20px!important}.margin-right-25{margin-right:25px!important}.margin-right-30{margin-right:30px!important}.margin-right-35{margin-right:35px!important}.margin-right-40{margin-right:40px!important}.margin-right-45{margin-right:45px!important}.margin-right-50{margin-right:50px!important}.margin-bottom-0{margin-bottom:0!important}.margin-bottom-5{margin-bottom:5px!important}.margin-bottom-10{margin-bottom:10px!important}.margin-bottom-15{margin-bottom:15px!important}.margin-bottom-20{margin-bottom:20px!important}.margin-bottom-25{margin-bottom:25px!important}.margin-bottom-30{margin-bottom:30px!important}.margin-bottom-35{margin-bottom:35px!important}.margin-bottom-40{margin-bottom:40px!important}.margin-bottom-45{margin-bottom:45px!important}.margin-bottom-50{margin-bottom:50px!important}.margin-bottom-80{margin-bottom:80px!important}.margin-left-0{margin-left:0!important}.margin-left-5{margin-left:5px!important}.margin-left-10{margin-left:10px!important}.margin-left-15{margin-left:15px!important}.margin-left-20{margin-left:20px!important}.margin-left-25{margin-left:25px!important}.margin-left-30{margin-left:30px!important}.margin-left-35{margin-left:35px!important}.margin-left-40{margin-left:40px!important}.margin-left-45{margin-left:45px!important}.margin-left-50{margin-left:50px!important}.margin-0{margin:0!important}.margin-5{margin:5px!important}.margin-10{margin:10px!important}.margin-15{margin:15px!important}.margin-20{margin:20px!important}.margin-25{margin:25px!important}.margin-30{margin:30px!important}.margin-35{margin:35px!important}.margin-40{margin:40px!important}.margin-45{margin:45px!important}.margin-50{margin:50px!important}.padding-top-0{padding-top:0!important}.padding-top-5{padding-top:5px!important}.padding-top-10{padding-top:10px!important}.padding-top-15{padding-top:15px!important}.padding-top-20{padding-top:20px!important}.padding-top-25{padding-top:25px!important}.padding-top-30{padding-top:30px!important}.padding-top-35{padding-top:35px!important}.padding-top-40{padding-top:40px!important}.padding-top-45{padding-top:45px!important}.padding-top-50{padding-top:50px!important}.padding-right-0{padding-right:0!important}.padding-right-5{padding-right:5px!important}.padding-right-10{padding-right:10px!important}.padding-right-15{padding-right:15px!important}.padding-right-20{padding-right:20px!important}.padding-right-25{padding-right:25px!important}.padding-right-30{padding-right:30px!important}.padding-right-35{padding-right:35px!important}.padding-right-40{padding-right:40px!important}.padding-right-45{padding-right:45px!important}.padding-right-50{padding-right:50px!important}.padding-bottom-0{padding-bottom:0!important}.padding-bottom-5{padding-bottom:5px!important}.padding-bottom-10{padding-bottom:10px!important}.padding-bottom-15{padding-bottom:15px!important}.padding-bottom-20{padding-bottom:20px!important}.padding-bottom-25{padding-bottom:25px!important}.padding-bottom-30{padding-bottom:30px!important}.padding-bottom-35{padding-bottom:35px!important}.padding-bottom-40{padding-bottom:40px!important}.padding-bottom-45{padding-bottom:45px!important}.padding-bottom-50{padding-bottom:50px!important}.padding-left-0{padding-left:0!important}.padding-left-5{padding-left:5px!important}.padding-left-10{padding-left:10px!important}.padding-left-15{padding-left:15px!important}.padding-left-20{padding-left:20px!important}.padding-left-25{padding-left:25px!important}.padding-left-30{padding-left:30px!important}.padding-left-35{padding-left:35px!important}.padding-left-40{padding-left:40px!important}.padding-left-45{padding-left:45px!important}.padding-left-50{padding-left:50px!important}.padding-0{padding:0!important}.padding-5{padding:5px!important}.padding-10{padding:10px!important}.padding-15{padding:15px!important}.padding-20{padding:20px!important}.padding-25{padding:25px!important}.padding-30{padding:30px!important}.padding-35{padding:35px!important}.padding-40{padding:40px!important}.padding-45{padding:45px!important}.padding-50{padding:50px!important}.float-left{float:left!important}.float-right{float:right!important}.float-none{float:none!important}.align-right{text-align:right!important}.align-center{text-align:center!important}.align-left{text-align:left!important}.display-block{display:block!important}.display-inline{display:inline!important}.display-inline-block{display:inline-block!important}.display-flex{display:flex;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex}.vertical-align-middle{vertical-align:middle!important}.vertical-align-top{vertical-align:top!important}.vertical-align-bottom{vertical-align:bottom!important}.text-uppercase{text-transform:uppercase!important}.text-lowercase{text-transform:lowercase!important}.text-capitalize{text-transform:capitalize!important}.text-transform-none{text-transform:none!important}.cursor-default{cursor:default!important}.cursor-pointer{cursor:pointer!important}.border-0,.border-none{border:none!important}.width-5-pct{width:5%!important}.width-10-pct{width:10%!important}.width-15-pct{width:15%!important}.width-20-pct{width:20%!important}.width-25-pct{width:25%!important}.width-30-pct{width:30%!important}.width-35-pct{width:35%!important}.width-40-pct{width:40%!important}.width-45-pct{width:45%!important}.width-50-pct{width:50%!important}.width-55-pct{width:55%!important}.width-60-pct{width:60%!important}.width-65-pct{width:65%!important}.width-70-pct{width:70%!important}.width-75-pct{width:75%!important}.width-80-pct{width:80%!important}.width-85-pct{width:85%!important}.width-90-pct{width:90%!important}.width-95-pct{width:95%!important}.width-100-pct{width:100%!important}.width-5{width:5px!important}.width-10{width:10px!important}.width-15{width:15px!important}.width-20{width:20px!important}.width-25{width:25px!important}.width-30{width:30px!important}.width-35{width:35px!important}.width-40{width:40px!important}.width-45{width:45px!important}.width-50{width:50px!important}.width-55{width:55px!important}.width-60{width:60px!important}.width-65{width:65px!important}.width-70{width:70px!important}.width-75{width:75px!important}.width-80{width:80px!important}.width-85{width:85px!important}.width-90{width:90px!important}.width-95{width:95px!important}.width-100{width:100px!important}.width-150{width:150px!important}.width-200{width:200px!important}.width-250{width:250px!important}.width-300{width:300px!important}.width-350{width:350px!important}.width-400{width:400px!important}.width-450{width:450px!important}.width-500{width:500px!important}.height-5-pct{height:5%!important}.height-10-pct{height:10%!important}.height-15-pct{height:15%!important}.height-20-pct{height:20%!important}.height-25-pct{height:25%!important}.height-30-pct{height:30%!important}.height-35-pct{height:35%!important}.height-40-pct{height:40%!important}.height-45-pct{height:45%!important}.height-50-pct{height:50%!important}.height-55-pct{height:55%!important}.height-60-pct{height:60%!important}.height-65-pct{height:65%!important}.height-70-pct{height:70%!important}.height-75-pct{height:75%!important}.height-80-pct{height:80%!important}.height-85-pct{height:85%!important}.height-90-pct{height:90%!important}.height-95-pct{height:95%!important}.height-100-pct{height:100%!important}.height-5{height:5px!important}.height-10{height:10px!important}.height-15{height:15px!important}.height-20{height:20px!important}.height-25{height:25px!important}.height-30{height:30px!important}.height-35{height:35px!important}.height-40{height:40px!important}.height-45{height:45px!important}.height-50{height:50px!important}.height-55{height:55px!important}.height-60{height:60px!important}.height-65{height:65px!important}.height-70{height:70px!important}.height-75{height:75px!important}.height-80{height:80px!important}.height-85{height:85px!important}.height-90{height:90px!important}.height-95{height:95px!important}.height-100{height:100px!important}.height-150{height:150px!important}.height-200{height:200px!important}.height-250{height:250px!important}.height-300{height:300px!important}.height-350{height:350px!important}.height-400{height:400px!important}.height-450{height:450px!important}.height-500{height:500px!important}@media print{.col-print-1{width:1.666666667%;float:left}.col-print-2{width:3.333333333%;float:left}.col-print-3{width:5%;float:left}.col-print-4{width:6.666666667%;float:left}.col-print-5{width:8.333333333%;float:left}.col-print-6{width:10%;float:left}.col-print-7{width:11.66666667%;float:left}.col-print-8{width:13.33333333%;float:left}.col-print-9{width:15%;float:left}.col-print-10{width:16.66666667%;float:left}.col-print-11{width:18.33333333%;float:left}.col-print-12{width:20%;float:left}.col-print-13{width:21.66666667%;float:left}.col-print-14{width:23.33333333%;float:left}.col-print-15{width:25%;float:left}.col-print-16{width:26.66666667%;float:left}.col-print-17{width:28.33333333%;float:left}.col-print-18{width:30%;float:left}.col-print-19{width:31.66666667%;float:left}.col-print-20{width:33.33333333%;float:left}.col-print-21{width:35%;float:left}.col-print-22{width:36.66666667%;float:left}.col-print-23{width:38.33333333%;float:left}.col-print-24{width:40%;float:left}.col-print-25{width:41.66666667%;float:left}.col-print-26{width:43.33333333%;float:left}.col-print-27{width:45%;float:left}.col-print-28{width:46.66666667%;float:left}.col-print-29{width:48.33333333%;float:left}.col-print-30{width:50%;float:left}.col-print-31{width:51.66666667%;float:left}.col-print-32{width:53.33333333%;float:left}.col-print-33{width:55%;float:left}.col-print-34{width:56.66666667%;float:left}.col-print-35{width:58.33333333%;float:left}.col-print-36{width:60%;float:left}.col-print-37{width:61.66666667%;float:left}.col-print-38{width:63.33333333%;float:left}.col-print-39{width:65%;float:left}.col-print-40{width:66.66666667%;float:left}.col-print-41{width:68.33333333%;float:left}.col-print-42{width:70%;float:left}.col-print-43{width:71.66666667%;float:left}.col-print-44{width:73.33333333%;float:left}.col-print-45{width:75%;float:left}.col-print-46{width:76.66666667%;float:left}.col-print-47{width:78.33333333%;float:left}.col-print-48{width:80%;float:left}.col-print-49{width:81.66666667%;float:left}.col-print-50{width:83.33333333%;float:left}.col-print-51{width:85%;float:left}.col-print-52{width:86.66666667%;float:left}.col-print-53{width:88.33333333%;float:left}.col-print-54{width:90%;float:left}.col-print-55{width:91.66666667%;float:left}.col-print-56{width:93.33333333%;float:left}.col-print-57{width:95%;float:left}.col-print-58{width:96.66666667%;float:left}.col-print-59{width:98.33333333%;float:left}.col-print-60{width:100%;float:left}}.letter-spacing-1-3{letter-spacing:1.3px!important}.letter-spacing-1-5{letter-spacing:1.5px!important}.letter-spacing-1-7{letter-spacing:1.7px!important}.letter-spacing-2{letter-spacing:2px!important}.position-relative{position:relative!important}.position-static{position:static!important}.position-absolute{position:absolute!important}.position-fixed{position:fixed!important}.text-ellipsis-inline{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.text-ellipsis-multiline{position:relative;overflow:hidden}.text-ellipsis-multiline:after{content:"";text-align:right;position:absolute;bottom:0;right:0;width:20%;height:20px;z-index:3;background:linear-gradient(90deg,hsla(0,0%,100%,0),#fff 50%)}.text-ellipsis-multiline-brand{position:relative;overflow:hidden}.text-ellipsis-multiline-brand:after{content:"";text-align:right;position:absolute;bottom:0;right:0;width:20%;height:20px;z-index:3;background:linear-gradient(90deg,hsla(0,0%,100%,0),#fff7ee 50%)}.no-border-bottom{border-bottom:0!important;border-bottom-left-radius:0!important;border-bottom-right-radius:0!important}.no-border-top{border-top:0!important;border-top-left-radius:0!important;border-top-right-radius:0!important}.flex-items-center{align-items:center}.margin-left-auto{margin-left:auto}.margin-auto{margin:auto!important}.line-height-30{line-height:30px!important}.fa-rotate-180{transform:rotate(180deg)}.nav-tabs{background:#e07e3c;padding:0 15px}.nav-tabs,.nav-tabs>li>a{border:0;border-radius:3px}.nav-tabs>li>a{color:#fff;margin:0;line-height:24px;text-transform:uppercase;font-size:12px}.nav-tabs>li>a:hover{background-color:transparent;border:0}.nav-tabs>li>a,.nav-tabs>li>a:focus,.nav-tabs>li>a:hover{background-color:transparent;border:0!important;color:#fff!important;font-weight:500}.nav-tabs>li.disabled>a,.nav-tabs>li.disabled>a:hover{color:hsla(0,0%,100%,.5)}.amazon-management .top_buttons_body .nav .nav-tabs>li .dropdown-toggle:after,.amazon-management .top_buttons_body .nav .open .nav-tabs>li .dropdown-toggle:after,.nav-tabs>li .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.nav-tabs>li .material-icons{margin:-1px 5px 0 0}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{background-color:hsla(0,0%,100%,.2);transition:background-color .1s .2s}@media (min-width:992px){.navbar-form{margin-top:21px;margin-bottom:21px;padding-left:5px;padding-right:5px}.navbar-nav.navbar-right>li>.dropdown-menu:after,.navbar-nav.navbar-right>li>.dropdown-menu:before{left:auto;right:12px}.footer:not(.footer-big) nav>ul li:first-child{margin-left:0}.card form [class*=col-]:first-child{padding-left:15px}.card form [class*=col-]:last-child{padding-right:15px}.sidebar .navbar-form{display:none!important}.close-layer,.sidebar .nav-mobile-menu{display:none}.wrapper .navbar-dashboard-fixed{width:calc(100% - 260px);right:0;left:auto}.sidebar-mini .wrapper .navbar-dashboard-fixed{width:calc(100% - 80px)}}@media (max-width:991px){.form-group textarea{padding-top:15px}.menu-on-left.nav-open .main-panel,.menu-on-left.nav-open .navbar-fixed>div,.menu-on-left.nav-open .wrapper-full-page{-webkit-transform:translate3d(260px,0,0);-moz-transform:translate3d(260px,0,0);-o-transform:translate3d(260px,0,0);-ms-transform:translate3d(260px,0,0);transform:translate3d(260px,0,0)}.menu-on-left.nav-open .off-canvas-sidebar,.menu-on-left.nav-open .sidebar{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-o-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0)}.menu-on-left .off-canvas-sidebar,.menu-on-left .sidebar{left:0;right:auto;-webkit-transform:translate3d(-260px,0,0);-moz-transform:translate3d(-260px,0,0);-o-transform:translate3d(-260px,0,0);-ms-transform:translate3d(-260px,0,0);transform:translate3d(-260px,0,0)}.timeline:before,.timeline>li>.timeline-badge{left:5%}.timeline>li>.timeline-panel{float:right;width:86%}.timeline>li>.timeline-panel:before{border-left-width:0;border-right-width:15px;left:-15px;right:auto}.timeline>li>.timeline-panel:after{border-left-width:0;border-right-width:14px;left:-14px;right:auto}.nav-mobile-menu .dropdown .dropdown-menu{display:none}.nav-mobile-menu .dropdown.open .dropdown-menu{display:block}.nav-mobile-menu li.active>a{background-color:hsla(0,0%,100%,.1)}.navbar-minimize{display:none}.card .form-horizontal .label-on-left,.card .form-horizontal .label-on-right{padding-left:15px;padding-top:8px}.card .form-horizontal .form-group{margin-top:25px}.card .form-horizontal .checkbox-radios{padding-bottom:15px}.card .form-horizontal .checkbox-inline,.card .form-horizontal .checkbox-radios .checkbox:first-child,.card .form-horizontal .checkbox-radios .radio:first-child{margin-top:0}.sidebar{display:none;box-shadow:none}.sidebar .sidebar-wrapper{padding-bottom:60px}.sidebar .nav-mobile-menu{margin-top:0}.sidebar .nav-mobile-menu .notification{float:left;line-height:30px;margin-right:8px}.sidebar .nav-mobile-menu .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;-webkit-box-shadow:none;box-shadow:none}.main-panel{width:100%}.wrapper-full-page .navbar.navbar-transparent{padding-top:15px;background-color:rgba(0,0,0,.45)}body{position:relative;min-height:100vh}.off-canvas-menu .wrapper-full-page,.sidebar-pages .main-panel,.sidebar-pages .navbar .container,.wrapper .main-panel{left:0}.navbar .container,.off-canvas-menu .wrapper-full-page,.sidebar-pages .main-panel,.sidebar-pages .navbar .container,.wrapper .main-panel{-webkit-transition:all .33s cubic-bezier(.685,.0473,.346,1);-moz-transition:all .33s cubic-bezier(.685,.0473,.346,1);-o-transition:all .33s cubic-bezier(.685,.0473,.346,1);-ms-transition:all .33s cubic-bezier(.685,.0473,.346,1);transition:all .33s cubic-bezier(.685,.0473,.346,1)}.sidebar-pages .navbar .navbar-collapse.collapse,.sidebar-pages .navbar .navbar-collapse.collapse.in,.sidebar-pages .navbar .navbar-collapse.collapsing{display:none!important}.off-canvas-sidebar,.sidebar{position:fixed;display:block;top:0;height:100vh;width:260px;right:0;left:auto;z-index:1032;visibility:visible;background-color:#9a9a9a;overflow-y:visible;border-top:none;text-align:left;padding-right:0;padding-left:0;-webkit-transform:translate3d(260px,0,0);-moz-transform:translate3d(260px,0,0);-o-transform:translate3d(260px,0,0);-ms-transform:translate3d(260px,0,0);transform:translate3d(260px,0,0);-webkit-transition:all .33s cubic-bezier(.685,.0473,.346,1);-moz-transition:all .33s cubic-bezier(.685,.0473,.346,1);-o-transition:all .33s cubic-bezier(.685,.0473,.346,1);-ms-transition:all .33s cubic-bezier(.685,.0473,.346,1);transition:all .33s cubic-bezier(.685,.0473,.346,1)}.off-canvas-sidebar>ul,.sidebar>ul{position:relative;z-index:4;overflow-y:scroll;height:calc(100vh - 61px);width:100%}.off-canvas-sidebar:before,.sidebar:before{top:0;left:0;height:100%;width:100%;position:absolute;background-color:#282828;display:block;content:"";z-index:1}.off-canvas-sidebar .logo,.sidebar .logo{position:relative;z-index:4}.off-canvas-sidebar .navbar-form,.sidebar .navbar-form{margin:10px 0;float:none!important;padding-top:1px;padding-bottom:1px;position:relative}.off-canvas-sidebar .table-responsive,.sidebar .table-responsive{width:100%;margin-bottom:15px;overflow-x:scroll;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;-webkit-overflow-scrolling:touch}.form-group.form-search .form-control{font-size:1.7em;height:37px;width:78%}.navbar-form .btn{position:absolute;top:12px;right:15px}.nav-open .sidebar-pages .main-panel,.nav-open .sidebar-pages .navbar .container,.nav-open .wrapper .main-panel{left:0;-webkit-transform:translate3d(-260px,0,0);-moz-transform:translate3d(-260px,0,0);-o-transform:translate3d(-260px,0,0);-ms-transform:translate3d(-260px,0,0);transform:translate3d(-260px,0,0)}.nav-open .navbar .container,.nav-open.off-canvas-menu .navbar .container{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-o-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0)}.nav-open .sidebar{box-shadow:0 10px 30px -12px rgba(0,0,0,.42),0 4px 25px 0 rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.nav-open .off-canvas-sidebar,.nav-open .sidebar{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-o-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0)}.close-layer{height:100%;width:100%;position:absolute;opacity:0;top:0;left:auto;background:rgba(0,0,0,.35);content:"";z-index:9999;overflow-x:hidden;-webkit-transition:all .37s ease-in;-moz-transition:all .37s ease-in;-o-transition:all .37s ease-in;-ms-transition:all .37s ease-in;transition:all .37s ease-in}.close-layer.visible{opacity:1}.navbar-toggle .icon-bar{display:block;position:relative;background:#fff;width:24px;height:2px;border-radius:1px;margin:0 auto}.navbar-header .navbar-toggle{padding:15px;margin-top:4px;width:40px;height:40px;display:block!important;float:right}.bar1,.bar2,.bar3{outline:1px solid transparent}@keyframes topbar-x{0%{top:0;transform:rotate(0deg)}45%{top:6px;transform:rotate(145deg)}75%{transform:rotate(130deg)}to{transform:rotate(135deg)}}@-webkit-keyframes topbar-x{0%{top:0;-webkit-transform:rotate(0deg)}45%{top:6px;-webkit-transform:rotate(145deg)}75%{-webkit-transform:rotate(130deg)}to{-webkit-transform:rotate(135deg)}}@-moz-keyframes topbar-x{0%{top:0;-moz-transform:rotate(0deg)}45%{top:6px;-moz-transform:rotate(145deg)}75%{-moz-transform:rotate(130deg)}to{-moz-transform:rotate(135deg)}}@keyframes topbar-back{0%{top:6px;transform:rotate(135deg)}45%{transform:rotate(-10deg)}75%{transform:rotate(5deg)}to{top:0;transform:rotate(0)}}@-webkit-keyframes topbar-back{0%{top:6px;-webkit-transform:rotate(135deg)}45%{-webkit-transform:rotate(-10deg)}75%{-webkit-transform:rotate(5deg)}to{top:0;-webkit-transform:rotate(0)}}@-moz-keyframes topbar-back{0%{top:6px;-moz-transform:rotate(135deg)}45%{-moz-transform:rotate(-10deg)}75%{-moz-transform:rotate(5deg)}to{top:0;-moz-transform:rotate(0)}}@keyframes bottombar-x{0%{bottom:0;transform:rotate(0deg)}45%{bottom:6px;transform:rotate(-145deg)}75%{transform:rotate(-130deg)}to{transform:rotate(-135deg)}}@-webkit-keyframes bottombar-x{0%{bottom:0;-webkit-transform:rotate(0deg)}45%{bottom:6px;-webkit-transform:rotate(-145deg)}75%{-webkit-transform:rotate(-130deg)}to{-webkit-transform:rotate(-135deg)}}@-moz-keyframes bottombar-x{0%{bottom:0;-moz-transform:rotate(0deg)}45%{bottom:6px;-moz-transform:rotate(-145deg)}75%{-moz-transform:rotate(-130deg)}to{-moz-transform:rotate(-135deg)}}@keyframes bottombar-back{0%{bottom:6px;transform:rotate(-135deg)}45%{transform:rotate(10deg)}75%{transform:rotate(-5deg)}to{bottom:0;transform:rotate(0)}}@-webkit-keyframes bottombar-back{0%{bottom:6px;-webkit-transform:rotate(-135deg)}45%{-webkit-transform:rotate(10deg)}75%{-webkit-transform:rotate(-5deg)}to{bottom:0;-webkit-transform:rotate(0)}}@-moz-keyframes bottombar-back{0%{bottom:6px;-moz-transform:rotate(-135deg)}45%{-moz-transform:rotate(10deg)}75%{-moz-transform:rotate(-5deg)}to{bottom:0;-moz-transform:rotate(0)}}.navbar-toggle .icon-bar:nth-child(2){top:0;-webkit-animation:topbar-back .5s linear 0s;-moz-animation:topbar-back .5s linear 0s;animation:topbar-back .5s 0s;-webkit-animation-fill-mode:forwards;-moz-animation-fill-mode:forwards;animation-fill-mode:forwards}.navbar-toggle .icon-bar:nth-child(3){opacity:1}.navbar-toggle .icon-bar:nth-child(4){bottom:0;-webkit-animation:bottombar-back .5s linear 0s;-moz-animation:bottombar-back .5s linear 0s;animation:bottombar-back .5s 0s;-webkit-animation-fill-mode:forwards;-moz-animation-fill-mode:forwards;animation-fill-mode:forwards}.navbar-toggle.toggled .icon-bar:nth-child(2){top:6px;-webkit-animation:topbar-x .5s linear 0s;-moz-animation:topbar-x .5s linear 0s;animation:topbar-x .5s 0s;-webkit-animation-fill-mode:forwards;-moz-animation-fill-mode:forwards;animation-fill-mode:forwards}.navbar-toggle.toggled .icon-bar:nth-child(3){opacity:0}.navbar-toggle.toggled .icon-bar:nth-child(4){bottom:6px;-webkit-animation:bottombar-x .5s linear 0s;-moz-animation:bottombar-x .5s linear 0s;animation:bottombar-x .5s 0s;-webkit-animation-fill-mode:forwards;-moz-animation-fill-mode:forwards;animation-fill-mode:forwards}@-webkit-keyframes fadeIn{0%{opacity:0}to{opacity:1}}@-moz-keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.dropdown-menu .divider{background-color:hsla(0,0%,90%,.15)}.navbar-nav{margin:1px 0}.navbar-nav .open .dropdown-menu>li>a{padding:15px 15px 5px 50px}.navbar-nav .open .dropdown-menu>li:first-child>a{padding:5px 15px 5px 50px}.navbar-nav .open .dropdown-menu>li:last-child>a{padding:15px 15px 25px 50px}[class*=navbar-] .navbar-nav.navbar-nav .open .dropdown-menu>li>a:active{opacity:1}[class*=navbar-] .navbar-nav .dropdown>a:hover .caret{border-bottom-color:#777;border-top-color:#777}[class*=navbar-] .navbar-nav .dropdown>a:active .caret{border-bottom-color:#fff;border-top-color:#fff}.dropdown-menu{display:none}.navbar-fixed-top{-webkit-backface-visibility:hidden}#bodyClick{height:100%;width:100%;position:fixed;opacity:0;top:0;left:auto;right:250px;content:"";z-index:9999;overflow-x:hidden}.social-line .btn,.subscribe-line .form-control{margin:0 0 10px}.footer:not(.footer-big) nav>ul li,.social-line.pull-right{float:none}.social-area.pull-right{float:none!important}.form-control+.form-control-feedback{margin-top:-8px}.navbar-toggle:focus,.navbar-toggle:hover{background-color:transparent!important}.media-post .author{width:20%;float:none!important;display:block;margin:0 auto 10px}.media-post .media-body{width:100%}.sidebar-pages .navbar-header .collapse,.sidebar-pages .navbar-toggle{display:block!important}.off-canvas-menu .navbar-header .collapse,.off-canvas-menu .navbar-toggle{display:none!important}.sidebar-pages .navbar-collapse.collapse{height:100%!important}.navbar-collapse.collapse.in{display:block}.navbar-header,.off-canvas-menu .navbar-header{float:right}.navbar-collapse .nav p{font-size:14px;margin:0}.navbar-transparent{background:rgba(0,0,0,.6)}}@media (min-width:768px){.navbar>.container-fluid .navbar-brand{margin-left:0}}@media (max-width:991px){.main-panel .content{padding-left:0;padding-right:0}.off-canvas-menu .nav>li>a,.off-canvas-menu .nav>li>a:hover{color:#fff}.off-canvas-menu .nav>li>a i,.off-canvas-menu .nav>li>a i:hover{color:#a9afbb}.off-canvas-menu .navbar-collapse{position:fixed;display:block;top:-15px;height:100vh;width:260px;right:0;z-index:1032;visibility:visible;background-color:#999;overflow-y:visible;border-top:none;margin:0;text-align:left;max-height:none!important;-webkit-transform:translate3d(260px,0,0);-moz-transform:translate3d(260px,0,0);-o-transform:translate3d(260px,0,0);-ms-transform:translate3d(260px,0,0);transform:translate3d(260px,0,0);-webkit-transition:all .33s cubic-bezier(.685,.0473,.346,1);-moz-transition:all .33s cubic-bezier(.685,.0473,.346,1);-o-transition:all .33s cubic-bezier(.685,.0473,.346,1);-ms-transition:all .33s cubic-bezier(.685,.0473,.346,1);transition:all .33s cubic-bezier(.685,.0473,.346,1)}.off-canvas-menu .navbar-collapse ul{position:relative;z-index:3;overflow-y:auto;height:100%}.off-canvas-menu .navbar-collapse:after{top:0;left:0;height:100%;width:100%;position:absolute;background-color:#282828;display:block;content:"";z-index:1}.off-canvas-menu .navbar-header{float:none}.off-canvas-menu .navbar-header .collapse,.off-canvas-menu .navbar-toggle{display:block!important}.nav-open.off-canvas-menu .navbar .container,.nav-open.off-canvas-menu .wrapper-full-page{left:0;-webkit-transform:translate3d(-260px,0,0);-moz-transform:translate3d(-260px,0,0);-o-transform:translate3d(-260px,0,0);-ms-transform:translate3d(-260px,0,0);transform:translate3d(-260px,0,0)}.navbar-nav>li{float:none;position:relative;display:block}.card .card-header.card-header-text,.fileinput{display:block}.navbar-form .form-group{margin-bottom:0}.table-responsive{border:none}.modal-small{width:auto;margin-left:15px;margin-right:15px}}@media (min-width:992px){.table-full-width{margin-left:-20px;margin-right:-20px}.table-responsive{overflow:auto}}@media (max-width:490px){.nav-center .nav-pills-icons{max-width:211px}}[class*=col-]{padding-left:15px;padding-right:15px}.col-sp-5,[class*=col-]{position:relative;min-height:1px}.col-sp-5{padding:10px}@media (min-width:500px){.col-sp-5{width:50%;float:left}}@media (min-width:768px){.col-sp-5{width:33%;float:left}}@media (min-width:1279px){.col-sp-5{width:25%;float:left}}@media (min-width:1570px){.col-sp-5{width:20%;float:left}}.login-page .container-fluid{position:absolute;top:50%;transform:translateY(-21px);width:100%}.login-page .content{padding-top:0}.login-page .content .btn{text-transform:none;font-size:28px}.login-page .content .btn img{height:36px;margin-right:5px;margin-top:-5px}.login-page .content .btn span{line-height:36px}.login-page form .card-login .card-content{padding:0 10px}.login-page form .card-login .btn{text-transform:none;margin:10px 50%;transform:translateX(-50%)}.login-page form .card-login .btn span{padding-right:5px;font-weight:600;font-size:22px}.currency-title{margin-bottom:40px}.chart-wrapper{display:block;outline:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.separation{margin-bottom:40px}.pac-container{z-index:11111}.top_buttons_body{padding:0;position:absolute;top:16px;left:90px;z-index:1100;display:flex;display:-ms-flexbox}.top_buttons_body .search{border-radius:30px;background-color:#fff;box-shadow:0 4px 5px 0 hsla(0,0%,60%,.14),0 1px 10px 0 hsla(0,0%,60%,.12),0 2px 4px -1px hsla(0,0%,60%,.2);max-width:350px;display:inline-block;margin-right:5px;align-self:flex-start;min-width:246px}.top_buttons_body .form-group{display:inline-block;margin:0;float:right;padding:0 10px 0 0}.top_buttons_body .form-group .form-control{background-image:none;height:44px;font-size:14px}.top_buttons_body .btn{margin:0;font-size:24px}.top_buttons_body:first-child .btn{margin-right:20px;align-self:flex-start}.top_buttons_body .text-help{display:inline-block;margin-left:5px;color:#9e9e9e;margin-top:5px}@media (max-width:1130px){.top_buttons_body{flex-wrap:wrap}.top_buttons_body .text-help{margin-top:10px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}}@media (max-width:991px){.search .form-group.form-search .form-control{width:160px}}@media (max-width:768px){.navbar-left{display:none}.top_buttons_body{left:20px;width:auto;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex}.top_buttons_body .text-help{display:none}.search .form-group.form-search .form-control{width:130px}.top_buttons_body .form-group{float:inherit}}@media (max-width:500px){.top_buttons .create-icon{position:relative;top:0;left:0}.top_buttons_body:first-child .btn{margin-right:5px}.top_buttons_body .search{min-width:inherit}}@media (max-width:350px){.top_buttons_body .form-group{width:135px}}.agent-card .card{width:225px;height:190px}.agent-card .card:hover{box-shadow:0 14px 26px -12px hsla(0,0%,60%,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px hsla(0,0%,60%,.2);will-change:box-shadow,transform;transition:box-shadow .2s cubic-bezier(.4,0,1,1),background-color .2s cubic-bezier(.4,0,.2,1)}.agent-card .card img{border-radius:3px}.agent-card .card .card-header{padding:0;width:70px;height:70px}.agent-card .card .card-header i{font-size:36px;line-height:70px;width:70px;height:70px}.agent-card .card .card-content{text-align:left;padding:10px 0;height:56px}.agent-card .card .card-content p{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right:10px;cursor:pointer;color:#be6b33;font-weight:700}.agent-card .card .card-footer{border:none}.agent-card .card .card-footer div{display:block}.agent-card .card .card-footer .row{margin-bottom:8px}.agent-card .card .card-footer .row .card-title{color:#999;width:70px;display:inline-block}.agent-card .card .card-footer .row .card-info{padding-left:7px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.agent-modal .header{width:50%;height:40px;padding-top:7px;padding-left:20px;background-color:#fff7ee;float:left;margin:-20px 0 0 29px;box-shadow:2px 3px 2px #f1f1f1;border-radius:5px}.agent-modal .default-image{background-color:orange;width:150px;height:150px;border-radius:10px;box-shadow:0 3px 6px rgba(0,0,0,.16)}.agent-modal .default-image i{font-size:150px;color:#fff}.agent-modal .avatar{width:inherit;height:inherit;border-radius:5px}.agent-modal form{padding:20px 20px 0}.agent-modal .position{padding-left:30px}.agent-modal .form-horizontal .checkbox-inline{margin:0 15px 15px 0}.agent-modal .row_quick_order{position:absolute;margin-left:-30px;top:40px;width:780px}.agent-modal .select2-container--default .select2-selection--single{border:none;border-bottom:1px solid #d2d2d2}.agent-modal button{font-weight:700}@media (max-width:991px){.agent-modal .default-image{width:120px;height:120px;margin-bottom:0;margin-top:15px}.agent-modal .default-image i{font-size:120px}.agent-modal .row_quick_order{width:730px}}@media (max-width:767px){.agent-modal .row_quick_order{width:auto;margin-right:0;margin-left:calc(50% - 145px)}.agent-modal .customer-card{margin-top:40px}.agent-modal .modal-close-btn{margin-right:0;margin-top:0;z-index:2000;box-shadow:none}.agent-modal .default-image{margin-top:0}.agent-modal .position{padding-left:0}.agent-modal .card-content .row:nth-child(3){margin-top:20px}.agent-modal .card-content .btn-light-orange{padding:10px 13px}.agent-modal .card-content .btn-primary{padding:10px 20px}.agent-modal .line-form{padding-top:20px}}@media (max-width:550px){.agent-card{text-align:center}.agent-card .card{text-align:left}.agent-modal.aafee-change-modal .header{width:auto}}@media (max-width:500px){.create-icon{position:absolute;top:-58px;left:140px}.agent-modal .header{width:70%}}body{background-color:#fafafa;color:#000;cursor:default;overflow:hidden}.main-panel{background:#fafafa;overflow-y:scroll}.nav-center{margin-bottom:10px}.navbar-nav>li{margin:5px 10px}.navbar .notification{right:-5px;top:0}.icon-grey{color:#9e9e9e}.icon-green{color:#4caf50}.icon-orange{color:#e07e3c}.btn-green-style{border:3px solid #4caf50!important}.amazon-management .top_buttons_body .nav .btn-green-style .dropdown-toggle:after,.btn-green-style .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.btn-green-style .material-icons{color:#4caf50}.btn-yellow-style{border:3px solid #fbc02d!important}.amazon-management .top_buttons_body .nav .btn-yellow-style .dropdown-toggle:after,.btn-yellow-style .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.btn-yellow-style .material-icons{color:#fbc02d}.btn-red-style{border:3px solid #eb5757!important}.amazon-management .top_buttons_body .nav .btn-red-style .dropdown-toggle:after,.btn-red-style .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.btn-red-style .material-icons{color:#eb5757}.btn-orange{background-color:#e07e3c;box-shadow:0 2px 4px rgba(74,74,74,.21);border:1px solid #f2f2f2}.btn-orange:active,.btn-orange:active:focus,.btn-orange:active:hover,.btn-orange:focus,.btn-orange:hover{background-color:#e07e3c;box-shadow:0 4px 8px #702d00}.text-white{color:#fff!important}.edited{top:-30px;right:-40px;color:#fff;display:block;position:absolute;text-align:center;text-decoration:none;background-color:#e07e3c;padding:20px 30px 0;-webkit-transform:rotate(-45deg) scale(1);transform:rotate(45deg) scale(1);z-index:10}.amazon-management .top_buttons_body .nav .edited .dropdown-toggle:after,.edited .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.edited .material-icons{transform:rotate(227deg);margin-left:12px;font-size:16px;margin-top:14px}.edited span{margin-bottom:-5px;display:block}.brand{color:#e07e3c}.amazon-management .top_buttons_body .nav .btn.btn-round-mini .dropdown-toggle:after,.btn.btn-round-mini .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.btn.btn-round-mini .material-icons{font-size:14px}.btn.btn-round-mini.btn-just-icon{padding:6px 2px 4px}.btn-light-orange{color:#e07e3c}.btn-light-orange:active,.btn-light-orange:active:focus,.btn-light-orange:active:hover,.btn-light-orange:focus,.btn-light-orange:hover{background-color:#fff7ee;color:#e07e3c}.lighter .form-group label{color:hsla(0,0%,62%,.38)}.color-primary{color:#e07e3c}.off-canvas-sidebar .logo-img img,.sidebar .logo-img img{width:140px;top:inherit;left:inherit;position:relative}.btn-white-orange,.btn-white-orange:active,.btn-white-orange:active:focus,.btn-white-orange:active:hover,.btn-white-orange:focus,.btn-white-orange:hover{background-color:#fff;color:#e07e3c}.btn-balck-white,.btn-balck-white:active,.btn-balck-white:active:focus,.btn-balck-white:active:hover,.btn-balck-white:focus,.btn-balck-white:hover{background-color:#000;color:#fff}.btn-wide{padding:10px 60px}.btn-dark-orange{font-weight:700}.btn-dark-orange,.btn-dark-orange:active,.btn-dark-orange:active:focus,.btn-dark-orange:active:hover,.btn-dark-orange:focus,.btn-dark-orange:hover{background-color:#e07e3c;color:#fff}.btn-md-orange{font-weight:700}.btn-md-orange,.btn-md-orange:active,.btn-md-orange:active:focus,.btn-md-orange:active:hover,.btn-md-orange:focus,.btn-md-orange:hover{background-color:#ffe4c7;color:#e07e3c}.blur-content{-webkit-filter:blur(5px);-moz-filter:blur(5px);-ms-filter:blur(5px);-o-filter:blur(5px);filter:blur(5px)}.paginate_button{cursor:pointer}.panel-group{margin-bottom:0}.modal-close-icon{font-size:21px!important;padding:8px;color:grey}.modal-close-btn{margin-right:-50px;margin-top:-1px}.card-content .category{font-style:normal;font-weight:700;line-height:21px;font-size:16px!important}.text-black{color:#333}.bordered{border:1px solid #e5e5e5;box-sizing:border-box;border-radius:5px}.card-footer .card-title{font-style:normal;font-weight:700;line-height:normal;font-size:14px;color:#000}.text-italic-gray{color:#9e9e9e;font-style:italic;font-size:14px;font-weight:400}.btn-light-orange{background-color:#fff7ee;color:#e49158;font-weight:700}.mobile-show{display:none}.form-group .help-block{text-transform:none}.amazon-management .top_buttons_body .nav .btn .dropdown-toggle:after,.amazon-management .top_buttons_body .nav .navbar .navbar-nav>li>a .dropdown-toggle:after,.btn .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.btn .material-icons,.navbar .navbar-nav>li>a .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.navbar .navbar-nav>li>a .fa,.navbar .navbar-nav>li>a .material-icons{font-size:24px}.btn.btn-just-icon i,.navbar .navbar-nav>li>a.btn.btn-just-icon i{width:24px}.btn.btn-just-icon,.navbar .navbar-nav>li>a.btn.btn-just-icon{font-size:24px;padding:10px 11px}.btn-no-styles{padding:0!important;box-shadow:none!important}.btn-no-styles i{margin:0!important}.btn-no-styles:hover{box-shadow:none!important}@media (max-width:991px){.navbar-nav{position:absolute;top:11px}}.pointer{cursor:pointer}.disabled{cursor:not-allowed!important}@media (min-width:992px){.modal-lg{width:750px}}.form-group.label-floating.is-focused label.control-label,.form-group.label-floating:not(.is-empty) label.control-label{font-size:14px;font-weight:700}.form-group.label-floating label.control-label{font-weight:700}.form-group.label-static label.control-label{font-size:14px;font-weight:700}.form-group.label-placeholder label.control-label{font-weight:700}.select2-type .form-group.label-floating:not(.is-empty) label.control-label{top:-7px}.select2-type .form-group.select-is-open.label-floating:not(.is-empty) label.control-label{top:-28px}.nav-pills>li>a{color:#9e9e9e;cursor:pointer}.sidebar .logo{padding-left:60px}.line-form{padding-top:10px}.disabled *{color:#9e9e9e!important;cursor:not-allowed}.disabled:hover a{background-color:transparent!important}.form-group .select2-container--default .select2-selection--single{border:0!important;background-image:linear-gradient(#e07e3c,#e07e3c),linear-gradient(#d2d2d2,#d2d2d2);background-size:0 2px,100% 1px;background-repeat:no-repeat;background-position:bottom,50% calc(100% - 1px);background-color:transparent;transition:background 0s ease-out;float:none}.form-group.has-error .select2-container--default .select2-selection--single{border-bottom:none!important;background-image:linear-gradient(#f44336,#f44336),linear-gradient(#d2d2d2,#d2d2d2);background-size:100% 2px,100% 1px;transition-duration:.3s}.select2-container--default.select2-container--disabled .select2-selection--single{background-color:transparent!important}.select2-container--default.select2-container--disabled .select2-selection--single .select2-selection__arrow{display:none!important}.loader,.loader:after,.loader:before{border-radius:50%;width:2.5em;height:2.5em;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:load7 1.8s infinite ease-in-out;animation:load7 1.8s infinite ease-in-out}.loader{color:#fff;font-size:10px;margin:15px auto;position:relative;text-indent:-9999em;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{content:"";position:absolute;top:0}.loader:before{left:-3.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:3.5em}@-webkit-keyframes load7{0%,80%,to{box-shadow:0 2.5em 0 -1.3em}40%{box-shadow:0 2.5em 0 0}}@keyframes load7{0%,80%,to{box-shadow:0 2.5em 0 -1.3em}40%{box-shadow:0 2.5em 0 0}}input[type=number]{-moz-appearance:textfield;-webkit-appearance:textfield}@media (max-width:991px){.sidebar .sidebar-wrapper{background:#fff}.navbar-header .navbar-toggle{margin-top:8px}}@media (max-width:768px){.mobile-show{display:block}.modal .modal-dialog{margin-top:30px}.col-sp-5 .card{margin:15px 0}}.spinner-container{height:100px}.agent-modal .custom-tooltip{left:15px}.custom-tooltip{position:absolute;top:30px;left:10px}@media (max-width:767px){.agent-modal .custom-tooltip{top:0}}@media (max-width:390px){.checkbox-inline:last-child{margin-left:0}}.readonly{pointer-events:none}.location-card .card{width:225px;height:210px}.location-card .card:hover{box-shadow:0 14px 26px -12px hsla(0,0%,60%,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px hsla(0,0%,60%,.2);will-change:box-shadow,transform;transition:box-shadow .2s cubic-bezier(.4,0,1,1),background-color .2s cubic-bezier(.4,0,.2,1)}.location-card .card img{border-radius:3px}.location-card .card .icon-orange{color:#eb843f}.location-card .card .edit-button{top:-25px;margin-right:30px}.location-card .card .card-header{padding:0;width:70px;height:70px}.location-card .card .card-header i{font-size:36px;line-height:70px;width:70px;height:70px}.location-card .card .card-content{text-align:left;padding:10px 0;height:56px}.location-card .card .card-content p{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right:10px;cursor:pointer;color:#eb843f;font-weight:700}.location-card .card .card-footer{border:none}.location-card .card .card-footer ul li{height:27px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.location-card .card .card-footer ul li .card-title{color:#eb843f;width:70px;display:inline-block;font-weight:700}.location-card .card .card-footer ul .card-text-description{height:43px;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;-webkit-box-orient:vertical;display:block;display:-webkit-box;margin:0 auto;white-space:normal;margin-bottom:10px}.location-modal .header{width:50%;height:40px;padding-top:7px;padding-left:20px;background-color:#fff7ee;float:left;margin:-20px 0 0 29px;box-shadow:2px 3px 2px #f1f1f1;border-radius:5px}.location-modal .card-content .btn{margin:0}.location-modal .card-content .zip{line-height:40px}@media (max-width:767px){.location-modal .customer-card{margin-top:40px}.location-modal .row-btn{display:block}.location-modal .modal-close-btn{margin-right:0;margin-top:0;z-index:2000;box-shadow:none}.location-modal .btn-primary{padding:10px 20px}}@media (max-width:550px){.location-card{text-align:center}.location-card .card{text-align:left}}.customer-card .card{width:225px;height:200px;cursor:pointer}.customer-card .card:hover{box-shadow:0 14px 26px -12px hsla(0,0%,60%,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px hsla(0,0%,60%,.2);will-change:box-shadow,transform;transition:box-shadow .2s cubic-bezier(.4,0,1,1),background-color .2s cubic-bezier(.4,0,.2,1)}.customer-card .card img{border-radius:3px}.customer-card .card .card-header{padding:0;width:70px;height:70px}.customer-card .card .card-header i{font-size:36px;line-height:70px;width:70px;height:70px}.customer-card .card .card-content{text-align:left;padding:10px 0;height:56px;position:relative;overflow:hidden;border-radius:5px}.customer-card .card .card-content p{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right:10px;cursor:pointer;color:#be6b33;font-weight:700}.customer-card .card .card-footer{border:none;text-align:left}.customer-card .card .card-footer div{display:block}.customer-card .card .card-footer .row{margin-bottom:8px}.customer-card .card .card-footer .row .card-title{color:#999;width:75px;display:inline-block;word-wrap:break-word}.customer-card .card .card-footer .row .commercial{color:#999;width:auto;display:inline-block;font-weight:700}.customer-card .card .card-footer .row .card-info{padding-left:7px}.customer-card .card .card-footer .row .big-info{height:40px;overflow:hidden;word-wrap:break-word}.customer-card .card .card-footer .card-text-address{height:40px!important;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;-webkit-box-orient:vertical;display:block;display:-webkit-box;margin:0 auto;white-space:normal}.modal-content .modal-footer{position:relative}.top_buttons_right{right:75px;left:inherit}.top_buttons_right .btn{margin-right:10px}.customer_top_buttons{z-index:1030}.row-btn{display:flex;display:-webkit-flex;align-items:center;-webkit-align-items:center}.payment_process{padding:0 20px}.payment_responce_block{padding-bottom:25px;text-align:center;font-size:18px;line-height:1.5}.payment_responce_block h4{color:#e07e3c;font-weight:700;margin-bottom:25px}.loader.customer_model_loader{top:-25px;color:#e07e3c}.customer-modal .request-card-wrapper{display:flex;align-items:center}.customer-modal .request-card-wrapper .cc-link-wrapper{width:40%;position:relative;margin-left:auto}.customer-modal .request-card-wrapper .cc-link-wrapper__title{font-weight:700;position:absolute;left:0;top:-22px;color:#aaa;font-size:14px}.customer-modal .request-card-wrapper .cc-link{width:100%;overflow:hidden;white-space:nowrap;border:1px solid silver;border-radius:4px;padding:10px;position:relative}.customer-modal .request-card-wrapper .cc-link-copy-button{padding:15px 0 10px 10px;cursor:pointer}.customer-modal .cc_request_wrapper button{width:100%;padding-left:0;padding-right:0;text-align:center;text-transform:capitalize}.customer-modal .cc_request_wrapper .loader{color:#e07e3c;top:-26px}.customer-modal .modal-title{text-transform:uppercase}.customer-modal .header{width:50%;height:40px;padding-top:7px;padding-left:20px;background-color:#fff7ee;float:left;margin:-20px 0 0 29px;box-shadow:2px 3px 2px #f1f1f1;border-radius:5px}.customer-modal .default-image{background-color:orange;width:150px;height:150px;border-radius:10px;box-shadow:0 3px 6px rgba(0,0,0,.16)}.customer-modal .default-image i{font-size:150px;color:#fff}.customer-modal form{padding:20px 20px 0}.customer-modal .row_quick_order{position:absolute;margin-left:-30px;top:40px;width:780px}.customer-modal .line-form{padding-top:10px}.customer-modal .card-bottom-row{margin-bottom:15px}.customer-modal .card-bottom-row .left-input{margin-right:-30px;padding-right:45px}.customer-modal .card-bottom-row .right-input{padding-right:45px;margin-right:-31px}@media (max-width:768px){#customer-management .main-content.calculator{margin-top:0;padding-top:0}.top_buttons_right{right:-5px;left:inherit;top:71px}}@media (max-width:991px){.customer-modal .default-image{width:120px;height:120px;margin-bottom:0;margin-top:15px}.customer-modal .default-image i{font-size:120px}.customer-modal .row_quick_order{width:730px}}@media (max-width:767px){.customer-modal .row_quick_order{width:auto;margin-right:0;margin-left:calc(50% - 145px)}.customer-modal .customer-card{margin-top:40px}.customer-modal .modal-close-btn{margin-right:0;margin-top:0;z-index:2000;box-shadow:none}.customer-modal .default-image{margin-top:0}.customer-modal .position{padding-left:0}.customer-modal .card-content .row-btn{margin-top:20px;display:block}.customer-modal .card-content .btn-light-orange{padding:10px 13px}.customer-modal .card-content .btn-primary{padding:10px 20px}.customer-modal .line-form{padding-top:20px}}@media (max-width:550px){.customer-card{text-align:center}.customer-card .card{text-align:left}}@media (max-width:500px){.create-icon{position:absolute;top:-58px;left:140px}.customer-modal .header{width:70%}}.card.quick-order-details{position:relative;background-color:#fff;width:230px;height:auto;display:block;padding-bottom:10px;margin-bottom:10px}.card.quick-order-details .card-title{color:#999;font-weight:700}.card.quick-order-details .quick-card-title{color:#be6b33}.card.quick-order-details .green{color:#4caf50}.card.quick-order-details .card.quick-order-details-margin{margin-top:70px}.order-column-modal .card-content .btn{margin:5px 1px}.order-column-modal .checkbox{margin-top:5px;margin-bottom:5px}.order-column-modal .close{opacity:1}.order-column-modal .btn-container-flex{justify-content:flex-end;-webkit-justify-content:flex-end;align-items:center;-webkit-align-items:center;display:flex;display:-ms-flexbox}.order-column-modal .checkbox label{display:flex;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex}.order-column-modal span.label-text{line-height:23px}.checkbox input[type=checkbox]:checked~.label-text{color:#000}.edit-filters-modal .date-picker-inner .form-control{text-align:center}.edit-filters-modal .date-picker-inner .form-control:focus{border:none;box-shadow:none}@media (min-width:500px){.edit-filters-modal .modal-dialog,.order-column-modal .modal-dialog{margin:30px auto}.edit-filters-modal .modal-sm,.order-column-modal .modal-sm{width:400px}}@media (max-width:767px){.edit-filters-modal .modal-content .modal-body,.order-column-modal .modal-content .modal-body{padding-top:40px}.edit-filters-modal .customer-modal .card-content .btn-primary,.order-column-modal .customer-modal .card-content .btn-primary{padding:0}}.spinner,.spinner:after,.spinner:before{background:grey;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.spinner{color:grey;text-indent:-9999em;margin:88px auto;position:relative;font-size:11px;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.spinner:after,.spinner:before{position:absolute;top:0;content:""}.spinner:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.spinner:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{box-shadow:0 0;height:4em}40%{box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{box-shadow:0 0;height:4em}40%{box-shadow:0 -2em;height:5em}}.opacity-background{background:hsla(0,0%,96%,.55)}.bold{font-weight:700}.small-header{padding:0 20px!important}.calculator-product-form .panel-collapse{padding-left:30px;padding-right:30px}.btn-email{width:auto;padding:12px;font-size:11px}.nav-pills>li+li{margin-left:5px}.nav-pills>li{margin-bottom:10px}.wizard-card[data-color=cyan] .radio input[type=radio]:checked~.check{border-color:#e07e3c;background-color:#e07e3c}.public-calc .nav-center{margin-top:10px}.calculator .add-padding{padding-right:50px}.calculator .red-shadow{box-shadow:0 3px 6px #f44336!important}.calculator .red-background{background:rgba(244,67,54,.3)!important}.calculator .calc-tab{overflow:hidden;background:#fff7ee;box-shadow:0 3px 6px rgba(0,0,0,.16);border-radius:5px;padding:13px 30px;margin:10px auto;font-weight:700;height:100px}.calculator .calc-tab-info{height:75px;overflow:hidden;padding:16px 0}.calculator .calc-tab .title{color:#e07e3c}.calculator .calc-tab span.title{display:inline-block;margin-right:7px}.calculator .calc-tab .percent{display:inline-block;color:#9e9e9e;font-size:12px}.calculator .calc-tab .cost-dropdown a{color:#000}.calculator .calc-tab .bs-dropdown{line-height:36px;border:0;background-image:linear-gradient(#e07e3c,#e07e3c),linear-gradient(#d2d2d2,#d2d2d2);background-size:0 2px,100% 1px;background-repeat:no-repeat;background-position:bottom,50% calc(100% - 1px);background-color:transparent;transition:background 0s ease-out}.calculator .calc-tab .bs-dropdown.disabled span{color:#000!important}.calculator .calc-tab .cost{display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center;overflow:hidden}.calculator .calc-tab .cost .currency{padding:0;width:50%}.calculator .calc-tab .cost .form-group{margin-top:0;padding-bottom:0;margin-left:10px}.calculator .calc-tab .cost .form-group .form-control{text-align:center;color:#e07e3c;font-weight:700}.calculator .calc-tab .cost .dropdown-menu{padding-bottom:5px;left:15px;right:15px;background:#fff7ee;margin-top:-3px;box-shadow:0 3px 6px rgba(0,0,0,.16);border-top-left-radius:0;border-top-right-radius:0}.calculator .calc-tab .cost .clearance-options{display:flex;align-items:center;margin-bottom:10px}.calculator .calc-tab .cost .clearance-options .form-group{margin:0}.calculator .calc-tab .cost .clearance-options .form-group .form-control{height:30px;color:#000}.calculator .calc-tab select.form-control{font-weight:600}.calculator .calc-tab .form-control:focus{border:none;box-shadow:none}.calculator .calc-tab .edited{top:-44px;right:-72px}.calculator .small-tab-row .big-title .calc-tab.small-tab .title{padding-right:0;padding-left:0}.calculator .calc-tab.small-tab{min-height:130px;height:auto}.calculator .calc-tab.small-tab .title{overflow:hidden;height:42px;margin-bottom:15px;padding-right:25px;padding-left:25px}.calculator .btn.mail{margin-right:30px}.calculator .nav-pills>li i{display:inline-block;float:left;font-size:50px;padding-right:15px}.calculator .nav-pills>li i.nav-pills-warning>li.active>a{background-color:#fff7ee}.calculator .nav-pills>li.active>a{background-color:#ffe4c7}.calculator .nav-pills.nav-pills-warning>li.active>a{background-color:#ffe4c7;color:#dc7732;font-weight:600}.calculator .nav-pills.nav-pills-warning>li:nth-child(3)>a>.tab-info{padding-right:50px}.calculator .nav-pills.nav-pills-warning>li:first-child>a>.tab-info{padding-right:0}.calculator .tab-info{text-align:left;padding-left:10px;padding-right:20px;font-size:16px;text-transform:none}.calculator .nav-pills.nav-pills-warning>li>a{width:225px;height:100px;border-radius:10px;display:-webkit-flex;display:flex;align-items:center;-webkit-align-items:center}.calculator .wizard-card[data-color=cyan] .radio input[type=radio]:checked~.circle{border-color:#e07e3c}.calculator .card .card-header{padding-left:30px}.calculator [tab].total{display:inline-block;padding-right:20px;font-weight:700;color:#e49158;font-size:17px}.calculator .btn-close .btn{margin:0 1px}.calculator .products{padding-left:0;padding-right:0;padding-top:30px}.calculator .order-summary .panel.card.panel-default,.calculator .products .panel.card.panel-default{margin-top:0}.calculator .order-summary{padding-left:0;padding-right:0;padding-top:20px}.calculator .panel-heading.card-header{background-color:#fff7ee;box-shadow:0 3px 10px 1px #bfbfbf}.calculator .accordion-open .panel-heading{background-color:#fff;box-shadow:none;margin:0;border-bottom:none}.calculator .accordion-open .panel-heading .row.product{padding:0;margin-bottom:0}.calculator .product-items{margin:0}.calculator .product{padding:0 0 10px}.calculator .product .index{font-weight:700;color:#e07e3c}.calculator .product .details{margin-top:10px}.calculator .card .tabs{margin:0 30px;margin-top:-41px;border-radius:5px;display:flex;display:-ms-flexbox;display:-webkit-flex}.calculator .card .tabs .simple-tab{padding:12px;cursor:pointer;box-shadow:0 3px 6px rgba(0,0,0,.16);border-radius:3px;border-top-right-radius:0;border-bottom-right-radius:0;background:#f5f5f5;color:#9e9e9e;transition:all .3s;width:auto;min-width:150px;text-align:center}.calculator .card .tabs .second-tab{border-radius:3px;border-top-left-radius:0;border-bottom-left-radius:0}.calculator .card .tabs .simple-tab.active-tab,.calculator .card .tabs tab.active-tab{background:#e07e3c;color:#fff}.calculator .card.tariff{background-color:#fafafa;box-shadow:none;border-radius:0;margin:10px 0}.calculator .card .card-header .card-title{margin-top:-5px;font-size:14px}.calculator .card .card-header-text{display:block}.calculator .card [data-background-color]{background-color:#fff7ee;width:300px;height:40px;border-radius:10px;box-shadow:0 3px 6px rgba(0,0,0,.16)}.calculator .card [data-background-color] .card-title{color:#000}.calculator .card .bg-light-grey{background-color:#fafafa}.calculator .card .bg-light-grey .card-title{color:#e07e3c;font-size:14px}.calculator .card .form-horizontal .radio{padding:0}.calculator .card .select2-container--default .select2-selection--single{border:none;border-bottom:1px solid #d2d2d2}.calculator .card .add-more{margin-right:20px}.calculator .card .card-content.fees{padding-bottom:0}.calculator .card .card-content .row{margin-bottom:10px}.calculator .card .card-content .row.product{margin-bottom:0}.calculator .card .card-content .row.first-row{margin-bottom:-9px}.calculator .card .card-content .product-card-info .percent-area{display:flex;justify-content:center;align-items:center}.amazon-management .top_buttons_body .nav .calculator .card .card-content .product-card-info .percent-area .dropdown-toggle:after,.calculator .card .card-content .product-card-info .percent-area .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.calculator .card .card-content .product-card-info .percent-area .material-icons{color:#aaa;font-size:20px;padding-left:5px}.calculator .card .card-content .product-card-info .percent-input{width:100%}.calculator .card .card-content .product-card-info .col-xs-5{padding:0 10px}.calculator .card .card-content .product-card-info .currency-row{padding:0 5px 0 10px}.calculator .card .card-content .product-card-info .right-row{padding:0 10px 0 5px}.calculator .card .card-content .product-card-info .col-xs-7{line-height:30px}.calculator .card .card-content .product-card-info .bg-grey{background:#f5f5f5;line-height:30px}.calculator .alert.alert-success{box-shadow:1px 3px 4px 0 #d3d3d3;height:120px;color:#000;background-color:#fff7ee}.calculator .alert.alert-success.thin{height:70px}.calculator .order-summary{padding-bottom:0}.calculator .order-summary .card-padding{margin-top:10px;width:calc(100% - 30px);padding-left:15px}.calculator .order-summary .card .no-btm-margin{margin-bottom:0}.calculator .order-summary .card .no-btm-padding{padding-bottom:0}.calculator .order-summary .index{font-weight:700;color:#e07e3c}.calculator .order-summary .order-info{margin-bottom:10px}.calculator .order-summary .btn.btn-fab.btn-fab-mini{height:24px;min-width:24px;width:24px;margin-top:-5px}.calculator .order-summary .panel-heading{box-shadow:none;background-color:inherit;border-bottom:2px solid #ffe4c7;padding:0;margin:15px 30px 0}.calculator .order-summary .panel.card.panel-default{box-shadow:none}.calculator .order-summary .btn-orange-small{height:30px;min-width:30px;width:30px}.calculator .panel-group .panel-heading+.panel-collapse>.list-group,.calculator .panel-group .panel-heading+.panel-collapse>.panel-body{border-top:none}.calculator .panel.card{margin:0}.calculator .accordion-error .panel-heading.card-header{background-image:linear-gradient(#f44336,#f44336),linear-gradient(#d2d2d2,#d2d2d2);background-size:100% 3px,100% 1px;transition-duration:.3s;background-repeat:no-repeat;background-position:bottom,50% calc(100% - 1px);transition:background 0s ease-out;float:none}.calculator .calc-tab-btn button{display:block;width:184px;margin:10px auto}.calculator .calc-tab-btn .new_style{width:auto;font-weight:500;font-size:14px}.calculator .calc-tab-btn .loader.colored{color:#e07e3c;top:-19px}.calculator .form-group .help-block{width:100%}.calculator .public-btns .btn{width:215px;padding:10px 0;display:block;margin:10px auto}.calculator .text-area-long textarea::-webkit-input-placeholder{overflow:hidden;height:20px}.calculator textarea:-moz-placeholder,.calculator textarea::-moz-placeholder{overflow:hidden;height:20px}.calculator textarea:-ms-input-placeholder{overflow:hidden;height:20px}.calculator .grand-total{line-height:1.4em}.clear-product-select{position:absolute;top:10px;right:-5px;font-size:20px;color:#888;margin-right:5px;transition:all .5s;font-weight:700;font-style:normal;cursor:pointer}.clear-product-select:hover{color:#000}.short-description{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.short-description.text-italic-gray{color:#9e9e9e;font-style:italic;font-size:14px;font-weight:400}.canad-calc .calc-info-row-container .card-row:nth-child(2n) .product-card-info,usa-calc-tab .calc-info-row-container calc-info-row:nth-child(2n) .product-card-info{background:#fafafa}.canad-calc .calc-info-row-container .card-title{color:#e07e3c;font-size:14px}@media (max-width:1225px){.calculator .nav-pills.nav-pills-warning>li>a{width:150px;height:80px}.calculator .nav-pills>li i{padding-right:0;padding:5px 0}.calculator .tab-info{padding-left:0;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.calculator .nav-pills.nav-pills-warning>li:nth-child(3)>a>.tab-info{padding-right:0}}@media (max-width:1199px){.calculator .calc-tab{padding:13px 10px}.calculator .calc-tab .edited{top:-42px;right:-60px}.calculator .calc-tab.small-tab{padding:13px 20px}}@media (max-width:1100px){.calculator .products{padding-top:5px}.calculator .card .tabs.long-tabs{margin:10px 0 0;width:100%;float:none!important}.calculator .card .tabs.long-tabs .simple-tab{width:50%;min-width:auto}}@media (max-width:991px){.calculator .calc-tab-btn button,.calculator .public-btns .btn{display:inline-block;margin:10px}.calculator .vehicles .form-group{margin-top:0}}@media (max-width:767px){.mobile-hide{display:none}.calculator .public-btns .pay{text-align:center}.calculator .public-btns .pay button{float:none!important}}@media (max-width:768px){.calculator .form-horizontal .control-label{padding-top:8px}.calculator .card .add-more{margin-right:50%;-webkit-transform:translateX(50%);-moz-transform:translateX(50%);-ms-transform:translateX(50%);-o-transform:translateX(50%);transform:translateX(50%)}.calculator .card.tariff{margin-top:10px}}@media (max-width:670px){.calculator .tab-info{display:none}.calculator .nav-pills.nav-pills-warning>li>a{width:auto;height:70px;min-width:0}.calculator .nav-pills>li i{font-size:40px}.calculator .currency{padding-left:5px}.calculator .card .card-header{padding-left:20px}.calculator .calculator-product-form .panel-collapse{padding-left:20px;padding-right:20px}.calculator .products{padding-top:5px}.calculator .card .tabs{margin:10px 0 0;width:100%;float:none!important}.calculator .card .tabs .simple-tab{width:50%;min-width:auto}}@media (max-width:490px){.calculator .nav-center .nav-pills-icons{max-width:none}.calculator .card .card-content .row.product{margin-bottom:0}.row.product .col-xs-1,.row.product .col-xs-2,.row.product .col-xs-4,.row.product .col-xs-5{padding-right:5px;padding-left:5px}.row.product .btn{margin:0}.row.product .btn-close{padding-right:5px}.calculator .calc-tab .cost .currency{width:40%}.calculator .calc-tab.small-tab .title{padding-right:0;padding-left:0}}.disclaimer-block{line-height:1.1}@media (max-width:350px){.calculator .nav>li>a{padding:10px}.calculator .card [data-background-color]{width:auto}}.order-card .card{width:225px;height:250px;cursor:pointer}.order-card .card:hover{box-shadow:0 14px 26px -12px hsla(0,0%,60%,.42),0 4px 23px 0 rgba(0,0,0,.12),0 8px 10px -5px hsla(0,0%,60%,.2);will-change:box-shadow,transform;transition:box-shadow .2s cubic-bezier(.4,0,1,1),background-color .2s cubic-bezier(.4,0,.2,1)}.order-card .card img{border-radius:3px}.order-card .card .card-header{padding:0;width:70px;height:70px}.order-card .card .card-header i{font-size:36px;line-height:70px;width:70px;height:70px}.order-card .card .card-content{text-align:left;padding:10px 0;height:56px}.order-card .card .card-content p{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right:10px;cursor:pointer;color:#be6b33;font-weight:700}.order-card .card .card-footer{border:none}.order-card .card .card-footer ul li{height:20px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.order-card .card .card-footer ul li .card-title{color:#999;width:70px;display:inline-block}.order-card .card .card-footer ul li .quick-card-title{color:#be6b33;width:70px;display:inline-block}.order-card .card .card-footer ul .card-text-address{height:40px!important;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;-webkit-box-orient:vertical;display:block;display:-webkit-box;margin:0 auto;white-space:normal}.order-data{margin-top:30px}.order-data .left-tab-card{cursor:pointer;margin:5px 0;border-radius:0}.order-data .advanced-doc-selector .center-block .btn{padding:10px 0}.order-data .advanced-doc-selector .row.row-doc{margin-left:-10px;margin-right:-10px}.order-data .advanced-doc-selector .card{margin-top:30px}.order-data .advanced-doc-selector .card .card-header{padding-bottom:10px}.order-data .advanced-doc-selector .doc-check{margin-top:-1px}.order-data .center-block{margin-top:-8px}.order-data .center-block .card{margin-bottom:10px;margin-top:13px}.order-data .center-block .advanced-doc-selector .card{margin-top:30px}.order-data .center-block .btn:not(.modal-close-btn){margin:0}.order-data .center-block .card .card-content{padding:10px}.order-data .right-block .card{margin-top:5px;margin-bottom:10px;padding-bottom:15px;padding-top:15px}.order-data .right-block .btn{margin:0}.order-data .right-block .card .file-selector{min-height:190px}.order-data .card .card-content{padding:11px 10px 11px 15px}.order-data .card .card-content .row{margin-bottom:0}.order-data .card .icon-grey{color:#9e9e9e}.order-data .card .icon-green{color:#4caf50}.order-data .card .icon-orange{color:#e07e3c}.order-data .card .icon-white{color:#fff}.order-data .card .left-tab{display:flex;display:-webkit-flex;align-items:center;-webkit-align-items:center}.order-data .card .left-tab .left-tab-text{line-height:28px}.order-data .card .left-tab i{margin-right:15px}.order-data .card .central-title{font-size:larger;color:#e07e3c;font-style:normal;font-weight:700;line-height:normal}.order-data .card .card-header{padding-top:10px}.order-data .card .file-selector{min-height:185px;list-style-type:none;height:185px;padding-left:0;margin-bottom:0}.order-data .card .file-selector li{margin-bottom:10px;cursor:pointer;display:flex;display:-webkit-flex;font-size:14px}.order-data .card .file-selector li i{font-size:18px;margin-right:10px}.order-data .card .file-selector li span:not(.check){word-wrap:break-word;width:calc(100% - 45px)}.order-data .upload-button{color:#e07e3c;padding:0}.order-data .upload-button label{margin-bottom:0;padding:10px 60px;cursor:pointer}.order-data .complete-button{color:#fff!important;width:220px}.order-data .left-tab-selected{background-color:#e07e3c;color:#fff}.order-data textarea{resize:none;height:100%;width:100%;min-height:195px;background-color:#fff7ee;border-radius:10px;border-color:#ffe7ce;padding:10px}.order-data .advanced-doc-selector label.upload-button.btn.btn-white{padding:5px 6px;color:#333}.order-data .advanced-doc-selector .new-document-dropdown{position:relative}.order-data .advanced-doc-selector .card .card-header{height:auto}.order-data .advanced-doc-selector .bs-dropdown{background:#fff;padding:5px 4px 5px 9px;border-radius:10px;box-shadow:0 4px 5px 0 hsla(0,0%,60%,.14),0 1px 10px 0 hsla(0,0%,60%,.12),0 2px 4px -1px hsla(0,0%,60%,.2)}.amazon-management .top_buttons_body .nav .order-data .advanced-doc-selector .bs-dropdown .dropdown-toggle:after,.order-data .advanced-doc-selector .bs-dropdown .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.order-data .advanced-doc-selector .bs-dropdown .material-icons{font-size:20px}.order-data .advanced-doc-selector .bs-dropdown .material-icons:before{content:"keyboard_arrow_down"}.order-data .advanced-doc-selector .dropdown-menu{margin-top:-1px;box-shadow:0 6px 12px rgba(0,0,0,.1);color:#333;width:130px;min-width:0;padding:5px;border-radius:10px;border-top-left-radius:0;border-top-right-radius:0}.order-data .advanced-doc-selector .bs-dropdown.open{border-bottom-left-radius:0;border-bottom-right-radius:0}.amazon-management .top_buttons_body .nav .order-data .advanced-doc-selector .bs-dropdown.open .dropdown-toggle:after,.order-data .advanced-doc-selector .amazon-management .top_buttons_body .nav .bs-dropdown.open .dropdown-toggle:after,.order-data .advanced-doc-selector .bs-dropdown.open .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.order-data .advanced-doc-selector .bs-dropdown.open .material-icons{font-size:20px}.order-data .advanced-doc-selector .bs-dropdown.open .material-icons:before{content:"keyboard_arrow_up"}.order-data .advanced-doc-selector .file-selector .checkbox{margin-top:0;margin-bottom:0}.order-data .advanced-doc-selector .file-selector li{align-items:baseline}@media (max-width:1260px){.order-data .center-block .btn:not(.modal-close-btn),.order-data .right-block label{padding:10px 25px}.order-data .right-block .complete-button{width:150px;padding:10px 0}}@media (max-width:350px){.order-data .center-block .btn{padding:10px 15px}}.order-details ul{top:100px;position:absolute;padding:0;left:50%;-webkit-transform:translate(-50%);-moz-transform:translate(-50%);-ms-transform:translate(-50%);-o-transform:translate(-50%);transform:translate(-50%);width:calc(100% - 30px);border-radius:8px;-webkit-box-shadow:0 0 5px rgba(0,0,0,.16);box-shadow:0 0 5px rgba(0,0,0,.16)}.order-details ul,.order-details ul li{display:flex;display:-webkit-flex;justify-content:center;-webkit-justify-content:center}.order-details ul li{list-style:none;width:16.66%;background:#f5f5f5;height:70px;align-items:center;-webkit-align-items:center;color:#9e9e9e;text-align:center;padding:0 30px;position:relative;font-size:12px;line-height:20px}.order-details ul li .number{font-size:36px;margin-right:15px;margin-left:20px}.order-details ul li:before{position:absolute;z-index:10;right:-27px;content:"";border-top:36px solid transparent;border-left:27px solid #eee;border-bottom:36px solid transparent}.order-details ul li:after{position:absolute;z-index:10;right:-24px;content:"";border-top:35.5px solid transparent;border-left:25px solid #f5f5f5;border-bottom:35.5px solid transparent}.order-details ul li:last-child:after,.order-details ul li:last-child:before{content:"";border-left:0 solid #eee}.order-details ul li:first-child{border-top-left-radius:8px;border-bottom-left-radius:8px}.order-details ul li.passed{background:#f5fff6;color:#4caf50;font-weight:700}.order-details ul li.passed:after{border-left:25px solid #f5fff6;right:-24px}.order-details ul li:last-child.in-progress:after,.order-details ul li:last-child.passed:after{content:"";border-left:0 solid}.order-details ul li.in-progress{background:#e07e3c;color:#fff}.order-details ul li.in-progress:after{border-left:26px solid #e07e3c;right:-25px}.product-name{max-height:63px;word-wrap:break-word;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.order-id{color:#e07e3c;position:absolute;top:65px;left:50%;text-transform:uppercase;font-weight:700;font-size:24px;-webkit-transform:translate(-50%);-moz-transform:translate(-50%);-ms-transform:translate(-50%);-o-transform:translate(-50%);transform:translate(-50%)}.order-id .order-title{color:#9e9e9e;text-transform:none;font-weight:400;margin-right:7px}@media (max-width:768px){.main-content.order-details-content{margin-top:70px;padding-bottom:70px}.order-details .mobile-hide{display:none}.order-details .order-id{top:27px;left:50%}.order-details .order-info .col-xs-4{padding:0}.order-details ul{position:fixed;top:calc(100% - 50px);left:0;z-index:20;width:100%;transform:none}.order-details ul li{padding:0;height:50px;box-shadow:0 1px 4px 0 rgba(0,0,0,.14)}.order-details ul li .number{font-size:20px;margin-right:0;margin-left:15px}.order-details ul li.in-progress:after,.order-details ul li.in-progress:before,.order-details ul li.passed:after,.order-details ul li.passed:before,.order-details ul li:after,.order-details ul li:before{content:"";border-left:0 solid}.order-details ul li:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.order-id{top:70px;left:30px;transform:none;margin-right:50px;font-size:18px;text-align:center;width:90%}}@media (max-width:550px){.card.quick-order-details{display:inline-block}}@media (max-width:670px){.product-name{white-space:inherit}}.order-table-view .ngx-datatable.material{text-align:center;box-shadow:0 4px 5px 0 hsla(0,0%,60%,.14),0 1px 10px 0 hsla(0,0%,60%,.12),0 2px 4px -1px hsla(0,0%,60%,.2);border-radius:5px}.order-table-view .ngx-datatable.material .datatable-header .datatable-header-cell .datatable-header-cell-wrapper{font-size:16px;font-weight:700;text-align:center}.order-table-view ngx-datatable.material .datatable-header{box-shadow:0 4px 5px 0 hsla(0,0%,60%,.14),0 1px 10px 0 hsla(0,0%,60%,.12),0 2px 4px -1px hsla(0,0%,60%,.2);background:#fff7ee}.order-table-view ngx-datatable.material .datatable-header .datatable-header-cell{color:#000;border:none;line-height:40px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;flex-grow:1}.order-table-view .ngx-datatable.fixed-row .datatable-scroll .datatable-body-row:hover{cursor:pointer}.order-table-view .ngx-datatable .datatable-body .datatable-scroll{width:100%;max-width:100%}.order-table-view .ngx-datatable.scroll-vertical .datatable-body{overflow-x:hidden;overflow-y:scroll;max-height:calc(100vh - 200px)}.order-table-view .ngx-datatable .datatable-row-center{justify-content:center;-webkit-justify-content:center}.order-table-view .ngx-datatable .datatable-header .datatable-header-cell .datatable-header-cell-template-wrap{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;text-align:center}.order-table-view .ngx-datatable.material .datatable-header .datatable-header-cell{text-align:left;padding:.9rem .7rem}.order-table-view .datatable-body-cell-label{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;text-align:center}.order-table-view .ngx-datatable.material .datatable-body-cell,.order-table-view .ngx-datatable.material .datatable-header{border:none}.order-table-view .ngx-datatable.material .datatable-body .datatable-body-row .datatable-body-cell{padding:.9rem .7rem;line-height:32px}.order-table-view .ngx-datatable.material .datatable-body{border:none;border-top:none}.order-table-view .ngx-datatable.material.single-selection .datatable-body-row.active{background-color:#e0e0e0;color:#fff}.amazon-management .top_buttons_body .nav .order-table-view .dropdown-toggle:after,.order-table-view .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.order-table-view .material-icons{font-size:32px}.order-table-view .tooltip-inner{padding:10px;min-width:90px}@media only screen and (min-height:1200px){.order-table-view .ngx-datatable.scroll-vertical .datatable-body{max-height:1000px}}.hs-code{line-height:36px}@media (max-width:767px){.product-modal form{padding-top:50px}.product-modal .row .col-sm-6:nth-child(2){margin-top:50px}}.select2-container--default .select2-selection--single{border:none!important;border-bottom:1px solid #d2d2d2!important;border-radius:0!important}.select2-container--default .select2-selection--single .select2-selection__rendered{color:#444!important}.select2-container--default .select2-results__option[aria-selected=true]{background-color:#ffe4c7!important;color:#000!important}.select2-container--default .select2-search--dropdown .select2-search__field{border-color:#d2d2d2!important}.select2-container--default .select2-selection--multiple{border:1px solid #d2d2d2!important;border-right:none!important;border-left:none!important;border-top:none!important;border-radius:0!important}.select2-container--default .select2-selection--multiple .select2-selection__clear,.select2-container--default .select2-selection--single .select2-selection__clear{font-size:20px;line-height:33px;color:#888;margin-right:5px;transition:all .5s}.select2-container--default .select2-selection--multiple .select2-selection__clear:hover,.select2-container--default .select2-selection--single .select2-selection__clear:hover{color:#000}.select2-container--default .select2-results__option--highlighted[aria-selected]{background-color:#ffe4c7!important;color:#000!important}.select2-container--open .select2-dropdown--below{border-radius:0!important;border-color:#d2d2d2!important}.select2-container--default .select2-selection--single .select2-selection__clear{font-size:20px;line-height:33px;color:#888;margin-right:5px;transition:all .5s}.select2-container--default .select2-selection--single .select2-selection__clear:hover{color:#000}.select2-container .select2-selection--single .select2-selection__rendered{padding-left:0!important}.select2-container--default.select2-container--disabled .select2-search--inline .select2-search__field,.select2-container--default.select2-container--disabled .select2-selection--multiple,.select2-container--default.select2-container--disabled .select2-selection--single{cursor:not-allowed!important}.select2-results .select2-results__option{padding:6px 31px;font-family:Montserrat;color:#323232;font-style:normal;font-weight:500;font-size:14px;position:relative}.select2-results .select2-results__option:after{content:"";position:absolute;height:1px;width:calc(100% - 42px);left:21px;bottom:0;background:#eaeaea}.select2-container--default .select2-results__option--highlighted[aria-selected]{background-color:#fff!important;color:#e07e3c!important}@media (max-width:768px){.select2-results .select2-results__option{padding:6px 10px}.select2-results .select2-results__option:after{left:0;widt:100%}}.thin-tab{height:50px!important;text-align:center;padding-top:12px!important}.thin-tab .tab-info{text-align:center;padding-left:0;padding-top:0}.thin-tab i{padding-right:0!important}.report.main-content{margin-top:35px}.report .card-content{padding:35px 25px 30px 30px}.report .nav-center{position:absolute;margin-bottom:0;z-index:10;margin-top:5px;width:calc(100% - 15px);text-align:center}.report .nav-pills>li i{padding:0}.report .nav-pills>li+li{margin-left:0}.report .nav-pills>li>a{font-size:14px;border-radius:inherit;background:#f5f5f5;color:#9e9e9e;transition:all .3s}.report .thin-tab{height:40px!important;padding-top:9px!important}.report .nav{border-radius:5px}.report .nav li{text-transform:uppercase;cursor:pointer;box-shadow:0 3px 6px rgba(0,0,0,.16);margin-bottom:0;width:170px}.report .nav li:first-child{border-radius:5px;border-top-right-radius:0;border-bottom-right-radius:0}.report .nav li:last-child{border-radius:5px;border-top-left-radius:0;border-bottom-left-radius:0}.report .nav li.active a{background:#e07e3c;color:#fff}.report .nav .second-tab{border-radius:3px;border-top-left-radius:0;border-bottom-left-radius:0;margin-left:-4px}.report .rns-header-row{align-items:flex-end;top:-65px;z-index:10000;display:grid;grid-template-columns:230px repeat(3,min-content);column-gap:20px;width:90%;left:65px}.report .rns-header-row .col-status{justify-self:center;min-width:300px}.report .rns-header-row .col-calendar{padding-bottom:5px}.report .rns-header-row .col-calendar ::ng-deep .report .calendar .mydrp{width:220px!important}.report .rns-header-row .form-group select{appearance:auto}.report .rns-header-row .mydrp .selection,.report .rns-header-row .mydrp .selectiongroup{background-color:transparent}.report .rns-header-row .mydrp .btnpicker{background:transparent}.report .datatable-custom .ngx-datatable.fixed-row .datatable-scroll .datatable-body-row .datatable-body-cell,.report .datatable-custom .ngx-datatable.material .datatable-body{border:0}.report .datatable-custom .ngx-datatable.material .datatable-header{border:0;box-shadow:0 4px 5px 0 hsla(0,0%,60%,.14),0 1px 10px 0 hsla(0,0%,60%,.12),0 2px 4px -1px hsla(0,0%,60%,.2);background:#fff7ee}.report .datatable-custom .ngx-datatable.material .datatable-header .datatable-header-cell{border:0}.report .datatable-custom .ngx-datatable.material .datatable-header .datatable-header-cell .datatable-header-cell-wrapper{font-size:16px;font-weight:700;text-align:center}.report .calendar{position:relative;margin-bottom:20px;margin-top:10px}.report .calendar .calendar-icon-left{position:absolute;top:7px;right:20px;z-index:10;cursor:pointer}.report .calendar .calendar-icon-right{position:absolute;top:7px;right:0;z-index:10;cursor:pointer}.report .calendar .title{text-align:right;padding-right:45px;line-height:40px;color:#9e9e9e}.report .calendar .mydrp{border:none;border-radius:0}.report .calendar .mydrp .selection{display:table-cell;position:absolute;width:175px;margin:0 40px;padding:0;text-overflow:ellipsis;border-bottom:1px solid #d2d2d2;border-radius:0;color:#757575}.report .calendar .mydrp .selector:focus{border:1px solid #d2d2d2}.report .calendar .mydrp .selectorarrow:focus:before{border-bottom-color:#d2d2d2}.report .calendar .mydrp .selbtngroup{float:left}.report .calendar .mydrp .btnclear{display:none}.report .calendar .mydrp .btnpicker{color:#e07e3c}.report .calendar .mydrp .btnpicker:focus{background:transparent}.report .calendar .mydrp .btnpickerenabled:hover{background-color:inherit}.report .calendar .mydrp .header{margin-bottom:0}.report .calendar .mydrp .range{background-color:#ffe4c7}.report .calendar .mydrp .selecteddaybegin,.report .calendar .mydrp .selecteddayend{background-color:#e07e3c;color:#fff}.report .combined .select-agents{padding-left:15px}.report .combined .select-agents i{left:-25px;top:0}.report .combined .select2-container{margin-top:-10px}.report .select-agents{padding-left:50px}.report .select-agents i{color:#e07e3c;position:absolute;left:15px;top:10px;font-size:20px}.report .select-agents i.circle-icon{left:10px;top:13px;position:absolute}.report .select2-container--default.select2-container--focus .select2-selection--multiple,.report .select2-container--default .select2-selection--multiple{max-height:55px;min-height:55px;height:auto;overflow-y:scroll;-webkit-overflow-scrolling:touch}.report .select2-container--default .select2-selection--multiple .select2-selection__rendered{line-height:28px}.report .select2-container--default .select2-selection--multiple .select2-selection__choice{background-color:#fafafa;border-radius:0;border:none;width:100%;padding:8px;box-shadow:0 0 1px rgba(0,0,0,.25);color:#e07e3c;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;position:relative;padding-left:35px;padding-right:25px}.report .select2-container--default .select2-selection--multiple .select2-selection__clear{cursor:pointer;float:right;font-weight:700;margin-top:0;margin-right:0;position:absolute;left:-15px;top:3px}.report .select2-container--default .select2-selection--multiple .select2-selection__choice__remove{color:#9e9e9e;margin-left:2px;right:10px;position:absolute}.report-title{font-style:normal;font-weight:400;line-height:normal;font-size:26px;text-align:center;color:#9e9e9e}@media (max-width:989px){.report .calendar .mydrp .btnpicker{text-align:left;padding-left:2px}.report .calendar .mydrp .selection{margin-left:35px}.report .report-title{font-size:20px}}@media (max-width:767px){.report .combined .select2-container{margin-top:10px}.report .select2-container--default .select2-selection--multiple{max-height:100%!important}.report .combined .select-agents i:not(.circle-icon){left:0;top:20px}.report .combined .select-agents{padding-left:45px}.report .select2-container--default.select2-container--focus .select2-selection--multiple,.report .select2-container--default .select2-selection--multiple{overflow-y:visible}.report .select2-container--default .select2-selection--multiple .select2-selection__choice{width:auto;margin-bottom:1px}}@media (max-width:770px){.report .mydrp .caltable{width:auto}}@media (max-width:670px){.report .tab-content{min-width:635px}.report .wizard-container{overflow-x:scroll}}@media (max-width:550px){.report .nav-center{width:auto}.report .nav-center .nav-pills-icons{max-width:none}.report .nav li{width:auto}.report .report-title{text-align:left}}@media (max-width:350px){.report .nav li a{min-width:0;padding:10px 8px}}.dashboard .charts .card-header{background:#fff7ee;height:40px;border-radius:10px;box-shadow:0 3px 6px rgba(0,0,0,.16)}.dashboard .charts .card-title{color:#000;margin-top:-5px;text-transform:uppercase;font-size:14px}.fixed-header{width:100%;top:0;left:0;background:#fff;z-index:100}.fixed-header.quote-page{position:fixed;width:calc(100% - 8px)}.fixed-header .header{padding-top:25px;padding-bottom:0}.fixed-header .header .logo{width:270px}.fake-header{height:120px;width:100%;display:none;background:#fff}.fake-header.quote-page{display:block}.public-calc-v2{font-family:Montserrat,sans-serif;background:#fff;color:#e07e3c}.public-calc-v2 .ps.ps--active-x>.ps__scrollbar-x-rail{display:none}.public-calc-v2 .item_desc_block{display:flex;align-items:center;justify-content:center}.public-calc-v2 .item_desc_block form{width:100%}.public-calc-v2 .item_desc_block .form-control{padding:24px 10px;width:100%;background:#fff;color:#242021}.public-calc-v2 .row.no-gutter [class*=col-]{padding-left:0!important;padding-right:0!important}.public-calc-v2 .result-wrapper{border:2px solid #e07e3c;padding-left:15px;padding-right:15px;position:relative;margin-bottom:50px}.public-calc-v2 .new-input-wrapper form{width:292px}.public-calc-v2 .new-input-wrapper .btn{border:0;padding:0;color:#242021}.public-calc-v2 .new-input-wrapper .btn+.btn{margin-top:30px}.public-calc-v2 .new-input-wrapper .btn:hover{background:#e07e3c}.public-calc-v2 .new-input-wrapper .btn:hover .form-control{color:#242021}.public-calc-v2 .new-input-wrapper .btn .form-control{padding:24px 10px;width:100%;background:#fff;color:#242021}.public-calc-v2 .new-input-wrapper .form-group.has-error .help-block{color:#fff}.public-calc-v2 .price-block{display:flex;justify-content:center;align-items:center;background:#e07e3c}.public-calc-v2 .price-block .btn{background:#fff;cursor:auto;padding:12px 30px}.public-calc-v2 .price-block .btn .form-control{color:#242021}.public-calc-v2 .price-block .btn:hover{background:#fff;color:#242021}.public-calc-v2 .price-block .btn:hover .form-control{color:#242021}.public-calc-v2 .price-block .btn-arrow{color:#fff;text-transform:uppercase;font-weight:700;font-size:44px;position:relative;background:transparent;border:0}.public-calc-v2 .price-block .btn-arrow.active:after{content:"";position:absolute;width:30px;height:30px;background:url(assets/tick.bed9a0b9e01abf979483fa1e9dd4777d.svg);background-repeat:no-repeat;background-size:contain;top:50%;margin-top:-15px}.public-calc-v2 .price-block .btn-arrow.active.usd:after{right:-30px}.public-calc-v2 .price-block .btn-arrow.active.cad:after{left:-30px}.public-calc-v2 .manufacturer .form-group{display:flex;align-items:center;justify-content:center}.public-calc-v2 form .btn:hover{background:#e07e3c}.public-calc-v2 .textarea-description .form-group.has-error .help-block{color:#fff;bottom:-7px}.public-calc-v2 .textarea-description.btn:hover .form-control{color:#000}.public-calc-v2 .textarea-description .form-group{display:flex;align-items:center;justify-content:center;flex-direction:column;padding:55px 0}.public-calc-v2 .textarea-description .form-group textarea{width:40%;background:#fff;color:#000;padding:14px 15px}.public-calc-v2 .col-md-4 .select2-container{background:#fff;width:80%!important}.public-calc-v2 .select2-container{background:#fff;width:60%!important}.public-calc-v2 *{outline:none}.public-calc-v2 .container{overflow:hidden}.public-calc-v2 .main-wrapper .main{margin-top:20px}.public-calc-v2 .bg-brand-prymary{background:#e07e3c}.public-calc-v2 .d-flex{display:flex!important}.public-calc-v2 .flex-row{flex-direction:row!important}.public-calc-v2 .flex-wrap{flex-wrap:wrap}.public-calc-v2 .justify-content-center{justify-content:center!important}.public-calc-v2 .align-items-center{align-items:center!important}.public-calc-v2 .w-100{width:100%!important}.public-calc-v2 .header{display:flex;align-items:center;flex-wrap:wrap;color:#000}.public-calc-v2 .header a{color:#000}.public-calc-v2 .footer{color:#a5a5a5}.public-calc-v2 .footer .social-icon{display:flex;align-items:center;justify-content:center}.public-calc-v2 .footer .social-icon a{margin-left:22px;margin-right:22px}.public-calc-v2 .footer .social-icon a img{width:30px}.public-calc-v2 .footer .line{height:1px;margin-bottom:20px}.public-calc-v2 .footer .all-rights{display:flex;align-items:center}.public-calc-v2 .footer .all-rights a{color:#a5a5a5}.public-calc-v2 .footer .all-rights a:hover{text-decoration:none}.public-calc-v2 .footer .all-rights>div{position:relative;padding-right:10px;margin-right:10px}.public-calc-v2 .footer .all-rights>div:after{content:"";position:absolute;width:1px;height:12px;background:#a5a5a5;top:50%;right:0;margin-top:-6px}.public-calc-v2 .footer .all-rights>div:last-child:after{display:none}.public-calc-v2 .footer .bottom-line{display:flex;align-items:center;justify-content:space-between}.public-calc-v2 .small-form .btn{padding:42px 88px}.public-calc-v2 .small-form .btn .form-control{background:#fff;padding:20px 10px;color:#242021}.public-calc-v2 .small-form .btn .form-group.has-error .help-block{color:#fff}.public-calc-v2 .small-form .btn:hover .form-control{color:#242021}.public-calc-v2 .progress{background:#e5e5e5;height:2px;position:absolute;left:50%;top:115px;width:100%;position:fixed;max-width:1170px;margin-left:-585px;z-index:100;overflow:visible}.public-calc-v2 .progress:after,.public-calc-v2 .progress:before{content:"";position:absolute;left:0;width:100%;height:37px;background:#fff}.public-calc-v2 .progress:after{top:2px}.public-calc-v2 .progress:before{top:-37px}.public-calc-v2 .progress .progress-bar,.public-calc-v2 .progress .progress-bar.progress-bar-default{background:#e07e3c}.public-calc-v2 .tab-content{min-height:320px}.public-calc-v2 .line{height:2px;background:#e5e5e5;margin-top:20px}.public-calc-v2 .logo{font-weight:900;font-size:36px;line-height:50px;margin-top:30px}.public-calc-v2 .logo-img{height:60px}.public-calc-v2 .middle{font-size:24px;font-weight:700}.public-calc-v2 .middle,.public-calc-v2 .small{line-height:30px;display:block;margin:20px 0 40px}.public-calc-v2 .small{font-size:18px;font-weight:400}.public-calc-v2 .btn{width:100%;font-size:22px;border:.5px solid #fff;background:#e07e3c;line-height:16px;box-shadow:none;overflow:hidden;position:relative;margin:0;border-radius:0}.public-calc-v2 .btn:before{content:"";position:absolute;background-size:contain;background:url(assets/rect.9641db9d73bb9b38a4553c4d9c61625a.svg);background-repeat:no-repeat;background-position:100% 0;height:30px;width:30px;right:.5px;top:.5px}.public-calc-v2 .btn.continue:before .public-calc-v2 .btn.back:before{display:none}.public-calc-v2 .btn:active:focus,.public-calc-v2 .btn:hover{background:#c75b28;color:#fff}.public-calc-v2 .btn:hover{box-shadow:none}.public-calc-v2 .btn:hover .form-control{color:#fff}.public-calc-v2 .btn:hover .form-control::-webkit-input-placeholder{color:#a5a5a5}.public-calc-v2 .btn:hover .form-control::-moz-placeholder{color:#a5a5a5}.public-calc-v2 .btn:hover .form-control::placeholder{color:#a5a5a5}.public-calc-v2 .btn.no-hover:hover{background:#e07e3c}.public-calc-v2 .btn.no-triangle:before{display:none}.public-calc-v2 .btn.size-1{padding:54px 20px;max-height:125px}.public-calc-v2 .btn.size-2{font-size:50px;padding:109px 10px}.public-calc-v2 .btn.size-2.smaller-font{font-size:38px}.public-calc-v2 .btn.size-3{font-family:Montserrat;font-style:normal;font-weight:700;font-size:15px;padding:20px 0}.public-calc-v2 .height-size-2{min-height:234px}.public-calc-v2 .btn.active{background:#c75b28;color:#fff;box-shadow:none;outline:none}.public-calc-v2 .btn.active:hover{color:#fff;outline:none}.public-calc-v2 .btn-wide{width:100%;padding:15px 20px}.public-calc-v2 form-input.btn-wide{padding:11.5px 20px}.public-calc-v2 .btn-orange:active,.public-calc-v2 .btn-orange:active:focus,.public-calc-v2 .btn-orange:active:hover,.public-calc-v2 .btn-orange:focus,.public-calc-v2 .btn-orange:hover{background:#e07e3c;box-shadow:0 2px 4px rgba(74,74,74,.21)}.public-calc-v2 .btn-white.active{color:#e07e3c;box-shadow:0 4px 8px #702d00}.public-calc-v2 .btn-white-orange.disabled,.public-calc-v2 .btn-white-orange[disabled]{background:#fff;opacity:1;color:#333;box-shadow:0 2px 4px rgba(74,74,74,.21);cursor:pointer!important}.public-calc-v2 .btn-white-orange.continue:hover{background:transparent;color:#fff;box-shadow:none}.public-calc-v2 .title{display:flex;height:auto;text-align:center;justify-content:center;align-items:center;color:#e07e3c;font-size:29px;font-weight:700;margin:0;margin-top:60px;margin-bottom:0;line-height:30px}.public-calc-v2 price-tab-v2 .title{margin-bottom:20px}.public-calc-v2 .title.small-title{height:40px;line-height:40px}.public-calc-v2 .note{margin-top:10px;color:#a5a5a5;margin-bottom:44px;font-size:15px;font-weight:500}.public-calc-v2 .btn-small{width:30%;padding:15px 0}.public-calc-v2 .form-group{padding-bottom:0;margin:0}.public-calc-v2 .form-control{height:23px;padding:0;font-size:16px;color:#e07e3c;background-image:none;text-align:center;font-weight:700;line-height:16px}.public-calc-v2 .form-group.is-focused .form-control{background-image:none}.public-calc-v2 .form-control::-webkit-input-placeholder{color:#a5a5a5;font-family:Montserrat;font-style:normal;font-weight:500;font-size:15px;text-transform:none}.public-calc-v2 .form-control::-moz-placeholder{color:#a5a5a5;font-family:Montserrat;font-style:normal;font-weight:500;font-size:15px;text-transform:none}.public-calc-v2 .form-control::placeholder{color:#a5a5a5;font-family:Montserrat;font-style:normal;font-weight:500;font-size:15px;text-transform:none}.public-calc-v2 .btn::-webkit-input-placeholder{color:#333;font-size:14px;text-align:center;font-weight:700;text-transform:uppercase}.public-calc-v2 .btn::-moz-placeholder{color:#333;font-size:14px;text-align:center;font-weight:700;text-transform:uppercase}.public-calc-v2 .btn::placeholder{color:#333;font-size:14px;text-align:center;font-weight:700;text-transform:uppercase}.public-calc-v2 .calculator-v2-tab-result .tab-background{height:26px;width:100%;position:fixed;top:64px;left:0;z-index:10;background:#e07e3c}.public-calc-v2 .calculator-v2-tab-result .title{height:auto;display:block;text-align:left;line-height:20px}.public-calc-v2 .calculator-v2-tab-result .title.thanksTab{margin-top:50px;text-align:center!important;padding:20px 10px;font-size:24px;line-height:35px;height:auto;text-overflow:inherit;white-space:inherit}.public-calc-v2 .calculator-v2-tab-result calc-info-row:last-child .product-card-info{position:absolute;width:calc(100% - 30px);bottom:-71px;font-family:Montserrat;font-weight:700;font-size:19px;color:#e07e3c}.public-calc-v2 .calculator-v2-tab-result .product-card-info{padding:13px 15px 9px;border-bottom:1px solid #eaeaea;margin:0;font-size:16px;line-height:24px}.public-calc-v2 .calculator-v2-tab-result .product-card-info [class*=col-xs]{padding:0 5px;text-align:right}.public-calc-v2 .calculator-v2-tab-result .product-card-info .tax-name{text-align:left}.public-calc-v2 .calculator-v2-tab-result .card{box-shadow:none;border-radius:0;color:#737373;background:transparent;margin-top:85px}.public-calc-v2 .calculator-v2-tab-result .card .card-header{border-radius:0;display:flex;align-items:center;justify-content:center;height:150px;border:0;background:#e07e3c}.public-calc-v2 .calculator-v2-tab-result .card span.index{font-size:27px;font-family:Montserrat;font-style:normal;font-weight:700;line-height:30px;color:#fff}.public-calc-v2 .calculator-v2-tab-result .panel .panel-heading i{margin-right:15px;float:right;color:#fff;display:none}.public-calc-v2 .calculator-v2-tab-result .panel-group .panel-heading+.panel-collapse>.list-group,.public-calc-v2 .calculator-v2-tab-result .panel-group .panel-heading+.panel-collapse>.panel-body{border-top:none}.public-calc-v2 .spinner,.public-calc-v2 .spinner:after,.public-calc-v2 .spinner:before{background:#fff;color:#fff}.public-calc-v2 .accordion .panel-body{height:auto;padding:0}.public-calc-v2 .pull-bottom .form-email .btn{color:#fff;padding:11.5px 15px;margin-bottom:10px}.public-calc-v2 .pull-bottom .form-email .form-control{color:#fff}.public-calc-v2 .pull-bottom .form-control::-webkit-input-placeholder{color:#fff;font-weight:400;text-transform:none}.public-calc-v2 .pull-bottom .form-control::-moz-placeholder{color:#fff;font-weight:400;text-transform:none}.public-calc-v2 .pull-bottom .form-control::placeholder{color:#fff;font-weight:400;text-transform:none}.public-calc-v2 .select2-container--default .select2-selection--single .select2-selection__rendered{color:#a5a5a5!important;font-style:normal!important;font-weight:500!important;font-size:15px!important;padding-right:20px!important;text-transform:none}.public-calc-v2 .title.small-title.currency-btn-block{margin-right:-25px;margin-left:-25px;justify-content:space-between;height:auto}.public-calc-v2 .title.small-title.currency-btn-block .btn{padding:0;min-width:75px;height:55px;box-shadow:0 2px 4px rgba(74,74,74,.21);color:#333}.public-calc-v2 .title.small-title.currency-btn-block .btn:hover{color:#fff}.public-calc-v2 .title.small-title.currency-btn-block .btn-light-orange.active{background-color:#fff7ee;color:#e07e3c}.public-calc-v2 .title.small-title.currency-btn-block .btn-light-orange.active:hover{background:transparent;color:#fff}.public-calc-v2 .title.small-title.currency-btn-block .btn-left{border-radius:0 5px 5px 0}.public-calc-v2 .title.small-title.currency-btn-block .btn-right{border-radius:5px 0 0 5px}.public-calc-v2 textarea.form-control{height:auto;background:#fff;color:#242021;padding:15px}.public-calc-v2 form-textarea .btn-wide{padding:15px 25px}.public-calc-v2 form-textarea .form-control{line-height:20px}.amazon-management .top_buttons_body .nav .public-calc-v2 .btn.back .dropdown-toggle:after,.amazon-management .top_buttons_body .nav .public-calc-v2 .btn.continue .dropdown-toggle:after,.public-calc-v2 .btn.back .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.public-calc-v2 .btn.back .material-icons,.public-calc-v2 .btn.continue .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.public-calc-v2 .btn.continue .material-icons{height:16px;line-height:24px}.public-calc-v2 .btn-select-container{display:flex;flex-wrap:wrap;justify-content:center}.public-calc-v2 .btn-select-container .btn:hover{background:#e07e3c}.public-calc-v2 .header-side{position:fixed;width:calc(100% - 8px);z-index:100;left:0;background:#fff;height:100px;top:117px;padding:28px 0}.public-calc-v2 .header-side .container{min-height:0}.public-calc-v2 .header-side .wizard-footer{margin:0 -15px}.public-calc-v2 .header-side .wizard-footer .block-center{margin:0}.public-calc-v2 .header-side .wizard-footer .block-center .btn.get-started{color:#fff;background:#e07e3c}.public-calc-v2 .header-side .wizard-footer .block-center .btn.form-email.custom-from{width:100%}.public-calc-v2 .wizard-footer{margin-top:45px;text-align:center}.public-calc-v2 .wizard-footer .btn-container .btn:before{display:none}.public-calc-v2 .wizard-footer .result{margin-bottom:45px}.public-calc-v2 .wizard-footer .block-center{margin-bottom:50px}.public-calc-v2 .wizard-footer .block-center .quote-send{height:45px;display:flex;align-items:center;justify-content:center;color:#9c9a9a}.public-calc-v2 .wizard-footer .block-center .btn{width:auto;background:transparent;border:1px solid #e07e3c;color:#e07e3c;font-size:15px;padding:13px 40px}.public-calc-v2 .wizard-footer .block-center .btn.customer-padding{padding-left:6px;padding-right:6px;width:100%}.public-calc-v2 .wizard-footer .block-center .btn.back:before,.public-calc-v2 .wizard-footer .block-center .btn.continue:before,.public-calc-v2 .wizard-footer .block-center .btn:before{display:none}.public-calc-v2 .wizard-footer .block-center .btn.form-email{border:1px solid #dfdfdf;color:#dfdfdf;overflow:visible}.public-calc-v2 .wizard-footer .block-center .btn.form-email.custom-from{padding-left:5px;padding-right:5px}.public-calc-v2 .wizard-footer .block-center .btn.form-email.custom-from .form-control::placeholder{font-size:13px}.public-calc-v2 .wizard-footer .block-center .btn.form-email .form-control{color:#242021;height:17px}.public-calc-v2 .wizard-footer .block-center .btn.form-email:hover .form-control{color:#242021}.public-calc-v2 .wizard-footer .block-center form-input.ng-untouched.ng-dirty.ng-invalid{padding-bottom:10px}.public-calc-v2 .wizard-footer .block-center .form-group.has-error .help-block{bottom:-40px}.public-calc-v2 .wizard-footer .btn-container *,.public-calc-v2 .wizard-footer .disabled *{cursor:pointer}.public-calc-v2 .wizard-footer .btn-container{display:inline-block;position:relative;border:1px solid #e07e3c;box-sizing:border-box}.public-calc-v2 .wizard-footer .btn-container .btn,.public-calc-v2 .wizard-footer .btn-container input.back,.public-calc-v2 .wizard-footer .btn-container input.continue{width:auto;background:transparent;text-align:center;font-weight:600;font-size:15px;border:0;text-transform:capitalize;color:#e07e3c;padding:13px 40px}.public-calc-v2 .wizard-footer .btn-container:hover .btn-balck-white.continue{background:transparent;color:#fff;box-shadow:none}.public-calc-v2 .wizard-footer .btn-container i{color:#e07e3c;position:absolute;right:7px;top:50%;margin-top:-12px}.public-calc-v2 .wizard-footer .btn-container.disabled{cursor:pointer!important;border-color:#dfdfdf}.public-calc-v2 .wizard-footer .btn-container.disabled .btn,.public-calc-v2 .wizard-footer .btn-container.disabled input.back,.public-calc-v2 .wizard-footer .btn-container.disabled input.continue{color:#a5a5a5!important;background:transparent}.public-calc-v2 .wizard-footer .btn-container.disabled:hover i,.public-calc-v2 .wizard-footer .btn-container.disabled i{color:#a5a5a5!important}.public-calc-v2 .wizard-footer .btn-container.disabled:hover .btn-balck-white.continue{color:#9e9e9e!important;background:#4d4a48}.public-calc-v2 .wizard-footer .btn.back i,.public-calc-v2 .wizard-footer .btn.back~i{right:inherit;left:7px;transform:rotateY(180deg)}.public-calc-v2 .question{font-size:24px;display:inline-block;line-height:30px}.public-calc-v2 .question-tab form{margin:0 auto}.public-calc-v2 .question-tab .input-email input{background:#fff;padding:10px;height:50px;color:#242021}.public-calc-v2 .question-tab .input-email .form-group.has-error .help-block{color:#fff}.public-calc-v2 .question-tab .form-control::-webkit-input-placeholder{color:#a5a5a5;font-weight:400;text-transform:none;font-style:normal;font-size:18px}.public-calc-v2 .question-tab .form-control::-moz-placeholder{color:#a5a5a5;font-weight:400;text-transform:none;font-style:normal;font-size:18px}.public-calc-v2 .question-tab .form-control::placeholder{color:#a5a5a5;font-weight:400;text-transform:none;font-style:normal;font-size:18px}.public-calc-v2 .question-tab .textarea-container{width:285px;margin:0 auto}.public-calc-v2 .question-tab .textarea-container .form-control{background:#fff;border-radius:20px;text-align:center;color:#000;font-weight:400;padding:10px;line-height:1.42857}.public-calc-v2 .long-currency-text .currency-row{padding:0}.public-calc-v2 .pull-bottom .wizard-footer .btn-container i{top:15px}.form-group.select-2 .select2-container--default .select2-selection--single{background-image:none}.form-group.select-2 .select2-container--default .select2-selection--single .select2-selection__placeholder{color:#a5a5a5;font-style:normal;font-weight:500;font-size:15px;text-transform:none}.ps.ps--active-y>.ps__scrollbar-y-rail{z-index:200}result-tab-v2 .ps>.ps__scrollbar-y-rail>.ps__scrollbar-y{background-color:transparent;z-index:200}result-tab-v2 .ps:hover>.ps__scrollbar-y-rail:hover>.ps__scrollbar-y{background-color:transparent}result-tab-v2 .ps:hover>.ps__scrollbar-y-rail:hover{background-color:transparent;opacity:.9}@media (max-width:991px){.public-calc-v2 .wizard-footer{margin-bottom:25px}.public-calc-v2 .wizard-footer .block-center{margin-bottom:0}.public-calc-v2 .wizard-footer .block-center .col-xs-12{margin-bottom:15px}.public-calc-v2 .wizard-footer .block-center .btn{width:100%}.public-calc-v2 .wizard-footer.result{display:flex;margin-top:0;flex-wrap:wrap}.public-calc-v2 .wizard-footer.result .block-1{order:1;text-align:left;margin-bottom:20px}.public-calc-v2 .wizard-footer.result .block-2{order:3}.public-calc-v2 .wizard-footer.result .block-3{text-align:right;order:2;margin-bottom:20px}}@media (max-width:767px){.public-calc-v2 .title{font-size:18px;line-height:1}.public-calc-v2 .note{margin-top:5px;margin-bottom:5px}.public-calc-v2 .tab-content{min-height:0}.public-calc-v2 .wizard-footer{margin-top:15px}.public-calc-v2 .height-size-2{min-height:0;padding:5px 0}.public-calc-v2 .textarea-description .form-group{padding:21px 0}.public-calc-v2 .result-wrapper{padding-left:0;padding-right:0}.public-calc-v2 .calculator-v2-tab-result .product-card-info{padding-left:7px;padding-right:7px;font-size:11px}.public-calc-v2 .calculator-v2-tab-result calc-info-row:last-child .product-card-info{font-size:14px}.public-calc-v2 .calculator-v2-tab-result .tab-background{display:none}.public-calc-v2 .footer .all-rights{flex-direction:column}.public-calc-v2 .footer .all-rights>div{padding-right:0;margin-right:0}.public-calc-v2 .footer .all-rights>div:after{display:none}.public-calc-v2 .textarea-description.btn{padding:0 10px}.public-calc-v2 .textarea-description .form-group textarea{width:100%}.public-calc-v2 .price-block{flex-direction:column}.public-calc-v2 .price-block .btn-arrow{margin:0;padding:5px 0;font-size:20px}.public-calc-v2 .price-block .btn-arrow.active:after{width:16px;height:16px;margin-top:-8px}.public-calc-v2 .price-block .btn-arrow.active.cad:after{right:-30px;left:auto}.public-calc-v2 .fixed-header{width:100%;top:0;left:0;background:#fff}.public-calc-v2 .header{text-align:center;padding-top:5px!important}.public-calc-v2 .header .text-right{text-align:center}.public-calc-v2 .title{margin-top:0;margin-bottom:0}.public-calc-v2 .value .buttons{max-width:500px;margin:auto}.public-calc-v2 .logo{position:fixed;width:100%;background:#e07e3c;z-index:10;margin-right:-15px;margin-left:-15px;margin-top:0!important}.public-calc-v2 .first-page .logo{position:relative;width:auto;margin-right:0;margin-left:0;margin-top:30px!important}.public-calc-v2 .progress{position:static;margin-bottom:10px;top:60px;z-index:10}.public-calc-v2 .fixed-row{position:fixed;top:64px;background:#e07e3c;z-index:10;padding:20px 0}.public-calc-v2 .calculator-v2-tab-result .card .card-header{width:100%}.public-calc-v2 .calculator-v2-tab-result .title{height:20px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.public-calc-v2 .tab-content.calculator-v2-tab-result{padding:0}.public-calc-v2 .public-calc-v2 .note{margin-bottom:15px}.public-calc-v2 .btn.size-2{font-size:19px;padding:15px 0}.public-calc-v2 .btn.size-1{padding:12px 0;font-size:18px}.public-calc-v2 .btn.size-3{padding:11px 0}.public-calc-v2 .first-page-new .btn.size-1{font-size:11px}.public-calc-v2 .small-form .btn .form-control{padding:13px 10px}.public-calc-v2 .small-form .btn{padding:7px 8px}.public-calc-v2 .new-input-wrapper .btn+.btn{margin-top:5px}}@media (max-width:991px){.public-calc-v2 .form-email .btn{padding:15px}.public-calc-v2 .first-page button:last-child{margin-left:0;display:block}.public-calc-v2 .pull-bottom .wizard-footer .btn-container i{top:10px}.public-calc-v2 .btn-select-container{justify-content:center}.public-calc-v2 .btn-select-container .btn-small,.public-calc-v2 .btn-select-container .form-group.label-floating.select-2{max-width:100%}.public-calc-v2 .btn-select-container_form{width:auto;margin-left:0}}@media (max-width:768px){.public-calc-v2 .btn-select-container .form-group.label-floating.select-2{margin:0;padding:2px 0}.margin-bottom-xs-45{margin-bottom:45px!important}.margin-bottom-xs-0{margin-bottom:0!important}.public-calc-v2 .wizard-footer .block-center .btn.form-email.custom-from{padding:7px 5px}.public-calc-v2 .wizard-footer .block-center .btn.form-email.custom-from .form-control{height:23px}}@media (min-width:768px){.padding-left-md-0{padding-left:0!important}.padding-right-md-0{padding-right:0!important}.width-md-initial{width:auto!important}.public-calc-v2 .container{min-height:100vh}.public-calc-v2 .logo{font-size:50px;font-weight:900;letter-spacing:0;line-height:50px}.public-calc-v2 .title.small-title{height:auto;line-height:30px}.public-calc-v2 .note.text-italic-gray.margin-top-0{margin-top:10px!important}.public-calc-v2 .accordion .panel-body{max-height:inherit}.public-calc-v2 .title.small-title.currency-btn-block{justify-content:center}.public-calc-v2 .title.small-title.currency-btn-block .btn{position:absolute;top:5px}.public-calc-v2 .title.small-title.currency-btn-block .btn-left{left:5px;border-radius:5px}.public-calc-v2 .title.small-title.currency-btn-block .btn-right{right:5px;border-radius:5px}.public-calc-v2 .calculator-v2-tab-result .tab-background{display:none}}@media (min-width:992px){.public-calc-v2 h1.logo{margin-top:30px}.public-calc-v2 .logo{margin-top:0;font-size:70px;line-height:70px}.public-calc-v2 .middle{font-size:34px;font-weight:700;line-height:34px}.public-calc-v2 .small{font-weight:700}.public-calc-v2 .desktop-center{text-align:center}.public-calc-v2 form-input.btn-wide{padding:17.5px 20px}.public-calc-v2 .tab-content{min-height:calc(100vh - 600px)}.public-calc-v2 .btn-small{margin:7px 5px;font-size:14px}.public-calc-v2 .accordion .panel-body{max-height:inherit}.public-calc-v2 .note.text-italic-gray.margin-top-0.year{margin-top:50px!important}.public-calc-v2 .manufacturer .btn{float:right;margin-right:0}.public-calc-v2 .manufacturer .form-group{float:left;margin-left:0}.public-calc-v2 .value form{display:inline}.public-calc-v2 .push-down{margin-bottom:-160px!important}.public-calc-v2 .title.small-title.currency-btn-block{justify-content:center}.public-calc-v2 .title.small-title.currency-btn-block .btn{position:absolute;top:5px}.public-calc-v2 .title.small-title.currency-btn-block .btn-left{left:5px;border-radius:5px}.public-calc-v2 .title.small-title.currency-btn-block .btn-right{right:5px;border-radius:5px}.public-calc-v2 .wizard-footer{text-align:center}}@media (max-width:600px){.public-calc-v2:not(.amazon) .wizard-footer .btn-container.btn-container-full-width{width:100%}.public-calc-v2:not(.amazon) .wizard-footer .btn-container.btn-container-full-width .btn.back~i{left:140px}.public-calc-v2:not(.amazon) .wizard-footer .btn-container.btn-container-full-width .btn.back.back-full-width{padding-right:0}.public-calc-v2:not(.amazon) .wizard-footer .btn-container{min-width:auto}.public-calc-v2:not(.amazon) .wizard-footer .btn-container .btn.back.back-full-width,.public-calc-v2:not(.amazon) .wizard-footer .btn-container .btn.continue.next-full-width{float:inherit;width:100%;margin-left:auto}.public-calc-v2:not(.amazon) .pull-bottom .wizard-footer{position:absolute;bottom:5px;width:calc(100% + 52px);right:0;margin-right:-26px}.public-calc-v2:not(.amazon) .pull-bottom .wizard-footer i{top:15px}.public-calc-v2:not(.amazon) .pull-bottom .wizard-footer .nextButton i{right:7px;line-height:24px;top:10px}.public-calc-v2:not(.amazon) .pull-bottom .wizard-footer .previousButton i{left:7px;top:10px;transform:rotateY(180deg);width:24px;line-height:24px}.public-calc-v2:not(.amazon) .btn-select-container .form-group.label-floating.select-2{margin:0}.public-calc-v2 .panel-body.ps{overflow:initial!important}}@media (hover:none){.public-calc-v2 .title.small-title.currency-btn-block .btn-light-orange.active:hover{background:#fff7ee;color:#e07e3c}}@media screen and (device-aspect-ratio:40/71){body{font-size:16px}}@media screen and (device-aspect-ratio:375/667){body{font-size:16px}}@media screen and (device-aspect-ratio:9/16){body{font-size:16px}}@media (max-width:1200px) and (min-width:991px){.public-calc-v2 .wizard-footer .block-center .btn{font-size:13px}}@media (max-width:1200px){.public-calc-v2 .btn.size-2.smaller-font{font-size:32px}}@media (max-width:600px){.public-calc-v2 .btn.size-2.smaller-font{font-size:21px}}.publick_calc_modal .close{border:transparent!important;border-radius:0!important;box-shadow:none!important;text-shadow:none!important;font-size:40px!important;font-weight:300!important;background-color:transparent!important;color:#000!important;top:10px!important;right:10px!important;width:40px!important;height:40px!important}.publick_calc_modal .modal-title{font-size:32px;font-weight:700}@media (min-width:768px){.d-md-none{display:none!important}.text-md-right{text-align:right!important}.text-md-left{text-align:left!important}.padding-top-md-15{padding-top:15px}}@media (max-width:768px){.d-sm-none{display:none!important}.thanksTab{padding-top:40px}}.wrapper{overflow:auto}@media (max-width:768px){body{background:#fff}}.amazon .page-container,.amazon .tab-content{margin-top:70px}.amazon amazon-general-info{font-size:12px}.amazon .img-landing{max-width:100%;max-height:300px}.amazon-management .top_buttons_body .nav .amazon .watch-bottom-icon .dropdown-toggle:after,.amazon .watch-bottom-icon .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.amazon .watch-bottom-icon .material-icons{font-size:50px}.amazon .carousel-control{display:none}.amazon .btn{font-size:14px}.amazon .title{margin-left:-15px;margin-right:-15px;background:#e9a271;height:70px;box-shadow:0 4px 4px rgba(0,0,0,.25)}.amazon .logo{background:#e57e39;border-bottom:1px solid #f5aa78;text-align:center;padding:0 20px}.amazon .logo-normal{display:inline-block}.amazon .title.small-title{font-size:22px;height:auto;line-height:30px}.amazon .description{color:#fff}.amazon .title-wizard{display:block;height:auto;font-size:24px;text-transform:uppercase;margin-bottom:0;font-weight:900;letter-spacing:1px}.amazon .row.bottom{padding:35px 0;border-top:1px solid #f5aa78}.amazon .row.bottom .btn{margin:0}.amazon .img-sector{text-align:center;margin:20px}.amazon .img-sector img{height:200px}.amazon .img-sector.big-img img{width:100%;height:auto;max-width:500px}.amazon .img-sector.step-5 img{height:100px}.amazon .text-center{text-align:center!important}.amazon .slick-slide{padding:0 5px}.amazon .slick-slide img{display:inline-block}.amazon .slick-dots{bottom:0}.amazon .slick-dots li{position:relative;display:inline-block;width:auto;height:auto;margin:0;padding:0;cursor:pointer}.amazon .slick-dots li button{display:inline-block;width:20px;height:20px;margin:1px 12px;text-indent:-999px;cursor:pointer;background-color:hsla(0,0%,100%,.34);border:none;border-radius:10px}.amazon .slick-dots .slick-active button{width:20px;height:20px;margin:1px 10px;background-color:#fff}.amazon .slick-dots li button:before{content:""}.amazon .wizard-footer .btn-container{margin-bottom:30px}.amazon-management .top_buttons_body .nav .amazon .wizard-footer .btn-container .dropdown-toggle:after,.amazon .wizard-footer .btn-container .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.amazon .wizard-footer .btn-container .material-icons{display:none}.amazon .required .form-control{background-color:rgba(0,0,0,.15)}.amazon .required .form-group.has-error .form-control,.amazon .required .form-group.has-error.is-focused .form-control{background:#c56433;border:1px solid #b10c00}.amazon .form-group{margin:30px 0}.amazon .form-group .help-block{font-size:12px}.amazon .form-control,.amazon .form-group .form-control,.amazon .form-group.is-focused .form-control{text-align:left;color:#fff;background-image:none;font-weight:400;line-height:20px;border:1px solid #fff;border-radius:5px;height:55px;padding:0 18px}.amazon .form-control::-webkit-input-placeholder{color:#fff;font-size:14px;text-align:left;font-weight:400;font-style:normal;font-family:Montserrat,sans-serif;text-transform:capitalize}.amazon .form-control::-moz-placeholder{color:#fff;font-size:14px;text-align:left;font-weight:400;font-style:normal;font-family:Montserrat,sans-serif;text-transform:capitalize}.amazon .form-control::placeholder{color:#fff;font-size:14px;text-align:left;font-weight:400;font-style:normal;font-family:Montserrat,sans-serif;text-transform:capitalize}.amazon-management .top_buttons_body .nav .amazon .btn.continue .dropdown-toggle:after,.amazon .btn.continue .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.amazon .btn.continue .material-icons{height:16px;line-height:16px;transform:translateX(10px)}.amazon .bordered-footer{padding:15px;border:3px solid #fff;border-radius:50px;margin-top:30px;margin-bottom:40px}.amazon .bordered-footer .btn-container{margin-bottom:0}.amazon .bordered-footer .btn-container .btn{width:auto}.amazon .dashboard .btn{line-height:24px;padding:10px 30px;text-align:left;margin-bottom:30px}.amazon-management .top_buttons_body .nav .amazon .dashboard .btn .dropdown-toggle:after,.amazon .dashboard .btn .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.amazon .dashboard .btn .material-icons{margin-right:20px}.amazon .dashboard .btn-container{display:flex;flex-direction:column;height:calc(100vh - 160px);justify-content:space-between}.amazon form-input:first-child .form-group{margin-top:0}.amazon .form-group.has-error .help-block{color:#b10c00}.amazon .amazon-store-products.calculator-v2-tab-result .card .card-header{margin-left:-15px;margin-right:0;position:relative;top:0;margin-top:35px;width:100vw}.amazon .navbar-inner .navbar-right .dropdown-menu{right:0;left:auto}.amazon .navbar-inner .nav .open>a,.amazon .navbar-inner .nav .open>a:focus,.amazon .navbar-inner .nav .open>a:hover{background-color:transparent;border-color:transparent;color:#fff}.amazon .navbar-inner .nav>li>a{color:#fff;padding:0}.amazon .navbar-inner .nav>li>a:focus,.amazon .navbar-inner .nav>li>a:hover{background-color:transparent;border-color:transparent;color:#fff}.amazon-management .top_buttons_body .amazon .navbar-inner .nav>li>a .dropdown-toggle:after,.amazon .navbar-inner .amazon-management .top_buttons_body .nav>li>a .dropdown-toggle:after,.amazon .navbar-inner .nav>li>a .material-icons{font-size:18px;line-height:18px}.amazon .store-content{margin-top:10px}.amazon .store-content .products-count{display:inline-flex}.amazon-management .top_buttons_body .nav .amazon .store-content .products-count .dropdown-toggle:after,.amazon .store-content .products-count .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.amazon .store-content .products-count .material-icons{font-size:18px;line-height:18px;margin-right:10px}.amazon .store-content .store-menu{padding:10px 15px 10px 25px}.amazon .instructions{font-weight:600}.amazon .instructions ul{list-style:none;padding-left:0;text-align:left;padding-bottom:7px}.amazon .instructions ul img{height:auto;margin:10px 0;border-radius:4px;display:block;max-width:800px}.amazon .instructions ul li{padding-bottom:7px}.amazon .instructions li ul{padding-left:40px}.amazon .has-error .form-control{background:#c56433;border:1px solid #b10c00}.amazon .help-block{color:#b10c00;font-size:16px}.amazon .select-all.checkbox .check{border:1px solid #fff;background:#fff;margin-bottom:-3px;margin-right:10px}div#hsEmbeddedWrapper{margin:0 auto}iframe#hsEmbeddedFrame{max-height:600px}.amazon-product-card-container{margin-right:-15px}.amazon-product-card-container .fixed-row{position:relative;top:0;padding:0}.amazon-product-card-container .datatable-body{height:600px;max-height:calc(100vh - 200px);overflow-y:scroll}.amazon-product-card-container .datatable-body-row{border-radius:6px;color:#000;margin-top:0;margin-bottom:5px;display:flex;padding:0}.amazon-product-card-container .datatable-body-cell{padding:10px 0;margin-right:30px}.amazon-product-card-container .datatable-body-cell:first-child{padding-left:20px;margin-right:0}.amazon-product-card-container .datatable-body-cell .datatable-body-cell-label{white-space:inherit;justify-content:center;align-items:center}.amazon-product-card-container .datatable-body-row>div{height:135px;box-shadow:0 1px 4px 0 rgba(0,0,0,.14);background:#fff;border-radius:6px}.amazon-product-card-container .ngx-datatable.fixed-row .datatable-scroll .datatable-body-row .datatable-body-cell{overflow:hidden;white-space:normal;word-break:break-all}.amazon-product-card-container .basic-info{width:100%;height:100%;z-index:10}.amazon-product-card-container .basic-info-item{flex:1 1;position:relative}.amazon-product-card-container .datatable-body-cell-label{display:flex;height:100%;overflow:hidden}.amazon-product-card-container .product-title{flex-grow:2}.amazon-product-card-container .product-image{display:flex;height:100%;width:100%;justify-content:center;align-items:center}.amazon-product-card-container .product-image img{max-height:130px;width:auto}.amazon-product-card-container .selected{background:#fff7ee;position:absolute;width:100%;height:100%;top:0;left:0;border-radius:6px}.amazon-product-card-container .selected-icon{display:none;position:absolute;width:30px;height:30px;border-radius:50%;left:calc(50% - 15px);color:#fff;text-align:center;background:#e07e3c;box-shadow:0 3px 6px rgba(102,57,27,.8)}.amazon-management .top_buttons_body .nav .amazon-product-card-container .selected-icon .dropdown-toggle:after,.amazon-product-card-container .selected-icon .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.amazon-product-card-container .selected-icon .material-icons{line-height:30px;font-size:18px}.amazon-product-card-container .datatable-body-cell:last-child{margin-right:20px}.amazon-product-card-container .ngx-datatable.scroll-vertical .datatable-body{overflow-y:scroll;max-height:calc(100vh - 200px)}.amazon.wrapper{min-height:100vh;background:#e57e39}@media (max-width:992px){.public-calc-v2.amazon .instructions ul img{max-width:100%}}@media (min-width:768px){.public-calc-v2.amazon .tab-content{text-align:center}.public-calc-v2.amazon .page-container{margin-top:10px}.public-calc-v2.amazon amazon-general-info{font-size:14px}.public-calc-v2.amazon .title{text-align:center;margin-bottom:20px}.public-calc-v2.amazon .title.small-title{height:40px;line-height:30px}.public-calc-v2.amazon .logo{margin-top:0}.public-calc-v2.amazon .amazon-store-products.calculator-v2-tab-result .card .card-header{margin-top:0;width:calc(100% + 30px)}.public-calc-v2.amazon .amazon-product-card-container .ngx-datatable.scroll-vertical .datatable-body{max-height:calc(100vh - 380px);margin-left:0}}::-webkit-scrollbar{width:8px;height:8px}::-webkit-scrollbar-track{background:#f1f1f1}::-webkit-scrollbar-thumb{background:#aaa;border-radius:8px}::-webkit-scrollbar-thumb:hover{background:#7a7a7a}@media (min-width:992px){.public-calc-v2.amazon .logo{font-size:50px;font-weight:900;letter-spacing:0;line-height:50px}}@media (max-width:500px){div#hsEmbeddedWrapper{transform:none;padding-left:0;min-width:100%}iframe#hsEmbeddedFrame{min-width:100%}}.document .modal-content .modal-body{padding-right:30px;padding-left:30px}.document .form-horizontal .radio{min-height:30px}.document .title{font-weight:700;font-size:16px;text-transform:uppercase;color:#e07e3c;line-height:30px;margin-bottom:10px;display:inline-block}.document .form-group.label-floating label.control-label,.document .form-group.label-placeholder label.control-label{top:0;text-transform:uppercase;position:relative;padding-top:0}.document .form-control{height:35px}.document .form-group{margin-top:0;padding-bottom:0}.document .radio-btn-right{display:inline-block;margin-left:10px}.document .row-in-row .row:last-child{margin-bottom:0}.document .input-with-checkbox .form-group{margin-top:5px}.document .checkbox-label{font-size:14px;line-height:1.42857;color:#aaa;text-transform:uppercase;font-weight:700}.document .container-table.row{margin-right:-35px;margin-left:-35px}.document .checkbox-padding-0 .checkbox{padding-top:0}.document .checkbox-form-margin-bottom .form-control{margin-bottom:14px}.document .checkbox-with-input .form-group{padding-left:25px}.document .background-grey{background:#fafafa}.document .table .background-light-orange td{background:#fff7ee}.document .table th{border:1px solid rgba(224,126,60,.4);border-bottom:1px solid rgba(224,126,60,.4);border-top:1px solid rgba(224,126,60,.4)!important;line-height:20px;background:#fff7ee;padding:15px}.document .table .form-group{margin:0}.document .table th:last-child{border-right:none}.document .table th:first-child{border-left:none}.document .table tbody tr td{border:1px solid rgba(224,126,60,.4);border-top:1px solid rgba(224,126,60,.4)}.document .table tbody tr td:last-child{border-right:none}.document .table tbody tr td:first-child{border-left:none}.document .table .radio{width:100%}.document .row.row-right-content-stick{margin-right:-35px}.document .row.row-right-content-stick .col-md-6:first-child{padding-right:30px}.document .add-line-btn{text-transform:capitalize}.document .title-pull-top{margin-top:-40px}.document .declaration-block-title{margin-left:28px}.document .long-label .form-group.label-floating label.control-label{letter-spacing:-.1px}.document .no-label .form-control{margin-top:25px}.document div.has-error .radio label .radio-label,.document div.has-error span{color:#f44336}.document div.has-error .radio label .circle{border:1px solid #f44336}.document .form-group .help-block{line-height:12px}.document .input-margin-bottom .form-control{margin-top:12px}.document .save.btn{padding:0;position:absolute;top:45px;right:-52px}.document .save.btn .modal-close-icon{color:#e07e3c}.document .close.btn.sticky{top:10px}.document .close.btn.sticky,.document .save.btn.sticky{position:sticky;position:-webkit-sticky;margin-right:-52px}.document .save.btn.sticky{top:55px}.document-3461 .table th{width:30%}.document-7501 .table td,.document-7501 .table th{padding:5px;vertical-align:top}.document-7501 .checkbox-label{line-height:30px}.document.customer-modal .line-form{padding-top:0}@media (min-width:992px){.document .modal-lg{width:915px}}@media (min-width:768px){.document .form-horizontal .control-label{text-align:left}}@media (max-width:767px){.document .save.btn{padding:0;position:absolute;top:35px;z-index:2000;right:0;box-shadow:none}}@media (max-width:600px){.document .table-inner{overflow-x:scroll}}@media (max-width:991px){.document .title-pull-top{margin-top:0}.document.customer-modal .header{width:auto}}@media (max-width:600px){.document .modal-lg .table-inner{overflow-x:scroll}}.seller-item .customer-card.seller .card{height:304px}.seller-item .customer-card.seller .card .card-footer .row .big-info{height:60px}.amazon-management .material-icons,.amazon-management .top_buttons_body .nav .dropdown-toggle:after,.amazon-management .top_buttons_body .nav .open .dropdown-toggle:after{direction:ltr;display:inline-block;font-family:Material Icons;font-size:24px;font-style:normal;font-weight:400;letter-spacing:normal;line-height:1;text-transform:none;white-space:nowrap;word-wrap:normal;-webkit-font-feature-settings:"liga";-webkit-font-smoothing:antialiased}.amazon-management .top_buttons_body{width:calc(100% - 180px);justify-content:space-between}.amazon-management .top_buttons_body .nav{margin-left:50%;transform:translateX(-50%)}.amazon-management .top_buttons_body .nav .dropdown-toggle{background:#ffe4c7;box-shadow:0 1px 3px rgba(0,0,0,.16);border-radius:5px;padding-right:40px}.amazon-management .top_buttons_body .nav .dropdown-toggle:after,.amazon-management .top_buttons_body .nav .open .dropdown-toggle:after{position:absolute;right:5px;top:7px}.amazon-management .top_buttons_body .nav .dropdown-menu{width:100%;background:#fff7ee}.amazon-management .top_buttons_body .nav>li>a{padding:10px 30px}.order-table-view.amazon-product-card-container .ngx-datatable.material .datatable-body .datatable-body-row{padding:15px 0;box-shadow:0 1px 4px 0 rgba(0,0,0,.14)}.order-table-view.amazon-product-card-container .ngx-datatable.material .datatable-body .datatable-body-row:hover{cursor:default}.order-table-view.amazon-product-card-container .ngx-datatable.material .datatable-body .datatable-body-row>div{box-shadow:none;border-radius:0;background:none}.order-table-view.amazon-product-card-container .ngx-datatable.material .datatable-body .datatable-body-row .datatable-body-cell{margin-right:0;padding:0 10px}.order-table-view.amazon-product-card-container .ngx-datatable.material .datatable-body .datatable-body-row .datatable-body-cell:first-child{padding-left:20px}.order-table-view.amazon-product-card-container .ngx-datatable.material .datatable-body .datatable-body-row .datatable-body-cell .datatable-body-cell-label{white-space:inherit;justify-content:center;align-items:center;overflow:hidden;height:120px}.order-table-view.amazon-product-card-container .ngx-datatable.material .form-group{margin-top:0}.amazon-management .top_buttons_body .nav .order-table-view.amazon-product-card-container .ngx-datatable.material .dropdown-toggle:after,.order-table-view.amazon-product-card-container .ngx-datatable.material .amazon-management .top_buttons_body .nav .dropdown-toggle:after,.order-table-view.amazon-product-card-container .ngx-datatable.material .material-icons{color:#e07e3c;font-size:16px;line-height:18px;display:inline-block;background:#fff7ee;width:18px;height:18px;margin:auto;border-radius:2px}.amazon-management .top_buttons_body .nav .order-table-view.amazon-product-card-container .ngx-datatable.material .dropdown-toggle:hover:after,.order-table-view.amazon-product-card-container .ngx-datatable.material .amazon-management .top_buttons_body .nav .dropdown-toggle:hover:after,.order-table-view.amazon-product-card-container .ngx-datatable.material .material-icons:hover{cursor:pointer}.order-table-view.amazon-product-card-container .ngx-datatable.scroll-vertical .datatable-body{overflow-x:hidden;overflow-y:scroll;max-height:calc(100vh - 200px);min-height:calc(100vh - 200px)}.order-table-view.amazon-product-card-container .ngx-datatable.material:not(.cell-selection) .datatable-body-row:hover .datatable-row-group{background-color:inherit;transition-property:inherit;transition-duration:.3s;transition-timing-function:linear}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvdGhlbWUvY3NzL21hdGVyaWFsLWRhc2hib2FyZC5jc3MubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL3RoZW1lL2Nzcy9tYXRlcmlhbC1kYXNoYm9hcmQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=material-dashboard.css.ngstyle.js.map
// CONCATENATED MODULE: ./compiled/node_modules/ng2-toastr/ng2-toastr.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var ng2_toastr_css_ngstyle_styles = ['.toast-title{font-weight:700}.toast-message{word-wrap:break-word}.toast-message a,.toast-message label{color:#fff}.toast-message a:hover{color:#ccc;text-decoration:none}.toast-close-button{position:relative;right:-.3em;top:-.3em;float:right;font-size:20px;font-weight:700;color:#fff;-webkit-text-shadow:0 1px 0 #fff;text-shadow:0 1px 0 #fff;opacity:.8}.toast-close-button:focus,.toast-close-button:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.4}button.toast-close-button{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.toast-top-center{top:0;right:0;width:100%}.toast-bottom-center{bottom:0;right:0;width:100%}.toast-top-full-width{top:0;right:0;width:100%}.toast-bottom-full-width{bottom:0;right:0;width:100%}.toast-top-left{top:12px;left:12px}.toast-top-right{top:12px;right:12px}.toast-bottom-right{right:12px;bottom:12px}.toast-bottom-left{bottom:12px;left:12px}#toast-container{pointer-events:none;position:fixed;z-index:99999}#toast-container *{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box}#toast-container>div{position:relative;overflow:hidden;margin:0 0 6px;padding:15px 15px 15px 50px;width:300px;-moz-border-radius:3px 3px 3px 3px;-webkit-border-radius:3px 3px 3px 3px;border-radius:3px 3px 3px 3px;background-position:15px;background-repeat:no-repeat;-moz-box-shadow:0 0 12px #999;-webkit-box-shadow:0 0 12px #999;box-shadow:0 0 12px #999;color:#fff;opacity:.8}#toast-container>div.toast-custom{padding:15px;color:#030303}#toast-container>div.toast-custom .toast-close-button{color:#999!important}#toast-container>:hover{-moz-box-shadow:0 0 12px #000;-webkit-box-shadow:0 0 12px #000;box-shadow:0 0 12px #000;opacity:1;cursor:pointer}#toast-container>.toast-info{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=")!important}#toast-container>.toast-error{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=")!important}#toast-container>.toast-success{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==")!important}#toast-container>.toast-warning{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=")!important}#toast-container.toast-bottom-center>div,#toast-container.toast-top-center>div{width:300px;margin:auto}#toast-container.toast-bottom-full-width>div,#toast-container.toast-top-full-width>div{width:96%;margin:auto}.toast{background-color:#fff;pointer-events:auto}.toast-success{background-color:#51a351}.toast-error{background-color:#bd362f}.toast-info{background-color:#2f96b4}.toast-warning{background-color:#f89406}.toast-progress{position:absolute;left:0;bottom:0;height:4px;background-color:#000;opacity:.4}@media (max-width:240px){#toast-container>div{padding:8px 8px 8px 50px;width:11em}#toast-container .toast-close-button{right:-.2em;top:-.2em}}@media (min-width:241px) and (max-width:480px){#toast-container>div{padding:8px 8px 8px 50px;width:18em}#toast-container .toast-close-button{right:-.2em;top:-.2em}}@media (min-width:481px) and (max-width:768px){#toast-container>div{padding:15px 15px 15px 50px;width:25em}}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL25nMi10b2FzdHIvbmcyLXRvYXN0ci5jc3MubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL25vZGVfbW9kdWxlcy9uZzItdG9hc3RyL25nMi10b2FzdHIuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=ng2-toastr.css.ngstyle.js.map
// CONCATENATED MODULE: ./compiled/node_modules/perfect-scrollbar/dist/css/perfect-scrollbar.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var perfect_scrollbar_css_ngstyle_styles = ['.ps{-ms-touch-action:auto;touch-action:auto;overflow:hidden!important;-ms-overflow-style:none}@supports (-ms-overflow-style:none){.ps{overflow:auto!important}}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.ps{overflow:auto!important}}.ps.ps--active-x>.ps__scrollbar-x-rail,.ps.ps--active-y>.ps__scrollbar-y-rail{display:block;background-color:transparent}.ps.ps--in-scrolling.ps--x>.ps__scrollbar-x-rail{background-color:#eee;opacity:.9}.ps.ps--in-scrolling.ps--x>.ps__scrollbar-x-rail>.ps__scrollbar-x{background-color:#999;height:11px}.ps.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail{background-color:#eee;opacity:.9}.ps.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail>.ps__scrollbar-y{background-color:#999;width:11px}.ps>.ps__scrollbar-x-rail{display:none;position:absolute;opacity:0;-webkit-transition:background-color .2s linear,opacity .2s linear;-moz-transition:background-color .2s linear,opacity .2s linear;-o-transition:background-color .2s linear,opacity .2s linear;transition:background-color .2s linear,opacity .2s linear;bottom:0;height:15px}.ps>.ps__scrollbar-x-rail>.ps__scrollbar-x{position:absolute;background-color:#aaa;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;-webkit-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;-moz-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;-o-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-webkit-border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;bottom:2px;height:6px}.ps>.ps__scrollbar-x-rail:active>.ps__scrollbar-x,.ps>.ps__scrollbar-x-rail:hover>.ps__scrollbar-x{height:11px}.ps>.ps__scrollbar-y-rail{display:none;position:absolute;opacity:0;-webkit-transition:background-color .2s linear,opacity .2s linear;-moz-transition:background-color .2s linear,opacity .2s linear;-o-transition:background-color .2s linear,opacity .2s linear;transition:background-color .2s linear,opacity .2s linear;right:0;width:15px}.ps>.ps__scrollbar-y-rail>.ps__scrollbar-y{position:absolute;background-color:#aaa;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;-webkit-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;-moz-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;-o-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-webkit-border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;right:2px;width:6px}.ps>.ps__scrollbar-y-rail:active>.ps__scrollbar-y,.ps>.ps__scrollbar-y-rail:hover>.ps__scrollbar-y{width:11px}.ps:hover.ps--in-scrolling.ps--x>.ps__scrollbar-x-rail{background-color:#eee;opacity:.9}.ps:hover.ps--in-scrolling.ps--x>.ps__scrollbar-x-rail>.ps__scrollbar-x{background-color:#999;height:11px}.ps:hover.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail{background-color:#eee;opacity:.9}.ps:hover.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail>.ps__scrollbar-y{background-color:#999;width:11px}.ps:hover>.ps__scrollbar-x-rail,.ps:hover>.ps__scrollbar-y-rail{opacity:.6}.ps:hover>.ps__scrollbar-x-rail:hover{background-color:#eee;opacity:.9}.ps:hover>.ps__scrollbar-x-rail:hover>.ps__scrollbar-x{background-color:#999}.ps:hover>.ps__scrollbar-y-rail:hover{background-color:#eee;opacity:.9}.ps:hover>.ps__scrollbar-y-rail:hover>.ps__scrollbar-y{background-color:#999}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL3BlcmZlY3Qtc2Nyb2xsYmFyL2Rpc3QvY3NzL3BlcmZlY3Qtc2Nyb2xsYmFyLmNzcy5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL3BlcmZlY3Qtc2Nyb2xsYmFyL2Rpc3QvY3NzL3BlcmZlY3Qtc2Nyb2xsYmFyLmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=perfect-scrollbar.css.ngstyle.js.map
// CONCATENATED MODULE: ./compiled/node_modules/@swimlane/ngx-dnd/release/index.css.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var release_index_css_ngstyle_styles = ['.ngx-dnd-item{margin:10px;padding:10px;background-color:rgba(0,0,0,.2);transition:opacity .4s ease-in-out;border:1px solid #add8e6;display:block}.ngx-dnd-item.has-handle [ngxdraghandle],.ngx-dnd-item.has-handle [ngxDragHandle],.ngx-dnd-item:not(.has-handle):not(.move-disabled){cursor:move;cursor:grab;cursor:-webkit-grab}.ngx-dnd-item .ngx-dnd-content{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ngx-dnd-item:hover{border:1px solid blue}.gu-mirror{position:fixed!important;margin:0!important;z-index:9999!important;opacity:.8;-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=80)";filter:alpha(opacity=80)}.gu-hide{display:none!important}.gu-unselectable{-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}.gu-transit{opacity:.2;-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)";filter:alpha(opacity=20)}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZG5kL3JlbGVhc2UvaW5kZXguY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kbmQvcmVsZWFzZS9pbmRleC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=index.css.ngstyle.js.map
// CONCATENATED MODULE: ./compiled/app/app.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_AppComponent = [css_bootstrap_css_ngstyle_styles, material_dashboard_css_ngstyle_styles, ng2_toastr_css_ngstyle_styles, perfect_scrollbar_css_ngstyle_styles, release_index_css_ngstyle_styles];
var RenderType_AppComponent = core_es5["ɵcrt"]({ encapsulation: 2, styles: styles_AppComponent,
    data: {} });
function View_AppComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](16777216, null, null, 1, 'router-outlet', [], null, null, null, null, null)),
        core_es5["ɵdid"](212992, null, 0, router_es5["r" /* RouterOutlet */], [router_es5["b" /* ChildrenOutletContexts */], core_es5["ViewContainerRef"],
            core_es5["ComponentFactoryResolver"], [8, null], core_es5["ChangeDetectorRef"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
function View_AppComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](16777216, null, null, 1, 'my-app', [], null, null, null, View_AppComponent_0, RenderType_AppComponent)), core_es5["ɵdid"](4243456, null, 0, app_component_AppComponent, [toast_manager["ToastsManager"],
            core_es5["ViewContainerRef"], services_configService["a" /* ConfigService */]], null, null)], null, null);
}
var AppComponentNgFactory = core_es5["ɵccf"]('my-app', app_component_AppComponent, View_AppComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvYXBwLmNvbXBvbmVudC50cy5BcHBDb21wb25lbnQuaHRtbCIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9hcHAuY29tcG9uZW50LnRzLkFwcENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD4iLCI8bXktYXBwPjwvbXktYXBwPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTthQUFBO3NDQUFBO1VBQUE7SUFBQTs7OztvQkNBQTtNQUFBOzZCQUFBLFVBQUE7MENBQUE7Ozs7In0=
//# sourceMappingURL=app.component.ngfactory.js.map
// EXTERNAL MODULE: ./node_modules/@angular/animations/@angular/animations/browser.es5.js
var browser_es5 = __webpack_require__("1GJ2");

// EXTERNAL MODULE: ./node_modules/@angular/platform-browser/@angular/platform-browser/animations.es5.js
var animations_es5 = __webpack_require__("KN8t");

// EXTERNAL MODULE: ./node_modules/@angular/animations/@angular/animations.es5.js
var _angular_animations_es5 = __webpack_require__("Um43");

// CONCATENATED MODULE: ./app/services/appService.ts




var appService_AppService = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](AppService, _super);
    function AppService(http, configService) {
        return _super.call(this, http, configService) || this;
    }
    AppService.prototype.getAllApps = function () {
        return this.get(new http_es5["i" /* RequestOptions */]({
            url: "v2/apps/all"
        }));
    };
    AppService.prototype.getApp = function (appId) {
        return this.get(new http_es5["i" /* RequestOptions */]({
            url: "v2/apps/" + appId
        }));
    };
    AppService.prototype.getUsers = function (appId, groupId) {
        return this.get(new http_es5["i" /* RequestOptions */]({
            url: "v2/apps/" + appId + "/groups/users",
            params: { groupId: groupId }
        }));
    };
    AppService.prototype.updateApp = function (app) {
        return this.put(new http_es5["i" /* RequestOptions */]({
            url: "v2/apps/" + app.Id,
            body: JSON.stringify(app)
        }));
    };
    AppService.prototype.updateAppGroups = function (app) {
        return this.put(new http_es5["i" /* RequestOptions */]({
            url: "v2/apps/" + app.Id + "/groups",
            body: JSON.stringify(app)
        }));
    };
    AppService.prototype.installApp = function (app) {
        return this.post(new http_es5["i" /* RequestOptions */]({
            url: "v2/apps",
            body: app
        }));
    };
    AppService.prototype.getCurrentSubscription = function (appId) {
        return this.get(new http_es5["i" /* RequestOptions */]({
            url: "v2/apps/" + appId + "/subscriptions"
        }));
    };
    AppService.prototype.orderSubscription = function (appId, request) {
        return this.post(new http_es5["i" /* RequestOptions */]({
            url: "v2/apps/" + appId + "/subscriptions",
            body: request
        }));
    };
    AppService.ctorParameters = function () { return [{ type: http_es5["e" /* Http */] }, { type: services_configService["a" /* ConfigService */] }]; };
    return AppService;
}(baseService["a" /* BaseApi */]));

//# sourceMappingURL=appService.js.map
// CONCATENATED MODULE: ./app/services/sipService.ts




var sipService_SipService = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](SipService, _super);
    function SipService(http, configService) {
        return _super.call(this, http, configService) || this;
    }
    SipService.prototype.getManufacturers = function (request) {
        return this.post(new http_es5["i" /* RequestOptions */]({
            url: "v2/manufacturers/search",
            body: request
        }));
    };
    SipService.ctorParameters = function () { return [{ type: http_es5["e" /* Http */] }, { type: services_configService["a" /* ConfigService */] }]; };
    return SipService;
}(baseService["a" /* BaseApi */]));

//# sourceMappingURL=sipService.js.map
// CONCATENATED MODULE: ./app/objects/groups/permissionScope.ts


var permissionScope_PermissionScope = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](PermissionScope, _super);
    function PermissionScope() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PermissionScope;
}(baseEntity["a" /* BaseEntity */]));

var Permission;
(function (Permission) {
    Permission[Permission["Read"] = 0] = "Read";
    Permission[Permission["Write"] = 1] = "Write";
})(Permission || (Permission = {}));
//# sourceMappingURL=permissionScope.js.map
// CONCATENATED MODULE: ./app/common/guards/authGuard.ts





var authGuard_AuthGuard = /** @class */ (function () {
    function AuthGuard(configService, storageManager, router) {
        this.configService = configService;
        this.storageManager = storageManager;
        this.router = router;
    }
    AuthGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        if (!ng2_cookies_ng2_cookies["Cookie"].get(this.configService.config.ApiTokenCookieName) || !ng2_cookies_ng2_cookies["Cookie"].get(this.configService.config.UserCookieName)) {
            this.storageManager.setCurrentUser(null);
            this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
        return this.storageManager.getCurrentUser().then(function (user) {
            if (user == null) {
                _this.storageManager.setCurrentUser(null);
                _this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
                return false;
            }
            if (route.data && route.data['componentID'] && !_this.canAccess(route.data['componentID'], user)) {
                if (_this.hasPermission(user, 10, Permission.Read)) {
                    _this.router.navigate(['']);
                }
                else if (_this.hasPermission(user, 1, Permission.Read)) {
                    _this.router.navigate(['/management/agent']);
                }
                else {
                    _this.storageManager.setCurrentUser(null);
                    _this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
                }
                return false;
            }
            return true;
        });
    };
    AuthGuard.prototype.canActivateChild = function (childRoute, state) {
        return this.canActivate(childRoute, state);
    };
    AuthGuard.prototype.hasPermission = function (currentUser, componentId, permission) {
        var hasPermission = false;
        for (var _i = 0, _a = currentUser.Groups; _i < _a.length; _i++) {
            var group = _a[_i];
            hasPermission = group.PermissionScopes.find(function (x) { return x.ComponentId == componentId && x.Permissions.indexOf(permission) != -1; }) != null;
            if (hasPermission)
                break;
        }
        return hasPermission;
    };
    AuthGuard.prototype.canAccess = function (currentComponent, currentUser) {
        return this.hasPermission(currentUser, currentComponent, Permission.Read);
    };
    AuthGuard.ctorParameters = function () { return [{ type: services_configService["a" /* ConfigService */] }, { type: managers_storageManager["a" /* StorageManager */] }, { type: router_es5["n" /* Router */] }]; };
    return AuthGuard;
}());

//# sourceMappingURL=authGuard.js.map
// EXTERNAL MODULE: ./app/common/helpers/enumHelper.ts
var enumHelper = __webpack_require__("ZP5A");
var enumHelper_default = /*#__PURE__*/__webpack_require__.n(enumHelper);

// CONCATENATED MODULE: ./app/common/guards/appGuard.ts



var appGuard_AppGuard = /** @class */ (function () {
    function AppGuard(storageManager, router) {
        this.storageManager = storageManager;
        this.router = router;
    }
    AppGuard.prototype.canActivate = function (route, state) {
        return true;
        // if (this.storageManager.getCurrentAppId() <= 0) {
        //     this.router.navigate(['/apps']);
        //     return false;
        // }
        //
        // if (state.url == "/app/sip/subscriptions")
        //     return true;
        //
        // return this.storageManager.getCurrentUser().then(user => {
        //     if (user.Role.indexOf(1) > -1 || user.Role.indexOf(13) > -1) {
        //         if (state.url == "/app/sip")
        //             this.router.navigate(["/app/sip/brands"]);
        //         return true;
        //     }
        //
        //     if (!app.Flags.hasFlag(AppFlags.Paid)) {
        //         this.router.navigate(["/app/sip/subscriptions"]);
        //         return false;
        //     }
        //
        //     if (state.url == "/app/sip") {
        //         const groups = app.Groups.filter(group => group.UserIds.indexOf(user.Id) > -1);
        //
        //         if (groups.some(group => group.Type == GroupType.Owner)) {
        //             this.router.navigate(["/app/sip/brands"]);
        //             return false;
        //         } else {
        //             this.router.navigate(["/app/sip/marketshare"]);
        //             return false;
        //         }
        //     }
        //
        //     return true;
        // })
        //     .catch(x => {
        //         this.router.navigate(["/apps"]);
        //         return false;
        //     });
    };
    AppGuard.prototype.canActivateChild = function (childRoute, state) {
        return this.canActivate(childRoute, state);
    };
    AppGuard.ctorParameters = function () { return [{ type: managers_storageManager["a" /* StorageManager */] }, { type: router_es5["n" /* Router */] }]; };
    return AppGuard;
}());

//# sourceMappingURL=appGuard.js.map
// CONCATENATED MODULE: ./app/common/guards/amazonGuard.ts





var amazonGuard_AmazonGuard = /** @class */ (function () {
    function AmazonGuard(configService, router, amazonService, userService) {
        this.configService = configService;
        this.router = router;
        this.amazonService = amazonService;
        this.userService = userService;
    }
    AmazonGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        var userId = +ng2_cookies_ng2_cookies["Cookie"].get(this.configService.config.UserAmazonCookieName);
        if (!ng2_cookies_ng2_cookies["Cookie"].get(this.configService.config.ApiTokenCookieName) || !userId) {
            this.amazonService.setCurrentSeller(null);
            this.router.navigate(['/amazon'], { queryParams: { returnUrl: state.url } });
            return false;
        }
        this.userService.getById(userId).then(function (resp) {
            _this.amazonService.userEmail = resp.Data.Email;
        });
        return this.amazonService.getCurrentSeller().then(function (seller) {
            if (state.url == "/amazon/info/store" || state.url == "/amazon/info/dashboard") {
                if (seller.UserId == undefined || seller.UserId == null) {
                    _this.router.navigate(["amazon/info/seller"]);
                }
            }
            var sellerId = route.params["sellerId"];
            var storeId = route.params["storeId"];
            if (state.url == "/amazon/info/" + sellerId + "/store/" + storeId + "/products") {
                var store = seller.Stores.find(function (store) { return store.Id == storeId; });
                if (!store || sellerId != seller.Id) {
                    _this.router.navigate(['/amazon/info/dashboard']);
                }
            }
            return true;
        });
    };
    AmazonGuard.prototype.canActivateChild = function (childRoute, state) {
        return this.canActivate(childRoute, state);
    };
    AmazonGuard.ctorParameters = function () { return [{ type: services_configService["a" /* ConfigService */] }, { type: router_es5["n" /* Router */] }, { type: amazon_service["a" /* AmazonService */] }, { type: services_userService["a" /* UserService */] }]; };
    return AmazonGuard;
}());

//# sourceMappingURL=amazonGuard.js.map
// CONCATENATED MODULE: ./app/services/currencyService.ts
/**
 * Created by alex.y on 7/19/2017.
 */



var currencyService_CurrencyService = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](CurrencyService, _super);
    function CurrencyService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CurrencyService.prototype.getFromDate = function (dateFrom) {
        return this.get(new http_es5["i" /* RequestOptions */]({
            url: "currency",
            params: { dateFrom: (String.formatDateMMDDYYYY(dateFrom.toString())) }
        }));
    };
    CurrencyService.prototype.getCanadianCurrencyCodes = function () {
        return this.get(new http_es5["i" /* RequestOptions */]({
            url: "currency/codes/canadian"
        }));
    };
    return CurrencyService;
}(baseService["a" /* BaseApi */]));

//# sourceMappingURL=currencyService.js.map
// CONCATENATED MODULE: ./app/components/currencyExchange/currency.resolver.ts

var currency_resolver_CurrencyResolver = /** @class */ (function () {
    function CurrencyResolver(currencyService) {
        this.currencyService = currencyService;
    }
    CurrencyResolver.prototype.resolve = function () {
        var date = new Date(Date.now());
        date.setDate(date.getDate() - 356);
        return this.currencyService.getFromDate(date).then(function (result) {
            return result.Data;
        }).catch(function (err) {
            //TODO how we will handle errors in js?
            return null;
        });
    };
    CurrencyResolver.ctorParameters = function () { return [{ type: currencyService_CurrencyService }]; };
    return CurrencyResolver;
}());

//# sourceMappingURL=currency.resolver.js.map
// CONCATENATED MODULE: ./app/services/googleService.ts




/**
 * Created by alex.y on 7/27/2017.
 */
var googleService_GoogleService = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](GoogleService, _super);
    function GoogleService(http, configService) {
        return _super.call(this, http, configService) || this;
    }
    GoogleService.prototype.getGoogleContacts = function () {
        return this.get(new http_es5["i" /* RequestOptions */]({
            url: "google/contacts"
        }));
    };
    GoogleService.ctorParameters = function () { return [{ type: http_es5["e" /* Http */] }, { type: services_configService["a" /* ConfigService */] }]; };
    return GoogleService;
}(baseService["a" /* BaseApi */]));

//# sourceMappingURL=googleService.js.map
// CONCATENATED MODULE: ./app/components/Managment/locationManagement/locationManagment.resolver.ts

/**
 * Created by alex.y on 7/31/2017.
 */
var locationManagment_resolver_LocationManagementResolver = /** @class */ (function () {
    function LocationManagementResolver(locationService) {
        this.locationService = locationService;
    }
    LocationManagementResolver.prototype.resolve = function () {
        return this.locationService.getAll(12, 0).then(function (result) {
            return result.Data;
        }).catch(function (err) {
            return null;
        });
    };
    LocationManagementResolver.ctorParameters = function () { return [{ type: services_locationService["a" /* LocationService */] }]; };
    return LocationManagementResolver;
}());

//# sourceMappingURL=locationManagment.resolver.js.map
// CONCATENATED MODULE: ./app/components/agent/agent-management.resolver.ts


/**
 * Created by vlad.p on 8/9/2017.
 */
var agent_management_resolver_AgentManagementResolver = /** @class */ (function () {
    function AgentManagementResolver(userService) {
        this.userService = userService;
    }
    AgentManagementResolver.prototype.resolve = function () {
        return this.userService.search(new userSearchRequest_UserSearchRequest({
            Skip: 0,
            Top: 12,
            Query: '',
            FillOrders: true
        })).then(function (result) {
            return result.Data;
        }).catch(function (err) {
            return null;
        });
    };
    AgentManagementResolver.ctorParameters = function () { return [{ type: services_userService["a" /* UserService */] }]; };
    return AgentManagementResolver;
}());

//# sourceMappingURL=agent-management.resolver.js.map
// CONCATENATED MODULE: ./app/services/groupService.ts
/**
 * Created by vlad.p on 8/9/2017.
 */




var groupService_GroupService = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](GroupService, _super);
    function GroupService(http, configService) {
        return _super.call(this, http, configService) || this;
    }
    GroupService.prototype.getAllGroups = function () {
        return this.get(new http_es5["i" /* RequestOptions */]({
            url: "groups"
        }));
    };
    GroupService.ctorParameters = function () { return [{ type: http_es5["e" /* Http */] }, { type: services_configService["a" /* ConfigService */] }]; };
    return GroupService;
}(baseService["a" /* BaseApi */]));

//# sourceMappingURL=groupService.js.map
// CONCATENATED MODULE: ./app/components/agent/group.resolver.ts

/**
 * Created by vlad.p on 8/9/2017.
 */
var group_resolver_GroupResolver = /** @class */ (function () {
    function GroupResolver(groupService) {
        this.groupService = groupService;
    }
    GroupResolver.prototype.resolve = function () {
        return this.groupService.getAllGroups();
    };
    GroupResolver.ctorParameters = function () { return [{ type: groupService_GroupService }]; };
    return GroupResolver;
}());

//# sourceMappingURL=group.resolver.js.map
// CONCATENATED MODULE: ./app/components/calculator/resolvers/canadian-currency-codes.resolver.ts

/**
 * Created by vlad.p on 8/22/2017.
 */
var canadian_currency_codes_resolver_CanadianCurrencyCodesResolver = /** @class */ (function () {
    function CanadianCurrencyCodesResolver(currencyService) {
        this.currencyService = currencyService;
    }
    CanadianCurrencyCodesResolver.prototype.resolve = function () {
        return this.currencyService.getCanadianCurrencyCodes();
    };
    CanadianCurrencyCodesResolver.ctorParameters = function () { return [{ type: currencyService_CurrencyService }]; };
    return CanadianCurrencyCodesResolver;
}());

//# sourceMappingURL=canadian-currency-codes.resolver.js.map
// CONCATENATED MODULE: ./app/components/Managment/customerManagement/customerManagement.resolver.ts



/**
 * Created by alex.y on 9/7/2017.
 */
var customerManagement_resolver_CustomerManagementResolver = /** @class */ (function () {
    function CustomerManagementResolver(customerService) {
        this.customerService = customerService;
    }
    CustomerManagementResolver.prototype.resolve = function () {
        return this.customerService.search(new customerSearchRequest_CustomerSearchRequest({
            Skip: 0,
            Top: 12,
            Query: '',
            OrderBy: { PropertyName: 'Id', OrderBy: ngx_odata_v4_es5["a" /* OrderBy */].Desc },
            FillOrders: false
        })).then(function (result) {
            return result.Data;
        }).catch(function (err) {
            return null;
        });
    };
    CustomerManagementResolver.ctorParameters = function () { return [{ type: services_customerService["a" /* CustomerService */] }]; };
    return CustomerManagementResolver;
}());

//# sourceMappingURL=customerManagement.resolver.js.map
// CONCATENATED MODULE: ./app/components/Managment/productManagement/productManagement.resolver.ts



/**
 * Created by alex.y on 9/11/2017.
 */
var productManagement_resolver_ProductManagementResolver = /** @class */ (function () {
    function ProductManagementResolver(productService) {
        this.productService = productService;
    }
    ProductManagementResolver.prototype.resolve = function () {
        return this.productService.search(new productSearchRequest["a" /* ProductSearchRequest */]({
            Skip: 0,
            Top: 12,
            Query: '',
            Source: null,
            RequestType: requestType["a" /* RequestType */].Search
        })).then(function (result) {
            return result.Data;
        }).catch(function (err) {
            return null;
        });
    };
    ProductManagementResolver.ctorParameters = function () { return [{ type: services_productService["a" /* ProductService */] }]; };
    return ProductManagementResolver;
}());

//# sourceMappingURL=productManagement.resolver.js.map
// CONCATENATED MODULE: ./app/components/Managment/orderManagement/orderManagement.resolver.ts











/**
 * Created by alex.y on 9/13/2017.
 */
var orderManagement_resolver_OrderManagementResolver = /** @class */ (function () {
    function OrderManagementResolver(orderService, customerService, userService, userViewService, orderODataService) {
        this.orderService = orderService;
        this.customerService = customerService;
        this.userService = userService;
        this.userViewService = userViewService;
        this.orderODataService = orderODataService;
    }
    OrderManagementResolver.prototype.resolve = function (route) {
        var currentConfigs = this.userViewService.userView[component["a" /* Component */].OrderManagement];
        var isOrderManagement = route.routeConfig.path == 'management/order';
        var top = (currentConfigs.ViewType == orderViewType["a" /* OrderViewType */].Table) && isOrderManagement ? 20 : 12;
        if (screenHelper["a" /* ScreenHelper */].isPhone()) {
            currentConfigs.ViewType = orderViewType["a" /* OrderViewType */].Tile;
        }
        var orderBy = userViewHelper["a" /* UserViewHelper */].getColumnOrderBy(this.userViewService.userView, component["a" /* Component */].OrderManagement);
        var customerId = route.params["customerid"];
        var query = calculatorHelper["a" /* CalculatorHelper */].replaceOrderPrefix(route.params['query']);
        var agentId = route.params['agentid'];
        if (agentId)
            return this.orderODataService.getOrdersByAgentId(agentId, 0, top, orderBy).then(function (result) {
                return result;
            }).catch(function (err) {
                return null;
            });
        if (customerId)
            return this.orderODataService.getByCustomerId(customerId, 0, top).then(function (result) {
                return result;
            }).catch(function (err) {
                return null;
            });
        return this.orderService.search(new orderSearchRequest_OrderSearchRequest({
            Skip: 0,
            Top: top,
            Query: query ? query : "",
            OrderBy: orderBy
        })).then(function (result) {
            return result;
        }).catch(function (err) {
            return null;
        });
    };
    OrderManagementResolver.ctorParameters = function () { return [{ type: services_orderService["a" /* OrderService */] }, { type: services_customerService["a" /* CustomerService */] }, { type: services_userService["a" /* UserService */] }, { type: services_userViewService["a" /* UserViewService */] }, { type: orderOData_service_OrderODataService }]; };
    return OrderManagementResolver;
}());

//# sourceMappingURL=orderManagement.resolver.js.map
// CONCATENATED MODULE: ./app/components/Managment/orderManagement/orderDetails/orderDetails.resolver.ts

/**
 * Created by vadim.m on 9/14/2017.
 */
var orderDetails_resolver_OrderDetailsResolver = /** @class */ (function () {
    function OrderDetailsResolver(orderService) {
        this.orderService = orderService;
    }
    OrderDetailsResolver.prototype.resolve = function (route) {
        var orderId = route.params["id"];
        if (String.isNullOrEmpty(orderId))
            orderId = route.params['orderId'];
        if (!orderId)
            return null;
        return this.orderService.getById(orderId);
    };
    OrderDetailsResolver.ctorParameters = function () { return [{ type: services_orderService["a" /* OrderService */] }]; };
    return OrderDetailsResolver;
}());

//# sourceMappingURL=orderDetails.resolver.js.map
// CONCATENATED MODULE: ./app/components/Managment/orderManagement/orderDetails/extraDataResolver.ts


/**
 * Created by alex.y on 9/18/2017.
 */
var extraDataResolver_ExtraDataResolver = /** @class */ (function () {
    function ExtraDataResolver(extraDataService) {
        this.extraDataService = extraDataService;
    }
    ExtraDataResolver.prototype.resolve = function (route) {
        var customerId = route.params["customerid"];
        if (customerId)
            return this.extraDataService.getByRefIdandRefType(customerId, extraDataSearchRequest["c" /* ReferenceType */].Order);
        return null;
    };
    ExtraDataResolver.ctorParameters = function () { return [{ type: services_extraDataService["a" /* ExtraDataService */] }]; };
    return ExtraDataResolver;
}());

//# sourceMappingURL=extraDataResolver.js.map
// CONCATENATED MODULE: ./app/components/reports/totalAmount/totalAmountReport.resolver.ts



var totalAmountReport_resolver_TotalAmountReportResolver = /** @class */ (function () {
    function TotalAmountReportResolver(reportService) {
        this.reportService = reportService;
    }
    TotalAmountReportResolver.prototype.resolve = function () {
        var reportSearch = new ReportSearchRequest();
        reportSearch.StartDate = null;
        reportSearch.EndDate = null;
        reportSearch.ReportType = ReportType.TotalFee;
        return this.reportService.getTotalFee(reportSearch).then(function (result) {
            return result.Data;
        }).catch(function (err) {
            return null;
        });
    };
    TotalAmountReportResolver.ctorParameters = function () { return [{ type: reportService_ReportService }]; };
    return TotalAmountReportResolver;
}());

//# sourceMappingURL=totalAmountReport.resolver.js.map
// CONCATENATED MODULE: ./app/components/reports/totalAmount/totalQuantityReport.resolver.ts



var totalQuantityReport_resolver_TotalQuantityReportResolver = /** @class */ (function () {
    function TotalQuantityReportResolver(reportService) {
        this.reportService = reportService;
    }
    TotalQuantityReportResolver.prototype.resolve = function () {
        var reportSearch = new ReportSearchRequest();
        reportSearch.StartDate = null;
        reportSearch.EndDate = null;
        reportSearch.ReportType = ReportType.TotalQuantity;
        return this.reportService.getTotalFee(reportSearch).then(function (result) {
            return result.Data;
        }).catch(function (err) {
            return null;
        });
    };
    TotalQuantityReportResolver.ctorParameters = function () { return [{ type: reportService_ReportService }]; };
    return TotalQuantityReportResolver;
}());

//# sourceMappingURL=totalQuantityReport.resolver.js.map
// CONCATENATED MODULE: ./app/components/Managment/orderManagement/orderData/orderContentResolver.ts

/**
 * Created by alex.y on 10/4/2017.
 */
var orderContentResolver_OrderContentResolver = /** @class */ (function () {
    function OrderContentResolver(orderContentService) {
        this.orderContentService = orderContentService;
    }
    OrderContentResolver.prototype.resolve = function (route) {
        var orderId = route.params["id"];
        if (orderId)
            return this.orderContentService.getByOrderIdAndStatus(orderId);
        return null;
    };
    OrderContentResolver.ctorParameters = function () { return [{ type: orderContentService_OrderContentService }]; };
    return OrderContentResolver;
}());

//# sourceMappingURL=orderContentResolver.js.map
// CONCATENATED MODULE: ./app/components/reports/totalAmount/allUser.resolver.ts

/**
 * Created by alex.y on 10/25/2017.
 */
var allUser_resolver_AllUserResolver = /** @class */ (function () {
    function AllUserResolver(userService) {
        this.userService = userService;
    }
    AllUserResolver.prototype.resolve = function () {
        return this.userService.getAll().then(function (result) {
            return result.Data;
        }).catch(function (err) {
            return null;
        });
    };
    AllUserResolver.ctorParameters = function () { return [{ type: services_userService["a" /* UserService */] }]; };
    return AllUserResolver;
}());

//# sourceMappingURL=allUser.resolver.js.map
// CONCATENATED MODULE: ./app/components/calculator/resolvers/default-tarff.resolver.ts


var default_tarff_resolver_DefaultTariffResolver = /** @class */ (function () {
    function DefaultTariffResolver(productService) {
        this.productService = productService;
    }
    DefaultTariffResolver.prototype.resolve = function () {
        return this.productService.search(new productSearchRequest["a" /* ProductSearchRequest */]({
            SearchType: 4,
            Top: 10,
            Skip: 0,
            RequestType: 1
        }));
    };
    DefaultTariffResolver.ctorParameters = function () { return [{ type: services_productService["a" /* ProductService */] }]; };
    return DefaultTariffResolver;
}());

//# sourceMappingURL=default-tarff.resolver.js.map
// CONCATENATED MODULE: ./app/components/userView/user-view.resolver.ts

var user_view_resolver_UserViewResolver = /** @class */ (function () {
    function UserViewResolver(userViewService) {
        this.userViewService = userViewService;
    }
    UserViewResolver.prototype.resolve = function (route) {
        var _this = this;
        if (this.userViewService.userView)
            return new Promise(function (resolve, reject) { return resolve(_this.userViewService.userView); });
        return this.userViewService.getUserView().then(function (x) {
            return x.Data;
        });
    };
    UserViewResolver.ctorParameters = function () { return [{ type: services_userViewService["a" /* UserViewService */] }]; };
    return UserViewResolver;
}());

//# sourceMappingURL=user-view.resolver.js.map
// CONCATENATED MODULE: ./app/components/userView/user-view-order.resolver.ts



var user_view_order_resolver_UserViewOrderResolver = /** @class */ (function () {
    function UserViewOrderResolver(orderManagementResolver, userViewResolver) {
        this.orderManagementResolver = orderManagementResolver;
        this.userViewResolver = userViewResolver;
    }
    ;
    UserViewOrderResolver.prototype.resolve = function (route) {
        return tslib_es6["a" /* __awaiter */](this, void 0, void 0, function () {
            var userViewConfig, orders;
            return tslib_es6["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userViewResolver.resolve(route)];
                    case 1:
                        userViewConfig = _a.sent();
                        return [4 /*yield*/, this.orderManagementResolver.resolve(route)];
                    case 2:
                        orders = _a.sent();
                        return [2 /*return*/, { userViewConfig: userViewConfig, orders: orders }];
                }
            });
        });
    };
    UserViewOrderResolver.ctorParameters = function () { return [{ type: orderManagement_resolver_OrderManagementResolver }, { type: user_view_resolver_UserViewResolver }]; };
    return UserViewOrderResolver;
}());

//# sourceMappingURL=user-view-order.resolver.js.map
// CONCATENATED MODULE: ./app/components/Managment/orderManagement/orderData/orderData.resolver.ts

var orderData_resolver_OrderDataResolver = /** @class */ (function () {
    function OrderDataResolver(documentService) {
        this.documentService = documentService;
    }
    OrderDataResolver.prototype.resolve = function (route) {
        var orderId = route.params["id"];
        if (String.isNullOrEmpty(orderId))
            orderId = route.params['orderId'];
        if (!orderId)
            return null;
        return this.documentService.getDocuments(orderId, 'CBP3461', 0, 100);
    };
    OrderDataResolver.ctorParameters = function () { return [{ type: documentService_DocumentService }]; };
    return OrderDataResolver;
}());

//# sourceMappingURL=orderData.resolver.js.map
// CONCATENATED MODULE: ./app/components/Managment/orderManagement/orderData/orderDataCBP7501.resolver.ts

var orderDataCBP7501_resolver_OrderDataCBP7501Resolver = /** @class */ (function () {
    function OrderDataCBP7501Resolver(documentService) {
        this.documentService = documentService;
    }
    OrderDataCBP7501Resolver.prototype.resolve = function (route) {
        var orderId = route.params["id"];
        if (String.isNullOrEmpty(orderId))
            orderId = route.params['orderId'];
        if (!orderId)
            return null;
        return this.documentService.getDocuments(orderId, 'CBP7501', 0, 100);
    };
    OrderDataCBP7501Resolver.ctorParameters = function () { return [{ type: documentService_DocumentService }]; };
    return OrderDataCBP7501Resolver;
}());

//# sourceMappingURL=orderDataCBP7501.resolver.js.map
// CONCATENATED MODULE: ./app/components/Managment/amazon-management/amazon-seller-management.resolver.ts

var amazon_seller_management_resolver_AmazonSellerManagementResolver = /** @class */ (function () {
    function AmazonSellerManagementResolver(amazonService) {
        this.amazonService = amazonService;
    }
    AmazonSellerManagementResolver.prototype.resolve = function () {
        return this.amazonService.getSellers(0, 12).then(function (result) {
            return result.Data;
        }).catch(function (err) {
            return null;
        });
    };
    AmazonSellerManagementResolver.ctorParameters = function () { return [{ type: amazon_service["a" /* AmazonService */] }]; };
    return AmazonSellerManagementResolver;
}());

//# sourceMappingURL=amazon-seller-management.resolver.js.map
// CONCATENATED MODULE: ./app/components/Managment/amazon-management/store/amazon-store.resolver.ts

var amazon_store_resolver_AmazonStoreResolver = /** @class */ (function () {
    function AmazonStoreResolver(amazonService) {
        this.amazonService = amazonService;
    }
    AmazonStoreResolver.prototype.resolve = function (route) {
        var sellerId = route.params["sellerId"];
        return this.amazonService.getSellerByUserId(sellerId).then(function (result) {
            return result.Data;
        }).catch(function (err) {
            return null;
        });
    };
    AmazonStoreResolver.ctorParameters = function () { return [{ type: amazon_service["a" /* AmazonService */] }]; };
    return AmazonStoreResolver;
}());

//# sourceMappingURL=amazon-store.resolver.js.map
// CONCATENATED MODULE: ./app/components/amazon/amazon-info/amazon-currentSelleer.resolver.ts

var amazon_currentSelleer_resolver_AmazonCurrentSellerResolver = /** @class */ (function () {
    function AmazonCurrentSellerResolver(amazonService) {
        this.amazonService = amazonService;
    }
    AmazonCurrentSellerResolver.prototype.resolve = function () {
        return this.amazonService.getCurrentSeller().then(function (resp) {
            return resp;
        }).catch(function (err) {
            return null;
        });
    };
    AmazonCurrentSellerResolver.ctorParameters = function () { return [{ type: amazon_service["a" /* AmazonService */] }]; };
    return AmazonCurrentSellerResolver;
}());

//# sourceMappingURL=amazon-currentSelleer.resolver.js.map
// CONCATENATED MODULE: ./app/components/Managment/amazon-management/store/amazon-product.resolver.ts


var amazon_product_resolver_AmazonProductResolver = /** @class */ (function () {
    function AmazonProductResolver(amazonService, router) {
        this.amazonService = amazonService;
        this.router = router;
    }
    AmazonProductResolver.prototype.resolve = function (route, router) {
        var sellerId = route.params["sellerId"];
        var storeId = route.params["storeId"];
        var top = 50;
        var isAdmin = true;
        if (router.url.indexOf('/amazon/info') > -1) {
            top = 10;
            isAdmin = false;
        }
        return this.amazonService.getProducts(sellerId, storeId, 0, top, isAdmin).then(function (result) {
            return result.Data;
        }).catch(function (err) {
            return null;
        });
    };
    AmazonProductResolver.ctorParameters = function () { return [{ type: amazon_service["a" /* AmazonService */] }, { type: router_es5["n" /* Router */] }]; };
    return AmazonProductResolver;
}());

//# sourceMappingURL=amazon-product.resolver.js.map
// EXTERNAL MODULE: ./node_modules/ng2-toastr/src/toast.module.js
var toast_module = __webpack_require__("c/fr");
var toast_module_default = /*#__PURE__*/__webpack_require__.n(toast_module);

// EXTERNAL MODULE: ./node_modules/@swimlane/ngx-datatable/release/datatable.module.js
var datatable_module = __webpack_require__("/j9b");
var datatable_module_default = /*#__PURE__*/__webpack_require__.n(datatable_module);

// EXTERNAL MODULE: ./node_modules/ng2-google-place-autocomplete/src/app/ng2-google-place.module.ts
var ng2_google_place_module = __webpack_require__("ictE");

// CONCATENATED MODULE: ./node_modules/ngx-validators/src/universal/universal-validators.js

var universal_validators_UniversalValidators = (function () {
    function UniversalValidators() {
    }
    UniversalValidators.noWhitespace = function (control) {
        if (Util.isNotPresent(control))
            return undefined;
        var pattern = '\\s';
        if (new RegExp(pattern).test(control.value)) {
            return { 'noWhitespaceRequired': true };
        }
        return undefined;
    };
    ;
    UniversalValidators.noEmptyString = function (control) {
        if (Util.isNotPresent(control))
            return undefined;
        if (control.value.trim().length === 0) {
            return { 'noEmptyString': true };
        }
        return undefined;
    };
    ;
    UniversalValidators.isNumber = function (control) {
        if (Util.isNotPresent(control))
            return undefined;
        if (isNaN(control.value)) {
            return { 'numberRequired': true };
        }
        return undefined;
    };
    ;
    UniversalValidators.isInRange = function (minValue, maxValue) {
        var validator = function (control) {
            if (Util.isNotPresent(control))
                return undefined;
            if (isNaN(control.value)) {
                return { 'numberRequired': true };
            }
            if (+control.value < minValue) {
                return { 'rangeValueToSmall': { 'requiredMinValue': minValue, 'requiredMaxValue': maxValue, 'actual': control.value } };
            }
            if (+control.value > maxValue) {
                return { 'rangeValueToBig': { 'requiredMinValue': minValue, 'requiredMaxValue': maxValue, 'actual': control.value } };
            }
            else {
                return undefined;
            }
        };
        return validator;
    };
    ;
    UniversalValidators.minLength = function (minLength) {
        var validator = function (control) {
            if (Util.isNotPresent(control))
                return undefined;
            var value = control.value;
            if (value.length >= minLength) {
                return undefined;
            }
            return { 'minLength': { 'requiredMinLength': minLength, 'actualLength': value.length } };
        };
        return validator;
    };
    ;
    UniversalValidators.maxLength = function (maxLength) {
        var validator = function (control) {
            if (Util.isNotPresent(control))
                return undefined;
            var value = control.value;
            if (maxLength >= value.length) {
                return undefined;
            }
            return { 'maxLength': { 'requiredMaxLength': maxLength, 'actualLength': value.length } };
        };
        return validator;
    };
    ;
    UniversalValidators.min = function (min) {
        var validator = function (control) {
            if (Util.isNotPresent(control))
                return undefined;
            var value = control.value;
            if (isNaN(control.value)) {
                return { 'numberRequired': true };
            }
            if (+value >= min) {
                return undefined;
            }
            return { 'min': { 'required': min, 'actual': control.value } };
        };
        return validator;
    };
    ;
    UniversalValidators.max = function (max) {
        var validator = function (control) {
            if (Util.isNotPresent(control))
                return undefined;
            var value = control.value;
            if (isNaN(control.value)) {
                return { 'numberRequired': true };
            }
            if (max >= +value) {
                return undefined;
            }
            return { 'max': { 'required': max, 'actual': control.value } };
        };
        return validator;
    };
    ;
    return UniversalValidators;
}());

//# sourceMappingURL=universal-validators.js.map
// CONCATENATED MODULE: ./node_modules/ngx-validators/src/universal/universal.directive.js



var universal_directive_WhiteSpaceValidatorDirective = (function () {
    function WhiteSpaceValidatorDirective() {
    }
    WhiteSpaceValidatorDirective.prototype.ngOnInit = function () {
        this.validator = universal_validators_UniversalValidators.noWhitespace;
    };
    WhiteSpaceValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    return WhiteSpaceValidatorDirective;
}());

universal_directive_WhiteSpaceValidatorDirective.decorators = [
    { type: core_es5["Directive"], args: [{
                selector: '[noWhitespace][formControlName],[noWhitespace][formControl],[noWhitespace][ngModel]',
                providers: [{
                        provide: forms_es5["NG_VALIDATORS"],
                        // tslint:disable-next-line:no-forward-ref
                        useExisting: Object(core_es5["forwardRef"])(function () { return universal_directive_WhiteSpaceValidatorDirective; }),
                        multi: true
                    }]
            },] },
];
/** @nocollapse */
universal_directive_WhiteSpaceValidatorDirective.ctorParameters = function () { return []; };
var universal_directive_EmptyStringValidatorDirective = (function () {
    function EmptyStringValidatorDirective() {
    }
    EmptyStringValidatorDirective.prototype.ngOnInit = function () {
        this.validator = universal_validators_UniversalValidators.noEmptyString;
    };
    EmptyStringValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    return EmptyStringValidatorDirective;
}());

universal_directive_EmptyStringValidatorDirective.decorators = [
    { type: core_es5["Directive"], args: [{
                selector: '[noEmptyString][formControlName],[noEmptyString][formControl],[noEmptyString][ngModel]',
                providers: [{
                        provide: forms_es5["NG_VALIDATORS"],
                        // tslint:disable-next-line:no-forward-ref
                        useExisting: Object(core_es5["forwardRef"])(function () { return universal_directive_EmptyStringValidatorDirective; }),
                        multi: true
                    }]
            },] },
];
/** @nocollapse */
universal_directive_EmptyStringValidatorDirective.ctorParameters = function () { return []; };
var universal_directive_IsNumberValidatorDirective = (function () {
    function IsNumberValidatorDirective() {
    }
    IsNumberValidatorDirective.prototype.ngOnInit = function () {
        this.validator = universal_validators_UniversalValidators.isNumber;
    };
    IsNumberValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    return IsNumberValidatorDirective;
}());

universal_directive_IsNumberValidatorDirective.decorators = [
    { type: core_es5["Directive"], args: [{
                selector: '[isNumber][formControlName],[isNumber][formControl],[isNumber][ngModel]',
                providers: [{
                        provide: forms_es5["NG_VALIDATORS"],
                        // tslint:disable-next-line:no-forward-ref
                        useExisting: Object(core_es5["forwardRef"])(function () { return universal_directive_IsNumberValidatorDirective; }),
                        multi: true
                    }]
            },] },
];
/** @nocollapse */
universal_directive_IsNumberValidatorDirective.ctorParameters = function () { return []; };
var universal_directive_IsInRangeValidatorDirective = (function () {
    function IsInRangeValidatorDirective() {
    }
    IsInRangeValidatorDirective.prototype.ngOnInit = function () {
        this.validator = universal_validators_UniversalValidators.isInRange(this.minValue, this.maxValue);
    };
    IsInRangeValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    return IsInRangeValidatorDirective;
}());

universal_directive_IsInRangeValidatorDirective.decorators = [
    { type: core_es5["Directive"], args: [{
                selector: '[isInRange][formControlName],[isInRange][formControl],[isInRange][ngModel]',
                providers: [{
                        provide: forms_es5["NG_VALIDATORS"],
                        // tslint:disable-next-line:no-forward-ref
                        useExisting: Object(core_es5["forwardRef"])(function () { return universal_directive_IsInRangeValidatorDirective; }),
                        multi: true
                    }]
            },] },
];
/** @nocollapse */
universal_directive_IsInRangeValidatorDirective.ctorParameters = function () { return []; };
universal_directive_IsInRangeValidatorDirective.propDecorators = {
    'minValue': [{ type: core_es5["Input"] },],
    'maxValue': [{ type: core_es5["Input"] },],
};
var universal_directive_MaxValidatorDirective = (function () {
    function MaxValidatorDirective() {
    }
    MaxValidatorDirective.prototype.ngOnInit = function () {
        this.validator = universal_validators_UniversalValidators.max(this.max);
    };
    MaxValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    return MaxValidatorDirective;
}());

universal_directive_MaxValidatorDirective.decorators = [
    { type: core_es5["Directive"], args: [{
                selector: '[max][formControlName],[max][formControl],[max][ngModel]',
                providers: [{
                        provide: forms_es5["NG_VALIDATORS"],
                        // tslint:disable-next-line:no-forward-ref
                        useExisting: Object(core_es5["forwardRef"])(function () { return universal_directive_MaxValidatorDirective; }),
                        multi: true
                    }]
            },] },
];
/** @nocollapse */
universal_directive_MaxValidatorDirective.ctorParameters = function () { return []; };
universal_directive_MaxValidatorDirective.propDecorators = {
    'max': [{ type: core_es5["Input"] },],
};
var universal_directive_MinValidatorDirective = (function () {
    function MinValidatorDirective() {
    }
    MinValidatorDirective.prototype.ngOnInit = function () {
        this.validator = universal_validators_UniversalValidators.min(this.min);
    };
    MinValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    return MinValidatorDirective;
}());

universal_directive_MinValidatorDirective.decorators = [
    { type: core_es5["Directive"], args: [{
                selector: '[min][formControlName],[min][formControl],[min][ngModel]',
                providers: [{
                        provide: forms_es5["NG_VALIDATORS"],
                        // tslint:disable-next-line:no-forward-ref
                        useExisting: Object(core_es5["forwardRef"])(function () { return universal_directive_MinValidatorDirective; }),
                        multi: true
                    }]
            },] },
];
/** @nocollapse */
universal_directive_MinValidatorDirective.ctorParameters = function () { return []; };
universal_directive_MinValidatorDirective.propDecorators = {
    'min': [{ type: core_es5["Input"] },],
};
//# sourceMappingURL=universal.directive.js.map
// CONCATENATED MODULE: ./node_modules/ngx-validators/src/creditcard/creditcard-validators.js

var visaRegex = '^(?:4[0-9]{12})(?:[0-9]{3})?$';
var americanExpressRegex = '^(?:3[47][0-9]{13})$';
var maestroRegex = '^(?:(?:5[0678]\\d\\d|6304|6390|67\\d\\d)\\d{8,15})$';
var jcbRegex = '^(?:(?:2131|1800|35\\d{3})\\d{11})$';
var discoverRegex = '^(?:6(?:011|5[0-9]{2})(?:[0-9]{12}))$';
var dinersclubRegex = '^(?:3(?:0[0-5]|[68][0-9])[0-9]{11})$';
var mastercardRegex = '^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$';
var creditcard_validators_CreditCardValidators = (function () {
    function CreditCardValidators() {
    }
    CreditCardValidators.isCreditCard = function (control) {
        if (Util.isNotPresent(control))
            return undefined;
        if (new RegExp(americanExpressRegex + '|' +
            visaRegex + '|' +
            maestroRegex + '|' +
            jcbRegex + '|' +
            discoverRegex + '|' +
            mastercardRegex + '|' +
            dinersclubRegex).test(control.value)) {
            return undefined;
        }
        return { 'creditcard': true };
    };
    ;
    CreditCardValidators.americanExpress = function (control) {
        if (Util.isNotPresent(control))
            return undefined;
        if (new RegExp(americanExpressRegex).test(control.value)) {
            return undefined;
        }
        return { 'americanExpress': true };
    };
    ;
    CreditCardValidators.dinersclub = function (control) {
        if (Util.isNotPresent(control))
            return undefined;
        if (new RegExp(dinersclubRegex).test(control.value)) {
            return undefined;
        }
        return { 'dinersclub': true };
    };
    ;
    CreditCardValidators.discover = function (control) {
        if (Util.isNotPresent(control))
            return undefined;
        if (new RegExp(discoverRegex).test(control.value)) {
            return undefined;
        }
        return { 'discover': true };
    };
    ;
    CreditCardValidators.jcb = function (control) {
        if (Util.isNotPresent(control))
            return undefined;
        if (new RegExp(jcbRegex).test(control.value)) {
            return undefined;
        }
        return { 'jcb': true };
    };
    ;
    CreditCardValidators.maestro = function (control) {
        if (Util.isNotPresent(control))
            return undefined;
        if (new RegExp(maestroRegex).test(control.value)) {
            return undefined;
        }
        return { 'maestro': true };
    };
    ;
    CreditCardValidators.mastercard = function (control) {
        if (Util.isNotPresent(control))
            return undefined;
        if (new RegExp(mastercardRegex).test(control.value)) {
            return undefined;
        }
        return { 'mastercard': true };
    };
    ;
    CreditCardValidators.visa = function (control) {
        if (Util.isNotPresent(control))
            return undefined;
        if (new RegExp(visaRegex).test(control.value)) {
            return undefined;
        }
        return { 'visa': true };
    };
    ;
    return CreditCardValidators;
}());

//# sourceMappingURL=creditcard-validators.js.map
// CONCATENATED MODULE: ./node_modules/ngx-validators/src/creditcard/creditcard.directive.js



var creditcard_directive_CreditCardValidatorDirective = (function () {
    function CreditCardValidatorDirective() {
        this.creditCard = 'all';
    }
    CreditCardValidatorDirective.prototype.ngOnInit = function () {
        switch (this.creditCard) {
            case 'all':
                this.validator = creditcard_validators_CreditCardValidators.isCreditCard;
                break;
            case 'americanExpress':
                this.validator = creditcard_validators_CreditCardValidators.americanExpress;
                break;
            case 'dinersclub':
                this.validator = creditcard_validators_CreditCardValidators.dinersclub;
                break;
            case 'discover':
                this.validator = creditcard_validators_CreditCardValidators.discover;
                break;
            case 'jcb':
                this.validator = creditcard_validators_CreditCardValidators.jcb;
                break;
            case 'maestro':
                this.validator = creditcard_validators_CreditCardValidators.maestro;
                break;
            case 'mastercard':
                this.validator = creditcard_validators_CreditCardValidators.mastercard;
                break;
            case 'visa':
                this.validator = creditcard_validators_CreditCardValidators.visa;
                break;
            default:
                this.validator = creditcard_validators_CreditCardValidators.isCreditCard;
                break;
        }
    };
    CreditCardValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    return CreditCardValidatorDirective;
}());

creditcard_directive_CreditCardValidatorDirective.decorators = [
    { type: core_es5["Directive"], args: [{
                selector: '[creditCard][formControlName],[creditCard][formControl],[creditCard][ngModel]',
                providers: [{
                        provide: forms_es5["NG_VALIDATORS"],
                        // tslint:disable-next-line:no-forward-ref
                        useExisting: Object(core_es5["forwardRef"])(function () { return creditcard_directive_CreditCardValidatorDirective; }),
                        multi: true
                    }]
            },] },
];
/** @nocollapse */
creditcard_directive_CreditCardValidatorDirective.ctorParameters = function () { return []; };
creditcard_directive_CreditCardValidatorDirective.propDecorators = {
    'creditCard': [{ type: core_es5["Input"] },],
};
//# sourceMappingURL=creditcard.directive.js.map
// CONCATENATED MODULE: ./node_modules/ngx-validators/src/password/password-validators.js

// tslint:disable-next-line:variable-name
var password_validators_PasswordValidators = (function () {
    function PasswordValidators() {
    }
    PasswordValidators.repeatCharacterRegexRule = function (repeatCount) {
        var validator = function (control) {
            if (Util.isNotPresent(control))
                return undefined;
            var repeatDec = repeatCount - 1;
            var pattern = '([^\\x00-\\x1F])\\1{' + repeatDec + '}';
            if (control.value !== '' && new RegExp(pattern).test(control.value)) {
                return { 'repeatCharacterRegexRule': { 'repeatCount': repeatCount } };
            }
            return undefined;
        };
        return validator;
    };
    ;
    PasswordValidators.allowedCharacterRule = function (allowedChars) {
        var validator = function (control) {
            if (Util.isNotPresent(control))
                return undefined;
            var value = control.value;
            var valid = true;
            var invalidChars = [];
            for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
                var char = value_1[_i];
                if (allowedChars.indexOf(char) === -1) {
                    valid = false;
                    if (invalidChars.indexOf(char) === -1) {
                        invalidChars.push(char);
                    }
                }
            }
            if (!valid) {
                return { 'allowedCharacterRule': { 'invalidChars': invalidChars, 'allowedChars': allowedChars } };
            }
            return undefined;
        };
        return validator;
    };
    ;
    PasswordValidators.alphabeticalCharacterRule = function (amount) {
        var validator = function (control) {
            if (Util.isNotPresent(control))
                return undefined;
            var value = control.value;
            if (value.length === 0) {
                return undefined;
            }
            var pattern = /[^A-Za-z]+/g;
            var stripped = value.replace(pattern, '');
            if (stripped.length < amount) {
                return { 'alphabeticalCharacterRule': { 'required': amount, 'actual': stripped.length } };
            }
            return undefined;
        };
        return validator;
    };
    ;
    PasswordValidators.digitCharacterRule = function (amount) {
        var validator = function (control) {
            if (Util.isNotPresent(control))
                return undefined;
            var value = control.value;
            if (value.length === 0) {
                return undefined;
            }
            var pattern = /[^0-9\.]+/g;
            var stripped = value.replace(pattern, '');
            if (stripped.length < amount) {
                return { 'digitCharacterRule': { 'required': amount, 'actual': stripped.length } };
            }
            return undefined;
        };
        return validator;
    };
    ;
    PasswordValidators.lowercaseCharacterRule = function (amount) {
        var validator = function (control) {
            if (Util.isNotPresent(control))
                return undefined;
            var value = control.value;
            if (value.length === 0) {
                return undefined;
            }
            var pattern = /[^a-z]+/g;
            var stripped = value.replace(pattern, '');
            if (stripped.length < amount) {
                return { 'lowercaseCharacterRule': { 'required': amount, 'actual': stripped.length } };
            }
            return undefined;
        };
        return validator;
    };
    ;
    PasswordValidators.uppercaseCharacterRule = function (amount) {
        var validator = function (control) {
            if (Util.isNotPresent(control))
                return undefined;
            var value = control.value;
            if (value.length === 0) {
                return undefined;
            }
            var pattern = /[^A-Z]+/g;
            var stripped = value.replace(pattern, '');
            if (stripped.length < amount) {
                return { 'uppercaseCharacterRule': { 'required': amount, 'actual': stripped.length } };
            }
            return undefined;
        };
        return validator;
    };
    ;
    PasswordValidators.specialCharacterRule = function (amount) {
        var validator = function (control) {
            if (Util.isNotPresent(control))
                return undefined;
            var value = control.value;
            if (value.length === 0) {
                return undefined;
            }
            var pattern = /[\w\s]+/g;
            var stripped = value.replace(pattern, '');
            if (stripped.length < amount) {
                return { 'specialCharacterRule': { 'required': amount, 'actual': stripped.length } };
            }
            return undefined;
        };
        return validator;
    };
    ;
    PasswordValidators.mismatchedPasswords = function (passwordControlName, confirmPasswordControlName) {
        var validator = function (group) {
            var newPasswordValue = group.get(passwordControlName ? passwordControlName : 'newPassword').value;
            var newPasswordConfirmValue = group.get(confirmPasswordControlName ? confirmPasswordControlName : 'confirmPassword').value;
            if (newPasswordValue !== newPasswordConfirmValue) {
                Util.addError(group.get(confirmPasswordControlName ? confirmPasswordControlName : 'confirmPassword'), 'mismatchedPasswords', true);
                return { 'mismatchedPasswords': true };
            }
            else {
                Util.removeError(group.get(confirmPasswordControlName ? confirmPasswordControlName : 'confirmPassword'), 'mismatchedPasswords');
            }
            return undefined;
        };
        return validator;
    };
    ;
    return PasswordValidators;
}());

//# sourceMappingURL=password-validators.js.map
// CONCATENATED MODULE: ./node_modules/ngx-validators/src/password/password.directive.js



var password_directive_PasswordValidatorDirective = (function () {
    function PasswordValidatorDirective() {
        this.repeatCharacter = 4;
        this.alphabeticalCharacter = 1;
        this.digitCharacter = 1;
        this.lowercaseCharacter = 1;
        this.uppercaseCharacter = 1;
    }
    PasswordValidatorDirective.prototype.ngOnInit = function () {
        this.repeatCharacterValidator = password_validators_PasswordValidators.repeatCharacterRegexRule(this.repeatCharacter);
        this.alphabeticalCharacterValidator = password_validators_PasswordValidators.alphabeticalCharacterRule(this.alphabeticalCharacter);
        this.digitCharacterValidator = password_validators_PasswordValidators.digitCharacterRule(this.digitCharacter);
        this.lowercaseCharacterValidator = password_validators_PasswordValidators.lowercaseCharacterRule(this.lowercaseCharacter);
        this.uppercaseCharacterValidator = password_validators_PasswordValidators.uppercaseCharacterRule(this.uppercaseCharacter);
    };
    PasswordValidatorDirective.prototype.validate = function (c) {
        var compose = forms_es5["Validators"].compose([this.repeatCharacterValidator,
            this.digitCharacterValidator, this.alphabeticalCharacterValidator,
            this.lowercaseCharacterValidator, this.uppercaseCharacterValidator]);
        return compose(c);
    };
    return PasswordValidatorDirective;
}());

password_directive_PasswordValidatorDirective.decorators = [
    { type: core_es5["Directive"], args: [{
                selector: '[password][formControlName],[password][formControl],[password][ngModel]',
                providers: [{
                        provide: forms_es5["NG_VALIDATORS"],
                        // tslint:disable-next-line:no-forward-ref
                        useExisting: Object(core_es5["forwardRef"])(function () { return password_directive_PasswordValidatorDirective; }),
                        multi: true
                    }]
            },] },
];
/** @nocollapse */
password_directive_PasswordValidatorDirective.ctorParameters = function () { return []; };
password_directive_PasswordValidatorDirective.propDecorators = {
    'repeatCharacter': [{ type: core_es5["Input"] },],
    'alphabeticalCharacter': [{ type: core_es5["Input"] },],
    'digitCharacter': [{ type: core_es5["Input"] },],
    'lowercaseCharacter': [{ type: core_es5["Input"] },],
    'uppercaseCharacter': [{ type: core_es5["Input"] },],
};
//# sourceMappingURL=password.directive.js.map
// CONCATENATED MODULE: ./node_modules/ngx-validators/src/validators.module.js







var ValidatorsModule = (function () {
    function ValidatorsModule() {
    }
    return ValidatorsModule;
}());

ValidatorsModule.decorators = [
    { type: core_es5["NgModule"], args: [{
                declarations: [creditcard_directive_CreditCardValidatorDirective,
                    email_directive_EmailValidatorDirective,
                    password_directive_PasswordValidatorDirective,
                    universal_directive_IsInRangeValidatorDirective,
                    universal_directive_IsNumberValidatorDirective,
                    universal_directive_MaxValidatorDirective,
                    universal_directive_MinValidatorDirective,
                    universal_directive_WhiteSpaceValidatorDirective,
                    phone_directive_PhoneValidatorDirective,
                    phone_directive_PossiblePhoneValidatorDirective,
                    universal_directive_EmptyStringValidatorDirective,
                    phone_directive_CountryCodeValidatorDirective],
                exports: [creditcard_directive_CreditCardValidatorDirective,
                    email_directive_EmailValidatorDirective,
                    password_directive_PasswordValidatorDirective,
                    universal_directive_IsInRangeValidatorDirective,
                    universal_directive_IsNumberValidatorDirective,
                    universal_directive_MaxValidatorDirective,
                    universal_directive_MinValidatorDirective,
                    universal_directive_WhiteSpaceValidatorDirective,
                    phone_directive_PhoneValidatorDirective,
                    phone_directive_PossiblePhoneValidatorDirective,
                    universal_directive_EmptyStringValidatorDirective,
                    phone_directive_CountryCodeValidatorDirective]
            },] },
];
/** @nocollapse */
ValidatorsModule.ctorParameters = function () { return []; };
//# sourceMappingURL=validators.module.js.map
// EXTERNAL MODULE: ./node_modules/angular2-text-mask/dist/angular2TextMask.js
var angular2TextMask = __webpack_require__("VWgf");
var angular2TextMask_default = /*#__PURE__*/__webpack_require__.n(angular2TextMask);

// EXTERNAL MODULE: ./node_modules/ngx-mydatepicker/dist/ngx-my-date-picker.module.js
var ngx_my_date_picker_module = __webpack_require__("maWo");

// EXTERNAL MODULE: ./node_modules/mydaterangepicker/dist/my-date-range-picker.module.js
var my_date_range_picker_module = __webpack_require__("P/e1");

// CONCATENATED MODULE: ./node_modules/ngx-uploader/src/ngx-uploader/module/ngx-uploader.module.ts
var module_ngx_uploader_module_NgUploaderModule = /** @class */ (function () {
    function NgUploaderModule() {
    }
    return NgUploaderModule;
}());

//# sourceMappingURL=ngx-uploader.module.js.map
// EXTERNAL MODULE: ./node_modules/ngx-tooltip/index.js
var ngx_tooltip = __webpack_require__("IfaC");
var ngx_tooltip_default = /*#__PURE__*/__webpack_require__.n(ngx_tooltip);

// CONCATENATED MODULE: ./node_modules/@swimlane/ngx-dnd/release/directives/ngx-drag-handle.directive.js

/**
 * Adds properties and events to drag handle elements
 *
 * @export
 * @class DragHandleDirective
 */
var ngx_drag_handle_directive_DragHandleDirective = (function () {
    function DragHandleDirective() {
    }
    DragHandleDirective.decorators = [
        { type: core_es5["Directive"], args: [{ selector: '[ngxDragHandle]' },] },
    ];
    /** @nocollapse */
    DragHandleDirective.ctorParameters = function () { return []; };
    return DragHandleDirective;
}());

//# sourceMappingURL=ngx-drag-handle.directive.js.map
// CONCATENATED MODULE: ./node_modules/@swimlane/ngx-dnd/release/directives/index.js



//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/@swimlane/ngx-dnd/release/components/container/container.component.js


var container_component_i = 0;
function container_component_getNextId() {
    return container_component_i++;
}
/**
 * Component that allows nested ngxDroppable and ngxDraggables
 *
 * @export
 * @class ContainerComponent
 * @implements {OnInit}
 * @implements {AfterViewInit}
 */
var container_component_ContainerComponent = (function () {
    function ContainerComponent() {
        this.copy = false;
        this.removeOnSpill = false;
        this.dropZone = "@@DefaultDropZone-" + container_component_getNextId() + "@@";
        this.drop = new core_es5["EventEmitter"]();
        this.drag = new core_es5["EventEmitter"]();
        this.over = new core_es5["EventEmitter"]();
        this.out = new core_es5["EventEmitter"]();
        this.remove = new core_es5["EventEmitter"]();
        this.cancel = new core_es5["EventEmitter"]();
    }
    Object.defineProperty(ContainerComponent.prototype, "dropZones", {
        get: function () {
            return this._dropZones || this._defaultZones;
        },
        set: function (val) {
            this._dropZones = val;
        },
        enumerable: true,
        configurable: true
    });
    ContainerComponent.prototype.ngOnInit = function () {
        this._defaultZones = [this.dropZone];
    };
    ContainerComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.droppable.drag.subscribe(function (v) { return _this.drag.emit(v); });
        this.droppable.drop.subscribe(function (v) { return _this.drop.emit(v); });
        this.droppable.over.subscribe(function (v) { return _this.over.emit(v); });
        this.droppable.out.subscribe(function (v) { return _this.out.emit(v); });
        this.droppable.remove.subscribe(function (v) { return _this.remove.emit(v); });
        this.droppable.cancel.subscribe(function (v) { return _this.cancel.emit(v); });
    };
    ContainerComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'ngx-dnd-container',
                    templateUrl: './container.component.html',
                    styleUrls: ['./container.component.css'],
                    encapsulation: core_es5["ViewEncapsulation"].None
                },] },
    ];
    /** @nocollapse */
    ContainerComponent.ctorParameters = function () { return []; };
    ContainerComponent.propDecorators = {
        'model': [{ type: core_es5["Input"] },],
        'copy': [{ type: core_es5["Input"] },],
        'removeOnSpill': [{ type: core_es5["Input"] },],
        'droppableItemClass': [{ type: core_es5["Input"] },],
        'dropZone': [{ type: core_es5["Input"] },],
        'dropZones': [{ type: core_es5["Input"] },],
        'moves': [{ type: core_es5["Input"] },],
        'template': [{ type: core_es5["Input"] }, { type: core_es5["ContentChild"], args: [core_es5["TemplateRef"],] },],
        'droppable': [{ type: core_es5["Input"] }, { type: core_es5["ViewChild"], args: [ngx_droppable_directive_DroppableDirective,] },],
        'drop': [{ type: core_es5["Output"] },],
        'drag': [{ type: core_es5["Output"] },],
        'over': [{ type: core_es5["Output"] },],
        'out': [{ type: core_es5["Output"] },],
        'remove': [{ type: core_es5["Output"] },],
        'cancel': [{ type: core_es5["Output"] },],
    };
    return ContainerComponent;
}());

//# sourceMappingURL=container.component.js.map
// CONCATENATED MODULE: ./node_modules/@swimlane/ngx-dnd/release/components/item/item.component.js



/**
 * Component that allows nested ngxDroppable and ngxDraggables
 * Should only be use inside a ngx-dnd-container
 * Outside a ngx-dnd-container use ngxDroppable
 *
 * @export
 * @class ItemComponent
 * @implements {OnInit}
 */
var item_component_ItemComponent = (function () {
    function ItemComponent(container, draggableDirective) {
        this.container = container;
        this.draggableDirective = draggableDirective;
        this._copy = false;
        this._removeOnSpill = false;
    }
    Object.defineProperty(ItemComponent.prototype, "dropZone", {
        get: function () {
            return this._dropZone || this.container.dropZone;
        },
        set: function (val) {
            this._dropZone = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemComponent.prototype, "dropZones", {
        get: function () {
            return this._dropZones || this.container.dropZones;
        },
        set: function (val) {
            this._dropZones = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemComponent.prototype, "droppableItemClass", {
        get: function () {
            return this._droppableItemClass || this.container.droppableItemClass;
        },
        set: function (val) {
            this._droppableItemClass = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemComponent.prototype, "removeOnSpill", {
        get: function () {
            return typeof this._removeOnSpill === 'boolean' ? this._removeOnSpill : this.container.removeOnSpill;
        },
        set: function (val) {
            this._removeOnSpill = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemComponent.prototype, "copy", {
        get: function () {
            return typeof this._copy === 'boolean' ? this._copy : this.container.copy;
        },
        set: function (val) {
            this._copy = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemComponent.prototype, "hasHandle", {
        get: function () {
            return this.draggableDirective.hasHandle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemComponent.prototype, "moveDisabled", {
        get: function () {
            return !this.draggableDirective.canMove();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemComponent.prototype, "classString", {
        get: function () {
            var itemClass = (typeof this.droppableItemClass === 'function') ?
                this.droppableItemClass(this.model) :
                this.droppableItemClass;
            var classes = ['ngx-dnd-item', itemClass || ''];
            if (this.moveDisabled) {
                classes.push('move-disabled');
            }
            if (this.hasHandle) {
                classes.push('has-handle');
            }
            return classes.join(' ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemComponent.prototype, "type", {
        get: function () {
            if (Array.isArray(this.model)) {
                return 'array';
            }
            return typeof this.model;
        },
        enumerable: true,
        configurable: true
    });
    ItemComponent.prototype.ngOnInit = function () {
        this.data = {
            model: this.model,
            type: this.type,
            dropZone: this.dropZone,
            template: this.container.template
        };
    };
    ItemComponent.decorators = [
        { type: core_es5["Component"], args: [{
                    selector: 'ngx-dnd-item',
                    templateUrl: './item.component.html',
                    styleUrls: ['./item.component.css'],
                    encapsulation: core_es5["ViewEncapsulation"].None
                },] },
    ];
    /** @nocollapse */
    ItemComponent.ctorParameters = function () { return [
        { type: container_component_ContainerComponent, },
        { type: ngx_draggable_directive_DraggableDirective, },
    ]; };
    ItemComponent.propDecorators = {
        'model': [{ type: core_es5["Input"] },],
        'dropZone': [{ type: core_es5["Input"] },],
        'dropZones': [{ type: core_es5["Input"] },],
        'droppableItemClass': [{ type: core_es5["Input"] },],
        'removeOnSpill': [{ type: core_es5["Input"] },],
        'copy': [{ type: core_es5["Input"] },],
        'classString': [{ type: core_es5["HostBinding"], args: ['class',] },],
    };
    return ItemComponent;
}());

//# sourceMappingURL=item.component.js.map
// CONCATENATED MODULE: ./node_modules/@swimlane/ngx-dnd/release/components/index.js


//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/@swimlane/ngx-dnd/release/services/index.js

//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/@swimlane/ngx-dnd/release/ngx-dnd.module.js





var components = [container_component_ContainerComponent, item_component_ItemComponent];
var directives = [ngx_draggable_directive_DraggableDirective, ngx_droppable_directive_DroppableDirective, ngx_drag_handle_directive_DragHandleDirective];
var ngx_dnd_module_NgxDnDModule = (function () {
    function NgxDnDModule() {
    }
    NgxDnDModule.decorators = [
        { type: core_es5["NgModule"], args: [{
                    imports: [
                        common_es5["CommonModule"]
                    ],
                    declarations: components.concat(directives),
                    exports: components.concat(directives),
                    providers: [drake_store_service_DrakeStoreService]
                },] },
    ];
    /** @nocollapse */
    NgxDnDModule.ctorParameters = function () { return []; };
    return NgxDnDModule;
}());

//# sourceMappingURL=ngx-dnd.module.js.map
// CONCATENATED MODULE: ./node_modules/ngx-currency/src/currency-mask.module.js





var currency_mask_module_NgxCurrencyModule = (function () {
    function NgxCurrencyModule() {
    }
    NgxCurrencyModule.forRoot = function (config) {
        return {
            ngModule: NgxCurrencyModule,
            providers: [{
                    provide: CURRENCY_MASK_CONFIG,
                    useValue: config,
                }]
        };
    };
    return NgxCurrencyModule;
}());

currency_mask_module_NgxCurrencyModule.decorators = [
    { type: core_es5["NgModule"], args: [{
                imports: [common_es5["CommonModule"], forms_es5["FormsModule"]],
                declarations: [currency_mask_directive_CurrencyMaskDirective],
                exports: [currency_mask_directive_CurrencyMaskDirective]
            },] },
];
/** @nocollapse */
currency_mask_module_NgxCurrencyModule.ctorParameters = function () { return []; };
//# sourceMappingURL=currency-mask.module.js.map
// CONCATENATED MODULE: ./compiled/app/app.module.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


























































































































































































var AppModuleNgFactory = core_es5["ɵcmf"](AppModule, [app_component_AppComponent], function (_l) {
    return core_es5["ɵmod"]([core_es5["ɵmpd"](512, core_es5["ComponentFactoryResolver"], core_es5["ɵCodegenComponentFactoryResolver"], [[8, [ToastContainerNgFactory, ModalBackdropComponentNgFactory, ModalContainerComponentNgFactory,
                    BsDropdownContainerComponentNgFactory, NgxMyDatePickerNgFactory,
                    TooltipContentNgFactory, LayoutComponentNgFactory, DashboardComponentNgFactory,
                    CustomerManagementComponentNgFactory, CustomersImportComponentNgFactory,
                    LocationManagementComponentNgFactory, ProductManagementComponentNgFactory,
                    OrderManagementComponentNgFactory, AmazonSellerManagementComponentNgFactory,
                    AmazonStoreManagementNgFactory, AgentManagementComponentNgFactory,
                    CalculatorComponentNgFactory, CurrencyDashBoardComponentNgFactory,
                    OrderDetailsNgFactory, TotalFeeReportComponentNgFactory, TotalQuantityReportComponentNgFactory,
                    RnsStatusComponentNgFactory, ZonosComponentNgFactory, AmazonProductExportComponentNgFactory,
                    OrderExportComponentNgFactory, AmazonComponentNgFactory, AmazonInfoComponentNgFactory,
                    AmazonSellerFormComponentNgFactory, AmazonCredentialsComponentNgFactory,
                    AmazonDashboardComponentNgFactory, AmazonStoreProductsComponentNgFactory,
                    AmazonInstructionsComponentNgFactory, AmazonCongratulationComponentNgFactory,
                    AuthLayoutComponentNgFactory, GoogleLoginComponentNgFactory, RegisterComponentNgFactory,
                    ForgotPasswordComponentNgFactory, ResetPasswordComponentNgFactory,
                    PaymentRedirectComponentNgFactory, PublicCalculatorComponentNgFactory,
                    OrderPaymentComponentNgFactory, ApiDocumentationComponentNgFactory,
                    ParsStatusWidgetComponentNgFactory, ParsStatusRefreshComponentNgFactory,
                    AppComponentNgFactory]], [3, core_es5["ComponentFactoryResolver"]], core_es5["NgModuleRef"]]),
        core_es5["ɵmpd"](5120, core_es5["LOCALE_ID"], core_es5["ɵm"], [[3, core_es5["LOCALE_ID"]]]), core_es5["ɵmpd"](4608, common_es5["NgLocalization"], common_es5["NgLocaleLocalization"], [core_es5["LOCALE_ID"]]), core_es5["ɵmpd"](5120, core_es5["APP_ID"], core_es5["ɵf"], []), core_es5["ɵmpd"](5120, core_es5["IterableDiffers"], core_es5["ɵk"], []),
        core_es5["ɵmpd"](5120, core_es5["KeyValueDiffers"], core_es5["ɵl"], []), core_es5["ɵmpd"](4608, platform_browser_es5["DomSanitizer"], platform_browser_es5["ɵe"], [common_es5["DOCUMENT"]]), core_es5["ɵmpd"](6144, core_es5["Sanitizer"], null, [platform_browser_es5["DomSanitizer"]]),
        core_es5["ɵmpd"](4608, platform_browser_es5["HAMMER_GESTURE_CONFIG"], platform_browser_es5["HammerGestureConfig"], []),
        core_es5["ɵmpd"](5120, platform_browser_es5["EVENT_MANAGER_PLUGINS"], function (p0_0, p1_0, p2_0, p2_1) {
            return [new platform_browser_es5["ɵDomEventsPlugin"](p0_0), new platform_browser_es5["ɵKeyEventsPlugin"](p1_0),
                new platform_browser_es5["ɵHammerGesturesPlugin"](p2_0, p2_1)];
        }, [common_es5["DOCUMENT"], common_es5["DOCUMENT"], common_es5["DOCUMENT"], platform_browser_es5["HAMMER_GESTURE_CONFIG"]]), core_es5["ɵmpd"](4608, platform_browser_es5["EventManager"], platform_browser_es5["EventManager"], [platform_browser_es5["EVENT_MANAGER_PLUGINS"], core_es5["NgZone"]]),
        core_es5["ɵmpd"](135680, platform_browser_es5["ɵDomSharedStylesHost"], platform_browser_es5["ɵDomSharedStylesHost"], [common_es5["DOCUMENT"]]),
        core_es5["ɵmpd"](4608, platform_browser_es5["ɵDomRendererFactory2"], platform_browser_es5["ɵDomRendererFactory2"], [platform_browser_es5["EventManager"],
            platform_browser_es5["ɵDomSharedStylesHost"]]), core_es5["ɵmpd"](5120, browser_es5["a" /* AnimationDriver */], animations_es5["d" /* ɵc */], []),
        core_es5["ɵmpd"](5120, browser_es5["c" /* ɵAnimationStyleNormalizer */], animations_es5["e" /* ɵd */], []), core_es5["ɵmpd"](4608, browser_es5["b" /* ɵAnimationEngine */], animations_es5["c" /* ɵb */], [browser_es5["a" /* AnimationDriver */], browser_es5["c" /* ɵAnimationStyleNormalizer */]]),
        core_es5["ɵmpd"](5120, core_es5["RendererFactory2"], animations_es5["f" /* ɵe */], [platform_browser_es5["ɵDomRendererFactory2"], browser_es5["b" /* ɵAnimationEngine */],
            core_es5["NgZone"]]), core_es5["ɵmpd"](6144, platform_browser_es5["ɵSharedStylesHost"], null, [platform_browser_es5["ɵDomSharedStylesHost"]]),
        core_es5["ɵmpd"](4608, core_es5["Testability"], core_es5["Testability"], [core_es5["NgZone"]]), core_es5["ɵmpd"](4608, platform_browser_es5["Meta"], platform_browser_es5["Meta"], [common_es5["DOCUMENT"]]), core_es5["ɵmpd"](4608, platform_browser_es5["Title"], platform_browser_es5["Title"], [common_es5["DOCUMENT"]]),
        core_es5["ɵmpd"](4608, forms_es5["ɵi"], forms_es5["ɵi"], []), core_es5["ɵmpd"](4608, forms_es5["FormBuilder"], forms_es5["FormBuilder"], []), core_es5["ɵmpd"](4608, _angular_animations_es5["b" /* AnimationBuilder */], animations_es5["b" /* ɵBrowserAnimationBuilder */], [core_es5["RendererFactory2"], platform_browser_es5["DOCUMENT"]]), core_es5["ɵmpd"](4608, scrollbar_helper_service["ScrollbarHelper"], scrollbar_helper_service["ScrollbarHelper"], [platform_browser_es5["DOCUMENT"]]), core_es5["ɵmpd"](4608, dimensions_helper_service["DimensionsHelper"], dimensions_helper_service["DimensionsHelper"], []), core_es5["ɵmpd"](4608, GooglePlaceService, GooglePlaceService, []), core_es5["ɵmpd"](4608, ngx_pagination_PaginationService, ngx_pagination_PaginationService, []), core_es5["ɵmpd"](4608, drake_store_service_DrakeStoreService, drake_store_service_DrakeStoreService, []), core_es5["ɵmpd"](4608, carousel_config_CarouselConfig, carousel_config_CarouselConfig, []), core_es5["ɵmpd"](5120, router_es5["a" /* ActivatedRoute */], router_es5["A" /* ɵf */], [router_es5["n" /* Router */]]), core_es5["ɵmpd"](4608, router_es5["g" /* NoPreloading */], router_es5["g" /* NoPreloading */], []),
        core_es5["ɵmpd"](6144, router_es5["i" /* PreloadingStrategy */], null, [router_es5["g" /* NoPreloading */]]), core_es5["ɵmpd"](135680, router_es5["s" /* RouterPreloader */], router_es5["s" /* RouterPreloader */], [router_es5["n" /* Router */], core_es5["NgModuleFactoryLoader"],
            core_es5["Compiler"], core_es5["Injector"], router_es5["i" /* PreloadingStrategy */]]), core_es5["ɵmpd"](4608, router_es5["h" /* PreloadAllModules */], router_es5["h" /* PreloadAllModules */], []), core_es5["ɵmpd"](5120, router_es5["k" /* ROUTER_INITIALIZER */], router_es5["D" /* ɵi */], [router_es5["B" /* ɵg */]]), core_es5["ɵmpd"](5120, core_es5["APP_BOOTSTRAP_LISTENER"], function (p0_0) {
            return [p0_0];
        }, [router_es5["k" /* ROUTER_INITIALIZER */]]), core_es5["ɵmpd"](4608, toast_options["ToastOptions"], app_module_CustomToastOption, []), core_es5["ɵmpd"](4608, toast_manager["ToastsManager"], toast_manager["ToastsManager"], [core_es5["ComponentFactoryResolver"],
            core_es5["NgZone"], core_es5["ApplicationRef"], toast_options["ToastOptions"]]), core_es5["ɵmpd"](4608, positioning_service["a" /* PositioningService */], positioning_service["a" /* PositioningService */], []), core_es5["ɵmpd"](4608, component_loader_factory["a" /* ComponentLoaderFactory */], component_loader_factory["a" /* ComponentLoaderFactory */], [core_es5["ComponentFactoryResolver"], core_es5["NgZone"], core_es5["Injector"],
            positioning_service["a" /* PositioningService */], core_es5["ApplicationRef"]]), core_es5["ɵmpd"](4608, bs_modal_service["a" /* BsModalService */], bs_modal_service["a" /* BsModalService */], [component_loader_factory["a" /* ComponentLoaderFactory */]]), core_es5["ɵmpd"](4608, accordion_config_AccordionConfig, accordion_config_AccordionConfig, []), core_es5["ɵmpd"](4608, bs_dropdown_state["a" /* BsDropdownState */], bs_dropdown_state["a" /* BsDropdownState */], []), core_es5["ɵmpd"](4608, ngx_my_date_picker_config["a" /* NgxMyDatePickerConfig */], ngx_my_date_picker_config["a" /* NgxMyDatePickerConfig */], []), core_es5["ɵmpd"](4608, ng2_cookies_cookie["CookieService"], ng2_cookies_cookie["CookieService"], []), core_es5["ɵmpd"](4608, services_userService["a" /* UserService */], services_userService["a" /* UserService */], [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, appService_AppService, appService_AppService, [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, sipService_SipService, sipService_SipService, [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, managers_storageManager["a" /* StorageManager */], managers_storageManager["a" /* StorageManager */], [services_userService["a" /* UserService */], ng2_cookies_cookie["CookieService"], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, authGuard_AuthGuard, authGuard_AuthGuard, [services_configService["a" /* ConfigService */], managers_storageManager["a" /* StorageManager */], router_es5["n" /* Router */]]),
        core_es5["ɵmpd"](4608, appGuard_AppGuard, appGuard_AppGuard, [managers_storageManager["a" /* StorageManager */], router_es5["n" /* Router */]]),
        core_es5["ɵmpd"](4608, amazon_service["a" /* AmazonService */], amazon_service["a" /* AmazonService */], [http_es5["e" /* Http */], services_configService["a" /* ConfigService */],
            ng2_cookies_cookie["CookieService"]]), core_es5["ɵmpd"](4608, amazonGuard_AmazonGuard, amazonGuard_AmazonGuard, [services_configService["a" /* ConfigService */],
            router_es5["n" /* Router */], amazon_service["a" /* AmazonService */], services_userService["a" /* UserService */]]), core_es5["ɵmpd"](4608, currencyService_CurrencyService, currencyService_CurrencyService, [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, currency_resolver_CurrencyResolver, currency_resolver_CurrencyResolver, [currencyService_CurrencyService]), core_es5["ɵmpd"](4608, googleService_GoogleService, googleService_GoogleService, [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, services_locationService["a" /* LocationService */], services_locationService["a" /* LocationService */], [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, locationManagment_resolver_LocationManagementResolver, locationManagment_resolver_LocationManagementResolver, [services_locationService["a" /* LocationService */]]), core_es5["ɵmpd"](4608, services_emailService["a" /* EmailService */], services_emailService["a" /* EmailService */], [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, logService_LogService, logService_LogService, [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, services_productService["a" /* ProductService */], services_productService["a" /* ProductService */], [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, services_orderService["a" /* OrderService */], services_orderService["a" /* OrderService */], [http_es5["e" /* Http */], services_configService["a" /* ConfigService */], router_es5["a" /* ActivatedRoute */]]), core_es5["ɵmpd"](4608, pageVisitService["a" /* PageVisitService */], pageVisitService["a" /* PageVisitService */], [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]),
        core_es5["ɵmpd"](4608, agent_management_resolver_AgentManagementResolver, agent_management_resolver_AgentManagementResolver, [services_userService["a" /* UserService */]]),
        core_es5["ɵmpd"](4608, groupService_GroupService, groupService_GroupService, [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]),
        core_es5["ɵmpd"](4608, group_resolver_GroupResolver, group_resolver_GroupResolver, [groupService_GroupService]), core_es5["ɵmpd"](4608, canadian_currency_codes_resolver_CanadianCurrencyCodesResolver, canadian_currency_codes_resolver_CanadianCurrencyCodesResolver, [currencyService_CurrencyService]), core_es5["ɵmpd"](4608, services_customerService["a" /* CustomerService */], services_customerService["a" /* CustomerService */], [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, customerManagement_resolver_CustomerManagementResolver, customerManagement_resolver_CustomerManagementResolver, [services_customerService["a" /* CustomerService */]]), core_es5["ɵmpd"](4608, productManagement_resolver_ProductManagementResolver, productManagement_resolver_ProductManagementResolver, [services_productService["a" /* ProductService */]]), core_es5["ɵmpd"](4608, services_userViewService["a" /* UserViewService */], services_userViewService["a" /* UserViewService */], [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, orderOData_service_OrderODataService, orderOData_service_OrderODataService, [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, orderManagement_resolver_OrderManagementResolver, orderManagement_resolver_OrderManagementResolver, [services_orderService["a" /* OrderService */], services_customerService["a" /* CustomerService */], services_userService["a" /* UserService */],
            services_userViewService["a" /* UserViewService */], orderOData_service_OrderODataService]), core_es5["ɵmpd"](4608, orderDetails_resolver_OrderDetailsResolver, orderDetails_resolver_OrderDetailsResolver, [services_orderService["a" /* OrderService */]]), core_es5["ɵmpd"](4608, calculator_calculatorService["a" /* CalculatorService */], calculator_calculatorService["a" /* CalculatorService */], []), core_es5["ɵmpd"](4608, services_extraDataService["a" /* ExtraDataService */], services_extraDataService["a" /* ExtraDataService */], [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, extraDataResolver_ExtraDataResolver, extraDataResolver_ExtraDataResolver, [services_extraDataService["a" /* ExtraDataService */]]), core_es5["ɵmpd"](4608, reportService_ReportService, reportService_ReportService, [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, totalAmountReport_resolver_TotalAmountReportResolver, totalAmountReport_resolver_TotalAmountReportResolver, [reportService_ReportService]), core_es5["ɵmpd"](4608, totalQuantityReport_resolver_TotalQuantityReportResolver, totalQuantityReport_resolver_TotalQuantityReportResolver, [reportService_ReportService]), core_es5["ɵmpd"](4608, uploadService_UploadService, uploadService_UploadService, [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]),
        core_es5["ɵmpd"](4608, orderContentService_OrderContentService, orderContentService_OrderContentService, [http_es5["e" /* Http */],
            services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, orderContentResolver_OrderContentResolver, orderContentResolver_OrderContentResolver, [orderContentService_OrderContentService]), core_es5["ɵmpd"](4608, allUser_resolver_AllUserResolver, allUser_resolver_AllUserResolver, [services_userService["a" /* UserService */]]), core_es5["ɵmpd"](4608, default_tarff_resolver_DefaultTariffResolver, default_tarff_resolver_DefaultTariffResolver, [services_productService["a" /* ProductService */]]), core_es5["ɵmpd"](4608, user_view_resolver_UserViewResolver, user_view_resolver_UserViewResolver, [services_userViewService["a" /* UserViewService */]]), core_es5["ɵmpd"](4608, user_view_order_resolver_UserViewOrderResolver, user_view_order_resolver_UserViewOrderResolver, [orderManagement_resolver_OrderManagementResolver, user_view_resolver_UserViewResolver]), core_es5["ɵmpd"](4608, documentService_DocumentService, documentService_DocumentService, [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, orderData_resolver_OrderDataResolver, orderData_resolver_OrderDataResolver, [documentService_DocumentService]), core_es5["ɵmpd"](4608, orderDataCBP7501_resolver_OrderDataCBP7501Resolver, orderDataCBP7501_resolver_OrderDataCBP7501Resolver, [documentService_DocumentService]), core_es5["ɵmpd"](4608, google_tag_service["a" /* GoogleTagService */], google_tag_service["a" /* GoogleTagService */], [common_es5["Location"], http_es5["e" /* Http */], services_configService["a" /* ConfigService */], router_es5["n" /* Router */]]),
        core_es5["ɵmpd"](4608, amazon_seller_management_resolver_AmazonSellerManagementResolver, amazon_seller_management_resolver_AmazonSellerManagementResolver, [amazon_service["a" /* AmazonService */]]), core_es5["ɵmpd"](4608, amazon_store_resolver_AmazonStoreResolver, amazon_store_resolver_AmazonStoreResolver, [amazon_service["a" /* AmazonService */]]), core_es5["ɵmpd"](4608, amazon_currentSelleer_resolver_AmazonCurrentSellerResolver, amazon_currentSelleer_resolver_AmazonCurrentSellerResolver, [amazon_service["a" /* AmazonService */]]), core_es5["ɵmpd"](4608, amazon_product_resolver_AmazonProductResolver, amazon_product_resolver_AmazonProductResolver, [amazon_service["a" /* AmazonService */], router_es5["n" /* Router */]]), core_es5["ɵmpd"](4608, tax_service["a" /* TaxService */], tax_service["a" /* TaxService */], [http_es5["e" /* Http */]]), core_es5["ɵmpd"](4608, services_paymentService["a" /* PaymentService */], services_paymentService["a" /* PaymentService */], [http_es5["e" /* Http */],
            services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, RNS_service_RNSService, RNS_service_RNSService, [http_es5["e" /* Http */],
            services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, publisher_service_PublisherService, publisher_service_PublisherService, [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](4608, zonos_service_ZonosService, zonos_service_ZonosService, [http_es5["e" /* Http */], services_configService["a" /* ConfigService */]]), core_es5["ɵmpd"](512, common_es5["CommonModule"], common_es5["CommonModule"], []), core_es5["ɵmpd"](512, core_es5["ErrorHandler"], app_module_customErrorHandler, [core_es5["Injector"]]),
        core_es5["ɵmpd"](1024, core_es5["NgProbeToken"], function () {
            return [router_es5["w" /* ɵb */]()];
        }, []), core_es5["ɵmpd"](512, router_es5["B" /* ɵg */], router_es5["B" /* ɵg */], [core_es5["Injector"]]), core_es5["ɵmpd"](512, http_es5["c" /* BrowserXhr */], http_es5["c" /* BrowserXhr */], []), core_es5["ɵmpd"](512, http_es5["k" /* ResponseOptions */], http_es5["b" /* BaseResponseOptions */], []), core_es5["ɵmpd"](1024, http_es5["n" /* XSRFStrategy */], http_es5["o" /* ɵb */], []), core_es5["ɵmpd"](512, http_es5["m" /* XHRBackend */], http_es5["m" /* XHRBackend */], [http_es5["c" /* BrowserXhr */], http_es5["k" /* ResponseOptions */], http_es5["n" /* XSRFStrategy */]]),
        core_es5["ɵmpd"](512, http_es5["i" /* RequestOptions */], http_es5["a" /* BaseRequestOptions */], []), core_es5["ɵmpd"](1024, http_es5["e" /* Http */], http_es5["p" /* ɵc */], [http_es5["m" /* XHRBackend */], http_es5["i" /* RequestOptions */]]), core_es5["ɵmpd"](512, services_configService["a" /* ConfigService */], services_configService["a" /* ConfigService */], [http_es5["e" /* Http */]]), core_es5["ɵmpd"](512, CountryService_CountryService, CountryService_CountryService, [http_es5["e" /* Http */]]), core_es5["ɵmpd"](1024, core_es5["APP_INITIALIZER"], function (p0_0, p0_1, p1_0, p2_0, p2_1, p3_0, p3_1) {
            return [platform_browser_es5["ɵc"](p0_0, p0_1), router_es5["C" /* ɵh */](p1_0), createConfigService(p2_0, p2_1),
                createCountryDataService(p3_0, p3_1)];
        }, [[2, platform_browser_es5["NgProbeToken"]], [2, core_es5["NgProbeToken"]], router_es5["B" /* ɵg */], services_configService["a" /* ConfigService */], core_es5["ErrorHandler"],
            CountryService_CountryService, core_es5["ErrorHandler"]]), core_es5["ɵmpd"](512, core_es5["ApplicationInitStatus"], core_es5["ApplicationInitStatus"], [[2, core_es5["APP_INITIALIZER"]]]), core_es5["ɵmpd"](131584, core_es5["ɵe"], core_es5["ɵe"], [core_es5["NgZone"], core_es5["ɵConsole"], core_es5["Injector"], core_es5["ErrorHandler"], core_es5["ComponentFactoryResolver"],
            core_es5["ApplicationInitStatus"]]), core_es5["ɵmpd"](2048, core_es5["ApplicationRef"], null, [core_es5["ɵe"]]), core_es5["ɵmpd"](512, core_es5["ApplicationModule"], core_es5["ApplicationModule"], [core_es5["ApplicationRef"]]),
        core_es5["ɵmpd"](512, platform_browser_es5["BrowserModule"], platform_browser_es5["BrowserModule"], [[3, platform_browser_es5["BrowserModule"]]]),
        core_es5["ɵmpd"](512, forms_es5["ɵba"], forms_es5["ɵba"], []), core_es5["ɵmpd"](512, forms_es5["FormsModule"], forms_es5["FormsModule"], []), core_es5["ɵmpd"](512, forms_es5["ReactiveFormsModule"], forms_es5["ReactiveFormsModule"], []), core_es5["ɵmpd"](1024, router_es5["v" /* ɵa */], router_es5["y" /* ɵd */], [[3, router_es5["n" /* Router */]]]), core_es5["ɵmpd"](512, router_es5["u" /* UrlSerializer */], router_es5["c" /* DefaultUrlSerializer */], []), core_es5["ɵmpd"](512, router_es5["b" /* ChildrenOutletContexts */], router_es5["b" /* ChildrenOutletContexts */], []),
        core_es5["ɵmpd"](256, router_es5["j" /* ROUTER_CONFIGURATION */], {}, []), core_es5["ɵmpd"](1024, common_es5["LocationStrategy"], router_es5["x" /* ɵc */], [common_es5["PlatformLocation"], [2, common_es5["APP_BASE_HREF"]], router_es5["j" /* ROUTER_CONFIGURATION */]]),
        core_es5["ɵmpd"](512, common_es5["Location"], common_es5["Location"], [common_es5["LocationStrategy"]]), core_es5["ɵmpd"](512, core_es5["Compiler"], core_es5["Compiler"], []), core_es5["ɵmpd"](512, core_es5["NgModuleFactoryLoader"], core_es5["SystemJsNgModuleLoader"], [core_es5["Compiler"], [2, core_es5["SystemJsNgModuleLoaderConfig"]]]),
        core_es5["ɵmpd"](1024, router_es5["l" /* ROUTES */], function () {
            return [[{ path: '', canActivate: [authGuard_AuthGuard], canActivateChild: [authGuard_AuthGuard],
                        component: layout_component["a" /* LayoutComponent */], children: [{ path: 'dashboard', component: dashboard_component_DashboardComponent,
                                resolve: { totalFee: totalAmountReport_resolver_TotalAmountReportResolver, totalQuantity: totalQuantityReport_resolver_TotalQuantityReportResolver,
                                    userViewOrder: user_view_order_resolver_UserViewOrderResolver, canadianCurrencyCodes: canadian_currency_codes_resolver_CanadianCurrencyCodesResolver },
                                data: { componentID: 10 } }, { path: 'management/customer', component: customerManagement_component_CustomerManagementComponent,
                                resolve: { customers: customerManagement_resolver_CustomerManagementResolver, userView: user_view_resolver_UserViewResolver,
                                    canadianCurrencyCodes: canadian_currency_codes_resolver_CanadianCurrencyCodesResolver }, data: { componentID: 4 } },
                            { path: 'management/customersImport', component: customersImport_component_CustomersImportComponent,
                                resolve: { userView: user_view_resolver_UserViewResolver }, data: { componentID: 4 } },
                            { path: '', redirectTo: 'dashboard', pathMatch: 'full' }, { path: 'management/location',
                                component: locationManagement_component_LocationManagementComponent, resolve: { locations: locationManagment_resolver_LocationManagementResolver },
                                data: { componentID: 2 } }, { path: 'management/product', component: productManagement_component_ProductManagementComponent,
                                resolve: { products: productManagement_resolver_ProductManagementResolver }, data: { componentID: 6 } },
                            { path: 'management/order', component: orderManagement_component_OrderManagementComponent,
                                resolve: { canadianCurrencyCodes: canadian_currency_codes_resolver_CanadianCurrencyCodesResolver,
                                    userViewOrder: user_view_order_resolver_UserViewOrderResolver }, data: { componentID: 7 } },
                            { path: 'management/amazon/sellers', component: amazon_seller_management_component_AmazonSellerManagementComponent,
                                resolve: { sellers: amazon_seller_management_resolver_AmazonSellerManagementResolver }, data: { componentID: 12 } },
                            { path: 'management/amazon/seller/:sellerId/store/:storeId', component: amazon_store_management_AmazonStoreManagement,
                                resolve: { seller: amazon_store_resolver_AmazonStoreResolver, products: amazon_product_resolver_AmazonProductResolver },
                                data: { componentID: 12 } }, { path: 'management/agent', component: agent_management_component_AgentManagementComponent,
                                resolve: { agents: agent_management_resolver_AgentManagementResolver, groups: group_resolver_GroupResolver,
                                    userViewOrder: user_view_order_resolver_UserViewOrderResolver }, data: { componentID: 1 } },
                            { path: 'calculator/agent', component: calculator_component_CalculatorComponent, resolve: { canadianCurrencyCodes: canadian_currency_codes_resolver_CanadianCurrencyCodesResolver,
                                    userView: user_view_resolver_UserViewResolver }, data: { componentID: 5 } }, { path: 'tariffs/exchange',
                                component: currencyDashBoard_component_CurrencyDashBoardComponent, resolve: { currencyItems: currency_resolver_CurrencyResolver },
                                data: { componentID: 3 } }, { path: 'order/:id', component: orderDetails_component_OrderDetails,
                                resolve: { order: orderDetails_resolver_OrderDetailsResolver, canadianCurrencyCodes: canadian_currency_codes_resolver_CanadianCurrencyCodesResolver,
                                    extraData: extraDataResolver_ExtraDataResolver }, data: { componentID: 9 } },
                            { path: 'report/fee', component: totalFeeReport_component_TotalFeeReportComponent, resolve: { totalFee: totalAmountReport_resolver_TotalAmountReportResolver,
                                    allAgents: allUser_resolver_AllUserResolver }, data: { componentID: 8 } }, { path: 'report/quantity',
                                component: totalQuantityReport_component_TotalQuantityReportComponent, resolve: { totalFee: totalQuantityReport_resolver_TotalQuantityReportResolver,
                                    allAgents: allUser_resolver_AllUserResolver }, data: { componentID: 8 } },
                            { path: 'report/rns/status', component: rns_status_component_RnsStatusComponent, data: { componentID: 8 } },
                            { path: 'zonos', component: zonos_component_ZonosComponent }] }, { path: 'management/amazon/seller/:sellerId/store/:storeId/export',
                        component: amazon_product_export_component_AmazonProductExportComponent, canActivate: [authGuard_AuthGuard] },
                    { path: 'order/export/all', canActivate: [authGuard_AuthGuard], component: order_export_component_OrderExportComponent },
                    { path: 'amazon', component: amazon_component["a" /* AmazonComponent */] }, { path: 'amazon/info/seller/:sellerId/store/:storeId/export',
                        component: amazon_product_export_component_AmazonProductExportComponent, canActivate: [amazonGuard_AmazonGuard] },
                    { path: 'amazon/info', component: amazon_info_component_AmazonInfoComponent, canActivateChild: [amazonGuard_AmazonGuard],
                        data: { componentID: 11 }, resolve: { AmazonCurrentSellerResolver: amazon_currentSelleer_resolver_AmazonCurrentSellerResolver },
                        children: [{ path: '', redirectTo: 'dashboard', pathMatch: 'full' }, { path: 'seller',
                                component: amazon_seller_form_component_AmazonSellerFormComponent, resolve: { AmazonCurrentSellerResolver: amazon_currentSelleer_resolver_AmazonCurrentSellerResolver } },
                            { path: 'store', component: amazon_credentials_component_AmazonCredentialsComponent, resolve: { AmazonCurrentSellerResolver: amazon_currentSelleer_resolver_AmazonCurrentSellerResolver } },
                            { path: 'dashboard', component: amazon_dashboard_component_AmazonDashboardComponent,
                                resolve: { AmazonCurrentSellerResolver: amazon_currentSelleer_resolver_AmazonCurrentSellerResolver } },
                            { path: ':sellerId/store/:storeId/products', component: amazon_store_products_component_AmazonStoreProductsComponent,
                                resolve: { AmazonCurrentSellerResolver: amazon_currentSelleer_resolver_AmazonCurrentSellerResolver,
                                    products: amazon_product_resolver_AmazonProductResolver } }, { path: 'instructions',
                                component: amazon_instructions_component_AmazonInstructionsComponent }, { path: 'congratulations',
                                component: AmazonCongratulationComponent }, { path: '**',
                                redirectTo: 'dashboard' }] }, { path: 'auth', component: authLayout_component_AuthLayoutComponent,
                        children: [{ path: '', redirectTo: '/auth/login', pathMatch: 'full' },
                            { path: 'login', component: googleLogin_component_GoogleLoginComponent }, { path: 'register',
                                component: register_component_RegisterComponent }, { path: 'forgotpassword',
                                component: forgotPassword_component_ForgotPasswordComponent }, { path: 'resetpassword',
                                component: resetPassword_component_ResetPasswordComponent }] }, { path: 'paymentredirect',
                        component: PaymentRedirectComponent }, { path: 'calculator/public',
                        component: public_calculator_component_PublicCalculatorComponent, resolve: { canadianCurrencyCodes: canadian_currency_codes_resolver_CanadianCurrencyCodesResolver,
                            order: orderDetails_resolver_OrderDetailsResolver, extraData: extraDataResolver_ExtraDataResolver } },
                    { path: 'calculator2/public', component: public_calculator_component_PublicCalculatorComponent,
                        resolve: { canadianCurrencyCodes: canadian_currency_codes_resolver_CanadianCurrencyCodesResolver,
                            defaultProducts: default_tarff_resolver_DefaultTariffResolver }, children: [{ path: '**',
                                component: public_calculator_component_PublicCalculatorComponent }] }, { path: 'orderpayment',
                        component: order_payment_component_OrderPaymentComponent }, { path: 'api/doc', component: api_documentation_component_ApiDocumentationComponent },
                    { path: 'pars-status-widget', component: pars_status_widget_component_ParsStatusWidgetComponent },
                    { path: 'pars-status-refresh', component: pars_status_refresh_component_ParsStatusRefreshComponent },
                    { path: '**', redirectTo: 'calculator/agent' }]];
        }, []), core_es5["ɵmpd"](1024, router_es5["n" /* Router */], router_es5["z" /* ɵe */], [core_es5["ApplicationRef"], router_es5["u" /* UrlSerializer */],
            router_es5["b" /* ChildrenOutletContexts */], common_es5["Location"], core_es5["Injector"], core_es5["NgModuleFactoryLoader"],
            core_es5["Compiler"], router_es5["l" /* ROUTES */], router_es5["j" /* ROUTER_CONFIGURATION */], [2, router_es5["t" /* UrlHandlingStrategy */]],
            [2, router_es5["m" /* RouteReuseStrategy */]]]), core_es5["ɵmpd"](512, router_es5["q" /* RouterModule */], router_es5["q" /* RouterModule */], [[2, router_es5["v" /* ɵa */]], [2, router_es5["n" /* Router */]]]), core_es5["ɵmpd"](512, http_es5["f" /* HttpModule */], http_es5["f" /* HttpModule */], []), core_es5["ɵmpd"](512, animations_es5["a" /* BrowserAnimationsModule */], animations_es5["a" /* BrowserAnimationsModule */], []), core_es5["ɵmpd"](512, toast_module["ToastModule"], toast_module["ToastModule"], []),
        core_es5["ɵmpd"](512, modal_module["a" /* ModalModule */], modal_module["a" /* ModalModule */], []), core_es5["ɵmpd"](512, collapse_module["a" /* CollapseModule */], collapse_module["a" /* CollapseModule */], []), core_es5["ɵmpd"](512, accordion_module_AccordionModule, accordion_module_AccordionModule, []), core_es5["ɵmpd"](512, bs_dropdown_module["a" /* BsDropdownModule */], bs_dropdown_module["a" /* BsDropdownModule */], []), core_es5["ɵmpd"](512, datatable_module["NgxDatatableModule"], datatable_module["NgxDatatableModule"], []), core_es5["ɵmpd"](512, charts["ChartsModule"], charts["ChartsModule"], []), core_es5["ɵmpd"](512, ng2_google_place_module["a" /* GooglePlaceModule */], ng2_google_place_module["a" /* GooglePlaceModule */], []), core_es5["ɵmpd"](512, NgxPaginationModule, NgxPaginationModule, []), core_es5["ɵmpd"](512, ValidatorsModule, ValidatorsModule, []), core_es5["ɵmpd"](512, angular2TextMask["TextMaskModule"], angular2TextMask["TextMaskModule"], []), core_es5["ɵmpd"](512, ngx_my_date_picker_module["a" /* NgxMyDatePickerModule */], ngx_my_date_picker_module["a" /* NgxMyDatePickerModule */], []), core_es5["ɵmpd"](512, my_date_range_picker_module["a" /* MyDateRangePickerModule */], my_date_range_picker_module["a" /* MyDateRangePickerModule */], []), core_es5["ɵmpd"](512, module_ngx_uploader_module_NgUploaderModule, module_ngx_uploader_module_NgUploaderModule, []), core_es5["ɵmpd"](512, ngx_tooltip["TooltipModule"], ngx_tooltip["TooltipModule"], []), core_es5["ɵmpd"](512, ngx_wizard_es5["e" /* WizardModule */], ngx_wizard_es5["e" /* WizardModule */], []), core_es5["ɵmpd"](512, ngx_dnd_module_NgxDnDModule, ngx_dnd_module_NgxDnDModule, []),
        core_es5["ɵmpd"](512, carousel_module_CarouselModule, carousel_module_CarouselModule, []), core_es5["ɵmpd"](512, currency_mask_module_NgxCurrencyModule, currency_mask_module_NgxCurrencyModule, []), core_es5["ɵmpd"](512, AppModule, AppModule, []), core_es5["ɵmpd"](256, bs_dropdown_config["a" /* BsDropdownConfig */], { autoClose: true }, []), core_es5["ɵmpd"](256, CURRENCY_MASK_CONFIG, { align: 'left', allowNegative: true, allowZero: true, decimal: '.', precision: 2,
            prefix: '$ ', suffix: '', thousands: ',', nullable: true }, [])]);
});
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2FwcC5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2FwcC5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9
//# sourceMappingURL=app.module.ngfactory.js.map
// CONCATENATED MODULE: ./app/main.aot.ts



Object(core_es5["enableProdMode"])();
Object(platform_browser_es5["platformBrowser"])().bootstrapModuleFactory(AppModuleNgFactory);
//# sourceMappingURL=main.aot.js.map

/***/ }),

/***/ "Ul3N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var footer_template_directive_1 = __webpack_require__("9/L2");
var DatatableFooterDirective = /** @class */ (function () {
    function DatatableFooterDirective() {
    }
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DatatableFooterDirective.prototype, "footerHeight", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DatatableFooterDirective.prototype, "totalMessage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DatatableFooterDirective.prototype, "selectedMessage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DatatableFooterDirective.prototype, "pagerLeftArrowIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DatatableFooterDirective.prototype, "pagerRightArrowIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DatatableFooterDirective.prototype, "pagerPreviousIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DatatableFooterDirective.prototype, "pagerNextIcon", void 0);
    __decorate([
        core_1.Input(),
        core_1.ContentChild(footer_template_directive_1.DataTableFooterTemplateDirective, { read: core_1.TemplateRef }),
        __metadata("design:type", core_1.TemplateRef)
    ], DatatableFooterDirective.prototype, "template", void 0);
    DatatableFooterDirective = __decorate([
        core_1.Directive({ selector: 'ngx-datatable-footer' })
    ], DatatableFooterDirective);
    return DatatableFooterDirective;
}());
exports.DatatableFooterDirective = DatatableFooterDirective;
//# sourceMappingURL=footer.directive.js.map

/***/ }),

/***/ "VWgf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var forms_1 = __webpack_require__("NVOs");
var platform_browser_1 = __webpack_require__("Qbdm");
var textMaskCore_1 = __webpack_require__("/Zin");
var TextMaskConfig = /** @class */ (function () {
    function TextMaskConfig() {
    }
    return TextMaskConfig;
}());
exports.TextMaskConfig = TextMaskConfig;
exports.MASKEDINPUT_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return MaskedInputDirective; }),
    multi: true
};
/**
 * We must check whether the agent is Android because composition events
 * behave differently between iOS and Android.
 */
function _isAndroid() {
    var userAgent = platform_browser_1.ɵgetDOM() ? platform_browser_1.ɵgetDOM().getUserAgent() : '';
    return /android (\d+)/.test(userAgent.toLowerCase());
}
var MaskedInputDirective = /** @class */ (function () {
    function MaskedInputDirective(_renderer, _elementRef, _compositionMode) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._compositionMode = _compositionMode;
        this.textMaskConfig = {
            mask: [],
            guide: true,
            placeholderChar: '_',
            pipe: undefined,
            keepCharPositions: false,
        };
        this.onChange = function (_) { };
        this.onTouched = function () { };
        /** Whether the user is creating a composition string (IME events). */
        this._composing = false;
        if (this._compositionMode == null) {
            this._compositionMode = !_isAndroid();
        }
    }
    MaskedInputDirective.prototype.ngOnChanges = function (changes) {
        this._setupMask(true);
        if (this.textMaskInputElement !== undefined) {
            this.textMaskInputElement.update(this.inputElement.value);
        }
    };
    MaskedInputDirective.prototype.writeValue = function (value) {
        this._setupMask();
        // set the initial value for cases where the mask is disabled
        var normalizedValue = value == null ? '' : value;
        this._renderer.setProperty(this.inputElement, 'value', normalizedValue);
        if (this.textMaskInputElement !== undefined) {
            this.textMaskInputElement.update(value);
        }
    };
    MaskedInputDirective.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    MaskedInputDirective.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    MaskedInputDirective.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    MaskedInputDirective.prototype._handleInput = function (value) {
        if (!this._compositionMode || (this._compositionMode && !this._composing)) {
            this._setupMask();
            if (this.textMaskInputElement !== undefined) {
                this.textMaskInputElement.update(value);
                // get the updated value
                value = this.inputElement.value;
                this.onChange(value);
            }
        }
    };
    MaskedInputDirective.prototype._setupMask = function (create) {
        if (create === void 0) { create = false; }
        if (!this.inputElement) {
            if (this._elementRef.nativeElement.tagName.toUpperCase() === 'INPUT') {
                // `textMask` directive is used directly on an input element
                this.inputElement = this._elementRef.nativeElement;
            }
            else {
                // `textMask` directive is used on an abstracted input element, `md-input-container`, etc
                this.inputElement = this._elementRef.nativeElement.getElementsByTagName('INPUT')[0];
            }
        }
        if (this.inputElement && create) {
            this.textMaskInputElement = textMaskCore_1.createTextMaskInputElement(Object.assign({ inputElement: this.inputElement }, this.textMaskConfig));
        }
    };
    MaskedInputDirective.prototype._compositionStart = function () { this._composing = true; };
    MaskedInputDirective.prototype._compositionEnd = function (value) {
        this._composing = false;
        this._compositionMode && this._handleInput(value);
    };
    MaskedInputDirective.decorators = [
        { type: core_1.Directive, args: [{
                    host: {
                        '(input)': '_handleInput($event.target.value)',
                        '(blur)': 'onTouched()',
                        '(compositionstart)': '_compositionStart()',
                        '(compositionend)': '_compositionEnd($event.target.value)'
                    },
                    selector: '[textMask]',
                    exportAs: 'textMask',
                    providers: [exports.MASKEDINPUT_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    MaskedInputDirective.ctorParameters = function () { return [
        { type: core_1.Renderer2, },
        { type: core_1.ElementRef, },
        { type: undefined, decorators: [{ type: core_1.Optional }, { type: core_1.Inject, args: [forms_1.COMPOSITION_BUFFER_MODE,] },] },
    ]; };
    MaskedInputDirective.propDecorators = {
        'textMaskConfig': [{ type: core_1.Input, args: ['textMask',] },],
    };
    return MaskedInputDirective;
}());
exports.MaskedInputDirective = MaskedInputDirective;
var TextMaskModule = /** @class */ (function () {
    function TextMaskModule() {
    }
    TextMaskModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [MaskedInputDirective],
                    exports: [MaskedInputDirective]
                },] },
    ];
    /** @nocollapse */
    TextMaskModule.ctorParameters = function () { return []; };
    return TextMaskModule;
}());
exports.TextMaskModule = TextMaskModule;
var textMaskCore_2 = __webpack_require__("/Zin");
exports.conformToMask = textMaskCore_2.conformToMask;
//# sourceMappingURL=angular2TextMask.js.map

/***/ }),

/***/ "W2+g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PublicWizardV2Component; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_orders_order__ = __webpack_require__("hz4y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_orderService__ = __webpack_require__("72WZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_calculator_public_types_type__ = __webpack_require__("LOzE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_configService__ = __webpack_require__("cfSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objects_orders_orderItem__ = __webpack_require__("PL+a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_router__ = __webpack_require__("5oXY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__objects_orders_orderOptions__ = __webpack_require__("Wcmd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_helpers_calculatorHelper__ = __webpack_require__("osrx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_google_tag_service__ = __webpack_require__("nz7M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_helpers_formHelper__ = __webpack_require__("Pb0k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_pageVisitService__ = __webpack_require__("qyLN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_operators__ = __webpack_require__("W+Sr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_operators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_rxjs_operators__);













var PublicWizardV2Component = /** @class */ (function () {
    function PublicWizardV2Component(configService, orderService, route, detectChanges, googleTagService, pageVisitService) {
        this.configService = configService;
        this.orderService = orderService;
        this.route = route;
        this.detectChanges = detectChanges;
        this.googleTagService = googleTagService;
        this.pageVisitService = pageVisitService;
        this.order = new __WEBPACK_IMPORTED_MODULE_1__objects_orders_order__["a" /* Order */]();
        this.orderItem = new __WEBPACK_IMPORTED_MODULE_5__objects_orders_orderItem__["b" /* OrderItem */]();
        this.showFirstTab = true;
        this.getAnotherQuote = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.marketingURL = null;
        this.hideWizard = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.setOrderItem = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.createNewOrder = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.isNeedSendEmail = false;
        /*refs to enums*/
        this.importerTypeRef = __WEBPACK_IMPORTED_MODULE_3__objects_calculator_public_types_type__["b" /* ImporterType */];
        this.currentYearRange = null;
        this.currentDescription = null;
        this.currentImportType = null;
        this.isPusrchased = null;
        this.isSelfServeApp = false;
        this.isQuotePage = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](false);
        /*static data*/
        this.provinceArray = new Array();
        this.canadianCurrencyCodes = [];
        this.defaultProducts = [];
        this.getMeanValue = function (x, y) { return Math.round((y + x) / 2); };
    }
    Object.defineProperty(PublicWizardV2Component.prototype, "isVehicle", {
        /**/
        /*getters*/
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_8__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].isVehicle(this.order);
        },
        enumerable: true,
        configurable: true
    });
    /*getters end*/
    PublicWizardV2Component.prototype.addPageVisit = function (pageVisit) {
        try {
            this.pageVisitService.add(pageVisit);
        }
        catch (error) {
            console.error(error);
        }
    };
    PublicWizardV2Component.prototype.focusInput = function (index) {
        var _this = this;
        if (index != -1) {
            setTimeout(function () {
                var activeTab = _this.wizardComponent.tabs.find(function (item) { return item.index == index; });
                if (activeTab != undefined) {
                    var focusInput = activeTab.elementRef.nativeElement.querySelector('input[data-autofocus="true"]') || activeTab.elementRef.nativeElement.querySelector('textarea[data-autofocus="true"]');
                    var focusSelect = activeTab.elementRef.nativeElement.querySelector('select[data-autofocus]');
                    var activeButton = activeTab.elementRef.nativeElement.querySelector('.btn.active');
                    focusSelect = null;
                    if (focusInput != null) {
                        if (focusInput.value == "")
                            focusInput.focus();
                    }
                    else if (focusSelect != null && activeButton == null) {
                        var text = activeTab.elementRef.nativeElement.querySelector('.select2-selection__rendered').innerText;
                        if (text == "" || text == "OTHER COUNTRY")
                            $(focusSelect).select2('open');
                    }
                    $(focusSelect).on('blur', function () {
                        __WEBPACK_IMPORTED_MODULE_10__common_helpers_formHelper__["a" /* FormHelper */].scrollToCalcV2TabOnMobile();
                    });
                    $(focusInput).on('blur', function () {
                        __WEBPACK_IMPORTED_MODULE_10__common_helpers_formHelper__["a" /* FormHelper */].scrollToCalcV2TabOnMobile();
                    });
                }
            }, 100);
        }
        __WEBPACK_IMPORTED_MODULE_10__common_helpers_formHelper__["a" /* FormHelper */].scrollToCalcV2TabOnMobile();
    };
    PublicWizardV2Component.prototype.isIconShow = function () {
        if (this.wizardComponent.activeTab)
            return this.wizardComponent.activeTab.index != 17;
        return true;
    };
    PublicWizardV2Component.prototype.isFullWidth = function () {
        if (this.wizardComponent.activeTab) {
            return (this.wizardComponent.activeTab.index == 17 || this.wizardComponent.activeTab.index === 0);
        }
        return false;
    };
    PublicWizardV2Component.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParamMap
            .pipe(Object(__WEBPACK_IMPORTED_MODULE_12_rxjs_operators__["tap"])(function (r) {
            if (!r.has('vehicleapp')) {
                return;
            }
            _this.isSelfServeApp = true;
            _this.setImportType(__WEBPACK_IMPORTED_MODULE_3__objects_calculator_public_types_type__["b" /* ImporterType */].Vehicle);
            _this.moveToNextTab(true);
        }))
            .subscribe();
        this.canadianCurrencyCodes = this.route.snapshot.data.canadianCurrencyCodes.Data;
        this.defaultProducts = this.route.snapshot.data.defaultProducts.Data.Items;
        this.provinceArray = [
            { code: "AB", name: "Alberta" },
            { code: "BC", name: "British Columbia" },
            { code: "MB", name: "Manitoba" },
            { code: "NB", name: "New Brunswick" },
            { code: "NL", name: "Newfoundland and Labrador" },
            { code: "NT", name: "Northwest Territories" },
            { code: "NS", name: "Nova Scotia" },
            { code: "NU", name: "Nunavut" },
            { code: "ON", name: "Ontario" },
            { code: "PE", name: "Prince Edward Island" },
            { code: "QC", name: "Quebec" },
            { code: "SK", name: "Saskatchewan" },
            { code: "YT", name: "Yukon" }
        ];
        this.order.IsCommercial = null;
    };
    PublicWizardV2Component.prototype.createdOrder = function (order) {
        this.order = order;
        if (order.OrderItems.length > 0) {
            this.orderItem = order.OrderItems[0];
        }
        this.createNewOrder.emit(this.order);
    };
    PublicWizardV2Component.prototype.ngAfterViewInit = function () {
        var t = this.wizardComponent.tabs[0];
        if (t != null)
            t.active = true;
    };
    PublicWizardV2Component.prototype.setImportType = function (importerType) {
        if (importerType == this.currentImportType) {
            this.currentImportType = null;
        }
        else {
            this.currentImportType = importerType;
            if (this.order.OrderItems.length > 0) {
                this.order.OrderItems[0].Price = null;
            }
        }
        this.detectChanges.detectChanges();
    };
    PublicWizardV2Component.prototype.setImportTypeToOrder = function () {
        var prevImporterType = __WEBPACK_IMPORTED_MODULE_8__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].checkOrderImporterType(this.order);
        if (prevImporterType === undefined) {
            prevImporterType = this.currentImportType;
        }
        if (this.currentImportType !== prevImporterType) {
            if (this.order.OrderItems.length > 0)
                this.order.OrderItems[0].Price = null;
            else
                this.orderItem.Price = null;
        }
        switch (this.currentImportType) {
            case __WEBPACK_IMPORTED_MODULE_3__objects_calculator_public_types_type__["b" /* ImporterType */].Vehicle:
                this.order.Flag |= __WEBPACK_IMPORTED_MODULE_7__objects_orders_orderOptions__["a" /* OrderOptions */].IsVehicle;
                break;
            case __WEBPACK_IMPORTED_MODULE_3__objects_calculator_public_types_type__["b" /* ImporterType */].Product:
                this.order.Flag &= ~__WEBPACK_IMPORTED_MODULE_7__objects_orders_orderOptions__["a" /* OrderOptions */].IsVehicle;
                break;
        }
    };
    PublicWizardV2Component.prototype.setYear = function (from, to) {
        this.currentYearRange = this.getButtonValue(this.getMeanValue(from, to), this.currentYearRange);
        this.currentYear = null;
        this.detectChanges.detectChanges();
    };
    PublicWizardV2Component.prototype.setYearToOI = function () {
        if (this.currentYear)
            this.orderItem.Year = this.currentYear;
        else
            this.orderItem.Year = this.currentYearRange;
    };
    ;
    PublicWizardV2Component.prototype.getButtonValue = function (value, currentValue) {
        return __WEBPACK_IMPORTED_MODULE_8__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].getButtonValue(value, currentValue);
    };
    PublicWizardV2Component.prototype.eventHandler = function (event) {
        var val = event.target.value + String.fromCharCode(event.charCode);
        if (!/^[0-9]+$/.test(val) && (event.charCode != 0)) {
            event.preventDefault();
        }
    };
    PublicWizardV2Component.prototype.setPurchased = function (isPurchased) {
        if (this.isPusrchased == isPurchased)
            this.isPusrchased = null;
        else
            this.isPusrchased = isPurchased;
        this.orderItem.IsPurchased = this.isPusrchased;
    };
    PublicWizardV2Component.prototype.showBottomText = function (vehicle) {
        var index = this.wizardComponent.activeTab.index;
        switch (index) {
            case 1: {
                return '';
            }
            case 2: {
                return '';
            }
            case 3: {
                return '';
            }
            case 5: {
                return '';
            }
            case 7: {
                if (vehicle) {
                    return '';
                }
                return '';
            }
            case 8: {
                return '';
            }
            case 10: {
                return '';
            }
            default: {
                return '';
            }
        }
    };
    PublicWizardV2Component.prototype.backToAskQuestionTab = function (event) {
        var _this = this;
        if (this.isAskQuestionTabShow) {
            event.preventDefault();
            setTimeout(function (_) { return _this.wizardComponent.nextTab(false); }, 0);
        }
    };
    PublicWizardV2Component.prototype.scrollTop = function () {
        if (this.mainElement)
            this.mainElement.nativeElement.scrollTop = 0;
    };
    PublicWizardV2Component.prototype.showEmailText = function (show) {
        this.isEmailTextShow = show;
    };
    PublicWizardV2Component.prototype.showThanksTab = function (show) {
        this.isThanksTabShow = show;
    };
    PublicWizardV2Component.prototype.showQuestionOrCallTab = function (show) {
        this.isQuestionOrCallTabShow = show;
    };
    PublicWizardV2Component.prototype.goToThanksTab = function () {
        this.isThanksTabShow = true;
        this.isAskQuestionTabShow = false;
        this.moveToNextTab(false);
    };
    PublicWizardV2Component.prototype.goToAskQuestionTab = function () {
        this.isAskQuestionTabShow = true;
        this.isThanksTabShow = false;
        this.moveToNextTab(false);
    };
    PublicWizardV2Component.prototype.moveToNextTab = function (x) {
        var _this = this;
        setTimeout(function (_) { return _this.wizardComponent.nextTab(x); }, 0);
    };
    PublicWizardV2Component.prototype.customBlur = function () {
        if (window.orientation != undefined) {
            var activeTab = this.wizardComponent.tabs.find(function (item) { return item.active == true; });
            var inputs = activeTab.elementRef.nativeElement.querySelectorAll('input');
            for (var i = 0; i < inputs.length; ++i) {
                inputs[i].blur();
            }
        }
    };
    PublicWizardV2Component.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_4__services_configService__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__services_orderService__["a" /* OrderService */] }, { type: __WEBPACK_IMPORTED_MODULE_6__angular_router__["a" /* ActivatedRoute */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] }, { type: __WEBPACK_IMPORTED_MODULE_9__services_google_tag_service__["a" /* GoogleTagService */] }, { type: __WEBPACK_IMPORTED_MODULE_11__services_pageVisitService__["a" /* PageVisitService */] }]; };
    return PublicWizardV2Component;
}());

//# sourceMappingURL=public-wizard-v2.component.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "WWez":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ticky = __webpack_require__("ys6Q");

module.exports = function debounce (fn, args, ctx) {
  if (!fn) { return; }
  ticky(function run () {
    fn.apply(ctx || null, args || []);
  });
};


/***/ }),

/***/ "WavH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__("3j3K");
var TooltipContent = (function () {
    // -------------------------------------------------------------------------
    // Constructor
    // -------------------------------------------------------------------------
    function TooltipContent(element, cdr) {
        this.element = element;
        this.cdr = cdr;
        this.placement = "bottom";
        this.animation = true;
        // -------------------------------------------------------------------------
        // Properties
        // -------------------------------------------------------------------------
        this.top = -100000;
        this.left = -100000;
        this.isIn = false;
        this.isFade = false;
    }
    // -------------------------------------------------------------------------
    // Lifecycle callbacks
    // -------------------------------------------------------------------------
    TooltipContent.prototype.ngAfterViewInit = function () {
        this.show();
        this.cdr.detectChanges();
    };
    // -------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------
    TooltipContent.prototype.show = function () {
        if (!this.hostElement)
            return;
        var p = this.positionElements(this.hostElement, this.element.nativeElement.children[0], this.placement);
        this.top = p.top;
        this.left = p.left;
        this.isIn = true;
        if (this.animation)
            this.isFade = true;
    };
    TooltipContent.prototype.hide = function () {
        this.top = -100000;
        this.left = -100000;
        this.isIn = true;
        if (this.animation)
            this.isFade = false;
    };
    // -------------------------------------------------------------------------
    // Private Methods
    // -------------------------------------------------------------------------
    TooltipContent.prototype.positionElements = function (hostEl, targetEl, positionStr, appendToBody) {
        if (appendToBody === void 0) { appendToBody = false; }
        var positionStrParts = positionStr.split("-");
        var pos0 = positionStrParts[0];
        var pos1 = positionStrParts[1] || "center";
        var hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);
        var targetElWidth = targetEl.offsetWidth;
        var targetElHeight = targetEl.offsetHeight;
        var shiftWidth = {
            center: function () {
                return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
            },
            left: function () {
                return hostElPos.left;
            },
            right: function () {
                return hostElPos.left + hostElPos.width;
            }
        };
        var shiftHeight = {
            center: function () {
                return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
            },
            top: function () {
                return hostElPos.top;
            },
            bottom: function () {
                return hostElPos.top + hostElPos.height;
            }
        };
        var targetElPos;
        switch (pos0) {
            case "right":
                targetElPos = {
                    top: shiftHeight[pos1](),
                    left: shiftWidth[pos0]()
                };
                break;
            case "left":
                targetElPos = {
                    top: shiftHeight[pos1](),
                    left: hostElPos.left - targetElWidth
                };
                break;
            case "bottom":
                targetElPos = {
                    top: shiftHeight[pos0](),
                    left: shiftWidth[pos1]()
                };
                break;
            default:
                targetElPos = {
                    top: hostElPos.top - targetElHeight,
                    left: shiftWidth[pos1]()
                };
                break;
        }
        return targetElPos;
    };
    TooltipContent.prototype.position = function (nativeEl) {
        var offsetParentBCR = { top: 0, left: 0 };
        var elBCR = this.offset(nativeEl);
        var offsetParentEl = this.parentOffsetEl(nativeEl);
        if (offsetParentEl !== window.document) {
            offsetParentBCR = this.offset(offsetParentEl);
            offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
            offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
        }
        var boundingClientRect = nativeEl.getBoundingClientRect();
        return {
            width: boundingClientRect.width || nativeEl.offsetWidth,
            height: boundingClientRect.height || nativeEl.offsetHeight,
            top: elBCR.top - offsetParentBCR.top,
            left: elBCR.left - offsetParentBCR.left
        };
    };
    TooltipContent.prototype.offset = function (nativeEl) {
        var boundingClientRect = nativeEl.getBoundingClientRect();
        return {
            width: boundingClientRect.width || nativeEl.offsetWidth,
            height: boundingClientRect.height || nativeEl.offsetHeight,
            top: boundingClientRect.top + (window.pageYOffset || window.document.documentElement.scrollTop),
            left: boundingClientRect.left + (window.pageXOffset || window.document.documentElement.scrollLeft)
        };
    };
    TooltipContent.prototype.getStyle = function (nativeEl, cssProp) {
        if (nativeEl.currentStyle)
            return nativeEl.currentStyle[cssProp];
        if (window.getComputedStyle)
            return window.getComputedStyle(nativeEl)[cssProp];
        // finally try and get inline style
        return nativeEl.style[cssProp];
    };
    TooltipContent.prototype.isStaticPositioned = function (nativeEl) {
        return (this.getStyle(nativeEl, "position") || "static") === "static";
    };
    TooltipContent.prototype.parentOffsetEl = function (nativeEl) {
        var offsetParent = nativeEl.offsetParent || window.document;
        while (offsetParent && offsetParent !== window.document && this.isStaticPositioned(offsetParent)) {
            offsetParent = offsetParent.offsetParent;
        }
        return offsetParent || window.document;
    };
    return TooltipContent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", HTMLElement)
], TooltipContent.prototype, "hostElement", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], TooltipContent.prototype, "content", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], TooltipContent.prototype, "placement", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], TooltipContent.prototype, "animation", void 0);
TooltipContent = __decorate([
    core_1.Component({
        selector: "tooltip-content",
        template: "\n<div class=\"tooltip {{ placement }}\"\n     [style.top]=\"top + 'px'\"\n     [style.left]=\"left + 'px'\"\n     [class.in]=\"isIn\"\n     [class.fade]=\"isFade\"\n     role=\"tooltip\">\n    <div class=\"tooltip-arrow\"></div> \n    <div class=\"tooltip-inner\">\n        <ng-content></ng-content>\n        {{ content }}\n    </div> \n</div>\n"
    }),
    __metadata("design:paramtypes", [core_1.ElementRef,
        core_1.ChangeDetectorRef])
], TooltipContent);
exports.TooltipContent = TooltipContent;
//# sourceMappingURL=TooltipContent.js.map

/***/ }),

/***/ "Wcmd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrderOptions; });
/**
 * Created by vlad.p on 9/22/2017.
 */
var OrderOptions;
(function (OrderOptions) {
    OrderOptions[OrderOptions["None"] = 0] = "None";
    OrderOptions[OrderOptions["IsOcean"] = 1] = "IsOcean";
    OrderOptions[OrderOptions["IsOneTime"] = 2] = "IsOneTime";
    OrderOptions[OrderOptions["IsQuickQuote"] = 4] = "IsQuickQuote";
    OrderOptions[OrderOptions["IsPulic"] = 8] = "IsPulic";
    OrderOptions[OrderOptions["IsVehicle"] = 16] = "IsVehicle";
    OrderOptions[OrderOptions["IsUsService"] = 32] = "IsUsService";
    OrderOptions[OrderOptions["IsBBFeeEdited"] = 64] = "IsBBFeeEdited";
    OrderOptions[OrderOptions["IsCommercialCarrier"] = 128] = "IsCommercialCarrier";
    OrderOptions[OrderOptions["IsDrivingAcross"] = 256] = "IsDrivingAcross";
    OrderOptions[OrderOptions["ContinuousBondOnFile"] = 512] = "ContinuousBondOnFile";
})(OrderOptions || (OrderOptions = {}));
//# sourceMappingURL=orderOptions.js.map

/***/ }),

/***/ "WdmS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AmazonService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseService__ = __webpack_require__("IhmT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__("Fzro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configService__ = __webpack_require__("cfSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_amazon_seller__ = __webpack_require__("UB/I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies__ = __webpack_require__("46qw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_deep_extend__ = __webpack_require__("/+tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_deep_extend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_deep_extend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ng2_cookies__ = __webpack_require__("tbtb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ng2_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ng2_cookies__);








window.Buffer = window.Buffer || /** @class */ (function () {
    function Buffer() {
    }
    return Buffer;
}());
var AmazonService = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](AmazonService, _super);
    function AmazonService(http, configService, cookieService) {
        var _this = _super.call(this, http, configService) || this;
        _this.cookieService = cookieService;
        _this.seller = new __WEBPACK_IMPORTED_MODULE_4__objects_amazon_seller__["a" /* Seller */]();
        _this.prevUrl = null;
        return _this;
    }
    AmazonService.prototype.exportProducts = function (sellerId, marketplaceId, mwsAuthToken, companyName) {
        var params = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["l" /* URLSearchParams */]();
        params.append('sellerId', sellerId.toString());
        params.append('marketplaceId', marketplaceId.toString());
        params.append('mwsAuthToken', mwsAuthToken.toString());
        params.append('companyName', companyName.toString());
        this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "amazon/export",
            search: params
        }));
    };
    AmazonService.prototype.exportAndSaveProducts = function (sellerId, storeId) {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "amazon/product/export/" + sellerId + "/" + storeId
        }));
    };
    AmazonService.prototype.exportStoreProducts = function (sellerId, storeId) {
        var _this = this;
        return this.exportAndSaveProducts(sellerId, storeId).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_6_deep_extend__(_this.seller, response.Data);
            return response.Data;
        });
    };
    AmazonService.prototype.getCurrentSeller = function () {
        var _this = this;
        if (this.seller.Id)
            return new Promise(function (resolve, reject) { return resolve(_this.seller); });
        if (!__WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies__["Cookie"].get(this.configService.config.UserAmazonCookieName))
            return null;
        var userId = +__WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies__["Cookie"].get(this.configService.config.UserAmazonCookieName);
        return this.getSellerByUserId(userId).then(function (x) {
            __WEBPACK_IMPORTED_MODULE_6_deep_extend__(_this.seller, x.Data);
            return _this.seller;
        });
    };
    AmazonService.prototype.setCurrentSeller = function (obj) {
        var _this = this;
        if (obj == null) {
            this.cookieService.delete(this.configService.config.ApiTokenCookieName);
            this.cookieService.delete(this.configService.config.UserAmazonCookieName);
            return;
        }
        var userId = +__WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies__["Cookie"].get(this.configService.config.UserAmazonCookieName);
        obj.UserId = userId;
        obj.Email = this.userEmail;
        return this.modifySeller(obj).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_6_deep_extend__(_this.seller, response.Data);
            return response.Data;
        });
    };
    AmazonService.prototype.getSellers = function (skip, top) {
        var params = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["l" /* URLSearchParams */]();
        params.append('skip', skip.toString());
        params.append('top', top.toString());
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "amazon/seller",
            search: params
        }));
    };
    AmazonService.prototype.getSellerByUserId = function (id) {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "amazon/seller/" + id
        }));
    };
    AmazonService.prototype.modifySeller = function (seller) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "amazon/seller/" + seller.UserId,
            body: seller
        }));
    };
    AmazonService.prototype.getProducts = function (sellerId, storeId, skip, top, isAdmin, prop, isAscending) {
        if (isAdmin === void 0) { isAdmin = false; }
        if (prop === void 0) { prop = null; }
        if (isAscending === void 0) { isAscending = null; }
        var params = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["l" /* URLSearchParams */]();
        params.append('skip', skip.toString());
        params.append('top', top.toString());
        params.append('isAdmin', isAdmin.toString());
        if (prop != null && isAscending != null) {
            params.append('prop', prop);
            params.append('isascending', isAscending.toString());
        }
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "amazon/" + sellerId + "/store/" + storeId + "/product",
            search: params
        }));
    };
    AmazonService.prototype.updateProduct = function (sellerId, storeId, product) {
        return this.put(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "amazon/seller/" + sellerId + "/store/" + storeId + "/product",
            body: product
        }));
    };
    AmazonService.prototype.updateProducts = function (sellerId, storeId, products) {
        return this.put(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "amazon/seller/" + sellerId + "/store/" + storeId + "/products",
            body: products
        }));
    };
    AmazonService.prototype.setPrevUrl = function (url) {
        this.prevUrl = url;
    };
    AmazonService.prototype.getHelloSignUrl = function (seller) {
        if (!seller.Email) {
            seller.Email = this.userEmail;
        }
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "sign?email=" + seller.Email + "&fullName=" + seller.ContactName,
        }));
    };
    AmazonService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_http__["e" /* Http */] }, { type: __WEBPACK_IMPORTED_MODULE_3__configService__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_7_ng2_cookies__["CookieService"] }]; };
    return AmazonService;
}(__WEBPACK_IMPORTED_MODULE_1__baseService__["a" /* BaseApi */]));

//# sourceMappingURL=amazon.service.js.map

/***/ }),

/***/ "WlhA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var UUID = (function () {
    function UUID() {
        // no-op
    }
    UUID.UUID = function () {
        if (typeof (window) !== "undefined" && typeof (window.crypto) !== "undefined" && typeof (window.crypto.getRandomValues) !== "undefined") {
            // If we have a cryptographically secure PRNG, use that
            // http://stackoverflow.com/questions/6906916/collisions-when-generating-uuids-in-javascript
            var buf = new Uint16Array(8);
            window.crypto.getRandomValues(buf);
            return (this.pad4(buf[0]) + this.pad4(buf[1]) + "-" + this.pad4(buf[2]) + "-" + this.pad4(buf[3]) + "-" + this.pad4(buf[4]) + "-" + this.pad4(buf[5]) + this.pad4(buf[6]) + this.pad4(buf[7]));
        }
        else {
            // Otherwise, just use Math.random
            // https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
            // https://stackoverflow.com/questions/11605068/why-does-jshint-argue-against-bitwise-operators-how-should-i-express-this-code
            return this.random4() + this.random4() + "-" + this.random4() + "-" + this.random4() + "-" +
                this.random4() + "-" + this.random4() + this.random4() + this.random4();
        }
    };
    UUID.pad4 = function (num) {
        var ret = num.toString(16);
        while (ret.length < 4) {
            ret = "0" + ret;
        }
        return ret;
    };
    UUID.random4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    return UUID;
}());
exports.UUID = UUID;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "WzQ7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var camel_case_1 = __webpack_require__("L9Tr");
var cache = {};
var testStyle = typeof document !== 'undefined' ? document.createElement('div').style : undefined;
// Get Prefix
// http://davidwalsh.name/vendor-prefix
var prefix = function () {
    var styles = typeof window !== 'undefined' ? window.getComputedStyle(document.documentElement, '') : undefined;
    var match = typeof styles !== 'undefined' ?
        Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) : null;
    var pre = match !== null ? match[1] : undefined;
    var dom = typeof pre !== 'undefined' ? ('WebKit|Moz|MS|O').match(new RegExp('(' + pre + ')', 'i'))[1] : undefined;
    return dom ? {
        dom: dom,
        lowercase: pre,
        css: "-" + pre + "-",
        js: pre[0].toUpperCase() + pre.substr(1)
    } : undefined;
}();
function getVendorPrefixedName(property) {
    var name = camel_case_1.camelCase(property);
    if (!cache[name]) {
        if (prefix !== undefined && testStyle[prefix.css + property] !== undefined) {
            cache[name] = prefix.css + property;
        }
        else if (testStyle[property] !== undefined) {
            cache[name] = property;
        }
    }
    return cache[name];
}
exports.getVendorPrefixedName = getVendorPrefixedName;
//# sourceMappingURL=prefixes.js.map

/***/ }),

/***/ "X6wl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var utils_1 = __webpack_require__("x6Zf");
var types_1 = __webpack_require__("j2I9");
var scroller_component_1 = __webpack_require__("0RJd");
var DataTableBodyComponent = /** @class */ (function () {
    /**
     * Creates an instance of DataTableBodyComponent.
     */
    function DataTableBodyComponent(cd) {
        var _this = this;
        this.cd = cd;
        this.selected = [];
        this.scroll = new core_1.EventEmitter();
        this.page = new core_1.EventEmitter();
        this.activate = new core_1.EventEmitter();
        this.select = new core_1.EventEmitter();
        this.detailToggle = new core_1.EventEmitter();
        this.rowContextmenu = new core_1.EventEmitter(false);
        this.rowHeightsCache = new utils_1.RowHeightCache();
        this.temp = [];
        this.offsetY = 0;
        this.indexes = {};
        this.rowIndexes = new Map();
        this.rowExpansions = new Map();
        /**
         * Get the height of the detail row.
         */
        this.getDetailRowHeight = function (row, index) {
            if (!_this.rowDetail)
                return 0;
            var rowHeight = _this.rowDetail.rowHeight;
            return typeof rowHeight === 'function' ? rowHeight(row, index) : rowHeight;
        };
        // declare fn here so we can get access to the `this` property
        this.rowTrackingFn = function (index, row) {
            var idx = this.getRowIndex(row);
            if (this.trackByProp) {
                return idx + "-" + this.trackByProp;
            }
            else {
                return idx;
            }
        }.bind(this);
    }
    Object.defineProperty(DataTableBodyComponent.prototype, "pageSize", {
        get: function () {
            return this._pageSize;
        },
        set: function (val) {
            this._pageSize = val;
            this.recalcLayout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "rows", {
        get: function () {
            return this._rows;
        },
        set: function (val) {
            this._rows = val;
            this.rowExpansions.clear();
            this.recalcLayout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (val) {
            this._columns = val;
            var colsByPin = utils_1.columnsByPin(val);
            this.columnGroupWidths = utils_1.columnGroupWidths(colsByPin, val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "offset", {
        get: function () {
            return this._offset;
        },
        set: function (val) {
            this._offset = val;
            this.recalcLayout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "rowCount", {
        get: function () {
            return this._rowCount;
        },
        set: function (val) {
            this._rowCount = val;
            this.recalcLayout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "bodyWidth", {
        get: function () {
            if (this.scrollbarH) {
                return this.innerWidth + 'px';
            }
            else {
                return '100%';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "bodyHeight", {
        get: function () {
            return this._bodyHeight;
        },
        set: function (val) {
            if (this.scrollbarV) {
                this._bodyHeight = val + 'px';
            }
            else {
                this._bodyHeight = 'auto';
            }
            this.recalcLayout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "selectEnabled", {
        /**
         * Returns if selection is enabled.
         */
        get: function () {
            return !!this.selectionType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "scrollHeight", {
        /**
         * Property that would calculate the height of scroll bar
         * based on the row heights cache for virtual scroll. Other scenarios
         * calculate scroll height automatically (as height will be undefined).
         */
        get: function () {
            if (this.scrollbarV && this.rowCount) {
                return this.rowHeightsCache.query(this.rowCount - 1);
            }
            // avoid TS7030: Not all code paths return a value.
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Called after the constructor, initializing input properties
     */
    DataTableBodyComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.rowDetail) {
            this.listener = this.rowDetail.toggle
                .subscribe(function (_a) {
                var type = _a.type, value = _a.value;
                if (type === 'row')
                    _this.toggleRowExpansion(value);
                if (type === 'all')
                    _this.toggleAllRows(value);
                // Refresh rows after toggle
                // Fixes #883
                _this.updateIndexes();
                _this.updateRows();
                _this.cd.markForCheck();
            });
        }
        if (this.groupHeader) {
            this.listener = this.groupHeader.toggle
                .subscribe(function (_a) {
                var type = _a.type, value = _a.value;
                if (type === 'group')
                    _this.toggleRowExpansion(value);
                if (type === 'all')
                    _this.toggleAllRows(value);
                // Refresh rows after toggle
                // Fixes #883
                _this.updateIndexes();
                _this.updateRows();
                _this.cd.markForCheck();
            });
        }
    };
    /**
     * Called once, before the instance is destroyed.
     */
    DataTableBodyComponent.prototype.ngOnDestroy = function () {
        if (this.rowDetail)
            this.listener.unsubscribe();
        if (this.groupHeader)
            this.listener.unsubscribe();
    };
    /**
     * Updates the Y offset given a new offset.
     */
    DataTableBodyComponent.prototype.updateOffsetY = function (offset) {
        // scroller is missing on empty table
        if (!this.scroller)
            return;
        if (this.scrollbarV && offset) {
            // First get the row Index that we need to move to.
            var rowIndex = this.pageSize * offset;
            offset = this.rowHeightsCache.query(rowIndex - 1);
        }
        this.scroller.setOffset(offset || 0);
    };
    /**
     * Body was scrolled, this is mainly useful for
     * when a user is server-side pagination via virtual scroll.
     */
    DataTableBodyComponent.prototype.onBodyScroll = function (event) {
        var scrollYPos = event.scrollYPos;
        var scrollXPos = event.scrollXPos;
        // if scroll change, trigger update
        // this is mainly used for header cell positions
        if (this.offsetY !== scrollYPos || this.offsetX !== scrollXPos) {
            this.scroll.emit({
                offsetY: scrollYPos,
                offsetX: scrollXPos
            });
        }
        this.offsetY = scrollYPos;
        this.offsetX = scrollXPos;
        this.updateIndexes();
        this.updatePage(event.direction);
        this.updateRows();
    };
    /**
     * Updates the page given a direction.
     */
    DataTableBodyComponent.prototype.updatePage = function (direction) {
        var offset = this.indexes.first / this.pageSize;
        if (direction === 'up') {
            offset = Math.ceil(offset);
        }
        else if (direction === 'down') {
            offset = Math.floor(offset);
        }
        if (direction !== undefined && !isNaN(offset)) {
            this.page.emit({ offset: offset });
        }
    };
    /**
     * Updates the rows in the view port
     */
    DataTableBodyComponent.prototype.updateRows = function () {
        var _a = this.indexes, first = _a.first, last = _a.last;
        var rowIndex = first;
        var idx = 0;
        var temp = [];
        this.rowIndexes.clear();
        // if grouprowsby has been specified treat row paging
        // parameters as group paging parameters ie if limit 10 has been
        // specified treat it as 10 groups rather than 10 rows
        if (this.groupedRows) {
            var maxRowsPerGroup = 3;
            // if there is only one group set the maximum number of
            // rows per group the same as the total number of rows
            if (this.groupedRows.length === 1) {
                maxRowsPerGroup = this.groupedRows[0].value.length;
            }
            while (rowIndex < last && rowIndex < this.groupedRows.length) {
                // Add the groups into this page
                var group = this.groupedRows[rowIndex];
                temp[idx] = group;
                idx++;
                // Group index in this context
                rowIndex++;
            }
        }
        else {
            while (rowIndex < last && rowIndex < this.rowCount) {
                var row = this.rows[rowIndex];
                if (row) {
                    this.rowIndexes.set(row, rowIndex);
                    temp[idx] = row;
                }
                idx++;
                rowIndex++;
            }
        }
        this.temp = temp;
        this.cd.detectChanges();
    };
    /**
     * Get the row height
     */
    DataTableBodyComponent.prototype.getRowHeight = function (row) {
        var height;
        // if its a function return it
        if (typeof this.rowHeight === 'function') {
            height = this.rowHeight(row);
        }
        else {
            height = this.rowHeight;
        }
        return height;
    };
    /**
     * @param group the group with all rows
     */
    DataTableBodyComponent.prototype.getGroupHeight = function (group) {
        var rowHeight = 0;
        if (group.value) {
            for (var index = 0; index < group.value.length; index++) {
                rowHeight += this.getRowAndDetailHeight(group.value[index]);
            }
        }
        return rowHeight;
    };
    /**
     * Calculate row height based on the expanded state of the row.
     */
    DataTableBodyComponent.prototype.getRowAndDetailHeight = function (row) {
        var rowHeight = this.getRowHeight(row);
        var expanded = this.rowExpansions.get(row);
        // Adding detail row height if its expanded.
        if (expanded === 1) {
            rowHeight += this.getDetailRowHeight(row);
        }
        return rowHeight;
    };
    /**
     * Calculates the styles for the row so that the rows can be moved in 2D space
     * during virtual scroll inside the DOM.   In the below case the Y position is
     * manipulated.   As an example, if the height of row 0 is 30 px and row 1 is
     * 100 px then following styles are generated:
     *
     * transform: translate3d(0px, 0px, 0px);    ->  row0
     * transform: translate3d(0px, 30px, 0px);   ->  row1
     * transform: translate3d(0px, 130px, 0px);  ->  row2
     *
     * Row heights have to be calculated based on the row heights cache as we wont
     * be able to determine which row is of what height before hand.  In the above
     * case the positionY of the translate3d for row2 would be the sum of all the
     * heights of the rows before it (i.e. row0 and row1).
     *
     * @param {*} rows The row that needs to be placed in the 2D space.
     * @returns {*} Returns the CSS3 style to be applied
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.getRowsStyles = function (rows) {
        var styles = {};
        // only add styles for the group if there is a group
        if (this.groupedRows) {
            styles['width'] = this.columnGroupWidths.total;
        }
        if (this.scrollbarV) {
            var idx = 0;
            if (this.groupedRows) {
                // Get the latest row rowindex in a group
                var row = rows[rows.length - 1];
                idx = row ? this.getRowIndex(row) : 0;
            }
            else {
                idx = this.getRowIndex(rows);
            }
            // const pos = idx * rowHeight;
            // The position of this row would be the sum of all row heights
            // until the previous row position.
            var pos = this.rowHeightsCache.query(idx - 1);
            utils_1.translateXY(styles, 0, pos);
        }
        return styles;
    };
    /**
     * Hides the loading indicator
     */
    DataTableBodyComponent.prototype.hideIndicator = function () {
        var _this = this;
        setTimeout(function () { return _this.loadingIndicator = false; }, 500);
    };
    /**
     * Updates the index of the rows in the viewport
     */
    DataTableBodyComponent.prototype.updateIndexes = function () {
        var first = 0;
        var last = 0;
        if (this.scrollbarV) {
            if (this.virtualization) {
                // Calculation of the first and last indexes will be based on where the
                // scrollY position would be at.  The last index would be the one
                // that shows up inside the view port the last.
                var height = parseInt(this.bodyHeight, 0);
                first = this.rowHeightsCache.getRowIndex(this.offsetY);
                last = this.rowHeightsCache.getRowIndex(height + this.offsetY) + 1;
            }
            else {
                // If virtual rows are not needed
                // We render all in one go
                first = 0;
                last = this.rowCount;
            }
        }
        else {
            // The server is handling paging and will pass an array that begins with the
            // element at a specified offset.  first should always be 0 with external paging.
            if (!this.externalPaging) {
                first = Math.max(this.offset * this.pageSize, 0);
            }
            last = Math.min((first + this.pageSize), this.rowCount);
        }
        this.indexes = { first: first, last: last };
    };
    /**
     * Refreshes the full Row Height cache.  Should be used
     * when the entire row array state has changed.
     */
    DataTableBodyComponent.prototype.refreshRowHeightCache = function () {
        if (!this.scrollbarV)
            return;
        // clear the previous row height cache if already present.
        // this is useful during sorts, filters where the state of the
        // rows array is changed.
        this.rowHeightsCache.clearCache();
        // Initialize the tree only if there are rows inside the tree.
        if (this.rows && this.rows.length) {
            this.rowHeightsCache.initCache({
                rows: this.rows,
                rowHeight: this.rowHeight,
                detailRowHeight: this.getDetailRowHeight,
                externalVirtual: this.scrollbarV && this.externalPaging,
                rowCount: this.rowCount,
                rowIndexes: this.rowIndexes,
                rowExpansions: this.rowExpansions
            });
        }
    };
    /**
     * Gets the index for the view port
     */
    DataTableBodyComponent.prototype.getAdjustedViewPortIndex = function () {
        // Capture the row index of the first row that is visible on the viewport.
        // If the scroll bar is just below the row which is highlighted then make that as the
        // first index.
        var viewPortFirstRowIndex = this.indexes.first;
        if (this.scrollbarV) {
            var offsetScroll = this.rowHeightsCache.query(viewPortFirstRowIndex - 1);
            return offsetScroll <= this.offsetY ? viewPortFirstRowIndex - 1 : viewPortFirstRowIndex;
        }
        return viewPortFirstRowIndex;
    };
    /**
     * Toggle the Expansion of the row i.e. if the row is expanded then it will
     * collapse and vice versa.   Note that the expanded status is stored as
     * a part of the row object itself as we have to preserve the expanded row
     * status in case of sorting and filtering of the row set.
     */
    DataTableBodyComponent.prototype.toggleRowExpansion = function (row) {
        // Capture the row index of the first row that is visible on the viewport.
        var viewPortFirstRowIndex = this.getAdjustedViewPortIndex();
        var expanded = this.rowExpansions.get(row);
        // If the detailRowHeight is auto --> only in case of non-virtualized scroll
        if (this.scrollbarV) {
            var detailRowHeight = this.getDetailRowHeight(row) * (expanded ? -1 : 1);
            // const idx = this.rowIndexes.get(row) || 0;
            var idx = this.getRowIndex(row);
            this.rowHeightsCache.update(idx, detailRowHeight);
        }
        // Update the toggled row and update thive nevere heights in the cache.
        expanded = expanded ^= 1;
        this.rowExpansions.set(row, expanded);
        this.detailToggle.emit({
            rows: [row],
            currentIndex: viewPortFirstRowIndex
        });
    };
    /**
     * Expand/Collapse all the rows no matter what their state is.
     */
    DataTableBodyComponent.prototype.toggleAllRows = function (expanded) {
        // clear prev expansions
        this.rowExpansions.clear();
        var rowExpanded = expanded ? 1 : 0;
        // Capture the row index of the first row that is visible on the viewport.
        var viewPortFirstRowIndex = this.getAdjustedViewPortIndex();
        for (var _i = 0, _a = this.rows; _i < _a.length; _i++) {
            var row = _a[_i];
            this.rowExpansions.set(row, rowExpanded);
        }
        if (this.scrollbarV) {
            // Refresh the full row heights cache since every row was affected.
            this.recalcLayout();
        }
        // Emit all rows that have been expanded.
        this.detailToggle.emit({
            rows: this.rows,
            currentIndex: viewPortFirstRowIndex
        });
    };
    /**
     * Recalculates the table
     */
    DataTableBodyComponent.prototype.recalcLayout = function () {
        this.refreshRowHeightCache();
        this.updateIndexes();
        this.updateRows();
    };
    /**
     * Tracks the column
     */
    DataTableBodyComponent.prototype.columnTrackingFn = function (index, column) {
        return column.$$id;
    };
    /**
     * Gets the row pinning group styles
     */
    DataTableBodyComponent.prototype.stylesByGroup = function (group) {
        var widths = this.columnGroupWidths;
        var offsetX = this.offsetX;
        var styles = {
            width: widths[group] + "px"
        };
        if (group === 'left') {
            utils_1.translateXY(styles, offsetX, 0);
        }
        else if (group === 'right') {
            var bodyWidth = parseInt(this.innerWidth + '', 0);
            var totalDiff = widths.total - bodyWidth;
            var offsetDiff = totalDiff - offsetX;
            var offset = offsetDiff * -1;
            utils_1.translateXY(styles, offset, 0);
        }
        return styles;
    };
    /**
     * Returns if the row was expanded and set default row expansion when row expansion is empty
     */
    DataTableBodyComponent.prototype.getRowExpanded = function (row) {
        if (this.rowExpansions.size === 0 && this.groupExpansionDefault) {
            for (var _i = 0, _a = this.groupedRows; _i < _a.length; _i++) {
                var group = _a[_i];
                this.rowExpansions.set(group, 1);
            }
        }
        var expanded = this.rowExpansions.get(row);
        return expanded === 1;
    };
    /**
     * Gets the row index given a row
     */
    DataTableBodyComponent.prototype.getRowIndex = function (row) {
        return this.rowIndexes.get(row) || 0;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableBodyComponent.prototype, "scrollbarV", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableBodyComponent.prototype, "scrollbarH", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableBodyComponent.prototype, "loadingIndicator", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableBodyComponent.prototype, "externalPaging", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableBodyComponent.prototype, "rowHeight", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableBodyComponent.prototype, "offsetX", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableBodyComponent.prototype, "emptyMessage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableBodyComponent.prototype, "selectionType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DataTableBodyComponent.prototype, "selected", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableBodyComponent.prototype, "rowIdentity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableBodyComponent.prototype, "rowDetail", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableBodyComponent.prototype, "groupHeader", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableBodyComponent.prototype, "selectCheck", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableBodyComponent.prototype, "displayCheck", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableBodyComponent.prototype, "trackByProp", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableBodyComponent.prototype, "rowClass", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableBodyComponent.prototype, "groupedRows", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableBodyComponent.prototype, "groupExpansionDefault", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableBodyComponent.prototype, "innerWidth", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableBodyComponent.prototype, "groupRowsBy", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableBodyComponent.prototype, "virtualization", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableBodyComponent.prototype, "summaryRow", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableBodyComponent.prototype, "summaryPosition", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableBodyComponent.prototype, "summaryHeight", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], DataTableBodyComponent.prototype, "pageSize", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], DataTableBodyComponent.prototype, "rows", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], DataTableBodyComponent.prototype, "columns", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], DataTableBodyComponent.prototype, "offset", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], DataTableBodyComponent.prototype, "rowCount", null);
    __decorate([
        core_1.HostBinding('style.width'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], DataTableBodyComponent.prototype, "bodyWidth", null);
    __decorate([
        core_1.Input(),
        core_1.HostBinding('style.height'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], DataTableBodyComponent.prototype, "bodyHeight", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTableBodyComponent.prototype, "scroll", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTableBodyComponent.prototype, "page", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTableBodyComponent.prototype, "activate", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTableBodyComponent.prototype, "select", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTableBodyComponent.prototype, "detailToggle", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], DataTableBodyComponent.prototype, "rowContextmenu", void 0);
    __decorate([
        core_1.ViewChild(scroller_component_1.ScrollerComponent),
        __metadata("design:type", scroller_component_1.ScrollerComponent)
    ], DataTableBodyComponent.prototype, "scroller", void 0);
    DataTableBodyComponent = __decorate([
        core_1.Component({
            selector: 'datatable-body',
            template: "\n    <datatable-selection\n      #selector\n      [selected]=\"selected\"\n      [rows]=\"rows\"\n      [selectCheck]=\"selectCheck\"\n      [selectEnabled]=\"selectEnabled\"\n      [selectionType]=\"selectionType\"\n      [rowIdentity]=\"rowIdentity\"\n      (select)=\"select.emit($event)\"\n      (activate)=\"activate.emit($event)\">\n      <datatable-progress\n        *ngIf=\"loadingIndicator\">\n      </datatable-progress>\n      <datatable-scroller\n        *ngIf=\"rows?.length\"\n        [scrollbarV]=\"scrollbarV\"\n        [scrollbarH]=\"scrollbarH\"\n        [scrollHeight]=\"scrollHeight\"\n        [scrollWidth]=\"columnGroupWidths?.total\"\n        (scroll)=\"onBodyScroll($event)\">\n        <datatable-summary-row\n          *ngIf=\"summaryRow && summaryPosition === 'top'\"\n          [rowHeight]=\"summaryHeight\"\n          [offsetX]=\"offsetX\"\n          [innerWidth]=\"innerWidth\"\n          [rows]=\"rows\"\n          [columns]=\"columns\">\n        </datatable-summary-row>\n        <datatable-row-wrapper\n          [groupedRows]=\"groupedRows\"\n          *ngFor=\"let group of temp; let i = index; trackBy: rowTrackingFn;\"\n          [innerWidth]=\"innerWidth\"\n          [ngStyle]=\"getRowsStyles(group)\"\n          [rowDetail]=\"rowDetail\"\n          [groupHeader]=\"groupHeader\"\n          [offsetX]=\"offsetX\"\n          [detailRowHeight]=\"getDetailRowHeight(group[i],i)\"\n          [row]=\"group\"\n          [expanded]=\"getRowExpanded(group)\"\n          [rowIndex]=\"getRowIndex(group[i])\"\n          (rowContextmenu)=\"rowContextmenu.emit($event)\">\n          <datatable-body-row\n            *ngIf=\"!groupedRows; else groupedRowsTemplate\"\n            tabindex=\"-1\"\n            [isSelected]=\"selector.getRowSelected(group)\"\n            [innerWidth]=\"innerWidth\"\n            [offsetX]=\"offsetX\"\n            [columns]=\"columns\"\n            [rowHeight]=\"getRowHeight(group)\"\n            [row]=\"group\"\n            [rowIndex]=\"getRowIndex(group)\"\n            [expanded]=\"getRowExpanded(group)\"\n            [rowClass]=\"rowClass\"\n            [displayCheck]=\"displayCheck\"\n            (activate)=\"selector.onActivate($event, indexes.first + i)\">\n          </datatable-body-row>\n          <ng-template #groupedRowsTemplate>\n            <datatable-body-row\n              *ngFor=\"let row of group.value; let i = index; trackBy: rowTrackingFn;\"\n              tabindex=\"-1\"\n              [isSelected]=\"selector.getRowSelected(row)\"\n              [innerWidth]=\"innerWidth\"\n              [offsetX]=\"offsetX\"\n              [columns]=\"columns\"\n              [rowHeight]=\"getRowHeight(row)\"\n              [row]=\"row\"\n              [group]=\"group.value\"\n              [rowIndex]=\"getRowIndex(row)\"\n              [expanded]=\"getRowExpanded(row)\"\n              [rowClass]=\"rowClass\"\n              (activate)=\"selector.onActivate($event, i)\">\n            </datatable-body-row>\n          </ng-template>\n        </datatable-row-wrapper>\n        <datatable-summary-row\n          *ngIf=\"summaryRow && summaryPosition === 'bottom'\"\n          [rowHeight]=\"summaryHeight\"\n          [offsetX]=\"offsetX\"\n          [innerWidth]=\"innerWidth\"\n          [rows]=\"rows\"\n          [columns]=\"columns\">\n        </datatable-summary-row>\n      </datatable-scroller>\n      <div\n        class=\"empty-row\"\n        *ngIf=\"!rows?.length && !loadingIndicator\"\n        [innerHTML]=\"emptyMessage\">\n      </div>\n    </datatable-selection>\n  ",
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
            host: {
                class: 'datatable-body'
            }
        }),
        __metadata("design:paramtypes", [core_1.ChangeDetectorRef])
    ], DataTableBodyComponent);
    return DataTableBodyComponent;
}());
exports.DataTableBodyComponent = DataTableBodyComponent;
//# sourceMappingURL=body.component.js.map

/***/ }),

/***/ "XowU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseService__ = __webpack_require__("IhmT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__("Fzro");



/**
 * Created by alex.y on 8/9/2017.
 */
var ProductService = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ProductService, _super);
    function ProductService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductService.prototype.search = function (request) {
        var params = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["l" /* URLSearchParams */]();
        params.append('query', request.Query);
        if (request.CustomerId)
            params.append('customerId', request.CustomerId.toString());
        params.append('top', request.Top.toString());
        params.append('skip', request.Skip.toString());
        params.append('source', request.Source != null ? request.Source.toString() : null);
        params.append('requestType', request.RequestType.toString());
        params.append('searchType', request.SearchType.toString());
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "product/search",
            search: params
        }));
    };
    ProductService.prototype.update = function (product) {
        return this.put(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "product",
            body: product
        }));
    };
    ProductService.prototype.classification = function (request) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "product/classification",
            body: request
        }));
    };
    return ProductService;
}(__WEBPACK_IMPORTED_MODULE_1__baseService__["a" /* BaseApi */]));

//# sourceMappingURL=productService.js.map

/***/ }),

/***/ "Z/0s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__("3j3K");
var TooltipContent_1 = __webpack_require__("WavH");
var Tooltip = (function () {
    // -------------------------------------------------------------------------
    // Constructor
    // -------------------------------------------------------------------------
    function Tooltip(viewContainerRef, resolver) {
        this.viewContainerRef = viewContainerRef;
        this.resolver = resolver;
        this.tooltipAnimation = true;
        this.tooltipPlacement = "bottom";
    }
    // -------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------
    Tooltip.prototype.show = function () {
        if (this.tooltipDisabled || this.visible)
            return;
        this.visible = true;
        if (typeof this.content === "string") {
            var factory = this.resolver.resolveComponentFactory(TooltipContent_1.TooltipContent);
            if (!this.visible)
                return;
            this.tooltip = this.viewContainerRef.createComponent(factory);
            this.tooltip.instance.hostElement = this.viewContainerRef.element.nativeElement;
            this.tooltip.instance.content = this.content;
            this.tooltip.instance.placement = this.tooltipPlacement;
            this.tooltip.instance.animation = this.tooltipAnimation;
        }
        else {
            var tooltip = this.content;
            tooltip.hostElement = this.viewContainerRef.element.nativeElement;
            tooltip.placement = this.tooltipPlacement;
            tooltip.animation = this.tooltipAnimation;
            tooltip.show();
        }
    };
    Tooltip.prototype.hide = function () {
        if (!this.visible)
            return;
        this.visible = false;
        if (this.tooltip)
            this.tooltip.destroy();
        if (this.content instanceof TooltipContent_1.TooltipContent)
            this.content.hide();
    };
    return Tooltip;
}());
__decorate([
    core_1.Input("tooltip"),
    __metadata("design:type", Object)
], Tooltip.prototype, "content", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], Tooltip.prototype, "tooltipDisabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], Tooltip.prototype, "tooltipAnimation", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], Tooltip.prototype, "tooltipPlacement", void 0);
__decorate([
    core_1.HostListener("focusin"),
    core_1.HostListener("mouseenter"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Tooltip.prototype, "show", null);
__decorate([
    core_1.HostListener("focusout"),
    core_1.HostListener("mouseleave"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Tooltip.prototype, "hide", null);
Tooltip = __decorate([
    core_1.Directive({
        selector: "[tooltip]"
    }),
    __metadata("design:paramtypes", [core_1.ViewContainerRef,
        core_1.ComponentFactoryResolver])
], Tooltip);
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map

/***/ }),

/***/ "Z9jN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var operators_1 = __webpack_require__("W+Sr");
var fromEvent_1 = __webpack_require__("TIy+");
/**
 * Draggable Directive for Angular2
 *
 * Inspiration:
 *   https://github.com/AngularClass/angular2-examples/blob/master/rx-draggable/directives/draggable.ts
 *   http://stackoverflow.com/questions/35662530/how-to-implement-drag-and-drop-in-angular2
 *
 */
var DraggableDirective = /** @class */ (function () {
    function DraggableDirective(element) {
        this.dragX = true;
        this.dragY = true;
        this.dragStart = new core_1.EventEmitter();
        this.dragging = new core_1.EventEmitter();
        this.dragEnd = new core_1.EventEmitter();
        this.isDragging = false;
        this.element = element.nativeElement;
    }
    DraggableDirective.prototype.ngOnChanges = function (changes) {
        if (changes['dragEventTarget'] && changes['dragEventTarget'].currentValue && this.dragModel.dragging) {
            this.onMousedown(changes['dragEventTarget'].currentValue);
        }
    };
    DraggableDirective.prototype.ngOnDestroy = function () {
        this._destroySubscription();
    };
    DraggableDirective.prototype.onMouseup = function (event) {
        if (!this.isDragging)
            return;
        this.isDragging = false;
        this.element.classList.remove('dragging');
        if (this.subscription) {
            this._destroySubscription();
            this.dragEnd.emit({
                event: event,
                element: this.element,
                model: this.dragModel
            });
        }
    };
    DraggableDirective.prototype.onMousedown = function (event) {
        var _this = this;
        // we only want to drag the inner header text
        var isDragElm = event.target.classList.contains('draggable');
        if (isDragElm && (this.dragX || this.dragY)) {
            event.preventDefault();
            this.isDragging = true;
            var mouseDownPos_1 = { x: event.clientX, y: event.clientY };
            var mouseup = fromEvent_1.fromEvent(document, 'mouseup');
            this.subscription = mouseup
                .subscribe(function (ev) { return _this.onMouseup(ev); });
            var mouseMoveSub = fromEvent_1.fromEvent(document, 'mousemove')
                .pipe(operators_1.takeUntil(mouseup))
                .subscribe(function (ev) { return _this.move(ev, mouseDownPos_1); });
            this.subscription.add(mouseMoveSub);
            this.dragStart.emit({
                event: event,
                element: this.element,
                model: this.dragModel
            });
        }
    };
    DraggableDirective.prototype.move = function (event, mouseDownPos) {
        if (!this.isDragging)
            return;
        var x = event.clientX - mouseDownPos.x;
        var y = event.clientY - mouseDownPos.y;
        if (this.dragX)
            this.element.style.left = x + "px";
        if (this.dragY)
            this.element.style.top = y + "px";
        this.element.classList.add('dragging');
        this.dragging.emit({
            event: event,
            element: this.element,
            model: this.dragModel
        });
    };
    DraggableDirective.prototype._destroySubscription = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DraggableDirective.prototype, "dragEventTarget", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DraggableDirective.prototype, "dragModel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DraggableDirective.prototype, "dragX", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DraggableDirective.prototype, "dragY", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DraggableDirective.prototype, "dragStart", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DraggableDirective.prototype, "dragging", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DraggableDirective.prototype, "dragEnd", void 0);
    DraggableDirective = __decorate([
        core_1.Directive({ selector: '[draggable]' }),
        __metadata("design:paramtypes", [core_1.ElementRef])
    ], DraggableDirective);
    return DraggableDirective;
}());
exports.DraggableDirective = DraggableDirective;
//# sourceMappingURL=draggable.directive.js.map

/***/ }),

/***/ "ZP5A":
/***/ (function(module, exports) {

Number.prototype.hasFlag = function (flag) {
    return (this & flag) == flag;
};
Number.prototype.roundToDigits = function (digits) {
    return +(Math.round(+(this + "e+" + digits)) + ("e-" + digits));
};
//# sourceMappingURL=enumHelper.js.map

/***/ }),

/***/ "ZSxL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseService__ = __webpack_require__("IhmT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__("Fzro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configService__ = __webpack_require__("cfSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_toPromise__ = __webpack_require__("eErF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_toPromise__);





/**
 * Created by stas on 5/23/2017.
 */
var UserService = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](UserService, _super);
    function UserService(http, configService) {
        return _super.call(this, http, configService) || this;
    }
    UserService.prototype.login = function (username, password) {
        var url = this.config.ApiUrl + "/Token";
        var body = "username=" + username + "&password=" + password + "&grant_type=password";
        var options = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            headers: new __WEBPACK_IMPORTED_MODULE_2__angular_http__["d" /* Headers */]({ "Content-Type": "application/x-www-form-urlencoded" })
        });
        return this.http.post(url, body, options).toPromise();
    };
    UserService.prototype.register = function (request) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: 'users/register/',
            body: request
        }));
    };
    UserService.prototype.forgotPassword = function (request) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: 'users/forgotpassword/',
            body: request
        }));
    };
    UserService.prototype.resetPassword = function (request) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: 'users/resetpassword/',
            body: request
        }));
    };
    UserService.prototype.confirmEmail = function (code, userId) {
        var body = "code=" + code + "&userId=" + userId;
        var options = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            headers: new __WEBPACK_IMPORTED_MODULE_2__angular_http__["d" /* Headers */]({ "Content-Type": "application/x-www-form-urlencoded" })
        });
        return this.http.post(this.config.ApiUrl + "/confirmemail", body, options).toPromise();
    };
    UserService.prototype.getUserInfo = function (userId) {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "users/" + userId + "/info"
        }));
    };
    UserService.prototype.getUserApps = function (userId) {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "users/" + userId + "/apps"
        }));
    };
    UserService.prototype.inviteUser = function (user) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "users/invite",
            body: user
        }));
    };
    /**
     * register user in the system when login via external
     * resources such as google
     * @param accessToken
     * @returns {null}
     */
    UserService.prototype.externalRegister = function (accessToken) {
        var params = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "api/Account/RegisterExternal",
            headers: new __WEBPACK_IMPORTED_MODULE_2__angular_http__["d" /* Headers */]()
        });
        params.headers.append("Authorization", "Bearer " + accessToken);
        return this.post(params);
    };
    /**
     * get user info using accessToken that can be received
     * by externalLogin
     * @param accessToken
     * @returns {null}
     */
    UserService.prototype.getExternalUserInfo = function (accessToken) {
        var params = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "api/Account/UserInfo",
            headers: new __WEBPACK_IMPORTED_MODULE_2__angular_http__["d" /* Headers */]()
        });
        if (accessToken)
            params.headers.append("Authorization", "Bearer " + accessToken);
        return this.get(params);
    };
    UserService.prototype.getExternalLogin = function (provider) {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "api/Account/ExternalLogin?provider=Google&response_type=token&client_id=self&redirect_uri=" + this.configService.config.AdminUrl + "/" + this.configService.config.RedirectUrl + "&state=kpxvpRAg4jMTv5QO9DBJjLO6ib4J6A-AO9sjx3H0k9s1"
        }));
    };
    UserService.prototype.prepareExternalLogin = function () {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "api/Account/PrepareExternalLogin"
        }));
    };
    UserService.prototype.search = function (request) {
        var params = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["l" /* URLSearchParams */]();
        params.append('query', String.isNullOrEmpty(request.Query) ? request.Query : encodeURIComponent(request.Query));
        params.append('top', request.Top.toString());
        params.append('skip', request.Skip.toString());
        params.append('fillOrders', request.FillOrders.toString());
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "users/search",
            search: params
        }));
    };
    UserService.prototype.update = function (user) {
        return this.put(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "users/update",
            body: user
        }));
    };
    UserService.prototype.create = function (user) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "users/create",
            body: user
        }));
    };
    UserService.prototype.getById = function (id) {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "users/" + id
        }));
    };
    UserService.prototype.getAll = function () {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: 'users/all'
        }));
    };
    UserService.prototype.getOrdersByAgentId = function (agentId, skip, top) {
        if (skip === void 0) { skip = 0; }
        if (top === void 0) { top = 10; }
        var params = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["l" /* URLSearchParams */]();
        params.append('top', top.toString());
        params.append('skip', skip.toString());
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "users/" + agentId + "/orders",
            search: params
        }));
    };
    UserService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_http__["e" /* Http */] }, { type: __WEBPACK_IMPORTED_MODULE_3__configService__["a" /* ConfigService */] }]; };
    return UserService;
}(__WEBPACK_IMPORTED_MODULE_1__baseService__["a" /* BaseApi */]));

//# sourceMappingURL=userService.js.map

/***/ }),

/***/ "ZweM":
/***/ (function(module, exports, __webpack_require__) {

var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.libphonenumber = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var COMPILED = !0, goog = goog || {};
goog.global = this;
goog.isDef = function(a) {
  return void 0 !== a;
};
goog.isString = function(a) {
  return "string" == typeof a;
};
goog.isBoolean = function(a) {
  return "boolean" == typeof a;
};
goog.isNumber = function(a) {
  return "number" == typeof a;
};
goog.exportPath_ = function(a, b, c) {
  a = a.split(".");
  c = c || goog.global;
  a[0] in c || !c.execScript || c.execScript("var " + a[0]);
  for (var d; a.length && (d = a.shift());) {
    !a.length && goog.isDef(b) ? c[d] = b : c = c[d] && c[d] !== Object.prototype[d] ? c[d] : c[d] = {};
  }
};
goog.define = function(a, b) {
  var c = b;
  COMPILED || (goog.global.CLOSURE_UNCOMPILED_DEFINES && void 0 === goog.global.CLOSURE_UNCOMPILED_DEFINES.nodeType && Object.prototype.hasOwnProperty.call(goog.global.CLOSURE_UNCOMPILED_DEFINES, a) ? c = goog.global.CLOSURE_UNCOMPILED_DEFINES[a] : goog.global.CLOSURE_DEFINES && void 0 === goog.global.CLOSURE_DEFINES.nodeType && Object.prototype.hasOwnProperty.call(goog.global.CLOSURE_DEFINES, a) && (c = goog.global.CLOSURE_DEFINES[a]));
  goog.exportPath_(a, c);
};
goog.DEBUG = !0;
goog.LOCALE = "en";
goog.TRUSTED_SITE = !0;
goog.STRICT_MODE_COMPATIBLE = !1;
goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG;
goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1;
goog.provide = function(a) {
  if (goog.isInModuleLoader_()) {
    throw Error("goog.provide can not be used within a goog.module.");
  }
  if (!COMPILED && goog.isProvided_(a)) {
    throw Error('Namespace "' + a + '" already declared.');
  }
  goog.constructNamespace_(a);
};
goog.constructNamespace_ = function(a, b) {
  if (!COMPILED) {
    delete goog.implicitNamespaces_[a];
    for (var c = a; (c = c.substring(0, c.lastIndexOf("."))) && !goog.getObjectByName(c);) {
      goog.implicitNamespaces_[c] = !0;
    }
  }
  goog.exportPath_(a, b);
};
goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
goog.module = function(a) {
  if (!goog.isString(a) || !a || -1 == a.search(goog.VALID_MODULE_RE_)) {
    throw Error("Invalid module identifier");
  }
  if (!goog.isInModuleLoader_()) {
    throw Error("Module " + a + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
  }
  if (goog.moduleLoaderState_.moduleName) {
    throw Error("goog.module may only be called once per module.");
  }
  goog.moduleLoaderState_.moduleName = a;
  if (!COMPILED) {
    if (goog.isProvided_(a)) {
      throw Error('Namespace "' + a + '" already declared.');
    }
    delete goog.implicitNamespaces_[a];
  }
};
goog.module.get = function(a) {
  return goog.module.getInternal_(a);
};
goog.module.getInternal_ = function(a) {
  if (!COMPILED) {
    if (a in goog.loadedModules_) {
      return goog.loadedModules_[a];
    }
    if (!goog.implicitNamespaces_[a]) {
      return a = goog.getObjectByName(a), null != a ? a : null;
    }
  }
  return null;
};
goog.moduleLoaderState_ = null;
goog.isInModuleLoader_ = function() {
  return null != goog.moduleLoaderState_;
};
goog.module.declareLegacyNamespace = function() {
  if (!COMPILED && !goog.isInModuleLoader_()) {
    throw Error("goog.module.declareLegacyNamespace must be called from within a goog.module");
  }
  if (!COMPILED && !goog.moduleLoaderState_.moduleName) {
    throw Error("goog.module must be called prior to goog.module.declareLegacyNamespace.");
  }
  goog.moduleLoaderState_.declareLegacyNamespace = !0;
};
goog.setTestOnly = function(a) {
  if (goog.DISALLOW_TEST_ONLY_CODE) {
    throw a = a || "", Error("Importing test-only code into non-debug environment" + (a ? ": " + a : "."));
  }
};
goog.forwardDeclare = function(a) {
};
COMPILED || (goog.isProvided_ = function(a) {
  return a in goog.loadedModules_ || !goog.implicitNamespaces_[a] && goog.isDefAndNotNull(goog.getObjectByName(a));
}, goog.implicitNamespaces_ = {"goog.module":!0});
goog.getObjectByName = function(a, b) {
  for (var c = a.split("."), d = b || goog.global, e; e = c.shift();) {
    if (goog.isDefAndNotNull(d[e])) {
      d = d[e];
    } else {
      return null;
    }
  }
  return d;
};
goog.globalize = function(a, b) {
  var c = b || goog.global, d;
  for (d in a) {
    c[d] = a[d];
  }
};
goog.addDependency = function(a, b, c, d) {
  if (goog.DEPENDENCIES_ENABLED) {
    var e;
    a = a.replace(/\\/g, "/");
    var f = goog.dependencies_;
    d && "boolean" !== typeof d || (d = d ? {module:"goog"} : {});
    for (var g = 0; e = b[g]; g++) {
      f.nameToPath[e] = a, f.loadFlags[a] = d;
    }
    for (d = 0; b = c[d]; d++) {
      a in f.requires || (f.requires[a] = {}), f.requires[a][b] = !0;
    }
  }
};
goog.ENABLE_DEBUG_LOADER = !0;
goog.logToConsole_ = function(a) {
  goog.global.console && goog.global.console.error(a);
};
goog.require = function(a) {
  if (!COMPILED) {
    goog.ENABLE_DEBUG_LOADER && goog.IS_OLD_IE_ && goog.maybeProcessDeferredDep_(a);
    if (goog.isProvided_(a)) {
      if (goog.isInModuleLoader_()) {
        return goog.module.getInternal_(a);
      }
    } else {
      if (goog.ENABLE_DEBUG_LOADER) {
        var b = goog.getPathFromDeps_(a);
        if (b) {
          goog.writeScripts_(b);
        } else {
          throw a = "goog.require could not find: " + a, goog.logToConsole_(a), Error(a);
        }
      }
    }
    return null;
  }
};
goog.basePath = "";
goog.nullFunction = function() {
};
goog.abstractMethod = function() {
  throw Error("unimplemented abstract method");
};
goog.addSingletonGetter = function(a) {
  a.instance_ = void 0;
  a.getInstance = function() {
    if (a.instance_) {
      return a.instance_;
    }
    goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = a);
    return a.instance_ = new a;
  };
};
goog.instantiatedSingletons_ = [];
goog.LOAD_MODULE_USING_EVAL = !0;
goog.SEAL_MODULE_EXPORTS = goog.DEBUG;
goog.loadedModules_ = {};
goog.DEPENDENCIES_ENABLED = !COMPILED && goog.ENABLE_DEBUG_LOADER;
goog.TRANSPILE = "detect";
goog.TRANSPILER = "transpile.js";
goog.DEPENDENCIES_ENABLED && (goog.dependencies_ = {loadFlags:{}, nameToPath:{}, requires:{}, visited:{}, written:{}, deferred:{}}, goog.inHtmlDocument_ = function() {
  var a = goog.global.document;
  return null != a && "write" in a;
}, goog.findBasePath_ = function() {
  if (goog.isDef(goog.global.CLOSURE_BASE_PATH) && goog.isString(goog.global.CLOSURE_BASE_PATH)) {
    goog.basePath = goog.global.CLOSURE_BASE_PATH;
  } else {
    if (goog.inHtmlDocument_()) {
      var a = goog.global.document;
      var b = a.currentScript;
      a = b ? [b] : a.getElementsByTagName("SCRIPT");
      for (b = a.length - 1; 0 <= b; --b) {
        var c = a[b].src, d = c.lastIndexOf("?"), d = -1 == d ? c.length : d;
        if ("base.js" == c.substr(d - 7, 7)) {
          goog.basePath = c.substr(0, d - 7);
          break;
        }
      }
    }
  }
}, goog.importScript_ = function(a, b) {
  (goog.global.CLOSURE_IMPORT_SCRIPT || goog.writeScriptTag_)(a, b) && (goog.dependencies_.written[a] = !0);
}, goog.IS_OLD_IE_ = !(goog.global.atob || !goog.global.document || !goog.global.document.all), goog.oldIeWaiting_ = !1, goog.importProcessedScript_ = function(a, b, c) {
  goog.importScript_("", 'goog.retrieveAndExec_("' + a + '", ' + b + ", " + c + ");");
}, goog.queuedModules_ = [], goog.wrapModule_ = function(a, b) {
  return goog.LOAD_MODULE_USING_EVAL && goog.isDef(goog.global.JSON) ? "goog.loadModule(" + goog.global.JSON.stringify(b + "\n//# sourceURL=" + a + "\n") + ");" : 'goog.loadModule(function(exports) {"use strict";' + b + "\n;return exports});\n//# sourceURL=" + a + "\n";
}, goog.loadQueuedModules_ = function() {
  var a = goog.queuedModules_.length;
  if (0 < a) {
    var b = goog.queuedModules_;
    goog.queuedModules_ = [];
    for (var c = 0; c < a; c++) {
      goog.maybeProcessDeferredPath_(b[c]);
    }
  }
  goog.oldIeWaiting_ = !1;
}, goog.maybeProcessDeferredDep_ = function(a) {
  goog.isDeferredModule_(a) && goog.allDepsAreAvailable_(a) && (a = goog.getPathFromDeps_(a), goog.maybeProcessDeferredPath_(goog.basePath + a));
}, goog.isDeferredModule_ = function(a) {
  var b = (a = goog.getPathFromDeps_(a)) && goog.dependencies_.loadFlags[a] || {}, c = b.lang || "es3";
  return a && ("goog" == b.module || goog.needsTranspile_(c)) ? goog.basePath + a in goog.dependencies_.deferred : !1;
}, goog.allDepsAreAvailable_ = function(a) {
  if ((a = goog.getPathFromDeps_(a)) && a in goog.dependencies_.requires) {
    for (var b in goog.dependencies_.requires[a]) {
      if (!goog.isProvided_(b) && !goog.isDeferredModule_(b)) {
        return !1;
      }
    }
  }
  return !0;
}, goog.maybeProcessDeferredPath_ = function(a) {
  if (a in goog.dependencies_.deferred) {
    var b = goog.dependencies_.deferred[a];
    delete goog.dependencies_.deferred[a];
    goog.globalEval(b);
  }
}, goog.loadModuleFromUrl = function(a) {
  goog.retrieveAndExec_(a, !0, !1);
}, goog.writeScriptSrcNode_ = function(a) {
  goog.global.document.write('<script type="text/javascript" src="' + a + '">\x3c/script>');
}, goog.appendScriptSrcNode_ = function(a) {
  var b = goog.global.document, c = b.createElement("script");
  c.type = "text/javascript";
  c.src = a;
  c.defer = !1;
  c.async = !1;
  b.head.appendChild(c);
}, goog.writeScriptTag_ = function(a, b) {
  if (goog.inHtmlDocument_()) {
    var c = goog.global.document;
    if (!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING && "complete" == c.readyState) {
      if (/\bdeps.js$/.test(a)) {
        return !1;
      }
      throw Error('Cannot write "' + a + '" after document load');
    }
    if (void 0 === b) {
      if (goog.IS_OLD_IE_) {
        goog.oldIeWaiting_ = !0;
        var d = " onreadystatechange='goog.onScriptLoad_(this, " + ++goog.lastNonModuleScriptIndex_ + ")' ";
        c.write('<script type="text/javascript" src="' + a + '"' + d + ">\x3c/script>");
      } else {
        goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING ? goog.appendScriptSrcNode_(a) : goog.writeScriptSrcNode_(a);
      }
    } else {
      c.write('<script type="text/javascript">' + goog.protectScriptTag_(b) + "\x3c/script>");
    }
    return !0;
  }
  return !1;
}, goog.protectScriptTag_ = function(a) {
  return a.replace(/<\/(SCRIPT)/ig, "\\x3c/$1");
}, goog.needsTranspile_ = function(a) {
  if ("always" == goog.TRANSPILE) {
    return !0;
  }
  if ("never" == goog.TRANSPILE) {
    return !1;
  }
  goog.requiresTranspilation_ || (goog.requiresTranspilation_ = goog.createRequiresTranspilation_());
  if (a in goog.requiresTranspilation_) {
    return goog.requiresTranspilation_[a];
  }
  throw Error("Unknown language mode: " + a);
}, goog.requiresTranspilation_ = null, goog.lastNonModuleScriptIndex_ = 0, goog.onScriptLoad_ = function(a, b) {
  "complete" == a.readyState && goog.lastNonModuleScriptIndex_ == b && goog.loadQueuedModules_();
  return !0;
}, goog.writeScripts_ = function(a) {
  function b(a) {
    if (!(a in e.written || a in e.visited)) {
      e.visited[a] = !0;
      if (a in e.requires) {
        for (var f in e.requires[a]) {
          if (!goog.isProvided_(f)) {
            if (f in e.nameToPath) {
              b(e.nameToPath[f]);
            } else {
              throw Error("Undefined nameToPath for " + f);
            }
          }
        }
      }
      a in d || (d[a] = !0, c.push(a));
    }
  }
  var c = [], d = {}, e = goog.dependencies_;
  b(a);
  for (var f = 0; f < c.length; f++) {
    a = c[f], goog.dependencies_.written[a] = !0;
  }
  var g = goog.moduleLoaderState_;
  goog.moduleLoaderState_ = null;
  for (f = 0; f < c.length; f++) {
    if (a = c[f]) {
      var h = e.loadFlags[a] || {}, k = goog.needsTranspile_(h.lang || "es3");
      "goog" == h.module || k ? goog.importProcessedScript_(goog.basePath + a, "goog" == h.module, k) : goog.importScript_(goog.basePath + a);
    } else {
      throw goog.moduleLoaderState_ = g, Error("Undefined script input");
    }
  }
  goog.moduleLoaderState_ = g;
}, goog.getPathFromDeps_ = function(a) {
  return a in goog.dependencies_.nameToPath ? goog.dependencies_.nameToPath[a] : null;
}, goog.findBasePath_(), goog.global.CLOSURE_NO_DEPS || goog.importScript_(goog.basePath + "deps.js"));
goog.hasBadLetScoping = null;
goog.useSafari10Workaround = function() {
  if (null == goog.hasBadLetScoping) {
    try {
      var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
    } catch (b) {
      a = !1;
    }
    goog.hasBadLetScoping = a;
  }
  return goog.hasBadLetScoping;
};
goog.workaroundSafari10EvalBug = function(a) {
  return "(function(){" + a + "\n;})();\n";
};
goog.loadModule = function(a) {
  var b = goog.moduleLoaderState_;
  try {
    goog.moduleLoaderState_ = {moduleName:void 0, declareLegacyNamespace:!1};
    if (goog.isFunction(a)) {
      var c = a.call(void 0, {});
    } else {
      if (goog.isString(a)) {
        goog.useSafari10Workaround() && (a = goog.workaroundSafari10EvalBug(a)), c = goog.loadModuleFromSource_.call(void 0, a);
      } else {
        throw Error("Invalid module definition");
      }
    }
    var d = goog.moduleLoaderState_.moduleName;
    if (!goog.isString(d) || !d) {
      throw Error('Invalid module name "' + d + '"');
    }
    goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(d, c) : goog.SEAL_MODULE_EXPORTS && Object.seal && "object" == typeof c && null != c && Object.seal(c);
    goog.loadedModules_[d] = c;
  } finally {
    goog.moduleLoaderState_ = b;
  }
};
goog.loadModuleFromSource_ = function(a) {
  eval(a);
  return {};
};
goog.normalizePath_ = function(a) {
  a = a.split("/");
  for (var b = 0; b < a.length;) {
    "." == a[b] ? a.splice(b, 1) : b && ".." == a[b] && a[b - 1] && ".." != a[b - 1] ? a.splice(--b, 2) : b++;
  }
  return a.join("/");
};
goog.loadFileSync_ = function(a) {
  if (goog.global.CLOSURE_LOAD_FILE_SYNC) {
    return goog.global.CLOSURE_LOAD_FILE_SYNC(a);
  }
  try {
    var b = new goog.global.XMLHttpRequest;
    b.open("get", a, !1);
    b.send();
    return 0 == b.status || 200 == b.status ? b.responseText : null;
  } catch (c) {
    return null;
  }
};
goog.retrieveAndExec_ = function(a, b, c) {
  if (!COMPILED) {
    var d = a;
    a = goog.normalizePath_(a);
    var e = goog.global.CLOSURE_IMPORT_SCRIPT || goog.writeScriptTag_, f = goog.loadFileSync_(a);
    if (null == f) {
      throw Error('Load of "' + a + '" failed');
    }
    c && (f = goog.transpile_.call(goog.global, f, a));
    f = b ? goog.wrapModule_(a, f) : f + ("\n//# sourceURL=" + a);
    goog.IS_OLD_IE_ && goog.oldIeWaiting_ ? (goog.dependencies_.deferred[d] = f, goog.queuedModules_.push(d)) : e(a, f);
  }
};
goog.transpile_ = function(a, b) {
  var c = goog.global.$jscomp;
  c || (goog.global.$jscomp = c = {});
  var d = c.transpile;
  if (!d) {
    var e = goog.basePath + goog.TRANSPILER, f = goog.loadFileSync_(e);
    if (f) {
      eval(f + "\n//# sourceURL=" + e);
      if (goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) {
        throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
      }
      goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile;
      c = goog.global.$jscomp;
      d = c.transpile;
    }
  }
  d || (d = c.transpile = function(a, b) {
    goog.logToConsole_(b + " requires transpilation but no transpiler was found.");
    return a;
  });
  return d(a, b);
};
goog.typeOf = function(a) {
  var b = typeof a;
  if ("object" == b) {
    if (a) {
      if (a instanceof Array) {
        return "array";
      }
      if (a instanceof Object) {
        return b;
      }
      var c = Object.prototype.toString.call(a);
      if ("[object Window]" == c) {
        return "object";
      }
      if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) {
        return "array";
      }
      if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) {
        return "function";
      }
    } else {
      return "null";
    }
  } else {
    if ("function" == b && "undefined" == typeof a.call) {
      return "object";
    }
  }
  return b;
};
goog.isNull = function(a) {
  return null === a;
};
goog.isDefAndNotNull = function(a) {
  return null != a;
};
goog.isArray = function(a) {
  return "array" == goog.typeOf(a);
};
goog.isArrayLike = function(a) {
  var b = goog.typeOf(a);
  return "array" == b || "object" == b && "number" == typeof a.length;
};
goog.isDateLike = function(a) {
  return goog.isObject(a) && "function" == typeof a.getFullYear;
};
goog.isFunction = function(a) {
  return "function" == goog.typeOf(a);
};
goog.isObject = function(a) {
  var b = typeof a;
  return "object" == b && null != a || "function" == b;
};
goog.getUid = function(a) {
  return a[goog.UID_PROPERTY_] || (a[goog.UID_PROPERTY_] = ++goog.uidCounter_);
};
goog.hasUid = function(a) {
  return !!a[goog.UID_PROPERTY_];
};
goog.removeUid = function(a) {
  null !== a && "removeAttribute" in a && a.removeAttribute(goog.UID_PROPERTY_);
  try {
    delete a[goog.UID_PROPERTY_];
  } catch (b) {
  }
};
goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0);
goog.uidCounter_ = 0;
goog.getHashCode = goog.getUid;
goog.removeHashCode = goog.removeUid;
goog.cloneObject = function(a) {
  var b = goog.typeOf(a);
  if ("object" == b || "array" == b) {
    if (a.clone) {
      return a.clone();
    }
    var b = "array" == b ? [] : {}, c;
    for (c in a) {
      b[c] = goog.cloneObject(a[c]);
    }
    return b;
  }
  return a;
};
goog.bindNative_ = function(a, b, c) {
  return a.call.apply(a.bind, arguments);
};
goog.bindJs_ = function(a, b, c) {
  if (!a) {
    throw Error();
  }
  if (2 < arguments.length) {
    var d = Array.prototype.slice.call(arguments, 2);
    return function() {
      var c = Array.prototype.slice.call(arguments);
      Array.prototype.unshift.apply(c, d);
      return a.apply(b, c);
    };
  }
  return function() {
    return a.apply(b, arguments);
  };
};
goog.bind = function(a, b, c) {
  Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_;
  return goog.bind.apply(null, arguments);
};
goog.partial = function(a, b) {
  var c = Array.prototype.slice.call(arguments, 1);
  return function() {
    var b = c.slice();
    b.push.apply(b, arguments);
    return a.apply(this, b);
  };
};
goog.mixin = function(a, b) {
  for (var c in b) {
    a[c] = b[c];
  }
};
goog.now = goog.TRUSTED_SITE && Date.now || function() {
  return +new Date;
};
goog.globalEval = function(a) {
  if (goog.global.execScript) {
    goog.global.execScript(a, "JavaScript");
  } else {
    if (goog.global.eval) {
      if (null == goog.evalWorksForGlobals_) {
        if (goog.global.eval("var _evalTest_ = 1;"), "undefined" != typeof goog.global._evalTest_) {
          try {
            delete goog.global._evalTest_;
          } catch (d) {
          }
          goog.evalWorksForGlobals_ = !0;
        } else {
          goog.evalWorksForGlobals_ = !1;
        }
      }
      if (goog.evalWorksForGlobals_) {
        goog.global.eval(a);
      } else {
        var b = goog.global.document, c = b.createElement("SCRIPT");
        c.type = "text/javascript";
        c.defer = !1;
        c.appendChild(b.createTextNode(a));
        b.body.appendChild(c);
        b.body.removeChild(c);
      }
    } else {
      throw Error("goog.globalEval not available");
    }
  }
};
goog.evalWorksForGlobals_ = null;
goog.getCssName = function(a, b) {
  if ("." == String(a).charAt(0)) {
    throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + a);
  }
  var c = function(a) {
    return goog.cssNameMapping_[a] || a;
  }, d = function(a) {
    a = a.split("-");
    for (var b = [], d = 0; d < a.length; d++) {
      b.push(c(a[d]));
    }
    return b.join("-");
  }, d = goog.cssNameMapping_ ? "BY_WHOLE" == goog.cssNameMappingStyle_ ? c : d : function(a) {
    return a;
  }, d = b ? a + "-" + d(b) : d(a);
  return goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(d) : d;
};
goog.setCssNameMapping = function(a, b) {
  goog.cssNameMapping_ = a;
  goog.cssNameMappingStyle_ = b;
};
!COMPILED && goog.global.CLOSURE_CSS_NAME_MAPPING && (goog.cssNameMapping_ = goog.global.CLOSURE_CSS_NAME_MAPPING);
goog.getMsg = function(a, b) {
  b && (a = a.replace(/\{\$([^}]+)}/g, function(a, d) {
    return null != b && d in b ? b[d] : a;
  }));
  return a;
};
goog.getMsgWithFallback = function(a, b) {
  return a;
};
goog.exportSymbol = function(a, b, c) {
  goog.exportPath_(a, b, c);
};
goog.exportProperty = function(a, b, c) {
  a[b] = c;
};
goog.inherits = function(a, b) {
  function c() {
  }
  c.prototype = b.prototype;
  a.superClass_ = b.prototype;
  a.prototype = new c;
  a.prototype.constructor = a;
  a.base = function(a, c, f) {
    for (var d = Array(arguments.length - 2), e = 2; e < arguments.length; e++) {
      d[e - 2] = arguments[e];
    }
    return b.prototype[c].apply(a, d);
  };
};
goog.base = function(a, b, c) {
  var d = arguments.callee.caller;
  if (goog.STRICT_MODE_COMPATIBLE || goog.DEBUG && !d) {
    throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");
  }
  if (d.superClass_) {
    for (var e = Array(arguments.length - 1), f = 1; f < arguments.length; f++) {
      e[f - 1] = arguments[f];
    }
    return d.superClass_.constructor.apply(a, e);
  }
  e = Array(arguments.length - 2);
  for (f = 2; f < arguments.length; f++) {
    e[f - 2] = arguments[f];
  }
  for (var f = !1, g = a.constructor; g; g = g.superClass_ && g.superClass_.constructor) {
    if (g.prototype[b] === d) {
      f = !0;
    } else {
      if (f) {
        return g.prototype[b].apply(a, e);
      }
    }
  }
  if (a[b] === d) {
    return a.constructor.prototype[b].apply(a, e);
  }
  throw Error("goog.base called from a method of one name to a method of a different name");
};
goog.scope = function(a) {
  if (goog.isInModuleLoader_()) {
    throw Error("goog.scope is not supported within a goog.module.");
  }
  a.call(goog.global);
};
COMPILED || (goog.global.COMPILED = COMPILED);
goog.defineClass = function(a, b) {
  var c = b.constructor, d = b.statics;
  c && c != Object.prototype.constructor || (c = function() {
    throw Error("cannot instantiate an interface (no constructor defined).");
  });
  c = goog.defineClass.createSealingConstructor_(c, a);
  a && goog.inherits(c, a);
  delete b.constructor;
  delete b.statics;
  goog.defineClass.applyProperties_(c.prototype, b);
  null != d && (d instanceof Function ? d(c) : goog.defineClass.applyProperties_(c, d));
  return c;
};
goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG;
goog.defineClass.createSealingConstructor_ = function(a, b) {
  if (!goog.defineClass.SEAL_CLASS_INSTANCES) {
    return a;
  }
  var c = !goog.defineClass.isUnsealable_(b), d = function() {
    var b = a.apply(this, arguments) || this;
    b[goog.UID_PROPERTY_] = b[goog.UID_PROPERTY_];
    this.constructor === d && c && Object.seal instanceof Function && Object.seal(b);
    return b;
  };
  return d;
};
goog.defineClass.isUnsealable_ = function(a) {
  return a && a.prototype && a.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];
};
goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
goog.defineClass.applyProperties_ = function(a, b) {
  for (var c in b) {
    Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
  }
  for (var d = 0; d < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; d++) {
    c = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d], Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
  }
};
goog.tagUnsealableClass = function(a) {
  !COMPILED && goog.defineClass.SEAL_CLASS_INSTANCES && (a.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_] = !0);
};
goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_ = "goog_defineClass_legacy_unsealable";
goog.createRequiresTranspilation_ = function() {
  function a(a, b) {
    d ? c[a] = !0 : b() ? c[a] = !1 : d = c[a] = !0;
  }
  function b(a) {
    try {
      return !!eval(a);
    } catch (g) {
      return !1;
    }
  }
  var c = {es3:!1}, d = !1, e = goog.global.navigator && goog.global.navigator.userAgent ? goog.global.navigator.userAgent : "";
  a("es5", function() {
    return b("[1,].length==1");
  });
  a("es6", function() {
    var a = e.match(/Edge\/(\d+)(\.\d)*/i);
    return a && 15 > Number(a[1]) ? !1 : b('(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()');
  });
  a("es6-impl", function() {
    return !0;
  });
  a("es7", function() {
    return b("2 ** 2 == 4");
  });
  a("es8", function() {
    return b("async () => 1, true");
  });
  return c;
};
goog.string = {};
goog.string.StringBuffer = function(a, b) {
  null != a && this.append.apply(this, arguments);
};
goog.string.StringBuffer.prototype.buffer_ = "";
goog.string.StringBuffer.prototype.set = function(a) {
  this.buffer_ = "" + a;
};
goog.string.StringBuffer.prototype.append = function(a, b, c) {
  this.buffer_ += String(a);
  if (null != b) {
    for (var d = 1; d < arguments.length; d++) {
      this.buffer_ += arguments[d];
    }
  }
  return this;
};
goog.string.StringBuffer.prototype.clear = function() {
  this.buffer_ = "";
};
goog.string.StringBuffer.prototype.getLength = function() {
  return this.buffer_.length;
};
goog.string.StringBuffer.prototype.toString = function() {
  return this.buffer_;
};
goog.debug = {};
goog.debug.Error = function(a) {
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, goog.debug.Error);
  } else {
    var b = Error().stack;
    b && (this.stack = b);
  }
  a && (this.message = String(a));
  this.reportErrorToServer = !0;
};
goog.inherits(goog.debug.Error, Error);
goog.debug.Error.prototype.name = "CustomError";
goog.dom = {};
goog.dom.NodeType = {ELEMENT:1, ATTRIBUTE:2, TEXT:3, CDATA_SECTION:4, ENTITY_REFERENCE:5, ENTITY:6, PROCESSING_INSTRUCTION:7, COMMENT:8, DOCUMENT:9, DOCUMENT_TYPE:10, DOCUMENT_FRAGMENT:11, NOTATION:12};
goog.string.DETECT_DOUBLE_ESCAPING = !1;
goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1;
goog.string.Unicode = {NBSP:"\u00a0"};
goog.string.startsWith = function(a, b) {
  return 0 == a.lastIndexOf(b, 0);
};
goog.string.endsWith = function(a, b) {
  var c = a.length - b.length;
  return 0 <= c && a.indexOf(b, c) == c;
};
goog.string.caseInsensitiveStartsWith = function(a, b) {
  return 0 == goog.string.caseInsensitiveCompare(b, a.substr(0, b.length));
};
goog.string.caseInsensitiveEndsWith = function(a, b) {
  return 0 == goog.string.caseInsensitiveCompare(b, a.substr(a.length - b.length, b.length));
};
goog.string.caseInsensitiveEquals = function(a, b) {
  return a.toLowerCase() == b.toLowerCase();
};
goog.string.subs = function(a, b) {
  for (var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;) {
    d += c.shift() + e.shift();
  }
  return d + c.join("%s");
};
goog.string.collapseWhitespace = function(a) {
  return a.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
};
goog.string.isEmptyOrWhitespace = function(a) {
  return /^[\s\xa0]*$/.test(a);
};
goog.string.isEmptyString = function(a) {
  return 0 == a.length;
};
goog.string.isEmpty = goog.string.isEmptyOrWhitespace;
goog.string.isEmptyOrWhitespaceSafe = function(a) {
  return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a));
};
goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe;
goog.string.isBreakingWhitespace = function(a) {
  return !/[^\t\n\r ]/.test(a);
};
goog.string.isAlpha = function(a) {
  return !/[^a-zA-Z]/.test(a);
};
goog.string.isNumeric = function(a) {
  return !/[^0-9]/.test(a);
};
goog.string.isAlphaNumeric = function(a) {
  return !/[^a-zA-Z0-9]/.test(a);
};
goog.string.isSpace = function(a) {
  return " " == a;
};
goog.string.isUnicodeChar = function(a) {
  return 1 == a.length && " " <= a && "~" >= a || "\u0080" <= a && "\ufffd" >= a;
};
goog.string.stripNewlines = function(a) {
  return a.replace(/(\r\n|\r|\n)+/g, " ");
};
goog.string.canonicalizeNewlines = function(a) {
  return a.replace(/(\r\n|\r|\n)/g, "\n");
};
goog.string.normalizeWhitespace = function(a) {
  return a.replace(/\xa0|\s/g, " ");
};
goog.string.normalizeSpaces = function(a) {
  return a.replace(/\xa0|[ \t]+/g, " ");
};
goog.string.collapseBreakingSpaces = function(a) {
  return a.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
};
goog.string.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(a) {
  return a.trim();
} : function(a) {
  return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g, "");
};
goog.string.trimLeft = function(a) {
  return a.replace(/^[\s\xa0]+/, "");
};
goog.string.trimRight = function(a) {
  return a.replace(/[\s\xa0]+$/, "");
};
goog.string.caseInsensitiveCompare = function(a, b) {
  var c = String(a).toLowerCase(), d = String(b).toLowerCase();
  return c < d ? -1 : c == d ? 0 : 1;
};
goog.string.numberAwareCompare_ = function(a, b, c) {
  if (a == b) {
    return 0;
  }
  if (!a) {
    return -1;
  }
  if (!b) {
    return 1;
  }
  for (var d = a.toLowerCase().match(c), e = b.toLowerCase().match(c), f = Math.min(d.length, e.length), g = 0; g < f; g++) {
    c = d[g];
    var h = e[g];
    if (c != h) {
      return a = parseInt(c, 10), !isNaN(a) && (b = parseInt(h, 10), !isNaN(b) && a - b) ? a - b : c < h ? -1 : 1;
    }
  }
  return d.length != e.length ? d.length - e.length : a < b ? -1 : 1;
};
goog.string.intAwareCompare = function(a, b) {
  return goog.string.numberAwareCompare_(a, b, /\d+|\D+/g);
};
goog.string.floatAwareCompare = function(a, b) {
  return goog.string.numberAwareCompare_(a, b, /\d+|\.\d+|\D+/g);
};
goog.string.numerateCompare = goog.string.floatAwareCompare;
goog.string.urlEncode = function(a) {
  return encodeURIComponent(String(a));
};
goog.string.urlDecode = function(a) {
  return decodeURIComponent(a.replace(/\+/g, " "));
};
goog.string.newLineToBr = function(a, b) {
  return a.replace(/(\r\n|\r|\n)/g, b ? "<br />" : "<br>");
};
goog.string.htmlEscape = function(a, b) {
  if (b) {
    a = a.replace(goog.string.AMP_RE_, "&amp;").replace(goog.string.LT_RE_, "&lt;").replace(goog.string.GT_RE_, "&gt;").replace(goog.string.QUOT_RE_, "&quot;").replace(goog.string.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.NULL_RE_, "&#0;"), goog.string.DETECT_DOUBLE_ESCAPING && (a = a.replace(goog.string.E_RE_, "&#101;"));
  } else {
    if (!goog.string.ALL_RE_.test(a)) {
      return a;
    }
    -1 != a.indexOf("&") && (a = a.replace(goog.string.AMP_RE_, "&amp;"));
    -1 != a.indexOf("<") && (a = a.replace(goog.string.LT_RE_, "&lt;"));
    -1 != a.indexOf(">") && (a = a.replace(goog.string.GT_RE_, "&gt;"));
    -1 != a.indexOf('"') && (a = a.replace(goog.string.QUOT_RE_, "&quot;"));
    -1 != a.indexOf("'") && (a = a.replace(goog.string.SINGLE_QUOTE_RE_, "&#39;"));
    -1 != a.indexOf("\x00") && (a = a.replace(goog.string.NULL_RE_, "&#0;"));
    goog.string.DETECT_DOUBLE_ESCAPING && -1 != a.indexOf("e") && (a = a.replace(goog.string.E_RE_, "&#101;"));
  }
  return a;
};
goog.string.AMP_RE_ = /&/g;
goog.string.LT_RE_ = /</g;
goog.string.GT_RE_ = />/g;
goog.string.QUOT_RE_ = /"/g;
goog.string.SINGLE_QUOTE_RE_ = /'/g;
goog.string.NULL_RE_ = /\x00/g;
goog.string.E_RE_ = /e/g;
goog.string.ALL_RE_ = goog.string.DETECT_DOUBLE_ESCAPING ? /[\x00&<>"'e]/ : /[\x00&<>"']/;
goog.string.unescapeEntities = function(a) {
  return goog.string.contains(a, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(a) : goog.string.unescapePureXmlEntities_(a) : a;
};
goog.string.unescapeEntitiesWithDocument = function(a, b) {
  return goog.string.contains(a, "&") ? goog.string.unescapeEntitiesUsingDom_(a, b) : a;
};
goog.string.unescapeEntitiesUsingDom_ = function(a, b) {
  var c = {"&amp;":"&", "&lt;":"<", "&gt;":">", "&quot;":'"'};
  var d = b ? b.createElement("div") : goog.global.document.createElement("div");
  return a.replace(goog.string.HTML_ENTITY_PATTERN_, function(a, b) {
    var e = c[a];
    if (e) {
      return e;
    }
    if ("#" == b.charAt(0)) {
      var f = Number("0" + b.substr(1));
      isNaN(f) || (e = String.fromCharCode(f));
    }
    e || (d.innerHTML = a + " ", e = d.firstChild.nodeValue.slice(0, -1));
    return c[a] = e;
  });
};
goog.string.unescapePureXmlEntities_ = function(a) {
  return a.replace(/&([^;]+);/g, function(a, c) {
    switch(c) {
      case "amp":
        return "&";
      case "lt":
        return "<";
      case "gt":
        return ">";
      case "quot":
        return '"';
      default:
        if ("#" == c.charAt(0)) {
          var b = Number("0" + c.substr(1));
          if (!isNaN(b)) {
            return String.fromCharCode(b);
          }
        }
        return a;
    }
  });
};
goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g;
goog.string.whitespaceEscape = function(a, b) {
  return goog.string.newLineToBr(a.replace(/  /g, " &#160;"), b);
};
goog.string.preserveSpaces = function(a) {
  return a.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
};
goog.string.stripQuotes = function(a, b) {
  for (var c = b.length, d = 0; d < c; d++) {
    var e = 1 == c ? b : b.charAt(d);
    if (a.charAt(0) == e && a.charAt(a.length - 1) == e) {
      return a.substring(1, a.length - 1);
    }
  }
  return a;
};
goog.string.truncate = function(a, b, c) {
  c && (a = goog.string.unescapeEntities(a));
  a.length > b && (a = a.substring(0, b - 3) + "...");
  c && (a = goog.string.htmlEscape(a));
  return a;
};
goog.string.truncateMiddle = function(a, b, c, d) {
  c && (a = goog.string.unescapeEntities(a));
  if (d && a.length > b) {
    d > b && (d = b);
    var e = a.length - d;
    a = a.substring(0, b - d) + "..." + a.substring(e);
  } else {
    a.length > b && (d = Math.floor(b / 2), e = a.length - d, a = a.substring(0, d + b % 2) + "..." + a.substring(e));
  }
  c && (a = goog.string.htmlEscape(a));
  return a;
};
goog.string.specialEscapeChars_ = {"\x00":"\\0", "\b":"\\b", "\f":"\\f", "\n":"\\n", "\r":"\\r", "\t":"\\t", "\x0B":"\\x0B", '"':'\\"', "\\":"\\\\", "<":"<"};
goog.string.jsEscapeCache_ = {"'":"\\'"};
goog.string.quote = function(a) {
  a = String(a);
  for (var b = ['"'], c = 0; c < a.length; c++) {
    var d = a.charAt(c), e = d.charCodeAt(0);
    b[c + 1] = goog.string.specialEscapeChars_[d] || (31 < e && 127 > e ? d : goog.string.escapeChar(d));
  }
  b.push('"');
  return b.join("");
};
goog.string.escapeString = function(a) {
  for (var b = [], c = 0; c < a.length; c++) {
    b[c] = goog.string.escapeChar(a.charAt(c));
  }
  return b.join("");
};
goog.string.escapeChar = function(a) {
  if (a in goog.string.jsEscapeCache_) {
    return goog.string.jsEscapeCache_[a];
  }
  if (a in goog.string.specialEscapeChars_) {
    return goog.string.jsEscapeCache_[a] = goog.string.specialEscapeChars_[a];
  }
  var b = a.charCodeAt(0);
  if (31 < b && 127 > b) {
    var c = a;
  } else {
    if (256 > b) {
      if (c = "\\x", 16 > b || 256 < b) {
        c += "0";
      }
    } else {
      c = "\\u", 4096 > b && (c += "0");
    }
    c += b.toString(16).toUpperCase();
  }
  return goog.string.jsEscapeCache_[a] = c;
};
goog.string.contains = function(a, b) {
  return -1 != a.indexOf(b);
};
goog.string.caseInsensitiveContains = function(a, b) {
  return goog.string.contains(a.toLowerCase(), b.toLowerCase());
};
goog.string.countOf = function(a, b) {
  return a && b ? a.split(b).length - 1 : 0;
};
goog.string.removeAt = function(a, b, c) {
  var d = a;
  0 <= b && b < a.length && 0 < c && (d = a.substr(0, b) + a.substr(b + c, a.length - b - c));
  return d;
};
goog.string.remove = function(a, b) {
  return a.replace(b, "");
};
goog.string.removeAll = function(a, b) {
  var c = new RegExp(goog.string.regExpEscape(b), "g");
  return a.replace(c, "");
};
goog.string.replaceAll = function(a, b, c) {
  b = new RegExp(goog.string.regExpEscape(b), "g");
  return a.replace(b, c.replace(/\$/g, "$$$$"));
};
goog.string.regExpEscape = function(a) {
  return String(a).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
};
goog.string.repeat = String.prototype.repeat ? function(a, b) {
  return a.repeat(b);
} : function(a, b) {
  return Array(b + 1).join(a);
};
goog.string.padNumber = function(a, b, c) {
  a = goog.isDef(c) ? a.toFixed(c) : String(a);
  c = a.indexOf(".");
  -1 == c && (c = a.length);
  return goog.string.repeat("0", Math.max(0, b - c)) + a;
};
goog.string.makeSafe = function(a) {
  return null == a ? "" : String(a);
};
goog.string.buildString = function(a) {
  return Array.prototype.join.call(arguments, "");
};
goog.string.getRandomString = function() {
  return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
};
goog.string.compareVersions = function(a, b) {
  for (var c = 0, d = goog.string.trim(String(a)).split("."), e = goog.string.trim(String(b)).split("."), f = Math.max(d.length, e.length), g = 0; 0 == c && g < f; g++) {
    var h = d[g] || "", k = e[g] || "";
    do {
      h = /(\d*)(\D*)(.*)/.exec(h) || ["", "", "", ""];
      k = /(\d*)(\D*)(.*)/.exec(k) || ["", "", "", ""];
      if (0 == h[0].length && 0 == k[0].length) {
        break;
      }
      var c = 0 == h[1].length ? 0 : parseInt(h[1], 10), l = 0 == k[1].length ? 0 : parseInt(k[1], 10), c = goog.string.compareElements_(c, l) || goog.string.compareElements_(0 == h[2].length, 0 == k[2].length) || goog.string.compareElements_(h[2], k[2]), h = h[3], k = k[3];
    } while (0 == c);
  }
  return c;
};
goog.string.compareElements_ = function(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
};
goog.string.hashCode = function(a) {
  for (var b = 0, c = 0; c < a.length; ++c) {
    b = 31 * b + a.charCodeAt(c) >>> 0;
  }
  return b;
};
goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0;
goog.string.createUniqueString = function() {
  return "goog_" + goog.string.uniqueStringCounter_++;
};
goog.string.toNumber = function(a) {
  var b = Number(a);
  return 0 == b && goog.string.isEmptyOrWhitespace(a) ? NaN : b;
};
goog.string.isLowerCamelCase = function(a) {
  return /^[a-z]+([A-Z][a-z]*)*$/.test(a);
};
goog.string.isUpperCamelCase = function(a) {
  return /^([A-Z][a-z]*)+$/.test(a);
};
goog.string.toCamelCase = function(a) {
  return String(a).replace(/\-([a-z])/g, function(a, c) {
    return c.toUpperCase();
  });
};
goog.string.toSelectorCase = function(a) {
  return String(a).replace(/([A-Z])/g, "-$1").toLowerCase();
};
goog.string.toTitleCase = function(a, b) {
  var c = goog.isString(b) ? goog.string.regExpEscape(b) : "\\s";
  return a.replace(new RegExp("(^" + (c ? "|[" + c + "]+" : "") + ")([a-z])", "g"), function(a, b, c) {
    return b + c.toUpperCase();
  });
};
goog.string.capitalize = function(a) {
  return String(a.charAt(0)).toUpperCase() + String(a.substr(1)).toLowerCase();
};
goog.string.parseInt = function(a) {
  isFinite(a) && (a = String(a));
  return goog.isString(a) ? /^\s*-?0x/i.test(a) ? parseInt(a, 16) : parseInt(a, 10) : NaN;
};
goog.string.splitLimit = function(a, b, c) {
  a = a.split(b);
  for (var d = []; 0 < c && a.length;) {
    d.push(a.shift()), c--;
  }
  a.length && d.push(a.join(b));
  return d;
};
goog.string.lastComponent = function(a, b) {
  if (b) {
    "string" == typeof b && (b = [b]);
  } else {
    return a;
  }
  for (var c = -1, d = 0; d < b.length; d++) {
    if ("" != b[d]) {
      var e = a.lastIndexOf(b[d]);
      e > c && (c = e);
    }
  }
  return -1 == c ? a : a.slice(c + 1);
};
goog.string.editDistance = function(a, b) {
  var c = [], d = [];
  if (a == b) {
    return 0;
  }
  if (!a.length || !b.length) {
    return Math.max(a.length, b.length);
  }
  for (var e = 0; e < b.length + 1; e++) {
    c[e] = e;
  }
  for (e = 0; e < a.length; e++) {
    d[0] = e + 1;
    for (var f = 0; f < b.length; f++) {
      d[f + 1] = Math.min(d[f] + 1, c[f + 1] + 1, c[f] + Number(a[e] != b[f]));
    }
    for (f = 0; f < c.length; f++) {
      c[f] = d[f];
    }
  }
  return d[b.length];
};
goog.asserts = {};
goog.asserts.ENABLE_ASSERTS = goog.DEBUG;
goog.asserts.AssertionError = function(a, b) {
  b.unshift(a);
  goog.debug.Error.call(this, goog.string.subs.apply(null, b));
  b.shift();
  this.messagePattern = a;
};
goog.inherits(goog.asserts.AssertionError, goog.debug.Error);
goog.asserts.AssertionError.prototype.name = "AssertionError";
goog.asserts.DEFAULT_ERROR_HANDLER = function(a) {
  throw a;
};
goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER;
goog.asserts.doAssertFailure_ = function(a, b, c, d) {
  var e = "Assertion failed";
  if (c) {
    e += ": " + c;
    var f = d;
  } else {
    a && (e += ": " + a, f = b);
  }
  a = new goog.asserts.AssertionError("" + e, f || []);
  goog.asserts.errorHandler_(a);
};
goog.asserts.setErrorHandler = function(a) {
  goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = a);
};
goog.asserts.assert = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !a && goog.asserts.doAssertFailure_("", null, b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.fail = function(a, b) {
  goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1)));
};
goog.asserts.assertNumber = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !goog.isNumber(a) && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertString = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !goog.isString(a) && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertFunction = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !goog.isFunction(a) && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertObject = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !goog.isObject(a) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertArray = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !goog.isArray(a) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertBoolean = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !goog.isBoolean(a) && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertElement = function(a, b, c) {
  !goog.asserts.ENABLE_ASSERTS || goog.isObject(a) && a.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertInstanceof = function(a, b, c, d) {
  !goog.asserts.ENABLE_ASSERTS || a instanceof b || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [goog.asserts.getType_(b), goog.asserts.getType_(a)], c, Array.prototype.slice.call(arguments, 3));
  return a;
};
goog.asserts.assertObjectPrototypeIsIntact = function() {
  for (var a in Object.prototype) {
    goog.asserts.fail(a + " should not be enumerable in Object.prototype.");
  }
};
goog.asserts.getType_ = function(a) {
  return a instanceof Function ? a.displayName || a.name || "unknown type name" : a instanceof Object ? a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a) : null === a ? "null" : typeof a;
};
goog.array = {};
goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
goog.array.ASSUME_NATIVE_FUNCTIONS = !1;
goog.array.peek = function(a) {
  return a[a.length - 1];
};
goog.array.last = goog.array.peek;
goog.array.indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.indexOf.call(a, b, c);
} : function(a, b, c) {
  c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;
  if (goog.isString(a)) {
    return goog.isString(b) && 1 == b.length ? a.indexOf(b, c) : -1;
  }
  for (; c < a.length; c++) {
    if (c in a && a[c] === b) {
      return c;
    }
  }
  return -1;
};
goog.array.lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.lastIndexOf.call(a, b, null == c ? a.length - 1 : c);
} : function(a, b, c) {
  c = null == c ? a.length - 1 : c;
  0 > c && (c = Math.max(0, a.length + c));
  if (goog.isString(a)) {
    return goog.isString(b) && 1 == b.length ? a.lastIndexOf(b, c) : -1;
  }
  for (; 0 <= c; c--) {
    if (c in a && a[c] === b) {
      return c;
    }
  }
  return -1;
};
goog.array.forEach = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  Array.prototype.forEach.call(a, b, c);
} : function(a, b, c) {
  for (var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++) {
    f in e && b.call(c, e[f], f, a);
  }
};
goog.array.forEachRight = function(a, b, c) {
  for (var d = a.length, e = goog.isString(a) ? a.split("") : a, d = d - 1; 0 <= d; --d) {
    d in e && b.call(c, e[d], d, a);
  }
};
goog.array.filter = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.filter.call(a, b, c);
} : function(a, b, c) {
  for (var d = a.length, e = [], f = 0, g = goog.isString(a) ? a.split("") : a, h = 0; h < d; h++) {
    if (h in g) {
      var k = g[h];
      b.call(c, k, h, a) && (e[f++] = k);
    }
  }
  return e;
};
goog.array.map = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.map.call(a, b, c);
} : function(a, b, c) {
  for (var d = a.length, e = Array(d), f = goog.isString(a) ? a.split("") : a, g = 0; g < d; g++) {
    g in f && (e[g] = b.call(c, f[g], g, a));
  }
  return e;
};
goog.array.reduce = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(a, b, c, d) {
  goog.asserts.assert(null != a.length);
  d && (b = goog.bind(b, d));
  return Array.prototype.reduce.call(a, b, c);
} : function(a, b, c, d) {
  var e = c;
  goog.array.forEach(a, function(c, g) {
    e = b.call(d, e, c, g, a);
  });
  return e;
};
goog.array.reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(a, b, c, d) {
  goog.asserts.assert(null != a.length);
  goog.asserts.assert(null != b);
  d && (b = goog.bind(b, d));
  return Array.prototype.reduceRight.call(a, b, c);
} : function(a, b, c, d) {
  var e = c;
  goog.array.forEachRight(a, function(c, g) {
    e = b.call(d, e, c, g, a);
  });
  return e;
};
goog.array.some = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.some.call(a, b, c);
} : function(a, b, c) {
  for (var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++) {
    if (f in e && b.call(c, e[f], f, a)) {
      return !0;
    }
  }
  return !1;
};
goog.array.every = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.every.call(a, b, c);
} : function(a, b, c) {
  for (var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++) {
    if (f in e && !b.call(c, e[f], f, a)) {
      return !1;
    }
  }
  return !0;
};
goog.array.count = function(a, b, c) {
  var d = 0;
  goog.array.forEach(a, function(a, f, g) {
    b.call(c, a, f, g) && ++d;
  }, c);
  return d;
};
goog.array.find = function(a, b, c) {
  b = goog.array.findIndex(a, b, c);
  return 0 > b ? null : goog.isString(a) ? a.charAt(b) : a[b];
};
goog.array.findIndex = function(a, b, c) {
  for (var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++) {
    if (f in e && b.call(c, e[f], f, a)) {
      return f;
    }
  }
  return -1;
};
goog.array.findRight = function(a, b, c) {
  b = goog.array.findIndexRight(a, b, c);
  return 0 > b ? null : goog.isString(a) ? a.charAt(b) : a[b];
};
goog.array.findIndexRight = function(a, b, c) {
  for (var d = a.length, e = goog.isString(a) ? a.split("") : a, d = d - 1; 0 <= d; d--) {
    if (d in e && b.call(c, e[d], d, a)) {
      return d;
    }
  }
  return -1;
};
goog.array.contains = function(a, b) {
  return 0 <= goog.array.indexOf(a, b);
};
goog.array.isEmpty = function(a) {
  return 0 == a.length;
};
goog.array.clear = function(a) {
  if (!goog.isArray(a)) {
    for (var b = a.length - 1; 0 <= b; b--) {
      delete a[b];
    }
  }
  a.length = 0;
};
goog.array.insert = function(a, b) {
  goog.array.contains(a, b) || a.push(b);
};
goog.array.insertAt = function(a, b, c) {
  goog.array.splice(a, c, 0, b);
};
goog.array.insertArrayAt = function(a, b, c) {
  goog.partial(goog.array.splice, a, c, 0).apply(null, b);
};
goog.array.insertBefore = function(a, b, c) {
  var d;
  2 == arguments.length || 0 > (d = goog.array.indexOf(a, c)) ? a.push(b) : goog.array.insertAt(a, b, d);
};
goog.array.remove = function(a, b) {
  var c = goog.array.indexOf(a, b), d;
  (d = 0 <= c) && goog.array.removeAt(a, c);
  return d;
};
goog.array.removeLast = function(a, b) {
  var c = goog.array.lastIndexOf(a, b);
  return 0 <= c ? (goog.array.removeAt(a, c), !0) : !1;
};
goog.array.removeAt = function(a, b) {
  goog.asserts.assert(null != a.length);
  return 1 == Array.prototype.splice.call(a, b, 1).length;
};
goog.array.removeIf = function(a, b, c) {
  b = goog.array.findIndex(a, b, c);
  return 0 <= b ? (goog.array.removeAt(a, b), !0) : !1;
};
goog.array.removeAllIf = function(a, b, c) {
  var d = 0;
  goog.array.forEachRight(a, function(e, f) {
    b.call(c, e, f, a) && goog.array.removeAt(a, f) && d++;
  });
  return d;
};
goog.array.concat = function(a) {
  return Array.prototype.concat.apply([], arguments);
};
goog.array.join = function(a) {
  return Array.prototype.concat.apply([], arguments);
};
goog.array.toArray = function(a) {
  var b = a.length;
  if (0 < b) {
    for (var c = Array(b), d = 0; d < b; d++) {
      c[d] = a[d];
    }
    return c;
  }
  return [];
};
goog.array.clone = goog.array.toArray;
goog.array.extend = function(a, b) {
  for (var c = 1; c < arguments.length; c++) {
    var d = arguments[c];
    if (goog.isArrayLike(d)) {
      var e = a.length || 0, f = d.length || 0;
      a.length = e + f;
      for (var g = 0; g < f; g++) {
        a[e + g] = d[g];
      }
    } else {
      a.push(d);
    }
  }
};
goog.array.splice = function(a, b, c, d) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.splice.apply(a, goog.array.slice(arguments, 1));
};
goog.array.slice = function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return 2 >= arguments.length ? Array.prototype.slice.call(a, b) : Array.prototype.slice.call(a, b, c);
};
goog.array.removeDuplicates = function(a, b, c) {
  b = b || a;
  var d = function(a) {
    return goog.isObject(a) ? "o" + goog.getUid(a) : (typeof a).charAt(0) + a;
  };
  c = c || d;
  for (var d = {}, e = 0, f = 0; f < a.length;) {
    var g = a[f++], h = c(g);
    Object.prototype.hasOwnProperty.call(d, h) || (d[h] = !0, b[e++] = g);
  }
  b.length = e;
};
goog.array.binarySearch = function(a, b, c) {
  return goog.array.binarySearch_(a, c || goog.array.defaultCompare, !1, b);
};
goog.array.binarySelect = function(a, b, c) {
  return goog.array.binarySearch_(a, b, !0, void 0, c);
};
goog.array.binarySearch_ = function(a, b, c, d, e) {
  for (var f = 0, g = a.length, h; f < g;) {
    var k = f + g >> 1;
    var l = c ? b.call(e, a[k], k, a) : b(d, a[k]);
    0 < l ? f = k + 1 : (g = k, h = !l);
  }
  return h ? f : ~f;
};
goog.array.sort = function(a, b) {
  a.sort(b || goog.array.defaultCompare);
};
goog.array.stableSort = function(a, b) {
  for (var c = Array(a.length), d = 0; d < a.length; d++) {
    c[d] = {index:d, value:a[d]};
  }
  var e = b || goog.array.defaultCompare;
  goog.array.sort(c, function(a, b) {
    return e(a.value, b.value) || a.index - b.index;
  });
  for (d = 0; d < a.length; d++) {
    a[d] = c[d].value;
  }
};
goog.array.sortByKey = function(a, b, c) {
  var d = c || goog.array.defaultCompare;
  goog.array.sort(a, function(a, c) {
    return d(b(a), b(c));
  });
};
goog.array.sortObjectsByKey = function(a, b, c) {
  goog.array.sortByKey(a, function(a) {
    return a[b];
  }, c);
};
goog.array.isSorted = function(a, b, c) {
  b = b || goog.array.defaultCompare;
  for (var d = 1; d < a.length; d++) {
    var e = b(a[d - 1], a[d]);
    if (0 < e || 0 == e && c) {
      return !1;
    }
  }
  return !0;
};
goog.array.equals = function(a, b, c) {
  if (!goog.isArrayLike(a) || !goog.isArrayLike(b) || a.length != b.length) {
    return !1;
  }
  var d = a.length;
  c = c || goog.array.defaultCompareEquality;
  for (var e = 0; e < d; e++) {
    if (!c(a[e], b[e])) {
      return !1;
    }
  }
  return !0;
};
goog.array.compare3 = function(a, b, c) {
  c = c || goog.array.defaultCompare;
  for (var d = Math.min(a.length, b.length), e = 0; e < d; e++) {
    var f = c(a[e], b[e]);
    if (0 != f) {
      return f;
    }
  }
  return goog.array.defaultCompare(a.length, b.length);
};
goog.array.defaultCompare = function(a, b) {
  return a > b ? 1 : a < b ? -1 : 0;
};
goog.array.inverseDefaultCompare = function(a, b) {
  return -goog.array.defaultCompare(a, b);
};
goog.array.defaultCompareEquality = function(a, b) {
  return a === b;
};
goog.array.binaryInsert = function(a, b, c) {
  c = goog.array.binarySearch(a, b, c);
  return 0 > c ? (goog.array.insertAt(a, b, -(c + 1)), !0) : !1;
};
goog.array.binaryRemove = function(a, b, c) {
  b = goog.array.binarySearch(a, b, c);
  return 0 <= b ? goog.array.removeAt(a, b) : !1;
};
goog.array.bucket = function(a, b, c) {
  for (var d = {}, e = 0; e < a.length; e++) {
    var f = a[e], g = b.call(c, f, e, a);
    goog.isDef(g) && (d[g] || (d[g] = [])).push(f);
  }
  return d;
};
goog.array.toObject = function(a, b, c) {
  var d = {};
  goog.array.forEach(a, function(e, f) {
    d[b.call(c, e, f, a)] = e;
  });
  return d;
};
goog.array.range = function(a, b, c) {
  var d = [], e = 0, f = a;
  c = c || 1;
  void 0 !== b && (e = a, f = b);
  if (0 > c * (f - e)) {
    return [];
  }
  if (0 < c) {
    for (a = e; a < f; a += c) {
      d.push(a);
    }
  } else {
    for (a = e; a > f; a += c) {
      d.push(a);
    }
  }
  return d;
};
goog.array.repeat = function(a, b) {
  for (var c = [], d = 0; d < b; d++) {
    c[d] = a;
  }
  return c;
};
goog.array.flatten = function(a) {
  for (var b = [], c = 0; c < arguments.length; c++) {
    var d = arguments[c];
    if (goog.isArray(d)) {
      for (var e = 0; e < d.length; e += 8192) {
        for (var f = goog.array.slice(d, e, e + 8192), f = goog.array.flatten.apply(null, f), g = 0; g < f.length; g++) {
          b.push(f[g]);
        }
      }
    } else {
      b.push(d);
    }
  }
  return b;
};
goog.array.rotate = function(a, b) {
  goog.asserts.assert(null != a.length);
  a.length && (b %= a.length, 0 < b ? Array.prototype.unshift.apply(a, a.splice(-b, b)) : 0 > b && Array.prototype.push.apply(a, a.splice(0, -b)));
  return a;
};
goog.array.moveItem = function(a, b, c) {
  goog.asserts.assert(0 <= b && b < a.length);
  goog.asserts.assert(0 <= c && c < a.length);
  b = Array.prototype.splice.call(a, b, 1);
  Array.prototype.splice.call(a, c, 0, b[0]);
};
goog.array.zip = function(a) {
  if (!arguments.length) {
    return [];
  }
  for (var b = [], c = arguments[0].length, d = 1; d < arguments.length; d++) {
    arguments[d].length < c && (c = arguments[d].length);
  }
  for (d = 0; d < c; d++) {
    for (var e = [], f = 0; f < arguments.length; f++) {
      e.push(arguments[f][d]);
    }
    b.push(e);
  }
  return b;
};
goog.array.shuffle = function(a, b) {
  for (var c = b || Math.random, d = a.length - 1; 0 < d; d--) {
    var e = Math.floor(c() * (d + 1)), f = a[d];
    a[d] = a[e];
    a[e] = f;
  }
};
goog.array.copyByIndex = function(a, b) {
  var c = [];
  goog.array.forEach(b, function(b) {
    c.push(a[b]);
  });
  return c;
};
goog.array.concatMap = function(a, b, c) {
  return goog.array.concat.apply([], goog.array.map(a, b, c));
};
goog.object = {};
goog.object.is = function(a, b) {
  return a === b ? 0 !== a || 1 / a === 1 / b : a !== a && b !== b;
};
goog.object.forEach = function(a, b, c) {
  for (var d in a) {
    b.call(c, a[d], d, a);
  }
};
goog.object.filter = function(a, b, c) {
  var d = {}, e;
  for (e in a) {
    b.call(c, a[e], e, a) && (d[e] = a[e]);
  }
  return d;
};
goog.object.map = function(a, b, c) {
  var d = {}, e;
  for (e in a) {
    d[e] = b.call(c, a[e], e, a);
  }
  return d;
};
goog.object.some = function(a, b, c) {
  for (var d in a) {
    if (b.call(c, a[d], d, a)) {
      return !0;
    }
  }
  return !1;
};
goog.object.every = function(a, b, c) {
  for (var d in a) {
    if (!b.call(c, a[d], d, a)) {
      return !1;
    }
  }
  return !0;
};
goog.object.getCount = function(a) {
  var b = 0, c;
  for (c in a) {
    b++;
  }
  return b;
};
goog.object.getAnyKey = function(a) {
  for (var b in a) {
    return b;
  }
};
goog.object.getAnyValue = function(a) {
  for (var b in a) {
    return a[b];
  }
};
goog.object.contains = function(a, b) {
  return goog.object.containsValue(a, b);
};
goog.object.getValues = function(a) {
  var b = [], c = 0, d;
  for (d in a) {
    b[c++] = a[d];
  }
  return b;
};
goog.object.getKeys = function(a) {
  var b = [], c = 0, d;
  for (d in a) {
    b[c++] = d;
  }
  return b;
};
goog.object.getValueByKeys = function(a, b) {
  for (var c = goog.isArrayLike(b), d = c ? b : arguments, c = c ? 0 : 1; c < d.length && (a = a[d[c]], goog.isDef(a)); c++) {
  }
  return a;
};
goog.object.containsKey = function(a, b) {
  return null !== a && b in a;
};
goog.object.containsValue = function(a, b) {
  for (var c in a) {
    if (a[c] == b) {
      return !0;
    }
  }
  return !1;
};
goog.object.findKey = function(a, b, c) {
  for (var d in a) {
    if (b.call(c, a[d], d, a)) {
      return d;
    }
  }
};
goog.object.findValue = function(a, b, c) {
  return (b = goog.object.findKey(a, b, c)) && a[b];
};
goog.object.isEmpty = function(a) {
  for (var b in a) {
    return !1;
  }
  return !0;
};
goog.object.clear = function(a) {
  for (var b in a) {
    delete a[b];
  }
};
goog.object.remove = function(a, b) {
  var c;
  (c = b in a) && delete a[b];
  return c;
};
goog.object.add = function(a, b, c) {
  if (null !== a && b in a) {
    throw Error('The object already contains the key "' + b + '"');
  }
  goog.object.set(a, b, c);
};
goog.object.get = function(a, b, c) {
  return null !== a && b in a ? a[b] : c;
};
goog.object.set = function(a, b, c) {
  a[b] = c;
};
goog.object.setIfUndefined = function(a, b, c) {
  return b in a ? a[b] : a[b] = c;
};
goog.object.setWithReturnValueIfNotSet = function(a, b, c) {
  if (b in a) {
    return a[b];
  }
  c = c();
  return a[b] = c;
};
goog.object.equals = function(a, b) {
  for (var c in a) {
    if (!(c in b) || a[c] !== b[c]) {
      return !1;
    }
  }
  for (c in b) {
    if (!(c in a)) {
      return !1;
    }
  }
  return !0;
};
goog.object.clone = function(a) {
  var b = {}, c;
  for (c in a) {
    b[c] = a[c];
  }
  return b;
};
goog.object.unsafeClone = function(a) {
  var b = goog.typeOf(a);
  if ("object" == b || "array" == b) {
    if (goog.isFunction(a.clone)) {
      return a.clone();
    }
    var b = "array" == b ? [] : {}, c;
    for (c in a) {
      b[c] = goog.object.unsafeClone(a[c]);
    }
    return b;
  }
  return a;
};
goog.object.transpose = function(a) {
  var b = {}, c;
  for (c in a) {
    b[a[c]] = c;
  }
  return b;
};
goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
goog.object.extend = function(a, b) {
  for (var c, d, e = 1; e < arguments.length; e++) {
    d = arguments[e];
    for (c in d) {
      a[c] = d[c];
    }
    for (var f = 0; f < goog.object.PROTOTYPE_FIELDS_.length; f++) {
      c = goog.object.PROTOTYPE_FIELDS_[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
  }
};
goog.object.create = function(a) {
  var b = arguments.length;
  if (1 == b && goog.isArray(arguments[0])) {
    return goog.object.create.apply(null, arguments[0]);
  }
  if (b % 2) {
    throw Error("Uneven number of arguments");
  }
  for (var c = {}, d = 0; d < b; d += 2) {
    c[arguments[d]] = arguments[d + 1];
  }
  return c;
};
goog.object.createSet = function(a) {
  var b = arguments.length;
  if (1 == b && goog.isArray(arguments[0])) {
    return goog.object.createSet.apply(null, arguments[0]);
  }
  for (var c = {}, d = 0; d < b; d++) {
    c[arguments[d]] = !0;
  }
  return c;
};
goog.object.createImmutableView = function(a) {
  var b = a;
  Object.isFrozen && !Object.isFrozen(a) && (b = Object.create(a), Object.freeze(b));
  return b;
};
goog.object.isImmutableView = function(a) {
  return !!Object.isFrozen && Object.isFrozen(a);
};
goog.object.getAllPropertyNames = function(a, b, c) {
  if (!a) {
    return [];
  }
  if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) {
    return goog.object.getKeys(a);
  }
  for (var d = {}; a && (a !== Object.prototype || b) && (a !== Function.prototype || c);) {
    for (var e = Object.getOwnPropertyNames(a), f = 0; f < e.length; f++) {
      d[e[f]] = !0;
    }
    a = Object.getPrototypeOf(a);
  }
  return goog.object.getKeys(d);
};
goog.proto2 = {};
goog.proto2.FieldDescriptor = function(a, b, c) {
  this.parent_ = a;
  goog.asserts.assert(goog.string.isNumeric(b));
  this.tag_ = b;
  this.name_ = c.name;
  this.isPacked_ = !!c.packed;
  this.isRepeated_ = !!c.repeated;
  this.isRequired_ = !!c.required;
  this.fieldType_ = c.fieldType;
  this.nativeType_ = c.type;
  this.deserializationConversionPermitted_ = !1;
  switch(this.fieldType_) {
    case goog.proto2.FieldDescriptor.FieldType.INT64:
    case goog.proto2.FieldDescriptor.FieldType.UINT64:
    case goog.proto2.FieldDescriptor.FieldType.FIXED64:
    case goog.proto2.FieldDescriptor.FieldType.SFIXED64:
    case goog.proto2.FieldDescriptor.FieldType.SINT64:
    case goog.proto2.FieldDescriptor.FieldType.FLOAT:
    case goog.proto2.FieldDescriptor.FieldType.DOUBLE:
      this.deserializationConversionPermitted_ = !0;
  }
  this.defaultValue_ = c.defaultValue;
};
goog.proto2.FieldDescriptor.FieldType = {DOUBLE:1, FLOAT:2, INT64:3, UINT64:4, INT32:5, FIXED64:6, FIXED32:7, BOOL:8, STRING:9, GROUP:10, MESSAGE:11, BYTES:12, UINT32:13, ENUM:14, SFIXED32:15, SFIXED64:16, SINT32:17, SINT64:18};
goog.proto2.FieldDescriptor.prototype.getTag = function() {
  return this.tag_;
};
goog.proto2.FieldDescriptor.prototype.getContainingType = function() {
  return this.parent_.prototype.getDescriptor();
};
goog.proto2.FieldDescriptor.prototype.getName = function() {
  return this.name_;
};
goog.proto2.FieldDescriptor.prototype.getDefaultValue = function() {
  if (void 0 === this.defaultValue_) {
    var a = this.nativeType_;
    if (a === Boolean) {
      this.defaultValue_ = !1;
    } else {
      if (a === Number) {
        this.defaultValue_ = 0;
      } else {
        if (a === String) {
          this.defaultValue_ = this.deserializationConversionPermitted_ ? "0" : "";
        } else {
          return new a;
        }
      }
    }
  }
  return this.defaultValue_;
};
goog.proto2.FieldDescriptor.prototype.getFieldType = function() {
  return this.fieldType_;
};
goog.proto2.FieldDescriptor.prototype.getNativeType = function() {
  return this.nativeType_;
};
goog.proto2.FieldDescriptor.prototype.deserializationConversionPermitted = function() {
  return this.deserializationConversionPermitted_;
};
goog.proto2.FieldDescriptor.prototype.getFieldMessageType = function() {
  return this.nativeType_.prototype.getDescriptor();
};
goog.proto2.FieldDescriptor.prototype.isCompositeType = function() {
  return this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.MESSAGE || this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.GROUP;
};
goog.proto2.FieldDescriptor.prototype.isPacked = function() {
  return this.isPacked_;
};
goog.proto2.FieldDescriptor.prototype.isRepeated = function() {
  return this.isRepeated_;
};
goog.proto2.FieldDescriptor.prototype.isRequired = function() {
  return this.isRequired_;
};
goog.proto2.FieldDescriptor.prototype.isOptional = function() {
  return !this.isRepeated_ && !this.isRequired_;
};
goog.proto2.Descriptor = function(a, b, c) {
  this.messageType_ = a;
  this.name_ = b.name || null;
  this.fullName_ = b.fullName || null;
  this.containingType_ = b.containingType;
  this.fields_ = {};
  for (a = 0; a < c.length; a++) {
    b = c[a], this.fields_[b.getTag()] = b;
  }
};
goog.proto2.Descriptor.prototype.getName = function() {
  return this.name_;
};
goog.proto2.Descriptor.prototype.getFullName = function() {
  return this.fullName_;
};
goog.proto2.Descriptor.prototype.getContainingType = function() {
  return this.containingType_ ? this.containingType_.getDescriptor() : null;
};
goog.proto2.Descriptor.prototype.getFields = function() {
  var a = goog.object.getValues(this.fields_);
  goog.array.sort(a, function(a, c) {
    return a.getTag() - c.getTag();
  });
  return a;
};
goog.proto2.Descriptor.prototype.getFieldsMap = function() {
  return this.fields_;
};
goog.proto2.Descriptor.prototype.findFieldByName = function(a) {
  return goog.object.findValue(this.fields_, function(b, c, d) {
    return b.getName() == a;
  }) || null;
};
goog.proto2.Descriptor.prototype.findFieldByTag = function(a) {
  goog.asserts.assert(goog.string.isNumeric(a));
  return this.fields_[parseInt(a, 10)] || null;
};
goog.proto2.Descriptor.prototype.createMessageInstance = function() {
  return new this.messageType_;
};
goog.proto2.Message = function() {
  this.values_ = {};
  this.fields_ = this.getDescriptor().getFieldsMap();
  this.deserializedFields_ = this.lazyDeserializer_ = null;
};
goog.proto2.Message.FieldType = {DOUBLE:1, FLOAT:2, INT64:3, UINT64:4, INT32:5, FIXED64:6, FIXED32:7, BOOL:8, STRING:9, GROUP:10, MESSAGE:11, BYTES:12, UINT32:13, ENUM:14, SFIXED32:15, SFIXED64:16, SINT32:17, SINT64:18};
goog.proto2.Message.prototype.initializeForLazyDeserializer = function(a, b) {
  this.lazyDeserializer_ = a;
  this.values_ = b;
  this.deserializedFields_ = {};
};
goog.proto2.Message.prototype.setUnknown = function(a, b) {
  goog.asserts.assert(!this.fields_[a], "Field is not unknown in this message");
  goog.asserts.assert(1 <= a, "Tag " + a + ' has value "' + b + '" in descriptor ' + this.getDescriptor().getName());
  goog.asserts.assert(null !== b, "Value cannot be null");
  this.values_[a] = b;
  this.deserializedFields_ && delete this.deserializedFields_[a];
};
goog.proto2.Message.prototype.forEachUnknown = function(a, b) {
  var c = b || this, d;
  for (d in this.values_) {
    var e = Number(d);
    this.fields_[e] || a.call(c, e, this.values_[d]);
  }
};
goog.proto2.Message.prototype.getDescriptor = goog.abstractMethod;
goog.proto2.Message.prototype.has = function(a) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  return this.has$Value(a.getTag());
};
goog.proto2.Message.prototype.arrayOf = function(a) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  return this.array$Values(a.getTag());
};
goog.proto2.Message.prototype.countOf = function(a) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  return this.count$Values(a.getTag());
};
goog.proto2.Message.prototype.get = function(a, b) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  return this.get$Value(a.getTag(), b);
};
goog.proto2.Message.prototype.getOrDefault = function(a, b) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  return this.get$ValueOrDefault(a.getTag(), b);
};
goog.proto2.Message.prototype.set = function(a, b) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  this.set$Value(a.getTag(), b);
};
goog.proto2.Message.prototype.add = function(a, b) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  this.add$Value(a.getTag(), b);
};
goog.proto2.Message.prototype.clear = function(a) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  this.clear$Field(a.getTag());
};
goog.proto2.Message.prototype.equals = function(a) {
  if (!a || this.constructor != a.constructor) {
    return !1;
  }
  for (var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++) {
    var d = b[c], e = d.getTag();
    if (this.has$Value(e) != a.has$Value(e)) {
      return !1;
    }
    if (this.has$Value(e)) {
      var f = d.isCompositeType(), g = this.getValueForTag_(e), e = a.getValueForTag_(e);
      if (d.isRepeated()) {
        if (g.length != e.length) {
          return !1;
        }
        for (d = 0; d < g.length; d++) {
          var h = g[d], k = e[d];
          if (f ? !h.equals(k) : h != k) {
            return !1;
          }
        }
      } else {
        if (f ? !g.equals(e) : g != e) {
          return !1;
        }
      }
    }
  }
  return !0;
};
goog.proto2.Message.prototype.copyFrom = function(a) {
  goog.asserts.assert(this.constructor == a.constructor, "The source message must have the same type.");
  this != a && (this.values_ = {}, this.deserializedFields_ && (this.deserializedFields_ = {}), this.mergeFrom(a));
};
goog.proto2.Message.prototype.mergeFrom = function(a) {
  goog.asserts.assert(this.constructor == a.constructor, "The source message must have the same type.");
  for (var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++) {
    var d = b[c], e = d.getTag();
    if (a.has$Value(e)) {
      this.deserializedFields_ && delete this.deserializedFields_[d.getTag()];
      var f = d.isCompositeType();
      if (d.isRepeated()) {
        for (var d = a.array$Values(e), g = 0; g < d.length; g++) {
          this.add$Value(e, f ? d[g].clone() : d[g]);
        }
      } else {
        d = a.getValueForTag_(e), f ? (f = this.getValueForTag_(e)) ? f.mergeFrom(d) : this.set$Value(e, d.clone()) : this.set$Value(e, d);
      }
    }
  }
};
goog.proto2.Message.prototype.clone = function() {
  var a = new this.constructor;
  a.copyFrom(this);
  return a;
};
goog.proto2.Message.prototype.initDefaults = function(a) {
  for (var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++) {
    var d = b[c], e = d.getTag(), f = d.isCompositeType();
    this.has$Value(e) || d.isRepeated() || (f ? this.values_[e] = new (d.getNativeType()) : a && (this.values_[e] = d.getDefaultValue()));
    if (f) {
      if (d.isRepeated()) {
        for (d = this.array$Values(e), e = 0; e < d.length; e++) {
          d[e].initDefaults(a);
        }
      } else {
        this.get$Value(e).initDefaults(a);
      }
    }
  }
};
goog.proto2.Message.prototype.has$Value = function(a) {
  return null != this.values_[a];
};
goog.proto2.Message.prototype.getValueForTag_ = function(a) {
  var b = this.values_[a];
  return goog.isDefAndNotNull(b) ? this.lazyDeserializer_ ? a in this.deserializedFields_ ? this.deserializedFields_[a] : (b = this.lazyDeserializer_.deserializeField(this, this.fields_[a], b), this.deserializedFields_[a] = b) : b : null;
};
goog.proto2.Message.prototype.get$Value = function(a, b) {
  var c = this.getValueForTag_(a);
  if (this.fields_[a].isRepeated()) {
    var d = b || 0;
    goog.asserts.assert(0 <= d && d < c.length, "Given index %s is out of bounds.  Repeated field length: %s", d, c.length);
    return c[d];
  }
  return c;
};
goog.proto2.Message.prototype.get$ValueOrDefault = function(a, b) {
  return this.has$Value(a) ? this.get$Value(a, b) : this.fields_[a].getDefaultValue();
};
goog.proto2.Message.prototype.array$Values = function(a) {
  return this.getValueForTag_(a) || [];
};
goog.proto2.Message.prototype.count$Values = function(a) {
  return this.fields_[a].isRepeated() ? this.has$Value(a) ? this.values_[a].length : 0 : this.has$Value(a) ? 1 : 0;
};
goog.proto2.Message.prototype.set$Value = function(a, b) {
  goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a], b);
  this.values_[a] = b;
  this.deserializedFields_ && (this.deserializedFields_[a] = b);
};
goog.proto2.Message.prototype.add$Value = function(a, b) {
  goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a], b);
  this.values_[a] || (this.values_[a] = []);
  this.values_[a].push(b);
  this.deserializedFields_ && delete this.deserializedFields_[a];
};
goog.proto2.Message.prototype.checkFieldType_ = function(a, b) {
  a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM ? goog.asserts.assertNumber(b) : goog.asserts.assert(Object(b).constructor == a.getNativeType());
};
goog.proto2.Message.prototype.clear$Field = function(a) {
  delete this.values_[a];
  this.deserializedFields_ && delete this.deserializedFields_[a];
};
goog.proto2.Message.createDescriptor = function(a, b) {
  var c = [], d = b[0], e;
  for (e in b) {
    0 != e && c.push(new goog.proto2.FieldDescriptor(a, e, b[e]));
  }
  return new goog.proto2.Descriptor(a, d, c);
};
goog.proto2.Serializer = function() {
};
goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS = !1;
goog.proto2.Serializer.prototype.serialize = goog.abstractMethod;
goog.proto2.Serializer.prototype.getSerializedValue = function(a, b) {
  return a.isCompositeType() ? this.serialize(b) : goog.isNumber(b) && !isFinite(b) ? b.toString() : b;
};
goog.proto2.Serializer.prototype.deserialize = function(a, b) {
  var c = a.createMessageInstance();
  this.deserializeTo(c, b);
  goog.asserts.assert(c instanceof goog.proto2.Message);
  return c;
};
goog.proto2.Serializer.prototype.deserializeTo = goog.abstractMethod;
goog.proto2.Serializer.prototype.getDeserializedValue = function(a, b) {
  if (a.isCompositeType()) {
    return b instanceof goog.proto2.Message ? b : this.deserialize(a.getFieldMessageType(), b);
  }
  if (a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM) {
    if (goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS && goog.isString(b)) {
      var c = a.getNativeType();
      if (c.hasOwnProperty(b)) {
        return c[b];
      }
    }
    return goog.isString(b) && goog.proto2.Serializer.INTEGER_REGEX.test(b) && (c = Number(b), 0 < c) ? c : b;
  }
  if (!a.deserializationConversionPermitted()) {
    return b;
  }
  c = a.getNativeType();
  if (c === String) {
    if (goog.isNumber(b)) {
      return String(b);
    }
  } else {
    if (c === Number && goog.isString(b) && ("Infinity" === b || "-Infinity" === b || "NaN" === b || goog.proto2.Serializer.INTEGER_REGEX.test(b))) {
      return Number(b);
    }
  }
  return b;
};
goog.proto2.Serializer.INTEGER_REGEX = /^-?[0-9]+$/;
goog.proto2.LazyDeserializer = function() {
};
goog.inherits(goog.proto2.LazyDeserializer, goog.proto2.Serializer);
goog.proto2.LazyDeserializer.prototype.deserialize = function(a, b) {
  var c = a.createMessageInstance();
  c.initializeForLazyDeserializer(this, b);
  goog.asserts.assert(c instanceof goog.proto2.Message);
  return c;
};
goog.proto2.LazyDeserializer.prototype.deserializeTo = function(a, b) {
  throw Error("Unimplemented");
};
goog.proto2.LazyDeserializer.prototype.deserializeField = goog.abstractMethod;
goog.proto2.PbLiteSerializer = function() {
};
goog.inherits(goog.proto2.PbLiteSerializer, goog.proto2.LazyDeserializer);
goog.proto2.PbLiteSerializer.prototype.zeroIndexing_ = !1;
goog.proto2.PbLiteSerializer.prototype.setZeroIndexed = function(a) {
  this.zeroIndexing_ = a;
};
goog.proto2.PbLiteSerializer.prototype.serialize = function(a) {
  for (var b = a.getDescriptor().getFields(), c = [], d = this.zeroIndexing_, e = 0; e < b.length; e++) {
    var f = b[e];
    if (a.has(f)) {
      var g = f.getTag(), g = d ? g - 1 : g;
      if (f.isRepeated()) {
        c[g] = [];
        for (var h = 0; h < a.countOf(f); h++) {
          c[g][h] = this.getSerializedValue(f, a.get(f, h));
        }
      } else {
        c[g] = this.getSerializedValue(f, a.get(f));
      }
    }
  }
  a.forEachUnknown(function(a, b) {
    c[d ? a - 1 : a] = b;
  });
  return c;
};
goog.proto2.PbLiteSerializer.prototype.deserializeField = function(a, b, c) {
  if (null == c) {
    return c;
  }
  if (b.isRepeated()) {
    a = [];
    goog.asserts.assert(goog.isArray(c), "Value must be array: %s", c);
    for (var d = 0; d < c.length; d++) {
      a[d] = this.getDeserializedValue(b, c[d]);
    }
    return a;
  }
  return this.getDeserializedValue(b, c);
};
goog.proto2.PbLiteSerializer.prototype.getSerializedValue = function(a, b) {
  return a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? b ? 1 : 0 : goog.proto2.Serializer.prototype.getSerializedValue.apply(this, arguments);
};
goog.proto2.PbLiteSerializer.prototype.getDeserializedValue = function(a, b) {
  return a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? (goog.asserts.assert(goog.isNumber(b) || goog.isBoolean(b), "Value is expected to be a number or boolean"), !!b) : goog.proto2.Serializer.prototype.getDeserializedValue.apply(this, arguments);
};
goog.proto2.PbLiteSerializer.prototype.deserialize = function(a, b) {
  var c = b;
  if (this.zeroIndexing_) {
    var c = [], d;
    for (d in b) {
      c[parseInt(d, 10) + 1] = b[d];
    }
  }
  return goog.proto2.PbLiteSerializer.superClass_.deserialize.call(this, a, c);
};
/*

 Protocol Buffer 2 Copyright 2008 Google Inc.
 All other code copyright its respective owners.
 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
var i18n = {phonenumbers:{}};
i18n.phonenumbers.NumberFormat = function() {
  goog.proto2.Message.call(this);
};
goog.inherits(i18n.phonenumbers.NumberFormat, goog.proto2.Message);
i18n.phonenumbers.NumberFormat.descriptor_ = null;
i18n.phonenumbers.NumberFormat.prototype.getPattern = function() {
  return this.get$Value(1);
};
i18n.phonenumbers.NumberFormat.prototype.getPatternOrDefault = function() {
  return this.get$ValueOrDefault(1);
};
i18n.phonenumbers.NumberFormat.prototype.setPattern = function(a) {
  this.set$Value(1, a);
};
i18n.phonenumbers.NumberFormat.prototype.hasPattern = function() {
  return this.has$Value(1);
};
i18n.phonenumbers.NumberFormat.prototype.patternCount = function() {
  return this.count$Values(1);
};
i18n.phonenumbers.NumberFormat.prototype.clearPattern = function() {
  this.clear$Field(1);
};
i18n.phonenumbers.NumberFormat.prototype.getFormat = function() {
  return this.get$Value(2);
};
i18n.phonenumbers.NumberFormat.prototype.getFormatOrDefault = function() {
  return this.get$ValueOrDefault(2);
};
i18n.phonenumbers.NumberFormat.prototype.setFormat = function(a) {
  this.set$Value(2, a);
};
i18n.phonenumbers.NumberFormat.prototype.hasFormat = function() {
  return this.has$Value(2);
};
i18n.phonenumbers.NumberFormat.prototype.formatCount = function() {
  return this.count$Values(2);
};
i18n.phonenumbers.NumberFormat.prototype.clearFormat = function() {
  this.clear$Field(2);
};
i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPattern = function(a) {
  return this.get$Value(3, a);
};
i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPatternOrDefault = function(a) {
  return this.get$ValueOrDefault(3, a);
};
i18n.phonenumbers.NumberFormat.prototype.addLeadingDigitsPattern = function(a) {
  this.add$Value(3, a);
};
i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternArray = function() {
  return this.array$Values(3);
};
i18n.phonenumbers.NumberFormat.prototype.hasLeadingDigitsPattern = function() {
  return this.has$Value(3);
};
i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternCount = function() {
  return this.count$Values(3);
};
i18n.phonenumbers.NumberFormat.prototype.clearLeadingDigitsPattern = function() {
  this.clear$Field(3);
};
i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRule = function() {
  return this.get$Value(4);
};
i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRuleOrDefault = function() {
  return this.get$ValueOrDefault(4);
};
i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixFormattingRule = function(a) {
  this.set$Value(4, a);
};
i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixFormattingRule = function() {
  return this.has$Value(4);
};
i18n.phonenumbers.NumberFormat.prototype.nationalPrefixFormattingRuleCount = function() {
  return this.count$Values(4);
};
i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixFormattingRule = function() {
  this.clear$Field(4);
};
i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormatting = function() {
  return this.get$Value(6);
};
i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormattingOrDefault = function() {
  return this.get$ValueOrDefault(6);
};
i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixOptionalWhenFormatting = function(a) {
  this.set$Value(6, a);
};
i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixOptionalWhenFormatting = function() {
  return this.has$Value(6);
};
i18n.phonenumbers.NumberFormat.prototype.nationalPrefixOptionalWhenFormattingCount = function() {
  return this.count$Values(6);
};
i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixOptionalWhenFormatting = function() {
  this.clear$Field(6);
};
i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRule = function() {
  return this.get$Value(5);
};
i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRuleOrDefault = function() {
  return this.get$ValueOrDefault(5);
};
i18n.phonenumbers.NumberFormat.prototype.setDomesticCarrierCodeFormattingRule = function(a) {
  this.set$Value(5, a);
};
i18n.phonenumbers.NumberFormat.prototype.hasDomesticCarrierCodeFormattingRule = function() {
  return this.has$Value(5);
};
i18n.phonenumbers.NumberFormat.prototype.domesticCarrierCodeFormattingRuleCount = function() {
  return this.count$Values(5);
};
i18n.phonenumbers.NumberFormat.prototype.clearDomesticCarrierCodeFormattingRule = function() {
  this.clear$Field(5);
};
i18n.phonenumbers.PhoneNumberDesc = function() {
  goog.proto2.Message.call(this);
};
goog.inherits(i18n.phonenumbers.PhoneNumberDesc, goog.proto2.Message);
i18n.phonenumbers.PhoneNumberDesc.descriptor_ = null;
i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPattern = function() {
  return this.get$Value(2);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPatternOrDefault = function() {
  return this.get$ValueOrDefault(2);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.setNationalNumberPattern = function(a) {
  this.set$Value(2, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasNationalNumberPattern = function() {
  return this.has$Value(2);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.nationalNumberPatternCount = function() {
  return this.count$Values(2);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.clearNationalNumberPattern = function() {
  this.clear$Field(2);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleNumberPattern = function() {
  return this.get$Value(3);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleNumberPatternOrDefault = function() {
  return this.get$ValueOrDefault(3);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.setPossibleNumberPattern = function(a) {
  this.set$Value(3, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleNumberPattern = function() {
  return this.has$Value(3);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.possibleNumberPatternCount = function() {
  return this.count$Values(3);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleNumberPattern = function() {
  this.clear$Field(3);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLength = function(a) {
  return this.get$Value(9, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthOrDefault = function(a) {
  return this.get$ValueOrDefault(9, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLength = function(a) {
  this.add$Value(9, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthArray = function() {
  return this.array$Values(9);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLength = function() {
  return this.has$Value(9);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthCount = function() {
  return this.count$Values(9);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLength = function() {
  this.clear$Field(9);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnly = function(a) {
  return this.get$Value(10, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnlyOrDefault = function(a) {
  return this.get$ValueOrDefault(10, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLengthLocalOnly = function(a) {
  this.add$Value(10, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyArray = function() {
  return this.array$Values(10);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLengthLocalOnly = function() {
  return this.has$Value(10);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyCount = function() {
  return this.count$Values(10);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLengthLocalOnly = function() {
  this.clear$Field(10);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumber = function() {
  return this.get$Value(6);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumberOrDefault = function() {
  return this.get$ValueOrDefault(6);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.setExampleNumber = function(a) {
  this.set$Value(6, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasExampleNumber = function() {
  return this.has$Value(6);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.exampleNumberCount = function() {
  return this.count$Values(6);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.clearExampleNumber = function() {
  this.clear$Field(6);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberMatcherData = function() {
  return this.get$Value(7);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberMatcherDataOrDefault = function() {
  return this.get$ValueOrDefault(7);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.setNationalNumberMatcherData = function(a) {
  this.set$Value(7, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasNationalNumberMatcherData = function() {
  return this.has$Value(7);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.nationalNumberMatcherDataCount = function() {
  return this.count$Values(7);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.clearNationalNumberMatcherData = function() {
  this.clear$Field(7);
};
i18n.phonenumbers.PhoneMetadata = function() {
  goog.proto2.Message.call(this);
};
goog.inherits(i18n.phonenumbers.PhoneMetadata, goog.proto2.Message);
i18n.phonenumbers.PhoneMetadata.descriptor_ = null;
i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDesc = function() {
  return this.get$Value(1);
};
i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDescOrDefault = function() {
  return this.get$ValueOrDefault(1);
};
i18n.phonenumbers.PhoneMetadata.prototype.setGeneralDesc = function(a) {
  this.set$Value(1, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasGeneralDesc = function() {
  return this.has$Value(1);
};
i18n.phonenumbers.PhoneMetadata.prototype.generalDescCount = function() {
  return this.count$Values(1);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearGeneralDesc = function() {
  this.clear$Field(1);
};
i18n.phonenumbers.PhoneMetadata.prototype.getFixedLine = function() {
  return this.get$Value(2);
};
i18n.phonenumbers.PhoneMetadata.prototype.getFixedLineOrDefault = function() {
  return this.get$ValueOrDefault(2);
};
i18n.phonenumbers.PhoneMetadata.prototype.setFixedLine = function(a) {
  this.set$Value(2, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasFixedLine = function() {
  return this.has$Value(2);
};
i18n.phonenumbers.PhoneMetadata.prototype.fixedLineCount = function() {
  return this.count$Values(2);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearFixedLine = function() {
  this.clear$Field(2);
};
i18n.phonenumbers.PhoneMetadata.prototype.getMobile = function() {
  return this.get$Value(3);
};
i18n.phonenumbers.PhoneMetadata.prototype.getMobileOrDefault = function() {
  return this.get$ValueOrDefault(3);
};
i18n.phonenumbers.PhoneMetadata.prototype.setMobile = function(a) {
  this.set$Value(3, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasMobile = function() {
  return this.has$Value(3);
};
i18n.phonenumbers.PhoneMetadata.prototype.mobileCount = function() {
  return this.count$Values(3);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearMobile = function() {
  this.clear$Field(3);
};
i18n.phonenumbers.PhoneMetadata.prototype.getTollFree = function() {
  return this.get$Value(4);
};
i18n.phonenumbers.PhoneMetadata.prototype.getTollFreeOrDefault = function() {
  return this.get$ValueOrDefault(4);
};
i18n.phonenumbers.PhoneMetadata.prototype.setTollFree = function(a) {
  this.set$Value(4, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasTollFree = function() {
  return this.has$Value(4);
};
i18n.phonenumbers.PhoneMetadata.prototype.tollFreeCount = function() {
  return this.count$Values(4);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearTollFree = function() {
  this.clear$Field(4);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRate = function() {
  return this.get$Value(5);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRateOrDefault = function() {
  return this.get$ValueOrDefault(5);
};
i18n.phonenumbers.PhoneMetadata.prototype.setPremiumRate = function(a) {
  this.set$Value(5, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasPremiumRate = function() {
  return this.has$Value(5);
};
i18n.phonenumbers.PhoneMetadata.prototype.premiumRateCount = function() {
  return this.count$Values(5);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearPremiumRate = function() {
  this.clear$Field(5);
};
i18n.phonenumbers.PhoneMetadata.prototype.getSharedCost = function() {
  return this.get$Value(6);
};
i18n.phonenumbers.PhoneMetadata.prototype.getSharedCostOrDefault = function() {
  return this.get$ValueOrDefault(6);
};
i18n.phonenumbers.PhoneMetadata.prototype.setSharedCost = function(a) {
  this.set$Value(6, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasSharedCost = function() {
  return this.has$Value(6);
};
i18n.phonenumbers.PhoneMetadata.prototype.sharedCostCount = function() {
  return this.count$Values(6);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearSharedCost = function() {
  this.clear$Field(6);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumber = function() {
  return this.get$Value(7);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumberOrDefault = function() {
  return this.get$ValueOrDefault(7);
};
i18n.phonenumbers.PhoneMetadata.prototype.setPersonalNumber = function(a) {
  this.set$Value(7, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasPersonalNumber = function() {
  return this.has$Value(7);
};
i18n.phonenumbers.PhoneMetadata.prototype.personalNumberCount = function() {
  return this.count$Values(7);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearPersonalNumber = function() {
  this.clear$Field(7);
};
i18n.phonenumbers.PhoneMetadata.prototype.getVoip = function() {
  return this.get$Value(8);
};
i18n.phonenumbers.PhoneMetadata.prototype.getVoipOrDefault = function() {
  return this.get$ValueOrDefault(8);
};
i18n.phonenumbers.PhoneMetadata.prototype.setVoip = function(a) {
  this.set$Value(8, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasVoip = function() {
  return this.has$Value(8);
};
i18n.phonenumbers.PhoneMetadata.prototype.voipCount = function() {
  return this.count$Values(8);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearVoip = function() {
  this.clear$Field(8);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPager = function() {
  return this.get$Value(21);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPagerOrDefault = function() {
  return this.get$ValueOrDefault(21);
};
i18n.phonenumbers.PhoneMetadata.prototype.setPager = function(a) {
  this.set$Value(21, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasPager = function() {
  return this.has$Value(21);
};
i18n.phonenumbers.PhoneMetadata.prototype.pagerCount = function() {
  return this.count$Values(21);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearPager = function() {
  this.clear$Field(21);
};
i18n.phonenumbers.PhoneMetadata.prototype.getUan = function() {
  return this.get$Value(25);
};
i18n.phonenumbers.PhoneMetadata.prototype.getUanOrDefault = function() {
  return this.get$ValueOrDefault(25);
};
i18n.phonenumbers.PhoneMetadata.prototype.setUan = function(a) {
  this.set$Value(25, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasUan = function() {
  return this.has$Value(25);
};
i18n.phonenumbers.PhoneMetadata.prototype.uanCount = function() {
  return this.count$Values(25);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearUan = function() {
  this.clear$Field(25);
};
i18n.phonenumbers.PhoneMetadata.prototype.getEmergency = function() {
  return this.get$Value(27);
};
i18n.phonenumbers.PhoneMetadata.prototype.getEmergencyOrDefault = function() {
  return this.get$ValueOrDefault(27);
};
i18n.phonenumbers.PhoneMetadata.prototype.setEmergency = function(a) {
  this.set$Value(27, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasEmergency = function() {
  return this.has$Value(27);
};
i18n.phonenumbers.PhoneMetadata.prototype.emergencyCount = function() {
  return this.count$Values(27);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearEmergency = function() {
  this.clear$Field(27);
};
i18n.phonenumbers.PhoneMetadata.prototype.getVoicemail = function() {
  return this.get$Value(28);
};
i18n.phonenumbers.PhoneMetadata.prototype.getVoicemailOrDefault = function() {
  return this.get$ValueOrDefault(28);
};
i18n.phonenumbers.PhoneMetadata.prototype.setVoicemail = function(a) {
  this.set$Value(28, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasVoicemail = function() {
  return this.has$Value(28);
};
i18n.phonenumbers.PhoneMetadata.prototype.voicemailCount = function() {
  return this.count$Values(28);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearVoicemail = function() {
  this.clear$Field(28);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDialling = function() {
  return this.get$Value(24);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDiallingOrDefault = function() {
  return this.get$ValueOrDefault(24);
};
i18n.phonenumbers.PhoneMetadata.prototype.setNoInternationalDialling = function(a) {
  this.set$Value(24, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasNoInternationalDialling = function() {
  return this.has$Value(24);
};
i18n.phonenumbers.PhoneMetadata.prototype.noInternationalDiallingCount = function() {
  return this.count$Values(24);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearNoInternationalDialling = function() {
  this.clear$Field(24);
};
i18n.phonenumbers.PhoneMetadata.prototype.getId = function() {
  return this.get$Value(9);
};
i18n.phonenumbers.PhoneMetadata.prototype.getIdOrDefault = function() {
  return this.get$ValueOrDefault(9);
};
i18n.phonenumbers.PhoneMetadata.prototype.setId = function(a) {
  this.set$Value(9, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasId = function() {
  return this.has$Value(9);
};
i18n.phonenumbers.PhoneMetadata.prototype.idCount = function() {
  return this.count$Values(9);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearId = function() {
  this.clear$Field(9);
};
i18n.phonenumbers.PhoneMetadata.prototype.getCountryCode = function() {
  return this.get$Value(10);
};
i18n.phonenumbers.PhoneMetadata.prototype.getCountryCodeOrDefault = function() {
  return this.get$ValueOrDefault(10);
};
i18n.phonenumbers.PhoneMetadata.prototype.setCountryCode = function(a) {
  this.set$Value(10, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasCountryCode = function() {
  return this.has$Value(10);
};
i18n.phonenumbers.PhoneMetadata.prototype.countryCodeCount = function() {
  return this.count$Values(10);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearCountryCode = function() {
  this.clear$Field(10);
};
i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefix = function() {
  return this.get$Value(11);
};
i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefixOrDefault = function() {
  return this.get$ValueOrDefault(11);
};
i18n.phonenumbers.PhoneMetadata.prototype.setInternationalPrefix = function(a) {
  this.set$Value(11, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasInternationalPrefix = function() {
  return this.has$Value(11);
};
i18n.phonenumbers.PhoneMetadata.prototype.internationalPrefixCount = function() {
  return this.count$Values(11);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearInternationalPrefix = function() {
  this.clear$Field(11);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefix = function() {
  return this.get$Value(17);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefixOrDefault = function() {
  return this.get$ValueOrDefault(17);
};
i18n.phonenumbers.PhoneMetadata.prototype.setPreferredInternationalPrefix = function(a) {
  this.set$Value(17, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredInternationalPrefix = function() {
  return this.has$Value(17);
};
i18n.phonenumbers.PhoneMetadata.prototype.preferredInternationalPrefixCount = function() {
  return this.count$Values(17);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredInternationalPrefix = function() {
  this.clear$Field(17);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefix = function() {
  return this.get$Value(12);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixOrDefault = function() {
  return this.get$ValueOrDefault(12);
};
i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefix = function(a) {
  this.set$Value(12, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefix = function() {
  return this.has$Value(12);
};
i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixCount = function() {
  return this.count$Values(12);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefix = function() {
  this.clear$Field(12);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefix = function() {
  return this.get$Value(13);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefixOrDefault = function() {
  return this.get$ValueOrDefault(13);
};
i18n.phonenumbers.PhoneMetadata.prototype.setPreferredExtnPrefix = function(a) {
  this.set$Value(13, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredExtnPrefix = function() {
  return this.has$Value(13);
};
i18n.phonenumbers.PhoneMetadata.prototype.preferredExtnPrefixCount = function() {
  return this.count$Values(13);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredExtnPrefix = function() {
  this.clear$Field(13);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsing = function() {
  return this.get$Value(15);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsingOrDefault = function() {
  return this.get$ValueOrDefault(15);
};
i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixForParsing = function(a) {
  this.set$Value(15, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixForParsing = function() {
  return this.has$Value(15);
};
i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixForParsingCount = function() {
  return this.count$Values(15);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixForParsing = function() {
  this.clear$Field(15);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRule = function() {
  return this.get$Value(16);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRuleOrDefault = function() {
  return this.get$ValueOrDefault(16);
};
i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixTransformRule = function(a) {
  this.set$Value(16, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixTransformRule = function() {
  return this.has$Value(16);
};
i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixTransformRuleCount = function() {
  return this.count$Values(16);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixTransformRule = function() {
  this.clear$Field(16);
};
i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePattern = function() {
  return this.get$Value(18);
};
i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePatternOrDefault = function() {
  return this.get$ValueOrDefault(18);
};
i18n.phonenumbers.PhoneMetadata.prototype.setSameMobileAndFixedLinePattern = function(a) {
  this.set$Value(18, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasSameMobileAndFixedLinePattern = function() {
  return this.has$Value(18);
};
i18n.phonenumbers.PhoneMetadata.prototype.sameMobileAndFixedLinePatternCount = function() {
  return this.count$Values(18);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearSameMobileAndFixedLinePattern = function() {
  this.clear$Field(18);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormat = function(a) {
  return this.get$Value(19, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormatOrDefault = function(a) {
  return this.get$ValueOrDefault(19, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.addNumberFormat = function(a) {
  this.add$Value(19, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.numberFormatArray = function() {
  return this.array$Values(19);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasNumberFormat = function() {
  return this.has$Value(19);
};
i18n.phonenumbers.PhoneMetadata.prototype.numberFormatCount = function() {
  return this.count$Values(19);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearNumberFormat = function() {
  this.clear$Field(19);
};
i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormat = function(a) {
  return this.get$Value(20, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormatOrDefault = function(a) {
  return this.get$ValueOrDefault(20, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.addIntlNumberFormat = function(a) {
  this.add$Value(20, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatArray = function() {
  return this.array$Values(20);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasIntlNumberFormat = function() {
  return this.has$Value(20);
};
i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatCount = function() {
  return this.count$Values(20);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearIntlNumberFormat = function() {
  this.clear$Field(20);
};
i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCode = function() {
  return this.get$Value(22);
};
i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCodeOrDefault = function() {
  return this.get$ValueOrDefault(22);
};
i18n.phonenumbers.PhoneMetadata.prototype.setMainCountryForCode = function(a) {
  this.set$Value(22, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasMainCountryForCode = function() {
  return this.has$Value(22);
};
i18n.phonenumbers.PhoneMetadata.prototype.mainCountryForCodeCount = function() {
  return this.count$Values(22);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearMainCountryForCode = function() {
  this.clear$Field(22);
};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigits = function() {
  return this.get$Value(23);
};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigitsOrDefault = function() {
  return this.get$ValueOrDefault(23);
};
i18n.phonenumbers.PhoneMetadata.prototype.setLeadingDigits = function(a) {
  this.set$Value(23, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingDigits = function() {
  return this.has$Value(23);
};
i18n.phonenumbers.PhoneMetadata.prototype.leadingDigitsCount = function() {
  return this.count$Values(23);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingDigits = function() {
  this.clear$Field(23);
};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingZeroPossible = function() {
  return this.get$Value(26);
};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingZeroPossibleOrDefault = function() {
  return this.get$ValueOrDefault(26);
};
i18n.phonenumbers.PhoneMetadata.prototype.setLeadingZeroPossible = function(a) {
  this.set$Value(26, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingZeroPossible = function() {
  return this.has$Value(26);
};
i18n.phonenumbers.PhoneMetadata.prototype.leadingZeroPossibleCount = function() {
  return this.count$Values(26);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingZeroPossible = function() {
  this.clear$Field(26);
};
i18n.phonenumbers.PhoneMetadataCollection = function() {
  goog.proto2.Message.call(this);
};
goog.inherits(i18n.phonenumbers.PhoneMetadataCollection, goog.proto2.Message);
i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = null;
i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadata = function(a) {
  return this.get$Value(1, a);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadataOrDefault = function(a) {
  return this.get$ValueOrDefault(1, a);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.addMetadata = function(a) {
  this.add$Value(1, a);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataArray = function() {
  return this.array$Values(1);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.hasMetadata = function() {
  return this.has$Value(1);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataCount = function() {
  return this.count$Values(1);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.clearMetadata = function() {
  this.clear$Field(1);
};
i18n.phonenumbers.NumberFormat.prototype.getDescriptor = function() {
  var a = i18n.phonenumbers.NumberFormat.descriptor_;
  a || (i18n.phonenumbers.NumberFormat.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.NumberFormat, {0:{name:"NumberFormat", fullName:"i18n.phonenumbers.NumberFormat"}, 1:{name:"pattern", required:!0, fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 2:{name:"format", required:!0, fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 3:{name:"leading_digits_pattern", repeated:!0, fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 4:{name:"national_prefix_formatting_rule", 
  fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 6:{name:"national_prefix_optional_when_formatting", fieldType:goog.proto2.Message.FieldType.BOOL, defaultValue:!1, type:Boolean}, 5:{name:"domestic_carrier_code_formatting_rule", fieldType:goog.proto2.Message.FieldType.STRING, type:String}}));
  return a;
};
i18n.phonenumbers.NumberFormat.getDescriptor = i18n.phonenumbers.NumberFormat.prototype.getDescriptor;
i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor = function() {
  var a = i18n.phonenumbers.PhoneNumberDesc.descriptor_;
  a || (i18n.phonenumbers.PhoneNumberDesc.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumberDesc, {0:{name:"PhoneNumberDesc", fullName:"i18n.phonenumbers.PhoneNumberDesc"}, 2:{name:"national_number_pattern", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 3:{name:"possible_number_pattern", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 9:{name:"possible_length", repeated:!0, fieldType:goog.proto2.Message.FieldType.INT32, type:Number}, 
  10:{name:"possible_length_local_only", repeated:!0, fieldType:goog.proto2.Message.FieldType.INT32, type:Number}, 6:{name:"example_number", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 7:{name:"national_number_matcher_data", fieldType:goog.proto2.Message.FieldType.BYTES, type:String}}));
  return a;
};
i18n.phonenumbers.PhoneNumberDesc.getDescriptor = i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor;
i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor = function() {
  var a = i18n.phonenumbers.PhoneMetadata.descriptor_;
  a || (i18n.phonenumbers.PhoneMetadata.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadata, {0:{name:"PhoneMetadata", fullName:"i18n.phonenumbers.PhoneMetadata"}, 1:{name:"general_desc", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 2:{name:"fixed_line", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 3:{name:"mobile", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 
  4:{name:"toll_free", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 5:{name:"premium_rate", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 6:{name:"shared_cost", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 7:{name:"personal_number", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 8:{name:"voip", fieldType:goog.proto2.Message.FieldType.MESSAGE, 
  type:i18n.phonenumbers.PhoneNumberDesc}, 21:{name:"pager", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 25:{name:"uan", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 27:{name:"emergency", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 28:{name:"voicemail", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 24:{name:"no_international_dialling", 
  fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 9:{name:"id", required:!0, fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 10:{name:"country_code", fieldType:goog.proto2.Message.FieldType.INT32, type:Number}, 11:{name:"international_prefix", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 17:{name:"preferred_international_prefix", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 12:{name:"national_prefix", fieldType:goog.proto2.Message.FieldType.STRING, 
  type:String}, 13:{name:"preferred_extn_prefix", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 15:{name:"national_prefix_for_parsing", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 16:{name:"national_prefix_transform_rule", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 18:{name:"same_mobile_and_fixed_line_pattern", fieldType:goog.proto2.Message.FieldType.BOOL, defaultValue:!1, type:Boolean}, 19:{name:"number_format", repeated:!0, fieldType:goog.proto2.Message.FieldType.MESSAGE, 
  type:i18n.phonenumbers.NumberFormat}, 20:{name:"intl_number_format", repeated:!0, fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.NumberFormat}, 22:{name:"main_country_for_code", fieldType:goog.proto2.Message.FieldType.BOOL, defaultValue:!1, type:Boolean}, 23:{name:"leading_digits", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 26:{name:"leading_zero_possible", fieldType:goog.proto2.Message.FieldType.BOOL, defaultValue:!1, type:Boolean}}));
  return a;
};
i18n.phonenumbers.PhoneMetadata.getDescriptor = i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor;
i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor = function() {
  var a = i18n.phonenumbers.PhoneMetadataCollection.descriptor_;
  a || (i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadataCollection, {0:{name:"PhoneMetadataCollection", fullName:"i18n.phonenumbers.PhoneMetadataCollection"}, 1:{name:"metadata", repeated:!0, fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneMetadata}}));
  return a;
};
i18n.phonenumbers.PhoneMetadataCollection.getDescriptor = i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor;
i18n.phonenumbers.PhoneNumber = function() {
  goog.proto2.Message.call(this);
};
goog.inherits(i18n.phonenumbers.PhoneNumber, goog.proto2.Message);
i18n.phonenumbers.PhoneNumber.prototype.getCountryCode = function() {
  return this.get$Value(1);
};
i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeOrDefault = function() {
  return this.get$ValueOrDefault(1);
};
i18n.phonenumbers.PhoneNumber.prototype.setCountryCode = function(a) {
  this.set$Value(1, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasCountryCode = function() {
  return this.has$Value(1);
};
i18n.phonenumbers.PhoneNumber.prototype.countryCodeCount = function() {
  return this.count$Values(1);
};
i18n.phonenumbers.PhoneNumber.prototype.clearCountryCode = function() {
  this.clear$Field(1);
};
i18n.phonenumbers.PhoneNumber.prototype.getNationalNumber = function() {
  return this.get$Value(2);
};
i18n.phonenumbers.PhoneNumber.prototype.getNationalNumberOrDefault = function() {
  return this.get$ValueOrDefault(2);
};
i18n.phonenumbers.PhoneNumber.prototype.setNationalNumber = function(a) {
  this.set$Value(2, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasNationalNumber = function() {
  return this.has$Value(2);
};
i18n.phonenumbers.PhoneNumber.prototype.nationalNumberCount = function() {
  return this.count$Values(2);
};
i18n.phonenumbers.PhoneNumber.prototype.clearNationalNumber = function() {
  this.clear$Field(2);
};
i18n.phonenumbers.PhoneNumber.prototype.getExtension = function() {
  return this.get$Value(3);
};
i18n.phonenumbers.PhoneNumber.prototype.getExtensionOrDefault = function() {
  return this.get$ValueOrDefault(3);
};
i18n.phonenumbers.PhoneNumber.prototype.setExtension = function(a) {
  this.set$Value(3, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasExtension = function() {
  return this.has$Value(3);
};
i18n.phonenumbers.PhoneNumber.prototype.extensionCount = function() {
  return this.count$Values(3);
};
i18n.phonenumbers.PhoneNumber.prototype.clearExtension = function() {
  this.clear$Field(3);
};
i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZero = function() {
  return this.get$Value(4);
};
i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZeroOrDefault = function() {
  return this.get$ValueOrDefault(4);
};
i18n.phonenumbers.PhoneNumber.prototype.setItalianLeadingZero = function(a) {
  this.set$Value(4, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasItalianLeadingZero = function() {
  return this.has$Value(4);
};
i18n.phonenumbers.PhoneNumber.prototype.italianLeadingZeroCount = function() {
  return this.count$Values(4);
};
i18n.phonenumbers.PhoneNumber.prototype.clearItalianLeadingZero = function() {
  this.clear$Field(4);
};
i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZeros = function() {
  return this.get$Value(8);
};
i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZerosOrDefault = function() {
  return this.get$ValueOrDefault(8);
};
i18n.phonenumbers.PhoneNumber.prototype.setNumberOfLeadingZeros = function(a) {
  this.set$Value(8, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasNumberOfLeadingZeros = function() {
  return this.has$Value(8);
};
i18n.phonenumbers.PhoneNumber.prototype.numberOfLeadingZerosCount = function() {
  return this.count$Values(8);
};
i18n.phonenumbers.PhoneNumber.prototype.clearNumberOfLeadingZeros = function() {
  this.clear$Field(8);
};
i18n.phonenumbers.PhoneNumber.prototype.getRawInput = function() {
  return this.get$Value(5);
};
i18n.phonenumbers.PhoneNumber.prototype.getRawInputOrDefault = function() {
  return this.get$ValueOrDefault(5);
};
i18n.phonenumbers.PhoneNumber.prototype.setRawInput = function(a) {
  this.set$Value(5, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasRawInput = function() {
  return this.has$Value(5);
};
i18n.phonenumbers.PhoneNumber.prototype.rawInputCount = function() {
  return this.count$Values(5);
};
i18n.phonenumbers.PhoneNumber.prototype.clearRawInput = function() {
  this.clear$Field(5);
};
i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSource = function() {
  return this.get$Value(6);
};
i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSourceOrDefault = function() {
  return this.get$ValueOrDefault(6);
};
i18n.phonenumbers.PhoneNumber.prototype.setCountryCodeSource = function(a) {
  this.set$Value(6, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasCountryCodeSource = function() {
  return this.has$Value(6);
};
i18n.phonenumbers.PhoneNumber.prototype.countryCodeSourceCount = function() {
  return this.count$Values(6);
};
i18n.phonenumbers.PhoneNumber.prototype.clearCountryCodeSource = function() {
  this.clear$Field(6);
};
i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCode = function() {
  return this.get$Value(7);
};
i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCodeOrDefault = function() {
  return this.get$ValueOrDefault(7);
};
i18n.phonenumbers.PhoneNumber.prototype.setPreferredDomesticCarrierCode = function(a) {
  this.set$Value(7, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasPreferredDomesticCarrierCode = function() {
  return this.has$Value(7);
};
i18n.phonenumbers.PhoneNumber.prototype.preferredDomesticCarrierCodeCount = function() {
  return this.count$Values(7);
};
i18n.phonenumbers.PhoneNumber.prototype.clearPreferredDomesticCarrierCode = function() {
  this.clear$Field(7);
};
i18n.phonenumbers.PhoneNumber.CountryCodeSource = {FROM_NUMBER_WITH_PLUS_SIGN:1, FROM_NUMBER_WITH_IDD:5, FROM_NUMBER_WITHOUT_PLUS_SIGN:10, FROM_DEFAULT_COUNTRY:20};
i18n.phonenumbers.PhoneNumber.prototype.getDescriptor = function() {
  i18n.phonenumbers.PhoneNumber.descriptor_ || (i18n.phonenumbers.PhoneNumber.descriptor_ = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumber, {0:{name:"PhoneNumber", fullName:"i18n.phonenumbers.PhoneNumber"}, 1:{name:"country_code", required:!0, fieldType:goog.proto2.Message.FieldType.INT32, type:Number}, 2:{name:"national_number", required:!0, fieldType:goog.proto2.Message.FieldType.UINT64, type:Number}, 3:{name:"extension", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 
  4:{name:"italian_leading_zero", fieldType:goog.proto2.Message.FieldType.BOOL, type:Boolean}, 8:{name:"number_of_leading_zeros", fieldType:goog.proto2.Message.FieldType.INT32, defaultValue:1, type:Number}, 5:{name:"raw_input", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 6:{name:"country_code_source", fieldType:goog.proto2.Message.FieldType.ENUM, defaultValue:i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN, type:i18n.phonenumbers.PhoneNumber.CountryCodeSource}, 
  7:{name:"preferred_domestic_carrier_code", fieldType:goog.proto2.Message.FieldType.STRING, type:String}}));
  return i18n.phonenumbers.PhoneNumber.descriptor_;
};
i18n.phonenumbers.PhoneNumber.ctor = i18n.phonenumbers.PhoneNumber;
i18n.phonenumbers.PhoneNumber.ctor.getDescriptor = i18n.phonenumbers.PhoneNumber.prototype.getDescriptor;
/*

 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.metadata = {};
i18n.phonenumbers.metadata.countryCodeToRegionCodeMap = {1:"US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "), 7:["RU", "KZ"], 20:["EG"], 27:["ZA"], 30:["GR"], 31:["NL"], 32:["BE"], 33:["FR"], 34:["ES"], 36:["HU"], 39:["IT", "VA"], 40:["RO"], 41:["CH"], 43:["AT"], 44:["GB", "GG", "IM", "JE"], 45:["DK"], 46:["SE"], 47:["NO", "SJ"], 48:["PL"], 49:["DE"], 51:["PE"], 52:["MX"], 53:["CU"], 54:["AR"], 55:["BR"], 56:["CL"], 57:["CO"], 58:["VE"], 60:["MY"], 61:["AU", 
"CC", "CX"], 62:["ID"], 63:["PH"], 64:["NZ"], 65:["SG"], 66:["TH"], 81:["JP"], 82:["KR"], 84:["VN"], 86:["CN"], 90:["TR"], 91:["IN"], 92:["PK"], 93:["AF"], 94:["LK"], 95:["MM"], 98:["IR"], 211:["SS"], 212:["MA", "EH"], 213:["DZ"], 216:["TN"], 218:["LY"], 220:["GM"], 221:["SN"], 222:["MR"], 223:["ML"], 224:["GN"], 225:["CI"], 226:["BF"], 227:["NE"], 228:["TG"], 229:["BJ"], 230:["MU"], 231:["LR"], 232:["SL"], 233:["GH"], 234:["NG"], 235:["TD"], 236:["CF"], 237:["CM"], 238:["CV"], 239:["ST"], 240:["GQ"], 
241:["GA"], 242:["CG"], 243:["CD"], 244:["AO"], 245:["GW"], 246:["IO"], 247:["AC"], 248:["SC"], 249:["SD"], 250:["RW"], 251:["ET"], 252:["SO"], 253:["DJ"], 254:["KE"], 255:["TZ"], 256:["UG"], 257:["BI"], 258:["MZ"], 260:["ZM"], 261:["MG"], 262:["RE", "YT"], 263:["ZW"], 264:["NA"], 265:["MW"], 266:["LS"], 267:["BW"], 268:["SZ"], 269:["KM"], 290:["SH", "TA"], 291:["ER"], 297:["AW"], 298:["FO"], 299:["GL"], 350:["GI"], 351:["PT"], 352:["LU"], 353:["IE"], 354:["IS"], 355:["AL"], 356:["MT"], 357:["CY"], 
358:["FI", "AX"], 359:["BG"], 370:["LT"], 371:["LV"], 372:["EE"], 373:["MD"], 374:["AM"], 375:["BY"], 376:["AD"], 377:["MC"], 378:["SM"], 380:["UA"], 381:["RS"], 382:["ME"], 385:["HR"], 386:["SI"], 387:["BA"], 389:["MK"], 420:["CZ"], 421:["SK"], 423:["LI"], 500:["FK"], 501:["BZ"], 502:["GT"], 503:["SV"], 504:["HN"], 505:["NI"], 506:["CR"], 507:["PA"], 508:["PM"], 509:["HT"], 590:["GP", "BL", "MF"], 591:["BO"], 592:["GY"], 593:["EC"], 594:["GF"], 595:["PY"], 596:["MQ"], 597:["SR"], 598:["UY"], 599:["CW", 
"BQ"], 670:["TL"], 672:["NF"], 673:["BN"], 674:["NR"], 675:["PG"], 676:["TO"], 677:["SB"], 678:["VU"], 679:["FJ"], 680:["PW"], 681:["WF"], 682:["CK"], 683:["NU"], 685:["WS"], 686:["KI"], 687:["NC"], 688:["TV"], 689:["PF"], 690:["TK"], 691:["FM"], 692:["MH"], 800:["001"], 808:["001"], 850:["KP"], 852:["HK"], 853:["MO"], 855:["KH"], 856:["LA"], 870:["001"], 878:["001"], 880:["BD"], 881:["001"], 882:["001"], 883:["001"], 886:["TW"], 888:["001"], 960:["MV"], 961:["LB"], 962:["JO"], 963:["SY"], 964:["IQ"], 
965:["KW"], 966:["SA"], 967:["YE"], 968:["OM"], 970:["PS"], 971:["AE"], 972:["IL"], 973:["BH"], 974:["QA"], 975:["BT"], 976:["MN"], 977:["NP"], 979:["001"], 992:["TJ"], 993:["TM"], 994:["AZ"], 995:["GE"], 996:["KG"], 998:["UZ"]};
i18n.phonenumbers.metadata.countryToMetadata = {AC:[, [, , "[46]\\d{4}|[01589]\\d{5}", , , , , , , [5, 6]], [, , "6[2-467]\\d{3}", , , , "62889", , , [5]], [, , "4\\d{4}", , , , "40123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AC", 247, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[01589]\\d{5}", , , , "542011", , , [6]], , , [, , , , , , , , , [-1]]], AD:[, 
[, , "[16]\\d{5,8}|[37-9]\\d{5}", , , , , , , [6, 8, 9]], [, , "[78]\\d{5}", , , , "712345", , , [6]], [, , "(?:3\\d|6(?:[0-8]|90\\d{2}))\\d{4}", , , , "312345", , , [6, 9]], [, , "180[02]\\d{4}", , , , "18001234", , , [8]], [, , "[19]\\d{5}", , , , "912345", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AD", 376, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[137-9]|6[0-8]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["180", "180[02]"]], [, "(\\d{3})(\\d{3})(\\d{3})", 
"$1 $2 $3", ["690"]]], , [, , , , , , , , , [-1]], , , [, , "1800\\d{4}", , , , "18000000", , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AE:[, [, , "[2-79]\\d{7,8}|800\\d{2,9}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]], [, , "[2-4679][2-8]\\d{6}", , , , "22345678", , , [8], [7]], [, , "5[024-68]\\d{7}", , , , "501234567", , , [9]], [, , "400\\d{6}|800\\d{2,9}", , , , "800123456"], [, , "900[02]\\d{5}", , , , "900234567", , , [9]], [, , "700[05]\\d{5}", , , , "700012345", , , 
[9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AE", 971, "00", "0", , , "0", , , , [[, "([2-4679])(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-4679][2-8]"], "0$1"], [, "(5\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "([479]00)(\\d)(\\d{5})", "$1 $2 $3", ["[479]0"], "$1"], [, "([68]00)(\\d{2,9})", "$1 $2", ["60|8"], "$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "600[25]\\d{5}", , , , "600212345", , , [9]], , , [, , , , , , , , , [-1]]], AF:[, [, , "[2-7]\\d{8}", 
, , , , , , [9], [7]], [, , "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}", , , , "234567890", , , , [7]], [, , "7(?:[014-9]\\d|2[89]|30)\\d{6}", , , , "701234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AF", 93, "00", "0", , , "0", , , , [[, "([2-7]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , 
[-1]]], AG:[, [, , "[2589]\\d{9}", , , , , , , [10], [7]], [, , "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}", , , , "2684601234", , , , [7]], [, , "268(?:464|7(?:2\\d|3[246]|64|7[0-689]|8[02-68]))\\d{4}", , , , "2684641234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "26848[01]\\d{4}", , , , "2684801234", , , , [7]], "AG", 1, "011", 
"1", , , "1", , , , , , [, , "26840[69]\\d{4}", , , , "2684061234", , , , [7]], , "268", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AI:[, [, , "[2589]\\d{9}", , , , , , , [10], [7]], [, , "2644(?:6[12]|9[78])\\d{4}", , , , "2644612345", , , , [7]], [, , "264(?:235|476|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}", , , , "2642351234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , 
, , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AI", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "264", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AL:[, [, , "[2-57]\\d{7}|6\\d{8}|8\\d{5,7}|9\\d{5}", , , , , , , [6, 7, 8, 9], [5]], [, , "(?:2(?:1(?:0[2-9]|[1-9]\\d)|[247]\\d{2}|[35][2-9]\\d|[68](?:0[2-9]|[1-9]\\d)|9(?:[089][2-9]|[1-7]\\d))|3(?:1(?:[04-9][2-9]|[1-3]\\d)|[2-6]\\d{2}|[79](?:[09][2-9]|[1-8]\\d)|8(?:0[2-9]|[1-9]\\d))|4\\d{3}|5(?:1(?:[05-9][2-9]|[1-4]\\d)|[2-578]\\d{2}|6(?:[06-9][2-9]|[1-5]\\d)|9(?:[089][2-9]|[1-7]\\d))|8(?:[19](?:[06-9][2-9]|[1-5]\\d)|[2-6]\\d{2}|[78](?:[089][2-9]|[1-7]\\d)))\\d{4}", 
, , , "22345678", , , [8], [5, 6, 7]], [, , "6(?:[689][2-9]|7[2-6])\\d{6}", , , , "662123456", , , [9]], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , "900[1-9]\\d{2}", , , , "900123", , , [6]], [, , "808[1-9]\\d{2}", , , , "808123", , , [6]], [, , "700[2-9]\\d{4}", , , , "70021234", , , [8]], [, , , , , , , , , [-1]], "AL", 355, "00", "0", , , "0", , , , [[, "(4)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[0-6]"], "0$1"], [, "(6\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", 
"$1 $2 $3", ["[2358][2-5]|4[7-9]"], "0$1"], [, "(\\d{3})(\\d{3,5})", "$1 $2", ["[235][16-9]|8[016-9]|[79]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AM:[, [, , "[1-9]\\d{7}", , , , , , , [8], [5, 6]], [, , "(?:1[0-2]\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2|47\\d)\\d{5}", , , , "10123456", , , , [5, 6]], [, , "(?:4[1349]|55|77|9[1-9])\\d{6}", , , , "77123456"], [, , "800\\d{5}", , , , "80012345"], 
[, , "90[016]\\d{5}", , , , "90012345"], [, , "80[1-4]\\d{5}", , , , "80112345"], [, , , , , , , , , [-1]], [, , "60(?:2[078]|[3-7]\\d|8[0-5])\\d{4}", , , , "60271234"], "AM", 374, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["4[1349]|[5-7]|9[1-9]"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[23]"], "(0$1)"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8|90"], "0 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AO:[, [, , "[29]\\d{8}", , , , , , , [9]], [, , "2\\d(?:[26-9]\\d|\\d[26-9])\\d{5}", , , , "222123456"], [, , "9[1-49]\\d{7}", , , , "923123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AO", 244, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , 
, , , , , , , [-1]]], AR:[, [, , "11\\d{8}|[2368]\\d{9}|9\\d{10}", , , , , , , [10, 11], [6, 7, 8]], [, , "11\\d{8}|(?:2(?:2(?:[013]\\d|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[067]\\d)|4(?:7[3-8]|9\\d)|6(?:[01346]\\d|2[24-6]|5[15-8])|80\\d|9(?:[0124789]\\d|3[1-6]|5[234]|6[2-46]))|3(?:3(?:2[79]|6\\d|8[2578])|4(?:[78]\\d|0[0124-9]|[1-35]\\d|4[24-7]|6[02-9]|9[123678])|5(?:[138]\\d|2[1245]|4[1-9]|6[2-4]|7[1-6])|6[24]\\d|7(?:[0469]\\d|1[1568]|2[013-9]|3[145]|5[14-8]|7[2-57]|8[0-24-9])|8(?:[013578]\\d|2[15-7]|4[13-6]|6[1-357-9]|9[124]))|670\\d)\\d{6}", 
, , , "1123456789", , , [10], [6, 7, 8]], [, , "675\\d{7}|9(?:11[2-9]\\d{7}|(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[12358]|5[138]|6[24]|7[069]|8[013578]))[2-9]\\d{6}|\\d{4}[2-9]\\d{5})", , , , "91123456789", , , , [6, 7, 8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "60[04579]\\d{7}", , , , "6001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AR", 54, "00", "0", , , "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))?15)?", 
"9$1", , , [[, "([68]\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d{2})(\\d{4})", "$1-$2", ["[2-9]"], "$1"], [, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"], "$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["[2-9]"], "$1"], [, "(9)(11)(\\d{4})(\\d{4})", "$2 15-$3-$4", ["911"], "0$1"], [, "(9)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9(?:2[234689]|3[3-8])", "9(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578]))", "9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[456]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))", 
"9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1239])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"], "0$1"], [, "(9)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9[23]"], "0$1"], [, "(11)(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578])", "2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[456]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))", 
"2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1239])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"], "0$1", , 1], [, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1], [, "(\\d{3})", "$1", ["1[012]|911"], "$1"]], [[, "([68]\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(9)(11)(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["911"]], [, "(9)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3-$4", ["9(?:2[234689]|3[3-8])", 
"9(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578]))", "9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[456]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))", "9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1239])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"]], [, 
"(9)(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3-$4", ["9[23]"]], [, "(11)(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578])", "2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[456]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))", "2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1239])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"], 
"0$1", , 1], [, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "810\\d{7}", , , , "8101234567", , , [10]], [, , "810\\d{7}", , , , "8101234567", , , [10]], , , [, , , , , , , , , [-1]]], AS:[, [, , "[5689]\\d{9}", , , , , , , [10], [7]], [, , "6846(?:22|33|44|55|77|88|9[19])\\d{4}", , , , "6846221234", , , , [7]], [, , "684(?:2(?:5[2468]|72)|7(?:3[13]|70))\\d{4}", , , , "6847331234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , 
"8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AS", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "684", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AT:[, [, , "[1-9]\\d{3,12}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [3]], [, , "1\\d{3,12}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-8]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|63|7[1368]|8[2457])|5(?:12|2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[1-35-8]|5[468]|62)|7(?:2[1-8]|3[25]|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{3,10}", 
, , , "1234567890", , , , [3]], [, , "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", , , , "664123456", , , [7, 8, 9, 10, 11, 12, 13]], [, , "800\\d{6,10}", , , , "800123456", , , [9, 10, 11, 12, 13]], [, , "9(?:0[01]|3[019])\\d{6,10}", , , , "900123456", , , [9, 10, 11, 12, 13]], [, , "8(?:10\\d|2(?:[01]\\d|8\\d?))\\d{5,9}", , , , "810123456", , , [8, 9, 10, 11, 12, 13]], [, , , , , , , , , [-1]], [, , "780\\d{6,10}", , , , "780123456", , , [9, 10, 11, 12, 13]], "AT", 43, "00", "0", , , "0", , , , 
[[, "(116\\d{3})", "$1", ["116"], "$1"], [, "(1)(\\d{3,12})", "$1 $2", ["1"], "0$1"], [, "(5\\d)(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], [, "(5\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5[079]"], "0$1"], [, "(5\\d)(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5[079]"], "0$1"], [, "(\\d{3})(\\d{3,10})", "$1 $2", ["316|46|51|732|6(?:5[0-3579]|[6-9])|7(?:[28]0)|[89]"], "0$1"], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["2|3(?:1[1-578]|[3-8])|4[2378]|5[2-6]|6(?:[12]|4[1-9]|5[468])|7(?:2[1-8]|35|4[1-8]|[5-79])"], "0$1"]], 
, [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "5(?:(?:0[1-9]|17)\\d{2,10}|[79]\\d{3,11})|720\\d{6,10}", , , , "50123", , , [5, 6, 7, 8, 9, 10, 11, 12, 13]], , , [, , , , , , , , , [-1]]], AU:[, [, , "1\\d{4,9}|[2-578]\\d{8}", , , , , , , [5, 6, 7, 8, 9, 10]], [, , "[237]\\d{8}|8(?:[6-8]\\d{3}|9(?:[02-9]\\d{2}|1(?:[0-57-9]\\d|6[0135-9])))\\d{4}", , , , "212345678", , , [9], [8]], [, , "14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[47-9]|5[0-25-9]|6[6-9]|7[02-9]|8[147-9]|9[017-9])\\d{6}", , , 
, "412345678", , , [9]], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "19(?:0[0126]\\d|[679])\\d{5}", , , , "1900123456", , , [8, 10]], [, , "13(?:00\\d{3}|45[0-4]|\\d)\\d{3}", , , , "1300123456", , , [6, 8, 10]], [, , "500\\d{6}", , , , "500123456", , , [9]], [, , "550\\d{6}", , , , "550123456", , , [9]], "AU", 61, "(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]", "0", , , "0", , "0011", , [[, "([2378])(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", 
"$1 $2 $3", ["[45]|14"], "0$1"], [, "(16)(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(16)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(1[389]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[38]0|90)", "1(?:[38]00|90)"], "$1"], [, "(180)(2\\d{3})", "$1 $2", ["180", "1802"], "$1"], [, "(19\\d)(\\d{3})", "$1 $2", ["19[13]"], "$1"], [, "(19\\d{2})(\\d{4})", "$1 $2", ["19[679]"], "$1"], [, "(13)(\\d{2})(\\d{2})", "$1 $2 $3", ["13[1-9]"], "$1"]], , [, , "16\\d{3,7}", , , , "1612345", , , [5, 6, 7, 8, 
9]], 1, , [, , "1(?:3(?:00\\d{3}|45[0-4]|\\d)\\d{3}|80(?:0\\d{6}|2\\d{3}))", , , , "1300123456", , , [6, 7, 8, 10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AW:[, [, , "[25-9]\\d{6}", , , , , , , [7]], [, , "5(?:2\\d|8[1-9])\\d{4}", , , , "5212345"], [, , "(?:5(?:6\\d|9[2-478])|6(?:[039]0|22|4[01]|6[0-2])|7[34]\\d|9(?:6[45]|9[4-8]))\\d{4}", , , , "5601234"], [, , "800\\d{4}", , , , "8001234"], [, , "900\\d{4}", , , , "9001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
[, , "28\\d{5}|501\\d{4}", , , , "5011234"], "AW", 297, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AX:[, [, , "[15]\\d{6,9}|2\\d{4,9}|3\\d{5,9}|4\\d{7,10}|[67]\\d{7,9}|8\\d{7,8}", , , , , , , [5, 6, 7, 8, 9, 10, 11]], [, , "18[1-8]\\d{4,6}", , , , "181234567", , , [7, 8, 9]], [, , "4(?:[0-8]\\d{6,8}|9\\d{9})|50\\d{6,8}", , , , "412345678", , , [8, 9, 10, 11]], [, , "800\\d{5,6}", 
, , , "800123456", , , [8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AX", 358, "00|99(?:[02469]|5(?:11|33|5[59]|88|9[09]))", "0", , , "0", , "00", , , , [, , , , , , , , , [-1]], , , [, , "100\\d{4,6}|20(?:0\\d{4,6}|2[023]\\d{4,5}|9[89]\\d{1,6})|300\\d{3,7}|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{5,6})", , , , "1001234", , , [5, 6, 7, 8, 9, 10]], [, , "10(?:0\\d{4,6}|[1-9]\\d{5,7})|2(?:0(?:0\\d{4,6}|[13-8]\\d{5,7}|2(?:[023]\\d{4,5}|[14-9]\\d{4,6})|9(?:[0-7]\\d{4,6}|[89]\\d{1,6}))|9\\d{6,8})|3(?:0(?:0\\d{3,7}|[1-57-9]\\d{5,7}|6(?:\\d{3}|\\d{5,7}))|93\\d{5,7})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{5,6})", 
, , , "10112345", , , [5, 6, 7, 8, 9, 10]], , , [, , , , , , , , , [-1]]], AZ:[, [, , "[1-9]\\d{8}", , , , , , , [9], [7]], [, , "(?:1[28]\\d{3}|2(?:02|1[24]|2[2-4]|33|[45]2|6[23])\\d{2}|365(?:[0-46-9]\\d|5[0-35-9]))\\d{4}", , , , "123123456", , , , [7]], [, , "(?:36554|(?:4[04]|5[015]|60|7[07])\\d{3})\\d{4}", , , , "401234567"], [, , "88\\d{7}", , , , "881234567"], [, , "900200\\d{3}", , , , "900200123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AZ", 994, "00", 
"0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["(?:1[28]|2(?:[45]2|[0-36])|365)"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[4-8]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BA:[, [, , "[3-9]\\d{7,8}", , , , , , , [8, 9], [6]], [, , "(?:[35]\\d|49)\\d{6}", , , , "30123456", , , [8], [6]], [, , 
"6(?:0(?:3\\d|40)|[1-356]\\d|44[0-6]|71[137])\\d{5}", , , , "61123456"], [, , "8[08]\\d{6}", , , , "80123456", , , [8]], [, , "9[0246]\\d{6}", , , , "90123456", , , [8]], [, , "8[12]\\d{6}", , , , "82123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BA", 387, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-356]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6[047]"], 
"0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "70[23]\\d{5}", , , , "70223456", , , [8]], , , [, , , , , , , , , [-1]]], BB:[, [, , "[2589]\\d{9}", , , , , , , [10], [7]], [, , "246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7(?:37|57)|9(?:1[89]|63))\\d{4}", , , , "2464123456", , , , [7]], [, , "246(?:2(?:[356]\\d|4[0-57-9]|8[0-79])|45\\d|8(?:[2-5]\\d|83))\\d{4}", , , , "2462501234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", 
, , , "8002123456"], [, , "900\\d{7}|246976\\d{4}", , , , "9002123456", , , , [7]], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "24631\\d{5}", , , , "2463101234", , , , [7]], "BB", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "246", [, , , , , , , , , [-1]], [, , "246(?:292|367|4(?:1[7-9]|3[01]|44|67)|736)\\d{4}", , , , "2464301234", , , , [7]], , , [, , , , , , , , , [-1]]], BD:[, [, , "[2-79]\\d{5,9}|1\\d{9}|8[0-7]\\d{4,8}", 
, , , , , , [6, 7, 8, 9, 10]], [, , "2(?:[45]\\d{3}|7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|[139][1-6]|2[0157-9]|41|6[1-35]|7[1-5]|8[1-8]|90)|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0167]|7[15]|8[0146-9]))\\d{4}|3(?:12?[5-7]\\d{2}|0(?:2(?:[025-79]\\d|[348]\\d{1,2})|3(?:[2-4]\\d|[56]\\d?))|2(?:1\\d{2}|2(?:[12]\\d|[35]\\d{1,2}|4\\d?))|3(?:1\\d{2}|2(?:[2356]\\d|4\\d{1,2}))|4(?:1\\d{2}|2(?:2\\d{1,2}|[47]|5\\d{2}))|5(?:1\\d{2}|29)|[67]1\\d{2}|8(?:1\\d{2}|2(?:2\\d{2}|3|4\\d)))\\d{3}|4(?:0(?:2(?:[09]\\d|7)|33\\d{2})|1\\d{3}|2(?:1\\d{2}|2(?:[25]\\d?|[348]\\d|[67]\\d{1,2}))|3(?:1\\d{2}(?:\\d{2})?|2(?:[045]\\d|[236-9]\\d{1,2})|32\\d{2})|4(?:[18]\\d{2}|2(?:[2-46]\\d{2}|3)|5[25]\\d{2})|5(?:1\\d{2}|2(?:3\\d|5))|6(?:[18]\\d{2}|2(?:3(?:\\d{2})?|[46]\\d{1,2}|5\\d{2}|7\\d)|5(?:3\\d?|4\\d|[57]\\d{1,2}|6\\d{2}|8))|71\\d{2}|8(?:[18]\\d{2}|23\\d{2}|54\\d{2})|9(?:[18]\\d{2}|2[2-5]\\d{2}|53\\d{1,2}))\\d{3}|5(?:02[03489]\\d{2}|1\\d{2}|2(?:1\\d{2}|2(?:2(?:\\d{2})?|[457]\\d{2}))|3(?:1\\d{2}|2(?:[37](?:\\d{2})?|[569]\\d{2}))|4(?:1\\d{2}|2[46]\\d{2})|5(?:1\\d{2}|26\\d{1,2})|6(?:[18]\\d{2}|2|53\\d{2})|7(?:1|24)\\d{2}|8(?:1|26)\\d{2}|91\\d{2})\\d{3}|6(?:0(?:1\\d{2}|2(?:3\\d{2}|4\\d{1,2}))|2(?:2[2-5]\\d{2}|5(?:[3-5]\\d{2}|7)|8\\d{2})|3(?:1|2[3478])\\d{2}|4(?:1|2[34])\\d{2}|5(?:1|2[47])\\d{2}|6(?:[18]\\d{2}|6(?:2(?:2\\d|[34]\\d{2})|5(?:[24]\\d{2}|3\\d|5\\d{1,2})))|72[2-5]\\d{2}|8(?:1\\d{2}|2[2-5]\\d{2})|9(?:1\\d{2}|2[2-6]\\d{2}))\\d{3}|7(?:(?:02|[3-589]1|6[12]|72[24])\\d{2}|21\\d{3}|32)\\d{3}|8(?:(?:4[12]|[5-7]2|1\\d?)|(?:0|3[12]|[5-7]1|217)\\d)\\d{4}|9(?:[35]1|(?:[024]2|81)\\d|(?:1|[24]1)\\d{2})\\d{3}", 
, , , "27111234", , , [6, 7, 8, 9]], [, , "(?:1[13-9]\\d|(?:3[78]|44)[02-9]|6(?:44|6[02-9]))\\d{7}", , , , "1812345678", , , [10]], [, , "80[03]\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "96(?:0[49]|1[0-4]|6[69])\\d{6}", , , , "9604123456", , , [10]], "BD", 880, "00", "0", , , "0", , , , [[, "(2)(\\d{7,8})", "$1-$2", ["2"], "0$1"], [, "(\\d{2})(\\d{4,6})", "$1-$2", ["[3-79]1"], "0$1"], [, "(\\d{4})(\\d{3,6})", "$1-$2", 
["1|3(?:0|[2-58]2)|4(?:0|[25]2|3[23]|[4689][25])|5(?:[02-578]2|6[25])|6(?:[0347-9]2|[26][25])|7[02-9]2|8(?:[023][23]|[4-7]2)|9(?:[02][23]|[458]2|6[016])"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1-$2", ["[3-79][2-9]|8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BE:[, [, , "[1-9]\\d{7,8}", , , , , , , [8, 9]], [, , "(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}|80[2-8]\\d{5}", , , , "12345678", , 
, [8]], [, , "4(?:6[0135-8]|[79]\\d|8[3-9])\\d{6}", , , , "470123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "(?:70[2-467]|90[0-79])\\d{5}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BE", 32, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4[6-9]"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[23]|4[23]|9[2-4]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4", ["[156]|7[018]|8(?:0[1-9]|[1-79])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "78\\d{6}", , , , "78123456", , , [8]], , , [, , , , , , , , , [-1]]], BF:[, [, , "[25-7]\\d{7}", , , , , , , [8]], [, , "2(?:0(?:49|5[23]|6[56]|9[016-9])|4(?:4[569]|5[4-6]|6[56]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}", , , , "20491234"], [, , "(?:5[156]\\d|[67]\\d{2})\\d{5}", , , , "70123456"], [, , , , , , , 
, , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BF", 226, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BG:[, [, , "[23567]\\d{5,7}|[489]\\d{6,8}", , , , , , , [6, 7, 8, 9], [4, 5]], [, , "2\\d{5,7}|(?:[36]\\d|5[1-9]|8[1-6]|9[1-7])\\d{5,6}|(?:4(?:[124-7]\\d|3[1-6])|7(?:0[1-9]|[1-9]\\d))\\d{4,5}", 
, , , "2123456", , , [6, 7, 8], [4, 5]], [, , "(?:8[7-9]\\d|9(?:8\\d|99))\\d{6}|4(?:3[0789]|8\\d)\\d{5}", , , , "48123456", , , [8, 9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90\\d{6}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , "700\\d{5}", , , , "70012345", , , [8]], [, , , , , , , , , [-1]], "BG", 359, "00", "0", , , "0", , , , [[, "(2)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [, "(2)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{4})", 
"$1 $2", ["43[124-7]|70[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[124-7]|70[1-9]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[78]00"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["999"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["48|8[7-9]|9[08]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , 
, , , , , , [-1]]], BH:[, [, , "[136-9]\\d{7}", , , , , , , [8]], [, , "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9])|9[69][69])|7(?:1(?:11|78)|7\\d{2}))\\d{4}", , , , "17001234"], [, , "(?:3(?:[1-4679]\\d|5[013-69]|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:[69]\\d|3[03-9]|7[0-6])))\\d{4}", , , , "36001234"], [, , "80\\d{6}", , , , "80123456"], [, , "(?:87|9[014578])\\d{6}", , , , "90123456"], [, , "84\\d{6}", , , , "84123456"], [, , , , , , , , , [-1]], [, , , , , , , , 
, [-1]], "BH", 973, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BI:[, [, , "[267]\\d{7}", , , , , , , [8]], [, , "22\\d{6}", , , , "22201234"], [, , "(?:29|6[189]|7[124-9])\\d{6}", , , , "79561234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BI", 257, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BJ:[, [, , "[2689]\\d{7}|7\\d{3}", , , , , , , [4, 8]], [, , "2(?:02|1[037]|2[45]|3[68])\\d{5}", , , , "20211234", , , [8]], [, , "(?:6[1-8]|9[03-9])\\d{6}", , , , "90011234", , , [8]], [, , "7[3-5]\\d{2}", , , , "7312", , , [4]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "857[58]\\d{4}", , , , "85751234", , , [8]], "BJ", 229, 
"00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "81\\d{6}", , , , "81123456", , , [8]], , , [, , , , , , , , , [-1]]], BL:[, [, , "[56]\\d{8}", , , , , , , [9]], [, , "590(?:2[7-9]|5[12]|87)\\d{4}", , , , "590271234"], [, , "690(?:0[05-9]|[1-9]\\d)\\d{4}", , , , "690001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BL", 
590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BM:[, [, , "[4589]\\d{9}", , , , , , , [10], [7]], [, , "441(?:2(?:02|23|61|[3479]\\d)|[46]\\d{2}|5(?:4\\d|60|89)|824)\\d{4}", , , , "4412345678", , , , [7]], [, , "441(?:[37]\\d|5[0-39])\\d{5}", , , , "4413701234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , 
, , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "BM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "441", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BN:[, [, , "[2-578]\\d{6}", , , , , , , [7]], [, , "2(?:[013-9]\\d|2[0-7])\\d{4}|[3-5]\\d{6}", , , , "2345678"], [, , "22[89]\\d{4}|[78]\\d{6}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BN", 673, "00", , , , , , , , [[, "([2-578]\\d{2})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BO:[, [, , "[23467]\\d{7}", , , , , , , [8], [7]], [, , "(?:2(?:2\\d{2}|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d{2}|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:2\\d|3[234]|4[248]|5[24]|6[2-6]|7\\d))|4(?:4\\d{2}|6(?:11|[24689]\\d|72)))\\d{4}", 
, , , "22123456", , , , [7]], [, , "[67]\\d{7}", , , , "71234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BO", 591, "00(1\\d)?", "0", , , "0(1\\d)?", , , , [[, "([234])(\\d{7})", "$1 $2", ["[234]"], , "0$CC $1"], [, "([67]\\d{7})", "$1", ["[67]"], , "0$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BQ:[, [, , "[347]\\d{6}", , , 
, , , , [7]], [, , "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|50)\\d)\\d{3}", , , , "7151234"], [, , "(?:31(?:8[14-8]|9[14578])|416[145-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}", , , , "3181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BQ", 599, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BR:[, [, , "[1-46-9]\\d{7,10}|5(?:[0-4]\\d{7,9}|5(?:[2-8]\\d{7}|9\\d{7,8}))", 
, , , , , , [8, 9, 10, 11]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", , , , "1123456789", , , [10], [8]], [, , "(?:[189][1-9]|2[12478])(?:7|9\\d)\\d{7}|(?:3[1-578]|[46][1-9]|5[13-5]|7[13-579])(?:[6-8]|9\\d?)\\d{7}", , , , "11961234567", , , [10, 11], [8]], [, , "800\\d{6,7}", , , , "800123456", , , [9, 10]], [, , "(?:300|[59]00\\d?)\\d{6}", , , , "300123456", , , [9, 10]], [, , "(?:300\\d(?:\\d{2})?|40(?:0\\d|20))\\d{4}", , , , "40041234", , , [8, 10]], [, , , , , , 
, , , [-1]], [, , , , , , , , , [-1]], "BR", 55, "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "0", , , "0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["(?:300|40[02])", "(?:300|40(?:0|20))"]], [, "([3589]00)(\\d{2,3})(\\d{4})", "$1 $2 $3", ["[3589]00"], "0$1"], [, "(\\d{3,5})", "$1", ["1[125689]"], "$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["[2-9](?:[1-9]|0[1-9])"], "$1"], [, "(\\d{5})(\\d{4})", "$1-$2", ["9(?:[1-9]|0[1-9])"], "$1"], [, "(\\d{2})(\\d{4})(\\d{4})", 
"$1 $2-$3", ["[1-9][1-9]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[1-9][1-9]9"], "($1)", "0 $CC ($1)"]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["(?:300|40[02])", "(?:300|40(?:0|20))"]], [, "([3589]00)(\\d{2,3})(\\d{4})", "$1 $2 $3", ["[3589]00"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["[1-9][1-9]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[1-9][1-9]9"], "($1)", "0 $CC ($1)"]], [, , , , , , , , , [-1]], , , [, , "(?:300\\d|40(?:0\\d|20))\\d{4}", 
, , , "40041234", , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BS:[, [, , "[2589]\\d{9}", , , , , , , [10], [7]], [, , "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[3467]|8[0-4]|9[2-467])|461|502|6(?:0[1-3]|12|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}", , , , "2423456789", , , , [7]], [, , "242(?:3(?:5[79]|[79]5)|4(?:[2-4][1-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|99))\\d{4}", , , , "2423591234", , , , [7]], [, , "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", 
, , , "8002123456", , , , [7]], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "BS", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "242", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BT:[, [, , "[1-8]\\d{6,7}", , , , , , , [7, 8], [6]], [, , "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", , , , "2345678", , , [7], [6]], 
[, , "(?:1[67]|77)\\d{6}", , , , "17123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BT", 975, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1|77"]], [, "([2-8])(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BW:[, [, , "[2-79]\\d{6,7}", , , , , , , 
[7, 8]], [, , "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[01])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[0389]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}", , , , "2401234", , , [7]], [, , "7(?:[1-6]\\d|7[014-8])\\d{5}", , , , "71123456", , , [8]], [, , , , , , , , , [-1]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "79[12][01]\\d{4}", , , , "79101234", , , [8]], "BW", 267, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", 
"$1 $2", ["[2-6]"]], [, "(7\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], [, "(90)(\\d{5})", "$1 $2", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BY:[, [, , "[1-4]\\d{8}|800\\d{3,7}|[89]\\d{9,10}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [, , "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d{2})|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", , , , 
"152450911", , , [9], [5, 6, 7]], [, , "(?:2(?:5[5679]|9[1-9])|33\\d|44\\d)\\d{6}", , , , "294911911", , , [9]], [, , "8(?:0[13]|20\\d)\\d{7}|800\\d{3,7}", , , , "8011234567"], [, , "(?:810|902)\\d{7}", , , , "9021234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "249\\d{6}", , , , "249123456", , , [9]], "BY", 375, "810", "8", , , "8?0?", , "8~10", , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["17[0-3589]|2[4-9]|[34]", "17(?:[02358]|1[0-2]|9[0189])|2[4-9]|[34]"], 
"8 0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])", "1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])"], "8 0$1"], [, "(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], [, "([89]\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8[01]|9"], "8 $1"], [, "(82\\d)(\\d{4})(\\d{4})", 
"$1 $2 $3", ["82"], "8 $1"], [, "(800)(\\d{3})", "$1 $2", ["800"], "8 $1"], [, "(800)(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , "8(?:0[13]|10|20\\d)\\d{7}|800\\d{3,7}|902\\d{7}", , , , "82012345678"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BZ:[, [, , "[2-8]\\d{6}|0\\d{10}", , , , , , , [7, 11]], [, , "(?:2(?:[02]\\d|36)|[3-58][02]\\d|7(?:[02]\\d|32))\\d{4}", , , , "2221234", , , [7]], [, , "6[0-35-7]\\d{5}", , , , "6221234", , , [7]], 
[, , "0800\\d{7}", , , , "08001234123", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BZ", 501, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [, "(0)(800)(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]]], CA:[, [, , "[2-9]\\d{9}|3\\d{6}", , , , , , , [7, 10]], [, , "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}|310\\d{4}", 
, , , "2042345678", , , [10], [7]], [, , "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", , , , "2042345678", , , [10], [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}|310\\d{4}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456", , , [10]], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678", , , [10]], [, , , , , , , , 
, [-1]], "CA", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CC:[, [, , "[1458]\\d{5,9}", , , , , , , [6, 7, 9, 10], [8]], [, , "89162\\d{4}", , , , "891621234", , , [9], [8]], [, , "14(?:5\\d|71)\\d{5}|4(?:[0-2]\\d|3[0-57-9]|4[47-9]|5[0-25-9]|6[6-9]|7[02-9]|8[147-9]|9[017-9])\\d{6}", , , , "412345678", , , [9]], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0126]\\d{6}", 
, , , "1900123456", , , [10]], [, , "13(?:00\\d{2})?\\d{4}", , , , "1300123456", , , [6, 10]], [, , "500\\d{6}", , , , "500123456", , , [9]], [, , "550\\d{6}", , , , "550123456", , , [9]], "CC", 61, "(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]", "0", , , "0", , "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CD:[, [, , "[2-6]\\d{6}|[18]\\d{6,8}|9\\d{8}", , , , , , , [7, 9]], [, , "1(?:2\\d{7}|\\d{6})|[2-6]\\d{6}", 
, , , "1234567"], [, , "8(?:[0-2459]\\d{2}|8)\\d{5}|9[017-9]\\d{7}", , , , "991234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CD", 243, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["12"], "0$1"], [, "([89]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[0-2459]|9"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"]], , 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CF:[, [, , "[278]\\d{7}", , , , , , , [8]], [, , "2[12]\\d{6}", , , , "21612345"], [, , "7[0257]\\d{6}", , , , "70012345"], [, , , , , , , , , [-1]], [, , "8776\\d{4}", , , , "87761234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CF", 236, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, 
, , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CG:[, [, , "[028]\\d{8}", , , , , , , [9]], [, , "222[1-589]\\d{5}", , , , "222123456"], [, , "0[14-6]\\d{7}", , , , "061234567"], [, , , , , , , , , [-1]], [, , "80(?:0\\d{2}|11[01])\\d{4}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CG", 242, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["801"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", 
["[02]"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["800"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]]], CH:[, [, , "[2-9]\\d{8}|860\\d{9}", , , , , , , [9, 12]], [, , "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", , , , "212345678", , , [9]], [, , "7[5-9]\\d{7}", , , , "781234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[016]\\d{6}", , , , "900123456", , , [9]], [, , "84[0248]\\d{6}", , , 
, "840123456", , , [9]], [, , "878\\d{6}", , , , "878123456", , , [9]], [, , , , , , , , , [-1]], "CH", 41, "00", "0", , , "0", , , , [[, "([2-9]\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]|[89]1"], "0$1"], [, "([89]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["860"], "0$1"]], , [, , "74[0248]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "5[18]\\d{7}", , , , "581234567", , , [9]], 
, , [, , "860\\d{9}", , , , "860123456789", , , [12]]], CI:[, [, , "[02-8]\\d{7}", , , , , , , [8]], [, , "(?:2(?:0[023]|1[02357]|[23][045]|4[03-5])|3(?:0[06]|1[069]|[2-4][07]|5[09]|6[08]))\\d{5}", , , , "21234567"], [, , "(?:0[1-9]|4\\d|5[14-9]|6[015-79]|[78][4-9])\\d{6}", , , , "01234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CI", 225, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], 
, [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]]], CK:[, [, , "[2-8]\\d{4}", , , , , , , [5]], [, , "(?:2\\d|3[13-7]|4[1-5])\\d{3}", , , , "21234"], [, , "[5-8]\\d{4}", , , , "71234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CK", 682, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CL:[, [, , "(?:[2-9]|600|123)\\d{7,8}", , , , , , , [9, 10, 11], [7, 8]], [, , "2(?:1962\\d{4}|2\\d{7}|32[0-2467]\\d{5})|(?:3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|9[3-9])\\d{7}", , , , "221234567", , , [9], [7, 8]], [, , "2(?:1962\\d{4}|2\\d{7}|32[0-2467]\\d{5})|(?:3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|9[3-9])\\d{7}", , , , "961234567", , , [9], [8]], [, , "800\\d{6}|1230\\d{7}", , , , "800123456", , , [9, 11]], [, , , , , , , , , [-1]], [, , 
"600\\d{7,8}", , , , "6001234567", , , [10, 11]], [, , , , , , , , , [-1]], [, , "44\\d{7}", , , , "441234567", , , [9]], "CL", 56, "(?:0|1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))0", "0", , , "0|(1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))", , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[23]"], "($1)", "$CC ($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[357]|4[1-35]|6[13-57]"], "($1)", "$CC ($1)"], [, "(9)(\\d{4})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(44)(\\d{3})(\\d{4})", 
"$1 $2 $3", ["44"], "0$1"], [, "([68]00)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"], "$1"], [, "(600)(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"], "$1"], [, "(1230)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "$1"], [, "(\\d{5})(\\d{4})", "$1 $2", ["219"], "($1)", "$CC ($1)"], [, "(\\d{4,5})", "$1", ["[1-9]"], "$1"]], [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[23]"], "($1)", "$CC ($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[357]|4[1-35]|6[13-57]"], "($1)", "$CC ($1)"], [, "(9)(\\d{4})(\\d{4})", 
"$1 $2 $3", ["9"], "0$1"], [, "(44)(\\d{3})(\\d{4})", "$1 $2 $3", ["44"], "0$1"], [, "([68]00)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"], "$1"], [, "(600)(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"], "$1"], [, "(1230)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "$1"], [, "(\\d{5})(\\d{4})", "$1 $2", ["219"], "($1)", "$CC ($1)"]], [, , , , , , , , , [-1]], , , [, , "600\\d{7,8}", , , , "6001234567", , , [10, 11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CM:[, [, , "[2368]\\d{7,8}", , 
, , , , , [8, 9]], [, , "2(?:22|33|4[23])\\d{6}", , , , "222123456", , , [9]], [, , "6[5-9]\\d{7}", , , , "671234567", , , [9]], [, , "88\\d{6}", , , , "88012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CM", 237, "00", , , , , , , , [[, "([26])(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[23]|88"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , 
, [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CN:[, [, , "[1-7]\\d{6,11}|8[0-357-9]\\d{6,9}|9\\d{7,10}", , , , , , , [7, 8, 9, 10, 11, 12], [5, 6]], [, , "21(?:100\\d{2}|95\\d{3,4}|\\d{8,10})|(?:10|2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:[57]1|98))(?:100\\d{2}|95\\d{3,4}|\\d{8})|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[3-9]|5[2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-4689]|6[2368]|9[02-9])|8(?:078|1[236-8]|2[5-7]|3\\d|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100\\d{2}|95\\d{3,4}|\\d{7})|80(?:29|6[03578]|7[018]|81)\\d{4}", 
, , , "1012345678", , , , [5, 6]], [, , "1(?:[38]\\d|4[57]|5[0-35-9]|7[0-35-8])\\d{8}", , , , "13123456789", , , [11]], [, , "(?:10)?800\\d{7}", , , , "8001234567", , , [10, 12]], [, , "16[08]\\d{5}", , , , "16812345", , , [8]], [, , "400\\d{7}|950\\d{7,8}|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[4789]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[3678]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", 
, , , "4001234567", , , [7, 8, 9, 10, 11], [5, 6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CN", 86, "(1(?:[129]\\d{3}|79\\d{2}))?00", "0", , , "(1(?:[129]\\d{3}|79\\d{2}))|0", , "00", , [[, "(80\\d{2})(\\d{4})", "$1 $2", ["80[2678]"], "0$1", "$CC $1", 1], [, "([48]00)(\\d{3})(\\d{4})", "$1 $2 $3", ["[48]00"]], [, "(\\d{5,6})", "$1", ["100|95"]], [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2\\d)[19]", "(?:10|2\\d)(?:10|9[56])", "(?:10|2\\d)(?:100|9[56])"], "0$1", "$CC $1"], [, "(\\d{3})(\\d{5,6})", 
"$1 $2", ["[3-9]", "[3-9]\\d{2}[19]", "[3-9]\\d{2}(?:10|9[56])"], "0$1", "$CC $1"], [, "(\\d{3,4})(\\d{4})", "$1 $2", ["[2-9]"]], [, "(21)(\\d{4})(\\d{4,6})", "$1 $2 $3", ["21"], "0$1", "$CC $1", 1], [, "([12]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["10[1-9]|2[02-9]", "10[1-9]|2[02-9]", "10(?:[1-79]|8(?:[1-9]|0[1-9]))|2[02-9]"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"], 
"0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:[57]1|98)"], "0$1", "$CC $1", 1], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["807", "8078"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-578]"], , "$CC $1"], [, "(10800)(\\d{3})(\\d{4})", "$1 $2 $3", ["108", "1080", "10800"]], [, "(\\d{3})(\\d{7,8})", "$1 $2", ["950"]]], [[, "(80\\d{2})(\\d{4})", "$1 $2", ["80[2678]"], 
"0$1", "$CC $1", 1], [, "([48]00)(\\d{3})(\\d{4})", "$1 $2 $3", ["[48]00"]], [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2\\d)[19]", "(?:10|2\\d)(?:10|9[56])", "(?:10|2\\d)(?:100|9[56])"], "0$1", "$CC $1"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[3-9]", "[3-9]\\d{2}[19]", "[3-9]\\d{2}(?:10|9[56])"], "0$1", "$CC $1"], [, "(21)(\\d{4})(\\d{4,6})", "$1 $2 $3", ["21"], "0$1", "$CC $1", 1], [, "([12]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["10[1-9]|2[02-9]", "10[1-9]|2[02-9]", "10(?:[1-79]|8(?:[1-9]|0[1-9]))|2[02-9]"], 
"0$1", "$CC $1", 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:[57]1|98)"], 
"0$1", "$CC $1", 1], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["807", "8078"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-578]"], , "$CC $1"], [, "(10800)(\\d{3})(\\d{4})", "$1 $2 $3", ["108", "1080", "10800"]], [, "(\\d{3})(\\d{7,8})", "$1 $2", ["950"]]], [, , , , , , , , , [-1]], , , [, , "(?:4|(?:10)?8)00\\d{7}|950\\d{7,8}", , , , "4001234567", , , [10, 11, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CO:[, [, , "(?:[13]\\d{0,3}|[24-8])\\d{7}", , 
, , , , , [8, 10, 11], [7]], [, , "[124-8][2-9]\\d{6}", , , , "12345678", , , [8], [7]], [, , "3(?:0[0-5]|1\\d|2[0-3]|5[01])\\d{7}", , , , "3211234567", , , [10]], [, , "1800\\d{7}", , , , "18001234567", , , [11]], [, , "19(?:0[01]|4[78])\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CO", 57, "00(?:4(?:[14]4|56)|[579])", "0", , , "0([3579]|4(?:44|56))?", , , , [[, "(\\d)(\\d{7})", "$1 $2", ["1(?:8[2-9]|9[0-3]|[2-7])|[24-8]", 
"1(?:8[2-9]|9(?:09|[1-3])|[2-7])|[24-8]"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], , "0$CC $1"], [, "(1)(\\d{3})(\\d{7})", "$1-$2-$3", ["1(?:80|9[04])", "1(?:800|9(?:0[01]|4[78]))"], "0$1"]], [[, "(\\d)(\\d{7})", "$1 $2", ["1(?:8[2-9]|9[0-3]|[2-7])|[24-8]", "1(?:8[2-9]|9(?:09|[1-3])|[2-7])|[24-8]"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], , "0$CC $1"], [, "(1)(\\d{3})(\\d{7})", "$1 $2 $3", ["1(?:80|9[04])", "1(?:800|9(?:0[01]|4[78]))"]]], [, , , , , , , , , [-1]], 
, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CR:[, [, , "[24-9]\\d{7,9}", , , , , , , [8, 10]], [, , "2[0-24-7]\\d{6}", , , , "22123456", , , [8]], [, , "5(?:0[01]|7[0-3])\\d{5}|6(?:[0-4]\\d{3}|500[01])\\d{3}|(?:7[0-3]|8[3-9])\\d{6}", , , , "83123456", , , [8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "90[059]\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "210[0-6]\\d{4}|4\\d{7}|5100\\d{4}", 
, , , "40001234", , , [8]], "CR", 506, "00", , , , "(19(?:0[012468]|1[09]|20|66|77|99))", , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[24-7]|8[3-9]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]0"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CU:[, [, , "[2-57]\\d{5,7}", , , , , , , [6, 7, 8], [4, 5]], [, , "2[1-4]\\d{5,6}|3(?:1\\d{6}|[23]\\d{4,6})|4(?:[125]\\d{5,6}|[36]\\d{6}|[78]\\d{4,6})|7\\d{6,7}", 
, , , "71234567", , , , [4, 5]], [, , "5\\d{7}", , , , "51234567", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CU", 53, "119", "0", , , "0", , , , [[, "(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], [, "(\\d{2})(\\d{4,6})", "$1 $2", ["[2-4]"], "(0$1)"], [, "(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 
CV:[, [, , "[259]\\d{6}", , , , , , , [7]], [, , "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}", , , , "2211234"], [, , "(?:9\\d|59)\\d{5}", , , , "9911234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CV", 238, "0", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CW:[, [, 
, "[169]\\d{6,7}", , , , , , , [7, 8]], [, , "9(?:[48]\\d{2}|50\\d|7(?:2[0-24]|[34]\\d|6[35-7]|77|8[7-9]))\\d{4}", , , , "94151234", , , [8]], [, , "9(?:5(?:[12467]\\d|3[01])|6(?:[15-9]\\d|3[01]))\\d{4}", , , , "95181234", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "60[0-2]\\d{4}", , , , "6001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CW", 599, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[13-7]"]], [, "(9)(\\d{3})(\\d{4})", "$1 $2 $3", 
["9"]]], , [, , "955\\d{5}", , , , "95581234", , , [8]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CX:[, [, , "[1458]\\d{5,9}", , , , , , , [6, 7, 8, 9, 10]], [, , "89164\\d{4}", , , , "891641234", , , [9], [8]], [, , "14(?:5\\d|71)\\d{5}|4(?:[0-2]\\d|3[0-57-9]|4[47-9]|5[0-25-9]|6[6-9]|7[02-9]|8[147-9]|9[017-9])\\d{6}", , , , "412345678", , , [9]], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0126]\\d{6}", , , , "1900123456", 
, , [10]], [, , "13(?:00\\d{2})?\\d{4}", , , , "1300123456", , , [6, 8, 10]], [, , "500\\d{6}", , , , "500123456", , , [9]], [, , "550\\d{6}", , , , "550123456", , , [9]], "CX", 61, "(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]", "0", , , "0", , "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CY:[, [, , "[257-9]\\d{7}", , , , , , , [8]], [, , "2[2-6]\\d{6}", , , , "22345678"], [, , "9[4-79]\\d{6}", , , , "96123456"], 
[, , "800\\d{5}", , , , "80001234"], [, , "90[09]\\d{5}", , , , "90012345"], [, , "80[1-9]\\d{5}", , , , "80112345"], [, , "700\\d{5}", , , , "70012345"], [, , , , , , , , , [-1]], "CY", 357, "00", , , , , , , , [[, "(\\d{2})(\\d{6})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:50|77)\\d{6}", , , , "77123456"], , , [, , , , , , , , , [-1]]], CZ:[, [, , "[2-8]\\d{8}|9\\d{8,11}", , , , , , , [9, 10, 11, 12]], [, , "2\\d{8}|(?:3[1257-9]|4[16-9]|5[13-9])\\d{7}", , , 
, "212345678", , , [9]], [, , "(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}", , , , "601123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:0[05689]|76)\\d{6}", , , , "900123456", , , [9]], [, , "8[134]\\d{7}", , , , "811234567", , , [9]], [, , "70[01]\\d{6}", , , , "700123456", , , [9]], [, , "9[17]0\\d{6}", , , , "910123456", , , [9]], "CZ", 420, "00", , , , , , , , [[, "([2-9]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], [, "(96\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", 
["96"]], [, "(9\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9[36]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "9(?:5\\d|7[234])\\d{6}", , , , "972123456", , , [9]], , , [, , "9(?:3\\d{9}|6\\d{7,10})", , , , "93123456789"]], DE:[, [, , "[1-35-9]\\d{3,14}|4(?:[0-8]\\d{3,12}|9(?:[0-37]\\d|4(?:[1-35-8]|4\\d?)|5\\d{1,2}|6[1-8]\\d?)\\d{2,8})", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [3]], [, , "2\\d{5,13}|3(?:0\\d{3,13}|2\\d{9}|[3-9]\\d{4,13})|4(?:0\\d{3,12}|\\d{5,13})|5(?:0[2-8]|[1256]\\d|[38][0-8]|4\\d{0,2}|[79][0-7])\\d{3,11}|6(?:\\d{5,13}|9\\d{3,12})|7(?:0[2-8]|[1-9]\\d)\\d{3,10}|8(?:0[2-9]|[1-8]\\d|9\\d?)\\d{3,10}|9(?:0[6-9]\\d{3,10}|1\\d{4,12}|[2-9]\\d{4,11})", 
, , , "30123456", , , [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [3, 4]], [, , "1(?:5[0-25-9]\\d{8}|6[023]\\d{7,8}|7\\d{8,9})", , , , "15123456789", , , [10, 11]], [, , "800\\d{7,12}", , , , "8001234567890", , , [10, 11, 12, 13, 14, 15]], [, , "137[7-9]\\d{6}|900(?:[135]\\d{6}|9\\d{7})", , , , "9001234567", , , [10, 11]], [, , "1(?:3(?:7[1-6]\\d{6}|8\\d{4})|80\\d{5,11})", , , , "18012345", , , [7, 8, 9, 10, 11, 12, 13, 14]], [, , "700\\d{8}", , , , "70012345678", , , [11]], [, , , , , , , , , [-1]], 
"DE", 49, "00", "0", , , "0", , , , [[, "(1\\d{2})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], [, "(15\\d{3})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], [, "(1\\d{3})(\\d{7})", "$1 $2", ["15"], "0$1"], [, "(\\d{2})(\\d{3,11})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], [, "(\\d{3})(\\d{3,11})", "$1 $2", ["2(?:\\d1|0[2389]|1[24]|28|34)|3(?:[3-9][15]|40)|[4-8][1-9]1|9(?:06|[1-9]1)"], "0$1"], [, "(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|[7-9](?:\\d[1-9]|[1-9]\\d)|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])", 
"[24-6]|[7-9](?:\\d[1-9]|[1-9]\\d)|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|4[1246]|6[1-4]|7[1346]|8[13568]|9[1246])|6(?:0[356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6[0135-9]|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))"], "0$1"], [, "(3\\d{4})(\\d{1,10})", "$1 $2", 
["3"], "0$1"], [, "(800)(\\d{7,12})", "$1 $2", ["800"], "0$1"], [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["(?:18|90)0|137", "1(?:37|80)|900[1359]"], "0$1"], [, "(1\\d{2})(\\d{5,11})", "$1 $2", ["181"], "0$1"], [, "(18\\d{3})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], [, "(18\\d{2})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], [, "(18\\d)(\\d{8})", "$1 $2", ["18[2-579]"], "0$1"], [, "(700)(\\d{4})(\\d{4})", "$1 $2 $3", ["700"], "0$1"], [, "(138)(\\d{4})", "$1 $2", ["138"], "0$1"], [, "(15[013-68])(\\d{2})(\\d{8})", 
"$1 $2 $3", ["15[013-68]"], "0$1"], [, "(15[279]\\d)(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], [, "(1[67]\\d)(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"]], , [, , "16(?:4\\d{1,10}|[89]\\d{1,11})", , , , "16412345", , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]], [, , "18(?:1\\d{5,11}|[2-9]\\d{8})", , , , "18500123456", , , [8, 9, 10, 11, 12, 13, 14]], , , [, , "1(?:5(?:(?:2\\d55|7\\d99|9\\d33)\\d{7}|(?:[034568]00|113)\\d{8})|6(?:013|255|399)\\d{7,8}|7(?:[015]13|[234]55|[69]33|[78]99)\\d{7,8})", 
, , , "177991234567", , , [12, 13]]], DJ:[, [, , "[27]\\d{7}", , , , , , , [8]], [, , "2(?:1[2-5]|7[45])\\d{5}", , , , "21360003"], [, , "77\\d{6}", , , , "77831001"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DJ", 253, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 
DK:[, [, , "[2-9]\\d{7}", , , , , , , [8]], [, , "(?:[2-7]\\d|8[126-9]|9[1-36-9])\\d{6}", , , , "32123456"], [, , "(?:[2-7]\\d|8[126-9]|9[1-36-9])\\d{6}", , , , "20123456"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DK", 45, "00", , , , , , , 1, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, 
, , , , , , , , [-1]]], DM:[, [, , "[57-9]\\d{9}", , , , , , , [10], [7]], [, , "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4]|70[1-3])\\d{4}", , , , "7674201234", , , , [7]], [, , "767(?:2(?:[234689]5|7[5-7])|31[5-7]|61[2-7])\\d{4}", , , , "7672251234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "DM", 
1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "767", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], DO:[, [, , "[589]\\d{9}", , , , , , , [10], [7]], [, , "8(?:[04]9[2-9]\\d{6}|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d{2}|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9]))\\d{4})", 
, , , "8092345678", , , , [7]], [, , "8[024]9[2-9]\\d{6}", , , , "8092345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "DO", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "8[024]9", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], DZ:[, [, , "(?:[1-4]|[5-9]\\d)\\d{7}", 
, , , , , , [8, 9]], [, , "(?:1\\d|2[013-79]|3[0-8]|4[0135689])\\d{6}|9619\\d{5}", , , , "12345678"], [, , "(?:5[4-6]|7[7-9])\\d{7}|6(?:[569]\\d|7[0-6])\\d{6}", , , , "551234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "80[3-689]1\\d{5}", , , , "808123456", , , [9]], [, , "80[12]1\\d{5}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , "98[23]\\d{6}", , , , "983123456", , , [9]], "DZ", 213, "00", "0", , , "0", , , , [[, "([1-4]\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", 
["[1-4]"], "0$1"], [, "([5-8]\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"], [, "(9\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EC:[, [, , "1\\d{9,10}|[2-8]\\d{7}|9\\d{8}", , , , , , , [8, 9, 10, 11], [7]], [, , "[2-7][2-7]\\d{6}", , , , "22123456", , , [8], [7]], [, , "9(?:(?:39|[45][89]|7[7-9]|[89]\\d)\\d|6(?:[017-9]\\d|2[0-4]))\\d{5}", , , , "991234567", 
, , [9]], [, , "1800\\d{6,7}", , , , "18001234567", , , [10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[2-7]890\\d{4}", , , , "28901234", , , [8]], "EC", 593, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[247]|[356][2-8]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(1800)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"], "$1"]], [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[247]|[356][2-8]"]], [, "(\\d{2})(\\d{3})(\\d{4})", 
"$1 $2 $3", ["9"], "0$1"], [, "(1800)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"], "$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EE:[, [, , "1\\d{3,4}|[3-9]\\d{6,7}|800\\d{6,7}", , , , , , , [4, 5, 7, 8, 10]], [, , "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", , , , "3212345", , , [7]], [, , "(?:5\\d|8[1-5])\\d{6}|5(?:[02]\\d{2}|1(?:[0-8]\\d|95)|5[0-478]\\d|64[0-4]|65[1-589])\\d{3}", , , , "51234567", , , [7, 8]], [, , "800(?:0\\d{3}|1\\d|[2-9])\\d{3}", 
, , , "80012345", , , [7, 8, 10]], [, , "(?:40\\d{2}|900)\\d{4}", , , , "9001234", , , [7, 8]], [, , , , , , , , , [-1]], [, , "70[0-2]\\d{5}", , , , "70012345", , , [8]], [, , , , , , , , , [-1]], "EE", 372, "00", , , , , , , , [[, "([3-79]\\d{2})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"]], [, "(70)(\\d{2})(\\d{4})", "$1 $2 $3", ["70"]], [, "(8000)(\\d{3})(\\d{3})", "$1 $2 $3", ["800", "8000"]], 
[, "([458]\\d{3})(\\d{3,4})", "$1 $2", ["40|5|8(?:00|[1-5])", "40|5|8(?:00[1-9]|[1-5])"]]], , [, , , , , , , , , [-1]], , , [, , "1\\d{3,4}|800[2-9]\\d{3}", , , , "8002123", , , [4, 5, 7]], [, , "1(?:2[01245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[012])\\d{1,2}", , , , "12123", , , [4, 5]], , , [, , , , , , , , , [-1]]], EG:[, [, , "1\\d{4,9}|[2456]\\d{8}|3\\d{7}|[89]\\d{8,9}", , , , , , , [5, 8, 9, 10], [7]], [, , "(?:1(?:3[23]\\d|5(?:[23]|9\\d))|2[2-4]\\d{2}|3\\d{2}|4(?:0[2-5]|[578][23]|64)\\d|5(?:0[2-7]|[57][23])\\d|6[24-689]3\\d|8(?:2[2-57]|4[26]|6[237]|8[2-4])\\d|9(?:2[27]|3[24]|52|6[2356]|7[2-4])\\d)\\d{5}|1[69]\\d{3}", 
, , , "234567890", , , [5, 8, 9], [7]], [, , "1(?:0[0-269]|1[0-245]|2[0-278])\\d{7}", , , , "1001234567", , , [10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "EG", 20, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1[012]|[89]00"], "0$1"], [, "(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|[89][2-9]"], 
"0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EH:[, [, , "[5-9]\\d{8}", , , , , , , [9]], [, , "528[89]\\d{5}", , , , "528812345"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[07][07]|6[12]))\\d{6}", , , , "650123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5924[01]\\d{4}", , , , "592401234"], "EH", 212, "00", "0", , , "0", , , , , 
, [, , , , , , , , , [-1]], , "528[89]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ER:[, [, , "[178]\\d{6}", , , , , , , [7], [6]], [, , "1(?:1[12568]|20|40|55|6[146])\\d{4}|8\\d{6}", , , , "8370362", , , , [6]], [, , "17[1-3]\\d{4}|7\\d{6}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ER", 291, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", 
, "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ES:[, [, , "[5-9]\\d{8}", , , , , , , [9]], [, , "8(?:[1356]\\d|[28][0-8]|[47][1-9])\\d{6}|9(?:[135]\\d{7}|[28][0-8]\\d{6}|4[1-9]\\d{6}|6(?:[0-8]\\d{6}|9(?:0(?:[0-57-9]\\d{4}|6(?:0[0-8]|1[1-9]|[2-9]\\d)\\d{2})|[1-9]\\d{5}))|7(?:[124-9]\\d{2}|3(?:[0-8]\\d|9[1-9]))\\d{4})", , , , "810123456"], [, , "(?:6\\d{6}|7[1-48]\\d{5}|9(?:6906(?:09|10)|7390\\d{2}))\\d{2}", , , , "612345678"], 
[, , "[89]00\\d{6}", , , , "800123456"], [, , "80[367]\\d{6}", , , , "803123456"], [, , "90[12]\\d{6}", , , , "901123456"], [, , "70\\d{7}", , , , "701234567"], [, , , , , , , , , [-1]], "ES", 34, "00", , , , , , , , [[, "([89]00)(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "([5-9]\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[568]|[79][0-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "51\\d{7}", , , , "511234567"], , , [, , , , , , , , , [-1]]], ET:[, [, , "[1-59]\\d{8}", 
, , , , , , [9], [7]], [, , "(?:11(?:1(?:1[124]|2[2-57]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:18|2[69]|39|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|22[0-6]|33[0134689]|44[04]|55[0-6]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:11[1-9]|22[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}", 
, , , "111112345", , , , [7]], [, , "9(?:[1-46-8]\\d|5[89])\\d{6}", , , , "911234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ET", 251, "00", "0", , , "0", , , , [[, "([1-59]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", , "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FI:[, [, , "[16]\\d{6,9}|2\\d{4,9}|[35]\\d{5,9}|4\\d{7,10}|7\\d{7,9}|[89]\\d{6,8}", 
, , , , , , [5, 6, 7, 8, 9, 10, 11]], [, , "1[3-79][1-8]\\d{4,6}|[235689][1-8]\\d{5,7}", , , , "131234567", , , [7, 8, 9]], [, , "4(?:[0-8]\\d{6,8}|9\\d{9})|50\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10, 11]], [, , "800\\d{5,6}", , , , "800123456", , , [8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FI", 358, "00|99(?:[02469]|5(?:11|33|5[59]|88|9[09]))", "0", , , "0", , "00", , [[, "(\\d{3})(\\d{3,7})", 
"$1 $2", ["(?:[16-8]0|300)"], "0$1"], [, "(116\\d{3})", "$1", ["116"], "$1"], [, "(\\d{2})(\\d{3,9})", "$1 $2", ["1[3-9]|2[09]|4|50|7(?:[13]|5[03-9])"], "0$1"], [, "(75\\d{3})", "$1", ["75[12]"], "0$1"], [, "(\\d)(\\d{5,9})", "$1 $2", ["[25689][1-8]|3(?:0[1-9]|[1-8])"], "0$1"], [, "(39\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["39"], "0$1"]], [[, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[16-8]0|300)"], "0$1"], [, "(116\\d{3})", "$1", ["116"], "$1"], [, "(\\d{2})(\\d{3,9})", "$1 $2", ["1[3-9]|2[09]|4|50|7(?:[13]|5[03-9])"], 
"0$1"], [, "(\\d)(\\d{5,9})", "$1 $2", ["[25689][1-8]|3(?:0[1-9]|[1-8])"], "0$1"], [, "(39\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["39"], "0$1"]], [, , , , , , , , , [-1]], 1, , [, , "100\\d{4,6}|20(?:0\\d{4,6}|2[023]\\d{4,5}|9[89]\\d{1,6})|300\\d{3,7}|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{5,6})", , , , "1001234", , , [5, 6, 7, 8, 9, 10]], [, , "10(?:0\\d{4,6}|[1-9]\\d{5,7})|2(?:0(?:0\\d{4,6}|[13-8]\\d{5,7}|2(?:[023]\\d{4,5}|[14-9]\\d{4,6})|9(?:[0-7]\\d{4,6}|[89]\\d{1,6}))|9\\d{6,8})|3(?:0(?:0\\d{3,7}|[1-57-9]\\d{5,7}|6(?:\\d{3}|\\d{5,7}))|93\\d{5,7})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{5,6})", 
, , , "10112345", , , [5, 6, 7, 8, 9, 10]], , , [, , , , , , , , , [-1]]], FJ:[, [, , "[35-9]\\d{6}|0\\d{10}", , , , , , , [7, 11]], [, , "(?:3[0-5]|6[25-7]|8[58])\\d{5}", , , , "3212345", , , [7]], [, , "(?:5[018]|[79]\\d|8[034679])\\d{5}", , , , "7012345", , , [7]], [, , "0800\\d{7}", , , , "08001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FJ", 679, "0(?:0|52)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[35-9]"]], 
[, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]]], FK:[, [, , "[2-7]\\d{4}", , , , , , , [5]], [, , "[2-47]\\d{4}", , , , "31234"], [, , "[56]\\d{4}", , , , "51234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FK", 500, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FM:[, [, , "[39]\\d{6}", , , , , , , [7]], [, , "3[2357]0[1-9]\\d{3}|9[2-6]\\d{5}", , , , "3201234"], [, , "3[2357]0[1-9]\\d{3}|9[2-7]\\d{5}", , , , "3501234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FM", 691, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , 
[, , , , , , , , , [-1]]], FO:[, [, , "[2-9]\\d{5}", , , , , , , [6]], [, , "(?:20|[3-4]\\d|8[19])\\d{4}", , , , "201234"], [, , "(?:[27][1-9]|5\\d)\\d{4}", , , , "211234"], [, , "80[257-9]\\d{3}", , , , "802123"], [, , "90(?:[1345][15-7]|2[125-7]|99)\\d{2}", , , , "901123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:6[0-36]|88)\\d{4}", , , , "601234"], "FO", 298, "00", , , , "(10(?:01|[12]0|88))", , , , [[, "(\\d{6})", "$1", , , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , 
, , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FR:[, [, , "[1-9]\\d{8}", , , , , , , [9]], [, , "[1-5]\\d{8}", , , , "123456789"], [, , "(?:6\\d|7[3-9])\\d{7}", , , , "612345678"], [, , "80[0-5]\\d{6}", , , , "801234567"], [, , "89[1-37-9]\\d{6}", , , , "891123456"], [, , "8(?:1[0-29]|2[0156]|84|90)\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "9\\d{8}", , , , "912345678"], "FR", 33, "00", "0", , , "0", , , , [[, "([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4 $5", ["[1-79]"], "0$1"], [, "(1\\d{2})(\\d{3})", "$1 $2", ["11"], "$1"], [, "(8\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"]], [[, "([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"], [, "(8\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "80[6-9]\\d{6}", , , , "806123456"], , , [, , , , , , , , , [-1]]], GA:[, [, , "0?\\d{7}", , , , , , , [7, 8]], [, , "01\\d{6}", 
, , , "01441234", , , [8]], [, , "0?[2-7]\\d{6}", , , , "06031234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GA", 241, "00", , , , , , , , [[, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]]], GB:[, [, , "\\d{7,10}", 
, , , , , , [7, 9, 10], [4, 5, 6, 8]], [, , "2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{7}|1(?:1(?:3[0-48]|[46][0-4]|5[0-26-9]|[78][0-49])|21[0-7]|31[0-8]|[4-69]1\\d)\\d{6}|1(?:2(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)|3(?:0\\d|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[28][02-57-9]|[37]\\d|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|2[024-9]|3[015689]|4[02-9]|5[03-9]|6\\d|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0124578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|8\\d|9[2-57]))\\d{6}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[345])))|3(?:638[2-5]|647[23]|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[123]))|5(?:24(?:3[2-79]|6\\d)|276\\d|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[567]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|955[0-4])|7(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|84(?:3[2-58]))|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}|176888[2-46-8]\\d{2}|16977[23]\\d{3}", 
, , , "1212345678", , , [9, 10], [4, 5, 6, 7, 8]], [, , "7(?:[1-3]\\d{3}|4(?:[0-46-9]\\d{2}|5(?:[0-689]\\d|7[0-57-9]))|5(?:0[0-8]|[13-9]\\d|2[0-35-9])\\d|7(?:0(?:0[01]|[1-9]\\d)|[1-7]\\d{2}|8[02-9]\\d|9[0-689]\\d)|8(?:[014-9]\\d|[23][0-8])\\d|9(?:[024-9]\\d{2}|1(?:[02-9]\\d|1[028])|3[0-689]\\d))\\d{5}", , , , "7400123456", , , [10]], [, , "80(?:0(?:1111|\\d{6,7})|8\\d{7})|500\\d{6}", , , , "8001234567"], [, , "(?:87[123]|9(?:[01]\\d|8[2349]))\\d{7}", , , , "9012345678", , , [10]], [, , "8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})", 
, , , "8431234567", , , [7, 10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , "56\\d{8}", , , , "5612345678", , , [10]], "GB", 44, "00", "0", " x", , "0", , , , [[, "(7\\d{3})(\\d{6})", "$1 $2", ["7(?:[1-57-9]|62)", "7(?:[1-57-9]|624)"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2|5[56]|7[06]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:1|\\d1)|3|9[018]"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:387|5(?:24|39)|697|768|946)", "1(?:3873|5(?:242|39[456])|697[347]|768[347]|9467)"], 
"0$1"], [, "(1\\d{3})(\\d{5,6})", "$1 $2", ["1"], "0$1"], [, "(800)(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], [, "(845)(46)(4\\d)", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], [, "(8\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8(?:4[2-5]|7[0-3])"], "0$1"], [, "(80\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1"], [, "([58]00)(\\d{6})", "$1 $2", ["[58]00"], "0$1"]], , [, , "76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}", , , , "7640123456", , , 
[10]], 1, , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]], GD:[, [, , "[4589]\\d{9}", , , , , , , [10], [7]], [, , "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|68|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}", , , , "4732691234", , , , [7]], [, , "473(?:4(?:0[2-79]|1[04-9]|20|58)|5(?:2[01]|3[3-8])|901)\\d{4}", , , , "4734031234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, 
, "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "GD", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "473", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GE:[, [, , "[34578]\\d{8}", , , , , , , [9], [6]], [, , "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}", , , , "322123456", , , , [6]], [, , "5(?:[14]4|5[0157-9]|68|7[0147-9]|9[0-35-9])\\d{6}", 
, , , "555123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "706\\d{6}", , , , "706123456"], "GE", 995, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5"], "$1"]], , [, , , , , , , , , [-1]], , , [, , "706\\d{6}", , , , "706123456"], [, , , , , , , , , 
[-1]], , , [, , , , , , , , , [-1]]], GF:[, [, , "[56]\\d{8}", , , , , , , [9]], [, , "594(?:10|2[012457-9]|3[0-57-9]|4[3-9]|5[7-9]|6[0-3]|9[014])\\d{4}", , , , "594101234"], [, , "694(?:[0249]\\d|1[2-9]|3[0-48])\\d{4}", , , , "694201234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GF", 594, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", , "0$1"]], , [, , , , , , , , , [-1]], 
, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GG:[, [, , "[135789]\\d{6,9}", , , , , , , [7, 9, 10], [6]], [, , "1481[25-9]\\d{5}", , , , "1481256789", , , [10], [6]], [, , "7(?:781\\d|839\\d|911[17])\\d{5}", , , , "7781123456", , , [10]], [, , "80(?:0(?:1111|\\d{6,7})|8\\d{7})|500\\d{6}", , , , "8001234567"], [, , "(?:87[123]|9(?:[01]\\d|8[0-3]))\\d{7}", , , , "9012345678", , , [10]], [, , "8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})", , , , "8431234567", , , 
[7, 10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , "56\\d{8}", , , , "5612345678", , , [10]], "GG", 44, "00", "0", " x", , "0", , , , , , [, , "76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}", , , , "7640123456", , , [10]], , , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]], GH:[, [, , "[235]\\d{8}|8\\d{7}", , , , , , , [8, 9], [7]], [, , "3(?:0(?:[237]\\d|80)|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", 
, , , "302345678", , , [9], [7]], [, , "(?:2[034678]\\d|5(?:[0457]\\d|6[01]))\\d{6}", , , , "231234567", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GH", 233, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "800\\d{5}", , , , "80012345", , , [8]], [, , , , , 
, , , , [-1]], , , [, , , , , , , , , [-1]]], GI:[, [, , "[256]\\d{7}", , , , , , , [8]], [, , "2(?:00\\d{2}|1(?:6[24-7]\\d|90[0-2])|2(?:2[2457]\\d|50[0-2]))\\d{3}", , , , "20012345"], [, , "(?:5[46-8]|62)\\d{6}", , , , "57123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GI", 350, "00", , , , , , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , 
, , , , , , [-1]], , , [, , , , , , , , , [-1]]], GL:[, [, , "[1-689]\\d{5}", , , , , , , [6]], [, , "(?:19|3[1-6]|6[14689]|8[14-79]|9\\d)\\d{4}", , , , "321000"], [, , "[245][2-9]\\d{4}", , , , "221234"], [, , "80\\d{4}", , , , "801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3[89]\\d{4}", , , , "381234"], "GL", 299, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , 
, , , , [-1]], , , [, , , , , , , , , [-1]]], GM:[, [, , "[2-9]\\d{6}", , , , , , , [7]], [, , "(?:4(?:[23]\\d{2}|4(?:1[024679]|[6-9]\\d))|5(?:54[0-7]|6(?:[67]\\d)|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}", , , , "5661234"], [, , "[23679]\\d{6}", , , , "3012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GM", 220, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , 
, , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GN:[, [, , "[367]\\d{7,8}", , , , , , , [8, 9]], [, , "30(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])\\d{4}", , , , "30241234", , , [8]], [, , "6[02356]\\d{7}", , , , "601123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "722\\d{6}", , , , "722123456", , , [9]], "GN", 224, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", 
["3"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GP:[, [, , "[56]\\d{8}", , , , , , , [9]], [, , "590(?:0[13468]|1[012]|2[0-68]|3[28]|4[0-8]|5[579]|6[0189]|70|8[0-689]|9\\d)\\d{4}", , , , "590201234"], [, , "690(?:0[05-9]|[1-9]\\d)\\d{4}", , , , "690001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], "GP", 590, "00", "0", , , "0", , , , [[, "([56]90)(\\d{2})(\\d{4})", "$1 $2-$3", , "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GQ:[, [, , "[23589]\\d{8}", , , , , , , [9]], [, , "3(?:3(?:3\\d[7-9]|[0-24-9]\\d[46])|5\\d{2}[7-9])\\d{4}", , , , "333091234"], [, , "(?:222|55[15])\\d{6}", , , , "222123456"], [, , "80\\d[1-9]\\d{5}", , , , "800123456"], [, , "90\\d[1-9]\\d{5}", , , , "900123456"], 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GQ", 240, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GR:[, [, , "[26-9]\\d{9}", , , , , , , [10]], [, , "2(?:1\\d{2}|2(?:2[1-46-9]|3[1-8]|4[1-7]|5[1-4]|6[1-8]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|3[1245]|4[1-7]|5[13-9]|[269][1-6]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", 
, , , "2123456789"], [, , "69\\d{8}", , , , "6912345678"], [, , "800\\d{7}", , , , "8001234567"], [, , "90[19]\\d{7}", , , , "9091234567"], [, , "8(?:0[16]|12|25)\\d{7}", , , , "8011234567"], [, , "70\\d{8}", , , , "7012345678"], [, , , , , , , , , [-1]], "GR", 30, "00", , , , , , , , [[, "([27]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[2-9]1|[689]"]], [, "(2\\d{3})(\\d{6})", "$1 $2", ["2[2-9][02-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , 
, , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GT:[, [, , "[2-7]\\d{7}|1[89]\\d{9}", , , , , , , [8, 11]], [, , "[267][2-9]\\d{6}", , , , "22456789", , , [8]], [, , "[345]\\d{7}", , , , "51234567", , , [8]], [, , "18[01]\\d{8}", , , , "18001112222", , , [11]], [, , "19\\d{9}", , , , "19001112222", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GT", 502, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], [, "(\\d{4})(\\d{3})(\\d{4})", 
"$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GU:[, [, , "[5689]\\d{9}", , , , , , , [10], [7]], [, , "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[5-9])|7(?:[079]7|2[0167]|3[45]|47|8[789])|8(?:[2-5789]8|6[48])|9(?:2[29]|6[79]|7[179]|8[789]|9[78]))\\d{4}", , , , "6713001234", , , , [7]], [, , "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[5-9])|7(?:[079]7|2[0167]|3[45]|47|8[789])|8(?:[2-5789]8|6[48])|9(?:2[29]|6[79]|7[179]|8[789]|9[78]))\\d{4}", 
, , , "6713001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "GU", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "671", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GW:[, [, , "(?:4(?:0\\d{5}|4\\d{7})|9\\d{8})", , , , , , , [7, 9]], [, , "443\\d{6}", 
, , , "443201234", , , [9]], [, , "9(?:5(?:5\\d|6[0-2])|6(?:5[0-2]|6\\d|9[012])|77\\d)\\d{5}", , , , "955012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "40\\d{5}", , , , "4012345", , , [7]], "GW", 245, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["44|9[567]"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["40"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , 
, , , , , [-1]]], GY:[, [, , "[2-46-9]\\d{6}", , , , , , , [7]], [, , "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}", , , , "2201234"], [, , "6\\d{6}", , , , "6091234"], [, , "(?:289|862)\\d{4}", , , , "2891234"], [, , "9008\\d{3}", , , , "9008123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GY", 592, "001", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , 
, , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], HK:[, [, , "[235-7]\\d{7}|8\\d{7,8}|9\\d{4,10}", , , , , , , [5, 6, 7, 8, 9, 11]], [, , "(?:2(?:[13-8]\\d|2[013-9]|9[0-24-9])|3(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69]|89)|58[01])\\d{5}", , , , "21234567", , , [8]], [, , "(?:5(?:[1-59][0-46-9]|6[0-4689]|7[0-2469])|6(?:0[1-9]|[1459]\\d|[2368][0-57-9]|7[0-79])|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", , , , "51234567", , , [8]], [, , "800\\d{6}", , , , "800123456", , , [9]], 
[, , "900(?:[0-24-9]\\d{7}|3\\d{1,4})", , , , "90012345678", , , [5, 6, 7, 8, 11]], [, , , , , , , , , [-1]], [, , "8(?:1[1-4679]|2[0-367]|3[02-47])\\d{5}", , , , "81123456", , , [8]], [, , , , , , , , , [-1]], "HK", 852, "00(?:[126-9]|30|5[09])?", , , , , , "00", , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[235-7]|[89](?:0[1-9]|[1-9])"]], [, "(800)(\\d{3})(\\d{3})", "$1 $2 $3", ["800"]], [, "(900)(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["900"]], [, "(900)(\\d{2,5})", "$1 $2", ["900"]]], , [, , "7(?:1[0-369]|[23][0-37-9]|47|5[1578]|6[0235]|7[278]|8[236-9]|9[025-9])\\d{5}", 
, , , "71234567", , , [8]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], HN:[, [, , "[237-9]\\d{7}", , , , , , , [8]], [, , "2(?:2(?:0[019]|1[1-36]|[23]\\d|4[04-6]|5[57]|7[01389]|8[0146-9]|9[012])|4(?:07|2[3-59]|3[13-689]|4[0-68]|5[1-35])|5(?:16|4[03-5]|5\\d|6[4-6]|74)|6(?:[056]\\d|17|3[04]|4[0-378]|[78][0-8]|9[01])|7(?:6[46-9]|7[02-9]|8[034])|8(?:79|8[0-35789]|9[1-57-9]))\\d{4}", , , , "22123456"], [, , "[37-9]\\d{7}", , , , "91234567"], [, , , , , , , , 
, [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "HN", 504, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1-$2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], HR:[, [, , "[1-7]\\d{5,8}|[89]\\d{6,8}", , , , , , , [6, 7, 8, 9]], [, , "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", , , , "12345678", , , [8, 9], [6, 7]], [, , "9(?:01\\d|[1259]\\d{2}|7(?:[0679]\\d|51)|8\\d{1,2})\\d{5}", 
, , , "921234567", , , [8, 9]], [, , "80[01]\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "6(?:[01]\\d{0,2}|[459]\\d{2})\\d{4}", , , , "611234", , , [6, 7, 8]], [, , , , , , , , , [-1]], [, , "7[45]\\d{6}", , , , "74123456", , , [8]], [, , , , , , , , , [-1]], "HR", 385, "00", "0", , , "0", , , , [[, "(1)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], [, "([2-5]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], [, "(9\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(6[01])(\\d{2})(\\d{2,3})", 
"$1 $2 $3", ["6[01]"], "0$1"], [, "([67]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], [, "(80[01])(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], [, "(80[01])(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:62\\d?|72)\\d{6}", , , , "62123456", , , [8, 9]], , , [, , , , , , , , , [-1]]], HT:[, [, , "[2-489]\\d{7}", , , , , , , [8]], [, , "2(?:2\\d|5[1-5]|81|9[149])\\d{5}", , , , "22453300"], [, , "[34]\\d{7}", , , , "34101234"], 
[, , "8\\d{7}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:9(?:[67][0-4]|8[0-3589]|9\\d))\\d{5}", , , , "98901234"], "HT", 509, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], HU:[, [, , "[1-9]\\d{7,8}", , , , , , , [8, 9], [6]], [, , "(?:1\\d|2[2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|7[2-9]|8[2-57-9]|9[2-69])\\d{6}", 
, , , "12345678", , , [8], [6]], [, , "(?:[257]0|3[01])\\d{7}", , , , "201234567", , , [9]], [, , "[48]0\\d{6}", , , , "80123456", , , [8]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "21\\d{7}", , , , "211234567", , , [9]], "HU", 36, "00", "06", , , "06", , , , [[, "(1)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "($1)"]], , [, , , , , , , , , [-1]], , , [, , "[48]0\\d{6}", , , 
, "80123456", , , [8]], [, , "38\\d{7}", , , , "381234567", , , [9]], , , [, , , , , , , , , [-1]]], ID:[, [, , "(?:[1-79]\\d{6,10}|8\\d{7,11})", , , , , , , [7, 8, 9, 10, 11, 12], [5, 6]], [, , "2(?:1(?:14\\d{3}|[0-8]\\d{6,7}|500\\d{3}|9\\d{6})|2\\d{6,8}|4\\d{7,8})|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:19?|[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", 
, , , "612345678", , , [7, 8, 9, 10, 11], [5, 6]], [, , "(?:2(?:1(?:3[145]|4[01]|5[1-469]|60|8[0359]|9\\d)|2(?:88|9[1256])|3[1-4]9|4(?:36|91)|5(?:1[349]|[2-4]9)|6[0-7]9|7(?:[1-36]9|4[39])|8[1-5]9|9[1-48]9)|3(?:19[1-3]|2[12]9|3[13]9|4(?:1[69]|39)|5[14]9|6(?:1[69]|2[89])|709)|4[13]19|5(?:1(?:19|8[39])|4[129]9|6[12]9)|6(?:19[12]|2(?:[23]9|77))|7(?:1[13]9|2[15]9|419|5(?:1[89]|29)|6[15]9|7[178]9))\\d{5,6}|8[1-35-9]\\d{7,10}", , , , "812345678", , , [9, 10, 11, 12]], [, , "177\\d{6,8}|800\\d{5,7}", , , 
, "8001234567", , , [8, 9, 10, 11]], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , "804\\d{7}", , , , "8041234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ID", 62, "0(?:0[1789]|10(?:00|1[67]))", "0", , , "0", , , , [[, "(\\d{2})(\\d{5,8})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [, "(\\d{3})(\\d{5,8})", "$1 $2", ["[4579]|2[035-9]|[36][02-9]"], "(0$1)"], [, "(8\\d{2})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(8\\d{2})(\\d{4})(\\d{4,5})", "$1-$2-$3", 
["8[1-35-9]"], "0$1"], [, "(1)(500)(\\d{3})", "$1 $2 $3", ["15"], "$1"], [, "(177)(\\d{6,8})", "$1 $2", ["17"], "0$1"], [, "(800)(\\d{5,7})", "$1 $2", ["800"], "0$1"], [, "(804)(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(80\\d)(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80[79]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "8071\\d{6}", , , , "8071123456", , , [10]], [, , "1500\\d{3}|8071\\d{6}", , , , "8071123456", , , [7, 10]], , , [, , , , , , , , , [-1]]], IE:[, [, , "[124-9]\\d{6,9}", 
, , , , , , [7, 8, 9, 10], [5, 6]], [, , "1\\d{7,8}|2(?:1\\d{6,7}|3\\d{7}|[24-9]\\d{5})|4(?:0[24]\\d{5}|[1-469]\\d{7}|5\\d{6}|7\\d{5}|8[0-46-9]\\d{7})|5(?:0[45]\\d{5}|1\\d{6}|[23679]\\d{7}|8\\d{5})|6(?:1\\d{6}|[237-9]\\d{5}|[4-6]\\d{7})|7[14]\\d{7}|9(?:1\\d{6}|[04]\\d{7}|[35-9]\\d{5})", , , , "2212345", , , , [5, 6]], [, , "8(?:22\\d{6}|[35-9]\\d{7})", , , , "850123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , "15(?:1[2-8]|[2-8]0|9[089])\\d{6}", , , , "1520123456", , , [10]], 
[, , "18[59]0\\d{6}", , , , "1850123456", , , [10]], [, , "700\\d{6}", , , , "700123456", , , [9]], [, , "76\\d{7}", , , , "761234567", , , [9]], "IE", 353, "00", "0", , , "0", , , , [[, "(1)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], [, "(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["40[24]|50[45]"], "(0$1)"], [, "(48)(\\d{4})(\\d{4})", "$1 $2 $3", ["48"], "(0$1)"], [, "(818)(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", 
"$1 $2 $3", ["[24-69]|7[14]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["76|8[35-9]"], "0$1"], [, "(8\\d)(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8[35-9]5"], "0$1"], [, "(700)(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:8[059]|5)", "1(?:8[059]0|5)"], "$1"]], , [, , , , , , , , , [-1]], , , [, , "18[59]0\\d{6}", , , , "1850123456", , , [10]], [, , "818\\d{6}", , , , "818123456", , , [9]], , , [, , "8[35-9]5\\d{7}", , , , "8551234567", 
, , [10]]], IL:[, [, , "1\\d{6,11}|[2-589]\\d{3}(?:\\d{3,6})?|6\\d{3}|7\\d{6,9}", , , , , , , [4, 7, 8, 9, 10, 11, 12]], [, , "(?:153\\d{1,2}|[2-489])\\d{7}", , , , "21234567", , , [8, 11, 12], [7]], [, , "5(?:[02-47-9]\\d{2}|5(?:01|2[23]|3[2-4]|4[45]|5[5689]|6[6-8]|7[0178]|8[6-9]|9[2-9])|6[2-9]\\d)\\d{5}", , , , "501234567", , , [9]], [, , "1(?:80[019]\\d{3}|255)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "1(?:212|(?:9(?:0[01]|19)|200)\\d{2})\\d{4}", , , , "1919123456", , , [8, 9, 10]], [, , 
"1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , "7(?:18\\d|2[23]\\d|3[237]\\d|47\\d|6[58]\\d|7\\d{2}|8(?:2\\d|33|55|77|81)|9[2579]\\d)\\d{5}", , , , "771234567", , , [9]], "IL", 972, "0(?:0|1[2-9])", "0", , , "0", , , , [[, "([2-489])(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], [, "([57]\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], [, "(153)(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["153"], "$1"], [, "(1)([7-9]\\d{2})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"], 
"$1"], [, "(1255)(\\d{3})", "$1-$2", ["125"], "$1"], [, "(1200)(\\d{3})(\\d{3})", "$1-$2-$3", ["120"], "$1"], [, "(1212)(\\d{2})(\\d{2})", "$1-$2-$3", ["121"], "$1"], [, "(1599)(\\d{6})", "$1-$2", ["15"], "$1"], [, "(\\d{4})", "*$1", ["[2-689]"], "$1"]], , [, , , , , , , , , [-1]], , , [, , "1700\\d{6}|[2-689]\\d{3}", , , , "1700123456", , , [4, 10]], [, , "[2-689]\\d{3}|1599\\d{6}", , , , "1599123456", , , [4, 10]], , , [, , , , , , , , , [-1]]], IM:[, [, , "[135789]\\d{6,9}", , , , , , , [10], 
[6]], [, , "1624[5-8]\\d{5}", , , , "1624756789", , , , [6]], [, , "7(?:4576|[59]24\\d)\\d{5}", , , , "7924123456"], [, , "808162\\d{4}", , , , "8081624567"], [, , "(?:872299|90[0167]624)\\d{4}", , , , "9016247890"], [, , "8(?:4(?:40[49]06|5624\\d)|70624\\d)\\d{3}", , , , "8456247890"], [, , "70\\d{8}", , , , "7012345678"], [, , "56\\d{8}", , , , "5612345678"], "IM", 44, "00", "0", " x", , "0", , , , , , [, , "7624[0-4689]\\d{5}", , , , "7624212345"], , , [, , , , , , , , , [-1]], [, , "3(?:08162\\d|3\\d{5}|4(?:40[49]06|5624\\d)|7(?:0624\\d|2299\\d))\\d{3}|55\\d{8}", 
, , , "5512345678"], , , [, , , , , , , , , [-1]]], IN:[, [, , "008\\d{9}|1\\d{7,12}|[2-9]\\d{9,10}", , , , , , , [8, 9, 10, 11, 12, 13], [6, 7]], [, , "(?:11|2[02]|33|4[04]|79)[2-7]\\d{7}|80[2-467]\\d{7}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|[36][25]|22|4[28]|5[12]|[78]1|9[15])|6(?:12|[2345]1|57|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[13-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1-5]|4[25-8]|5[125689]|6[235-7]|7[157-9]|8[2-467])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|[57][2-689]|6[24-578]|8[1-6])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d|7(?:(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|9\\d)\\d|8(?:2[0-6]|[013-8]\\d)))[2-7]\\d{5}", 
, , , "1123456789", , , [10], [6, 7, 8]], [, , "(?:600[1-3]\\d|7(?:0\\d{3}|19[0-5]\\d|2(?:[0235679]\\d{2}|[14][017-9]\\d|8(?:[0-59]\\d|[678][089]))|3(?:[05-8]\\d{2}|1(?:[089]\\d|7[5-8])|2(?:[0-49][089]|[5-8]\\d)|3[017-9]\\d|4(?:[07-9]\\d|11)|9(?:[016-9]\\d|[2-5][089]))|4(?:0\\d{2}|1(?:[015-9]\\d|[23][089]|4[089])|2(?:0[089]|[1-7][089]|[89]\\d)|3(?:[0-8][089]|9\\d)|4(?:[089]\\d|11|7[02-8])|[56]\\d[089]|7(?:[089]\\d|11|7[02-8])|8(?:[0-24-7][089]|[389]\\d)|9(?:[0-6][089]|7[089]|[89]\\d))|5(?:[0346-8]\\d{2}|1(?:[07-9]\\d|11)|2(?:[04-9]\\d|[123][089])|5[017-9]\\d|9(?:[0-6][089]|[7-9]\\d))|6(?:0(?:[0-47]\\d|[5689][089])|(?:1[0-257-9]|[6-9]\\d)\\d|2(?:[0-4]\\d|[5-9][089])|3(?:[02-8][089]|[19]\\d)|4\\d[089]|5(?:[0-367][089]|[4589]\\d))|7(?:0(?:0[02-9]|[13-6][089]|[289]\\d|7[89])|[1-9]\\d{2})|8(?:[0-79]\\d{2}|8(?:[089]\\d|11|7[02-9]))|9(?:[089]\\d{2}|313|7(?:[02-8]\\d|9[07-9])))|8(?:0(?:[01589]\\d{2}|6[67]\\d|7(?:[02-8]\\d|9[05-9]))|1(?:[02-57-9]\\d{2}|1(?:[0-35-9]\\d|4[0-46-9])|6(?:[089]\\d|7[02-8]))|2(?:0(?:[089]\\d|7[02])|[14](?:[089]\\d|7[02-8])|[235-9]\\d{2})|3(?:[0357-9]\\d{2}|1(?:[089]\\d|7[02-6])|2(?:[09]\\d|77|8[0-689])|4(?:0[1-7]|[1-9]\\d)|6(?:[089]\\d|7[02-7]))|[45]\\d{3}|6(?:[02457-9]\\d{2}|1(?:[089]\\d|7[02-8])|3(?:[089]\\d|7[02-8])|6(?:[08]\\d|7[02-8]|9\\d))|7(?:0[07-9]\\d|[1-69]\\d{2}|[78](?:[089]\\d|7[02-8]))|8(?:[0-25-9]\\d{2}|3(?:[089]\\d|7[02-8])|4(?:[0489]\\d|7[02-68]))|9(?:[02-9]\\d{2}|1(?:[0289]\\d|7[2-6])))|9\\d{4})\\d{5}", 
, , , "8123456789", , , [10]], [, , "00800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))", , , , "1800123456"], [, , "186[12]\\d{9}", , , , "1861123456789", , , [13]], [, , "1860\\d{7}", , , , "18603451234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IN", 91, "00", "0", , , "0", , , , [[, "(\\d{5})(\\d{5})", "$1 $2", ["600|7(?:[02-8]|19|9[037-9])|8(?:0[015-9]|[1-9])|9", "600|7(?:[078]|19[0-5]|2(?:[02356-9]|[14][017-9]|9[389])|3(?:[025-9]|1[07-9]|[34][017-9])|4(?:[0-35689]|[47][017-9])|5(?:[02346-9]|1[017-9]|5[017-9])|6(?:[02-9]|1[0-257-9])|9(?:[089]|31|7[02-9]))|8(?:0(?:[01589]|6[67]|7[02-9])|1(?:[0-57-9]|6[07-9])|2(?:0[07-9]|[14][07-9]|[235-9])|3(?:[03-57-9]|[126][07-9])|[45]|6(?:[02457-9]|[136][07-9])|7(?:[078][07-9]|[1-69])|8(?:[0-25-9]|3[07-9]|4[047-9])|9(?:[02-9]|1[027-9]))|9", 
"600|7(?:0|19[0-5]|2(?:[0235679]|[14][017-9]|8(?:[0-569]|[78][089])|9[389])|3(?:[05-8]|1(?:[089]|7[5-9])|2(?:[5-8]|[0-49][089])|3[017-9]|4(?:[07-9]|11)|9(?:[01689]|[2345][089]|40|7[0189]))|4(?:[056]|1(?:[0135-9]|[23][089]|2[089]|4[089])|2(?:0[089]|[1-7][089]|[89])|3(?:[0-8][089]|9)|4(?:[089]|11|7[02-8])|7(?:[089]|11|7[02-8])|8(?:[0-24-7][089]|[389])|9(?:[0-7][089]|[89]))|5(?:[0346-9]|1[017-9]|2(?:[03-9]|[12][089])|5[017-9])|6(?:[0346-9]|1[0-257-9]|2(?:[0-4]\\d|[5-9][089])|5(?:[0-367][089]|[4589]))|7(?:0(?:[02-9]|1[089])|[1-9])|8(?:[0-79]|8(?:0[0189]|11|8[013-9]|9))|9(?:[089]|313|7(?:[02-8]|9[07-9])))|8(?:0(?:[01589]|6[67]|7(?:[02-8]|9[05-9]))|1(?:[02-57-9]|1(?:[0-35-9]|4[0-46-9])|6(?:[089]|7[02-8]))|2(?:0(?:[089]|7[02])|[14](?:[089]|7[02-8])|[235-9])|3(?:[0357-9]|1(?:[089]|7[02-6])|2(?:[09]|77|8[0-689])|4(?:0[1-7]|[1-9])|6(?:[089]|7[02-7]))|[45]|6(?:[02457-9]|1(?:[089]|7[02-8])|3(?:[089]|7[02-8])|6(?:[08]|7[02-8]|9\\d))|7(?:0[07-9]|[1-69]|7(?:[089]|7[02-8])|8(?:[089]|7[02-8]))|8(?:[0-25-9]|3(?:[089]|7[02-8])|4(?:[0489]|7[02-68]))|9(?:[02-9]|1(?:[0289]|7[2-6])))|9"], 
"0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-9]|80[2-46]"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[59][14]|7[1257]|[68][1-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|[36][25]|22|4[28]|5[12]|[78]1|9[15])|6(?:12|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)"], 
"0$1", , 1], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[23579]|[468][1-9])|[2-8]"], "0$1", , 1], [, "(\\d{2})(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3 $4", ["008"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], "$1", , 1], [, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["160", "1600"], "$1", , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], "$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["180", "1800"], "$1", , 1], [, "(\\d{4})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["186", 
"1860"], "$1", , 1], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18[06]"], "$1", , 1]], , [, , , , , , , , , [-1]], , , [, , "00800\\d{7}|1(?:600\\d{6}|8(?:0(?:0\\d{4,9}|3\\d{9})|6(?:0\\d{7}|[12]\\d{9})))", , , , "1800123456"], [, , "140\\d{7}", , , , "1409305260", , , [10]], 1, , [, , , , , , , , , [-1]]], IO:[, [, , "3\\d{6}", , , , , , , [7]], [, , "37\\d{5}", , , , "3709100"], [, , "38\\d{5}", , , , "3801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , 
[-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IO", 246, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], IQ:[, [, , "[1-7]\\d{7,9}", , , , , , , [8, 9, 10], [6, 7]], [, , "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", , , , "12345678", , , [8, 9], [6, 7]], [, , "7[3-9]\\d{8}", , , , "7912345678", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , 
[-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IQ", 964, "00", "0", , , "0", , , , [[, "(1)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "([2-6]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], [, "(7\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], IR:[, [, , "[1-8]\\d{5,9}|9(?:[0-4]\\d{8}|9\\d{8})", , , , , , , [6, 7, 10], [4, 5, 
8]], [, , "(?:(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:\\d{8}|(?:[16]|[289]\\d?)\\d{3}))|94(?:000|11[1-7]|2\\d{2}|440)\\d{5}", , , , "2123456789", , , , [4, 5, 8]], [, , "9(?:0[1-3]\\d{2}|[1-3]\\d{3}|9(?:0\\d{2}|44\\d|810|9(?:00|11|9[89])))\\d{5}", , , , "9123456789", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:[2-6]0\\d|993)\\d{7}", , , , "9932123456", , , [10]], "IR", 98, "00", "0", , , "0", 
, , , [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"], [, "(\\d{2})(\\d{4,5})", "$1 $2", ["[1-8]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"]], , [, , "943\\d{7}", , , , "9432123456", , , [10]], , , [, , "(?:9411[1-7]|94440)\\d{5}", , , , "9411110000", , , [10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], IS:[, [, , "[4-9]\\d{6}|38\\d{7}", , , , , , , [7, 9]], [, , "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-245]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-79]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|87[23])\\d{4}", 
, , , "4101234", , , [7]], [, , "38[589]\\d{6}|(?:6(?:1[1-8]|2[0-6]|3[027-9]|4[014679]|5[0159]|[67][0-69]|9\\d)|7(?:5[057]|[6-8]\\d)|8(?:2[0-59]|3[0-4]|[469]\\d|5[1-9]|88))\\d{4}", , , , "6111234"], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , "90\\d{5}", , , , "9011234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "49\\d{5}", , , , "4921234", , , [7]], "IS", 354, "1(?:0(?:01|10|20)|100)|00", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], [, "(3\\d{2})(\\d{3})(\\d{3})", 
"$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "809\\d{4}", , , , "8091234", , , [7]], , , [, , "(?:6(?:2[78]|49|8\\d)|8(?:7[0189]|80)|95[48])\\d{4}", , , , "6271234", , , [7]]], IT:[, [, , "[01589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9})", , , , , , , [6, 7, 8, 9, 10, 11]], [, , "0(?:[26]\\d{4,9}|(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2346]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[34578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7})", 
, , , "0212345678"], [, , "3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})", , , , "3123456789", , , [9, 10, 11]], [, , "80(?:0\\d{6}|3\\d{3})", , , , "800123456", , , [6, 9]], [, , "0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{6}|[17]\\d{3})", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], 
"IT", 39, "00", , , , , , , , [[, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|55"]], [, "(0[26])(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [, "(0[26])(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(0\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[245])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]], [, "(0\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["0[13-57-9][2-46-8]"]], [, "(0\\d{3})(\\d{2,6})", "$1 $2", ["0[13-57-9][2-46-8]"]], 
[, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13]|8(?:00|4[08]|9[59])", "[13]|8(?:00|4[08]|9(?:5[5-9]|9))"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["894", "894[5-9]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], 1, , [, , "848\\d{6}", , , , "848123456", , , [9]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]]], JE:[, [, , "[135789]\\d{6,9}", , , , , , , [10], [6]], [, , "1534[0-24-8]\\d{5}", , , , "1534456789", , , , [6]], [, , "7(?:509\\d|7(?:00[378]|97[7-9])|829\\d|937\\d)\\d{5}", 
, , , "7797712345"], [, , "80(?:07(?:35|81)|8901)\\d{4}", , , , "8007354567"], [, , "(?:871206|90(?:066[59]|1810|71(?:07|55)))\\d{4}", , , , "9018105678"], [, , "8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|70002)\\d{4}", , , , "8447034567"], [, , "701511\\d{4}", , , , "7015115678"], [, , "56\\d{8}", , , , "5612345678"], "JE", 44, "00", "0", " x", , "0", , , , , , [, , "76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}", , , , "7640123456"], , , [, , , , , , , , , [-1]], [, , "3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))\\d{4}|55\\d{8}", 
, , , "5512345678"], , , [, , , , , , , , , [-1]]], JM:[, [, , "[589]\\d{9}", , , , , , , [10], [7]], [, , "876(?:5(?:0[12]|1[0-468]|2[35]|63)|6(?:0[1-3579]|1[027-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468]))\\d{4}", , , , "8765123456", , , , [7]], [, , "876(?:2[14-9]\\d|[348]\\d{2}|5(?:0[3-9]|[2-57-9]\\d|6[0-24-9])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579]))\\d{4}", , , , "8762101234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", 
, , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "JM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "876", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], JO:[, [, , "[235-9]\\d{7,8}", , , , , , , [8, 9]], [, , "(?:2(?:6(?:2[0-35-9]|3[0-57-8]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[57][023]|6[03])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2[50]0|3(?:00|33)|4(?:0[0125]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[17-8]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[02-39]))|87(?:[02]0|7[08]|90))\\d{4}", 
, , , "62001234", , , [8]], [, , "7(?:55|7[025-9]|8[0-25-9]|9[0-25-9])\\d{6}", , , , "790123456", , , [9]], [, , "80\\d{6}", , , , "80012345", , , [8]], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , "85\\d{6}", , , , "85012345", , , [8]], [, , "70\\d{7}", , , , "700123456", , , [9]], [, , , , , , , , , [-1]], "JO", 962, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], [, "(7)(\\d{4})(\\d{4})", "$1 $2 $3", ["7[457-9]"], "0$1"], [, "(\\d{2})(\\d{7})", 
"$1 $2", ["70"], "0$1"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["8[0158]|9"], "0$1"]], , [, , "74(?:66|77)\\d{5}", , , , "746612345", , , [9]], , , [, , , , , , , , , [-1]], [, , "8(?:10|8\\d)\\d{5}", , , , "88101234", , , [8]], , , [, , , , , , , , , [-1]]], JP:[, [, , "[1-9]\\d{8,9}|00(?:[36]\\d{7,14}|7\\d{5,7}|8\\d{7})", , , , , , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|2[2-9]\\d|[36][1-9]\\d|4(?:6[02-8]|[2-578]\\d|9[2-59])|5(?:6[1-9]|7[2-8]|[2-589]\\d)|7(?:3[4-9]|4[02-9]|[25-9]\\d)|8(?:3[2-9]|4[5-9]|5[1-9]|8[03-9]|[2679]\\d)|9(?:[679][1-9]|[2-58]\\d))\\d{6}", 
, , , "312345678", , , [9]], [, , "[7-9]0[1-9]\\d{7}", , , , "9012345678", , , [10]], [, , "120\\d{6}|800\\d{7}|00(?:37\\d{6,13}|66\\d{6,13}|777(?:[01]\\d{2}|5\\d{3}|8\\d{4})|882[1245]\\d{4})", , , , "120123456"], [, , "990\\d{6}", , , , "990123456", , , [9]], [, , , , , , , , , [-1]], [, , "60\\d{7}", , , , "601234567", , , [9]], [, , "50[1-9]\\d{7}", , , , "5012345678", , , [10]], "JP", 81, "010", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", 
"$1-$2-$3", ["800"], "0$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["0077"], "$1"], [, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["0077"], "$1"], [, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["0088"], "$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["00(?:37|66)"], "$1"], [, "(\\d{4})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["00(?:37|66)"], "$1"], [, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["00(?:37|66)"], "$1"], [, "(\\d{4})(\\d{6})(\\d{6,7})", "$1-$2-$3", ["00(?:37|66)"], "$1"], [, "(\\d{2})(\\d{4})(\\d{4})", 
"$1-$2-$3", ["[2579]0|80[1-9]"], "0$1"], [, "(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|5(?:76|97)|499|746|8(?:3[89]|63|47|51)|9(?:49|80|9[16])", "1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:76|97)9|499[2468]|7468|8(?:3(?:8[78]|96)|636|477|51[24])|9(?:496|802|9(?:1[23]|69))", "1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:769|979[2-69])|499[2468]|7468|8(?:3(?:8[78]|96[2457-9])|636[2-57-9]|477|51[24])|9(?:496|802|9(?:1[23]|69))"], 
"0$1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])", "1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:7[2-6]|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|[4-7]))", 
"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6[56]))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))", 
"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6(?:5[25]|60)))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"], 
"0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5(?:[2-589]|39)|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93)", "1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93[34])", "1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93(?:31|4))"], 
"0$1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["2(?:9[14-79]|74|[34]7|[56]9)|82|993"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2479][1-9]"], "0$1"]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[2579]0|80[1-9]"], "0$1"], [, "(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|5(?:76|97)|499|746|8(?:3[89]|63|47|51)|9(?:49|80|9[16])", 
"1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:76|97)9|499[2468]|7468|8(?:3(?:8[78]|96)|636|477|51[24])|9(?:496|802|9(?:1[23]|69))", "1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:769|979[2-69])|499[2468]|7468|8(?:3(?:8[78]|96[2457-9])|636[2-57-9]|477|51[24])|9(?:496|802|9(?:1[23]|69))"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])", 
"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:7[2-6]|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|[4-7]))", 
"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6[56]))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))", 
"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6(?:5[25]|60)))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"], 
"0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5(?:[2-589]|39)|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93)", "1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93[34])", "1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93(?:31|4))"], 
"0$1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["2(?:9[14-79]|74|[34]7|[56]9)|82|993"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2479][1-9]"], "0$1"]], [, , "20\\d{8}", , , , "2012345678", , , [10]], , , [, , "00(?:37\\d{6,13}|66\\d{6,13}|777(?:[01]\\d{2}|5\\d{3}|8\\d{4})|882[1245]\\d{4})", , , , "00777012"], [, , "570\\d{6}", , , , "570123456", , , [9]], 1, , [, , , , , , , , , [-1]]], KE:[, [, , "20\\d{6,7}|[4-9]\\d{6,9}", 
, , , , , , [7, 8, 9, 10]], [, , "20\\d{6,7}|4(?:0\\d{6,7}|[136]\\d{7}|[245]\\d{5,7})|5(?:[08]\\d{7}|[1-79]\\d{5,7})|6(?:[01457-9]\\d{5,7}|2\\d{7}|6\\d{6,7})", , , , "202012345", , , [7, 8, 9]], [, , "7(?:[0-3679]\\d|4[0-479]|5[0-6]|8[0-25-9])\\d{6}", , , , "712123456", , , [9]], [, , "800[24-8]\\d{5,6}", , , , "800223456", , , [9, 10]], [, , "900[02-9]\\d{5}", , , , "900223456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KE", 254, "000", "0", , , "005|0", 
, , , [[, "(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KG:[, [, , "[235-8]\\d{8,9}", , , , , , , [9, 10], [5, 6]], [, , "(?:3(?:1(?:[256]\\d|3[1-9]|47)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", 
, , , "312123456", , , [9], [5, 6]], [, , "(?:20[0-35]|5[124-7]\\d|7[07]\\d)\\d{6}", , , , "700123456", , , [9]], [, , "800\\d{6,7}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KG", 996, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[25-7]|31[25]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[36]|[2-9])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d)(\\d{3})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , 
, , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KH:[, [, , "[1-9]\\d{7,9}", , , , , , , [8, 9, 10], [6, 7]], [, , "(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:[237-9]|4[56]|5\\d|6\\d?)\\d{5}|23(?:4[234]|8\\d{2})\\d{4}", , , , "23756789", , , [8, 9], [6, 7]], [, , "(?:1(?:[013-79]\\d|[28]\\d{1,2})|2[3-6]48|3(?:[18]\\d{2}|[2-6]48)|4[2-4]48|5[2-5]48|6(?:[016-9]\\d|[2-5]48)|7(?:[07-9]\\d|[16]\\d{2}|[2-5]48)|8(?:[013-79]\\d|8\\d{2})|9(?:6\\d{2}|7\\d{1,2}|[0-589]\\d))\\d{5}", 
, , , "91234567", , , [8, 9]], [, , "1800(?:1\\d|2[019])\\d{4}", , , , "1800123456", , , [10]], [, , "1900(?:1\\d|2[09])\\d{4}", , , , "1900123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KH", 855, "00[14-9]", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1\\d[1-9]|[2-9]"], "0$1"], [, "(1[89]00)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[89]0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , 
[, , , , , , , , , [-1]]], KI:[, [, , "[2458]\\d{4}|3\\d{4,7}|7\\d{7}", , , , , , , [5, 8]], [, , "(?:[24]\\d|3[1-9]|50|8[0-5])\\d{3}|7(?:27|31|5[0-4])\\d{5}", , , , "31234"], [, , "7[23]0\\d{5}", , , , "72012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "30(?:0[01]\\d{2}|12(?:11|20))\\d{2}", , , , "30010000", , , [8]], "KI", 686, "00", , , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , 
, , , , , , [-1]], , , [, , , , , , , , , [-1]]], KM:[, [, , "[3478]\\d{6}", , , , , , , [7]], [, , "7[4-7]\\d{5}", , , , "7712345"], [, , "[34]\\d{6}", , , , "3212345"], [, , , , , , , , , [-1]], [, , "(?:39[01]|8\\d{2})\\d{4}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KM", 269, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , 
, , , , [-1]]], KN:[, [, , "[589]\\d{9}", , , , , , , [10], [7]], [, , "869(?:2(?:29|36)|302|4(?:6[015-9]|70))\\d{4}", , , , "8692361234", , , , [7]], [, , "869(?:5(?:5[6-8]|6[5-7])|66\\d|76[02-7])\\d{4}", , , , "8697652917", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "KN", 1, "011", "1", , , "1", , , , 
, , [, , , , , , , , , [-1]], , "869", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KP:[, [, , "1\\d{9}|[28]\\d{7}", , , , , , , [8, 10], [6, 7]], [, , "2\\d{7}|85\\d{6}", , , , "21234567", , , [8], [6, 7]], [, , "19[123]\\d{7}", , , , "1921234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KP", 850, "00|99", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{4})", 
"$1 $2 $3", ["1"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "2(?:[0-24-9]\\d{2}|3(?:[0-79]\\d|8[02-9]))\\d{4}", , , , "23821234", , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KR:[, [, , "007\\d{9,11}|[1-7]\\d{3,9}|8\\d{8}", , , , , , , [4, 5, 6, 8, 9, 10, 12, 13, 14], [3, 7]], [, , "(?:2|3[1-3]|[46][1-4]|5[1-5])(?:1\\d{2,3}|[1-9]\\d{6,7})", , , , "22123456", 
, , [4, 5, 6, 8, 9, 10], [3, 7]], [, , "1[0-26-9]\\d{7,8}", , , , "1000000000", , , [9, 10]], [, , "(?:00798\\d{0,2}|80)\\d{7}", , , , "801234567", , , [9, 12, 13, 14]], [, , "60[2-9]\\d{6}", , , , "602345678", , , [9]], [, , , , , , , , , [-1]], [, , "50\\d{8}", , , , "5012345678", , , [10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "KR", 82, "00(?:[124-68]|3\\d{2}|7(?:[0-8]\\d|9[0-79]))", "0", , , "0(8[1-46-8]|85\\d{2})?", , , , [[, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["00798"], "$1", 
"0$CC-$1"], [, "(\\d{5})(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["00798"], "$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["1(?:0|1[19]|[69]9|5[458])|[57]0", "1(?:0|1[19]|[69]9|5(?:44|59|8))|[57]0"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["1(?:[01]|5[1-4]|6[2-8]|[7-9])|[68]0|[3-6][1-9][1-9]", "1(?:[01]|5(?:[1-3]|4[56])|6[2-8]|[7-9])|[68]0|[3-6][1-9][1-9]"], "0$1", "0$CC-$1"], [, "(\\d{3})(\\d)(\\d{4})", "$1-$2-$3", ["131", "1312"], "0$1", "0$CC-$1"], [, "(\\d{3})(\\d{2})(\\d{4})", 
"$1-$2-$3", ["131", "131[13-9]"], "0$1", "0$CC-$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["13[2-9]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3-$4", ["30"], "0$1", "0$CC-$1"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2[1-9]"], "0$1", "0$CC-$1"], [, "(\\d)(\\d{3,4})", "$1-$2", ["21[0-46-9]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})", "$1-$2", ["[3-6][1-9]1", "[3-6][1-9]1(?:[0-46-9])"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1(?:5[246-9]|6[04678]|8[03579])", 
"1(?:5(?:22|44|66|77|88|99)|6(?:00|44|6[16]|70|88)|8(?:00|33|55|77|99))"], "$1", "0$CC-$1"]], [[, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["1(?:0|1[19]|[69]9|5[458])|[57]0", "1(?:0|1[19]|[69]9|5(?:44|59|8))|[57]0"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["1(?:[01]|5[1-4]|6[2-8]|[7-9])|[68]0|[3-6][1-9][1-9]", "1(?:[01]|5(?:[1-3]|4[56])|6[2-8]|[7-9])|[68]0|[3-6][1-9][1-9]"], "0$1", "0$CC-$1"], [, "(\\d{3})(\\d)(\\d{4})", "$1-$2-$3", ["131", "1312"], "0$1", "0$CC-$1"], [, "(\\d{3})(\\d{2})(\\d{4})", 
"$1-$2-$3", ["131", "131[13-9]"], "0$1", "0$CC-$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["13[2-9]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3-$4", ["30"], "0$1", "0$CC-$1"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2[1-9]"], "0$1", "0$CC-$1"], [, "(\\d)(\\d{3,4})", "$1-$2", ["21[0-46-9]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})", "$1-$2", ["[3-6][1-9]1", "[3-6][1-9]1(?:[0-46-9])"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1(?:5[246-9]|6[04678]|8[03579])", 
"1(?:5(?:22|44|66|77|88|99)|6(?:00|44|6[16]|70|88)|8(?:00|33|55|77|99))"], "$1", "0$CC-$1"]], [, , "15\\d{7,8}", , , , "1523456789", , , [9, 10]], , , [, , "00798\\d{7,9}", , , , "007981234567", , , [12, 13, 14]], [, , "1(?:5(?:22|44|66|77|88|99)|6(?:00|44|6[16]|70|88)|8(?:00|33|55|77|99))\\d{4}", , , , "15441234", , , [8]], 1, , [, , , , , , , , , [-1]]], KW:[, [, , "[12569]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:18\\d|2(?:[23]\\d{2}|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7])))\\d{4}", 
, , , "22345678"], [, , "(?:5(?:[05]\\d{2}|1[0-7]\\d|2(?:22|5[25])|6[56]\\d)|6(?:0[034679]\\d|222|5[015-9]\\d|6\\d{2}|7[067]\\d|9[0369]\\d)|9(?:0[09]\\d|22\\d|4[01479]\\d|55\\d|6[0679]\\d|[79]\\d{2}|8[057-9]\\d))\\d{4}", , , , "50012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KW", 965, "00", , , , , , , , [[, "(\\d{4})(\\d{3,4})", "$1 $2", ["[16]|2(?:[0-35-9]|4[0-35-9])|9[024-9]|52[25]"]], [, "(\\d{3})(\\d{5})", 
"$1 $2", ["244|5(?:[015]|6[56])"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KY:[, [, , "[3589]\\d{9}", , , , , , , [10], [7]], [, , "345(?:2(?:22|44)|444|6(?:23|38|40)|7(?:4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}", , , , "3452221234", , , , [7]], [, , "345(?:32[1-9]|5(?:1[67]|2[5-7]|4[6-8]|76)|9(?:1[67]|2[2-9]|3[689]))\\d{4}", , , , "3453231234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", 
, , , "8002345678"], [, , "900[2-9]\\d{6}|345976\\d{4}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "KY", 1, "011", "1", , , "1", , , , , , [, , "345849\\d{4}", , , , "3458491234"], , "345", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KZ:[, [, , "(?:33\\d|7\\d{2}|80[09])\\d{7}", , , , , , , [10]], [, , "33622\\d{5}|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[234]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[234]\\d|5[139])|4(?:2\\d|3[1235-9]|59)|5(?:[23]\\d|4[01246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59)))\\d{5}", 
, , , "7123456789"], [, , "7(?:0[012578]|47|6[02-4]|7[15-8]|85)\\d{7}", , , , "7710009998"], [, , "800\\d{7}", , , , "8001234567"], [, , "809\\d{7}", , , , "8091234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "751\\d{7}", , , , "7511234567"], "KZ", 7, "810", "8", , , "8", , "8~10", , , , [, , , , , , , , , [-1]], , , [, , "751\\d{7}", , , , "7511234567"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LA:[, [, , "[2-8]\\d{7,9}", , , , , , , [8, 9, 10], [6]], [, , "(?:2[13]|3(?:0\\d|[14])|[5-7][14]|41|8[1468])\\d{6}", 
, , , "21212862", , , [8, 9], [6]], [, , "20(?:2[2389]|5[24-689]|7[6-8]|9[15-9])\\d{6}", , , , "2023123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LA", 856, "00", "0", , , "0", , , , [[, "(20)(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["20"], "0$1"], [, "([2-8]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], [, "(30)(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30"], "0$1"]], , [, 
, , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LB:[, [, , "[13-9]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:[14-6]\\d{2}|7(?:[2-57]\\d|62|8[0-7]|9[04-9])|8[02-9]\\d|9\\d{2})\\d{4}", , , , "1123456", , , [7]], [, , "(?:3\\d|7(?:[01]\\d|6[013-9]|8[89]|9[1-3])|81\\d)\\d{5}", , , , "71123456"], [, , , , , , , , , [-1]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , "80\\d{6}", , , , "80123456", , , [8]], [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], "LB", 961, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-6]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]|9"], "0$1"], [, "([7-9]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[89][01]|7(?:[01]|6[013-9]|8[89]|9[1-3])"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LC:[, [, , "[5789]\\d{9}", , , , , , , [10], [7]], [, , "758(?:4(?:30|5[0-9]|6[2-9]|8[0-2])|57[0-2]|638)\\d{4}", , , , "7584305678", 
, , , [7]], [, , "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2[0-8]))\\d{4}", , , , "7582845678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "LC", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "758", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , 
, , , , [-1]]], LI:[, [, , "6\\d{8}|[23789]\\d{6}", , , , , , , [7, 9]], [, , "(?:2(?:01|1[27]|3\\d|6[02-578]|96)|3(?:7[0135-7]|8[048]|9[0269]))\\d{4}", , , , "2345678", , , [7]], [, , "6(?:5(?:09|1\\d|20)|6(?:0[0-6]|10|2[06-9]|39))\\d{5}|7(?:[37-9]\\d|42|56)\\d{4}", , , , "660234567"], [, , "80(?:02[28]|9\\d{2})\\d{2}", , , , "8002222", , , [7]], [, , "90(?:02[258]|1(?:23|3[14])|66[136])\\d{2}", , , , "9002222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
"LI", 423, "00", "0", , , "0|10(?:01|20|66)", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[23789]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[56]"]], [, "(69)(7\\d{2})(\\d{4})", "$1 $2 $3", ["697"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "870(?:28|87)\\d{2}", , , , "8702812", , , [7]], , , [, , "697(?:42|56|[78]\\d)\\d{4}", , , , "697861234", , , [9]]], LK:[, [, , "[1-9]\\d{8}", , , , , , , [9], [7]], [, , "(?:[189]1|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}", 
, , , "112345678", , , , [7]], [, , "7[0125-8]\\d{7}", , , , "712345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LK", 94, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{1})(\\d{6})", "$1 $2 $3", ["[1-689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LR:[, [, , "2\\d{7,8}|[378]\\d{8}|4\\d{6}|5\\d{6,8}", 
, , , , , , [7, 8, 9]], [, , "(?:2\\d{3}|33333)\\d{4}", , , , "21234567", , , [8, 9]], [, , "(?:20\\d{2}|330\\d|4[67]|5(?:55)?\\d|77\\d{2}|88\\d{2})\\d{5}", , , , "770123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "332(?:02|[2-5]\\d)\\d{4}", , , , "332021234", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LR", 231, "00", "0", , , "0", , , , [[, "(2\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "([4-5])(\\d{3})(\\d{3})", "$1 $2 $3", ["[45]"], 
"0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LS:[, [, , "[2568]\\d{7}", , , , , , , [8]], [, , "2\\d{7}", , , , "22123456"], [, , "[56]\\d{7}", , , , "50123456"], [, , "800[256]\\d{4}", , , , "80021234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LS", 266, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", 
"$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LT:[, [, , "[3-9]\\d{7}", , , , , , , [8]], [, , "(?:3[1478]|4[124-6]|52)\\d{6}", , , , "31234567"], [, , "6\\d{7}", , , , "61234567"], [, , "800\\d{5}", , , , "80012345"], [, , "9(?:0[0239]|10)\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [, , "700\\d{5}", , , , "70012345"], [, , , , , , , , , [-1]], "LT", 370, "00", "8", , , "[08]", , , , [[, "([34]\\d)(\\d{6})", 
"$1 $2", ["37|4(?:1|5[45]|6[2-4])"], "(8-$1)", , 1], [, "([3-6]\\d{2})(\\d{5})", "$1 $2", ["3[148]|4(?:[24]|6[09])|528|6"], "(8-$1)", , 1], [, "([7-9]\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", , 1], [, "(5)(2\\d{2})(\\d{4})", "$1 $2 $3", ["52[0-79]"], "(8-$1)", , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "70[67]\\d{5}", , , , "70712345"], , , [, , , , , , , , , [-1]]], LU:[, [, , "[24-9]\\d{3,10}|3(?:[0-46-9]\\d{2,9}|5[013-9]\\d{1,8})", , , , , , , [4, 5, 6, 
7, 8, 9, 10, 11]], [, , "(?:2[2-9]\\d{2,9}|(?:[3457]\\d{2}|8(?:0[2-9]|[13-9]\\d)|9(?:0[89]|[2-579]\\d))\\d{1,8})", , , , "27123456"], [, , "6[25-79][18]\\d{6}", , , , "628123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90[015]\\d{5}", , , , "90012345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , "70\\d{6}", , , , "70123456", , , [8]], [, , "20(?:1\\d{5}|[2-689]\\d{1,7})", , , , "20201234", , , [4, 5, 6, 7, 8, 9, 10]], "LU", 352, "00", , , , "(15(?:0[06]|1[12]|35|4[04]|55|6[26]|77|88|99)\\d)", 
, , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["[2-5]|7[1-9]|[89](?:[1-9]|0[2-9])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-5]|7[1-9]|[89](?:[1-9]|0[2-9])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"], 
, "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,4})", "$1 $2 $3 $4", ["2(?:[12589]|4[12])|[3-5]|7[1-9]|8(?:[1-9]|0[2-9])|9(?:[1-9]|0[2-46-9])"], , "$CC $1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["70|80[01]|90[015]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LV:[, [, , "[2689]\\d{7}", , , , , , , [8]], [, , "6\\d{7}", , , , "63123456"], [, , 
"2\\d{7}", , , , "21234567"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , "81\\d{6}", , , , "81123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LV", 371, "00", , , , , , , , [[, "([2689]\\d)(\\d{3})(\\d{3})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LY:[, [, , "[25679]\\d{8}", , , , , , , [9], [7]], [, , "(?:2[1345]|5[1347]|6[123479]|71)\\d{7}", , , , "212345678", 
, , , [7]], [, , "9[1-6]\\d{7}", , , , "912345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LY", 218, "00", "0", , , "0", , , , [[, "([25679]\\d)(\\d{7})", "$1-$2", , "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MA:[, [, , "[5-9]\\d{8}", , , , , , , [9]], [, , "5(?:2(?:[015-79]\\d|2[02-9]|3[2-57]|4[2-8]|8[235-7])\\d|3(?:[0-48]\\d|[57][2-9]|6[2-8]|9[3-9])\\d|4[067]\\d{2}|5[03]\\d{2})\\d{4}", 
, , , "520123456"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[07][07]|6[12]))\\d{6}", , , , "650123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5924[01]\\d{4}", , , , "592401234"], "MA", 212, "00", "0", , , "0", , , , [[, "([5-7]\\d{2})(\\d{6})", "$1-$2", ["5(?:2[015-7]|3[0-4])|[67]"], "0$1"], [, "([58]\\d{3})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|92)|892", "5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"], 
"0$1"], [, "(5\\d{4})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29|38)[89]"], "0$1"], [, "([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:4[067]|5[03])"], "0$1"], [, "(8[09])(\\d{7})", "$1-$2", ["8(?:0|9[013-9])"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MC:[, [, , "[34689]\\d{7,8}", , , , , , , [8, 9]], [, , "870\\d{5}|9[2-47-9]\\d{6}", , , , "99123456", , , [8]], [, , "3\\d{7}|4(?:4\\d|5[1-9])\\d{5}|6\\d{8}", 
, , , "612345678"], [, , "90\\d{6}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MC", 377, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[39]"], "$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(6)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["8"], "$1"]], , [, , , , , , , , , [-1]], , , 
[, , "870\\d{5}", , , , "87012345", , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MD:[, [, , "[235-9]\\d{7}", , , , , , , [8]], [, , "(?:2[1-9]\\d|3[1-79]\\d|5(?:33|5[257]))\\d{5}", , , , "22212345"], [, , "(?:562|6\\d{2}|7(?:[189]\\d|6[07]|7[457-9]))\\d{5}", , , , "62112345"], [, , "800\\d{5}", , , , "80012345"], [, , "90[056]\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [, , , , , , , , , [-1]], [, , "3[08]\\d{6}", , , , "30123456"], "MD", 373, "00", "0", 
, , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], [, "([25-7]\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["2[13-9]|[5-7]"], "0$1"], [, "([89]\\d{2})(\\d{5})", "$1 $2", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "803\\d{5}", , , , "80312345"], , , [, , , , , , , , , [-1]]], ME:[, [, , "[2-9]\\d{7,8}", , , , , , , [8], [6]], [, , "(?:20[2-8]|3(?:0[2-7]|[12][235-7]|3[24-7])|4(?:0[2-467]|1[267])|5(?:0[2467]|1[267]|2[2367]))\\d{5}", , , , "30234567", 
, , , [6]], [, , "6(?:00\\d|3[024]\\d|6[0-25]\\d|[7-9]\\d{2})\\d{4}", , , , "67622901"], [, , "80[0-258]\\d{5}", , , , "80080002"], [, , "(?:9(?:4[1568]|5[178]))\\d{5}", , , , "94515151"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "78[1-49]\\d{5}", , , , "78108780"], "ME", 382, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]|6[036-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "77[1-9]\\d{5}", , , , "77273012"], , , [, 
, , , , , , , , [-1]]], MF:[, [, , "[56]\\d{8}", , , , , , , [9]], [, , "590(?:[02][79]|13|5[0-268]|[78]7)\\d{4}", , , , "590271234"], [, , "690(?:0[05-9]|[1-9]\\d)\\d{4}", , , , "690001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MF", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MG:[, [, , "[23]\\d{8}", 
, , , , , , [9], [7]], [, , "20(?:2\\d{2}|4[47]\\d|5[3467]\\d|6[279]\\d|7(?:2[29]|[35]\\d)|8[268]\\d|9[245]\\d)\\d{4}", , , , "202123456", , , , [7]], [, , "3[2-49]\\d{7}", , , , "321234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "22\\d{7}", , , , "221234567"], "MG", 261, "00", "0", , , "0", , , , [[, "([23]\\d)(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", , "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , 
, , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MH:[, [, , "[2-6]\\d{6}", , , , , , , [7]], [, , "(?:247|528|625)\\d{4}", , , , "2471234"], [, , "(?:235|329|45[56]|545)\\d{4}", , , , "2351234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "635\\d{4}", , , , "6351234"], "MH", 692, "011", "1", , , "1", , , , [[, "(\\d{3})(\\d{4})", "$1-$2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, 
, , , , , , , , [-1]]], MK:[, [, , "[2-578]\\d{7}", , , , , , , [8], [6, 7]], [, , "(?:2(?:[23]\\d|5[124578]|6[01])|3(?:1[3-6]|[23][2-6]|4[2356])|4(?:[23][2-6]|4[3-6]|5[256]|6[25-8]|7[24-6]|8[4-6]))\\d{5}", , , , "22212345", , , , [6, 7]], [, , "7(?:[0-25-8]\\d{2}|32\\d|421|9[23]\\d)\\d{4}", , , , "72345678"], [, , "800\\d{5}", , , , "80012345"], [, , "5[02-9]\\d{6}", , , , "50012345"], [, , "8(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "80123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MK", 
389, "00", "0", , , "0", , , , [[, "(2)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "([347]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], [, "([58]\\d{2})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ML:[, [, , "[246-9]\\d{7}", , , , , , , [8]], [, , "(?:2(?:0(?:2\\d|7[0-8])|1(?:2[5-7]|[3-689]\\d))|44[1239]\\d)\\d{4}", , , , "20212345"], [, , "(?:2(?:079|17\\d)|[679]\\d{3}|8[239]\\d{2})\\d{4}", 
, , , "65012345"], [, , "80\\d{6}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ML", 223, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[246-9]"]], [, "(\\d{4})", "$1", ["67|74"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[246-9]"]]], [, , , , , , , , , [-1]], , , [, , "80\\d{6}", , , , "80012345"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MM:[, [, , "[1478]\\d{5,7}|[256]\\d{5,8}|9(?:[279]\\d{0,2}|[58]|[34]\\d{1,2}|6\\d?)\\d{6}", 
, , , , , , [6, 7, 8, 9, 10], [5]], [, , "1(?:2\\d{1,2}|[3-5]\\d|6\\d?|[89][0-6]\\d)\\d{4}|2(?:2(?:000\\d{3}|\\d{4})|3\\d{4}|4(?:0\\d{5}|\\d{4})|5(?:1\\d{3,6}|[02-9]\\d{3,5})|[6-9]\\d{4})|4(?:2[245-8]|3(?:[2-46]|56?)|[46][2-6]|5[3-5])\\d{4}|5(?:2(?:2(?:\\d{1,2})?|[3-8])|3[2-68]|4(?:21?|[4-8])|5[23]|6[2-4]|7[2-8]|8[24-7]|9[2-7])\\d{4}|6(?:0[23]|1(?:2(?:0|4\\d)?|[356])|2[2-6]|3[24-6]|4(?:2(?:4\\d)?|[3-6])|5[2-4]|6[2-8]|7(?:[2367]|4\\d|5\\d?|8[145]\\d)|8[245]|9(?:20?|4))\\d{4}|7(?:[04][24-8]|1(?:20?|[3-7])|22|3[2-4]|5[2-7])\\d{4}|8(?:1(?:2\\d{1,2}|[3-689]\\d)|2(?:2\\d|3(?:\\d|20)|[4-8]\\d)|3[24]\\d|4[24-7]\\d|5[245]\\d|6[23]\\d)\\d{3}", 
, , , "1234567", , , [6, 7, 8, 9], [5]], [, , "17[01]\\d{4}|9(?:2(?:[0-4]|5\\d{2}|6[0-5]\\d)|3(?:[0-36]|4[069])\\d|4(?:0[0-4]\\d|[1379]\\d|2\\d{2}|4[0-589]\\d|5\\d{2}|88)|5[0-6]|61?\\d|7(?:3\\d|[6-9]\\d{2})|8\\d|9(?:1\\d|[5-7]\\d{2}|[089]))\\d{5}", , , , "92123456", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1333\\d{4}", , , , "13331234", , , [8]], "MM", 95, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3,4})", 
"$1 $2 $3", ["1|2[245]"], "0$1"], [, "(2)(\\d{4})(\\d{4})", "$1 $2 $3", ["251"], "0$1"], [, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["67|81"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3,4})", "$1 $2 $3", ["[4-8]"], "0$1"], [, "(9)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], [, "(9)([34]\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:3[0-36]|4[0-57-9])"], "0$1"], [, "(9)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92[56]"], "0$1"], 
[, "(9)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["93"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MN:[, [, , "[12]\\d{7,9}|[57-9]\\d{7}", , , , , , , [8, 9, 10], [6, 7]], [, , "[12](?:1\\d|2(?:[1-3]\\d?|7\\d)|3[2-8]\\d{1,2}|4[2-68]\\d{1,2}|5[1-4689]\\d{1,2})\\d{5}|5[0568]\\d{6}", , , , "50123456", , , , [6, 7]], [, , "(?:8(?:[05689]\\d|3[01])|9[013-9]\\d)\\d{5}", , , , "88123456", , , [8]], [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "7[05-8]\\d{6}", , , , "75123456", , , [8]], "MN", 976, "001", "0", , , "0", , , , [[, "([12]\\d)(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], [, "([12]2\\d)(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], [, "([12]\\d{3})(\\d{5})", "$1 $2", ["[12](?:27|[3-5])", "[12](?:27|[3-5]\\d)2"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[57-9]"], "$1"], [, "([12]\\d{4})(\\d{4,5})", "$1 $2", ["[12](?:27|[3-5])", "[12](?:27|[3-5]\\d)[4-9]"], 
"0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MO:[, [, , "[268]\\d{7}", , , , , , , [8]], [, , "(?:28[2-57-9]|8[2-57-9]\\d)\\d{5}", , , , "28212345"], [, , "6(?:[2356]\\d|8[158])\\d{5}", , , , "66123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MO", 853, "00", , , , , , , , [[, "([268]\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , 
, , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MP:[, [, , "[5689]\\d{9}", , , , , , , [10], [7]], [, , "670(?:2(?:3[3-7]|56|8[5-8])|32[1238]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "670(?:2(?:3[3-7]|56|8[5-8])|32[1238]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], 
[, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "MP", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "670", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MQ:[, [, , "[56]\\d{8}", , , , , , , [9]], [, , "596(?:0[2-5]|[12]0|3[05-9]|4[024-8]|[5-7]\\d|89|9[4-8])\\d{4}", , , , "596301234"], [, , "696(?:[0-47-9]\\d|5[0-6]|6[0-4])\\d{4}", 
, , , "696201234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MQ", 596, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", , "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MR:[, [, , "[2-48]\\d{7}", , , , , , , [8]], [, , "25[08]\\d{5}|35\\d{6}|45[1-7]\\d{5}", , , , "35123456"], [, , "[234][0-46-9]\\d{6}", 
, , , "22123456"], [, , "800\\d{5}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MR", 222, "00", , , , , , , , [[, "([2-48]\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MS:[, [, , "[5689]\\d{9}", , , , , , , [10], [7]], [, , "664491\\d{4}", , , , "6644912345", , , , [7]], [, , "66449[2-6]\\d{4}", , , , 
"6644923456", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "MS", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "664", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MT:[, [, , "[2357-9]\\d{7}", , , , , , , [8]], [, , "2(?:0(?:1[0-6]|3[1-4]|[69]\\d)|[1-357]\\d{2})\\d{4}", 
, , , "21001234"], [, , "(?:7(?:210|[79]\\d{2})|9(?:2(?:1[01]|31)|696|8(?:1[1-3]|89|97)|9\\d{2}))\\d{4}", , , , "96961234"], [, , "800[3467]\\d{4}", , , , "80071234"], [, , "5(?:0(?:0(?:37|43)|6\\d{2}|70\\d|9[0168]\\d)|[12]\\d0[1-5])\\d{3}", , , , "50037123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3550\\d{4}", , , , "35501234"], "MT", 356, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2"]], , [, , "7117\\d{4}", , , , "71171234"], , , [, , , , , , , , , [-1]], [, , "501\\d{5}", 
, , , "50112345"], , , [, , , , , , , , , [-1]]], MU:[, [, , "[2-9]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:2(?:[03478]\\d|1[0-7]|6[1-69])|4(?:[013568]\\d|2[4-7])|5(?:44\\d|471)|6\\d{2}|8(?:14|3[129]))\\d{4}", , , , "2012345"], [, , "5(?:2[59]\\d|4(?:2[1-389]|4\\d|7[1-9]|9\\d)|7\\d{2}|8(?:[0-25689]\\d|4[3479]|7[15-8])|9[0-8]\\d)\\d{4}", , , , "52512345", , , [8]], [, , "80[012]\\d{4}", , , , "8001234", , , [7]], [, , "30\\d{5}", , , , "3012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , 
, , [-1]], [, , "3(?:20|9\\d)\\d{4}", , , , "3201234", , , [7]], "MU", 230, "0(?:0|[2-7]0|33)", , , , , , "020", , [[, "([2-46-9]\\d{2})(\\d{4})", "$1 $2", ["[2-46-9]"]], [, "(5\\d{3})(\\d{4})", "$1 $2", ["5"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MV:[, [, , "[346-8]\\d{6,9}|9(?:00\\d{7}|\\d{6})", , , , , , , [7, 10]], [, , "(?:3(?:0[0-3]|3[0-59])|6(?:[57][02468]|6[024568]|8[024689]|90))\\d{4}", , , , "6701234", , , [7]], 
[, , "(?:46[46]|7[3-9]\\d|9[15-9]\\d)\\d{4}", , , , "7712345", , , [7]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MV", 960, "0(?:0|19)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[3467]|9(?:[1-9]|0[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]00"]]], , [, , "781\\d{4}", , , , "7812345", , , [7]], , , [, , , , , , , , , [-1]], [, , "4[05]0\\d{4}", 
, , , "4001234", , , [7]], , , [, , , , , , , , , [-1]]], MW:[, [, , "(?:1(?:\\d{2})?|[2789]\\d{2})\\d{6}", , , , , , , [7, 9]], [, , "(?:1[2-9]|21\\d{2})\\d{5}", , , , "1234567"], [, , "(?:111|77\\d|88\\d|99\\d)\\d{6}", , , , "991234567", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MW", 265, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], [, "(2\\d{2})(\\d{3})(\\d{3})", 
"$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1789]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MX:[, [, , "[1-9]\\d{9,10}", , , , , , , [10, 11], [7, 8]], [, , "(?:33|55|81)\\d{8}|(?:2(?:0[01]|2[2-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-6][1-9]|[37][1-8]|8[1-35-9]|9[2-689])|5(?:88|9[1-79])|6(?:1[2-68]|[234][1-9]|5[1-3689]|6[12457-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2[1-8]|5[13-9]|8[1-69]|9[17])|8(?:2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}", 
, , , "2221234567", , , [10], [7, 8]], [, , "1(?:(?:33|55|81)\\d{8}|(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-6][1-9]|[37][1-8]|8[1-35-9]|9[2-689])|5(?:88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[12457-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2[1-8]|5[13-9]|8[1-69]|9[17])|8(?:2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7})", , , , "12221234567", 
, , [11]], [, , "8(?:00|88)\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , "300\\d{7}", , , , "3001234567", , , [10]], [, , "500\\d{7}", , , , "5001234567", , , [10]], [, , , , , , , , , [-1]], "MX", 52, "0[09]", "01", , , "0[12]|04[45](\\d{10})", "1$1", , , [[, "([358]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["33|55|81"], "01 $1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"], "01 $1", , 1], [, "(1)([358]\\d)(\\d{4})(\\d{4})", 
"044 $2 $3 $4", ["1(?:33|55|81)"], "$1", , 1], [, "(1)(\\d{3})(\\d{3})(\\d{4})", "044 $2 $3 $4", ["1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"], "$1", , 1]], [[, "([358]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["33|55|81"], "01 $1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"], "01 $1", , 1], [, "(1)([358]\\d)(\\d{4})(\\d{4})", "$1 $2 $3 $4", ["1(?:33|55|81)"]], [, "(1)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"]]], 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]]], MY:[, [, , "[13-9]\\d{7,9}", , , , , , , [8, 9, 10], [6, 7]], [, , "(?:3[2-9]\\d|[4-9][2-9])\\d{6}", , , , "323456789", , , [8, 9], [6, 7]], [, , "1(?:1[1-5]\\d{2}|[02-4679][2-9]\\d|59\\d{2}|8(?:1[23]|[2-9]\\d))\\d{5}", , , , "123456789", , , [9, 10]], [, , "1[378]00\\d{6}", , , , "1300123456", , , [10]], [, , "1600\\d{6}", , , , "1600123456", , , [10]], [, , , , , , , , , [-1]], [, , 
, , , , , , , [-1]], [, , "154\\d{7}", , , , "1541234567", , , [10]], "MY", 60, "00", "0", , , "0", , , , [[, "([4-79])(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], [, "(3)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], [, "([18]\\d)(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1[02-46-9][1-9]|8"], "0$1"], [, "(1)([36-8]00)(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1[36-8]0"]], [, "(11)(\\d{4})(\\d{4})", "$1-$2 $3", ["11"], "0$1"], [, "(15[49])(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"]], , [, , , , , , , , , 
[-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MZ:[, [, , "[28]\\d{7,8}", , , , , , , [8, 9]], [, , "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", , , , "21123456", , , [8]], [, , "8[2-7]\\d{7}", , , , "821234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MZ", 258, "00", , , , , , , , [[, "([28]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-7]"]], 
[, "(80\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["80"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NA:[, [, , "[68]\\d{7,8}", , , , , , , [8, 9]], [, , "6(?:1(?:17|2(?:[0189]\\d|[2-6]|7\\d?)|3(?:[01378]|2\\d)|4(?:[024]|10?|3[15]?)|69|7[014])|2(?:17|5(?:[0-36-8]|4\\d?)|69|70)|3(?:17|2(?:[0237]\\d?|[14-689])|34|6[289]|7[01]|81)|4(?:17|2(?:[012]|7\\d?)|4(?:[06]|1\\d?)|5(?:[01357]|[25]\\d?)|69|7[01])|5(?:17|2(?:[0459]|[23678]\\d?)|69|7[01])|6(?:17|2(?:5|6\\d?)|38|42|69|7[01])|7(?:17|2(?:[569]|[234]\\d?)|3(?:0\\d?|[13])|6[89]|7[01]))\\d{4}", 
, , , "61221234"], [, , "(?:60|8[125])\\d{7}", , , , "811234567", , , [9]], [, , , , , , , , , [-1]], [, , "8701\\d{5}", , , , "870123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8(?:3\\d{2}|86)\\d{5}", , , , "88612345"], "NA", 264, "00", "0", , , "0", , , , [[, "(8\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["8[1235]"], "0$1"], [, "(6\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], [, "(88)(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(870)(\\d{3})(\\d{3})", "$1 $2 $3", 
["870"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NC:[, [, , "[2-57-9]\\d{5}", , , , , , , [6]], [, , "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}", , , , "201234"], [, , "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}", , , , "751234"], [, , , , , , , , , [-1]], [, , "36\\d{4}", , , , "366711"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NC", 687, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", 
["[2-46-9]|5[0-4]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NE:[, [, , "[0289]\\d{7}", , , , , , , [8]], [, , "2(?:0(?:20|3[1-7]|4[134]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}", , , , "20201234"], [, , "(?:8[089]|9\\d)\\d{6}", , , , "93123456"], [, , "08\\d{6}", , , , "08123456"], [, , "09\\d{6}", , , , "09123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
"NE", 227, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[289]|09"]], [, "(08)(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]]], NF:[, [, , "[13]\\d{5}", , , , , , , [6], [5]], [, , "(?:1(?:06|17|28|39)|3[012]\\d)\\d{3}", , , , "106609", , , , [5]], [, , "3[58]\\d{4}", , , , "381234", , , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , 
, , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NF", 672, "00", , , , , , , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["1"]], [, "(\\d)(\\d{5})", "$1 $2", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NG:[, [, , "[1-6]\\d{5,8}|9\\d{5,9}|[78]\\d{5,13}", , , , , , , [7, 8, 10, 11, 12, 13, 14], [5, 6]], [, , "[12]\\d{6,7}|9(?:0[3-9]|[1-9]\\d)\\d{5}|(?:3\\d|4[023568]|5[02368]|6[02-469]|7[4-69]|8[2-9])\\d{6}|(?:4[47]|5[14579]|6[1578]|7[0-357])\\d{5,6}|(?:78|41)\\d{5}", 
, , , "12345678", , , [7, 8], [5, 6]], [, , "(?:1(?:7[34]\\d|8(?:04|[124579]\\d|8[0-3])|95\\d)|287[0-7]|3(?:18[1-8]|88[0-7]|9(?:8[5-9]|6[1-5]))|4(?:28[0-2]|6(?:7[1-9]|8[02-47])|88[0-2])|5(?:2(?:7[7-9]|8\\d)|38[1-79]|48[0-7]|68[4-7])|6(?:2(?:7[7-9]|8\\d)|4(?:3[7-9]|[68][129]|7[04-69]|9[1-8])|58[0-2]|98[7-9])|7(?:38[0-7]|69[1-8]|78[2-4])|8(?:28[3-9]|38[0-2]|4(?:2[12]|3[147-9]|5[346]|7[4-9]|8[014-689]|90)|58[1-8]|78[2-9]|88[5-7])|98[07]\\d)\\d{4}|(?:70(?:[1-689]\\d|7[0-3])|8(?:0(?:1[01]|[2-9]\\d)|1(?:[0-8]\\d|9[01]))|90[235-9]\\d)\\d{6}", 
, , , "8021234567", , , [8, 10]], [, , "800\\d{7,11}", , , , "80017591759", , , [10, 11, 12, 13, 14]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NG", 234, "009", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-6]|7(?:[1-79]|0[1-9])|8[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["70|8[01]|90[235-9]"], "0$1"], [, "([78]00)(\\d{4})(\\d{4,5})", 
"$1 $2 $3", ["[78]00"], "0$1"], [, "([78]00)(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]00"], "0$1"], [, "(78)(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "700\\d{7,11}", , , , "7001234567", , , [10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]]], NI:[, [, , "[12578]\\d{7}", , , , , , , [8]], [, , "2\\d{7}", , , , "21234567"], [, , "5(?:5[0-7]\\d{5}|[78]\\d{6})|7[5-8]\\d{6}|8\\d{7}", , , , "81234567"], [, , "1800\\d{4}", , , , "18001234"], 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NI", 505, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NL:[, [, , "1\\d{4,8}|[2-7]\\d{8}|[89]\\d{6,9}", , , , , , , [5, 6, 7, 8, 9, 10]], [, , "(?:1[0135-8]|2[02-69]|3[0-68]|4[0135-9]|[57]\\d|8[478])\\d{7}", , , , "101234567", , , [9]], [, , "6[1-58]\\d{7}", , , , "612345678", 
, , [9]], [, , "800\\d{4,7}", , , , "8001234", , , [7, 8, 9, 10]], [, , "90[069]\\d{4,7}", , , , "9061234", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:6760|85\\d{2})\\d{5}", , , , "851234567", , , [9]], "NL", 31, "00", "0", , , "0", , , , [[, "([1-578]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1[035]|2[0346]|3[03568]|4[0356]|5[0358]|7|8[4578]"], "0$1"], [, "([1-5]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], [, "(6)(\\d{8})", 
"$1 $2", ["6[0-57-9]"], "0$1"], [, "(66)(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(14)(\\d{3,4})", "$1 $2", ["14"], "$1"], [, "([89]0\\d)(\\d{4,7})", "$1 $2", ["80|9"], "0$1"]], , [, , "66\\d{7}", , , , "662345678", , , [9]], , , [, , "14\\d{3,4}", , , , "14123", , , [5, 6]], [, , "140(?:1(?:[035]|[16-8]\\d)|2(?:[0346]|[259]\\d)|3(?:[03568]|[124]\\d)|4(?:[0356]|[17-9]\\d)|5(?:[0358]|[124679]\\d)|7\\d|8[458])", , , , "14020", , , [5, 6]], , , [, , , , , , , , , [-1]]], NO:[, [, , "0\\d{4}|[2-9]\\d{7}", 
, , , , , , [5, 8]], [, , "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", , , , "21234567", , , [8]], [, , "(?:4[015-8]|5[89]|87|9\\d)\\d{6}", , , , "40612345", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "NO", 47, "00", , , , , , , , [[, "([489]\\d{2})(\\d{2})(\\d{3})", 
"$1 $2 $3", ["[489]"]], [, "([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , "0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}", , , , "01234"], 1, , [, , "81[23]\\d{5}", , , , "81212345", , , [8]]], NP:[, [, , "[1-8]\\d{7}|9(?:[1-69]\\d{6,8}|7[2-6]\\d{5,7}|8\\d{8})", , , , , , , [8, 10], [6, 7]], [, , "(?:1[0-6]\\d|2[13-79][2-6]|3[135-8][2-6]|4[146-9][2-6]|5[135-7][2-6]|6[13-9][2-6]|7[15-9][2-6]|8[1-46-9][2-6]|9[1-79][2-6])\\d{5}", 
, , , "14567890", , , [8], [6, 7]], [, , "9(?:6[013]|7[245]|8[0-24-6])\\d{7}", , , , "9841234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NP", 977, "00", "0", , , "0", , , , [[, "(1)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [, "(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-69]|7[15-9])"], "0$1"], [, "(9\\d{2})(\\d{7})", "$1-$2", ["9(?:6[013]|7[245]|8)"], "$1"]], , [, , , , , , , , , [-1]], , , 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NR:[, [, , "[458]\\d{6}", , , , , , , [7]], [, , "(?:444|888)\\d{4}", , , , "4441234"], [, , "55[5-9]\\d{4}", , , , "5551234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NR", 674, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , 
, , , , , , [-1]]], NU:[, [, , "[1-5]\\d{3}", , , , , , , [4]], [, , "[34]\\d{3}", , , , "4002"], [, , "[125]\\d{3}", , , , "1234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NU", 683, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NZ:[, [, , "6[235-9]\\d{6}|[2-57-9]\\d{7,9}", , , , , , , [8, 9, 10], [7]], [, , "(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}|24099\\d{3}", 
, , , "32345678", , , [8], [7]], [, , "2(?:[028]\\d{7,8}|1(?:[03]\\d{5,7}|[12457]\\d{5,6}|[689]\\d{5})|[79]\\d{7})", , , , "211234567"], [, , "508\\d{6,7}|80\\d{6,8}", , , , "800123456"], [, , "90\\d{6,7}", , , , "900123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , "70\\d{7}", , , , "701234567", , , [9]], [, , , , , , , , , [-1]], "NZ", 64, "0(?:0|161)", "0", , , "0", , "00", , [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["240|[346]|7[2-57-9]|9[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", 
["21"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:1[1-9]|[69]|7[0-35-9])|70|86"], "0$1"], [, "(2\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["2[028]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["90"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|5|[89]0"], "0$1"]], , [, , "[28]6\\d{6,7}", , , , "26123456", , , [8, 9]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], OM:[, [, , "(?:5|[279]\\d)\\d{6}|800\\d{5,6}", , , , 
, , , [7, 8, 9]], [, , "2[2-6]\\d{6}", , , , "23123456", , , [8]], [, , "7[19]\\d{6}|9(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "92123456", , , [8]], [, , "8007\\d{4,5}|500\\d{4}", , , , "80071234"], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "OM", 968, "00", , , , , , , , [[, "(2\\d)(\\d{6})", "$1 $2", ["2"]], [, "([79]\\d{3})(\\d{4})", "$1 $2", ["[79]"]], [, "([58]00)(\\d{4,6})", "$1 $2", ["[58]"]]], , [, , , , , , , , , [-1]], 
, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PA:[, [, , "[1-9]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:1(?:0[0-8]|1[49]|2[37]|3[0137]|4[147]|5[05]|6[58]|7[0167]|8[58]|9[139])|2(?:[0235679]\\d|1[0-7]|4[04-9]|8[028])|3(?:[09]\\d|1[014-7]|2[0-3]|3[03]|4[03-57]|55|6[068]|7[06-8]|8[06-9])|4(?:3[013-69]|4\\d|7[0-589])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-267]|3[06]|[469]0|5[06-9]|7[0-24-79]|8[7-9])|8(?:09|[34]\\d|5[0134]|8[02])|9(?:0[6-9]|1[016-8]|2[036-8]|3[3679]|40|5[0489]|6[06-9]|7[046-9]|8[36-8]|9[1-9]))\\d{4}", 
, , , "2001234", , , [7]], [, , "(?:1[16]1|21[89]|8(?:1[01]|7[23]))\\d{4}|6(?:[024-9]\\d|1[0-5]|3[0-24-9])\\d{5}", , , , "60012345"], [, , "80[09]\\d{4}", , , , "8001234", , , [7]], [, , "(?:779|8(?:55|60|7[78])|9(?:00|81))\\d{4}", , , , "8601234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PA", 507, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["6"]]], , [, , , , , , , , , [-1]], , , [, , , , , , 
, , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PE:[, [, , "[14-9]\\d{7,8}", , , , , , , [8, 9], [6, 7]], [, , "(?:1\\d|4[1-4]|5[1-46]|6[1-7]|7[2-46]|8[2-4])\\d{6}", , , , "11234567", , , [8], [6, 7]], [, , "9\\d{8}", , , , "912345678", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "805\\d{5}", , , , "80512345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , "80[24]\\d{5}", , , , "80212345", , , [8]], [, , , , , , , , , [-1]], "PE", 51, "19(?:1[124]|77|90)00", 
"0", " Anexo ", , "0", , , , [[, "(1)(\\d{7})", "$1 $2", ["1"], "(0$1)"], [, "([4-8]\\d)(\\d{6})", "$1 $2", ["[4-7]|8[2-4]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], [, "(9\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PF:[, [, , "4\\d{5,7}|8\\d{7}", , , , , , , [6, 8]], [, , "4(?:[09][45689]\\d|4)\\d{4}", , , , "40412345"], [, , "8[79]\\d{6}", , , , "87123456", 
, , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PF", 689, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4[09]|8[79]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]]], , [, , , , , , , , , [-1]], , , [, , "44\\d{4}", , , , "441234", , , [6]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PG:[, [, , "[1-9]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:3[0-2]\\d|4[257]\\d|5[34]\\d|64[1-9]|77(?:[0-24]\\d|30)|85[02-46-9]|9[78]\\d)\\d{4}", 
, , , "3123456", , , [7]], [, , "7(?:[0-689]\\d|75)\\d{5}", , , , "70123456", , , [8]], [, , "180\\d{4}", , , , "1801234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "2(?:0[0-47]|7[568])\\d{4}", , , , "2751234", , , [7]], "PG", 675, "140[1-3]|00", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[13-689]|27"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["20|7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, 
, , , , , , , , [-1]]], PH:[, [, , "2\\d{5,7}|[3-9]\\d{7,9}|1800\\d{7,9}", , , , , , , [6, 8, 9, 10, 11, 12, 13], [5, 7]], [, , "2\\d{5}(?:\\d{2})?|(?:3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578]|8[2-8])\\d{7}|88(?:22\\d{6}|42\\d{4})", , , , "21234567", , , [6, 8, 9, 10], [5, 7]], [, , "(?:81[37]|9(?:0[5-9]|1[024-9]|2[0-35-9]|3[02-9]|4[235-9]|5[056]|6[5-7]|7[34-79]|89|9[4-9]))\\d{7}", , , , "9051234567", , , [10]], [, , "1800\\d{7,9}", , , , "180012345678", , , [11, 12, 13]], [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PH", 63, "00", "0", , , "0", , , , [[, "(2)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [, "(2)(\\d{5})", "$1 $2", ["2"], "(0$1)"], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], [, "(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", 
"3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], [, "([3-8]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["81|9"], "0$1"], [, "(1800)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(1800)(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PK:[, [, , "1\\d{8}|[2-8]\\d{5,11}|9(?:[013-9]\\d{4,9}|2\\d(?:111\\d{6}|\\d{3,7}))", , , , , , , [8, 9, 
10, 11, 12], [6, 7]], [, , "(?:21|42)[2-9]\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}|58[126]\\d{7}", , , , "2123456789", , , [9, 10], [6, 7, 8]], [, , "3(?:[014]\\d|2[0-5]|3[0-7]|55|64)\\d{7}", , , , "3012345678", , , [10]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "900\\d{5}", , , , "90012345", , , [8]], 
[, , , , , , , , , [-1]], [, , "122\\d{6}", , , , "122044444", , , [9]], [, , , , , , , , , [-1]], "PK", 92, "00", "0", , , "0", , , , [[, "(\\d{2})(111)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)1", "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)11", "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)111"], "(0$1)"], [, "(\\d{3})(111)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[349]|45|54|60|72|8[2-5]|9[2-9]", "(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d1", 
"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d11", "(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d111"], "(0$1)"], [, "(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], [, "(\\d{3})(\\d{6,7})", "$1 $2", ["2[349]|45|5(?:4|8[12])|60|72|8[2-5]|9[2-9]", "(?:2[349]|45|5(?:4|8[12])|60|72|8[2-5]|9[2-9])\\d[2-9]"], "(0$1)"], [, "(3\\d{2})(\\d{7})", "$1 $2", ["3"], "0$1"], [, "(1\\d{3})(\\d{5,6})", "$1 $2", ["1"], "$1"], [, "(586\\d{2})(\\d{5})", "$1 $2", ["586"], 
"(0$1)"], [, "([89]00)(\\d{3})(\\d{2})", "$1 $2 $3", ["[89]00"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:[1-8]|0[468])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", , , , "21111825888", , , [11, 12]], , , [, , , , , , , , , [-1]]], PL:[, [, , "[12]\\d{6,8}|[3-57-9]\\d{8}|6\\d{5,8}", , , , , , , [6, 7, 8, 9]], [, , 
"(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])\\d{7}|[12]2\\d{5}", , , , "123456789", , , [7, 9]], [, , "(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", , , , "512345678", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "70\\d{7}", , , , "701234567", , , [9]], [, , "801\\d{6}", , , , "801234567", , , [9]], [, , , , , , , , , [-1]], [, , "39\\d{7}", , , , "391234567", , , [9]], "PL", 48, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["26|39|45|5[0137]|6[0469]|7[02389]|8[08]"]], 
[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[14]|2[0-57-9]|3[2-4]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]], [, "(\\d{2})(\\d{1})(\\d{4})", "$1 $2 $3", ["[12]2"]], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["64"]]], , [, , "64\\d{4,7}", , , , "641234567"], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PM:[, [, , "[45]\\d{5}", , , , , , , [6]], [, , "41\\d{4}", , , , "411234"], [, , "55\\d{4}", , , 
, "551234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PM", 508, "00", "0", , , "0", , , , [[, "([45]\\d)(\\d{2})(\\d{2})", "$1 $2 $3", , "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PR:[, [, , "[5789]\\d{9}", , , , , , , [10], [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , 
"7872345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "PR", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "787|939", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PS:[, [, , "[24589]\\d{7,8}|1(?:[78]\\d{8}|[49]\\d{2,3})", , , , , , , [4, 5, 8, 9, 
10], [7]], [, , "(?:22[234789]|42[45]|82[01458]|92[369])\\d{5}", , , , "22234567", , , [8], [7]], [, , "5[69]\\d{7}", , , , "599123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , "1(?:4|9\\d)\\d{2}", , , , "19123", , , [4, 5]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PS", 970, "00", "0", , , "0", , , , [[, "([2489])(2\\d{2})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], [, "(5[69]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], 
"0$1"], [, "(1[78]00)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[78]"], "$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PT:[, [, , "[2-46-9]\\d{8}", , , , , , , [9]], [, , "2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}", , , , "212345678"], [, , "9(?:[1236]\\d{2}|480)\\d{5}", , , , "912345678"], [, , "80[02]\\d{6}", , , , "800123456"], [, , "6(?:0[178]|4[68])\\d{6}|76(?:0[1-57]|1[2-47]|2[237])\\d{5}", , , 
, "760123456"], [, , "80(?:8\\d|9[1579])\\d{5}", , , , "808123456"], [, , "884[0-4689]\\d{5}", , , , "884123456"], [, , "30\\d{7}", , , , "301234567"], "PT", 351, "00", , , , , , , , [[, "(2\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], [, "([2-46-9]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[3-9]|[346-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7(?:0(?:7\\d|8[17]))\\d{5}", , , , "707123456"], , , [, , "600\\d{6}", , , , "600110000"]], PW:[, [, , "[2-8]\\d{6}", , , , , , 
, [7]], [, , "2552255|(?:277|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76))\\d{4}", , , , "2771234"], [, , "(?:6[234689]0|77[45789])\\d{4}", , , , "6201234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PW", 680, "01[12]", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PY:[, [, , "5[0-5]\\d{4,7}|[2-46-9]\\d{5,8}", 
, , , , , , [6, 7, 8, 9], [5]], [, , "(?:[26]1|3[289]|4[124678]|7[123]|8[1236])\\d{5,7}|(?:2(?:2[4568]|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51)|4(?:18|2[45]|3[12]|5[13]|64|71|9[1-47])|5(?:[1-4]\\d|5[0234])|6(?:3[1-3]|44|7[1-4678])|7(?:17|4[0-4]|6[1-578]|75|8[0-8])|858)\\d{5,6}", , , , "212345678", , , [7, 8, 9], [5, 6]], [, , "9(?:6[12]|[78][1-6]|9[1-5])\\d{6}", , , , "961456789", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , 
"8700[0-4]\\d{4}", , , , "870012345", , , [9]], "PY", 595, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["(?:[26]1|3[289]|4[124678]|7[123]|8[1236])"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["(?:[26]1|3[289]|4[124678]|7[123]|8[1236])"], "(0$1)"], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["9[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8700"]], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["[2-8][1-9]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", 
"$1 $2 $3", ["[2-8][1-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[2-9]0\\d{4,7}", , , , "201234567"], , , [, , , , , , , , , [-1]]], QA:[, [, , "[2-8]\\d{6,7}", , , , , , , [7, 8]], [, , "4[04]\\d{6}", , , , "44123456", , , [8]], [, , "[3567]\\d{7}", , , , "33123456", , , [8]], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "QA", 974, "00", , , , , , , , [[, "([28]\\d{2})(\\d{4})", 
"$1 $2", ["[28]"]], [, "([3-7]\\d{3})(\\d{4})", "$1 $2", ["[3-7]"]]], , [, , "2(?:[12]\\d|61)\\d{4}", , , , "2123456", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], RE:[, [, , "[268]\\d{8}", , , , , , , [9]], [, , "262\\d{6}", , , , "262161234"], [, , "69(?:2\\d{2}|3(?:0[0-46]|1[013]|2[0-2]|3[039]|4[0-7]|5[05]|6[06]|7[07]|8[0-38]|9[0-479]))\\d{4}", , , , "692123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89[1-37-9]\\d{6}", , , , "891123456"], 
[, , "8(?:1[019]|2[0156]|84|90)\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RE", 262, "00", "0", , , "0", , , , [[, "([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", , "0$1"]], , [, , , , , , , , , [-1]], 1, "262|69|8", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], RO:[, [, , "[23]\\d{5,8}|[7-9]\\d{8}", , , , , , , [6, 9]], [, , "2(?:1(?:\\d{7}|9\\d{3})|[3-6](?:\\d{7}|\\d9\\d{2}))|3(?:1\\d{4}(?:\\d{3})?|[3-6]\\d{7})", 
, , , "211234567"], [, , "7(?:[0-8]\\d{2}|99\\d)\\d{5}", , , , "712345678", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[036]\\d{6}", , , , "900123456", , , [9]], [, , "801\\d{6}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RO", 40, "00", "0", " int ", , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], [, "(\\d{2})(\\d{4})", "$1 $2", ["[23]1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23][3-7]|[7-9]"], 
"0$1"], [, "(2\\d{2})(\\d{3})", "$1 $2", ["2[3-6]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "37\\d{7}", , , , "372123456", , , [9]], , , [, , , , , , , , , [-1]]], RS:[, [, , "[126-9]\\d{4,11}|3(?:[0-79]\\d{3,10}|8[2-9]\\d{2,9})", , , , , , , [6, 7, 8, 9, 10, 11, 12], [5]], [, , "(?:1(?:[02-9][2-9]|1[1-9])\\d|2(?:[0-24-7][2-9]\\d|[389](?:0[2-9]|[2-9]\\d))|3(?:[0-8][2-9]\\d|9(?:[2-9]\\d|0[2-9])))\\d{3,8}", , , , "10234567", , , [7, 8, 9, 10, 11, 12], [5, 6]], [, , 
"6(?:[0-689]|7\\d)\\d{6,7}", , , , "601234567", , , [8, 9, 10]], [, , "800\\d{3,9}", , , , "80012345"], [, , "(?:90[0169]|78\\d)\\d{3,7}", , , , "90012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RS", 381, "00", "0", , , "0", , , , [[, "([23]\\d{2})(\\d{4,9})", "$1 $2", ["(?:2[389]|39)0"], "0$1"], [, "([1-3]\\d)(\\d{5,10})", "$1 $2", ["1|2(?:[0-24-7]|[389][1-9])|3(?:[0-8]|9[1-9])"], "0$1"], [, "(6\\d)(\\d{6,8})", "$1 $2", ["6"], "0$1"], [, "([89]\\d{2})(\\d{3,9})", 
"$1 $2", ["[89]"], "0$1"], [, "(7[26])(\\d{4,9})", "$1 $2", ["7[26]"], "0$1"], [, "(7[08]\\d)(\\d{4,9})", "$1 $2", ["7[08]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7[06]\\d{4,10}", , , , "700123456"], , , [, , , , , , , , , [-1]]], RU:[, [, , "[3489]\\d{9}", , , , , , , [10]], [, , "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", , , , "3011234567"], 
[, , "9\\d{9}", , , , "9123456789"], [, , "80[04]\\d{7}", , , , "8001234567"], [, , "80[39]\\d{7}", , , , "8091234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RU", 7, "810", "8", , , "8", , "8~10", , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1-$2-$3", ["[1-79]"], "$1", , 1], [, "([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[34689]"], "8 ($1)", , 1], [, "(7\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1]], [[, "([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})", 
"$1 $2-$3-$4", ["[34689]"], "8 ($1)", , 1], [, "(7\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], RW:[, [, , "[027-9]\\d{7,8}", , , , , , , [8, 9]], [, , "2[258]\\d{7}|06\\d{6}", , , , "250123456"], [, , "7[238]\\d{7}", , , , "720123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "900\\d{6}", , , , "900123456", , , [9]], [, , , , , , , , , [-1]], [, , 
, , , , , , , [-1]], [, , , , , , , , , [-1]], "RW", 250, "00", "0", , , "0", , , , [[, "(2\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "$1"], [, "([7-9]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], [, "(0\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]]], SA:[, [, , "1\\d{7,8}|(?:[2-467]|92)\\d{7}|5\\d{8}|8\\d{9}", , , , , , , [8, 9, 10], [7]], [, , "11\\d{7}|1?(?:2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", 
, , , "112345678", , , [8, 9], [7]], [, , "(?:5(?:[013-689]\\d|7[0-26-8])|811\\d)\\d{6}", , , , "512345678", , , [9, 10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , "92[05]\\d{6}", , , , "920012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SA", 966, "00", "0", , , "0", , , , [[, "([1-467])(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-467]"], "0$1"], [, "(1\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1[1-467]"], "0$1"], [, "(5\\d)(\\d{3})(\\d{4})", "$1 $2 $3", 
["5"], "0$1"], [, "(92\\d{2})(\\d{5})", "$1 $2", ["92"], "$1"], [, "(800)(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "$1"], [, "(811)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SB:[, [, , "[1-9]\\d{4,6}", , , , , , , [5, 7]], [, , "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", , , , "40123", , , [5]], [, , "48\\d{3}|7(?:30|[46-8]\\d|5[025-9]|9[0-5])\\d{4}|8[4-9]\\d{5}|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8])\\d{4}", 
, , , "7421234"], [, , "1[38]\\d{3}", , , , "18123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5[12]\\d{3}", , , , "51123", , , [5]], "SB", 677, "0[01]", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["[7-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SC:[, [, , "[24689]\\d{5,6}", , , , , , , [7]], [, , "4[2-46]\\d{5}", , , , "4217123"], [, , "2[5-8]\\d{5}", , , , "2510123"], 
[, , "8000\\d{3}", , , , "8000000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:64\\d|971)\\d{4}", , , , "6412345"], "SC", 248, "0(?:[02]|10?)", , , , , , "00", , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SD:[, [, , "[19]\\d{8}", , , , , , , [9]], [, , "1(?:[125]\\d|8[3567])\\d{6}", , , , "121231234"], [, , "9[0-3569]\\d{7}", , 
, , "911231234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SD", 249, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", , "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SE:[, [, , "[1-35-9]\\d{5,11}|4\\d{6,8}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "1(?:0[1-8]\\d{6}|[136]\\d{5,7}|(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)\\d{5,6})|2(?:[136]\\d{5,7}|(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])\\d{5,6})|3(?:[356]\\d{5,7}|(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])\\d{5,6})|4(?:[0246]\\d{5,7}|(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])\\d{5,6})|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])\\d{5,6}|6(?:[03]\\d{5,7}|(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])\\d{5,6})|8\\d{6,8}|9(?:0[1-9]\\d{4,6}|(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8])\\d{5,6})", 
, , , "8123456", , , [7, 8, 9]], [, , "7[02369]\\d{7}", , , , "701234567", , , [9]], [, , "20\\d{4,7}", , , , "20123456", , , [6, 7, 8, 9]], [, , "649\\d{6}|9(?:00|39|44)[1-8]\\d{3,6}", , , , "9001234567", , , [7, 8, 9, 10]], [, , "77(?:0\\d{3}(?:\\d{3})?|[1-7]\\d{6})", , , , "771234567", , , [6, 9]], [, , "75[1-8]\\d{6}", , , , "751234567", , , [9]], [, , , , , , , , , [-1]], "SE", 46, "00", "0", , , "0", , , , [[, "(8)(\\d{2,3})(\\d{2,3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [, "([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})", 
"$1-$2 $3 $4", ["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"], "0$1"], [, "([1-469]\\d)(\\d{3})(\\d{2})", "$1-$2 $3", ["1[136]|2[136]|3[356]|4[0246]|6[03]|90"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"], 
"0$1"], [, "(7\\d)(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["7"], "0$1"], [, "(77)(\\d{2})(\\d{2})", "$1-$2$3", ["7"], "0$1"], [, "(20)(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"], [, "(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9[034]"], "0$1"], [, "(9[034]\\d)(\\d{4})", "$1-$2", ["9[034]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["25[245]|67[3-6]"], "0$1"]], [[, "(8)(\\d{2,3})(\\d{2,3})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4", ["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"]], [, "([1-469]\\d)(\\d{3})(\\d{2})", "$1 $2 $3", ["1[136]|2[136]|3[356]|4[0246]|6[03]|90"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"]], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"]], [, "(7\\d)(\\d{3})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4", ["7"]], [, "(77)(\\d{2})(\\d{2})", "$1 $2 $3", ["7"]], [, "(20)(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]], [, "(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9[034]"]], [, "(9[034]\\d)(\\d{4})", "$1 $2", ["9[034]"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["25[245]|67[3-6]"]]], [, , "74[02-9]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "(?:25[245]|67[3-6])\\d{9}", , , , "254123456789", , , [12]]], 
SG:[, [, , "[36]\\d{7}|[17-9]\\d{7,10}", , , , , , , [8, 10, 11]], [, , "6[1-9]\\d{6}", , , , "61234567", , , [8]], [, , "(?:8[1-8]|9[0-8])\\d{6}", , , , "81234567", , , [8]], [, , "1?800\\d{7}", , , , "18001234567", , , [10, 11]], [, , "1900\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3[12]\\d{6}", , , , "31234567", , , [8]], "SG", 65, "0[0-3]\\d", , , , , , , , [[, "([3689]\\d{3})(\\d{4})", "$1 $2", ["[369]|8[1-9]"]], [, "(1[89]00)(\\d{3})(\\d{4})", 
"$1 $2 $3", ["1[89]"]], [, "(7000)(\\d{4})(\\d{3})", "$1 $2 $3", ["70"]], [, "(800)(\\d{3})(\\d{4})", "$1 $2 $3", ["80"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7000\\d{7}", , , , "70001234567", , , [11]], , , [, , , , , , , , , [-1]]], SH:[, [, , "[256]\\d{4}", , , , , , , [4, 5]], [, , "2(?:[0-57-9]\\d|6[4-9])\\d{2}", , , , "22158"], [, , "[56]\\d{4}", , , , "51234", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , 
, , [-1]], [, , "262\\d{2}", , , , "26212", , , [5]], "SH", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SI:[, [, , "[1-7]\\d{6,7}|[89]\\d{4,7}", , , , , , , [5, 6, 7, 8]], [, , "(?:1\\d|[25][2-8]|3[24-8]|4[24-8]|7[3-8])\\d{6}", , , , "11234567", , , [8], [7]], [, , "(?:[37][01]\\d|4[0139]\\d|51\\d|6(?:[48]\\d|9[69]))\\d{5}", , , , "31234567", , , [8]], [, , "80\\d{4,6}", , , , "80123456", , , [6, 7, 
8]], [, , "90\\d{4,6}|89[1-3]\\d{2,5}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:59|8[1-3])\\d{6}", , , , "59012345", , , [8]], "SI", 386, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[12]|3[24-8]|4[24-8]|5[2-8]|7[3-8]"], "(0$1)"], [, "([3-7]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], [, "([89][09])(\\d{3,6})", "$1 $2", ["[89][09]"], "0$1"], [, "([58]\\d{2})(\\d{5})", "$1 $2", ["59|8[1-3]"], "0$1"]], 
, [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SJ:[, [, , "0\\d{4}|[45789]\\d{7}", , , , , , , [5, 8]], [, , "79\\d{6}", , , , "79123456", , , [8]], [, , "(?:4[015-8]|5[89]|9\\d)\\d{6}", , , , "41234567", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", 
, , , "85012345", , , [8]], "SJ", 47, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}", , , , "01234"], 1, , [, , "81[23]\\d{5}", , , , "81212345", , , [8]]], SK:[, [, , "(?:[2-68]\\d{5,8}|9\\d{6,8})", , , , , , , [6, 7, 9]], [, , "2(?:1(?:6\\d{3,4}|7\\d{3})|[2-9]\\d{7})|[3-5][1-8](?:1(?:6\\d{2,3}|7\\d{3})|\\d{7})", , , , "221234567"], [, , "9(?:0(?:[1-8]\\d|9[1-9])|(?:1[0-24-9]|[45]\\d)\\d)\\d{5}", , , , "912123456", 
, , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:[78]\\d{7}|00\\d{6})", , , , "900123456", , , [9]], [, , "8[5-9]\\d{7}", , , , "850123456", , , [9]], [, , , , , , , , , [-1]], [, , "6(?:02|5[0-4]|9[0-6])\\d{6}", , , , "690123456", , , [9]], "SK", 421, "00", "0", , , "0", , , , [[, "(2)(1[67])(\\d{3,4})", "$1 $2 $3", ["21[67]"], "0$1"], [, "([3-5]\\d)(1[67])(\\d{2,3})", "$1 $2 $3", ["[3-5]"], "0$1"], [, "(2)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "([3-5]\\d)(\\d{3})(\\d{2})(\\d{2})", 
"$1/$2 $3 $4", ["[3-5]"], "0$1"], [, "([689]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(9090)(\\d{3})", "$1 $2", ["9090"], "0$1"]], , [, , "9090\\d{3}", , , , "9090123", , , [7]], , , [, , "(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}|9090\\d{3}", , , , "800123456", , , [7, 9]], [, , "96\\d{7}", , , , "961234567", , , [9]], , , [, , , , , , , , , [-1]]], SL:[, [, , "[2-9]\\d{7}", , , , , , , [8], [6]], [, , "[235]2[2-4][2-9]\\d{4}", , , , "22221234", , , , [6]], [, , "(?:2[15]|3[03-5]|4[04]|5[05]|66|7[6-9]|8[08]|99)\\d{6}", 
, , , "25123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SL", 232, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", , "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SM:[, [, , "[05-7]\\d{7,9}", , , , , , , [8, 10], [6]], [, , "0549(?:8[0157-9]|9\\d)\\d{4}", , , , "0549886377", , , [10], [6]], [, , "6[16]\\d{6}", , , , 
"66661212", , , [8]], [, , , , , , , , , [-1]], [, , "7[178]\\d{6}", , , , "71123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5[158]\\d{6}", , , , "58001110", , , [8]], "SM", 378, "00", , , , "(?:0549)?([89]\\d{5})", "0549$1", , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(0549)(\\d{6})", "$1 $2", ["0"]], [, "(\\d{6})", "0549 $1", ["[89]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(0549)(\\d{6})", "($1) $2", 
["0"]], [, "(\\d{6})", "(0549) $1", ["[89]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]]], SN:[, [, , "[3789]\\d{8}", , , , , , , [9]], [, , "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}", , , , "301012345"], [, , "7(?:[06-8]\\d|21|90)\\d{6}", , , , "701234567"], [, , "800\\d{6}", , , , "800123456"], [, , "88[4689]\\d{6}", , , , "884123456"], [, , "81[02468]\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "39[01]\\d{6}|3392\\d{5}|93330\\d{4}", 
, , , "933301234"], "SN", 221, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SO:[, [, , "[1-9]\\d{5,8}", , , , , , , [6, 7, 8, 9]], [, , "(?:1\\d{1,2}|2[0-79]\\d|3[0-46-8]?\\d|4[0-7]?\\d|59\\d|8[125])\\d{4}", , , , "4012345", , , [6, 7]], [, , "(?:15\\d|2(?:4\\d|8)|3[59]\\d{2}|4[89]\\d{2}|6[1-9]?\\d{2}|7(?:[1-8]\\d|9\\d{1,2})|8[08]\\d{2}|9(?:0[67]|[2-9])\\d)\\d{5}", 
, , , "71123456", , , [7, 8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SO", 252, "00", "0", , , "0", , , , [[, "(\\d{6})", "$1", ["[134]"]], [, "(\\d)(\\d{6})", "$1 $2", ["2[0-79]|[13-5]"]], [, "(\\d)(\\d{7})", "$1 $2", ["24|[67]"]], [, "(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], [, "(\\d{2})(\\d{5,7})", "$1 $2", ["15|28|6[1-35-9]|799|9[2-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3[59]|4[89]|6[24-6]|79|8[08]|90"]]], 
, [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SR:[, [, , "[2-8]\\d{5,6}", , , , , , , [6, 7]], [, , "(?:2[1-3]|3[0-7]|4\\d|5[2-58]|68\\d)\\d{4}", , , , "211234"], [, , "(?:7[124-7]|8[1-9])\\d{5}", , , , "7412345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "56\\d{4}", , , , "561234", , , [6]], "SR", 597, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1-$2", 
["[2-4]|5[2-58]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SS:[, [, , "[19]\\d{8}", , , , , , , [9]], [, , "18\\d{7}", , , , "181234567"], [, , "(?:12|9[1257])\\d{7}", , , , "977123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SS", 211, 
"00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", , "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ST:[, [, , "[29]\\d{6}", , , , , , , [7]], [, , "22\\d{5}", , , , "2221234"], [, , "9(?:0(?:0[5-9]|[1-9]\\d)|[89]\\d{2})\\d{3}", , , , "9812345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ST", 239, "00", , , , , , , 
, [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SV:[, [, , "[267]\\d{7}|[89]\\d{6}(?:\\d{4})?", , , , , , , [7, 8, 11]], [, , "2[1-6]\\d{6}", , , , "21234567", , , [8]], [, , "[67]\\d{7}", , , , "70123456", , , [8]], [, , "800\\d{4}(?:\\d{4})?", , , , "8001234", , , [7, 11]], [, , "900\\d{4}(?:\\d{4})?", , , , "9001234", , , [7, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , 
, , , , , [-1]], "SV", 503, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SX:[, [, , "[5789]\\d{9}", , , , , , , [10], [7]], [, , "7215(?:4[2-8]|8[239]|9[056])\\d{4}", , , , "7215425678", , , , [7]], [, , "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", , , , "7215205678", 
, , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "SX", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "721", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SY:[, [, , "[1-59]\\d{7,8}", , , , , , , [8, 9], [6, 7]], [, , "(?:1(?:1\\d?|4\\d|[2356])|2(?:1\\d?|[235])|3(?:[13]\\d|4)|4[13]|5[1-3])\\d{6}", 
, , , "112345678", , , , [6, 7]], [, , "9(?:22|[3-589]\\d|6[024-9])\\d{6}", , , , "944567890", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SY", 963, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", , 1], [, "(9\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , 
, , , , , , [-1]]], SZ:[, [, , "[027]\\d{7}", , , , , , , [8]], [, , "2[2-5]\\d{6}", , , , "22171234"], [, , "7[6-8]\\d{6}", , , , "76123456"], [, , "0800\\d{4}", , , , "08001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SZ", 268, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[027]"]]], , [, , , , , , , , , [-1]], , , [, , "0800\\d{4}", , , , "08001234"], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]]], TA:[, [, , 
"8\\d{3}", , , , , , , [4]], [, , "8\\d{3}", , , , "8999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TA", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TC:[, [, , "[5689]\\d{9}", , , , , , , [10], [7]], [, , "649(?:712|9(?:4\\d|50))\\d{4}", , , , "6497121234", , , , [7]], [, , "649(?:2(?:3[129]|4[1-7])|3(?:3[1-389]|4[1-8])|4[34][1-3])\\d{4}", 
, , , "6492311234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "64971[01]\\d{4}", , , , "6497101234", , , , [7]], "TC", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "649", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TD:[, [, , "[2679]\\d{7}", , , , , , , [8]], [, , "22(?:[3789]0|5[0-5]|6[89])\\d{4}", 
, , , "22501234"], [, , "(?:6[023568]\\d|77\\d|9\\d{2})\\d{5}", , , , "63012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TD", 235, "00|16", , , , , , "00", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TG:[, [, , "[29]\\d{7}", , , , , , , [8]], [, , "2(?:2[2-7]|3[23]|44|55|66|77)\\d{5}", 
, , , "22212345"], [, , "9[0-36-9]\\d{6}", , , , "90112345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TG", 228, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[29]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TH:[, [, , "[2-9]\\d{7,8}|1\\d{3}(?:\\d{5,6})?", , , , , , , [4, 8, 9, 10]], [, , "(?:2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", 
, , , "21234567", , , [8]], [, , "(?:14|6[1-6]|[89]\\d)\\d{7}", , , , "812345678", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , "1900\\d{6}", , , , "1900123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "6[08]\\d{7}", , , , "601234567", , , [9]], "TH", 66, "00", "0", , , "0", , , , [[, "(2)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "([13-9]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["14|[3-9]"], "0$1"], [, "(1[89]00)(\\d{3})(\\d{3})", "$1 $2 $3", ["1"], 
"$1"]], , [, , , , , , , , , [-1]], , , [, , "1\\d{3}", , , , "1100", , , [4]], [, , "1\\d{3}", , , , "1100", , , [4]], , , [, , , , , , , , , [-1]]], TJ:[, [, , "[3-57-9]\\d{8}", , , , , , , [9], [3, 5, 7]], [, , "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}", , , , "372123456", , , , [3, 5, 7]], [, , "(?:41[18]|(?:5[05]|77|88|9[0-35-9])\\d)\\d{6}", , , , "917123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], "TJ", 992, "810", "8", , , "8", , "8~10", , [[, "([349]\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"], "$1", , 1], [, "([457-9]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[148]|[578]|9(?:1[59]|[0235-9])"], "$1", , 1], [, "(331700)(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317", "33170", "331700"], "$1", , 1], [, "(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]", "3(?:[1245]|3(?:[02-9]|1[0-589]))"], "$1", , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , 
, , , , [-1]], , , [, , , , , , , , , [-1]]], TK:[, [, , "[2-47]\\d{3,6}", , , , , , , [4, 5, 6, 7]], [, , "(?:2[2-4]|[34]\\d)\\d{2,5}", , , , "3101"], [, , "7[2-4]\\d{2,5}", , , , "7290"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TK", 690, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TL:[, [, , "[2-489]\\d{6}|7\\d{6,7}", 
, , , , , , [7, 8]], [, , "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", , , , "2112345", , , [7]], [, , "7[3-8]\\d{6}", , , , "77212345", , , [8]], [, , "80\\d{5}", , , , "8012345", , , [7]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , "70\\d{5}", , , , "7012345", , , [7]], [, , , , , , , , , [-1]], "TL", 670, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["7[3-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TM:[, [, , "[1-6]\\d{7}", , , , , , , [8]], [, , "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}", , , , "12345678"], [, , "6[1-9]\\d{6}", , , , "66123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TM", 993, "810", "8", , , "8", , "8~10", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", 
["12"], "(8 $1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["13|[2-5]"], "(8 $1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TN:[, [, , "[2-57-9]\\d{7}", , , , , , , [8]], [, , "3(?:[012]\\d|6[0-4]|91)\\d{5}|7\\d{7}|81200\\d{3}", , , , "71234567"], [, , "(?:[259]\\d|4[0-6])\\d{6}", , , , "20123456"], [, , "8010\\d{4}", , , , "80101234"], [, , "88\\d{6}", , , , "88123456"], 
[, , "8[12]10\\d{4}", , , , "81101234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TN", 216, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TO:[, [, , "[02-8]\\d{4,6}", , , , , , , [5, 7]], [, , "(?:2\\d|3[1-8]|4[1-4]|[56]0|7[0149]|8[05])\\d{3}", , , , "20123", , , [5]], [, , "(?:7[578]|8[47-9])\\d{5}", , , , "7715123", , , [7]], [, , "0800\\d{3}", , , , 
"0800222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TO", 676, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1-$2", ["[1-6]|7[0-4]|8[05]"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["7[5-9]|8[47-9]"]], [, "(\\d{4})(\\d{3})", "$1 $2", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]]], TR:[, [, , "[2-589]\\d{9}|444\\d{4}", , , , , , , [7, 10]], [, , "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", 
, , , "2123456789", , , [10]], [, , "5(?:(?:0[1-7]|22|[34]\\d|5[1-59]|9[246])\\d{2}|6161)\\d{5}", , , , "5012345678", , , [10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TR", 90, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[23]|4(?:[0-35-9]|4[0-35-9])"], "(0$1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[02-69]"], 
"0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["51|[89]"], "0$1", , 1], [, "(444)(\\d{1})(\\d{3})", "$1 $2 $3", ["444"]]], , [, , "512\\d{7}", , , , "5123456789", , , [10]], , , [, , "444\\d{4}", , , , "4441444", , , [7]], [, , "444\\d{4}|850\\d{7}", , , , "4441444"], , , [, , , , , , , , , [-1]]], TT:[, [, , "[589]\\d{9}", , , , , , , [10], [7]], [, , "868(?:2(?:01|[23]\\d)|6(?:0[79]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}", , , , "8682211234", , , , [7]], [, , "868(?:2(?:6[6-9]|[789]\\d)|3(?:0[1-9]|1[02-9]|[2-9]\\d)|4[6-9]\\d|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}", 
, , , "8682911234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "TT", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "868", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "868619\\d{4}", , , , "8686191234", , , , [7]]], TV:[, [, , "[279]\\d{4,6}", , , , , , , [5, 6, 7]], [, , 
"2[02-9]\\d{3}", , , , "20123", , , [5]], [, , "(?:70\\d|90)\\d{4}", , , , "901234", , , [6, 7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TV", 688, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TW:[, [, , "2\\d{6,8}|[3-689]\\d{7,8}|7\\d{7,9}", , , , , , , [7, 8, 9, 10]], [, , "2(?:[235-8]\\d{7}|4\\d{6,7})|[3-8]\\d{7,8}", 
, , , "221234567", , , [8, 9]], [, , "9\\d{8}", , , , "912345678", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "20(?:2|[013-9]\\d{2})\\d{4}", , , , "203123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "TW", 886, "0(?:0[25679]|19)", "0", "#", , "0", , , , [[, "(20)(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], [, "(20)(\\d{3})(\\d{4})", "$1 $2 $3", ["20[013-9]"], "0$1"], [, "([2-8])(\\d{3,4})(\\d{4})", "$1 $2 $3", 
["2[23-8]|[3-6]|[78][1-9]"], "0$1"], [, "([89]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["80|9"], "0$1"], [, "(70)(\\d{4})(\\d{4})", "$1 $2 $3", ["70"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TZ:[, [, , "\\d{9}", , , , , , , [7, 9]], [, , "2[2-8]\\d{7}", , , , "222345678"], [, , "(?:6[2-9]|7[13-9])\\d{7}", , , , "621234567", , , [9]], [, , "80[08]\\d{6}", , , , "800123456", , , [9]], [, , "90\\d{7}", , , , "900123456", 
, , [9]], [, , "8(?:40|6[01])\\d{6}", , , , "840123456", , , [9]], [, , , , , , , , , [-1]], [, , "41\\d{7}", , , , "412345678", , , [9]], "TZ", 255, "00[056]", "0", , , "0", , , , [[, "([24]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], [, "([67]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"], [, "([89]\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "(?:8(?:[04]0|6[01])|90\\d)\\d{6}", , , , "800123456", , , [9]], [, , , , , , , , , [-1]], 
, , [, , , , , , , , , [-1]]], UA:[, [, , "[3-9]\\d{8}", , , , , , , [9], [5, 6, 7]], [, , "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", , , , "311234567", , , , [5, 6, 7]], [, , "(?:39|50|6[36-8]|7[13]|9[1-9])\\d{7}", , , , "391234567"], [, , "800\\d{6}", , , , "800123456"], [, , "900[2-49]\\d{5}", , , , "900212345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "89\\d{7}", , , , "891234567"], "UA", 380, "00", "0", , , "0", , "0~0", , [[, "([3-9]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[38]9|4(?:[45][0-5]|87)|5(?:0|6[37]|7[37])|6[36-8]|7|9[1-9]", 
"[38]9|4(?:[45][0-5]|87)|5(?:0|6(?:3[14-7]|7)|7[37])|6[36-8]|7|9[1-9]"], "0$1"], [, "([3-689]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["3[1-8]2|4[13678]2|5(?:[12457]2|6[24])|6(?:[49]2|[12][29]|5[24])|8[0-8]|90", "3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[49]2|[12][29]|5[24])|8[0-8]|90"], "0$1"], [, "([3-6]\\d{3})(\\d{5})", "$1 $2", ["3(?:5[013-9]|[1-46-8])|4(?:[137][013-9]|6|[45][6-9]|8[4-6])|5(?:[1245][013-9]|6[0135-9]|3|7[4-6])|6(?:[49][013-9]|5[0135-9]|[12][13-8])", 
"3(?:5[013-9]|[1-46-8](?:22|[013-9]))|4(?:[137][013-9]|6(?:[013-9]|22)|[45][6-9]|8[4-6])|5(?:[1245][013-9]|6(?:3[02389]|[015689])|3|7[4-6])|6(?:[49][013-9]|5[0135-9]|[12][13-8])"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UG:[, [, , "\\d{9}", , , , , , , [9], [5, 6, 7]], [, , "20(?:[0147]\\d{2}|2(?:40|[5-9]\\d)|3(?:0[0-4]|[23]\\d)|5[0-4]\\d|6[035-9]\\d|8[0-2]\\d)\\d{4}|[34]\\d{8}", , , , "312345678", , , , [5, 6, 7]], 
[, , "7(?:(?:0[0-7]|[15789]\\d|30|4[0-4])\\d|2(?:[03]\\d|60))\\d{5}", , , , "712345678"], [, , "800[123]\\d{5}", , , , "800123456"], [, , "90[123]\\d{6}", , , , "901123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UG", 256, "00[057]", "0", , , "0", , , , [[, "(\\d{3})(\\d{6})", "$1 $2", ["[7-9]|20(?:[013-8]|2[5-9])|4(?:6[45]|[7-9])"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["3|4(?:[1-5]|6[0-36-9])"], "0$1"], [, "(2024)(\\d{5})", "$1 $2", ["2024"], "0$1"]], 
, [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], US:[, [, , "[2-9]\\d{9}", , , , , , , [10], [7]], [, , "(?:2(?:0[1-35-9]|1[02-9]|2[04589]|3[149]|4[08]|5[1-46]|6[0279]|7[026]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-37]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[012])|7(?:0[1-46-8]|1[02-9]|2[0457]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-25]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[014678]|4[0179]|5[12469]|7[0-3589]|8[0459]))[2-9]\\d{6}", 
, , , "2015550123", , , , [7]], [, , "(?:2(?:0[1-35-9]|1[02-9]|2[04589]|3[149]|4[08]|5[1-46]|6[0279]|7[026]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-37]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[012])|7(?:0[1-46-8]|1[02-9]|2[0457]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-25]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[014678]|4[0179]|5[12469]|7[0-3589]|8[0459]))[2-9]\\d{6}", 
, , , "2015550123", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "US", 1, "011", "1", , , "1", , , 1, [[, "(\\d{3})(\\d{4})", "$1-$2", , , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", , , , 1]], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3"]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UY:[, [, , "[2489]\\d{6,7}", , , , , , , [7, 8]], [, , "2\\d{7}|4[2-7]\\d{6}", , , , "21231234", , , [8], [7]], [, , "9[1-9]\\d{6}", , , , "94231234", , , [8]], [, , "80[05]\\d{4}", , , , "8001234", , , [7]], [, , "90[0-8]\\d{4}", , , , "9001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UY", 598, "0(?:1[3-9]\\d|0)", "0", " int. ", , "0", , "00", , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[24]"]], [, "(\\d{2})(\\d{3})(\\d{3})", 
"$1 $2 $3", ["9[1-9]"], "0$1"], [, "(\\d{3})(\\d{4})", "$1 $2", ["[89]0"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UZ:[, [, , "[679]\\d{8}", , , , , , , [9], [7]], [, , "(?:6(?:1(?:22|3[124]|4[1-4]|5[123578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d{2}|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[12456]|9[135-8])|1[12]\\d|2(?:22|3[1345789]|4[123579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}", 
, , , "662345678", , , , [7]], [, , "6(?:1(?:2(?:98|2[01])|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:11\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4])|7\\d{2})|5(?:19[01]|2(?:27|9[26])|30\\d|59\\d|7\\d{2})|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|3[79]\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79])|9[0-3]\\d)|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|5\\d|3[01]|7[0-4])|5[67]\\d|6(?:2[0-26]|8\\d)|7\\d{2}))\\d{4}|7(?:0\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|33\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078])|9[4-6]\\d)|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0127]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[05629]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07])))\\d{4}|9[0-57-9]\\d{7}", 
, , , "912345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UZ", 998, "810", "8", , , "8", , "8~10", , [[, "([679]\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", , "8 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VA:[, [, , "(?:0(?:878\\d{5}|6698\\d{5})|[1589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9}))", , , , , , , [6, 8, 9, 10, 11]], 
[, , "06698\\d{5}", , , , "0669812345", , , [10]], [, , "3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})", , , , "3123456789", , , [9, 10, 11]], [, , "80(?:0\\d{6}|3\\d{3})", , , , "800123456", , , [6, 9]], [, , "0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{6}|[17]\\d{3})", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", 
, , , "5512345678", , , [10]], "VA", 39, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , "848\\d{6}", , , , "848123456", , , [9]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]]], VC:[, [, , "[5789]\\d{9}", , , , , , , [10], [7]], [, , "784(?:266|3(?:6[6-9]|7\\d|8[0-24-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}", , , , "7842661234", , , , [7]], [, , "784(?:4(?:3[0-4]|5[45]|89|9[0-58])|5(?:2[6-9]|3[0-4]))\\d{4}", , , , "7844301234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", 
, , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VC", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "784", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VE:[, [, , "[24589]\\d{9}", , , , , , , [10], [7]], [, , "(?:2(?:12|3[457-9]|[58][1-9]|[467]\\d|9[1-6])|50[01])\\d{7}", , , , "2121234567", , , , [7]], [, , "4(?:1[24-8]|2[46])\\d{7}", 
, , , "4121234567"], [, , "800\\d{7}", , , , "8001234567"], [, , "900\\d{7}", , , , "9001234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "VE", 58, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{7})", "$1-$2", , "0$1", "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VG:[, [, , "[2589]\\d{9}", , , , , , , [10], [7]], [, , "284(?:(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}|496[0-5]\\d{3})", 
, , , "2842291234", , , , [7]], [, , "284(?:(?:3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|99)|54[0-57])\\d{4}|496[6-9]\\d{3})", , , , "2843001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VG", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "284", [, , , , , , , , , [-1]], [, , , , , , 
, , , [-1]], , , [, , , , , , , , , [-1]]], VI:[, [, , "[3589]\\d{9}", , , , , , , [10], [7]], [, , "340(?:2(?:01|2[0678]|44|77)|3(?:32|44)|4(?:22|7[34])|5(?:1[34]|55)|6(?:26|4[23]|77|9[023])|7(?:1[2-589]|27|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], [, , "340(?:2(?:01|2[0678]|44|77)|3(?:32|44)|4(?:22|7[34])|5(?:1[34]|55)|6(?:26|4[23]|77|9[023])|7(?:1[2-589]|27|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , 
"900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VI", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "340", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VN:[, [, , "[167]\\d{6,9}|[2-59]\\d{7,9}|8\\d{6,8}", , , , , , , [7, 8, 9, 10]], [, , "(?:2(?:0[3-9]|1[0-689]|2[0-25-9]|3[2-9]|[48][02-9]|5[124-9]?|6[0-39]?|7[0-7]?|9[0-4679])\\d|3(?:[0136]|[25][01])\\d|4\\d{2}|5(?:0[01]|[5-9])\\d|6(?:[0-46-8]|5[01])\\d|7(?:[02-79]|[18][01])\\d)\\d{6}|8(?:[2-5]\\d|6[236]|7[13])\\d{6}", 
, , , "2101234567", , , [9, 10]], [, , "(?:9\\d|1(?:2\\d|6[2-9]|8[68]|99))\\d{7}|8(?:6[89]|8\\d|9[89])\\d{6}", , , , "912345678", , , [9, 10]], [, , "1800\\d{4,6}", , , , "1800123456", , , [8, 9, 10]], [, , "1900\\d{4,6}", , , , "1900123456", , , [8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "VN", 84, "00", "0", , , "0", , , , [[, "([17]99)(\\d{4})", "$1 $2", ["[17]99"], "0$1", , 1], [, "([48])(\\d{4})(\\d{4})", "$1 $2 $3", ["4|8(?:[2-5]|6[236]|7[13])"], 
"0$1", , 1], [, "([235-7]\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["2[5-7]|3[0136]|5[5-9]|6[0-46-8]|7[02-79]"], "0$1", , 1], [, "(80)(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(69\\d)(\\d{4,5})", "$1 $2", ["69"], "0$1", , 1], [, "([235-7]\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["2(?:[0-489]|5[124-9]|6[0-39]|7[0-7])|3[25]|50|65|7[18]"], "0$1", , 1], [, "([89]\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8(?:8|9[89])|9"], "0$1", , 1], [, "(1[2689]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:[26]|8[68]|99)"], 
"0$1", , 1], [, "(86[89])(\\d{3})(\\d{3})", "$1 $2 $3", ["86[89]"], "0$1", , 1], [, "(1[89]00)(\\d{4,6})", "$1 $2", ["1[89]0"], "$1", , 1]], , [, , , , , , , , , [-1]], , , [, , "[17]99\\d{4}|69\\d{5,6}", , , , "1992000", , , [7, 8]], [, , "[17]99\\d{4}|69\\d{5,6}|80\\d{5}", , , , "1992000", , , [7, 8]], , , [, , , , , , , , , [-1]]], VU:[, [, , "[2-57-9]\\d{4,6}", , , , , , , [5, 7]], [, , "(?:2[02-9]\\d|3(?:[5-7]\\d|8[0-8])|48[4-9]|88\\d)\\d{2}", , , , "22123", , , [5]], [, , "(?:5(?:7[2-5]|[0-689]\\d)|7[013-7]\\d)\\d{4}", 
, , , "5912345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "VU", 678, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[579]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "3[03]\\d{3}|900\\d{4}", , , , "30123"], , , [, , , , , , , , , [-1]]], WF:[, [, , "[4-8]\\d{5}", , , , , , , [6]], [, , "(?:50|68|72)\\d{4}", , , , "501234"], [, , "(?:50|68|72|8[23])\\d{4}", , , , "501234"], 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WF", 681, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "[48]0\\d{4}", , , , "401234"]], WS:[, [, , "[2-8]\\d{4,6}", , , , , , , [5, 6, 7]], [, , "(?:[2-5]\\d|6[1-9]|84\\d{2})\\d{3}", , , , "22123", , , [5, 7]], [, , "(?:60|7[25-7]\\d)\\d{4}", , , , "601234", 
, , [6, 7]], [, , "800\\d{3}", , , , "800123", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WS", 685, "0", , , , , , , , [[, "(8\\d{2})(\\d{3,4})", "$1 $2", ["8"]], [, "(7\\d)(\\d{5})", "$1 $2", ["7"]], [, "(\\d{5})", "$1", ["[2-6]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], YE:[, [, , "[1-7]\\d{6,8}", , , , , , , [7, 8, 9], [6]], [, , "(?:1(?:7\\d|[2-68])|2[2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-68])\\d{5}", 
, , , "1234567", , , [7, 8], [6]], [, , "7[0137]\\d{7}", , , , "712345678", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "YE", 967, "00", "0", , , "0", , , , [[, "([1-7])(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7[24-68]"], "0$1"], [, "(7\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["7[0137]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 
YT:[, [, , "[268]\\d{8}", , , , , , , [9]], [, , "269(?:6[0-4]|50)\\d{4}", , , , "269601234"], [, , "639(?:0[0-79]|1[019]|[26]\\d|3[09]|[45]0|7[06]|9[04-79])\\d{4}", , , , "639012345"], [, , "80\\d{7}", , , , "801234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "YT", 262, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , "269|63", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ZA:[, [, , "[1-79]\\d{8}|8\\d{4,8}", 
, , , , , , [5, 6, 7, 8, 9]], [, , "(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", , , , "101234567", , , [9]], [, , "(?:6\\d|7[0-46-9])\\d{7}|8(?:[1-4]\\d{1,5}|5\\d{5})\\d{2}", , , , "711234567"], [, , "80\\d{7}", , , , "801234567", , , [9]], [, , "86[2-9]\\d{6}|9[0-2]\\d{7}", , , , "862345678", , , [9]], [, , "860\\d{6}", , , , "860123456", , , [9]], [, , , , , , , , , [-1]], [, , "87\\d{7}", , , , "871234567", , , [9]], "ZA", 27, "00", "0", , , "0", , , , [[, "(860)(\\d{3})(\\d{3})", "$1 $2 $3", 
["860"], "0$1"], [, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-79]|8(?:[0-57]|6[1-9])"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "861\\d{6}", , , , "861123456", , , [9]], , , [, , , , , , , , , [-1]]], ZM:[, [, , "[289]\\d{8}", , , , , , , [9]], [, , "21[1-8]\\d{6}", , , , "211234567"], [, , "9(?:5[034589]|[67]\\d)\\d{6}", , , , "955123456"], [, 
, "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ZM", 260, "00", "0", , , "0", , , , [[, "([29]\\d)(\\d{7})", "$1 $2", ["[29]"], "0$1"], [, "(800)(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ZW:[, [, , "2(?:[0-2457-9]\\d{3,8}|6(?:[14]\\d{7}|\\d{4}))|[13-79]\\d{4,9}|8[06]\\d{8}", , , , , , , [5, 
6, 7, 8, 9, 10], [3, 4]], [, , "(?:2(?:0(?:4\\d|5\\d{2})|2[278]\\d|48\\d|7(?:[1-7]\\d|[089]\\d{2})|8(?:[2-57-9]|[146]\\d{2})|98)|3(?:08|17|3[78]|7(?:[19]|[56]\\d)|8[37]|98)|5[15][78]|6(?:28\\d{2}|37|6[78]|75\\d|98|8(?:7\\d|8)))\\d{3}|(?:2(?:1[39]|2[0157]|31|[56][14]|7[35]|84)|329)\\d{7}|(?:1(?:3\\d{2}|[4-8]|9\\d)|2(?:0\\d{2}|12|292|[569]\\d)|3(?:[26]|[013459]\\d)|5(?:0|1[2-4]|26|[37]2|5\\d{2}|[689]\\d)|6(?:[39]|[01246]\\d|[78]\\d{2}))\\d{3}|(?:29\\d|39|54)\\d{6}|(?:(?:25|54)83\\d|2582\\d{2}|65[2-8])\\d{2}|(?:4\\d{6,7}|9[2-9]\\d{4,5})", 
, , , "1312345", , , , [3, 4]], [, , "7[1378]\\d{7}", , , , "711234567", , , [9]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "86(?:1[12]|30|44|55|77|8[367]|99)\\d{6}", , , , "8686123456", , , [10]], "ZW", 263, "00", "0", , , "0", , , , [[, "([49])(\\d{3})(\\d{2,4})", "$1 $2 $3", ["4|9[2-9]"], "0$1"], [, "(7\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["7"], "0$1"], [, "(86\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["86[24]"], 
"0$1"], [, "([2356]\\d{2})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8|[78])|3(?:08|17|3[78]|7[1569]|8[37]|98)|5[15][78]|6(?:[29]8|[38]7|6[78]|75|[89]8)"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|31|[56][14]|7[35]|84)|329"], "0$1"], [, "([1-356]\\d)(\\d{3,5})", "$1 $2", ["1[3-9]|2[02569]|3[0-69]|5[05689]|6\\d"], "0$1"], [, "([235]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[23]9|54"], "0$1"], [, "([25]\\d{3})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258[23]|5483"], "0$1"], 
[, "(8\\d{3})(\\d{6})", "$1 $2", ["86"], "0$1"], [, "(80\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 800:[, [, , "\\d{8}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "\\d{8}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 800, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", 
"$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]]], 808:[, [, , "\\d{8}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "\\d{8}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 808, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
1, , [, , , , , , , , , [-1]]], 870:[, [, , "[35-7]\\d{8}", , , , , , , [9]], [, , , , , , , , , [-1]], [, , "(?:[356]\\d|7[6-8])\\d{7}", , , , "301234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 870, , , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 878:[, [, , "1\\d{11}", 
, , , , , , [12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "10\\d{10}", , , , "101234567890"], "001", 878, , , , , , , , 1, [[, "(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 881:[, [, , "[67]\\d{8}", , , , , , , [9]], [, , , , , , , , , [-1]], [, , "[67]\\d{8}", , , , 
"612345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 881, , , , , , , , , [[, "(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[67]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 882:[, [, , "[13]\\d{6,11}", , , , , , , [7, 8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , "3(?:2\\d{3}|37\\d{2}|4(?:2|7\\d{3}))\\d{4}", , , , "3421234", , 
, [7, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15678]|9[0689])\\d{4}|6\\d{5,10})|3(?:45|9\\d{3})\\d{7}", , , , "390123456789"], "001", 882, , , , , , , , , [[, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["34[57]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["348"]], 
[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], [, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["16|39"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "348[57]\\d{7}", , , , "34851234567", , , [11]]], 883:[, [, , "51\\d{7}(?:\\d{3})?", , , , , , , [9, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , 
, , , , , [-1]], [, , "51(?:00\\d{5}(?:\\d{3})?|[13]0\\d{8})", , , , "510012345"], "001", 883, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["510"]], [, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 888:[, [, , "\\d{11}", , , , , , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , 
, , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 888, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "\\d{11}", , , , "12345678901"], 1, , [, , , , , , , , , [-1]]], 979:[, [, , "\\d{9}", , , , , , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "\\d{9}", , , , "123456789"], [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 979, , , , , , , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]]]};
/*

 Copyright (C) 2010 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.PhoneNumberUtil = function() {
  this.regionToMetadataMap = {};
};
goog.addSingletonGetter(i18n.phonenumbers.PhoneNumberUtil);
i18n.phonenumbers.Error = {INVALID_COUNTRY_CODE:"Invalid country calling code", NOT_A_NUMBER:"The string supplied did not seem to be a phone number", TOO_SHORT_AFTER_IDD:"Phone number too short after IDD", TOO_SHORT_NSN:"The string supplied is too short to be a phone number", TOO_LONG:"The string supplied is too long to be a phone number"};
i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ = 1;
i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ = 2;
i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_ = 17;
i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ = 3;
i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_ = 250;
i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ = "ZZ";
i18n.phonenumbers.PhoneNumberUtil.COLOMBIA_MOBILE_TO_FIXED_LINE_PREFIX_ = "3";
i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_ = {52:"1", 54:"9"};
i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_ = [52, 54, 55];
i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN = "+";
i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ = "*";
i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ = ";ext=";
i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ = "tel:";
i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_ = ";phone-context=";
i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_ = ";isub=";
i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS = {0:"0", 1:"1", 2:"2", 3:"3", 4:"4", 5:"5", 6:"6", 7:"7", 8:"8", 9:"9", "\uff10":"0", "\uff11":"1", "\uff12":"2", "\uff13":"3", "\uff14":"4", "\uff15":"5", "\uff16":"6", "\uff17":"7", "\uff18":"8", "\uff19":"9", "\u0660":"0", "\u0661":"1", "\u0662":"2", "\u0663":"3", "\u0664":"4", "\u0665":"5", "\u0666":"6", "\u0667":"7", "\u0668":"8", "\u0669":"9", "\u06f0":"0", "\u06f1":"1", "\u06f2":"2", "\u06f3":"3", "\u06f4":"4", "\u06f5":"5", "\u06f6":"6", "\u06f7":"7", 
"\u06f8":"8", "\u06f9":"9"};
i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_ = {0:"0", 1:"1", 2:"2", 3:"3", 4:"4", 5:"5", 6:"6", 7:"7", 8:"8", 9:"9", "+":i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN, "*":"*", "#":"#"};
i18n.phonenumbers.PhoneNumberUtil.ALPHA_MAPPINGS_ = {A:"2", B:"2", C:"2", D:"3", E:"3", F:"3", G:"4", H:"4", I:"4", J:"5", K:"5", L:"5", M:"6", N:"6", O:"6", P:"7", Q:"7", R:"7", S:"7", T:"8", U:"8", V:"8", W:"9", X:"9", Y:"9", Z:"9"};
i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_ = {0:"0", 1:"1", 2:"2", 3:"3", 4:"4", 5:"5", 6:"6", 7:"7", 8:"8", 9:"9", "\uff10":"0", "\uff11":"1", "\uff12":"2", "\uff13":"3", "\uff14":"4", "\uff15":"5", "\uff16":"6", "\uff17":"7", "\uff18":"8", "\uff19":"9", "\u0660":"0", "\u0661":"1", "\u0662":"2", "\u0663":"3", "\u0664":"4", "\u0665":"5", "\u0666":"6", "\u0667":"7", "\u0668":"8", "\u0669":"9", "\u06f0":"0", "\u06f1":"1", "\u06f2":"2", "\u06f3":"3", "\u06f4":"4", "\u06f5":"5", "\u06f6":"6", 
"\u06f7":"7", "\u06f8":"8", "\u06f9":"9", A:"2", B:"2", C:"2", D:"3", E:"3", F:"3", G:"4", H:"4", I:"4", J:"5", K:"5", L:"5", M:"6", N:"6", O:"6", P:"7", Q:"7", R:"7", S:"7", T:"8", U:"8", V:"8", W:"9", X:"9", Y:"9", Z:"9"};
i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_ = {0:"0", 1:"1", 2:"2", 3:"3", 4:"4", 5:"5", 6:"6", 7:"7", 8:"8", 9:"9", A:"A", B:"B", C:"C", D:"D", E:"E", F:"F", G:"G", H:"H", I:"I", J:"J", K:"K", L:"L", M:"M", N:"N", O:"O", P:"P", Q:"Q", R:"R", S:"S", T:"T", U:"U", V:"V", W:"W", X:"X", Y:"Y", Z:"Z", a:"A", b:"B", c:"C", d:"D", e:"E", f:"F", g:"G", h:"H", i:"I", j:"J", k:"K", l:"L", m:"M", n:"N", o:"O", p:"P", q:"Q", r:"R", s:"S", t:"T", u:"U", v:"V", w:"W", x:"X", y:"Y", z:"Z", 
"-":"-", "\uff0d":"-", "\u2010":"-", "\u2011":"-", "\u2012":"-", "\u2013":"-", "\u2014":"-", "\u2015":"-", "\u2212":"-", "/":"/", "\uff0f":"/", " ":" ", "\u3000":" ", "\u2060":" ", ".":".", "\uff0e":"."};
i18n.phonenumbers.PhoneNumberUtil.UNIQUE_INTERNATIONAL_PREFIX_ = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/;
i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION = "-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e";
i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ = "0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9";
i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ = "A-Za-z";
i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ = "+\uff0b";
i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+");
i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN_ = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+");
i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]+";
i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN = new RegExp("([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "])");
i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_ = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]");
i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_ = /[\\\/] *x/;
i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_ = new RegExp("[^" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + "#]+$");
i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_ = /(?:.*?[A-Za-z]){3}.*/;
i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ + "}";
i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ = "[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]*(?:[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + "]*[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]){3,}[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]*";
i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ = " ext. ";
i18n.phonenumbers.PhoneNumberUtil.CAPTURING_EXTN_DIGITS_ = "([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{1,7})";
i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERNS_FOR_PARSING_ = i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.CAPTURING_EXTN_DIGITS_ + "|[ \u00a0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\u00f3))?n?|\uff45?\uff58\uff54\uff4e?|[;,x\uff58#\uff03~\uff5e]|int|anexo|\uff49\uff4e\uff54)[:\\.\uff0e]?[ \u00a0\\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.CAPTURING_EXTN_DIGITS_ + "#?|[- ]+([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{1,5})#";
i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_ = new RegExp("(?:" + i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERNS_FOR_PARSING_ + ")$", "i");
i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_ = new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ + "$|^" + i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ + "(?:" + i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERNS_FOR_PARSING_ + ")?$", "i");
i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_ = /\D+/;
i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_ = /(\$\d)/;
i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_ = /\$NP/;
i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_ = /\$FG/;
i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_ = /\$CC/;
i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_ = /^\(?\$1\)?$/;
i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY = "001";
i18n.phonenumbers.PhoneNumberFormat = {E164:0, INTERNATIONAL:1, NATIONAL:2, RFC3966:3};
i18n.phonenumbers.PhoneNumberType = {FIXED_LINE:0, MOBILE:1, FIXED_LINE_OR_MOBILE:2, TOLL_FREE:3, PREMIUM_RATE:4, SHARED_COST:5, VOIP:6, PERSONAL_NUMBER:7, PAGER:8, UAN:9, VOICEMAIL:10, UNKNOWN:-1};
i18n.phonenumbers.PhoneNumberUtil.MatchType = {NOT_A_NUMBER:0, NO_MATCH:1, SHORT_NSN_MATCH:2, NSN_MATCH:3, EXACT_MATCH:4};
i18n.phonenumbers.PhoneNumberUtil.ValidationResult = {IS_POSSIBLE:0, IS_POSSIBLE_LOCAL_ONLY:4, INVALID_COUNTRY_CODE:1, TOO_SHORT:2, INVALID_LENGTH:5, TOO_LONG:3};
i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber = function(a) {
  var b = a.search(i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_);
  0 <= b ? (a = a.substring(b), a = a.replace(i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_, ""), b = a.search(i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_), 0 <= b && (a = a.substring(0, b))) : a = "";
  return a;
};
i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber = function(a) {
  return a.length < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_, a);
};
i18n.phonenumbers.PhoneNumberUtil.normalize = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a) ? i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !0) : i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);
};
i18n.phonenumbers.PhoneNumberUtil.normalizeSB_ = function(a) {
  var b = i18n.phonenumbers.PhoneNumberUtil.normalize(a.toString());
  a.clear();
  a.append(b);
};
i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS, !0);
};
i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_, !0);
};
i18n.phonenumbers.PhoneNumberUtil.convertAlphaCharactersInNumber = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !1);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfGeographicalAreaCode = function(a) {
  var b = this.getMetadataForRegion(this.getRegionCodeForNumber(a));
  return null != b && (b.hasNationalPrefix() || a.hasItalianLeadingZero()) && this.isNumberGeographical(a) ? this.getLengthOfNationalDestinationCode(a) : 0;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfNationalDestinationCode = function(a) {
  if (a.hasExtension()) {
    var b = a.clone();
    b.clearExtension();
  } else {
    b = a;
  }
  b = this.format(b, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).split(i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_);
  0 == b[0].length && b.shift();
  return 2 >= b.length ? 0 : this.getNumberType(a) == i18n.phonenumbers.PhoneNumberType.MOBILE && (a = i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken(a.getCountryCodeOrDefault()), "" != a) ? b[2].length + a.length : b[1].length;
};
i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_[a] || "";
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedRegions = function() {
  return goog.array.filter(Object.keys(i18n.phonenumbers.metadata.countryToMetadata), function(a) {
    return isNaN(a);
  });
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedGlobalNetworkCallingCodes = function() {
  var a = goog.array.filter(Object.keys(i18n.phonenumbers.metadata.countryToMetadata), function(a) {
    return !isNaN(a);
  });
  return goog.array.map(a, function(a) {
    return parseInt(a, 10);
  });
};
i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_ = function(a) {
  return null != a && (1 != a.possibleLengthCount() || -1 != a.possibleLengthArray()[0]);
};
i18n.phonenumbers.PhoneNumberUtil.descHasData_ = function(a) {
  return null != a && (a.hasExampleNumber() || i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(a) || a.hasNationalNumberPattern());
};
i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_ = function(a) {
  var b = [];
  goog.object.forEach(i18n.phonenumbers.PhoneNumberType, function(c) {
    if (c != i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE && c != i18n.phonenumbers.PhoneNumberType.UNKNOWN) {
      var d = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(a, c);
      i18n.phonenumbers.PhoneNumberUtil.descHasData_(d) && b.push(c);
    }
  });
  return b;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForRegion = function(a) {
  return this.isValidRegionCode_(a) ? i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(this.getMetadataForRegion(a)) : [];
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForNonGeoEntity = function(a) {
  a = this.getMetadataForNonGeographicalRegion(a);
  return null == a ? [] : i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(a);
};
i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_ = function(a, b, c) {
  for (var d = new goog.string.StringBuffer, e, f, g = a.length, h = 0; h < g; ++h) {
    e = a.charAt(h), f = b[e.toUpperCase()], null != f ? d.append(f) : c || d.append(e);
  }
  return d.toString();
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formattingRuleHasFirstGroupOnly = function(a) {
  return 0 == a.length || i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_.test(a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberGeographical = function(a) {
  var b = this.getNumberType(a);
  return b == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || b == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE || goog.array.contains(i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_, a.getCountryCodeOrDefault()) && b == i18n.phonenumbers.PhoneNumberType.MOBILE;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isValidRegionCode_ = function(a) {
  return null != a && isNaN(a) && a.toUpperCase() in i18n.phonenumbers.metadata.countryToMetadata;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.hasValidCountryCallingCode_ = function(a) {
  return a in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.format = function(a, b) {
  if (0 == a.getNationalNumber() && a.hasRawInput()) {
    var c = a.getRawInputOrDefault();
    if (0 < c.length) {
      return c;
    }
  }
  var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
  if (b == i18n.phonenumbers.PhoneNumberFormat.E164) {
    return this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.E164, d, "");
  }
  if (!this.hasValidCountryCallingCode_(c)) {
    return d;
  }
  var e = this.getRegionCodeForCountryCode(c), f = this.getMetadataForRegionOrCallingCode_(c, e), e = this.maybeGetFormattedExtension_(a, f, b), d = this.formatNsn_(d, f, b);
  return this.prefixNumberWithCountryCallingCode_(c, b, d, e);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatByPattern = function(a, b, c) {
  var d = a.getCountryCodeOrDefault(), e = this.getNationalSignificantNumber(a);
  if (!this.hasValidCountryCallingCode_(d)) {
    return e;
  }
  var f = this.getRegionCodeForCountryCode(d), f = this.getMetadataForRegionOrCallingCode_(d, f), g = this.chooseFormattingPatternForNumber_(c, e);
  if (null != g) {
    c = g.clone();
    g = g.getNationalPrefixFormattingRuleOrDefault();
    if (0 < g.length) {
      var h = f.getNationalPrefixOrDefault();
      0 < h.length ? (g = g.replace(i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_, h).replace(i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_, "$1"), c.setNationalPrefixFormattingRule(g)) : c.clearNationalPrefixFormattingRule();
    }
    e = this.formatNsnUsingPattern_(e, c, b);
  }
  a = this.maybeGetFormattedExtension_(a, f, b);
  return this.prefixNumberWithCountryCallingCode_(d, b, e, a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithCarrierCode = function(a, b) {
  var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
  if (!this.hasValidCountryCallingCode_(c)) {
    return d;
  }
  var e = this.getRegionCodeForCountryCode(c), f = this.getMetadataForRegionOrCallingCode_(c, e), e = this.maybeGetFormattedExtension_(a, f, i18n.phonenumbers.PhoneNumberFormat.NATIONAL), d = this.formatNsn_(d, f, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, b);
  return this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, d, e);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegionOrCallingCode_ = function(a, b) {
  return i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == b ? this.getMetadataForNonGeographicalRegion(a) : this.getMetadataForRegion(b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithPreferredCarrierCode = function(a, b) {
  return this.formatNationalNumberWithCarrierCode(a, 0 < a.getPreferredDomesticCarrierCodeOrDefault().length ? a.getPreferredDomesticCarrierCodeOrDefault() : b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNumberForMobileDialing = function(a, b, c) {
  var d = a.getCountryCodeOrDefault();
  if (!this.hasValidCountryCallingCode_(d)) {
    return a.hasRawInput() ? a.getRawInputOrDefault() : "";
  }
  var e = "";
  a = a.clone();
  a.clearExtension();
  var f = this.getRegionCodeForCountryCode(d), g = this.getNumberType(a), h = g != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
  if (b == f) {
    e = g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || g == i18n.phonenumbers.PhoneNumberType.MOBILE || g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE, "CO" == f && g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE ? e = this.formatNationalNumberWithCarrierCode(a, i18n.phonenumbers.PhoneNumberUtil.COLOMBIA_MOBILE_TO_FIXED_LINE_PREFIX_) : "BR" == f && e ? e = 0 < a.getPreferredDomesticCarrierCodeOrDefault().length ? this.formatNationalNumberWithPreferredCarrierCode(a, "") : "" : 
    h && "HU" == f ? e = this.getNddPrefixForRegion(f, !0) + " " + this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL) : d == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ ? (b = this.getMetadataForRegion(b), e = this.canBeInternationallyDialled(a) && this.testNumberLength_(this.getNationalSignificantNumber(a), b) != i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL)) : 
    e = (f == i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY || ("MX" == f || "CL" == f) && e) && this.canBeInternationallyDialled(a) ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
  } else {
    if (h && this.canBeInternationallyDialled(a)) {
      return c ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.E164);
    }
  }
  return c ? e : i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(e);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryCallingNumber = function(a, b) {
  if (!this.isValidRegionCode_(b)) {
    return this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
  }
  var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
  if (!this.hasValidCountryCallingCode_(c)) {
    return d;
  }
  if (c == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
    if (this.isNANPACountry(b)) {
      return c + " " + this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
    }
  } else {
    if (c == this.getCountryCodeForValidRegion_(b)) {
      return this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
    }
  }
  var e = this.getMetadataForRegion(b), f = e.getInternationalPrefixOrDefault(), g = "";
  i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(i18n.phonenumbers.PhoneNumberUtil.UNIQUE_INTERNATIONAL_PREFIX_, f) ? g = f : e.hasPreferredInternationalPrefix() && (g = e.getPreferredInternationalPrefixOrDefault());
  e = this.getRegionCodeForCountryCode(c);
  e = this.getMetadataForRegionOrCallingCode_(c, e);
  d = this.formatNsn_(d, e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
  e = this.maybeGetFormattedExtension_(a, e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
  return 0 < g.length ? g + " " + c + " " + d + e : this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, d, e);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatInOriginalFormat = function(a, b) {
  if (a.hasRawInput() && (this.hasUnexpectedItalianLeadingZero_(a) || !this.hasFormattingPatternForNumber_(a))) {
    return a.getRawInputOrDefault();
  }
  if (!a.hasCountryCodeSource()) {
    return this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
  }
  switch(a.getCountryCodeSource()) {
    case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN:
      var c = this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
      break;
    case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:
      c = this.formatOutOfCountryCallingNumber(a, b);
      break;
    case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN:
      c = this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).substring(1);
      break;
    default:
      var d = this.getRegionCodeForCountryCode(a.getCountryCodeOrDefault()), e = this.getNddPrefixForRegion(d, !0);
      c = this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
      if (null != e && 0 != e.length && !this.rawInputContainsNationalPrefix_(a.getRawInputOrDefault(), e, d) && (d = this.getMetadataForRegion(d), e = this.getNationalSignificantNumber(a), d = this.chooseFormattingPatternForNumber_(d.numberFormatArray(), e), null != d)) {
        var e = d.getNationalPrefixFormattingRuleOrDefault(), f = e.indexOf("$1");
        0 >= f || (e = e.substring(0, f), e = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(e), 0 != e.length && (c = d.clone(), c.clearNationalPrefixFormattingRule(), c = this.formatByPattern(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, [c])));
      }
  }
  d = a.getRawInputOrDefault();
  null != c && 0 < d.length && (e = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(c), f = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(d), e != f && (c = d));
  return c;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.rawInputContainsNationalPrefix_ = function(a, b, c) {
  a = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);
  if (goog.string.startsWith(a, b)) {
    try {
      return this.isValidNumber(this.parse(a.substring(b.length), c));
    } catch (d) {
    }
  }
  return !1;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.hasUnexpectedItalianLeadingZero_ = function(a) {
  return a.hasItalianLeadingZero() && !this.isLeadingZeroPossible(a.getCountryCodeOrDefault());
};
i18n.phonenumbers.PhoneNumberUtil.prototype.hasFormattingPatternForNumber_ = function(a) {
  var b = a.getCountryCodeOrDefault(), c = this.getRegionCodeForCountryCode(b), b = this.getMetadataForRegionOrCallingCode_(b, c);
  if (null == b) {
    return !1;
  }
  a = this.getNationalSignificantNumber(a);
  return null != this.chooseFormattingPatternForNumber_(b.numberFormatArray(), a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryKeepingAlphaChars = function(a, b) {
  var c = a.getRawInputOrDefault();
  if (0 == c.length) {
    return this.formatOutOfCountryCallingNumber(a, b);
  }
  var d = a.getCountryCodeOrDefault();
  if (!this.hasValidCountryCallingCode_(d)) {
    return c;
  }
  var c = i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(c, i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_, !0), e = this.getNationalSignificantNumber(a);
  if (3 < e.length) {
    var f = c.indexOf(e.substring(0, 3));
    -1 != f && (c = c.substring(f));
  }
  f = this.getMetadataForRegion(b);
  if (d == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
    if (this.isNANPACountry(b)) {
      return d + " " + c;
    }
  } else {
    if (null != f && d == this.getCountryCodeForValidRegion_(b)) {
      d = this.chooseFormattingPatternForNumber_(f.numberFormatArray(), e);
      if (null == d) {
        return c;
      }
      d = d.clone();
      d.setPattern("(\\d+)(.*)");
      d.setFormat("$1$2");
      return this.formatNsnUsingPattern_(c, d, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
    }
  }
  e = "";
  null != f && (e = f.getInternationalPrefixOrDefault(), e = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(i18n.phonenumbers.PhoneNumberUtil.UNIQUE_INTERNATIONAL_PREFIX_, e) ? e : f.getPreferredInternationalPrefixOrDefault());
  f = this.getRegionCodeForCountryCode(d);
  f = this.getMetadataForRegionOrCallingCode_(d, f);
  f = this.maybeGetFormattedExtension_(a, f, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
  return 0 < e.length ? e + " " + d + " " + c + f : this.prefixNumberWithCountryCallingCode_(d, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, c, f);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNationalSignificantNumber = function(a) {
  var b = "" + a.getNationalNumber();
  return a.hasItalianLeadingZero() && a.getItalianLeadingZero() && 0 < a.getNumberOfLeadingZerosOrDefault() ? Array(a.getNumberOfLeadingZerosOrDefault() + 1).join("0") + b : b;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.prefixNumberWithCountryCallingCode_ = function(a, b, c, d) {
  switch(b) {
    case i18n.phonenumbers.PhoneNumberFormat.E164:
      return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + c + d;
    case i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL:
      return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + " " + c + d;
    case i18n.phonenumbers.PhoneNumberFormat.RFC3966:
      return i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + "-" + c + d;
    default:
      return c + d;
  }
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsn_ = function(a, b, c, d) {
  b = 0 == b.intlNumberFormatArray().length || c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL ? b.numberFormatArray() : b.intlNumberFormatArray();
  b = this.chooseFormattingPatternForNumber_(b, a);
  return null == b ? a : this.formatNsnUsingPattern_(a, b, c, d);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.chooseFormattingPatternForNumber_ = function(a, b) {
  for (var c, d = a.length, e = 0; e < d; ++e) {
    c = a[e];
    var f = c.leadingDigitsPatternCount();
    if (0 == f || 0 == b.search(c.getLeadingDigitsPattern(f - 1))) {
      if (f = new RegExp(c.getPattern()), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(f, b)) {
        return c;
      }
    }
  }
  return null;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsnUsingPattern_ = function(a, b, c, d) {
  var e = b.getFormatOrDefault(), f = new RegExp(b.getPattern()), g = b.getDomesticCarrierCodeFormattingRuleOrDefault();
  c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && null != d && 0 < d.length && 0 < g.length ? (b = g.replace(i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_, d), e = e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b), a = a.replace(f, e)) : (b = b.getNationalPrefixFormattingRuleOrDefault(), a = c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && null != b && 0 < b.length ? a.replace(f, e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b)) : a.replace(f, e));
  c == i18n.phonenumbers.PhoneNumberFormat.RFC3966 && (a = a.replace(new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_), ""), a = a.replace(new RegExp(i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_, "g"), "-"));
  return a;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumber = function(a) {
  return this.getExampleNumberForType(a, i18n.phonenumbers.PhoneNumberType.FIXED_LINE);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForType = function(a, b) {
  if (!this.isValidRegionCode_(a)) {
    return null;
  }
  var c = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(this.getMetadataForRegion(a), b);
  try {
    if (c.hasExampleNumber()) {
      return this.parse(c.getExampleNumber(), a);
    }
  } catch (d) {
  }
  return null;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForNonGeoEntity = function(a) {
  var b = this.getMetadataForNonGeographicalRegion(a);
  if (null != b && (b = goog.array.find([b.getMobile(), b.getTollFree(), b.getSharedCost(), b.getVoip(), b.getVoicemail(), b.getUan(), b.getPremiumRate()], function(a, b) {
    return a.hasExampleNumber();
  }), null != b)) {
    try {
      return this.parse("+" + a + b.getExampleNumber(), "ZZ");
    } catch (c) {
    }
  }
  return null;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeGetFormattedExtension_ = function(a, b, c) {
  return a.hasExtension() && 0 != a.getExtension().length ? c == i18n.phonenumbers.PhoneNumberFormat.RFC3966 ? i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + a.getExtension() : b.hasPreferredExtnPrefix() ? b.getPreferredExtnPrefix() + a.getExtensionOrDefault() : i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ + a.getExtensionOrDefault() : "";
};
i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_ = function(a, b) {
  switch(b) {
    case i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:
      return a.getPremiumRate();
    case i18n.phonenumbers.PhoneNumberType.TOLL_FREE:
      return a.getTollFree();
    case i18n.phonenumbers.PhoneNumberType.MOBILE:
      return a.getMobile();
    case i18n.phonenumbers.PhoneNumberType.FIXED_LINE:
    case i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:
      return a.getFixedLine();
    case i18n.phonenumbers.PhoneNumberType.SHARED_COST:
      return a.getSharedCost();
    case i18n.phonenumbers.PhoneNumberType.VOIP:
      return a.getVoip();
    case i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:
      return a.getPersonalNumber();
    case i18n.phonenumbers.PhoneNumberType.PAGER:
      return a.getPager();
    case i18n.phonenumbers.PhoneNumberType.UAN:
      return a.getUan();
    case i18n.phonenumbers.PhoneNumberType.VOICEMAIL:
      return a.getVoicemail();
    default:
      return a.getGeneralDesc();
  }
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberType = function(a) {
  var b = this.getRegionCodeForNumber(a), b = this.getMetadataForRegionOrCallingCode_(a.getCountryCodeOrDefault(), b);
  if (null == b) {
    return i18n.phonenumbers.PhoneNumberType.UNKNOWN;
  }
  a = this.getNationalSignificantNumber(a);
  return this.getNumberTypeHelper_(a, b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberTypeHelper_ = function(a, b) {
  return this.isNumberMatchingDesc_(a, b.getGeneralDesc()) ? this.isNumberMatchingDesc_(a, b.getPremiumRate()) ? i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE : this.isNumberMatchingDesc_(a, b.getTollFree()) ? i18n.phonenumbers.PhoneNumberType.TOLL_FREE : this.isNumberMatchingDesc_(a, b.getSharedCost()) ? i18n.phonenumbers.PhoneNumberType.SHARED_COST : this.isNumberMatchingDesc_(a, b.getVoip()) ? i18n.phonenumbers.PhoneNumberType.VOIP : this.isNumberMatchingDesc_(a, b.getPersonalNumber()) ? i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER : 
  this.isNumberMatchingDesc_(a, b.getPager()) ? i18n.phonenumbers.PhoneNumberType.PAGER : this.isNumberMatchingDesc_(a, b.getUan()) ? i18n.phonenumbers.PhoneNumberType.UAN : this.isNumberMatchingDesc_(a, b.getVoicemail()) ? i18n.phonenumbers.PhoneNumberType.VOICEMAIL : this.isNumberMatchingDesc_(a, b.getFixedLine()) ? b.getSameMobileAndFixedLinePattern() || this.isNumberMatchingDesc_(a, b.getMobile()) ? i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE : i18n.phonenumbers.PhoneNumberType.FIXED_LINE : 
  !b.getSameMobileAndFixedLinePattern() && this.isNumberMatchingDesc_(a, b.getMobile()) ? i18n.phonenumbers.PhoneNumberType.MOBILE : i18n.phonenumbers.PhoneNumberType.UNKNOWN : i18n.phonenumbers.PhoneNumberType.UNKNOWN;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegion = function(a) {
  if (null == a) {
    return null;
  }
  a = a.toUpperCase();
  var b = this.regionToMetadataMap[a];
  if (null == b) {
    var b = new goog.proto2.PbLiteSerializer, c = i18n.phonenumbers.metadata.countryToMetadata[a];
    if (null == c) {
      return null;
    }
    b = b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), c);
    this.regionToMetadataMap[a] = b;
  }
  return b;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForNonGeographicalRegion = function(a) {
  return this.getMetadataForRegion("" + a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatchingDesc_ = function(a, b) {
  var c = a.length;
  return 0 < b.possibleLengthCount() && -1 == goog.array.indexOf(b.possibleLengthArray(), c) ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(b.getNationalNumberPatternOrDefault(), a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumber = function(a) {
  var b = this.getRegionCodeForNumber(a);
  return this.isValidNumberForRegion(a, b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumberForRegion = function(a, b) {
  var c = a.getCountryCodeOrDefault(), d = this.getMetadataForRegionOrCallingCode_(c, b);
  if (null == d || i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY != b && c != this.getCountryCodeForValidRegion_(b)) {
    return !1;
  }
  c = this.getNationalSignificantNumber(a);
  return this.getNumberTypeHelper_(c, d) != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumber = function(a) {
  if (null == a) {
    return null;
  }
  var b = a.getCountryCodeOrDefault(), b = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[b];
  return null == b ? null : 1 == b.length ? b[0] : this.getRegionCodeForNumberFromRegionList_(a, b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumberFromRegionList_ = function(a, b) {
  for (var c = this.getNationalSignificantNumber(a), d, e = b.length, f = 0; f < e; f++) {
    d = b[f];
    var g = this.getMetadataForRegion(d);
    if (g.hasLeadingDigits()) {
      if (0 == c.search(g.getLeadingDigits())) {
        return d;
      }
    } else {
      if (this.getNumberTypeHelper_(c, g) != i18n.phonenumbers.PhoneNumberType.UNKNOWN) {
        return d;
      }
    }
  }
  return null;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForCountryCode = function(a) {
  a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];
  return null == a ? i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ : a[0];
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodesForCountryCode = function(a) {
  a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];
  return null == a ? [] : a;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForRegion = function(a) {
  return this.isValidRegionCode_(a) ? this.getCountryCodeForValidRegion_(a) : 0;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForValidRegion_ = function(a) {
  var b = this.getMetadataForRegion(a);
  if (null == b) {
    throw Error("Invalid region code: " + a);
  }
  return b.getCountryCodeOrDefault();
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNddPrefixForRegion = function(a, b) {
  var c = this.getMetadataForRegion(a);
  if (null == c) {
    return null;
  }
  c = c.getNationalPrefixOrDefault();
  if (0 == c.length) {
    return null;
  }
  b && (c = c.replace("~", ""));
  return c;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNANPACountry = function(a) {
  return null != a && goog.array.contains(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_], a.toUpperCase());
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isLeadingZeroPossible = function(a) {
  a = this.getMetadataForRegionOrCallingCode_(a, this.getRegionCodeForCountryCode(a));
  return null != a && a.getLeadingZeroPossibleOrDefault();
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isAlphaNumber = function(a) {
  if (!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(a)) {
    return !1;
  }
  a = new goog.string.StringBuffer(a);
  this.maybeStripExtension(a);
  return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a.toString());
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumber = function(a) {
  a = this.isPossibleNumberWithReason(a);
  return a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForType = function(a, b) {
  var c = this.isPossibleNumberForTypeWithReason(a, b);
  return c == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || c == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLength_ = function(a, b) {
  return this.testNumberLengthForType_(a, b, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLengthForType_ = function(a, b, c) {
  var d = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, c), e = 0 == d.possibleLengthCount() ? b.getGeneralDesc().possibleLengthArray() : d.possibleLengthArray(), d = d.possibleLengthLocalOnlyArray();
  if (c == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE) {
    if (i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, i18n.phonenumbers.PhoneNumberType.FIXED_LINE))) {
      c = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, i18n.phonenumbers.PhoneNumberType.MOBILE), i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(c) && (e = e.concat(0 == c.possibleLengthCount() ? b.getGeneralDesc().possibleLengthArray() : c.possibleLengthArray()), goog.array.sort(e), 0 == d.length ? d = c.possibleLengthLocalOnlyArray() : (d = d.concat(c.possibleLengthLocalOnlyArray()), goog.array.sort(d)));
    } else {
      return this.testNumberLengthForType_(a, b, i18n.phonenumbers.PhoneNumberType.MOBILE);
    }
  }
  if (-1 == e[0]) {
    return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
  }
  a = a.length;
  if (-1 < goog.array.indexOf(d, a)) {
    return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
  }
  b = e[0];
  return b == a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : b > a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT : e[e.length - 1] < a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG : -1 < goog.array.indexOf(e, a, 1) ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberWithReason = function(a) {
  return this.isPossibleNumberForTypeWithReason(a, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForTypeWithReason = function(a, b) {
  var c = this.getNationalSignificantNumber(a), d = a.getCountryCodeOrDefault();
  if (!this.hasValidCountryCallingCode_(d)) {
    return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_COUNTRY_CODE;
  }
  var e = this.getRegionCodeForCountryCode(d), d = this.getMetadataForRegionOrCallingCode_(d, e);
  return this.testNumberLengthForType_(c, d, b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberString = function(a, b) {
  try {
    return this.isPossibleNumber(this.parse(a, b));
  } catch (c) {
    return !1;
  }
};
i18n.phonenumbers.PhoneNumberUtil.prototype.truncateTooLongNumber = function(a) {
  if (this.isValidNumber(a)) {
    return !0;
  }
  var b = a.clone(), c = a.getNationalNumberOrDefault();
  do {
    if (c = Math.floor(c / 10), b.setNationalNumber(c), 0 == c || this.isPossibleNumberWithReason(b) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT) {
      return !1;
    }
  } while (!this.isValidNumber(b));
  a.setNationalNumber(c);
  return !0;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.extractCountryCode = function(a, b) {
  var c = a.toString();
  if (0 == c.length || "0" == c.charAt(0)) {
    return 0;
  }
  for (var d, e = c.length, f = 1; f <= i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ && f <= e; ++f) {
    if (d = parseInt(c.substring(0, f), 10), d in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap) {
      return b.append(c.substring(f)), d;
    }
  }
  return 0;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeExtractCountryCode = function(a, b, c, d, e) {
  if (0 == a.length) {
    return 0;
  }
  a = new goog.string.StringBuffer(a);
  var f;
  null != b && (f = b.getInternationalPrefix());
  null == f && (f = "NonMatch");
  f = this.maybeStripInternationalPrefixAndNormalize(a, f);
  d && e.setCountryCodeSource(f);
  if (f != i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY) {
    if (a.getLength() <= i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) {
      throw Error(i18n.phonenumbers.Error.TOO_SHORT_AFTER_IDD);
    }
    b = this.extractCountryCode(a, c);
    if (0 != b) {
      return e.setCountryCode(b), b;
    }
    throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
  }
  if (null != b) {
    f = b.getCountryCodeOrDefault();
    var g = "" + f, h = a.toString();
    if (goog.string.startsWith(h, g) && (g = new goog.string.StringBuffer(h.substring(g.length)), h = b.getGeneralDesc(), h = new RegExp(h.getNationalNumberPatternOrDefault()), this.maybeStripNationalPrefixAndCarrierCode(g, b, null), g = g.toString(), !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(h, a.toString()) && i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(h, g) || this.testNumberLength_(a.toString(), b) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG)) {
      return c.append(g), d && e.setCountryCodeSource(i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN), e.setCountryCode(f), f;
    }
  }
  e.setCountryCode(0);
  return 0;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.parsePrefixAsIdd_ = function(a, b) {
  var c = b.toString();
  if (0 == c.search(a)) {
    var d = c.match(a)[0].length, e = c.substring(d).match(i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN);
    if (e && null != e[1] && 0 < e[1].length && "0" == i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(e[1])) {
      return !1;
    }
    b.clear();
    b.append(c.substring(d));
    return !0;
  }
  return !1;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripInternationalPrefixAndNormalize = function(a, b) {
  var c = a.toString();
  if (0 == c.length) {
    return i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;
  }
  if (i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN_.test(c)) {
    return c = c.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN_, ""), a.clear(), a.append(i18n.phonenumbers.PhoneNumberUtil.normalize(c)), i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN;
  }
  c = new RegExp(b);
  i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(a);
  return this.parsePrefixAsIdd_(c, a) ? i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD : i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripNationalPrefixAndCarrierCode = function(a, b, c) {
  var d = a.toString(), e = d.length, f = b.getNationalPrefixForParsing();
  if (0 == e || null == f || 0 == f.length) {
    return !1;
  }
  var g = new RegExp("^(?:" + f + ")");
  if (e = g.exec(d)) {
    var f = new RegExp(b.getGeneralDesc().getNationalNumberPatternOrDefault()), h = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(f, d), k = e.length - 1;
    b = b.getNationalPrefixTransformRule();
    if (null == b || 0 == b.length || null == e[k] || 0 == e[k].length) {
      if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(f, d.substring(e[0].length))) {
        return !1;
      }
      null != c && 0 < k && null != e[k] && c.append(e[1]);
      a.set(d.substring(e[0].length));
    } else {
      d = d.replace(g, b);
      if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(f, d)) {
        return !1;
      }
      null != c && 0 < k && c.append(e[1]);
      a.set(d);
    }
    return !0;
  }
  return !1;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripExtension = function(a) {
  var b = a.toString(), c = b.search(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_);
  if (0 <= c && i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(b.substring(0, c))) {
    for (var d = b.match(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_), e = d.length, f = 1; f < e; ++f) {
      if (null != d[f] && 0 < d[f].length) {
        return a.clear(), a.append(b.substring(0, c)), d[f];
      }
    }
  }
  return "";
};
i18n.phonenumbers.PhoneNumberUtil.prototype.checkRegionForParsing_ = function(a, b) {
  return this.isValidRegionCode_(b) || null != a && 0 < a.length && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN_.test(a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.parse = function(a, b) {
  return this.parseHelper_(a, b, !1, !0);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.parseAndKeepRawInput = function(a, b) {
  if (!this.isValidRegionCode_(b) && 0 < a.length && a.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
    throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
  }
  return this.parseHelper_(a, b, !0, !0);
};
i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_ = function(a, b) {
  if (1 < a.length && "0" == a.charAt(0)) {
    b.setItalianLeadingZero(!0);
    for (var c = 1; c < a.length - 1 && "0" == a.charAt(c);) {
      c++;
    }
    1 != c && b.setNumberOfLeadingZeros(c);
  }
};
i18n.phonenumbers.PhoneNumberUtil.prototype.parseHelper_ = function(a, b, c, d) {
  if (null == a) {
    throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
  }
  if (a.length > i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_) {
    throw Error(i18n.phonenumbers.Error.TOO_LONG);
  }
  var e = new goog.string.StringBuffer;
  this.buildNationalNumberForParsing_(a, e);
  if (!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(e.toString())) {
    throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
  }
  if (d && !this.checkRegionForParsing_(e.toString(), b)) {
    throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
  }
  d = new i18n.phonenumbers.PhoneNumber;
  c && d.setRawInput(a);
  a = this.maybeStripExtension(e);
  0 < a.length && d.setExtension(a);
  a = this.getMetadataForRegion(b);
  var f = new goog.string.StringBuffer, g = 0, h = e.toString();
  try {
    g = this.maybeExtractCountryCode(h, a, f, c, d);
  } catch (k) {
    if (k.message == i18n.phonenumbers.Error.INVALID_COUNTRY_CODE && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN_.test(h)) {
      if (h = h.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN_, ""), g = this.maybeExtractCountryCode(h, a, f, c, d), 0 == g) {
        throw k;
      }
    } else {
      throw k;
    }
  }
  0 != g ? (e = this.getRegionCodeForCountryCode(g), e != b && (a = this.getMetadataForRegionOrCallingCode_(g, e))) : (i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(e), f.append(e.toString()), null != b ? (g = a.getCountryCodeOrDefault(), d.setCountryCode(g)) : c && d.clearCountryCodeSource());
  if (f.getLength() < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) {
    throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
  }
  null != a && (b = new goog.string.StringBuffer, e = new goog.string.StringBuffer(f.toString()), this.maybeStripNationalPrefixAndCarrierCode(e, a, b), this.testNumberLength_(e.toString(), a) != i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT && (f = e, c && 0 < b.toString().length && d.setPreferredDomesticCarrierCode(b.toString())));
  c = f.toString();
  b = c.length;
  if (b < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) {
    throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
  }
  if (b > i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_) {
    throw Error(i18n.phonenumbers.Error.TOO_LONG);
  }
  i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_(c, d);
  d.setNationalNumber(parseInt(c, 10));
  return d;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.buildNationalNumberForParsing_ = function(a, b) {
  var c = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
  if (0 <= c) {
    var d = c + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_.length;
    if (a.charAt(d) == i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
      var e = a.indexOf(";", d);
      0 < e ? b.append(a.substring(d, e)) : b.append(a.substring(d));
    }
    d = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_);
    b.append(a.substring(0 <= d ? d + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_.length : 0, c));
  } else {
    b.append(i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a));
  }
  c = b.toString();
  d = c.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_);
  0 < d && (b.clear(), b.append(c.substring(0, d)));
};
i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_ = function(a) {
  var b = new i18n.phonenumbers.PhoneNumber;
  b.setCountryCode(a.getCountryCodeOrDefault());
  b.setNationalNumber(a.getNationalNumberOrDefault());
  0 < a.getExtensionOrDefault().length && b.setExtension(a.getExtensionOrDefault());
  a.getItalianLeadingZero() && (b.setItalianLeadingZero(!0), b.setNumberOfLeadingZeros(a.getNumberOfLeadingZerosOrDefault()));
  return b;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatch = function(a, b) {
  if ("string" == typeof a) {
    try {
      var c = this.parse(a, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_);
    } catch (g) {
      if (g.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE) {
        return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
      }
      if ("string" != typeof b) {
        var d = this.getRegionCodeForCountryCode(b.getCountryCodeOrDefault());
        if (d != i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_) {
          try {
            c = this.parse(a, d);
          } catch (h) {
            return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
          }
          c = this.isNumberMatch(c, b);
          return c == i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : c;
        }
      }
      try {
        c = this.parseHelper_(a, null, !1, !1);
      } catch (h) {
        return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
      }
    }
  } else {
    c = a.clone();
  }
  if ("string" == typeof b) {
    try {
      var e = this.parse(b, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_);
      return this.isNumberMatch(a, e);
    } catch (g) {
      return g.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER : this.isNumberMatch(b, c);
    }
  } else {
    e = b.clone();
  }
  c = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(c);
  e = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(e);
  if (c.hasExtension() && e.hasExtension() && c.getExtension() != e.getExtension()) {
    return i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
  }
  var d = c.getCountryCodeOrDefault(), f = e.getCountryCodeOrDefault();
  if (0 != d && 0 != f) {
    return c.equals(e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH : d == f && this.isNationalNumberSuffixOfTheOther_(c, e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
  }
  c.setCountryCode(0);
  e.setCountryCode(0);
  return c.equals(e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : this.isNationalNumberSuffixOfTheOther_(c, e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNationalNumberSuffixOfTheOther_ = function(a, b) {
  var c = "" + a.getNationalNumber(), d = "" + b.getNationalNumber();
  return goog.string.endsWith(c, d) || goog.string.endsWith(d, c);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.canBeInternationallyDialled = function(a) {
  var b = this.getMetadataForRegion(this.getRegionCodeForNumber(a));
  if (null == b) {
    return !0;
  }
  a = this.getNationalSignificantNumber(a);
  return !this.isNumberMatchingDesc_(a, b.getNoInternationalDialling());
};
i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_ = function(a, b) {
  var c = "string" == typeof a ? b.match("^(?:" + a + ")$") : b.match(a);
  return c && c[0].length == b.length ? !0 : !1;
};
i18n.phonenumbers.AsYouTypeFormatter = function(a) {
  this.DIGIT_PLACEHOLDER_ = "\u2008";
  this.DIGIT_PATTERN_ = new RegExp(this.DIGIT_PLACEHOLDER_);
  this.currentOutput_ = "";
  this.formattingTemplate_ = new goog.string.StringBuffer;
  this.currentFormattingPattern_ = "";
  this.accruedInput_ = new goog.string.StringBuffer;
  this.accruedInputWithoutFormatting_ = new goog.string.StringBuffer;
  this.ableToFormat_ = !0;
  this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = this.inputHasFormatting_ = !1;
  this.phoneUtil_ = i18n.phonenumbers.PhoneNumberUtil.getInstance();
  this.positionToRemember_ = this.originalPosition_ = this.lastMatchPosition_ = 0;
  this.prefixBeforeNationalNumber_ = new goog.string.StringBuffer;
  this.shouldAddSpaceAfterNationalPrefix_ = !1;
  this.extractedNationalPrefix_ = "";
  this.nationalNumber_ = new goog.string.StringBuffer;
  this.possibleFormats_ = [];
  this.defaultCountry_ = a;
  this.defaultMetadata_ = this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_);
};
i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ = " ";
i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_ = new i18n.phonenumbers.PhoneMetadata;
i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_.setInternationalPrefix("NA");
i18n.phonenumbers.AsYouTypeFormatter.CHARACTER_CLASS_PATTERN_ = /\[([^\[\]])*\]/g;
i18n.phonenumbers.AsYouTypeFormatter.STANDALONE_DIGIT_PATTERN_ = /\d(?=[^,}][^,}])/g;
i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_ = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*(\\$\\d[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*)+$");
i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_ = /[- ]/;
i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ = 3;
i18n.phonenumbers.AsYouTypeFormatter.prototype.getMetadataForRegion_ = function(a) {
  a = this.phoneUtil_.getCountryCodeForRegion(a);
  a = this.phoneUtil_.getRegionCodeForCountryCode(a);
  a = this.phoneUtil_.getMetadataForRegion(a);
  return null != a ? a : i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.maybeCreateNewTemplate_ = function() {
  for (var a = this.possibleFormats_.length, b = 0; b < a; ++b) {
    var c = this.possibleFormats_[b], d = c.getPatternOrDefault();
    if (this.currentFormattingPattern_ == d) {
      return !1;
    }
    if (this.createFormattingTemplate_(c)) {
      return this.currentFormattingPattern_ = d, this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(c.getNationalPrefixFormattingRule()), this.lastMatchPosition_ = 0, !0;
    }
  }
  return this.ableToFormat_ = !1;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getAvailableFormats_ = function(a) {
  for (var b = this.isCompleteNumber_ && 0 < this.currentMetadata_.intlNumberFormatCount() ? this.currentMetadata_.intlNumberFormatArray() : this.currentMetadata_.numberFormatArray(), c = b.length, d = 0; d < c; ++d) {
    var e = b[d];
    (!this.currentMetadata_.hasNationalPrefix() || this.isCompleteNumber_ || e.getNationalPrefixOptionalWhenFormatting() || this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault())) && this.isFormatEligible_(e.getFormatOrDefault()) && this.possibleFormats_.push(e);
  }
  this.narrowDownPossibleFormats_(a);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.isFormatEligible_ = function(a) {
  return i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_.test(a);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.narrowDownPossibleFormats_ = function(a) {
  for (var b = [], c = a.length - i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_, d = this.possibleFormats_.length, e = 0; e < d; ++e) {
    var f = this.possibleFormats_[e];
    if (0 == f.leadingDigitsPatternCount()) {
      b.push(this.possibleFormats_[e]);
    } else {
      var g = Math.min(c, f.leadingDigitsPatternCount() - 1), f = f.getLeadingDigitsPattern(g);
      0 == a.search(f) && b.push(this.possibleFormats_[e]);
    }
  }
  this.possibleFormats_ = b;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.createFormattingTemplate_ = function(a) {
  var b = a.getPatternOrDefault();
  if (-1 != b.indexOf("|")) {
    return !1;
  }
  b = b.replace(i18n.phonenumbers.AsYouTypeFormatter.CHARACTER_CLASS_PATTERN_, "\\d");
  b = b.replace(i18n.phonenumbers.AsYouTypeFormatter.STANDALONE_DIGIT_PATTERN_, "\\d");
  this.formattingTemplate_.clear();
  a = this.getFormattingTemplate_(b, a.getFormatOrDefault());
  return 0 < a.length ? (this.formattingTemplate_.append(a), !0) : !1;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getFormattingTemplate_ = function(a, b) {
  var c = "999999999999999".match(a)[0];
  if (c.length < this.nationalNumber_.getLength()) {
    return "";
  }
  c = c.replace(new RegExp(a, "g"), b);
  return c = c.replace(RegExp("9", "g"), this.DIGIT_PLACEHOLDER_);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.clear = function() {
  this.currentOutput_ = "";
  this.accruedInput_.clear();
  this.accruedInputWithoutFormatting_.clear();
  this.formattingTemplate_.clear();
  this.lastMatchPosition_ = 0;
  this.currentFormattingPattern_ = "";
  this.prefixBeforeNationalNumber_.clear();
  this.extractedNationalPrefix_ = "";
  this.nationalNumber_.clear();
  this.ableToFormat_ = !0;
  this.inputHasFormatting_ = !1;
  this.originalPosition_ = this.positionToRemember_ = 0;
  this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = !1;
  this.possibleFormats_ = [];
  this.shouldAddSpaceAfterNationalPrefix_ = !1;
  this.currentMetadata_ != this.defaultMetadata_ && (this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_));
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigit = function(a) {
  return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a, !1);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitAndRememberPosition = function(a) {
  return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a, !0);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitWithOptionToRememberPosition_ = function(a, b) {
  this.accruedInput_.append(a);
  b && (this.originalPosition_ = this.accruedInput_.getLength());
  this.isDigitOrLeadingPlusSign_(a) ? a = this.normalizeAndAccrueDigitsAndPlusSign_(a, b) : (this.ableToFormat_ = !1, this.inputHasFormatting_ = !0);
  if (!this.ableToFormat_) {
    if (!this.inputHasFormatting_) {
      if (this.attemptToExtractIdd_()) {
        if (this.attemptToExtractCountryCallingCode_()) {
          return this.attemptToChoosePatternWithPrefixExtracted_();
        }
      } else {
        if (this.ableToExtractLongerNdd_()) {
          return this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.attemptToChoosePatternWithPrefixExtracted_();
        }
      }
    }
    return this.accruedInput_.toString();
  }
  switch(this.accruedInputWithoutFormatting_.getLength()) {
    case 0:
    case 1:
    case 2:
      return this.accruedInput_.toString();
    case 3:
      if (this.attemptToExtractIdd_()) {
        this.isExpectingCountryCallingCode_ = !0;
      } else {
        return this.extractedNationalPrefix_ = this.removeNationalPrefixFromNationalNumber_(), this.attemptToChooseFormattingPattern_();
      }
    default:
      if (this.isExpectingCountryCallingCode_) {
        return this.attemptToExtractCountryCallingCode_() && (this.isExpectingCountryCallingCode_ = !1), this.prefixBeforeNationalNumber_.toString() + this.nationalNumber_.toString();
      }
      if (0 < this.possibleFormats_.length) {
        var c = this.inputDigitHelper_(a), d = this.attemptToFormatAccruedDigits_();
        if (0 < d.length) {
          return d;
        }
        this.narrowDownPossibleFormats_(this.nationalNumber_.toString());
        return this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.ableToFormat_ ? this.appendNationalNumber_(c) : this.accruedInput_.toString();
      }
      return this.attemptToChooseFormattingPattern_();
  }
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChoosePatternWithPrefixExtracted_ = function() {
  this.ableToFormat_ = !0;
  this.isExpectingCountryCallingCode_ = !1;
  this.possibleFormats_ = [];
  this.lastMatchPosition_ = 0;
  this.formattingTemplate_.clear();
  this.currentFormattingPattern_ = "";
  return this.attemptToChooseFormattingPattern_();
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getExtractedNationalPrefix_ = function() {
  return this.extractedNationalPrefix_;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.ableToExtractLongerNdd_ = function() {
  if (0 < this.extractedNationalPrefix_.length) {
    var a = this.nationalNumber_.toString();
    this.nationalNumber_.clear();
    this.nationalNumber_.append(this.extractedNationalPrefix_);
    this.nationalNumber_.append(a);
    var a = this.prefixBeforeNationalNumber_.toString(), b = a.lastIndexOf(this.extractedNationalPrefix_);
    this.prefixBeforeNationalNumber_.clear();
    this.prefixBeforeNationalNumber_.append(a.substring(0, b));
  }
  return this.extractedNationalPrefix_ != this.removeNationalPrefixFromNationalNumber_();
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.isDigitOrLeadingPlusSign_ = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN.test(a) || 1 == this.accruedInput_.getLength() && i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN.test(a);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToFormatAccruedDigits_ = function() {
  for (var a = this.nationalNumber_.toString(), b = this.possibleFormats_.length, c = 0; c < b; ++c) {
    var d = this.possibleFormats_[c], e = d.getPatternOrDefault();
    if ((new RegExp("^(?:" + e + ")$")).test(a)) {
      return this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(d.getNationalPrefixFormattingRule()), a = a.replace(new RegExp(e, "g"), d.getFormat()), this.appendNationalNumber_(a);
    }
  }
  return "";
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.appendNationalNumber_ = function(a) {
  var b = this.prefixBeforeNationalNumber_.getLength();
  return this.shouldAddSpaceAfterNationalPrefix_ && 0 < b && this.prefixBeforeNationalNumber_.toString().charAt(b - 1) != i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ ? this.prefixBeforeNationalNumber_ + i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ + a : this.prefixBeforeNationalNumber_ + a;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getRememberedPosition = function() {
  if (!this.ableToFormat_) {
    return this.originalPosition_;
  }
  for (var a = 0, b = 0, c = this.accruedInputWithoutFormatting_.toString(), d = this.currentOutput_.toString(); a < this.positionToRemember_ && b < d.length;) {
    c.charAt(a) == d.charAt(b) && a++, b++;
  }
  return b;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChooseFormattingPattern_ = function() {
  var a = this.nationalNumber_.toString();
  return a.length >= i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ ? (this.getAvailableFormats_(a), a = this.attemptToFormatAccruedDigits_(), 0 < a.length ? a : this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.accruedInput_.toString()) : this.appendNationalNumber_(a);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputAccruedNationalNumber_ = function() {
  var a = this.nationalNumber_.toString(), b = a.length;
  if (0 < b) {
    for (var c = "", d = 0; d < b; d++) {
      c = this.inputDigitHelper_(a.charAt(d));
    }
    return this.ableToFormat_ ? this.appendNationalNumber_(c) : this.accruedInput_.toString();
  }
  return this.prefixBeforeNationalNumber_.toString();
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.isNanpaNumberWithNationalPrefix_ = function() {
  if (1 != this.currentMetadata_.getCountryCode()) {
    return !1;
  }
  var a = this.nationalNumber_.toString();
  return "1" == a.charAt(0) && "0" != a.charAt(1) && "1" != a.charAt(1);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.removeNationalPrefixFromNationalNumber_ = function() {
  var a = this.nationalNumber_.toString(), b = 0;
  if (this.isNanpaNumberWithNationalPrefix_()) {
    b = 1, this.prefixBeforeNationalNumber_.append("1").append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.isCompleteNumber_ = !0;
  } else {
    if (this.currentMetadata_.hasNationalPrefixForParsing()) {
      var c = new RegExp("^(?:" + this.currentMetadata_.getNationalPrefixForParsing() + ")"), c = a.match(c);
      null != c && null != c[0] && 0 < c[0].length && (this.isCompleteNumber_ = !0, b = c[0].length, this.prefixBeforeNationalNumber_.append(a.substring(0, b)));
    }
  }
  this.nationalNumber_.clear();
  this.nationalNumber_.append(a.substring(b));
  return a.substring(0, b);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractIdd_ = function() {
  var a = this.accruedInputWithoutFormatting_.toString(), b = new RegExp("^(?:\\" + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + "|" + this.currentMetadata_.getInternationalPrefix() + ")"), b = a.match(b);
  return null != b && null != b[0] && 0 < b[0].length ? (this.isCompleteNumber_ = !0, b = b[0].length, this.nationalNumber_.clear(), this.nationalNumber_.append(a.substring(b)), this.prefixBeforeNationalNumber_.clear(), this.prefixBeforeNationalNumber_.append(a.substring(0, b)), a.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), !0) : !1;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractCountryCallingCode_ = function() {
  if (0 == this.nationalNumber_.getLength()) {
    return !1;
  }
  var a = new goog.string.StringBuffer, b = this.phoneUtil_.extractCountryCode(this.nationalNumber_, a);
  if (0 == b) {
    return !1;
  }
  this.nationalNumber_.clear();
  this.nationalNumber_.append(a.toString());
  a = this.phoneUtil_.getRegionCodeForCountryCode(b);
  i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == a ? this.currentMetadata_ = this.phoneUtil_.getMetadataForNonGeographicalRegion(b) : a != this.defaultCountry_ && (this.currentMetadata_ = this.getMetadataForRegion_(a));
  this.prefixBeforeNationalNumber_.append("" + b).append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_);
  this.extractedNationalPrefix_ = "";
  return !0;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.normalizeAndAccrueDigitsAndPlusSign_ = function(a, b) {
  if (a == i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
    var c = a;
    this.accruedInputWithoutFormatting_.append(a);
  } else {
    c = i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS[a], this.accruedInputWithoutFormatting_.append(c), this.nationalNumber_.append(c);
  }
  b && (this.positionToRemember_ = this.accruedInputWithoutFormatting_.getLength());
  return c;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitHelper_ = function(a) {
  var b = this.formattingTemplate_.toString();
  if (0 <= b.substring(this.lastMatchPosition_).search(this.DIGIT_PATTERN_)) {
    var c = b.search(this.DIGIT_PATTERN_);
    a = b.replace(this.DIGIT_PATTERN_, a);
    this.formattingTemplate_.clear();
    this.formattingTemplate_.append(a);
    this.lastMatchPosition_ = c;
    return a.substring(0, this.lastMatchPosition_ + 1);
  }
  1 == this.possibleFormats_.length && (this.ableToFormat_ = !1);
  this.currentFormattingPattern_ = "";
  return this.accruedInput_.toString();
};
Object.defineProperty(exports, "__esModule", {value:!0});
exports["default"] = i18n.phonenumbers;
module.exports = exports["default"];


},{}]},{},[1])(1)
});

/***/ }),

/***/ "ZxOp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Location; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_baseEntity__ = __webpack_require__("mCwL");


/**
 * Created by alex.y on 7/31/2017.
 */
var Location = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Location, _super);
    function Location(obj) {
        var _this = _super.call(this) || this;
        _this.Country = "";
        _this.City = "";
        _this.Street = "";
        _this.Zip = "";
        _this.State = "";
        Object.assign(_this, obj);
        return _this;
    }
    return Location;
}(__WEBPACK_IMPORTED_MODULE_1__common_baseEntity__["a" /* BaseEntity */]));

//# sourceMappingURL=location.js.map

/***/ }),

/***/ "aIIe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var DatatableGroupHeaderTemplateDirective = /** @class */ (function () {
    function DatatableGroupHeaderTemplateDirective(template) {
        this.template = template;
    }
    DatatableGroupHeaderTemplateDirective = __decorate([
        core_1.Directive({
            selector: '[ngx-datatable-group-header-template]'
        }),
        __metadata("design:paramtypes", [core_1.TemplateRef])
    ], DatatableGroupHeaderTemplateDirective);
    return DatatableGroupHeaderTemplateDirective;
}());
exports.DatatableGroupHeaderTemplateDirective = DatatableGroupHeaderTemplateDirective;
//# sourceMappingURL=body-group-header-template.directive.js.map

/***/ }),

/***/ "aZ3i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("TToO");

// EXTERNAL MODULE: ./app/objects/common/baseEntity.ts
var baseEntity = __webpack_require__("mCwL");

// CONCATENATED MODULE: ./app/objects/products/baseProduct.ts


/**
 * Created by alex.y on 9/11/2017.
 */
var baseProduct_BaseProduct = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](BaseProduct, _super);
    function BaseProduct() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseProduct;
}(baseEntity["a" /* BaseEntity */]));

//# sourceMappingURL=baseProduct.js.map
// CONCATENATED MODULE: ./app/objects/products/product.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return product_Product; });


/**
 * Created by alex.y on 8/8/2017.
 */
var product_Product = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](Product, _super);
    function Product() {
        var _this = _super.call(this) || this;
        _this.Countries = [];
        return _this;
    }
    return Product;
}(baseProduct_BaseProduct));

//# sourceMappingURL=product.js.map

/***/ }),

/***/ "bYJ/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var DataTableFooterComponent = /** @class */ (function () {
    function DataTableFooterComponent() {
        this.selectedCount = 0;
        this.page = new core_1.EventEmitter();
    }
    Object.defineProperty(DataTableFooterComponent.prototype, "isVisible", {
        get: function () {
            return (this.rowCount / this.pageSize) > 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableFooterComponent.prototype, "curPage", {
        get: function () {
            return this.offset + 1;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableFooterComponent.prototype, "footerHeight", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableFooterComponent.prototype, "rowCount", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableFooterComponent.prototype, "pageSize", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableFooterComponent.prototype, "offset", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableFooterComponent.prototype, "pagerLeftArrowIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableFooterComponent.prototype, "pagerRightArrowIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableFooterComponent.prototype, "pagerPreviousIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableFooterComponent.prototype, "pagerNextIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableFooterComponent.prototype, "totalMessage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", core_1.TemplateRef)
    ], DataTableFooterComponent.prototype, "footerTemplate", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableFooterComponent.prototype, "selectedCount", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableFooterComponent.prototype, "selectedMessage", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTableFooterComponent.prototype, "page", void 0);
    DataTableFooterComponent = __decorate([
        core_1.Component({
            selector: 'datatable-footer',
            template: "\n    <div\n      class=\"datatable-footer-inner\"\n      [ngClass]=\"{'selected-count': selectedMessage}\"\n      [style.height.px]=\"footerHeight\">\n      <ng-template\n        *ngIf=\"footerTemplate\"\n        [ngTemplateOutlet]=\"footerTemplate.template\"\n        [ngTemplateOutletContext]=\"{ \n          rowCount: rowCount, \n          pageSize: pageSize, \n          selectedCount: selectedCount,\n          curPage: curPage,\n          offset: offset\n        }\">\n      </ng-template>\n      <div class=\"page-count\" *ngIf=\"!footerTemplate\">\n        <span *ngIf=\"selectedMessage\">\n          {{selectedCount.toLocaleString()}} {{selectedMessage}} / \n        </span>\n        {{rowCount.toLocaleString()}} {{totalMessage}}\n      </div>\n      <datatable-pager *ngIf=\"!footerTemplate\"\n        [pagerLeftArrowIcon]=\"pagerLeftArrowIcon\"\n        [pagerRightArrowIcon]=\"pagerRightArrowIcon\"\n        [pagerPreviousIcon]=\"pagerPreviousIcon\"\n        [pagerNextIcon]=\"pagerNextIcon\"\n        [page]=\"curPage\"\n        [size]=\"pageSize\"\n        [count]=\"rowCount\"\n        [hidden]=\"!isVisible\"\n        (change)=\"page.emit($event)\">\n      </datatable-pager>\n    </div>\n  ",
            host: {
                class: 'datatable-footer'
            },
            changeDetection: core_1.ChangeDetectionStrategy.OnPush
        })
    ], DataTableFooterComponent);
    return DataTableFooterComponent;
}());
exports.DataTableFooterComponent = DataTableFooterComponent;
//# sourceMappingURL=footer.component.js.map

/***/ }),

/***/ "cfSW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfigService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("Fzro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map__ = __webpack_require__("+pb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_catch__ = __webpack_require__("6Yye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__ = __webpack_require__("eErF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__);




var ConfigService = /** @class */ (function () {
    function ConfigService(http) {
        this.http = http;
        this.config = null;
    }
    ConfigService.prototype.getConfig = function () {
        if (this.config != null)
            return this.config;
        return this.load();
    };
    ConfigService.makeId = function () {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 10; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
    };
    ConfigService.prototype.load = function () {
        var _this = this;
        var url = 'configuration/configuration.json';
        url += '?id=' + ConfigService.makeId();
        return this.http.get(url).toPromise().then(function (x) {
            _this.config = x.json();
            return _this.config;
        });
    };
    ConfigService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["e" /* Http */] }]; };
    return ConfigService;
}());

//# sourceMappingURL=configService.js.map

/***/ }),

/***/ "cfoZ":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.createNumberMask=t():e.createNumberMask=t()}(this,function(){return function(e){function t(n){if(o[n])return o[n].exports;var i=o[n]={exports:{},id:n,loaded:!1};return e[n].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t,o){e.exports=o(2)},,function(e,t){"use strict";function o(){function e(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:l,t=e.length;if(e===l||e[0]===y[0]&&1===t)return y.split(l).concat([v]).concat(g.split(l));if(e===k&&M)return y.split(l).concat(["0",k,v]).concat(g.split(l));var o=e[0]===s&&q;o&&(e=e.toString().substr(1));var c=e.lastIndexOf(k),u=c!==-1,a=void 0,b=void 0,h=void 0;if(e.slice(T*-1)===g&&(e=e.slice(0,T*-1)),u&&(M||$)?(a=e.slice(e.slice(0,R)===y?R:0,c),b=e.slice(c+1,t),b=n(b.replace(f,l))):a=e.slice(0,R)===y?e.slice(R):e,P&&("undefined"==typeof P?"undefined":r(P))===p){var S="."===j?"[.]":""+j,w=(a.match(new RegExp(S,"g"))||[]).length;a=a.slice(0,P+w*Z)}return a=a.replace(f,l),E||(a=a.replace(/^0+(0$|[^0])/,"$1")),a=x?i(a,j):a,h=n(a),(u&&M||$===!0)&&(e[c-1]!==k&&h.push(m),h.push(k,m),b&&(("undefined"==typeof L?"undefined":r(L))===p&&(b=b.slice(0,L)),h=h.concat(b)),$===!0&&e[c-1]===k&&h.push(v)),R>0&&(h=y.split(l).concat(h)),o&&(h.length===R&&h.push(v),h=[d].concat(h)),g.length>0&&(h=h.concat(g.split(l))),h}var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},o=t.prefix,y=void 0===o?c:o,b=t.suffix,g=void 0===b?l:b,h=t.includeThousandsSeparator,x=void 0===h||h,S=t.thousandsSeparatorSymbol,j=void 0===S?u:S,w=t.allowDecimal,M=void 0!==w&&w,N=t.decimalSymbol,k=void 0===N?a:N,D=t.decimalLimit,L=void 0===D?2:D,O=t.requireDecimal,$=void 0!==O&&O,_=t.allowNegative,q=void 0!==_&&_,B=t.allowLeadingZeroes,E=void 0!==B&&B,I=t.integerLimit,P=void 0===I?null:I,R=y&&y.length||0,T=g&&g.length||0,Z=j&&j.length||0;return e.instanceOf="createNumberMask",e}function n(e){return e.split(l).map(function(e){return v.test(e)?v:e})}function i(e,t){return e.replace(/\B(?=(\d{3})+(?!\d))/g,t)}Object.defineProperty(t,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var c="$",l="",u=",",a=".",s="-",d=/-/,f=/\D+/g,p="number",v=/\d/,m="[]"}])});

/***/ }),

/***/ "clEe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StripePaymentData; });
var StripePaymentData = /** @class */ (function () {
    function StripePaymentData() {
    }
    return StripePaymentData;
}());

//# sourceMappingURL=stripe-payment-data.js.map

/***/ }),

/***/ "e4LZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserViewService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseService__ = __webpack_require__("IhmT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__("Fzro");



var UserViewService = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](UserViewService, _super);
    function UserViewService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserViewService.prototype.getUserView = function () {
        var _this = this;
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "user/view",
        })).then(function (x) { _this.userView = x.Data; return x; });
    };
    UserViewService.prototype.modify = function (config) {
        return this.put(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "user/view/columns",
            body: config
        }));
    };
    UserViewService.prototype.updateUserView = function (config) {
        return this.put(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: 'user/view',
            body: config
        }));
    };
    return UserViewService;
}(__WEBPACK_IMPORTED_MODULE_1__baseService__["a" /* BaseApi */]));

//# sourceMappingURL=userViewService.js.map

/***/ }),

/***/ "eZFs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Country; });
/**
 * Created by vlad.p on 8/21/2017.
 */
var Country = /** @class */ (function () {
    function Country(obj) {
        Object.assign(this, obj);
    }
    return Country;
}());

//# sourceMappingURL=Country.js.map

/***/ }),

/***/ "eeIR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScreenHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_users_viewType__ = __webpack_require__("n7Lc");

var ScreenHelper = /** @class */ (function () {
    function ScreenHelper() {
    }
    ScreenHelper.isPhone = function () {
        return window.innerWidth <= 768;
    };
    ScreenHelper.isTabletOrPhone = function () {
        return window.innerWidth <= 991;
    };
    ScreenHelper.getViewType = function () {
        // for the future using
        // if (navigator.userAgent.match(/Android/i))
        //     return ViewType.Android;
        // if (navigator.userAgent.match(/BlackBerry/i))
        //     return ViewType.Mobile;
        // if (navigator.userAgent.match(/Opera Mini/i))
        //     return ViewType.Mobile;
        // if (navigator.userAgent.match(/iPhone|iPad|iPod/i))
        //     return ViewType.Ios;
        // if (navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i))
        //     return ViewType.WindowsPhone;
        var isMobile = (function (a) {
            return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4));
        })(navigator.userAgent || navigator.vendor);
        if (isMobile)
            return __WEBPACK_IMPORTED_MODULE_0__objects_users_viewType__["a" /* ViewType */].Mobile;
        return __WEBPACK_IMPORTED_MODULE_0__objects_users_viewType__["a" /* ViewType */].Desktop;
    };
    return ScreenHelper;
}());

//# sourceMappingURL=screenHelper.js.map

/***/ }),

/***/ "fj/O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var events_1 = __webpack_require__("NBsw");
var DataTableRowWrapperComponent = /** @class */ (function () {
    function DataTableRowWrapperComponent(cd, differs) {
        this.cd = cd;
        this.differs = differs;
        this.rowContextmenu = new core_1.EventEmitter(false);
        this.groupContext = {
            group: this.row,
            expanded: this.expanded,
            rowIndex: this.rowIndex
        };
        this.rowContext = {
            row: this.row,
            expanded: this.expanded,
            rowIndex: this.rowIndex
        };
        this._expanded = false;
        this.rowDiffer = differs.find({}).create();
    }
    Object.defineProperty(DataTableRowWrapperComponent.prototype, "rowIndex", {
        get: function () {
            return this._rowIndex;
        },
        set: function (val) {
            this._rowIndex = val;
            this.rowContext.rowIndex = val;
            this.groupContext.rowIndex = val;
            this.cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableRowWrapperComponent.prototype, "expanded", {
        get: function () {
            return this._expanded;
        },
        set: function (val) {
            this._expanded = val;
            this.groupContext.expanded = val;
            this.rowContext.expanded = val;
            this.cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    DataTableRowWrapperComponent.prototype.ngDoCheck = function () {
        if (this.rowDiffer.diff(this.row)) {
            this.rowContext.row = this.row;
            this.groupContext.group = this.row;
            this.cd.markForCheck();
        }
    };
    DataTableRowWrapperComponent.prototype.onContextmenu = function ($event) {
        this.rowContextmenu.emit({ event: $event, row: this.row });
    };
    DataTableRowWrapperComponent.prototype.getGroupHeaderStyle = function (group) {
        var styles = {};
        styles['transform'] = 'translate3d(' + this.offsetX + 'px, 0px, 0px)';
        styles['backface-visibility'] = 'hidden';
        styles['width'] = this.innerWidth;
        return styles;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableRowWrapperComponent.prototype, "innerWidth", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableRowWrapperComponent.prototype, "rowDetail", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableRowWrapperComponent.prototype, "groupHeader", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableRowWrapperComponent.prototype, "offsetX", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableRowWrapperComponent.prototype, "detailRowHeight", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableRowWrapperComponent.prototype, "row", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableRowWrapperComponent.prototype, "groupedRows", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], DataTableRowWrapperComponent.prototype, "rowContextmenu", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], DataTableRowWrapperComponent.prototype, "rowIndex", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], DataTableRowWrapperComponent.prototype, "expanded", null);
    __decorate([
        core_1.HostListener('contextmenu', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DataTableRowWrapperComponent.prototype, "onContextmenu", null);
    DataTableRowWrapperComponent = __decorate([
        core_1.Component({
            selector: 'datatable-row-wrapper',
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
            template: "\n    <div \n      *ngIf=\"groupHeader && groupHeader.template\"\n      class=\"datatable-group-header\"\n      [ngStyle]=\"getGroupHeaderStyle()\">\n      <ng-template\n        *ngIf=\"groupHeader && groupHeader.template\"\n        [ngTemplateOutlet]=\"groupHeader.template\"\n        [ngTemplateOutletContext]=\"groupContext\">\n      </ng-template>\n    </div>\n    <ng-content \n      *ngIf=\"(groupHeader && groupHeader.template && expanded) || \n             (!groupHeader || !groupHeader.template)\">\n    </ng-content>\n    <div\n      *ngIf=\"rowDetail && rowDetail.template && expanded\"\n      [style.height.px]=\"detailRowHeight\"\n      class=\"datatable-row-detail\">\n      <ng-template\n        *ngIf=\"rowDetail && rowDetail.template\"\n        [ngTemplateOutlet]=\"rowDetail.template\"\n        [ngTemplateOutletContext]=\"rowContext\">\n      </ng-template>\n    </div>\n  ",
            host: {
                class: 'datatable-row-wrapper'
            }
        }),
        __metadata("design:paramtypes", [core_1.ChangeDetectorRef, core_1.KeyValueDiffers])
    ], DataTableRowWrapperComponent);
    return DataTableRowWrapperComponent;
}());
exports.DataTableRowWrapperComponent = DataTableRowWrapperComponent;
//# sourceMappingURL=body-row-wrapper.component.js.map

/***/ }),

/***/ "gE7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailTemplateType; });
/**
 * Created by vadim.m on 10/13/2017.
 */
var EmailTemplateType;
(function (EmailTemplateType) {
    EmailTemplateType[EmailTemplateType["OrderToCustomer"] = 0] = "OrderToCustomer";
    EmailTemplateType[EmailTemplateType["AgentNotification"] = 1] = "AgentNotification";
    EmailTemplateType[EmailTemplateType["OrderToCustomerPay"] = 2] = "OrderToCustomerPay";
    EmailTemplateType[EmailTemplateType["BBFeeChanged"] = 3] = "BBFeeChanged";
    EmailTemplateType[EmailTemplateType["AmazonSellerDefault"] = 4] = "AmazonSellerDefault";
    EmailTemplateType[EmailTemplateType["AmazonSellerRegistered"] = 5] = "AmazonSellerRegistered";
    EmailTemplateType[EmailTemplateType["AmazonBNSubmitted"] = 6] = "AmazonBNSubmitted";
    EmailTemplateType[EmailTemplateType["AmazonProductsCompleted"] = 7] = "AmazonProductsCompleted";
    EmailTemplateType[EmailTemplateType["CreditCardRequest"] = 8] = "CreditCardRequest";
    EmailTemplateType[EmailTemplateType["CreditCardDontWork"] = 9] = "CreditCardDontWork";
    EmailTemplateType[EmailTemplateType["CustomChargesHaveBeenPaid"] = 10] = "CustomChargesHaveBeenPaid";
    EmailTemplateType[EmailTemplateType["CanadaPageMonitorNotification"] = 11] = "CanadaPageMonitorNotification";
    EmailTemplateType[EmailTemplateType["UpdatePaymentData"] = 12] = "UpdatePaymentData";
    EmailTemplateType[EmailTemplateType["PayPalPaymentRequest"] = 13] = "PayPalPaymentRequest";
    EmailTemplateType[EmailTemplateType["CreditCardExistingCustomerRequest"] = 14] = "CreditCardExistingCustomerRequest";
})(EmailTemplateType || (EmailTemplateType = {}));
//# sourceMappingURL=emailTemplateType.js.map

/***/ }),

/***/ "gHgi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgentModalComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_users_user__ = __webpack_require__("E4s1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_users_userFlag__ = __webpack_require__("AYdn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_userService__ = __webpack_require__("ZSxL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_helpers_userHelper__ = __webpack_require__("AvNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_configService__ = __webpack_require__("cfSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ng2_cookies_ng2_cookies__ = __webpack_require__("46qw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ng2_cookies_ng2_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ng2_cookies_ng2_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils_blurUtil__ = __webpack_require__("vWtP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_router__ = __webpack_require__("5oXY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_utils_select2Util__ = __webpack_require__("jFcQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_perfect_scrollbar__ = __webpack_require__("Fiov");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_managers_storageManager__ = __webpack_require__("ivjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_management_order_orderViewType__ = __webpack_require__("9ev/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_helpers_userViewHelper__ = __webpack_require__("AIey");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__objects_components_component__ = __webpack_require__("+TKD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_userViewService__ = __webpack_require__("e4LZ");

















var AgentModalComponent = /** @class */ (function () {
    function AgentModalComponent(userService, configService, router, storageManager, userViewService) {
        this.userService = userService;
        this.configService = configService;
        this.router = router;
        this.storageManager = storageManager;
        this.userViewService = userViewService;
        this.agentSaved = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.originalAgent = new __WEBPACK_IMPORTED_MODULE_2__objects_users_user__["c" /* User */]();
        this.currentAgent = new __WEBPACK_IMPORTED_MODULE_2__objects_users_user__["c" /* User */]();
        this.string = String;
        this.number = Number;
        this.userFlag = __WEBPACK_IMPORTED_MODULE_3__objects_users_userFlag__["a" /* UserFlag */];
        this.userHelper = __WEBPACK_IMPORTED_MODULE_5__common_helpers_userHelper__["a" /* UserHelper */];
        this.select2Util = __WEBPACK_IMPORTED_MODULE_10__common_utils_select2Util__["a" /* Select2Util */];
        this.processing = false;
        this.contacts = [];
        this.top = 10;
        this.skip = 3;
        this.hasNextOrder = true;
        this.isOrderLoading = false;
        this.showSelect = false;
        this.tableColumns = [];
    }
    AgentModalComponent.prototype.ngOnInit = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var _a;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        __WEBPACK_IMPORTED_MODULE_11_perfect_scrollbar__["initialize"](this.agentModalRef.nativeElement);
                        _a = this;
                        return [4 /*yield*/, this.storageManager.getCurrentUser()];
                    case 1:
                        _a.currentUser = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AgentModalComponent.prototype.onMousewheel = function () {
        var delta = document.getElementById("myModal").clientHeight - document.getElementById("myModal").scrollHeight == 0;
        if (delta && !this.isOrderLoading)
            this.loadNextOrders();
    };
    AgentModalComponent.prototype.onArrowDown = function (event) {
        if (this.isOrderLoading)
            return;
        if (event.keyCode == 38 || event.keyCode == 40)
            this.loadNextOrders();
    };
    AgentModalComponent.prototype.viewAllOrders = function () {
        __WEBPACK_IMPORTED_MODULE_8__common_utils_blurUtil__["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
        this.router.navigate(["management/order", { agentid: this.currentAgent.Id }]);
    };
    AgentModalComponent.prototype.handleScroll = function () {
        this.loadNextOrders();
    };
    AgentModalComponent.prototype.loadNextOrders = function () {
        var _this = this;
        if (!this.hasNextOrder)
            return;
        this.isOrderLoading = true;
        this.userService.getOrdersByAgentId(this.currentAgent.Id, this.skip, this.top).then(function (result) {
            _this.isOrderLoading = false;
            if (!result || !result.Data)
                return;
            if (result.Data.Items.length == 0 || _this.originalAgent.Orders.length == result.Data.TotalCount)
                _this.hasNextOrder = false;
            _this.skip += _this.top;
            result.Data.Items.sort(function (x, y) {
                return new Date(x.Created) > new Date(y.Created) ? -1 : 1;
            });
            for (var _i = 0, _a = result.Data.Items; _i < _a.length; _i++) {
                var o = _a[_i];
                _this.currentAgent.Orders.push(o);
                _this.originalAgent.Orders.push(o);
            }
        });
    };
    AgentModalComponent.prototype.show = function (agent) {
        var _this = this;
        this.top = 10;
        this.skip = agent.Orders.length;
        this.hasNextOrder = true;
        this.originalAgent = agent;
        this.currentAgent = JSON.parse(JSON.stringify(agent));
        this.agentModal.show();
        __WEBPACK_IMPORTED_MODULE_8__common_utils_blurUtil__["a" /* BlurUtil */].blurMenu(this.idToBlur);
        this.showSelect = true;
        setTimeout(function (x) {
            _this.initSelect();
        }, 200);
        this.tableColumns = __WEBPACK_IMPORTED_MODULE_14__common_helpers_userViewHelper__["a" /* UserViewHelper */].getColumns(this.userViewService, __WEBPACK_IMPORTED_MODULE_15__objects_components_component__["a" /* Component */].OrderManagement, __WEBPACK_IMPORTED_MODULE_13__objects_management_order_orderViewType__["a" /* OrderViewType */].Tile);
    };
    AgentModalComponent.prototype.onModalHidden = function () {
        var select = $('#emailModel');
        select.select2('destroy');
        select.off('select2:select');
        select.off('select2:unselect');
        this.agentForm.resetForm();
        this.showSelect = false;
        __WEBPACK_IMPORTED_MODULE_8__common_utils_blurUtil__["a" /* BlurUtil */].unBlurMenu(this.idToBlur);
    };
    AgentModalComponent.prototype.toggleEnabled = function () {
        if (this.currentAgent.Flag.hasFlag(__WEBPACK_IMPORTED_MODULE_3__objects_users_userFlag__["a" /* UserFlag */].Disabled)) {
            this.currentAgent.Flag &= ~__WEBPACK_IMPORTED_MODULE_3__objects_users_userFlag__["a" /* UserFlag */].Disabled;
        }
        else {
            this.currentAgent.Flag |= __WEBPACK_IMPORTED_MODULE_3__objects_users_userFlag__["a" /* UserFlag */].Disabled;
        }
    };
    AgentModalComponent.prototype.save = function (isValid) {
        var _this = this;
        if (!isValid)
            return;
        this.processing = true;
        this.currentAgent.FullName = this.currentAgent.FirstName + ' ' + this.currentAgent.LastName;
        if (this.currentAgent.Id != null && String.isNullOrEmpty(this.currentAgent.Id.toString())) {
            this.userService.create(this.currentAgent).then(function (response) {
                _this.onSaveSuccess(response);
            });
        }
        else {
            this.userService.update(this.currentAgent).then(function (response) {
                _this.onSaveSuccess(response);
            });
        }
    };
    AgentModalComponent.prototype.onSaveSuccess = function (response) {
        this.processing = false;
        this.agentSaved.emit(response.Data);
        this.agentModal.hide();
    };
    AgentModalComponent.prototype.cancel = function () {
        this.agentModal.hide();
    };
    AgentModalComponent.prototype.groupChanged = function (group) {
        if (__WEBPACK_IMPORTED_MODULE_5__common_helpers_userHelper__["a" /* UserHelper */].isInGroup(this.currentAgent, group)) {
            this.currentAgent.Groups = this.currentAgent.Groups.filter(function (x) { return x.Id != group.Id; });
        }
        else {
            this.currentAgent.Groups.push(group);
        }
    };
    AgentModalComponent.prototype.initSelect = function () {
        var data = this.currentAgent.Id != null
            ? [{ id: this.currentAgent.Email, text: this.currentAgent.Email, object: this.currentAgent }]
            : [];
        var self = this;
        $('#emailModel').select2({
            width: '100%',
            data: data,
            allowClear: true,
            placeholder: '',
            ajax: {
                url: this.configService.config.ApiUrl + "/google/contacts/search",
                datatype: 'json',
                delay: 500,
                headers: {
                    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_7_ng2_cookies_ng2_cookies__["Cookie"].get(this.configService.config.ApiTokenCookieName),
                },
                data: function (params) {
                    return {
                        query: params.term
                    };
                },
                processResults: function (data, params) {
                    var results = data.Data.map(function (item) {
                        return {
                            id: item.Email,
                            text: item.Email,
                            object: item
                        };
                    });
                    // if (results.length == 0)
                    //     results.push({id: params.term, text: params.term});
                    self.contacts = results;
                    return {
                        results: results
                    };
                }
            },
            minimumInputLength: 2
        }).on('select2:select', function (e) {
            var selectedEmail = $('#emailModel').select2('val');
            var selectedContact = self.contacts.find(function (x) { return x.id == selectedEmail; });
            self.currentAgent.Email = selectedEmail;
            self.agentForm.control.get('emailModel').setValue(selectedEmail);
            self.agentForm.control.get('emailModel').markAsTouched();
            if (selectedContact == null || selectedContact.object == null)
                return;
            self.currentAgent.FirstName = selectedContact.object.FirstName;
            self.currentAgent.LastName = selectedContact.object.LastName;
            self.currentAgent.ImageSrc = selectedContact.object.ImageUrl;
        }).on('select2:unselect', function (e) {
            self.currentAgent.Email = '';
            self.agentForm.control.get('emailModel').markAsTouched();
        });
        if (this.currentAgent.Id != null) {
            $('#emailModel').val(this.currentAgent.Email).trigger("change");
        }
        if (this.currentAgent.Id)
            $('#emailModel').select2('enable', false);
    };
    AgentModalComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_4__services_userService__["a" /* UserService */] }, { type: __WEBPACK_IMPORTED_MODULE_6__services_configService__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_9__angular_router__["n" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_12__common_managers_storageManager__["a" /* StorageManager */] }, { type: __WEBPACK_IMPORTED_MODULE_16__services_userViewService__["a" /* UserViewService */] }]; };
    return AgentModalComponent;
}());

//# sourceMappingURL=agent-modal.component.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "gN9/":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
var NativeCustomEvent = global.CustomEvent;

function useNative () {
  try {
    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
    return  'cat' === p.type && 'bar' === p.detail.foo;
  } catch (e) {
  }
  return false;
}

/**
 * Cross-browser `CustomEvent` constructor.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
 *
 * @public
 */

module.exports = useNative() ? NativeCustomEvent :

// IE >= 9
'function' === typeof document.createEvent ? function CustomEvent (type, params) {
  var e = document.createEvent('CustomEvent');
  if (params) {
    e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
  } else {
    e.initCustomEvent(type, false, false, void 0);
  }
  return e;
} :

// IE <= 8
function CustomEvent (type, params) {
  var e = document.createEventObject();
  e.type = type;
  if (params) {
    e.bubbles = Boolean(params.bubbles);
    e.cancelable = Boolean(params.cancelable);
    e.detail = params.detail;
  } else {
    e.bubbles = false;
    e.cancelable = false;
    e.detail = void 0;
  }
  return e;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "gqkz":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;(function(factory) {
    'use strict';
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("7t+N")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 0) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
            }
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }
        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick', '*', function(event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function() {

                if( _.options.pauseOnFocus ) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }

            }, 0);

        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                 ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                coef = -1

                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2
                    }
                }
                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this,
                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
                    return (val >= 0) && (val < _.slideCount);
                });

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });

                if (slideControlIndex !== -1) {
                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
                   if ($('#' + ariaButtonControl).length) {
                     $(this).attr({
                         'aria-describedby': ariaButtonControl
                     });
                   }
                }
            });

            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $(this).attr({
                    'role': 'presentation'
                });

                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': (i + 1) + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });

            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }

        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
          if (_.options.focusOnChange) {
            _.$slides.eq(i).attr({'tabindex': '0'});
          } else {
            _.$slides.eq(i).removeAttr('tabindex');
          }
        }

        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
            }
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageSrcSet = $(this).attr('data-srcset'),
                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {

                            if (imageSrcSet) {
                                image
                                    .attr('srcset', imageSrcSet );

                                if (imageSizes) {
                                    image
                                        .attr('sizes', imageSizes );
                                }
                            }

                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy data-srcset data-sizes')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();

                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                if (imageSrcSet) {
                    image
                        .attr('srcset', imageSrcSet );

                    if (imageSizes) {
                        image
                            .attr('sizes', imageSizes );
                    }
                }

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy data-srcset data-sizes')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                    _.$slides
                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                    .removeClass('slick-active')
                    .end();

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));


/***/ }),

/***/ "hDLL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseSearchRequest; });
/**
 * Created by vlad.p on 7/31/2017.
 */
var BaseSearchRequest = /** @class */ (function () {
    function BaseSearchRequest() {
    }
    return BaseSearchRequest;
}());

//# sourceMappingURL=baseSearchRequest.js.map

/***/ }),

/***/ "hIqV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("0dt4"));
__export(__webpack_require__("2xC4"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "hTTC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var eventmap = [];
var eventname = '';
var ron = /^on/;

for (eventname in global) {
  if (ron.test(eventname)) {
    eventmap.push(eventname.slice(2));
  }
}

module.exports = eventmap;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "hgwR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductSearchRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseSearchRequest__ = __webpack_require__("hDLL");


/**
 * Created by alex.y on 9/11/2017.
 */
var ProductSearchRequest = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ProductSearchRequest, _super);
    function ProductSearchRequest(obj) {
        var _this = _super.call(this) || this;
        _this.SearchType = 1;
        Object.assign(_this, obj);
        return _this;
    }
    return ProductSearchRequest;
}(__WEBPACK_IMPORTED_MODULE_1__baseSearchRequest__["a" /* BaseSearchRequest */]));

//# sourceMappingURL=productSearchRequest.js.map

/***/ }),

/***/ "hz4y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Order; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SimpleOrderTotal; });
/* unused harmony export ESOrder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_baseEntity__ = __webpack_require__("mCwL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customers_customer__ = __webpack_require__("svBX");



/**
 * Created by alex.y on 8/8/2017.
 */
var Order = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Order, _super);
    function Order() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.OrderItems = [];
        _this.Customer = new __WEBPACK_IMPORTED_MODULE_2__customers_customer__["a" /* Customer */]();
        _this.Locations = [];
        _this.IsCommercial = false;
        _this.IsNeedShippingHelp = false;
        _this.DataList = new Array();
        return _this;
    }
    return Order;
}(__WEBPACK_IMPORTED_MODULE_1__common_baseEntity__["a" /* BaseEntity */]));

var SimpleOrderTotal = /** @class */ (function () {
    function SimpleOrderTotal() {
    }
    return SimpleOrderTotal;
}());

var ESOrder = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ESOrder, _super);
    function ESOrder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.IsCommercial = false;
        _this.IsNeedShippingHelp = false;
        return _this;
    }
    return ESOrder;
}(__WEBPACK_IMPORTED_MODULE_1__common_baseEntity__["a" /* BaseEntity */]));

//# sourceMappingURL=order.js.map

/***/ }),

/***/ "icKY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var draggable_directive_1 = __webpack_require__("Z9jN");
var platform_browser_1 = __webpack_require__("Qbdm");
var OrderableDirective = /** @class */ (function () {
    function OrderableDirective(differs, document) {
        this.document = document;
        this.reorder = new core_1.EventEmitter();
        this.differ = differs.find({}).create();
    }
    OrderableDirective.prototype.ngAfterContentInit = function () {
        // HACK: Investigate Better Way
        this.updateSubscriptions();
        this.draggables.changes.subscribe(this.updateSubscriptions.bind(this));
    };
    OrderableDirective.prototype.ngOnDestroy = function () {
        this.draggables.forEach(function (d) {
            d.dragStart.unsubscribe();
            d.dragEnd.unsubscribe();
        });
    };
    OrderableDirective.prototype.updateSubscriptions = function () {
        var _this = this;
        var diffs = this.differ.diff(this.createMapDiffs());
        if (diffs) {
            var subscribe = function (_a) {
                var currentValue = _a.currentValue, previousValue = _a.previousValue;
                unsubscribe_1({ previousValue: previousValue });
                if (currentValue) {
                    currentValue.dragStart.subscribe(_this.onDragStart.bind(_this));
                    currentValue.dragEnd.subscribe(_this.onDragEnd.bind(_this));
                }
            };
            var unsubscribe_1 = function (_a) {
                var previousValue = _a.previousValue;
                if (previousValue) {
                    previousValue.dragStart.unsubscribe();
                    previousValue.dragEnd.unsubscribe();
                }
            };
            diffs.forEachAddedItem(subscribe.bind(this));
            // diffs.forEachChangedItem(subscribe.bind(this));
            diffs.forEachRemovedItem(unsubscribe_1.bind(this));
        }
    };
    OrderableDirective.prototype.onDragStart = function () {
        this.positions = {};
        var i = 0;
        for (var _i = 0, _a = this.draggables.toArray(); _i < _a.length; _i++) {
            var dragger = _a[_i];
            var elm = dragger.element;
            var left = parseInt(elm.offsetLeft.toString(), 0);
            this.positions[dragger.dragModel.prop] = {
                left: left,
                right: left + parseInt(elm.offsetWidth.toString(), 0),
                index: i++,
                element: elm
            };
        }
    };
    OrderableDirective.prototype.onDragEnd = function (_a) {
        var element = _a.element, model = _a.model, event = _a.event;
        var prevPos = this.positions[model.prop];
        var target = this.isTarget(model, event);
        if (target) {
            this.reorder.emit({
                prevIndex: prevPos.index,
                newIndex: target.i,
                model: model
            });
        }
        element.style.left = 'auto';
    };
    OrderableDirective.prototype.isTarget = function (model, event) {
        var i = 0;
        var x = event.x || event.clientX;
        var y = event.y || event.clientY;
        var targets = this.document.elementsFromPoint(x, y);
        var _loop_1 = function (prop) {
            // current column position which throws event.
            var pos = this_1.positions[prop];
            // since we drag the inner span, we need to find it in the elements at the cursor
            if (model.prop !== prop && targets.find(function (el) { return el === pos.element; })) {
                return { value: {
                        pos: pos,
                        i: i
                    } };
            }
            i++;
        };
        var this_1 = this;
        for (var prop in this.positions) {
            var state_1 = _loop_1(prop);
            if (typeof state_1 === "object")
                return state_1.value;
        }
    };
    OrderableDirective.prototype.createMapDiffs = function () {
        return this.draggables.toArray()
            .reduce(function (acc, curr) {
            acc[curr.dragModel.$$id] = curr;
            return acc;
        }, {});
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], OrderableDirective.prototype, "reorder", void 0);
    __decorate([
        core_1.ContentChildren(draggable_directive_1.DraggableDirective, { descendants: true }),
        __metadata("design:type", core_1.QueryList)
    ], OrderableDirective.prototype, "draggables", void 0);
    OrderableDirective = __decorate([
        core_1.Directive({ selector: '[orderable]' }),
        __param(1, core_1.Inject(platform_browser_1.DOCUMENT)),
        __metadata("design:paramtypes", [core_1.KeyValueDiffers, Object])
    ], OrderableDirective);
    return OrderableDirective;
}());
exports.OrderableDirective = OrderableDirective;
//# sourceMappingURL=orderable.directive.js.map

/***/ }),

/***/ "ivjz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StorageManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_userService__ = __webpack_require__("ZSxL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ng2_cookies__ = __webpack_require__("tbtb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ng2_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ng2_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_configService__ = __webpack_require__("cfSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ng2_cookies_ng2_cookies__ = __webpack_require__("46qw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ng2_cookies_ng2_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ng2_cookies_ng2_cookies__);




var StorageManager = /** @class */ (function () {
    function StorageManager(userService, cookieService, configService) {
        this.userService = userService;
        this.cookieService = cookieService;
        this.configService = configService;
    }
    StorageManager.prototype.getCurrentUser = function () {
        var _this = this;
        if (this.user != null)
            return new Promise(function (resolve, reject) { return resolve(_this.user); });
        if (!__WEBPACK_IMPORTED_MODULE_3_ng2_cookies_ng2_cookies__["Cookie"].get(this.configService.config.UserCookieName))
            return null;
        var userId = +__WEBPACK_IMPORTED_MODULE_3_ng2_cookies_ng2_cookies__["Cookie"].get(this.configService.config.UserCookieName);
        return this.userService.getById(userId).then(function (x) {
            _this.user = x.Data;
            return _this.user;
        });
    };
    StorageManager.prototype.setCurrentUser = function (obj) {
        this.user = obj;
        if (obj == null) {
            this.cookieService.delete(this.configService.config.ApiTokenCookieName);
            this.cookieService.delete(this.configService.config.UserCookieName);
        }
    };
    StorageManager.prototype.logout = function () {
        this.setCurrentUser(null);
    };
    StorageManager.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__services_userService__["a" /* UserService */] }, { type: __WEBPACK_IMPORTED_MODULE_1_ng2_cookies__["CookieService"] }, { type: __WEBPACK_IMPORTED_MODULE_2__services_configService__["a" /* ConfigService */] }]; };
    return StorageManager;
}());

//# sourceMappingURL=storageManager.js.map

/***/ }),

/***/ "j2I9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("jUj/"));
__export(__webpack_require__("2dA3"));
__export(__webpack_require__("17ct"));
__export(__webpack_require__("ORct"));
__export(__webpack_require__("kl+b"));
__export(__webpack_require__("U6Mf"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "jFcQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Select2Util; });
/**
 * Created by svitlana.i on 9/21/2017.
 */
var Select2Util = /** @class */ (function () {
    function Select2Util() {
    }
    Select2Util.checkIfSelectOpen = function (id) {
        return $('#' + id + ' .select2-container--open').length > 0;
    };
    return Select2Util;
}());

//# sourceMappingURL=select2Util.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "jUPs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManufacturerTabV2Component; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_orders_order__ = __webpack_require__("hz4y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_orders_orderItem__ = __webpack_require__("PL+a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_management_locationManagement_Country__ = __webpack_require__("eZFs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ng2_cookies_ng2_cookies__ = __webpack_require__("46qw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ng2_cookies_ng2_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ng2_cookies_ng2_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_configService__ = __webpack_require__("cfSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_helpers_calculatorHelper__ = __webpack_require__("osrx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_google_tag_service__ = __webpack_require__("nz7M");








var ManufacturerTabV2Component = /** @class */ (function () {
    function ManufacturerTabV2Component(configService, detectChanges, googleTagService) {
        this.configService = configService;
        this.detectChanges = detectChanges;
        this.googleTagService = googleTagService;
        this.order = new __WEBPACK_IMPORTED_MODULE_1__objects_orders_order__["a" /* Order */]();
        this.orderItem = new __WEBPACK_IMPORTED_MODULE_2__objects_orders_orderItem__["b" /* OrderItem */]();
        this.onTabSelected = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    Object.defineProperty(ManufacturerTabV2Component.prototype, "isVehicle", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_6__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].isVehicle(this.order);
        },
        enumerable: true,
        configurable: true
    });
    ManufacturerTabV2Component.prototype.ngAfterViewInit = function () {
        this.initManufacturerSelect();
    };
    ManufacturerTabV2Component.prototype.initManufacturerSelect = function () {
        var select = $("#manufacturerSelect");
        var self = this;
        select.select2({
            width: '100%',
            data: [],
            allowClear: false,
            placeholder: 'Other country',
            ajax: {
                url: this.configService.config.ApiUrl + "/location/search/country",
                delay: 500,
                headers: {
                    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_4_ng2_cookies_ng2_cookies__["Cookie"].get(this.configService.config.ApiTokenCookieName),
                },
                data: function (params) {
                    return {
                        country: params.term
                    };
                },
                processResults: function (data, params) {
                    var results = data.Data.map(function (country) {
                        return {
                            id: country.Code,
                            text: country.Name
                        };
                    });
                    results = results.filter(function (x) { return x.text.toLowerCase() != "canada"
                        /*&& x.text.toLowerCase() != "mexico"*/
                        && x.text.toLowerCase() != "united states"
                        && x.text.toLowerCase() != 'japan'
                        && x.text.toLowerCase() != 'china'
                        && x.text.toLowerCase() != 'germany'; });
                    return {
                        results: results
                    };
                },
            },
            minimumInputLength: 2
        }).on('select2:select', function (e) {
            var selectedData = $(this).select2('data');
            var item = selectedData[0];
            self.orderItem.Manufacturer = new __WEBPACK_IMPORTED_MODULE_3__objects_management_locationManagement_Country__["a" /* Country */]({
                Code: item.id,
                Name: item.text
            });
        }).on('select2:unselect', function (e) {
            self.orderItem.Manufacturer = new __WEBPACK_IMPORTED_MODULE_3__objects_management_locationManagement_Country__["a" /* Country */]();
        }).on('select2:open', function (params) {
            var select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });
    };
    ManufacturerTabV2Component.prototype.setManufacturer = function (country) {
        if (this.orderItem.Manufacturer && this.orderItem.Manufacturer.Code == country.Code)
            this.orderItem.Manufacturer = new __WEBPACK_IMPORTED_MODULE_3__objects_management_locationManagement_Country__["a" /* Country */]();
        else {
            $("#manufacturerSelect").html("");
            this.orderItem.Manufacturer = country;
        }
        this.detectChanges.detectChanges();
    };
    ManufacturerTabV2Component.prototype.getCountry = function (code) {
        var name = '';
        code = code.toUpperCase().trim();
        switch (code) {
            case 'US':
                name = 'United States';
                break;
            case 'CA':
                name = 'Canada';
                break;
            case 'CN':
                name = 'China';
                break;
            case 'JP':
                name = 'Japan';
                break;
            case 'DE':
                name = 'Germany';
                break;
        }
        return new __WEBPACK_IMPORTED_MODULE_3__objects_management_locationManagement_Country__["a" /* Country */]({
            Code: code,
            Name: name
        });
    };
    ManufacturerTabV2Component.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_5__services_configService__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] }, { type: __WEBPACK_IMPORTED_MODULE_7__services_google_tag_service__["a" /* GoogleTagService */] }]; };
    return ManufacturerTabV2Component;
}());

//# sourceMappingURL=manufacturer-tab-v2.component.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "jUj/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ColumnMode;
(function (ColumnMode) {
    ColumnMode["standard"] = "standard";
    ColumnMode["flex"] = "flex";
    ColumnMode["force"] = "force";
})(ColumnMode = exports.ColumnMode || (exports.ColumnMode = {}));
//# sourceMappingURL=column-mode.type.js.map

/***/ }),

/***/ "kl+b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ClickType;
(function (ClickType) {
    ClickType["single"] = "single";
    ClickType["double"] = "double";
})(ClickType = exports.ClickType || (exports.ClickType = {}));
//# sourceMappingURL=click.type.js.map

/***/ }),

/***/ "kxTq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TariffSource; });
/**
 * Created by alex.y on 8/8/2017.
 */
var TariffSource;
(function (TariffSource) {
    TariffSource[TariffSource["Canada"] = 0] = "Canada";
    TariffSource[TariffSource["Usa"] = 1] = "Usa";
})(TariffSource || (TariffSource = {}));
//# sourceMappingURL=tariffSource.js.map

/***/ }),

/***/ "l1uE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Duty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DutyType; });
/**
 * Created by alex.y on 8/31/2017.
 */
var Duty = /** @class */ (function () {
    function Duty(obj) {
        this.ExtraDuties = [];
        Object.assign(this, obj);
    }
    return Duty;
}());

var DutyType;
(function (DutyType) {
    DutyType[DutyType["Percent"] = 0] = "Percent";
    DutyType[DutyType["PerItem"] = 1] = "PerItem";
    DutyType[DutyType["Sugar"] = 2] = "Sugar";
    DutyType[DutyType["Less"] = 3] = "Less";
    DutyType[DutyType["More"] = 4] = "More";
    DutyType[DutyType["LessTariff"] = 5] = "LessTariff";
    DutyType[DutyType["Degree"] = 6] = "Degree";
    DutyType[DutyType["Plus"] = 7] = "Plus";
    DutyType[DutyType["None"] = 8] = "None";
    DutyType[DutyType["Manual"] = 9] = "Manual";
})(DutyType || (DutyType = {}));
//# sourceMappingURL=duty.js.map

/***/ }),

/***/ "lyLw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var atoa = __webpack_require__("Nkju");
var debounce = __webpack_require__("WWez");

module.exports = function emitter (thing, options) {
  var opts = options || {};
  var evt = {};
  if (thing === undefined) { thing = {}; }
  thing.on = function (type, fn) {
    if (!evt[type]) {
      evt[type] = [fn];
    } else {
      evt[type].push(fn);
    }
    return thing;
  };
  thing.once = function (type, fn) {
    fn._once = true; // thing.off(fn) still works!
    thing.on(type, fn);
    return thing;
  };
  thing.off = function (type, fn) {
    var c = arguments.length;
    if (c === 1) {
      delete evt[type];
    } else if (c === 0) {
      evt = {};
    } else {
      var et = evt[type];
      if (!et) { return thing; }
      et.splice(et.indexOf(fn), 1);
    }
    return thing;
  };
  thing.emit = function () {
    var args = atoa(arguments);
    return thing.emitterSnapshot(args.shift()).apply(this, args);
  };
  thing.emitterSnapshot = function (type) {
    var et = (evt[type] || []).slice(0);
    return function () {
      var args = atoa(arguments);
      var ctx = this || thing;
      if (type === 'error' && opts.throws !== false && !et.length) { throw args.length === 1 ? args[0] : args; }
      et.forEach(function emitter (listen) {
        if (opts.async) { debounce(listen, args, ctx); } else { listen.apply(ctx, args); }
        if (listen._once) { thing.off(type, listen); }
      });
      return thing;
    };
  };
  return thing;
};


/***/ }),

/***/ "mCwL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseEntity; });
/**
 * Created by stas on 5/22/2017.
 */
var BaseEntity = /** @class */ (function () {
    function BaseEntity() {
        this.Id = null;
        this.Created = null;
        this.Updated = null;
    }
    return BaseEntity;
}());

//# sourceMappingURL=baseEntity.js.map

/***/ }),

/***/ "mZEr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalculatorAccordion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_orders_orderItem__ = __webpack_require__("PL+a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_EnumUtil__ = __webpack_require__("niNk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_products_product__ = __webpack_require__("aZ3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies__ = __webpack_require__("46qw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_configService__ = __webpack_require__("cfSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__objects_management_locationManagement_Country__ = __webpack_require__("eZFs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_helpers_guidHelper__ = __webpack_require__("SCcC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__objects_currencyExchange_canadianCurrencyCode__ = __webpack_require__("3Ddi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__objects_calculator_duty__ = __webpack_require__("l1uE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_productService__ = __webpack_require__("XowU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__objects_tariffs_tariffSource__ = __webpack_require__("kxTq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_orders_PdaType__ = __webpack_require__("xDjd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__objects_orders_calculatorType__ = __webpack_require__("BhF2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__objects_requests_productSearchRequest__ = __webpack_require__("hgwR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_calculator_calculatorService__ = __webpack_require__("5Lgg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__objects_products_requestType__ = __webpack_require__("HY16");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__ = __webpack_require__("osrx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__ = __webpack_require__("MAv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__objects_orders_orderOptions__ = __webpack_require__("Wcmd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__objects_products_productSearchType__ = __webpack_require__("Tp9a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_helpers_HScodeHelper__ = __webpack_require__("uPA9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__objects_orders_taxType__ = __webpack_require__("TDHu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__services_calculator_tax_service__ = __webpack_require__("/9l6");

























var CalculatorAccordion = /** @class */ (function () {
    function CalculatorAccordion(configService, productService, calculatorService, ChangeDetectorRef, taxService) {
        this.configService = configService;
        this.productService = productService;
        this.calculatorService = calculatorService;
        this.ChangeDetectorRef = ChangeDetectorRef;
        this.taxService = taxService;
        this.isQuickQuote = false;
        this.isPublic = false;
        this.calculatorHelper = __WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */];
        this.enumUtil = __WEBPACK_IMPORTED_MODULE_3__common_utils_EnumUtil__["a" /* EnumUtil */];
        this.string = String;
        this.calculatorType = __WEBPACK_IMPORTED_MODULE_14__objects_orders_calculatorType__["a" /* CalculatorType */];
        this.tariffSource = __WEBPACK_IMPORTED_MODULE_12__objects_tariffs_tariffSource__["a" /* TariffSource */];
        this.orderOptions = __WEBPACK_IMPORTED_MODULE_20__objects_orders_orderOptions__["a" /* OrderOptions */];
        this.dutyType = __WEBPACK_IMPORTED_MODULE_10__objects_calculator_duty__["b" /* DutyType */];
        this.OrderOptions = __WEBPACK_IMPORTED_MODULE_20__objects_orders_orderOptions__["a" /* OrderOptions */];
        this.isTarifLoading = false;
        this.select2ProductId = "productSelect-" + __WEBPACK_IMPORTED_MODULE_8__common_helpers_guidHelper__["a" /* Guid */].newGuid();
        this.select2ProductData = null;
        this.select2ManufacturerId = "manufacturer-" + __WEBPACK_IMPORTED_MODULE_8__common_helpers_guidHelper__["a" /* Guid */].newGuid();
        this.select2PdaId = "pda-" + __WEBPACK_IMPORTED_MODULE_8__common_helpers_guidHelper__["a" /* Guid */].newGuid();
        this.select2CurrencyId = "pda-" + __WEBPACK_IMPORTED_MODULE_8__common_helpers_guidHelper__["a" /* Guid */].newGuid();
        this.select2CurrencyData = null;
        this.pdaEnum = __WEBPACK_IMPORTED_MODULE_13__objects_orders_PdaType__["a" /* PdaType */];
        this.manufacturer = '';
        this.isPassVehicle = false;
        this.IsTrucksVal = false;
        this.isAC = false;
        this.isVehicleParts = false;
        this.isTrailerOnly = false;
        this.pagerConfig = {
            itemsPerPage: 10,
            currentPage: 0,
            totalItems: 1
        };
        this.isProductNameHidden = true;
        this.initialized = false;
        this.onItemRemoved = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.greenLevyResult = [
            {
                id: 0,
                text: "0-13 liters"
            },
            {
                id: 1,
                text: "13-14 liters"
            },
            {
                id: 2,
                text: "14-15 liters"
            },
            {
                id: 3,
                text: "15-16 liters"
            },
            {
                id: 4,
                text: "16 or more liters"
            }
        ];
    }
    Object.defineProperty(CalculatorAccordion.prototype, "isUsService", {
        get: function () {
            if (!this.order || !this.order.Flag)
                return false;
            return this.order.Flag.hasFlag(__WEBPACK_IMPORTED_MODULE_20__objects_orders_orderOptions__["a" /* OrderOptions */].IsUsService);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalculatorAccordion.prototype, "isVehicle", {
        // @Input()
        get: function () {
            return this.calculatorHelper.isVehicle(this.order);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalculatorAccordion.prototype, "usedEquipmentExamp", {
        get: function () {
            return this.orderItem.Flags != null && this.orderItem.Flags.hasFlag(__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].UsedEquipment);
        },
        set: function (val) {
            if (val) {
                this.orderItem.Flags |= __WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].UsedEquipment;
            }
            else {
                this.orderItem.Flags &= ~__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].UsedEquipment;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalculatorAccordion.prototype, "greenLevy", {
        get: function () {
            var tax = this.orderItem.Taxes.find(function (x) { return x.TaxType == __WEBPACK_IMPORTED_MODULE_23__objects_orders_taxType__["a" /* TaxType */].GreenLevy; });
            if (!tax) {
                tax = new __WEBPACK_IMPORTED_MODULE_2__objects_orders_orderItem__["a" /* ItemTax */]({
                    TaxType: __WEBPACK_IMPORTED_MODULE_23__objects_orders_taxType__["a" /* TaxType */].GreenLevy
                });
                this.orderItem.Taxes.push(tax);
            }
            return tax;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalculatorAccordion.prototype, "greenLevyValue", {
        get: function () {
            var tax = this.orderItem.Taxes.find(function (x) { return x.TaxType == __WEBPACK_IMPORTED_MODULE_23__objects_orders_taxType__["a" /* TaxType */].GreenLevy; });
            return !tax ? null : tax.Value;
        },
        enumerable: true,
        configurable: true
    });
    CalculatorAccordion.prototype.getClass = function () {
        if (!this.initialized)
            return "panel-default";
        if (this.accordion.isOpen)
            return "accordion-open";
        if (!this.accordionForm.valid && !this.disableChanges)
            return 'accordion-error';
        else
            return "";
    };
    CalculatorAccordion.prototype.checkForm = function () {
        this.accordionForm.onSubmit(null);
        return this.accordionForm.valid;
    };
    CalculatorAccordion.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.$greenLevyElement = $("#" + this.select2ProductId + "_greenLevy");
        this.subscription = this.calculatorService.subscribe(function (location) {
            if (!location)
                return;
            //if (location.Type == 2) {
            _this.handleHsChange(true);
            //}
            if (__WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].isUsaShipmentFrom(_this.order) && __WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].isCanadianVehicleCalculator(_this.order)) {
                setTimeout(function () {
                    _this.initGreenLevySelect();
                }, 150);
            }
        });
        this.subscriptionIsVehicle = this.calculatorService.subscribeIsVeh(function (isVehicle) {
            if (_this.select2ProductData) {
                _this.select2ProductData.destroy();
                var t = $("#" + _this.select2ProductId);
                t.off('select2:select');
                t.off('select2:unselect');
                t.off('select2:close');
                t.off('select2:open');
                setTimeout(function () {
                    _this.initProductSelect();
                });
            }
            setTimeout(function () {
                _this.initYearSelect();
            });
            if (__WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].isUsaShipmentFrom(_this.order) && __WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].isCanadianVehicleCalculator(_this.order)) {
                setTimeout(function () {
                    _this.initGreenLevySelect();
                }, 150);
            }
            _this.handleHsChange(true);
        });
        setTimeout(function () {
            _this.initialized = true;
            _this.initProductSelect();
            _this.initManufacturerSelect();
            _this.initPdaSelect();
            _this.initCurrencySelect();
            _this.initYearSelect();
            _this.initGreenLevySelect();
        });
        if (__WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].isCanadianVehicleCalculator(this.order) && this.orderItem.Flags != null) {
            this.isAC = this.orderItem.Flags.hasFlag(__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsAC);
            this.isVehicleParts = this.orderItem.Flags.hasFlag(__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsVehicleParts);
            this.isTrailerOnly = this.orderItem.Flags.hasFlag(__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].isTrailerOnly);
            //this.lessOrEqualFifteenYears = this.orderItem.Flags.hasFlag(OrderItemOptions.IsLessOrEqualFifteenYrs);
        }
    };
    CalculatorAccordion.prototype.ngOnDestroy = function () {
        if (this.subscription)
            this.subscription.unsubscribe();
        if (this.subscriptionIsVehicle)
            this.subscriptionIsVehicle.unsubscribe();
    };
    CalculatorAccordion.prototype.initProductSelect = function () {
        var _this = this;
        var self = this;
        var $element = $("#" + self.select2ProductId);
        $element.select2({
            width: '100%',
            data: [],
            selectOnClose: true,
            placeholder: self.isVehicle ? 'Enter vehicle make and model' : 'Type and select product (minimum two words)',
            language: {
                noResults: function () {
                    return "Sorry, nothing matches, please source the HS/Tariff code manually and enter it into HS Code input field.";
                },
                inputTooShort: function () {
                    return _this.isVehicle ? $('<span>please enter 2 or more characters</span><br><span>*note, search result will contain most used tariffs</span>')
                        : "please enter 2 or more characters";
                },
            },
            ajax: {
                dataType: 'json',
                delay: 500,
                transport: function (params, success, failure) {
                    var request = new __WEBPACK_IMPORTED_MODULE_15__objects_requests_productSearchRequest__["a" /* ProductSearchRequest */]({
                        Query: params.data.term,
                        CustomerId: self.order.Customer && self.order.Customer.Id && !self.isPublic ? self.order.Customer.Id : '',
                        Skip: self.pagerConfig.currentPage++ * self.pagerConfig.itemsPerPage,
                        Top: self.pagerConfig.itemsPerPage,
                        Source: self.getSearchType(),
                        RequestType: __WEBPACK_IMPORTED_MODULE_17__objects_products_requestType__["a" /* RequestType */].ProductsAndTariffs,
                        SearchType: self.getSearchTypeByQuery(params.data.term)
                    });
                    _this.productService.search(request).then(function (response) {
                        if ((!response || !response.Data || response.Data.TotalCount == 0) && (_this.order.Flag && _this.order.Flag.hasFlag(__WEBPACK_IMPORTED_MODULE_20__objects_orders_orderOptions__["a" /* OrderOptions */].IsVehicle))) {
                            request.Query = "87%";
                            request.SearchType = 2;
                            _this.productService.search(request).then(function (response) { return success(response); });
                        }
                        else
                            success(response);
                    }).catch(function (_) { return failure(); });
                },
                processResults: function (data, params) {
                    self.pagerConfig.totalItems = data.Data.TotalCount;
                    var results = data.Data.Items.map(function (product) {
                        return {
                            id: product.Id,
                            text: product.Name,
                            item: product,
                            updateTariff: true,
                            isSelect: true
                        };
                    });
                    return {
                        results: results,
                        pagination: {
                            more: self.pagerConfig.currentPage * self.pagerConfig.itemsPerPage < self.pagerConfig.totalItems
                        }
                    };
                },
            },
            templateResult: function formatState(state) {
                if (!state.id) {
                    self.pagerConfig.currentPage = 0;
                    return state.text;
                }
                return $((self.getSearchType() == null ? '<span> Tariff Country: ' + (state.item.Source == __WEBPACK_IMPORTED_MODULE_12__objects_tariffs_tariffSource__["a" /* TariffSource */].Usa ? 'USA' : 'Canada') + '</span><br>' : '') +
                    (state.item.Name ? ('<span>' + state.item.Name + '</span><br>') : '') +
                    (state.item.Description ? ('<span>' + state.item.Description + '</span><br>') : '') +
                    '<span>' + state.item.HsCode + '</span><br>' +
                    '<span>' + self.calculatorHelper.getProductTariff(state.item, self.orderItem, self.order, self.taxService.canadianHsCodesAlAndSteel10, self.taxService.canadianHsCodesAlAndSteel25, self.taxService.canadianHsCodesChina0, self.taxService.usaHsCodesChina25) + '</span>');
            },
            minimumInputLength: 2
        }).on('select2:select', function (e) {
            var selectedData = $(this).select2('data');
            if (!selectedData || !selectedData[0])
                return;
            selectedData[0] = e.params.data;
            if (selectedData[0].item == null) {
                return;
            }
            if (__WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].isUsedEquipment(selectedData[0].item) && ((self.orderItem.Product == null || !self.orderItem.Product.Name)
                || !__WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].isUsedEquipment(self.orderItem.Product))) {
                self.orderItem.Flags |= __WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].UsedEquipment;
            }
            if (!__WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].isUsedEquipment(selectedData[0].item)) {
                self.orderItem.Flags &= ~__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].UsedEquipment;
            }
            var tempName = "";
            if (selectedData[0].isSelect && selectedData[0].item.Name && selectedData[0].item.Description) {
                tempName = selectedData[0].item.Name;
            }
            else
                tempName = self.orderItem.Product.Name; //Get typed name from select 2, see on close select handler
            if (!tempName)
                tempName = "";
            self.orderItem.Product = selectedData[0].item;
            if (self.orderItem.Product.HsCode || !self.manualHsCode)
                self.manualHsCode = self.orderItem.Product.HsCode; //TODO ??
            if (tempName || (self.orderItem.Product.Name && !self.orderItem.Product.Description)) {
                var tempDescription = self.orderItem.Product.Name; //Save Name as description
                self.orderItem.Product.Name = tempName; // override name(description) to name that was typed
                if (self.orderItem.Product.Id && !self.orderItem.Product.Description)
                    self.orderItem.Product.Description = tempDescription;
            }
            if (selectedData[0].updateTariff)
                __WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].getTariffs(self.orderItem.Product.Source, self.calculatorHelper.getTariff(self.orderItem, self.order, self.order.Flag && self.order.Flag.hasFlag(__WEBPACK_IMPORTED_MODULE_20__objects_orders_orderOptions__["a" /* OrderOptions */].IsVehicle), self.taxService.canadianHsCodesAlAndSteel10, self.taxService.canadianHsCodesAlAndSteel25, self.taxService.canadianHsCodesChina0, self.taxService.usaHsCodesChina25), self.orderItem);
            if (!self.orderItem.Product.Name && !self.orderItem.Product.Description) {
                self.isProductNameHidden = true;
                return;
            }
            self.select2ProductData.$selection.hide();
            self.isProductNameHidden = false;
        }).on('select2:close', function (e) {
            self.pagerConfig.currentPage = 0;
            var select = $(this).data("select2");
            if (self.select2ProductData && self.select2ProductData.results && self.select2ProductData.results.lastParams
                && self.select2ProductData.results.lastParams.term) {
                self.orderItem.Product.Name = select.results.lastParams.term;
                select.results.lastParams.term = "";
                self.select2ProductData.$selection.hide();
                self.isProductNameHidden = false;
            }
        }).on('select2:unselect', function (e) {
            self.clearProduct();
        }).on('select2:open', function (params) {
            var select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });
        this.select2ProductData = $element.data("select2");
        if (this.isUsService) {
            $element.prop("disabled", true);
        }
        if (!self.orderItem.Product || (!self.orderItem.Product.Name && !self.orderItem.Product.Description && !self.orderItem.Product.HsCode)) {
            this.isProductNameHidden = true;
            return;
        }
        setTimeout(function () {
            if (_this.select2ProductData) {
                if (_this.orderItem.Product != null && _this.orderItem.Product.Source != null && _this.order.CalculatorType != +_this.orderItem.Product.Source) {
                    _this.handleHsChange(true);
                }
                else {
                    _this.select2ProductData.trigger("select", { data: { item: _this.orderItem.Product, updateTariff: false, id: __WEBPACK_IMPORTED_MODULE_8__common_helpers_guidHelper__["a" /* Guid */].newGuid() } });
                }
            }
        }, 300);
        if (this.disableChanges)
            $element.prop("disabled", true);
    };
    CalculatorAccordion.prototype.getSearchTypeByQuery = function (name) {
        var regex = /[^0-9^.]/i;
        if (regex.test(name))
            return this.isVehicle ? __WEBPACK_IMPORTED_MODULE_21__objects_products_productSearchType__["a" /* ProductSearchType */].VehicleQuery : __WEBPACK_IMPORTED_MODULE_21__objects_products_productSearchType__["a" /* ProductSearchType */].ProductQuery;
        return this.isVehicle ? __WEBPACK_IMPORTED_MODULE_21__objects_products_productSearchType__["a" /* ProductSearchType */].VehicleHsCode : __WEBPACK_IMPORTED_MODULE_21__objects_products_productSearchType__["a" /* ProductSearchType */].ProductHsCode;
    };
    CalculatorAccordion.prototype.clearProduct = function (saveName, manualCode) {
        var _this = this;
        if (saveName === void 0) { saveName = false; }
        if (manualCode === void 0) { manualCode = false; }
        if (this.disableChanges)
            if (this.disableChanges)
                return;
        var tempName = this.orderItem.Product.Name;
        var tempHs = this.manualHsCode;
        this.orderItem.Product = new __WEBPACK_IMPORTED_MODULE_4__objects_products_product__["a" /* Product */]();
        this.orderItem.DutyList = [];
        if (!manualCode)
            this.manualHsCode = "";
        if (this.isQuickQuote)
            return;
        if (saveName) {
            this.orderItem.Product.Name = tempName;
            this.orderItem.Product.HsCode = tempHs;
            this.select2ProductData.$selection.hide();
            this.isProductNameHidden = false;
            return;
        }
        this.isProductNameHidden = true;
        setTimeout(function () {
            _this.select2ProductData.$element.val('');
            _this.select2ProductData.$element.trigger('change');
            _this.select2ProductData.$selection.show();
        }, 300);
    };
    CalculatorAccordion.prototype.handleProductInput = function (value) {
        if (this.select2ProductData && this.select2ProductData.results && this.select2ProductData.results.lastParams && this.select2ProductData.results.lastParams.term)
            this.select2ProductData.results.lastParams.term = value;
    };
    CalculatorAccordion.prototype.initManufacturerSelect = function () {
        var self = this;
        var select = $("#" + self.select2ManufacturerId);
        if (this.isQuickQuote)
            this.initStaticManufacturerSelect2(select);
        else
            this.initDynamicManufacturerSelect2(select);
        if (this.disableChanges)
            select.prop("disabled", true);
    };
    CalculatorAccordion.prototype.initDynamicManufacturerSelect2 = function (select) {
        var self = this;
        select.select2({
            width: '100%',
            data: [],
            allowClear: true,
            selectOnClose: true,
            placeholder: 'Type or select country of origin',
            ajax: {
                url: this.configService.config.ApiUrl + "/location/search/country",
                datatype: 'json',
                delay: 500,
                headers: {
                    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_5_ng2_cookies_ng2_cookies__["Cookie"].get(this.configService.config.ApiTokenCookieName),
                },
                data: function (params) {
                    return {
                        country: params.term
                    };
                },
                processResults: function (data, params) {
                    var results = data.Data.map(function (country) {
                        return {
                            id: country.Code,
                            text: country.Name
                        };
                    });
                    if (self.isQuickQuote) {
                        results = results.filter(function (x) { return x.text == "Canada" || x.text == "United States" || x.text == "Mexico"; });
                    }
                    return {
                        results: results
                    };
                },
            },
            minimumInputLength: 2
        }).on('select2:select', function (e) {
            var selectedData = $(this).select2('data');
            self.orderItem.Manufacturer.Name = selectedData[0].text;
            self.orderItem.Manufacturer.Code = selectedData[0].id;
            self.manufacturer = selectedData[0].id;
            __WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].getTariffs(self.orderItem.Product.Source, self.calculatorHelper.getTariff(self.orderItem, self.order, false, self.taxService.canadianHsCodesAlAndSteel10, self.taxService.canadianHsCodesAlAndSteel25, self.taxService.canadianHsCodesChina0, self.taxService.usaHsCodesChina25), self.orderItem);
        }).on('select2:unselect', function (e) {
            self.orderItem.Manufacturer = new __WEBPACK_IMPORTED_MODULE_7__objects_management_locationManagement_Country__["a" /* Country */]();
            self.manufacturer = '';
            __WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].getTariffs(self.orderItem.Product.Source, self.calculatorHelper.getTariff(self.orderItem, self.order, false, self.taxService.canadianHsCodesAlAndSteel10, self.taxService.canadianHsCodesAlAndSteel25, self.taxService.canadianHsCodesChina0, self.taxService.usaHsCodesChina25), self.orderItem);
        }).on('select2:open', function (params) {
            var select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });
        var select2Data = select.data("select2");
        if (!self.orderItem.Manufacturer || !self.orderItem.Manufacturer.Name)
            return;
        setTimeout(function () {
            if (select2Data)
                select2Data.trigger("select", { data: { id: self.orderItem.Manufacturer.Code, text: self.orderItem.Manufacturer.Name } });
        }, 300);
    };
    CalculatorAccordion.prototype.initStaticManufacturerSelect2 = function (select) {
        var self = this;
        select.select2({
            width: '100%',
            selectOnClose: true,
            data: [
                {
                    id: "CA",
                    text: "Canada"
                },
                {
                    id: "US",
                    text: "United States"
                },
                {
                    id: "MX",
                    text: "Mexico"
                }
            ],
            allowClear: true,
            placeholder: 'Type or select country of origin',
        }).on('select2:select', function (e) {
            var selectedData = $(this).select2('data');
            self.orderItem.Manufacturer.Name = selectedData[0].text;
            self.orderItem.Manufacturer.Code = selectedData[0].id;
            self.manufacturer = selectedData[0].id;
            __WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].getTariffs(self.orderItem.Product.Source, self.calculatorHelper.getTariff(self.orderItem, self.order, false, self.taxService.canadianHsCodesAlAndSteel10, self.taxService.canadianHsCodesAlAndSteel25, self.taxService.canadianHsCodesChina0, self.taxService.usaHsCodesChina25), self.orderItem);
        }).on('select2:unselect', function (e) {
            self.orderItem.Manufacturer = new __WEBPACK_IMPORTED_MODULE_7__objects_management_locationManagement_Country__["a" /* Country */]();
            self.manufacturer = '';
            __WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].getTariffs(self.orderItem.Product.Source, self.calculatorHelper.getTariff(self.orderItem, self.order, false, self.taxService.canadianHsCodesAlAndSteel10, self.taxService.canadianHsCodesAlAndSteel25, self.taxService.canadianHsCodesChina0, self.taxService.usaHsCodesChina25), self.orderItem);
        }).on('select2:open', function (params) {
            var select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });
        var select2Data = select.data("select2");
        if (!self.orderItem.Manufacturer || !self.orderItem.Manufacturer.Name)
            return;
        setTimeout(function () {
            if (select2Data)
                select2Data.trigger("select", { data: { id: self.orderItem.Manufacturer.Code } });
        }, 300);
    };
    CalculatorAccordion.prototype.handlePdaSelect = function (selectedData) {
        this.orderItem.Type = 0;
        this.setPdaTypes(selectedData, this.orderItem);
    };
    CalculatorAccordion.prototype.initPdaSelect = function () {
        var _this = this;
        var self = this;
        var select = $("#" + self.select2PdaId);
        var convertedData = this.enumUtil.convertEnumToTuple(self.pdaEnum);
        select.select2({
            width: '100%',
            data: self.generateSelectData(convertedData),
            allowClear: true,
            placeholder: 'Select',
            multiple: 'multiple',
            selectOnClose: true,
            closeOnSelect: false
        }).on('select2:select', function (e) {
            self.handlePdaSelect($(this).val());
        }).on('select2:unselect', function (e) {
            self.handlePdaSelect($(this).val());
        }).on('select2:open', function (params) {
            var select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });
        if (this.orderItem && this.orderItem.Type && this.orderItem.Type != 0) {
            setTimeout(function () {
                var result = [];
                for (var _i = 0, convertedData_1 = convertedData; _i < convertedData_1.length; _i++) {
                    var pdaType = convertedData_1[_i];
                    if ((_this.orderItem.Type).hasFlag(parseInt(pdaType.Key.toString()))) {
                        result.push(parseInt(pdaType.Key.toString()));
                    }
                }
                select.val(result).trigger("change");
            }, 300);
        }
        if (this.disableChanges)
            select.prop("disabled", true);
    };
    CalculatorAccordion.prototype.changeCurrency = function (currency) {
        if (this.select2CurrencyData)
            this.select2CurrencyData.trigger("select", { data: { id: currency.Code } });
    };
    CalculatorAccordion.prototype.initCurrencySelect = function () {
        var _this = this;
        var self = this;
        var $element = $("#" + self.select2CurrencyId);
        $element.select2({
            width: '100%',
            allowClear: true,
            placeholder: 'Currency',
            closeOnSelect: true,
            selectOnClose: true
        }).on('select2:select', function (e) {
            var selectedData = $(this).select2('data');
            if (!selectedData || selectedData.length == 0)
                return;
            if (!self.disableChanges) {
                self.orderItem.CanadianCurrencyCode = JSON.parse(JSON.stringify(self.canadianCurrencyCodes.find(function (x) { return x.Code.toLowerCase() == selectedData[0].id.toLowerCase(); })));
                if (self.orderItem.CurrencyId != null)
                    self.orderItem.CanadianCurrencyCode.Id = self.orderItem.CurrencyId.toString();
            }
            if (!self.orderItem.CanadianCurrencyCode) {
                self.select2CurrencyData.trigger("select", { data: { id: "FXUSDCAD" } });
            }
        }).on('select2:unselect', function (e) {
            self.orderItem.CanadianCurrencyCode = new __WEBPACK_IMPORTED_MODULE_9__objects_currencyExchange_canadianCurrencyCode__["a" /* CanadianCurrencyCode */]();
        }).on('select2:open', function (params) {
            var select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });
        this.select2CurrencyData = $element.data("select2");
        setTimeout(function () {
            if (_this.orderItem.CanadianCurrencyCode && _this.orderItem.CanadianCurrencyCode.Code) {
                _this.changeCurrency(_this.orderItem.CanadianCurrencyCode);
            }
        }, 300);
        if (this.disableChanges)
            $element.prop("disabled", true);
    };
    CalculatorAccordion.prototype.initYearSelect = function () {
        if (!this.isVehicle)
            return;
        var self = this;
        var years = __WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].generateYearsArray((new Date().getFullYear()), 1800);
        var result = new Array();
        for (var _i = 0, years_1 = years; _i < years_1.length; _i++) {
            var item = years_1[_i];
            result.push({
                id: item,
                text: item
            });
        }
        var $element = $("#" + this.select2ProductId + "_year");
        var select = $element.select2({
            width: '100%',
            allowClear: true,
            selectOnClose: true,
            placeholder: 'Please select year',
            data: result
        }).on('select2:select', function (e) {
            self.orderItem.Year = $(this).val();
        }).on('select2:unselect', function (e) {
            self.orderItem.Year = null;
        }).on('select2:open', function (params) {
            var select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });
        if (!this.orderItem.Year)
            return;
        if (select.data("select2"))
            select.data("select2").trigger("select", { data: { id: this.orderItem.Year } });
        if (this.disableChanges)
            $element.prop("disabled", true);
    };
    CalculatorAccordion.prototype.initGreenLevySelect = function () {
        var _this = this;
        if (!this.isVehicle)
            return;
        if (!__WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].isUsaShipmentFrom(this.order))
            return;
        var self = this;
        this.$greenLevyElement = $("#" + this.select2ProductId + "_greenLevy");
        if (!this.$greenLevyElement || this.$greenLevyElement.length === 0) {
            setTimeout(function () {
                _this.initGreenLevySelect();
            }, 150);
            return;
        }
        this.$greenLevySelect = this.$greenLevyElement.select2({
            width: '100%',
            allowClear: true,
            selectOnClose: true,
            placeholder: 'Please select fuel consumption',
            data: this.greenLevyResult
        }).on('select2:select', function (e) {
            self.greenLevy.Value = $(this).val();
        }).on('select2:unselect', function (e) {
            //self.greenLevy.Value = null;
            //self.orderItem.Taxes.splice(self.orderItem.Taxes.indexOf(self.greenLevy), 1);
            var grlavy = self.orderItem.Taxes.find(function (x) { return x.TaxType == __WEBPACK_IMPORTED_MODULE_23__objects_orders_taxType__["a" /* TaxType */].GreenLevy; });
            grlavy.Value = null;
            //self.orderItem.GreenLevy = null;
        }).on('select2:open', function (params) {
            var select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });
        var greenLevy = self.orderItem.Taxes.find(function (x) { return x.TaxType == __WEBPACK_IMPORTED_MODULE_23__objects_orders_taxType__["a" /* TaxType */].GreenLevy; });
        if (!greenLevy)
            return;
        var select2 = this.$greenLevySelect.data("select2");
        if (!select2) {
            setTimeout(function () {
                _this.initGreenLevySelect();
            }, 150);
            return;
        }
        select2.trigger("select", { data: { id: greenLevy.Value } });
        if (this.disableChanges)
            this.$greenLevyElement.prop("disabled", true);
    };
    /**
     * retunr tariff from country list, if manufacturer
     * has been chosen and country list contains this country
     * else return Base Tariff
     * @returns {string}
     * @param dataArray
     * @param orderItem
     */
    CalculatorAccordion.prototype.setPdaTypes = function (dataArray, orderItem) {
        for (var _i = 0, dataArray_1 = dataArray; _i < dataArray_1.length; _i++) {
            var pdaType = dataArray_1[_i];
            if ((orderItem.Type).hasFlag(parseInt(pdaType)))
                continue;
            orderItem.Type |= parseInt(pdaType);
        }
    };
    /**
     * return only duties where measure is not empty
     * @param duties
     * @returns {Duty[]}
     */
    CalculatorAccordion.prototype.filterDuties = function (duties) {
        var result = [];
        for (var _i = 0, duties_1 = duties; _i < duties_1.length; _i++) {
            var duty = duties_1[_i];
            if ((duty.Measure && duty.Measure.trim()) || duty.DutyType == __WEBPACK_IMPORTED_MODULE_10__objects_calculator_duty__["b" /* DutyType */].Manual)
                result.push(duty);
        }
        return result;
    };
    CalculatorAccordion.prototype.onDutyChange = function (value, mainDuty) {
        if (this.order.CalculatorType != __WEBPACK_IMPORTED_MODULE_14__objects_orders_calculatorType__["a" /* CalculatorType */].CanadianImport)
            return;
        if (mainDuty.Measure != '%')
            mainDuty.Quantity = value;
        for (var _i = 0, _a = mainDuty.ExtraDuties; _i < _a.length; _i++) {
            var extraDuty = _a[_i];
            if (extraDuty.Measure != '%')
                extraDuty.Quantity = value;
        }
    };
    /**
     * return string label depend on Duty's Measure
     * @param duty
     * @returns {any}
     */
    CalculatorAccordion.prototype.getDutyLabel = function (duty) {
        if (duty.DutyType == __WEBPACK_IMPORTED_MODULE_10__objects_calculator_duty__["b" /* DutyType */].Percent)
            return "Price " + duty.Measure;
        if (duty.Measure == "each")
            return "Quantity";
        if (duty.DutyType == __WEBPACK_IMPORTED_MODULE_10__objects_calculator_duty__["b" /* DutyType */].Manual)
            return "Manual duty";
        if (new RegExp("(1000|thousand|1,000)").test(duty.Measure)) {
            return "Quantity x1000";
        }
        return duty.Measure;
    };
    CalculatorAccordion.prototype.clearData = function () {
        this.isTarifLoading = true;
        if (String.isNullOrEmpty(this.manualHsCode)) {
            var saveName = true;
            if (!this.orderItem.Product.Name)
                saveName = false;
            this.clearProduct(saveName);
        }
    };
    /**
     * handle changing of input filed with HsCode
     * Send request to product search controller
     * to get new product
     * HsCode MUST be fully equal to searched product's HsCode
     */
    CalculatorAccordion.prototype.handleHsChange = function (force) {
        if (force === void 0) { force = false; }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var select, select2Data, cloned, response, saveName, e_1;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.orderItem.Product.HsCode == this.manualHsCode && !force) {
                            this.isTarifLoading = false;
                            return [2 /*return*/];
                        }
                        select = $("#" + this.select2ProductId);
                        select2Data = $(select).data('select2');
                        cloned = new __WEBPACK_IMPORTED_MODULE_4__objects_products_product__["a" /* Product */]();
                        Object.assign(cloned, this.orderItem.Product);
                        if (this.manualHsCode)
                            this.orderItem.Product.HsCode = this.manualHsCode;
                        //if hsCode is bot fully matched, then remove chosen product
                        if (!force && (!this.manualHsCode || !this.manualHsCode.match(/^\d+\.\d+\.(\d+\.\d+|\d{4})$/g))) {
                            this.isTarifLoading = false;
                            this.orderItem.Product.HsCode = this.manualHsCode;
                            return [2 /*return*/];
                        }
                        this.isTarifLoading = true;
                        this.manualHsCode = this.orderItem.Product.HsCode;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.isTarifLoading = true;
                        return [4 /*yield*/, (this.productService.search(new __WEBPACK_IMPORTED_MODULE_15__objects_requests_productSearchRequest__["a" /* ProductSearchRequest */]({
                                Query: __WEBPACK_IMPORTED_MODULE_22__common_helpers_HScodeHelper__["a" /* HScodeHelper */].addDotAfterLastTwoNumb(this.manualHsCode),
                                Source: this.getSearchType(),
                                Skip: 0,
                                Top: 10,
                                RequestType: __WEBPACK_IMPORTED_MODULE_17__objects_products_requestType__["a" /* RequestType */].ProductsAndTariffs,
                                SearchType: this.isVehicle ? __WEBPACK_IMPORTED_MODULE_21__objects_products_productSearchType__["a" /* ProductSearchType */].VehicleHsCode : __WEBPACK_IMPORTED_MODULE_21__objects_products_productSearchType__["a" /* ProductSearchType */].ProductHsCode,
                                CustomerId: this.order.Customer && this.order.Customer.Id && !this.isPublic ? this.order.Customer.Id : null
                            })))];
                    case 2:
                        response = _a.sent();
                        if (!response || !response.Data || response.Data.Items.length == 0 || __WEBPACK_IMPORTED_MODULE_22__common_helpers_HScodeHelper__["a" /* HScodeHelper */].addDotAfterLastTwoNumb(this.manualHsCode) != __WEBPACK_IMPORTED_MODULE_22__common_helpers_HScodeHelper__["a" /* HScodeHelper */].addDotAfterLastTwoNumb(response.Data.Items[0].HsCode)) {
                            saveName = true;
                            if (!this.orderItem.Product.Name)
                                saveName = false;
                            this.clearProduct(saveName, true);
                            return [2 /*return*/];
                        }
                        if (!this.productSelect.nativeElement.value) {
                            if (this.select2ProductData && this.select2ProductData.results && this.select2ProductData.results.lastParams && this.select2ProductData.results.lastParams.term)
                                this.select2ProductData.results.lastParams.term = "";
                        }
                        response.Data.Items[0].HsCode = this.manualHsCode;
                        select2Data.trigger("select", { data: { item: response.Data.Items[0], updateTariff: true, id: __WEBPACK_IMPORTED_MODULE_8__common_helpers_guidHelper__["a" /* Guid */].newGuid() } });
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        this.isTarifLoading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * return polarization duty if exists
     * @param duty
     * @returns {Duty}
     */
    CalculatorAccordion.prototype.getPolarizationExtraDuty = function (duty) {
        for (var _i = 0, _a = duty.ExtraDuties; _i < _a.length; _i++) {
            var dut = _a[_i];
            if (dut.DutyType == __WEBPACK_IMPORTED_MODULE_10__objects_calculator_duty__["b" /* DutyType */].Degree)
                return dut;
        }
        return new __WEBPACK_IMPORTED_MODULE_10__objects_calculator_duty__["a" /* Duty */]();
    };
    /**
     * return null if no duty with Duty Type Sugar
     * return duty with extra duties when
     * duty with Duty Type Sugar exists
     * @returns {Duty}
     */
    CalculatorAccordion.prototype.getSugarDuty = function () {
        for (var _i = 0, _a = this.orderItem.DutyList; _i < _a.length; _i++) {
            var duty = _a[_i];
            if (duty.DutyType == __WEBPACK_IMPORTED_MODULE_10__objects_calculator_duty__["b" /* DutyType */].Sugar) {
                this.polarizationDuty = this.getPolarizationExtraDuty(duty);
                return duty;
            }
        }
        return null;
    };
    /**
     * generate select data from tuple =>
     * convert tuple into object with id and text
     * props
     * @param data
     * @returns {Array}
     */
    CalculatorAccordion.prototype.generateSelectData = function (data) {
        var result = [];
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var item = data_1[_i];
            result.push({
                id: item.Key,
                text: item.Value
            });
        }
        return result;
    };
    /**
     * return search type for product searching
     * null - when no shipment country selected
     * 0 - when Canada has been selected
     * 1 - when USA has been selected
     * @returns {any}
     */
    CalculatorAccordion.prototype.getSearchType = function () {
        if (!this.order.Locations || this.order.Locations.length == 0)
            return null;
        var shipmentTo = this.order.Locations.find(function (x) { return x.Type == 2; });
        if (shipmentTo.Country.toLowerCase() == 'canada')
            return 0;
        if (shipmentTo.Country.toLowerCase() == 'united states' || shipmentTo.Country.toLowerCase() == 'usa')
            return 1;
        return null;
    };
    CalculatorAccordion.prototype.isUsaShipmentTo = function () {
        return __WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].isUsaShipmentTo(this.order);
    };
    CalculatorAccordion.prototype.isCanadaShipmentTo = function () {
        return __WEBPACK_IMPORTED_MODULE_18__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].isCanadaShipmentTo(this.order);
    };
    CalculatorAccordion.prototype.deleteItem = function () {
        if (this.disableChanges)
            return;
        this.onItemRemoved.emit(this.orderItem);
    };
    CalculatorAccordion.prototype.isValid = function () {
        return this.accordionForm.valid;
    };
    CalculatorAccordion.prototype.isNumber = function (num) {
        return !Number.isNaN(+num);
    };
    CalculatorAccordion.prototype.isPass = function () {
        if (this.orderItem.Flags)
            return this.orderItem.Flags.hasFlag(__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsPassVehicle);
        else
            return false;
    };
    CalculatorAccordion.prototype.isVehicleCalc = function () {
        var result = this.calculatorHelper.isVehicle(this.order);
        if (result)
            this.resetUsaTariffs();
        return result;
    };
    CalculatorAccordion.prototype.resetUsaTariffs = function () {
        if (!this.orderItem.Flags)
            return;
        this.isPassVehicle = this.orderItem.Flags.hasFlag(__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsPassVehicle);
        this.IsTrucksVal = this.orderItem.Flags.hasFlag(__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsTrucks);
    };
    CalculatorAccordion.prototype.setPassVehicle = function (value) {
        this.isPassVehicle = value;
        if (value) {
            this.orderItem.Flags |= __WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsPassVehicle;
        }
        else {
            this.orderItem.Flags &= ~__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsPassVehicle;
        }
    };
    CalculatorAccordion.prototype.setIsTrucks = function (value) {
        this.IsTrucksVal = value;
        if (value) {
            this.orderItem.Flags |= __WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsTrucks;
        }
        else {
            this.orderItem.Flags &= ~__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsTrucks;
        }
    };
    CalculatorAccordion.prototype.toggleAES = function () {
        if (this.orderItem.Flags != null && this.orderItem.Flags.hasFlag(__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsAC)) {
            this.orderItem.Flags &= ~__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsAC;
        }
        else {
            this.orderItem.Flags |= __WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsAC;
        }
    };
    CalculatorAccordion.prototype.toggleVehicleParts = function () {
        if (this.orderItem.Flags != null && this.orderItem.Flags.hasFlag(__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsVehicleParts)) {
            this.orderItem.Flags &= ~__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsVehicleParts;
        }
        else {
            this.orderItem.Flags |= __WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsVehicleParts;
        }
    };
    CalculatorAccordion.prototype.toggleIsTrailerOnly = function () {
        if (this.isTrailerOnly) {
            this.$greenLevySelect.val("0").trigger("change");
            this.greenLevy.Value = this.$greenLevySelect.val();
            this.isAC = false;
            if (this.orderItem.Flags != null && this.orderItem.Flags.hasFlag(__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsAC)) {
                this.orderItem.Flags &= ~__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].IsAC;
            }
            this.orderItem.Flags |= __WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].isTrailerOnly;
        }
        else {
            this.orderItem.Flags &= ~__WEBPACK_IMPORTED_MODULE_19__objects_orders_orderItemOptions__["a" /* OrderItemOptions */].isTrailerOnly;
        }
    };
    CalculatorAccordion.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_6__services_configService__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_11__services_productService__["a" /* ProductService */] }, { type: __WEBPACK_IMPORTED_MODULE_16__services_calculator_calculatorService__["a" /* CalculatorService */] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectorRef"] }, { type: __WEBPACK_IMPORTED_MODULE_24__services_calculator_tax_service__["a" /* TaxService */] }]; };
    return CalculatorAccordion;
}());

//# sourceMappingURL=calculator-accordion.component.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "n/KB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentEmailRequest; });
var PaymentEmailRequest = /** @class */ (function () {
    function PaymentEmailRequest(init) {
        Object.assign(this, init);
    }
    return PaymentEmailRequest;
}());

//# sourceMappingURL=PaymentEmailRequest.js.map

/***/ }),

/***/ "n7Lc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewType; });
var ViewType;
(function (ViewType) {
    ViewType[ViewType["Desktop"] = 0] = "Desktop";
    ViewType[ViewType["Mobile"] = 1] = "Mobile";
    ViewType[ViewType["Android"] = 2] = "Android";
    ViewType[ViewType["Ios"] = 3] = "Ios";
    ViewType[ViewType["WindowsPhone"] = 4] = "WindowsPhone";
})(ViewType || (ViewType = {}));
//# sourceMappingURL=viewType.js.map

/***/ }),

/***/ "natU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrderStatus; });
/**
 * Created by alex.y on 8/8/2017.
 */
var OrderStatus;
(function (OrderStatus) {
    OrderStatus[OrderStatus["Calculated"] = 0] = "Calculated";
    OrderStatus[OrderStatus["Quoted"] = 1] = "Quoted";
    OrderStatus[OrderStatus["Paid"] = 2] = "Paid";
    OrderStatus[OrderStatus["Refunded"] = 3] = "Refunded";
    OrderStatus[OrderStatus["PrepareDoc"] = 4] = "PrepareDoc";
    OrderStatus[OrderStatus["SentToCustom"] = 5] = "SentToCustom";
    OrderStatus[OrderStatus["CustomReleased"] = 6] = "CustomReleased";
    OrderStatus[OrderStatus["BorderCrossed"] = 7] = "BorderCrossed";
    OrderStatus[OrderStatus["Closed"] = 8] = "Closed";
})(OrderStatus || (OrderStatus = {}));
//# sourceMappingURL=orderStatus.js.map

/***/ }),

/***/ "ndXn":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["jQuery"] = __webpack_require__("24Wip");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "niNk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./app/objects/common/Tuple.ts
/**
 * Created by alex.y on 8/1/2017.
 */
var Tuple = /** @class */ (function () {
    function Tuple(Key, Value) {
        this.Key = Key;
        this.Value = Value;
    }
    return Tuple;
}());

//# sourceMappingURL=Tuple.js.map
// CONCATENATED MODULE: ./app/common/utils/EnumUtil.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EnumUtil_EnumUtil; });

/**
 * Created by alex.y on 8/9/2017.
 */
var EnumUtil_EnumUtil = /** @class */ (function () {
    function EnumUtil() {
    }
    EnumUtil.convertEnumToTuple = function (enumType) {
        var result = [];
        for (var en in enumType) {
            if (isNaN(enumType[en]) && en != '0')
                result.push(new Tuple(+en, enumType[en].toString()));
        }
        return result;
    };
    EnumUtil.checkFlag = function (enm, flag) {
        // tslint:disable-next-line:no-bitwise
        return (enm & flag) === flag;
    };
    // tslint:disable-next-line:variable-name
    EnumUtil.getKeys = function (_enum) {
        var keys = Object.keys(_enum);
        var halfLength = keys.length / 2;
        return keys.splice(halfLength, halfLength);
    };
    EnumUtil.enumToArray = function (Enum, exclude, isString) {
        if (exclude === void 0) { exclude = []; }
        if (isString === void 0) { isString = false; }
        if (isString) {
            return Object.keys(Enum)
                .filter(function (key) { return !exclude.includes(key); })
                .map(function (key) { return ({ Id: key, Name: Enum[key] }); });
        }
        return Object.keys(Enum)
            .filter(function (key) { return !isNaN(Number(Enum[key])); })
            .filter(function (key) { return !exclude.includes(Enum[key]); })
            .map(function (key) { return ({ Id: Enum[key], Name: key }); });
    };
    EnumUtil.enumToObject = function (Enum, exclude, isString) {
        if (exclude === void 0) { exclude = []; }
        if (isString === void 0) { isString = false; }
        var array = this.enumToArray(Enum, exclude, isString);
        var result = {};
        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
            var item = array_1[_i];
            result[item.Id.toString()] = item.Name;
        }
        return result;
    };
    return EnumUtil;
}());

//# sourceMappingURL=EnumUtil.js.map

/***/ }),

/***/ "nnCU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShipmentFromTabComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_orders_orderItem__ = __webpack_require__("PL+a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_orders_order__ = __webpack_require__("hz4y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_helpers_calculatorHelper__ = __webpack_require__("osrx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ng2_cookies_ng2_cookies__ = __webpack_require__("46qw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ng2_cookies_ng2_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ng2_cookies_ng2_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objects_management_locationManagement_Country__ = __webpack_require__("eZFs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_configService__ = __webpack_require__("cfSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_google_tag_service__ = __webpack_require__("nz7M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_customers_customer__ = __webpack_require__("svBX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__objects_management_order_orderLocation__ = __webpack_require__("oiko");










var ShipmentFromTabComponent = /** @class */ (function () {
    function ShipmentFromTabComponent(configService, detectChanges, googleTagService) {
        this.configService = configService;
        this.detectChanges = detectChanges;
        this.googleTagService = googleTagService;
        this.order = new __WEBPACK_IMPORTED_MODULE_2__objects_orders_order__["a" /* Order */]();
        this.orderItem = new __WEBPACK_IMPORTED_MODULE_1__objects_orders_orderItem__["b" /* OrderItem */]();
        this.onTabSelected = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.showCanadaBtn = true;
        this.showUSABtn = true;
    }
    Object.defineProperty(ShipmentFromTabComponent.prototype, "isVehicle", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_3__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].isVehicle(this.order);
        },
        enumerable: true,
        configurable: true
    });
    ShipmentFromTabComponent.prototype.ngAfterViewInit = function () {
        this.initManufacturerSelect();
    };
    ShipmentFromTabComponent.prototype.initManufacturerSelect = function () {
        var select = $("#shipFromSelect");
        var self = this;
        select.select2({
            width: '100%',
            data: [],
            allowClear: false,
            placeholder: 'Other country',
            ajax: {
                url: this.configService.config.ApiUrl + "/location/search/country",
                delay: 500,
                headers: {
                    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_4_ng2_cookies_ng2_cookies__["Cookie"].get(this.configService.config.ApiTokenCookieName),
                },
                data: function (params) {
                    return {
                        country: params.term
                    };
                },
                processResults: function (data, params) {
                    var results = data.Data.map(function (country) {
                        return {
                            id: country.Code,
                            text: country.Name
                        };
                    });
                    results = results.filter(function (x) { return x.text.toLowerCase() != "canada"
                        /*&& x.text.toLowerCase() != "mexico"*/
                        && x.text.toLowerCase() != "united states"
                        && x.text.toLowerCase() != 'japan'
                        && x.text.toLowerCase() != 'china'
                        && x.text.toLowerCase() != 'germany'; });
                    return {
                        results: results
                    };
                },
            },
            minimumInputLength: 2
        }).on('select2:select', function (e) {
            var selectedData = $(this).select2('data');
            var item = selectedData[0];
            self.locationFrom = new __WEBPACK_IMPORTED_MODULE_5__objects_management_locationManagement_Country__["a" /* Country */]({
                Code: item.id,
                Name: item.text
            });
        }).on('select2:unselect', function (e) {
            self.locationFrom = new __WEBPACK_IMPORTED_MODULE_5__objects_management_locationManagement_Country__["a" /* Country */]();
        }).on('select2:open', function (params) {
            var select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });
    };
    ShipmentFromTabComponent.prototype.setManufacturer = function (country) {
        if (this.locationFrom && this.locationFrom.Code == country.Code)
            this.locationFrom = new __WEBPACK_IMPORTED_MODULE_5__objects_management_locationManagement_Country__["a" /* Country */]();
        else {
            $("#manufacturerSelect").html("");
            this.locationFrom = country;
        }
        this.detectChanges.detectChanges();
    };
    ShipmentFromTabComponent.prototype.getCountry = function (code) {
        var name = '';
        code = code.toUpperCase().trim();
        switch (code) {
            case 'US':
                name = 'United States';
                break;
            case 'CA':
                name = 'Canada';
                break;
            case 'CN':
                name = 'China';
                break;
            case 'JP':
                name = 'Japan';
                break;
            case 'DE':
                name = 'Germany';
                break;
        }
        return new __WEBPACK_IMPORTED_MODULE_5__objects_management_locationManagement_Country__["a" /* Country */]({
            Code: code,
            Name: name
        });
    };
    ShipmentFromTabComponent.prototype.setShipFrom = function () {
        if (!this.order.Customer)
            this.order.Customer = new __WEBPACK_IMPORTED_MODULE_8__objects_customers_customer__["a" /* Customer */]();
        this.order.Customer.Location = new __WEBPACK_IMPORTED_MODULE_9__objects_management_order_orderLocation__["a" /* OrderLocation */]({
            Country: this.locationFrom.Name
        });
    };
    ShipmentFromTabComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_6__services_configService__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] }, { type: __WEBPACK_IMPORTED_MODULE_7__services_google_tag_service__["a" /* GoogleTagService */] }]; };
    return ShipmentFromTabComponent;
}());

//# sourceMappingURL=shipment-from-tab.component.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "ntOl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseExtraData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_extraData_extraData__ = __webpack_require__("KGeA");


/**
 * Created by vadim.m on 10/26/2017.
 */
var BaseExtraData = /** @class */ (function () {
    function BaseExtraData(extraDataService) {
        this.extraDataService = extraDataService;
    }
    BaseExtraData.prototype.getExtraData = function (customerId, referenceType) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var extraData;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.extraDataService.getByRefIdandRefType(customerId, referenceType)];
                    case 1:
                        extraData = _a.sent();
                        if (!extraData || !extraData.Data)
                            return [2 /*return*/, new __WEBPACK_IMPORTED_MODULE_1__objects_extraData_extraData__["a" /* ExtraData */]()];
                        return [2 /*return*/, extraData.Data.find(function (x) { return x.Name == 'marketing text'; })];
                }
            });
        });
    };
    return BaseExtraData;
}());

//# sourceMappingURL=baseExtraData.js.map

/***/ }),

/***/ "nz7M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GoogleTagService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseService__ = __webpack_require__("IhmT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__("Fzro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configService__ = __webpack_require__("cfSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_router__ = __webpack_require__("5oXY");






var dpExtend = __webpack_require__("/+tr");
var GoogleTagService = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](GoogleTagService, _super);
    function GoogleTagService(location, http, configService, router) {
        var _this = _super.call(this, http, configService) || this;
        _this.location = location;
        _this.http = http;
        _this.configService = configService;
        _this.router = router;
        _this.eventsArray = [];
        return _this;
    }
    GoogleTagService.prototype.pushData = function (location, customData) {
        if (customData === void 0) { customData = null; }
        var path = "calculator2/public/" + location;
        if (!this.eventsArray.includes(location)) {
            if (location === 'import' && !this.eventsArray.includes(location))
                this.eventsArray.push('import');
            this.location.replaceState(this.buildUrl(this.router, {}, path, true));
            if (customData) {
                dataLayer.push(customData);
            }
            else {
                dataLayer.push({ 'page_path': path, event: 'virtualPageView' });
            }
            gtag('config', this.configService.config.GUATagId ? this.configService.config.GUATagId : this.configService.config.GTagId, {
                'page_title': path,
                'page_path': "/" + path
            });
        }
    };
    GoogleTagService.prototype.clearEventsArray = function () {
        this.eventsArray = [];
    };
    GoogleTagService.prototype.getRoot = function (router) {
        return router.url.split('?')[0];
    };
    GoogleTagService.prototype.buildUrl = function (router, queryString, root, preserveQueryString) {
        if (root === void 0) { root = ""; }
        if (preserveQueryString === void 0) { preserveQueryString = false; }
        if (preserveQueryString) {
            var obj = {};
            dpExtend(obj, router.routerState.snapshot.root.queryParams);
            if (queryString) {
                dpExtend(obj, queryString);
            }
            queryString = obj;
        }
        if (String.isNullOrEmpty(root))
            root = this.getRoot(router);
        return router.createUrlTree([root], {
            queryParams: queryString
        }).toString();
    };
    GoogleTagService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_4__angular_common__["Location"] }, { type: __WEBPACK_IMPORTED_MODULE_2__angular_http__["e" /* Http */] }, { type: __WEBPACK_IMPORTED_MODULE_3__configService__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_5__angular_router__["n" /* Router */] }]; };
    return GoogleTagService;
}(__WEBPACK_IMPORTED_MODULE_1__baseService__["a" /* BaseApi */]));

//# sourceMappingURL=google-tag.service.js.map

/***/ }),

/***/ "ob4r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cache = {};
var start = '(?:^|\\s)';
var end = '(?:\\s|$)';

function lookupClass (className) {
  var cached = cache[className];
  if (cached) {
    cached.lastIndex = 0;
  } else {
    cache[className] = cached = new RegExp(start + className + end, 'g');
  }
  return cached;
}

function addClass (el, className) {
  var current = el.className;
  if (!current.length) {
    el.className = className;
  } else if (!lookupClass(className).test(current)) {
    el.className += ' ' + className;
  }
}

function rmClass (el, className) {
  el.className = el.className.replace(lookupClass(className), ' ').trim();
}

module.exports = {
  add: addClass,
  rm: rmClass
};


/***/ }),

/***/ "oiko":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrderLocation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locationManagement_location__ = __webpack_require__("ZxOp");


var OrderLocation = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](OrderLocation, _super);
    function OrderLocation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OrderLocation;
}(__WEBPACK_IMPORTED_MODULE_1__locationManagement_location__["a" /* Location */]));

//# sourceMappingURL=orderLocation.js.map

/***/ }),

/***/ "osrx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./app/objects/orders/orderItem.ts + 1 modules
var orders_orderItem = __webpack_require__("PL+a");

// EXTERNAL MODULE: ./app/objects/currencyExchange/canadianCurrencyCode.ts
var canadianCurrencyCode = __webpack_require__("3Ddi");

// EXTERNAL MODULE: ./app/objects/orders/orderOptions.ts
var orderOptions = __webpack_require__("Wcmd");

// EXTERNAL MODULE: ./app/objects/orders/taxType.ts
var taxType = __webpack_require__("TDHu");

// EXTERNAL MODULE: ./app/objects/calculator/duty.ts
var calculator_duty = __webpack_require__("l1uE");

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("TToO");

// CONCATENATED MODULE: ./app/services/calculator/baseTaxService.ts
/**
 * Created by alex.y on 8/31/2017.
 */
var BaseTaxService = /** @class */ (function () {
    function BaseTaxService() {
    }
    return BaseTaxService;
}());

//# sourceMappingURL=baseTaxService.js.map
// CONCATENATED MODULE: ./app/services/calculator/canadianTaxService.ts



/**
 * Created by vlad.p on 8/31/2017.
 */
var canadianTaxService_CanadianTaxService = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](CanadianTaxService, _super);
    function CanadianTaxService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CanadianTaxService.prototype.parseTariff = function (tariff) {
        if (String.isNullOrEmpty(tariff) || tariff == "-" || tariff == "N/A" || tariff == "Free" || tariff == '; Free')
            return [];
        var lessThan = tariff.split('but not less than');
        if (lessThan.length > 1) {
            var duty = this.createDuty(lessThan[0], this.separateValueFromMeasure(lessThan[0]));
            if (this.hasPlus(tariff)) {
                var plusPercent = lessThan[1].split('plus');
                lessThan[1] = plusPercent[0];
                duty.ExtraDuties.push(this.createDuty('%', this.separateValueFromMeasure(plusPercent[1]), calculator_duty["b" /* DutyType */].Plus));
            }
            var moreThanTokens = lessThan[1].split('or more than');
            if (moreThanTokens.length > 1) {
                lessThan[1] = moreThanTokens[0];
                duty.ExtraDuties.push(this.createDuty(moreThanTokens[1], this.separateValueFromMeasure(moreThanTokens[1]), calculator_duty["b" /* DutyType */].More));
            }
            duty.ExtraDuties.push(this.createDuty(lessThan[1], this.separateValueFromMeasure(lessThan[1]), calculator_duty["b" /* DutyType */].Less));
            return [duty];
        }
        if (this.hasPlus(tariff))
            return [this.createPlusDuty(tariff)];
        return [this.createDuty(tariff, this.separateValueFromMeasure(tariff))];
    };
    CanadianTaxService.prototype.createDuty = function (measure, value, dutyType) {
        var duty = new calculator_duty["a" /* Duty */]();
        duty.Value = value;
        duty.Measure = this.getMeasure(measure);
        duty.DutyType = dutyType ? dutyType : this.getDutyType(duty.Measure);
        if (String.isNullOrEmpty(duty.Measure) || isNaN(duty.Value)) {
            throw new Error("Can't create duty!");
        }
        return duty;
    };
    CanadianTaxService.prototype.createPlusDuty = function (tariff) {
        var dutyTokens = tariff.split('plus');
        var duty = this.createDuty(this.getMeasure(dutyTokens[0]), this.separateValueFromMeasure(dutyTokens[0]));
        duty.ExtraDuties.push(this.createDuty('%', this.separateValueFromMeasure(dutyTokens[1]), calculator_duty["b" /* DutyType */].Plus));
        return duty;
    };
    CanadianTaxService.prototype.separateValueFromMeasure = function (value) {
        if (value.includes("%"))
            return +value.replace("%", "").trim();
        var valueWithCurrency = value.split('/');
        if (valueWithCurrency[0].includes("$"))
            return +valueWithCurrency[0].replace("$", "").trim();
        return +valueWithCurrency[0].replace('¢', '').replace('each', '').trim() / 100;
    };
    CanadianTaxService.prototype.hasPlus = function (tariff) {
        return tariff.includes('plus');
    };
    CanadianTaxService.prototype.getMeasure = function (value) {
        if (value.includes('%'))
            return '%';
        if (value.includes('¢each'))
            return 'each';
        var measure = value.split('/');
        if (measure.length == 1)
            return measure[0].trim();
        return measure[1].trim();
    };
    CanadianTaxService.prototype.getDutyType = function (measure) {
        if (String.isNullOrEmpty(measure))
            throw new Error("Measure is null.");
        if (measure.includes('%'))
            return calculator_duty["b" /* DutyType */].Percent;
        return calculator_duty["b" /* DutyType */].PerItem;
    };
    return CanadianTaxService;
}(BaseTaxService));

//# sourceMappingURL=canadianTaxService.js.map
// CONCATENATED MODULE: ./app/common/helpers/tariffHelper.ts
/**
 * Created by vlad.p on 10/2/2017.
 */
var TariffHelper = /** @class */ (function () {
    function TariffHelper() {
    }
    TariffHelper.isCustomTariff = function (tariff) {
        if (tariff.toLowerCase().includes('free'))
            return false;
        var measures = ['kg', '¢', '%', '$', 'cent', 'percent'];
        for (var _i = 0, measures_1 = measures; _i < measures_1.length; _i++) {
            var measure = measures_1[_i];
            if (tariff.includes(measure))
                return false;
        }
        return true;
    };
    return TariffHelper;
}());

//# sourceMappingURL=tariffHelper.js.map
// CONCATENATED MODULE: ./app/services/calculator/usaTaxService.ts




/**
 * Created by alex.y on 8/31/2017.
 */
var usaTaxService_UsaTaxService = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](UsaTaxService, _super);
    function UsaTaxService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UsaTaxService.prototype.parseTariff = function (tariff) {
        var result = [];
        if (TariffHelper.isCustomTariff(tariff)) {
            result.push(new calculator_duty["a" /* Duty */]({
                DutyType: calculator_duty["b" /* DutyType */].Manual,
                Value: 0,
                Measure: "",
                Quantity: 0,
                ExtraDuties: []
            }));
            return result;
        }
        if (tariff.toLowerCase().trim() == "free") {
            result.push(new calculator_duty["a" /* Duty */]({
                DutyType: calculator_duty["b" /* DutyType */].Percent,
                Value: 0,
                Measure: "",
                Quantity: 0,
                ExtraDuties: []
            }));
        }
        var duties = tariff.split('+'); //get different duties
        for (var _i = 0, duties_1 = duties; _i < duties_1.length; _i++) {
            var duty = duties_1[_i];
            var parsedDuty = 0;
            var dutyType = void 0;
            var measure = "";
            var extraDuties = [];
            if (duty.includes("%")) {
                var parsed = duty.split("%");
                parsedDuty = Number.parseFloat(parsed[0]);
                if (parsed.length > 1 && parsed[1]) {
                    if (parsed[1].includes("<u>"))
                        parsed[1] = parsed[1].replace(new RegExp("(<u>)(</u>)"), "").trim();
                    if (parsed[1])
                        measure = parsed[1];
                }
                dutyType = calculator_duty["b" /* DutyType */].Percent;
            }
            else if (duty.includes("less")) {
                //If duty contains less so it's something like
                //3.6606¢/kg less 0.020668¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 3.143854¢/kg
                var regex = /(.+?)less\W(\d+[.][^\s]+)\s+[^\d]+((\w+) degrees?).*\s+(\d.*)/g;
                var sugarTariffsArray = regex.exec(duty);
                var baseSugarTariff = sugarTariffsArray[1].trim().split("/");
                var eachSugarTariff = sugarTariffsArray[2].trim().split("/");
                var notMoreSugarTariff = sugarTariffsArray[5].trim().split("/");
                var degreeSugarTariff = sugarTariffsArray[4].trim();
                measure = baseSugarTariff[1]; //TODO
                parsedDuty = this.getAmount(baseSugarTariff[0]);
                extraDuties.push(new calculator_duty["a" /* Duty */]({
                    DutyType: calculator_duty["b" /* DutyType */].LessTariff,
                    Value: Number.parseFloat(eachSugarTariff[0]),
                    Measure: eachSugarTariff[1],
                    Quantity: null,
                    ExtraDuties: []
                }));
                extraDuties.push(new calculator_duty["a" /* Duty */]({
                    DutyType: calculator_duty["b" /* DutyType */].Less,
                    Value: Number.parseFloat(notMoreSugarTariff[0]),
                    Measure: notMoreSugarTariff[1],
                    Quantity: null,
                    ExtraDuties: []
                }));
                extraDuties.push(new calculator_duty["a" /* Duty */]({
                    DutyType: calculator_duty["b" /* DutyType */].Degree,
                    Value: Number.parseFloat(degreeSugarTariff),
                    Measure: "degree",
                    Quantity: null,
                    ExtraDuties: []
                }));
                dutyType = calculator_duty["b" /* DutyType */].Sugar;
            }
            else {
                var parsed = duty.trim().split(new RegExp("[\\s/](.+)?")); //first space or slash
                var price = parsed[0];
                measure = parsed[1];
                parsedDuty = this.getAmount(price);
                dutyType = calculator_duty["b" /* DutyType */].PerItem;
            }
            result.push(new calculator_duty["a" /* Duty */]({
                DutyType: dutyType,
                Value: parsedDuty,
                Measure: measure,
                Quantity: null,
                ExtraDuties: extraDuties
            }));
        }
        return result;
    };
    UsaTaxService.prototype.getAmount = function (price) {
        if (price.includes("¢") || price.includes("&cent;")) {
            var resultPrice = Number.parseFloat(price.split(new RegExp("¢|{&cent;}"))[0]);
            return resultPrice / 100;
        }
        if (price.includes("$"))
            return Number.parseFloat(price.split('$')[1]);
    };
    return UsaTaxService;
}(BaseTaxService));

//# sourceMappingURL=usaTaxService.js.map
// EXTERNAL MODULE: ./app/objects/orders/orderStatus.ts
var orderStatus = __webpack_require__("natU");

// CONCATENATED MODULE: ./app/common/helpers/calculatorHelper.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculatorHelper_CalculatorHelper; });








/**
 * Created by vlad.p on 9/11/2017.
 */
var calculatorHelper_CalculatorHelper = /** @class */ (function () {
    function CalculatorHelper() {
    }
    CalculatorHelper.getCalculatorType = function (locations) {
        if (!locations || locations.length == 0)
            return null;
        var shipmentTo = locations.find(function (x) { return x.Type == 2; });
        if (shipmentTo.Country.toLowerCase() == 'canada')
            return 0;
        if (shipmentTo.Country.toLowerCase() == 'united states' || shipmentTo.Country.toLowerCase() == 'usa')
            return 1;
        return null;
    };
    CalculatorHelper.isSameCurrency = function (orderItems) {
        if (orderItems == null || orderItems.length == 0)
            return false;
        var firstCurrency = orderItems[0].CanadianCurrencyCode;
        for (var i = 1; i < orderItems.length; i++) {
            if (String.isNullOrEmpty(orderItems[i].CanadianCurrencyCode.Code))
                return false;
            if (firstCurrency.Code == null || orderItems[i].CanadianCurrencyCode == null)
                continue;
            if (firstCurrency.Code != orderItems[i].CanadianCurrencyCode.Code) {
                return false;
            }
        }
        return true;
    };
    CalculatorHelper.getDefaultCurrency = function (currencyCodes, order, countryService) {
        if (!order || !order.Customer || !order.Customer.Location)
            return new canadianCurrencyCode["a" /* CanadianCurrencyCode */]();
        //According tot BB-1745 default currency must be USD
        return currencyCodes.find(function (x) { return x.Name == 'USD'; });
        // let countryCurrencies: string[] = countryService.getCode(order.Customer.Location.Country);
        //
        // if (!countryCurrencies || countryCurrencies.length == 0)
        //     return currencyCodes.find(x => x.Name == 'CAD');
        //
        // let countryCode: CanadianCurrencyCode = currencyCodes.find(x => countryCurrencies.indexOf(x.Name) != -1);
        //
        // if (countryCode != null)
        //     return countryCode;
        //
        // return currencyCodes.find(x => x.Name == 'CAD');
    };
    CalculatorHelper.setDefaultCurrency = function (currencyCodes, order, productAccordions, countryService, changeForAll) {
        if (changeForAll === void 0) { changeForAll = true; }
        var defaultCurrency = this.getDefaultCurrency(currencyCodes, order, countryService);
        for (var _i = 0, productAccordions_1 = productAccordions; _i < productAccordions_1.length; _i++) {
            var accordion = productAccordions_1[_i];
            if (!accordion || !accordion.orderItem)
                continue;
            if (accordion.orderItem.CanadianCurrencyCode == null || accordion.orderItem.CanadianCurrencyCode.Id == null ||
                (!changeForAll && (!accordion.orderItem.Price && !accordion.orderItem.Manufacturer.Name && !accordion.orderItem.Product.HsCode))) {
                accordion.changeCurrency(defaultCurrency);
            }
        }
    };
    CalculatorHelper.getProductTariff = function (product, orderItem, order, hsCodes10, hsCodes25, hsCodes0, usHsCodes25) {
        if (hsCodes10 === void 0) { hsCodes10 = new Array(); }
        if (hsCodes25 === void 0) { hsCodes25 = new Array(); }
        if (hsCodes0 === void 0) { hsCodes0 = new Array(); }
        if (usHsCodes25 === void 0) { usHsCodes25 = new Array(); }
        var special = CalculatorHelper.checkSpecialCanadianHsCodes(product.HsCode, order, orderItem, hsCodes10, hsCodes25, usHsCodes25);
        if (special != null)
            return special;
        if (!orderItem.Manufacturer || !orderItem.Manufacturer.Name)
            return product.BaseTariff;
        var item = new orders_orderItem["b" /* OrderItem */]();
        item.Product = product;
        item.Manufacturer = orderItem.Manufacturer;
        return this.getTariff(item, order, order.Flag && order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsVehicle), hsCodes10, hsCodes25, hsCodes0, usHsCodes25);
    };
    CalculatorHelper.checkSpecialCanadianHsCodes = function (hsCode, order, orderItem, hsCodes10, hsCodes25, hsCodes0, usHsCodes25) {
        if (hsCodes10 === void 0) { hsCodes10 = new Array(); }
        if (hsCodes25 === void 0) { hsCodes25 = new Array(); }
        if (hsCodes0 === void 0) { hsCodes0 = new Array(); }
        if (usHsCodes25 === void 0) { usHsCodes25 = new Array(); }
        if ((hsCodes10.length <= 0 && hsCodes25.length <= 0 && hsCodes0.length <= 0 && usHsCodes25.length <= 0) || String.isNullOrEmpty(hsCode))
            return null;
        if (!orderItem.Manufacturer || !orderItem.Manufacturer.Name)
            return null;
        var shipmentTo = order.Locations.find(function (x) { return x.Type == 2; });
        var manufacturer = orderItem.Manufacturer.Code;
        if (!manufacturer || !shipmentTo)
            return null;
        var countryFrom = manufacturer;
        var countryTo = shipmentTo.Country;
        if (String.isNullOrEmpty(countryFrom) || String.isNullOrEmpty(countryTo))
            return null;
        countryFrom = countryFrom.toLowerCase();
        if (((countryFrom == "us") && (countryTo.toLowerCase() == "canada"))) {
            if (hsCodes0.find(function (x) { return hsCode.indexOf(x) != -1; }))
                return 'Free';
            if (hsCodes10.find(function (x) { return hsCode.indexOf(x) != -1; }))
                return '10%';
            if (hsCodes25.find(function (x) { return hsCode.indexOf(x) != -1; }))
                return '25%';
        }
        return null;
    };
    CalculatorHelper.checkSpecialUsHsCodes = function (hsCode, order, orderItem, hsCodes25) {
        if (hsCodes25 === void 0) { hsCodes25 = new Array(); }
        if (hsCodes25.length <= 0 || String.isNullOrEmpty(hsCode))
            return null;
        if (!orderItem.Manufacturer || !orderItem.Manufacturer.Name)
            return null;
        var shipmentTo = order.Locations.find(function (x) { return x.Type == 2; });
        var manufacturer = orderItem.Manufacturer.Code;
        if (!manufacturer || !shipmentTo)
            return null;
        var countryFrom = manufacturer;
        var countryTo = shipmentTo.Country;
        if (String.isNullOrEmpty(countryFrom) || String.isNullOrEmpty(countryTo))
            return null;
        countryFrom = countryFrom.toLowerCase();
        if (((countryFrom == "cn") && (countryTo.toLowerCase() == "united states"))) {
            if (hsCodes25.find(function (x) { return hsCode.indexOf(x) != -1; }))
                return 25;
        }
        return null;
    };
    CalculatorHelper.getTariff = function (orderItem, order, isVehicle, hsCodes10, hsCodes25, hsCodes0, usHsCodes25) {
        if (isVehicle === void 0) { isVehicle = false; }
        if (hsCodes10 === void 0) { hsCodes10 = new Array(); }
        if (hsCodes25 === void 0) { hsCodes25 = new Array(); }
        if (hsCodes0 === void 0) { hsCodes0 = new Array(); }
        if (usHsCodes25 === void 0) { usHsCodes25 = new Array(); }
        if (orderItem.IsAgentEditCustomDuty) {
            var perc_1 = orderItem.AgentEditedCustomDutyPercent;
            return perc_1.toString() + "%";
        }
        if ((orderItem.Product.HsCode == "8703.90.00.00" || orderItem.Product.HsCode == "8703.80.00.00")) {
            if (CalculatorHelper.isLessThanTwentyFive(order, orderItem)
                && !CalculatorHelper.isManufacturerFromCanadaUSAMexico(orderItem)) {
                return "6.1%";
            }
            else {
                return '0%';
            }
        }
        if (CalculatorHelper.isMoreOrEqThanTwentyFive(order, orderItem)) {
            return 'Free';
        }
        var shipmentTo = order.Locations.find(function (x) { return x.Type == 2; });
        var shipmentFrom = order.Locations.find(function (x) { return x.Type == 1; });
        var manufacturer = orderItem.Manufacturer.Code;
        var special = CalculatorHelper.checkSpecialCanadianHsCodes(orderItem.Product.HsCode, order, orderItem, hsCodes10, hsCodes25, hsCodes0, usHsCodes25);
        if (special != null)
            return special;
        var usSpecial = CalculatorHelper.checkSpecialUsHsCodes(orderItem.Product.HsCode, order, orderItem, usHsCodes25);
        if (CalculatorHelper.isPublicCalculatorHsCode(orderItem)
            && (shipmentTo != null && !String.isNullOrEmpty(shipmentTo.Country) && (shipmentTo.Country.toLowerCase() == "us" || shipmentTo.Country.toLowerCase() == "united states"))
            && (shipmentFrom != undefined && !String.isNullOrEmpty(shipmentFrom.Country) && shipmentFrom.Country.toLowerCase() == "china")
            || (order.Customer.Location != undefined && !String.isNullOrEmpty(order.Customer.Location.Country) && order.Customer.Location.Country.toLowerCase() == "china")
            || (!String.isNullOrEmpty(manufacturer) && (manufacturer.toLowerCase() == "china" || manufacturer.toLowerCase() == "cn"))
                && !isVehicle) {
            var dutyTax = orderItem.Total.Taxes.find(function (i) { return i.Type == taxType["a" /* TaxType */].CustomDuty; });
            if (dutyTax != null) {
                return dutyTax.Percentage + "%";
            }
            return '0%';
        }
        if (shipmentTo != null && !String.isNullOrEmpty(shipmentTo.Country) && orderItem.Manufacturer != null && !String.isNullOrEmpty(orderItem.Manufacturer.Name)
            && orderItem.Manufacturer.Name.toLowerCase() == shipmentTo.Country.toLowerCase() && !isVehicle
            && !(shipmentTo.Country == "Canada" && orderItem.Product.HsCode == "8703.90.00.00")) {
            return 'Free';
        }
        if (shipmentTo != null && !String.isNullOrEmpty(shipmentTo.Country) && !String.isNullOrEmpty(manufacturer)
            && orderItem.Product.HsCode == "9999.99.99.98" &&
            (shipmentTo.Country.toLowerCase() == "us" || shipmentTo.Country.toLowerCase() == "united states") &&
            (manufacturer.toLowerCase() == "china" || manufacturer.toLowerCase() == "cn")) {
            return '0%';
        }
        if (isVehicle) {
            if (!String.isNullOrEmpty(manufacturer) && (orderItem.Product.HsCode == "9999.99.99.98" || orderItem.Product.HsCode == "9999.99.99.99")
                && (this.isMoreOrEqThanTwentyFive(order, orderItem) ||
                    manufacturer.toLowerCase() == "mexico" || manufacturer.toLowerCase() == "usa" || manufacturer.toLowerCase() == "united states" || manufacturer.toLowerCase() == "canada")) {
                return '0%';
            }
            var res = orderItem.Total.Taxes.find(function (x) { return x.Type == taxType["a" /* TaxType */].CustomDuty; });
            if (res) {
                if (res.Percentage == 0 && usSpecial == null)
                    return 'Free';
                var perc_2 = res.Percentage;
                if (usSpecial != null)
                    perc_2 += usSpecial;
                return perc_2.toString() + "%";
            }
        }
        if (orderItem.Manufacturer && orderItem.Manufacturer.Code && orderItem.Product && orderItem.Product.Countries) {
            for (var _i = 0, _a = orderItem.Product.Countries; _i < _a.length; _i++) {
                var country = _a[_i];
                if (country.CountryCode == orderItem.Manufacturer.Code) {
                    var perc_3 = country.Value == "Free" ? 0 : parseFloat(country.Value.split("%")[0]);
                    if (usSpecial != null)
                        perc_3 += usSpecial;
                    return perc_3.toString() + "%";
                }
            }
        }
        var perc = String.isNullOrEmpty(orderItem.Product.BaseTariff) || orderItem.Product.BaseTariff == "Free" ? 0 : parseFloat(orderItem.Product.BaseTariff.split("%")[0]);
        if (shipmentTo != null && !String.isNullOrEmpty(shipmentTo.Country) && !isVehicle && (shipmentTo.Country.toLowerCase() == "canada")
            && CalculatorHelper.isPublicCalculatorHsCode(orderItem)) {
            return "0%";
        }
        if (usSpecial != null)
            perc += usSpecial;
        return perc.toString() + "%";
    };
    CalculatorHelper.isPublicCalculatorHsCode = function (orderItem) {
        return (orderItem.Product.HsCode == "9999.99.99.98" || orderItem.Product.HsCode == "9999.99.99.99");
    };
    CalculatorHelper.isQuickQuote = function (order) {
        if (order.Flag == null)
            return false;
        return order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsQuickQuote);
    };
    CalculatorHelper.isQuickQuoteES = function (order) {
        if (order.Flag == null)
            return false;
        return order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsQuickQuote);
    };
    CalculatorHelper.isUsService = function (order) {
        if (order == null || order.Flag == null)
            return false;
        return order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsUsService);
    };
    CalculatorHelper.getTariffs = function (calculatorType, tariff, orderItem) {
        var service;
        switch (calculatorType) {
            case (0):
                service = new canadianTaxService_CanadianTaxService();
                break;
            case (1):
                service = new usaTaxService_UsaTaxService();
                break;
            default:
                return;
        }
        CalculatorHelper.mergeDutyLists(service.parseTariff(tariff), orderItem.DutyList);
    };
    CalculatorHelper.mergeDutyLists = function (parsedDuties, currentDuties) {
        if (currentDuties == null || currentDuties.length == 0) {
            Object.assign(currentDuties, parsedDuties);
            return;
        }
        if (this.isManualDuties(parsedDuties, currentDuties)) {
            parsedDuties[0].Value = currentDuties[0].Value;
            return;
        }
        var _loop_1 = function (parsedDuty) {
            var itemDuty = currentDuties
                .find(function (x) { return x.DutyType == parsedDuty.DutyType && x.Measure == parsedDuty.Measure; });
            if (itemDuty == null) {
                currentDuties.push(parsedDuty);
                return "continue";
            }
            itemDuty.Measure = parsedDuty.Measure;
            itemDuty.Value = parsedDuty.Value;
        };
        for (var _i = 0, parsedDuties_1 = parsedDuties; _i < parsedDuties_1.length; _i++) {
            var parsedDuty = parsedDuties_1[_i];
            _loop_1(parsedDuty);
        }
        var _loop_2 = function (i) {
            var parsedDuty = parsedDuties
                .find(function (x) {
                return x.DutyType == currentDuties[i].DutyType &&
                    x.Measure == currentDuties[i].Measure;
            });
            if (parsedDuty == null)
                currentDuties.splice(i, 1);
        };
        for (var i = currentDuties.length - 1; i >= 0; i--) {
            _loop_2(i);
        }
    };
    CalculatorHelper.isManualDuties = function (parsedDuties, currentDuties) {
        return parsedDuties.length == 1 && currentDuties.length == 1 && parsedDuties[0].DutyType == calculator_duty["b" /* DutyType */].Manual && currentDuties[0].DutyType == calculator_duty["b" /* DutyType */].Manual;
    };
    CalculatorHelper.isVehicle = function (order) {
        if (!order || !order.Flag)
            return false;
        return order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsVehicle);
    };
    CalculatorHelper.isVehicleES = function (order) {
        if (!order || !order.Flag)
            return false;
        return order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsVehicle);
    };
    CalculatorHelper.isCanadianVehicleCalculator = function (order) {
        if (!this.isVehicle(order))
            return false;
        var shipmentTo = order.Locations.find(function (x) { return x.Type == 2; });
        if (shipmentTo == null)
            return false;
        if (shipmentTo.Country.toLowerCase() == "canada")
            return true;
        return false;
    };
    CalculatorHelper.isUsaShipmentFrom = function (order) {
        if (!order.Customer || !order.Customer.Location || String.isNullOrEmpty(order.Customer.Location.Country))
            return false;
        return order.Customer.Location.Country.toLowerCase() == 'usa' || order.Customer.Location.Country.toLowerCase() == 'united states';
    };
    CalculatorHelper.isManufacturerFromCanadaUSAMexico = function (orderItem) {
        var manufacturerCode = orderItem.Manufacturer.Code;
        return manufacturerCode.toLowerCase() === 'mx' || manufacturerCode.toLowerCase() === 'ca' || manufacturerCode.toLowerCase() === 'us';
    };
    CalculatorHelper.isUsaShipmentTo = function (order) {
        return order.Locations.find(function (x) { return (x.Country && (x.Country.toLowerCase() == 'usa' || x.Country.toLowerCase() == 'united states')) && x.Type == 2; }) != null;
    };
    CalculatorHelper.replaceOrderPrefix = function (query) {
        if (String.isNullOrEmpty(query))
            return query;
        var regex = new RegExp(/(^bb-[0-9]*$|^b$|^bb$)/i);
        var match = regex.exec(query);
        if (query.match(regex)) {
            query = match[1].replace(/(bb?-?)/i, '');
        }
        return query;
    };
    CalculatorHelper.isUsedEquipment = function (product) {
        if (!product || String.isNullOrEmpty(product.HsCode))
            return false;
        if (product.HsCode == '8429.52.00.92' || product.HsCode == '8429.51.00.66')
            return true;
        return false;
    };
    /**
     * generate years array
     * @param from - the highest year
     * @param to - the lowest year
     */
    CalculatorHelper.generateYearsArray = function (from, to) {
        var result = new Array();
        for (var i = from; i >= to; i--) {
            result.push(i);
        }
        return result;
    };
    CalculatorHelper.calculateGrantTotalForItem = function (orderItem, order) {
        var result = 0;
        for (var _i = 0, _a = orderItem.Total.Taxes; _i < _a.length; _i++) {
            var tax = _a[_i];
            if (this.isCanadianVehicleCalculator(order)) {
                if (tax.Type == taxType["a" /* TaxType */].AdminFee || tax.Type == taxType["a" /* TaxType */].RIV)
                    continue;
                if (!order.IsCommercial && tax.Type == taxType["a" /* TaxType */].CustomPST)
                    continue;
            }
            result += tax.Value;
        }
        return result;
    };
    CalculatorHelper.getButtonValue = function (value, currentValue) {
        if (currentValue == value)
            return null;
        return value;
    };
    CalculatorHelper.getCurrencyName = function (order) {
        if (!order || !order.Currency)
            return null;
        return order.Currency.Name;
    };
    CalculatorHelper.isMoreOrEqThanTwentyFive = function (order, orderItem) {
        if (!CalculatorHelper.isVehicle(order))
            return false;
        return new Date().getFullYear() - orderItem.Year >= 25;
    };
    CalculatorHelper.isLessThanTwentyFive = function (order, orderItem) {
        if (!CalculatorHelper.isVehicle(order))
            return false;
        return new Date().getFullYear() - orderItem.Year < 25;
    };
    CalculatorHelper.calculateProductsValue = function (selectedCode, order) {
        var total = 0;
        if (selectedCode == null)
            return total;
        for (var _i = 0, _a = order.OrderItems; _i < _a.length; _i++) {
            var orderItem = _a[_i];
            if (orderItem.CanadianCurrencyCode.Code == selectedCode.Code) {
                total += orderItem.Price;
                continue;
            }
            var price = orderItem.Price * orderItem.CanadianCurrencyCode.Value; //convert to canadian
            total += price / selectedCode.Value;
        }
        return total;
    };
    CalculatorHelper.getTotalPriceCurrencyCode = function (order, canadianCurrencyCodes) {
        if (order.Status >= orderStatus["a" /* OrderStatus */].Paid) {
            if (CalculatorHelper.isSameCurrency(order.OrderItems))
                return order.OrderItems[0].CanadianCurrencyCode;
            return order.Currency;
        }
        if (CalculatorHelper.isSameCurrency(order.OrderItems))
            return canadianCurrencyCodes.find(function (x) { return x.Code == order.OrderItems[0].CanadianCurrencyCode.Code; });
        return canadianCurrencyCodes.find(function (x) { return x.Code == order.Currency.Code; });
    };
    /**
     * if null => not hst pr qst
     * if true => HST
     * if false => QST
     * @param {Order} order
     */
    CalculatorHelper.isHQst = function (order) {
        var loc = order.Locations.find(function (x) { return x.Type == 2; });
        if (loc == null)
            return null;
        if (this.getListOfHstProvincial().find(function (x) { return x.indexOf(loc.State) != -1; }) != null) {
            return true;
        }
        if (this.getListOfQstProvincial().find(function (x) { return x.indexOf(loc.State) != -1; }) != null) {
            return false;
        }
        return null;
    };
    CalculatorHelper.getListOfHstProvincial = function () {
        var arr = new Array();
        arr.push("New Brunswick");
        arr.push("Newfoundland and Labrador");
        arr.push("Nova Scotia");
        arr.push("Ontario");
        arr.push("Prince Edward Island");
        return arr;
    };
    CalculatorHelper.getListOfQstProvincial = function () {
        var arr = new Array();
        arr.push("Quebec");
        return arr;
    };
    CalculatorHelper.IsBBFeeEdited = function (order) {
        if (order.Flag != null && order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsBBFeeEdited))
            return true;
        return false;
    };
    CalculatorHelper.checkOrderImporterType = function (order) {
        if (order.Flag || order.Flag === 0) {
            if (order.Flag.hasFlag(orderOptions["a" /* OrderOptions */].IsVehicle)) {
                return 0;
            }
            else
                return 1;
        }
    };
    CalculatorHelper.isCanadaShipmentTo = function (order) {
        return order.Locations.find(function (x) { return (x.Country && x.Country.toLowerCase() == 'canada') && x.Type == 2; }) != null;
    };
    CalculatorHelper.getMeanValue = function (x, y) { return Math.round((y + x) / 2); };
    return CalculatorHelper;
}());

//# sourceMappingURL=calculatorHelper.js.map

/***/ }),

/***/ "p4tm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("GWXQ"));
__export(__webpack_require__("Ii9O"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "qjx7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var customEvent = __webpack_require__("gN9/");
var eventmap = __webpack_require__("hTTC");
var doc = global.document;
var addEvent = addEventEasy;
var removeEvent = removeEventEasy;
var hardCache = [];

if (!global.addEventListener) {
  addEvent = addEventHard;
  removeEvent = removeEventHard;
}

module.exports = {
  add: addEvent,
  remove: removeEvent,
  fabricate: fabricateEvent
};

function addEventEasy (el, type, fn, capturing) {
  return el.addEventListener(type, fn, capturing);
}

function addEventHard (el, type, fn) {
  return el.attachEvent('on' + type, wrap(el, type, fn));
}

function removeEventEasy (el, type, fn, capturing) {
  return el.removeEventListener(type, fn, capturing);
}

function removeEventHard (el, type, fn) {
  var listener = unwrap(el, type, fn);
  if (listener) {
    return el.detachEvent('on' + type, listener);
  }
}

function fabricateEvent (el, type, model) {
  var e = eventmap.indexOf(type) === -1 ? makeCustomEvent() : makeClassicEvent();
  if (el.dispatchEvent) {
    el.dispatchEvent(e);
  } else {
    el.fireEvent('on' + type, e);
  }
  function makeClassicEvent () {
    var e;
    if (doc.createEvent) {
      e = doc.createEvent('Event');
      e.initEvent(type, true, true);
    } else if (doc.createEventObject) {
      e = doc.createEventObject();
    }
    return e;
  }
  function makeCustomEvent () {
    return new customEvent(type, { detail: model });
  }
}

function wrapperFactory (el, type, fn) {
  return function wrapper (originalEvent) {
    var e = originalEvent || global.event;
    e.target = e.target || e.srcElement;
    e.preventDefault = e.preventDefault || function preventDefault () { e.returnValue = false; };
    e.stopPropagation = e.stopPropagation || function stopPropagation () { e.cancelBubble = true; };
    e.which = e.which || e.keyCode;
    fn.call(el, e);
  };
}

function wrap (el, type, fn) {
  var wrapper = unwrap(el, type, fn) || wrapperFactory(el, type, fn);
  hardCache.push({
    wrapper: wrapper,
    element: el,
    type: type,
    fn: fn
  });
  return wrapper;
}

function unwrap (el, type, fn) {
  var i = find(el, type, fn);
  if (i) {
    var wrapper = hardCache[i].wrapper;
    hardCache.splice(i, 1); // free up a tad of memory
    return wrapper;
  }
}

function find (el, type, fn) {
  var i, item;
  for (i = 0; i < hardCache.length; i++) {
    item = hardCache[i];
    if (item.element === el && item.type === type && item.fn === fn) {
      return i;
    }
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "qyLN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageVisitService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseService__ = __webpack_require__("IhmT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__("Fzro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configService__ = __webpack_require__("cfSW");




var PageVisitService = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](PageVisitService, _super);
    function PageVisitService(http, configService) {
        var _this = _super.call(this, http, configService) || this;
        _this.http = http;
        _this.configService = configService;
        return _this;
    }
    PageVisitService.prototype.add = function (pageVisit) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "pagevisit?pageTitle=" + pageVisit.pageTitle + "&pageOrder=" + pageVisit.pageOrder
        }));
    };
    PageVisitService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_http__["e" /* Http */] }, { type: __WEBPACK_IMPORTED_MODULE_3__configService__["a" /* ConfigService */] }]; };
    return PageVisitService;
}(__WEBPACK_IMPORTED_MODULE_1__baseService__["a" /* BaseApi */]));

//# sourceMappingURL=pageVisitService.js.map

/***/ }),

/***/ "sQpZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var utils_1 = __webpack_require__("x6Zf");
var services_1 = __webpack_require__("J/iR");
var types_1 = __webpack_require__("j2I9");
var body_1 = __webpack_require__("KPjg");
var body_group_header_directive_1 = __webpack_require__("+erw");
var columns_1 = __webpack_require__("Fglw");
var row_detail_1 = __webpack_require__("p4tm");
var footer_1 = __webpack_require__("yl66");
var header_1 = __webpack_require__("hIqV");
var BehaviorSubject_1 = __webpack_require__("TfWX");
var DatatableComponent = /** @class */ (function () {
    function DatatableComponent(scrollbarHelper, dimensionsHelper, cd, element, differs) {
        this.scrollbarHelper = scrollbarHelper;
        this.dimensionsHelper = dimensionsHelper;
        this.cd = cd;
        /**
         * List of row objects that should be
         * represented as selected in the grid.
         * Default value: `[]`
         */
        this.selected = [];
        /**
         * Enable vertical scrollbars
         */
        this.scrollbarV = false;
        /**
         * Enable horz scrollbars
         */
        this.scrollbarH = false;
        /**
         * The row height; which is necessary
         * to calculate the height for the lazy rendering.
         */
        this.rowHeight = 30;
        /**
         * Type of column width distribution formula.
         * Example: flex, force, standard
         */
        this.columnMode = types_1.ColumnMode.standard;
        /**
         * The minimum header height in pixels.
         * Pass a falsey for no header
         */
        this.headerHeight = 30;
        /**
         * The minimum footer height in pixels.
         * Pass falsey for no footer
         */
        this.footerHeight = 0;
        /**
         * If the table should use external paging
         * otherwise its assumed that all data is preloaded.
         */
        this.externalPaging = false;
        /**
         * If the table should use external sorting or
         * the built-in basic sorting.
         */
        this.externalSorting = false;
        /**
         * Show the linear loading bar.
         * Default value: `false`
         */
        this.loadingIndicator = false;
        /**
         * Enable/Disable ability to re-order columns
         * by dragging them.
         */
        this.reorderable = true;
        /**
         * The type of sorting
         */
        this.sortType = types_1.SortType.single;
        /**
         * Array of sorted columns by property and type.
         * Default value: `[]`
         */
        this.sorts = [];
        /**
         * Css class overrides
         */
        this.cssClasses = {
            sortAscending: 'datatable-icon-up',
            sortDescending: 'datatable-icon-down',
            pagerLeftArrow: 'datatable-icon-left',
            pagerRightArrow: 'datatable-icon-right',
            pagerPrevious: 'datatable-icon-prev',
            pagerNext: 'datatable-icon-skip'
        };
        /**
         * Message overrides for localization
         *
         * emptyMessage     [default] = 'No data to display'
         * totalMessage     [default] = 'total'
         * selectedMessage  [default] = 'selected'
         */
        this.messages = {
            // Message to show when array is presented
            // but contains no values
            emptyMessage: 'No data to display',
            // Footer total message
            totalMessage: 'total',
            // Footer selected message
            selectedMessage: 'selected'
        };
        /**
         * This will be used when displaying or selecting rows.
         * when tracking/comparing them, we'll use the value of this fn,
         *
         * (`fn(x) === fn(y)` instead of `x === y`)
         */
        this.rowIdentity = (function (x) { return x; });
        /**
         * A boolean you can use to set the detault behaviour of rows and groups
         * whether they will start expanded or not. If ommited the default is NOT expanded.
         *
         */
        this.groupExpansionDefault = false;
        /**
         * Property to which you can use for determining select all
         * rows on current page or not.
         *
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        this.selectAllRowsOnPage = false;
        /**
         * A flag for row virtualization on / off
         */
        this.virtualization = true;
        /**
         * A flag for switching summary row on / off
         */
        this.summaryRow = false;
        /**
         * A height of summary row
         */
        this.summaryHeight = this.rowHeight;
        /**
         * A property holds a summary row position: top/bottom
         */
        this.summaryPosition = 'top';
        /**
         * Body was scrolled typically in a `scrollbarV:true` scenario.
         */
        this.scroll = new core_1.EventEmitter();
        /**
         * A cell or row was focused via keyboard or mouse click.
         */
        this.activate = new core_1.EventEmitter();
        /**
         * A cell or row was selected.
         */
        this.select = new core_1.EventEmitter();
        /**
         * Column sort was invoked.
         */
        this.sort = new core_1.EventEmitter();
        /**
         * The table was paged either triggered by the pager or the body scroll.
         */
        this.page = new core_1.EventEmitter();
        /**
         * Columns were re-ordered.
         */
        this.reorder = new core_1.EventEmitter();
        /**
         * Column was resized.
         */
        this.resize = new core_1.EventEmitter();
        /**
         * The context menu was invoked on the table.
         * type indicates whether the header or the body was clicked.
         * content contains either the column or the row that was clicked.
         */
        this.tableContextmenu = new core_1.EventEmitter(false);
        this.rowCount = 0;
        this._offsetX = new BehaviorSubject_1.BehaviorSubject(0);
        this._count = 0;
        this._offset = 0;
        // get ref to elm for measuring
        this.element = element.nativeElement;
        this.rowDiffer = differs.find({}).create();
    }
    Object.defineProperty(DatatableComponent.prototype, "rows", {
        /**
         * Gets the rows.
         */
        get: function () {
            return this._rows;
        },
        /**
         * Rows that are displayed in the table.
         */
        set: function (val) {
            this._rows = val;
            if (val) {
                this._internalRows = val.slice();
            }
            // auto sort on new updates
            if (!this.externalSorting) {
                this.sortInternalRows();
            }
            // recalculate sizes/etc
            this.recalculate();
            if (this._rows && this._groupRowsBy) {
                // If a column has been specified in _groupRowsBy created a new array with the data grouped by that row
                this.groupedRows = this.groupArrayBy(this._rows, this._groupRowsBy);
            }
            this.cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "groupRowsBy", {
        get: function () {
            return this._groupRowsBy;
        },
        /**
         * This attribute allows the user to set the name of the column to group the data with
         */
        set: function (val) {
            if (val) {
                this._groupRowsBy = val;
                if (this._rows && this._groupRowsBy) {
                    // cretes a new array with the data grouped
                    this.groupedRows = this.groupArrayBy(this._rows, this._groupRowsBy);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "columns", {
        /**
         * Get the columns.
         */
        get: function () {
            return this._columns;
        },
        /**
         * Columns to be displayed.
         */
        set: function (val) {
            if (val) {
                this._internalColumns = val.slice();
                utils_1.setColumnDefaults(this._internalColumns);
                this.recalculateColumns();
            }
            this._columns = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "limit", {
        /**
         * Gets the limit.
         */
        get: function () {
            return this._limit;
        },
        /**
         * The page size to be shown.
         * Default value: `undefined`
         */
        set: function (val) {
            this._limit = val;
            // recalculate sizes/etc
            this.recalculate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "count", {
        /**
         * Gets the count.
         */
        get: function () {
            return this._count;
        },
        /**
         * The total count of all rows.
         * Default value: `0`
         */
        set: function (val) {
            this._count = val;
            // recalculate sizes/etc
            this.recalculate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "offset", {
        get: function () {
            return Math.max(Math.min(this._offset, Math.ceil(this.rowCount / this.pageSize) - 1), 0);
        },
        /**
         * The current offset ( page - 1 ) shown.
         * Default value: `0`
         */
        set: function (val) {
            this._offset = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isFixedHeader", {
        /**
         * CSS class applied if the header height if fixed height.
         */
        get: function () {
            var headerHeight = this.headerHeight;
            return (typeof headerHeight === 'string') ?
                headerHeight !== 'auto' : true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isFixedRow", {
        /**
         * CSS class applied to the root element if
         * the row heights are fixed heights.
         */
        get: function () {
            var rowHeight = this.rowHeight;
            return (typeof rowHeight === 'string') ?
                rowHeight !== 'auto' : true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isVertScroll", {
        /**
         * CSS class applied to root element if
         * vertical scrolling is enabled.
         */
        get: function () {
            return this.scrollbarV;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isHorScroll", {
        /**
         * CSS class applied to the root element
         * if the horziontal scrolling is enabled.
         */
        get: function () {
            return this.scrollbarH;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isSelectable", {
        /**
         * CSS class applied to root element is selectable.
         */
        get: function () {
            return this.selectionType !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isCheckboxSelection", {
        /**
         * CSS class applied to root is checkbox selection.
         */
        get: function () {
            return this.selectionType === types_1.SelectionType.checkbox;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isCellSelection", {
        /**
         * CSS class applied to root if cell selection.
         */
        get: function () {
            return this.selectionType === types_1.SelectionType.cell;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isSingleSelection", {
        /**
         * CSS class applied to root if single select.
         */
        get: function () {
            return this.selectionType === types_1.SelectionType.single;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isMultiSelection", {
        /**
         * CSS class added to root element if mulit select
         */
        get: function () {
            return this.selectionType === types_1.SelectionType.multi;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isMultiClickSelection", {
        /**
         * CSS class added to root element if mulit click select
         */
        get: function () {
            return this.selectionType === types_1.SelectionType.multiClick;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "columnTemplates", {
        /**
         * Returns the column templates.
         */
        get: function () {
            return this._columnTemplates;
        },
        /**
         * Column templates gathered from `ContentChildren`
         * if described in your markup.
         */
        set: function (val) {
            this._columnTemplates = val;
            this.translateColumns(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "allRowsSelected", {
        /**
         * Returns if all rows are selected.
         */
        get: function () {
            var allRowsSelected = (this.rows && this.selected && this.selected.length === this.rows.length);
            if (this.selectAllRowsOnPage) {
                var indexes = this.bodyComponent.indexes;
                var rowsOnPage = indexes.last - indexes.first;
                allRowsSelected = (this.selected.length === rowsOnPage);
            }
            return this.selected && this.rows &&
                this.rows.length !== 0 && allRowsSelected;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Lifecycle hook that is called after data-bound
     * properties of a directive are initialized.
     */
    DatatableComponent.prototype.ngOnInit = function () {
        // need to call this immediatly to size
        // if the table is hidden the visibility
        // listener will invoke this itself upon show
        this.recalculate();
    };
    /**
     * Lifecycle hook that is called after a component's
     * view has been fully initialized.
     */
    DatatableComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (!this.externalSorting) {
            this.sortInternalRows();
        }
        // this has to be done to prevent the change detection
        // tree from freaking out because we are readjusting
        if (typeof requestAnimationFrame === 'undefined') {
            return;
        }
        requestAnimationFrame(function () {
            _this.recalculate();
            // emit page for virtual server-side kickoff
            if (_this.externalPaging && _this.scrollbarV) {
                _this.page.emit({
                    count: _this.count,
                    pageSize: _this.pageSize,
                    limit: _this.limit,
                    offset: 0
                });
            }
        });
    };
    /**
     * Lifecycle hook that is called after a component's
     * content has been fully initialized.
     */
    DatatableComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.columnTemplates.changes.subscribe(function (v) {
            return _this.translateColumns(v);
        });
    };
    /**
     * Translates the templates to the column objects
     */
    DatatableComponent.prototype.translateColumns = function (val) {
        if (val) {
            var arr = val.toArray();
            if (arr.length) {
                this._internalColumns = utils_1.translateTemplates(arr);
                utils_1.setColumnDefaults(this._internalColumns);
                this.recalculateColumns();
                this.sortInternalRows();
                this.cd.markForCheck();
            }
        }
    };
    /**
     * Creates a map with the data grouped by the user choice of grouping index
     *
     * @param originalArray the original array passed via parameter
     * @param groupByIndex  the index of the column to group the data by
     */
    DatatableComponent.prototype.groupArrayBy = function (originalArray, groupBy) {
        // create a map to hold groups with their corresponding results
        var map = new Map();
        var i = 0;
        originalArray.forEach(function (item) {
            var key = item[groupBy];
            if (!map.has(key)) {
                map.set(key, [item]);
            }
            else {
                map.get(key).push(item);
            }
            i++;
        });
        var addGroup = function (key, value) {
            return { key: key, value: value };
        };
        // convert map back to a simple array of objects
        return Array.from(map, function (x) { return addGroup(x[0], x[1]); });
    };
    /*
    * Lifecycle hook that is called when Angular dirty checks a directive.
    */
    DatatableComponent.prototype.ngDoCheck = function () {
        if (this.rowDiffer.diff(this.rows)) {
            if (!this.externalSorting) {
                this.sortInternalRows();
            }
            else {
                this._internalRows = this.rows.slice();
            }
            this.recalculatePages();
            this.cd.markForCheck();
        }
    };
    /**
     * Recalc's the sizes of the grid.
     *
     * Updated automatically on changes to:
     *
     *  - Columns
     *  - Rows
     *  - Paging related
     *
     * Also can be manually invoked or upon window resize.
     */
    DatatableComponent.prototype.recalculate = function () {
        this.recalculateDims();
        this.recalculateColumns();
    };
    /**
     * Window resize handler to update sizes.
     */
    DatatableComponent.prototype.onWindowResize = function () {
        this.recalculate();
    };
    /**
     * Recalulcates the column widths based on column width
     * distribution mode and scrollbar offsets.
     */
    DatatableComponent.prototype.recalculateColumns = function (columns, forceIdx, allowBleed) {
        if (columns === void 0) { columns = this._internalColumns; }
        if (forceIdx === void 0) { forceIdx = -1; }
        if (allowBleed === void 0) { allowBleed = this.scrollbarH; }
        if (!columns)
            return undefined;
        var width = this._innerWidth;
        if (this.scrollbarV) {
            width = width - this.scrollbarHelper.width;
        }
        if (this.columnMode === types_1.ColumnMode.force) {
            utils_1.forceFillColumnWidths(columns, width, forceIdx, allowBleed);
        }
        else if (this.columnMode === types_1.ColumnMode.flex) {
            utils_1.adjustColumnWidths(columns, width);
        }
        return columns;
    };
    /**
     * Recalculates the dimensions of the table size.
     * Internally calls the page size and row count calcs too.
     *
     */
    DatatableComponent.prototype.recalculateDims = function () {
        var dims = this.dimensionsHelper.getDimensions(this.element);
        this._innerWidth = Math.floor(dims.width);
        if (this.scrollbarV) {
            var height = dims.height;
            if (this.headerHeight)
                height = height - this.headerHeight;
            if (this.footerHeight)
                height = height - this.footerHeight;
            this.bodyHeight = height;
        }
        this.recalculatePages();
    };
    /**
     * Recalculates the pages after a update.
     */
    DatatableComponent.prototype.recalculatePages = function () {
        this.pageSize = this.calcPageSize();
        this.rowCount = this.calcRowCount();
    };
    /**
     * Body triggered a page event.
     */
    DatatableComponent.prototype.onBodyPage = function (_a) {
        var offset = _a.offset;
        this.offset = offset;
        this.page.emit({
            count: this.count,
            pageSize: this.pageSize,
            limit: this.limit,
            offset: this.offset
        });
    };
    /**
     * The body triggered a scroll event.
     */
    DatatableComponent.prototype.onBodyScroll = function (event) {
        this._offsetX.next(event.offsetX);
        this.scroll.emit(event);
        this.cd.detectChanges();
    };
    /**
     * The footer triggered a page event.
     */
    DatatableComponent.prototype.onFooterPage = function (event) {
        this.offset = event.page - 1;
        this.bodyComponent.updateOffsetY(this.offset);
        this.page.emit({
            count: this.count,
            pageSize: this.pageSize,
            limit: this.limit,
            offset: this.offset
        });
        if (this.selectAllRowsOnPage) {
            this.selected = [];
            this.select.emit({
                selected: this.selected
            });
        }
    };
    /**
     * Recalculates the sizes of the page
     */
    DatatableComponent.prototype.calcPageSize = function (val) {
        if (val === void 0) { val = this.rows; }
        // Keep the page size constant even if the row has been expanded.
        // This is because an expanded row is still considered to be a child of
        // the original row.  Hence calculation would use rowHeight only.
        if (this.scrollbarV) {
            var size = Math.ceil(this.bodyHeight / this.rowHeight);
            return Math.max(size, 0);
        }
        // if limit is passed, we are paging
        if (this.limit !== undefined) {
            return this.limit;
        }
        // otherwise use row length
        if (val) {
            return val.length;
        }
        // other empty :(
        return 0;
    };
    /**
     * Calculates the row count.
     */
    DatatableComponent.prototype.calcRowCount = function (val) {
        if (val === void 0) { val = this.rows; }
        if (!this.externalPaging) {
            if (!val)
                return 0;
            if (this.groupedRows) {
                return this.groupedRows.length;
            }
            else {
                return val.length;
            }
        }
        return this.count;
    };
    /**
     * The header triggered a contextmenu event.
     */
    DatatableComponent.prototype.onColumnContextmenu = function (_a) {
        var event = _a.event, column = _a.column;
        this.tableContextmenu.emit({ event: event, type: types_1.ContextmenuType.header, content: column });
    };
    /**
     * The body triggered a contextmenu event.
     */
    DatatableComponent.prototype.onRowContextmenu = function (_a) {
        var event = _a.event, row = _a.row;
        this.tableContextmenu.emit({ event: event, type: types_1.ContextmenuType.body, content: row });
    };
    /**
     * The header triggered a column resize event.
     */
    DatatableComponent.prototype.onColumnResize = function (_a) {
        var column = _a.column, newValue = _a.newValue;
        /* Safari/iOS 10.2 workaround */
        if (column === undefined) {
            return;
        }
        var idx;
        var cols = this._internalColumns.map(function (c, i) {
            c = __assign({}, c);
            if (c.$$id === column.$$id) {
                idx = i;
                c.width = newValue;
                // set this so we can force the column
                // width distribution to be to this value
                c.$$oldWidth = newValue;
            }
            return c;
        });
        this.recalculateColumns(cols, idx);
        this._internalColumns = cols;
        this.resize.emit({
            column: column,
            newValue: newValue
        });
    };
    /**
     * The header triggered a column re-order event.
     */
    DatatableComponent.prototype.onColumnReorder = function (_a) {
        var column = _a.column, newValue = _a.newValue, prevValue = _a.prevValue;
        var cols = this._internalColumns.map(function (c) {
            return __assign({}, c);
        });
        var prevCol = cols[newValue];
        cols[newValue] = column;
        cols[prevValue] = prevCol;
        this._internalColumns = cols;
        this.reorder.emit({
            column: column,
            newValue: newValue,
            prevValue: prevValue
        });
    };
    /**
     * The header triggered a column sort event.
     */
    DatatableComponent.prototype.onColumnSort = function (event) {
        // clean selected rows
        if (this.selectAllRowsOnPage) {
            this.selected = [];
            this.select.emit({
                selected: this.selected
            });
        }
        this.sorts = event.sorts;
        // this could be optimized better since it will resort
        // the rows again on the 'push' detection...
        if (this.externalSorting === false) {
            // don't use normal setter so we don't resort
            this.sortInternalRows();
        }
        // Always go to first page when sorting to see the newly sorted data
        this.offset = 0;
        this.bodyComponent.updateOffsetY(this.offset);
        this.sort.emit(event);
    };
    /**
     * Toggle all row selection
     */
    DatatableComponent.prototype.onHeaderSelect = function (event) {
        if (this.selectAllRowsOnPage) {
            // before we splice, chk if we currently have all selected
            var first = this.bodyComponent.indexes.first;
            var last = this.bodyComponent.indexes.last;
            var allSelected = this.selected.length === (last - first);
            // remove all existing either way
            this.selected = [];
            // do the opposite here
            if (!allSelected) {
                (_a = this.selected).push.apply(_a, this._internalRows.slice(first, last));
            }
        }
        else {
            // before we splice, chk if we currently have all selected
            var allSelected = this.selected.length === this.rows.length;
            // remove all existing either way
            this.selected = [];
            // do the opposite here
            if (!allSelected) {
                (_b = this.selected).push.apply(_b, this.rows);
            }
        }
        this.select.emit({
            selected: this.selected
        });
        var _a, _b;
    };
    /**
     * A row was selected from body
     */
    DatatableComponent.prototype.onBodySelect = function (event) {
        this.select.emit(event);
    };
    DatatableComponent.prototype.sortInternalRows = function () {
        this._internalRows = utils_1.sortRows(this._internalRows, this._internalColumns, this.sorts);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], DatatableComponent.prototype, "rows", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], DatatableComponent.prototype, "groupRowsBy", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DatatableComponent.prototype, "groupedRows", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], DatatableComponent.prototype, "columns", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DatatableComponent.prototype, "selected", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DatatableComponent.prototype, "scrollbarV", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DatatableComponent.prototype, "scrollbarH", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DatatableComponent.prototype, "rowHeight", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DatatableComponent.prototype, "columnMode", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DatatableComponent.prototype, "headerHeight", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DatatableComponent.prototype, "footerHeight", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DatatableComponent.prototype, "externalPaging", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DatatableComponent.prototype, "externalSorting", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], DatatableComponent.prototype, "limit", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], DatatableComponent.prototype, "count", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], DatatableComponent.prototype, "offset", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DatatableComponent.prototype, "loadingIndicator", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DatatableComponent.prototype, "selectionType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DatatableComponent.prototype, "reorderable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DatatableComponent.prototype, "sortType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DatatableComponent.prototype, "sorts", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DatatableComponent.prototype, "cssClasses", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DatatableComponent.prototype, "messages", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Function)
    ], DatatableComponent.prototype, "rowIdentity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DatatableComponent.prototype, "rowClass", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DatatableComponent.prototype, "selectCheck", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Function)
    ], DatatableComponent.prototype, "displayCheck", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DatatableComponent.prototype, "groupExpansionDefault", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DatatableComponent.prototype, "trackByProp", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DatatableComponent.prototype, "selectAllRowsOnPage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DatatableComponent.prototype, "virtualization", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DatatableComponent.prototype, "summaryRow", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DatatableComponent.prototype, "summaryHeight", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DatatableComponent.prototype, "summaryPosition", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DatatableComponent.prototype, "scroll", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DatatableComponent.prototype, "activate", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DatatableComponent.prototype, "select", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DatatableComponent.prototype, "sort", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DatatableComponent.prototype, "page", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DatatableComponent.prototype, "reorder", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DatatableComponent.prototype, "resize", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], DatatableComponent.prototype, "tableContextmenu", void 0);
    __decorate([
        core_1.HostBinding('class.fixed-header'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], DatatableComponent.prototype, "isFixedHeader", null);
    __decorate([
        core_1.HostBinding('class.fixed-row'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], DatatableComponent.prototype, "isFixedRow", null);
    __decorate([
        core_1.HostBinding('class.scroll-vertical'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], DatatableComponent.prototype, "isVertScroll", null);
    __decorate([
        core_1.HostBinding('class.scroll-horz'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], DatatableComponent.prototype, "isHorScroll", null);
    __decorate([
        core_1.HostBinding('class.selectable'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], DatatableComponent.prototype, "isSelectable", null);
    __decorate([
        core_1.HostBinding('class.checkbox-selection'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], DatatableComponent.prototype, "isCheckboxSelection", null);
    __decorate([
        core_1.HostBinding('class.cell-selection'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], DatatableComponent.prototype, "isCellSelection", null);
    __decorate([
        core_1.HostBinding('class.single-selection'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], DatatableComponent.prototype, "isSingleSelection", null);
    __decorate([
        core_1.HostBinding('class.multi-selection'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], DatatableComponent.prototype, "isMultiSelection", null);
    __decorate([
        core_1.HostBinding('class.multi-click-selection'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], DatatableComponent.prototype, "isMultiClickSelection", null);
    __decorate([
        core_1.ContentChildren(columns_1.DataTableColumnDirective),
        __metadata("design:type", core_1.QueryList),
        __metadata("design:paramtypes", [core_1.QueryList])
    ], DatatableComponent.prototype, "columnTemplates", null);
    __decorate([
        core_1.ContentChild(row_detail_1.DatatableRowDetailDirective),
        __metadata("design:type", row_detail_1.DatatableRowDetailDirective)
    ], DatatableComponent.prototype, "rowDetail", void 0);
    __decorate([
        core_1.ContentChild(body_group_header_directive_1.DatatableGroupHeaderDirective),
        __metadata("design:type", body_group_header_directive_1.DatatableGroupHeaderDirective)
    ], DatatableComponent.prototype, "groupHeader", void 0);
    __decorate([
        core_1.ContentChild(footer_1.DatatableFooterDirective),
        __metadata("design:type", footer_1.DatatableFooterDirective)
    ], DatatableComponent.prototype, "footer", void 0);
    __decorate([
        core_1.ViewChild(body_1.DataTableBodyComponent),
        __metadata("design:type", body_1.DataTableBodyComponent)
    ], DatatableComponent.prototype, "bodyComponent", void 0);
    __decorate([
        core_1.ViewChild(header_1.DataTableHeaderComponent),
        __metadata("design:type", header_1.DataTableHeaderComponent)
    ], DatatableComponent.prototype, "headerComponent", void 0);
    __decorate([
        core_1.HostListener('window:resize'),
        utils_1.throttleable(5),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DatatableComponent.prototype, "onWindowResize", null);
    DatatableComponent = __decorate([
        core_1.Component({
            selector: 'ngx-datatable',
            template: "\n    <div\n      visibilityObserver\n      (visible)=\"recalculate()\">\n      <datatable-header\n        *ngIf=\"headerHeight\"\n        [sorts]=\"sorts\"\n        [sortType]=\"sortType\"\n        [scrollbarH]=\"scrollbarH\"\n        [innerWidth]=\"_innerWidth\"\n        [offsetX]=\"_offsetX | async\"\n        [dealsWithGroup]=\"groupedRows\"\n        [columns]=\"_internalColumns\"\n        [headerHeight]=\"headerHeight\"\n        [reorderable]=\"reorderable\"\n        [sortAscendingIcon]=\"cssClasses.sortAscending\"\n        [sortDescendingIcon]=\"cssClasses.sortDescending\"\n        [allRowsSelected]=\"allRowsSelected\"\n        [selectionType]=\"selectionType\"\n        (sort)=\"onColumnSort($event)\"\n        (resize)=\"onColumnResize($event)\"\n        (reorder)=\"onColumnReorder($event)\"\n        (select)=\"onHeaderSelect($event)\"\n        (columnContextmenu)=\"onColumnContextmenu($event)\">\n      </datatable-header>\n      <datatable-body\n        [groupRowsBy]=\"groupRowsBy\"\n        [groupedRows]=\"groupedRows\"\n        [rows]=\"_internalRows\"\n        [groupExpansionDefault]=\"groupExpansionDefault\"\n        [scrollbarV]=\"scrollbarV\"\n        [scrollbarH]=\"scrollbarH\"\n        [virtualization]=\"virtualization\"\n        [loadingIndicator]=\"loadingIndicator\"\n        [externalPaging]=\"externalPaging\"\n        [rowHeight]=\"rowHeight\"\n        [rowCount]=\"rowCount\"\n        [offset]=\"offset\"\n        [trackByProp]=\"trackByProp\"\n        [columns]=\"_internalColumns\"\n        [pageSize]=\"pageSize\"\n        [offsetX]=\"_offsetX | async\"\n        [rowDetail]=\"rowDetail\"\n        [groupHeader]=\"groupHeader\"\n        [selected]=\"selected\"\n        [innerWidth]=\"_innerWidth\"\n        [bodyHeight]=\"bodyHeight\"\n        [selectionType]=\"selectionType\"\n        [emptyMessage]=\"messages.emptyMessage\"\n        [rowIdentity]=\"rowIdentity\"\n        [rowClass]=\"rowClass\"\n        [selectCheck]=\"selectCheck\"\n        [displayCheck]=\"displayCheck\"\n        [summaryRow]=\"summaryRow\"\n        [summaryHeight]=\"summaryHeight\"\n        [summaryPosition]=\"summaryPosition\"\n        (page)=\"onBodyPage($event)\"\n        (activate)=\"activate.emit($event)\"\n        (rowContextmenu)=\"onRowContextmenu($event)\"\n        (select)=\"onBodySelect($event)\"\n        (scroll)=\"onBodyScroll($event)\">\n      </datatable-body>\n      <datatable-footer\n        *ngIf=\"footerHeight\"\n        [rowCount]=\"rowCount\"\n        [pageSize]=\"pageSize\"\n        [offset]=\"offset\"\n        [footerHeight]=\"footerHeight\"\n        [footerTemplate]=\"footer\"\n        [totalMessage]=\"messages.totalMessage\"\n        [pagerLeftArrowIcon]=\"cssClasses.pagerLeftArrow\"\n        [pagerRightArrowIcon]=\"cssClasses.pagerRightArrow\"\n        [pagerPreviousIcon]=\"cssClasses.pagerPrevious\"\n        [selectedCount]=\"selected.length\"\n        [selectedMessage]=\"!!selectionType && messages.selectedMessage\"\n        [pagerNextIcon]=\"cssClasses.pagerNext\"\n        (page)=\"onFooterPage($event)\">\n      </datatable-footer>\n    </div>\n  ",
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
            encapsulation: core_1.ViewEncapsulation.None,
            styleUrls: ['./datatable.component.css'],
            host: {
                class: 'ngx-datatable'
            }
        }),
        __param(0, core_1.SkipSelf()),
        __param(1, core_1.SkipSelf()),
        __metadata("design:paramtypes", [services_1.ScrollbarHelper,
            services_1.DimensionsHelper,
            core_1.ChangeDetectorRef,
            core_1.ElementRef,
            core_1.KeyValueDiffers])
    ], DatatableComponent);
    return DatatableComponent;
}());
exports.DatatableComponent = DatatableComponent;
//# sourceMappingURL=datatable.component.js.map

/***/ }),

/***/ "sUlX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var DataTableColumnHeaderDirective = /** @class */ (function () {
    function DataTableColumnHeaderDirective(template) {
        this.template = template;
    }
    DataTableColumnHeaderDirective = __decorate([
        core_1.Directive({ selector: '[ngx-datatable-header-template]' }),
        __metadata("design:paramtypes", [core_1.TemplateRef])
    ], DataTableColumnHeaderDirective);
    return DataTableColumnHeaderDirective;
}());
exports.DataTableColumnHeaderDirective = DataTableColumnHeaderDirective;
//# sourceMappingURL=column-header.directive.js.map

/***/ }),

/***/ "sXN4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// maybe rename this file to prop-getters.ts
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Always returns the empty string ''
 * @returns {string}
 */
function emptyStringGetter() {
    return '';
}
exports.emptyStringGetter = emptyStringGetter;
/**
 * Returns the appropriate getter function for this kind of prop.
 * If prop == null, returns the emptyStringGetter.
 */
function getterForProp(prop) {
    if (prop == null)
        return emptyStringGetter;
    if (typeof prop === 'number') {
        return numericIndexGetter;
    }
    else {
        // deep or simple
        if (prop.indexOf('.') !== -1) {
            return deepValueGetter;
        }
        else {
            return shallowValueGetter;
        }
    }
}
exports.getterForProp = getterForProp;
/**
 * Returns the value at this numeric index.
 * @param row array of values
 * @param index numeric index
 * @returns {any} or '' if invalid index
 */
function numericIndexGetter(row, index) {
    if (row == null)
        return '';
    // mimic behavior of deepValueGetter
    if (!row || index == null)
        return row;
    var value = row[index];
    if (value == null)
        return '';
    return value;
}
exports.numericIndexGetter = numericIndexGetter;
/**
 * Returns the value of a field.
 * (more efficient than deepValueGetter)
 * @param obj object containing the field
 * @param fieldName field name string
 * @returns {any}
 */
function shallowValueGetter(obj, fieldName) {
    if (obj == null)
        return '';
    if (!obj || !fieldName)
        return obj;
    var value = obj[fieldName];
    if (value == null)
        return '';
    return value;
}
exports.shallowValueGetter = shallowValueGetter;
/**
 * Returns a deep object given a string. zoo['animal.type']
 * @param {object} obj
 * @param {string} path
 */
function deepValueGetter(obj, path) {
    if (obj == null)
        return '';
    if (!obj || !path)
        return obj;
    // check if path matches a root-level field
    // { "a.b.c": 123 }
    var current = obj[path];
    if (current !== undefined)
        return current;
    current = obj;
    var split = path.split('.');
    if (split.length) {
        for (var i = 0; i < split.length; i++) {
            current = current[split[i]];
            // if found undefined, return empty string
            if (current === undefined || current === null)
                return '';
        }
    }
    return current;
}
exports.deepValueGetter = deepValueGetter;
//# sourceMappingURL=column-prop-getters.js.map

/***/ }),

/***/ "svBX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("TToO");

// EXTERNAL MODULE: ./app/objects/common/baseEntity.ts
var baseEntity = __webpack_require__("mCwL");

// CONCATENATED MODULE: ./app/objects/customers/company.ts


/**
 * Created by alex.y on 9/7/2017.
 */
var company_Company = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](Company, _super);
    function Company() {
        return _super.call(this) || this;
    }
    return Company;
}(baseEntity["a" /* BaseEntity */]));

//# sourceMappingURL=company.js.map
// EXTERNAL MODULE: ./app/objects/management/order/orderLocation.ts
var orderLocation = __webpack_require__("oiko");

// EXTERNAL MODULE: ./app/objects/customers/stripe-payment-data.ts
var stripe_payment_data = __webpack_require__("clEe");

// CONCATENATED MODULE: ./app/objects/customers/customer.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customer_Customer; });





/**
 * Created by alex.y on 9/7/2017.
 */
var customer_Customer = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](Customer, _super);
    function Customer() {
        var _this = _super.call(this) || this;
        _this.Email = "";
        _this.Company = new company_Company();
        _this.Location = new orderLocation["a" /* OrderLocation */]();
        _this.OrderIDs = [];
        _this.Orders = new Array();
        _this.StripePaymentData = new stripe_payment_data["a" /* StripePaymentData */]();
        return _this;
    }
    return Customer;
}(baseEntity["a" /* BaseEntity */]));

//# sourceMappingURL=customer.js.map

/***/ }),

/***/ "tI4G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocationService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseService__ = __webpack_require__("IhmT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__("Fzro");
/**
 * Created by alex.y on 7/31/2017.
 */



var LocationService = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](LocationService, _super);
    function LocationService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocationService.prototype.getAll = function (top, skip) {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "location/all",
            params: {
                top: top,
                skip: skip
            }
        }));
    };
    LocationService.prototype.getById = function (id) {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "currency/" + id,
        }));
    };
    LocationService.prototype.modify = function (updateRequest) {
        return this.put(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "location",
            body: updateRequest
        }));
    };
    LocationService.prototype.deleteById = function (id) {
        return this.delete(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "location/" + id,
        }));
    };
    LocationService.prototype.search = function (request) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "location/search",
            body: request
        }));
    };
    LocationService.prototype.getCountryStates = function () {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "location/countryStates"
        }));
    };
    return LocationService;
}(__WEBPACK_IMPORTED_MODULE_1__baseService__["a" /* BaseApi */]));

//# sourceMappingURL=locationService.js.map

/***/ }),

/***/ "tbtb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__("KJe9"));
__export(__webpack_require__("LuMv"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "uI+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocationUtil; });
/**
 * Created by alex.y on 8/10/2017.
 */
var LocationUtil = /** @class */ (function () {
    function LocationUtil() {
    }
    LocationUtil.formatAddress = function (location, showState) {
        if (showState === void 0) { showState = false; }
        var result = '';
        if (!location)
            return result;
        if (location.Street)
            result += location.Street + ", ";
        if (location.City)
            result += location.City + ", ";
        if (showState && location.State)
            result += location.State + ", ";
        if (location.Zip)
            result += location.Zip + ", ";
        if (location.Country)
            result += location.Country;
        return result;
    };
    LocationUtil.getShipmentTo = function (locations) {
        if (!locations)
            return null;
        return locations.find(function (x) { return x.Type == 2; });
    };
    LocationUtil.getShipmentFrom = function (locations) {
        if (!locations)
            return null;
        return locations.find(function (x) { return x.Type == 1; });
    };
    return LocationUtil;
}());

//# sourceMappingURL=LocationUtil.js.map

/***/ }),

/***/ "uPA9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HScodeHelper; });
var HScodeHelper = /** @class */ (function () {
    function HScodeHelper() {
    }
    HScodeHelper.addDotAfterLastTwoNumb = function (hsCode) {
        if (!hsCode)
            return;
        if (!hsCode.match(/^\d+\.\d+\.\d{4}$/g)) {
            return hsCode;
        }
        var arr = hsCode.split(".");
        arr[2] = String.insertStr(arr[2], ".", 2);
        return arr.join(".");
    };
    return HScodeHelper;
}());

//# sourceMappingURL=HScodeHelper.js.map

/***/ }),

/***/ "ujcs":
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "vWtP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlurUtil; });
/**
 * Created by alex.y on 9/7/2017.
 */
var BlurUtil = /** @class */ (function () {
    function BlurUtil() {
    }
    BlurUtil.blurMenu = function (id) {
        var leftMenu = document.getElementById("left-sidebar");
        var topMenu = document.getElementById("navbar-top");
        var content = document.getElementById(id);
        if (leftMenu)
            leftMenu.className = leftMenu.className + " blur-content";
        if (topMenu)
            topMenu.className = topMenu.className + " blur-content";
        if (content)
            content.className = content.className + " blur-content";
    };
    BlurUtil.unBlurMenu = function (id) {
        var leftMenu = document.getElementById("left-sidebar");
        var topMenu = document.getElementById("navbar-top");
        var content = document.getElementById(id);
        if (leftMenu)
            leftMenu.className = leftMenu.className.replace("blur-content", "");
        if (topMenu)
            topMenu.className = topMenu.className.replace("blur-content", "");
        if (content)
            content.className = content.className.replace("blur-content", "");
    };
    return BlurUtil;
}());

//# sourceMappingURL=blurUtil.js.map

/***/ }),

/***/ "vlGe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocationType; });
/**
 * Created by alex.y on 7/31/2017.
 */
var LocationType;
(function (LocationType) {
    LocationType[LocationType["Ship From"] = 1] = "Ship From";
    LocationType[LocationType["Ship To"] = 2] = "Ship To";
    LocationType[LocationType["Border Crossing"] = 3] = "Border Crossing";
    LocationType[LocationType["Billing Address"] = 4] = "Billing Address";
    LocationType[LocationType["Country Of Origin"] = 5] = "Country Of Origin";
})(LocationType || (LocationType = {}));
//# sourceMappingURL=locationType.js.map

/***/ }),

/***/ "vw9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseService__ = __webpack_require__("IhmT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__("Fzro");



var PaymentService = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](PaymentService, _super);
    function PaymentService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentService.prototype.save = function (data) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "payment/save",
            body: data
        }));
    };
    PaymentService.prototype.pay = function (orderId, amount, currencyCode, customerId, agentId, agentEmail, paymentCompany) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "payment/pay",
            body: { FileNumber: orderId, amount: amount, CurrencyCode: currencyCode, CustomerId: customerId, AgentId: agentId, AgentEmail: agentEmail, PaymentCompany: paymentCompany }
        }));
    };
    return PaymentService;
}(__WEBPACK_IMPORTED_MODULE_1__baseService__["a" /* BaseApi */]));

//# sourceMappingURL=paymentService.js.map

/***/ }),

/***/ "vx8o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var emitter = __webpack_require__("lyLw");
var crossvent = __webpack_require__("qjx7");
var classes = __webpack_require__("ob4r");
var doc = document;
var documentElement = doc.documentElement;

function dragula (initialContainers, options) {
  var len = arguments.length;
  if (len === 1 && Array.isArray(initialContainers) === false) {
    options = initialContainers;
    initialContainers = [];
  }
  var _mirror; // mirror image
  var _source; // source container
  var _item; // item being dragged
  var _offsetX; // reference x
  var _offsetY; // reference y
  var _moveX; // reference move x
  var _moveY; // reference move y
  var _initialSibling; // reference sibling when grabbed
  var _currentSibling; // reference sibling now
  var _copy; // item used for copying
  var _renderTimer; // timer for setTimeout renderMirrorImage
  var _lastDropTarget = null; // last container item was over
  var _grabbed; // holds mousedown context until first mousemove

  var o = options || {};
  if (o.moves === void 0) { o.moves = always; }
  if (o.accepts === void 0) { o.accepts = always; }
  if (o.invalid === void 0) { o.invalid = invalidTarget; }
  if (o.containers === void 0) { o.containers = initialContainers || []; }
  if (o.isContainer === void 0) { o.isContainer = never; }
  if (o.copy === void 0) { o.copy = false; }
  if (o.copySortSource === void 0) { o.copySortSource = false; }
  if (o.revertOnSpill === void 0) { o.revertOnSpill = false; }
  if (o.removeOnSpill === void 0) { o.removeOnSpill = false; }
  if (o.direction === void 0) { o.direction = 'vertical'; }
  if (o.ignoreInputTextSelection === void 0) { o.ignoreInputTextSelection = true; }
  if (o.mirrorContainer === void 0) { o.mirrorContainer = doc.body; }

  var drake = emitter({
    containers: o.containers,
    start: manualStart,
    end: end,
    cancel: cancel,
    remove: remove,
    destroy: destroy,
    canMove: canMove,
    dragging: false
  });

  if (o.removeOnSpill === true) {
    drake.on('over', spillOver).on('out', spillOut);
  }

  events();

  return drake;

  function isContainer (el) {
    return drake.containers.indexOf(el) !== -1 || o.isContainer(el);
  }

  function events (remove) {
    var op = remove ? 'remove' : 'add';
    touchy(documentElement, op, 'mousedown', grab);
    touchy(documentElement, op, 'mouseup', release);
  }

  function eventualMovements (remove) {
    var op = remove ? 'remove' : 'add';
    touchy(documentElement, op, 'mousemove', startBecauseMouseMoved);
  }

  function movements (remove) {
    var op = remove ? 'remove' : 'add';
    crossvent[op](documentElement, 'selectstart', preventGrabbed); // IE8
    crossvent[op](documentElement, 'click', preventGrabbed);
  }

  function destroy () {
    events(true);
    release({});
  }

  function preventGrabbed (e) {
    if (_grabbed) {
      e.preventDefault();
    }
  }

  function grab (e) {
    _moveX = e.clientX;
    _moveY = e.clientY;

    var ignore = whichMouseButton(e) !== 1 || e.metaKey || e.ctrlKey;
    if (ignore) {
      return; // we only care about honest-to-god left clicks and touch events
    }
    var item = e.target;
    var context = canStart(item);
    if (!context) {
      return;
    }
    _grabbed = context;
    eventualMovements();
    if (e.type === 'mousedown') {
      if (isInput(item)) { // see also: https://github.com/bevacqua/dragula/issues/208
        item.focus(); // fixes https://github.com/bevacqua/dragula/issues/176
      } else {
        e.preventDefault(); // fixes https://github.com/bevacqua/dragula/issues/155
      }
    }
  }

  function startBecauseMouseMoved (e) {
    if (!_grabbed) {
      return;
    }
    if (whichMouseButton(e) === 0) {
      release({});
      return; // when text is selected on an input and then dragged, mouseup doesn't fire. this is our only hope
    }
    // truthy check fixes #239, equality fixes #207
    if (e.clientX !== void 0 && e.clientX === _moveX && e.clientY !== void 0 && e.clientY === _moveY) {
      return;
    }
    if (o.ignoreInputTextSelection) {
      var clientX = getCoord('clientX', e);
      var clientY = getCoord('clientY', e);
      var elementBehindCursor = doc.elementFromPoint(clientX, clientY);
      if (isInput(elementBehindCursor)) {
        return;
      }
    }

    var grabbed = _grabbed; // call to end() unsets _grabbed
    eventualMovements(true);
    movements();
    end();
    start(grabbed);

    var offset = getOffset(_item);
    _offsetX = getCoord('pageX', e) - offset.left;
    _offsetY = getCoord('pageY', e) - offset.top;

    classes.add(_copy || _item, 'gu-transit');
    renderMirrorImage();
    drag(e);
  }

  function canStart (item) {
    if (drake.dragging && _mirror) {
      return;
    }
    if (isContainer(item)) {
      return; // don't drag container itself
    }
    var handle = item;
    while (getParent(item) && isContainer(getParent(item)) === false) {
      if (o.invalid(item, handle)) {
        return;
      }
      item = getParent(item); // drag target should be a top element
      if (!item) {
        return;
      }
    }
    var source = getParent(item);
    if (!source) {
      return;
    }
    if (o.invalid(item, handle)) {
      return;
    }

    var movable = o.moves(item, source, handle, nextEl(item));
    if (!movable) {
      return;
    }

    return {
      item: item,
      source: source
    };
  }

  function canMove (item) {
    return !!canStart(item);
  }

  function manualStart (item) {
    var context = canStart(item);
    if (context) {
      start(context);
    }
  }

  function start (context) {
    if (isCopy(context.item, context.source)) {
      _copy = context.item.cloneNode(true);
      drake.emit('cloned', _copy, context.item, 'copy');
    }

    _source = context.source;
    _item = context.item;
    _initialSibling = _currentSibling = nextEl(context.item);

    drake.dragging = true;
    drake.emit('drag', _item, _source);
  }

  function invalidTarget () {
    return false;
  }

  function end () {
    if (!drake.dragging) {
      return;
    }
    var item = _copy || _item;
    drop(item, getParent(item));
  }

  function ungrab () {
    _grabbed = false;
    eventualMovements(true);
    movements(true);
  }

  function release (e) {
    ungrab();

    if (!drake.dragging) {
      return;
    }
    var item = _copy || _item;
    var clientX = getCoord('clientX', e);
    var clientY = getCoord('clientY', e);
    var elementBehindCursor = getElementBehindPoint(_mirror, clientX, clientY);
    var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
    if (dropTarget && ((_copy && o.copySortSource) || (!_copy || dropTarget !== _source))) {
      drop(item, dropTarget);
    } else if (o.removeOnSpill) {
      remove();
    } else {
      cancel();
    }
  }

  function drop (item, target) {
    var parent = getParent(item);
    if (_copy && o.copySortSource && target === _source) {
      parent.removeChild(_item);
    }
    if (isInitialPlacement(target)) {
      drake.emit('cancel', item, _source, _source);
    } else {
      drake.emit('drop', item, target, _source, _currentSibling);
    }
    cleanup();
  }

  function remove () {
    if (!drake.dragging) {
      return;
    }
    var item = _copy || _item;
    var parent = getParent(item);
    if (parent) {
      parent.removeChild(item);
    }
    drake.emit(_copy ? 'cancel' : 'remove', item, parent, _source);
    cleanup();
  }

  function cancel (revert) {
    if (!drake.dragging) {
      return;
    }
    var reverts = arguments.length > 0 ? revert : o.revertOnSpill;
    var item = _copy || _item;
    var parent = getParent(item);
    var initial = isInitialPlacement(parent);
    if (initial === false && reverts) {
      if (_copy) {
        if (parent) {
          parent.removeChild(_copy);
        }
      } else {
        _source.insertBefore(item, _initialSibling);
      }
    }
    if (initial || reverts) {
      drake.emit('cancel', item, _source, _source);
    } else {
      drake.emit('drop', item, parent, _source, _currentSibling);
    }
    cleanup();
  }

  function cleanup () {
    var item = _copy || _item;
    ungrab();
    removeMirrorImage();
    if (item) {
      classes.rm(item, 'gu-transit');
    }
    if (_renderTimer) {
      clearTimeout(_renderTimer);
    }
    drake.dragging = false;
    if (_lastDropTarget) {
      drake.emit('out', item, _lastDropTarget, _source);
    }
    drake.emit('dragend', item);
    _source = _item = _copy = _initialSibling = _currentSibling = _renderTimer = _lastDropTarget = null;
  }

  function isInitialPlacement (target, s) {
    var sibling;
    if (s !== void 0) {
      sibling = s;
    } else if (_mirror) {
      sibling = _currentSibling;
    } else {
      sibling = nextEl(_copy || _item);
    }
    return target === _source && sibling === _initialSibling;
  }

  function findDropTarget (elementBehindCursor, clientX, clientY) {
    var target = elementBehindCursor;
    while (target && !accepted()) {
      target = getParent(target);
    }
    return target;

    function accepted () {
      var droppable = isContainer(target);
      if (droppable === false) {
        return false;
      }

      var immediate = getImmediateChild(target, elementBehindCursor);
      var reference = getReference(target, immediate, clientX, clientY);
      var initial = isInitialPlacement(target, reference);
      if (initial) {
        return true; // should always be able to drop it right back where it was
      }
      return o.accepts(_item, target, _source, reference);
    }
  }

  function drag (e) {
    if (!_mirror) {
      return;
    }
    e.preventDefault();

    var clientX = getCoord('clientX', e);
    var clientY = getCoord('clientY', e);
    var x = clientX - _offsetX;
    var y = clientY - _offsetY;

    _mirror.style.left = x + 'px';
    _mirror.style.top = y + 'px';

    var item = _copy || _item;
    var elementBehindCursor = getElementBehindPoint(_mirror, clientX, clientY);
    var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
    var changed = dropTarget !== null && dropTarget !== _lastDropTarget;
    if (changed || dropTarget === null) {
      out();
      _lastDropTarget = dropTarget;
      over();
    }
    var parent = getParent(item);
    if (dropTarget === _source && _copy && !o.copySortSource) {
      if (parent) {
        parent.removeChild(item);
      }
      return;
    }
    var reference;
    var immediate = getImmediateChild(dropTarget, elementBehindCursor);
    if (immediate !== null) {
      reference = getReference(dropTarget, immediate, clientX, clientY);
    } else if (o.revertOnSpill === true && !_copy) {
      reference = _initialSibling;
      dropTarget = _source;
    } else {
      if (_copy && parent) {
        parent.removeChild(item);
      }
      return;
    }
    if (
      (reference === null && changed) ||
      reference !== item &&
      reference !== nextEl(item)
    ) {
      _currentSibling = reference;
      dropTarget.insertBefore(item, reference);
      drake.emit('shadow', item, dropTarget, _source);
    }
    function moved (type) { drake.emit(type, item, _lastDropTarget, _source); }
    function over () { if (changed) { moved('over'); } }
    function out () { if (_lastDropTarget) { moved('out'); } }
  }

  function spillOver (el) {
    classes.rm(el, 'gu-hide');
  }

  function spillOut (el) {
    if (drake.dragging) { classes.add(el, 'gu-hide'); }
  }

  function renderMirrorImage () {
    if (_mirror) {
      return;
    }
    var rect = _item.getBoundingClientRect();
    _mirror = _item.cloneNode(true);
    _mirror.style.width = getRectWidth(rect) + 'px';
    _mirror.style.height = getRectHeight(rect) + 'px';
    classes.rm(_mirror, 'gu-transit');
    classes.add(_mirror, 'gu-mirror');
    o.mirrorContainer.appendChild(_mirror);
    touchy(documentElement, 'add', 'mousemove', drag);
    classes.add(o.mirrorContainer, 'gu-unselectable');
    drake.emit('cloned', _mirror, _item, 'mirror');
  }

  function removeMirrorImage () {
    if (_mirror) {
      classes.rm(o.mirrorContainer, 'gu-unselectable');
      touchy(documentElement, 'remove', 'mousemove', drag);
      getParent(_mirror).removeChild(_mirror);
      _mirror = null;
    }
  }

  function getImmediateChild (dropTarget, target) {
    var immediate = target;
    while (immediate !== dropTarget && getParent(immediate) !== dropTarget) {
      immediate = getParent(immediate);
    }
    if (immediate === documentElement) {
      return null;
    }
    return immediate;
  }

  function getReference (dropTarget, target, x, y) {
    var horizontal = o.direction === 'horizontal';
    var reference = target !== dropTarget ? inside() : outside();
    return reference;

    function outside () { // slower, but able to figure out any position
      var len = dropTarget.children.length;
      var i;
      var el;
      var rect;
      for (i = 0; i < len; i++) {
        el = dropTarget.children[i];
        rect = el.getBoundingClientRect();
        if (horizontal && (rect.left + rect.width / 2) > x) { return el; }
        if (!horizontal && (rect.top + rect.height / 2) > y) { return el; }
      }
      return null;
    }

    function inside () { // faster, but only available if dropped inside a child element
      var rect = target.getBoundingClientRect();
      if (horizontal) {
        return resolve(x > rect.left + getRectWidth(rect) / 2);
      }
      return resolve(y > rect.top + getRectHeight(rect) / 2);
    }

    function resolve (after) {
      return after ? nextEl(target) : target;
    }
  }

  function isCopy (item, container) {
    return typeof o.copy === 'boolean' ? o.copy : o.copy(item, container);
  }
}

function touchy (el, op, type, fn) {
  var touch = {
    mouseup: 'touchend',
    mousedown: 'touchstart',
    mousemove: 'touchmove'
  };
  var pointers = {
    mouseup: 'pointerup',
    mousedown: 'pointerdown',
    mousemove: 'pointermove'
  };
  var microsoft = {
    mouseup: 'MSPointerUp',
    mousedown: 'MSPointerDown',
    mousemove: 'MSPointerMove'
  };
  if (global.navigator.pointerEnabled) {
    crossvent[op](el, pointers[type], fn);
  } else if (global.navigator.msPointerEnabled) {
    crossvent[op](el, microsoft[type], fn);
  } else {
    crossvent[op](el, touch[type], fn);
    crossvent[op](el, type, fn);
  }
}

function whichMouseButton (e) {
  if (e.touches !== void 0) { return e.touches.length; }
  if (e.which !== void 0 && e.which !== 0) { return e.which; } // see https://github.com/bevacqua/dragula/issues/261
  if (e.buttons !== void 0) { return e.buttons; }
  var button = e.button;
  if (button !== void 0) { // see https://github.com/jquery/jquery/blob/99e8ff1baa7ae341e94bb89c3e84570c7c3ad9ea/src/event.js#L573-L575
    return button & 1 ? 1 : button & 2 ? 3 : (button & 4 ? 2 : 0);
  }
}

function getOffset (el) {
  var rect = el.getBoundingClientRect();
  return {
    left: rect.left + getScroll('scrollLeft', 'pageXOffset'),
    top: rect.top + getScroll('scrollTop', 'pageYOffset')
  };
}

function getScroll (scrollProp, offsetProp) {
  if (typeof global[offsetProp] !== 'undefined') {
    return global[offsetProp];
  }
  if (documentElement.clientHeight) {
    return documentElement[scrollProp];
  }
  return doc.body[scrollProp];
}

function getElementBehindPoint (point, x, y) {
  var p = point || {};
  var state = p.className;
  var el;
  p.className += ' gu-hide';
  el = doc.elementFromPoint(x, y);
  p.className = state;
  return el;
}

function never () { return false; }
function always () { return true; }
function getRectWidth (rect) { return rect.width || (rect.right - rect.left); }
function getRectHeight (rect) { return rect.height || (rect.bottom - rect.top); }
function getParent (el) { return el.parentNode === doc ? null : el.parentNode; }
function isInput (el) { return el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || isEditable(el); }
function isEditable (el) {
  if (!el) { return false; } // no parents were editable
  if (el.contentEditable === 'false') { return false; } // stop the lookup
  if (el.contentEditable === 'true') { return true; } // found a contentEditable element in the chain
  return isEditable(getParent(el)); // contentEditable is set to 'inherit'
}

function nextEl (el) {
  return el.nextElementSibling || manually();
  function manually () {
    var sibling = el;
    do {
      sibling = sibling.nextSibling;
    } while (sibling && sibling.nodeType !== 1);
    return sibling;
  }
}

function getEventHost (e) {
  // on touchend event, we have to use `e.changedTouches`
  // see http://stackoverflow.com/questions/7192563/touchend-event-properties
  // see https://github.com/bevacqua/dragula/issues/34
  if (e.targetTouches && e.targetTouches.length) {
    return e.targetTouches[0];
  }
  if (e.changedTouches && e.changedTouches.length) {
    return e.changedTouches[0];
  }
  return e;
}

function getCoord (coord, e) {
  var host = getEventHost(e);
  var missMap = {
    pageX: 'clientX', // IE8
    pageY: 'clientY' // IE8
  };
  if (coord in missMap && !(coord in host) && missMap[coord] in host) {
    coord = missMap[coord];
  }
  return host[coord];
}

module.exports = dragula;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "wfUm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomerCardComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_configService__ = __webpack_require__("cfSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ng2_cookies_ng2_cookies__ = __webpack_require__("46qw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ng2_cookies_ng2_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ng2_cookies_ng2_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_customers_customer__ = __webpack_require__("svBX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objects_orders_orderStatus__ = __webpack_require__("natU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_helpers_calculatorHelper__ = __webpack_require__("osrx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__objects_extraData_extraData__ = __webpack_require__("KGeA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_extraDataService__ = __webpack_require__("PGpm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_utils_select2Util__ = __webpack_require__("jFcQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__objects_extraData_extraDataSearchRequest__ = __webpack_require__("BRKd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__objects_orders_orderItem__ = __webpack_require__("PL+a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__objects_orders_orderOptions__ = __webpack_require__("Wcmd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_helpers_guidHelper__ = __webpack_require__("SCcC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__angular_router__ = __webpack_require__("5oXY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_calculator_calculatorService__ = __webpack_require__("5Lgg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__extraData_baseExtraData__ = __webpack_require__("ntOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_customerService__ = __webpack_require__("Tq/D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__objects_orders_taxType__ = __webpack_require__("TDHu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_ngx_odata_v4__ = __webpack_require__("MDYC");




















var CustomerCardComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CustomerCardComponent, _super);
    function CustomerCardComponent(configService, extraDataService, router, calculatorService, customerService) {
        var _this = _super.call(this, extraDataService) || this;
        _this.configService = configService;
        _this.extraDataService = extraDataService;
        _this.router = router;
        _this.calculatorService = calculatorService;
        _this.customerService = customerService;
        _this.isPublic = false;
        _this.isOrderDetails = false;
        _this.extraDataChange = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        _this.select2Util = __WEBPACK_IMPORTED_MODULE_9__common_utils_select2Util__["a" /* Select2Util */];
        _this.calculatorHelper = __WEBPACK_IMPORTED_MODULE_6__common_helpers_calculatorHelper__["a" /* CalculatorHelper */];
        _this.showForm = true;
        _this.select2EmailData = null;
        _this.hasExtraData = false;
        _this.emailSelected = false;
        return _this;
    }
    Object.defineProperty(CustomerCardComponent.prototype, "continuousBondFile", {
        get: function () {
            return this.order.Flag != null && this.order.Flag.hasFlag(__WEBPACK_IMPORTED_MODULE_12__objects_orders_orderOptions__["a" /* OrderOptions */].ContinuousBondOnFile);
        },
        set: function (val) {
            if (val) {
                this.order.Flag |= __WEBPACK_IMPORTED_MODULE_12__objects_orders_orderOptions__["a" /* OrderOptions */].ContinuousBondOnFile;
            }
            else {
                this.order.Flag &= ~__WEBPACK_IMPORTED_MODULE_12__objects_orders_orderOptions__["a" /* OrderOptions */].ContinuousBondOnFile;
            }
        },
        enumerable: true,
        configurable: true
    });
    CustomerCardComponent.prototype.ngAfterViewInit = function () {
        this.initSelect2();
        this.handleFormChange();
        if (!String.isNullOrEmpty(this.extraData.Data))
            this.hasExtraData = true;
    };
    CustomerCardComponent.prototype.ngOnDestroy = function () {
        this.formSubscribtion.unsubscribe();
    };
    CustomerCardComponent.prototype.initSelect2 = function () {
        if (this.isPublic)
            return;
        var self = this;
        var $emailSelect = $('#emailSelect');
        $emailSelect.select2({
            width: '100%',
            data: "",
            allowClear: true,
            placeholder: '',
            selectOnClose: false,
            ajax: {
                url: this.configService.config.ApiUrl + "/customer/search",
                datatype: 'json',
                delay: 500,
                headers: {
                    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3_ng2_cookies_ng2_cookies__["Cookie"].get(this.configService.config.ApiTokenCookieName),
                },
                data: function (params) {
                    return {
                        query: params.term,
                        fillOrders: true,
                        orderBy: '_score',
                        orderByDir: __WEBPACK_IMPORTED_MODULE_19_ngx_odata_v4__["a" /* OrderBy */].Desc.toString(),
                        skip: 0,
                        top: 10
                    };
                },
                processResults: function (response, params) {
                    if (!response || !response.Data)
                        return [];
                    var results = response.Data.Items.map(function (customer) {
                        return {
                            id: customer.Id,
                            text: customer.Email,
                            Item: customer
                        };
                    });
                    if (results.length == 0)
                        results.push({ id: params.term, text: params.term });
                    self.emailSelected = false;
                    return {
                        results: results
                    };
                }
            },
            minimumInputLength: 2
        }).on('select2:select', function (e) {
            var selectedData = $(this).select2('data');
            if (!selectedData || !selectedData[0])
                return;
            self.emailSelected = true;
            if (selectedData[0].Item == null) {
                self.order.Customer.Email = selectedData[0].text.trim();
                return;
            }
            self.getExtraData(selectedData[0].id, __WEBPACK_IMPORTED_MODULE_10__objects_extraData_extraDataSearchRequest__["c" /* ReferenceType */].Order).then(function (x) {
                if (!x)
                    self.extraData = new __WEBPACK_IMPORTED_MODULE_7__objects_extraData_extraData__["a" /* ExtraData */]();
                else
                    self.extraData = x;
                if (!String.isNullOrEmpty(self.extraData.Data))
                    self.hasExtraData = true;
                self.extraDataChange.emit(self.extraData);
            });
            self.order.Customer.Email = selectedData[0].text.trim();
            self.prefillCustomerInfo(JSON.parse(JSON.stringify(selectedData[0].Item)), self.order.Customer);
            self.select2EmailData.trigger("select", { data: { item: selectedData[0].Item, text: selectedData[0].text, id: __WEBPACK_IMPORTED_MODULE_13__common_helpers_guidHelper__["a" /* Guid */].newGuid() } });
        }).on('select2:unselect', function (e) {
            self.order.Customer.Email = "";
            self.extraData = new __WEBPACK_IMPORTED_MODULE_7__objects_extraData_extraData__["a" /* ExtraData */]();
            self.hasExtraData = false;
            setTimeout(function () {
                self.emailSelected = false;
            });
        }).on('select2:open', function (params) {
            var select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        }).on('select2:close', function (params) {
            var _this = this;
            setTimeout(function () {
                if (self.emailSelected)
                    return;
                var select = $(_this).data("select2");
                var query = select.results.lastParams.term;
                if (!String.isNullOrEmpty(query)) {
                    self.emailSelected = true;
                    self.select2EmailData.trigger("select", { data: { item: null, text: query, id: __WEBPACK_IMPORTED_MODULE_13__common_helpers_guidHelper__["a" /* Guid */].newGuid() } });
                }
            });
        });
        this.select2EmailData = $emailSelect.data("select2");
        if (this.order.Customer && this.order.Customer.Email)
            this.select2EmailData.trigger("select", { data: { item: this.order.Customer, text: this.order.Customer.Email, id: __WEBPACK_IMPORTED_MODULE_13__common_helpers_guidHelper__["a" /* Guid */].newGuid() } });
        if (this.disableChanges)
            $emailSelect.prop("disabled", true);
    };
    CustomerCardComponent.prototype.prefillCustomerInfo = function (customerFrom, customer) {
        var _this = this;
        customer.Id = customerFrom.Id;
        customer.FirstName = customerFrom.FirstName;
        customer.LastName = customerFrom.LastName;
        customer.Company.Name = customerFrom.Company.Name;
        customer.Phone = customerFrom.Phone;
        customer.IsSeller = customerFrom.IsSeller;
        if (!customer.Location || !customer.Location.Country) {
            customer.Location = customerFrom.Location;
            customer.Location.Id = null; // need to null this, because when order is exists and we change customer(with existing location) this will override prev order location
            this.locationCard.setLocationFrom(customerFrom.Location);
        }
        //change extraData only if it's empty
        if (!this.extraData) {
            this.getExtraData(this.order.Customer.Id.toString(), __WEBPACK_IMPORTED_MODULE_10__objects_extraData_extraDataSearchRequest__["c" /* ReferenceType */].Order).then(function (x) {
                _this.extraData = x;
                if (!String.isNullOrEmpty(_this.extraData.Data))
                    _this.hasExtraData = true;
            });
        }
        this.fillOrder(customerFrom, this.order);
    };
    CustomerCardComponent.prototype.fillOrder = function (customerFrom, order) {
        var _this = this;
        if (customerFrom.Orders == null || customerFrom.Orders.length == 0)
            return;
        var latestCustomerOrder = customerFrom.Orders.sort(function (a, b) {
            return a.Created - b.Created;
        })[0];
        if (latestCustomerOrder == null)
            return;
        order.Status = __WEBPACK_IMPORTED_MODULE_5__objects_orders_orderStatus__["a" /* OrderStatus */].Calculated;
        order.IsCommercial = latestCustomerOrder.IsCommercial;
        var loc = order.Locations.find(function (x) { return x.Type == 2; });
        var broadcastLocation = false;
        if (!loc || !loc.Country) {
            var shipmentTo = latestCustomerOrder.Locations.find(function (x) { return x.Type == 2; });
            if (shipmentTo != null) {
                order.Locations = new Array();
                order.Locations.push(shipmentTo);
                order.CalculatorType = __WEBPACK_IMPORTED_MODULE_6__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].getCalculatorType([shipmentTo]);
            }
            this.locationCard.setLocationTo(shipmentTo);
        }
        else {
            broadcastLocation = true;
        }
        if (!this.isOrderEmpty(order))
            return;
        order.Flag = latestCustomerOrder.Flag;
        //TODO
        //this.productsCard.isQuickQuote = latestCustomerOrder.Flag.hasFlag(OrderOptions.IsQuickQuote);
        order.OrderItems = [];
        order.CarryingType = latestCustomerOrder.CarryingType;
        this.productsCard.isOneTime = latestCustomerOrder.Flag.hasFlag(__WEBPACK_IMPORTED_MODULE_12__objects_orders_orderOptions__["a" /* OrderOptions */].IsOneTime);
        if (order.Flag.hasFlag(__WEBPACK_IMPORTED_MODULE_12__objects_orders_orderOptions__["a" /* OrderOptions */].IsPulic))
            this.order.Flag &= ~__WEBPACK_IMPORTED_MODULE_12__objects_orders_orderOptions__["a" /* OrderOptions */].IsPulic;
        if (order.Flag.hasFlag(__WEBPACK_IMPORTED_MODULE_12__objects_orders_orderOptions__["a" /* OrderOptions */].IsBBFeeEdited))
            this.order.Flag &= ~__WEBPACK_IMPORTED_MODULE_12__objects_orders_orderOptions__["a" /* OrderOptions */].IsBBFeeEdited;
        for (var _i = 0, _a = latestCustomerOrder.OrderItems; _i < _a.length; _i++) {
            var orderItem = _a[_i];
            orderItem.Id = null;
            orderItem.OrderId = null;
            var aaTax = orderItem.Taxes.find(function (x) { return x.TaxType == __WEBPACK_IMPORTED_MODULE_18__objects_orders_taxType__["a" /* TaxType */].AAFee; });
            if (aaTax != null)
                orderItem.Taxes.splice(orderItem.Taxes.indexOf(aaTax), 1);
            for (var _b = 0, _c = orderItem.Taxes; _b < _c.length; _b++) {
                var tax = _c[_b];
                tax.Id = null;
                tax.ItemId = null;
            }
            order.OrderItems.push(orderItem);
        }
        if (order.OrderItems.length == 0)
            order.OrderItems.push(new __WEBPACK_IMPORTED_MODULE_11__objects_orders_orderItem__["b" /* OrderItem */]());
        this.locationCard.showCarryingTypes(order);
        if (broadcastLocation)
            setTimeout(function () {
                _this.calculatorService.broadcast(loc);
            }, 300);
    };
    CustomerCardComponent.prototype.isOrderEmpty = function (order) {
        if (this.order.OrderItems.length > 1)
            return false;
        for (var _i = 0, _a = order.OrderItems; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item.Id || item.Manufacturer.Code || (item.Product && item.Product.Name) || item.Product.HsCode || item.Price || item.Type > 0 ||
                (__WEBPACK_IMPORTED_MODULE_6__common_helpers_calculatorHelper__["a" /* CalculatorHelper */].isVehicle(this.order) && item.Year))
                return false;
        }
        return true;
    };
    CustomerCardComponent.prototype.checkForm = function () {
        this.customerForm.onSubmit(null);
        return this.customerForm.valid;
    };
    CustomerCardComponent.prototype.isValid = function () {
        if (!this.customerForm)
            return false;
        return this.customerForm.valid;
    };
    CustomerCardComponent.prototype.resetForm = function () {
        var _this = this;
        this.customerForm.resetForm();
        this.hasExtraData = false;
        this.order.Customer = new __WEBPACK_IMPORTED_MODULE_4__objects_customers_customer__["a" /* Customer */]();
        $('#emailSelect').val('').trigger("change");
        this.showForm = false;
        setTimeout(function () {
            _this.showForm = true;
            setTimeout(function () {
                _this.initSelect2();
                _this.handleFormChange();
            });
        });
    };
    CustomerCardComponent.prototype.handleFormChange = function () {
        var _this = this;
        this.formSubscribtion = this.customerForm.valueChanges.debounceTime(1000)
            .distinctUntilChanged()
            .subscribe(function (modelValue) {
            if (_this.customerForm.valid && _this.sendCustomer)
                _this.customerService.updateInPipeDrive(_this.order.Customer);
        });
    };
    CustomerCardComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__services_configService__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_8__services_extraDataService__["a" /* ExtraDataService */] }, { type: __WEBPACK_IMPORTED_MODULE_14__angular_router__["n" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_15__services_calculator_calculatorService__["a" /* CalculatorService */] }, { type: __WEBPACK_IMPORTED_MODULE_17__services_customerService__["a" /* CustomerService */] }]; };
    return CustomerCardComponent;
}(__WEBPACK_IMPORTED_MODULE_16__extraData_baseExtraData__["a" /* BaseExtraData */]));

//# sourceMappingURL=customer-card.component.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "x6Zf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("z2AX"));
__export(__webpack_require__("CCID"));
__export(__webpack_require__("sXN4"));
__export(__webpack_require__("L9Tr"));
__export(__webpack_require__("Qp6t"));
__export(__webpack_require__("GfIz"));
__export(__webpack_require__("WzQ7"));
__export(__webpack_require__("Lttq"));
__export(__webpack_require__("Jc2l"));
__export(__webpack_require__("TeqA"));
__export(__webpack_require__("6hVY"));
__export(__webpack_require__("y/wv"));
__export(__webpack_require__("+3sH"));
__export(__webpack_require__("OjYj"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "xDjd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PdaType; });
/**
 * Created by alex.y on 8/11/2017.
 */
var PdaType;
(function (PdaType) {
    PdaType[PdaType["Default"] = 0] = "Default";
    PdaType[PdaType["FDA"] = 1] = "FDA";
    PdaType[PdaType["EPA"] = 2] = "EPA";
    PdaType[PdaType["DOT"] = 4] = "DOT";
})(PdaType || (PdaType = {}));
//# sourceMappingURL=PdaType.js.map

/***/ }),

/***/ "xFNE":
/***/ (function(module, exports) {

String.insertStr = function (origin, str, index) {
    if (index > origin.length || index < 0 || String.isNullOrEmpty(origin))
        return;
    return origin.slice(0, index) + str + origin.slice(index);
};
String.isNullOrEmpty = function (value) {
    if (value != null && typeof value == "number")
        return false;
    return (value == null || (value == "") || value.length == 0);
};
String.formatDateMMDDYYYY = function (value) {
    var date = new Date(value);
    return (date.getMonth() + 1) +
        "-" + date.getDate() +
        "-" + date.getFullYear();
};
String.formatDateDDMMMYYYY = function (value) {
    var date = new Date(value);
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return date.getDate() +
        "-" + months[date.getMonth()] +
        "-" + date.getFullYear();
};
String.getEnumValue = function (value, enumLink) {
    var result = enumLink[value];
    if (result && typeof result != 'undefined')
        return result.toString();
    else
        return value;
};
String.isUrl = function isURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return pattern.test(str);
};
//# sourceMappingURL=stringHelper.js.map

/***/ }),

/***/ "xTdc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
function defaultSumFunc(cells) {
    return cells
        .filter(function (cell) { return !!cell; })
        .reduce(function (res, cell) { return res + cell; });
}
var DataTableSummaryRowComponent = /** @class */ (function () {
    function DataTableSummaryRowComponent() {
        this.summaryRow = {};
    }
    DataTableSummaryRowComponent.prototype.ngOnChanges = function () {
        if (!this.columns || !this.rows) {
            return;
        }
        this.updateInternalColumns();
        this.updateValues();
    };
    DataTableSummaryRowComponent.prototype.updateInternalColumns = function () {
        this._internalColumns = this.columns.map(function (col) { return (__assign({}, col, { cellTemplate: col.summaryTemplate })); });
    };
    DataTableSummaryRowComponent.prototype.updateValues = function () {
        var _this = this;
        this.summaryRow = {};
        this.columns
            .filter(function (col) { return !col.summaryTemplate; })
            .forEach(function (col) {
            var cellsFromSingleColumn = _this.rows.map(function (row) { return row[col.prop]; });
            var sumFunc = col.summaryFunc || defaultSumFunc;
            _this.summaryRow[col.prop] = col.pipe ?
                col.pipe.transform(sumFunc(cellsFromSingleColumn)) :
                sumFunc(cellsFromSingleColumn);
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DataTableSummaryRowComponent.prototype, "rows", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DataTableSummaryRowComponent.prototype, "columns", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableSummaryRowComponent.prototype, "rowHeight", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableSummaryRowComponent.prototype, "offsetX", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DataTableSummaryRowComponent.prototype, "innerWidth", void 0);
    DataTableSummaryRowComponent = __decorate([
        core_1.Component({
            selector: 'datatable-summary-row',
            template: "\n  <datatable-body-row\n    *ngIf=\"summaryRow && _internalColumns\"\n    tabindex=\"-1\"\n    [innerWidth]=\"innerWidth\"\n    [offsetX]=\"offsetX\"\n    [columns]=\"_internalColumns\"\n    [rowHeight]=\"rowHeight\"\n    [row]=\"summaryRow\"\n    [rowIndex]=\"-1\">\n  </datatable-body-row>\n  ",
            host: {
                class: 'datatable-summary-row'
            }
        })
    ], DataTableSummaryRowComponent);
    return DataTableSummaryRowComponent;
}());
exports.DataTableSummaryRowComponent = DataTableSummaryRowComponent;
//# sourceMappingURL=summary-row.component.js.map

/***/ }),

/***/ "y/wv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This object contains the cache of the various row heights that are present inside
 * the data table.   Its based on Fenwick tree data structure that helps with
 * querying sums that have time complexity of log n.
 *
 * Fenwick Tree Credits: http://petr-mitrichev.blogspot.com/2013/05/fenwick-tree-range-updates.html
 * https://github.com/mikolalysenko/fenwick-tree
 *
 */
var RowHeightCache = /** @class */ (function () {
    function RowHeightCache() {
        /**
         * Tree Array stores the cumulative information of the row heights to perform efficient
         * range queries and updates.  Currently the tree is initialized to the base row
         * height instead of the detail row height.
         */
        this.treeArray = [];
    }
    /**
     * Clear the Tree array.
     */
    RowHeightCache.prototype.clearCache = function () {
        this.treeArray = [];
    };
    /**
     * Initialize the Fenwick tree with row Heights.
     *
     * @param rows The array of rows which contain the expanded status.
     * @param rowHeight The row height.
     * @param detailRowHeight The detail row height.
     */
    RowHeightCache.prototype.initCache = function (details) {
        var rows = details.rows, rowHeight = details.rowHeight, detailRowHeight = details.detailRowHeight, externalVirtual = details.externalVirtual, rowCount = details.rowCount, rowIndexes = details.rowIndexes, rowExpansions = details.rowExpansions;
        var isFn = typeof rowHeight === 'function';
        var isDetailFn = typeof detailRowHeight === 'function';
        if (!isFn && isNaN(rowHeight)) {
            throw new Error("Row Height cache initialization failed. Please ensure that 'rowHeight' is a\n        valid number or function value: (" + rowHeight + ") when 'scrollbarV' is enabled.");
        }
        // Add this additional guard in case detailRowHeight is set to 'auto' as it wont work.
        if (!isDetailFn && isNaN(detailRowHeight)) {
            throw new Error("Row Height cache initialization failed. Please ensure that 'detailRowHeight' is a\n        valid number or function value: (" + detailRowHeight + ") when 'scrollbarV' is enabled.");
        }
        var n = externalVirtual ? rowCount : rows.length;
        this.treeArray = new Array(n);
        for (var i = 0; i < n; ++i) {
            this.treeArray[i] = 0;
        }
        for (var i = 0; i < n; ++i) {
            var row = rows[i];
            var currentRowHeight = rowHeight;
            if (isFn) {
                currentRowHeight = rowHeight(row);
            }
            // Add the detail row height to the already expanded rows.
            // This is useful for the table that goes through a filter or sort.
            var expanded = rowExpansions.get(row);
            if (row && expanded === 1) {
                if (isDetailFn) {
                    var index = rowIndexes.get(row);
                    currentRowHeight += detailRowHeight(row, index);
                }
                else {
                    currentRowHeight += detailRowHeight;
                }
            }
            this.update(i, currentRowHeight);
        }
    };
    /**
     * Given the ScrollY position i.e. sum, provide the rowIndex
     * that is present in the current view port.  Below handles edge cases.
     */
    RowHeightCache.prototype.getRowIndex = function (scrollY) {
        if (scrollY === 0)
            return 0;
        return this.calcRowIndex(scrollY);
    };
    /**
     * When a row is expanded or rowHeight is changed, update the height.  This can
     * be utilized in future when Angular Data table supports dynamic row heights.
     */
    RowHeightCache.prototype.update = function (atRowIndex, byRowHeight) {
        if (!this.treeArray.length) {
            throw new Error("Update at index " + atRowIndex + " with value " + byRowHeight + " failed:\n        Row Height cache not initialized.");
        }
        var n = this.treeArray.length;
        atRowIndex |= 0;
        while (atRowIndex < n) {
            this.treeArray[atRowIndex] += byRowHeight;
            atRowIndex |= (atRowIndex + 1);
        }
    };
    /**
     * Range Sum query from 1 to the rowIndex
     */
    RowHeightCache.prototype.query = function (atIndex) {
        if (!this.treeArray.length) {
            throw new Error("query at index " + atIndex + " failed: Fenwick tree array not initialized.");
        }
        var sum = 0;
        atIndex |= 0;
        while (atIndex >= 0) {
            sum += this.treeArray[atIndex];
            atIndex = (atIndex & (atIndex + 1)) - 1;
        }
        return sum;
    };
    /**
     * Find the total height between 2 row indexes
     */
    RowHeightCache.prototype.queryBetween = function (atIndexA, atIndexB) {
        return this.query(atIndexB) - this.query(atIndexA - 1);
    };
    /**
     * Given the ScrollY position i.e. sum, provide the rowIndex
     * that is present in the current view port.
     */
    RowHeightCache.prototype.calcRowIndex = function (sum) {
        if (!this.treeArray.length)
            return 0;
        var pos = -1;
        var dataLength = this.treeArray.length;
        // Get the highest bit for the block size.
        var highestBit = Math.pow(2, dataLength.toString(2).length - 1);
        for (var blockSize = highestBit; blockSize !== 0; blockSize >>= 1) {
            var nextPos = pos + blockSize;
            if (nextPos < dataLength && sum >= this.treeArray[nextPos]) {
                sum -= this.treeArray[nextPos];
                pos = nextPos;
            }
        }
        return pos + 1;
    };
    return RowHeightCache;
}());
exports.RowHeightCache = RowHeightCache;
//# sourceMappingURL=row-height-cache.js.map

/***/ }),

/***/ "y7Yj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
/**
 * Visibility Observer Directive
 *
 * Usage:
 *
 * 		<div
 * 			visibilityObserver
 * 			(visible)="onVisible($event)">
 * 		</div>
 *
 */
var VisibilityDirective = /** @class */ (function () {
    function VisibilityDirective(element, zone) {
        this.element = element;
        this.zone = zone;
        this.isVisible = false;
        this.visible = new core_1.EventEmitter();
    }
    VisibilityDirective.prototype.ngOnInit = function () {
        this.runCheck();
    };
    VisibilityDirective.prototype.ngOnDestroy = function () {
        clearTimeout(this.timeout);
    };
    VisibilityDirective.prototype.onVisibilityChange = function () {
        var _this = this;
        // trigger zone recalc for columns
        this.zone.run(function () {
            _this.isVisible = true;
            _this.visible.emit(true);
        });
    };
    VisibilityDirective.prototype.runCheck = function () {
        var _this = this;
        var check = function () {
            // https://davidwalsh.name/offsetheight-visibility
            var _a = _this.element.nativeElement, offsetHeight = _a.offsetHeight, offsetWidth = _a.offsetWidth;
            if (offsetHeight && offsetWidth) {
                clearTimeout(_this.timeout);
                _this.onVisibilityChange();
            }
            else {
                clearTimeout(_this.timeout);
                _this.zone.runOutsideAngular(function () {
                    _this.timeout = setTimeout(function () { return check(); }, 50);
                });
            }
        };
        this.timeout = setTimeout(function () { return check(); });
    };
    __decorate([
        core_1.HostBinding('class.visible'),
        __metadata("design:type", Boolean)
    ], VisibilityDirective.prototype, "isVisible", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], VisibilityDirective.prototype, "visible", void 0);
    VisibilityDirective = __decorate([
        core_1.Directive({ selector: '[visibilityObserver]' }),
        __metadata("design:paramtypes", [core_1.ElementRef, core_1.NgZone])
    ], VisibilityDirective);
    return VisibilityDirective;
}());
exports.VisibilityDirective = VisibilityDirective;
//# sourceMappingURL=visibility.directive.js.map

/***/ }),

/***/ "yN1j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("3j3K");
var utils_1 = __webpack_require__("x6Zf");
var types_1 = __webpack_require__("j2I9");
var DataTableSelectionComponent = /** @class */ (function () {
    function DataTableSelectionComponent() {
        this.activate = new core_1.EventEmitter();
        this.select = new core_1.EventEmitter();
    }
    DataTableSelectionComponent.prototype.selectRow = function (event, index, row) {
        if (!this.selectEnabled)
            return;
        var chkbox = this.selectionType === types_1.SelectionType.checkbox;
        var multi = this.selectionType === types_1.SelectionType.multi;
        var multiClick = this.selectionType === types_1.SelectionType.multiClick;
        var selected = [];
        if (multi || chkbox || multiClick) {
            if (event.shiftKey) {
                selected = utils_1.selectRowsBetween([], this.rows, index, this.prevIndex, this.getRowSelectedIdx.bind(this));
            }
            else if (event.ctrlKey || event.metaKey || multiClick || chkbox) {
                selected = utils_1.selectRows(this.selected.slice(), row, this.getRowSelectedIdx.bind(this));
            }
            else {
                selected = utils_1.selectRows([], row, this.getRowSelectedIdx.bind(this));
            }
        }
        else {
            selected = utils_1.selectRows([], row, this.getRowSelectedIdx.bind(this));
        }
        if (typeof this.selectCheck === 'function') {
            selected = selected.filter(this.selectCheck.bind(this));
        }
        this.selected.splice(0, this.selected.length);
        (_a = this.selected).push.apply(_a, selected);
        this.prevIndex = index;
        this.select.emit({
            selected: selected
        });
        var _a;
    };
    DataTableSelectionComponent.prototype.onActivate = function (model, index) {
        var type = model.type, event = model.event, row = model.row;
        var chkbox = this.selectionType === types_1.SelectionType.checkbox;
        var select = (!chkbox && (type === 'click' || type === 'dblclick')) ||
            (chkbox && type === 'checkbox');
        if (select) {
            this.selectRow(event, index, row);
        }
        else if (type === 'keydown') {
            if (event.keyCode === utils_1.Keys.return) {
                this.selectRow(event, index, row);
            }
            else {
                this.onKeyboardFocus(model);
            }
        }
        this.activate.emit(model);
    };
    DataTableSelectionComponent.prototype.onKeyboardFocus = function (model) {
        var keyCode = model.event.keyCode;
        var shouldFocus = keyCode === utils_1.Keys.up ||
            keyCode === utils_1.Keys.down ||
            keyCode === utils_1.Keys.right ||
            keyCode === utils_1.Keys.left;
        if (shouldFocus) {
            var isCellSelection = this.selectionType === types_1.SelectionType.cell;
            if (!model.cellElement || !isCellSelection) {
                this.focusRow(model.rowElement, keyCode);
            }
            else if (isCellSelection) {
                this.focusCell(model.cellElement, model.rowElement, keyCode, model.cellIndex);
            }
        }
    };
    DataTableSelectionComponent.prototype.focusRow = function (rowElement, keyCode) {
        var nextRowElement = this.getPrevNextRow(rowElement, keyCode);
        if (nextRowElement)
            nextRowElement.focus();
    };
    DataTableSelectionComponent.prototype.getPrevNextRow = function (rowElement, keyCode) {
        var parentElement = rowElement.parentElement;
        if (parentElement) {
            var focusElement = void 0;
            if (keyCode === utils_1.Keys.up) {
                focusElement = parentElement.previousElementSibling;
            }
            else if (keyCode === utils_1.Keys.down) {
                focusElement = parentElement.nextElementSibling;
            }
            if (focusElement && focusElement.children.length) {
                return focusElement.children[0];
            }
        }
    };
    DataTableSelectionComponent.prototype.focusCell = function (cellElement, rowElement, keyCode, cellIndex) {
        var nextCellElement;
        if (keyCode === utils_1.Keys.left) {
            nextCellElement = cellElement.previousElementSibling;
        }
        else if (keyCode === utils_1.Keys.right) {
            nextCellElement = cellElement.nextElementSibling;
        }
        else if (keyCode === utils_1.Keys.up || keyCode === utils_1.Keys.down) {
            var nextRowElement = this.getPrevNextRow(rowElement, keyCode);
            if (nextRowElement) {
                var children = nextRowElement.getElementsByClassName('datatable-body-cell');
                if (children.length)
                    nextCellElement = children[cellIndex];
            }
        }
        if (nextCellElement)
            nextCellElement.focus();
    };
    DataTableSelectionComponent.prototype.getRowSelected = function (row) {
        return this.getRowSelectedIdx(row, this.selected) > -1;
    };
    DataTableSelectionComponent.prototype.getRowSelectedIdx = function (row, selected) {
        var _this = this;
        if (!selected || !selected.length)
            return -1;
        var rowId = this.rowIdentity(row);
        return selected.findIndex(function (r) {
            var id = _this.rowIdentity(r);
            return id === rowId;
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DataTableSelectionComponent.prototype, "rows", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DataTableSelectionComponent.prototype, "selected", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DataTableSelectionComponent.prototype, "selectEnabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DataTableSelectionComponent.prototype, "selectionType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableSelectionComponent.prototype, "rowIdentity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DataTableSelectionComponent.prototype, "selectCheck", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTableSelectionComponent.prototype, "activate", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DataTableSelectionComponent.prototype, "select", void 0);
    DataTableSelectionComponent = __decorate([
        core_1.Component({
            selector: 'datatable-selection',
            template: "\n    <ng-content></ng-content>\n  ",
            changeDetection: core_1.ChangeDetectionStrategy.OnPush
        })
    ], DataTableSelectionComponent);
    return DataTableSelectionComponent;
}());
exports.DataTableSelectionComponent = DataTableSelectionComponent;
//# sourceMappingURL=selection.component.js.map

/***/ }),

/***/ "yl66":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("bYJ/"));
__export(__webpack_require__("4gpe"));
__export(__webpack_require__("Ul3N"));
__export(__webpack_require__("9/L2"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "ys6Q":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var si = typeof setImmediate === 'function', tick;
if (si) {
  tick = function (fn) { setImmediate(fn); };
} else {
  tick = function (fn) { setTimeout(fn, 0); };
}

module.exports = tick;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("162o").setImmediate))

/***/ }),

/***/ "z/46":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseService__ = __webpack_require__("IhmT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__("Fzro");



/**
 * Created by vadim.m on 9/19/2017.
 */
var EmailService = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](EmailService, _super);
    function EmailService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmailService.prototype.sendOrderToCustomer = function (emailRequest) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "email/order/" + emailRequest.OrderId,
            body: emailRequest
        }));
    };
    EmailService.prototype.sendPaymentEmail = function (emailRequest) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "email/orderpaymentemail",
            body: emailRequest
        }));
    };
    EmailService.prototype.sendQuestionEmailToAgent = function (email, body) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "email/question?email=" + email,
            body: { Body: body }
        }));
    };
    EmailService.prototype.sendNotificationToSalesEmail = function (email) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "email/notification?email=" + email,
        }));
    };
    EmailService.prototype.sendProductsToBB = function (sellerId, storeId) {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "amazon/seller/" + sellerId + "/store/" + storeId + "/email",
        }));
    };
    EmailService.prototype.sendPayPalPaymentRequest = function (customerId) {
        return this.post(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "email/paypalpaymentrequest/" + customerId
        }));
    };
    EmailService.prototype.sendSubscribeToPARSStatus = function (ccn, email, orderId) {
        if (orderId === void 0) { orderId = null; }
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "email/subscribeToPARSStatus/" + ccn + "/" + email + "/" + orderId
        }));
    };
    EmailService.prototype.sendGetStartedEmail = function (customerEmail) {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "email/first-login/" + customerEmail,
        }));
    };
    EmailService.prototype.unsubscribeEmail = function (ccn, email) {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "email/unsubscribe/" + ccn + "/" + email,
        }));
    };
    EmailService.prototype.inviteCustomerToSelfServeApp = function (email) {
        return this.get(new __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */]({
            url: "email/invite-customer/" + email,
        }));
    };
    return EmailService;
}(__WEBPACK_IMPORTED_MODULE_1__baseService__["a" /* BaseApi */]));

//# sourceMappingURL=emailService.js.map

/***/ }),

/***/ "z2AX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Creates a unique object id.
 * http://stackoverflow.com/questions/6248666/how-to-generate-short-uid-like-ax4j9z-in-js
 */
function id() {
    return ('0000' + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4);
}
exports.id = id;
//# sourceMappingURL=id.js.map

/***/ })

},["UITZ"]);


// WEBPACK FOOTER //
// app.52ebc8cbe93e2e569de9.js